(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire2b2c"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire2b2c"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("8rEqs", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $626034102436cf64$export$6503ec6e8aabbaf; }, function (v) { return $626034102436cf64$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $626034102436cf64$export$f7ad0328861e2f03; }, function (v) { return $626034102436cf64$export$f7ad0328861e2f03 = v; });
var $626034102436cf64$export$6503ec6e8aabbaf;
var $626034102436cf64$export$f7ad0328861e2f03;
"use strict";
var $626034102436cf64$var$mapping = new Map();
function $626034102436cf64$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$626034102436cf64$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $626034102436cf64$var$resolve(id) {
    var resolved = $626034102436cf64$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$626034102436cf64$export$6503ec6e8aabbaf = $626034102436cf64$var$register;
$626034102436cf64$export$f7ad0328861e2f03 = $626034102436cf64$var$resolve;

});

parcelRegister("fF0r8", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $b66b0613bc52b346$export$bdfd709ae4826697; }, function (v) { return $b66b0613bc52b346$export$bdfd709ae4826697 = v; });
var $b66b0613bc52b346$export$bdfd709ae4826697;
var $b66b0613bc52b346$export$c9e73fbda7da57b6;
var $b66b0613bc52b346$export$5a759dc7a1cfb72a;
"use strict";
var $b66b0613bc52b346$var$bundleURL = {};
function $b66b0613bc52b346$var$getBundleURLCached(id) {
    var value = $b66b0613bc52b346$var$bundleURL[id];
    if (!value) {
        value = $b66b0613bc52b346$var$getBundleURL();
        $b66b0613bc52b346$var$bundleURL[id] = value;
    }
    return value;
}
function $b66b0613bc52b346$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $b66b0613bc52b346$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $b66b0613bc52b346$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $b66b0613bc52b346$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$b66b0613bc52b346$export$bdfd709ae4826697 = $b66b0613bc52b346$var$getBundleURLCached;
$b66b0613bc52b346$export$c9e73fbda7da57b6 = $b66b0613bc52b346$var$getBaseURL;
$b66b0613bc52b346$export$5a759dc7a1cfb72a = $b66b0613bc52b346$var$getOrigin;

});

parcelRegister("kl2BW", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $ece7cb45097e2d21$export$ffb0004e005737fa; }, function (v) { return $ece7cb45097e2d21$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $ece7cb45097e2d21$export$34b9dba7ce09269b; }, function (v) { return $ece7cb45097e2d21$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $ece7cb45097e2d21$export$25062201e9e25d76; }, function (v) { return $ece7cb45097e2d21$export$25062201e9e25d76 = v; });
/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $ece7cb45097e2d21$export$ffb0004e005737fa;
var $ece7cb45097e2d21$export$34b9dba7ce09269b;
var $ece7cb45097e2d21$export$25062201e9e25d76;
"use strict";
parcelRequire("8dmsj");

var $b6HlZ = parcelRequire("b6HlZ");
var $ece7cb45097e2d21$var$g = 60103;
$ece7cb45097e2d21$export$ffb0004e005737fa = 60107;
if ("function" === typeof Symbol && Symbol.for) {
    var $ece7cb45097e2d21$var$h = Symbol.for;
    $ece7cb45097e2d21$var$g = $ece7cb45097e2d21$var$h("react.element");
    $ece7cb45097e2d21$export$ffb0004e005737fa = $ece7cb45097e2d21$var$h("react.fragment");
}
var $ece7cb45097e2d21$var$m = $b6HlZ.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $ece7cb45097e2d21$var$n = Object.prototype.hasOwnProperty, $ece7cb45097e2d21$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $ece7cb45097e2d21$var$q(c, a, k) {
    var b, d = {}, e = null, l = null;
    void 0 !== k && (e = "" + k);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (l = a.ref);
    for(b in a)$ece7cb45097e2d21$var$n.call(a, b) && !$ece7cb45097e2d21$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $ece7cb45097e2d21$var$g,
        type: c,
        key: e,
        ref: l,
        props: d,
        _owner: $ece7cb45097e2d21$var$m.current
    };
}
$ece7cb45097e2d21$export$34b9dba7ce09269b = $ece7cb45097e2d21$var$q;
$ece7cb45097e2d21$export$25062201e9e25d76 = $ece7cb45097e2d21$var$q;

});
parcelRegister("8dmsj", function(module, exports) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ "use strict";
/* eslint-disable no-unused-vars */ var $5fb0f4dc6c7005a3$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $5fb0f4dc6c7005a3$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $5fb0f4dc6c7005a3$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $5fb0f4dc6c7005a3$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(val);
}
function $5fb0f4dc6c7005a3$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String("abc"); // eslint-disable-line no-new-wrappers
        test1[5] = "de";
        if (Object.getOwnPropertyNames(test1)[0] === "5") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2["_" + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join("") !== "0123456789") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        "abcdefghijklmnopqrst".split("").forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = $5fb0f4dc6c7005a3$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $5fb0f4dc6c7005a3$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($5fb0f4dc6c7005a3$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($5fb0f4dc6c7005a3$var$getOwnPropertySymbols) {
            symbols = $5fb0f4dc6c7005a3$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($5fb0f4dc6c7005a3$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

});

parcelRegister("b6HlZ", function(module, exports) {
"use strict";

module.exports = (parcelRequire("h6avy"));

});
parcelRegister("h6avy", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $c72b25dec65aede5$export$ffb0004e005737fa; }, function (v) { return $c72b25dec65aede5$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "StrictMode", function () { return $c72b25dec65aede5$export$5f8d39834fd61797; }, function (v) { return $c72b25dec65aede5$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Profiler", function () { return $c72b25dec65aede5$export$e2c29f18771995cb; }, function (v) { return $c72b25dec65aede5$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "Suspense", function () { return $c72b25dec65aede5$export$74bf444e3cd11ea5; }, function (v) { return $c72b25dec65aede5$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "Children", function () { return $c72b25dec65aede5$export$dca3b0875bd9a954; }, function (v) { return $c72b25dec65aede5$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $c72b25dec65aede5$export$16fa2f45be04daa8; }, function (v) { return $c72b25dec65aede5$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "PureComponent", function () { return $c72b25dec65aede5$export$221d75b3f55bb0bd; }, function (v) { return $c72b25dec65aede5$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $c72b25dec65aede5$export$ae55be85d98224ed; }, function (v) { return $c72b25dec65aede5$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "cloneElement", function () { return $c72b25dec65aede5$export$e530037191fcd5d7; }, function (v) { return $c72b25dec65aede5$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $c72b25dec65aede5$export$fd42f52fd3ae1109; }, function (v) { return $c72b25dec65aede5$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $c72b25dec65aede5$export$c8a8987d4410bf2d; }, function (v) { return $c72b25dec65aede5$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $c72b25dec65aede5$export$d38cd72104c1f0e9; }, function (v) { return $c72b25dec65aede5$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $c72b25dec65aede5$export$7d1e3a5e95ceca43; }, function (v) { return $c72b25dec65aede5$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $c72b25dec65aede5$export$257a8862b851cb5b; }, function (v) { return $c72b25dec65aede5$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $c72b25dec65aede5$export$a8257692ac88316c; }, function (v) { return $c72b25dec65aede5$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $c72b25dec65aede5$export$488013bae63b21da; }, function (v) { return $c72b25dec65aede5$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $c72b25dec65aede5$export$7c73462e0d25e514; }, function (v) { return $c72b25dec65aede5$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "useCallback", function () { return $c72b25dec65aede5$export$35808ee640e87ca7; }, function (v) { return $c72b25dec65aede5$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $c72b25dec65aede5$export$fae74005e78b1a27; }, function (v) { return $c72b25dec65aede5$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $c72b25dec65aede5$export$dc8fbce3eb94dc1e; }, function (v) { return $c72b25dec65aede5$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useEffect", function () { return $c72b25dec65aede5$export$6d9c69b0de29b591; }, function (v) { return $c72b25dec65aede5$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $c72b25dec65aede5$export$d5a552a76deda3c2; }, function (v) { return $c72b25dec65aede5$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $c72b25dec65aede5$export$e5c5a5f917a5871c; }, function (v) { return $c72b25dec65aede5$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $c72b25dec65aede5$export$1538c33de8887b59; }, function (v) { return $c72b25dec65aede5$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $c72b25dec65aede5$export$13e3392192263954; }, function (v) { return $c72b25dec65aede5$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $c72b25dec65aede5$export$b8f5890fc79d6aca; }, function (v) { return $c72b25dec65aede5$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $c72b25dec65aede5$export$60241385465d0a34; }, function (v) { return $c72b25dec65aede5$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "version", function () { return $c72b25dec65aede5$export$83d89fbfd8236492; }, function (v) { return $c72b25dec65aede5$export$83d89fbfd8236492 = v; });
/** @license React v17.0.2
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $c72b25dec65aede5$export$ffb0004e005737fa;
var $c72b25dec65aede5$export$5f8d39834fd61797;
var $c72b25dec65aede5$export$e2c29f18771995cb;
var $c72b25dec65aede5$export$74bf444e3cd11ea5;
var $c72b25dec65aede5$export$dca3b0875bd9a954;
var $c72b25dec65aede5$export$16fa2f45be04daa8;
var $c72b25dec65aede5$export$221d75b3f55bb0bd;
var $c72b25dec65aede5$export$ae55be85d98224ed;
var $c72b25dec65aede5$export$e530037191fcd5d7;
var $c72b25dec65aede5$export$fd42f52fd3ae1109;
var $c72b25dec65aede5$export$c8a8987d4410bf2d;
var $c72b25dec65aede5$export$d38cd72104c1f0e9;
var $c72b25dec65aede5$export$7d1e3a5e95ceca43;
var $c72b25dec65aede5$export$257a8862b851cb5b;
var $c72b25dec65aede5$export$a8257692ac88316c;
var $c72b25dec65aede5$export$488013bae63b21da;
var $c72b25dec65aede5$export$7c73462e0d25e514;
var $c72b25dec65aede5$export$35808ee640e87ca7;
var $c72b25dec65aede5$export$fae74005e78b1a27;
var $c72b25dec65aede5$export$dc8fbce3eb94dc1e;
var $c72b25dec65aede5$export$6d9c69b0de29b591;
var $c72b25dec65aede5$export$d5a552a76deda3c2;
var $c72b25dec65aede5$export$e5c5a5f917a5871c;
var $c72b25dec65aede5$export$1538c33de8887b59;
var $c72b25dec65aede5$export$13e3392192263954;
var $c72b25dec65aede5$export$b8f5890fc79d6aca;
var $c72b25dec65aede5$export$60241385465d0a34;
var $c72b25dec65aede5$export$83d89fbfd8236492;
"use strict";

var $8dmsj = parcelRequire("8dmsj");
var $c72b25dec65aede5$var$n = 60103, $c72b25dec65aede5$var$p = 60106;
$c72b25dec65aede5$export$ffb0004e005737fa = 60107;
$c72b25dec65aede5$export$5f8d39834fd61797 = 60108;
$c72b25dec65aede5$export$e2c29f18771995cb = 60114;
var $c72b25dec65aede5$var$q = 60109, $c72b25dec65aede5$var$r = 60110, $c72b25dec65aede5$var$t = 60112;
$c72b25dec65aede5$export$74bf444e3cd11ea5 = 60113;
var $c72b25dec65aede5$var$u = 60115, $c72b25dec65aede5$var$v = 60116;
if ("function" === typeof Symbol && Symbol.for) {
    var $c72b25dec65aede5$var$w = Symbol.for;
    $c72b25dec65aede5$var$n = $c72b25dec65aede5$var$w("react.element");
    $c72b25dec65aede5$var$p = $c72b25dec65aede5$var$w("react.portal");
    $c72b25dec65aede5$export$ffb0004e005737fa = $c72b25dec65aede5$var$w("react.fragment");
    $c72b25dec65aede5$export$5f8d39834fd61797 = $c72b25dec65aede5$var$w("react.strict_mode");
    $c72b25dec65aede5$export$e2c29f18771995cb = $c72b25dec65aede5$var$w("react.profiler");
    $c72b25dec65aede5$var$q = $c72b25dec65aede5$var$w("react.provider");
    $c72b25dec65aede5$var$r = $c72b25dec65aede5$var$w("react.context");
    $c72b25dec65aede5$var$t = $c72b25dec65aede5$var$w("react.forward_ref");
    $c72b25dec65aede5$export$74bf444e3cd11ea5 = $c72b25dec65aede5$var$w("react.suspense");
    $c72b25dec65aede5$var$u = $c72b25dec65aede5$var$w("react.memo");
    $c72b25dec65aede5$var$v = $c72b25dec65aede5$var$w("react.lazy");
}
var $c72b25dec65aede5$var$x = "function" === typeof Symbol && Symbol.iterator;
function $c72b25dec65aede5$var$y(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $c72b25dec65aede5$var$x && a[$c72b25dec65aede5$var$x] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
function $c72b25dec65aede5$var$z(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $c72b25dec65aede5$var$A = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $c72b25dec65aede5$var$B = {};
function $c72b25dec65aede5$var$C(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $c72b25dec65aede5$var$B;
    this.updater = c || $c72b25dec65aede5$var$A;
}
$c72b25dec65aede5$var$C.prototype.isReactComponent = {};
$c72b25dec65aede5$var$C.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error($c72b25dec65aede5$var$z(85));
    this.updater.enqueueSetState(this, a, b, "setState");
};
$c72b25dec65aede5$var$C.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $c72b25dec65aede5$var$D() {}
$c72b25dec65aede5$var$D.prototype = $c72b25dec65aede5$var$C.prototype;
function $c72b25dec65aede5$var$E(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $c72b25dec65aede5$var$B;
    this.updater = c || $c72b25dec65aede5$var$A;
}
var $c72b25dec65aede5$var$F = $c72b25dec65aede5$var$E.prototype = new $c72b25dec65aede5$var$D;
$c72b25dec65aede5$var$F.constructor = $c72b25dec65aede5$var$E;
$8dmsj($c72b25dec65aede5$var$F, $c72b25dec65aede5$var$C.prototype);
$c72b25dec65aede5$var$F.isPureReactComponent = !0;
var $c72b25dec65aede5$var$G = {
    current: null
}, $c72b25dec65aede5$var$H = Object.prototype.hasOwnProperty, $c72b25dec65aede5$var$I = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $c72b25dec65aede5$var$J(a, b, c) {
    var e, d = {}, k = null, h = null;
    if (null != b) for(e in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$c72b25dec65aede5$var$H.call(b, e) && !$c72b25dec65aede5$var$I.hasOwnProperty(e) && (d[e] = b[e]);
    var g = arguments.length - 2;
    if (1 === g) d.children = c;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        d.children = f;
    }
    if (a && a.defaultProps) for(e in g = a.defaultProps, g)void 0 === d[e] && (d[e] = g[e]);
    return {
        $$typeof: $c72b25dec65aede5$var$n,
        type: a,
        key: k,
        ref: h,
        props: d,
        _owner: $c72b25dec65aede5$var$G.current
    };
}
function $c72b25dec65aede5$var$K(a, b) {
    return {
        $$typeof: $c72b25dec65aede5$var$n,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $c72b25dec65aede5$var$L(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $c72b25dec65aede5$var$n;
}
function $c72b25dec65aede5$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $c72b25dec65aede5$var$M = /\/+/g;
function $c72b25dec65aede5$var$N(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $c72b25dec65aede5$var$escape("" + a.key) : b.toString(36);
}
function $c72b25dec65aede5$var$O(a, b, c, e, d) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $c72b25dec65aede5$var$n:
                case $c72b25dec65aede5$var$p:
                    h = !0;
            }
    }
    if (h) return h = a, d = d(h), a = "" === e ? "." + $c72b25dec65aede5$var$N(h, 0) : e, Array.isArray(d) ? (c = "", null != a && (c = a.replace($c72b25dec65aede5$var$M, "$&/") + "/"), $c72b25dec65aede5$var$O(d, b, c, "", function(a) {
        return a;
    })) : null != d && ($c72b25dec65aede5$var$L(d) && (d = $c72b25dec65aede5$var$K(d, c + (!d.key || h && h.key === d.key ? "" : ("" + d.key).replace($c72b25dec65aede5$var$M, "$&/") + "/") + a)), b.push(d)), 1;
    h = 0;
    e = "" === e ? "." : e + ":";
    if (Array.isArray(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = e + $c72b25dec65aede5$var$N(k, g);
        h += $c72b25dec65aede5$var$O(k, b, c, f, d);
    }
    else if (f = $c72b25dec65aede5$var$y(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = e + $c72b25dec65aede5$var$N(k, g++), h += $c72b25dec65aede5$var$O(k, b, c, f, d);
    else if ("object" === k) throw b = "" + a, Error($c72b25dec65aede5$var$z(31, "[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b));
    return h;
}
function $c72b25dec65aede5$var$P(a, b, c) {
    if (null == a) return a;
    var e = [], d = 0;
    $c72b25dec65aede5$var$O(a, e, "", "", function(a) {
        return b.call(c, a, d++);
    });
    return e;
}
function $c72b25dec65aede5$var$Q(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        a._status = 0;
        a._result = b;
        b.then(function(b) {
            0 === a._status && (b = b.default, a._status = 1, a._result = b);
        }, function(b) {
            0 === a._status && (a._status = 2, a._result = b);
        });
    }
    if (1 === a._status) return a._result;
    throw a._result;
}
var $c72b25dec65aede5$var$R = {
    current: null
};
function $c72b25dec65aede5$var$S() {
    var a = $c72b25dec65aede5$var$R.current;
    if (null === a) throw Error($c72b25dec65aede5$var$z(321));
    return a;
}
var $c72b25dec65aede5$var$T = {
    ReactCurrentDispatcher: $c72b25dec65aede5$var$R,
    ReactCurrentBatchConfig: {
        transition: 0
    },
    ReactCurrentOwner: $c72b25dec65aede5$var$G,
    IsSomeRendererActing: {
        current: !1
    },
    assign: $8dmsj
};
$c72b25dec65aede5$export$dca3b0875bd9a954 = {
    map: $c72b25dec65aede5$var$P,
    forEach: function(a, b, c) {
        $c72b25dec65aede5$var$P(a, function() {
            b.apply(this, arguments);
        }, c);
    },
    count: function(a) {
        var b = 0;
        $c72b25dec65aede5$var$P(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $c72b25dec65aede5$var$P(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$c72b25dec65aede5$var$L(a)) throw Error($c72b25dec65aede5$var$z(143));
        return a;
    }
};
$c72b25dec65aede5$export$16fa2f45be04daa8 = $c72b25dec65aede5$var$C;
$c72b25dec65aede5$export$221d75b3f55bb0bd = $c72b25dec65aede5$var$E;
$c72b25dec65aede5$export$ae55be85d98224ed = $c72b25dec65aede5$var$T;
$c72b25dec65aede5$export$e530037191fcd5d7 = function(a, b, c) {
    if (null === a || void 0 === a) throw Error($c72b25dec65aede5$var$z(267, a));
    var e = $8dmsj({}, a.props), d = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $c72b25dec65aede5$var$G.current);
        void 0 !== b.key && (d = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$c72b25dec65aede5$var$H.call(b, f) && !$c72b25dec65aede5$var$I.hasOwnProperty(f) && (e[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) e.children = c;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        e.children = g;
    }
    return {
        $$typeof: $c72b25dec65aede5$var$n,
        type: a.type,
        key: d,
        ref: k,
        props: e,
        _owner: h
    };
};
$c72b25dec65aede5$export$fd42f52fd3ae1109 = function(a, b) {
    void 0 === b && (b = null);
    a = {
        $$typeof: $c72b25dec65aede5$var$r,
        _calculateChangedBits: b,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    a.Provider = {
        $$typeof: $c72b25dec65aede5$var$q,
        _context: a
    };
    return a.Consumer = a;
};
$c72b25dec65aede5$export$c8a8987d4410bf2d = $c72b25dec65aede5$var$J;
$c72b25dec65aede5$export$d38cd72104c1f0e9 = function(a) {
    var b = $c72b25dec65aede5$var$J.bind(null, a);
    b.type = a;
    return b;
};
$c72b25dec65aede5$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$c72b25dec65aede5$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $c72b25dec65aede5$var$t,
        render: a
    };
};
$c72b25dec65aede5$export$a8257692ac88316c = $c72b25dec65aede5$var$L;
$c72b25dec65aede5$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $c72b25dec65aede5$var$v,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $c72b25dec65aede5$var$Q
    };
};
$c72b25dec65aede5$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $c72b25dec65aede5$var$u,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$c72b25dec65aede5$export$35808ee640e87ca7 = function(a, b) {
    return $c72b25dec65aede5$var$S().useCallback(a, b);
};
$c72b25dec65aede5$export$fae74005e78b1a27 = function(a, b) {
    return $c72b25dec65aede5$var$S().useContext(a, b);
};
$c72b25dec65aede5$export$dc8fbce3eb94dc1e = function() {};
$c72b25dec65aede5$export$6d9c69b0de29b591 = function(a, b) {
    return $c72b25dec65aede5$var$S().useEffect(a, b);
};
$c72b25dec65aede5$export$d5a552a76deda3c2 = function(a, b, c) {
    return $c72b25dec65aede5$var$S().useImperativeHandle(a, b, c);
};
$c72b25dec65aede5$export$e5c5a5f917a5871c = function(a, b) {
    return $c72b25dec65aede5$var$S().useLayoutEffect(a, b);
};
$c72b25dec65aede5$export$1538c33de8887b59 = function(a, b) {
    return $c72b25dec65aede5$var$S().useMemo(a, b);
};
$c72b25dec65aede5$export$13e3392192263954 = function(a, b, c) {
    return $c72b25dec65aede5$var$S().useReducer(a, b, c);
};
$c72b25dec65aede5$export$b8f5890fc79d6aca = function(a) {
    return $c72b25dec65aede5$var$S().useRef(a);
};
$c72b25dec65aede5$export$60241385465d0a34 = function(a) {
    return $c72b25dec65aede5$var$S().useState(a);
};
$c72b25dec65aede5$export$83d89fbfd8236492 = "17.0.2";

});



parcelRegister("3uMgk", function(module, exports) {
"use strict";
function $28b99c5597be05c2$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($28b99c5597be05c2$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$28b99c5597be05c2$var$checkDCE();

module.exports = (parcelRequire("dkYvP"));

});
parcelRegister("dkYvP", function(module, exports) {
/** @license React v17.0.2
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ "use strict";

var $b6HlZ = parcelRequire("b6HlZ");

var $8dmsj = parcelRequire("8dmsj");

var $5IcjB = parcelRequire("5IcjB");
function y(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
if (!$b6HlZ) throw Error(y(227));
var ba = new Set, ca = {};
function da(a, b) {
    ea(a, b);
    ea(a + "Capture", b);
}
function ea(a, b) {
    ca[a] = b;
    for(a = 0; a < b.length; a++)ba.add(b[a]);
}
var fa = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), ha = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, ia = Object.prototype.hasOwnProperty, ja = {}, ka = {};
function la(a) {
    if (ia.call(ka, a)) return !0;
    if (ia.call(ja, a)) return !1;
    if (ha.test(a)) return ka[a] = !0;
    ja[a] = !0;
    return !1;
}
function ma(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function na(a, b, c, d) {
    if (null === b || "undefined" === typeof b || ma(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function B(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var D = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    D[a] = new B(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    D[b] = new B(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    D[a] = new B(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    D[a] = new B(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    D[a] = new B(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    D[a] = new B(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    D[a] = new B(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    D[a] = new B(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    D[a] = new B(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var oa = /[\-:]([a-z])/g;
function pa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace(oa, pa);
    D[b] = new B(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace(oa, pa);
    D[b] = new B(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace(oa, pa);
    D[b] = new B(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    D[a] = new B(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
D.xlinkHref = new B("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    D[a] = new B(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function qa(a, b, c, d) {
    var e = D.hasOwnProperty(b) ? D[b] : null;
    var f = null !== e ? 0 === e.type : d ? !1 : !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1] ? !1 : !0;
    f || (na(b, c, e, d) && (c = null), d || null === e ? la(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c))));
}
var ra = $b6HlZ.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, sa = 60103, ta = 60106, ua = 60107, wa = 60108, xa = 60114, ya = 60109, za = 60110, Aa = 60112, Ba = 60113, Ca = 60120, Da = 60115, Ea = 60116, Fa = 60121, Ga = 60128, Ha = 60129, Ia = 60130, Ja = 60131;
if ("function" === typeof Symbol && Symbol.for) {
    var E = Symbol.for;
    sa = E("react.element");
    ta = E("react.portal");
    ua = E("react.fragment");
    wa = E("react.strict_mode");
    xa = E("react.profiler");
    ya = E("react.provider");
    za = E("react.context");
    Aa = E("react.forward_ref");
    Ba = E("react.suspense");
    Ca = E("react.suspense_list");
    Da = E("react.memo");
    Ea = E("react.lazy");
    Fa = E("react.block");
    E("react.scope");
    Ga = E("react.opaque.id");
    Ha = E("react.debug_trace_mode");
    Ia = E("react.offscreen");
    Ja = E("react.legacy_hidden");
}
var Ka = "function" === typeof Symbol && Symbol.iterator;
function La(a) {
    if (null === a || "object" !== typeof a) return null;
    a = Ka && a[Ka] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var Ma;
function Na(a) {
    if (void 0 === Ma) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        Ma = b && b[1] || "";
    }
    return "\n" + Ma + a;
}
var Oa = !1;
function Pa(a, b) {
    if (!a || Oa) return "";
    Oa = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (k) {
                    var d = k;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (k) {
                    d = k;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (k) {
                d = k;
            }
            a();
        }
    } catch (k) {
        if (k && d && "string" === typeof k.stack) {
            for(var e = k.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) return "\n" + e[g].replace(" at new ", " at ");
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        Oa = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? Na(a) : "";
}
function Qa(a) {
    switch(a.tag){
        case 5:
            return Na(a.type);
        case 16:
            return Na("Lazy");
        case 13:
            return Na("Suspense");
        case 19:
            return Na("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = Pa(a.type, !1), a;
        case 11:
            return a = Pa(a.type.render, !1), a;
        case 22:
            return a = Pa(a.type._render, !1), a;
        case 1:
            return a = Pa(a.type, !0), a;
        default:
            return "";
    }
}
function Ra(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case ua:
            return "Fragment";
        case ta:
            return "Portal";
        case xa:
            return "Profiler";
        case wa:
            return "StrictMode";
        case Ba:
            return "Suspense";
        case Ca:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case za:
            return (a.displayName || "Context") + ".Consumer";
        case ya:
            return (a._context.displayName || "Context") + ".Provider";
        case Aa:
            var b = a.render;
            b = b.displayName || b.name || "";
            return a.displayName || ("" !== b ? "ForwardRef(" + b + ")" : "ForwardRef");
        case Da:
            return Ra(a.type);
        case Fa:
            return Ra(a._render);
        case Ea:
            b = a._payload;
            a = a._init;
            try {
                return Ra(a(b));
            } catch (c) {}
    }
    return null;
}
function Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "object":
        case "string":
        case "undefined":
            return a;
        default:
            return "";
    }
}
function Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function Ua(a) {
    var b = Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function Va(a) {
    a._valueTracker || (a._valueTracker = Ua(a));
}
function Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function Ya(a, b) {
    var c = b.checked;
    return $8dmsj({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $a(a, b) {
    b = b.checked;
    null != b && qa(a, "checked", b, !1);
}
function ab(a, b) {
    $a(a, b);
    var c = Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? bb(a, b.type, c) : b.hasOwnProperty("defaultValue") && bb(a, b.type, Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function cb(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function bb(a, b, c) {
    if ("number" !== b || Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
function db(a) {
    var b = "";
    $b6HlZ.Children.forEach(a, function(a) {
        null != a && (b += a);
    });
    return b;
}
function eb(a, b) {
    a = $8dmsj({
        children: void 0
    }, b);
    if (b = db(b.children)) a.children = b;
    return a;
}
function fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error(y(91));
    return $8dmsj({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error(y(92));
            if (Array.isArray(c)) {
                if (!(1 >= c.length)) throw Error(y(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: Sa(c)
    };
}
function ib(a, b) {
    var c = Sa(b.value), d = Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
var kb = {
    html: "http://www.w3.org/1999/xhtml",
    mathml: "http://www.w3.org/1998/Math/MathML",
    svg: "http://www.w3.org/2000/svg"
};
function lb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function mb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? lb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var nb, ob = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if (a.namespaceURI !== kb.svg || "innerHTML" in a) a.innerHTML = b;
    else {
        nb = nb || document.createElement("div");
        nb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = nb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function pb(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var qb = {
    animationIterationCount: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, rb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys(qb).forEach(function(a) {
    rb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        qb[b] = qb[a];
    });
});
function sb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || qb.hasOwnProperty(a) && qb[a] ? ("" + b).trim() : b + "px";
}
function tb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = sb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var ub = $8dmsj({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function vb(a, b) {
    if (b) {
        if (ub[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error(y(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error(y(60));
            if (!("object" === typeof b.dangerouslySetInnerHTML && "__html" in b.dangerouslySetInnerHTML)) throw Error(y(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error(y(62));
    }
}
function wb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
function xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var yb = null, zb = null, Ab = null;
function Bb(a) {
    if (a = Cb(a)) {
        if ("function" !== typeof yb) throw Error(y(280));
        var b = a.stateNode;
        b && (b = Db(b), yb(a.stateNode, a.type, b));
    }
}
function Eb(a) {
    zb ? Ab ? Ab.push(a) : Ab = [
        a
    ] : zb = a;
}
function Fb() {
    if (zb) {
        var a = zb, b = Ab;
        Ab = zb = null;
        Bb(a);
        if (b) for(a = 0; a < b.length; a++)Bb(b[a]);
    }
}
function Gb(a, b) {
    return a(b);
}
function Hb(a, b, c, d, e) {
    return a(b, c, d, e);
}
function Ib() {}
var Jb = Gb, Kb = !1, Lb = !1;
function Mb() {
    if (null !== zb || null !== Ab) Ib(), Fb();
}
function Nb(a, b, c) {
    if (Lb) return a(b, c);
    Lb = !0;
    try {
        return Jb(a, b, c);
    } finally{
        Lb = !1, Mb();
    }
}
function Ob(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error(y(231, b, typeof c));
    return c;
}
var Pb = !1;
if (fa) try {
    var Qb = {};
    Object.defineProperty(Qb, "passive", {
        get: function() {
            Pb = !0;
        }
    });
    window.addEventListener("test", Qb, Qb);
    window.removeEventListener("test", Qb, Qb);
} catch (a) {
    Pb = !1;
}
function Rb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (n) {
        this.onError(n);
    }
}
var Sb = !1, Tb = null, Ub = !1, Vb = null, Wb = {
    onError: function(a) {
        Sb = !0;
        Tb = a;
    }
};
function Xb(a, b, c, d, e, f, g, h, k) {
    Sb = !1;
    Tb = null;
    Rb.apply(Wb, arguments);
}
function Yb(a, b, c, d, e, f, g, h, k) {
    Xb.apply(this, arguments);
    if (Sb) {
        if (Sb) {
            var l = Tb;
            Sb = !1;
            Tb = null;
        } else throw Error(y(198));
        Ub || (Ub = !0, Vb = l);
    }
}
function Zb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 1026) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $b(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function ac(a) {
    if (Zb(a) !== a) throw Error(y(188));
}
function bc(a) {
    var b = a.alternate;
    if (!b) {
        b = Zb(a);
        if (null === b) throw Error(y(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return ac(e), a;
                if (f === d) return ac(e), b;
                f = f.sibling;
            }
            throw Error(y(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error(y(189));
            }
        }
        if (c.alternate !== d) throw Error(y(190));
    }
    if (3 !== c.tag) throw Error(y(188));
    return c.stateNode.current === c ? a : b;
}
function cc(a) {
    a = bc(a);
    if (!a) return null;
    for(var b = a;;){
        if (5 === b.tag || 6 === b.tag) return b;
        if (b.child) b.child.return = b, b = b.child;
        else {
            if (b === a) break;
            for(; !b.sibling;){
                if (!b.return || b.return === a) return null;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return null;
}
function dc(a, b) {
    for(var c = a.alternate; null !== b;){
        if (b === a || b === c) return !0;
        b = b.return;
    }
    return !1;
}
var ec, fc, gc, hc, ic = !1, jc = [], kc = null, lc = null, mc = null, nc = new Map, oc = new Map, pc = [], qc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function rc(a, b, c, d, e) {
    return {
        blockedOn: a,
        domEventName: b,
        eventSystemFlags: c | 16,
        nativeEvent: e,
        targetContainers: [
            d
        ]
    };
}
function sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            kc = null;
            break;
        case "dragenter":
        case "dragleave":
            lc = null;
            break;
        case "mouseover":
        case "mouseout":
            mc = null;
            break;
        case "pointerover":
        case "pointerout":
            nc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            oc.delete(b.pointerId);
    }
}
function tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = rc(b, c, d, e, f), null !== b && (b = Cb(b), null !== b && fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return kc = tc(kc, a, b, c, d, e), !0;
        case "dragenter":
            return lc = tc(lc, a, b, c, d, e), !0;
        case "mouseover":
            return mc = tc(mc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            nc.set(f, tc(nc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, oc.set(f, tc(oc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function vc(a) {
    var b = wc(a.target);
    if (null !== b) {
        var c = Zb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $b(c), null !== b) {
                    a.blockedOn = b;
                    hc(a.lanePriority, function() {
                        $5IcjB.unstable_runWithPriority(a.priority, function() {
                            gc(c);
                        });
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.hydrate) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null !== c) return b = Cb(c), null !== b && fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function zc(a, b, c) {
    xc(a) && c.delete(b);
}
function Ac() {
    for(ic = !1; 0 < jc.length;){
        var a = jc[0];
        if (null !== a.blockedOn) {
            a = Cb(a.blockedOn);
            null !== a && ec(a);
            break;
        }
        for(var b = a.targetContainers; 0 < b.length;){
            var c = yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
            if (null !== c) {
                a.blockedOn = c;
                break;
            }
            b.shift();
        }
        null === a.blockedOn && jc.shift();
    }
    null !== kc && xc(kc) && (kc = null);
    null !== lc && xc(lc) && (lc = null);
    null !== mc && xc(mc) && (mc = null);
    nc.forEach(zc);
    oc.forEach(zc);
}
function Bc(a, b) {
    a.blockedOn === b && (a.blockedOn = null, ic || (ic = !0, $5IcjB.unstable_scheduleCallback($5IcjB.unstable_NormalPriority, Ac)));
}
function Cc(a) {
    function b(b) {
        return Bc(b, a);
    }
    if (0 < jc.length) {
        Bc(jc[0], a);
        for(var c = 1; c < jc.length; c++){
            var d = jc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== kc && Bc(kc, a);
    null !== lc && Bc(lc, a);
    null !== mc && Bc(mc, a);
    nc.forEach(b);
    oc.forEach(b);
    for(c = 0; c < pc.length; c++)d = pc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < pc.length && (c = pc[0], null === c.blockedOn);)vc(c), null === c.blockedOn && pc.shift();
}
function Dc(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var Ec = {
    animationend: Dc("Animation", "AnimationEnd"),
    animationiteration: Dc("Animation", "AnimationIteration"),
    animationstart: Dc("Animation", "AnimationStart"),
    transitionend: Dc("Transition", "TransitionEnd")
}, Fc = {}, Gc = {};
fa && (Gc = document.createElement("div").style, "AnimationEvent" in window || (delete Ec.animationend.animation, delete Ec.animationiteration.animation, delete Ec.animationstart.animation), "TransitionEvent" in window || delete Ec.transitionend.transition);
function Hc(a) {
    if (Fc[a]) return Fc[a];
    if (!Ec[a]) return a;
    var b = Ec[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in Gc) return Fc[a] = b[c];
    return a;
}
var Ic = Hc("animationend"), Jc = Hc("animationiteration"), Kc = Hc("animationstart"), Lc = Hc("transitionend"), Mc = new Map, Nc = new Map, Oc = [
    "abort",
    "abort",
    Ic,
    "animationEnd",
    Jc,
    "animationIteration",
    Kc,
    "animationStart",
    "canplay",
    "canPlay",
    "canplaythrough",
    "canPlayThrough",
    "durationchange",
    "durationChange",
    "emptied",
    "emptied",
    "encrypted",
    "encrypted",
    "ended",
    "ended",
    "error",
    "error",
    "gotpointercapture",
    "gotPointerCapture",
    "load",
    "load",
    "loadeddata",
    "loadedData",
    "loadedmetadata",
    "loadedMetadata",
    "loadstart",
    "loadStart",
    "lostpointercapture",
    "lostPointerCapture",
    "playing",
    "playing",
    "progress",
    "progress",
    "seeking",
    "seeking",
    "stalled",
    "stalled",
    "suspend",
    "suspend",
    "timeupdate",
    "timeUpdate",
    Lc,
    "transitionEnd",
    "waiting",
    "waiting"
];
function Pc(a, b) {
    for(var c = 0; c < a.length; c += 2){
        var d = a[c], e = a[c + 1];
        e = "on" + (e[0].toUpperCase() + e.slice(1));
        Nc.set(d, b);
        Mc.set(d, e);
        da(e, [
            d
        ]);
    }
}
var Qc = $5IcjB.unstable_now;
Qc();
var F = 8;
function Rc(a) {
    if (0 !== (1 & a)) return F = 15, 1;
    if (0 !== (2 & a)) return F = 14, 2;
    if (0 !== (4 & a)) return F = 13, 4;
    var b = 24 & a;
    if (0 !== b) return F = 12, b;
    if (0 !== (a & 32)) return F = 11, 32;
    b = 192 & a;
    if (0 !== b) return F = 10, b;
    if (0 !== (a & 256)) return F = 9, 256;
    b = 3584 & a;
    if (0 !== b) return F = 8, b;
    if (0 !== (a & 4096)) return F = 7, 4096;
    b = 4186112 & a;
    if (0 !== b) return F = 6, b;
    b = 62914560 & a;
    if (0 !== b) return F = 5, b;
    if (a & 67108864) return F = 4, 67108864;
    if (0 !== (a & 134217728)) return F = 3, 134217728;
    b = 805306368 & a;
    if (0 !== b) return F = 2, b;
    if (0 !== (1073741824 & a)) return F = 1, 1073741824;
    F = 8;
    return a;
}
function Sc(a) {
    switch(a){
        case 99:
            return 15;
        case 98:
            return 10;
        case 97:
        case 96:
            return 8;
        case 95:
            return 2;
        default:
            return 0;
    }
}
function Tc(a) {
    switch(a){
        case 15:
        case 14:
            return 99;
        case 13:
        case 12:
        case 11:
        case 10:
            return 98;
        case 9:
        case 8:
        case 7:
        case 6:
        case 4:
        case 5:
            return 97;
        case 3:
        case 2:
        case 1:
            return 95;
        case 0:
            return 90;
        default:
            throw Error(y(358, a));
    }
}
function Uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return F = 0;
    var d = 0, e = 0, f = a.expiredLanes, g = a.suspendedLanes, h = a.pingedLanes;
    if (0 !== f) d = f, e = F = 15;
    else if (f = c & 134217727, 0 !== f) {
        var k = f & ~g;
        0 !== k ? (d = Rc(k), e = F) : (h &= f, 0 !== h && (d = Rc(h), e = F));
    } else f = c & ~g, 0 !== f ? (d = Rc(f), e = F) : 0 !== h && (d = Rc(h), e = F);
    if (0 === d) return 0;
    d = 31 - Vc(d);
    d = c & ((0 > d ? 0 : 1 << d) << 1) - 1;
    if (0 !== b && b !== d && 0 === (b & g)) {
        Rc(b);
        if (e <= F) return b;
        F = e;
    }
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - Vc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function Wc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function Xc(a, b) {
    switch(a){
        case 15:
            return 1;
        case 14:
            return 2;
        case 12:
            return a = Yc(24 & ~b), 0 === a ? Xc(10, b) : a;
        case 10:
            return a = Yc(192 & ~b), 0 === a ? Xc(8, b) : a;
        case 8:
            return a = Yc(3584 & ~b), 0 === a && (a = Yc(4186112 & ~b), 0 === a && (a = 512)), a;
        case 2:
            return b = Yc(805306368 & ~b), 0 === b && (b = 268435456), b;
    }
    throw Error(y(358, a));
}
function Yc(a) {
    return a & -a;
}
function Zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $c(a, b, c) {
    a.pendingLanes |= b;
    var d = b - 1;
    a.suspendedLanes &= d;
    a.pingedLanes &= d;
    a = a.eventTimes;
    b = 31 - Vc(b);
    a[b] = c;
}
var Vc = Math.clz32 ? Math.clz32 : ad, bd = Math.log, cd = Math.LN2;
function ad(a) {
    return 0 === a ? 32 : 31 - (bd(a) / cd | 0) | 0;
}
var dd = $5IcjB.unstable_UserBlockingPriority, ed = $5IcjB.unstable_runWithPriority, fd = !0;
function gd(a, b, c, d) {
    Kb || Ib();
    var e = hd, f = Kb;
    Kb = !0;
    try {
        Hb(e, a, b, c, d);
    } finally{
        (Kb = f) || Mb();
    }
}
function id(a, b, c, d) {
    ed(dd, hd.bind(null, a, b, c, d));
}
function hd(a, b, c, d) {
    if (fd) {
        var e;
        if ((e = 0 === (b & 4)) && 0 < jc.length && -1 < qc.indexOf(a)) a = rc(null, a, b, c, d), jc.push(a);
        else {
            var f = yc(a, b, c, d);
            if (null === f) e && sc(a, d);
            else {
                if (e) {
                    if (-1 < qc.indexOf(a)) {
                        a = rc(f, a, b, c, d);
                        jc.push(a);
                        return;
                    }
                    if (uc(f, a, b, c, d)) return;
                    sc(a, d);
                }
                jd(a, b, d, null, c);
            }
        }
    }
}
function yc(a, b, c, d) {
    var e = xb(d);
    e = wc(e);
    if (null !== e) {
        var f = Zb(e);
        if (null === f) e = null;
        else {
            var g = f.tag;
            if (13 === g) {
                e = $b(f);
                if (null !== e) return e;
                e = null;
            } else if (3 === g) {
                if (f.stateNode.hydrate) return 3 === f.tag ? f.stateNode.containerInfo : null;
                e = null;
            } else f !== e && (e = null);
        }
    }
    jd(a, b, d, e, c);
    return null;
}
var kd = null, ld = null, md = null;
function nd() {
    if (md) return md;
    var a, b = ld, c = b.length, d, e = "value" in kd ? kd.value : kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function pd() {
    return !0;
}
function qd() {
    return !1;
}
function rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? pd : qd;
        this.isPropagationStopped = qd;
        return this;
    }
    $8dmsj(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = pd);
        },
        persist: function() {},
        isPersistent: pd
    });
    return b;
}
var sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, td = rd(sd), ud = $8dmsj({}, sd, {
    view: 0,
    detail: 0
}), vd = rd(ud), wd, xd, yd, Ad = $8dmsj({}, ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== yd && (yd && "mousemove" === a.type ? (wd = a.screenX - yd.screenX, xd = a.screenY - yd.screenY) : xd = wd = 0, yd = a);
        return wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : xd;
    }
}), Bd = rd(Ad), Cd = $8dmsj({}, Ad, {
    dataTransfer: 0
}), Dd = rd(Cd), Ed = $8dmsj({}, ud, {
    relatedTarget: 0
}), Fd = rd(Ed), Gd = $8dmsj({}, sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Hd = rd(Gd), Id = $8dmsj({}, sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), Jd = rd(Id), Kd = $8dmsj({}, sd, {
    data: 0
}), Ld = rd(Kd), Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = Od[a]) ? !!b[a] : !1;
}
function zd() {
    return Pd;
}
var Qd = $8dmsj({}, ud, {
    key: function(a) {
        if (a.key) {
            var b = Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: zd,
    charCode: function(a) {
        return "keypress" === a.type ? od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), Rd = rd(Qd), Sd = $8dmsj({}, Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), Td = rd(Sd), Ud = $8dmsj({}, ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: zd
}), Vd = rd(Ud), Wd = $8dmsj({}, sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Xd = rd(Wd), Yd = $8dmsj({}, Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), Zd = rd(Yd), $d = [
    9,
    13,
    27,
    32
], ae = fa && "CompositionEvent" in window, be = null;
fa && "documentMode" in document && (be = document.documentMode);
var ce = fa && "TextEvent" in window && !be, de = fa && (!ae || be && 8 < be && 11 >= be), ee = String.fromCharCode(32), fe = !1;
function ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var ie = !1;
function je(a, b) {
    switch(a){
        case "compositionend":
            return he(b);
        case "keypress":
            if (32 !== b.which) return null;
            fe = !0;
            return ee;
        case "textInput":
            return a = b.data, a === ee && fe ? null : a;
        default:
            return null;
    }
}
function ke(a, b) {
    if (ie) return "compositionend" === a || !ae && ge(a, b) ? (a = nd(), md = ld = kd = null, ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!le[a.type] : "textarea" === b ? !0 : !1;
}
function ne(a, b, c, d) {
    Eb(d);
    b = oe(b, "onChange");
    0 < b.length && (c = new td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var pe = null, qe = null;
function re(a) {
    se(a, 0);
}
function te(a) {
    var b = ue(a);
    if (Wa(b)) return a;
}
function ve(a, b) {
    if ("change" === a) return b;
}
var we = !1;
if (fa) {
    var xe;
    if (fa) {
        var ye = "oninput" in document;
        if (!ye) {
            var ze = document.createElement("div");
            ze.setAttribute("oninput", "return;");
            ye = "function" === typeof ze.oninput;
        }
        xe = ye;
    } else xe = !1;
    we = xe && (!document.documentMode || 9 < document.documentMode);
}
function Ae() {
    pe && (pe.detachEvent("onpropertychange", Be), qe = pe = null);
}
function Be(a) {
    if ("value" === a.propertyName && te(qe)) {
        var b = [];
        ne(b, qe, a, xb(a));
        a = re;
        if (Kb) a(b);
        else {
            Kb = !0;
            try {
                Gb(a, b);
            } finally{
                Kb = !1, Mb();
            }
        }
    }
}
function Ce(a, b, c) {
    "focusin" === a ? (Ae(), pe = b, qe = c, pe.attachEvent("onpropertychange", Be)) : "focusout" === a && Ae();
}
function De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return te(qe);
}
function Ee(a, b) {
    if ("click" === a) return te(b);
}
function Fe(a, b) {
    if ("input" === a || "change" === a) return te(b);
}
function Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var He = "function" === typeof Object.is ? Object.is : Ge, Ie = Object.prototype.hasOwnProperty;
function Je(a, b) {
    if (He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++)if (!Ie.call(b, c[d]) || !He(a[c[d]], b[c[d]])) return !1;
    return !0;
}
function Ke(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function Le(a, b) {
    var c = Ke(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = Ke(c);
    }
}
function Me(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? Me(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function Ne() {
    for(var a = window, b = Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = Xa(a.document);
    }
    return b;
}
function Oe(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
var Pe = fa && "documentMode" in document && 11 >= document.documentMode, Qe = null, Re = null, Se = null, Te = !1;
function Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    Te || null == Qe || Qe !== Xa(d) || (d = Qe, "selectionStart" in d && Oe(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), Se && Je(Se, d) || (Se = d, d = oe(Re, "onSelect"), 0 < d.length && (b = new td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = Qe)));
}
Pc("cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focusin focus focusout blur input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "), 0);
Pc("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "), 1);
Pc(Oc, 2);
for(var Ve = "change selectionchange textInput compositionstart compositionend compositionupdate".split(" "), We = 0; We < Ve.length; We++)Nc.set(Ve[We], 0);
ea("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
ea("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
ea("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
ea("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
da("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
da("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
da("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
da("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
da("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
da("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var Xe = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), Ye = new Set("cancel close invalid load scroll toggle".split(" ").concat(Xe));
function Ze(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    Yb(d, b, void 0, a);
    a.currentTarget = null;
}
function se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                Ze(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                Ze(e, h, l);
                f = k;
            }
        }
    }
    if (Ub) throw a = Vb, Ub = !1, Vb = null, a;
}
function G(a, b) {
    var c = $e(b), d = a + "__bubble";
    c.has(d) || (af(b, a, 2, !1), c.add(d));
}
var bf = "_reactListening" + Math.random().toString(36).slice(2);
function cf(a) {
    a[bf] || (a[bf] = !0, ba.forEach(function(b) {
        Ye.has(b) || df(b, !1, a, null);
        df(b, !0, a, null);
    }));
}
function df(a, b, c, d) {
    var e = 4 < arguments.length && void 0 !== arguments[4] ? arguments[4] : 0, f = c;
    "selectionchange" === a && 9 !== c.nodeType && (f = c.ownerDocument);
    if (null !== d && !b && Ye.has(a)) {
        if ("scroll" !== a) return;
        e |= 2;
        f = d;
    }
    var g = $e(f), h = a + "__" + (b ? "capture" : "bubble");
    g.has(h) || (b && (e |= 4), af(f, a, e, b), g.add(h));
}
function af(a, b, c, d) {
    var e = Nc.get(b);
    switch(void 0 === e ? 2 : e){
        case 0:
            e = gd;
            break;
        case 1:
            e = id;
            break;
        default:
            e = hd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !Pb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function jd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    Nb(function() {
        var d = f, e = xb(c), g = [];
        a: {
            var h = Mc.get(a);
            if (void 0 !== h) {
                var k = td, x = a;
                switch(a){
                    case "keypress":
                        if (0 === od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = Rd;
                        break;
                    case "focusin":
                        x = "focus";
                        k = Fd;
                        break;
                    case "focusout":
                        x = "blur";
                        k = Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = Vd;
                        break;
                    case Ic:
                    case Jc:
                    case Kc:
                        k = Hd;
                        break;
                    case Lc:
                        k = Xd;
                        break;
                    case "scroll":
                        k = vd;
                        break;
                    case "wheel":
                        k = Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = Td;
                }
                var w = 0 !== (b & 4), z = !w && "scroll" === a, u = w ? null !== h ? h + "Capture" : null : h;
                w = [];
                for(var t = d, q; null !== t;){
                    q = t;
                    var v = q.stateNode;
                    5 === q.tag && null !== v && (q = v, null !== u && (v = Ob(t, u), null != v && w.push(ef(t, v, q))));
                    if (z) break;
                    t = t.return;
                }
                0 < w.length && (h = new k(h, x, null, c, e), g.push({
                    event: h,
                    listeners: w
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && 0 === (b & 16) && (x = c.relatedTarget || c.fromElement) && (wc(x) || x[ff])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (x = c.relatedTarget || c.toElement, k = d, x = x ? wc(x) : null, null !== x && (z = Zb(x), x !== z || 5 !== x.tag && 6 !== x.tag)) x = null;
                    } else k = null, x = d;
                    if (k !== x) {
                        w = Bd;
                        v = "onMouseLeave";
                        u = "onMouseEnter";
                        t = "mouse";
                        if ("pointerout" === a || "pointerover" === a) w = Td, v = "onPointerLeave", u = "onPointerEnter", t = "pointer";
                        z = null == k ? h : ue(k);
                        q = null == x ? h : ue(x);
                        h = new w(v, t + "leave", k, c, e);
                        h.target = z;
                        h.relatedTarget = q;
                        v = null;
                        wc(e) === d && (w = new w(u, t + "enter", x, c, e), w.target = q, w.relatedTarget = z, v = w);
                        z = v;
                        if (k && x) b: {
                            w = k;
                            u = x;
                            t = 0;
                            for(q = w; q; q = gf(q))t++;
                            q = 0;
                            for(v = u; v; v = gf(v))q++;
                            for(; 0 < t - q;)w = gf(w), t--;
                            for(; 0 < q - t;)u = gf(u), q--;
                            for(; t--;){
                                if (w === u || null !== u && w === u.alternate) break b;
                                w = gf(w);
                                u = gf(u);
                            }
                            w = null;
                        }
                        else w = null;
                        null !== k && hf(g, h, k, w, !1);
                        null !== x && null !== z && hf(g, z, x, w, !0);
                    }
                }
            }
            a: {
                h = d ? ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var J = ve;
                else if (me(h)) {
                    if (we) J = Fe;
                    else {
                        J = De;
                        var K = Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (J = Ee);
                if (J && (J = J(a, d))) {
                    ne(g, J, c, e);
                    break a;
                }
                K && K(a, h, d);
                "focusout" === a && (K = h._wrapperState) && K.controlled && "number" === h.type && bb(h, "number", h.value);
            }
            K = d ? ue(d) : window;
            switch(a){
                case "focusin":
                    if (me(K) || "true" === K.contentEditable) Qe = K, Re = d, Se = null;
                    break;
                case "focusout":
                    Se = Re = Qe = null;
                    break;
                case "mousedown":
                    Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    Te = !1;
                    Ue(g, c, e);
                    break;
                case "selectionchange":
                    if (Pe) break;
                case "keydown":
                case "keyup":
                    Ue(g, c, e);
            }
            var Q;
            if (ae) b: {
                switch(a){
                    case "compositionstart":
                        var L = "onCompositionStart";
                        break b;
                    case "compositionend":
                        L = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        L = "onCompositionUpdate";
                        break b;
                }
                L = void 0;
            }
            else ie ? ge(a, c) && (L = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (L = "onCompositionStart");
            L && (de && "ko" !== c.locale && (ie || "onCompositionStart" !== L ? "onCompositionEnd" === L && ie && (Q = nd()) : (kd = e, ld = "value" in kd ? kd.value : kd.textContent, ie = !0)), K = oe(d, L), 0 < K.length && (L = new Ld(L, a, null, c, e), g.push({
                event: L,
                listeners: K
            }), Q ? L.data = Q : (Q = he(c), null !== Q && (L.data = Q))));
            if (Q = ce ? je(a, c) : ke(a, c)) d = oe(d, "onBeforeInput"), 0 < d.length && (e = new Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = Q);
        }
        se(g, b);
    });
}
function ef(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = Ob(a, c), null != f && d.unshift(ef(a, f, e)), f = Ob(a, b), null != f && d.push(ef(a, f, e)));
        a = a.return;
    }
    return d;
}
function gf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function hf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = Ob(c, f), null != k && g.unshift(ef(c, k, h))) : e || (k = Ob(c, f), null != k && g.push(ef(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
function jf() {}
var kf = null, lf = null;
function mf(a, b) {
    switch(a){
        case "button":
        case "input":
        case "select":
        case "textarea":
            return !!b.autoFocus;
    }
    return !1;
}
function nf(a, b) {
    return "textarea" === a || "option" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var of = "function" === typeof setTimeout ? setTimeout : void 0, pf = "function" === typeof clearTimeout ? clearTimeout : void 0;
function qf(a) {
    1 === a.nodeType ? a.textContent = "" : 9 === a.nodeType && (a = a.body, null != a && (a.textContent = ""));
}
function rf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
    }
    return a;
}
function sf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var tf = 0;
function uf(a) {
    return {
        $$typeof: Ga,
        toString: a,
        valueOf: a
    };
}
var vf = Math.random().toString(36).slice(2), wf = "__reactFiber$" + vf, xf = "__reactProps$" + vf, ff = "__reactContainer$" + vf, yf = "__reactEvents$" + vf;
function wc(a) {
    var b = a[wf];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[ff] || c[wf]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = sf(a); null !== a;){
                if (c = a[wf]) return c;
                a = sf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function Cb(a) {
    a = a[wf] || a[ff];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error(y(33));
}
function Db(a) {
    return a[xf] || null;
}
function $e(a) {
    var b = a[yf];
    void 0 === b && (b = a[yf] = new Set);
    return b;
}
var zf = [], Af = -1;
function Bf(a) {
    return {
        current: a
    };
}
function H(a) {
    0 > Af || (a.current = zf[Af], zf[Af] = null, Af--);
}
function I(a, b) {
    Af++;
    zf[Af] = a.current;
    a.current = b;
}
var Cf = {}, M = Bf(Cf), N = Bf(!1), Df = Cf;
function Ef(a, b) {
    var c = a.type.contextTypes;
    if (!c) return Cf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function Ff(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function Gf() {
    H(N);
    H(M);
}
function Hf(a, b, c) {
    if (M.current !== Cf) throw Error(y(168));
    I(M, b);
    I(N, c);
}
function If(a, b, c) {
    var d = a.stateNode;
    a = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in a)) throw Error(y(108, Ra(b) || "Unknown", e));
    return $8dmsj({}, c, d);
}
function Jf(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || Cf;
    Df = M.current;
    I(M, a);
    I(N, N.current);
    return !0;
}
function Kf(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error(y(169));
    c ? (a = If(a, b, Df), d.__reactInternalMemoizedMergedChildContext = a, H(N), H(M), I(M, a)) : H(N);
    I(N, c);
}
var Lf = null, Mf = null, Nf = $5IcjB.unstable_runWithPriority, Of = $5IcjB.unstable_scheduleCallback, Pf = $5IcjB.unstable_cancelCallback, Qf = $5IcjB.unstable_shouldYield, Rf = $5IcjB.unstable_requestPaint, Sf = $5IcjB.unstable_now, Tf = $5IcjB.unstable_getCurrentPriorityLevel, Uf = $5IcjB.unstable_ImmediatePriority, Vf = $5IcjB.unstable_UserBlockingPriority, Wf = $5IcjB.unstable_NormalPriority, Xf = $5IcjB.unstable_LowPriority, Yf = $5IcjB.unstable_IdlePriority, Zf = {}, $f = void 0 !== Rf ? Rf : function() {}, ag = null, bg = null, cg = !1, dg = Sf(), O = 1E4 > dg ? Sf : function() {
    return Sf() - dg;
};
function eg() {
    switch(Tf()){
        case Uf:
            return 99;
        case Vf:
            return 98;
        case Wf:
            return 97;
        case Xf:
            return 96;
        case Yf:
            return 95;
        default:
            throw Error(y(332));
    }
}
function fg(a) {
    switch(a){
        case 99:
            return Uf;
        case 98:
            return Vf;
        case 97:
            return Wf;
        case 96:
            return Xf;
        case 95:
            return Yf;
        default:
            throw Error(y(332));
    }
}
function gg(a, b) {
    a = fg(a);
    return Nf(a, b);
}
function hg(a, b, c) {
    a = fg(a);
    return Of(a, b, c);
}
function ig() {
    if (null !== bg) {
        var a = bg;
        bg = null;
        Pf(a);
    }
    jg();
}
function jg() {
    if (!cg && null !== ag) {
        cg = !0;
        var a = 0;
        try {
            var b = ag;
            gg(99, function() {
                for(; a < b.length; a++){
                    var c = b[a];
                    do c = c(!0);
                    while (null !== c);
                }
            });
            ag = null;
        } catch (c) {
            throw null !== ag && (ag = ag.slice(a + 1)), Of(Uf, ig), c;
        } finally{
            cg = !1;
        }
    }
}
var kg = ra.ReactCurrentBatchConfig;
function lg(a, b) {
    if (a && a.defaultProps) {
        b = $8dmsj({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var mg = Bf(null), ng = null, og = null, pg = null;
function qg() {
    pg = og = ng = null;
}
function rg(a) {
    var b = mg.current;
    H(mg);
    a.type._context._currentValue = b;
}
function sg(a, b) {
    for(; null !== a;){
        var c = a.alternate;
        if ((a.childLanes & b) === b) {
            if (null === c || (c.childLanes & b) === b) break;
            else c.childLanes |= b;
        } else a.childLanes |= b, null !== c && (c.childLanes |= b);
        a = a.return;
    }
}
function tg(a, b) {
    ng = a;
    pg = og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && (ug = !0), a.firstContext = null);
}
function vg(a, b) {
    if (pg !== a && !1 !== b && 0 !== b) {
        if ("number" !== typeof b || 1073741823 === b) pg = a, b = 1073741823;
        b = {
            context: a,
            observedBits: b,
            next: null
        };
        if (null === og) {
            if (null === ng) throw Error(y(308));
            og = b;
            ng.dependencies = {
                lanes: 0,
                firstContext: b,
                responders: null
            };
        } else og = og.next = b;
    }
    return a._currentValue;
}
var wg = !1;
function xg(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null
        },
        effects: null
    };
}
function yg(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function zg(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function Ag(a, b) {
    a = a.updateQueue;
    if (null !== a) {
        a = a.shared;
        var c = a.pending;
        null === c ? b.next = b : (b.next = c.next, c.next = b);
        a.pending = b;
    }
}
function Bg(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function Cg(a, b, c, d) {
    var e = a.updateQueue;
    wg = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var n = a.alternate;
        if (null !== n) {
            n = n.updateQueue;
            var A = n.lastBaseUpdate;
            A !== g && (null === A ? n.firstBaseUpdate = l : A.next = l, n.lastBaseUpdate = k);
        }
    }
    if (null !== f) {
        A = e.baseState;
        g = 0;
        n = l = k = null;
        do {
            h = f.lane;
            var p = f.eventTime;
            if ((d & h) === h) {
                null !== n && (n = n.next = {
                    eventTime: p,
                    lane: 0,
                    tag: f.tag,
                    payload: f.payload,
                    callback: f.callback,
                    next: null
                });
                a: {
                    var C = a, x = f;
                    h = b;
                    p = c;
                    switch(x.tag){
                        case 1:
                            C = x.payload;
                            if ("function" === typeof C) {
                                A = C.call(p, A, h);
                                break a;
                            }
                            A = C;
                            break a;
                        case 3:
                            C.flags = C.flags & -4097 | 64;
                        case 0:
                            C = x.payload;
                            h = "function" === typeof C ? C.call(p, A, h) : C;
                            if (null === h || void 0 === h) break a;
                            A = $8dmsj({}, A, h);
                            break a;
                        case 2:
                            wg = !0;
                    }
                }
                null !== f.callback && (a.flags |= 32, h = e.effects, null === h ? e.effects = [
                    f
                ] : h.push(f));
            } else p = {
                eventTime: p,
                lane: h,
                tag: f.tag,
                payload: f.payload,
                callback: f.callback,
                next: null
            }, null === n ? (l = n = p, k = A) : n = n.next = p, g |= h;
            f = f.next;
            if (null === f) {
                if (h = e.shared.pending, null === h) break;
                else f = h.next, h.next = null, e.lastBaseUpdate = h, e.shared.pending = null;
            }
        }while (1);
        null === n && (k = A);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = n;
        Dg |= g;
        a.lanes = g;
        a.memoizedState = A;
    }
}
function Eg(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error(y(191, e));
            e.call(d);
        }
    }
}
var Fg = (new $b6HlZ.Component).refs;
function Gg(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $8dmsj({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var Kg = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? Zb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = Hg(), e = Ig(a), f = zg(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        Ag(a, f);
        Jg(a, e, d);
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = Hg(), e = Ig(a), f = zg(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        Ag(a, f);
        Jg(a, e, d);
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = Hg(), d = Ig(a), e = zg(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        Ag(a, e);
        Jg(a, d, c);
    }
};
function Lg(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !Je(c, d) || !Je(e, f) : !0;
}
function Mg(a, b, c) {
    var d = !1, e = Cf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = vg(f) : (e = Ff(b) ? Df : M.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? Ef(a, e) : Cf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = Kg;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function Ng(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && Kg.enqueueReplaceState(b, b.state, null);
}
function Og(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = Fg;
    xg(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = vg(f) : (f = Ff(b) ? Df : M.current, e.context = Ef(a, f));
    Cg(a, c, e, d);
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && (Gg(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && Kg.enqueueReplaceState(e, e.state, null), Cg(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4);
}
var Pg = Array.isArray;
function Qg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error(y(309));
                var d = c.stateNode;
            }
            if (!d) throw Error(y(147, a));
            var e = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === e) return b.ref;
            b = function(a) {
                var b = d.refs;
                b === Fg && (b = d.refs = {});
                null === a ? delete b[e] : b[e] = a;
            };
            b._stringRef = e;
            return b;
        }
        if ("string" !== typeof a) throw Error(y(284));
        if (!c._owner) throw Error(y(290, a));
    }
    return a;
}
function Rg(a, b) {
    if ("textarea" !== a.type) throw Error(y(31, "[object Object]" === Object.prototype.toString.call(b) ? "object with keys {" + Object.keys(b).join(", ") + "}" : b));
}
function Sg(a) {
    function b(b, c) {
        if (a) {
            var d = b.lastEffect;
            null !== d ? (d.nextEffect = c, b.lastEffect = c) : b.firstEffect = b.lastEffect = c;
            c.nextEffect = null;
            c.flags = 8;
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = Tg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags = 2, c) : d;
        b.flags = 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags = 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = Ug(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        if (null !== b && b.elementType === c.type) return d = e(b, c.props), d.ref = Qg(a, b, c), d.return = a, d;
        d = Vg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = Qg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = Wg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function n(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = Xg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function A(a, b, c) {
        if ("string" === typeof b || "number" === typeof b) return b = Ug("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case sa:
                    return c = Vg(b.type, b.key, b.props, null, a.mode, c), c.ref = Qg(a, null, b), c.return = a, c;
                case ta:
                    return b = Wg(b, a.mode, c), b.return = a, b;
            }
            if (Pg(b) || La(b)) return b = Xg(b, a.mode, c, null), b.return = a, b;
            Rg(a, b);
        }
        return null;
    }
    function p(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case sa:
                    return c.key === e ? c.type === ua ? n(a, b, c.props.children, d, e) : k(a, b, c, d) : null;
                case ta:
                    return c.key === e ? l(a, b, c, d) : null;
            }
            if (Pg(c) || La(c)) return null !== e ? null : n(a, b, c, d, null);
            Rg(a, c);
        }
        return null;
    }
    function C(a, b, c, d, e) {
        if ("string" === typeof d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case sa:
                    return a = a.get(null === d.key ? c : d.key) || null, d.type === ua ? n(b, a, d.props.children, e, d.key) : k(b, a, d, e);
                case ta:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
            }
            if (Pg(d) || La(d)) return a = a.get(c) || null, n(b, a, d, e, null);
            Rg(b, d);
        }
        return null;
    }
    function x(e, g, h, k) {
        for(var l = null, t = null, u = g, z = g = 0, q = null; null !== u && z < h.length; z++){
            u.index > z ? (q = u, u = null) : q = u.sibling;
            var n = p(e, u, h[z], k);
            if (null === n) {
                null === u && (u = q);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, z);
            null === t ? l = n : t.sibling = n;
            t = n;
            u = q;
        }
        if (z === h.length) return c(e, u), l;
        if (null === u) {
            for(; z < h.length; z++)u = A(e, h[z], k), null !== u && (g = f(u, g, z), null === t ? l = u : t.sibling = u, t = u);
            return l;
        }
        for(u = d(e, u); z < h.length; z++)q = C(u, e, z, h[z], k), null !== q && (a && null !== q.alternate && u.delete(null === q.key ? z : q.key), g = f(q, g, z), null === t ? l = q : t.sibling = q, t = q);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        return l;
    }
    function w(e, g, h, k) {
        var l = La(h);
        if ("function" !== typeof l) throw Error(y(150));
        h = l.call(h);
        if (null == h) throw Error(y(151));
        for(var t = l = null, u = g, z = g = 0, q = null, n = h.next(); null !== u && !n.done; z++, n = h.next()){
            u.index > z ? (q = u, u = null) : q = u.sibling;
            var w = p(e, u, n.value, k);
            if (null === w) {
                null === u && (u = q);
                break;
            }
            a && u && null === w.alternate && b(e, u);
            g = f(w, g, z);
            null === t ? l = w : t.sibling = w;
            t = w;
            u = q;
        }
        if (n.done) return c(e, u), l;
        if (null === u) {
            for(; !n.done; z++, n = h.next())n = A(e, n.value, k), null !== n && (g = f(n, g, z), null === t ? l = n : t.sibling = n, t = n);
            return l;
        }
        for(u = d(e, u); !n.done; z++, n = h.next())n = C(u, e, z, n.value, k), null !== n && (a && null !== n.alternate && u.delete(null === n.key ? z : n.key), g = f(n, g, z), null === t ? l = n : t.sibling = n, t = n);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        return l;
    }
    return function(a, d, f, h) {
        var k = "object" === typeof f && null !== f && f.type === ua && null === f.key;
        k && (f = f.props.children);
        var l = "object" === typeof f && null !== f;
        if (l) switch(f.$$typeof){
            case sa:
                a: {
                    l = f.key;
                    for(k = d; null !== k;){
                        if (k.key === l) {
                            switch(k.tag){
                                case 7:
                                    if (f.type === ua) {
                                        c(a, k.sibling);
                                        d = e(k, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                    break;
                                default:
                                    if (k.elementType === f.type) {
                                        c(a, k.sibling);
                                        d = e(k, f.props);
                                        d.ref = Qg(a, k, f);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                            }
                            c(a, k);
                            break;
                        } else b(a, k);
                        k = k.sibling;
                    }
                    f.type === ua ? (d = Xg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = Vg(f.type, f.key, f.props, null, a.mode, h), h.ref = Qg(a, d, f), h.return = a, a = h);
                }
                return g(a);
            case ta:
                a: {
                    for(k = f.key; null !== d;){
                        if (d.key === k) {
                            if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                c(a, d.sibling);
                                d = e(d, f.children || []);
                                d.return = a;
                                a = d;
                                break a;
                            } else {
                                c(a, d);
                                break;
                            }
                        } else b(a, d);
                        d = d.sibling;
                    }
                    d = Wg(f, a.mode, h);
                    d.return = a;
                    a = d;
                }
                return g(a);
        }
        if ("string" === typeof f || "number" === typeof f) return f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = Ug(f, a.mode, h), d.return = a, a = d), g(a);
        if (Pg(f)) return x(a, d, f, h);
        if (La(f)) return w(a, d, f, h);
        l && Rg(a, f);
        if ("undefined" === typeof f && !k) switch(a.tag){
            case 1:
            case 22:
            case 0:
            case 11:
            case 15:
                throw Error(y(152, Ra(a.type) || "Component"));
        }
        return c(a, d);
    };
}
var Yg = Sg(!0), Zg = Sg(!1), $g = {}, ah = Bf($g), bh = Bf($g), ch = Bf($g);
function dh(a) {
    if (a === $g) throw Error(y(174));
    return a;
}
function eh(a, b) {
    I(ch, b);
    I(bh, a);
    I(ah, $g);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : mb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = mb(b, a);
    }
    H(ah);
    I(ah, b);
}
function fh() {
    H(ah);
    H(bh);
    H(ch);
}
function gh(a) {
    dh(ch.current);
    var b = dh(ah.current);
    var c = mb(b, a.type);
    b !== c && (I(bh, a), I(ah, c));
}
function hh(a) {
    bh.current === a && (H(ah), H(bh));
}
var P = Bf(0);
function ih(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 64)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var jh = null, kh = null, lh = !1;
function mh(a, b) {
    var c = nh(5, null, null, 0);
    c.elementType = "DELETED";
    c.type = "DELETED";
    c.stateNode = b;
    c.return = a;
    c.flags = 8;
    null !== a.lastEffect ? (a.lastEffect.nextEffect = c, a.lastEffect = c) : a.firstEffect = a.lastEffect = c;
}
function oh(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, !0) : !1;
        case 13:
            return !1;
        default:
            return !1;
    }
}
function ph(a) {
    if (lh) {
        var b = kh;
        if (b) {
            var c = b;
            if (!oh(a, b)) {
                b = rf(c.nextSibling);
                if (!b || !oh(a, b)) {
                    a.flags = a.flags & -1025 | 2;
                    lh = !1;
                    jh = a;
                    return;
                }
                mh(jh, c);
            }
            jh = a;
            kh = rf(b.firstChild);
        } else a.flags = a.flags & -1025 | 2, lh = !1, jh = a;
    }
}
function qh(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    jh = a;
}
function rh(a) {
    if (a !== jh) return !1;
    if (!lh) return qh(a), lh = !0, !1;
    var b = a.type;
    if (5 !== a.tag || "head" !== b && "body" !== b && !nf(b, a.memoizedProps)) for(b = kh; b;)mh(a, b), b = rf(b.nextSibling);
    qh(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error(y(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            kh = rf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            kh = null;
        }
    } else kh = jh ? rf(a.stateNode.nextSibling) : null;
    return !0;
}
function sh() {
    kh = jh = null;
    lh = !1;
}
var th = [];
function uh() {
    for(var a = 0; a < th.length; a++)th[a]._workInProgressVersionPrimary = null;
    th.length = 0;
}
var vh = ra.ReactCurrentDispatcher, wh = ra.ReactCurrentBatchConfig, xh = 0, R = null, S = null, T = null, yh = !1, zh = !1;
function Ah() {
    throw Error(y(321));
}
function Bh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!He(a[c], b[c])) return !1;
    return !0;
}
function Ch(a, b, c, d, e, f) {
    xh = f;
    R = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    vh.current = null === a || null === a.memoizedState ? Dh : Eh;
    a = c(d, e);
    if (zh) {
        f = 0;
        do {
            zh = !1;
            if (!(25 > f)) throw Error(y(301));
            f += 1;
            T = S = null;
            b.updateQueue = null;
            vh.current = Fh;
            a = c(d, e);
        }while (zh);
    }
    vh.current = Gh;
    b = null !== S && null !== S.next;
    xh = 0;
    T = S = R = null;
    yh = !1;
    if (b) throw Error(y(300));
    return a;
}
function Hh() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === T ? R.memoizedState = T = a : T = T.next = a;
    return T;
}
function Ih() {
    if (null === S) {
        var a = R.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = S.next;
    var b = null === T ? R.memoizedState : T.next;
    if (null !== b) T = b, S = a;
    else {
        if (null === a) throw Error(y(310));
        S = a;
        a = {
            memoizedState: S.memoizedState,
            baseState: S.baseState,
            baseQueue: S.baseQueue,
            queue: S.queue,
            next: null
        };
        null === T ? R.memoizedState = T = a : T = T.next = a;
    }
    return T;
}
function Jh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function Kh(a) {
    var b = Ih(), c = b.queue;
    if (null === c) throw Error(y(311));
    c.lastRenderedReducer = a;
    var d = S, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        e = e.next;
        d = d.baseState;
        var h = g = f = null, k = e;
        do {
            var l = k.lane;
            if ((xh & l) === l) null !== h && (h = h.next = {
                lane: 0,
                action: k.action,
                eagerReducer: k.eagerReducer,
                eagerState: k.eagerState,
                next: null
            }), d = k.eagerReducer === a ? k.eagerState : a(d, k.action);
            else {
                var n = {
                    lane: l,
                    action: k.action,
                    eagerReducer: k.eagerReducer,
                    eagerState: k.eagerState,
                    next: null
                };
                null === h ? (g = h = n, f = d) : h = h.next = n;
                R.lanes |= l;
                Dg |= l;
            }
            k = k.next;
        }while (null !== k && k !== e);
        null === h ? f = d : h.next = g;
        He(d, b.memoizedState) || (ug = !0);
        b.memoizedState = d;
        b.baseState = f;
        b.baseQueue = h;
        c.lastRenderedState = d;
    }
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function Lh(a) {
    var b = Ih(), c = b.queue;
    if (null === c) throw Error(y(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        He(f, b.memoizedState) || (ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function Mh(a, b, c) {
    var d = b._getVersion;
    d = d(b._source);
    var e = b._workInProgressVersionPrimary;
    if (null !== e) a = e === d;
    else if (a = a.mutableReadLanes, a = (xh & a) === a) b._workInProgressVersionPrimary = d, th.push(b);
    if (a) return c(b._source);
    th.push(b);
    throw Error(y(350));
}
function Nh(a, b, c, d) {
    var e = U;
    if (null === e) throw Error(y(349));
    var f = b._getVersion, g = f(b._source), h = vh.current, k = h.useState(function() {
        return Mh(e, b, c);
    }), l = k[1], n = k[0];
    k = T;
    var A = a.memoizedState, p = A.refs, C = p.getSnapshot, x = A.source;
    A = A.subscribe;
    var w = R;
    a.memoizedState = {
        refs: p,
        source: b,
        subscribe: d
    };
    h.useEffect(function() {
        p.getSnapshot = c;
        p.setSnapshot = l;
        var a = f(b._source);
        if (!He(g, a)) {
            a = c(b._source);
            He(n, a) || (l(a), a = Ig(w), e.mutableReadLanes |= a & e.pendingLanes);
            a = e.mutableReadLanes;
            e.entangledLanes |= a;
            for(var d = e.entanglements, h = a; 0 < h;){
                var k = 31 - Vc(h), v = 1 << k;
                d[k] |= a;
                h &= ~v;
            }
        }
    }, [
        c,
        b,
        d
    ]);
    h.useEffect(function() {
        return d(b._source, function() {
            var a = p.getSnapshot, c = p.setSnapshot;
            try {
                c(a(b._source));
                var d = Ig(w);
                e.mutableReadLanes |= d & e.pendingLanes;
            } catch (q) {
                c(function() {
                    throw q;
                });
            }
        });
    }, [
        b,
        d
    ]);
    He(C, c) && He(x, b) && He(A, d) || (a = {
        pending: null,
        dispatch: null,
        lastRenderedReducer: Jh,
        lastRenderedState: n
    }, a.dispatch = l = Oh.bind(null, R, a), k.queue = a, k.baseQueue = null, n = Mh(e, b, c), k.memoizedState = k.baseState = n);
    return n;
}
function Ph(a, b, c) {
    var d = Ih();
    return Nh(d, a, b, c);
}
function Qh(a) {
    var b = Hh();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = b.queue = {
        pending: null,
        dispatch: null,
        lastRenderedReducer: Jh,
        lastRenderedState: a
    };
    a = a.dispatch = Oh.bind(null, R, a);
    return [
        b.memoizedState,
        a
    ];
}
function Rh(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = R.updateQueue;
    null === b ? (b = {
        lastEffect: null
    }, R.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function Sh(a) {
    var b = Hh();
    a = {
        current: a
    };
    return b.memoizedState = a;
}
function Th() {
    return Ih().memoizedState;
}
function Uh(a, b, c, d) {
    var e = Hh();
    R.flags |= a;
    e.memoizedState = Rh(1 | b, c, void 0, void 0 === d ? null : d);
}
function Vh(a, b, c, d) {
    var e = Ih();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== S) {
        var g = S.memoizedState;
        f = g.destroy;
        if (null !== d && Bh(d, g.deps)) {
            Rh(b, c, f, d);
            return;
        }
    }
    R.flags |= a;
    e.memoizedState = Rh(1 | b, c, f, d);
}
function Wh(a, b) {
    return Uh(516, 4, a, b);
}
function Xh(a, b) {
    return Vh(516, 4, a, b);
}
function Yh(a, b) {
    return Vh(4, 2, a, b);
}
function Zh(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $h(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return Vh(4, 2, Zh.bind(null, b, a), c);
}
function ai() {}
function bi(a, b) {
    var c = Ih();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Bh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function ci(a, b) {
    var c = Ih();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Bh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function di(a, b) {
    var c = eg();
    gg(98 > c ? 98 : c, function() {
        a(!0);
    });
    gg(97 < c ? 97 : c, function() {
        var c = wh.transition;
        wh.transition = 1;
        try {
            a(!1), b();
        } finally{
            wh.transition = c;
        }
    });
}
function Oh(a, b, c) {
    var d = Hg(), e = Ig(a), f = {
        lane: e,
        action: c,
        eagerReducer: null,
        eagerState: null,
        next: null
    }, g = b.pending;
    null === g ? f.next = f : (f.next = g.next, g.next = f);
    b.pending = f;
    g = a.alternate;
    if (a === R || null !== g && g === R) zh = yh = !0;
    else {
        if (0 === a.lanes && (null === g || 0 === g.lanes) && (g = b.lastRenderedReducer, null !== g)) try {
            var h = b.lastRenderedState, k = g(h, c);
            f.eagerReducer = g;
            f.eagerState = k;
            if (He(k, h)) return;
        } catch (l) {} finally{}
        Jg(a, e, d);
    }
}
var Gh = {
    readContext: vg,
    useCallback: Ah,
    useContext: Ah,
    useEffect: Ah,
    useImperativeHandle: Ah,
    useLayoutEffect: Ah,
    useMemo: Ah,
    useReducer: Ah,
    useRef: Ah,
    useState: Ah,
    useDebugValue: Ah,
    useDeferredValue: Ah,
    useTransition: Ah,
    useMutableSource: Ah,
    useOpaqueIdentifier: Ah,
    unstable_isNewReconciler: !1
}, Dh = {
    readContext: vg,
    useCallback: function(a, b) {
        Hh().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: vg,
    useEffect: Wh,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return Uh(4, 2, Zh.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return Uh(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = Hh();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = Hh();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = d.queue = {
            pending: null,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        a = a.dispatch = Oh.bind(null, R, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: Sh,
    useState: Qh,
    useDebugValue: ai,
    useDeferredValue: function(a) {
        var b = Qh(a), c = b[0], d = b[1];
        Wh(function() {
            var b = wh.transition;
            wh.transition = 1;
            try {
                d(a);
            } finally{
                wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = Qh(!1), b = a[0];
        a = di.bind(null, a[1]);
        Sh(a);
        return [
            a,
            b
        ];
    },
    useMutableSource: function(a, b, c) {
        var d = Hh();
        d.memoizedState = {
            refs: {
                getSnapshot: b,
                setSnapshot: null
            },
            source: a,
            subscribe: c
        };
        return Nh(d, a, b, c);
    },
    useOpaqueIdentifier: function() {
        if (lh) {
            var a = !1, b = uf(function() {
                a || (a = !0, c("r:" + (tf++).toString(36)));
                throw Error(y(355));
            }), c = Qh(b)[1];
            0 === (R.mode & 2) && (R.flags |= 516, Rh(5, function() {
                c("r:" + (tf++).toString(36));
            }, void 0, null));
            return b;
        }
        b = "r:" + (tf++).toString(36);
        Qh(b);
        return b;
    },
    unstable_isNewReconciler: !1
}, Eh = {
    readContext: vg,
    useCallback: bi,
    useContext: vg,
    useEffect: Xh,
    useImperativeHandle: $h,
    useLayoutEffect: Yh,
    useMemo: ci,
    useReducer: Kh,
    useRef: Th,
    useState: function() {
        return Kh(Jh);
    },
    useDebugValue: ai,
    useDeferredValue: function(a) {
        var b = Kh(Jh), c = b[0], d = b[1];
        Xh(function() {
            var b = wh.transition;
            wh.transition = 1;
            try {
                d(a);
            } finally{
                wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = Kh(Jh)[0];
        return [
            Th().current,
            a
        ];
    },
    useMutableSource: Ph,
    useOpaqueIdentifier: function() {
        return Kh(Jh)[0];
    },
    unstable_isNewReconciler: !1
}, Fh = {
    readContext: vg,
    useCallback: bi,
    useContext: vg,
    useEffect: Xh,
    useImperativeHandle: $h,
    useLayoutEffect: Yh,
    useMemo: ci,
    useReducer: Lh,
    useRef: Th,
    useState: function() {
        return Lh(Jh);
    },
    useDebugValue: ai,
    useDeferredValue: function(a) {
        var b = Lh(Jh), c = b[0], d = b[1];
        Xh(function() {
            var b = wh.transition;
            wh.transition = 1;
            try {
                d(a);
            } finally{
                wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = Lh(Jh)[0];
        return [
            Th().current,
            a
        ];
    },
    useMutableSource: Ph,
    useOpaqueIdentifier: function() {
        return Lh(Jh)[0];
    },
    unstable_isNewReconciler: !1
}, ei = ra.ReactCurrentOwner, ug = !1;
function fi(a, b, c, d) {
    b.child = null === a ? Zg(b, null, c, d) : Yg(b, a.child, c, d);
}
function gi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    tg(b, e);
    d = Ch(a, b, c, d, f, e);
    if (null !== a && !ug) return b.updateQueue = a.updateQueue, b.flags &= -517, a.lanes &= ~e, hi(a, b, e);
    b.flags |= 1;
    fi(a, b, d, e);
    return b.child;
}
function ii(a, b, c, d, e, f) {
    if (null === a) {
        var g = c.type;
        if ("function" === typeof g && !ji(g) && void 0 === g.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = g, ki(a, b, g, d, e, f);
        a = Vg(c.type, null, d, b, b.mode, f);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    g = a.child;
    if (0 === (e & f) && (e = g.memoizedProps, c = c.compare, c = null !== c ? c : Je, c(e, d) && a.ref === b.ref)) return hi(a, b, f);
    b.flags |= 1;
    a = Tg(g, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function ki(a, b, c, d, e, f) {
    if (null !== a && Je(a.memoizedProps, d) && a.ref === b.ref) {
        if (ug = !1, 0 !== (f & e)) 0 !== (a.flags & 16384) && (ug = !0);
        else return b.lanes = a.lanes, hi(a, b, f);
    }
    return li(a, b, c, d, f);
}
function mi(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode || "unstable-defer-without-hiding" === d.mode) {
        if (0 === (b.mode & 4)) b.memoizedState = {
            baseLanes: 0
        }, ni(b, c);
        else if (0 !== (c & 1073741824)) b.memoizedState = {
            baseLanes: 0
        }, ni(b, null !== f ? f.baseLanes : c);
        else return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
            baseLanes: a
        }, ni(b, a), null;
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, ni(b, d);
    fi(a, b, e, c);
    return b.child;
}
function oi(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 128;
}
function li(a, b, c, d, e) {
    var f = Ff(c) ? Df : M.current;
    f = Ef(b, f);
    tg(b, e);
    c = Ch(a, b, c, d, f, e);
    if (null !== a && !ug) return b.updateQueue = a.updateQueue, b.flags &= -517, a.lanes &= ~e, hi(a, b, e);
    b.flags |= 1;
    fi(a, b, c, e);
    return b.child;
}
function pi(a, b, c, d, e) {
    if (Ff(c)) {
        var f = !0;
        Jf(b);
    } else f = !1;
    tg(b, e);
    if (null === b.stateNode) null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2), Mg(b, c, d), Og(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = vg(l) : (l = Ff(c) ? Df : M.current, l = Ef(b, l));
        var n = c.getDerivedStateFromProps, A = "function" === typeof n || "function" === typeof g.getSnapshotBeforeUpdate;
        A || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && Ng(b, g, d, l);
        wg = !1;
        var p = b.memoizedState;
        g.state = p;
        Cg(b, d, g, e);
        k = b.memoizedState;
        h !== d || p !== k || N.current || wg ? ("function" === typeof n && (Gg(b, c, n, d), k = b.memoizedState), (h = wg || Lg(b, c, h, d, p, k, l)) ? (A || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4)) : ("function" === typeof g.componentDidMount && (b.flags |= 4), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4), d = !1);
    } else {
        g = b.stateNode;
        yg(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : lg(b.type, h);
        g.props = l;
        A = b.pendingProps;
        p = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = vg(k) : (k = Ff(c) ? Df : M.current, k = Ef(b, k));
        var C = c.getDerivedStateFromProps;
        (n = "function" === typeof C || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== A || p !== k) && Ng(b, g, d, k);
        wg = !1;
        p = b.memoizedState;
        g.state = p;
        Cg(b, d, g, e);
        var x = b.memoizedState;
        h !== A || p !== x || N.current || wg ? ("function" === typeof C && (Gg(b, c, C, d), x = b.memoizedState), (l = wg || Lg(b, c, l, d, p, x, k)) ? (n || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, x, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, x, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 256)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 256), b.memoizedProps = d, b.memoizedState = x), g.props = d, g.state = x, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 256), d = !1);
    }
    return qi(a, b, c, d, f, e);
}
function qi(a, b, c, d, e, f) {
    oi(a, b);
    var g = 0 !== (b.flags & 64);
    if (!d && !g) return e && Kf(b, c, !1), hi(a, b, f);
    d = b.stateNode;
    ei.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = Yg(b, a.child, null, f), b.child = Yg(b, null, h, f)) : fi(a, b, h, f);
    b.memoizedState = d.state;
    e && Kf(b, c, !0);
    return b.child;
}
function ri(a) {
    var b = a.stateNode;
    b.pendingContext ? Hf(a, b.pendingContext, b.pendingContext !== b.context) : b.context && Hf(a, b.context, !1);
    eh(a, b.containerInfo);
}
var si = {
    dehydrated: null,
    retryLane: 0
};
function ti(a, b, c) {
    var d = b.pendingProps, e = P.current, f = !1, g;
    (g = 0 !== (b.flags & 64)) || (g = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    g ? (f = !0, b.flags &= -65) : null !== a && null === a.memoizedState || void 0 === d.fallback || !0 === d.unstable_avoidThisFallback || (e |= 1);
    I(P, e & 1);
    if (null === a) {
        void 0 !== d.fallback && ph(b);
        a = d.children;
        e = d.fallback;
        if (f) return a = ui(b, a, e, c), b.child.memoizedState = {
            baseLanes: c
        }, b.memoizedState = si, a;
        if ("number" === typeof d.unstable_expectedLoadTime) return a = ui(b, a, e, c), b.child.memoizedState = {
            baseLanes: c
        }, b.memoizedState = si, b.lanes = 33554432, a;
        c = vi({
            mode: "visible",
            children: a
        }, b.mode, c, null);
        c.return = b;
        return b.child = c;
    }
    if (null !== a.memoizedState) {
        if (f) return d = wi(a, b, d.children, d.fallback, c), f = b.child, e = a.child.memoizedState, f.memoizedState = null === e ? {
            baseLanes: c
        } : {
            baseLanes: e.baseLanes | c
        }, f.childLanes = a.childLanes & ~c, b.memoizedState = si, d;
        c = xi(a, b, d.children, c);
        b.memoizedState = null;
        return c;
    }
    if (f) return d = wi(a, b, d.children, d.fallback, c), f = b.child, e = a.child.memoizedState, f.memoizedState = null === e ? {
        baseLanes: c
    } : {
        baseLanes: e.baseLanes | c
    }, f.childLanes = a.childLanes & ~c, b.memoizedState = si, d;
    c = xi(a, b, d.children, c);
    b.memoizedState = null;
    return c;
}
function ui(a, b, c, d) {
    var e = a.mode, f = a.child;
    b = {
        mode: "hidden",
        children: b
    };
    0 === (e & 2) && null !== f ? (f.childLanes = 0, f.pendingProps = b) : f = vi(b, e, 0, null);
    c = Xg(c, e, d, null);
    f.return = a;
    c.return = a;
    f.sibling = c;
    a.child = f;
    return c;
}
function xi(a, b, c, d) {
    var e = a.child;
    a = e.sibling;
    c = Tg(e, {
        mode: "visible",
        children: c
    });
    0 === (b.mode & 2) && (c.lanes = d);
    c.return = b;
    c.sibling = null;
    null !== a && (a.nextEffect = null, a.flags = 8, b.firstEffect = b.lastEffect = a);
    return b.child = c;
}
function wi(a, b, c, d, e) {
    var f = b.mode, g = a.child;
    a = g.sibling;
    var h = {
        mode: "hidden",
        children: c
    };
    0 === (f & 2) && b.child !== g ? (c = b.child, c.childLanes = 0, c.pendingProps = h, g = c.lastEffect, null !== g ? (b.firstEffect = c.firstEffect, b.lastEffect = g, g.nextEffect = null) : b.firstEffect = b.lastEffect = null) : c = Tg(g, h);
    null !== a ? d = Tg(a, d) : (d = Xg(d, f, e, null), d.flags |= 2);
    d.return = b;
    c.return = b;
    c.sibling = d;
    b.child = c;
    return d;
}
function yi(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    sg(a.return, b);
}
function zi(a, b, c, d, e, f) {
    var g = a.memoizedState;
    null === g ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e,
        lastEffect: f
    } : (g.isBackwards = b, g.rendering = null, g.renderingStartTime = 0, g.last = d, g.tail = c, g.tailMode = e, g.lastEffect = f);
}
function Ai(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    fi(a, b, d.children, c);
    d = P.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 64;
    else {
        if (null !== a && 0 !== (a.flags & 64)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && yi(a, c);
            else if (19 === a.tag) yi(a, c);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    I(P, d);
    if (0 === (b.mode & 2)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === ih(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            zi(b, !1, e, c, f, b.lastEffect);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === ih(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            zi(b, !0, c, null, f, b.lastEffect);
            break;
        case "together":
            zi(b, !1, null, null, void 0, b.lastEffect);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function hi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    Dg |= b.lanes;
    if (0 !== (c & b.childLanes)) {
        if (null !== a && b.child !== a.child) throw Error(y(153));
        if (null !== b.child) {
            a = b.child;
            c = Tg(a, a.pendingProps);
            b.child = c;
            for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = Tg(a, a.pendingProps), c.return = b;
            c.sibling = null;
        }
        return b.child;
    }
    return null;
}
var Bi, Ci, Di, Ei;
Bi = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
Ci = function() {};
Di = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        dh(ah.current);
        var f = null;
        switch(c){
            case "input":
                e = Ya(a, e);
                d = Ya(a, d);
                f = [];
                break;
            case "option":
                e = eb(a, e);
                d = eb(a, d);
                f = [];
                break;
            case "select":
                e = $8dmsj({}, e, {
                    value: void 0
                });
                d = $8dmsj({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = gb(a, e);
                d = gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = jf);
        }
        vb(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && (ca.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && (ca.hasOwnProperty(l) ? (null != k && "onScroll" === l && G("scroll", a), f || h === k || (f = [])) : "object" === typeof k && null !== k && k.$$typeof === Ga ? k.toString() : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
Ei = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function Fi(a, b) {
    if (!lh) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function Gi(a, b, c) {
    var d = b.pendingProps;
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return null;
        case 1:
            return Ff(b.type) && Gf(), null;
        case 3:
            fh();
            H(N);
            H(M);
            uh();
            d = b.stateNode;
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) rh(b) ? b.flags |= 4 : d.hydrate || (b.flags |= 256);
            Ci(b);
            return null;
        case 5:
            hh(b);
            var e = dh(ch.current);
            c = b.type;
            if (null !== a && null != b.stateNode) Di(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 128);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error(y(166));
                    return null;
                }
                a = dh(ah.current);
                if (rh(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[wf] = b;
                    d[xf] = f;
                    switch(c){
                        case "dialog":
                            G("cancel", d);
                            G("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            G("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(a = 0; a < Xe.length; a++)G(Xe[a], d);
                            break;
                        case "source":
                            G("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            G("error", d);
                            G("load", d);
                            break;
                        case "details":
                            G("toggle", d);
                            break;
                        case "input":
                            Za(d, f);
                            G("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            G("invalid", d);
                            break;
                        case "textarea":
                            hb(d, f), G("invalid", d);
                    }
                    vb(c, f);
                    a = null;
                    for(var g in f)f.hasOwnProperty(g) && (e = f[g], "children" === g ? "string" === typeof e ? d.textContent !== e && (a = [
                        "children",
                        e
                    ]) : "number" === typeof e && d.textContent !== "" + e && (a = [
                        "children",
                        "" + e
                    ]) : ca.hasOwnProperty(g) && null != e && "onScroll" === g && G("scroll", d));
                    switch(c){
                        case "input":
                            Va(d);
                            cb(d, f, !0);
                            break;
                        case "textarea":
                            Va(d);
                            jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = jf);
                    }
                    d = a;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    a === kb.html && (a = lb(c));
                    a === kb.html ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[wf] = b;
                    a[xf] = d;
                    Bi(a, b, !1, !1);
                    b.stateNode = a;
                    g = wb(c, d);
                    switch(c){
                        case "dialog":
                            G("cancel", a);
                            G("close", a);
                            e = d;
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            G("load", a);
                            e = d;
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < Xe.length; e++)G(Xe[e], a);
                            e = d;
                            break;
                        case "source":
                            G("error", a);
                            e = d;
                            break;
                        case "img":
                        case "image":
                        case "link":
                            G("error", a);
                            G("load", a);
                            e = d;
                            break;
                        case "details":
                            G("toggle", a);
                            e = d;
                            break;
                        case "input":
                            Za(a, d);
                            e = Ya(a, d);
                            G("invalid", a);
                            break;
                        case "option":
                            e = eb(a, d);
                            break;
                        case "select":
                            a._wrapperState = {
                                wasMultiple: !!d.multiple
                            };
                            e = $8dmsj({}, d, {
                                value: void 0
                            });
                            G("invalid", a);
                            break;
                        case "textarea":
                            hb(a, d);
                            e = gb(a, d);
                            G("invalid", a);
                            break;
                        default:
                            e = d;
                    }
                    vb(c, e);
                    var h = e;
                    for(f in h)if (h.hasOwnProperty(f)) {
                        var k = h[f];
                        "style" === f ? tb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && ob(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && pb(a, k) : "number" === typeof k && pb(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && (ca.hasOwnProperty(f) ? null != k && "onScroll" === f && G("scroll", a) : null != k && qa(a, f, k, g));
                    }
                    switch(c){
                        case "input":
                            Va(a);
                            cb(a, d, !1);
                            break;
                        case "textarea":
                            Va(a);
                            jb(a);
                            break;
                        case "option":
                            null != d.value && a.setAttribute("value", "" + Sa(d.value));
                            break;
                        case "select":
                            a.multiple = !!d.multiple;
                            f = d.value;
                            null != f ? fb(a, !!d.multiple, f, !1) : null != d.defaultValue && fb(a, !!d.multiple, d.defaultValue, !0);
                            break;
                        default:
                            "function" === typeof e.onClick && (a.onclick = jf);
                    }
                    mf(c, d) && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 128);
            }
            return null;
        case 6:
            if (a && null != b.stateNode) Ei(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error(y(166));
                c = dh(ch.current);
                dh(ah.current);
                rh(b) ? (d = b.stateNode, c = b.memoizedProps, d[wf] = b, d.nodeValue !== c && (b.flags |= 4)) : (d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[wf] = b, b.stateNode = d);
            }
            return null;
        case 13:
            H(P);
            d = b.memoizedState;
            if (0 !== (b.flags & 64)) return b.lanes = c, b;
            d = null !== d;
            c = !1;
            null === a ? void 0 !== b.memoizedProps.fallback && rh(b) : c = null !== a.memoizedState;
            if (d && !c && 0 !== (b.mode & 2)) {
                if (null === a && !0 !== b.memoizedProps.unstable_avoidThisFallback || 0 !== (P.current & 1)) 0 === V && (V = 3);
                else {
                    if (0 === V || 3 === V) V = 4;
                    null === U || 0 === (Dg & 134217727) && 0 === (Hi & 134217727) || Ii(U, W);
                }
            }
            if (d || c) b.flags |= 4;
            return null;
        case 4:
            return fh(), Ci(b), null === a && cf(b.stateNode.containerInfo), null;
        case 10:
            return rg(b), null;
        case 17:
            return Ff(b.type) && Gf(), null;
        case 19:
            H(P);
            d = b.memoizedState;
            if (null === d) return null;
            f = 0 !== (b.flags & 64);
            g = d.rendering;
            if (null === g) {
                if (f) Fi(d, !1);
                else {
                    if (0 !== V || null !== a && 0 !== (a.flags & 64)) for(a = b.child; null !== a;){
                        g = ih(a);
                        if (null !== g) {
                            b.flags |= 64;
                            Fi(d, !1);
                            f = g.updateQueue;
                            null !== f && (b.updateQueue = f, b.flags |= 4);
                            null === d.lastEffect && (b.firstEffect = null);
                            b.lastEffect = d.lastEffect;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 2, f.nextEffect = null, f.firstEffect = null, f.lastEffect = null, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            I(P, P.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== d.tail && O() > Ji && (b.flags |= 64, f = !0, Fi(d, !1), b.lanes = 33554432);
                }
            } else {
                if (!f) {
                    if (a = ih(g), null !== a) {
                        if (b.flags |= 64, f = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), Fi(d, !0), null === d.tail && "hidden" === d.tailMode && !g.alternate && !lh) return b = b.lastEffect = d.lastEffect, null !== b && (b.nextEffect = null), null;
                    } else 2 * O() - d.renderingStartTime > Ji && 1073741824 !== c && (b.flags |= 64, f = !0, Fi(d, !1), b.lanes = 33554432);
                }
                d.isBackwards ? (g.sibling = b.child, b.child = g) : (c = d.last, null !== c ? c.sibling = g : b.child = g, d.last = g);
            }
            return null !== d.tail ? (c = d.tail, d.rendering = c, d.tail = c.sibling, d.lastEffect = b.lastEffect, d.renderingStartTime = O(), c.sibling = null, b = P.current, I(P, f ? b & 1 | 2 : b & 1), c) : null;
        case 23:
        case 24:
            return Ki(), null !== a && null !== a.memoizedState !== (null !== b.memoizedState) && "unstable-defer-without-hiding" !== d.mode && (b.flags |= 4), null;
    }
    throw Error(y(156, b.tag));
}
function Li(a) {
    switch(a.tag){
        case 1:
            Ff(a.type) && Gf();
            var b = a.flags;
            return b & 4096 ? (a.flags = b & -4097 | 64, a) : null;
        case 3:
            fh();
            H(N);
            H(M);
            uh();
            b = a.flags;
            if (0 !== (b & 64)) throw Error(y(285));
            a.flags = b & -4097 | 64;
            return a;
        case 5:
            return hh(a), null;
        case 13:
            return H(P), b = a.flags, b & 4096 ? (a.flags = b & -4097 | 64, a) : null;
        case 19:
            return H(P), null;
        case 4:
            return fh(), null;
        case 10:
            return rg(a), null;
        case 23:
        case 24:
            return Ki(), null;
        default:
            return null;
    }
}
function Mi(a, b) {
    try {
        var c = "", d = b;
        do c += Qa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e
    };
}
function Ni(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var Oi = "function" === typeof WeakMap ? WeakMap : Map;
function Pi(a, b, c) {
    c = zg(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        Qi || (Qi = !0, Ri = d);
        Ni(a, b);
    };
    return c;
}
function Si(a, b, c) {
    c = zg(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            Ni(a, b);
            return d(e);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        "function" !== typeof d && (null === Ti ? Ti = new Set([
            this
        ]) : Ti.add(this), Ni(a, b));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
var Ui = "function" === typeof WeakSet ? WeakSet : Set;
function Vi(a) {
    var b = a.ref;
    if (null !== b) {
        if ("function" === typeof b) try {
            b(null);
        } catch (c) {
            Wi(a, c);
        }
        else b.current = null;
    }
}
function Xi(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            return;
        case 1:
            if (b.flags & 256 && null !== a) {
                var c = a.memoizedProps, d = a.memoizedState;
                a = b.stateNode;
                b = a.getSnapshotBeforeUpdate(b.elementType === b.type ? c : lg(b.type, c), d);
                a.__reactInternalSnapshotBeforeUpdate = b;
            }
            return;
        case 3:
            b.flags & 256 && qf(b.stateNode.containerInfo);
            return;
        case 5:
        case 6:
        case 4:
        case 17:
            return;
    }
    throw Error(y(163));
}
function Yi(a, b, c) {
    switch(c.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            b = c.updateQueue;
            b = null !== b ? b.lastEffect : null;
            if (null !== b) {
                a = b = b.next;
                do {
                    if (3 === (a.tag & 3)) {
                        var d = a.create;
                        a.destroy = d();
                    }
                    a = a.next;
                }while (a !== b);
            }
            b = c.updateQueue;
            b = null !== b ? b.lastEffect : null;
            if (null !== b) {
                a = b = b.next;
                do {
                    var e = a;
                    d = e.next;
                    e = e.tag;
                    0 !== (e & 4) && 0 !== (e & 1) && (Zi(c, a), $i(c, a));
                    a = d;
                }while (a !== b);
            }
            return;
        case 1:
            a = c.stateNode;
            c.flags & 4 && (null === b ? a.componentDidMount() : (d = c.elementType === c.type ? b.memoizedProps : lg(c.type, b.memoizedProps), a.componentDidUpdate(d, b.memoizedState, a.__reactInternalSnapshotBeforeUpdate)));
            b = c.updateQueue;
            null !== b && Eg(c, b, a);
            return;
        case 3:
            b = c.updateQueue;
            if (null !== b) {
                a = null;
                if (null !== c.child) switch(c.child.tag){
                    case 5:
                        a = c.child.stateNode;
                        break;
                    case 1:
                        a = c.child.stateNode;
                }
                Eg(c, b, a);
            }
            return;
        case 5:
            a = c.stateNode;
            null === b && c.flags & 4 && mf(c.type, c.memoizedProps) && a.focus();
            return;
        case 6:
            return;
        case 4:
            return;
        case 12:
            return;
        case 13:
            null === c.memoizedState && (c = c.alternate, null !== c && (c = c.memoizedState, null !== c && (c = c.dehydrated, null !== c && Cc(c))));
            return;
        case 19:
        case 17:
        case 20:
        case 21:
        case 23:
        case 24:
            return;
    }
    throw Error(y(163));
}
function aj(a, b) {
    for(var c = a;;){
        if (5 === c.tag) {
            var d = c.stateNode;
            if (b) d = d.style, "function" === typeof d.setProperty ? d.setProperty("display", "none", "important") : d.display = "none";
            else {
                d = c.stateNode;
                var e = c.memoizedProps.style;
                e = void 0 !== e && null !== e && e.hasOwnProperty("display") ? e.display : null;
                d.style.display = sb("display", e);
            }
        } else if (6 === c.tag) c.stateNode.nodeValue = b ? "" : c.memoizedProps;
        else if ((23 !== c.tag && 24 !== c.tag || null === c.memoizedState || c === a) && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === a) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === a) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
}
function bj(a, b) {
    if (Mf && "function" === typeof Mf.onCommitFiberUnmount) try {
        Mf.onCommitFiberUnmount(Lf, b);
    } catch (f) {}
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            a = b.updateQueue;
            if (null !== a && (a = a.lastEffect, null !== a)) {
                var c = a = a.next;
                do {
                    var d = c, e = d.destroy;
                    d = d.tag;
                    if (void 0 !== e) {
                        if (0 !== (d & 4)) Zi(b, c);
                        else {
                            d = b;
                            try {
                                e();
                            } catch (f) {
                                Wi(d, f);
                            }
                        }
                    }
                    c = c.next;
                }while (c !== a);
            }
            break;
        case 1:
            Vi(b);
            a = b.stateNode;
            if ("function" === typeof a.componentWillUnmount) try {
                a.props = b.memoizedProps, a.state = b.memoizedState, a.componentWillUnmount();
            } catch (f) {
                Wi(b, f);
            }
            break;
        case 5:
            Vi(b);
            break;
        case 4:
            cj(a, b);
    }
}
function dj(a) {
    a.alternate = null;
    a.child = null;
    a.dependencies = null;
    a.firstEffect = null;
    a.lastEffect = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.return = null;
    a.updateQueue = null;
}
function ej(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function fj(a) {
    a: {
        for(var b = a.return; null !== b;){
            if (ej(b)) break a;
            b = b.return;
        }
        throw Error(y(160));
    }
    var c = b;
    b = c.stateNode;
    switch(c.tag){
        case 5:
            var d = !1;
            break;
        case 3:
            b = b.containerInfo;
            d = !0;
            break;
        case 4:
            b = b.containerInfo;
            d = !0;
            break;
        default:
            throw Error(y(161));
    }
    c.flags & 16 && (pb(b, ""), c.flags &= -17);
    a: b: for(c = a;;){
        for(; null === c.sibling;){
            if (null === c.return || ej(c.return)) {
                c = null;
                break a;
            }
            c = c.return;
        }
        c.sibling.return = c.return;
        for(c = c.sibling; 5 !== c.tag && 6 !== c.tag && 18 !== c.tag;){
            if (c.flags & 2) continue b;
            if (null === c.child || 4 === c.tag) continue b;
            else c.child.return = c, c = c.child;
        }
        if (!(c.flags & 2)) {
            c = c.stateNode;
            break a;
        }
    }
    d ? gj(a, c, b) : hj(a, c, b);
}
function gj(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = jf));
    else if (4 !== d && (a = a.child, null !== a)) for(gj(a, b, c), a = a.sibling; null !== a;)gj(a, b, c), a = a.sibling;
}
function hj(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for(hj(a, b, c), a = a.sibling; null !== a;)hj(a, b, c), a = a.sibling;
}
function cj(a, b) {
    for(var c = b, d = !1, e, f;;){
        if (!d) {
            d = c.return;
            a: for(;;){
                if (null === d) throw Error(y(160));
                e = d.stateNode;
                switch(d.tag){
                    case 5:
                        f = !1;
                        break a;
                    case 3:
                        e = e.containerInfo;
                        f = !0;
                        break a;
                    case 4:
                        e = e.containerInfo;
                        f = !0;
                        break a;
                }
                d = d.return;
            }
            d = !0;
        }
        if (5 === c.tag || 6 === c.tag) {
            a: for(var g = a, h = c, k = h;;)if (bj(g, k), null !== k.child && 4 !== k.tag) k.child.return = k, k = k.child;
            else {
                if (k === h) break a;
                for(; null === k.sibling;){
                    if (null === k.return || k.return === h) break a;
                    k = k.return;
                }
                k.sibling.return = k.return;
                k = k.sibling;
            }
            f ? (g = e, h = c.stateNode, 8 === g.nodeType ? g.parentNode.removeChild(h) : g.removeChild(h)) : e.removeChild(c.stateNode);
        } else if (4 === c.tag) {
            if (null !== c.child) {
                e = c.stateNode.containerInfo;
                f = !0;
                c.child.return = c;
                c = c.child;
                continue;
            }
        } else if (bj(a, c), null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
            4 === c.tag && (d = !1);
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
}
function ij(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            var c = b.updateQueue;
            c = null !== c ? c.lastEffect : null;
            if (null !== c) {
                var d = c = c.next;
                do 3 === (d.tag & 3) && (a = d.destroy, d.destroy = void 0, void 0 !== a && a()), d = d.next;
                while (d !== c);
            }
            return;
        case 1:
            return;
        case 5:
            c = b.stateNode;
            if (null != c) {
                d = b.memoizedProps;
                var e = null !== a ? a.memoizedProps : d;
                a = b.type;
                var f = b.updateQueue;
                b.updateQueue = null;
                if (null !== f) {
                    c[xf] = d;
                    "input" === a && "radio" === d.type && null != d.name && $a(c, d);
                    wb(a, e);
                    b = wb(a, d);
                    for(e = 0; e < f.length; e += 2){
                        var g = f[e], h = f[e + 1];
                        "style" === g ? tb(c, h) : "dangerouslySetInnerHTML" === g ? ob(c, h) : "children" === g ? pb(c, h) : qa(c, g, h, b);
                    }
                    switch(a){
                        case "input":
                            ab(c, d);
                            break;
                        case "textarea":
                            ib(c, d);
                            break;
                        case "select":
                            a = c._wrapperState.wasMultiple, c._wrapperState.wasMultiple = !!d.multiple, f = d.value, null != f ? fb(c, !!d.multiple, f, !1) : a !== !!d.multiple && (null != d.defaultValue ? fb(c, !!d.multiple, d.defaultValue, !0) : fb(c, !!d.multiple, d.multiple ? [] : "", !1));
                    }
                }
            }
            return;
        case 6:
            if (null === b.stateNode) throw Error(y(162));
            b.stateNode.nodeValue = b.memoizedProps;
            return;
        case 3:
            c = b.stateNode;
            c.hydrate && (c.hydrate = !1, Cc(c.containerInfo));
            return;
        case 12:
            return;
        case 13:
            null !== b.memoizedState && (jj = O(), aj(b.child, !0));
            kj(b);
            return;
        case 19:
            kj(b);
            return;
        case 17:
            return;
        case 23:
        case 24:
            aj(b, null !== b.memoizedState);
            return;
    }
    throw Error(y(163));
}
function kj(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new Ui);
        b.forEach(function(b) {
            var d = lj.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function mj(a, b) {
    return null !== a && (a = a.memoizedState, null === a || null !== a.dehydrated) ? (b = b.memoizedState, null !== b && null === b.dehydrated) : !1;
}
var nj = Math.ceil, oj = ra.ReactCurrentDispatcher, pj = ra.ReactCurrentOwner, X = 0, U = null, Y = null, W = 0, qj = 0, rj = Bf(0), V = 0, sj = null, tj = 0, Dg = 0, Hi = 0, uj = 0, vj = null, jj = 0, Ji = Infinity;
function wj() {
    Ji = O() + 500;
}
var Z = null, Qi = !1, Ri = null, Ti = null, xj = !1, yj = null, zj = 90, Aj = [], Bj = [], Cj = null, Dj = 0, Ej = null, Fj = -1, Gj = 0, Hj = 0, Ij = null, Jj = !1;
function Hg() {
    return 0 !== (X & 48) ? O() : -1 !== Fj ? Fj : Fj = O();
}
function Ig(a) {
    a = a.mode;
    if (0 === (a & 2)) return 1;
    if (0 === (a & 4)) return 99 === eg() ? 1 : 2;
    0 === Gj && (Gj = tj);
    if (0 !== kg.transition) {
        0 !== Hj && (Hj = null !== vj ? vj.pendingLanes : 0);
        a = Gj;
        var b = 4186112 & ~Hj;
        b &= -b;
        0 === b && (a = 4186112 & ~a, b = a & -a, 0 === b && (b = 8192));
        return b;
    }
    a = eg();
    0 !== (X & 4) && 98 === a ? a = Xc(12, Gj) : (a = Sc(a), a = Xc(a, Gj));
    return a;
}
function Jg(a, b, c) {
    if (50 < Dj) throw Dj = 0, Ej = null, Error(y(185));
    a = Kj(a, b);
    if (null === a) return null;
    $c(a, b, c);
    a === U && (Hi |= b, 4 === V && Ii(a, W));
    var d = eg();
    1 === b ? 0 !== (X & 8) && 0 === (X & 48) ? Lj(a) : (Mj(a, c), 0 === X && (wj(), ig())) : (0 === (X & 4) || 98 !== d && 99 !== d || (null === Cj ? Cj = new Set([
        a
    ]) : Cj.add(a)), Mj(a, c));
    vj = a;
}
function Kj(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
function Mj(a, b) {
    for(var c = a.callbackNode, d = a.suspendedLanes, e = a.pingedLanes, f = a.expirationTimes, g = a.pendingLanes; 0 < g;){
        var h = 31 - Vc(g), k = 1 << h, l = f[h];
        if (-1 === l) {
            if (0 === (k & d) || 0 !== (k & e)) {
                l = b;
                Rc(k);
                var n = F;
                f[h] = 10 <= n ? l + 250 : 6 <= n ? l + 5E3 : -1;
            }
        } else l <= b && (a.expiredLanes |= k);
        g &= ~k;
    }
    d = Uc(a, a === U ? W : 0);
    b = F;
    if (0 === d) null !== c && (c !== Zf && Pf(c), a.callbackNode = null, a.callbackPriority = 0);
    else {
        if (null !== c) {
            if (a.callbackPriority === b) return;
            c !== Zf && Pf(c);
        }
        15 === b ? (c = Lj.bind(null, a), null === ag ? (ag = [
            c
        ], bg = Of(Uf, jg)) : ag.push(c), c = Zf) : 14 === b ? c = hg(99, Lj.bind(null, a)) : (c = Tc(b), c = hg(c, Nj.bind(null, a)));
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function Nj(a) {
    Fj = -1;
    Hj = Gj = 0;
    if (0 !== (X & 48)) throw Error(y(327));
    var b = a.callbackNode;
    if (Oj() && a.callbackNode !== b) return null;
    var c = Uc(a, a === U ? W : 0);
    if (0 === c) return null;
    var d = c;
    var e = X;
    X |= 16;
    var f = Pj();
    if (U !== a || W !== d) wj(), Qj(a, d);
    for(;;)try {
        Rj();
        break;
    } catch (h) {
        Sj(a, h);
    }
    qg();
    oj.current = f;
    X = e;
    null !== Y ? d = 0 : (U = null, W = 0, d = V);
    if (0 !== (tj & Hi)) Qj(a, 0);
    else if (0 !== d) {
        2 === d && (X |= 64, a.hydrate && (a.hydrate = !1, qf(a.containerInfo)), c = Wc(a), 0 !== c && (d = Tj(a, c)));
        if (1 === d) throw b = sj, Qj(a, 0), Ii(a, c), Mj(a, O()), b;
        a.finishedWork = a.current.alternate;
        a.finishedLanes = c;
        switch(d){
            case 0:
            case 1:
                throw Error(y(345));
            case 2:
                Uj(a);
                break;
            case 3:
                Ii(a, c);
                if ((c & 62914560) === c && (d = jj + 500 - O(), 10 < d)) {
                    if (0 !== Uc(a, 0)) break;
                    e = a.suspendedLanes;
                    if ((e & c) !== c) {
                        Hg();
                        a.pingedLanes |= a.suspendedLanes & e;
                        break;
                    }
                    a.timeoutHandle = of(Uj.bind(null, a), d);
                    break;
                }
                Uj(a);
                break;
            case 4:
                Ii(a, c);
                if ((c & 4186112) === c) break;
                d = a.eventTimes;
                for(e = -1; 0 < c;){
                    var g = 31 - Vc(c);
                    f = 1 << g;
                    g = d[g];
                    g > e && (e = g);
                    c &= ~f;
                }
                c = e;
                c = O() - c;
                c = (120 > c ? 120 : 480 > c ? 480 : 1080 > c ? 1080 : 1920 > c ? 1920 : 3E3 > c ? 3E3 : 4320 > c ? 4320 : 1960 * nj(c / 1960)) - c;
                if (10 < c) {
                    a.timeoutHandle = of(Uj.bind(null, a), c);
                    break;
                }
                Uj(a);
                break;
            case 5:
                Uj(a);
                break;
            default:
                throw Error(y(329));
        }
    }
    Mj(a, O());
    return a.callbackNode === b ? Nj.bind(null, a) : null;
}
function Ii(a, b) {
    b &= ~uj;
    b &= ~Hi;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - Vc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function Lj(a) {
    if (0 !== (X & 48)) throw Error(y(327));
    Oj();
    if (a === U && 0 !== (a.expiredLanes & W)) {
        var b = W;
        var c = Tj(a, b);
        0 !== (tj & Hi) && (b = Uc(a, b), c = Tj(a, b));
    } else b = Uc(a, 0), c = Tj(a, b);
    0 !== a.tag && 2 === c && (X |= 64, a.hydrate && (a.hydrate = !1, qf(a.containerInfo)), b = Wc(a), 0 !== b && (c = Tj(a, b)));
    if (1 === c) throw c = sj, Qj(a, 0), Ii(a, b), Mj(a, O()), c;
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    Uj(a);
    Mj(a, O());
    return null;
}
function Vj() {
    if (null !== Cj) {
        var a = Cj;
        Cj = null;
        a.forEach(function(a) {
            a.expiredLanes |= 24 & a.pendingLanes;
            Mj(a, O());
        });
    }
    ig();
}
function Wj(a, b) {
    var c = X;
    X |= 1;
    try {
        return a(b);
    } finally{
        X = c, 0 === X && (wj(), ig());
    }
}
function Xj(a, b) {
    var c = X;
    X &= -2;
    X |= 8;
    try {
        return a(b);
    } finally{
        X = c, 0 === X && (wj(), ig());
    }
}
function ni(a, b) {
    I(rj, qj);
    qj |= b;
    tj |= b;
}
function Ki() {
    qj = rj.current;
    H(rj);
}
function Qj(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, pf(c));
    if (null !== Y) for(c = Y.return; null !== c;){
        var d = c;
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && Gf();
                break;
            case 3:
                fh();
                H(N);
                H(M);
                uh();
                break;
            case 5:
                hh(d);
                break;
            case 4:
                fh();
                break;
            case 13:
                H(P);
                break;
            case 19:
                H(P);
                break;
            case 10:
                rg(d);
                break;
            case 23:
            case 24:
                Ki();
        }
        c = c.return;
    }
    U = a;
    Y = Tg(a.current, null);
    W = qj = tj = b;
    V = 0;
    sj = null;
    uj = Hi = Dg = 0;
}
function Sj(a, b) {
    do {
        var c = Y;
        try {
            qg();
            vh.current = Gh;
            if (yh) {
                for(var d = R.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                yh = !1;
            }
            xh = 0;
            T = S = R = null;
            zh = !1;
            pj.current = null;
            if (null === c || null === c.return) {
                V = 1;
                sj = b;
                Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = W;
                h.flags |= 2048;
                h.firstEffect = h.lastEffect = null;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k;
                    if (0 === (h.mode & 2)) {
                        var n = h.alternate;
                        n ? (h.updateQueue = n.updateQueue, h.memoizedState = n.memoizedState, h.lanes = n.lanes) : (h.updateQueue = null, h.memoizedState = null);
                    }
                    var A = 0 !== (P.current & 1), p = g;
                    do {
                        var C;
                        if (C = 13 === p.tag) {
                            var x = p.memoizedState;
                            if (null !== x) C = null !== x.dehydrated ? !0 : !1;
                            else {
                                var w = p.memoizedProps;
                                C = void 0 === w.fallback ? !1 : !0 !== w.unstable_avoidThisFallback ? !0 : A ? !1 : !0;
                            }
                        }
                        if (C) {
                            var z = p.updateQueue;
                            if (null === z) {
                                var u = new Set;
                                u.add(l);
                                p.updateQueue = u;
                            } else z.add(l);
                            if (0 === (p.mode & 2)) {
                                p.flags |= 64;
                                h.flags |= 16384;
                                h.flags &= -2981;
                                if (1 === h.tag) {
                                    if (null === h.alternate) h.tag = 17;
                                    else {
                                        var t = zg(-1, 1);
                                        t.tag = 2;
                                        Ag(h, t);
                                    }
                                }
                                h.lanes |= 1;
                                break a;
                            }
                            k = void 0;
                            h = b;
                            var q = f.pingCache;
                            null === q ? (q = f.pingCache = new Oi, k = new Set, q.set(l, k)) : (k = q.get(l), void 0 === k && (k = new Set, q.set(l, k)));
                            if (!k.has(h)) {
                                k.add(h);
                                var v = Yj.bind(null, f, l, h);
                                l.then(v, v);
                            }
                            p.flags |= 4096;
                            p.lanes = b;
                            break a;
                        }
                        p = p.return;
                    }while (null !== p);
                    k = Error((Ra(h.type) || "A React component") + " suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display.");
                }
                5 !== V && (V = 2);
                k = Mi(k, h);
                p = g;
                do {
                    switch(p.tag){
                        case 3:
                            f = k;
                            p.flags |= 4096;
                            b &= -b;
                            p.lanes |= b;
                            var J = Pi(p, f, b);
                            Bg(p, J);
                            break a;
                        case 1:
                            f = k;
                            var K = p.type, Q = p.stateNode;
                            if (0 === (p.flags & 64) && ("function" === typeof K.getDerivedStateFromError || null !== Q && "function" === typeof Q.componentDidCatch && (null === Ti || !Ti.has(Q)))) {
                                p.flags |= 4096;
                                b &= -b;
                                p.lanes |= b;
                                var L = Si(p, f, b);
                                Bg(p, L);
                                break a;
                            }
                    }
                    p = p.return;
                }while (null !== p);
            }
            Zj(c);
        } catch (va) {
            b = va;
            Y === c && null !== c && (Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function Pj() {
    var a = oj.current;
    oj.current = Gh;
    return null === a ? Gh : a;
}
function Tj(a, b) {
    var c = X;
    X |= 16;
    var d = Pj();
    U === a && W === b || Qj(a, b);
    for(;;)try {
        ak();
        break;
    } catch (e) {
        Sj(a, e);
    }
    qg();
    X = c;
    oj.current = d;
    if (null !== Y) throw Error(y(261));
    U = null;
    W = 0;
    return V;
}
function ak() {
    for(; null !== Y;)bk(Y);
}
function Rj() {
    for(; null !== Y && !Qf();)bk(Y);
}
function bk(a) {
    var b = ck(a.alternate, a, qj);
    a.memoizedProps = a.pendingProps;
    null === b ? Zj(a) : Y = b;
    pj.current = null;
}
function Zj(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 2048)) {
            c = Gi(c, b, qj);
            if (null !== c) {
                Y = c;
                return;
            }
            c = b;
            if (24 !== c.tag && 23 !== c.tag || null === c.memoizedState || 0 !== (qj & 1073741824) || 0 === (c.mode & 4)) {
                for(var d = 0, e = c.child; null !== e;)d |= e.lanes | e.childLanes, e = e.sibling;
                c.childLanes = d;
            }
            null !== a && 0 === (a.flags & 2048) && (null === a.firstEffect && (a.firstEffect = b.firstEffect), null !== b.lastEffect && (null !== a.lastEffect && (a.lastEffect.nextEffect = b.firstEffect), a.lastEffect = b.lastEffect), 1 < b.flags && (null !== a.lastEffect ? a.lastEffect.nextEffect = b : a.firstEffect = b, a.lastEffect = b));
        } else {
            c = Li(b);
            if (null !== c) {
                c.flags &= 2047;
                Y = c;
                return;
            }
            null !== a && (a.firstEffect = a.lastEffect = null, a.flags |= 2048);
        }
        b = b.sibling;
        if (null !== b) {
            Y = b;
            return;
        }
        Y = b = a;
    }while (null !== b);
    0 === V && (V = 5);
}
function Uj(a) {
    var b = eg();
    gg(99, dk.bind(null, a, b));
    return null;
}
function dk(a, b) {
    do Oj();
    while (null !== yj);
    if (0 !== (X & 48)) throw Error(y(327));
    var c = a.finishedWork;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error(y(177));
    a.callbackNode = null;
    var d = c.lanes | c.childLanes, e = d, f = a.pendingLanes & ~e;
    a.pendingLanes = e;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= e;
    a.mutableReadLanes &= e;
    a.entangledLanes &= e;
    e = a.entanglements;
    for(var g = a.eventTimes, h = a.expirationTimes; 0 < f;){
        var k = 31 - Vc(f), l = 1 << k;
        e[k] = 0;
        g[k] = -1;
        h[k] = -1;
        f &= ~l;
    }
    null !== Cj && 0 === (d & 24) && Cj.has(a) && Cj.delete(a);
    a === U && (Y = U = null, W = 0);
    1 < c.flags ? null !== c.lastEffect ? (c.lastEffect.nextEffect = c, d = c.firstEffect) : d = c : d = c.firstEffect;
    if (null !== d) {
        e = X;
        X |= 32;
        pj.current = null;
        kf = fd;
        g = Ne();
        if (Oe(g)) {
            if ("selectionStart" in g) h = {
                start: g.selectionStart,
                end: g.selectionEnd
            };
            else a: if (h = (h = g.ownerDocument) && h.defaultView || window, (l = h.getSelection && h.getSelection()) && 0 !== l.rangeCount) {
                h = l.anchorNode;
                f = l.anchorOffset;
                k = l.focusNode;
                l = l.focusOffset;
                try {
                    h.nodeType, k.nodeType;
                } catch (va) {
                    h = null;
                    break a;
                }
                var n = 0, A = -1, p = -1, C = 0, x = 0, w = g, z = null;
                b: for(;;){
                    for(var u;;){
                        w !== h || 0 !== f && 3 !== w.nodeType || (A = n + f);
                        w !== k || 0 !== l && 3 !== w.nodeType || (p = n + l);
                        3 === w.nodeType && (n += w.nodeValue.length);
                        if (null === (u = w.firstChild)) break;
                        z = w;
                        w = u;
                    }
                    for(;;){
                        if (w === g) break b;
                        z === h && ++C === f && (A = n);
                        z === k && ++x === l && (p = n);
                        if (null !== (u = w.nextSibling)) break;
                        w = z;
                        z = w.parentNode;
                    }
                    w = u;
                }
                h = -1 === A || -1 === p ? null : {
                    start: A,
                    end: p
                };
            } else h = null;
            h = h || {
                start: 0,
                end: 0
            };
        } else h = null;
        lf = {
            focusedElem: g,
            selectionRange: h
        };
        fd = !1;
        Ij = null;
        Jj = !1;
        Z = d;
        do try {
            ek();
        } catch (va) {
            if (null === Z) throw Error(y(330));
            Wi(Z, va);
            Z = Z.nextEffect;
        }
        while (null !== Z);
        Ij = null;
        Z = d;
        do try {
            for(g = a; null !== Z;){
                var t = Z.flags;
                t & 16 && pb(Z.stateNode, "");
                if (t & 128) {
                    var q = Z.alternate;
                    if (null !== q) {
                        var v = q.ref;
                        null !== v && ("function" === typeof v ? v(null) : v.current = null);
                    }
                }
                switch(t & 1038){
                    case 2:
                        fj(Z);
                        Z.flags &= -3;
                        break;
                    case 6:
                        fj(Z);
                        Z.flags &= -3;
                        ij(Z.alternate, Z);
                        break;
                    case 1024:
                        Z.flags &= -1025;
                        break;
                    case 1028:
                        Z.flags &= -1025;
                        ij(Z.alternate, Z);
                        break;
                    case 4:
                        ij(Z.alternate, Z);
                        break;
                    case 8:
                        h = Z;
                        cj(g, h);
                        var J = h.alternate;
                        dj(h);
                        null !== J && dj(J);
                }
                Z = Z.nextEffect;
            }
        } catch (va) {
            if (null === Z) throw Error(y(330));
            Wi(Z, va);
            Z = Z.nextEffect;
        }
        while (null !== Z);
        v = lf;
        q = Ne();
        t = v.focusedElem;
        g = v.selectionRange;
        if (q !== t && t && t.ownerDocument && Me(t.ownerDocument.documentElement, t)) {
            null !== g && Oe(t) && (q = g.start, v = g.end, void 0 === v && (v = q), "selectionStart" in t ? (t.selectionStart = q, t.selectionEnd = Math.min(v, t.value.length)) : (v = (q = t.ownerDocument || document) && q.defaultView || window, v.getSelection && (v = v.getSelection(), h = t.textContent.length, J = Math.min(g.start, h), g = void 0 === g.end ? J : Math.min(g.end, h), !v.extend && J > g && (h = g, g = J, J = h), h = Le(t, J), f = Le(t, g), h && f && (1 !== v.rangeCount || v.anchorNode !== h.node || v.anchorOffset !== h.offset || v.focusNode !== f.node || v.focusOffset !== f.offset) && (q = q.createRange(), q.setStart(h.node, h.offset), v.removeAllRanges(), J > g ? (v.addRange(q), v.extend(f.node, f.offset)) : (q.setEnd(f.node, f.offset), v.addRange(q))))));
            q = [];
            for(v = t; v = v.parentNode;)1 === v.nodeType && q.push({
                element: v,
                left: v.scrollLeft,
                top: v.scrollTop
            });
            "function" === typeof t.focus && t.focus();
            for(t = 0; t < q.length; t++)v = q[t], v.element.scrollLeft = v.left, v.element.scrollTop = v.top;
        }
        fd = !!kf;
        lf = kf = null;
        a.current = c;
        Z = d;
        do try {
            for(t = a; null !== Z;){
                var K = Z.flags;
                K & 36 && Yi(t, Z.alternate, Z);
                if (K & 128) {
                    q = void 0;
                    var Q = Z.ref;
                    if (null !== Q) {
                        var L = Z.stateNode;
                        switch(Z.tag){
                            case 5:
                                q = L;
                                break;
                            default:
                                q = L;
                        }
                        "function" === typeof Q ? Q(q) : Q.current = q;
                    }
                }
                Z = Z.nextEffect;
            }
        } catch (va) {
            if (null === Z) throw Error(y(330));
            Wi(Z, va);
            Z = Z.nextEffect;
        }
        while (null !== Z);
        Z = null;
        $f();
        X = e;
    } else a.current = c;
    if (xj) xj = !1, yj = a, zj = b;
    else for(Z = d; null !== Z;)b = Z.nextEffect, Z.nextEffect = null, Z.flags & 8 && (K = Z, K.sibling = null, K.stateNode = null), Z = b;
    d = a.pendingLanes;
    0 === d && (Ti = null);
    1 === d ? a === Ej ? Dj++ : (Dj = 0, Ej = a) : Dj = 0;
    c = c.stateNode;
    if (Mf && "function" === typeof Mf.onCommitFiberRoot) try {
        Mf.onCommitFiberRoot(Lf, c, void 0, 64 === (c.current.flags & 64));
    } catch (va) {}
    Mj(a, O());
    if (Qi) throw Qi = !1, a = Ri, Ri = null, a;
    if (0 !== (X & 8)) return null;
    ig();
    return null;
}
function ek() {
    for(; null !== Z;){
        var a = Z.alternate;
        Jj || null === Ij || (0 !== (Z.flags & 8) ? dc(Z, Ij) && (Jj = !0) : 13 === Z.tag && mj(a, Z) && dc(Z, Ij) && (Jj = !0));
        var b = Z.flags;
        0 !== (b & 256) && Xi(a, Z);
        0 === (b & 512) || xj || (xj = !0, hg(97, function() {
            Oj();
            return null;
        }));
        Z = Z.nextEffect;
    }
}
function Oj() {
    if (90 !== zj) {
        var a = 97 < zj ? 97 : zj;
        zj = 90;
        return gg(a, fk);
    }
    return !1;
}
function $i(a, b) {
    Aj.push(b, a);
    xj || (xj = !0, hg(97, function() {
        Oj();
        return null;
    }));
}
function Zi(a, b) {
    Bj.push(b, a);
    xj || (xj = !0, hg(97, function() {
        Oj();
        return null;
    }));
}
function fk() {
    if (null === yj) return !1;
    var a = yj;
    yj = null;
    if (0 !== (X & 48)) throw Error(y(331));
    var b = X;
    X |= 32;
    var c = Bj;
    Bj = [];
    for(var d = 0; d < c.length; d += 2){
        var e = c[d], f = c[d + 1], g = e.destroy;
        e.destroy = void 0;
        if ("function" === typeof g) try {
            g();
        } catch (k) {
            if (null === f) throw Error(y(330));
            Wi(f, k);
        }
    }
    c = Aj;
    Aj = [];
    for(d = 0; d < c.length; d += 2){
        e = c[d];
        f = c[d + 1];
        try {
            var h = e.create;
            e.destroy = h();
        } catch (k) {
            if (null === f) throw Error(y(330));
            Wi(f, k);
        }
    }
    for(h = a.current.firstEffect; null !== h;)a = h.nextEffect, h.nextEffect = null, h.flags & 8 && (h.sibling = null, h.stateNode = null), h = a;
    X = b;
    ig();
    return !0;
}
function gk(a, b, c) {
    b = Mi(c, b);
    b = Pi(a, b, 1);
    Ag(a, b);
    b = Hg();
    a = Kj(a, 1);
    null !== a && ($c(a, 1, b), Mj(a, b));
}
function Wi(a, b) {
    if (3 === a.tag) gk(a, a, b);
    else for(var c = a.return; null !== c;){
        if (3 === c.tag) {
            gk(c, a, b);
            break;
        } else if (1 === c.tag) {
            var d = c.stateNode;
            if ("function" === typeof c.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === Ti || !Ti.has(d))) {
                a = Mi(b, a);
                var e = Si(c, a, 1);
                Ag(c, e);
                e = Hg();
                c = Kj(c, 1);
                if (null !== c) $c(c, 1, e), Mj(c, e);
                else if ("function" === typeof d.componentDidCatch && (null === Ti || !Ti.has(d))) try {
                    d.componentDidCatch(b, a);
                } catch (f) {}
                break;
            }
        }
        c = c.return;
    }
}
function Yj(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = Hg();
    a.pingedLanes |= a.suspendedLanes & c;
    U === a && (W & c) === c && (4 === V || 3 === V && (W & 62914560) === W && 500 > O() - jj ? Qj(a, 0) : uj |= c);
    Mj(a, b);
}
function lj(a, b) {
    var c = a.stateNode;
    null !== c && c.delete(b);
    b = 0;
    0 === b && (b = a.mode, 0 === (b & 2) ? b = 1 : 0 === (b & 4) ? b = 99 === eg() ? 1 : 2 : (0 === Gj && (Gj = tj), b = Yc(62914560 & ~Gj), 0 === b && (b = 4194304)));
    c = Hg();
    a = Kj(a, b);
    null !== a && ($c(a, b, c), Mj(a, c));
}
var ck;
ck = function(a, b, c) {
    var d = b.lanes;
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || N.current) ug = !0;
        else if (0 !== (c & d)) ug = 0 !== (a.flags & 16384) ? !0 : !1;
        else {
            ug = !1;
            switch(b.tag){
                case 3:
                    ri(b);
                    sh();
                    break;
                case 5:
                    gh(b);
                    break;
                case 1:
                    Ff(b.type) && Jf(b);
                    break;
                case 4:
                    eh(b, b.stateNode.containerInfo);
                    break;
                case 10:
                    d = b.memoizedProps.value;
                    var e = b.type._context;
                    I(mg, e._currentValue);
                    e._currentValue = d;
                    break;
                case 13:
                    if (null !== b.memoizedState) {
                        if (0 !== (c & b.child.childLanes)) return ti(a, b, c);
                        I(P, P.current & 1);
                        b = hi(a, b, c);
                        return null !== b ? b.sibling : null;
                    }
                    I(P, P.current & 1);
                    break;
                case 19:
                    d = 0 !== (c & b.childLanes);
                    if (0 !== (a.flags & 64)) {
                        if (d) return Ai(a, b, c);
                        b.flags |= 64;
                    }
                    e = b.memoizedState;
                    null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
                    I(P, P.current);
                    if (d) break;
                    else return null;
                case 23:
                case 24:
                    return b.lanes = 0, mi(a, b, c);
            }
            return hi(a, b, c);
        }
    } else ug = !1;
    b.lanes = 0;
    switch(b.tag){
        case 2:
            d = b.type;
            null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
            a = b.pendingProps;
            e = Ef(b, M.current);
            tg(b, c);
            e = Ch(null, b, d, a, e, c);
            b.flags |= 1;
            if ("object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof) {
                b.tag = 1;
                b.memoizedState = null;
                b.updateQueue = null;
                if (Ff(d)) {
                    var f = !0;
                    Jf(b);
                } else f = !1;
                b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null;
                xg(b);
                var g = d.getDerivedStateFromProps;
                "function" === typeof g && Gg(b, d, g, a);
                e.updater = Kg;
                b.stateNode = e;
                e._reactInternals = b;
                Og(b, d, a, c);
                b = qi(null, b, d, !0, f, c);
            } else b.tag = 0, fi(null, b, e, c), b = b.child;
            return b;
        case 16:
            e = b.elementType;
            a: {
                null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
                a = b.pendingProps;
                f = e._init;
                e = f(e._payload);
                b.type = e;
                f = b.tag = hk(e);
                a = lg(e, a);
                switch(f){
                    case 0:
                        b = li(null, b, e, a, c);
                        break a;
                    case 1:
                        b = pi(null, b, e, a, c);
                        break a;
                    case 11:
                        b = gi(null, b, e, a, c);
                        break a;
                    case 14:
                        b = ii(null, b, e, lg(e.type, a), d, c);
                        break a;
                }
                throw Error(y(306, e, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), li(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), pi(a, b, d, e, c);
        case 3:
            ri(b);
            d = b.updateQueue;
            if (null === a || null === d) throw Error(y(282));
            d = b.pendingProps;
            e = b.memoizedState;
            e = null !== e ? e.element : null;
            yg(a, b);
            Cg(b, d, null, c);
            d = b.memoizedState.element;
            if (d === e) sh(), b = hi(a, b, c);
            else {
                e = b.stateNode;
                if (f = e.hydrate) kh = rf(b.stateNode.containerInfo.firstChild), jh = b, f = lh = !0;
                if (f) {
                    a = e.mutableSourceEagerHydrationData;
                    if (null != a) for(e = 0; e < a.length; e += 2)f = a[e], f._workInProgressVersionPrimary = a[e + 1], th.push(f);
                    c = Zg(b, null, d, c);
                    for(b.child = c; c;)c.flags = c.flags & -3 | 1024, c = c.sibling;
                } else fi(a, b, d, c), sh();
                b = b.child;
            }
            return b;
        case 5:
            return gh(b), null === a && ph(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, nf(d, e) ? g = null : null !== f && nf(d, f) && (b.flags |= 16), oi(a, b), fi(a, b, g, c), b.child;
        case 6:
            return null === a && ph(b), null;
        case 13:
            return ti(a, b, c);
        case 4:
            return eh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = Yg(b, null, d, c) : fi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), gi(a, b, d, e, c);
        case 7:
            return fi(a, b, b.pendingProps, c), b.child;
        case 8:
            return fi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return fi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                g = b.memoizedProps;
                f = e.value;
                var h = b.type._context;
                I(mg, h._currentValue);
                h._currentValue = f;
                if (null !== g) {
                    if (h = g.value, f = He(h, f) ? 0 : ("function" === typeof d._calculateChangedBits ? d._calculateChangedBits(h, f) : 1073741823) | 0, 0 === f) {
                        if (g.children === e.children && !N.current) {
                            b = hi(a, b, c);
                            break a;
                        }
                    } else for(h = b.child, null !== h && (h.return = b); null !== h;){
                        var k = h.dependencies;
                        if (null !== k) {
                            g = h.child;
                            for(var l = k.firstContext; null !== l;){
                                if (l.context === d && 0 !== (l.observedBits & f)) {
                                    1 === h.tag && (l = zg(-1, c & -c), l.tag = 2, Ag(h, l));
                                    h.lanes |= c;
                                    l = h.alternate;
                                    null !== l && (l.lanes |= c);
                                    sg(h.return, c);
                                    k.lanes |= c;
                                    break;
                                }
                                l = l.next;
                            }
                        } else g = 10 === h.tag ? h.type === b.type ? null : h.child : h.child;
                        if (null !== g) g.return = h;
                        else for(g = h; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            h = g.sibling;
                            if (null !== h) {
                                h.return = g.return;
                                g = h;
                                break;
                            }
                            g = g.return;
                        }
                        h = g;
                    }
                }
                fi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, f = b.pendingProps, d = f.children, tg(b, c), e = vg(e, f.unstable_observedBits), d = d(e), b.flags |= 1, fi(a, b, d, c), b.child;
        case 14:
            return e = b.type, f = lg(e, b.pendingProps), f = lg(e.type, f), ii(a, b, e, f, d, c);
        case 15:
            return ki(a, b, b.type, b.pendingProps, d, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2), b.tag = 1, Ff(d) ? (a = !0, Jf(b)) : a = !1, tg(b, c), Mg(b, d, e), Og(b, d, e, c), qi(null, b, d, !0, a, c);
        case 19:
            return Ai(a, b, c);
        case 23:
            return mi(a, b, c);
        case 24:
            return mi(a, b, c);
    }
    throw Error(y(156, b.tag));
};
function ik(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.flags = 0;
    this.lastEffect = this.firstEffect = this.nextEffect = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function nh(a, b, c, d) {
    return new ik(a, b, c, d);
}
function ji(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function hk(a) {
    if ("function" === typeof a) return ji(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === Aa) return 11;
        if (a === Da) return 14;
    }
    return 2;
}
function Tg(a, b) {
    var c = a.alternate;
    null === c ? (c = nh(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.nextEffect = null, c.firstEffect = null, c.lastEffect = null);
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function Vg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) ji(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case ua:
            return Xg(c.children, e, f, b);
        case Ha:
            g = 8;
            e |= 16;
            break;
        case wa:
            g = 8;
            e |= 1;
            break;
        case xa:
            return a = nh(12, c, b, e | 8), a.elementType = xa, a.type = xa, a.lanes = f, a;
        case Ba:
            return a = nh(13, c, b, e), a.type = Ba, a.elementType = Ba, a.lanes = f, a;
        case Ca:
            return a = nh(19, c, b, e), a.elementType = Ca, a.lanes = f, a;
        case Ia:
            return vi(c, e, f, b);
        case Ja:
            return a = nh(24, c, b, e), a.elementType = Ja, a.lanes = f, a;
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case ya:
                    g = 10;
                    break a;
                case za:
                    g = 9;
                    break a;
                case Aa:
                    g = 11;
                    break a;
                case Da:
                    g = 14;
                    break a;
                case Ea:
                    g = 16;
                    d = null;
                    break a;
                case Fa:
                    g = 22;
                    break a;
            }
            throw Error(y(130, null == a ? a : typeof a, ""));
    }
    b = nh(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function Xg(a, b, c, d) {
    a = nh(7, a, d, b);
    a.lanes = c;
    return a;
}
function vi(a, b, c, d) {
    a = nh(23, a, d, b);
    a.elementType = Ia;
    a.lanes = c;
    return a;
}
function Ug(a, b, c) {
    a = nh(6, a, null, b);
    a.lanes = c;
    return a;
}
function Wg(a, b, c) {
    b = nh(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function jk(a, b, c) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.pendingContext = this.context = null;
    this.hydrate = c;
    this.callbackNode = null;
    this.callbackPriority = 0;
    this.eventTimes = Zc(0);
    this.expirationTimes = Zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = Zc(0);
    this.mutableSourceEagerHydrationData = null;
}
function kk(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: ta,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function lk(a, b, c, d) {
    var e = b.current, f = Hg(), g = Ig(e);
    a: if (c) {
        c = c._reactInternals;
        b: {
            if (Zb(c) !== c || 1 !== c.tag) throw Error(y(170));
            var h = c;
            do {
                switch(h.tag){
                    case 3:
                        h = h.stateNode.context;
                        break b;
                    case 1:
                        if (Ff(h.type)) {
                            h = h.stateNode.__reactInternalMemoizedMergedChildContext;
                            break b;
                        }
                }
                h = h.return;
            }while (null !== h);
            throw Error(y(171));
        }
        if (1 === c.tag) {
            var k = c.type;
            if (Ff(k)) {
                c = If(c, k, h);
                break a;
            }
        }
        c = h;
    } else c = Cf;
    null === b.context ? b.context = c : b.pendingContext = c;
    b = zg(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    Ag(e, b);
    Jg(e, g, f);
    return g;
}
function mk(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function nk(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function ok(a, b) {
    nk(a, b);
    (a = a.alternate) && nk(a, b);
}
function pk() {
    return null;
}
function qk(a, b, c) {
    var d = null != c && null != c.hydrationOptions && c.hydrationOptions.mutableSources || null;
    c = new jk(a, b, null != c && !0 === c.hydrate);
    b = nh(3, null, null, 2 === b ? 7 : 1 === b ? 3 : 0);
    c.current = b;
    b.stateNode = c;
    xg(b);
    a[ff] = c.current;
    cf(8 === a.nodeType ? a.parentNode : a);
    if (d) for(a = 0; a < d.length; a++){
        b = d[a];
        var e = b._getVersion;
        e = e(b._source);
        null == c.mutableSourceEagerHydrationData ? c.mutableSourceEagerHydrationData = [
            b,
            e
        ] : c.mutableSourceEagerHydrationData.push(b, e);
    }
    this._internalRoot = c;
}
qk.prototype.render = function(a) {
    lk(a, this._internalRoot, null, null);
};
qk.prototype.unmount = function() {
    var a = this._internalRoot, b = a.containerInfo;
    lk(null, a, null, function() {
        b[ff] = null;
    });
};
function rk(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function sk(a, b) {
    b || (b = a ? 9 === a.nodeType ? a.documentElement : a.firstChild : null, b = !(!b || 1 !== b.nodeType || !b.hasAttribute("data-reactroot")));
    if (!b) for(var c; c = a.lastChild;)a.removeChild(c);
    return new qk(a, 0, b ? {
        hydrate: !0
    } : void 0);
}
function tk(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f._internalRoot;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = mk(g);
                h.call(a);
            };
        }
        lk(b, g, a, e);
    } else {
        f = c._reactRootContainer = sk(c, d);
        g = f._internalRoot;
        if ("function" === typeof e) {
            var k = e;
            e = function() {
                var a = mk(g);
                k.call(a);
            };
        }
        Xj(function() {
            lk(b, g, a, e);
        });
    }
    return mk(g);
}
ec = function(a) {
    if (13 === a.tag) {
        var b = Hg();
        Jg(a, 4, b);
        ok(a, 4);
    }
};
fc = function(a) {
    if (13 === a.tag) {
        var b = Hg();
        Jg(a, 67108864, b);
        ok(a, 67108864);
    }
};
gc = function(a) {
    if (13 === a.tag) {
        var b = Hg(), c = Ig(a);
        Jg(a, c, b);
        ok(a, c);
    }
};
hc = function(a, b) {
    return b();
};
yb = function(a, b, c) {
    switch(b){
        case "input":
            ab(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = Db(d);
                        if (!e) throw Error(y(90));
                        Wa(d);
                        ab(d, e);
                    }
                }
            }
            break;
        case "textarea":
            ib(a, c);
            break;
        case "select":
            b = c.value, null != b && fb(a, !!c.multiple, b, !1);
    }
};
Gb = Wj;
Hb = function(a, b, c, d, e) {
    var f = X;
    X |= 4;
    try {
        return gg(98, a.bind(null, b, c, d, e));
    } finally{
        X = f, 0 === X && (wj(), ig());
    }
};
Ib = function() {
    0 === (X & 49) && (Vj(), Oj());
};
Jb = function(a, b) {
    var c = X;
    X |= 2;
    try {
        return a(b);
    } finally{
        X = c, 0 === X && (wj(), ig());
    }
};
function uk(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!rk(b)) throw Error(y(200));
    return kk(a, b, null, c);
}
var vk = {
    Events: [
        Cb,
        ue,
        Db,
        Eb,
        Fb,
        Oj,
        {
            current: !1
        }
    ]
}, wk = {
    findFiberByHostInstance: wc,
    bundleType: 0,
    version: "17.0.2",
    rendererPackageName: "react-dom"
};
var xk = {
    bundleType: wk.bundleType,
    version: wk.version,
    rendererPackageName: wk.rendererPackageName,
    rendererConfig: wk.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: ra.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = cc(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: wk.findFiberByHostInstance || pk,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var yk = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!yk.isDisabled && yk.supportsFiber) try {
        Lf = yk.inject(xk), Mf = yk;
    } catch (a) {}
}
exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = vk;
exports.createPortal = uk;
exports.findDOMNode = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error(y(188));
        throw Error(y(268, Object.keys(a)));
    }
    a = cc(b);
    a = null === a ? null : a.stateNode;
    return a;
};
exports.flushSync = function(a, b) {
    var c = X;
    if (0 !== (c & 48)) return a(b);
    X |= 1;
    try {
        if (a) return gg(99, a.bind(null, b));
    } finally{
        X = c, ig();
    }
};
exports.hydrate = function(a, b, c) {
    if (!rk(b)) throw Error(y(200));
    return tk(null, a, b, !0, c);
};
exports.render = function(a, b, c) {
    if (!rk(b)) throw Error(y(200));
    return tk(null, a, b, !1, c);
};
exports.unmountComponentAtNode = function(a) {
    if (!rk(a)) throw Error(y(40));
    return a._reactRootContainer ? (Xj(function() {
        tk(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[ff] = null;
        });
    }), !0) : !1;
};
exports.unstable_batchedUpdates = Wj;
exports.unstable_createPortal = function(a, b) {
    return uk(a, b, 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null);
};
exports.unstable_renderSubtreeIntoContainer = function(a, b, c, d) {
    if (!rk(c)) throw Error(y(200));
    if (null == a || void 0 === a._reactInternals) throw Error(y(38));
    return tk(a, b, c, !1, d);
};
exports.version = "17.0.2";

});
parcelRegister("5IcjB", function(module, exports) {
"use strict";

module.exports = (parcelRequire("gSkyL"));

});
parcelRegister("gSkyL", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $032ba3aa3b6f1f78$export$c4744153514ff05d; }, function (v) { return $032ba3aa3b6f1f78$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $032ba3aa3b6f1f78$export$b5836b71941fa3ed; }, function (v) { return $032ba3aa3b6f1f78$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $032ba3aa3b6f1f78$export$d66a1c1c77bd778b; }, function (v) { return $032ba3aa3b6f1f78$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $032ba3aa3b6f1f78$export$3e506c1ccc9cc1a7; }, function (v) { return $032ba3aa3b6f1f78$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $032ba3aa3b6f1f78$export$e26fe2ed2fa76875; }, function (v) { return $032ba3aa3b6f1f78$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $032ba3aa3b6f1f78$export$502329bbf4b505b1; }, function (v) { return $032ba3aa3b6f1f78$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $032ba3aa3b6f1f78$export$6e3807111c4874c4; }, function (v) { return $032ba3aa3b6f1f78$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $032ba3aa3b6f1f78$export$c27134553091fb3a; }, function (v) { return $032ba3aa3b6f1f78$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $032ba3aa3b6f1f78$export$33ee1acdc04fd2a2; }, function (v) { return $032ba3aa3b6f1f78$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $032ba3aa3b6f1f78$export$b00a404bbd5edef2; }, function (v) { return $032ba3aa3b6f1f78$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $032ba3aa3b6f1f78$export$8352ce38b91d0c62; }, function (v) { return $032ba3aa3b6f1f78$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $032ba3aa3b6f1f78$export$d3dfb8e4810cb555; }, function (v) { return $032ba3aa3b6f1f78$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $032ba3aa3b6f1f78$export$839f9183b0465a69; }, function (v) { return $032ba3aa3b6f1f78$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $032ba3aa3b6f1f78$export$72fdf0e06517287b; }, function (v) { return $032ba3aa3b6f1f78$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $032ba3aa3b6f1f78$export$4b844e58a3e414b4; }, function (v) { return $032ba3aa3b6f1f78$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $032ba3aa3b6f1f78$export$816d2913ae6b83b1; }, function (v) { return $032ba3aa3b6f1f78$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $032ba3aa3b6f1f78$export$61bcfe829111a1d0; }, function (v) { return $032ba3aa3b6f1f78$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $032ba3aa3b6f1f78$export$7ee8c9beb337bc3f; }, function (v) { return $032ba3aa3b6f1f78$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $032ba3aa3b6f1f78$export$cf845f2c119da08a; }, function (v) { return $032ba3aa3b6f1f78$export$cf845f2c119da08a = v; });
/** @license React v0.20.2
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $032ba3aa3b6f1f78$export$c4744153514ff05d;
var $032ba3aa3b6f1f78$export$b5836b71941fa3ed;
var $032ba3aa3b6f1f78$export$d66a1c1c77bd778b;
var $032ba3aa3b6f1f78$export$3e506c1ccc9cc1a7;
var $032ba3aa3b6f1f78$export$e26fe2ed2fa76875;
var $032ba3aa3b6f1f78$export$502329bbf4b505b1;
var $032ba3aa3b6f1f78$export$6e3807111c4874c4;
var $032ba3aa3b6f1f78$export$c27134553091fb3a;
var $032ba3aa3b6f1f78$export$33ee1acdc04fd2a2;
var $032ba3aa3b6f1f78$export$b00a404bbd5edef2;
var $032ba3aa3b6f1f78$export$8352ce38b91d0c62;
var $032ba3aa3b6f1f78$export$d3dfb8e4810cb555;
var $032ba3aa3b6f1f78$export$839f9183b0465a69;
var $032ba3aa3b6f1f78$export$72fdf0e06517287b;
var $032ba3aa3b6f1f78$export$4b844e58a3e414b4;
var $032ba3aa3b6f1f78$export$816d2913ae6b83b1;
var $032ba3aa3b6f1f78$export$61bcfe829111a1d0;
var $032ba3aa3b6f1f78$export$7ee8c9beb337bc3f;
var $032ba3aa3b6f1f78$export$cf845f2c119da08a;
"use strict";
var $032ba3aa3b6f1f78$var$f, $032ba3aa3b6f1f78$var$g, $032ba3aa3b6f1f78$var$h, $032ba3aa3b6f1f78$var$k;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $032ba3aa3b6f1f78$var$l = performance;
    $032ba3aa3b6f1f78$export$c4744153514ff05d = function() {
        return $032ba3aa3b6f1f78$var$l.now();
    };
} else {
    var $032ba3aa3b6f1f78$var$p = Date, $032ba3aa3b6f1f78$var$q = $032ba3aa3b6f1f78$var$p.now();
    $032ba3aa3b6f1f78$export$c4744153514ff05d = function() {
        return $032ba3aa3b6f1f78$var$p.now() - $032ba3aa3b6f1f78$var$q;
    };
}
if ("undefined" === typeof window || "function" !== typeof MessageChannel) {
    var $032ba3aa3b6f1f78$var$t = null, $032ba3aa3b6f1f78$var$u = null, $032ba3aa3b6f1f78$var$w = function() {
        if (null !== $032ba3aa3b6f1f78$var$t) try {
            var a = $032ba3aa3b6f1f78$export$c4744153514ff05d();
            $032ba3aa3b6f1f78$var$t(!0, a);
            $032ba3aa3b6f1f78$var$t = null;
        } catch (b) {
            throw setTimeout($032ba3aa3b6f1f78$var$w, 0), b;
        }
    };
    $032ba3aa3b6f1f78$var$f = function(a) {
        null !== $032ba3aa3b6f1f78$var$t ? setTimeout($032ba3aa3b6f1f78$var$f, 0, a) : ($032ba3aa3b6f1f78$var$t = a, setTimeout($032ba3aa3b6f1f78$var$w, 0));
    };
    $032ba3aa3b6f1f78$var$g = function(a, b) {
        $032ba3aa3b6f1f78$var$u = setTimeout(a, b);
    };
    $032ba3aa3b6f1f78$var$h = function() {
        clearTimeout($032ba3aa3b6f1f78$var$u);
    };
    $032ba3aa3b6f1f78$export$b5836b71941fa3ed = function() {
        return !1;
    };
    $032ba3aa3b6f1f78$var$k = $032ba3aa3b6f1f78$export$d66a1c1c77bd778b = function() {};
} else {
    var $032ba3aa3b6f1f78$var$x = window.setTimeout, $032ba3aa3b6f1f78$var$y = window.clearTimeout;
    if ("undefined" !== typeof console) {
        var $032ba3aa3b6f1f78$var$z = window.cancelAnimationFrame;
        "function" !== typeof window.requestAnimationFrame && console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
        "function" !== typeof $032ba3aa3b6f1f78$var$z && console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
    }
    var $032ba3aa3b6f1f78$var$A = !1, $032ba3aa3b6f1f78$var$B = null, $032ba3aa3b6f1f78$var$C = -1, $032ba3aa3b6f1f78$var$D = 5, $032ba3aa3b6f1f78$var$E = 0;
    $032ba3aa3b6f1f78$export$b5836b71941fa3ed = function() {
        return $032ba3aa3b6f1f78$export$c4744153514ff05d() >= $032ba3aa3b6f1f78$var$E;
    };
    $032ba3aa3b6f1f78$var$k = function() {};
    $032ba3aa3b6f1f78$export$d66a1c1c77bd778b = function(a) {
        0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $032ba3aa3b6f1f78$var$D = 0 < a ? Math.floor(1E3 / a) : 5;
    };
    var $032ba3aa3b6f1f78$var$F = new MessageChannel, $032ba3aa3b6f1f78$var$G = $032ba3aa3b6f1f78$var$F.port2;
    $032ba3aa3b6f1f78$var$F.port1.onmessage = function() {
        if (null !== $032ba3aa3b6f1f78$var$B) {
            var a = $032ba3aa3b6f1f78$export$c4744153514ff05d();
            $032ba3aa3b6f1f78$var$E = a + $032ba3aa3b6f1f78$var$D;
            try {
                $032ba3aa3b6f1f78$var$B(!0, a) ? $032ba3aa3b6f1f78$var$G.postMessage(null) : ($032ba3aa3b6f1f78$var$A = !1, $032ba3aa3b6f1f78$var$B = null);
            } catch (b) {
                throw $032ba3aa3b6f1f78$var$G.postMessage(null), b;
            }
        } else $032ba3aa3b6f1f78$var$A = !1;
    };
    $032ba3aa3b6f1f78$var$f = function(a) {
        $032ba3aa3b6f1f78$var$B = a;
        $032ba3aa3b6f1f78$var$A || ($032ba3aa3b6f1f78$var$A = !0, $032ba3aa3b6f1f78$var$G.postMessage(null));
    };
    $032ba3aa3b6f1f78$var$g = function(a, b) {
        $032ba3aa3b6f1f78$var$C = $032ba3aa3b6f1f78$var$x(function() {
            a($032ba3aa3b6f1f78$export$c4744153514ff05d());
        }, b);
    };
    $032ba3aa3b6f1f78$var$h = function() {
        $032ba3aa3b6f1f78$var$y($032ba3aa3b6f1f78$var$C);
        $032ba3aa3b6f1f78$var$C = -1;
    };
}
function $032ba3aa3b6f1f78$var$H(a, b) {
    var c = a.length;
    a.push(b);
    a: for(;;){
        var d = c - 1 >>> 1, e = a[d];
        if (void 0 !== e && 0 < $032ba3aa3b6f1f78$var$I(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $032ba3aa3b6f1f78$var$J(a) {
    a = a[0];
    return void 0 === a ? null : a;
}
function $032ba3aa3b6f1f78$var$K(a) {
    var b = a[0];
    if (void 0 !== b) {
        var c = a.pop();
        if (c !== b) {
            a[0] = c;
            a: for(var d = 0, e = a.length; d < e;){
                var m = 2 * (d + 1) - 1, n = a[m], v = m + 1, r = a[v];
                if (void 0 !== n && 0 > $032ba3aa3b6f1f78$var$I(n, c)) void 0 !== r && 0 > $032ba3aa3b6f1f78$var$I(r, n) ? (a[d] = r, a[v] = c, d = v) : (a[d] = n, a[m] = c, d = m);
                else if (void 0 !== r && 0 > $032ba3aa3b6f1f78$var$I(r, c)) a[d] = r, a[v] = c, d = v;
                else break a;
            }
        }
        return b;
    }
    return null;
}
function $032ba3aa3b6f1f78$var$I(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
var $032ba3aa3b6f1f78$var$L = [], $032ba3aa3b6f1f78$var$M = [], $032ba3aa3b6f1f78$var$N = 1, $032ba3aa3b6f1f78$var$O = null, $032ba3aa3b6f1f78$var$P = 3, $032ba3aa3b6f1f78$var$Q = !1, $032ba3aa3b6f1f78$var$R = !1, $032ba3aa3b6f1f78$var$S = !1;
function $032ba3aa3b6f1f78$var$T(a) {
    for(var b = $032ba3aa3b6f1f78$var$J($032ba3aa3b6f1f78$var$M); null !== b;){
        if (null === b.callback) $032ba3aa3b6f1f78$var$K($032ba3aa3b6f1f78$var$M);
        else if (b.startTime <= a) $032ba3aa3b6f1f78$var$K($032ba3aa3b6f1f78$var$M), b.sortIndex = b.expirationTime, $032ba3aa3b6f1f78$var$H($032ba3aa3b6f1f78$var$L, b);
        else break;
        b = $032ba3aa3b6f1f78$var$J($032ba3aa3b6f1f78$var$M);
    }
}
function $032ba3aa3b6f1f78$var$U(a) {
    $032ba3aa3b6f1f78$var$S = !1;
    $032ba3aa3b6f1f78$var$T(a);
    if (!$032ba3aa3b6f1f78$var$R) {
        if (null !== $032ba3aa3b6f1f78$var$J($032ba3aa3b6f1f78$var$L)) $032ba3aa3b6f1f78$var$R = !0, $032ba3aa3b6f1f78$var$f($032ba3aa3b6f1f78$var$V);
        else {
            var b = $032ba3aa3b6f1f78$var$J($032ba3aa3b6f1f78$var$M);
            null !== b && $032ba3aa3b6f1f78$var$g($032ba3aa3b6f1f78$var$U, b.startTime - a);
        }
    }
}
function $032ba3aa3b6f1f78$var$V(a, b) {
    $032ba3aa3b6f1f78$var$R = !1;
    $032ba3aa3b6f1f78$var$S && ($032ba3aa3b6f1f78$var$S = !1, $032ba3aa3b6f1f78$var$h());
    $032ba3aa3b6f1f78$var$Q = !0;
    var c = $032ba3aa3b6f1f78$var$P;
    try {
        $032ba3aa3b6f1f78$var$T(b);
        for($032ba3aa3b6f1f78$var$O = $032ba3aa3b6f1f78$var$J($032ba3aa3b6f1f78$var$L); null !== $032ba3aa3b6f1f78$var$O && (!($032ba3aa3b6f1f78$var$O.expirationTime > b) || a && !$032ba3aa3b6f1f78$export$b5836b71941fa3ed());){
            var d = $032ba3aa3b6f1f78$var$O.callback;
            if ("function" === typeof d) {
                $032ba3aa3b6f1f78$var$O.callback = null;
                $032ba3aa3b6f1f78$var$P = $032ba3aa3b6f1f78$var$O.priorityLevel;
                var e = d($032ba3aa3b6f1f78$var$O.expirationTime <= b);
                b = $032ba3aa3b6f1f78$export$c4744153514ff05d();
                "function" === typeof e ? $032ba3aa3b6f1f78$var$O.callback = e : $032ba3aa3b6f1f78$var$O === $032ba3aa3b6f1f78$var$J($032ba3aa3b6f1f78$var$L) && $032ba3aa3b6f1f78$var$K($032ba3aa3b6f1f78$var$L);
                $032ba3aa3b6f1f78$var$T(b);
            } else $032ba3aa3b6f1f78$var$K($032ba3aa3b6f1f78$var$L);
            $032ba3aa3b6f1f78$var$O = $032ba3aa3b6f1f78$var$J($032ba3aa3b6f1f78$var$L);
        }
        if (null !== $032ba3aa3b6f1f78$var$O) var m = !0;
        else {
            var n = $032ba3aa3b6f1f78$var$J($032ba3aa3b6f1f78$var$M);
            null !== n && $032ba3aa3b6f1f78$var$g($032ba3aa3b6f1f78$var$U, n.startTime - b);
            m = !1;
        }
        return m;
    } finally{
        $032ba3aa3b6f1f78$var$O = null, $032ba3aa3b6f1f78$var$P = c, $032ba3aa3b6f1f78$var$Q = !1;
    }
}
var $032ba3aa3b6f1f78$var$W = $032ba3aa3b6f1f78$var$k;
$032ba3aa3b6f1f78$export$3e506c1ccc9cc1a7 = 5;
$032ba3aa3b6f1f78$export$e26fe2ed2fa76875 = 1;
$032ba3aa3b6f1f78$export$502329bbf4b505b1 = 4;
$032ba3aa3b6f1f78$export$6e3807111c4874c4 = 3;
$032ba3aa3b6f1f78$export$c27134553091fb3a = null;
$032ba3aa3b6f1f78$export$33ee1acdc04fd2a2 = 2;
$032ba3aa3b6f1f78$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$032ba3aa3b6f1f78$export$8352ce38b91d0c62 = function() {
    $032ba3aa3b6f1f78$var$R || $032ba3aa3b6f1f78$var$Q || ($032ba3aa3b6f1f78$var$R = !0, $032ba3aa3b6f1f78$var$f($032ba3aa3b6f1f78$var$V));
};
$032ba3aa3b6f1f78$export$d3dfb8e4810cb555 = function() {
    return $032ba3aa3b6f1f78$var$P;
};
$032ba3aa3b6f1f78$export$839f9183b0465a69 = function() {
    return $032ba3aa3b6f1f78$var$J($032ba3aa3b6f1f78$var$L);
};
$032ba3aa3b6f1f78$export$72fdf0e06517287b = function(a) {
    switch($032ba3aa3b6f1f78$var$P){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $032ba3aa3b6f1f78$var$P;
    }
    var c = $032ba3aa3b6f1f78$var$P;
    $032ba3aa3b6f1f78$var$P = b;
    try {
        return a();
    } finally{
        $032ba3aa3b6f1f78$var$P = c;
    }
};
$032ba3aa3b6f1f78$export$4b844e58a3e414b4 = function() {};
$032ba3aa3b6f1f78$export$816d2913ae6b83b1 = $032ba3aa3b6f1f78$var$W;
$032ba3aa3b6f1f78$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $032ba3aa3b6f1f78$var$P;
    $032ba3aa3b6f1f78$var$P = a;
    try {
        return b();
    } finally{
        $032ba3aa3b6f1f78$var$P = c;
    }
};
$032ba3aa3b6f1f78$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $032ba3aa3b6f1f78$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $032ba3aa3b6f1f78$var$N++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $032ba3aa3b6f1f78$var$H($032ba3aa3b6f1f78$var$M, a), null === $032ba3aa3b6f1f78$var$J($032ba3aa3b6f1f78$var$L) && a === $032ba3aa3b6f1f78$var$J($032ba3aa3b6f1f78$var$M) && ($032ba3aa3b6f1f78$var$S ? $032ba3aa3b6f1f78$var$h() : $032ba3aa3b6f1f78$var$S = !0, $032ba3aa3b6f1f78$var$g($032ba3aa3b6f1f78$var$U, c - d))) : (a.sortIndex = e, $032ba3aa3b6f1f78$var$H($032ba3aa3b6f1f78$var$L, a), $032ba3aa3b6f1f78$var$R || $032ba3aa3b6f1f78$var$Q || ($032ba3aa3b6f1f78$var$R = !0, $032ba3aa3b6f1f78$var$f($032ba3aa3b6f1f78$var$V)));
    return a;
};
$032ba3aa3b6f1f78$export$cf845f2c119da08a = function(a) {
    var b = $032ba3aa3b6f1f78$var$P;
    return function() {
        var c = $032ba3aa3b6f1f78$var$P;
        $032ba3aa3b6f1f78$var$P = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $032ba3aa3b6f1f78$var$P = c;
        }
    };
};

});




parcelRegister("e0pK3", function(module, exports) {


module.exports = (parcelRequire("6Yny6"))((parcelRequire("8rEqs")).resolve("jD60Z")).then(()=>parcelRequire("cNIke"));

});
parcelRegister("6Yny6", function(module, exports) {
"use strict";

var $eWJMa = parcelRequire("eWJMa");
module.exports = $eWJMa(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName("script");
        if ([].concat(existingScripts).some(function isCurrentBundle(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement("link");
        preloadLink.href = bundle;
        preloadLink.rel = "preload";
        preloadLink.as = "script";
        document.head.appendChild(preloadLink);
        var script = document.createElement("script");
        script.async = true;
        script.type = "text/javascript";
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName("head")[0].appendChild(script);
    });
});

});
parcelRegister("eWJMa", function(module, exports) {
"use strict";
var $ae19fd9d832fa92a$var$cachedBundles = {};
var $ae19fd9d832fa92a$var$cachedPreloads = {};
var $ae19fd9d832fa92a$var$cachedPrefetches = {};
function $ae19fd9d832fa92a$var$getCache(type) {
    switch(type){
        case "preload":
            return $ae19fd9d832fa92a$var$cachedPreloads;
        case "prefetch":
            return $ae19fd9d832fa92a$var$cachedPrefetches;
        default:
            return $ae19fd9d832fa92a$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $ae19fd9d832fa92a$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



parcelRegister("aRbOc", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $7e78039315d31965$var$ReactIs, $7e78039315d31965$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("b42xS"))();

});
parcelRegister("b42xS", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $9BVR1 = parcelRequire("9BVR1");
function $80e20aeb2379013f$var$emptyFunction() {}
function $80e20aeb2379013f$var$emptyFunctionWithReset() {}
$80e20aeb2379013f$var$emptyFunctionWithReset.resetWarningCache = $80e20aeb2379013f$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $9BVR1) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $80e20aeb2379013f$var$emptyFunctionWithReset,
        resetWarningCache: $80e20aeb2379013f$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("9BVR1", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var $6ff472697b824e91$var$ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = $6ff472697b824e91$var$ReactPropTypesSecret;

});



parcelRegister("gB0MJ", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", function () { return $c150b5eed0e0c337$export$a7c73072b1a182ae; }, function (v) { return $c150b5eed0e0c337$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $c150b5eed0e0c337$export$9f27bc3417b4524d; }, function (v) { return $c150b5eed0e0c337$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $c150b5eed0e0c337$export$db77ccec0bb4ccac; }, function (v) { return $c150b5eed0e0c337$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $c150b5eed0e0c337$export$8392c0c9d3dcbd35; }, function (v) { return $c150b5eed0e0c337$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $c150b5eed0e0c337$export$ffb0004e005737fa; }, function (v) { return $c150b5eed0e0c337$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $c150b5eed0e0c337$export$b624eff549462981; }, function (v) { return $c150b5eed0e0c337$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $c150b5eed0e0c337$export$7897aa7841a5380c; }, function (v) { return $c150b5eed0e0c337$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $c150b5eed0e0c337$export$602eac185826482c; }, function (v) { return $c150b5eed0e0c337$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $c150b5eed0e0c337$export$e2c29f18771995cb; }, function (v) { return $c150b5eed0e0c337$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $c150b5eed0e0c337$export$5f8d39834fd61797; }, function (v) { return $c150b5eed0e0c337$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $c150b5eed0e0c337$export$74bf444e3cd11ea5; }, function (v) { return $c150b5eed0e0c337$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "SuspenseList", function () { return $c150b5eed0e0c337$export$998bcd577473dd93; }, function (v) { return $c150b5eed0e0c337$export$998bcd577473dd93 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $c150b5eed0e0c337$export$92387174baf9b227; }, function (v) { return $c150b5eed0e0c337$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $c150b5eed0e0c337$export$ec112efeb987d9c6; }, function (v) { return $c150b5eed0e0c337$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $c150b5eed0e0c337$export$b706b080d889d2c9; }, function (v) { return $c150b5eed0e0c337$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $c150b5eed0e0c337$export$5be5a87408f70ddc; }, function (v) { return $c150b5eed0e0c337$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $c150b5eed0e0c337$export$45a5e7f76e0caa8d; }, function (v) { return $c150b5eed0e0c337$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $c150b5eed0e0c337$export$455c2e768291efa6; }, function (v) { return $c150b5eed0e0c337$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $c150b5eed0e0c337$export$9522e17588c12572; }, function (v) { return $c150b5eed0e0c337$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $c150b5eed0e0c337$export$2110ac352bb060b9; }, function (v) { return $c150b5eed0e0c337$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $c150b5eed0e0c337$export$56885ab8b9c456ab; }, function (v) { return $c150b5eed0e0c337$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $c150b5eed0e0c337$export$d927fcb6adf8f9de; }, function (v) { return $c150b5eed0e0c337$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $c150b5eed0e0c337$export$b82d16f27459e05a; }, function (v) { return $c150b5eed0e0c337$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $c150b5eed0e0c337$export$522c17b4f5e123e8; }, function (v) { return $c150b5eed0e0c337$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $c150b5eed0e0c337$export$1aabd8a0274ecfd6; }, function (v) { return $c150b5eed0e0c337$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isSuspenseList", function () { return $c150b5eed0e0c337$export$3d6c20d97e46b957; }, function (v) { return $c150b5eed0e0c337$export$3d6c20d97e46b957 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $c150b5eed0e0c337$export$9b621391a187a31a; }, function (v) { return $c150b5eed0e0c337$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $c150b5eed0e0c337$export$f5bbd400c2f4426f; }, function (v) { return $c150b5eed0e0c337$export$f5bbd400c2f4426f = v; });
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $c150b5eed0e0c337$export$a7c73072b1a182ae;
var $c150b5eed0e0c337$export$9f27bc3417b4524d;
var $c150b5eed0e0c337$export$db77ccec0bb4ccac;
var $c150b5eed0e0c337$export$8392c0c9d3dcbd35;
var $c150b5eed0e0c337$export$ffb0004e005737fa;
var $c150b5eed0e0c337$export$b624eff549462981;
var $c150b5eed0e0c337$export$7897aa7841a5380c;
var $c150b5eed0e0c337$export$602eac185826482c;
var $c150b5eed0e0c337$export$e2c29f18771995cb;
var $c150b5eed0e0c337$export$5f8d39834fd61797;
var $c150b5eed0e0c337$export$74bf444e3cd11ea5;
var $c150b5eed0e0c337$export$998bcd577473dd93;
var $c150b5eed0e0c337$export$92387174baf9b227;
var $c150b5eed0e0c337$export$ec112efeb987d9c6;
var $c150b5eed0e0c337$export$b706b080d889d2c9;
var $c150b5eed0e0c337$export$5be5a87408f70ddc;
var $c150b5eed0e0c337$export$45a5e7f76e0caa8d;
var $c150b5eed0e0c337$export$455c2e768291efa6;
var $c150b5eed0e0c337$export$9522e17588c12572;
var $c150b5eed0e0c337$export$2110ac352bb060b9;
var $c150b5eed0e0c337$export$56885ab8b9c456ab;
var $c150b5eed0e0c337$export$d927fcb6adf8f9de;
var $c150b5eed0e0c337$export$b82d16f27459e05a;
var $c150b5eed0e0c337$export$522c17b4f5e123e8;
var $c150b5eed0e0c337$export$1aabd8a0274ecfd6;
var $c150b5eed0e0c337$export$3d6c20d97e46b957;
var $c150b5eed0e0c337$export$9b621391a187a31a;
var $c150b5eed0e0c337$export$f5bbd400c2f4426f;
"use strict";
var $c150b5eed0e0c337$var$b = Symbol.for("react.element"), $c150b5eed0e0c337$var$c = Symbol.for("react.portal"), $c150b5eed0e0c337$var$d = Symbol.for("react.fragment"), $c150b5eed0e0c337$var$e = Symbol.for("react.strict_mode"), $c150b5eed0e0c337$var$f = Symbol.for("react.profiler"), $c150b5eed0e0c337$var$g = Symbol.for("react.provider"), $c150b5eed0e0c337$var$h = Symbol.for("react.context"), $c150b5eed0e0c337$var$k = Symbol.for("react.server_context"), $c150b5eed0e0c337$var$l = Symbol.for("react.forward_ref"), $c150b5eed0e0c337$var$m = Symbol.for("react.suspense"), $c150b5eed0e0c337$var$n = Symbol.for("react.suspense_list"), $c150b5eed0e0c337$var$p = Symbol.for("react.memo"), $c150b5eed0e0c337$var$q = Symbol.for("react.lazy"), $c150b5eed0e0c337$var$t = Symbol.for("react.offscreen"), $c150b5eed0e0c337$var$u;
$c150b5eed0e0c337$var$u = Symbol.for("react.module.reference");
function $c150b5eed0e0c337$var$v(a) {
    if ("object" === typeof a && null !== a) {
        var r = a.$$typeof;
        switch(r){
            case $c150b5eed0e0c337$var$b:
                switch(a = a.type, a){
                    case $c150b5eed0e0c337$var$d:
                    case $c150b5eed0e0c337$var$f:
                    case $c150b5eed0e0c337$var$e:
                    case $c150b5eed0e0c337$var$m:
                    case $c150b5eed0e0c337$var$n:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $c150b5eed0e0c337$var$k:
                            case $c150b5eed0e0c337$var$h:
                            case $c150b5eed0e0c337$var$l:
                            case $c150b5eed0e0c337$var$q:
                            case $c150b5eed0e0c337$var$p:
                            case $c150b5eed0e0c337$var$g:
                                return a;
                            default:
                                return r;
                        }
                }
            case $c150b5eed0e0c337$var$c:
                return r;
        }
    }
}
$c150b5eed0e0c337$export$a7c73072b1a182ae = $c150b5eed0e0c337$var$h;
$c150b5eed0e0c337$export$9f27bc3417b4524d = $c150b5eed0e0c337$var$g;
$c150b5eed0e0c337$export$db77ccec0bb4ccac = $c150b5eed0e0c337$var$b;
$c150b5eed0e0c337$export$8392c0c9d3dcbd35 = $c150b5eed0e0c337$var$l;
$c150b5eed0e0c337$export$ffb0004e005737fa = $c150b5eed0e0c337$var$d;
$c150b5eed0e0c337$export$b624eff549462981 = $c150b5eed0e0c337$var$q;
$c150b5eed0e0c337$export$7897aa7841a5380c = $c150b5eed0e0c337$var$p;
$c150b5eed0e0c337$export$602eac185826482c = $c150b5eed0e0c337$var$c;
$c150b5eed0e0c337$export$e2c29f18771995cb = $c150b5eed0e0c337$var$f;
$c150b5eed0e0c337$export$5f8d39834fd61797 = $c150b5eed0e0c337$var$e;
$c150b5eed0e0c337$export$74bf444e3cd11ea5 = $c150b5eed0e0c337$var$m;
$c150b5eed0e0c337$export$998bcd577473dd93 = $c150b5eed0e0c337$var$n;
$c150b5eed0e0c337$export$92387174baf9b227 = function() {
    return !1;
};
$c150b5eed0e0c337$export$ec112efeb987d9c6 = function() {
    return !1;
};
$c150b5eed0e0c337$export$b706b080d889d2c9 = function(a) {
    return $c150b5eed0e0c337$var$v(a) === $c150b5eed0e0c337$var$h;
};
$c150b5eed0e0c337$export$5be5a87408f70ddc = function(a) {
    return $c150b5eed0e0c337$var$v(a) === $c150b5eed0e0c337$var$g;
};
$c150b5eed0e0c337$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $c150b5eed0e0c337$var$b;
};
$c150b5eed0e0c337$export$455c2e768291efa6 = function(a) {
    return $c150b5eed0e0c337$var$v(a) === $c150b5eed0e0c337$var$l;
};
$c150b5eed0e0c337$export$9522e17588c12572 = function(a) {
    return $c150b5eed0e0c337$var$v(a) === $c150b5eed0e0c337$var$d;
};
$c150b5eed0e0c337$export$2110ac352bb060b9 = function(a) {
    return $c150b5eed0e0c337$var$v(a) === $c150b5eed0e0c337$var$q;
};
$c150b5eed0e0c337$export$56885ab8b9c456ab = function(a) {
    return $c150b5eed0e0c337$var$v(a) === $c150b5eed0e0c337$var$p;
};
$c150b5eed0e0c337$export$d927fcb6adf8f9de = function(a) {
    return $c150b5eed0e0c337$var$v(a) === $c150b5eed0e0c337$var$c;
};
$c150b5eed0e0c337$export$b82d16f27459e05a = function(a) {
    return $c150b5eed0e0c337$var$v(a) === $c150b5eed0e0c337$var$f;
};
$c150b5eed0e0c337$export$522c17b4f5e123e8 = function(a) {
    return $c150b5eed0e0c337$var$v(a) === $c150b5eed0e0c337$var$e;
};
$c150b5eed0e0c337$export$1aabd8a0274ecfd6 = function(a) {
    return $c150b5eed0e0c337$var$v(a) === $c150b5eed0e0c337$var$m;
};
$c150b5eed0e0c337$export$3d6c20d97e46b957 = function(a) {
    return $c150b5eed0e0c337$var$v(a) === $c150b5eed0e0c337$var$n;
};
$c150b5eed0e0c337$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $c150b5eed0e0c337$var$d || a === $c150b5eed0e0c337$var$f || a === $c150b5eed0e0c337$var$e || a === $c150b5eed0e0c337$var$m || a === $c150b5eed0e0c337$var$n || a === $c150b5eed0e0c337$var$t || "object" === typeof a && null !== a && (a.$$typeof === $c150b5eed0e0c337$var$q || a.$$typeof === $c150b5eed0e0c337$var$p || a.$$typeof === $c150b5eed0e0c337$var$g || a.$$typeof === $c150b5eed0e0c337$var$h || a.$$typeof === $c150b5eed0e0c337$var$l || a.$$typeof === $c150b5eed0e0c337$var$u || void 0 !== a.getModuleId) ? !0 : !1;
};
$c150b5eed0e0c337$export$f5bbd400c2f4426f = $c150b5eed0e0c337$var$v;

});

parcelRegister("cyuoq", function(module, exports) {

$parcel$export(module.exports, "get", function () { return $27f56328017c699e$export$3988ae62b71be9a3; });
$parcel$export(module.exports, "useFormContext", function () { return $27f56328017c699e$export$4d957a5e1be13b03; });
$parcel$export(module.exports, "FormProvider", function () { return $27f56328017c699e$export$8ce1ff4f94d08846; });
$parcel$export(module.exports, "useFormState", function () { return $27f56328017c699e$export$606f11b2eb45ecc6; });
$parcel$export(module.exports, "useWatch", function () { return $27f56328017c699e$export$3c773aa2b84f29e0; });
$parcel$export(module.exports, "set", function () { return $27f56328017c699e$export$adaa4cf7ef1b65be; });
$parcel$export(module.exports, "useController", function () { return $27f56328017c699e$export$e8c786024a2b0a79; });
$parcel$export(module.exports, "Controller", function () { return $27f56328017c699e$export$bd0bf19f25da8474; });
$parcel$export(module.exports, "Form", function () { return $27f56328017c699e$export$a7fed597f4b8afd8; });
$parcel$export(module.exports, "appendErrors", function () { return $27f56328017c699e$export$b196c2a4f765bd30; });
$parcel$export(module.exports, "useFieldArray", function () { return $27f56328017c699e$export$310131896651d559; });
$parcel$export(module.exports, "useForm", function () { return $27f56328017c699e$export$87c0cf8eb5a167e0; });

var $b6HlZ = parcelRequire("b6HlZ");
var $27f56328017c699e$var$isCheckBoxInput = (element)=>element.type === "checkbox";
var $27f56328017c699e$var$isDateObject = (value1)=>value1 instanceof Date;
var $27f56328017c699e$var$isNullOrUndefined = (value1)=>value1 == null;
const $27f56328017c699e$var$isObjectType = (value1)=>typeof value1 === "object";
var $27f56328017c699e$var$isObject = (value1)=>!$27f56328017c699e$var$isNullOrUndefined(value1) && !Array.isArray(value1) && $27f56328017c699e$var$isObjectType(value1) && !$27f56328017c699e$var$isDateObject(value1);
var $27f56328017c699e$var$getEventValue = (event)=>$27f56328017c699e$var$isObject(event) && event.target ? $27f56328017c699e$var$isCheckBoxInput(event.target) ? event.target.checked : event.target.value : event;
var $27f56328017c699e$var$getNodeParentName = (name)=>name.substring(0, name.search(/\.\d+(\.|$)/)) || name;
var $27f56328017c699e$var$isNameInFieldArray = (names, name)=>names.has($27f56328017c699e$var$getNodeParentName(name));
var $27f56328017c699e$var$isPlainObject = (tempObject)=>{
    const prototypeCopy = tempObject.constructor && tempObject.constructor.prototype;
    return $27f56328017c699e$var$isObject(prototypeCopy) && prototypeCopy.hasOwnProperty("isPrototypeOf");
};
var $27f56328017c699e$var$isWeb = typeof window !== "undefined" && typeof window.HTMLElement !== "undefined" && typeof document !== "undefined";
function $27f56328017c699e$var$cloneObject(data) {
    let copy;
    const isArray = Array.isArray(data);
    if (data instanceof Date) copy = new Date(data);
    else if (data instanceof Set) copy = new Set(data);
    else if (!($27f56328017c699e$var$isWeb && (data instanceof Blob || data instanceof FileList)) && (isArray || $27f56328017c699e$var$isObject(data))) {
        copy = isArray ? [] : {};
        if (!isArray && !$27f56328017c699e$var$isPlainObject(data)) copy = data;
        else {
            for(const key in data)if (data.hasOwnProperty(key)) copy[key] = $27f56328017c699e$var$cloneObject(data[key]);
        }
    } else return data;
    return copy;
}
var $27f56328017c699e$var$compact = (value1)=>Array.isArray(value1) ? value1.filter(Boolean) : [];
var $27f56328017c699e$var$isUndefined = (val)=>val === undefined;
var $27f56328017c699e$export$3988ae62b71be9a3 = (object, path, defaultValue)=>{
    if (!path || !$27f56328017c699e$var$isObject(object)) return defaultValue;
    const result = $27f56328017c699e$var$compact(path.split(/[,[\].]+?/)).reduce((result, key)=>$27f56328017c699e$var$isNullOrUndefined(result) ? result : result[key], object);
    return $27f56328017c699e$var$isUndefined(result) || result === object ? $27f56328017c699e$var$isUndefined(object[path]) ? defaultValue : object[path] : result;
};
var $27f56328017c699e$var$isBoolean = (value1)=>typeof value1 === "boolean";
const $27f56328017c699e$var$EVENTS = {
    BLUR: "blur",
    FOCUS_OUT: "focusout",
    CHANGE: "change"
};
const $27f56328017c699e$var$VALIDATION_MODE = {
    onBlur: "onBlur",
    onChange: "onChange",
    onSubmit: "onSubmit",
    onTouched: "onTouched",
    all: "all"
};
const $27f56328017c699e$var$INPUT_VALIDATION_RULES = {
    max: "max",
    min: "min",
    maxLength: "maxLength",
    minLength: "minLength",
    pattern: "pattern",
    required: "required",
    validate: "validate"
};
const $27f56328017c699e$var$HookFormContext = (0, (/*@__PURE__*/$parcel$interopDefault($b6HlZ))).createContext(null);
/**
 * This custom hook allows you to access the form context. useFormContext is intended to be used in deeply nested structures, where it would become inconvenient to pass the context as a prop. To be used with {@link FormProvider}.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformcontext) • [Demo](https://codesandbox.io/s/react-hook-form-v7-form-context-ytudi)
 *
 * @returns return all useForm methods
 *
 * @example
 * ```tsx
 * function App() {
 *   const methods = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   return (
 *     <FormProvider {...methods} >
 *       <form onSubmit={methods.handleSubmit(onSubmit)}>
 *         <NestedInput />
 *         <input type="submit" />
 *       </form>
 *     </FormProvider>
 *   );
 * }
 *
 *  function NestedInput() {
 *   const { register } = useFormContext(); // retrieve all hook methods
 *   return <input {...register("test")} />;
 * }
 * ```
 */ const $27f56328017c699e$export$4d957a5e1be13b03 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($b6HlZ))).useContext($27f56328017c699e$var$HookFormContext);
/**
 * A provider component that propagates the `useForm` methods to all children components via [React Context](https://reactjs.org/docs/context.html) API. To be used with {@link useFormContext}.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformcontext) • [Demo](https://codesandbox.io/s/react-hook-form-v7-form-context-ytudi)
 *
 * @param props - all useForm methods
 *
 * @example
 * ```tsx
 * function App() {
 *   const methods = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   return (
 *     <FormProvider {...methods} >
 *       <form onSubmit={methods.handleSubmit(onSubmit)}>
 *         <NestedInput />
 *         <input type="submit" />
 *       </form>
 *     </FormProvider>
 *   );
 * }
 *
 *  function NestedInput() {
 *   const { register } = useFormContext(); // retrieve all hook methods
 *   return <input {...register("test")} />;
 * }
 * ```
 */ const $27f56328017c699e$export$8ce1ff4f94d08846 = (props)=>{
    const { children: children, ...data } = props;
    return (0, (/*@__PURE__*/$parcel$interopDefault($b6HlZ))).createElement($27f56328017c699e$var$HookFormContext.Provider, {
        value: data
    }, children);
};
var $27f56328017c699e$var$getProxyFormState = (formState, control, localProxyFormState, isRoot = true)=>{
    const result = {
        defaultValues: control._defaultValues
    };
    for(const key in formState)Object.defineProperty(result, key, {
        get: ()=>{
            const _key = key;
            if (control._proxyFormState[_key] !== $27f56328017c699e$var$VALIDATION_MODE.all) control._proxyFormState[_key] = !isRoot || $27f56328017c699e$var$VALIDATION_MODE.all;
            localProxyFormState && (localProxyFormState[_key] = true);
            return formState[_key];
        }
    });
    return result;
};
var $27f56328017c699e$var$isEmptyObject = (value1)=>$27f56328017c699e$var$isObject(value1) && !Object.keys(value1).length;
var $27f56328017c699e$var$shouldRenderFormState = (formStateData, _proxyFormState, updateFormState, isRoot)=>{
    updateFormState(formStateData);
    const { name: name, ...formState } = formStateData;
    return $27f56328017c699e$var$isEmptyObject(formState) || Object.keys(formState).length >= Object.keys(_proxyFormState).length || Object.keys(formState).find((key)=>_proxyFormState[key] === (!isRoot || $27f56328017c699e$var$VALIDATION_MODE.all));
};
var $27f56328017c699e$var$convertToArrayPayload = (value1)=>Array.isArray(value1) ? value1 : [
        value1
    ];
var $27f56328017c699e$var$shouldSubscribeByName = (name, signalName, exact)=>!name || !signalName || name === signalName || $27f56328017c699e$var$convertToArrayPayload(name).some((currentName)=>currentName && (exact ? currentName === signalName : currentName.startsWith(signalName) || signalName.startsWith(currentName)));
function $27f56328017c699e$var$useSubscribe(props) {
    const _props = (0, (/*@__PURE__*/$parcel$interopDefault($b6HlZ))).useRef(props);
    _props.current = props;
    (0, (/*@__PURE__*/$parcel$interopDefault($b6HlZ))).useEffect(()=>{
        const subscription = !props.disabled && _props.current.subject && _props.current.subject.subscribe({
            next: _props.current.next
        });
        return ()=>{
            subscription && subscription.unsubscribe();
        };
    }, [
        props.disabled
    ]);
}
/**
 * This custom hook allows you to subscribe to each form state, and isolate the re-render at the custom hook level. It has its scope in terms of form state subscription, so it would not affect other useFormState and useForm. Using this hook can reduce the re-render impact on large and complex form application.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformstate) • [Demo](https://codesandbox.io/s/useformstate-75xly)
 *
 * @param props - include options on specify fields to subscribe. {@link UseFormStateReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, handleSubmit, control } = useForm({
 *     defaultValues: {
 *     firstName: "firstName"
 *   }});
 *   const { dirtyFields } = useFormState({
 *     control
 *   });
 *   const onSubmit = (data) => console.log(data);
 *
 *   return (
 *     <form onSubmit={handleSubmit(onSubmit)}>
 *       <input {...register("firstName")} placeholder="First Name" />
 *       {dirtyFields.firstName && <p>Field is dirty.</p>}
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */ function $27f56328017c699e$export$606f11b2eb45ecc6(props) {
    const methods = $27f56328017c699e$export$4d957a5e1be13b03();
    const { control: control = methods.control, disabled: disabled, name: name, exact: exact } = props || {};
    const [formState, updateFormState] = (0, (/*@__PURE__*/$parcel$interopDefault($b6HlZ))).useState(control._formState);
    const _mounted = (0, (/*@__PURE__*/$parcel$interopDefault($b6HlZ))).useRef(true);
    const _localProxyFormState = (0, (/*@__PURE__*/$parcel$interopDefault($b6HlZ))).useRef({
        isDirty: false,
        isLoading: false,
        dirtyFields: false,
        touchedFields: false,
        isValidating: false,
        isValid: false,
        errors: false
    });
    const _name = (0, (/*@__PURE__*/$parcel$interopDefault($b6HlZ))).useRef(name);
    _name.current = name;
    $27f56328017c699e$var$useSubscribe({
        disabled: disabled,
        next: (value1)=>_mounted.current && $27f56328017c699e$var$shouldSubscribeByName(_name.current, value1.name, exact) && $27f56328017c699e$var$shouldRenderFormState(value1, _localProxyFormState.current, control._updateFormState) && updateFormState({
                ...control._formState,
                ...value1
            }),
        subject: control._subjects.state
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($b6HlZ))).useEffect(()=>{
        _mounted.current = true;
        _localProxyFormState.current.isValid && control._updateValid(true);
        return ()=>{
            _mounted.current = false;
        };
    }, [
        control
    ]);
    return $27f56328017c699e$var$getProxyFormState(formState, control, _localProxyFormState.current, false);
}
var $27f56328017c699e$var$isString = (value1)=>typeof value1 === "string";
var $27f56328017c699e$var$generateWatchOutput = (names, _names, formValues, isGlobal, defaultValue)=>{
    if ($27f56328017c699e$var$isString(names)) {
        isGlobal && _names.watch.add(names);
        return $27f56328017c699e$export$3988ae62b71be9a3(formValues, names, defaultValue);
    }
    if (Array.isArray(names)) return names.map((fieldName)=>(isGlobal && _names.watch.add(fieldName), $27f56328017c699e$export$3988ae62b71be9a3(formValues, fieldName)));
    isGlobal && (_names.watchAll = true);
    return formValues;
};
/**
 * Custom hook to subscribe to field change and isolate re-rendering at the component level.
 *
 * @remarks
 *
 * [API](https://react-hook-form.com/docs/usewatch) • [Demo](https://codesandbox.io/s/react-hook-form-v7-ts-usewatch-h9i5e)
 *
 * @example
 * ```tsx
 * const { control } = useForm();
 * const values = useWatch({
 *   name: "fieldName"
 *   control,
 * })
 * ```
 */ function $27f56328017c699e$export$3c773aa2b84f29e0(props) {
    const methods = $27f56328017c699e$export$4d957a5e1be13b03();
    const { control: control = methods.control, name: name, defaultValue: defaultValue, disabled: disabled, exact: exact } = props || {};
    const _name = (0, (/*@__PURE__*/$parcel$interopDefault($b6HlZ))).useRef(name);
    _name.current = name;
    $27f56328017c699e$var$useSubscribe({
        disabled: disabled,
        subject: control._subjects.values,
        next: (formState)=>{
            if ($27f56328017c699e$var$shouldSubscribeByName(_name.current, formState.name, exact)) updateValue($27f56328017c699e$var$cloneObject($27f56328017c699e$var$generateWatchOutput(_name.current, control._names, formState.values || control._formValues, false, defaultValue)));
        }
    });
    const [value1, updateValue] = (0, (/*@__PURE__*/$parcel$interopDefault($b6HlZ))).useState(control._getWatch(name, defaultValue));
    (0, (/*@__PURE__*/$parcel$interopDefault($b6HlZ))).useEffect(()=>control._removeUnmounted());
    return value1;
}
var $27f56328017c699e$var$isKey = (value1)=>/^\w*$/.test(value1);
var $27f56328017c699e$var$stringToPath = (input)=>$27f56328017c699e$var$compact(input.replace(/["|']|\]/g, "").split(/\.|\[/));
var $27f56328017c699e$export$adaa4cf7ef1b65be = (object, path, value1)=>{
    let index = -1;
    const tempPath = $27f56328017c699e$var$isKey(path) ? [
        path
    ] : $27f56328017c699e$var$stringToPath(path);
    const length = tempPath.length;
    const lastIndex = length - 1;
    while(++index < length){
        const key = tempPath[index];
        let newValue = value1;
        if (index !== lastIndex) {
            const objValue = object[key];
            newValue = $27f56328017c699e$var$isObject(objValue) || Array.isArray(objValue) ? objValue : !isNaN(+tempPath[index + 1]) ? [] : {};
        }
        object[key] = newValue;
        object = object[key];
    }
    return object;
};
/**
 * Custom hook to work with controlled component, this function provide you with both form and field level state. Re-render is isolated at the hook level.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usecontroller) • [Demo](https://codesandbox.io/s/usecontroller-0o8px)
 *
 * @param props - the path name to the form field value, and validation rules.
 *
 * @returns field properties, field and form state. {@link UseControllerReturn}
 *
 * @example
 * ```tsx
 * function Input(props) {
 *   const { field, fieldState, formState } = useController(props);
 *   return (
 *     <div>
 *       <input {...field} placeholder={props.name} />
 *       <p>{fieldState.isTouched && "Touched"}</p>
 *       <p>{formState.isSubmitted ? "submitted" : ""}</p>
 *     </div>
 *   );
 * }
 * ```
 */ function $27f56328017c699e$export$e8c786024a2b0a79(props) {
    const methods = $27f56328017c699e$export$4d957a5e1be13b03();
    const { name: name, disabled: disabled, control: control = methods.control, shouldUnregister: shouldUnregister } = props;
    const isArrayField = $27f56328017c699e$var$isNameInFieldArray(control._names.array, name);
    const value1 = $27f56328017c699e$export$3c773aa2b84f29e0({
        control: control,
        name: name,
        defaultValue: $27f56328017c699e$export$3988ae62b71be9a3(control._formValues, name, $27f56328017c699e$export$3988ae62b71be9a3(control._defaultValues, name, props.defaultValue)),
        exact: true
    });
    const formState = $27f56328017c699e$export$606f11b2eb45ecc6({
        control: control,
        name: name
    });
    const _registerProps = (0, (/*@__PURE__*/$parcel$interopDefault($b6HlZ))).useRef(control.register(name, {
        ...props.rules,
        value: value1,
        ...$27f56328017c699e$var$isBoolean(props.disabled) ? {
            disabled: props.disabled
        } : {}
    }));
    (0, (/*@__PURE__*/$parcel$interopDefault($b6HlZ))).useEffect(()=>{
        const _shouldUnregisterField = control._options.shouldUnregister || shouldUnregister;
        const updateMounted = (name, value1)=>{
            const field = $27f56328017c699e$export$3988ae62b71be9a3(control._fields, name);
            if (field) field._f.mount = value1;
        };
        updateMounted(name, true);
        if (_shouldUnregisterField) {
            const value1 = $27f56328017c699e$var$cloneObject($27f56328017c699e$export$3988ae62b71be9a3(control._options.defaultValues, name));
            $27f56328017c699e$export$adaa4cf7ef1b65be(control._defaultValues, name, value1);
            if ($27f56328017c699e$var$isUndefined($27f56328017c699e$export$3988ae62b71be9a3(control._formValues, name))) $27f56328017c699e$export$adaa4cf7ef1b65be(control._formValues, name, value1);
        }
        return ()=>{
            (isArrayField ? _shouldUnregisterField && !control._state.action : _shouldUnregisterField) ? control.unregister(name) : updateMounted(name, false);
        };
    }, [
        name,
        control,
        isArrayField,
        shouldUnregister
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($b6HlZ))).useEffect(()=>{
        if ($27f56328017c699e$export$3988ae62b71be9a3(control._fields, name)) control._updateDisabledField({
            disabled: disabled,
            fields: control._fields,
            name: name,
            value: $27f56328017c699e$export$3988ae62b71be9a3(control._fields, name)._f.value
        });
    }, [
        disabled,
        name,
        control
    ]);
    return {
        field: {
            name: name,
            value: value1,
            ...$27f56328017c699e$var$isBoolean(disabled) || $27f56328017c699e$var$isBoolean(formState.disabled) ? {
                disabled: formState.disabled || disabled
            } : {},
            onChange: (0, (/*@__PURE__*/$parcel$interopDefault($b6HlZ))).useCallback((event)=>_registerProps.current.onChange({
                    target: {
                        value: $27f56328017c699e$var$getEventValue(event),
                        name: name
                    },
                    type: $27f56328017c699e$var$EVENTS.CHANGE
                }), [
                name
            ]),
            onBlur: (0, (/*@__PURE__*/$parcel$interopDefault($b6HlZ))).useCallback(()=>_registerProps.current.onBlur({
                    target: {
                        value: $27f56328017c699e$export$3988ae62b71be9a3(control._formValues, name),
                        name: name
                    },
                    type: $27f56328017c699e$var$EVENTS.BLUR
                }), [
                name,
                control
            ]),
            ref: (elm)=>{
                const field = $27f56328017c699e$export$3988ae62b71be9a3(control._fields, name);
                if (field && elm) field._f.ref = {
                    focus: ()=>elm.focus(),
                    select: ()=>elm.select(),
                    setCustomValidity: (message)=>elm.setCustomValidity(message),
                    reportValidity: ()=>elm.reportValidity()
                };
            }
        },
        formState: formState,
        fieldState: Object.defineProperties({}, {
            invalid: {
                enumerable: true,
                get: ()=>!!$27f56328017c699e$export$3988ae62b71be9a3(formState.errors, name)
            },
            isDirty: {
                enumerable: true,
                get: ()=>!!$27f56328017c699e$export$3988ae62b71be9a3(formState.dirtyFields, name)
            },
            isTouched: {
                enumerable: true,
                get: ()=>!!$27f56328017c699e$export$3988ae62b71be9a3(formState.touchedFields, name)
            },
            error: {
                enumerable: true,
                get: ()=>$27f56328017c699e$export$3988ae62b71be9a3(formState.errors, name)
            }
        })
    };
}
/**
 * Component based on `useController` hook to work with controlled component.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usecontroller/controller) • [Demo](https://codesandbox.io/s/react-hook-form-v6-controller-ts-jwyzw) • [Video](https://www.youtube.com/watch?v=N2UNk_UCVyA)
 *
 * @param props - the path name to the form field value, and validation rules.
 *
 * @returns provide field handler functions, field and form state.
 *
 * @example
 * ```tsx
 * function App() {
 *   const { control } = useForm<FormValues>({
 *     defaultValues: {
 *       test: ""
 *     }
 *   });
 *
 *   return (
 *     <form>
 *       <Controller
 *         control={control}
 *         name="test"
 *         render={({ field: { onChange, onBlur, value, ref }, formState, fieldState }) => (
 *           <>
 *             <input
 *               onChange={onChange} // send value to hook form
 *               onBlur={onBlur} // notify when input is touched
 *               value={value} // return updated value
 *               ref={ref} // set ref for focus management
 *             />
 *             <p>{formState.isSubmitted ? "submitted" : ""}</p>
 *             <p>{fieldState.isTouched ? "touched" : ""}</p>
 *           </>
 *         )}
 *       />
 *     </form>
 *   );
 * }
 * ```
 */ const $27f56328017c699e$export$bd0bf19f25da8474 = (props)=>props.render($27f56328017c699e$export$e8c786024a2b0a79(props));
const $27f56328017c699e$var$POST_REQUEST = "post";
/**
 * Form component to manage submission.
 *
 * @param props - to setup submission detail. {@link FormProps}
 *
 * @returns form component or headless render prop.
 *
 * @example
 * ```tsx
 * function App() {
 *   const { control, formState: { errors } } = useForm();
 *
 *   return (
 *     <Form action="/api" control={control}>
 *       <input {...register("name")} />
 *       <p>{errors?.root?.server && 'Server error'}</p>
 *       <button>Submit</button>
 *     </Form>
 *   );
 * }
 * ```
 */ function $27f56328017c699e$export$a7fed597f4b8afd8(props) {
    const methods = $27f56328017c699e$export$4d957a5e1be13b03();
    const [mounted, setMounted] = (0, (/*@__PURE__*/$parcel$interopDefault($b6HlZ))).useState(false);
    const { control: control = methods.control, onSubmit: onSubmit, children: children, action: action, method: method = $27f56328017c699e$var$POST_REQUEST, headers: headers, encType: encType, onError: onError, render: render, onSuccess: onSuccess, validateStatus: validateStatus, ...rest } = props;
    const submit = async (event)=>{
        let hasError = false;
        let type = "";
        await control.handleSubmit(async (data)=>{
            const formData = new FormData();
            let formDataJson = "";
            try {
                formDataJson = JSON.stringify(data);
            } catch (_a) {}
            for (const name of control._names.mount)formData.append(name, $27f56328017c699e$export$3988ae62b71be9a3(data, name));
            if (onSubmit) await onSubmit({
                data: data,
                event: event,
                method: method,
                formData: formData,
                formDataJson: formDataJson
            });
            if (action) try {
                const shouldStringifySubmissionData = [
                    headers && headers["Content-Type"],
                    encType
                ].some((value1)=>value1 && value1.includes("json"));
                const response = await fetch(action, {
                    method: method,
                    headers: {
                        ...headers,
                        ...encType ? {
                            "Content-Type": encType
                        } : {}
                    },
                    body: shouldStringifySubmissionData ? formDataJson : formData
                });
                if (response && (validateStatus ? !validateStatus(response.status) : response.status < 200 || response.status >= 300)) {
                    hasError = true;
                    onError && onError({
                        response: response
                    });
                    type = String(response.status);
                } else onSuccess && onSuccess({
                    response: response
                });
            } catch (error) {
                hasError = true;
                onError && onError({
                    error: error
                });
            }
        })(event);
        if (hasError && props.control) {
            props.control._subjects.state.next({
                isSubmitSuccessful: false
            });
            props.control.setError("root.server", {
                type: type
            });
        }
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($b6HlZ))).useEffect(()=>{
        setMounted(true);
    }, []);
    return render ? (0, (/*@__PURE__*/$parcel$interopDefault($b6HlZ))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($b6HlZ))).Fragment, null, render({
        submit: submit
    })) : (0, (/*@__PURE__*/$parcel$interopDefault($b6HlZ))).createElement("form", {
        noValidate: mounted,
        action: action,
        method: method,
        encType: encType,
        onSubmit: submit,
        ...rest
    }, children);
}
var $27f56328017c699e$export$b196c2a4f765bd30 = (name, validateAllFieldCriteria, errors, type, message)=>validateAllFieldCriteria ? {
        ...errors[name],
        types: {
            ...errors[name] && errors[name].types ? errors[name].types : {},
            [type]: message || true
        }
    } : {};
var $27f56328017c699e$var$generateId = ()=>{
    const d = typeof performance === "undefined" ? Date.now() : performance.now() * 1000;
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c)=>{
        const r = (Math.random() * 16 + d) % 16 | 0;
        return (c == "x" ? r : r & 0x3 | 0x8).toString(16);
    });
};
var $27f56328017c699e$var$getFocusFieldName = (name, index, options = {})=>options.shouldFocus || $27f56328017c699e$var$isUndefined(options.shouldFocus) ? options.focusName || `${name}.${$27f56328017c699e$var$isUndefined(options.focusIndex) ? index : options.focusIndex}.` : "";
var $27f56328017c699e$var$getValidationModes = (mode)=>({
        isOnSubmit: !mode || mode === $27f56328017c699e$var$VALIDATION_MODE.onSubmit,
        isOnBlur: mode === $27f56328017c699e$var$VALIDATION_MODE.onBlur,
        isOnChange: mode === $27f56328017c699e$var$VALIDATION_MODE.onChange,
        isOnAll: mode === $27f56328017c699e$var$VALIDATION_MODE.all,
        isOnTouch: mode === $27f56328017c699e$var$VALIDATION_MODE.onTouched
    });
var $27f56328017c699e$var$isWatched = (name, _names, isBlurEvent)=>!isBlurEvent && (_names.watchAll || _names.watch.has(name) || [
        ..._names.watch
    ].some((watchName)=>name.startsWith(watchName) && /^\.\w+/.test(name.slice(watchName.length))));
const $27f56328017c699e$var$iterateFieldsByAction = (fields, action, fieldsNames, abortEarly)=>{
    for (const key of fieldsNames || Object.keys(fields)){
        const field = $27f56328017c699e$export$3988ae62b71be9a3(fields, key);
        if (field) {
            const { _f: _f, ...currentField } = field;
            if (_f) {
                if (_f.refs && _f.refs[0] && action(_f.refs[0], key) && !abortEarly) break;
                else if (_f.ref && action(_f.ref, _f.name) && !abortEarly) break;
                else $27f56328017c699e$var$iterateFieldsByAction(currentField, action);
            } else if ($27f56328017c699e$var$isObject(currentField)) $27f56328017c699e$var$iterateFieldsByAction(currentField, action);
        }
    }
};
var $27f56328017c699e$var$updateFieldArrayRootError = (errors, error, name)=>{
    const fieldArrayErrors = $27f56328017c699e$var$compact($27f56328017c699e$export$3988ae62b71be9a3(errors, name));
    $27f56328017c699e$export$adaa4cf7ef1b65be(fieldArrayErrors, "root", error[name]);
    $27f56328017c699e$export$adaa4cf7ef1b65be(errors, name, fieldArrayErrors);
    return errors;
};
var $27f56328017c699e$var$isFileInput = (element)=>element.type === "file";
var $27f56328017c699e$var$isFunction = (value1)=>typeof value1 === "function";
var $27f56328017c699e$var$isHTMLElement = (value1)=>{
    if (!$27f56328017c699e$var$isWeb) return false;
    const owner = value1 ? value1.ownerDocument : 0;
    return value1 instanceof (owner && owner.defaultView ? owner.defaultView.HTMLElement : HTMLElement);
};
var $27f56328017c699e$var$isMessage = (value1)=>$27f56328017c699e$var$isString(value1);
var $27f56328017c699e$var$isRadioInput = (element)=>element.type === "radio";
var $27f56328017c699e$var$isRegex = (value1)=>value1 instanceof RegExp;
const $27f56328017c699e$var$defaultResult = {
    value: false,
    isValid: false
};
const $27f56328017c699e$var$validResult = {
    value: true,
    isValid: true
};
var $27f56328017c699e$var$getCheckboxValue = (options)=>{
    if (Array.isArray(options)) {
        if (options.length > 1) {
            const values = options.filter((option)=>option && option.checked && !option.disabled).map((option)=>option.value);
            return {
                value: values,
                isValid: !!values.length
            };
        }
        return options[0].checked && !options[0].disabled ? options[0].attributes && !$27f56328017c699e$var$isUndefined(options[0].attributes.value) ? $27f56328017c699e$var$isUndefined(options[0].value) || options[0].value === "" ? $27f56328017c699e$var$validResult : {
            value: options[0].value,
            isValid: true
        } : $27f56328017c699e$var$validResult : $27f56328017c699e$var$defaultResult;
    }
    return $27f56328017c699e$var$defaultResult;
};
const $27f56328017c699e$var$defaultReturn = {
    isValid: false,
    value: null
};
var $27f56328017c699e$var$getRadioValue = (options)=>Array.isArray(options) ? options.reduce((previous, option)=>option && option.checked && !option.disabled ? {
            isValid: true,
            value: option.value
        } : previous, $27f56328017c699e$var$defaultReturn) : $27f56328017c699e$var$defaultReturn;
function $27f56328017c699e$var$getValidateError(result, ref, type = "validate") {
    if ($27f56328017c699e$var$isMessage(result) || Array.isArray(result) && result.every($27f56328017c699e$var$isMessage) || $27f56328017c699e$var$isBoolean(result) && !result) return {
        type: type,
        message: $27f56328017c699e$var$isMessage(result) ? result : "",
        ref: ref
    };
}
var $27f56328017c699e$var$getValueAndMessage = (validationData)=>$27f56328017c699e$var$isObject(validationData) && !$27f56328017c699e$var$isRegex(validationData) ? validationData : {
        value: validationData,
        message: ""
    };
var $27f56328017c699e$var$validateField = async (field, formValues, validateAllFieldCriteria, shouldUseNativeValidation, isFieldArray)=>{
    const { ref: ref, refs: refs, required: required, maxLength: maxLength, minLength: minLength, min: min, max: max, pattern: pattern, validate: validate, name: name, valueAsNumber: valueAsNumber, mount: mount, disabled: disabled } = field._f;
    const inputValue = $27f56328017c699e$export$3988ae62b71be9a3(formValues, name);
    if (!mount || disabled) return {};
    const inputRef = refs ? refs[0] : ref;
    const setCustomValidity = (message)=>{
        if (shouldUseNativeValidation && inputRef.reportValidity) {
            inputRef.setCustomValidity($27f56328017c699e$var$isBoolean(message) ? "" : message || "");
            inputRef.reportValidity();
        }
    };
    const error = {};
    const isRadio = $27f56328017c699e$var$isRadioInput(ref);
    const isCheckBox = $27f56328017c699e$var$isCheckBoxInput(ref);
    const isRadioOrCheckbox = isRadio || isCheckBox;
    const isEmpty = (valueAsNumber || $27f56328017c699e$var$isFileInput(ref)) && $27f56328017c699e$var$isUndefined(ref.value) && $27f56328017c699e$var$isUndefined(inputValue) || $27f56328017c699e$var$isHTMLElement(ref) && ref.value === "" || inputValue === "" || Array.isArray(inputValue) && !inputValue.length;
    const appendErrorsCurry = $27f56328017c699e$export$b196c2a4f765bd30.bind(null, name, validateAllFieldCriteria, error);
    const getMinMaxMessage = (exceedMax, maxLengthMessage, minLengthMessage, maxType = $27f56328017c699e$var$INPUT_VALIDATION_RULES.maxLength, minType = $27f56328017c699e$var$INPUT_VALIDATION_RULES.minLength)=>{
        const message = exceedMax ? maxLengthMessage : minLengthMessage;
        error[name] = {
            type: exceedMax ? maxType : minType,
            message: message,
            ref: ref,
            ...appendErrorsCurry(exceedMax ? maxType : minType, message)
        };
    };
    if (isFieldArray ? !Array.isArray(inputValue) || !inputValue.length : required && (!isRadioOrCheckbox && (isEmpty || $27f56328017c699e$var$isNullOrUndefined(inputValue)) || $27f56328017c699e$var$isBoolean(inputValue) && !inputValue || isCheckBox && !$27f56328017c699e$var$getCheckboxValue(refs).isValid || isRadio && !$27f56328017c699e$var$getRadioValue(refs).isValid)) {
        const { value: value1, message: message } = $27f56328017c699e$var$isMessage(required) ? {
            value: !!required,
            message: required
        } : $27f56328017c699e$var$getValueAndMessage(required);
        if (value1) {
            error[name] = {
                type: $27f56328017c699e$var$INPUT_VALIDATION_RULES.required,
                message: message,
                ref: inputRef,
                ...appendErrorsCurry($27f56328017c699e$var$INPUT_VALIDATION_RULES.required, message)
            };
            if (!validateAllFieldCriteria) {
                setCustomValidity(message);
                return error;
            }
        }
    }
    if (!isEmpty && (!$27f56328017c699e$var$isNullOrUndefined(min) || !$27f56328017c699e$var$isNullOrUndefined(max))) {
        let exceedMax;
        let exceedMin;
        const maxOutput = $27f56328017c699e$var$getValueAndMessage(max);
        const minOutput = $27f56328017c699e$var$getValueAndMessage(min);
        if (!$27f56328017c699e$var$isNullOrUndefined(inputValue) && !isNaN(inputValue)) {
            const valueNumber = ref.valueAsNumber || (inputValue ? +inputValue : inputValue);
            if (!$27f56328017c699e$var$isNullOrUndefined(maxOutput.value)) exceedMax = valueNumber > maxOutput.value;
            if (!$27f56328017c699e$var$isNullOrUndefined(minOutput.value)) exceedMin = valueNumber < minOutput.value;
        } else {
            const valueDate = ref.valueAsDate || new Date(inputValue);
            const convertTimeToDate = (time)=>new Date(new Date().toDateString() + " " + time);
            const isTime = ref.type == "time";
            const isWeek = ref.type == "week";
            if ($27f56328017c699e$var$isString(maxOutput.value) && inputValue) exceedMax = isTime ? convertTimeToDate(inputValue) > convertTimeToDate(maxOutput.value) : isWeek ? inputValue > maxOutput.value : valueDate > new Date(maxOutput.value);
            if ($27f56328017c699e$var$isString(minOutput.value) && inputValue) exceedMin = isTime ? convertTimeToDate(inputValue) < convertTimeToDate(minOutput.value) : isWeek ? inputValue < minOutput.value : valueDate < new Date(minOutput.value);
        }
        if (exceedMax || exceedMin) {
            getMinMaxMessage(!!exceedMax, maxOutput.message, minOutput.message, $27f56328017c699e$var$INPUT_VALIDATION_RULES.max, $27f56328017c699e$var$INPUT_VALIDATION_RULES.min);
            if (!validateAllFieldCriteria) {
                setCustomValidity(error[name].message);
                return error;
            }
        }
    }
    if ((maxLength || minLength) && !isEmpty && ($27f56328017c699e$var$isString(inputValue) || isFieldArray && Array.isArray(inputValue))) {
        const maxLengthOutput = $27f56328017c699e$var$getValueAndMessage(maxLength);
        const minLengthOutput = $27f56328017c699e$var$getValueAndMessage(minLength);
        const exceedMax = !$27f56328017c699e$var$isNullOrUndefined(maxLengthOutput.value) && inputValue.length > +maxLengthOutput.value;
        const exceedMin = !$27f56328017c699e$var$isNullOrUndefined(minLengthOutput.value) && inputValue.length < +minLengthOutput.value;
        if (exceedMax || exceedMin) {
            getMinMaxMessage(exceedMax, maxLengthOutput.message, minLengthOutput.message);
            if (!validateAllFieldCriteria) {
                setCustomValidity(error[name].message);
                return error;
            }
        }
    }
    if (pattern && !isEmpty && $27f56328017c699e$var$isString(inputValue)) {
        const { value: patternValue, message: message } = $27f56328017c699e$var$getValueAndMessage(pattern);
        if ($27f56328017c699e$var$isRegex(patternValue) && !inputValue.match(patternValue)) {
            error[name] = {
                type: $27f56328017c699e$var$INPUT_VALIDATION_RULES.pattern,
                message: message,
                ref: ref,
                ...appendErrorsCurry($27f56328017c699e$var$INPUT_VALIDATION_RULES.pattern, message)
            };
            if (!validateAllFieldCriteria) {
                setCustomValidity(message);
                return error;
            }
        }
    }
    if (validate) {
        if ($27f56328017c699e$var$isFunction(validate)) {
            const result = await validate(inputValue, formValues);
            const validateError = $27f56328017c699e$var$getValidateError(result, inputRef);
            if (validateError) {
                error[name] = {
                    ...validateError,
                    ...appendErrorsCurry($27f56328017c699e$var$INPUT_VALIDATION_RULES.validate, validateError.message)
                };
                if (!validateAllFieldCriteria) {
                    setCustomValidity(validateError.message);
                    return error;
                }
            }
        } else if ($27f56328017c699e$var$isObject(validate)) {
            let validationResult = {};
            for(const key in validate){
                if (!$27f56328017c699e$var$isEmptyObject(validationResult) && !validateAllFieldCriteria) break;
                const validateError = $27f56328017c699e$var$getValidateError(await validate[key](inputValue, formValues), inputRef, key);
                if (validateError) {
                    validationResult = {
                        ...validateError,
                        ...appendErrorsCurry(key, validateError.message)
                    };
                    setCustomValidity(validateError.message);
                    if (validateAllFieldCriteria) error[name] = validationResult;
                }
            }
            if (!$27f56328017c699e$var$isEmptyObject(validationResult)) {
                error[name] = {
                    ref: inputRef,
                    ...validationResult
                };
                if (!validateAllFieldCriteria) return error;
            }
        }
    }
    setCustomValidity(true);
    return error;
};
var $27f56328017c699e$var$appendAt = (data, value1)=>[
        ...data,
        ...$27f56328017c699e$var$convertToArrayPayload(value1)
    ];
var $27f56328017c699e$var$fillEmptyArray = (value1)=>Array.isArray(value1) ? value1.map(()=>undefined) : undefined;
function $27f56328017c699e$var$insert(data, index, value1) {
    return [
        ...data.slice(0, index),
        ...$27f56328017c699e$var$convertToArrayPayload(value1),
        ...data.slice(index)
    ];
}
var $27f56328017c699e$var$moveArrayAt = (data, from, to)=>{
    if (!Array.isArray(data)) return [];
    if ($27f56328017c699e$var$isUndefined(data[to])) data[to] = undefined;
    data.splice(to, 0, data.splice(from, 1)[0]);
    return data;
};
var $27f56328017c699e$var$prependAt = (data, value1)=>[
        ...$27f56328017c699e$var$convertToArrayPayload(value1),
        ...$27f56328017c699e$var$convertToArrayPayload(data)
    ];
function $27f56328017c699e$var$removeAtIndexes(data, indexes) {
    let i = 0;
    const temp = [
        ...data
    ];
    for (const index of indexes){
        temp.splice(index - i, 1);
        i++;
    }
    return $27f56328017c699e$var$compact(temp).length ? temp : [];
}
var $27f56328017c699e$var$removeArrayAt = (data, index)=>$27f56328017c699e$var$isUndefined(index) ? [] : $27f56328017c699e$var$removeAtIndexes(data, $27f56328017c699e$var$convertToArrayPayload(index).sort((a, b)=>a - b));
var $27f56328017c699e$var$swapArrayAt = (data, indexA, indexB)=>{
    [data[indexA], data[indexB]] = [
        data[indexB],
        data[indexA]
    ];
};
function $27f56328017c699e$var$baseGet(object, updatePath) {
    const length = updatePath.slice(0, -1).length;
    let index = 0;
    while(index < length)object = $27f56328017c699e$var$isUndefined(object) ? index++ : object[updatePath[index++]];
    return object;
}
function $27f56328017c699e$var$isEmptyArray(obj) {
    for(const key in obj){
        if (obj.hasOwnProperty(key) && !$27f56328017c699e$var$isUndefined(obj[key])) return false;
    }
    return true;
}
function $27f56328017c699e$var$unset(object, path) {
    const paths = Array.isArray(path) ? path : $27f56328017c699e$var$isKey(path) ? [
        path
    ] : $27f56328017c699e$var$stringToPath(path);
    const childObject = paths.length === 1 ? object : $27f56328017c699e$var$baseGet(object, paths);
    const index = paths.length - 1;
    const key = paths[index];
    if (childObject) delete childObject[key];
    if (index !== 0 && ($27f56328017c699e$var$isObject(childObject) && $27f56328017c699e$var$isEmptyObject(childObject) || Array.isArray(childObject) && $27f56328017c699e$var$isEmptyArray(childObject))) $27f56328017c699e$var$unset(object, paths.slice(0, -1));
    return object;
}
var $27f56328017c699e$var$updateAt = (fieldValues, index, value1)=>{
    fieldValues[index] = value1;
    return fieldValues;
};
/**
 * A custom hook that exposes convenient methods to perform operations with a list of dynamic inputs that need to be appended, updated, removed etc. • [Demo](https://codesandbox.io/s/react-hook-form-usefieldarray-ssugn) • [Video](https://youtu.be/4MrbfGSFY2A)
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usefieldarray) • [Demo](https://codesandbox.io/s/react-hook-form-usefieldarray-ssugn)
 *
 * @param props - useFieldArray props
 *
 * @returns methods - functions to manipulate with the Field Arrays (dynamic inputs) {@link UseFieldArrayReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, control, handleSubmit, reset, trigger, setError } = useForm({
 *     defaultValues: {
 *       test: []
 *     }
 *   });
 *   const { fields, append } = useFieldArray({
 *     control,
 *     name: "test"
 *   });
 *
 *   return (
 *     <form onSubmit={handleSubmit(data => console.log(data))}>
 *       {fields.map((item, index) => (
 *          <input key={item.id} {...register(`test.${index}.firstName`)}  />
 *       ))}
 *       <button type="button" onClick={() => append({ firstName: "bill" })}>
 *         append
 *       </button>
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */ function $27f56328017c699e$export$310131896651d559(props) {
    const methods = $27f56328017c699e$export$4d957a5e1be13b03();
    const { control: control = methods.control, name: name, keyName: keyName = "id", shouldUnregister: shouldUnregister } = props;
    const [fields, setFields] = (0, (/*@__PURE__*/$parcel$interopDefault($b6HlZ))).useState(control._getFieldArray(name));
    const ids = (0, (/*@__PURE__*/$parcel$interopDefault($b6HlZ))).useRef(control._getFieldArray(name).map($27f56328017c699e$var$generateId));
    const _fieldIds = (0, (/*@__PURE__*/$parcel$interopDefault($b6HlZ))).useRef(fields);
    const _name = (0, (/*@__PURE__*/$parcel$interopDefault($b6HlZ))).useRef(name);
    const _actioned = (0, (/*@__PURE__*/$parcel$interopDefault($b6HlZ))).useRef(false);
    _name.current = name;
    _fieldIds.current = fields;
    control._names.array.add(name);
    props.rules && control.register(name, props.rules);
    $27f56328017c699e$var$useSubscribe({
        next: ({ values: values, name: fieldArrayName })=>{
            if (fieldArrayName === _name.current || !fieldArrayName) {
                const fieldValues = $27f56328017c699e$export$3988ae62b71be9a3(values, _name.current);
                if (Array.isArray(fieldValues)) {
                    setFields(fieldValues);
                    ids.current = fieldValues.map($27f56328017c699e$var$generateId);
                }
            }
        },
        subject: control._subjects.array
    });
    const updateValues = (0, (/*@__PURE__*/$parcel$interopDefault($b6HlZ))).useCallback((updatedFieldArrayValues)=>{
        _actioned.current = true;
        control._updateFieldArray(name, updatedFieldArrayValues);
    }, [
        control,
        name
    ]);
    const append = (value1, options)=>{
        const appendValue = $27f56328017c699e$var$convertToArrayPayload($27f56328017c699e$var$cloneObject(value1));
        const updatedFieldArrayValues = $27f56328017c699e$var$appendAt(control._getFieldArray(name), appendValue);
        control._names.focus = $27f56328017c699e$var$getFocusFieldName(name, updatedFieldArrayValues.length - 1, options);
        ids.current = $27f56328017c699e$var$appendAt(ids.current, appendValue.map($27f56328017c699e$var$generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $27f56328017c699e$var$appendAt, {
            argA: $27f56328017c699e$var$fillEmptyArray(value1)
        });
    };
    const prepend = (value1, options)=>{
        const prependValue = $27f56328017c699e$var$convertToArrayPayload($27f56328017c699e$var$cloneObject(value1));
        const updatedFieldArrayValues = $27f56328017c699e$var$prependAt(control._getFieldArray(name), prependValue);
        control._names.focus = $27f56328017c699e$var$getFocusFieldName(name, 0, options);
        ids.current = $27f56328017c699e$var$prependAt(ids.current, prependValue.map($27f56328017c699e$var$generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $27f56328017c699e$var$prependAt, {
            argA: $27f56328017c699e$var$fillEmptyArray(value1)
        });
    };
    const remove = (index)=>{
        const updatedFieldArrayValues = $27f56328017c699e$var$removeArrayAt(control._getFieldArray(name), index);
        ids.current = $27f56328017c699e$var$removeArrayAt(ids.current, index);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $27f56328017c699e$var$removeArrayAt, {
            argA: index
        });
    };
    const insert$1 = (index, value1, options)=>{
        const insertValue = $27f56328017c699e$var$convertToArrayPayload($27f56328017c699e$var$cloneObject(value1));
        const updatedFieldArrayValues = $27f56328017c699e$var$insert(control._getFieldArray(name), index, insertValue);
        control._names.focus = $27f56328017c699e$var$getFocusFieldName(name, index, options);
        ids.current = $27f56328017c699e$var$insert(ids.current, index, insertValue.map($27f56328017c699e$var$generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $27f56328017c699e$var$insert, {
            argA: index,
            argB: $27f56328017c699e$var$fillEmptyArray(value1)
        });
    };
    const swap = (indexA, indexB)=>{
        const updatedFieldArrayValues = control._getFieldArray(name);
        $27f56328017c699e$var$swapArrayAt(updatedFieldArrayValues, indexA, indexB);
        $27f56328017c699e$var$swapArrayAt(ids.current, indexA, indexB);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $27f56328017c699e$var$swapArrayAt, {
            argA: indexA,
            argB: indexB
        }, false);
    };
    const move = (from, to)=>{
        const updatedFieldArrayValues = control._getFieldArray(name);
        $27f56328017c699e$var$moveArrayAt(updatedFieldArrayValues, from, to);
        $27f56328017c699e$var$moveArrayAt(ids.current, from, to);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $27f56328017c699e$var$moveArrayAt, {
            argA: from,
            argB: to
        }, false);
    };
    const update = (index, value1)=>{
        const updateValue = $27f56328017c699e$var$cloneObject(value1);
        const updatedFieldArrayValues = $27f56328017c699e$var$updateAt(control._getFieldArray(name), index, updateValue);
        ids.current = [
            ...updatedFieldArrayValues
        ].map((item, i)=>!item || i === index ? $27f56328017c699e$var$generateId() : ids.current[i]);
        updateValues(updatedFieldArrayValues);
        setFields([
            ...updatedFieldArrayValues
        ]);
        control._updateFieldArray(name, updatedFieldArrayValues, $27f56328017c699e$var$updateAt, {
            argA: index,
            argB: updateValue
        }, true, false);
    };
    const replace = (value1)=>{
        const updatedFieldArrayValues = $27f56328017c699e$var$convertToArrayPayload($27f56328017c699e$var$cloneObject(value1));
        ids.current = updatedFieldArrayValues.map($27f56328017c699e$var$generateId);
        updateValues([
            ...updatedFieldArrayValues
        ]);
        setFields([
            ...updatedFieldArrayValues
        ]);
        control._updateFieldArray(name, [
            ...updatedFieldArrayValues
        ], (data)=>data, {}, true, false);
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($b6HlZ))).useEffect(()=>{
        control._state.action = false;
        $27f56328017c699e$var$isWatched(name, control._names) && control._subjects.state.next({
            ...control._formState
        });
        if (_actioned.current && (!$27f56328017c699e$var$getValidationModes(control._options.mode).isOnSubmit || control._formState.isSubmitted)) {
            if (control._options.resolver) control._executeSchema([
                name
            ]).then((result)=>{
                const error = $27f56328017c699e$export$3988ae62b71be9a3(result.errors, name);
                const existingError = $27f56328017c699e$export$3988ae62b71be9a3(control._formState.errors, name);
                if (existingError ? !error && existingError.type || error && (existingError.type !== error.type || existingError.message !== error.message) : error && error.type) {
                    error ? $27f56328017c699e$export$adaa4cf7ef1b65be(control._formState.errors, name, error) : $27f56328017c699e$var$unset(control._formState.errors, name);
                    control._subjects.state.next({
                        errors: control._formState.errors
                    });
                }
            });
            else {
                const field = $27f56328017c699e$export$3988ae62b71be9a3(control._fields, name);
                if (field && field._f) $27f56328017c699e$var$validateField(field, control._formValues, control._options.criteriaMode === $27f56328017c699e$var$VALIDATION_MODE.all, control._options.shouldUseNativeValidation, true).then((error)=>!$27f56328017c699e$var$isEmptyObject(error) && control._subjects.state.next({
                        errors: $27f56328017c699e$var$updateFieldArrayRootError(control._formState.errors, error, name)
                    }));
            }
        }
        control._subjects.values.next({
            name: name,
            values: {
                ...control._formValues
            }
        });
        control._names.focus && $27f56328017c699e$var$iterateFieldsByAction(control._fields, (ref, key)=>{
            if (control._names.focus && key.startsWith(control._names.focus) && ref.focus) {
                ref.focus();
                return 1;
            }
            return;
        });
        control._names.focus = "";
        control._updateValid();
        _actioned.current = false;
    }, [
        fields,
        name,
        control
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($b6HlZ))).useEffect(()=>{
        !$27f56328017c699e$export$3988ae62b71be9a3(control._formValues, name) && control._updateFieldArray(name);
        return ()=>{
            (control._options.shouldUnregister || shouldUnregister) && control.unregister(name);
        };
    }, [
        name,
        control,
        keyName,
        shouldUnregister
    ]);
    return {
        swap: (0, (/*@__PURE__*/$parcel$interopDefault($b6HlZ))).useCallback(swap, [
            updateValues,
            name,
            control
        ]),
        move: (0, (/*@__PURE__*/$parcel$interopDefault($b6HlZ))).useCallback(move, [
            updateValues,
            name,
            control
        ]),
        prepend: (0, (/*@__PURE__*/$parcel$interopDefault($b6HlZ))).useCallback(prepend, [
            updateValues,
            name,
            control
        ]),
        append: (0, (/*@__PURE__*/$parcel$interopDefault($b6HlZ))).useCallback(append, [
            updateValues,
            name,
            control
        ]),
        remove: (0, (/*@__PURE__*/$parcel$interopDefault($b6HlZ))).useCallback(remove, [
            updateValues,
            name,
            control
        ]),
        insert: (0, (/*@__PURE__*/$parcel$interopDefault($b6HlZ))).useCallback(insert$1, [
            updateValues,
            name,
            control
        ]),
        update: (0, (/*@__PURE__*/$parcel$interopDefault($b6HlZ))).useCallback(update, [
            updateValues,
            name,
            control
        ]),
        replace: (0, (/*@__PURE__*/$parcel$interopDefault($b6HlZ))).useCallback(replace, [
            updateValues,
            name,
            control
        ]),
        fields: (0, (/*@__PURE__*/$parcel$interopDefault($b6HlZ))).useMemo(()=>fields.map((field, index)=>({
                    ...field,
                    [keyName]: ids.current[index] || $27f56328017c699e$var$generateId()
                })), [
            fields,
            keyName
        ])
    };
}
var $27f56328017c699e$var$createSubject = ()=>{
    let _observers = [];
    const next = (value1)=>{
        for (const observer of _observers)observer.next && observer.next(value1);
    };
    const subscribe = (observer)=>{
        _observers.push(observer);
        return {
            unsubscribe: ()=>{
                _observers = _observers.filter((o)=>o !== observer);
            }
        };
    };
    const unsubscribe = ()=>{
        _observers = [];
    };
    return {
        get observers () {
            return _observers;
        },
        next: next,
        subscribe: subscribe,
        unsubscribe: unsubscribe
    };
};
var $27f56328017c699e$var$isPrimitive = (value1)=>$27f56328017c699e$var$isNullOrUndefined(value1) || !$27f56328017c699e$var$isObjectType(value1);
function $27f56328017c699e$var$deepEqual(object1, object2) {
    if ($27f56328017c699e$var$isPrimitive(object1) || $27f56328017c699e$var$isPrimitive(object2)) return object1 === object2;
    if ($27f56328017c699e$var$isDateObject(object1) && $27f56328017c699e$var$isDateObject(object2)) return object1.getTime() === object2.getTime();
    const keys1 = Object.keys(object1);
    const keys2 = Object.keys(object2);
    if (keys1.length !== keys2.length) return false;
    for (const key of keys1){
        const val1 = object1[key];
        if (!keys2.includes(key)) return false;
        if (key !== "ref") {
            const val2 = object2[key];
            if ($27f56328017c699e$var$isDateObject(val1) && $27f56328017c699e$var$isDateObject(val2) || $27f56328017c699e$var$isObject(val1) && $27f56328017c699e$var$isObject(val2) || Array.isArray(val1) && Array.isArray(val2) ? !$27f56328017c699e$var$deepEqual(val1, val2) : val1 !== val2) return false;
        }
    }
    return true;
}
var $27f56328017c699e$var$isMultipleSelect = (element)=>element.type === `select-multiple`;
var $27f56328017c699e$var$isRadioOrCheckbox = (ref)=>$27f56328017c699e$var$isRadioInput(ref) || $27f56328017c699e$var$isCheckBoxInput(ref);
var $27f56328017c699e$var$live = (ref)=>$27f56328017c699e$var$isHTMLElement(ref) && ref.isConnected;
var $27f56328017c699e$var$objectHasFunction = (data)=>{
    for(const key in data){
        if ($27f56328017c699e$var$isFunction(data[key])) return true;
    }
    return false;
};
function $27f56328017c699e$var$markFieldsDirty(data, fields = {}) {
    const isParentNodeArray = Array.isArray(data);
    if ($27f56328017c699e$var$isObject(data) || isParentNodeArray) for(const key in data){
        if (Array.isArray(data[key]) || $27f56328017c699e$var$isObject(data[key]) && !$27f56328017c699e$var$objectHasFunction(data[key])) {
            fields[key] = Array.isArray(data[key]) ? [] : {};
            $27f56328017c699e$var$markFieldsDirty(data[key], fields[key]);
        } else if (!$27f56328017c699e$var$isNullOrUndefined(data[key])) fields[key] = true;
    }
    return fields;
}
function $27f56328017c699e$var$getDirtyFieldsFromDefaultValues(data, formValues, dirtyFieldsFromValues) {
    const isParentNodeArray = Array.isArray(data);
    if ($27f56328017c699e$var$isObject(data) || isParentNodeArray) {
        for(const key in data)if (Array.isArray(data[key]) || $27f56328017c699e$var$isObject(data[key]) && !$27f56328017c699e$var$objectHasFunction(data[key])) {
            if ($27f56328017c699e$var$isUndefined(formValues) || $27f56328017c699e$var$isPrimitive(dirtyFieldsFromValues[key])) dirtyFieldsFromValues[key] = Array.isArray(data[key]) ? $27f56328017c699e$var$markFieldsDirty(data[key], []) : {
                ...$27f56328017c699e$var$markFieldsDirty(data[key])
            };
            else $27f56328017c699e$var$getDirtyFieldsFromDefaultValues(data[key], $27f56328017c699e$var$isNullOrUndefined(formValues) ? {} : formValues[key], dirtyFieldsFromValues[key]);
        } else dirtyFieldsFromValues[key] = !$27f56328017c699e$var$deepEqual(data[key], formValues[key]);
    }
    return dirtyFieldsFromValues;
}
var $27f56328017c699e$var$getDirtyFields = (defaultValues, formValues)=>$27f56328017c699e$var$getDirtyFieldsFromDefaultValues(defaultValues, formValues, $27f56328017c699e$var$markFieldsDirty(formValues));
var $27f56328017c699e$var$getFieldValueAs = (value1, { valueAsNumber: valueAsNumber, valueAsDate: valueAsDate, setValueAs: setValueAs })=>$27f56328017c699e$var$isUndefined(value1) ? value1 : valueAsNumber ? value1 === "" ? NaN : value1 ? +value1 : value1 : valueAsDate && $27f56328017c699e$var$isString(value1) ? new Date(value1) : setValueAs ? setValueAs(value1) : value1;
function $27f56328017c699e$var$getFieldValue(_f) {
    const ref = _f.ref;
    if (_f.refs ? _f.refs.every((ref)=>ref.disabled) : ref.disabled) return;
    if ($27f56328017c699e$var$isFileInput(ref)) return ref.files;
    if ($27f56328017c699e$var$isRadioInput(ref)) return $27f56328017c699e$var$getRadioValue(_f.refs).value;
    if ($27f56328017c699e$var$isMultipleSelect(ref)) return [
        ...ref.selectedOptions
    ].map(({ value: value1 })=>value1);
    if ($27f56328017c699e$var$isCheckBoxInput(ref)) return $27f56328017c699e$var$getCheckboxValue(_f.refs).value;
    return $27f56328017c699e$var$getFieldValueAs($27f56328017c699e$var$isUndefined(ref.value) ? _f.ref.value : ref.value, _f);
}
var $27f56328017c699e$var$getResolverOptions = (fieldsNames, _fields, criteriaMode, shouldUseNativeValidation)=>{
    const fields = {};
    for (const name of fieldsNames){
        const field = $27f56328017c699e$export$3988ae62b71be9a3(_fields, name);
        field && $27f56328017c699e$export$adaa4cf7ef1b65be(fields, name, field._f);
    }
    return {
        criteriaMode: criteriaMode,
        names: [
            ...fieldsNames
        ],
        fields: fields,
        shouldUseNativeValidation: shouldUseNativeValidation
    };
};
var $27f56328017c699e$var$getRuleValue = (rule)=>$27f56328017c699e$var$isUndefined(rule) ? rule : $27f56328017c699e$var$isRegex(rule) ? rule.source : $27f56328017c699e$var$isObject(rule) ? $27f56328017c699e$var$isRegex(rule.value) ? rule.value.source : rule.value : rule;
var $27f56328017c699e$var$hasValidation = (options)=>options.mount && (options.required || options.min || options.max || options.maxLength || options.minLength || options.pattern || options.validate);
function $27f56328017c699e$var$schemaErrorLookup(errors, _fields, name) {
    const error = $27f56328017c699e$export$3988ae62b71be9a3(errors, name);
    if (error || $27f56328017c699e$var$isKey(name)) return {
        error: error,
        name: name
    };
    const names = name.split(".");
    while(names.length){
        const fieldName = names.join(".");
        const field = $27f56328017c699e$export$3988ae62b71be9a3(_fields, fieldName);
        const foundError = $27f56328017c699e$export$3988ae62b71be9a3(errors, fieldName);
        if (field && !Array.isArray(field) && name !== fieldName) return {
            name: name
        };
        if (foundError && foundError.type) return {
            name: fieldName,
            error: foundError
        };
        names.pop();
    }
    return {
        name: name
    };
}
var $27f56328017c699e$var$skipValidation = (isBlurEvent, isTouched, isSubmitted, reValidateMode, mode)=>{
    if (mode.isOnAll) return false;
    else if (!isSubmitted && mode.isOnTouch) return !(isTouched || isBlurEvent);
    else if (isSubmitted ? reValidateMode.isOnBlur : mode.isOnBlur) return !isBlurEvent;
    else if (isSubmitted ? reValidateMode.isOnChange : mode.isOnChange) return isBlurEvent;
    return true;
};
var $27f56328017c699e$var$unsetEmptyArray = (ref, name)=>!$27f56328017c699e$var$compact($27f56328017c699e$export$3988ae62b71be9a3(ref, name)).length && $27f56328017c699e$var$unset(ref, name);
const $27f56328017c699e$var$defaultOptions = {
    mode: $27f56328017c699e$var$VALIDATION_MODE.onSubmit,
    reValidateMode: $27f56328017c699e$var$VALIDATION_MODE.onChange,
    shouldFocusError: true
};
function $27f56328017c699e$var$createFormControl(props = {}, flushRootRender) {
    let _options = {
        ...$27f56328017c699e$var$defaultOptions,
        ...props
    };
    let _formState = {
        submitCount: 0,
        isDirty: false,
        isLoading: $27f56328017c699e$var$isFunction(_options.defaultValues),
        isValidating: false,
        isSubmitted: false,
        isSubmitting: false,
        isSubmitSuccessful: false,
        isValid: false,
        touchedFields: {},
        dirtyFields: {},
        errors: _options.errors || {},
        disabled: false
    };
    let _fields = {};
    let _defaultValues = $27f56328017c699e$var$isObject(_options.defaultValues) || $27f56328017c699e$var$isObject(_options.values) ? $27f56328017c699e$var$cloneObject(_options.defaultValues || _options.values) || {} : {};
    let _formValues = _options.shouldUnregister ? {} : $27f56328017c699e$var$cloneObject(_defaultValues);
    let _state = {
        action: false,
        mount: false,
        watch: false
    };
    let _names = {
        mount: new Set(),
        unMount: new Set(),
        array: new Set(),
        watch: new Set()
    };
    let delayErrorCallback;
    let timer = 0;
    const _proxyFormState = {
        isDirty: false,
        dirtyFields: false,
        touchedFields: false,
        isValidating: false,
        isValid: false,
        errors: false
    };
    const _subjects = {
        values: $27f56328017c699e$var$createSubject(),
        array: $27f56328017c699e$var$createSubject(),
        state: $27f56328017c699e$var$createSubject()
    };
    const shouldCaptureDirtyFields = props.resetOptions && props.resetOptions.keepDirtyValues;
    const validationModeBeforeSubmit = $27f56328017c699e$var$getValidationModes(_options.mode);
    const validationModeAfterSubmit = $27f56328017c699e$var$getValidationModes(_options.reValidateMode);
    const shouldDisplayAllAssociatedErrors = _options.criteriaMode === $27f56328017c699e$var$VALIDATION_MODE.all;
    const debounce = (callback)=>(wait)=>{
            clearTimeout(timer);
            timer = setTimeout(callback, wait);
        };
    const _updateValid = async (shouldUpdateValid)=>{
        if (_proxyFormState.isValid || shouldUpdateValid) {
            const isValid = _options.resolver ? $27f56328017c699e$var$isEmptyObject((await _executeSchema()).errors) : await executeBuiltInValidation(_fields, true);
            if (isValid !== _formState.isValid) _subjects.state.next({
                isValid: isValid
            });
        }
    };
    const _updateIsValidating = (value1)=>_proxyFormState.isValidating && _subjects.state.next({
            isValidating: value1
        });
    const _updateFieldArray = (name, values = [], method, args, shouldSetValues = true, shouldUpdateFieldsAndState = true)=>{
        if (args && method) {
            _state.action = true;
            if (shouldUpdateFieldsAndState && Array.isArray($27f56328017c699e$export$3988ae62b71be9a3(_fields, name))) {
                const fieldValues = method($27f56328017c699e$export$3988ae62b71be9a3(_fields, name), args.argA, args.argB);
                shouldSetValues && $27f56328017c699e$export$adaa4cf7ef1b65be(_fields, name, fieldValues);
            }
            if (shouldUpdateFieldsAndState && Array.isArray($27f56328017c699e$export$3988ae62b71be9a3(_formState.errors, name))) {
                const errors = method($27f56328017c699e$export$3988ae62b71be9a3(_formState.errors, name), args.argA, args.argB);
                shouldSetValues && $27f56328017c699e$export$adaa4cf7ef1b65be(_formState.errors, name, errors);
                $27f56328017c699e$var$unsetEmptyArray(_formState.errors, name);
            }
            if (_proxyFormState.touchedFields && shouldUpdateFieldsAndState && Array.isArray($27f56328017c699e$export$3988ae62b71be9a3(_formState.touchedFields, name))) {
                const touchedFields = method($27f56328017c699e$export$3988ae62b71be9a3(_formState.touchedFields, name), args.argA, args.argB);
                shouldSetValues && $27f56328017c699e$export$adaa4cf7ef1b65be(_formState.touchedFields, name, touchedFields);
            }
            if (_proxyFormState.dirtyFields) _formState.dirtyFields = $27f56328017c699e$var$getDirtyFields(_defaultValues, _formValues);
            _subjects.state.next({
                name: name,
                isDirty: _getDirty(name, values),
                dirtyFields: _formState.dirtyFields,
                errors: _formState.errors,
                isValid: _formState.isValid
            });
        } else $27f56328017c699e$export$adaa4cf7ef1b65be(_formValues, name, values);
    };
    const updateErrors = (name, error)=>{
        $27f56328017c699e$export$adaa4cf7ef1b65be(_formState.errors, name, error);
        _subjects.state.next({
            errors: _formState.errors
        });
    };
    const _setErrors = (errors)=>{
        _formState.errors = errors;
        _subjects.state.next({
            errors: _formState.errors,
            isValid: false
        });
    };
    const updateValidAndValue = (name, shouldSkipSetValueAs, value1, ref)=>{
        const field = $27f56328017c699e$export$3988ae62b71be9a3(_fields, name);
        if (field) {
            const defaultValue = $27f56328017c699e$export$3988ae62b71be9a3(_formValues, name, $27f56328017c699e$var$isUndefined(value1) ? $27f56328017c699e$export$3988ae62b71be9a3(_defaultValues, name) : value1);
            $27f56328017c699e$var$isUndefined(defaultValue) || ref && ref.defaultChecked || shouldSkipSetValueAs ? $27f56328017c699e$export$adaa4cf7ef1b65be(_formValues, name, shouldSkipSetValueAs ? defaultValue : $27f56328017c699e$var$getFieldValue(field._f)) : setFieldValue(name, defaultValue);
            _state.mount && _updateValid();
        }
    };
    const updateTouchAndDirty = (name, fieldValue, isBlurEvent, shouldDirty, shouldRender)=>{
        let shouldUpdateField = false;
        let isPreviousDirty = false;
        const output = {
            name: name
        };
        const disabledField = !!($27f56328017c699e$export$3988ae62b71be9a3(_fields, name) && $27f56328017c699e$export$3988ae62b71be9a3(_fields, name)._f.disabled);
        if (!isBlurEvent || shouldDirty) {
            if (_proxyFormState.isDirty) {
                isPreviousDirty = _formState.isDirty;
                _formState.isDirty = output.isDirty = _getDirty();
                shouldUpdateField = isPreviousDirty !== output.isDirty;
            }
            const isCurrentFieldPristine = disabledField || $27f56328017c699e$var$deepEqual($27f56328017c699e$export$3988ae62b71be9a3(_defaultValues, name), fieldValue);
            isPreviousDirty = !!(!disabledField && $27f56328017c699e$export$3988ae62b71be9a3(_formState.dirtyFields, name));
            isCurrentFieldPristine || disabledField ? $27f56328017c699e$var$unset(_formState.dirtyFields, name) : $27f56328017c699e$export$adaa4cf7ef1b65be(_formState.dirtyFields, name, true);
            output.dirtyFields = _formState.dirtyFields;
            shouldUpdateField = shouldUpdateField || _proxyFormState.dirtyFields && isPreviousDirty !== !isCurrentFieldPristine;
        }
        if (isBlurEvent) {
            const isPreviousFieldTouched = $27f56328017c699e$export$3988ae62b71be9a3(_formState.touchedFields, name);
            if (!isPreviousFieldTouched) {
                $27f56328017c699e$export$adaa4cf7ef1b65be(_formState.touchedFields, name, isBlurEvent);
                output.touchedFields = _formState.touchedFields;
                shouldUpdateField = shouldUpdateField || _proxyFormState.touchedFields && isPreviousFieldTouched !== isBlurEvent;
            }
        }
        shouldUpdateField && shouldRender && _subjects.state.next(output);
        return shouldUpdateField ? output : {};
    };
    const shouldRenderByError = (name, isValid, error, fieldState)=>{
        const previousFieldError = $27f56328017c699e$export$3988ae62b71be9a3(_formState.errors, name);
        const shouldUpdateValid = _proxyFormState.isValid && $27f56328017c699e$var$isBoolean(isValid) && _formState.isValid !== isValid;
        if (props.delayError && error) {
            delayErrorCallback = debounce(()=>updateErrors(name, error));
            delayErrorCallback(props.delayError);
        } else {
            clearTimeout(timer);
            delayErrorCallback = null;
            error ? $27f56328017c699e$export$adaa4cf7ef1b65be(_formState.errors, name, error) : $27f56328017c699e$var$unset(_formState.errors, name);
        }
        if ((error ? !$27f56328017c699e$var$deepEqual(previousFieldError, error) : previousFieldError) || !$27f56328017c699e$var$isEmptyObject(fieldState) || shouldUpdateValid) {
            const updatedFormState = {
                ...fieldState,
                ...shouldUpdateValid && $27f56328017c699e$var$isBoolean(isValid) ? {
                    isValid: isValid
                } : {},
                errors: _formState.errors,
                name: name
            };
            _formState = {
                ..._formState,
                ...updatedFormState
            };
            _subjects.state.next(updatedFormState);
        }
        _updateIsValidating(false);
    };
    const _executeSchema = async (name)=>_options.resolver(_formValues, _options.context, $27f56328017c699e$var$getResolverOptions(name || _names.mount, _fields, _options.criteriaMode, _options.shouldUseNativeValidation));
    const executeSchemaAndUpdateState = async (names)=>{
        const { errors: errors } = await _executeSchema(names);
        if (names) for (const name of names){
            const error = $27f56328017c699e$export$3988ae62b71be9a3(errors, name);
            error ? $27f56328017c699e$export$adaa4cf7ef1b65be(_formState.errors, name, error) : $27f56328017c699e$var$unset(_formState.errors, name);
        }
        else _formState.errors = errors;
        return errors;
    };
    const executeBuiltInValidation = async (fields, shouldOnlyCheckValid, context = {
        valid: true
    })=>{
        for(const name in fields){
            const field = fields[name];
            if (field) {
                const { _f: _f, ...fieldValue } = field;
                if (_f) {
                    const isFieldArrayRoot = _names.array.has(_f.name);
                    const fieldError = await $27f56328017c699e$var$validateField(field, _formValues, shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation && !shouldOnlyCheckValid, isFieldArrayRoot);
                    if (fieldError[_f.name]) {
                        context.valid = false;
                        if (shouldOnlyCheckValid) break;
                    }
                    !shouldOnlyCheckValid && ($27f56328017c699e$export$3988ae62b71be9a3(fieldError, _f.name) ? isFieldArrayRoot ? $27f56328017c699e$var$updateFieldArrayRootError(_formState.errors, fieldError, _f.name) : $27f56328017c699e$export$adaa4cf7ef1b65be(_formState.errors, _f.name, fieldError[_f.name]) : $27f56328017c699e$var$unset(_formState.errors, _f.name));
                }
                fieldValue && await executeBuiltInValidation(fieldValue, shouldOnlyCheckValid, context);
            }
        }
        return context.valid;
    };
    const _removeUnmounted = ()=>{
        for (const name of _names.unMount){
            const field = $27f56328017c699e$export$3988ae62b71be9a3(_fields, name);
            field && (field._f.refs ? field._f.refs.every((ref)=>!$27f56328017c699e$var$live(ref)) : !$27f56328017c699e$var$live(field._f.ref)) && unregister(name);
        }
        _names.unMount = new Set();
    };
    const _getDirty = (name, data)=>(name && data && $27f56328017c699e$export$adaa4cf7ef1b65be(_formValues, name, data), !$27f56328017c699e$var$deepEqual(getValues(), _defaultValues));
    const _getWatch = (names, defaultValue, isGlobal)=>$27f56328017c699e$var$generateWatchOutput(names, _names, {
            ..._state.mount ? _formValues : $27f56328017c699e$var$isUndefined(defaultValue) ? _defaultValues : $27f56328017c699e$var$isString(names) ? {
                [names]: defaultValue
            } : defaultValue
        }, isGlobal, defaultValue);
    const _getFieldArray = (name)=>$27f56328017c699e$var$compact($27f56328017c699e$export$3988ae62b71be9a3(_state.mount ? _formValues : _defaultValues, name, props.shouldUnregister ? $27f56328017c699e$export$3988ae62b71be9a3(_defaultValues, name, []) : []));
    const setFieldValue = (name, value1, options = {})=>{
        const field = $27f56328017c699e$export$3988ae62b71be9a3(_fields, name);
        let fieldValue = value1;
        if (field) {
            const fieldReference = field._f;
            if (fieldReference) {
                !fieldReference.disabled && $27f56328017c699e$export$adaa4cf7ef1b65be(_formValues, name, $27f56328017c699e$var$getFieldValueAs(value1, fieldReference));
                fieldValue = $27f56328017c699e$var$isHTMLElement(fieldReference.ref) && $27f56328017c699e$var$isNullOrUndefined(value1) ? "" : value1;
                if ($27f56328017c699e$var$isMultipleSelect(fieldReference.ref)) [
                    ...fieldReference.ref.options
                ].forEach((optionRef)=>optionRef.selected = fieldValue.includes(optionRef.value));
                else if (fieldReference.refs) {
                    if ($27f56328017c699e$var$isCheckBoxInput(fieldReference.ref)) fieldReference.refs.length > 1 ? fieldReference.refs.forEach((checkboxRef)=>(!checkboxRef.defaultChecked || !checkboxRef.disabled) && (checkboxRef.checked = Array.isArray(fieldValue) ? !!fieldValue.find((data)=>data === checkboxRef.value) : fieldValue === checkboxRef.value)) : fieldReference.refs[0] && (fieldReference.refs[0].checked = !!fieldValue);
                    else fieldReference.refs.forEach((radioRef)=>radioRef.checked = radioRef.value === fieldValue);
                } else if ($27f56328017c699e$var$isFileInput(fieldReference.ref)) fieldReference.ref.value = "";
                else {
                    fieldReference.ref.value = fieldValue;
                    if (!fieldReference.ref.type) _subjects.values.next({
                        name: name,
                        values: {
                            ..._formValues
                        }
                    });
                }
            }
        }
        (options.shouldDirty || options.shouldTouch) && updateTouchAndDirty(name, fieldValue, options.shouldTouch, options.shouldDirty, true);
        options.shouldValidate && trigger(name);
    };
    const setValues = (name, value1, options)=>{
        for(const fieldKey in value1){
            const fieldValue = value1[fieldKey];
            const fieldName = `${name}.${fieldKey}`;
            const field = $27f56328017c699e$export$3988ae62b71be9a3(_fields, fieldName);
            (_names.array.has(name) || !$27f56328017c699e$var$isPrimitive(fieldValue) || field && !field._f) && !$27f56328017c699e$var$isDateObject(fieldValue) ? setValues(fieldName, fieldValue, options) : setFieldValue(fieldName, fieldValue, options);
        }
    };
    const setValue = (name, value1, options = {})=>{
        const field = $27f56328017c699e$export$3988ae62b71be9a3(_fields, name);
        const isFieldArray = _names.array.has(name);
        const cloneValue = $27f56328017c699e$var$cloneObject(value1);
        $27f56328017c699e$export$adaa4cf7ef1b65be(_formValues, name, cloneValue);
        if (isFieldArray) {
            _subjects.array.next({
                name: name,
                values: {
                    ..._formValues
                }
            });
            if ((_proxyFormState.isDirty || _proxyFormState.dirtyFields) && options.shouldDirty) _subjects.state.next({
                name: name,
                dirtyFields: $27f56328017c699e$var$getDirtyFields(_defaultValues, _formValues),
                isDirty: _getDirty(name, cloneValue)
            });
        } else field && !field._f && !$27f56328017c699e$var$isNullOrUndefined(cloneValue) ? setValues(name, cloneValue, options) : setFieldValue(name, cloneValue, options);
        $27f56328017c699e$var$isWatched(name, _names) && _subjects.state.next({
            ..._formState
        });
        _subjects.values.next({
            name: name,
            values: {
                ..._formValues
            }
        });
        !_state.mount && flushRootRender();
    };
    const onChange = async (event)=>{
        const target = event.target;
        let name = target.name;
        let isFieldValueUpdated = true;
        const field = $27f56328017c699e$export$3988ae62b71be9a3(_fields, name);
        const getCurrentFieldValue = ()=>target.type ? $27f56328017c699e$var$getFieldValue(field._f) : $27f56328017c699e$var$getEventValue(event);
        const _updateIsFieldValueUpdated = (fieldValue)=>{
            isFieldValueUpdated = Number.isNaN(fieldValue) || fieldValue === $27f56328017c699e$export$3988ae62b71be9a3(_formValues, name, fieldValue);
        };
        if (field) {
            let error;
            let isValid;
            const fieldValue = getCurrentFieldValue();
            const isBlurEvent = event.type === $27f56328017c699e$var$EVENTS.BLUR || event.type === $27f56328017c699e$var$EVENTS.FOCUS_OUT;
            const shouldSkipValidation = !$27f56328017c699e$var$hasValidation(field._f) && !_options.resolver && !$27f56328017c699e$export$3988ae62b71be9a3(_formState.errors, name) && !field._f.deps || $27f56328017c699e$var$skipValidation(isBlurEvent, $27f56328017c699e$export$3988ae62b71be9a3(_formState.touchedFields, name), _formState.isSubmitted, validationModeAfterSubmit, validationModeBeforeSubmit);
            const watched = $27f56328017c699e$var$isWatched(name, _names, isBlurEvent);
            $27f56328017c699e$export$adaa4cf7ef1b65be(_formValues, name, fieldValue);
            if (isBlurEvent) {
                field._f.onBlur && field._f.onBlur(event);
                delayErrorCallback && delayErrorCallback(0);
            } else if (field._f.onChange) field._f.onChange(event);
            const fieldState = updateTouchAndDirty(name, fieldValue, isBlurEvent, false);
            const shouldRender = !$27f56328017c699e$var$isEmptyObject(fieldState) || watched;
            !isBlurEvent && _subjects.values.next({
                name: name,
                type: event.type,
                values: {
                    ..._formValues
                }
            });
            if (shouldSkipValidation) {
                _proxyFormState.isValid && _updateValid();
                return shouldRender && _subjects.state.next({
                    name: name,
                    ...watched ? {} : fieldState
                });
            }
            !isBlurEvent && watched && _subjects.state.next({
                ..._formState
            });
            _updateIsValidating(true);
            if (_options.resolver) {
                const { errors: errors } = await _executeSchema([
                    name
                ]);
                _updateIsFieldValueUpdated(fieldValue);
                if (isFieldValueUpdated) {
                    const previousErrorLookupResult = $27f56328017c699e$var$schemaErrorLookup(_formState.errors, _fields, name);
                    const errorLookupResult = $27f56328017c699e$var$schemaErrorLookup(errors, _fields, previousErrorLookupResult.name || name);
                    error = errorLookupResult.error;
                    name = errorLookupResult.name;
                    isValid = $27f56328017c699e$var$isEmptyObject(errors);
                }
            } else {
                error = (await $27f56328017c699e$var$validateField(field, _formValues, shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation))[name];
                _updateIsFieldValueUpdated(fieldValue);
                if (isFieldValueUpdated) {
                    if (error) isValid = false;
                    else if (_proxyFormState.isValid) isValid = await executeBuiltInValidation(_fields, true);
                }
            }
            if (isFieldValueUpdated) {
                field._f.deps && trigger(field._f.deps);
                shouldRenderByError(name, isValid, error, fieldState);
            }
        }
    };
    const _focusInput = (ref, key)=>{
        if ($27f56328017c699e$export$3988ae62b71be9a3(_formState.errors, key) && ref.focus) {
            ref.focus();
            return 1;
        }
        return;
    };
    const trigger = async (name, options = {})=>{
        let isValid;
        let validationResult;
        const fieldNames = $27f56328017c699e$var$convertToArrayPayload(name);
        _updateIsValidating(true);
        if (_options.resolver) {
            const errors = await executeSchemaAndUpdateState($27f56328017c699e$var$isUndefined(name) ? name : fieldNames);
            isValid = $27f56328017c699e$var$isEmptyObject(errors);
            validationResult = name ? !fieldNames.some((name)=>$27f56328017c699e$export$3988ae62b71be9a3(errors, name)) : isValid;
        } else if (name) {
            validationResult = (await Promise.all(fieldNames.map(async (fieldName)=>{
                const field = $27f56328017c699e$export$3988ae62b71be9a3(_fields, fieldName);
                return await executeBuiltInValidation(field && field._f ? {
                    [fieldName]: field
                } : field);
            }))).every(Boolean);
            !(!validationResult && !_formState.isValid) && _updateValid();
        } else validationResult = isValid = await executeBuiltInValidation(_fields);
        _subjects.state.next({
            ...!$27f56328017c699e$var$isString(name) || _proxyFormState.isValid && isValid !== _formState.isValid ? {} : {
                name: name
            },
            ..._options.resolver || !name ? {
                isValid: isValid
            } : {},
            errors: _formState.errors,
            isValidating: false
        });
        options.shouldFocus && !validationResult && $27f56328017c699e$var$iterateFieldsByAction(_fields, _focusInput, name ? fieldNames : _names.mount);
        return validationResult;
    };
    const getValues = (fieldNames)=>{
        const values = {
            ..._defaultValues,
            ..._state.mount ? _formValues : {}
        };
        return $27f56328017c699e$var$isUndefined(fieldNames) ? values : $27f56328017c699e$var$isString(fieldNames) ? $27f56328017c699e$export$3988ae62b71be9a3(values, fieldNames) : fieldNames.map((name)=>$27f56328017c699e$export$3988ae62b71be9a3(values, name));
    };
    const getFieldState = (name, formState)=>({
            invalid: !!$27f56328017c699e$export$3988ae62b71be9a3((formState || _formState).errors, name),
            isDirty: !!$27f56328017c699e$export$3988ae62b71be9a3((formState || _formState).dirtyFields, name),
            isTouched: !!$27f56328017c699e$export$3988ae62b71be9a3((formState || _formState).touchedFields, name),
            error: $27f56328017c699e$export$3988ae62b71be9a3((formState || _formState).errors, name)
        });
    const clearErrors = (name)=>{
        name && $27f56328017c699e$var$convertToArrayPayload(name).forEach((inputName)=>$27f56328017c699e$var$unset(_formState.errors, inputName));
        _subjects.state.next({
            errors: name ? _formState.errors : {}
        });
    };
    const setError = (name, error, options)=>{
        const ref = ($27f56328017c699e$export$3988ae62b71be9a3(_fields, name, {
            _f: {}
        })._f || {}).ref;
        $27f56328017c699e$export$adaa4cf7ef1b65be(_formState.errors, name, {
            ...error,
            ref: ref
        });
        _subjects.state.next({
            name: name,
            errors: _formState.errors,
            isValid: false
        });
        options && options.shouldFocus && ref && ref.focus && ref.focus();
    };
    const watch = (name, defaultValue)=>$27f56328017c699e$var$isFunction(name) ? _subjects.values.subscribe({
            next: (payload)=>name(_getWatch(undefined, defaultValue), payload)
        }) : _getWatch(name, defaultValue, true);
    const unregister = (name, options = {})=>{
        for (const fieldName of name ? $27f56328017c699e$var$convertToArrayPayload(name) : _names.mount){
            _names.mount.delete(fieldName);
            _names.array.delete(fieldName);
            if (!options.keepValue) {
                $27f56328017c699e$var$unset(_fields, fieldName);
                $27f56328017c699e$var$unset(_formValues, fieldName);
            }
            !options.keepError && $27f56328017c699e$var$unset(_formState.errors, fieldName);
            !options.keepDirty && $27f56328017c699e$var$unset(_formState.dirtyFields, fieldName);
            !options.keepTouched && $27f56328017c699e$var$unset(_formState.touchedFields, fieldName);
            !_options.shouldUnregister && !options.keepDefaultValue && $27f56328017c699e$var$unset(_defaultValues, fieldName);
        }
        _subjects.values.next({
            values: {
                ..._formValues
            }
        });
        _subjects.state.next({
            ..._formState,
            ...!options.keepDirty ? {} : {
                isDirty: _getDirty()
            }
        });
        !options.keepIsValid && _updateValid();
    };
    const _updateDisabledField = ({ disabled: disabled, name: name, field: field, fields: fields, value: value1 })=>{
        if ($27f56328017c699e$var$isBoolean(disabled)) {
            const inputValue = disabled ? undefined : $27f56328017c699e$var$isUndefined(value1) ? $27f56328017c699e$var$getFieldValue(field ? field._f : $27f56328017c699e$export$3988ae62b71be9a3(fields, name)._f) : value1;
            $27f56328017c699e$export$adaa4cf7ef1b65be(_formValues, name, inputValue);
            updateTouchAndDirty(name, inputValue, false, false, true);
        }
    };
    const register = (name, options = {})=>{
        let field = $27f56328017c699e$export$3988ae62b71be9a3(_fields, name);
        const disabledIsDefined = $27f56328017c699e$var$isBoolean(options.disabled);
        $27f56328017c699e$export$adaa4cf7ef1b65be(_fields, name, {
            ...field || {},
            _f: {
                ...field && field._f ? field._f : {
                    ref: {
                        name: name
                    }
                },
                name: name,
                mount: true,
                ...options
            }
        });
        _names.mount.add(name);
        if (field) _updateDisabledField({
            field: field,
            disabled: options.disabled,
            name: name,
            value: options.value
        });
        else updateValidAndValue(name, true, options.value);
        return {
            ...disabledIsDefined ? {
                disabled: options.disabled
            } : {},
            ..._options.progressive ? {
                required: !!options.required,
                min: $27f56328017c699e$var$getRuleValue(options.min),
                max: $27f56328017c699e$var$getRuleValue(options.max),
                minLength: $27f56328017c699e$var$getRuleValue(options.minLength),
                maxLength: $27f56328017c699e$var$getRuleValue(options.maxLength),
                pattern: $27f56328017c699e$var$getRuleValue(options.pattern)
            } : {},
            name: name,
            onChange: onChange,
            onBlur: onChange,
            ref: (ref)=>{
                if (ref) {
                    register(name, options);
                    field = $27f56328017c699e$export$3988ae62b71be9a3(_fields, name);
                    const fieldRef = $27f56328017c699e$var$isUndefined(ref.value) ? ref.querySelectorAll ? ref.querySelectorAll("input,select,textarea")[0] || ref : ref : ref;
                    const radioOrCheckbox = $27f56328017c699e$var$isRadioOrCheckbox(fieldRef);
                    const refs = field._f.refs || [];
                    if (radioOrCheckbox ? refs.find((option)=>option === fieldRef) : fieldRef === field._f.ref) return;
                    $27f56328017c699e$export$adaa4cf7ef1b65be(_fields, name, {
                        _f: {
                            ...field._f,
                            ...radioOrCheckbox ? {
                                refs: [
                                    ...refs.filter($27f56328017c699e$var$live),
                                    fieldRef,
                                    ...Array.isArray($27f56328017c699e$export$3988ae62b71be9a3(_defaultValues, name)) ? [
                                        {}
                                    ] : []
                                ],
                                ref: {
                                    type: fieldRef.type,
                                    name: name
                                }
                            } : {
                                ref: fieldRef
                            }
                        }
                    });
                    updateValidAndValue(name, false, undefined, fieldRef);
                } else {
                    field = $27f56328017c699e$export$3988ae62b71be9a3(_fields, name, {});
                    if (field._f) field._f.mount = false;
                    (_options.shouldUnregister || options.shouldUnregister) && !($27f56328017c699e$var$isNameInFieldArray(_names.array, name) && _state.action) && _names.unMount.add(name);
                }
            }
        };
    };
    const _focusError = ()=>_options.shouldFocusError && $27f56328017c699e$var$iterateFieldsByAction(_fields, _focusInput, _names.mount);
    const _disableForm = (disabled)=>{
        if ($27f56328017c699e$var$isBoolean(disabled)) {
            _subjects.state.next({
                disabled: disabled
            });
            $27f56328017c699e$var$iterateFieldsByAction(_fields, (ref, name)=>{
                let requiredDisabledState = disabled;
                const currentField = $27f56328017c699e$export$3988ae62b71be9a3(_fields, name);
                if (currentField && $27f56328017c699e$var$isBoolean(currentField._f.disabled)) requiredDisabledState || (requiredDisabledState = currentField._f.disabled);
                ref.disabled = requiredDisabledState;
            }, 0, false);
        }
    };
    const handleSubmit = (onValid, onInvalid)=>async (e)=>{
            if (e) {
                e.preventDefault && e.preventDefault();
                e.persist && e.persist();
            }
            let fieldValues = $27f56328017c699e$var$cloneObject(_formValues);
            _subjects.state.next({
                isSubmitting: true
            });
            if (_options.resolver) {
                const { errors: errors, values: values } = await _executeSchema();
                _formState.errors = errors;
                fieldValues = values;
            } else await executeBuiltInValidation(_fields);
            $27f56328017c699e$var$unset(_formState.errors, "root");
            if ($27f56328017c699e$var$isEmptyObject(_formState.errors)) {
                _subjects.state.next({
                    errors: {}
                });
                await onValid(fieldValues, e);
            } else {
                if (onInvalid) await onInvalid({
                    ..._formState.errors
                }, e);
                _focusError();
                setTimeout(_focusError);
            }
            _subjects.state.next({
                isSubmitted: true,
                isSubmitting: false,
                isSubmitSuccessful: $27f56328017c699e$var$isEmptyObject(_formState.errors),
                submitCount: _formState.submitCount + 1,
                errors: _formState.errors
            });
        };
    const resetField = (name, options = {})=>{
        if ($27f56328017c699e$export$3988ae62b71be9a3(_fields, name)) {
            if ($27f56328017c699e$var$isUndefined(options.defaultValue)) setValue(name, $27f56328017c699e$export$3988ae62b71be9a3(_defaultValues, name));
            else {
                setValue(name, options.defaultValue);
                $27f56328017c699e$export$adaa4cf7ef1b65be(_defaultValues, name, options.defaultValue);
            }
            if (!options.keepTouched) $27f56328017c699e$var$unset(_formState.touchedFields, name);
            if (!options.keepDirty) {
                $27f56328017c699e$var$unset(_formState.dirtyFields, name);
                _formState.isDirty = options.defaultValue ? _getDirty(name, $27f56328017c699e$export$3988ae62b71be9a3(_defaultValues, name)) : _getDirty();
            }
            if (!options.keepError) {
                $27f56328017c699e$var$unset(_formState.errors, name);
                _proxyFormState.isValid && _updateValid();
            }
            _subjects.state.next({
                ..._formState
            });
        }
    };
    const _reset = (formValues, keepStateOptions = {})=>{
        const updatedValues = formValues ? $27f56328017c699e$var$cloneObject(formValues) : _defaultValues;
        const cloneUpdatedValues = $27f56328017c699e$var$cloneObject(updatedValues);
        const values = formValues && !$27f56328017c699e$var$isEmptyObject(formValues) ? cloneUpdatedValues : _defaultValues;
        if (!keepStateOptions.keepDefaultValues) _defaultValues = updatedValues;
        if (!keepStateOptions.keepValues) {
            if (keepStateOptions.keepDirtyValues || shouldCaptureDirtyFields) for (const fieldName of _names.mount)$27f56328017c699e$export$3988ae62b71be9a3(_formState.dirtyFields, fieldName) ? $27f56328017c699e$export$adaa4cf7ef1b65be(values, fieldName, $27f56328017c699e$export$3988ae62b71be9a3(_formValues, fieldName)) : setValue(fieldName, $27f56328017c699e$export$3988ae62b71be9a3(values, fieldName));
            else {
                if ($27f56328017c699e$var$isWeb && $27f56328017c699e$var$isUndefined(formValues)) for (const name of _names.mount){
                    const field = $27f56328017c699e$export$3988ae62b71be9a3(_fields, name);
                    if (field && field._f) {
                        const fieldReference = Array.isArray(field._f.refs) ? field._f.refs[0] : field._f.ref;
                        if ($27f56328017c699e$var$isHTMLElement(fieldReference)) {
                            const form = fieldReference.closest("form");
                            if (form) {
                                form.reset();
                                break;
                            }
                        }
                    }
                }
                _fields = {};
            }
            _formValues = props.shouldUnregister ? keepStateOptions.keepDefaultValues ? $27f56328017c699e$var$cloneObject(_defaultValues) : {} : $27f56328017c699e$var$cloneObject(values);
            _subjects.array.next({
                values: {
                    ...values
                }
            });
            _subjects.values.next({
                values: {
                    ...values
                }
            });
        }
        _names = {
            mount: new Set(),
            unMount: new Set(),
            array: new Set(),
            watch: new Set(),
            watchAll: false,
            focus: ""
        };
        !_state.mount && flushRootRender();
        _state.mount = !_proxyFormState.isValid || !!keepStateOptions.keepIsValid;
        _state.watch = !!props.shouldUnregister;
        _subjects.state.next({
            submitCount: keepStateOptions.keepSubmitCount ? _formState.submitCount : 0,
            isDirty: keepStateOptions.keepDirty ? _formState.isDirty : !!(keepStateOptions.keepDefaultValues && !$27f56328017c699e$var$deepEqual(formValues, _defaultValues)),
            isSubmitted: keepStateOptions.keepIsSubmitted ? _formState.isSubmitted : false,
            dirtyFields: keepStateOptions.keepDirtyValues ? _formState.dirtyFields : keepStateOptions.keepDefaultValues && formValues ? $27f56328017c699e$var$getDirtyFields(_defaultValues, formValues) : {},
            touchedFields: keepStateOptions.keepTouched ? _formState.touchedFields : {},
            errors: keepStateOptions.keepErrors ? _formState.errors : {},
            isSubmitSuccessful: keepStateOptions.keepIsSubmitSuccessful ? _formState.isSubmitSuccessful : false,
            isSubmitting: false
        });
    };
    const reset = (formValues, keepStateOptions)=>_reset($27f56328017c699e$var$isFunction(formValues) ? formValues(_formValues) : formValues, keepStateOptions);
    const setFocus = (name, options = {})=>{
        const field = $27f56328017c699e$export$3988ae62b71be9a3(_fields, name);
        const fieldReference = field && field._f;
        if (fieldReference) {
            const fieldRef = fieldReference.refs ? fieldReference.refs[0] : fieldReference.ref;
            if (fieldRef.focus) {
                fieldRef.focus();
                options.shouldSelect && fieldRef.select();
            }
        }
    };
    const _updateFormState = (updatedFormState)=>{
        _formState = {
            ..._formState,
            ...updatedFormState
        };
    };
    const _resetDefaultValues = ()=>$27f56328017c699e$var$isFunction(_options.defaultValues) && _options.defaultValues().then((values)=>{
            reset(values, _options.resetOptions);
            _subjects.state.next({
                isLoading: false
            });
        });
    return {
        control: {
            register: register,
            unregister: unregister,
            getFieldState: getFieldState,
            handleSubmit: handleSubmit,
            setError: setError,
            _executeSchema: _executeSchema,
            _getWatch: _getWatch,
            _getDirty: _getDirty,
            _updateValid: _updateValid,
            _removeUnmounted: _removeUnmounted,
            _updateFieldArray: _updateFieldArray,
            _updateDisabledField: _updateDisabledField,
            _getFieldArray: _getFieldArray,
            _reset: _reset,
            _resetDefaultValues: _resetDefaultValues,
            _updateFormState: _updateFormState,
            _disableForm: _disableForm,
            _subjects: _subjects,
            _proxyFormState: _proxyFormState,
            _setErrors: _setErrors,
            get _fields () {
                return _fields;
            },
            get _formValues () {
                return _formValues;
            },
            get _state () {
                return _state;
            },
            set _state (value){
                _state = value;
            },
            get _defaultValues () {
                return _defaultValues;
            },
            get _names () {
                return _names;
            },
            set _names (value){
                _names = value;
            },
            get _formState () {
                return _formState;
            },
            set _formState (value){
                _formState = value;
            },
            get _options () {
                return _options;
            },
            set _options (value){
                _options = {
                    ..._options,
                    ...value
                };
            }
        },
        trigger: trigger,
        register: register,
        handleSubmit: handleSubmit,
        watch: watch,
        setValue: setValue,
        getValues: getValues,
        reset: reset,
        resetField: resetField,
        clearErrors: clearErrors,
        unregister: unregister,
        setError: setError,
        setFocus: setFocus,
        getFieldState: getFieldState
    };
}
/**
 * Custom hook to manage the entire form.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useform) • [Demo](https://codesandbox.io/s/react-hook-form-get-started-ts-5ksmm) • [Video](https://www.youtube.com/watch?v=RkXv4AXXC_4)
 *
 * @param props - form configuration and validation parameters.
 *
 * @returns methods - individual functions to manage the form state. {@link UseFormReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, handleSubmit, watch, formState: { errors } } = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   console.log(watch("example"));
 *
 *   return (
 *     <form onSubmit={handleSubmit(onSubmit)}>
 *       <input defaultValue="test" {...register("example")} />
 *       <input {...register("exampleRequired", { required: true })} />
 *       {errors.exampleRequired && <span>This field is required</span>}
 *       <button>Submit</button>
 *     </form>
 *   );
 * }
 * ```
 */ function $27f56328017c699e$export$87c0cf8eb5a167e0(props = {}) {
    const _formControl = (0, (/*@__PURE__*/$parcel$interopDefault($b6HlZ))).useRef();
    const _values = (0, (/*@__PURE__*/$parcel$interopDefault($b6HlZ))).useRef();
    const [formState, updateFormState] = (0, (/*@__PURE__*/$parcel$interopDefault($b6HlZ))).useState({
        isDirty: false,
        isValidating: false,
        isLoading: $27f56328017c699e$var$isFunction(props.defaultValues),
        isSubmitted: false,
        isSubmitting: false,
        isSubmitSuccessful: false,
        isValid: false,
        submitCount: 0,
        dirtyFields: {},
        touchedFields: {},
        errors: props.errors || {},
        disabled: false,
        defaultValues: $27f56328017c699e$var$isFunction(props.defaultValues) ? undefined : props.defaultValues
    });
    if (!_formControl.current) _formControl.current = {
        ...$27f56328017c699e$var$createFormControl(props, ()=>updateFormState((formState)=>({
                    ...formState
                }))),
        formState: formState
    };
    const control = _formControl.current.control;
    control._options = props;
    $27f56328017c699e$var$useSubscribe({
        subject: control._subjects.state,
        next: (value1)=>{
            if ($27f56328017c699e$var$shouldRenderFormState(value1, control._proxyFormState, control._updateFormState, true)) updateFormState({
                ...control._formState
            });
        }
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($b6HlZ))).useEffect(()=>control._disableForm(props.disabled), [
        control,
        props.disabled
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($b6HlZ))).useEffect(()=>{
        if (control._proxyFormState.isDirty) {
            const isDirty = control._getDirty();
            if (isDirty !== formState.isDirty) control._subjects.state.next({
                isDirty: isDirty
            });
        }
    }, [
        control,
        formState.isDirty
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($b6HlZ))).useEffect(()=>{
        if (props.values && !$27f56328017c699e$var$deepEqual(props.values, _values.current)) {
            control._reset(props.values, control._options.resetOptions);
            _values.current = props.values;
            updateFormState((state)=>({
                    ...state
                }));
        } else control._resetDefaultValues();
    }, [
        props.values,
        control
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($b6HlZ))).useEffect(()=>{
        if (props.errors) control._setErrors(props.errors);
    }, [
        props.errors,
        control
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($b6HlZ))).useEffect(()=>{
        if (!control._state.mount) {
            control._updateValid();
            control._state.mount = true;
        }
        if (control._state.watch) {
            control._state.watch = false;
            control._subjects.state.next({
                ...control._formState
            });
        }
        control._removeUnmounted();
    });
    _formControl.current.formState = $27f56328017c699e$var$getProxyFormState(formState, control);
    return _formControl.current;
}

});

parcelRegister("ehmfL", function(module, exports) {

var $lgL0X = parcelRequire("lgL0X");
$parcel$exportWildcard(module.exports, $lgL0X);

});
parcelRegister("lgL0X", function(module, exports) {

$parcel$export(module.exports, "ActionCodeOperation", function () { return (parcelRequire("clAv2")).A; });
$parcel$export(module.exports, "ActionCodeURL", function () { return (parcelRequire("clAv2")).ad; });
$parcel$export(module.exports, "AuthCredential", function () { return (parcelRequire("clAv2")).H; });
$parcel$export(module.exports, "AuthErrorCodes", function () { return (parcelRequire("clAv2")).D; });
$parcel$export(module.exports, "EmailAuthCredential", function () { return (parcelRequire("clAv2")).I; });
$parcel$export(module.exports, "EmailAuthProvider", function () { return (parcelRequire("clAv2")).M; });
$parcel$export(module.exports, "FacebookAuthProvider", function () { return (parcelRequire("clAv2")).N; });
$parcel$export(module.exports, "FactorId", function () { return (parcelRequire("clAv2")).F; });
$parcel$export(module.exports, "GithubAuthProvider", function () { return (parcelRequire("clAv2")).T; });
$parcel$export(module.exports, "GoogleAuthProvider", function () { return (parcelRequire("clAv2")).Q; });
$parcel$export(module.exports, "OAuthCredential", function () { return (parcelRequire("clAv2")).J; });
$parcel$export(module.exports, "OAuthProvider", function () { return (parcelRequire("clAv2")).U; });
$parcel$export(module.exports, "OperationType", function () { return (parcelRequire("clAv2")).O; });
$parcel$export(module.exports, "PhoneAuthCredential", function () { return (parcelRequire("clAv2")).K; });
$parcel$export(module.exports, "PhoneAuthProvider", function () { return (parcelRequire("clAv2")).P; });
$parcel$export(module.exports, "PhoneMultiFactorGenerator", function () { return (parcelRequire("clAv2")).m; });
$parcel$export(module.exports, "ProviderId", function () { return (parcelRequire("clAv2")).o; });
$parcel$export(module.exports, "RecaptchaVerifier", function () { return (parcelRequire("clAv2")).R; });
$parcel$export(module.exports, "SAMLAuthProvider", function () { return (parcelRequire("clAv2")).V; });
$parcel$export(module.exports, "SignInMethod", function () { return (parcelRequire("clAv2")).S; });
$parcel$export(module.exports, "TwitterAuthProvider", function () { return (parcelRequire("clAv2")).W; });
$parcel$export(module.exports, "applyActionCode", function () { return (parcelRequire("clAv2")).a2; });
$parcel$export(module.exports, "beforeAuthStateChanged", function () { return (parcelRequire("clAv2")).t; });
$parcel$export(module.exports, "browserLocalPersistence", function () { return (parcelRequire("clAv2")).b; });
$parcel$export(module.exports, "browserPopupRedirectResolver", function () { return (parcelRequire("clAv2")).k; });
$parcel$export(module.exports, "browserSessionPersistence", function () { return (parcelRequire("clAv2")).a; });
$parcel$export(module.exports, "checkActionCode", function () { return (parcelRequire("clAv2")).a3; });
$parcel$export(module.exports, "confirmPasswordReset", function () { return (parcelRequire("clAv2")).a1; });
$parcel$export(module.exports, "connectAuthEmulator", function () { return (parcelRequire("clAv2")).G; });
$parcel$export(module.exports, "createUserWithEmailAndPassword", function () { return (parcelRequire("clAv2")).a5; });
$parcel$export(module.exports, "debugErrorMap", function () { return (parcelRequire("clAv2")).B; });
$parcel$export(module.exports, "deleteUser", function () { return (parcelRequire("clAv2")).z; });
$parcel$export(module.exports, "fetchSignInMethodsForEmail", function () { return (parcelRequire("clAv2")).aa; });
$parcel$export(module.exports, "getAdditionalUserInfo", function () { return (parcelRequire("clAv2")).al; });
$parcel$export(module.exports, "getAuth", function () { return (parcelRequire("clAv2")).n; });
$parcel$export(module.exports, "getIdToken", function () { return (parcelRequire("clAv2")).ai; });
$parcel$export(module.exports, "getIdTokenResult", function () { return (parcelRequire("clAv2")).aj; });
$parcel$export(module.exports, "getMultiFactorResolver", function () { return (parcelRequire("clAv2")).an; });
$parcel$export(module.exports, "getRedirectResult", function () { return (parcelRequire("clAv2")).j; });
$parcel$export(module.exports, "inMemoryPersistence", function () { return (parcelRequire("clAv2")).L; });
$parcel$export(module.exports, "indexedDBLocalPersistence", function () { return (parcelRequire("clAv2")).i; });
$parcel$export(module.exports, "initializeAuth", function () { return (parcelRequire("clAv2")).E; });
$parcel$export(module.exports, "isSignInWithEmailLink", function () { return (parcelRequire("clAv2")).a8; });
$parcel$export(module.exports, "linkWithCredential", function () { return (parcelRequire("clAv2")).Z; });
$parcel$export(module.exports, "linkWithPhoneNumber", function () { return (parcelRequire("clAv2")).l; });
$parcel$export(module.exports, "linkWithPopup", function () { return (parcelRequire("clAv2")).d; });
$parcel$export(module.exports, "linkWithRedirect", function () { return (parcelRequire("clAv2")).g; });
$parcel$export(module.exports, "multiFactor", function () { return (parcelRequire("clAv2")).ao; });
$parcel$export(module.exports, "onAuthStateChanged", function () { return (parcelRequire("clAv2")).v; });
$parcel$export(module.exports, "onIdTokenChanged", function () { return (parcelRequire("clAv2")).q; });
$parcel$export(module.exports, "parseActionCodeURL", function () { return (parcelRequire("clAv2")).ae; });
$parcel$export(module.exports, "prodErrorMap", function () { return (parcelRequire("clAv2")).C; });
$parcel$export(module.exports, "reauthenticateWithCredential", function () { return (parcelRequire("clAv2"))._; });
$parcel$export(module.exports, "reauthenticateWithPhoneNumber", function () { return (parcelRequire("clAv2")).r; });
$parcel$export(module.exports, "reauthenticateWithPopup", function () { return (parcelRequire("clAv2")).e; });
$parcel$export(module.exports, "reauthenticateWithRedirect", function () { return (parcelRequire("clAv2")).h; });
$parcel$export(module.exports, "reload", function () { return (parcelRequire("clAv2")).am; });
$parcel$export(module.exports, "sendEmailVerification", function () { return (parcelRequire("clAv2")).ab; });
$parcel$export(module.exports, "sendPasswordResetEmail", function () { return (parcelRequire("clAv2")).a0; });
$parcel$export(module.exports, "sendSignInLinkToEmail", function () { return (parcelRequire("clAv2")).a7; });
$parcel$export(module.exports, "setPersistence", function () { return (parcelRequire("clAv2")).p; });
$parcel$export(module.exports, "signInAnonymously", function () { return (parcelRequire("clAv2")).X; });
$parcel$export(module.exports, "signInWithCredential", function () { return (parcelRequire("clAv2")).Y; });
$parcel$export(module.exports, "signInWithCustomToken", function () { return (parcelRequire("clAv2")).$; });
$parcel$export(module.exports, "signInWithEmailAndPassword", function () { return (parcelRequire("clAv2")).a6; });
$parcel$export(module.exports, "signInWithEmailLink", function () { return (parcelRequire("clAv2")).a9; });
$parcel$export(module.exports, "signInWithPhoneNumber", function () { return (parcelRequire("clAv2")).s; });
$parcel$export(module.exports, "signInWithPopup", function () { return (parcelRequire("clAv2")).c; });
$parcel$export(module.exports, "signInWithRedirect", function () { return (parcelRequire("clAv2")).f; });
$parcel$export(module.exports, "signOut", function () { return (parcelRequire("clAv2")).y; });
$parcel$export(module.exports, "unlink", function () { return (parcelRequire("clAv2")).ak; });
$parcel$export(module.exports, "updateCurrentUser", function () { return (parcelRequire("clAv2")).x; });
$parcel$export(module.exports, "updateEmail", function () { return (parcelRequire("clAv2")).ag; });
$parcel$export(module.exports, "updatePassword", function () { return (parcelRequire("clAv2")).ah; });
$parcel$export(module.exports, "updatePhoneNumber", function () { return (parcelRequire("clAv2")).u; });
$parcel$export(module.exports, "updateProfile", function () { return (parcelRequire("clAv2")).af; });
$parcel$export(module.exports, "useDeviceLanguage", function () { return (parcelRequire("clAv2")).w; });
$parcel$export(module.exports, "verifyBeforeUpdateEmail", function () { return (parcelRequire("clAv2")).ac; });
$parcel$export(module.exports, "verifyPasswordResetCode", function () { return (parcelRequire("clAv2")).a4; });

var $clAv2 = parcelRequire("clAv2");
parcelRequire("6vM9o");
parcelRequire("iXpG9");

parcelRequire("bfcN2");
parcelRequire("kOJH8");

});
parcelRegister("clAv2", function(module, exports) {

$parcel$export(module.exports, "F", function () { return $8fd3c2447d7c53c3$export$d66501df72047452; });
$parcel$export(module.exports, "o", function () { return $8fd3c2447d7c53c3$export$ae1af26003f05816; });
$parcel$export(module.exports, "S", function () { return $8fd3c2447d7c53c3$export$25ce5a424b770e84; });
$parcel$export(module.exports, "O", function () { return $8fd3c2447d7c53c3$export$c4ce752e73470fba; });
$parcel$export(module.exports, "A", function () { return $8fd3c2447d7c53c3$export$ebd11618f299a286; });
$parcel$export(module.exports, "B", function () { return $8fd3c2447d7c53c3$export$ef35774e6d314e91; });
$parcel$export(module.exports, "C", function () { return $8fd3c2447d7c53c3$export$e7094788287c5e9b; });
$parcel$export(module.exports, "D", function () { return $8fd3c2447d7c53c3$export$96f57966bedc81b4; });
$parcel$export(module.exports, "E", function () { return $8fd3c2447d7c53c3$export$a9c23c6ac3fc3eca; });
$parcel$export(module.exports, "ai", function () { return $8fd3c2447d7c53c3$export$f38c853ae54ed474; });
$parcel$export(module.exports, "aj", function () { return $8fd3c2447d7c53c3$export$3b513254972cfc9c; });
$parcel$export(module.exports, "am", function () { return $8fd3c2447d7c53c3$export$1a82df3d29112e01; });
$parcel$export(module.exports, "L", function () { return $8fd3c2447d7c53c3$export$61196ced6d74a310; });
$parcel$export(module.exports, "G", function () { return $8fd3c2447d7c53c3$export$2329c99376c9d0a4; });
$parcel$export(module.exports, "H", function () { return $8fd3c2447d7c53c3$export$7f8ddf7c7c20b3cd; });
$parcel$export(module.exports, "I", function () { return $8fd3c2447d7c53c3$export$9bb611d729802a56; });
$parcel$export(module.exports, "J", function () { return $8fd3c2447d7c53c3$export$b4171a6734a65d42; });
$parcel$export(module.exports, "K", function () { return $8fd3c2447d7c53c3$export$3466f893ebf79586; });
$parcel$export(module.exports, "ad", function () { return $8fd3c2447d7c53c3$export$4c3d22f3d993c33f; });
$parcel$export(module.exports, "ae", function () { return $8fd3c2447d7c53c3$export$f787f51d84a910ad; });
$parcel$export(module.exports, "M", function () { return $8fd3c2447d7c53c3$export$3a1a48c8f6ef640e; });
$parcel$export(module.exports, "U", function () { return $8fd3c2447d7c53c3$export$3a6d5c9ae78a2c08; });
$parcel$export(module.exports, "N", function () { return $8fd3c2447d7c53c3$export$a07804094c3ecf2d; });
$parcel$export(module.exports, "Q", function () { return $8fd3c2447d7c53c3$export$3722cfe417b6ed86; });
$parcel$export(module.exports, "T", function () { return $8fd3c2447d7c53c3$export$971d5caa766a69d7; });
$parcel$export(module.exports, "V", function () { return $8fd3c2447d7c53c3$export$e7c866399fa523f5; });
$parcel$export(module.exports, "W", function () { return $8fd3c2447d7c53c3$export$71cec2538cb2c617; });
$parcel$export(module.exports, "X", function () { return $8fd3c2447d7c53c3$export$78acf4525d8a74c4; });
$parcel$export(module.exports, "ak", function () { return $8fd3c2447d7c53c3$export$21579262ef46735b; });
$parcel$export(module.exports, "Y", function () { return $8fd3c2447d7c53c3$export$8743009a87fcb00f; });
$parcel$export(module.exports, "Z", function () { return $8fd3c2447d7c53c3$export$dc98b0b04f4c7758; });
$parcel$export(module.exports, "_", function () { return $8fd3c2447d7c53c3$export$71511d61b312f219; });
$parcel$export(module.exports, "$", function () { return $8fd3c2447d7c53c3$export$3d8c2f653ac9d0b9; });
$parcel$export(module.exports, "a0", function () { return $8fd3c2447d7c53c3$export$34aec0b863436764; });
$parcel$export(module.exports, "a1", function () { return $8fd3c2447d7c53c3$export$3c2fa207a37baaea; });
$parcel$export(module.exports, "a2", function () { return $8fd3c2447d7c53c3$export$ce26c07117d59d6a; });
$parcel$export(module.exports, "a3", function () { return $8fd3c2447d7c53c3$export$6559d589eb85fbb6; });
$parcel$export(module.exports, "a4", function () { return $8fd3c2447d7c53c3$export$efca4cbe5dd06740; });
$parcel$export(module.exports, "a5", function () { return $8fd3c2447d7c53c3$export$a8550f7dbe79f93a; });
$parcel$export(module.exports, "a6", function () { return $8fd3c2447d7c53c3$export$2e2af4578d910ddf; });
$parcel$export(module.exports, "a7", function () { return $8fd3c2447d7c53c3$export$a93c5207d687da10; });
$parcel$export(module.exports, "a8", function () { return $8fd3c2447d7c53c3$export$c3950d9923825c02; });
$parcel$export(module.exports, "a9", function () { return $8fd3c2447d7c53c3$export$a9c996f45e5784d0; });
$parcel$export(module.exports, "aa", function () { return $8fd3c2447d7c53c3$export$7910e0436ed8d1de; });
$parcel$export(module.exports, "ab", function () { return $8fd3c2447d7c53c3$export$555508cbc6add439; });
$parcel$export(module.exports, "ac", function () { return $8fd3c2447d7c53c3$export$2219238a014317b0; });
$parcel$export(module.exports, "af", function () { return $8fd3c2447d7c53c3$export$c9170ad7d4cd7e57; });
$parcel$export(module.exports, "ag", function () { return $8fd3c2447d7c53c3$export$ee7c8ad385a60b7b; });
$parcel$export(module.exports, "ah", function () { return $8fd3c2447d7c53c3$export$995eb9fca571757; });
$parcel$export(module.exports, "al", function () { return $8fd3c2447d7c53c3$export$ab83b03e4111b1d0; });
$parcel$export(module.exports, "p", function () { return $8fd3c2447d7c53c3$export$ffb5f4729a158638; });
$parcel$export(module.exports, "q", function () { return $8fd3c2447d7c53c3$export$9e5f44173e64f162; });
$parcel$export(module.exports, "t", function () { return $8fd3c2447d7c53c3$export$625550452a3fa3ec; });
$parcel$export(module.exports, "v", function () { return $8fd3c2447d7c53c3$export$90a7f3efeed30595; });
$parcel$export(module.exports, "w", function () { return $8fd3c2447d7c53c3$export$efccba1c4a2ef57b; });
$parcel$export(module.exports, "x", function () { return $8fd3c2447d7c53c3$export$d141bba7fdc215a3; });
$parcel$export(module.exports, "y", function () { return $8fd3c2447d7c53c3$export$4a5767248b18ef41; });
$parcel$export(module.exports, "z", function () { return $8fd3c2447d7c53c3$export$df995fae86a55f06; });
$parcel$export(module.exports, "an", function () { return $8fd3c2447d7c53c3$export$306ddfe3a8403e2; });
$parcel$export(module.exports, "ao", function () { return $8fd3c2447d7c53c3$export$7a38258bbe170828; });
$parcel$export(module.exports, "b", function () { return $8fd3c2447d7c53c3$export$8b22cf2602fb60ce; });
$parcel$export(module.exports, "a", function () { return $8fd3c2447d7c53c3$export$407448d2b89b1813; });
$parcel$export(module.exports, "i", function () { return $8fd3c2447d7c53c3$export$23f2a1d2818174ef; });
$parcel$export(module.exports, "R", function () { return $8fd3c2447d7c53c3$export$db202ddc8be9136; });
$parcel$export(module.exports, "s", function () { return $8fd3c2447d7c53c3$export$2408f22a0fab9ae5; });
$parcel$export(module.exports, "l", function () { return $8fd3c2447d7c53c3$export$882b5998b3b9117c; });
$parcel$export(module.exports, "r", function () { return $8fd3c2447d7c53c3$export$43caf9889c228507; });
$parcel$export(module.exports, "u", function () { return $8fd3c2447d7c53c3$export$3b14a55fb2447963; });
$parcel$export(module.exports, "P", function () { return $8fd3c2447d7c53c3$export$56c0d5a1e737357d; });
$parcel$export(module.exports, "c", function () { return $8fd3c2447d7c53c3$export$db3b6bfb95261072; });
$parcel$export(module.exports, "e", function () { return $8fd3c2447d7c53c3$export$f1e1789686576879; });
$parcel$export(module.exports, "d", function () { return $8fd3c2447d7c53c3$export$4368d992c4eafac0; });
$parcel$export(module.exports, "f", function () { return $8fd3c2447d7c53c3$export$2d1720544b23b823; });
$parcel$export(module.exports, "h", function () { return $8fd3c2447d7c53c3$export$dda1d9f60106f0e9; });
$parcel$export(module.exports, "g", function () { return $8fd3c2447d7c53c3$export$39b482c5e57630a8; });
$parcel$export(module.exports, "j", function () { return $8fd3c2447d7c53c3$export$35e795649ee09318; });
$parcel$export(module.exports, "k", function () { return $8fd3c2447d7c53c3$export$342063e11d6c3cad; });
$parcel$export(module.exports, "m", function () { return $8fd3c2447d7c53c3$export$953cecd6e717a553; });
$parcel$export(module.exports, "n", function () { return $8fd3c2447d7c53c3$export$7ccc53e8f1e7dfc5; });

var $6vM9o = parcelRequire("6vM9o");

var $iXpG9 = parcelRequire("iXpG9");

var $k2nG7 = parcelRequire("k2nG7");

var $bfcN2 = parcelRequire("bfcN2");

var $kOJH8 = parcelRequire("kOJH8");
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An enum of factors that may be used for multifactor authentication.
 *
 * @public
 */ const $8fd3c2447d7c53c3$export$d66501df72047452 = {
    /** Phone as second factor */ PHONE: "phone"
};
/**
 * Enumeration of supported providers.
 *
 * @public
 */ const $8fd3c2447d7c53c3$export$ae1af26003f05816 = {
    /** Facebook provider ID */ FACEBOOK: "facebook.com",
    /** GitHub provider ID */ GITHUB: "github.com",
    /** Google provider ID */ GOOGLE: "google.com",
    /** Password provider */ PASSWORD: "password",
    /** Phone provider */ PHONE: "phone",
    /** Twitter provider ID */ TWITTER: "twitter.com"
};
/**
 * Enumeration of supported sign-in methods.
 *
 * @public
 */ const $8fd3c2447d7c53c3$export$25ce5a424b770e84 = {
    /** Email link sign in method */ EMAIL_LINK: "emailLink",
    /** Email/password sign in method */ EMAIL_PASSWORD: "password",
    /** Facebook sign in method */ FACEBOOK: "facebook.com",
    /** GitHub sign in method */ GITHUB: "github.com",
    /** Google sign in method */ GOOGLE: "google.com",
    /** Phone sign in method */ PHONE: "phone",
    /** Twitter sign in method */ TWITTER: "twitter.com"
};
/**
 * Enumeration of supported operation types.
 *
 * @public
 */ const $8fd3c2447d7c53c3$export$c4ce752e73470fba = {
    /** Operation involving linking an additional provider to an already signed-in user. */ LINK: "link",
    /** Operation involving using a provider to reauthenticate an already signed-in user. */ REAUTHENTICATE: "reauthenticate",
    /** Operation involving signing in a user. */ SIGN_IN: "signIn"
};
/**
 * An enumeration of the possible email action types.
 *
 * @public
 */ const $8fd3c2447d7c53c3$export$ebd11618f299a286 = {
    /** The email link sign-in action. */ EMAIL_SIGNIN: "EMAIL_SIGNIN",
    /** The password reset action. */ PASSWORD_RESET: "PASSWORD_RESET",
    /** The email revocation action. */ RECOVER_EMAIL: "RECOVER_EMAIL",
    /** The revert second factor addition email action. */ REVERT_SECOND_FACTOR_ADDITION: "REVERT_SECOND_FACTOR_ADDITION",
    /** The revert second factor addition email action. */ VERIFY_AND_CHANGE_EMAIL: "VERIFY_AND_CHANGE_EMAIL",
    /** The email verification action. */ VERIFY_EMAIL: "VERIFY_EMAIL"
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $8fd3c2447d7c53c3$var$_debugErrorMap() {
    return {
        ["admin-restricted-operation" /* ADMIN_ONLY_OPERATION */ ]: "This operation is restricted to administrators only.",
        ["argument-error" /* ARGUMENT_ERROR */ ]: "",
        ["app-not-authorized" /* APP_NOT_AUTHORIZED */ ]: "This app, identified by the domain where it's hosted, is not authorized to use Firebase Authentication with the provided API key. Review your key configuration in the Google API console.",
        ["app-not-installed" /* APP_NOT_INSTALLED */ ]: "The requested mobile application corresponding to the identifier (Android package name or iOS bundle ID) provided is not installed on this device.",
        ["captcha-check-failed" /* CAPTCHA_CHECK_FAILED */ ]: "The reCAPTCHA response token provided is either invalid, expired, already used or the domain associated with it does not match the list of whitelisted domains.",
        ["code-expired" /* CODE_EXPIRED */ ]: "The SMS code has expired. Please re-send the verification code to try again.",
        ["cordova-not-ready" /* CORDOVA_NOT_READY */ ]: "Cordova framework is not ready.",
        ["cors-unsupported" /* CORS_UNSUPPORTED */ ]: "This browser is not supported.",
        ["credential-already-in-use" /* CREDENTIAL_ALREADY_IN_USE */ ]: "This credential is already associated with a different user account.",
        ["custom-token-mismatch" /* CREDENTIAL_MISMATCH */ ]: "The custom token corresponds to a different audience.",
        ["requires-recent-login" /* CREDENTIAL_TOO_OLD_LOGIN_AGAIN */ ]: "This operation is sensitive and requires recent authentication. Log in again before retrying this request.",
        ["dependent-sdk-initialized-before-auth" /* DEPENDENT_SDK_INIT_BEFORE_AUTH */ ]: "Another Firebase SDK was initialized and is trying to use Auth before Auth is initialized. Please be sure to call `initializeAuth` or `getAuth` before starting any other Firebase SDK.",
        ["dynamic-link-not-activated" /* DYNAMIC_LINK_NOT_ACTIVATED */ ]: "Please activate Dynamic Links in the Firebase Console and agree to the terms and conditions.",
        ["email-change-needs-verification" /* EMAIL_CHANGE_NEEDS_VERIFICATION */ ]: "Multi-factor users must always have a verified email.",
        ["email-already-in-use" /* EMAIL_EXISTS */ ]: "The email address is already in use by another account.",
        ["emulator-config-failed" /* EMULATOR_CONFIG_FAILED */ ]: 'Auth instance has already been used to make a network call. Auth can no longer be configured to use the emulator. Try calling "connectAuthEmulator()" sooner.',
        ["expired-action-code" /* EXPIRED_OOB_CODE */ ]: "The action code has expired.",
        ["cancelled-popup-request" /* EXPIRED_POPUP_REQUEST */ ]: "This operation has been cancelled due to another conflicting popup being opened.",
        ["internal-error" /* INTERNAL_ERROR */ ]: "An internal AuthError has occurred.",
        ["invalid-app-credential" /* INVALID_APP_CREDENTIAL */ ]: "The phone verification request contains an invalid application verifier. The reCAPTCHA token response is either invalid or expired.",
        ["invalid-app-id" /* INVALID_APP_ID */ ]: "The mobile app identifier is not registed for the current project.",
        ["invalid-user-token" /* INVALID_AUTH */ ]: "This user's credential isn't valid for this project. This can happen if the user's token has been tampered with, or if the user isn't for the project associated with this API key.",
        ["invalid-auth-event" /* INVALID_AUTH_EVENT */ ]: "An internal AuthError has occurred.",
        ["invalid-verification-code" /* INVALID_CODE */ ]: "The SMS verification code used to create the phone auth credential is invalid. Please resend the verification code sms and be sure to use the verification code provided by the user.",
        ["invalid-continue-uri" /* INVALID_CONTINUE_URI */ ]: "The continue URL provided in the request is invalid.",
        ["invalid-cordova-configuration" /* INVALID_CORDOVA_CONFIGURATION */ ]: "The following Cordova plugins must be installed to enable OAuth sign-in: cordova-plugin-buildinfo, cordova-universal-links-plugin, cordova-plugin-browsertab, cordova-plugin-inappbrowser and cordova-plugin-customurlscheme.",
        ["invalid-custom-token" /* INVALID_CUSTOM_TOKEN */ ]: "The custom token format is incorrect. Please check the documentation.",
        ["invalid-dynamic-link-domain" /* INVALID_DYNAMIC_LINK_DOMAIN */ ]: "The provided dynamic link domain is not configured or authorized for the current project.",
        ["invalid-email" /* INVALID_EMAIL */ ]: "The email address is badly formatted.",
        ["invalid-emulator-scheme" /* INVALID_EMULATOR_SCHEME */ ]: "Emulator URL must start with a valid scheme (http:// or https://).",
        ["invalid-api-key" /* INVALID_API_KEY */ ]: "Your API key is invalid, please check you have copied it correctly.",
        ["invalid-cert-hash" /* INVALID_CERT_HASH */ ]: "The SHA-1 certificate hash provided is invalid.",
        ["invalid-credential" /* INVALID_IDP_RESPONSE */ ]: "The supplied auth credential is malformed or has expired.",
        ["invalid-message-payload" /* INVALID_MESSAGE_PAYLOAD */ ]: "The email template corresponding to this action contains invalid characters in its message. Please fix by going to the Auth email templates section in the Firebase Console.",
        ["invalid-multi-factor-session" /* INVALID_MFA_SESSION */ ]: "The request does not contain a valid proof of first factor successful sign-in.",
        ["invalid-oauth-provider" /* INVALID_OAUTH_PROVIDER */ ]: "EmailAuthProvider is not supported for this operation. This operation only supports OAuth providers.",
        ["invalid-oauth-client-id" /* INVALID_OAUTH_CLIENT_ID */ ]: "The OAuth client ID provided is either invalid or does not match the specified API key.",
        ["unauthorized-domain" /* INVALID_ORIGIN */ ]: "This domain is not authorized for OAuth operations for your Firebase project. Edit the list of authorized domains from the Firebase console.",
        ["invalid-action-code" /* INVALID_OOB_CODE */ ]: "The action code is invalid. This can happen if the code is malformed, expired, or has already been used.",
        ["wrong-password" /* INVALID_PASSWORD */ ]: "The password is invalid or the user does not have a password.",
        ["invalid-persistence-type" /* INVALID_PERSISTENCE */ ]: "The specified persistence type is invalid. It can only be local, session or none.",
        ["invalid-phone-number" /* INVALID_PHONE_NUMBER */ ]: "The format of the phone number provided is incorrect. Please enter the phone number in a format that can be parsed into E.164 format. E.164 phone numbers are written in the format [+][country code][subscriber number including area code].",
        ["invalid-provider-id" /* INVALID_PROVIDER_ID */ ]: "The specified provider ID is invalid.",
        ["invalid-recipient-email" /* INVALID_RECIPIENT_EMAIL */ ]: "The email corresponding to this action failed to send as the provided recipient email address is invalid.",
        ["invalid-sender" /* INVALID_SENDER */ ]: "The email template corresponding to this action contains an invalid sender email or name. Please fix by going to the Auth email templates section in the Firebase Console.",
        ["invalid-verification-id" /* INVALID_SESSION_INFO */ ]: "The verification ID used to create the phone auth credential is invalid.",
        ["invalid-tenant-id" /* INVALID_TENANT_ID */ ]: "The Auth instance's tenant ID is invalid.",
        ["login-blocked" /* LOGIN_BLOCKED */ ]: "Login blocked by user-provided method: {$originalMessage}",
        ["missing-android-pkg-name" /* MISSING_ANDROID_PACKAGE_NAME */ ]: "An Android Package Name must be provided if the Android App is required to be installed.",
        ["auth-domain-config-required" /* MISSING_AUTH_DOMAIN */ ]: "Be sure to include authDomain when calling firebase.initializeApp(), by following the instructions in the Firebase console.",
        ["missing-app-credential" /* MISSING_APP_CREDENTIAL */ ]: "The phone verification request is missing an application verifier assertion. A reCAPTCHA response token needs to be provided.",
        ["missing-verification-code" /* MISSING_CODE */ ]: "The phone auth credential was created with an empty SMS verification code.",
        ["missing-continue-uri" /* MISSING_CONTINUE_URI */ ]: "A continue URL must be provided in the request.",
        ["missing-iframe-start" /* MISSING_IFRAME_START */ ]: "An internal AuthError has occurred.",
        ["missing-ios-bundle-id" /* MISSING_IOS_BUNDLE_ID */ ]: "An iOS Bundle ID must be provided if an App Store ID is provided.",
        ["missing-or-invalid-nonce" /* MISSING_OR_INVALID_NONCE */ ]: "The request does not contain a valid nonce. This can occur if the SHA-256 hash of the provided raw nonce does not match the hashed nonce in the ID token payload.",
        ["missing-multi-factor-info" /* MISSING_MFA_INFO */ ]: "No second factor identifier is provided.",
        ["missing-multi-factor-session" /* MISSING_MFA_SESSION */ ]: "The request is missing proof of first factor successful sign-in.",
        ["missing-phone-number" /* MISSING_PHONE_NUMBER */ ]: "To send verification codes, provide a phone number for the recipient.",
        ["missing-verification-id" /* MISSING_SESSION_INFO */ ]: "The phone auth credential was created with an empty verification ID.",
        ["app-deleted" /* MODULE_DESTROYED */ ]: "This instance of FirebaseApp has been deleted.",
        ["multi-factor-info-not-found" /* MFA_INFO_NOT_FOUND */ ]: "The user does not have a second factor matching the identifier provided.",
        ["multi-factor-auth-required" /* MFA_REQUIRED */ ]: "Proof of ownership of a second factor is required to complete sign-in.",
        ["account-exists-with-different-credential" /* NEED_CONFIRMATION */ ]: "An account already exists with the same email address but different sign-in credentials. Sign in using a provider associated with this email address.",
        ["network-request-failed" /* NETWORK_REQUEST_FAILED */ ]: "A network AuthError (such as timeout, interrupted connection or unreachable host) has occurred.",
        ["no-auth-event" /* NO_AUTH_EVENT */ ]: "An internal AuthError has occurred.",
        ["no-such-provider" /* NO_SUCH_PROVIDER */ ]: "User was not linked to an account with the given provider.",
        ["null-user" /* NULL_USER */ ]: "A null user object was provided as the argument for an operation which requires a non-null user object.",
        ["operation-not-allowed" /* OPERATION_NOT_ALLOWED */ ]: "The given sign-in provider is disabled for this Firebase project. Enable it in the Firebase console, under the sign-in method tab of the Auth section.",
        ["operation-not-supported-in-this-environment" /* OPERATION_NOT_SUPPORTED */ ]: 'This operation is not supported in the environment this application is running on. "location.protocol" must be http, https or chrome-extension and web storage must be enabled.',
        ["popup-blocked" /* POPUP_BLOCKED */ ]: "Unable to establish a connection with the popup. It may have been blocked by the browser.",
        ["popup-closed-by-user" /* POPUP_CLOSED_BY_USER */ ]: "The popup has been closed by the user before finalizing the operation.",
        ["provider-already-linked" /* PROVIDER_ALREADY_LINKED */ ]: "User can only be linked to one identity for the given provider.",
        ["quota-exceeded" /* QUOTA_EXCEEDED */ ]: "The project's quota for this operation has been exceeded.",
        ["redirect-cancelled-by-user" /* REDIRECT_CANCELLED_BY_USER */ ]: "The redirect operation has been cancelled by the user before finalizing.",
        ["redirect-operation-pending" /* REDIRECT_OPERATION_PENDING */ ]: "A redirect sign-in operation is already pending.",
        ["rejected-credential" /* REJECTED_CREDENTIAL */ ]: "The request contains malformed or mismatching credentials.",
        ["second-factor-already-in-use" /* SECOND_FACTOR_ALREADY_ENROLLED */ ]: "The second factor is already enrolled on this account.",
        ["maximum-second-factor-count-exceeded" /* SECOND_FACTOR_LIMIT_EXCEEDED */ ]: "The maximum allowed number of second factors on a user has been exceeded.",
        ["tenant-id-mismatch" /* TENANT_ID_MISMATCH */ ]: "The provided tenant ID does not match the Auth instance's tenant ID",
        ["timeout" /* TIMEOUT */ ]: "The operation has timed out.",
        ["user-token-expired" /* TOKEN_EXPIRED */ ]: "The user's credential is no longer valid. The user must sign in again.",
        ["too-many-requests" /* TOO_MANY_ATTEMPTS_TRY_LATER */ ]: "We have blocked all requests from this device due to unusual activity. Try again later.",
        ["unauthorized-continue-uri" /* UNAUTHORIZED_DOMAIN */ ]: "The domain of the continue URL is not whitelisted.  Please whitelist the domain in the Firebase console.",
        ["unsupported-first-factor" /* UNSUPPORTED_FIRST_FACTOR */ ]: "Enrolling a second factor or signing in with a multi-factor account requires sign-in with a supported first factor.",
        ["unsupported-persistence-type" /* UNSUPPORTED_PERSISTENCE */ ]: "The current environment does not support the specified persistence type.",
        ["unsupported-tenant-operation" /* UNSUPPORTED_TENANT_OPERATION */ ]: "This operation is not supported in a multi-tenant context.",
        ["unverified-email" /* UNVERIFIED_EMAIL */ ]: "The operation requires a verified email.",
        ["user-cancelled" /* USER_CANCELLED */ ]: "The user did not grant your application the permissions it requested.",
        ["user-not-found" /* USER_DELETED */ ]: "There is no user record corresponding to this identifier. The user may have been deleted.",
        ["user-disabled" /* USER_DISABLED */ ]: "The user account has been disabled by an administrator.",
        ["user-mismatch" /* USER_MISMATCH */ ]: "The supplied credentials do not correspond to the previously signed in user.",
        ["user-signed-out" /* USER_SIGNED_OUT */ ]: "",
        ["weak-password" /* WEAK_PASSWORD */ ]: "The password must be 6 characters long or more.",
        ["web-storage-unsupported" /* WEB_STORAGE_UNSUPPORTED */ ]: "This browser is not supported or 3rd party cookies and data may be disabled.",
        ["already-initialized" /* ALREADY_INITIALIZED */ ]: "initializeAuth() has already been called with different options. To avoid this error, call initializeAuth() with the same options as when it was originally called, or call getAuth() to return the already initialized instance."
    };
}
function $8fd3c2447d7c53c3$var$_prodErrorMap() {
    // We will include this one message in the prod error map since by the very
    // nature of this error, developers will never be able to see the message
    // using the debugErrorMap (which is installed during auth initialization).
    return {
        ["dependent-sdk-initialized-before-auth" /* DEPENDENT_SDK_INIT_BEFORE_AUTH */ ]: "Another Firebase SDK was initialized and is trying to use Auth before Auth is initialized. Please be sure to call `initializeAuth` or `getAuth` before starting any other Firebase SDK."
    };
}
/**
 * A verbose error map with detailed descriptions for most error codes.
 *
 * See discussion at {@link AuthErrorMap}
 *
 * @public
 */ const $8fd3c2447d7c53c3$export$ef35774e6d314e91 = $8fd3c2447d7c53c3$var$_debugErrorMap;
/**
 * A minimal error map with all verbose error messages stripped.
 *
 * See discussion at {@link AuthErrorMap}
 *
 * @public
 */ const $8fd3c2447d7c53c3$export$e7094788287c5e9b = $8fd3c2447d7c53c3$var$_prodErrorMap;
const $8fd3c2447d7c53c3$var$_DEFAULT_AUTH_ERROR_FACTORY = new (0, $6vM9o.ErrorFactory)("auth", "Firebase", $8fd3c2447d7c53c3$var$_prodErrorMap());
/**
 * A map of potential `Auth` error codes, for easier comparison with errors
 * thrown by the SDK.
 *
 * @remarks
 * Note that you can't tree-shake individual keys
 * in the map, so by using the map you might substantially increase your
 * bundle size.
 *
 * @public
 */ const $8fd3c2447d7c53c3$export$96f57966bedc81b4 = {
    ADMIN_ONLY_OPERATION: "auth/admin-restricted-operation",
    ARGUMENT_ERROR: "auth/argument-error",
    APP_NOT_AUTHORIZED: "auth/app-not-authorized",
    APP_NOT_INSTALLED: "auth/app-not-installed",
    CAPTCHA_CHECK_FAILED: "auth/captcha-check-failed",
    CODE_EXPIRED: "auth/code-expired",
    CORDOVA_NOT_READY: "auth/cordova-not-ready",
    CORS_UNSUPPORTED: "auth/cors-unsupported",
    CREDENTIAL_ALREADY_IN_USE: "auth/credential-already-in-use",
    CREDENTIAL_MISMATCH: "auth/custom-token-mismatch",
    CREDENTIAL_TOO_OLD_LOGIN_AGAIN: "auth/requires-recent-login",
    DEPENDENT_SDK_INIT_BEFORE_AUTH: "auth/dependent-sdk-initialized-before-auth",
    DYNAMIC_LINK_NOT_ACTIVATED: "auth/dynamic-link-not-activated",
    EMAIL_CHANGE_NEEDS_VERIFICATION: "auth/email-change-needs-verification",
    EMAIL_EXISTS: "auth/email-already-in-use",
    EMULATOR_CONFIG_FAILED: "auth/emulator-config-failed",
    EXPIRED_OOB_CODE: "auth/expired-action-code",
    EXPIRED_POPUP_REQUEST: "auth/cancelled-popup-request",
    INTERNAL_ERROR: "auth/internal-error",
    INVALID_API_KEY: "auth/invalid-api-key",
    INVALID_APP_CREDENTIAL: "auth/invalid-app-credential",
    INVALID_APP_ID: "auth/invalid-app-id",
    INVALID_AUTH: "auth/invalid-user-token",
    INVALID_AUTH_EVENT: "auth/invalid-auth-event",
    INVALID_CERT_HASH: "auth/invalid-cert-hash",
    INVALID_CODE: "auth/invalid-verification-code",
    INVALID_CONTINUE_URI: "auth/invalid-continue-uri",
    INVALID_CORDOVA_CONFIGURATION: "auth/invalid-cordova-configuration",
    INVALID_CUSTOM_TOKEN: "auth/invalid-custom-token",
    INVALID_DYNAMIC_LINK_DOMAIN: "auth/invalid-dynamic-link-domain",
    INVALID_EMAIL: "auth/invalid-email",
    INVALID_EMULATOR_SCHEME: "auth/invalid-emulator-scheme",
    INVALID_IDP_RESPONSE: "auth/invalid-credential",
    INVALID_MESSAGE_PAYLOAD: "auth/invalid-message-payload",
    INVALID_MFA_SESSION: "auth/invalid-multi-factor-session",
    INVALID_OAUTH_CLIENT_ID: "auth/invalid-oauth-client-id",
    INVALID_OAUTH_PROVIDER: "auth/invalid-oauth-provider",
    INVALID_OOB_CODE: "auth/invalid-action-code",
    INVALID_ORIGIN: "auth/unauthorized-domain",
    INVALID_PASSWORD: "auth/wrong-password",
    INVALID_PERSISTENCE: "auth/invalid-persistence-type",
    INVALID_PHONE_NUMBER: "auth/invalid-phone-number",
    INVALID_PROVIDER_ID: "auth/invalid-provider-id",
    INVALID_RECIPIENT_EMAIL: "auth/invalid-recipient-email",
    INVALID_SENDER: "auth/invalid-sender",
    INVALID_SESSION_INFO: "auth/invalid-verification-id",
    INVALID_TENANT_ID: "auth/invalid-tenant-id",
    MFA_INFO_NOT_FOUND: "auth/multi-factor-info-not-found",
    MFA_REQUIRED: "auth/multi-factor-auth-required",
    MISSING_ANDROID_PACKAGE_NAME: "auth/missing-android-pkg-name",
    MISSING_APP_CREDENTIAL: "auth/missing-app-credential",
    MISSING_AUTH_DOMAIN: "auth/auth-domain-config-required",
    MISSING_CODE: "auth/missing-verification-code",
    MISSING_CONTINUE_URI: "auth/missing-continue-uri",
    MISSING_IFRAME_START: "auth/missing-iframe-start",
    MISSING_IOS_BUNDLE_ID: "auth/missing-ios-bundle-id",
    MISSING_OR_INVALID_NONCE: "auth/missing-or-invalid-nonce",
    MISSING_MFA_INFO: "auth/missing-multi-factor-info",
    MISSING_MFA_SESSION: "auth/missing-multi-factor-session",
    MISSING_PHONE_NUMBER: "auth/missing-phone-number",
    MISSING_SESSION_INFO: "auth/missing-verification-id",
    MODULE_DESTROYED: "auth/app-deleted",
    NEED_CONFIRMATION: "auth/account-exists-with-different-credential",
    NETWORK_REQUEST_FAILED: "auth/network-request-failed",
    NULL_USER: "auth/null-user",
    NO_AUTH_EVENT: "auth/no-auth-event",
    NO_SUCH_PROVIDER: "auth/no-such-provider",
    OPERATION_NOT_ALLOWED: "auth/operation-not-allowed",
    OPERATION_NOT_SUPPORTED: "auth/operation-not-supported-in-this-environment",
    POPUP_BLOCKED: "auth/popup-blocked",
    POPUP_CLOSED_BY_USER: "auth/popup-closed-by-user",
    PROVIDER_ALREADY_LINKED: "auth/provider-already-linked",
    QUOTA_EXCEEDED: "auth/quota-exceeded",
    REDIRECT_CANCELLED_BY_USER: "auth/redirect-cancelled-by-user",
    REDIRECT_OPERATION_PENDING: "auth/redirect-operation-pending",
    REJECTED_CREDENTIAL: "auth/rejected-credential",
    SECOND_FACTOR_ALREADY_ENROLLED: "auth/second-factor-already-in-use",
    SECOND_FACTOR_LIMIT_EXCEEDED: "auth/maximum-second-factor-count-exceeded",
    TENANT_ID_MISMATCH: "auth/tenant-id-mismatch",
    TIMEOUT: "auth/timeout",
    TOKEN_EXPIRED: "auth/user-token-expired",
    TOO_MANY_ATTEMPTS_TRY_LATER: "auth/too-many-requests",
    UNAUTHORIZED_DOMAIN: "auth/unauthorized-continue-uri",
    UNSUPPORTED_FIRST_FACTOR: "auth/unsupported-first-factor",
    UNSUPPORTED_PERSISTENCE: "auth/unsupported-persistence-type",
    UNSUPPORTED_TENANT_OPERATION: "auth/unsupported-tenant-operation",
    UNVERIFIED_EMAIL: "auth/unverified-email",
    USER_CANCELLED: "auth/user-cancelled",
    USER_DELETED: "auth/user-not-found",
    USER_DISABLED: "auth/user-disabled",
    USER_MISMATCH: "auth/user-mismatch",
    USER_SIGNED_OUT: "auth/user-signed-out",
    WEAK_PASSWORD: "auth/weak-password",
    WEB_STORAGE_UNSUPPORTED: "auth/web-storage-unsupported",
    ALREADY_INITIALIZED: "auth/already-initialized"
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $8fd3c2447d7c53c3$var$logClient = new (0, $bfcN2.Logger)("@firebase/auth");
function $8fd3c2447d7c53c3$var$_logError(msg, ...args) {
    if ($8fd3c2447d7c53c3$var$logClient.logLevel <= (0, $bfcN2.LogLevel).ERROR) $8fd3c2447d7c53c3$var$logClient.error(`Auth (${(0, $iXpG9.SDK_VERSION)}): ${msg}`, ...args);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $8fd3c2447d7c53c3$export$493d36ec626b6698(authOrCode, ...rest) {
    throw $8fd3c2447d7c53c3$var$createErrorInternal(authOrCode, ...rest);
}
function $8fd3c2447d7c53c3$export$92108d983e8ee699(authOrCode, ...rest) {
    return $8fd3c2447d7c53c3$var$createErrorInternal(authOrCode, ...rest);
}
function $8fd3c2447d7c53c3$var$_errorWithCustomMessage(auth, code, message) {
    const errorMap = Object.assign(Object.assign({}, $8fd3c2447d7c53c3$export$e7094788287c5e9b()), {
        [code]: message
    });
    const factory = new (0, $6vM9o.ErrorFactory)("auth", "Firebase", errorMap);
    return factory.create(code, {
        appName: auth.name
    });
}
function $8fd3c2447d7c53c3$var$_assertInstanceOf(auth, object, instance) {
    const constructorInstance = instance;
    if (!(object instanceof constructorInstance)) {
        if (constructorInstance.name !== object.constructor.name) $8fd3c2447d7c53c3$export$493d36ec626b6698(auth, "argument-error" /* ARGUMENT_ERROR */ );
        throw $8fd3c2447d7c53c3$var$_errorWithCustomMessage(auth, "argument-error" /* ARGUMENT_ERROR */ , `Type of ${object.constructor.name} does not match expected instance.` + `Did you pass a reference from a different Auth SDK?`);
    }
}
function $8fd3c2447d7c53c3$var$createErrorInternal(authOrCode, ...rest) {
    if (typeof authOrCode !== "string") {
        const code = rest[0];
        const fullParams = [
            ...rest.slice(1)
        ];
        if (fullParams[0]) fullParams[0].appName = authOrCode.name;
        return authOrCode._errorFactory.create(code, ...fullParams);
    }
    return $8fd3c2447d7c53c3$var$_DEFAULT_AUTH_ERROR_FACTORY.create(authOrCode, ...rest);
}
function $8fd3c2447d7c53c3$export$9fa96a7d116ea3ce(assertion, authOrCode, ...rest) {
    if (!assertion) throw $8fd3c2447d7c53c3$var$createErrorInternal(authOrCode, ...rest);
}
/**
 * Unconditionally fails, throwing an internal error with the given message.
 *
 * @param failure type of failure encountered
 * @throws Error
 */ function $8fd3c2447d7c53c3$var$debugFail(failure) {
    // Log the failure in addition to throw an exception, just in case the
    // exception is swallowed.
    const message = `INTERNAL ASSERTION FAILED: ` + failure;
    $8fd3c2447d7c53c3$var$_logError(message);
    // NOTE: We don't use FirebaseError here because these are internal failures
    // that cannot be handled by the user. (Also it would create a circular
    // dependency between the error and assert modules which doesn't work.)
    throw new Error(message);
}
/**
 * Fails if the given assertion condition is false, throwing an Error with the
 * given message if it did.
 *
 * @param assertion
 * @param message
 */ function $8fd3c2447d7c53c3$export$8a5498727ef6be21(assertion, message) {
    if (!assertion) $8fd3c2447d7c53c3$var$debugFail(message);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $8fd3c2447d7c53c3$var$instanceCache = new Map();
function $8fd3c2447d7c53c3$export$28f7fcd39efa255(cls) {
    $8fd3c2447d7c53c3$export$8a5498727ef6be21(cls instanceof Function, "Expected a class definition");
    let instance = $8fd3c2447d7c53c3$var$instanceCache.get(cls);
    if (instance) {
        $8fd3c2447d7c53c3$export$8a5498727ef6be21(instance instanceof cls, "Instance stored in cache mismatched with class");
        return instance;
    }
    instance = new cls();
    $8fd3c2447d7c53c3$var$instanceCache.set(cls, instance);
    return instance;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Initializes an {@link Auth} instance with fine-grained control over
 * {@link Dependencies}.
 *
 * @remarks
 *
 * This function allows more control over the {@link Auth} instance than
 * {@link getAuth}. `getAuth` uses platform-specific defaults to supply
 * the {@link Dependencies}. In general, `getAuth` is the easiest way to
 * initialize Auth and works for most use cases. Use `initializeAuth` if you
 * need control over which persistence layer is used, or to minimize bundle
 * size if you're not using either `signInWithPopup` or `signInWithRedirect`.
 *
 * For example, if your app only uses anonymous accounts and you only want
 * accounts saved for the current session, initialize `Auth` with:
 *
 * ```js
 * const auth = initializeAuth(app, {
 *   persistence: browserSessionPersistence,
 *   popupRedirectResolver: undefined,
 * });
 * ```
 *
 * @public
 */ function $8fd3c2447d7c53c3$export$a9c23c6ac3fc3eca(app, deps) {
    const provider = (0, $iXpG9._getProvider)(app, "auth");
    if (provider.isInitialized()) {
        const auth = provider.getImmediate();
        const initialOptions = provider.getOptions();
        if ((0, $6vM9o.deepEqual)(initialOptions, deps !== null && deps !== void 0 ? deps : {})) return auth;
        else $8fd3c2447d7c53c3$export$493d36ec626b6698(auth, "already-initialized" /* ALREADY_INITIALIZED */ );
    }
    const auth = provider.initialize({
        options: deps
    });
    return auth;
}
function $8fd3c2447d7c53c3$var$_initializeAuthInstance(auth, deps) {
    const persistence = (deps === null || deps === void 0 ? void 0 : deps.persistence) || [];
    const hierarchy = (Array.isArray(persistence) ? persistence : [
        persistence
    ]).map($8fd3c2447d7c53c3$export$28f7fcd39efa255);
    if (deps === null || deps === void 0 ? void 0 : deps.errorMap) auth._updateErrorMap(deps.errorMap);
    // This promise is intended to float; auth initialization happens in the
    // background, meanwhile the auth object may be used by the app.
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    auth._initializeWithPersistence(hierarchy, deps === null || deps === void 0 ? void 0 : deps.popupRedirectResolver);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $8fd3c2447d7c53c3$var$_getCurrentUrl() {
    var _a;
    return typeof self !== "undefined" && ((_a = self.location) === null || _a === void 0 ? void 0 : _a.href) || "";
}
function $8fd3c2447d7c53c3$var$_isHttpOrHttps() {
    return $8fd3c2447d7c53c3$var$_getCurrentScheme() === "http:" || $8fd3c2447d7c53c3$var$_getCurrentScheme() === "https:";
}
function $8fd3c2447d7c53c3$var$_getCurrentScheme() {
    var _a;
    return typeof self !== "undefined" && ((_a = self.location) === null || _a === void 0 ? void 0 : _a.protocol) || null;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Determine whether the browser is working online
 */ function $8fd3c2447d7c53c3$var$_isOnline() {
    if (typeof navigator !== "undefined" && navigator && "onLine" in navigator && typeof navigator.onLine === "boolean" && // Apply only for traditional web apps and Chrome extensions.
    // This is especially true for Cordova apps which have unreliable
    // navigator.onLine behavior unless cordova-plugin-network-information is
    // installed which overwrites the native navigator.onLine value and
    // defines navigator.connection.
    ($8fd3c2447d7c53c3$var$_isHttpOrHttps() || (0, $6vM9o.isBrowserExtension)() || "connection" in navigator)) return navigator.onLine;
    // If we can't determine the state, assume it is online.
    return true;
}
function $8fd3c2447d7c53c3$var$_getUserLanguage() {
    if (typeof navigator === "undefined") return null;
    const navigatorLanguage = navigator;
    return(// Most reliable, but only supported in Chrome/Firefox.
    navigatorLanguage.languages && navigatorLanguage.languages[0] || // Supported in most browsers, but returns the language of the browser
    // UI, not the language set in browser settings.
    navigatorLanguage.language || // Couldn't determine language.
    null);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A structure to help pick between a range of long and short delay durations
 * depending on the current environment. In general, the long delay is used for
 * mobile environments whereas short delays are used for desktop environments.
 */ class $8fd3c2447d7c53c3$var$Delay {
    get() {
        if (!$8fd3c2447d7c53c3$var$_isOnline()) // Pick the shorter timeout.
        return Math.min(5000 /* OFFLINE */ , this.shortDelay);
        // If running in a mobile environment, return the long delay, otherwise
        // return the short delay.
        // This could be improved in the future to dynamically change based on other
        // variables instead of just reading the current environment.
        return this.isMobile ? this.longDelay : this.shortDelay;
    }
    constructor(shortDelay, longDelay){
        this.shortDelay = shortDelay;
        this.longDelay = longDelay;
        // Internal error when improperly initialized.
        $8fd3c2447d7c53c3$export$8a5498727ef6be21(longDelay > shortDelay, "Short delay should be less than long delay!");
        this.isMobile = (0, $6vM9o.isMobileCordova)() || (0, $6vM9o.isReactNative)();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $8fd3c2447d7c53c3$var$_emulatorUrl(config, path) {
    $8fd3c2447d7c53c3$export$8a5498727ef6be21(config.emulator, "Emulator should always be set here");
    const { url: url } = config.emulator;
    if (!path) return url;
    return `${url}${path.startsWith("/") ? path.slice(1) : path}`;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $8fd3c2447d7c53c3$export$23ebac1979863676 {
    static initialize(fetchImpl, headersImpl, responseImpl) {
        this.fetchImpl = fetchImpl;
        if (headersImpl) this.headersImpl = headersImpl;
        if (responseImpl) this.responseImpl = responseImpl;
    }
    static fetch() {
        if (this.fetchImpl) return this.fetchImpl;
        if (typeof self !== "undefined" && "fetch" in self) return self.fetch;
        $8fd3c2447d7c53c3$var$debugFail("Could not find fetch implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill");
    }
    static headers() {
        if (this.headersImpl) return this.headersImpl;
        if (typeof self !== "undefined" && "Headers" in self) return self.Headers;
        $8fd3c2447d7c53c3$var$debugFail("Could not find Headers implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill");
    }
    static response() {
        if (this.responseImpl) return this.responseImpl;
        if (typeof self !== "undefined" && "Response" in self) return self.Response;
        $8fd3c2447d7c53c3$var$debugFail("Could not find Response implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill");
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Map from errors returned by the server to errors to developer visible errors
 */ const $8fd3c2447d7c53c3$var$SERVER_ERROR_MAP = {
    // Custom token errors.
    ["CREDENTIAL_MISMATCH" /* CREDENTIAL_MISMATCH */ ]: "custom-token-mismatch" /* CREDENTIAL_MISMATCH */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_CUSTOM_TOKEN" /* MISSING_CUSTOM_TOKEN */ ]: "internal-error" /* INTERNAL_ERROR */ ,
    // Create Auth URI errors.
    ["INVALID_IDENTIFIER" /* INVALID_IDENTIFIER */ ]: "invalid-email" /* INVALID_EMAIL */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_CONTINUE_URI" /* MISSING_CONTINUE_URI */ ]: "internal-error" /* INTERNAL_ERROR */ ,
    // Sign in with email and password errors (some apply to sign up too).
    ["INVALID_PASSWORD" /* INVALID_PASSWORD */ ]: "wrong-password" /* INVALID_PASSWORD */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_PASSWORD" /* MISSING_PASSWORD */ ]: "internal-error" /* INTERNAL_ERROR */ ,
    // Sign up with email and password errors.
    ["EMAIL_EXISTS" /* EMAIL_EXISTS */ ]: "email-already-in-use" /* EMAIL_EXISTS */ ,
    ["PASSWORD_LOGIN_DISABLED" /* PASSWORD_LOGIN_DISABLED */ ]: "operation-not-allowed" /* OPERATION_NOT_ALLOWED */ ,
    // Verify assertion for sign in with credential errors:
    ["INVALID_IDP_RESPONSE" /* INVALID_IDP_RESPONSE */ ]: "invalid-credential" /* INVALID_IDP_RESPONSE */ ,
    ["INVALID_PENDING_TOKEN" /* INVALID_PENDING_TOKEN */ ]: "invalid-credential" /* INVALID_IDP_RESPONSE */ ,
    ["FEDERATED_USER_ID_ALREADY_LINKED" /* FEDERATED_USER_ID_ALREADY_LINKED */ ]: "credential-already-in-use" /* CREDENTIAL_ALREADY_IN_USE */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_REQ_TYPE" /* MISSING_REQ_TYPE */ ]: "internal-error" /* INTERNAL_ERROR */ ,
    // Send Password reset email errors:
    ["EMAIL_NOT_FOUND" /* EMAIL_NOT_FOUND */ ]: "user-not-found" /* USER_DELETED */ ,
    ["RESET_PASSWORD_EXCEED_LIMIT" /* RESET_PASSWORD_EXCEED_LIMIT */ ]: "too-many-requests" /* TOO_MANY_ATTEMPTS_TRY_LATER */ ,
    ["EXPIRED_OOB_CODE" /* EXPIRED_OOB_CODE */ ]: "expired-action-code" /* EXPIRED_OOB_CODE */ ,
    ["INVALID_OOB_CODE" /* INVALID_OOB_CODE */ ]: "invalid-action-code" /* INVALID_OOB_CODE */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_OOB_CODE" /* MISSING_OOB_CODE */ ]: "internal-error" /* INTERNAL_ERROR */ ,
    // Operations that require ID token in request:
    ["CREDENTIAL_TOO_OLD_LOGIN_AGAIN" /* CREDENTIAL_TOO_OLD_LOGIN_AGAIN */ ]: "requires-recent-login" /* CREDENTIAL_TOO_OLD_LOGIN_AGAIN */ ,
    ["INVALID_ID_TOKEN" /* INVALID_ID_TOKEN */ ]: "invalid-user-token" /* INVALID_AUTH */ ,
    ["TOKEN_EXPIRED" /* TOKEN_EXPIRED */ ]: "user-token-expired" /* TOKEN_EXPIRED */ ,
    ["USER_NOT_FOUND" /* USER_NOT_FOUND */ ]: "user-token-expired" /* TOKEN_EXPIRED */ ,
    // Other errors.
    ["TOO_MANY_ATTEMPTS_TRY_LATER" /* TOO_MANY_ATTEMPTS_TRY_LATER */ ]: "too-many-requests" /* TOO_MANY_ATTEMPTS_TRY_LATER */ ,
    // Phone Auth related errors.
    ["INVALID_CODE" /* INVALID_CODE */ ]: "invalid-verification-code" /* INVALID_CODE */ ,
    ["INVALID_SESSION_INFO" /* INVALID_SESSION_INFO */ ]: "invalid-verification-id" /* INVALID_SESSION_INFO */ ,
    ["INVALID_TEMPORARY_PROOF" /* INVALID_TEMPORARY_PROOF */ ]: "invalid-credential" /* INVALID_IDP_RESPONSE */ ,
    ["MISSING_SESSION_INFO" /* MISSING_SESSION_INFO */ ]: "missing-verification-id" /* MISSING_SESSION_INFO */ ,
    ["SESSION_EXPIRED" /* SESSION_EXPIRED */ ]: "code-expired" /* CODE_EXPIRED */ ,
    // Other action code errors when additional settings passed.
    // MISSING_CONTINUE_URI is getting mapped to INTERNAL_ERROR above.
    // This is OK as this error will be caught by client side validation.
    ["MISSING_ANDROID_PACKAGE_NAME" /* MISSING_ANDROID_PACKAGE_NAME */ ]: "missing-android-pkg-name" /* MISSING_ANDROID_PACKAGE_NAME */ ,
    ["UNAUTHORIZED_DOMAIN" /* UNAUTHORIZED_DOMAIN */ ]: "unauthorized-continue-uri" /* UNAUTHORIZED_DOMAIN */ ,
    // getProjectConfig errors when clientId is passed.
    ["INVALID_OAUTH_CLIENT_ID" /* INVALID_OAUTH_CLIENT_ID */ ]: "invalid-oauth-client-id" /* INVALID_OAUTH_CLIENT_ID */ ,
    // User actions (sign-up or deletion) disabled errors.
    ["ADMIN_ONLY_OPERATION" /* ADMIN_ONLY_OPERATION */ ]: "admin-restricted-operation" /* ADMIN_ONLY_OPERATION */ ,
    // Multi factor related errors.
    ["INVALID_MFA_PENDING_CREDENTIAL" /* INVALID_MFA_PENDING_CREDENTIAL */ ]: "invalid-multi-factor-session" /* INVALID_MFA_SESSION */ ,
    ["MFA_ENROLLMENT_NOT_FOUND" /* MFA_ENROLLMENT_NOT_FOUND */ ]: "multi-factor-info-not-found" /* MFA_INFO_NOT_FOUND */ ,
    ["MISSING_MFA_ENROLLMENT_ID" /* MISSING_MFA_ENROLLMENT_ID */ ]: "missing-multi-factor-info" /* MISSING_MFA_INFO */ ,
    ["MISSING_MFA_PENDING_CREDENTIAL" /* MISSING_MFA_PENDING_CREDENTIAL */ ]: "missing-multi-factor-session" /* MISSING_MFA_SESSION */ ,
    ["SECOND_FACTOR_EXISTS" /* SECOND_FACTOR_EXISTS */ ]: "second-factor-already-in-use" /* SECOND_FACTOR_ALREADY_ENROLLED */ ,
    ["SECOND_FACTOR_LIMIT_EXCEEDED" /* SECOND_FACTOR_LIMIT_EXCEEDED */ ]: "maximum-second-factor-count-exceeded" /* SECOND_FACTOR_LIMIT_EXCEEDED */ ,
    // Blocking functions related errors.
    ["BLOCKING_FUNCTION_ERROR_RESPONSE" /* BLOCKING_FUNCTION_ERROR_RESPONSE */ ]: "internal-error" /* INTERNAL_ERROR */ 
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $8fd3c2447d7c53c3$var$DEFAULT_API_TIMEOUT_MS = new $8fd3c2447d7c53c3$var$Delay(30000, 60000);
function $8fd3c2447d7c53c3$var$_addTidIfNecessary(auth, request) {
    if (auth.tenantId && !request.tenantId) return Object.assign(Object.assign({}, request), {
        tenantId: auth.tenantId
    });
    return request;
}
async function $8fd3c2447d7c53c3$var$_performApiRequest(auth, method, path, request, customErrorMap = {}) {
    return $8fd3c2447d7c53c3$var$_performFetchWithErrorHandling(auth, customErrorMap, async ()=>{
        let body = {};
        let params = {};
        if (request) {
            if (method === "GET" /* GET */ ) params = request;
            else body = {
                body: JSON.stringify(request)
            };
        }
        const query = (0, $6vM9o.querystring)(Object.assign({
            key: auth.config.apiKey
        }, params)).slice(1);
        const headers = await auth._getAdditionalHeaders();
        headers["Content-Type" /* CONTENT_TYPE */ ] = "application/json";
        if (auth.languageCode) headers["X-Firebase-Locale" /* X_FIREBASE_LOCALE */ ] = auth.languageCode;
        return $8fd3c2447d7c53c3$export$23ebac1979863676.fetch()($8fd3c2447d7c53c3$var$_getFinalTarget(auth, auth.config.apiHost, path, query), Object.assign({
            method: method,
            headers: headers,
            referrerPolicy: "no-referrer"
        }, body));
    });
}
async function $8fd3c2447d7c53c3$var$_performFetchWithErrorHandling(auth, customErrorMap, fetchFn) {
    auth._canInitEmulator = false;
    const errorMap = Object.assign(Object.assign({}, $8fd3c2447d7c53c3$var$SERVER_ERROR_MAP), customErrorMap);
    try {
        const networkTimeout = new $8fd3c2447d7c53c3$var$NetworkTimeout(auth);
        const response = await Promise.race([
            fetchFn(),
            networkTimeout.promise
        ]);
        // If we've reached this point, the fetch succeeded and the networkTimeout
        // didn't throw; clear the network timeout delay so that Node won't hang
        networkTimeout.clearNetworkTimeout();
        const json = await response.json();
        if ("needConfirmation" in json) throw $8fd3c2447d7c53c3$var$_makeTaggedError(auth, "account-exists-with-different-credential" /* NEED_CONFIRMATION */ , json);
        if (response.ok && !("errorMessage" in json)) return json;
        else {
            const errorMessage = response.ok ? json.errorMessage : json.error.message;
            const [serverErrorCode, serverErrorMessage] = errorMessage.split(" : ");
            if (serverErrorCode === "FEDERATED_USER_ID_ALREADY_LINKED" /* FEDERATED_USER_ID_ALREADY_LINKED */ ) throw $8fd3c2447d7c53c3$var$_makeTaggedError(auth, "credential-already-in-use" /* CREDENTIAL_ALREADY_IN_USE */ , json);
            else if (serverErrorCode === "EMAIL_EXISTS" /* EMAIL_EXISTS */ ) throw $8fd3c2447d7c53c3$var$_makeTaggedError(auth, "email-already-in-use" /* EMAIL_EXISTS */ , json);
            else if (serverErrorCode === "USER_DISABLED" /* USER_DISABLED */ ) throw $8fd3c2447d7c53c3$var$_makeTaggedError(auth, "user-disabled" /* USER_DISABLED */ , json);
            const authError = errorMap[serverErrorCode] || serverErrorCode.toLowerCase().replace(/[_\s]+/g, "-");
            if (serverErrorMessage) throw $8fd3c2447d7c53c3$var$_errorWithCustomMessage(auth, authError, serverErrorMessage);
            else $8fd3c2447d7c53c3$export$493d36ec626b6698(auth, authError);
        }
    } catch (e) {
        if (e instanceof (0, $6vM9o.FirebaseError)) throw e;
        $8fd3c2447d7c53c3$export$493d36ec626b6698(auth, "network-request-failed" /* NETWORK_REQUEST_FAILED */ );
    }
}
async function $8fd3c2447d7c53c3$var$_performSignInRequest(auth, method, path, request, customErrorMap = {}) {
    const serverResponse = await $8fd3c2447d7c53c3$var$_performApiRequest(auth, method, path, request, customErrorMap);
    if ("mfaPendingCredential" in serverResponse) $8fd3c2447d7c53c3$export$493d36ec626b6698(auth, "multi-factor-auth-required" /* MFA_REQUIRED */ , {
        _serverResponse: serverResponse
    });
    return serverResponse;
}
function $8fd3c2447d7c53c3$var$_getFinalTarget(auth, host, path, query) {
    const base = `${host}${path}?${query}`;
    if (!auth.config.emulator) return `${auth.config.apiScheme}://${base}`;
    return $8fd3c2447d7c53c3$var$_emulatorUrl(auth.config, base);
}
class $8fd3c2447d7c53c3$var$NetworkTimeout {
    clearNetworkTimeout() {
        clearTimeout(this.timer);
    }
    constructor(auth){
        this.auth = auth;
        // Node timers and browser timers are fundamentally incompatible, but we
        // don't care about the value here
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.timer = null;
        this.promise = new Promise((_, reject)=>{
            this.timer = setTimeout(()=>{
                return reject($8fd3c2447d7c53c3$export$92108d983e8ee699(this.auth, "network-request-failed" /* NETWORK_REQUEST_FAILED */ ));
            }, $8fd3c2447d7c53c3$var$DEFAULT_API_TIMEOUT_MS.get());
        });
    }
}
function $8fd3c2447d7c53c3$var$_makeTaggedError(auth, code, response) {
    const errorParams = {
        appName: auth.name
    };
    if (response.email) errorParams.email = response.email;
    if (response.phoneNumber) errorParams.phoneNumber = response.phoneNumber;
    const error = $8fd3c2447d7c53c3$export$92108d983e8ee699(auth, code, errorParams);
    // We know customData is defined on error because errorParams is defined
    error.customData._tokenResponse = response;
    return error;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $8fd3c2447d7c53c3$var$deleteAccount(auth, request) {
    return $8fd3c2447d7c53c3$var$_performApiRequest(auth, "POST" /* POST */ , "/v1/accounts:delete" /* DELETE_ACCOUNT */ , request);
}
async function $8fd3c2447d7c53c3$var$deleteLinkedAccounts(auth, request) {
    return $8fd3c2447d7c53c3$var$_performApiRequest(auth, "POST" /* POST */ , "/v1/accounts:update" /* SET_ACCOUNT_INFO */ , request);
}
async function $8fd3c2447d7c53c3$var$getAccountInfo(auth, request) {
    return $8fd3c2447d7c53c3$var$_performApiRequest(auth, "POST" /* POST */ , "/v1/accounts:lookup" /* GET_ACCOUNT_INFO */ , request);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $8fd3c2447d7c53c3$var$utcTimestampToDateString(utcTimestamp) {
    if (!utcTimestamp) return undefined;
    try {
        // Convert to date object.
        const date = new Date(Number(utcTimestamp));
        // Test date is valid.
        if (!isNaN(date.getTime())) // Convert to UTC date string.
        return date.toUTCString();
    } catch (e) {
    // Do nothing. undefined will be returned.
    }
    return undefined;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a JSON Web Token (JWT) used to identify the user to a Firebase service.
 *
 * @remarks
 * Returns the current token if it has not expired or if it will not expire in the next five
 * minutes. Otherwise, this will refresh the token and return a new one.
 *
 * @param user - The user.
 * @param forceRefresh - Force refresh regardless of token expiration.
 *
 * @public
 */ function $8fd3c2447d7c53c3$export$f38c853ae54ed474(user, forceRefresh = false) {
    return (0, $6vM9o.getModularInstance)(user).getIdToken(forceRefresh);
}
/**
 * Returns a deserialized JSON Web Token (JWT) used to identitfy the user to a Firebase service.
 *
 * @remarks
 * Returns the current token if it has not expired or if it will not expire in the next five
 * minutes. Otherwise, this will refresh the token and return a new one.
 *
 * @param user - The user.
 * @param forceRefresh - Force refresh regardless of token expiration.
 *
 * @public
 */ async function $8fd3c2447d7c53c3$export$3b513254972cfc9c(user, forceRefresh = false) {
    const userInternal = (0, $6vM9o.getModularInstance)(user);
    const token = await userInternal.getIdToken(forceRefresh);
    const claims = $8fd3c2447d7c53c3$var$_parseToken(token);
    $8fd3c2447d7c53c3$export$9fa96a7d116ea3ce(claims && claims.exp && claims.auth_time && claims.iat, userInternal.auth, "internal-error" /* INTERNAL_ERROR */ );
    const firebase = typeof claims.firebase === "object" ? claims.firebase : undefined;
    const signInProvider = firebase === null || firebase === void 0 ? void 0 : firebase["sign_in_provider"];
    return {
        claims: claims,
        token: token,
        authTime: $8fd3c2447d7c53c3$var$utcTimestampToDateString($8fd3c2447d7c53c3$var$secondsStringToMilliseconds(claims.auth_time)),
        issuedAtTime: $8fd3c2447d7c53c3$var$utcTimestampToDateString($8fd3c2447d7c53c3$var$secondsStringToMilliseconds(claims.iat)),
        expirationTime: $8fd3c2447d7c53c3$var$utcTimestampToDateString($8fd3c2447d7c53c3$var$secondsStringToMilliseconds(claims.exp)),
        signInProvider: signInProvider || null,
        signInSecondFactor: (firebase === null || firebase === void 0 ? void 0 : firebase["sign_in_second_factor"]) || null
    };
}
function $8fd3c2447d7c53c3$var$secondsStringToMilliseconds(seconds) {
    return Number(seconds) * 1000;
}
function $8fd3c2447d7c53c3$var$_parseToken(token) {
    const [algorithm, payload, signature] = token.split(".");
    if (algorithm === undefined || payload === undefined || signature === undefined) {
        $8fd3c2447d7c53c3$var$_logError("JWT malformed, contained fewer than 3 sections");
        return null;
    }
    try {
        const decoded = (0, $6vM9o.base64Decode)(payload);
        if (!decoded) {
            $8fd3c2447d7c53c3$var$_logError("Failed to decode base64 JWT payload");
            return null;
        }
        return JSON.parse(decoded);
    } catch (e) {
        $8fd3c2447d7c53c3$var$_logError("Caught error parsing JWT payload as JSON", e);
        return null;
    }
}
/**
 * Extract expiresIn TTL from a token by subtracting the expiration from the issuance.
 */ function $8fd3c2447d7c53c3$var$_tokenExpiresIn(token) {
    const parsedToken = $8fd3c2447d7c53c3$var$_parseToken(token);
    $8fd3c2447d7c53c3$export$9fa96a7d116ea3ce(parsedToken, "internal-error" /* INTERNAL_ERROR */ );
    $8fd3c2447d7c53c3$export$9fa96a7d116ea3ce(typeof parsedToken.exp !== "undefined", "internal-error" /* INTERNAL_ERROR */ );
    $8fd3c2447d7c53c3$export$9fa96a7d116ea3ce(typeof parsedToken.iat !== "undefined", "internal-error" /* INTERNAL_ERROR */ );
    return Number(parsedToken.exp) - Number(parsedToken.iat);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $8fd3c2447d7c53c3$var$_logoutIfInvalidated(user, promise, bypassAuthState = false) {
    if (bypassAuthState) return promise;
    try {
        return await promise;
    } catch (e) {
        if (e instanceof (0, $6vM9o.FirebaseError) && $8fd3c2447d7c53c3$var$isUserInvalidated(e)) {
            if (user.auth.currentUser === user) await user.auth.signOut();
        }
        throw e;
    }
}
function $8fd3c2447d7c53c3$var$isUserInvalidated({ code: code }) {
    return code === `auth/${"user-disabled" /* USER_DISABLED */ }` || code === `auth/${"user-token-expired" /* TOKEN_EXPIRED */ }`;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $8fd3c2447d7c53c3$var$ProactiveRefresh {
    _start() {
        if (this.isRunning) return;
        this.isRunning = true;
        this.schedule();
    }
    _stop() {
        if (!this.isRunning) return;
        this.isRunning = false;
        if (this.timerId !== null) clearTimeout(this.timerId);
    }
    getInterval(wasError) {
        var _a;
        if (wasError) {
            const interval = this.errorBackoff;
            this.errorBackoff = Math.min(this.errorBackoff * 2, 960000 /* RETRY_BACKOFF_MAX */ );
            return interval;
        } else {
            // Reset the error backoff
            this.errorBackoff = 30000 /* RETRY_BACKOFF_MIN */ ;
            const expTime = (_a = this.user.stsTokenManager.expirationTime) !== null && _a !== void 0 ? _a : 0;
            const interval = expTime - Date.now() - 300000 /* OFFSET */ ;
            return Math.max(0, interval);
        }
    }
    schedule(wasError = false) {
        if (!this.isRunning) // Just in case...
        return;
        const interval = this.getInterval(wasError);
        this.timerId = setTimeout(async ()=>{
            await this.iteration();
        }, interval);
    }
    async iteration() {
        try {
            await this.user.getIdToken(true);
        } catch (e) {
            // Only retry on network errors
            if (e.code === `auth/${"network-request-failed" /* NETWORK_REQUEST_FAILED */ }`) this.schedule(/* wasError */ true);
            return;
        }
        this.schedule();
    }
    constructor(user){
        this.user = user;
        this.isRunning = false;
        // Node timers and browser timers return fundamentally different types.
        // We don't actually care what the value is but TS won't accept unknown and
        // we can't cast properly in both environments.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.timerId = null;
        this.errorBackoff = 30000 /* RETRY_BACKOFF_MIN */ ;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $8fd3c2447d7c53c3$var$UserMetadata {
    _initializeTime() {
        this.lastSignInTime = $8fd3c2447d7c53c3$var$utcTimestampToDateString(this.lastLoginAt);
        this.creationTime = $8fd3c2447d7c53c3$var$utcTimestampToDateString(this.createdAt);
    }
    _copy(metadata) {
        this.createdAt = metadata.createdAt;
        this.lastLoginAt = metadata.lastLoginAt;
        this._initializeTime();
    }
    toJSON() {
        return {
            createdAt: this.createdAt,
            lastLoginAt: this.lastLoginAt
        };
    }
    constructor(createdAt, lastLoginAt){
        this.createdAt = createdAt;
        this.lastLoginAt = lastLoginAt;
        this._initializeTime();
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $8fd3c2447d7c53c3$var$_reloadWithoutSaving(user) {
    var _a;
    const auth = user.auth;
    const idToken = await user.getIdToken();
    const response = await $8fd3c2447d7c53c3$var$_logoutIfInvalidated(user, $8fd3c2447d7c53c3$var$getAccountInfo(auth, {
        idToken: idToken
    }));
    $8fd3c2447d7c53c3$export$9fa96a7d116ea3ce(response === null || response === void 0 ? void 0 : response.users.length, auth, "internal-error" /* INTERNAL_ERROR */ );
    const coreAccount = response.users[0];
    user._notifyReloadListener(coreAccount);
    const newProviderData = ((_a = coreAccount.providerUserInfo) === null || _a === void 0 ? void 0 : _a.length) ? $8fd3c2447d7c53c3$var$extractProviderData(coreAccount.providerUserInfo) : [];
    const providerData = $8fd3c2447d7c53c3$var$mergeProviderData(user.providerData, newProviderData);
    // Preserves the non-nonymous status of the stored user, even if no more
    // credentials (federated or email/password) are linked to the user. If
    // the user was previously anonymous, then use provider data to update.
    // On the other hand, if it was not anonymous before, it should never be
    // considered anonymous now.
    const oldIsAnonymous = user.isAnonymous;
    const newIsAnonymous = !(user.email && coreAccount.passwordHash) && !(providerData === null || providerData === void 0 ? void 0 : providerData.length);
    const isAnonymous = !oldIsAnonymous ? false : newIsAnonymous;
    const updates = {
        uid: coreAccount.localId,
        displayName: coreAccount.displayName || null,
        photoURL: coreAccount.photoUrl || null,
        email: coreAccount.email || null,
        emailVerified: coreAccount.emailVerified || false,
        phoneNumber: coreAccount.phoneNumber || null,
        tenantId: coreAccount.tenantId || null,
        providerData: providerData,
        metadata: new $8fd3c2447d7c53c3$var$UserMetadata(coreAccount.createdAt, coreAccount.lastLoginAt),
        isAnonymous: isAnonymous
    };
    Object.assign(user, updates);
}
/**
 * Reloads user account data, if signed in.
 *
 * @param user - The user.
 *
 * @public
 */ async function $8fd3c2447d7c53c3$export$1a82df3d29112e01(user) {
    const userInternal = (0, $6vM9o.getModularInstance)(user);
    await $8fd3c2447d7c53c3$var$_reloadWithoutSaving(userInternal);
    // Even though the current user hasn't changed, update
    // current user will trigger a persistence update w/ the
    // new info.
    await userInternal.auth._persistUserIfCurrent(userInternal);
    userInternal.auth._notifyListenersIfCurrent(userInternal);
}
function $8fd3c2447d7c53c3$var$mergeProviderData(original, newData) {
    const deduped = original.filter((o)=>!newData.some((n)=>n.providerId === o.providerId));
    return [
        ...deduped,
        ...newData
    ];
}
function $8fd3c2447d7c53c3$var$extractProviderData(providers) {
    return providers.map((_a)=>{
        var { providerId: providerId } = _a, provider = (0, $k2nG7.__rest)(_a, [
            "providerId"
        ]);
        return {
            providerId: providerId,
            uid: provider.rawId || "",
            displayName: provider.displayName || null,
            email: provider.email || null,
            phoneNumber: provider.phoneNumber || null,
            photoURL: provider.photoUrl || null
        };
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $8fd3c2447d7c53c3$var$requestStsToken(auth, refreshToken) {
    const response = await $8fd3c2447d7c53c3$var$_performFetchWithErrorHandling(auth, {}, async ()=>{
        const body = (0, $6vM9o.querystring)({
            "grant_type": "refresh_token",
            "refresh_token": refreshToken
        }).slice(1);
        const { tokenApiHost: tokenApiHost, apiKey: apiKey } = auth.config;
        const url = $8fd3c2447d7c53c3$var$_getFinalTarget(auth, tokenApiHost, "/v1/token" /* TOKEN */ , `key=${apiKey}`);
        const headers = await auth._getAdditionalHeaders();
        headers["Content-Type" /* CONTENT_TYPE */ ] = "application/x-www-form-urlencoded";
        return $8fd3c2447d7c53c3$export$23ebac1979863676.fetch()(url, {
            method: "POST" /* POST */ ,
            headers: headers,
            body: body
        });
    });
    // The response comes back in snake_case. Convert to camel:
    return {
        accessToken: response.access_token,
        expiresIn: response.expires_in,
        refreshToken: response.refresh_token
    };
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * We need to mark this class as internal explicitly to exclude it in the public typings, because
 * it references AuthInternal which has a circular dependency with UserInternal.
 *
 * @internal
 */ class $8fd3c2447d7c53c3$var$StsTokenManager {
    get isExpired() {
        return !this.expirationTime || Date.now() > this.expirationTime - 30000 /* TOKEN_REFRESH */ ;
    }
    updateFromServerResponse(response) {
        $8fd3c2447d7c53c3$export$9fa96a7d116ea3ce(response.idToken, "internal-error" /* INTERNAL_ERROR */ );
        $8fd3c2447d7c53c3$export$9fa96a7d116ea3ce(typeof response.idToken !== "undefined", "internal-error" /* INTERNAL_ERROR */ );
        $8fd3c2447d7c53c3$export$9fa96a7d116ea3ce(typeof response.refreshToken !== "undefined", "internal-error" /* INTERNAL_ERROR */ );
        const expiresIn = "expiresIn" in response && typeof response.expiresIn !== "undefined" ? Number(response.expiresIn) : $8fd3c2447d7c53c3$var$_tokenExpiresIn(response.idToken);
        this.updateTokensAndExpiration(response.idToken, response.refreshToken, expiresIn);
    }
    async getToken(auth, forceRefresh = false) {
        $8fd3c2447d7c53c3$export$9fa96a7d116ea3ce(!this.accessToken || this.refreshToken, auth, "user-token-expired" /* TOKEN_EXPIRED */ );
        if (!forceRefresh && this.accessToken && !this.isExpired) return this.accessToken;
        if (this.refreshToken) {
            await this.refresh(auth, this.refreshToken);
            return this.accessToken;
        }
        return null;
    }
    clearRefreshToken() {
        this.refreshToken = null;
    }
    async refresh(auth, oldToken) {
        const { accessToken: accessToken, refreshToken: refreshToken, expiresIn: expiresIn } = await $8fd3c2447d7c53c3$var$requestStsToken(auth, oldToken);
        this.updateTokensAndExpiration(accessToken, refreshToken, Number(expiresIn));
    }
    updateTokensAndExpiration(accessToken, refreshToken, expiresInSec) {
        this.refreshToken = refreshToken || null;
        this.accessToken = accessToken || null;
        this.expirationTime = Date.now() + expiresInSec * 1000;
    }
    static fromJSON(appName, object) {
        const { refreshToken: refreshToken, accessToken: accessToken, expirationTime: expirationTime } = object;
        const manager = new $8fd3c2447d7c53c3$var$StsTokenManager();
        if (refreshToken) {
            $8fd3c2447d7c53c3$export$9fa96a7d116ea3ce(typeof refreshToken === "string", "internal-error" /* INTERNAL_ERROR */ , {
                appName: appName
            });
            manager.refreshToken = refreshToken;
        }
        if (accessToken) {
            $8fd3c2447d7c53c3$export$9fa96a7d116ea3ce(typeof accessToken === "string", "internal-error" /* INTERNAL_ERROR */ , {
                appName: appName
            });
            manager.accessToken = accessToken;
        }
        if (expirationTime) {
            $8fd3c2447d7c53c3$export$9fa96a7d116ea3ce(typeof expirationTime === "number", "internal-error" /* INTERNAL_ERROR */ , {
                appName: appName
            });
            manager.expirationTime = expirationTime;
        }
        return manager;
    }
    toJSON() {
        return {
            refreshToken: this.refreshToken,
            accessToken: this.accessToken,
            expirationTime: this.expirationTime
        };
    }
    _assign(stsTokenManager) {
        this.accessToken = stsTokenManager.accessToken;
        this.refreshToken = stsTokenManager.refreshToken;
        this.expirationTime = stsTokenManager.expirationTime;
    }
    _clone() {
        return Object.assign(new $8fd3c2447d7c53c3$var$StsTokenManager(), this.toJSON());
    }
    _performRefresh() {
        return $8fd3c2447d7c53c3$var$debugFail("not implemented");
    }
    constructor(){
        this.refreshToken = null;
        this.accessToken = null;
        this.expirationTime = null;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $8fd3c2447d7c53c3$var$assertStringOrUndefined(assertion, appName) {
    $8fd3c2447d7c53c3$export$9fa96a7d116ea3ce(typeof assertion === "string" || typeof assertion === "undefined", "internal-error" /* INTERNAL_ERROR */ , {
        appName: appName
    });
}
class $8fd3c2447d7c53c3$export$cf2f7c5792f80b46 {
    async getIdToken(forceRefresh) {
        const accessToken = await $8fd3c2447d7c53c3$var$_logoutIfInvalidated(this, this.stsTokenManager.getToken(this.auth, forceRefresh));
        $8fd3c2447d7c53c3$export$9fa96a7d116ea3ce(accessToken, this.auth, "internal-error" /* INTERNAL_ERROR */ );
        if (this.accessToken !== accessToken) {
            this.accessToken = accessToken;
            await this.auth._persistUserIfCurrent(this);
            this.auth._notifyListenersIfCurrent(this);
        }
        return accessToken;
    }
    getIdTokenResult(forceRefresh) {
        return $8fd3c2447d7c53c3$export$3b513254972cfc9c(this, forceRefresh);
    }
    reload() {
        return $8fd3c2447d7c53c3$export$1a82df3d29112e01(this);
    }
    _assign(user) {
        if (this === user) return;
        $8fd3c2447d7c53c3$export$9fa96a7d116ea3ce(this.uid === user.uid, this.auth, "internal-error" /* INTERNAL_ERROR */ );
        this.displayName = user.displayName;
        this.photoURL = user.photoURL;
        this.email = user.email;
        this.emailVerified = user.emailVerified;
        this.phoneNumber = user.phoneNumber;
        this.isAnonymous = user.isAnonymous;
        this.tenantId = user.tenantId;
        this.providerData = user.providerData.map((userInfo)=>Object.assign({}, userInfo));
        this.metadata._copy(user.metadata);
        this.stsTokenManager._assign(user.stsTokenManager);
    }
    _clone(auth) {
        return new $8fd3c2447d7c53c3$export$cf2f7c5792f80b46(Object.assign(Object.assign({}, this), {
            auth: auth,
            stsTokenManager: this.stsTokenManager._clone()
        }));
    }
    _onReload(callback) {
        // There should only ever be one listener, and that is a single instance of MultiFactorUser
        $8fd3c2447d7c53c3$export$9fa96a7d116ea3ce(!this.reloadListener, this.auth, "internal-error" /* INTERNAL_ERROR */ );
        this.reloadListener = callback;
        if (this.reloadUserInfo) {
            this._notifyReloadListener(this.reloadUserInfo);
            this.reloadUserInfo = null;
        }
    }
    _notifyReloadListener(userInfo) {
        if (this.reloadListener) this.reloadListener(userInfo);
        else // If no listener is subscribed yet, save the result so it's available when they do subscribe
        this.reloadUserInfo = userInfo;
    }
    _startProactiveRefresh() {
        this.proactiveRefresh._start();
    }
    _stopProactiveRefresh() {
        this.proactiveRefresh._stop();
    }
    async _updateTokensIfNecessary(response, reload = false) {
        let tokensRefreshed = false;
        if (response.idToken && response.idToken !== this.stsTokenManager.accessToken) {
            this.stsTokenManager.updateFromServerResponse(response);
            tokensRefreshed = true;
        }
        if (reload) await $8fd3c2447d7c53c3$var$_reloadWithoutSaving(this);
        await this.auth._persistUserIfCurrent(this);
        if (tokensRefreshed) this.auth._notifyListenersIfCurrent(this);
    }
    async delete() {
        const idToken = await this.getIdToken();
        await $8fd3c2447d7c53c3$var$_logoutIfInvalidated(this, $8fd3c2447d7c53c3$var$deleteAccount(this.auth, {
            idToken: idToken
        }));
        this.stsTokenManager.clearRefreshToken();
        // TODO: Determine if cancellable-promises are necessary to use in this class so that delete()
        //       cancels pending actions...
        return this.auth.signOut();
    }
    toJSON() {
        return Object.assign(Object.assign({
            uid: this.uid,
            email: this.email || undefined,
            emailVerified: this.emailVerified,
            displayName: this.displayName || undefined,
            isAnonymous: this.isAnonymous,
            photoURL: this.photoURL || undefined,
            phoneNumber: this.phoneNumber || undefined,
            tenantId: this.tenantId || undefined,
            providerData: this.providerData.map((userInfo)=>Object.assign({}, userInfo)),
            stsTokenManager: this.stsTokenManager.toJSON(),
            // Redirect event ID must be maintained in case there is a pending
            // redirect event.
            _redirectEventId: this._redirectEventId
        }, this.metadata.toJSON()), {
            // Required for compatibility with the legacy SDK (go/firebase-auth-sdk-persistence-parsing):
            apiKey: this.auth.config.apiKey,
            appName: this.auth.name
        });
    }
    get refreshToken() {
        return this.stsTokenManager.refreshToken || "";
    }
    static _fromJSON(auth, object) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        const displayName = (_a = object.displayName) !== null && _a !== void 0 ? _a : undefined;
        const email = (_b = object.email) !== null && _b !== void 0 ? _b : undefined;
        const phoneNumber = (_c = object.phoneNumber) !== null && _c !== void 0 ? _c : undefined;
        const photoURL = (_d = object.photoURL) !== null && _d !== void 0 ? _d : undefined;
        const tenantId = (_e = object.tenantId) !== null && _e !== void 0 ? _e : undefined;
        const _redirectEventId = (_f = object._redirectEventId) !== null && _f !== void 0 ? _f : undefined;
        const createdAt = (_g = object.createdAt) !== null && _g !== void 0 ? _g : undefined;
        const lastLoginAt = (_h = object.lastLoginAt) !== null && _h !== void 0 ? _h : undefined;
        const { uid: uid, emailVerified: emailVerified, isAnonymous: isAnonymous, providerData: providerData, stsTokenManager: plainObjectTokenManager } = object;
        $8fd3c2447d7c53c3$export$9fa96a7d116ea3ce(uid && plainObjectTokenManager, auth, "internal-error" /* INTERNAL_ERROR */ );
        const stsTokenManager = $8fd3c2447d7c53c3$var$StsTokenManager.fromJSON(this.name, plainObjectTokenManager);
        $8fd3c2447d7c53c3$export$9fa96a7d116ea3ce(typeof uid === "string", auth, "internal-error" /* INTERNAL_ERROR */ );
        $8fd3c2447d7c53c3$var$assertStringOrUndefined(displayName, auth.name);
        $8fd3c2447d7c53c3$var$assertStringOrUndefined(email, auth.name);
        $8fd3c2447d7c53c3$export$9fa96a7d116ea3ce(typeof emailVerified === "boolean", auth, "internal-error" /* INTERNAL_ERROR */ );
        $8fd3c2447d7c53c3$export$9fa96a7d116ea3ce(typeof isAnonymous === "boolean", auth, "internal-error" /* INTERNAL_ERROR */ );
        $8fd3c2447d7c53c3$var$assertStringOrUndefined(phoneNumber, auth.name);
        $8fd3c2447d7c53c3$var$assertStringOrUndefined(photoURL, auth.name);
        $8fd3c2447d7c53c3$var$assertStringOrUndefined(tenantId, auth.name);
        $8fd3c2447d7c53c3$var$assertStringOrUndefined(_redirectEventId, auth.name);
        $8fd3c2447d7c53c3$var$assertStringOrUndefined(createdAt, auth.name);
        $8fd3c2447d7c53c3$var$assertStringOrUndefined(lastLoginAt, auth.name);
        const user = new $8fd3c2447d7c53c3$export$cf2f7c5792f80b46({
            uid: uid,
            auth: auth,
            email: email,
            emailVerified: emailVerified,
            displayName: displayName,
            isAnonymous: isAnonymous,
            photoURL: photoURL,
            phoneNumber: phoneNumber,
            tenantId: tenantId,
            stsTokenManager: stsTokenManager,
            createdAt: createdAt,
            lastLoginAt: lastLoginAt
        });
        if (providerData && Array.isArray(providerData)) user.providerData = providerData.map((userInfo)=>Object.assign({}, userInfo));
        if (_redirectEventId) user._redirectEventId = _redirectEventId;
        return user;
    }
    /**
     * Initialize a User from an idToken server response
     * @param auth
     * @param idTokenResponse
     */ static async _fromIdTokenResponse(auth, idTokenResponse, isAnonymous = false) {
        const stsTokenManager = new $8fd3c2447d7c53c3$var$StsTokenManager();
        stsTokenManager.updateFromServerResponse(idTokenResponse);
        // Initialize the Firebase Auth user.
        const user = new $8fd3c2447d7c53c3$export$cf2f7c5792f80b46({
            uid: idTokenResponse.localId,
            auth: auth,
            stsTokenManager: stsTokenManager,
            isAnonymous: isAnonymous
        });
        // Updates the user info and data and resolves with a user instance.
        await $8fd3c2447d7c53c3$var$_reloadWithoutSaving(user);
        return user;
    }
    constructor(_a){
        var { uid: uid, auth: auth, stsTokenManager: stsTokenManager } = _a, opt = (0, $k2nG7.__rest)(_a, [
            "uid",
            "auth",
            "stsTokenManager"
        ]);
        // For the user object, provider is always Firebase.
        this.providerId = "firebase" /* FIREBASE */ ;
        this.proactiveRefresh = new $8fd3c2447d7c53c3$var$ProactiveRefresh(this);
        this.reloadUserInfo = null;
        this.reloadListener = null;
        this.uid = uid;
        this.auth = auth;
        this.stsTokenManager = stsTokenManager;
        this.accessToken = stsTokenManager.accessToken;
        this.displayName = opt.displayName || null;
        this.email = opt.email || null;
        this.emailVerified = opt.emailVerified || false;
        this.phoneNumber = opt.phoneNumber || null;
        this.photoURL = opt.photoURL || null;
        this.isAnonymous = opt.isAnonymous || false;
        this.tenantId = opt.tenantId || null;
        this.providerData = opt.providerData ? [
            ...opt.providerData
        ] : [];
        this.metadata = new $8fd3c2447d7c53c3$var$UserMetadata(opt.createdAt || undefined, opt.lastLoginAt || undefined);
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $8fd3c2447d7c53c3$var$InMemoryPersistence {
    async _isAvailable() {
        return true;
    }
    async _set(key, value) {
        this.storage[key] = value;
    }
    async _get(key) {
        const value = this.storage[key];
        return value === undefined ? null : value;
    }
    async _remove(key) {
        delete this.storage[key];
    }
    _addListener(_key, _listener) {
        // Listeners are not supported for in-memory storage since it cannot be shared across windows/workers
        return;
    }
    _removeListener(_key, _listener) {
        // Listeners are not supported for in-memory storage since it cannot be shared across windows/workers
        return;
    }
    constructor(){
        this.type = "NONE" /* NONE */ ;
        this.storage = {};
    }
}
$8fd3c2447d7c53c3$var$InMemoryPersistence.type = "NONE";
/**
 * An implementation of {@link Persistence} of type 'NONE'.
 *
 * @public
 */ const $8fd3c2447d7c53c3$export$61196ced6d74a310 = $8fd3c2447d7c53c3$var$InMemoryPersistence;
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $8fd3c2447d7c53c3$export$3d12bd131bb975d1(key, apiKey, appName) {
    return `${"firebase" /* PERSISTENCE */ }:${key}:${apiKey}:${appName}`;
}
class $8fd3c2447d7c53c3$var$PersistenceUserManager {
    setCurrentUser(user) {
        return this.persistence._set(this.fullUserKey, user.toJSON());
    }
    async getCurrentUser() {
        const blob = await this.persistence._get(this.fullUserKey);
        return blob ? $8fd3c2447d7c53c3$export$cf2f7c5792f80b46._fromJSON(this.auth, blob) : null;
    }
    removeCurrentUser() {
        return this.persistence._remove(this.fullUserKey);
    }
    savePersistenceForRedirect() {
        return this.persistence._set(this.fullPersistenceKey, this.persistence.type);
    }
    async setPersistence(newPersistence) {
        if (this.persistence === newPersistence) return;
        const currentUser = await this.getCurrentUser();
        await this.removeCurrentUser();
        this.persistence = newPersistence;
        if (currentUser) return this.setCurrentUser(currentUser);
    }
    delete() {
        this.persistence._removeListener(this.fullUserKey, this.boundEventHandler);
    }
    static async create(auth, persistenceHierarchy, userKey = "authUser" /* AUTH_USER */ ) {
        if (!persistenceHierarchy.length) return new $8fd3c2447d7c53c3$var$PersistenceUserManager($8fd3c2447d7c53c3$export$28f7fcd39efa255($8fd3c2447d7c53c3$export$61196ced6d74a310), auth, userKey);
        // Eliminate any persistences that are not available
        const availablePersistences = (await Promise.all(persistenceHierarchy.map(async (persistence)=>{
            if (await persistence._isAvailable()) return persistence;
            return undefined;
        }))).filter((persistence)=>persistence);
        // Fall back to the first persistence listed, or in memory if none available
        let selectedPersistence = availablePersistences[0] || $8fd3c2447d7c53c3$export$28f7fcd39efa255($8fd3c2447d7c53c3$export$61196ced6d74a310);
        const key = $8fd3c2447d7c53c3$export$3d12bd131bb975d1(userKey, auth.config.apiKey, auth.name);
        // Pull out the existing user, setting the chosen persistence to that
        // persistence if the user exists.
        let userToMigrate = null;
        // Note, here we check for a user in _all_ persistences, not just the
        // ones deemed available. If we can migrate a user out of a broken
        // persistence, we will (but only if that persistence supports migration).
        for (const persistence of persistenceHierarchy)try {
            const blob = await persistence._get(key);
            if (blob) {
                const user = $8fd3c2447d7c53c3$export$cf2f7c5792f80b46._fromJSON(auth, blob); // throws for unparsable blob (wrong format)
                if (persistence !== selectedPersistence) userToMigrate = user;
                selectedPersistence = persistence;
                break;
            }
        } catch (_a) {}
        // If we find the user in a persistence that does support migration, use
        // that migration path (of only persistences that support migration)
        const migrationHierarchy = availablePersistences.filter((p)=>p._shouldAllowMigration);
        // If the persistence does _not_ allow migration, just finish off here
        if (!selectedPersistence._shouldAllowMigration || !migrationHierarchy.length) return new $8fd3c2447d7c53c3$var$PersistenceUserManager(selectedPersistence, auth, userKey);
        selectedPersistence = migrationHierarchy[0];
        if (userToMigrate) // This normally shouldn't throw since chosenPersistence.isAvailable() is true, but if it does
        // we'll just let it bubble to surface the error.
        await selectedPersistence._set(key, userToMigrate.toJSON());
        // Attempt to clear the key in other persistences but ignore errors. This helps prevent issues
        // such as users getting stuck with a previous account after signing out and refreshing the tab.
        await Promise.all(persistenceHierarchy.map(async (persistence)=>{
            if (persistence !== selectedPersistence) try {
                await persistence._remove(key);
            } catch (_a) {}
        }));
        return new $8fd3c2447d7c53c3$var$PersistenceUserManager(selectedPersistence, auth, userKey);
    }
    constructor(persistence, auth, userKey){
        this.persistence = persistence;
        this.auth = auth;
        this.userKey = userKey;
        const { config: config, name: name } = this.auth;
        this.fullUserKey = $8fd3c2447d7c53c3$export$3d12bd131bb975d1(this.userKey, config.apiKey, name);
        this.fullPersistenceKey = $8fd3c2447d7c53c3$export$3d12bd131bb975d1("persistence" /* PERSISTENCE_USER */ , config.apiKey, name);
        this.boundEventHandler = auth._onStorageEvent.bind(auth);
        this.persistence._addListener(this.fullUserKey, this.boundEventHandler);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Determine the browser for the purposes of reporting usage to the API
 */ function $8fd3c2447d7c53c3$var$_getBrowserName(userAgent) {
    const ua = userAgent.toLowerCase();
    if (ua.includes("opera/") || ua.includes("opr/") || ua.includes("opios/")) return "Opera" /* OPERA */ ;
    else if ($8fd3c2447d7c53c3$var$_isIEMobile(ua)) // Windows phone IEMobile browser.
    return "IEMobile" /* IEMOBILE */ ;
    else if (ua.includes("msie") || ua.includes("trident/")) return "IE" /* IE */ ;
    else if (ua.includes("edge/")) return "Edge" /* EDGE */ ;
    else if ($8fd3c2447d7c53c3$var$_isFirefox(ua)) return "Firefox" /* FIREFOX */ ;
    else if (ua.includes("silk/")) return "Silk" /* SILK */ ;
    else if ($8fd3c2447d7c53c3$var$_isBlackBerry(ua)) // Blackberry browser.
    return "Blackberry" /* BLACKBERRY */ ;
    else if ($8fd3c2447d7c53c3$var$_isWebOS(ua)) // WebOS default browser.
    return "Webos" /* WEBOS */ ;
    else if ($8fd3c2447d7c53c3$var$_isSafari(ua)) return "Safari" /* SAFARI */ ;
    else if ((ua.includes("chrome/") || $8fd3c2447d7c53c3$var$_isChromeIOS(ua)) && !ua.includes("edge/")) return "Chrome" /* CHROME */ ;
    else if ($8fd3c2447d7c53c3$export$6554612db691658e(ua)) // Android stock browser.
    return "Android" /* ANDROID */ ;
    else {
        // Most modern browsers have name/version at end of user agent string.
        const re = /([a-zA-Z\d\.]+)\/[a-zA-Z\d\.]*$/;
        const matches = userAgent.match(re);
        if ((matches === null || matches === void 0 ? void 0 : matches.length) === 2) return matches[1];
    }
    return "Other" /* OTHER */ ;
}
function $8fd3c2447d7c53c3$var$_isFirefox(ua = (0, $6vM9o.getUA)()) {
    return /firefox\//i.test(ua);
}
function $8fd3c2447d7c53c3$var$_isSafari(userAgent = (0, $6vM9o.getUA)()) {
    const ua = userAgent.toLowerCase();
    return ua.includes("safari/") && !ua.includes("chrome/") && !ua.includes("crios/") && !ua.includes("android");
}
function $8fd3c2447d7c53c3$var$_isChromeIOS(ua = (0, $6vM9o.getUA)()) {
    return /crios\//i.test(ua);
}
function $8fd3c2447d7c53c3$var$_isIEMobile(ua = (0, $6vM9o.getUA)()) {
    return /iemobile/i.test(ua);
}
function $8fd3c2447d7c53c3$export$6554612db691658e(ua = (0, $6vM9o.getUA)()) {
    return /android/i.test(ua);
}
function $8fd3c2447d7c53c3$var$_isBlackBerry(ua = (0, $6vM9o.getUA)()) {
    return /blackberry/i.test(ua);
}
function $8fd3c2447d7c53c3$var$_isWebOS(ua = (0, $6vM9o.getUA)()) {
    return /webos/i.test(ua);
}
function $8fd3c2447d7c53c3$export$d24c54395ce0c509(ua = (0, $6vM9o.getUA)()) {
    return /iphone|ipad|ipod/i.test(ua);
}
function $8fd3c2447d7c53c3$export$2f6ca3d3b1f80bf5(ua = (0, $6vM9o.getUA)()) {
    return /(iPad|iPhone|iPod).*OS 7_\d/i.test(ua) || /(iPad|iPhone|iPod).*OS 8_\d/i.test(ua);
}
function $8fd3c2447d7c53c3$var$_isIOSStandalone(ua = (0, $6vM9o.getUA)()) {
    var _a;
    return $8fd3c2447d7c53c3$export$d24c54395ce0c509(ua) && !!((_a = window.navigator) === null || _a === void 0 ? void 0 : _a.standalone);
}
function $8fd3c2447d7c53c3$var$_isIE10() {
    return (0, $6vM9o.isIE)() && document.documentMode === 10;
}
function $8fd3c2447d7c53c3$var$_isMobileBrowser(ua = (0, $6vM9o.getUA)()) {
    // TODO: implement getBrowserName equivalent for OS.
    return $8fd3c2447d7c53c3$export$d24c54395ce0c509(ua) || $8fd3c2447d7c53c3$export$6554612db691658e(ua) || $8fd3c2447d7c53c3$var$_isWebOS(ua) || $8fd3c2447d7c53c3$var$_isBlackBerry(ua) || /windows phone/i.test(ua) || $8fd3c2447d7c53c3$var$_isIEMobile(ua);
}
function $8fd3c2447d7c53c3$var$_isIframe() {
    try {
        // Check that the current window is not the top window.
        // If so, return true.
        return !!(window && window !== window.top);
    } catch (e) {
        return false;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Determine the SDK version string
 */ function $8fd3c2447d7c53c3$export$a33b77bbdbb8366c(clientPlatform, frameworks = []) {
    let reportedPlatform;
    switch(clientPlatform){
        case "Browser" /* BROWSER */ :
            // In a browser environment, report the browser name.
            reportedPlatform = $8fd3c2447d7c53c3$var$_getBrowserName((0, $6vM9o.getUA)());
            break;
        case "Worker" /* WORKER */ :
            // Technically a worker runs from a browser but we need to differentiate a
            // worker from a browser.
            // For example: Chrome-Worker/JsCore/4.9.1/FirebaseCore-web.
            reportedPlatform = `${$8fd3c2447d7c53c3$var$_getBrowserName((0, $6vM9o.getUA)())}-${clientPlatform}`;
            break;
        default:
            reportedPlatform = clientPlatform;
    }
    const reportedFrameworks = frameworks.length ? frameworks.join(",") : "FirebaseCore-web"; /* default value if no other framework is used */ 
    return `${reportedPlatform}/${"JsCore" /* CORE */ }/${0, $iXpG9.SDK_VERSION}/${reportedFrameworks}`;
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $8fd3c2447d7c53c3$var$AuthMiddlewareQueue {
    pushCallback(callback, onAbort) {
        // The callback could be sync or async. Wrap it into a
        // function that is always async.
        const wrappedCallback = (user)=>new Promise((resolve, reject)=>{
                try {
                    const result = callback(user);
                    // Either resolve with existing promise or wrap a non-promise
                    // return value into a promise.
                    resolve(result);
                } catch (e) {
                    // Sync callback throws.
                    reject(e);
                }
            });
        // Attach the onAbort if present
        wrappedCallback.onAbort = onAbort;
        this.queue.push(wrappedCallback);
        const index = this.queue.length - 1;
        return ()=>{
            // Unsubscribe. Replace with no-op. Do not remove from array, or it will disturb
            // indexing of other elements.
            this.queue[index] = ()=>Promise.resolve();
        };
    }
    async runMiddleware(nextUser) {
        var _a;
        if (this.auth.currentUser === nextUser) return;
        // While running the middleware, build a temporary stack of onAbort
        // callbacks to call if one middleware callback rejects.
        const onAbortStack = [];
        try {
            for (const beforeStateCallback of this.queue){
                await beforeStateCallback(nextUser);
                // Only push the onAbort if the callback succeeds
                if (beforeStateCallback.onAbort) onAbortStack.push(beforeStateCallback.onAbort);
            }
        } catch (e) {
            // Run all onAbort, with separate try/catch to ignore any errors and
            // continue
            onAbortStack.reverse();
            for (const onAbort of onAbortStack)try {
                onAbort();
            } catch (_) {}
            throw this.auth._errorFactory.create("login-blocked" /* LOGIN_BLOCKED */ , {
                originalMessage: (_a = e) === null || _a === void 0 ? void 0 : _a.message
            });
        }
    }
    constructor(auth){
        this.auth = auth;
        this.queue = [];
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $8fd3c2447d7c53c3$export$53a70dd1ebbae346 {
    _initializeWithPersistence(persistenceHierarchy, popupRedirectResolver) {
        if (popupRedirectResolver) this._popupRedirectResolver = $8fd3c2447d7c53c3$export$28f7fcd39efa255(popupRedirectResolver);
        // Have to check for app deletion throughout initialization (after each
        // promise resolution)
        this._initializationPromise = this.queue(async ()=>{
            var _a, _b;
            if (this._deleted) return;
            this.persistenceManager = await $8fd3c2447d7c53c3$var$PersistenceUserManager.create(this, persistenceHierarchy);
            if (this._deleted) return;
            // Initialize the resolver early if necessary (only applicable to web:
            // this will cause the iframe to load immediately in certain cases)
            if ((_a = this._popupRedirectResolver) === null || _a === void 0 ? void 0 : _a._shouldInitProactively) // If this fails, don't halt auth loading
            try {
                await this._popupRedirectResolver._initialize(this);
            } catch (e) {}
            await this.initializeCurrentUser(popupRedirectResolver);
            this.lastNotifiedUid = ((_b = this.currentUser) === null || _b === void 0 ? void 0 : _b.uid) || null;
            if (this._deleted) return;
            this._isInitialized = true;
        });
        return this._initializationPromise;
    }
    /**
     * If the persistence is changed in another window, the user manager will let us know
     */ async _onStorageEvent() {
        if (this._deleted) return;
        const user = await this.assertedPersistence.getCurrentUser();
        if (!this.currentUser && !user) // No change, do nothing (was signed out and remained signed out).
        return;
        // If the same user is to be synchronized.
        if (this.currentUser && user && this.currentUser.uid === user.uid) {
            // Data update, simply copy data changes.
            this._currentUser._assign(user);
            // If tokens changed from previous user tokens, this will trigger
            // notifyAuthListeners_.
            await this.currentUser.getIdToken();
            return;
        }
        // Update current Auth state. Either a new login or logout.
        // Skip blocking callbacks, they should not apply to a change in another tab.
        await this._updateCurrentUser(user, /* skipBeforeStateCallbacks */ true);
    }
    async initializeCurrentUser(popupRedirectResolver) {
        var _a;
        // First check to see if we have a pending redirect event.
        const previouslyStoredUser = await this.assertedPersistence.getCurrentUser();
        let futureCurrentUser = previouslyStoredUser;
        let needsTocheckMiddleware = false;
        if (popupRedirectResolver && this.config.authDomain) {
            await this.getOrInitRedirectPersistenceManager();
            const redirectUserEventId = (_a = this.redirectUser) === null || _a === void 0 ? void 0 : _a._redirectEventId;
            const storedUserEventId = futureCurrentUser === null || futureCurrentUser === void 0 ? void 0 : futureCurrentUser._redirectEventId;
            const result = await this.tryRedirectSignIn(popupRedirectResolver);
            // If the stored user (i.e. the old "currentUser") has a redirectId that
            // matches the redirect user, then we want to initially sign in with the
            // new user object from result.
            // TODO(samgho): More thoroughly test all of this
            if ((!redirectUserEventId || redirectUserEventId === storedUserEventId) && (result === null || result === void 0 ? void 0 : result.user)) {
                futureCurrentUser = result.user;
                needsTocheckMiddleware = true;
            }
        }
        // If no user in persistence, there is no current user. Set to null.
        if (!futureCurrentUser) return this.directlySetCurrentUser(null);
        if (!futureCurrentUser._redirectEventId) {
            // This isn't a redirect link operation, we can reload and bail.
            // First though, ensure that we check the middleware is happy.
            if (needsTocheckMiddleware) try {
                await this.beforeStateQueue.runMiddleware(futureCurrentUser);
            } catch (e) {
                futureCurrentUser = previouslyStoredUser;
                // We know this is available since the bit is only set when the
                // resolver is available
                this._popupRedirectResolver._overrideRedirectResult(this, ()=>Promise.reject(e));
            }
            if (futureCurrentUser) return this.reloadAndSetCurrentUserOrClear(futureCurrentUser);
            else return this.directlySetCurrentUser(null);
        }
        $8fd3c2447d7c53c3$export$9fa96a7d116ea3ce(this._popupRedirectResolver, this, "argument-error" /* ARGUMENT_ERROR */ );
        await this.getOrInitRedirectPersistenceManager();
        // If the redirect user's event ID matches the current user's event ID,
        // DO NOT reload the current user, otherwise they'll be cleared from storage.
        // This is important for the reauthenticateWithRedirect() flow.
        if (this.redirectUser && this.redirectUser._redirectEventId === futureCurrentUser._redirectEventId) return this.directlySetCurrentUser(futureCurrentUser);
        return this.reloadAndSetCurrentUserOrClear(futureCurrentUser);
    }
    async tryRedirectSignIn(redirectResolver) {
        // The redirect user needs to be checked (and signed in if available)
        // during auth initialization. All of the normal sign in and link/reauth
        // flows call back into auth and push things onto the promise queue. We
        // need to await the result of the redirect sign in *inside the promise
        // queue*. This presents a problem: we run into deadlock. See:
        //    ┌> [Initialization] ─────┐
        //    ┌> [<other queue tasks>] │
        //    └─ [getRedirectResult] <─┘
        //    where [] are tasks on the queue and arrows denote awaits
        // Initialization will never complete because it's waiting on something
        // that's waiting for initialization to complete!
        //
        // Instead, this method calls getRedirectResult() (stored in
        // _completeRedirectFn) with an optional parameter that instructs all of
        // the underlying auth operations to skip anything that mutates auth state.
        let result = null;
        try {
            // We know this._popupRedirectResolver is set since redirectResolver
            // is passed in. The _completeRedirectFn expects the unwrapped extern.
            result = await this._popupRedirectResolver._completeRedirectFn(this, redirectResolver, true);
        } catch (e) {
            // Swallow any errors here; the code can retrieve them in
            // getRedirectResult().
            await this._setRedirectUser(null);
        }
        return result;
    }
    async reloadAndSetCurrentUserOrClear(user) {
        try {
            await $8fd3c2447d7c53c3$var$_reloadWithoutSaving(user);
        } catch (e) {
            if (e.code !== `auth/${"network-request-failed" /* NETWORK_REQUEST_FAILED */ }`) // Something's wrong with the user's token. Log them out and remove
            // them from storage
            return this.directlySetCurrentUser(null);
        }
        return this.directlySetCurrentUser(user);
    }
    useDeviceLanguage() {
        this.languageCode = $8fd3c2447d7c53c3$var$_getUserLanguage();
    }
    async _delete() {
        this._deleted = true;
    }
    async updateCurrentUser(userExtern) {
        // The public updateCurrentUser method needs to make a copy of the user,
        // and also check that the project matches
        const user = userExtern ? (0, $6vM9o.getModularInstance)(userExtern) : null;
        if (user) $8fd3c2447d7c53c3$export$9fa96a7d116ea3ce(user.auth.config.apiKey === this.config.apiKey, this, "invalid-user-token" /* INVALID_AUTH */ );
        return this._updateCurrentUser(user && user._clone(this));
    }
    async _updateCurrentUser(user, skipBeforeStateCallbacks = false) {
        if (this._deleted) return;
        if (user) $8fd3c2447d7c53c3$export$9fa96a7d116ea3ce(this.tenantId === user.tenantId, this, "tenant-id-mismatch" /* TENANT_ID_MISMATCH */ );
        if (!skipBeforeStateCallbacks) await this.beforeStateQueue.runMiddleware(user);
        return this.queue(async ()=>{
            await this.directlySetCurrentUser(user);
            this.notifyAuthListeners();
        });
    }
    async signOut() {
        // Run first, to block _setRedirectUser() if any callbacks fail.
        await this.beforeStateQueue.runMiddleware(null);
        // Clear the redirect user when signOut is called
        if (this.redirectPersistenceManager || this._popupRedirectResolver) await this._setRedirectUser(null);
        // Prevent callbacks from being called again in _updateCurrentUser, as
        // they were already called in the first line.
        return this._updateCurrentUser(null, /* skipBeforeStateCallbacks */ true);
    }
    setPersistence(persistence) {
        return this.queue(async ()=>{
            await this.assertedPersistence.setPersistence($8fd3c2447d7c53c3$export$28f7fcd39efa255(persistence));
        });
    }
    _getPersistence() {
        return this.assertedPersistence.persistence.type;
    }
    _updateErrorMap(errorMap) {
        this._errorFactory = new (0, $6vM9o.ErrorFactory)("auth", "Firebase", errorMap());
    }
    onAuthStateChanged(nextOrObserver, error, completed) {
        return this.registerStateListener(this.authStateSubscription, nextOrObserver, error, completed);
    }
    beforeAuthStateChanged(callback, onAbort) {
        return this.beforeStateQueue.pushCallback(callback, onAbort);
    }
    onIdTokenChanged(nextOrObserver, error, completed) {
        return this.registerStateListener(this.idTokenSubscription, nextOrObserver, error, completed);
    }
    toJSON() {
        var _a;
        return {
            apiKey: this.config.apiKey,
            authDomain: this.config.authDomain,
            appName: this.name,
            currentUser: (_a = this._currentUser) === null || _a === void 0 ? void 0 : _a.toJSON()
        };
    }
    async _setRedirectUser(user, popupRedirectResolver) {
        const redirectManager = await this.getOrInitRedirectPersistenceManager(popupRedirectResolver);
        return user === null ? redirectManager.removeCurrentUser() : redirectManager.setCurrentUser(user);
    }
    async getOrInitRedirectPersistenceManager(popupRedirectResolver) {
        if (!this.redirectPersistenceManager) {
            const resolver = popupRedirectResolver && $8fd3c2447d7c53c3$export$28f7fcd39efa255(popupRedirectResolver) || this._popupRedirectResolver;
            $8fd3c2447d7c53c3$export$9fa96a7d116ea3ce(resolver, this, "argument-error" /* ARGUMENT_ERROR */ );
            this.redirectPersistenceManager = await $8fd3c2447d7c53c3$var$PersistenceUserManager.create(this, [
                $8fd3c2447d7c53c3$export$28f7fcd39efa255(resolver._redirectPersistence)
            ], "redirectUser" /* REDIRECT_USER */ );
            this.redirectUser = await this.redirectPersistenceManager.getCurrentUser();
        }
        return this.redirectPersistenceManager;
    }
    async _redirectUserForId(id) {
        var _a, _b;
        // Make sure we've cleared any pending persistence actions if we're not in
        // the initializer
        if (this._isInitialized) await this.queue(async ()=>{});
        if (((_a = this._currentUser) === null || _a === void 0 ? void 0 : _a._redirectEventId) === id) return this._currentUser;
        if (((_b = this.redirectUser) === null || _b === void 0 ? void 0 : _b._redirectEventId) === id) return this.redirectUser;
        return null;
    }
    async _persistUserIfCurrent(user) {
        if (user === this.currentUser) return this.queue(async ()=>this.directlySetCurrentUser(user));
    }
    /** Notifies listeners only if the user is current */ _notifyListenersIfCurrent(user) {
        if (user === this.currentUser) this.notifyAuthListeners();
    }
    _key() {
        return `${this.config.authDomain}:${this.config.apiKey}:${this.name}`;
    }
    _startProactiveRefresh() {
        this.isProactiveRefreshEnabled = true;
        if (this.currentUser) this._currentUser._startProactiveRefresh();
    }
    _stopProactiveRefresh() {
        this.isProactiveRefreshEnabled = false;
        if (this.currentUser) this._currentUser._stopProactiveRefresh();
    }
    /** Returns the current user cast as the internal type */ get _currentUser() {
        return this.currentUser;
    }
    notifyAuthListeners() {
        var _a, _b;
        if (!this._isInitialized) return;
        this.idTokenSubscription.next(this.currentUser);
        const currentUid = (_b = (_a = this.currentUser) === null || _a === void 0 ? void 0 : _a.uid) !== null && _b !== void 0 ? _b : null;
        if (this.lastNotifiedUid !== currentUid) {
            this.lastNotifiedUid = currentUid;
            this.authStateSubscription.next(this.currentUser);
        }
    }
    registerStateListener(subscription, nextOrObserver, error, completed) {
        if (this._deleted) return ()=>{};
        const cb = typeof nextOrObserver === "function" ? nextOrObserver : nextOrObserver.next.bind(nextOrObserver);
        const promise = this._isInitialized ? Promise.resolve() : this._initializationPromise;
        $8fd3c2447d7c53c3$export$9fa96a7d116ea3ce(promise, this, "internal-error" /* INTERNAL_ERROR */ );
        // The callback needs to be called asynchronously per the spec.
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        promise.then(()=>cb(this.currentUser));
        if (typeof nextOrObserver === "function") return subscription.addObserver(nextOrObserver, error, completed);
        else return subscription.addObserver(nextOrObserver);
    }
    /**
     * Unprotected (from race conditions) method to set the current user. This
     * should only be called from within a queued callback. This is necessary
     * because the queue shouldn't rely on another queued callback.
     */ async directlySetCurrentUser(user) {
        if (this.currentUser && this.currentUser !== user) {
            this._currentUser._stopProactiveRefresh();
            if (user && this.isProactiveRefreshEnabled) user._startProactiveRefresh();
        }
        this.currentUser = user;
        if (user) await this.assertedPersistence.setCurrentUser(user);
        else await this.assertedPersistence.removeCurrentUser();
    }
    queue(action) {
        // In case something errors, the callback still should be called in order
        // to keep the promise chain alive
        this.operations = this.operations.then(action, action);
        return this.operations;
    }
    get assertedPersistence() {
        $8fd3c2447d7c53c3$export$9fa96a7d116ea3ce(this.persistenceManager, this, "internal-error" /* INTERNAL_ERROR */ );
        return this.persistenceManager;
    }
    _logFramework(framework) {
        if (!framework || this.frameworks.includes(framework)) return;
        this.frameworks.push(framework);
        // Sort alphabetically so that "FirebaseCore-web,FirebaseUI-web" and
        // "FirebaseUI-web,FirebaseCore-web" aren't viewed as different.
        this.frameworks.sort();
        this.clientVersion = $8fd3c2447d7c53c3$export$a33b77bbdbb8366c(this.config.clientPlatform, this._getFrameworks());
    }
    _getFrameworks() {
        return this.frameworks;
    }
    async _getAdditionalHeaders() {
        var _a;
        // Additional headers on every request
        const headers = {
            ["X-Client-Version" /* X_CLIENT_VERSION */ ]: this.clientVersion
        };
        if (this.app.options.appId) headers["X-Firebase-gmpid" /* X_FIREBASE_GMPID */ ] = this.app.options.appId;
        // If the heartbeat service exists, add the heartbeat string
        const heartbeatsHeader = await ((_a = this.heartbeatServiceProvider.getImmediate({
            optional: true
        })) === null || _a === void 0 ? void 0 : _a.getHeartbeatsHeader());
        if (heartbeatsHeader) headers["X-Firebase-Client" /* X_FIREBASE_CLIENT */ ] = heartbeatsHeader;
        return headers;
    }
    constructor(app, heartbeatServiceProvider, config){
        this.app = app;
        this.heartbeatServiceProvider = heartbeatServiceProvider;
        this.config = config;
        this.currentUser = null;
        this.emulatorConfig = null;
        this.operations = Promise.resolve();
        this.authStateSubscription = new $8fd3c2447d7c53c3$var$Subscription(this);
        this.idTokenSubscription = new $8fd3c2447d7c53c3$var$Subscription(this);
        this.beforeStateQueue = new $8fd3c2447d7c53c3$var$AuthMiddlewareQueue(this);
        this.redirectUser = null;
        this.isProactiveRefreshEnabled = false;
        // Any network calls will set this to true and prevent subsequent emulator
        // initialization
        this._canInitEmulator = true;
        this._isInitialized = false;
        this._deleted = false;
        this._initializationPromise = null;
        this._popupRedirectResolver = null;
        this._errorFactory = $8fd3c2447d7c53c3$var$_DEFAULT_AUTH_ERROR_FACTORY;
        // Tracks the last notified UID for state change listeners to prevent
        // repeated calls to the callbacks. Undefined means it's never been
        // called, whereas null means it's been called with a signed out user
        this.lastNotifiedUid = undefined;
        this.languageCode = null;
        this.tenantId = null;
        this.settings = {
            appVerificationDisabledForTesting: false
        };
        this.frameworks = [];
        this.name = app.name;
        this.clientVersion = config.sdkClientVersion;
    }
}
/**
 * Method to be used to cast down to our private implmentation of Auth.
 * It will also handle unwrapping from the compat type if necessary
 *
 * @param auth Auth object passed in from developer
 */ function $8fd3c2447d7c53c3$export$158acd800e1ef08b(auth) {
    return (0, $6vM9o.getModularInstance)(auth);
}
/** Helper class to wrap subscriber logic */ class $8fd3c2447d7c53c3$var$Subscription {
    get next() {
        $8fd3c2447d7c53c3$export$9fa96a7d116ea3ce(this.observer, this.auth, "internal-error" /* INTERNAL_ERROR */ );
        return this.observer.next.bind(this.observer);
    }
    constructor(auth){
        this.auth = auth;
        this.observer = null;
        this.addObserver = (0, $6vM9o.createSubscribe)((observer)=>this.observer = observer);
    }
}
/**
 * Changes the {@link Auth} instance to communicate with the Firebase Auth Emulator, instead of production
 * Firebase Auth services.
 *
 * @remarks
 * This must be called synchronously immediately following the first call to
 * {@link initializeAuth}.  Do not use with production credentials as emulator
 * traffic is not encrypted.
 *
 *
 * @example
 * ```javascript
 * connectAuthEmulator(auth, 'http://127.0.0.1:9099', { disableWarnings: true });
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param url - The URL at which the emulator is running (eg, 'http://localhost:9099').
 * @param options - Optional. `options.disableWarnings` defaults to `false`. Set it to
 * `true` to disable the warning banner attached to the DOM.
 *
 * @public
 */ function $8fd3c2447d7c53c3$export$2329c99376c9d0a4(auth, url, options) {
    const authInternal = $8fd3c2447d7c53c3$export$158acd800e1ef08b(auth);
    $8fd3c2447d7c53c3$export$9fa96a7d116ea3ce(authInternal._canInitEmulator, authInternal, "emulator-config-failed" /* EMULATOR_CONFIG_FAILED */ );
    $8fd3c2447d7c53c3$export$9fa96a7d116ea3ce(/^https?:\/\//.test(url), authInternal, "invalid-emulator-scheme" /* INVALID_EMULATOR_SCHEME */ );
    const disableWarnings = !!(options === null || options === void 0 ? void 0 : options.disableWarnings);
    const protocol = $8fd3c2447d7c53c3$var$extractProtocol(url);
    const { host: host, port: port } = $8fd3c2447d7c53c3$var$extractHostAndPort(url);
    const portStr = port === null ? "" : `:${port}`;
    // Always replace path with "/" (even if input url had no path at all, or had a different one).
    authInternal.config.emulator = {
        url: `${protocol}//${host}${portStr}/`
    };
    authInternal.settings.appVerificationDisabledForTesting = true;
    authInternal.emulatorConfig = Object.freeze({
        host: host,
        port: port,
        protocol: protocol.replace(":", ""),
        options: Object.freeze({
            disableWarnings: disableWarnings
        })
    });
    if (!disableWarnings) $8fd3c2447d7c53c3$var$emitEmulatorWarning();
}
function $8fd3c2447d7c53c3$var$extractProtocol(url) {
    const protocolEnd = url.indexOf(":");
    return protocolEnd < 0 ? "" : url.substr(0, protocolEnd + 1);
}
function $8fd3c2447d7c53c3$var$extractHostAndPort(url) {
    const protocol = $8fd3c2447d7c53c3$var$extractProtocol(url);
    const authority = /(\/\/)?([^?#/]+)/.exec(url.substr(protocol.length)); // Between // and /, ? or #.
    if (!authority) return {
        host: "",
        port: null
    };
    const hostAndPort = authority[2].split("@").pop() || ""; // Strip out "username:password@".
    const bracketedIPv6 = /^(\[[^\]]+\])(:|$)/.exec(hostAndPort);
    if (bracketedIPv6) {
        const host = bracketedIPv6[1];
        return {
            host: host,
            port: $8fd3c2447d7c53c3$var$parsePort(hostAndPort.substr(host.length + 1))
        };
    } else {
        const [host, port] = hostAndPort.split(":");
        return {
            host: host,
            port: $8fd3c2447d7c53c3$var$parsePort(port)
        };
    }
}
function $8fd3c2447d7c53c3$var$parsePort(portStr) {
    if (!portStr) return null;
    const port = Number(portStr);
    if (isNaN(port)) return null;
    return port;
}
function $8fd3c2447d7c53c3$var$emitEmulatorWarning() {
    function attachBanner() {
        const el = document.createElement("p");
        const sty = el.style;
        el.innerText = "Running in emulator mode. Do not use with production credentials.";
        sty.position = "fixed";
        sty.width = "100%";
        sty.backgroundColor = "#ffffff";
        sty.border = ".1em solid #000000";
        sty.color = "#b50000";
        sty.bottom = "0px";
        sty.left = "0px";
        sty.margin = "0px";
        sty.zIndex = "10000";
        sty.textAlign = "center";
        el.classList.add("firebase-emulator-warning");
        document.body.appendChild(el);
    }
    if (typeof console !== "undefined" && typeof console.info === "function") console.info("WARNING: You are using the Auth Emulator, which is intended for local testing only.  Do not use with production credentials.");
    if (typeof window !== "undefined" && typeof document !== "undefined") {
        if (document.readyState === "loading") window.addEventListener("DOMContentLoaded", attachBanner);
        else attachBanner();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface that represents the credentials returned by an {@link AuthProvider}.
 *
 * @remarks
 * Implementations specify the details about each auth provider's credential requirements.
 *
 * @public
 */ class $8fd3c2447d7c53c3$export$7f8ddf7c7c20b3cd {
    /**
     * Returns a JSON-serializable representation of this object.
     *
     * @returns a JSON-serializable representation of this object.
     */ toJSON() {
        return $8fd3c2447d7c53c3$var$debugFail("not implemented");
    }
    /** @internal */ _getIdTokenResponse(_auth) {
        return $8fd3c2447d7c53c3$var$debugFail("not implemented");
    }
    /** @internal */ _linkToIdToken(_auth, _idToken) {
        return $8fd3c2447d7c53c3$var$debugFail("not implemented");
    }
    /** @internal */ _getReauthenticationResolver(_auth) {
        return $8fd3c2447d7c53c3$var$debugFail("not implemented");
    }
    /** @internal */ constructor(/**
     * The authentication provider ID for the credential.
     *
     * @remarks
     * For example, 'facebook.com', or 'google.com'.
     */ providerId, /**
     * The authentication sign in method for the credential.
     *
     * @remarks
     * For example, {@link SignInMethod}.EMAIL_PASSWORD, or
     * {@link SignInMethod}.EMAIL_LINK. This corresponds to the sign-in method
     * identifier as returned in {@link fetchSignInMethodsForEmail}.
     */ signInMethod){
        this.providerId = providerId;
        this.signInMethod = signInMethod;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $8fd3c2447d7c53c3$var$resetPassword(auth, request) {
    return $8fd3c2447d7c53c3$var$_performApiRequest(auth, "POST" /* POST */ , "/v1/accounts:resetPassword" /* RESET_PASSWORD */ , $8fd3c2447d7c53c3$var$_addTidIfNecessary(auth, request));
}
async function $8fd3c2447d7c53c3$var$updateEmailPassword(auth, request) {
    return $8fd3c2447d7c53c3$var$_performApiRequest(auth, "POST" /* POST */ , "/v1/accounts:update" /* SET_ACCOUNT_INFO */ , request);
}
async function $8fd3c2447d7c53c3$var$applyActionCode$1(auth, request) {
    return $8fd3c2447d7c53c3$var$_performApiRequest(auth, "POST" /* POST */ , "/v1/accounts:update" /* SET_ACCOUNT_INFO */ , $8fd3c2447d7c53c3$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $8fd3c2447d7c53c3$var$signInWithPassword(auth, request) {
    return $8fd3c2447d7c53c3$var$_performSignInRequest(auth, "POST" /* POST */ , "/v1/accounts:signInWithPassword" /* SIGN_IN_WITH_PASSWORD */ , $8fd3c2447d7c53c3$var$_addTidIfNecessary(auth, request));
}
async function $8fd3c2447d7c53c3$var$sendOobCode(auth, request) {
    return $8fd3c2447d7c53c3$var$_performApiRequest(auth, "POST" /* POST */ , "/v1/accounts:sendOobCode" /* SEND_OOB_CODE */ , $8fd3c2447d7c53c3$var$_addTidIfNecessary(auth, request));
}
async function $8fd3c2447d7c53c3$var$sendEmailVerification$1(auth, request) {
    return $8fd3c2447d7c53c3$var$sendOobCode(auth, request);
}
async function $8fd3c2447d7c53c3$var$sendPasswordResetEmail$1(auth, request) {
    return $8fd3c2447d7c53c3$var$sendOobCode(auth, request);
}
async function $8fd3c2447d7c53c3$var$sendSignInLinkToEmail$1(auth, request) {
    return $8fd3c2447d7c53c3$var$sendOobCode(auth, request);
}
async function $8fd3c2447d7c53c3$var$verifyAndChangeEmail(auth, request) {
    return $8fd3c2447d7c53c3$var$sendOobCode(auth, request);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $8fd3c2447d7c53c3$var$signInWithEmailLink$1(auth, request) {
    return $8fd3c2447d7c53c3$var$_performSignInRequest(auth, "POST" /* POST */ , "/v1/accounts:signInWithEmailLink" /* SIGN_IN_WITH_EMAIL_LINK */ , $8fd3c2447d7c53c3$var$_addTidIfNecessary(auth, request));
}
async function $8fd3c2447d7c53c3$var$signInWithEmailLinkForLinking(auth, request) {
    return $8fd3c2447d7c53c3$var$_performSignInRequest(auth, "POST" /* POST */ , "/v1/accounts:signInWithEmailLink" /* SIGN_IN_WITH_EMAIL_LINK */ , $8fd3c2447d7c53c3$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface that represents the credentials returned by {@link EmailAuthProvider} for
 * {@link ProviderId}.PASSWORD
 *
 * @remarks
 * Covers both {@link SignInMethod}.EMAIL_PASSWORD and
 * {@link SignInMethod}.EMAIL_LINK.
 *
 * @public
 */ class $8fd3c2447d7c53c3$export$9bb611d729802a56 extends $8fd3c2447d7c53c3$export$7f8ddf7c7c20b3cd {
    /** @internal */ static _fromEmailAndPassword(email, password) {
        return new $8fd3c2447d7c53c3$export$9bb611d729802a56(email, password, "password" /* EMAIL_PASSWORD */ );
    }
    /** @internal */ static _fromEmailAndCode(email, oobCode, tenantId = null) {
        return new $8fd3c2447d7c53c3$export$9bb611d729802a56(email, oobCode, "emailLink" /* EMAIL_LINK */ , tenantId);
    }
    /** {@inheritdoc AuthCredential.toJSON} */ toJSON() {
        return {
            email: this._email,
            password: this._password,
            signInMethod: this.signInMethod,
            tenantId: this._tenantId
        };
    }
    /**
     * Static method to deserialize a JSON representation of an object into an {@link  AuthCredential}.
     *
     * @param json - Either `object` or the stringified representation of the object. When string is
     * provided, `JSON.parse` would be called first.
     *
     * @returns If the JSON input does not represent an {@link AuthCredential}, null is returned.
     */ static fromJSON(json) {
        const obj = typeof json === "string" ? JSON.parse(json) : json;
        if ((obj === null || obj === void 0 ? void 0 : obj.email) && (obj === null || obj === void 0 ? void 0 : obj.password)) {
            if (obj.signInMethod === "password" /* EMAIL_PASSWORD */ ) return this._fromEmailAndPassword(obj.email, obj.password);
            else if (obj.signInMethod === "emailLink" /* EMAIL_LINK */ ) return this._fromEmailAndCode(obj.email, obj.password, obj.tenantId);
        }
        return null;
    }
    /** @internal */ async _getIdTokenResponse(auth) {
        switch(this.signInMethod){
            case "password" /* EMAIL_PASSWORD */ :
                return $8fd3c2447d7c53c3$var$signInWithPassword(auth, {
                    returnSecureToken: true,
                    email: this._email,
                    password: this._password
                });
            case "emailLink" /* EMAIL_LINK */ :
                return $8fd3c2447d7c53c3$var$signInWithEmailLink$1(auth, {
                    email: this._email,
                    oobCode: this._password
                });
            default:
                $8fd3c2447d7c53c3$export$493d36ec626b6698(auth, "internal-error" /* INTERNAL_ERROR */ );
        }
    }
    /** @internal */ async _linkToIdToken(auth, idToken) {
        switch(this.signInMethod){
            case "password" /* EMAIL_PASSWORD */ :
                return $8fd3c2447d7c53c3$var$updateEmailPassword(auth, {
                    idToken: idToken,
                    returnSecureToken: true,
                    email: this._email,
                    password: this._password
                });
            case "emailLink" /* EMAIL_LINK */ :
                return $8fd3c2447d7c53c3$var$signInWithEmailLinkForLinking(auth, {
                    idToken: idToken,
                    email: this._email,
                    oobCode: this._password
                });
            default:
                $8fd3c2447d7c53c3$export$493d36ec626b6698(auth, "internal-error" /* INTERNAL_ERROR */ );
        }
    }
    /** @internal */ _getReauthenticationResolver(auth) {
        return this._getIdTokenResponse(auth);
    }
    /** @internal */ constructor(/** @internal */ _email, /** @internal */ _password, signInMethod, /** @internal */ _tenantId = null){
        super("password" /* PASSWORD */ , signInMethod);
        this._email = _email;
        this._password = _password;
        this._tenantId = _tenantId;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $8fd3c2447d7c53c3$var$signInWithIdp(auth, request) {
    return $8fd3c2447d7c53c3$var$_performSignInRequest(auth, "POST" /* POST */ , "/v1/accounts:signInWithIdp" /* SIGN_IN_WITH_IDP */ , $8fd3c2447d7c53c3$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $8fd3c2447d7c53c3$var$IDP_REQUEST_URI$1 = "http://localhost";
/**
 * Represents the OAuth credentials returned by an {@link OAuthProvider}.
 *
 * @remarks
 * Implementations specify the details about each auth provider's credential requirements.
 *
 * @public
 */ class $8fd3c2447d7c53c3$export$b4171a6734a65d42 extends $8fd3c2447d7c53c3$export$7f8ddf7c7c20b3cd {
    /** @internal */ static _fromParams(params) {
        const cred = new $8fd3c2447d7c53c3$export$b4171a6734a65d42(params.providerId, params.signInMethod);
        if (params.idToken || params.accessToken) {
            // OAuth 2 and either ID token or access token.
            if (params.idToken) cred.idToken = params.idToken;
            if (params.accessToken) cred.accessToken = params.accessToken;
            // Add nonce if available and no pendingToken is present.
            if (params.nonce && !params.pendingToken) cred.nonce = params.nonce;
            if (params.pendingToken) cred.pendingToken = params.pendingToken;
        } else if (params.oauthToken && params.oauthTokenSecret) {
            // OAuth 1 and OAuth token with token secret
            cred.accessToken = params.oauthToken;
            cred.secret = params.oauthTokenSecret;
        } else $8fd3c2447d7c53c3$export$493d36ec626b6698("argument-error" /* ARGUMENT_ERROR */ );
        return cred;
    }
    /** {@inheritdoc AuthCredential.toJSON}  */ toJSON() {
        return {
            idToken: this.idToken,
            accessToken: this.accessToken,
            secret: this.secret,
            nonce: this.nonce,
            pendingToken: this.pendingToken,
            providerId: this.providerId,
            signInMethod: this.signInMethod
        };
    }
    /**
     * Static method to deserialize a JSON representation of an object into an
     * {@link  AuthCredential}.
     *
     * @param json - Input can be either Object or the stringified representation of the object.
     * When string is provided, JSON.parse would be called first.
     *
     * @returns If the JSON input does not represent an {@link  AuthCredential}, null is returned.
     */ static fromJSON(json) {
        const obj = typeof json === "string" ? JSON.parse(json) : json;
        const { providerId: providerId, signInMethod: signInMethod } = obj, rest = (0, $k2nG7.__rest)(obj, [
            "providerId",
            "signInMethod"
        ]);
        if (!providerId || !signInMethod) return null;
        const cred = new $8fd3c2447d7c53c3$export$b4171a6734a65d42(providerId, signInMethod);
        cred.idToken = rest.idToken || undefined;
        cred.accessToken = rest.accessToken || undefined;
        cred.secret = rest.secret;
        cred.nonce = rest.nonce;
        cred.pendingToken = rest.pendingToken || null;
        return cred;
    }
    /** @internal */ _getIdTokenResponse(auth) {
        const request = this.buildRequest();
        return $8fd3c2447d7c53c3$var$signInWithIdp(auth, request);
    }
    /** @internal */ _linkToIdToken(auth, idToken) {
        const request = this.buildRequest();
        request.idToken = idToken;
        return $8fd3c2447d7c53c3$var$signInWithIdp(auth, request);
    }
    /** @internal */ _getReauthenticationResolver(auth) {
        const request = this.buildRequest();
        request.autoCreate = false;
        return $8fd3c2447d7c53c3$var$signInWithIdp(auth, request);
    }
    buildRequest() {
        const request = {
            requestUri: $8fd3c2447d7c53c3$var$IDP_REQUEST_URI$1,
            returnSecureToken: true
        };
        if (this.pendingToken) request.pendingToken = this.pendingToken;
        else {
            const postBody = {};
            if (this.idToken) postBody["id_token"] = this.idToken;
            if (this.accessToken) postBody["access_token"] = this.accessToken;
            if (this.secret) postBody["oauth_token_secret"] = this.secret;
            postBody["providerId"] = this.providerId;
            if (this.nonce && !this.pendingToken) postBody["nonce"] = this.nonce;
            request.postBody = (0, $6vM9o.querystring)(postBody);
        }
        return request;
    }
    constructor(){
        super(...arguments);
        this.pendingToken = null;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $8fd3c2447d7c53c3$var$sendPhoneVerificationCode(auth, request) {
    return $8fd3c2447d7c53c3$var$_performApiRequest(auth, "POST" /* POST */ , "/v1/accounts:sendVerificationCode" /* SEND_VERIFICATION_CODE */ , $8fd3c2447d7c53c3$var$_addTidIfNecessary(auth, request));
}
async function $8fd3c2447d7c53c3$var$signInWithPhoneNumber$1(auth, request) {
    return $8fd3c2447d7c53c3$var$_performSignInRequest(auth, "POST" /* POST */ , "/v1/accounts:signInWithPhoneNumber" /* SIGN_IN_WITH_PHONE_NUMBER */ , $8fd3c2447d7c53c3$var$_addTidIfNecessary(auth, request));
}
async function $8fd3c2447d7c53c3$var$linkWithPhoneNumber$1(auth, request) {
    const response = await $8fd3c2447d7c53c3$var$_performSignInRequest(auth, "POST" /* POST */ , "/v1/accounts:signInWithPhoneNumber" /* SIGN_IN_WITH_PHONE_NUMBER */ , $8fd3c2447d7c53c3$var$_addTidIfNecessary(auth, request));
    if (response.temporaryProof) throw $8fd3c2447d7c53c3$var$_makeTaggedError(auth, "account-exists-with-different-credential" /* NEED_CONFIRMATION */ , response);
    return response;
}
const $8fd3c2447d7c53c3$var$VERIFY_PHONE_NUMBER_FOR_EXISTING_ERROR_MAP_ = {
    ["USER_NOT_FOUND" /* USER_NOT_FOUND */ ]: "user-not-found" /* USER_DELETED */ 
};
async function $8fd3c2447d7c53c3$var$verifyPhoneNumberForExisting(auth, request) {
    const apiRequest = Object.assign(Object.assign({}, request), {
        operation: "REAUTH"
    });
    return $8fd3c2447d7c53c3$var$_performSignInRequest(auth, "POST" /* POST */ , "/v1/accounts:signInWithPhoneNumber" /* SIGN_IN_WITH_PHONE_NUMBER */ , $8fd3c2447d7c53c3$var$_addTidIfNecessary(auth, apiRequest), $8fd3c2447d7c53c3$var$VERIFY_PHONE_NUMBER_FOR_EXISTING_ERROR_MAP_);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents the credentials returned by {@link PhoneAuthProvider}.
 *
 * @public
 */ class $8fd3c2447d7c53c3$export$3466f893ebf79586 extends $8fd3c2447d7c53c3$export$7f8ddf7c7c20b3cd {
    /** @internal */ static _fromVerification(verificationId, verificationCode) {
        return new $8fd3c2447d7c53c3$export$3466f893ebf79586({
            verificationId: verificationId,
            verificationCode: verificationCode
        });
    }
    /** @internal */ static _fromTokenResponse(phoneNumber, temporaryProof) {
        return new $8fd3c2447d7c53c3$export$3466f893ebf79586({
            phoneNumber: phoneNumber,
            temporaryProof: temporaryProof
        });
    }
    /** @internal */ _getIdTokenResponse(auth) {
        return $8fd3c2447d7c53c3$var$signInWithPhoneNumber$1(auth, this._makeVerificationRequest());
    }
    /** @internal */ _linkToIdToken(auth, idToken) {
        return $8fd3c2447d7c53c3$var$linkWithPhoneNumber$1(auth, Object.assign({
            idToken: idToken
        }, this._makeVerificationRequest()));
    }
    /** @internal */ _getReauthenticationResolver(auth) {
        return $8fd3c2447d7c53c3$var$verifyPhoneNumberForExisting(auth, this._makeVerificationRequest());
    }
    /** @internal */ _makeVerificationRequest() {
        const { temporaryProof: temporaryProof, phoneNumber: phoneNumber, verificationId: verificationId, verificationCode: verificationCode } = this.params;
        if (temporaryProof && phoneNumber) return {
            temporaryProof: temporaryProof,
            phoneNumber: phoneNumber
        };
        return {
            sessionInfo: verificationId,
            code: verificationCode
        };
    }
    /** {@inheritdoc AuthCredential.toJSON} */ toJSON() {
        const obj = {
            providerId: this.providerId
        };
        if (this.params.phoneNumber) obj.phoneNumber = this.params.phoneNumber;
        if (this.params.temporaryProof) obj.temporaryProof = this.params.temporaryProof;
        if (this.params.verificationCode) obj.verificationCode = this.params.verificationCode;
        if (this.params.verificationId) obj.verificationId = this.params.verificationId;
        return obj;
    }
    /** Generates a phone credential based on a plain object or a JSON string. */ static fromJSON(json) {
        if (typeof json === "string") json = JSON.parse(json);
        const { verificationId: verificationId, verificationCode: verificationCode, phoneNumber: phoneNumber, temporaryProof: temporaryProof } = json;
        if (!verificationCode && !verificationId && !phoneNumber && !temporaryProof) return null;
        return new $8fd3c2447d7c53c3$export$3466f893ebf79586({
            verificationId: verificationId,
            verificationCode: verificationCode,
            phoneNumber: phoneNumber,
            temporaryProof: temporaryProof
        });
    }
    constructor(params){
        super("phone" /* PHONE */ , "phone" /* PHONE */ );
        this.params = params;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Maps the mode string in action code URL to Action Code Info operation.
 *
 * @param mode
 */ function $8fd3c2447d7c53c3$var$parseMode(mode) {
    switch(mode){
        case "recoverEmail":
            return "RECOVER_EMAIL" /* RECOVER_EMAIL */ ;
        case "resetPassword":
            return "PASSWORD_RESET" /* PASSWORD_RESET */ ;
        case "signIn":
            return "EMAIL_SIGNIN" /* EMAIL_SIGNIN */ ;
        case "verifyEmail":
            return "VERIFY_EMAIL" /* VERIFY_EMAIL */ ;
        case "verifyAndChangeEmail":
            return "VERIFY_AND_CHANGE_EMAIL" /* VERIFY_AND_CHANGE_EMAIL */ ;
        case "revertSecondFactorAddition":
            return "REVERT_SECOND_FACTOR_ADDITION" /* REVERT_SECOND_FACTOR_ADDITION */ ;
        default:
            return null;
    }
}
/**
 * Helper to parse FDL links
 *
 * @param url
 */ function $8fd3c2447d7c53c3$var$parseDeepLink(url) {
    const link = (0, $6vM9o.querystringDecode)((0, $6vM9o.extractQuerystring)(url))["link"];
    // Double link case (automatic redirect).
    const doubleDeepLink = link ? (0, $6vM9o.querystringDecode)((0, $6vM9o.extractQuerystring)(link))["deep_link_id"] : null;
    // iOS custom scheme links.
    const iOSDeepLink = (0, $6vM9o.querystringDecode)((0, $6vM9o.extractQuerystring)(url))["deep_link_id"];
    const iOSDoubleDeepLink = iOSDeepLink ? (0, $6vM9o.querystringDecode)((0, $6vM9o.extractQuerystring)(iOSDeepLink))["link"] : null;
    return iOSDoubleDeepLink || iOSDeepLink || doubleDeepLink || link || url;
}
/**
 * A utility class to parse email action URLs such as password reset, email verification,
 * email link sign in, etc.
 *
 * @public
 */ class $8fd3c2447d7c53c3$export$4c3d22f3d993c33f {
    /**
     * Parses the email action link string and returns an {@link ActionCodeURL} if the link is valid,
     * otherwise returns null.
     *
     * @param link  - The email action link string.
     * @returns The {@link ActionCodeURL} object, or null if the link is invalid.
     *
     * @public
     */ static parseLink(link) {
        const actionLink = $8fd3c2447d7c53c3$var$parseDeepLink(link);
        try {
            return new $8fd3c2447d7c53c3$export$4c3d22f3d993c33f(actionLink);
        } catch (_a) {
            return null;
        }
    }
    /**
     * @param actionLink - The link from which to extract the URL.
     * @returns The {@link ActionCodeURL} object, or null if the link is invalid.
     *
     * @internal
     */ constructor(actionLink){
        var _a, _b, _c, _d, _e, _f;
        const searchParams = (0, $6vM9o.querystringDecode)((0, $6vM9o.extractQuerystring)(actionLink));
        const apiKey = (_a = searchParams["apiKey" /* API_KEY */ ]) !== null && _a !== void 0 ? _a : null;
        const code = (_b = searchParams["oobCode" /* CODE */ ]) !== null && _b !== void 0 ? _b : null;
        const operation = $8fd3c2447d7c53c3$var$parseMode((_c = searchParams["mode" /* MODE */ ]) !== null && _c !== void 0 ? _c : null);
        // Validate API key, code and mode.
        $8fd3c2447d7c53c3$export$9fa96a7d116ea3ce(apiKey && code && operation, "argument-error" /* ARGUMENT_ERROR */ );
        this.apiKey = apiKey;
        this.operation = operation;
        this.code = code;
        this.continueUrl = (_d = searchParams["continueUrl" /* CONTINUE_URL */ ]) !== null && _d !== void 0 ? _d : null;
        this.languageCode = (_e = searchParams["languageCode" /* LANGUAGE_CODE */ ]) !== null && _e !== void 0 ? _e : null;
        this.tenantId = (_f = searchParams["tenantId" /* TENANT_ID */ ]) !== null && _f !== void 0 ? _f : null;
    }
}
/**
 * Parses the email action link string and returns an {@link ActionCodeURL} if
 * the link is valid, otherwise returns null.
 *
 * @public
 */ function $8fd3c2447d7c53c3$export$f787f51d84a910ad(link) {
    return $8fd3c2447d7c53c3$export$4c3d22f3d993c33f.parseLink(link);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating {@link EmailAuthCredential}.
 *
 * @public
 */ class $8fd3c2447d7c53c3$export$3a1a48c8f6ef640e {
    /**
     * Initialize an {@link AuthCredential} using an email and password.
     *
     * @example
     * ```javascript
     * const authCredential = EmailAuthProvider.credential(email, password);
     * const userCredential = await signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * ```javascript
     * const userCredential = await signInWithEmailAndPassword(auth, email, password);
     * ```
     *
     * @param email - Email address.
     * @param password - User account password.
     * @returns The auth provider credential.
     */ static credential(email, password) {
        return $8fd3c2447d7c53c3$export$9bb611d729802a56._fromEmailAndPassword(email, password);
    }
    /**
     * Initialize an {@link AuthCredential} using an email and an email link after a sign in with
     * email link operation.
     *
     * @example
     * ```javascript
     * const authCredential = EmailAuthProvider.credentialWithLink(auth, email, emailLink);
     * const userCredential = await signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * ```javascript
     * await sendSignInLinkToEmail(auth, email);
     * // Obtain emailLink from user.
     * const userCredential = await signInWithEmailLink(auth, email, emailLink);
     * ```
     *
     * @param auth - The {@link Auth} instance used to verify the link.
     * @param email - Email address.
     * @param emailLink - Sign-in email link.
     * @returns - The auth provider credential.
     */ static credentialWithLink(email, emailLink) {
        const actionCodeUrl = $8fd3c2447d7c53c3$export$4c3d22f3d993c33f.parseLink(emailLink);
        $8fd3c2447d7c53c3$export$9fa96a7d116ea3ce(actionCodeUrl, "argument-error" /* ARGUMENT_ERROR */ );
        return $8fd3c2447d7c53c3$export$9bb611d729802a56._fromEmailAndCode(email, actionCodeUrl.code, actionCodeUrl.tenantId);
    }
    constructor(){
        /**
         * Always set to {@link ProviderId}.PASSWORD, even for email link.
         */ this.providerId = $8fd3c2447d7c53c3$export$3a1a48c8f6ef640e.PROVIDER_ID;
    }
}
/**
 * Always set to {@link ProviderId}.PASSWORD, even for email link.
 */ $8fd3c2447d7c53c3$export$3a1a48c8f6ef640e.PROVIDER_ID = "password" /* PASSWORD */ ;
/**
 * Always set to {@link SignInMethod}.EMAIL_PASSWORD.
 */ $8fd3c2447d7c53c3$export$3a1a48c8f6ef640e.EMAIL_PASSWORD_SIGN_IN_METHOD = "password" /* EMAIL_PASSWORD */ ;
/**
 * Always set to {@link SignInMethod}.EMAIL_LINK.
 */ $8fd3c2447d7c53c3$export$3a1a48c8f6ef640e.EMAIL_LINK_SIGN_IN_METHOD = "emailLink" /* EMAIL_LINK */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The base class for all Federated providers (OAuth (including OIDC), SAML).
 *
 * This class is not meant to be instantiated directly.
 *
 * @public
 */ class $8fd3c2447d7c53c3$var$FederatedAuthProvider {
    /**
     * Set the language gode.
     *
     * @param languageCode - language code
     */ setDefaultLanguage(languageCode) {
        this.defaultLanguageCode = languageCode;
    }
    /**
     * Sets the OAuth custom parameters to pass in an OAuth request for popup and redirect sign-in
     * operations.
     *
     * @remarks
     * For a detailed list, check the reserved required OAuth 2.0 parameters such as `client_id`,
     * `redirect_uri`, `scope`, `response_type`, and `state` are not allowed and will be ignored.
     *
     * @param customOAuthParameters - The custom OAuth parameters to pass in the OAuth request.
     */ setCustomParameters(customOAuthParameters) {
        this.customParameters = customOAuthParameters;
        return this;
    }
    /**
     * Retrieve the current list of {@link CustomParameters}.
     */ getCustomParameters() {
        return this.customParameters;
    }
    /**
     * Constructor for generic OAuth providers.
     *
     * @param providerId - Provider for which credentials should be generated.
     */ constructor(providerId){
        this.providerId = providerId;
        /** @internal */ this.defaultLanguageCode = null;
        /** @internal */ this.customParameters = {};
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Common code to all OAuth providers. This is separate from the
 * {@link OAuthProvider} so that child providers (like
 * {@link GoogleAuthProvider}) don't inherit the `credential` instance method.
 * Instead, they rely on a static `credential` method.
 */ class $8fd3c2447d7c53c3$var$BaseOAuthProvider extends $8fd3c2447d7c53c3$var$FederatedAuthProvider {
    /**
     * Add an OAuth scope to the credential.
     *
     * @param scope - Provider OAuth scope to add.
     */ addScope(scope) {
        // If not already added, add scope to list.
        if (!this.scopes.includes(scope)) this.scopes.push(scope);
        return this;
    }
    /**
     * Retrieve the current list of OAuth scopes.
     */ getScopes() {
        return [
            ...this.scopes
        ];
    }
    constructor(){
        super(...arguments);
        /** @internal */ this.scopes = [];
    }
}
/**
 * Provider for generating generic {@link OAuthCredential}.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new OAuthProvider('google.com');
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('profile');
 * provider.addScope('email');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a OAuth Access Token for the provider.
 *   const credential = provider.credentialFromResult(auth, result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new OAuthProvider('google.com');
 * provider.addScope('profile');
 * provider.addScope('email');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a OAuth Access Token for the provider.
 * const credential = provider.credentialFromResult(auth, result);
 * const token = credential.accessToken;
 * ```
 * @public
 */ class $8fd3c2447d7c53c3$export$3a6d5c9ae78a2c08 extends $8fd3c2447d7c53c3$var$BaseOAuthProvider {
    /**
     * Creates an {@link OAuthCredential} from a JSON string or a plain object.
     * @param json - A plain object or a JSON string
     */ static credentialFromJSON(json) {
        const obj = typeof json === "string" ? JSON.parse(json) : json;
        $8fd3c2447d7c53c3$export$9fa96a7d116ea3ce("providerId" in obj && "signInMethod" in obj, "argument-error" /* ARGUMENT_ERROR */ );
        return $8fd3c2447d7c53c3$export$b4171a6734a65d42._fromParams(obj);
    }
    /**
     * Creates a {@link OAuthCredential} from a generic OAuth provider's access token or ID token.
     *
     * @remarks
     * The raw nonce is required when an ID token with a nonce field is provided. The SHA-256 hash of
     * the raw nonce must match the nonce field in the ID token.
     *
     * @example
     * ```javascript
     * // `googleUser` from the onsuccess Google Sign In callback.
     * // Initialize a generate OAuth provider with a `google.com` providerId.
     * const provider = new OAuthProvider('google.com');
     * const credential = provider.credential({
     *   idToken: googleUser.getAuthResponse().id_token,
     * });
     * const result = await signInWithCredential(credential);
     * ```
     *
     * @param params - Either the options object containing the ID token, access token and raw nonce
     * or the ID token string.
     */ credential(params) {
        return this._credential(Object.assign(Object.assign({}, params), {
            nonce: params.rawNonce
        }));
    }
    /** An internal credential method that accepts more permissive options */ _credential(params) {
        $8fd3c2447d7c53c3$export$9fa96a7d116ea3ce(params.idToken || params.accessToken, "argument-error" /* ARGUMENT_ERROR */ );
        // For OAuthCredential, sign in method is same as providerId.
        return $8fd3c2447d7c53c3$export$b4171a6734a65d42._fromParams(Object.assign(Object.assign({}, params), {
            providerId: this.providerId,
            signInMethod: this.providerId
        }));
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $8fd3c2447d7c53c3$export$3a6d5c9ae78a2c08.oauthCredentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $8fd3c2447d7c53c3$export$3a6d5c9ae78a2c08.oauthCredentialFromTaggedObject(error.customData || {});
    }
    static oauthCredentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { oauthIdToken: oauthIdToken, oauthAccessToken: oauthAccessToken, oauthTokenSecret: oauthTokenSecret, pendingToken: pendingToken, nonce: nonce, providerId: providerId } = tokenResponse;
        if (!oauthAccessToken && !oauthTokenSecret && !oauthIdToken && !pendingToken) return null;
        if (!providerId) return null;
        try {
            return new $8fd3c2447d7c53c3$export$3a6d5c9ae78a2c08(providerId)._credential({
                idToken: oauthIdToken,
                accessToken: oauthAccessToken,
                nonce: nonce,
                pendingToken: pendingToken
            });
        } catch (e) {
            return null;
        }
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link OAuthCredential} for {@link ProviderId}.FACEBOOK.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('user_birthday');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Facebook Access Token.
 *   const credential = FacebookAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new FacebookAuthProvider();
 * provider.addScope('user_birthday');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Facebook Access Token.
 * const credential = FacebookAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * ```
 *
 * @public
 */ class $8fd3c2447d7c53c3$export$a07804094c3ecf2d extends $8fd3c2447d7c53c3$var$BaseOAuthProvider {
    /**
     * Creates a credential for Facebook.
     *
     * @example
     * ```javascript
     * // `event` from the Facebook auth.authResponseChange callback.
     * const credential = FacebookAuthProvider.credential(event.authResponse.accessToken);
     * const result = await signInWithCredential(credential);
     * ```
     *
     * @param accessToken - Facebook access token.
     */ static credential(accessToken) {
        return $8fd3c2447d7c53c3$export$b4171a6734a65d42._fromParams({
            providerId: $8fd3c2447d7c53c3$export$a07804094c3ecf2d.PROVIDER_ID,
            signInMethod: $8fd3c2447d7c53c3$export$a07804094c3ecf2d.FACEBOOK_SIGN_IN_METHOD,
            accessToken: accessToken
        });
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $8fd3c2447d7c53c3$export$a07804094c3ecf2d.credentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $8fd3c2447d7c53c3$export$a07804094c3ecf2d.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse || !("oauthAccessToken" in tokenResponse)) return null;
        if (!tokenResponse.oauthAccessToken) return null;
        try {
            return $8fd3c2447d7c53c3$export$a07804094c3ecf2d.credential(tokenResponse.oauthAccessToken);
        } catch (_a) {
            return null;
        }
    }
    constructor(){
        super("facebook.com" /* FACEBOOK */ );
    }
}
/** Always set to {@link SignInMethod}.FACEBOOK. */ $8fd3c2447d7c53c3$export$a07804094c3ecf2d.FACEBOOK_SIGN_IN_METHOD = "facebook.com" /* FACEBOOK */ ;
/** Always set to {@link ProviderId}.FACEBOOK. */ $8fd3c2447d7c53c3$export$a07804094c3ecf2d.PROVIDER_ID = "facebook.com" /* FACEBOOK */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an an {@link OAuthCredential} for {@link ProviderId}.GOOGLE.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new GoogleAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('profile');
 * provider.addScope('email');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Google Access Token.
 *   const credential = GoogleAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new GoogleAuthProvider();
 * provider.addScope('profile');
 * provider.addScope('email');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Google Access Token.
 * const credential = GoogleAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * ```
 *
 * @public
 */ class $8fd3c2447d7c53c3$export$3722cfe417b6ed86 extends $8fd3c2447d7c53c3$var$BaseOAuthProvider {
    /**
     * Creates a credential for Google. At least one of ID token and access token is required.
     *
     * @example
     * ```javascript
     * // \`googleUser\` from the onsuccess Google Sign In callback.
     * const credential = GoogleAuthProvider.credential(googleUser.getAuthResponse().id_token);
     * const result = await signInWithCredential(credential);
     * ```
     *
     * @param idToken - Google ID token.
     * @param accessToken - Google access token.
     */ static credential(idToken, accessToken) {
        return $8fd3c2447d7c53c3$export$b4171a6734a65d42._fromParams({
            providerId: $8fd3c2447d7c53c3$export$3722cfe417b6ed86.PROVIDER_ID,
            signInMethod: $8fd3c2447d7c53c3$export$3722cfe417b6ed86.GOOGLE_SIGN_IN_METHOD,
            idToken: idToken,
            accessToken: accessToken
        });
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $8fd3c2447d7c53c3$export$3722cfe417b6ed86.credentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $8fd3c2447d7c53c3$export$3722cfe417b6ed86.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { oauthIdToken: oauthIdToken, oauthAccessToken: oauthAccessToken } = tokenResponse;
        if (!oauthIdToken && !oauthAccessToken) // This could be an oauth 1 credential or a phone credential
        return null;
        try {
            return $8fd3c2447d7c53c3$export$3722cfe417b6ed86.credential(oauthIdToken, oauthAccessToken);
        } catch (_a) {
            return null;
        }
    }
    constructor(){
        super("google.com" /* GOOGLE */ );
        this.addScope("profile");
    }
}
/** Always set to {@link SignInMethod}.GOOGLE. */ $8fd3c2447d7c53c3$export$3722cfe417b6ed86.GOOGLE_SIGN_IN_METHOD = "google.com" /* GOOGLE */ ;
/** Always set to {@link ProviderId}.GOOGLE. */ $8fd3c2447d7c53c3$export$3722cfe417b6ed86.PROVIDER_ID = "google.com" /* GOOGLE */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link OAuthCredential} for {@link ProviderId}.GITHUB.
 *
 * @remarks
 * GitHub requires an OAuth 2.0 redirect, so you can either handle the redirect directly, or use
 * the {@link signInWithPopup} handler:
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new GithubAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('repo');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Github Access Token.
 *   const credential = GithubAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new GithubAuthProvider();
 * provider.addScope('repo');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Github Access Token.
 * const credential = GithubAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * ```
 * @public
 */ class $8fd3c2447d7c53c3$export$971d5caa766a69d7 extends $8fd3c2447d7c53c3$var$BaseOAuthProvider {
    /**
     * Creates a credential for Github.
     *
     * @param accessToken - Github access token.
     */ static credential(accessToken) {
        return $8fd3c2447d7c53c3$export$b4171a6734a65d42._fromParams({
            providerId: $8fd3c2447d7c53c3$export$971d5caa766a69d7.PROVIDER_ID,
            signInMethod: $8fd3c2447d7c53c3$export$971d5caa766a69d7.GITHUB_SIGN_IN_METHOD,
            accessToken: accessToken
        });
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $8fd3c2447d7c53c3$export$971d5caa766a69d7.credentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $8fd3c2447d7c53c3$export$971d5caa766a69d7.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse || !("oauthAccessToken" in tokenResponse)) return null;
        if (!tokenResponse.oauthAccessToken) return null;
        try {
            return $8fd3c2447d7c53c3$export$971d5caa766a69d7.credential(tokenResponse.oauthAccessToken);
        } catch (_a) {
            return null;
        }
    }
    constructor(){
        super("github.com" /* GITHUB */ );
    }
}
/** Always set to {@link SignInMethod}.GITHUB. */ $8fd3c2447d7c53c3$export$971d5caa766a69d7.GITHUB_SIGN_IN_METHOD = "github.com" /* GITHUB */ ;
/** Always set to {@link ProviderId}.GITHUB. */ $8fd3c2447d7c53c3$export$971d5caa766a69d7.PROVIDER_ID = "github.com" /* GITHUB */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $8fd3c2447d7c53c3$var$IDP_REQUEST_URI = "http://localhost";
/**
 * @public
 */ class $8fd3c2447d7c53c3$export$91477dc880baac21 extends $8fd3c2447d7c53c3$export$7f8ddf7c7c20b3cd {
    /** @internal */ _getIdTokenResponse(auth) {
        const request = this.buildRequest();
        return $8fd3c2447d7c53c3$var$signInWithIdp(auth, request);
    }
    /** @internal */ _linkToIdToken(auth, idToken) {
        const request = this.buildRequest();
        request.idToken = idToken;
        return $8fd3c2447d7c53c3$var$signInWithIdp(auth, request);
    }
    /** @internal */ _getReauthenticationResolver(auth) {
        const request = this.buildRequest();
        request.autoCreate = false;
        return $8fd3c2447d7c53c3$var$signInWithIdp(auth, request);
    }
    /** {@inheritdoc AuthCredential.toJSON}  */ toJSON() {
        return {
            signInMethod: this.signInMethod,
            providerId: this.providerId,
            pendingToken: this.pendingToken
        };
    }
    /**
     * Static method to deserialize a JSON representation of an object into an
     * {@link  AuthCredential}.
     *
     * @param json - Input can be either Object or the stringified representation of the object.
     * When string is provided, JSON.parse would be called first.
     *
     * @returns If the JSON input does not represent an {@link  AuthCredential}, null is returned.
     */ static fromJSON(json) {
        const obj = typeof json === "string" ? JSON.parse(json) : json;
        const { providerId: providerId, signInMethod: signInMethod, pendingToken: pendingToken } = obj;
        if (!providerId || !signInMethod || !pendingToken || providerId !== signInMethod) return null;
        return new $8fd3c2447d7c53c3$export$91477dc880baac21(providerId, pendingToken);
    }
    /**
     * Helper static method to avoid exposing the constructor to end users.
     *
     * @internal
     */ static _create(providerId, pendingToken) {
        return new $8fd3c2447d7c53c3$export$91477dc880baac21(providerId, pendingToken);
    }
    buildRequest() {
        return {
            requestUri: $8fd3c2447d7c53c3$var$IDP_REQUEST_URI,
            returnSecureToken: true,
            pendingToken: this.pendingToken
        };
    }
    /** @internal */ constructor(providerId, pendingToken){
        super(providerId, providerId);
        this.pendingToken = pendingToken;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $8fd3c2447d7c53c3$var$SAML_PROVIDER_PREFIX = "saml.";
/**
 * An {@link AuthProvider} for SAML.
 *
 * @public
 */ class $8fd3c2447d7c53c3$export$e7c866399fa523f5 extends $8fd3c2447d7c53c3$var$FederatedAuthProvider {
    /**
     * Generates an {@link AuthCredential} from a {@link UserCredential} after a
     * successful SAML flow completes.
     *
     * @remarks
     *
     * For example, to get an {@link AuthCredential}, you could write the
     * following code:
     *
     * ```js
     * const userCredential = await signInWithPopup(auth, samlProvider);
     * const credential = SAMLAuthProvider.credentialFromResult(userCredential);
     * ```
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $8fd3c2447d7c53c3$export$e7c866399fa523f5.samlCredentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $8fd3c2447d7c53c3$export$e7c866399fa523f5.samlCredentialFromTaggedObject(error.customData || {});
    }
    /**
     * Creates an {@link AuthCredential} from a JSON string or a plain object.
     * @param json - A plain object or a JSON string
     */ static credentialFromJSON(json) {
        const credential = $8fd3c2447d7c53c3$export$91477dc880baac21.fromJSON(json);
        $8fd3c2447d7c53c3$export$9fa96a7d116ea3ce(credential, "argument-error" /* ARGUMENT_ERROR */ );
        return credential;
    }
    static samlCredentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { pendingToken: pendingToken, providerId: providerId } = tokenResponse;
        if (!pendingToken || !providerId) return null;
        try {
            return $8fd3c2447d7c53c3$export$91477dc880baac21._create(providerId, pendingToken);
        } catch (e) {
            return null;
        }
    }
    /**
     * Constructor. The providerId must start with "saml."
     * @param providerId - SAML provider ID.
     */ constructor(providerId){
        $8fd3c2447d7c53c3$export$9fa96a7d116ea3ce(providerId.startsWith($8fd3c2447d7c53c3$var$SAML_PROVIDER_PREFIX), "argument-error" /* ARGUMENT_ERROR */ );
        super(providerId);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link OAuthCredential} for {@link ProviderId}.TWITTER.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new TwitterAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Twitter Access Token and Secret.
 *   const credential = TwitterAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 *   const secret = credential.secret;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new TwitterAuthProvider();
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Twitter Access Token and Secret.
 * const credential = TwitterAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * const secret = credential.secret;
 * ```
 *
 * @public
 */ class $8fd3c2447d7c53c3$export$71cec2538cb2c617 extends $8fd3c2447d7c53c3$var$BaseOAuthProvider {
    /**
     * Creates a credential for Twitter.
     *
     * @param token - Twitter access token.
     * @param secret - Twitter secret.
     */ static credential(token, secret) {
        return $8fd3c2447d7c53c3$export$b4171a6734a65d42._fromParams({
            providerId: $8fd3c2447d7c53c3$export$71cec2538cb2c617.PROVIDER_ID,
            signInMethod: $8fd3c2447d7c53c3$export$71cec2538cb2c617.TWITTER_SIGN_IN_METHOD,
            oauthToken: token,
            oauthTokenSecret: secret
        });
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $8fd3c2447d7c53c3$export$71cec2538cb2c617.credentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $8fd3c2447d7c53c3$export$71cec2538cb2c617.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { oauthAccessToken: oauthAccessToken, oauthTokenSecret: oauthTokenSecret } = tokenResponse;
        if (!oauthAccessToken || !oauthTokenSecret) return null;
        try {
            return $8fd3c2447d7c53c3$export$71cec2538cb2c617.credential(oauthAccessToken, oauthTokenSecret);
        } catch (_a) {
            return null;
        }
    }
    constructor(){
        super("twitter.com" /* TWITTER */ );
    }
}
/** Always set to {@link SignInMethod}.TWITTER. */ $8fd3c2447d7c53c3$export$71cec2538cb2c617.TWITTER_SIGN_IN_METHOD = "twitter.com" /* TWITTER */ ;
/** Always set to {@link ProviderId}.TWITTER. */ $8fd3c2447d7c53c3$export$71cec2538cb2c617.PROVIDER_ID = "twitter.com" /* TWITTER */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $8fd3c2447d7c53c3$var$signUp(auth, request) {
    return $8fd3c2447d7c53c3$var$_performSignInRequest(auth, "POST" /* POST */ , "/v1/accounts:signUp" /* SIGN_UP */ , $8fd3c2447d7c53c3$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $8fd3c2447d7c53c3$var$UserCredentialImpl {
    static async _fromIdTokenResponse(auth, operationType, idTokenResponse, isAnonymous = false) {
        const user = await $8fd3c2447d7c53c3$export$cf2f7c5792f80b46._fromIdTokenResponse(auth, idTokenResponse, isAnonymous);
        const providerId = $8fd3c2447d7c53c3$var$providerIdForResponse(idTokenResponse);
        const userCred = new $8fd3c2447d7c53c3$var$UserCredentialImpl({
            user: user,
            providerId: providerId,
            _tokenResponse: idTokenResponse,
            operationType: operationType
        });
        return userCred;
    }
    static async _forOperation(user, operationType, response) {
        await user._updateTokensIfNecessary(response, /* reload */ true);
        const providerId = $8fd3c2447d7c53c3$var$providerIdForResponse(response);
        return new $8fd3c2447d7c53c3$var$UserCredentialImpl({
            user: user,
            providerId: providerId,
            _tokenResponse: response,
            operationType: operationType
        });
    }
    constructor(params){
        this.user = params.user;
        this.providerId = params.providerId;
        this._tokenResponse = params._tokenResponse;
        this.operationType = params.operationType;
    }
}
function $8fd3c2447d7c53c3$var$providerIdForResponse(response) {
    if (response.providerId) return response.providerId;
    if ("phoneNumber" in response) return "phone" /* PHONE */ ;
    return null;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Asynchronously signs in as an anonymous user.
 *
 * @remarks
 * If there is already an anonymous user signed in, that user will be returned; otherwise, a
 * new anonymous user identity will be created and returned.
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */ async function $8fd3c2447d7c53c3$export$78acf4525d8a74c4(auth) {
    var _a;
    const authInternal = $8fd3c2447d7c53c3$export$158acd800e1ef08b(auth);
    await authInternal._initializationPromise;
    if ((_a = authInternal.currentUser) === null || _a === void 0 ? void 0 : _a.isAnonymous) // If an anonymous user is already signed in, no need to sign them in again.
    return new $8fd3c2447d7c53c3$var$UserCredentialImpl({
        user: authInternal.currentUser,
        providerId: null,
        operationType: "signIn" /* SIGN_IN */ 
    });
    const response = await $8fd3c2447d7c53c3$var$signUp(authInternal, {
        returnSecureToken: true
    });
    const userCredential = await $8fd3c2447d7c53c3$var$UserCredentialImpl._fromIdTokenResponse(authInternal, "signIn" /* SIGN_IN */ , response, true);
    await authInternal._updateCurrentUser(userCredential.user);
    return userCredential;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $8fd3c2447d7c53c3$var$MultiFactorError extends (0, $6vM9o.FirebaseError) {
    static _fromErrorAndOperation(auth, error, operationType, user) {
        return new $8fd3c2447d7c53c3$var$MultiFactorError(auth, error, operationType, user);
    }
    constructor(auth, error, operationType, user){
        var _a;
        super(error.code, error.message);
        this.operationType = operationType;
        this.user = user;
        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $8fd3c2447d7c53c3$var$MultiFactorError.prototype);
        this.customData = {
            appName: auth.name,
            tenantId: (_a = auth.tenantId) !== null && _a !== void 0 ? _a : undefined,
            _serverResponse: error.customData._serverResponse,
            operationType: operationType
        };
    }
}
function $8fd3c2447d7c53c3$var$_processCredentialSavingMfaContextIfNecessary(auth, operationType, credential, user) {
    const idTokenProvider = operationType === "reauthenticate" /* REAUTHENTICATE */  ? credential._getReauthenticationResolver(auth) : credential._getIdTokenResponse(auth);
    return idTokenProvider.catch((error)=>{
        if (error.code === `auth/${"multi-factor-auth-required" /* MFA_REQUIRED */ }`) throw $8fd3c2447d7c53c3$var$MultiFactorError._fromErrorAndOperation(auth, error, operationType, user);
        throw error;
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Takes a set of UserInfo provider data and converts it to a set of names
 */ function $8fd3c2447d7c53c3$var$providerDataAsNames(providerData) {
    return new Set(providerData.map(({ providerId: providerId })=>providerId).filter((pid)=>!!pid));
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Unlinks a provider from a user account.
 *
 * @param user - The user.
 * @param providerId - The provider to unlink.
 *
 * @public
 */ async function $8fd3c2447d7c53c3$export$21579262ef46735b(user, providerId) {
    const userInternal = (0, $6vM9o.getModularInstance)(user);
    await $8fd3c2447d7c53c3$var$_assertLinkedStatus(true, userInternal, providerId);
    const { providerUserInfo: providerUserInfo } = await $8fd3c2447d7c53c3$var$deleteLinkedAccounts(userInternal.auth, {
        idToken: await userInternal.getIdToken(),
        deleteProvider: [
            providerId
        ]
    });
    const providersLeft = $8fd3c2447d7c53c3$var$providerDataAsNames(providerUserInfo || []);
    userInternal.providerData = userInternal.providerData.filter((pd)=>providersLeft.has(pd.providerId));
    if (!providersLeft.has("phone" /* PHONE */ )) userInternal.phoneNumber = null;
    await userInternal.auth._persistUserIfCurrent(userInternal);
    return userInternal;
}
async function $8fd3c2447d7c53c3$var$_link$1(user, credential, bypassAuthState = false) {
    const response = await $8fd3c2447d7c53c3$var$_logoutIfInvalidated(user, credential._linkToIdToken(user.auth, await user.getIdToken()), bypassAuthState);
    return $8fd3c2447d7c53c3$var$UserCredentialImpl._forOperation(user, "link" /* LINK */ , response);
}
async function $8fd3c2447d7c53c3$var$_assertLinkedStatus(expected, user, provider) {
    await $8fd3c2447d7c53c3$var$_reloadWithoutSaving(user);
    const providerIds = $8fd3c2447d7c53c3$var$providerDataAsNames(user.providerData);
    const code = expected === false ? "provider-already-linked" /* PROVIDER_ALREADY_LINKED */  : "no-such-provider" /* NO_SUCH_PROVIDER */ ;
    $8fd3c2447d7c53c3$export$9fa96a7d116ea3ce(providerIds.has(provider) === expected, user.auth, code);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $8fd3c2447d7c53c3$var$_reauthenticate(user, credential, bypassAuthState = false) {
    const { auth: auth } = user;
    const operationType = "reauthenticate" /* REAUTHENTICATE */ ;
    try {
        const response = await $8fd3c2447d7c53c3$var$_logoutIfInvalidated(user, $8fd3c2447d7c53c3$var$_processCredentialSavingMfaContextIfNecessary(auth, operationType, credential, user), bypassAuthState);
        $8fd3c2447d7c53c3$export$9fa96a7d116ea3ce(response.idToken, auth, "internal-error" /* INTERNAL_ERROR */ );
        const parsed = $8fd3c2447d7c53c3$var$_parseToken(response.idToken);
        $8fd3c2447d7c53c3$export$9fa96a7d116ea3ce(parsed, auth, "internal-error" /* INTERNAL_ERROR */ );
        const { sub: localId } = parsed;
        $8fd3c2447d7c53c3$export$9fa96a7d116ea3ce(user.uid === localId, auth, "user-mismatch" /* USER_MISMATCH */ );
        return $8fd3c2447d7c53c3$var$UserCredentialImpl._forOperation(user, operationType, response);
    } catch (e) {
        // Convert user deleted error into user mismatch
        if ((e === null || e === void 0 ? void 0 : e.code) === `auth/${"user-not-found" /* USER_DELETED */ }`) $8fd3c2447d7c53c3$export$493d36ec626b6698(auth, "user-mismatch" /* USER_MISMATCH */ );
        throw e;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $8fd3c2447d7c53c3$var$_signInWithCredential(auth, credential, bypassAuthState = false) {
    const operationType = "signIn" /* SIGN_IN */ ;
    const response = await $8fd3c2447d7c53c3$var$_processCredentialSavingMfaContextIfNecessary(auth, operationType, credential);
    const userCredential = await $8fd3c2447d7c53c3$var$UserCredentialImpl._fromIdTokenResponse(auth, operationType, response);
    if (!bypassAuthState) await auth._updateCurrentUser(userCredential.user);
    return userCredential;
}
/**
 * Asynchronously signs in with the given credentials.
 *
 * @remarks
 * An {@link AuthProvider} can be used to generate the credential.
 *
 * @param auth - The {@link Auth} instance.
 * @param credential - The auth credential.
 *
 * @public
 */ async function $8fd3c2447d7c53c3$export$8743009a87fcb00f(auth, credential) {
    return $8fd3c2447d7c53c3$var$_signInWithCredential($8fd3c2447d7c53c3$export$158acd800e1ef08b(auth), credential);
}
/**
 * Links the user account with the given credentials.
 *
 * @remarks
 * An {@link AuthProvider} can be used to generate the credential.
 *
 * @param user - The user.
 * @param credential - The auth credential.
 *
 * @public
 */ async function $8fd3c2447d7c53c3$export$dc98b0b04f4c7758(user, credential) {
    const userInternal = (0, $6vM9o.getModularInstance)(user);
    await $8fd3c2447d7c53c3$var$_assertLinkedStatus(false, userInternal, credential.providerId);
    return $8fd3c2447d7c53c3$var$_link$1(userInternal, credential);
}
/**
 * Re-authenticates a user using a fresh credential.
 *
 * @remarks
 * Use before operations such as {@link updatePassword} that require tokens from recent sign-in
 * attempts. This method can be used to recover from a `CREDENTIAL_TOO_OLD_LOGIN_AGAIN` error.
 *
 * @param user - The user.
 * @param credential - The auth credential.
 *
 * @public
 */ async function $8fd3c2447d7c53c3$export$71511d61b312f219(user, credential) {
    return $8fd3c2447d7c53c3$var$_reauthenticate((0, $6vM9o.getModularInstance)(user), credential);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $8fd3c2447d7c53c3$var$signInWithCustomToken$1(auth, request) {
    return $8fd3c2447d7c53c3$var$_performSignInRequest(auth, "POST" /* POST */ , "/v1/accounts:signInWithCustomToken" /* SIGN_IN_WITH_CUSTOM_TOKEN */ , $8fd3c2447d7c53c3$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Asynchronously signs in using a custom token.
 *
 * @remarks
 * Custom tokens are used to integrate Firebase Auth with existing auth systems, and must
 * be generated by an auth backend using the
 * {@link https://firebase.google.com/docs/reference/admin/node/admin.auth.Auth#createcustomtoken | createCustomToken}
 * method in the {@link https://firebase.google.com/docs/auth/admin | Admin SDK} .
 *
 * Fails with an error if the token is invalid, expired, or not accepted by the Firebase Auth service.
 *
 * @param auth - The {@link Auth} instance.
 * @param customToken - The custom token to sign in with.
 *
 * @public
 */ async function $8fd3c2447d7c53c3$export$3d8c2f653ac9d0b9(auth, customToken) {
    const authInternal = $8fd3c2447d7c53c3$export$158acd800e1ef08b(auth);
    const response = await $8fd3c2447d7c53c3$var$signInWithCustomToken$1(authInternal, {
        token: customToken,
        returnSecureToken: true
    });
    const cred = await $8fd3c2447d7c53c3$var$UserCredentialImpl._fromIdTokenResponse(authInternal, "signIn" /* SIGN_IN */ , response);
    await authInternal._updateCurrentUser(cred.user);
    return cred;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $8fd3c2447d7c53c3$var$MultiFactorInfoImpl {
    static _fromServerResponse(auth, enrollment) {
        if ("phoneInfo" in enrollment) return $8fd3c2447d7c53c3$var$PhoneMultiFactorInfoImpl._fromServerResponse(auth, enrollment);
        return $8fd3c2447d7c53c3$export$493d36ec626b6698(auth, "internal-error" /* INTERNAL_ERROR */ );
    }
    constructor(factorId, response){
        this.factorId = factorId;
        this.uid = response.mfaEnrollmentId;
        this.enrollmentTime = new Date(response.enrolledAt).toUTCString();
        this.displayName = response.displayName;
    }
}
class $8fd3c2447d7c53c3$var$PhoneMultiFactorInfoImpl extends $8fd3c2447d7c53c3$var$MultiFactorInfoImpl {
    static _fromServerResponse(_auth, enrollment) {
        return new $8fd3c2447d7c53c3$var$PhoneMultiFactorInfoImpl(enrollment);
    }
    constructor(response){
        super("phone" /* PHONE */ , response);
        this.phoneNumber = response.phoneInfo;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $8fd3c2447d7c53c3$var$_setActionCodeSettingsOnRequest(auth, request, actionCodeSettings) {
    var _a;
    $8fd3c2447d7c53c3$export$9fa96a7d116ea3ce(((_a = actionCodeSettings.url) === null || _a === void 0 ? void 0 : _a.length) > 0, auth, "invalid-continue-uri" /* INVALID_CONTINUE_URI */ );
    $8fd3c2447d7c53c3$export$9fa96a7d116ea3ce(typeof actionCodeSettings.dynamicLinkDomain === "undefined" || actionCodeSettings.dynamicLinkDomain.length > 0, auth, "invalid-dynamic-link-domain" /* INVALID_DYNAMIC_LINK_DOMAIN */ );
    request.continueUrl = actionCodeSettings.url;
    request.dynamicLinkDomain = actionCodeSettings.dynamicLinkDomain;
    request.canHandleCodeInApp = actionCodeSettings.handleCodeInApp;
    if (actionCodeSettings.iOS) {
        $8fd3c2447d7c53c3$export$9fa96a7d116ea3ce(actionCodeSettings.iOS.bundleId.length > 0, auth, "missing-ios-bundle-id" /* MISSING_IOS_BUNDLE_ID */ );
        request.iOSBundleId = actionCodeSettings.iOS.bundleId;
    }
    if (actionCodeSettings.android) {
        $8fd3c2447d7c53c3$export$9fa96a7d116ea3ce(actionCodeSettings.android.packageName.length > 0, auth, "missing-android-pkg-name" /* MISSING_ANDROID_PACKAGE_NAME */ );
        request.androidInstallApp = actionCodeSettings.android.installApp;
        request.androidMinimumVersionCode = actionCodeSettings.android.minimumVersion;
        request.androidPackageName = actionCodeSettings.android.packageName;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Sends a password reset email to the given email address.
 *
 * @remarks
 * To complete the password reset, call {@link confirmPasswordReset} with the code supplied in
 * the email sent to the user, along with the new password specified by the user.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendPasswordResetEmail(auth, 'user@example.com', actionCodeSettings);
 * // Obtain code from user.
 * await confirmPasswordReset('user@example.com', code);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */ async function $8fd3c2447d7c53c3$export$34aec0b863436764(auth, email, actionCodeSettings) {
    const authModular = (0, $6vM9o.getModularInstance)(auth);
    const request = {
        requestType: "PASSWORD_RESET" /* PASSWORD_RESET */ ,
        email: email
    };
    if (actionCodeSettings) $8fd3c2447d7c53c3$var$_setActionCodeSettingsOnRequest(authModular, request, actionCodeSettings);
    await $8fd3c2447d7c53c3$var$sendPasswordResetEmail$1(authModular, request);
}
/**
 * Completes the password reset process, given a confirmation code and new password.
 *
 * @param auth - The {@link Auth} instance.
 * @param oobCode - A confirmation code sent to the user.
 * @param newPassword - The new password.
 *
 * @public
 */ async function $8fd3c2447d7c53c3$export$3c2fa207a37baaea(auth, oobCode, newPassword) {
    await $8fd3c2447d7c53c3$var$resetPassword((0, $6vM9o.getModularInstance)(auth), {
        oobCode: oobCode,
        newPassword: newPassword
    });
// Do not return the email.
}
/**
 * Applies a verification code sent to the user by email or other out-of-band mechanism.
 *
 * @param auth - The {@link Auth} instance.
 * @param oobCode - A verification code sent to the user.
 *
 * @public
 */ async function $8fd3c2447d7c53c3$export$ce26c07117d59d6a(auth, oobCode) {
    await $8fd3c2447d7c53c3$var$applyActionCode$1((0, $6vM9o.getModularInstance)(auth), {
        oobCode: oobCode
    });
}
/**
 * Checks a verification code sent to the user by email or other out-of-band mechanism.
 *
 * @returns metadata about the code.
 *
 * @param auth - The {@link Auth} instance.
 * @param oobCode - A verification code sent to the user.
 *
 * @public
 */ async function $8fd3c2447d7c53c3$export$6559d589eb85fbb6(auth, oobCode) {
    const authModular = (0, $6vM9o.getModularInstance)(auth);
    const response = await $8fd3c2447d7c53c3$var$resetPassword(authModular, {
        oobCode: oobCode
    });
    // Email could be empty only if the request type is EMAIL_SIGNIN or
    // VERIFY_AND_CHANGE_EMAIL.
    // New email should not be empty if the request type is
    // VERIFY_AND_CHANGE_EMAIL.
    // Multi-factor info could not be empty if the request type is
    // REVERT_SECOND_FACTOR_ADDITION.
    const operation = response.requestType;
    $8fd3c2447d7c53c3$export$9fa96a7d116ea3ce(operation, authModular, "internal-error" /* INTERNAL_ERROR */ );
    switch(operation){
        case "EMAIL_SIGNIN" /* EMAIL_SIGNIN */ :
            break;
        case "VERIFY_AND_CHANGE_EMAIL" /* VERIFY_AND_CHANGE_EMAIL */ :
            $8fd3c2447d7c53c3$export$9fa96a7d116ea3ce(response.newEmail, authModular, "internal-error" /* INTERNAL_ERROR */ );
            break;
        case "REVERT_SECOND_FACTOR_ADDITION" /* REVERT_SECOND_FACTOR_ADDITION */ :
            $8fd3c2447d7c53c3$export$9fa96a7d116ea3ce(response.mfaInfo, authModular, "internal-error" /* INTERNAL_ERROR */ );
        // fall through
        default:
            $8fd3c2447d7c53c3$export$9fa96a7d116ea3ce(response.email, authModular, "internal-error" /* INTERNAL_ERROR */ );
    }
    // The multi-factor info for revert second factor addition
    let multiFactorInfo = null;
    if (response.mfaInfo) multiFactorInfo = $8fd3c2447d7c53c3$var$MultiFactorInfoImpl._fromServerResponse($8fd3c2447d7c53c3$export$158acd800e1ef08b(authModular), response.mfaInfo);
    return {
        data: {
            email: (response.requestType === "VERIFY_AND_CHANGE_EMAIL" /* VERIFY_AND_CHANGE_EMAIL */  ? response.newEmail : response.email) || null,
            previousEmail: (response.requestType === "VERIFY_AND_CHANGE_EMAIL" /* VERIFY_AND_CHANGE_EMAIL */  ? response.email : response.newEmail) || null,
            multiFactorInfo: multiFactorInfo
        },
        operation: operation
    };
}
/**
 * Checks a password reset code sent to the user by email or other out-of-band mechanism.
 *
 * @returns the user's email address if valid.
 *
 * @param auth - The {@link Auth} instance.
 * @param code - A verification code sent to the user.
 *
 * @public
 */ async function $8fd3c2447d7c53c3$export$efca4cbe5dd06740(auth, code) {
    const { data: data } = await $8fd3c2447d7c53c3$export$6559d589eb85fbb6((0, $6vM9o.getModularInstance)(auth), code);
    // Email should always be present since a code was sent to it
    return data.email;
}
/**
 * Creates a new user account associated with the specified email address and password.
 *
 * @remarks
 * On successful creation of the user account, this user will also be signed in to your application.
 *
 * User account creation can fail if the account already exists or the password is invalid.
 *
 * Note: The email address acts as a unique identifier for the user and enables an email-based
 * password reset. This function will create a new user account and set the initial user password.
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param password - The user's chosen password.
 *
 * @public
 */ async function $8fd3c2447d7c53c3$export$a8550f7dbe79f93a(auth, email, password) {
    const authInternal = $8fd3c2447d7c53c3$export$158acd800e1ef08b(auth);
    const response = await $8fd3c2447d7c53c3$var$signUp(authInternal, {
        returnSecureToken: true,
        email: email,
        password: password
    });
    const userCredential = await $8fd3c2447d7c53c3$var$UserCredentialImpl._fromIdTokenResponse(authInternal, "signIn" /* SIGN_IN */ , response);
    await authInternal._updateCurrentUser(userCredential.user);
    return userCredential;
}
/**
 * Asynchronously signs in using an email and password.
 *
 * @remarks
 * Fails with an error if the email address and password do not match.
 *
 * Note: The user's password is NOT the password used to access the user's email account. The
 * email address serves as a unique identifier for the user, and the password is used to access
 * the user's account in your Firebase project. See also: {@link createUserWithEmailAndPassword}.
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The users email address.
 * @param password - The users password.
 *
 * @public
 */ function $8fd3c2447d7c53c3$export$2e2af4578d910ddf(auth, email, password) {
    return $8fd3c2447d7c53c3$export$8743009a87fcb00f((0, $6vM9o.getModularInstance)(auth), $8fd3c2447d7c53c3$export$3a1a48c8f6ef640e.credential(email, password));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Sends a sign-in email link to the user with the specified email.
 *
 * @remarks
 * The sign-in operation has to always be completed in the app unlike other out of band email
 * actions (password reset and email verifications). This is because, at the end of the flow,
 * the user is expected to be signed in and their Auth state persisted within the app.
 *
 * To complete sign in with the email link, call {@link signInWithEmailLink} with the email
 * address and the email link supplied in the email sent to the user.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendSignInLinkToEmail(auth, 'user@example.com', actionCodeSettings);
 * // Obtain emailLink from the user.
 * if(isSignInWithEmailLink(auth, emailLink)) {
 *   await signInWithEmailLink(auth, 'user@example.com', emailLink);
 * }
 * ```
 *
 * @param authInternal - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */ async function $8fd3c2447d7c53c3$export$a93c5207d687da10(auth, email, actionCodeSettings) {
    const authModular = (0, $6vM9o.getModularInstance)(auth);
    const request = {
        requestType: "EMAIL_SIGNIN" /* EMAIL_SIGNIN */ ,
        email: email
    };
    $8fd3c2447d7c53c3$export$9fa96a7d116ea3ce(actionCodeSettings.handleCodeInApp, authModular, "argument-error" /* ARGUMENT_ERROR */ );
    if (actionCodeSettings) $8fd3c2447d7c53c3$var$_setActionCodeSettingsOnRequest(authModular, request, actionCodeSettings);
    await $8fd3c2447d7c53c3$var$sendSignInLinkToEmail$1(authModular, request);
}
/**
 * Checks if an incoming link is a sign-in with email link suitable for {@link signInWithEmailLink}.
 *
 * @param auth - The {@link Auth} instance.
 * @param emailLink - The link sent to the user's email address.
 *
 * @public
 */ function $8fd3c2447d7c53c3$export$c3950d9923825c02(auth, emailLink) {
    const actionCodeUrl = $8fd3c2447d7c53c3$export$4c3d22f3d993c33f.parseLink(emailLink);
    return (actionCodeUrl === null || actionCodeUrl === void 0 ? void 0 : actionCodeUrl.operation) === "EMAIL_SIGNIN" /* EMAIL_SIGNIN */ ;
}
/**
 * Asynchronously signs in using an email and sign-in email link.
 *
 * @remarks
 * If no link is passed, the link is inferred from the current URL.
 *
 * Fails with an error if the email address is invalid or OTP in email link expires.
 *
 * Note: Confirm the link is a sign-in email link before calling this method firebase.auth.Auth.isSignInWithEmailLink.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendSignInLinkToEmail(auth, 'user@example.com', actionCodeSettings);
 * // Obtain emailLink from the user.
 * if(isSignInWithEmailLink(auth, emailLink)) {
 *   await signInWithEmailLink(auth, 'user@example.com', emailLink);
 * }
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param emailLink - The link sent to the user's email address.
 *
 * @public
 */ async function $8fd3c2447d7c53c3$export$a9c996f45e5784d0(auth, email, emailLink) {
    const authModular = (0, $6vM9o.getModularInstance)(auth);
    const credential = $8fd3c2447d7c53c3$export$3a1a48c8f6ef640e.credentialWithLink(email, emailLink || $8fd3c2447d7c53c3$var$_getCurrentUrl());
    // Check if the tenant ID in the email link matches the tenant ID on Auth
    // instance.
    $8fd3c2447d7c53c3$export$9fa96a7d116ea3ce(credential._tenantId === (authModular.tenantId || null), authModular, "tenant-id-mismatch" /* TENANT_ID_MISMATCH */ );
    return $8fd3c2447d7c53c3$export$8743009a87fcb00f(authModular, credential);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $8fd3c2447d7c53c3$var$createAuthUri(auth, request) {
    return $8fd3c2447d7c53c3$var$_performApiRequest(auth, "POST" /* POST */ , "/v1/accounts:createAuthUri" /* CREATE_AUTH_URI */ , $8fd3c2447d7c53c3$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Gets the list of possible sign in methods for the given email address.
 *
 * @remarks
 * This is useful to differentiate methods of sign-in for the same provider, eg.
 * {@link EmailAuthProvider} which has 2 methods of sign-in,
 * {@link SignInMethod}.EMAIL_PASSWORD and
 * {@link SignInMethod}.EMAIL_LINK.
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 *
 * @public
 */ async function $8fd3c2447d7c53c3$export$7910e0436ed8d1de(auth, email) {
    // createAuthUri returns an error if continue URI is not http or https.
    // For environments like Cordova, Chrome extensions, native frameworks, file
    // systems, etc, use http://localhost as continue URL.
    const continueUri = $8fd3c2447d7c53c3$var$_isHttpOrHttps() ? $8fd3c2447d7c53c3$var$_getCurrentUrl() : "http://localhost";
    const request = {
        identifier: email,
        continueUri: continueUri
    };
    const { signinMethods: signinMethods } = await $8fd3c2447d7c53c3$var$createAuthUri((0, $6vM9o.getModularInstance)(auth), request);
    return signinMethods || [];
}
/**
 * Sends a verification email to a user.
 *
 * @remarks
 * The verification process is completed by calling {@link applyActionCode}.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendEmailVerification(user, actionCodeSettings);
 * // Obtain code from the user.
 * await applyActionCode(auth, code);
 * ```
 *
 * @param user - The user.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */ async function $8fd3c2447d7c53c3$export$555508cbc6add439(user, actionCodeSettings) {
    const userInternal = (0, $6vM9o.getModularInstance)(user);
    const idToken = await user.getIdToken();
    const request = {
        requestType: "VERIFY_EMAIL" /* VERIFY_EMAIL */ ,
        idToken: idToken
    };
    if (actionCodeSettings) $8fd3c2447d7c53c3$var$_setActionCodeSettingsOnRequest(userInternal.auth, request, actionCodeSettings);
    const { email: email } = await $8fd3c2447d7c53c3$var$sendEmailVerification$1(userInternal.auth, request);
    if (email !== user.email) await user.reload();
}
/**
 * Sends a verification email to a new email address.
 *
 * @remarks
 * The user's email will be updated to the new one after being verified.
 *
 * If you have a custom email action handler, you can complete the verification process by calling
 * {@link applyActionCode}.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await verifyBeforeUpdateEmail(user, 'newemail@example.com', actionCodeSettings);
 * // Obtain code from the user.
 * await applyActionCode(auth, code);
 * ```
 *
 * @param user - The user.
 * @param newEmail - The new email address to be verified before update.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */ async function $8fd3c2447d7c53c3$export$2219238a014317b0(user, newEmail, actionCodeSettings) {
    const userInternal = (0, $6vM9o.getModularInstance)(user);
    const idToken = await user.getIdToken();
    const request = {
        requestType: "VERIFY_AND_CHANGE_EMAIL" /* VERIFY_AND_CHANGE_EMAIL */ ,
        idToken: idToken,
        newEmail: newEmail
    };
    if (actionCodeSettings) $8fd3c2447d7c53c3$var$_setActionCodeSettingsOnRequest(userInternal.auth, request, actionCodeSettings);
    const { email: email } = await $8fd3c2447d7c53c3$var$verifyAndChangeEmail(userInternal.auth, request);
    if (email !== user.email) // If the local copy of the email on user is outdated, reload the
    // user.
    await user.reload();
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $8fd3c2447d7c53c3$var$updateProfile$1(auth, request) {
    return $8fd3c2447d7c53c3$var$_performApiRequest(auth, "POST" /* POST */ , "/v1/accounts:update" /* SET_ACCOUNT_INFO */ , request);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Updates a user's profile data.
 *
 * @param user - The user.
 * @param profile - The profile's `displayName` and `photoURL` to update.
 *
 * @public
 */ async function $8fd3c2447d7c53c3$export$c9170ad7d4cd7e57(user, { displayName: displayName, photoURL: photoUrl }) {
    if (displayName === undefined && photoUrl === undefined) return;
    const userInternal = (0, $6vM9o.getModularInstance)(user);
    const idToken = await userInternal.getIdToken();
    const profileRequest = {
        idToken: idToken,
        displayName: displayName,
        photoUrl: photoUrl,
        returnSecureToken: true
    };
    const response = await $8fd3c2447d7c53c3$var$_logoutIfInvalidated(userInternal, $8fd3c2447d7c53c3$var$updateProfile$1(userInternal.auth, profileRequest));
    userInternal.displayName = response.displayName || null;
    userInternal.photoURL = response.photoUrl || null;
    // Update the password provider as well
    const passwordProvider = userInternal.providerData.find(({ providerId: providerId })=>providerId === "password" /* PASSWORD */ );
    if (passwordProvider) {
        passwordProvider.displayName = userInternal.displayName;
        passwordProvider.photoURL = userInternal.photoURL;
    }
    await userInternal._updateTokensIfNecessary(response);
}
/**
 * Updates the user's email address.
 *
 * @remarks
 * An email will be sent to the original email address (if it was set) that allows to revoke the
 * email address change, in order to protect them from account hijacking.
 *
 * Important: this is a security sensitive operation that requires the user to have recently signed
 * in. If this requirement isn't met, ask the user to authenticate again and then call
 * {@link reauthenticateWithCredential}.
 *
 * @param user - The user.
 * @param newEmail - The new email address.
 *
 * @public
 */ function $8fd3c2447d7c53c3$export$ee7c8ad385a60b7b(user, newEmail) {
    return $8fd3c2447d7c53c3$var$updateEmailOrPassword((0, $6vM9o.getModularInstance)(user), newEmail, null);
}
/**
 * Updates the user's password.
 *
 * @remarks
 * Important: this is a security sensitive operation that requires the user to have recently signed
 * in. If this requirement isn't met, ask the user to authenticate again and then call
 * {@link reauthenticateWithCredential}.
 *
 * @param user - The user.
 * @param newPassword - The new password.
 *
 * @public
 */ function $8fd3c2447d7c53c3$export$995eb9fca571757(user, newPassword) {
    return $8fd3c2447d7c53c3$var$updateEmailOrPassword((0, $6vM9o.getModularInstance)(user), null, newPassword);
}
async function $8fd3c2447d7c53c3$var$updateEmailOrPassword(user, email, password) {
    const { auth: auth } = user;
    const idToken = await user.getIdToken();
    const request = {
        idToken: idToken,
        returnSecureToken: true
    };
    if (email) request.email = email;
    if (password) request.password = password;
    const response = await $8fd3c2447d7c53c3$var$_logoutIfInvalidated(user, $8fd3c2447d7c53c3$var$updateEmailPassword(auth, request));
    await user._updateTokensIfNecessary(response, /* reload */ true);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Parse the `AdditionalUserInfo` from the ID token response.
 *
 */ function $8fd3c2447d7c53c3$var$_fromIdTokenResponse(idTokenResponse) {
    var _a, _b;
    if (!idTokenResponse) return null;
    const { providerId: providerId } = idTokenResponse;
    const profile = idTokenResponse.rawUserInfo ? JSON.parse(idTokenResponse.rawUserInfo) : {};
    const isNewUser = idTokenResponse.isNewUser || idTokenResponse.kind === "identitytoolkit#SignupNewUserResponse" /* SignupNewUser */ ;
    if (!providerId && (idTokenResponse === null || idTokenResponse === void 0 ? void 0 : idTokenResponse.idToken)) {
        const signInProvider = (_b = (_a = $8fd3c2447d7c53c3$var$_parseToken(idTokenResponse.idToken)) === null || _a === void 0 ? void 0 : _a.firebase) === null || _b === void 0 ? void 0 : _b["sign_in_provider"];
        if (signInProvider) {
            const filteredProviderId = signInProvider !== "anonymous" /* ANONYMOUS */  && signInProvider !== "custom" /* CUSTOM */  ? signInProvider : null;
            // Uses generic class in accordance with the legacy SDK.
            return new $8fd3c2447d7c53c3$var$GenericAdditionalUserInfo(isNewUser, filteredProviderId);
        }
    }
    if (!providerId) return null;
    switch(providerId){
        case "facebook.com" /* FACEBOOK */ :
            return new $8fd3c2447d7c53c3$var$FacebookAdditionalUserInfo(isNewUser, profile);
        case "github.com" /* GITHUB */ :
            return new $8fd3c2447d7c53c3$var$GithubAdditionalUserInfo(isNewUser, profile);
        case "google.com" /* GOOGLE */ :
            return new $8fd3c2447d7c53c3$var$GoogleAdditionalUserInfo(isNewUser, profile);
        case "twitter.com" /* TWITTER */ :
            return new $8fd3c2447d7c53c3$var$TwitterAdditionalUserInfo(isNewUser, profile, idTokenResponse.screenName || null);
        case "custom" /* CUSTOM */ :
        case "anonymous" /* ANONYMOUS */ :
            return new $8fd3c2447d7c53c3$var$GenericAdditionalUserInfo(isNewUser, null);
        default:
            return new $8fd3c2447d7c53c3$var$GenericAdditionalUserInfo(isNewUser, providerId, profile);
    }
}
class $8fd3c2447d7c53c3$var$GenericAdditionalUserInfo {
    constructor(isNewUser, providerId, profile = {}){
        this.isNewUser = isNewUser;
        this.providerId = providerId;
        this.profile = profile;
    }
}
class $8fd3c2447d7c53c3$var$FederatedAdditionalUserInfoWithUsername extends $8fd3c2447d7c53c3$var$GenericAdditionalUserInfo {
    constructor(isNewUser, providerId, profile, username){
        super(isNewUser, providerId, profile);
        this.username = username;
    }
}
class $8fd3c2447d7c53c3$var$FacebookAdditionalUserInfo extends $8fd3c2447d7c53c3$var$GenericAdditionalUserInfo {
    constructor(isNewUser, profile){
        super(isNewUser, "facebook.com" /* FACEBOOK */ , profile);
    }
}
class $8fd3c2447d7c53c3$var$GithubAdditionalUserInfo extends $8fd3c2447d7c53c3$var$FederatedAdditionalUserInfoWithUsername {
    constructor(isNewUser, profile){
        super(isNewUser, "github.com" /* GITHUB */ , profile, typeof (profile === null || profile === void 0 ? void 0 : profile.login) === "string" ? profile === null || profile === void 0 ? void 0 : profile.login : null);
    }
}
class $8fd3c2447d7c53c3$var$GoogleAdditionalUserInfo extends $8fd3c2447d7c53c3$var$GenericAdditionalUserInfo {
    constructor(isNewUser, profile){
        super(isNewUser, "google.com" /* GOOGLE */ , profile);
    }
}
class $8fd3c2447d7c53c3$var$TwitterAdditionalUserInfo extends $8fd3c2447d7c53c3$var$FederatedAdditionalUserInfoWithUsername {
    constructor(isNewUser, profile, screenName){
        super(isNewUser, "twitter.com" /* TWITTER */ , profile, screenName);
    }
}
/**
 * Extracts provider specific {@link AdditionalUserInfo} for the given credential.
 *
 * @param userCredential - The user credential.
 *
 * @public
 */ function $8fd3c2447d7c53c3$export$ab83b03e4111b1d0(userCredential) {
    const { user: user, _tokenResponse: _tokenResponse } = userCredential;
    if (user.isAnonymous && !_tokenResponse) // Handle the special case where signInAnonymously() gets called twice.
    // No network call is made so there's nothing to actually fill this in
    return {
        providerId: null,
        isNewUser: false,
        profile: null
    };
    return $8fd3c2447d7c53c3$var$_fromIdTokenResponse(_tokenResponse);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Non-optional auth methods.
/**
 * Changes the type of persistence on the {@link Auth} instance for the currently saved
 * `Auth` session and applies this type of persistence for future sign-in requests, including
 * sign-in with redirect requests.
 *
 * @remarks
 * This makes it easy for a user signing in to specify whether their session should be
 * remembered or not. It also makes it easier to never persist the `Auth` state for applications
 * that are shared by other users or have sensitive data.
 *
 * @example
 * ```javascript
 * setPersistence(auth, browserSessionPersistence);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param persistence - The {@link Persistence} to use.
 * @returns A `Promise` that resolves once the persistence change has completed
 *
 * @public
 */ function $8fd3c2447d7c53c3$export$ffb5f4729a158638(auth, persistence) {
    return (0, $6vM9o.getModularInstance)(auth).setPersistence(persistence);
}
/**
 * Adds an observer for changes to the signed-in user's ID token.
 *
 * @remarks
 * This includes sign-in, sign-out, and token refresh events.
 *
 * @param auth - The {@link Auth} instance.
 * @param nextOrObserver - callback triggered on change.
 * @param error - Deprecated. This callback is never triggered. Errors
 * on signing in/out can be caught in promises returned from
 * sign-in/sign-out functions.
 * @param completed - Deprecated. This callback is never triggered.
 *
 * @public
 */ function $8fd3c2447d7c53c3$export$9e5f44173e64f162(auth, nextOrObserver, error, completed) {
    return (0, $6vM9o.getModularInstance)(auth).onIdTokenChanged(nextOrObserver, error, completed);
}
/**
 * Adds a blocking callback that runs before an auth state change
 * sets a new user.
 *
 * @param auth - The {@link Auth} instance.
 * @param callback - callback triggered before new user value is set.
 *   If this throws, it blocks the user from being set.
 * @param onAbort - callback triggered if a later `beforeAuthStateChanged()`
 *   callback throws, allowing you to undo any side effects.
 */ function $8fd3c2447d7c53c3$export$625550452a3fa3ec(auth, callback, onAbort) {
    return (0, $6vM9o.getModularInstance)(auth).beforeAuthStateChanged(callback, onAbort);
}
/**
 * Adds an observer for changes to the user's sign-in state.
 *
 * @remarks
 * To keep the old behavior, see {@link onIdTokenChanged}.
 *
 * @param auth - The {@link Auth} instance.
 * @param nextOrObserver - callback triggered on change.
 * @param error - Deprecated. This callback is never triggered. Errors
 * on signing in/out can be caught in promises returned from
 * sign-in/sign-out functions.
 * @param completed - Deprecated. This callback is never triggered.
 *
 * @public
 */ function $8fd3c2447d7c53c3$export$90a7f3efeed30595(auth, nextOrObserver, error, completed) {
    return (0, $6vM9o.getModularInstance)(auth).onAuthStateChanged(nextOrObserver, error, completed);
}
/**
 * Sets the current language to the default device/browser preference.
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */ function $8fd3c2447d7c53c3$export$efccba1c4a2ef57b(auth) {
    (0, $6vM9o.getModularInstance)(auth).useDeviceLanguage();
}
/**
 * Asynchronously sets the provided user as {@link Auth.currentUser} on the
 * {@link Auth} instance.
 *
 * @remarks
 * A new instance copy of the user provided will be made and set as currentUser.
 *
 * This will trigger {@link onAuthStateChanged} and {@link onIdTokenChanged} listeners
 * like other sign in methods.
 *
 * The operation fails with an error if the user to be updated belongs to a different Firebase
 * project.
 *
 * @param auth - The {@link Auth} instance.
 * @param user - The new {@link User}.
 *
 * @public
 */ function $8fd3c2447d7c53c3$export$d141bba7fdc215a3(auth, user) {
    return (0, $6vM9o.getModularInstance)(auth).updateCurrentUser(user);
}
/**
 * Signs out the current user.
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */ function $8fd3c2447d7c53c3$export$4a5767248b18ef41(auth) {
    return (0, $6vM9o.getModularInstance)(auth).signOut();
}
/**
 * Deletes and signs out the user.
 *
 * @remarks
 * Important: this is a security-sensitive operation that requires the user to have recently
 * signed in. If this requirement isn't met, ask the user to authenticate again and then call
 * {@link reauthenticateWithCredential}.
 *
 * @param user - The user.
 *
 * @public
 */ async function $8fd3c2447d7c53c3$export$df995fae86a55f06(user) {
    return (0, $6vM9o.getModularInstance)(user).delete();
}
class $8fd3c2447d7c53c3$var$MultiFactorSessionImpl {
    static _fromIdtoken(idToken) {
        return new $8fd3c2447d7c53c3$var$MultiFactorSessionImpl("enroll" /* ENROLL */ , idToken);
    }
    static _fromMfaPendingCredential(mfaPendingCredential) {
        return new $8fd3c2447d7c53c3$var$MultiFactorSessionImpl("signin" /* SIGN_IN */ , mfaPendingCredential);
    }
    toJSON() {
        const key = this.type === "enroll" /* ENROLL */  ? "idToken" : "pendingCredential";
        return {
            multiFactorSession: {
                [key]: this.credential
            }
        };
    }
    static fromJSON(obj) {
        var _a, _b;
        if (obj === null || obj === void 0 ? void 0 : obj.multiFactorSession) {
            if ((_a = obj.multiFactorSession) === null || _a === void 0 ? void 0 : _a.pendingCredential) return $8fd3c2447d7c53c3$var$MultiFactorSessionImpl._fromMfaPendingCredential(obj.multiFactorSession.pendingCredential);
            else if ((_b = obj.multiFactorSession) === null || _b === void 0 ? void 0 : _b.idToken) return $8fd3c2447d7c53c3$var$MultiFactorSessionImpl._fromIdtoken(obj.multiFactorSession.idToken);
        }
        return null;
    }
    constructor(type, credential){
        this.type = type;
        this.credential = credential;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $8fd3c2447d7c53c3$var$MultiFactorResolverImpl {
    /** @internal */ static _fromError(authExtern, error) {
        const auth = $8fd3c2447d7c53c3$export$158acd800e1ef08b(authExtern);
        const serverResponse = error.customData._serverResponse;
        const hints = (serverResponse.mfaInfo || []).map((enrollment)=>$8fd3c2447d7c53c3$var$MultiFactorInfoImpl._fromServerResponse(auth, enrollment));
        $8fd3c2447d7c53c3$export$9fa96a7d116ea3ce(serverResponse.mfaPendingCredential, auth, "internal-error" /* INTERNAL_ERROR */ );
        const session = $8fd3c2447d7c53c3$var$MultiFactorSessionImpl._fromMfaPendingCredential(serverResponse.mfaPendingCredential);
        return new $8fd3c2447d7c53c3$var$MultiFactorResolverImpl(session, hints, async (assertion)=>{
            const mfaResponse = await assertion._process(auth, session);
            // Clear out the unneeded fields from the old login response
            delete serverResponse.mfaInfo;
            delete serverResponse.mfaPendingCredential;
            // Use in the new token & refresh token in the old response
            const idTokenResponse = Object.assign(Object.assign({}, serverResponse), {
                idToken: mfaResponse.idToken,
                refreshToken: mfaResponse.refreshToken
            });
            // TODO: we should collapse this switch statement into UserCredentialImpl._forOperation and have it support the SIGN_IN case
            switch(error.operationType){
                case "signIn" /* SIGN_IN */ :
                    const userCredential = await $8fd3c2447d7c53c3$var$UserCredentialImpl._fromIdTokenResponse(auth, error.operationType, idTokenResponse);
                    await auth._updateCurrentUser(userCredential.user);
                    return userCredential;
                case "reauthenticate" /* REAUTHENTICATE */ :
                    $8fd3c2447d7c53c3$export$9fa96a7d116ea3ce(error.user, auth, "internal-error" /* INTERNAL_ERROR */ );
                    return $8fd3c2447d7c53c3$var$UserCredentialImpl._forOperation(error.user, error.operationType, idTokenResponse);
                default:
                    $8fd3c2447d7c53c3$export$493d36ec626b6698(auth, "internal-error" /* INTERNAL_ERROR */ );
            }
        });
    }
    async resolveSignIn(assertionExtern) {
        const assertion = assertionExtern;
        return this.signInResolver(assertion);
    }
    constructor(session, hints, signInResolver){
        this.session = session;
        this.hints = hints;
        this.signInResolver = signInResolver;
    }
}
/**
 * Provides a {@link MultiFactorResolver} suitable for completion of a
 * multi-factor flow.
 *
 * @param auth - The {@link Auth} instance.
 * @param error - The {@link MultiFactorError} raised during a sign-in, or
 * reauthentication operation.
 *
 * @public
 */ function $8fd3c2447d7c53c3$export$306ddfe3a8403e2(auth, error) {
    var _a;
    const authModular = (0, $6vM9o.getModularInstance)(auth);
    const errorInternal = error;
    $8fd3c2447d7c53c3$export$9fa96a7d116ea3ce(error.customData.operationType, authModular, "argument-error" /* ARGUMENT_ERROR */ );
    $8fd3c2447d7c53c3$export$9fa96a7d116ea3ce((_a = errorInternal.customData._serverResponse) === null || _a === void 0 ? void 0 : _a.mfaPendingCredential, authModular, "argument-error" /* ARGUMENT_ERROR */ );
    return $8fd3c2447d7c53c3$var$MultiFactorResolverImpl._fromError(authModular, errorInternal);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $8fd3c2447d7c53c3$var$startEnrollPhoneMfa(auth, request) {
    return $8fd3c2447d7c53c3$var$_performApiRequest(auth, "POST" /* POST */ , "/v2/accounts/mfaEnrollment:start" /* START_PHONE_MFA_ENROLLMENT */ , $8fd3c2447d7c53c3$var$_addTidIfNecessary(auth, request));
}
function $8fd3c2447d7c53c3$var$finalizeEnrollPhoneMfa(auth, request) {
    return $8fd3c2447d7c53c3$var$_performApiRequest(auth, "POST" /* POST */ , "/v2/accounts/mfaEnrollment:finalize" /* FINALIZE_PHONE_MFA_ENROLLMENT */ , $8fd3c2447d7c53c3$var$_addTidIfNecessary(auth, request));
}
function $8fd3c2447d7c53c3$var$withdrawMfa(auth, request) {
    return $8fd3c2447d7c53c3$var$_performApiRequest(auth, "POST" /* POST */ , "/v2/accounts/mfaEnrollment:withdraw" /* WITHDRAW_MFA */ , $8fd3c2447d7c53c3$var$_addTidIfNecessary(auth, request));
}
class $8fd3c2447d7c53c3$var$MultiFactorUserImpl {
    static _fromUser(user) {
        return new $8fd3c2447d7c53c3$var$MultiFactorUserImpl(user);
    }
    async getSession() {
        return $8fd3c2447d7c53c3$var$MultiFactorSessionImpl._fromIdtoken(await this.user.getIdToken());
    }
    async enroll(assertionExtern, displayName) {
        const assertion = assertionExtern;
        const session = await this.getSession();
        const finalizeMfaResponse = await $8fd3c2447d7c53c3$var$_logoutIfInvalidated(this.user, assertion._process(this.user.auth, session, displayName));
        // New tokens will be issued after enrollment of the new second factors.
        // They need to be updated on the user.
        await this.user._updateTokensIfNecessary(finalizeMfaResponse);
        // The user needs to be reloaded to get the new multi-factor information
        // from server. USER_RELOADED event will be triggered and `enrolledFactors`
        // will be updated.
        return this.user.reload();
    }
    async unenroll(infoOrUid) {
        const mfaEnrollmentId = typeof infoOrUid === "string" ? infoOrUid : infoOrUid.uid;
        const idToken = await this.user.getIdToken();
        const idTokenResponse = await $8fd3c2447d7c53c3$var$_logoutIfInvalidated(this.user, $8fd3c2447d7c53c3$var$withdrawMfa(this.user.auth, {
            idToken: idToken,
            mfaEnrollmentId: mfaEnrollmentId
        }));
        // Remove the second factor from the user's list.
        this.enrolledFactors = this.enrolledFactors.filter(({ uid: uid })=>uid !== mfaEnrollmentId);
        // Depending on whether the backend decided to revoke the user's session,
        // the tokenResponse may be empty. If the tokens were not updated (and they
        // are now invalid), reloading the user will discover this and invalidate
        // the user's state accordingly.
        await this.user._updateTokensIfNecessary(idTokenResponse);
        try {
            await this.user.reload();
        } catch (e) {
            if (e.code !== `auth/${"user-token-expired" /* TOKEN_EXPIRED */ }`) throw e;
        }
    }
    constructor(user){
        this.user = user;
        this.enrolledFactors = [];
        user._onReload((userInfo)=>{
            if (userInfo.mfaInfo) this.enrolledFactors = userInfo.mfaInfo.map((enrollment)=>$8fd3c2447d7c53c3$var$MultiFactorInfoImpl._fromServerResponse(user.auth, enrollment));
        });
    }
}
const $8fd3c2447d7c53c3$var$multiFactorUserCache = new WeakMap();
/**
 * The {@link MultiFactorUser} corresponding to the user.
 *
 * @remarks
 * This is used to access all multi-factor properties and operations related to the user.
 *
 * @param user - The user.
 *
 * @public
 */ function $8fd3c2447d7c53c3$export$7a38258bbe170828(user) {
    const userModular = (0, $6vM9o.getModularInstance)(user);
    if (!$8fd3c2447d7c53c3$var$multiFactorUserCache.has(userModular)) $8fd3c2447d7c53c3$var$multiFactorUserCache.set(userModular, $8fd3c2447d7c53c3$var$MultiFactorUserImpl._fromUser(userModular));
    return $8fd3c2447d7c53c3$var$multiFactorUserCache.get(userModular);
}
const $8fd3c2447d7c53c3$var$STORAGE_AVAILABLE_KEY = "__sak";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // There are two different browser persistence types: local and session.
// Both have the same implementation but use a different underlying storage
// object.
class $8fd3c2447d7c53c3$var$BrowserPersistenceClass {
    _isAvailable() {
        try {
            if (!this.storage) return Promise.resolve(false);
            this.storage.setItem($8fd3c2447d7c53c3$var$STORAGE_AVAILABLE_KEY, "1");
            this.storage.removeItem($8fd3c2447d7c53c3$var$STORAGE_AVAILABLE_KEY);
            return Promise.resolve(true);
        } catch (_a) {
            return Promise.resolve(false);
        }
    }
    _set(key, value) {
        this.storage.setItem(key, JSON.stringify(value));
        return Promise.resolve();
    }
    _get(key) {
        const json = this.storage.getItem(key);
        return Promise.resolve(json ? JSON.parse(json) : null);
    }
    _remove(key) {
        this.storage.removeItem(key);
        return Promise.resolve();
    }
    get storage() {
        return this.storageRetriever();
    }
    constructor(storageRetriever, type){
        this.storageRetriever = storageRetriever;
        this.type = type;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $8fd3c2447d7c53c3$var$_iframeCannotSyncWebStorage() {
    const ua = (0, $6vM9o.getUA)();
    return $8fd3c2447d7c53c3$var$_isSafari(ua) || $8fd3c2447d7c53c3$export$d24c54395ce0c509(ua);
}
// The polling period in case events are not supported
const $8fd3c2447d7c53c3$var$_POLLING_INTERVAL_MS$1 = 1000;
// The IE 10 localStorage cross tab synchronization delay in milliseconds
const $8fd3c2447d7c53c3$var$IE10_LOCAL_STORAGE_SYNC_DELAY = 10;
class $8fd3c2447d7c53c3$var$BrowserLocalPersistence extends $8fd3c2447d7c53c3$var$BrowserPersistenceClass {
    forAllChangedKeys(cb) {
        // Check all keys with listeners on them.
        for (const key of Object.keys(this.listeners)){
            // Get value from localStorage.
            const newValue = this.storage.getItem(key);
            const oldValue = this.localCache[key];
            // If local map value does not match, trigger listener with storage event.
            // Differentiate this simulated event from the real storage event.
            if (newValue !== oldValue) cb(key, oldValue, newValue);
        }
    }
    onStorageEvent(event, poll = false) {
        // Key would be null in some situations, like when localStorage is cleared
        if (!event.key) {
            this.forAllChangedKeys((key, _oldValue, newValue)=>{
                this.notifyListeners(key, newValue);
            });
            return;
        }
        const key = event.key;
        // Check the mechanism how this event was detected.
        // The first event will dictate the mechanism to be used.
        if (poll) // Environment detects storage changes via polling.
        // Remove storage event listener to prevent possible event duplication.
        this.detachListener();
        else // Environment detects storage changes via storage event listener.
        // Remove polling listener to prevent possible event duplication.
        this.stopPolling();
        // Safari embedded iframe. Storage event will trigger with the delta
        // changes but no changes will be applied to the iframe localStorage.
        if (this.safariLocalStorageNotSynced) {
            // Get current iframe page value.
            const storedValue = this.storage.getItem(key);
            // Value not synchronized, synchronize manually.
            if (event.newValue !== storedValue) {
                if (event.newValue !== null) // Value changed from current value.
                this.storage.setItem(key, event.newValue);
                else // Current value deleted.
                this.storage.removeItem(key);
            } else if (this.localCache[key] === event.newValue && !poll) // Already detected and processed, do not trigger listeners again.
            return;
        }
        const triggerListeners = ()=>{
            // Keep local map up to date in case storage event is triggered before
            // poll.
            const storedValue = this.storage.getItem(key);
            if (!poll && this.localCache[key] === storedValue) // Real storage event which has already been detected, do nothing.
            // This seems to trigger in some IE browsers for some reason.
            return;
            this.notifyListeners(key, storedValue);
        };
        const storedValue = this.storage.getItem(key);
        if ($8fd3c2447d7c53c3$var$_isIE10() && storedValue !== event.newValue && event.newValue !== event.oldValue) // IE 10 has this weird bug where a storage event would trigger with the
        // correct key, oldValue and newValue but localStorage.getItem(key) does
        // not yield the updated value until a few milliseconds. This ensures
        // this recovers from that situation.
        setTimeout(triggerListeners, $8fd3c2447d7c53c3$var$IE10_LOCAL_STORAGE_SYNC_DELAY);
        else triggerListeners();
    }
    notifyListeners(key, value) {
        this.localCache[key] = value;
        const listeners = this.listeners[key];
        if (listeners) for (const listener of Array.from(listeners))listener(value ? JSON.parse(value) : value);
    }
    startPolling() {
        this.stopPolling();
        this.pollTimer = setInterval(()=>{
            this.forAllChangedKeys((key, oldValue, newValue)=>{
                this.onStorageEvent(new StorageEvent("storage", {
                    key: key,
                    oldValue: oldValue,
                    newValue: newValue
                }), /* poll */ true);
            });
        }, $8fd3c2447d7c53c3$var$_POLLING_INTERVAL_MS$1);
    }
    stopPolling() {
        if (this.pollTimer) {
            clearInterval(this.pollTimer);
            this.pollTimer = null;
        }
    }
    attachListener() {
        window.addEventListener("storage", this.boundEventHandler);
    }
    detachListener() {
        window.removeEventListener("storage", this.boundEventHandler);
    }
    _addListener(key, listener) {
        if (Object.keys(this.listeners).length === 0) {
            // Whether browser can detect storage event when it had already been pushed to the background.
            // This may happen in some mobile browsers. A localStorage change in the foreground window
            // will not be detected in the background window via the storage event.
            // This was detected in iOS 7.x mobile browsers
            if (this.fallbackToPolling) this.startPolling();
            else this.attachListener();
        }
        if (!this.listeners[key]) {
            this.listeners[key] = new Set();
            // Populate the cache to avoid spuriously triggering on first poll.
            this.localCache[key] = this.storage.getItem(key);
        }
        this.listeners[key].add(listener);
    }
    _removeListener(key, listener) {
        if (this.listeners[key]) {
            this.listeners[key].delete(listener);
            if (this.listeners[key].size === 0) delete this.listeners[key];
        }
        if (Object.keys(this.listeners).length === 0) {
            this.detachListener();
            this.stopPolling();
        }
    }
    // Update local cache on base operations:
    async _set(key, value) {
        await super._set(key, value);
        this.localCache[key] = JSON.stringify(value);
    }
    async _get(key) {
        const value = await super._get(key);
        this.localCache[key] = JSON.stringify(value);
        return value;
    }
    async _remove(key) {
        await super._remove(key);
        delete this.localCache[key];
    }
    constructor(){
        super(()=>window.localStorage, "LOCAL" /* LOCAL */ );
        this.boundEventHandler = (event, poll)=>this.onStorageEvent(event, poll);
        this.listeners = {};
        this.localCache = {};
        // setTimeout return value is platform specific
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.pollTimer = null;
        // Safari or iOS browser and embedded in an iframe.
        this.safariLocalStorageNotSynced = $8fd3c2447d7c53c3$var$_iframeCannotSyncWebStorage() && $8fd3c2447d7c53c3$var$_isIframe();
        // Whether to use polling instead of depending on window events
        this.fallbackToPolling = $8fd3c2447d7c53c3$var$_isMobileBrowser();
        this._shouldAllowMigration = true;
    }
}
$8fd3c2447d7c53c3$var$BrowserLocalPersistence.type = "LOCAL";
/**
 * An implementation of {@link Persistence} of type `LOCAL` using `localStorage`
 * for the underlying storage.
 *
 * @public
 */ const $8fd3c2447d7c53c3$export$8b22cf2602fb60ce = $8fd3c2447d7c53c3$var$BrowserLocalPersistence;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $8fd3c2447d7c53c3$var$BrowserSessionPersistence extends $8fd3c2447d7c53c3$var$BrowserPersistenceClass {
    _addListener(_key, _listener) {
        // Listeners are not supported for session storage since it cannot be shared across windows
        return;
    }
    _removeListener(_key, _listener) {
        // Listeners are not supported for session storage since it cannot be shared across windows
        return;
    }
    constructor(){
        super(()=>window.sessionStorage, "SESSION" /* SESSION */ );
    }
}
$8fd3c2447d7c53c3$var$BrowserSessionPersistence.type = "SESSION";
/**
 * An implementation of {@link Persistence} of `SESSION` using `sessionStorage`
 * for the underlying storage.
 *
 * @public
 */ const $8fd3c2447d7c53c3$export$407448d2b89b1813 = $8fd3c2447d7c53c3$var$BrowserSessionPersistence;
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Shim for Promise.allSettled, note the slightly different format of `fulfilled` vs `status`.
 *
 * @param promises - Array of promises to wait on.
 */ function $8fd3c2447d7c53c3$var$_allSettled(promises) {
    return Promise.all(promises.map(async (promise)=>{
        try {
            const value = await promise;
            return {
                fulfilled: true,
                value: value
            };
        } catch (reason) {
            return {
                fulfilled: false,
                reason: reason
            };
        }
    }));
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface class for receiving messages.
 *
 */ class $8fd3c2447d7c53c3$var$Receiver {
    /**
     * Obtain an instance of a Receiver for a given event target, if none exists it will be created.
     *
     * @param eventTarget - An event target (such as window or self) through which the underlying
     * messages will be received.
     */ static _getInstance(eventTarget) {
        // The results are stored in an array since objects can't be keys for other
        // objects. In addition, setting a unique property on an event target as a
        // hash map key may not be allowed due to CORS restrictions.
        const existingInstance = this.receivers.find((receiver)=>receiver.isListeningto(eventTarget));
        if (existingInstance) return existingInstance;
        const newInstance = new $8fd3c2447d7c53c3$var$Receiver(eventTarget);
        this.receivers.push(newInstance);
        return newInstance;
    }
    isListeningto(eventTarget) {
        return this.eventTarget === eventTarget;
    }
    /**
     * Fans out a MessageEvent to the appropriate listeners.
     *
     * @remarks
     * Sends an {@link Status.ACK} upon receipt and a {@link Status.DONE} once all handlers have
     * finished processing.
     *
     * @param event - The MessageEvent.
     *
     */ async handleEvent(event) {
        const messageEvent = event;
        const { eventId: eventId, eventType: eventType, data: data } = messageEvent.data;
        const handlers = this.handlersMap[eventType];
        if (!(handlers === null || handlers === void 0 ? void 0 : handlers.size)) return;
        messageEvent.ports[0].postMessage({
            status: "ack" /* ACK */ ,
            eventId: eventId,
            eventType: eventType
        });
        const promises = Array.from(handlers).map(async (handler)=>handler(messageEvent.origin, data));
        const response = await $8fd3c2447d7c53c3$var$_allSettled(promises);
        messageEvent.ports[0].postMessage({
            status: "done" /* DONE */ ,
            eventId: eventId,
            eventType: eventType,
            response: response
        });
    }
    /**
     * Subscribe an event handler for a particular event.
     *
     * @param eventType - Event name to subscribe to.
     * @param eventHandler - The event handler which should receive the events.
     *
     */ _subscribe(eventType, eventHandler) {
        if (Object.keys(this.handlersMap).length === 0) this.eventTarget.addEventListener("message", this.boundEventHandler);
        if (!this.handlersMap[eventType]) this.handlersMap[eventType] = new Set();
        this.handlersMap[eventType].add(eventHandler);
    }
    /**
     * Unsubscribe an event handler from a particular event.
     *
     * @param eventType - Event name to unsubscribe from.
     * @param eventHandler - Optinoal event handler, if none provided, unsubscribe all handlers on this event.
     *
     */ _unsubscribe(eventType, eventHandler) {
        if (this.handlersMap[eventType] && eventHandler) this.handlersMap[eventType].delete(eventHandler);
        if (!eventHandler || this.handlersMap[eventType].size === 0) delete this.handlersMap[eventType];
        if (Object.keys(this.handlersMap).length === 0) this.eventTarget.removeEventListener("message", this.boundEventHandler);
    }
    constructor(eventTarget){
        this.eventTarget = eventTarget;
        this.handlersMap = {};
        this.boundEventHandler = this.handleEvent.bind(this);
    }
}
$8fd3c2447d7c53c3$var$Receiver.receivers = [];
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $8fd3c2447d7c53c3$export$b9a6b53f9be3734(prefix = "", digits = 10) {
    let random = "";
    for(let i = 0; i < digits; i++)random += Math.floor(Math.random() * 10);
    return prefix + random;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface for sending messages and waiting for a completion response.
 *
 */ class $8fd3c2447d7c53c3$var$Sender {
    /**
     * Unsubscribe the handler and remove it from our tracking Set.
     *
     * @param handler - The handler to unsubscribe.
     */ removeMessageHandler(handler) {
        if (handler.messageChannel) {
            handler.messageChannel.port1.removeEventListener("message", handler.onMessage);
            handler.messageChannel.port1.close();
        }
        this.handlers.delete(handler);
    }
    /**
     * Send a message to the Receiver located at {@link target}.
     *
     * @remarks
     * We'll first wait a bit for an ACK , if we get one we will wait significantly longer until the
     * receiver has had a chance to fully process the event.
     *
     * @param eventType - Type of event to send.
     * @param data - The payload of the event.
     * @param timeout - Timeout for waiting on an ACK from the receiver.
     *
     * @returns An array of settled promises from all the handlers that were listening on the receiver.
     */ async _send(eventType, data, timeout = 50 /* ACK */ ) {
        const messageChannel = typeof MessageChannel !== "undefined" ? new MessageChannel() : null;
        if (!messageChannel) throw new Error("connection_unavailable" /* CONNECTION_UNAVAILABLE */ );
        // Node timers and browser timers return fundamentally different types.
        // We don't actually care what the value is but TS won't accept unknown and
        // we can't cast properly in both environments.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let completionTimer;
        let handler;
        return new Promise((resolve, reject)=>{
            const eventId = $8fd3c2447d7c53c3$export$b9a6b53f9be3734("", 20);
            messageChannel.port1.start();
            const ackTimer = setTimeout(()=>{
                reject(new Error("unsupported_event" /* UNSUPPORTED_EVENT */ ));
            }, timeout);
            handler = {
                messageChannel: messageChannel,
                onMessage (event) {
                    const messageEvent = event;
                    if (messageEvent.data.eventId !== eventId) return;
                    switch(messageEvent.data.status){
                        case "ack" /* ACK */ :
                            // The receiver should ACK first.
                            clearTimeout(ackTimer);
                            completionTimer = setTimeout(()=>{
                                reject(new Error("timeout" /* TIMEOUT */ ));
                            }, 3000 /* COMPLETION */ );
                            break;
                        case "done" /* DONE */ :
                            // Once the receiver's handlers are finished we will get the results.
                            clearTimeout(completionTimer);
                            resolve(messageEvent.data.response);
                            break;
                        default:
                            clearTimeout(ackTimer);
                            clearTimeout(completionTimer);
                            reject(new Error("invalid_response" /* INVALID_RESPONSE */ ));
                            break;
                    }
                }
            };
            this.handlers.add(handler);
            messageChannel.port1.addEventListener("message", handler.onMessage);
            this.target.postMessage({
                eventType: eventType,
                eventId: eventId,
                data: data
            }, [
                messageChannel.port2
            ]);
        }).finally(()=>{
            if (handler) this.removeMessageHandler(handler);
        });
    }
    constructor(target){
        this.target = target;
        this.handlers = new Set();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Lazy accessor for window, since the compat layer won't tree shake this out,
 * we need to make sure not to mess with window unless we have to
 */ function $8fd3c2447d7c53c3$var$_window() {
    return window;
}
function $8fd3c2447d7c53c3$var$_setWindowLocation(url) {
    $8fd3c2447d7c53c3$var$_window().location.href = url;
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $8fd3c2447d7c53c3$var$_isWorker() {
    return typeof $8fd3c2447d7c53c3$var$_window()["WorkerGlobalScope"] !== "undefined" && typeof $8fd3c2447d7c53c3$var$_window()["importScripts"] === "function";
}
async function $8fd3c2447d7c53c3$var$_getActiveServiceWorker() {
    if (!(navigator === null || navigator === void 0 ? void 0 : navigator.serviceWorker)) return null;
    try {
        const registration = await navigator.serviceWorker.ready;
        return registration.active;
    } catch (_a) {
        return null;
    }
}
function $8fd3c2447d7c53c3$var$_getServiceWorkerController() {
    var _a;
    return ((_a = navigator === null || navigator === void 0 ? void 0 : navigator.serviceWorker) === null || _a === void 0 ? void 0 : _a.controller) || null;
}
function $8fd3c2447d7c53c3$var$_getWorkerGlobalScope() {
    return $8fd3c2447d7c53c3$var$_isWorker() ? self : null;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $8fd3c2447d7c53c3$var$DB_NAME = "firebaseLocalStorageDb";
const $8fd3c2447d7c53c3$var$DB_VERSION = 1;
const $8fd3c2447d7c53c3$var$DB_OBJECTSTORE_NAME = "firebaseLocalStorage";
const $8fd3c2447d7c53c3$var$DB_DATA_KEYPATH = "fbase_key";
/**
 * Promise wrapper for IDBRequest
 *
 * Unfortunately we can't cleanly extend Promise<T> since promises are not callable in ES6
 *
 */ class $8fd3c2447d7c53c3$var$DBPromise {
    toPromise() {
        return new Promise((resolve, reject)=>{
            this.request.addEventListener("success", ()=>{
                resolve(this.request.result);
            });
            this.request.addEventListener("error", ()=>{
                reject(this.request.error);
            });
        });
    }
    constructor(request){
        this.request = request;
    }
}
function $8fd3c2447d7c53c3$var$getObjectStore(db, isReadWrite) {
    return db.transaction([
        $8fd3c2447d7c53c3$var$DB_OBJECTSTORE_NAME
    ], isReadWrite ? "readwrite" : "readonly").objectStore($8fd3c2447d7c53c3$var$DB_OBJECTSTORE_NAME);
}
function $8fd3c2447d7c53c3$var$_deleteDatabase() {
    const request = indexedDB.deleteDatabase($8fd3c2447d7c53c3$var$DB_NAME);
    return new $8fd3c2447d7c53c3$var$DBPromise(request).toPromise();
}
function $8fd3c2447d7c53c3$var$_openDatabase() {
    const request = indexedDB.open($8fd3c2447d7c53c3$var$DB_NAME, $8fd3c2447d7c53c3$var$DB_VERSION);
    return new Promise((resolve, reject)=>{
        request.addEventListener("error", ()=>{
            reject(request.error);
        });
        request.addEventListener("upgradeneeded", ()=>{
            const db = request.result;
            try {
                db.createObjectStore($8fd3c2447d7c53c3$var$DB_OBJECTSTORE_NAME, {
                    keyPath: $8fd3c2447d7c53c3$var$DB_DATA_KEYPATH
                });
            } catch (e) {
                reject(e);
            }
        });
        request.addEventListener("success", async ()=>{
            const db = request.result;
            // Strange bug that occurs in Firefox when multiple tabs are opened at the
            // same time. The only way to recover seems to be deleting the database
            // and re-initializing it.
            // https://github.com/firebase/firebase-js-sdk/issues/634
            if (!db.objectStoreNames.contains($8fd3c2447d7c53c3$var$DB_OBJECTSTORE_NAME)) {
                // Need to close the database or else you get a `blocked` event
                db.close();
                await $8fd3c2447d7c53c3$var$_deleteDatabase();
                resolve(await $8fd3c2447d7c53c3$var$_openDatabase());
            } else resolve(db);
        });
    });
}
async function $8fd3c2447d7c53c3$var$_putObject(db, key, value) {
    const request = $8fd3c2447d7c53c3$var$getObjectStore(db, true).put({
        [$8fd3c2447d7c53c3$var$DB_DATA_KEYPATH]: key,
        value: value
    });
    return new $8fd3c2447d7c53c3$var$DBPromise(request).toPromise();
}
async function $8fd3c2447d7c53c3$var$getObject(db, key) {
    const request = $8fd3c2447d7c53c3$var$getObjectStore(db, false).get(key);
    const data = await new $8fd3c2447d7c53c3$var$DBPromise(request).toPromise();
    return data === undefined ? null : data.value;
}
function $8fd3c2447d7c53c3$var$_deleteObject(db, key) {
    const request = $8fd3c2447d7c53c3$var$getObjectStore(db, true).delete(key);
    return new $8fd3c2447d7c53c3$var$DBPromise(request).toPromise();
}
const $8fd3c2447d7c53c3$var$_POLLING_INTERVAL_MS = 800;
const $8fd3c2447d7c53c3$var$_TRANSACTION_RETRY_COUNT = 3;
class $8fd3c2447d7c53c3$var$IndexedDBLocalPersistence {
    async _openDb() {
        if (this.db) return this.db;
        this.db = await $8fd3c2447d7c53c3$var$_openDatabase();
        return this.db;
    }
    async _withRetries(op) {
        let numAttempts = 0;
        while(true)try {
            const db = await this._openDb();
            return await op(db);
        } catch (e) {
            if (numAttempts++ > $8fd3c2447d7c53c3$var$_TRANSACTION_RETRY_COUNT) throw e;
            if (this.db) {
                this.db.close();
                this.db = undefined;
            }
        // TODO: consider adding exponential backoff
        }
    }
    /**
     * IndexedDB events do not propagate from the main window to the worker context.  We rely on a
     * postMessage interface to send these events to the worker ourselves.
     */ async initializeServiceWorkerMessaging() {
        return $8fd3c2447d7c53c3$var$_isWorker() ? this.initializeReceiver() : this.initializeSender();
    }
    /**
     * As the worker we should listen to events from the main window.
     */ async initializeReceiver() {
        this.receiver = $8fd3c2447d7c53c3$var$Receiver._getInstance($8fd3c2447d7c53c3$var$_getWorkerGlobalScope());
        // Refresh from persistence if we receive a KeyChanged message.
        this.receiver._subscribe("keyChanged" /* KEY_CHANGED */ , async (_origin, data)=>{
            const keys = await this._poll();
            return {
                keyProcessed: keys.includes(data.key)
            };
        });
        // Let the sender know that we are listening so they give us more timeout.
        this.receiver._subscribe("ping" /* PING */ , async (_origin, _data)=>{
            return [
                "keyChanged" /* KEY_CHANGED */ 
            ];
        });
    }
    /**
     * As the main window, we should let the worker know when keys change (set and remove).
     *
     * @remarks
     * {@link https://developer.mozilla.org/en-US/docs/Web/API/ServiceWorkerContainer/ready | ServiceWorkerContainer.ready}
     * may not resolve.
     */ async initializeSender() {
        var _a, _b;
        // Check to see if there's an active service worker.
        this.activeServiceWorker = await $8fd3c2447d7c53c3$var$_getActiveServiceWorker();
        if (!this.activeServiceWorker) return;
        this.sender = new $8fd3c2447d7c53c3$var$Sender(this.activeServiceWorker);
        // Ping the service worker to check what events they can handle.
        const results = await this.sender._send("ping" /* PING */ , {}, 800 /* LONG_ACK */ );
        if (!results) return;
        if (((_a = results[0]) === null || _a === void 0 ? void 0 : _a.fulfilled) && ((_b = results[0]) === null || _b === void 0 ? void 0 : _b.value.includes("keyChanged" /* KEY_CHANGED */ ))) this.serviceWorkerReceiverAvailable = true;
    }
    /**
     * Let the worker know about a changed key, the exact key doesn't technically matter since the
     * worker will just trigger a full sync anyway.
     *
     * @remarks
     * For now, we only support one service worker per page.
     *
     * @param key - Storage key which changed.
     */ async notifyServiceWorker(key) {
        if (!this.sender || !this.activeServiceWorker || $8fd3c2447d7c53c3$var$_getServiceWorkerController() !== this.activeServiceWorker) return;
        try {
            await this.sender._send("keyChanged" /* KEY_CHANGED */ , {
                key: key
            }, // Use long timeout if receiver has previously responded to a ping from us.
            this.serviceWorkerReceiverAvailable ? 800 /* LONG_ACK */  : 50 /* ACK */ );
        } catch (_a) {
        // This is a best effort approach. Ignore errors.
        }
    }
    async _isAvailable() {
        try {
            if (!indexedDB) return false;
            const db = await $8fd3c2447d7c53c3$var$_openDatabase();
            await $8fd3c2447d7c53c3$var$_putObject(db, $8fd3c2447d7c53c3$var$STORAGE_AVAILABLE_KEY, "1");
            await $8fd3c2447d7c53c3$var$_deleteObject(db, $8fd3c2447d7c53c3$var$STORAGE_AVAILABLE_KEY);
            return true;
        } catch (_a) {}
        return false;
    }
    async _withPendingWrite(write) {
        this.pendingWrites++;
        try {
            await write();
        } finally{
            this.pendingWrites--;
        }
    }
    async _set(key, value) {
        return this._withPendingWrite(async ()=>{
            await this._withRetries((db)=>$8fd3c2447d7c53c3$var$_putObject(db, key, value));
            this.localCache[key] = value;
            return this.notifyServiceWorker(key);
        });
    }
    async _get(key) {
        const obj = await this._withRetries((db)=>$8fd3c2447d7c53c3$var$getObject(db, key));
        this.localCache[key] = obj;
        return obj;
    }
    async _remove(key) {
        return this._withPendingWrite(async ()=>{
            await this._withRetries((db)=>$8fd3c2447d7c53c3$var$_deleteObject(db, key));
            delete this.localCache[key];
            return this.notifyServiceWorker(key);
        });
    }
    async _poll() {
        // TODO: check if we need to fallback if getAll is not supported
        const result = await this._withRetries((db)=>{
            const getAllRequest = $8fd3c2447d7c53c3$var$getObjectStore(db, false).getAll();
            return new $8fd3c2447d7c53c3$var$DBPromise(getAllRequest).toPromise();
        });
        if (!result) return [];
        // If we have pending writes in progress abort, we'll get picked up on the next poll
        if (this.pendingWrites !== 0) return [];
        const keys = [];
        const keysInResult = new Set();
        for (const { fbase_key: key, value: value } of result){
            keysInResult.add(key);
            if (JSON.stringify(this.localCache[key]) !== JSON.stringify(value)) {
                this.notifyListeners(key, value);
                keys.push(key);
            }
        }
        for (const localKey of Object.keys(this.localCache))if (this.localCache[localKey] && !keysInResult.has(localKey)) {
            // Deleted
            this.notifyListeners(localKey, null);
            keys.push(localKey);
        }
        return keys;
    }
    notifyListeners(key, newValue) {
        this.localCache[key] = newValue;
        const listeners = this.listeners[key];
        if (listeners) for (const listener of Array.from(listeners))listener(newValue);
    }
    startPolling() {
        this.stopPolling();
        this.pollTimer = setInterval(async ()=>this._poll(), $8fd3c2447d7c53c3$var$_POLLING_INTERVAL_MS);
    }
    stopPolling() {
        if (this.pollTimer) {
            clearInterval(this.pollTimer);
            this.pollTimer = null;
        }
    }
    _addListener(key, listener) {
        if (Object.keys(this.listeners).length === 0) this.startPolling();
        if (!this.listeners[key]) {
            this.listeners[key] = new Set();
            // Populate the cache to avoid spuriously triggering on first poll.
            this._get(key); // This can happen in the background async and we can return immediately.
        }
        this.listeners[key].add(listener);
    }
    _removeListener(key, listener) {
        if (this.listeners[key]) {
            this.listeners[key].delete(listener);
            if (this.listeners[key].size === 0) delete this.listeners[key];
        }
        if (Object.keys(this.listeners).length === 0) this.stopPolling();
    }
    constructor(){
        this.type = "LOCAL" /* LOCAL */ ;
        this._shouldAllowMigration = true;
        this.listeners = {};
        this.localCache = {};
        // setTimeout return value is platform specific
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.pollTimer = null;
        this.pendingWrites = 0;
        this.receiver = null;
        this.sender = null;
        this.serviceWorkerReceiverAvailable = false;
        this.activeServiceWorker = null;
        // Fire & forget the service worker registration as it may never resolve
        this._workerInitializationPromise = this.initializeServiceWorkerMessaging().then(()=>{}, ()=>{});
    }
}
$8fd3c2447d7c53c3$var$IndexedDBLocalPersistence.type = "LOCAL";
/**
 * An implementation of {@link Persistence} of type `LOCAL` using `indexedDB`
 * for the underlying storage.
 *
 * @public
 */ const $8fd3c2447d7c53c3$export$23f2a1d2818174ef = $8fd3c2447d7c53c3$var$IndexedDBLocalPersistence;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $8fd3c2447d7c53c3$var$startSignInPhoneMfa(auth, request) {
    return $8fd3c2447d7c53c3$var$_performApiRequest(auth, "POST" /* POST */ , "/v2/accounts/mfaSignIn:start" /* START_PHONE_MFA_SIGN_IN */ , $8fd3c2447d7c53c3$var$_addTidIfNecessary(auth, request));
}
function $8fd3c2447d7c53c3$var$finalizeSignInPhoneMfa(auth, request) {
    return $8fd3c2447d7c53c3$var$_performApiRequest(auth, "POST" /* POST */ , "/v2/accounts/mfaSignIn:finalize" /* FINALIZE_PHONE_MFA_SIGN_IN */ , $8fd3c2447d7c53c3$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $8fd3c2447d7c53c3$var$getRecaptchaParams(auth) {
    return (await $8fd3c2447d7c53c3$var$_performApiRequest(auth, "GET" /* GET */ , "/v1/recaptchaParams" /* GET_RECAPTCHA_PARAM */ )).recaptchaSiteKey || "";
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $8fd3c2447d7c53c3$var$getScriptParentElement() {
    var _a, _b;
    return (_b = (_a = document.getElementsByTagName("head")) === null || _a === void 0 ? void 0 : _a[0]) !== null && _b !== void 0 ? _b : document;
}
function $8fd3c2447d7c53c3$var$_loadJS(url) {
    // TODO: consider adding timeout support & cancellation
    return new Promise((resolve, reject)=>{
        const el = document.createElement("script");
        el.setAttribute("src", url);
        el.onload = resolve;
        el.onerror = (e)=>{
            const error = $8fd3c2447d7c53c3$export$92108d983e8ee699("internal-error" /* INTERNAL_ERROR */ );
            error.customData = e;
            reject(error);
        };
        el.type = "text/javascript";
        el.charset = "UTF-8";
        $8fd3c2447d7c53c3$var$getScriptParentElement().appendChild(el);
    });
}
function $8fd3c2447d7c53c3$var$_generateCallbackName(prefix) {
    return `__${prefix}${Math.floor(Math.random() * 1000000)}`;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $8fd3c2447d7c53c3$var$_SOLVE_TIME_MS = 500;
const $8fd3c2447d7c53c3$var$_EXPIRATION_TIME_MS = 60000;
const $8fd3c2447d7c53c3$var$_WIDGET_ID_START = 1000000000000;
class $8fd3c2447d7c53c3$var$MockReCaptcha {
    render(container, parameters) {
        const id = this.counter;
        this._widgets.set(id, new $8fd3c2447d7c53c3$var$MockWidget(container, this.auth.name, parameters || {}));
        this.counter++;
        return id;
    }
    reset(optWidgetId) {
        var _a;
        const id = optWidgetId || $8fd3c2447d7c53c3$var$_WIDGET_ID_START;
        (_a = this._widgets.get(id)) === null || _a === void 0 || _a.delete();
        this._widgets.delete(id);
    }
    getResponse(optWidgetId) {
        var _a;
        const id = optWidgetId || $8fd3c2447d7c53c3$var$_WIDGET_ID_START;
        return ((_a = this._widgets.get(id)) === null || _a === void 0 ? void 0 : _a.getResponse()) || "";
    }
    async execute(optWidgetId) {
        var _a;
        const id = optWidgetId || $8fd3c2447d7c53c3$var$_WIDGET_ID_START;
        (_a = this._widgets.get(id)) === null || _a === void 0 || _a.execute();
        return "";
    }
    constructor(auth){
        this.auth = auth;
        this.counter = $8fd3c2447d7c53c3$var$_WIDGET_ID_START;
        this._widgets = new Map();
    }
}
class $8fd3c2447d7c53c3$var$MockWidget {
    getResponse() {
        this.checkIfDeleted();
        return this.responseToken;
    }
    delete() {
        this.checkIfDeleted();
        this.deleted = true;
        if (this.timerId) {
            clearTimeout(this.timerId);
            this.timerId = null;
        }
        this.container.removeEventListener("click", this.clickHandler);
    }
    execute() {
        this.checkIfDeleted();
        if (this.timerId) return;
        this.timerId = window.setTimeout(()=>{
            this.responseToken = $8fd3c2447d7c53c3$var$generateRandomAlphaNumericString(50);
            const { callback: callback, "expired-callback": expiredCallback } = this.params;
            if (callback) try {
                callback(this.responseToken);
            } catch (e) {}
            this.timerId = window.setTimeout(()=>{
                this.timerId = null;
                this.responseToken = null;
                if (expiredCallback) try {
                    expiredCallback();
                } catch (e) {}
                if (this.isVisible) this.execute();
            }, $8fd3c2447d7c53c3$var$_EXPIRATION_TIME_MS);
        }, $8fd3c2447d7c53c3$var$_SOLVE_TIME_MS);
    }
    checkIfDeleted() {
        if (this.deleted) throw new Error("reCAPTCHA mock was already deleted!");
    }
    constructor(containerOrId, appName, params){
        this.params = params;
        this.timerId = null;
        this.deleted = false;
        this.responseToken = null;
        this.clickHandler = ()=>{
            this.execute();
        };
        const container = typeof containerOrId === "string" ? document.getElementById(containerOrId) : containerOrId;
        $8fd3c2447d7c53c3$export$9fa96a7d116ea3ce(container, "argument-error" /* ARGUMENT_ERROR */ , {
            appName: appName
        });
        this.container = container;
        this.isVisible = this.params.size !== "invisible";
        if (this.isVisible) this.execute();
        else this.container.addEventListener("click", this.clickHandler);
    }
}
function $8fd3c2447d7c53c3$var$generateRandomAlphaNumericString(len) {
    const chars = [];
    const allowedChars = "1234567890abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
    for(let i = 0; i < len; i++)chars.push(allowedChars.charAt(Math.floor(Math.random() * allowedChars.length)));
    return chars.join("");
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // ReCaptcha will load using the same callback, so the callback function needs
// to be kept around
const $8fd3c2447d7c53c3$var$_JSLOAD_CALLBACK = $8fd3c2447d7c53c3$var$_generateCallbackName("rcb");
const $8fd3c2447d7c53c3$var$NETWORK_TIMEOUT_DELAY = new $8fd3c2447d7c53c3$var$Delay(30000, 60000);
const $8fd3c2447d7c53c3$var$RECAPTCHA_BASE = "https://www.google.com/recaptcha/api.js?";
/**
 * Loader for the GReCaptcha library. There should only ever be one of this.
 */ class $8fd3c2447d7c53c3$var$ReCaptchaLoaderImpl {
    load(auth, hl = "") {
        $8fd3c2447d7c53c3$export$9fa96a7d116ea3ce($8fd3c2447d7c53c3$var$isHostLanguageValid(hl), auth, "argument-error" /* ARGUMENT_ERROR */ );
        if (this.shouldResolveImmediately(hl)) return Promise.resolve($8fd3c2447d7c53c3$var$_window().grecaptcha);
        return new Promise((resolve, reject)=>{
            const networkTimeout = $8fd3c2447d7c53c3$var$_window().setTimeout(()=>{
                reject($8fd3c2447d7c53c3$export$92108d983e8ee699(auth, "network-request-failed" /* NETWORK_REQUEST_FAILED */ ));
            }, $8fd3c2447d7c53c3$var$NETWORK_TIMEOUT_DELAY.get());
            $8fd3c2447d7c53c3$var$_window()[$8fd3c2447d7c53c3$var$_JSLOAD_CALLBACK] = ()=>{
                $8fd3c2447d7c53c3$var$_window().clearTimeout(networkTimeout);
                delete $8fd3c2447d7c53c3$var$_window()[$8fd3c2447d7c53c3$var$_JSLOAD_CALLBACK];
                const recaptcha = $8fd3c2447d7c53c3$var$_window().grecaptcha;
                if (!recaptcha) {
                    reject($8fd3c2447d7c53c3$export$92108d983e8ee699(auth, "internal-error" /* INTERNAL_ERROR */ ));
                    return;
                }
                // Wrap the greptcha render function so that we know if the developer has
                // called it separately
                const render = recaptcha.render;
                recaptcha.render = (container, params)=>{
                    const widgetId = render(container, params);
                    this.counter++;
                    return widgetId;
                };
                this.hostLanguage = hl;
                resolve(recaptcha);
            };
            const url = `${$8fd3c2447d7c53c3$var$RECAPTCHA_BASE}?${(0, $6vM9o.querystring)({
                onload: $8fd3c2447d7c53c3$var$_JSLOAD_CALLBACK,
                render: "explicit",
                hl: hl
            })}`;
            $8fd3c2447d7c53c3$var$_loadJS(url).catch(()=>{
                clearTimeout(networkTimeout);
                reject($8fd3c2447d7c53c3$export$92108d983e8ee699(auth, "internal-error" /* INTERNAL_ERROR */ ));
            });
        });
    }
    clearedOneInstance() {
        this.counter--;
    }
    shouldResolveImmediately(hl) {
        // We can resolve immediately if:
        //   • grecaptcha is already defined AND (
        //     1. the requested language codes are the same OR
        //     2. there exists already a ReCaptcha on the page
        //     3. the library was already loaded by the app
        // In cases (2) and (3), we _can't_ reload as it would break the recaptchas
        // that are already in the page
        return !!$8fd3c2447d7c53c3$var$_window().grecaptcha && (hl === this.hostLanguage || this.counter > 0 || this.librarySeparatelyLoaded);
    }
    constructor(){
        this.hostLanguage = "";
        this.counter = 0;
        this.librarySeparatelyLoaded = !!$8fd3c2447d7c53c3$var$_window().grecaptcha;
    }
}
function $8fd3c2447d7c53c3$var$isHostLanguageValid(hl) {
    return hl.length <= 6 && /^\s*[a-zA-Z0-9\-]*\s*$/.test(hl);
}
class $8fd3c2447d7c53c3$var$MockReCaptchaLoaderImpl {
    async load(auth) {
        return new $8fd3c2447d7c53c3$var$MockReCaptcha(auth);
    }
    clearedOneInstance() {}
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $8fd3c2447d7c53c3$var$RECAPTCHA_VERIFIER_TYPE = "recaptcha";
const $8fd3c2447d7c53c3$var$DEFAULT_PARAMS = {
    theme: "light",
    type: "image"
};
/**
 * An {@link https://www.google.com/recaptcha/ | reCAPTCHA}-based application verifier.
 *
 * @public
 */ class $8fd3c2447d7c53c3$export$db202ddc8be9136 {
    /**
     * Waits for the user to solve the reCAPTCHA and resolves with the reCAPTCHA token.
     *
     * @returns A Promise for the reCAPTCHA token.
     */ async verify() {
        this.assertNotDestroyed();
        const id = await this.render();
        const recaptcha = this.getAssertedRecaptcha();
        const response = recaptcha.getResponse(id);
        if (response) return response;
        return new Promise((resolve)=>{
            const tokenChange = (token)=>{
                if (!token) return; // Ignore token expirations.
                this.tokenChangeListeners.delete(tokenChange);
                resolve(token);
            };
            this.tokenChangeListeners.add(tokenChange);
            if (this.isInvisible) recaptcha.execute(id);
        });
    }
    /**
     * Renders the reCAPTCHA widget on the page.
     *
     * @returns A Promise that resolves with the reCAPTCHA widget ID.
     */ render() {
        try {
            this.assertNotDestroyed();
        } catch (e) {
            // This method returns a promise. Since it's not async (we want to return the
            // _same_ promise if rendering is still occurring), the API surface should
            // reject with the error rather than just throw
            return Promise.reject(e);
        }
        if (this.renderPromise) return this.renderPromise;
        this.renderPromise = this.makeRenderPromise().catch((e)=>{
            this.renderPromise = null;
            throw e;
        });
        return this.renderPromise;
    }
    /** @internal */ _reset() {
        this.assertNotDestroyed();
        if (this.widgetId !== null) this.getAssertedRecaptcha().reset(this.widgetId);
    }
    /**
     * Clears the reCAPTCHA widget from the page and destroys the instance.
     */ clear() {
        this.assertNotDestroyed();
        this.destroyed = true;
        this._recaptchaLoader.clearedOneInstance();
        if (!this.isInvisible) this.container.childNodes.forEach((node)=>{
            this.container.removeChild(node);
        });
    }
    validateStartingState() {
        $8fd3c2447d7c53c3$export$9fa96a7d116ea3ce(!this.parameters.sitekey, this.auth, "argument-error" /* ARGUMENT_ERROR */ );
        $8fd3c2447d7c53c3$export$9fa96a7d116ea3ce(this.isInvisible || !this.container.hasChildNodes(), this.auth, "argument-error" /* ARGUMENT_ERROR */ );
        $8fd3c2447d7c53c3$export$9fa96a7d116ea3ce(typeof document !== "undefined", this.auth, "operation-not-supported-in-this-environment" /* OPERATION_NOT_SUPPORTED */ );
    }
    makeTokenCallback(existing) {
        return (token)=>{
            this.tokenChangeListeners.forEach((listener)=>listener(token));
            if (typeof existing === "function") existing(token);
            else if (typeof existing === "string") {
                const globalFunc = $8fd3c2447d7c53c3$var$_window()[existing];
                if (typeof globalFunc === "function") globalFunc(token);
            }
        };
    }
    assertNotDestroyed() {
        $8fd3c2447d7c53c3$export$9fa96a7d116ea3ce(!this.destroyed, this.auth, "internal-error" /* INTERNAL_ERROR */ );
    }
    async makeRenderPromise() {
        await this.init();
        if (!this.widgetId) {
            let container = this.container;
            if (!this.isInvisible) {
                const guaranteedEmpty = document.createElement("div");
                container.appendChild(guaranteedEmpty);
                container = guaranteedEmpty;
            }
            this.widgetId = this.getAssertedRecaptcha().render(container, this.parameters);
        }
        return this.widgetId;
    }
    async init() {
        $8fd3c2447d7c53c3$export$9fa96a7d116ea3ce($8fd3c2447d7c53c3$var$_isHttpOrHttps() && !$8fd3c2447d7c53c3$var$_isWorker(), this.auth, "internal-error" /* INTERNAL_ERROR */ );
        await $8fd3c2447d7c53c3$var$domReady();
        this.recaptcha = await this._recaptchaLoader.load(this.auth, this.auth.languageCode || undefined);
        const siteKey = await $8fd3c2447d7c53c3$var$getRecaptchaParams(this.auth);
        $8fd3c2447d7c53c3$export$9fa96a7d116ea3ce(siteKey, this.auth, "internal-error" /* INTERNAL_ERROR */ );
        this.parameters.sitekey = siteKey;
    }
    getAssertedRecaptcha() {
        $8fd3c2447d7c53c3$export$9fa96a7d116ea3ce(this.recaptcha, this.auth, "internal-error" /* INTERNAL_ERROR */ );
        return this.recaptcha;
    }
    /**
     *
     * @param containerOrId - The reCAPTCHA container parameter.
     *
     * @remarks
     * This has different meaning depending on whether the reCAPTCHA is hidden or visible. For a
     * visible reCAPTCHA the container must be empty. If a string is used, it has to correspond to
     * an element ID. The corresponding element must also must be in the DOM at the time of
     * initialization.
     *
     * @param parameters - The optional reCAPTCHA parameters.
     *
     * @remarks
     * Check the reCAPTCHA docs for a comprehensive list. All parameters are accepted except for
     * the sitekey. Firebase Auth backend provisions a reCAPTCHA for each project and will
     * configure this upon rendering. For an invisible reCAPTCHA, a size key must have the value
     * 'invisible'.
     *
     * @param authExtern - The corresponding Firebase {@link Auth} instance.
     *
     * @remarks
     * If none is provided, the default Firebase {@link Auth} instance is used. A Firebase {@link Auth} instance
     * must be initialized with an API key, otherwise an error will be thrown.
     */ constructor(containerOrId, parameters = Object.assign({}, $8fd3c2447d7c53c3$var$DEFAULT_PARAMS), authExtern){
        this.parameters = parameters;
        /**
         * The application verifier type.
         *
         * @remarks
         * For a reCAPTCHA verifier, this is 'recaptcha'.
         */ this.type = $8fd3c2447d7c53c3$var$RECAPTCHA_VERIFIER_TYPE;
        this.destroyed = false;
        this.widgetId = null;
        this.tokenChangeListeners = new Set();
        this.renderPromise = null;
        this.recaptcha = null;
        this.auth = $8fd3c2447d7c53c3$export$158acd800e1ef08b(authExtern);
        this.isInvisible = this.parameters.size === "invisible";
        $8fd3c2447d7c53c3$export$9fa96a7d116ea3ce(typeof document !== "undefined", this.auth, "operation-not-supported-in-this-environment" /* OPERATION_NOT_SUPPORTED */ );
        const container = typeof containerOrId === "string" ? document.getElementById(containerOrId) : containerOrId;
        $8fd3c2447d7c53c3$export$9fa96a7d116ea3ce(container, this.auth, "argument-error" /* ARGUMENT_ERROR */ );
        this.container = container;
        this.parameters.callback = this.makeTokenCallback(this.parameters.callback);
        this._recaptchaLoader = this.auth.settings.appVerificationDisabledForTesting ? new $8fd3c2447d7c53c3$var$MockReCaptchaLoaderImpl() : new $8fd3c2447d7c53c3$var$ReCaptchaLoaderImpl();
        this.validateStartingState();
    // TODO: Figure out if sdk version is needed
    }
}
function $8fd3c2447d7c53c3$var$domReady() {
    let resolver = null;
    return new Promise((resolve)=>{
        if (document.readyState === "complete") {
            resolve();
            return;
        }
        // Document not ready, wait for load before resolving.
        // Save resolver, so we can remove listener in case it was externally
        // cancelled.
        resolver = ()=>resolve();
        window.addEventListener("load", resolver);
    }).catch((e)=>{
        if (resolver) window.removeEventListener("load", resolver);
        throw e;
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $8fd3c2447d7c53c3$var$ConfirmationResultImpl {
    confirm(verificationCode) {
        const authCredential = $8fd3c2447d7c53c3$export$3466f893ebf79586._fromVerification(this.verificationId, verificationCode);
        return this.onConfirmation(authCredential);
    }
    constructor(verificationId, onConfirmation){
        this.verificationId = verificationId;
        this.onConfirmation = onConfirmation;
    }
}
/**
 * Asynchronously signs in using a phone number.
 *
 * @remarks
 * This method sends a code via SMS to the given
 * phone number, and returns a {@link ConfirmationResult}. After the user
 * provides the code sent to their phone, call {@link ConfirmationResult.confirm}
 * with the code to sign the user in.
 *
 * For abuse prevention, this method also requires a {@link ApplicationVerifier}.
 * This SDK includes a reCAPTCHA-based implementation, {@link RecaptchaVerifier}.
 * This function can work on other platforms that do not support the
 * {@link RecaptchaVerifier} (like React Native), but you need to use a
 * third-party {@link ApplicationVerifier} implementation.
 *
 * @example
 * ```javascript
 * // 'recaptcha-container' is the ID of an element in the DOM.
 * const applicationVerifier = new firebase.auth.RecaptchaVerifier('recaptcha-container');
 * const confirmationResult = await signInWithPhoneNumber(auth, phoneNumber, applicationVerifier);
 * // Obtain a verificationCode from the user.
 * const credential = await confirmationResult.confirm(verificationCode);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param phoneNumber - The user's phone number in E.164 format (e.g. +16505550101).
 * @param appVerifier - The {@link ApplicationVerifier}.
 *
 * @public
 */ async function $8fd3c2447d7c53c3$export$2408f22a0fab9ae5(auth, phoneNumber, appVerifier) {
    const authInternal = $8fd3c2447d7c53c3$export$158acd800e1ef08b(auth);
    const verificationId = await $8fd3c2447d7c53c3$var$_verifyPhoneNumber(authInternal, phoneNumber, (0, $6vM9o.getModularInstance)(appVerifier));
    return new $8fd3c2447d7c53c3$var$ConfirmationResultImpl(verificationId, (cred)=>$8fd3c2447d7c53c3$export$8743009a87fcb00f(authInternal, cred));
}
/**
 * Links the user account with the given phone number.
 *
 * @param user - The user.
 * @param phoneNumber - The user's phone number in E.164 format (e.g. +16505550101).
 * @param appVerifier - The {@link ApplicationVerifier}.
 *
 * @public
 */ async function $8fd3c2447d7c53c3$export$882b5998b3b9117c(user, phoneNumber, appVerifier) {
    const userInternal = (0, $6vM9o.getModularInstance)(user);
    await $8fd3c2447d7c53c3$var$_assertLinkedStatus(false, userInternal, "phone" /* PHONE */ );
    const verificationId = await $8fd3c2447d7c53c3$var$_verifyPhoneNumber(userInternal.auth, phoneNumber, (0, $6vM9o.getModularInstance)(appVerifier));
    return new $8fd3c2447d7c53c3$var$ConfirmationResultImpl(verificationId, (cred)=>$8fd3c2447d7c53c3$export$dc98b0b04f4c7758(userInternal, cred));
}
/**
 * Re-authenticates a user using a fresh phone credential.
 *
 * @remarks Use before operations such as {@link updatePassword} that require tokens from recent sign-in attempts.
 *
 * @param user - The user.
 * @param phoneNumber - The user's phone number in E.164 format (e.g. +16505550101).
 * @param appVerifier - The {@link ApplicationVerifier}.
 *
 * @public
 */ async function $8fd3c2447d7c53c3$export$43caf9889c228507(user, phoneNumber, appVerifier) {
    const userInternal = (0, $6vM9o.getModularInstance)(user);
    const verificationId = await $8fd3c2447d7c53c3$var$_verifyPhoneNumber(userInternal.auth, phoneNumber, (0, $6vM9o.getModularInstance)(appVerifier));
    return new $8fd3c2447d7c53c3$var$ConfirmationResultImpl(verificationId, (cred)=>$8fd3c2447d7c53c3$export$71511d61b312f219(userInternal, cred));
}
/**
 * Returns a verification ID to be used in conjunction with the SMS code that is sent.
 *
 */ async function $8fd3c2447d7c53c3$var$_verifyPhoneNumber(auth, options, verifier) {
    var _a;
    const recaptchaToken = await verifier.verify();
    try {
        $8fd3c2447d7c53c3$export$9fa96a7d116ea3ce(typeof recaptchaToken === "string", auth, "argument-error" /* ARGUMENT_ERROR */ );
        $8fd3c2447d7c53c3$export$9fa96a7d116ea3ce(verifier.type === $8fd3c2447d7c53c3$var$RECAPTCHA_VERIFIER_TYPE, auth, "argument-error" /* ARGUMENT_ERROR */ );
        let phoneInfoOptions;
        if (typeof options === "string") phoneInfoOptions = {
            phoneNumber: options
        };
        else phoneInfoOptions = options;
        if ("session" in phoneInfoOptions) {
            const session = phoneInfoOptions.session;
            if ("phoneNumber" in phoneInfoOptions) {
                $8fd3c2447d7c53c3$export$9fa96a7d116ea3ce(session.type === "enroll" /* ENROLL */ , auth, "internal-error" /* INTERNAL_ERROR */ );
                const response = await $8fd3c2447d7c53c3$var$startEnrollPhoneMfa(auth, {
                    idToken: session.credential,
                    phoneEnrollmentInfo: {
                        phoneNumber: phoneInfoOptions.phoneNumber,
                        recaptchaToken: recaptchaToken
                    }
                });
                return response.phoneSessionInfo.sessionInfo;
            } else {
                $8fd3c2447d7c53c3$export$9fa96a7d116ea3ce(session.type === "signin" /* SIGN_IN */ , auth, "internal-error" /* INTERNAL_ERROR */ );
                const mfaEnrollmentId = ((_a = phoneInfoOptions.multiFactorHint) === null || _a === void 0 ? void 0 : _a.uid) || phoneInfoOptions.multiFactorUid;
                $8fd3c2447d7c53c3$export$9fa96a7d116ea3ce(mfaEnrollmentId, auth, "missing-multi-factor-info" /* MISSING_MFA_INFO */ );
                const response = await $8fd3c2447d7c53c3$var$startSignInPhoneMfa(auth, {
                    mfaPendingCredential: session.credential,
                    mfaEnrollmentId: mfaEnrollmentId,
                    phoneSignInInfo: {
                        recaptchaToken: recaptchaToken
                    }
                });
                return response.phoneResponseInfo.sessionInfo;
            }
        } else {
            const { sessionInfo: sessionInfo } = await $8fd3c2447d7c53c3$var$sendPhoneVerificationCode(auth, {
                phoneNumber: phoneInfoOptions.phoneNumber,
                recaptchaToken: recaptchaToken
            });
            return sessionInfo;
        }
    } finally{
        verifier._reset();
    }
}
/**
 * Updates the user's phone number.
 *
 * @example
 * ```
 * // 'recaptcha-container' is the ID of an element in the DOM.
 * const applicationVerifier = new RecaptchaVerifier('recaptcha-container');
 * const provider = new PhoneAuthProvider(auth);
 * const verificationId = await provider.verifyPhoneNumber('+16505550101', applicationVerifier);
 * // Obtain the verificationCode from the user.
 * const phoneCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
 * await updatePhoneNumber(user, phoneCredential);
 * ```
 *
 * @param user - The user.
 * @param credential - A credential authenticating the new phone number.
 *
 * @public
 */ async function $8fd3c2447d7c53c3$export$3b14a55fb2447963(user, credential) {
    await $8fd3c2447d7c53c3$var$_link$1((0, $6vM9o.getModularInstance)(user), credential);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link PhoneAuthCredential}.
 *
 * @example
 * ```javascript
 * // 'recaptcha-container' is the ID of an element in the DOM.
 * const applicationVerifier = new RecaptchaVerifier('recaptcha-container');
 * const provider = new PhoneAuthProvider(auth);
 * const verificationId = await provider.verifyPhoneNumber('+16505550101', applicationVerifier);
 * // Obtain the verificationCode from the user.
 * const phoneCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
 * const userCredential = await signInWithCredential(auth, phoneCredential);
 * ```
 *
 * @public
 */ class $8fd3c2447d7c53c3$export$56c0d5a1e737357d {
    /**
     *
     * Starts a phone number authentication flow by sending a verification code to the given phone
     * number.
     *
     * @example
     * ```javascript
     * const provider = new PhoneAuthProvider(auth);
     * const verificationId = await provider.verifyPhoneNumber(phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const authCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
     * const userCredential = await signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * An alternative flow is provided using the `signInWithPhoneNumber` method.
     * ```javascript
     * const confirmationResult = signInWithPhoneNumber(auth, phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const userCredential = confirmationResult.confirm(verificationCode);
     * ```
     *
     * @param phoneInfoOptions - The user's {@link PhoneInfoOptions}. The phone number should be in
     * E.164 format (e.g. +16505550101).
     * @param applicationVerifier - For abuse prevention, this method also requires a
     * {@link ApplicationVerifier}. This SDK includes a reCAPTCHA-based implementation,
     * {@link RecaptchaVerifier}.
     *
     * @returns A Promise for a verification ID that can be passed to
     * {@link PhoneAuthProvider.credential} to identify this flow..
     */ verifyPhoneNumber(phoneOptions, applicationVerifier) {
        return $8fd3c2447d7c53c3$var$_verifyPhoneNumber(this.auth, phoneOptions, (0, $6vM9o.getModularInstance)(applicationVerifier));
    }
    /**
     * Creates a phone auth credential, given the verification ID from
     * {@link PhoneAuthProvider.verifyPhoneNumber} and the code that was sent to the user's
     * mobile device.
     *
     * @example
     * ```javascript
     * const provider = new PhoneAuthProvider(auth);
     * const verificationId = provider.verifyPhoneNumber(phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const authCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
     * const userCredential = signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * An alternative flow is provided using the `signInWithPhoneNumber` method.
     * ```javascript
     * const confirmationResult = await signInWithPhoneNumber(auth, phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const userCredential = await confirmationResult.confirm(verificationCode);
     * ```
     *
     * @param verificationId - The verification ID returned from {@link PhoneAuthProvider.verifyPhoneNumber}.
     * @param verificationCode - The verification code sent to the user's mobile device.
     *
     * @returns The auth provider credential.
     */ static credential(verificationId, verificationCode) {
        return $8fd3c2447d7c53c3$export$3466f893ebf79586._fromVerification(verificationId, verificationCode);
    }
    /**
     * Generates an {@link AuthCredential} from a {@link UserCredential}.
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        const credential = userCredential;
        return $8fd3c2447d7c53c3$export$56c0d5a1e737357d.credentialFromTaggedObject(credential);
    }
    /**
     * Returns an {@link AuthCredential} when passed an error.
     *
     * @remarks
     *
     * This method works for errors like
     * `auth/account-exists-with-different-credentials`. This is useful for
     * recovering when attempting to set a user's phone number but the number
     * in question is already tied to another account. For example, the following
     * code tries to update the current user's phone number, and if that
     * fails, links the user with the account associated with that number:
     *
     * ```js
     * const provider = new PhoneAuthProvider(auth);
     * const verificationId = await provider.verifyPhoneNumber(number, verifier);
     * try {
     *   const code = ''; // Prompt the user for the verification code
     *   await updatePhoneNumber(
     *       auth.currentUser,
     *       PhoneAuthProvider.credential(verificationId, code));
     * } catch (e) {
     *   if (e.code === 'auth/account-exists-with-different-credential') {
     *     const cred = PhoneAuthProvider.credentialFromError(e);
     *     await linkWithCredential(auth.currentUser, cred);
     *   }
     * }
     *
     * // At this point, auth.currentUser.phoneNumber === number.
     * ```
     *
     * @param error - The error to generate a credential from.
     */ static credentialFromError(error) {
        return $8fd3c2447d7c53c3$export$56c0d5a1e737357d.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { phoneNumber: phoneNumber, temporaryProof: temporaryProof } = tokenResponse;
        if (phoneNumber && temporaryProof) return $8fd3c2447d7c53c3$export$3466f893ebf79586._fromTokenResponse(phoneNumber, temporaryProof);
        return null;
    }
    /**
     * @param auth - The Firebase {@link Auth} instance in which sign-ins should occur.
     *
     */ constructor(auth){
        /** Always set to {@link ProviderId}.PHONE. */ this.providerId = $8fd3c2447d7c53c3$export$56c0d5a1e737357d.PROVIDER_ID;
        this.auth = $8fd3c2447d7c53c3$export$158acd800e1ef08b(auth);
    }
}
/** Always set to {@link ProviderId}.PHONE. */ $8fd3c2447d7c53c3$export$56c0d5a1e737357d.PROVIDER_ID = "phone" /* PHONE */ ;
/** Always set to {@link SignInMethod}.PHONE. */ $8fd3c2447d7c53c3$export$56c0d5a1e737357d.PHONE_SIGN_IN_METHOD = "phone" /* PHONE */ ;
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Chooses a popup/redirect resolver to use. This prefers the override (which
 * is directly passed in), and falls back to the property set on the auth
 * object. If neither are available, this function errors w/ an argument error.
 */ function $8fd3c2447d7c53c3$var$_withDefaultResolver(auth, resolverOverride) {
    if (resolverOverride) return $8fd3c2447d7c53c3$export$28f7fcd39efa255(resolverOverride);
    $8fd3c2447d7c53c3$export$9fa96a7d116ea3ce(auth._popupRedirectResolver, auth, "argument-error" /* ARGUMENT_ERROR */ );
    return auth._popupRedirectResolver;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $8fd3c2447d7c53c3$var$IdpCredential extends $8fd3c2447d7c53c3$export$7f8ddf7c7c20b3cd {
    _getIdTokenResponse(auth) {
        return $8fd3c2447d7c53c3$var$signInWithIdp(auth, this._buildIdpRequest());
    }
    _linkToIdToken(auth, idToken) {
        return $8fd3c2447d7c53c3$var$signInWithIdp(auth, this._buildIdpRequest(idToken));
    }
    _getReauthenticationResolver(auth) {
        return $8fd3c2447d7c53c3$var$signInWithIdp(auth, this._buildIdpRequest());
    }
    _buildIdpRequest(idToken) {
        const request = {
            requestUri: this.params.requestUri,
            sessionId: this.params.sessionId,
            postBody: this.params.postBody,
            tenantId: this.params.tenantId,
            pendingToken: this.params.pendingToken,
            returnSecureToken: true,
            returnIdpCredential: true
        };
        if (idToken) request.idToken = idToken;
        return request;
    }
    constructor(params){
        super("custom" /* CUSTOM */ , "custom" /* CUSTOM */ );
        this.params = params;
    }
}
function $8fd3c2447d7c53c3$var$_signIn(params) {
    return $8fd3c2447d7c53c3$var$_signInWithCredential(params.auth, new $8fd3c2447d7c53c3$var$IdpCredential(params), params.bypassAuthState);
}
function $8fd3c2447d7c53c3$var$_reauth(params) {
    const { auth: auth, user: user } = params;
    $8fd3c2447d7c53c3$export$9fa96a7d116ea3ce(user, auth, "internal-error" /* INTERNAL_ERROR */ );
    return $8fd3c2447d7c53c3$var$_reauthenticate(user, new $8fd3c2447d7c53c3$var$IdpCredential(params), params.bypassAuthState);
}
async function $8fd3c2447d7c53c3$var$_link(params) {
    const { auth: auth, user: user } = params;
    $8fd3c2447d7c53c3$export$9fa96a7d116ea3ce(user, auth, "internal-error" /* INTERNAL_ERROR */ );
    return $8fd3c2447d7c53c3$var$_link$1(user, new $8fd3c2447d7c53c3$var$IdpCredential(params), params.bypassAuthState);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Popup event manager. Handles the popup's entire lifecycle; listens to auth
 * events
 */ class $8fd3c2447d7c53c3$var$AbstractPopupRedirectOperation {
    execute() {
        return new Promise(async (resolve, reject)=>{
            this.pendingPromise = {
                resolve: resolve,
                reject: reject
            };
            try {
                this.eventManager = await this.resolver._initialize(this.auth);
                await this.onExecution();
                this.eventManager.registerConsumer(this);
            } catch (e) {
                this.reject(e);
            }
        });
    }
    async onAuthEvent(event) {
        const { urlResponse: urlResponse, sessionId: sessionId, postBody: postBody, tenantId: tenantId, error: error, type: type } = event;
        if (error) {
            this.reject(error);
            return;
        }
        const params = {
            auth: this.auth,
            requestUri: urlResponse,
            sessionId: sessionId,
            tenantId: tenantId || undefined,
            postBody: postBody || undefined,
            user: this.user,
            bypassAuthState: this.bypassAuthState
        };
        try {
            this.resolve(await this.getIdpTask(type)(params));
        } catch (e) {
            this.reject(e);
        }
    }
    onError(error) {
        this.reject(error);
    }
    getIdpTask(type) {
        switch(type){
            case "signInViaPopup" /* SIGN_IN_VIA_POPUP */ :
            case "signInViaRedirect" /* SIGN_IN_VIA_REDIRECT */ :
                return $8fd3c2447d7c53c3$var$_signIn;
            case "linkViaPopup" /* LINK_VIA_POPUP */ :
            case "linkViaRedirect" /* LINK_VIA_REDIRECT */ :
                return $8fd3c2447d7c53c3$var$_link;
            case "reauthViaPopup" /* REAUTH_VIA_POPUP */ :
            case "reauthViaRedirect" /* REAUTH_VIA_REDIRECT */ :
                return $8fd3c2447d7c53c3$var$_reauth;
            default:
                $8fd3c2447d7c53c3$export$493d36ec626b6698(this.auth, "internal-error" /* INTERNAL_ERROR */ );
        }
    }
    resolve(cred) {
        $8fd3c2447d7c53c3$export$8a5498727ef6be21(this.pendingPromise, "Pending promise was never set");
        this.pendingPromise.resolve(cred);
        this.unregisterAndCleanUp();
    }
    reject(error) {
        $8fd3c2447d7c53c3$export$8a5498727ef6be21(this.pendingPromise, "Pending promise was never set");
        this.pendingPromise.reject(error);
        this.unregisterAndCleanUp();
    }
    unregisterAndCleanUp() {
        if (this.eventManager) this.eventManager.unregisterConsumer(this);
        this.pendingPromise = null;
        this.cleanUp();
    }
    constructor(auth, filter, resolver, user, bypassAuthState = false){
        this.auth = auth;
        this.resolver = resolver;
        this.user = user;
        this.bypassAuthState = bypassAuthState;
        this.pendingPromise = null;
        this.eventManager = null;
        this.filter = Array.isArray(filter) ? filter : [
            filter
        ];
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $8fd3c2447d7c53c3$var$_POLL_WINDOW_CLOSE_TIMEOUT = new $8fd3c2447d7c53c3$var$Delay(2000, 10000);
/**
 * Authenticates a Firebase client using a popup-based OAuth authentication flow.
 *
 * @remarks
 * If succeeds, returns the signed in user along with the provider's credential. If sign in was
 * unsuccessful, returns an error object containing additional information about the error.
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new FacebookAuthProvider();
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Facebook Access Token.
 * const credential = provider.credentialFromResult(auth, result);
 * const token = credential.accessToken;
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 *
 * @public
 */ async function $8fd3c2447d7c53c3$export$db3b6bfb95261072(auth, provider, resolver) {
    const authInternal = $8fd3c2447d7c53c3$export$158acd800e1ef08b(auth);
    $8fd3c2447d7c53c3$var$_assertInstanceOf(auth, provider, $8fd3c2447d7c53c3$var$FederatedAuthProvider);
    const resolverInternal = $8fd3c2447d7c53c3$var$_withDefaultResolver(authInternal, resolver);
    const action = new $8fd3c2447d7c53c3$var$PopupOperation(authInternal, "signInViaPopup" /* SIGN_IN_VIA_POPUP */ , provider, resolverInternal);
    return action.executeNotNull();
}
/**
 * Reauthenticates the current user with the specified {@link OAuthProvider} using a pop-up based
 * OAuth flow.
 *
 * @remarks
 * If the reauthentication is successful, the returned result will contain the user and the
 * provider's credential.
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new FacebookAuthProvider();
 * const result = await signInWithPopup(auth, provider);
 * // Reauthenticate using a popup.
 * await reauthenticateWithPopup(result.user, provider);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ async function $8fd3c2447d7c53c3$export$f1e1789686576879(user, provider, resolver) {
    const userInternal = (0, $6vM9o.getModularInstance)(user);
    $8fd3c2447d7c53c3$var$_assertInstanceOf(userInternal.auth, provider, $8fd3c2447d7c53c3$var$FederatedAuthProvider);
    const resolverInternal = $8fd3c2447d7c53c3$var$_withDefaultResolver(userInternal.auth, resolver);
    const action = new $8fd3c2447d7c53c3$var$PopupOperation(userInternal.auth, "reauthViaPopup" /* REAUTH_VIA_POPUP */ , provider, resolverInternal, userInternal);
    return action.executeNotNull();
}
/**
 * Links the authenticated provider to the user account using a pop-up based OAuth flow.
 *
 * @remarks
 * If the linking is successful, the returned result will contain the user and the provider's credential.
 *
 *
 * @example
 * ```javascript
 * // Sign in using some other provider.
 * const result = await signInWithEmailAndPassword(auth, email, password);
 * // Link using a popup.
 * const provider = new FacebookAuthProvider();
 * await linkWithPopup(result.user, provider);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ async function $8fd3c2447d7c53c3$export$4368d992c4eafac0(user, provider, resolver) {
    const userInternal = (0, $6vM9o.getModularInstance)(user);
    $8fd3c2447d7c53c3$var$_assertInstanceOf(userInternal.auth, provider, $8fd3c2447d7c53c3$var$FederatedAuthProvider);
    const resolverInternal = $8fd3c2447d7c53c3$var$_withDefaultResolver(userInternal.auth, resolver);
    const action = new $8fd3c2447d7c53c3$var$PopupOperation(userInternal.auth, "linkViaPopup" /* LINK_VIA_POPUP */ , provider, resolverInternal, userInternal);
    return action.executeNotNull();
}
/**
 * Popup event manager. Handles the popup's entire lifecycle; listens to auth
 * events
 *
 */ class $8fd3c2447d7c53c3$var$PopupOperation extends $8fd3c2447d7c53c3$var$AbstractPopupRedirectOperation {
    async executeNotNull() {
        const result = await this.execute();
        $8fd3c2447d7c53c3$export$9fa96a7d116ea3ce(result, this.auth, "internal-error" /* INTERNAL_ERROR */ );
        return result;
    }
    async onExecution() {
        $8fd3c2447d7c53c3$export$8a5498727ef6be21(this.filter.length === 1, "Popup operations only handle one event");
        const eventId = $8fd3c2447d7c53c3$export$b9a6b53f9be3734();
        this.authWindow = await this.resolver._openPopup(this.auth, this.provider, this.filter[0], eventId);
        this.authWindow.associatedEvent = eventId;
        // Check for web storage support and origin validation _after_ the popup is
        // loaded. These operations are slow (~1 second or so) Rather than
        // waiting on them before opening the window, optimistically open the popup
        // and check for storage support at the same time. If storage support is
        // not available, this will cause the whole thing to reject properly. It
        // will also close the popup, but since the promise has already rejected,
        // the popup closed by user poll will reject into the void.
        this.resolver._originValidation(this.auth).catch((e)=>{
            this.reject(e);
        });
        this.resolver._isIframeWebStorageSupported(this.auth, (isSupported)=>{
            if (!isSupported) this.reject($8fd3c2447d7c53c3$export$92108d983e8ee699(this.auth, "web-storage-unsupported" /* WEB_STORAGE_UNSUPPORTED */ ));
        });
        // Handle user closure. Notice this does *not* use await
        this.pollUserCancellation();
    }
    get eventId() {
        var _a;
        return ((_a = this.authWindow) === null || _a === void 0 ? void 0 : _a.associatedEvent) || null;
    }
    cancel() {
        this.reject($8fd3c2447d7c53c3$export$92108d983e8ee699(this.auth, "cancelled-popup-request" /* EXPIRED_POPUP_REQUEST */ ));
    }
    cleanUp() {
        if (this.authWindow) this.authWindow.close();
        if (this.pollId) window.clearTimeout(this.pollId);
        this.authWindow = null;
        this.pollId = null;
        $8fd3c2447d7c53c3$var$PopupOperation.currentPopupAction = null;
    }
    pollUserCancellation() {
        const poll = ()=>{
            var _a, _b;
            if ((_b = (_a = this.authWindow) === null || _a === void 0 ? void 0 : _a.window) === null || _b === void 0 ? void 0 : _b.closed) {
                // Make sure that there is sufficient time for whatever action to
                // complete. The window could have closed but the sign in network
                // call could still be in flight.
                this.pollId = window.setTimeout(()=>{
                    this.pollId = null;
                    this.reject($8fd3c2447d7c53c3$export$92108d983e8ee699(this.auth, "popup-closed-by-user" /* POPUP_CLOSED_BY_USER */ ));
                }, 2000 /* AUTH_EVENT */ );
                return;
            }
            this.pollId = window.setTimeout(poll, $8fd3c2447d7c53c3$var$_POLL_WINDOW_CLOSE_TIMEOUT.get());
        };
        poll();
    }
    constructor(auth, filter, provider, resolver, user){
        super(auth, filter, resolver, user);
        this.provider = provider;
        this.authWindow = null;
        this.pollId = null;
        if ($8fd3c2447d7c53c3$var$PopupOperation.currentPopupAction) $8fd3c2447d7c53c3$var$PopupOperation.currentPopupAction.cancel();
        $8fd3c2447d7c53c3$var$PopupOperation.currentPopupAction = this;
    }
}
// Only one popup is ever shown at once. The lifecycle of the current popup
// can be managed / cancelled by the constructor.
$8fd3c2447d7c53c3$var$PopupOperation.currentPopupAction = null;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $8fd3c2447d7c53c3$var$PENDING_REDIRECT_KEY = "pendingRedirect";
// We only get one redirect outcome for any one auth, so just store it
// in here.
const $8fd3c2447d7c53c3$var$redirectOutcomeMap = new Map();
class $8fd3c2447d7c53c3$var$RedirectAction extends $8fd3c2447d7c53c3$var$AbstractPopupRedirectOperation {
    /**
     * Override the execute function; if we already have a redirect result, then
     * just return it.
     */ async execute() {
        let readyOutcome = $8fd3c2447d7c53c3$var$redirectOutcomeMap.get(this.auth._key());
        if (!readyOutcome) {
            try {
                const hasPendingRedirect = await $8fd3c2447d7c53c3$var$_getAndClearPendingRedirectStatus(this.resolver, this.auth);
                const result = hasPendingRedirect ? await super.execute() : null;
                readyOutcome = ()=>Promise.resolve(result);
            } catch (e) {
                readyOutcome = ()=>Promise.reject(e);
            }
            $8fd3c2447d7c53c3$var$redirectOutcomeMap.set(this.auth._key(), readyOutcome);
        }
        // If we're not bypassing auth state, the ready outcome should be set to
        // null.
        if (!this.bypassAuthState) $8fd3c2447d7c53c3$var$redirectOutcomeMap.set(this.auth._key(), ()=>Promise.resolve(null));
        return readyOutcome();
    }
    async onAuthEvent(event) {
        if (event.type === "signInViaRedirect" /* SIGN_IN_VIA_REDIRECT */ ) return super.onAuthEvent(event);
        else if (event.type === "unknown" /* UNKNOWN */ ) {
            // This is a sentinel value indicating there's no pending redirect
            this.resolve(null);
            return;
        }
        if (event.eventId) {
            const user = await this.auth._redirectUserForId(event.eventId);
            if (user) {
                this.user = user;
                return super.onAuthEvent(event);
            } else this.resolve(null);
        }
    }
    async onExecution() {}
    cleanUp() {}
    constructor(auth, resolver, bypassAuthState = false){
        super(auth, [
            "signInViaRedirect" /* SIGN_IN_VIA_REDIRECT */ ,
            "linkViaRedirect" /* LINK_VIA_REDIRECT */ ,
            "reauthViaRedirect" /* REAUTH_VIA_REDIRECT */ ,
            "unknown" /* UNKNOWN */ 
        ], resolver, undefined, bypassAuthState);
        this.eventId = null;
    }
}
async function $8fd3c2447d7c53c3$var$_getAndClearPendingRedirectStatus(resolver, auth) {
    const key = $8fd3c2447d7c53c3$var$pendingRedirectKey(auth);
    const persistence = $8fd3c2447d7c53c3$var$resolverPersistence(resolver);
    if (!await persistence._isAvailable()) return false;
    const hasPendingRedirect = await persistence._get(key) === "true";
    await persistence._remove(key);
    return hasPendingRedirect;
}
async function $8fd3c2447d7c53c3$var$_setPendingRedirectStatus(resolver, auth) {
    return $8fd3c2447d7c53c3$var$resolverPersistence(resolver)._set($8fd3c2447d7c53c3$var$pendingRedirectKey(auth), "true");
}
function $8fd3c2447d7c53c3$export$24baa2b76016ce0e() {
    $8fd3c2447d7c53c3$var$redirectOutcomeMap.clear();
}
function $8fd3c2447d7c53c3$export$890c4ad488842ce7(auth, result) {
    $8fd3c2447d7c53c3$var$redirectOutcomeMap.set(auth._key(), result);
}
function $8fd3c2447d7c53c3$var$resolverPersistence(resolver) {
    return $8fd3c2447d7c53c3$export$28f7fcd39efa255(resolver._redirectPersistence);
}
function $8fd3c2447d7c53c3$var$pendingRedirectKey(auth) {
    return $8fd3c2447d7c53c3$export$3d12bd131bb975d1($8fd3c2447d7c53c3$var$PENDING_REDIRECT_KEY, auth.config.apiKey, auth.name);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Authenticates a Firebase client using a full-page redirect flow.
 *
 * @remarks
 * To handle the results and errors for this operation, refer to {@link getRedirectResult}.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * // You can add additional scopes to the provider:
 * provider.addScope('user_birthday');
 * // Start a sign in process for an unauthenticated user.
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Facebook Access Token.
 *   const credential = provider.credentialFromResult(auth, result);
 *   const token = credential.accessToken;
 * }
 * // As this API can be used for sign-in, linking and reauthentication,
 * // check the operationType to determine what triggered this redirect
 * // operation.
 * const operationType = result.operationType;
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ function $8fd3c2447d7c53c3$export$2d1720544b23b823(auth, provider, resolver) {
    return $8fd3c2447d7c53c3$var$_signInWithRedirect(auth, provider, resolver);
}
async function $8fd3c2447d7c53c3$var$_signInWithRedirect(auth, provider, resolver) {
    const authInternal = $8fd3c2447d7c53c3$export$158acd800e1ef08b(auth);
    $8fd3c2447d7c53c3$var$_assertInstanceOf(auth, provider, $8fd3c2447d7c53c3$var$FederatedAuthProvider);
    const resolverInternal = $8fd3c2447d7c53c3$var$_withDefaultResolver(authInternal, resolver);
    await $8fd3c2447d7c53c3$var$_setPendingRedirectStatus(resolverInternal, authInternal);
    return resolverInternal._openRedirect(authInternal, provider, "signInViaRedirect" /* SIGN_IN_VIA_REDIRECT */ );
}
/**
 * Reauthenticates the current user with the specified {@link OAuthProvider} using a full-page redirect flow.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * const result = await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * // Link using a redirect.
 * await linkWithRedirect(result.user, provider);
 * // This will again trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ function $8fd3c2447d7c53c3$export$dda1d9f60106f0e9(user, provider, resolver) {
    return $8fd3c2447d7c53c3$var$_reauthenticateWithRedirect(user, provider, resolver);
}
async function $8fd3c2447d7c53c3$var$_reauthenticateWithRedirect(user, provider, resolver) {
    const userInternal = (0, $6vM9o.getModularInstance)(user);
    $8fd3c2447d7c53c3$var$_assertInstanceOf(userInternal.auth, provider, $8fd3c2447d7c53c3$var$FederatedAuthProvider);
    // Allow the resolver to error before persisting the redirect user
    const resolverInternal = $8fd3c2447d7c53c3$var$_withDefaultResolver(userInternal.auth, resolver);
    await $8fd3c2447d7c53c3$var$_setPendingRedirectStatus(resolverInternal, userInternal.auth);
    const eventId = await $8fd3c2447d7c53c3$var$prepareUserForRedirect(userInternal);
    return resolverInternal._openRedirect(userInternal.auth, provider, "reauthViaRedirect" /* REAUTH_VIA_REDIRECT */ , eventId);
}
/**
 * Links the {@link OAuthProvider} to the user account using a full-page redirect flow.
 *
 * @example
 * ```javascript
 * // Sign in using some other provider.
 * const result = await signInWithEmailAndPassword(auth, email, password);
 * // Link using a redirect.
 * const provider = new FacebookAuthProvider();
 * await linkWithRedirect(result.user, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 *
 * @public
 */ function $8fd3c2447d7c53c3$export$39b482c5e57630a8(user, provider, resolver) {
    return $8fd3c2447d7c53c3$var$_linkWithRedirect(user, provider, resolver);
}
async function $8fd3c2447d7c53c3$var$_linkWithRedirect(user, provider, resolver) {
    const userInternal = (0, $6vM9o.getModularInstance)(user);
    $8fd3c2447d7c53c3$var$_assertInstanceOf(userInternal.auth, provider, $8fd3c2447d7c53c3$var$FederatedAuthProvider);
    // Allow the resolver to error before persisting the redirect user
    const resolverInternal = $8fd3c2447d7c53c3$var$_withDefaultResolver(userInternal.auth, resolver);
    await $8fd3c2447d7c53c3$var$_assertLinkedStatus(false, userInternal, provider.providerId);
    await $8fd3c2447d7c53c3$var$_setPendingRedirectStatus(resolverInternal, userInternal.auth);
    const eventId = await $8fd3c2447d7c53c3$var$prepareUserForRedirect(userInternal);
    return resolverInternal._openRedirect(userInternal.auth, provider, "linkViaRedirect" /* LINK_VIA_REDIRECT */ , eventId);
}
/**
 * Returns a {@link UserCredential} from the redirect-based sign-in flow.
 *
 * @remarks
 * If sign-in succeeded, returns the signed in user. If sign-in was unsuccessful, fails with an
 * error. If no redirect operation was called, returns a {@link UserCredential}
 * with a null `user`.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * // You can add additional scopes to the provider:
 * provider.addScope('user_birthday');
 * // Start a sign in process for an unauthenticated user.
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Facebook Access Token.
 *   const credential = provider.credentialFromResult(auth, result);
 *   const token = credential.accessToken;
 * }
 * // As this API can be used for sign-in, linking and reauthentication,
 * // check the operationType to determine what triggered this redirect
 * // operation.
 * const operationType = result.operationType;
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ async function $8fd3c2447d7c53c3$export$35e795649ee09318(auth, resolver) {
    await $8fd3c2447d7c53c3$export$158acd800e1ef08b(auth)._initializationPromise;
    return $8fd3c2447d7c53c3$export$9d398bebfec1c039(auth, resolver, false);
}
async function $8fd3c2447d7c53c3$export$9d398bebfec1c039(auth, resolverExtern, bypassAuthState = false) {
    const authInternal = $8fd3c2447d7c53c3$export$158acd800e1ef08b(auth);
    const resolver = $8fd3c2447d7c53c3$var$_withDefaultResolver(authInternal, resolverExtern);
    const action = new $8fd3c2447d7c53c3$var$RedirectAction(authInternal, resolver, bypassAuthState);
    const result = await action.execute();
    if (result && !bypassAuthState) {
        delete result.user._redirectEventId;
        await authInternal._persistUserIfCurrent(result.user);
        await authInternal._setRedirectUser(null, resolverExtern);
    }
    return result;
}
async function $8fd3c2447d7c53c3$var$prepareUserForRedirect(user) {
    const eventId = $8fd3c2447d7c53c3$export$b9a6b53f9be3734(`${user.uid}:::`);
    user._redirectEventId = eventId;
    await user.auth._setRedirectUser(user);
    await user.auth._persistUserIfCurrent(user);
    return eventId;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // The amount of time to store the UIDs of seen events; this is
// set to 10 min by default
const $8fd3c2447d7c53c3$var$EVENT_DUPLICATION_CACHE_DURATION_MS = 600000;
class $8fd3c2447d7c53c3$export$91c6e00c14e7e6fd {
    registerConsumer(authEventConsumer) {
        this.consumers.add(authEventConsumer);
        if (this.queuedRedirectEvent && this.isEventForConsumer(this.queuedRedirectEvent, authEventConsumer)) {
            this.sendToConsumer(this.queuedRedirectEvent, authEventConsumer);
            this.saveEventToCache(this.queuedRedirectEvent);
            this.queuedRedirectEvent = null;
        }
    }
    unregisterConsumer(authEventConsumer) {
        this.consumers.delete(authEventConsumer);
    }
    onEvent(event) {
        // Check if the event has already been handled
        if (this.hasEventBeenHandled(event)) return false;
        let handled = false;
        this.consumers.forEach((consumer)=>{
            if (this.isEventForConsumer(event, consumer)) {
                handled = true;
                this.sendToConsumer(event, consumer);
                this.saveEventToCache(event);
            }
        });
        if (this.hasHandledPotentialRedirect || !$8fd3c2447d7c53c3$var$isRedirectEvent(event)) // If we've already seen a redirect before, or this is a popup event,
        // bail now
        return handled;
        this.hasHandledPotentialRedirect = true;
        // If the redirect wasn't handled, hang on to it
        if (!handled) {
            this.queuedRedirectEvent = event;
            handled = true;
        }
        return handled;
    }
    sendToConsumer(event, consumer) {
        var _a;
        if (event.error && !$8fd3c2447d7c53c3$var$isNullRedirectEvent(event)) {
            const code = ((_a = event.error.code) === null || _a === void 0 ? void 0 : _a.split("auth/")[1]) || "internal-error" /* INTERNAL_ERROR */ ;
            consumer.onError($8fd3c2447d7c53c3$export$92108d983e8ee699(this.auth, code));
        } else consumer.onAuthEvent(event);
    }
    isEventForConsumer(event, consumer) {
        const eventIdMatches = consumer.eventId === null || !!event.eventId && event.eventId === consumer.eventId;
        return consumer.filter.includes(event.type) && eventIdMatches;
    }
    hasEventBeenHandled(event) {
        if (Date.now() - this.lastProcessedEventTime >= $8fd3c2447d7c53c3$var$EVENT_DUPLICATION_CACHE_DURATION_MS) this.cachedEventUids.clear();
        return this.cachedEventUids.has($8fd3c2447d7c53c3$var$eventUid(event));
    }
    saveEventToCache(event) {
        this.cachedEventUids.add($8fd3c2447d7c53c3$var$eventUid(event));
        this.lastProcessedEventTime = Date.now();
    }
    constructor(auth){
        this.auth = auth;
        this.cachedEventUids = new Set();
        this.consumers = new Set();
        this.queuedRedirectEvent = null;
        this.hasHandledPotentialRedirect = false;
        this.lastProcessedEventTime = Date.now();
    }
}
function $8fd3c2447d7c53c3$var$eventUid(e) {
    return [
        e.type,
        e.eventId,
        e.sessionId,
        e.tenantId
    ].filter((v)=>v).join("-");
}
function $8fd3c2447d7c53c3$var$isNullRedirectEvent({ type: type, error: error }) {
    return type === "unknown" /* UNKNOWN */  && (error === null || error === void 0 ? void 0 : error.code) === `auth/${"no-auth-event" /* NO_AUTH_EVENT */ }`;
}
function $8fd3c2447d7c53c3$var$isRedirectEvent(event) {
    switch(event.type){
        case "signInViaRedirect" /* SIGN_IN_VIA_REDIRECT */ :
        case "linkViaRedirect" /* LINK_VIA_REDIRECT */ :
        case "reauthViaRedirect" /* REAUTH_VIA_REDIRECT */ :
            return true;
        case "unknown" /* UNKNOWN */ :
            return $8fd3c2447d7c53c3$var$isNullRedirectEvent(event);
        default:
            return false;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $8fd3c2447d7c53c3$export$d66dc83d8cfc8dd(auth, request = {}) {
    return $8fd3c2447d7c53c3$var$_performApiRequest(auth, "GET" /* GET */ , "/v1/projects" /* GET_PROJECT_CONFIG */ , request);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $8fd3c2447d7c53c3$var$IP_ADDRESS_REGEX = /^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/;
const $8fd3c2447d7c53c3$var$HTTP_REGEX = /^https?/;
async function $8fd3c2447d7c53c3$var$_validateOrigin(auth) {
    // Skip origin validation if we are in an emulated environment
    if (auth.config.emulator) return;
    const { authorizedDomains: authorizedDomains } = await $8fd3c2447d7c53c3$export$d66dc83d8cfc8dd(auth);
    for (const domain of authorizedDomains)try {
        if ($8fd3c2447d7c53c3$var$matchDomain(domain)) return;
    } catch (_a) {
    // Do nothing if there's a URL error; just continue searching
    }
    // In the old SDK, this error also provides helpful messages.
    $8fd3c2447d7c53c3$export$493d36ec626b6698(auth, "unauthorized-domain" /* INVALID_ORIGIN */ );
}
function $8fd3c2447d7c53c3$var$matchDomain(expected) {
    const currentUrl = $8fd3c2447d7c53c3$var$_getCurrentUrl();
    const { protocol: protocol, hostname: hostname } = new URL(currentUrl);
    if (expected.startsWith("chrome-extension://")) {
        const ceUrl = new URL(expected);
        if (ceUrl.hostname === "" && hostname === "") // For some reason we're not parsing chrome URLs properly
        return protocol === "chrome-extension:" && expected.replace("chrome-extension://", "") === currentUrl.replace("chrome-extension://", "");
        return protocol === "chrome-extension:" && ceUrl.hostname === hostname;
    }
    if (!$8fd3c2447d7c53c3$var$HTTP_REGEX.test(protocol)) return false;
    if ($8fd3c2447d7c53c3$var$IP_ADDRESS_REGEX.test(expected)) // The domain has to be exactly equal to the pattern, as an IP domain will
    // only contain the IP, no extra character.
    return hostname === expected;
    // Dots in pattern should be escaped.
    const escapedDomainPattern = expected.replace(/\./g, "\\.");
    // Non ip address domains.
    // domain.com = *.domain.com OR domain.com
    const re = new RegExp("^(.+\\." + escapedDomainPattern + "|" + escapedDomainPattern + ")$", "i");
    return re.test(hostname);
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $8fd3c2447d7c53c3$var$NETWORK_TIMEOUT = new $8fd3c2447d7c53c3$var$Delay(30000, 60000);
/**
 * Reset unlaoded GApi modules. If gapi.load fails due to a network error,
 * it will stop working after a retrial. This is a hack to fix this issue.
 */ function $8fd3c2447d7c53c3$var$resetUnloadedGapiModules() {
    // Clear last failed gapi.load state to force next gapi.load to first
    // load the failed gapi.iframes module.
    // Get gapix.beacon context.
    const beacon = $8fd3c2447d7c53c3$var$_window().___jsl;
    // Get current hint.
    if (beacon === null || beacon === void 0 ? void 0 : beacon.H) // Get gapi hint.
    for (const hint of Object.keys(beacon.H)){
        // Requested modules.
        beacon.H[hint].r = beacon.H[hint].r || [];
        // Loaded modules.
        beacon.H[hint].L = beacon.H[hint].L || [];
        // Set requested modules to a copy of the loaded modules.
        beacon.H[hint].r = [
            ...beacon.H[hint].L
        ];
        // Clear pending callbacks.
        if (beacon.CP) for(let i = 0; i < beacon.CP.length; i++)// Remove all failed pending callbacks.
        beacon.CP[i] = null;
    }
}
function $8fd3c2447d7c53c3$var$loadGapi(auth) {
    return new Promise((resolve, reject)=>{
        var _a, _b, _c;
        // Function to run when gapi.load is ready.
        function loadGapiIframe() {
            // The developer may have tried to previously run gapi.load and failed.
            // Run this to fix that.
            $8fd3c2447d7c53c3$var$resetUnloadedGapiModules();
            gapi.load("gapi.iframes", {
                callback: ()=>{
                    resolve(gapi.iframes.getContext());
                },
                ontimeout: ()=>{
                    // The above reset may be sufficient, but having this reset after
                    // failure ensures that if the developer calls gapi.load after the
                    // connection is re-established and before another attempt to embed
                    // the iframe, it would work and would not be broken because of our
                    // failed attempt.
                    // Timeout when gapi.iframes.Iframe not loaded.
                    $8fd3c2447d7c53c3$var$resetUnloadedGapiModules();
                    reject($8fd3c2447d7c53c3$export$92108d983e8ee699(auth, "network-request-failed" /* NETWORK_REQUEST_FAILED */ ));
                },
                timeout: $8fd3c2447d7c53c3$var$NETWORK_TIMEOUT.get()
            });
        }
        if ((_b = (_a = $8fd3c2447d7c53c3$var$_window().gapi) === null || _a === void 0 ? void 0 : _a.iframes) === null || _b === void 0 ? void 0 : _b.Iframe) // If gapi.iframes.Iframe available, resolve.
        resolve(gapi.iframes.getContext());
        else if (!!((_c = $8fd3c2447d7c53c3$var$_window().gapi) === null || _c === void 0 ? void 0 : _c.load)) // Gapi loader ready, load gapi.iframes.
        loadGapiIframe();
        else {
            // Create a new iframe callback when this is called so as not to overwrite
            // any previous defined callback. This happens if this method is called
            // multiple times in parallel and could result in the later callback
            // overwriting the previous one. This would end up with a iframe
            // timeout.
            const cbName = $8fd3c2447d7c53c3$var$_generateCallbackName("iframefcb");
            // GApi loader not available, dynamically load platform.js.
            $8fd3c2447d7c53c3$var$_window()[cbName] = ()=>{
                // GApi loader should be ready.
                if (!!gapi.load) loadGapiIframe();
                else // Gapi loader failed, throw error.
                reject($8fd3c2447d7c53c3$export$92108d983e8ee699(auth, "network-request-failed" /* NETWORK_REQUEST_FAILED */ ));
            };
            // Load GApi loader.
            return $8fd3c2447d7c53c3$var$_loadJS(`https://apis.google.com/js/api.js?onload=${cbName}`).catch((e)=>reject(e));
        }
    }).catch((error)=>{
        // Reset cached promise to allow for retrial.
        $8fd3c2447d7c53c3$var$cachedGApiLoader = null;
        throw error;
    });
}
let $8fd3c2447d7c53c3$var$cachedGApiLoader = null;
function $8fd3c2447d7c53c3$var$_loadGapi(auth) {
    $8fd3c2447d7c53c3$var$cachedGApiLoader = $8fd3c2447d7c53c3$var$cachedGApiLoader || $8fd3c2447d7c53c3$var$loadGapi(auth);
    return $8fd3c2447d7c53c3$var$cachedGApiLoader;
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $8fd3c2447d7c53c3$var$PING_TIMEOUT = new $8fd3c2447d7c53c3$var$Delay(5000, 15000);
const $8fd3c2447d7c53c3$var$IFRAME_PATH = "__/auth/iframe";
const $8fd3c2447d7c53c3$var$EMULATED_IFRAME_PATH = "emulator/auth/iframe";
const $8fd3c2447d7c53c3$var$IFRAME_ATTRIBUTES = {
    style: {
        position: "absolute",
        top: "-100px",
        width: "1px",
        height: "1px"
    },
    "aria-hidden": "true",
    tabindex: "-1"
};
// Map from apiHost to endpoint ID for passing into iframe. In current SDK, apiHost can be set to
// anything (not from a list of endpoints with IDs as in legacy), so this is the closest we can get.
const $8fd3c2447d7c53c3$var$EID_FROM_APIHOST = new Map([
    [
        "identitytoolkit.googleapis.com" /* API_HOST */ ,
        "p"
    ],
    [
        "staging-identitytoolkit.sandbox.googleapis.com",
        "s"
    ],
    [
        "test-identitytoolkit.sandbox.googleapis.com",
        "t"
    ] // test
]);
function $8fd3c2447d7c53c3$var$getIframeUrl(auth) {
    const config = auth.config;
    $8fd3c2447d7c53c3$export$9fa96a7d116ea3ce(config.authDomain, auth, "auth-domain-config-required" /* MISSING_AUTH_DOMAIN */ );
    const url = config.emulator ? $8fd3c2447d7c53c3$var$_emulatorUrl(config, $8fd3c2447d7c53c3$var$EMULATED_IFRAME_PATH) : `https://${auth.config.authDomain}/${$8fd3c2447d7c53c3$var$IFRAME_PATH}`;
    const params = {
        apiKey: config.apiKey,
        appName: auth.name,
        v: (0, $iXpG9.SDK_VERSION)
    };
    const eid = $8fd3c2447d7c53c3$var$EID_FROM_APIHOST.get(auth.config.apiHost);
    if (eid) params.eid = eid;
    const frameworks = auth._getFrameworks();
    if (frameworks.length) params.fw = frameworks.join(",");
    return `${url}?${(0, $6vM9o.querystring)(params).slice(1)}`;
}
async function $8fd3c2447d7c53c3$var$_openIframe(auth) {
    const context = await $8fd3c2447d7c53c3$var$_loadGapi(auth);
    const gapi1 = $8fd3c2447d7c53c3$var$_window().gapi;
    $8fd3c2447d7c53c3$export$9fa96a7d116ea3ce(gapi1, auth, "internal-error" /* INTERNAL_ERROR */ );
    return context.open({
        where: document.body,
        url: $8fd3c2447d7c53c3$var$getIframeUrl(auth),
        messageHandlersFilter: gapi1.iframes.CROSS_ORIGIN_IFRAMES_FILTER,
        attributes: $8fd3c2447d7c53c3$var$IFRAME_ATTRIBUTES,
        dontclear: true
    }, (iframe)=>new Promise(async (resolve, reject)=>{
            await iframe.restyle({
                // Prevent iframe from closing on mouse out.
                setHideOnLeave: false
            });
            const networkError = $8fd3c2447d7c53c3$export$92108d983e8ee699(auth, "network-request-failed" /* NETWORK_REQUEST_FAILED */ );
            // Confirm iframe is correctly loaded.
            // To fallback on failure, set a timeout.
            const networkErrorTimer = $8fd3c2447d7c53c3$var$_window().setTimeout(()=>{
                reject(networkError);
            }, $8fd3c2447d7c53c3$var$PING_TIMEOUT.get());
            // Clear timer and resolve pending iframe ready promise.
            function clearTimerAndResolve() {
                $8fd3c2447d7c53c3$var$_window().clearTimeout(networkErrorTimer);
                resolve(iframe);
            }
            // This returns an IThenable. However the reject part does not call
            // when the iframe is not loaded.
            iframe.ping(clearTimerAndResolve).then(clearTimerAndResolve, ()=>{
                reject(networkError);
            });
        }));
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $8fd3c2447d7c53c3$var$BASE_POPUP_OPTIONS = {
    location: "yes",
    resizable: "yes",
    statusbar: "yes",
    toolbar: "no"
};
const $8fd3c2447d7c53c3$var$DEFAULT_WIDTH = 500;
const $8fd3c2447d7c53c3$var$DEFAULT_HEIGHT = 600;
const $8fd3c2447d7c53c3$var$TARGET_BLANK = "_blank";
const $8fd3c2447d7c53c3$var$FIREFOX_EMPTY_URL = "http://localhost";
class $8fd3c2447d7c53c3$export$a05254e7c3aeba6e {
    close() {
        if (this.window) try {
            this.window.close();
        } catch (e) {}
    }
    constructor(window1){
        this.window = window1;
        this.associatedEvent = null;
    }
}
function $8fd3c2447d7c53c3$var$_open(auth, url, name, width = $8fd3c2447d7c53c3$var$DEFAULT_WIDTH, height = $8fd3c2447d7c53c3$var$DEFAULT_HEIGHT) {
    const top = Math.max((window.screen.availHeight - height) / 2, 0).toString();
    const left = Math.max((window.screen.availWidth - width) / 2, 0).toString();
    let target = "";
    const options = Object.assign(Object.assign({}, $8fd3c2447d7c53c3$var$BASE_POPUP_OPTIONS), {
        width: width.toString(),
        height: height.toString(),
        top: top,
        left: left
    });
    // Chrome iOS 7 and 8 is returning an undefined popup win when target is
    // specified, even though the popup is not necessarily blocked.
    const ua = (0, $6vM9o.getUA)().toLowerCase();
    if (name) target = $8fd3c2447d7c53c3$var$_isChromeIOS(ua) ? $8fd3c2447d7c53c3$var$TARGET_BLANK : name;
    if ($8fd3c2447d7c53c3$var$_isFirefox(ua)) {
        // Firefox complains when invalid URLs are popped out. Hacky way to bypass.
        url = url || $8fd3c2447d7c53c3$var$FIREFOX_EMPTY_URL;
        // Firefox disables by default scrolling on popup windows, which can create
        // issues when the user has many Google accounts, for instance.
        options.scrollbars = "yes";
    }
    const optionsString = Object.entries(options).reduce((accum, [key, value])=>`${accum}${key}=${value},`, "");
    if ($8fd3c2447d7c53c3$var$_isIOSStandalone(ua) && target !== "_self") {
        $8fd3c2447d7c53c3$var$openAsNewWindowIOS(url || "", target);
        return new $8fd3c2447d7c53c3$export$a05254e7c3aeba6e(null);
    }
    // about:blank getting sanitized causing browsers like IE/Edge to display
    // brief error message before redirecting to handler.
    const newWin = window.open(url || "", target, optionsString);
    $8fd3c2447d7c53c3$export$9fa96a7d116ea3ce(newWin, auth, "popup-blocked" /* POPUP_BLOCKED */ );
    // Flaky on IE edge, encapsulate with a try and catch.
    try {
        newWin.focus();
    } catch (e) {}
    return new $8fd3c2447d7c53c3$export$a05254e7c3aeba6e(newWin);
}
function $8fd3c2447d7c53c3$var$openAsNewWindowIOS(url, target) {
    const el = document.createElement("a");
    el.href = url;
    el.target = target;
    const click = document.createEvent("MouseEvent");
    click.initMouseEvent("click", true, true, window, 1, 0, 0, 0, 0, false, false, false, false, 1, null);
    el.dispatchEvent(click);
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * URL for Authentication widget which will initiate the OAuth handshake
 *
 * @internal
 */ const $8fd3c2447d7c53c3$var$WIDGET_PATH = "__/auth/handler";
/**
 * URL for emulated environment
 *
 * @internal
 */ const $8fd3c2447d7c53c3$var$EMULATOR_WIDGET_PATH = "emulator/auth/handler";
function $8fd3c2447d7c53c3$export$1fbe638ecf81657e(auth, provider, authType, redirectUrl, eventId, additionalParams) {
    $8fd3c2447d7c53c3$export$9fa96a7d116ea3ce(auth.config.authDomain, auth, "auth-domain-config-required" /* MISSING_AUTH_DOMAIN */ );
    $8fd3c2447d7c53c3$export$9fa96a7d116ea3ce(auth.config.apiKey, auth, "invalid-api-key" /* INVALID_API_KEY */ );
    const params = {
        apiKey: auth.config.apiKey,
        appName: auth.name,
        authType: authType,
        redirectUrl: redirectUrl,
        v: (0, $iXpG9.SDK_VERSION),
        eventId: eventId
    };
    if (provider instanceof $8fd3c2447d7c53c3$var$FederatedAuthProvider) {
        provider.setDefaultLanguage(auth.languageCode);
        params.providerId = provider.providerId || "";
        if (!(0, $6vM9o.isEmpty)(provider.getCustomParameters())) params.customParameters = JSON.stringify(provider.getCustomParameters());
        // TODO set additionalParams from the provider as well?
        for (const [key, value] of Object.entries(additionalParams || {}))params[key] = value;
    }
    if (provider instanceof $8fd3c2447d7c53c3$var$BaseOAuthProvider) {
        const scopes = provider.getScopes().filter((scope)=>scope !== "");
        if (scopes.length > 0) params.scopes = scopes.join(",");
    }
    if (auth.tenantId) params.tid = auth.tenantId;
    // TODO: maybe set eid as endipointId
    // TODO: maybe set fw as Frameworks.join(",")
    const paramsDict = params;
    for (const key of Object.keys(paramsDict))if (paramsDict[key] === undefined) delete paramsDict[key];
    return `${$8fd3c2447d7c53c3$var$getHandlerBase(auth)}?${(0, $6vM9o.querystring)(paramsDict).slice(1)}`;
}
function $8fd3c2447d7c53c3$var$getHandlerBase({ config: config }) {
    if (!config.emulator) return `https://${config.authDomain}/${$8fd3c2447d7c53c3$var$WIDGET_PATH}`;
    return $8fd3c2447d7c53c3$var$_emulatorUrl(config, $8fd3c2447d7c53c3$var$EMULATOR_WIDGET_PATH);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The special web storage event
 *
 */ const $8fd3c2447d7c53c3$var$WEB_STORAGE_SUPPORT_KEY = "webStorageSupport";
class $8fd3c2447d7c53c3$var$BrowserPopupRedirectResolver {
    // Wrapping in async even though we don't await anywhere in order
    // to make sure errors are raised as promise rejections
    async _openPopup(auth, provider, authType, eventId) {
        var _a;
        $8fd3c2447d7c53c3$export$8a5498727ef6be21((_a = this.eventManagers[auth._key()]) === null || _a === void 0 ? void 0 : _a.manager, "_initialize() not called before _openPopup()");
        const url = $8fd3c2447d7c53c3$export$1fbe638ecf81657e(auth, provider, authType, $8fd3c2447d7c53c3$var$_getCurrentUrl(), eventId);
        return $8fd3c2447d7c53c3$var$_open(auth, url, $8fd3c2447d7c53c3$export$b9a6b53f9be3734());
    }
    async _openRedirect(auth, provider, authType, eventId) {
        await this._originValidation(auth);
        $8fd3c2447d7c53c3$var$_setWindowLocation($8fd3c2447d7c53c3$export$1fbe638ecf81657e(auth, provider, authType, $8fd3c2447d7c53c3$var$_getCurrentUrl(), eventId));
        return new Promise(()=>{});
    }
    _initialize(auth) {
        const key = auth._key();
        if (this.eventManagers[key]) {
            const { manager: manager, promise: promise } = this.eventManagers[key];
            if (manager) return Promise.resolve(manager);
            else {
                $8fd3c2447d7c53c3$export$8a5498727ef6be21(promise, "If manager is not set, promise should be");
                return promise;
            }
        }
        const promise = this.initAndGetManager(auth);
        this.eventManagers[key] = {
            promise: promise
        };
        // If the promise is rejected, the key should be removed so that the
        // operation can be retried later.
        promise.catch(()=>{
            delete this.eventManagers[key];
        });
        return promise;
    }
    async initAndGetManager(auth) {
        const iframe = await $8fd3c2447d7c53c3$var$_openIframe(auth);
        const manager = new $8fd3c2447d7c53c3$export$91c6e00c14e7e6fd(auth);
        iframe.register("authEvent", (iframeEvent)=>{
            $8fd3c2447d7c53c3$export$9fa96a7d116ea3ce(iframeEvent === null || iframeEvent === void 0 ? void 0 : iframeEvent.authEvent, auth, "invalid-auth-event" /* INVALID_AUTH_EVENT */ );
            // TODO: Consider splitting redirect and popup events earlier on
            const handled = manager.onEvent(iframeEvent.authEvent);
            return {
                status: handled ? "ACK" /* ACK */  : "ERROR" /* ERROR */ 
            };
        }, gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER);
        this.eventManagers[auth._key()] = {
            manager: manager
        };
        this.iframes[auth._key()] = iframe;
        return manager;
    }
    _isIframeWebStorageSupported(auth, cb) {
        const iframe = this.iframes[auth._key()];
        iframe.send($8fd3c2447d7c53c3$var$WEB_STORAGE_SUPPORT_KEY, {
            type: $8fd3c2447d7c53c3$var$WEB_STORAGE_SUPPORT_KEY
        }, (result)=>{
            var _a;
            const isSupported = (_a = result === null || result === void 0 ? void 0 : result[0]) === null || _a === void 0 ? void 0 : _a[$8fd3c2447d7c53c3$var$WEB_STORAGE_SUPPORT_KEY];
            if (isSupported !== undefined) cb(!!isSupported);
            $8fd3c2447d7c53c3$export$493d36ec626b6698(auth, "internal-error" /* INTERNAL_ERROR */ );
        }, gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER);
    }
    _originValidation(auth) {
        const key = auth._key();
        if (!this.originValidationPromises[key]) this.originValidationPromises[key] = $8fd3c2447d7c53c3$var$_validateOrigin(auth);
        return this.originValidationPromises[key];
    }
    get _shouldInitProactively() {
        // Mobile browsers and Safari need to optimistically initialize
        return $8fd3c2447d7c53c3$var$_isMobileBrowser() || $8fd3c2447d7c53c3$var$_isSafari() || $8fd3c2447d7c53c3$export$d24c54395ce0c509();
    }
    constructor(){
        this.eventManagers = {};
        this.iframes = {};
        this.originValidationPromises = {};
        this._redirectPersistence = $8fd3c2447d7c53c3$export$407448d2b89b1813;
        this._completeRedirectFn = $8fd3c2447d7c53c3$export$9d398bebfec1c039;
        this._overrideRedirectResult = $8fd3c2447d7c53c3$export$890c4ad488842ce7;
    }
}
/**
 * An implementation of {@link PopupRedirectResolver} suitable for browser
 * based applications.
 *
 * @public
 */ const $8fd3c2447d7c53c3$export$342063e11d6c3cad = $8fd3c2447d7c53c3$var$BrowserPopupRedirectResolver;
class $8fd3c2447d7c53c3$var$MultiFactorAssertionImpl {
    _process(auth, session, displayName) {
        switch(session.type){
            case "enroll" /* ENROLL */ :
                return this._finalizeEnroll(auth, session.credential, displayName);
            case "signin" /* SIGN_IN */ :
                return this._finalizeSignIn(auth, session.credential);
            default:
                return $8fd3c2447d7c53c3$var$debugFail("unexpected MultiFactorSessionType");
        }
    }
    constructor(factorId){
        this.factorId = factorId;
    }
}
/**
 * {@inheritdoc PhoneMultiFactorAssertion}
 *
 * @public
 */ class $8fd3c2447d7c53c3$var$PhoneMultiFactorAssertionImpl extends $8fd3c2447d7c53c3$var$MultiFactorAssertionImpl {
    /** @internal */ static _fromCredential(credential) {
        return new $8fd3c2447d7c53c3$var$PhoneMultiFactorAssertionImpl(credential);
    }
    /** @internal */ _finalizeEnroll(auth, idToken, displayName) {
        return $8fd3c2447d7c53c3$var$finalizeEnrollPhoneMfa(auth, {
            idToken: idToken,
            displayName: displayName,
            phoneVerificationInfo: this.credential._makeVerificationRequest()
        });
    }
    /** @internal */ _finalizeSignIn(auth, mfaPendingCredential) {
        return $8fd3c2447d7c53c3$var$finalizeSignInPhoneMfa(auth, {
            mfaPendingCredential: mfaPendingCredential,
            phoneVerificationInfo: this.credential._makeVerificationRequest()
        });
    }
    constructor(credential){
        super("phone" /* PHONE */ );
        this.credential = credential;
    }
}
/**
 * Provider for generating a {@link PhoneMultiFactorAssertion}.
 *
 * @public
 */ class $8fd3c2447d7c53c3$export$953cecd6e717a553 {
    /**
     * Provides a {@link PhoneMultiFactorAssertion} to confirm ownership of the phone second factor.
     *
     * @param phoneAuthCredential - A credential provided by {@link PhoneAuthProvider.credential}.
     * @returns A {@link PhoneMultiFactorAssertion} which can be used with
     * {@link MultiFactorResolver.resolveSignIn}
     */ static assertion(credential) {
        return $8fd3c2447d7c53c3$var$PhoneMultiFactorAssertionImpl._fromCredential(credential);
    }
    constructor(){}
}
/**
 * The identifier of the phone second factor: `phone`.
 */ $8fd3c2447d7c53c3$export$953cecd6e717a553.FACTOR_ID = "phone";
var $8fd3c2447d7c53c3$var$name = "@firebase/auth";
var $8fd3c2447d7c53c3$var$version = "0.20.3";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $8fd3c2447d7c53c3$var$AuthInterop {
    getUid() {
        var _a;
        this.assertAuthConfigured();
        return ((_a = this.auth.currentUser) === null || _a === void 0 ? void 0 : _a.uid) || null;
    }
    async getToken(forceRefresh) {
        this.assertAuthConfigured();
        await this.auth._initializationPromise;
        if (!this.auth.currentUser) return null;
        const accessToken = await this.auth.currentUser.getIdToken(forceRefresh);
        return {
            accessToken: accessToken
        };
    }
    addAuthTokenListener(listener) {
        this.assertAuthConfigured();
        if (this.internalListeners.has(listener)) return;
        const unsubscribe = this.auth.onIdTokenChanged((user)=>{
            var _a;
            listener(((_a = user) === null || _a === void 0 ? void 0 : _a.stsTokenManager.accessToken) || null);
        });
        this.internalListeners.set(listener, unsubscribe);
        this.updateProactiveRefresh();
    }
    removeAuthTokenListener(listener) {
        this.assertAuthConfigured();
        const unsubscribe = this.internalListeners.get(listener);
        if (!unsubscribe) return;
        this.internalListeners.delete(listener);
        unsubscribe();
        this.updateProactiveRefresh();
    }
    assertAuthConfigured() {
        $8fd3c2447d7c53c3$export$9fa96a7d116ea3ce(this.auth._initializationPromise, "dependent-sdk-initialized-before-auth" /* DEPENDENT_SDK_INIT_BEFORE_AUTH */ );
    }
    updateProactiveRefresh() {
        if (this.internalListeners.size > 0) this.auth._startProactiveRefresh();
        else this.auth._stopProactiveRefresh();
    }
    constructor(auth){
        this.auth = auth;
        this.internalListeners = new Map();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $8fd3c2447d7c53c3$var$getVersionForPlatform(clientPlatform) {
    switch(clientPlatform){
        case "Node" /* NODE */ :
            return "node";
        case "ReactNative" /* REACT_NATIVE */ :
            return "rn";
        case "Worker" /* WORKER */ :
            return "webworker";
        case "Cordova" /* CORDOVA */ :
            return "cordova";
        default:
            return undefined;
    }
}
/** @internal */ function $8fd3c2447d7c53c3$var$registerAuth(clientPlatform) {
    (0, $iXpG9._registerComponent)(new (0, $kOJH8.Component)("auth" /* AUTH */ , (container, { options: deps })=>{
        const app = container.getProvider("app").getImmediate();
        const heartbeatServiceProvider = container.getProvider("heartbeat");
        const { apiKey: apiKey, authDomain: authDomain } = app.options;
        return ((app, heartbeatServiceProvider)=>{
            $8fd3c2447d7c53c3$export$9fa96a7d116ea3ce(apiKey && !apiKey.includes(":"), "invalid-api-key" /* INVALID_API_KEY */ , {
                appName: app.name
            });
            // Auth domain is optional if IdP sign in isn't being used
            $8fd3c2447d7c53c3$export$9fa96a7d116ea3ce(!(authDomain === null || authDomain === void 0 ? void 0 : authDomain.includes(":")), "argument-error" /* ARGUMENT_ERROR */ , {
                appName: app.name
            });
            const config = {
                apiKey: apiKey,
                authDomain: authDomain,
                clientPlatform: clientPlatform,
                apiHost: "identitytoolkit.googleapis.com" /* API_HOST */ ,
                tokenApiHost: "securetoken.googleapis.com" /* TOKEN_API_HOST */ ,
                apiScheme: "https" /* API_SCHEME */ ,
                sdkClientVersion: $8fd3c2447d7c53c3$export$a33b77bbdbb8366c(clientPlatform)
            };
            const authInstance = new $8fd3c2447d7c53c3$export$53a70dd1ebbae346(app, heartbeatServiceProvider, config);
            $8fd3c2447d7c53c3$var$_initializeAuthInstance(authInstance, deps);
            return authInstance;
        })(app, heartbeatServiceProvider);
    }, "PUBLIC" /* PUBLIC */ )/**
         * Auth can only be initialized by explicitly calling getAuth() or initializeAuth()
         * For why we do this, See go/firebase-next-auth-init
         */ .setInstantiationMode("EXPLICIT" /* EXPLICIT */ )/**
         * Because all firebase products that depend on auth depend on auth-internal directly,
         * we need to initialize auth-internal after auth is initialized to make it available to other firebase products.
         */ .setInstanceCreatedCallback((container, _instanceIdentifier, _instance)=>{
        const authInternalProvider = container.getProvider("auth-internal" /* AUTH_INTERNAL */ );
        authInternalProvider.initialize();
    }));
    (0, $iXpG9._registerComponent)(new (0, $kOJH8.Component)("auth-internal" /* AUTH_INTERNAL */ , (container)=>{
        const auth = $8fd3c2447d7c53c3$export$158acd800e1ef08b(container.getProvider("auth" /* AUTH */ ).getImmediate());
        return ((auth)=>new $8fd3c2447d7c53c3$var$AuthInterop(auth))(auth);
    }, "PRIVATE" /* PRIVATE */ ).setInstantiationMode("EXPLICIT" /* EXPLICIT */ ));
    (0, $iXpG9.registerVersion)($8fd3c2447d7c53c3$var$name, $8fd3c2447d7c53c3$var$version, $8fd3c2447d7c53c3$var$getVersionForPlatform(clientPlatform));
    // BUILD_TARGET will be replaced by values like esm5, esm2017, cjs5, etc during the compilation
    (0, $iXpG9.registerVersion)($8fd3c2447d7c53c3$var$name, $8fd3c2447d7c53c3$var$version, "esm2017");
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns the Auth instance associated with the provided {@link @firebase/app#FirebaseApp}.
 * If no instance exists, initializes an Auth instance with platform-specific default dependencies.
 *
 * @param app - The Firebase App.
 *
 * @public
 */ function $8fd3c2447d7c53c3$export$7ccc53e8f1e7dfc5(app = (0, $iXpG9.getApp)()) {
    const provider = (0, $iXpG9._getProvider)(app, "auth");
    if (provider.isInitialized()) return provider.getImmediate();
    return $8fd3c2447d7c53c3$export$a9c23c6ac3fc3eca(app, {
        popupRedirectResolver: $8fd3c2447d7c53c3$export$342063e11d6c3cad,
        persistence: [
            $8fd3c2447d7c53c3$export$23f2a1d2818174ef,
            $8fd3c2447d7c53c3$export$8b22cf2602fb60ce,
            $8fd3c2447d7c53c3$export$407448d2b89b1813
        ]
    });
}
$8fd3c2447d7c53c3$var$registerAuth("Browser" /* BROWSER */ );

});
parcelRegister("6vM9o", function(module, exports) {

$parcel$export(module.exports, "base64Decode", function () { return $4bdafd014543a1dc$export$c62426fdd000a97e; });
$parcel$export(module.exports, "Deferred", function () { return $4bdafd014543a1dc$export$85f6557964517f1a; });
$parcel$export(module.exports, "getUA", function () { return $4bdafd014543a1dc$export$c36915b22ce77c19; });
$parcel$export(module.exports, "isMobileCordova", function () { return $4bdafd014543a1dc$export$872f8323f01d7ae0; });
$parcel$export(module.exports, "isBrowserExtension", function () { return $4bdafd014543a1dc$export$caa8774a9107a58e; });
$parcel$export(module.exports, "isReactNative", function () { return $4bdafd014543a1dc$export$f7a1e23e542d38e3; });
$parcel$export(module.exports, "isIE", function () { return $4bdafd014543a1dc$export$7e7b1a9668aaed8; });
$parcel$export(module.exports, "FirebaseError", function () { return $4bdafd014543a1dc$export$dd24e9cd51226c56; });
$parcel$export(module.exports, "ErrorFactory", function () { return $4bdafd014543a1dc$export$3fa6e1b18a3b2d40; });
$parcel$export(module.exports, "isEmpty", function () { return $4bdafd014543a1dc$export$dd1bc94b04021eeb; });
$parcel$export(module.exports, "deepEqual", function () { return $4bdafd014543a1dc$export$9cb4719e2e525b7a; });
$parcel$export(module.exports, "querystring", function () { return $4bdafd014543a1dc$export$ac4103b836844853; });
$parcel$export(module.exports, "querystringDecode", function () { return $4bdafd014543a1dc$export$c1271ca4c8a70741; });
$parcel$export(module.exports, "extractQuerystring", function () { return $4bdafd014543a1dc$export$1a8408415472d8ed; });
$parcel$export(module.exports, "createSubscribe", function () { return $4bdafd014543a1dc$export$364097d812234b3f; });
$parcel$export(module.exports, "getModularInstance", function () { return $4bdafd014543a1dc$export$4befe9b5fa509a1b; });
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Firebase constants.  Some of these (@defines) can be overridden at compile-time.
 */ const $4bdafd014543a1dc$export$588c7fdda06fbb0a = {
    /**
     * @define {boolean} Whether this is the client Node.js SDK.
     */ NODE_CLIENT: false,
    /**
     * @define {boolean} Whether this is the Admin Node.js SDK.
     */ NODE_ADMIN: false,
    /**
     * Firebase SDK Version
     */ SDK_VERSION: "${JSCORE_VERSION}"
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Throws an error if the provided assertion is falsy
 */ const $4bdafd014543a1dc$export$a7a9523472993e97 = function(assertion, message) {
    if (!assertion) throw $4bdafd014543a1dc$export$a39cad550e7ab28a(message);
};
/**
 * Returns an Error object suitable for throwing.
 */ const $4bdafd014543a1dc$export$a39cad550e7ab28a = function(message) {
    return new Error("Firebase Database (" + $4bdafd014543a1dc$export$588c7fdda06fbb0a.SDK_VERSION + ") INTERNAL ASSERT FAILED: " + message);
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $4bdafd014543a1dc$var$stringToByteArray$1 = function(str) {
    // TODO(user): Use native implementations if/when available
    const out = [];
    let p = 0;
    for(let i = 0; i < str.length; i++){
        let c = str.charCodeAt(i);
        if (c < 128) out[p++] = c;
        else if (c < 2048) {
            out[p++] = c >> 6 | 192;
            out[p++] = c & 63 | 128;
        } else if ((c & 0xfc00) === 0xd800 && i + 1 < str.length && (str.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
            // Surrogate Pair
            c = 0x10000 + ((c & 0x03ff) << 10) + (str.charCodeAt(++i) & 0x03ff);
            out[p++] = c >> 18 | 240;
            out[p++] = c >> 12 & 63 | 128;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        } else {
            out[p++] = c >> 12 | 224;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        }
    }
    return out;
};
/**
 * Turns an array of numbers into the string given by the concatenation of the
 * characters to which the numbers correspond.
 * @param bytes Array of numbers representing characters.
 * @return Stringification of the array.
 */ const $4bdafd014543a1dc$var$byteArrayToString = function(bytes) {
    // TODO(user): Use native implementations if/when available
    const out = [];
    let pos = 0, c = 0;
    while(pos < bytes.length){
        const c1 = bytes[pos++];
        if (c1 < 128) out[c++] = String.fromCharCode(c1);
        else if (c1 > 191 && c1 < 224) {
            const c2 = bytes[pos++];
            out[c++] = String.fromCharCode((c1 & 31) << 6 | c2 & 63);
        } else if (c1 > 239 && c1 < 365) {
            // Surrogate Pair
            const c2 = bytes[pos++];
            const c3 = bytes[pos++];
            const c4 = bytes[pos++];
            const u = ((c1 & 7) << 18 | (c2 & 63) << 12 | (c3 & 63) << 6 | c4 & 63) - 0x10000;
            out[c++] = String.fromCharCode(0xd800 + (u >> 10));
            out[c++] = String.fromCharCode(0xdc00 + (u & 1023));
        } else {
            const c2 = bytes[pos++];
            const c3 = bytes[pos++];
            out[c++] = String.fromCharCode((c1 & 15) << 12 | (c2 & 63) << 6 | c3 & 63);
        }
    }
    return out.join("");
};
// We define it as an object literal instead of a class because a class compiled down to es5 can't
// be treeshaked. https://github.com/rollup/rollup/issues/1691
// Static lookup maps, lazily populated by init_()
const $4bdafd014543a1dc$export$b3b2de96497acc47 = {
    /**
     * Maps bytes to characters.
     */ byteToCharMap_: null,
    /**
     * Maps characters to bytes.
     */ charToByteMap_: null,
    /**
     * Maps bytes to websafe characters.
     * @private
     */ byteToCharMapWebSafe_: null,
    /**
     * Maps websafe characters to bytes.
     * @private
     */ charToByteMapWebSafe_: null,
    /**
     * Our default alphabet, shared between
     * ENCODED_VALS and ENCODED_VALS_WEBSAFE
     */ ENCODED_VALS_BASE: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789",
    /**
     * Our default alphabet. Value 64 (=) is special; it means "nothing."
     */ get ENCODED_VALS () {
        return this.ENCODED_VALS_BASE + "+/=";
    },
    /**
     * Our websafe alphabet.
     */ get ENCODED_VALS_WEBSAFE () {
        return this.ENCODED_VALS_BASE + "-_.";
    },
    /**
     * Whether this browser supports the atob and btoa functions. This extension
     * started at Mozilla but is now implemented by many browsers. We use the
     * ASSUME_* variables to avoid pulling in the full useragent detection library
     * but still allowing the standard per-browser compilations.
     *
     */ HAS_NATIVE_SUPPORT: typeof atob === "function",
    /**
     * Base64-encode an array of bytes.
     *
     * @param input An array of bytes (numbers with
     *     value in [0, 255]) to encode.
     * @param webSafe Boolean indicating we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */ encodeByteArray (input, webSafe) {
        if (!Array.isArray(input)) throw Error("encodeByteArray takes an array as a parameter");
        this.init_();
        const byteToCharMap = webSafe ? this.byteToCharMapWebSafe_ : this.byteToCharMap_;
        const output = [];
        for(let i = 0; i < input.length; i += 3){
            const byte1 = input[i];
            const haveByte2 = i + 1 < input.length;
            const byte2 = haveByte2 ? input[i + 1] : 0;
            const haveByte3 = i + 2 < input.length;
            const byte3 = haveByte3 ? input[i + 2] : 0;
            const outByte1 = byte1 >> 2;
            const outByte2 = (byte1 & 0x03) << 4 | byte2 >> 4;
            let outByte3 = (byte2 & 0x0f) << 2 | byte3 >> 6;
            let outByte4 = byte3 & 0x3f;
            if (!haveByte3) {
                outByte4 = 64;
                if (!haveByte2) outByte3 = 64;
            }
            output.push(byteToCharMap[outByte1], byteToCharMap[outByte2], byteToCharMap[outByte3], byteToCharMap[outByte4]);
        }
        return output.join("");
    },
    /**
     * Base64-encode a string.
     *
     * @param input A string to encode.
     * @param webSafe If true, we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */ encodeString (input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) return btoa(input);
        return this.encodeByteArray($4bdafd014543a1dc$var$stringToByteArray$1(input), webSafe);
    },
    /**
     * Base64-decode a string.
     *
     * @param input to decode.
     * @param webSafe True if we should use the
     *     alternative alphabet.
     * @return string representing the decoded value.
     */ decodeString (input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) return atob(input);
        return $4bdafd014543a1dc$var$byteArrayToString(this.decodeStringToByteArray(input, webSafe));
    },
    /**
     * Base64-decode a string.
     *
     * In base-64 decoding, groups of four characters are converted into three
     * bytes.  If the encoder did not apply padding, the input length may not
     * be a multiple of 4.
     *
     * In this case, the last group will have fewer than 4 characters, and
     * padding will be inferred.  If the group has one or two characters, it decodes
     * to one byte.  If the group has three characters, it decodes to two bytes.
     *
     * @param input Input to decode.
     * @param webSafe True if we should use the web-safe alphabet.
     * @return bytes representing the decoded value.
     */ decodeStringToByteArray (input, webSafe) {
        this.init_();
        const charToByteMap = webSafe ? this.charToByteMapWebSafe_ : this.charToByteMap_;
        const output = [];
        for(let i = 0; i < input.length;){
            const byte1 = charToByteMap[input.charAt(i++)];
            const haveByte2 = i < input.length;
            const byte2 = haveByte2 ? charToByteMap[input.charAt(i)] : 0;
            ++i;
            const haveByte3 = i < input.length;
            const byte3 = haveByte3 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            const haveByte4 = i < input.length;
            const byte4 = haveByte4 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            if (byte1 == null || byte2 == null || byte3 == null || byte4 == null) throw Error();
            const outByte1 = byte1 << 2 | byte2 >> 4;
            output.push(outByte1);
            if (byte3 !== 64) {
                const outByte2 = byte2 << 4 & 0xf0 | byte3 >> 2;
                output.push(outByte2);
                if (byte4 !== 64) {
                    const outByte3 = byte3 << 6 & 0xc0 | byte4;
                    output.push(outByte3);
                }
            }
        }
        return output;
    },
    /**
     * Lazy static initialization function. Called before
     * accessing any of the static map variables.
     * @private
     */ init_ () {
        if (!this.byteToCharMap_) {
            this.byteToCharMap_ = {};
            this.charToByteMap_ = {};
            this.byteToCharMapWebSafe_ = {};
            this.charToByteMapWebSafe_ = {};
            // We want quick mappings back and forth, so we precompute two maps.
            for(let i = 0; i < this.ENCODED_VALS.length; i++){
                this.byteToCharMap_[i] = this.ENCODED_VALS.charAt(i);
                this.charToByteMap_[this.byteToCharMap_[i]] = i;
                this.byteToCharMapWebSafe_[i] = this.ENCODED_VALS_WEBSAFE.charAt(i);
                this.charToByteMapWebSafe_[this.byteToCharMapWebSafe_[i]] = i;
                // Be forgiving when decoding and correctly decode both encodings.
                if (i >= this.ENCODED_VALS_BASE.length) {
                    this.charToByteMap_[this.ENCODED_VALS_WEBSAFE.charAt(i)] = i;
                    this.charToByteMapWebSafe_[this.ENCODED_VALS.charAt(i)] = i;
                }
            }
        }
    }
};
/**
 * URL-safe base64 encoding
 */ const $4bdafd014543a1dc$export$e510a73ee562749 = function(str) {
    const utf8Bytes = $4bdafd014543a1dc$var$stringToByteArray$1(str);
    return $4bdafd014543a1dc$export$b3b2de96497acc47.encodeByteArray(utf8Bytes, true);
};
/**
 * URL-safe base64 encoding (without "." padding in the end).
 * e.g. Used in JSON Web Token (JWT) parts.
 */ const $4bdafd014543a1dc$export$4b5284a3025a455 = function(str) {
    // Use base64url encoding and remove padding in the end (dot characters).
    return $4bdafd014543a1dc$export$e510a73ee562749(str).replace(/\./g, "");
};
/**
 * URL-safe base64 decoding
 *
 * NOTE: DO NOT use the global atob() function - it does NOT support the
 * base64Url variant encoding.
 *
 * @param str To be decoded
 * @return Decoded result, if possible
 */ const $4bdafd014543a1dc$export$c62426fdd000a97e = function(str) {
    try {
        return $4bdafd014543a1dc$export$b3b2de96497acc47.decodeString(str, true);
    } catch (e) {
        console.error("base64Decode failed: ", e);
    }
    return null;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Do a deep-copy of basic JavaScript Objects or Arrays.
 */ function $4bdafd014543a1dc$export$6c40052bed430212(value) {
    return $4bdafd014543a1dc$export$54e9fb29908872fa(undefined, value);
}
/**
 * Copy properties from source to target (recursively allows extension
 * of Objects and Arrays).  Scalar values in the target are over-written.
 * If target is undefined, an object of the appropriate type will be created
 * (and returned).
 *
 * We recursively copy all child properties of plain Objects in the source- so
 * that namespace- like dictionaries are merged.
 *
 * Note that the target can be a function, in which case the properties in
 * the source Object are copied onto it as static properties of the Function.
 *
 * Note: we don't merge __proto__ to prevent prototype pollution
 */ function $4bdafd014543a1dc$export$54e9fb29908872fa(target, source) {
    if (!(source instanceof Object)) return source;
    switch(source.constructor){
        case Date:
            // Treat Dates like scalars; if the target date object had any child
            // properties - they will be lost!
            const dateValue = source;
            return new Date(dateValue.getTime());
        case Object:
            if (target === undefined) target = {};
            break;
        case Array:
            // Always copy the array source and overwrite the target.
            target = [];
            break;
        default:
            // Not a plain Object - treat it as a scalar.
            return source;
    }
    for(const prop in source){
        // use isValidKey to guard against prototype pollution. See https://snyk.io/vuln/SNYK-JS-LODASH-450202
        if (!source.hasOwnProperty(prop) || !$4bdafd014543a1dc$var$isValidKey(prop)) continue;
        target[prop] = $4bdafd014543a1dc$export$54e9fb29908872fa(target[prop], source[prop]);
    }
    return target;
}
function $4bdafd014543a1dc$var$isValidKey(key) {
    return key !== "__proto__";
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $4bdafd014543a1dc$export$85f6557964517f1a {
    /**
     * Our API internals are not promiseified and cannot because our callback APIs have subtle expectations around
     * invoking promises inline, which Promises are forbidden to do. This method accepts an optional node-style callback
     * and returns a node-style callback which will resolve or reject the Deferred's promise.
     */ wrapCallback(callback) {
        return (error, value)=>{
            if (error) this.reject(error);
            else this.resolve(value);
            if (typeof callback === "function") {
                // Attaching noop handler just in case developer wasn't expecting
                // promises
                this.promise.catch(()=>{});
                // Some of our callbacks don't expect a value and our own tests
                // assert that the parameter length is 1
                if (callback.length === 1) callback(error);
                else callback(error, value);
            }
        };
    }
    constructor(){
        this.reject = ()=>{};
        this.resolve = ()=>{};
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
    }
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $4bdafd014543a1dc$export$367bf224123348f1(token, projectId) {
    if (token.uid) throw new Error('The "uid" field is no longer supported by mockUserToken. Please use "sub" instead for Firebase Auth User ID.');
    // Unsecured JWTs use "none" as the algorithm.
    const header = {
        alg: "none",
        type: "JWT"
    };
    const project = projectId || "demo-project";
    const iat = token.iat || 0;
    const sub = token.sub || token.user_id;
    if (!sub) throw new Error("mockUserToken must contain 'sub' or 'user_id' field!");
    const payload = Object.assign({
        // Set all required fields to decent defaults
        iss: `https://securetoken.google.com/${project}`,
        aud: project,
        iat: iat,
        exp: iat + 3600,
        auth_time: iat,
        sub: sub,
        user_id: sub,
        firebase: {
            sign_in_provider: "custom",
            identities: {}
        }
    }, token);
    // Unsecured JWTs use the empty string as a signature.
    const signature = "";
    return [
        $4bdafd014543a1dc$export$4b5284a3025a455(JSON.stringify(header)),
        $4bdafd014543a1dc$export$4b5284a3025a455(JSON.stringify(payload)),
        signature
    ].join(".");
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns navigator.userAgent string or '' if it's not defined.
 * @return user agent string
 */ function $4bdafd014543a1dc$export$c36915b22ce77c19() {
    if (typeof navigator !== "undefined" && typeof navigator["userAgent"] === "string") return navigator["userAgent"];
    else return "";
}
/**
 * Detect Cordova / PhoneGap / Ionic frameworks on a mobile device.
 *
 * Deliberately does not rely on checking `file://` URLs (as this fails PhoneGap
 * in the Ripple emulator) nor Cordova `onDeviceReady`, which would normally
 * wait for a callback.
 */ function $4bdafd014543a1dc$export$872f8323f01d7ae0() {
    return typeof window !== "undefined" && // @ts-ignore Setting up an broadly applicable index signature for Window
    // just to deal with this case would probably be a bad idea.
    !!(window["cordova"] || window["phonegap"] || window["PhoneGap"]) && /ios|iphone|ipod|ipad|android|blackberry|iemobile/i.test($4bdafd014543a1dc$export$c36915b22ce77c19());
}
/**
 * Detect Node.js.
 *
 * @return true if Node.js environment is detected.
 */ // Node detection logic from: https://github.com/iliakan/detect-node/
function $4bdafd014543a1dc$export$8ee0fc9ee280b4ee() {
    try {
        return Object.prototype.toString.call($parcel$global.process) === "[object process]";
    } catch (e) {
        return false;
    }
}
/**
 * Detect Browser Environment
 */ function $4bdafd014543a1dc$export$4e09c449d6c407f7() {
    return typeof self === "object" && self.self === self;
}
function $4bdafd014543a1dc$export$caa8774a9107a58e() {
    const runtime = typeof chrome === "object" ? chrome.runtime : typeof browser === "object" ? browser.runtime : undefined;
    return typeof runtime === "object" && runtime.id !== undefined;
}
/**
 * Detect React Native.
 *
 * @return true if ReactNative environment is detected.
 */ function $4bdafd014543a1dc$export$f7a1e23e542d38e3() {
    return typeof navigator === "object" && navigator["product"] === "ReactNative";
}
/** Detects Electron apps. */ function $4bdafd014543a1dc$export$f2f6a8999f8ebd30() {
    return $4bdafd014543a1dc$export$c36915b22ce77c19().indexOf("Electron/") >= 0;
}
/** Detects Internet Explorer. */ function $4bdafd014543a1dc$export$7e7b1a9668aaed8() {
    const ua = $4bdafd014543a1dc$export$c36915b22ce77c19();
    return ua.indexOf("MSIE ") >= 0 || ua.indexOf("Trident/") >= 0;
}
/** Detects Universal Windows Platform apps. */ function $4bdafd014543a1dc$export$202944b2d2824246() {
    return $4bdafd014543a1dc$export$c36915b22ce77c19().indexOf("MSAppHost/") >= 0;
}
/**
 * Detect whether the current SDK build is the Node version.
 *
 * @return true if it's the Node SDK build.
 */ function $4bdafd014543a1dc$export$5d1d834fbbf8bab7() {
    return $4bdafd014543a1dc$export$588c7fdda06fbb0a.NODE_CLIENT === true || $4bdafd014543a1dc$export$588c7fdda06fbb0a.NODE_ADMIN === true;
}
/** Returns true if we are running in Safari. */ function $4bdafd014543a1dc$export$95df08bae54cb4df() {
    return !$4bdafd014543a1dc$export$8ee0fc9ee280b4ee() && navigator.userAgent.includes("Safari") && !navigator.userAgent.includes("Chrome");
}
/**
 * This method checks if indexedDB is supported by current browser/service worker context
 * @return true if indexedDB is supported by current browser/service worker context
 */ function $4bdafd014543a1dc$export$3865db50535c2055() {
    return typeof indexedDB === "object";
}
/**
 * This method validates browser/sw context for indexedDB by opening a dummy indexedDB database and reject
 * if errors occur during the database open operation.
 *
 * @throws exception if current browser/sw context can't run idb.open (ex: Safari iframe, Firefox
 * private browsing)
 */ function $4bdafd014543a1dc$export$a8a3018f3d187a4d() {
    return new Promise((resolve, reject)=>{
        try {
            let preExist = true;
            const DB_CHECK_NAME = "validate-browser-context-for-indexeddb-analytics-module";
            const request = self.indexedDB.open(DB_CHECK_NAME);
            request.onsuccess = ()=>{
                request.result.close();
                // delete database only when it doesn't pre-exist
                if (!preExist) self.indexedDB.deleteDatabase(DB_CHECK_NAME);
                resolve(true);
            };
            request.onupgradeneeded = ()=>{
                preExist = false;
            };
            request.onerror = ()=>{
                var _a;
                reject(((_a = request.error) === null || _a === void 0 ? void 0 : _a.message) || "");
            };
        } catch (error) {
            reject(error);
        }
    });
}
/**
 *
 * This method checks whether cookie is enabled within current browser
 * @return true if cookie is enabled within current browser
 */ function $4bdafd014543a1dc$export$f172b7eb6cf60599() {
    if (typeof navigator === "undefined" || !navigator.cookieEnabled) return false;
    return true;
}
/**
 * Polyfill for `globalThis` object.
 * @returns the `globalThis` object for the given environment.
 */ function $4bdafd014543a1dc$export$a4e55266d2135a7f() {
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw new Error("Unable to locate global object.");
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Standardized Firebase Error.
 *
 * Usage:
 *
 *   // Typescript string literals for type-safe codes
 *   type Err =
 *     'unknown' |
 *     'object-not-found'
 *     ;
 *
 *   // Closure enum for type-safe error codes
 *   // at-enum {string}
 *   var Err = {
 *     UNKNOWN: 'unknown',
 *     OBJECT_NOT_FOUND: 'object-not-found',
 *   }
 *
 *   let errors: Map<Err, string> = {
 *     'generic-error': "Unknown error",
 *     'file-not-found': "Could not find file: {$file}",
 *   };
 *
 *   // Type-safe function - must pass a valid error code as param.
 *   let error = new ErrorFactory<Err>('service', 'Service', errors);
 *
 *   ...
 *   throw error.create(Err.GENERIC);
 *   ...
 *   throw error.create(Err.FILE_NOT_FOUND, {'file': fileName});
 *   ...
 *   // Service: Could not file file: foo.txt (service/file-not-found).
 *
 *   catch (e) {
 *     assert(e.message === "Could not find file: foo.txt.");
 *     if (e.code === 'service/file-not-found') {
 *       console.log("Could not read file: " + e['file']);
 *     }
 *   }
 */ const $4bdafd014543a1dc$var$ERROR_NAME = "FirebaseError";
// Based on code from:
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Custom_Error_Types
class $4bdafd014543a1dc$export$dd24e9cd51226c56 extends Error {
    constructor(/** The error code for this error. */ code, message, /** Custom data for this error. */ customData){
        super(message);
        this.code = code;
        this.customData = customData;
        /** The custom name for all FirebaseErrors. */ this.name = $4bdafd014543a1dc$var$ERROR_NAME;
        // Fix For ES5
        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $4bdafd014543a1dc$export$dd24e9cd51226c56.prototype);
        // Maintains proper stack trace for where our error was thrown.
        // Only available on V8.
        if (Error.captureStackTrace) Error.captureStackTrace(this, $4bdafd014543a1dc$export$3fa6e1b18a3b2d40.prototype.create);
    }
}
class $4bdafd014543a1dc$export$3fa6e1b18a3b2d40 {
    create(code, ...data) {
        const customData = data[0] || {};
        const fullCode = `${this.service}/${code}`;
        const template = this.errors[code];
        const message = template ? $4bdafd014543a1dc$var$replaceTemplate(template, customData) : "Error";
        // Service Name: Error message (service/code).
        const fullMessage = `${this.serviceName}: ${message} (${fullCode}).`;
        const error = new $4bdafd014543a1dc$export$dd24e9cd51226c56(fullCode, fullMessage, customData);
        return error;
    }
    constructor(service, serviceName, errors){
        this.service = service;
        this.serviceName = serviceName;
        this.errors = errors;
    }
}
function $4bdafd014543a1dc$var$replaceTemplate(template, data) {
    return template.replace($4bdafd014543a1dc$var$PATTERN, (_, key)=>{
        const value = data[key];
        return value != null ? String(value) : `<${key}?>`;
    });
}
const $4bdafd014543a1dc$var$PATTERN = /\{\$([^}]+)}/g;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Evaluates a JSON string into a javascript object.
 *
 * @param {string} str A string containing JSON.
 * @return {*} The javascript object representing the specified JSON.
 */ function $4bdafd014543a1dc$export$c5a53ce6a17cf18d(str) {
    return JSON.parse(str);
}
/**
 * Returns JSON representing a javascript object.
 * @param {*} data Javascript object to be stringified.
 * @return {string} The JSON contents of the object.
 */ function $4bdafd014543a1dc$export$fac44ee5b035f737(data) {
    return JSON.stringify(data);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Decodes a Firebase auth. token into constituent parts.
 *
 * Notes:
 * - May return with invalid / incomplete claims if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $4bdafd014543a1dc$export$2f872c0f2117be69 = function(token) {
    let header = {}, claims = {}, data = {}, signature = "";
    try {
        const parts = token.split(".");
        header = $4bdafd014543a1dc$export$c5a53ce6a17cf18d($4bdafd014543a1dc$export$c62426fdd000a97e(parts[0]) || "");
        claims = $4bdafd014543a1dc$export$c5a53ce6a17cf18d($4bdafd014543a1dc$export$c62426fdd000a97e(parts[1]) || "");
        signature = parts[2];
        data = claims["d"] || {};
        delete claims["d"];
    } catch (e) {}
    return {
        header: header,
        claims: claims,
        data: data,
        signature: signature
    };
};
/**
 * Decodes a Firebase auth. token and checks the validity of its time-based claims. Will return true if the
 * token is within the time window authorized by the 'nbf' (not-before) and 'iat' (issued-at) claims.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $4bdafd014543a1dc$export$5f870fcca7ae6a88 = function(token) {
    const claims = $4bdafd014543a1dc$export$2f872c0f2117be69(token).claims;
    const now = Math.floor(new Date().getTime() / 1000);
    let validSince = 0, validUntil = 0;
    if (typeof claims === "object") {
        if (claims.hasOwnProperty("nbf")) validSince = claims["nbf"];
        else if (claims.hasOwnProperty("iat")) validSince = claims["iat"];
        if (claims.hasOwnProperty("exp")) validUntil = claims["exp"];
        else // token will expire after 24h by default
        validUntil = validSince + 86400;
    }
    return !!now && !!validSince && !!validUntil && now >= validSince && now <= validUntil;
};
/**
 * Decodes a Firebase auth. token and returns its issued at time if valid, null otherwise.
 *
 * Notes:
 * - May return null if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $4bdafd014543a1dc$export$701c661ec91095f2 = function(token) {
    const claims = $4bdafd014543a1dc$export$2f872c0f2117be69(token).claims;
    if (typeof claims === "object" && claims.hasOwnProperty("iat")) return claims["iat"];
    return null;
};
/**
 * Decodes a Firebase auth. token and checks the validity of its format. Expects a valid issued-at time.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $4bdafd014543a1dc$export$9565ca3d387f8aa0 = function(token) {
    const decoded = $4bdafd014543a1dc$export$2f872c0f2117be69(token), claims = decoded.claims;
    return !!claims && typeof claims === "object" && claims.hasOwnProperty("iat");
};
/**
 * Attempts to peer into an auth token and determine if it's an admin auth token by looking at the claims portion.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $4bdafd014543a1dc$export$fc970ed23da99565 = function(token) {
    const claims = $4bdafd014543a1dc$export$2f872c0f2117be69(token).claims;
    return typeof claims === "object" && claims["admin"] === true;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $4bdafd014543a1dc$export$2344b14b097df817(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
}
function $4bdafd014543a1dc$export$e51ae4db7b428f67(obj, key) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) return obj[key];
    else return undefined;
}
function $4bdafd014543a1dc$export$dd1bc94b04021eeb(obj) {
    for(const key in obj){
        if (Object.prototype.hasOwnProperty.call(obj, key)) return false;
    }
    return true;
}
function $4bdafd014543a1dc$export$871de8747c9eaa88(obj, fn, contextObj) {
    const res = {};
    for(const key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) res[key] = fn.call(contextObj, obj[key], key, obj);
    return res;
}
/**
 * Deep equal two objects. Support Arrays and Objects.
 */ function $4bdafd014543a1dc$export$9cb4719e2e525b7a(a, b) {
    if (a === b) return true;
    const aKeys = Object.keys(a);
    const bKeys = Object.keys(b);
    for (const k of aKeys){
        if (!bKeys.includes(k)) return false;
        const aProp = a[k];
        const bProp = b[k];
        if ($4bdafd014543a1dc$var$isObject(aProp) && $4bdafd014543a1dc$var$isObject(bProp)) {
            if (!$4bdafd014543a1dc$export$9cb4719e2e525b7a(aProp, bProp)) return false;
        } else if (aProp !== bProp) return false;
    }
    for (const k of bKeys){
        if (!aKeys.includes(k)) return false;
    }
    return true;
}
function $4bdafd014543a1dc$var$isObject(thing) {
    return thing !== null && typeof thing === "object";
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a querystring-formatted string (e.g. &arg=val&arg2=val2) from a
 * params object (e.g. {arg: 'val', arg2: 'val2'})
 * Note: You must prepend it with ? when adding it to a URL.
 */ function $4bdafd014543a1dc$export$ac4103b836844853(querystringParams) {
    const params = [];
    for (const [key, value] of Object.entries(querystringParams))if (Array.isArray(value)) value.forEach((arrayVal)=>{
        params.push(encodeURIComponent(key) + "=" + encodeURIComponent(arrayVal));
    });
    else params.push(encodeURIComponent(key) + "=" + encodeURIComponent(value));
    return params.length ? "&" + params.join("&") : "";
}
/**
 * Decodes a querystring (e.g. ?arg=val&arg2=val2) into a params object
 * (e.g. {arg: 'val', arg2: 'val2'})
 */ function $4bdafd014543a1dc$export$c1271ca4c8a70741(querystring) {
    const obj = {};
    const tokens = querystring.replace(/^\?/, "").split("&");
    tokens.forEach((token)=>{
        if (token) {
            const [key, value] = token.split("=");
            obj[decodeURIComponent(key)] = decodeURIComponent(value);
        }
    });
    return obj;
}
/**
 * Extract the query string part of a URL, including the leading question mark (if present).
 */ function $4bdafd014543a1dc$export$1a8408415472d8ed(url) {
    const queryStart = url.indexOf("?");
    if (!queryStart) return "";
    const fragmentStart = url.indexOf("#", queryStart);
    return url.substring(queryStart, fragmentStart > 0 ? fragmentStart : undefined);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview SHA-1 cryptographic hash.
 * Variable names follow the notation in FIPS PUB 180-3:
 * http://csrc.nist.gov/publications/fips/fips180-3/fips180-3_final.pdf.
 *
 * Usage:
 *   var sha1 = new sha1();
 *   sha1.update(bytes);
 *   var hash = sha1.digest();
 *
 * Performance:
 *   Chrome 23:   ~400 Mbit/s
 *   Firefox 16:  ~250 Mbit/s
 *
 */ /**
 * SHA-1 cryptographic hash constructor.
 *
 * The properties declared here are discussed in the above algorithm document.
 * @constructor
 * @final
 * @struct
 */ class $4bdafd014543a1dc$export$c85d589bf4e25fef {
    reset() {
        this.chain_[0] = 0x67452301;
        this.chain_[1] = 0xefcdab89;
        this.chain_[2] = 0x98badcfe;
        this.chain_[3] = 0x10325476;
        this.chain_[4] = 0xc3d2e1f0;
        this.inbuf_ = 0;
        this.total_ = 0;
    }
    /**
     * Internal compress helper function.
     * @param buf Block to compress.
     * @param offset Offset of the block in the buffer.
     * @private
     */ compress_(buf, offset) {
        if (!offset) offset = 0;
        const W = this.W_;
        // get 16 big endian words
        if (typeof buf === "string") for(let i = 0; i < 16; i++){
            // TODO(user): [bug 8140122] Recent versions of Safari for Mac OS and iOS
            // have a bug that turns the post-increment ++ operator into pre-increment
            // during JIT compilation.  We have code that depends heavily on SHA-1 for
            // correctness and which is affected by this bug, so I've removed all uses
            // of post-increment ++ in which the result value is used.  We can revert
            // this change once the Safari bug
            // (https://bugs.webkit.org/show_bug.cgi?id=109036) has been fixed and
            // most clients have been updated.
            W[i] = buf.charCodeAt(offset) << 24 | buf.charCodeAt(offset + 1) << 16 | buf.charCodeAt(offset + 2) << 8 | buf.charCodeAt(offset + 3);
            offset += 4;
        }
        else for(let i = 0; i < 16; i++){
            W[i] = buf[offset] << 24 | buf[offset + 1] << 16 | buf[offset + 2] << 8 | buf[offset + 3];
            offset += 4;
        }
        // expand to 80 words
        for(let i = 16; i < 80; i++){
            const t = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
            W[i] = (t << 1 | t >>> 31) & 0xffffffff;
        }
        let a = this.chain_[0];
        let b = this.chain_[1];
        let c = this.chain_[2];
        let d = this.chain_[3];
        let e = this.chain_[4];
        let f, k;
        // TODO(user): Try to unroll this loop to speed up the computation.
        for(let i = 0; i < 80; i++){
            if (i < 40) {
                if (i < 20) {
                    f = d ^ b & (c ^ d);
                    k = 0x5a827999;
                } else {
                    f = b ^ c ^ d;
                    k = 0x6ed9eba1;
                }
            } else if (i < 60) {
                f = b & c | d & (b | c);
                k = 0x8f1bbcdc;
            } else {
                f = b ^ c ^ d;
                k = 0xca62c1d6;
            }
            const t = (a << 5 | a >>> 27) + f + e + k + W[i] & 0xffffffff;
            e = d;
            d = c;
            c = (b << 30 | b >>> 2) & 0xffffffff;
            b = a;
            a = t;
        }
        this.chain_[0] = this.chain_[0] + a & 0xffffffff;
        this.chain_[1] = this.chain_[1] + b & 0xffffffff;
        this.chain_[2] = this.chain_[2] + c & 0xffffffff;
        this.chain_[3] = this.chain_[3] + d & 0xffffffff;
        this.chain_[4] = this.chain_[4] + e & 0xffffffff;
    }
    update(bytes, length) {
        // TODO(johnlenz): tighten the function signature and remove this check
        if (bytes == null) return;
        if (length === undefined) length = bytes.length;
        const lengthMinusBlock = length - this.blockSize;
        let n = 0;
        // Using local instead of member variables gives ~5% speedup on Firefox 16.
        const buf = this.buf_;
        let inbuf = this.inbuf_;
        // The outer while loop should execute at most twice.
        while(n < length){
            // When we have no data in the block to top up, we can directly process the
            // input buffer (assuming it contains sufficient data). This gives ~25%
            // speedup on Chrome 23 and ~15% speedup on Firefox 16, but requires that
            // the data is provided in large chunks (or in multiples of 64 bytes).
            if (inbuf === 0) while(n <= lengthMinusBlock){
                this.compress_(bytes, n);
                n += this.blockSize;
            }
            if (typeof bytes === "string") while(n < length){
                buf[inbuf] = bytes.charCodeAt(n);
                ++inbuf;
                ++n;
                if (inbuf === this.blockSize) {
                    this.compress_(buf);
                    inbuf = 0;
                    break;
                }
            }
            else while(n < length){
                buf[inbuf] = bytes[n];
                ++inbuf;
                ++n;
                if (inbuf === this.blockSize) {
                    this.compress_(buf);
                    inbuf = 0;
                    break;
                }
            }
        }
        this.inbuf_ = inbuf;
        this.total_ += length;
    }
    /** @override */ digest() {
        const digest = [];
        let totalBits = this.total_ * 8;
        // Add pad 0x80 0x00*.
        if (this.inbuf_ < 56) this.update(this.pad_, 56 - this.inbuf_);
        else this.update(this.pad_, this.blockSize - (this.inbuf_ - 56));
        // Add # bits.
        for(let i = this.blockSize - 1; i >= 56; i--){
            this.buf_[i] = totalBits & 255;
            totalBits /= 256; // Don't use bit-shifting here!
        }
        this.compress_(this.buf_);
        let n = 0;
        for(let i = 0; i < 5; i++)for(let j = 24; j >= 0; j -= 8){
            digest[n] = this.chain_[i] >> j & 255;
            ++n;
        }
        return digest;
    }
    constructor(){
        /**
         * Holds the previous values of accumulated variables a-e in the compress_
         * function.
         * @private
         */ this.chain_ = [];
        /**
         * A buffer holding the partially computed hash result.
         * @private
         */ this.buf_ = [];
        /**
         * An array of 80 bytes, each a part of the message to be hashed.  Referred to
         * as the message schedule in the docs.
         * @private
         */ this.W_ = [];
        /**
         * Contains data needed to pad messages less than 64 bytes.
         * @private
         */ this.pad_ = [];
        /**
         * @private {number}
         */ this.inbuf_ = 0;
        /**
         * @private {number}
         */ this.total_ = 0;
        this.blockSize = 64;
        this.pad_[0] = 128;
        for(let i = 1; i < this.blockSize; ++i)this.pad_[i] = 0;
        this.reset();
    }
}
/**
 * Helper to make a Subscribe function (just like Promise helps make a
 * Thenable).
 *
 * @param executor Function which can make calls to a single Observer
 *     as a proxy.
 * @param onNoObservers Callback when count of Observers goes to zero.
 */ function $4bdafd014543a1dc$export$364097d812234b3f(executor, onNoObservers) {
    const proxy = new $4bdafd014543a1dc$var$ObserverProxy(executor, onNoObservers);
    return proxy.subscribe.bind(proxy);
}
/**
 * Implement fan-out for any number of Observers attached via a subscribe
 * function.
 */ class $4bdafd014543a1dc$var$ObserverProxy {
    next(value) {
        this.forEachObserver((observer)=>{
            observer.next(value);
        });
    }
    error(error) {
        this.forEachObserver((observer)=>{
            observer.error(error);
        });
        this.close(error);
    }
    complete() {
        this.forEachObserver((observer)=>{
            observer.complete();
        });
        this.close();
    }
    /**
     * Subscribe function that can be used to add an Observer to the fan-out list.
     *
     * - We require that no event is sent to a subscriber sychronously to their
     *   call to subscribe().
     */ subscribe(nextOrObserver, error, complete) {
        let observer;
        if (nextOrObserver === undefined && error === undefined && complete === undefined) throw new Error("Missing Observer.");
        // Assemble an Observer object when passed as callback functions.
        if ($4bdafd014543a1dc$var$implementsAnyMethods(nextOrObserver, [
            "next",
            "error",
            "complete"
        ])) observer = nextOrObserver;
        else observer = {
            next: nextOrObserver,
            error: error,
            complete: complete
        };
        if (observer.next === undefined) observer.next = $4bdafd014543a1dc$var$noop;
        if (observer.error === undefined) observer.error = $4bdafd014543a1dc$var$noop;
        if (observer.complete === undefined) observer.complete = $4bdafd014543a1dc$var$noop;
        const unsub = this.unsubscribeOne.bind(this, this.observers.length);
        // Attempt to subscribe to a terminated Observable - we
        // just respond to the Observer with the final error or complete
        // event.
        if (this.finalized) // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            try {
                if (this.finalError) observer.error(this.finalError);
                else observer.complete();
            } catch (e) {
            // nothing
            }
            return;
        });
        this.observers.push(observer);
        return unsub;
    }
    // Unsubscribe is synchronous - we guarantee that no events are sent to
    // any unsubscribed Observer.
    unsubscribeOne(i) {
        if (this.observers === undefined || this.observers[i] === undefined) return;
        delete this.observers[i];
        this.observerCount -= 1;
        if (this.observerCount === 0 && this.onNoObservers !== undefined) this.onNoObservers(this);
    }
    forEachObserver(fn) {
        if (this.finalized) // Already closed by previous event....just eat the additional values.
        return;
        // Since sendOne calls asynchronously - there is no chance that
        // this.observers will become undefined.
        for(let i = 0; i < this.observers.length; i++)this.sendOne(i, fn);
    }
    // Call the Observer via one of it's callback function. We are careful to
    // confirm that the observe has not been unsubscribed since this asynchronous
    // function had been queued.
    sendOne(i, fn) {
        // Execute the callback asynchronously
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            if (this.observers !== undefined && this.observers[i] !== undefined) try {
                fn(this.observers[i]);
            } catch (e) {
                // Ignore exceptions raised in Observers or missing methods of an
                // Observer.
                // Log error to console. b/31404806
                if (typeof console !== "undefined" && console.error) console.error(e);
            }
        });
    }
    close(err) {
        if (this.finalized) return;
        this.finalized = true;
        if (err !== undefined) this.finalError = err;
        // Proxy is no longer needed - garbage collect references
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            this.observers = undefined;
            this.onNoObservers = undefined;
        });
    }
    /**
     * @param executor Function which can make calls to a single Observer
     *     as a proxy.
     * @param onNoObservers Callback when count of Observers goes to zero.
     */ constructor(executor, onNoObservers){
        this.observers = [];
        this.unsubscribes = [];
        this.observerCount = 0;
        // Micro-task scheduling by calling task.then().
        this.task = Promise.resolve();
        this.finalized = false;
        this.onNoObservers = onNoObservers;
        // Call the executor asynchronously so subscribers that are called
        // synchronously after the creation of the subscribe function
        // can still receive the very first value generated in the executor.
        this.task.then(()=>{
            executor(this);
        }).catch((e)=>{
            this.error(e);
        });
    }
}
/** Turn synchronous function into one called asynchronously. */ // eslint-disable-next-line @typescript-eslint/ban-types
function $4bdafd014543a1dc$export$12af436354f1a4f7(fn, onError) {
    return (...args)=>{
        Promise.resolve(true).then(()=>{
            fn(...args);
        }).catch((error)=>{
            if (onError) onError(error);
        });
    };
}
/**
 * Return true if the object passed in implements any of the named methods.
 */ function $4bdafd014543a1dc$var$implementsAnyMethods(obj, methods) {
    if (typeof obj !== "object" || obj === null) return false;
    for (const method of methods){
        if (method in obj && typeof obj[method] === "function") return true;
    }
    return false;
}
function $4bdafd014543a1dc$var$noop() {
// do nothing
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Check to make sure the appropriate number of arguments are provided for a public function.
 * Throws an error if it fails.
 *
 * @param fnName The function name
 * @param minCount The minimum number of arguments to allow for the function call
 * @param maxCount The maximum number of argument to allow for the function call
 * @param argCount The actual number of arguments provided.
 */ const $4bdafd014543a1dc$export$20164226a0ed35c3 = function(fnName, minCount, maxCount, argCount) {
    let argError;
    if (argCount < minCount) argError = "at least " + minCount;
    else if (argCount > maxCount) argError = maxCount === 0 ? "none" : "no more than " + maxCount;
    if (argError) {
        const error = fnName + " failed: Was called with " + argCount + (argCount === 1 ? " argument." : " arguments.") + " Expects " + argError + ".";
        throw new Error(error);
    }
};
/**
 * Generates a string to prefix an error message about failed argument validation
 *
 * @param fnName The function name
 * @param argName The name of the argument
 * @return The prefix to add to the error thrown for validation.
 */ function $4bdafd014543a1dc$export$adea4917e02d93dc(fnName, argName) {
    return `${fnName} failed: ${argName} argument `;
}
/**
 * @param fnName
 * @param argumentNumber
 * @param namespace
 * @param optional
 */ function $4bdafd014543a1dc$export$8eef22622e725943(fnName, namespace, optional) {
    if (optional && !namespace) return;
    if (typeof namespace !== "string") //TODO: I should do more validation here. We only allow certain chars in namespaces.
    throw new Error($4bdafd014543a1dc$export$adea4917e02d93dc(fnName, "namespace") + "must be a valid firebase namespace.");
}
function $4bdafd014543a1dc$export$5bcd2a2eb6640dfa(fnName, argumentName, // eslint-disable-next-line @typescript-eslint/ban-types
callback, optional) {
    if (optional && !callback) return;
    if (typeof callback !== "function") throw new Error($4bdafd014543a1dc$export$adea4917e02d93dc(fnName, argumentName) + "must be a valid function.");
}
function $4bdafd014543a1dc$export$df77539402cfb523(fnName, argumentName, context, optional) {
    if (optional && !context) return;
    if (typeof context !== "object" || context === null) throw new Error($4bdafd014543a1dc$export$adea4917e02d93dc(fnName, argumentName) + "must be a valid context object.");
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Code originally came from goog.crypt.stringToUtf8ByteArray, but for some reason they
// automatically replaced '\r\n' with '\n', and they didn't handle surrogate pairs,
// so it's been modified.
// Note that not all Unicode characters appear as single characters in JavaScript strings.
// fromCharCode returns the UTF-16 encoding of a character - so some Unicode characters
// use 2 characters in Javascript.  All 4-byte UTF-8 characters begin with a first
// character in the range 0xD800 - 0xDBFF (the first character of a so-called surrogate
// pair).
// See http://www.ecma-international.org/ecma-262/5.1/#sec-15.1.3
/**
 * @param {string} str
 * @return {Array}
 */ const $4bdafd014543a1dc$export$655666783217a925 = function(str) {
    const out = [];
    let p = 0;
    for(let i = 0; i < str.length; i++){
        let c = str.charCodeAt(i);
        // Is this the lead surrogate in a surrogate pair?
        if (c >= 0xd800 && c <= 0xdbff) {
            const high = c - 0xd800; // the high 10 bits.
            i++;
            $4bdafd014543a1dc$export$a7a9523472993e97(i < str.length, "Surrogate pair missing trail surrogate.");
            const low = str.charCodeAt(i) - 0xdc00; // the low 10 bits.
            c = 0x10000 + (high << 10) + low;
        }
        if (c < 128) out[p++] = c;
        else if (c < 2048) {
            out[p++] = c >> 6 | 192;
            out[p++] = c & 63 | 128;
        } else if (c < 65536) {
            out[p++] = c >> 12 | 224;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        } else {
            out[p++] = c >> 18 | 240;
            out[p++] = c >> 12 & 63 | 128;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        }
    }
    return out;
};
/**
 * Calculate length without actually converting; useful for doing cheaper validation.
 * @param {string} str
 * @return {number}
 */ const $4bdafd014543a1dc$export$9536dc0a75b20bf9 = function(str) {
    let p = 0;
    for(let i = 0; i < str.length; i++){
        const c = str.charCodeAt(i);
        if (c < 128) p++;
        else if (c < 2048) p += 2;
        else if (c >= 0xd800 && c <= 0xdbff) {
            // Lead surrogate of a surrogate pair.  The pair together will take 4 bytes to represent.
            p += 4;
            i++; // skip trail surrogate.
        } else p += 3;
    }
    return p;
};
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The amount of milliseconds to exponentially increase.
 */ const $4bdafd014543a1dc$var$DEFAULT_INTERVAL_MILLIS = 1000;
/**
 * The factor to backoff by.
 * Should be a number greater than 1.
 */ const $4bdafd014543a1dc$var$DEFAULT_BACKOFF_FACTOR = 2;
/**
 * The maximum milliseconds to increase to.
 *
 * <p>Visible for testing
 */ const $4bdafd014543a1dc$export$bdf1213ffbdb096e = 14400000; // Four hours, like iOS and Android.
/**
 * The percentage of backoff time to randomize by.
 * See
 * http://go/safe-client-behavior#step-1-determine-the-appropriate-retry-interval-to-handle-spike-traffic
 * for context.
 *
 * <p>Visible for testing
 */ const $4bdafd014543a1dc$export$3518ed2cfe61fa30 = 0.5;
/**
 * Based on the backoff method from
 * https://github.com/google/closure-library/blob/master/closure/goog/math/exponentialbackoff.js.
 * Extracted here so we don't need to pass metadata and a stateful ExponentialBackoff object around.
 */ function $4bdafd014543a1dc$export$4d810c0ca64ed8e9(backoffCount, intervalMillis = $4bdafd014543a1dc$var$DEFAULT_INTERVAL_MILLIS, backoffFactor = $4bdafd014543a1dc$var$DEFAULT_BACKOFF_FACTOR) {
    // Calculates an exponentially increasing value.
    // Deviation: calculates value from count and a constant interval, so we only need to save value
    // and count to restore state.
    const currBaseValue = intervalMillis * Math.pow(backoffFactor, backoffCount);
    // A random "fuzz" to avoid waves of retries.
    // Deviation: randomFactor is required.
    const randomWait = Math.round(// A fraction of the backoff value to add/subtract.
    // Deviation: changes multiplication order to improve readability.
    $4bdafd014543a1dc$export$3518ed2cfe61fa30 * currBaseValue * // A random float (rounded to int by Math.round above) in the range [-1, 1]. Determines
    // if we add or subtract.
    (Math.random() - 0.5) * 2);
    // Limits backoff to max to avoid effectively permanent backoff.
    return Math.min($4bdafd014543a1dc$export$bdf1213ffbdb096e, currBaseValue + randomWait);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provide English ordinal letters after a number
 */ function $4bdafd014543a1dc$export$7bb39f879164e4ac(i) {
    if (!Number.isFinite(i)) return `${i}`;
    return i + $4bdafd014543a1dc$var$indicator(i);
}
function $4bdafd014543a1dc$var$indicator(i) {
    i = Math.abs(i);
    const cent = i % 100;
    if (cent >= 10 && cent <= 20) return "th";
    const dec = i % 10;
    if (dec === 1) return "st";
    if (dec === 2) return "nd";
    if (dec === 3) return "rd";
    return "th";
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $4bdafd014543a1dc$export$4befe9b5fa509a1b(service) {
    if (service && service._delegate) return service._delegate;
    else return service;
}

});

parcelRegister("iXpG9", function(module, exports) {

$parcel$export(module.exports, "_registerComponent", function () { return $dcd1a7fd5d31bb42$export$c930050e7bb63965; });
$parcel$export(module.exports, "_getProvider", function () { return $dcd1a7fd5d31bb42$export$fa0d6da0f5838f50; });
$parcel$export(module.exports, "_removeServiceInstance", function () { return $dcd1a7fd5d31bb42$export$48d18de2ff1c45a5; });
$parcel$export(module.exports, "SDK_VERSION", function () { return $dcd1a7fd5d31bb42$export$31499a9cd224b78c; });
$parcel$export(module.exports, "initializeApp", function () { return $dcd1a7fd5d31bb42$export$c55cfd413944906d; });
$parcel$export(module.exports, "getApp", function () { return $dcd1a7fd5d31bb42$export$f9962582c9e66d99; });
$parcel$export(module.exports, "registerVersion", function () { return $dcd1a7fd5d31bb42$export$d29d5299a7137abc; });

var $5m6Nf = parcelRequire("5m6Nf");

var $c8QAK = parcelRequire("c8QAK");

var $fekBK = parcelRequire("fekBK");

var $hpRWE = parcelRequire("hpRWE");
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $dcd1a7fd5d31bb42$var$PlatformLoggerServiceImpl {
    // In initial implementation, this will be called by installations on
    // auth token refresh, and installations will send this string.
    getPlatformInfoString() {
        const providers = this.container.getProviders();
        // Loop through providers and get library/version pairs from any that are
        // version components.
        return providers.map((provider)=>{
            if ($dcd1a7fd5d31bb42$var$isVersionServiceProvider(provider)) {
                const service = provider.getImmediate();
                return `${service.library}/${service.version}`;
            } else return null;
        }).filter((logString)=>logString).join(" ");
    }
    constructor(container){
        this.container = container;
    }
}
/**
 *
 * @param provider check if this provider provides a VersionService
 *
 * NOTE: Using Provider<'app-version'> is a hack to indicate that the provider
 * provides VersionService. The provider is not necessarily a 'app-version'
 * provider.
 */ function $dcd1a7fd5d31bb42$var$isVersionServiceProvider(provider) {
    const component = provider.getComponent();
    return (component === null || component === void 0 ? void 0 : component.type) === "VERSION" /* VERSION */ ;
}
const $dcd1a7fd5d31bb42$var$name$o = "@firebase/app";
const $dcd1a7fd5d31bb42$var$version$1 = "0.7.26";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $dcd1a7fd5d31bb42$var$logger = new (0, $c8QAK.Logger)("@firebase/app");
const $dcd1a7fd5d31bb42$var$name$n = "@firebase/app-compat";
const $dcd1a7fd5d31bb42$var$name$m = "@firebase/analytics-compat";
const $dcd1a7fd5d31bb42$var$name$l = "@firebase/analytics";
const $dcd1a7fd5d31bb42$var$name$k = "@firebase/app-check-compat";
const $dcd1a7fd5d31bb42$var$name$j = "@firebase/app-check";
const $dcd1a7fd5d31bb42$var$name$i = "@firebase/auth";
const $dcd1a7fd5d31bb42$var$name$h = "@firebase/auth-compat";
const $dcd1a7fd5d31bb42$var$name$g = "@firebase/database";
const $dcd1a7fd5d31bb42$var$name$f = "@firebase/database-compat";
const $dcd1a7fd5d31bb42$var$name$e = "@firebase/functions";
const $dcd1a7fd5d31bb42$var$name$d = "@firebase/functions-compat";
const $dcd1a7fd5d31bb42$var$name$c = "@firebase/installations";
const $dcd1a7fd5d31bb42$var$name$b = "@firebase/installations-compat";
const $dcd1a7fd5d31bb42$var$name$a = "@firebase/messaging";
const $dcd1a7fd5d31bb42$var$name$9 = "@firebase/messaging-compat";
const $dcd1a7fd5d31bb42$var$name$8 = "@firebase/performance";
const $dcd1a7fd5d31bb42$var$name$7 = "@firebase/performance-compat";
const $dcd1a7fd5d31bb42$var$name$6 = "@firebase/remote-config";
const $dcd1a7fd5d31bb42$var$name$5 = "@firebase/remote-config-compat";
const $dcd1a7fd5d31bb42$var$name$4 = "@firebase/storage";
const $dcd1a7fd5d31bb42$var$name$3 = "@firebase/storage-compat";
const $dcd1a7fd5d31bb42$var$name$2 = "@firebase/firestore";
const $dcd1a7fd5d31bb42$var$name$1 = "@firebase/firestore-compat";
const $dcd1a7fd5d31bb42$var$name = "firebase";
const $dcd1a7fd5d31bb42$var$version = "9.8.3";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The default app name
 *
 * @internal
 */ const $dcd1a7fd5d31bb42$export$9f30fa0c10967f7f = "[DEFAULT]";
const $dcd1a7fd5d31bb42$var$PLATFORM_LOG_STRING = {
    [$dcd1a7fd5d31bb42$var$name$o]: "fire-core",
    [$dcd1a7fd5d31bb42$var$name$n]: "fire-core-compat",
    [$dcd1a7fd5d31bb42$var$name$l]: "fire-analytics",
    [$dcd1a7fd5d31bb42$var$name$m]: "fire-analytics-compat",
    [$dcd1a7fd5d31bb42$var$name$j]: "fire-app-check",
    [$dcd1a7fd5d31bb42$var$name$k]: "fire-app-check-compat",
    [$dcd1a7fd5d31bb42$var$name$i]: "fire-auth",
    [$dcd1a7fd5d31bb42$var$name$h]: "fire-auth-compat",
    [$dcd1a7fd5d31bb42$var$name$g]: "fire-rtdb",
    [$dcd1a7fd5d31bb42$var$name$f]: "fire-rtdb-compat",
    [$dcd1a7fd5d31bb42$var$name$e]: "fire-fn",
    [$dcd1a7fd5d31bb42$var$name$d]: "fire-fn-compat",
    [$dcd1a7fd5d31bb42$var$name$c]: "fire-iid",
    [$dcd1a7fd5d31bb42$var$name$b]: "fire-iid-compat",
    [$dcd1a7fd5d31bb42$var$name$a]: "fire-fcm",
    [$dcd1a7fd5d31bb42$var$name$9]: "fire-fcm-compat",
    [$dcd1a7fd5d31bb42$var$name$8]: "fire-perf",
    [$dcd1a7fd5d31bb42$var$name$7]: "fire-perf-compat",
    [$dcd1a7fd5d31bb42$var$name$6]: "fire-rc",
    [$dcd1a7fd5d31bb42$var$name$5]: "fire-rc-compat",
    [$dcd1a7fd5d31bb42$var$name$4]: "fire-gcs",
    [$dcd1a7fd5d31bb42$var$name$3]: "fire-gcs-compat",
    [$dcd1a7fd5d31bb42$var$name$2]: "fire-fst",
    [$dcd1a7fd5d31bb42$var$name$1]: "fire-fst-compat",
    "fire-js": "fire-js",
    [$dcd1a7fd5d31bb42$var$name]: "fire-js-all"
};
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @internal
 */ const $dcd1a7fd5d31bb42$export$b4e3c36c855b14b5 = new Map();
/**
 * Registered components.
 *
 * @internal
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $dcd1a7fd5d31bb42$export$9566bce3835c0f28 = new Map();
/**
 * @param component - the component being added to this app's container
 *
 * @internal
 */ function $dcd1a7fd5d31bb42$export$fa5244b94c62d36a(app, component) {
    try {
        app.container.addComponent(component);
    } catch (e) {
        $dcd1a7fd5d31bb42$var$logger.debug(`Component ${component.name} failed to register with FirebaseApp ${app.name}`, e);
    }
}
/**
 *
 * @internal
 */ function $dcd1a7fd5d31bb42$export$4393112b42e2b41d(app, component) {
    app.container.addOrOverwriteComponent(component);
}
/**
 *
 * @param component - the component to register
 * @returns whether or not the component is registered successfully
 *
 * @internal
 */ function $dcd1a7fd5d31bb42$export$c930050e7bb63965(component) {
    const componentName = component.name;
    if ($dcd1a7fd5d31bb42$export$9566bce3835c0f28.has(componentName)) {
        $dcd1a7fd5d31bb42$var$logger.debug(`There were multiple attempts to register component ${componentName}.`);
        return false;
    }
    $dcd1a7fd5d31bb42$export$9566bce3835c0f28.set(componentName, component);
    // add the component to existing app instances
    for (const app of $dcd1a7fd5d31bb42$export$b4e3c36c855b14b5.values())$dcd1a7fd5d31bb42$export$fa5244b94c62d36a(app, component);
    return true;
}
/**
 *
 * @param app - FirebaseApp instance
 * @param name - service name
 *
 * @returns the provider for the service with the matching name
 *
 * @internal
 */ function $dcd1a7fd5d31bb42$export$fa0d6da0f5838f50(app, name) {
    const heartbeatController = app.container.getProvider("heartbeat").getImmediate({
        optional: true
    });
    if (heartbeatController) heartbeatController.triggerHeartbeat();
    return app.container.getProvider(name);
}
/**
 *
 * @param app - FirebaseApp instance
 * @param name - service name
 * @param instanceIdentifier - service instance identifier in case the service supports multiple instances
 *
 * @internal
 */ function $dcd1a7fd5d31bb42$export$48d18de2ff1c45a5(app, name, instanceIdentifier = $dcd1a7fd5d31bb42$export$9f30fa0c10967f7f) {
    $dcd1a7fd5d31bb42$export$fa0d6da0f5838f50(app, name).clearInstance(instanceIdentifier);
}
/**
 * Test only
 *
 * @internal
 */ function $dcd1a7fd5d31bb42$export$3685d89b9c3cdfaf() {
    $dcd1a7fd5d31bb42$export$9566bce3835c0f28.clear();
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $dcd1a7fd5d31bb42$var$ERRORS = {
    ["no-app" /* NO_APP */ ]: "No Firebase App '{$appName}' has been created - call Firebase App.initializeApp()",
    ["bad-app-name" /* BAD_APP_NAME */ ]: "Illegal App name: '{$appName}",
    ["duplicate-app" /* DUPLICATE_APP */ ]: "Firebase App named '{$appName}' already exists with different options or config",
    ["app-deleted" /* APP_DELETED */ ]: "Firebase App named '{$appName}' already deleted",
    ["invalid-app-argument" /* INVALID_APP_ARGUMENT */ ]: "firebase.{$appName}() takes either no argument or a Firebase App instance.",
    ["invalid-log-argument" /* INVALID_LOG_ARGUMENT */ ]: "First argument to `onLog` must be null or a function.",
    ["storage-open" /* STORAGE_OPEN */ ]: "Error thrown when opening storage. Original error: {$originalErrorMessage}.",
    ["storage-get" /* STORAGE_GET */ ]: "Error thrown when reading from storage. Original error: {$originalErrorMessage}.",
    ["storage-set" /* STORAGE_WRITE */ ]: "Error thrown when writing to storage. Original error: {$originalErrorMessage}.",
    ["storage-delete" /* STORAGE_DELETE */ ]: "Error thrown when deleting from storage. Original error: {$originalErrorMessage}."
};
const $dcd1a7fd5d31bb42$var$ERROR_FACTORY = new (0, $fekBK.ErrorFactory)("app", "Firebase", $dcd1a7fd5d31bb42$var$ERRORS);
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $dcd1a7fd5d31bb42$var$FirebaseAppImpl {
    get automaticDataCollectionEnabled() {
        this.checkDestroyed();
        return this._automaticDataCollectionEnabled;
    }
    set automaticDataCollectionEnabled(val) {
        this.checkDestroyed();
        this._automaticDataCollectionEnabled = val;
    }
    get name() {
        this.checkDestroyed();
        return this._name;
    }
    get options() {
        this.checkDestroyed();
        return this._options;
    }
    get config() {
        this.checkDestroyed();
        return this._config;
    }
    get container() {
        return this._container;
    }
    get isDeleted() {
        return this._isDeleted;
    }
    set isDeleted(val) {
        this._isDeleted = val;
    }
    /**
     * This function will throw an Error if the App has already been deleted -
     * use before performing API actions on the App.
     */ checkDestroyed() {
        if (this.isDeleted) throw $dcd1a7fd5d31bb42$var$ERROR_FACTORY.create("app-deleted" /* APP_DELETED */ , {
            appName: this._name
        });
    }
    constructor(options, config, container){
        this._isDeleted = false;
        this._options = Object.assign({}, options);
        this._config = Object.assign({}, config);
        this._name = config.name;
        this._automaticDataCollectionEnabled = config.automaticDataCollectionEnabled;
        this._container = container;
        this.container.addComponent(new (0, $5m6Nf.Component)("app", ()=>this, "PUBLIC" /* PUBLIC */ ));
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The current SDK version.
 *
 * @public
 */ const $dcd1a7fd5d31bb42$export$31499a9cd224b78c = $dcd1a7fd5d31bb42$var$version;
function $dcd1a7fd5d31bb42$export$c55cfd413944906d(options, rawConfig = {}) {
    if (typeof rawConfig !== "object") {
        const name = rawConfig;
        rawConfig = {
            name: name
        };
    }
    const config = Object.assign({
        name: $dcd1a7fd5d31bb42$export$9f30fa0c10967f7f,
        automaticDataCollectionEnabled: false
    }, rawConfig);
    const name = config.name;
    if (typeof name !== "string" || !name) throw $dcd1a7fd5d31bb42$var$ERROR_FACTORY.create("bad-app-name" /* BAD_APP_NAME */ , {
        appName: String(name)
    });
    const existingApp = $dcd1a7fd5d31bb42$export$b4e3c36c855b14b5.get(name);
    if (existingApp) {
        // return the existing app if options and config deep equal the ones in the existing app.
        if ((0, $fekBK.deepEqual)(options, existingApp.options) && (0, $fekBK.deepEqual)(config, existingApp.config)) return existingApp;
        else throw $dcd1a7fd5d31bb42$var$ERROR_FACTORY.create("duplicate-app" /* DUPLICATE_APP */ , {
            appName: name
        });
    }
    const container = new (0, $5m6Nf.ComponentContainer)(name);
    for (const component of $dcd1a7fd5d31bb42$export$9566bce3835c0f28.values())container.addComponent(component);
    const newApp = new $dcd1a7fd5d31bb42$var$FirebaseAppImpl(options, config, container);
    $dcd1a7fd5d31bb42$export$b4e3c36c855b14b5.set(name, newApp);
    return newApp;
}
/**
 * Retrieves a {@link @firebase/app#FirebaseApp} instance.
 *
 * When called with no arguments, the default app is returned. When an app name
 * is provided, the app corresponding to that name is returned.
 *
 * An exception is thrown if the app being retrieved has not yet been
 * initialized.
 *
 * @example
 * ```javascript
 * // Return the default app
 * const app = getApp();
 * ```
 *
 * @example
 * ```javascript
 * // Return a named app
 * const otherApp = getApp("otherApp");
 * ```
 *
 * @param name - Optional name of the app to return. If no name is
 *   provided, the default is `"[DEFAULT]"`.
 *
 * @returns The app corresponding to the provided app name.
 *   If no app name is provided, the default app is returned.
 *
 * @public
 */ function $dcd1a7fd5d31bb42$export$f9962582c9e66d99(name = $dcd1a7fd5d31bb42$export$9f30fa0c10967f7f) {
    const app = $dcd1a7fd5d31bb42$export$b4e3c36c855b14b5.get(name);
    if (!app) throw $dcd1a7fd5d31bb42$var$ERROR_FACTORY.create("no-app" /* NO_APP */ , {
        appName: name
    });
    return app;
}
/**
 * A (read-only) array of all initialized apps.
 * @public
 */ function $dcd1a7fd5d31bb42$export$68ddedf7d44b3bdf() {
    return Array.from($dcd1a7fd5d31bb42$export$b4e3c36c855b14b5.values());
}
/**
 * Renders this app unusable and frees the resources of all associated
 * services.
 *
 * @example
 * ```javascript
 * deleteApp(app)
 *   .then(function() {
 *     console.log("App deleted successfully");
 *   })
 *   .catch(function(error) {
 *     console.log("Error deleting app:", error);
 *   });
 * ```
 *
 * @public
 */ async function $dcd1a7fd5d31bb42$export$6eec44aa53d5ea34(app) {
    const name = app.name;
    if ($dcd1a7fd5d31bb42$export$b4e3c36c855b14b5.has(name)) {
        $dcd1a7fd5d31bb42$export$b4e3c36c855b14b5.delete(name);
        await Promise.all(app.container.getProviders().map((provider)=>provider.delete()));
        app.isDeleted = true;
    }
}
/**
 * Registers a library's name and version for platform logging purposes.
 * @param library - Name of 1p or 3p library (e.g. firestore, angularfire)
 * @param version - Current version of that library.
 * @param variant - Bundle variant, e.g., node, rn, etc.
 *
 * @public
 */ function $dcd1a7fd5d31bb42$export$d29d5299a7137abc(libraryKeyOrName, version, variant) {
    var _a;
    // TODO: We can use this check to whitelist strings when/if we set up
    // a good whitelist system.
    let library = (_a = $dcd1a7fd5d31bb42$var$PLATFORM_LOG_STRING[libraryKeyOrName]) !== null && _a !== void 0 ? _a : libraryKeyOrName;
    if (variant) library += `-${variant}`;
    const libraryMismatch = library.match(/\s|\//);
    const versionMismatch = version.match(/\s|\//);
    if (libraryMismatch || versionMismatch) {
        const warning = [
            `Unable to register library "${library}" with version "${version}":`
        ];
        if (libraryMismatch) warning.push(`library name "${library}" contains illegal characters (whitespace or "/")`);
        if (libraryMismatch && versionMismatch) warning.push("and");
        if (versionMismatch) warning.push(`version name "${version}" contains illegal characters (whitespace or "/")`);
        $dcd1a7fd5d31bb42$var$logger.warn(warning.join(" "));
        return;
    }
    $dcd1a7fd5d31bb42$export$c930050e7bb63965(new (0, $5m6Nf.Component)(`${library}-version`, ()=>({
            library: library,
            version: version
        }), "VERSION" /* VERSION */ ));
}
/**
 * Sets log handler for all Firebase SDKs.
 * @param logCallback - An optional custom log handler that executes user code whenever
 * the Firebase SDK makes a logging call.
 *
 * @public
 */ function $dcd1a7fd5d31bb42$export$a82ad227dc8163dc(logCallback, options) {
    if (logCallback !== null && typeof logCallback !== "function") throw $dcd1a7fd5d31bb42$var$ERROR_FACTORY.create("invalid-log-argument" /* INVALID_LOG_ARGUMENT */ );
    (0, $c8QAK.setUserLogHandler)(logCallback, options);
}
/**
 * Sets log level for all Firebase SDKs.
 *
 * All of the log types above the current log level are captured (i.e. if
 * you set the log level to `info`, errors are logged, but `debug` and
 * `verbose` logs are not).
 *
 * @public
 */ function $dcd1a7fd5d31bb42$export$c622e99c0ce7b1c9(logLevel) {
    (0, $c8QAK.setLogLevel)(logLevel);
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $dcd1a7fd5d31bb42$var$DB_NAME = "firebase-heartbeat-database";
const $dcd1a7fd5d31bb42$var$DB_VERSION = 1;
const $dcd1a7fd5d31bb42$var$STORE_NAME = "firebase-heartbeat-store";
let $dcd1a7fd5d31bb42$var$dbPromise = null;
function $dcd1a7fd5d31bb42$var$getDbPromise() {
    if (!$dcd1a7fd5d31bb42$var$dbPromise) $dcd1a7fd5d31bb42$var$dbPromise = (0, $hpRWE.openDB)($dcd1a7fd5d31bb42$var$DB_NAME, $dcd1a7fd5d31bb42$var$DB_VERSION, {
        upgrade: (db, oldVersion)=>{
            // We don't use 'break' in this switch statement, the fall-through
            // behavior is what we want, because if there are multiple versions between
            // the old version and the current version, we want ALL the migrations
            // that correspond to those versions to run, not only the last one.
            // eslint-disable-next-line default-case
            switch(oldVersion){
                case 0:
                    db.createObjectStore($dcd1a7fd5d31bb42$var$STORE_NAME);
            }
        }
    }).catch((e)=>{
        throw $dcd1a7fd5d31bb42$var$ERROR_FACTORY.create("storage-open" /* STORAGE_OPEN */ , {
            originalErrorMessage: e.message
        });
    });
    return $dcd1a7fd5d31bb42$var$dbPromise;
}
async function $dcd1a7fd5d31bb42$var$readHeartbeatsFromIndexedDB(app) {
    var _a;
    try {
        const db = await $dcd1a7fd5d31bb42$var$getDbPromise();
        return db.transaction($dcd1a7fd5d31bb42$var$STORE_NAME).objectStore($dcd1a7fd5d31bb42$var$STORE_NAME).get($dcd1a7fd5d31bb42$var$computeKey(app));
    } catch (e) {
        throw $dcd1a7fd5d31bb42$var$ERROR_FACTORY.create("storage-get" /* STORAGE_GET */ , {
            originalErrorMessage: (_a = e) === null || _a === void 0 ? void 0 : _a.message
        });
    }
}
async function $dcd1a7fd5d31bb42$var$writeHeartbeatsToIndexedDB(app, heartbeatObject) {
    var _a;
    try {
        const db = await $dcd1a7fd5d31bb42$var$getDbPromise();
        const tx = db.transaction($dcd1a7fd5d31bb42$var$STORE_NAME, "readwrite");
        const objectStore = tx.objectStore($dcd1a7fd5d31bb42$var$STORE_NAME);
        await objectStore.put(heartbeatObject, $dcd1a7fd5d31bb42$var$computeKey(app));
        return tx.done;
    } catch (e) {
        throw $dcd1a7fd5d31bb42$var$ERROR_FACTORY.create("storage-set" /* STORAGE_WRITE */ , {
            originalErrorMessage: (_a = e) === null || _a === void 0 ? void 0 : _a.message
        });
    }
}
function $dcd1a7fd5d31bb42$var$computeKey(app) {
    return `${app.name}!${app.options.appId}`;
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $dcd1a7fd5d31bb42$var$MAX_HEADER_BYTES = 1024;
// 30 days
const $dcd1a7fd5d31bb42$var$STORED_HEARTBEAT_RETENTION_MAX_MILLIS = 2592000000;
class $dcd1a7fd5d31bb42$var$HeartbeatServiceImpl {
    /**
     * Called to report a heartbeat. The function will generate
     * a HeartbeatsByUserAgent object, update heartbeatsCache, and persist it
     * to IndexedDB.
     * Note that we only store one heartbeat per day. So if a heartbeat for today is
     * already logged, subsequent calls to this function in the same day will be ignored.
     */ async triggerHeartbeat() {
        const platformLogger = this.container.getProvider("platform-logger").getImmediate();
        // This is the "Firebase user agent" string from the platform logger
        // service, not the browser user agent.
        const agent = platformLogger.getPlatformInfoString();
        const date = $dcd1a7fd5d31bb42$var$getUTCDateString();
        if (this._heartbeatsCache === null) this._heartbeatsCache = await this._heartbeatsCachePromise;
        // Do not store a heartbeat if one is already stored for this day
        // or if a header has already been sent today.
        if (this._heartbeatsCache.lastSentHeartbeatDate === date || this._heartbeatsCache.heartbeats.some((singleDateHeartbeat)=>singleDateHeartbeat.date === date)) return;
        else // There is no entry for this date. Create one.
        this._heartbeatsCache.heartbeats.push({
            date: date,
            agent: agent
        });
        // Remove entries older than 30 days.
        this._heartbeatsCache.heartbeats = this._heartbeatsCache.heartbeats.filter((singleDateHeartbeat)=>{
            const hbTimestamp = new Date(singleDateHeartbeat.date).valueOf();
            const now = Date.now();
            return now - hbTimestamp <= $dcd1a7fd5d31bb42$var$STORED_HEARTBEAT_RETENTION_MAX_MILLIS;
        });
        return this._storage.overwrite(this._heartbeatsCache);
    }
    /**
     * Returns a base64 encoded string which can be attached to the heartbeat-specific header directly.
     * It also clears all heartbeats from memory as well as in IndexedDB.
     *
     * NOTE: Consuming product SDKs should not send the header if this method
     * returns an empty string.
     */ async getHeartbeatsHeader() {
        if (this._heartbeatsCache === null) await this._heartbeatsCachePromise;
        // If it's still null or the array is empty, there is no data to send.
        if (this._heartbeatsCache === null || this._heartbeatsCache.heartbeats.length === 0) return "";
        const date = $dcd1a7fd5d31bb42$var$getUTCDateString();
        // Extract as many heartbeats from the cache as will fit under the size limit.
        const { heartbeatsToSend: heartbeatsToSend, unsentEntries: unsentEntries } = $dcd1a7fd5d31bb42$var$extractHeartbeatsForHeader(this._heartbeatsCache.heartbeats);
        const headerString = (0, $fekBK.base64urlEncodeWithoutPadding)(JSON.stringify({
            version: 2,
            heartbeats: heartbeatsToSend
        }));
        // Store last sent date to prevent another being logged/sent for the same day.
        this._heartbeatsCache.lastSentHeartbeatDate = date;
        if (unsentEntries.length > 0) {
            // Store any unsent entries if they exist.
            this._heartbeatsCache.heartbeats = unsentEntries;
            // This seems more likely than emptying the array (below) to lead to some odd state
            // since the cache isn't empty and this will be called again on the next request,
            // and is probably safest if we await it.
            await this._storage.overwrite(this._heartbeatsCache);
        } else {
            this._heartbeatsCache.heartbeats = [];
            // Do not wait for this, to reduce latency.
            this._storage.overwrite(this._heartbeatsCache);
        }
        return headerString;
    }
    constructor(container){
        this.container = container;
        /**
         * In-memory cache for heartbeats, used by getHeartbeatsHeader() to generate
         * the header string.
         * Stores one record per date. This will be consolidated into the standard
         * format of one record per user agent string before being sent as a header.
         * Populated from indexedDB when the controller is instantiated and should
         * be kept in sync with indexedDB.
         * Leave public for easier testing.
         */ this._heartbeatsCache = null;
        const app = this.container.getProvider("app").getImmediate();
        this._storage = new $dcd1a7fd5d31bb42$var$HeartbeatStorageImpl(app);
        this._heartbeatsCachePromise = this._storage.read().then((result)=>{
            this._heartbeatsCache = result;
            return result;
        });
    }
}
function $dcd1a7fd5d31bb42$var$getUTCDateString() {
    const today = new Date();
    // Returns date format 'YYYY-MM-DD'
    return today.toISOString().substring(0, 10);
}
function $dcd1a7fd5d31bb42$var$extractHeartbeatsForHeader(heartbeatsCache, maxSize = $dcd1a7fd5d31bb42$var$MAX_HEADER_BYTES) {
    // Heartbeats grouped by user agent in the standard format to be sent in
    // the header.
    const heartbeatsToSend = [];
    // Single date format heartbeats that are not sent.
    let unsentEntries = heartbeatsCache.slice();
    for (const singleDateHeartbeat of heartbeatsCache){
        // Look for an existing entry with the same user agent.
        const heartbeatEntry = heartbeatsToSend.find((hb)=>hb.agent === singleDateHeartbeat.agent);
        if (!heartbeatEntry) {
            // If no entry for this user agent exists, create one.
            heartbeatsToSend.push({
                agent: singleDateHeartbeat.agent,
                dates: [
                    singleDateHeartbeat.date
                ]
            });
            if ($dcd1a7fd5d31bb42$var$countBytes(heartbeatsToSend) > maxSize) {
                // If the header would exceed max size, remove the added heartbeat
                // entry and stop adding to the header.
                heartbeatsToSend.pop();
                break;
            }
        } else {
            heartbeatEntry.dates.push(singleDateHeartbeat.date);
            // If the header would exceed max size, remove the added date
            // and stop adding to the header.
            if ($dcd1a7fd5d31bb42$var$countBytes(heartbeatsToSend) > maxSize) {
                heartbeatEntry.dates.pop();
                break;
            }
        }
        // Pop unsent entry from queue. (Skipped if adding the entry exceeded
        // quota and the loop breaks early.)
        unsentEntries = unsentEntries.slice(1);
    }
    return {
        heartbeatsToSend: heartbeatsToSend,
        unsentEntries: unsentEntries
    };
}
class $dcd1a7fd5d31bb42$var$HeartbeatStorageImpl {
    async runIndexedDBEnvironmentCheck() {
        if (!(0, $fekBK.isIndexedDBAvailable)()) return false;
        else return (0, $fekBK.validateIndexedDBOpenable)().then(()=>true).catch(()=>false);
    }
    /**
     * Read all heartbeats.
     */ async read() {
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) return {
            heartbeats: []
        };
        else {
            const idbHeartbeatObject = await $dcd1a7fd5d31bb42$var$readHeartbeatsFromIndexedDB(this.app);
            return idbHeartbeatObject || {
                heartbeats: []
            };
        }
    }
    // overwrite the storage with the provided heartbeats
    async overwrite(heartbeatsObject) {
        var _a;
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) return;
        else {
            const existingHeartbeatsObject = await this.read();
            return $dcd1a7fd5d31bb42$var$writeHeartbeatsToIndexedDB(this.app, {
                lastSentHeartbeatDate: (_a = heartbeatsObject.lastSentHeartbeatDate) !== null && _a !== void 0 ? _a : existingHeartbeatsObject.lastSentHeartbeatDate,
                heartbeats: heartbeatsObject.heartbeats
            });
        }
    }
    // add heartbeats
    async add(heartbeatsObject) {
        var _a;
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) return;
        else {
            const existingHeartbeatsObject = await this.read();
            return $dcd1a7fd5d31bb42$var$writeHeartbeatsToIndexedDB(this.app, {
                lastSentHeartbeatDate: (_a = heartbeatsObject.lastSentHeartbeatDate) !== null && _a !== void 0 ? _a : existingHeartbeatsObject.lastSentHeartbeatDate,
                heartbeats: [
                    ...existingHeartbeatsObject.heartbeats,
                    ...heartbeatsObject.heartbeats
                ]
            });
        }
    }
    constructor(app){
        this.app = app;
        this._canUseIndexedDBPromise = this.runIndexedDBEnvironmentCheck();
    }
}
/**
 * Calculate bytes of a HeartbeatsByUserAgent array after being wrapped
 * in a platform logging header JSON object, stringified, and converted
 * to base 64.
 */ function $dcd1a7fd5d31bb42$var$countBytes(heartbeatsCache) {
    // base64 has a restricted set of characters, all of which should be 1 byte.
    return (0, $fekBK.base64urlEncodeWithoutPadding)(// heartbeatsCache wrapper properties
    JSON.stringify({
        version: 2,
        heartbeats: heartbeatsCache
    })).length;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $dcd1a7fd5d31bb42$var$registerCoreComponents(variant) {
    $dcd1a7fd5d31bb42$export$c930050e7bb63965(new (0, $5m6Nf.Component)("platform-logger", (container)=>new $dcd1a7fd5d31bb42$var$PlatformLoggerServiceImpl(container), "PRIVATE" /* PRIVATE */ ));
    $dcd1a7fd5d31bb42$export$c930050e7bb63965(new (0, $5m6Nf.Component)("heartbeat", (container)=>new $dcd1a7fd5d31bb42$var$HeartbeatServiceImpl(container), "PRIVATE" /* PRIVATE */ ));
    // Register `app` package.
    $dcd1a7fd5d31bb42$export$d29d5299a7137abc($dcd1a7fd5d31bb42$var$name$o, $dcd1a7fd5d31bb42$var$version$1, variant);
    // BUILD_TARGET will be replaced by values like esm5, esm2017, cjs5, etc during the compilation
    $dcd1a7fd5d31bb42$export$d29d5299a7137abc($dcd1a7fd5d31bb42$var$name$o, $dcd1a7fd5d31bb42$var$version$1, "esm2017");
    // Register platform SDK identifier (no version).
    $dcd1a7fd5d31bb42$export$d29d5299a7137abc("fire-js", "");
}
/**
 * Firebase App
 *
 * @remarks This package coordinates the communication between the different Firebase components
 * @packageDocumentation
 */ $dcd1a7fd5d31bb42$var$registerCoreComponents("");

});
parcelRegister("5m6Nf", function(module, exports) {

$parcel$export(module.exports, "Component", function () { return $3e6446d01246eb15$export$16fa2f45be04daa8; });
$parcel$export(module.exports, "ComponentContainer", function () { return $3e6446d01246eb15$export$436a80eea5d5c0c5; });

var $fekBK = parcelRequire("fekBK");
/**
 * Component for service name T, e.g. `auth`, `auth-internal`
 */ class $3e6446d01246eb15$export$16fa2f45be04daa8 {
    setInstantiationMode(mode) {
        this.instantiationMode = mode;
        return this;
    }
    setMultipleInstances(multipleInstances) {
        this.multipleInstances = multipleInstances;
        return this;
    }
    setServiceProps(props) {
        this.serviceProps = props;
        return this;
    }
    setInstanceCreatedCallback(callback) {
        this.onInstanceCreated = callback;
        return this;
    }
    /**
     *
     * @param name The public service name, e.g. app, auth, firestore, database
     * @param instanceFactory Service factory responsible for creating the public interface
     * @param type whether the service provided by the component is public or private
     */ constructor(name, instanceFactory, type){
        this.name = name;
        this.instanceFactory = instanceFactory;
        this.type = type;
        this.multipleInstances = false;
        /**
         * Properties to be added to the service namespace
         */ this.serviceProps = {};
        this.instantiationMode = "LAZY" /* LAZY */ ;
        this.onInstanceCreated = null;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $3e6446d01246eb15$var$DEFAULT_ENTRY_NAME = "[DEFAULT]";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for instance for service name T, e.g. 'auth', 'auth-internal'
 * NameServiceMapping[T] is an alias for the type of the instance
 */ class $3e6446d01246eb15$export$2881499e37b75b9a {
    /**
     * @param identifier A provider can provide mulitple instances of a service
     * if this.component.multipleInstances is true.
     */ get(identifier) {
        // if multipleInstances is not supported, use the default name
        const normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
        if (!this.instancesDeferred.has(normalizedIdentifier)) {
            const deferred = new (0, $fekBK.Deferred)();
            this.instancesDeferred.set(normalizedIdentifier, deferred);
            if (this.isInitialized(normalizedIdentifier) || this.shouldAutoInitialize()) // initialize the service if it can be auto-initialized
            try {
                const instance = this.getOrInitializeService({
                    instanceIdentifier: normalizedIdentifier
                });
                if (instance) deferred.resolve(instance);
            } catch (e) {
            // when the instance factory throws an exception during get(), it should not cause
            // a fatal error. We just return the unresolved promise in this case.
            }
        }
        return this.instancesDeferred.get(normalizedIdentifier).promise;
    }
    getImmediate(options) {
        var _a;
        // if multipleInstances is not supported, use the default name
        const normalizedIdentifier = this.normalizeInstanceIdentifier(options === null || options === void 0 ? void 0 : options.identifier);
        const optional = (_a = options === null || options === void 0 ? void 0 : options.optional) !== null && _a !== void 0 ? _a : false;
        if (this.isInitialized(normalizedIdentifier) || this.shouldAutoInitialize()) try {
            return this.getOrInitializeService({
                instanceIdentifier: normalizedIdentifier
            });
        } catch (e) {
            if (optional) return null;
            else throw e;
        }
        else {
            // In case a component is not initialized and should/can not be auto-initialized at the moment, return null if the optional flag is set, or throw
            if (optional) return null;
            else throw Error(`Service ${this.name} is not available`);
        }
    }
    getComponent() {
        return this.component;
    }
    setComponent(component) {
        if (component.name !== this.name) throw Error(`Mismatching Component ${component.name} for Provider ${this.name}.`);
        if (this.component) throw Error(`Component for ${this.name} has already been provided`);
        this.component = component;
        // return early without attempting to initialize the component if the component requires explicit initialization (calling `Provider.initialize()`)
        if (!this.shouldAutoInitialize()) return;
        // if the service is eager, initialize the default instance
        if ($3e6446d01246eb15$var$isComponentEager(component)) try {
            this.getOrInitializeService({
                instanceIdentifier: $3e6446d01246eb15$var$DEFAULT_ENTRY_NAME
            });
        } catch (e) {
        // when the instance factory for an eager Component throws an exception during the eager
        // initialization, it should not cause a fatal error.
        // TODO: Investigate if we need to make it configurable, because some component may want to cause
        // a fatal error in this case?
        }
        // Create service instances for the pending promises and resolve them
        // NOTE: if this.multipleInstances is false, only the default instance will be created
        // and all promises with resolve with it regardless of the identifier.
        for (const [instanceIdentifier, instanceDeferred] of this.instancesDeferred.entries()){
            const normalizedIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
            try {
                // `getOrInitializeService()` should always return a valid instance since a component is guaranteed. use ! to make typescript happy.
                const instance = this.getOrInitializeService({
                    instanceIdentifier: normalizedIdentifier
                });
                instanceDeferred.resolve(instance);
            } catch (e) {
            // when the instance factory throws an exception, it should not cause
            // a fatal error. We just leave the promise unresolved.
            }
        }
    }
    clearInstance(identifier = $3e6446d01246eb15$var$DEFAULT_ENTRY_NAME) {
        this.instancesDeferred.delete(identifier);
        this.instancesOptions.delete(identifier);
        this.instances.delete(identifier);
    }
    // app.delete() will call this method on every provider to delete the services
    // TODO: should we mark the provider as deleted?
    async delete() {
        const services = Array.from(this.instances.values());
        await Promise.all([
            ...services.filter((service)=>"INTERNAL" in service) // legacy services
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .map((service)=>service.INTERNAL.delete()),
            ...services.filter((service)=>"_delete" in service) // modularized services
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .map((service)=>service._delete())
        ]);
    }
    isComponentSet() {
        return this.component != null;
    }
    isInitialized(identifier = $3e6446d01246eb15$var$DEFAULT_ENTRY_NAME) {
        return this.instances.has(identifier);
    }
    getOptions(identifier = $3e6446d01246eb15$var$DEFAULT_ENTRY_NAME) {
        return this.instancesOptions.get(identifier) || {};
    }
    initialize(opts = {}) {
        const { options: options = {} } = opts;
        const normalizedIdentifier = this.normalizeInstanceIdentifier(opts.instanceIdentifier);
        if (this.isInitialized(normalizedIdentifier)) throw Error(`${this.name}(${normalizedIdentifier}) has already been initialized`);
        if (!this.isComponentSet()) throw Error(`Component ${this.name} has not been registered yet`);
        const instance = this.getOrInitializeService({
            instanceIdentifier: normalizedIdentifier,
            options: options
        });
        // resolve any pending promise waiting for the service instance
        for (const [instanceIdentifier, instanceDeferred] of this.instancesDeferred.entries()){
            const normalizedDeferredIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
            if (normalizedIdentifier === normalizedDeferredIdentifier) instanceDeferred.resolve(instance);
        }
        return instance;
    }
    /**
     *
     * @param callback - a function that will be invoked  after the provider has been initialized by calling provider.initialize().
     * The function is invoked SYNCHRONOUSLY, so it should not execute any longrunning tasks in order to not block the program.
     *
     * @param identifier An optional instance identifier
     * @returns a function to unregister the callback
     */ onInit(callback, identifier) {
        var _a;
        const normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
        const existingCallbacks = (_a = this.onInitCallbacks.get(normalizedIdentifier)) !== null && _a !== void 0 ? _a : new Set();
        existingCallbacks.add(callback);
        this.onInitCallbacks.set(normalizedIdentifier, existingCallbacks);
        const existingInstance = this.instances.get(normalizedIdentifier);
        if (existingInstance) callback(existingInstance, normalizedIdentifier);
        return ()=>{
            existingCallbacks.delete(callback);
        };
    }
    /**
     * Invoke onInit callbacks synchronously
     * @param instance the service instance`
     */ invokeOnInitCallbacks(instance, identifier) {
        const callbacks = this.onInitCallbacks.get(identifier);
        if (!callbacks) return;
        for (const callback of callbacks)try {
            callback(instance, identifier);
        } catch (_a) {
        // ignore errors in the onInit callback
        }
    }
    getOrInitializeService({ instanceIdentifier: instanceIdentifier, options: options = {} }) {
        let instance = this.instances.get(instanceIdentifier);
        if (!instance && this.component) {
            instance = this.component.instanceFactory(this.container, {
                instanceIdentifier: $3e6446d01246eb15$var$normalizeIdentifierForFactory(instanceIdentifier),
                options: options
            });
            this.instances.set(instanceIdentifier, instance);
            this.instancesOptions.set(instanceIdentifier, options);
            /**
             * Invoke onInit listeners.
             * Note this.component.onInstanceCreated is different, which is used by the component creator,
             * while onInit listeners are registered by consumers of the provider.
             */ this.invokeOnInitCallbacks(instance, instanceIdentifier);
            /**
             * Order is important
             * onInstanceCreated() should be called after this.instances.set(instanceIdentifier, instance); which
             * makes `isInitialized()` return true.
             */ if (this.component.onInstanceCreated) try {
                this.component.onInstanceCreated(this.container, instanceIdentifier, instance);
            } catch (_a) {
            // ignore errors in the onInstanceCreatedCallback
            }
        }
        return instance || null;
    }
    normalizeInstanceIdentifier(identifier = $3e6446d01246eb15$var$DEFAULT_ENTRY_NAME) {
        if (this.component) return this.component.multipleInstances ? identifier : $3e6446d01246eb15$var$DEFAULT_ENTRY_NAME;
        else return identifier; // assume multiple instances are supported before the component is provided.
    }
    shouldAutoInitialize() {
        return !!this.component && this.component.instantiationMode !== "EXPLICIT" /* EXPLICIT */ ;
    }
    constructor(name, container){
        this.name = name;
        this.container = container;
        this.component = null;
        this.instances = new Map();
        this.instancesDeferred = new Map();
        this.instancesOptions = new Map();
        this.onInitCallbacks = new Map();
    }
}
// undefined should be passed to the service factory for the default instance
function $3e6446d01246eb15$var$normalizeIdentifierForFactory(identifier) {
    return identifier === $3e6446d01246eb15$var$DEFAULT_ENTRY_NAME ? undefined : identifier;
}
function $3e6446d01246eb15$var$isComponentEager(component) {
    return component.instantiationMode === "EAGER" /* EAGER */ ;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * ComponentContainer that provides Providers for service name T, e.g. `auth`, `auth-internal`
 */ class $3e6446d01246eb15$export$436a80eea5d5c0c5 {
    /**
     *
     * @param component Component being added
     * @param overwrite When a component with the same name has already been registered,
     * if overwrite is true: overwrite the existing component with the new component and create a new
     * provider with the new component. It can be useful in tests where you want to use different mocks
     * for different tests.
     * if overwrite is false: throw an exception
     */ addComponent(component) {
        const provider = this.getProvider(component.name);
        if (provider.isComponentSet()) throw new Error(`Component ${component.name} has already been registered with ${this.name}`);
        provider.setComponent(component);
    }
    addOrOverwriteComponent(component) {
        const provider = this.getProvider(component.name);
        if (provider.isComponentSet()) // delete the existing provider from the container, so we can register the new component
        this.providers.delete(component.name);
        this.addComponent(component);
    }
    /**
     * getProvider provides a type safe interface where it can only be called with a field name
     * present in NameServiceMapping interface.
     *
     * Firebase SDKs providing services should extend NameServiceMapping interface to register
     * themselves.
     */ getProvider(name) {
        if (this.providers.has(name)) return this.providers.get(name);
        // create a Provider for a service that hasn't registered with Firebase
        const provider = new $3e6446d01246eb15$export$2881499e37b75b9a(name, this);
        this.providers.set(name, provider);
        return provider;
    }
    getProviders() {
        return Array.from(this.providers.values());
    }
    constructor(name){
        this.name = name;
        this.providers = new Map();
    }
}

});
parcelRegister("fekBK", function(module, exports) {

$parcel$export(module.exports, "base64urlEncodeWithoutPadding", function () { return $b168261d71956463$export$4b5284a3025a455; });
$parcel$export(module.exports, "Deferred", function () { return $b168261d71956463$export$85f6557964517f1a; });
$parcel$export(module.exports, "isIndexedDBAvailable", function () { return $b168261d71956463$export$3865db50535c2055; });
$parcel$export(module.exports, "validateIndexedDBOpenable", function () { return $b168261d71956463$export$a8a3018f3d187a4d; });
$parcel$export(module.exports, "ErrorFactory", function () { return $b168261d71956463$export$3fa6e1b18a3b2d40; });
$parcel$export(module.exports, "deepEqual", function () { return $b168261d71956463$export$9cb4719e2e525b7a; });
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Firebase constants.  Some of these (@defines) can be overridden at compile-time.
 */ const $b168261d71956463$export$588c7fdda06fbb0a = {
    /**
     * @define {boolean} Whether this is the client Node.js SDK.
     */ NODE_CLIENT: false,
    /**
     * @define {boolean} Whether this is the Admin Node.js SDK.
     */ NODE_ADMIN: false,
    /**
     * Firebase SDK Version
     */ SDK_VERSION: "${JSCORE_VERSION}"
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Throws an error if the provided assertion is falsy
 */ const $b168261d71956463$export$a7a9523472993e97 = function(assertion, message) {
    if (!assertion) throw $b168261d71956463$export$a39cad550e7ab28a(message);
};
/**
 * Returns an Error object suitable for throwing.
 */ const $b168261d71956463$export$a39cad550e7ab28a = function(message) {
    return new Error("Firebase Database (" + $b168261d71956463$export$588c7fdda06fbb0a.SDK_VERSION + ") INTERNAL ASSERT FAILED: " + message);
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $b168261d71956463$var$stringToByteArray$1 = function(str) {
    // TODO(user): Use native implementations if/when available
    const out = [];
    let p = 0;
    for(let i = 0; i < str.length; i++){
        let c = str.charCodeAt(i);
        if (c < 128) out[p++] = c;
        else if (c < 2048) {
            out[p++] = c >> 6 | 192;
            out[p++] = c & 63 | 128;
        } else if ((c & 0xfc00) === 0xd800 && i + 1 < str.length && (str.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
            // Surrogate Pair
            c = 0x10000 + ((c & 0x03ff) << 10) + (str.charCodeAt(++i) & 0x03ff);
            out[p++] = c >> 18 | 240;
            out[p++] = c >> 12 & 63 | 128;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        } else {
            out[p++] = c >> 12 | 224;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        }
    }
    return out;
};
/**
 * Turns an array of numbers into the string given by the concatenation of the
 * characters to which the numbers correspond.
 * @param bytes Array of numbers representing characters.
 * @return Stringification of the array.
 */ const $b168261d71956463$var$byteArrayToString = function(bytes) {
    // TODO(user): Use native implementations if/when available
    const out = [];
    let pos = 0, c = 0;
    while(pos < bytes.length){
        const c1 = bytes[pos++];
        if (c1 < 128) out[c++] = String.fromCharCode(c1);
        else if (c1 > 191 && c1 < 224) {
            const c2 = bytes[pos++];
            out[c++] = String.fromCharCode((c1 & 31) << 6 | c2 & 63);
        } else if (c1 > 239 && c1 < 365) {
            // Surrogate Pair
            const c2 = bytes[pos++];
            const c3 = bytes[pos++];
            const c4 = bytes[pos++];
            const u = ((c1 & 7) << 18 | (c2 & 63) << 12 | (c3 & 63) << 6 | c4 & 63) - 0x10000;
            out[c++] = String.fromCharCode(0xd800 + (u >> 10));
            out[c++] = String.fromCharCode(0xdc00 + (u & 1023));
        } else {
            const c2 = bytes[pos++];
            const c3 = bytes[pos++];
            out[c++] = String.fromCharCode((c1 & 15) << 12 | (c2 & 63) << 6 | c3 & 63);
        }
    }
    return out.join("");
};
// We define it as an object literal instead of a class because a class compiled down to es5 can't
// be treeshaked. https://github.com/rollup/rollup/issues/1691
// Static lookup maps, lazily populated by init_()
const $b168261d71956463$export$b3b2de96497acc47 = {
    /**
     * Maps bytes to characters.
     */ byteToCharMap_: null,
    /**
     * Maps characters to bytes.
     */ charToByteMap_: null,
    /**
     * Maps bytes to websafe characters.
     * @private
     */ byteToCharMapWebSafe_: null,
    /**
     * Maps websafe characters to bytes.
     * @private
     */ charToByteMapWebSafe_: null,
    /**
     * Our default alphabet, shared between
     * ENCODED_VALS and ENCODED_VALS_WEBSAFE
     */ ENCODED_VALS_BASE: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789",
    /**
     * Our default alphabet. Value 64 (=) is special; it means "nothing."
     */ get ENCODED_VALS () {
        return this.ENCODED_VALS_BASE + "+/=";
    },
    /**
     * Our websafe alphabet.
     */ get ENCODED_VALS_WEBSAFE () {
        return this.ENCODED_VALS_BASE + "-_.";
    },
    /**
     * Whether this browser supports the atob and btoa functions. This extension
     * started at Mozilla but is now implemented by many browsers. We use the
     * ASSUME_* variables to avoid pulling in the full useragent detection library
     * but still allowing the standard per-browser compilations.
     *
     */ HAS_NATIVE_SUPPORT: typeof atob === "function",
    /**
     * Base64-encode an array of bytes.
     *
     * @param input An array of bytes (numbers with
     *     value in [0, 255]) to encode.
     * @param webSafe Boolean indicating we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */ encodeByteArray (input, webSafe) {
        if (!Array.isArray(input)) throw Error("encodeByteArray takes an array as a parameter");
        this.init_();
        const byteToCharMap = webSafe ? this.byteToCharMapWebSafe_ : this.byteToCharMap_;
        const output = [];
        for(let i = 0; i < input.length; i += 3){
            const byte1 = input[i];
            const haveByte2 = i + 1 < input.length;
            const byte2 = haveByte2 ? input[i + 1] : 0;
            const haveByte3 = i + 2 < input.length;
            const byte3 = haveByte3 ? input[i + 2] : 0;
            const outByte1 = byte1 >> 2;
            const outByte2 = (byte1 & 0x03) << 4 | byte2 >> 4;
            let outByte3 = (byte2 & 0x0f) << 2 | byte3 >> 6;
            let outByte4 = byte3 & 0x3f;
            if (!haveByte3) {
                outByte4 = 64;
                if (!haveByte2) outByte3 = 64;
            }
            output.push(byteToCharMap[outByte1], byteToCharMap[outByte2], byteToCharMap[outByte3], byteToCharMap[outByte4]);
        }
        return output.join("");
    },
    /**
     * Base64-encode a string.
     *
     * @param input A string to encode.
     * @param webSafe If true, we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */ encodeString (input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) return btoa(input);
        return this.encodeByteArray($b168261d71956463$var$stringToByteArray$1(input), webSafe);
    },
    /**
     * Base64-decode a string.
     *
     * @param input to decode.
     * @param webSafe True if we should use the
     *     alternative alphabet.
     * @return string representing the decoded value.
     */ decodeString (input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) return atob(input);
        return $b168261d71956463$var$byteArrayToString(this.decodeStringToByteArray(input, webSafe));
    },
    /**
     * Base64-decode a string.
     *
     * In base-64 decoding, groups of four characters are converted into three
     * bytes.  If the encoder did not apply padding, the input length may not
     * be a multiple of 4.
     *
     * In this case, the last group will have fewer than 4 characters, and
     * padding will be inferred.  If the group has one or two characters, it decodes
     * to one byte.  If the group has three characters, it decodes to two bytes.
     *
     * @param input Input to decode.
     * @param webSafe True if we should use the web-safe alphabet.
     * @return bytes representing the decoded value.
     */ decodeStringToByteArray (input, webSafe) {
        this.init_();
        const charToByteMap = webSafe ? this.charToByteMapWebSafe_ : this.charToByteMap_;
        const output = [];
        for(let i = 0; i < input.length;){
            const byte1 = charToByteMap[input.charAt(i++)];
            const haveByte2 = i < input.length;
            const byte2 = haveByte2 ? charToByteMap[input.charAt(i)] : 0;
            ++i;
            const haveByte3 = i < input.length;
            const byte3 = haveByte3 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            const haveByte4 = i < input.length;
            const byte4 = haveByte4 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            if (byte1 == null || byte2 == null || byte3 == null || byte4 == null) throw Error();
            const outByte1 = byte1 << 2 | byte2 >> 4;
            output.push(outByte1);
            if (byte3 !== 64) {
                const outByte2 = byte2 << 4 & 0xf0 | byte3 >> 2;
                output.push(outByte2);
                if (byte4 !== 64) {
                    const outByte3 = byte3 << 6 & 0xc0 | byte4;
                    output.push(outByte3);
                }
            }
        }
        return output;
    },
    /**
     * Lazy static initialization function. Called before
     * accessing any of the static map variables.
     * @private
     */ init_ () {
        if (!this.byteToCharMap_) {
            this.byteToCharMap_ = {};
            this.charToByteMap_ = {};
            this.byteToCharMapWebSafe_ = {};
            this.charToByteMapWebSafe_ = {};
            // We want quick mappings back and forth, so we precompute two maps.
            for(let i = 0; i < this.ENCODED_VALS.length; i++){
                this.byteToCharMap_[i] = this.ENCODED_VALS.charAt(i);
                this.charToByteMap_[this.byteToCharMap_[i]] = i;
                this.byteToCharMapWebSafe_[i] = this.ENCODED_VALS_WEBSAFE.charAt(i);
                this.charToByteMapWebSafe_[this.byteToCharMapWebSafe_[i]] = i;
                // Be forgiving when decoding and correctly decode both encodings.
                if (i >= this.ENCODED_VALS_BASE.length) {
                    this.charToByteMap_[this.ENCODED_VALS_WEBSAFE.charAt(i)] = i;
                    this.charToByteMapWebSafe_[this.ENCODED_VALS.charAt(i)] = i;
                }
            }
        }
    }
};
/**
 * URL-safe base64 encoding
 */ const $b168261d71956463$export$e510a73ee562749 = function(str) {
    const utf8Bytes = $b168261d71956463$var$stringToByteArray$1(str);
    return $b168261d71956463$export$b3b2de96497acc47.encodeByteArray(utf8Bytes, true);
};
/**
 * URL-safe base64 encoding (without "." padding in the end).
 * e.g. Used in JSON Web Token (JWT) parts.
 */ const $b168261d71956463$export$4b5284a3025a455 = function(str) {
    // Use base64url encoding and remove padding in the end (dot characters).
    return $b168261d71956463$export$e510a73ee562749(str).replace(/\./g, "");
};
/**
 * URL-safe base64 decoding
 *
 * NOTE: DO NOT use the global atob() function - it does NOT support the
 * base64Url variant encoding.
 *
 * @param str To be decoded
 * @return Decoded result, if possible
 */ const $b168261d71956463$export$c62426fdd000a97e = function(str) {
    try {
        return $b168261d71956463$export$b3b2de96497acc47.decodeString(str, true);
    } catch (e) {
        console.error("base64Decode failed: ", e);
    }
    return null;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Do a deep-copy of basic JavaScript Objects or Arrays.
 */ function $b168261d71956463$export$6c40052bed430212(value) {
    return $b168261d71956463$export$54e9fb29908872fa(undefined, value);
}
/**
 * Copy properties from source to target (recursively allows extension
 * of Objects and Arrays).  Scalar values in the target are over-written.
 * If target is undefined, an object of the appropriate type will be created
 * (and returned).
 *
 * We recursively copy all child properties of plain Objects in the source- so
 * that namespace- like dictionaries are merged.
 *
 * Note that the target can be a function, in which case the properties in
 * the source Object are copied onto it as static properties of the Function.
 *
 * Note: we don't merge __proto__ to prevent prototype pollution
 */ function $b168261d71956463$export$54e9fb29908872fa(target, source) {
    if (!(source instanceof Object)) return source;
    switch(source.constructor){
        case Date:
            // Treat Dates like scalars; if the target date object had any child
            // properties - they will be lost!
            const dateValue = source;
            return new Date(dateValue.getTime());
        case Object:
            if (target === undefined) target = {};
            break;
        case Array:
            // Always copy the array source and overwrite the target.
            target = [];
            break;
        default:
            // Not a plain Object - treat it as a scalar.
            return source;
    }
    for(const prop in source){
        // use isValidKey to guard against prototype pollution. See https://snyk.io/vuln/SNYK-JS-LODASH-450202
        if (!source.hasOwnProperty(prop) || !$b168261d71956463$var$isValidKey(prop)) continue;
        target[prop] = $b168261d71956463$export$54e9fb29908872fa(target[prop], source[prop]);
    }
    return target;
}
function $b168261d71956463$var$isValidKey(key) {
    return key !== "__proto__";
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $b168261d71956463$export$85f6557964517f1a {
    /**
     * Our API internals are not promiseified and cannot because our callback APIs have subtle expectations around
     * invoking promises inline, which Promises are forbidden to do. This method accepts an optional node-style callback
     * and returns a node-style callback which will resolve or reject the Deferred's promise.
     */ wrapCallback(callback) {
        return (error, value)=>{
            if (error) this.reject(error);
            else this.resolve(value);
            if (typeof callback === "function") {
                // Attaching noop handler just in case developer wasn't expecting
                // promises
                this.promise.catch(()=>{});
                // Some of our callbacks don't expect a value and our own tests
                // assert that the parameter length is 1
                if (callback.length === 1) callback(error);
                else callback(error, value);
            }
        };
    }
    constructor(){
        this.reject = ()=>{};
        this.resolve = ()=>{};
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
    }
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $b168261d71956463$export$367bf224123348f1(token, projectId) {
    if (token.uid) throw new Error('The "uid" field is no longer supported by mockUserToken. Please use "sub" instead for Firebase Auth User ID.');
    // Unsecured JWTs use "none" as the algorithm.
    const header = {
        alg: "none",
        type: "JWT"
    };
    const project = projectId || "demo-project";
    const iat = token.iat || 0;
    const sub = token.sub || token.user_id;
    if (!sub) throw new Error("mockUserToken must contain 'sub' or 'user_id' field!");
    const payload = Object.assign({
        // Set all required fields to decent defaults
        iss: `https://securetoken.google.com/${project}`,
        aud: project,
        iat: iat,
        exp: iat + 3600,
        auth_time: iat,
        sub: sub,
        user_id: sub,
        firebase: {
            sign_in_provider: "custom",
            identities: {}
        }
    }, token);
    // Unsecured JWTs use the empty string as a signature.
    const signature = "";
    return [
        $b168261d71956463$export$4b5284a3025a455(JSON.stringify(header)),
        $b168261d71956463$export$4b5284a3025a455(JSON.stringify(payload)),
        signature
    ].join(".");
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns navigator.userAgent string or '' if it's not defined.
 * @return user agent string
 */ function $b168261d71956463$export$c36915b22ce77c19() {
    if (typeof navigator !== "undefined" && typeof navigator["userAgent"] === "string") return navigator["userAgent"];
    else return "";
}
/**
 * Detect Cordova / PhoneGap / Ionic frameworks on a mobile device.
 *
 * Deliberately does not rely on checking `file://` URLs (as this fails PhoneGap
 * in the Ripple emulator) nor Cordova `onDeviceReady`, which would normally
 * wait for a callback.
 */ function $b168261d71956463$export$872f8323f01d7ae0() {
    return typeof window !== "undefined" && // @ts-ignore Setting up an broadly applicable index signature for Window
    // just to deal with this case would probably be a bad idea.
    !!(window["cordova"] || window["phonegap"] || window["PhoneGap"]) && /ios|iphone|ipod|ipad|android|blackberry|iemobile/i.test($b168261d71956463$export$c36915b22ce77c19());
}
/**
 * Detect Node.js.
 *
 * @return true if Node.js environment is detected.
 */ // Node detection logic from: https://github.com/iliakan/detect-node/
function $b168261d71956463$export$8ee0fc9ee280b4ee() {
    try {
        return Object.prototype.toString.call($parcel$global.process) === "[object process]";
    } catch (e) {
        return false;
    }
}
/**
 * Detect Browser Environment
 */ function $b168261d71956463$export$4e09c449d6c407f7() {
    return typeof self === "object" && self.self === self;
}
function $b168261d71956463$export$caa8774a9107a58e() {
    const runtime = typeof chrome === "object" ? chrome.runtime : typeof browser === "object" ? browser.runtime : undefined;
    return typeof runtime === "object" && runtime.id !== undefined;
}
/**
 * Detect React Native.
 *
 * @return true if ReactNative environment is detected.
 */ function $b168261d71956463$export$f7a1e23e542d38e3() {
    return typeof navigator === "object" && navigator["product"] === "ReactNative";
}
/** Detects Electron apps. */ function $b168261d71956463$export$f2f6a8999f8ebd30() {
    return $b168261d71956463$export$c36915b22ce77c19().indexOf("Electron/") >= 0;
}
/** Detects Internet Explorer. */ function $b168261d71956463$export$7e7b1a9668aaed8() {
    const ua = $b168261d71956463$export$c36915b22ce77c19();
    return ua.indexOf("MSIE ") >= 0 || ua.indexOf("Trident/") >= 0;
}
/** Detects Universal Windows Platform apps. */ function $b168261d71956463$export$202944b2d2824246() {
    return $b168261d71956463$export$c36915b22ce77c19().indexOf("MSAppHost/") >= 0;
}
/**
 * Detect whether the current SDK build is the Node version.
 *
 * @return true if it's the Node SDK build.
 */ function $b168261d71956463$export$5d1d834fbbf8bab7() {
    return $b168261d71956463$export$588c7fdda06fbb0a.NODE_CLIENT === true || $b168261d71956463$export$588c7fdda06fbb0a.NODE_ADMIN === true;
}
/** Returns true if we are running in Safari. */ function $b168261d71956463$export$95df08bae54cb4df() {
    return !$b168261d71956463$export$8ee0fc9ee280b4ee() && navigator.userAgent.includes("Safari") && !navigator.userAgent.includes("Chrome");
}
/**
 * This method checks if indexedDB is supported by current browser/service worker context
 * @return true if indexedDB is supported by current browser/service worker context
 */ function $b168261d71956463$export$3865db50535c2055() {
    return typeof indexedDB === "object";
}
/**
 * This method validates browser/sw context for indexedDB by opening a dummy indexedDB database and reject
 * if errors occur during the database open operation.
 *
 * @throws exception if current browser/sw context can't run idb.open (ex: Safari iframe, Firefox
 * private browsing)
 */ function $b168261d71956463$export$a8a3018f3d187a4d() {
    return new Promise((resolve, reject)=>{
        try {
            let preExist = true;
            const DB_CHECK_NAME = "validate-browser-context-for-indexeddb-analytics-module";
            const request = self.indexedDB.open(DB_CHECK_NAME);
            request.onsuccess = ()=>{
                request.result.close();
                // delete database only when it doesn't pre-exist
                if (!preExist) self.indexedDB.deleteDatabase(DB_CHECK_NAME);
                resolve(true);
            };
            request.onupgradeneeded = ()=>{
                preExist = false;
            };
            request.onerror = ()=>{
                var _a;
                reject(((_a = request.error) === null || _a === void 0 ? void 0 : _a.message) || "");
            };
        } catch (error) {
            reject(error);
        }
    });
}
/**
 *
 * This method checks whether cookie is enabled within current browser
 * @return true if cookie is enabled within current browser
 */ function $b168261d71956463$export$f172b7eb6cf60599() {
    if (typeof navigator === "undefined" || !navigator.cookieEnabled) return false;
    return true;
}
/**
 * Polyfill for `globalThis` object.
 * @returns the `globalThis` object for the given environment.
 */ function $b168261d71956463$export$a4e55266d2135a7f() {
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw new Error("Unable to locate global object.");
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Standardized Firebase Error.
 *
 * Usage:
 *
 *   // Typescript string literals for type-safe codes
 *   type Err =
 *     'unknown' |
 *     'object-not-found'
 *     ;
 *
 *   // Closure enum for type-safe error codes
 *   // at-enum {string}
 *   var Err = {
 *     UNKNOWN: 'unknown',
 *     OBJECT_NOT_FOUND: 'object-not-found',
 *   }
 *
 *   let errors: Map<Err, string> = {
 *     'generic-error': "Unknown error",
 *     'file-not-found': "Could not find file: {$file}",
 *   };
 *
 *   // Type-safe function - must pass a valid error code as param.
 *   let error = new ErrorFactory<Err>('service', 'Service', errors);
 *
 *   ...
 *   throw error.create(Err.GENERIC);
 *   ...
 *   throw error.create(Err.FILE_NOT_FOUND, {'file': fileName});
 *   ...
 *   // Service: Could not file file: foo.txt (service/file-not-found).
 *
 *   catch (e) {
 *     assert(e.message === "Could not find file: foo.txt.");
 *     if (e.code === 'service/file-not-found') {
 *       console.log("Could not read file: " + e['file']);
 *     }
 *   }
 */ const $b168261d71956463$var$ERROR_NAME = "FirebaseError";
// Based on code from:
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Custom_Error_Types
class $b168261d71956463$export$dd24e9cd51226c56 extends Error {
    constructor(/** The error code for this error. */ code, message, /** Custom data for this error. */ customData){
        super(message);
        this.code = code;
        this.customData = customData;
        /** The custom name for all FirebaseErrors. */ this.name = $b168261d71956463$var$ERROR_NAME;
        // Fix For ES5
        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $b168261d71956463$export$dd24e9cd51226c56.prototype);
        // Maintains proper stack trace for where our error was thrown.
        // Only available on V8.
        if (Error.captureStackTrace) Error.captureStackTrace(this, $b168261d71956463$export$3fa6e1b18a3b2d40.prototype.create);
    }
}
class $b168261d71956463$export$3fa6e1b18a3b2d40 {
    create(code, ...data) {
        const customData = data[0] || {};
        const fullCode = `${this.service}/${code}`;
        const template = this.errors[code];
        const message = template ? $b168261d71956463$var$replaceTemplate(template, customData) : "Error";
        // Service Name: Error message (service/code).
        const fullMessage = `${this.serviceName}: ${message} (${fullCode}).`;
        const error = new $b168261d71956463$export$dd24e9cd51226c56(fullCode, fullMessage, customData);
        return error;
    }
    constructor(service, serviceName, errors){
        this.service = service;
        this.serviceName = serviceName;
        this.errors = errors;
    }
}
function $b168261d71956463$var$replaceTemplate(template, data) {
    return template.replace($b168261d71956463$var$PATTERN, (_, key)=>{
        const value = data[key];
        return value != null ? String(value) : `<${key}?>`;
    });
}
const $b168261d71956463$var$PATTERN = /\{\$([^}]+)}/g;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Evaluates a JSON string into a javascript object.
 *
 * @param {string} str A string containing JSON.
 * @return {*} The javascript object representing the specified JSON.
 */ function $b168261d71956463$export$c5a53ce6a17cf18d(str) {
    return JSON.parse(str);
}
/**
 * Returns JSON representing a javascript object.
 * @param {*} data Javascript object to be stringified.
 * @return {string} The JSON contents of the object.
 */ function $b168261d71956463$export$fac44ee5b035f737(data) {
    return JSON.stringify(data);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Decodes a Firebase auth. token into constituent parts.
 *
 * Notes:
 * - May return with invalid / incomplete claims if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $b168261d71956463$export$2f872c0f2117be69 = function(token) {
    let header = {}, claims = {}, data = {}, signature = "";
    try {
        const parts = token.split(".");
        header = $b168261d71956463$export$c5a53ce6a17cf18d($b168261d71956463$export$c62426fdd000a97e(parts[0]) || "");
        claims = $b168261d71956463$export$c5a53ce6a17cf18d($b168261d71956463$export$c62426fdd000a97e(parts[1]) || "");
        signature = parts[2];
        data = claims["d"] || {};
        delete claims["d"];
    } catch (e) {}
    return {
        header: header,
        claims: claims,
        data: data,
        signature: signature
    };
};
/**
 * Decodes a Firebase auth. token and checks the validity of its time-based claims. Will return true if the
 * token is within the time window authorized by the 'nbf' (not-before) and 'iat' (issued-at) claims.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $b168261d71956463$export$5f870fcca7ae6a88 = function(token) {
    const claims = $b168261d71956463$export$2f872c0f2117be69(token).claims;
    const now = Math.floor(new Date().getTime() / 1000);
    let validSince = 0, validUntil = 0;
    if (typeof claims === "object") {
        if (claims.hasOwnProperty("nbf")) validSince = claims["nbf"];
        else if (claims.hasOwnProperty("iat")) validSince = claims["iat"];
        if (claims.hasOwnProperty("exp")) validUntil = claims["exp"];
        else // token will expire after 24h by default
        validUntil = validSince + 86400;
    }
    return !!now && !!validSince && !!validUntil && now >= validSince && now <= validUntil;
};
/**
 * Decodes a Firebase auth. token and returns its issued at time if valid, null otherwise.
 *
 * Notes:
 * - May return null if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $b168261d71956463$export$701c661ec91095f2 = function(token) {
    const claims = $b168261d71956463$export$2f872c0f2117be69(token).claims;
    if (typeof claims === "object" && claims.hasOwnProperty("iat")) return claims["iat"];
    return null;
};
/**
 * Decodes a Firebase auth. token and checks the validity of its format. Expects a valid issued-at time.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $b168261d71956463$export$9565ca3d387f8aa0 = function(token) {
    const decoded = $b168261d71956463$export$2f872c0f2117be69(token), claims = decoded.claims;
    return !!claims && typeof claims === "object" && claims.hasOwnProperty("iat");
};
/**
 * Attempts to peer into an auth token and determine if it's an admin auth token by looking at the claims portion.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $b168261d71956463$export$fc970ed23da99565 = function(token) {
    const claims = $b168261d71956463$export$2f872c0f2117be69(token).claims;
    return typeof claims === "object" && claims["admin"] === true;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $b168261d71956463$export$2344b14b097df817(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
}
function $b168261d71956463$export$e51ae4db7b428f67(obj, key) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) return obj[key];
    else return undefined;
}
function $b168261d71956463$export$dd1bc94b04021eeb(obj) {
    for(const key in obj){
        if (Object.prototype.hasOwnProperty.call(obj, key)) return false;
    }
    return true;
}
function $b168261d71956463$export$871de8747c9eaa88(obj, fn, contextObj) {
    const res = {};
    for(const key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) res[key] = fn.call(contextObj, obj[key], key, obj);
    return res;
}
/**
 * Deep equal two objects. Support Arrays and Objects.
 */ function $b168261d71956463$export$9cb4719e2e525b7a(a, b) {
    if (a === b) return true;
    const aKeys = Object.keys(a);
    const bKeys = Object.keys(b);
    for (const k of aKeys){
        if (!bKeys.includes(k)) return false;
        const aProp = a[k];
        const bProp = b[k];
        if ($b168261d71956463$var$isObject(aProp) && $b168261d71956463$var$isObject(bProp)) {
            if (!$b168261d71956463$export$9cb4719e2e525b7a(aProp, bProp)) return false;
        } else if (aProp !== bProp) return false;
    }
    for (const k of bKeys){
        if (!aKeys.includes(k)) return false;
    }
    return true;
}
function $b168261d71956463$var$isObject(thing) {
    return thing !== null && typeof thing === "object";
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a querystring-formatted string (e.g. &arg=val&arg2=val2) from a
 * params object (e.g. {arg: 'val', arg2: 'val2'})
 * Note: You must prepend it with ? when adding it to a URL.
 */ function $b168261d71956463$export$ac4103b836844853(querystringParams) {
    const params = [];
    for (const [key, value] of Object.entries(querystringParams))if (Array.isArray(value)) value.forEach((arrayVal)=>{
        params.push(encodeURIComponent(key) + "=" + encodeURIComponent(arrayVal));
    });
    else params.push(encodeURIComponent(key) + "=" + encodeURIComponent(value));
    return params.length ? "&" + params.join("&") : "";
}
/**
 * Decodes a querystring (e.g. ?arg=val&arg2=val2) into a params object
 * (e.g. {arg: 'val', arg2: 'val2'})
 */ function $b168261d71956463$export$c1271ca4c8a70741(querystring) {
    const obj = {};
    const tokens = querystring.replace(/^\?/, "").split("&");
    tokens.forEach((token)=>{
        if (token) {
            const [key, value] = token.split("=");
            obj[decodeURIComponent(key)] = decodeURIComponent(value);
        }
    });
    return obj;
}
/**
 * Extract the query string part of a URL, including the leading question mark (if present).
 */ function $b168261d71956463$export$1a8408415472d8ed(url) {
    const queryStart = url.indexOf("?");
    if (!queryStart) return "";
    const fragmentStart = url.indexOf("#", queryStart);
    return url.substring(queryStart, fragmentStart > 0 ? fragmentStart : undefined);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview SHA-1 cryptographic hash.
 * Variable names follow the notation in FIPS PUB 180-3:
 * http://csrc.nist.gov/publications/fips/fips180-3/fips180-3_final.pdf.
 *
 * Usage:
 *   var sha1 = new sha1();
 *   sha1.update(bytes);
 *   var hash = sha1.digest();
 *
 * Performance:
 *   Chrome 23:   ~400 Mbit/s
 *   Firefox 16:  ~250 Mbit/s
 *
 */ /**
 * SHA-1 cryptographic hash constructor.
 *
 * The properties declared here are discussed in the above algorithm document.
 * @constructor
 * @final
 * @struct
 */ class $b168261d71956463$export$c85d589bf4e25fef {
    reset() {
        this.chain_[0] = 0x67452301;
        this.chain_[1] = 0xefcdab89;
        this.chain_[2] = 0x98badcfe;
        this.chain_[3] = 0x10325476;
        this.chain_[4] = 0xc3d2e1f0;
        this.inbuf_ = 0;
        this.total_ = 0;
    }
    /**
     * Internal compress helper function.
     * @param buf Block to compress.
     * @param offset Offset of the block in the buffer.
     * @private
     */ compress_(buf, offset) {
        if (!offset) offset = 0;
        const W = this.W_;
        // get 16 big endian words
        if (typeof buf === "string") for(let i = 0; i < 16; i++){
            // TODO(user): [bug 8140122] Recent versions of Safari for Mac OS and iOS
            // have a bug that turns the post-increment ++ operator into pre-increment
            // during JIT compilation.  We have code that depends heavily on SHA-1 for
            // correctness and which is affected by this bug, so I've removed all uses
            // of post-increment ++ in which the result value is used.  We can revert
            // this change once the Safari bug
            // (https://bugs.webkit.org/show_bug.cgi?id=109036) has been fixed and
            // most clients have been updated.
            W[i] = buf.charCodeAt(offset) << 24 | buf.charCodeAt(offset + 1) << 16 | buf.charCodeAt(offset + 2) << 8 | buf.charCodeAt(offset + 3);
            offset += 4;
        }
        else for(let i = 0; i < 16; i++){
            W[i] = buf[offset] << 24 | buf[offset + 1] << 16 | buf[offset + 2] << 8 | buf[offset + 3];
            offset += 4;
        }
        // expand to 80 words
        for(let i = 16; i < 80; i++){
            const t = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
            W[i] = (t << 1 | t >>> 31) & 0xffffffff;
        }
        let a = this.chain_[0];
        let b = this.chain_[1];
        let c = this.chain_[2];
        let d = this.chain_[3];
        let e = this.chain_[4];
        let f, k;
        // TODO(user): Try to unroll this loop to speed up the computation.
        for(let i = 0; i < 80; i++){
            if (i < 40) {
                if (i < 20) {
                    f = d ^ b & (c ^ d);
                    k = 0x5a827999;
                } else {
                    f = b ^ c ^ d;
                    k = 0x6ed9eba1;
                }
            } else if (i < 60) {
                f = b & c | d & (b | c);
                k = 0x8f1bbcdc;
            } else {
                f = b ^ c ^ d;
                k = 0xca62c1d6;
            }
            const t = (a << 5 | a >>> 27) + f + e + k + W[i] & 0xffffffff;
            e = d;
            d = c;
            c = (b << 30 | b >>> 2) & 0xffffffff;
            b = a;
            a = t;
        }
        this.chain_[0] = this.chain_[0] + a & 0xffffffff;
        this.chain_[1] = this.chain_[1] + b & 0xffffffff;
        this.chain_[2] = this.chain_[2] + c & 0xffffffff;
        this.chain_[3] = this.chain_[3] + d & 0xffffffff;
        this.chain_[4] = this.chain_[4] + e & 0xffffffff;
    }
    update(bytes, length) {
        // TODO(johnlenz): tighten the function signature and remove this check
        if (bytes == null) return;
        if (length === undefined) length = bytes.length;
        const lengthMinusBlock = length - this.blockSize;
        let n = 0;
        // Using local instead of member variables gives ~5% speedup on Firefox 16.
        const buf = this.buf_;
        let inbuf = this.inbuf_;
        // The outer while loop should execute at most twice.
        while(n < length){
            // When we have no data in the block to top up, we can directly process the
            // input buffer (assuming it contains sufficient data). This gives ~25%
            // speedup on Chrome 23 and ~15% speedup on Firefox 16, but requires that
            // the data is provided in large chunks (or in multiples of 64 bytes).
            if (inbuf === 0) while(n <= lengthMinusBlock){
                this.compress_(bytes, n);
                n += this.blockSize;
            }
            if (typeof bytes === "string") while(n < length){
                buf[inbuf] = bytes.charCodeAt(n);
                ++inbuf;
                ++n;
                if (inbuf === this.blockSize) {
                    this.compress_(buf);
                    inbuf = 0;
                    break;
                }
            }
            else while(n < length){
                buf[inbuf] = bytes[n];
                ++inbuf;
                ++n;
                if (inbuf === this.blockSize) {
                    this.compress_(buf);
                    inbuf = 0;
                    break;
                }
            }
        }
        this.inbuf_ = inbuf;
        this.total_ += length;
    }
    /** @override */ digest() {
        const digest = [];
        let totalBits = this.total_ * 8;
        // Add pad 0x80 0x00*.
        if (this.inbuf_ < 56) this.update(this.pad_, 56 - this.inbuf_);
        else this.update(this.pad_, this.blockSize - (this.inbuf_ - 56));
        // Add # bits.
        for(let i = this.blockSize - 1; i >= 56; i--){
            this.buf_[i] = totalBits & 255;
            totalBits /= 256; // Don't use bit-shifting here!
        }
        this.compress_(this.buf_);
        let n = 0;
        for(let i = 0; i < 5; i++)for(let j = 24; j >= 0; j -= 8){
            digest[n] = this.chain_[i] >> j & 255;
            ++n;
        }
        return digest;
    }
    constructor(){
        /**
         * Holds the previous values of accumulated variables a-e in the compress_
         * function.
         * @private
         */ this.chain_ = [];
        /**
         * A buffer holding the partially computed hash result.
         * @private
         */ this.buf_ = [];
        /**
         * An array of 80 bytes, each a part of the message to be hashed.  Referred to
         * as the message schedule in the docs.
         * @private
         */ this.W_ = [];
        /**
         * Contains data needed to pad messages less than 64 bytes.
         * @private
         */ this.pad_ = [];
        /**
         * @private {number}
         */ this.inbuf_ = 0;
        /**
         * @private {number}
         */ this.total_ = 0;
        this.blockSize = 64;
        this.pad_[0] = 128;
        for(let i = 1; i < this.blockSize; ++i)this.pad_[i] = 0;
        this.reset();
    }
}
/**
 * Helper to make a Subscribe function (just like Promise helps make a
 * Thenable).
 *
 * @param executor Function which can make calls to a single Observer
 *     as a proxy.
 * @param onNoObservers Callback when count of Observers goes to zero.
 */ function $b168261d71956463$export$364097d812234b3f(executor, onNoObservers) {
    const proxy = new $b168261d71956463$var$ObserverProxy(executor, onNoObservers);
    return proxy.subscribe.bind(proxy);
}
/**
 * Implement fan-out for any number of Observers attached via a subscribe
 * function.
 */ class $b168261d71956463$var$ObserverProxy {
    next(value) {
        this.forEachObserver((observer)=>{
            observer.next(value);
        });
    }
    error(error) {
        this.forEachObserver((observer)=>{
            observer.error(error);
        });
        this.close(error);
    }
    complete() {
        this.forEachObserver((observer)=>{
            observer.complete();
        });
        this.close();
    }
    /**
     * Subscribe function that can be used to add an Observer to the fan-out list.
     *
     * - We require that no event is sent to a subscriber sychronously to their
     *   call to subscribe().
     */ subscribe(nextOrObserver, error, complete) {
        let observer;
        if (nextOrObserver === undefined && error === undefined && complete === undefined) throw new Error("Missing Observer.");
        // Assemble an Observer object when passed as callback functions.
        if ($b168261d71956463$var$implementsAnyMethods(nextOrObserver, [
            "next",
            "error",
            "complete"
        ])) observer = nextOrObserver;
        else observer = {
            next: nextOrObserver,
            error: error,
            complete: complete
        };
        if (observer.next === undefined) observer.next = $b168261d71956463$var$noop;
        if (observer.error === undefined) observer.error = $b168261d71956463$var$noop;
        if (observer.complete === undefined) observer.complete = $b168261d71956463$var$noop;
        const unsub = this.unsubscribeOne.bind(this, this.observers.length);
        // Attempt to subscribe to a terminated Observable - we
        // just respond to the Observer with the final error or complete
        // event.
        if (this.finalized) // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            try {
                if (this.finalError) observer.error(this.finalError);
                else observer.complete();
            } catch (e) {
            // nothing
            }
            return;
        });
        this.observers.push(observer);
        return unsub;
    }
    // Unsubscribe is synchronous - we guarantee that no events are sent to
    // any unsubscribed Observer.
    unsubscribeOne(i) {
        if (this.observers === undefined || this.observers[i] === undefined) return;
        delete this.observers[i];
        this.observerCount -= 1;
        if (this.observerCount === 0 && this.onNoObservers !== undefined) this.onNoObservers(this);
    }
    forEachObserver(fn) {
        if (this.finalized) // Already closed by previous event....just eat the additional values.
        return;
        // Since sendOne calls asynchronously - there is no chance that
        // this.observers will become undefined.
        for(let i = 0; i < this.observers.length; i++)this.sendOne(i, fn);
    }
    // Call the Observer via one of it's callback function. We are careful to
    // confirm that the observe has not been unsubscribed since this asynchronous
    // function had been queued.
    sendOne(i, fn) {
        // Execute the callback asynchronously
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            if (this.observers !== undefined && this.observers[i] !== undefined) try {
                fn(this.observers[i]);
            } catch (e) {
                // Ignore exceptions raised in Observers or missing methods of an
                // Observer.
                // Log error to console. b/31404806
                if (typeof console !== "undefined" && console.error) console.error(e);
            }
        });
    }
    close(err) {
        if (this.finalized) return;
        this.finalized = true;
        if (err !== undefined) this.finalError = err;
        // Proxy is no longer needed - garbage collect references
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            this.observers = undefined;
            this.onNoObservers = undefined;
        });
    }
    /**
     * @param executor Function which can make calls to a single Observer
     *     as a proxy.
     * @param onNoObservers Callback when count of Observers goes to zero.
     */ constructor(executor, onNoObservers){
        this.observers = [];
        this.unsubscribes = [];
        this.observerCount = 0;
        // Micro-task scheduling by calling task.then().
        this.task = Promise.resolve();
        this.finalized = false;
        this.onNoObservers = onNoObservers;
        // Call the executor asynchronously so subscribers that are called
        // synchronously after the creation of the subscribe function
        // can still receive the very first value generated in the executor.
        this.task.then(()=>{
            executor(this);
        }).catch((e)=>{
            this.error(e);
        });
    }
}
/** Turn synchronous function into one called asynchronously. */ // eslint-disable-next-line @typescript-eslint/ban-types
function $b168261d71956463$export$12af436354f1a4f7(fn, onError) {
    return (...args)=>{
        Promise.resolve(true).then(()=>{
            fn(...args);
        }).catch((error)=>{
            if (onError) onError(error);
        });
    };
}
/**
 * Return true if the object passed in implements any of the named methods.
 */ function $b168261d71956463$var$implementsAnyMethods(obj, methods) {
    if (typeof obj !== "object" || obj === null) return false;
    for (const method of methods){
        if (method in obj && typeof obj[method] === "function") return true;
    }
    return false;
}
function $b168261d71956463$var$noop() {
// do nothing
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Check to make sure the appropriate number of arguments are provided for a public function.
 * Throws an error if it fails.
 *
 * @param fnName The function name
 * @param minCount The minimum number of arguments to allow for the function call
 * @param maxCount The maximum number of argument to allow for the function call
 * @param argCount The actual number of arguments provided.
 */ const $b168261d71956463$export$20164226a0ed35c3 = function(fnName, minCount, maxCount, argCount) {
    let argError;
    if (argCount < minCount) argError = "at least " + minCount;
    else if (argCount > maxCount) argError = maxCount === 0 ? "none" : "no more than " + maxCount;
    if (argError) {
        const error = fnName + " failed: Was called with " + argCount + (argCount === 1 ? " argument." : " arguments.") + " Expects " + argError + ".";
        throw new Error(error);
    }
};
/**
 * Generates a string to prefix an error message about failed argument validation
 *
 * @param fnName The function name
 * @param argName The name of the argument
 * @return The prefix to add to the error thrown for validation.
 */ function $b168261d71956463$export$adea4917e02d93dc(fnName, argName) {
    return `${fnName} failed: ${argName} argument `;
}
/**
 * @param fnName
 * @param argumentNumber
 * @param namespace
 * @param optional
 */ function $b168261d71956463$export$8eef22622e725943(fnName, namespace, optional) {
    if (optional && !namespace) return;
    if (typeof namespace !== "string") //TODO: I should do more validation here. We only allow certain chars in namespaces.
    throw new Error($b168261d71956463$export$adea4917e02d93dc(fnName, "namespace") + "must be a valid firebase namespace.");
}
function $b168261d71956463$export$5bcd2a2eb6640dfa(fnName, argumentName, // eslint-disable-next-line @typescript-eslint/ban-types
callback, optional) {
    if (optional && !callback) return;
    if (typeof callback !== "function") throw new Error($b168261d71956463$export$adea4917e02d93dc(fnName, argumentName) + "must be a valid function.");
}
function $b168261d71956463$export$df77539402cfb523(fnName, argumentName, context, optional) {
    if (optional && !context) return;
    if (typeof context !== "object" || context === null) throw new Error($b168261d71956463$export$adea4917e02d93dc(fnName, argumentName) + "must be a valid context object.");
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Code originally came from goog.crypt.stringToUtf8ByteArray, but for some reason they
// automatically replaced '\r\n' with '\n', and they didn't handle surrogate pairs,
// so it's been modified.
// Note that not all Unicode characters appear as single characters in JavaScript strings.
// fromCharCode returns the UTF-16 encoding of a character - so some Unicode characters
// use 2 characters in Javascript.  All 4-byte UTF-8 characters begin with a first
// character in the range 0xD800 - 0xDBFF (the first character of a so-called surrogate
// pair).
// See http://www.ecma-international.org/ecma-262/5.1/#sec-15.1.3
/**
 * @param {string} str
 * @return {Array}
 */ const $b168261d71956463$export$655666783217a925 = function(str) {
    const out = [];
    let p = 0;
    for(let i = 0; i < str.length; i++){
        let c = str.charCodeAt(i);
        // Is this the lead surrogate in a surrogate pair?
        if (c >= 0xd800 && c <= 0xdbff) {
            const high = c - 0xd800; // the high 10 bits.
            i++;
            $b168261d71956463$export$a7a9523472993e97(i < str.length, "Surrogate pair missing trail surrogate.");
            const low = str.charCodeAt(i) - 0xdc00; // the low 10 bits.
            c = 0x10000 + (high << 10) + low;
        }
        if (c < 128) out[p++] = c;
        else if (c < 2048) {
            out[p++] = c >> 6 | 192;
            out[p++] = c & 63 | 128;
        } else if (c < 65536) {
            out[p++] = c >> 12 | 224;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        } else {
            out[p++] = c >> 18 | 240;
            out[p++] = c >> 12 & 63 | 128;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        }
    }
    return out;
};
/**
 * Calculate length without actually converting; useful for doing cheaper validation.
 * @param {string} str
 * @return {number}
 */ const $b168261d71956463$export$9536dc0a75b20bf9 = function(str) {
    let p = 0;
    for(let i = 0; i < str.length; i++){
        const c = str.charCodeAt(i);
        if (c < 128) p++;
        else if (c < 2048) p += 2;
        else if (c >= 0xd800 && c <= 0xdbff) {
            // Lead surrogate of a surrogate pair.  The pair together will take 4 bytes to represent.
            p += 4;
            i++; // skip trail surrogate.
        } else p += 3;
    }
    return p;
};
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The amount of milliseconds to exponentially increase.
 */ const $b168261d71956463$var$DEFAULT_INTERVAL_MILLIS = 1000;
/**
 * The factor to backoff by.
 * Should be a number greater than 1.
 */ const $b168261d71956463$var$DEFAULT_BACKOFF_FACTOR = 2;
/**
 * The maximum milliseconds to increase to.
 *
 * <p>Visible for testing
 */ const $b168261d71956463$export$bdf1213ffbdb096e = 14400000; // Four hours, like iOS and Android.
/**
 * The percentage of backoff time to randomize by.
 * See
 * http://go/safe-client-behavior#step-1-determine-the-appropriate-retry-interval-to-handle-spike-traffic
 * for context.
 *
 * <p>Visible for testing
 */ const $b168261d71956463$export$3518ed2cfe61fa30 = 0.5;
/**
 * Based on the backoff method from
 * https://github.com/google/closure-library/blob/master/closure/goog/math/exponentialbackoff.js.
 * Extracted here so we don't need to pass metadata and a stateful ExponentialBackoff object around.
 */ function $b168261d71956463$export$4d810c0ca64ed8e9(backoffCount, intervalMillis = $b168261d71956463$var$DEFAULT_INTERVAL_MILLIS, backoffFactor = $b168261d71956463$var$DEFAULT_BACKOFF_FACTOR) {
    // Calculates an exponentially increasing value.
    // Deviation: calculates value from count and a constant interval, so we only need to save value
    // and count to restore state.
    const currBaseValue = intervalMillis * Math.pow(backoffFactor, backoffCount);
    // A random "fuzz" to avoid waves of retries.
    // Deviation: randomFactor is required.
    const randomWait = Math.round(// A fraction of the backoff value to add/subtract.
    // Deviation: changes multiplication order to improve readability.
    $b168261d71956463$export$3518ed2cfe61fa30 * currBaseValue * // A random float (rounded to int by Math.round above) in the range [-1, 1]. Determines
    // if we add or subtract.
    (Math.random() - 0.5) * 2);
    // Limits backoff to max to avoid effectively permanent backoff.
    return Math.min($b168261d71956463$export$bdf1213ffbdb096e, currBaseValue + randomWait);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provide English ordinal letters after a number
 */ function $b168261d71956463$export$7bb39f879164e4ac(i) {
    if (!Number.isFinite(i)) return `${i}`;
    return i + $b168261d71956463$var$indicator(i);
}
function $b168261d71956463$var$indicator(i) {
    i = Math.abs(i);
    const cent = i % 100;
    if (cent >= 10 && cent <= 20) return "th";
    const dec = i % 10;
    if (dec === 1) return "st";
    if (dec === 2) return "nd";
    if (dec === 3) return "rd";
    return "th";
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $b168261d71956463$export$4befe9b5fa509a1b(service) {
    if (service && service._delegate) return service._delegate;
    else return service;
}

});


parcelRegister("c8QAK", function(module, exports) {

$parcel$export(module.exports, "Logger", function () { return $8d6f06fe55aa3daa$export$efa9a398d6368992; });
$parcel$export(module.exports, "setLogLevel", function () { return $8d6f06fe55aa3daa$export$c622e99c0ce7b1c9; });
$parcel$export(module.exports, "setUserLogHandler", function () { return $8d6f06fe55aa3daa$export$29577d29c84db5f6; });
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A container for all of the Logger instances
 */ const $8d6f06fe55aa3daa$var$instances = [];
/**
 * The JS SDK supports 5 log levels and also allows a user the ability to
 * silence the logs altogether.
 *
 * The order is a follows:
 * DEBUG < VERBOSE < INFO < WARN < ERROR
 *
 * All of the log types above the current log level will be captured (i.e. if
 * you set the log level to `INFO`, errors will still be logged, but `DEBUG` and
 * `VERBOSE` logs will not)
 */ var $8d6f06fe55aa3daa$export$243e62d78d3b544d;
(function(LogLevel) {
    LogLevel[LogLevel["DEBUG"] = 0] = "DEBUG";
    LogLevel[LogLevel["VERBOSE"] = 1] = "VERBOSE";
    LogLevel[LogLevel["INFO"] = 2] = "INFO";
    LogLevel[LogLevel["WARN"] = 3] = "WARN";
    LogLevel[LogLevel["ERROR"] = 4] = "ERROR";
    LogLevel[LogLevel["SILENT"] = 5] = "SILENT";
})($8d6f06fe55aa3daa$export$243e62d78d3b544d || ($8d6f06fe55aa3daa$export$243e62d78d3b544d = {}));
const $8d6f06fe55aa3daa$var$levelStringToEnum = {
    "debug": $8d6f06fe55aa3daa$export$243e62d78d3b544d.DEBUG,
    "verbose": $8d6f06fe55aa3daa$export$243e62d78d3b544d.VERBOSE,
    "info": $8d6f06fe55aa3daa$export$243e62d78d3b544d.INFO,
    "warn": $8d6f06fe55aa3daa$export$243e62d78d3b544d.WARN,
    "error": $8d6f06fe55aa3daa$export$243e62d78d3b544d.ERROR,
    "silent": $8d6f06fe55aa3daa$export$243e62d78d3b544d.SILENT
};
/**
 * The default log level
 */ const $8d6f06fe55aa3daa$var$defaultLogLevel = $8d6f06fe55aa3daa$export$243e62d78d3b544d.INFO;
/**
 * By default, `console.debug` is not displayed in the developer console (in
 * chrome). To avoid forcing users to have to opt-in to these logs twice
 * (i.e. once for firebase, and once in the console), we are sending `DEBUG`
 * logs to the `console.log` function.
 */ const $8d6f06fe55aa3daa$var$ConsoleMethod = {
    [$8d6f06fe55aa3daa$export$243e62d78d3b544d.DEBUG]: "log",
    [$8d6f06fe55aa3daa$export$243e62d78d3b544d.VERBOSE]: "log",
    [$8d6f06fe55aa3daa$export$243e62d78d3b544d.INFO]: "info",
    [$8d6f06fe55aa3daa$export$243e62d78d3b544d.WARN]: "warn",
    [$8d6f06fe55aa3daa$export$243e62d78d3b544d.ERROR]: "error"
};
/**
 * The default log handler will forward DEBUG, VERBOSE, INFO, WARN, and ERROR
 * messages on to their corresponding console counterparts (if the log method
 * is supported by the current log level)
 */ const $8d6f06fe55aa3daa$var$defaultLogHandler = (instance, logType, ...args)=>{
    if (logType < instance.logLevel) return;
    const now = new Date().toISOString();
    const method = $8d6f06fe55aa3daa$var$ConsoleMethod[logType];
    if (method) console[method](`[${now}]  ${instance.name}:`, ...args);
    else throw new Error(`Attempted to log a message with an invalid logType (value: ${logType})`);
};
class $8d6f06fe55aa3daa$export$efa9a398d6368992 {
    get logLevel() {
        return this._logLevel;
    }
    set logLevel(val) {
        if (!(val in $8d6f06fe55aa3daa$export$243e62d78d3b544d)) throw new TypeError(`Invalid value "${val}" assigned to \`logLevel\``);
        this._logLevel = val;
    }
    // Workaround for setter/getter having to be the same type.
    setLogLevel(val) {
        this._logLevel = typeof val === "string" ? $8d6f06fe55aa3daa$var$levelStringToEnum[val] : val;
    }
    get logHandler() {
        return this._logHandler;
    }
    set logHandler(val) {
        if (typeof val !== "function") throw new TypeError("Value assigned to `logHandler` must be a function");
        this._logHandler = val;
    }
    get userLogHandler() {
        return this._userLogHandler;
    }
    set userLogHandler(val) {
        this._userLogHandler = val;
    }
    /**
     * The functions below are all based on the `console` interface
     */ debug(...args) {
        this._userLogHandler && this._userLogHandler(this, $8d6f06fe55aa3daa$export$243e62d78d3b544d.DEBUG, ...args);
        this._logHandler(this, $8d6f06fe55aa3daa$export$243e62d78d3b544d.DEBUG, ...args);
    }
    log(...args) {
        this._userLogHandler && this._userLogHandler(this, $8d6f06fe55aa3daa$export$243e62d78d3b544d.VERBOSE, ...args);
        this._logHandler(this, $8d6f06fe55aa3daa$export$243e62d78d3b544d.VERBOSE, ...args);
    }
    info(...args) {
        this._userLogHandler && this._userLogHandler(this, $8d6f06fe55aa3daa$export$243e62d78d3b544d.INFO, ...args);
        this._logHandler(this, $8d6f06fe55aa3daa$export$243e62d78d3b544d.INFO, ...args);
    }
    warn(...args) {
        this._userLogHandler && this._userLogHandler(this, $8d6f06fe55aa3daa$export$243e62d78d3b544d.WARN, ...args);
        this._logHandler(this, $8d6f06fe55aa3daa$export$243e62d78d3b544d.WARN, ...args);
    }
    error(...args) {
        this._userLogHandler && this._userLogHandler(this, $8d6f06fe55aa3daa$export$243e62d78d3b544d.ERROR, ...args);
        this._logHandler(this, $8d6f06fe55aa3daa$export$243e62d78d3b544d.ERROR, ...args);
    }
    /**
     * Gives you an instance of a Logger to capture messages according to
     * Firebase's logging scheme.
     *
     * @param name The name that the logs will be associated with
     */ constructor(name){
        this.name = name;
        /**
         * The log level of the given Logger instance.
         */ this._logLevel = $8d6f06fe55aa3daa$var$defaultLogLevel;
        /**
         * The main (internal) log handler for the Logger instance.
         * Can be set to a new function in internal package code but not by user.
         */ this._logHandler = $8d6f06fe55aa3daa$var$defaultLogHandler;
        /**
         * The optional, additional, user-defined log handler for the Logger instance.
         */ this._userLogHandler = null;
        /**
         * Capture the current instance for later use
         */ $8d6f06fe55aa3daa$var$instances.push(this);
    }
}
function $8d6f06fe55aa3daa$export$c622e99c0ce7b1c9(level) {
    $8d6f06fe55aa3daa$var$instances.forEach((inst)=>{
        inst.setLogLevel(level);
    });
}
function $8d6f06fe55aa3daa$export$29577d29c84db5f6(logCallback, options) {
    for (const instance of $8d6f06fe55aa3daa$var$instances){
        let customLogLevel = null;
        if (options && options.level) customLogLevel = $8d6f06fe55aa3daa$var$levelStringToEnum[options.level];
        if (logCallback === null) instance.userLogHandler = null;
        else instance.userLogHandler = (instance, level, ...args)=>{
            const message = args.map((arg)=>{
                if (arg == null) return null;
                else if (typeof arg === "string") return arg;
                else if (typeof arg === "number" || typeof arg === "boolean") return arg.toString();
                else if (arg instanceof Error) return arg.message;
                else try {
                    return JSON.stringify(arg);
                } catch (ignored) {
                    return null;
                }
            }).filter((arg)=>arg).join(" ");
            if (level >= (customLogLevel !== null && customLogLevel !== void 0 ? customLogLevel : instance.logLevel)) logCallback({
                level: $8d6f06fe55aa3daa$export$243e62d78d3b544d[level].toLowerCase(),
                message: message,
                args: args,
                type: instance.name
            });
        };
    }
}

});

parcelRegister("hpRWE", function(module, exports) {

$parcel$export(module.exports, "openDB", function () { return $cade9dcfc100e56b$export$ca0ed41b1a2af7e; });

var $e2MJs = parcelRequire("e2MJs");
/**
 * Open a database.
 *
 * @param name Name of the database.
 * @param version Schema version.
 * @param callbacks Additional callbacks.
 */ function $cade9dcfc100e56b$export$ca0ed41b1a2af7e(name, version, { blocked: blocked, upgrade: upgrade, blocking: blocking, terminated: terminated } = {}) {
    const request = indexedDB.open(name, version);
    const openPromise = (0, $e2MJs.w)(request);
    if (upgrade) request.addEventListener("upgradeneeded", (event)=>{
        upgrade((0, $e2MJs.w)(request.result), event.oldVersion, event.newVersion, (0, $e2MJs.w)(request.transaction));
    });
    if (blocked) request.addEventListener("blocked", ()=>blocked());
    openPromise.then((db)=>{
        if (terminated) db.addEventListener("close", ()=>terminated());
        if (blocking) db.addEventListener("versionchange", ()=>blocking());
    }).catch(()=>{});
    return openPromise;
}
/**
 * Delete a database.
 *
 * @param name Name of the database.
 */ function $cade9dcfc100e56b$export$9d6df0ac66a98bb2(name, { blocked: blocked } = {}) {
    const request = indexedDB.deleteDatabase(name);
    if (blocked) request.addEventListener("blocked", ()=>blocked());
    return (0, $e2MJs.w)(request).then(()=>undefined);
}
const $cade9dcfc100e56b$var$readMethods = [
    "get",
    "getKey",
    "getAll",
    "getAllKeys",
    "count"
];
const $cade9dcfc100e56b$var$writeMethods = [
    "put",
    "add",
    "delete",
    "clear"
];
const $cade9dcfc100e56b$var$cachedMethods = new Map();
function $cade9dcfc100e56b$var$getMethod(target, prop) {
    if (!(target instanceof IDBDatabase && !(prop in target) && typeof prop === "string")) return;
    if ($cade9dcfc100e56b$var$cachedMethods.get(prop)) return $cade9dcfc100e56b$var$cachedMethods.get(prop);
    const targetFuncName = prop.replace(/FromIndex$/, "");
    const useIndex = prop !== targetFuncName;
    const isWrite = $cade9dcfc100e56b$var$writeMethods.includes(targetFuncName);
    if (// Bail if the target doesn't exist on the target. Eg, getAll isn't in Edge.
    !(targetFuncName in (useIndex ? IDBIndex : IDBObjectStore).prototype) || !(isWrite || $cade9dcfc100e56b$var$readMethods.includes(targetFuncName))) return;
    const method = async function(storeName, ...args) {
        // isWrite ? 'readwrite' : undefined gzipps better, but fails in Edge :(
        const tx = this.transaction(storeName, isWrite ? "readwrite" : "readonly");
        let target = tx.store;
        if (useIndex) target = target.index(args.shift());
        // Must reject if op rejects.
        // If it's a write operation, must reject if tx.done rejects.
        // Must reject with op rejection first.
        // Must resolve with op value.
        // Must handle both promises (no unhandled rejections)
        return (await Promise.all([
            target[targetFuncName](...args),
            isWrite && tx.done
        ]))[0];
    };
    $cade9dcfc100e56b$var$cachedMethods.set(prop, method);
    return method;
}
(0, $e2MJs.r)((oldTraps)=>({
        ...oldTraps,
        get: (target, prop, receiver)=>$cade9dcfc100e56b$var$getMethod(target, prop) || oldTraps.get(target, prop, receiver),
        has: (target, prop)=>!!$cade9dcfc100e56b$var$getMethod(target, prop) || oldTraps.has(target, prop)
    }));

});
parcelRegister("e2MJs", function(module, exports) {

$parcel$export(module.exports, "w", function () { return $a3970dcf2d7d0cd6$export$efccba1c4a2ef57b; });
$parcel$export(module.exports, "r", function () { return $a3970dcf2d7d0cd6$export$43caf9889c228507; });
const $a3970dcf2d7d0cd6$export$23f2a1d2818174ef = (object, constructors)=>constructors.some((c)=>object instanceof c);
let $a3970dcf2d7d0cd6$var$idbProxyableTypes;
let $a3970dcf2d7d0cd6$var$cursorAdvanceMethods;
// This is a function to prevent it throwing up in node environments.
function $a3970dcf2d7d0cd6$var$getIdbProxyableTypes() {
    return $a3970dcf2d7d0cd6$var$idbProxyableTypes || ($a3970dcf2d7d0cd6$var$idbProxyableTypes = [
        IDBDatabase,
        IDBObjectStore,
        IDBIndex,
        IDBCursor,
        IDBTransaction
    ]);
}
// This is a function to prevent it throwing up in node environments.
function $a3970dcf2d7d0cd6$var$getCursorAdvanceMethods() {
    return $a3970dcf2d7d0cd6$var$cursorAdvanceMethods || ($a3970dcf2d7d0cd6$var$cursorAdvanceMethods = [
        IDBCursor.prototype.advance,
        IDBCursor.prototype.continue,
        IDBCursor.prototype.continuePrimaryKey
    ]);
}
const $a3970dcf2d7d0cd6$var$cursorRequestMap = new WeakMap();
const $a3970dcf2d7d0cd6$var$transactionDoneMap = new WeakMap();
const $a3970dcf2d7d0cd6$var$transactionStoreNamesMap = new WeakMap();
const $a3970dcf2d7d0cd6$var$transformCache = new WeakMap();
const $a3970dcf2d7d0cd6$export$407448d2b89b1813 = new WeakMap();
function $a3970dcf2d7d0cd6$var$promisifyRequest(request) {
    const promise = new Promise((resolve, reject)=>{
        const unlisten = ()=>{
            request.removeEventListener("success", success);
            request.removeEventListener("error", error);
        };
        const success = ()=>{
            resolve($a3970dcf2d7d0cd6$export$efccba1c4a2ef57b(request.result));
            unlisten();
        };
        const error = ()=>{
            reject(request.error);
            unlisten();
        };
        request.addEventListener("success", success);
        request.addEventListener("error", error);
    });
    promise.then((value)=>{
        // Since cursoring reuses the IDBRequest (*sigh*), we cache it for later retrieval
        // (see wrapFunction).
        if (value instanceof IDBCursor) $a3970dcf2d7d0cd6$var$cursorRequestMap.set(value, request);
    // Catching to avoid "Uncaught Promise exceptions"
    }).catch(()=>{});
    // This mapping exists in reverseTransformCache but doesn't doesn't exist in transformCache. This
    // is because we create many promises from a single IDBRequest.
    $a3970dcf2d7d0cd6$export$407448d2b89b1813.set(promise, request);
    return promise;
}
function $a3970dcf2d7d0cd6$var$cacheDonePromiseForTransaction(tx) {
    // Early bail if we've already created a done promise for this transaction.
    if ($a3970dcf2d7d0cd6$var$transactionDoneMap.has(tx)) return;
    const done = new Promise((resolve, reject)=>{
        const unlisten = ()=>{
            tx.removeEventListener("complete", complete);
            tx.removeEventListener("error", error);
            tx.removeEventListener("abort", error);
        };
        const complete = ()=>{
            resolve();
            unlisten();
        };
        const error = ()=>{
            reject(tx.error || new DOMException("AbortError", "AbortError"));
            unlisten();
        };
        tx.addEventListener("complete", complete);
        tx.addEventListener("error", error);
        tx.addEventListener("abort", error);
    });
    // Cache it for later retrieval.
    $a3970dcf2d7d0cd6$var$transactionDoneMap.set(tx, done);
}
let $a3970dcf2d7d0cd6$var$idbProxyTraps = {
    get (target, prop, receiver) {
        if (target instanceof IDBTransaction) {
            // Special handling for transaction.done.
            if (prop === "done") return $a3970dcf2d7d0cd6$var$transactionDoneMap.get(target);
            // Polyfill for objectStoreNames because of Edge.
            if (prop === "objectStoreNames") return target.objectStoreNames || $a3970dcf2d7d0cd6$var$transactionStoreNamesMap.get(target);
            // Make tx.store return the only store in the transaction, or undefined if there are many.
            if (prop === "store") return receiver.objectStoreNames[1] ? undefined : receiver.objectStore(receiver.objectStoreNames[0]);
        }
        // Else transform whatever we get back.
        return $a3970dcf2d7d0cd6$export$efccba1c4a2ef57b(target[prop]);
    },
    set (target, prop, value) {
        target[prop] = value;
        return true;
    },
    has (target, prop) {
        if (target instanceof IDBTransaction && (prop === "done" || prop === "store")) return true;
        return prop in target;
    }
};
function $a3970dcf2d7d0cd6$export$43caf9889c228507(callback) {
    $a3970dcf2d7d0cd6$var$idbProxyTraps = callback($a3970dcf2d7d0cd6$var$idbProxyTraps);
}
function $a3970dcf2d7d0cd6$var$wrapFunction(func) {
    // Due to expected object equality (which is enforced by the caching in `wrap`), we
    // only create one new func per func.
    // Edge doesn't support objectStoreNames (booo), so we polyfill it here.
    if (func === IDBDatabase.prototype.transaction && !("objectStoreNames" in IDBTransaction.prototype)) return function(storeNames, ...args) {
        const tx = func.call($a3970dcf2d7d0cd6$export$3b14a55fb2447963(this), storeNames, ...args);
        $a3970dcf2d7d0cd6$var$transactionStoreNamesMap.set(tx, storeNames.sort ? storeNames.sort() : [
            storeNames
        ]);
        return $a3970dcf2d7d0cd6$export$efccba1c4a2ef57b(tx);
    };
    // Cursor methods are special, as the behaviour is a little more different to standard IDB. In
    // IDB, you advance the cursor and wait for a new 'success' on the IDBRequest that gave you the
    // cursor. It's kinda like a promise that can resolve with many values. That doesn't make sense
    // with real promises, so each advance methods returns a new promise for the cursor object, or
    // undefined if the end of the cursor has been reached.
    if ($a3970dcf2d7d0cd6$var$getCursorAdvanceMethods().includes(func)) return function(...args) {
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        func.apply($a3970dcf2d7d0cd6$export$3b14a55fb2447963(this), args);
        return $a3970dcf2d7d0cd6$export$efccba1c4a2ef57b($a3970dcf2d7d0cd6$var$cursorRequestMap.get(this));
    };
    return function(...args) {
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        return $a3970dcf2d7d0cd6$export$efccba1c4a2ef57b(func.apply($a3970dcf2d7d0cd6$export$3b14a55fb2447963(this), args));
    };
}
function $a3970dcf2d7d0cd6$var$transformCachableValue(value) {
    if (typeof value === "function") return $a3970dcf2d7d0cd6$var$wrapFunction(value);
    // This doesn't return, it just creates a 'done' promise for the transaction,
    // which is later returned for transaction.done (see idbObjectHandler).
    if (value instanceof IDBTransaction) $a3970dcf2d7d0cd6$var$cacheDonePromiseForTransaction(value);
    if ($a3970dcf2d7d0cd6$export$23f2a1d2818174ef(value, $a3970dcf2d7d0cd6$var$getIdbProxyableTypes())) return new Proxy(value, $a3970dcf2d7d0cd6$var$idbProxyTraps);
    // Return the same value back if we're not going to transform it.
    return value;
}
function $a3970dcf2d7d0cd6$export$efccba1c4a2ef57b(value) {
    // We sometimes generate multiple promises from a single IDBRequest (eg when cursoring), because
    // IDB is weird and a single IDBRequest can yield many responses, so these can't be cached.
    if (value instanceof IDBRequest) return $a3970dcf2d7d0cd6$var$promisifyRequest(value);
    // If we've already transformed this value before, reuse the transformed value.
    // This is faster, but it also provides object equality.
    if ($a3970dcf2d7d0cd6$var$transformCache.has(value)) return $a3970dcf2d7d0cd6$var$transformCache.get(value);
    const newValue = $a3970dcf2d7d0cd6$var$transformCachableValue(value);
    // Not all types are transformed.
    // These may be primitive types, so they can't be WeakMap keys.
    if (newValue !== value) {
        $a3970dcf2d7d0cd6$var$transformCache.set(value, newValue);
        $a3970dcf2d7d0cd6$export$407448d2b89b1813.set(newValue, value);
    }
    return newValue;
}
const $a3970dcf2d7d0cd6$export$3b14a55fb2447963 = (value)=>$a3970dcf2d7d0cd6$export$407448d2b89b1813.get(value);

});



parcelRegister("k2nG7", function(module, exports) {

$parcel$export(module.exports, "__rest", function () { return $e9665c8d2b37cc67$export$3c9a16f847548506; });
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $e9665c8d2b37cc67$var$extendStatics = function(d, b) {
    $e9665c8d2b37cc67$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $e9665c8d2b37cc67$var$extendStatics(d, b);
};
function $e9665c8d2b37cc67$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $e9665c8d2b37cc67$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $e9665c8d2b37cc67$export$18ce0697a983be9b = function() {
    $e9665c8d2b37cc67$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $e9665c8d2b37cc67$export$18ce0697a983be9b.apply(this, arguments);
};
function $e9665c8d2b37cc67$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $e9665c8d2b37cc67$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $e9665c8d2b37cc67$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $e9665c8d2b37cc67$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $e9665c8d2b37cc67$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $e9665c8d2b37cc67$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $e9665c8d2b37cc67$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $e9665c8d2b37cc67$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $e9665c8d2b37cc67$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $e9665c8d2b37cc67$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $e9665c8d2b37cc67$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $e9665c8d2b37cc67$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $e9665c8d2b37cc67$export$45d3717a4c69092e(o, m, p);
}
function $e9665c8d2b37cc67$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $e9665c8d2b37cc67$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $e9665c8d2b37cc67$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($e9665c8d2b37cc67$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $e9665c8d2b37cc67$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $e9665c8d2b37cc67$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $e9665c8d2b37cc67$export$10c90e4f7922046c(v) {
    return this instanceof $e9665c8d2b37cc67$export$10c90e4f7922046c ? (this.v = v, this) : new $e9665c8d2b37cc67$export$10c90e4f7922046c(v);
}
function $e9665c8d2b37cc67$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $e9665c8d2b37cc67$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $e9665c8d2b37cc67$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $e9665c8d2b37cc67$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $e9665c8d2b37cc67$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $e9665c8d2b37cc67$export$19a8beecd37a4c45 === "function" ? $e9665c8d2b37cc67$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $e9665c8d2b37cc67$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $e9665c8d2b37cc67$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $e9665c8d2b37cc67$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $e9665c8d2b37cc67$export$45d3717a4c69092e(result, mod, k);
    }
    $e9665c8d2b37cc67$var$__setModuleDefault(result, mod);
    return result;
}
function $e9665c8d2b37cc67$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $e9665c8d2b37cc67$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $e9665c8d2b37cc67$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $e9665c8d2b37cc67$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $e9665c8d2b37cc67$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $e9665c8d2b37cc67$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $e9665c8d2b37cc67$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $e9665c8d2b37cc67$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $e9665c8d2b37cc67$export$2e2bcd8739ae039 = {
    __extends: $e9665c8d2b37cc67$export$a8ba968b8961cb8a,
    __assign: $e9665c8d2b37cc67$export$18ce0697a983be9b,
    __rest: $e9665c8d2b37cc67$export$3c9a16f847548506,
    __decorate: $e9665c8d2b37cc67$export$29e00dfd3077644b,
    __param: $e9665c8d2b37cc67$export$d5ad3fd78186038f,
    __metadata: $e9665c8d2b37cc67$export$f1db080c865becb9,
    __awaiter: $e9665c8d2b37cc67$export$1050f835b63b671e,
    __generator: $e9665c8d2b37cc67$export$67ebef60e6f28a6,
    __createBinding: $e9665c8d2b37cc67$export$45d3717a4c69092e,
    __exportStar: $e9665c8d2b37cc67$export$f33643c0debef087,
    __values: $e9665c8d2b37cc67$export$19a8beecd37a4c45,
    __read: $e9665c8d2b37cc67$export$8d051b38c9118094,
    __spread: $e9665c8d2b37cc67$export$afc72e2116322959,
    __spreadArrays: $e9665c8d2b37cc67$export$6388937ca91ccae8,
    __spreadArray: $e9665c8d2b37cc67$export$1216008129fb82ed,
    __await: $e9665c8d2b37cc67$export$10c90e4f7922046c,
    __asyncGenerator: $e9665c8d2b37cc67$export$e427f37a30a4de9b,
    __asyncDelegator: $e9665c8d2b37cc67$export$bbd80228419bb833,
    __asyncValues: $e9665c8d2b37cc67$export$e3b29a3d6162315f,
    __makeTemplateObject: $e9665c8d2b37cc67$export$4fb47efe1390b86f,
    __importStar: $e9665c8d2b37cc67$export$c21735bcef00d192,
    __importDefault: $e9665c8d2b37cc67$export$da59b14a69baef04,
    __classPrivateFieldGet: $e9665c8d2b37cc67$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $e9665c8d2b37cc67$export$d40a35129aaff81f,
    __classPrivateFieldIn: $e9665c8d2b37cc67$export$81fdc39f203e4e04,
    __addDisposableResource: $e9665c8d2b37cc67$export$88ac25d8e944e405,
    __disposeResources: $e9665c8d2b37cc67$export$8f076105dc360e92
};

});

parcelRegister("bfcN2", function(module, exports) {

$parcel$export(module.exports, "LogLevel", function () { return $82fb04408417c009$export$243e62d78d3b544d; });
$parcel$export(module.exports, "Logger", function () { return $82fb04408417c009$export$efa9a398d6368992; });
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A container for all of the Logger instances
 */ const $82fb04408417c009$var$instances = [];
/**
 * The JS SDK supports 5 log levels and also allows a user the ability to
 * silence the logs altogether.
 *
 * The order is a follows:
 * DEBUG < VERBOSE < INFO < WARN < ERROR
 *
 * All of the log types above the current log level will be captured (i.e. if
 * you set the log level to `INFO`, errors will still be logged, but `DEBUG` and
 * `VERBOSE` logs will not)
 */ var $82fb04408417c009$export$243e62d78d3b544d;
(function(LogLevel) {
    LogLevel[LogLevel["DEBUG"] = 0] = "DEBUG";
    LogLevel[LogLevel["VERBOSE"] = 1] = "VERBOSE";
    LogLevel[LogLevel["INFO"] = 2] = "INFO";
    LogLevel[LogLevel["WARN"] = 3] = "WARN";
    LogLevel[LogLevel["ERROR"] = 4] = "ERROR";
    LogLevel[LogLevel["SILENT"] = 5] = "SILENT";
})($82fb04408417c009$export$243e62d78d3b544d || ($82fb04408417c009$export$243e62d78d3b544d = {}));
const $82fb04408417c009$var$levelStringToEnum = {
    "debug": $82fb04408417c009$export$243e62d78d3b544d.DEBUG,
    "verbose": $82fb04408417c009$export$243e62d78d3b544d.VERBOSE,
    "info": $82fb04408417c009$export$243e62d78d3b544d.INFO,
    "warn": $82fb04408417c009$export$243e62d78d3b544d.WARN,
    "error": $82fb04408417c009$export$243e62d78d3b544d.ERROR,
    "silent": $82fb04408417c009$export$243e62d78d3b544d.SILENT
};
/**
 * The default log level
 */ const $82fb04408417c009$var$defaultLogLevel = $82fb04408417c009$export$243e62d78d3b544d.INFO;
/**
 * By default, `console.debug` is not displayed in the developer console (in
 * chrome). To avoid forcing users to have to opt-in to these logs twice
 * (i.e. once for firebase, and once in the console), we are sending `DEBUG`
 * logs to the `console.log` function.
 */ const $82fb04408417c009$var$ConsoleMethod = {
    [$82fb04408417c009$export$243e62d78d3b544d.DEBUG]: "log",
    [$82fb04408417c009$export$243e62d78d3b544d.VERBOSE]: "log",
    [$82fb04408417c009$export$243e62d78d3b544d.INFO]: "info",
    [$82fb04408417c009$export$243e62d78d3b544d.WARN]: "warn",
    [$82fb04408417c009$export$243e62d78d3b544d.ERROR]: "error"
};
/**
 * The default log handler will forward DEBUG, VERBOSE, INFO, WARN, and ERROR
 * messages on to their corresponding console counterparts (if the log method
 * is supported by the current log level)
 */ const $82fb04408417c009$var$defaultLogHandler = (instance, logType, ...args)=>{
    if (logType < instance.logLevel) return;
    const now = new Date().toISOString();
    const method = $82fb04408417c009$var$ConsoleMethod[logType];
    if (method) console[method](`[${now}]  ${instance.name}:`, ...args);
    else throw new Error(`Attempted to log a message with an invalid logType (value: ${logType})`);
};
class $82fb04408417c009$export$efa9a398d6368992 {
    get logLevel() {
        return this._logLevel;
    }
    set logLevel(val) {
        if (!(val in $82fb04408417c009$export$243e62d78d3b544d)) throw new TypeError(`Invalid value "${val}" assigned to \`logLevel\``);
        this._logLevel = val;
    }
    // Workaround for setter/getter having to be the same type.
    setLogLevel(val) {
        this._logLevel = typeof val === "string" ? $82fb04408417c009$var$levelStringToEnum[val] : val;
    }
    get logHandler() {
        return this._logHandler;
    }
    set logHandler(val) {
        if (typeof val !== "function") throw new TypeError("Value assigned to `logHandler` must be a function");
        this._logHandler = val;
    }
    get userLogHandler() {
        return this._userLogHandler;
    }
    set userLogHandler(val) {
        this._userLogHandler = val;
    }
    /**
     * The functions below are all based on the `console` interface
     */ debug(...args) {
        this._userLogHandler && this._userLogHandler(this, $82fb04408417c009$export$243e62d78d3b544d.DEBUG, ...args);
        this._logHandler(this, $82fb04408417c009$export$243e62d78d3b544d.DEBUG, ...args);
    }
    log(...args) {
        this._userLogHandler && this._userLogHandler(this, $82fb04408417c009$export$243e62d78d3b544d.VERBOSE, ...args);
        this._logHandler(this, $82fb04408417c009$export$243e62d78d3b544d.VERBOSE, ...args);
    }
    info(...args) {
        this._userLogHandler && this._userLogHandler(this, $82fb04408417c009$export$243e62d78d3b544d.INFO, ...args);
        this._logHandler(this, $82fb04408417c009$export$243e62d78d3b544d.INFO, ...args);
    }
    warn(...args) {
        this._userLogHandler && this._userLogHandler(this, $82fb04408417c009$export$243e62d78d3b544d.WARN, ...args);
        this._logHandler(this, $82fb04408417c009$export$243e62d78d3b544d.WARN, ...args);
    }
    error(...args) {
        this._userLogHandler && this._userLogHandler(this, $82fb04408417c009$export$243e62d78d3b544d.ERROR, ...args);
        this._logHandler(this, $82fb04408417c009$export$243e62d78d3b544d.ERROR, ...args);
    }
    /**
     * Gives you an instance of a Logger to capture messages according to
     * Firebase's logging scheme.
     *
     * @param name The name that the logs will be associated with
     */ constructor(name){
        this.name = name;
        /**
         * The log level of the given Logger instance.
         */ this._logLevel = $82fb04408417c009$var$defaultLogLevel;
        /**
         * The main (internal) log handler for the Logger instance.
         * Can be set to a new function in internal package code but not by user.
         */ this._logHandler = $82fb04408417c009$var$defaultLogHandler;
        /**
         * The optional, additional, user-defined log handler for the Logger instance.
         */ this._userLogHandler = null;
        /**
         * Capture the current instance for later use
         */ $82fb04408417c009$var$instances.push(this);
    }
}
function $82fb04408417c009$export$c622e99c0ce7b1c9(level) {
    $82fb04408417c009$var$instances.forEach((inst)=>{
        inst.setLogLevel(level);
    });
}
function $82fb04408417c009$export$29577d29c84db5f6(logCallback, options) {
    for (const instance of $82fb04408417c009$var$instances){
        let customLogLevel = null;
        if (options && options.level) customLogLevel = $82fb04408417c009$var$levelStringToEnum[options.level];
        if (logCallback === null) instance.userLogHandler = null;
        else instance.userLogHandler = (instance, level, ...args)=>{
            const message = args.map((arg)=>{
                if (arg == null) return null;
                else if (typeof arg === "string") return arg;
                else if (typeof arg === "number" || typeof arg === "boolean") return arg.toString();
                else if (arg instanceof Error) return arg.message;
                else try {
                    return JSON.stringify(arg);
                } catch (ignored) {
                    return null;
                }
            }).filter((arg)=>arg).join(" ");
            if (level >= (customLogLevel !== null && customLogLevel !== void 0 ? customLogLevel : instance.logLevel)) logCallback({
                level: $82fb04408417c009$export$243e62d78d3b544d[level].toLowerCase(),
                message: message,
                args: args,
                type: instance.name
            });
        };
    }
}

});

parcelRegister("kOJH8", function(module, exports) {

$parcel$export(module.exports, "Component", function () { return $f27bec2e9d071a95$export$16fa2f45be04daa8; });

var $6vM9o = parcelRequire("6vM9o");
/**
 * Component for service name T, e.g. `auth`, `auth-internal`
 */ class $f27bec2e9d071a95$export$16fa2f45be04daa8 {
    setInstantiationMode(mode) {
        this.instantiationMode = mode;
        return this;
    }
    setMultipleInstances(multipleInstances) {
        this.multipleInstances = multipleInstances;
        return this;
    }
    setServiceProps(props) {
        this.serviceProps = props;
        return this;
    }
    setInstanceCreatedCallback(callback) {
        this.onInstanceCreated = callback;
        return this;
    }
    /**
     *
     * @param name The public service name, e.g. app, auth, firestore, database
     * @param instanceFactory Service factory responsible for creating the public interface
     * @param type whether the service provided by the component is public or private
     */ constructor(name, instanceFactory, type){
        this.name = name;
        this.instanceFactory = instanceFactory;
        this.type = type;
        this.multipleInstances = false;
        /**
         * Properties to be added to the service namespace
         */ this.serviceProps = {};
        this.instantiationMode = "LAZY" /* LAZY */ ;
        this.onInstanceCreated = null;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $f27bec2e9d071a95$var$DEFAULT_ENTRY_NAME = "[DEFAULT]";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for instance for service name T, e.g. 'auth', 'auth-internal'
 * NameServiceMapping[T] is an alias for the type of the instance
 */ class $f27bec2e9d071a95$export$2881499e37b75b9a {
    /**
     * @param identifier A provider can provide mulitple instances of a service
     * if this.component.multipleInstances is true.
     */ get(identifier) {
        // if multipleInstances is not supported, use the default name
        const normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
        if (!this.instancesDeferred.has(normalizedIdentifier)) {
            const deferred = new (0, $6vM9o.Deferred)();
            this.instancesDeferred.set(normalizedIdentifier, deferred);
            if (this.isInitialized(normalizedIdentifier) || this.shouldAutoInitialize()) // initialize the service if it can be auto-initialized
            try {
                const instance = this.getOrInitializeService({
                    instanceIdentifier: normalizedIdentifier
                });
                if (instance) deferred.resolve(instance);
            } catch (e) {
            // when the instance factory throws an exception during get(), it should not cause
            // a fatal error. We just return the unresolved promise in this case.
            }
        }
        return this.instancesDeferred.get(normalizedIdentifier).promise;
    }
    getImmediate(options) {
        var _a;
        // if multipleInstances is not supported, use the default name
        const normalizedIdentifier = this.normalizeInstanceIdentifier(options === null || options === void 0 ? void 0 : options.identifier);
        const optional = (_a = options === null || options === void 0 ? void 0 : options.optional) !== null && _a !== void 0 ? _a : false;
        if (this.isInitialized(normalizedIdentifier) || this.shouldAutoInitialize()) try {
            return this.getOrInitializeService({
                instanceIdentifier: normalizedIdentifier
            });
        } catch (e) {
            if (optional) return null;
            else throw e;
        }
        else {
            // In case a component is not initialized and should/can not be auto-initialized at the moment, return null if the optional flag is set, or throw
            if (optional) return null;
            else throw Error(`Service ${this.name} is not available`);
        }
    }
    getComponent() {
        return this.component;
    }
    setComponent(component) {
        if (component.name !== this.name) throw Error(`Mismatching Component ${component.name} for Provider ${this.name}.`);
        if (this.component) throw Error(`Component for ${this.name} has already been provided`);
        this.component = component;
        // return early without attempting to initialize the component if the component requires explicit initialization (calling `Provider.initialize()`)
        if (!this.shouldAutoInitialize()) return;
        // if the service is eager, initialize the default instance
        if ($f27bec2e9d071a95$var$isComponentEager(component)) try {
            this.getOrInitializeService({
                instanceIdentifier: $f27bec2e9d071a95$var$DEFAULT_ENTRY_NAME
            });
        } catch (e) {
        // when the instance factory for an eager Component throws an exception during the eager
        // initialization, it should not cause a fatal error.
        // TODO: Investigate if we need to make it configurable, because some component may want to cause
        // a fatal error in this case?
        }
        // Create service instances for the pending promises and resolve them
        // NOTE: if this.multipleInstances is false, only the default instance will be created
        // and all promises with resolve with it regardless of the identifier.
        for (const [instanceIdentifier, instanceDeferred] of this.instancesDeferred.entries()){
            const normalizedIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
            try {
                // `getOrInitializeService()` should always return a valid instance since a component is guaranteed. use ! to make typescript happy.
                const instance = this.getOrInitializeService({
                    instanceIdentifier: normalizedIdentifier
                });
                instanceDeferred.resolve(instance);
            } catch (e) {
            // when the instance factory throws an exception, it should not cause
            // a fatal error. We just leave the promise unresolved.
            }
        }
    }
    clearInstance(identifier = $f27bec2e9d071a95$var$DEFAULT_ENTRY_NAME) {
        this.instancesDeferred.delete(identifier);
        this.instancesOptions.delete(identifier);
        this.instances.delete(identifier);
    }
    // app.delete() will call this method on every provider to delete the services
    // TODO: should we mark the provider as deleted?
    async delete() {
        const services = Array.from(this.instances.values());
        await Promise.all([
            ...services.filter((service)=>"INTERNAL" in service) // legacy services
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .map((service)=>service.INTERNAL.delete()),
            ...services.filter((service)=>"_delete" in service) // modularized services
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .map((service)=>service._delete())
        ]);
    }
    isComponentSet() {
        return this.component != null;
    }
    isInitialized(identifier = $f27bec2e9d071a95$var$DEFAULT_ENTRY_NAME) {
        return this.instances.has(identifier);
    }
    getOptions(identifier = $f27bec2e9d071a95$var$DEFAULT_ENTRY_NAME) {
        return this.instancesOptions.get(identifier) || {};
    }
    initialize(opts = {}) {
        const { options: options = {} } = opts;
        const normalizedIdentifier = this.normalizeInstanceIdentifier(opts.instanceIdentifier);
        if (this.isInitialized(normalizedIdentifier)) throw Error(`${this.name}(${normalizedIdentifier}) has already been initialized`);
        if (!this.isComponentSet()) throw Error(`Component ${this.name} has not been registered yet`);
        const instance = this.getOrInitializeService({
            instanceIdentifier: normalizedIdentifier,
            options: options
        });
        // resolve any pending promise waiting for the service instance
        for (const [instanceIdentifier, instanceDeferred] of this.instancesDeferred.entries()){
            const normalizedDeferredIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
            if (normalizedIdentifier === normalizedDeferredIdentifier) instanceDeferred.resolve(instance);
        }
        return instance;
    }
    /**
     *
     * @param callback - a function that will be invoked  after the provider has been initialized by calling provider.initialize().
     * The function is invoked SYNCHRONOUSLY, so it should not execute any longrunning tasks in order to not block the program.
     *
     * @param identifier An optional instance identifier
     * @returns a function to unregister the callback
     */ onInit(callback, identifier) {
        var _a;
        const normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
        const existingCallbacks = (_a = this.onInitCallbacks.get(normalizedIdentifier)) !== null && _a !== void 0 ? _a : new Set();
        existingCallbacks.add(callback);
        this.onInitCallbacks.set(normalizedIdentifier, existingCallbacks);
        const existingInstance = this.instances.get(normalizedIdentifier);
        if (existingInstance) callback(existingInstance, normalizedIdentifier);
        return ()=>{
            existingCallbacks.delete(callback);
        };
    }
    /**
     * Invoke onInit callbacks synchronously
     * @param instance the service instance`
     */ invokeOnInitCallbacks(instance, identifier) {
        const callbacks = this.onInitCallbacks.get(identifier);
        if (!callbacks) return;
        for (const callback of callbacks)try {
            callback(instance, identifier);
        } catch (_a) {
        // ignore errors in the onInit callback
        }
    }
    getOrInitializeService({ instanceIdentifier: instanceIdentifier, options: options = {} }) {
        let instance = this.instances.get(instanceIdentifier);
        if (!instance && this.component) {
            instance = this.component.instanceFactory(this.container, {
                instanceIdentifier: $f27bec2e9d071a95$var$normalizeIdentifierForFactory(instanceIdentifier),
                options: options
            });
            this.instances.set(instanceIdentifier, instance);
            this.instancesOptions.set(instanceIdentifier, options);
            /**
             * Invoke onInit listeners.
             * Note this.component.onInstanceCreated is different, which is used by the component creator,
             * while onInit listeners are registered by consumers of the provider.
             */ this.invokeOnInitCallbacks(instance, instanceIdentifier);
            /**
             * Order is important
             * onInstanceCreated() should be called after this.instances.set(instanceIdentifier, instance); which
             * makes `isInitialized()` return true.
             */ if (this.component.onInstanceCreated) try {
                this.component.onInstanceCreated(this.container, instanceIdentifier, instance);
            } catch (_a) {
            // ignore errors in the onInstanceCreatedCallback
            }
        }
        return instance || null;
    }
    normalizeInstanceIdentifier(identifier = $f27bec2e9d071a95$var$DEFAULT_ENTRY_NAME) {
        if (this.component) return this.component.multipleInstances ? identifier : $f27bec2e9d071a95$var$DEFAULT_ENTRY_NAME;
        else return identifier; // assume multiple instances are supported before the component is provided.
    }
    shouldAutoInitialize() {
        return !!this.component && this.component.instantiationMode !== "EXPLICIT" /* EXPLICIT */ ;
    }
    constructor(name, container){
        this.name = name;
        this.container = container;
        this.component = null;
        this.instances = new Map();
        this.instancesDeferred = new Map();
        this.instancesOptions = new Map();
        this.onInitCallbacks = new Map();
    }
}
// undefined should be passed to the service factory for the default instance
function $f27bec2e9d071a95$var$normalizeIdentifierForFactory(identifier) {
    return identifier === $f27bec2e9d071a95$var$DEFAULT_ENTRY_NAME ? undefined : identifier;
}
function $f27bec2e9d071a95$var$isComponentEager(component) {
    return component.instantiationMode === "EAGER" /* EAGER */ ;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * ComponentContainer that provides Providers for service name T, e.g. `auth`, `auth-internal`
 */ class $f27bec2e9d071a95$export$436a80eea5d5c0c5 {
    /**
     *
     * @param component Component being added
     * @param overwrite When a component with the same name has already been registered,
     * if overwrite is true: overwrite the existing component with the new component and create a new
     * provider with the new component. It can be useful in tests where you want to use different mocks
     * for different tests.
     * if overwrite is false: throw an exception
     */ addComponent(component) {
        const provider = this.getProvider(component.name);
        if (provider.isComponentSet()) throw new Error(`Component ${component.name} has already been registered with ${this.name}`);
        provider.setComponent(component);
    }
    addOrOverwriteComponent(component) {
        const provider = this.getProvider(component.name);
        if (provider.isComponentSet()) // delete the existing provider from the container, so we can register the new component
        this.providers.delete(component.name);
        this.addComponent(component);
    }
    /**
     * getProvider provides a type safe interface where it can only be called with a field name
     * present in NameServiceMapping interface.
     *
     * Firebase SDKs providing services should extend NameServiceMapping interface to register
     * themselves.
     */ getProvider(name) {
        if (this.providers.has(name)) return this.providers.get(name);
        // create a Provider for a service that hasn't registered with Firebase
        const provider = new $f27bec2e9d071a95$export$2881499e37b75b9a(name, this);
        this.providers.set(name, provider);
        return provider;
    }
    getProviders() {
        return Array.from(this.providers.values());
    }
    constructor(name){
        this.name = name;
        this.providers = new Map();
    }
}

});




parcelRegister("8vofH", function(module, exports) {

var $7TObl = parcelRequire("7TObl");
$parcel$exportWildcard(module.exports, $7TObl);

});
parcelRegister("7TObl", function(module, exports) {

$parcel$export(module.exports, "setLogLevel", function () { return $5c04988f82cad1b3$export$c622e99c0ce7b1c9; });
$parcel$export(module.exports, "_logWarn", function () { return $5c04988f82cad1b3$export$86cd73f49cc6e0bb; });
$parcel$export(module.exports, "_debugAssert", function () { return $5c04988f82cad1b3$export$1d2b90eea9bba017; });
$parcel$export(module.exports, "FirestoreError", function () { return $5c04988f82cad1b3$export$8fada0bf726bf278; });
$parcel$export(module.exports, "_EmptyAuthCredentialsProvider", function () { return $5c04988f82cad1b3$export$65ffa50b6039c992; });
$parcel$export(module.exports, "_EmptyAppCheckTokenProvider", function () { return $5c04988f82cad1b3$export$b342cec01954510f; });
$parcel$export(module.exports, "Timestamp", function () { return $5c04988f82cad1b3$export$d9bcbd5e1ff81430; });
$parcel$export(module.exports, "_FieldPath", function () { return $5c04988f82cad1b3$export$b7871852b967eaf1; });
$parcel$export(module.exports, "_DocumentKey", function () { return $5c04988f82cad1b3$export$afc2e57c475b7810; });
$parcel$export(module.exports, "_isBase64Available", function () { return $5c04988f82cad1b3$export$cbfc1605afde699b; });
$parcel$export(module.exports, "_DatabaseId", function () { return $5c04988f82cad1b3$export$4c3ccc07620ae30a; });
$parcel$export(module.exports, "_validateIsNotUsedTogether", function () { return $5c04988f82cad1b3$export$8731e8d1617cddb1; });
$parcel$export(module.exports, "_cast", function () { return $5c04988f82cad1b3$export$572106fb5803752c; });
$parcel$export(module.exports, "connectFirestoreEmulator", function () { return $5c04988f82cad1b3$export$966a03d25297d115; });
$parcel$export(module.exports, "DocumentReference", function () { return $5c04988f82cad1b3$export$6be62b059fb12175; });
$parcel$export(module.exports, "CollectionReference", function () { return $5c04988f82cad1b3$export$ab5a1a47940a200e; });
$parcel$export(module.exports, "Query", function () { return $5c04988f82cad1b3$export$62297b13309008b2; });
$parcel$export(module.exports, "collection", function () { return $5c04988f82cad1b3$export$bf5175b0c24981cd; });
$parcel$export(module.exports, "collectionGroup", function () { return $5c04988f82cad1b3$export$473d82a73f88c107; });
$parcel$export(module.exports, "doc", function () { return $5c04988f82cad1b3$export$2a111da947c407d2; });
$parcel$export(module.exports, "refEqual", function () { return $5c04988f82cad1b3$export$62a32f2da6187d11; });
$parcel$export(module.exports, "queryEqual", function () { return $5c04988f82cad1b3$export$49b1d0de6ba30f41; });
$parcel$export(module.exports, "LoadBundleTask", function () { return $5c04988f82cad1b3$export$6cac12425252ec14; });
$parcel$export(module.exports, "CACHE_SIZE_UNLIMITED", function () { return $5c04988f82cad1b3$export$3e714f2ae27d2df4; });
$parcel$export(module.exports, "Firestore", function () { return $5c04988f82cad1b3$export$d0e2b3272814ce82; });
$parcel$export(module.exports, "initializeFirestore", function () { return $5c04988f82cad1b3$export$9061557f3e3b42f9; });
$parcel$export(module.exports, "getFirestore", function () { return $5c04988f82cad1b3$export$f06a05d14c3a6678; });
$parcel$export(module.exports, "ensureFirestoreConfigured", function () { return $5c04988f82cad1b3$export$8da5fbea04405656; });
$parcel$export(module.exports, "enableIndexedDbPersistence", function () { return $5c04988f82cad1b3$export$cebe3b626a79c5f3; });
$parcel$export(module.exports, "enableMultiTabIndexedDbPersistence", function () { return $5c04988f82cad1b3$export$6d4c055e91302ab9; });
$parcel$export(module.exports, "clearIndexedDbPersistence", function () { return $5c04988f82cad1b3$export$b4f5899b4e28cf7b; });
$parcel$export(module.exports, "waitForPendingWrites", function () { return $5c04988f82cad1b3$export$50b5113fd6653025; });
$parcel$export(module.exports, "enableNetwork", function () { return $5c04988f82cad1b3$export$ee6bdee8287ecc5f; });
$parcel$export(module.exports, "disableNetwork", function () { return $5c04988f82cad1b3$export$f35b708ad73d52eb; });
$parcel$export(module.exports, "terminate", function () { return $5c04988f82cad1b3$export$9aff22d1ec357a14; });
$parcel$export(module.exports, "loadBundle", function () { return $5c04988f82cad1b3$export$4b8b93c690c9810b; });
$parcel$export(module.exports, "namedQuery", function () { return $5c04988f82cad1b3$export$169d2c6fe0f7f4ea; });
$parcel$export(module.exports, "FieldPath", function () { return $5c04988f82cad1b3$export$a1a8fea822d17659; });
$parcel$export(module.exports, "documentId", function () { return $5c04988f82cad1b3$export$bf6e62266977b8eb; });
$parcel$export(module.exports, "Bytes", function () { return $5c04988f82cad1b3$export$9f55f2e2bf8c2fc1; });
$parcel$export(module.exports, "FieldValue", function () { return $5c04988f82cad1b3$export$c58bc8ee7ecc248d; });
$parcel$export(module.exports, "GeoPoint", function () { return $5c04988f82cad1b3$export$f9f719d1b6419c4; });
$parcel$export(module.exports, "SnapshotMetadata", function () { return $5c04988f82cad1b3$export$99d61448206ab5cd; });
$parcel$export(module.exports, "DocumentSnapshot", function () { return $5c04988f82cad1b3$export$acab0e6ef25eb301; });
$parcel$export(module.exports, "QueryDocumentSnapshot", function () { return $5c04988f82cad1b3$export$6d4d04e42af6b03c; });
$parcel$export(module.exports, "QuerySnapshot", function () { return $5c04988f82cad1b3$export$8f21149d8133945c; });
$parcel$export(module.exports, "snapshotEqual", function () { return $5c04988f82cad1b3$export$f243a5d948512846; });
$parcel$export(module.exports, "QueryConstraint", function () { return $5c04988f82cad1b3$export$b0e86f2c7431df4e; });
$parcel$export(module.exports, "query", function () { return $5c04988f82cad1b3$export$2fa187e846a241c4; });
$parcel$export(module.exports, "where", function () { return $5c04988f82cad1b3$export$9c59b80dda569a6e; });
$parcel$export(module.exports, "orderBy", function () { return $5c04988f82cad1b3$export$f18af21d6f4dafd8; });
$parcel$export(module.exports, "limit", function () { return $5c04988f82cad1b3$export$ee37e834aaad6f7e; });
$parcel$export(module.exports, "limitToLast", function () { return $5c04988f82cad1b3$export$f823b3589f69d3b8; });
$parcel$export(module.exports, "startAt", function () { return $5c04988f82cad1b3$export$859941c5fc8eba6b; });
$parcel$export(module.exports, "startAfter", function () { return $5c04988f82cad1b3$export$dd8dee5f7b804673; });
$parcel$export(module.exports, "endBefore", function () { return $5c04988f82cad1b3$export$57203950645b8b11; });
$parcel$export(module.exports, "endAt", function () { return $5c04988f82cad1b3$export$28ec54a8428bdb3f; });
$parcel$export(module.exports, "AbstractUserDataWriter", function () { return $5c04988f82cad1b3$export$2cd31cfe6f6866e9; });
$parcel$export(module.exports, "WriteBatch", function () { return $5c04988f82cad1b3$export$d94ed661b1cfd435; });
$parcel$export(module.exports, "getDoc", function () { return $5c04988f82cad1b3$export$11eb3b5ef9574821; });
$parcel$export(module.exports, "getDocFromCache", function () { return $5c04988f82cad1b3$export$a58bd92642f7fb58; });
$parcel$export(module.exports, "getDocFromServer", function () { return $5c04988f82cad1b3$export$35dd759aed9686b4; });
$parcel$export(module.exports, "getDocs", function () { return $5c04988f82cad1b3$export$81d3477bd73c86ef; });
$parcel$export(module.exports, "getDocsFromCache", function () { return $5c04988f82cad1b3$export$3fd010f18eac1dd; });
$parcel$export(module.exports, "getDocsFromServer", function () { return $5c04988f82cad1b3$export$ec7d9e44f349c77b; });
$parcel$export(module.exports, "setDoc", function () { return $5c04988f82cad1b3$export$5ff77ddaff3c9e12; });
$parcel$export(module.exports, "executeWrite", function () { return $5c04988f82cad1b3$export$1945f8fec9dda613; });
$parcel$export(module.exports, "updateDoc", function () { return $5c04988f82cad1b3$export$22d1fdd1e73faff2; });
$parcel$export(module.exports, "deleteDoc", function () { return $5c04988f82cad1b3$export$a4f20481fae8f78b; });
$parcel$export(module.exports, "addDoc", function () { return $5c04988f82cad1b3$export$a13890143fb1c2dd; });
$parcel$export(module.exports, "onSnapshot", function () { return $5c04988f82cad1b3$export$d36370812fb26935; });
$parcel$export(module.exports, "onSnapshotsInSync", function () { return $5c04988f82cad1b3$export$9dff4f5aba83e348; });
$parcel$export(module.exports, "Transaction", function () { return $5c04988f82cad1b3$export$febc5573c75cefb0; });
$parcel$export(module.exports, "runTransaction", function () { return $5c04988f82cad1b3$export$3c54e006bf9c93b7; });
$parcel$export(module.exports, "deleteField", function () { return $5c04988f82cad1b3$export$2bbad96c62fdba3e; });
$parcel$export(module.exports, "serverTimestamp", function () { return $5c04988f82cad1b3$export$3ff8e7e00c3264b7; });
$parcel$export(module.exports, "arrayUnion", function () { return $5c04988f82cad1b3$export$f62af892fd92610c; });
$parcel$export(module.exports, "arrayRemove", function () { return $5c04988f82cad1b3$export$30a014203d0d7e4f; });
$parcel$export(module.exports, "increment", function () { return $5c04988f82cad1b3$export$a2647aa13413c947; });
$parcel$export(module.exports, "writeBatch", function () { return $5c04988f82cad1b3$export$44cd1c9d57edd9b1; });
$parcel$export(module.exports, "_setIndexConfiguration", function () { return $5c04988f82cad1b3$export$2862db5d92ff7996; });

var $iXpG9 = parcelRequire("iXpG9");

var $k46Iq = parcelRequire("k46Iq");

var $gDOOI = parcelRequire("gDOOI");

var $isbtl = parcelRequire("isbtl");

var $3YLik = parcelRequire("3YLik");

var $i9yYZ = parcelRequire("i9yYZ");
const $5c04988f82cad1b3$var$D = "@firebase/firestore";
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Simple wrapper around a nullable UID. Mostly exists to make code more
 * readable.
 */ class $5c04988f82cad1b3$var$C {
    isAuthenticated() {
        return null != this.uid;
    }
    /**
     * Returns a key representing this user, suitable for inclusion in a
     * dictionary.
     */ toKey() {
        return this.isAuthenticated() ? "uid:" + this.uid : "anonymous-user";
    }
    isEqual(t) {
        return t.uid === this.uid;
    }
    constructor(t){
        this.uid = t;
    }
}
/** A user with a null UID. */ $5c04988f82cad1b3$var$C.UNAUTHENTICATED = new $5c04988f82cad1b3$var$C(null), // TODO(mikelehen): Look into getting a proper uid-equivalent for
// non-FirebaseAuth providers.
$5c04988f82cad1b3$var$C.GOOGLE_CREDENTIALS = new $5c04988f82cad1b3$var$C("google-credentials-uid"), $5c04988f82cad1b3$var$C.FIRST_PARTY = new $5c04988f82cad1b3$var$C("first-party-uid"), $5c04988f82cad1b3$var$C.MOCK_USER = new $5c04988f82cad1b3$var$C("mock-user");
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $5c04988f82cad1b3$var$x = "9.8.3";
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $5c04988f82cad1b3$var$N = new (0, $gDOOI.Logger)("@firebase/firestore");
// Helper methods are needed because variables can't be exported as read/write
function $5c04988f82cad1b3$var$k() {
    return $5c04988f82cad1b3$var$N.logLevel;
}
/**
 * Sets the verbosity of Cloud Firestore logs (debug, error, or silent).
 *
 * @param logLevel - The verbosity you set for activity and error logging. Can
 *   be any of the following values:
 *
 *   <ul>
 *     <li>`debug` for the most verbose logging level, primarily for
 *     debugging.</li>
 *     <li>`error` to log errors only.</li>
 *     <li><code>`silent` to turn off logging.</li>
 *   </ul>
 */ function $5c04988f82cad1b3$export$c622e99c0ce7b1c9(t) {
    $5c04988f82cad1b3$var$N.setLogLevel(t);
}
function $5c04988f82cad1b3$var$M(t, ...e) {
    if ($5c04988f82cad1b3$var$N.logLevel <= (0, $gDOOI.LogLevel).DEBUG) {
        const n = e.map($5c04988f82cad1b3$var$B);
        $5c04988f82cad1b3$var$N.debug(`Firestore (${$5c04988f82cad1b3$var$x}): ${t}`, ...n);
    }
}
function $5c04988f82cad1b3$var$F(t, ...e) {
    if ($5c04988f82cad1b3$var$N.logLevel <= (0, $gDOOI.LogLevel).ERROR) {
        const n = e.map($5c04988f82cad1b3$var$B);
        $5c04988f82cad1b3$var$N.error(`Firestore (${$5c04988f82cad1b3$var$x}): ${t}`, ...n);
    }
}
/**
 * @internal
 */ function $5c04988f82cad1b3$export$86cd73f49cc6e0bb(t, ...e) {
    if ($5c04988f82cad1b3$var$N.logLevel <= (0, $gDOOI.LogLevel).WARN) {
        const n = e.map($5c04988f82cad1b3$var$B);
        $5c04988f82cad1b3$var$N.warn(`Firestore (${$5c04988f82cad1b3$var$x}): ${t}`, ...n);
    }
}
/**
 * Converts an additional log parameter to a string representation.
 */ function $5c04988f82cad1b3$var$B(t) {
    if ("string" == typeof t) return t;
    try {
        return e = t, JSON.stringify(e);
    } catch (e) {
        // Converting to JSON failed, just log the object directly
        return t;
    }
    /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Formats an object as a JSON string, suitable for logging. */ var e;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Unconditionally fails, throwing an Error with the given message.
 * Messages are stripped in production builds.
 *
 * Returns `never` and can be used in expressions:
 * @example
 * let futureVar = fail('not implemented yet');
 */ function $5c04988f82cad1b3$var$L(t = "Unexpected state") {
    // Log the failure in addition to throw an exception, just in case the
    // exception is swallowed.
    const e = `FIRESTORE (${$5c04988f82cad1b3$var$x}) INTERNAL ASSERTION FAILED: ` + t;
    // NOTE: We don't use FirestoreError here because these are internal failures
    // that cannot be handled by the user. (Also it would create a circular
    // dependency between the error and assert modules which doesn't work.)
    throw $5c04988f82cad1b3$var$F(e), new Error(e);
}
/**
 * Fails if the given assertion condition is false, throwing an Error with the
 * given message if it did.
 *
 * Messages are stripped in production builds.
 */ function $5c04988f82cad1b3$var$U(t, e) {
    t || $5c04988f82cad1b3$var$L();
}
/**
 * Fails if the given assertion condition is false, throwing an Error with the
 * given message if it did.
 *
 * The code of callsites invoking this function are stripped out in production
 * builds. Any side-effects of code within the debugAssert() invocation will not
 * happen in this case.
 *
 * @internal
 */ function $5c04988f82cad1b3$export$1d2b90eea9bba017(t, e) {
    t || $5c04988f82cad1b3$var$L();
}
/**
 * Casts `obj` to `T`. In non-production builds, verifies that `obj` is an
 * instance of `T` before casting.
 */ function $5c04988f82cad1b3$var$K(t, // eslint-disable-next-line @typescript-eslint/no-explicit-any
e) {
    return t;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $5c04988f82cad1b3$var$G = {
    // Causes are copied from:
    // https://github.com/grpc/grpc/blob/bceec94ea4fc5f0085d81235d8e1c06798dc341a/include/grpc%2B%2B/impl/codegen/status_code_enum.h
    /** Not an error; returned on success. */ OK: "ok",
    /** The operation was cancelled (typically by the caller). */ CANCELLED: "cancelled",
    /** Unknown error or an error from a different error domain. */ UNKNOWN: "unknown",
    /**
     * Client specified an invalid argument. Note that this differs from
     * FAILED_PRECONDITION. INVALID_ARGUMENT indicates arguments that are
     * problematic regardless of the state of the system (e.g., a malformed file
     * name).
     */ INVALID_ARGUMENT: "invalid-argument",
    /**
     * Deadline expired before operation could complete. For operations that
     * change the state of the system, this error may be returned even if the
     * operation has completed successfully. For example, a successful response
     * from a server could have been delayed long enough for the deadline to
     * expire.
     */ DEADLINE_EXCEEDED: "deadline-exceeded",
    /** Some requested entity (e.g., file or directory) was not found. */ NOT_FOUND: "not-found",
    /**
     * Some entity that we attempted to create (e.g., file or directory) already
     * exists.
     */ ALREADY_EXISTS: "already-exists",
    /**
     * The caller does not have permission to execute the specified operation.
     * PERMISSION_DENIED must not be used for rejections caused by exhausting
     * some resource (use RESOURCE_EXHAUSTED instead for those errors).
     * PERMISSION_DENIED must not be used if the caller can not be identified
     * (use UNAUTHENTICATED instead for those errors).
     */ PERMISSION_DENIED: "permission-denied",
    /**
     * The request does not have valid authentication credentials for the
     * operation.
     */ UNAUTHENTICATED: "unauthenticated",
    /**
     * Some resource has been exhausted, perhaps a per-user quota, or perhaps the
     * entire file system is out of space.
     */ RESOURCE_EXHAUSTED: "resource-exhausted",
    /**
     * Operation was rejected because the system is not in a state required for
     * the operation's execution. For example, directory to be deleted may be
     * non-empty, an rmdir operation is applied to a non-directory, etc.
     *
     * A litmus test that may help a service implementor in deciding
     * between FAILED_PRECONDITION, ABORTED, and UNAVAILABLE:
     *  (a) Use UNAVAILABLE if the client can retry just the failing call.
     *  (b) Use ABORTED if the client should retry at a higher-level
     *      (e.g., restarting a read-modify-write sequence).
     *  (c) Use FAILED_PRECONDITION if the client should not retry until
     *      the system state has been explicitly fixed. E.g., if an "rmdir"
     *      fails because the directory is non-empty, FAILED_PRECONDITION
     *      should be returned since the client should not retry unless
     *      they have first fixed up the directory by deleting files from it.
     *  (d) Use FAILED_PRECONDITION if the client performs conditional
     *      REST Get/Update/Delete on a resource and the resource on the
     *      server does not match the condition. E.g., conflicting
     *      read-modify-write on the same resource.
     */ FAILED_PRECONDITION: "failed-precondition",
    /**
     * The operation was aborted, typically due to a concurrency issue like
     * sequencer check failures, transaction aborts, etc.
     *
     * See litmus test above for deciding between FAILED_PRECONDITION, ABORTED,
     * and UNAVAILABLE.
     */ ABORTED: "aborted",
    /**
     * Operation was attempted past the valid range. E.g., seeking or reading
     * past end of file.
     *
     * Unlike INVALID_ARGUMENT, this error indicates a problem that may be fixed
     * if the system state changes. For example, a 32-bit file system will
     * generate INVALID_ARGUMENT if asked to read at an offset that is not in the
     * range [0,2^32-1], but it will generate OUT_OF_RANGE if asked to read from
     * an offset past the current file size.
     *
     * There is a fair bit of overlap between FAILED_PRECONDITION and
     * OUT_OF_RANGE. We recommend using OUT_OF_RANGE (the more specific error)
     * when it applies so that callers who are iterating through a space can
     * easily look for an OUT_OF_RANGE error to detect when they are done.
     */ OUT_OF_RANGE: "out-of-range",
    /** Operation is not implemented or not supported/enabled in this service. */ UNIMPLEMENTED: "unimplemented",
    /**
     * Internal errors. Means some invariants expected by underlying System has
     * been broken. If you see one of these errors, Something is very broken.
     */ INTERNAL: "internal",
    /**
     * The service is currently unavailable. This is a most likely a transient
     * condition and may be corrected by retrying with a backoff.
     *
     * See litmus test above for deciding between FAILED_PRECONDITION, ABORTED,
     * and UNAVAILABLE.
     */ UNAVAILABLE: "unavailable",
    /** Unrecoverable data loss or corruption. */ DATA_LOSS: "data-loss"
};
/** An error returned by a Firestore operation. */ class $5c04988f82cad1b3$export$8fada0bf726bf278 extends (0, $isbtl.FirebaseError) {
    /** @hideconstructor */ constructor(/**
     * The backend error code associated with this error.
     */ t, /**
     * A custom error description.
     */ e){
        super(t, e), this.code = t, this.message = e, // HACK: We write a toString property directly because Error is not a real
        // class and so inheritance does not work correctly. We could alternatively
        // do the same "back-door inheritance" trick that FirebaseError does.
        this.toString = ()=>`${this.name}: [code=${this.code}]: ${this.message}`;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $5c04988f82cad1b3$var$j {
    constructor(){
        this.promise = new Promise((t, e)=>{
            this.resolve = t, this.reject = e;
        });
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $5c04988f82cad1b3$var$W {
    constructor(t, e){
        this.user = e, this.type = "OAuth", this.headers = new Map, this.headers.set("Authorization", `Bearer ${t}`);
    }
}
/**
 * A CredentialsProvider that always yields an empty token.
 * @internal
 */ class $5c04988f82cad1b3$export$65ffa50b6039c992 {
    getToken() {
        return Promise.resolve(null);
    }
    invalidateToken() {}
    start(t, e) {
        // Fire with initial user.
        t.enqueueRetryable(()=>e($5c04988f82cad1b3$var$C.UNAUTHENTICATED));
    }
    shutdown() {}
}
/**
 * A CredentialsProvider that always returns a constant token. Used for
 * emulator token mocking.
 */ class $5c04988f82cad1b3$var$H {
    getToken() {
        return Promise.resolve(this.token);
    }
    invalidateToken() {}
    start(t, e) {
        this.changeListener = e, // Fire with initial user.
        t.enqueueRetryable(()=>e(this.token.user));
    }
    shutdown() {
        this.changeListener = null;
    }
    constructor(t){
        this.token = t, /**
         * Stores the listener registered with setChangeListener()
         * This isn't actually necessary since the UID never changes, but we use this
         * to verify the listen contract is adhered to in tests.
         */ this.changeListener = null;
    }
}
class $5c04988f82cad1b3$var$J {
    start(t, e) {
        let n = this.i;
        // A change listener that prevents double-firing for the same token change.
        const s = (t)=>this.i !== n ? (n = this.i, e(t)) : Promise.resolve();
        // A promise that can be waited on to block on the next token change.
        // This promise is re-created after each change.
        let i = new $5c04988f82cad1b3$var$j;
        this.o = ()=>{
            this.i++, this.currentUser = this.u(), i.resolve(), i = new $5c04988f82cad1b3$var$j, t.enqueueRetryable(()=>s(this.currentUser));
        };
        const r = ()=>{
            const e = i;
            t.enqueueRetryable(async ()=>{
                await e.promise, await s(this.currentUser);
            });
        }, o = (t)=>{
            $5c04988f82cad1b3$var$M("FirebaseAuthCredentialsProvider", "Auth detected"), this.auth = t, this.auth.addAuthTokenListener(this.o), r();
        };
        this.t.onInit((t)=>o(t)), // Our users can initialize Auth right after Firestore, so we give it
        // a chance to register itself with the component framework before we
        // determine whether to start up in unauthenticated mode.
        setTimeout(()=>{
            if (!this.auth) {
                const t = this.t.getImmediate({
                    optional: !0
                });
                t ? o(t) : // If auth is still not available, proceed with `null` user
                ($5c04988f82cad1b3$var$M("FirebaseAuthCredentialsProvider", "Auth not yet detected"), i.resolve(), i = new $5c04988f82cad1b3$var$j);
            }
        }, 0), r();
    }
    getToken() {
        // Take note of the current value of the tokenCounter so that this method
        // can fail (with an ABORTED error) if there is a token change while the
        // request is outstanding.
        const t = this.i, e = this.forceRefresh;
        return this.forceRefresh = !1, this.auth ? this.auth.getToken(e).then((e)=>// Cancel the request since the token changed while the request was
            // outstanding so the response is potentially for a previous user (which
            // user, we can't be sure).
            this.i !== t ? ($5c04988f82cad1b3$var$M("FirebaseAuthCredentialsProvider", "getToken aborted due to token change."), this.getToken()) : e ? ($5c04988f82cad1b3$var$U("string" == typeof e.accessToken), new $5c04988f82cad1b3$var$W(e.accessToken, this.currentUser)) : null) : Promise.resolve(null);
    }
    invalidateToken() {
        this.forceRefresh = !0;
    }
    shutdown() {
        this.auth && this.auth.removeAuthTokenListener(this.o);
    }
    // Auth.getUid() can return null even with a user logged in. It is because
    // getUid() is synchronous, but the auth code populating Uid is asynchronous.
    // This method should only be called in the AuthTokenListener callback
    // to guarantee to get the actual user.
    u() {
        const t = this.auth && this.auth.getUid();
        return $5c04988f82cad1b3$var$U(null === t || "string" == typeof t), new $5c04988f82cad1b3$var$C(t);
    }
    constructor(t){
        this.t = t, /** Tracks the current User. */ this.currentUser = $5c04988f82cad1b3$var$C.UNAUTHENTICATED, /**
         * Counter used to detect if the token changed while a getToken request was
         * outstanding.
         */ this.i = 0, this.forceRefresh = !1, this.auth = null;
    }
}
/*
 * FirstPartyToken provides a fresh token each time its value
 * is requested, because if the token is too old, requests will be rejected.
 * Technically this may no longer be necessary since the SDK should gracefully
 * recover from unauthenticated errors (see b/33147818 for context), but it's
 * safer to keep the implementation as-is.
 */ class $5c04988f82cad1b3$var$Y {
    constructor(t, e, n){
        this.type = "FirstParty", this.user = $5c04988f82cad1b3$var$C.FIRST_PARTY, this.headers = new Map, this.headers.set("X-Goog-AuthUser", e);
        const s = t.auth.getAuthHeaderValueForFirstParty([]);
        s && this.headers.set("Authorization", s), n && this.headers.set("X-Goog-Iam-Authorization-Token", n);
    }
}
/*
 * Provides user credentials required for the Firestore JavaScript SDK
 * to authenticate the user, using technique that is only available
 * to applications hosted by Google.
 */ class $5c04988f82cad1b3$var$X {
    getToken() {
        return Promise.resolve(new $5c04988f82cad1b3$var$Y(this.h, this.l, this.m));
    }
    start(t, e) {
        // Fire with initial uid.
        t.enqueueRetryable(()=>e($5c04988f82cad1b3$var$C.FIRST_PARTY));
    }
    shutdown() {}
    invalidateToken() {}
    constructor(t, e, n){
        this.h = t, this.l = e, this.m = n;
    }
}
class $5c04988f82cad1b3$var$Z {
    constructor(t){
        this.value = t, this.type = "AppCheck", this.headers = new Map, t && t.length > 0 && this.headers.set("x-firebase-appcheck", this.value);
    }
}
class $5c04988f82cad1b3$var$tt {
    start(t, e) {
        const n = (t)=>{
            null != t.error && $5c04988f82cad1b3$var$M("FirebaseAppCheckTokenProvider", `Error getting App Check token; using placeholder token instead. Error: ${t.error.message}`);
            const n = t.token !== this.p;
            return this.p = t.token, $5c04988f82cad1b3$var$M("FirebaseAppCheckTokenProvider", `Received ${n ? "new" : "existing"} token.`), n ? e(t.token) : Promise.resolve();
        };
        this.o = (e)=>{
            t.enqueueRetryable(()=>n(e));
        };
        const s = (t)=>{
            $5c04988f82cad1b3$var$M("FirebaseAppCheckTokenProvider", "AppCheck detected"), this.appCheck = t, this.appCheck.addTokenListener(this.o);
        };
        this.g.onInit((t)=>s(t)), // Our users can initialize AppCheck after Firestore, so we give it
        // a chance to register itself with the component framework.
        setTimeout(()=>{
            if (!this.appCheck) {
                const t = this.g.getImmediate({
                    optional: !0
                });
                t ? s(t) : // If AppCheck is still not available, proceed without it.
                $5c04988f82cad1b3$var$M("FirebaseAppCheckTokenProvider", "AppCheck not yet detected");
            }
        }, 0);
    }
    getToken() {
        const t = this.forceRefresh;
        return this.forceRefresh = !1, this.appCheck ? this.appCheck.getToken(t).then((t)=>t ? ($5c04988f82cad1b3$var$U("string" == typeof t.token), this.p = t.token, new $5c04988f82cad1b3$var$Z(t.token)) : null) : Promise.resolve(null);
    }
    invalidateToken() {
        this.forceRefresh = !0;
    }
    shutdown() {
        this.appCheck && this.appCheck.removeTokenListener(this.o);
    }
    constructor(t){
        this.g = t, this.forceRefresh = !1, this.appCheck = null, this.p = null;
    }
}
/**
 * An AppCheck token provider that always yields an empty token.
 * @internal
 */ class $5c04988f82cad1b3$export$b342cec01954510f {
    getToken() {
        return Promise.resolve(new $5c04988f82cad1b3$var$Z(""));
    }
    invalidateToken() {}
    start(t, e) {}
    shutdown() {}
}
/**
 * Builds a CredentialsProvider depending on the type of
 * the credentials passed in.
 */ /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Generates `nBytes` of random bytes.
 *
 * If `nBytes < 0` , an error will be thrown.
 */ function $5c04988f82cad1b3$var$nt(t) {
    // Polyfills for IE and WebWorker by using `self` and `msCrypto` when `crypto` is not available.
    const e = // eslint-disable-next-line @typescript-eslint/no-explicit-any
    "undefined" != typeof self && (self.crypto || self.msCrypto), n = new Uint8Array(t);
    if (e && "function" == typeof e.getRandomValues) e.getRandomValues(n);
    else // Falls back to Math.random
    for(let e = 0; e < t; e++)n[e] = Math.floor(256 * Math.random());
    return n;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $5c04988f82cad1b3$var$st {
    static I() {
        // Alphanumeric characters
        const t = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789", e = Math.floor(256 / t.length) * t.length;
        // The largest byte value that is a multiple of `char.length`.
        let n = "";
        for(; n.length < 20;){
            const s = $5c04988f82cad1b3$var$nt(40);
            for(let i = 0; i < s.length; ++i)// Only accept values that are [0, maxMultiple), this ensures they can
            // be evenly mapped to indices of `chars` via a modulo operation.
            n.length < 20 && s[i] < e && (n += t.charAt(s[i] % t.length));
        }
        return n;
    }
}
function $5c04988f82cad1b3$var$it(t, e) {
    return t < e ? -1 : t > e ? 1 : 0;
}
/** Helper to compare arrays using isEqual(). */ function $5c04988f82cad1b3$var$rt(t, e, n) {
    return t.length === e.length && t.every((t, s)=>n(t, e[s]));
}
/**
 * Returns the immediate lexicographically-following string. This is useful to
 * construct an inclusive range for indexeddb iterators.
 */ function $5c04988f82cad1b3$var$ot(t) {
    // Return the input string, with an additional NUL byte appended.
    return t + "\x00";
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // The earliest date supported by Firestore timestamps (0001-01-01T00:00:00Z).
/**
 * A `Timestamp` represents a point in time independent of any time zone or
 * calendar, represented as seconds and fractions of seconds at nanosecond
 * resolution in UTC Epoch time.
 *
 * It is encoded using the Proleptic Gregorian Calendar which extends the
 * Gregorian calendar backwards to year one. It is encoded assuming all minutes
 * are 60 seconds long, i.e. leap seconds are "smeared" so that no leap second
 * table is needed for interpretation. Range is from 0001-01-01T00:00:00Z to
 * 9999-12-31T23:59:59.999999999Z.
 *
 * For examples and further specifications, refer to the
 * {@link https://github.com/google/protobuf/blob/master/src/google/protobuf/timestamp.proto | Timestamp definition}.
 */ class $5c04988f82cad1b3$export$d9bcbd5e1ff81430 {
    /**
     * Creates a new timestamp with the current date, with millisecond precision.
     *
     * @returns a new timestamp representing the current date.
     */ static now() {
        return $5c04988f82cad1b3$export$d9bcbd5e1ff81430.fromMillis(Date.now());
    }
    /**
     * Creates a new timestamp from the given date.
     *
     * @param date - The date to initialize the `Timestamp` from.
     * @returns A new `Timestamp` representing the same point in time as the given
     *     date.
     */ static fromDate(t) {
        return $5c04988f82cad1b3$export$d9bcbd5e1ff81430.fromMillis(t.getTime());
    }
    /**
     * Creates a new timestamp from the given number of milliseconds.
     *
     * @param milliseconds - Number of milliseconds since Unix epoch
     *     1970-01-01T00:00:00Z.
     * @returns A new `Timestamp` representing the same point in time as the given
     *     number of milliseconds.
     */ static fromMillis(t) {
        const e = Math.floor(t / 1e3), n = Math.floor(1e6 * (t - 1e3 * e));
        return new $5c04988f82cad1b3$export$d9bcbd5e1ff81430(e, n);
    }
    /**
     * Converts a `Timestamp` to a JavaScript `Date` object. This conversion
     * causes a loss of precision since `Date` objects only support millisecond
     * precision.
     *
     * @returns JavaScript `Date` object representing the same point in time as
     *     this `Timestamp`, with millisecond precision.
     */ toDate() {
        return new Date(this.toMillis());
    }
    /**
     * Converts a `Timestamp` to a numeric timestamp (in milliseconds since
     * epoch). This operation causes a loss of precision.
     *
     * @returns The point in time corresponding to this timestamp, represented as
     *     the number of milliseconds since Unix epoch 1970-01-01T00:00:00Z.
     */ toMillis() {
        return 1e3 * this.seconds + this.nanoseconds / 1e6;
    }
    _compareTo(t) {
        return this.seconds === t.seconds ? $5c04988f82cad1b3$var$it(this.nanoseconds, t.nanoseconds) : $5c04988f82cad1b3$var$it(this.seconds, t.seconds);
    }
    /**
     * Returns true if this `Timestamp` is equal to the provided one.
     *
     * @param other - The `Timestamp` to compare against.
     * @returns true if this `Timestamp` is equal to the provided one.
     */ isEqual(t) {
        return t.seconds === this.seconds && t.nanoseconds === this.nanoseconds;
    }
    /** Returns a textual representation of this `Timestamp`. */ toString() {
        return "Timestamp(seconds=" + this.seconds + ", nanoseconds=" + this.nanoseconds + ")";
    }
    /** Returns a JSON-serializable representation of this `Timestamp`. */ toJSON() {
        return {
            seconds: this.seconds,
            nanoseconds: this.nanoseconds
        };
    }
    /**
     * Converts this object to a primitive string, which allows `Timestamp` objects
     * to be compared using the `>`, `<=`, `>=` and `>` operators.
     */ valueOf() {
        // This method returns a string of the form <seconds>.<nanoseconds> where
        // <seconds> is translated to have a non-negative value and both <seconds>
        // and <nanoseconds> are left-padded with zeroes to be a consistent length.
        // Strings with this format then have a lexiographical ordering that matches
        // the expected ordering. The <seconds> translation is done to avoid having
        // a leading negative sign (i.e. a leading '-' character) in its string
        // representation, which would affect its lexiographical ordering.
        const t = this.seconds - -62135596800;
        // Note: Up to 12 decimal digits are required to represent all valid
        // 'seconds' values.
        return String(t).padStart(12, "0") + "." + String(this.nanoseconds).padStart(9, "0");
    }
    /**
     * Creates a new timestamp.
     *
     * @param seconds - The number of seconds of UTC time since Unix epoch
     *     1970-01-01T00:00:00Z. Must be from 0001-01-01T00:00:00Z to
     *     9999-12-31T23:59:59Z inclusive.
     * @param nanoseconds - The non-negative fractions of a second at nanosecond
     *     resolution. Negative second values with fractions must still have
     *     non-negative nanoseconds values that count forward in time. Must be
     *     from 0 to 999,999,999 inclusive.
     */ constructor(/**
     * The number of seconds of UTC time since Unix epoch 1970-01-01T00:00:00Z.
     */ t, /**
     * The fractions of a second at nanosecond resolution.*
     */ e){
        if (this.seconds = t, this.nanoseconds = e, e < 0) throw new $5c04988f82cad1b3$export$8fada0bf726bf278($5c04988f82cad1b3$var$G.INVALID_ARGUMENT, "Timestamp nanoseconds out of range: " + e);
        if (e >= 1e9) throw new $5c04988f82cad1b3$export$8fada0bf726bf278($5c04988f82cad1b3$var$G.INVALID_ARGUMENT, "Timestamp nanoseconds out of range: " + e);
        if (t < -62135596800) throw new $5c04988f82cad1b3$export$8fada0bf726bf278($5c04988f82cad1b3$var$G.INVALID_ARGUMENT, "Timestamp seconds out of range: " + t);
        // This will break in the year 10,000.
        if (t >= 253402300800) throw new $5c04988f82cad1b3$export$8fada0bf726bf278($5c04988f82cad1b3$var$G.INVALID_ARGUMENT, "Timestamp seconds out of range: " + t);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A version of a document in Firestore. This corresponds to the version
 * timestamp, such as update_time or read_time.
 */ class $5c04988f82cad1b3$var$ct {
    static fromTimestamp(t) {
        return new $5c04988f82cad1b3$var$ct(t);
    }
    static min() {
        return new $5c04988f82cad1b3$var$ct(new $5c04988f82cad1b3$export$d9bcbd5e1ff81430(0, 0));
    }
    static max() {
        return new $5c04988f82cad1b3$var$ct(new $5c04988f82cad1b3$export$d9bcbd5e1ff81430(253402300799, 999999999));
    }
    compareTo(t) {
        return this.timestamp._compareTo(t.timestamp);
    }
    isEqual(t) {
        return this.timestamp.isEqual(t.timestamp);
    }
    /** Returns a number representation of the version for use in spec tests. */ toMicroseconds() {
        // Convert to microseconds.
        return 1e6 * this.timestamp.seconds + this.timestamp.nanoseconds / 1e3;
    }
    toString() {
        return "SnapshotVersion(" + this.timestamp.toString() + ")";
    }
    toTimestamp() {
        return this.timestamp;
    }
    constructor(t){
        this.timestamp = t;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Path represents an ordered sequence of string segments.
 */ class $5c04988f82cad1b3$var$at {
    get length() {
        return this.len;
    }
    isEqual(t) {
        return 0 === $5c04988f82cad1b3$var$at.comparator(this, t);
    }
    child(t) {
        const e = this.segments.slice(this.offset, this.limit());
        return t instanceof $5c04988f82cad1b3$var$at ? t.forEach((t)=>{
            e.push(t);
        }) : e.push(t), this.construct(e);
    }
    /** The index of one past the last segment of the path. */ limit() {
        return this.offset + this.length;
    }
    popFirst(t) {
        return t = void 0 === t ? 1 : t, this.construct(this.segments, this.offset + t, this.length - t);
    }
    popLast() {
        return this.construct(this.segments, this.offset, this.length - 1);
    }
    firstSegment() {
        return this.segments[this.offset];
    }
    lastSegment() {
        return this.get(this.length - 1);
    }
    get(t) {
        return this.segments[this.offset + t];
    }
    isEmpty() {
        return 0 === this.length;
    }
    isPrefixOf(t) {
        if (t.length < this.length) return !1;
        for(let e = 0; e < this.length; e++)if (this.get(e) !== t.get(e)) return !1;
        return !0;
    }
    isImmediateParentOf(t) {
        if (this.length + 1 !== t.length) return !1;
        for(let e = 0; e < this.length; e++)if (this.get(e) !== t.get(e)) return !1;
        return !0;
    }
    forEach(t) {
        for(let e = this.offset, n = this.limit(); e < n; e++)t(this.segments[e]);
    }
    toArray() {
        return this.segments.slice(this.offset, this.limit());
    }
    static comparator(t, e) {
        const n = Math.min(t.length, e.length);
        for(let s = 0; s < n; s++){
            const n = t.get(s), i = e.get(s);
            if (n < i) return -1;
            if (n > i) return 1;
        }
        return t.length < e.length ? -1 : t.length > e.length ? 1 : 0;
    }
    constructor(t, e, n){
        void 0 === e ? e = 0 : e > t.length && $5c04988f82cad1b3$var$L(), void 0 === n ? n = t.length - e : n > t.length - e && $5c04988f82cad1b3$var$L(), this.segments = t, this.offset = e, this.len = n;
    }
}
/**
 * A slash-separated path for navigating resources (documents and collections)
 * within Firestore.
 *
 * @internal
 */ class $5c04988f82cad1b3$var$ht extends $5c04988f82cad1b3$var$at {
    construct(t, e, n) {
        return new $5c04988f82cad1b3$var$ht(t, e, n);
    }
    canonicalString() {
        // NOTE: The client is ignorant of any path segments containing escape
        // sequences (e.g. __id123__) and just passes them through raw (they exist
        // for legacy reasons and should not be used frequently).
        return this.toArray().join("/");
    }
    toString() {
        return this.canonicalString();
    }
    /**
     * Creates a resource path from the given slash-delimited string. If multiple
     * arguments are provided, all components are combined. Leading and trailing
     * slashes from all components are ignored.
     */ static fromString(...t) {
        // NOTE: The client is ignorant of any path segments containing escape
        // sequences (e.g. __id123__) and just passes them through raw (they exist
        // for legacy reasons and should not be used frequently).
        const e = [];
        for (const n of t){
            if (n.indexOf("//") >= 0) throw new $5c04988f82cad1b3$export$8fada0bf726bf278($5c04988f82cad1b3$var$G.INVALID_ARGUMENT, `Invalid segment (${n}). Paths must not contain // in them.`);
            // Strip leading and traling slashed.
            e.push(...n.split("/").filter((t)=>t.length > 0));
        }
        return new $5c04988f82cad1b3$var$ht(e);
    }
    static emptyPath() {
        return new $5c04988f82cad1b3$var$ht([]);
    }
}
const $5c04988f82cad1b3$var$lt = /^[_a-zA-Z][_a-zA-Z0-9]*$/;
/**
 * A dot-separated path for navigating sub-objects within a document.
 * @internal
 */ class $5c04988f82cad1b3$export$b7871852b967eaf1 extends $5c04988f82cad1b3$var$at {
    construct(t, e, n) {
        return new $5c04988f82cad1b3$export$b7871852b967eaf1(t, e, n);
    }
    /**
     * Returns true if the string could be used as a segment in a field path
     * without escaping.
     */ static isValidIdentifier(t) {
        return $5c04988f82cad1b3$var$lt.test(t);
    }
    canonicalString() {
        return this.toArray().map((t)=>(t = t.replace(/\\/g, "\\\\").replace(/`/g, "\\`"), $5c04988f82cad1b3$export$b7871852b967eaf1.isValidIdentifier(t) || (t = "`" + t + "`"), t)).join(".");
    }
    toString() {
        return this.canonicalString();
    }
    /**
     * Returns true if this field references the key of a document.
     */ isKeyField() {
        return 1 === this.length && "__name__" === this.get(0);
    }
    /**
     * The field designating the key of a document.
     */ static keyField() {
        return new $5c04988f82cad1b3$export$b7871852b967eaf1([
            "__name__"
        ]);
    }
    /**
     * Parses a field string from the given server-formatted string.
     *
     * - Splitting the empty string is not allowed (for now at least).
     * - Empty segments within the string (e.g. if there are two consecutive
     *   separators) are not allowed.
     *
     * TODO(b/37244157): we should make this more strict. Right now, it allows
     * non-identifier path components, even if they aren't escaped.
     */ static fromServerFormat(t) {
        const e = [];
        let n = "", s = 0;
        const i = ()=>{
            if (0 === n.length) throw new $5c04988f82cad1b3$export$8fada0bf726bf278($5c04988f82cad1b3$var$G.INVALID_ARGUMENT, `Invalid field path (${t}). Paths must not be empty, begin with '.', end with '.', or contain '..'`);
            e.push(n), n = "";
        };
        let r = !1;
        for(; s < t.length;){
            const e = t[s];
            if ("\\" === e) {
                if (s + 1 === t.length) throw new $5c04988f82cad1b3$export$8fada0bf726bf278($5c04988f82cad1b3$var$G.INVALID_ARGUMENT, "Path has trailing escape character: " + t);
                const e = t[s + 1];
                if ("\\" !== e && "." !== e && "`" !== e) throw new $5c04988f82cad1b3$export$8fada0bf726bf278($5c04988f82cad1b3$var$G.INVALID_ARGUMENT, "Path has invalid escape sequence: " + t);
                n += e, s += 2;
            } else "`" === e ? (r = !r, s++) : "." !== e || r ? (n += e, s++) : (i(), s++);
        }
        if (i(), r) throw new $5c04988f82cad1b3$export$8fada0bf726bf278($5c04988f82cad1b3$var$G.INVALID_ARGUMENT, "Unterminated ` in path: " + t);
        return new $5c04988f82cad1b3$export$b7871852b967eaf1(e);
    }
    static emptyPath() {
        return new $5c04988f82cad1b3$export$b7871852b967eaf1([]);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @internal
 */ class $5c04988f82cad1b3$export$afc2e57c475b7810 {
    static fromPath(t) {
        return new $5c04988f82cad1b3$export$afc2e57c475b7810($5c04988f82cad1b3$var$ht.fromString(t));
    }
    static fromName(t) {
        return new $5c04988f82cad1b3$export$afc2e57c475b7810($5c04988f82cad1b3$var$ht.fromString(t).popFirst(5));
    }
    static empty() {
        return new $5c04988f82cad1b3$export$afc2e57c475b7810($5c04988f82cad1b3$var$ht.emptyPath());
    }
    get collectionGroup() {
        return this.path.popLast().lastSegment();
    }
    /** Returns true if the document is in the specified collectionId. */ hasCollectionId(t) {
        return this.path.length >= 2 && this.path.get(this.path.length - 2) === t;
    }
    /** Returns the collection group (i.e. the name of the parent collection) for this key. */ getCollectionGroup() {
        return this.path.get(this.path.length - 2);
    }
    /** Returns the fully qualified path to the parent collection. */ getCollectionPath() {
        return this.path.popLast();
    }
    isEqual(t) {
        return null !== t && 0 === $5c04988f82cad1b3$var$ht.comparator(this.path, t.path);
    }
    toString() {
        return this.path.toString();
    }
    static comparator(t, e) {
        return $5c04988f82cad1b3$var$ht.comparator(t.path, e.path);
    }
    static isDocumentKey(t) {
        return t.length % 2 == 0;
    }
    /**
     * Creates and returns a new document key with the given segments.
     *
     * @param segments - The segments of the path to the document
     * @returns A new instance of DocumentKey
     */ static fromSegments(t) {
        return new $5c04988f82cad1b3$export$afc2e57c475b7810(new $5c04988f82cad1b3$var$ht(t.slice()));
    }
    constructor(t){
        this.path = t;
    }
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The initial mutation batch id for each index. Gets updated during index
 * backfill.
 */ /**
 * An index definition for field indexes in Firestore.
 *
 * Every index is associated with a collection. The definition contains a list
 * of fields and their index kind (which can be `ASCENDING`, `DESCENDING` or
 * `CONTAINS` for ArrayContains/ArrayContainsAny queries).
 *
 * Unlike the backend, the SDK does not differentiate between collection or
 * collection group-scoped indices. Every index can be used for both single
 * collection and collection group queries.
 */ class $5c04988f82cad1b3$var$_t {
    constructor(/**
     * The index ID. Returns -1 if the index ID is not available (e.g. the index
     * has not yet been persisted).
     */ t, /** The collection ID this index applies to. */ e, /** The field segments for this index. */ n, /** Shows how up-to-date the index is for the current user. */ s){
        this.indexId = t, this.collectionGroup = e, this.fields = n, this.indexState = s;
    }
}
/** An ID for an index that has not yet been added to persistence.  */ /** Returns the ArrayContains/ArrayContainsAny segment for this index. */ function $5c04988f82cad1b3$var$wt(t) {
    return t.fields.find((t)=>2 /* CONTAINS */  === t.kind);
}
/** Returns all directional (ascending/descending) segments for this index. */ function $5c04988f82cad1b3$var$mt(t) {
    return t.fields.filter((t)=>2 /* CONTAINS */  !== t.kind);
}
/**
 * Returns the order of the document key component for the given index.
 *
 * PORTING NOTE: This is only used in the Web IndexedDb implementation.
 */ $5c04988f82cad1b3$var$_t.UNKNOWN_ID = -1;
/** An index component consisting of field path and index type.  */ class $5c04988f82cad1b3$var$gt {
    constructor(/** The field path of the component. */ t, /** The fields sorting order. */ e){
        this.fieldPath = t, this.kind = e;
    }
}
/**
 * Stores the "high water mark" that indicates how updated the Index is for the
 * current user.
 */ class $5c04988f82cad1b3$var$yt {
    /** The state of an index that has not yet been backfilled. */ static empty() {
        return new $5c04988f82cad1b3$var$yt(0, $5c04988f82cad1b3$var$Tt.min());
    }
    constructor(/**
     * Indicates when the index was last updated (relative to other indexes).
     */ t, /** The the latest indexed read time, document and batch id. */ e){
        this.sequenceNumber = t, this.offset = e;
    }
}
/**
 * Creates an offset that matches all documents with a read time higher than
 * `readTime`.
 */ function $5c04988f82cad1b3$var$pt(t, e) {
    // We want to create an offset that matches all documents with a read time
    // greater than the provided read time. To do so, we technically need to
    // create an offset for `(readTime, MAX_DOCUMENT_KEY)`. While we could use
    // Unicode codepoints to generate MAX_DOCUMENT_KEY, it is much easier to use
    // `(readTime + 1, DocumentKey.empty())` since `> DocumentKey.empty()` matches
    // all valid document IDs.
    const n = t.toTimestamp().seconds, s = t.toTimestamp().nanoseconds + 1, i = $5c04988f82cad1b3$var$ct.fromTimestamp(1e9 === s ? new $5c04988f82cad1b3$export$d9bcbd5e1ff81430(n + 1, 0) : new $5c04988f82cad1b3$export$d9bcbd5e1ff81430(n, s));
    return new $5c04988f82cad1b3$var$Tt(i, $5c04988f82cad1b3$export$afc2e57c475b7810.empty(), e);
}
/** Creates a new offset based on the provided document. */ function $5c04988f82cad1b3$var$It(t) {
    return new $5c04988f82cad1b3$var$Tt(t.readTime, t.key, -1);
}
/**
 * Stores the latest read time, document and batch ID that were processed for an
 * index.
 */ class $5c04988f82cad1b3$var$Tt {
    /** Returns an offset that sorts before all regular offsets. */ static min() {
        return new $5c04988f82cad1b3$var$Tt($5c04988f82cad1b3$var$ct.min(), $5c04988f82cad1b3$export$afc2e57c475b7810.empty(), -1);
    }
    /** Returns an offset that sorts after all regular offsets. */ static max() {
        return new $5c04988f82cad1b3$var$Tt($5c04988f82cad1b3$var$ct.max(), $5c04988f82cad1b3$export$afc2e57c475b7810.empty(), -1);
    }
    constructor(/**
     * The latest read time version that has been indexed by Firestore for this
     * field index.
     */ t, /**
     * The key of the last document that was indexed for this query. Use
     * `DocumentKey.empty()` if no document has been indexed.
     */ e, /*
     * The largest mutation batch id that's been processed by Firestore.
     */ n){
        this.readTime = t, this.documentKey = e, this.largestBatchId = n;
    }
}
function $5c04988f82cad1b3$var$Et(t, e) {
    let n = t.readTime.compareTo(e.readTime);
    return 0 !== n ? n : (n = $5c04988f82cad1b3$export$afc2e57c475b7810.comparator(t.documentKey, e.documentKey), 0 !== n ? n : $5c04988f82cad1b3$var$it(t.largestBatchId, e.largestBatchId));
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // TODO(indexing): Remove this constant
const $5c04988f82cad1b3$var$At = "The current tab is not in the required state to perform this operation. It might be necessary to refresh the browser tab.";
/**
 * A base class representing a persistence transaction, encapsulating both the
 * transaction's sequence numbers as well as a list of onCommitted listeners.
 *
 * When you call Persistence.runTransaction(), it will create a transaction and
 * pass it to your callback. You then pass it to any method that operates
 * on persistence.
 */ class $5c04988f82cad1b3$var$Rt {
    addOnCommittedListener(t) {
        this.onCommittedListeners.push(t);
    }
    raiseOnCommittedEvent() {
        this.onCommittedListeners.forEach((t)=>t());
    }
    constructor(){
        this.onCommittedListeners = [];
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Verifies the error thrown by a LocalStore operation. If a LocalStore
 * operation fails because the primary lease has been taken by another client,
 * we ignore the error (the persistence layer will immediately call
 * `applyPrimaryLease` to propagate the primary state change). All other errors
 * are re-thrown.
 *
 * @param err - An error returned by a LocalStore operation.
 * @returns A Promise that resolves after we recovered, or the original error.
 */ async function $5c04988f82cad1b3$var$bt(t) {
    if (t.code !== $5c04988f82cad1b3$var$G.FAILED_PRECONDITION || t.message !== $5c04988f82cad1b3$var$At) throw t;
    $5c04988f82cad1b3$var$M("LocalStore", "Unexpectedly lost primary lease");
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * PersistencePromise is essentially a re-implementation of Promise except
 * it has a .next() method instead of .then() and .next() and .catch() callbacks
 * are executed synchronously when a PersistencePromise resolves rather than
 * asynchronously (Promise implementations use setImmediate() or similar).
 *
 * This is necessary to interoperate with IndexedDB which will automatically
 * commit transactions if control is returned to the event loop without
 * synchronously initiating another operation on the transaction.
 *
 * NOTE: .then() and .catch() only allow a single consumer, unlike normal
 * Promises.
 */ class $5c04988f82cad1b3$var$Pt {
    catch(t) {
        return this.next(void 0, t);
    }
    next(t, e) {
        return this.callbackAttached && $5c04988f82cad1b3$var$L(), this.callbackAttached = !0, this.isDone ? this.error ? this.wrapFailure(e, this.error) : this.wrapSuccess(t, this.result) : new $5c04988f82cad1b3$var$Pt((n, s)=>{
            this.nextCallback = (e)=>{
                this.wrapSuccess(t, e).next(n, s);
            }, this.catchCallback = (t)=>{
                this.wrapFailure(e, t).next(n, s);
            };
        });
    }
    toPromise() {
        return new Promise((t, e)=>{
            this.next(t, e);
        });
    }
    wrapUserFunction(t) {
        try {
            const e = t();
            return e instanceof $5c04988f82cad1b3$var$Pt ? e : $5c04988f82cad1b3$var$Pt.resolve(e);
        } catch (t) {
            return $5c04988f82cad1b3$var$Pt.reject(t);
        }
    }
    wrapSuccess(t, e) {
        return t ? this.wrapUserFunction(()=>t(e)) : $5c04988f82cad1b3$var$Pt.resolve(e);
    }
    wrapFailure(t, e) {
        return t ? this.wrapUserFunction(()=>t(e)) : $5c04988f82cad1b3$var$Pt.reject(e);
    }
    static resolve(t) {
        return new $5c04988f82cad1b3$var$Pt((e, n)=>{
            e(t);
        });
    }
    static reject(t) {
        return new $5c04988f82cad1b3$var$Pt((e, n)=>{
            n(t);
        });
    }
    static waitFor(// Accept all Promise types in waitFor().
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    t) {
        return new $5c04988f82cad1b3$var$Pt((e, n)=>{
            let s = 0, i = 0, r = !1;
            t.forEach((t)=>{
                ++s, t.next(()=>{
                    ++i, r && i === s && e();
                }, (t)=>n(t));
            }), r = !0, i === s && e();
        });
    }
    /**
     * Given an array of predicate functions that asynchronously evaluate to a
     * boolean, implements a short-circuiting `or` between the results. Predicates
     * will be evaluated until one of them returns `true`, then stop. The final
     * result will be whether any of them returned `true`.
     */ static or(t) {
        let e = $5c04988f82cad1b3$var$Pt.resolve(!1);
        for (const n of t)e = e.next((t)=>t ? $5c04988f82cad1b3$var$Pt.resolve(t) : n());
        return e;
    }
    static forEach(t, e) {
        const n = [];
        return t.forEach((t, s)=>{
            n.push(e.call(this, t, s));
        }), this.waitFor(n);
    }
    /**
     * Concurrently map all array elements through asynchronous function.
     */ static mapArray(t, e) {
        return new $5c04988f82cad1b3$var$Pt((n, s)=>{
            const i = t.length, r = new Array(i);
            let o = 0;
            for(let u = 0; u < i; u++){
                const c = u;
                e(t[c]).next((t)=>{
                    r[c] = t, ++o, o === i && n(r);
                }, (t)=>s(t));
            }
        });
    }
    /**
     * An alternative to recursive PersistencePromise calls, that avoids
     * potential memory problems from unbounded chains of promises.
     *
     * The `action` will be called repeatedly while `condition` is true.
     */ static doWhile(t, e) {
        return new $5c04988f82cad1b3$var$Pt((n, s)=>{
            const i = ()=>{
                !0 === t() ? e().next(()=>{
                    i();
                }, s) : n();
            };
            i();
        });
    }
    constructor(t){
        // NOTE: next/catchCallback will always point to our own wrapper functions,
        // not the user's raw next() or catch() callbacks.
        this.nextCallback = null, this.catchCallback = null, // When the operation resolves, we'll set result or error and mark isDone.
        this.result = void 0, this.error = void 0, this.isDone = !1, // Set to true when .then() or .catch() are called and prevents additional
        // chaining.
        this.callbackAttached = !1, t((t)=>{
            this.isDone = !0, this.result = t, this.nextCallback && // value should be defined unless T is Void, but we can't express
            // that in the type system.
            this.nextCallback(t);
        }, (t)=>{
            this.isDone = !0, this.error = t, this.catchCallback && this.catchCallback(t);
        });
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // References to `window` are guarded by SimpleDb.isAvailable()
/* eslint-disable no-restricted-globals */ /**
 * Wraps an IDBTransaction and exposes a store() method to get a handle to a
 * specific object store.
 */ class $5c04988f82cad1b3$var$vt {
    static open(t, e, n, s) {
        try {
            return new $5c04988f82cad1b3$var$vt(e, t.transaction(s, n));
        } catch (t) {
            throw new $5c04988f82cad1b3$var$Dt(e, t);
        }
    }
    get A() {
        return this.T.promise;
    }
    abort(t) {
        t && this.T.reject(t), this.aborted || ($5c04988f82cad1b3$var$M("SimpleDb", "Aborting transaction:", t ? t.message : "Client-initiated abort"), this.aborted = !0, this.transaction.abort());
    }
    R() {
        // If the browser supports V3 IndexedDB, we invoke commit() explicitly to
        // speed up index DB processing if the event loop remains blocks.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const t = this.transaction;
        this.aborted || "function" != typeof t.commit || t.commit();
    }
    /**
     * Returns a SimpleDbStore<KeyType, ValueType> for the specified store. All
     * operations performed on the SimpleDbStore happen within the context of this
     * transaction and it cannot be used anymore once the transaction is
     * completed.
     *
     * Note that we can't actually enforce that the KeyType and ValueType are
     * correct, but they allow type safety through the rest of the consuming code.
     */ store(t) {
        const e = this.transaction.objectStore(t);
        return new $5c04988f82cad1b3$var$xt(e);
    }
    constructor(t, e){
        this.action = t, this.transaction = e, this.aborted = !1, /**
         * A `Promise` that resolves with the result of the IndexedDb transaction.
         */ this.T = new $5c04988f82cad1b3$var$j, this.transaction.oncomplete = ()=>{
            this.T.resolve();
        }, this.transaction.onabort = ()=>{
            e.error ? this.T.reject(new $5c04988f82cad1b3$var$Dt(t, e.error)) : this.T.resolve();
        }, this.transaction.onerror = (e)=>{
            const n = $5c04988f82cad1b3$var$Ot(e.target.error);
            this.T.reject(new $5c04988f82cad1b3$var$Dt(t, n));
        };
    }
}
/**
 * Provides a wrapper around IndexedDb with a simplified interface that uses
 * Promise-like return values to chain operations. Real promises cannot be used
 * since .then() continuations are executed asynchronously (e.g. via
 * .setImmediate), which would cause IndexedDB to end the transaction.
 * See PersistencePromise for more details.
 */ class $5c04988f82cad1b3$var$Vt {
    /** Deletes the specified database. */ static delete(t) {
        return $5c04988f82cad1b3$var$M("SimpleDb", "Removing database:", t), $5c04988f82cad1b3$var$Nt(window.indexedDB.deleteDatabase(t)).toPromise();
    }
    /** Returns true if IndexedDB is available in the current environment. */ static V() {
        if (!(0, $isbtl.isIndexedDBAvailable)()) return !1;
        if ($5c04988f82cad1b3$var$Vt.S()) return !0;
        // We extensively use indexed array values and compound keys,
        // which IE and Edge do not support. However, they still have indexedDB
        // defined on the window, so we need to check for them here and make sure
        // to return that persistence is not enabled for those browsers.
        // For tracking support of this feature, see here:
        // https://developer.microsoft.com/en-us/microsoft-edge/platform/status/indexeddbarraysandmultientrysupport/
        // Check the UA string to find out the browser.
        const t = (0, $isbtl.getUA)(), e = $5c04988f82cad1b3$var$Vt.v(t), n = 0 < e && e < 10, s = $5c04988f82cad1b3$var$Vt.D(t), i = 0 < s && s < 4.5;
        // IE 10
        // ua = 'Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)';
        // IE 11
        // ua = 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko';
        // Edge
        // ua = 'Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML,
        // like Gecko) Chrome/39.0.2171.71 Safari/537.36 Edge/12.0';
        // iOS Safari: Disable for users running iOS version < 10.
        return !(t.indexOf("MSIE ") > 0 || t.indexOf("Trident/") > 0 || t.indexOf("Edge/") > 0 || n || i);
    }
    /**
     * Returns true if the backing IndexedDB store is the Node IndexedDBShim
     * (see https://github.com/axemclion/IndexedDBShim).
     */ static S() {
        var t;
        return "undefined" != typeof $i9yYZ && "YES" === ((t = {}, void 0 === t) ? void 0 : t.C);
    }
    /** Helper to get a typed SimpleDbStore from a transaction. */ static N(t, e) {
        return t.store(e);
    }
    // visible for testing
    /** Parse User Agent to determine iOS version. Returns -1 if not found. */ static v(t) {
        const e = t.match(/i(?:phone|pad|pod) os ([\d_]+)/i), n = e ? e[1].split("_").slice(0, 2).join(".") : "-1";
        return Number(n);
    }
    // visible for testing
    /** Parse User Agent to determine Android version. Returns -1 if not found. */ static D(t) {
        const e = t.match(/Android ([\d.]+)/i), n = e ? e[1].split(".").slice(0, 2).join(".") : "-1";
        return Number(n);
    }
    /**
     * Opens the specified database, creating or upgrading it if necessary.
     */ async k(t) {
        return this.db || ($5c04988f82cad1b3$var$M("SimpleDb", "Opening database:", this.name), this.db = await new Promise((e, n)=>{
            // TODO(mikelehen): Investigate browser compatibility.
            // https://developer.mozilla.org/en-US/docs/Web/API/IndexedDB_API/Using_IndexedDB
            // suggests IE9 and older WebKit browsers handle upgrade
            // differently. They expect setVersion, as described here:
            // https://developer.mozilla.org/en-US/docs/Web/API/IDBVersionChangeRequest/setVersion
            const s = indexedDB.open(this.name, this.version);
            s.onsuccess = (t)=>{
                const n = t.target.result;
                e(n);
            }, s.onblocked = ()=>{
                n(new $5c04988f82cad1b3$var$Dt(t, "Cannot upgrade IndexedDB schema while another tab is open. Close all tabs that access Firestore and reload this page to proceed."));
            }, s.onerror = (e)=>{
                const s = e.target.error;
                "VersionError" === s.name ? n(new $5c04988f82cad1b3$export$8fada0bf726bf278($5c04988f82cad1b3$var$G.FAILED_PRECONDITION, "A newer version of the Firestore SDK was previously used and so the persisted data is not compatible with the version of the SDK you are now using. The SDK will operate with persistence disabled. If you need persistence, please re-upgrade to a newer version of the SDK or else clear the persisted IndexedDB data for your app to start fresh.")) : "InvalidStateError" === s.name ? n(new $5c04988f82cad1b3$export$8fada0bf726bf278($5c04988f82cad1b3$var$G.FAILED_PRECONDITION, "Unable to open an IndexedDB connection. This could be due to running in a private browsing session on a browser whose private browsing sessions do not support IndexedDB: " + s)) : n(new $5c04988f82cad1b3$var$Dt(t, s));
            }, s.onupgradeneeded = (t)=>{
                $5c04988f82cad1b3$var$M("SimpleDb", 'Database "' + this.name + '" requires upgrade from version:', t.oldVersion);
                const e = t.target.result;
                this.P.O(e, s.transaction, t.oldVersion, this.version).next(()=>{
                    $5c04988f82cad1b3$var$M("SimpleDb", "Database upgrade to version " + this.version + " complete");
                });
            };
        })), this.M && (this.db.onversionchange = (t)=>this.M(t)), this.db;
    }
    F(t) {
        this.M = t, this.db && (this.db.onversionchange = (e)=>t(e));
    }
    async runTransaction(t, e, n, s) {
        const i = "readonly" === e;
        let r = 0;
        for(;;){
            ++r;
            try {
                this.db = await this.k(t);
                const e = $5c04988f82cad1b3$var$vt.open(this.db, t, i ? "readonly" : "readwrite", n), r = s(e).next((t)=>(e.R(), t)).catch((t)=>// Abort the transaction if there was an error.
                    (e.abort(t), $5c04988f82cad1b3$var$Pt.reject(t))).toPromise();
                // As noted above, errors are propagated by aborting the transaction. So
                // we swallow any error here to avoid the browser logging it as unhandled.
                return r.catch(()=>{}), // Wait for the transaction to complete (i.e. IndexedDb's onsuccess event to
                // fire), but still return the original transactionFnResult back to the
                // caller.
                await e.A, r;
            } catch (t) {
                // TODO(schmidt-sebastian): We could probably be smarter about this and
                // not retry exceptions that are likely unrecoverable (such as quota
                // exceeded errors).
                // Note: We cannot use an instanceof check for FirestoreException, since the
                // exception is wrapped in a generic error by our async/await handling.
                const e = "FirebaseError" !== t.name && r < 3;
                if ($5c04988f82cad1b3$var$M("SimpleDb", "Transaction failed with error:", t.message, "Retrying:", e), this.close(), !e) return Promise.reject(t);
            }
        }
    }
    close() {
        this.db && this.db.close(), this.db = void 0;
    }
    /*
     * Creates a new SimpleDb wrapper for IndexedDb database `name`.
     *
     * Note that `version` must not be a downgrade. IndexedDB does not support
     * downgrading the schema version. We currently do not support any way to do
     * versioning outside of IndexedDB's versioning mechanism, as only
     * version-upgrade transactions are allowed to do things like create
     * objectstores.
     */ constructor(t, e, n){
        this.name = t, this.version = e, this.P = n;
        // NOTE: According to https://bugs.webkit.org/show_bug.cgi?id=197050, the
        // bug we're checking for should exist in iOS >= 12.2 and < 13, but for
        // whatever reason it's much harder to hit after 12.2 so we only proactively
        // log on 12.2.
        12.2 === $5c04988f82cad1b3$var$Vt.v((0, $isbtl.getUA)()) && $5c04988f82cad1b3$var$F("Firestore persistence suffers from a bug in iOS 12.2 Safari that may cause your app to stop working. See https://stackoverflow.com/q/56496296/110915 for details and a potential workaround.");
    }
}
/**
 * A controller for iterating over a key range or index. It allows an iterate
 * callback to delete the currently-referenced object, or jump to a new key
 * within the key range or index.
 */ class $5c04988f82cad1b3$var$St {
    get isDone() {
        return this.B;
    }
    get U() {
        return this.L;
    }
    set cursor(t) {
        this.$ = t;
    }
    /**
     * This function can be called to stop iteration at any point.
     */ done() {
        this.B = !0;
    }
    /**
     * This function can be called to skip to that next key, which could be
     * an index or a primary key.
     */ q(t) {
        this.L = t;
    }
    /**
     * Delete the current cursor value from the object store.
     *
     * NOTE: You CANNOT do this with a keysOnly query.
     */ delete() {
        return $5c04988f82cad1b3$var$Nt(this.$.delete());
    }
    constructor(t){
        this.$ = t, this.B = !1, this.L = null;
    }
}
/** An error that wraps exceptions that thrown during IndexedDB execution. */ class $5c04988f82cad1b3$var$Dt extends $5c04988f82cad1b3$export$8fada0bf726bf278 {
    constructor(t, e){
        super($5c04988f82cad1b3$var$G.UNAVAILABLE, `IndexedDB transaction '${t}' failed: ${e}`), this.name = "IndexedDbTransactionError";
    }
}
/** Verifies whether `e` is an IndexedDbTransactionError. */ function $5c04988f82cad1b3$var$Ct(t) {
    // Use name equality, as instanceof checks on errors don't work with errors
    // that wrap other errors.
    return "IndexedDbTransactionError" === t.name;
}
/**
 * A wrapper around an IDBObjectStore providing an API that:
 *
 * 1) Has generic KeyType / ValueType parameters to provide strongly-typed
 * methods for acting against the object store.
 * 2) Deals with IndexedDB's onsuccess / onerror event callbacks, making every
 * method return a PersistencePromise instead.
 * 3) Provides a higher-level API to avoid needing to do excessive wrapping of
 * intermediate IndexedDB types (IDBCursorWithValue, etc.)
 */ class $5c04988f82cad1b3$var$xt {
    put(t, e) {
        let n;
        return void 0 !== e ? ($5c04988f82cad1b3$var$M("SimpleDb", "PUT", this.store.name, t, e), n = this.store.put(e, t)) : ($5c04988f82cad1b3$var$M("SimpleDb", "PUT", this.store.name, "<auto-key>", t), n = this.store.put(t)), $5c04988f82cad1b3$var$Nt(n);
    }
    /**
     * Adds a new value into an Object Store and returns the new key. Similar to
     * IndexedDb's `add()`, this method will fail on primary key collisions.
     *
     * @param value - The object to write.
     * @returns The key of the value to add.
     */ add(t) {
        $5c04988f82cad1b3$var$M("SimpleDb", "ADD", this.store.name, t, t);
        return $5c04988f82cad1b3$var$Nt(this.store.add(t));
    }
    /**
     * Gets the object with the specified key from the specified store, or null
     * if no object exists with the specified key.
     *
     * @key The key of the object to get.
     * @returns The object with the specified key or null if no object exists.
     */ get(t) {
        // We're doing an unsafe cast to ValueType.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return $5c04988f82cad1b3$var$Nt(this.store.get(t)).next((e)=>// Normalize nonexistence to null.
            (void 0 === e && (e = null), $5c04988f82cad1b3$var$M("SimpleDb", "GET", this.store.name, t, e), e));
    }
    delete(t) {
        $5c04988f82cad1b3$var$M("SimpleDb", "DELETE", this.store.name, t);
        return $5c04988f82cad1b3$var$Nt(this.store.delete(t));
    }
    /**
     * If we ever need more of the count variants, we can add overloads. For now,
     * all we need is to count everything in a store.
     *
     * Returns the number of rows in the store.
     */ count() {
        $5c04988f82cad1b3$var$M("SimpleDb", "COUNT", this.store.name);
        return $5c04988f82cad1b3$var$Nt(this.store.count());
    }
    K(t, e) {
        const n = this.options(t, e);
        // Use `getAll()` if the browser supports IndexedDB v3, as it is roughly
        // 20% faster. Unfortunately, getAll() does not support custom indices.
        if (n.index || "function" != typeof this.store.getAll) {
            const t = this.cursor(n), e = [];
            return this.G(t, (t, n)=>{
                e.push(n);
            }).next(()=>e);
        }
        {
            const t = this.store.getAll(n.range);
            return new $5c04988f82cad1b3$var$Pt((e, n)=>{
                t.onerror = (t)=>{
                    n(t.target.error);
                }, t.onsuccess = (t)=>{
                    e(t.target.result);
                };
            });
        }
    }
    /**
     * Loads the first `count` elements from the provided index range. Loads all
     * elements if no limit is provided.
     */ j(t, e) {
        const n = this.store.getAll(t, null === e ? void 0 : e);
        return new $5c04988f82cad1b3$var$Pt((t, e)=>{
            n.onerror = (t)=>{
                e(t.target.error);
            }, n.onsuccess = (e)=>{
                t(e.target.result);
            };
        });
    }
    W(t, e) {
        $5c04988f82cad1b3$var$M("SimpleDb", "DELETE ALL", this.store.name);
        const n = this.options(t, e);
        n.H = !1;
        const s = this.cursor(n);
        return this.G(s, (t, e, n)=>n.delete());
    }
    J(t, e) {
        let n;
        e ? n = t : (n = {}, e = t);
        const s = this.cursor(n);
        return this.G(s, e);
    }
    /**
     * Iterates over a store, but waits for the given callback to complete for
     * each entry before iterating the next entry. This allows the callback to do
     * asynchronous work to determine if this iteration should continue.
     *
     * The provided callback should return `true` to continue iteration, and
     * `false` otherwise.
     */ Y(t) {
        const e = this.cursor({});
        return new $5c04988f82cad1b3$var$Pt((n, s)=>{
            e.onerror = (t)=>{
                const e = $5c04988f82cad1b3$var$Ot(t.target.error);
                s(e);
            }, e.onsuccess = (e)=>{
                const s = e.target.result;
                s ? t(s.primaryKey, s.value).next((t)=>{
                    t ? s.continue() : n();
                }) : n();
            };
        });
    }
    G(t, e) {
        const n = [];
        return new $5c04988f82cad1b3$var$Pt((s, i)=>{
            t.onerror = (t)=>{
                i(t.target.error);
            }, t.onsuccess = (t)=>{
                const i = t.target.result;
                if (!i) return void s();
                const r = new $5c04988f82cad1b3$var$St(i), o = e(i.primaryKey, i.value, r);
                if (o instanceof $5c04988f82cad1b3$var$Pt) {
                    const t = o.catch((t)=>(r.done(), $5c04988f82cad1b3$var$Pt.reject(t)));
                    n.push(t);
                }
                r.isDone ? s() : null === r.U ? i.continue() : i.continue(r.U);
            };
        }).next(()=>$5c04988f82cad1b3$var$Pt.waitFor(n));
    }
    options(t, e) {
        let n;
        return void 0 !== t && ("string" == typeof t ? n = t : e = t), {
            index: n,
            range: e
        };
    }
    cursor(t) {
        let e = "next";
        if (t.reverse && (e = "prev"), t.index) {
            const n = this.store.index(t.index);
            return t.H ? n.openKeyCursor(t.range, e) : n.openCursor(t.range, e);
        }
        return this.store.openCursor(t.range, e);
    }
    constructor(t){
        this.store = t;
    }
}
/**
 * Wraps an IDBRequest in a PersistencePromise, using the onsuccess / onerror
 * handlers to resolve / reject the PersistencePromise as appropriate.
 */ function $5c04988f82cad1b3$var$Nt(t) {
    return new $5c04988f82cad1b3$var$Pt((e, n)=>{
        t.onsuccess = (t)=>{
            const n = t.target.result;
            e(n);
        }, t.onerror = (t)=>{
            const e = $5c04988f82cad1b3$var$Ot(t.target.error);
            n(e);
        };
    });
}
// Guard so we only report the error once.
let $5c04988f82cad1b3$var$kt = !1;
function $5c04988f82cad1b3$var$Ot(t) {
    const e = $5c04988f82cad1b3$var$Vt.v((0, $isbtl.getUA)());
    if (e >= 12.2 && e < 13) {
        const e = "An internal error was encountered in the Indexed Database server";
        if (t.message.indexOf(e) >= 0) {
            // Wrap error in a more descriptive one.
            const t = new $5c04988f82cad1b3$export$8fada0bf726bf278("internal", `IOS_INDEXEDDB_BUG1: IndexedDb has thrown '${e}'. This is likely due to an unavoidable bug in iOS. See https://stackoverflow.com/q/56496296/110915 for details and a potential workaround.`);
            return $5c04988f82cad1b3$var$kt || ($5c04988f82cad1b3$var$kt = !0, // Throw a global exception outside of this promise chain, for the user to
            // potentially catch.
            setTimeout(()=>{
                throw t;
            }, 0)), t;
        }
    }
    return t;
}
/** This class is responsible for the scheduling of Index Backfiller. */ class $5c04988f82cad1b3$var$Mt {
    start() {}
    stop() {
        this.task && (this.task.cancel(), this.task = null);
    }
    get started() {
        return null !== this.task;
    }
    Z(t) {
        $5c04988f82cad1b3$var$M("IndexBackiller", `Scheduled in ${t}ms`), this.task = this.asyncQueue.enqueueAfterDelay("index_backfill" /* IndexBackfill */ , t, async ()=>{
            this.task = null;
            try {
                $5c04988f82cad1b3$var$M("IndexBackiller", `Documents written: ${await this.X.tt()}`);
            } catch (t) {
                $5c04988f82cad1b3$var$Ct(t) ? $5c04988f82cad1b3$var$M("IndexBackiller", "Ignoring IndexedDB error during index backfill: ", t) : await $5c04988f82cad1b3$var$bt(t);
            }
            await this.Z(1);
        });
    }
    constructor(t, e){
        this.asyncQueue = t, this.X = e, this.task = null;
    }
}
/** Implements the steps for backfilling indexes. */ class $5c04988f82cad1b3$var$Ft {
    async tt(t = 50) {
        return this.persistence.runTransaction("Backfill Indexes", "readwrite-primary", (e)=>this.et(e, t));
    }
    /** Writes index entries until the cap is reached. Returns the number of documents processed. */ et(t, e) {
        const n = new Set;
        let s = e, i = !0;
        return $5c04988f82cad1b3$var$Pt.doWhile(()=>!0 === i && s > 0, ()=>this.localStore.indexManager.getNextCollectionGroupToUpdate(t).next((e)=>{
                if (null !== e && !n.has(e)) return $5c04988f82cad1b3$var$M("IndexBackiller", `Processing collection: ${e}`), this.nt(t, e, s).next((t)=>{
                    s -= t, n.add(e);
                });
                i = !1;
            })).next(()=>e - s);
    }
    /**
     * Writes entries for the provided collection group. Returns the number of documents processed.
     */ nt(t, e, n) {
        // Use the earliest offset of all field indexes to query the local cache.
        return this.localStore.indexManager.getMinOffsetFromCollectionGroup(t, e).next((s)=>this.localStore.localDocuments.getNextDocuments(t, e, s, n).next((n)=>{
                const i = n.changes;
                return this.localStore.indexManager.updateIndexEntries(t, i).next(()=>this.st(s, n)).next((n)=>($5c04988f82cad1b3$var$M("IndexBackiller", `Updating offset: ${n}`), this.localStore.indexManager.updateCollectionGroup(t, e, n))).next(()=>i.size);
            }));
    }
    /** Returns the next offset based on the provided documents. */ st(t, e) {
        let n = t;
        return e.changes.forEach((t, e)=>{
            const s = $5c04988f82cad1b3$var$It(e);
            $5c04988f82cad1b3$var$Et(s, n) > 0 && (n = s);
        }), new $5c04988f82cad1b3$var$Tt(n.readTime, n.documentKey, Math.max(e.batchId, t.largestBatchId));
    }
    constructor(/**
     * LocalStore provides access to IndexManager and LocalDocumentView.
     * These properties will update when the user changes. Consequently,
     * making a local copy of IndexManager and LocalDocumentView will require
     * updates over time. The simpler solution is to rely on LocalStore to have
     * an up-to-date references to IndexManager and LocalDocumentStore.
     */ t, e){
        this.localStore = t, this.persistence = e;
    }
}
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * `ListenSequence` is a monotonic sequence. It is initialized with a minimum value to
 * exceed. All subsequent calls to next will return increasing values. If provided with a
 * `SequenceNumberSyncer`, it will additionally bump its next value when told of a new value, as
 * well as write out sequence numbers that it produces via `next()`.
 */ class $5c04988f82cad1b3$var$$t {
    it(t) {
        return this.previousValue = Math.max(t, this.previousValue), this.previousValue;
    }
    next() {
        const t = ++this.previousValue;
        return this.rt && this.rt(t), t;
    }
    constructor(t, e){
        this.previousValue = t, e && (e.sequenceNumberHandler = (t)=>this.it(t), this.rt = (t)=>e.writeSequenceNumber(t));
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $5c04988f82cad1b3$var$Bt(t) {
    let e = 0;
    for(const n in t)Object.prototype.hasOwnProperty.call(t, n) && e++;
    return e;
}
function $5c04988f82cad1b3$var$Lt(t, e) {
    for(const n in t)Object.prototype.hasOwnProperty.call(t, n) && e(n, t[n]);
}
function $5c04988f82cad1b3$var$Ut(t) {
    for(const e in t)if (Object.prototype.hasOwnProperty.call(t, e)) return !1;
    return !0;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // An immutable sorted map implementation, based on a Left-leaning Red-Black
// tree.
$5c04988f82cad1b3$var$$t.ot = -1;
class $5c04988f82cad1b3$var$qt {
    // Returns a copy of the map, with the specified key/value added or replaced.
    insert(t, e) {
        return new $5c04988f82cad1b3$var$qt(this.comparator, this.root.insert(t, e, this.comparator).copy(null, null, $5c04988f82cad1b3$var$Gt.BLACK, null, null));
    }
    // Returns a copy of the map, with the specified key removed.
    remove(t) {
        return new $5c04988f82cad1b3$var$qt(this.comparator, this.root.remove(t, this.comparator).copy(null, null, $5c04988f82cad1b3$var$Gt.BLACK, null, null));
    }
    // Returns the value of the node with the given key, or null.
    get(t) {
        let e = this.root;
        for(; !e.isEmpty();){
            const n = this.comparator(t, e.key);
            if (0 === n) return e.value;
            n < 0 ? e = e.left : n > 0 && (e = e.right);
        }
        return null;
    }
    // Returns the index of the element in this sorted map, or -1 if it doesn't
    // exist.
    indexOf(t) {
        // Number of nodes that were pruned when descending right
        let e = 0, n = this.root;
        for(; !n.isEmpty();){
            const s = this.comparator(t, n.key);
            if (0 === s) return e + n.left.size;
            s < 0 ? n = n.left : // Count all nodes left of the node plus the node itself
            (e += n.left.size + 1, n = n.right);
        }
        // Node not found
        return -1;
    }
    isEmpty() {
        return this.root.isEmpty();
    }
    // Returns the total number of nodes in the map.
    get size() {
        return this.root.size;
    }
    // Returns the minimum key in the map.
    minKey() {
        return this.root.minKey();
    }
    // Returns the maximum key in the map.
    maxKey() {
        return this.root.maxKey();
    }
    // Traverses the map in key order and calls the specified action function
    // for each key/value pair. If action returns true, traversal is aborted.
    // Returns the first truthy value returned by action, or the last falsey
    // value returned by action.
    inorderTraversal(t) {
        return this.root.inorderTraversal(t);
    }
    forEach(t) {
        this.inorderTraversal((e, n)=>(t(e, n), !1));
    }
    toString() {
        const t = [];
        return this.inorderTraversal((e, n)=>(t.push(`${e}:${n}`), !1)), `{${t.join(", ")}}`;
    }
    // Traverses the map in reverse key order and calls the specified action
    // function for each key/value pair. If action returns true, traversal is
    // aborted.
    // Returns the first truthy value returned by action, or the last falsey
    // value returned by action.
    reverseTraversal(t) {
        return this.root.reverseTraversal(t);
    }
    // Returns an iterator over the SortedMap.
    getIterator() {
        return new $5c04988f82cad1b3$var$Kt(this.root, null, this.comparator, !1);
    }
    getIteratorFrom(t) {
        return new $5c04988f82cad1b3$var$Kt(this.root, t, this.comparator, !1);
    }
    getReverseIterator() {
        return new $5c04988f82cad1b3$var$Kt(this.root, null, this.comparator, !0);
    }
    getReverseIteratorFrom(t) {
        return new $5c04988f82cad1b3$var$Kt(this.root, t, this.comparator, !0);
    }
    constructor(t, e){
        this.comparator = t, this.root = e || $5c04988f82cad1b3$var$Gt.EMPTY;
    }
}
// end SortedMap
// An iterator over an LLRBNode.
class $5c04988f82cad1b3$var$Kt {
    getNext() {
        let t = this.nodeStack.pop();
        const e = {
            key: t.key,
            value: t.value
        };
        if (this.isReverse) for(t = t.left; !t.isEmpty();)this.nodeStack.push(t), t = t.right;
        else for(t = t.right; !t.isEmpty();)this.nodeStack.push(t), t = t.left;
        return e;
    }
    hasNext() {
        return this.nodeStack.length > 0;
    }
    peek() {
        if (0 === this.nodeStack.length) return null;
        const t = this.nodeStack[this.nodeStack.length - 1];
        return {
            key: t.key,
            value: t.value
        };
    }
    constructor(t, e, n, s){
        this.isReverse = s, this.nodeStack = [];
        let i = 1;
        for(; !t.isEmpty();)if (i = e ? n(t.key, e) : 1, // flip the comparison if we're going in reverse
        e && s && (i *= -1), i < 0) // This node is less than our start key. ignore it
        t = this.isReverse ? t.left : t.right;
        else {
            if (0 === i) {
                // This node is exactly equal to our start key. Push it on the stack,
                // but stop iterating;
                this.nodeStack.push(t);
                break;
            }
            // This node is greater than our start key, add it to the stack and move
            // to the next one
            this.nodeStack.push(t), t = this.isReverse ? t.right : t.left;
        }
    }
}
// end SortedMapIterator
// Represents a node in a Left-leaning Red-Black tree.
class $5c04988f82cad1b3$var$Gt {
    // Returns a copy of the current node, optionally replacing pieces of it.
    copy(t, e, n, s, i) {
        return new $5c04988f82cad1b3$var$Gt(null != t ? t : this.key, null != e ? e : this.value, null != n ? n : this.color, null != s ? s : this.left, null != i ? i : this.right);
    }
    isEmpty() {
        return !1;
    }
    // Traverses the tree in key order and calls the specified action function
    // for each node. If action returns true, traversal is aborted.
    // Returns the first truthy value returned by action, or the last falsey
    // value returned by action.
    inorderTraversal(t) {
        return this.left.inorderTraversal(t) || t(this.key, this.value) || this.right.inorderTraversal(t);
    }
    // Traverses the tree in reverse key order and calls the specified action
    // function for each node. If action returns true, traversal is aborted.
    // Returns the first truthy value returned by action, or the last falsey
    // value returned by action.
    reverseTraversal(t) {
        return this.right.reverseTraversal(t) || t(this.key, this.value) || this.left.reverseTraversal(t);
    }
    // Returns the minimum node in the tree.
    min() {
        return this.left.isEmpty() ? this : this.left.min();
    }
    // Returns the maximum key in the tree.
    minKey() {
        return this.min().key;
    }
    // Returns the maximum key in the tree.
    maxKey() {
        return this.right.isEmpty() ? this.key : this.right.maxKey();
    }
    // Returns new tree, with the key/value added.
    insert(t, e, n) {
        let s = this;
        const i = n(t, s.key);
        return s = i < 0 ? s.copy(null, null, null, s.left.insert(t, e, n), null) : 0 === i ? s.copy(null, e, null, null, null) : s.copy(null, null, null, null, s.right.insert(t, e, n)), s.fixUp();
    }
    removeMin() {
        if (this.left.isEmpty()) return $5c04988f82cad1b3$var$Gt.EMPTY;
        let t = this;
        return t.left.isRed() || t.left.left.isRed() || (t = t.moveRedLeft()), t = t.copy(null, null, null, t.left.removeMin(), null), t.fixUp();
    }
    // Returns new tree, with the specified item removed.
    remove(t, e) {
        let n, s = this;
        if (e(t, s.key) < 0) s.left.isEmpty() || s.left.isRed() || s.left.left.isRed() || (s = s.moveRedLeft()), s = s.copy(null, null, null, s.left.remove(t, e), null);
        else {
            if (s.left.isRed() && (s = s.rotateRight()), s.right.isEmpty() || s.right.isRed() || s.right.left.isRed() || (s = s.moveRedRight()), 0 === e(t, s.key)) {
                if (s.right.isEmpty()) return $5c04988f82cad1b3$var$Gt.EMPTY;
                n = s.right.min(), s = s.copy(n.key, n.value, null, null, s.right.removeMin());
            }
            s = s.copy(null, null, null, null, s.right.remove(t, e));
        }
        return s.fixUp();
    }
    isRed() {
        return this.color;
    }
    // Returns new tree after performing any needed rotations.
    fixUp() {
        let t = this;
        return t.right.isRed() && !t.left.isRed() && (t = t.rotateLeft()), t.left.isRed() && t.left.left.isRed() && (t = t.rotateRight()), t.left.isRed() && t.right.isRed() && (t = t.colorFlip()), t;
    }
    moveRedLeft() {
        let t = this.colorFlip();
        return t.right.left.isRed() && (t = t.copy(null, null, null, null, t.right.rotateRight()), t = t.rotateLeft(), t = t.colorFlip()), t;
    }
    moveRedRight() {
        let t = this.colorFlip();
        return t.left.left.isRed() && (t = t.rotateRight(), t = t.colorFlip()), t;
    }
    rotateLeft() {
        const t = this.copy(null, null, $5c04988f82cad1b3$var$Gt.RED, null, this.right.left);
        return this.right.copy(null, null, this.color, t, null);
    }
    rotateRight() {
        const t = this.copy(null, null, $5c04988f82cad1b3$var$Gt.RED, this.left.right, null);
        return this.left.copy(null, null, this.color, null, t);
    }
    colorFlip() {
        const t = this.left.copy(null, null, !this.left.color, null, null), e = this.right.copy(null, null, !this.right.color, null, null);
        return this.copy(null, null, !this.color, t, e);
    }
    // For testing.
    checkMaxDepth() {
        const t = this.check();
        return Math.pow(2, t) <= this.size + 1;
    }
    // In a balanced RB tree, the black-depth (number of black nodes) from root to
    // leaves is equal on both sides.  This function verifies that or asserts.
    check() {
        if (this.isRed() && this.left.isRed()) throw $5c04988f82cad1b3$var$L();
        if (this.right.isRed()) throw $5c04988f82cad1b3$var$L();
        const t = this.left.check();
        if (t !== this.right.check()) throw $5c04988f82cad1b3$var$L();
        return t + (this.isRed() ? 0 : 1);
    }
    constructor(t, e, n, s, i){
        this.key = t, this.value = e, this.color = null != n ? n : $5c04988f82cad1b3$var$Gt.RED, this.left = null != s ? s : $5c04988f82cad1b3$var$Gt.EMPTY, this.right = null != i ? i : $5c04988f82cad1b3$var$Gt.EMPTY, this.size = this.left.size + 1 + this.right.size;
    }
}
// end LLRBNode
// Empty node is shared between all LLRB trees.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
$5c04988f82cad1b3$var$Gt.EMPTY = null, $5c04988f82cad1b3$var$Gt.RED = !0, $5c04988f82cad1b3$var$Gt.BLACK = !1;
// end LLRBEmptyNode
$5c04988f82cad1b3$var$Gt.EMPTY = new // Represents an empty node (a leaf node in the Red-Black Tree).
class {
    get key() {
        throw $5c04988f82cad1b3$var$L();
    }
    get value() {
        throw $5c04988f82cad1b3$var$L();
    }
    get color() {
        throw $5c04988f82cad1b3$var$L();
    }
    get left() {
        throw $5c04988f82cad1b3$var$L();
    }
    get right() {
        throw $5c04988f82cad1b3$var$L();
    }
    // Returns a copy of the current node.
    copy(t, e, n, s, i) {
        return this;
    }
    // Returns a copy of the tree, with the specified key/value added.
    insert(t, e, n) {
        return new $5c04988f82cad1b3$var$Gt(t, e);
    }
    // Returns a copy of the tree, with the specified key removed.
    remove(t, e) {
        return this;
    }
    isEmpty() {
        return !0;
    }
    inorderTraversal(t) {
        return !1;
    }
    reverseTraversal(t) {
        return !1;
    }
    minKey() {
        return null;
    }
    maxKey() {
        return null;
    }
    isRed() {
        return !1;
    }
    // For testing.
    checkMaxDepth() {
        return !0;
    }
    check() {
        return 0;
    }
    constructor(){
        this.size = 0;
    }
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * SortedSet is an immutable (copy-on-write) collection that holds elements
 * in order specified by the provided comparator.
 *
 * NOTE: if provided comparator returns 0 for two elements, we consider them to
 * be equal!
 */ class $5c04988f82cad1b3$var$Qt {
    has(t) {
        return null !== this.data.get(t);
    }
    first() {
        return this.data.minKey();
    }
    last() {
        return this.data.maxKey();
    }
    get size() {
        return this.data.size;
    }
    indexOf(t) {
        return this.data.indexOf(t);
    }
    /** Iterates elements in order defined by "comparator" */ forEach(t) {
        this.data.inorderTraversal((e, n)=>(t(e), !1));
    }
    /** Iterates over `elem`s such that: range[0] &lt;= elem &lt; range[1]. */ forEachInRange(t, e) {
        const n = this.data.getIteratorFrom(t[0]);
        for(; n.hasNext();){
            const s = n.getNext();
            if (this.comparator(s.key, t[1]) >= 0) return;
            e(s.key);
        }
    }
    /**
     * Iterates over `elem`s such that: start &lt;= elem until false is returned.
     */ forEachWhile(t, e) {
        let n;
        for(n = void 0 !== e ? this.data.getIteratorFrom(e) : this.data.getIterator(); n.hasNext();){
            if (!t(n.getNext().key)) return;
        }
    }
    /** Finds the least element greater than or equal to `elem`. */ firstAfterOrEqual(t) {
        const e = this.data.getIteratorFrom(t);
        return e.hasNext() ? e.getNext().key : null;
    }
    getIterator() {
        return new $5c04988f82cad1b3$var$jt(this.data.getIterator());
    }
    getIteratorFrom(t) {
        return new $5c04988f82cad1b3$var$jt(this.data.getIteratorFrom(t));
    }
    /** Inserts or updates an element */ add(t) {
        return this.copy(this.data.remove(t).insert(t, !0));
    }
    /** Deletes an element */ delete(t) {
        return this.has(t) ? this.copy(this.data.remove(t)) : this;
    }
    isEmpty() {
        return this.data.isEmpty();
    }
    unionWith(t) {
        let e = this;
        // Make sure `result` always refers to the larger one of the two sets.
        return e.size < t.size && (e = t, t = this), t.forEach((t)=>{
            e = e.add(t);
        }), e;
    }
    isEqual(t) {
        if (!(t instanceof $5c04988f82cad1b3$var$Qt)) return !1;
        if (this.size !== t.size) return !1;
        const e = this.data.getIterator(), n = t.data.getIterator();
        for(; e.hasNext();){
            const t = e.getNext().key, s = n.getNext().key;
            if (0 !== this.comparator(t, s)) return !1;
        }
        return !0;
    }
    toArray() {
        const t = [];
        return this.forEach((e)=>{
            t.push(e);
        }), t;
    }
    toString() {
        const t = [];
        return this.forEach((e)=>t.push(e)), "SortedSet(" + t.toString() + ")";
    }
    copy(t) {
        const e = new $5c04988f82cad1b3$var$Qt(this.comparator);
        return e.data = t, e;
    }
    constructor(t){
        this.comparator = t, this.data = new $5c04988f82cad1b3$var$qt(this.comparator);
    }
}
class $5c04988f82cad1b3$var$jt {
    getNext() {
        return this.iter.getNext().key;
    }
    hasNext() {
        return this.iter.hasNext();
    }
    constructor(t){
        this.iter = t;
    }
}
/**
 * Compares two sorted sets for equality using their natural ordering. The
 * method computes the intersection and invokes `onAdd` for every element that
 * is in `after` but not `before`. `onRemove` is invoked for every element in
 * `before` but missing from `after`.
 *
 * The method creates a copy of both `before` and `after` and runs in O(n log
 * n), where n is the size of the two lists.
 *
 * @param before - The elements that exist in the original set.
 * @param after - The elements to diff against the original set.
 * @param comparator - The comparator for the elements in before and after.
 * @param onAdd - A function to invoke for every element that is part of `
 * after` but not `before`.
 * @param onRemove - A function to invoke for every element that is part of
 * `before` but not `after`.
 */ /**
 * Returns the next element from the iterator or `undefined` if none available.
 */ function $5c04988f82cad1b3$var$Wt(t) {
    return t.hasNext() ? t.getNext() : void 0;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provides a set of fields that can be used to partially patch a document.
 * FieldMask is used in conjunction with ObjectValue.
 * Examples:
 *   foo - Overwrites foo entirely with the provided value. If foo is not
 *         present in the companion ObjectValue, the field is deleted.
 *   foo.bar - Overwrites only the field bar of the object foo.
 *             If foo is not an object, foo is replaced with an object
 *             containing foo
 */ class $5c04988f82cad1b3$var$zt {
    static empty() {
        return new $5c04988f82cad1b3$var$zt([]);
    }
    /**
     * Returns a new FieldMask object that is the result of adding all the given
     * fields paths to this field mask.
     */ unionWith(t) {
        let e = new $5c04988f82cad1b3$var$Qt($5c04988f82cad1b3$export$b7871852b967eaf1.comparator);
        for (const t of this.fields)e = e.add(t);
        for (const n of t)e = e.add(n);
        return new $5c04988f82cad1b3$var$zt(e.toArray());
    }
    /**
     * Verifies that `fieldPath` is included by at least one field in this field
     * mask.
     *
     * This is an O(n) operation, where `n` is the size of the field mask.
     */ covers(t) {
        for (const e of this.fields)if (e.isPrefixOf(t)) return !0;
        return !1;
    }
    isEqual(t) {
        return $5c04988f82cad1b3$var$rt(this.fields, t.fields, (t, e)=>t.isEqual(e));
    }
    constructor(t){
        this.fields = t, // TODO(dimond): validation of FieldMask
        // Sort the field mask to support `FieldMask.isEqual()` and assert below.
        t.sort($5c04988f82cad1b3$export$b7871852b967eaf1.comparator);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Converts a Base64 encoded string to a binary string. */ /** True if and only if the Base64 conversion functions are available. */ function $5c04988f82cad1b3$export$cbfc1605afde699b() {
    return "undefined" != typeof atob;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Immutable class that represents a "proto" byte string.
 *
 * Proto byte strings can either be Base64-encoded strings or Uint8Arrays when
 * sent on the wire. This class abstracts away this differentiation by holding
 * the proto byte string in a common class that must be converted into a string
 * before being sent as a proto.
 * @internal
 */ class $5c04988f82cad1b3$var$Jt {
    static fromBase64String(t) {
        const e = atob(t);
        return new $5c04988f82cad1b3$var$Jt(e);
    }
    static fromUint8Array(t) {
        // TODO(indexing); Remove the copy of the byte string here as this method
        // is frequently called during indexing.
        const e = /**
 * Helper function to convert an Uint8array to a binary string.
 */ function(t) {
            let e = "";
            for(let n = 0; n < t.length; ++n)e += String.fromCharCode(t[n]);
            return e;
        }(t);
        return new $5c04988f82cad1b3$var$Jt(e);
    }
    [Symbol.iterator]() {
        let t = 0;
        return {
            next: ()=>t < this.binaryString.length ? {
                    value: this.binaryString.charCodeAt(t++),
                    done: !1
                } : {
                    value: void 0,
                    done: !0
                }
        };
    }
    toBase64() {
        var t;
        return t = this.binaryString, btoa(t);
    }
    toUint8Array() {
        return function(t) {
            const e = new Uint8Array(t.length);
            for(let n = 0; n < t.length; n++)e[n] = t.charCodeAt(n);
            return e;
        }(this.binaryString);
    }
    approximateByteSize() {
        return 2 * this.binaryString.length;
    }
    compareTo(t) {
        return $5c04988f82cad1b3$var$it(this.binaryString, t.binaryString);
    }
    isEqual(t) {
        return this.binaryString === t.binaryString;
    }
    constructor(t){
        this.binaryString = t;
    }
}
$5c04988f82cad1b3$var$Jt.EMPTY_BYTE_STRING = new $5c04988f82cad1b3$var$Jt("");
const $5c04988f82cad1b3$var$Yt = new RegExp(/^\d{4}-\d\d-\d\dT\d\d:\d\d:\d\d(?:\.(\d+))?Z$/);
/**
 * Converts the possible Proto values for a timestamp value into a "seconds and
 * nanos" representation.
 */ function $5c04988f82cad1b3$var$Xt(t) {
    // The json interface (for the browser) will return an iso timestamp string,
    // while the proto js library (for node) will return a
    // google.protobuf.Timestamp instance.
    if ($5c04988f82cad1b3$var$U(!!t), "string" == typeof t) {
        // The date string can have higher precision (nanos) than the Date class
        // (millis), so we do some custom parsing here.
        // Parse the nanos right out of the string.
        let e = 0;
        const n = $5c04988f82cad1b3$var$Yt.exec(t);
        if ($5c04988f82cad1b3$var$U(!!n), n[1]) {
            // Pad the fraction out to 9 digits (nanos).
            let t = n[1];
            t = (t + "000000000").substr(0, 9), e = Number(t);
        }
        // Parse the date to get the seconds.
        const s = new Date(t);
        return {
            seconds: Math.floor(s.getTime() / 1e3),
            nanos: e
        };
    }
    return {
        seconds: $5c04988f82cad1b3$var$Zt(t.seconds),
        nanos: $5c04988f82cad1b3$var$Zt(t.nanos)
    };
}
/**
 * Converts the possible Proto types for numbers into a JavaScript number.
 * Returns 0 if the value is not numeric.
 */ function $5c04988f82cad1b3$var$Zt(t) {
    // TODO(bjornick): Handle int64 greater than 53 bits.
    return "number" == typeof t ? t : "string" == typeof t ? Number(t) : 0;
}
/** Converts the possible Proto types for Blobs into a ByteString. */ function $5c04988f82cad1b3$var$te(t) {
    return "string" == typeof t ? $5c04988f82cad1b3$var$Jt.fromBase64String(t) : $5c04988f82cad1b3$var$Jt.fromUint8Array(t);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a locally-applied ServerTimestamp.
 *
 * Server Timestamps are backed by MapValues that contain an internal field
 * `__type__` with a value of `server_timestamp`. The previous value and local
 * write time are stored in its `__previous_value__` and `__local_write_time__`
 * fields respectively.
 *
 * Notes:
 * - ServerTimestampValue instances are created as the result of applying a
 *   transform. They can only exist in the local view of a document. Therefore
 *   they do not need to be parsed or serialized.
 * - When evaluated locally (e.g. for snapshot.data()), they by default
 *   evaluate to `null`. This behavior can be configured by passing custom
 *   FieldValueOptions to value().
 * - With respect to other ServerTimestampValues, they sort by their
 *   localWriteTime.
 */ function $5c04988f82cad1b3$var$ee(t) {
    var e, n;
    return "server_timestamp" === (null === (n = ((null === (e = null == t ? void 0 : t.mapValue) || void 0 === e ? void 0 : e.fields) || {}).__type__) || void 0 === n ? void 0 : n.stringValue);
}
/**
 * Creates a new ServerTimestamp proto value (using the internal format).
 */ /**
 * Returns the value of the field before this ServerTimestamp was set.
 *
 * Preserving the previous values allows the user to display the last resoled
 * value until the backend responds with the timestamp.
 */ function $5c04988f82cad1b3$var$ne(t) {
    const e = t.mapValue.fields.__previous_value__;
    return $5c04988f82cad1b3$var$ee(e) ? $5c04988f82cad1b3$var$ne(e) : e;
}
/**
 * Returns the local time at which this timestamp was first set.
 */ function $5c04988f82cad1b3$var$se(t) {
    const e = $5c04988f82cad1b3$var$Xt(t.mapValue.fields.__local_write_time__.timestampValue);
    return new $5c04988f82cad1b3$export$d9bcbd5e1ff81430(e.seconds, e.nanos);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $5c04988f82cad1b3$var$ie {
    /**
     * Constructs a DatabaseInfo using the provided host, databaseId and
     * persistenceKey.
     *
     * @param databaseId - The database to use.
     * @param appId - The Firebase App Id.
     * @param persistenceKey - A unique identifier for this Firestore's local
     * storage (used in conjunction with the databaseId).
     * @param host - The Firestore backend host to connect to.
     * @param ssl - Whether to use SSL when connecting.
     * @param forceLongPolling - Whether to use the forceLongPolling option
     * when using WebChannel as the network transport.
     * @param autoDetectLongPolling - Whether to use the detectBufferingProxy
     * option when using WebChannel as the network transport.
     * @param useFetchStreams Whether to use the Fetch API instead of
     * XMLHTTPRequest
     */ constructor(t, e, n, s, i, r, o, u){
        this.databaseId = t, this.appId = e, this.persistenceKey = n, this.host = s, this.ssl = i, this.forceLongPolling = r, this.autoDetectLongPolling = o, this.useFetchStreams = u;
    }
}
/** The default database name for a project. */ /**
 * Represents the database ID a Firestore client is associated with.
 * @internal
 */ class $5c04988f82cad1b3$export$4c3ccc07620ae30a {
    static empty() {
        return new $5c04988f82cad1b3$export$4c3ccc07620ae30a("", "");
    }
    get isDefaultDatabase() {
        return "(default)" === this.database;
    }
    isEqual(t) {
        return t instanceof $5c04988f82cad1b3$export$4c3ccc07620ae30a && t.projectId === this.projectId && t.database === this.database;
    }
    constructor(t, e){
        this.projectId = t, this.database = e || "(default)";
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Sentinel value that sorts before any Mutation Batch ID. */ /**
 * Returns whether a variable is either undefined or null.
 */ function $5c04988f82cad1b3$var$oe(t) {
    return null == t;
}
/** Returns whether the value represents -0. */ function $5c04988f82cad1b3$var$ue(t) {
    // Detect if the value is -0.0. Based on polyfill from
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
    return 0 === t && 1 / t == -1 / 0;
}
/**
 * Returns whether a value is an integer and in the safe integer range
 * @param value - The value to test for being an integer and in the safe range
 */ function $5c04988f82cad1b3$var$ce(t) {
    return "number" == typeof t && Number.isInteger(t) && !$5c04988f82cad1b3$var$ue(t) && t <= Number.MAX_SAFE_INTEGER && t >= Number.MIN_SAFE_INTEGER;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $5c04988f82cad1b3$var$ae = {
    mapValue: {
        fields: {
            __type__: {
                stringValue: "__max__"
            }
        }
    }
}, $5c04988f82cad1b3$var$he = {
    nullValue: "NULL_VALUE"
};
/** Extracts the backend's type order for the provided value. */ function $5c04988f82cad1b3$var$le(t) {
    return "nullValue" in t ? 0 /* NullValue */  : "booleanValue" in t ? 1 /* BooleanValue */  : "integerValue" in t || "doubleValue" in t ? 2 /* NumberValue */  : "timestampValue" in t ? 3 /* TimestampValue */  : "stringValue" in t ? 5 /* StringValue */  : "bytesValue" in t ? 6 /* BlobValue */  : "referenceValue" in t ? 7 /* RefValue */  : "geoPointValue" in t ? 8 /* GeoPointValue */  : "arrayValue" in t ? 9 /* ArrayValue */  : "mapValue" in t ? $5c04988f82cad1b3$var$ee(t) ? 4 /* ServerTimestampValue */  : $5c04988f82cad1b3$var$be(t) ? 9007199254740991 /* MaxValue */  : 10 /* ObjectValue */  : $5c04988f82cad1b3$var$L();
}
/** Tests `left` and `right` for equality based on the backend semantics. */ function $5c04988f82cad1b3$var$fe(t, e) {
    if (t === e) return !0;
    const n = $5c04988f82cad1b3$var$le(t);
    if (n !== $5c04988f82cad1b3$var$le(e)) return !1;
    switch(n){
        case 0 /* NullValue */ :
        case 9007199254740991 /* MaxValue */ :
            return !0;
        case 1 /* BooleanValue */ :
            return t.booleanValue === e.booleanValue;
        case 4 /* ServerTimestampValue */ :
            return $5c04988f82cad1b3$var$se(t).isEqual($5c04988f82cad1b3$var$se(e));
        case 3 /* TimestampValue */ :
            return function(t, e) {
                if ("string" == typeof t.timestampValue && "string" == typeof e.timestampValue && t.timestampValue.length === e.timestampValue.length) // Use string equality for ISO 8601 timestamps
                return t.timestampValue === e.timestampValue;
                const n = $5c04988f82cad1b3$var$Xt(t.timestampValue), s = $5c04988f82cad1b3$var$Xt(e.timestampValue);
                return n.seconds === s.seconds && n.nanos === s.nanos;
            }(t, e);
        case 5 /* StringValue */ :
            return t.stringValue === e.stringValue;
        case 6 /* BlobValue */ :
            return function(t, e) {
                return $5c04988f82cad1b3$var$te(t.bytesValue).isEqual($5c04988f82cad1b3$var$te(e.bytesValue));
            }(t, e);
        case 7 /* RefValue */ :
            return t.referenceValue === e.referenceValue;
        case 8 /* GeoPointValue */ :
            return function(t, e) {
                return $5c04988f82cad1b3$var$Zt(t.geoPointValue.latitude) === $5c04988f82cad1b3$var$Zt(e.geoPointValue.latitude) && $5c04988f82cad1b3$var$Zt(t.geoPointValue.longitude) === $5c04988f82cad1b3$var$Zt(e.geoPointValue.longitude);
            }(t, e);
        case 2 /* NumberValue */ :
            return function(t, e) {
                if ("integerValue" in t && "integerValue" in e) return $5c04988f82cad1b3$var$Zt(t.integerValue) === $5c04988f82cad1b3$var$Zt(e.integerValue);
                if ("doubleValue" in t && "doubleValue" in e) {
                    const n = $5c04988f82cad1b3$var$Zt(t.doubleValue), s = $5c04988f82cad1b3$var$Zt(e.doubleValue);
                    return n === s ? $5c04988f82cad1b3$var$ue(n) === $5c04988f82cad1b3$var$ue(s) : isNaN(n) && isNaN(s);
                }
                return !1;
            }(t, e);
        case 9 /* ArrayValue */ :
            return $5c04988f82cad1b3$var$rt(t.arrayValue.values || [], e.arrayValue.values || [], $5c04988f82cad1b3$var$fe);
        case 10 /* ObjectValue */ :
            return function(t, e) {
                const n = t.mapValue.fields || {}, s = e.mapValue.fields || {};
                if ($5c04988f82cad1b3$var$Bt(n) !== $5c04988f82cad1b3$var$Bt(s)) return !1;
                for(const t in n)if (n.hasOwnProperty(t) && (void 0 === s[t] || !$5c04988f82cad1b3$var$fe(n[t], s[t]))) return !1;
                return !0;
            }(t, e);
        default:
            return $5c04988f82cad1b3$var$L();
    }
}
function $5c04988f82cad1b3$var$de(t, e) {
    return void 0 !== (t.values || []).find((t)=>$5c04988f82cad1b3$var$fe(t, e));
}
function $5c04988f82cad1b3$var$_e(t, e) {
    if (t === e) return 0;
    const n = $5c04988f82cad1b3$var$le(t), s = $5c04988f82cad1b3$var$le(e);
    if (n !== s) return $5c04988f82cad1b3$var$it(n, s);
    switch(n){
        case 0 /* NullValue */ :
        case 9007199254740991 /* MaxValue */ :
            return 0;
        case 1 /* BooleanValue */ :
            return $5c04988f82cad1b3$var$it(t.booleanValue, e.booleanValue);
        case 2 /* NumberValue */ :
            return function(t, e) {
                const n = $5c04988f82cad1b3$var$Zt(t.integerValue || t.doubleValue), s = $5c04988f82cad1b3$var$Zt(e.integerValue || e.doubleValue);
                return n < s ? -1 : n > s ? 1 : n === s ? 0 : // one or both are NaN.
                isNaN(n) ? isNaN(s) ? 0 : -1 : 1;
            }(t, e);
        case 3 /* TimestampValue */ :
            return $5c04988f82cad1b3$var$we(t.timestampValue, e.timestampValue);
        case 4 /* ServerTimestampValue */ :
            return $5c04988f82cad1b3$var$we($5c04988f82cad1b3$var$se(t), $5c04988f82cad1b3$var$se(e));
        case 5 /* StringValue */ :
            return $5c04988f82cad1b3$var$it(t.stringValue, e.stringValue);
        case 6 /* BlobValue */ :
            return function(t, e) {
                const n = $5c04988f82cad1b3$var$te(t), s = $5c04988f82cad1b3$var$te(e);
                return n.compareTo(s);
            }(t.bytesValue, e.bytesValue);
        case 7 /* RefValue */ :
            return function(t, e) {
                const n = t.split("/"), s = e.split("/");
                for(let t = 0; t < n.length && t < s.length; t++){
                    const e = $5c04988f82cad1b3$var$it(n[t], s[t]);
                    if (0 !== e) return e;
                }
                return $5c04988f82cad1b3$var$it(n.length, s.length);
            }(t.referenceValue, e.referenceValue);
        case 8 /* GeoPointValue */ :
            return function(t, e) {
                const n = $5c04988f82cad1b3$var$it($5c04988f82cad1b3$var$Zt(t.latitude), $5c04988f82cad1b3$var$Zt(e.latitude));
                if (0 !== n) return n;
                return $5c04988f82cad1b3$var$it($5c04988f82cad1b3$var$Zt(t.longitude), $5c04988f82cad1b3$var$Zt(e.longitude));
            }(t.geoPointValue, e.geoPointValue);
        case 9 /* ArrayValue */ :
            return function(t, e) {
                const n = t.values || [], s = e.values || [];
                for(let t = 0; t < n.length && t < s.length; ++t){
                    const e = $5c04988f82cad1b3$var$_e(n[t], s[t]);
                    if (e) return e;
                }
                return $5c04988f82cad1b3$var$it(n.length, s.length);
            }(t.arrayValue, e.arrayValue);
        case 10 /* ObjectValue */ :
            return function(t, e) {
                if (t === $5c04988f82cad1b3$var$ae.mapValue && e === $5c04988f82cad1b3$var$ae.mapValue) return 0;
                if (t === $5c04988f82cad1b3$var$ae.mapValue) return 1;
                if (e === $5c04988f82cad1b3$var$ae.mapValue) return -1;
                const n = t.fields || {}, s = Object.keys(n), i = e.fields || {}, r = Object.keys(i);
                // Even though MapValues are likely sorted correctly based on their insertion
                // order (e.g. when received from the backend), local modifications can bring
                // elements out of order. We need to re-sort the elements to ensure that
                // canonical IDs are independent of insertion order.
                s.sort(), r.sort();
                for(let t = 0; t < s.length && t < r.length; ++t){
                    const e = $5c04988f82cad1b3$var$it(s[t], r[t]);
                    if (0 !== e) return e;
                    const o = $5c04988f82cad1b3$var$_e(n[s[t]], i[r[t]]);
                    if (0 !== o) return o;
                }
                return $5c04988f82cad1b3$var$it(s.length, r.length);
            }(t.mapValue, e.mapValue);
        default:
            throw $5c04988f82cad1b3$var$L();
    }
}
function $5c04988f82cad1b3$var$we(t, e) {
    if ("string" == typeof t && "string" == typeof e && t.length === e.length) return $5c04988f82cad1b3$var$it(t, e);
    const n = $5c04988f82cad1b3$var$Xt(t), s = $5c04988f82cad1b3$var$Xt(e), i = $5c04988f82cad1b3$var$it(n.seconds, s.seconds);
    return 0 !== i ? i : $5c04988f82cad1b3$var$it(n.nanos, s.nanos);
}
function $5c04988f82cad1b3$var$me(t) {
    return $5c04988f82cad1b3$var$ge(t);
}
function $5c04988f82cad1b3$var$ge(t) {
    var e, n;
    return "nullValue" in t ? "null" : "booleanValue" in t ? "" + t.booleanValue : "integerValue" in t ? "" + t.integerValue : "doubleValue" in t ? "" + t.doubleValue : "timestampValue" in t ? function(t) {
        const e = $5c04988f82cad1b3$var$Xt(t);
        return `time(${e.seconds},${e.nanos})`;
    }(t.timestampValue) : "stringValue" in t ? t.stringValue : "bytesValue" in t ? $5c04988f82cad1b3$var$te(t.bytesValue).toBase64() : "referenceValue" in t ? (n = t.referenceValue, $5c04988f82cad1b3$export$afc2e57c475b7810.fromName(n).toString()) : "geoPointValue" in t ? `geo(${(e = t.geoPointValue).latitude},${e.longitude})` : "arrayValue" in t ? function(t) {
        let e = "[", n = !0;
        for (const s of t.values || [])n ? n = !1 : e += ",", e += $5c04988f82cad1b3$var$ge(s);
        return e + "]";
    }(t.arrayValue) : "mapValue" in t ? function(t) {
        // Iteration order in JavaScript is not guaranteed. To ensure that we generate
        // matching canonical IDs for identical maps, we need to sort the keys.
        const e = Object.keys(t.fields || {}).sort();
        let n = "{", s = !0;
        for (const i of e)s ? s = !1 : n += ",", n += `${i}:${$5c04988f82cad1b3$var$ge(t.fields[i])}`;
        return n + "}";
    }(t.mapValue) : $5c04988f82cad1b3$var$L();
}
function $5c04988f82cad1b3$var$ye(t, e) {
    return {
        referenceValue: `projects/${t.projectId}/databases/${t.database}/documents/${e.path.canonicalString()}`
    };
}
/** Returns true if `value` is an IntegerValue . */ function $5c04988f82cad1b3$var$pe(t) {
    return !!t && "integerValue" in t;
}
/** Returns true if `value` is a DoubleValue. */ /** Returns true if `value` is an ArrayValue. */ function $5c04988f82cad1b3$var$Ie(t) {
    return !!t && "arrayValue" in t;
}
/** Returns true if `value` is a NullValue. */ function $5c04988f82cad1b3$var$Te(t) {
    return !!t && "nullValue" in t;
}
/** Returns true if `value` is NaN. */ function $5c04988f82cad1b3$var$Ee(t) {
    return !!t && "doubleValue" in t && isNaN(Number(t.doubleValue));
}
/** Returns true if `value` is a MapValue. */ function $5c04988f82cad1b3$var$Ae(t) {
    return !!t && "mapValue" in t;
}
/** Creates a deep copy of `source`. */ function $5c04988f82cad1b3$var$Re(t) {
    if (t.geoPointValue) return {
        geoPointValue: Object.assign({}, t.geoPointValue)
    };
    if (t.timestampValue && "object" == typeof t.timestampValue) return {
        timestampValue: Object.assign({}, t.timestampValue)
    };
    if (t.mapValue) {
        const e = {
            mapValue: {
                fields: {}
            }
        };
        return $5c04988f82cad1b3$var$Lt(t.mapValue.fields, (t, n)=>e.mapValue.fields[t] = $5c04988f82cad1b3$var$Re(n)), e;
    }
    if (t.arrayValue) {
        const e = {
            arrayValue: {
                values: []
            }
        };
        for(let n = 0; n < (t.arrayValue.values || []).length; ++n)e.arrayValue.values[n] = $5c04988f82cad1b3$var$Re(t.arrayValue.values[n]);
        return e;
    }
    return Object.assign({}, t);
}
/** Returns true if the Value represents the canonical {@link #MAX_VALUE} . */ function $5c04988f82cad1b3$var$be(t) {
    return "__max__" === (((t.mapValue || {}).fields || {}).__type__ || {}).stringValue;
}
/** Returns the lowest value for the given value type (inclusive). */ function $5c04988f82cad1b3$var$Pe(t) {
    return "nullValue" in t ? $5c04988f82cad1b3$var$he : "booleanValue" in t ? {
        booleanValue: !1
    } : "integerValue" in t || "doubleValue" in t ? {
        doubleValue: NaN
    } : "timestampValue" in t ? {
        timestampValue: {
            seconds: Number.MIN_SAFE_INTEGER
        }
    } : "stringValue" in t ? {
        stringValue: ""
    } : "bytesValue" in t ? {
        bytesValue: ""
    } : "referenceValue" in t ? $5c04988f82cad1b3$var$ye($5c04988f82cad1b3$export$4c3ccc07620ae30a.empty(), $5c04988f82cad1b3$export$afc2e57c475b7810.empty()) : "geoPointValue" in t ? {
        geoPointValue: {
            latitude: -90,
            longitude: -180
        }
    } : "arrayValue" in t ? {
        arrayValue: {}
    } : "mapValue" in t ? {
        mapValue: {}
    } : $5c04988f82cad1b3$var$L();
}
/** Returns the largest value for the given value type (exclusive). */ function $5c04988f82cad1b3$var$ve(t) {
    return "nullValue" in t ? {
        booleanValue: !1
    } : "booleanValue" in t ? {
        doubleValue: NaN
    } : "integerValue" in t || "doubleValue" in t ? {
        timestampValue: {
            seconds: Number.MIN_SAFE_INTEGER
        }
    } : "timestampValue" in t ? {
        stringValue: ""
    } : "stringValue" in t ? {
        bytesValue: ""
    } : "bytesValue" in t ? $5c04988f82cad1b3$var$ye($5c04988f82cad1b3$export$4c3ccc07620ae30a.empty(), $5c04988f82cad1b3$export$afc2e57c475b7810.empty()) : "referenceValue" in t ? {
        geoPointValue: {
            latitude: -90,
            longitude: -180
        }
    } : "geoPointValue" in t ? {
        arrayValue: {}
    } : "arrayValue" in t ? {
        mapValue: {}
    } : "mapValue" in t ? $5c04988f82cad1b3$var$ae : $5c04988f82cad1b3$var$L();
}
function $5c04988f82cad1b3$var$Ve(t, e) {
    const n = $5c04988f82cad1b3$var$_e(t.value, e.value);
    return 0 !== n ? n : t.inclusive && !e.inclusive ? -1 : !t.inclusive && e.inclusive ? 1 : 0;
}
function $5c04988f82cad1b3$var$Se(t, e) {
    const n = $5c04988f82cad1b3$var$_e(t.value, e.value);
    return 0 !== n ? n : t.inclusive && !e.inclusive ? 1 : !t.inclusive && e.inclusive ? -1 : 0;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An ObjectValue represents a MapValue in the Firestore Proto and offers the
 * ability to add and remove fields (via the ObjectValueBuilder).
 */ class $5c04988f82cad1b3$var$De {
    static empty() {
        return new $5c04988f82cad1b3$var$De({
            mapValue: {}
        });
    }
    /**
     * Returns the value at the given path or null.
     *
     * @param path - the path to search
     * @returns The value at the path or null if the path is not set.
     */ field(t) {
        if (t.isEmpty()) return this.value;
        {
            let e = this.value;
            for(let n = 0; n < t.length - 1; ++n)if (e = (e.mapValue.fields || {})[t.get(n)], !$5c04988f82cad1b3$var$Ae(e)) return null;
            return e = (e.mapValue.fields || {})[t.lastSegment()], e || null;
        }
    }
    /**
     * Sets the field to the provided value.
     *
     * @param path - The field path to set.
     * @param value - The value to set.
     */ set(t, e) {
        this.getFieldsMap(t.popLast())[t.lastSegment()] = $5c04988f82cad1b3$var$Re(e);
    }
    /**
     * Sets the provided fields to the provided values.
     *
     * @param data - A map of fields to values (or null for deletes).
     */ setAll(t) {
        let e = $5c04988f82cad1b3$export$b7871852b967eaf1.emptyPath(), n = {}, s = [];
        t.forEach((t, i)=>{
            if (!e.isImmediateParentOf(i)) {
                // Insert the accumulated changes at this parent location
                const t = this.getFieldsMap(e);
                this.applyChanges(t, n, s), n = {}, s = [], e = i.popLast();
            }
            t ? n[i.lastSegment()] = $5c04988f82cad1b3$var$Re(t) : s.push(i.lastSegment());
        });
        const i = this.getFieldsMap(e);
        this.applyChanges(i, n, s);
    }
    /**
     * Removes the field at the specified path. If there is no field at the
     * specified path, nothing is changed.
     *
     * @param path - The field path to remove.
     */ delete(t) {
        const e = this.field(t.popLast());
        $5c04988f82cad1b3$var$Ae(e) && e.mapValue.fields && delete e.mapValue.fields[t.lastSegment()];
    }
    isEqual(t) {
        return $5c04988f82cad1b3$var$fe(this.value, t.value);
    }
    /**
     * Returns the map that contains the leaf element of `path`. If the parent
     * entry does not yet exist, or if it is not a map, a new map will be created.
     */ getFieldsMap(t) {
        let e = this.value;
        e.mapValue.fields || (e.mapValue = {
            fields: {}
        });
        for(let n = 0; n < t.length; ++n){
            let s = e.mapValue.fields[t.get(n)];
            $5c04988f82cad1b3$var$Ae(s) && s.mapValue.fields || (s = {
                mapValue: {
                    fields: {}
                }
            }, e.mapValue.fields[t.get(n)] = s), e = s;
        }
        return e.mapValue.fields;
    }
    /**
     * Modifies `fieldsMap` by adding, replacing or deleting the specified
     * entries.
     */ applyChanges(t, e, n) {
        $5c04988f82cad1b3$var$Lt(e, (e, n)=>t[e] = n);
        for (const e of n)delete t[e];
    }
    clone() {
        return new $5c04988f82cad1b3$var$De($5c04988f82cad1b3$var$Re(this.value));
    }
    constructor(t){
        this.value = t;
    }
}
/**
 * Returns a FieldMask built from all fields in a MapValue.
 */ function $5c04988f82cad1b3$var$Ce(t) {
    const e = [];
    return $5c04988f82cad1b3$var$Lt(t.fields, (t, n)=>{
        const s = new $5c04988f82cad1b3$export$b7871852b967eaf1([
            t
        ]);
        if ($5c04988f82cad1b3$var$Ae(n)) {
            const t = $5c04988f82cad1b3$var$Ce(n.mapValue).fields;
            if (0 === t.length) // Preserve the empty map by adding it to the FieldMask.
            e.push(s);
            else // For nested and non-empty ObjectValues, add the FieldPath of the
            // leaf nodes.
            for (const n of t)e.push(s.child(n));
        } else // For nested and non-empty ObjectValues, add the FieldPath of the leaf
        // nodes.
        e.push(s);
    }), new $5c04988f82cad1b3$var$zt(e);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a document in Firestore with a key, version, data and whether it
 * has local mutations applied to it.
 *
 * Documents can transition between states via `convertToFoundDocument()`,
 * `convertToNoDocument()` and `convertToUnknownDocument()`. If a document does
 * not transition to one of these states even after all mutations have been
 * applied, `isValidDocument()` returns false and the document should be removed
 * from all views.
 */ class $5c04988f82cad1b3$var$xe {
    /**
     * Creates a document with no known version or data, but which can serve as
     * base document for mutations.
     */ static newInvalidDocument(t) {
        return new $5c04988f82cad1b3$var$xe(t, 0 /* INVALID */ , $5c04988f82cad1b3$var$ct.min(), $5c04988f82cad1b3$var$ct.min(), $5c04988f82cad1b3$var$De.empty(), 0 /* SYNCED */ );
    }
    /**
     * Creates a new document that is known to exist with the given data at the
     * given version.
     */ static newFoundDocument(t, e, n) {
        return new $5c04988f82cad1b3$var$xe(t, 1 /* FOUND_DOCUMENT */ , e, $5c04988f82cad1b3$var$ct.min(), n, 0 /* SYNCED */ );
    }
    /** Creates a new document that is known to not exist at the given version. */ static newNoDocument(t, e) {
        return new $5c04988f82cad1b3$var$xe(t, 2 /* NO_DOCUMENT */ , e, $5c04988f82cad1b3$var$ct.min(), $5c04988f82cad1b3$var$De.empty(), 0 /* SYNCED */ );
    }
    /**
     * Creates a new document that is known to exist at the given version but
     * whose data is not known (e.g. a document that was updated without a known
     * base document).
     */ static newUnknownDocument(t, e) {
        return new $5c04988f82cad1b3$var$xe(t, 3 /* UNKNOWN_DOCUMENT */ , e, $5c04988f82cad1b3$var$ct.min(), $5c04988f82cad1b3$var$De.empty(), 2 /* HAS_COMMITTED_MUTATIONS */ );
    }
    /**
     * Changes the document type to indicate that it exists and that its version
     * and data are known.
     */ convertToFoundDocument(t, e) {
        return this.version = t, this.documentType = 1 /* FOUND_DOCUMENT */ , this.data = e, this.documentState = 0 /* SYNCED */ , this;
    }
    /**
     * Changes the document type to indicate that it doesn't exist at the given
     * version.
     */ convertToNoDocument(t) {
        return this.version = t, this.documentType = 2 /* NO_DOCUMENT */ , this.data = $5c04988f82cad1b3$var$De.empty(), this.documentState = 0 /* SYNCED */ , this;
    }
    /**
     * Changes the document type to indicate that it exists at a given version but
     * that its data is not known (e.g. a document that was updated without a known
     * base document).
     */ convertToUnknownDocument(t) {
        return this.version = t, this.documentType = 3 /* UNKNOWN_DOCUMENT */ , this.data = $5c04988f82cad1b3$var$De.empty(), this.documentState = 2 /* HAS_COMMITTED_MUTATIONS */ , this;
    }
    setHasCommittedMutations() {
        return this.documentState = 2 /* HAS_COMMITTED_MUTATIONS */ , this;
    }
    setHasLocalMutations() {
        return this.documentState = 1 /* HAS_LOCAL_MUTATIONS */ , this.version = $5c04988f82cad1b3$var$ct.min(), this;
    }
    setReadTime(t) {
        return this.readTime = t, this;
    }
    get hasLocalMutations() {
        return 1 /* HAS_LOCAL_MUTATIONS */  === this.documentState;
    }
    get hasCommittedMutations() {
        return 2 /* HAS_COMMITTED_MUTATIONS */  === this.documentState;
    }
    get hasPendingWrites() {
        return this.hasLocalMutations || this.hasCommittedMutations;
    }
    isValidDocument() {
        return 0 /* INVALID */  !== this.documentType;
    }
    isFoundDocument() {
        return 1 /* FOUND_DOCUMENT */  === this.documentType;
    }
    isNoDocument() {
        return 2 /* NO_DOCUMENT */  === this.documentType;
    }
    isUnknownDocument() {
        return 3 /* UNKNOWN_DOCUMENT */  === this.documentType;
    }
    isEqual(t) {
        return t instanceof $5c04988f82cad1b3$var$xe && this.key.isEqual(t.key) && this.version.isEqual(t.version) && this.documentType === t.documentType && this.documentState === t.documentState && this.data.isEqual(t.data);
    }
    mutableCopy() {
        return new $5c04988f82cad1b3$var$xe(this.key, this.documentType, this.version, this.readTime, this.data.clone(), this.documentState);
    }
    toString() {
        return `Document(${this.key}, ${this.version}, ${JSON.stringify(this.data.value)}, {documentType: ${this.documentType}}), {documentState: ${this.documentState}})`;
    }
    constructor(t, e, n, s, i, r){
        this.key = t, this.documentType = e, this.version = n, this.readTime = s, this.data = i, this.documentState = r;
    }
}
/**
 * Compares the value for field `field` in the provided documents. Throws if
 * the field does not exist in both documents.
 */ /**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Visible for testing
class $5c04988f82cad1b3$var$Ne {
    constructor(t, e = null, n = [], s = [], i = null, r = null, o = null){
        this.path = t, this.collectionGroup = e, this.orderBy = n, this.filters = s, this.limit = i, this.startAt = r, this.endAt = o, this.ut = null;
    }
}
/**
 * Initializes a Target with a path and optional additional query constraints.
 * Path must currently be empty if this is a collection group query.
 *
 * NOTE: you should always construct `Target` from `Query.toTarget` instead of
 * using this factory method, because `Query` provides an implicit `orderBy`
 * property.
 */ function $5c04988f82cad1b3$var$ke(t, e = null, n = [], s = [], i = null, r = null, o = null) {
    return new $5c04988f82cad1b3$var$Ne(t, e, n, s, i, r, o);
}
function $5c04988f82cad1b3$var$Oe(t) {
    const e = $5c04988f82cad1b3$var$K(t);
    if (null === e.ut) {
        let t = e.path.canonicalString();
        null !== e.collectionGroup && (t += "|cg:" + e.collectionGroup), t += "|f:", t += e.filters.map((t)=>{
            var e;
            return (e = t).field.canonicalString() + e.op.toString() + $5c04988f82cad1b3$var$me(e.value);
        }).join(","), t += "|ob:", t += e.orderBy.map((t)=>(function(t) {
                // TODO(b/29183165): Make this collision robust.
                return t.field.canonicalString() + t.dir;
            })(t)).join(","), $5c04988f82cad1b3$var$oe(e.limit) || (t += "|l:", t += e.limit), e.startAt && (t += "|lb:", t += e.startAt.inclusive ? "b:" : "a:", t += e.startAt.position.map((t)=>$5c04988f82cad1b3$var$me(t)).join(",")), e.endAt && (t += "|ub:", t += e.endAt.inclusive ? "a:" : "b:", t += e.endAt.position.map((t)=>$5c04988f82cad1b3$var$me(t)).join(",")), e.ut = t;
    }
    return e.ut;
}
function $5c04988f82cad1b3$var$Me(t) {
    let e = t.path.canonicalString();
    return null !== t.collectionGroup && (e += " collectionGroup=" + t.collectionGroup), t.filters.length > 0 && (e += `, filters: [${t.filters.map((t)=>{
        var e;
        return `${(e = t).field.canonicalString()} ${e.op} ${$5c04988f82cad1b3$var$me(e.value)}`;
    /** Filter that matches on key fields (i.e. '__name__'). */ }).join(", ")}]`), $5c04988f82cad1b3$var$oe(t.limit) || (e += ", limit: " + t.limit), t.orderBy.length > 0 && (e += `, orderBy: [${t.orderBy.map((t)=>(function(t) {
            return `${t.field.canonicalString()} (${t.dir})`;
        })(t)).join(", ")}]`), t.startAt && (e += ", startAt: ", e += t.startAt.inclusive ? "b:" : "a:", e += t.startAt.position.map((t)=>$5c04988f82cad1b3$var$me(t)).join(",")), t.endAt && (e += ", endAt: ", e += t.endAt.inclusive ? "a:" : "b:", e += t.endAt.position.map((t)=>$5c04988f82cad1b3$var$me(t)).join(",")), `Target(${e})`;
}
function $5c04988f82cad1b3$var$Fe(t, e) {
    if (t.limit !== e.limit) return !1;
    if (t.orderBy.length !== e.orderBy.length) return !1;
    for(let n = 0; n < t.orderBy.length; n++)if (!$5c04988f82cad1b3$var$Ze(t.orderBy[n], e.orderBy[n])) return !1;
    if (t.filters.length !== e.filters.length) return !1;
    for(let i = 0; i < t.filters.length; i++)if (n = t.filters[i], s = e.filters[i], n.op !== s.op || !n.field.isEqual(s.field) || !$5c04988f82cad1b3$var$fe(n.value, s.value)) return !1;
    var n, s;
    return t.collectionGroup === e.collectionGroup && !!t.path.isEqual(e.path) && !!$5c04988f82cad1b3$var$en(t.startAt, e.startAt) && $5c04988f82cad1b3$var$en(t.endAt, e.endAt);
}
function $5c04988f82cad1b3$var$$e(t) {
    return $5c04988f82cad1b3$export$afc2e57c475b7810.isDocumentKey(t.path) && null === t.collectionGroup && 0 === t.filters.length;
}
/** Returns the field filters that target the given field path. */ function $5c04988f82cad1b3$var$Be(t, e) {
    return t.filters.filter((t)=>t instanceof $5c04988f82cad1b3$var$qe && t.field.isEqual(e));
}
/**
 * Returns the values that are used in ARRAY_CONTAINS or ARRAY_CONTAINS_ANY
 * filters. Returns `null` if there are no such filters.
 */ /**
 * Returns the value to use as the lower bound for ascending index segment at
 * the provided `fieldPath` (or the upper bound for an descending segment).
 */ function $5c04988f82cad1b3$var$Le(t, e, n) {
    let s = $5c04988f82cad1b3$var$he, i = !0;
    // Process all filters to find a value for the current field segment
    for (const n of $5c04988f82cad1b3$var$Be(t, e)){
        let t = $5c04988f82cad1b3$var$he, e = !0;
        switch(n.op){
            case "<" /* LESS_THAN */ :
            case "<=" /* LESS_THAN_OR_EQUAL */ :
                t = $5c04988f82cad1b3$var$Pe(n.value);
                break;
            case "==" /* EQUAL */ :
            case "in" /* IN */ :
            case ">=" /* GREATER_THAN_OR_EQUAL */ :
                t = n.value;
                break;
            case ">" /* GREATER_THAN */ :
                t = n.value, e = !1;
                break;
            case "!=" /* NOT_EQUAL */ :
            case "not-in" /* NOT_IN */ :
                t = $5c04988f82cad1b3$var$he;
        }
        $5c04988f82cad1b3$var$Ve({
            value: s,
            inclusive: i
        }, {
            value: t,
            inclusive: e
        }) < 0 && (s = t, i = e);
    }
    // If there is an additional bound, compare the values against the existing
    // range to see if we can narrow the scope.
    if (null !== n) {
        for(let r = 0; r < t.orderBy.length; ++r)if (t.orderBy[r].field.isEqual(e)) {
            const t = n.position[r];
            $5c04988f82cad1b3$var$Ve({
                value: s,
                inclusive: i
            }, {
                value: t,
                inclusive: n.inclusive
            }) < 0 && (s = t, i = n.inclusive);
            break;
        }
    }
    return {
        value: s,
        inclusive: i
    };
}
/**
 * Returns the value to use as the upper bound for ascending index segment at
 * the provided `fieldPath` (or the lower bound for a descending segment).
 */ function $5c04988f82cad1b3$var$Ue(t, e, n) {
    let s = $5c04988f82cad1b3$var$ae, i = !0;
    // Process all filters to find a value for the current field segment
    for (const n of $5c04988f82cad1b3$var$Be(t, e)){
        let t = $5c04988f82cad1b3$var$ae, e = !0;
        switch(n.op){
            case ">=" /* GREATER_THAN_OR_EQUAL */ :
            case ">" /* GREATER_THAN */ :
                t = $5c04988f82cad1b3$var$ve(n.value), e = !1;
                break;
            case "==" /* EQUAL */ :
            case "in" /* IN */ :
            case "<=" /* LESS_THAN_OR_EQUAL */ :
                t = n.value;
                break;
            case "<" /* LESS_THAN */ :
                t = n.value, e = !1;
                break;
            case "!=" /* NOT_EQUAL */ :
            case "not-in" /* NOT_IN */ :
                t = $5c04988f82cad1b3$var$ae;
        }
        $5c04988f82cad1b3$var$Se({
            value: s,
            inclusive: i
        }, {
            value: t,
            inclusive: e
        }) > 0 && (s = t, i = e);
    }
    // If there is an additional bound, compare the values against the existing
    // range to see if we can narrow the scope.
    if (null !== n) {
        for(let r = 0; r < t.orderBy.length; ++r)if (t.orderBy[r].field.isEqual(e)) {
            const t = n.position[r];
            $5c04988f82cad1b3$var$Se({
                value: s,
                inclusive: i
            }, {
                value: t,
                inclusive: n.inclusive
            }) > 0 && (s = t, i = n.inclusive);
            break;
        }
    }
    return {
        value: s,
        inclusive: i
    };
}
/** Returns the number of segments of a perfect index for this target. */ class $5c04988f82cad1b3$var$qe extends class {
} {
    /**
     * Creates a filter based on the provided arguments.
     */ static create(t, e, n) {
        return t.isKeyField() ? "in" /* IN */  === e || "not-in" /* NOT_IN */  === e ? this.ct(t, e, n) : new $5c04988f82cad1b3$var$Ke(t, e, n) : "array-contains" /* ARRAY_CONTAINS */  === e ? new $5c04988f82cad1b3$var$We(t, n) : "in" /* IN */  === e ? new $5c04988f82cad1b3$var$ze(t, n) : "not-in" /* NOT_IN */  === e ? new $5c04988f82cad1b3$var$He(t, n) : "array-contains-any" /* ARRAY_CONTAINS_ANY */  === e ? new $5c04988f82cad1b3$var$Je(t, n) : new $5c04988f82cad1b3$var$qe(t, e, n);
    }
    static ct(t, e, n) {
        return "in" /* IN */  === e ? new $5c04988f82cad1b3$var$Ge(t, n) : new $5c04988f82cad1b3$var$Qe(t, n);
    }
    matches(t) {
        const e = t.data.field(this.field);
        // Types do not have to match in NOT_EQUAL filters.
        return "!=" /* NOT_EQUAL */  === this.op ? null !== e && this.at($5c04988f82cad1b3$var$_e(e, this.value)) : null !== e && $5c04988f82cad1b3$var$le(this.value) === $5c04988f82cad1b3$var$le(e) && this.at($5c04988f82cad1b3$var$_e(e, this.value));
    // Only compare types with matching backend order (such as double and int).
    }
    at(t) {
        switch(this.op){
            case "<" /* LESS_THAN */ :
                return t < 0;
            case "<=" /* LESS_THAN_OR_EQUAL */ :
                return t <= 0;
            case "==" /* EQUAL */ :
                return 0 === t;
            case "!=" /* NOT_EQUAL */ :
                return 0 !== t;
            case ">" /* GREATER_THAN */ :
                return t > 0;
            case ">=" /* GREATER_THAN_OR_EQUAL */ :
                return t >= 0;
            default:
                return $5c04988f82cad1b3$var$L();
        }
    }
    ht() {
        return [
            "<" /* LESS_THAN */ ,
            "<=" /* LESS_THAN_OR_EQUAL */ ,
            ">" /* GREATER_THAN */ ,
            ">=" /* GREATER_THAN_OR_EQUAL */ ,
            "!=" /* NOT_EQUAL */ ,
            "not-in" /* NOT_IN */ 
        ].indexOf(this.op) >= 0;
    }
    constructor(t, e, n){
        super(), this.field = t, this.op = e, this.value = n;
    }
}
class $5c04988f82cad1b3$var$Ke extends $5c04988f82cad1b3$var$qe {
    matches(t) {
        const e = $5c04988f82cad1b3$export$afc2e57c475b7810.comparator(t.key, this.key);
        return this.at(e);
    }
    constructor(t, e, n){
        super(t, e, n), this.key = $5c04988f82cad1b3$export$afc2e57c475b7810.fromName(n.referenceValue);
    }
}
/** Filter that matches on key fields within an array. */ class $5c04988f82cad1b3$var$Ge extends $5c04988f82cad1b3$var$qe {
    matches(t) {
        return this.keys.some((e)=>e.isEqual(t.key));
    }
    constructor(t, e){
        super(t, "in" /* IN */ , e), this.keys = $5c04988f82cad1b3$var$je("in" /* IN */ , e);
    }
}
/** Filter that matches on key fields not present within an array. */ class $5c04988f82cad1b3$var$Qe extends $5c04988f82cad1b3$var$qe {
    matches(t) {
        return !this.keys.some((e)=>e.isEqual(t.key));
    }
    constructor(t, e){
        super(t, "not-in" /* NOT_IN */ , e), this.keys = $5c04988f82cad1b3$var$je("not-in" /* NOT_IN */ , e);
    }
}
function $5c04988f82cad1b3$var$je(t, e) {
    var n;
    return ((null === (n = e.arrayValue) || void 0 === n ? void 0 : n.values) || []).map((t)=>$5c04988f82cad1b3$export$afc2e57c475b7810.fromName(t.referenceValue));
}
/** A Filter that implements the array-contains operator. */ class $5c04988f82cad1b3$var$We extends $5c04988f82cad1b3$var$qe {
    matches(t) {
        const e = t.data.field(this.field);
        return $5c04988f82cad1b3$var$Ie(e) && $5c04988f82cad1b3$var$de(e.arrayValue, this.value);
    }
    constructor(t, e){
        super(t, "array-contains" /* ARRAY_CONTAINS */ , e);
    }
}
/** A Filter that implements the IN operator. */ class $5c04988f82cad1b3$var$ze extends $5c04988f82cad1b3$var$qe {
    matches(t) {
        const e = t.data.field(this.field);
        return null !== e && $5c04988f82cad1b3$var$de(this.value.arrayValue, e);
    }
    constructor(t, e){
        super(t, "in" /* IN */ , e);
    }
}
/** A Filter that implements the not-in operator. */ class $5c04988f82cad1b3$var$He extends $5c04988f82cad1b3$var$qe {
    matches(t) {
        if ($5c04988f82cad1b3$var$de(this.value.arrayValue, {
            nullValue: "NULL_VALUE"
        })) return !1;
        const e = t.data.field(this.field);
        return null !== e && !$5c04988f82cad1b3$var$de(this.value.arrayValue, e);
    }
    constructor(t, e){
        super(t, "not-in" /* NOT_IN */ , e);
    }
}
/** A Filter that implements the array-contains-any operator. */ class $5c04988f82cad1b3$var$Je extends $5c04988f82cad1b3$var$qe {
    matches(t) {
        const e = t.data.field(this.field);
        return !(!$5c04988f82cad1b3$var$Ie(e) || !e.arrayValue.values) && e.arrayValue.values.some((t)=>$5c04988f82cad1b3$var$de(this.value.arrayValue, t));
    }
    constructor(t, e){
        super(t, "array-contains-any" /* ARRAY_CONTAINS_ANY */ , e);
    }
}
/**
 * Represents a bound of a query.
 *
 * The bound is specified with the given components representing a position and
 * whether it's just before or just after the position (relative to whatever the
 * query order is).
 *
 * The position represents a logical index position for a query. It's a prefix
 * of values for the (potentially implicit) order by clauses of a query.
 *
 * Bound provides a function to determine whether a document comes before or
 * after a bound. This is influenced by whether the position is just before or
 * just after the provided values.
 */ class $5c04988f82cad1b3$var$Ye {
    constructor(t, e){
        this.position = t, this.inclusive = e;
    }
}
/**
 * An ordering on a field, in some Direction. Direction defaults to ASCENDING.
 */ class $5c04988f82cad1b3$var$Xe {
    constructor(t, e = "asc" /* ASCENDING */ ){
        this.field = t, this.dir = e;
    }
}
function $5c04988f82cad1b3$var$Ze(t, e) {
    return t.dir === e.dir && t.field.isEqual(e.field);
}
function $5c04988f82cad1b3$var$tn(t, e, n) {
    let s = 0;
    for(let i = 0; i < t.position.length; i++){
        const r = e[i], o = t.position[i];
        if (r.field.isKeyField()) s = $5c04988f82cad1b3$export$afc2e57c475b7810.comparator($5c04988f82cad1b3$export$afc2e57c475b7810.fromName(o.referenceValue), n.key);
        else s = $5c04988f82cad1b3$var$_e(o, n.data.field(r.field));
        if ("desc" /* DESCENDING */  === r.dir && (s *= -1), 0 !== s) break;
    }
    return s;
}
/**
 * Returns true if a document sorts after a bound using the provided sort
 * order.
 */ function $5c04988f82cad1b3$var$en(t, e) {
    if (null === t) return null === e;
    if (null === e) return !1;
    if (t.inclusive !== e.inclusive || t.position.length !== e.position.length) return !1;
    for(let n = 0; n < t.position.length; n++){
        if (!$5c04988f82cad1b3$var$fe(t.position[n], e.position[n])) return !1;
    }
    return !0;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Query encapsulates all the query attributes we support in the SDK. It can
 * be run against the LocalStore, as well as be converted to a `Target` to
 * query the RemoteStore results.
 *
 * Visible for testing.
 */ class $5c04988f82cad1b3$var$nn {
    /**
     * Initializes a Query with a path and optional additional query constraints.
     * Path must currently be empty if this is a collection group query.
     */ constructor(t, e = null, n = [], s = [], i = null, r = "F" /* First */ , o = null, u = null){
        this.path = t, this.collectionGroup = e, this.explicitOrderBy = n, this.filters = s, this.limit = i, this.limitType = r, this.startAt = o, this.endAt = u, this.lt = null, // The corresponding `Target` of this `Query` instance.
        this.ft = null, this.startAt, this.endAt;
    }
}
/** Creates a new Query instance with the options provided. */ function $5c04988f82cad1b3$var$sn(t, e, n, s, i, r, o, u) {
    return new $5c04988f82cad1b3$var$nn(t, e, n, s, i, r, o, u);
}
/** Creates a new Query for a query that matches all documents at `path` */ function $5c04988f82cad1b3$var$rn(t) {
    return new $5c04988f82cad1b3$var$nn(t);
}
/**
 * Helper to convert a collection group query into a collection query at a
 * specific path. This is used when executing collection group queries, since
 * we have to split the query into a set of collection queries at multiple
 * paths.
 */ /**
 * Returns true if this query does not specify any query constraints that
 * could remove results.
 */ function $5c04988f82cad1b3$var$on(t) {
    return 0 === t.filters.length && null === t.limit && null == t.startAt && null == t.endAt && (0 === t.explicitOrderBy.length || 1 === t.explicitOrderBy.length && t.explicitOrderBy[0].field.isKeyField());
}
function $5c04988f82cad1b3$var$un(t) {
    return t.explicitOrderBy.length > 0 ? t.explicitOrderBy[0].field : null;
}
function $5c04988f82cad1b3$var$cn(t) {
    for (const e of t.filters)if (e.ht()) return e.field;
    return null;
}
/**
 * Checks if any of the provided Operators are included in the query and
 * returns the first one that is, or null if none are.
 */ /**
 * Returns whether the query matches a collection group rather than a specific
 * collection.
 */ function $5c04988f82cad1b3$var$an(t) {
    return null !== t.collectionGroup;
}
/**
 * Returns the implicit order by constraint that is used to execute the Query,
 * which can be different from the order by constraints the user provided (e.g.
 * the SDK and backend always orders by `__name__`).
 */ function $5c04988f82cad1b3$var$hn(t) {
    const e = $5c04988f82cad1b3$var$K(t);
    if (null === e.lt) {
        e.lt = [];
        const t = $5c04988f82cad1b3$var$cn(e), n = $5c04988f82cad1b3$var$un(e);
        if (null !== t && null === n) // In order to implicitly add key ordering, we must also add the
        // inequality filter field for it to be a valid query.
        // Note that the default inequality field and key ordering is ascending.
        t.isKeyField() || e.lt.push(new $5c04988f82cad1b3$var$Xe(t)), e.lt.push(new $5c04988f82cad1b3$var$Xe($5c04988f82cad1b3$export$b7871852b967eaf1.keyField(), "asc" /* ASCENDING */ ));
        else {
            let t = !1;
            for (const n of e.explicitOrderBy)e.lt.push(n), n.field.isKeyField() && (t = !0);
            if (!t) {
                // The order of the implicit key ordering always matches the last
                // explicit order by
                const t = e.explicitOrderBy.length > 0 ? e.explicitOrderBy[e.explicitOrderBy.length - 1].dir : "asc" /* ASCENDING */ ;
                e.lt.push(new $5c04988f82cad1b3$var$Xe($5c04988f82cad1b3$export$b7871852b967eaf1.keyField(), t));
            }
        }
    }
    return e.lt;
}
/**
 * Converts this `Query` instance to it's corresponding `Target` representation.
 */ function $5c04988f82cad1b3$var$ln(t) {
    const e = $5c04988f82cad1b3$var$K(t);
    if (!e.ft) {
        if ("F" /* First */  === e.limitType) e.ft = $5c04988f82cad1b3$var$ke(e.path, e.collectionGroup, $5c04988f82cad1b3$var$hn(e), e.filters, e.limit, e.startAt, e.endAt);
        else {
            // Flip the orderBy directions since we want the last results
            const t = [];
            for (const n of $5c04988f82cad1b3$var$hn(e)){
                const e = "desc" /* DESCENDING */  === n.dir ? "asc" /* ASCENDING */  : "desc" /* DESCENDING */ ;
                t.push(new $5c04988f82cad1b3$var$Xe(n.field, e));
            }
            // We need to swap the cursors to match the now-flipped query ordering.
            const n = e.endAt ? new $5c04988f82cad1b3$var$Ye(e.endAt.position, e.endAt.inclusive) : null, s = e.startAt ? new $5c04988f82cad1b3$var$Ye(e.startAt.position, e.startAt.inclusive) : null;
            // Now return as a LimitType.First query.
            e.ft = $5c04988f82cad1b3$var$ke(e.path, e.collectionGroup, t, e.filters, e.limit, n, s);
        }
    }
    return e.ft;
}
function $5c04988f82cad1b3$var$fn(t, e, n) {
    return new $5c04988f82cad1b3$var$nn(t.path, t.collectionGroup, t.explicitOrderBy.slice(), t.filters.slice(), e, n, t.startAt, t.endAt);
}
function $5c04988f82cad1b3$var$dn(t, e) {
    return $5c04988f82cad1b3$var$Fe($5c04988f82cad1b3$var$ln(t), $5c04988f82cad1b3$var$ln(e)) && t.limitType === e.limitType;
}
// TODO(b/29183165): This is used to get a unique string from a query to, for
// example, use as a dictionary key, but the implementation is subject to
// collisions. Make it collision-free.
function $5c04988f82cad1b3$var$_n(t) {
    return `${$5c04988f82cad1b3$var$Oe($5c04988f82cad1b3$var$ln(t))}|lt:${t.limitType}`;
}
function $5c04988f82cad1b3$var$wn(t) {
    return `Query(target=${$5c04988f82cad1b3$var$Me($5c04988f82cad1b3$var$ln(t))}; limitType=${t.limitType})`;
}
/** Returns whether `doc` matches the constraints of `query`. */ function $5c04988f82cad1b3$var$mn(t, e) {
    return e.isFoundDocument() && function(t, e) {
        const n = e.key.path;
        return null !== t.collectionGroup ? e.key.hasCollectionId(t.collectionGroup) && t.path.isPrefixOf(n) : $5c04988f82cad1b3$export$afc2e57c475b7810.isDocumentKey(t.path) ? t.path.isEqual(n) : t.path.isImmediateParentOf(n);
    }(t, e) && function(t, e) {
        for (const n of t.explicitOrderBy)// order by key always matches
        if (!n.field.isKeyField() && null === e.data.field(n.field)) return !1;
        return !0;
    }(t, e) && function(t, e) {
        for (const n of t.filters)if (!n.matches(e)) return !1;
        return !0;
    }(t, e) && function(t, e) {
        if (t.startAt && !/**
 * Returns true if a document sorts before a bound using the provided sort
 * order.
 */ function(t, e, n) {
            const s = $5c04988f82cad1b3$var$tn(t, e, n);
            return t.inclusive ? s <= 0 : s < 0;
        }(t.startAt, $5c04988f82cad1b3$var$hn(t), e)) return !1;
        if (t.endAt && !function(t, e, n) {
            const s = $5c04988f82cad1b3$var$tn(t, e, n);
            return t.inclusive ? s >= 0 : s > 0;
        }(t.endAt, $5c04988f82cad1b3$var$hn(t), e)) return !1;
        return !0;
    }(t, e);
}
function $5c04988f82cad1b3$var$gn(t) {
    return t.collectionGroup || (t.path.length % 2 == 1 ? t.path.lastSegment() : t.path.get(t.path.length - 2));
}
/**
 * Returns a new comparator function that can be used to compare two documents
 * based on the Query's ordering constraint.
 */ function $5c04988f82cad1b3$var$yn(t) {
    return (e, n)=>{
        let s = !1;
        for (const i of $5c04988f82cad1b3$var$hn(t)){
            const t = $5c04988f82cad1b3$var$pn(i, e, n);
            if (0 !== t) return t;
            s = s || i.field.isKeyField();
        }
        return 0;
    };
}
function $5c04988f82cad1b3$var$pn(t, e, n) {
    const s = t.field.isKeyField() ? $5c04988f82cad1b3$export$afc2e57c475b7810.comparator(e.key, n.key) : function(t, e, n) {
        const s = e.data.field(t), i = n.data.field(t);
        return null !== s && null !== i ? $5c04988f82cad1b3$var$_e(s, i) : $5c04988f82cad1b3$var$L();
    }(t.field, e, n);
    switch(t.dir){
        case "asc" /* ASCENDING */ :
            return s;
        case "desc" /* DESCENDING */ :
            return -1 * s;
        default:
            return $5c04988f82cad1b3$var$L();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns an DoubleValue for `value` that is encoded based the serializer's
 * `useProto3Json` setting.
 */ function $5c04988f82cad1b3$var$In(t, e) {
    if (t.dt) {
        if (isNaN(e)) return {
            doubleValue: "NaN"
        };
        if (e === 1 / 0) return {
            doubleValue: "Infinity"
        };
        if (e === -1 / 0) return {
            doubleValue: "-Infinity"
        };
    }
    return {
        doubleValue: $5c04988f82cad1b3$var$ue(e) ? "-0" : e
    };
}
/**
 * Returns an IntegerValue for `value`.
 */ function $5c04988f82cad1b3$var$Tn(t) {
    return {
        integerValue: "" + t
    };
}
/**
 * Returns a value for a number that's appropriate to put into a proto.
 * The return value is an IntegerValue if it can safely represent the value,
 * otherwise a DoubleValue is returned.
 */ function $5c04988f82cad1b3$var$En(t, e) {
    return $5c04988f82cad1b3$var$ce(e) ? $5c04988f82cad1b3$var$Tn(e) : $5c04988f82cad1b3$var$In(t, e);
}
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Used to represent a field transform on a mutation. */ class $5c04988f82cad1b3$var$An {
    constructor(){
        // Make sure that the structural type of `TransformOperation` is unique.
        // See https://github.com/microsoft/TypeScript/issues/5451
        this._ = void 0;
    }
}
/**
 * Computes the local transform result against the provided `previousValue`,
 * optionally using the provided localWriteTime.
 */ function $5c04988f82cad1b3$var$Rn(t, e, n) {
    return t instanceof $5c04988f82cad1b3$var$vn ? function(t, e) {
        const n = {
            fields: {
                __type__: {
                    stringValue: "server_timestamp"
                },
                __local_write_time__: {
                    timestampValue: {
                        seconds: t.seconds,
                        nanos: t.nanoseconds
                    }
                }
            }
        };
        return e && (n.fields.__previous_value__ = e), {
            mapValue: n
        };
    }(n, e) : t instanceof $5c04988f82cad1b3$var$Vn ? $5c04988f82cad1b3$var$Sn(t, e) : t instanceof $5c04988f82cad1b3$var$Dn ? $5c04988f82cad1b3$var$Cn(t, e) : function(t, e) {
        // PORTING NOTE: Since JavaScript's integer arithmetic is limited to 53 bit
        // precision and resolves overflows by reducing precision, we do not
        // manually cap overflows at 2^63.
        const n = $5c04988f82cad1b3$var$Pn(t, e), s = $5c04988f82cad1b3$var$Nn(n) + $5c04988f82cad1b3$var$Nn(t._t);
        return $5c04988f82cad1b3$var$pe(n) && $5c04988f82cad1b3$var$pe(t._t) ? $5c04988f82cad1b3$var$Tn(s) : $5c04988f82cad1b3$var$In(t.wt, s);
    }(t, e);
}
/**
 * Computes a final transform result after the transform has been acknowledged
 * by the server, potentially using the server-provided transformResult.
 */ function $5c04988f82cad1b3$var$bn(t, e, n) {
    // The server just sends null as the transform result for array operations,
    // so we have to calculate a result the same as we do for local
    // applications.
    return t instanceof $5c04988f82cad1b3$var$Vn ? $5c04988f82cad1b3$var$Sn(t, e) : t instanceof $5c04988f82cad1b3$var$Dn ? $5c04988f82cad1b3$var$Cn(t, e) : n;
}
/**
 * If this transform operation is not idempotent, returns the base value to
 * persist for this transform. If a base value is returned, the transform
 * operation is always applied to this base value, even if document has
 * already been updated.
 *
 * Base values provide consistent behavior for non-idempotent transforms and
 * allow us to return the same latency-compensated value even if the backend
 * has already applied the transform operation. The base value is null for
 * idempotent transforms, as they can be re-played even if the backend has
 * already applied them.
 *
 * @returns a base value to store along with the mutation, or null for
 * idempotent transforms.
 */ function $5c04988f82cad1b3$var$Pn(t, e) {
    var n;
    return t instanceof $5c04988f82cad1b3$var$xn ? $5c04988f82cad1b3$var$pe(n = e) || function(t) {
        return !!t && "doubleValue" in t;
    }(n) ? e : {
        integerValue: 0
    } : null;
}
/** Transforms a value into a server-generated timestamp. */ class $5c04988f82cad1b3$var$vn extends $5c04988f82cad1b3$var$An {
}
/** Transforms an array value via a union operation. */ class $5c04988f82cad1b3$var$Vn extends $5c04988f82cad1b3$var$An {
    constructor(t){
        super(), this.elements = t;
    }
}
function $5c04988f82cad1b3$var$Sn(t, e) {
    const n = $5c04988f82cad1b3$var$kn(e);
    for (const e of t.elements)n.some((t)=>$5c04988f82cad1b3$var$fe(t, e)) || n.push(e);
    return {
        arrayValue: {
            values: n
        }
    };
}
/** Transforms an array value via a remove operation. */ class $5c04988f82cad1b3$var$Dn extends $5c04988f82cad1b3$var$An {
    constructor(t){
        super(), this.elements = t;
    }
}
function $5c04988f82cad1b3$var$Cn(t, e) {
    let n = $5c04988f82cad1b3$var$kn(e);
    for (const e of t.elements)n = n.filter((t)=>!$5c04988f82cad1b3$var$fe(t, e));
    return {
        arrayValue: {
            values: n
        }
    };
}
/**
 * Implements the backend semantics for locally computed NUMERIC_ADD (increment)
 * transforms. Converts all field values to integers or doubles, but unlike the
 * backend does not cap integer values at 2^63. Instead, JavaScript number
 * arithmetic is used and precision loss can occur for values greater than 2^53.
 */ class $5c04988f82cad1b3$var$xn extends $5c04988f82cad1b3$var$An {
    constructor(t, e){
        super(), this.wt = t, this._t = e;
    }
}
function $5c04988f82cad1b3$var$Nn(t) {
    return $5c04988f82cad1b3$var$Zt(t.integerValue || t.doubleValue);
}
function $5c04988f82cad1b3$var$kn(t) {
    return $5c04988f82cad1b3$var$Ie(t) && t.arrayValue.values ? t.arrayValue.values.slice() : [];
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** A field path and the TransformOperation to perform upon it. */ class $5c04988f82cad1b3$var$On {
    constructor(t, e){
        this.field = t, this.transform = e;
    }
}
function $5c04988f82cad1b3$var$Mn(t, e) {
    return t.field.isEqual(e.field) && function(t, e) {
        return t instanceof $5c04988f82cad1b3$var$Vn && e instanceof $5c04988f82cad1b3$var$Vn || t instanceof $5c04988f82cad1b3$var$Dn && e instanceof $5c04988f82cad1b3$var$Dn ? $5c04988f82cad1b3$var$rt(t.elements, e.elements, $5c04988f82cad1b3$var$fe) : t instanceof $5c04988f82cad1b3$var$xn && e instanceof $5c04988f82cad1b3$var$xn ? $5c04988f82cad1b3$var$fe(t._t, e._t) : t instanceof $5c04988f82cad1b3$var$vn && e instanceof $5c04988f82cad1b3$var$vn;
    }(t.transform, e.transform);
}
/** The result of successfully applying a mutation to the backend. */ class $5c04988f82cad1b3$var$Fn {
    constructor(/**
     * The version at which the mutation was committed:
     *
     * - For most operations, this is the updateTime in the WriteResult.
     * - For deletes, the commitTime of the WriteResponse (because deletes are
     *   not stored and have no updateTime).
     *
     * Note that these versions can be different: No-op writes will not change
     * the updateTime even though the commitTime advances.
     */ t, /**
     * The resulting fields returned from the backend after a mutation
     * containing field transforms has been committed. Contains one FieldValue
     * for each FieldTransform that was in the mutation.
     *
     * Will be empty if the mutation did not contain any field transforms.
     */ e){
        this.version = t, this.transformResults = e;
    }
}
/**
 * Encodes a precondition for a mutation. This follows the model that the
 * backend accepts with the special case of an explicit "empty" precondition
 * (meaning no precondition).
 */ class $5c04988f82cad1b3$var$$n {
    /** Creates a new empty Precondition. */ static none() {
        return new $5c04988f82cad1b3$var$$n;
    }
    /** Creates a new Precondition with an exists flag. */ static exists(t) {
        return new $5c04988f82cad1b3$var$$n(void 0, t);
    }
    /** Creates a new Precondition based on a version a document exists at. */ static updateTime(t) {
        return new $5c04988f82cad1b3$var$$n(t);
    }
    /** Returns whether this Precondition is empty. */ get isNone() {
        return void 0 === this.updateTime && void 0 === this.exists;
    }
    isEqual(t) {
        return this.exists === t.exists && (this.updateTime ? !!t.updateTime && this.updateTime.isEqual(t.updateTime) : !t.updateTime);
    }
    constructor(t, e){
        this.updateTime = t, this.exists = e;
    }
}
/** Returns true if the preconditions is valid for the given document. */ function $5c04988f82cad1b3$var$Bn(t, e) {
    return void 0 !== t.updateTime ? e.isFoundDocument() && e.version.isEqual(t.updateTime) : void 0 === t.exists || t.exists === e.isFoundDocument();
}
/**
 * A mutation describes a self-contained change to a document. Mutations can
 * create, replace, delete, and update subsets of documents.
 *
 * Mutations not only act on the value of the document but also its version.
 *
 * For local mutations (mutations that haven't been committed yet), we preserve
 * the existing version for Set and Patch mutations. For Delete mutations, we
 * reset the version to 0.
 *
 * Here's the expected transition table.
 *
 * MUTATION           APPLIED TO            RESULTS IN
 *
 * SetMutation        Document(v3)          Document(v3)
 * SetMutation        NoDocument(v3)        Document(v0)
 * SetMutation        InvalidDocument(v0)   Document(v0)
 * PatchMutation      Document(v3)          Document(v3)
 * PatchMutation      NoDocument(v3)        NoDocument(v3)
 * PatchMutation      InvalidDocument(v0)   UnknownDocument(v3)
 * DeleteMutation     Document(v3)          NoDocument(v0)
 * DeleteMutation     NoDocument(v3)        NoDocument(v0)
 * DeleteMutation     InvalidDocument(v0)   NoDocument(v0)
 *
 * For acknowledged mutations, we use the updateTime of the WriteResponse as
 * the resulting version for Set and Patch mutations. As deletes have no
 * explicit update time, we use the commitTime of the WriteResponse for
 * Delete mutations.
 *
 * If a mutation is acknowledged by the backend but fails the precondition check
 * locally, we transition to an `UnknownDocument` and rely on Watch to send us
 * the updated version.
 *
 * Field transforms are used only with Patch and Set Mutations. We use the
 * `updateTransforms` message to store transforms, rather than the `transforms`s
 * messages.
 *
 * ## Subclassing Notes
 *
 * Every type of mutation needs to implement its own applyToRemoteDocument() and
 * applyToLocalView() to implement the actual behavior of applying the mutation
 * to some source document (see `setMutationApplyToRemoteDocument()` for an
 * example).
 */ class $5c04988f82cad1b3$var$Ln {
}
/**
 * A utility method to calculate a `Mutation` representing the overlay from the
 * final state of the document, and a `FieldMask` representing the fields that
 * are mutated by the local mutations.
 */ function $5c04988f82cad1b3$var$Un(t, e) {
    if (!t.hasLocalMutations || e && 0 === e.fields.length) return null;
    // mask is null when sets or deletes are applied to the current document.
    if (null === e) return t.isNoDocument() ? new $5c04988f82cad1b3$var$Yn(t.key, $5c04988f82cad1b3$var$$n.none()) : new $5c04988f82cad1b3$var$jn(t.key, t.data, $5c04988f82cad1b3$var$$n.none());
    {
        const n = t.data, s = $5c04988f82cad1b3$var$De.empty();
        let i = new $5c04988f82cad1b3$var$Qt($5c04988f82cad1b3$export$b7871852b967eaf1.comparator);
        for (let t of e.fields)if (!i.has(t)) {
            let e = n.field(t);
            // If we are deleting a nested field, we take the immediate parent as
            // the mask used to construct the resulting mutation.
            // Justification: Nested fields can create parent fields implicitly. If
            // only a leaf entry is deleted in later mutations, the parent field
            // should still remain, but we may have lost this information.
            // Consider mutation (foo.bar 1), then mutation (foo.bar delete()).
            // This leaves the final result (foo, {}). Despite the fact that `doc`
            // has the correct result, `foo` is not in `mask`, and the resulting
            // mutation would miss `foo`.
            null === e && t.length > 1 && (t = t.popLast(), e = n.field(t)), null === e ? s.delete(t) : s.set(t, e), i = i.add(t);
        }
        return new $5c04988f82cad1b3$var$Wn(t.key, s, new $5c04988f82cad1b3$var$zt(i.toArray()), $5c04988f82cad1b3$var$$n.none());
    }
}
/**
 * Applies this mutation to the given document for the purposes of computing a
 * new remote document. If the input document doesn't match the expected state
 * (e.g. it is invalid or outdated), the document type may transition to
 * unknown.
 *
 * @param mutation - The mutation to apply.
 * @param document - The document to mutate. The input document can be an
 *     invalid document if the client has no knowledge of the pre-mutation state
 *     of the document.
 * @param mutationResult - The result of applying the mutation from the backend.
 */ function $5c04988f82cad1b3$var$qn(t, e, n) {
    t instanceof $5c04988f82cad1b3$var$jn ? function(t, e, n) {
        // Unlike setMutationApplyToLocalView, if we're applying a mutation to a
        // remote document the server has accepted the mutation so the precondition
        // must have held.
        const s = t.value.clone(), i = $5c04988f82cad1b3$var$Hn(t.fieldTransforms, e, n.transformResults);
        s.setAll(i), e.convertToFoundDocument(n.version, s).setHasCommittedMutations();
    }(t, e, n) : t instanceof $5c04988f82cad1b3$var$Wn ? function(t, e, n) {
        if (!$5c04988f82cad1b3$var$Bn(t.precondition, e)) // Since the mutation was not rejected, we know that the precondition
        // matched on the backend. We therefore must not have the expected version
        // of the document in our cache and convert to an UnknownDocument with a
        // known updateTime.
        return void e.convertToUnknownDocument(n.version);
        const s = $5c04988f82cad1b3$var$Hn(t.fieldTransforms, e, n.transformResults), i = e.data;
        i.setAll($5c04988f82cad1b3$var$zn(t)), i.setAll(s), e.convertToFoundDocument(n.version, i).setHasCommittedMutations();
    }(t, e, n) : function(t, e, n) {
        // Unlike applyToLocalView, if we're applying a mutation to a remote
        // document the server has accepted the mutation so the precondition must
        // have held.
        e.convertToNoDocument(n.version).setHasCommittedMutations();
    }(0, e, n);
}
/**
 * Applies this mutation to the given document for the purposes of computing
 * the new local view of a document. If the input document doesn't match the
 * expected state, the document is not modified.
 *
 * @param mutation - The mutation to apply.
 * @param document - The document to mutate. The input document can be an
 *     invalid document if the client has no knowledge of the pre-mutation state
 *     of the document.
 * @param previousMask - The fields that have been updated before applying this mutation.
 * @param localWriteTime - A timestamp indicating the local write time of the
 *     batch this mutation is a part of.
 * @returns A `FieldMask` representing the fields that are changed by applying this mutation.
 */ function $5c04988f82cad1b3$var$Kn(t, e, n, s) {
    return t instanceof $5c04988f82cad1b3$var$jn ? function(t, e, n, s) {
        if (!$5c04988f82cad1b3$var$Bn(t.precondition, e)) // The mutation failed to apply (e.g. a document ID created with add()
        // caused a name collision).
        return n;
        const i = t.value.clone(), r = $5c04988f82cad1b3$var$Jn(t.fieldTransforms, s, e);
        return i.setAll(r), e.convertToFoundDocument(e.version, i).setHasLocalMutations(), null;
    // SetMutation overwrites all fields.
    }(t, e, n, s) : t instanceof $5c04988f82cad1b3$var$Wn ? function(t, e, n, s) {
        if (!$5c04988f82cad1b3$var$Bn(t.precondition, e)) return n;
        const i = $5c04988f82cad1b3$var$Jn(t.fieldTransforms, s, e), r = e.data;
        if (r.setAll($5c04988f82cad1b3$var$zn(t)), r.setAll(i), e.convertToFoundDocument(e.version, r).setHasLocalMutations(), null === n) return null;
        return n.unionWith(t.fieldMask.fields).unionWith(t.fieldTransforms.map((t)=>t.field));
    }(t, e, n, s) : function(t, e, n) {
        if ($5c04988f82cad1b3$var$Bn(t.precondition, e)) return e.convertToNoDocument(e.version).setHasLocalMutations(), null;
        return n;
    }(t, e, n);
}
/**
 * If this mutation is not idempotent, returns the base value to persist with
 * this mutation. If a base value is returned, the mutation is always applied
 * to this base value, even if document has already been updated.
 *
 * The base value is a sparse object that consists of only the document
 * fields for which this mutation contains a non-idempotent transformation
 * (e.g. a numeric increment). The provided value guarantees consistent
 * behavior for non-idempotent transforms and allow us to return the same
 * latency-compensated value even if the backend has already applied the
 * mutation. The base value is null for idempotent mutations, as they can be
 * re-played even if the backend has already applied them.
 *
 * @returns a base value to store along with the mutation, or null for
 * idempotent mutations.
 */ function $5c04988f82cad1b3$var$Gn(t, e) {
    let n = null;
    for (const s of t.fieldTransforms){
        const t = e.data.field(s.field), i = $5c04988f82cad1b3$var$Pn(s.transform, t || null);
        null != i && (null === n && (n = $5c04988f82cad1b3$var$De.empty()), n.set(s.field, i));
    }
    return n || null;
}
function $5c04988f82cad1b3$var$Qn(t, e) {
    return t.type === e.type && !!t.key.isEqual(e.key) && !!t.precondition.isEqual(e.precondition) && !!function(t, e) {
        return void 0 === t && void 0 === e || !(!t || !e) && $5c04988f82cad1b3$var$rt(t, e, (t, e)=>$5c04988f82cad1b3$var$Mn(t, e));
    }(t.fieldTransforms, e.fieldTransforms) && (0 /* Set */  === t.type ? t.value.isEqual(e.value) : 1 /* Patch */  !== t.type || t.data.isEqual(e.data) && t.fieldMask.isEqual(e.fieldMask));
}
/**
 * A mutation that creates or replaces the document at the given key with the
 * object value contents.
 */ class $5c04988f82cad1b3$var$jn extends $5c04988f82cad1b3$var$Ln {
    getFieldMask() {
        return null;
    }
    constructor(t, e, n, s = []){
        super(), this.key = t, this.value = e, this.precondition = n, this.fieldTransforms = s, this.type = 0 /* Set */ ;
    }
}
class $5c04988f82cad1b3$var$Wn extends $5c04988f82cad1b3$var$Ln {
    getFieldMask() {
        return this.fieldMask;
    }
    constructor(t, e, n, s, i = []){
        super(), this.key = t, this.data = e, this.fieldMask = n, this.precondition = s, this.fieldTransforms = i, this.type = 1 /* Patch */ ;
    }
}
function $5c04988f82cad1b3$var$zn(t) {
    const e = new Map;
    return t.fieldMask.fields.forEach((n)=>{
        if (!n.isEmpty()) {
            const s = t.data.field(n);
            e.set(n, s);
        }
    }), e;
}
/**
 * Creates a list of "transform results" (a transform result is a field value
 * representing the result of applying a transform) for use after a mutation
 * containing transforms has been acknowledged by the server.
 *
 * @param fieldTransforms - The field transforms to apply the result to.
 * @param mutableDocument - The current state of the document after applying all
 * previous mutations.
 * @param serverTransformResults - The transform results received by the server.
 * @returns The transform results list.
 */ function $5c04988f82cad1b3$var$Hn(t, e, n) {
    const s = new Map;
    $5c04988f82cad1b3$var$U(t.length === n.length);
    for(let i = 0; i < n.length; i++){
        const r = t[i], o = r.transform, u = e.data.field(r.field);
        s.set(r.field, $5c04988f82cad1b3$var$bn(o, u, n[i]));
    }
    return s;
}
/**
 * Creates a list of "transform results" (a transform result is a field value
 * representing the result of applying a transform) for use when applying a
 * transform locally.
 *
 * @param fieldTransforms - The field transforms to apply the result to.
 * @param localWriteTime - The local time of the mutation (used to
 *     generate ServerTimestampValues).
 * @param mutableDocument - The document to apply transforms on.
 * @returns The transform results list.
 */ function $5c04988f82cad1b3$var$Jn(t, e, n) {
    const s = new Map;
    for (const i of t){
        const t = i.transform, r = n.data.field(i.field);
        s.set(i.field, $5c04988f82cad1b3$var$Rn(t, r, e));
    }
    return s;
}
/** A mutation that deletes the document at the given key. */ class $5c04988f82cad1b3$var$Yn extends $5c04988f82cad1b3$var$Ln {
    getFieldMask() {
        return null;
    }
    constructor(t, e){
        super(), this.key = t, this.precondition = e, this.type = 2 /* Delete */ , this.fieldTransforms = [];
    }
}
class $5c04988f82cad1b3$var$Xn extends $5c04988f82cad1b3$var$Ln {
    getFieldMask() {
        return null;
    }
    constructor(t, e){
        super(), this.key = t, this.precondition = e, this.type = 3 /* Verify */ , this.fieldTransforms = [];
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $5c04988f82cad1b3$var$Zn {
    // TODO(b/33078163): just use simplest form of existence filter for now
    constructor(t){
        this.count = t;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Error Codes describing the different ways GRPC can fail. These are copied
 * directly from GRPC's sources here:
 *
 * https://github.com/grpc/grpc/blob/bceec94ea4fc5f0085d81235d8e1c06798dc341a/include/grpc%2B%2B/impl/codegen/status_code_enum.h
 *
 * Important! The names of these identifiers matter because the string forms
 * are used for reverse lookups from the webchannel stream. Do NOT change the
 * names of these identifiers or change this into a const enum.
 */ var $5c04988f82cad1b3$var$ts, $5c04988f82cad1b3$var$es;
/**
 * Determines whether an error code represents a permanent error when received
 * in response to a non-write operation.
 *
 * See isPermanentWriteError for classifying write errors.
 */ function $5c04988f82cad1b3$var$ns(t) {
    switch(t){
        default:
            return $5c04988f82cad1b3$var$L();
        case $5c04988f82cad1b3$var$G.CANCELLED:
        case $5c04988f82cad1b3$var$G.UNKNOWN:
        case $5c04988f82cad1b3$var$G.DEADLINE_EXCEEDED:
        case $5c04988f82cad1b3$var$G.RESOURCE_EXHAUSTED:
        case $5c04988f82cad1b3$var$G.INTERNAL:
        case $5c04988f82cad1b3$var$G.UNAVAILABLE:
        // Unauthenticated means something went wrong with our token and we need
        // to retry with new credentials which will happen automatically.
        case $5c04988f82cad1b3$var$G.UNAUTHENTICATED:
            return !1;
        case $5c04988f82cad1b3$var$G.INVALID_ARGUMENT:
        case $5c04988f82cad1b3$var$G.NOT_FOUND:
        case $5c04988f82cad1b3$var$G.ALREADY_EXISTS:
        case $5c04988f82cad1b3$var$G.PERMISSION_DENIED:
        case $5c04988f82cad1b3$var$G.FAILED_PRECONDITION:
        // Aborted might be retried in some scenarios, but that is dependant on
        // the context and should handled individually by the calling code.
        // See https://cloud.google.com/apis/design/errors.
        case $5c04988f82cad1b3$var$G.ABORTED:
        case $5c04988f82cad1b3$var$G.OUT_OF_RANGE:
        case $5c04988f82cad1b3$var$G.UNIMPLEMENTED:
        case $5c04988f82cad1b3$var$G.DATA_LOSS:
            return !0;
    }
}
/**
 * Determines whether an error code represents a permanent error when received
 * in response to a write operation.
 *
 * Write operations must be handled specially because as of b/119437764, ABORTED
 * errors on the write stream should be retried too (even though ABORTED errors
 * are not generally retryable).
 *
 * Note that during the initial handshake on the write stream an ABORTED error
 * signals that we should discard our stream token (i.e. it is permanent). This
 * means a handshake error should be classified with isPermanentError, above.
 */ /**
 * Maps an error Code from GRPC status code number, like 0, 1, or 14. These
 * are not the same as HTTP status codes.
 *
 * @returns The Code equivalent to the given GRPC status code. Fails if there
 *     is no match.
 */ function $5c04988f82cad1b3$var$ss(t) {
    if (void 0 === t) // This shouldn't normally happen, but in certain error cases (like trying
    // to send invalid proto messages) we may get an error with no GRPC code.
    return $5c04988f82cad1b3$var$F("GRPC error has no .code"), $5c04988f82cad1b3$var$G.UNKNOWN;
    switch(t){
        case $5c04988f82cad1b3$var$ts.OK:
            return $5c04988f82cad1b3$var$G.OK;
        case $5c04988f82cad1b3$var$ts.CANCELLED:
            return $5c04988f82cad1b3$var$G.CANCELLED;
        case $5c04988f82cad1b3$var$ts.UNKNOWN:
            return $5c04988f82cad1b3$var$G.UNKNOWN;
        case $5c04988f82cad1b3$var$ts.DEADLINE_EXCEEDED:
            return $5c04988f82cad1b3$var$G.DEADLINE_EXCEEDED;
        case $5c04988f82cad1b3$var$ts.RESOURCE_EXHAUSTED:
            return $5c04988f82cad1b3$var$G.RESOURCE_EXHAUSTED;
        case $5c04988f82cad1b3$var$ts.INTERNAL:
            return $5c04988f82cad1b3$var$G.INTERNAL;
        case $5c04988f82cad1b3$var$ts.UNAVAILABLE:
            return $5c04988f82cad1b3$var$G.UNAVAILABLE;
        case $5c04988f82cad1b3$var$ts.UNAUTHENTICATED:
            return $5c04988f82cad1b3$var$G.UNAUTHENTICATED;
        case $5c04988f82cad1b3$var$ts.INVALID_ARGUMENT:
            return $5c04988f82cad1b3$var$G.INVALID_ARGUMENT;
        case $5c04988f82cad1b3$var$ts.NOT_FOUND:
            return $5c04988f82cad1b3$var$G.NOT_FOUND;
        case $5c04988f82cad1b3$var$ts.ALREADY_EXISTS:
            return $5c04988f82cad1b3$var$G.ALREADY_EXISTS;
        case $5c04988f82cad1b3$var$ts.PERMISSION_DENIED:
            return $5c04988f82cad1b3$var$G.PERMISSION_DENIED;
        case $5c04988f82cad1b3$var$ts.FAILED_PRECONDITION:
            return $5c04988f82cad1b3$var$G.FAILED_PRECONDITION;
        case $5c04988f82cad1b3$var$ts.ABORTED:
            return $5c04988f82cad1b3$var$G.ABORTED;
        case $5c04988f82cad1b3$var$ts.OUT_OF_RANGE:
            return $5c04988f82cad1b3$var$G.OUT_OF_RANGE;
        case $5c04988f82cad1b3$var$ts.UNIMPLEMENTED:
            return $5c04988f82cad1b3$var$G.UNIMPLEMENTED;
        case $5c04988f82cad1b3$var$ts.DATA_LOSS:
            return $5c04988f82cad1b3$var$G.DATA_LOSS;
        default:
            return $5c04988f82cad1b3$var$L();
    }
}
/**
 * Converts an HTTP response's error status to the equivalent error code.
 *
 * @param status - An HTTP error response status ("FAILED_PRECONDITION",
 * "UNKNOWN", etc.)
 * @returns The equivalent Code. Non-matching responses are mapped to
 *     Code.UNKNOWN.
 */ ($5c04988f82cad1b3$var$es = $5c04988f82cad1b3$var$ts || ($5c04988f82cad1b3$var$ts = {}))[$5c04988f82cad1b3$var$es.OK = 0] = "OK", $5c04988f82cad1b3$var$es[$5c04988f82cad1b3$var$es.CANCELLED = 1] = "CANCELLED", $5c04988f82cad1b3$var$es[$5c04988f82cad1b3$var$es.UNKNOWN = 2] = "UNKNOWN", $5c04988f82cad1b3$var$es[$5c04988f82cad1b3$var$es.INVALID_ARGUMENT = 3] = "INVALID_ARGUMENT", $5c04988f82cad1b3$var$es[$5c04988f82cad1b3$var$es.DEADLINE_EXCEEDED = 4] = "DEADLINE_EXCEEDED", $5c04988f82cad1b3$var$es[$5c04988f82cad1b3$var$es.NOT_FOUND = 5] = "NOT_FOUND", $5c04988f82cad1b3$var$es[$5c04988f82cad1b3$var$es.ALREADY_EXISTS = 6] = "ALREADY_EXISTS", $5c04988f82cad1b3$var$es[$5c04988f82cad1b3$var$es.PERMISSION_DENIED = 7] = "PERMISSION_DENIED", $5c04988f82cad1b3$var$es[$5c04988f82cad1b3$var$es.UNAUTHENTICATED = 16] = "UNAUTHENTICATED", $5c04988f82cad1b3$var$es[$5c04988f82cad1b3$var$es.RESOURCE_EXHAUSTED = 8] = "RESOURCE_EXHAUSTED", $5c04988f82cad1b3$var$es[$5c04988f82cad1b3$var$es.FAILED_PRECONDITION = 9] = "FAILED_PRECONDITION", $5c04988f82cad1b3$var$es[$5c04988f82cad1b3$var$es.ABORTED = 10] = "ABORTED", $5c04988f82cad1b3$var$es[$5c04988f82cad1b3$var$es.OUT_OF_RANGE = 11] = "OUT_OF_RANGE", $5c04988f82cad1b3$var$es[$5c04988f82cad1b3$var$es.UNIMPLEMENTED = 12] = "UNIMPLEMENTED", $5c04988f82cad1b3$var$es[$5c04988f82cad1b3$var$es.INTERNAL = 13] = "INTERNAL", $5c04988f82cad1b3$var$es[$5c04988f82cad1b3$var$es.UNAVAILABLE = 14] = "UNAVAILABLE", $5c04988f82cad1b3$var$es[$5c04988f82cad1b3$var$es.DATA_LOSS = 15] = "DATA_LOSS";
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A map implementation that uses objects as keys. Objects must have an
 * associated equals function and must be immutable. Entries in the map are
 * stored together with the key being produced from the mapKeyFn. This map
 * automatically handles collisions of keys.
 */ class $5c04988f82cad1b3$var$is {
    /** Get a value for this key, or undefined if it does not exist. */ get(t) {
        const e = this.mapKeyFn(t), n = this.inner[e];
        if (void 0 !== n) {
            for (const [e, s] of n)if (this.equalsFn(e, t)) return s;
        }
    }
    has(t) {
        return void 0 !== this.get(t);
    }
    /** Put this key and value in the map. */ set(t, e) {
        const n = this.mapKeyFn(t), s = this.inner[n];
        if (void 0 === s) return this.inner[n] = [
            [
                t,
                e
            ]
        ], void this.innerSize++;
        for(let n = 0; n < s.length; n++)if (this.equalsFn(s[n][0], t)) // This is updating an existing entry and does not increase `innerSize`.
        return void (s[n] = [
            t,
            e
        ]);
        s.push([
            t,
            e
        ]), this.innerSize++;
    }
    /**
     * Remove this key from the map. Returns a boolean if anything was deleted.
     */ delete(t) {
        const e = this.mapKeyFn(t), n = this.inner[e];
        if (void 0 === n) return !1;
        for(let s = 0; s < n.length; s++)if (this.equalsFn(n[s][0], t)) return 1 === n.length ? delete this.inner[e] : n.splice(s, 1), this.innerSize--, !0;
        return !1;
    }
    forEach(t) {
        $5c04988f82cad1b3$var$Lt(this.inner, (e, n)=>{
            for (const [e, s] of n)t(e, s);
        });
    }
    isEmpty() {
        return $5c04988f82cad1b3$var$Ut(this.inner);
    }
    size() {
        return this.innerSize;
    }
    constructor(t, e){
        this.mapKeyFn = t, this.equalsFn = e, /**
         * The inner map for a key/value pair. Due to the possibility of collisions we
         * keep a list of entries that we do a linear search through to find an actual
         * match. Note that collisions should be rare, so we still expect near
         * constant time lookups in practice.
         */ this.inner = {}, /** The number of entries stored in the map */ this.innerSize = 0;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $5c04988f82cad1b3$var$rs = new $5c04988f82cad1b3$var$qt($5c04988f82cad1b3$export$afc2e57c475b7810.comparator);
function $5c04988f82cad1b3$var$os() {
    return $5c04988f82cad1b3$var$rs;
}
const $5c04988f82cad1b3$var$us = new $5c04988f82cad1b3$var$qt($5c04988f82cad1b3$export$afc2e57c475b7810.comparator);
function $5c04988f82cad1b3$var$cs(...t) {
    let e = $5c04988f82cad1b3$var$us;
    for (const n of t)e = e.insert(n.key, n);
    return e;
}
function $5c04988f82cad1b3$var$as(t) {
    let e = $5c04988f82cad1b3$var$us;
    return t.forEach((t, n)=>e = e.insert(t, n.overlayedDocument)), e;
}
function $5c04988f82cad1b3$var$hs() {
    return $5c04988f82cad1b3$var$fs();
}
function $5c04988f82cad1b3$var$ls() {
    return $5c04988f82cad1b3$var$fs();
}
function $5c04988f82cad1b3$var$fs() {
    return new $5c04988f82cad1b3$var$is((t)=>t.toString(), (t, e)=>t.isEqual(e));
}
const $5c04988f82cad1b3$var$ds = new $5c04988f82cad1b3$var$qt($5c04988f82cad1b3$export$afc2e57c475b7810.comparator);
const $5c04988f82cad1b3$var$_s = new $5c04988f82cad1b3$var$Qt($5c04988f82cad1b3$export$afc2e57c475b7810.comparator);
function $5c04988f82cad1b3$var$ws(...t) {
    let e = $5c04988f82cad1b3$var$_s;
    for (const n of t)e = e.add(n);
    return e;
}
const $5c04988f82cad1b3$var$ms = new $5c04988f82cad1b3$var$Qt($5c04988f82cad1b3$var$it);
function $5c04988f82cad1b3$var$gs() {
    return $5c04988f82cad1b3$var$ms;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An event from the RemoteStore. It is split into targetChanges (changes to the
 * state or the set of documents in our watched targets) and documentUpdates
 * (changes to the actual documents).
 */ class $5c04988f82cad1b3$var$ys {
    /**
     * HACK: Views require RemoteEvents in order to determine whether the view is
     * CURRENT, but secondary tabs don't receive remote events. So this method is
     * used to create a synthesized RemoteEvent that can be used to apply a
     * CURRENT status change to a View, for queries executed in a different tab.
     */ // PORTING NOTE: Multi-tab only
    static createSynthesizedRemoteEventForCurrentChange(t, e) {
        const n = new Map;
        return n.set(t, $5c04988f82cad1b3$var$ps.createSynthesizedTargetChangeForCurrentChange(t, e)), new $5c04988f82cad1b3$var$ys($5c04988f82cad1b3$var$ct.min(), n, $5c04988f82cad1b3$var$gs(), $5c04988f82cad1b3$var$os(), $5c04988f82cad1b3$var$ws());
    }
    constructor(/**
     * The snapshot version this event brings us up to, or MIN if not set.
     */ t, /**
     * A map from target to changes to the target. See TargetChange.
     */ e, /**
     * A set of targets that is known to be inconsistent. Listens for these
     * targets should be re-established without resume tokens.
     */ n, /**
     * A set of which documents have changed or been deleted, along with the
     * doc's new values (if not deleted).
     */ s, /**
     * A set of which document updates are due only to limbo resolution targets.
     */ i){
        this.snapshotVersion = t, this.targetChanges = e, this.targetMismatches = n, this.documentUpdates = s, this.resolvedLimboDocuments = i;
    }
}
/**
 * A TargetChange specifies the set of changes for a specific target as part of
 * a RemoteEvent. These changes track which documents are added, modified or
 * removed, as well as the target's resume token and whether the target is
 * marked CURRENT.
 * The actual changes *to* documents are not part of the TargetChange since
 * documents may be part of multiple targets.
 */ class $5c04988f82cad1b3$var$ps {
    /**
     * This method is used to create a synthesized TargetChanges that can be used to
     * apply a CURRENT status change to a View (for queries executed in a different
     * tab) or for new queries (to raise snapshots with correct CURRENT status).
     */ static createSynthesizedTargetChangeForCurrentChange(t, e) {
        return new $5c04988f82cad1b3$var$ps($5c04988f82cad1b3$var$Jt.EMPTY_BYTE_STRING, e, $5c04988f82cad1b3$var$ws(), $5c04988f82cad1b3$var$ws(), $5c04988f82cad1b3$var$ws());
    }
    constructor(/**
     * An opaque, server-assigned token that allows watching a query to be resumed
     * after disconnecting without retransmitting all the data that matches the
     * query. The resume token essentially identifies a point in time from which
     * the server should resume sending results.
     */ t, /**
     * The "current" (synced) status of this target. Note that "current"
     * has special meaning in the RPC protocol that implies that a target is
     * both up-to-date and consistent with the rest of the watch stream.
     */ e, /**
     * The set of documents that were newly assigned to this target as part of
     * this remote event.
     */ n, /**
     * The set of documents that were already assigned to this target but received
     * an update during this remote event.
     */ s, /**
     * The set of documents that were removed from this target as part of this
     * remote event.
     */ i){
        this.resumeToken = t, this.current = e, this.addedDocuments = n, this.modifiedDocuments = s, this.removedDocuments = i;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a changed document and a list of target ids to which this change
 * applies.
 *
 * If document has been deleted NoDocument will be provided.
 */ class $5c04988f82cad1b3$var$Is {
    constructor(/** The new document applies to all of these targets. */ t, /** The new document is removed from all of these targets. */ e, /** The key of the document for this change. */ n, /**
     * The new document or NoDocument if it was deleted. Is null if the
     * document went out of view without the server sending a new document.
     */ s){
        this.gt = t, this.removedTargetIds = e, this.key = n, this.yt = s;
    }
}
class $5c04988f82cad1b3$var$Ts {
    constructor(t, e){
        this.targetId = t, this.It = e;
    }
}
class $5c04988f82cad1b3$var$Es {
    constructor(/** What kind of change occurred to the watch target. */ t, /** The target IDs that were added/removed/set. */ e, /**
     * An opaque, server-assigned token that allows watching a target to be
     * resumed after disconnecting without retransmitting all the data that
     * matches the target. The resume token essentially identifies a point in
     * time from which the server should resume sending results.
     */ n = $5c04988f82cad1b3$var$Jt.EMPTY_BYTE_STRING, s = null){
        this.state = t, this.targetIds = e, this.resumeToken = n, this.cause = s;
    }
}
/** Tracks the internal state of a Watch target. */ class $5c04988f82cad1b3$var$As {
    /**
     * Whether this target has been marked 'current'.
     *
     * 'Current' has special meaning in the RPC protocol: It implies that the
     * Watch backend has sent us all changes up to the point at which the target
     * was added and that the target is consistent with the rest of the watch
     * stream.
     */ get current() {
        return this.Rt;
    }
    /** The last resume token sent to us for this target. */ get resumeToken() {
        return this.At;
    }
    /** Whether this target has pending target adds or target removes. */ get Pt() {
        return 0 !== this.Tt;
    }
    /** Whether we have modified any state that should trigger a snapshot. */ get vt() {
        return this.bt;
    }
    /**
     * Applies the resume token to the TargetChange, but only when it has a new
     * value. Empty resumeTokens are discarded.
     */ Vt(t) {
        t.approximateByteSize() > 0 && (this.bt = !0, this.At = t);
    }
    /**
     * Creates a target change from the current set of changes.
     *
     * To reset the document changes after raising this snapshot, call
     * `clearPendingChanges()`.
     */ St() {
        let t = $5c04988f82cad1b3$var$ws(), e = $5c04988f82cad1b3$var$ws(), n = $5c04988f82cad1b3$var$ws();
        return this.Et.forEach((s, i)=>{
            switch(i){
                case 0 /* Added */ :
                    t = t.add(s);
                    break;
                case 2 /* Modified */ :
                    e = e.add(s);
                    break;
                case 1 /* Removed */ :
                    n = n.add(s);
                    break;
                default:
                    $5c04988f82cad1b3$var$L();
            }
        }), new $5c04988f82cad1b3$var$ps(this.At, this.Rt, t, e, n);
    }
    /**
     * Resets the document changes and sets `hasPendingChanges` to false.
     */ Dt() {
        this.bt = !1, this.Et = $5c04988f82cad1b3$var$Ps();
    }
    Ct(t, e) {
        this.bt = !0, this.Et = this.Et.insert(t, e);
    }
    xt(t) {
        this.bt = !0, this.Et = this.Et.remove(t);
    }
    Nt() {
        this.Tt += 1;
    }
    kt() {
        this.Tt -= 1;
    }
    Ot() {
        this.bt = !0, this.Rt = !0;
    }
    constructor(){
        /**
         * The number of pending responses (adds or removes) that we are waiting on.
         * We only consider targets active that have no pending responses.
         */ this.Tt = 0, /**
         * Keeps track of the document changes since the last raised snapshot.
         *
         * These changes are continuously updated as we receive document updates and
         * always reflect the current set of changes against the last issued snapshot.
         */ this.Et = $5c04988f82cad1b3$var$Ps(), /** See public getters for explanations of these fields. */ this.At = $5c04988f82cad1b3$var$Jt.EMPTY_BYTE_STRING, this.Rt = !1, /**
         * Whether this target state should be included in the next snapshot. We
         * initialize to true so that newly-added targets are included in the next
         * RemoteEvent.
         */ this.bt = !0;
    }
}
/**
 * A helper class to accumulate watch changes into a RemoteEvent.
 */ class $5c04988f82cad1b3$var$Rs {
    /**
     * Processes and adds the DocumentWatchChange to the current set of changes.
     */ Ut(t) {
        for (const e of t.gt)t.yt && t.yt.isFoundDocument() ? this.qt(e, t.yt) : this.Kt(e, t.key, t.yt);
        for (const e of t.removedTargetIds)this.Kt(e, t.key, t.yt);
    }
    /** Processes and adds the WatchTargetChange to the current set of changes. */ Gt(t) {
        this.forEachTarget(t, (e)=>{
            const n = this.Qt(e);
            switch(t.state){
                case 0 /* NoChange */ :
                    this.jt(e) && n.Vt(t.resumeToken);
                    break;
                case 1 /* Added */ :
                    // We need to decrement the number of pending acks needed from watch
                    // for this targetId.
                    n.kt(), n.Pt || // We have a freshly added target, so we need to reset any state
                    // that we had previously. This can happen e.g. when remove and add
                    // back a target for existence filter mismatches.
                    n.Dt(), n.Vt(t.resumeToken);
                    break;
                case 2 /* Removed */ :
                    // We need to keep track of removed targets to we can post-filter and
                    // remove any target changes.
                    // We need to decrement the number of pending acks needed from watch
                    // for this targetId.
                    n.kt(), n.Pt || this.removeTarget(e);
                    break;
                case 3 /* Current */ :
                    this.jt(e) && (n.Ot(), n.Vt(t.resumeToken));
                    break;
                case 4 /* Reset */ :
                    this.jt(e) && // Reset the target and synthesizes removes for all existing
                    // documents. The backend will re-add any documents that still
                    // match the target before it sends the next global snapshot.
                    (this.Wt(e), n.Vt(t.resumeToken));
                    break;
                default:
                    $5c04988f82cad1b3$var$L();
            }
        });
    }
    /**
     * Iterates over all targetIds that the watch change applies to: either the
     * targetIds explicitly listed in the change or the targetIds of all currently
     * active targets.
     */ forEachTarget(t, e) {
        t.targetIds.length > 0 ? t.targetIds.forEach(e) : this.Ft.forEach((t, n)=>{
            this.jt(n) && e(n);
        });
    }
    /**
     * Handles existence filters and synthesizes deletes for filter mismatches.
     * Targets that are invalidated by filter mismatches are added to
     * `pendingTargetResets`.
     */ zt(t) {
        const e = t.targetId, n = t.It.count, s = this.Ht(e);
        if (s) {
            const t = s.target;
            if ($5c04988f82cad1b3$var$$e(t)) {
                if (0 === n) {
                    // The existence filter told us the document does not exist. We deduce
                    // that this document does not exist and apply a deleted document to
                    // our updates. Without applying this deleted document there might be
                    // another query that will raise this document as part of a snapshot
                    // until it is resolved, essentially exposing inconsistency between
                    // queries.
                    const n = new $5c04988f82cad1b3$export$afc2e57c475b7810(t.path);
                    this.Kt(e, n, $5c04988f82cad1b3$var$xe.newNoDocument(n, $5c04988f82cad1b3$var$ct.min()));
                } else $5c04988f82cad1b3$var$U(1 === n);
            } else this.Jt(e) !== n && // Existence filter mismatch: We reset the mapping and raise a new
            // snapshot with `isFromCache:true`.
            (this.Wt(e), this.Lt = this.Lt.add(e));
        }
    }
    /**
     * Converts the currently accumulated state into a remote event at the
     * provided snapshot version. Resets the accumulated changes before returning.
     */ Yt(t) {
        const e = new Map;
        this.Ft.forEach((n, s)=>{
            const i = this.Ht(s);
            if (i) {
                if (n.current && $5c04988f82cad1b3$var$$e(i.target)) {
                    // Document queries for document that don't exist can produce an empty
                    // result set. To update our local cache, we synthesize a document
                    // delete if we have not previously received the document. This
                    // resolves the limbo state of the document, removing it from
                    // limboDocumentRefs.
                    // TODO(dimond): Ideally we would have an explicit lookup target
                    // instead resulting in an explicit delete message and we could
                    // remove this special logic.
                    const e = new $5c04988f82cad1b3$export$afc2e57c475b7810(i.target.path);
                    null !== this.$t.get(e) || this.Xt(s, e) || this.Kt(s, e, $5c04988f82cad1b3$var$xe.newNoDocument(e, t));
                }
                n.vt && (e.set(s, n.St()), n.Dt());
            }
        });
        let n = $5c04988f82cad1b3$var$ws();
        // We extract the set of limbo-only document updates as the GC logic
        // special-cases documents that do not appear in the target cache.
        // TODO(gsoltis): Expand on this comment once GC is available in the JS
        // client.
        this.Bt.forEach((t, e)=>{
            let s = !0;
            e.forEachWhile((t)=>{
                const e = this.Ht(t);
                return !e || 2 /* LimboResolution */  === e.purpose || (s = !1, !1);
            }), s && (n = n.add(t));
        }), this.$t.forEach((e, n)=>n.setReadTime(t));
        const s = new $5c04988f82cad1b3$var$ys(t, e, this.Lt, this.$t, n);
        return this.$t = $5c04988f82cad1b3$var$os(), this.Bt = $5c04988f82cad1b3$var$bs(), this.Lt = new $5c04988f82cad1b3$var$Qt($5c04988f82cad1b3$var$it), s;
    }
    /**
     * Adds the provided document to the internal list of document updates and
     * its document key to the given target's mapping.
     */ // Visible for testing.
    qt(t, e) {
        if (!this.jt(t)) return;
        const n = this.Xt(t, e.key) ? 2 /* Modified */  : 0 /* Added */ ;
        this.Qt(t).Ct(e.key, n), this.$t = this.$t.insert(e.key, e), this.Bt = this.Bt.insert(e.key, this.Zt(e.key).add(t));
    }
    /**
     * Removes the provided document from the target mapping. If the
     * document no longer matches the target, but the document's state is still
     * known (e.g. we know that the document was deleted or we received the change
     * that caused the filter mismatch), the new document can be provided
     * to update the remote document cache.
     */ // Visible for testing.
    Kt(t, e, n) {
        if (!this.jt(t)) return;
        const s = this.Qt(t);
        this.Xt(t, e) ? s.Ct(e, 1 /* Removed */ ) : // The document may have entered and left the target before we raised a
        // snapshot, so we can just ignore the change.
        s.xt(e), this.Bt = this.Bt.insert(e, this.Zt(e).delete(t)), n && (this.$t = this.$t.insert(e, n));
    }
    removeTarget(t) {
        this.Ft.delete(t);
    }
    /**
     * Returns the current count of documents in the target. This includes both
     * the number of documents that the LocalStore considers to be part of the
     * target as well as any accumulated changes.
     */ Jt(t) {
        const e = this.Qt(t).St();
        return this.Mt.getRemoteKeysForTarget(t).size + e.addedDocuments.size - e.removedDocuments.size;
    }
    /**
     * Increment the number of acks needed from watch before we can consider the
     * server to be 'in-sync' with the client's active targets.
     */ Nt(t) {
        this.Qt(t).Nt();
    }
    Qt(t) {
        let e = this.Ft.get(t);
        return e || (e = new $5c04988f82cad1b3$var$As, this.Ft.set(t, e)), e;
    }
    Zt(t) {
        let e = this.Bt.get(t);
        return e || (e = new $5c04988f82cad1b3$var$Qt($5c04988f82cad1b3$var$it), this.Bt = this.Bt.insert(t, e)), e;
    }
    /**
     * Verifies that the user is still interested in this target (by calling
     * `getTargetDataForTarget()`) and that we are not waiting for pending ADDs
     * from watch.
     */ jt(t) {
        const e = null !== this.Ht(t);
        return e || $5c04988f82cad1b3$var$M("WatchChangeAggregator", "Detected inactive target", t), e;
    }
    /**
     * Returns the TargetData for an active target (i.e. a target that the user
     * is still interested in that has no outstanding target change requests).
     */ Ht(t) {
        const e = this.Ft.get(t);
        return e && e.Pt ? null : this.Mt.te(t);
    }
    /**
     * Resets the state of a Watch target to its initial state (e.g. sets
     * 'current' to false, clears the resume token and removes its target mapping
     * from all documents).
     */ Wt(t) {
        this.Ft.set(t, new $5c04988f82cad1b3$var$As);
        this.Mt.getRemoteKeysForTarget(t).forEach((e)=>{
            this.Kt(t, e, /*updatedDocument=*/ null);
        });
    }
    /**
     * Returns whether the LocalStore considers the document to be part of the
     * specified target.
     */ Xt(t, e) {
        return this.Mt.getRemoteKeysForTarget(t).has(e);
    }
    constructor(t){
        this.Mt = t, /** The internal state of all tracked targets. */ this.Ft = new Map, /** Keeps track of the documents to update since the last raised snapshot. */ this.$t = $5c04988f82cad1b3$var$os(), /** A mapping of document keys to their set of target IDs. */ this.Bt = $5c04988f82cad1b3$var$bs(), /**
         * A list of targets with existence filter mismatches. These targets are
         * known to be inconsistent and their listens needs to be re-established by
         * RemoteStore.
         */ this.Lt = new $5c04988f82cad1b3$var$Qt($5c04988f82cad1b3$var$it);
    }
}
function $5c04988f82cad1b3$var$bs() {
    return new $5c04988f82cad1b3$var$qt($5c04988f82cad1b3$export$afc2e57c475b7810.comparator);
}
function $5c04988f82cad1b3$var$Ps() {
    return new $5c04988f82cad1b3$var$qt($5c04988f82cad1b3$export$afc2e57c475b7810.comparator);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $5c04988f82cad1b3$var$vs = (()=>{
    const t = {
        asc: "ASCENDING",
        desc: "DESCENDING"
    };
    return t;
})(), $5c04988f82cad1b3$var$Vs = (()=>{
    const t = {
        "<": "LESS_THAN",
        "<=": "LESS_THAN_OR_EQUAL",
        ">": "GREATER_THAN",
        ">=": "GREATER_THAN_OR_EQUAL",
        "==": "EQUAL",
        "!=": "NOT_EQUAL",
        "array-contains": "ARRAY_CONTAINS",
        in: "IN",
        "not-in": "NOT_IN",
        "array-contains-any": "ARRAY_CONTAINS_ANY"
    };
    return t;
})();
/**
 * This class generates JsonObject values for the Datastore API suitable for
 * sending to either GRPC stub methods or via the JSON/HTTP REST API.
 *
 * The serializer supports both Protobuf.js and Proto3 JSON formats. By
 * setting `useProto3Json` to true, the serializer will use the Proto3 JSON
 * format.
 *
 * For a description of the Proto3 JSON format check
 * https://developers.google.com/protocol-buffers/docs/proto3#json
 *
 * TODO(klimt): We can remove the databaseId argument if we keep the full
 * resource name in documents.
 */ class $5c04988f82cad1b3$var$Ss {
    constructor(t, e){
        this.databaseId = t, this.dt = e;
    }
}
/**
 * Returns a value for a Date that's appropriate to put into a proto.
 */ function $5c04988f82cad1b3$var$Ds(t, e) {
    if (t.dt) return `${new Date(1e3 * e.seconds).toISOString().replace(/\.\d*/, "").replace("Z", "")}.${("000000000" + e.nanoseconds).slice(-9)}Z`;
    return {
        seconds: "" + e.seconds,
        nanos: e.nanoseconds
    };
}
/**
 * Returns a value for bytes that's appropriate to put in a proto.
 *
 * Visible for testing.
 */ function $5c04988f82cad1b3$var$Cs(t, e) {
    return t.dt ? e.toBase64() : e.toUint8Array();
}
/**
 * Returns a ByteString based on the proto string value.
 */ function $5c04988f82cad1b3$var$xs(t, e) {
    return $5c04988f82cad1b3$var$Ds(t, e.toTimestamp());
}
function $5c04988f82cad1b3$var$Ns(t) {
    return $5c04988f82cad1b3$var$U(!!t), $5c04988f82cad1b3$var$ct.fromTimestamp(function(t) {
        const e = $5c04988f82cad1b3$var$Xt(t);
        return new $5c04988f82cad1b3$export$d9bcbd5e1ff81430(e.seconds, e.nanos);
    }(t));
}
function $5c04988f82cad1b3$var$ks(t, e) {
    return (function(t) {
        return new $5c04988f82cad1b3$var$ht([
            "projects",
            t.projectId,
            "databases",
            t.database
        ]);
    })(t).child("documents").child(e).canonicalString();
}
function $5c04988f82cad1b3$var$Os(t) {
    const e = $5c04988f82cad1b3$var$ht.fromString(t);
    return $5c04988f82cad1b3$var$U($5c04988f82cad1b3$var$ui(e)), e;
}
function $5c04988f82cad1b3$var$Ms(t, e) {
    return $5c04988f82cad1b3$var$ks(t.databaseId, e.path);
}
function $5c04988f82cad1b3$var$Fs(t, e) {
    const n = $5c04988f82cad1b3$var$Os(e);
    if (n.get(1) !== t.databaseId.projectId) throw new $5c04988f82cad1b3$export$8fada0bf726bf278($5c04988f82cad1b3$var$G.INVALID_ARGUMENT, "Tried to deserialize key from different project: " + n.get(1) + " vs " + t.databaseId.projectId);
    if (n.get(3) !== t.databaseId.database) throw new $5c04988f82cad1b3$export$8fada0bf726bf278($5c04988f82cad1b3$var$G.INVALID_ARGUMENT, "Tried to deserialize key from different database: " + n.get(3) + " vs " + t.databaseId.database);
    return new $5c04988f82cad1b3$export$afc2e57c475b7810($5c04988f82cad1b3$var$Us(n));
}
function $5c04988f82cad1b3$var$$s(t, e) {
    return $5c04988f82cad1b3$var$ks(t.databaseId, e);
}
function $5c04988f82cad1b3$var$Bs(t) {
    const e = $5c04988f82cad1b3$var$Os(t);
    // In v1beta1 queries for collections at the root did not have a trailing
    // "/documents". In v1 all resource paths contain "/documents". Preserve the
    // ability to read the v1beta1 form for compatibility with queries persisted
    // in the local target cache.
    return 4 === e.length ? $5c04988f82cad1b3$var$ht.emptyPath() : $5c04988f82cad1b3$var$Us(e);
}
function $5c04988f82cad1b3$var$Ls(t) {
    return new $5c04988f82cad1b3$var$ht([
        "projects",
        t.databaseId.projectId,
        "databases",
        t.databaseId.database
    ]).canonicalString();
}
function $5c04988f82cad1b3$var$Us(t) {
    return $5c04988f82cad1b3$var$U(t.length > 4 && "documents" === t.get(4)), t.popFirst(5);
}
/** Creates a Document proto from key and fields (but no create/update time) */ function $5c04988f82cad1b3$var$qs(t, e, n) {
    return {
        name: $5c04988f82cad1b3$var$Ms(t, e),
        fields: n.value.mapValue.fields
    };
}
function $5c04988f82cad1b3$var$Ks(t, e, n) {
    const s = $5c04988f82cad1b3$var$Fs(t, e.name), i = $5c04988f82cad1b3$var$Ns(e.updateTime), r = new $5c04988f82cad1b3$var$De({
        mapValue: {
            fields: e.fields
        }
    }), o = $5c04988f82cad1b3$var$xe.newFoundDocument(s, i, r);
    return n && o.setHasCommittedMutations(), n ? o.setHasCommittedMutations() : o;
}
function $5c04988f82cad1b3$var$Gs(t, e) {
    return "found" in e ? function(t, e) {
        $5c04988f82cad1b3$var$U(!!e.found), e.found.name, e.found.updateTime;
        const n = $5c04988f82cad1b3$var$Fs(t, e.found.name), s = $5c04988f82cad1b3$var$Ns(e.found.updateTime), i = new $5c04988f82cad1b3$var$De({
            mapValue: {
                fields: e.found.fields
            }
        });
        return $5c04988f82cad1b3$var$xe.newFoundDocument(n, s, i);
    }(t, e) : "missing" in e ? function(t, e) {
        $5c04988f82cad1b3$var$U(!!e.missing), $5c04988f82cad1b3$var$U(!!e.readTime);
        const n = $5c04988f82cad1b3$var$Fs(t, e.missing), s = $5c04988f82cad1b3$var$Ns(e.readTime);
        return $5c04988f82cad1b3$var$xe.newNoDocument(n, s);
    }(t, e) : $5c04988f82cad1b3$var$L();
}
function $5c04988f82cad1b3$var$Qs(t, e) {
    let n;
    if ("targetChange" in e) {
        e.targetChange;
        // proto3 default value is unset in JSON (undefined), so use 'NO_CHANGE'
        // if unset
        const s = function(t) {
            return "NO_CHANGE" === t ? 0 /* NoChange */  : "ADD" === t ? 1 /* Added */  : "REMOVE" === t ? 2 /* Removed */  : "CURRENT" === t ? 3 /* Current */  : "RESET" === t ? 4 /* Reset */  : $5c04988f82cad1b3$var$L();
        }(e.targetChange.targetChangeType || "NO_CHANGE"), i = e.targetChange.targetIds || [], r = function(t, e) {
            return t.dt ? ($5c04988f82cad1b3$var$U(void 0 === e || "string" == typeof e), $5c04988f82cad1b3$var$Jt.fromBase64String(e || "")) : ($5c04988f82cad1b3$var$U(void 0 === e || e instanceof Uint8Array), $5c04988f82cad1b3$var$Jt.fromUint8Array(e || new Uint8Array));
        }(t, e.targetChange.resumeToken), o = e.targetChange.cause, u = o && function(t) {
            const e = void 0 === t.code ? $5c04988f82cad1b3$var$G.UNKNOWN : $5c04988f82cad1b3$var$ss(t.code);
            return new $5c04988f82cad1b3$export$8fada0bf726bf278(e, t.message || "");
        }(o);
        n = new $5c04988f82cad1b3$var$Es(s, i, r, u || null);
    } else if ("documentChange" in e) {
        e.documentChange;
        const s = e.documentChange;
        s.document, s.document.name, s.document.updateTime;
        const i = $5c04988f82cad1b3$var$Fs(t, s.document.name), r = $5c04988f82cad1b3$var$Ns(s.document.updateTime), o = new $5c04988f82cad1b3$var$De({
            mapValue: {
                fields: s.document.fields
            }
        }), u = $5c04988f82cad1b3$var$xe.newFoundDocument(i, r, o), c = s.targetIds || [], a = s.removedTargetIds || [];
        n = new $5c04988f82cad1b3$var$Is(c, a, u.key, u);
    } else if ("documentDelete" in e) {
        e.documentDelete;
        const s = e.documentDelete;
        s.document;
        const i = $5c04988f82cad1b3$var$Fs(t, s.document), r = s.readTime ? $5c04988f82cad1b3$var$Ns(s.readTime) : $5c04988f82cad1b3$var$ct.min(), o = $5c04988f82cad1b3$var$xe.newNoDocument(i, r), u = s.removedTargetIds || [];
        n = new $5c04988f82cad1b3$var$Is([], u, o.key, o);
    } else if ("documentRemove" in e) {
        e.documentRemove;
        const s = e.documentRemove;
        s.document;
        const i = $5c04988f82cad1b3$var$Fs(t, s.document), r = s.removedTargetIds || [];
        n = new $5c04988f82cad1b3$var$Is([], r, i, null);
    } else {
        if (!("filter" in e)) return $5c04988f82cad1b3$var$L();
        {
            e.filter;
            const t = e.filter;
            t.targetId;
            const s = t.count || 0, i = new $5c04988f82cad1b3$var$Zn(s), r = t.targetId;
            n = new $5c04988f82cad1b3$var$Ts(r, i);
        }
    }
    return n;
}
function $5c04988f82cad1b3$var$js(t, e) {
    let n;
    if (e instanceof $5c04988f82cad1b3$var$jn) n = {
        update: $5c04988f82cad1b3$var$qs(t, e.key, e.value)
    };
    else if (e instanceof $5c04988f82cad1b3$var$Yn) n = {
        delete: $5c04988f82cad1b3$var$Ms(t, e.key)
    };
    else if (e instanceof $5c04988f82cad1b3$var$Wn) n = {
        update: $5c04988f82cad1b3$var$qs(t, e.key, e.data),
        updateMask: $5c04988f82cad1b3$var$oi(e.fieldMask)
    };
    else {
        if (!(e instanceof $5c04988f82cad1b3$var$Xn)) return $5c04988f82cad1b3$var$L();
        n = {
            verify: $5c04988f82cad1b3$var$Ms(t, e.key)
        };
    }
    return e.fieldTransforms.length > 0 && (n.updateTransforms = e.fieldTransforms.map((t)=>(function(t, e) {
            const n = e.transform;
            if (n instanceof $5c04988f82cad1b3$var$vn) return {
                fieldPath: e.field.canonicalString(),
                setToServerValue: "REQUEST_TIME"
            };
            if (n instanceof $5c04988f82cad1b3$var$Vn) return {
                fieldPath: e.field.canonicalString(),
                appendMissingElements: {
                    values: n.elements
                }
            };
            if (n instanceof $5c04988f82cad1b3$var$Dn) return {
                fieldPath: e.field.canonicalString(),
                removeAllFromArray: {
                    values: n.elements
                }
            };
            if (n instanceof $5c04988f82cad1b3$var$xn) return {
                fieldPath: e.field.canonicalString(),
                increment: n._t
            };
            throw $5c04988f82cad1b3$var$L();
        })(0, t))), e.precondition.isNone || (n.currentDocument = function(t, e) {
        return void 0 !== e.updateTime ? {
            updateTime: $5c04988f82cad1b3$var$xs(t, e.updateTime)
        } : void 0 !== e.exists ? {
            exists: e.exists
        } : $5c04988f82cad1b3$var$L();
    }(t, e.precondition)), n;
}
function $5c04988f82cad1b3$var$Ws(t, e) {
    const n = e.currentDocument ? function(t) {
        return void 0 !== t.updateTime ? $5c04988f82cad1b3$var$$n.updateTime($5c04988f82cad1b3$var$Ns(t.updateTime)) : void 0 !== t.exists ? $5c04988f82cad1b3$var$$n.exists(t.exists) : $5c04988f82cad1b3$var$$n.none();
    }(e.currentDocument) : $5c04988f82cad1b3$var$$n.none(), s = e.updateTransforms ? e.updateTransforms.map((e)=>(function(t, e) {
            let n = null;
            if ("setToServerValue" in e) $5c04988f82cad1b3$var$U("REQUEST_TIME" === e.setToServerValue), n = new $5c04988f82cad1b3$var$vn;
            else if ("appendMissingElements" in e) {
                const t = e.appendMissingElements.values || [];
                n = new $5c04988f82cad1b3$var$Vn(t);
            } else if ("removeAllFromArray" in e) {
                const t = e.removeAllFromArray.values || [];
                n = new $5c04988f82cad1b3$var$Dn(t);
            } else "increment" in e ? n = new $5c04988f82cad1b3$var$xn(t, e.increment) : $5c04988f82cad1b3$var$L();
            const s = $5c04988f82cad1b3$export$b7871852b967eaf1.fromServerFormat(e.fieldPath);
            return new $5c04988f82cad1b3$var$On(s, n);
        })(t, e)) : [];
    if (e.update) {
        e.update.name;
        const i = $5c04988f82cad1b3$var$Fs(t, e.update.name), r = new $5c04988f82cad1b3$var$De({
            mapValue: {
                fields: e.update.fields
            }
        });
        if (e.updateMask) {
            const t = function(t) {
                const e = t.fieldPaths || [];
                return new $5c04988f82cad1b3$var$zt(e.map((t)=>$5c04988f82cad1b3$export$b7871852b967eaf1.fromServerFormat(t)));
            }(e.updateMask);
            return new $5c04988f82cad1b3$var$Wn(i, r, t, n, s);
        }
        return new $5c04988f82cad1b3$var$jn(i, r, n, s);
    }
    if (e.delete) {
        const s = $5c04988f82cad1b3$var$Fs(t, e.delete);
        return new $5c04988f82cad1b3$var$Yn(s, n);
    }
    if (e.verify) {
        const s = $5c04988f82cad1b3$var$Fs(t, e.verify);
        return new $5c04988f82cad1b3$var$Xn(s, n);
    }
    return $5c04988f82cad1b3$var$L();
}
function $5c04988f82cad1b3$var$zs(t, e) {
    return t && t.length > 0 ? ($5c04988f82cad1b3$var$U(void 0 !== e), t.map((t)=>(function(t, e) {
            // NOTE: Deletes don't have an updateTime.
            let n = t.updateTime ? $5c04988f82cad1b3$var$Ns(t.updateTime) : $5c04988f82cad1b3$var$Ns(e);
            return n.isEqual($5c04988f82cad1b3$var$ct.min()) && // The Firestore Emulator currently returns an update time of 0 for
            // deletes of non-existing documents (rather than null). This breaks the
            // test "get deleted doc while offline with source=cache" as NoDocuments
            // with version 0 are filtered by IndexedDb's RemoteDocumentCache.
            // TODO(#2149): Remove this when Emulator is fixed
            (n = $5c04988f82cad1b3$var$Ns(e)), new $5c04988f82cad1b3$var$Fn(n, t.transformResults || []);
        })(t, e))) : [];
}
function $5c04988f82cad1b3$var$Hs(t, e) {
    return {
        documents: [
            $5c04988f82cad1b3$var$$s(t, e.path)
        ]
    };
}
function $5c04988f82cad1b3$var$Js(t, e) {
    // Dissect the path into parent, collectionId, and optional key filter.
    const n = {
        structuredQuery: {}
    }, s = e.path;
    null !== e.collectionGroup ? (n.parent = $5c04988f82cad1b3$var$$s(t, s), n.structuredQuery.from = [
        {
            collectionId: e.collectionGroup,
            allDescendants: !0
        }
    ]) : (n.parent = $5c04988f82cad1b3$var$$s(t, s.popLast()), n.structuredQuery.from = [
        {
            collectionId: s.lastSegment()
        }
    ]);
    const i = function(t) {
        if (0 === t.length) return;
        const e = t.map((t)=>// visible for testing
            (function(t) {
                if ("==" /* EQUAL */  === t.op) {
                    if ($5c04988f82cad1b3$var$Ee(t.value)) return {
                        unaryFilter: {
                            field: $5c04988f82cad1b3$var$ni(t.field),
                            op: "IS_NAN"
                        }
                    };
                    if ($5c04988f82cad1b3$var$Te(t.value)) return {
                        unaryFilter: {
                            field: $5c04988f82cad1b3$var$ni(t.field),
                            op: "IS_NULL"
                        }
                    };
                } else if ("!=" /* NOT_EQUAL */  === t.op) {
                    if ($5c04988f82cad1b3$var$Ee(t.value)) return {
                        unaryFilter: {
                            field: $5c04988f82cad1b3$var$ni(t.field),
                            op: "IS_NOT_NAN"
                        }
                    };
                    if ($5c04988f82cad1b3$var$Te(t.value)) return {
                        unaryFilter: {
                            field: $5c04988f82cad1b3$var$ni(t.field),
                            op: "IS_NOT_NULL"
                        }
                    };
                }
                return {
                    fieldFilter: {
                        field: $5c04988f82cad1b3$var$ni(t.field),
                        op: $5c04988f82cad1b3$var$ei(t.op),
                        value: t.value
                    }
                };
            })(t));
        if (1 === e.length) return e[0];
        return {
            compositeFilter: {
                op: "AND",
                filters: e
            }
        };
    }(e.filters);
    i && (n.structuredQuery.where = i);
    const r = function(t) {
        if (0 === t.length) return;
        return t.map((t)=>// visible for testing
            (function(t) {
                return {
                    field: $5c04988f82cad1b3$var$ni(t.field),
                    direction: $5c04988f82cad1b3$var$ti(t.dir)
                };
            })(t));
    }(e.orderBy);
    r && (n.structuredQuery.orderBy = r);
    const o = function(t, e) {
        return t.dt || $5c04988f82cad1b3$var$oe(e) ? e : {
            value: e
        };
    }(t, e.limit);
    var u;
    return null !== o && (n.structuredQuery.limit = o), e.startAt && (n.structuredQuery.startAt = {
        before: (u = e.startAt).inclusive,
        values: u.position
    }), e.endAt && (n.structuredQuery.endAt = function(t) {
        return {
            before: !t.inclusive,
            values: t.position
        };
    }(e.endAt)), n;
}
function $5c04988f82cad1b3$var$Ys(t) {
    let e = $5c04988f82cad1b3$var$Bs(t.parent);
    const n = t.structuredQuery, s = n.from ? n.from.length : 0;
    let i = null;
    if (s > 0) {
        $5c04988f82cad1b3$var$U(1 === s);
        const t = n.from[0];
        t.allDescendants ? i = t.collectionId : e = e.child(t.collectionId);
    }
    let r = [];
    n.where && (r = $5c04988f82cad1b3$var$Zs(n.where));
    let o = [];
    n.orderBy && (o = n.orderBy.map((t)=>(function(t) {
            return new $5c04988f82cad1b3$var$Xe($5c04988f82cad1b3$var$si(t.field), // visible for testing
            function(t) {
                switch(t){
                    case "ASCENDING":
                        return "asc" /* ASCENDING */ ;
                    case "DESCENDING":
                        return "desc" /* DESCENDING */ ;
                    default:
                        return;
                }
            }(t.direction));
        })(t)));
    let u = null;
    n.limit && (u = function(t) {
        let e;
        return e = "object" == typeof t ? t.value : t, $5c04988f82cad1b3$var$oe(e) ? null : e;
    }(n.limit));
    let c = null;
    n.startAt && (c = function(t) {
        const e = !!t.before, n = t.values || [];
        return new $5c04988f82cad1b3$var$Ye(n, e);
    }(n.startAt));
    let a = null;
    return n.endAt && (a = function(t) {
        const e = !t.before, n = t.values || [];
        return new $5c04988f82cad1b3$var$Ye(n, e);
    }(n.endAt)), $5c04988f82cad1b3$var$sn(e, i, o, r, u, "F" /* First */ , c, a);
}
function $5c04988f82cad1b3$var$Xs(t, e) {
    const n = function(t, e) {
        switch(e){
            case 0 /* Listen */ :
                return null;
            case 1 /* ExistenceFilterMismatch */ :
                return "existence-filter-mismatch";
            case 2 /* LimboResolution */ :
                return "limbo-document";
            default:
                return $5c04988f82cad1b3$var$L();
        }
    }(0, e.purpose);
    return null == n ? null : {
        "goog-listen-tags": n
    };
}
function $5c04988f82cad1b3$var$Zs(t) {
    return t ? void 0 !== t.unaryFilter ? [
        $5c04988f82cad1b3$var$ri(t)
    ] : void 0 !== t.fieldFilter ? [
        $5c04988f82cad1b3$var$ii(t)
    ] : void 0 !== t.compositeFilter ? t.compositeFilter.filters.map((t)=>$5c04988f82cad1b3$var$Zs(t)).reduce((t, e)=>t.concat(e)) : $5c04988f82cad1b3$var$L() : [];
}
function $5c04988f82cad1b3$var$ti(t) {
    return $5c04988f82cad1b3$var$vs[t];
}
function $5c04988f82cad1b3$var$ei(t) {
    return $5c04988f82cad1b3$var$Vs[t];
}
function $5c04988f82cad1b3$var$ni(t) {
    return {
        fieldPath: t.canonicalString()
    };
}
function $5c04988f82cad1b3$var$si(t) {
    return $5c04988f82cad1b3$export$b7871852b967eaf1.fromServerFormat(t.fieldPath);
}
function $5c04988f82cad1b3$var$ii(t) {
    return $5c04988f82cad1b3$var$qe.create($5c04988f82cad1b3$var$si(t.fieldFilter.field), function(t) {
        switch(t){
            case "EQUAL":
                return "==" /* EQUAL */ ;
            case "NOT_EQUAL":
                return "!=" /* NOT_EQUAL */ ;
            case "GREATER_THAN":
                return ">" /* GREATER_THAN */ ;
            case "GREATER_THAN_OR_EQUAL":
                return ">=" /* GREATER_THAN_OR_EQUAL */ ;
            case "LESS_THAN":
                return "<" /* LESS_THAN */ ;
            case "LESS_THAN_OR_EQUAL":
                return "<=" /* LESS_THAN_OR_EQUAL */ ;
            case "ARRAY_CONTAINS":
                return "array-contains" /* ARRAY_CONTAINS */ ;
            case "IN":
                return "in" /* IN */ ;
            case "NOT_IN":
                return "not-in" /* NOT_IN */ ;
            case "ARRAY_CONTAINS_ANY":
                return "array-contains-any" /* ARRAY_CONTAINS_ANY */ ;
            default:
                return $5c04988f82cad1b3$var$L();
        }
    }(t.fieldFilter.op), t.fieldFilter.value);
}
function $5c04988f82cad1b3$var$ri(t) {
    switch(t.unaryFilter.op){
        case "IS_NAN":
            const e = $5c04988f82cad1b3$var$si(t.unaryFilter.field);
            return $5c04988f82cad1b3$var$qe.create(e, "==" /* EQUAL */ , {
                doubleValue: NaN
            });
        case "IS_NULL":
            const n = $5c04988f82cad1b3$var$si(t.unaryFilter.field);
            return $5c04988f82cad1b3$var$qe.create(n, "==" /* EQUAL */ , {
                nullValue: "NULL_VALUE"
            });
        case "IS_NOT_NAN":
            const s = $5c04988f82cad1b3$var$si(t.unaryFilter.field);
            return $5c04988f82cad1b3$var$qe.create(s, "!=" /* NOT_EQUAL */ , {
                doubleValue: NaN
            });
        case "IS_NOT_NULL":
            const i = $5c04988f82cad1b3$var$si(t.unaryFilter.field);
            return $5c04988f82cad1b3$var$qe.create(i, "!=" /* NOT_EQUAL */ , {
                nullValue: "NULL_VALUE"
            });
        default:
            return $5c04988f82cad1b3$var$L();
    }
}
function $5c04988f82cad1b3$var$oi(t) {
    const e = [];
    return t.fields.forEach((t)=>e.push(t.canonicalString())), {
        fieldPaths: e
    };
}
function $5c04988f82cad1b3$var$ui(t) {
    // Resource names have at least 4 components (project ID, database ID)
    return t.length >= 4 && "projects" === t.get(0) && "databases" === t.get(2);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Encodes a resource path into a IndexedDb-compatible string form.
 */ function $5c04988f82cad1b3$var$ci(t) {
    let e = "";
    for(let n = 0; n < t.length; n++)e.length > 0 && (e = $5c04988f82cad1b3$var$hi(e)), e = $5c04988f82cad1b3$var$ai(t.get(n), e);
    return $5c04988f82cad1b3$var$hi(e);
}
/** Encodes a single segment of a resource path into the given result */ function $5c04988f82cad1b3$var$ai(t, e) {
    let n = e;
    const s = t.length;
    for(let e = 0; e < s; e++){
        const s = t.charAt(e);
        switch(s){
            case "\x00":
                n += "\x01\x10";
                break;
            case "\x01":
                n += "\x01\x11";
                break;
            default:
                n += s;
        }
    }
    return n;
}
/** Encodes a path separator into the given result */ function $5c04988f82cad1b3$var$hi(t) {
    return t + "\x01\x01";
}
/**
 * Decodes the given IndexedDb-compatible string form of a resource path into
 * a ResourcePath instance. Note that this method is not suitable for use with
 * decoding resource names from the server; those are One Platform format
 * strings.
 */ function $5c04988f82cad1b3$var$li(t) {
    // Event the empty path must encode as a path of at least length 2. A path
    // with exactly 2 must be the empty path.
    const e = t.length;
    if ($5c04988f82cad1b3$var$U(e >= 2), 2 === e) return $5c04988f82cad1b3$var$U("\x01" === t.charAt(0) && "\x01" === t.charAt(1)), $5c04988f82cad1b3$var$ht.emptyPath();
    // Escape characters cannot exist past the second-to-last position in the
    // source value.
    const n = e - 2, s = [];
    let i = "";
    for(let r = 0; r < e;){
        // The last two characters of a valid encoded path must be a separator, so
        // there must be an end to this segment.
        const e = t.indexOf("\x01", r);
        (e < 0 || e > n) && $5c04988f82cad1b3$var$L();
        switch(t.charAt(e + 1)){
            case "\x01":
                const n1 = t.substring(r, e);
                let o;
                0 === i.length ? // Avoid copying for the common case of a segment that excludes \0
                // and \001
                o = n1 : (i += n1, o = i, i = ""), s.push(o);
                break;
            case "\x10":
                i += t.substring(r, e), i += "\x00";
                break;
            case "\x11":
                // The escape character can be used in the output to encode itself.
                i += t.substring(r, e + 1);
                break;
            default:
                $5c04988f82cad1b3$var$L();
        }
        r = e + 2;
    }
    return new $5c04988f82cad1b3$var$ht(s);
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $5c04988f82cad1b3$var$fi = [
    "userId",
    "batchId"
];
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Name of the IndexedDb object store.
 *
 * Note that the name 'owner' is chosen to ensure backwards compatibility with
 * older clients that only supported single locked access to the persistence
 * layer.
 */ /**
 * Creates a [userId, encodedPath] key for use in the DbDocumentMutations
 * index to iterate over all at document mutations for a given path or lower.
 */ function $5c04988f82cad1b3$var$di(t, e) {
    return [
        t,
        $5c04988f82cad1b3$var$ci(e)
    ];
}
/**
 * Creates a full index key of [userId, encodedPath, batchId] for inserting
 * and deleting into the DbDocumentMutations index.
 */ function $5c04988f82cad1b3$var$_i(t, e, n) {
    return [
        t,
        $5c04988f82cad1b3$var$ci(e),
        n
    ];
}
/**
 * Because we store all the useful information for this store in the key,
 * there is no useful information to store as the value. The raw (unencoded)
 * path cannot be stored because IndexedDb doesn't store prototype
 * information.
 */ const $5c04988f82cad1b3$var$wi = {}, $5c04988f82cad1b3$var$mi = [
    "prefixPath",
    "collectionGroup",
    "readTime",
    "documentId"
], $5c04988f82cad1b3$var$gi = [
    "prefixPath",
    "collectionGroup",
    "documentId"
], $5c04988f82cad1b3$var$yi = [
    "collectionGroup",
    "readTime",
    "prefixPath",
    "documentId"
], $5c04988f82cad1b3$var$pi = [
    "canonicalId",
    "targetId"
], $5c04988f82cad1b3$var$Ii = [
    "targetId",
    "path"
], $5c04988f82cad1b3$var$Ti = [
    "path",
    "targetId"
], $5c04988f82cad1b3$var$Ei = [
    "collectionId",
    "parent"
], $5c04988f82cad1b3$var$Ai = [
    "indexId",
    "uid"
], $5c04988f82cad1b3$var$Ri = [
    "uid",
    "sequenceNumber"
], $5c04988f82cad1b3$var$bi = [
    "indexId",
    "uid",
    "arrayValue",
    "directionalValue",
    "orderedDocumentKey",
    "documentKey"
], $5c04988f82cad1b3$var$Pi = [
    "indexId",
    "uid",
    "orderedDocumentKey"
], $5c04988f82cad1b3$var$vi = [
    "userId",
    "collectionPath",
    "documentId"
], $5c04988f82cad1b3$var$Vi = [
    "userId",
    "collectionPath",
    "largestBatchId"
], $5c04988f82cad1b3$var$Si = [
    "userId",
    "collectionGroup",
    "largestBatchId"
], $5c04988f82cad1b3$var$Di = [
    "mutationQueues",
    "mutations",
    "documentMutations",
    "remoteDocuments",
    "targets",
    "owner",
    "targetGlobal",
    "targetDocuments",
    "clientMetadata",
    "remoteDocumentGlobal",
    "collectionParents",
    "bundles",
    "namedQueries"
], $5c04988f82cad1b3$var$Ci = [
    ...$5c04988f82cad1b3$var$Di,
    "documentOverlays"
], $5c04988f82cad1b3$var$xi = [
    "mutationQueues",
    "mutations",
    "documentMutations",
    "remoteDocumentsV14",
    "targets",
    "owner",
    "targetGlobal",
    "targetDocuments",
    "clientMetadata",
    "remoteDocumentGlobal",
    "collectionParents",
    "bundles",
    "namedQueries",
    "documentOverlays"
], $5c04988f82cad1b3$var$Ni = $5c04988f82cad1b3$var$xi, $5c04988f82cad1b3$var$ki = [
    ...$5c04988f82cad1b3$var$Ni,
    "indexConfiguration",
    "indexState",
    "indexEntries"
];
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $5c04988f82cad1b3$var$Oi extends $5c04988f82cad1b3$var$Rt {
    constructor(t, e){
        super(), this.ee = t, this.currentSequenceNumber = e;
    }
}
function $5c04988f82cad1b3$var$Mi(t, e) {
    const n = $5c04988f82cad1b3$var$K(t);
    return $5c04988f82cad1b3$var$Vt.N(n.ee, e);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A batch of mutations that will be sent as one unit to the backend.
 */ class $5c04988f82cad1b3$var$Fi {
    /**
     * Applies all the mutations in this MutationBatch to the specified document
     * to compute the state of the remote document
     *
     * @param document - The document to apply mutations to.
     * @param batchResult - The result of applying the MutationBatch to the
     * backend.
     */ applyToRemoteDocument(t, e) {
        const n = e.mutationResults;
        for(let e = 0; e < this.mutations.length; e++){
            const s = this.mutations[e];
            if (s.key.isEqual(t.key)) $5c04988f82cad1b3$var$qn(s, t, n[e]);
        }
    }
    /**
     * Computes the local view of a document given all the mutations in this
     * batch.
     *
     * @param document - The document to apply mutations to.
     * @param mutatedFields - Fields that have been updated before applying this mutation batch.
     * @returns A `FieldMask` representing all the fields that are mutated.
     */ applyToLocalView(t, e) {
        // First, apply the base state. This allows us to apply non-idempotent
        // transform against a consistent set of values.
        for (const n of this.baseMutations)n.key.isEqual(t.key) && (e = $5c04988f82cad1b3$var$Kn(n, t, e, this.localWriteTime));
        // Second, apply all user-provided mutations.
        for (const n of this.mutations)n.key.isEqual(t.key) && (e = $5c04988f82cad1b3$var$Kn(n, t, e, this.localWriteTime));
        return e;
    }
    /**
     * Computes the local view for all provided documents given the mutations in
     * this batch. Returns a `DocumentKey` to `Mutation` map which can be used to
     * replace all the mutation applications.
     */ applyToLocalDocumentSet(t, e) {
        // TODO(mrschmidt): This implementation is O(n^2). If we apply the mutations
        // directly (as done in `applyToLocalView()`), we can reduce the complexity
        // to O(n).
        const n = $5c04988f82cad1b3$var$ls();
        return this.mutations.forEach((s)=>{
            const i = t.get(s.key), r = i.overlayedDocument;
            // TODO(mutabledocuments): This method should take a MutableDocumentMap
            // and we should remove this cast.
            let o = this.applyToLocalView(r, i.mutatedFields);
            // Set mutatedFields to null if the document is only from local mutations.
            // This creates a Set or Delete mutation, instead of trying to create a
            // patch mutation as the overlay.
            o = e.has(s.key) ? null : o;
            const u = $5c04988f82cad1b3$var$Un(r, o);
            null !== u && n.set(s.key, u), r.isValidDocument() || r.convertToNoDocument($5c04988f82cad1b3$var$ct.min());
        }), n;
    }
    keys() {
        return this.mutations.reduce((t, e)=>t.add(e.key), $5c04988f82cad1b3$var$ws());
    }
    isEqual(t) {
        return this.batchId === t.batchId && $5c04988f82cad1b3$var$rt(this.mutations, t.mutations, (t, e)=>$5c04988f82cad1b3$var$Qn(t, e)) && $5c04988f82cad1b3$var$rt(this.baseMutations, t.baseMutations, (t, e)=>$5c04988f82cad1b3$var$Qn(t, e));
    }
    /**
     * @param batchId - The unique ID of this mutation batch.
     * @param localWriteTime - The original write time of this mutation.
     * @param baseMutations - Mutations that are used to populate the base
     * values when this mutation is applied locally. This can be used to locally
     * overwrite values that are persisted in the remote document cache. Base
     * mutations are never sent to the backend.
     * @param mutations - The user-provided mutations in this mutation batch.
     * User-provided mutations are applied both locally and remotely on the
     * backend.
     */ constructor(t, e, n, s){
        this.batchId = t, this.localWriteTime = e, this.baseMutations = n, this.mutations = s;
    }
}
/** The result of applying a mutation batch to the backend. */ class $5c04988f82cad1b3$var$$i {
    /**
     * Creates a new MutationBatchResult for the given batch and results. There
     * must be one result for each mutation in the batch. This static factory
     * caches a document=&gt;version mapping (docVersions).
     */ static from(t, e, n) {
        $5c04988f82cad1b3$var$U(t.mutations.length === n.length);
        let s = $5c04988f82cad1b3$var$ds;
        const i = t.mutations;
        for(let t = 0; t < i.length; t++)s = s.insert(i[t].key, n[t].version);
        return new $5c04988f82cad1b3$var$$i(t, e, n, s);
    }
    constructor(t, e, n, /**
     * A pre-computed mapping from each mutated document to the resulting
     * version.
     */ s){
        this.batch = t, this.commitVersion = e, this.mutationResults = n, this.docVersions = s;
    }
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Representation of an overlay computed by Firestore.
 *
 * Holds information about a mutation and the largest batch id in Firestore when
 * the mutation was created.
 */ class $5c04988f82cad1b3$var$Bi {
    getKey() {
        return this.mutation.key;
    }
    isEqual(t) {
        return null !== t && this.mutation === t.mutation;
    }
    toString() {
        return `Overlay{\n      largestBatchId: ${this.largestBatchId},\n      mutation: ${this.mutation.toString()}\n    }`;
    }
    constructor(t, e){
        this.largestBatchId = t, this.mutation = e;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An immutable set of metadata that the local store tracks for each target.
 */ class $5c04988f82cad1b3$var$Li {
    /** Creates a new target data instance with an updated sequence number. */ withSequenceNumber(t) {
        return new $5c04988f82cad1b3$var$Li(this.target, this.targetId, this.purpose, t, this.snapshotVersion, this.lastLimboFreeSnapshotVersion, this.resumeToken);
    }
    /**
     * Creates a new target data instance with an updated resume token and
     * snapshot version.
     */ withResumeToken(t, e) {
        return new $5c04988f82cad1b3$var$Li(this.target, this.targetId, this.purpose, this.sequenceNumber, e, this.lastLimboFreeSnapshotVersion, t);
    }
    /**
     * Creates a new target data instance with an updated last limbo free
     * snapshot version number.
     */ withLastLimboFreeSnapshotVersion(t) {
        return new $5c04988f82cad1b3$var$Li(this.target, this.targetId, this.purpose, this.sequenceNumber, this.snapshotVersion, t, this.resumeToken);
    }
    constructor(/** The target being listened to. */ t, /**
     * The target ID to which the target corresponds; Assigned by the
     * LocalStore for user listens and by the SyncEngine for limbo watches.
     */ e, /** The purpose of the target. */ n, /**
     * The sequence number of the last transaction during which this target data
     * was modified.
     */ s, /** The latest snapshot version seen for this target. */ i = $5c04988f82cad1b3$var$ct.min(), r = $5c04988f82cad1b3$var$ct.min(), o = $5c04988f82cad1b3$var$Jt.EMPTY_BYTE_STRING){
        this.target = t, this.targetId = e, this.purpose = n, this.sequenceNumber = s, this.snapshotVersion = i, this.lastLimboFreeSnapshotVersion = r, this.resumeToken = o;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Serializer for values stored in the LocalStore. */ class $5c04988f82cad1b3$var$Ui {
    constructor(t){
        this.ne = t;
    }
}
/** Decodes a remote document from storage locally to a Document. */ function $5c04988f82cad1b3$var$qi(t, e) {
    let n;
    if (e.document) n = $5c04988f82cad1b3$var$Ks(t.ne, e.document, !!e.hasCommittedMutations);
    else if (e.noDocument) {
        const t = $5c04988f82cad1b3$export$afc2e57c475b7810.fromSegments(e.noDocument.path), s = $5c04988f82cad1b3$var$ji(e.noDocument.readTime);
        n = $5c04988f82cad1b3$var$xe.newNoDocument(t, s), e.hasCommittedMutations && n.setHasCommittedMutations();
    } else {
        if (!e.unknownDocument) return $5c04988f82cad1b3$var$L();
        {
            const t = $5c04988f82cad1b3$export$afc2e57c475b7810.fromSegments(e.unknownDocument.path), s = $5c04988f82cad1b3$var$ji(e.unknownDocument.version);
            n = $5c04988f82cad1b3$var$xe.newUnknownDocument(t, s);
        }
    }
    return e.readTime && n.setReadTime(function(t) {
        const e = new $5c04988f82cad1b3$export$d9bcbd5e1ff81430(t[0], t[1]);
        return $5c04988f82cad1b3$var$ct.fromTimestamp(e);
    }(e.readTime)), n;
}
/** Encodes a document for storage locally. */ function $5c04988f82cad1b3$var$Ki(t, e) {
    const n = e.key, s = {
        prefixPath: n.getCollectionPath().popLast().toArray(),
        collectionGroup: n.collectionGroup,
        documentId: n.path.lastSegment(),
        readTime: $5c04988f82cad1b3$var$Gi(e.readTime),
        hasCommittedMutations: e.hasCommittedMutations
    };
    if (e.isFoundDocument()) s.document = function(t, e) {
        return {
            name: $5c04988f82cad1b3$var$Ms(t, e.key),
            fields: e.data.value.mapValue.fields,
            updateTime: $5c04988f82cad1b3$var$Ds(t, e.version.toTimestamp())
        };
    }(t.ne, e);
    else if (e.isNoDocument()) s.noDocument = {
        path: n.path.toArray(),
        readTime: $5c04988f82cad1b3$var$Qi(e.version)
    };
    else {
        if (!e.isUnknownDocument()) return $5c04988f82cad1b3$var$L();
        s.unknownDocument = {
            path: n.path.toArray(),
            version: $5c04988f82cad1b3$var$Qi(e.version)
        };
    }
    return s;
}
function $5c04988f82cad1b3$var$Gi(t) {
    const e = t.toTimestamp();
    return [
        e.seconds,
        e.nanoseconds
    ];
}
function $5c04988f82cad1b3$var$Qi(t) {
    const e = t.toTimestamp();
    return {
        seconds: e.seconds,
        nanoseconds: e.nanoseconds
    };
}
function $5c04988f82cad1b3$var$ji(t) {
    const e = new $5c04988f82cad1b3$export$d9bcbd5e1ff81430(t.seconds, t.nanoseconds);
    return $5c04988f82cad1b3$var$ct.fromTimestamp(e);
}
/** Encodes a batch of mutations into a DbMutationBatch for local storage. */ /** Decodes a DbMutationBatch into a MutationBatch */ function $5c04988f82cad1b3$var$Wi(t, e) {
    const n = (e.baseMutations || []).map((e)=>$5c04988f82cad1b3$var$Ws(t.ne, e));
    // Squash old transform mutations into existing patch or set mutations.
    // The replacement of representing `transforms` with `update_transforms`
    // on the SDK means that old `transform` mutations stored in IndexedDB need
    // to be updated to `update_transforms`.
    // TODO(b/174608374): Remove this code once we perform a schema migration.
    for(let t = 0; t < e.mutations.length - 1; ++t){
        const n = e.mutations[t];
        if (t + 1 < e.mutations.length && void 0 !== e.mutations[t + 1].transform) {
            const s = e.mutations[t + 1];
            n.updateTransforms = s.transform.fieldTransforms, e.mutations.splice(t + 1, 1), ++t;
        }
    }
    const s = e.mutations.map((e)=>$5c04988f82cad1b3$var$Ws(t.ne, e)), i = $5c04988f82cad1b3$export$d9bcbd5e1ff81430.fromMillis(e.localWriteTimeMs);
    return new $5c04988f82cad1b3$var$Fi(e.batchId, i, n, s);
}
/** Decodes a DbTarget into TargetData */ function $5c04988f82cad1b3$var$zi(t) {
    const e = $5c04988f82cad1b3$var$ji(t.readTime), n = void 0 !== t.lastLimboFreeSnapshotVersion ? $5c04988f82cad1b3$var$ji(t.lastLimboFreeSnapshotVersion) : $5c04988f82cad1b3$var$ct.min();
    let s;
    var i;
    return void 0 !== t.query.documents ? ($5c04988f82cad1b3$var$U(1 === (i = t.query).documents.length), s = $5c04988f82cad1b3$var$ln($5c04988f82cad1b3$var$rn($5c04988f82cad1b3$var$Bs(i.documents[0])))) : s = function(t) {
        return $5c04988f82cad1b3$var$ln($5c04988f82cad1b3$var$Ys(t));
    }(t.query), new $5c04988f82cad1b3$var$Li(s, t.targetId, 0 /* Listen */ , t.lastListenSequenceNumber, e, n, $5c04988f82cad1b3$var$Jt.fromBase64String(t.resumeToken));
}
/** Encodes TargetData into a DbTarget for storage locally. */ function $5c04988f82cad1b3$var$Hi(t, e) {
    const n = $5c04988f82cad1b3$var$Qi(e.snapshotVersion), s = $5c04988f82cad1b3$var$Qi(e.lastLimboFreeSnapshotVersion);
    let i;
    i = $5c04988f82cad1b3$var$$e(e.target) ? $5c04988f82cad1b3$var$Hs(t.ne, e.target) : $5c04988f82cad1b3$var$Js(t.ne, e.target);
    // We can't store the resumeToken as a ByteString in IndexedDb, so we
    // convert it to a base64 string for storage.
    const r = e.resumeToken.toBase64();
    // lastListenSequenceNumber is always 0 until we do real GC.
    return {
        targetId: e.targetId,
        canonicalId: $5c04988f82cad1b3$var$Oe(e.target),
        readTime: n,
        resumeToken: r,
        lastListenSequenceNumber: e.sequenceNumber,
        lastLimboFreeSnapshotVersion: s,
        query: i
    };
}
/**
 * A helper function for figuring out what kind of query has been stored.
 */ /**
 * Encodes a `BundledQuery` from bundle proto to a Query object.
 *
 * This reconstructs the original query used to build the bundle being loaded,
 * including features exists only in SDKs (for example: limit-to-last).
 */ function $5c04988f82cad1b3$var$Ji(t) {
    const e = $5c04988f82cad1b3$var$Ys({
        parent: t.parent,
        structuredQuery: t.structuredQuery
    });
    return "LAST" === t.limitType ? $5c04988f82cad1b3$var$fn(e, e.limit, "L" /* Last */ ) : e;
}
/** Encodes a NamedQuery proto object to a NamedQuery model object. */ /** Encodes a DbDocumentOverlay object to an Overlay model object. */ function $5c04988f82cad1b3$var$Yi(t, e) {
    return new $5c04988f82cad1b3$var$Bi(e.largestBatchId, $5c04988f82cad1b3$var$Ws(t.ne, e.overlayMutation));
}
/** Decodes an Overlay model object into a DbDocumentOverlay object. */ /**
 * Returns the DbDocumentOverlayKey corresponding to the given user and
 * document key.
 */ function $5c04988f82cad1b3$var$Xi(t, e) {
    const n = e.path.lastSegment();
    return [
        t,
        $5c04988f82cad1b3$var$ci(e.path.popLast()),
        n
    ];
}
function $5c04988f82cad1b3$var$Zi(t, e, n, s) {
    return {
        indexId: t,
        uid: e.uid || "",
        sequenceNumber: n,
        readTime: $5c04988f82cad1b3$var$Qi(s.readTime),
        documentKey: $5c04988f82cad1b3$var$ci(s.documentKey.path),
        largestBatchId: s.largestBatchId
    };
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $5c04988f82cad1b3$var$tr {
    getBundleMetadata(t, e) {
        return $5c04988f82cad1b3$var$er(t).get(e).next((t)=>{
            if (t) return {
                id: (e = t).bundleId,
                createTime: $5c04988f82cad1b3$var$ji(e.createTime),
                version: e.version
            };
            /** Encodes a DbBundle to a BundleMetadata object. */ var e;
        /** Encodes a BundleMetadata to a DbBundle. */ });
    }
    saveBundleMetadata(t, e) {
        var n;
        return $5c04988f82cad1b3$var$er(t).put({
            bundleId: (n = e).id,
            createTime: $5c04988f82cad1b3$var$Qi($5c04988f82cad1b3$var$Ns(n.createTime)),
            version: n.version
        });
    /** Encodes a DbNamedQuery to a NamedQuery. */ }
    getNamedQuery(t, e) {
        return $5c04988f82cad1b3$var$nr(t).get(e).next((t)=>{
            if (t) return {
                name: (e = t).name,
                query: $5c04988f82cad1b3$var$Ji(e.bundledQuery),
                readTime: $5c04988f82cad1b3$var$ji(e.readTime)
            };
            var e;
        /** Encodes a NamedQuery from a bundle proto to a DbNamedQuery. */ });
    }
    saveNamedQuery(t, e) {
        return $5c04988f82cad1b3$var$nr(t).put(function(t) {
            return {
                name: t.name,
                readTime: $5c04988f82cad1b3$var$Qi($5c04988f82cad1b3$var$Ns(t.readTime)),
                bundledQuery: t.bundledQuery
            };
        }(e));
    }
}
/**
 * Helper to get a typed SimpleDbStore for the bundles object store.
 */ function $5c04988f82cad1b3$var$er(t) {
    return $5c04988f82cad1b3$var$Mi(t, "bundles");
}
/**
 * Helper to get a typed SimpleDbStore for the namedQueries object store.
 */ function $5c04988f82cad1b3$var$nr(t) {
    return $5c04988f82cad1b3$var$Mi(t, "namedQueries");
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Implementation of DocumentOverlayCache using IndexedDb.
 */ class $5c04988f82cad1b3$var$sr {
    static se(t, e) {
        const n = e.uid || "";
        return new $5c04988f82cad1b3$var$sr(t, n);
    }
    getOverlay(t, e) {
        return $5c04988f82cad1b3$var$ir(t).get($5c04988f82cad1b3$var$Xi(this.userId, e)).next((t)=>t ? $5c04988f82cad1b3$var$Yi(this.wt, t) : null);
    }
    getOverlays(t, e) {
        const n = $5c04988f82cad1b3$var$hs();
        return $5c04988f82cad1b3$var$Pt.forEach(e, (e)=>this.getOverlay(t, e).next((t)=>{
                null !== t && n.set(e, t);
            })).next(()=>n);
    }
    saveOverlays(t, e, n) {
        const s = [];
        return n.forEach((n, i)=>{
            const r = new $5c04988f82cad1b3$var$Bi(e, i);
            s.push(this.ie(t, r));
        }), $5c04988f82cad1b3$var$Pt.waitFor(s);
    }
    removeOverlaysForBatchId(t, e, n) {
        const s = new Set;
        // Get the set of unique collection paths.
        e.forEach((t)=>s.add($5c04988f82cad1b3$var$ci(t.getCollectionPath())));
        const i = [];
        return s.forEach((e)=>{
            const s = IDBKeyRange.bound([
                this.userId,
                e,
                n
            ], [
                this.userId,
                e,
                n + 1
            ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0);
            i.push($5c04988f82cad1b3$var$ir(t).W("collectionPathOverlayIndex", s));
        }), $5c04988f82cad1b3$var$Pt.waitFor(i);
    }
    getOverlaysForCollection(t, e, n) {
        const s = $5c04988f82cad1b3$var$hs(), i = $5c04988f82cad1b3$var$ci(e), r = IDBKeyRange.bound([
            this.userId,
            i,
            n
        ], [
            this.userId,
            i,
            Number.POSITIVE_INFINITY
        ], /*lowerOpen=*/ !0);
        return $5c04988f82cad1b3$var$ir(t).K("collectionPathOverlayIndex", r).next((t)=>{
            for (const e of t){
                const t = $5c04988f82cad1b3$var$Yi(this.wt, e);
                s.set(t.getKey(), t);
            }
            return s;
        });
    }
    getOverlaysForCollectionGroup(t, e, n, s) {
        const i = $5c04988f82cad1b3$var$hs();
        let r;
        // We want batch IDs larger than `sinceBatchId`, and so the lower bound
        // is not inclusive.
        const o = IDBKeyRange.bound([
            this.userId,
            e,
            n
        ], [
            this.userId,
            e,
            Number.POSITIVE_INFINITY
        ], /*lowerOpen=*/ !0);
        return $5c04988f82cad1b3$var$ir(t).J({
            index: "collectionGroupOverlayIndex",
            range: o
        }, (t, e, n)=>{
            // We do not want to return partial batch overlays, even if the size
            // of the result set exceeds the given `count` argument. Therefore, we
            // continue to aggregate results even after the result size exceeds
            // `count` if there are more overlays from the `currentBatchId`.
            const o = $5c04988f82cad1b3$var$Yi(this.wt, e);
            i.size() < s || o.largestBatchId === r ? (i.set(o.getKey(), o), r = o.largestBatchId) : n.done();
        }).next(()=>i);
    }
    ie(t, e) {
        return $5c04988f82cad1b3$var$ir(t).put(function(t, e, n) {
            const [s, i, r] = $5c04988f82cad1b3$var$Xi(e, n.mutation.key);
            return {
                userId: e,
                collectionPath: i,
                documentId: r,
                collectionGroup: n.mutation.key.getCollectionGroup(),
                largestBatchId: n.largestBatchId,
                overlayMutation: $5c04988f82cad1b3$var$js(t.ne, n.mutation)
            };
        }(this.wt, this.userId, e));
    }
    /**
     * @param serializer - The document serializer.
     * @param userId - The userId for which we are accessing overlays.
     */ constructor(t, e){
        this.wt = t, this.userId = e;
    }
}
/**
 * Helper to get a typed SimpleDbStore for the document overlay object store.
 */ function $5c04988f82cad1b3$var$ir(t) {
    return $5c04988f82cad1b3$var$Mi(t, "documentOverlays");
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Note: This code is copied from the backend. Code that is not used by
// Firestore was removed.
/** Firestore index value writer.  */ class $5c04988f82cad1b3$var$rr {
    // The write methods below short-circuit writing terminators for values
    // containing a (terminating) truncated value.
    // As an example, consider the resulting encoding for:
    // ["bar", [2, "foo"]] -> (STRING, "bar", TERM, ARRAY, NUMBER, 2, STRING, "foo", TERM, TERM, TERM)
    // ["bar", [2, truncated("foo")]] -> (STRING, "bar", TERM, ARRAY, NUMBER, 2, STRING, "foo", TRUNC)
    // ["bar", truncated(["foo"])] -> (STRING, "bar", TERM, ARRAY. STRING, "foo", TERM, TRUNC)
    /** Writes an index value.  */ re(t, e) {
        this.oe(t, e), // Write separator to split index values
        // (see go/firestore-storage-format#encodings).
        e.ue();
    }
    oe(t, e) {
        if ("nullValue" in t) this.ce(e, 5);
        else if ("booleanValue" in t) this.ce(e, 10), e.ae(t.booleanValue ? 1 : 0);
        else if ("integerValue" in t) this.ce(e, 15), e.ae($5c04988f82cad1b3$var$Zt(t.integerValue));
        else if ("doubleValue" in t) {
            const n = $5c04988f82cad1b3$var$Zt(t.doubleValue);
            isNaN(n) ? this.ce(e, 13) : (this.ce(e, 15), $5c04988f82cad1b3$var$ue(n) ? // -0.0, 0 and 0.0 are all considered the same
            e.ae(0) : e.ae(n));
        } else if ("timestampValue" in t) {
            const n = t.timestampValue;
            this.ce(e, 20), "string" == typeof n ? e.he(n) : (e.he(`${n.seconds || ""}`), e.ae(n.nanos || 0));
        } else if ("stringValue" in t) this.le(t.stringValue, e), this.fe(e);
        else if ("bytesValue" in t) this.ce(e, 30), e.de($5c04988f82cad1b3$var$te(t.bytesValue)), this.fe(e);
        else if ("referenceValue" in t) this._e(t.referenceValue, e);
        else if ("geoPointValue" in t) {
            const n = t.geoPointValue;
            this.ce(e, 45), e.ae(n.latitude || 0), e.ae(n.longitude || 0);
        } else "mapValue" in t ? $5c04988f82cad1b3$var$be(t) ? this.ce(e, Number.MAX_SAFE_INTEGER) : (this.we(t.mapValue, e), this.fe(e)) : "arrayValue" in t ? (this.me(t.arrayValue, e), this.fe(e)) : $5c04988f82cad1b3$var$L();
    }
    le(t, e) {
        this.ce(e, 25), this.ge(t, e);
    }
    ge(t, e) {
        e.he(t);
    }
    we(t, e) {
        const n = t.fields || {};
        this.ce(e, 55);
        for (const t of Object.keys(n))this.le(t, e), this.oe(n[t], e);
    }
    me(t, e) {
        const n = t.values || [];
        this.ce(e, 50);
        for (const t of n)this.oe(t, e);
    }
    _e(t, e) {
        this.ce(e, 37);
        $5c04988f82cad1b3$export$afc2e57c475b7810.fromName(t).path.forEach((t)=>{
            this.ce(e, 60), this.ge(t, e);
        });
    }
    ce(t, e) {
        t.ae(e);
    }
    fe(t) {
        // While the SDK does not implement truncation, the truncation marker is
        // used to terminate all variable length values (which are strings, bytes,
        // references, arrays and maps).
        t.ae(2);
    }
    constructor(){}
}
$5c04988f82cad1b3$var$rr.ye = new $5c04988f82cad1b3$var$rr;
/**
 * Counts the number of zeros in a byte.
 *
 * Visible for testing.
 */ function $5c04988f82cad1b3$var$or(t) {
    if (0 === t) return 8;
    let e = 0;
    return t >> 4 == 0 && // Test if the first four bits are zero.
    (e += 4, t <<= 4), t >> 6 == 0 && // Test if the first two (or next two) bits are zero.
    (e += 2, t <<= 2), t >> 7 == 0 && // Test if the remaining bit is zero.
    (e += 1), e;
}
/** Counts the number of leading zeros in the given byte array. */ /**
 * Returns the number of bytes required to store "value". Leading zero bytes
 * are skipped.
 */ function $5c04988f82cad1b3$var$ur(t) {
    // This is just the number of bytes for the unsigned representation of the number.
    const e = 64 - function(t) {
        let e = 0;
        for(let n = 0; n < 8; ++n){
            const s = $5c04988f82cad1b3$var$or(255 & t[n]);
            if (e += s, 8 !== s) break;
        }
        return e;
    }(t);
    return Math.ceil(e / 8);
}
/**
 * OrderedCodeWriter is a minimal-allocation implementation of the writing
 * behavior defined by the backend.
 *
 * The code is ported from its Java counterpart.
 */ class $5c04988f82cad1b3$var$cr {
    pe(t) {
        const e = t[Symbol.iterator]();
        let n = e.next();
        for(; !n.done;)this.Ie(n.value), n = e.next();
        this.Te();
    }
    Ee(t) {
        const e = t[Symbol.iterator]();
        let n = e.next();
        for(; !n.done;)this.Ae(n.value), n = e.next();
        this.Re();
    }
    /** Writes utf8 bytes into this byte sequence, ascending. */ be(t) {
        for (const e of t){
            const t = e.charCodeAt(0);
            if (t < 128) this.Ie(t);
            else if (t < 2048) this.Ie(960 | t >>> 6), this.Ie(128 | 63 & t);
            else if (e < "\ud800" || "\udbff" < e) this.Ie(480 | t >>> 12), this.Ie(128 | 63 & t >>> 6), this.Ie(128 | 63 & t);
            else {
                const t = e.codePointAt(0);
                this.Ie(240 | t >>> 18), this.Ie(128 | 63 & t >>> 12), this.Ie(128 | 63 & t >>> 6), this.Ie(128 | 63 & t);
            }
        }
        this.Te();
    }
    /** Writes utf8 bytes into this byte sequence, descending */ Pe(t) {
        for (const e of t){
            const t = e.charCodeAt(0);
            if (t < 128) this.Ae(t);
            else if (t < 2048) this.Ae(960 | t >>> 6), this.Ae(128 | 63 & t);
            else if (e < "\ud800" || "\udbff" < e) this.Ae(480 | t >>> 12), this.Ae(128 | 63 & t >>> 6), this.Ae(128 | 63 & t);
            else {
                const t = e.codePointAt(0);
                this.Ae(240 | t >>> 18), this.Ae(128 | 63 & t >>> 12), this.Ae(128 | 63 & t >>> 6), this.Ae(128 | 63 & t);
            }
        }
        this.Re();
    }
    ve(t) {
        // Values are encoded with a single byte length prefix, followed by the
        // actual value in big-endian format with leading 0 bytes dropped.
        const e = this.Ve(t), n = $5c04988f82cad1b3$var$ur(e);
        this.Se(1 + n), this.buffer[this.position++] = 255 & n;
        // Write the length
        for(let t = e.length - n; t < e.length; ++t)this.buffer[this.position++] = 255 & e[t];
    }
    De(t) {
        // Values are encoded with a single byte length prefix, followed by the
        // inverted value in big-endian format with leading 0 bytes dropped.
        const e = this.Ve(t), n = $5c04988f82cad1b3$var$ur(e);
        this.Se(1 + n), this.buffer[this.position++] = ~(255 & n);
        // Write the length
        for(let t = e.length - n; t < e.length; ++t)this.buffer[this.position++] = ~(255 & e[t]);
    }
    /**
     * Writes the "infinity" byte sequence that sorts after all other byte
     * sequences written in ascending order.
     */ Ce() {
        this.xe(255), this.xe(255);
    }
    /**
     * Writes the "infinity" byte sequence that sorts before all other byte
     * sequences written in descending order.
     */ Ne() {
        this.ke(255), this.ke(255);
    }
    /**
     * Resets the buffer such that it is the same as when it was newly
     * constructed.
     */ reset() {
        this.position = 0;
    }
    seed(t) {
        this.Se(t.length), this.buffer.set(t, this.position), this.position += t.length;
    }
    /** Makes a copy of the encoded bytes in this buffer.  */ Oe() {
        return this.buffer.slice(0, this.position);
    }
    /**
     * Encodes `val` into an encoding so that the order matches the IEEE 754
     * floating-point comparison results with the following exceptions:
     *   -0.0 < 0.0
     *   all non-NaN < NaN
     *   NaN = NaN
     */ Ve(t) {
        const e = /** Converts a JavaScript number to a byte array (using big endian encoding). */ function(t) {
            const e = new DataView(new ArrayBuffer(8));
            return e.setFloat64(0, t, /* littleEndian= */ !1), new Uint8Array(e.buffer);
        }(t), n = 0 != (128 & e[0]);
        // Check if the first bit is set. We use a bit mask since value[0] is
        // encoded as a number from 0 to 255.
        // Revert the two complement to get natural ordering
        e[0] ^= n ? 255 : 128;
        for(let t = 1; t < e.length; ++t)e[t] ^= n ? 255 : 0;
        return e;
    }
    /** Writes a single byte ascending to the buffer. */ Ie(t) {
        const e = 255 & t;
        0 === e ? (this.xe(0), this.xe(255)) : 255 === e ? (this.xe(255), this.xe(0)) : this.xe(e);
    }
    /** Writes a single byte descending to the buffer.  */ Ae(t) {
        const e = 255 & t;
        0 === e ? (this.ke(0), this.ke(255)) : 255 === e ? (this.ke(255), this.ke(0)) : this.ke(t);
    }
    Te() {
        this.xe(0), this.xe(1);
    }
    Re() {
        this.ke(0), this.ke(1);
    }
    xe(t) {
        this.Se(1), this.buffer[this.position++] = t;
    }
    ke(t) {
        this.Se(1), this.buffer[this.position++] = ~t;
    }
    Se(t) {
        const e = t + this.position;
        if (e <= this.buffer.length) return;
        // Try doubling.
        let n = 2 * this.buffer.length;
        // Still not big enough? Just allocate the right size.
        n < e && (n = e);
        // Create the new buffer.
        const s = new Uint8Array(n);
        s.set(this.buffer), this.buffer = s;
    }
    constructor(){
        this.buffer = new Uint8Array(1024), this.position = 0;
    }
}
class $5c04988f82cad1b3$var$ar {
    de(t) {
        this.Me.pe(t);
    }
    he(t) {
        this.Me.be(t);
    }
    ae(t) {
        this.Me.ve(t);
    }
    ue() {
        this.Me.Ce();
    }
    constructor(t){
        this.Me = t;
    }
}
class $5c04988f82cad1b3$var$hr {
    de(t) {
        this.Me.Ee(t);
    }
    he(t) {
        this.Me.Pe(t);
    }
    ae(t) {
        this.Me.De(t);
    }
    ue() {
        this.Me.Ne();
    }
    constructor(t){
        this.Me = t;
    }
}
/**
 * Implements `DirectionalIndexByteEncoder` using `OrderedCodeWriter` for the
 * actual encoding.
 */ class $5c04988f82cad1b3$var$lr {
    seed(t) {
        this.Me.seed(t);
    }
    Be(t) {
        return 0 /* ASCENDING */  === t ? this.Fe : this.$e;
    }
    Oe() {
        return this.Me.Oe();
    }
    reset() {
        this.Me.reset();
    }
    constructor(){
        this.Me = new $5c04988f82cad1b3$var$cr, this.Fe = new $5c04988f82cad1b3$var$ar(this.Me), this.$e = new $5c04988f82cad1b3$var$hr(this.Me);
    }
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Represents an index entry saved by the SDK in persisted storage. */ class $5c04988f82cad1b3$var$fr {
    /**
     * Returns an IndexEntry entry that sorts immediately after the current
     * directional value.
     */ Le() {
        const t = this.directionalValue.length, e = 0 === t || 255 === this.directionalValue[t - 1] ? t + 1 : t, n = new Uint8Array(e);
        return n.set(this.directionalValue, 0), e !== t ? n.set([
            0
        ], this.directionalValue.length) : ++n[n.length - 1], new $5c04988f82cad1b3$var$fr(this.indexId, this.documentKey, this.arrayValue, n);
    }
    constructor(t, e, n, s){
        this.indexId = t, this.documentKey = e, this.arrayValue = n, this.directionalValue = s;
    }
}
function $5c04988f82cad1b3$var$dr(t, e) {
    let n = t.indexId - e.indexId;
    return 0 !== n ? n : (n = $5c04988f82cad1b3$var$_r(t.arrayValue, e.arrayValue), 0 !== n ? n : (n = $5c04988f82cad1b3$var$_r(t.directionalValue, e.directionalValue), 0 !== n ? n : $5c04988f82cad1b3$export$afc2e57c475b7810.comparator(t.documentKey, e.documentKey)));
}
function $5c04988f82cad1b3$var$_r(t, e) {
    for(let n = 0; n < t.length && n < e.length; ++n){
        const s = t[n] - e[n];
        if (0 !== s) return s;
    }
    return t.length - e.length;
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A light query planner for Firestore.
 *
 * This class matches a `FieldIndex` against a Firestore Query `Target`. It
 * determines whether a given index can be used to serve the specified target.
 *
 * The following table showcases some possible index configurations:
 *
 * Query                                               | Index
 * -----------------------------------------------------------------------------
 * where('a', '==', 'a').where('b', '==', 'b')         | a ASC, b DESC
 * where('a', '==', 'a').where('b', '==', 'b')         | a ASC
 * where('a', '==', 'a').where('b', '==', 'b')         | b DESC
 * where('a', '>=', 'a').orderBy('a')                  | a ASC
 * where('a', '>=', 'a').orderBy('a', 'desc')          | a DESC
 * where('a', '>=', 'a').orderBy('a').orderBy('b')     | a ASC, b ASC
 * where('a', '>=', 'a').orderBy('a').orderBy('b')     | a ASC
 * where('a', 'array-contains', 'a').orderBy('b')      | a CONTAINS, b ASCENDING
 * where('a', 'array-contains', 'a').orderBy('b')      | a CONTAINS
 */ class $5c04988f82cad1b3$var$wr {
    /**
     * Returns whether the index can be used to serve the TargetIndexMatcher's
     * target.
     *
     * An index is considered capable of serving the target when:
     * - The target uses all index segments for its filters and orderBy clauses.
     *   The target can have additional filter and orderBy clauses, but not
     *   fewer.
     * - If an ArrayContains/ArrayContainsAnyfilter is used, the index must also
     *   have a corresponding `CONTAINS` segment.
     * - All directional index segments can be mapped to the target as a series of
     *   equality filters, a single inequality filter and a series of orderBy
     *   clauses.
     * - The segments that represent the equality filters may appear out of order.
     * - The optional segment for the inequality filter must appear after all
     *   equality segments.
     * - The segments that represent that orderBy clause of the target must appear
     *   in order after all equality and inequality segments. Single orderBy
     *   clauses cannot be skipped, but a continuous orderBy suffix may be
     *   omitted.
     */ Ge(t) {
        // If there is an array element, find a matching filter.
        const e = $5c04988f82cad1b3$var$wt(t);
        if (void 0 !== e && !this.Qe(e)) return !1;
        const n = $5c04988f82cad1b3$var$mt(t);
        let s = 0, i = 0;
        // Process all equalities first. Equalities can appear out of order.
        for(; s < n.length && this.Qe(n[s]); ++s);
        // If we already have processed all segments, all segments are used to serve
        // the equality filters and we do not need to map any segments to the
        // target's inequality and orderBy clauses.
        if (s === n.length) return !0;
        // If there is an inequality filter, the next segment must match both the
        // filter and the first orderBy clause.
        if (void 0 !== this.Ke) {
            const t = n[s];
            if (!this.je(this.Ke, t) || !this.We(this.Ue[i++], t)) return !1;
            ++s;
        }
        // All remaining segments need to represent the prefix of the target's
        // orderBy.
        for(; s < n.length; ++s){
            const t = n[s];
            if (i >= this.Ue.length || !this.We(this.Ue[i++], t)) return !1;
        }
        return !0;
    }
    Qe(t) {
        for (const e of this.qe)if (this.je(e, t)) return !0;
        return !1;
    }
    je(t, e) {
        if (void 0 === t || !t.field.isEqual(e.fieldPath)) return !1;
        const n = "array-contains" /* ARRAY_CONTAINS */  === t.op || "array-contains-any" /* ARRAY_CONTAINS_ANY */  === t.op;
        return 2 /* CONTAINS */  === e.kind === n;
    }
    We(t, e) {
        return !!t.field.isEqual(e.fieldPath) && (0 /* ASCENDING */  === e.kind && "asc" /* ASCENDING */  === t.dir || 1 /* DESCENDING */  === e.kind && "desc" /* DESCENDING */  === t.dir);
    }
    constructor(t){
        this.collectionId = null != t.collectionGroup ? t.collectionGroup : t.path.lastSegment(), this.Ue = t.orderBy, this.qe = [];
        for (const e of t.filters){
            const t = e;
            t.ht() ? this.Ke = t : this.qe.push(t);
        }
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An in-memory implementation of IndexManager.
 */ class $5c04988f82cad1b3$var$mr {
    addToCollectionParentIndex(t, e) {
        return this.ze.add(e), $5c04988f82cad1b3$var$Pt.resolve();
    }
    getCollectionParents(t, e) {
        return $5c04988f82cad1b3$var$Pt.resolve(this.ze.getEntries(e));
    }
    addFieldIndex(t, e) {
        // Field indices are not supported with memory persistence.
        return $5c04988f82cad1b3$var$Pt.resolve();
    }
    deleteFieldIndex(t, e) {
        // Field indices are not supported with memory persistence.
        return $5c04988f82cad1b3$var$Pt.resolve();
    }
    getDocumentsMatchingTarget(t, e) {
        // Field indices are not supported with memory persistence.
        return $5c04988f82cad1b3$var$Pt.resolve(null);
    }
    getIndexType(t, e) {
        // Field indices are not supported with memory persistence.
        return $5c04988f82cad1b3$var$Pt.resolve(0 /* NONE */ );
    }
    getFieldIndexes(t, e) {
        // Field indices are not supported with memory persistence.
        return $5c04988f82cad1b3$var$Pt.resolve([]);
    }
    getNextCollectionGroupToUpdate(t) {
        // Field indices are not supported with memory persistence.
        return $5c04988f82cad1b3$var$Pt.resolve(null);
    }
    getMinOffset(t, e) {
        return $5c04988f82cad1b3$var$Pt.resolve($5c04988f82cad1b3$var$Tt.min());
    }
    getMinOffsetFromCollectionGroup(t, e) {
        return $5c04988f82cad1b3$var$Pt.resolve($5c04988f82cad1b3$var$Tt.min());
    }
    updateCollectionGroup(t, e, n) {
        // Field indices are not supported with memory persistence.
        return $5c04988f82cad1b3$var$Pt.resolve();
    }
    updateIndexEntries(t, e) {
        // Field indices are not supported with memory persistence.
        return $5c04988f82cad1b3$var$Pt.resolve();
    }
    constructor(){
        this.ze = new $5c04988f82cad1b3$var$gr;
    }
}
/**
 * Internal implementation of the collection-parent index exposed by MemoryIndexManager.
 * Also used for in-memory caching by IndexedDbIndexManager and initial index population
 * in indexeddb_schema.ts
 */ class $5c04988f82cad1b3$var$gr {
    // Returns false if the entry already existed.
    add(t) {
        const e = t.lastSegment(), n = t.popLast(), s = this.index[e] || new $5c04988f82cad1b3$var$Qt($5c04988f82cad1b3$var$ht.comparator), i = !s.has(n);
        return this.index[e] = s.add(n), i;
    }
    has(t) {
        const e = t.lastSegment(), n = t.popLast(), s = this.index[e];
        return s && s.has(n);
    }
    getEntries(t) {
        return (this.index[t] || new $5c04988f82cad1b3$var$Qt($5c04988f82cad1b3$var$ht.comparator)).toArray();
    }
    constructor(){
        this.index = {};
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $5c04988f82cad1b3$var$yr = new Uint8Array(0);
/**
 * A persisted implementation of IndexManager.
 *
 * PORTING NOTE: Unlike iOS and Android, the Web SDK does not memoize index
 * data as it supports multi-tab access.
 */ class $5c04988f82cad1b3$var$pr {
    /**
     * Adds a new entry to the collection parent index.
     *
     * Repeated calls for the same collectionPath should be avoided within a
     * transaction as IndexedDbIndexManager only caches writes once a transaction
     * has been committed.
     */ addToCollectionParentIndex(t, e) {
        if (!this.He.has(e)) {
            const n = e.lastSegment(), s = e.popLast();
            t.addOnCommittedListener(()=>{
                // Add the collection to the in memory cache only if the transaction was
                // successfully committed.
                this.He.add(e);
            });
            const i = {
                collectionId: n,
                parent: $5c04988f82cad1b3$var$ci(s)
            };
            return $5c04988f82cad1b3$var$Ir(t).put(i);
        }
        return $5c04988f82cad1b3$var$Pt.resolve();
    }
    getCollectionParents(t, e) {
        const n = [], s = IDBKeyRange.bound([
            e,
            ""
        ], [
            $5c04988f82cad1b3$var$ot(e),
            ""
        ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0);
        return $5c04988f82cad1b3$var$Ir(t).K(s).next((t)=>{
            for (const s of t){
                // This collectionId guard shouldn't be necessary (and isn't as long
                // as we're running in a real browser), but there's a bug in
                // indexeddbshim that breaks our range in our tests running in node:
                // https://github.com/axemclion/IndexedDBShim/issues/334
                if (s.collectionId !== e) break;
                n.push($5c04988f82cad1b3$var$li(s.parent));
            }
            return n;
        });
    }
    addFieldIndex(t, e) {
        // TODO(indexing): Verify that the auto-incrementing index ID works in
        // Safari & Firefox.
        const n = $5c04988f82cad1b3$var$Er(t), s = function(t) {
            return {
                indexId: t.indexId,
                collectionGroup: t.collectionGroup,
                fields: t.fields.map((t)=>[
                        t.fieldPath.canonicalString(),
                        t.kind
                    ])
            };
        }(e);
        delete s.indexId;
        // `indexId` is auto-populated by IndexedDb
        const i = n.add(s);
        if (e.indexState) {
            const n = $5c04988f82cad1b3$var$Ar(t);
            return i.next((t)=>{
                n.put($5c04988f82cad1b3$var$Zi(t, this.user, e.indexState.sequenceNumber, e.indexState.offset));
            });
        }
        return i.next();
    }
    deleteFieldIndex(t, e) {
        const n = $5c04988f82cad1b3$var$Er(t), s = $5c04988f82cad1b3$var$Ar(t), i = $5c04988f82cad1b3$var$Tr(t);
        return n.delete(e.indexId).next(()=>s.delete(IDBKeyRange.bound([
                e.indexId
            ], [
                e.indexId + 1
            ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0))).next(()=>i.delete(IDBKeyRange.bound([
                e.indexId
            ], [
                e.indexId + 1
            ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0)));
    }
    getDocumentsMatchingTarget(t, e) {
        const n = $5c04988f82cad1b3$var$Tr(t);
        let s = !0;
        const i = new Map;
        return $5c04988f82cad1b3$var$Pt.forEach(this.Ye(e), (e)=>this.Xe(t, e).next((t)=>{
                s && (s = !!t), i.set(e, t);
            })).next(()=>{
            if (s) {
                let t = $5c04988f82cad1b3$var$ws();
                const s = [];
                return $5c04988f82cad1b3$var$Pt.forEach(i, (i, r)=>{
                    /** Returns a debug representation of the field index */ var o;
                    $5c04988f82cad1b3$var$M("IndexedDbIndexManager", `Using index ${(o = i, `id=${o.indexId}|cg=${o.collectionGroup}|f=${o.fields.map((t)=>`${t.fieldPath}:${t.kind}`).join(",")}`)} to execute ${$5c04988f82cad1b3$var$Oe(e)}`);
                    const u = function(t, e) {
                        const n = $5c04988f82cad1b3$var$wt(e);
                        if (void 0 === n) return null;
                        for (const e of $5c04988f82cad1b3$var$Be(t, n.fieldPath))switch(e.op){
                            case "array-contains-any" /* ARRAY_CONTAINS_ANY */ :
                                return e.value.arrayValue.values || [];
                            case "array-contains" /* ARRAY_CONTAINS */ :
                                return [
                                    e.value
                                ];
                        }
                        return null;
                    }(r, i), c = function(t, e) {
                        const n = new Map;
                        for (const s of $5c04988f82cad1b3$var$mt(e))for (const e of $5c04988f82cad1b3$var$Be(t, s.fieldPath))switch(e.op){
                            case "==" /* EQUAL */ :
                            case "in" /* IN */ :
                                // Encode equality prefix, which is encoded in the index value before
                                // the inequality (e.g. `a == 'a' && b != 'b'` is encoded to
                                // `value != 'ab'`).
                                n.set(s.fieldPath.canonicalString(), e.value);
                                break;
                            case "not-in" /* NOT_IN */ :
                            case "!=" /* NOT_EQUAL */ :
                                // NotIn/NotEqual is always a suffix. There cannot be any remaining
                                // segments and hence we can return early here.
                                return n.set(s.fieldPath.canonicalString(), e.value), Array.from(n.values());
                        }
                        return null;
                    }(r, i), a = function(t, e) {
                        const n = [];
                        let s = !0;
                        // For each segment, retrieve a lower bound if there is a suitable filter or
                        // startAt.
                        for (const i of $5c04988f82cad1b3$var$mt(e)){
                            const e = 0 /* ASCENDING */  === i.kind ? $5c04988f82cad1b3$var$Le(t, i.fieldPath, t.startAt) : $5c04988f82cad1b3$var$Ue(t, i.fieldPath, t.startAt);
                            n.push(e.value), s && (s = e.inclusive);
                        }
                        return new $5c04988f82cad1b3$var$Ye(n, s);
                    }(r, i), h = function(t, e) {
                        const n = [];
                        let s = !0;
                        // For each segment, retrieve an upper bound if there is a suitable filter or
                        // endAt.
                        for (const i of $5c04988f82cad1b3$var$mt(e)){
                            const e = 0 /* ASCENDING */  === i.kind ? $5c04988f82cad1b3$var$Ue(t, i.fieldPath, t.endAt) : $5c04988f82cad1b3$var$Le(t, i.fieldPath, t.endAt);
                            n.push(e.value), s && (s = e.inclusive);
                        }
                        return new $5c04988f82cad1b3$var$Ye(n, s);
                    }(r, i), l = this.Ze(i, r, a), f = this.Ze(i, r, h), d = this.tn(i, r, c), _ = this.en(i.indexId, u, l, a.inclusive, f, h.inclusive, d);
                    return $5c04988f82cad1b3$var$Pt.forEach(_, (i)=>n.j(i, e.limit).next((e)=>{
                            e.forEach((e)=>{
                                const n = $5c04988f82cad1b3$export$afc2e57c475b7810.fromSegments(e.documentKey);
                                t.has(n) || (t = t.add(n), s.push(n));
                            });
                        }));
                }).next(()=>s);
            }
            return $5c04988f82cad1b3$var$Pt.resolve(null);
        });
    }
    Ye(t) {
        let e = this.Je.get(t);
        return e || // TODO(orquery): Implement DNF transform
        (e = [
            t
        ], this.Je.set(t, e), e);
    }
    /**
     * Constructs a key range query on `DbIndexEntryStore` that unions all
     * bounds.
     */ en(t, e, n, s, i, r, o) {
        // The number of total index scans we union together. This is similar to a
        // distributed normal form, but adapted for array values. We create a single
        // index range per value in an ARRAY_CONTAINS or ARRAY_CONTAINS_ANY filter
        // combined with the values from the query bounds.
        const u = (null != e ? e.length : 1) * Math.max(n.length, i.length), c = u / (null != e ? e.length : 1), a = [];
        for(let h = 0; h < u; ++h){
            const u = e ? this.nn(e[h / c]) : $5c04988f82cad1b3$var$yr, l = this.sn(t, u, n[h % c], s), f = this.rn(t, u, i[h % c], r), d = o.map((e)=>this.sn(t, u, e, /* inclusive= */ !0));
            a.push(...this.createRange(l, f, d));
        }
        return a;
    }
    /** Generates the lower bound for `arrayValue` and `directionalValue`. */ sn(t, e, n, s) {
        const i = new $5c04988f82cad1b3$var$fr(t, $5c04988f82cad1b3$export$afc2e57c475b7810.empty(), e, n);
        return s ? i : i.Le();
    }
    /** Generates the upper bound for `arrayValue` and `directionalValue`. */ rn(t, e, n, s) {
        const i = new $5c04988f82cad1b3$var$fr(t, $5c04988f82cad1b3$export$afc2e57c475b7810.empty(), e, n);
        return s ? i.Le() : i;
    }
    Xe(t, e) {
        const n = new $5c04988f82cad1b3$var$wr(e), s = null != e.collectionGroup ? e.collectionGroup : e.path.lastSegment();
        return this.getFieldIndexes(t, s).next((t)=>{
            // Return the index with the most number of segments.
            let e = null;
            for (const s of t)n.Ge(s) && (!e || s.fields.length > e.fields.length) && (e = s);
            return e;
        });
    }
    getIndexType(t, e) {
        let n = 2 /* FULL */ ;
        return $5c04988f82cad1b3$var$Pt.forEach(this.Ye(e), (e)=>this.Xe(t, e).next((t)=>{
                t ? 0 /* NONE */  !== n && t.fields.length < function(t) {
                    let e = new $5c04988f82cad1b3$var$Qt($5c04988f82cad1b3$export$b7871852b967eaf1.comparator), n = !1;
                    for (const s of t.filters){
                        // TODO(orquery): Use the flattened filters here
                        const t = s;
                        // __name__ is not an explicit segment of any index, so we don't need to
                        // count it.
                        t.field.isKeyField() || // ARRAY_CONTAINS or ARRAY_CONTAINS_ANY filters must be counted separately.
                        // For instance, it is possible to have an index for "a ARRAY a ASC". Even
                        // though these are on the same field, they should be counted as two
                        // separate segments in an index.
                        ("array-contains" /* ARRAY_CONTAINS */  === t.op || "array-contains-any" /* ARRAY_CONTAINS_ANY */  === t.op ? n = !0 : e = e.add(t.field));
                    }
                    for (const n of t.orderBy)// __name__ is not an explicit segment of any index, so we don't need to
                    // count it.
                    n.field.isKeyField() || (e = e.add(n.field));
                    return e.size + (n ? 1 : 0);
                }(e) && (n = 1 /* PARTIAL */ ) : n = 0 /* NONE */ ;
            })).next(()=>n);
    }
    /**
     * Returns the byte encoded form of the directional values in the field index.
     * Returns `null` if the document does not have all fields specified in the
     * index.
     */ on(t, e) {
        const n = new $5c04988f82cad1b3$var$lr;
        for (const s of $5c04988f82cad1b3$var$mt(t)){
            const t = e.data.field(s.fieldPath);
            if (null == t) return null;
            const i = n.Be(s.kind);
            $5c04988f82cad1b3$var$rr.ye.re(t, i);
        }
        return n.Oe();
    }
    /** Encodes a single value to the ascending index format. */ nn(t) {
        const e = new $5c04988f82cad1b3$var$lr;
        return $5c04988f82cad1b3$var$rr.ye.re(t, e.Be(0 /* ASCENDING */ )), e.Oe();
    }
    /**
     * Returns an encoded form of the document key that sorts based on the key
     * ordering of the field index.
     */ un(t, e) {
        const n = new $5c04988f82cad1b3$var$lr;
        return $5c04988f82cad1b3$var$rr.ye.re($5c04988f82cad1b3$var$ye(this.databaseId, e), n.Be(function(t) {
            const e = $5c04988f82cad1b3$var$mt(t);
            return 0 === e.length ? 0 /* ASCENDING */  : e[e.length - 1].kind;
        }(t))), n.Oe();
    }
    /**
     * Encodes the given field values according to the specification in `target`.
     * For IN queries, a list of possible values is returned.
     */ tn(t, e, n) {
        if (null === n) return [];
        let s = [];
        s.push(new $5c04988f82cad1b3$var$lr);
        let i = 0;
        for (const r of $5c04988f82cad1b3$var$mt(t)){
            const t = n[i++];
            for (const n of s)if (this.cn(e, r.fieldPath) && $5c04988f82cad1b3$var$Ie(t)) s = this.an(s, r, t);
            else {
                const e = n.Be(r.kind);
                $5c04988f82cad1b3$var$rr.ye.re(t, e);
            }
        }
        return this.hn(s);
    }
    /**
     * Encodes the given bounds according to the specification in `target`. For IN
     * queries, a list of possible values is returned.
     */ Ze(t, e, n) {
        return this.tn(t, e, n.position);
    }
    /** Returns the byte representation for the provided encoders. */ hn(t) {
        const e = [];
        for(let n = 0; n < t.length; ++n)e[n] = t[n].Oe();
        return e;
    }
    /**
     * Creates a separate encoder for each element of an array.
     *
     * The method appends each value to all existing encoders (e.g. filter("a",
     * "==", "a1").filter("b", "in", ["b1", "b2"]) becomes ["a1,b1", "a1,b2"]). A
     * list of new encoders is returned.
     */ an(t, e, n) {
        const s = [
            ...t
        ], i = [];
        for (const t of n.arrayValue.values || [])for (const n of s){
            const s = new $5c04988f82cad1b3$var$lr;
            s.seed(n.Oe()), $5c04988f82cad1b3$var$rr.ye.re(t, s.Be(e.kind)), i.push(s);
        }
        return i;
    }
    cn(t, e) {
        return !!t.filters.find((t)=>t instanceof $5c04988f82cad1b3$var$qe && t.field.isEqual(e) && ("in" /* IN */  === t.op || "not-in" /* NOT_IN */  === t.op));
    }
    getFieldIndexes(t, e) {
        const n = $5c04988f82cad1b3$var$Er(t), s = $5c04988f82cad1b3$var$Ar(t);
        return (e ? n.K("collectionGroupIndex", IDBKeyRange.bound(e, e)) : n.K()).next((t)=>{
            const e = [];
            return $5c04988f82cad1b3$var$Pt.forEach(t, (t)=>s.get([
                    t.indexId,
                    this.uid
                ]).next((n)=>{
                    e.push(function(t, e) {
                        const n = e ? new $5c04988f82cad1b3$var$yt(e.sequenceNumber, new $5c04988f82cad1b3$var$Tt($5c04988f82cad1b3$var$ji(e.readTime), new $5c04988f82cad1b3$export$afc2e57c475b7810($5c04988f82cad1b3$var$li(e.documentKey)), e.largestBatchId)) : $5c04988f82cad1b3$var$yt.empty(), s = t.fields.map(([t, e])=>new $5c04988f82cad1b3$var$gt($5c04988f82cad1b3$export$b7871852b967eaf1.fromServerFormat(t), e));
                        return new $5c04988f82cad1b3$var$_t(t.indexId, t.collectionGroup, s, n);
                    }(t, n));
                })).next(()=>e);
        });
    }
    getNextCollectionGroupToUpdate(t) {
        return this.getFieldIndexes(t).next((t)=>0 === t.length ? null : (t.sort((t, e)=>{
                const n = t.indexState.sequenceNumber - e.indexState.sequenceNumber;
                return 0 !== n ? n : $5c04988f82cad1b3$var$it(t.collectionGroup, e.collectionGroup);
            }), t[0].collectionGroup));
    }
    updateCollectionGroup(t, e, n) {
        const s = $5c04988f82cad1b3$var$Er(t), i = $5c04988f82cad1b3$var$Ar(t);
        return this.ln(t).next((t)=>s.K("collectionGroupIndex", IDBKeyRange.bound(e, e)).next((e)=>$5c04988f82cad1b3$var$Pt.forEach(e, (e)=>i.put($5c04988f82cad1b3$var$Zi(e.indexId, this.user, t, n)))));
    }
    updateIndexEntries(t, e) {
        // Porting Note: `getFieldIndexes()` on Web does not cache index lookups as
        // it could be used across different IndexedDB transactions. As any cached
        // data might be invalidated by other multi-tab clients, we can only trust
        // data within a single IndexedDB transaction. We therefore add a cache
        // here.
        const n = new Map;
        return $5c04988f82cad1b3$var$Pt.forEach(e, (e, s)=>{
            const i = n.get(e.collectionGroup);
            return (i ? $5c04988f82cad1b3$var$Pt.resolve(i) : this.getFieldIndexes(t, e.collectionGroup)).next((i)=>(n.set(e.collectionGroup, i), $5c04988f82cad1b3$var$Pt.forEach(i, (n)=>this.fn(t, e, n).next((e)=>{
                        const i = this.dn(s, n);
                        return e.isEqual(i) ? $5c04988f82cad1b3$var$Pt.resolve() : this._n(t, s, n, e, i);
                    }))));
        });
    }
    wn(t, e, n, s) {
        return $5c04988f82cad1b3$var$Tr(t).put({
            indexId: s.indexId,
            uid: this.uid,
            arrayValue: s.arrayValue,
            directionalValue: s.directionalValue,
            orderedDocumentKey: this.un(n, e.key),
            documentKey: e.key.path.toArray()
        });
    }
    mn(t, e, n, s) {
        return $5c04988f82cad1b3$var$Tr(t).delete([
            s.indexId,
            this.uid,
            s.arrayValue,
            s.directionalValue,
            this.un(n, e.key),
            e.key.path.toArray()
        ]);
    }
    fn(t, e, n) {
        const s = $5c04988f82cad1b3$var$Tr(t);
        let i = new $5c04988f82cad1b3$var$Qt($5c04988f82cad1b3$var$dr);
        return s.J({
            index: "documentKeyIndex",
            range: IDBKeyRange.only([
                n.indexId,
                this.uid,
                this.un(n, e)
            ])
        }, (t, s)=>{
            i = i.add(new $5c04988f82cad1b3$var$fr(n.indexId, e, s.arrayValue, s.directionalValue));
        }).next(()=>i);
    }
    /** Creates the index entries for the given document. */ dn(t, e) {
        let n = new $5c04988f82cad1b3$var$Qt($5c04988f82cad1b3$var$dr);
        const s = this.on(e, t);
        if (null == s) return n;
        const i = $5c04988f82cad1b3$var$wt(e);
        if (null != i) {
            const r = t.data.field(i.fieldPath);
            if ($5c04988f82cad1b3$var$Ie(r)) for (const i of r.arrayValue.values || [])n = n.add(new $5c04988f82cad1b3$var$fr(e.indexId, t.key, this.nn(i), s));
        } else n = n.add(new $5c04988f82cad1b3$var$fr(e.indexId, t.key, $5c04988f82cad1b3$var$yr, s));
        return n;
    }
    /**
     * Updates the index entries for the provided document by deleting entries
     * that are no longer referenced in `newEntries` and adding all newly added
     * entries.
     */ _n(t, e, n, s, i) {
        $5c04988f82cad1b3$var$M("IndexedDbIndexManager", "Updating index entries for document '%s'", e.key);
        const r = [];
        return function(t, e, n, s, i) {
            const r = t.getIterator(), o = e.getIterator();
            let u = $5c04988f82cad1b3$var$Wt(r), c = $5c04988f82cad1b3$var$Wt(o);
            // Walk through the two sets at the same time, using the ordering defined by
            // `comparator`.
            for(; u || c;){
                let t = !1, e = !1;
                if (u && c) {
                    const s = n(u, c);
                    s < 0 ? // The element was removed if the next element in our ordered
                    // walkthrough is only in `before`.
                    e = !0 : s > 0 && // The element was added if the next element in our ordered walkthrough
                    // is only in `after`.
                    (t = !0);
                } else null != u ? e = !0 : t = !0;
                t ? (s(c), c = $5c04988f82cad1b3$var$Wt(o)) : e ? (i(u), u = $5c04988f82cad1b3$var$Wt(r)) : (u = $5c04988f82cad1b3$var$Wt(r), c = $5c04988f82cad1b3$var$Wt(o));
            }
        }(s, i, $5c04988f82cad1b3$var$dr, /* onAdd= */ (s)=>{
            r.push(this.wn(t, e, n, s));
        }, /* onRemove= */ (s)=>{
            r.push(this.mn(t, e, n, s));
        }), $5c04988f82cad1b3$var$Pt.waitFor(r);
    }
    ln(t) {
        let e = 1;
        return $5c04988f82cad1b3$var$Ar(t).J({
            index: "sequenceNumberIndex",
            reverse: !0,
            range: IDBKeyRange.upperBound([
                this.uid,
                Number.MAX_SAFE_INTEGER
            ])
        }, (t, n, s)=>{
            s.done(), e = n.sequenceNumber + 1;
        }).next(()=>e);
    }
    /**
     * Returns a new set of IDB ranges that splits the existing range and excludes
     * any values that match the `notInValue` from these ranges. As an example,
     * '[foo > 2 && foo != 3]` becomes  `[foo > 2 && < 3, foo > 3]`.
     */ createRange(t, e, n) {
        // The notIn values need to be sorted and unique so that we can return a
        // sorted set of non-overlapping ranges.
        n = n.sort((t, e)=>$5c04988f82cad1b3$var$dr(t, e)).filter((t, e, n)=>!e || 0 !== $5c04988f82cad1b3$var$dr(t, n[e - 1]));
        const s = [];
        s.push(t);
        for (const i of n){
            const n = $5c04988f82cad1b3$var$dr(i, t), r = $5c04988f82cad1b3$var$dr(i, e);
            if (0 === n) // `notInValue` is the lower bound. We therefore need to raise the bound
            // to the next value.
            s[0] = t.Le();
            else if (n > 0 && r < 0) // `notInValue` is in the middle of the range
            s.push(i), s.push(i.Le());
            else if (r > 0) break;
        }
        s.push(e);
        const i = [];
        for(let t = 0; t < s.length; t += 2)i.push(IDBKeyRange.bound([
            s[t].indexId,
            this.uid,
            s[t].arrayValue,
            s[t].directionalValue,
            $5c04988f82cad1b3$var$yr,
            []
        ], [
            s[t + 1].indexId,
            this.uid,
            s[t + 1].arrayValue,
            s[t + 1].directionalValue,
            $5c04988f82cad1b3$var$yr,
            []
        ]));
        return i;
    }
    getMinOffsetFromCollectionGroup(t, e) {
        return this.getFieldIndexes(t, e).next($5c04988f82cad1b3$var$Rr);
    }
    getMinOffset(t, e) {
        return $5c04988f82cad1b3$var$Pt.mapArray(this.Ye(e), (e)=>this.Xe(t, e).next((t)=>t || $5c04988f82cad1b3$var$L())).next($5c04988f82cad1b3$var$Rr);
    }
    constructor(t, e){
        this.user = t, this.databaseId = e, /**
         * An in-memory copy of the index entries we've already written since the SDK
         * launched. Used to avoid re-writing the same entry repeatedly.
         *
         * This is *NOT* a complete cache of what's in persistence and so can never be
         * used to satisfy reads.
         */ this.He = new $5c04988f82cad1b3$var$gr, /**
         * Maps from a target to its equivalent list of sub-targets. Each sub-target
         * contains only one term from the target's disjunctive normal form (DNF).
         */ this.Je = new $5c04988f82cad1b3$var$is((t)=>$5c04988f82cad1b3$var$Oe(t), (t, e)=>$5c04988f82cad1b3$var$Fe(t, e)), this.uid = t.uid || "";
    }
}
/**
 * Helper to get a typed SimpleDbStore for the collectionParents
 * document store.
 */ function $5c04988f82cad1b3$var$Ir(t) {
    return $5c04988f82cad1b3$var$Mi(t, "collectionParents");
}
/**
 * Helper to get a typed SimpleDbStore for the index entry object store.
 */ function $5c04988f82cad1b3$var$Tr(t) {
    return $5c04988f82cad1b3$var$Mi(t, "indexEntries");
}
/**
 * Helper to get a typed SimpleDbStore for the index configuration object store.
 */ function $5c04988f82cad1b3$var$Er(t) {
    return $5c04988f82cad1b3$var$Mi(t, "indexConfiguration");
}
/**
 * Helper to get a typed SimpleDbStore for the index state object store.
 */ function $5c04988f82cad1b3$var$Ar(t) {
    return $5c04988f82cad1b3$var$Mi(t, "indexState");
}
function $5c04988f82cad1b3$var$Rr(t) {
    $5c04988f82cad1b3$var$U(0 !== t.length);
    let e = t[0].indexState.offset, n = e.largestBatchId;
    for(let s = 1; s < t.length; s++){
        const i = t[s].indexState.offset;
        $5c04988f82cad1b3$var$Et(i, e) < 0 && (e = i), n < i.largestBatchId && (n = i.largestBatchId);
    }
    return new $5c04988f82cad1b3$var$Tt(e.readTime, e.documentKey, n);
}
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $5c04988f82cad1b3$var$br = {
    didRun: !1,
    sequenceNumbersCollected: 0,
    targetsRemoved: 0,
    documentsRemoved: 0
};
class $5c04988f82cad1b3$var$Pr {
    static withCacheSize(t) {
        return new $5c04988f82cad1b3$var$Pr(t, $5c04988f82cad1b3$var$Pr.DEFAULT_COLLECTION_PERCENTILE, $5c04988f82cad1b3$var$Pr.DEFAULT_MAX_SEQUENCE_NUMBERS_TO_COLLECT);
    }
    constructor(// When we attempt to collect, we will only do so if the cache size is greater than this
    // threshold. Passing `COLLECTION_DISABLED` here will cause collection to always be skipped.
    t, // The percentage of sequence numbers that we will attempt to collect
    e, // A cap on the total number of sequence numbers that will be collected. This prevents
    // us from collecting a huge number of sequence numbers if the cache has grown very large.
    n){
        this.cacheSizeCollectionThreshold = t, this.percentileToCollect = e, this.maximumSequenceNumbersToCollect = n;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Delete a mutation batch and the associated document mutations.
 * @returns A PersistencePromise of the document mutations that were removed.
 */ function $5c04988f82cad1b3$var$vr(t, e, n) {
    const s = t.store("mutations"), i = t.store("documentMutations"), r = [], o = IDBKeyRange.only(n.batchId);
    let u = 0;
    const c = s.J({
        range: o
    }, (t, e, n)=>(u++, n.delete()));
    r.push(c.next(()=>{
        $5c04988f82cad1b3$var$U(1 === u);
    }));
    const a = [];
    for (const t of n.mutations){
        const s = $5c04988f82cad1b3$var$_i(e, t.key.path, n.batchId);
        r.push(i.delete(s)), a.push(t.key);
    }
    return $5c04988f82cad1b3$var$Pt.waitFor(r).next(()=>a);
}
/**
 * Returns an approximate size for the given document.
 */ function $5c04988f82cad1b3$var$Vr(t) {
    if (!t) return 0;
    let e;
    if (t.document) e = t.document;
    else if (t.unknownDocument) e = t.unknownDocument;
    else {
        if (!t.noDocument) throw $5c04988f82cad1b3$var$L();
        e = t.noDocument;
    }
    return JSON.stringify(e).length;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** A mutation queue for a specific user, backed by IndexedDB. */ $5c04988f82cad1b3$var$Pr.DEFAULT_COLLECTION_PERCENTILE = 10, $5c04988f82cad1b3$var$Pr.DEFAULT_MAX_SEQUENCE_NUMBERS_TO_COLLECT = 1e3, $5c04988f82cad1b3$var$Pr.DEFAULT = new $5c04988f82cad1b3$var$Pr(41943040, $5c04988f82cad1b3$var$Pr.DEFAULT_COLLECTION_PERCENTILE, $5c04988f82cad1b3$var$Pr.DEFAULT_MAX_SEQUENCE_NUMBERS_TO_COLLECT), $5c04988f82cad1b3$var$Pr.DISABLED = new $5c04988f82cad1b3$var$Pr(-1, 0, 0);
class $5c04988f82cad1b3$var$Sr {
    /**
     * Creates a new mutation queue for the given user.
     * @param user - The user for which to create a mutation queue.
     * @param serializer - The serializer to use when persisting to IndexedDb.
     */ static se(t, e, n, s) {
        // TODO(mcg): Figure out what constraints there are on userIDs
        // In particular, are there any reserved characters? are empty ids allowed?
        // For the moment store these together in the same mutations table assuming
        // that empty userIDs aren't allowed.
        $5c04988f82cad1b3$var$U("" !== t.uid);
        const i = t.isAuthenticated() ? t.uid : "";
        return new $5c04988f82cad1b3$var$Sr(i, e, n, s);
    }
    checkEmpty(t) {
        let e = !0;
        const n = IDBKeyRange.bound([
            this.userId,
            Number.NEGATIVE_INFINITY
        ], [
            this.userId,
            Number.POSITIVE_INFINITY
        ]);
        return $5c04988f82cad1b3$var$Cr(t).J({
            index: "userMutationsIndex",
            range: n
        }, (t, n, s)=>{
            e = !1, s.done();
        }).next(()=>e);
    }
    addMutationBatch(t, e, n, s) {
        const i = $5c04988f82cad1b3$var$xr(t), r = $5c04988f82cad1b3$var$Cr(t);
        // The IndexedDb implementation in Chrome (and Firefox) does not handle
        // compound indices that include auto-generated keys correctly. To ensure
        // that the index entry is added correctly in all browsers, we perform two
        // writes: The first write is used to retrieve the next auto-generated Batch
        // ID, and the second write populates the index and stores the actual
        // mutation batch.
        // See: https://bugs.chromium.org/p/chromium/issues/detail?id=701972
        // We write an empty object to obtain key
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return r.add({}).next((o)=>{
            $5c04988f82cad1b3$var$U("number" == typeof o);
            const u = new $5c04988f82cad1b3$var$Fi(o, e, n, s), c = function(t, e, n) {
                const s = n.baseMutations.map((e)=>$5c04988f82cad1b3$var$js(t.ne, e)), i = n.mutations.map((e)=>$5c04988f82cad1b3$var$js(t.ne, e));
                return {
                    userId: e,
                    batchId: n.batchId,
                    localWriteTimeMs: n.localWriteTime.toMillis(),
                    baseMutations: s,
                    mutations: i
                };
            }(this.wt, this.userId, u), a = [];
            let h = new $5c04988f82cad1b3$var$Qt((t, e)=>$5c04988f82cad1b3$var$it(t.canonicalString(), e.canonicalString()));
            for (const t of s){
                const e = $5c04988f82cad1b3$var$_i(this.userId, t.key.path, o);
                h = h.add(t.key.path.popLast()), a.push(r.put(c)), a.push(i.put(e, $5c04988f82cad1b3$var$wi));
            }
            return h.forEach((e)=>{
                a.push(this.indexManager.addToCollectionParentIndex(t, e));
            }), t.addOnCommittedListener(()=>{
                this.gn[o] = u.keys();
            }), $5c04988f82cad1b3$var$Pt.waitFor(a).next(()=>u);
        });
    }
    lookupMutationBatch(t, e) {
        return $5c04988f82cad1b3$var$Cr(t).get(e).next((t)=>t ? ($5c04988f82cad1b3$var$U(t.userId === this.userId), $5c04988f82cad1b3$var$Wi(this.wt, t)) : null);
    }
    /**
     * Returns the document keys for the mutation batch with the given batchId.
     * For primary clients, this method returns `null` after
     * `removeMutationBatches()` has been called. Secondary clients return a
     * cached result until `removeCachedMutationKeys()` is invoked.
     */ // PORTING NOTE: Multi-tab only.
    yn(t, e) {
        return this.gn[e] ? $5c04988f82cad1b3$var$Pt.resolve(this.gn[e]) : this.lookupMutationBatch(t, e).next((t)=>{
            if (t) {
                const n = t.keys();
                return this.gn[e] = n, n;
            }
            return null;
        });
    }
    getNextMutationBatchAfterBatchId(t, e) {
        const n = e + 1, s = IDBKeyRange.lowerBound([
            this.userId,
            n
        ]);
        let i = null;
        return $5c04988f82cad1b3$var$Cr(t).J({
            index: "userMutationsIndex",
            range: s
        }, (t, e, s)=>{
            e.userId === this.userId && ($5c04988f82cad1b3$var$U(e.batchId >= n), i = $5c04988f82cad1b3$var$Wi(this.wt, e)), s.done();
        }).next(()=>i);
    }
    getHighestUnacknowledgedBatchId(t) {
        const e = IDBKeyRange.upperBound([
            this.userId,
            Number.POSITIVE_INFINITY
        ]);
        let n = -1;
        return $5c04988f82cad1b3$var$Cr(t).J({
            index: "userMutationsIndex",
            range: e,
            reverse: !0
        }, (t, e, s)=>{
            n = e.batchId, s.done();
        }).next(()=>n);
    }
    getAllMutationBatches(t) {
        const e = IDBKeyRange.bound([
            this.userId,
            -1
        ], [
            this.userId,
            Number.POSITIVE_INFINITY
        ]);
        return $5c04988f82cad1b3$var$Cr(t).K("userMutationsIndex", e).next((t)=>t.map((t)=>$5c04988f82cad1b3$var$Wi(this.wt, t)));
    }
    getAllMutationBatchesAffectingDocumentKey(t, e) {
        // Scan the document-mutation index starting with a prefix starting with
        // the given documentKey.
        const n = $5c04988f82cad1b3$var$di(this.userId, e.path), s = IDBKeyRange.lowerBound(n), i = [];
        return $5c04988f82cad1b3$var$xr(t).J({
            range: s
        }, (n, s, r)=>{
            const [o, u, c] = n, a = $5c04988f82cad1b3$var$li(u);
            // Only consider rows matching exactly the specific key of
            // interest. Note that because we order by path first, and we
            // order terminators before path separators, we'll encounter all
            // the index rows for documentKey contiguously. In particular, all
            // the rows for documentKey will occur before any rows for
            // documents nested in a subcollection beneath documentKey so we
            // can stop as soon as we hit any such row.
            if (o === this.userId && e.path.isEqual(a)) // Look up the mutation batch in the store.
            return $5c04988f82cad1b3$var$Cr(t).get(c).next((t)=>{
                if (!t) throw $5c04988f82cad1b3$var$L();
                $5c04988f82cad1b3$var$U(t.userId === this.userId), i.push($5c04988f82cad1b3$var$Wi(this.wt, t));
            });
            r.done();
        }).next(()=>i);
    }
    getAllMutationBatchesAffectingDocumentKeys(t, e) {
        let n = new $5c04988f82cad1b3$var$Qt($5c04988f82cad1b3$var$it);
        const s = [];
        return e.forEach((e)=>{
            const i = $5c04988f82cad1b3$var$di(this.userId, e.path), r = IDBKeyRange.lowerBound(i), o = $5c04988f82cad1b3$var$xr(t).J({
                range: r
            }, (t, s, i)=>{
                const [r, o, u] = t, c = $5c04988f82cad1b3$var$li(o);
                // Only consider rows matching exactly the specific key of
                // interest. Note that because we order by path first, and we
                // order terminators before path separators, we'll encounter all
                // the index rows for documentKey contiguously. In particular, all
                // the rows for documentKey will occur before any rows for
                // documents nested in a subcollection beneath documentKey so we
                // can stop as soon as we hit any such row.
                r === this.userId && e.path.isEqual(c) ? n = n.add(u) : i.done();
            });
            s.push(o);
        }), $5c04988f82cad1b3$var$Pt.waitFor(s).next(()=>this.pn(t, n));
    }
    getAllMutationBatchesAffectingQuery(t, e) {
        const n = e.path, s = n.length + 1, i = $5c04988f82cad1b3$var$di(this.userId, n), r = IDBKeyRange.lowerBound(i);
        // Collect up unique batchIDs encountered during a scan of the index. Use a
        // SortedSet to accumulate batch IDs so they can be traversed in order in a
        // scan of the main table.
        let o = new $5c04988f82cad1b3$var$Qt($5c04988f82cad1b3$var$it);
        return $5c04988f82cad1b3$var$xr(t).J({
            range: r
        }, (t, e, i)=>{
            const [r, u, c] = t, a = $5c04988f82cad1b3$var$li(u);
            r === this.userId && n.isPrefixOf(a) ? // Rows with document keys more than one segment longer than the
            // query path can't be matches. For example, a query on 'rooms'
            // can't match the document /rooms/abc/messages/xyx.
            // TODO(mcg): we'll need a different scanner when we implement
            // ancestor queries.
            a.length === s && (o = o.add(c)) : i.done();
        }).next(()=>this.pn(t, o));
    }
    pn(t, e) {
        const n = [], s = [];
        // TODO(rockwood): Implement this using iterate.
        return e.forEach((e)=>{
            s.push($5c04988f82cad1b3$var$Cr(t).get(e).next((t)=>{
                if (null === t) throw $5c04988f82cad1b3$var$L();
                $5c04988f82cad1b3$var$U(t.userId === this.userId), n.push($5c04988f82cad1b3$var$Wi(this.wt, t));
            }));
        }), $5c04988f82cad1b3$var$Pt.waitFor(s).next(()=>n);
    }
    removeMutationBatch(t, e) {
        return $5c04988f82cad1b3$var$vr(t.ee, this.userId, e).next((n)=>(t.addOnCommittedListener(()=>{
                this.In(e.batchId);
            }), $5c04988f82cad1b3$var$Pt.forEach(n, (e)=>this.referenceDelegate.markPotentiallyOrphaned(t, e))));
    }
    /**
     * Clears the cached keys for a mutation batch. This method should be
     * called by secondary clients after they process mutation updates.
     *
     * Note that this method does not have to be called from primary clients as
     * the corresponding cache entries are cleared when an acknowledged or
     * rejected batch is removed from the mutation queue.
     */ // PORTING NOTE: Multi-tab only
    In(t) {
        delete this.gn[t];
    }
    performConsistencyCheck(t) {
        return this.checkEmpty(t).next((e)=>{
            if (!e) return $5c04988f82cad1b3$var$Pt.resolve();
            // Verify that there are no entries in the documentMutations index if
            // the queue is empty.
            const n = IDBKeyRange.lowerBound([
                this.userId
            ]);
            const s = [];
            return $5c04988f82cad1b3$var$xr(t).J({
                range: n
            }, (t, e, n)=>{
                if (t[0] === this.userId) {
                    const e = $5c04988f82cad1b3$var$li(t[1]);
                    s.push(e);
                } else n.done();
            }).next(()=>{
                $5c04988f82cad1b3$var$U(0 === s.length);
            });
        });
    }
    containsKey(t, e) {
        return $5c04988f82cad1b3$var$Dr(t, this.userId, e);
    }
    // PORTING NOTE: Multi-tab only (state is held in memory in other clients).
    /** Returns the mutation queue's metadata from IndexedDb. */ Tn(t) {
        return $5c04988f82cad1b3$var$Nr(t).get(this.userId).next((t)=>t || {
                userId: this.userId,
                lastAcknowledgedBatchId: -1,
                lastStreamToken: ""
            });
    }
    constructor(/**
     * The normalized userId (e.g. null UID => "" userId) used to store /
     * retrieve mutations.
     */ t, e, n, s){
        this.userId = t, this.wt = e, this.indexManager = n, this.referenceDelegate = s, /**
         * Caches the document keys for pending mutation batches. If the mutation
         * has been removed from IndexedDb, the cached value may continue to
         * be used to retrieve the batch's document keys. To remove a cached value
         * locally, `removeCachedMutationKeys()` should be invoked either directly
         * or through `removeMutationBatches()`.
         *
         * With multi-tab, when the primary client acknowledges or rejects a mutation,
         * this cache is used by secondary clients to invalidate the local
         * view of the documents that were previously affected by the mutation.
         */ // PORTING NOTE: Multi-tab only.
        this.gn = {};
    }
}
/**
 * @returns true if the mutation queue for the given user contains a pending
 *         mutation for the given key.
 */ function $5c04988f82cad1b3$var$Dr(t, e, n) {
    const s = $5c04988f82cad1b3$var$di(e, n.path), i = s[1], r = IDBKeyRange.lowerBound(s);
    let o = !1;
    return $5c04988f82cad1b3$var$xr(t).J({
        range: r,
        H: !0
    }, (t, n, s)=>{
        const [r, u, /*batchID*/ c] = t;
        r === e && u === i && (o = !0), s.done();
    }).next(()=>o);
}
/** Returns true if any mutation queue contains the given document. */ /**
 * Helper to get a typed SimpleDbStore for the mutations object store.
 */ function $5c04988f82cad1b3$var$Cr(t) {
    return $5c04988f82cad1b3$var$Mi(t, "mutations");
}
/**
 * Helper to get a typed SimpleDbStore for the mutationQueues object store.
 */ function $5c04988f82cad1b3$var$xr(t) {
    return $5c04988f82cad1b3$var$Mi(t, "documentMutations");
}
/**
 * Helper to get a typed SimpleDbStore for the mutationQueues object store.
 */ function $5c04988f82cad1b3$var$Nr(t) {
    return $5c04988f82cad1b3$var$Mi(t, "mutationQueues");
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Offset to ensure non-overlapping target ids. */ /**
 * Generates monotonically increasing target IDs for sending targets to the
 * watch stream.
 *
 * The client constructs two generators, one for the target cache, and one for
 * for the sync engine (to generate limbo documents targets). These
 * generators produce non-overlapping IDs (by using even and odd IDs
 * respectively).
 *
 * By separating the target ID space, the query cache can generate target IDs
 * that persist across client restarts, while sync engine can independently
 * generate in-memory target IDs that are transient and can be reused after a
 * restart.
 */ class $5c04988f82cad1b3$var$kr {
    next() {
        return this.En += 2, this.En;
    }
    static An() {
        // The target cache generator must return '2' in its first call to `next()`
        // as there is no differentiation in the protocol layer between an unset
        // number and the number '0'. If we were to sent a target with target ID
        // '0', the backend would consider it unset and replace it with its own ID.
        return new $5c04988f82cad1b3$var$kr(0);
    }
    static Rn() {
        // Sync engine assigns target IDs for limbo document detection.
        return new $5c04988f82cad1b3$var$kr(-1);
    }
    constructor(t){
        this.En = t;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $5c04988f82cad1b3$var$Or {
    // PORTING NOTE: We don't cache global metadata for the target cache, since
    // some of it (in particular `highestTargetId`) can be modified by secondary
    // tabs. We could perhaps be more granular (and e.g. still cache
    // `lastRemoteSnapshotVersion` in memory) but for simplicity we currently go
    // to IndexedDb whenever we need to read metadata. We can revisit if it turns
    // out to have a meaningful performance impact.
    allocateTargetId(t) {
        return this.bn(t).next((e)=>{
            const n = new $5c04988f82cad1b3$var$kr(e.highestTargetId);
            return e.highestTargetId = n.next(), this.Pn(t, e).next(()=>e.highestTargetId);
        });
    }
    getLastRemoteSnapshotVersion(t) {
        return this.bn(t).next((t)=>$5c04988f82cad1b3$var$ct.fromTimestamp(new $5c04988f82cad1b3$export$d9bcbd5e1ff81430(t.lastRemoteSnapshotVersion.seconds, t.lastRemoteSnapshotVersion.nanoseconds)));
    }
    getHighestSequenceNumber(t) {
        return this.bn(t).next((t)=>t.highestListenSequenceNumber);
    }
    setTargetsMetadata(t, e, n) {
        return this.bn(t).next((s)=>(s.highestListenSequenceNumber = e, n && (s.lastRemoteSnapshotVersion = n.toTimestamp()), e > s.highestListenSequenceNumber && (s.highestListenSequenceNumber = e), this.Pn(t, s)));
    }
    addTargetData(t, e) {
        return this.vn(t, e).next(()=>this.bn(t).next((n)=>(n.targetCount += 1, this.Vn(e, n), this.Pn(t, n))));
    }
    updateTargetData(t, e) {
        return this.vn(t, e);
    }
    removeTargetData(t, e) {
        return this.removeMatchingKeysForTargetId(t, e.targetId).next(()=>$5c04988f82cad1b3$var$Mr(t).delete(e.targetId)).next(()=>this.bn(t)).next((e)=>($5c04988f82cad1b3$var$U(e.targetCount > 0), e.targetCount -= 1, this.Pn(t, e)));
    }
    /**
     * Drops any targets with sequence number less than or equal to the upper bound, excepting those
     * present in `activeTargetIds`. Document associations for the removed targets are also removed.
     * Returns the number of targets removed.
     */ removeTargets(t, e, n) {
        let s = 0;
        const i = [];
        return $5c04988f82cad1b3$var$Mr(t).J((r, o)=>{
            const u = $5c04988f82cad1b3$var$zi(o);
            u.sequenceNumber <= e && null === n.get(u.targetId) && (s++, i.push(this.removeTargetData(t, u)));
        }).next(()=>$5c04988f82cad1b3$var$Pt.waitFor(i)).next(()=>s);
    }
    /**
     * Call provided function with each `TargetData` that we have cached.
     */ forEachTarget(t, e) {
        return $5c04988f82cad1b3$var$Mr(t).J((t, n)=>{
            const s = $5c04988f82cad1b3$var$zi(n);
            e(s);
        });
    }
    bn(t) {
        return $5c04988f82cad1b3$var$Fr(t).get("targetGlobalKey").next((t)=>($5c04988f82cad1b3$var$U(null !== t), t));
    }
    Pn(t, e) {
        return $5c04988f82cad1b3$var$Fr(t).put("targetGlobalKey", e);
    }
    vn(t, e) {
        return $5c04988f82cad1b3$var$Mr(t).put($5c04988f82cad1b3$var$Hi(this.wt, e));
    }
    /**
     * In-place updates the provided metadata to account for values in the given
     * TargetData. Saving is done separately. Returns true if there were any
     * changes to the metadata.
     */ Vn(t, e) {
        let n = !1;
        return t.targetId > e.highestTargetId && (e.highestTargetId = t.targetId, n = !0), t.sequenceNumber > e.highestListenSequenceNumber && (e.highestListenSequenceNumber = t.sequenceNumber, n = !0), n;
    }
    getTargetCount(t) {
        return this.bn(t).next((t)=>t.targetCount);
    }
    getTargetData(t, e) {
        // Iterating by the canonicalId may yield more than one result because
        // canonicalId values are not required to be unique per target. This query
        // depends on the queryTargets index to be efficient.
        const n = $5c04988f82cad1b3$var$Oe(e), s = IDBKeyRange.bound([
            n,
            Number.NEGATIVE_INFINITY
        ], [
            n,
            Number.POSITIVE_INFINITY
        ]);
        let i = null;
        return $5c04988f82cad1b3$var$Mr(t).J({
            range: s,
            index: "queryTargetsIndex"
        }, (t, n, s)=>{
            const r = $5c04988f82cad1b3$var$zi(n);
            // After finding a potential match, check that the target is
            // actually equal to the requested target.
            $5c04988f82cad1b3$var$Fe(e, r.target) && (i = r, s.done());
        }).next(()=>i);
    }
    addMatchingKeys(t, e, n) {
        // PORTING NOTE: The reverse index (documentsTargets) is maintained by
        // IndexedDb.
        const s = [], i = $5c04988f82cad1b3$var$$r(t);
        return e.forEach((e)=>{
            const r = $5c04988f82cad1b3$var$ci(e.path);
            s.push(i.put({
                targetId: n,
                path: r
            })), s.push(this.referenceDelegate.addReference(t, n, e));
        }), $5c04988f82cad1b3$var$Pt.waitFor(s);
    }
    removeMatchingKeys(t, e, n) {
        // PORTING NOTE: The reverse index (documentsTargets) is maintained by
        // IndexedDb.
        const s = $5c04988f82cad1b3$var$$r(t);
        return $5c04988f82cad1b3$var$Pt.forEach(e, (e)=>{
            const i = $5c04988f82cad1b3$var$ci(e.path);
            return $5c04988f82cad1b3$var$Pt.waitFor([
                s.delete([
                    n,
                    i
                ]),
                this.referenceDelegate.removeReference(t, n, e)
            ]);
        });
    }
    removeMatchingKeysForTargetId(t, e) {
        const n = $5c04988f82cad1b3$var$$r(t), s = IDBKeyRange.bound([
            e
        ], [
            e + 1
        ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0);
        return n.delete(s);
    }
    getMatchingKeysForTargetId(t, e) {
        const n = IDBKeyRange.bound([
            e
        ], [
            e + 1
        ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0), s = $5c04988f82cad1b3$var$$r(t);
        let i = $5c04988f82cad1b3$var$ws();
        return s.J({
            range: n,
            H: !0
        }, (t, e, n)=>{
            const s = $5c04988f82cad1b3$var$li(t[1]), r = new $5c04988f82cad1b3$export$afc2e57c475b7810(s);
            i = i.add(r);
        }).next(()=>i);
    }
    containsKey(t, e) {
        const n = $5c04988f82cad1b3$var$ci(e.path), s = IDBKeyRange.bound([
            n
        ], [
            $5c04988f82cad1b3$var$ot(n)
        ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0);
        let i = 0;
        return $5c04988f82cad1b3$var$$r(t).J({
            index: "documentTargetsIndex",
            H: !0,
            range: s
        }, ([t, e], n, s)=>{
            // Having a sentinel row for a document does not count as containing that document;
            // For the target cache, containing the document means the document is part of some
            // target.
            0 !== t && (i++, s.done());
        }).next(()=>i > 0);
    }
    /**
     * Looks up a TargetData entry by target ID.
     *
     * @param targetId - The target ID of the TargetData entry to look up.
     * @returns The cached TargetData entry, or null if the cache has no entry for
     * the target.
     */ // PORTING NOTE: Multi-tab only.
    te(t, e) {
        return $5c04988f82cad1b3$var$Mr(t).get(e).next((t)=>t ? $5c04988f82cad1b3$var$zi(t) : null);
    }
    constructor(t, e){
        this.referenceDelegate = t, this.wt = e;
    }
}
/**
 * Helper to get a typed SimpleDbStore for the queries object store.
 */ function $5c04988f82cad1b3$var$Mr(t) {
    return $5c04988f82cad1b3$var$Mi(t, "targets");
}
/**
 * Helper to get a typed SimpleDbStore for the target globals object store.
 */ function $5c04988f82cad1b3$var$Fr(t) {
    return $5c04988f82cad1b3$var$Mi(t, "targetGlobal");
}
/**
 * Helper to get a typed SimpleDbStore for the document target object store.
 */ function $5c04988f82cad1b3$var$$r(t) {
    return $5c04988f82cad1b3$var$Mi(t, "targetDocuments");
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $5c04988f82cad1b3$var$Br([t, e], [n, s]) {
    const i = $5c04988f82cad1b3$var$it(t, n);
    return 0 === i ? $5c04988f82cad1b3$var$it(e, s) : i;
}
/**
 * Used to calculate the nth sequence number. Keeps a rolling buffer of the
 * lowest n values passed to `addElement`, and finally reports the largest of
 * them in `maxValue`.
 */ class $5c04988f82cad1b3$var$Lr {
    Cn() {
        return ++this.Dn;
    }
    xn(t) {
        const e = [
            t,
            this.Cn()
        ];
        if (this.buffer.size < this.Sn) this.buffer = this.buffer.add(e);
        else {
            const t = this.buffer.last();
            $5c04988f82cad1b3$var$Br(e, t) < 0 && (this.buffer = this.buffer.delete(t).add(e));
        }
    }
    get maxValue() {
        // Guaranteed to be non-empty. If we decide we are not collecting any
        // sequence numbers, nthSequenceNumber below short-circuits. If we have
        // decided that we are collecting n sequence numbers, it's because n is some
        // percentage of the existing sequence numbers. That means we should never
        // be in a situation where we are collecting sequence numbers but don't
        // actually have any.
        return this.buffer.last()[0];
    }
    constructor(t){
        this.Sn = t, this.buffer = new $5c04988f82cad1b3$var$Qt($5c04988f82cad1b3$var$Br), this.Dn = 0;
    }
}
/**
 * This class is responsible for the scheduling of LRU garbage collection. It handles checking
 * whether or not GC is enabled, as well as which delay to use before the next run.
 */ class $5c04988f82cad1b3$var$Ur {
    start() {
        -1 !== this.garbageCollector.params.cacheSizeCollectionThreshold && this.kn(6e4);
    }
    stop() {
        this.Nn && (this.Nn.cancel(), this.Nn = null);
    }
    get started() {
        return null !== this.Nn;
    }
    kn(t) {
        $5c04988f82cad1b3$var$M("LruGarbageCollector", `Garbage collection scheduled in ${t}ms`), this.Nn = this.asyncQueue.enqueueAfterDelay("lru_garbage_collection" /* LruGarbageCollection */ , t, async ()=>{
            this.Nn = null;
            try {
                await this.localStore.collectGarbage(this.garbageCollector);
            } catch (t) {
                $5c04988f82cad1b3$var$Ct(t) ? $5c04988f82cad1b3$var$M("LruGarbageCollector", "Ignoring IndexedDB error during garbage collection: ", t) : await $5c04988f82cad1b3$var$bt(t);
            }
            await this.kn(3e5);
        });
    }
    constructor(t, e, n){
        this.garbageCollector = t, this.asyncQueue = e, this.localStore = n, this.Nn = null;
    }
}
/** Implements the steps for LRU garbage collection. */ class $5c04988f82cad1b3$var$qr {
    calculateTargetCount(t, e) {
        return this.On.Mn(t).next((t)=>Math.floor(e / 100 * t));
    }
    nthSequenceNumber(t, e) {
        if (0 === e) return $5c04988f82cad1b3$var$Pt.resolve($5c04988f82cad1b3$var$$t.ot);
        const n = new $5c04988f82cad1b3$var$Lr(e);
        return this.On.forEachTarget(t, (t)=>n.xn(t.sequenceNumber)).next(()=>this.On.Fn(t, (t)=>n.xn(t))).next(()=>n.maxValue);
    }
    removeTargets(t, e, n) {
        return this.On.removeTargets(t, e, n);
    }
    removeOrphanedDocuments(t, e) {
        return this.On.removeOrphanedDocuments(t, e);
    }
    collect(t, e) {
        return -1 === this.params.cacheSizeCollectionThreshold ? ($5c04988f82cad1b3$var$M("LruGarbageCollector", "Garbage collection skipped; disabled"), $5c04988f82cad1b3$var$Pt.resolve($5c04988f82cad1b3$var$br)) : this.getCacheSize(t).next((n)=>n < this.params.cacheSizeCollectionThreshold ? ($5c04988f82cad1b3$var$M("LruGarbageCollector", `Garbage collection skipped; Cache size ${n} is lower than threshold ${this.params.cacheSizeCollectionThreshold}`), $5c04988f82cad1b3$var$br) : this.$n(t, e));
    }
    getCacheSize(t) {
        return this.On.getCacheSize(t);
    }
    $n(t, e) {
        let n, s, i, r, o, c, a;
        const h = Date.now();
        return this.calculateTargetCount(t, this.params.percentileToCollect).next((e)=>// Cap at the configured max
            (e > this.params.maximumSequenceNumbersToCollect ? ($5c04988f82cad1b3$var$M("LruGarbageCollector", `Capping sequence numbers to collect down to the maximum of ${this.params.maximumSequenceNumbersToCollect} from ${e}`), s = this.params.maximumSequenceNumbersToCollect) : s = e, r = Date.now(), this.nthSequenceNumber(t, s))).next((s)=>(n = s, o = Date.now(), this.removeTargets(t, n, e))).next((e)=>(i = e, c = Date.now(), this.removeOrphanedDocuments(t, n))).next((t)=>{
            if (a = Date.now(), $5c04988f82cad1b3$var$k() <= (0, $gDOOI.LogLevel).DEBUG) $5c04988f82cad1b3$var$M("LruGarbageCollector", `LRU Garbage Collection\n\tCounted targets in ${r - h}ms\n\tDetermined least recently used ${s} in ` + (o - r) + "ms\n" + `\tRemoved ${i} targets in ` + (c - o) + "ms\n" + `\tRemoved ${t} documents in ` + (a - c) + "ms\n" + `Total Duration: ${a - h}ms`);
            return $5c04988f82cad1b3$var$Pt.resolve({
                didRun: !0,
                sequenceNumbersCollected: s,
                targetsRemoved: i,
                documentsRemoved: t
            });
        });
    }
    constructor(t, e){
        this.On = t, this.params = e;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Provides LRU functionality for IndexedDB persistence. */ class $5c04988f82cad1b3$var$Kr {
    Mn(t) {
        const e = this.Bn(t);
        return this.db.getTargetCache().getTargetCount(t).next((t)=>e.next((e)=>t + e));
    }
    Bn(t) {
        let e = 0;
        return this.Fn(t, (t)=>{
            e++;
        }).next(()=>e);
    }
    forEachTarget(t, e) {
        return this.db.getTargetCache().forEachTarget(t, e);
    }
    Fn(t, e) {
        return this.Ln(t, (t, n)=>e(n));
    }
    addReference(t, e, n) {
        return $5c04988f82cad1b3$var$Gr(t, n);
    }
    removeReference(t, e, n) {
        return $5c04988f82cad1b3$var$Gr(t, n);
    }
    removeTargets(t, e, n) {
        return this.db.getTargetCache().removeTargets(t, e, n);
    }
    markPotentiallyOrphaned(t, e) {
        return $5c04988f82cad1b3$var$Gr(t, e);
    }
    /**
     * Returns true if anything would prevent this document from being garbage
     * collected, given that the document in question is not present in any
     * targets and has a sequence number less than or equal to the upper bound for
     * the collection run.
     */ Un(t, e) {
        return function(t, e) {
            let n = !1;
            return $5c04988f82cad1b3$var$Nr(t).Y((s)=>$5c04988f82cad1b3$var$Dr(t, s, e).next((t)=>(t && (n = !0), $5c04988f82cad1b3$var$Pt.resolve(!t)))).next(()=>n);
        }(t, e);
    }
    removeOrphanedDocuments(t, e) {
        const n = this.db.getRemoteDocumentCache().newChangeBuffer(), s = [];
        let i = 0;
        return this.Ln(t, (r, o)=>{
            if (o <= e) {
                const e = this.Un(t, r).next((e)=>{
                    if (!e) // Our size accounting requires us to read all documents before
                    // removing them.
                    return i++, n.getEntry(t, r).next(()=>(n.removeEntry(r, $5c04988f82cad1b3$var$ct.min()), $5c04988f82cad1b3$var$$r(t).delete([
                            0,
                            $5c04988f82cad1b3$var$ci(r.path)
                        ])));
                });
                s.push(e);
            }
        }).next(()=>$5c04988f82cad1b3$var$Pt.waitFor(s)).next(()=>n.apply(t)).next(()=>i);
    }
    removeTarget(t, e) {
        const n = e.withSequenceNumber(t.currentSequenceNumber);
        return this.db.getTargetCache().updateTargetData(t, n);
    }
    updateLimboDocument(t, e) {
        return $5c04988f82cad1b3$var$Gr(t, e);
    }
    /**
     * Call provided function for each document in the cache that is 'orphaned'. Orphaned
     * means not a part of any target, so the only entry in the target-document index for
     * that document will be the sentinel row (targetId 0), which will also have the sequence
     * number for the last time the document was accessed.
     */ Ln(t, e) {
        const n = $5c04988f82cad1b3$var$$r(t);
        let s, i = $5c04988f82cad1b3$var$$t.ot;
        return n.J({
            index: "documentTargetsIndex"
        }, ([t, n], { path: r, sequenceNumber: o })=>{
            0 === t ? // if nextToReport is valid, report it, this is a new key so the
            // last one must not be a member of any targets.
            (i !== $5c04988f82cad1b3$var$$t.ot && e(new $5c04988f82cad1b3$export$afc2e57c475b7810($5c04988f82cad1b3$var$li(s)), i), // set nextToReport to be this sequence number. It's the next one we
            // might report, if we don't find any targets for this document.
            // Note that the sequence number must be defined when the targetId
            // is 0.
            i = o, s = r) : // set nextToReport to be invalid, we know we don't need to report
            // this one since we found a target for it.
            i = $5c04988f82cad1b3$var$$t.ot;
        }).next(()=>{
            // Since we report sequence numbers after getting to the next key, we
            // need to check if the last key we iterated over was an orphaned
            // document and report it.
            i !== $5c04988f82cad1b3$var$$t.ot && e(new $5c04988f82cad1b3$export$afc2e57c475b7810($5c04988f82cad1b3$var$li(s)), i);
        });
    }
    getCacheSize(t) {
        return this.db.getRemoteDocumentCache().getSize(t);
    }
    constructor(t, e){
        this.db = t, this.garbageCollector = function(t, e) {
            return new $5c04988f82cad1b3$var$qr(t, e);
        }(this, e);
    }
}
function $5c04988f82cad1b3$var$Gr(t, e) {
    return $5c04988f82cad1b3$var$$r(t).put(/**
 * @returns A value suitable for writing a sentinel row in the target-document
 * store.
 */ function(t, e) {
        return {
            targetId: 0,
            path: $5c04988f82cad1b3$var$ci(t.path),
            sequenceNumber: e
        };
    }(e, t.currentSequenceNumber));
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An in-memory buffer of entries to be written to a RemoteDocumentCache.
 * It can be used to batch up a set of changes to be written to the cache, but
 * additionally supports reading entries back with the `getEntry()` method,
 * falling back to the underlying RemoteDocumentCache if no entry is
 * buffered.
 *
 * Entries added to the cache *must* be read first. This is to facilitate
 * calculating the size delta of the pending changes.
 *
 * PORTING NOTE: This class was implemented then removed from other platforms.
 * If byte-counting ends up being needed on the other platforms, consider
 * porting this class as part of that implementation work.
 */ class $5c04988f82cad1b3$var$Qr {
    /**
     * Buffers a `RemoteDocumentCache.addEntry()` call.
     *
     * You can only modify documents that have already been retrieved via
     * `getEntry()/getEntries()` (enforced via IndexedDbs `apply()`).
     */ addEntry(t) {
        this.assertNotApplied(), this.changes.set(t.key, t);
    }
    /**
     * Buffers a `RemoteDocumentCache.removeEntry()` call.
     *
     * You can only remove documents that have already been retrieved via
     * `getEntry()/getEntries()` (enforced via IndexedDbs `apply()`).
     */ removeEntry(t, e) {
        this.assertNotApplied(), this.changes.set(t, $5c04988f82cad1b3$var$xe.newInvalidDocument(t).setReadTime(e));
    }
    /**
     * Looks up an entry in the cache. The buffered changes will first be checked,
     * and if no buffered change applies, this will forward to
     * `RemoteDocumentCache.getEntry()`.
     *
     * @param transaction - The transaction in which to perform any persistence
     *     operations.
     * @param documentKey - The key of the entry to look up.
     * @returns The cached document or an invalid document if we have nothing
     * cached.
     */ getEntry(t, e) {
        this.assertNotApplied();
        const n = this.changes.get(e);
        return void 0 !== n ? $5c04988f82cad1b3$var$Pt.resolve(n) : this.getFromCache(t, e);
    }
    /**
     * Looks up several entries in the cache, forwarding to
     * `RemoteDocumentCache.getEntry()`.
     *
     * @param transaction - The transaction in which to perform any persistence
     *     operations.
     * @param documentKeys - The keys of the entries to look up.
     * @returns A map of cached documents, indexed by key. If an entry cannot be
     *     found, the corresponding key will be mapped to an invalid document.
     */ getEntries(t, e) {
        return this.getAllFromCache(t, e);
    }
    /**
     * Applies buffered changes to the underlying RemoteDocumentCache, using
     * the provided transaction.
     */ apply(t) {
        return this.assertNotApplied(), this.changesApplied = !0, this.applyChanges(t);
    }
    /** Helper to assert this.changes is not null  */ assertNotApplied() {}
    constructor(){
        // A mapping of document key to the new cache entry that should be written.
        this.changes = new $5c04988f82cad1b3$var$is((t)=>t.toString(), (t, e)=>t.isEqual(e)), this.changesApplied = !1;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The RemoteDocumentCache for IndexedDb. To construct, invoke
 * `newIndexedDbRemoteDocumentCache()`.
 */ class $5c04988f82cad1b3$var$jr {
    setIndexManager(t) {
        this.indexManager = t;
    }
    /**
     * Adds the supplied entries to the cache.
     *
     * All calls of `addEntry` are required to go through the RemoteDocumentChangeBuffer
     * returned by `newChangeBuffer()` to ensure proper accounting of metadata.
     */ addEntry(t, e, n) {
        return $5c04988f82cad1b3$var$Jr(t).put(n);
    }
    /**
     * Removes a document from the cache.
     *
     * All calls of `removeEntry`  are required to go through the RemoteDocumentChangeBuffer
     * returned by `newChangeBuffer()` to ensure proper accounting of metadata.
     */ removeEntry(t, e, n) {
        return $5c04988f82cad1b3$var$Jr(t).delete(/**
 * Returns a key that can be used for document lookups via the primary key of
 * the DbRemoteDocument object store.
 */ function(t, e) {
            const n = t.path.toArray();
            return [
                /* prefix path */ n.slice(0, n.length - 2),
                /* collection id */ n[n.length - 2],
                $5c04988f82cad1b3$var$Gi(e),
                /* document id */ n[n.length - 1]
            ];
        }(e, n));
    }
    /**
     * Updates the current cache size.
     *
     * Callers to `addEntry()` and `removeEntry()` *must* call this afterwards to update the
     * cache's metadata.
     */ updateMetadata(t, e) {
        return this.getMetadata(t).next((n)=>(n.byteSize += e, this.qn(t, n)));
    }
    getEntry(t, e) {
        let n = $5c04988f82cad1b3$var$xe.newInvalidDocument(e);
        return $5c04988f82cad1b3$var$Jr(t).J({
            index: "documentKeyIndex",
            range: IDBKeyRange.only($5c04988f82cad1b3$var$Yr(e))
        }, (t, s)=>{
            n = this.Kn(e, s);
        }).next(()=>n);
    }
    /**
     * Looks up an entry in the cache.
     *
     * @param documentKey - The key of the entry to look up.
     * @returns The cached document entry and its size.
     */ Gn(t, e) {
        let n = {
            size: 0,
            document: $5c04988f82cad1b3$var$xe.newInvalidDocument(e)
        };
        return $5c04988f82cad1b3$var$Jr(t).J({
            index: "documentKeyIndex",
            range: IDBKeyRange.only($5c04988f82cad1b3$var$Yr(e))
        }, (t, s)=>{
            n = {
                document: this.Kn(e, s),
                size: $5c04988f82cad1b3$var$Vr(s)
            };
        }).next(()=>n);
    }
    getEntries(t, e) {
        let n = $5c04988f82cad1b3$var$os();
        return this.Qn(t, e, (t, e)=>{
            const s = this.Kn(t, e);
            n = n.insert(t, s);
        }).next(()=>n);
    }
    /**
     * Looks up several entries in the cache.
     *
     * @param documentKeys - The set of keys entries to look up.
     * @returns A map of documents indexed by key and a map of sizes indexed by
     *     key (zero if the document does not exist).
     */ jn(t, e) {
        let n = $5c04988f82cad1b3$var$os(), s = new $5c04988f82cad1b3$var$qt($5c04988f82cad1b3$export$afc2e57c475b7810.comparator);
        return this.Qn(t, e, (t, e)=>{
            const i = this.Kn(t, e);
            n = n.insert(t, i), s = s.insert(t, $5c04988f82cad1b3$var$Vr(e));
        }).next(()=>({
                documents: n,
                Wn: s
            }));
    }
    Qn(t, e, n) {
        if (e.isEmpty()) return $5c04988f82cad1b3$var$Pt.resolve();
        let s = new $5c04988f82cad1b3$var$Qt($5c04988f82cad1b3$var$Zr);
        e.forEach((t)=>s = s.add(t));
        const i = IDBKeyRange.bound($5c04988f82cad1b3$var$Yr(s.first()), $5c04988f82cad1b3$var$Yr(s.last())), r = s.getIterator();
        let o = r.getNext();
        return $5c04988f82cad1b3$var$Jr(t).J({
            index: "documentKeyIndex",
            range: i
        }, (t, e, s)=>{
            const i = $5c04988f82cad1b3$export$afc2e57c475b7810.fromSegments([
                ...e.prefixPath,
                e.collectionGroup,
                e.documentId
            ]);
            // Go through keys not found in cache.
            for(; o && $5c04988f82cad1b3$var$Zr(o, i) < 0;)n(o, null), o = r.getNext();
            o && o.isEqual(i) && // Key found in cache.
            (n(o, e), o = r.hasNext() ? r.getNext() : null), // Skip to the next key (if there is one).
            o ? s.q($5c04988f82cad1b3$var$Yr(o)) : s.done();
        }).next(()=>{
            // The rest of the keys are not in the cache. One case where `iterate`
            // above won't go through them is when the cache is empty.
            for(; o;)n(o, null), o = r.hasNext() ? r.getNext() : null;
        });
    }
    getAllFromCollection(t, e, n) {
        const s = [
            e.popLast().toArray(),
            e.lastSegment(),
            $5c04988f82cad1b3$var$Gi(n.readTime),
            n.documentKey.path.isEmpty() ? "" : n.documentKey.path.lastSegment()
        ], i = [
            e.popLast().toArray(),
            e.lastSegment(),
            [
                Number.MAX_SAFE_INTEGER,
                Number.MAX_SAFE_INTEGER
            ],
            ""
        ];
        return $5c04988f82cad1b3$var$Jr(t).K(IDBKeyRange.bound(s, i, !0)).next((t)=>{
            let e = $5c04988f82cad1b3$var$os();
            for (const n of t){
                const t = this.Kn($5c04988f82cad1b3$export$afc2e57c475b7810.fromSegments(n.prefixPath.concat(n.collectionGroup, n.documentId)), n);
                e = e.insert(t.key, t);
            }
            return e;
        });
    }
    getAllFromCollectionGroup(t, e, n, s) {
        let i = $5c04988f82cad1b3$var$os();
        const r = $5c04988f82cad1b3$var$Xr(e, n), o = $5c04988f82cad1b3$var$Xr(e, $5c04988f82cad1b3$var$Tt.max());
        return $5c04988f82cad1b3$var$Jr(t).J({
            index: "collectionGroupIndex",
            range: IDBKeyRange.bound(r, o, !0)
        }, (t, e, n)=>{
            const r = this.Kn($5c04988f82cad1b3$export$afc2e57c475b7810.fromSegments(e.prefixPath.concat(e.collectionGroup, e.documentId)), e);
            i = i.insert(r.key, r), i.size === s && n.done();
        }).next(()=>i);
    }
    newChangeBuffer(t) {
        return new $5c04988f82cad1b3$var$zr(this, !!t && t.trackRemovals);
    }
    getSize(t) {
        return this.getMetadata(t).next((t)=>t.byteSize);
    }
    getMetadata(t) {
        return $5c04988f82cad1b3$var$Hr(t).get("remoteDocumentGlobalKey").next((t)=>($5c04988f82cad1b3$var$U(!!t), t));
    }
    qn(t, e) {
        return $5c04988f82cad1b3$var$Hr(t).put("remoteDocumentGlobalKey", e);
    }
    /**
     * Decodes `dbRemoteDoc` and returns the document (or an invalid document if
     * the document corresponds to the format used for sentinel deletes).
     */ Kn(t, e) {
        if (e) {
            const t = $5c04988f82cad1b3$var$qi(this.wt, e);
            // Whether the document is a sentinel removal and should only be used in the
            // `getNewDocumentChanges()`
            if (!(t.isNoDocument() && t.version.isEqual($5c04988f82cad1b3$var$ct.min()))) return t;
        }
        return $5c04988f82cad1b3$var$xe.newInvalidDocument(t);
    }
    constructor(t){
        this.wt = t;
    }
}
/** Creates a new IndexedDbRemoteDocumentCache. */ function $5c04988f82cad1b3$var$Wr(t) {
    return new $5c04988f82cad1b3$var$jr(t);
}
/**
 * Handles the details of adding and updating documents in the IndexedDbRemoteDocumentCache.
 *
 * Unlike the MemoryRemoteDocumentChangeBuffer, the IndexedDb implementation computes the size
 * delta for all submitted changes. This avoids having to re-read all documents from IndexedDb
 * when we apply the changes.
 */ class $5c04988f82cad1b3$var$zr extends $5c04988f82cad1b3$var$Qr {
    applyChanges(t) {
        const e = [];
        let n = 0, s = new $5c04988f82cad1b3$var$Qt((t, e)=>$5c04988f82cad1b3$var$it(t.canonicalString(), e.canonicalString()));
        return this.changes.forEach((i, r)=>{
            const o = this.Hn.get(i);
            if (e.push(this.zn.removeEntry(t, i, o.readTime)), r.isValidDocument()) {
                const u = $5c04988f82cad1b3$var$Ki(this.zn.wt, r);
                s = s.add(i.path.popLast());
                const c = $5c04988f82cad1b3$var$Vr(u);
                n += c - o.size, e.push(this.zn.addEntry(t, i, u));
            } else if (n -= o.size, this.trackRemovals) {
                // In order to track removals, we store a "sentinel delete" in the
                // RemoteDocumentCache. This entry is represented by a NoDocument
                // with a version of 0 and ignored by `maybeDecodeDocument()` but
                // preserved in `getNewDocumentChanges()`.
                const n = $5c04988f82cad1b3$var$Ki(this.zn.wt, r.convertToNoDocument($5c04988f82cad1b3$var$ct.min()));
                e.push(this.zn.addEntry(t, i, n));
            }
        }), s.forEach((n)=>{
            e.push(this.zn.indexManager.addToCollectionParentIndex(t, n));
        }), e.push(this.zn.updateMetadata(t, n)), $5c04988f82cad1b3$var$Pt.waitFor(e);
    }
    getFromCache(t, e) {
        // Record the size of everything we load from the cache so we can compute a delta later.
        return this.zn.Gn(t, e).next((t)=>(this.Hn.set(e, {
                size: t.size,
                readTime: t.document.readTime
            }), t.document));
    }
    getAllFromCache(t, e) {
        // Record the size of everything we load from the cache so we can compute
        // a delta later.
        return this.zn.jn(t, e).next(({ documents: t, Wn: e })=>// Note: `getAllFromCache` returns two maps instead of a single map from
            // keys to `DocumentSizeEntry`s. This is to allow returning the
            // `MutableDocumentMap` directly, without a conversion.
            (e.forEach((e, n)=>{
                this.Hn.set(e, {
                    size: n,
                    readTime: t.get(e).readTime
                });
            }), t));
    }
    /**
     * @param documentCache - The IndexedDbRemoteDocumentCache to apply the changes to.
     * @param trackRemovals - Whether to create sentinel deletes that can be tracked by
     * `getNewDocumentChanges()`.
     */ constructor(t, e){
        super(), this.zn = t, this.trackRemovals = e, // A map of document sizes and read times prior to applying the changes in
        // this buffer.
        this.Hn = new $5c04988f82cad1b3$var$is((t)=>t.toString(), (t, e)=>t.isEqual(e));
    }
}
function $5c04988f82cad1b3$var$Hr(t) {
    return $5c04988f82cad1b3$var$Mi(t, "remoteDocumentGlobal");
}
/**
 * Helper to get a typed SimpleDbStore for the remoteDocuments object store.
 */ function $5c04988f82cad1b3$var$Jr(t) {
    return $5c04988f82cad1b3$var$Mi(t, "remoteDocumentsV14");
}
/**
 * Returns a key that can be used for document lookups on the
 * `DbRemoteDocumentDocumentKeyIndex` index.
 */ function $5c04988f82cad1b3$var$Yr(t) {
    const e = t.path.toArray();
    return [
        /* prefix path */ e.slice(0, e.length - 2),
        /* collection id */ e[e.length - 2],
        /* document id */ e[e.length - 1]
    ];
}
function $5c04988f82cad1b3$var$Xr(t, e) {
    const n = e.documentKey.path.toArray();
    return [
        /* collection id */ t,
        $5c04988f82cad1b3$var$Gi(e.readTime),
        /* prefix path */ n.slice(0, n.length - 2),
        /* document id */ n.length > 0 ? n[n.length - 1] : ""
    ];
}
/**
 * Comparator that compares document keys according to the primary key sorting
 * used by the `DbRemoteDocumentDocument` store (by prefix path, collection id
 * and then document ID).
 *
 * Visible for testing.
 */ function $5c04988f82cad1b3$var$Zr(t, e) {
    const n = t.path.toArray(), s = e.path.toArray();
    // The ordering is based on https://chromium.googlesource.com/chromium/blink/+/fe5c21fef94dae71c1c3344775b8d8a7f7e6d9ec/Source/modules/indexeddb/IDBKey.cpp#74
    let i = 0;
    for(let t = 0; t < n.length - 2 && t < s.length - 2; ++t)if (i = $5c04988f82cad1b3$var$it(n[t], s[t]), i) return i;
    return i = $5c04988f82cad1b3$var$it(n.length, s.length), i || (i = $5c04988f82cad1b3$var$it(n[n.length - 2], s[s.length - 2]), i || $5c04988f82cad1b3$var$it(n[n.length - 1], s[s.length - 1]));
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a local view (overlay) of a document, and the fields that are
 * locally mutated.
 */ class $5c04988f82cad1b3$var$to {
    constructor(t, /**
     * The fields that are locally mutated by patch mutations. If the overlayed
     * document is from set or delete mutations, this returns null.
     */ e){
        this.overlayedDocument = t, this.mutatedFields = e;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A readonly view of the local state of all documents we're tracking (i.e. we
 * have a cached version in remoteDocumentCache or local mutations for the
 * document). The view is computed by applying the mutations in the
 * MutationQueue to the RemoteDocumentCache.
 */ class $5c04988f82cad1b3$var$eo {
    /**
     * Get the local view of the document identified by `key`.
     *
     * @returns Local view of the document or null if we don't have any cached
     * state for it.
     */ getDocument(t, e) {
        let n = null;
        return this.documentOverlayCache.getOverlay(t, e).next((s)=>(n = s, this.getBaseDocument(t, e, n))).next((t)=>(null !== n && $5c04988f82cad1b3$var$Kn(n.mutation, t, $5c04988f82cad1b3$var$zt.empty(), $5c04988f82cad1b3$export$d9bcbd5e1ff81430.now()), t));
    }
    /**
     * Gets the local view of the documents identified by `keys`.
     *
     * If we don't have cached state for a document in `keys`, a NoDocument will
     * be stored for that key in the resulting set.
     */ getDocuments(t, e) {
        return this.remoteDocumentCache.getEntries(t, e).next((e)=>this.getLocalViewOfDocuments(t, e, $5c04988f82cad1b3$var$ws()).next(()=>e));
    }
    /**
     * Similar to `getDocuments`, but creates the local view from the given
     * `baseDocs` without retrieving documents from the local store.
     *
     * @param transaction - The transaction this operation is scoped to.
     * @param docs - The documents to apply local mutations to get the local views.
     * @param existenceStateChanged - The set of document keys whose existence state
     *   is changed. This is useful to determine if some documents overlay needs
     *   to be recalculated.
     */ getLocalViewOfDocuments(t, e, n = $5c04988f82cad1b3$var$ws()) {
        const s = $5c04988f82cad1b3$var$hs();
        return this.populateOverlays(t, s, e).next(()=>this.computeViews(t, e, s, n).next((t)=>{
                let e = $5c04988f82cad1b3$var$cs();
                return t.forEach((t, n)=>{
                    e = e.insert(t, n.overlayedDocument);
                }), e;
            }));
    }
    /**
     * Gets the overlayed documents for the given document map, which will include
     * the local view of those documents and a `FieldMask` indicating which fields
     * are mutated locally, `null` if overlay is a Set or Delete mutation.
     */ getOverlayedDocuments(t, e) {
        const n = $5c04988f82cad1b3$var$hs();
        return this.populateOverlays(t, n, e).next(()=>this.computeViews(t, e, n, $5c04988f82cad1b3$var$ws()));
    }
    /**
     * Fetches the overlays for {@code docs} and adds them to provided overlay map
     * if the map does not already contain an entry for the given document key.
     */ populateOverlays(t, e, n) {
        const s = [];
        return n.forEach((t)=>{
            e.has(t) || s.push(t);
        }), this.documentOverlayCache.getOverlays(t, s).next((t)=>{
            t.forEach((t, n)=>{
                e.set(t, n);
            });
        });
    }
    /**
     * Computes the local view for the given documents.
     *
     * @param docs - The documents to compute views for. It also has the base
     *   version of the documents.
     * @param overlays - The overlays that need to be applied to the given base
     *   version of the documents.
     * @param existenceStateChanged - A set of documents whose existence states
     *   might have changed. This is used to determine if we need to re-calculate
     *   overlays from mutation queues.
     * @return A map represents the local documents view.
     */ computeViews(t, e, n, s) {
        let i = $5c04988f82cad1b3$var$os();
        const r = $5c04988f82cad1b3$var$fs(), o = $5c04988f82cad1b3$var$fs();
        return e.forEach((t, e)=>{
            const o = n.get(e.key);
            // Recalculate an overlay if the document's existence state changed due to
            // a remote event *and* the overlay is a PatchMutation. This is because
            // document existence state can change if some patch mutation's
            // preconditions are met.
            // NOTE: we recalculate when `overlay` is undefined as well, because there
            // might be a patch mutation whose precondition does not match before the
            // change (hence overlay is undefined), but would now match.
            s.has(e.key) && (void 0 === o || o.mutation instanceof $5c04988f82cad1b3$var$Wn) ? i = i.insert(e.key, e) : void 0 !== o && (r.set(e.key, o.mutation.getFieldMask()), $5c04988f82cad1b3$var$Kn(o.mutation, e, o.mutation.getFieldMask(), $5c04988f82cad1b3$export$d9bcbd5e1ff81430.now()));
        }), this.recalculateAndSaveOverlays(t, i).next((t)=>(t.forEach((t, e)=>r.set(t, e)), e.forEach((t, e)=>{
                var n;
                return o.set(t, new $5c04988f82cad1b3$var$to(e, null !== (n = r.get(t)) && void 0 !== n ? n : null));
            }), o));
    }
    recalculateAndSaveOverlays(t, e) {
        const n = $5c04988f82cad1b3$var$fs();
        // A reverse lookup map from batch id to the documents within that batch.
        let s = new $5c04988f82cad1b3$var$qt((t, e)=>t - e), i = $5c04988f82cad1b3$var$ws();
        return this.mutationQueue.getAllMutationBatchesAffectingDocumentKeys(t, e).next((t)=>{
            for (const i of t)i.keys().forEach((t)=>{
                const r = e.get(t);
                if (null === r) return;
                let o = n.get(t) || $5c04988f82cad1b3$var$zt.empty();
                o = i.applyToLocalView(r, o), n.set(t, o);
                const u = (s.get(i.batchId) || $5c04988f82cad1b3$var$ws()).add(t);
                s = s.insert(i.batchId, u);
            });
        }).next(()=>{
            const r = [], o = s.getReverseIterator();
            // Iterate in descending order of batch IDs, and skip documents that are
            // already saved.
            for(; o.hasNext();){
                const s = o.getNext(), u = s.key, c = s.value, a = $5c04988f82cad1b3$var$ls();
                c.forEach((t)=>{
                    if (!i.has(t)) {
                        const s = $5c04988f82cad1b3$var$Un(e.get(t), n.get(t));
                        null !== s && a.set(t, s), i = i.add(t);
                    }
                }), r.push(this.documentOverlayCache.saveOverlays(t, u, a));
            }
            return $5c04988f82cad1b3$var$Pt.waitFor(r);
        }).next(()=>n);
    }
    /**
     * Recalculates overlays by reading the documents from remote document cache
     * first, and saves them after they are calculated.
     */ recalculateAndSaveOverlaysForDocumentKeys(t, e) {
        return this.remoteDocumentCache.getEntries(t, e).next((e)=>this.recalculateAndSaveOverlays(t, e));
    }
    /**
     * Performs a query against the local view of all documents.
     *
     * @param transaction - The persistence transaction.
     * @param query - The query to match documents against.
     * @param offset - Read time and key to start scanning by (exclusive).
     */ getDocumentsMatchingQuery(t, e, n) {
        /**
 * Returns whether the query matches a single document by path (rather than a
 * collection).
 */ return function(t) {
            return $5c04988f82cad1b3$export$afc2e57c475b7810.isDocumentKey(t.path) && null === t.collectionGroup && 0 === t.filters.length;
        }(e) ? this.getDocumentsMatchingDocumentQuery(t, e.path) : $5c04988f82cad1b3$var$an(e) ? this.getDocumentsMatchingCollectionGroupQuery(t, e, n) : this.getDocumentsMatchingCollectionQuery(t, e, n);
    }
    /**
     * Given a collection group, returns the next documents that follow the provided offset, along
     * with an updated batch ID.
     *
     * <p>The documents returned by this method are ordered by remote version from the provided
     * offset. If there are no more remote documents after the provided offset, documents with
     * mutations in order of batch id from the offset are returned. Since all documents in a batch are
     * returned together, the total number of documents returned can exceed {@code count}.
     *
     * @param transaction
     * @param collectionGroup The collection group for the documents.
     * @param offset The offset to index into.
     * @param count The number of documents to return
     * @return A LocalWriteResult with the documents that follow the provided offset and the last processed batch id.
     */ getNextDocuments(t, e, n, s) {
        return this.remoteDocumentCache.getAllFromCollectionGroup(t, e, n, s).next((i)=>{
            const r = s - i.size > 0 ? this.documentOverlayCache.getOverlaysForCollectionGroup(t, e, n.largestBatchId, s - i.size) : $5c04988f82cad1b3$var$Pt.resolve($5c04988f82cad1b3$var$hs());
            // The callsite will use the largest batch ID together with the latest read time to create
            // a new index offset. Since we only process batch IDs if all remote documents have been read,
            // no overlay will increase the overall read time. This is why we only need to special case
            // the batch id.
            let o = -1, u = i;
            return r.next((e)=>$5c04988f82cad1b3$var$Pt.forEach(e, (e, n)=>(o < n.largestBatchId && (o = n.largestBatchId), i.get(e) ? $5c04988f82cad1b3$var$Pt.resolve() : this.getBaseDocument(t, e, n).next((t)=>{
                        u = u.insert(e, t);
                    }))).next(()=>this.populateOverlays(t, e, i)).next(()=>this.computeViews(t, u, e, $5c04988f82cad1b3$var$ws())).next((t)=>({
                        batchId: o,
                        changes: $5c04988f82cad1b3$var$as(t)
                    })));
        });
    }
    getDocumentsMatchingDocumentQuery(t, e) {
        // Just do a simple document lookup.
        return this.getDocument(t, new $5c04988f82cad1b3$export$afc2e57c475b7810(e)).next((t)=>{
            let e = $5c04988f82cad1b3$var$cs();
            return t.isFoundDocument() && (e = e.insert(t.key, t)), e;
        });
    }
    getDocumentsMatchingCollectionGroupQuery(t, e, n) {
        const s = e.collectionGroup;
        let i = $5c04988f82cad1b3$var$cs();
        return this.indexManager.getCollectionParents(t, s).next((r)=>$5c04988f82cad1b3$var$Pt.forEach(r, (r)=>{
                const o = function(t, e) {
                    return new $5c04988f82cad1b3$var$nn(e, /*collectionGroup=*/ null, t.explicitOrderBy.slice(), t.filters.slice(), t.limit, t.limitType, t.startAt, t.endAt);
                }(e, r.child(s));
                return this.getDocumentsMatchingCollectionQuery(t, o, n).next((t)=>{
                    t.forEach((t, e)=>{
                        i = i.insert(t, e);
                    });
                });
            }).next(()=>i));
    }
    getDocumentsMatchingCollectionQuery(t, e, n) {
        // Query the remote documents and overlay mutations.
        let s;
        return this.remoteDocumentCache.getAllFromCollection(t, e.path, n).next((i)=>(s = i, this.documentOverlayCache.getOverlaysForCollection(t, e.path, n.largestBatchId))).next((t)=>{
            // As documents might match the query because of their overlay we need to
            // include documents for all overlays in the initial document set.
            t.forEach((t, e)=>{
                const n = e.getKey();
                null === s.get(n) && (s = s.insert(n, $5c04988f82cad1b3$var$xe.newInvalidDocument(n)));
            });
            // Apply the overlays and match against the query.
            let n = $5c04988f82cad1b3$var$cs();
            return s.forEach((s, i)=>{
                const r = t.get(s);
                void 0 !== r && $5c04988f82cad1b3$var$Kn(r.mutation, i, $5c04988f82cad1b3$var$zt.empty(), $5c04988f82cad1b3$export$d9bcbd5e1ff81430.now()), // Finally, insert the documents that still match the query
                $5c04988f82cad1b3$var$mn(e, i) && (n = n.insert(s, i));
            }), n;
        });
    }
    /** Returns a base document that can be used to apply `overlay`. */ getBaseDocument(t, e, n) {
        return null === n || 1 /* Patch */  === n.mutation.type ? this.remoteDocumentCache.getEntry(t, e) : $5c04988f82cad1b3$var$Pt.resolve($5c04988f82cad1b3$var$xe.newInvalidDocument(e));
    }
    constructor(t, e, n, s){
        this.remoteDocumentCache = t, this.mutationQueue = e, this.documentOverlayCache = n, this.indexManager = s;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $5c04988f82cad1b3$var$no {
    getBundleMetadata(t, e) {
        return $5c04988f82cad1b3$var$Pt.resolve(this.Jn.get(e));
    }
    saveBundleMetadata(t, e) {
        /** Decodes a BundleMetadata proto into a BundleMetadata object. */ var n;
        return this.Jn.set(e.id, {
            id: (n = e).id,
            version: n.version,
            createTime: $5c04988f82cad1b3$var$Ns(n.createTime)
        }), $5c04988f82cad1b3$var$Pt.resolve();
    }
    getNamedQuery(t, e) {
        return $5c04988f82cad1b3$var$Pt.resolve(this.Yn.get(e));
    }
    saveNamedQuery(t, e) {
        return this.Yn.set(e.name, function(t) {
            return {
                name: t.name,
                query: $5c04988f82cad1b3$var$Ji(t.bundledQuery),
                readTime: $5c04988f82cad1b3$var$Ns(t.readTime)
            };
        }(e)), $5c04988f82cad1b3$var$Pt.resolve();
    }
    constructor(t){
        this.wt = t, this.Jn = new Map, this.Yn = new Map;
    }
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An in-memory implementation of DocumentOverlayCache.
 */ class $5c04988f82cad1b3$var$so {
    getOverlay(t, e) {
        return $5c04988f82cad1b3$var$Pt.resolve(this.overlays.get(e));
    }
    getOverlays(t, e) {
        const n = $5c04988f82cad1b3$var$hs();
        return $5c04988f82cad1b3$var$Pt.forEach(e, (e)=>this.getOverlay(t, e).next((t)=>{
                null !== t && n.set(e, t);
            })).next(()=>n);
    }
    saveOverlays(t, e, n) {
        return n.forEach((n, s)=>{
            this.ie(t, e, s);
        }), $5c04988f82cad1b3$var$Pt.resolve();
    }
    removeOverlaysForBatchId(t, e, n) {
        const s = this.Xn.get(n);
        return void 0 !== s && (s.forEach((t)=>this.overlays = this.overlays.remove(t)), this.Xn.delete(n)), $5c04988f82cad1b3$var$Pt.resolve();
    }
    getOverlaysForCollection(t, e, n) {
        const s = $5c04988f82cad1b3$var$hs(), i = e.length + 1, r = new $5c04988f82cad1b3$export$afc2e57c475b7810(e.child("")), o = this.overlays.getIteratorFrom(r);
        for(; o.hasNext();){
            const t = o.getNext().value, r = t.getKey();
            if (!e.isPrefixOf(r.path)) break;
            // Documents from sub-collections
            r.path.length === i && t.largestBatchId > n && s.set(t.getKey(), t);
        }
        return $5c04988f82cad1b3$var$Pt.resolve(s);
    }
    getOverlaysForCollectionGroup(t, e, n, s) {
        let i = new $5c04988f82cad1b3$var$qt((t, e)=>t - e);
        const r = this.overlays.getIterator();
        for(; r.hasNext();){
            const t = r.getNext().value;
            if (t.getKey().getCollectionGroup() === e && t.largestBatchId > n) {
                let e = i.get(t.largestBatchId);
                null === e && (e = $5c04988f82cad1b3$var$hs(), i = i.insert(t.largestBatchId, e)), e.set(t.getKey(), t);
            }
        }
        const o = $5c04988f82cad1b3$var$hs(), u = i.getIterator();
        for(; u.hasNext();){
            if (u.getNext().value.forEach((t, e)=>o.set(t, e)), o.size() >= s) break;
        }
        return $5c04988f82cad1b3$var$Pt.resolve(o);
    }
    ie(t, e, n) {
        // Remove the association of the overlay to its batch id.
        const s = this.overlays.get(n.key);
        if (null !== s) {
            const t = this.Xn.get(s.largestBatchId).delete(n.key);
            this.Xn.set(s.largestBatchId, t);
        }
        this.overlays = this.overlays.insert(n.key, new $5c04988f82cad1b3$var$Bi(e, n));
        // Create the association of this overlay to the given largestBatchId.
        let i = this.Xn.get(e);
        void 0 === i && (i = $5c04988f82cad1b3$var$ws(), this.Xn.set(e, i)), this.Xn.set(e, i.add(n.key));
    }
    constructor(){
        // A map sorted by DocumentKey, whose value is a pair of the largest batch id
        // for the overlay and the overlay itself.
        this.overlays = new $5c04988f82cad1b3$var$qt($5c04988f82cad1b3$export$afc2e57c475b7810.comparator), this.Xn = new Map;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A collection of references to a document from some kind of numbered entity
 * (either a target ID or batch ID). As references are added to or removed from
 * the set corresponding events are emitted to a registered garbage collector.
 *
 * Each reference is represented by a DocumentReference object. Each of them
 * contains enough information to uniquely identify the reference. They are all
 * stored primarily in a set sorted by key. A document is considered garbage if
 * there's no references in that set (this can be efficiently checked thanks to
 * sorting by key).
 *
 * ReferenceSet also keeps a secondary set that contains references sorted by
 * IDs. This one is used to efficiently implement removal of all references by
 * some target ID.
 */ class $5c04988f82cad1b3$var$io {
    /** Returns true if the reference set contains no references. */ isEmpty() {
        return this.Zn.isEmpty();
    }
    /** Adds a reference to the given document key for the given ID. */ addReference(t, e) {
        const n = new $5c04988f82cad1b3$var$ro(t, e);
        this.Zn = this.Zn.add(n), this.es = this.es.add(n);
    }
    /** Add references to the given document keys for the given ID. */ ss(t, e) {
        t.forEach((t)=>this.addReference(t, e));
    }
    /**
     * Removes a reference to the given document key for the given
     * ID.
     */ removeReference(t, e) {
        this.rs(new $5c04988f82cad1b3$var$ro(t, e));
    }
    os(t, e) {
        t.forEach((t)=>this.removeReference(t, e));
    }
    /**
     * Clears all references with a given ID. Calls removeRef() for each key
     * removed.
     */ us(t) {
        const e = new $5c04988f82cad1b3$export$afc2e57c475b7810(new $5c04988f82cad1b3$var$ht([])), n = new $5c04988f82cad1b3$var$ro(e, t), s = new $5c04988f82cad1b3$var$ro(e, t + 1), i = [];
        return this.es.forEachInRange([
            n,
            s
        ], (t)=>{
            this.rs(t), i.push(t.key);
        }), i;
    }
    cs() {
        this.Zn.forEach((t)=>this.rs(t));
    }
    rs(t) {
        this.Zn = this.Zn.delete(t), this.es = this.es.delete(t);
    }
    hs(t) {
        const e = new $5c04988f82cad1b3$export$afc2e57c475b7810(new $5c04988f82cad1b3$var$ht([])), n = new $5c04988f82cad1b3$var$ro(e, t), s = new $5c04988f82cad1b3$var$ro(e, t + 1);
        let i = $5c04988f82cad1b3$var$ws();
        return this.es.forEachInRange([
            n,
            s
        ], (t)=>{
            i = i.add(t.key);
        }), i;
    }
    containsKey(t) {
        const e = new $5c04988f82cad1b3$var$ro(t, 0), n = this.Zn.firstAfterOrEqual(e);
        return null !== n && t.isEqual(n.key);
    }
    constructor(){
        // A set of outstanding references to a document sorted by key.
        this.Zn = new $5c04988f82cad1b3$var$Qt($5c04988f82cad1b3$var$ro.ts), // A set of outstanding references to a document sorted by target id.
        this.es = new $5c04988f82cad1b3$var$Qt($5c04988f82cad1b3$var$ro.ns);
    }
}
class $5c04988f82cad1b3$var$ro {
    /** Compare by key then by ID */ static ts(t, e) {
        return $5c04988f82cad1b3$export$afc2e57c475b7810.comparator(t.key, e.key) || $5c04988f82cad1b3$var$it(t.ls, e.ls);
    }
    /** Compare by ID then by key */ static ns(t, e) {
        return $5c04988f82cad1b3$var$it(t.ls, e.ls) || $5c04988f82cad1b3$export$afc2e57c475b7810.comparator(t.key, e.key);
    }
    constructor(t, e){
        this.key = t, this.ls = e;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $5c04988f82cad1b3$var$oo {
    checkEmpty(t) {
        return $5c04988f82cad1b3$var$Pt.resolve(0 === this.mutationQueue.length);
    }
    addMutationBatch(t, e, n, s) {
        const i = this.fs;
        this.fs++, this.mutationQueue.length > 0 && this.mutationQueue[this.mutationQueue.length - 1];
        const r = new $5c04988f82cad1b3$var$Fi(i, e, n, s);
        this.mutationQueue.push(r);
        // Track references by document key and index collection parents.
        for (const e of s)this.ds = this.ds.add(new $5c04988f82cad1b3$var$ro(e.key, i)), this.indexManager.addToCollectionParentIndex(t, e.key.path.popLast());
        return $5c04988f82cad1b3$var$Pt.resolve(r);
    }
    lookupMutationBatch(t, e) {
        return $5c04988f82cad1b3$var$Pt.resolve(this._s(e));
    }
    getNextMutationBatchAfterBatchId(t, e) {
        const n = e + 1, s = this.ws(n), i = s < 0 ? 0 : s;
        // The requested batchId may still be out of range so normalize it to the
        // start of the queue.
        return $5c04988f82cad1b3$var$Pt.resolve(this.mutationQueue.length > i ? this.mutationQueue[i] : null);
    }
    getHighestUnacknowledgedBatchId() {
        return $5c04988f82cad1b3$var$Pt.resolve(0 === this.mutationQueue.length ? -1 : this.fs - 1);
    }
    getAllMutationBatches(t) {
        return $5c04988f82cad1b3$var$Pt.resolve(this.mutationQueue.slice());
    }
    getAllMutationBatchesAffectingDocumentKey(t, e) {
        const n = new $5c04988f82cad1b3$var$ro(e, 0), s = new $5c04988f82cad1b3$var$ro(e, Number.POSITIVE_INFINITY), i = [];
        return this.ds.forEachInRange([
            n,
            s
        ], (t)=>{
            const e = this._s(t.ls);
            i.push(e);
        }), $5c04988f82cad1b3$var$Pt.resolve(i);
    }
    getAllMutationBatchesAffectingDocumentKeys(t, e) {
        let n = new $5c04988f82cad1b3$var$Qt($5c04988f82cad1b3$var$it);
        return e.forEach((t)=>{
            const e = new $5c04988f82cad1b3$var$ro(t, 0), s = new $5c04988f82cad1b3$var$ro(t, Number.POSITIVE_INFINITY);
            this.ds.forEachInRange([
                e,
                s
            ], (t)=>{
                n = n.add(t.ls);
            });
        }), $5c04988f82cad1b3$var$Pt.resolve(this.gs(n));
    }
    getAllMutationBatchesAffectingQuery(t, e) {
        // Use the query path as a prefix for testing if a document matches the
        // query.
        const n = e.path, s = n.length + 1;
        // Construct a document reference for actually scanning the index. Unlike
        // the prefix the document key in this reference must have an even number of
        // segments. The empty segment can be used a suffix of the query path
        // because it precedes all other segments in an ordered traversal.
        let i = n;
        $5c04988f82cad1b3$export$afc2e57c475b7810.isDocumentKey(i) || (i = i.child(""));
        const r = new $5c04988f82cad1b3$var$ro(new $5c04988f82cad1b3$export$afc2e57c475b7810(i), 0);
        // Find unique batchIDs referenced by all documents potentially matching the
        // query.
        let o = new $5c04988f82cad1b3$var$Qt($5c04988f82cad1b3$var$it);
        return this.ds.forEachWhile((t)=>{
            const e = t.key.path;
            return !!n.isPrefixOf(e) && // Rows with document keys more than one segment longer than the query
            // path can't be matches. For example, a query on 'rooms' can't match
            // the document /rooms/abc/messages/xyx.
            // TODO(mcg): we'll need a different scanner when we implement
            // ancestor queries.
            (e.length === s && (o = o.add(t.ls)), !0);
        }, r), $5c04988f82cad1b3$var$Pt.resolve(this.gs(o));
    }
    gs(t) {
        // Construct an array of matching batches, sorted by batchID to ensure that
        // multiple mutations affecting the same document key are applied in order.
        const e = [];
        return t.forEach((t)=>{
            const n = this._s(t);
            null !== n && e.push(n);
        }), e;
    }
    removeMutationBatch(t, e) {
        $5c04988f82cad1b3$var$U(0 === this.ys(e.batchId, "removed")), this.mutationQueue.shift();
        let n = this.ds;
        return $5c04988f82cad1b3$var$Pt.forEach(e.mutations, (s)=>{
            const i = new $5c04988f82cad1b3$var$ro(s.key, e.batchId);
            return n = n.delete(i), this.referenceDelegate.markPotentiallyOrphaned(t, s.key);
        }).next(()=>{
            this.ds = n;
        });
    }
    In(t) {
    // No-op since the memory mutation queue does not maintain a separate cache.
    }
    containsKey(t, e) {
        const n = new $5c04988f82cad1b3$var$ro(e, 0), s = this.ds.firstAfterOrEqual(n);
        return $5c04988f82cad1b3$var$Pt.resolve(e.isEqual(s && s.key));
    }
    performConsistencyCheck(t) {
        return this.mutationQueue.length, $5c04988f82cad1b3$var$Pt.resolve();
    }
    /**
     * Finds the index of the given batchId in the mutation queue and asserts that
     * the resulting index is within the bounds of the queue.
     *
     * @param batchId - The batchId to search for
     * @param action - A description of what the caller is doing, phrased in passive
     * form (e.g. "acknowledged" in a routine that acknowledges batches).
     */ ys(t, e) {
        return this.ws(t);
    }
    /**
     * Finds the index of the given batchId in the mutation queue. This operation
     * is O(1).
     *
     * @returns The computed index of the batch with the given batchId, based on
     * the state of the queue. Note this index can be negative if the requested
     * batchId has already been remvoed from the queue or past the end of the
     * queue if the batchId is larger than the last added batch.
     */ ws(t) {
        if (0 === this.mutationQueue.length) // As an index this is past the end of the queue
        return 0;
        // Examine the front of the queue to figure out the difference between the
        // batchId and indexes in the array. Note that since the queue is ordered
        // by batchId, if the first batch has a larger batchId then the requested
        // batchId doesn't exist in the queue.
        return t - this.mutationQueue[0].batchId;
    }
    /**
     * A version of lookupMutationBatch that doesn't return a promise, this makes
     * other functions that uses this code easier to read and more efficent.
     */ _s(t) {
        const e = this.ws(t);
        if (e < 0 || e >= this.mutationQueue.length) return null;
        return this.mutationQueue[e];
    }
    constructor(t, e){
        this.indexManager = t, this.referenceDelegate = e, /**
         * The set of all mutations that have been sent but not yet been applied to
         * the backend.
         */ this.mutationQueue = [], /** Next value to use when assigning sequential IDs to each mutation batch. */ this.fs = 1, /** An ordered mapping between documents and the mutations batch IDs. */ this.ds = new $5c04988f82cad1b3$var$Qt($5c04988f82cad1b3$var$ro.ts);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The memory-only RemoteDocumentCache for IndexedDb. To construct, invoke
 * `newMemoryRemoteDocumentCache()`.
 */ class $5c04988f82cad1b3$var$uo {
    setIndexManager(t) {
        this.indexManager = t;
    }
    /**
     * Adds the supplied entry to the cache and updates the cache size as appropriate.
     *
     * All calls of `addEntry`  are required to go through the RemoteDocumentChangeBuffer
     * returned by `newChangeBuffer()`.
     */ addEntry(t, e) {
        const n = e.key, s = this.docs.get(n), i = s ? s.size : 0, r = this.ps(e);
        return this.docs = this.docs.insert(n, {
            document: e.mutableCopy(),
            size: r
        }), this.size += r - i, this.indexManager.addToCollectionParentIndex(t, n.path.popLast());
    }
    /**
     * Removes the specified entry from the cache and updates the cache size as appropriate.
     *
     * All calls of `removeEntry` are required to go through the RemoteDocumentChangeBuffer
     * returned by `newChangeBuffer()`.
     */ removeEntry(t) {
        const e = this.docs.get(t);
        e && (this.docs = this.docs.remove(t), this.size -= e.size);
    }
    getEntry(t, e) {
        const n = this.docs.get(e);
        return $5c04988f82cad1b3$var$Pt.resolve(n ? n.document.mutableCopy() : $5c04988f82cad1b3$var$xe.newInvalidDocument(e));
    }
    getEntries(t, e) {
        let n = $5c04988f82cad1b3$var$os();
        return e.forEach((t)=>{
            const e = this.docs.get(t);
            n = n.insert(t, e ? e.document.mutableCopy() : $5c04988f82cad1b3$var$xe.newInvalidDocument(t));
        }), $5c04988f82cad1b3$var$Pt.resolve(n);
    }
    getAllFromCollection(t, e, n) {
        let s = $5c04988f82cad1b3$var$os();
        // Documents are ordered by key, so we can use a prefix scan to narrow down
        // the documents we need to match the query against.
        const i = new $5c04988f82cad1b3$export$afc2e57c475b7810(e.child("")), r = this.docs.getIteratorFrom(i);
        for(; r.hasNext();){
            const { key: t, value: { document: i } } = r.getNext();
            if (!e.isPrefixOf(t.path)) break;
            t.path.length > e.length + 1 || $5c04988f82cad1b3$var$Et($5c04988f82cad1b3$var$It(i), n) <= 0 || (s = s.insert(i.key, i.mutableCopy()));
        }
        return $5c04988f82cad1b3$var$Pt.resolve(s);
    }
    getAllFromCollectionGroup(t, e, n, s) {
        // This method should only be called from the IndexBackfiller if persistence
        // is enabled.
        $5c04988f82cad1b3$var$L();
    }
    Is(t, e) {
        return $5c04988f82cad1b3$var$Pt.forEach(this.docs, (t)=>e(t));
    }
    newChangeBuffer(t) {
        // `trackRemovals` is ignores since the MemoryRemoteDocumentCache keeps
        // a separate changelog and does not need special handling for removals.
        return new $5c04988f82cad1b3$var$co(this);
    }
    getSize(t) {
        return $5c04988f82cad1b3$var$Pt.resolve(this.size);
    }
    /**
     * @param sizer - Used to assess the size of a document. For eager GC, this is
     * expected to just return 0 to avoid unnecessarily doing the work of
     * calculating the size.
     */ constructor(t){
        this.ps = t, /** Underlying cache of documents and their read times. */ this.docs = new $5c04988f82cad1b3$var$qt($5c04988f82cad1b3$export$afc2e57c475b7810.comparator), /** Size of all cached documents. */ this.size = 0;
    }
}
/**
 * Creates a new memory-only RemoteDocumentCache.
 *
 * @param sizer - Used to assess the size of a document. For eager GC, this is
 * expected to just return 0 to avoid unnecessarily doing the work of
 * calculating the size.
 */ /**
 * Handles the details of adding and updating documents in the MemoryRemoteDocumentCache.
 */ class $5c04988f82cad1b3$var$co extends $5c04988f82cad1b3$var$Qr {
    applyChanges(t) {
        const e = [];
        return this.changes.forEach((n, s)=>{
            s.isValidDocument() ? e.push(this.zn.addEntry(t, s)) : this.zn.removeEntry(n);
        }), $5c04988f82cad1b3$var$Pt.waitFor(e);
    }
    getFromCache(t, e) {
        return this.zn.getEntry(t, e);
    }
    getAllFromCache(t, e) {
        return this.zn.getEntries(t, e);
    }
    constructor(t){
        super(), this.zn = t;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $5c04988f82cad1b3$var$ao {
    forEachTarget(t, e) {
        return this.Ts.forEach((t, n)=>e(n)), $5c04988f82cad1b3$var$Pt.resolve();
    }
    getLastRemoteSnapshotVersion(t) {
        return $5c04988f82cad1b3$var$Pt.resolve(this.lastRemoteSnapshotVersion);
    }
    getHighestSequenceNumber(t) {
        return $5c04988f82cad1b3$var$Pt.resolve(this.Es);
    }
    allocateTargetId(t) {
        return this.highestTargetId = this.Rs.next(), $5c04988f82cad1b3$var$Pt.resolve(this.highestTargetId);
    }
    setTargetsMetadata(t, e, n) {
        return n && (this.lastRemoteSnapshotVersion = n), e > this.Es && (this.Es = e), $5c04988f82cad1b3$var$Pt.resolve();
    }
    vn(t) {
        this.Ts.set(t.target, t);
        const e = t.targetId;
        e > this.highestTargetId && (this.Rs = new $5c04988f82cad1b3$var$kr(e), this.highestTargetId = e), t.sequenceNumber > this.Es && (this.Es = t.sequenceNumber);
    }
    addTargetData(t, e) {
        return this.vn(e), this.targetCount += 1, $5c04988f82cad1b3$var$Pt.resolve();
    }
    updateTargetData(t, e) {
        return this.vn(e), $5c04988f82cad1b3$var$Pt.resolve();
    }
    removeTargetData(t, e) {
        return this.Ts.delete(e.target), this.As.us(e.targetId), this.targetCount -= 1, $5c04988f82cad1b3$var$Pt.resolve();
    }
    removeTargets(t, e, n) {
        let s = 0;
        const i = [];
        return this.Ts.forEach((r, o)=>{
            o.sequenceNumber <= e && null === n.get(o.targetId) && (this.Ts.delete(r), i.push(this.removeMatchingKeysForTargetId(t, o.targetId)), s++);
        }), $5c04988f82cad1b3$var$Pt.waitFor(i).next(()=>s);
    }
    getTargetCount(t) {
        return $5c04988f82cad1b3$var$Pt.resolve(this.targetCount);
    }
    getTargetData(t, e) {
        const n = this.Ts.get(e) || null;
        return $5c04988f82cad1b3$var$Pt.resolve(n);
    }
    addMatchingKeys(t, e, n) {
        return this.As.ss(e, n), $5c04988f82cad1b3$var$Pt.resolve();
    }
    removeMatchingKeys(t, e, n) {
        this.As.os(e, n);
        const s = this.persistence.referenceDelegate, i = [];
        return s && e.forEach((e)=>{
            i.push(s.markPotentiallyOrphaned(t, e));
        }), $5c04988f82cad1b3$var$Pt.waitFor(i);
    }
    removeMatchingKeysForTargetId(t, e) {
        return this.As.us(e), $5c04988f82cad1b3$var$Pt.resolve();
    }
    getMatchingKeysForTargetId(t, e) {
        const n = this.As.hs(e);
        return $5c04988f82cad1b3$var$Pt.resolve(n);
    }
    containsKey(t, e) {
        return $5c04988f82cad1b3$var$Pt.resolve(this.As.containsKey(e));
    }
    constructor(t){
        this.persistence = t, /**
         * Maps a target to the data about that target
         */ this.Ts = new $5c04988f82cad1b3$var$is((t)=>$5c04988f82cad1b3$var$Oe(t), $5c04988f82cad1b3$var$Fe), /** The last received snapshot version. */ this.lastRemoteSnapshotVersion = $5c04988f82cad1b3$var$ct.min(), /** The highest numbered target ID encountered. */ this.highestTargetId = 0, /** The highest sequence number encountered. */ this.Es = 0, /**
         * A ordered bidirectional mapping between documents and the remote target
         * IDs.
         */ this.As = new $5c04988f82cad1b3$var$io, this.targetCount = 0, this.Rs = $5c04988f82cad1b3$var$kr.An();
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A memory-backed instance of Persistence. Data is stored only in RAM and
 * not persisted across sessions.
 */ class $5c04988f82cad1b3$var$ho {
    start() {
        return Promise.resolve();
    }
    shutdown() {
        // No durable state to ensure is closed on shutdown.
        return this.vs = !1, Promise.resolve();
    }
    get started() {
        return this.vs;
    }
    setDatabaseDeletedListener() {
    // No op.
    }
    setNetworkEnabled() {
    // No op.
    }
    getIndexManager(t) {
        // We do not currently support indices for memory persistence, so we can
        // return the same shared instance of the memory index manager.
        return this.indexManager;
    }
    getDocumentOverlayCache(t) {
        let e = this.overlays[t.toKey()];
        return e || (e = new $5c04988f82cad1b3$var$so, this.overlays[t.toKey()] = e), e;
    }
    getMutationQueue(t, e) {
        let n = this.bs[t.toKey()];
        return n || (n = new $5c04988f82cad1b3$var$oo(e, this.referenceDelegate), this.bs[t.toKey()] = n), n;
    }
    getTargetCache() {
        return this.Vs;
    }
    getRemoteDocumentCache() {
        return this.remoteDocumentCache;
    }
    getBundleCache() {
        return this.Ds;
    }
    runTransaction(t, e, n) {
        $5c04988f82cad1b3$var$M("MemoryPersistence", "Starting transaction:", t);
        const s = new $5c04988f82cad1b3$var$lo(this.Ps.next());
        return this.referenceDelegate.Cs(), n(s).next((t)=>this.referenceDelegate.xs(s).next(()=>t)).toPromise().then((t)=>(s.raiseOnCommittedEvent(), t));
    }
    Ns(t, e) {
        return $5c04988f82cad1b3$var$Pt.or(Object.values(this.bs).map((n)=>()=>n.containsKey(t, e)));
    }
    /**
     * The constructor accepts a factory for creating a reference delegate. This
     * allows both the delegate and this instance to have strong references to
     * each other without having nullable fields that would then need to be
     * checked or asserted on every access.
     */ constructor(t, e){
        this.bs = {}, this.overlays = {}, this.Ps = new $5c04988f82cad1b3$var$$t(0), this.vs = !1, this.vs = !0, this.referenceDelegate = t(this), this.Vs = new $5c04988f82cad1b3$var$ao(this);
        this.indexManager = new $5c04988f82cad1b3$var$mr, this.remoteDocumentCache = function(t) {
            return new $5c04988f82cad1b3$var$uo(t);
        }((t)=>this.referenceDelegate.Ss(t)), this.wt = new $5c04988f82cad1b3$var$Ui(e), this.Ds = new $5c04988f82cad1b3$var$no(this.wt);
    }
}
/**
 * Memory persistence is not actually transactional, but future implementations
 * may have transaction-scoped state.
 */ class $5c04988f82cad1b3$var$lo extends $5c04988f82cad1b3$var$Rt {
    constructor(t){
        super(), this.currentSequenceNumber = t;
    }
}
class $5c04988f82cad1b3$var$fo {
    static Ms(t) {
        return new $5c04988f82cad1b3$var$fo(t);
    }
    get Fs() {
        if (this.Os) return this.Os;
        throw $5c04988f82cad1b3$var$L();
    }
    addReference(t, e, n) {
        return this.ks.addReference(n, e), this.Fs.delete(n.toString()), $5c04988f82cad1b3$var$Pt.resolve();
    }
    removeReference(t, e, n) {
        return this.ks.removeReference(n, e), this.Fs.add(n.toString()), $5c04988f82cad1b3$var$Pt.resolve();
    }
    markPotentiallyOrphaned(t, e) {
        return this.Fs.add(e.toString()), $5c04988f82cad1b3$var$Pt.resolve();
    }
    removeTarget(t, e) {
        this.ks.us(e.targetId).forEach((t)=>this.Fs.add(t.toString()));
        const n = this.persistence.getTargetCache();
        return n.getMatchingKeysForTargetId(t, e.targetId).next((t)=>{
            t.forEach((t)=>this.Fs.add(t.toString()));
        }).next(()=>n.removeTargetData(t, e));
    }
    Cs() {
        this.Os = new Set;
    }
    xs(t) {
        // Remove newly orphaned documents.
        const e = this.persistence.getRemoteDocumentCache().newChangeBuffer();
        return $5c04988f82cad1b3$var$Pt.forEach(this.Fs, (n)=>{
            const s = $5c04988f82cad1b3$export$afc2e57c475b7810.fromPath(n);
            return this.$s(t, s).next((t)=>{
                t || e.removeEntry(s, $5c04988f82cad1b3$var$ct.min());
            });
        }).next(()=>(this.Os = null, e.apply(t)));
    }
    updateLimboDocument(t, e) {
        return this.$s(t, e).next((t)=>{
            t ? this.Fs.delete(e.toString()) : this.Fs.add(e.toString());
        });
    }
    Ss(t) {
        // For eager GC, we don't care about the document size, there are no size thresholds.
        return 0;
    }
    $s(t, e) {
        return $5c04988f82cad1b3$var$Pt.or([
            ()=>$5c04988f82cad1b3$var$Pt.resolve(this.ks.containsKey(e)),
            ()=>this.persistence.getTargetCache().containsKey(t, e),
            ()=>this.persistence.Ns(t, e)
        ]);
    }
    constructor(t){
        this.persistence = t, /** Tracks all documents that are active in Query views. */ this.ks = new $5c04988f82cad1b3$var$io, /** The list of documents that are potentially GCed after each transaction. */ this.Os = null;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Performs database creation and schema upgrades. */ class $5c04988f82cad1b3$var$_o {
    /**
     * Performs database creation and schema upgrades.
     *
     * Note that in production, this method is only ever used to upgrade the schema
     * to SCHEMA_VERSION. Different values of toVersion are only used for testing
     * and local feature development.
     */ O(t, e, n, s) {
        const i = new $5c04988f82cad1b3$var$vt("createOrUpgrade", e);
        n < 1 && s >= 1 && (function(t) {
            t.createObjectStore("owner");
        }(t), function(t) {
            t.createObjectStore("mutationQueues", {
                keyPath: "userId"
            });
            t.createObjectStore("mutations", {
                keyPath: "batchId",
                autoIncrement: !0
            }).createIndex("userMutationsIndex", $5c04988f82cad1b3$var$fi, {
                unique: !0
            }), t.createObjectStore("documentMutations");
        }(t), $5c04988f82cad1b3$var$wo(t), function(t) {
            t.createObjectStore("remoteDocuments");
        }(t));
        // Migration 2 to populate the targetGlobal object no longer needed since
        // migration 3 unconditionally clears it.
        let r = $5c04988f82cad1b3$var$Pt.resolve();
        return n < 3 && s >= 3 && // Brand new clients don't need to drop and recreate--only clients that
        // potentially have corrupt data.
        (0 !== n && (!function(t) {
            t.deleteObjectStore("targetDocuments"), t.deleteObjectStore("targets"), t.deleteObjectStore("targetGlobal");
        }(t), $5c04988f82cad1b3$var$wo(t)), r = r.next(()=>/**
 * Creates the target global singleton row.
 *
 * @param txn - The version upgrade transaction for indexeddb
 */ (function(t) {
                const e = t.store("targetGlobal"), n = {
                    highestTargetId: 0,
                    highestListenSequenceNumber: 0,
                    lastRemoteSnapshotVersion: $5c04988f82cad1b3$var$ct.min().toTimestamp(),
                    targetCount: 0
                };
                return e.put("targetGlobalKey", n);
            })(i))), n < 4 && s >= 4 && (0 !== n && // Schema version 3 uses auto-generated keys to generate globally unique
        // mutation batch IDs (this was previously ensured internally by the
        // client). To migrate to the new schema, we have to read all mutations
        // and write them back out. We preserve the existing batch IDs to guarantee
        // consistency with other object stores. Any further mutation batch IDs will
        // be auto-generated.
        (r = r.next(()=>(function(t, e) {
                return e.store("mutations").K().next((n)=>{
                    t.deleteObjectStore("mutations");
                    t.createObjectStore("mutations", {
                        keyPath: "batchId",
                        autoIncrement: !0
                    }).createIndex("userMutationsIndex", $5c04988f82cad1b3$var$fi, {
                        unique: !0
                    });
                    const s = e.store("mutations"), i = n.map((t)=>s.put(t));
                    return $5c04988f82cad1b3$var$Pt.waitFor(i);
                });
            })(t, i))), r = r.next(()=>{
            !function(t) {
                t.createObjectStore("clientMetadata", {
                    keyPath: "clientId"
                });
            }(t);
        })), n < 5 && s >= 5 && (r = r.next(()=>this.Bs(i))), n < 6 && s >= 6 && (r = r.next(()=>((function(t) {
                t.createObjectStore("remoteDocumentGlobal");
            })(t), this.Ls(i)))), n < 7 && s >= 7 && (r = r.next(()=>this.Us(i))), n < 8 && s >= 8 && (r = r.next(()=>this.qs(t, i))), n < 9 && s >= 9 && (r = r.next(()=>{
            // Multi-Tab used to manage its own changelog, but this has been moved
            // to the DbRemoteDocument object store itself. Since the previous change
            // log only contained transient data, we can drop its object store.
            !function(t) {
                t.objectStoreNames.contains("remoteDocumentChanges") && t.deleteObjectStore("remoteDocumentChanges");
            }(t);
        // Note: Schema version 9 used to create a read time index for the
        // RemoteDocumentCache. This is now done with schema version 13.
        })), n < 10 && s >= 10 && (r = r.next(()=>this.Ks(i))), n < 11 && s >= 11 && (r = r.next(()=>{
            !function(t) {
                t.createObjectStore("bundles", {
                    keyPath: "bundleId"
                });
            }(t), function(t) {
                t.createObjectStore("namedQueries", {
                    keyPath: "name"
                });
            }(t);
        })), n < 12 && s >= 12 && (r = r.next(()=>{
            !function(t) {
                const e = t.createObjectStore("documentOverlays", {
                    keyPath: $5c04988f82cad1b3$var$vi
                });
                e.createIndex("collectionPathOverlayIndex", $5c04988f82cad1b3$var$Vi, {
                    unique: !1
                }), e.createIndex("collectionGroupOverlayIndex", $5c04988f82cad1b3$var$Si, {
                    unique: !1
                });
            }(t);
        })), n < 13 && s >= 13 && (r = r.next(()=>(function(t) {
                const e = t.createObjectStore("remoteDocumentsV14", {
                    keyPath: $5c04988f82cad1b3$var$mi
                });
                e.createIndex("documentKeyIndex", $5c04988f82cad1b3$var$gi), e.createIndex("collectionGroupIndex", $5c04988f82cad1b3$var$yi);
            })(t)).next(()=>this.Gs(t, i)).next(()=>t.deleteObjectStore("remoteDocuments"))), n < 14 && s >= 14 && (r = r.next(()=>this.Qs(t, i))), n < 15 && s >= 15 && (r = r.next(()=>(function(t) {
                t.createObjectStore("indexConfiguration", {
                    keyPath: "indexId",
                    autoIncrement: !0
                }).createIndex("collectionGroupIndex", "collectionGroup", {
                    unique: !1
                });
                t.createObjectStore("indexState", {
                    keyPath: $5c04988f82cad1b3$var$Ai
                }).createIndex("sequenceNumberIndex", $5c04988f82cad1b3$var$Ri, {
                    unique: !1
                });
                t.createObjectStore("indexEntries", {
                    keyPath: $5c04988f82cad1b3$var$bi
                }).createIndex("documentKeyIndex", $5c04988f82cad1b3$var$Pi, {
                    unique: !1
                });
            })(t))), r;
    }
    Ls(t) {
        let e = 0;
        return t.store("remoteDocuments").J((t, n)=>{
            e += $5c04988f82cad1b3$var$Vr(n);
        }).next(()=>{
            const n = {
                byteSize: e
            };
            return t.store("remoteDocumentGlobal").put("remoteDocumentGlobalKey", n);
        });
    }
    Bs(t) {
        const e = t.store("mutationQueues"), n = t.store("mutations");
        return e.K().next((e)=>$5c04988f82cad1b3$var$Pt.forEach(e, (e)=>{
                const s = IDBKeyRange.bound([
                    e.userId,
                    -1
                ], [
                    e.userId,
                    e.lastAcknowledgedBatchId
                ]);
                return n.K("userMutationsIndex", s).next((n)=>$5c04988f82cad1b3$var$Pt.forEach(n, (n)=>{
                        $5c04988f82cad1b3$var$U(n.userId === e.userId);
                        const s = $5c04988f82cad1b3$var$Wi(this.wt, n);
                        return $5c04988f82cad1b3$var$vr(t, e.userId, s).next(()=>{});
                    }));
            }));
    }
    /**
     * Ensures that every document in the remote document cache has a corresponding sentinel row
     * with a sequence number. Missing rows are given the most recently used sequence number.
     */ Us(t) {
        const e = t.store("targetDocuments"), n = t.store("remoteDocuments");
        return t.store("targetGlobal").get("targetGlobalKey").next((t)=>{
            const s = [];
            return n.J((n, i)=>{
                const r = new $5c04988f82cad1b3$var$ht(n), o = function(t) {
                    return [
                        0,
                        $5c04988f82cad1b3$var$ci(t)
                    ];
                }(r);
                s.push(e.get(o).next((n)=>n ? $5c04988f82cad1b3$var$Pt.resolve() : ((n)=>e.put({
                            targetId: 0,
                            path: $5c04988f82cad1b3$var$ci(n),
                            sequenceNumber: t.highestListenSequenceNumber
                        }))(r)));
            }).next(()=>$5c04988f82cad1b3$var$Pt.waitFor(s));
        });
    }
    qs(t, e) {
        // Create the index.
        t.createObjectStore("collectionParents", {
            keyPath: $5c04988f82cad1b3$var$Ei
        });
        const n = e.store("collectionParents"), s = new $5c04988f82cad1b3$var$gr, i = (t)=>{
            if (s.add(t)) {
                const e = t.lastSegment(), s = t.popLast();
                return n.put({
                    collectionId: e,
                    parent: $5c04988f82cad1b3$var$ci(s)
                });
            }
        };
        // Helper to add an index entry iff we haven't already written it.
        // Index existing remote documents.
        return e.store("remoteDocuments").J({
            H: !0
        }, (t, e)=>{
            const n = new $5c04988f82cad1b3$var$ht(t);
            return i(n.popLast());
        }).next(()=>e.store("documentMutations").J({
                H: !0
            }, ([t, e, n], s)=>{
                const r = $5c04988f82cad1b3$var$li(e);
                return i(r.popLast());
            }));
    }
    Ks(t) {
        const e = t.store("targets");
        return e.J((t, n)=>{
            const s = $5c04988f82cad1b3$var$zi(n), i = $5c04988f82cad1b3$var$Hi(this.wt, s);
            return e.put(i);
        });
    }
    Gs(t, e) {
        const n = e.store("remoteDocuments"), s = [];
        return n.J((t, n)=>{
            const i = e.store("remoteDocumentsV14"), r = (o = n, o.document ? new $5c04988f82cad1b3$export$afc2e57c475b7810($5c04988f82cad1b3$var$ht.fromString(o.document.name).popFirst(5)) : o.noDocument ? $5c04988f82cad1b3$export$afc2e57c475b7810.fromSegments(o.noDocument.path) : o.unknownDocument ? $5c04988f82cad1b3$export$afc2e57c475b7810.fromSegments(o.unknownDocument.path) : $5c04988f82cad1b3$var$L()).path.toArray();
            var o;
            /**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const u = {
                prefixPath: r.slice(0, r.length - 2),
                collectionGroup: r[r.length - 2],
                documentId: r[r.length - 1],
                readTime: n.readTime || [
                    0,
                    0
                ],
                unknownDocument: n.unknownDocument,
                noDocument: n.noDocument,
                document: n.document,
                hasCommittedMutations: !!n.hasCommittedMutations
            };
            s.push(i.put(u));
        }).next(()=>$5c04988f82cad1b3$var$Pt.waitFor(s));
    }
    Qs(t, e) {
        const n = e.store("mutations"), s = $5c04988f82cad1b3$var$Wr(this.wt), i = new $5c04988f82cad1b3$var$ho($5c04988f82cad1b3$var$fo.Ms, this.wt.ne);
        return n.K().next((t)=>{
            const n = new Map;
            return t.forEach((t)=>{
                var e;
                let s = null !== (e = n.get(t.userId)) && void 0 !== e ? e : $5c04988f82cad1b3$var$ws();
                $5c04988f82cad1b3$var$Wi(this.wt, t).keys().forEach((t)=>s = s.add(t)), n.set(t.userId, s);
            }), $5c04988f82cad1b3$var$Pt.forEach(n, (t, n)=>{
                const r = new $5c04988f82cad1b3$var$C(n), o = $5c04988f82cad1b3$var$sr.se(this.wt, r), u = i.getIndexManager(r), c = $5c04988f82cad1b3$var$Sr.se(r, this.wt, u, i.referenceDelegate);
                return new $5c04988f82cad1b3$var$eo(s, c, o, u).recalculateAndSaveOverlaysForDocumentKeys(new $5c04988f82cad1b3$var$Oi(e, $5c04988f82cad1b3$var$$t.ot), t).next();
            });
        });
    }
    constructor(t){
        this.wt = t;
    }
}
function $5c04988f82cad1b3$var$wo(t) {
    t.createObjectStore("targetDocuments", {
        keyPath: $5c04988f82cad1b3$var$Ii
    }).createIndex("documentTargetsIndex", $5c04988f82cad1b3$var$Ti, {
        unique: !0
    });
    // NOTE: This is unique only because the TargetId is the suffix.
    t.createObjectStore("targets", {
        keyPath: "targetId"
    }).createIndex("queryTargetsIndex", $5c04988f82cad1b3$var$pi, {
        unique: !0
    }), t.createObjectStore("targetGlobal");
}
const $5c04988f82cad1b3$var$mo = "Failed to obtain exclusive access to the persistence layer. To allow shared access, multi-tab synchronization has to be enabled in all tabs. If you are using `experimentalForceOwningTab:true`, make sure that only one tab has persistence enabled at any given time.";
/**
 * Oldest acceptable age in milliseconds for client metadata before the client
 * is considered inactive and its associated data is garbage collected.
 */ /**
 * An IndexedDB-backed instance of Persistence. Data is stored persistently
 * across sessions.
 *
 * On Web only, the Firestore SDKs support shared access to its persistence
 * layer. This allows multiple browser tabs to read and write to IndexedDb and
 * to synchronize state even without network connectivity. Shared access is
 * currently optional and not enabled unless all clients invoke
 * `enablePersistence()` with `{synchronizeTabs:true}`.
 *
 * In multi-tab mode, if multiple clients are active at the same time, the SDK
 * will designate one client as the “primary client”. An effort is made to pick
 * a visible, network-connected and active client, and this client is
 * responsible for letting other clients know about its presence. The primary
 * client writes a unique client-generated identifier (the client ID) to
 * IndexedDb’s “owner” store every 4 seconds. If the primary client fails to
 * update this entry, another client can acquire the lease and take over as
 * primary.
 *
 * Some persistence operations in the SDK are designated as primary-client only
 * operations. This includes the acknowledgment of mutations and all updates of
 * remote documents. The effects of these operations are written to persistence
 * and then broadcast to other tabs via LocalStorage (see
 * `WebStorageSharedClientState`), which then refresh their state from
 * persistence.
 *
 * Similarly, the primary client listens to notifications sent by secondary
 * clients to discover persistence changes written by secondary clients, such as
 * the addition of new mutations and query targets.
 *
 * If multi-tab is not enabled and another tab already obtained the primary
 * lease, IndexedDbPersistence enters a failed state and all subsequent
 * operations will automatically fail.
 *
 * Additionally, there is an optimization so that when a tab is closed, the
 * primary lease is released immediately (this is especially important to make
 * sure that a refreshed tab is able to immediately re-acquire the primary
 * lease). Unfortunately, IndexedDB cannot be reliably used in window.unload
 * since it is an asynchronous API. So in addition to attempting to give up the
 * lease, the leaseholder writes its client ID to a "zombiedClient" entry in
 * LocalStorage which acts as an indicator that another tab should go ahead and
 * take the primary lease immediately regardless of the current lease timestamp.
 *
 * TODO(b/114226234): Remove `synchronizeTabs` section when multi-tab is no
 * longer optional.
 */ class $5c04988f82cad1b3$var$go {
    /**
     * Attempt to start IndexedDb persistence.
     *
     * @returns Whether persistence was enabled.
     */ start() {
        // NOTE: This is expected to fail sometimes (in the case of another tab
        // already having the persistence lock), so it's the first thing we should
        // do.
        return this.ii().then(()=>{
            if (!this.isPrimary && !this.allowTabSynchronization) // Fail `start()` if `synchronizeTabs` is disabled and we cannot
            // obtain the primary lease.
            throw new $5c04988f82cad1b3$export$8fada0bf726bf278($5c04988f82cad1b3$var$G.FAILED_PRECONDITION, $5c04988f82cad1b3$var$mo);
            return this.ri(), this.oi(), this.ui(), this.runTransaction("getHighestListenSequenceNumber", "readonly", (t)=>this.Vs.getHighestSequenceNumber(t));
        }).then((t)=>{
            this.Ps = new $5c04988f82cad1b3$var$$t(t, this.Ws);
        }).then(()=>{
            this.vs = !0;
        }).catch((t)=>(this.ni && this.ni.close(), Promise.reject(t)));
    }
    /**
     * Registers a listener that gets called when the primary state of the
     * instance changes. Upon registering, this listener is invoked immediately
     * with the current primary state.
     *
     * PORTING NOTE: This is only used for Web multi-tab.
     */ ci(t) {
        return this.ti = async (e)=>{
            if (this.started) return t(e);
        }, t(this.isPrimary);
    }
    /**
     * Registers a listener that gets called when the database receives a
     * version change event indicating that it has deleted.
     *
     * PORTING NOTE: This is only used for Web multi-tab.
     */ setDatabaseDeletedListener(t) {
        this.ni.F(async (e)=>{
            // Check if an attempt is made to delete IndexedDB.
            null === e.newVersion && await t();
        });
    }
    /**
     * Adjusts the current network state in the client's metadata, potentially
     * affecting the primary lease.
     *
     * PORTING NOTE: This is only used for Web multi-tab.
     */ setNetworkEnabled(t) {
        this.networkEnabled !== t && (this.networkEnabled = t, // Schedule a primary lease refresh for immediate execution. The eventual
        // lease update will be propagated via `primaryStateListener`.
        this.js.enqueueAndForget(async ()=>{
            this.started && await this.ii();
        }));
    }
    /**
     * Updates the client metadata in IndexedDb and attempts to either obtain or
     * extend the primary lease for the local client. Asynchronously notifies the
     * primary state listener if the client either newly obtained or released its
     * primary lease.
     */ ii() {
        return this.runTransaction("updateClientMetadataAndTryBecomePrimary", "readwrite", (t)=>$5c04988f82cad1b3$var$po(t).put({
                clientId: this.clientId,
                updateTimeMs: Date.now(),
                networkEnabled: this.networkEnabled,
                inForeground: this.inForeground
            }).next(()=>{
                if (this.isPrimary) return this.ai(t).next((t)=>{
                    t || (this.isPrimary = !1, this.js.enqueueRetryable(()=>this.ti(!1)));
                });
            }).next(()=>this.hi(t)).next((e)=>this.isPrimary && !e ? this.li(t).next(()=>!1) : !!e && this.fi(t).next(()=>!0))).catch((t)=>{
            if ($5c04988f82cad1b3$var$Ct(t)) // Proceed with the existing state. Any subsequent access to
            // IndexedDB will verify the lease.
            return $5c04988f82cad1b3$var$M("IndexedDbPersistence", "Failed to extend owner lease: ", t), this.isPrimary;
            if (!this.allowTabSynchronization) throw t;
            return $5c04988f82cad1b3$var$M("IndexedDbPersistence", "Releasing owner lease after error during lease refresh", t), /* isPrimary= */ !1;
        }).then((t)=>{
            this.isPrimary !== t && this.js.enqueueRetryable(()=>this.ti(t)), this.isPrimary = t;
        });
    }
    ai(t) {
        return $5c04988f82cad1b3$var$yo(t).get("owner").next((t)=>$5c04988f82cad1b3$var$Pt.resolve(this.di(t)));
    }
    _i(t) {
        return $5c04988f82cad1b3$var$po(t).delete(this.clientId);
    }
    /**
     * If the garbage collection threshold has passed, prunes the
     * RemoteDocumentChanges and the ClientMetadata store based on the last update
     * time of all clients.
     */ async wi() {
        if (this.isPrimary && !this.mi(this.Zs, 18e5)) {
            this.Zs = Date.now();
            const t = await this.runTransaction("maybeGarbageCollectMultiClientState", "readwrite-primary", (t)=>{
                const e = $5c04988f82cad1b3$var$Mi(t, "clientMetadata");
                return e.K().next((t)=>{
                    const n = this.gi(t, 18e5), s = t.filter((t)=>-1 === n.indexOf(t));
                    // Delete metadata for clients that are no longer considered active.
                    return $5c04988f82cad1b3$var$Pt.forEach(s, (t)=>e.delete(t.clientId)).next(()=>s);
                });
            }).catch(()=>[]);
            // Delete potential leftover entries that may continue to mark the
            // inactive clients as zombied in LocalStorage.
            // Ideally we'd delete the IndexedDb and LocalStorage zombie entries for
            // the client atomically, but we can't. So we opt to delete the IndexedDb
            // entries first to avoid potentially reviving a zombied client.
            if (this.si) for (const e of t)this.si.removeItem(this.yi(e.clientId));
        }
    }
    /**
     * Schedules a recurring timer to update the client metadata and to either
     * extend or acquire the primary lease if the client is eligible.
     */ ui() {
        this.Xs = this.js.enqueueAfterDelay("client_metadata_refresh" /* ClientMetadataRefresh */ , 4e3, ()=>this.ii().then(()=>this.wi()).then(()=>this.ui()));
    }
    /** Checks whether `client` is the local client. */ di(t) {
        return !!t && t.ownerId === this.clientId;
    }
    /**
     * Evaluate the state of all active clients and determine whether the local
     * client is or can act as the holder of the primary lease. Returns whether
     * the client is eligible for the lease, but does not actually acquire it.
     * May return 'false' even if there is no active leaseholder and another
     * (foreground) client should become leaseholder instead.
     */ hi(t) {
        if (this.zs) return $5c04988f82cad1b3$var$Pt.resolve(!0);
        return $5c04988f82cad1b3$var$yo(t).get("owner").next((e)=>{
            // A client is eligible for the primary lease if:
            // - its network is enabled and the client's tab is in the foreground.
            // - its network is enabled and no other client's tab is in the
            //   foreground.
            // - every clients network is disabled and the client's tab is in the
            //   foreground.
            // - every clients network is disabled and no other client's tab is in
            //   the foreground.
            // - the `forceOwningTab` setting was passed in.
            if (null !== e && this.mi(e.leaseTimestampMs, 5e3) && !this.pi(e.ownerId)) {
                if (this.di(e) && this.networkEnabled) return !0;
                if (!this.di(e)) {
                    if (!e.allowTabSynchronization) // Fail the `canActAsPrimary` check if the current leaseholder has
                    // not opted into multi-tab synchronization. If this happens at
                    // client startup, we reject the Promise returned by
                    // `enablePersistence()` and the user can continue to use Firestore
                    // with in-memory persistence.
                    // If this fails during a lease refresh, we will instead block the
                    // AsyncQueue from executing further operations. Note that this is
                    // acceptable since mixing & matching different `synchronizeTabs`
                    // settings is not supported.
                    // TODO(b/114226234): Remove this check when `synchronizeTabs` can
                    // no longer be turned off.
                    throw new $5c04988f82cad1b3$export$8fada0bf726bf278($5c04988f82cad1b3$var$G.FAILED_PRECONDITION, $5c04988f82cad1b3$var$mo);
                    return !1;
                }
            }
            return !(!this.networkEnabled || !this.inForeground) || $5c04988f82cad1b3$var$po(t).K().next((t)=>void 0 === this.gi(t, 5e3).find((t)=>{
                    if (this.clientId !== t.clientId) {
                        const e = !this.networkEnabled && t.networkEnabled, n = !this.inForeground && t.inForeground, s = this.networkEnabled === t.networkEnabled;
                        if (e || n && s) return !0;
                    }
                    return !1;
                }));
        }).next((t)=>(this.isPrimary !== t && $5c04988f82cad1b3$var$M("IndexedDbPersistence", `Client ${t ? "is" : "is not"} eligible for a primary lease.`), t));
    }
    async shutdown() {
        // The shutdown() operations are idempotent and can be called even when
        // start() aborted (e.g. because it couldn't acquire the persistence lease).
        this.vs = !1, this.Ii(), this.Xs && (this.Xs.cancel(), this.Xs = null), this.Ti(), this.Ei(), // Use `SimpleDb.runTransaction` directly to avoid failing if another tab
        // has obtained the primary lease.
        await this.ni.runTransaction("shutdown", "readwrite", [
            "owner",
            "clientMetadata"
        ], (t)=>{
            const e = new $5c04988f82cad1b3$var$Oi(t, $5c04988f82cad1b3$var$$t.ot);
            return this.li(e).next(()=>this._i(e));
        }), this.ni.close(), // Remove the entry marking the client as zombied from LocalStorage since
        // we successfully deleted its metadata from IndexedDb.
        this.Ai();
    }
    /**
     * Returns clients that are not zombied and have an updateTime within the
     * provided threshold.
     */ gi(t, e) {
        return t.filter((t)=>this.mi(t.updateTimeMs, e) && !this.pi(t.clientId));
    }
    /**
     * Returns the IDs of the clients that are currently active. If multi-tab
     * is not supported, returns an array that only contains the local client's
     * ID.
     *
     * PORTING NOTE: This is only used for Web multi-tab.
     */ Ri() {
        return this.runTransaction("getActiveClients", "readonly", (t)=>$5c04988f82cad1b3$var$po(t).K().next((t)=>this.gi(t, 18e5).map((t)=>t.clientId)));
    }
    get started() {
        return this.vs;
    }
    getMutationQueue(t, e) {
        return $5c04988f82cad1b3$var$Sr.se(t, this.wt, e, this.referenceDelegate);
    }
    getTargetCache() {
        return this.Vs;
    }
    getRemoteDocumentCache() {
        return this.remoteDocumentCache;
    }
    getIndexManager(t) {
        return new $5c04988f82cad1b3$var$pr(t, this.wt.ne.databaseId);
    }
    getDocumentOverlayCache(t) {
        return $5c04988f82cad1b3$var$sr.se(this.wt, t);
    }
    getBundleCache() {
        return this.Ds;
    }
    runTransaction(t, e, n) {
        $5c04988f82cad1b3$var$M("IndexedDbPersistence", "Starting transaction:", t);
        const s = "readonly" === e ? "readonly" : "readwrite", i = 15 === (r = this.Hs) ? $5c04988f82cad1b3$var$ki : 14 === r ? $5c04988f82cad1b3$var$Ni : 13 === r ? $5c04988f82cad1b3$var$xi : 12 === r ? $5c04988f82cad1b3$var$Ci : 11 === r ? $5c04988f82cad1b3$var$Di : void $5c04988f82cad1b3$var$L();
        /** Returns the object stores for the provided schema. */ var r;
        let o;
        // Do all transactions as readwrite against all object stores, since we
        // are the only reader/writer.
        return this.ni.runTransaction(t, s, i, (s)=>(o = new $5c04988f82cad1b3$var$Oi(s, this.Ps ? this.Ps.next() : $5c04988f82cad1b3$var$$t.ot), "readwrite-primary" === e ? this.ai(o).next((t)=>!!t || this.hi(o)).next((e)=>{
                if (!e) throw $5c04988f82cad1b3$var$F(`Failed to obtain primary lease for action '${t}'.`), this.isPrimary = !1, this.js.enqueueRetryable(()=>this.ti(!1)), new $5c04988f82cad1b3$export$8fada0bf726bf278($5c04988f82cad1b3$var$G.FAILED_PRECONDITION, $5c04988f82cad1b3$var$At);
                return n(o);
            }).next((t)=>this.fi(o).next(()=>t)) : this.bi(o).next(()=>n(o)))).then((t)=>(o.raiseOnCommittedEvent(), t));
    }
    /**
     * Verifies that the current tab is the primary leaseholder or alternatively
     * that the leaseholder has opted into multi-tab synchronization.
     */ // TODO(b/114226234): Remove this check when `synchronizeTabs` can no longer
    // be turned off.
    bi(t) {
        return $5c04988f82cad1b3$var$yo(t).get("owner").next((t)=>{
            if (null !== t && this.mi(t.leaseTimestampMs, 5e3) && !this.pi(t.ownerId) && !this.di(t) && !(this.zs || this.allowTabSynchronization && t.allowTabSynchronization)) throw new $5c04988f82cad1b3$export$8fada0bf726bf278($5c04988f82cad1b3$var$G.FAILED_PRECONDITION, $5c04988f82cad1b3$var$mo);
        });
    }
    /**
     * Obtains or extends the new primary lease for the local client. This
     * method does not verify that the client is eligible for this lease.
     */ fi(t) {
        const e = {
            ownerId: this.clientId,
            allowTabSynchronization: this.allowTabSynchronization,
            leaseTimestampMs: Date.now()
        };
        return $5c04988f82cad1b3$var$yo(t).put("owner", e);
    }
    static V() {
        return $5c04988f82cad1b3$var$Vt.V();
    }
    /** Checks the primary lease and removes it if we are the current primary. */ li(t) {
        const e = $5c04988f82cad1b3$var$yo(t);
        return e.get("owner").next((t)=>this.di(t) ? ($5c04988f82cad1b3$var$M("IndexedDbPersistence", "Releasing primary lease."), e.delete("owner")) : $5c04988f82cad1b3$var$Pt.resolve());
    }
    /** Verifies that `updateTimeMs` is within `maxAgeMs`. */ mi(t, e) {
        const n = Date.now();
        return !(t < n - e) && (!(t > n) || ($5c04988f82cad1b3$var$F(`Detected an update time that is in the future: ${t} > ${n}`), !1));
    }
    ri() {
        null !== this.document && "function" == typeof this.document.addEventListener && (this.Ys = ()=>{
            this.js.enqueueAndForget(()=>(this.inForeground = "visible" === this.document.visibilityState, this.ii()));
        }, this.document.addEventListener("visibilitychange", this.Ys), this.inForeground = "visible" === this.document.visibilityState);
    }
    Ti() {
        this.Ys && (this.document.removeEventListener("visibilitychange", this.Ys), this.Ys = null);
    }
    /**
     * Attaches a window.unload handler that will synchronously write our
     * clientId to a "zombie client id" location in LocalStorage. This can be used
     * by tabs trying to acquire the primary lease to determine that the lease
     * is no longer valid even if the timestamp is recent. This is particularly
     * important for the refresh case (so the tab correctly re-acquires the
     * primary lease). LocalStorage is used for this rather than IndexedDb because
     * it is a synchronous API and so can be used reliably from  an unload
     * handler.
     */ oi() {
        var t;
        "function" == typeof (null === (t = this.window) || void 0 === t ? void 0 : t.addEventListener) && (this.Js = ()=>{
            // Note: In theory, this should be scheduled on the AsyncQueue since it
            // accesses internal state. We execute this code directly during shutdown
            // to make sure it gets a chance to run.
            this.Ii(), (0, $isbtl.isSafari)() && navigator.appVersion.match(/Version\/1[45]/) && // On Safari 14 and 15, we do not run any cleanup actions as it might
            // trigger a bug that prevents Safari from re-opening IndexedDB during
            // the next page load.
            // See https://bugs.webkit.org/show_bug.cgi?id=226547
            this.js.enterRestrictedMode(/* purgeExistingTasks= */ !0), this.js.enqueueAndForget(()=>this.shutdown());
        }, this.window.addEventListener("pagehide", this.Js));
    }
    Ei() {
        this.Js && (this.window.removeEventListener("pagehide", this.Js), this.Js = null);
    }
    /**
     * Returns whether a client is "zombied" based on its LocalStorage entry.
     * Clients become zombied when their tab closes without running all of the
     * cleanup logic in `shutdown()`.
     */ pi(t) {
        var e;
        try {
            const n = null !== (null === (e = this.si) || void 0 === e ? void 0 : e.getItem(this.yi(t)));
            return $5c04988f82cad1b3$var$M("IndexedDbPersistence", `Client '${t}' ${n ? "is" : "is not"} zombied in LocalStorage`), n;
        } catch (t) {
            // Gracefully handle if LocalStorage isn't working.
            return $5c04988f82cad1b3$var$F("IndexedDbPersistence", "Failed to get zombied client id.", t), !1;
        }
    }
    /**
     * Record client as zombied (a client that had its tab closed). Zombied
     * clients are ignored during primary tab selection.
     */ Ii() {
        if (this.si) try {
            this.si.setItem(this.yi(this.clientId), String(Date.now()));
        } catch (t) {
            // Gracefully handle if LocalStorage isn't available / working.
            $5c04988f82cad1b3$var$F("Failed to set zombie client id.", t);
        }
    }
    /** Removes the zombied client entry if it exists. */ Ai() {
        if (this.si) try {
            this.si.removeItem(this.yi(this.clientId));
        } catch (t) {
        // Ignore
        }
    }
    yi(t) {
        return `firestore_zombie_${this.persistenceKey}_${t}`;
    }
    constructor(/**
     * Whether to synchronize the in-memory state of multiple tabs and share
     * access to local persistence.
     */ t, e, n, s, i, r, o, u, c, /**
     * If set to true, forcefully obtains database access. Existing tabs will
     * no longer be able to access IndexedDB.
     */ a, h = 14){
        if (this.allowTabSynchronization = t, this.persistenceKey = e, this.clientId = n, this.js = i, this.window = r, this.document = o, this.Ws = c, this.zs = a, this.Hs = h, this.Ps = null, this.vs = !1, this.isPrimary = !1, this.networkEnabled = !0, /** Our window.unload handler, if registered. */ this.Js = null, this.inForeground = !1, /** Our 'visibilitychange' listener if registered. */ this.Ys = null, /** The client metadata refresh task. */ this.Xs = null, /** The last time we garbage collected the client metadata object store. */ this.Zs = Number.NEGATIVE_INFINITY, /** A listener to notify on primary state changes. */ this.ti = (t)=>Promise.resolve(), !$5c04988f82cad1b3$var$go.V()) throw new $5c04988f82cad1b3$export$8fada0bf726bf278($5c04988f82cad1b3$var$G.UNIMPLEMENTED, "This platform is either missing IndexedDB or is known to have an incomplete implementation. Offline persistence has been disabled.");
        this.referenceDelegate = new $5c04988f82cad1b3$var$Kr(this, s), this.ei = e + "main", this.wt = new $5c04988f82cad1b3$var$Ui(u), this.ni = new $5c04988f82cad1b3$var$Vt(this.ei, this.Hs, new $5c04988f82cad1b3$var$_o(this.wt)), this.Vs = new $5c04988f82cad1b3$var$Or(this.referenceDelegate, this.wt), this.remoteDocumentCache = $5c04988f82cad1b3$var$Wr(this.wt), this.Ds = new $5c04988f82cad1b3$var$tr, this.window && this.window.localStorage ? this.si = this.window.localStorage : (this.si = null, !1 === a && $5c04988f82cad1b3$var$F("IndexedDbPersistence", "LocalStorage is unavailable. As a result, persistence may not work reliably. In particular enablePersistence() could fail immediately after refreshing the page."));
    }
}
/**
 * Helper to get a typed SimpleDbStore for the primary client object store.
 */ function $5c04988f82cad1b3$var$yo(t) {
    return $5c04988f82cad1b3$var$Mi(t, "owner");
}
/**
 * Helper to get a typed SimpleDbStore for the client metadata object store.
 */ function $5c04988f82cad1b3$var$po(t) {
    return $5c04988f82cad1b3$var$Mi(t, "clientMetadata");
}
/**
 * Generates a string used as a prefix when storing data in IndexedDB and
 * LocalStorage.
 */ function $5c04988f82cad1b3$var$Io(t, e) {
    // Use two different prefix formats:
    //   * firestore / persistenceKey / projectID . databaseID / ...
    //   * firestore / persistenceKey / projectID / ...
    // projectIDs are DNS-compatible names and cannot contain dots
    // so there's no danger of collisions.
    let n = t.projectId;
    return t.isDefaultDatabase || (n += "." + t.database), "firestore/" + e + "/" + n + "/";
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A set of changes to what documents are currently in view and out of view for
 * a given query. These changes are sent to the LocalStore by the View (via
 * the SyncEngine) and are used to pin / unpin documents as appropriate.
 */ class $5c04988f82cad1b3$var$To {
    static Vi(t, e) {
        let n = $5c04988f82cad1b3$var$ws(), s = $5c04988f82cad1b3$var$ws();
        for (const t of e.docChanges)switch(t.type){
            case 0 /* Added */ :
                n = n.add(t.doc.key);
                break;
            case 1 /* Removed */ :
                s = s.add(t.doc.key);
        }
        return new $5c04988f82cad1b3$var$To(t, e.fromCache, n, s);
    }
    constructor(t, e, n, s){
        this.targetId = t, this.fromCache = e, this.Pi = n, this.vi = s;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The Firestore query engine.
 *
 * Firestore queries can be executed in three modes. The Query Engine determines
 * what mode to use based on what data is persisted. The mode only determines
 * the runtime complexity of the query - the result set is equivalent across all
 * implementations.
 *
 * The Query engine will use indexed-based execution if a user has configured
 * any index that can be used to execute query (via `setIndexConfiguration()`).
 * Otherwise, the engine will try to optimize the query by re-using a previously
 * persisted query result. If that is not possible, the query will be executed
 * via a full collection scan.
 *
 * Index-based execution is the default when available. The query engine
 * supports partial indexed execution and merges the result from the index
 * lookup with documents that have not yet been indexed. The index evaluation
 * matches the backend's format and as such, the SDK can use indexing for all
 * queries that the backend supports.
 *
 * If no index exists, the query engine tries to take advantage of the target
 * document mapping in the TargetCache. These mappings exists for all queries
 * that have been synced with the backend at least once and allow the query
 * engine to only read documents that previously matched a query plus any
 * documents that were edited after the query was last listened to.
 *
 * There are some cases when this optimization is not guaranteed to produce
 * the same results as full collection scans. In these cases, query
 * processing falls back to full scans. These cases are:
 *
 * - Limit queries where a document that matched the query previously no longer
 *   matches the query.
 *
 * - Limit queries where a document edit may cause the document to sort below
 *   another document that is in the local cache.
 *
 * - Queries that have never been CURRENT or free of limbo documents.
 */ class $5c04988f82cad1b3$var$Eo {
    /** Sets the document view to query against. */ initialize(t, e) {
        this.Di = t, this.indexManager = e, this.Si = !0;
    }
    /** Returns all local documents matching the specified query. */ getDocumentsMatchingQuery(t, e, n, s) {
        return this.Ci(t, e).next((i)=>i || this.xi(t, e, s, n)).next((n)=>n || this.Ni(t, e));
    }
    /**
     * Performs an indexed query that evaluates the query based on a collection's
     * persisted index values. Returns `null` if an index is not available.
     */ Ci(t, e) {
        return $5c04988f82cad1b3$var$Pt.resolve(null);
    }
    /**
     * Performs a query based on the target's persisted query mapping. Returns
     * `null` if the mapping is not available or cannot be used.
     */ xi(t, e, n, s) {
        return $5c04988f82cad1b3$var$on(e) || s.isEqual($5c04988f82cad1b3$var$ct.min()) ? this.Ni(t, e) : this.Di.getDocuments(t, n).next((i)=>{
            const r = this.ki(e, i);
            return this.Oi(e, r, n, s) ? this.Ni(t, e) : ($5c04988f82cad1b3$var$k() <= (0, $gDOOI.LogLevel).DEBUG && $5c04988f82cad1b3$var$M("QueryEngine", "Re-using previous result from %s to execute query: %s", s.toString(), $5c04988f82cad1b3$var$wn(e)), this.Mi(t, r, e, $5c04988f82cad1b3$var$pt(s, -1)));
        });
    // Queries that have never seen a snapshot without limbo free documents
    // should also be run as a full collection scan.
    }
    /** Applies the query filter and sorting to the provided documents.  */ ki(t, e) {
        // Sort the documents and re-apply the query filter since previously
        // matching documents do not necessarily still match the query.
        let n = new $5c04988f82cad1b3$var$Qt($5c04988f82cad1b3$var$yn(t));
        return e.forEach((e, s)=>{
            $5c04988f82cad1b3$var$mn(t, s) && (n = n.add(s));
        }), n;
    }
    /**
     * Determines if a limit query needs to be refilled from cache, making it
     * ineligible for index-free execution.
     *
     * @param query - The query.
     * @param sortedPreviousResults - The documents that matched the query when it
     * was last synchronized, sorted by the query's comparator.
     * @param remoteKeys - The document keys that matched the query at the last
     * snapshot.
     * @param limboFreeSnapshotVersion - The version of the snapshot when the
     * query was last synchronized.
     */ Oi(t, e, n, s) {
        if (null === t.limit) // Queries without limits do not need to be refilled.
        return !1;
        if (n.size !== e.size) // The query needs to be refilled if a previously matching document no
        // longer matches.
        return !0;
        // Limit queries are not eligible for index-free query execution if there is
        // a potential that an older document from cache now sorts before a document
        // that was previously part of the limit. This, however, can only happen if
        // the document at the edge of the limit goes out of limit.
        // If a document that is not the limit boundary sorts differently,
        // the boundary of the limit itself did not change and documents from cache
        // will continue to be "rejected" by this boundary. Therefore, we can ignore
        // any modifications that don't affect the last document.
        const i = "F" /* First */  === t.limitType ? e.last() : e.first();
        return !!i && (i.hasPendingWrites || i.version.compareTo(s) > 0);
    }
    Ni(t, e) {
        return $5c04988f82cad1b3$var$k() <= (0, $gDOOI.LogLevel).DEBUG && $5c04988f82cad1b3$var$M("QueryEngine", "Using full collection scan to execute query:", $5c04988f82cad1b3$var$wn(e)), this.Di.getDocumentsMatchingQuery(t, e, $5c04988f82cad1b3$var$Tt.min());
    }
    /**
     * Combines the results from an indexed execution with the remaining documents
     * that have not yet been indexed.
     */ Mi(t, e, n, s) {
        // Retrieve all results for documents that were updated since the offset.
        return this.Di.getDocumentsMatchingQuery(t, n, s).next((t)=>// Merge with existing results
            (e.forEach((e)=>{
                t = t.insert(e.key, e);
            }), t));
    }
    constructor(){
        this.Si = !1;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Implements `LocalStore` interface.
 *
 * Note: some field defined in this class might have public access level, but
 * the class is not exported so they are only accessible from this module.
 * This is useful to implement optional features (like bundles) in free
 * functions, such that they are tree-shakeable.
 */ class $5c04988f82cad1b3$var$Ao {
    qi(t) {
        // TODO(indexing): Add spec tests that test these components change after a
        // user change
        this.documentOverlayCache = this.persistence.getDocumentOverlayCache(t), this.indexManager = this.persistence.getIndexManager(t), this.mutationQueue = this.persistence.getMutationQueue(t, this.indexManager), this.localDocuments = new $5c04988f82cad1b3$var$eo(this.Ui, this.mutationQueue, this.documentOverlayCache, this.indexManager), this.Ui.setIndexManager(this.indexManager), this.Fi.initialize(this.localDocuments, this.indexManager);
    }
    collectGarbage(t) {
        return this.persistence.runTransaction("Collect garbage", "readwrite-primary", (e)=>t.collect(e, this.$i));
    }
    constructor(/** Manages our in-memory or durable persistence. */ t, e, n, s){
        this.persistence = t, this.Fi = e, this.wt = s, /**
         * Maps a targetID to data about its target.
         *
         * PORTING NOTE: We are using an immutable data structure on Web to make re-runs
         * of `applyRemoteEvent()` idempotent.
         */ this.$i = new $5c04988f82cad1b3$var$qt($5c04988f82cad1b3$var$it), /** Maps a target to its targetID. */ // TODO(wuandy): Evaluate if TargetId can be part of Target.
        this.Bi = new $5c04988f82cad1b3$var$is((t)=>$5c04988f82cad1b3$var$Oe(t), $5c04988f82cad1b3$var$Fe), /**
         * A per collection group index of the last read time processed by
         * `getNewDocumentChanges()`.
         *
         * PORTING NOTE: This is only used for multi-tab synchronization.
         */ this.Li = new Map, this.Ui = t.getRemoteDocumentCache(), this.Vs = t.getTargetCache(), this.Ds = t.getBundleCache(), this.qi(n);
    }
}
function $5c04988f82cad1b3$var$Ro(/** Manages our in-memory or durable persistence. */ t, e, n, s) {
    return new $5c04988f82cad1b3$var$Ao(t, e, n, s);
}
/**
 * Tells the LocalStore that the currently authenticated user has changed.
 *
 * In response the local store switches the mutation queue to the new user and
 * returns any resulting document changes.
 */ // PORTING NOTE: Android and iOS only return the documents affected by the
// change.
async function $5c04988f82cad1b3$var$bo(t, e) {
    const n = $5c04988f82cad1b3$var$K(t);
    return await n.persistence.runTransaction("Handle user change", "readonly", (t)=>{
        // Swap out the mutation queue, grabbing the pending mutation batches
        // before and after.
        let s;
        return n.mutationQueue.getAllMutationBatches(t).next((i)=>(s = i, n.qi(e), n.mutationQueue.getAllMutationBatches(t))).next((e)=>{
            const i = [], r = [];
            // Union the old/new changed keys.
            let o = $5c04988f82cad1b3$var$ws();
            for (const t of s){
                i.push(t.batchId);
                for (const e of t.mutations)o = o.add(e.key);
            }
            for (const t of e){
                r.push(t.batchId);
                for (const e of t.mutations)o = o.add(e.key);
            }
            // Return the set of all (potentially) changed documents and the list
            // of mutation batch IDs that were affected by change.
            return n.localDocuments.getDocuments(t, o).next((t)=>({
                    Ki: t,
                    removedBatchIds: i,
                    addedBatchIds: r
                }));
        });
    });
}
/* Accepts locally generated Mutations and commit them to storage. */ /**
 * Acknowledges the given batch.
 *
 * On the happy path when a batch is acknowledged, the local store will
 *
 *  + remove the batch from the mutation queue;
 *  + apply the changes to the remote document cache;
 *  + recalculate the latency compensated view implied by those changes (there
 *    may be mutations in the queue that affect the documents but haven't been
 *    acknowledged yet); and
 *  + give the changed documents back the sync engine
 *
 * @returns The resulting (modified) documents.
 */ function $5c04988f82cad1b3$var$Po(t, e) {
    const n = $5c04988f82cad1b3$var$K(t);
    return n.persistence.runTransaction("Acknowledge batch", "readwrite-primary", (t)=>{
        const s = e.batch.keys(), i = n.Ui.newChangeBuffer({
            trackRemovals: !0
        });
        return (function(t, e, n, s) {
            const i = n.batch, r = i.keys();
            let o = $5c04988f82cad1b3$var$Pt.resolve();
            return r.forEach((t)=>{
                o = o.next(()=>s.getEntry(e, t)).next((e)=>{
                    const r = n.docVersions.get(t);
                    $5c04988f82cad1b3$var$U(null !== r), e.version.compareTo(r) < 0 && (i.applyToRemoteDocument(e, n), e.isValidDocument() && // We use the commitVersion as the readTime rather than the
                    // document's updateTime since the updateTime is not advanced
                    // for updates that do not modify the underlying document.
                    (e.setReadTime(n.commitVersion), s.addEntry(e)));
                });
            }), o.next(()=>t.mutationQueue.removeMutationBatch(e, i));
        })(n, t, e, i).next(()=>i.apply(t)).next(()=>n.mutationQueue.performConsistencyCheck(t)).next(()=>n.documentOverlayCache.removeOverlaysForBatchId(t, s, e.batch.batchId)).next(()=>n.localDocuments.recalculateAndSaveOverlaysForDocumentKeys(t, function(t) {
                let e = $5c04988f82cad1b3$var$ws();
                for(let n = 0; n < t.mutationResults.length; ++n)t.mutationResults[n].transformResults.length > 0 && (e = e.add(t.batch.mutations[n].key));
                return e;
            }(e))).next(()=>n.localDocuments.getDocuments(t, s));
    });
}
/**
 * Returns the last consistent snapshot processed (used by the RemoteStore to
 * determine whether to buffer incoming snapshots from the backend).
 */ function $5c04988f82cad1b3$var$vo(t) {
    const e = $5c04988f82cad1b3$var$K(t);
    return e.persistence.runTransaction("Get last remote snapshot version", "readonly", (t)=>e.Vs.getLastRemoteSnapshotVersion(t));
}
/**
 * Updates the "ground-state" (remote) documents. We assume that the remote
 * event reflects any write batches that have been acknowledged or rejected
 * (i.e. we do not re-apply local mutations to updates from this event).
 *
 * LocalDocuments are re-calculated if there are remaining mutations in the
 * queue.
 */ function $5c04988f82cad1b3$var$Vo(t, e) {
    const n = $5c04988f82cad1b3$var$K(t), s = e.snapshotVersion;
    let i = n.$i;
    return n.persistence.runTransaction("Apply remote event", "readwrite-primary", (t)=>{
        const r = n.Ui.newChangeBuffer({
            trackRemovals: !0
        });
        // Reset newTargetDataByTargetMap in case this transaction gets re-run.
        i = n.$i;
        const o = [];
        e.targetChanges.forEach((r, u)=>{
            const c = i.get(u);
            if (!c) return;
            // Only update the remote keys if the target is still active. This
            // ensures that we can persist the updated target data along with
            // the updated assignment.
            o.push(n.Vs.removeMatchingKeys(t, r.removedDocuments, u).next(()=>n.Vs.addMatchingKeys(t, r.addedDocuments, u)));
            let a = c.withSequenceNumber(t.currentSequenceNumber);
            e.targetMismatches.has(u) ? a = a.withResumeToken($5c04988f82cad1b3$var$Jt.EMPTY_BYTE_STRING, $5c04988f82cad1b3$var$ct.min()).withLastLimboFreeSnapshotVersion($5c04988f82cad1b3$var$ct.min()) : r.resumeToken.approximateByteSize() > 0 && (a = a.withResumeToken(r.resumeToken, s)), i = i.insert(u, a), // Update the target data if there are target changes (or if
            // sufficient time has passed since the last update).
            /**
 * Returns true if the newTargetData should be persisted during an update of
 * an active target. TargetData should always be persisted when a target is
 * being released and should not call this function.
 *
 * While the target is active, TargetData updates can be omitted when nothing
 * about the target has changed except metadata like the resume token or
 * snapshot version. Occasionally it's worth the extra write to prevent these
 * values from getting too stale after a crash, but this doesn't have to be
 * too frequent.
 */ function(t, e, n) {
                // Always persist target data if we don't already have a resume token.
                if (0 === t.resumeToken.approximateByteSize()) return !0;
                // Don't allow resume token changes to be buffered indefinitely. This
                // allows us to be reasonably up-to-date after a crash and avoids needing
                // to loop over all active queries on shutdown. Especially in the browser
                // we may not get time to do anything interesting while the current tab is
                // closing.
                if (e.snapshotVersion.toMicroseconds() - t.snapshotVersion.toMicroseconds() >= 3e8) return !0;
                // Otherwise if the only thing that has changed about a target is its resume
                // token it's not worth persisting. Note that the RemoteStore keeps an
                // in-memory view of the currently active targets which includes the current
                // resume token, so stream failure or user changes will still use an
                // up-to-date resume token regardless of what we do here.
                return n.addedDocuments.size + n.modifiedDocuments.size + n.removedDocuments.size > 0;
            }(c, a, r) && o.push(n.Vs.updateTargetData(t, a));
        });
        let u = $5c04988f82cad1b3$var$os(), c = $5c04988f82cad1b3$var$ws();
        // HACK: The only reason we allow a null snapshot version is so that we
        // can synthesize remote events when we get permission denied errors while
        // trying to resolve the state of a locally cached document that is in
        // limbo.
        if (e.documentUpdates.forEach((s)=>{
            e.resolvedLimboDocuments.has(s) && o.push(n.persistence.referenceDelegate.updateLimboDocument(t, s));
        }), // Each loop iteration only affects its "own" doc, so it's safe to get all
        // the remote documents in advance in a single call.
        o.push($5c04988f82cad1b3$var$So(t, r, e.documentUpdates).next((t)=>{
            u = t.Gi, c = t.Qi;
        })), !s.isEqual($5c04988f82cad1b3$var$ct.min())) {
            const e = n.Vs.getLastRemoteSnapshotVersion(t).next((e)=>n.Vs.setTargetsMetadata(t, t.currentSequenceNumber, s));
            o.push(e);
        }
        return $5c04988f82cad1b3$var$Pt.waitFor(o).next(()=>r.apply(t)).next(()=>n.localDocuments.getLocalViewOfDocuments(t, u, c)).next(()=>u);
    }).then((t)=>(n.$i = i, t));
}
/**
 * Populates document change buffer with documents from backend or a bundle.
 * Returns the document changes resulting from applying those documents, and
 * also a set of documents whose existence state are changed as a result.
 *
 * @param txn - Transaction to use to read existing documents from storage.
 * @param documentBuffer - Document buffer to collect the resulted changes to be
 *        applied to storage.
 * @param documents - Documents to be applied.
 */ function $5c04988f82cad1b3$var$So(t, e, n) {
    let s = $5c04988f82cad1b3$var$ws(), i = $5c04988f82cad1b3$var$ws();
    return n.forEach((t)=>s = s.add(t)), e.getEntries(t, s).next((t)=>{
        let s = $5c04988f82cad1b3$var$os();
        return n.forEach((n, r)=>{
            const o = t.get(n);
            // Check if see if there is a existence state change for this document.
            r.isFoundDocument() !== o.isFoundDocument() && (i = i.add(n)), // Note: The order of the steps below is important, since we want
            // to ensure that rejected limbo resolutions (which fabricate
            // NoDocuments with SnapshotVersion.min()) never add documents to
            // cache.
            r.isNoDocument() && r.version.isEqual($5c04988f82cad1b3$var$ct.min()) ? // NoDocuments with SnapshotVersion.min() are used in manufactured
            // events. We remove these documents from cache since we lost
            // access.
            (e.removeEntry(n, r.readTime), s = s.insert(n, r)) : !o.isValidDocument() || r.version.compareTo(o.version) > 0 || 0 === r.version.compareTo(o.version) && o.hasPendingWrites ? (e.addEntry(r), s = s.insert(n, r)) : $5c04988f82cad1b3$var$M("LocalStore", "Ignoring outdated watch update for ", n, ". Current version:", o.version, " Watch version:", r.version);
        }), {
            Gi: s,
            Qi: i
        };
    });
}
/**
 * Gets the mutation batch after the passed in batchId in the mutation queue
 * or null if empty.
 * @param afterBatchId - If provided, the batch to search after.
 * @returns The next mutation or null if there wasn't one.
 */ function $5c04988f82cad1b3$var$Do(t, e) {
    const n = $5c04988f82cad1b3$var$K(t);
    return n.persistence.runTransaction("Get next mutation batch", "readonly", (t)=>(void 0 === e && (e = -1), n.mutationQueue.getNextMutationBatchAfterBatchId(t, e)));
}
/**
 * Reads the current value of a Document with a given key or null if not
 * found - used for testing.
 */ /**
 * Assigns the given target an internal ID so that its results can be pinned so
 * they don't get GC'd. A target must be allocated in the local store before
 * the store can be used to manage its view.
 *
 * Allocating an already allocated `Target` will return the existing `TargetData`
 * for that `Target`.
 */ function $5c04988f82cad1b3$var$Co(t, e) {
    const n = $5c04988f82cad1b3$var$K(t);
    return n.persistence.runTransaction("Allocate target", "readwrite", (t)=>{
        let s;
        return n.Vs.getTargetData(t, e).next((i)=>i ? // This target has been listened to previously, so reuse the
            // previous targetID.
            // TODO(mcg): freshen last accessed date?
            (s = i, $5c04988f82cad1b3$var$Pt.resolve(s)) : n.Vs.allocateTargetId(t).next((i)=>(s = new $5c04988f82cad1b3$var$Li(e, i, 0 /* Listen */ , t.currentSequenceNumber), n.Vs.addTargetData(t, s).next(()=>s))));
    }).then((t)=>{
        // If Multi-Tab is enabled, the existing target data may be newer than
        // the in-memory data
        const s = n.$i.get(t.targetId);
        return (null === s || t.snapshotVersion.compareTo(s.snapshotVersion) > 0) && (n.$i = n.$i.insert(t.targetId, t), n.Bi.set(e, t.targetId)), t;
    });
}
/**
 * Returns the TargetData as seen by the LocalStore, including updates that may
 * have not yet been persisted to the TargetCache.
 */ // Visible for testing.
/**
 * Unpins all the documents associated with the given target. If
 * `keepPersistedTargetData` is set to false and Eager GC enabled, the method
 * directly removes the associated target data from the target cache.
 *
 * Releasing a non-existing `Target` is a no-op.
 */ // PORTING NOTE: `keepPersistedTargetData` is multi-tab only.
async function $5c04988f82cad1b3$var$xo(t, e, n) {
    const s = $5c04988f82cad1b3$var$K(t), i = s.$i.get(e), r = n ? "readwrite" : "readwrite-primary";
    try {
        n || await s.persistence.runTransaction("Release target", r, (t)=>s.persistence.referenceDelegate.removeTarget(t, i));
    } catch (t) {
        if (!$5c04988f82cad1b3$var$Ct(t)) throw t;
        // All `releaseTarget` does is record the final metadata state for the
        // target, but we've been recording this periodically during target
        // activity. If we lose this write this could cause a very slight
        // difference in the order of target deletion during GC, but we
        // don't define exact LRU semantics so this is acceptable.
        $5c04988f82cad1b3$var$M("LocalStore", `Failed to update sequence numbers for target ${e}: ${t}`);
    }
    s.$i = s.$i.remove(e), s.Bi.delete(i.target);
}
/**
 * Runs the specified query against the local store and returns the results,
 * potentially taking advantage of query data from previous executions (such
 * as the set of remote keys).
 *
 * @param usePreviousResults - Whether results from previous executions can
 * be used to optimize this query execution.
 */ function $5c04988f82cad1b3$var$No(t, e, n) {
    const s = $5c04988f82cad1b3$var$K(t);
    let i = $5c04988f82cad1b3$var$ct.min(), r = $5c04988f82cad1b3$var$ws();
    return s.persistence.runTransaction("Execute query", "readonly", (t)=>(function(t, e, n) {
            const s = $5c04988f82cad1b3$var$K(t), i = s.Bi.get(n);
            return void 0 !== i ? $5c04988f82cad1b3$var$Pt.resolve(s.$i.get(i)) : s.Vs.getTargetData(e, n);
        })(s, t, $5c04988f82cad1b3$var$ln(e)).next((e)=>{
            if (e) return i = e.lastLimboFreeSnapshotVersion, s.Vs.getMatchingKeysForTargetId(t, e.targetId).next((t)=>{
                r = t;
            });
        }).next(()=>s.Fi.getDocumentsMatchingQuery(t, e, n ? i : $5c04988f82cad1b3$var$ct.min(), n ? r : $5c04988f82cad1b3$var$ws())).next((t)=>($5c04988f82cad1b3$var$Mo(s, $5c04988f82cad1b3$var$gn(e), t), {
                documents: t,
                ji: r
            })));
}
// PORTING NOTE: Multi-Tab only.
function $5c04988f82cad1b3$var$ko(t, e) {
    const n = $5c04988f82cad1b3$var$K(t), s = $5c04988f82cad1b3$var$K(n.Vs), i = n.$i.get(e);
    return i ? Promise.resolve(i.target) : n.persistence.runTransaction("Get target data", "readonly", (t)=>s.te(t, e).next((t)=>t ? t.target : null));
}
/**
 * Returns the set of documents that have been updated since the last call.
 * If this is the first call, returns the set of changes since client
 * initialization. Further invocations will return document that have changed
 * since the prior call.
 */ // PORTING NOTE: Multi-Tab only.
function $5c04988f82cad1b3$var$Oo(t, e) {
    const n = $5c04988f82cad1b3$var$K(t), s = n.Li.get(e) || $5c04988f82cad1b3$var$ct.min();
    // Get the current maximum read time for the collection. This should always
    // exist, but to reduce the chance for regressions we default to
    // SnapshotVersion.Min()
    // TODO(indexing): Consider removing the default value.
    return n.persistence.runTransaction("Get new document changes", "readonly", (t)=>n.Ui.getAllFromCollectionGroup(t, e, $5c04988f82cad1b3$var$pt(s, -1), /* limit= */ Number.MAX_SAFE_INTEGER)).then((t)=>($5c04988f82cad1b3$var$Mo(n, e, t), t));
}
/** Sets the collection group's maximum read time from the given documents. */ // PORTING NOTE: Multi-Tab only.
function $5c04988f82cad1b3$var$Mo(t, e, n) {
    let s = $5c04988f82cad1b3$var$ct.min();
    n.forEach((t, e)=>{
        e.readTime.compareTo(s) > 0 && (s = e.readTime);
    }), t.Li.set(e, s);
}
/**
 * Creates a new target using the given bundle name, which will be used to
 * hold the keys of all documents from the bundle in query-document mappings.
 * This ensures that the loaded documents do not get garbage collected
 * right away.
 */ /**
 * Applies the documents from a bundle to the "ground-state" (remote)
 * documents.
 *
 * LocalDocuments are re-calculated if there are remaining mutations in the
 * queue.
 */ async function $5c04988f82cad1b3$var$Fo(t, e, n, s) {
    const i = $5c04988f82cad1b3$var$K(t);
    let r = $5c04988f82cad1b3$var$ws(), o = $5c04988f82cad1b3$var$os();
    for (const t of n){
        const n = e.Wi(t.metadata.name);
        t.document && (r = r.add(n));
        const s = e.zi(t);
        s.setReadTime(e.Hi(t.metadata.readTime)), o = o.insert(n, s);
    }
    const u = i.Ui.newChangeBuffer({
        trackRemovals: !0
    }), c = await $5c04988f82cad1b3$var$Co(i, function(t) {
        // It is OK that the path used for the query is not valid, because this will
        // not be read and queried.
        return $5c04988f82cad1b3$var$ln($5c04988f82cad1b3$var$rn($5c04988f82cad1b3$var$ht.fromString(`__bundle__/docs/${t}`)));
    }(s));
    // Allocates a target to hold all document keys from the bundle, such that
    // they will not get garbage collected right away.
    return i.persistence.runTransaction("Apply bundle documents", "readwrite", (t)=>$5c04988f82cad1b3$var$So(t, u, o).next((e)=>(u.apply(t), e)).next((e)=>i.Vs.removeMatchingKeysForTargetId(t, c.targetId).next(()=>i.Vs.addMatchingKeys(t, r, c.targetId)).next(()=>i.localDocuments.getLocalViewOfDocuments(t, e.Gi, e.Qi)).next(()=>e.Gi)));
}
/**
 * Returns a promise of a boolean to indicate if the given bundle has already
 * been loaded and the create time is newer than the current loading bundle.
 */ /**
 * Saves the given `NamedQuery` to local persistence.
 */ async function $5c04988f82cad1b3$var$$o(t, e, n = $5c04988f82cad1b3$var$ws()) {
    // Allocate a target for the named query such that it can be resumed
    // from associated read time if users use it to listen.
    // NOTE: this also means if no corresponding target exists, the new target
    // will remain active and will not get collected, unless users happen to
    // unlisten the query somehow.
    const s = await $5c04988f82cad1b3$var$Co(t, $5c04988f82cad1b3$var$ln($5c04988f82cad1b3$var$Ji(e.bundledQuery))), i = $5c04988f82cad1b3$var$K(t);
    return i.persistence.runTransaction("Save named query", "readwrite", (t)=>{
        const r = $5c04988f82cad1b3$var$Ns(e.readTime);
        // Simply save the query itself if it is older than what the SDK already
        // has.
        if (s.snapshotVersion.compareTo(r) >= 0) return i.Ds.saveNamedQuery(t, e);
        // Update existing target data because the query from the bundle is newer.
        const o = s.withResumeToken($5c04988f82cad1b3$var$Jt.EMPTY_BYTE_STRING, r);
        return i.$i = i.$i.insert(o.targetId, o), i.Vs.updateTargetData(t, o).next(()=>i.Vs.removeMatchingKeysForTargetId(t, s.targetId)).next(()=>i.Vs.addMatchingKeys(t, n, s.targetId)).next(()=>i.Ds.saveNamedQuery(t, e));
    });
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // The format of the LocalStorage key that stores the client state is:
//     firestore_clients_<persistence_prefix>_<instance_key>
/** Assembles the key for a client state in WebStorage */ function $5c04988f82cad1b3$var$Bo(t, e) {
    return `firestore_clients_${t}_${e}`;
}
// The format of the WebStorage key that stores the mutation state is:
//     firestore_mutations_<persistence_prefix>_<batch_id>
//     (for unauthenticated users)
// or: firestore_mutations_<persistence_prefix>_<batch_id>_<user_uid>
// 'user_uid' is last to avoid needing to escape '_' characters that it might
// contain.
/** Assembles the key for a mutation batch in WebStorage */ function $5c04988f82cad1b3$var$Lo(t, e, n) {
    let s = `firestore_mutations_${t}_${n}`;
    return e.isAuthenticated() && (s += `_${e.uid}`), s;
}
// The format of the WebStorage key that stores a query target's metadata is:
//     firestore_targets_<persistence_prefix>_<target_id>
/** Assembles the key for a query state in WebStorage */ function $5c04988f82cad1b3$var$Uo(t, e) {
    return `firestore_targets_${t}_${e}`;
}
// The WebStorage prefix that stores the primary tab's online state. The
// format of the key is:
//     firestore_online_state_<persistence_prefix>
/**
 * Holds the state of a mutation batch, including its user ID, batch ID and
 * whether the batch is 'pending', 'acknowledged' or 'rejected'.
 */ // Visible for testing
class $5c04988f82cad1b3$var$qo {
    /**
     * Parses a MutationMetadata from its JSON representation in WebStorage.
     * Logs a warning and returns null if the format of the data is not valid.
     */ static Ji(t, e, n) {
        const s = JSON.parse(n);
        let i, r = "object" == typeof s && -1 !== [
            "pending",
            "acknowledged",
            "rejected"
        ].indexOf(s.state) && (void 0 === s.error || "object" == typeof s.error);
        return r && s.error && (r = "string" == typeof s.error.message && "string" == typeof s.error.code, r && (i = new $5c04988f82cad1b3$export$8fada0bf726bf278(s.error.code, s.error.message))), r ? new $5c04988f82cad1b3$var$qo(t, e, s.state, i) : ($5c04988f82cad1b3$var$F("SharedClientState", `Failed to parse mutation state for ID '${e}': ${n}`), null);
    }
    Yi() {
        const t = {
            state: this.state,
            updateTimeMs: Date.now()
        };
        return this.error && (t.error = {
            code: this.error.code,
            message: this.error.message
        }), JSON.stringify(t);
    }
    constructor(t, e, n, s){
        this.user = t, this.batchId = e, this.state = n, this.error = s;
    }
}
/**
 * Holds the state of a query target, including its target ID and whether the
 * target is 'not-current', 'current' or 'rejected'.
 */ // Visible for testing
class $5c04988f82cad1b3$var$Ko {
    /**
     * Parses a QueryTargetMetadata from its JSON representation in WebStorage.
     * Logs a warning and returns null if the format of the data is not valid.
     */ static Ji(t, e) {
        const n = JSON.parse(e);
        let s, i = "object" == typeof n && -1 !== [
            "not-current",
            "current",
            "rejected"
        ].indexOf(n.state) && (void 0 === n.error || "object" == typeof n.error);
        return i && n.error && (i = "string" == typeof n.error.message && "string" == typeof n.error.code, i && (s = new $5c04988f82cad1b3$export$8fada0bf726bf278(n.error.code, n.error.message))), i ? new $5c04988f82cad1b3$var$Ko(t, n.state, s) : ($5c04988f82cad1b3$var$F("SharedClientState", `Failed to parse target state for ID '${t}': ${e}`), null);
    }
    Yi() {
        const t = {
            state: this.state,
            updateTimeMs: Date.now()
        };
        return this.error && (t.error = {
            code: this.error.code,
            message: this.error.message
        }), JSON.stringify(t);
    }
    constructor(t, e, n){
        this.targetId = t, this.state = e, this.error = n;
    }
}
/**
 * This class represents the immutable ClientState for a client read from
 * WebStorage, containing the list of active query targets.
 */ class $5c04988f82cad1b3$var$Go {
    /**
     * Parses a RemoteClientState from the JSON representation in WebStorage.
     * Logs a warning and returns null if the format of the data is not valid.
     */ static Ji(t, e) {
        const n = JSON.parse(e);
        let s = "object" == typeof n && n.activeTargetIds instanceof Array, i = $5c04988f82cad1b3$var$gs();
        for(let t = 0; s && t < n.activeTargetIds.length; ++t)s = $5c04988f82cad1b3$var$ce(n.activeTargetIds[t]), i = i.add(n.activeTargetIds[t]);
        return s ? new $5c04988f82cad1b3$var$Go(t, i) : ($5c04988f82cad1b3$var$F("SharedClientState", `Failed to parse client data for instance '${t}': ${e}`), null);
    }
    constructor(t, e){
        this.clientId = t, this.activeTargetIds = e;
    }
}
/**
 * This class represents the online state for all clients participating in
 * multi-tab. The online state is only written to by the primary client, and
 * used in secondary clients to update their query views.
 */ class $5c04988f82cad1b3$var$Qo {
    /**
     * Parses a SharedOnlineState from its JSON representation in WebStorage.
     * Logs a warning and returns null if the format of the data is not valid.
     */ static Ji(t) {
        const e = JSON.parse(t);
        return "object" == typeof e && -1 !== [
            "Unknown",
            "Online",
            "Offline"
        ].indexOf(e.onlineState) && "string" == typeof e.clientId ? new $5c04988f82cad1b3$var$Qo(e.clientId, e.onlineState) : ($5c04988f82cad1b3$var$F("SharedClientState", `Failed to parse online state: ${t}`), null);
    }
    constructor(t, e){
        this.clientId = t, this.onlineState = e;
    }
}
/**
 * Metadata state of the local client. Unlike `RemoteClientState`, this class is
 * mutable and keeps track of all pending mutations, which allows us to
 * update the range of pending mutation batch IDs as new mutations are added or
 * removed.
 *
 * The data in `LocalClientState` is not read from WebStorage and instead
 * updated via its instance methods. The updated state can be serialized via
 * `toWebStorageJSON()`.
 */ // Visible for testing.
class $5c04988f82cad1b3$var$jo {
    Xi(t) {
        this.activeTargetIds = this.activeTargetIds.add(t);
    }
    Zi(t) {
        this.activeTargetIds = this.activeTargetIds.delete(t);
    }
    /**
     * Converts this entry into a JSON-encoded format we can use for WebStorage.
     * Does not encode `clientId` as it is part of the key in WebStorage.
     */ Yi() {
        const t = {
            activeTargetIds: this.activeTargetIds.toArray(),
            updateTimeMs: Date.now()
        };
        return JSON.stringify(t);
    }
    constructor(){
        this.activeTargetIds = $5c04988f82cad1b3$var$gs();
    }
}
/**
 * `WebStorageSharedClientState` uses WebStorage (window.localStorage) as the
 * backing store for the SharedClientState. It keeps track of all active
 * clients and supports modifications of the local client's data.
 */ class $5c04988f82cad1b3$var$Wo {
    /** Returns 'true' if WebStorage is available in the current environment. */ static V(t) {
        return !(!t || !t.localStorage);
    }
    async start() {
        // Retrieve the list of existing clients to backfill the data in
        // SharedClientState.
        const t = await this.syncEngine.Ri();
        for (const e of t){
            if (e === this.tr) continue;
            const t = this.getItem($5c04988f82cad1b3$var$Bo(this.persistenceKey, e));
            if (t) {
                const n = $5c04988f82cad1b3$var$Go.Ji(e, t);
                n && (this.sr = this.sr.insert(n.clientId, n));
            }
        }
        this._r();
        // Check if there is an existing online state and call the callback handler
        // if applicable.
        const e = this.storage.getItem(this.lr);
        if (e) {
            const t = this.wr(e);
            t && this.mr(t);
        }
        for (const t of this.ir)this.nr(t);
        this.ir = [], // Register a window unload hook to remove the client metadata entry from
        // WebStorage even if `shutdown()` was not called.
        this.window.addEventListener("pagehide", ()=>this.shutdown()), this.started = !0;
    }
    writeSequenceNumber(t) {
        this.setItem(this.ur, JSON.stringify(t));
    }
    getAllActiveQueryTargets() {
        return this.gr(this.sr);
    }
    isActiveQueryTarget(t) {
        let e = !1;
        return this.sr.forEach((n, s)=>{
            s.activeTargetIds.has(t) && (e = !0);
        }), e;
    }
    addPendingMutation(t) {
        this.yr(t, "pending");
    }
    updateMutationState(t, e, n) {
        this.yr(t, e, n), // Once a final mutation result is observed by other clients, they no longer
        // access the mutation's metadata entry. Since WebStorage replays events
        // in order, it is safe to delete the entry right after updating it.
        this.pr(t);
    }
    addLocalQueryTarget(t) {
        let e = "not-current";
        // Lookup an existing query state if the target ID was already registered
        // by another tab
        if (this.isActiveQueryTarget(t)) {
            const n = this.storage.getItem($5c04988f82cad1b3$var$Uo(this.persistenceKey, t));
            if (n) {
                const s = $5c04988f82cad1b3$var$Ko.Ji(t, n);
                s && (e = s.state);
            }
        }
        return this.Ir.Xi(t), this._r(), e;
    }
    removeLocalQueryTarget(t) {
        this.Ir.Zi(t), this._r();
    }
    isLocalQueryTarget(t) {
        return this.Ir.activeTargetIds.has(t);
    }
    clearQueryState(t) {
        this.removeItem($5c04988f82cad1b3$var$Uo(this.persistenceKey, t));
    }
    updateQueryState(t, e, n) {
        this.Tr(t, e, n);
    }
    handleUserChange(t, e, n) {
        e.forEach((t)=>{
            this.pr(t);
        }), this.currentUser = t, n.forEach((t)=>{
            this.addPendingMutation(t);
        });
    }
    setOnlineState(t) {
        this.Er(t);
    }
    notifyBundleLoaded(t) {
        this.Ar(t);
    }
    shutdown() {
        this.started && (this.window.removeEventListener("storage", this.er), this.removeItem(this.rr), this.started = !1);
    }
    getItem(t) {
        const e = this.storage.getItem(t);
        return $5c04988f82cad1b3$var$M("SharedClientState", "READ", t, e), e;
    }
    setItem(t, e) {
        $5c04988f82cad1b3$var$M("SharedClientState", "SET", t, e), this.storage.setItem(t, e);
    }
    removeItem(t) {
        $5c04988f82cad1b3$var$M("SharedClientState", "REMOVE", t), this.storage.removeItem(t);
    }
    nr(t) {
        // Note: The function is typed to take Event to be interface-compatible with
        // `Window.addEventListener`.
        const e = t;
        if (e.storageArea === this.storage) {
            if ($5c04988f82cad1b3$var$M("SharedClientState", "EVENT", e.key, e.newValue), e.key === this.rr) return void $5c04988f82cad1b3$var$F("Received WebStorage notification for local change. Another client might have garbage-collected our state");
            this.js.enqueueRetryable(async ()=>{
                if (this.started) {
                    if (null !== e.key) {
                        if (this.cr.test(e.key)) {
                            if (null == e.newValue) {
                                const t = this.Rr(e.key);
                                return this.br(t, null);
                            }
                            {
                                const t = this.Pr(e.key, e.newValue);
                                if (t) return this.br(t.clientId, t);
                            }
                        } else if (this.ar.test(e.key)) {
                            if (null !== e.newValue) {
                                const t = this.vr(e.key, e.newValue);
                                if (t) return this.Vr(t);
                            }
                        } else if (this.hr.test(e.key)) {
                            if (null !== e.newValue) {
                                const t = this.Sr(e.key, e.newValue);
                                if (t) return this.Dr(t);
                            }
                        } else if (e.key === this.lr) {
                            if (null !== e.newValue) {
                                const t = this.wr(e.newValue);
                                if (t) return this.mr(t);
                            }
                        } else if (e.key === this.ur) {
                            const t = function(t) {
                                let e = $5c04988f82cad1b3$var$$t.ot;
                                if (null != t) try {
                                    const n = JSON.parse(t);
                                    $5c04988f82cad1b3$var$U("number" == typeof n), e = n;
                                } catch (t) {
                                    $5c04988f82cad1b3$var$F("SharedClientState", "Failed to read sequence number from WebStorage", t);
                                }
                                return e;
                            }(e.newValue);
                            t !== $5c04988f82cad1b3$var$$t.ot && this.sequenceNumberHandler(t);
                        } else if (e.key === this.dr) {
                            const t = this.Cr(e.newValue);
                            await Promise.all(t.map((t)=>this.syncEngine.Nr(t)));
                        }
                    }
                } else this.ir.push(e);
            });
        }
    }
    get Ir() {
        return this.sr.get(this.tr);
    }
    _r() {
        this.setItem(this.rr, this.Ir.Yi());
    }
    yr(t, e, n) {
        const s = new $5c04988f82cad1b3$var$qo(this.currentUser, t, e, n), i = $5c04988f82cad1b3$var$Lo(this.persistenceKey, this.currentUser, t);
        this.setItem(i, s.Yi());
    }
    pr(t) {
        const e = $5c04988f82cad1b3$var$Lo(this.persistenceKey, this.currentUser, t);
        this.removeItem(e);
    }
    Er(t) {
        const e = {
            clientId: this.tr,
            onlineState: t
        };
        this.storage.setItem(this.lr, JSON.stringify(e));
    }
    Tr(t, e, n) {
        const s = $5c04988f82cad1b3$var$Uo(this.persistenceKey, t), i = new $5c04988f82cad1b3$var$Ko(t, e, n);
        this.setItem(s, i.Yi());
    }
    Ar(t) {
        const e = JSON.stringify(Array.from(t));
        this.setItem(this.dr, e);
    }
    /**
     * Parses a client state key in WebStorage. Returns null if the key does not
     * match the expected key format.
     */ Rr(t) {
        const e = this.cr.exec(t);
        return e ? e[1] : null;
    }
    /**
     * Parses a client state in WebStorage. Returns 'null' if the value could not
     * be parsed.
     */ Pr(t, e) {
        const n = this.Rr(t);
        return $5c04988f82cad1b3$var$Go.Ji(n, e);
    }
    /**
     * Parses a mutation batch state in WebStorage. Returns 'null' if the value
     * could not be parsed.
     */ vr(t, e) {
        const n = this.ar.exec(t), s = Number(n[1]), i = void 0 !== n[2] ? n[2] : null;
        return $5c04988f82cad1b3$var$qo.Ji(new $5c04988f82cad1b3$var$C(i), s, e);
    }
    /**
     * Parses a query target state from WebStorage. Returns 'null' if the value
     * could not be parsed.
     */ Sr(t, e) {
        const n = this.hr.exec(t), s = Number(n[1]);
        return $5c04988f82cad1b3$var$Ko.Ji(s, e);
    }
    /**
     * Parses an online state from WebStorage. Returns 'null' if the value
     * could not be parsed.
     */ wr(t) {
        return $5c04988f82cad1b3$var$Qo.Ji(t);
    }
    Cr(t) {
        return JSON.parse(t);
    }
    async Vr(t) {
        if (t.user.uid === this.currentUser.uid) return this.syncEngine.kr(t.batchId, t.state, t.error);
        $5c04988f82cad1b3$var$M("SharedClientState", `Ignoring mutation for non-active user ${t.user.uid}`);
    }
    Dr(t) {
        return this.syncEngine.Or(t.targetId, t.state, t.error);
    }
    br(t, e) {
        const n = e ? this.sr.insert(t, e) : this.sr.remove(t), s = this.gr(this.sr), i = this.gr(n), r = [], o = [];
        return i.forEach((t)=>{
            s.has(t) || r.push(t);
        }), s.forEach((t)=>{
            i.has(t) || o.push(t);
        }), this.syncEngine.Mr(r, o).then(()=>{
            this.sr = n;
        });
    }
    mr(t) {
        // We check whether the client that wrote this online state is still active
        // by comparing its client ID to the list of clients kept active in
        // IndexedDb. If a client does not update their IndexedDb client state
        // within 5 seconds, it is considered inactive and we don't emit an online
        // state event.
        this.sr.get(t.clientId) && this.onlineStateHandler(t.onlineState);
    }
    gr(t) {
        let e = $5c04988f82cad1b3$var$gs();
        return t.forEach((t, n)=>{
            e = e.unionWith(n.activeTargetIds);
        }), e;
    }
    constructor(t, e, n, s, i){
        this.window = t, this.js = e, this.persistenceKey = n, this.tr = s, this.syncEngine = null, this.onlineStateHandler = null, this.sequenceNumberHandler = null, this.er = this.nr.bind(this), this.sr = new $5c04988f82cad1b3$var$qt($5c04988f82cad1b3$var$it), this.started = !1, /**
         * Captures WebStorage events that occur before `start()` is called. These
         * events are replayed once `WebStorageSharedClientState` is started.
         */ this.ir = [];
        // Escape the special characters mentioned here:
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions
        const r = n.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
        this.storage = this.window.localStorage, this.currentUser = i, this.rr = $5c04988f82cad1b3$var$Bo(this.persistenceKey, this.tr), this.ur = /** Assembles the key for the current sequence number. */ function(t) {
            return `firestore_sequence_number_${t}`;
        }(this.persistenceKey), this.sr = this.sr.insert(this.tr, new $5c04988f82cad1b3$var$jo), this.cr = new RegExp(`^firestore_clients_${r}_([^_]*)$`), this.ar = new RegExp(`^firestore_mutations_${r}_(\\d+)(?:_(.*))?$`), this.hr = new RegExp(`^firestore_targets_${r}_(\\d+)$`), this.lr = /** Assembles the key for the online state of the primary tab. */ function(t) {
            return `firestore_online_state_${t}`;
        }(this.persistenceKey), this.dr = function(t) {
            return `firestore_bundle_loaded_v2_${t}`;
        }(this.persistenceKey), // Rather than adding the storage observer during start(), we add the
        // storage observer during initialization. This ensures that we collect
        // events before other components populate their initial state (during their
        // respective start() calls). Otherwise, we might for example miss a
        // mutation that is added after LocalStore's start() processed the existing
        // mutations but before we observe WebStorage events.
        this.window.addEventListener("storage", this.er);
    }
}
class $5c04988f82cad1b3$var$zo {
    addPendingMutation(t) {
    // No op.
    }
    updateMutationState(t, e, n) {
    // No op.
    }
    addLocalQueryTarget(t) {
        return this.Fr.Xi(t), this.$r[t] || "not-current";
    }
    updateQueryState(t, e, n) {
        this.$r[t] = e;
    }
    removeLocalQueryTarget(t) {
        this.Fr.Zi(t);
    }
    isLocalQueryTarget(t) {
        return this.Fr.activeTargetIds.has(t);
    }
    clearQueryState(t) {
        delete this.$r[t];
    }
    getAllActiveQueryTargets() {
        return this.Fr.activeTargetIds;
    }
    isActiveQueryTarget(t) {
        return this.Fr.activeTargetIds.has(t);
    }
    start() {
        return this.Fr = new $5c04988f82cad1b3$var$jo, Promise.resolve();
    }
    handleUserChange(t, e, n) {
    // No op.
    }
    setOnlineState(t) {
    // No op.
    }
    shutdown() {}
    writeSequenceNumber(t) {}
    notifyBundleLoaded(t) {
    // No op.
    }
    constructor(){
        this.Fr = new $5c04988f82cad1b3$var$jo, this.$r = {}, this.onlineStateHandler = null, this.sequenceNumberHandler = null;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $5c04988f82cad1b3$var$Ho {
    Br(t) {
    // No-op.
    }
    shutdown() {
    // No-op.
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // References to `window` are guarded by BrowserConnectivityMonitor.isAvailable()
/* eslint-disable no-restricted-globals */ /**
 * Browser implementation of ConnectivityMonitor.
 */ class $5c04988f82cad1b3$var$Jo {
    Br(t) {
        this.Gr.push(t);
    }
    shutdown() {
        window.removeEventListener("online", this.Lr), window.removeEventListener("offline", this.qr);
    }
    Qr() {
        window.addEventListener("online", this.Lr), window.addEventListener("offline", this.qr);
    }
    Ur() {
        $5c04988f82cad1b3$var$M("ConnectivityMonitor", "Network connectivity changed: AVAILABLE");
        for (const t of this.Gr)t(0 /* AVAILABLE */ );
    }
    Kr() {
        $5c04988f82cad1b3$var$M("ConnectivityMonitor", "Network connectivity changed: UNAVAILABLE");
        for (const t of this.Gr)t(1 /* UNAVAILABLE */ );
    }
    // TODO(chenbrian): Consider passing in window either into this component or
    // here for testing via FakeWindow.
    /** Checks that all used attributes of window are available. */ static V() {
        return "undefined" != typeof window && void 0 !== window.addEventListener && void 0 !== window.removeEventListener;
    }
    constructor(){
        this.Lr = ()=>this.Ur(), this.qr = ()=>this.Kr(), this.Gr = [], this.Qr();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $5c04988f82cad1b3$var$Yo = {
    BatchGetDocuments: "batchGet",
    Commit: "commit",
    RunQuery: "runQuery"
};
/**
 * Maps RPC names to the corresponding REST endpoint name.
 *
 * We use array notation to avoid mangling.
 */ /**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provides a simple helper class that implements the Stream interface to
 * bridge to other implementations that are streams but do not implement the
 * interface. The stream callbacks are invoked with the callOn... methods.
 */ class $5c04988f82cad1b3$var$Xo {
    zr(t) {
        this.Hr = t;
    }
    Jr(t) {
        this.Yr = t;
    }
    onMessage(t) {
        this.Xr = t;
    }
    close() {
        this.Wr();
    }
    send(t) {
        this.jr(t);
    }
    Zr() {
        this.Hr();
    }
    eo(t) {
        this.Yr(t);
    }
    no(t) {
        this.Xr(t);
    }
    constructor(t){
        this.jr = t.jr, this.Wr = t.Wr;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $5c04988f82cad1b3$var$Zo extends /**
 * Base class for all Rest-based connections to the backend (WebChannel and
 * HTTP).
 */ class {
    ro(t, e, n, s, i) {
        const r = this.oo(t, e);
        $5c04988f82cad1b3$var$M("RestConnection", "Sending: ", r, n);
        const o = {};
        return this.uo(o, s, i), this.co(t, r, o, n).then((t)=>($5c04988f82cad1b3$var$M("RestConnection", "Received: ", t), t), (e)=>{
            throw $5c04988f82cad1b3$export$86cd73f49cc6e0bb("RestConnection", `${t} failed with error: `, e, "url: ", r, "request:", n), e;
        });
    }
    ao(t, e, n, s, i) {
        // The REST API automatically aggregates all of the streamed results, so we
        // can just use the normal invoke() method.
        return this.ro(t, e, n, s, i);
    }
    /**
     * Modifies the headers for a request, adding any authorization token if
     * present and any additional headers for the request.
     */ uo(t, e, n) {
        t["X-Goog-Api-Client"] = "gl-js/ fire/" + $5c04988f82cad1b3$var$x, // Content-Type: text/plain will avoid preflight requests which might
        // mess with CORS and redirects by proxies. If we add custom headers
        // we will need to change this code to potentially use the $httpOverwrite
        // parameter supported by ESF to avoid triggering preflight requests.
        t["Content-Type"] = "text/plain", this.databaseInfo.appId && (t["X-Firebase-GMPID"] = this.databaseInfo.appId), e && e.headers.forEach((e, n)=>t[n] = e), n && n.headers.forEach((e, n)=>t[n] = e);
    }
    oo(t, e) {
        const n = $5c04988f82cad1b3$var$Yo[t];
        return `${this.so}/v1/${e}:${n}`;
    }
    constructor(t){
        this.databaseInfo = t, this.databaseId = t.databaseId;
        const e = t.ssl ? "https" : "http";
        this.so = e + "://" + t.host, this.io = "projects/" + this.databaseId.projectId + "/databases/" + this.databaseId.database + "/documents";
    }
} {
    co(t, e, n, s) {
        return new Promise((i, r)=>{
            const o = new (0, $3YLik.XhrIo);
            o.listenOnce((0, $3YLik.EventType).COMPLETE, ()=>{
                try {
                    switch(o.getLastErrorCode()){
                        case (0, $3YLik.ErrorCode).NO_ERROR:
                            const e = o.getResponseJson();
                            $5c04988f82cad1b3$var$M("Connection", "XHR received:", JSON.stringify(e)), i(e);
                            break;
                        case (0, $3YLik.ErrorCode).TIMEOUT:
                            $5c04988f82cad1b3$var$M("Connection", 'RPC "' + t + '" timed out'), r(new $5c04988f82cad1b3$export$8fada0bf726bf278($5c04988f82cad1b3$var$G.DEADLINE_EXCEEDED, "Request time out"));
                            break;
                        case (0, $3YLik.ErrorCode).HTTP_ERROR:
                            const n = o.getStatus();
                            if ($5c04988f82cad1b3$var$M("Connection", 'RPC "' + t + '" failed with status:', n, "response text:", o.getResponseText()), n > 0) {
                                const t = o.getResponseJson().error;
                                if (t && t.status && t.message) {
                                    const e = function(t) {
                                        const e = t.toLowerCase().replace(/_/g, "-");
                                        return Object.values($5c04988f82cad1b3$var$G).indexOf(e) >= 0 ? e : $5c04988f82cad1b3$var$G.UNKNOWN;
                                    }(t.status);
                                    r(new $5c04988f82cad1b3$export$8fada0bf726bf278(e, t.message));
                                } else r(new $5c04988f82cad1b3$export$8fada0bf726bf278($5c04988f82cad1b3$var$G.UNKNOWN, "Server responded with status " + o.getStatus()));
                            } else // If we received an HTTP_ERROR but there's no status code,
                            // it's most probably a connection issue
                            r(new $5c04988f82cad1b3$export$8fada0bf726bf278($5c04988f82cad1b3$var$G.UNAVAILABLE, "Connection failed."));
                            break;
                        default:
                            $5c04988f82cad1b3$var$L();
                    }
                } finally{
                    $5c04988f82cad1b3$var$M("Connection", 'RPC "' + t + '" completed.');
                }
            });
            const u = JSON.stringify(s);
            o.send(e, "POST", u, n, 15);
        });
    }
    ho(t, e, n) {
        const s = [
            this.so,
            "/",
            "google.firestore.v1.Firestore",
            "/",
            t,
            "/channel"
        ], i = (0, $3YLik.createWebChannelTransport)(), r = (0, $3YLik.getStatEventTarget)(), o = {
            // Required for backend stickiness, routing behavior is based on this
            // parameter.
            httpSessionIdParam: "gsessionid",
            initMessageHeaders: {},
            messageUrlParams: {
                // This param is used to improve routing and project isolation by the
                // backend and must be included in every request.
                database: `projects/${this.databaseId.projectId}/databases/${this.databaseId.database}`
            },
            sendRawJson: !0,
            supportsCrossDomainXhr: !0,
            internalChannelParams: {
                // Override the default timeout (randomized between 10-20 seconds) since
                // a large write batch on a slow internet connection may take a long
                // time to send to the backend. Rather than have WebChannel impose a
                // tight timeout which could lead to infinite timeouts and retries, we
                // set it very large (5-10 minutes) and rely on the browser's builtin
                // timeouts to kick in if the request isn't working.
                forwardChannelRequestTimeoutMs: 6e5
            },
            forceLongPolling: this.forceLongPolling,
            detectBufferingProxy: this.autoDetectLongPolling
        };
        this.useFetchStreams && (o.xmlHttpFactory = new (0, $3YLik.FetchXmlHttpFactory)({})), this.uo(o.initMessageHeaders, e, n), // Sending the custom headers we just added to request.initMessageHeaders
        // (Authorization, etc.) will trigger the browser to make a CORS preflight
        // request because the XHR will no longer meet the criteria for a "simple"
        // CORS request:
        // https://developer.mozilla.org/en-US/docs/Web/HTTP/CORS#Simple_requests
        // Therefore to avoid the CORS preflight request (an extra network
        // roundtrip), we use the httpHeadersOverwriteParam option to specify that
        // the headers should instead be encoded into a special "$httpHeaders" query
        // parameter, which is recognized by the webchannel backend. This is
        // formally defined here:
        // https://github.com/google/closure-library/blob/b0e1815b13fb92a46d7c9b3c30de5d6a396a3245/closure/goog/net/rpc/httpcors.js#L32
        // TODO(b/145624756): There is a backend bug where $httpHeaders isn't respected if the request
        // doesn't have an Origin header. So we have to exclude a few browser environments that are
        // known to (sometimes) not include an Origin. See
        // https://github.com/firebase/firebase-js-sdk/issues/1491.
        (0, $isbtl.isMobileCordova)() || (0, $isbtl.isReactNative)() || (0, $isbtl.isElectron)() || (0, $isbtl.isIE)() || (0, $isbtl.isUWP)() || (0, $isbtl.isBrowserExtension)() || (o.httpHeadersOverwriteParam = "$httpHeaders");
        const u = s.join("");
        $5c04988f82cad1b3$var$M("Connection", "Creating WebChannel: " + u, o);
        const c = i.createWebChannel(u, o);
        // WebChannel supports sending the first message with the handshake - saving
        // a network round trip. However, it will have to call send in the same
        // JS event loop as open. In order to enforce this, we delay actually
        // opening the WebChannel until send is called. Whether we have called
        // open is tracked with this variable.
        let a = !1, h = !1;
        // A flag to determine whether the stream was closed (by us or through an
        // error/close event) to avoid delivering multiple close events or sending
        // on a closed stream
        const l = new $5c04988f82cad1b3$var$Xo({
            jr: (t)=>{
                h ? $5c04988f82cad1b3$var$M("Connection", "Not sending because WebChannel is closed:", t) : (a || ($5c04988f82cad1b3$var$M("Connection", "Opening WebChannel transport."), c.open(), a = !0), $5c04988f82cad1b3$var$M("Connection", "WebChannel sending:", t), c.send(t));
            },
            Wr: ()=>c.close()
        }), y = (t, e, n)=>{
            // TODO(dimond): closure typing seems broken because WebChannel does
            // not implement goog.events.Listenable
            t.listen(e, (t)=>{
                try {
                    n(t);
                } catch (t) {
                    setTimeout(()=>{
                        throw t;
                    }, 0);
                }
            });
        };
        // Closure events are guarded and exceptions are swallowed, so catch any
        // exception and rethrow using a setTimeout so they become visible again.
        // Note that eventually this function could go away if we are confident
        // enough the code is exception free.
        return y(c, (0, $3YLik.WebChannel).EventType.OPEN, ()=>{
            h || $5c04988f82cad1b3$var$M("Connection", "WebChannel transport opened.");
        }), y(c, (0, $3YLik.WebChannel).EventType.CLOSE, ()=>{
            h || (h = !0, $5c04988f82cad1b3$var$M("Connection", "WebChannel transport closed"), l.eo());
        }), y(c, (0, $3YLik.WebChannel).EventType.ERROR, (t)=>{
            h || (h = !0, $5c04988f82cad1b3$export$86cd73f49cc6e0bb("Connection", "WebChannel transport errored:", t), l.eo(new $5c04988f82cad1b3$export$8fada0bf726bf278($5c04988f82cad1b3$var$G.UNAVAILABLE, "The operation could not be completed")));
        }), y(c, (0, $3YLik.WebChannel).EventType.MESSAGE, (t)=>{
            var e;
            if (!h) {
                const n = t.data[0];
                $5c04988f82cad1b3$var$U(!!n);
                // TODO(b/35143891): There is a bug in One Platform that caused errors
                // (and only errors) to be wrapped in an extra array. To be forward
                // compatible with the bug we need to check either condition. The latter
                // can be removed once the fix has been rolled out.
                // Use any because msgData.error is not typed.
                const s = n, i = s.error || (null === (e = s[0]) || void 0 === e ? void 0 : e.error);
                if (i) {
                    $5c04988f82cad1b3$var$M("Connection", "WebChannel received error:", i);
                    // error.status will be a string like 'OK' or 'NOT_FOUND'.
                    const t = i.status;
                    let e = /**
 * Maps an error Code from a GRPC status identifier like 'NOT_FOUND'.
 *
 * @returns The Code equivalent to the given status string or undefined if
 *     there is no match.
 */ function(t) {
                        // lookup by string
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        const e = $5c04988f82cad1b3$var$ts[t];
                        if (void 0 !== e) return $5c04988f82cad1b3$var$ss(e);
                    }(t), n = i.message;
                    void 0 === e && (e = $5c04988f82cad1b3$var$G.INTERNAL, n = "Unknown error status: " + t + " with message " + i.message), // Mark closed so no further events are propagated
                    h = !0, l.eo(new $5c04988f82cad1b3$export$8fada0bf726bf278(e, n)), c.close();
                } else $5c04988f82cad1b3$var$M("Connection", "WebChannel received:", n), l.no(n);
            }
        }), y(r, (0, $3YLik.Event).STAT_EVENT, (t)=>{
            t.stat === (0, $3YLik.Stat).PROXY ? $5c04988f82cad1b3$var$M("Connection", "Detected buffering proxy") : t.stat === (0, $3YLik.Stat).NOPROXY && $5c04988f82cad1b3$var$M("Connection", "Detected no buffering proxy");
        }), setTimeout(()=>{
            // Technically we could/should wait for the WebChannel opened event,
            // but because we want to send the first message with the WebChannel
            // handshake we pretend the channel opened here (asynchronously), and
            // then delay the actual open until the first message is sent.
            l.Zr();
        }, 0), l;
    }
    constructor(t){
        super(t), this.forceLongPolling = t.forceLongPolling, this.autoDetectLongPolling = t.autoDetectLongPolling, this.useFetchStreams = t.useFetchStreams;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Initializes the WebChannelConnection for the browser. */ /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** The Platform's 'window' implementation or null if not available. */ function $5c04988f82cad1b3$var$tu() {
    // `window` is not always available, e.g. in ReactNative and WebWorkers.
    // eslint-disable-next-line no-restricted-globals
    return "undefined" != typeof window ? window : null;
}
/** The Platform's 'document' implementation or null if not available. */ function $5c04988f82cad1b3$var$eu() {
    // `document` is not always available, e.g. in ReactNative and WebWorkers.
    // eslint-disable-next-line no-restricted-globals
    return "undefined" != typeof document ? document : null;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $5c04988f82cad1b3$var$nu(t) {
    return new $5c04988f82cad1b3$var$Ss(t, /* useProto3Json= */ !0);
}
/**
 * An instance of the Platform's 'TextEncoder' implementation.
 */ /**
 * A helper for running delayed tasks following an exponential backoff curve
 * between attempts.
 *
 * Each delay is made up of a "base" delay which follows the exponential
 * backoff curve, and a +/- 50% "jitter" that is calculated and added to the
 * base delay. This prevents clients from accidentally synchronizing their
 * delays causing spikes of load to the backend.
 */ class $5c04988f82cad1b3$var$su {
    /**
     * Resets the backoff delay.
     *
     * The very next backoffAndWait() will have no delay. If it is called again
     * (i.e. due to an error), initialDelayMs (plus jitter) will be used, and
     * subsequent ones will increase according to the backoffFactor.
     */ reset() {
        this.wo = 0;
    }
    /**
     * Resets the backoff delay to the maximum delay (e.g. for use after a
     * RESOURCE_EXHAUSTED error).
     */ po() {
        this.wo = this._o;
    }
    /**
     * Returns a promise that resolves after currentDelayMs, and increases the
     * delay for any subsequent attempts. If there was a pending backoff operation
     * already, it will be canceled.
     */ Io(t) {
        // Cancel any pending backoff operation.
        this.cancel();
        // First schedule using the current base (which may be 0 and should be
        // honored as such).
        const e = Math.floor(this.wo + this.To()), n = Math.max(0, Date.now() - this.yo), s = Math.max(0, e - n);
        // Guard against lastAttemptTime being in the future due to a clock change.
        s > 0 && $5c04988f82cad1b3$var$M("ExponentialBackoff", `Backing off for ${s} ms (base delay: ${this.wo} ms, delay with jitter: ${e} ms, last attempt: ${n} ms ago)`), this.mo = this.js.enqueueAfterDelay(this.timerId, s, ()=>(this.yo = Date.now(), t())), // Apply backoff factor to determine next delay and ensure it is within
        // bounds.
        this.wo *= this.fo, this.wo < this.lo && (this.wo = this.lo), this.wo > this._o && (this.wo = this._o);
    }
    Eo() {
        null !== this.mo && (this.mo.skipDelay(), this.mo = null);
    }
    cancel() {
        null !== this.mo && (this.mo.cancel(), this.mo = null);
    }
    /** Returns a random value in the range [-currentBaseMs/2, currentBaseMs/2] */ To() {
        return (Math.random() - .5) * this.wo;
    }
    constructor(/**
     * The AsyncQueue to run backoff operations on.
     */ t, /**
     * The ID to use when scheduling backoff operations on the AsyncQueue.
     */ e, /**
     * The initial delay (used as the base delay on the first retry attempt).
     * Note that jitter will still be applied, so the actual delay could be as
     * little as 0.5*initialDelayMs.
     */ n = 1e3, s = 1.5, i = 6e4){
        this.js = t, this.timerId = e, this.lo = n, this.fo = s, this._o = i, this.wo = 0, this.mo = null, /** The last backoff attempt, as epoch milliseconds. */ this.yo = Date.now(), this.reset();
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A PersistentStream is an abstract base class that represents a streaming RPC
 * to the Firestore backend. It's built on top of the connections own support
 * for streaming RPCs, and adds several critical features for our clients:
 *
 *   - Exponential backoff on failure
 *   - Authentication via CredentialsProvider
 *   - Dispatching all callbacks into the shared worker queue
 *   - Closing idle streams after 60 seconds of inactivity
 *
 * Subclasses of PersistentStream implement serialization of models to and
 * from the JSON representation of the protocol buffers for a specific
 * streaming RPC.
 *
 * ## Starting and Stopping
 *
 * Streaming RPCs are stateful and need to be start()ed before messages can
 * be sent and received. The PersistentStream will call the onOpen() function
 * of the listener once the stream is ready to accept requests.
 *
 * Should a start() fail, PersistentStream will call the registered onClose()
 * listener with a FirestoreError indicating what went wrong.
 *
 * A PersistentStream can be started and stopped repeatedly.
 *
 * Generic types:
 *  SendType: The type of the outgoing message of the underlying
 *    connection stream
 *  ReceiveType: The type of the incoming message of the underlying
 *    connection stream
 *  ListenerType: The type of the listener that will be used for callbacks
 */ class $5c04988f82cad1b3$var$iu {
    /**
     * Returns true if start() has been called and no error has occurred. True
     * indicates the stream is open or in the process of opening (which
     * encompasses respecting backoff, getting auth tokens, and starting the
     * actual RPC). Use isOpen() to determine if the stream is open and ready for
     * outbound requests.
     */ Do() {
        return 1 /* Starting */  === this.state || 5 /* Backoff */  === this.state || this.Co();
    }
    /**
     * Returns true if the underlying RPC is open (the onOpen() listener has been
     * called) and the stream is ready for outbound requests.
     */ Co() {
        return 2 /* Open */  === this.state || 3 /* Healthy */  === this.state;
    }
    /**
     * Starts the RPC. Only allowed if isStarted() returns false. The stream is
     * not immediately ready for use: onOpen() will be invoked when the RPC is
     * ready for outbound requests, at which point isOpen() will return true.
     *
     * When start returns, isStarted() will return true.
     */ start() {
        4 /* Error */  !== this.state ? this.auth() : this.xo();
    }
    /**
     * Stops the RPC. This call is idempotent and allowed regardless of the
     * current isStarted() state.
     *
     * When stop returns, isStarted() and isOpen() will both return false.
     */ async stop() {
        this.Do() && await this.close(0 /* Initial */ );
    }
    /**
     * After an error the stream will usually back off on the next attempt to
     * start it. If the error warrants an immediate restart of the stream, the
     * sender can use this to indicate that the receiver should not back off.
     *
     * Each error will call the onClose() listener. That function can decide to
     * inhibit backoff if required.
     */ No() {
        this.state = 0 /* Initial */ , this.So.reset();
    }
    /**
     * Marks this stream as idle. If no further actions are performed on the
     * stream for one minute, the stream will automatically close itself and
     * notify the stream's onClose() handler with Status.OK. The stream will then
     * be in a !isStarted() state, requiring the caller to start the stream again
     * before further use.
     *
     * Only streams that are in state 'Open' can be marked idle, as all other
     * states imply pending network operations.
     */ ko() {
        // Starts the idle time if we are in state 'Open' and are not yet already
        // running a timer (in which case the previous idle timeout still applies).
        this.Co() && null === this.vo && (this.vo = this.js.enqueueAfterDelay(this.Ao, 6e4, ()=>this.Oo()));
    }
    /** Sends a message to the underlying stream. */ Mo(t) {
        this.Fo(), this.stream.send(t);
    }
    /** Called by the idle timer when the stream should close due to inactivity. */ async Oo() {
        if (this.Co()) // When timing out an idle stream there's no reason to force the stream into backoff when
        // it restarts so set the stream state to Initial instead of Error.
        return this.close(0 /* Initial */ );
    }
    /** Marks the stream as active again. */ Fo() {
        this.vo && (this.vo.cancel(), this.vo = null);
    }
    /** Cancels the health check delayed operation. */ $o() {
        this.Vo && (this.Vo.cancel(), this.Vo = null);
    }
    /**
     * Closes the stream and cleans up as necessary:
     *
     * * closes the underlying GRPC stream;
     * * calls the onClose handler with the given 'error';
     * * sets internal stream state to 'finalState';
     * * adjusts the backoff timer based on the error
     *
     * A new stream can be opened by calling start().
     *
     * @param finalState - the intended state of the stream after closing.
     * @param error - the error the connection was closed with.
     */ async close(t, e) {
        // Cancel any outstanding timers (they're guaranteed not to execute).
        this.Fo(), this.$o(), this.So.cancel(), // Invalidates any stream-related callbacks (e.g. from auth or the
        // underlying stream), guaranteeing they won't execute.
        this.Po++, 4 /* Error */  !== t ? // If this is an intentional close ensure we don't delay our next connection attempt.
        this.So.reset() : e && e.code === $5c04988f82cad1b3$var$G.RESOURCE_EXHAUSTED ? // Log the error. (Probably either 'quota exceeded' or 'max queue length reached'.)
        ($5c04988f82cad1b3$var$F(e.toString()), $5c04988f82cad1b3$var$F("Using maximum backoff delay to prevent overloading the backend."), this.So.po()) : e && e.code === $5c04988f82cad1b3$var$G.UNAUTHENTICATED && 3 /* Healthy */  !== this.state && // "unauthenticated" error means the token was rejected. This should rarely
        // happen since both Auth and AppCheck ensure a sufficient TTL when we
        // request a token. If a user manually resets their system clock this can
        // fail, however. In this case, we should get a Code.UNAUTHENTICATED error
        // before we received the first message and we need to invalidate the token
        // to ensure that we fetch a new token.
        (this.authCredentialsProvider.invalidateToken(), this.appCheckCredentialsProvider.invalidateToken()), // Clean up the underlying stream because we are no longer interested in events.
        null !== this.stream && (this.Bo(), this.stream.close(), this.stream = null), // This state must be assigned before calling onClose() to allow the callback to
        // inhibit backoff or otherwise manipulate the state in its non-started state.
        this.state = t, // Notify the listener that the stream closed.
        await this.listener.Jr(e);
    }
    /**
     * Can be overridden to perform additional cleanup before the stream is closed.
     * Calling super.tearDown() is not required.
     */ Bo() {}
    auth() {
        this.state = 1 /* Starting */ ;
        const t = this.Lo(this.Po), e = this.Po;
        // TODO(mikelehen): Just use dispatchIfNotClosed, but see TODO below.
        Promise.all([
            this.authCredentialsProvider.getToken(),
            this.appCheckCredentialsProvider.getToken()
        ]).then(([t, n])=>{
            // Stream can be stopped while waiting for authentication.
            // TODO(mikelehen): We really should just use dispatchIfNotClosed
            // and let this dispatch onto the queue, but that opened a spec test can
            // of worms that I don't want to deal with in this PR.
            this.Po === e && // Normally we'd have to schedule the callback on the AsyncQueue.
            // However, the following calls are safe to be called outside the
            // AsyncQueue since they don't chain asynchronous calls
            this.Uo(t, n);
        }, (e)=>{
            t(()=>{
                const t = new $5c04988f82cad1b3$export$8fada0bf726bf278($5c04988f82cad1b3$var$G.UNKNOWN, "Fetching auth token failed: " + e.message);
                return this.qo(t);
            });
        });
    }
    Uo(t, e) {
        const n = this.Lo(this.Po);
        this.stream = this.Ko(t, e), this.stream.zr(()=>{
            n(()=>(this.state = 2 /* Open */ , this.Vo = this.js.enqueueAfterDelay(this.Ro, 1e4, ()=>(this.Co() && (this.state = 3 /* Healthy */ ), Promise.resolve())), this.listener.zr()));
        }), this.stream.Jr((t)=>{
            n(()=>this.qo(t));
        }), this.stream.onMessage((t)=>{
            n(()=>this.onMessage(t));
        });
    }
    xo() {
        this.state = 5 /* Backoff */ , this.So.Io(async ()=>{
            this.state = 0 /* Initial */ , this.start();
        });
    }
    // Visible for tests
    qo(t) {
        // In theory the stream could close cleanly, however, in our current model
        // we never expect this to happen because if we stop a stream ourselves,
        // this callback will never be called. To prevent cases where we retry
        // without a backoff accidentally, we set the stream to error in all cases.
        return $5c04988f82cad1b3$var$M("PersistentStream", `close with error: ${t}`), this.stream = null, this.close(4 /* Error */ , t);
    }
    /**
     * Returns a "dispatcher" function that dispatches operations onto the
     * AsyncQueue but only runs them if closeCount remains unchanged. This allows
     * us to turn auth / stream callbacks into no-ops if the stream is closed /
     * re-opened, etc.
     */ Lo(t) {
        return (e)=>{
            this.js.enqueueAndForget(()=>this.Po === t ? e() : ($5c04988f82cad1b3$var$M("PersistentStream", "stream callback skipped by getCloseGuardedDispatcher."), Promise.resolve()));
        };
    }
    constructor(t, e, n, s, i, r, o, u){
        this.js = t, this.Ao = n, this.Ro = s, this.bo = i, this.authCredentialsProvider = r, this.appCheckCredentialsProvider = o, this.listener = u, this.state = 0 /* Initial */ , /**
         * A close count that's incremented every time the stream is closed; used by
         * getCloseGuardedDispatcher() to invalidate callbacks that happen after
         * close.
         */ this.Po = 0, this.vo = null, this.Vo = null, this.stream = null, this.So = new $5c04988f82cad1b3$var$su(t, e);
    }
}
/**
 * A PersistentStream that implements the Listen RPC.
 *
 * Once the Listen stream has called the onOpen() listener, any number of
 * listen() and unlisten() calls can be made to control what changes will be
 * sent from the server for ListenResponses.
 */ class $5c04988f82cad1b3$var$ru extends $5c04988f82cad1b3$var$iu {
    Ko(t, e) {
        return this.bo.ho("Listen", t, e);
    }
    onMessage(t) {
        // A successful response means the stream is healthy
        this.So.reset();
        const e = $5c04988f82cad1b3$var$Qs(this.wt, t), n = function(t) {
            // We have only reached a consistent snapshot for the entire stream if there
            // is a read_time set and it applies to all targets (i.e. the list of
            // targets is empty). The backend is guaranteed to send such responses.
            if (!("targetChange" in t)) return $5c04988f82cad1b3$var$ct.min();
            const e = t.targetChange;
            return e.targetIds && e.targetIds.length ? $5c04988f82cad1b3$var$ct.min() : e.readTime ? $5c04988f82cad1b3$var$Ns(e.readTime) : $5c04988f82cad1b3$var$ct.min();
        }(t);
        return this.listener.Go(e, n);
    }
    /**
     * Registers interest in the results of the given target. If the target
     * includes a resumeToken it will be included in the request. Results that
     * affect the target will be streamed back as WatchChange messages that
     * reference the targetId.
     */ Qo(t) {
        const e = {};
        e.database = $5c04988f82cad1b3$var$Ls(this.wt), e.addTarget = function(t, e) {
            let n;
            const s = e.target;
            return n = $5c04988f82cad1b3$var$$e(s) ? {
                documents: $5c04988f82cad1b3$var$Hs(t, s)
            } : {
                query: $5c04988f82cad1b3$var$Js(t, s)
            }, n.targetId = e.targetId, e.resumeToken.approximateByteSize() > 0 ? n.resumeToken = $5c04988f82cad1b3$var$Cs(t, e.resumeToken) : e.snapshotVersion.compareTo($5c04988f82cad1b3$var$ct.min()) > 0 && // TODO(wuandy): Consider removing above check because it is most likely true.
            // Right now, many tests depend on this behaviour though (leaving min() out
            // of serialization).
            (n.readTime = $5c04988f82cad1b3$var$Ds(t, e.snapshotVersion.toTimestamp())), n;
        }(this.wt, t);
        const n = $5c04988f82cad1b3$var$Xs(this.wt, t);
        n && (e.labels = n), this.Mo(e);
    }
    /**
     * Unregisters interest in the results of the target associated with the
     * given targetId.
     */ jo(t) {
        const e = {};
        e.database = $5c04988f82cad1b3$var$Ls(this.wt), e.removeTarget = t, this.Mo(e);
    }
    constructor(t, e, n, s, i, r){
        super(t, "listen_stream_connection_backoff" /* ListenStreamConnectionBackoff */ , "listen_stream_idle" /* ListenStreamIdle */ , "health_check_timeout" /* HealthCheckTimeout */ , e, n, s, r), this.wt = i;
    }
}
/**
 * A Stream that implements the Write RPC.
 *
 * The Write RPC requires the caller to maintain special streamToken
 * state in between calls, to help the server understand which responses the
 * client has processed by the time the next request is made. Every response
 * will contain a streamToken; this value must be passed to the next
 * request.
 *
 * After calling start() on this stream, the next request must be a handshake,
 * containing whatever streamToken is on hand. Once a response to this
 * request is received, all pending mutations may be submitted. When
 * submitting multiple batches of mutations at the same time, it's
 * okay to use the same streamToken for the calls to writeMutations.
 *
 * TODO(b/33271235): Use proto types
 */ class $5c04988f82cad1b3$var$ou extends $5c04988f82cad1b3$var$iu {
    /**
     * Tracks whether or not a handshake has been successfully exchanged and
     * the stream is ready to accept mutations.
     */ get zo() {
        return this.Wo;
    }
    // Override of PersistentStream.start
    start() {
        this.Wo = !1, this.lastStreamToken = void 0, super.start();
    }
    Bo() {
        this.Wo && this.Ho([]);
    }
    Ko(t, e) {
        return this.bo.ho("Write", t, e);
    }
    onMessage(t) {
        if (// Always capture the last stream token.
        $5c04988f82cad1b3$var$U(!!t.streamToken), this.lastStreamToken = t.streamToken, this.Wo) {
            // A successful first write response means the stream is healthy,
            // Note, that we could consider a successful handshake healthy, however,
            // the write itself might be causing an error we want to back off from.
            this.So.reset();
            const e = $5c04988f82cad1b3$var$zs(t.writeResults, t.commitTime), n = $5c04988f82cad1b3$var$Ns(t.commitTime);
            return this.listener.Jo(n, e);
        }
        // The first response is always the handshake response
        return $5c04988f82cad1b3$var$U(!t.writeResults || 0 === t.writeResults.length), this.Wo = !0, this.listener.Yo();
    }
    /**
     * Sends an initial streamToken to the server, performing the handshake
     * required to make the StreamingWrite RPC work. Subsequent
     * calls should wait until onHandshakeComplete was called.
     */ Xo() {
        // TODO(dimond): Support stream resumption. We intentionally do not set the
        // stream token on the handshake, ignoring any stream token we might have.
        const t = {};
        t.database = $5c04988f82cad1b3$var$Ls(this.wt), this.Mo(t);
    }
    /** Sends a group of mutations to the Firestore backend to apply. */ Ho(t) {
        const e = {
            streamToken: this.lastStreamToken,
            writes: t.map((t)=>$5c04988f82cad1b3$var$js(this.wt, t))
        };
        this.Mo(e);
    }
    constructor(t, e, n, s, i, r){
        super(t, "write_stream_connection_backoff" /* WriteStreamConnectionBackoff */ , "write_stream_idle" /* WriteStreamIdle */ , "health_check_timeout" /* HealthCheckTimeout */ , e, n, s, r), this.wt = i, this.Wo = !1;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Datastore and its related methods are a wrapper around the external Google
 * Cloud Datastore grpc API, which provides an interface that is more convenient
 * for the rest of the client SDK architecture to consume.
 */ /**
 * An implementation of Datastore that exposes additional state for internal
 * consumption.
 */ class $5c04988f82cad1b3$var$uu extends class {
} {
    tu() {
        if (this.Zo) throw new $5c04988f82cad1b3$export$8fada0bf726bf278($5c04988f82cad1b3$var$G.FAILED_PRECONDITION, "The client has already been terminated.");
    }
    /** Invokes the provided RPC with auth and AppCheck tokens. */ ro(t, e, n) {
        return this.tu(), Promise.all([
            this.authCredentials.getToken(),
            this.appCheckCredentials.getToken()
        ]).then(([s, i])=>this.bo.ro(t, e, n, s, i)).catch((t)=>{
            throw "FirebaseError" === t.name ? (t.code === $5c04988f82cad1b3$var$G.UNAUTHENTICATED && (this.authCredentials.invalidateToken(), this.appCheckCredentials.invalidateToken()), t) : new $5c04988f82cad1b3$export$8fada0bf726bf278($5c04988f82cad1b3$var$G.UNKNOWN, t.toString());
        });
    }
    /** Invokes the provided RPC with streamed results with auth and AppCheck tokens. */ ao(t, e, n) {
        return this.tu(), Promise.all([
            this.authCredentials.getToken(),
            this.appCheckCredentials.getToken()
        ]).then(([s, i])=>this.bo.ao(t, e, n, s, i)).catch((t)=>{
            throw "FirebaseError" === t.name ? (t.code === $5c04988f82cad1b3$var$G.UNAUTHENTICATED && (this.authCredentials.invalidateToken(), this.appCheckCredentials.invalidateToken()), t) : new $5c04988f82cad1b3$export$8fada0bf726bf278($5c04988f82cad1b3$var$G.UNKNOWN, t.toString());
        });
    }
    terminate() {
        this.Zo = !0;
    }
    constructor(t, e, n, s){
        super(), this.authCredentials = t, this.appCheckCredentials = e, this.bo = n, this.wt = s, this.Zo = !1;
    }
}
// TODO(firestorexp): Make sure there is only one Datastore instance per
// firestore-exp client.
/**
 * A component used by the RemoteStore to track the OnlineState (that is,
 * whether or not the client as a whole should be considered to be online or
 * offline), implementing the appropriate heuristics.
 *
 * In particular, when the client is trying to connect to the backend, we
 * allow up to MAX_WATCH_STREAM_FAILURES within ONLINE_STATE_TIMEOUT_MS for
 * a connection to succeed. If we have too many failures or the timeout elapses,
 * then we set the OnlineState to Offline, and the client will behave as if
 * it is offline (get()s will return cached data, etc.).
 */ class $5c04988f82cad1b3$var$cu {
    /**
     * Called by RemoteStore when a watch stream is started (including on each
     * backoff attempt).
     *
     * If this is the first attempt, it sets the OnlineState to Unknown and starts
     * the onlineStateTimer.
     */ iu() {
        0 === this.eu && (this.ru("Unknown" /* Unknown */ ), this.nu = this.asyncQueue.enqueueAfterDelay("online_state_timeout" /* OnlineStateTimeout */ , 1e4, ()=>(this.nu = null, this.ou("Backend didn't respond within 10 seconds."), this.ru("Offline" /* Offline */ ), Promise.resolve())));
    }
    /**
     * Updates our OnlineState as appropriate after the watch stream reports a
     * failure. The first failure moves us to the 'Unknown' state. We then may
     * allow multiple failures (based on MAX_WATCH_STREAM_FAILURES) before we
     * actually transition to the 'Offline' state.
     */ uu(t) {
        "Online" /* Online */  === this.state ? this.ru("Unknown" /* Unknown */ ) : (this.eu++, this.eu >= 1 && (this.cu(), this.ou(`Connection failed 1 times. Most recent error: ${t.toString()}`), this.ru("Offline" /* Offline */ )));
    }
    /**
     * Explicitly sets the OnlineState to the specified state.
     *
     * Note that this resets our timers / failure counters, etc. used by our
     * Offline heuristics, so must not be used in place of
     * handleWatchStreamStart() and handleWatchStreamFailure().
     */ set(t) {
        this.cu(), this.eu = 0, "Online" /* Online */  === t && // We've connected to watch at least once. Don't warn the developer
        // about being offline going forward.
        (this.su = !1), this.ru(t);
    }
    ru(t) {
        t !== this.state && (this.state = t, this.onlineStateHandler(t));
    }
    ou(t) {
        const e = `Could not reach Cloud Firestore backend. ${t}\nThis typically indicates that your device does not have a healthy Internet connection at the moment. The client will operate in offline mode until it is able to successfully connect to the backend.`;
        this.su ? ($5c04988f82cad1b3$var$F(e), this.su = !1) : $5c04988f82cad1b3$var$M("OnlineStateTracker", e);
    }
    cu() {
        null !== this.nu && (this.nu.cancel(), this.nu = null);
    }
    constructor(t, e){
        this.asyncQueue = t, this.onlineStateHandler = e, /** The current OnlineState. */ this.state = "Unknown" /* Unknown */ , /**
         * A count of consecutive failures to open the stream. If it reaches the
         * maximum defined by MAX_WATCH_STREAM_FAILURES, we'll set the OnlineState to
         * Offline.
         */ this.eu = 0, /**
         * A timer that elapses after ONLINE_STATE_TIMEOUT_MS, at which point we
         * transition from OnlineState.Unknown to OnlineState.Offline without waiting
         * for the stream to actually fail (MAX_WATCH_STREAM_FAILURES times).
         */ this.nu = null, /**
         * Whether the client should log a warning message if it fails to connect to
         * the backend (initially true, cleared after a successful stream, or if we've
         * logged the message already).
         */ this.su = !0;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $5c04988f82cad1b3$var$au {
    constructor(/**
     * The local store, used to fill the write pipeline with outbound mutations.
     */ t, /** The client-side proxy for interacting with the backend. */ e, n, s, i){
        this.localStore = t, this.datastore = e, this.asyncQueue = n, this.remoteSyncer = {}, /**
         * A list of up to MAX_PENDING_WRITES writes that we have fetched from the
         * LocalStore via fillWritePipeline() and have or will send to the write
         * stream.
         *
         * Whenever writePipeline.length > 0 the RemoteStore will attempt to start or
         * restart the write stream. When the stream is established the writes in the
         * pipeline will be sent in order.
         *
         * Writes remain in writePipeline until they are acknowledged by the backend
         * and thus will automatically be re-sent if the stream is interrupted /
         * restarted before they're acknowledged.
         *
         * Write responses from the backend are linked to their originating request
         * purely based on order, and so we can just shift() writes from the front of
         * the writePipeline as we receive responses.
         */ this.au = [], /**
         * A mapping of watched targets that the client cares about tracking and the
         * user has explicitly called a 'listen' for this target.
         *
         * These targets may or may not have been sent to or acknowledged by the
         * server. On re-establishing the listen stream, these targets should be sent
         * to the server. The targets removed with unlistens are removed eagerly
         * without waiting for confirmation from the listen stream.
         */ this.hu = new Map, /**
         * A set of reasons for why the RemoteStore may be offline. If empty, the
         * RemoteStore may start its network connections.
         */ this.lu = new Set, /**
         * Event handlers that get called when the network is disabled or enabled.
         *
         * PORTING NOTE: These functions are used on the Web client to create the
         * underlying streams (to support tree-shakeable streams). On Android and iOS,
         * the streams are created during construction of RemoteStore.
         */ this.fu = [], this.du = i, this.du.Br((t)=>{
            n.enqueueAndForget(async ()=>{
                // Porting Note: Unlike iOS, `restartNetwork()` is called even when the
                // network becomes unreachable as we don't have any other way to tear
                // down our streams.
                $5c04988f82cad1b3$var$yu(this) && ($5c04988f82cad1b3$var$M("RemoteStore", "Restarting streams for network reachability change."), await async function(t) {
                    const e = $5c04988f82cad1b3$var$K(t);
                    e.lu.add(4 /* ConnectivityChange */ ), await $5c04988f82cad1b3$var$lu(e), e._u.set("Unknown" /* Unknown */ ), e.lu.delete(4 /* ConnectivityChange */ ), await $5c04988f82cad1b3$var$hu(e);
                }(this));
            });
        }), this._u = new $5c04988f82cad1b3$var$cu(n, s);
    }
}
async function $5c04988f82cad1b3$var$hu(t) {
    if ($5c04988f82cad1b3$var$yu(t)) for (const e of t.fu)await e(/* enabled= */ !0);
}
/**
 * Temporarily disables the network. The network can be re-enabled using
 * enableNetwork().
 */ async function $5c04988f82cad1b3$var$lu(t) {
    for (const e of t.fu)await e(/* enabled= */ !1);
}
/**
 * Starts new listen for the given target. Uses resume token if provided. It
 * is a no-op if the target of given `TargetData` is already being listened to.
 */ function $5c04988f82cad1b3$var$fu(t, e) {
    const n = $5c04988f82cad1b3$var$K(t);
    n.hu.has(e.targetId) || // Mark this as something the client is currently listening for.
    (n.hu.set(e.targetId, e), $5c04988f82cad1b3$var$gu(n) ? // The listen will be sent in onWatchStreamOpen
    $5c04988f82cad1b3$var$mu(n) : $5c04988f82cad1b3$var$Mu(n).Co() && $5c04988f82cad1b3$var$_u(n, e));
}
/**
 * Removes the listen from server. It is a no-op if the given target id is
 * not being listened to.
 */ function $5c04988f82cad1b3$var$du(t, e) {
    const n = $5c04988f82cad1b3$var$K(t), s = $5c04988f82cad1b3$var$Mu(n);
    n.hu.delete(e), s.Co() && $5c04988f82cad1b3$var$wu(n, e), 0 === n.hu.size && (s.Co() ? s.ko() : $5c04988f82cad1b3$var$yu(n) && // Revert to OnlineState.Unknown if the watch stream is not open and we
    // have no listeners, since without any listens to send we cannot
    // confirm if the stream is healthy and upgrade to OnlineState.Online.
    n._u.set("Unknown" /* Unknown */ ));
}
/**
 * We need to increment the the expected number of pending responses we're due
 * from watch so we wait for the ack to process any messages from this target.
 */ function $5c04988f82cad1b3$var$_u(t, e) {
    t.wu.Nt(e.targetId), $5c04988f82cad1b3$var$Mu(t).Qo(e);
}
/**
 * We need to increment the expected number of pending responses we're due
 * from watch so we wait for the removal on the server before we process any
 * messages from this target.
 */ function $5c04988f82cad1b3$var$wu(t, e) {
    t.wu.Nt(e), $5c04988f82cad1b3$var$Mu(t).jo(e);
}
function $5c04988f82cad1b3$var$mu(t) {
    t.wu = new $5c04988f82cad1b3$var$Rs({
        getRemoteKeysForTarget: (e)=>t.remoteSyncer.getRemoteKeysForTarget(e),
        te: (e)=>t.hu.get(e) || null
    }), $5c04988f82cad1b3$var$Mu(t).start(), t._u.iu();
}
/**
 * Returns whether the watch stream should be started because it's necessary
 * and has not yet been started.
 */ function $5c04988f82cad1b3$var$gu(t) {
    return $5c04988f82cad1b3$var$yu(t) && !$5c04988f82cad1b3$var$Mu(t).Do() && t.hu.size > 0;
}
function $5c04988f82cad1b3$var$yu(t) {
    return 0 === $5c04988f82cad1b3$var$K(t).lu.size;
}
function $5c04988f82cad1b3$var$pu(t) {
    t.wu = void 0;
}
async function $5c04988f82cad1b3$var$Iu(t) {
    t.hu.forEach((e, n)=>{
        $5c04988f82cad1b3$var$_u(t, e);
    });
}
async function $5c04988f82cad1b3$var$Tu(t, e) {
    $5c04988f82cad1b3$var$pu(t), // If we still need the watch stream, retry the connection.
    $5c04988f82cad1b3$var$gu(t) ? (t._u.uu(e), $5c04988f82cad1b3$var$mu(t)) : // No need to restart watch stream because there are no active targets.
    // The online state is set to unknown because there is no active attempt
    // at establishing a connection
    t._u.set("Unknown" /* Unknown */ );
}
async function $5c04988f82cad1b3$var$Eu(t, e, n) {
    if (// Mark the client as online since we got a message from the server
    t._u.set("Online" /* Online */ ), e instanceof $5c04988f82cad1b3$var$Es && 2 /* Removed */  === e.state && e.cause) // There was an error on a target, don't wait for a consistent snapshot
    // to raise events
    try {
        await /** Handles an error on a target */ async function(t, e) {
            const n = e.cause;
            for (const s of e.targetIds)// A watched target might have been removed already.
            t.hu.has(s) && (await t.remoteSyncer.rejectListen(s, n), t.hu.delete(s), t.wu.removeTarget(s));
        }(t, e);
    } catch (n) {
        $5c04988f82cad1b3$var$M("RemoteStore", "Failed to remove targets %s: %s ", e.targetIds.join(","), n), await $5c04988f82cad1b3$var$Au(t, n);
    }
    else if (e instanceof $5c04988f82cad1b3$var$Is ? t.wu.Ut(e) : e instanceof $5c04988f82cad1b3$var$Ts ? t.wu.zt(e) : t.wu.Gt(e), !n.isEqual($5c04988f82cad1b3$var$ct.min())) try {
        const e = await $5c04988f82cad1b3$var$vo(t.localStore);
        n.compareTo(e) >= 0 && // We have received a target change with a global snapshot if the snapshot
        // version is not equal to SnapshotVersion.min().
        await /**
 * Takes a batch of changes from the Datastore, repackages them as a
 * RemoteEvent, and passes that on to the listener, which is typically the
 * SyncEngine.
 */ function(t, e) {
            const n = t.wu.Yt(e);
            // Update in-memory resume tokens. LocalStore will update the
            // persistent view of these when applying the completed RemoteEvent.
            return n.targetChanges.forEach((n, s)=>{
                if (n.resumeToken.approximateByteSize() > 0) {
                    const i = t.hu.get(s);
                    // A watched target might have been removed already.
                    i && t.hu.set(s, i.withResumeToken(n.resumeToken, e));
                }
            }), // Re-establish listens for the targets that have been invalidated by
            // existence filter mismatches.
            n.targetMismatches.forEach((e)=>{
                const n = t.hu.get(e);
                if (!n) // A watched target might have been removed already.
                return;
                // Clear the resume token for the target, since we're in a known mismatch
                // state.
                t.hu.set(e, n.withResumeToken($5c04988f82cad1b3$var$Jt.EMPTY_BYTE_STRING, n.snapshotVersion)), // Cause a hard reset by unwatching and rewatching immediately, but
                // deliberately don't send a resume token so that we get a full update.
                $5c04988f82cad1b3$var$wu(t, e);
                // Mark the target we send as being on behalf of an existence filter
                // mismatch, but don't actually retain that in listenTargets. This ensures
                // that we flag the first re-listen this way without impacting future
                // listens of this target (that might happen e.g. on reconnect).
                const s = new $5c04988f82cad1b3$var$Li(n.target, e, 1 /* ExistenceFilterMismatch */ , n.sequenceNumber);
                $5c04988f82cad1b3$var$_u(t, s);
            }), t.remoteSyncer.applyRemoteEvent(n);
        }(t, n);
    } catch (e) {
        $5c04988f82cad1b3$var$M("RemoteStore", "Failed to raise snapshot:", e), await $5c04988f82cad1b3$var$Au(t, e);
    }
}
/**
 * Recovery logic for IndexedDB errors that takes the network offline until
 * `op` succeeds. Retries are scheduled with backoff using
 * `enqueueRetryable()`. If `op()` is not provided, IndexedDB access is
 * validated via a generic operation.
 *
 * The returned Promise is resolved once the network is disabled and before
 * any retry attempt.
 */ async function $5c04988f82cad1b3$var$Au(t, e, n) {
    if (!$5c04988f82cad1b3$var$Ct(e)) throw e;
    t.lu.add(1 /* IndexedDbFailed */ ), // Disable network and raise offline snapshots
    await $5c04988f82cad1b3$var$lu(t), t._u.set("Offline" /* Offline */ ), n || // Use a simple read operation to determine if IndexedDB recovered.
    // Ideally, we would expose a health check directly on SimpleDb, but
    // RemoteStore only has access to persistence through LocalStore.
    (n = ()=>$5c04988f82cad1b3$var$vo(t.localStore)), // Probe IndexedDB periodically and re-enable network
    t.asyncQueue.enqueueRetryable(async ()=>{
        $5c04988f82cad1b3$var$M("RemoteStore", "Retrying IndexedDB access"), await n(), t.lu.delete(1 /* IndexedDbFailed */ ), await $5c04988f82cad1b3$var$hu(t);
    });
}
/**
 * Executes `op`. If `op` fails, takes the network offline until `op`
 * succeeds. Returns after the first attempt.
 */ function $5c04988f82cad1b3$var$Ru(t, e) {
    return e().catch((n)=>$5c04988f82cad1b3$var$Au(t, n, e));
}
async function $5c04988f82cad1b3$var$bu(t) {
    const e = $5c04988f82cad1b3$var$K(t), n = $5c04988f82cad1b3$var$Fu(e);
    let s = e.au.length > 0 ? e.au[e.au.length - 1].batchId : -1;
    for(; $5c04988f82cad1b3$var$Pu(e);)try {
        const t = await $5c04988f82cad1b3$var$Do(e.localStore, s);
        if (null === t) {
            0 === e.au.length && n.ko();
            break;
        }
        s = t.batchId, $5c04988f82cad1b3$var$vu(e, t);
    } catch (t) {
        await $5c04988f82cad1b3$var$Au(e, t);
    }
    $5c04988f82cad1b3$var$Vu(e) && $5c04988f82cad1b3$var$Su(e);
}
/**
 * Returns true if we can add to the write pipeline (i.e. the network is
 * enabled and the write pipeline is not full).
 */ function $5c04988f82cad1b3$var$Pu(t) {
    return $5c04988f82cad1b3$var$yu(t) && t.au.length < 10;
}
/**
 * Queues additional writes to be sent to the write stream, sending them
 * immediately if the write stream is established.
 */ function $5c04988f82cad1b3$var$vu(t, e) {
    t.au.push(e);
    const n = $5c04988f82cad1b3$var$Fu(t);
    n.Co() && n.zo && n.Ho(e.mutations);
}
function $5c04988f82cad1b3$var$Vu(t) {
    return $5c04988f82cad1b3$var$yu(t) && !$5c04988f82cad1b3$var$Fu(t).Do() && t.au.length > 0;
}
function $5c04988f82cad1b3$var$Su(t) {
    $5c04988f82cad1b3$var$Fu(t).start();
}
async function $5c04988f82cad1b3$var$Du(t) {
    $5c04988f82cad1b3$var$Fu(t).Xo();
}
async function $5c04988f82cad1b3$var$Cu(t) {
    const e = $5c04988f82cad1b3$var$Fu(t);
    // Send the write pipeline now that the stream is established.
    for (const n of t.au)e.Ho(n.mutations);
}
async function $5c04988f82cad1b3$var$xu(t, e, n) {
    const s = t.au.shift(), i = $5c04988f82cad1b3$var$$i.from(s, e, n);
    await $5c04988f82cad1b3$var$Ru(t, ()=>t.remoteSyncer.applySuccessfulWrite(i)), // It's possible that with the completion of this mutation another
    // slot has freed up.
    await $5c04988f82cad1b3$var$bu(t);
}
async function $5c04988f82cad1b3$var$Nu(t, e) {
    // If the write stream closed after the write handshake completes, a write
    // operation failed and we fail the pending operation.
    e && $5c04988f82cad1b3$var$Fu(t).zo && // This error affects the actual write.
    await async function(t, e) {
        // Only handle permanent errors here. If it's transient, just let the retry
        // logic kick in.
        if (n = e.code, $5c04988f82cad1b3$var$ns(n) && n !== $5c04988f82cad1b3$var$G.ABORTED) {
            // This was a permanent error, the request itself was the problem
            // so it's not going to succeed if we resend it.
            const n = t.au.shift();
            // In this case it's also unlikely that the server itself is melting
            // down -- this was just a bad request so inhibit backoff on the next
            // restart.
            $5c04988f82cad1b3$var$Fu(t).No(), await $5c04988f82cad1b3$var$Ru(t, ()=>t.remoteSyncer.rejectFailedWrite(n.batchId, e)), // It's possible that with the completion of this mutation
            // another slot has freed up.
            await $5c04988f82cad1b3$var$bu(t);
        }
        var n;
    }(t, e), // The write stream might have been started by refilling the write
    // pipeline for failed writes
    $5c04988f82cad1b3$var$Vu(t) && $5c04988f82cad1b3$var$Su(t);
}
async function $5c04988f82cad1b3$var$ku(t, e) {
    const n = $5c04988f82cad1b3$var$K(t);
    n.asyncQueue.verifyOperationInProgress(), $5c04988f82cad1b3$var$M("RemoteStore", "RemoteStore received new credentials");
    const s = $5c04988f82cad1b3$var$yu(n);
    // Tear down and re-create our network streams. This will ensure we get a
    // fresh auth token for the new user and re-fill the write pipeline with
    // new mutations from the LocalStore (since mutations are per-user).
    n.lu.add(3 /* CredentialChange */ ), await $5c04988f82cad1b3$var$lu(n), s && // Don't set the network status to Unknown if we are offline.
    n._u.set("Unknown" /* Unknown */ ), await n.remoteSyncer.handleCredentialChange(e), n.lu.delete(3 /* CredentialChange */ ), await $5c04988f82cad1b3$var$hu(n);
}
/**
 * Toggles the network state when the client gains or loses its primary lease.
 */ async function $5c04988f82cad1b3$var$Ou(t, e) {
    const n = $5c04988f82cad1b3$var$K(t);
    e ? (n.lu.delete(2 /* IsSecondary */ ), await $5c04988f82cad1b3$var$hu(n)) : e || (n.lu.add(2 /* IsSecondary */ ), await $5c04988f82cad1b3$var$lu(n), n._u.set("Unknown" /* Unknown */ ));
}
/**
 * If not yet initialized, registers the WatchStream and its network state
 * callback with `remoteStoreImpl`. Returns the existing stream if one is
 * already available.
 *
 * PORTING NOTE: On iOS and Android, the WatchStream gets registered on startup.
 * This is not done on Web to allow it to be tree-shaken.
 */ function $5c04988f82cad1b3$var$Mu(t) {
    return t.mu || // Create stream (but note that it is not started yet).
    (t.mu = function(t, e, n) {
        const s = $5c04988f82cad1b3$var$K(t);
        return s.tu(), new $5c04988f82cad1b3$var$ru(e, s.bo, s.authCredentials, s.appCheckCredentials, s.wt, n);
    }(t.datastore, t.asyncQueue, {
        zr: $5c04988f82cad1b3$var$Iu.bind(null, t),
        Jr: $5c04988f82cad1b3$var$Tu.bind(null, t),
        Go: $5c04988f82cad1b3$var$Eu.bind(null, t)
    }), t.fu.push(async (e)=>{
        e ? (t.mu.No(), $5c04988f82cad1b3$var$gu(t) ? $5c04988f82cad1b3$var$mu(t) : t._u.set("Unknown" /* Unknown */ )) : (await t.mu.stop(), $5c04988f82cad1b3$var$pu(t));
    })), t.mu;
}
/**
 * If not yet initialized, registers the WriteStream and its network state
 * callback with `remoteStoreImpl`. Returns the existing stream if one is
 * already available.
 *
 * PORTING NOTE: On iOS and Android, the WriteStream gets registered on startup.
 * This is not done on Web to allow it to be tree-shaken.
 */ function $5c04988f82cad1b3$var$Fu(t) {
    return t.gu || // Create stream (but note that it is not started yet).
    (t.gu = function(t, e, n) {
        const s = $5c04988f82cad1b3$var$K(t);
        return s.tu(), new $5c04988f82cad1b3$var$ou(e, s.bo, s.authCredentials, s.appCheckCredentials, s.wt, n);
    }(t.datastore, t.asyncQueue, {
        zr: $5c04988f82cad1b3$var$Du.bind(null, t),
        Jr: $5c04988f82cad1b3$var$Nu.bind(null, t),
        Yo: $5c04988f82cad1b3$var$Cu.bind(null, t),
        Jo: $5c04988f82cad1b3$var$xu.bind(null, t)
    }), t.fu.push(async (e)=>{
        e ? (t.gu.No(), // This will start the write stream if necessary.
        await $5c04988f82cad1b3$var$bu(t)) : (await t.gu.stop(), t.au.length > 0 && ($5c04988f82cad1b3$var$M("RemoteStore", `Stopping write stream with ${t.au.length} pending writes`), t.au = []));
    })), t.gu;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents an operation scheduled to be run in the future on an AsyncQueue.
 *
 * It is created via DelayedOperation.createAndSchedule().
 *
 * Supports cancellation (via cancel()) and early execution (via skipDelay()).
 *
 * Note: We implement `PromiseLike` instead of `Promise`, as the `Promise` type
 * in newer versions of TypeScript defines `finally`, which is not available in
 * IE.
 */ class $5c04988f82cad1b3$var$$u {
    /**
     * Creates and returns a DelayedOperation that has been scheduled to be
     * executed on the provided asyncQueue after the provided delayMs.
     *
     * @param asyncQueue - The queue to schedule the operation on.
     * @param id - A Timer ID identifying the type of operation this is.
     * @param delayMs - The delay (ms) before the operation should be scheduled.
     * @param op - The operation to run.
     * @param removalCallback - A callback to be called synchronously once the
     *   operation is executed or canceled, notifying the AsyncQueue to remove it
     *   from its delayedOperations list.
     *   PORTING NOTE: This exists to prevent making removeDelayedOperation() and
     *   the DelayedOperation class public.
     */ static createAndSchedule(t, e, n, s, i) {
        const r = Date.now() + n, o = new $5c04988f82cad1b3$var$$u(t, e, r, s, i);
        return o.start(n), o;
    }
    /**
     * Starts the timer. This is called immediately after construction by
     * createAndSchedule().
     */ start(t) {
        this.timerHandle = setTimeout(()=>this.handleDelayElapsed(), t);
    }
    /**
     * Queues the operation to run immediately (if it hasn't already been run or
     * canceled).
     */ skipDelay() {
        return this.handleDelayElapsed();
    }
    /**
     * Cancels the operation if it hasn't already been executed or canceled. The
     * promise will be rejected.
     *
     * As long as the operation has not yet been run, calling cancel() provides a
     * guarantee that the operation will not be run.
     */ cancel(t) {
        null !== this.timerHandle && (this.clearTimeout(), this.deferred.reject(new $5c04988f82cad1b3$export$8fada0bf726bf278($5c04988f82cad1b3$var$G.CANCELLED, "Operation cancelled" + (t ? ": " + t : ""))));
    }
    handleDelayElapsed() {
        this.asyncQueue.enqueueAndForget(()=>null !== this.timerHandle ? (this.clearTimeout(), this.op().then((t)=>this.deferred.resolve(t))) : Promise.resolve());
    }
    clearTimeout() {
        null !== this.timerHandle && (this.removalCallback(this), clearTimeout(this.timerHandle), this.timerHandle = null);
    }
    constructor(t, e, n, s, i){
        this.asyncQueue = t, this.timerId = e, this.targetTimeMs = n, this.op = s, this.removalCallback = i, this.deferred = new $5c04988f82cad1b3$var$j, this.then = this.deferred.promise.then.bind(this.deferred.promise), // It's normal for the deferred promise to be canceled (due to cancellation)
        // and so we attach a dummy catch callback to avoid
        // 'UnhandledPromiseRejectionWarning' log spam.
        this.deferred.promise.catch((t)=>{});
    }
}
/**
 * Returns a FirestoreError that can be surfaced to the user if the provided
 * error is an IndexedDbTransactionError. Re-throws the error otherwise.
 */ function $5c04988f82cad1b3$var$Bu(t, e) {
    if ($5c04988f82cad1b3$var$F("AsyncQueue", `${e}: ${t}`), $5c04988f82cad1b3$var$Ct(t)) return new $5c04988f82cad1b3$export$8fada0bf726bf278($5c04988f82cad1b3$var$G.UNAVAILABLE, `${e}: ${t}`);
    throw t;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * DocumentSet is an immutable (copy-on-write) collection that holds documents
 * in order specified by the provided comparator. We always add a document key
 * comparator on top of what is provided to guarantee document equality based on
 * the key.
 */ class $5c04988f82cad1b3$var$Lu {
    /**
     * Returns an empty copy of the existing DocumentSet, using the same
     * comparator.
     */ static emptySet(t) {
        return new $5c04988f82cad1b3$var$Lu(t.comparator);
    }
    has(t) {
        return null != this.keyedMap.get(t);
    }
    get(t) {
        return this.keyedMap.get(t);
    }
    first() {
        return this.sortedSet.minKey();
    }
    last() {
        return this.sortedSet.maxKey();
    }
    isEmpty() {
        return this.sortedSet.isEmpty();
    }
    /**
     * Returns the index of the provided key in the document set, or -1 if the
     * document key is not present in the set;
     */ indexOf(t) {
        const e = this.keyedMap.get(t);
        return e ? this.sortedSet.indexOf(e) : -1;
    }
    get size() {
        return this.sortedSet.size;
    }
    /** Iterates documents in order defined by "comparator" */ forEach(t) {
        this.sortedSet.inorderTraversal((e, n)=>(t(e), !1));
    }
    /** Inserts or updates a document with the same key */ add(t) {
        // First remove the element if we have it.
        const e = this.delete(t.key);
        return e.copy(e.keyedMap.insert(t.key, t), e.sortedSet.insert(t, null));
    }
    /** Deletes a document with a given key */ delete(t) {
        const e = this.get(t);
        return e ? this.copy(this.keyedMap.remove(t), this.sortedSet.remove(e)) : this;
    }
    isEqual(t) {
        if (!(t instanceof $5c04988f82cad1b3$var$Lu)) return !1;
        if (this.size !== t.size) return !1;
        const e = this.sortedSet.getIterator(), n = t.sortedSet.getIterator();
        for(; e.hasNext();){
            const t = e.getNext().key, s = n.getNext().key;
            if (!t.isEqual(s)) return !1;
        }
        return !0;
    }
    toString() {
        const t = [];
        return this.forEach((e)=>{
            t.push(e.toString());
        }), 0 === t.length ? "DocumentSet ()" : "DocumentSet (\n  " + t.join("  \n") + "\n)";
    }
    copy(t, e) {
        const n = new $5c04988f82cad1b3$var$Lu;
        return n.comparator = this.comparator, n.keyedMap = t, n.sortedSet = e, n;
    }
    /** The default ordering is by key if the comparator is omitted */ constructor(t){
        // We are adding document key comparator to the end as it's the only
        // guaranteed unique property of a document.
        this.comparator = t ? (e, n)=>t(e, n) || $5c04988f82cad1b3$export$afc2e57c475b7810.comparator(e.key, n.key) : (t, e)=>$5c04988f82cad1b3$export$afc2e57c475b7810.comparator(t.key, e.key), this.keyedMap = $5c04988f82cad1b3$var$cs(), this.sortedSet = new $5c04988f82cad1b3$var$qt(this.comparator);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * DocumentChangeSet keeps track of a set of changes to docs in a query, merging
 * duplicate events for the same doc.
 */ class $5c04988f82cad1b3$var$Uu {
    track(t) {
        const e = t.doc.key, n = this.yu.get(e);
        n ? // Merge the new change with the existing change.
        0 /* Added */  !== t.type && 3 /* Metadata */  === n.type ? this.yu = this.yu.insert(e, t) : 3 /* Metadata */  === t.type && 1 /* Removed */  !== n.type ? this.yu = this.yu.insert(e, {
            type: n.type,
            doc: t.doc
        }) : 2 /* Modified */  === t.type && 2 /* Modified */  === n.type ? this.yu = this.yu.insert(e, {
            type: 2 /* Modified */ ,
            doc: t.doc
        }) : 2 /* Modified */  === t.type && 0 /* Added */  === n.type ? this.yu = this.yu.insert(e, {
            type: 0 /* Added */ ,
            doc: t.doc
        }) : 1 /* Removed */  === t.type && 0 /* Added */  === n.type ? this.yu = this.yu.remove(e) : 1 /* Removed */  === t.type && 2 /* Modified */  === n.type ? this.yu = this.yu.insert(e, {
            type: 1 /* Removed */ ,
            doc: n.doc
        }) : 0 /* Added */  === t.type && 1 /* Removed */  === n.type ? this.yu = this.yu.insert(e, {
            type: 2 /* Modified */ ,
            doc: t.doc
        }) : // This includes these cases, which don't make sense:
        // Added->Added
        // Removed->Removed
        // Modified->Added
        // Removed->Modified
        // Metadata->Added
        // Removed->Metadata
        $5c04988f82cad1b3$var$L() : this.yu = this.yu.insert(e, t);
    }
    pu() {
        const t = [];
        return this.yu.inorderTraversal((e, n)=>{
            t.push(n);
        }), t;
    }
    constructor(){
        this.yu = new $5c04988f82cad1b3$var$qt($5c04988f82cad1b3$export$afc2e57c475b7810.comparator);
    }
}
class $5c04988f82cad1b3$var$qu {
    /** Returns a view snapshot as if all documents in the snapshot were added. */ static fromInitialDocuments(t, e, n, s) {
        const i = [];
        return e.forEach((t)=>{
            i.push({
                type: 0 /* Added */ ,
                doc: t
            });
        }), new $5c04988f82cad1b3$var$qu(t, e, $5c04988f82cad1b3$var$Lu.emptySet(e), i, n, s, /* syncStateChanged= */ !0, /* excludesMetadataChanges= */ !1);
    }
    get hasPendingWrites() {
        return !this.mutatedKeys.isEmpty();
    }
    isEqual(t) {
        if (!(this.fromCache === t.fromCache && this.syncStateChanged === t.syncStateChanged && this.mutatedKeys.isEqual(t.mutatedKeys) && $5c04988f82cad1b3$var$dn(this.query, t.query) && this.docs.isEqual(t.docs) && this.oldDocs.isEqual(t.oldDocs))) return !1;
        const e = this.docChanges, n = t.docChanges;
        if (e.length !== n.length) return !1;
        for(let t = 0; t < e.length; t++)if (e[t].type !== n[t].type || !e[t].doc.isEqual(n[t].doc)) return !1;
        return !0;
    }
    constructor(t, e, n, s, i, r, o, u){
        this.query = t, this.docs = e, this.oldDocs = n, this.docChanges = s, this.mutatedKeys = i, this.fromCache = r, this.syncStateChanged = o, this.excludesMetadataChanges = u;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Holds the listeners and the last received ViewSnapshot for a query being
 * tracked by EventManager.
 */ class $5c04988f82cad1b3$var$Ku {
    constructor(){
        this.Iu = void 0, this.listeners = [];
    }
}
class $5c04988f82cad1b3$var$Gu {
    constructor(){
        this.queries = new $5c04988f82cad1b3$var$is((t)=>$5c04988f82cad1b3$var$_n(t), $5c04988f82cad1b3$var$dn), this.onlineState = "Unknown" /* Unknown */ , this.Tu = new Set;
    }
}
async function $5c04988f82cad1b3$var$Qu(t, e) {
    const n = $5c04988f82cad1b3$var$K(t), s = e.query;
    let i = !1, r = n.queries.get(s);
    if (r || (i = !0, r = new $5c04988f82cad1b3$var$Ku), i) try {
        r.Iu = await n.onListen(s);
    } catch (t) {
        const n = $5c04988f82cad1b3$var$Bu(t, `Initialization of query '${$5c04988f82cad1b3$var$wn(e.query)}' failed`);
        return void e.onError(n);
    }
    if (n.queries.set(s, r), r.listeners.push(e), // Run global snapshot listeners if a consistent snapshot has been emitted.
    e.Eu(n.onlineState), r.Iu) e.Au(r.Iu) && $5c04988f82cad1b3$var$Hu(n);
}
async function $5c04988f82cad1b3$var$ju(t, e) {
    const n = $5c04988f82cad1b3$var$K(t), s = e.query;
    let i = !1;
    const r = n.queries.get(s);
    if (r) {
        const t = r.listeners.indexOf(e);
        t >= 0 && (r.listeners.splice(t, 1), i = 0 === r.listeners.length);
    }
    if (i) return n.queries.delete(s), n.onUnlisten(s);
}
function $5c04988f82cad1b3$var$Wu(t, e) {
    const n = $5c04988f82cad1b3$var$K(t);
    let s = !1;
    for (const t of e){
        const e = t.query, i = n.queries.get(e);
        if (i) {
            for (const e of i.listeners)e.Au(t) && (s = !0);
            i.Iu = t;
        }
    }
    s && $5c04988f82cad1b3$var$Hu(n);
}
function $5c04988f82cad1b3$var$zu(t, e, n) {
    const s = $5c04988f82cad1b3$var$K(t), i = s.queries.get(e);
    if (i) for (const t of i.listeners)t.onError(n);
    // Remove all listeners. NOTE: We don't need to call syncEngine.unlisten()
    // after an error.
    s.queries.delete(e);
}
// Call all global snapshot listeners that have been set.
function $5c04988f82cad1b3$var$Hu(t) {
    t.Tu.forEach((t)=>{
        t.next();
    });
}
/**
 * QueryListener takes a series of internal view snapshots and determines
 * when to raise the event.
 *
 * It uses an Observer to dispatch events.
 */ class $5c04988f82cad1b3$var$Ju {
    /**
     * Applies the new ViewSnapshot to this listener, raising a user-facing event
     * if applicable (depending on what changed, whether the user has opted into
     * metadata-only changes, etc.). Returns true if a user-facing event was
     * indeed raised.
     */ Au(t) {
        if (!this.options.includeMetadataChanges) {
            // Remove the metadata only changes.
            const e = [];
            for (const n of t.docChanges)3 /* Metadata */  !== n.type && e.push(n);
            t = new $5c04988f82cad1b3$var$qu(t.query, t.docs, t.oldDocs, e, t.mutatedKeys, t.fromCache, t.syncStateChanged, /* excludesMetadataChanges= */ !0);
        }
        let e = !1;
        return this.bu ? this.vu(t) && (this.Ru.next(t), e = !0) : this.Vu(t, this.onlineState) && (this.Su(t), e = !0), this.Pu = t, e;
    }
    onError(t) {
        this.Ru.error(t);
    }
    /** Returns whether a snapshot was raised. */ Eu(t) {
        this.onlineState = t;
        let e = !1;
        return this.Pu && !this.bu && this.Vu(this.Pu, t) && (this.Su(this.Pu), e = !0), e;
    }
    Vu(t, e) {
        // Always raise the first event when we're synced
        if (!t.fromCache) return !0;
        // NOTE: We consider OnlineState.Unknown as online (it should become Offline
        // or Online if we wait long enough).
        const n = "Offline" /* Offline */  !== e;
        // Don't raise the event if we're online, aren't synced yet (checked
        // above) and are waiting for a sync.
        return (!this.options.Du || !n) && (!t.docs.isEmpty() || "Offline" /* Offline */  === e);
    // Raise data from cache if we have any documents or we are offline
    }
    vu(t) {
        // We don't need to handle includeDocumentMetadataChanges here because
        // the Metadata only changes have already been stripped out if needed.
        // At this point the only changes we will see are the ones we should
        // propagate.
        if (t.docChanges.length > 0) return !0;
        const e = this.Pu && this.Pu.hasPendingWrites !== t.hasPendingWrites;
        return !(!t.syncStateChanged && !e) && !0 === this.options.includeMetadataChanges;
    // Generally we should have hit one of the cases above, but it's possible
    // to get here if there were only metadata docChanges and they got
    // stripped out.
    }
    Su(t) {
        t = $5c04988f82cad1b3$var$qu.fromInitialDocuments(t.query, t.docs, t.mutatedKeys, t.fromCache), this.bu = !0, this.Ru.next(t);
    }
    constructor(t, e, n){
        this.query = t, this.Ru = e, /**
         * Initial snapshots (e.g. from cache) may not be propagated to the wrapped
         * observer. This flag is set to true once we've actually raised an event.
         */ this.bu = !1, this.Pu = null, this.onlineState = "Unknown" /* Unknown */ , this.options = n || {};
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A complete element in the bundle stream, together with the byte length it
 * occupies in the stream.
 */ class $5c04988f82cad1b3$var$Yu {
    Cu() {
        return "metadata" in this.payload;
    }
    constructor(t, // How many bytes this element takes to store in the bundle.
    e){
        this.payload = t, this.byteLength = e;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Helper to convert objects from bundles to model objects in the SDK.
 */ class $5c04988f82cad1b3$var$Xu {
    Wi(t) {
        return $5c04988f82cad1b3$var$Fs(this.wt, t);
    }
    /**
     * Converts a BundleDocument to a MutableDocument.
     */ zi(t) {
        return t.metadata.exists ? $5c04988f82cad1b3$var$Ks(this.wt, t.document, !1) : $5c04988f82cad1b3$var$xe.newNoDocument(this.Wi(t.metadata.name), this.Hi(t.metadata.readTime));
    }
    Hi(t) {
        return $5c04988f82cad1b3$var$Ns(t);
    }
    constructor(t){
        this.wt = t;
    }
}
/**
 * A class to process the elements from a bundle, load them into local
 * storage and provide progress update while loading.
 */ class $5c04988f82cad1b3$var$Zu {
    /**
     * Adds an element from the bundle to the loader.
     *
     * Returns a new progress if adding the element leads to a new progress,
     * otherwise returns null.
     */ Nu(t) {
        this.progress.bytesLoaded += t.byteLength;
        let e = this.progress.documentsLoaded;
        if (t.payload.namedQuery) this.queries.push(t.payload.namedQuery);
        else if (t.payload.documentMetadata) {
            this.documents.push({
                metadata: t.payload.documentMetadata
            }), t.payload.documentMetadata.exists || ++e;
            const n = $5c04988f82cad1b3$var$ht.fromString(t.payload.documentMetadata.name);
            this.collectionGroups.add(n.get(n.length - 2));
        } else t.payload.document && (this.documents[this.documents.length - 1].document = t.payload.document, ++e);
        return e !== this.progress.documentsLoaded ? (this.progress.documentsLoaded = e, Object.assign({}, this.progress)) : null;
    }
    ku(t) {
        const e = new Map, n = new $5c04988f82cad1b3$var$Xu(this.wt);
        for (const s of t)if (s.metadata.queries) {
            const t = n.Wi(s.metadata.name);
            for (const n of s.metadata.queries){
                const s = (e.get(n) || $5c04988f82cad1b3$var$ws()).add(t);
                e.set(n, s);
            }
        }
        return e;
    }
    /**
     * Update the progress to 'Success' and return the updated progress.
     */ async complete() {
        const t = await $5c04988f82cad1b3$var$Fo(this.localStore, new $5c04988f82cad1b3$var$Xu(this.wt), this.documents, this.xu.id), e = this.ku(this.documents);
        for (const t of this.queries)await $5c04988f82cad1b3$var$$o(this.localStore, t, e.get(t.name));
        return this.progress.taskState = "Success", {
            progress: this.progress,
            Ou: this.collectionGroups,
            Mu: t
        };
    }
    constructor(t, e, n){
        this.xu = t, this.localStore = e, this.wt = n, /** Batched queries to be saved into storage */ this.queries = [], /** Batched documents to be saved into storage */ this.documents = [], /** The collection groups affected by this bundle. */ this.collectionGroups = new Set, this.progress = $5c04988f82cad1b3$var$tc(t);
    }
}
/**
 * Returns a `LoadBundleTaskProgress` representing the initial progress of
 * loading a bundle.
 */ function $5c04988f82cad1b3$var$tc(t) {
    return {
        taskState: "Running",
        documentsLoaded: 0,
        bytesLoaded: 0,
        totalDocuments: t.totalDocuments,
        totalBytes: t.totalBytes
    };
}
/**
 * Returns a `LoadBundleTaskProgress` representing the progress that the loading
 * has succeeded.
 */ /**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $5c04988f82cad1b3$var$ec {
    constructor(t){
        this.key = t;
    }
}
class $5c04988f82cad1b3$var$nc {
    constructor(t){
        this.key = t;
    }
}
/**
 * View is responsible for computing the final merged truth of what docs are in
 * a query. It gets notified of local and remote changes to docs, and applies
 * the query filters and limits to determine the most correct possible results.
 */ class $5c04988f82cad1b3$var$sc {
    /**
     * The set of remote documents that the server has told us belongs to the target associated with
     * this view.
     */ get qu() {
        return this.Fu;
    }
    /**
     * Iterates over a set of doc changes, applies the query limit, and computes
     * what the new results should be, what the changes were, and whether we may
     * need to go back to the local cache for more results. Does not make any
     * changes to the view.
     * @param docChanges - The doc changes to apply to this view.
     * @param previousChanges - If this is being called with a refill, then start
     *        with this set of docs and changes instead of the current view.
     * @returns a new set of docs, changes, and refill flag.
     */ Ku(t, e) {
        const n = e ? e.Gu : new $5c04988f82cad1b3$var$Uu, s = e ? e.Uu : this.Uu;
        let i = e ? e.mutatedKeys : this.mutatedKeys, r = s, o = !1;
        // Track the last doc in a (full) limit. This is necessary, because some
        // update (a delete, or an update moving a doc past the old limit) might
        // mean there is some other document in the local cache that either should
        // come (1) between the old last limit doc and the new last document, in the
        // case of updates, or (2) after the new last document, in the case of
        // deletes. So we keep this doc at the old limit to compare the updates to.
        // Note that this should never get used in a refill (when previousChanges is
        // set), because there will only be adds -- no deletes or updates.
        const u = "F" /* First */  === this.query.limitType && s.size === this.query.limit ? s.last() : null, c = "L" /* Last */  === this.query.limitType && s.size === this.query.limit ? s.first() : null;
        // Drop documents out to meet limit/limitToLast requirement.
        if (t.inorderTraversal((t, e)=>{
            const a = s.get(t), h = $5c04988f82cad1b3$var$mn(this.query, e) ? e : null, l = !!a && this.mutatedKeys.has(a.key), f = !!h && (h.hasLocalMutations || // We only consider committed mutations for documents that were
            // mutated during the lifetime of the view.
            this.mutatedKeys.has(h.key) && h.hasCommittedMutations);
            let d = !1;
            // Calculate change
            if (a && h) a.data.isEqual(h.data) ? l !== f && (n.track({
                type: 3 /* Metadata */ ,
                doc: h
            }), d = !0) : this.Qu(a, h) || (n.track({
                type: 2 /* Modified */ ,
                doc: h
            }), d = !0, (u && this.Lu(h, u) > 0 || c && this.Lu(h, c) < 0) && // This doc moved from inside the limit to outside the limit.
            // That means there may be some other doc in the local cache
            // that should be included instead.
            (o = !0));
            else !a && h ? (n.track({
                type: 0 /* Added */ ,
                doc: h
            }), d = !0) : a && !h && (n.track({
                type: 1 /* Removed */ ,
                doc: a
            }), d = !0, (u || c) && // A doc was removed from a full limit query. We'll need to
            // requery from the local cache to see if we know about some other
            // doc that should be in the results.
            (o = !0));
            d && (h ? (r = r.add(h), i = f ? i.add(t) : i.delete(t)) : (r = r.delete(t), i = i.delete(t)));
        }), null !== this.query.limit) for(; r.size > this.query.limit;){
            const t = "F" /* First */  === this.query.limitType ? r.last() : r.first();
            r = r.delete(t.key), i = i.delete(t.key), n.track({
                type: 1 /* Removed */ ,
                doc: t
            });
        }
        return {
            Uu: r,
            Gu: n,
            Oi: o,
            mutatedKeys: i
        };
    }
    Qu(t, e) {
        // We suppress the initial change event for documents that were modified as
        // part of a write acknowledgment (e.g. when the value of a server transform
        // is applied) as Watch will send us the same document again.
        // By suppressing the event, we only raise two user visible events (one with
        // `hasPendingWrites` and the final state of the document) instead of three
        // (one with `hasPendingWrites`, the modified document with
        // `hasPendingWrites` and the final state of the document).
        return t.hasLocalMutations && e.hasCommittedMutations && !e.hasLocalMutations;
    }
    /**
     * Updates the view with the given ViewDocumentChanges and optionally updates
     * limbo docs and sync state from the provided target change.
     * @param docChanges - The set of changes to make to the view's docs.
     * @param updateLimboDocuments - Whether to update limbo documents based on
     *        this change.
     * @param targetChange - A target change to apply for computing limbo docs and
     *        sync state.
     * @returns A new ViewChange with the given docs, changes, and sync state.
     */ // PORTING NOTE: The iOS/Android clients always compute limbo document changes.
    applyChanges(t, e, n) {
        const s = this.Uu;
        this.Uu = t.Uu, this.mutatedKeys = t.mutatedKeys;
        // Sort changes based on type and query comparator
        const i = t.Gu.pu();
        i.sort((t, e)=>(function(t, e) {
                const n = (t)=>{
                    switch(t){
                        case 0 /* Added */ :
                            return 1;
                        case 2 /* Modified */ :
                        case 3 /* Metadata */ :
                            // A metadata change is converted to a modified change at the public
                            // api layer.  Since we sort by document key and then change type,
                            // metadata and modified changes must be sorted equivalently.
                            return 2;
                        case 1 /* Removed */ :
                            return 0;
                        default:
                            return $5c04988f82cad1b3$var$L();
                    }
                };
                return n(t) - n(e);
            })(t.type, e.type) || this.Lu(t.doc, e.doc)), this.ju(n);
        const r = e ? this.Wu() : [], o = 0 === this.Bu.size && this.current ? 1 /* Synced */  : 0 /* Local */ , u = o !== this.$u;
        if (this.$u = o, 0 !== i.length || u) return {
            snapshot: new $5c04988f82cad1b3$var$qu(this.query, t.Uu, s, i, t.mutatedKeys, 0 /* Local */  === o, u, /* excludesMetadataChanges= */ !1),
            zu: r
        };
        // no changes
        return {
            zu: r
        };
    }
    /**
     * Applies an OnlineState change to the view, potentially generating a
     * ViewChange if the view's syncState changes as a result.
     */ Eu(t) {
        return this.current && "Offline" /* Offline */  === t ? // If we're offline, set `current` to false and then call applyChanges()
        // to refresh our syncState and generate a ViewChange as appropriate. We
        // are guaranteed to get a new TargetChange that sets `current` back to
        // true once the client is back online.
        (this.current = !1, this.applyChanges({
            Uu: this.Uu,
            Gu: new $5c04988f82cad1b3$var$Uu,
            mutatedKeys: this.mutatedKeys,
            Oi: !1
        }, /* updateLimboDocuments= */ !1)) : {
            zu: []
        };
    }
    /**
     * Returns whether the doc for the given key should be in limbo.
     */ Hu(t) {
        // If the remote end says it's part of this query, it's not in limbo.
        return !this.Fu.has(t) && // The local store doesn't think it's a result, so it shouldn't be in limbo.
        !!this.Uu.has(t) && !this.Uu.get(t).hasLocalMutations;
    }
    /**
     * Updates syncedDocuments, current, and limbo docs based on the given change.
     * Returns the list of changes to which docs are in limbo.
     */ ju(t) {
        t && (t.addedDocuments.forEach((t)=>this.Fu = this.Fu.add(t)), t.modifiedDocuments.forEach((t)=>{}), t.removedDocuments.forEach((t)=>this.Fu = this.Fu.delete(t)), this.current = t.current);
    }
    Wu() {
        // We can only determine limbo documents when we're in-sync with the server.
        if (!this.current) return [];
        // TODO(klimt): Do this incrementally so that it's not quadratic when
        // updating many documents.
        const t = this.Bu;
        this.Bu = $5c04988f82cad1b3$var$ws(), this.Uu.forEach((t)=>{
            this.Hu(t.key) && (this.Bu = this.Bu.add(t.key));
        });
        // Diff the new limbo docs with the old limbo docs.
        const e = [];
        return t.forEach((t)=>{
            this.Bu.has(t) || e.push(new $5c04988f82cad1b3$var$nc(t));
        }), this.Bu.forEach((n)=>{
            t.has(n) || e.push(new $5c04988f82cad1b3$var$ec(n));
        }), e;
    }
    /**
     * Update the in-memory state of the current view with the state read from
     * persistence.
     *
     * We update the query view whenever a client's primary status changes:
     * - When a client transitions from primary to secondary, it can miss
     *   LocalStorage updates and its query views may temporarily not be
     *   synchronized with the state on disk.
     * - For secondary to primary transitions, the client needs to update the list
     *   of `syncedDocuments` since secondary clients update their query views
     *   based purely on synthesized RemoteEvents.
     *
     * @param queryResult.documents - The documents that match the query according
     * to the LocalStore.
     * @param queryResult.remoteKeys - The keys of the documents that match the
     * query according to the backend.
     *
     * @returns The ViewChange that resulted from this synchronization.
     */ // PORTING NOTE: Multi-tab only.
    Ju(t) {
        this.Fu = t.ji, this.Bu = $5c04988f82cad1b3$var$ws();
        const e = this.Ku(t.documents);
        return this.applyChanges(e, /*updateLimboDocuments=*/ !0);
    }
    /**
     * Returns a view snapshot as if this query was just listened to. Contains
     * a document add for every existing document and the `fromCache` and
     * `hasPendingWrites` status of the already established view.
     */ // PORTING NOTE: Multi-tab only.
    Yu() {
        return $5c04988f82cad1b3$var$qu.fromInitialDocuments(this.query, this.Uu, this.mutatedKeys, 0 /* Local */  === this.$u);
    }
    constructor(t, /** Documents included in the remote target */ e){
        this.query = t, this.Fu = e, this.$u = null, /**
         * A flag whether the view is current with the backend. A view is considered
         * current after it has seen the current flag from the backend and did not
         * lose consistency within the watch stream (e.g. because of an existence
         * filter mismatch).
         */ this.current = !1, /** Documents in the view but not in the remote target */ this.Bu = $5c04988f82cad1b3$var$ws(), /** Document Keys that have local changes */ this.mutatedKeys = $5c04988f82cad1b3$var$ws(), this.Lu = $5c04988f82cad1b3$var$yn(t), this.Uu = new $5c04988f82cad1b3$var$Lu(this.Lu);
    }
}
/**
 * QueryView contains all of the data that SyncEngine needs to keep track of for
 * a particular query.
 */ class $5c04988f82cad1b3$var$ic {
    constructor(/**
     * The query itself.
     */ t, /**
     * The target number created by the client that is used in the watch
     * stream to identify this query.
     */ e, /**
     * The view is responsible for computing the final merged truth of what
     * docs are in the query. It gets notified of local and remote changes,
     * and applies the query filters and limits to determine the most correct
     * possible results.
     */ n){
        this.query = t, this.targetId = e, this.view = n;
    }
}
/** Tracks a limbo resolution. */ class $5c04988f82cad1b3$var$rc {
    constructor(t){
        this.key = t, /**
         * Set to true once we've received a document. This is used in
         * getRemoteKeysForTarget() and ultimately used by WatchChangeAggregator to
         * decide whether it needs to manufacture a delete event for the target once
         * the target is CURRENT.
         */ this.Xu = !1;
    }
}
/**
 * An implementation of `SyncEngine` coordinating with other parts of SDK.
 *
 * The parts of SyncEngine that act as a callback to RemoteStore need to be
 * registered individually. This is done in `syncEngineWrite()` and
 * `syncEngineListen()` (as well as `applyPrimaryState()`) as these methods
 * serve as entry points to RemoteStore's functionality.
 *
 * Note: some field defined in this class might have public access level, but
 * the class is not exported so they are only accessible from this module.
 * This is useful to implement optional features (like bundles) in free
 * functions, such that they are tree-shakeable.
 */ class $5c04988f82cad1b3$var$oc {
    get isPrimaryClient() {
        return !0 === this.ac;
    }
    constructor(t, e, n, // PORTING NOTE: Manages state synchronization in multi-tab environments.
    s, i, r){
        this.localStore = t, this.remoteStore = e, this.eventManager = n, this.sharedClientState = s, this.currentUser = i, this.maxConcurrentLimboResolutions = r, this.Zu = {}, this.tc = new $5c04988f82cad1b3$var$is((t)=>$5c04988f82cad1b3$var$_n(t), $5c04988f82cad1b3$var$dn), this.ec = new Map, /**
         * The keys of documents that are in limbo for which we haven't yet started a
         * limbo resolution query. The strings in this set are the result of calling
         * `key.path.canonicalString()` where `key` is a `DocumentKey` object.
         *
         * The `Set` type was chosen because it provides efficient lookup and removal
         * of arbitrary elements and it also maintains insertion order, providing the
         * desired queue-like FIFO semantics.
         */ this.nc = new Set, /**
         * Keeps track of the target ID for each document that is in limbo with an
         * active target.
         */ this.sc = new $5c04988f82cad1b3$var$qt($5c04988f82cad1b3$export$afc2e57c475b7810.comparator), /**
         * Keeps track of the information about an active limbo resolution for each
         * active target ID that was started for the purpose of limbo resolution.
         */ this.ic = new Map, this.rc = new $5c04988f82cad1b3$var$io, /** Stores user completion handlers, indexed by User and BatchId. */ this.oc = {}, /** Stores user callbacks waiting for all pending writes to be acknowledged. */ this.uc = new Map, this.cc = $5c04988f82cad1b3$var$kr.Rn(), this.onlineState = "Unknown" /* Unknown */ , // The primary state is set to `true` or `false` immediately after Firestore
        // startup. In the interim, a client should only be considered primary if
        // `isPrimary` is true.
        this.ac = void 0;
    }
}
/**
 * Initiates the new listen, resolves promise when listen enqueued to the
 * server. All the subsequent view snapshots or errors are sent to the
 * subscribed handlers. Returns the initial snapshot.
 */ async function $5c04988f82cad1b3$var$uc(t, e) {
    const n = $5c04988f82cad1b3$var$Mc(t);
    let s, i;
    const r = n.tc.get(e);
    if (r) // PORTING NOTE: With Multi-Tab Web, it is possible that a query view
    // already exists when EventManager calls us for the first time. This
    // happens when the primary tab is already listening to this query on
    // behalf of another tab and the user of the primary also starts listening
    // to the query. EventManager will not have an assigned target ID in this
    // case and calls `listen` to obtain this ID.
    s = r.targetId, n.sharedClientState.addLocalQueryTarget(s), i = r.view.Yu();
    else {
        const t = await $5c04988f82cad1b3$var$Co(n.localStore, $5c04988f82cad1b3$var$ln(e));
        n.isPrimaryClient && $5c04988f82cad1b3$var$fu(n.remoteStore, t);
        const r = n.sharedClientState.addLocalQueryTarget(t.targetId);
        s = t.targetId, i = await $5c04988f82cad1b3$var$cc(n, e, s, "current" === r);
    }
    return i;
}
/**
 * Registers a view for a previously unknown query and computes its initial
 * snapshot.
 */ async function $5c04988f82cad1b3$var$cc(t, e, n, s) {
    // PORTING NOTE: On Web only, we inject the code that registers new Limbo
    // targets based on view changes. This allows us to only depend on Limbo
    // changes when user code includes queries.
    t.hc = (e, n, s)=>(async function(t, e, n, s) {
            let i = e.view.Ku(n);
            i.Oi && // The query has a limit and some docs were removed, so we need
            // to re-run the query against the local store to make sure we
            // didn't lose any good docs that had been past the limit.
            (i = await $5c04988f82cad1b3$var$No(t.localStore, e.query, /* usePreviousResults= */ !1).then(({ documents: t })=>e.view.Ku(t, i)));
            const r = s && s.targetChanges.get(e.targetId), o = e.view.applyChanges(i, /* updateLimboDocuments= */ t.isPrimaryClient, r);
            return $5c04988f82cad1b3$var$Tc(t, e.targetId, o.zu), o.snapshot;
        })(t, e, n, s);
    const i = await $5c04988f82cad1b3$var$No(t.localStore, e, /* usePreviousResults= */ !0), r = new $5c04988f82cad1b3$var$sc(e, i.ji), o = r.Ku(i.documents), u = $5c04988f82cad1b3$var$ps.createSynthesizedTargetChangeForCurrentChange(n, s && "Offline" /* Offline */  !== t.onlineState), c = r.applyChanges(o, /* updateLimboDocuments= */ t.isPrimaryClient, u);
    $5c04988f82cad1b3$var$Tc(t, n, c.zu);
    const a = new $5c04988f82cad1b3$var$ic(e, n, r);
    return t.tc.set(e, a), t.ec.has(n) ? t.ec.get(n).push(e) : t.ec.set(n, [
        e
    ]), c.snapshot;
}
/** Stops listening to the query. */ async function $5c04988f82cad1b3$var$ac(t, e) {
    const n = $5c04988f82cad1b3$var$K(t), s = n.tc.get(e), i = n.ec.get(s.targetId);
    if (i.length > 1) return n.ec.set(s.targetId, i.filter((t)=>!$5c04988f82cad1b3$var$dn(t, e))), void n.tc.delete(e);
    // No other queries are mapped to the target, clean up the query and the target.
    if (n.isPrimaryClient) {
        // We need to remove the local query target first to allow us to verify
        // whether any other client is still interested in this target.
        n.sharedClientState.removeLocalQueryTarget(s.targetId);
        n.sharedClientState.isActiveQueryTarget(s.targetId) || await $5c04988f82cad1b3$var$xo(n.localStore, s.targetId, /*keepPersistedTargetData=*/ !1).then(()=>{
            n.sharedClientState.clearQueryState(s.targetId), $5c04988f82cad1b3$var$du(n.remoteStore, s.targetId), $5c04988f82cad1b3$var$pc(n, s.targetId);
        }).catch($5c04988f82cad1b3$var$bt);
    } else $5c04988f82cad1b3$var$pc(n, s.targetId), await $5c04988f82cad1b3$var$xo(n.localStore, s.targetId, /*keepPersistedTargetData=*/ !0);
}
/**
 * Initiates the write of local mutation batch which involves adding the
 * writes to the mutation queue, notifying the remote store about new
 * mutations and raising events for any changes this write caused.
 *
 * The promise returned by this call is resolved when the above steps
 * have completed, *not* when the write was acked by the backend. The
 * userCallback is resolved once the write was acked/rejected by the
 * backend (or failed locally for any other reason).
 */ async function $5c04988f82cad1b3$var$hc(t, e, n) {
    const s = $5c04988f82cad1b3$var$Fc(t);
    try {
        const t = await function(t, e) {
            const n = $5c04988f82cad1b3$var$K(t), s = $5c04988f82cad1b3$export$d9bcbd5e1ff81430.now(), i = e.reduce((t, e)=>t.add(e.key), $5c04988f82cad1b3$var$ws());
            let r, o;
            return n.persistence.runTransaction("Locally write mutations", "readwrite", (t)=>{
                // Figure out which keys do not have a remote version in the cache, this
                // is needed to create the right overlay mutation: if no remote version
                // presents, we do not need to create overlays as patch mutations.
                // TODO(Overlay): Is there a better way to determine this? Using the
                //  document version does not work because local mutations set them back
                //  to 0.
                let u = $5c04988f82cad1b3$var$os(), c = $5c04988f82cad1b3$var$ws();
                return n.Ui.getEntries(t, i).next((t)=>{
                    u = t, u.forEach((t, e)=>{
                        e.isValidDocument() || (c = c.add(t));
                    });
                }).next(()=>n.localDocuments.getOverlayedDocuments(t, u)).next((i)=>{
                    r = i;
                    // For non-idempotent mutations (such as `FieldValue.increment()`),
                    // we record the base state in a separate patch mutation. This is
                    // later used to guarantee consistent values and prevents flicker
                    // even if the backend sends us an update that already includes our
                    // transform.
                    const o = [];
                    for (const t of e){
                        const e = $5c04988f82cad1b3$var$Gn(t, r.get(t.key).overlayedDocument);
                        null != e && // NOTE: The base state should only be applied if there's some
                        // existing document to override, so use a Precondition of
                        // exists=true
                        o.push(new $5c04988f82cad1b3$var$Wn(t.key, e, $5c04988f82cad1b3$var$Ce(e.value.mapValue), $5c04988f82cad1b3$var$$n.exists(!0)));
                    }
                    return n.mutationQueue.addMutationBatch(t, s, o, e);
                }).next((e)=>{
                    o = e;
                    const s = e.applyToLocalDocumentSet(r, c);
                    return n.documentOverlayCache.saveOverlays(t, e.batchId, s);
                });
            }).then(()=>({
                    batchId: o.batchId,
                    changes: $5c04988f82cad1b3$var$as(r)
                }));
        }(s.localStore, e);
        s.sharedClientState.addPendingMutation(t.batchId), function(t, e, n) {
            let s = t.oc[t.currentUser.toKey()];
            s || (s = new $5c04988f82cad1b3$var$qt($5c04988f82cad1b3$var$it));
            s = s.insert(e, n), t.oc[t.currentUser.toKey()] = s;
        }(s, t.batchId, n), await $5c04988f82cad1b3$var$Rc(s, t.changes), await $5c04988f82cad1b3$var$bu(s.remoteStore);
    } catch (t) {
        // If we can't persist the mutation, we reject the user callback and
        // don't send the mutation. The user can then retry the write.
        const e = $5c04988f82cad1b3$var$Bu(t, "Failed to persist write");
        n.reject(e);
    }
}
/**
 * Applies one remote event to the sync engine, notifying any views of the
 * changes, and releasing any pending mutation batches that would become
 * visible because of the snapshot version the remote event contains.
 */ async function $5c04988f82cad1b3$var$lc(t, e) {
    const n = $5c04988f82cad1b3$var$K(t);
    try {
        const t = await $5c04988f82cad1b3$var$Vo(n.localStore, e);
        // Update `receivedDocument` as appropriate for any limbo targets.
        e.targetChanges.forEach((t, e)=>{
            const s = n.ic.get(e);
            s && // Since this is a limbo resolution lookup, it's for a single document
            // and it could be added, modified, or removed, but not a combination.
            ($5c04988f82cad1b3$var$U(t.addedDocuments.size + t.modifiedDocuments.size + t.removedDocuments.size <= 1), t.addedDocuments.size > 0 ? s.Xu = !0 : t.modifiedDocuments.size > 0 ? $5c04988f82cad1b3$var$U(s.Xu) : t.removedDocuments.size > 0 && ($5c04988f82cad1b3$var$U(s.Xu), s.Xu = !1));
        }), await $5c04988f82cad1b3$var$Rc(n, t, e);
    } catch (t) {
        await $5c04988f82cad1b3$var$bt(t);
    }
}
/**
 * Applies an OnlineState change to the sync engine and notifies any views of
 * the change.
 */ function $5c04988f82cad1b3$var$fc(t, e, n) {
    const s = $5c04988f82cad1b3$var$K(t);
    // If we are the secondary client, we explicitly ignore the remote store's
    // online state (the local client may go offline, even though the primary
    // tab remains online) and only apply the primary tab's online state from
    // SharedClientState.
    if (s.isPrimaryClient && 0 /* RemoteStore */  === n || !s.isPrimaryClient && 1 /* SharedClientState */  === n) {
        const t = [];
        s.tc.forEach((n, s)=>{
            const i = s.view.Eu(e);
            i.snapshot && t.push(i.snapshot);
        }), function(t, e) {
            const n = $5c04988f82cad1b3$var$K(t);
            n.onlineState = e;
            let s = !1;
            n.queries.forEach((t, n)=>{
                for (const t of n.listeners)// Run global snapshot listeners if a consistent snapshot has been emitted.
                t.Eu(e) && (s = !0);
            }), s && $5c04988f82cad1b3$var$Hu(n);
        }(s.eventManager, e), t.length && s.Zu.Go(t), s.onlineState = e, s.isPrimaryClient && s.sharedClientState.setOnlineState(e);
    }
}
/**
 * Rejects the listen for the given targetID. This can be triggered by the
 * backend for any active target.
 *
 * @param syncEngine - The sync engine implementation.
 * @param targetId - The targetID corresponds to one previously initiated by the
 * user as part of TargetData passed to listen() on RemoteStore.
 * @param err - A description of the condition that has forced the rejection.
 * Nearly always this will be an indication that the user is no longer
 * authorized to see the data matching the target.
 */ async function $5c04988f82cad1b3$var$dc(t, e, n) {
    const s = $5c04988f82cad1b3$var$K(t);
    // PORTING NOTE: Multi-tab only.
    s.sharedClientState.updateQueryState(e, "rejected", n);
    const i = s.ic.get(e), r = i && i.key;
    if (r) {
        // TODO(klimt): We really only should do the following on permission
        // denied errors, but we don't have the cause code here.
        // It's a limbo doc. Create a synthetic event saying it was deleted.
        // This is kind of a hack. Ideally, we would have a method in the local
        // store to purge a document. However, it would be tricky to keep all of
        // the local store's invariants with another method.
        let t = new $5c04988f82cad1b3$var$qt($5c04988f82cad1b3$export$afc2e57c475b7810.comparator);
        // TODO(b/217189216): This limbo document should ideally have a read time,
        // so that it is picked up by any read-time based scans. The backend,
        // however, does not send a read time for target removals.
        t = t.insert(r, $5c04988f82cad1b3$var$xe.newNoDocument(r, $5c04988f82cad1b3$var$ct.min()));
        const n = $5c04988f82cad1b3$var$ws().add(r), i = new $5c04988f82cad1b3$var$ys($5c04988f82cad1b3$var$ct.min(), /* targetChanges= */ new Map, /* targetMismatches= */ new $5c04988f82cad1b3$var$Qt($5c04988f82cad1b3$var$it), t, n);
        await $5c04988f82cad1b3$var$lc(s, i), // Since this query failed, we won't want to manually unlisten to it.
        // We only remove it from bookkeeping after we successfully applied the
        // RemoteEvent. If `applyRemoteEvent()` throws, we want to re-listen to
        // this query when the RemoteStore restarts the Watch stream, which should
        // re-trigger the target failure.
        s.sc = s.sc.remove(r), s.ic.delete(e), $5c04988f82cad1b3$var$Ac(s);
    } else await $5c04988f82cad1b3$var$xo(s.localStore, e, /* keepPersistedTargetData */ !1).then(()=>$5c04988f82cad1b3$var$pc(s, e, n)).catch($5c04988f82cad1b3$var$bt);
}
async function $5c04988f82cad1b3$var$_c(t, e) {
    const n = $5c04988f82cad1b3$var$K(t), s = e.batch.batchId;
    try {
        const t = await $5c04988f82cad1b3$var$Po(n.localStore, e);
        // The local store may or may not be able to apply the write result and
        // raise events immediately (depending on whether the watcher is caught
        // up), so we raise user callbacks first so that they consistently happen
        // before listen events.
        $5c04988f82cad1b3$var$yc(n, s, /*error=*/ null), $5c04988f82cad1b3$var$gc(n, s), n.sharedClientState.updateMutationState(s, "acknowledged"), await $5c04988f82cad1b3$var$Rc(n, t);
    } catch (t) {
        await $5c04988f82cad1b3$var$bt(t);
    }
}
async function $5c04988f82cad1b3$var$wc(t, e, n) {
    const s = $5c04988f82cad1b3$var$K(t);
    try {
        const t = await function(t, e) {
            const n = $5c04988f82cad1b3$var$K(t);
            return n.persistence.runTransaction("Reject batch", "readwrite-primary", (t)=>{
                let s;
                return n.mutationQueue.lookupMutationBatch(t, e).next((e)=>($5c04988f82cad1b3$var$U(null !== e), s = e.keys(), n.mutationQueue.removeMutationBatch(t, e))).next(()=>n.mutationQueue.performConsistencyCheck(t)).next(()=>n.documentOverlayCache.removeOverlaysForBatchId(t, s, e)).next(()=>n.localDocuments.recalculateAndSaveOverlaysForDocumentKeys(t, s)).next(()=>n.localDocuments.getDocuments(t, s));
            });
        }(s.localStore, e);
        // The local store may or may not be able to apply the write result and
        // raise events immediately (depending on whether the watcher is caught up),
        // so we raise user callbacks first so that they consistently happen before
        // listen events.
        $5c04988f82cad1b3$var$yc(s, e, n), $5c04988f82cad1b3$var$gc(s, e), s.sharedClientState.updateMutationState(e, "rejected", n), await $5c04988f82cad1b3$var$Rc(s, t);
    } catch (n) {
        await $5c04988f82cad1b3$var$bt(n);
    }
}
/**
 * Registers a user callback that resolves when all pending mutations at the moment of calling
 * are acknowledged .
 */ async function $5c04988f82cad1b3$var$mc(t, e) {
    const n = $5c04988f82cad1b3$var$K(t);
    $5c04988f82cad1b3$var$yu(n.remoteStore) || $5c04988f82cad1b3$var$M("SyncEngine", "The network is disabled. The task returned by 'awaitPendingWrites()' will not complete until the network is enabled.");
    try {
        const t = await function(t) {
            const e = $5c04988f82cad1b3$var$K(t);
            return e.persistence.runTransaction("Get highest unacknowledged batch id", "readonly", (t)=>e.mutationQueue.getHighestUnacknowledgedBatchId(t));
        }(n.localStore);
        if (-1 === t) // Trigger the callback right away if there is no pending writes at the moment.
        return void e.resolve();
        const s = n.uc.get(t) || [];
        s.push(e), n.uc.set(t, s);
    } catch (t) {
        const n = $5c04988f82cad1b3$var$Bu(t, "Initialization of waitForPendingWrites() operation failed");
        e.reject(n);
    }
}
/**
 * Triggers the callbacks that are waiting for this batch id to get acknowledged by server,
 * if there are any.
 */ function $5c04988f82cad1b3$var$gc(t, e) {
    (t.uc.get(e) || []).forEach((t)=>{
        t.resolve();
    }), t.uc.delete(e);
}
/** Reject all outstanding callbacks waiting for pending writes to complete. */ function $5c04988f82cad1b3$var$yc(t, e, n) {
    const s = $5c04988f82cad1b3$var$K(t);
    let i = s.oc[s.currentUser.toKey()];
    // NOTE: Mutations restored from persistence won't have callbacks, so it's
    // okay for there to be no callback for this ID.
    if (i) {
        const t = i.get(e);
        t && (n ? t.reject(n) : t.resolve(), i = i.remove(e)), s.oc[s.currentUser.toKey()] = i;
    }
}
function $5c04988f82cad1b3$var$pc(t, e, n = null) {
    t.sharedClientState.removeLocalQueryTarget(e);
    for (const s of t.ec.get(e))t.tc.delete(s), n && t.Zu.lc(s, n);
    if (t.ec.delete(e), t.isPrimaryClient) t.rc.us(e).forEach((e)=>{
        t.rc.containsKey(e) || // We removed the last reference for this key
        $5c04988f82cad1b3$var$Ic(t, e);
    });
}
function $5c04988f82cad1b3$var$Ic(t, e) {
    t.nc.delete(e.path.canonicalString());
    // It's possible that the target already got removed because the query failed. In that case,
    // the key won't exist in `limboTargetsByKey`. Only do the cleanup if we still have the target.
    const n = t.sc.get(e);
    null !== n && ($5c04988f82cad1b3$var$du(t.remoteStore, n), t.sc = t.sc.remove(e), t.ic.delete(n), $5c04988f82cad1b3$var$Ac(t));
}
function $5c04988f82cad1b3$var$Tc(t, e, n) {
    for (const s of n)if (s instanceof $5c04988f82cad1b3$var$ec) t.rc.addReference(s.key, e), $5c04988f82cad1b3$var$Ec(t, s);
    else if (s instanceof $5c04988f82cad1b3$var$nc) {
        $5c04988f82cad1b3$var$M("SyncEngine", "Document no longer in limbo: " + s.key), t.rc.removeReference(s.key, e);
        t.rc.containsKey(s.key) || // We removed the last reference for this key
        $5c04988f82cad1b3$var$Ic(t, s.key);
    } else $5c04988f82cad1b3$var$L();
}
function $5c04988f82cad1b3$var$Ec(t, e) {
    const n = e.key, s = n.path.canonicalString();
    t.sc.get(n) || t.nc.has(s) || ($5c04988f82cad1b3$var$M("SyncEngine", "New document in limbo: " + n), t.nc.add(s), $5c04988f82cad1b3$var$Ac(t));
}
/**
 * Starts listens for documents in limbo that are enqueued for resolution,
 * subject to a maximum number of concurrent resolutions.
 *
 * Without bounding the number of concurrent resolutions, the server can fail
 * with "resource exhausted" errors which can lead to pathological client
 * behavior as seen in https://github.com/firebase/firebase-js-sdk/issues/2683.
 */ function $5c04988f82cad1b3$var$Ac(t) {
    for(; t.nc.size > 0 && t.sc.size < t.maxConcurrentLimboResolutions;){
        const e = t.nc.values().next().value;
        t.nc.delete(e);
        const n = new $5c04988f82cad1b3$export$afc2e57c475b7810($5c04988f82cad1b3$var$ht.fromString(e)), s = t.cc.next();
        t.ic.set(s, new $5c04988f82cad1b3$var$rc(n)), t.sc = t.sc.insert(n, s), $5c04988f82cad1b3$var$fu(t.remoteStore, new $5c04988f82cad1b3$var$Li($5c04988f82cad1b3$var$ln($5c04988f82cad1b3$var$rn(n.path)), s, 2 /* LimboResolution */ , $5c04988f82cad1b3$var$$t.ot));
    }
}
async function $5c04988f82cad1b3$var$Rc(t, e, n) {
    const s = $5c04988f82cad1b3$var$K(t), i = [], r = [], o = [];
    s.tc.isEmpty() || (s.tc.forEach((t, u)=>{
        o.push(s.hc(u, e, n).then((t)=>{
            if (t) {
                s.isPrimaryClient && s.sharedClientState.updateQueryState(u.targetId, t.fromCache ? "not-current" : "current"), i.push(t);
                const e = $5c04988f82cad1b3$var$To.Vi(u.targetId, t);
                r.push(e);
            }
        }));
    }), await Promise.all(o), s.Zu.Go(i), await async function(t, e) {
        const n = $5c04988f82cad1b3$var$K(t);
        try {
            await n.persistence.runTransaction("notifyLocalViewChanges", "readwrite", (t)=>$5c04988f82cad1b3$var$Pt.forEach(e, (e)=>$5c04988f82cad1b3$var$Pt.forEach(e.Pi, (s)=>n.persistence.referenceDelegate.addReference(t, e.targetId, s)).next(()=>$5c04988f82cad1b3$var$Pt.forEach(e.vi, (s)=>n.persistence.referenceDelegate.removeReference(t, e.targetId, s)))));
        } catch (t) {
            if (!$5c04988f82cad1b3$var$Ct(t)) throw t;
            // If `notifyLocalViewChanges` fails, we did not advance the sequence
            // number for the documents that were included in this transaction.
            // This might trigger them to be deleted earlier than they otherwise
            // would have, but it should not invalidate the integrity of the data.
            $5c04988f82cad1b3$var$M("LocalStore", "Failed to update sequence numbers: " + t);
        }
        for (const t of e){
            const e = t.targetId;
            if (!t.fromCache) {
                const t = n.$i.get(e), s = t.snapshotVersion, i = t.withLastLimboFreeSnapshotVersion(s);
                // Advance the last limbo free snapshot version
                n.$i = n.$i.insert(e, i);
            }
        }
    }(s.localStore, r));
}
async function $5c04988f82cad1b3$var$bc(t, e) {
    const n = $5c04988f82cad1b3$var$K(t);
    if (!n.currentUser.isEqual(e)) {
        $5c04988f82cad1b3$var$M("SyncEngine", "User change. New user:", e.toKey());
        const t = await $5c04988f82cad1b3$var$bo(n.localStore, e);
        n.currentUser = e, // Fails tasks waiting for pending writes requested by previous user.
        function(t, e) {
            t.uc.forEach((t)=>{
                t.forEach((t)=>{
                    t.reject(new $5c04988f82cad1b3$export$8fada0bf726bf278($5c04988f82cad1b3$var$G.CANCELLED, e));
                });
            }), t.uc.clear();
        }(n, "'waitForPendingWrites' promise is rejected due to a user change."), // TODO(b/114226417): Consider calling this only in the primary tab.
        n.sharedClientState.handleUserChange(e, t.removedBatchIds, t.addedBatchIds), await $5c04988f82cad1b3$var$Rc(n, t.Ki);
    }
}
function $5c04988f82cad1b3$var$Pc(t, e) {
    const n = $5c04988f82cad1b3$var$K(t), s = n.ic.get(e);
    if (s && s.Xu) return $5c04988f82cad1b3$var$ws().add(s.key);
    {
        let t = $5c04988f82cad1b3$var$ws();
        const s = n.ec.get(e);
        if (!s) return t;
        for (const e of s){
            const s = n.tc.get(e);
            t = t.unionWith(s.view.qu);
        }
        return t;
    }
}
/**
 * Reconcile the list of synced documents in an existing view with those
 * from persistence.
 */ async function $5c04988f82cad1b3$var$vc(t, e) {
    const n = $5c04988f82cad1b3$var$K(t), s = await $5c04988f82cad1b3$var$No(n.localStore, e.query, /* usePreviousResults= */ !0), i = e.view.Ju(s);
    return n.isPrimaryClient && $5c04988f82cad1b3$var$Tc(n, e.targetId, i.zu), i;
}
/**
 * Retrieves newly changed documents from remote document cache and raises
 * snapshots if needed.
 */ // PORTING NOTE: Multi-Tab only.
async function $5c04988f82cad1b3$var$Vc(t, e) {
    const n = $5c04988f82cad1b3$var$K(t);
    return $5c04988f82cad1b3$var$Oo(n.localStore, e).then((t)=>$5c04988f82cad1b3$var$Rc(n, t));
}
/** Applies a mutation state to an existing batch.  */ // PORTING NOTE: Multi-Tab only.
async function $5c04988f82cad1b3$var$Sc(t, e, n, s) {
    const i = $5c04988f82cad1b3$var$K(t), r = await function(t, e) {
        const n = $5c04988f82cad1b3$var$K(t), s = $5c04988f82cad1b3$var$K(n.mutationQueue);
        return n.persistence.runTransaction("Lookup mutation documents", "readonly", (t)=>s.yn(t, e).next((e)=>e ? n.localDocuments.getDocuments(t, e) : $5c04988f82cad1b3$var$Pt.resolve(null)));
    }(i.localStore, e);
    null !== r ? ("pending" === n ? // If we are the primary client, we need to send this write to the
    // backend. Secondary clients will ignore these writes since their remote
    // connection is disabled.
    await $5c04988f82cad1b3$var$bu(i.remoteStore) : "acknowledged" === n || "rejected" === n ? // NOTE: Both these methods are no-ops for batches that originated from
    // other clients.
    ($5c04988f82cad1b3$var$yc(i, e, s || null), $5c04988f82cad1b3$var$gc(i, e), function(t, e) {
        $5c04988f82cad1b3$var$K($5c04988f82cad1b3$var$K(t).mutationQueue).In(e);
    }(i.localStore, e)) : $5c04988f82cad1b3$var$L(), await $5c04988f82cad1b3$var$Rc(i, r)) : // A throttled tab may not have seen the mutation before it was completed
    // and removed from the mutation queue, in which case we won't have cached
    // the affected documents. In this case we can safely ignore the update
    // since that means we didn't apply the mutation locally at all (if we
    // had, we would have cached the affected documents), and so we will just
    // see any resulting document changes via normal remote document updates
    // as applicable.
    $5c04988f82cad1b3$var$M("SyncEngine", "Cannot apply mutation batch with id: " + e);
}
/** Applies a query target change from a different tab. */ // PORTING NOTE: Multi-Tab only.
async function $5c04988f82cad1b3$var$Dc(t, e) {
    const n = $5c04988f82cad1b3$var$K(t);
    if ($5c04988f82cad1b3$var$Mc(n), $5c04988f82cad1b3$var$Fc(n), !0 === e && !0 !== n.ac) {
        // Secondary tabs only maintain Views for their local listeners and the
        // Views internal state may not be 100% populated (in particular
        // secondary tabs don't track syncedDocuments, the set of documents the
        // server considers to be in the target). So when a secondary becomes
        // primary, we need to need to make sure that all views for all targets
        // match the state on disk.
        const t = n.sharedClientState.getAllActiveQueryTargets(), e = await $5c04988f82cad1b3$var$Cc(n, t.toArray());
        n.ac = !0, await $5c04988f82cad1b3$var$Ou(n.remoteStore, !0);
        for (const t of e)$5c04988f82cad1b3$var$fu(n.remoteStore, t);
    } else if (!1 === e && !1 !== n.ac) {
        const t = [];
        let e = Promise.resolve();
        n.ec.forEach((s, i)=>{
            n.sharedClientState.isLocalQueryTarget(i) ? t.push(i) : e = e.then(()=>($5c04988f82cad1b3$var$pc(n, i), $5c04988f82cad1b3$var$xo(n.localStore, i, /*keepPersistedTargetData=*/ !0))), $5c04988f82cad1b3$var$du(n.remoteStore, i);
        }), await e, await $5c04988f82cad1b3$var$Cc(n, t), // PORTING NOTE: Multi-Tab only.
        function(t) {
            const e = $5c04988f82cad1b3$var$K(t);
            e.ic.forEach((t, n)=>{
                $5c04988f82cad1b3$var$du(e.remoteStore, n);
            }), e.rc.cs(), e.ic = new Map, e.sc = new $5c04988f82cad1b3$var$qt($5c04988f82cad1b3$export$afc2e57c475b7810.comparator);
        }(n), n.ac = !1, await $5c04988f82cad1b3$var$Ou(n.remoteStore, !1);
    }
}
async function $5c04988f82cad1b3$var$Cc(t, e, n) {
    const s = $5c04988f82cad1b3$var$K(t), i = [], r = [];
    for (const t of e){
        let e;
        const n = s.ec.get(t);
        if (n && 0 !== n.length) {
            // For queries that have a local View, we fetch their current state
            // from LocalStore (as the resume token and the snapshot version
            // might have changed) and reconcile their views with the persisted
            // state (the list of syncedDocuments may have gotten out of sync).
            e = await $5c04988f82cad1b3$var$Co(s.localStore, $5c04988f82cad1b3$var$ln(n[0]));
            for (const t of n){
                const e = s.tc.get(t), n = await $5c04988f82cad1b3$var$vc(s, e);
                n.snapshot && r.push(n.snapshot);
            }
        } else {
            // For queries that never executed on this client, we need to
            // allocate the target in LocalStore and initialize a new View.
            const n = await $5c04988f82cad1b3$var$ko(s.localStore, t);
            e = await $5c04988f82cad1b3$var$Co(s.localStore, n), await $5c04988f82cad1b3$var$cc(s, $5c04988f82cad1b3$var$xc(n), t, /*current=*/ !1);
        }
        i.push(e);
    }
    return s.Zu.Go(r), i;
}
/**
 * Creates a `Query` object from the specified `Target`. There is no way to
 * obtain the original `Query`, so we synthesize a `Query` from the `Target`
 * object.
 *
 * The synthesized result might be different from the original `Query`, but
 * since the synthesized `Query` should return the same results as the
 * original one (only the presentation of results might differ), the potential
 * difference will not cause issues.
 */ // PORTING NOTE: Multi-Tab only.
function $5c04988f82cad1b3$var$xc(t) {
    return $5c04988f82cad1b3$var$sn(t.path, t.collectionGroup, t.orderBy, t.filters, t.limit, "F" /* First */ , t.startAt, t.endAt);
}
/** Returns the IDs of the clients that are currently active. */ // PORTING NOTE: Multi-Tab only.
function $5c04988f82cad1b3$var$Nc(t) {
    const e = $5c04988f82cad1b3$var$K(t);
    return $5c04988f82cad1b3$var$K($5c04988f82cad1b3$var$K(e.localStore).persistence).Ri();
}
/** Applies a query target change from a different tab. */ // PORTING NOTE: Multi-Tab only.
async function $5c04988f82cad1b3$var$kc(t, e, n, s) {
    const i = $5c04988f82cad1b3$var$K(t);
    if (i.ac) // If we receive a target state notification via WebStorage, we are
    // either already secondary or another tab has taken the primary lease.
    return void $5c04988f82cad1b3$var$M("SyncEngine", "Ignoring unexpected query state notification.");
    const r = i.ec.get(e);
    if (r && r.length > 0) switch(n){
        case "current":
        case "not-current":
            {
                const t = await $5c04988f82cad1b3$var$Oo(i.localStore, $5c04988f82cad1b3$var$gn(r[0])), s = $5c04988f82cad1b3$var$ys.createSynthesizedRemoteEventForCurrentChange(e, "current" === n);
                await $5c04988f82cad1b3$var$Rc(i, t, s);
                break;
            }
        case "rejected":
            await $5c04988f82cad1b3$var$xo(i.localStore, e, /* keepPersistedTargetData */ !0), $5c04988f82cad1b3$var$pc(i, e, s);
            break;
        default:
            $5c04988f82cad1b3$var$L();
    }
}
/** Adds or removes Watch targets for queries from different tabs. */ async function $5c04988f82cad1b3$var$Oc(t, e, n) {
    const s = $5c04988f82cad1b3$var$Mc(t);
    if (s.ac) {
        for (const t of e){
            if (s.ec.has(t)) {
                // A target might have been added in a previous attempt
                $5c04988f82cad1b3$var$M("SyncEngine", "Adding an already active target " + t);
                continue;
            }
            const e = await $5c04988f82cad1b3$var$ko(s.localStore, t), n = await $5c04988f82cad1b3$var$Co(s.localStore, e);
            await $5c04988f82cad1b3$var$cc(s, $5c04988f82cad1b3$var$xc(e), n.targetId, /*current=*/ !1), $5c04988f82cad1b3$var$fu(s.remoteStore, n);
        }
        for (const t of n)// Check that the target is still active since the target might have been
        // removed if it has been rejected by the backend.
        s.ec.has(t) && // Release queries that are still active.
        await $5c04988f82cad1b3$var$xo(s.localStore, t, /* keepPersistedTargetData */ !1).then(()=>{
            $5c04988f82cad1b3$var$du(s.remoteStore, t), $5c04988f82cad1b3$var$pc(s, t);
        }).catch($5c04988f82cad1b3$var$bt);
    }
}
function $5c04988f82cad1b3$var$Mc(t) {
    const e = $5c04988f82cad1b3$var$K(t);
    return e.remoteStore.remoteSyncer.applyRemoteEvent = $5c04988f82cad1b3$var$lc.bind(null, e), e.remoteStore.remoteSyncer.getRemoteKeysForTarget = $5c04988f82cad1b3$var$Pc.bind(null, e), e.remoteStore.remoteSyncer.rejectListen = $5c04988f82cad1b3$var$dc.bind(null, e), e.Zu.Go = $5c04988f82cad1b3$var$Wu.bind(null, e.eventManager), e.Zu.lc = $5c04988f82cad1b3$var$zu.bind(null, e.eventManager), e;
}
function $5c04988f82cad1b3$var$Fc(t) {
    const e = $5c04988f82cad1b3$var$K(t);
    return e.remoteStore.remoteSyncer.applySuccessfulWrite = $5c04988f82cad1b3$var$_c.bind(null, e), e.remoteStore.remoteSyncer.rejectFailedWrite = $5c04988f82cad1b3$var$wc.bind(null, e), e;
}
/**
 * Loads a Firestore bundle into the SDK. The returned promise resolves when
 * the bundle finished loading.
 *
 * @param syncEngine - SyncEngine to use.
 * @param bundleReader - Bundle to load into the SDK.
 * @param task - LoadBundleTask used to update the loading progress to public API.
 */ function $5c04988f82cad1b3$var$$c(t, e, n) {
    const s = $5c04988f82cad1b3$var$K(t);
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    /** Loads a bundle and returns the list of affected collection groups. */ (async function(t, e, n) {
        try {
            const s = await e.getMetadata();
            if (await function(t, e) {
                const n = $5c04988f82cad1b3$var$K(t), s = $5c04988f82cad1b3$var$Ns(e.createTime);
                return n.persistence.runTransaction("hasNewerBundle", "readonly", (t)=>n.Ds.getBundleMetadata(t, e.id)).then((t)=>!!t && t.createTime.compareTo(s) >= 0);
            }(t.localStore, s)) return await e.close(), n._completeWith(function(t) {
                return {
                    taskState: "Success",
                    documentsLoaded: t.totalDocuments,
                    bytesLoaded: t.totalBytes,
                    totalDocuments: t.totalDocuments,
                    totalBytes: t.totalBytes
                };
            }(s)), Promise.resolve(new Set);
            n._updateProgress($5c04988f82cad1b3$var$tc(s));
            const i = new $5c04988f82cad1b3$var$Zu(s, t.localStore, e.wt);
            let r = await e.fc();
            for(; r;){
                const t = await i.Nu(r);
                t && n._updateProgress(t), r = await e.fc();
            }
            const o = await i.complete();
            return await $5c04988f82cad1b3$var$Rc(t, o.Mu, /* remoteEvent */ void 0), // Save metadata, so loading the same bundle will skip.
            await function(t, e) {
                const n = $5c04988f82cad1b3$var$K(t);
                return n.persistence.runTransaction("Save bundle", "readwrite", (t)=>n.Ds.saveBundleMetadata(t, e));
            }(t.localStore, s), n._completeWith(o.progress), Promise.resolve(o.Ou);
        } catch (t) {
            return $5c04988f82cad1b3$export$86cd73f49cc6e0bb("SyncEngine", `Loading bundle failed with ${t}`), n._failWith(t), Promise.resolve(new Set);
        }
    })(s, e, n).then((t)=>{
        s.sharedClientState.notifyBundleLoaded(t);
    });
}
class $5c04988f82cad1b3$var$Bc {
    async initialize(t) {
        this.wt = $5c04988f82cad1b3$var$nu(t.databaseInfo.databaseId), this.sharedClientState = this.dc(t), this.persistence = this._c(t), await this.persistence.start(), this.localStore = this.wc(t), this.gcScheduler = this.mc(t, this.localStore), this.indexBackfillerScheduler = this.gc(t, this.localStore);
    }
    mc(t, e) {
        return null;
    }
    gc(t, e) {
        return null;
    }
    wc(t) {
        return $5c04988f82cad1b3$var$Ro(this.persistence, new $5c04988f82cad1b3$var$Eo, t.initialUser, this.wt);
    }
    _c(t) {
        return new $5c04988f82cad1b3$var$ho($5c04988f82cad1b3$var$fo.Ms, this.wt);
    }
    dc(t) {
        return new $5c04988f82cad1b3$var$zo;
    }
    async terminate() {
        this.gcScheduler && this.gcScheduler.stop(), await this.sharedClientState.shutdown(), await this.persistence.shutdown();
    }
    constructor(){
        this.synchronizeTabs = !1;
    }
}
/**
 * Provides all components needed for Firestore with IndexedDB persistence.
 */ class $5c04988f82cad1b3$var$Lc extends $5c04988f82cad1b3$var$Bc {
    async initialize(t) {
        await super.initialize(t), await this.yc.initialize(this, t), // Enqueue writes from a previous session
        await $5c04988f82cad1b3$var$Fc(this.yc.syncEngine), await $5c04988f82cad1b3$var$bu(this.yc.remoteStore), // NOTE: This will immediately call the listener, so we make sure to
        // set it after localStore / remoteStore are started.
        await this.persistence.ci(()=>(this.gcScheduler && !this.gcScheduler.started && this.gcScheduler.start(), this.indexBackfillerScheduler && !this.indexBackfillerScheduler.started && this.indexBackfillerScheduler.start(), Promise.resolve()));
    }
    wc(t) {
        return $5c04988f82cad1b3$var$Ro(this.persistence, new $5c04988f82cad1b3$var$Eo, t.initialUser, this.wt);
    }
    mc(t, e) {
        const n = this.persistence.referenceDelegate.garbageCollector;
        return new $5c04988f82cad1b3$var$Ur(n, t.asyncQueue, e);
    }
    gc(t, e) {
        const n = new $5c04988f82cad1b3$var$Ft(e, this.persistence);
        return new $5c04988f82cad1b3$var$Mt(t.asyncQueue, n);
    }
    _c(t) {
        const e = $5c04988f82cad1b3$var$Io(t.databaseInfo.databaseId, t.databaseInfo.persistenceKey), n = void 0 !== this.cacheSizeBytes ? $5c04988f82cad1b3$var$Pr.withCacheSize(this.cacheSizeBytes) : $5c04988f82cad1b3$var$Pr.DEFAULT;
        return new $5c04988f82cad1b3$var$go(this.synchronizeTabs, e, t.clientId, n, t.asyncQueue, $5c04988f82cad1b3$var$tu(), $5c04988f82cad1b3$var$eu(), this.wt, this.sharedClientState, !!this.forceOwnership);
    }
    dc(t) {
        return new $5c04988f82cad1b3$var$zo;
    }
    constructor(t, e, n){
        super(), this.yc = t, this.cacheSizeBytes = e, this.forceOwnership = n, this.synchronizeTabs = !1;
    }
}
/**
 * Provides all components needed for Firestore with multi-tab IndexedDB
 * persistence.
 *
 * In the legacy client, this provider is used to provide both multi-tab and
 * non-multi-tab persistence since we cannot tell at build time whether
 * `synchronizeTabs` will be enabled.
 */ class $5c04988f82cad1b3$var$Uc extends $5c04988f82cad1b3$var$Lc {
    async initialize(t) {
        await super.initialize(t);
        const e = this.yc.syncEngine;
        this.sharedClientState instanceof $5c04988f82cad1b3$var$Wo && (this.sharedClientState.syncEngine = {
            kr: $5c04988f82cad1b3$var$Sc.bind(null, e),
            Or: $5c04988f82cad1b3$var$kc.bind(null, e),
            Mr: $5c04988f82cad1b3$var$Oc.bind(null, e),
            Ri: $5c04988f82cad1b3$var$Nc.bind(null, e),
            Nr: $5c04988f82cad1b3$var$Vc.bind(null, e)
        }, await this.sharedClientState.start()), // NOTE: This will immediately call the listener, so we make sure to
        // set it after localStore / remoteStore are started.
        await this.persistence.ci(async (t)=>{
            await $5c04988f82cad1b3$var$Dc(this.yc.syncEngine, t), this.gcScheduler && (t && !this.gcScheduler.started ? this.gcScheduler.start() : t || this.gcScheduler.stop()), this.indexBackfillerScheduler && (t && !this.indexBackfillerScheduler.started ? this.indexBackfillerScheduler.start() : t || this.indexBackfillerScheduler.stop());
        });
    }
    dc(t) {
        const e = $5c04988f82cad1b3$var$tu();
        if (!$5c04988f82cad1b3$var$Wo.V(e)) throw new $5c04988f82cad1b3$export$8fada0bf726bf278($5c04988f82cad1b3$var$G.UNIMPLEMENTED, "IndexedDB persistence is only available on platforms that support LocalStorage.");
        const n = $5c04988f82cad1b3$var$Io(t.databaseInfo.databaseId, t.databaseInfo.persistenceKey);
        return new $5c04988f82cad1b3$var$Wo(e, t.asyncQueue, n, t.clientId, t.initialUser);
    }
    constructor(t, e){
        super(t, e, /* forceOwnership= */ !1), this.yc = t, this.cacheSizeBytes = e, this.synchronizeTabs = !0;
    }
}
/**
 * Initializes and wires the components that are needed to interface with the
 * network.
 */ class $5c04988f82cad1b3$var$qc {
    async initialize(t, e) {
        this.localStore || (this.localStore = t.localStore, this.sharedClientState = t.sharedClientState, this.datastore = this.createDatastore(e), this.remoteStore = this.createRemoteStore(e), this.eventManager = this.createEventManager(e), this.syncEngine = this.createSyncEngine(e, /* startAsPrimary=*/ !t.synchronizeTabs), this.sharedClientState.onlineStateHandler = (t)=>$5c04988f82cad1b3$var$fc(this.syncEngine, t, 1 /* SharedClientState */ ), this.remoteStore.remoteSyncer.handleCredentialChange = $5c04988f82cad1b3$var$bc.bind(null, this.syncEngine), await $5c04988f82cad1b3$var$Ou(this.remoteStore, this.syncEngine.isPrimaryClient));
    }
    createEventManager(t) {
        return new $5c04988f82cad1b3$var$Gu;
    }
    createDatastore(t) {
        const e = $5c04988f82cad1b3$var$nu(t.databaseInfo.databaseId), n = (s = t.databaseInfo, new $5c04988f82cad1b3$var$Zo(s));
        var s;
        /** Return the Platform-specific connectivity monitor. */ return function(t, e, n, s) {
            return new $5c04988f82cad1b3$var$uu(t, e, n, s);
        }(t.authCredentials, t.appCheckCredentials, n, e);
    }
    createRemoteStore(t) {
        var e, n, s, i, r;
        return e = this.localStore, n = this.datastore, s = t.asyncQueue, i = (t)=>$5c04988f82cad1b3$var$fc(this.syncEngine, t, 0 /* RemoteStore */ ), r = $5c04988f82cad1b3$var$Jo.V() ? new $5c04988f82cad1b3$var$Jo : new $5c04988f82cad1b3$var$Ho, new $5c04988f82cad1b3$var$au(e, n, s, i, r);
    /** Re-enables the network. Idempotent. */ }
    createSyncEngine(t, e) {
        return function(t, e, n, // PORTING NOTE: Manages state synchronization in multi-tab environments.
        s, i, r, o) {
            const u = new $5c04988f82cad1b3$var$oc(t, e, n, s, i, r);
            return o && (u.ac = !0), u;
        }(this.localStore, this.remoteStore, this.eventManager, this.sharedClientState, t.initialUser, t.maxConcurrentLimboResolutions, e);
    }
    terminate() {
        return async function(t) {
            const e = $5c04988f82cad1b3$var$K(t);
            $5c04988f82cad1b3$var$M("RemoteStore", "RemoteStore shutting down."), e.lu.add(5 /* Shutdown */ ), await $5c04988f82cad1b3$var$lu(e), e.du.shutdown(), // Set the OnlineState to Unknown (rather than Offline) to avoid potentially
            // triggering spurious listener events with cached data, etc.
            e._u.set("Unknown" /* Unknown */ );
        }(this.remoteStore);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * How many bytes to read each time when `ReadableStreamReader.read()` is
 * called. Only applicable for byte streams that we control (e.g. those backed
 * by an UInt8Array).
 */ /**
 * Builds a `ByteStreamReader` from a UInt8Array.
 * @param source - The data source to use.
 * @param bytesPerRead - How many bytes each `read()` from the returned reader
 *        will read.
 */ function $5c04988f82cad1b3$var$Kc(t, e = 10240) {
    let n = 0;
    // The TypeScript definition for ReadableStreamReader changed. We use
    // `any` here to allow this code to compile with different versions.
    // See https://github.com/microsoft/TypeScript/issues/42970
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        async read () {
            if (n < t.byteLength) {
                const s = {
                    value: t.slice(n, n + e),
                    done: !1
                };
                return n += e, s;
            }
            return {
                done: !0
            };
        },
        async cancel () {},
        releaseLock () {},
        closed: Promise.reject("unimplemented")
    };
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * On web, a `ReadableStream` is wrapped around by a `ByteStreamReader`.
 */ /**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * A wrapper implementation of Observer<T> that will dispatch events
 * asynchronously. To allow immediate silencing, a mute call is added which
 * causes events scheduled to no longer be raised.
 */ class $5c04988f82cad1b3$var$Gc {
    next(t) {
        this.observer.next && this.Ic(this.observer.next, t);
    }
    error(t) {
        this.observer.error ? this.Ic(this.observer.error, t) : console.error("Uncaught Error in snapshot listener:", t);
    }
    Tc() {
        this.muted = !0;
    }
    Ic(t, e) {
        this.muted || setTimeout(()=>{
            this.muted || t(e);
        }, 0);
    }
    constructor(t){
        this.observer = t, /**
         * When set to true, will not raise future events. Necessary to deal with
         * async detachment of listener.
         */ this.muted = !1;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A class representing a bundle.
 *
 * Takes a bundle stream or buffer, and presents abstractions to read bundled
 * elements out of the underlying content.
 */ class $5c04988f82cad1b3$var$Qc {
    close() {
        return this.Ec.cancel();
    }
    async getMetadata() {
        return this.metadata.promise;
    }
    async fc() {
        // Makes sure metadata is read before proceeding.
        return await this.getMetadata(), this.Rc();
    }
    /**
     * Reads from the head of internal buffer, and pulling more data from
     * underlying stream if a complete element cannot be found, until an
     * element(including the prefixed length and the JSON string) is found.
     *
     * Once a complete element is read, it is dropped from internal buffer.
     *
     * Returns either the bundled element, or null if we have reached the end of
     * the stream.
     */ async Rc() {
        const t = await this.bc();
        if (null === t) return null;
        const e = this.Ac.decode(t), n = Number(e);
        isNaN(n) && this.Pc(`length string (${e}) is not valid number`);
        const s = await this.vc(n);
        return new $5c04988f82cad1b3$var$Yu(JSON.parse(s), t.length + n);
    }
    /** First index of '{' from the underlying buffer. */ Vc() {
        return this.buffer.findIndex((t)=>t === "{".charCodeAt(0));
    }
    /**
     * Reads from the beginning of the internal buffer, until the first '{', and
     * return the content.
     *
     * If reached end of the stream, returns a null.
     */ async bc() {
        for(; this.Vc() < 0;){
            if (await this.Sc()) break;
        }
        // Broke out of the loop because underlying stream is closed, and there
        // happens to be no more data to process.
        if (0 === this.buffer.length) return null;
        const t = this.Vc();
        // Broke out of the loop because underlying stream is closed, but still
        // cannot find an open bracket.
        t < 0 && this.Pc("Reached the end of bundle when a length string is expected.");
        const e = this.buffer.slice(0, t);
        // Update the internal buffer to drop the read length.
        return this.buffer = this.buffer.slice(t), e;
    }
    /**
     * Reads from a specified position from the internal buffer, for a specified
     * number of bytes, pulling more data from the underlying stream if needed.
     *
     * Returns a string decoded from the read bytes.
     */ async vc(t) {
        for(; this.buffer.length < t;)await this.Sc() && this.Pc("Reached the end of bundle when more is expected.");
        const e = this.Ac.decode(this.buffer.slice(0, t));
        // Update the internal buffer to drop the read json string.
        return this.buffer = this.buffer.slice(t), e;
    }
    Pc(t) {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        throw this.Ec.cancel(), new Error(`Invalid bundle format: ${t}`);
    }
    /**
     * Pulls more data from underlying stream to internal buffer.
     * Returns a boolean indicating whether the stream is finished.
     */ async Sc() {
        const t = await this.Ec.read();
        if (!t.done) {
            const e = new Uint8Array(this.buffer.length + t.value.length);
            e.set(this.buffer), e.set(t.value, this.buffer.length), this.buffer = e;
        }
        return t.done;
    }
    constructor(/** The reader to read from underlying binary bundle data source. */ t, e){
        this.Ec = t, this.wt = e, /** Cached bundle metadata. */ this.metadata = new $5c04988f82cad1b3$var$j, /**
         * Internal buffer to hold bundle content, accumulating incomplete element
         * content.
         */ this.buffer = new Uint8Array, this.Ac = new TextDecoder("utf-8"), // Read the metadata (which is the first element).
        this.Rc().then((t)=>{
            t && t.Cu() ? this.metadata.resolve(t.payload.metadata) : this.metadata.reject(new Error(`The first element of the bundle is not a metadata, it is\n             ${JSON.stringify(null == t ? void 0 : t.payload)}`));
        }, (t)=>this.metadata.reject(t));
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Internal transaction object responsible for accumulating the mutations to
 * perform and the base versions for any documents read.
 */ class $5c04988f82cad1b3$var$jc {
    async lookup(t) {
        if (this.ensureCommitNotCalled(), this.mutations.length > 0) throw new $5c04988f82cad1b3$export$8fada0bf726bf278($5c04988f82cad1b3$var$G.INVALID_ARGUMENT, "Firestore transactions require all reads to be executed before all writes.");
        const e = await async function(t, e) {
            const n = $5c04988f82cad1b3$var$K(t), s = $5c04988f82cad1b3$var$Ls(n.wt) + "/documents", i = {
                documents: e.map((t)=>$5c04988f82cad1b3$var$Ms(n.wt, t))
            }, r = await n.ao("BatchGetDocuments", s, i), o = new Map;
            r.forEach((t)=>{
                const e = $5c04988f82cad1b3$var$Gs(n.wt, t);
                o.set(e.key.toString(), e);
            });
            const u = [];
            return e.forEach((t)=>{
                const e = o.get(t.toString());
                $5c04988f82cad1b3$var$U(!!e), u.push(e);
            }), u;
        }(this.datastore, t);
        return e.forEach((t)=>this.recordVersion(t)), e;
    }
    set(t, e) {
        this.write(e.toMutation(t, this.precondition(t))), this.writtenDocs.add(t.toString());
    }
    update(t, e) {
        try {
            this.write(e.toMutation(t, this.preconditionForUpdate(t)));
        } catch (t) {
            this.lastWriteError = t;
        }
        this.writtenDocs.add(t.toString());
    }
    delete(t) {
        this.write(new $5c04988f82cad1b3$var$Yn(t, this.precondition(t))), this.writtenDocs.add(t.toString());
    }
    async commit() {
        if (this.ensureCommitNotCalled(), this.lastWriteError) throw this.lastWriteError;
        const t = this.readVersions;
        // For each mutation, note that the doc was written.
        this.mutations.forEach((e)=>{
            t.delete(e.key.toString());
        }), // For each document that was read but not written to, we want to perform
        // a `verify` operation.
        t.forEach((t, e)=>{
            const n = $5c04988f82cad1b3$export$afc2e57c475b7810.fromPath(e);
            this.mutations.push(new $5c04988f82cad1b3$var$Xn(n, this.precondition(n)));
        }), await async function(t, e) {
            const n = $5c04988f82cad1b3$var$K(t), s = $5c04988f82cad1b3$var$Ls(n.wt) + "/documents", i = {
                writes: e.map((t)=>$5c04988f82cad1b3$var$js(n.wt, t))
            };
            await n.ro("Commit", s, i);
        }(this.datastore, this.mutations), this.committed = !0;
    }
    recordVersion(t) {
        let e;
        if (t.isFoundDocument()) e = t.version;
        else {
            if (!t.isNoDocument()) throw $5c04988f82cad1b3$var$L();
            // For deleted docs, we must use baseVersion 0 when we overwrite them.
            e = $5c04988f82cad1b3$var$ct.min();
        }
        const n = this.readVersions.get(t.key.toString());
        if (n) {
            if (!e.isEqual(n)) // This transaction will fail no matter what.
            throw new $5c04988f82cad1b3$export$8fada0bf726bf278($5c04988f82cad1b3$var$G.ABORTED, "Document version changed between two reads.");
        } else this.readVersions.set(t.key.toString(), e);
    }
    /**
     * Returns the version of this document when it was read in this transaction,
     * as a precondition, or no precondition if it was not read.
     */ precondition(t) {
        const e = this.readVersions.get(t.toString());
        return !this.writtenDocs.has(t.toString()) && e ? $5c04988f82cad1b3$var$$n.updateTime(e) : $5c04988f82cad1b3$var$$n.none();
    }
    /**
     * Returns the precondition for a document if the operation is an update.
     */ preconditionForUpdate(t) {
        const e = this.readVersions.get(t.toString());
        // The first time a document is written, we want to take into account the
        // read time and existence
        if (!this.writtenDocs.has(t.toString()) && e) {
            if (e.isEqual($5c04988f82cad1b3$var$ct.min())) // The document doesn't exist, so fail the transaction.
            // This has to be validated locally because you can't send a
            // precondition that a document does not exist without changing the
            // semantics of the backend write to be an insert. This is the reverse
            // of what we want, since we want to assert that the document doesn't
            // exist but then send the update and have it fail. Since we can't
            // express that to the backend, we have to validate locally.
            // Note: this can change once we can send separate verify writes in the
            // transaction.
            throw new $5c04988f82cad1b3$export$8fada0bf726bf278($5c04988f82cad1b3$var$G.INVALID_ARGUMENT, "Can't update a document that doesn't exist.");
            // Document exists, base precondition on document update time.
            return $5c04988f82cad1b3$var$$n.updateTime(e);
        }
        // Document was not read, so we just use the preconditions for a blind
        // update.
        return $5c04988f82cad1b3$var$$n.exists(!0);
    }
    write(t) {
        this.ensureCommitNotCalled(), this.mutations.push(t);
    }
    ensureCommitNotCalled() {}
    constructor(t){
        this.datastore = t, // The version of each document that was read during this transaction.
        this.readVersions = new Map, this.mutations = [], this.committed = !1, /**
         * A deferred usage error that occurred previously in this transaction that
         * will cause the transaction to fail once it actually commits.
         */ this.lastWriteError = null, /**
         * Set of documents that have been written in the transaction.
         *
         * When there's more than one write to the same key in a transaction, any
         * writes after the first are handled differently.
         */ this.writtenDocs = new Set;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * TransactionRunner encapsulates the logic needed to run and retry transactions
 * with backoff.
 */ class $5c04988f82cad1b3$var$Wc {
    /** Runs the transaction and sets the result on deferred. */ run() {
        this.Dc -= 1, this.Cc();
    }
    Cc() {
        this.So.Io(async ()=>{
            const t = new $5c04988f82cad1b3$var$jc(this.datastore), e = this.xc(t);
            e && e.then((e)=>{
                this.asyncQueue.enqueueAndForget(()=>t.commit().then(()=>{
                        this.deferred.resolve(e);
                    }).catch((t)=>{
                        this.Nc(t);
                    }));
            }).catch((t)=>{
                this.Nc(t);
            });
        });
    }
    xc(t) {
        try {
            const e = this.updateFunction(t);
            return !$5c04988f82cad1b3$var$oe(e) && e.catch && e.then ? e : (this.deferred.reject(Error("Transaction callback must return a Promise")), null);
        } catch (t) {
            // Do not retry errors thrown by user provided updateFunction.
            return this.deferred.reject(t), null;
        }
    }
    Nc(t) {
        this.Dc > 0 && this.kc(t) ? (this.Dc -= 1, this.asyncQueue.enqueueAndForget(()=>(this.Cc(), Promise.resolve()))) : this.deferred.reject(t);
    }
    kc(t) {
        if ("FirebaseError" === t.name) {
            // In transactions, the backend will fail outdated reads with FAILED_PRECONDITION and
            // non-matching document versions with ABORTED. These errors should be retried.
            const e = t.code;
            return "aborted" === e || "failed-precondition" === e || !$5c04988f82cad1b3$var$ns(e);
        }
        return !1;
    }
    constructor(t, e, n, s, i){
        this.asyncQueue = t, this.datastore = e, this.options = n, this.updateFunction = s, this.deferred = i, this.Dc = n.maxAttempts, this.So = new $5c04988f82cad1b3$var$su(this.asyncQueue, "transaction_retry" /* TransactionRetry */ );
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * FirestoreClient is a top-level class that constructs and owns all of the
 * pieces of the client SDK architecture. It is responsible for creating the
 * async queue that is shared by all of the other components in the system.
 */ class $5c04988f82cad1b3$var$zc {
    async getConfiguration() {
        return {
            asyncQueue: this.asyncQueue,
            databaseInfo: this.databaseInfo,
            clientId: this.clientId,
            authCredentials: this.authCredentials,
            appCheckCredentials: this.appCheckCredentials,
            initialUser: this.user,
            maxConcurrentLimboResolutions: 100
        };
    }
    setCredentialChangeListener(t) {
        this.authCredentialListener = t;
    }
    setAppCheckTokenChangeListener(t) {
        this.appCheckCredentialListener = t;
    }
    /**
     * Checks that the client has not been terminated. Ensures that other methods on
     * this class cannot be called after the client is terminated.
     */ verifyNotTerminated() {
        if (this.asyncQueue.isShuttingDown) throw new $5c04988f82cad1b3$export$8fada0bf726bf278($5c04988f82cad1b3$var$G.FAILED_PRECONDITION, "The client has already been terminated.");
    }
    terminate() {
        this.asyncQueue.enterRestrictedMode();
        const t = new $5c04988f82cad1b3$var$j;
        return this.asyncQueue.enqueueAndForgetEvenWhileRestricted(async ()=>{
            try {
                this.onlineComponents && await this.onlineComponents.terminate(), this.offlineComponents && await this.offlineComponents.terminate(), // The credentials provider must be terminated after shutting down the
                // RemoteStore as it will prevent the RemoteStore from retrieving auth
                // tokens.
                this.authCredentials.shutdown(), this.appCheckCredentials.shutdown(), t.resolve();
            } catch (e) {
                const n = $5c04988f82cad1b3$var$Bu(e, "Failed to shutdown persistence");
                t.reject(n);
            }
        }), t.promise;
    }
    constructor(t, e, /**
     * Asynchronous queue responsible for all of our internal processing. When
     * we get incoming work from the user (via public API) or the network
     * (incoming GRPC messages), we should always schedule onto this queue.
     * This ensures all of our work is properly serialized (e.g. we don't
     * start processing a new operation while the previous one is waiting for
     * an async I/O to complete).
     */ n, s){
        this.authCredentials = t, this.appCheckCredentials = e, this.asyncQueue = n, this.databaseInfo = s, this.user = $5c04988f82cad1b3$var$C.UNAUTHENTICATED, this.clientId = $5c04988f82cad1b3$var$st.I(), this.authCredentialListener = ()=>Promise.resolve(), this.appCheckCredentialListener = ()=>Promise.resolve(), this.authCredentials.start(n, async (t)=>{
            $5c04988f82cad1b3$var$M("FirestoreClient", "Received user=", t.uid), await this.authCredentialListener(t), this.user = t;
        }), this.appCheckCredentials.start(n, (t)=>($5c04988f82cad1b3$var$M("FirestoreClient", "Received new app check token=", t), this.appCheckCredentialListener(t, this.user)));
    }
}
async function $5c04988f82cad1b3$var$Hc(t, e) {
    t.asyncQueue.verifyOperationInProgress(), $5c04988f82cad1b3$var$M("FirestoreClient", "Initializing OfflineComponentProvider");
    const n = await t.getConfiguration();
    await e.initialize(n);
    let s = n.initialUser;
    t.setCredentialChangeListener(async (t)=>{
        s.isEqual(t) || (await $5c04988f82cad1b3$var$bo(e.localStore, t), s = t);
    }), // When a user calls clearPersistence() in one client, all other clients
    // need to be terminated to allow the delete to succeed.
    e.persistence.setDatabaseDeletedListener(()=>t.terminate()), t.offlineComponents = e;
}
async function $5c04988f82cad1b3$var$Jc(t, e) {
    t.asyncQueue.verifyOperationInProgress();
    const n = await $5c04988f82cad1b3$var$Yc(t);
    $5c04988f82cad1b3$var$M("FirestoreClient", "Initializing OnlineComponentProvider");
    const s = await t.getConfiguration();
    await e.initialize(n, s), // The CredentialChangeListener of the online component provider takes
    // precedence over the offline component provider.
    t.setCredentialChangeListener((t)=>$5c04988f82cad1b3$var$ku(e.remoteStore, t)), t.setAppCheckTokenChangeListener((t, n)=>$5c04988f82cad1b3$var$ku(e.remoteStore, n)), t.onlineComponents = e;
}
async function $5c04988f82cad1b3$var$Yc(t) {
    return t.offlineComponents || ($5c04988f82cad1b3$var$M("FirestoreClient", "Using default OfflineComponentProvider"), await $5c04988f82cad1b3$var$Hc(t, new $5c04988f82cad1b3$var$Bc)), t.offlineComponents;
}
async function $5c04988f82cad1b3$var$Xc(t) {
    return t.onlineComponents || ($5c04988f82cad1b3$var$M("FirestoreClient", "Using default OnlineComponentProvider"), await $5c04988f82cad1b3$var$Jc(t, new $5c04988f82cad1b3$var$qc)), t.onlineComponents;
}
function $5c04988f82cad1b3$var$Zc(t) {
    return $5c04988f82cad1b3$var$Yc(t).then((t)=>t.persistence);
}
function $5c04988f82cad1b3$var$ta(t) {
    return $5c04988f82cad1b3$var$Yc(t).then((t)=>t.localStore);
}
function $5c04988f82cad1b3$var$ea(t) {
    return $5c04988f82cad1b3$var$Xc(t).then((t)=>t.remoteStore);
}
function $5c04988f82cad1b3$var$na(t) {
    return $5c04988f82cad1b3$var$Xc(t).then((t)=>t.syncEngine);
}
async function $5c04988f82cad1b3$var$sa(t) {
    const e = await $5c04988f82cad1b3$var$Xc(t), n = e.eventManager;
    return n.onListen = $5c04988f82cad1b3$var$uc.bind(null, e.syncEngine), n.onUnlisten = $5c04988f82cad1b3$var$ac.bind(null, e.syncEngine), n;
}
/** Enables the network connection and re-enqueues all pending operations. */ function $5c04988f82cad1b3$var$ia(t) {
    return t.asyncQueue.enqueue(async ()=>{
        const e = await $5c04988f82cad1b3$var$Zc(t), n = await $5c04988f82cad1b3$var$ea(t);
        return e.setNetworkEnabled(!0), function(t) {
            const e = $5c04988f82cad1b3$var$K(t);
            return e.lu.delete(0 /* UserDisabled */ ), $5c04988f82cad1b3$var$hu(e);
        }(n);
    });
}
/** Disables the network connection. Pending operations will not complete. */ function $5c04988f82cad1b3$var$ra(t) {
    return t.asyncQueue.enqueue(async ()=>{
        const e = await $5c04988f82cad1b3$var$Zc(t), n = await $5c04988f82cad1b3$var$ea(t);
        return e.setNetworkEnabled(!1), async function(t) {
            const e = $5c04988f82cad1b3$var$K(t);
            e.lu.add(0 /* UserDisabled */ ), await $5c04988f82cad1b3$var$lu(e), // Set the OnlineState to Offline so get()s return from cache, etc.
            e._u.set("Offline" /* Offline */ );
        }(n);
    });
}
/**
 * Returns a Promise that resolves when all writes that were pending at the time
 * this method was called received server acknowledgement. An acknowledgement
 * can be either acceptance or rejection.
 */ function $5c04988f82cad1b3$var$oa(t, e) {
    const n = new $5c04988f82cad1b3$var$j;
    return t.asyncQueue.enqueueAndForget(async ()=>(async function(t, e, n) {
            try {
                const s = await function(t, e) {
                    const n = $5c04988f82cad1b3$var$K(t);
                    return n.persistence.runTransaction("read document", "readonly", (t)=>n.localDocuments.getDocument(t, e));
                }(t, e);
                s.isFoundDocument() ? n.resolve(s) : s.isNoDocument() ? n.resolve(null) : n.reject(new $5c04988f82cad1b3$export$8fada0bf726bf278($5c04988f82cad1b3$var$G.UNAVAILABLE, "Failed to get document from cache. (However, this document may exist on the server. Run again without setting 'source' in the GetOptions to attempt to retrieve the document from the server.)"));
            } catch (t) {
                const s = $5c04988f82cad1b3$var$Bu(t, `Failed to get document '${e} from cache`);
                n.reject(s);
            }
        })(await $5c04988f82cad1b3$var$ta(t), e, n)), n.promise;
}
function $5c04988f82cad1b3$var$ua(t, e, n = {}) {
    const s = new $5c04988f82cad1b3$var$j;
    return t.asyncQueue.enqueueAndForget(async ()=>(function(t, e, n, s, i) {
            const r = new $5c04988f82cad1b3$var$Gc({
                next: (r)=>{
                    // Remove query first before passing event to user to avoid
                    // user actions affecting the now stale query.
                    e.enqueueAndForget(()=>$5c04988f82cad1b3$var$ju(t, o));
                    const u = r.docs.has(n);
                    !u && r.fromCache ? // TODO(dimond): If we're online and the document doesn't
                    // exist then we resolve with a doc.exists set to false. If
                    // we're offline however, we reject the Promise in this
                    // case. Two options: 1) Cache the negative response from
                    // the server so we can deliver that even when you're
                    // offline 2) Actually reject the Promise in the online case
                    // if the document doesn't exist.
                    i.reject(new $5c04988f82cad1b3$export$8fada0bf726bf278($5c04988f82cad1b3$var$G.UNAVAILABLE, "Failed to get document because the client is offline.")) : u && r.fromCache && s && "server" === s.source ? i.reject(new $5c04988f82cad1b3$export$8fada0bf726bf278($5c04988f82cad1b3$var$G.UNAVAILABLE, 'Failed to get document from server. (However, this document does exist in the local cache. Run again without setting source to "server" to retrieve the cached document.)')) : i.resolve(r);
                },
                error: (t)=>i.reject(t)
            }), o = new $5c04988f82cad1b3$var$Ju($5c04988f82cad1b3$var$rn(n.path), r, {
                includeMetadataChanges: !0,
                Du: !0
            });
            return $5c04988f82cad1b3$var$Qu(t, o);
        })(await $5c04988f82cad1b3$var$sa(t), t.asyncQueue, e, n, s)), s.promise;
}
function $5c04988f82cad1b3$var$ca(t, e) {
    const n = new $5c04988f82cad1b3$var$j;
    return t.asyncQueue.enqueueAndForget(async ()=>(async function(t, e, n) {
            try {
                const s = await $5c04988f82cad1b3$var$No(t, e, /* usePreviousResults= */ !0), i = new $5c04988f82cad1b3$var$sc(e, s.ji), r = i.Ku(s.documents), o = i.applyChanges(r, /* updateLimboDocuments= */ !1);
                n.resolve(o.snapshot);
            } catch (t) {
                const s = $5c04988f82cad1b3$var$Bu(t, `Failed to execute query '${e} against cache`);
                n.reject(s);
            }
        })(await $5c04988f82cad1b3$var$ta(t), e, n)), n.promise;
}
function $5c04988f82cad1b3$var$aa(t, e, n = {}) {
    const s = new $5c04988f82cad1b3$var$j;
    return t.asyncQueue.enqueueAndForget(async ()=>(function(t, e, n, s, i) {
            const r = new $5c04988f82cad1b3$var$Gc({
                next: (n)=>{
                    // Remove query first before passing event to user to avoid
                    // user actions affecting the now stale query.
                    e.enqueueAndForget(()=>$5c04988f82cad1b3$var$ju(t, o)), n.fromCache && "server" === s.source ? i.reject(new $5c04988f82cad1b3$export$8fada0bf726bf278($5c04988f82cad1b3$var$G.UNAVAILABLE, 'Failed to get documents from server. (However, these documents may exist in the local cache. Run again without setting source to "server" to retrieve the cached documents.)')) : i.resolve(n);
                },
                error: (t)=>i.reject(t)
            }), o = new $5c04988f82cad1b3$var$Ju(n, r, {
                includeMetadataChanges: !0,
                Du: !0
            });
            return $5c04988f82cad1b3$var$Qu(t, o);
        })(await $5c04988f82cad1b3$var$sa(t), t.asyncQueue, e, n, s)), s.promise;
}
function $5c04988f82cad1b3$var$ha(t, e) {
    const n = new $5c04988f82cad1b3$var$Gc(e);
    return t.asyncQueue.enqueueAndForget(async ()=>(function(t, e) {
            $5c04988f82cad1b3$var$K(t).Tu.add(e), // Immediately fire an initial event, indicating all existing listeners
            // are in-sync.
            e.next();
        })(await $5c04988f82cad1b3$var$sa(t), n)), ()=>{
        n.Tc(), t.asyncQueue.enqueueAndForget(async ()=>(function(t, e) {
                $5c04988f82cad1b3$var$K(t).Tu.delete(e);
            })(await $5c04988f82cad1b3$var$sa(t), n));
    };
}
/**
 * Takes an updateFunction in which a set of reads and writes can be performed
 * atomically. In the updateFunction, the client can read and write values
 * using the supplied transaction object. After the updateFunction, all
 * changes will be committed. If a retryable error occurs (ex: some other
 * client has changed any of the data referenced), then the updateFunction
 * will be called again after a backoff. If the updateFunction still fails
 * after all retries, then the transaction will be rejected.
 *
 * The transaction object passed to the updateFunction contains methods for
 * accessing documents and collections. Unlike other datastore access, data
 * accessed with the transaction will not reflect local changes that have not
 * been committed. For this reason, it is required that all reads are
 * performed before any writes. Transactions must be performed while online.
 */ function $5c04988f82cad1b3$var$la(t, e, n) {
    const s = new $5c04988f82cad1b3$var$j;
    return t.asyncQueue.enqueueAndForget(async ()=>{
        const i = await function(t) {
            return $5c04988f82cad1b3$var$Xc(t).then((t)=>t.datastore);
        }(t);
        new $5c04988f82cad1b3$var$Wc(t.asyncQueue, i, n, e, s).run();
    }), s.promise;
}
function $5c04988f82cad1b3$var$fa(t, e, n, s) {
    const i = function(t, e) {
        let n;
        n = "string" == typeof t ? (new TextEncoder).encode(t) : t;
        return function(t, e) {
            return new $5c04988f82cad1b3$var$Qc(t, e);
        }(function(t, e) {
            if (t instanceof Uint8Array) return $5c04988f82cad1b3$var$Kc(t, e);
            if (t instanceof ArrayBuffer) return $5c04988f82cad1b3$var$Kc(new Uint8Array(t), e);
            if (t instanceof ReadableStream) return t.getReader();
            throw new Error("Source of `toByteStreamReader` has to be a ArrayBuffer or ReadableStream");
        }(n), e);
    }(n, $5c04988f82cad1b3$var$nu(e));
    t.asyncQueue.enqueueAndForget(async ()=>{
        $5c04988f82cad1b3$var$$c(await $5c04988f82cad1b3$var$na(t), i, s);
    });
}
function $5c04988f82cad1b3$var$da(t, e) {
    return t.asyncQueue.enqueue(async ()=>(function(t, e) {
            const n = $5c04988f82cad1b3$var$K(t);
            return n.persistence.runTransaction("Get named query", "readonly", (t)=>n.Ds.getNamedQuery(t, e));
        })(await $5c04988f82cad1b3$var$ta(t), e));
}
const $5c04988f82cad1b3$var$_a = new Map;
/**
 * An instance map that ensures only one Datastore exists per Firestore
 * instance.
 */ /**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $5c04988f82cad1b3$var$wa(t, e, n) {
    if (!n) throw new $5c04988f82cad1b3$export$8fada0bf726bf278($5c04988f82cad1b3$var$G.INVALID_ARGUMENT, `Function ${t}() cannot be called with an empty ${e}.`);
}
/**
 * Validates that two boolean options are not set at the same time.
 * @internal
 */ function $5c04988f82cad1b3$export$8731e8d1617cddb1(t, e, n, s) {
    if (!0 === e && !0 === s) throw new $5c04988f82cad1b3$export$8fada0bf726bf278($5c04988f82cad1b3$var$G.INVALID_ARGUMENT, `${t} and ${n} cannot be used together.`);
}
/**
 * Validates that `path` refers to a document (indicated by the fact it contains
 * an even numbers of segments).
 */ function $5c04988f82cad1b3$var$ga(t) {
    if (!$5c04988f82cad1b3$export$afc2e57c475b7810.isDocumentKey(t)) throw new $5c04988f82cad1b3$export$8fada0bf726bf278($5c04988f82cad1b3$var$G.INVALID_ARGUMENT, `Invalid document reference. Document references must have an even number of segments, but ${t} has ${t.length}.`);
}
/**
 * Validates that `path` refers to a collection (indicated by the fact it
 * contains an odd numbers of segments).
 */ function $5c04988f82cad1b3$var$ya(t) {
    if ($5c04988f82cad1b3$export$afc2e57c475b7810.isDocumentKey(t)) throw new $5c04988f82cad1b3$export$8fada0bf726bf278($5c04988f82cad1b3$var$G.INVALID_ARGUMENT, `Invalid collection reference. Collection references must have an odd number of segments, but ${t} has ${t.length}.`);
}
/**
 * Returns true if it's a non-null object without a custom prototype
 * (i.e. excludes Array, Date, etc.).
 */ /** Returns a string describing the type / value of the provided input. */ function $5c04988f82cad1b3$var$pa(t) {
    if (void 0 === t) return "undefined";
    if (null === t) return "null";
    if ("string" == typeof t) return t.length > 20 && (t = `${t.substring(0, 20)}...`), JSON.stringify(t);
    if ("number" == typeof t || "boolean" == typeof t) return "" + t;
    if ("object" == typeof t) {
        if (t instanceof Array) return "an array";
        {
            const e = /** try to get the constructor name for an object. */ function(t) {
                if (t.constructor) return t.constructor.name;
                return null;
            }(t);
            return e ? `a custom ${e} object` : "an object";
        }
    }
    return "function" == typeof t ? "a function" : $5c04988f82cad1b3$var$L();
}
function $5c04988f82cad1b3$export$572106fb5803752c(t, // eslint-disable-next-line @typescript-eslint/no-explicit-any
e) {
    if ("_delegate" in t && // Unwrap Compat types
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (t = t._delegate), !(t instanceof e)) {
        if (e.name === t.constructor.name) throw new $5c04988f82cad1b3$export$8fada0bf726bf278($5c04988f82cad1b3$var$G.INVALID_ARGUMENT, "Type does not match the expected instance. Did you pass a reference from a different Firestore SDK?");
        {
            const n = $5c04988f82cad1b3$var$pa(t);
            throw new $5c04988f82cad1b3$export$8fada0bf726bf278($5c04988f82cad1b3$var$G.INVALID_ARGUMENT, `Expected type '${e.name}', but it was: ${n}`);
        }
    }
    return t;
}
function $5c04988f82cad1b3$var$Ta(t, e) {
    if (e <= 0) throw new $5c04988f82cad1b3$export$8fada0bf726bf278($5c04988f82cad1b3$var$G.INVALID_ARGUMENT, `Function ${t}() requires a positive number, but it was: ${e}.`);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // settings() defaults:
/**
 * A concrete type describing all the values that can be applied via a
 * user-supplied `FirestoreSettings` object. This is a separate type so that
 * defaults can be supplied and the value can be checked for equality.
 */ class $5c04988f82cad1b3$var$Ea {
    isEqual(t) {
        return this.host === t.host && this.ssl === t.ssl && this.credentials === t.credentials && this.cacheSizeBytes === t.cacheSizeBytes && this.experimentalForceLongPolling === t.experimentalForceLongPolling && this.experimentalAutoDetectLongPolling === t.experimentalAutoDetectLongPolling && this.ignoreUndefinedProperties === t.ignoreUndefinedProperties && this.useFetchStreams === t.useFetchStreams;
    }
    constructor(t){
        var e;
        if (void 0 === t.host) {
            if (void 0 !== t.ssl) throw new $5c04988f82cad1b3$export$8fada0bf726bf278($5c04988f82cad1b3$var$G.INVALID_ARGUMENT, "Can't provide ssl option if host option is not set");
            this.host = "firestore.googleapis.com", this.ssl = true;
        } else this.host = t.host, this.ssl = null === (e = t.ssl) || void 0 === e || e;
        if (this.credentials = t.credentials, this.ignoreUndefinedProperties = !!t.ignoreUndefinedProperties, void 0 === t.cacheSizeBytes) this.cacheSizeBytes = 41943040;
        else {
            if (-1 !== t.cacheSizeBytes && t.cacheSizeBytes < 1048576) throw new $5c04988f82cad1b3$export$8fada0bf726bf278($5c04988f82cad1b3$var$G.INVALID_ARGUMENT, "cacheSizeBytes must be at least 1048576");
            this.cacheSizeBytes = t.cacheSizeBytes;
        }
        this.experimentalForceLongPolling = !!t.experimentalForceLongPolling, this.experimentalAutoDetectLongPolling = !!t.experimentalAutoDetectLongPolling, this.useFetchStreams = !!t.useFetchStreams, $5c04988f82cad1b3$export$8731e8d1617cddb1("experimentalForceLongPolling", t.experimentalForceLongPolling, "experimentalAutoDetectLongPolling", t.experimentalAutoDetectLongPolling);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The Cloud Firestore service interface.
 *
 * Do not call this constructor directly. Instead, use {@link getFirestore}.
 */ class $5c04988f82cad1b3$var$Aa {
    /**
     * The {@link @firebase/app#FirebaseApp} associated with this `Firestore` service
     * instance.
     */ get app() {
        if (!this._app) throw new $5c04988f82cad1b3$export$8fada0bf726bf278($5c04988f82cad1b3$var$G.FAILED_PRECONDITION, "Firestore was not initialized using the Firebase SDK. 'app' is not available");
        return this._app;
    }
    get _initialized() {
        return this._settingsFrozen;
    }
    get _terminated() {
        return void 0 !== this._terminateTask;
    }
    _setSettings(t) {
        if (this._settingsFrozen) throw new $5c04988f82cad1b3$export$8fada0bf726bf278($5c04988f82cad1b3$var$G.FAILED_PRECONDITION, "Firestore has already been started and its settings can no longer be changed. You can only modify settings before calling any other methods on a Firestore object.");
        this._settings = new $5c04988f82cad1b3$var$Ea(t), void 0 !== t.credentials && (this._authCredentials = function(t) {
            if (!t) return new $5c04988f82cad1b3$export$65ffa50b6039c992;
            switch(t.type){
                case "gapi":
                    const e = t.client;
                    // Make sure this really is a Gapi client.
                    return $5c04988f82cad1b3$var$U(!("object" != typeof e || null === e || !e.auth || !e.auth.getAuthHeaderValueForFirstParty)), new $5c04988f82cad1b3$var$X(e, t.sessionIndex || "0", t.iamToken || null);
                case "provider":
                    return t.client;
                default:
                    throw new $5c04988f82cad1b3$export$8fada0bf726bf278($5c04988f82cad1b3$var$G.INVALID_ARGUMENT, "makeAuthCredentialsProvider failed due to invalid credential type");
            }
        }(t.credentials));
    }
    _getSettings() {
        return this._settings;
    }
    _freezeSettings() {
        return this._settingsFrozen = !0, this._settings;
    }
    _delete() {
        return this._terminateTask || (this._terminateTask = this._terminate()), this._terminateTask;
    }
    /** Returns a JSON-serializable representation of this `Firestore` instance. */ toJSON() {
        return {
            app: this._app,
            databaseId: this._databaseId,
            settings: this._settings
        };
    }
    /**
     * Terminates all components used by this client. Subclasses can override
     * this method to clean up their own dependencies, but must also call this
     * method.
     *
     * Only ever called once.
     */ _terminate() {
        /**
 * Removes all components associated with the provided instance. Must be called
 * when the `Firestore` instance is terminated.
 */ return function(t) {
            const e = $5c04988f82cad1b3$var$_a.get(t);
            e && ($5c04988f82cad1b3$var$M("ComponentProvider", "Removing Datastore"), $5c04988f82cad1b3$var$_a.delete(t), e.terminate());
        }(this), Promise.resolve();
    }
    /** @hideconstructor */ constructor(t, e, n){
        this._authCredentials = e, this._appCheckCredentials = n, /**
         * Whether it's a Firestore or Firestore Lite instance.
         */ this.type = "firestore-lite", this._persistenceKey = "(lite)", this._settings = new $5c04988f82cad1b3$var$Ea({}), this._settingsFrozen = !1, t instanceof $5c04988f82cad1b3$export$4c3ccc07620ae30a ? this._databaseId = t : (this._app = t, this._databaseId = function(t) {
            if (!Object.prototype.hasOwnProperty.apply(t.options, [
                "projectId"
            ])) throw new $5c04988f82cad1b3$export$8fada0bf726bf278($5c04988f82cad1b3$var$G.INVALID_ARGUMENT, '"projectId" not provided in firebase.initializeApp.');
            return new $5c04988f82cad1b3$export$4c3ccc07620ae30a(t.options.projectId);
        }(t));
    }
}
function $5c04988f82cad1b3$export$966a03d25297d115(t, e, n, s = {}) {
    var i;
    const r = (t = $5c04988f82cad1b3$export$572106fb5803752c(t, $5c04988f82cad1b3$var$Aa))._getSettings();
    if ("firestore.googleapis.com" !== r.host && r.host !== e && $5c04988f82cad1b3$export$86cd73f49cc6e0bb("Host has been set in both settings() and useEmulator(), emulator host will be used"), t._setSettings(Object.assign(Object.assign({}, r), {
        host: `${e}:${n}`,
        ssl: !1
    })), s.mockUserToken) {
        let e, n;
        if ("string" == typeof s.mockUserToken) e = s.mockUserToken, n = $5c04988f82cad1b3$var$C.MOCK_USER;
        else {
            // Let createMockUserToken validate first (catches common mistakes like
            // invalid field "uid" and missing field "sub" / "user_id".)
            e = (0, $isbtl.createMockUserToken)(s.mockUserToken, null === (i = t._app) || void 0 === i ? void 0 : i.options.projectId);
            const r = s.mockUserToken.sub || s.mockUserToken.user_id;
            if (!r) throw new $5c04988f82cad1b3$export$8fada0bf726bf278($5c04988f82cad1b3$var$G.INVALID_ARGUMENT, "mockUserToken must contain 'sub' or 'user_id' field!");
            n = new $5c04988f82cad1b3$var$C(r);
        }
        t._authCredentials = new $5c04988f82cad1b3$var$H(new $5c04988f82cad1b3$var$W(e, n));
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A `DocumentReference` refers to a document location in a Firestore database
 * and can be used to write, read, or listen to the location. The document at
 * the referenced location may or may not exist.
 */ class $5c04988f82cad1b3$export$6be62b059fb12175 {
    get _path() {
        return this._key.path;
    }
    /**
     * The document's identifier within its collection.
     */ get id() {
        return this._key.path.lastSegment();
    }
    /**
     * A string representing the path of the referenced document (relative
     * to the root of the database).
     */ get path() {
        return this._key.path.canonicalString();
    }
    /**
     * The collection this `DocumentReference` belongs to.
     */ get parent() {
        return new $5c04988f82cad1b3$export$ab5a1a47940a200e(this.firestore, this.converter, this._key.path.popLast());
    }
    withConverter(t) {
        return new $5c04988f82cad1b3$export$6be62b059fb12175(this.firestore, t, this._key);
    }
    /** @hideconstructor */ constructor(t, /**
     * If provided, the `FirestoreDataConverter` associated with this instance.
     */ e, n){
        this.converter = e, this._key = n, /** The type of this Firestore reference. */ this.type = "document", this.firestore = t;
    }
}
/**
 * A `Query` refers to a query which you can read or listen to. You can also
 * construct refined `Query` objects by adding filters and ordering.
 */ class $5c04988f82cad1b3$export$62297b13309008b2 {
    withConverter(t) {
        return new $5c04988f82cad1b3$export$62297b13309008b2(this.firestore, t, this._query);
    }
    // This is the lite version of the Query class in the main SDK.
    /** @hideconstructor protected */ constructor(t, /**
     * If provided, the `FirestoreDataConverter` associated with this instance.
     */ e, n){
        this.converter = e, this._query = n, /** The type of this Firestore reference. */ this.type = "query", this.firestore = t;
    }
}
/**
 * A `CollectionReference` object can be used for adding documents, getting
 * document references, and querying for documents (using {@link query}).
 */ class $5c04988f82cad1b3$export$ab5a1a47940a200e extends $5c04988f82cad1b3$export$62297b13309008b2 {
    /** The collection's identifier. */ get id() {
        return this._query.path.lastSegment();
    }
    /**
     * A string representing the path of the referenced collection (relative
     * to the root of the database).
     */ get path() {
        return this._query.path.canonicalString();
    }
    /**
     * A reference to the containing `DocumentReference` if this is a
     * subcollection. If this isn't a subcollection, the reference is null.
     */ get parent() {
        const t = this._path.popLast();
        return t.isEmpty() ? null : new $5c04988f82cad1b3$export$6be62b059fb12175(this.firestore, /* converter= */ null, new $5c04988f82cad1b3$export$afc2e57c475b7810(t));
    }
    withConverter(t) {
        return new $5c04988f82cad1b3$export$ab5a1a47940a200e(this.firestore, t, this._path);
    }
    /** @hideconstructor */ constructor(t, e, n){
        super(t, e, $5c04988f82cad1b3$var$rn(n)), this._path = n, /** The type of this Firestore reference. */ this.type = "collection";
    }
}
function $5c04988f82cad1b3$export$bf5175b0c24981cd(t, e, ...n) {
    if (t = (0, $isbtl.getModularInstance)(t), $5c04988f82cad1b3$var$wa("collection", "path", e), t instanceof $5c04988f82cad1b3$var$Aa) {
        const s = $5c04988f82cad1b3$var$ht.fromString(e, ...n);
        return $5c04988f82cad1b3$var$ya(s), new $5c04988f82cad1b3$export$ab5a1a47940a200e(t, /* converter= */ null, s);
    }
    {
        if (!(t instanceof $5c04988f82cad1b3$export$6be62b059fb12175 || t instanceof $5c04988f82cad1b3$export$ab5a1a47940a200e)) throw new $5c04988f82cad1b3$export$8fada0bf726bf278($5c04988f82cad1b3$var$G.INVALID_ARGUMENT, "Expected first argument to collection() to be a CollectionReference, a DocumentReference or FirebaseFirestore");
        const s = t._path.child($5c04988f82cad1b3$var$ht.fromString(e, ...n));
        return $5c04988f82cad1b3$var$ya(s), new $5c04988f82cad1b3$export$ab5a1a47940a200e(t.firestore, /* converter= */ null, s);
    }
}
// TODO(firestorelite): Consider using ErrorFactory -
// https://github.com/firebase/firebase-js-sdk/blob/0131e1f/packages/util/src/errors.ts#L106
/**
 * Creates and returns a new `Query` instance that includes all documents in the
 * database that are contained in a collection or subcollection with the
 * given `collectionId`.
 *
 * @param firestore - A reference to the root `Firestore` instance.
 * @param collectionId - Identifies the collections to query over. Every
 * collection or subcollection with this ID as the last segment of its path
 * will be included. Cannot contain a slash.
 * @returns The created `Query`.
 */ function $5c04988f82cad1b3$export$473d82a73f88c107(t, e) {
    if (t = $5c04988f82cad1b3$export$572106fb5803752c(t, $5c04988f82cad1b3$var$Aa), $5c04988f82cad1b3$var$wa("collectionGroup", "collection id", e), e.indexOf("/") >= 0) throw new $5c04988f82cad1b3$export$8fada0bf726bf278($5c04988f82cad1b3$var$G.INVALID_ARGUMENT, `Invalid collection ID '${e}' passed to function collectionGroup(). Collection IDs must not contain '/'.`);
    return new $5c04988f82cad1b3$export$62297b13309008b2(t, /* converter= */ null, /**
 * Creates a new Query for a collection group query that matches all documents
 * within the provided collection group.
 */ function(t) {
        return new $5c04988f82cad1b3$var$nn($5c04988f82cad1b3$var$ht.emptyPath(), t);
    }(e));
}
function $5c04988f82cad1b3$export$2a111da947c407d2(t, e, ...n) {
    if (t = (0, $isbtl.getModularInstance)(t), // We allow omission of 'pathString' but explicitly prohibit passing in both
    // 'undefined' and 'null'.
    1 === arguments.length && (e = $5c04988f82cad1b3$var$st.I()), $5c04988f82cad1b3$var$wa("doc", "path", e), t instanceof $5c04988f82cad1b3$var$Aa) {
        const s = $5c04988f82cad1b3$var$ht.fromString(e, ...n);
        return $5c04988f82cad1b3$var$ga(s), new $5c04988f82cad1b3$export$6be62b059fb12175(t, /* converter= */ null, new $5c04988f82cad1b3$export$afc2e57c475b7810(s));
    }
    {
        if (!(t instanceof $5c04988f82cad1b3$export$6be62b059fb12175 || t instanceof $5c04988f82cad1b3$export$ab5a1a47940a200e)) throw new $5c04988f82cad1b3$export$8fada0bf726bf278($5c04988f82cad1b3$var$G.INVALID_ARGUMENT, "Expected first argument to collection() to be a CollectionReference, a DocumentReference or FirebaseFirestore");
        const s = t._path.child($5c04988f82cad1b3$var$ht.fromString(e, ...n));
        return $5c04988f82cad1b3$var$ga(s), new $5c04988f82cad1b3$export$6be62b059fb12175(t.firestore, t instanceof $5c04988f82cad1b3$export$ab5a1a47940a200e ? t.converter : null, new $5c04988f82cad1b3$export$afc2e57c475b7810(s));
    }
}
/**
 * Returns true if the provided references are equal.
 *
 * @param left - A reference to compare.
 * @param right - A reference to compare.
 * @returns true if the references point to the same location in the same
 * Firestore database.
 */ function $5c04988f82cad1b3$export$62a32f2da6187d11(t, e) {
    return t = (0, $isbtl.getModularInstance)(t), e = (0, $isbtl.getModularInstance)(e), (t instanceof $5c04988f82cad1b3$export$6be62b059fb12175 || t instanceof $5c04988f82cad1b3$export$ab5a1a47940a200e) && (e instanceof $5c04988f82cad1b3$export$6be62b059fb12175 || e instanceof $5c04988f82cad1b3$export$ab5a1a47940a200e) && t.firestore === e.firestore && t.path === e.path && t.converter === e.converter;
}
/**
 * Returns true if the provided queries point to the same collection and apply
 * the same constraints.
 *
 * @param left - A `Query` to compare.
 * @param right - A `Query` to compare.
 * @returns true if the references point to the same location in the same
 * Firestore database.
 */ function $5c04988f82cad1b3$export$49b1d0de6ba30f41(t, e) {
    return t = (0, $isbtl.getModularInstance)(t), e = (0, $isbtl.getModularInstance)(e), t instanceof $5c04988f82cad1b3$export$62297b13309008b2 && e instanceof $5c04988f82cad1b3$export$62297b13309008b2 && t.firestore === e.firestore && $5c04988f82cad1b3$var$dn(t._query, e._query) && t.converter === e.converter;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $5c04988f82cad1b3$var$Na {
    get isShuttingDown() {
        return this.Fc;
    }
    /**
     * Adds a new operation to the queue without waiting for it to complete (i.e.
     * we ignore the Promise result).
     */ enqueueAndForget(t) {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.enqueue(t);
    }
    enqueueAndForgetEvenWhileRestricted(t) {
        this.Gc(), // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.Qc(t);
    }
    enterRestrictedMode(t) {
        if (!this.Fc) {
            this.Fc = !0, this.Uc = t || !1;
            const e = $5c04988f82cad1b3$var$eu();
            e && "function" == typeof e.removeEventListener && e.removeEventListener("visibilitychange", this.Kc);
        }
    }
    enqueue(t) {
        if (this.Gc(), this.Fc) // Return a Promise which never resolves.
        return new Promise(()=>{});
        // Create a deferred Promise that we can return to the callee. This
        // allows us to return a "hanging Promise" only to the callee and still
        // advance the queue even when the operation is not run.
        const e = new $5c04988f82cad1b3$var$j;
        return this.Qc(()=>this.Fc && this.Uc ? Promise.resolve() : (t().then(e.resolve, e.reject), e.promise)).then(()=>e.promise);
    }
    enqueueRetryable(t) {
        this.enqueueAndForget(()=>(this.Mc.push(t), this.jc()));
    }
    /**
     * Runs the next operation from the retryable queue. If the operation fails,
     * reschedules with backoff.
     */ async jc() {
        if (0 !== this.Mc.length) {
            try {
                await this.Mc[0](), this.Mc.shift(), this.So.reset();
            } catch (t) {
                if (!$5c04988f82cad1b3$var$Ct(t)) throw t;
                // Failure will be handled by AsyncQueue
                $5c04988f82cad1b3$var$M("AsyncQueue", "Operation failed with retryable error: " + t);
            }
            this.Mc.length > 0 && // If there are additional operations, we re-schedule `retryNextOp()`.
            // This is necessary to run retryable operations that failed during
            // their initial attempt since we don't know whether they are already
            // enqueued. If, for example, `op1`, `op2`, `op3` are enqueued and `op1`
            // needs to  be re-run, we will run `op1`, `op1`, `op2` using the
            // already enqueued calls to `retryNextOp()`. `op3()` will then run in the
            // call scheduled here.
            // Since `backoffAndRun()` cancels an existing backoff and schedules a
            // new backoff on every call, there is only ever a single additional
            // operation in the queue.
            this.So.Io(()=>this.jc());
        }
    }
    Qc(t) {
        const e = this.Oc.then(()=>(this.Lc = !0, t().catch((t)=>{
                this.Bc = t, this.Lc = !1;
                const e = /**
 * Chrome includes Error.message in Error.stack. Other browsers do not.
 * This returns expected output of message + stack when available.
 * @param error - Error or FirestoreError
 */ function(t) {
                    let e = t.message || "";
                    t.stack && (e = t.stack.includes(t.message) ? t.stack : t.message + "\n" + t.stack);
                    return e;
                }(t);
                // Re-throw the error so that this.tail becomes a rejected Promise and
                // all further attempts to chain (via .then) will just short-circuit
                // and return the rejected Promise.
                throw $5c04988f82cad1b3$var$F("INTERNAL UNHANDLED ERROR: ", e), t;
            }).then((t)=>(this.Lc = !1, t))));
        return this.Oc = e, e;
    }
    enqueueAfterDelay(t, e, n) {
        this.Gc(), // Fast-forward delays for timerIds that have been overriden.
        this.qc.indexOf(t) > -1 && (e = 0);
        const s = $5c04988f82cad1b3$var$$u.createAndSchedule(this, t, e, n, (t)=>this.Wc(t));
        return this.$c.push(s), s;
    }
    Gc() {
        this.Bc && $5c04988f82cad1b3$var$L();
    }
    verifyOperationInProgress() {}
    /**
     * Waits until all currently queued tasks are finished executing. Delayed
     * operations are not run.
     */ async zc() {
        // Operations in the queue prior to draining may have enqueued additional
        // operations. Keep draining the queue until the tail is no longer advanced,
        // which indicates that no more new operations were enqueued and that all
        // operations were executed.
        let t;
        do t = this.Oc, await t;
        while (t !== this.Oc);
    }
    /**
     * For Tests: Determine if a delayed operation with a particular TimerId
     * exists.
     */ Hc(t) {
        for (const e of this.$c)if (e.timerId === t) return !0;
        return !1;
    }
    /**
     * For Tests: Runs some or all delayed operations early.
     *
     * @param lastTimerId - Delayed operations up to and including this TimerId
     * will be drained. Pass TimerId.All to run all delayed operations.
     * @returns a Promise that resolves once all operations have been run.
     */ Jc(t) {
        // Note that draining may generate more delayed ops, so we do that first.
        return this.zc().then(()=>{
            // Run ops in the same order they'd run if they ran naturally.
            this.$c.sort((t, e)=>t.targetTimeMs - e.targetTimeMs);
            for (const e of this.$c)if (e.skipDelay(), "all" /* All */  !== t && e.timerId === t) break;
            return this.zc();
        });
    }
    /**
     * For Tests: Skip all subsequent delays for a timer id.
     */ Yc(t) {
        this.qc.push(t);
    }
    /** Called once a DelayedOperation is run or canceled. */ Wc(t) {
        // NOTE: indexOf / slice are O(n), but delayedOperations is expected to be small.
        const e = this.$c.indexOf(t);
        this.$c.splice(e, 1);
    }
    constructor(){
        // The last promise in the queue.
        this.Oc = Promise.resolve(), // A list of retryable operations. Retryable operations are run in order and
        // retried with backoff.
        this.Mc = [], // Is this AsyncQueue being shut down? Once it is set to true, it will not
        // be changed again.
        this.Fc = !1, // Operations scheduled to be queued in the future. Operations are
        // automatically removed after they are run or canceled.
        this.$c = [], // visible for testing
        this.Bc = null, // Flag set while there's an outstanding AsyncQueue operation, used for
        // assertion sanity-checks.
        this.Lc = !1, // Enabled during shutdown on Safari to prevent future access to IndexedDB.
        this.Uc = !1, // List of TimerIds to fast-forward delays for.
        this.qc = [], // Backoff timer used to schedule retries for retryable operations
        this.So = new $5c04988f82cad1b3$var$su(this, "async_queue_retry" /* AsyncQueueRetry */ ), // Visibility handler that triggers an immediate retry of all retryable
        // operations. Meant to speed up recovery when we regain file system access
        // after page comes into foreground.
        this.Kc = ()=>{
            const t = $5c04988f82cad1b3$var$eu();
            t && $5c04988f82cad1b3$var$M("AsyncQueue", "Visibility state changed to " + t.visibilityState), this.So.Eo();
        };
        const t = $5c04988f82cad1b3$var$eu();
        t && "function" == typeof t.addEventListener && t.addEventListener("visibilitychange", this.Kc);
    }
}
function $5c04988f82cad1b3$var$ka(t) {
    /**
 * Returns true if obj is an object and contains at least one of the specified
 * methods.
 */ return function(t, e) {
        if ("object" != typeof t || null === t) return !1;
        const n = t;
        for (const t of e)if (t in n && "function" == typeof n[t]) return !0;
        return !1;
    }(t, [
        "next",
        "error",
        "complete"
    ]);
}
class $5c04988f82cad1b3$export$6cac12425252ec14 {
    /**
     * Registers functions to listen to bundle loading progress events.
     * @param next - Called when there is a progress update from bundle loading. Typically `next` calls occur
     *   each time a Firestore document is loaded from the bundle.
     * @param error - Called when an error occurs during bundle loading. The task aborts after reporting the
     *   error, and there should be no more updates after this.
     * @param complete - Called when the loading task is complete.
     */ onProgress(t, e, n) {
        this._progressObserver = {
            next: t,
            error: e,
            complete: n
        };
    }
    /**
     * Implements the `Promise<LoadBundleTaskProgress>.catch` interface.
     *
     * @param onRejected - Called when an error occurs during bundle loading.
     */ catch(t) {
        return this._taskCompletionResolver.promise.catch(t);
    }
    /**
     * Implements the `Promise<LoadBundleTaskProgress>.then` interface.
     *
     * @param onFulfilled - Called on the completion of the loading task with a final `LoadBundleTaskProgress` update.
     *   The update will always have its `taskState` set to `"Success"`.
     * @param onRejected - Called when an error occurs during bundle loading.
     */ then(t, e) {
        return this._taskCompletionResolver.promise.then(t, e);
    }
    /**
     * Notifies all observers that bundle loading has completed, with a provided
     * `LoadBundleTaskProgress` object.
     *
     * @private
     */ _completeWith(t) {
        this._updateProgress(t), this._progressObserver.complete && this._progressObserver.complete(), this._taskCompletionResolver.resolve(t);
    }
    /**
     * Notifies all observers that bundle loading has failed, with a provided
     * `Error` as the reason.
     *
     * @private
     */ _failWith(t) {
        this._lastProgress.taskState = "Error", this._progressObserver.next && this._progressObserver.next(this._lastProgress), this._progressObserver.error && this._progressObserver.error(t), this._taskCompletionResolver.reject(t);
    }
    /**
     * Notifies a progress update of loading a bundle.
     * @param progress - The new progress.
     *
     * @private
     */ _updateProgress(t) {
        this._lastProgress = t, this._progressObserver.next && this._progressObserver.next(t);
    }
    constructor(){
        this._progressObserver = {}, this._taskCompletionResolver = new $5c04988f82cad1b3$var$j, this._lastProgress = {
            taskState: "Running",
            totalBytes: 0,
            totalDocuments: 0,
            bytesLoaded: 0,
            documentsLoaded: 0
        };
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** DOMException error code constants. */ const $5c04988f82cad1b3$export$3e714f2ae27d2df4 = -1;
/**
 * The Cloud Firestore service interface.
 *
 * Do not call this constructor directly. Instead, use {@link getFirestore}.
 */ class $5c04988f82cad1b3$export$d0e2b3272814ce82 extends $5c04988f82cad1b3$var$Aa {
    _terminate() {
        return this._firestoreClient || // The client must be initialized to ensure that all subsequent API
        // usage throws an exception.
        $5c04988f82cad1b3$var$Ua(this), this._firestoreClient.terminate();
    }
    /** @hideconstructor */ constructor(t, e, n){
        super(t, e, n), /**
         * Whether it's a {@link Firestore} or Firestore Lite instance.
         */ this.type = "firestore", this._queue = new $5c04988f82cad1b3$var$Na, this._persistenceKey = "name" in t ? t.name : "[DEFAULT]";
    }
}
/**
 * Initializes a new instance of {@link Firestore} with the provided settings.
 * Can only be called before any other function, including
 * {@link getFirestore}. If the custom settings are empty, this function is
 * equivalent to calling {@link getFirestore}.
 *
 * @param app - The {@link @firebase/app#FirebaseApp} with which the {@link Firestore} instance will
 * be associated.
 * @param settings - A settings object to configure the {@link Firestore} instance.
 * @returns A newly initialized {@link Firestore} instance.
 */ function $5c04988f82cad1b3$export$9061557f3e3b42f9(t, e) {
    const n = (0, $iXpG9._getProvider)(t, "firestore");
    if (n.isInitialized()) {
        const t = n.getImmediate(), s = n.getOptions();
        if ((0, $isbtl.deepEqual)(s, e)) return t;
        throw new $5c04988f82cad1b3$export$8fada0bf726bf278($5c04988f82cad1b3$var$G.FAILED_PRECONDITION, "initializeFirestore() has already been called with different options. To avoid this error, call initializeFirestore() with the same options as when it was originally called, or call getFirestore() to return the already initialized instance.");
    }
    if (void 0 !== e.cacheSizeBytes && -1 !== e.cacheSizeBytes && e.cacheSizeBytes < 1048576) throw new $5c04988f82cad1b3$export$8fada0bf726bf278($5c04988f82cad1b3$var$G.INVALID_ARGUMENT, "cacheSizeBytes must be at least 1048576");
    return n.initialize({
        options: e
    });
}
/**
 * Returns the existing {@link Firestore} instance that is associated with the
 * provided {@link @firebase/app#FirebaseApp}. If no instance exists, initializes a new
 * instance with default settings.
 *
 * @param app - The {@link @firebase/app#FirebaseApp} instance that the returned {@link Firestore}
 * instance is associated with.
 * @returns The {@link Firestore} instance of the provided app.
 */ function $5c04988f82cad1b3$export$f06a05d14c3a6678(e = (0, $iXpG9.getApp)()) {
    return (0, $iXpG9._getProvider)(e, "firestore").getImmediate();
}
/**
 * @internal
 */ function $5c04988f82cad1b3$export$8da5fbea04405656(t) {
    return t._firestoreClient || $5c04988f82cad1b3$var$Ua(t), t._firestoreClient.verifyNotTerminated(), t._firestoreClient;
}
function $5c04988f82cad1b3$var$Ua(t) {
    var e;
    const n = t._freezeSettings(), s = function(t, e, n, s) {
        return new $5c04988f82cad1b3$var$ie(t, e, n, s.host, s.ssl, s.experimentalForceLongPolling, s.experimentalAutoDetectLongPolling, s.useFetchStreams);
    }(t._databaseId, (null === (e = t._app) || void 0 === e ? void 0 : e.options.appId) || "", t._persistenceKey, n);
    t._firestoreClient = new $5c04988f82cad1b3$var$zc(t._authCredentials, t._appCheckCredentials, t._queue, s);
}
/**
 * Attempts to enable persistent storage, if possible.
 *
 * Must be called before any other functions (other than
 * {@link initializeFirestore}, {@link getFirestore} or
 * {@link clearIndexedDbPersistence}.
 *
 * If this fails, `enableIndexedDbPersistence()` will reject the promise it
 * returns. Note that even after this failure, the {@link Firestore} instance will
 * remain usable, however offline persistence will be disabled.
 *
 * There are several reasons why this can fail, which can be identified by
 * the `code` on the error.
 *
 *   * failed-precondition: The app is already open in another browser tab.
 *   * unimplemented: The browser is incompatible with the offline
 *     persistence implementation.
 *
 * @param firestore - The {@link Firestore} instance to enable persistence for.
 * @param persistenceSettings - Optional settings object to configure
 * persistence.
 * @returns A `Promise` that represents successfully enabling persistent storage.
 */ function $5c04988f82cad1b3$export$cebe3b626a79c5f3(t, e) {
    $5c04988f82cad1b3$var$Xa(t = $5c04988f82cad1b3$export$572106fb5803752c(t, $5c04988f82cad1b3$export$d0e2b3272814ce82));
    const n = $5c04988f82cad1b3$export$8da5fbea04405656(t), s = t._freezeSettings(), i = new $5c04988f82cad1b3$var$qc;
    return $5c04988f82cad1b3$var$Ga(n, i, new $5c04988f82cad1b3$var$Lc(i, s.cacheSizeBytes, null == e ? void 0 : e.forceOwnership));
}
/**
 * Attempts to enable multi-tab persistent storage, if possible. If enabled
 * across all tabs, all operations share access to local persistence, including
 * shared execution of queries and latency-compensated local document updates
 * across all connected instances.
 *
 * If this fails, `enableMultiTabIndexedDbPersistence()` will reject the promise
 * it returns. Note that even after this failure, the {@link Firestore} instance will
 * remain usable, however offline persistence will be disabled.
 *
 * There are several reasons why this can fail, which can be identified by
 * the `code` on the error.
 *
 *   * failed-precondition: The app is already open in another browser tab and
 *     multi-tab is not enabled.
 *   * unimplemented: The browser is incompatible with the offline
 *     persistence implementation.
 *
 * @param firestore - The {@link Firestore} instance to enable persistence for.
 * @returns A `Promise` that represents successfully enabling persistent
 * storage.
 */ function $5c04988f82cad1b3$export$6d4c055e91302ab9(t) {
    $5c04988f82cad1b3$var$Xa(t = $5c04988f82cad1b3$export$572106fb5803752c(t, $5c04988f82cad1b3$export$d0e2b3272814ce82));
    const e = $5c04988f82cad1b3$export$8da5fbea04405656(t), n = t._freezeSettings(), s = new $5c04988f82cad1b3$var$qc;
    return $5c04988f82cad1b3$var$Ga(e, s, new $5c04988f82cad1b3$var$Uc(s, n.cacheSizeBytes));
}
/**
 * Registers both the `OfflineComponentProvider` and `OnlineComponentProvider`.
 * If the operation fails with a recoverable error (see
 * `canRecoverFromIndexedDbError()` below), the returned Promise is rejected
 * but the client remains usable.
 */ function $5c04988f82cad1b3$var$Ga(t, e, n) {
    const s = new $5c04988f82cad1b3$var$j;
    return t.asyncQueue.enqueue(async ()=>{
        try {
            await $5c04988f82cad1b3$var$Hc(t, n), await $5c04988f82cad1b3$var$Jc(t, e), s.resolve();
        } catch (t) {
            if (!/**
 * Decides whether the provided error allows us to gracefully disable
 * persistence (as opposed to crashing the client).
 */ function(t) {
                if ("FirebaseError" === t.name) return t.code === $5c04988f82cad1b3$var$G.FAILED_PRECONDITION || t.code === $5c04988f82cad1b3$var$G.UNIMPLEMENTED;
                if ("undefined" != typeof DOMException && t instanceof DOMException) // There are a few known circumstances where we can open IndexedDb but
                // trying to read/write will fail (e.g. quota exceeded). For
                // well-understood cases, we attempt to detect these and then gracefully
                // fall back to memory persistence.
                // NOTE: Rather than continue to add to this list, we could decide to
                // always fall back, with the risk that we might accidentally hide errors
                // representing actual SDK bugs.
                // When the browser is out of quota we could get either quota exceeded
                // or an aborted error depending on whether the error happened during
                // schema migration.
                return 22 === t.code || 20 === t.code || // Firefox Private Browsing mode disables IndexedDb and returns
                // INVALID_STATE for any usage.
                11 === t.code;
                return !0;
            }(t)) throw t;
            console.warn("Error enabling offline persistence. Falling back to persistence disabled: " + t), s.reject(t);
        }
    }).then(()=>s.promise);
}
function $5c04988f82cad1b3$export$b4f5899b4e28cf7b(t) {
    if (t._initialized && !t._terminated) throw new $5c04988f82cad1b3$export$8fada0bf726bf278($5c04988f82cad1b3$var$G.FAILED_PRECONDITION, "Persistence can only be cleared before a Firestore instance is initialized or after it is terminated.");
    const e = new $5c04988f82cad1b3$var$j;
    return t._queue.enqueueAndForgetEvenWhileRestricted(async ()=>{
        try {
            await async function(t) {
                if (!$5c04988f82cad1b3$var$Vt.V()) return Promise.resolve();
                const e = t + "main";
                await $5c04988f82cad1b3$var$Vt.delete(e);
            }($5c04988f82cad1b3$var$Io(t._databaseId, t._persistenceKey)), e.resolve();
        } catch (t) {
            e.reject(t);
        }
    }), e.promise;
}
/**
 * Waits until all currently pending writes for the active user have been
 * acknowledged by the backend.
 *
 * The returned promise resolves immediately if there are no outstanding writes.
 * Otherwise, the promise waits for all previously issued writes (including
 * those written in a previous app session), but it does not wait for writes
 * that were added after the function is called. If you want to wait for
 * additional writes, call `waitForPendingWrites()` again.
 *
 * Any outstanding `waitForPendingWrites()` promises are rejected during user
 * changes.
 *
 * @returns A `Promise` which resolves when all currently pending writes have been
 * acknowledged by the backend.
 */ function $5c04988f82cad1b3$export$50b5113fd6653025(t) {
    return function(t) {
        const e = new $5c04988f82cad1b3$var$j;
        return t.asyncQueue.enqueueAndForget(async ()=>$5c04988f82cad1b3$var$mc(await $5c04988f82cad1b3$var$na(t), e)), e.promise;
    }($5c04988f82cad1b3$export$8da5fbea04405656(t = $5c04988f82cad1b3$export$572106fb5803752c(t, $5c04988f82cad1b3$export$d0e2b3272814ce82)));
}
/**
 * Re-enables use of the network for this {@link Firestore} instance after a prior
 * call to {@link disableNetwork}.
 *
 * @returns A `Promise` that is resolved once the network has been enabled.
 */ function $5c04988f82cad1b3$export$ee6bdee8287ecc5f(t) {
    return $5c04988f82cad1b3$var$ia($5c04988f82cad1b3$export$8da5fbea04405656(t = $5c04988f82cad1b3$export$572106fb5803752c(t, $5c04988f82cad1b3$export$d0e2b3272814ce82)));
}
/**
 * Disables network usage for this instance. It can be re-enabled via {@link
 * enableNetwork}. While the network is disabled, any snapshot listeners,
 * `getDoc()` or `getDocs()` calls will return results from cache, and any write
 * operations will be queued until the network is restored.
 *
 * @returns A `Promise` that is resolved once the network has been disabled.
 */ function $5c04988f82cad1b3$export$f35b708ad73d52eb(t) {
    return $5c04988f82cad1b3$var$ra($5c04988f82cad1b3$export$8da5fbea04405656(t = $5c04988f82cad1b3$export$572106fb5803752c(t, $5c04988f82cad1b3$export$d0e2b3272814ce82)));
}
/**
 * Terminates the provided {@link Firestore} instance.
 *
 * After calling `terminate()` only the `clearIndexedDbPersistence()` function
 * may be used. Any other function will throw a `FirestoreError`.
 *
 * To restart after termination, create a new instance of FirebaseFirestore with
 * {@link getFirestore}.
 *
 * Termination does not cancel any pending writes, and any promises that are
 * awaiting a response from the server will not be resolved. If you have
 * persistence enabled, the next time you start this instance, it will resume
 * sending these writes to the server.
 *
 * Note: Under normal circumstances, calling `terminate()` is not required. This
 * function is useful only when you want to force this instance to release all
 * of its resources or in combination with `clearIndexedDbPersistence()` to
 * ensure that all local state is destroyed between test runs.
 *
 * @returns A `Promise` that is resolved when the instance has been successfully
 * terminated.
 */ function $5c04988f82cad1b3$export$9aff22d1ec357a14(t) {
    return (0, $iXpG9._removeServiceInstance)(t.app, "firestore"), t._delete();
}
/**
 * Loads a Firestore bundle into the local cache.
 *
 * @param firestore - The {@link Firestore} instance to load bundles for.
 * @param bundleData - An object representing the bundle to be loaded. Valid
 * objects are `ArrayBuffer`, `ReadableStream<Uint8Array>` or `string`.
 *
 * @returns A `LoadBundleTask` object, which notifies callers with progress
 * updates, and completion or error events. It can be used as a
 * `Promise<LoadBundleTaskProgress>`.
 */ function $5c04988f82cad1b3$export$4b8b93c690c9810b(t, e) {
    const n = $5c04988f82cad1b3$export$8da5fbea04405656(t = $5c04988f82cad1b3$export$572106fb5803752c(t, $5c04988f82cad1b3$export$d0e2b3272814ce82)), s = new $5c04988f82cad1b3$export$6cac12425252ec14;
    return $5c04988f82cad1b3$var$fa(n, t._databaseId, e, s), s;
}
/**
 * Reads a Firestore {@link Query} from local cache, identified by the given
 * name.
 *
 * The named queries are packaged  into bundles on the server side (along
 * with resulting documents), and loaded to local cache using `loadBundle`. Once
 * in local cache, use this method to extract a {@link Query} by name.
 *
 * @param firestore - The {@link Firestore} instance to read the query from.
 * @param name - The name of the query.
 * @returns A `Promise` that is resolved with the Query or `null`.
 */ function $5c04988f82cad1b3$export$169d2c6fe0f7f4ea(t, e) {
    return $5c04988f82cad1b3$var$da($5c04988f82cad1b3$export$8da5fbea04405656(t = $5c04988f82cad1b3$export$572106fb5803752c(t, $5c04988f82cad1b3$export$d0e2b3272814ce82)), e).then((e)=>e ? new $5c04988f82cad1b3$export$62297b13309008b2(t, null, e.query) : null);
}
function $5c04988f82cad1b3$var$Xa(t) {
    if (t._initialized || t._terminated) throw new $5c04988f82cad1b3$export$8fada0bf726bf278($5c04988f82cad1b3$var$G.FAILED_PRECONDITION, "Firestore has already been started and persistence can no longer be enabled. You can only enable persistence before calling any other methods on a Firestore object.");
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A `FieldPath` refers to a field in a document. The path may consist of a
 * single field name (referring to a top-level field in the document), or a
 * list of field names (referring to a nested field in the document).
 *
 * Create a `FieldPath` by providing field names. If more than one field
 * name is provided, the path will point to a nested field in a document.
 */ class $5c04988f82cad1b3$export$a1a8fea822d17659 {
    /**
     * Returns true if this `FieldPath` is equal to the provided one.
     *
     * @param other - The `FieldPath` to compare against.
     * @returns true if this `FieldPath` is equal to the provided one.
     */ isEqual(t) {
        return this._internalPath.isEqual(t._internalPath);
    }
    /**
     * Creates a `FieldPath` from the provided field names. If more than one field
     * name is provided, the path will point to a nested field in a document.
     *
     * @param fieldNames - A list of field names.
     */ constructor(...t){
        for(let e = 0; e < t.length; ++e)if (0 === t[e].length) throw new $5c04988f82cad1b3$export$8fada0bf726bf278($5c04988f82cad1b3$var$G.INVALID_ARGUMENT, "Invalid field name at argument $(i + 1). Field names must not be empty.");
        this._internalPath = new $5c04988f82cad1b3$export$b7871852b967eaf1(t);
    }
}
/**
 * Returns a special sentinel `FieldPath` to refer to the ID of a document.
 * It can be used in queries to sort or filter by the document ID.
 */ function $5c04988f82cad1b3$export$bf6e62266977b8eb() {
    return new $5c04988f82cad1b3$export$a1a8fea822d17659("__name__");
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An immutable object representing an array of bytes.
 */ class $5c04988f82cad1b3$export$9f55f2e2bf8c2fc1 {
    /**
     * Creates a new `Bytes` object from the given Base64 string, converting it to
     * bytes.
     *
     * @param base64 - The Base64 string used to create the `Bytes` object.
     */ static fromBase64String(t) {
        try {
            return new $5c04988f82cad1b3$export$9f55f2e2bf8c2fc1($5c04988f82cad1b3$var$Jt.fromBase64String(t));
        } catch (t) {
            throw new $5c04988f82cad1b3$export$8fada0bf726bf278($5c04988f82cad1b3$var$G.INVALID_ARGUMENT, "Failed to construct data from Base64 string: " + t);
        }
    }
    /**
     * Creates a new `Bytes` object from the given Uint8Array.
     *
     * @param array - The Uint8Array used to create the `Bytes` object.
     */ static fromUint8Array(t) {
        return new $5c04988f82cad1b3$export$9f55f2e2bf8c2fc1($5c04988f82cad1b3$var$Jt.fromUint8Array(t));
    }
    /**
     * Returns the underlying bytes as a Base64-encoded string.
     *
     * @returns The Base64-encoded string created from the `Bytes` object.
     */ toBase64() {
        return this._byteString.toBase64();
    }
    /**
     * Returns the underlying bytes in a new `Uint8Array`.
     *
     * @returns The Uint8Array created from the `Bytes` object.
     */ toUint8Array() {
        return this._byteString.toUint8Array();
    }
    /**
     * Returns a string representation of the `Bytes` object.
     *
     * @returns A string representation of the `Bytes` object.
     */ toString() {
        return "Bytes(base64: " + this.toBase64() + ")";
    }
    /**
     * Returns true if this `Bytes` object is equal to the provided one.
     *
     * @param other - The `Bytes` object to compare against.
     * @returns true if this `Bytes` object is equal to the provided one.
     */ isEqual(t) {
        return this._byteString.isEqual(t._byteString);
    }
    /** @hideconstructor */ constructor(t){
        this._byteString = t;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Sentinel values that can be used when writing document fields with `set()`
 * or `update()`.
 */ class $5c04988f82cad1b3$export$c58bc8ee7ecc248d {
    /**
     * @param _methodName - The public API endpoint that returns this class.
     * @hideconstructor
     */ constructor(t){
        this._methodName = t;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An immutable object representing a geographic location in Firestore. The
 * location is represented as latitude/longitude pair.
 *
 * Latitude values are in the range of [-90, 90].
 * Longitude values are in the range of [-180, 180].
 */ class $5c04988f82cad1b3$export$f9f719d1b6419c4 {
    /**
     * The latitude of this `GeoPoint` instance.
     */ get latitude() {
        return this._lat;
    }
    /**
     * The longitude of this `GeoPoint` instance.
     */ get longitude() {
        return this._long;
    }
    /**
     * Returns true if this `GeoPoint` is equal to the provided one.
     *
     * @param other - The `GeoPoint` to compare against.
     * @returns true if this `GeoPoint` is equal to the provided one.
     */ isEqual(t) {
        return this._lat === t._lat && this._long === t._long;
    }
    /** Returns a JSON-serializable representation of this GeoPoint. */ toJSON() {
        return {
            latitude: this._lat,
            longitude: this._long
        };
    }
    /**
     * Actually private to JS consumers of our API, so this function is prefixed
     * with an underscore.
     */ _compareTo(t) {
        return $5c04988f82cad1b3$var$it(this._lat, t._lat) || $5c04988f82cad1b3$var$it(this._long, t._long);
    }
    /**
     * Creates a new immutable `GeoPoint` object with the provided latitude and
     * longitude values.
     * @param latitude - The latitude as number between -90 and 90.
     * @param longitude - The longitude as number between -180 and 180.
     */ constructor(t, e){
        if (!isFinite(t) || t < -90 || t > 90) throw new $5c04988f82cad1b3$export$8fada0bf726bf278($5c04988f82cad1b3$var$G.INVALID_ARGUMENT, "Latitude must be a number between -90 and 90, but was: " + t);
        if (!isFinite(e) || e < -180 || e > 180) throw new $5c04988f82cad1b3$export$8fada0bf726bf278($5c04988f82cad1b3$var$G.INVALID_ARGUMENT, "Longitude must be a number between -180 and 180, but was: " + e);
        this._lat = t, this._long = e;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $5c04988f82cad1b3$var$ih = /^__.*__$/;
/** The result of parsing document data (e.g. for a setData call). */ class $5c04988f82cad1b3$var$rh {
    toMutation(t, e) {
        return null !== this.fieldMask ? new $5c04988f82cad1b3$var$Wn(t, this.data, this.fieldMask, e, this.fieldTransforms) : new $5c04988f82cad1b3$var$jn(t, this.data, e, this.fieldTransforms);
    }
    constructor(t, e, n){
        this.data = t, this.fieldMask = e, this.fieldTransforms = n;
    }
}
/** The result of parsing "update" data (i.e. for an updateData call). */ class $5c04988f82cad1b3$var$oh {
    toMutation(t, e) {
        return new $5c04988f82cad1b3$var$Wn(t, this.data, this.fieldMask, e, this.fieldTransforms);
    }
    constructor(t, // The fieldMask does not include document transforms.
    e, n){
        this.data = t, this.fieldMask = e, this.fieldTransforms = n;
    }
}
function $5c04988f82cad1b3$var$uh(t) {
    switch(t){
        case 0 /* Set */ :
        // fall through
        case 2 /* MergeSet */ :
        // fall through
        case 1 /* Update */ :
            return !0;
        case 3 /* Argument */ :
        case 4 /* ArrayArgument */ :
            return !1;
        default:
            throw $5c04988f82cad1b3$var$L();
    }
}
/** A "context" object passed around while parsing user data. */ class $5c04988f82cad1b3$var$ch {
    get path() {
        return this.settings.path;
    }
    get Zc() {
        return this.settings.Zc;
    }
    /** Returns a new context with the specified settings overwritten. */ ta(t) {
        return new $5c04988f82cad1b3$var$ch(Object.assign(Object.assign({}, this.settings), t), this.databaseId, this.wt, this.ignoreUndefinedProperties, this.fieldTransforms, this.fieldMask);
    }
    ea(t) {
        var e;
        const n = null === (e = this.path) || void 0 === e ? void 0 : e.child(t), s = this.ta({
            path: n,
            na: !1
        });
        return s.sa(t), s;
    }
    ia(t) {
        var e;
        const n = null === (e = this.path) || void 0 === e ? void 0 : e.child(t), s = this.ta({
            path: n,
            na: !1
        });
        return s.Xc(), s;
    }
    ra(t) {
        // TODO(b/34871131): We don't support array paths right now; so make path
        // undefined.
        return this.ta({
            path: void 0,
            na: !0
        });
    }
    oa(t) {
        return $5c04988f82cad1b3$var$Vh(t, this.settings.methodName, this.settings.ua || !1, this.path, this.settings.ca);
    }
    /** Returns 'true' if 'fieldPath' was traversed when creating this context. */ contains(t) {
        return void 0 !== this.fieldMask.find((e)=>t.isPrefixOf(e)) || void 0 !== this.fieldTransforms.find((e)=>t.isPrefixOf(e.field));
    }
    Xc() {
        // TODO(b/34871131): Remove null check once we have proper paths for fields
        // within arrays.
        if (this.path) for(let t = 0; t < this.path.length; t++)this.sa(this.path.get(t));
    }
    sa(t) {
        if (0 === t.length) throw this.oa("Document fields must not be empty");
        if ($5c04988f82cad1b3$var$uh(this.Zc) && $5c04988f82cad1b3$var$ih.test(t)) throw this.oa('Document fields cannot begin and end with "__"');
    }
    /**
     * Initializes a ParseContext with the given source and path.
     *
     * @param settings - The settings for the parser.
     * @param databaseId - The database ID of the Firestore instance.
     * @param serializer - The serializer to use to generate the Value proto.
     * @param ignoreUndefinedProperties - Whether to ignore undefined properties
     * rather than throw.
     * @param fieldTransforms - A mutable list of field transforms encountered
     * while parsing the data.
     * @param fieldMask - A mutable list of field paths encountered while parsing
     * the data.
     *
     * TODO(b/34871131): We don't support array paths right now, so path can be
     * null to indicate the context represents any location within an array (in
     * which case certain features will not work and errors will be somewhat
     * compromised).
     */ constructor(t, e, n, s, i, r){
        this.settings = t, this.databaseId = e, this.wt = n, this.ignoreUndefinedProperties = s, // Minor hack: If fieldTransforms is undefined, we assume this is an
        // external call and we need to validate the entire path.
        void 0 === i && this.Xc(), this.fieldTransforms = i || [], this.fieldMask = r || [];
    }
}
/**
 * Helper for parsing raw user input (provided via the API) into internal model
 * classes.
 */ class $5c04988f82cad1b3$var$ah {
    /** Creates a new top-level parse context. */ aa(t, e, n, s = !1) {
        return new $5c04988f82cad1b3$var$ch({
            Zc: t,
            methodName: e,
            ca: n,
            path: $5c04988f82cad1b3$export$b7871852b967eaf1.emptyPath(),
            na: !1,
            ua: s
        }, this.databaseId, this.wt, this.ignoreUndefinedProperties);
    }
    constructor(t, e, n){
        this.databaseId = t, this.ignoreUndefinedProperties = e, this.wt = n || $5c04988f82cad1b3$var$nu(t);
    }
}
function $5c04988f82cad1b3$var$hh(t) {
    const e = t._freezeSettings(), n = $5c04988f82cad1b3$var$nu(t._databaseId);
    return new $5c04988f82cad1b3$var$ah(t._databaseId, !!e.ignoreUndefinedProperties, n);
}
/** Parse document data from a set() call. */ function $5c04988f82cad1b3$var$lh(t, e, n, s, i, r = {}) {
    const o = t.aa(r.merge || r.mergeFields ? 2 /* MergeSet */  : 0 /* Set */ , e, n, i);
    $5c04988f82cad1b3$var$Rh("Data must be an object, but it was:", o, s);
    const u = $5c04988f82cad1b3$var$Eh(s, o);
    let c, a;
    if (r.merge) c = new $5c04988f82cad1b3$var$zt(o.fieldMask), a = o.fieldTransforms;
    else if (r.mergeFields) {
        const t = [];
        for (const s of r.mergeFields){
            const i = $5c04988f82cad1b3$var$bh(e, s, n);
            if (!o.contains(i)) throw new $5c04988f82cad1b3$export$8fada0bf726bf278($5c04988f82cad1b3$var$G.INVALID_ARGUMENT, `Field '${i}' is specified in your field mask but missing from your input data.`);
            $5c04988f82cad1b3$var$Sh(t, i) || t.push(i);
        }
        c = new $5c04988f82cad1b3$var$zt(t), a = o.fieldTransforms.filter((t)=>c.covers(t.field));
    } else c = null, a = o.fieldTransforms;
    return new $5c04988f82cad1b3$var$rh(new $5c04988f82cad1b3$var$De(u), c, a);
}
class $5c04988f82cad1b3$var$fh extends $5c04988f82cad1b3$export$c58bc8ee7ecc248d {
    _toFieldTransform(t) {
        if (2 /* MergeSet */  !== t.Zc) throw 1 /* Update */  === t.Zc ? t.oa(`${this._methodName}() can only appear at the top level of your update data`) : t.oa(`${this._methodName}() cannot be used with set() unless you pass {merge:true}`);
        // No transform to add for a delete, but we need to add it to our
        // fieldMask so it gets deleted.
        return t.fieldMask.push(t.path), null;
    }
    isEqual(t) {
        return t instanceof $5c04988f82cad1b3$var$fh;
    }
}
/**
 * Creates a child context for parsing SerializableFieldValues.
 *
 * This is different than calling `ParseContext.contextWith` because it keeps
 * the fieldTransforms and fieldMask separate.
 *
 * The created context has its `dataSource` set to `UserDataSource.Argument`.
 * Although these values are used with writes, any elements in these FieldValues
 * are not considered writes since they cannot contain any FieldValue sentinels,
 * etc.
 *
 * @param fieldValue - The sentinel FieldValue for which to create a child
 *     context.
 * @param context - The parent context.
 * @param arrayElement - Whether or not the FieldValue has an array.
 */ function $5c04988f82cad1b3$var$dh(t, e, n) {
    return new $5c04988f82cad1b3$var$ch({
        Zc: 3 /* Argument */ ,
        ca: e.settings.ca,
        methodName: t._methodName,
        na: n
    }, e.databaseId, e.wt, e.ignoreUndefinedProperties);
}
class $5c04988f82cad1b3$var$_h extends $5c04988f82cad1b3$export$c58bc8ee7ecc248d {
    _toFieldTransform(t) {
        return new $5c04988f82cad1b3$var$On(t.path, new $5c04988f82cad1b3$var$vn);
    }
    isEqual(t) {
        return t instanceof $5c04988f82cad1b3$var$_h;
    }
}
class $5c04988f82cad1b3$var$wh extends $5c04988f82cad1b3$export$c58bc8ee7ecc248d {
    _toFieldTransform(t) {
        const e = $5c04988f82cad1b3$var$dh(this, t, /*array=*/ !0), n = this.ha.map((t)=>$5c04988f82cad1b3$var$Th(t, e)), s = new $5c04988f82cad1b3$var$Vn(n);
        return new $5c04988f82cad1b3$var$On(t.path, s);
    }
    isEqual(t) {
        // TODO(mrschmidt): Implement isEquals
        return this === t;
    }
    constructor(t, e){
        super(t), this.ha = e;
    }
}
class $5c04988f82cad1b3$var$mh extends $5c04988f82cad1b3$export$c58bc8ee7ecc248d {
    _toFieldTransform(t) {
        const e = $5c04988f82cad1b3$var$dh(this, t, /*array=*/ !0), n = this.ha.map((t)=>$5c04988f82cad1b3$var$Th(t, e)), s = new $5c04988f82cad1b3$var$Dn(n);
        return new $5c04988f82cad1b3$var$On(t.path, s);
    }
    isEqual(t) {
        // TODO(mrschmidt): Implement isEquals
        return this === t;
    }
    constructor(t, e){
        super(t), this.ha = e;
    }
}
class $5c04988f82cad1b3$var$gh extends $5c04988f82cad1b3$export$c58bc8ee7ecc248d {
    _toFieldTransform(t) {
        const e = new $5c04988f82cad1b3$var$xn(t.wt, $5c04988f82cad1b3$var$En(t.wt, this.la));
        return new $5c04988f82cad1b3$var$On(t.path, e);
    }
    isEqual(t) {
        // TODO(mrschmidt): Implement isEquals
        return this === t;
    }
    constructor(t, e){
        super(t), this.la = e;
    }
}
/** Parse update data from an update() call. */ function $5c04988f82cad1b3$var$yh(t, e, n, s) {
    const i = t.aa(1 /* Update */ , e, n);
    $5c04988f82cad1b3$var$Rh("Data must be an object, but it was:", i, s);
    const r = [], o = $5c04988f82cad1b3$var$De.empty();
    $5c04988f82cad1b3$var$Lt(s, (t, s)=>{
        const u = $5c04988f82cad1b3$var$vh(e, t, n);
        // For Compat types, we have to "extract" the underlying types before
        // performing validation.
        s = (0, $isbtl.getModularInstance)(s);
        const c = i.ia(u);
        if (s instanceof $5c04988f82cad1b3$var$fh) // Add it to the field mask, but don't add anything to updateData.
        r.push(u);
        else {
            const t = $5c04988f82cad1b3$var$Th(s, c);
            null != t && (r.push(u), o.set(u, t));
        }
    });
    const u = new $5c04988f82cad1b3$var$zt(r);
    return new $5c04988f82cad1b3$var$oh(o, u, i.fieldTransforms);
}
/** Parse update data from a list of field/value arguments. */ function $5c04988f82cad1b3$var$ph(t, e, n, s, i, r) {
    const o = t.aa(1 /* Update */ , e, n), u = [
        $5c04988f82cad1b3$var$bh(e, s, n)
    ], c = [
        i
    ];
    if (r.length % 2 != 0) throw new $5c04988f82cad1b3$export$8fada0bf726bf278($5c04988f82cad1b3$var$G.INVALID_ARGUMENT, `Function ${e}() needs to be called with an even number of arguments that alternate between field names and values.`);
    for(let t = 0; t < r.length; t += 2)u.push($5c04988f82cad1b3$var$bh(e, r[t])), c.push(r[t + 1]);
    const a = [], h = $5c04988f82cad1b3$var$De.empty();
    // We iterate in reverse order to pick the last value for a field if the
    // user specified the field multiple times.
    for(let t = u.length - 1; t >= 0; --t)if (!$5c04988f82cad1b3$var$Sh(a, u[t])) {
        const e = u[t];
        let n = c[t];
        // For Compat types, we have to "extract" the underlying types before
        // performing validation.
        n = (0, $isbtl.getModularInstance)(n);
        const s = o.ia(e);
        if (n instanceof $5c04988f82cad1b3$var$fh) // Add it to the field mask, but don't add anything to updateData.
        a.push(e);
        else {
            const t = $5c04988f82cad1b3$var$Th(n, s);
            null != t && (a.push(e), h.set(e, t));
        }
    }
    const l = new $5c04988f82cad1b3$var$zt(a);
    return new $5c04988f82cad1b3$var$oh(h, l, o.fieldTransforms);
}
/**
 * Parse a "query value" (e.g. value in a where filter or a value in a cursor
 * bound).
 *
 * @param allowArrays - Whether the query value is an array that may directly
 * contain additional arrays (e.g. the operand of an `in` query).
 */ function $5c04988f82cad1b3$var$Ih(t, e, n, s = !1) {
    return $5c04988f82cad1b3$var$Th(n, t.aa(s ? 4 /* ArrayArgument */  : 3 /* Argument */ , e));
}
/**
 * Parses user data to Protobuf Values.
 *
 * @param input - Data to be parsed.
 * @param context - A context object representing the current path being parsed,
 * the source of the data being parsed, etc.
 * @returns The parsed value, or null if the value was a FieldValue sentinel
 * that should not be included in the resulting parsed data.
 */ function $5c04988f82cad1b3$var$Th(t, e) {
    if ($5c04988f82cad1b3$var$Ah(// Unwrap the API type from the Compat SDK. This will return the API type
    // from firestore-exp.
    t = (0, $isbtl.getModularInstance)(t))) return $5c04988f82cad1b3$var$Rh("Unsupported field value:", e, t), $5c04988f82cad1b3$var$Eh(t, e);
    if (t instanceof $5c04988f82cad1b3$export$c58bc8ee7ecc248d) // FieldValues usually parse into transforms (except deleteField())
    // in which case we do not want to include this field in our parsed data
    // (as doing so will overwrite the field directly prior to the transform
    // trying to transform it). So we don't add this location to
    // context.fieldMask and we return null as our parsing result.
    /**
 * "Parses" the provided FieldValueImpl, adding any necessary transforms to
 * context.fieldTransforms.
 */ return function(t, e) {
        // Sentinels are only supported with writes, and not within arrays.
        if (!$5c04988f82cad1b3$var$uh(e.Zc)) throw e.oa(`${t._methodName}() can only be used with update() and set()`);
        if (!e.path) throw e.oa(`${t._methodName}() is not currently supported inside arrays`);
        const n = t._toFieldTransform(e);
        n && e.fieldTransforms.push(n);
    }(t, e), null;
    if (void 0 === t && e.ignoreUndefinedProperties) // If the input is undefined it can never participate in the fieldMask, so
    // don't handle this below. If `ignoreUndefinedProperties` is false,
    // `parseScalarValue` will reject an undefined value.
    return null;
    if (// If context.path is null we are inside an array and we don't support
    // field mask paths more granular than the top-level array.
    e.path && e.fieldMask.push(e.path), t instanceof Array) {
        // TODO(b/34871131): Include the path containing the array in the error
        // message.
        // In the case of IN queries, the parsed data is an array (representing
        // the set of values to be included for the IN query) that may directly
        // contain additional arrays (each representing an individual field
        // value), so we disable this validation.
        if (e.settings.na && 4 /* ArrayArgument */  !== e.Zc) throw e.oa("Nested arrays are not supported");
        return function(t, e) {
            const n = [];
            let s = 0;
            for (const i of t){
                let t = $5c04988f82cad1b3$var$Th(i, e.ra(s));
                null == t && // Just include nulls in the array for fields being replaced with a
                // sentinel.
                (t = {
                    nullValue: "NULL_VALUE"
                }), n.push(t), s++;
            }
            return {
                arrayValue: {
                    values: n
                }
            };
        }(t, e);
    }
    return function(t, e) {
        if (null === (t = (0, $isbtl.getModularInstance)(t))) return {
            nullValue: "NULL_VALUE"
        };
        if ("number" == typeof t) return $5c04988f82cad1b3$var$En(e.wt, t);
        if ("boolean" == typeof t) return {
            booleanValue: t
        };
        if ("string" == typeof t) return {
            stringValue: t
        };
        if (t instanceof Date) {
            const n = $5c04988f82cad1b3$export$d9bcbd5e1ff81430.fromDate(t);
            return {
                timestampValue: $5c04988f82cad1b3$var$Ds(e.wt, n)
            };
        }
        if (t instanceof $5c04988f82cad1b3$export$d9bcbd5e1ff81430) {
            // Firestore backend truncates precision down to microseconds. To ensure
            // offline mode works the same with regards to truncation, perform the
            // truncation immediately without waiting for the backend to do that.
            const n = new $5c04988f82cad1b3$export$d9bcbd5e1ff81430(t.seconds, 1e3 * Math.floor(t.nanoseconds / 1e3));
            return {
                timestampValue: $5c04988f82cad1b3$var$Ds(e.wt, n)
            };
        }
        if (t instanceof $5c04988f82cad1b3$export$f9f719d1b6419c4) return {
            geoPointValue: {
                latitude: t.latitude,
                longitude: t.longitude
            }
        };
        if (t instanceof $5c04988f82cad1b3$export$9f55f2e2bf8c2fc1) return {
            bytesValue: $5c04988f82cad1b3$var$Cs(e.wt, t._byteString)
        };
        if (t instanceof $5c04988f82cad1b3$export$6be62b059fb12175) {
            const n = e.databaseId, s = t.firestore._databaseId;
            if (!s.isEqual(n)) throw e.oa(`Document reference is for database ${s.projectId}/${s.database} but should be for database ${n.projectId}/${n.database}`);
            return {
                referenceValue: $5c04988f82cad1b3$var$ks(t.firestore._databaseId || e.databaseId, t._key.path)
            };
        }
        throw e.oa(`Unsupported field value: ${$5c04988f82cad1b3$var$pa(t)}`);
    }(t, e);
}
function $5c04988f82cad1b3$var$Eh(t, e) {
    const n = {};
    return $5c04988f82cad1b3$var$Ut(t) ? // If we encounter an empty object, we explicitly add it to the update
    // mask to ensure that the server creates a map entry.
    e.path && e.path.length > 0 && e.fieldMask.push(e.path) : $5c04988f82cad1b3$var$Lt(t, (t, s)=>{
        const i = $5c04988f82cad1b3$var$Th(s, e.ea(t));
        null != i && (n[t] = i);
    }), {
        mapValue: {
            fields: n
        }
    };
}
function $5c04988f82cad1b3$var$Ah(t) {
    return !("object" != typeof t || null === t || t instanceof Array || t instanceof Date || t instanceof $5c04988f82cad1b3$export$d9bcbd5e1ff81430 || t instanceof $5c04988f82cad1b3$export$f9f719d1b6419c4 || t instanceof $5c04988f82cad1b3$export$9f55f2e2bf8c2fc1 || t instanceof $5c04988f82cad1b3$export$6be62b059fb12175 || t instanceof $5c04988f82cad1b3$export$c58bc8ee7ecc248d);
}
function $5c04988f82cad1b3$var$Rh(t, e, n) {
    if (!$5c04988f82cad1b3$var$Ah(n) || !function(t) {
        return "object" == typeof t && null !== t && (Object.getPrototypeOf(t) === Object.prototype || null === Object.getPrototypeOf(t));
    }(n)) {
        const s = $5c04988f82cad1b3$var$pa(n);
        throw "an object" === s ? e.oa(t + " a custom object") : e.oa(t + " " + s);
    }
}
/**
 * Helper that calls fromDotSeparatedString() but wraps any error thrown.
 */ function $5c04988f82cad1b3$var$bh(t, e, n) {
    if (// If required, replace the FieldPath Compat class with with the firestore-exp
    // FieldPath.
    (e = (0, $isbtl.getModularInstance)(e)) instanceof $5c04988f82cad1b3$export$a1a8fea822d17659) return e._internalPath;
    if ("string" == typeof e) return $5c04988f82cad1b3$var$vh(t, e);
    throw $5c04988f82cad1b3$var$Vh("Field path arguments must be of type string or ", t, /* hasConverter= */ !1, /* path= */ void 0, n);
}
/**
 * Matches any characters in a field path string that are reserved.
 */ const $5c04988f82cad1b3$var$Ph = new RegExp("[~\\*/\\[\\]]");
/**
 * Wraps fromDotSeparatedString with an error message about the method that
 * was thrown.
 * @param methodName - The publicly visible method name
 * @param path - The dot-separated string form of a field path which will be
 * split on dots.
 * @param targetDoc - The document against which the field path will be
 * evaluated.
 */ function $5c04988f82cad1b3$var$vh(t, e, n) {
    if (e.search($5c04988f82cad1b3$var$Ph) >= 0) throw $5c04988f82cad1b3$var$Vh(`Invalid field path (${e}). Paths must not contain '~', '*', '/', '[', or ']'`, t, /* hasConverter= */ !1, /* path= */ void 0, n);
    try {
        return new $5c04988f82cad1b3$export$a1a8fea822d17659(...e.split("."))._internalPath;
    } catch (s) {
        throw $5c04988f82cad1b3$var$Vh(`Invalid field path (${e}). Paths must not be empty, begin with '.', end with '.', or contain '..'`, t, /* hasConverter= */ !1, /* path= */ void 0, n);
    }
}
function $5c04988f82cad1b3$var$Vh(t, e, n, s, i) {
    const r = s && !s.isEmpty(), o = void 0 !== i;
    let u = `Function ${e}() called with invalid data`;
    n && (u += " (via `toFirestore()`)"), u += ". ";
    let c = "";
    return (r || o) && (c += " (found", r && (c += ` in field ${s}`), o && (c += ` in document ${i}`), c += ")"), new $5c04988f82cad1b3$export$8fada0bf726bf278($5c04988f82cad1b3$var$G.INVALID_ARGUMENT, u + t + c);
}
/** Checks `haystack` if FieldPath `needle` is present. Runs in O(n). */ function $5c04988f82cad1b3$var$Sh(t, e) {
    return t.some((t)=>t.isEqual(e));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A `DocumentSnapshot` contains data read from a document in your Firestore
 * database. The data can be extracted with `.data()` or `.get(<field>)` to
 * get a specific field.
 *
 * For a `DocumentSnapshot` that points to a non-existing document, any data
 * access will return 'undefined'. You can use the `exists()` method to
 * explicitly verify a document's existence.
 */ class $5c04988f82cad1b3$var$Dh {
    /** Property of the `DocumentSnapshot` that provides the document's ID. */ get id() {
        return this._key.path.lastSegment();
    }
    /**
     * The `DocumentReference` for the document included in the `DocumentSnapshot`.
     */ get ref() {
        return new $5c04988f82cad1b3$export$6be62b059fb12175(this._firestore, this._converter, this._key);
    }
    /**
     * Signals whether or not the document at the snapshot's location exists.
     *
     * @returns true if the document exists.
     */ exists() {
        return null !== this._document;
    }
    /**
     * Retrieves all fields in the document as an `Object`. Returns `undefined` if
     * the document doesn't exist.
     *
     * @returns An `Object` containing all fields in the document or `undefined`
     * if the document doesn't exist.
     */ data() {
        if (this._document) {
            if (this._converter) {
                // We only want to use the converter and create a new DocumentSnapshot
                // if a converter has been provided.
                const t = new $5c04988f82cad1b3$var$Ch(this._firestore, this._userDataWriter, this._key, this._document, /* converter= */ null);
                return this._converter.fromFirestore(t);
            }
            return this._userDataWriter.convertValue(this._document.data.value);
        }
    }
    /**
     * Retrieves the field specified by `fieldPath`. Returns `undefined` if the
     * document or field doesn't exist.
     *
     * @param fieldPath - The path (for example 'foo' or 'foo.bar') to a specific
     * field.
     * @returns The data at the specified field location or undefined if no such
     * field exists in the document.
     */ // We are using `any` here to avoid an explicit cast by our users.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    get(t) {
        if (this._document) {
            const e = this._document.data.field($5c04988f82cad1b3$var$xh("DocumentSnapshot.get", t));
            if (null !== e) return this._userDataWriter.convertValue(e);
        }
    }
    // Note: This class is stripped down version of the DocumentSnapshot in
    // the legacy SDK. The changes are:
    // - No support for SnapshotMetadata.
    // - No support for SnapshotOptions.
    /** @hideconstructor protected */ constructor(t, e, n, s, i){
        this._firestore = t, this._userDataWriter = e, this._key = n, this._document = s, this._converter = i;
    }
}
/**
 * A `QueryDocumentSnapshot` contains data read from a document in your
 * Firestore database as part of a query. The document is guaranteed to exist
 * and its data can be extracted with `.data()` or `.get(<field>)` to get a
 * specific field.
 *
 * A `QueryDocumentSnapshot` offers the same API surface as a
 * `DocumentSnapshot`. Since query results contain only existing documents, the
 * `exists` property will always be true and `data()` will never return
 * 'undefined'.
 */ class $5c04988f82cad1b3$var$Ch extends $5c04988f82cad1b3$var$Dh {
    /**
     * Retrieves all fields in the document as an `Object`.
     *
     * @override
     * @returns An `Object` containing all fields in the document.
     */ data() {
        return super.data();
    }
}
/**
 * Helper that calls `fromDotSeparatedString()` but wraps any error thrown.
 */ function $5c04988f82cad1b3$var$xh(t, e) {
    return "string" == typeof e ? $5c04988f82cad1b3$var$vh(t, e) : e instanceof $5c04988f82cad1b3$export$a1a8fea822d17659 ? e._internalPath : e._delegate._internalPath;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Metadata about a snapshot, describing the state of the snapshot.
 */ class $5c04988f82cad1b3$export$99d61448206ab5cd {
    /**
     * Returns true if this `SnapshotMetadata` is equal to the provided one.
     *
     * @param other - The `SnapshotMetadata` to compare against.
     * @returns true if this `SnapshotMetadata` is equal to the provided one.
     */ isEqual(t) {
        return this.hasPendingWrites === t.hasPendingWrites && this.fromCache === t.fromCache;
    }
    /** @hideconstructor */ constructor(t, e){
        this.hasPendingWrites = t, this.fromCache = e;
    }
}
/**
 * A `DocumentSnapshot` contains data read from a document in your Firestore
 * database. The data can be extracted with `.data()` or `.get(<field>)` to
 * get a specific field.
 *
 * For a `DocumentSnapshot` that points to a non-existing document, any data
 * access will return 'undefined'. You can use the `exists()` method to
 * explicitly verify a document's existence.
 */ class $5c04988f82cad1b3$export$acab0e6ef25eb301 extends $5c04988f82cad1b3$var$Dh {
    /**
     * Returns whether or not the data exists. True if the document exists.
     */ exists() {
        return super.exists();
    }
    /**
     * Retrieves all fields in the document as an `Object`. Returns `undefined` if
     * the document doesn't exist.
     *
     * By default, `serverTimestamp()` values that have not yet been
     * set to their final value will be returned as `null`. You can override
     * this by passing an options object.
     *
     * @param options - An options object to configure how data is retrieved from
     * the snapshot (for example the desired behavior for server timestamps that
     * have not yet been set to their final value).
     * @returns An `Object` containing all fields in the document or `undefined` if
     * the document doesn't exist.
     */ data(t = {}) {
        if (this._document) {
            if (this._converter) {
                // We only want to use the converter and create a new DocumentSnapshot
                // if a converter has been provided.
                const e = new $5c04988f82cad1b3$export$6d4d04e42af6b03c(this._firestore, this._userDataWriter, this._key, this._document, this.metadata, /* converter= */ null);
                return this._converter.fromFirestore(e, t);
            }
            return this._userDataWriter.convertValue(this._document.data.value, t.serverTimestamps);
        }
    }
    /**
     * Retrieves the field specified by `fieldPath`. Returns `undefined` if the
     * document or field doesn't exist.
     *
     * By default, a `serverTimestamp()` that has not yet been set to
     * its final value will be returned as `null`. You can override this by
     * passing an options object.
     *
     * @param fieldPath - The path (for example 'foo' or 'foo.bar') to a specific
     * field.
     * @param options - An options object to configure how the field is retrieved
     * from the snapshot (for example the desired behavior for server timestamps
     * that have not yet been set to their final value).
     * @returns The data at the specified field location or undefined if no such
     * field exists in the document.
     */ // We are using `any` here to avoid an explicit cast by our users.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    get(t, e = {}) {
        if (this._document) {
            const n = this._document.data.field($5c04988f82cad1b3$var$xh("DocumentSnapshot.get", t));
            if (null !== n) return this._userDataWriter.convertValue(n, e.serverTimestamps);
        }
    }
    /** @hideconstructor protected */ constructor(t, e, n, s, i, r){
        super(t, e, n, s, r), this._firestore = t, this._firestoreImpl = t, this.metadata = i;
    }
}
/**
 * A `QueryDocumentSnapshot` contains data read from a document in your
 * Firestore database as part of a query. The document is guaranteed to exist
 * and its data can be extracted with `.data()` or `.get(<field>)` to get a
 * specific field.
 *
 * A `QueryDocumentSnapshot` offers the same API surface as a
 * `DocumentSnapshot`. Since query results contain only existing documents, the
 * `exists` property will always be true and `data()` will never return
 * 'undefined'.
 */ class $5c04988f82cad1b3$export$6d4d04e42af6b03c extends $5c04988f82cad1b3$export$acab0e6ef25eb301 {
    /**
     * Retrieves all fields in the document as an `Object`.
     *
     * By default, `serverTimestamp()` values that have not yet been
     * set to their final value will be returned as `null`. You can override
     * this by passing an options object.
     *
     * @override
     * @param options - An options object to configure how data is retrieved from
     * the snapshot (for example the desired behavior for server timestamps that
     * have not yet been set to their final value).
     * @returns An `Object` containing all fields in the document.
     */ data(t = {}) {
        return super.data(t);
    }
}
/**
 * A `QuerySnapshot` contains zero or more `DocumentSnapshot` objects
 * representing the results of a query. The documents can be accessed as an
 * array via the `docs` property or enumerated using the `forEach` method. The
 * number of documents can be determined via the `empty` and `size`
 * properties.
 */ class $5c04988f82cad1b3$export$8f21149d8133945c {
    /** An array of all the documents in the `QuerySnapshot`. */ get docs() {
        const t = [];
        return this.forEach((e)=>t.push(e)), t;
    }
    /** The number of documents in the `QuerySnapshot`. */ get size() {
        return this._snapshot.docs.size;
    }
    /** True if there are no documents in the `QuerySnapshot`. */ get empty() {
        return 0 === this.size;
    }
    /**
     * Enumerates all of the documents in the `QuerySnapshot`.
     *
     * @param callback - A callback to be called with a `QueryDocumentSnapshot` for
     * each document in the snapshot.
     * @param thisArg - The `this` binding for the callback.
     */ forEach(t, e) {
        this._snapshot.docs.forEach((n)=>{
            t.call(e, new $5c04988f82cad1b3$export$6d4d04e42af6b03c(this._firestore, this._userDataWriter, n.key, n, new $5c04988f82cad1b3$export$99d61448206ab5cd(this._snapshot.mutatedKeys.has(n.key), this._snapshot.fromCache), this.query.converter));
        });
    }
    /**
     * Returns an array of the documents changes since the last snapshot. If this
     * is the first snapshot, all documents will be in the list as 'added'
     * changes.
     *
     * @param options - `SnapshotListenOptions` that control whether metadata-only
     * changes (i.e. only `DocumentSnapshot.metadata` changed) should trigger
     * snapshot events.
     */ docChanges(t = {}) {
        const e = !!t.includeMetadataChanges;
        if (e && this._snapshot.excludesMetadataChanges) throw new $5c04988f82cad1b3$export$8fada0bf726bf278($5c04988f82cad1b3$var$G.INVALID_ARGUMENT, "To include metadata changes with your document changes, you must also pass { includeMetadataChanges:true } to onSnapshot().");
        return this._cachedChanges && this._cachedChangesIncludeMetadataChanges === e || (this._cachedChanges = /** Calculates the array of `DocumentChange`s for a given `ViewSnapshot`. */ function(t, e) {
            if (t._snapshot.oldDocs.isEmpty()) {
                let e = 0;
                return t._snapshot.docChanges.map((n)=>({
                        type: "added",
                        doc: new $5c04988f82cad1b3$export$6d4d04e42af6b03c(t._firestore, t._userDataWriter, n.doc.key, n.doc, new $5c04988f82cad1b3$export$99d61448206ab5cd(t._snapshot.mutatedKeys.has(n.doc.key), t._snapshot.fromCache), t.query.converter),
                        oldIndex: -1,
                        newIndex: e++
                    }));
            }
            {
                // A `DocumentSet` that is updated incrementally as changes are applied to use
                // to lookup the index of a document.
                let n = t._snapshot.oldDocs;
                return t._snapshot.docChanges.filter((t)=>e || 3 /* Metadata */  !== t.type).map((e)=>{
                    const s = new $5c04988f82cad1b3$export$6d4d04e42af6b03c(t._firestore, t._userDataWriter, e.doc.key, e.doc, new $5c04988f82cad1b3$export$99d61448206ab5cd(t._snapshot.mutatedKeys.has(e.doc.key), t._snapshot.fromCache), t.query.converter);
                    let i = -1, r = -1;
                    return 0 /* Added */  !== e.type && (i = n.indexOf(e.doc.key), n = n.delete(e.doc.key)), 1 /* Removed */  !== e.type && (n = n.add(e.doc), r = n.indexOf(e.doc.key)), {
                        type: $5c04988f82cad1b3$var$Fh(e.type),
                        doc: s,
                        oldIndex: i,
                        newIndex: r
                    };
                });
            }
        }(this, e), this._cachedChangesIncludeMetadataChanges = e), this._cachedChanges;
    }
    /** @hideconstructor */ constructor(t, e, n, s){
        this._firestore = t, this._userDataWriter = e, this._snapshot = s, this.metadata = new $5c04988f82cad1b3$export$99d61448206ab5cd(s.hasPendingWrites, s.fromCache), this.query = n;
    }
}
function $5c04988f82cad1b3$var$Fh(t) {
    switch(t){
        case 0 /* Added */ :
            return "added";
        case 2 /* Modified */ :
        case 3 /* Metadata */ :
            return "modified";
        case 1 /* Removed */ :
            return "removed";
        default:
            return $5c04988f82cad1b3$var$L();
    }
}
// TODO(firestoreexp): Add tests for snapshotEqual with different snapshot
// metadata
/**
 * Returns true if the provided snapshots are equal.
 *
 * @param left - A snapshot to compare.
 * @param right - A snapshot to compare.
 * @returns true if the snapshots are equal.
 */ function $5c04988f82cad1b3$export$f243a5d948512846(t, e) {
    return t instanceof $5c04988f82cad1b3$export$acab0e6ef25eb301 && e instanceof $5c04988f82cad1b3$export$acab0e6ef25eb301 ? t._firestore === e._firestore && t._key.isEqual(e._key) && (null === t._document ? null === e._document : t._document.isEqual(e._document)) && t._converter === e._converter : t instanceof $5c04988f82cad1b3$export$8f21149d8133945c && e instanceof $5c04988f82cad1b3$export$8f21149d8133945c && t._firestore === e._firestore && $5c04988f82cad1b3$export$49b1d0de6ba30f41(t.query, e.query) && t.metadata.isEqual(e.metadata) && t._snapshot.isEqual(e._snapshot);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $5c04988f82cad1b3$var$Bh(t) {
    if ("L" /* Last */  === t.limitType && 0 === t.explicitOrderBy.length) throw new $5c04988f82cad1b3$export$8fada0bf726bf278($5c04988f82cad1b3$var$G.UNIMPLEMENTED, "limitToLast() queries require specifying at least one orderBy() clause");
}
/**
 * A `QueryConstraint` is used to narrow the set of documents returned by a
 * Firestore query. `QueryConstraint`s are created by invoking {@link where},
 * {@link orderBy}, {@link (startAt:1)}, {@link (startAfter:1)}, {@link
 * endBefore:1}, {@link (endAt:1)}, {@link limit} or {@link limitToLast} and
 * can then be passed to {@link query} to create a new query instance that
 * also contains this `QueryConstraint`.
 */ class $5c04988f82cad1b3$export$b0e86f2c7431df4e {
}
/**
 * Creates a new immutable instance of {@link Query} that is extended to also include
 * additional query constraints.
 *
 * @param query - The {@link Query} instance to use as a base for the new constraints.
 * @param queryConstraints - The list of {@link QueryConstraint}s to apply.
 * @throws if any of the provided query constraints cannot be combined with the
 * existing or new constraints.
 */ function $5c04988f82cad1b3$export$2fa187e846a241c4(t, ...e) {
    for (const n of e)t = n._apply(t);
    return t;
}
class $5c04988f82cad1b3$var$qh extends $5c04988f82cad1b3$export$b0e86f2c7431df4e {
    _apply(t) {
        const e = $5c04988f82cad1b3$var$hh(t.firestore), n = function(t, e, n, s, i, r, o) {
            let u;
            if (i.isKeyField()) {
                if ("array-contains" /* ARRAY_CONTAINS */  === r || "array-contains-any" /* ARRAY_CONTAINS_ANY */  === r) throw new $5c04988f82cad1b3$export$8fada0bf726bf278($5c04988f82cad1b3$var$G.INVALID_ARGUMENT, `Invalid Query. You can't perform '${r}' queries on documentId().`);
                if ("in" /* IN */  === r || "not-in" /* NOT_IN */  === r) {
                    $5c04988f82cad1b3$var$sl(o, r);
                    const e = [];
                    for (const n of o)e.push($5c04988f82cad1b3$var$nl(s, t, n));
                    u = {
                        arrayValue: {
                            values: e
                        }
                    };
                } else u = $5c04988f82cad1b3$var$nl(s, t, o);
            } else "in" /* IN */  !== r && "not-in" /* NOT_IN */  !== r && "array-contains-any" /* ARRAY_CONTAINS_ANY */  !== r || $5c04988f82cad1b3$var$sl(o, r), u = $5c04988f82cad1b3$var$Ih(n, e, o, /* allowArrays= */ "in" /* IN */  === r || "not-in" /* NOT_IN */  === r);
            const c = $5c04988f82cad1b3$var$qe.create(i, r, u);
            return function(t, e) {
                if (e.ht()) {
                    const n = $5c04988f82cad1b3$var$cn(t);
                    if (null !== n && !n.isEqual(e.field)) throw new $5c04988f82cad1b3$export$8fada0bf726bf278($5c04988f82cad1b3$var$G.INVALID_ARGUMENT, `Invalid query. All where filters with an inequality (<, <=, !=, not-in, >, or >=) must be on the same field. But you have inequality filters on '${n.toString()}' and '${e.field.toString()}'`);
                    const s = $5c04988f82cad1b3$var$un(t);
                    null !== s && $5c04988f82cad1b3$var$il(t, e.field, s);
                }
                const n = function(t, e) {
                    for (const n of t.filters)if (e.indexOf(n.op) >= 0) return n.op;
                    return null;
                }(t, /**
 * Given an operator, returns the set of operators that cannot be used with it.
 *
 * Operators in a query must adhere to the following set of rules:
 * 1. Only one array operator is allowed.
 * 2. Only one disjunctive operator is allowed.
 * 3. `NOT_EQUAL` cannot be used with another `NOT_EQUAL` operator.
 * 4. `NOT_IN` cannot be used with array, disjunctive, or `NOT_EQUAL` operators.
 *
 * Array operators: `ARRAY_CONTAINS`, `ARRAY_CONTAINS_ANY`
 * Disjunctive operators: `IN`, `ARRAY_CONTAINS_ANY`, `NOT_IN`
 */ function(t) {
                    switch(t){
                        case "!=" /* NOT_EQUAL */ :
                            return [
                                "!=" /* NOT_EQUAL */ ,
                                "not-in" /* NOT_IN */ 
                            ];
                        case "array-contains" /* ARRAY_CONTAINS */ :
                            return [
                                "array-contains" /* ARRAY_CONTAINS */ ,
                                "array-contains-any" /* ARRAY_CONTAINS_ANY */ ,
                                "not-in" /* NOT_IN */ 
                            ];
                        case "in" /* IN */ :
                            return [
                                "array-contains-any" /* ARRAY_CONTAINS_ANY */ ,
                                "in" /* IN */ ,
                                "not-in" /* NOT_IN */ 
                            ];
                        case "array-contains-any" /* ARRAY_CONTAINS_ANY */ :
                            return [
                                "array-contains" /* ARRAY_CONTAINS */ ,
                                "array-contains-any" /* ARRAY_CONTAINS_ANY */ ,
                                "in" /* IN */ ,
                                "not-in" /* NOT_IN */ 
                            ];
                        case "not-in" /* NOT_IN */ :
                            return [
                                "array-contains" /* ARRAY_CONTAINS */ ,
                                "array-contains-any" /* ARRAY_CONTAINS_ANY */ ,
                                "in" /* IN */ ,
                                "not-in" /* NOT_IN */ ,
                                "!=" /* NOT_EQUAL */ 
                            ];
                        default:
                            return [];
                    }
                }(e.op));
                if (null !== n) // Special case when it's a duplicate op to give a slightly clearer error message.
                throw n === e.op ? new $5c04988f82cad1b3$export$8fada0bf726bf278($5c04988f82cad1b3$var$G.INVALID_ARGUMENT, `Invalid query. You cannot use more than one '${e.op.toString()}' filter.`) : new $5c04988f82cad1b3$export$8fada0bf726bf278($5c04988f82cad1b3$var$G.INVALID_ARGUMENT, `Invalid query. You cannot use '${e.op.toString()}' filters with '${n.toString()}' filters.`);
            }(t, c), c;
        }(t._query, "where", e, t.firestore._databaseId, this.fa, this.da, this._a);
        return new $5c04988f82cad1b3$export$62297b13309008b2(t.firestore, t.converter, function(t, e) {
            const n = t.filters.concat([
                e
            ]);
            return new $5c04988f82cad1b3$var$nn(t.path, t.collectionGroup, t.explicitOrderBy.slice(), n, t.limit, t.limitType, t.startAt, t.endAt);
        }(t._query, n));
    }
    constructor(t, e, n){
        super(), this.fa = t, this.da = e, this._a = n, this.type = "where";
    }
}
/**
 * Creates a {@link QueryConstraint} that enforces that documents must contain the
 * specified field and that the value should satisfy the relation constraint
 * provided.
 *
 * @param fieldPath - The path to compare
 * @param opStr - The operation string (e.g "&lt;", "&lt;=", "==", "&lt;",
 *   "&lt;=", "!=").
 * @param value - The value for comparison
 * @returns The created {@link Query}.
 */ function $5c04988f82cad1b3$export$9c59b80dda569a6e(t, e, n) {
    const s = e, i = $5c04988f82cad1b3$var$xh("where", t);
    return new $5c04988f82cad1b3$var$qh(i, s, n);
}
class $5c04988f82cad1b3$var$Gh extends $5c04988f82cad1b3$export$b0e86f2c7431df4e {
    _apply(t) {
        const e = function(t, e, n) {
            if (null !== t.startAt) throw new $5c04988f82cad1b3$export$8fada0bf726bf278($5c04988f82cad1b3$var$G.INVALID_ARGUMENT, "Invalid query. You must not call startAt() or startAfter() before calling orderBy().");
            if (null !== t.endAt) throw new $5c04988f82cad1b3$export$8fada0bf726bf278($5c04988f82cad1b3$var$G.INVALID_ARGUMENT, "Invalid query. You must not call endAt() or endBefore() before calling orderBy().");
            const s = new $5c04988f82cad1b3$var$Xe(e, n);
            return function(t, e) {
                if (null === $5c04988f82cad1b3$var$un(t)) {
                    // This is the first order by. It must match any inequality.
                    const n = $5c04988f82cad1b3$var$cn(t);
                    null !== n && $5c04988f82cad1b3$var$il(t, n, e.field);
                }
            }(t, s), s;
        }(t._query, this.fa, this.wa);
        return new $5c04988f82cad1b3$export$62297b13309008b2(t.firestore, t.converter, function(t, e) {
            // TODO(dimond): validate that orderBy does not list the same key twice.
            const n = t.explicitOrderBy.concat([
                e
            ]);
            return new $5c04988f82cad1b3$var$nn(t.path, t.collectionGroup, n, t.filters.slice(), t.limit, t.limitType, t.startAt, t.endAt);
        }(t._query, e));
    }
    constructor(t, e){
        super(), this.fa = t, this.wa = e, this.type = "orderBy";
    }
}
/**
 * Creates a {@link QueryConstraint} that sorts the query result by the
 * specified field, optionally in descending order instead of ascending.
 *
 * @param fieldPath - The field to sort by.
 * @param directionStr - Optional direction to sort by ('asc' or 'desc'). If
 * not specified, order will be ascending.
 * @returns The created {@link Query}.
 */ function $5c04988f82cad1b3$export$f18af21d6f4dafd8(t, e = "asc") {
    const n = e, s = $5c04988f82cad1b3$var$xh("orderBy", t);
    return new $5c04988f82cad1b3$var$Gh(s, n);
}
class $5c04988f82cad1b3$var$jh extends $5c04988f82cad1b3$export$b0e86f2c7431df4e {
    _apply(t) {
        return new $5c04988f82cad1b3$export$62297b13309008b2(t.firestore, t.converter, $5c04988f82cad1b3$var$fn(t._query, this.ma, this.ga));
    }
    constructor(t, e, n){
        super(), this.type = t, this.ma = e, this.ga = n;
    }
}
/**
 * Creates a {@link QueryConstraint} that only returns the first matching documents.
 *
 * @param limit - The maximum number of items to return.
 * @returns The created {@link Query}.
 */ function $5c04988f82cad1b3$export$ee37e834aaad6f7e(t) {
    return $5c04988f82cad1b3$var$Ta("limit", t), new $5c04988f82cad1b3$var$jh("limit", t, "F" /* First */ );
}
/**
 * Creates a {@link QueryConstraint} that only returns the last matching documents.
 *
 * You must specify at least one `orderBy` clause for `limitToLast` queries,
 * otherwise an exception will be thrown during execution.
 *
 * @param limit - The maximum number of items to return.
 * @returns The created {@link Query}.
 */ function $5c04988f82cad1b3$export$f823b3589f69d3b8(t) {
    return $5c04988f82cad1b3$var$Ta("limitToLast", t), new $5c04988f82cad1b3$var$jh("limitToLast", t, "L" /* Last */ );
}
class $5c04988f82cad1b3$var$Hh extends $5c04988f82cad1b3$export$b0e86f2c7431df4e {
    _apply(t) {
        const e = $5c04988f82cad1b3$var$el(t, this.type, this.ya, this.pa);
        return new $5c04988f82cad1b3$export$62297b13309008b2(t.firestore, t.converter, function(t, e) {
            return new $5c04988f82cad1b3$var$nn(t.path, t.collectionGroup, t.explicitOrderBy.slice(), t.filters.slice(), t.limit, t.limitType, e, t.endAt);
        }(t._query, e));
    }
    constructor(t, e, n){
        super(), this.type = t, this.ya = e, this.pa = n;
    }
}
function $5c04988f82cad1b3$export$859941c5fc8eba6b(...t) {
    return new $5c04988f82cad1b3$var$Hh("startAt", t, /*inclusive=*/ !0);
}
function $5c04988f82cad1b3$export$dd8dee5f7b804673(...t) {
    return new $5c04988f82cad1b3$var$Hh("startAfter", t, /*inclusive=*/ !1);
}
class $5c04988f82cad1b3$var$Xh extends $5c04988f82cad1b3$export$b0e86f2c7431df4e {
    _apply(t) {
        const e = $5c04988f82cad1b3$var$el(t, this.type, this.ya, this.pa);
        return new $5c04988f82cad1b3$export$62297b13309008b2(t.firestore, t.converter, function(t, e) {
            return new $5c04988f82cad1b3$var$nn(t.path, t.collectionGroup, t.explicitOrderBy.slice(), t.filters.slice(), t.limit, t.limitType, t.startAt, e);
        }(t._query, e));
    }
    constructor(t, e, n){
        super(), this.type = t, this.ya = e, this.pa = n;
    }
}
function $5c04988f82cad1b3$export$57203950645b8b11(...t) {
    return new $5c04988f82cad1b3$var$Xh("endBefore", t, /*inclusive=*/ !1);
}
function $5c04988f82cad1b3$export$28ec54a8428bdb3f(...t) {
    return new $5c04988f82cad1b3$var$Xh("endAt", t, /*inclusive=*/ !0);
}
/** Helper function to create a bound from a document or fields */ function $5c04988f82cad1b3$var$el(t, e, n, s) {
    if (n[0] = (0, $isbtl.getModularInstance)(n[0]), n[0] instanceof $5c04988f82cad1b3$var$Dh) return function(t, e, n, s, i) {
        if (!s) throw new $5c04988f82cad1b3$export$8fada0bf726bf278($5c04988f82cad1b3$var$G.NOT_FOUND, `Can't use a DocumentSnapshot that doesn't exist for ${n}().`);
        const r = [];
        // Because people expect to continue/end a query at the exact document
        // provided, we need to use the implicit sort order rather than the explicit
        // sort order, because it's guaranteed to contain the document key. That way
        // the position becomes unambiguous and the query continues/ends exactly at
        // the provided document. Without the key (by using the explicit sort
        // orders), multiple documents could match the position, yielding duplicate
        // results.
        for (const n of $5c04988f82cad1b3$var$hn(t))if (n.field.isKeyField()) r.push($5c04988f82cad1b3$var$ye(e, s.key));
        else {
            const t = s.data.field(n.field);
            if ($5c04988f82cad1b3$var$ee(t)) throw new $5c04988f82cad1b3$export$8fada0bf726bf278($5c04988f82cad1b3$var$G.INVALID_ARGUMENT, 'Invalid query. You are trying to start or end a query using a document for which the field "' + n.field + '" is an uncommitted server timestamp. (Since the value of this field is unknown, you cannot start/end a query with it.)');
            if (null === t) {
                const t = n.field.canonicalString();
                throw new $5c04988f82cad1b3$export$8fada0bf726bf278($5c04988f82cad1b3$var$G.INVALID_ARGUMENT, `Invalid query. You are trying to start or end a query using a document for which the field '${t}' (used as the orderBy) does not exist.`);
            }
            r.push(t);
        }
        return new $5c04988f82cad1b3$var$Ye(r, i);
    }(t._query, t.firestore._databaseId, e, n[0]._document, s);
    {
        const i = $5c04988f82cad1b3$var$hh(t.firestore);
        return function(t, e, n, s, i, r) {
            // Use explicit order by's because it has to match the query the user made
            const o = t.explicitOrderBy;
            if (i.length > o.length) throw new $5c04988f82cad1b3$export$8fada0bf726bf278($5c04988f82cad1b3$var$G.INVALID_ARGUMENT, `Too many arguments provided to ${s}(). The number of arguments must be less than or equal to the number of orderBy() clauses`);
            const u = [];
            for(let r = 0; r < i.length; r++){
                const c = i[r];
                if (o[r].field.isKeyField()) {
                    if ("string" != typeof c) throw new $5c04988f82cad1b3$export$8fada0bf726bf278($5c04988f82cad1b3$var$G.INVALID_ARGUMENT, `Invalid query. Expected a string for document ID in ${s}(), but got a ${typeof c}`);
                    if (!$5c04988f82cad1b3$var$an(t) && -1 !== c.indexOf("/")) throw new $5c04988f82cad1b3$export$8fada0bf726bf278($5c04988f82cad1b3$var$G.INVALID_ARGUMENT, `Invalid query. When querying a collection and ordering by documentId(), the value passed to ${s}() must be a plain document ID, but '${c}' contains a slash.`);
                    const n = t.path.child($5c04988f82cad1b3$var$ht.fromString(c));
                    if (!$5c04988f82cad1b3$export$afc2e57c475b7810.isDocumentKey(n)) throw new $5c04988f82cad1b3$export$8fada0bf726bf278($5c04988f82cad1b3$var$G.INVALID_ARGUMENT, `Invalid query. When querying a collection group and ordering by documentId(), the value passed to ${s}() must result in a valid document path, but '${n}' is not because it contains an odd number of segments.`);
                    const i = new $5c04988f82cad1b3$export$afc2e57c475b7810(n);
                    u.push($5c04988f82cad1b3$var$ye(e, i));
                } else {
                    const t = $5c04988f82cad1b3$var$Ih(n, s, c);
                    u.push(t);
                }
            }
            return new $5c04988f82cad1b3$var$Ye(u, r);
        }(t._query, t.firestore._databaseId, i, e, n, s);
    }
}
function $5c04988f82cad1b3$var$nl(t, e, n) {
    if ("string" == typeof (n = (0, $isbtl.getModularInstance)(n))) {
        if ("" === n) throw new $5c04988f82cad1b3$export$8fada0bf726bf278($5c04988f82cad1b3$var$G.INVALID_ARGUMENT, "Invalid query. When querying with documentId(), you must provide a valid document ID, but it was an empty string.");
        if (!$5c04988f82cad1b3$var$an(e) && -1 !== n.indexOf("/")) throw new $5c04988f82cad1b3$export$8fada0bf726bf278($5c04988f82cad1b3$var$G.INVALID_ARGUMENT, `Invalid query. When querying a collection by documentId(), you must provide a plain document ID, but '${n}' contains a '/' character.`);
        const s = e.path.child($5c04988f82cad1b3$var$ht.fromString(n));
        if (!$5c04988f82cad1b3$export$afc2e57c475b7810.isDocumentKey(s)) throw new $5c04988f82cad1b3$export$8fada0bf726bf278($5c04988f82cad1b3$var$G.INVALID_ARGUMENT, `Invalid query. When querying a collection group by documentId(), the value provided must result in a valid document path, but '${s}' is not because it has an odd number of segments (${s.length}).`);
        return $5c04988f82cad1b3$var$ye(t, new $5c04988f82cad1b3$export$afc2e57c475b7810(s));
    }
    if (n instanceof $5c04988f82cad1b3$export$6be62b059fb12175) return $5c04988f82cad1b3$var$ye(t, n._key);
    throw new $5c04988f82cad1b3$export$8fada0bf726bf278($5c04988f82cad1b3$var$G.INVALID_ARGUMENT, `Invalid query. When querying with documentId(), you must provide a valid string or a DocumentReference, but it was: ${$5c04988f82cad1b3$var$pa(n)}.`);
}
/**
 * Validates that the value passed into a disjunctive filter satisfies all
 * array requirements.
 */ function $5c04988f82cad1b3$var$sl(t, e) {
    if (!Array.isArray(t) || 0 === t.length) throw new $5c04988f82cad1b3$export$8fada0bf726bf278($5c04988f82cad1b3$var$G.INVALID_ARGUMENT, `Invalid Query. A non-empty array is required for '${e.toString()}' filters.`);
    if (t.length > 10) throw new $5c04988f82cad1b3$export$8fada0bf726bf278($5c04988f82cad1b3$var$G.INVALID_ARGUMENT, `Invalid Query. '${e.toString()}' filters support a maximum of 10 elements in the value array.`);
}
function $5c04988f82cad1b3$var$il(t, e, n) {
    if (!n.isEqual(e)) throw new $5c04988f82cad1b3$export$8fada0bf726bf278($5c04988f82cad1b3$var$G.INVALID_ARGUMENT, `Invalid query. You have a where filter with an inequality (<, <=, !=, not-in, >, or >=) on field '${e.toString()}' and so you must also use '${e.toString()}' as your first argument to orderBy(), but your first orderBy() is on field '${n.toString()}' instead.`);
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $5c04988f82cad1b3$var$rl = {
    maxAttempts: 5
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Converts Firestore's internal types to the JavaScript types that we expose
 * to the user.
 *
 * @internal
 */ class $5c04988f82cad1b3$export$2cd31cfe6f6866e9 {
    convertValue(t, e = "none") {
        switch($5c04988f82cad1b3$var$le(t)){
            case 0 /* NullValue */ :
                return null;
            case 1 /* BooleanValue */ :
                return t.booleanValue;
            case 2 /* NumberValue */ :
                return $5c04988f82cad1b3$var$Zt(t.integerValue || t.doubleValue);
            case 3 /* TimestampValue */ :
                return this.convertTimestamp(t.timestampValue);
            case 4 /* ServerTimestampValue */ :
                return this.convertServerTimestamp(t, e);
            case 5 /* StringValue */ :
                return t.stringValue;
            case 6 /* BlobValue */ :
                return this.convertBytes($5c04988f82cad1b3$var$te(t.bytesValue));
            case 7 /* RefValue */ :
                return this.convertReference(t.referenceValue);
            case 8 /* GeoPointValue */ :
                return this.convertGeoPoint(t.geoPointValue);
            case 9 /* ArrayValue */ :
                return this.convertArray(t.arrayValue, e);
            case 10 /* ObjectValue */ :
                return this.convertObject(t.mapValue, e);
            default:
                throw $5c04988f82cad1b3$var$L();
        }
    }
    convertObject(t, e) {
        const n = {};
        return $5c04988f82cad1b3$var$Lt(t.fields, (t, s)=>{
            n[t] = this.convertValue(s, e);
        }), n;
    }
    convertGeoPoint(t) {
        return new $5c04988f82cad1b3$export$f9f719d1b6419c4($5c04988f82cad1b3$var$Zt(t.latitude), $5c04988f82cad1b3$var$Zt(t.longitude));
    }
    convertArray(t, e) {
        return (t.values || []).map((t)=>this.convertValue(t, e));
    }
    convertServerTimestamp(t, e) {
        switch(e){
            case "previous":
                const n = $5c04988f82cad1b3$var$ne(t);
                return null == n ? null : this.convertValue(n, e);
            case "estimate":
                return this.convertTimestamp($5c04988f82cad1b3$var$se(t));
            default:
                return null;
        }
    }
    convertTimestamp(t) {
        const e = $5c04988f82cad1b3$var$Xt(t);
        return new $5c04988f82cad1b3$export$d9bcbd5e1ff81430(e.seconds, e.nanos);
    }
    convertDocumentKey(t, e) {
        const n = $5c04988f82cad1b3$var$ht.fromString(t);
        $5c04988f82cad1b3$var$U($5c04988f82cad1b3$var$ui(n));
        const s = new $5c04988f82cad1b3$export$4c3ccc07620ae30a(n.get(1), n.get(3)), i = new $5c04988f82cad1b3$export$afc2e57c475b7810(n.popFirst(5));
        return s.isEqual(e) || // TODO(b/64130202): Somehow support foreign references.
        $5c04988f82cad1b3$var$F(`Document ${i} contains a document reference within a different database (${s.projectId}/${s.database}) which is not supported. It will be treated as a reference in the current database (${e.projectId}/${e.database}) instead.`), i;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Converts custom model object of type T into `DocumentData` by applying the
 * converter if it exists.
 *
 * This function is used when converting user objects to `DocumentData`
 * because we want to provide the user with a more specific error message if
 * their `set()` or fails due to invalid data originating from a `toFirestore()`
 * call.
 */ function $5c04988f82cad1b3$var$ul(t, e, n) {
    let s;
    // Cast to `any` in order to satisfy the union type constraint on
    // toFirestore().
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return s = t ? n && (n.merge || n.mergeFields) ? t.toFirestore(e, n) : t.toFirestore(e) : e, s;
}
class $5c04988f82cad1b3$var$cl extends $5c04988f82cad1b3$export$2cd31cfe6f6866e9 {
    convertBytes(t) {
        return new $5c04988f82cad1b3$export$9f55f2e2bf8c2fc1(t);
    }
    convertReference(t) {
        const e = this.convertDocumentKey(t, this.firestore._databaseId);
        return new $5c04988f82cad1b3$export$6be62b059fb12175(this.firestore, /* converter= */ null, e);
    }
    constructor(t){
        super(), this.firestore = t;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A write batch, used to perform multiple writes as a single atomic unit.
 *
 * A `WriteBatch` object can be acquired by calling {@link writeBatch}. It
 * provides methods for adding writes to the write batch. None of the writes
 * will be committed (or visible locally) until {@link WriteBatch.commit} is
 * called.
 */ class $5c04988f82cad1b3$export$d94ed661b1cfd435 {
    set(t, e, n) {
        this._verifyNotCommitted();
        const s = $5c04988f82cad1b3$var$hl(t, this._firestore), i = $5c04988f82cad1b3$var$ul(s.converter, e, n), r = $5c04988f82cad1b3$var$lh(this._dataReader, "WriteBatch.set", s._key, i, null !== s.converter, n);
        return this._mutations.push(r.toMutation(s._key, $5c04988f82cad1b3$var$$n.none())), this;
    }
    update(t, e, n, ...s) {
        this._verifyNotCommitted();
        const i = $5c04988f82cad1b3$var$hl(t, this._firestore);
        // For Compat types, we have to "extract" the underlying types before
        // performing validation.
        let r;
        return r = "string" == typeof (e = (0, $isbtl.getModularInstance)(e)) || e instanceof $5c04988f82cad1b3$export$a1a8fea822d17659 ? $5c04988f82cad1b3$var$ph(this._dataReader, "WriteBatch.update", i._key, e, n, s) : $5c04988f82cad1b3$var$yh(this._dataReader, "WriteBatch.update", i._key, e), this._mutations.push(r.toMutation(i._key, $5c04988f82cad1b3$var$$n.exists(!0))), this;
    }
    /**
     * Deletes the document referred to by the provided {@link DocumentReference}.
     *
     * @param documentRef - A reference to the document to be deleted.
     * @returns This `WriteBatch` instance. Used for chaining method calls.
     */ delete(t) {
        this._verifyNotCommitted();
        const e = $5c04988f82cad1b3$var$hl(t, this._firestore);
        return this._mutations = this._mutations.concat(new $5c04988f82cad1b3$var$Yn(e._key, $5c04988f82cad1b3$var$$n.none())), this;
    }
    /**
     * Commits all of the writes in this write batch as a single atomic unit.
     *
     * The result of these writes will only be reflected in document reads that
     * occur after the returned promise resolves. If the client is offline, the
     * write fails. If you would like to see local modifications or buffer writes
     * until the client is online, use the full Firestore SDK.
     *
     * @returns A `Promise` resolved once all of the writes in the batch have been
     * successfully written to the backend as an atomic unit (note that it won't
     * resolve while you're offline).
     */ commit() {
        return this._verifyNotCommitted(), this._committed = !0, this._mutations.length > 0 ? this._commitHandler(this._mutations) : Promise.resolve();
    }
    _verifyNotCommitted() {
        if (this._committed) throw new $5c04988f82cad1b3$export$8fada0bf726bf278($5c04988f82cad1b3$var$G.FAILED_PRECONDITION, "A write batch can no longer be used after commit() has been called.");
    }
    /** @hideconstructor */ constructor(t, e){
        this._firestore = t, this._commitHandler = e, this._mutations = [], this._committed = !1, this._dataReader = $5c04988f82cad1b3$var$hh(t);
    }
}
function $5c04988f82cad1b3$var$hl(t, e) {
    if ((t = (0, $isbtl.getModularInstance)(t)).firestore !== e) throw new $5c04988f82cad1b3$export$8fada0bf726bf278($5c04988f82cad1b3$var$G.INVALID_ARGUMENT, "Provided document reference is from a different Firestore instance.");
    return t;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // TODO(mrschmidt) Consider using `BaseTransaction` as the base class in the
// legacy SDK.
/**
 * A reference to a transaction.
 *
 * The `Transaction` object passed to a transaction's `updateFunction` provides
 * the methods to read and write data within the transaction context. See
 * {@link runTransaction}.
 */ /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Reads the document referred to by this `DocumentReference`.
 *
 * Note: `getDoc()` attempts to provide up-to-date data when possible by waiting
 * for data from the server, but it may return cached data or fail if you are
 * offline and the server cannot be reached. To specify this behavior, invoke
 * {@link getDocFromCache} or {@link getDocFromServer}.
 *
 * @param reference - The reference of the document to fetch.
 * @returns A Promise resolved with a `DocumentSnapshot` containing the
 * current document contents.
 */ function $5c04988f82cad1b3$export$11eb3b5ef9574821(t) {
    t = $5c04988f82cad1b3$export$572106fb5803752c(t, $5c04988f82cad1b3$export$6be62b059fb12175);
    const e = $5c04988f82cad1b3$export$572106fb5803752c(t.firestore, $5c04988f82cad1b3$export$d0e2b3272814ce82);
    return $5c04988f82cad1b3$var$ua($5c04988f82cad1b3$export$8da5fbea04405656(e), t._key).then((n)=>$5c04988f82cad1b3$var$bl(e, t, n));
}
class $5c04988f82cad1b3$var$fl extends $5c04988f82cad1b3$export$2cd31cfe6f6866e9 {
    convertBytes(t) {
        return new $5c04988f82cad1b3$export$9f55f2e2bf8c2fc1(t);
    }
    convertReference(t) {
        const e = this.convertDocumentKey(t, this.firestore._databaseId);
        return new $5c04988f82cad1b3$export$6be62b059fb12175(this.firestore, /* converter= */ null, e);
    }
    constructor(t){
        super(), this.firestore = t;
    }
}
/**
 * Reads the document referred to by this `DocumentReference` from cache.
 * Returns an error if the document is not currently cached.
 *
 * @returns A `Promise` resolved with a `DocumentSnapshot` containing the
 * current document contents.
 */ function $5c04988f82cad1b3$export$a58bd92642f7fb58(t) {
    t = $5c04988f82cad1b3$export$572106fb5803752c(t, $5c04988f82cad1b3$export$6be62b059fb12175);
    const e = $5c04988f82cad1b3$export$572106fb5803752c(t.firestore, $5c04988f82cad1b3$export$d0e2b3272814ce82), n = $5c04988f82cad1b3$export$8da5fbea04405656(e), s = new $5c04988f82cad1b3$var$fl(e);
    return $5c04988f82cad1b3$var$oa(n, t._key).then((n)=>new $5c04988f82cad1b3$export$acab0e6ef25eb301(e, s, t._key, n, new $5c04988f82cad1b3$export$99d61448206ab5cd(null !== n && n.hasLocalMutations, /* fromCache= */ !0), t.converter));
}
/**
 * Reads the document referred to by this `DocumentReference` from the server.
 * Returns an error if the network is not available.
 *
 * @returns A `Promise` resolved with a `DocumentSnapshot` containing the
 * current document contents.
 */ function $5c04988f82cad1b3$export$35dd759aed9686b4(t) {
    t = $5c04988f82cad1b3$export$572106fb5803752c(t, $5c04988f82cad1b3$export$6be62b059fb12175);
    const e = $5c04988f82cad1b3$export$572106fb5803752c(t.firestore, $5c04988f82cad1b3$export$d0e2b3272814ce82);
    return $5c04988f82cad1b3$var$ua($5c04988f82cad1b3$export$8da5fbea04405656(e), t._key, {
        source: "server"
    }).then((n)=>$5c04988f82cad1b3$var$bl(e, t, n));
}
/**
 * Executes the query and returns the results as a `QuerySnapshot`.
 *
 * Note: `getDocs()` attempts to provide up-to-date data when possible by
 * waiting for data from the server, but it may return cached data or fail if
 * you are offline and the server cannot be reached. To specify this behavior,
 * invoke {@link getDocsFromCache} or {@link getDocsFromServer}.
 *
 * @returns A `Promise` that will be resolved with the results of the query.
 */ function $5c04988f82cad1b3$export$81d3477bd73c86ef(t) {
    t = $5c04988f82cad1b3$export$572106fb5803752c(t, $5c04988f82cad1b3$export$62297b13309008b2);
    const e = $5c04988f82cad1b3$export$572106fb5803752c(t.firestore, $5c04988f82cad1b3$export$d0e2b3272814ce82), n = $5c04988f82cad1b3$export$8da5fbea04405656(e), s = new $5c04988f82cad1b3$var$fl(e);
    return $5c04988f82cad1b3$var$Bh(t._query), $5c04988f82cad1b3$var$aa(n, t._query).then((n)=>new $5c04988f82cad1b3$export$8f21149d8133945c(e, s, t, n));
}
/**
 * Executes the query and returns the results as a `QuerySnapshot` from cache.
 * Returns an error if the document is not currently cached.
 *
 * @returns A `Promise` that will be resolved with the results of the query.
 */ function $5c04988f82cad1b3$export$3fd010f18eac1dd(t) {
    t = $5c04988f82cad1b3$export$572106fb5803752c(t, $5c04988f82cad1b3$export$62297b13309008b2);
    const e = $5c04988f82cad1b3$export$572106fb5803752c(t.firestore, $5c04988f82cad1b3$export$d0e2b3272814ce82), n = $5c04988f82cad1b3$export$8da5fbea04405656(e), s = new $5c04988f82cad1b3$var$fl(e);
    return $5c04988f82cad1b3$var$ca(n, t._query).then((n)=>new $5c04988f82cad1b3$export$8f21149d8133945c(e, s, t, n));
}
/**
 * Executes the query and returns the results as a `QuerySnapshot` from the
 * server. Returns an error if the network is not available.
 *
 * @returns A `Promise` that will be resolved with the results of the query.
 */ function $5c04988f82cad1b3$export$ec7d9e44f349c77b(t) {
    t = $5c04988f82cad1b3$export$572106fb5803752c(t, $5c04988f82cad1b3$export$62297b13309008b2);
    const e = $5c04988f82cad1b3$export$572106fb5803752c(t.firestore, $5c04988f82cad1b3$export$d0e2b3272814ce82), n = $5c04988f82cad1b3$export$8da5fbea04405656(e), s = new $5c04988f82cad1b3$var$fl(e);
    return $5c04988f82cad1b3$var$aa(n, t._query, {
        source: "server"
    }).then((n)=>new $5c04988f82cad1b3$export$8f21149d8133945c(e, s, t, n));
}
function $5c04988f82cad1b3$export$5ff77ddaff3c9e12(t, e, n) {
    t = $5c04988f82cad1b3$export$572106fb5803752c(t, $5c04988f82cad1b3$export$6be62b059fb12175);
    const s = $5c04988f82cad1b3$export$572106fb5803752c(t.firestore, $5c04988f82cad1b3$export$d0e2b3272814ce82), i = $5c04988f82cad1b3$var$ul(t.converter, e, n);
    return $5c04988f82cad1b3$export$1945f8fec9dda613(s, [
        $5c04988f82cad1b3$var$lh($5c04988f82cad1b3$var$hh(s), "setDoc", t._key, i, null !== t.converter, n).toMutation(t._key, $5c04988f82cad1b3$var$$n.none())
    ]);
}
function $5c04988f82cad1b3$export$22d1fdd1e73faff2(t, e, n, ...s) {
    t = $5c04988f82cad1b3$export$572106fb5803752c(t, $5c04988f82cad1b3$export$6be62b059fb12175);
    const i = $5c04988f82cad1b3$export$572106fb5803752c(t.firestore, $5c04988f82cad1b3$export$d0e2b3272814ce82), r = $5c04988f82cad1b3$var$hh(i);
    let o;
    o = "string" == typeof // For Compat types, we have to "extract" the underlying types before
    // performing validation.
    (e = (0, $isbtl.getModularInstance)(e)) || e instanceof $5c04988f82cad1b3$export$a1a8fea822d17659 ? $5c04988f82cad1b3$var$ph(r, "updateDoc", t._key, e, n, s) : $5c04988f82cad1b3$var$yh(r, "updateDoc", t._key, e);
    return $5c04988f82cad1b3$export$1945f8fec9dda613(i, [
        o.toMutation(t._key, $5c04988f82cad1b3$var$$n.exists(!0))
    ]);
}
/**
 * Deletes the document referred to by the specified `DocumentReference`.
 *
 * @param reference - A reference to the document to delete.
 * @returns A Promise resolved once the document has been successfully
 * deleted from the backend (note that it won't resolve while you're offline).
 */ function $5c04988f82cad1b3$export$a4f20481fae8f78b(t) {
    return $5c04988f82cad1b3$export$1945f8fec9dda613($5c04988f82cad1b3$export$572106fb5803752c(t.firestore, $5c04988f82cad1b3$export$d0e2b3272814ce82), [
        new $5c04988f82cad1b3$var$Yn(t._key, $5c04988f82cad1b3$var$$n.none())
    ]);
}
/**
 * Add a new document to specified `CollectionReference` with the given data,
 * assigning it a document ID automatically.
 *
 * @param reference - A reference to the collection to add this document to.
 * @param data - An Object containing the data for the new document.
 * @returns A `Promise` resolved with a `DocumentReference` pointing to the
 * newly created document after it has been written to the backend (Note that it
 * won't resolve while you're offline).
 */ function $5c04988f82cad1b3$export$a13890143fb1c2dd(t, e) {
    const n = $5c04988f82cad1b3$export$572106fb5803752c(t.firestore, $5c04988f82cad1b3$export$d0e2b3272814ce82), s = $5c04988f82cad1b3$export$2a111da947c407d2(t), i = $5c04988f82cad1b3$var$ul(t.converter, e);
    return $5c04988f82cad1b3$export$1945f8fec9dda613(n, [
        $5c04988f82cad1b3$var$lh($5c04988f82cad1b3$var$hh(t.firestore), "addDoc", s._key, i, null !== t.converter, {}).toMutation(s._key, $5c04988f82cad1b3$var$$n.exists(!1))
    ]).then(()=>s);
}
function $5c04988f82cad1b3$export$d36370812fb26935(t, ...e) {
    var n, s, i;
    t = (0, $isbtl.getModularInstance)(t);
    let r = {
        includeMetadataChanges: !1
    }, o = 0;
    "object" != typeof e[o] || $5c04988f82cad1b3$var$ka(e[o]) || (r = e[o], o++);
    const u = {
        includeMetadataChanges: r.includeMetadataChanges
    };
    if ($5c04988f82cad1b3$var$ka(e[o])) {
        const t = e[o];
        e[o] = null === (n = t.next) || void 0 === n ? void 0 : n.bind(t), e[o + 1] = null === (s = t.error) || void 0 === s ? void 0 : s.bind(t), e[o + 2] = null === (i = t.complete) || void 0 === i ? void 0 : i.bind(t);
    }
    let c, a, h;
    if (t instanceof $5c04988f82cad1b3$export$6be62b059fb12175) a = $5c04988f82cad1b3$export$572106fb5803752c(t.firestore, $5c04988f82cad1b3$export$d0e2b3272814ce82), h = $5c04988f82cad1b3$var$rn(t._key.path), c = {
        next: (n)=>{
            e[o] && e[o]($5c04988f82cad1b3$var$bl(a, t, n));
        },
        error: e[o + 1],
        complete: e[o + 2]
    };
    else {
        const n = $5c04988f82cad1b3$export$572106fb5803752c(t, $5c04988f82cad1b3$export$62297b13309008b2);
        a = $5c04988f82cad1b3$export$572106fb5803752c(n.firestore, $5c04988f82cad1b3$export$d0e2b3272814ce82), h = n._query;
        const s = new $5c04988f82cad1b3$var$fl(a);
        c = {
            next: (t)=>{
                e[o] && e[o](new $5c04988f82cad1b3$export$8f21149d8133945c(a, s, n, t));
            },
            error: e[o + 1],
            complete: e[o + 2]
        }, $5c04988f82cad1b3$var$Bh(t._query);
    }
    return function(t, e, n, s) {
        const i = new $5c04988f82cad1b3$var$Gc(s), r = new $5c04988f82cad1b3$var$Ju(e, i, n);
        return t.asyncQueue.enqueueAndForget(async ()=>$5c04988f82cad1b3$var$Qu(await $5c04988f82cad1b3$var$sa(t), r)), ()=>{
            i.Tc(), t.asyncQueue.enqueueAndForget(async ()=>$5c04988f82cad1b3$var$ju(await $5c04988f82cad1b3$var$sa(t), r));
        };
    }($5c04988f82cad1b3$export$8da5fbea04405656(a), h, u, c);
}
function $5c04988f82cad1b3$export$9dff4f5aba83e348(t, e) {
    return $5c04988f82cad1b3$var$ha($5c04988f82cad1b3$export$8da5fbea04405656(t = $5c04988f82cad1b3$export$572106fb5803752c(t, $5c04988f82cad1b3$export$d0e2b3272814ce82)), $5c04988f82cad1b3$var$ka(e) ? e : {
        next: e
    });
}
/**
 * Locally writes `mutations` on the async queue.
 * @internal
 */ function $5c04988f82cad1b3$export$1945f8fec9dda613(t, e) {
    return function(t, e) {
        const n = new $5c04988f82cad1b3$var$j;
        return t.asyncQueue.enqueueAndForget(async ()=>$5c04988f82cad1b3$var$hc(await $5c04988f82cad1b3$var$na(t), e, n)), n.promise;
    }($5c04988f82cad1b3$export$8da5fbea04405656(t), e);
}
/**
 * Converts a {@link ViewSnapshot} that contains the single document specified by `ref`
 * to a {@link DocumentSnapshot}.
 */ function $5c04988f82cad1b3$var$bl(t, e, n) {
    const s = n.docs.get(e._key), i = new $5c04988f82cad1b3$var$fl(t);
    return new $5c04988f82cad1b3$export$acab0e6ef25eb301(t, i, e._key, s, new $5c04988f82cad1b3$export$99d61448206ab5cd(n.hasPendingWrites, n.fromCache), e.converter);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A reference to a transaction.
 *
 * The `Transaction` object passed to a transaction's `updateFunction` provides
 * the methods to read and write data within the transaction context. See
 * {@link runTransaction}.
 */ class $5c04988f82cad1b3$export$febc5573c75cefb0 extends class {
    /**
     * Reads the document referenced by the provided {@link DocumentReference}.
     *
     * @param documentRef - A reference to the document to be read.
     * @returns A `DocumentSnapshot` with the read data.
     */ get(t) {
        const e = $5c04988f82cad1b3$var$hl(t, this._firestore), n = new $5c04988f82cad1b3$var$cl(this._firestore);
        return this._transaction.lookup([
            e._key
        ]).then((t)=>{
            if (!t || 1 !== t.length) return $5c04988f82cad1b3$var$L();
            const s = t[0];
            if (s.isFoundDocument()) return new $5c04988f82cad1b3$var$Dh(this._firestore, n, s.key, s, e.converter);
            if (s.isNoDocument()) return new $5c04988f82cad1b3$var$Dh(this._firestore, n, e._key, null, e.converter);
            throw $5c04988f82cad1b3$var$L();
        });
    }
    set(t, e, n) {
        const s = $5c04988f82cad1b3$var$hl(t, this._firestore), i = $5c04988f82cad1b3$var$ul(s.converter, e, n), r = $5c04988f82cad1b3$var$lh(this._dataReader, "Transaction.set", s._key, i, null !== s.converter, n);
        return this._transaction.set(s._key, r), this;
    }
    update(t, e, n, ...s) {
        const i = $5c04988f82cad1b3$var$hl(t, this._firestore);
        // For Compat types, we have to "extract" the underlying types before
        // performing validation.
        let r;
        return r = "string" == typeof (e = (0, $isbtl.getModularInstance)(e)) || e instanceof $5c04988f82cad1b3$export$a1a8fea822d17659 ? $5c04988f82cad1b3$var$ph(this._dataReader, "Transaction.update", i._key, e, n, s) : $5c04988f82cad1b3$var$yh(this._dataReader, "Transaction.update", i._key, e), this._transaction.update(i._key, r), this;
    }
    /**
     * Deletes the document referred to by the provided {@link DocumentReference}.
     *
     * @param documentRef - A reference to the document to be deleted.
     * @returns This `Transaction` instance. Used for chaining method calls.
     */ delete(t) {
        const e = $5c04988f82cad1b3$var$hl(t, this._firestore);
        return this._transaction.delete(e._key), this;
    }
    /** @hideconstructor */ constructor(t, e){
        this._firestore = t, this._transaction = e, this._dataReader = $5c04988f82cad1b3$var$hh(t);
    }
} {
    /**
     * Reads the document referenced by the provided {@link DocumentReference}.
     *
     * @param documentRef - A reference to the document to be read.
     * @returns A `DocumentSnapshot` with the read data.
     */ get(t) {
        const e = $5c04988f82cad1b3$var$hl(t, this._firestore), n = new $5c04988f82cad1b3$var$fl(this._firestore);
        return super.get(t).then((t)=>new $5c04988f82cad1b3$export$acab0e6ef25eb301(this._firestore, n, e._key, t._document, new $5c04988f82cad1b3$export$99d61448206ab5cd(/* hasPendingWrites= */ !1, /* fromCache= */ !1), e.converter));
    }
    // This class implements the same logic as the Transaction API in the Lite SDK
    // but is subclassed in order to return its own DocumentSnapshot types.
    /** @hideconstructor */ constructor(t, e){
        super(t, e), this._firestore = t;
    }
}
/**
 * Executes the given `updateFunction` and then attempts to commit the changes
 * applied within the transaction. If any document read within the transaction
 * has changed, Cloud Firestore retries the `updateFunction`. If it fails to
 * commit after 5 attempts, the transaction fails.
 *
 * The maximum number of writes allowed in a single transaction is 500.
 *
 * @param firestore - A reference to the Firestore database to run this
 * transaction against.
 * @param updateFunction - The function to execute within the transaction
 * context.
 * @param options - An options object to configure maximum number of attempts to
 * commit.
 * @returns If the transaction completed successfully or was explicitly aborted
 * (the `updateFunction` returned a failed promise), the promise returned by the
 * `updateFunction `is returned here. Otherwise, if the transaction failed, a
 * rejected promise with the corresponding failure error is returned.
 */ function $5c04988f82cad1b3$export$3c54e006bf9c93b7(t, e, n) {
    t = $5c04988f82cad1b3$export$572106fb5803752c(t, $5c04988f82cad1b3$export$d0e2b3272814ce82);
    const s = Object.assign(Object.assign({}, $5c04988f82cad1b3$var$rl), n);
    !function(t) {
        if (t.maxAttempts < 1) throw new $5c04988f82cad1b3$export$8fada0bf726bf278($5c04988f82cad1b3$var$G.INVALID_ARGUMENT, "Max attempts must be at least 1");
    }(s);
    return $5c04988f82cad1b3$var$la($5c04988f82cad1b3$export$8da5fbea04405656(t), (n)=>e(new $5c04988f82cad1b3$export$febc5573c75cefb0(t, n)), s);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a sentinel for use with {@link @firebase/firestore/lite#(updateDoc:1)} or
 * {@link @firebase/firestore/lite#(setDoc:1)} with `{merge: true}` to mark a field for deletion.
 */ function $5c04988f82cad1b3$export$2bbad96c62fdba3e() {
    return new $5c04988f82cad1b3$var$fh("deleteField");
}
/**
 * Returns a sentinel used with {@link @firebase/firestore/lite#(setDoc:1)} or {@link @firebase/firestore/lite#(updateDoc:1)} to
 * include a server-generated timestamp in the written data.
 */ function $5c04988f82cad1b3$export$3ff8e7e00c3264b7() {
    return new $5c04988f82cad1b3$var$_h("serverTimestamp");
}
/**
 * Returns a special value that can be used with {@link @firebase/firestore/lite#(setDoc:1)} or {@link
 * @firebase/firestore/lite#(updateDoc:1)} that tells the server to union the given elements with any array
 * value that already exists on the server. Each specified element that doesn't
 * already exist in the array will be added to the end. If the field being
 * modified is not already an array it will be overwritten with an array
 * containing exactly the specified elements.
 *
 * @param elements - The elements to union into the array.
 * @returns The `FieldValue` sentinel for use in a call to `setDoc()` or
 * `updateDoc()`.
 */ function $5c04988f82cad1b3$export$f62af892fd92610c(...t) {
    // NOTE: We don't actually parse the data until it's used in set() or
    // update() since we'd need the Firestore instance to do this.
    return new $5c04988f82cad1b3$var$wh("arrayUnion", t);
}
/**
 * Returns a special value that can be used with {@link (setDoc:1)} or {@link
 * updateDoc:1} that tells the server to remove the given elements from any
 * array value that already exists on the server. All instances of each element
 * specified will be removed from the array. If the field being modified is not
 * already an array it will be overwritten with an empty array.
 *
 * @param elements - The elements to remove from the array.
 * @returns The `FieldValue` sentinel for use in a call to `setDoc()` or
 * `updateDoc()`
 */ function $5c04988f82cad1b3$export$30a014203d0d7e4f(...t) {
    // NOTE: We don't actually parse the data until it's used in set() or
    // update() since we'd need the Firestore instance to do this.
    return new $5c04988f82cad1b3$var$mh("arrayRemove", t);
}
/**
 * Returns a special value that can be used with {@link @firebase/firestore/lite#(setDoc:1)} or {@link
 * @firebase/firestore/lite#(updateDoc:1)} that tells the server to increment the field's current value by
 * the given value.
 *
 * If either the operand or the current field value uses floating point
 * precision, all arithmetic follows IEEE 754 semantics. If both values are
 * integers, values outside of JavaScript's safe number range
 * (`Number.MIN_SAFE_INTEGER` to `Number.MAX_SAFE_INTEGER`) are also subject to
 * precision loss. Furthermore, once processed by the Firestore backend, all
 * integer operations are capped between -2^63 and 2^63-1.
 *
 * If the current field value is not of type `number`, or if the field does not
 * yet exist, the transformation sets the field to the given value.
 *
 * @param n - The value to increment by.
 * @returns The `FieldValue` sentinel for use in a call to `setDoc()` or
 * `updateDoc()`
 */ function $5c04988f82cad1b3$export$a2647aa13413c947(t) {
    return new $5c04988f82cad1b3$var$gh("increment", t);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Creates a write batch, used for performing multiple writes as a single
 * atomic operation. The maximum number of writes allowed in a single {@link WriteBatch}
 * is 500.
 *
 * Unlike transactions, write batches are persisted offline and therefore are
 * preferable when you don't need to condition your writes on read data.
 *
 * @returns A {@link WriteBatch} that can be used to atomically execute multiple
 * writes.
 */ function $5c04988f82cad1b3$export$44cd1c9d57edd9b1(t) {
    return $5c04988f82cad1b3$export$8da5fbea04405656(t = $5c04988f82cad1b3$export$572106fb5803752c(t, $5c04988f82cad1b3$export$d0e2b3272814ce82)), new $5c04988f82cad1b3$export$d94ed661b1cfd435(t, (e)=>$5c04988f82cad1b3$export$1945f8fec9dda613(t, e));
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $5c04988f82cad1b3$export$2862db5d92ff7996(t, e) {
    $5c04988f82cad1b3$export$8da5fbea04405656(t = $5c04988f82cad1b3$export$572106fb5803752c(t, $5c04988f82cad1b3$export$d0e2b3272814ce82));
    const n = "string" == typeof e ? function(t) {
        try {
            return JSON.parse(t);
        } catch (t) {
            throw new $5c04988f82cad1b3$export$8fada0bf726bf278($5c04988f82cad1b3$var$G.INVALID_ARGUMENT, "Failed to parse JSON:" + t.message);
        }
    }(e) : e, s = [];
    // PORTING NOTE: We don't return an error if the user has not enabled
    // persistence since `enableIndexeddbPersistence()` can fail on the Web.
    if (Array.isArray(n.indexes)) for (const t of n.indexes){
        const e = $5c04988f82cad1b3$var$Ol(t, "collectionGroup"), n = [];
        if (Array.isArray(t.fields)) for (const e of t.fields){
            const t = $5c04988f82cad1b3$var$vh("setIndexConfiguration", $5c04988f82cad1b3$var$Ol(e, "fieldPath"));
            "CONTAINS" === e.arrayConfig ? n.push(new $5c04988f82cad1b3$var$gt(t, 2 /* CONTAINS */ )) : "ASCENDING" === e.order ? n.push(new $5c04988f82cad1b3$var$gt(t, 0 /* ASCENDING */ )) : "DESCENDING" === e.order && n.push(new $5c04988f82cad1b3$var$gt(t, 1 /* DESCENDING */ ));
        }
        s.push(new $5c04988f82cad1b3$var$_t($5c04988f82cad1b3$var$_t.UNKNOWN_ID, e, n, $5c04988f82cad1b3$var$yt.empty()));
    }
    // TODO(indexing): Configure indexes
    return Promise.resolve();
}
function $5c04988f82cad1b3$var$Ol(t, e) {
    if ("string" != typeof t[e]) throw new $5c04988f82cad1b3$export$8fada0bf726bf278($5c04988f82cad1b3$var$G.INVALID_ARGUMENT, "Missing string value for: " + e);
    return t[e];
}
/**
 * Cloud Firestore
 *
 * @packageDocumentation
 */ !function(t, e = !0) {
    !function(t) {
        $5c04988f82cad1b3$var$x = t;
    }((0, $iXpG9.SDK_VERSION)), (0, $iXpG9._registerComponent)(new (0, $k46Iq.Component)("firestore", (t, { options: n })=>{
        const s = t.getProvider("app").getImmediate(), i = new $5c04988f82cad1b3$export$d0e2b3272814ce82(s, new $5c04988f82cad1b3$var$J(t.getProvider("auth-internal")), new $5c04988f82cad1b3$var$tt(t.getProvider("app-check-internal")));
        return n = Object.assign({
            useFetchStreams: e
        }, n), i._setSettings(n), i;
    }, "PUBLIC")), (0, $iXpG9.registerVersion)($5c04988f82cad1b3$var$D, "3.4.10", t), // BUILD_TARGET will be replaced by values like esm5, esm2017, cjs5, etc during the compilation
    (0, $iXpG9.registerVersion)($5c04988f82cad1b3$var$D, "3.4.10", "esm2017");
}();

});
parcelRegister("k46Iq", function(module, exports) {

$parcel$export(module.exports, "Component", function () { return $e9b963f2c987f856$export$16fa2f45be04daa8; });

var $isbtl = parcelRequire("isbtl");
/**
 * Component for service name T, e.g. `auth`, `auth-internal`
 */ class $e9b963f2c987f856$export$16fa2f45be04daa8 {
    setInstantiationMode(mode) {
        this.instantiationMode = mode;
        return this;
    }
    setMultipleInstances(multipleInstances) {
        this.multipleInstances = multipleInstances;
        return this;
    }
    setServiceProps(props) {
        this.serviceProps = props;
        return this;
    }
    setInstanceCreatedCallback(callback) {
        this.onInstanceCreated = callback;
        return this;
    }
    /**
     *
     * @param name The public service name, e.g. app, auth, firestore, database
     * @param instanceFactory Service factory responsible for creating the public interface
     * @param type whether the service provided by the component is public or private
     */ constructor(name, instanceFactory, type){
        this.name = name;
        this.instanceFactory = instanceFactory;
        this.type = type;
        this.multipleInstances = false;
        /**
         * Properties to be added to the service namespace
         */ this.serviceProps = {};
        this.instantiationMode = "LAZY" /* LAZY */ ;
        this.onInstanceCreated = null;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $e9b963f2c987f856$var$DEFAULT_ENTRY_NAME = "[DEFAULT]";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for instance for service name T, e.g. 'auth', 'auth-internal'
 * NameServiceMapping[T] is an alias for the type of the instance
 */ class $e9b963f2c987f856$export$2881499e37b75b9a {
    /**
     * @param identifier A provider can provide mulitple instances of a service
     * if this.component.multipleInstances is true.
     */ get(identifier) {
        // if multipleInstances is not supported, use the default name
        const normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
        if (!this.instancesDeferred.has(normalizedIdentifier)) {
            const deferred = new (0, $isbtl.Deferred)();
            this.instancesDeferred.set(normalizedIdentifier, deferred);
            if (this.isInitialized(normalizedIdentifier) || this.shouldAutoInitialize()) // initialize the service if it can be auto-initialized
            try {
                const instance = this.getOrInitializeService({
                    instanceIdentifier: normalizedIdentifier
                });
                if (instance) deferred.resolve(instance);
            } catch (e) {
            // when the instance factory throws an exception during get(), it should not cause
            // a fatal error. We just return the unresolved promise in this case.
            }
        }
        return this.instancesDeferred.get(normalizedIdentifier).promise;
    }
    getImmediate(options) {
        var _a;
        // if multipleInstances is not supported, use the default name
        const normalizedIdentifier = this.normalizeInstanceIdentifier(options === null || options === void 0 ? void 0 : options.identifier);
        const optional = (_a = options === null || options === void 0 ? void 0 : options.optional) !== null && _a !== void 0 ? _a : false;
        if (this.isInitialized(normalizedIdentifier) || this.shouldAutoInitialize()) try {
            return this.getOrInitializeService({
                instanceIdentifier: normalizedIdentifier
            });
        } catch (e) {
            if (optional) return null;
            else throw e;
        }
        else {
            // In case a component is not initialized and should/can not be auto-initialized at the moment, return null if the optional flag is set, or throw
            if (optional) return null;
            else throw Error(`Service ${this.name} is not available`);
        }
    }
    getComponent() {
        return this.component;
    }
    setComponent(component) {
        if (component.name !== this.name) throw Error(`Mismatching Component ${component.name} for Provider ${this.name}.`);
        if (this.component) throw Error(`Component for ${this.name} has already been provided`);
        this.component = component;
        // return early without attempting to initialize the component if the component requires explicit initialization (calling `Provider.initialize()`)
        if (!this.shouldAutoInitialize()) return;
        // if the service is eager, initialize the default instance
        if ($e9b963f2c987f856$var$isComponentEager(component)) try {
            this.getOrInitializeService({
                instanceIdentifier: $e9b963f2c987f856$var$DEFAULT_ENTRY_NAME
            });
        } catch (e) {
        // when the instance factory for an eager Component throws an exception during the eager
        // initialization, it should not cause a fatal error.
        // TODO: Investigate if we need to make it configurable, because some component may want to cause
        // a fatal error in this case?
        }
        // Create service instances for the pending promises and resolve them
        // NOTE: if this.multipleInstances is false, only the default instance will be created
        // and all promises with resolve with it regardless of the identifier.
        for (const [instanceIdentifier, instanceDeferred] of this.instancesDeferred.entries()){
            const normalizedIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
            try {
                // `getOrInitializeService()` should always return a valid instance since a component is guaranteed. use ! to make typescript happy.
                const instance = this.getOrInitializeService({
                    instanceIdentifier: normalizedIdentifier
                });
                instanceDeferred.resolve(instance);
            } catch (e) {
            // when the instance factory throws an exception, it should not cause
            // a fatal error. We just leave the promise unresolved.
            }
        }
    }
    clearInstance(identifier = $e9b963f2c987f856$var$DEFAULT_ENTRY_NAME) {
        this.instancesDeferred.delete(identifier);
        this.instancesOptions.delete(identifier);
        this.instances.delete(identifier);
    }
    // app.delete() will call this method on every provider to delete the services
    // TODO: should we mark the provider as deleted?
    async delete() {
        const services = Array.from(this.instances.values());
        await Promise.all([
            ...services.filter((service)=>"INTERNAL" in service) // legacy services
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .map((service)=>service.INTERNAL.delete()),
            ...services.filter((service)=>"_delete" in service) // modularized services
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .map((service)=>service._delete())
        ]);
    }
    isComponentSet() {
        return this.component != null;
    }
    isInitialized(identifier = $e9b963f2c987f856$var$DEFAULT_ENTRY_NAME) {
        return this.instances.has(identifier);
    }
    getOptions(identifier = $e9b963f2c987f856$var$DEFAULT_ENTRY_NAME) {
        return this.instancesOptions.get(identifier) || {};
    }
    initialize(opts = {}) {
        const { options: options = {} } = opts;
        const normalizedIdentifier = this.normalizeInstanceIdentifier(opts.instanceIdentifier);
        if (this.isInitialized(normalizedIdentifier)) throw Error(`${this.name}(${normalizedIdentifier}) has already been initialized`);
        if (!this.isComponentSet()) throw Error(`Component ${this.name} has not been registered yet`);
        const instance = this.getOrInitializeService({
            instanceIdentifier: normalizedIdentifier,
            options: options
        });
        // resolve any pending promise waiting for the service instance
        for (const [instanceIdentifier, instanceDeferred] of this.instancesDeferred.entries()){
            const normalizedDeferredIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
            if (normalizedIdentifier === normalizedDeferredIdentifier) instanceDeferred.resolve(instance);
        }
        return instance;
    }
    /**
     *
     * @param callback - a function that will be invoked  after the provider has been initialized by calling provider.initialize().
     * The function is invoked SYNCHRONOUSLY, so it should not execute any longrunning tasks in order to not block the program.
     *
     * @param identifier An optional instance identifier
     * @returns a function to unregister the callback
     */ onInit(callback, identifier) {
        var _a;
        const normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
        const existingCallbacks = (_a = this.onInitCallbacks.get(normalizedIdentifier)) !== null && _a !== void 0 ? _a : new Set();
        existingCallbacks.add(callback);
        this.onInitCallbacks.set(normalizedIdentifier, existingCallbacks);
        const existingInstance = this.instances.get(normalizedIdentifier);
        if (existingInstance) callback(existingInstance, normalizedIdentifier);
        return ()=>{
            existingCallbacks.delete(callback);
        };
    }
    /**
     * Invoke onInit callbacks synchronously
     * @param instance the service instance`
     */ invokeOnInitCallbacks(instance, identifier) {
        const callbacks = this.onInitCallbacks.get(identifier);
        if (!callbacks) return;
        for (const callback of callbacks)try {
            callback(instance, identifier);
        } catch (_a) {
        // ignore errors in the onInit callback
        }
    }
    getOrInitializeService({ instanceIdentifier: instanceIdentifier, options: options = {} }) {
        let instance = this.instances.get(instanceIdentifier);
        if (!instance && this.component) {
            instance = this.component.instanceFactory(this.container, {
                instanceIdentifier: $e9b963f2c987f856$var$normalizeIdentifierForFactory(instanceIdentifier),
                options: options
            });
            this.instances.set(instanceIdentifier, instance);
            this.instancesOptions.set(instanceIdentifier, options);
            /**
             * Invoke onInit listeners.
             * Note this.component.onInstanceCreated is different, which is used by the component creator,
             * while onInit listeners are registered by consumers of the provider.
             */ this.invokeOnInitCallbacks(instance, instanceIdentifier);
            /**
             * Order is important
             * onInstanceCreated() should be called after this.instances.set(instanceIdentifier, instance); which
             * makes `isInitialized()` return true.
             */ if (this.component.onInstanceCreated) try {
                this.component.onInstanceCreated(this.container, instanceIdentifier, instance);
            } catch (_a) {
            // ignore errors in the onInstanceCreatedCallback
            }
        }
        return instance || null;
    }
    normalizeInstanceIdentifier(identifier = $e9b963f2c987f856$var$DEFAULT_ENTRY_NAME) {
        if (this.component) return this.component.multipleInstances ? identifier : $e9b963f2c987f856$var$DEFAULT_ENTRY_NAME;
        else return identifier; // assume multiple instances are supported before the component is provided.
    }
    shouldAutoInitialize() {
        return !!this.component && this.component.instantiationMode !== "EXPLICIT" /* EXPLICIT */ ;
    }
    constructor(name, container){
        this.name = name;
        this.container = container;
        this.component = null;
        this.instances = new Map();
        this.instancesDeferred = new Map();
        this.instancesOptions = new Map();
        this.onInitCallbacks = new Map();
    }
}
// undefined should be passed to the service factory for the default instance
function $e9b963f2c987f856$var$normalizeIdentifierForFactory(identifier) {
    return identifier === $e9b963f2c987f856$var$DEFAULT_ENTRY_NAME ? undefined : identifier;
}
function $e9b963f2c987f856$var$isComponentEager(component) {
    return component.instantiationMode === "EAGER" /* EAGER */ ;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * ComponentContainer that provides Providers for service name T, e.g. `auth`, `auth-internal`
 */ class $e9b963f2c987f856$export$436a80eea5d5c0c5 {
    /**
     *
     * @param component Component being added
     * @param overwrite When a component with the same name has already been registered,
     * if overwrite is true: overwrite the existing component with the new component and create a new
     * provider with the new component. It can be useful in tests where you want to use different mocks
     * for different tests.
     * if overwrite is false: throw an exception
     */ addComponent(component) {
        const provider = this.getProvider(component.name);
        if (provider.isComponentSet()) throw new Error(`Component ${component.name} has already been registered with ${this.name}`);
        provider.setComponent(component);
    }
    addOrOverwriteComponent(component) {
        const provider = this.getProvider(component.name);
        if (provider.isComponentSet()) // delete the existing provider from the container, so we can register the new component
        this.providers.delete(component.name);
        this.addComponent(component);
    }
    /**
     * getProvider provides a type safe interface where it can only be called with a field name
     * present in NameServiceMapping interface.
     *
     * Firebase SDKs providing services should extend NameServiceMapping interface to register
     * themselves.
     */ getProvider(name) {
        if (this.providers.has(name)) return this.providers.get(name);
        // create a Provider for a service that hasn't registered with Firebase
        const provider = new $e9b963f2c987f856$export$2881499e37b75b9a(name, this);
        this.providers.set(name, provider);
        return provider;
    }
    getProviders() {
        return Array.from(this.providers.values());
    }
    constructor(name){
        this.name = name;
        this.providers = new Map();
    }
}

});
parcelRegister("isbtl", function(module, exports) {

$parcel$export(module.exports, "Deferred", function () { return $d6f3bdb39e758627$export$85f6557964517f1a; });
$parcel$export(module.exports, "createMockUserToken", function () { return $d6f3bdb39e758627$export$367bf224123348f1; });
$parcel$export(module.exports, "getUA", function () { return $d6f3bdb39e758627$export$c36915b22ce77c19; });
$parcel$export(module.exports, "isMobileCordova", function () { return $d6f3bdb39e758627$export$872f8323f01d7ae0; });
$parcel$export(module.exports, "isBrowserExtension", function () { return $d6f3bdb39e758627$export$caa8774a9107a58e; });
$parcel$export(module.exports, "isReactNative", function () { return $d6f3bdb39e758627$export$f7a1e23e542d38e3; });
$parcel$export(module.exports, "isElectron", function () { return $d6f3bdb39e758627$export$f2f6a8999f8ebd30; });
$parcel$export(module.exports, "isIE", function () { return $d6f3bdb39e758627$export$7e7b1a9668aaed8; });
$parcel$export(module.exports, "isUWP", function () { return $d6f3bdb39e758627$export$202944b2d2824246; });
$parcel$export(module.exports, "isSafari", function () { return $d6f3bdb39e758627$export$95df08bae54cb4df; });
$parcel$export(module.exports, "isIndexedDBAvailable", function () { return $d6f3bdb39e758627$export$3865db50535c2055; });
$parcel$export(module.exports, "FirebaseError", function () { return $d6f3bdb39e758627$export$dd24e9cd51226c56; });
$parcel$export(module.exports, "deepEqual", function () { return $d6f3bdb39e758627$export$9cb4719e2e525b7a; });
$parcel$export(module.exports, "getModularInstance", function () { return $d6f3bdb39e758627$export$4befe9b5fa509a1b; });
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Firebase constants.  Some of these (@defines) can be overridden at compile-time.
 */ const $d6f3bdb39e758627$export$588c7fdda06fbb0a = {
    /**
     * @define {boolean} Whether this is the client Node.js SDK.
     */ NODE_CLIENT: false,
    /**
     * @define {boolean} Whether this is the Admin Node.js SDK.
     */ NODE_ADMIN: false,
    /**
     * Firebase SDK Version
     */ SDK_VERSION: "${JSCORE_VERSION}"
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Throws an error if the provided assertion is falsy
 */ const $d6f3bdb39e758627$export$a7a9523472993e97 = function(assertion, message) {
    if (!assertion) throw $d6f3bdb39e758627$export$a39cad550e7ab28a(message);
};
/**
 * Returns an Error object suitable for throwing.
 */ const $d6f3bdb39e758627$export$a39cad550e7ab28a = function(message) {
    return new Error("Firebase Database (" + $d6f3bdb39e758627$export$588c7fdda06fbb0a.SDK_VERSION + ") INTERNAL ASSERT FAILED: " + message);
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $d6f3bdb39e758627$var$stringToByteArray$1 = function(str) {
    // TODO(user): Use native implementations if/when available
    const out = [];
    let p = 0;
    for(let i = 0; i < str.length; i++){
        let c = str.charCodeAt(i);
        if (c < 128) out[p++] = c;
        else if (c < 2048) {
            out[p++] = c >> 6 | 192;
            out[p++] = c & 63 | 128;
        } else if ((c & 0xfc00) === 0xd800 && i + 1 < str.length && (str.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
            // Surrogate Pair
            c = 0x10000 + ((c & 0x03ff) << 10) + (str.charCodeAt(++i) & 0x03ff);
            out[p++] = c >> 18 | 240;
            out[p++] = c >> 12 & 63 | 128;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        } else {
            out[p++] = c >> 12 | 224;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        }
    }
    return out;
};
/**
 * Turns an array of numbers into the string given by the concatenation of the
 * characters to which the numbers correspond.
 * @param bytes Array of numbers representing characters.
 * @return Stringification of the array.
 */ const $d6f3bdb39e758627$var$byteArrayToString = function(bytes) {
    // TODO(user): Use native implementations if/when available
    const out = [];
    let pos = 0, c = 0;
    while(pos < bytes.length){
        const c1 = bytes[pos++];
        if (c1 < 128) out[c++] = String.fromCharCode(c1);
        else if (c1 > 191 && c1 < 224) {
            const c2 = bytes[pos++];
            out[c++] = String.fromCharCode((c1 & 31) << 6 | c2 & 63);
        } else if (c1 > 239 && c1 < 365) {
            // Surrogate Pair
            const c2 = bytes[pos++];
            const c3 = bytes[pos++];
            const c4 = bytes[pos++];
            const u = ((c1 & 7) << 18 | (c2 & 63) << 12 | (c3 & 63) << 6 | c4 & 63) - 0x10000;
            out[c++] = String.fromCharCode(0xd800 + (u >> 10));
            out[c++] = String.fromCharCode(0xdc00 + (u & 1023));
        } else {
            const c2 = bytes[pos++];
            const c3 = bytes[pos++];
            out[c++] = String.fromCharCode((c1 & 15) << 12 | (c2 & 63) << 6 | c3 & 63);
        }
    }
    return out.join("");
};
// We define it as an object literal instead of a class because a class compiled down to es5 can't
// be treeshaked. https://github.com/rollup/rollup/issues/1691
// Static lookup maps, lazily populated by init_()
const $d6f3bdb39e758627$export$b3b2de96497acc47 = {
    /**
     * Maps bytes to characters.
     */ byteToCharMap_: null,
    /**
     * Maps characters to bytes.
     */ charToByteMap_: null,
    /**
     * Maps bytes to websafe characters.
     * @private
     */ byteToCharMapWebSafe_: null,
    /**
     * Maps websafe characters to bytes.
     * @private
     */ charToByteMapWebSafe_: null,
    /**
     * Our default alphabet, shared between
     * ENCODED_VALS and ENCODED_VALS_WEBSAFE
     */ ENCODED_VALS_BASE: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789",
    /**
     * Our default alphabet. Value 64 (=) is special; it means "nothing."
     */ get ENCODED_VALS () {
        return this.ENCODED_VALS_BASE + "+/=";
    },
    /**
     * Our websafe alphabet.
     */ get ENCODED_VALS_WEBSAFE () {
        return this.ENCODED_VALS_BASE + "-_.";
    },
    /**
     * Whether this browser supports the atob and btoa functions. This extension
     * started at Mozilla but is now implemented by many browsers. We use the
     * ASSUME_* variables to avoid pulling in the full useragent detection library
     * but still allowing the standard per-browser compilations.
     *
     */ HAS_NATIVE_SUPPORT: typeof atob === "function",
    /**
     * Base64-encode an array of bytes.
     *
     * @param input An array of bytes (numbers with
     *     value in [0, 255]) to encode.
     * @param webSafe Boolean indicating we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */ encodeByteArray (input, webSafe) {
        if (!Array.isArray(input)) throw Error("encodeByteArray takes an array as a parameter");
        this.init_();
        const byteToCharMap = webSafe ? this.byteToCharMapWebSafe_ : this.byteToCharMap_;
        const output = [];
        for(let i = 0; i < input.length; i += 3){
            const byte1 = input[i];
            const haveByte2 = i + 1 < input.length;
            const byte2 = haveByte2 ? input[i + 1] : 0;
            const haveByte3 = i + 2 < input.length;
            const byte3 = haveByte3 ? input[i + 2] : 0;
            const outByte1 = byte1 >> 2;
            const outByte2 = (byte1 & 0x03) << 4 | byte2 >> 4;
            let outByte3 = (byte2 & 0x0f) << 2 | byte3 >> 6;
            let outByte4 = byte3 & 0x3f;
            if (!haveByte3) {
                outByte4 = 64;
                if (!haveByte2) outByte3 = 64;
            }
            output.push(byteToCharMap[outByte1], byteToCharMap[outByte2], byteToCharMap[outByte3], byteToCharMap[outByte4]);
        }
        return output.join("");
    },
    /**
     * Base64-encode a string.
     *
     * @param input A string to encode.
     * @param webSafe If true, we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */ encodeString (input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) return btoa(input);
        return this.encodeByteArray($d6f3bdb39e758627$var$stringToByteArray$1(input), webSafe);
    },
    /**
     * Base64-decode a string.
     *
     * @param input to decode.
     * @param webSafe True if we should use the
     *     alternative alphabet.
     * @return string representing the decoded value.
     */ decodeString (input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) return atob(input);
        return $d6f3bdb39e758627$var$byteArrayToString(this.decodeStringToByteArray(input, webSafe));
    },
    /**
     * Base64-decode a string.
     *
     * In base-64 decoding, groups of four characters are converted into three
     * bytes.  If the encoder did not apply padding, the input length may not
     * be a multiple of 4.
     *
     * In this case, the last group will have fewer than 4 characters, and
     * padding will be inferred.  If the group has one or two characters, it decodes
     * to one byte.  If the group has three characters, it decodes to two bytes.
     *
     * @param input Input to decode.
     * @param webSafe True if we should use the web-safe alphabet.
     * @return bytes representing the decoded value.
     */ decodeStringToByteArray (input, webSafe) {
        this.init_();
        const charToByteMap = webSafe ? this.charToByteMapWebSafe_ : this.charToByteMap_;
        const output = [];
        for(let i = 0; i < input.length;){
            const byte1 = charToByteMap[input.charAt(i++)];
            const haveByte2 = i < input.length;
            const byte2 = haveByte2 ? charToByteMap[input.charAt(i)] : 0;
            ++i;
            const haveByte3 = i < input.length;
            const byte3 = haveByte3 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            const haveByte4 = i < input.length;
            const byte4 = haveByte4 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            if (byte1 == null || byte2 == null || byte3 == null || byte4 == null) throw Error();
            const outByte1 = byte1 << 2 | byte2 >> 4;
            output.push(outByte1);
            if (byte3 !== 64) {
                const outByte2 = byte2 << 4 & 0xf0 | byte3 >> 2;
                output.push(outByte2);
                if (byte4 !== 64) {
                    const outByte3 = byte3 << 6 & 0xc0 | byte4;
                    output.push(outByte3);
                }
            }
        }
        return output;
    },
    /**
     * Lazy static initialization function. Called before
     * accessing any of the static map variables.
     * @private
     */ init_ () {
        if (!this.byteToCharMap_) {
            this.byteToCharMap_ = {};
            this.charToByteMap_ = {};
            this.byteToCharMapWebSafe_ = {};
            this.charToByteMapWebSafe_ = {};
            // We want quick mappings back and forth, so we precompute two maps.
            for(let i = 0; i < this.ENCODED_VALS.length; i++){
                this.byteToCharMap_[i] = this.ENCODED_VALS.charAt(i);
                this.charToByteMap_[this.byteToCharMap_[i]] = i;
                this.byteToCharMapWebSafe_[i] = this.ENCODED_VALS_WEBSAFE.charAt(i);
                this.charToByteMapWebSafe_[this.byteToCharMapWebSafe_[i]] = i;
                // Be forgiving when decoding and correctly decode both encodings.
                if (i >= this.ENCODED_VALS_BASE.length) {
                    this.charToByteMap_[this.ENCODED_VALS_WEBSAFE.charAt(i)] = i;
                    this.charToByteMapWebSafe_[this.ENCODED_VALS.charAt(i)] = i;
                }
            }
        }
    }
};
/**
 * URL-safe base64 encoding
 */ const $d6f3bdb39e758627$export$e510a73ee562749 = function(str) {
    const utf8Bytes = $d6f3bdb39e758627$var$stringToByteArray$1(str);
    return $d6f3bdb39e758627$export$b3b2de96497acc47.encodeByteArray(utf8Bytes, true);
};
/**
 * URL-safe base64 encoding (without "." padding in the end).
 * e.g. Used in JSON Web Token (JWT) parts.
 */ const $d6f3bdb39e758627$export$4b5284a3025a455 = function(str) {
    // Use base64url encoding and remove padding in the end (dot characters).
    return $d6f3bdb39e758627$export$e510a73ee562749(str).replace(/\./g, "");
};
/**
 * URL-safe base64 decoding
 *
 * NOTE: DO NOT use the global atob() function - it does NOT support the
 * base64Url variant encoding.
 *
 * @param str To be decoded
 * @return Decoded result, if possible
 */ const $d6f3bdb39e758627$export$c62426fdd000a97e = function(str) {
    try {
        return $d6f3bdb39e758627$export$b3b2de96497acc47.decodeString(str, true);
    } catch (e) {
        console.error("base64Decode failed: ", e);
    }
    return null;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Do a deep-copy of basic JavaScript Objects or Arrays.
 */ function $d6f3bdb39e758627$export$6c40052bed430212(value) {
    return $d6f3bdb39e758627$export$54e9fb29908872fa(undefined, value);
}
/**
 * Copy properties from source to target (recursively allows extension
 * of Objects and Arrays).  Scalar values in the target are over-written.
 * If target is undefined, an object of the appropriate type will be created
 * (and returned).
 *
 * We recursively copy all child properties of plain Objects in the source- so
 * that namespace- like dictionaries are merged.
 *
 * Note that the target can be a function, in which case the properties in
 * the source Object are copied onto it as static properties of the Function.
 *
 * Note: we don't merge __proto__ to prevent prototype pollution
 */ function $d6f3bdb39e758627$export$54e9fb29908872fa(target, source) {
    if (!(source instanceof Object)) return source;
    switch(source.constructor){
        case Date:
            // Treat Dates like scalars; if the target date object had any child
            // properties - they will be lost!
            const dateValue = source;
            return new Date(dateValue.getTime());
        case Object:
            if (target === undefined) target = {};
            break;
        case Array:
            // Always copy the array source and overwrite the target.
            target = [];
            break;
        default:
            // Not a plain Object - treat it as a scalar.
            return source;
    }
    for(const prop in source){
        // use isValidKey to guard against prototype pollution. See https://snyk.io/vuln/SNYK-JS-LODASH-450202
        if (!source.hasOwnProperty(prop) || !$d6f3bdb39e758627$var$isValidKey(prop)) continue;
        target[prop] = $d6f3bdb39e758627$export$54e9fb29908872fa(target[prop], source[prop]);
    }
    return target;
}
function $d6f3bdb39e758627$var$isValidKey(key) {
    return key !== "__proto__";
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $d6f3bdb39e758627$export$85f6557964517f1a {
    /**
     * Our API internals are not promiseified and cannot because our callback APIs have subtle expectations around
     * invoking promises inline, which Promises are forbidden to do. This method accepts an optional node-style callback
     * and returns a node-style callback which will resolve or reject the Deferred's promise.
     */ wrapCallback(callback) {
        return (error, value)=>{
            if (error) this.reject(error);
            else this.resolve(value);
            if (typeof callback === "function") {
                // Attaching noop handler just in case developer wasn't expecting
                // promises
                this.promise.catch(()=>{});
                // Some of our callbacks don't expect a value and our own tests
                // assert that the parameter length is 1
                if (callback.length === 1) callback(error);
                else callback(error, value);
            }
        };
    }
    constructor(){
        this.reject = ()=>{};
        this.resolve = ()=>{};
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
    }
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $d6f3bdb39e758627$export$367bf224123348f1(token, projectId) {
    if (token.uid) throw new Error('The "uid" field is no longer supported by mockUserToken. Please use "sub" instead for Firebase Auth User ID.');
    // Unsecured JWTs use "none" as the algorithm.
    const header = {
        alg: "none",
        type: "JWT"
    };
    const project = projectId || "demo-project";
    const iat = token.iat || 0;
    const sub = token.sub || token.user_id;
    if (!sub) throw new Error("mockUserToken must contain 'sub' or 'user_id' field!");
    const payload = Object.assign({
        // Set all required fields to decent defaults
        iss: `https://securetoken.google.com/${project}`,
        aud: project,
        iat: iat,
        exp: iat + 3600,
        auth_time: iat,
        sub: sub,
        user_id: sub,
        firebase: {
            sign_in_provider: "custom",
            identities: {}
        }
    }, token);
    // Unsecured JWTs use the empty string as a signature.
    const signature = "";
    return [
        $d6f3bdb39e758627$export$4b5284a3025a455(JSON.stringify(header)),
        $d6f3bdb39e758627$export$4b5284a3025a455(JSON.stringify(payload)),
        signature
    ].join(".");
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns navigator.userAgent string or '' if it's not defined.
 * @return user agent string
 */ function $d6f3bdb39e758627$export$c36915b22ce77c19() {
    if (typeof navigator !== "undefined" && typeof navigator["userAgent"] === "string") return navigator["userAgent"];
    else return "";
}
/**
 * Detect Cordova / PhoneGap / Ionic frameworks on a mobile device.
 *
 * Deliberately does not rely on checking `file://` URLs (as this fails PhoneGap
 * in the Ripple emulator) nor Cordova `onDeviceReady`, which would normally
 * wait for a callback.
 */ function $d6f3bdb39e758627$export$872f8323f01d7ae0() {
    return typeof window !== "undefined" && // @ts-ignore Setting up an broadly applicable index signature for Window
    // just to deal with this case would probably be a bad idea.
    !!(window["cordova"] || window["phonegap"] || window["PhoneGap"]) && /ios|iphone|ipod|ipad|android|blackberry|iemobile/i.test($d6f3bdb39e758627$export$c36915b22ce77c19());
}
/**
 * Detect Node.js.
 *
 * @return true if Node.js environment is detected.
 */ // Node detection logic from: https://github.com/iliakan/detect-node/
function $d6f3bdb39e758627$export$8ee0fc9ee280b4ee() {
    try {
        return Object.prototype.toString.call($parcel$global.process) === "[object process]";
    } catch (e) {
        return false;
    }
}
/**
 * Detect Browser Environment
 */ function $d6f3bdb39e758627$export$4e09c449d6c407f7() {
    return typeof self === "object" && self.self === self;
}
function $d6f3bdb39e758627$export$caa8774a9107a58e() {
    const runtime = typeof chrome === "object" ? chrome.runtime : typeof browser === "object" ? browser.runtime : undefined;
    return typeof runtime === "object" && runtime.id !== undefined;
}
/**
 * Detect React Native.
 *
 * @return true if ReactNative environment is detected.
 */ function $d6f3bdb39e758627$export$f7a1e23e542d38e3() {
    return typeof navigator === "object" && navigator["product"] === "ReactNative";
}
/** Detects Electron apps. */ function $d6f3bdb39e758627$export$f2f6a8999f8ebd30() {
    return $d6f3bdb39e758627$export$c36915b22ce77c19().indexOf("Electron/") >= 0;
}
/** Detects Internet Explorer. */ function $d6f3bdb39e758627$export$7e7b1a9668aaed8() {
    const ua = $d6f3bdb39e758627$export$c36915b22ce77c19();
    return ua.indexOf("MSIE ") >= 0 || ua.indexOf("Trident/") >= 0;
}
/** Detects Universal Windows Platform apps. */ function $d6f3bdb39e758627$export$202944b2d2824246() {
    return $d6f3bdb39e758627$export$c36915b22ce77c19().indexOf("MSAppHost/") >= 0;
}
/**
 * Detect whether the current SDK build is the Node version.
 *
 * @return true if it's the Node SDK build.
 */ function $d6f3bdb39e758627$export$5d1d834fbbf8bab7() {
    return $d6f3bdb39e758627$export$588c7fdda06fbb0a.NODE_CLIENT === true || $d6f3bdb39e758627$export$588c7fdda06fbb0a.NODE_ADMIN === true;
}
/** Returns true if we are running in Safari. */ function $d6f3bdb39e758627$export$95df08bae54cb4df() {
    return !$d6f3bdb39e758627$export$8ee0fc9ee280b4ee() && navigator.userAgent.includes("Safari") && !navigator.userAgent.includes("Chrome");
}
/**
 * This method checks if indexedDB is supported by current browser/service worker context
 * @return true if indexedDB is supported by current browser/service worker context
 */ function $d6f3bdb39e758627$export$3865db50535c2055() {
    return typeof indexedDB === "object";
}
/**
 * This method validates browser/sw context for indexedDB by opening a dummy indexedDB database and reject
 * if errors occur during the database open operation.
 *
 * @throws exception if current browser/sw context can't run idb.open (ex: Safari iframe, Firefox
 * private browsing)
 */ function $d6f3bdb39e758627$export$a8a3018f3d187a4d() {
    return new Promise((resolve, reject)=>{
        try {
            let preExist = true;
            const DB_CHECK_NAME = "validate-browser-context-for-indexeddb-analytics-module";
            const request = self.indexedDB.open(DB_CHECK_NAME);
            request.onsuccess = ()=>{
                request.result.close();
                // delete database only when it doesn't pre-exist
                if (!preExist) self.indexedDB.deleteDatabase(DB_CHECK_NAME);
                resolve(true);
            };
            request.onupgradeneeded = ()=>{
                preExist = false;
            };
            request.onerror = ()=>{
                var _a;
                reject(((_a = request.error) === null || _a === void 0 ? void 0 : _a.message) || "");
            };
        } catch (error) {
            reject(error);
        }
    });
}
/**
 *
 * This method checks whether cookie is enabled within current browser
 * @return true if cookie is enabled within current browser
 */ function $d6f3bdb39e758627$export$f172b7eb6cf60599() {
    if (typeof navigator === "undefined" || !navigator.cookieEnabled) return false;
    return true;
}
/**
 * Polyfill for `globalThis` object.
 * @returns the `globalThis` object for the given environment.
 */ function $d6f3bdb39e758627$export$a4e55266d2135a7f() {
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw new Error("Unable to locate global object.");
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Standardized Firebase Error.
 *
 * Usage:
 *
 *   // Typescript string literals for type-safe codes
 *   type Err =
 *     'unknown' |
 *     'object-not-found'
 *     ;
 *
 *   // Closure enum for type-safe error codes
 *   // at-enum {string}
 *   var Err = {
 *     UNKNOWN: 'unknown',
 *     OBJECT_NOT_FOUND: 'object-not-found',
 *   }
 *
 *   let errors: Map<Err, string> = {
 *     'generic-error': "Unknown error",
 *     'file-not-found': "Could not find file: {$file}",
 *   };
 *
 *   // Type-safe function - must pass a valid error code as param.
 *   let error = new ErrorFactory<Err>('service', 'Service', errors);
 *
 *   ...
 *   throw error.create(Err.GENERIC);
 *   ...
 *   throw error.create(Err.FILE_NOT_FOUND, {'file': fileName});
 *   ...
 *   // Service: Could not file file: foo.txt (service/file-not-found).
 *
 *   catch (e) {
 *     assert(e.message === "Could not find file: foo.txt.");
 *     if (e.code === 'service/file-not-found') {
 *       console.log("Could not read file: " + e['file']);
 *     }
 *   }
 */ const $d6f3bdb39e758627$var$ERROR_NAME = "FirebaseError";
// Based on code from:
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Custom_Error_Types
class $d6f3bdb39e758627$export$dd24e9cd51226c56 extends Error {
    constructor(/** The error code for this error. */ code, message, /** Custom data for this error. */ customData){
        super(message);
        this.code = code;
        this.customData = customData;
        /** The custom name for all FirebaseErrors. */ this.name = $d6f3bdb39e758627$var$ERROR_NAME;
        // Fix For ES5
        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $d6f3bdb39e758627$export$dd24e9cd51226c56.prototype);
        // Maintains proper stack trace for where our error was thrown.
        // Only available on V8.
        if (Error.captureStackTrace) Error.captureStackTrace(this, $d6f3bdb39e758627$export$3fa6e1b18a3b2d40.prototype.create);
    }
}
class $d6f3bdb39e758627$export$3fa6e1b18a3b2d40 {
    create(code, ...data) {
        const customData = data[0] || {};
        const fullCode = `${this.service}/${code}`;
        const template = this.errors[code];
        const message = template ? $d6f3bdb39e758627$var$replaceTemplate(template, customData) : "Error";
        // Service Name: Error message (service/code).
        const fullMessage = `${this.serviceName}: ${message} (${fullCode}).`;
        const error = new $d6f3bdb39e758627$export$dd24e9cd51226c56(fullCode, fullMessage, customData);
        return error;
    }
    constructor(service, serviceName, errors){
        this.service = service;
        this.serviceName = serviceName;
        this.errors = errors;
    }
}
function $d6f3bdb39e758627$var$replaceTemplate(template, data) {
    return template.replace($d6f3bdb39e758627$var$PATTERN, (_, key)=>{
        const value = data[key];
        return value != null ? String(value) : `<${key}?>`;
    });
}
const $d6f3bdb39e758627$var$PATTERN = /\{\$([^}]+)}/g;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Evaluates a JSON string into a javascript object.
 *
 * @param {string} str A string containing JSON.
 * @return {*} The javascript object representing the specified JSON.
 */ function $d6f3bdb39e758627$export$c5a53ce6a17cf18d(str) {
    return JSON.parse(str);
}
/**
 * Returns JSON representing a javascript object.
 * @param {*} data Javascript object to be stringified.
 * @return {string} The JSON contents of the object.
 */ function $d6f3bdb39e758627$export$fac44ee5b035f737(data) {
    return JSON.stringify(data);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Decodes a Firebase auth. token into constituent parts.
 *
 * Notes:
 * - May return with invalid / incomplete claims if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $d6f3bdb39e758627$export$2f872c0f2117be69 = function(token) {
    let header = {}, claims = {}, data = {}, signature = "";
    try {
        const parts = token.split(".");
        header = $d6f3bdb39e758627$export$c5a53ce6a17cf18d($d6f3bdb39e758627$export$c62426fdd000a97e(parts[0]) || "");
        claims = $d6f3bdb39e758627$export$c5a53ce6a17cf18d($d6f3bdb39e758627$export$c62426fdd000a97e(parts[1]) || "");
        signature = parts[2];
        data = claims["d"] || {};
        delete claims["d"];
    } catch (e) {}
    return {
        header: header,
        claims: claims,
        data: data,
        signature: signature
    };
};
/**
 * Decodes a Firebase auth. token and checks the validity of its time-based claims. Will return true if the
 * token is within the time window authorized by the 'nbf' (not-before) and 'iat' (issued-at) claims.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $d6f3bdb39e758627$export$5f870fcca7ae6a88 = function(token) {
    const claims = $d6f3bdb39e758627$export$2f872c0f2117be69(token).claims;
    const now = Math.floor(new Date().getTime() / 1000);
    let validSince = 0, validUntil = 0;
    if (typeof claims === "object") {
        if (claims.hasOwnProperty("nbf")) validSince = claims["nbf"];
        else if (claims.hasOwnProperty("iat")) validSince = claims["iat"];
        if (claims.hasOwnProperty("exp")) validUntil = claims["exp"];
        else // token will expire after 24h by default
        validUntil = validSince + 86400;
    }
    return !!now && !!validSince && !!validUntil && now >= validSince && now <= validUntil;
};
/**
 * Decodes a Firebase auth. token and returns its issued at time if valid, null otherwise.
 *
 * Notes:
 * - May return null if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $d6f3bdb39e758627$export$701c661ec91095f2 = function(token) {
    const claims = $d6f3bdb39e758627$export$2f872c0f2117be69(token).claims;
    if (typeof claims === "object" && claims.hasOwnProperty("iat")) return claims["iat"];
    return null;
};
/**
 * Decodes a Firebase auth. token and checks the validity of its format. Expects a valid issued-at time.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $d6f3bdb39e758627$export$9565ca3d387f8aa0 = function(token) {
    const decoded = $d6f3bdb39e758627$export$2f872c0f2117be69(token), claims = decoded.claims;
    return !!claims && typeof claims === "object" && claims.hasOwnProperty("iat");
};
/**
 * Attempts to peer into an auth token and determine if it's an admin auth token by looking at the claims portion.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $d6f3bdb39e758627$export$fc970ed23da99565 = function(token) {
    const claims = $d6f3bdb39e758627$export$2f872c0f2117be69(token).claims;
    return typeof claims === "object" && claims["admin"] === true;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $d6f3bdb39e758627$export$2344b14b097df817(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
}
function $d6f3bdb39e758627$export$e51ae4db7b428f67(obj, key) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) return obj[key];
    else return undefined;
}
function $d6f3bdb39e758627$export$dd1bc94b04021eeb(obj) {
    for(const key in obj){
        if (Object.prototype.hasOwnProperty.call(obj, key)) return false;
    }
    return true;
}
function $d6f3bdb39e758627$export$871de8747c9eaa88(obj, fn, contextObj) {
    const res = {};
    for(const key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) res[key] = fn.call(contextObj, obj[key], key, obj);
    return res;
}
/**
 * Deep equal two objects. Support Arrays and Objects.
 */ function $d6f3bdb39e758627$export$9cb4719e2e525b7a(a, b) {
    if (a === b) return true;
    const aKeys = Object.keys(a);
    const bKeys = Object.keys(b);
    for (const k of aKeys){
        if (!bKeys.includes(k)) return false;
        const aProp = a[k];
        const bProp = b[k];
        if ($d6f3bdb39e758627$var$isObject(aProp) && $d6f3bdb39e758627$var$isObject(bProp)) {
            if (!$d6f3bdb39e758627$export$9cb4719e2e525b7a(aProp, bProp)) return false;
        } else if (aProp !== bProp) return false;
    }
    for (const k of bKeys){
        if (!aKeys.includes(k)) return false;
    }
    return true;
}
function $d6f3bdb39e758627$var$isObject(thing) {
    return thing !== null && typeof thing === "object";
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a querystring-formatted string (e.g. &arg=val&arg2=val2) from a
 * params object (e.g. {arg: 'val', arg2: 'val2'})
 * Note: You must prepend it with ? when adding it to a URL.
 */ function $d6f3bdb39e758627$export$ac4103b836844853(querystringParams) {
    const params = [];
    for (const [key, value] of Object.entries(querystringParams))if (Array.isArray(value)) value.forEach((arrayVal)=>{
        params.push(encodeURIComponent(key) + "=" + encodeURIComponent(arrayVal));
    });
    else params.push(encodeURIComponent(key) + "=" + encodeURIComponent(value));
    return params.length ? "&" + params.join("&") : "";
}
/**
 * Decodes a querystring (e.g. ?arg=val&arg2=val2) into a params object
 * (e.g. {arg: 'val', arg2: 'val2'})
 */ function $d6f3bdb39e758627$export$c1271ca4c8a70741(querystring) {
    const obj = {};
    const tokens = querystring.replace(/^\?/, "").split("&");
    tokens.forEach((token)=>{
        if (token) {
            const [key, value] = token.split("=");
            obj[decodeURIComponent(key)] = decodeURIComponent(value);
        }
    });
    return obj;
}
/**
 * Extract the query string part of a URL, including the leading question mark (if present).
 */ function $d6f3bdb39e758627$export$1a8408415472d8ed(url) {
    const queryStart = url.indexOf("?");
    if (!queryStart) return "";
    const fragmentStart = url.indexOf("#", queryStart);
    return url.substring(queryStart, fragmentStart > 0 ? fragmentStart : undefined);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview SHA-1 cryptographic hash.
 * Variable names follow the notation in FIPS PUB 180-3:
 * http://csrc.nist.gov/publications/fips/fips180-3/fips180-3_final.pdf.
 *
 * Usage:
 *   var sha1 = new sha1();
 *   sha1.update(bytes);
 *   var hash = sha1.digest();
 *
 * Performance:
 *   Chrome 23:   ~400 Mbit/s
 *   Firefox 16:  ~250 Mbit/s
 *
 */ /**
 * SHA-1 cryptographic hash constructor.
 *
 * The properties declared here are discussed in the above algorithm document.
 * @constructor
 * @final
 * @struct
 */ class $d6f3bdb39e758627$export$c85d589bf4e25fef {
    reset() {
        this.chain_[0] = 0x67452301;
        this.chain_[1] = 0xefcdab89;
        this.chain_[2] = 0x98badcfe;
        this.chain_[3] = 0x10325476;
        this.chain_[4] = 0xc3d2e1f0;
        this.inbuf_ = 0;
        this.total_ = 0;
    }
    /**
     * Internal compress helper function.
     * @param buf Block to compress.
     * @param offset Offset of the block in the buffer.
     * @private
     */ compress_(buf, offset) {
        if (!offset) offset = 0;
        const W = this.W_;
        // get 16 big endian words
        if (typeof buf === "string") for(let i = 0; i < 16; i++){
            // TODO(user): [bug 8140122] Recent versions of Safari for Mac OS and iOS
            // have a bug that turns the post-increment ++ operator into pre-increment
            // during JIT compilation.  We have code that depends heavily on SHA-1 for
            // correctness and which is affected by this bug, so I've removed all uses
            // of post-increment ++ in which the result value is used.  We can revert
            // this change once the Safari bug
            // (https://bugs.webkit.org/show_bug.cgi?id=109036) has been fixed and
            // most clients have been updated.
            W[i] = buf.charCodeAt(offset) << 24 | buf.charCodeAt(offset + 1) << 16 | buf.charCodeAt(offset + 2) << 8 | buf.charCodeAt(offset + 3);
            offset += 4;
        }
        else for(let i = 0; i < 16; i++){
            W[i] = buf[offset] << 24 | buf[offset + 1] << 16 | buf[offset + 2] << 8 | buf[offset + 3];
            offset += 4;
        }
        // expand to 80 words
        for(let i = 16; i < 80; i++){
            const t = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
            W[i] = (t << 1 | t >>> 31) & 0xffffffff;
        }
        let a = this.chain_[0];
        let b = this.chain_[1];
        let c = this.chain_[2];
        let d = this.chain_[3];
        let e = this.chain_[4];
        let f, k;
        // TODO(user): Try to unroll this loop to speed up the computation.
        for(let i = 0; i < 80; i++){
            if (i < 40) {
                if (i < 20) {
                    f = d ^ b & (c ^ d);
                    k = 0x5a827999;
                } else {
                    f = b ^ c ^ d;
                    k = 0x6ed9eba1;
                }
            } else if (i < 60) {
                f = b & c | d & (b | c);
                k = 0x8f1bbcdc;
            } else {
                f = b ^ c ^ d;
                k = 0xca62c1d6;
            }
            const t = (a << 5 | a >>> 27) + f + e + k + W[i] & 0xffffffff;
            e = d;
            d = c;
            c = (b << 30 | b >>> 2) & 0xffffffff;
            b = a;
            a = t;
        }
        this.chain_[0] = this.chain_[0] + a & 0xffffffff;
        this.chain_[1] = this.chain_[1] + b & 0xffffffff;
        this.chain_[2] = this.chain_[2] + c & 0xffffffff;
        this.chain_[3] = this.chain_[3] + d & 0xffffffff;
        this.chain_[4] = this.chain_[4] + e & 0xffffffff;
    }
    update(bytes, length) {
        // TODO(johnlenz): tighten the function signature and remove this check
        if (bytes == null) return;
        if (length === undefined) length = bytes.length;
        const lengthMinusBlock = length - this.blockSize;
        let n = 0;
        // Using local instead of member variables gives ~5% speedup on Firefox 16.
        const buf = this.buf_;
        let inbuf = this.inbuf_;
        // The outer while loop should execute at most twice.
        while(n < length){
            // When we have no data in the block to top up, we can directly process the
            // input buffer (assuming it contains sufficient data). This gives ~25%
            // speedup on Chrome 23 and ~15% speedup on Firefox 16, but requires that
            // the data is provided in large chunks (or in multiples of 64 bytes).
            if (inbuf === 0) while(n <= lengthMinusBlock){
                this.compress_(bytes, n);
                n += this.blockSize;
            }
            if (typeof bytes === "string") while(n < length){
                buf[inbuf] = bytes.charCodeAt(n);
                ++inbuf;
                ++n;
                if (inbuf === this.blockSize) {
                    this.compress_(buf);
                    inbuf = 0;
                    break;
                }
            }
            else while(n < length){
                buf[inbuf] = bytes[n];
                ++inbuf;
                ++n;
                if (inbuf === this.blockSize) {
                    this.compress_(buf);
                    inbuf = 0;
                    break;
                }
            }
        }
        this.inbuf_ = inbuf;
        this.total_ += length;
    }
    /** @override */ digest() {
        const digest = [];
        let totalBits = this.total_ * 8;
        // Add pad 0x80 0x00*.
        if (this.inbuf_ < 56) this.update(this.pad_, 56 - this.inbuf_);
        else this.update(this.pad_, this.blockSize - (this.inbuf_ - 56));
        // Add # bits.
        for(let i = this.blockSize - 1; i >= 56; i--){
            this.buf_[i] = totalBits & 255;
            totalBits /= 256; // Don't use bit-shifting here!
        }
        this.compress_(this.buf_);
        let n = 0;
        for(let i = 0; i < 5; i++)for(let j = 24; j >= 0; j -= 8){
            digest[n] = this.chain_[i] >> j & 255;
            ++n;
        }
        return digest;
    }
    constructor(){
        /**
         * Holds the previous values of accumulated variables a-e in the compress_
         * function.
         * @private
         */ this.chain_ = [];
        /**
         * A buffer holding the partially computed hash result.
         * @private
         */ this.buf_ = [];
        /**
         * An array of 80 bytes, each a part of the message to be hashed.  Referred to
         * as the message schedule in the docs.
         * @private
         */ this.W_ = [];
        /**
         * Contains data needed to pad messages less than 64 bytes.
         * @private
         */ this.pad_ = [];
        /**
         * @private {number}
         */ this.inbuf_ = 0;
        /**
         * @private {number}
         */ this.total_ = 0;
        this.blockSize = 64;
        this.pad_[0] = 128;
        for(let i = 1; i < this.blockSize; ++i)this.pad_[i] = 0;
        this.reset();
    }
}
/**
 * Helper to make a Subscribe function (just like Promise helps make a
 * Thenable).
 *
 * @param executor Function which can make calls to a single Observer
 *     as a proxy.
 * @param onNoObservers Callback when count of Observers goes to zero.
 */ function $d6f3bdb39e758627$export$364097d812234b3f(executor, onNoObservers) {
    const proxy = new $d6f3bdb39e758627$var$ObserverProxy(executor, onNoObservers);
    return proxy.subscribe.bind(proxy);
}
/**
 * Implement fan-out for any number of Observers attached via a subscribe
 * function.
 */ class $d6f3bdb39e758627$var$ObserverProxy {
    next(value) {
        this.forEachObserver((observer)=>{
            observer.next(value);
        });
    }
    error(error) {
        this.forEachObserver((observer)=>{
            observer.error(error);
        });
        this.close(error);
    }
    complete() {
        this.forEachObserver((observer)=>{
            observer.complete();
        });
        this.close();
    }
    /**
     * Subscribe function that can be used to add an Observer to the fan-out list.
     *
     * - We require that no event is sent to a subscriber sychronously to their
     *   call to subscribe().
     */ subscribe(nextOrObserver, error, complete) {
        let observer;
        if (nextOrObserver === undefined && error === undefined && complete === undefined) throw new Error("Missing Observer.");
        // Assemble an Observer object when passed as callback functions.
        if ($d6f3bdb39e758627$var$implementsAnyMethods(nextOrObserver, [
            "next",
            "error",
            "complete"
        ])) observer = nextOrObserver;
        else observer = {
            next: nextOrObserver,
            error: error,
            complete: complete
        };
        if (observer.next === undefined) observer.next = $d6f3bdb39e758627$var$noop;
        if (observer.error === undefined) observer.error = $d6f3bdb39e758627$var$noop;
        if (observer.complete === undefined) observer.complete = $d6f3bdb39e758627$var$noop;
        const unsub = this.unsubscribeOne.bind(this, this.observers.length);
        // Attempt to subscribe to a terminated Observable - we
        // just respond to the Observer with the final error or complete
        // event.
        if (this.finalized) // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            try {
                if (this.finalError) observer.error(this.finalError);
                else observer.complete();
            } catch (e) {
            // nothing
            }
            return;
        });
        this.observers.push(observer);
        return unsub;
    }
    // Unsubscribe is synchronous - we guarantee that no events are sent to
    // any unsubscribed Observer.
    unsubscribeOne(i) {
        if (this.observers === undefined || this.observers[i] === undefined) return;
        delete this.observers[i];
        this.observerCount -= 1;
        if (this.observerCount === 0 && this.onNoObservers !== undefined) this.onNoObservers(this);
    }
    forEachObserver(fn) {
        if (this.finalized) // Already closed by previous event....just eat the additional values.
        return;
        // Since sendOne calls asynchronously - there is no chance that
        // this.observers will become undefined.
        for(let i = 0; i < this.observers.length; i++)this.sendOne(i, fn);
    }
    // Call the Observer via one of it's callback function. We are careful to
    // confirm that the observe has not been unsubscribed since this asynchronous
    // function had been queued.
    sendOne(i, fn) {
        // Execute the callback asynchronously
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            if (this.observers !== undefined && this.observers[i] !== undefined) try {
                fn(this.observers[i]);
            } catch (e) {
                // Ignore exceptions raised in Observers or missing methods of an
                // Observer.
                // Log error to console. b/31404806
                if (typeof console !== "undefined" && console.error) console.error(e);
            }
        });
    }
    close(err) {
        if (this.finalized) return;
        this.finalized = true;
        if (err !== undefined) this.finalError = err;
        // Proxy is no longer needed - garbage collect references
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            this.observers = undefined;
            this.onNoObservers = undefined;
        });
    }
    /**
     * @param executor Function which can make calls to a single Observer
     *     as a proxy.
     * @param onNoObservers Callback when count of Observers goes to zero.
     */ constructor(executor, onNoObservers){
        this.observers = [];
        this.unsubscribes = [];
        this.observerCount = 0;
        // Micro-task scheduling by calling task.then().
        this.task = Promise.resolve();
        this.finalized = false;
        this.onNoObservers = onNoObservers;
        // Call the executor asynchronously so subscribers that are called
        // synchronously after the creation of the subscribe function
        // can still receive the very first value generated in the executor.
        this.task.then(()=>{
            executor(this);
        }).catch((e)=>{
            this.error(e);
        });
    }
}
/** Turn synchronous function into one called asynchronously. */ // eslint-disable-next-line @typescript-eslint/ban-types
function $d6f3bdb39e758627$export$12af436354f1a4f7(fn, onError) {
    return (...args)=>{
        Promise.resolve(true).then(()=>{
            fn(...args);
        }).catch((error)=>{
            if (onError) onError(error);
        });
    };
}
/**
 * Return true if the object passed in implements any of the named methods.
 */ function $d6f3bdb39e758627$var$implementsAnyMethods(obj, methods) {
    if (typeof obj !== "object" || obj === null) return false;
    for (const method of methods){
        if (method in obj && typeof obj[method] === "function") return true;
    }
    return false;
}
function $d6f3bdb39e758627$var$noop() {
// do nothing
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Check to make sure the appropriate number of arguments are provided for a public function.
 * Throws an error if it fails.
 *
 * @param fnName The function name
 * @param minCount The minimum number of arguments to allow for the function call
 * @param maxCount The maximum number of argument to allow for the function call
 * @param argCount The actual number of arguments provided.
 */ const $d6f3bdb39e758627$export$20164226a0ed35c3 = function(fnName, minCount, maxCount, argCount) {
    let argError;
    if (argCount < minCount) argError = "at least " + minCount;
    else if (argCount > maxCount) argError = maxCount === 0 ? "none" : "no more than " + maxCount;
    if (argError) {
        const error = fnName + " failed: Was called with " + argCount + (argCount === 1 ? " argument." : " arguments.") + " Expects " + argError + ".";
        throw new Error(error);
    }
};
/**
 * Generates a string to prefix an error message about failed argument validation
 *
 * @param fnName The function name
 * @param argName The name of the argument
 * @return The prefix to add to the error thrown for validation.
 */ function $d6f3bdb39e758627$export$adea4917e02d93dc(fnName, argName) {
    return `${fnName} failed: ${argName} argument `;
}
/**
 * @param fnName
 * @param argumentNumber
 * @param namespace
 * @param optional
 */ function $d6f3bdb39e758627$export$8eef22622e725943(fnName, namespace, optional) {
    if (optional && !namespace) return;
    if (typeof namespace !== "string") //TODO: I should do more validation here. We only allow certain chars in namespaces.
    throw new Error($d6f3bdb39e758627$export$adea4917e02d93dc(fnName, "namespace") + "must be a valid firebase namespace.");
}
function $d6f3bdb39e758627$export$5bcd2a2eb6640dfa(fnName, argumentName, // eslint-disable-next-line @typescript-eslint/ban-types
callback, optional) {
    if (optional && !callback) return;
    if (typeof callback !== "function") throw new Error($d6f3bdb39e758627$export$adea4917e02d93dc(fnName, argumentName) + "must be a valid function.");
}
function $d6f3bdb39e758627$export$df77539402cfb523(fnName, argumentName, context, optional) {
    if (optional && !context) return;
    if (typeof context !== "object" || context === null) throw new Error($d6f3bdb39e758627$export$adea4917e02d93dc(fnName, argumentName) + "must be a valid context object.");
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Code originally came from goog.crypt.stringToUtf8ByteArray, but for some reason they
// automatically replaced '\r\n' with '\n', and they didn't handle surrogate pairs,
// so it's been modified.
// Note that not all Unicode characters appear as single characters in JavaScript strings.
// fromCharCode returns the UTF-16 encoding of a character - so some Unicode characters
// use 2 characters in Javascript.  All 4-byte UTF-8 characters begin with a first
// character in the range 0xD800 - 0xDBFF (the first character of a so-called surrogate
// pair).
// See http://www.ecma-international.org/ecma-262/5.1/#sec-15.1.3
/**
 * @param {string} str
 * @return {Array}
 */ const $d6f3bdb39e758627$export$655666783217a925 = function(str) {
    const out = [];
    let p = 0;
    for(let i = 0; i < str.length; i++){
        let c = str.charCodeAt(i);
        // Is this the lead surrogate in a surrogate pair?
        if (c >= 0xd800 && c <= 0xdbff) {
            const high = c - 0xd800; // the high 10 bits.
            i++;
            $d6f3bdb39e758627$export$a7a9523472993e97(i < str.length, "Surrogate pair missing trail surrogate.");
            const low = str.charCodeAt(i) - 0xdc00; // the low 10 bits.
            c = 0x10000 + (high << 10) + low;
        }
        if (c < 128) out[p++] = c;
        else if (c < 2048) {
            out[p++] = c >> 6 | 192;
            out[p++] = c & 63 | 128;
        } else if (c < 65536) {
            out[p++] = c >> 12 | 224;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        } else {
            out[p++] = c >> 18 | 240;
            out[p++] = c >> 12 & 63 | 128;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        }
    }
    return out;
};
/**
 * Calculate length without actually converting; useful for doing cheaper validation.
 * @param {string} str
 * @return {number}
 */ const $d6f3bdb39e758627$export$9536dc0a75b20bf9 = function(str) {
    let p = 0;
    for(let i = 0; i < str.length; i++){
        const c = str.charCodeAt(i);
        if (c < 128) p++;
        else if (c < 2048) p += 2;
        else if (c >= 0xd800 && c <= 0xdbff) {
            // Lead surrogate of a surrogate pair.  The pair together will take 4 bytes to represent.
            p += 4;
            i++; // skip trail surrogate.
        } else p += 3;
    }
    return p;
};
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The amount of milliseconds to exponentially increase.
 */ const $d6f3bdb39e758627$var$DEFAULT_INTERVAL_MILLIS = 1000;
/**
 * The factor to backoff by.
 * Should be a number greater than 1.
 */ const $d6f3bdb39e758627$var$DEFAULT_BACKOFF_FACTOR = 2;
/**
 * The maximum milliseconds to increase to.
 *
 * <p>Visible for testing
 */ const $d6f3bdb39e758627$export$bdf1213ffbdb096e = 14400000; // Four hours, like iOS and Android.
/**
 * The percentage of backoff time to randomize by.
 * See
 * http://go/safe-client-behavior#step-1-determine-the-appropriate-retry-interval-to-handle-spike-traffic
 * for context.
 *
 * <p>Visible for testing
 */ const $d6f3bdb39e758627$export$3518ed2cfe61fa30 = 0.5;
/**
 * Based on the backoff method from
 * https://github.com/google/closure-library/blob/master/closure/goog/math/exponentialbackoff.js.
 * Extracted here so we don't need to pass metadata and a stateful ExponentialBackoff object around.
 */ function $d6f3bdb39e758627$export$4d810c0ca64ed8e9(backoffCount, intervalMillis = $d6f3bdb39e758627$var$DEFAULT_INTERVAL_MILLIS, backoffFactor = $d6f3bdb39e758627$var$DEFAULT_BACKOFF_FACTOR) {
    // Calculates an exponentially increasing value.
    // Deviation: calculates value from count and a constant interval, so we only need to save value
    // and count to restore state.
    const currBaseValue = intervalMillis * Math.pow(backoffFactor, backoffCount);
    // A random "fuzz" to avoid waves of retries.
    // Deviation: randomFactor is required.
    const randomWait = Math.round(// A fraction of the backoff value to add/subtract.
    // Deviation: changes multiplication order to improve readability.
    $d6f3bdb39e758627$export$3518ed2cfe61fa30 * currBaseValue * // A random float (rounded to int by Math.round above) in the range [-1, 1]. Determines
    // if we add or subtract.
    (Math.random() - 0.5) * 2);
    // Limits backoff to max to avoid effectively permanent backoff.
    return Math.min($d6f3bdb39e758627$export$bdf1213ffbdb096e, currBaseValue + randomWait);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provide English ordinal letters after a number
 */ function $d6f3bdb39e758627$export$7bb39f879164e4ac(i) {
    if (!Number.isFinite(i)) return `${i}`;
    return i + $d6f3bdb39e758627$var$indicator(i);
}
function $d6f3bdb39e758627$var$indicator(i) {
    i = Math.abs(i);
    const cent = i % 100;
    if (cent >= 10 && cent <= 20) return "th";
    const dec = i % 10;
    if (dec === 1) return "st";
    if (dec === 2) return "nd";
    if (dec === 3) return "rd";
    return "th";
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $d6f3bdb39e758627$export$4befe9b5fa509a1b(service) {
    if (service && service._delegate) return service._delegate;
    else return service;
}

});


parcelRegister("gDOOI", function(module, exports) {

$parcel$export(module.exports, "LogLevel", function () { return $c1d7b510ec4f7b7e$export$243e62d78d3b544d; });
$parcel$export(module.exports, "Logger", function () { return $c1d7b510ec4f7b7e$export$efa9a398d6368992; });
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A container for all of the Logger instances
 */ const $c1d7b510ec4f7b7e$var$instances = [];
/**
 * The JS SDK supports 5 log levels and also allows a user the ability to
 * silence the logs altogether.
 *
 * The order is a follows:
 * DEBUG < VERBOSE < INFO < WARN < ERROR
 *
 * All of the log types above the current log level will be captured (i.e. if
 * you set the log level to `INFO`, errors will still be logged, but `DEBUG` and
 * `VERBOSE` logs will not)
 */ var $c1d7b510ec4f7b7e$export$243e62d78d3b544d;
(function(LogLevel) {
    LogLevel[LogLevel["DEBUG"] = 0] = "DEBUG";
    LogLevel[LogLevel["VERBOSE"] = 1] = "VERBOSE";
    LogLevel[LogLevel["INFO"] = 2] = "INFO";
    LogLevel[LogLevel["WARN"] = 3] = "WARN";
    LogLevel[LogLevel["ERROR"] = 4] = "ERROR";
    LogLevel[LogLevel["SILENT"] = 5] = "SILENT";
})($c1d7b510ec4f7b7e$export$243e62d78d3b544d || ($c1d7b510ec4f7b7e$export$243e62d78d3b544d = {}));
const $c1d7b510ec4f7b7e$var$levelStringToEnum = {
    "debug": $c1d7b510ec4f7b7e$export$243e62d78d3b544d.DEBUG,
    "verbose": $c1d7b510ec4f7b7e$export$243e62d78d3b544d.VERBOSE,
    "info": $c1d7b510ec4f7b7e$export$243e62d78d3b544d.INFO,
    "warn": $c1d7b510ec4f7b7e$export$243e62d78d3b544d.WARN,
    "error": $c1d7b510ec4f7b7e$export$243e62d78d3b544d.ERROR,
    "silent": $c1d7b510ec4f7b7e$export$243e62d78d3b544d.SILENT
};
/**
 * The default log level
 */ const $c1d7b510ec4f7b7e$var$defaultLogLevel = $c1d7b510ec4f7b7e$export$243e62d78d3b544d.INFO;
/**
 * By default, `console.debug` is not displayed in the developer console (in
 * chrome). To avoid forcing users to have to opt-in to these logs twice
 * (i.e. once for firebase, and once in the console), we are sending `DEBUG`
 * logs to the `console.log` function.
 */ const $c1d7b510ec4f7b7e$var$ConsoleMethod = {
    [$c1d7b510ec4f7b7e$export$243e62d78d3b544d.DEBUG]: "log",
    [$c1d7b510ec4f7b7e$export$243e62d78d3b544d.VERBOSE]: "log",
    [$c1d7b510ec4f7b7e$export$243e62d78d3b544d.INFO]: "info",
    [$c1d7b510ec4f7b7e$export$243e62d78d3b544d.WARN]: "warn",
    [$c1d7b510ec4f7b7e$export$243e62d78d3b544d.ERROR]: "error"
};
/**
 * The default log handler will forward DEBUG, VERBOSE, INFO, WARN, and ERROR
 * messages on to their corresponding console counterparts (if the log method
 * is supported by the current log level)
 */ const $c1d7b510ec4f7b7e$var$defaultLogHandler = (instance, logType, ...args)=>{
    if (logType < instance.logLevel) return;
    const now = new Date().toISOString();
    const method = $c1d7b510ec4f7b7e$var$ConsoleMethod[logType];
    if (method) console[method](`[${now}]  ${instance.name}:`, ...args);
    else throw new Error(`Attempted to log a message with an invalid logType (value: ${logType})`);
};
class $c1d7b510ec4f7b7e$export$efa9a398d6368992 {
    get logLevel() {
        return this._logLevel;
    }
    set logLevel(val) {
        if (!(val in $c1d7b510ec4f7b7e$export$243e62d78d3b544d)) throw new TypeError(`Invalid value "${val}" assigned to \`logLevel\``);
        this._logLevel = val;
    }
    // Workaround for setter/getter having to be the same type.
    setLogLevel(val) {
        this._logLevel = typeof val === "string" ? $c1d7b510ec4f7b7e$var$levelStringToEnum[val] : val;
    }
    get logHandler() {
        return this._logHandler;
    }
    set logHandler(val) {
        if (typeof val !== "function") throw new TypeError("Value assigned to `logHandler` must be a function");
        this._logHandler = val;
    }
    get userLogHandler() {
        return this._userLogHandler;
    }
    set userLogHandler(val) {
        this._userLogHandler = val;
    }
    /**
     * The functions below are all based on the `console` interface
     */ debug(...args) {
        this._userLogHandler && this._userLogHandler(this, $c1d7b510ec4f7b7e$export$243e62d78d3b544d.DEBUG, ...args);
        this._logHandler(this, $c1d7b510ec4f7b7e$export$243e62d78d3b544d.DEBUG, ...args);
    }
    log(...args) {
        this._userLogHandler && this._userLogHandler(this, $c1d7b510ec4f7b7e$export$243e62d78d3b544d.VERBOSE, ...args);
        this._logHandler(this, $c1d7b510ec4f7b7e$export$243e62d78d3b544d.VERBOSE, ...args);
    }
    info(...args) {
        this._userLogHandler && this._userLogHandler(this, $c1d7b510ec4f7b7e$export$243e62d78d3b544d.INFO, ...args);
        this._logHandler(this, $c1d7b510ec4f7b7e$export$243e62d78d3b544d.INFO, ...args);
    }
    warn(...args) {
        this._userLogHandler && this._userLogHandler(this, $c1d7b510ec4f7b7e$export$243e62d78d3b544d.WARN, ...args);
        this._logHandler(this, $c1d7b510ec4f7b7e$export$243e62d78d3b544d.WARN, ...args);
    }
    error(...args) {
        this._userLogHandler && this._userLogHandler(this, $c1d7b510ec4f7b7e$export$243e62d78d3b544d.ERROR, ...args);
        this._logHandler(this, $c1d7b510ec4f7b7e$export$243e62d78d3b544d.ERROR, ...args);
    }
    /**
     * Gives you an instance of a Logger to capture messages according to
     * Firebase's logging scheme.
     *
     * @param name The name that the logs will be associated with
     */ constructor(name){
        this.name = name;
        /**
         * The log level of the given Logger instance.
         */ this._logLevel = $c1d7b510ec4f7b7e$var$defaultLogLevel;
        /**
         * The main (internal) log handler for the Logger instance.
         * Can be set to a new function in internal package code but not by user.
         */ this._logHandler = $c1d7b510ec4f7b7e$var$defaultLogHandler;
        /**
         * The optional, additional, user-defined log handler for the Logger instance.
         */ this._userLogHandler = null;
        /**
         * Capture the current instance for later use
         */ $c1d7b510ec4f7b7e$var$instances.push(this);
    }
}
function $c1d7b510ec4f7b7e$export$c622e99c0ce7b1c9(level) {
    $c1d7b510ec4f7b7e$var$instances.forEach((inst)=>{
        inst.setLogLevel(level);
    });
}
function $c1d7b510ec4f7b7e$export$29577d29c84db5f6(logCallback, options) {
    for (const instance of $c1d7b510ec4f7b7e$var$instances){
        let customLogLevel = null;
        if (options && options.level) customLogLevel = $c1d7b510ec4f7b7e$var$levelStringToEnum[options.level];
        if (logCallback === null) instance.userLogHandler = null;
        else instance.userLogHandler = (instance, level, ...args)=>{
            const message = args.map((arg)=>{
                if (arg == null) return null;
                else if (typeof arg === "string") return arg;
                else if (typeof arg === "number" || typeof arg === "boolean") return arg.toString();
                else if (arg instanceof Error) return arg.message;
                else try {
                    return JSON.stringify(arg);
                } catch (ignored) {
                    return null;
                }
            }).filter((arg)=>arg).join(" ");
            if (level >= (customLogLevel !== null && customLogLevel !== void 0 ? customLogLevel : instance.logLevel)) logCallback({
                level: $c1d7b510ec4f7b7e$export$243e62d78d3b544d[level].toLowerCase(),
                message: message,
                args: args,
                type: instance.name
            });
        };
    }
}

});

parcelRegister("3YLik", function(module, exports) {

$parcel$export(module.exports, "createWebChannelTransport", function () { return $2e5ba96e28048472$export$66869136fc133c3a; });
$parcel$export(module.exports, "getStatEventTarget", function () { return $2e5ba96e28048472$export$888d0d9ab79d08fc; });
$parcel$export(module.exports, "ErrorCode", function () { return $2e5ba96e28048472$export$d4e71bc0b80dc0fb; });
$parcel$export(module.exports, "EventType", function () { return $2e5ba96e28048472$export$3d7865934588d77e; });
$parcel$export(module.exports, "Event", function () { return $2e5ba96e28048472$export$d61e24a684f9e51; });
$parcel$export(module.exports, "Stat", function () { return $2e5ba96e28048472$export$cbbc350c1dfc80cb; });
$parcel$export(module.exports, "FetchXmlHttpFactory", function () { return $2e5ba96e28048472$export$ddb1030448106742; });
$parcel$export(module.exports, "WebChannel", function () { return $2e5ba96e28048472$export$aa726fb96ad3e039; });
$parcel$export(module.exports, "XhrIo", function () { return $2e5ba96e28048472$export$26404658cda3ee02; });
var $2e5ba96e28048472$var$commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : {};
var $2e5ba96e28048472$export$2e2bcd8739ae039 = {};
/*

 Copyright The Closure Library Authors.
 SPDX-License-Identifier: Apache-2.0
*/ var $2e5ba96e28048472$var$k, $2e5ba96e28048472$var$goog = $2e5ba96e28048472$var$goog || {}, $2e5ba96e28048472$var$l = $2e5ba96e28048472$var$commonjsGlobal || self;
function $2e5ba96e28048472$var$aa() {}
function $2e5ba96e28048472$var$ba(a) {
    var b = typeof a;
    b = "object" != b ? b : a ? Array.isArray(a) ? "array" : b : "null";
    return "array" == b || "object" == b && "number" == typeof a.length;
}
function $2e5ba96e28048472$var$p(a) {
    var b = typeof a;
    return "object" == b && null != a || "function" == b;
}
function $2e5ba96e28048472$var$da(a) {
    return Object.prototype.hasOwnProperty.call(a, $2e5ba96e28048472$var$ea) && a[$2e5ba96e28048472$var$ea] || (a[$2e5ba96e28048472$var$ea] = ++$2e5ba96e28048472$var$fa);
}
var $2e5ba96e28048472$var$ea = "closure_uid_" + (1E9 * Math.random() >>> 0), $2e5ba96e28048472$var$fa = 0;
function $2e5ba96e28048472$var$ha(a, b, c) {
    return a.call.apply(a.bind, arguments);
}
function $2e5ba96e28048472$var$ia(a, b, c) {
    if (!a) throw Error();
    if (2 < arguments.length) {
        var d = Array.prototype.slice.call(arguments, 2);
        return function() {
            var e = Array.prototype.slice.call(arguments);
            Array.prototype.unshift.apply(e, d);
            return a.apply(b, e);
        };
    }
    return function() {
        return a.apply(b, arguments);
    };
}
function $2e5ba96e28048472$var$q(a, b, c) {
    Function.prototype.bind && -1 != Function.prototype.bind.toString().indexOf("native code") ? $2e5ba96e28048472$var$q = $2e5ba96e28048472$var$ha : $2e5ba96e28048472$var$q = $2e5ba96e28048472$var$ia;
    return $2e5ba96e28048472$var$q.apply(null, arguments);
}
function $2e5ba96e28048472$var$ja(a, b) {
    var c = Array.prototype.slice.call(arguments, 1);
    return function() {
        var d = c.slice();
        d.push.apply(d, arguments);
        return a.apply(this, d);
    };
}
function $2e5ba96e28048472$var$t(a, b) {
    function c() {}
    c.prototype = b.prototype;
    a.Z = b.prototype;
    a.prototype = new c;
    a.prototype.constructor = a;
    a.Vb = function(d, e, f) {
        for(var h = Array(arguments.length - 2), n = 2; n < arguments.length; n++)h[n - 2] = arguments[n];
        return b.prototype[e].apply(d, h);
    };
}
function $2e5ba96e28048472$var$v() {
    this.s = this.s;
    this.o = this.o;
}
var $2e5ba96e28048472$var$ka = 0, $2e5ba96e28048472$var$la = {};
$2e5ba96e28048472$var$v.prototype.s = !1;
$2e5ba96e28048472$var$v.prototype.na = function() {
    if (!this.s && (this.s = !0, this.M(), 0 != $2e5ba96e28048472$var$ka)) {
        var a = $2e5ba96e28048472$var$da(this);
        delete $2e5ba96e28048472$var$la[a];
    }
};
$2e5ba96e28048472$var$v.prototype.M = function() {
    if (this.o) for(; this.o.length;)this.o.shift()();
};
const $2e5ba96e28048472$var$ma = Array.prototype.indexOf ? function(a, b) {
    return Array.prototype.indexOf.call(a, b, void 0);
} : function(a, b) {
    if ("string" === typeof a) return "string" !== typeof b || 1 != b.length ? -1 : a.indexOf(b, 0);
    for(let c = 0; c < a.length; c++)if (c in a && a[c] === b) return c;
    return -1;
}, $2e5ba96e28048472$var$na = Array.prototype.forEach ? function(a, b, c) {
    Array.prototype.forEach.call(a, b, c);
} : function(a, b, c) {
    const d = a.length, e = "string" === typeof a ? a.split("") : a;
    for(let f = 0; f < d; f++)f in e && b.call(c, e[f], f, a);
};
function $2e5ba96e28048472$var$oa(a) {
    a: {
        var b = $2e5ba96e28048472$var$pa;
        const c = a.length, d = "string" === typeof a ? a.split("") : a;
        for(let e = 0; e < c; e++)if (e in d && b.call(void 0, d[e], e, a)) {
            b = e;
            break a;
        }
        b = -1;
    }
    return 0 > b ? null : "string" === typeof a ? a.charAt(b) : a[b];
}
function $2e5ba96e28048472$var$qa(a) {
    return Array.prototype.concat.apply([], arguments);
}
function $2e5ba96e28048472$var$ra(a) {
    const b = a.length;
    if (0 < b) {
        const c = Array(b);
        for(let d = 0; d < b; d++)c[d] = a[d];
        return c;
    }
    return [];
}
function $2e5ba96e28048472$var$sa(a) {
    return /^[\s\xa0]*$/.test(a);
}
var $2e5ba96e28048472$var$ta = String.prototype.trim ? function(a) {
    return a.trim();
} : function(a) {
    return /^[\s\xa0]*([\s\S]*?)[\s\xa0]*$/.exec(a)[1];
};
function $2e5ba96e28048472$var$w(a, b) {
    return -1 != a.indexOf(b);
}
function $2e5ba96e28048472$var$ua(a, b) {
    return a < b ? -1 : a > b ? 1 : 0;
}
var $2e5ba96e28048472$var$x;
a: {
    var $2e5ba96e28048472$var$va = $2e5ba96e28048472$var$l.navigator;
    if ($2e5ba96e28048472$var$va) {
        var $2e5ba96e28048472$var$wa = $2e5ba96e28048472$var$va.userAgent;
        if ($2e5ba96e28048472$var$wa) {
            $2e5ba96e28048472$var$x = $2e5ba96e28048472$var$wa;
            break a;
        }
    }
    $2e5ba96e28048472$var$x = "";
}
function $2e5ba96e28048472$var$xa(a, b, c) {
    for(const d in a)b.call(c, a[d], d, a);
}
function $2e5ba96e28048472$var$ya(a) {
    const b = {};
    for(const c in a)b[c] = a[c];
    return b;
}
var $2e5ba96e28048472$var$za = "constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" ");
function $2e5ba96e28048472$var$Aa(a, b) {
    let c, d;
    for(let e = 1; e < arguments.length; e++){
        d = arguments[e];
        for(c in d)a[c] = d[c];
        for(let f = 0; f < $2e5ba96e28048472$var$za.length; f++)c = $2e5ba96e28048472$var$za[f], Object.prototype.hasOwnProperty.call(d, c) && (a[c] = d[c]);
    }
}
function $2e5ba96e28048472$var$Ca(a) {
    $2e5ba96e28048472$var$Ca[" "](a);
    return a;
}
$2e5ba96e28048472$var$Ca[" "] = $2e5ba96e28048472$var$aa;
function $2e5ba96e28048472$var$Fa(a) {
    var b = $2e5ba96e28048472$var$Ga;
    return Object.prototype.hasOwnProperty.call(b, 9) ? b[9] : b[9] = a(9);
}
var $2e5ba96e28048472$var$Ha = $2e5ba96e28048472$var$w($2e5ba96e28048472$var$x, "Opera"), $2e5ba96e28048472$var$y = $2e5ba96e28048472$var$w($2e5ba96e28048472$var$x, "Trident") || $2e5ba96e28048472$var$w($2e5ba96e28048472$var$x, "MSIE"), $2e5ba96e28048472$var$Ia = $2e5ba96e28048472$var$w($2e5ba96e28048472$var$x, "Edge"), $2e5ba96e28048472$var$Ja = $2e5ba96e28048472$var$Ia || $2e5ba96e28048472$var$y, $2e5ba96e28048472$var$Ka = $2e5ba96e28048472$var$w($2e5ba96e28048472$var$x, "Gecko") && !($2e5ba96e28048472$var$w($2e5ba96e28048472$var$x.toLowerCase(), "webkit") && !$2e5ba96e28048472$var$w($2e5ba96e28048472$var$x, "Edge")) && !($2e5ba96e28048472$var$w($2e5ba96e28048472$var$x, "Trident") || $2e5ba96e28048472$var$w($2e5ba96e28048472$var$x, "MSIE")) && !$2e5ba96e28048472$var$w($2e5ba96e28048472$var$x, "Edge"), $2e5ba96e28048472$var$La = $2e5ba96e28048472$var$w($2e5ba96e28048472$var$x.toLowerCase(), "webkit") && !$2e5ba96e28048472$var$w($2e5ba96e28048472$var$x, "Edge");
function $2e5ba96e28048472$var$Ma() {
    var a = $2e5ba96e28048472$var$l.document;
    return a ? a.documentMode : void 0;
}
var $2e5ba96e28048472$var$Na;
a: {
    var $2e5ba96e28048472$var$Oa = "", $2e5ba96e28048472$var$Pa = function() {
        var a = $2e5ba96e28048472$var$x;
        if ($2e5ba96e28048472$var$Ka) return /rv:([^\);]+)(\)|;)/.exec(a);
        if ($2e5ba96e28048472$var$Ia) return /Edge\/([\d\.]+)/.exec(a);
        if ($2e5ba96e28048472$var$y) return /\b(?:MSIE|rv)[: ]([^\);]+)(\)|;)/.exec(a);
        if ($2e5ba96e28048472$var$La) return /WebKit\/(\S+)/.exec(a);
        if ($2e5ba96e28048472$var$Ha) return /(?:Version)[ \/]?(\S+)/.exec(a);
    }();
    $2e5ba96e28048472$var$Pa && ($2e5ba96e28048472$var$Oa = $2e5ba96e28048472$var$Pa ? $2e5ba96e28048472$var$Pa[1] : "");
    if ($2e5ba96e28048472$var$y) {
        var $2e5ba96e28048472$var$Qa = $2e5ba96e28048472$var$Ma();
        if (null != $2e5ba96e28048472$var$Qa && $2e5ba96e28048472$var$Qa > parseFloat($2e5ba96e28048472$var$Oa)) {
            $2e5ba96e28048472$var$Na = String($2e5ba96e28048472$var$Qa);
            break a;
        }
    }
    $2e5ba96e28048472$var$Na = $2e5ba96e28048472$var$Oa;
}
var $2e5ba96e28048472$var$Ga = {};
function $2e5ba96e28048472$var$Ra() {
    return $2e5ba96e28048472$var$Fa(function() {
        let a = 0;
        const b = $2e5ba96e28048472$var$ta(String($2e5ba96e28048472$var$Na)).split("."), c = $2e5ba96e28048472$var$ta("9").split("."), d = Math.max(b.length, c.length);
        for(let h = 0; 0 == a && h < d; h++){
            var e = b[h] || "", f = c[h] || "";
            do {
                e = /(\d*)(\D*)(.*)/.exec(e) || [
                    "",
                    "",
                    "",
                    ""
                ];
                f = /(\d*)(\D*)(.*)/.exec(f) || [
                    "",
                    "",
                    "",
                    ""
                ];
                if (0 == e[0].length && 0 == f[0].length) break;
                a = $2e5ba96e28048472$var$ua(0 == e[1].length ? 0 : parseInt(e[1], 10), 0 == f[1].length ? 0 : parseInt(f[1], 10)) || $2e5ba96e28048472$var$ua(0 == e[2].length, 0 == f[2].length) || $2e5ba96e28048472$var$ua(e[2], f[2]);
                e = e[3];
                f = f[3];
            }while (0 == a);
        }
        return 0 <= a;
    });
}
var $2e5ba96e28048472$var$Sa;
if ($2e5ba96e28048472$var$l.document && $2e5ba96e28048472$var$y) {
    var $2e5ba96e28048472$var$Ta = $2e5ba96e28048472$var$Ma();
    $2e5ba96e28048472$var$Sa = $2e5ba96e28048472$var$Ta ? $2e5ba96e28048472$var$Ta : parseInt($2e5ba96e28048472$var$Na, 10) || void 0;
} else $2e5ba96e28048472$var$Sa = void 0;
var $2e5ba96e28048472$var$Ua = $2e5ba96e28048472$var$Sa;
var $2e5ba96e28048472$var$Va = function() {
    if (!$2e5ba96e28048472$var$l.addEventListener || !Object.defineProperty) return !1;
    var a = !1, b = Object.defineProperty({}, "passive", {
        get: function() {
            a = !0;
        }
    });
    try {
        $2e5ba96e28048472$var$l.addEventListener("test", $2e5ba96e28048472$var$aa, b), $2e5ba96e28048472$var$l.removeEventListener("test", $2e5ba96e28048472$var$aa, b);
    } catch (c) {}
    return a;
}();
function $2e5ba96e28048472$var$z(a, b) {
    this.type = a;
    this.g = this.target = b;
    this.defaultPrevented = !1;
}
$2e5ba96e28048472$var$z.prototype.h = function() {
    this.defaultPrevented = !0;
};
function $2e5ba96e28048472$var$A(a, b) {
    $2e5ba96e28048472$var$z.call(this, a ? a.type : "");
    this.relatedTarget = this.g = this.target = null;
    this.button = this.screenY = this.screenX = this.clientY = this.clientX = 0;
    this.key = "";
    this.metaKey = this.shiftKey = this.altKey = this.ctrlKey = !1;
    this.state = null;
    this.pointerId = 0;
    this.pointerType = "";
    this.i = null;
    if (a) {
        var c = this.type = a.type, d = a.changedTouches && a.changedTouches.length ? a.changedTouches[0] : null;
        this.target = a.target || a.srcElement;
        this.g = b;
        if (b = a.relatedTarget) {
            if ($2e5ba96e28048472$var$Ka) {
                a: {
                    try {
                        $2e5ba96e28048472$var$Ca(b.nodeName);
                        var e = !0;
                        break a;
                    } catch (f) {}
                    e = !1;
                }
                e || (b = null);
            }
        } else "mouseover" == c ? b = a.fromElement : "mouseout" == c && (b = a.toElement);
        this.relatedTarget = b;
        d ? (this.clientX = void 0 !== d.clientX ? d.clientX : d.pageX, this.clientY = void 0 !== d.clientY ? d.clientY : d.pageY, this.screenX = d.screenX || 0, this.screenY = d.screenY || 0) : (this.clientX = void 0 !== a.clientX ? a.clientX : a.pageX, this.clientY = void 0 !== a.clientY ? a.clientY : a.pageY, this.screenX = a.screenX || 0, this.screenY = a.screenY || 0);
        this.button = a.button;
        this.key = a.key || "";
        this.ctrlKey = a.ctrlKey;
        this.altKey = a.altKey;
        this.shiftKey = a.shiftKey;
        this.metaKey = a.metaKey;
        this.pointerId = a.pointerId || 0;
        this.pointerType = "string" === typeof a.pointerType ? a.pointerType : $2e5ba96e28048472$var$Wa[a.pointerType] || "";
        this.state = a.state;
        this.i = a;
        a.defaultPrevented && $2e5ba96e28048472$var$A.Z.h.call(this);
    }
}
$2e5ba96e28048472$var$t($2e5ba96e28048472$var$A, $2e5ba96e28048472$var$z);
var $2e5ba96e28048472$var$Wa = {
    2: "touch",
    3: "pen",
    4: "mouse"
};
$2e5ba96e28048472$var$A.prototype.h = function() {
    $2e5ba96e28048472$var$A.Z.h.call(this);
    var a = this.i;
    a.preventDefault ? a.preventDefault() : a.returnValue = !1;
};
var $2e5ba96e28048472$var$B = "closure_listenable_" + (1E6 * Math.random() | 0);
var $2e5ba96e28048472$var$Xa = 0;
function $2e5ba96e28048472$var$Ya(a, b, c, d, e) {
    this.listener = a;
    this.proxy = null;
    this.src = b;
    this.type = c;
    this.capture = !!d;
    this.ia = e;
    this.key = ++$2e5ba96e28048472$var$Xa;
    this.ca = this.fa = !1;
}
function $2e5ba96e28048472$var$Za(a) {
    a.ca = !0;
    a.listener = null;
    a.proxy = null;
    a.src = null;
    a.ia = null;
}
function $2e5ba96e28048472$var$$a(a) {
    this.src = a;
    this.g = {};
    this.h = 0;
}
$2e5ba96e28048472$var$$a.prototype.add = function(a, b, c, d, e) {
    var f = a.toString();
    a = this.g[f];
    a || (a = this.g[f] = [], this.h++);
    var h = $2e5ba96e28048472$var$ab(a, b, d, e);
    -1 < h ? (b = a[h], c || (b.fa = !1)) : (b = new $2e5ba96e28048472$var$Ya(b, this.src, f, !!d, e), b.fa = c, a.push(b));
    return b;
};
function $2e5ba96e28048472$var$bb(a, b) {
    var c = b.type;
    if (c in a.g) {
        var d = a.g[c], e = $2e5ba96e28048472$var$ma(d, b), f;
        (f = 0 <= e) && Array.prototype.splice.call(d, e, 1);
        f && ($2e5ba96e28048472$var$Za(b), 0 == a.g[c].length && (delete a.g[c], a.h--));
    }
}
function $2e5ba96e28048472$var$ab(a, b, c, d) {
    for(var e = 0; e < a.length; ++e){
        var f = a[e];
        if (!f.ca && f.listener == b && f.capture == !!c && f.ia == d) return e;
    }
    return -1;
}
var $2e5ba96e28048472$var$cb = "closure_lm_" + (1E6 * Math.random() | 0), $2e5ba96e28048472$var$db = {};
function $2e5ba96e28048472$var$fb(a, b, c, d, e) {
    if (d && d.once) return $2e5ba96e28048472$var$gb(a, b, c, d, e);
    if (Array.isArray(b)) {
        for(var f = 0; f < b.length; f++)$2e5ba96e28048472$var$fb(a, b[f], c, d, e);
        return null;
    }
    c = $2e5ba96e28048472$var$hb(c);
    return a && a[$2e5ba96e28048472$var$B] ? a.N(b, c, $2e5ba96e28048472$var$p(d) ? !!d.capture : !!d, e) : $2e5ba96e28048472$var$ib(a, b, c, !1, d, e);
}
function $2e5ba96e28048472$var$ib(a, b, c, d, e, f) {
    if (!b) throw Error("Invalid event type");
    var h = $2e5ba96e28048472$var$p(e) ? !!e.capture : !!e, n = $2e5ba96e28048472$var$jb(a);
    n || (a[$2e5ba96e28048472$var$cb] = n = new $2e5ba96e28048472$var$$a(a));
    c = n.add(b, c, d, h, f);
    if (c.proxy) return c;
    d = $2e5ba96e28048472$var$kb();
    c.proxy = d;
    d.src = a;
    d.listener = c;
    if (a.addEventListener) $2e5ba96e28048472$var$Va || (e = h), void 0 === e && (e = !1), a.addEventListener(b.toString(), d, e);
    else if (a.attachEvent) a.attachEvent($2e5ba96e28048472$var$lb(b.toString()), d);
    else if (a.addListener && a.removeListener) a.addListener(d);
    else throw Error("addEventListener and attachEvent are unavailable.");
    return c;
}
function $2e5ba96e28048472$var$kb() {
    function a(c) {
        return b.call(a.src, a.listener, c);
    }
    var b = $2e5ba96e28048472$var$mb;
    return a;
}
function $2e5ba96e28048472$var$gb(a, b, c, d, e) {
    if (Array.isArray(b)) {
        for(var f = 0; f < b.length; f++)$2e5ba96e28048472$var$gb(a, b[f], c, d, e);
        return null;
    }
    c = $2e5ba96e28048472$var$hb(c);
    return a && a[$2e5ba96e28048472$var$B] ? a.O(b, c, $2e5ba96e28048472$var$p(d) ? !!d.capture : !!d, e) : $2e5ba96e28048472$var$ib(a, b, c, !0, d, e);
}
function $2e5ba96e28048472$var$nb(a, b, c, d, e) {
    if (Array.isArray(b)) for(var f = 0; f < b.length; f++)$2e5ba96e28048472$var$nb(a, b[f], c, d, e);
    else (d = $2e5ba96e28048472$var$p(d) ? !!d.capture : !!d, c = $2e5ba96e28048472$var$hb(c), a && a[$2e5ba96e28048472$var$B]) ? (a = a.i, b = String(b).toString(), b in a.g && (f = a.g[b], c = $2e5ba96e28048472$var$ab(f, c, d, e), -1 < c && ($2e5ba96e28048472$var$Za(f[c]), Array.prototype.splice.call(f, c, 1), 0 == f.length && (delete a.g[b], a.h--)))) : a && (a = $2e5ba96e28048472$var$jb(a)) && (b = a.g[b.toString()], a = -1, b && (a = $2e5ba96e28048472$var$ab(b, c, d, e)), (c = -1 < a ? b[a] : null) && $2e5ba96e28048472$var$ob(c));
}
function $2e5ba96e28048472$var$ob(a) {
    if ("number" !== typeof a && a && !a.ca) {
        var b = a.src;
        if (b && b[$2e5ba96e28048472$var$B]) $2e5ba96e28048472$var$bb(b.i, a);
        else {
            var c = a.type, d = a.proxy;
            b.removeEventListener ? b.removeEventListener(c, d, a.capture) : b.detachEvent ? b.detachEvent($2e5ba96e28048472$var$lb(c), d) : b.addListener && b.removeListener && b.removeListener(d);
            (c = $2e5ba96e28048472$var$jb(b)) ? ($2e5ba96e28048472$var$bb(c, a), 0 == c.h && (c.src = null, b[$2e5ba96e28048472$var$cb] = null)) : $2e5ba96e28048472$var$Za(a);
        }
    }
}
function $2e5ba96e28048472$var$lb(a) {
    return a in $2e5ba96e28048472$var$db ? $2e5ba96e28048472$var$db[a] : $2e5ba96e28048472$var$db[a] = "on" + a;
}
function $2e5ba96e28048472$var$mb(a, b) {
    if (a.ca) a = !0;
    else {
        b = new $2e5ba96e28048472$var$A(b, this);
        var c = a.listener, d = a.ia || a.src;
        a.fa && $2e5ba96e28048472$var$ob(a);
        a = c.call(d, b);
    }
    return a;
}
function $2e5ba96e28048472$var$jb(a) {
    a = a[$2e5ba96e28048472$var$cb];
    return a instanceof $2e5ba96e28048472$var$$a ? a : null;
}
var $2e5ba96e28048472$var$pb = "__closure_events_fn_" + (1E9 * Math.random() >>> 0);
function $2e5ba96e28048472$var$hb(a) {
    if ("function" === typeof a) return a;
    a[$2e5ba96e28048472$var$pb] || (a[$2e5ba96e28048472$var$pb] = function(b) {
        return a.handleEvent(b);
    });
    return a[$2e5ba96e28048472$var$pb];
}
function $2e5ba96e28048472$var$C() {
    $2e5ba96e28048472$var$v.call(this);
    this.i = new $2e5ba96e28048472$var$$a(this);
    this.P = this;
    this.I = null;
}
$2e5ba96e28048472$var$t($2e5ba96e28048472$var$C, $2e5ba96e28048472$var$v);
$2e5ba96e28048472$var$C.prototype[$2e5ba96e28048472$var$B] = !0;
$2e5ba96e28048472$var$C.prototype.removeEventListener = function(a, b, c, d) {
    $2e5ba96e28048472$var$nb(this, a, b, c, d);
};
function $2e5ba96e28048472$var$D(a, b) {
    var c, d = a.I;
    if (d) for(c = []; d; d = d.I)c.push(d);
    a = a.P;
    d = b.type || b;
    if ("string" === typeof b) b = new $2e5ba96e28048472$var$z(b, a);
    else if (b instanceof $2e5ba96e28048472$var$z) b.target = b.target || a;
    else {
        var e = b;
        b = new $2e5ba96e28048472$var$z(d, a);
        $2e5ba96e28048472$var$Aa(b, e);
    }
    e = !0;
    if (c) for(var f = c.length - 1; 0 <= f; f--){
        var h = b.g = c[f];
        e = $2e5ba96e28048472$var$qb(h, d, !0, b) && e;
    }
    h = b.g = a;
    e = $2e5ba96e28048472$var$qb(h, d, !0, b) && e;
    e = $2e5ba96e28048472$var$qb(h, d, !1, b) && e;
    if (c) for(f = 0; f < c.length; f++)h = b.g = c[f], e = $2e5ba96e28048472$var$qb(h, d, !1, b) && e;
}
$2e5ba96e28048472$var$C.prototype.M = function() {
    $2e5ba96e28048472$var$C.Z.M.call(this);
    if (this.i) {
        var a = this.i, c;
        for(c in a.g){
            for(var d = a.g[c], e = 0; e < d.length; e++)$2e5ba96e28048472$var$Za(d[e]);
            delete a.g[c];
            a.h--;
        }
    }
    this.I = null;
};
$2e5ba96e28048472$var$C.prototype.N = function(a, b, c, d) {
    return this.i.add(String(a), b, !1, c, d);
};
$2e5ba96e28048472$var$C.prototype.O = function(a, b, c, d) {
    return this.i.add(String(a), b, !0, c, d);
};
function $2e5ba96e28048472$var$qb(a, b, c, d) {
    b = a.i.g[String(b)];
    if (!b) return !0;
    b = b.concat();
    for(var e = !0, f = 0; f < b.length; ++f){
        var h = b[f];
        if (h && !h.ca && h.capture == c) {
            var n = h.listener, u = h.ia || h.src;
            h.fa && $2e5ba96e28048472$var$bb(a.i, h);
            e = !1 !== n.call(u, d) && e;
        }
    }
    return e && !d.defaultPrevented;
}
var $2e5ba96e28048472$var$rb = $2e5ba96e28048472$var$l.JSON.stringify;
function $2e5ba96e28048472$var$sb() {
    var a = $2e5ba96e28048472$var$tb;
    let b = null;
    a.g && (b = a.g, a.g = a.g.next, a.g || (a.h = null), b.next = null);
    return b;
}
class $2e5ba96e28048472$var$ub {
    add(a, b) {
        const c = $2e5ba96e28048472$var$vb.get();
        c.set(a, b);
        this.h ? this.h.next = c : this.g = c;
        this.h = c;
    }
    constructor(){
        this.h = this.g = null;
    }
}
var $2e5ba96e28048472$var$vb = new class {
    get() {
        let a;
        0 < this.h ? (this.h--, a = this.g, this.g = a.next, a.next = null) : a = this.i();
        return a;
    }
    constructor(a, b){
        this.i = a;
        this.j = b;
        this.h = 0;
        this.g = null;
    }
}(()=>new $2e5ba96e28048472$var$wb, (a)=>a.reset());
class $2e5ba96e28048472$var$wb {
    set(a, b) {
        this.h = a;
        this.g = b;
        this.next = null;
    }
    reset() {
        this.next = this.g = this.h = null;
    }
    constructor(){
        this.next = this.g = this.h = null;
    }
}
function $2e5ba96e28048472$var$yb(a) {
    $2e5ba96e28048472$var$l.setTimeout(()=>{
        throw a;
    }, 0);
}
function $2e5ba96e28048472$var$zb(a, b) {
    $2e5ba96e28048472$var$Ab || $2e5ba96e28048472$var$Bb();
    $2e5ba96e28048472$var$Cb || ($2e5ba96e28048472$var$Ab(), $2e5ba96e28048472$var$Cb = !0);
    $2e5ba96e28048472$var$tb.add(a, b);
}
var $2e5ba96e28048472$var$Ab;
function $2e5ba96e28048472$var$Bb() {
    var a = $2e5ba96e28048472$var$l.Promise.resolve(void 0);
    $2e5ba96e28048472$var$Ab = function() {
        a.then($2e5ba96e28048472$var$Db);
    };
}
var $2e5ba96e28048472$var$Cb = !1, $2e5ba96e28048472$var$tb = new $2e5ba96e28048472$var$ub;
function $2e5ba96e28048472$var$Db() {
    for(var a; a = $2e5ba96e28048472$var$sb();){
        try {
            a.h.call(a.g);
        } catch (c) {
            $2e5ba96e28048472$var$yb(c);
        }
        var b = $2e5ba96e28048472$var$vb;
        b.j(a);
        100 > b.h && (b.h++, a.next = b.g, b.g = a);
    }
    $2e5ba96e28048472$var$Cb = !1;
}
function $2e5ba96e28048472$var$Eb(a, b) {
    $2e5ba96e28048472$var$C.call(this);
    this.h = a || 1;
    this.g = b || $2e5ba96e28048472$var$l;
    this.j = $2e5ba96e28048472$var$q(this.kb, this);
    this.l = Date.now();
}
$2e5ba96e28048472$var$t($2e5ba96e28048472$var$Eb, $2e5ba96e28048472$var$C);
$2e5ba96e28048472$var$k = $2e5ba96e28048472$var$Eb.prototype;
$2e5ba96e28048472$var$k.da = !1;
$2e5ba96e28048472$var$k.S = null;
$2e5ba96e28048472$var$k.kb = function() {
    if (this.da) {
        var a = Date.now() - this.l;
        0 < a && a < .8 * this.h ? this.S = this.g.setTimeout(this.j, this.h - a) : (this.S && (this.g.clearTimeout(this.S), this.S = null), $2e5ba96e28048472$var$D(this, "tick"), this.da && ($2e5ba96e28048472$var$Fb(this), this.start()));
    }
};
$2e5ba96e28048472$var$k.start = function() {
    this.da = !0;
    this.S || (this.S = this.g.setTimeout(this.j, this.h), this.l = Date.now());
};
function $2e5ba96e28048472$var$Fb(a) {
    a.da = !1;
    a.S && (a.g.clearTimeout(a.S), a.S = null);
}
$2e5ba96e28048472$var$k.M = function() {
    $2e5ba96e28048472$var$Eb.Z.M.call(this);
    $2e5ba96e28048472$var$Fb(this);
    delete this.g;
};
function $2e5ba96e28048472$var$Gb(a, b, c) {
    if ("function" === typeof a) c && (a = $2e5ba96e28048472$var$q(a, c));
    else if (a && "function" == typeof a.handleEvent) a = $2e5ba96e28048472$var$q(a.handleEvent, a);
    else throw Error("Invalid listener argument");
    return 2147483647 < Number(b) ? -1 : $2e5ba96e28048472$var$l.setTimeout(a, b || 0);
}
function $2e5ba96e28048472$var$Hb(a) {
    a.g = $2e5ba96e28048472$var$Gb(()=>{
        a.g = null;
        a.i && (a.i = !1, $2e5ba96e28048472$var$Hb(a));
    }, a.j);
    const b = a.h;
    a.h = null;
    a.m.apply(null, b);
}
class $2e5ba96e28048472$var$Ib extends $2e5ba96e28048472$var$v {
    l(a) {
        this.h = arguments;
        this.g ? this.i = !0 : $2e5ba96e28048472$var$Hb(this);
    }
    M() {
        super.M();
        this.g && ($2e5ba96e28048472$var$l.clearTimeout(this.g), this.g = null, this.i = !1, this.h = null);
    }
    constructor(a, b){
        super();
        this.m = a;
        this.j = b;
        this.h = null;
        this.i = !1;
        this.g = null;
    }
}
function $2e5ba96e28048472$var$E(a) {
    $2e5ba96e28048472$var$v.call(this);
    this.h = a;
    this.g = {};
}
$2e5ba96e28048472$var$t($2e5ba96e28048472$var$E, $2e5ba96e28048472$var$v);
var $2e5ba96e28048472$var$Jb = [];
function $2e5ba96e28048472$var$Kb(a, b, c, d) {
    Array.isArray(c) || (c && ($2e5ba96e28048472$var$Jb[0] = c.toString()), c = $2e5ba96e28048472$var$Jb);
    for(var e = 0; e < c.length; e++){
        var f = $2e5ba96e28048472$var$fb(b, c[e], d || a.handleEvent, !1, a.h || a);
        if (!f) break;
        a.g[f.key] = f;
    }
}
function $2e5ba96e28048472$var$Lb(a) {
    $2e5ba96e28048472$var$xa(a.g, function(b, c) {
        this.g.hasOwnProperty(c) && $2e5ba96e28048472$var$ob(b);
    }, a);
    a.g = {};
}
$2e5ba96e28048472$var$E.prototype.M = function() {
    $2e5ba96e28048472$var$E.Z.M.call(this);
    $2e5ba96e28048472$var$Lb(this);
};
$2e5ba96e28048472$var$E.prototype.handleEvent = function() {
    throw Error("EventHandler.handleEvent not implemented");
};
function $2e5ba96e28048472$var$Mb() {
    this.g = !0;
}
$2e5ba96e28048472$var$Mb.prototype.Aa = function() {
    this.g = !1;
};
function $2e5ba96e28048472$var$Nb(a, b, c, d, e, f) {
    a.info(function() {
        if (a.g) {
            if (f) {
                var h = "";
                for(var n = f.split("&"), u = 0; u < n.length; u++){
                    var m = n[u].split("=");
                    if (1 < m.length) {
                        var r = m[0];
                        m = m[1];
                        var G = r.split("_");
                        h = 2 <= G.length && "type" == G[1] ? h + (r + "=" + m + "&") : h + (r + "=redacted&");
                    }
                }
            } else h = null;
        } else h = f;
        return "XMLHTTP REQ (" + d + ") [attempt " + e + "]: " + b + "\n" + c + "\n" + h;
    });
}
function $2e5ba96e28048472$var$Ob(a, b, c, d, e, f, h) {
    a.info(function() {
        return "XMLHTTP RESP (" + d + ") [ attempt " + e + "]: " + b + "\n" + c + "\n" + f + " " + h;
    });
}
function $2e5ba96e28048472$var$F(a, b, c, d) {
    a.info(function() {
        return "XMLHTTP TEXT (" + b + "): " + $2e5ba96e28048472$var$Pb(a, c) + (d ? " " + d : "");
    });
}
function $2e5ba96e28048472$var$Qb(a, b) {
    a.info(function() {
        return "TIMEOUT: " + b;
    });
}
$2e5ba96e28048472$var$Mb.prototype.info = function() {};
function $2e5ba96e28048472$var$Pb(a, b) {
    if (!a.g) return b;
    if (!b) return null;
    try {
        var c = JSON.parse(b);
        if (c) {
            for(a = 0; a < c.length; a++)if (Array.isArray(c[a])) {
                var d = c[a];
                if (!(2 > d.length)) {
                    var e = d[1];
                    if (Array.isArray(e) && !(1 > e.length)) {
                        var f = e[0];
                        if ("noop" != f && "stop" != f && "close" != f) for(var h = 1; h < e.length; h++)e[h] = "";
                    }
                }
            }
        }
        return $2e5ba96e28048472$var$rb(c);
    } catch (n) {
        return b;
    }
}
var $2e5ba96e28048472$var$H = {}, $2e5ba96e28048472$var$Rb = null;
function $2e5ba96e28048472$var$Sb() {
    return $2e5ba96e28048472$var$Rb = $2e5ba96e28048472$var$Rb || new $2e5ba96e28048472$var$C;
}
$2e5ba96e28048472$var$H.Ma = "serverreachability";
function $2e5ba96e28048472$var$Tb(a) {
    $2e5ba96e28048472$var$z.call(this, $2e5ba96e28048472$var$H.Ma, a);
}
$2e5ba96e28048472$var$t($2e5ba96e28048472$var$Tb, $2e5ba96e28048472$var$z);
function $2e5ba96e28048472$var$I(a) {
    const b = $2e5ba96e28048472$var$Sb();
    $2e5ba96e28048472$var$D(b, new $2e5ba96e28048472$var$Tb(b, a));
}
$2e5ba96e28048472$var$H.STAT_EVENT = "statevent";
function $2e5ba96e28048472$var$Ub(a, b) {
    $2e5ba96e28048472$var$z.call(this, $2e5ba96e28048472$var$H.STAT_EVENT, a);
    this.stat = b;
}
$2e5ba96e28048472$var$t($2e5ba96e28048472$var$Ub, $2e5ba96e28048472$var$z);
function $2e5ba96e28048472$var$J(a) {
    const b = $2e5ba96e28048472$var$Sb();
    $2e5ba96e28048472$var$D(b, new $2e5ba96e28048472$var$Ub(b, a));
}
$2e5ba96e28048472$var$H.Na = "timingevent";
function $2e5ba96e28048472$var$Vb(a, b) {
    $2e5ba96e28048472$var$z.call(this, $2e5ba96e28048472$var$H.Na, a);
    this.size = b;
}
$2e5ba96e28048472$var$t($2e5ba96e28048472$var$Vb, $2e5ba96e28048472$var$z);
function $2e5ba96e28048472$var$K(a, b) {
    if ("function" !== typeof a) throw Error("Fn must not be null and must be a function");
    return $2e5ba96e28048472$var$l.setTimeout(function() {
        a();
    }, b);
}
var $2e5ba96e28048472$var$Wb = {
    NO_ERROR: 0,
    lb: 1,
    yb: 2,
    xb: 3,
    sb: 4,
    wb: 5,
    zb: 6,
    Ja: 7,
    TIMEOUT: 8,
    Cb: 9
};
var $2e5ba96e28048472$var$Xb = {
    qb: "complete",
    Mb: "success",
    Ka: "error",
    Ja: "abort",
    Eb: "ready",
    Fb: "readystatechange",
    TIMEOUT: "timeout",
    Ab: "incrementaldata",
    Db: "progress",
    tb: "downloadprogress",
    Ub: "uploadprogress"
};
function $2e5ba96e28048472$var$Yb() {}
$2e5ba96e28048472$var$Yb.prototype.h = null;
function $2e5ba96e28048472$var$Zb(a) {
    return a.h || (a.h = a.i());
}
function $2e5ba96e28048472$var$$b() {}
var $2e5ba96e28048472$var$L = {
    OPEN: "a",
    pb: "b",
    Ka: "c",
    Bb: "d"
};
function $2e5ba96e28048472$var$ac() {
    $2e5ba96e28048472$var$z.call(this, "d");
}
$2e5ba96e28048472$var$t($2e5ba96e28048472$var$ac, $2e5ba96e28048472$var$z);
function $2e5ba96e28048472$var$bc() {
    $2e5ba96e28048472$var$z.call(this, "c");
}
$2e5ba96e28048472$var$t($2e5ba96e28048472$var$bc, $2e5ba96e28048472$var$z);
var $2e5ba96e28048472$var$cc;
function $2e5ba96e28048472$var$dc() {}
$2e5ba96e28048472$var$t($2e5ba96e28048472$var$dc, $2e5ba96e28048472$var$Yb);
$2e5ba96e28048472$var$dc.prototype.g = function() {
    return new XMLHttpRequest;
};
$2e5ba96e28048472$var$dc.prototype.i = function() {
    return {};
};
$2e5ba96e28048472$var$cc = new $2e5ba96e28048472$var$dc;
function $2e5ba96e28048472$var$M(a, b, c, d) {
    this.l = a;
    this.j = b;
    this.m = c;
    this.X = d || 1;
    this.V = new $2e5ba96e28048472$var$E(this);
    this.P = $2e5ba96e28048472$var$ec;
    a = $2e5ba96e28048472$var$Ja ? 125 : void 0;
    this.W = new $2e5ba96e28048472$var$Eb(a);
    this.H = null;
    this.i = !1;
    this.s = this.A = this.v = this.K = this.F = this.Y = this.B = null;
    this.D = [];
    this.g = null;
    this.C = 0;
    this.o = this.u = null;
    this.N = -1;
    this.I = !1;
    this.O = 0;
    this.L = null;
    this.aa = this.J = this.$ = this.U = !1;
    this.h = new $2e5ba96e28048472$var$fc;
}
function $2e5ba96e28048472$var$fc() {
    this.i = null;
    this.g = "";
    this.h = !1;
}
var $2e5ba96e28048472$var$ec = 45E3, $2e5ba96e28048472$var$gc = {}, $2e5ba96e28048472$var$hc = {};
$2e5ba96e28048472$var$k = $2e5ba96e28048472$var$M.prototype;
$2e5ba96e28048472$var$k.setTimeout = function(a) {
    this.P = a;
};
function $2e5ba96e28048472$var$ic(a, b, c) {
    a.K = 1;
    a.v = $2e5ba96e28048472$var$jc($2e5ba96e28048472$var$N(b));
    a.s = c;
    a.U = !0;
    $2e5ba96e28048472$var$kc(a, null);
}
function $2e5ba96e28048472$var$kc(a, b) {
    a.F = Date.now();
    $2e5ba96e28048472$var$lc(a);
    a.A = $2e5ba96e28048472$var$N(a.v);
    var c = a.A, d = a.X;
    Array.isArray(d) || (d = [
        String(d)
    ]);
    $2e5ba96e28048472$var$mc(c.h, "t", d);
    a.C = 0;
    c = a.l.H;
    a.h = new $2e5ba96e28048472$var$fc;
    a.g = $2e5ba96e28048472$var$nc(a.l, c ? b : null, !a.s);
    0 < a.O && (a.L = new $2e5ba96e28048472$var$Ib($2e5ba96e28048472$var$q(a.Ia, a, a.g), a.O));
    $2e5ba96e28048472$var$Kb(a.V, a.g, "readystatechange", a.gb);
    b = a.H ? $2e5ba96e28048472$var$ya(a.H) : {};
    a.s ? (a.u || (a.u = "POST"), b["Content-Type"] = "application/x-www-form-urlencoded", a.g.ea(a.A, a.u, a.s, b)) : (a.u = "GET", a.g.ea(a.A, a.u, null, b));
    $2e5ba96e28048472$var$I(1);
    $2e5ba96e28048472$var$Nb(a.j, a.u, a.A, a.m, a.X, a.s);
}
$2e5ba96e28048472$var$k.gb = function(a) {
    a = a.target;
    const b = this.L;
    b && 3 == $2e5ba96e28048472$var$O(a) ? b.l() : this.Ia(a);
};
$2e5ba96e28048472$var$k.Ia = function(a) {
    try {
        if (a == this.g) a: {
            const r = $2e5ba96e28048472$var$O(this.g);
            var b = this.g.Da();
            const G = this.g.ba();
            if (!(3 > r) && (3 != r || $2e5ba96e28048472$var$Ja || this.g && (this.h.h || this.g.ga() || $2e5ba96e28048472$var$oc(this.g)))) {
                this.I || 4 != r || 7 == b || (8 == b || 0 >= G ? $2e5ba96e28048472$var$I(3) : $2e5ba96e28048472$var$I(2));
                $2e5ba96e28048472$var$pc(this);
                var c = this.g.ba();
                this.N = c;
                b: if ($2e5ba96e28048472$var$qc(this)) {
                    var d = $2e5ba96e28048472$var$oc(this.g);
                    a = "";
                    var e = d.length, f = 4 == $2e5ba96e28048472$var$O(this.g);
                    if (!this.h.i) {
                        if ("undefined" === typeof TextDecoder) {
                            $2e5ba96e28048472$var$P(this);
                            $2e5ba96e28048472$var$rc(this);
                            var h = "";
                            break b;
                        }
                        this.h.i = new $2e5ba96e28048472$var$l.TextDecoder;
                    }
                    for(b = 0; b < e; b++)this.h.h = !0, a += this.h.i.decode(d[b], {
                        stream: f && b == e - 1
                    });
                    d.splice(0, e);
                    this.h.g += a;
                    this.C = 0;
                    h = this.h.g;
                } else h = this.g.ga();
                this.i = 200 == c;
                $2e5ba96e28048472$var$Ob(this.j, this.u, this.A, this.m, this.X, r, c);
                if (this.i) {
                    if (this.$ && !this.J) {
                        b: {
                            if (this.g) {
                                var n, u = this.g;
                                if ((n = u.g ? u.g.getResponseHeader("X-HTTP-Initial-Response") : null) && !$2e5ba96e28048472$var$sa(n)) {
                                    var m = n;
                                    break b;
                                }
                            }
                            m = null;
                        }
                        if (c = m) $2e5ba96e28048472$var$F(this.j, this.m, c, "Initial handshake response via X-HTTP-Initial-Response"), this.J = !0, $2e5ba96e28048472$var$sc(this, c);
                        else {
                            this.i = !1;
                            this.o = 3;
                            $2e5ba96e28048472$var$J(12);
                            $2e5ba96e28048472$var$P(this);
                            $2e5ba96e28048472$var$rc(this);
                            break a;
                        }
                    }
                    this.U ? ($2e5ba96e28048472$var$tc(this, r, h), $2e5ba96e28048472$var$Ja && this.i && 3 == r && ($2e5ba96e28048472$var$Kb(this.V, this.W, "tick", this.fb), this.W.start())) : ($2e5ba96e28048472$var$F(this.j, this.m, h, null), $2e5ba96e28048472$var$sc(this, h));
                    4 == r && $2e5ba96e28048472$var$P(this);
                    this.i && !this.I && (4 == r ? $2e5ba96e28048472$var$uc(this.l, this) : (this.i = !1, $2e5ba96e28048472$var$lc(this)));
                } else 400 == c && 0 < h.indexOf("Unknown SID") ? (this.o = 3, $2e5ba96e28048472$var$J(12)) : (this.o = 0, $2e5ba96e28048472$var$J(13)), $2e5ba96e28048472$var$P(this), $2e5ba96e28048472$var$rc(this);
            }
        }
    } catch (r) {} finally{}
};
function $2e5ba96e28048472$var$qc(a) {
    return a.g ? "GET" == a.u && 2 != a.K && a.l.Ba : !1;
}
function $2e5ba96e28048472$var$tc(a, b, c) {
    let d = !0, e;
    for(; !a.I && a.C < c.length;)if (e = $2e5ba96e28048472$var$vc(a, c), e == $2e5ba96e28048472$var$hc) {
        4 == b && (a.o = 4, $2e5ba96e28048472$var$J(14), d = !1);
        $2e5ba96e28048472$var$F(a.j, a.m, null, "[Incomplete Response]");
        break;
    } else if (e == $2e5ba96e28048472$var$gc) {
        a.o = 4;
        $2e5ba96e28048472$var$J(15);
        $2e5ba96e28048472$var$F(a.j, a.m, c, "[Invalid Chunk]");
        d = !1;
        break;
    } else $2e5ba96e28048472$var$F(a.j, a.m, e, null), $2e5ba96e28048472$var$sc(a, e);
    $2e5ba96e28048472$var$qc(a) && e != $2e5ba96e28048472$var$hc && e != $2e5ba96e28048472$var$gc && (a.h.g = "", a.C = 0);
    4 != b || 0 != c.length || a.h.h || (a.o = 1, $2e5ba96e28048472$var$J(16), d = !1);
    a.i = a.i && d;
    d ? 0 < c.length && !a.aa && (a.aa = !0, b = a.l, b.g == a && b.$ && !b.L && (b.h.info("Great, no buffering proxy detected. Bytes received: " + c.length), $2e5ba96e28048472$var$wc(b), b.L = !0, $2e5ba96e28048472$var$J(11))) : ($2e5ba96e28048472$var$F(a.j, a.m, c, "[Invalid Chunked Response]"), $2e5ba96e28048472$var$P(a), $2e5ba96e28048472$var$rc(a));
}
$2e5ba96e28048472$var$k.fb = function() {
    if (this.g) {
        var a = $2e5ba96e28048472$var$O(this.g), b = this.g.ga();
        this.C < b.length && ($2e5ba96e28048472$var$pc(this), $2e5ba96e28048472$var$tc(this, a, b), this.i && 4 != a && $2e5ba96e28048472$var$lc(this));
    }
};
function $2e5ba96e28048472$var$vc(a, b) {
    var c = a.C, d = b.indexOf("\n", c);
    if (-1 == d) return $2e5ba96e28048472$var$hc;
    c = Number(b.substring(c, d));
    if (isNaN(c)) return $2e5ba96e28048472$var$gc;
    d += 1;
    if (d + c > b.length) return $2e5ba96e28048472$var$hc;
    b = b.substr(d, c);
    a.C = d + c;
    return b;
}
$2e5ba96e28048472$var$k.cancel = function() {
    this.I = !0;
    $2e5ba96e28048472$var$P(this);
};
function $2e5ba96e28048472$var$lc(a) {
    a.Y = Date.now() + a.P;
    $2e5ba96e28048472$var$xc(a, a.P);
}
function $2e5ba96e28048472$var$xc(a, b) {
    if (null != a.B) throw Error("WatchDog timer not null");
    a.B = $2e5ba96e28048472$var$K($2e5ba96e28048472$var$q(a.eb, a), b);
}
function $2e5ba96e28048472$var$pc(a) {
    a.B && ($2e5ba96e28048472$var$l.clearTimeout(a.B), a.B = null);
}
$2e5ba96e28048472$var$k.eb = function() {
    this.B = null;
    const a = Date.now();
    0 <= a - this.Y ? ($2e5ba96e28048472$var$Qb(this.j, this.A), 2 != this.K && ($2e5ba96e28048472$var$I(3), $2e5ba96e28048472$var$J(17)), $2e5ba96e28048472$var$P(this), this.o = 2, $2e5ba96e28048472$var$rc(this)) : $2e5ba96e28048472$var$xc(this, this.Y - a);
};
function $2e5ba96e28048472$var$rc(a) {
    0 == a.l.G || a.I || $2e5ba96e28048472$var$uc(a.l, a);
}
function $2e5ba96e28048472$var$P(a) {
    $2e5ba96e28048472$var$pc(a);
    var b = a.L;
    b && "function" == typeof b.na && b.na();
    a.L = null;
    $2e5ba96e28048472$var$Fb(a.W);
    $2e5ba96e28048472$var$Lb(a.V);
    a.g && (b = a.g, a.g = null, b.abort(), b.na());
}
function $2e5ba96e28048472$var$sc(a, b) {
    try {
        var c = a.l;
        if (0 != c.G && (c.g == a || $2e5ba96e28048472$var$yc(c.i, a))) {
            if (c.I = a.N, !a.J && $2e5ba96e28048472$var$yc(c.i, a) && 3 == c.G) {
                try {
                    var d = c.Ca.g.parse(b);
                } catch (m) {
                    d = null;
                }
                if (Array.isArray(d) && 3 == d.length) {
                    var e = d;
                    if (0 == e[0]) {
                        a: if (!c.u) {
                            if (c.g) {
                                if (c.g.F + 3E3 < a.F) $2e5ba96e28048472$var$zc(c), $2e5ba96e28048472$var$Ac(c);
                                else break a;
                            }
                            $2e5ba96e28048472$var$Bc(c);
                            $2e5ba96e28048472$var$J(18);
                        }
                    } else c.ta = e[1], 0 < c.ta - c.U && 37500 > e[2] && c.N && 0 == c.A && !c.v && (c.v = $2e5ba96e28048472$var$K($2e5ba96e28048472$var$q(c.ab, c), 6E3));
                    if (1 >= $2e5ba96e28048472$var$Cc(c.i) && c.ka) {
                        try {
                            c.ka();
                        } catch (m) {}
                        c.ka = void 0;
                    }
                } else $2e5ba96e28048472$var$Q(c, 11);
            } else if ((a.J || c.g == a) && $2e5ba96e28048472$var$zc(c), !$2e5ba96e28048472$var$sa(b)) for(e = c.Ca.g.parse(b), b = 0; b < e.length; b++){
                let m = e[b];
                c.U = m[0];
                m = m[1];
                if (2 == c.G) {
                    if ("c" == m[0]) {
                        c.J = m[1];
                        c.la = m[2];
                        const r = m[3];
                        null != r && (c.ma = r, c.h.info("VER=" + c.ma));
                        const G = m[4];
                        null != G && (c.za = G, c.h.info("SVER=" + c.za));
                        const Da = m[5];
                        null != Da && "number" === typeof Da && 0 < Da && (d = 1.5 * Da, c.K = d, c.h.info("backChannelRequestTimeoutMs_=" + d));
                        d = c;
                        const ca = a.g;
                        if (ca) {
                            const Ea = ca.g ? ca.g.getResponseHeader("X-Client-Wire-Protocol") : null;
                            if (Ea) {
                                var f = d.i;
                                !f.g && ($2e5ba96e28048472$var$w(Ea, "spdy") || $2e5ba96e28048472$var$w(Ea, "quic") || $2e5ba96e28048472$var$w(Ea, "h2")) && (f.j = f.l, f.g = new Set, f.h && ($2e5ba96e28048472$var$Dc(f, f.h), f.h = null));
                            }
                            if (d.D) {
                                const xb = ca.g ? ca.g.getResponseHeader("X-HTTP-Session-Id") : null;
                                xb && (d.sa = xb, $2e5ba96e28048472$var$R(d.F, d.D, xb));
                            }
                        }
                        c.G = 3;
                        c.j && c.j.xa();
                        c.$ && (c.O = Date.now() - a.F, c.h.info("Handshake RTT: " + c.O + "ms"));
                        d = c;
                        var h = a;
                        d.oa = $2e5ba96e28048472$var$Ec(d, d.H ? d.la : null, d.W);
                        if (h.J) {
                            $2e5ba96e28048472$var$Fc(d.i, h);
                            var n = h, u = d.K;
                            u && n.setTimeout(u);
                            n.B && ($2e5ba96e28048472$var$pc(n), $2e5ba96e28048472$var$lc(n));
                            d.g = h;
                        } else $2e5ba96e28048472$var$Gc(d);
                        0 < c.l.length && $2e5ba96e28048472$var$Hc(c);
                    } else "stop" != m[0] && "close" != m[0] || $2e5ba96e28048472$var$Q(c, 7);
                } else 3 == c.G && ("stop" == m[0] || "close" == m[0] ? "stop" == m[0] ? $2e5ba96e28048472$var$Q(c, 7) : $2e5ba96e28048472$var$Ic(c) : "noop" != m[0] && c.j && c.j.wa(m), c.A = 0);
            }
        }
        $2e5ba96e28048472$var$I(4);
    } catch (m) {}
}
function $2e5ba96e28048472$var$Jc(a) {
    if (a.R && "function" == typeof a.R) return a.R();
    if ("string" === typeof a) return a.split("");
    if ($2e5ba96e28048472$var$ba(a)) {
        for(var b = [], c = a.length, d = 0; d < c; d++)b.push(a[d]);
        return b;
    }
    b = [];
    c = 0;
    for(d in a)b[c++] = a[d];
    return b;
}
function $2e5ba96e28048472$var$Kc(a, b) {
    if (a.forEach && "function" == typeof a.forEach) a.forEach(b, void 0);
    else if ($2e5ba96e28048472$var$ba(a) || "string" === typeof a) $2e5ba96e28048472$var$na(a, b, void 0);
    else {
        if (a.T && "function" == typeof a.T) var c = a.T();
        else if (a.R && "function" == typeof a.R) c = void 0;
        else if ($2e5ba96e28048472$var$ba(a) || "string" === typeof a) {
            c = [];
            for(var d = a.length, e = 0; e < d; e++)c.push(e);
        } else for(e in c = [], d = 0, a)c[d++] = e;
        d = $2e5ba96e28048472$var$Jc(a);
        e = d.length;
        for(var f = 0; f < e; f++)b.call(void 0, d[f], c && c[f], a);
    }
}
function $2e5ba96e28048472$var$S(a, b) {
    this.h = {};
    this.g = [];
    this.i = 0;
    var c = arguments.length;
    if (1 < c) {
        if (c % 2) throw Error("Uneven number of arguments");
        for(var d = 0; d < c; d += 2)this.set(arguments[d], arguments[d + 1]);
    } else if (a) {
        if (a instanceof $2e5ba96e28048472$var$S) for(c = a.T(), d = 0; d < c.length; d++)this.set(c[d], a.get(c[d]));
        else for(d in a)this.set(d, a[d]);
    }
}
$2e5ba96e28048472$var$k = $2e5ba96e28048472$var$S.prototype;
$2e5ba96e28048472$var$k.R = function() {
    $2e5ba96e28048472$var$Lc(this);
    for(var a = [], b = 0; b < this.g.length; b++)a.push(this.h[this.g[b]]);
    return a;
};
$2e5ba96e28048472$var$k.T = function() {
    $2e5ba96e28048472$var$Lc(this);
    return this.g.concat();
};
function $2e5ba96e28048472$var$Lc(a) {
    if (a.i != a.g.length) {
        for(var b = 0, c = 0; b < a.g.length;){
            var d = a.g[b];
            $2e5ba96e28048472$var$T(a.h, d) && (a.g[c++] = d);
            b++;
        }
        a.g.length = c;
    }
    if (a.i != a.g.length) {
        var e = {};
        for(c = b = 0; b < a.g.length;)d = a.g[b], $2e5ba96e28048472$var$T(e, d) || (a.g[c++] = d, e[d] = 1), b++;
        a.g.length = c;
    }
}
$2e5ba96e28048472$var$k.get = function(a, b) {
    return $2e5ba96e28048472$var$T(this.h, a) ? this.h[a] : b;
};
$2e5ba96e28048472$var$k.set = function(a, b) {
    $2e5ba96e28048472$var$T(this.h, a) || (this.i++, this.g.push(a));
    this.h[a] = b;
};
$2e5ba96e28048472$var$k.forEach = function(a, b) {
    for(var c = this.T(), d = 0; d < c.length; d++){
        var e = c[d], f = this.get(e);
        a.call(b, f, e, this);
    }
};
function $2e5ba96e28048472$var$T(a, b) {
    return Object.prototype.hasOwnProperty.call(a, b);
}
var $2e5ba96e28048472$var$Mc = /^(?:([^:/?#.]+):)?(?:\/\/(?:([^\\/?#]*)@)?([^\\/?#]*?)(?::([0-9]+))?(?=[\\/?#]|$))?([^?#]+)?(?:\?([^#]*))?(?:#([\s\S]*))?$/;
function $2e5ba96e28048472$var$Nc(a, b) {
    if (a) {
        a = a.split("&");
        for(var c = 0; c < a.length; c++){
            var d = a[c].indexOf("="), e = null;
            if (0 <= d) {
                var f = a[c].substring(0, d);
                e = a[c].substring(d + 1);
            } else f = a[c];
            b(f, e ? decodeURIComponent(e.replace(/\+/g, " ")) : "");
        }
    }
}
function $2e5ba96e28048472$var$U(a, b) {
    this.i = this.s = this.j = "";
    this.m = null;
    this.o = this.l = "";
    this.g = !1;
    if (a instanceof $2e5ba96e28048472$var$U) {
        this.g = void 0 !== b ? b : a.g;
        $2e5ba96e28048472$var$Oc(this, a.j);
        this.s = a.s;
        $2e5ba96e28048472$var$Pc(this, a.i);
        $2e5ba96e28048472$var$Qc(this, a.m);
        this.l = a.l;
        b = a.h;
        var c = new $2e5ba96e28048472$var$Rc;
        c.i = b.i;
        b.g && (c.g = new $2e5ba96e28048472$var$S(b.g), c.h = b.h);
        $2e5ba96e28048472$var$Sc(this, c);
        this.o = a.o;
    } else a && (c = String(a).match($2e5ba96e28048472$var$Mc)) ? (this.g = !!b, $2e5ba96e28048472$var$Oc(this, c[1] || "", !0), this.s = $2e5ba96e28048472$var$Tc(c[2] || ""), $2e5ba96e28048472$var$Pc(this, c[3] || "", !0), $2e5ba96e28048472$var$Qc(this, c[4]), this.l = $2e5ba96e28048472$var$Tc(c[5] || "", !0), $2e5ba96e28048472$var$Sc(this, c[6] || "", !0), this.o = $2e5ba96e28048472$var$Tc(c[7] || "")) : (this.g = !!b, this.h = new $2e5ba96e28048472$var$Rc(null, this.g));
}
$2e5ba96e28048472$var$U.prototype.toString = function() {
    var a = [], b = this.j;
    b && a.push($2e5ba96e28048472$var$Uc(b, $2e5ba96e28048472$var$Vc, !0), ":");
    var c = this.i;
    if (c || "file" == b) a.push("//"), (b = this.s) && a.push($2e5ba96e28048472$var$Uc(b, $2e5ba96e28048472$var$Vc, !0), "@"), a.push(encodeURIComponent(String(c)).replace(/%25([0-9a-fA-F]{2})/g, "%$1")), c = this.m, null != c && a.push(":", String(c));
    if (c = this.l) this.i && "/" != c.charAt(0) && a.push("/"), a.push($2e5ba96e28048472$var$Uc(c, "/" == c.charAt(0) ? $2e5ba96e28048472$var$Wc : $2e5ba96e28048472$var$Xc, !0));
    (c = this.h.toString()) && a.push("?", c);
    (c = this.o) && a.push("#", $2e5ba96e28048472$var$Uc(c, $2e5ba96e28048472$var$Yc));
    return a.join("");
};
function $2e5ba96e28048472$var$N(a) {
    return new $2e5ba96e28048472$var$U(a);
}
function $2e5ba96e28048472$var$Oc(a, b, c) {
    a.j = c ? $2e5ba96e28048472$var$Tc(b, !0) : b;
    a.j && (a.j = a.j.replace(/:$/, ""));
}
function $2e5ba96e28048472$var$Pc(a, b, c) {
    a.i = c ? $2e5ba96e28048472$var$Tc(b, !0) : b;
}
function $2e5ba96e28048472$var$Qc(a, b) {
    if (b) {
        b = Number(b);
        if (isNaN(b) || 0 > b) throw Error("Bad port number " + b);
        a.m = b;
    } else a.m = null;
}
function $2e5ba96e28048472$var$Sc(a, b, c) {
    b instanceof $2e5ba96e28048472$var$Rc ? (a.h = b, $2e5ba96e28048472$var$Zc(a.h, a.g)) : (c || (b = $2e5ba96e28048472$var$Uc(b, $2e5ba96e28048472$var$$c)), a.h = new $2e5ba96e28048472$var$Rc(b, a.g));
}
function $2e5ba96e28048472$var$R(a, b, c) {
    a.h.set(b, c);
}
function $2e5ba96e28048472$var$jc(a) {
    $2e5ba96e28048472$var$R(a, "zx", Math.floor(2147483648 * Math.random()).toString(36) + Math.abs(Math.floor(2147483648 * Math.random()) ^ Date.now()).toString(36));
    return a;
}
function $2e5ba96e28048472$var$ad(a) {
    return a instanceof $2e5ba96e28048472$var$U ? $2e5ba96e28048472$var$N(a) : new $2e5ba96e28048472$var$U(a, void 0);
}
function $2e5ba96e28048472$var$bd(a, b, c, d) {
    var e = new $2e5ba96e28048472$var$U(null, void 0);
    a && $2e5ba96e28048472$var$Oc(e, a);
    b && $2e5ba96e28048472$var$Pc(e, b);
    c && $2e5ba96e28048472$var$Qc(e, c);
    d && (e.l = d);
    return e;
}
function $2e5ba96e28048472$var$Tc(a, b) {
    return a ? b ? decodeURI(a.replace(/%25/g, "%2525")) : decodeURIComponent(a) : "";
}
function $2e5ba96e28048472$var$Uc(a, b, c) {
    return "string" === typeof a ? (a = encodeURI(a).replace(b, $2e5ba96e28048472$var$cd), c && (a = a.replace(/%25([0-9a-fA-F]{2})/g, "%$1")), a) : null;
}
function $2e5ba96e28048472$var$cd(a) {
    a = a.charCodeAt(0);
    return "%" + (a >> 4 & 15).toString(16) + (a & 15).toString(16);
}
var $2e5ba96e28048472$var$Vc = /[#\/\?@]/g, $2e5ba96e28048472$var$Xc = /[#\?:]/g, $2e5ba96e28048472$var$Wc = /[#\?]/g, $2e5ba96e28048472$var$$c = /[#\?@]/g, $2e5ba96e28048472$var$Yc = /#/g;
function $2e5ba96e28048472$var$Rc(a, b) {
    this.h = this.g = null;
    this.i = a || null;
    this.j = !!b;
}
function $2e5ba96e28048472$var$V(a) {
    a.g || (a.g = new $2e5ba96e28048472$var$S, a.h = 0, a.i && $2e5ba96e28048472$var$Nc(a.i, function(b, c) {
        a.add(decodeURIComponent(b.replace(/\+/g, " ")), c);
    }));
}
$2e5ba96e28048472$var$k = $2e5ba96e28048472$var$Rc.prototype;
$2e5ba96e28048472$var$k.add = function(a, b) {
    $2e5ba96e28048472$var$V(this);
    this.i = null;
    a = $2e5ba96e28048472$var$W(this, a);
    var c = this.g.get(a);
    c || this.g.set(a, c = []);
    c.push(b);
    this.h += 1;
    return this;
};
function $2e5ba96e28048472$var$dd(a, b) {
    $2e5ba96e28048472$var$V(a);
    b = $2e5ba96e28048472$var$W(a, b);
    $2e5ba96e28048472$var$T(a.g.h, b) && (a.i = null, a.h -= a.g.get(b).length, a = a.g, $2e5ba96e28048472$var$T(a.h, b) && (delete a.h[b], a.i--, a.g.length > 2 * a.i && $2e5ba96e28048472$var$Lc(a)));
}
function $2e5ba96e28048472$var$ed(a, b) {
    $2e5ba96e28048472$var$V(a);
    b = $2e5ba96e28048472$var$W(a, b);
    return $2e5ba96e28048472$var$T(a.g.h, b);
}
$2e5ba96e28048472$var$k.forEach = function(a, b) {
    $2e5ba96e28048472$var$V(this);
    this.g.forEach(function(c, d) {
        $2e5ba96e28048472$var$na(c, function(e) {
            a.call(b, e, d, this);
        }, this);
    }, this);
};
$2e5ba96e28048472$var$k.T = function() {
    $2e5ba96e28048472$var$V(this);
    for(var a = this.g.R(), b = this.g.T(), c = [], d = 0; d < b.length; d++)for(var e = a[d], f = 0; f < e.length; f++)c.push(b[d]);
    return c;
};
$2e5ba96e28048472$var$k.R = function(a) {
    $2e5ba96e28048472$var$V(this);
    var b = [];
    if ("string" === typeof a) $2e5ba96e28048472$var$ed(this, a) && (b = $2e5ba96e28048472$var$qa(b, this.g.get($2e5ba96e28048472$var$W(this, a))));
    else {
        a = this.g.R();
        for(var c = 0; c < a.length; c++)b = $2e5ba96e28048472$var$qa(b, a[c]);
    }
    return b;
};
$2e5ba96e28048472$var$k.set = function(a, b) {
    $2e5ba96e28048472$var$V(this);
    this.i = null;
    a = $2e5ba96e28048472$var$W(this, a);
    $2e5ba96e28048472$var$ed(this, a) && (this.h -= this.g.get(a).length);
    this.g.set(a, [
        b
    ]);
    this.h += 1;
    return this;
};
$2e5ba96e28048472$var$k.get = function(a, b) {
    if (!a) return b;
    a = this.R(a);
    return 0 < a.length ? String(a[0]) : b;
};
function $2e5ba96e28048472$var$mc(a, b, c) {
    $2e5ba96e28048472$var$dd(a, b);
    0 < c.length && (a.i = null, a.g.set($2e5ba96e28048472$var$W(a, b), $2e5ba96e28048472$var$ra(c)), a.h += c.length);
}
$2e5ba96e28048472$var$k.toString = function() {
    if (this.i) return this.i;
    if (!this.g) return "";
    for(var a = [], b = this.g.T(), c = 0; c < b.length; c++){
        var d = b[c], e = encodeURIComponent(String(d));
        d = this.R(d);
        for(var f = 0; f < d.length; f++){
            var h = e;
            "" !== d[f] && (h += "=" + encodeURIComponent(String(d[f])));
            a.push(h);
        }
    }
    return this.i = a.join("&");
};
function $2e5ba96e28048472$var$W(a, b) {
    b = String(b);
    a.j && (b = b.toLowerCase());
    return b;
}
function $2e5ba96e28048472$var$Zc(a, b) {
    b && !a.j && ($2e5ba96e28048472$var$V(a), a.i = null, a.g.forEach(function(c, d) {
        var e = d.toLowerCase();
        d != e && ($2e5ba96e28048472$var$dd(this, d), $2e5ba96e28048472$var$mc(this, e, c));
    }, a));
    a.j = b;
}
var $2e5ba96e28048472$var$fd = class {
    constructor(a, b){
        this.h = a;
        this.g = b;
    }
};
function $2e5ba96e28048472$var$gd(a) {
    this.l = a || $2e5ba96e28048472$var$hd;
    $2e5ba96e28048472$var$l.PerformanceNavigationTiming ? (a = $2e5ba96e28048472$var$l.performance.getEntriesByType("navigation"), a = 0 < a.length && ("hq" == a[0].nextHopProtocol || "h2" == a[0].nextHopProtocol)) : a = !!($2e5ba96e28048472$var$l.g && $2e5ba96e28048472$var$l.g.Ea && $2e5ba96e28048472$var$l.g.Ea() && $2e5ba96e28048472$var$l.g.Ea().Zb);
    this.j = a ? this.l : 1;
    this.g = null;
    1 < this.j && (this.g = new Set);
    this.h = null;
    this.i = [];
}
var $2e5ba96e28048472$var$hd = 10;
function $2e5ba96e28048472$var$id(a) {
    return a.h ? !0 : a.g ? a.g.size >= a.j : !1;
}
function $2e5ba96e28048472$var$Cc(a) {
    return a.h ? 1 : a.g ? a.g.size : 0;
}
function $2e5ba96e28048472$var$yc(a, b) {
    return a.h ? a.h == b : a.g ? a.g.has(b) : !1;
}
function $2e5ba96e28048472$var$Dc(a, b) {
    a.g ? a.g.add(b) : a.h = b;
}
function $2e5ba96e28048472$var$Fc(a, b) {
    a.h && a.h == b ? a.h = null : a.g && a.g.has(b) && a.g.delete(b);
}
$2e5ba96e28048472$var$gd.prototype.cancel = function() {
    this.i = $2e5ba96e28048472$var$jd(this);
    if (this.h) this.h.cancel(), this.h = null;
    else if (this.g && 0 !== this.g.size) {
        for (const a of this.g.values())a.cancel();
        this.g.clear();
    }
};
function $2e5ba96e28048472$var$jd(a) {
    if (null != a.h) return a.i.concat(a.h.D);
    if (null != a.g && 0 !== a.g.size) {
        let b = a.i;
        for (const c of a.g.values())b = b.concat(c.D);
        return b;
    }
    return $2e5ba96e28048472$var$ra(a.i);
}
function $2e5ba96e28048472$var$kd() {}
$2e5ba96e28048472$var$kd.prototype.stringify = function(a) {
    return $2e5ba96e28048472$var$l.JSON.stringify(a, void 0);
};
$2e5ba96e28048472$var$kd.prototype.parse = function(a) {
    return $2e5ba96e28048472$var$l.JSON.parse(a, void 0);
};
function $2e5ba96e28048472$var$ld() {
    this.g = new $2e5ba96e28048472$var$kd;
}
function $2e5ba96e28048472$var$md(a, b, c) {
    const d = c || "";
    try {
        $2e5ba96e28048472$var$Kc(a, function(e, f) {
            let h = e;
            $2e5ba96e28048472$var$p(e) && (h = $2e5ba96e28048472$var$rb(e));
            b.push(d + f + "=" + encodeURIComponent(h));
        });
    } catch (e) {
        throw b.push(d + "type=" + encodeURIComponent("_badmap")), e;
    }
}
function $2e5ba96e28048472$var$nd(a, b) {
    const c = new $2e5ba96e28048472$var$Mb;
    if ($2e5ba96e28048472$var$l.Image) {
        const d = new Image;
        d.onload = $2e5ba96e28048472$var$ja($2e5ba96e28048472$var$od, c, d, "TestLoadImage: loaded", !0, b);
        d.onerror = $2e5ba96e28048472$var$ja($2e5ba96e28048472$var$od, c, d, "TestLoadImage: error", !1, b);
        d.onabort = $2e5ba96e28048472$var$ja($2e5ba96e28048472$var$od, c, d, "TestLoadImage: abort", !1, b);
        d.ontimeout = $2e5ba96e28048472$var$ja($2e5ba96e28048472$var$od, c, d, "TestLoadImage: timeout", !1, b);
        $2e5ba96e28048472$var$l.setTimeout(function() {
            if (d.ontimeout) d.ontimeout();
        }, 1E4);
        d.src = a;
    } else b(!1);
}
function $2e5ba96e28048472$var$od(a, b, c, d, e) {
    try {
        b.onload = null, b.onerror = null, b.onabort = null, b.ontimeout = null, e(d);
    } catch (f) {}
}
function $2e5ba96e28048472$var$pd(a) {
    this.l = a.$b || null;
    this.j = a.ib || !1;
}
$2e5ba96e28048472$var$t($2e5ba96e28048472$var$pd, $2e5ba96e28048472$var$Yb);
$2e5ba96e28048472$var$pd.prototype.g = function() {
    return new $2e5ba96e28048472$var$qd(this.l, this.j);
};
$2e5ba96e28048472$var$pd.prototype.i = function(a) {
    return function() {
        return a;
    };
}({});
function $2e5ba96e28048472$var$qd(a, b) {
    $2e5ba96e28048472$var$C.call(this);
    this.D = a;
    this.u = b;
    this.m = void 0;
    this.readyState = $2e5ba96e28048472$var$rd;
    this.status = 0;
    this.responseType = this.responseText = this.response = this.statusText = "";
    this.onreadystatechange = null;
    this.v = new Headers;
    this.h = null;
    this.C = "GET";
    this.B = "";
    this.g = !1;
    this.A = this.j = this.l = null;
}
$2e5ba96e28048472$var$t($2e5ba96e28048472$var$qd, $2e5ba96e28048472$var$C);
var $2e5ba96e28048472$var$rd = 0;
$2e5ba96e28048472$var$k = $2e5ba96e28048472$var$qd.prototype;
$2e5ba96e28048472$var$k.open = function(a, b) {
    if (this.readyState != $2e5ba96e28048472$var$rd) throw this.abort(), Error("Error reopening a connection");
    this.C = a;
    this.B = b;
    this.readyState = 1;
    $2e5ba96e28048472$var$sd(this);
};
$2e5ba96e28048472$var$k.send = function(a) {
    if (1 != this.readyState) throw this.abort(), Error("need to call open() first. ");
    this.g = !0;
    const b = {
        headers: this.v,
        method: this.C,
        credentials: this.m,
        cache: void 0
    };
    a && (b.body = a);
    (this.D || $2e5ba96e28048472$var$l).fetch(new Request(this.B, b)).then(this.Va.bind(this), this.ha.bind(this));
};
$2e5ba96e28048472$var$k.abort = function() {
    this.response = this.responseText = "";
    this.v = new Headers;
    this.status = 0;
    this.j && this.j.cancel("Request was aborted.");
    1 <= this.readyState && this.g && 4 != this.readyState && (this.g = !1, $2e5ba96e28048472$var$td(this));
    this.readyState = $2e5ba96e28048472$var$rd;
};
$2e5ba96e28048472$var$k.Va = function(a) {
    if (this.g && (this.l = a, this.h || (this.status = this.l.status, this.statusText = this.l.statusText, this.h = a.headers, this.readyState = 2, $2e5ba96e28048472$var$sd(this)), this.g && (this.readyState = 3, $2e5ba96e28048472$var$sd(this), this.g))) {
        if ("arraybuffer" === this.responseType) a.arrayBuffer().then(this.Ta.bind(this), this.ha.bind(this));
        else if ("undefined" !== typeof $2e5ba96e28048472$var$l.ReadableStream && "body" in a) {
            this.j = a.body.getReader();
            if (this.u) {
                if (this.responseType) throw Error('responseType must be empty for "streamBinaryChunks" mode responses.');
                this.response = [];
            } else this.response = this.responseText = "", this.A = new TextDecoder;
            $2e5ba96e28048472$var$ud(this);
        } else a.text().then(this.Ua.bind(this), this.ha.bind(this));
    }
};
function $2e5ba96e28048472$var$ud(a) {
    a.j.read().then(a.Sa.bind(a)).catch(a.ha.bind(a));
}
$2e5ba96e28048472$var$k.Sa = function(a) {
    if (this.g) {
        if (this.u && a.value) this.response.push(a.value);
        else if (!this.u) {
            var b = a.value ? a.value : new Uint8Array(0);
            if (b = this.A.decode(b, {
                stream: !a.done
            })) this.response = this.responseText += b;
        }
        a.done ? $2e5ba96e28048472$var$td(this) : $2e5ba96e28048472$var$sd(this);
        3 == this.readyState && $2e5ba96e28048472$var$ud(this);
    }
};
$2e5ba96e28048472$var$k.Ua = function(a) {
    this.g && (this.response = this.responseText = a, $2e5ba96e28048472$var$td(this));
};
$2e5ba96e28048472$var$k.Ta = function(a) {
    this.g && (this.response = a, $2e5ba96e28048472$var$td(this));
};
$2e5ba96e28048472$var$k.ha = function() {
    this.g && $2e5ba96e28048472$var$td(this);
};
function $2e5ba96e28048472$var$td(a) {
    a.readyState = 4;
    a.l = null;
    a.j = null;
    a.A = null;
    $2e5ba96e28048472$var$sd(a);
}
$2e5ba96e28048472$var$k.setRequestHeader = function(a, b) {
    this.v.append(a, b);
};
$2e5ba96e28048472$var$k.getResponseHeader = function(a) {
    return this.h ? this.h.get(a.toLowerCase()) || "" : "";
};
$2e5ba96e28048472$var$k.getAllResponseHeaders = function() {
    if (!this.h) return "";
    const a = [], b = this.h.entries();
    for(var c = b.next(); !c.done;)c = c.value, a.push(c[0] + ": " + c[1]), c = b.next();
    return a.join("\r\n");
};
function $2e5ba96e28048472$var$sd(a) {
    a.onreadystatechange && a.onreadystatechange.call(a);
}
Object.defineProperty($2e5ba96e28048472$var$qd.prototype, "withCredentials", {
    get: function() {
        return "include" === this.m;
    },
    set: function(a) {
        this.m = a ? "include" : "same-origin";
    }
});
var $2e5ba96e28048472$var$vd = $2e5ba96e28048472$var$l.JSON.parse;
function $2e5ba96e28048472$var$X(a) {
    $2e5ba96e28048472$var$C.call(this);
    this.headers = new $2e5ba96e28048472$var$S;
    this.u = a || null;
    this.h = !1;
    this.C = this.g = null;
    this.H = "";
    this.m = 0;
    this.j = "";
    this.l = this.F = this.v = this.D = !1;
    this.B = 0;
    this.A = null;
    this.J = $2e5ba96e28048472$var$wd;
    this.K = this.L = !1;
}
$2e5ba96e28048472$var$t($2e5ba96e28048472$var$X, $2e5ba96e28048472$var$C);
var $2e5ba96e28048472$var$wd = "", $2e5ba96e28048472$var$xd = /^https?$/i, $2e5ba96e28048472$var$yd = [
    "POST",
    "PUT"
];
$2e5ba96e28048472$var$k = $2e5ba96e28048472$var$X.prototype;
$2e5ba96e28048472$var$k.ea = function(a, b, c, d) {
    if (this.g) throw Error("[goog.net.XhrIo] Object is active with another request=" + this.H + "; newUri=" + a);
    b = b ? b.toUpperCase() : "GET";
    this.H = a;
    this.j = "";
    this.m = 0;
    this.D = !1;
    this.h = !0;
    this.g = this.u ? this.u.g() : $2e5ba96e28048472$var$cc.g();
    this.C = this.u ? $2e5ba96e28048472$var$Zb(this.u) : $2e5ba96e28048472$var$Zb($2e5ba96e28048472$var$cc);
    this.g.onreadystatechange = $2e5ba96e28048472$var$q(this.Fa, this);
    try {
        this.F = !0, this.g.open(b, String(a), !0), this.F = !1;
    } catch (f) {
        $2e5ba96e28048472$var$zd(this, f);
        return;
    }
    a = c || "";
    const e = new $2e5ba96e28048472$var$S(this.headers);
    d && $2e5ba96e28048472$var$Kc(d, function(f, h) {
        e.set(h, f);
    });
    d = $2e5ba96e28048472$var$oa(e.T());
    c = $2e5ba96e28048472$var$l.FormData && a instanceof $2e5ba96e28048472$var$l.FormData;
    !(0 <= $2e5ba96e28048472$var$ma($2e5ba96e28048472$var$yd, b)) || d || c || e.set("Content-Type", "application/x-www-form-urlencoded;charset=utf-8");
    e.forEach(function(f, h) {
        this.g.setRequestHeader(h, f);
    }, this);
    this.J && (this.g.responseType = this.J);
    "withCredentials" in this.g && this.g.withCredentials !== this.L && (this.g.withCredentials = this.L);
    try {
        $2e5ba96e28048472$var$Ad(this), 0 < this.B && ((this.K = $2e5ba96e28048472$var$Bd(this.g)) ? (this.g.timeout = this.B, this.g.ontimeout = $2e5ba96e28048472$var$q(this.pa, this)) : this.A = $2e5ba96e28048472$var$Gb(this.pa, this.B, this)), this.v = !0, this.g.send(a), this.v = !1;
    } catch (f) {
        $2e5ba96e28048472$var$zd(this, f);
    }
};
function $2e5ba96e28048472$var$Bd(a) {
    return $2e5ba96e28048472$var$y && $2e5ba96e28048472$var$Ra() && "number" === typeof a.timeout && void 0 !== a.ontimeout;
}
function $2e5ba96e28048472$var$pa(a) {
    return "content-type" == a.toLowerCase();
}
$2e5ba96e28048472$var$k.pa = function() {
    "undefined" != typeof $2e5ba96e28048472$var$goog && this.g && (this.j = "Timed out after " + this.B + "ms, aborting", this.m = 8, $2e5ba96e28048472$var$D(this, "timeout"), this.abort(8));
};
function $2e5ba96e28048472$var$zd(a, b) {
    a.h = !1;
    a.g && (a.l = !0, a.g.abort(), a.l = !1);
    a.j = b;
    a.m = 5;
    $2e5ba96e28048472$var$Cd(a);
    $2e5ba96e28048472$var$Dd(a);
}
function $2e5ba96e28048472$var$Cd(a) {
    a.D || (a.D = !0, $2e5ba96e28048472$var$D(a, "complete"), $2e5ba96e28048472$var$D(a, "error"));
}
$2e5ba96e28048472$var$k.abort = function(a) {
    this.g && this.h && (this.h = !1, this.l = !0, this.g.abort(), this.l = !1, this.m = a || 7, $2e5ba96e28048472$var$D(this, "complete"), $2e5ba96e28048472$var$D(this, "abort"), $2e5ba96e28048472$var$Dd(this));
};
$2e5ba96e28048472$var$k.M = function() {
    this.g && (this.h && (this.h = !1, this.l = !0, this.g.abort(), this.l = !1), $2e5ba96e28048472$var$Dd(this, !0));
    $2e5ba96e28048472$var$X.Z.M.call(this);
};
$2e5ba96e28048472$var$k.Fa = function() {
    this.s || (this.F || this.v || this.l ? $2e5ba96e28048472$var$Ed(this) : this.cb());
};
$2e5ba96e28048472$var$k.cb = function() {
    $2e5ba96e28048472$var$Ed(this);
};
function $2e5ba96e28048472$var$Ed(a) {
    if (a.h && "undefined" != typeof $2e5ba96e28048472$var$goog && (!a.C[1] || 4 != $2e5ba96e28048472$var$O(a) || 2 != a.ba())) {
        if (a.v && 4 == $2e5ba96e28048472$var$O(a)) $2e5ba96e28048472$var$Gb(a.Fa, 0, a);
        else if ($2e5ba96e28048472$var$D(a, "readystatechange"), 4 == $2e5ba96e28048472$var$O(a)) {
            a.h = !1;
            try {
                const n = a.ba();
                a: switch(n){
                    case 200:
                    case 201:
                    case 202:
                    case 204:
                    case 206:
                    case 304:
                    case 1223:
                        var b = !0;
                        break a;
                    default:
                        b = !1;
                }
                var c;
                if (!(c = b)) {
                    var d;
                    if (d = 0 === n) {
                        var e = String(a.H).match($2e5ba96e28048472$var$Mc)[1] || null;
                        if (!e && $2e5ba96e28048472$var$l.self && $2e5ba96e28048472$var$l.self.location) {
                            var f = $2e5ba96e28048472$var$l.self.location.protocol;
                            e = f.substr(0, f.length - 1);
                        }
                        d = !$2e5ba96e28048472$var$xd.test(e ? e.toLowerCase() : "");
                    }
                    c = d;
                }
                if (c) $2e5ba96e28048472$var$D(a, "complete"), $2e5ba96e28048472$var$D(a, "success");
                else {
                    a.m = 6;
                    try {
                        var h = 2 < $2e5ba96e28048472$var$O(a) ? a.g.statusText : "";
                    } catch (u) {
                        h = "";
                    }
                    a.j = h + " [" + a.ba() + "]";
                    $2e5ba96e28048472$var$Cd(a);
                }
            } finally{
                $2e5ba96e28048472$var$Dd(a);
            }
        }
    }
}
function $2e5ba96e28048472$var$Dd(a, b) {
    if (a.g) {
        $2e5ba96e28048472$var$Ad(a);
        const c = a.g, d = a.C[0] ? $2e5ba96e28048472$var$aa : null;
        a.g = null;
        a.C = null;
        b || $2e5ba96e28048472$var$D(a, "ready");
        try {
            c.onreadystatechange = d;
        } catch (e) {}
    }
}
function $2e5ba96e28048472$var$Ad(a) {
    a.g && a.K && (a.g.ontimeout = null);
    a.A && ($2e5ba96e28048472$var$l.clearTimeout(a.A), a.A = null);
}
function $2e5ba96e28048472$var$O(a) {
    return a.g ? a.g.readyState : 0;
}
$2e5ba96e28048472$var$k.ba = function() {
    try {
        return 2 < $2e5ba96e28048472$var$O(this) ? this.g.status : -1;
    } catch (a) {
        return -1;
    }
};
$2e5ba96e28048472$var$k.ga = function() {
    try {
        return this.g ? this.g.responseText : "";
    } catch (a) {
        return "";
    }
};
$2e5ba96e28048472$var$k.Qa = function(a) {
    if (this.g) {
        var b = this.g.responseText;
        a && 0 == b.indexOf(a) && (b = b.substring(a.length));
        return $2e5ba96e28048472$var$vd(b);
    }
};
function $2e5ba96e28048472$var$oc(a) {
    try {
        if (!a.g) return null;
        if ("response" in a.g) return a.g.response;
        switch(a.J){
            case $2e5ba96e28048472$var$wd:
            case "text":
                return a.g.responseText;
            case "arraybuffer":
                if ("mozResponseArrayBuffer" in a.g) return a.g.mozResponseArrayBuffer;
        }
        return null;
    } catch (b) {
        return null;
    }
}
$2e5ba96e28048472$var$k.Da = function() {
    return this.m;
};
$2e5ba96e28048472$var$k.La = function() {
    return "string" === typeof this.j ? this.j : String(this.j);
};
function $2e5ba96e28048472$var$Fd(a) {
    let b = "";
    $2e5ba96e28048472$var$xa(a, function(c, d) {
        b += d;
        b += ":";
        b += c;
        b += "\r\n";
    });
    return b;
}
function $2e5ba96e28048472$var$Gd(a, b, c) {
    a: {
        for(d in c){
            var d = !1;
            break a;
        }
        d = !0;
    }
    d || (c = $2e5ba96e28048472$var$Fd(c), "string" === typeof a ? null != c && encodeURIComponent(String(c)) : $2e5ba96e28048472$var$R(a, b, c));
}
function $2e5ba96e28048472$var$Hd(a, b, c) {
    return c && c.internalChannelParams ? c.internalChannelParams[a] || b : b;
}
function $2e5ba96e28048472$var$Id(a) {
    this.za = 0;
    this.l = [];
    this.h = new $2e5ba96e28048472$var$Mb;
    this.la = this.oa = this.F = this.W = this.g = this.sa = this.D = this.aa = this.o = this.P = this.s = null;
    this.Za = this.V = 0;
    this.Xa = $2e5ba96e28048472$var$Hd("failFast", !1, a);
    this.N = this.v = this.u = this.m = this.j = null;
    this.X = !0;
    this.I = this.ta = this.U = -1;
    this.Y = this.A = this.C = 0;
    this.Pa = $2e5ba96e28048472$var$Hd("baseRetryDelayMs", 5E3, a);
    this.$a = $2e5ba96e28048472$var$Hd("retryDelaySeedMs", 1E4, a);
    this.Ya = $2e5ba96e28048472$var$Hd("forwardChannelMaxRetries", 2, a);
    this.ra = $2e5ba96e28048472$var$Hd("forwardChannelRequestTimeoutMs", 2E4, a);
    this.qa = a && a.xmlHttpFactory || void 0;
    this.Ba = a && a.Yb || !1;
    this.K = void 0;
    this.H = a && a.supportsCrossDomainXhr || !1;
    this.J = "";
    this.i = new $2e5ba96e28048472$var$gd(a && a.concurrentRequestLimit);
    this.Ca = new $2e5ba96e28048472$var$ld;
    this.ja = a && a.fastHandshake || !1;
    this.Ra = a && a.Wb || !1;
    a && a.Aa && this.h.Aa();
    a && a.forceLongPolling && (this.X = !1);
    this.$ = !this.ja && this.X && a && a.detectBufferingProxy || !1;
    this.ka = void 0;
    this.O = 0;
    this.L = !1;
    this.B = null;
    this.Wa = !a || !1 !== a.Xb;
}
$2e5ba96e28048472$var$k = $2e5ba96e28048472$var$Id.prototype;
$2e5ba96e28048472$var$k.ma = 8;
$2e5ba96e28048472$var$k.G = 1;
function $2e5ba96e28048472$var$Ic(a) {
    $2e5ba96e28048472$var$Jd(a);
    if (3 == a.G) {
        var b = a.V++, c = $2e5ba96e28048472$var$N(a.F);
        $2e5ba96e28048472$var$R(c, "SID", a.J);
        $2e5ba96e28048472$var$R(c, "RID", b);
        $2e5ba96e28048472$var$R(c, "TYPE", "terminate");
        $2e5ba96e28048472$var$Kd(a, c);
        b = new $2e5ba96e28048472$var$M(a, a.h, b, void 0);
        b.K = 2;
        b.v = $2e5ba96e28048472$var$jc($2e5ba96e28048472$var$N(c));
        c = !1;
        $2e5ba96e28048472$var$l.navigator && $2e5ba96e28048472$var$l.navigator.sendBeacon && (c = $2e5ba96e28048472$var$l.navigator.sendBeacon(b.v.toString(), ""));
        !c && $2e5ba96e28048472$var$l.Image && ((new Image).src = b.v, c = !0);
        c || (b.g = $2e5ba96e28048472$var$nc(b.l, null), b.g.ea(b.v));
        b.F = Date.now();
        $2e5ba96e28048472$var$lc(b);
    }
    $2e5ba96e28048472$var$Ld(a);
}
$2e5ba96e28048472$var$k.hb = function(a) {
    try {
        this.h.info("Origin Trials invoked: " + a);
    } catch (b) {}
};
function $2e5ba96e28048472$var$Ac(a) {
    a.g && ($2e5ba96e28048472$var$wc(a), a.g.cancel(), a.g = null);
}
function $2e5ba96e28048472$var$Jd(a) {
    $2e5ba96e28048472$var$Ac(a);
    a.u && ($2e5ba96e28048472$var$l.clearTimeout(a.u), a.u = null);
    $2e5ba96e28048472$var$zc(a);
    a.i.cancel();
    a.m && ("number" === typeof a.m && $2e5ba96e28048472$var$l.clearTimeout(a.m), a.m = null);
}
function $2e5ba96e28048472$var$Md(a, b) {
    a.l.push(new $2e5ba96e28048472$var$fd(a.Za++, b));
    3 == a.G && $2e5ba96e28048472$var$Hc(a);
}
function $2e5ba96e28048472$var$Hc(a) {
    $2e5ba96e28048472$var$id(a.i) || a.m || (a.m = !0, $2e5ba96e28048472$var$zb(a.Ha, a), a.C = 0);
}
function $2e5ba96e28048472$var$Nd(a, b) {
    if ($2e5ba96e28048472$var$Cc(a.i) >= a.i.j - (a.m ? 1 : 0)) return !1;
    if (a.m) return a.l = b.D.concat(a.l), !0;
    if (1 == a.G || 2 == a.G || a.C >= (a.Xa ? 0 : a.Ya)) return !1;
    a.m = $2e5ba96e28048472$var$K($2e5ba96e28048472$var$q(a.Ha, a, b), $2e5ba96e28048472$var$Od(a, a.C));
    a.C++;
    return !0;
}
$2e5ba96e28048472$var$k.Ha = function(a) {
    if (this.m) {
        if (this.m = null, 1 == this.G) {
            if (!a) {
                this.V = Math.floor(1E5 * Math.random());
                a = this.V++;
                const e = new $2e5ba96e28048472$var$M(this, this.h, a, void 0);
                let f = this.s;
                this.P && (f ? (f = $2e5ba96e28048472$var$ya(f), $2e5ba96e28048472$var$Aa(f, this.P)) : f = this.P);
                null === this.o && (e.H = f);
                if (this.ja) a: {
                    var b = 0;
                    for(var c = 0; c < this.l.length; c++){
                        b: {
                            var d = this.l[c];
                            if ("__data__" in d.g && (d = d.g.__data__, "string" === typeof d)) {
                                d = d.length;
                                break b;
                            }
                            d = void 0;
                        }
                        if (void 0 === d) break;
                        b += d;
                        if (4096 < b) {
                            b = c;
                            break a;
                        }
                        if (4096 === b || c === this.l.length - 1) {
                            b = c + 1;
                            break a;
                        }
                    }
                    b = 1E3;
                }
                else b = 1E3;
                b = $2e5ba96e28048472$var$Pd(this, e, b);
                c = $2e5ba96e28048472$var$N(this.F);
                $2e5ba96e28048472$var$R(c, "RID", a);
                $2e5ba96e28048472$var$R(c, "CVER", 22);
                this.D && $2e5ba96e28048472$var$R(c, "X-HTTP-Session-Id", this.D);
                $2e5ba96e28048472$var$Kd(this, c);
                this.o && f && $2e5ba96e28048472$var$Gd(c, this.o, f);
                $2e5ba96e28048472$var$Dc(this.i, e);
                this.Ra && $2e5ba96e28048472$var$R(c, "TYPE", "init");
                this.ja ? ($2e5ba96e28048472$var$R(c, "$req", b), $2e5ba96e28048472$var$R(c, "SID", "null"), e.$ = !0, $2e5ba96e28048472$var$ic(e, c, null)) : $2e5ba96e28048472$var$ic(e, c, b);
                this.G = 2;
            }
        } else 3 == this.G && (a ? $2e5ba96e28048472$var$Qd(this, a) : 0 == this.l.length || $2e5ba96e28048472$var$id(this.i) || $2e5ba96e28048472$var$Qd(this));
    }
};
function $2e5ba96e28048472$var$Qd(a, b) {
    var c;
    b ? c = b.m : c = a.V++;
    const d = $2e5ba96e28048472$var$N(a.F);
    $2e5ba96e28048472$var$R(d, "SID", a.J);
    $2e5ba96e28048472$var$R(d, "RID", c);
    $2e5ba96e28048472$var$R(d, "AID", a.U);
    $2e5ba96e28048472$var$Kd(a, d);
    a.o && a.s && $2e5ba96e28048472$var$Gd(d, a.o, a.s);
    c = new $2e5ba96e28048472$var$M(a, a.h, c, a.C + 1);
    null === a.o && (c.H = a.s);
    b && (a.l = b.D.concat(a.l));
    b = $2e5ba96e28048472$var$Pd(a, c, 1E3);
    c.setTimeout(Math.round(.5 * a.ra) + Math.round(.5 * a.ra * Math.random()));
    $2e5ba96e28048472$var$Dc(a.i, c);
    $2e5ba96e28048472$var$ic(c, d, b);
}
function $2e5ba96e28048472$var$Kd(a, b) {
    a.j && $2e5ba96e28048472$var$Kc({}, function(c, d) {
        $2e5ba96e28048472$var$R(b, d, c);
    });
}
function $2e5ba96e28048472$var$Pd(a, b, c) {
    c = Math.min(a.l.length, c);
    var d = a.j ? $2e5ba96e28048472$var$q(a.j.Oa, a.j, a) : null;
    a: {
        var e = a.l;
        let f = -1;
        for(;;){
            const h = [
                "count=" + c
            ];
            -1 == f ? 0 < c ? (f = e[0].h, h.push("ofs=" + f)) : f = 0 : h.push("ofs=" + f);
            let n = !0;
            for(let u = 0; u < c; u++){
                let m = e[u].h;
                const r = e[u].g;
                m -= f;
                if (0 > m) f = Math.max(0, e[u].h - 100), n = !1;
                else try {
                    $2e5ba96e28048472$var$md(r, h, "req" + m + "_");
                } catch (G) {
                    d && d(r);
                }
            }
            if (n) {
                d = h.join("&");
                break a;
            }
        }
    }
    a = a.l.splice(0, c);
    b.D = a;
    return d;
}
function $2e5ba96e28048472$var$Gc(a) {
    a.g || a.u || (a.Y = 1, $2e5ba96e28048472$var$zb(a.Ga, a), a.A = 0);
}
function $2e5ba96e28048472$var$Bc(a) {
    if (a.g || a.u || 3 <= a.A) return !1;
    a.Y++;
    a.u = $2e5ba96e28048472$var$K($2e5ba96e28048472$var$q(a.Ga, a), $2e5ba96e28048472$var$Od(a, a.A));
    a.A++;
    return !0;
}
$2e5ba96e28048472$var$k.Ga = function() {
    this.u = null;
    $2e5ba96e28048472$var$Rd(this);
    if (this.$ && !(this.L || null == this.g || 0 >= this.O)) {
        var a = 2 * this.O;
        this.h.info("BP detection timer enabled: " + a);
        this.B = $2e5ba96e28048472$var$K($2e5ba96e28048472$var$q(this.bb, this), a);
    }
};
$2e5ba96e28048472$var$k.bb = function() {
    this.B && (this.B = null, this.h.info("BP detection timeout reached."), this.h.info("Buffering proxy detected and switch to long-polling!"), this.N = !1, this.L = !0, $2e5ba96e28048472$var$J(10), $2e5ba96e28048472$var$Ac(this), $2e5ba96e28048472$var$Rd(this));
};
function $2e5ba96e28048472$var$wc(a) {
    null != a.B && ($2e5ba96e28048472$var$l.clearTimeout(a.B), a.B = null);
}
function $2e5ba96e28048472$var$Rd(a) {
    a.g = new $2e5ba96e28048472$var$M(a, a.h, "rpc", a.Y);
    null === a.o && (a.g.H = a.s);
    a.g.O = 0;
    var b = $2e5ba96e28048472$var$N(a.oa);
    $2e5ba96e28048472$var$R(b, "RID", "rpc");
    $2e5ba96e28048472$var$R(b, "SID", a.J);
    $2e5ba96e28048472$var$R(b, "CI", a.N ? "0" : "1");
    $2e5ba96e28048472$var$R(b, "AID", a.U);
    $2e5ba96e28048472$var$Kd(a, b);
    $2e5ba96e28048472$var$R(b, "TYPE", "xmlhttp");
    a.o && a.s && $2e5ba96e28048472$var$Gd(b, a.o, a.s);
    a.K && a.g.setTimeout(a.K);
    var c = a.g;
    a = a.la;
    c.K = 1;
    c.v = $2e5ba96e28048472$var$jc($2e5ba96e28048472$var$N(b));
    c.s = null;
    c.U = !0;
    $2e5ba96e28048472$var$kc(c, a);
}
$2e5ba96e28048472$var$k.ab = function() {
    null != this.v && (this.v = null, $2e5ba96e28048472$var$Ac(this), $2e5ba96e28048472$var$Bc(this), $2e5ba96e28048472$var$J(19));
};
function $2e5ba96e28048472$var$zc(a) {
    null != a.v && ($2e5ba96e28048472$var$l.clearTimeout(a.v), a.v = null);
}
function $2e5ba96e28048472$var$uc(a, b) {
    var c = null;
    if (a.g == b) {
        $2e5ba96e28048472$var$zc(a);
        $2e5ba96e28048472$var$wc(a);
        a.g = null;
        var d = 2;
    } else if ($2e5ba96e28048472$var$yc(a.i, b)) c = b.D, $2e5ba96e28048472$var$Fc(a.i, b), d = 1;
    else return;
    a.I = b.N;
    if (0 != a.G) {
        if (b.i) {
            if (1 == d) {
                c = b.s ? b.s.length : 0;
                b = Date.now() - b.F;
                var e = a.C;
                d = $2e5ba96e28048472$var$Sb();
                $2e5ba96e28048472$var$D(d, new $2e5ba96e28048472$var$Vb(d, c, b, e));
                $2e5ba96e28048472$var$Hc(a);
            } else $2e5ba96e28048472$var$Gc(a);
        } else if (e = b.o, 3 == e || 0 == e && 0 < a.I || !(1 == d && $2e5ba96e28048472$var$Nd(a, b) || 2 == d && $2e5ba96e28048472$var$Bc(a))) switch(c && 0 < c.length && (b = a.i, b.i = b.i.concat(c)), e){
            case 1:
                $2e5ba96e28048472$var$Q(a, 5);
                break;
            case 4:
                $2e5ba96e28048472$var$Q(a, 10);
                break;
            case 3:
                $2e5ba96e28048472$var$Q(a, 6);
                break;
            default:
                $2e5ba96e28048472$var$Q(a, 2);
        }
    }
}
function $2e5ba96e28048472$var$Od(a, b) {
    let c = a.Pa + Math.floor(Math.random() * a.$a);
    a.j || (c *= 2);
    return c * b;
}
function $2e5ba96e28048472$var$Q(a, b) {
    a.h.info("Error code " + b);
    if (2 == b) {
        var c = null;
        a.j && (c = null);
        var d = $2e5ba96e28048472$var$q(a.jb, a);
        c || (c = new $2e5ba96e28048472$var$U("//www.google.com/images/cleardot.gif"), $2e5ba96e28048472$var$l.location && "http" == $2e5ba96e28048472$var$l.location.protocol || $2e5ba96e28048472$var$Oc(c, "https"), $2e5ba96e28048472$var$jc(c));
        $2e5ba96e28048472$var$nd(c.toString(), d);
    } else $2e5ba96e28048472$var$J(2);
    a.G = 0;
    a.j && a.j.va(b);
    $2e5ba96e28048472$var$Ld(a);
    $2e5ba96e28048472$var$Jd(a);
}
$2e5ba96e28048472$var$k.jb = function(a) {
    a ? (this.h.info("Successfully pinged google.com"), $2e5ba96e28048472$var$J(2)) : (this.h.info("Failed to ping google.com"), $2e5ba96e28048472$var$J(1));
};
function $2e5ba96e28048472$var$Ld(a) {
    a.G = 0;
    a.I = -1;
    if (a.j) {
        if (0 != $2e5ba96e28048472$var$jd(a.i).length || 0 != a.l.length) a.i.i.length = 0, $2e5ba96e28048472$var$ra(a.l), a.l.length = 0;
        a.j.ua();
    }
}
function $2e5ba96e28048472$var$Ec(a, b, c) {
    let d = $2e5ba96e28048472$var$ad(c);
    if ("" != d.i) b && $2e5ba96e28048472$var$Pc(d, b + "." + d.i), $2e5ba96e28048472$var$Qc(d, d.m);
    else {
        const e = $2e5ba96e28048472$var$l.location;
        d = $2e5ba96e28048472$var$bd(e.protocol, b ? b + "." + e.hostname : e.hostname, +e.port, c);
    }
    a.aa && $2e5ba96e28048472$var$xa(a.aa, function(e, f) {
        $2e5ba96e28048472$var$R(d, f, e);
    });
    b = a.D;
    c = a.sa;
    b && c && $2e5ba96e28048472$var$R(d, b, c);
    $2e5ba96e28048472$var$R(d, "VER", a.ma);
    $2e5ba96e28048472$var$Kd(a, d);
    return d;
}
function $2e5ba96e28048472$var$nc(a, b, c) {
    if (b && !a.H) throw Error("Can't create secondary domain capable XhrIo object.");
    b = c && a.Ba && !a.qa ? new $2e5ba96e28048472$var$X(new $2e5ba96e28048472$var$pd({
        ib: !0
    })) : new $2e5ba96e28048472$var$X(a.qa);
    b.L = a.H;
    return b;
}
function $2e5ba96e28048472$var$Sd() {}
$2e5ba96e28048472$var$k = $2e5ba96e28048472$var$Sd.prototype;
$2e5ba96e28048472$var$k.xa = function() {};
$2e5ba96e28048472$var$k.wa = function() {};
$2e5ba96e28048472$var$k.va = function() {};
$2e5ba96e28048472$var$k.ua = function() {};
$2e5ba96e28048472$var$k.Oa = function() {};
function $2e5ba96e28048472$var$Td() {
    if ($2e5ba96e28048472$var$y && !(10 <= Number($2e5ba96e28048472$var$Ua))) throw Error("Environmental error: no available transport.");
}
$2e5ba96e28048472$var$Td.prototype.g = function(a, b) {
    return new $2e5ba96e28048472$var$Y(a, b);
};
function $2e5ba96e28048472$var$Y(a, b) {
    $2e5ba96e28048472$var$C.call(this);
    this.g = new $2e5ba96e28048472$var$Id(b);
    this.l = a;
    this.h = b && b.messageUrlParams || null;
    a = b && b.messageHeaders || null;
    b && b.clientProtocolHeaderRequired && (a ? a["X-Client-Protocol"] = "webchannel" : a = {
        "X-Client-Protocol": "webchannel"
    });
    this.g.s = a;
    a = b && b.initMessageHeaders || null;
    b && b.messageContentType && (a ? a["X-WebChannel-Content-Type"] = b.messageContentType : a = {
        "X-WebChannel-Content-Type": b.messageContentType
    });
    b && b.ya && (a ? a["X-WebChannel-Client-Profile"] = b.ya : a = {
        "X-WebChannel-Client-Profile": b.ya
    });
    this.g.P = a;
    (a = b && b.httpHeadersOverwriteParam) && !$2e5ba96e28048472$var$sa(a) && (this.g.o = a);
    this.A = b && b.supportsCrossDomainXhr || !1;
    this.v = b && b.sendRawJson || !1;
    (b = b && b.httpSessionIdParam) && !$2e5ba96e28048472$var$sa(b) && (this.g.D = b, a = this.h, null !== a && b in a && (a = this.h, b in a && delete a[b]));
    this.j = new $2e5ba96e28048472$var$Z(this);
}
$2e5ba96e28048472$var$t($2e5ba96e28048472$var$Y, $2e5ba96e28048472$var$C);
$2e5ba96e28048472$var$Y.prototype.m = function() {
    this.g.j = this.j;
    this.A && (this.g.H = !0);
    var a = this.g, b = this.l, c = this.h || void 0;
    a.Wa && (a.h.info("Origin Trials enabled."), $2e5ba96e28048472$var$zb($2e5ba96e28048472$var$q(a.hb, a, b)));
    $2e5ba96e28048472$var$J(0);
    a.W = b;
    a.aa = c || {};
    a.N = a.X;
    a.F = $2e5ba96e28048472$var$Ec(a, null, a.W);
    $2e5ba96e28048472$var$Hc(a);
};
$2e5ba96e28048472$var$Y.prototype.close = function() {
    $2e5ba96e28048472$var$Ic(this.g);
};
$2e5ba96e28048472$var$Y.prototype.u = function(a) {
    if ("string" === typeof a) {
        var b = {};
        b.__data__ = a;
        $2e5ba96e28048472$var$Md(this.g, b);
    } else this.v ? (b = {}, b.__data__ = $2e5ba96e28048472$var$rb(a), $2e5ba96e28048472$var$Md(this.g, b)) : $2e5ba96e28048472$var$Md(this.g, a);
};
$2e5ba96e28048472$var$Y.prototype.M = function() {
    this.g.j = null;
    delete this.j;
    $2e5ba96e28048472$var$Ic(this.g);
    delete this.g;
    $2e5ba96e28048472$var$Y.Z.M.call(this);
};
function $2e5ba96e28048472$var$Ud(a) {
    $2e5ba96e28048472$var$ac.call(this);
    var b = a.__sm__;
    if (b) {
        a: {
            for(const c in b){
                a = c;
                break a;
            }
            a = void 0;
        }
        if (this.i = a) a = this.i, b = null !== b && a in b ? b[a] : void 0;
        this.data = b;
    } else this.data = a;
}
$2e5ba96e28048472$var$t($2e5ba96e28048472$var$Ud, $2e5ba96e28048472$var$ac);
function $2e5ba96e28048472$var$Vd() {
    $2e5ba96e28048472$var$bc.call(this);
    this.status = 1;
}
$2e5ba96e28048472$var$t($2e5ba96e28048472$var$Vd, $2e5ba96e28048472$var$bc);
function $2e5ba96e28048472$var$Z(a) {
    this.g = a;
}
$2e5ba96e28048472$var$t($2e5ba96e28048472$var$Z, $2e5ba96e28048472$var$Sd);
$2e5ba96e28048472$var$Z.prototype.xa = function() {
    $2e5ba96e28048472$var$D(this.g, "a");
};
$2e5ba96e28048472$var$Z.prototype.wa = function(a) {
    $2e5ba96e28048472$var$D(this.g, new $2e5ba96e28048472$var$Ud(a));
};
$2e5ba96e28048472$var$Z.prototype.va = function(a) {
    $2e5ba96e28048472$var$D(this.g, new $2e5ba96e28048472$var$Vd(a));
};
$2e5ba96e28048472$var$Z.prototype.ua = function() {
    $2e5ba96e28048472$var$D(this.g, "b");
}; /*

 Copyright 2017 Google LLC

 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

   http://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
*/ 
$2e5ba96e28048472$var$Td.prototype.createWebChannel = $2e5ba96e28048472$var$Td.prototype.g;
$2e5ba96e28048472$var$Y.prototype.send = $2e5ba96e28048472$var$Y.prototype.u;
$2e5ba96e28048472$var$Y.prototype.open = $2e5ba96e28048472$var$Y.prototype.m;
$2e5ba96e28048472$var$Y.prototype.close = $2e5ba96e28048472$var$Y.prototype.close;
$2e5ba96e28048472$var$Wb.NO_ERROR = 0;
$2e5ba96e28048472$var$Wb.TIMEOUT = 8;
$2e5ba96e28048472$var$Wb.HTTP_ERROR = 6;
$2e5ba96e28048472$var$Xb.COMPLETE = "complete";
$2e5ba96e28048472$var$$b.EventType = $2e5ba96e28048472$var$L;
$2e5ba96e28048472$var$L.OPEN = "a";
$2e5ba96e28048472$var$L.CLOSE = "b";
$2e5ba96e28048472$var$L.ERROR = "c";
$2e5ba96e28048472$var$L.MESSAGE = "d";
$2e5ba96e28048472$var$C.prototype.listen = $2e5ba96e28048472$var$C.prototype.N;
$2e5ba96e28048472$var$X.prototype.listenOnce = $2e5ba96e28048472$var$X.prototype.O;
$2e5ba96e28048472$var$X.prototype.getLastError = $2e5ba96e28048472$var$X.prototype.La;
$2e5ba96e28048472$var$X.prototype.getLastErrorCode = $2e5ba96e28048472$var$X.prototype.Da;
$2e5ba96e28048472$var$X.prototype.getStatus = $2e5ba96e28048472$var$X.prototype.ba;
$2e5ba96e28048472$var$X.prototype.getResponseJson = $2e5ba96e28048472$var$X.prototype.Qa;
$2e5ba96e28048472$var$X.prototype.getResponseText = $2e5ba96e28048472$var$X.prototype.ga;
$2e5ba96e28048472$var$X.prototype.send = $2e5ba96e28048472$var$X.prototype.ea;
var $2e5ba96e28048472$export$66869136fc133c3a = $2e5ba96e28048472$export$2e2bcd8739ae039.createWebChannelTransport = function() {
    return new $2e5ba96e28048472$var$Td;
};
var $2e5ba96e28048472$export$888d0d9ab79d08fc = $2e5ba96e28048472$export$2e2bcd8739ae039.getStatEventTarget = function() {
    return $2e5ba96e28048472$var$Sb();
};
var $2e5ba96e28048472$export$d4e71bc0b80dc0fb = $2e5ba96e28048472$export$2e2bcd8739ae039.ErrorCode = $2e5ba96e28048472$var$Wb;
var $2e5ba96e28048472$export$3d7865934588d77e = $2e5ba96e28048472$export$2e2bcd8739ae039.EventType = $2e5ba96e28048472$var$Xb;
var $2e5ba96e28048472$export$d61e24a684f9e51 = $2e5ba96e28048472$export$2e2bcd8739ae039.Event = $2e5ba96e28048472$var$H;
var $2e5ba96e28048472$export$cbbc350c1dfc80cb = $2e5ba96e28048472$export$2e2bcd8739ae039.Stat = {
    rb: 0,
    ub: 1,
    vb: 2,
    Ob: 3,
    Tb: 4,
    Qb: 5,
    Rb: 6,
    Pb: 7,
    Nb: 8,
    Sb: 9,
    PROXY: 10,
    NOPROXY: 11,
    Lb: 12,
    Hb: 13,
    Ib: 14,
    Gb: 15,
    Jb: 16,
    Kb: 17,
    nb: 18,
    mb: 19,
    ob: 20
};
var $2e5ba96e28048472$export$ddb1030448106742 = $2e5ba96e28048472$export$2e2bcd8739ae039.FetchXmlHttpFactory = $2e5ba96e28048472$var$pd;
var $2e5ba96e28048472$export$aa726fb96ad3e039 = $2e5ba96e28048472$export$2e2bcd8739ae039.WebChannel = $2e5ba96e28048472$var$$b;
var $2e5ba96e28048472$export$26404658cda3ee02 = $2e5ba96e28048472$export$2e2bcd8739ae039.XhrIo = $2e5ba96e28048472$var$X;

});

parcelRegister("i9yYZ", function(module, exports) {
module.exports = {};

});



parcelRegister("3rass", function(module, exports) {

var $6EV7A = parcelRequire("6EV7A");
const $280c016de56a09b7$var$groupBy = function(xs, key) {
    return xs.reduce(function(rv, x) {
        (rv[x[key]] = rv[x[key]] || []).push(x);
        return rv;
    }, {});
};
const $280c016de56a09b7$var$toString = (...ids)=>ids.filter((id)=>(id || "").length > 0).join(":");
const $280c016de56a09b7$var$flattenObject = (obj, parentKey = "", result = {})=>{
    for(const key in obj)if (obj.hasOwnProperty(key)) {
        const newKey = parentKey ? `${parentKey}_${key}` : key;
        if (Array.isArray(obj[key])) obj[key].forEach((value, index)=>{
            if (typeof value === "object" && value !== null) $280c016de56a09b7$var$flattenObject(value, `${newKey}_${index + 1}`, result);
            else result[`${newKey}_${index + 1}`] = value;
        });
        else if (typeof obj[key] === "object" && obj[key] !== null) $280c016de56a09b7$var$flattenObject(obj[key], newKey, result);
        else result[newKey] = obj[key];
    }
    return result;
};
const $280c016de56a09b7$var$slugifyName = (name = "")=>{
    return $6EV7A(name, {
        lower: true,
        remove: /[*+~.,()'"!:@]/g
    }).replace("flexday-suite-", "flexday-suites-");
};
const $280c016de56a09b7$var$getRequestDate = ()=>{
    const now = new Date();
    const options = {
        timeZone: "America/Toronto",
        year: "numeric",
        month: "2-digit",
        day: "2-digit"
    };
    const formatter = new Intl.DateTimeFormat("en-CA", options);
    return formatter.formatToParts(now).map((p)=>p.value).join("").replaceAll("-", "/");
};
const $280c016de56a09b7$var$sleep = (ms)=>new Promise((resolve)=>setTimeout(resolve, ms));
module.exports = {
    flattenObject: $280c016de56a09b7$var$flattenObject,
    getRequestDate: $280c016de56a09b7$var$getRequestDate,
    groupBy: $280c016de56a09b7$var$groupBy,
    sleep: $280c016de56a09b7$var$sleep,
    slugifyName: $280c016de56a09b7$var$slugifyName,
    toString: $280c016de56a09b7$var$toString
};

});
parcelRegister("6EV7A", function(module, exports) {
(function(name, root, factory) {
    module.exports = factory();
    module.exports["default"] = factory();
})("slugify", module.exports, function() {
    var charMap = JSON.parse('{"$":"dollar","%":"percent","&":"and","<":"less",">":"greater","|":"or","\xa2":"cent","\xa3":"pound","\xa4":"currency","\xa5":"yen","\xa9":"(c)","\xaa":"a","\xae":"(r)","\xba":"o","\xc0":"A","\xc1":"A","\xc2":"A","\xc3":"A","\xc4":"A","\xc5":"A","\xc6":"AE","\xc7":"C","\xc8":"E","\xc9":"E","\xca":"E","\xcb":"E","\xcc":"I","\xcd":"I","\xce":"I","\xcf":"I","\xd0":"D","\xd1":"N","\xd2":"O","\xd3":"O","\xd4":"O","\xd5":"O","\xd6":"O","\xd8":"O","\xd9":"U","\xda":"U","\xdb":"U","\xdc":"U","\xdd":"Y","\xde":"TH","\xdf":"ss","\xe0":"a","\xe1":"a","\xe2":"a","\xe3":"a","\xe4":"a","\xe5":"a","\xe6":"ae","\xe7":"c","\xe8":"e","\xe9":"e","\xea":"e","\xeb":"e","\xec":"i","\xed":"i","\xee":"i","\xef":"i","\xf0":"d","\xf1":"n","\xf2":"o","\xf3":"o","\xf4":"o","\xf5":"o","\xf6":"o","\xf8":"o","\xf9":"u","\xfa":"u","\xfb":"u","\xfc":"u","\xfd":"y","\xfe":"th","\xff":"y","\u0100":"A","\u0101":"a","\u0102":"A","\u0103":"a","\u0104":"A","\u0105":"a","\u0106":"C","\u0107":"c","\u010C":"C","\u010D":"c","\u010E":"D","\u010F":"d","\u0110":"DJ","\u0111":"dj","\u0112":"E","\u0113":"e","\u0116":"E","\u0117":"e","\u0118":"e","\u0119":"e","\u011A":"E","\u011B":"e","\u011E":"G","\u011F":"g","\u0122":"G","\u0123":"g","\u0128":"I","\u0129":"i","\u012A":"i","\u012B":"i","\u012E":"I","\u012F":"i","\u0130":"I","\u0131":"i","\u0136":"k","\u0137":"k","\u013B":"L","\u013C":"l","\u013D":"L","\u013E":"l","\u0141":"L","\u0142":"l","\u0143":"N","\u0144":"n","\u0145":"N","\u0146":"n","\u0147":"N","\u0148":"n","\u014C":"O","\u014D":"o","\u0150":"O","\u0151":"o","\u0152":"OE","\u0153":"oe","\u0154":"R","\u0155":"r","\u0158":"R","\u0159":"r","\u015A":"S","\u015B":"s","\u015E":"S","\u015F":"s","\u0160":"S","\u0161":"s","\u0162":"T","\u0163":"t","\u0164":"T","\u0165":"t","\u0168":"U","\u0169":"u","\u016A":"u","\u016B":"u","\u016E":"U","\u016F":"u","\u0170":"U","\u0171":"u","\u0172":"U","\u0173":"u","\u0174":"W","\u0175":"w","\u0176":"Y","\u0177":"y","\u0178":"Y","\u0179":"Z","\u017A":"z","\u017B":"Z","\u017C":"z","\u017D":"Z","\u017E":"z","\u018F":"E","\u0192":"f","\u01A0":"O","\u01A1":"o","\u01AF":"U","\u01B0":"u","\u01C8":"LJ","\u01C9":"lj","\u01CB":"NJ","\u01CC":"nj","\u0218":"S","\u0219":"s","\u021A":"T","\u021B":"t","\u0259":"e","\u02DA":"o","\u0386":"A","\u0388":"E","\u0389":"H","\u038A":"I","\u038C":"O","\u038E":"Y","\u038F":"W","\u0390":"i","\u0391":"A","\u0392":"B","\u0393":"G","\u0394":"D","\u0395":"E","\u0396":"Z","\u0397":"H","\u0398":"8","\u0399":"I","\u039A":"K","\u039B":"L","\u039C":"M","\u039D":"N","\u039E":"3","\u039F":"O","\u03A0":"P","\u03A1":"R","\u03A3":"S","\u03A4":"T","\u03A5":"Y","\u03A6":"F","\u03A7":"X","\u03A8":"PS","\u03A9":"W","\u03AA":"I","\u03AB":"Y","\u03AC":"a","\u03AD":"e","\u03AE":"h","\u03AF":"i","\u03B0":"y","\u03B1":"a","\u03B2":"b","\u03B3":"g","\u03B4":"d","\u03B5":"e","\u03B6":"z","\u03B7":"h","\u03B8":"8","\u03B9":"i","\u03BA":"k","\u03BB":"l","\u03BC":"m","\u03BD":"n","\u03BE":"3","\u03BF":"o","\u03C0":"p","\u03C1":"r","\u03C2":"s","\u03C3":"s","\u03C4":"t","\u03C5":"y","\u03C6":"f","\u03C7":"x","\u03C8":"ps","\u03C9":"w","\u03CA":"i","\u03CB":"y","\u03CC":"o","\u03CD":"y","\u03CE":"w","\u0401":"Yo","\u0402":"DJ","\u0404":"Ye","\u0406":"I","\u0407":"Yi","\u0408":"J","\u0409":"LJ","\u040A":"NJ","\u040B":"C","\u040F":"DZ","\u0410":"A","\u0411":"B","\u0412":"V","\u0413":"G","\u0414":"D","\u0415":"E","\u0416":"Zh","\u0417":"Z","\u0418":"I","\u0419":"J","\u041A":"K","\u041B":"L","\u041C":"M","\u041D":"N","\u041E":"O","\u041F":"P","\u0420":"R","\u0421":"S","\u0422":"T","\u0423":"U","\u0424":"F","\u0425":"H","\u0426":"C","\u0427":"Ch","\u0428":"Sh","\u0429":"Sh","\u042A":"U","\u042B":"Y","\u042C":"","\u042D":"E","\u042E":"Yu","\u042F":"Ya","\u0430":"a","\u0431":"b","\u0432":"v","\u0433":"g","\u0434":"d","\u0435":"e","\u0436":"zh","\u0437":"z","\u0438":"i","\u0439":"j","\u043A":"k","\u043B":"l","\u043C":"m","\u043D":"n","\u043E":"o","\u043F":"p","\u0440":"r","\u0441":"s","\u0442":"t","\u0443":"u","\u0444":"f","\u0445":"h","\u0446":"c","\u0447":"ch","\u0448":"sh","\u0449":"sh","\u044A":"u","\u044B":"y","\u044C":"","\u044D":"e","\u044E":"yu","\u044F":"ya","\u0451":"yo","\u0452":"dj","\u0454":"ye","\u0456":"i","\u0457":"yi","\u0458":"j","\u0459":"lj","\u045A":"nj","\u045B":"c","\u045D":"u","\u045F":"dz","\u0490":"G","\u0491":"g","\u0492":"GH","\u0493":"gh","\u049A":"KH","\u049B":"kh","\u04A2":"NG","\u04A3":"ng","\u04AE":"UE","\u04AF":"ue","\u04B0":"U","\u04B1":"u","\u04BA":"H","\u04BB":"h","\u04D8":"AE","\u04D9":"ae","\u04E8":"OE","\u04E9":"oe","\u0531":"A","\u0532":"B","\u0533":"G","\u0534":"D","\u0535":"E","\u0536":"Z","\u0537":"E\'","\u0538":"Y\'","\u0539":"T\'","\u053A":"JH","\u053B":"I","\u053C":"L","\u053D":"X","\u053E":"C\'","\u053F":"K","\u0540":"H","\u0541":"D\'","\u0542":"GH","\u0543":"TW","\u0544":"M","\u0545":"Y","\u0546":"N","\u0547":"SH","\u0549":"CH","\u054A":"P","\u054B":"J","\u054C":"R\'","\u054D":"S","\u054E":"V","\u054F":"T","\u0550":"R","\u0551":"C","\u0553":"P\'","\u0554":"Q\'","\u0555":"O\'\'","\u0556":"F","\u0587":"EV","\u0621":"a","\u0622":"aa","\u0623":"a","\u0624":"u","\u0625":"i","\u0626":"e","\u0627":"a","\u0628":"b","\u0629":"h","\u062A":"t","\u062B":"th","\u062C":"j","\u062D":"h","\u062E":"kh","\u062F":"d","\u0630":"th","\u0631":"r","\u0632":"z","\u0633":"s","\u0634":"sh","\u0635":"s","\u0636":"dh","\u0637":"t","\u0638":"z","\u0639":"a","\u063A":"gh","\u0641":"f","\u0642":"q","\u0643":"k","\u0644":"l","\u0645":"m","\u0646":"n","\u0647":"h","\u0648":"w","\u0649":"a","\u064A":"y","\u064B":"an","\u064C":"on","\u064D":"en","\u064E":"a","\u064F":"u","\u0650":"e","\u0652":"","\u0660":"0","\u0661":"1","\u0662":"2","\u0663":"3","\u0664":"4","\u0665":"5","\u0666":"6","\u0667":"7","\u0668":"8","\u0669":"9","\u067E":"p","\u0686":"ch","\u0698":"zh","\u06A9":"k","\u06AF":"g","\u06CC":"y","\u06F0":"0","\u06F1":"1","\u06F2":"2","\u06F3":"3","\u06F4":"4","\u06F5":"5","\u06F6":"6","\u06F7":"7","\u06F8":"8","\u06F9":"9","\u0E3F":"baht","\u10D0":"a","\u10D1":"b","\u10D2":"g","\u10D3":"d","\u10D4":"e","\u10D5":"v","\u10D6":"z","\u10D7":"t","\u10D8":"i","\u10D9":"k","\u10DA":"l","\u10DB":"m","\u10DC":"n","\u10DD":"o","\u10DE":"p","\u10DF":"zh","\u10E0":"r","\u10E1":"s","\u10E2":"t","\u10E3":"u","\u10E4":"f","\u10E5":"k","\u10E6":"gh","\u10E7":"q","\u10E8":"sh","\u10E9":"ch","\u10EA":"ts","\u10EB":"dz","\u10EC":"ts","\u10ED":"ch","\u10EE":"kh","\u10EF":"j","\u10F0":"h","\u1E62":"S","\u1E63":"s","\u1E80":"W","\u1E81":"w","\u1E82":"W","\u1E83":"w","\u1E84":"W","\u1E85":"w","\u1E9E":"SS","\u1EA0":"A","\u1EA1":"a","\u1EA2":"A","\u1EA3":"a","\u1EA4":"A","\u1EA5":"a","\u1EA6":"A","\u1EA7":"a","\u1EA8":"A","\u1EA9":"a","\u1EAA":"A","\u1EAB":"a","\u1EAC":"A","\u1EAD":"a","\u1EAE":"A","\u1EAF":"a","\u1EB0":"A","\u1EB1":"a","\u1EB2":"A","\u1EB3":"a","\u1EB4":"A","\u1EB5":"a","\u1EB6":"A","\u1EB7":"a","\u1EB8":"E","\u1EB9":"e","\u1EBA":"E","\u1EBB":"e","\u1EBC":"E","\u1EBD":"e","\u1EBE":"E","\u1EBF":"e","\u1EC0":"E","\u1EC1":"e","\u1EC2":"E","\u1EC3":"e","\u1EC4":"E","\u1EC5":"e","\u1EC6":"E","\u1EC7":"e","\u1EC8":"I","\u1EC9":"i","\u1ECA":"I","\u1ECB":"i","\u1ECC":"O","\u1ECD":"o","\u1ECE":"O","\u1ECF":"o","\u1ED0":"O","\u1ED1":"o","\u1ED2":"O","\u1ED3":"o","\u1ED4":"O","\u1ED5":"o","\u1ED6":"O","\u1ED7":"o","\u1ED8":"O","\u1ED9":"o","\u1EDA":"O","\u1EDB":"o","\u1EDC":"O","\u1EDD":"o","\u1EDE":"O","\u1EDF":"o","\u1EE0":"O","\u1EE1":"o","\u1EE2":"O","\u1EE3":"o","\u1EE4":"U","\u1EE5":"u","\u1EE6":"U","\u1EE7":"u","\u1EE8":"U","\u1EE9":"u","\u1EEA":"U","\u1EEB":"u","\u1EEC":"U","\u1EED":"u","\u1EEE":"U","\u1EEF":"u","\u1EF0":"U","\u1EF1":"u","\u1EF2":"Y","\u1EF3":"y","\u1EF4":"Y","\u1EF5":"y","\u1EF6":"Y","\u1EF7":"y","\u1EF8":"Y","\u1EF9":"y","\u2013":"-","\u2018":"\'","\u2019":"\'","\u201C":"\\"","\u201D":"\\"","\u201E":"\\"","\u2020":"+","\u2022":"*","\u2026":"...","\u20A0":"ecu","\u20A2":"cruzeiro","\u20A3":"french franc","\u20A4":"lira","\u20A5":"mill","\u20A6":"naira","\u20A7":"peseta","\u20A8":"rupee","\u20A9":"won","\u20AA":"new shequel","\u20AB":"dong","\u20AC":"euro","\u20AD":"kip","\u20AE":"tugrik","\u20AF":"drachma","\u20B0":"penny","\u20B1":"peso","\u20B2":"guarani","\u20B3":"austral","\u20B4":"hryvnia","\u20B5":"cedi","\u20B8":"kazakhstani tenge","\u20B9":"indian rupee","\u20BA":"turkish lira","\u20BD":"russian ruble","\u20BF":"bitcoin","\u2120":"sm","\u2122":"tm","\u2202":"d","\u2206":"delta","\u2211":"sum","\u221E":"infinity","\u2665":"love","\u5143":"yuan","\u5186":"yen","\uFDFC":"rial","\uFEF5":"laa","\uFEF7":"laa","\uFEF9":"lai","\uFEFB":"la"}');
    var locales = JSON.parse('{"bg":{"\u0419":"Y","\u0426":"Ts","\u0429":"Sht","\u042A":"A","\u042C":"Y","\u0439":"y","\u0446":"ts","\u0449":"sht","\u044A":"a","\u044C":"y"},"de":{"\xc4":"AE","\xe4":"ae","\xd6":"OE","\xf6":"oe","\xdc":"UE","\xfc":"ue","\xdf":"ss","%":"prozent","&":"und","|":"oder","\u2211":"summe","\u221E":"unendlich","\u2665":"liebe"},"es":{"%":"por ciento","&":"y","<":"menor que",">":"mayor que","|":"o","\xa2":"centavos","\xa3":"libras","\xa4":"moneda","\u20A3":"francos","\u2211":"suma","\u221E":"infinito","\u2665":"amor"},"fr":{"%":"pourcent","&":"et","<":"plus petit",">":"plus grand","|":"ou","\xa2":"centime","\xa3":"livre","\xa4":"devise","\u20A3":"franc","\u2211":"somme","\u221E":"infini","\u2665":"amour"},"pt":{"%":"porcento","&":"e","<":"menor",">":"maior","|":"ou","\xa2":"centavo","\u2211":"soma","\xa3":"libra","\u221E":"infinito","\u2665":"amor"},"uk":{"\u0418":"Y","\u0438":"y","\u0419":"Y","\u0439":"y","\u0426":"Ts","\u0446":"ts","\u0425":"Kh","\u0445":"kh","\u0429":"Shch","\u0449":"shch","\u0413":"H","\u0433":"h"},"vi":{"\u0110":"D","\u0111":"d"},"da":{"\xd8":"OE","\xf8":"oe","\xc5":"AA","\xe5":"aa","%":"procent","&":"og","|":"eller","$":"dollar","<":"mindre end",">":"st\xf8rre end"},"nb":{"&":"og","\xc5":"AA","\xc6":"AE","\xd8":"OE","\xe5":"aa","\xe6":"ae","\xf8":"oe"},"it":{"&":"e"},"nl":{"&":"en"},"sv":{"&":"och","\xc5":"AA","\xc4":"AE","\xd6":"OE","\xe5":"aa","\xe4":"ae","\xf6":"oe"}}');
    function replace(string, options) {
        if (typeof string !== "string") throw new Error("slugify: string argument expected");
        options = typeof options === "string" ? {
            replacement: options
        } : options || {};
        var locale = locales[options.locale] || {};
        var replacement = options.replacement === undefined ? "-" : options.replacement;
        var trim = options.trim === undefined ? true : options.trim;
        var slug = string.normalize().split("")// replace characters based on charMap
        .reduce(function(result, ch) {
            var appendChar = locale[ch];
            if (appendChar === undefined) appendChar = charMap[ch];
            if (appendChar === undefined) appendChar = ch;
            if (appendChar === replacement) appendChar = " ";
            return result + appendChar// remove not allowed characters
            .replace(options.remove || /[^\w\s$*_+~.()'"!\-:@]+/g, "");
        }, "");
        if (options.strict) slug = slug.replace(/[^A-Za-z0-9\s]/g, "");
        if (trim) slug = slug.trim();
        // Replace spaces with replacement character, treating multiple consecutive
        // spaces as a single space.
        slug = slug.replace(/\s+/g, replacement);
        if (options.lower) slug = slug.toLowerCase();
        return slug;
    }
    replace.extend = function(customMap) {
        Object.assign(charMap, customMap);
    };
    return replace;
});

});


parcelRegister("awSij", function(module, exports) {

module.exports = {
    Utils: (parcelRequire("i0Fr1"))
};

});
parcelRegister("i0Fr1", function(module, exports) {
const $d1c85e29d330980c$var$getAccountType = (email)=>{
    return new RegExp(`@(rogers|telus|bell|gmail|yahoo|outlook|me|icloud|sympatico|hotmail|ymail|ryerson|utoronto|queensu)`, "i").test(email) ? "Personal" : "Work";
};
module.exports = {
    getAccountType: $d1c85e29d330980c$var$getAccountType
};

});


parcelRegister("gEP1k", function(module, exports) {



module.exports = {
    AppTransformer: (parcelRequire("8bb9O")),
    IntercomTransformer: (parcelRequire("aXWPy")),
    StripeTransformer: (parcelRequire("iyilw"))
};

});
parcelRegister("8bb9O", function(module, exports) {

var $9sLUZ = parcelRequire("9sLUZ");
var $5f48016f8a964b25$require$parse = $9sLUZ.default;
module.exports = class AppTransformer {
    transform() {
        return {
            classification: "User",
            email: this.appUser.email,
            identifier: this.appUser.email,
            name: this.appUser.name,
            createdAt: $5f48016f8a964b25$require$parse(this.appUser.joinDate, "yyyy/MM/dd", new Date())
        };
    }
    constructor(appUser){
        this.appUser = appUser;
    }
};

});
parcelRegister("9sLUZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6e3be626bdd19e29$export$2e2bcd8739ae039; });

var $64KdH = parcelRequire("64KdH");

var $7BPI5 = parcelRequire("7BPI5");

var $5RKOy = parcelRequire("5RKOy");

var $9aLpV = parcelRequire("9aLpV");

var $j2DA4 = parcelRequire("j2DA4");

var $edQEp = parcelRequire("edQEp");

var $l4BdG = parcelRequire("l4BdG");

var $8Tuqe = parcelRequire("8Tuqe");

var $kJsk3 = parcelRequire("kJsk3");

var $hkULo = parcelRequire("hkULo");

var $1BahA = parcelRequire("1BahA");

var $9pLZJ = parcelRequire("9pLZJ");

var $b9f0v = parcelRequire("b9f0v");

var $2Kxhf = parcelRequire("2Kxhf");
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var $6e3be626bdd19e29$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var $6e3be626bdd19e29$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var $6e3be626bdd19e29$var$escapedStringRegExp = /^'([^]*?)'?$/;
var $6e3be626bdd19e29$var$doubleQuoteRegExp = /''/g;
var $6e3be626bdd19e29$var$notWhitespaceRegExp = /\S/;
var $6e3be626bdd19e29$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $6e3be626bdd19e29$export$2e2bcd8739ae039(dirtyDateString, dirtyFormatString, dirtyReferenceDate, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
    (0, $1BahA.default)(3, arguments);
    var dateString = String(dirtyDateString);
    var formatString = String(dirtyFormatString);
    var defaultOptions = (0, $2Kxhf.getDefaultOptions)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $5RKOy.default);
    if (!locale.match) throw new RangeError("locale must contain match property");
    var firstWeekContainsDate = (0, $hkULo.default)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var weekStartsOn = (0, $hkULo.default)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    if (formatString === "") {
        if (dateString === "") return (0, $j2DA4.default)(dirtyReferenceDate);
        else return new Date(NaN);
    }
    var subFnOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale
    };
    // If timezone isn't specified, it will be set to the system timezone
    var setters = [
        new (0, $9pLZJ.DateToSystemTimezoneSetter)()
    ];
    var tokens = formatString.match($6e3be626bdd19e29$var$longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter in (0, $l4BdG.default)) {
            var longFormatter = (0, $l4BdG.default)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match($6e3be626bdd19e29$var$formattingTokensRegExp);
    var usedTokens = [];
    var _iterator = (0, $7BPI5.default)(tokens), _step;
    try {
        var _loop = function _loop() {
            var token = _step.value;
            if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, $kJsk3.isProtectedWeekYearToken)(token)) (0, $kJsk3.throwProtectedError)(token, formatString, dirtyDateString);
            if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, $kJsk3.isProtectedDayOfYearToken)(token)) (0, $kJsk3.throwProtectedError)(token, formatString, dirtyDateString);
            var firstCharacter = token[0];
            var parser = (0, $b9f0v.parsers)[firstCharacter];
            if (parser) {
                var incompatibleTokens = parser.incompatibleTokens;
                if (Array.isArray(incompatibleTokens)) {
                    var incompatibleToken = usedTokens.find(function(usedToken) {
                        return incompatibleTokens.includes(usedToken.token) || usedToken.token === firstCharacter;
                    });
                    if (incompatibleToken) throw new RangeError("The format string mustn't contain `".concat(incompatibleToken.fullToken, "` and `").concat(token, "` at the same time"));
                } else if (parser.incompatibleTokens === "*" && usedTokens.length > 0) throw new RangeError("The format string mustn't contain `".concat(token, "` and any other token at the same time"));
                usedTokens.push({
                    token: firstCharacter,
                    fullToken: token
                });
                var parseResult = parser.run(dateString, token, locale.match, subFnOptions);
                if (!parseResult) return {
                    v: new Date(NaN)
                };
                setters.push(parseResult.setter);
                dateString = parseResult.rest;
            } else {
                if (firstCharacter.match($6e3be626bdd19e29$var$unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
                // Replace two single quote characters with one single quote character
                if (token === "''") token = "'";
                else if (firstCharacter === "'") token = $6e3be626bdd19e29$var$cleanEscapedString(token);
                // Cut token from string, or, if string doesn't match the token, return Invalid Date
                if (dateString.indexOf(token) === 0) dateString = dateString.slice(token.length);
                else return {
                    v: new Date(NaN)
                };
            }
        };
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var _ret = _loop();
            if ((0, $64KdH.default)(_ret) === "object") return _ret.v;
        }
    // Check if the remaining input contains something other than whitespace
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    if (dateString.length > 0 && $6e3be626bdd19e29$var$notWhitespaceRegExp.test(dateString)) return new Date(NaN);
    var uniquePrioritySetters = setters.map(function(setter) {
        return setter.priority;
    }).sort(function(a, b) {
        return b - a;
    }).filter(function(priority, index, array) {
        return array.indexOf(priority) === index;
    }).map(function(priority) {
        return setters.filter(function(setter) {
            return setter.priority === priority;
        }).sort(function(a, b) {
            return b.subPriority - a.subPriority;
        });
    }).map(function(setterArray) {
        return setterArray[0];
    });
    var date = (0, $j2DA4.default)(dirtyReferenceDate);
    if (isNaN(date.getTime())) return new Date(NaN);
    // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    var utcDate = (0, $9aLpV.default)(date, (0, $8Tuqe.default)(date));
    var flags = {};
    var _iterator2 = (0, $7BPI5.default)(uniquePrioritySetters), _step2;
    try {
        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
            var setter = _step2.value;
            if (!setter.validate(utcDate, subFnOptions)) return new Date(NaN);
            var result = setter.set(utcDate, flags, subFnOptions);
            // Result is tuple (date, flags)
            if (Array.isArray(result)) {
                utcDate = result[0];
                (0, $edQEp.default)(flags, result[1]);
            // Result is date
            } else utcDate = result;
        }
    } catch (err) {
        _iterator2.e(err);
    } finally{
        _iterator2.f();
    }
    return utcDate;
}
function $6e3be626bdd19e29$var$cleanEscapedString(input) {
    return input.match($6e3be626bdd19e29$var$escapedStringRegExp)[1].replace($6e3be626bdd19e29$var$doubleQuoteRegExp, "'");
}

});
parcelRegister("64KdH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $46c6f8186eb4d830$export$2e2bcd8739ae039; });
function $46c6f8186eb4d830$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $46c6f8186eb4d830$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $46c6f8186eb4d830$export$2e2bcd8739ae039(o);
}

});

parcelRegister("7BPI5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $58a419a475192f49$export$2e2bcd8739ae039; });

var $kLUwp = parcelRequire("kLUwp");
function $58a419a475192f49$export$2e2bcd8739ae039(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
        if (Array.isArray(o) || (it = (0, $kLUwp.default)(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it["return"] != null) it["return"]();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}

});
parcelRegister("kLUwp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f1f40a791c582ed3$export$2e2bcd8739ae039; });

var $hcXXE = parcelRequire("hcXXE");
function $f1f40a791c582ed3$export$2e2bcd8739ae039(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $hcXXE.default)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $hcXXE.default)(o, minLen);
}

});
parcelRegister("hcXXE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c87211af673aaaac$export$2e2bcd8739ae039; });
function $c87211af673aaaac$export$2e2bcd8739ae039(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});



parcelRegister("5RKOy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4456375fcd9c8e3e$export$2e2bcd8739ae039; });

var $b0hzc = parcelRequire("b0hzc");
var $4456375fcd9c8e3e$export$2e2bcd8739ae039 = (0, $b0hzc.default);

});
parcelRegister("b0hzc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $802d5229ca665cbe$export$2e2bcd8739ae039; });

var $bxUYA = parcelRequire("bxUYA");

var $jM01c = parcelRequire("jM01c");

var $ihlCY = parcelRequire("ihlCY");

var $4JQy4 = parcelRequire("4JQy4");

var $4gzjd = parcelRequire("4gzjd");
/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */ var $802d5229ca665cbe$var$locale = {
    code: "en-US",
    formatDistance: (0, $bxUYA.default),
    formatLong: (0, $jM01c.default),
    formatRelative: (0, $ihlCY.default),
    localize: (0, $4JQy4.default),
    match: (0, $4gzjd.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $802d5229ca665cbe$export$2e2bcd8739ae039 = $802d5229ca665cbe$var$locale;

});
parcelRegister("bxUYA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $867ef909e18040bb$export$2e2bcd8739ae039; });
var $867ef909e18040bb$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "less than a second",
        other: "less than {{count}} seconds"
    },
    xSeconds: {
        one: "1 second",
        other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
        one: "less than a minute",
        other: "less than {{count}} minutes"
    },
    xMinutes: {
        one: "1 minute",
        other: "{{count}} minutes"
    },
    aboutXHours: {
        one: "about 1 hour",
        other: "about {{count}} hours"
    },
    xHours: {
        one: "1 hour",
        other: "{{count}} hours"
    },
    xDays: {
        one: "1 day",
        other: "{{count}} days"
    },
    aboutXWeeks: {
        one: "about 1 week",
        other: "about {{count}} weeks"
    },
    xWeeks: {
        one: "1 week",
        other: "{{count}} weeks"
    },
    aboutXMonths: {
        one: "about 1 month",
        other: "about {{count}} months"
    },
    xMonths: {
        one: "1 month",
        other: "{{count}} months"
    },
    aboutXYears: {
        one: "about 1 year",
        other: "about {{count}} years"
    },
    xYears: {
        one: "1 year",
        other: "{{count}} years"
    },
    overXYears: {
        one: "over 1 year",
        other: "over {{count}} years"
    },
    almostXYears: {
        one: "almost 1 year",
        other: "almost {{count}} years"
    }
};
var $867ef909e18040bb$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $867ef909e18040bb$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "in " + result;
        else return result + " ago";
    }
    return result;
};
var $867ef909e18040bb$export$2e2bcd8739ae039 = $867ef909e18040bb$var$formatDistance;

});

parcelRegister("jM01c", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e65283a3750c8c3f$export$2e2bcd8739ae039; });

var $4PxBy = parcelRequire("4PxBy");
var $e65283a3750c8c3f$var$dateFormats = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
};
var $e65283a3750c8c3f$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
var $e65283a3750c8c3f$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $e65283a3750c8c3f$var$formatLong = {
    date: (0, $4PxBy.default)({
        formats: $e65283a3750c8c3f$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $4PxBy.default)({
        formats: $e65283a3750c8c3f$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $4PxBy.default)({
        formats: $e65283a3750c8c3f$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $e65283a3750c8c3f$export$2e2bcd8739ae039 = $e65283a3750c8c3f$var$formatLong;

});
parcelRegister("4PxBy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3845fe05dc4dc1ea$export$2e2bcd8739ae039; });
function $3845fe05dc4dc1ea$export$2e2bcd8739ae039(args) {
    return function() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        // TODO: Remove String()
        var width = options.width ? String(options.width) : args.defaultWidth;
        var format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}

});


parcelRegister("ihlCY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d4ea9753ee2f1df2$export$2e2bcd8739ae039; });
var $d4ea9753ee2f1df2$var$formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: "P"
};
var $d4ea9753ee2f1df2$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $d4ea9753ee2f1df2$var$formatRelativeLocale[token];
};
var $d4ea9753ee2f1df2$export$2e2bcd8739ae039 = $d4ea9753ee2f1df2$var$formatRelative;

});

parcelRegister("4JQy4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $37342072f67044a8$export$2e2bcd8739ae039; });

var $d1zoH = parcelRequire("d1zoH");
var $37342072f67044a8$var$eraValues = {
    narrow: [
        "B",
        "A"
    ],
    abbreviated: [
        "BC",
        "AD"
    ],
    wide: [
        "Before Christ",
        "Anno Domini"
    ]
};
var $37342072f67044a8$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1st quarter",
        "2nd quarter",
        "3rd quarter",
        "4th quarter"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $37342072f67044a8$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ],
    wide: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ]
};
var $37342072f67044a8$var$dayValues = {
    narrow: [
        "S",
        "M",
        "T",
        "W",
        "T",
        "F",
        "S"
    ],
    short: [
        "Su",
        "Mo",
        "Tu",
        "We",
        "Th",
        "Fr",
        "Sa"
    ],
    abbreviated: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    wide: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ]
};
var $37342072f67044a8$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    }
};
var $37342072f67044a8$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    }
};
var $37342072f67044a8$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + "st";
        case 2:
            return number + "nd";
        case 3:
            return number + "rd";
    }
    return number + "th";
};
var $37342072f67044a8$var$localize = {
    ordinalNumber: $37342072f67044a8$var$ordinalNumber,
    era: (0, $d1zoH.default)({
        values: $37342072f67044a8$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $d1zoH.default)({
        values: $37342072f67044a8$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $d1zoH.default)({
        values: $37342072f67044a8$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $d1zoH.default)({
        values: $37342072f67044a8$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $d1zoH.default)({
        values: $37342072f67044a8$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $37342072f67044a8$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $37342072f67044a8$export$2e2bcd8739ae039 = $37342072f67044a8$var$localize;

});
parcelRegister("d1zoH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $97b6d38d9e343d9f$export$2e2bcd8739ae039; });
function $97b6d38d9e343d9f$export$2e2bcd8739ae039(args) {
    return function(dirtyIndex, options) {
        var context = options !== null && options !== void 0 && options.context ? String(options.context) : "standalone";
        var valuesArray;
        if (context === "formatting" && args.formattingValues) {
            var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            var _defaultWidth = args.defaultWidth;
            var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[_width] || args.values[_defaultWidth];
        }
        var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
        // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}

});


parcelRegister("4gzjd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $31b40baf3c3cb861$export$2e2bcd8739ae039; });

var $9JF37 = parcelRequire("9JF37");

var $dSlWo = parcelRequire("dSlWo");
var $31b40baf3c3cb861$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $31b40baf3c3cb861$var$parseOrdinalNumberPattern = /\d+/i;
var $31b40baf3c3cb861$var$matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
var $31b40baf3c3cb861$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var $31b40baf3c3cb861$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
var $31b40baf3c3cb861$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $31b40baf3c3cb861$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var $31b40baf3c3cb861$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $31b40baf3c3cb861$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var $31b40baf3c3cb861$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var $31b40baf3c3cb861$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var $31b40baf3c3cb861$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var $31b40baf3c3cb861$var$match = {
    ordinalNumber: (0, $dSlWo.default)({
        matchPattern: $31b40baf3c3cb861$var$matchOrdinalNumberPattern,
        parsePattern: $31b40baf3c3cb861$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $9JF37.default)({
        matchPatterns: $31b40baf3c3cb861$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $31b40baf3c3cb861$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $9JF37.default)({
        matchPatterns: $31b40baf3c3cb861$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $31b40baf3c3cb861$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $9JF37.default)({
        matchPatterns: $31b40baf3c3cb861$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $31b40baf3c3cb861$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $9JF37.default)({
        matchPatterns: $31b40baf3c3cb861$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $31b40baf3c3cb861$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $9JF37.default)({
        matchPatterns: $31b40baf3c3cb861$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $31b40baf3c3cb861$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $31b40baf3c3cb861$export$2e2bcd8739ae039 = $31b40baf3c3cb861$var$match;

});
parcelRegister("9JF37", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7168288ebe9ccc78$export$2e2bcd8739ae039; });
function $7168288ebe9ccc78$export$2e2bcd8739ae039(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var width = options.width;
        var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        var matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        var key = Array.isArray(parsePatterns) ? $7168288ebe9ccc78$var$findIndex(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        }) : $7168288ebe9ccc78$var$findKey(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        });
        var value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function $7168288ebe9ccc78$var$findKey(object, predicate) {
    for(var key in object){
        if (object.hasOwnProperty(key) && predicate(object[key])) return key;
    }
    return undefined;
}
function $7168288ebe9ccc78$var$findIndex(array, predicate) {
    for(var key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}

});

parcelRegister("dSlWo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a1a1567f90ed2359$export$2e2bcd8739ae039; });
function $a1a1567f90ed2359$export$2e2bcd8739ae039(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}

});




parcelRegister("9aLpV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6ad9d443bec533dd$export$2e2bcd8739ae039; });

var $gbZP7 = parcelRequire("gbZP7");

var $1BahA = parcelRequire("1BahA");

var $hkULo = parcelRequire("hkULo");
function $6ad9d443bec533dd$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $1BahA.default)(2, arguments);
    var amount = (0, $hkULo.default)(dirtyAmount);
    return (0, $gbZP7.default)(dirtyDate, -amount);
}

});
parcelRegister("gbZP7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bc9da146ac8e47e0$export$2e2bcd8739ae039; });

var $hkULo = parcelRequire("hkULo");

var $j2DA4 = parcelRequire("j2DA4");

var $1BahA = parcelRequire("1BahA");
function $bc9da146ac8e47e0$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $1BahA.default)(2, arguments);
    var timestamp = (0, $j2DA4.default)(dirtyDate).getTime();
    var amount = (0, $hkULo.default)(dirtyAmount);
    return new Date(timestamp + amount);
}

});
parcelRegister("hkULo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c9f055f325de4035$export$2e2bcd8739ae039; });
function $c9f055f325de4035$export$2e2bcd8739ae039(dirtyNumber) {
    if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) return NaN;
    var number = Number(dirtyNumber);
    if (isNaN(number)) return number;
    return number < 0 ? Math.ceil(number) : Math.floor(number);
}

});

parcelRegister("j2DA4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0393d23218dbdb6e$export$2e2bcd8739ae039; });

var $64KdH = parcelRequire("64KdH");

var $1BahA = parcelRequire("1BahA");
function $0393d23218dbdb6e$export$2e2bcd8739ae039(argument) {
    (0, $1BahA.default)(1, arguments);
    var argStr = Object.prototype.toString.call(argument);
    // Clone the date
    if (argument instanceof Date || (0, $64KdH.default)(argument) === "object" && argStr === "[object Date]") // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === "number" || argStr === "[object Number]") return new Date(argument);
    else {
        if ((typeof argument === "string" || argStr === "[object String]") && typeof console !== "undefined") {
            // eslint-disable-next-line no-console
            console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
            // eslint-disable-next-line no-console
            console.warn(new Error().stack);
        }
        return new Date(NaN);
    }
}

});
parcelRegister("1BahA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $12a139176457e1f3$export$2e2bcd8739ae039; });
function $12a139176457e1f3$export$2e2bcd8739ae039(required, args) {
    if (args.length < required) throw new TypeError(required + " argument" + (required > 1 ? "s" : "") + " required, but only " + args.length + " present");
}

});




parcelRegister("edQEp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a5ab1ee874aae6d0$export$2e2bcd8739ae039; });
function $a5ab1ee874aae6d0$export$2e2bcd8739ae039(target, object) {
    if (target == null) throw new TypeError("assign requires that input parameter not be null or undefined");
    for(var property in object)if (Object.prototype.hasOwnProperty.call(object, property)) target[property] = object[property];
    return target;
}

});

parcelRegister("l4BdG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f576d7c4036717ae$export$2e2bcd8739ae039; });
var $f576d7c4036717ae$var$dateLongFormatter = function dateLongFormatter(pattern, formatLong) {
    switch(pattern){
        case "P":
            return formatLong.date({
                width: "short"
            });
        case "PP":
            return formatLong.date({
                width: "medium"
            });
        case "PPP":
            return formatLong.date({
                width: "long"
            });
        case "PPPP":
        default:
            return formatLong.date({
                width: "full"
            });
    }
};
var $f576d7c4036717ae$var$timeLongFormatter = function timeLongFormatter(pattern, formatLong) {
    switch(pattern){
        case "p":
            return formatLong.time({
                width: "short"
            });
        case "pp":
            return formatLong.time({
                width: "medium"
            });
        case "ppp":
            return formatLong.time({
                width: "long"
            });
        case "pppp":
        default:
            return formatLong.time({
                width: "full"
            });
    }
};
var $f576d7c4036717ae$var$dateTimeLongFormatter = function dateTimeLongFormatter(pattern, formatLong) {
    var matchResult = pattern.match(/(P+)(p+)?/) || [];
    var datePattern = matchResult[1];
    var timePattern = matchResult[2];
    if (!timePattern) return $f576d7c4036717ae$var$dateLongFormatter(pattern, formatLong);
    var dateTimeFormat;
    switch(datePattern){
        case "P":
            dateTimeFormat = formatLong.dateTime({
                width: "short"
            });
            break;
        case "PP":
            dateTimeFormat = formatLong.dateTime({
                width: "medium"
            });
            break;
        case "PPP":
            dateTimeFormat = formatLong.dateTime({
                width: "long"
            });
            break;
        case "PPPP":
        default:
            dateTimeFormat = formatLong.dateTime({
                width: "full"
            });
            break;
    }
    return dateTimeFormat.replace("{{date}}", $f576d7c4036717ae$var$dateLongFormatter(datePattern, formatLong)).replace("{{time}}", $f576d7c4036717ae$var$timeLongFormatter(timePattern, formatLong));
};
var $f576d7c4036717ae$var$longFormatters = {
    p: $f576d7c4036717ae$var$timeLongFormatter,
    P: $f576d7c4036717ae$var$dateTimeLongFormatter
};
var $f576d7c4036717ae$export$2e2bcd8739ae039 = $f576d7c4036717ae$var$longFormatters;

});

parcelRegister("8Tuqe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $679b0efcfb0e273b$export$2e2bcd8739ae039; });
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ function $679b0efcfb0e273b$export$2e2bcd8739ae039(date) {
    var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    utcDate.setUTCFullYear(date.getFullYear());
    return date.getTime() - utcDate.getTime();
}

});

parcelRegister("kJsk3", function(module, exports) {

$parcel$export(module.exports, "isProtectedDayOfYearToken", function () { return $f17dfae3d811a08a$export$c6cc36aa33304772; });
$parcel$export(module.exports, "isProtectedWeekYearToken", function () { return $f17dfae3d811a08a$export$c6b49d6dceb604a1; });
$parcel$export(module.exports, "throwProtectedError", function () { return $f17dfae3d811a08a$export$8073c1ae88f0e727; });
var $f17dfae3d811a08a$var$protectedDayOfYearTokens = [
    "D",
    "DD"
];
var $f17dfae3d811a08a$var$protectedWeekYearTokens = [
    "YY",
    "YYYY"
];
function $f17dfae3d811a08a$export$c6cc36aa33304772(token) {
    return $f17dfae3d811a08a$var$protectedDayOfYearTokens.indexOf(token) !== -1;
}
function $f17dfae3d811a08a$export$c6b49d6dceb604a1(token) {
    return $f17dfae3d811a08a$var$protectedWeekYearTokens.indexOf(token) !== -1;
}
function $f17dfae3d811a08a$export$8073c1ae88f0e727(token, format, input) {
    if (token === "YYYY") throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === "YY") throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === "D") throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === "DD") throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}

});

parcelRegister("9pLZJ", function(module, exports) {

$parcel$export(module.exports, "ValueSetter", function () { return $6dabad93285ed271$export$9a09e32dd4990fd5; });
$parcel$export(module.exports, "DateToSystemTimezoneSetter", function () { return $6dabad93285ed271$export$5aaf7ff7f09ea4ee; });

var $k7KFa = parcelRequire("k7KFa");

var $11RWQ = parcelRequire("11RWQ");

var $f2A3W = parcelRequire("f2A3W");

var $7bxB9 = parcelRequire("7bxB9");

var $6d01N = parcelRequire("6d01N");

var $dPXH7 = parcelRequire("dPXH7");
var $6dabad93285ed271$var$TIMEZONE_UNIT_PRIORITY = 10;
var $6dabad93285ed271$export$81d53e3678089a6 = /*#__PURE__*/ function() {
    function Setter() {
        (0, $7bxB9.default)(this, Setter);
        (0, $dPXH7.default)(this, "priority", void 0);
        (0, $dPXH7.default)(this, "subPriority", 0);
    }
    (0, $6d01N.default)(Setter, [
        {
            key: "validate",
            value: function validate(_utcDate, _options) {
                return true;
            }
        }
    ]);
    return Setter;
}();
var $6dabad93285ed271$export$9a09e32dd4990fd5 = /*#__PURE__*/ function(_Setter) {
    (0, $11RWQ.default)(ValueSetter, _Setter);
    var _super = (0, $f2A3W.default)(ValueSetter);
    function ValueSetter(value, validateValue, setValue, priority, subPriority) {
        var _this;
        (0, $7bxB9.default)(this, ValueSetter);
        _this = _super.call(this);
        _this.value = value;
        _this.validateValue = validateValue;
        _this.setValue = setValue;
        _this.priority = priority;
        if (subPriority) _this.subPriority = subPriority;
        return _this;
    }
    (0, $6d01N.default)(ValueSetter, [
        {
            key: "validate",
            value: function validate(utcDate, options) {
                return this.validateValue(utcDate, this.value, options);
            }
        },
        {
            key: "set",
            value: function set(utcDate, flags, options) {
                return this.setValue(utcDate, flags, this.value, options);
            }
        }
    ]);
    return ValueSetter;
}($6dabad93285ed271$export$81d53e3678089a6);
var $6dabad93285ed271$export$5aaf7ff7f09ea4ee = /*#__PURE__*/ function(_Setter2) {
    (0, $11RWQ.default)(DateToSystemTimezoneSetter, _Setter2);
    var _super2 = (0, $f2A3W.default)(DateToSystemTimezoneSetter);
    function DateToSystemTimezoneSetter() {
        var _this2;
        (0, $7bxB9.default)(this, DateToSystemTimezoneSetter);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this2 = _super2.call.apply(_super2, [
            this
        ].concat(args));
        (0, $dPXH7.default)((0, $k7KFa.default)(_this2), "priority", $6dabad93285ed271$var$TIMEZONE_UNIT_PRIORITY);
        (0, $dPXH7.default)((0, $k7KFa.default)(_this2), "subPriority", -1);
        return _this2;
    }
    (0, $6d01N.default)(DateToSystemTimezoneSetter, [
        {
            key: "set",
            value: function set(date, flags) {
                if (flags.timestampIsSet) return date;
                var convertedDate = new Date(0);
                convertedDate.setFullYear(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
                convertedDate.setHours(date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds());
                return convertedDate;
            }
        }
    ]);
    return DateToSystemTimezoneSetter;
}($6dabad93285ed271$export$81d53e3678089a6);

});
parcelRegister("k7KFa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ea68a86032ec400f$export$2e2bcd8739ae039; });
function $ea68a86032ec400f$export$2e2bcd8739ae039(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}

});

parcelRegister("11RWQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0bffbb65b8ccd5d0$export$2e2bcd8739ae039; });

var $2BeGd = parcelRequire("2BeGd");
function $0bffbb65b8ccd5d0$export$2e2bcd8739ae039(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) (0, $2BeGd.default)(subClass, superClass);
}

});
parcelRegister("2BeGd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1e4a6c9a021024c2$export$2e2bcd8739ae039; });
function $1e4a6c9a021024c2$export$2e2bcd8739ae039(o, p) {
    $1e4a6c9a021024c2$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $1e4a6c9a021024c2$export$2e2bcd8739ae039(o, p);
}

});


parcelRegister("f2A3W", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $af330431c3a5072c$export$2e2bcd8739ae039; });

var $e0c5k = parcelRequire("e0c5k");

var $aNEVz = parcelRequire("aNEVz");

var $doGFx = parcelRequire("doGFx");
function $af330431c3a5072c$export$2e2bcd8739ae039(Derived) {
    var hasNativeReflectConstruct = (0, $aNEVz.default)();
    return function _createSuperInternal() {
        var Super = (0, $e0c5k.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $e0c5k.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $doGFx.default)(this, result);
    };
}

});
parcelRegister("e0c5k", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a31a709cd3c98fc9$export$2e2bcd8739ae039; });
function $a31a709cd3c98fc9$export$2e2bcd8739ae039(o) {
    $a31a709cd3c98fc9$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $a31a709cd3c98fc9$export$2e2bcd8739ae039(o);
}

});

parcelRegister("aNEVz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7dce3a521c505e57$export$2e2bcd8739ae039; });
function $7dce3a521c505e57$export$2e2bcd8739ae039() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}

});

parcelRegister("doGFx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9c0e9d66a066ff14$export$2e2bcd8739ae039; });

var $64KdH = parcelRequire("64KdH");

var $k7KFa = parcelRequire("k7KFa");
function $9c0e9d66a066ff14$export$2e2bcd8739ae039(self, call) {
    if (call && ((0, $64KdH.default)(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $k7KFa.default)(self);
}

});


parcelRegister("7bxB9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $53b39f5f303a094d$export$2e2bcd8739ae039; });
function $53b39f5f303a094d$export$2e2bcd8739ae039(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("6d01N", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4853fa884369788e$export$2e2bcd8739ae039; });

var $hOX5O = parcelRequire("hOX5O");
function $4853fa884369788e$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, (0, $hOX5O.default)(descriptor.key), descriptor);
    }
}
function $4853fa884369788e$export$2e2bcd8739ae039(Constructor, protoProps, staticProps) {
    if (protoProps) $4853fa884369788e$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4853fa884369788e$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}

});
parcelRegister("hOX5O", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cf94f1c3da906d02$export$2e2bcd8739ae039; });

var $64KdH = parcelRequire("64KdH");

var $72fZN = parcelRequire("72fZN");
function $cf94f1c3da906d02$export$2e2bcd8739ae039(t) {
    var i = (0, $72fZN.default)(t, "string");
    return "symbol" == (0, $64KdH.default)(i) ? i : String(i);
}

});
parcelRegister("72fZN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $51f520bac31ab73c$export$2e2bcd8739ae039; });

var $64KdH = parcelRequire("64KdH");
function $51f520bac31ab73c$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $64KdH.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $64KdH.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("dPXH7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a12e57db9ebcb98e$export$2e2bcd8739ae039; });

var $hOX5O = parcelRequire("hOX5O");
function $a12e57db9ebcb98e$export$2e2bcd8739ae039(obj, key, value) {
    key = (0, $hOX5O.default)(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});


parcelRegister("b9f0v", function(module, exports) {

$parcel$export(module.exports, "parsers", function () { return $81dc2d1ba439bd25$export$19131010e7fd8373; });

var $f3XBv = parcelRequire("f3XBv");

var $8iKuR = parcelRequire("8iKuR");

var $axu7e = parcelRequire("axu7e");

var $iq7Jy = parcelRequire("iq7Jy");

var $gQSGR = parcelRequire("gQSGR");

var $62k9z = parcelRequire("62k9z");

var $H8wJs = parcelRequire("H8wJs");

var $5GKFP = parcelRequire("5GKFP");

var $kkptF = parcelRequire("kkptF");

var $8kKQW = parcelRequire("8kKQW");

var $6ACIQ = parcelRequire("6ACIQ");

var $cEvg5 = parcelRequire("cEvg5");

var $ZxJer = parcelRequire("ZxJer");

var $6GWID = parcelRequire("6GWID");

var $f4rfa = parcelRequire("f4rfa");

var $esKF5 = parcelRequire("esKF5");

var $j7aNS = parcelRequire("j7aNS");

var $33HbA = parcelRequire("33HbA");

var $8i39i = parcelRequire("8i39i");

var $eXXBv = parcelRequire("eXXBv");

var $lfTyN = parcelRequire("lfTyN");

var $51hYf = parcelRequire("51hYf");

var $6fdZG = parcelRequire("6fdZG");

var $hI6v8 = parcelRequire("hI6v8");

var $4ZvMw = parcelRequire("4ZvMw");

var $f2DrF = parcelRequire("f2DrF");

var $2BnLa = parcelRequire("2BnLa");

var $axbcL = parcelRequire("axbcL");

var $264rY = parcelRequire("264rY");

var $fUVYu = parcelRequire("fUVYu");

var $gscNR = parcelRequire("gscNR");
var $81dc2d1ba439bd25$export$19131010e7fd8373 = {
    G: new (0, $f3XBv.EraParser)(),
    y: new (0, $8iKuR.YearParser)(),
    Y: new (0, $axu7e.LocalWeekYearParser)(),
    R: new (0, $iq7Jy.ISOWeekYearParser)(),
    u: new (0, $gQSGR.ExtendedYearParser)(),
    Q: new (0, $62k9z.QuarterParser)(),
    q: new (0, $H8wJs.StandAloneQuarterParser)(),
    M: new (0, $5GKFP.MonthParser)(),
    L: new (0, $kkptF.StandAloneMonthParser)(),
    w: new (0, $8kKQW.LocalWeekParser)(),
    I: new (0, $6ACIQ.ISOWeekParser)(),
    d: new (0, $cEvg5.DateParser)(),
    D: new (0, $ZxJer.DayOfYearParser)(),
    E: new (0, $6GWID.DayParser)(),
    e: new (0, $f4rfa.LocalDayParser)(),
    c: new (0, $esKF5.StandAloneLocalDayParser)(),
    i: new (0, $j7aNS.ISODayParser)(),
    a: new (0, $33HbA.AMPMParser)(),
    b: new (0, $8i39i.AMPMMidnightParser)(),
    B: new (0, $eXXBv.DayPeriodParser)(),
    h: new (0, $lfTyN.Hour1to12Parser)(),
    H: new (0, $51hYf.Hour0to23Parser)(),
    K: new (0, $6fdZG.Hour0To11Parser)(),
    k: new (0, $hI6v8.Hour1To24Parser)(),
    m: new (0, $4ZvMw.MinuteParser)(),
    s: new (0, $f2DrF.SecondParser)(),
    S: new (0, $2BnLa.FractionOfSecondParser)(),
    X: new (0, $axbcL.ISOTimezoneWithZParser)(),
    x: new (0, $264rY.ISOTimezoneParser)(),
    t: new (0, $fUVYu.TimestampSecondsParser)(),
    T: new (0, $gscNR.TimestampMillisecondsParser)()
};

});
parcelRegister("f3XBv", function(module, exports) {

$parcel$export(module.exports, "EraParser", function () { return $af755eed9d802742$export$8e5a1d3f85a9688; });

var $7bxB9 = parcelRequire("7bxB9");

var $6d01N = parcelRequire("6d01N");

var $k7KFa = parcelRequire("k7KFa");

var $11RWQ = parcelRequire("11RWQ");

var $f2A3W = parcelRequire("f2A3W");

var $dPXH7 = parcelRequire("dPXH7");

var $4uOoB = parcelRequire("4uOoB");
var $af755eed9d802742$export$8e5a1d3f85a9688 = /*#__PURE__*/ function(_Parser) {
    (0, $11RWQ.default)(EraParser, _Parser);
    var _super = (0, $f2A3W.default)(EraParser);
    function EraParser() {
        var _this;
        (0, $7bxB9.default)(this, EraParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $dPXH7.default)((0, $k7KFa.default)(_this), "priority", 140);
        (0, $dPXH7.default)((0, $k7KFa.default)(_this), "incompatibleTokens", [
            "R",
            "u",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $6d01N.default)(EraParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // AD, BC
                    case "G":
                    case "GG":
                    case "GGG":
                        return match.era(dateString, {
                            width: "abbreviated"
                        }) || match.era(dateString, {
                            width: "narrow"
                        });
                    // A, B
                    case "GGGGG":
                        return match.era(dateString, {
                            width: "narrow"
                        });
                    // Anno Domini, Before Christ
                    case "GGGG":
                    default:
                        return match.era(dateString, {
                            width: "wide"
                        }) || match.era(dateString, {
                            width: "abbreviated"
                        }) || match.era(dateString, {
                            width: "narrow"
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                flags.era = value;
                date.setUTCFullYear(value, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return EraParser;
}((0, $4uOoB.Parser));

});
parcelRegister("4uOoB", function(module, exports) {

$parcel$export(module.exports, "Parser", function () { return $34610e5890851963$export$7acfa6ed01010e37; });

var $7bxB9 = parcelRequire("7bxB9");

var $6d01N = parcelRequire("6d01N");

var $dPXH7 = parcelRequire("dPXH7");

var $9pLZJ = parcelRequire("9pLZJ");
var $34610e5890851963$export$7acfa6ed01010e37 = /*#__PURE__*/ function() {
    function Parser() {
        (0, $7bxB9.default)(this, Parser);
        (0, $dPXH7.default)(this, "incompatibleTokens", void 0);
        (0, $dPXH7.default)(this, "priority", void 0);
        (0, $dPXH7.default)(this, "subPriority", void 0);
    }
    (0, $6d01N.default)(Parser, [
        {
            key: "run",
            value: function run(dateString, token, match, options) {
                var result = this.parse(dateString, token, match, options);
                if (!result) return null;
                return {
                    setter: new (0, $9pLZJ.ValueSetter)(result.value, this.validate, this.set, this.priority, this.subPriority),
                    rest: result.rest
                };
            }
        },
        {
            key: "validate",
            value: function validate(_utcDate, _value, _options) {
                return true;
            }
        }
    ]);
    return Parser;
}();

});


parcelRegister("8iKuR", function(module, exports) {

$parcel$export(module.exports, "YearParser", function () { return $60b41274d73a7f08$export$48d352de7cd4a988; });

var $7bxB9 = parcelRequire("7bxB9");

var $6d01N = parcelRequire("6d01N");

var $k7KFa = parcelRequire("k7KFa");

var $11RWQ = parcelRequire("11RWQ");

var $f2A3W = parcelRequire("f2A3W");

var $dPXH7 = parcelRequire("dPXH7");

var $4uOoB = parcelRequire("4uOoB");

var $ASfFO = parcelRequire("ASfFO");
var $60b41274d73a7f08$export$48d352de7cd4a988 = /*#__PURE__*/ function(_Parser) {
    (0, $11RWQ.default)(YearParser, _Parser);
    var _super = (0, $f2A3W.default)(YearParser);
    function YearParser() {
        var _this;
        (0, $7bxB9.default)(this, YearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $dPXH7.default)((0, $k7KFa.default)(_this), "priority", 130);
        (0, $dPXH7.default)((0, $k7KFa.default)(_this), "incompatibleTokens", [
            "Y",
            "R",
            "u",
            "w",
            "I",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $6d01N.default)(YearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(year) {
                    return {
                        year: year,
                        isTwoDigitYear: token === "yy"
                    };
                };
                switch(token){
                    case "y":
                        return (0, $ASfFO.mapValue)((0, $ASfFO.parseNDigits)(4, dateString), valueCallback);
                    case "yo":
                        return (0, $ASfFO.mapValue)(match.ordinalNumber(dateString, {
                            unit: "year"
                        }), valueCallback);
                    default:
                        return (0, $ASfFO.mapValue)((0, $ASfFO.parseNDigits)(token.length, dateString), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value.isTwoDigitYear || value.year > 0;
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                var currentYear = date.getUTCFullYear();
                if (value.isTwoDigitYear) {
                    var normalizedTwoDigitYear = (0, $ASfFO.normalizeTwoDigitYear)(value.year, currentYear);
                    date.setUTCFullYear(normalizedTwoDigitYear, 0, 1);
                    date.setUTCHours(0, 0, 0, 0);
                    return date;
                }
                var year = !("era" in flags) || flags.era === 1 ? value.year : 1 - value.year;
                date.setUTCFullYear(year, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return YearParser;
}((0, $4uOoB.Parser));

});
parcelRegister("ASfFO", function(module, exports) {

$parcel$export(module.exports, "mapValue", function () { return $06ed722f23e2310d$export$4f84e3a82c7b538; });
$parcel$export(module.exports, "parseNumericPattern", function () { return $06ed722f23e2310d$export$cc7cc9e2a3ff9388; });
$parcel$export(module.exports, "parseTimezonePattern", function () { return $06ed722f23e2310d$export$6497f4c0ecdfba8e; });
$parcel$export(module.exports, "parseAnyDigitsSigned", function () { return $06ed722f23e2310d$export$d931c43c4608a164; });
$parcel$export(module.exports, "parseNDigits", function () { return $06ed722f23e2310d$export$513bb01536146ab6; });
$parcel$export(module.exports, "parseNDigitsSigned", function () { return $06ed722f23e2310d$export$2c9307b2e29c533c; });
$parcel$export(module.exports, "dayPeriodEnumToHours", function () { return $06ed722f23e2310d$export$fb506d2676e7f207; });
$parcel$export(module.exports, "normalizeTwoDigitYear", function () { return $06ed722f23e2310d$export$29126f735cbf69f7; });
$parcel$export(module.exports, "isLeapYearIndex", function () { return $06ed722f23e2310d$export$3d50627710b84d75; });

var $6uILS = parcelRequire("6uILS");

var $kaekb = parcelRequire("kaekb");
function $06ed722f23e2310d$export$4f84e3a82c7b538(parseFnResult, mapFn) {
    if (!parseFnResult) return parseFnResult;
    return {
        value: mapFn(parseFnResult.value),
        rest: parseFnResult.rest
    };
}
function $06ed722f23e2310d$export$cc7cc9e2a3ff9388(pattern, dateString) {
    var matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    return {
        value: parseInt(matchResult[0], 10),
        rest: dateString.slice(matchResult[0].length)
    };
}
function $06ed722f23e2310d$export$6497f4c0ecdfba8e(pattern, dateString) {
    var matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    // Input is 'Z'
    if (matchResult[0] === "Z") return {
        value: 0,
        rest: dateString.slice(1)
    };
    var sign = matchResult[1] === "+" ? 1 : -1;
    var hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
    var minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
    var seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
    return {
        value: sign * (hours * (0, $6uILS.millisecondsInHour) + minutes * (0, $6uILS.millisecondsInMinute) + seconds * (0, $6uILS.millisecondsInSecond)),
        rest: dateString.slice(matchResult[0].length)
    };
}
function $06ed722f23e2310d$export$d931c43c4608a164(dateString) {
    return $06ed722f23e2310d$export$cc7cc9e2a3ff9388((0, $kaekb.numericPatterns).anyDigitsSigned, dateString);
}
function $06ed722f23e2310d$export$513bb01536146ab6(n, dateString) {
    switch(n){
        case 1:
            return $06ed722f23e2310d$export$cc7cc9e2a3ff9388((0, $kaekb.numericPatterns).singleDigit, dateString);
        case 2:
            return $06ed722f23e2310d$export$cc7cc9e2a3ff9388((0, $kaekb.numericPatterns).twoDigits, dateString);
        case 3:
            return $06ed722f23e2310d$export$cc7cc9e2a3ff9388((0, $kaekb.numericPatterns).threeDigits, dateString);
        case 4:
            return $06ed722f23e2310d$export$cc7cc9e2a3ff9388((0, $kaekb.numericPatterns).fourDigits, dateString);
        default:
            return $06ed722f23e2310d$export$cc7cc9e2a3ff9388(new RegExp("^\\d{1," + n + "}"), dateString);
    }
}
function $06ed722f23e2310d$export$2c9307b2e29c533c(n, dateString) {
    switch(n){
        case 1:
            return $06ed722f23e2310d$export$cc7cc9e2a3ff9388((0, $kaekb.numericPatterns).singleDigitSigned, dateString);
        case 2:
            return $06ed722f23e2310d$export$cc7cc9e2a3ff9388((0, $kaekb.numericPatterns).twoDigitsSigned, dateString);
        case 3:
            return $06ed722f23e2310d$export$cc7cc9e2a3ff9388((0, $kaekb.numericPatterns).threeDigitsSigned, dateString);
        case 4:
            return $06ed722f23e2310d$export$cc7cc9e2a3ff9388((0, $kaekb.numericPatterns).fourDigitsSigned, dateString);
        default:
            return $06ed722f23e2310d$export$cc7cc9e2a3ff9388(new RegExp("^-?\\d{1," + n + "}"), dateString);
    }
}
function $06ed722f23e2310d$export$fb506d2676e7f207(dayPeriod) {
    switch(dayPeriod){
        case "morning":
            return 4;
        case "evening":
            return 17;
        case "pm":
        case "noon":
        case "afternoon":
            return 12;
        case "am":
        case "midnight":
        case "night":
        default:
            return 0;
    }
}
function $06ed722f23e2310d$export$29126f735cbf69f7(twoDigitYear, currentYear) {
    var isCommonEra = currentYear > 0;
    // Absolute number of the current year:
    // 1 -> 1 AC
    // 0 -> 1 BC
    // -1 -> 2 BC
    var absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
    var result;
    if (absCurrentYear <= 50) result = twoDigitYear || 100;
    else {
        var rangeEnd = absCurrentYear + 50;
        var rangeEndCentury = Math.floor(rangeEnd / 100) * 100;
        var isPreviousCentury = twoDigitYear >= rangeEnd % 100;
        result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
    }
    return isCommonEra ? result : 1 - result;
}
function $06ed722f23e2310d$export$3d50627710b84d75(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}

});
parcelRegister("6uILS", function(module, exports) {

$parcel$export(module.exports, "millisecondsInMinute", function () { return $4ba846075944cf95$export$91246f0b9bd9beff; });
$parcel$export(module.exports, "millisecondsInHour", function () { return $4ba846075944cf95$export$7f72910d6dfd237a; });
$parcel$export(module.exports, "millisecondsInSecond", function () { return $4ba846075944cf95$export$397c2d5776aa9055; });
/**
 * Days in 1 week.
 *
 * @name daysInWeek
 * @constant
 * @type {number}
 * @default
 */ var $4ba846075944cf95$export$dfd9b671c89acc8e = 7;
var $4ba846075944cf95$export$3913210603d8e9ae = 365.2425;
var $4ba846075944cf95$export$81caae6e1cc7a622 = Math.pow(10, 8) * 86400000;
var $4ba846075944cf95$export$91246f0b9bd9beff = 60000;
var $4ba846075944cf95$export$7f72910d6dfd237a = 3600000;
var $4ba846075944cf95$export$397c2d5776aa9055 = 1000;
var $4ba846075944cf95$export$4dec998e48f9c246 = -$4ba846075944cf95$export$81caae6e1cc7a622;
var $4ba846075944cf95$export$f2f5ae5a8e2d8f9f = 60;
var $4ba846075944cf95$export$3c58128db900d44e = 3;
var $4ba846075944cf95$export$80d7e435f744f319 = 12;
var $4ba846075944cf95$export$4db7641526e3241f = 4;
var $4ba846075944cf95$export$698aec755e92c695 = 3600;
var $4ba846075944cf95$export$a77c1a7ebebe2a5a = 60;
var $4ba846075944cf95$export$815a9362476d2fe3 = $4ba846075944cf95$export$698aec755e92c695 * 24;
var $4ba846075944cf95$export$34804a017b31e2fe = $4ba846075944cf95$export$815a9362476d2fe3 * 7;
var $4ba846075944cf95$export$7271e9e3478110d1 = $4ba846075944cf95$export$815a9362476d2fe3 * $4ba846075944cf95$export$3913210603d8e9ae;
var $4ba846075944cf95$export$8e6600bbdee7dabb = $4ba846075944cf95$export$7271e9e3478110d1 / 12;
var $4ba846075944cf95$export$be1dccf2de902d31 = $4ba846075944cf95$export$8e6600bbdee7dabb * 3;

});

parcelRegister("kaekb", function(module, exports) {

$parcel$export(module.exports, "numericPatterns", function () { return $eadfda6026d1c65f$export$c123ee06d9da8480; });
$parcel$export(module.exports, "timezonePatterns", function () { return $eadfda6026d1c65f$export$a7ee192b982af9c1; });
var $eadfda6026d1c65f$export$c123ee06d9da8480 = {
    month: /^(1[0-2]|0?\d)/,
    // 0 to 12
    date: /^(3[0-1]|[0-2]?\d)/,
    // 0 to 31
    dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
    // 0 to 366
    week: /^(5[0-3]|[0-4]?\d)/,
    // 0 to 53
    hour23h: /^(2[0-3]|[0-1]?\d)/,
    // 0 to 23
    hour24h: /^(2[0-4]|[0-1]?\d)/,
    // 0 to 24
    hour11h: /^(1[0-1]|0?\d)/,
    // 0 to 11
    hour12h: /^(1[0-2]|0?\d)/,
    // 0 to 12
    minute: /^[0-5]?\d/,
    // 0 to 59
    second: /^[0-5]?\d/,
    // 0 to 59
    singleDigit: /^\d/,
    // 0 to 9
    twoDigits: /^\d{1,2}/,
    // 0 to 99
    threeDigits: /^\d{1,3}/,
    // 0 to 999
    fourDigits: /^\d{1,4}/,
    // 0 to 9999
    anyDigitsSigned: /^-?\d+/,
    singleDigitSigned: /^-?\d/,
    // 0 to 9, -0 to -9
    twoDigitsSigned: /^-?\d{1,2}/,
    // 0 to 99, -0 to -99
    threeDigitsSigned: /^-?\d{1,3}/,
    // 0 to 999, -0 to -999
    fourDigitsSigned: /^-?\d{1,4}/ // 0 to 9999, -0 to -9999
};
var $eadfda6026d1c65f$export$a7ee192b982af9c1 = {
    basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
    basic: /^([+-])(\d{2})(\d{2})|Z/,
    basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
    extended: /^([+-])(\d{2}):(\d{2})|Z/,
    extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};

});



parcelRegister("axu7e", function(module, exports) {

$parcel$export(module.exports, "LocalWeekYearParser", function () { return $7ac458cf6c0cc727$export$b8ef38dfcf05d5db; });

var $7bxB9 = parcelRequire("7bxB9");

var $6d01N = parcelRequire("6d01N");

var $k7KFa = parcelRequire("k7KFa");

var $11RWQ = parcelRequire("11RWQ");

var $f2A3W = parcelRequire("f2A3W");

var $dPXH7 = parcelRequire("dPXH7");

var $4uOoB = parcelRequire("4uOoB");

var $ASfFO = parcelRequire("ASfFO");

var $1G1jh = parcelRequire("1G1jh");

var $fmTWq = parcelRequire("fmTWq");
var $7ac458cf6c0cc727$export$b8ef38dfcf05d5db = /*#__PURE__*/ function(_Parser) {
    (0, $11RWQ.default)(LocalWeekYearParser, _Parser);
    var _super = (0, $f2A3W.default)(LocalWeekYearParser);
    function LocalWeekYearParser() {
        var _this;
        (0, $7bxB9.default)(this, LocalWeekYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $dPXH7.default)((0, $k7KFa.default)(_this), "priority", 130);
        (0, $dPXH7.default)((0, $k7KFa.default)(_this), "incompatibleTokens", [
            "y",
            "R",
            "u",
            "Q",
            "q",
            "M",
            "L",
            "I",
            "d",
            "D",
            "i",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $6d01N.default)(LocalWeekYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(year) {
                    return {
                        year: year,
                        isTwoDigitYear: token === "YY"
                    };
                };
                switch(token){
                    case "Y":
                        return (0, $ASfFO.mapValue)((0, $ASfFO.parseNDigits)(4, dateString), valueCallback);
                    case "Yo":
                        return (0, $ASfFO.mapValue)(match.ordinalNumber(dateString, {
                            unit: "year"
                        }), valueCallback);
                    default:
                        return (0, $ASfFO.mapValue)((0, $ASfFO.parseNDigits)(token.length, dateString), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value.isTwoDigitYear || value.year > 0;
            }
        },
        {
            key: "set",
            value: function set(date, flags, value, options) {
                var currentYear = (0, $1G1jh.default)(date, options);
                if (value.isTwoDigitYear) {
                    var normalizedTwoDigitYear = (0, $ASfFO.normalizeTwoDigitYear)(value.year, currentYear);
                    date.setUTCFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
                    date.setUTCHours(0, 0, 0, 0);
                    return (0, $fmTWq.default)(date, options);
                }
                var year = !("era" in flags) || flags.era === 1 ? value.year : 1 - value.year;
                date.setUTCFullYear(year, 0, options.firstWeekContainsDate);
                date.setUTCHours(0, 0, 0, 0);
                return (0, $fmTWq.default)(date, options);
            }
        }
    ]);
    return LocalWeekYearParser;
}((0, $4uOoB.Parser));

});
parcelRegister("1G1jh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $138abad5765eee5e$export$2e2bcd8739ae039; });

var $j2DA4 = parcelRequire("j2DA4");

var $1BahA = parcelRequire("1BahA");

var $fmTWq = parcelRequire("fmTWq");

var $hkULo = parcelRequire("hkULo");

var $2Kxhf = parcelRequire("2Kxhf");
function $138abad5765eee5e$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $1BahA.default)(1, arguments);
    var date = (0, $j2DA4.default)(dirtyDate);
    var year = date.getUTCFullYear();
    var defaultOptions = (0, $2Kxhf.getDefaultOptions)();
    var firstWeekContainsDate = (0, $hkULo.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var firstWeekOfNextYear = new Date(0);
    firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $fmTWq.default)(firstWeekOfNextYear, options);
    var firstWeekOfThisYear = new Date(0);
    firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $fmTWq.default)(firstWeekOfThisYear, options);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}

});
parcelRegister("fmTWq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b3044de03a318662$export$2e2bcd8739ae039; });

var $j2DA4 = parcelRequire("j2DA4");

var $1BahA = parcelRequire("1BahA");

var $hkULo = parcelRequire("hkULo");

var $2Kxhf = parcelRequire("2Kxhf");
function $b3044de03a318662$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $1BahA.default)(1, arguments);
    var defaultOptions = (0, $2Kxhf.getDefaultOptions)();
    var weekStartsOn = (0, $hkULo.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var date = (0, $j2DA4.default)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}

});
parcelRegister("2Kxhf", function(module, exports) {

$parcel$export(module.exports, "getDefaultOptions", function () { return $2009b0ca2fa96d23$export$430a3269e24b912e; });
var $2009b0ca2fa96d23$var$defaultOptions = {};
function $2009b0ca2fa96d23$export$430a3269e24b912e() {
    return $2009b0ca2fa96d23$var$defaultOptions;
}
function $2009b0ca2fa96d23$export$95365be1b0704abc(newOptions) {
    $2009b0ca2fa96d23$var$defaultOptions = newOptions;
}

});




parcelRegister("iq7Jy", function(module, exports) {

$parcel$export(module.exports, "ISOWeekYearParser", function () { return $d690a7750f00c484$export$951d1df011fde06f; });

var $7bxB9 = parcelRequire("7bxB9");

var $6d01N = parcelRequire("6d01N");

var $k7KFa = parcelRequire("k7KFa");

var $11RWQ = parcelRequire("11RWQ");

var $f2A3W = parcelRequire("f2A3W");

var $dPXH7 = parcelRequire("dPXH7");

var $4uOoB = parcelRequire("4uOoB");

var $ASfFO = parcelRequire("ASfFO");

var $14ftT = parcelRequire("14ftT");
var $d690a7750f00c484$export$951d1df011fde06f = /*#__PURE__*/ function(_Parser) {
    (0, $11RWQ.default)(ISOWeekYearParser, _Parser);
    var _super = (0, $f2A3W.default)(ISOWeekYearParser);
    function ISOWeekYearParser() {
        var _this;
        (0, $7bxB9.default)(this, ISOWeekYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $dPXH7.default)((0, $k7KFa.default)(_this), "priority", 130);
        (0, $dPXH7.default)((0, $k7KFa.default)(_this), "incompatibleTokens", [
            "G",
            "y",
            "Y",
            "u",
            "Q",
            "q",
            "M",
            "L",
            "w",
            "d",
            "D",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $6d01N.default)(ISOWeekYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                if (token === "R") return (0, $ASfFO.parseNDigitsSigned)(4, dateString);
                return (0, $ASfFO.parseNDigitsSigned)(token.length, dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                var firstWeekOfYear = new Date(0);
                firstWeekOfYear.setUTCFullYear(value, 0, 4);
                firstWeekOfYear.setUTCHours(0, 0, 0, 0);
                return (0, $14ftT.default)(firstWeekOfYear);
            }
        }
    ]);
    return ISOWeekYearParser;
}((0, $4uOoB.Parser));

});
parcelRegister("14ftT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0c722c64f0f9ca62$export$2e2bcd8739ae039; });

var $j2DA4 = parcelRequire("j2DA4");

var $1BahA = parcelRequire("1BahA");
function $0c722c64f0f9ca62$export$2e2bcd8739ae039(dirtyDate) {
    (0, $1BahA.default)(1, arguments);
    var weekStartsOn = 1;
    var date = (0, $j2DA4.default)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}

});


parcelRegister("gQSGR", function(module, exports) {

$parcel$export(module.exports, "ExtendedYearParser", function () { return $c44bed0460ecb190$export$bad9d2ea38e8f1a; });

var $7bxB9 = parcelRequire("7bxB9");

var $6d01N = parcelRequire("6d01N");

var $k7KFa = parcelRequire("k7KFa");

var $11RWQ = parcelRequire("11RWQ");

var $f2A3W = parcelRequire("f2A3W");

var $dPXH7 = parcelRequire("dPXH7");

var $4uOoB = parcelRequire("4uOoB");

var $ASfFO = parcelRequire("ASfFO");
var $c44bed0460ecb190$export$bad9d2ea38e8f1a = /*#__PURE__*/ function(_Parser) {
    (0, $11RWQ.default)(ExtendedYearParser, _Parser);
    var _super = (0, $f2A3W.default)(ExtendedYearParser);
    function ExtendedYearParser() {
        var _this;
        (0, $7bxB9.default)(this, ExtendedYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $dPXH7.default)((0, $k7KFa.default)(_this), "priority", 130);
        (0, $dPXH7.default)((0, $k7KFa.default)(_this), "incompatibleTokens", [
            "G",
            "y",
            "Y",
            "R",
            "w",
            "I",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $6d01N.default)(ExtendedYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                if (token === "u") return (0, $ASfFO.parseNDigitsSigned)(4, dateString);
                return (0, $ASfFO.parseNDigitsSigned)(token.length, dateString);
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCFullYear(value, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return ExtendedYearParser;
}((0, $4uOoB.Parser));

});

parcelRegister("62k9z", function(module, exports) {

$parcel$export(module.exports, "QuarterParser", function () { return $465290059f05a358$export$5cb0f701186dde1d; });

var $7bxB9 = parcelRequire("7bxB9");

var $6d01N = parcelRequire("6d01N");

var $k7KFa = parcelRequire("k7KFa");

var $11RWQ = parcelRequire("11RWQ");

var $f2A3W = parcelRequire("f2A3W");

var $dPXH7 = parcelRequire("dPXH7");

var $4uOoB = parcelRequire("4uOoB");

var $ASfFO = parcelRequire("ASfFO");
var $465290059f05a358$export$5cb0f701186dde1d = /*#__PURE__*/ function(_Parser) {
    (0, $11RWQ.default)(QuarterParser, _Parser);
    var _super = (0, $f2A3W.default)(QuarterParser);
    function QuarterParser() {
        var _this;
        (0, $7bxB9.default)(this, QuarterParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $dPXH7.default)((0, $k7KFa.default)(_this), "priority", 120);
        (0, $dPXH7.default)((0, $k7KFa.default)(_this), "incompatibleTokens", [
            "Y",
            "R",
            "q",
            "M",
            "L",
            "w",
            "I",
            "d",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $6d01N.default)(QuarterParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // 1, 2, 3, 4
                    case "Q":
                    case "QQ":
                        // 01, 02, 03, 04
                        return (0, $ASfFO.parseNDigits)(token.length, dateString);
                    // 1st, 2nd, 3rd, 4th
                    case "Qo":
                        return match.ordinalNumber(dateString, {
                            unit: "quarter"
                        });
                    // Q1, Q2, Q3, Q4
                    case "QQQ":
                        return match.quarter(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.quarter(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // 1, 2, 3, 4 (narrow quarter; could be not numerical)
                    case "QQQQQ":
                        return match.quarter(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // 1st quarter, 2nd quarter, ...
                    case "QQQQ":
                    default:
                        return match.quarter(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.quarter(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.quarter(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 4;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth((value - 1) * 3, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return QuarterParser;
}((0, $4uOoB.Parser));

});

parcelRegister("H8wJs", function(module, exports) {

$parcel$export(module.exports, "StandAloneQuarterParser", function () { return $081aa18a0bcc5f90$export$300c0c2990e20e6d; });

var $7bxB9 = parcelRequire("7bxB9");

var $6d01N = parcelRequire("6d01N");

var $k7KFa = parcelRequire("k7KFa");

var $11RWQ = parcelRequire("11RWQ");

var $f2A3W = parcelRequire("f2A3W");

var $dPXH7 = parcelRequire("dPXH7");

var $4uOoB = parcelRequire("4uOoB");

var $ASfFO = parcelRequire("ASfFO");
var $081aa18a0bcc5f90$export$300c0c2990e20e6d = /*#__PURE__*/ function(_Parser) {
    (0, $11RWQ.default)(StandAloneQuarterParser, _Parser);
    var _super = (0, $f2A3W.default)(StandAloneQuarterParser);
    function StandAloneQuarterParser() {
        var _this;
        (0, $7bxB9.default)(this, StandAloneQuarterParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $dPXH7.default)((0, $k7KFa.default)(_this), "priority", 120);
        (0, $dPXH7.default)((0, $k7KFa.default)(_this), "incompatibleTokens", [
            "Y",
            "R",
            "Q",
            "M",
            "L",
            "w",
            "I",
            "d",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $6d01N.default)(StandAloneQuarterParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // 1, 2, 3, 4
                    case "q":
                    case "qq":
                        // 01, 02, 03, 04
                        return (0, $ASfFO.parseNDigits)(token.length, dateString);
                    // 1st, 2nd, 3rd, 4th
                    case "qo":
                        return match.ordinalNumber(dateString, {
                            unit: "quarter"
                        });
                    // Q1, Q2, Q3, Q4
                    case "qqq":
                        return match.quarter(dateString, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || match.quarter(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // 1, 2, 3, 4 (narrow quarter; could be not numerical)
                    case "qqqqq":
                        return match.quarter(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // 1st quarter, 2nd quarter, ...
                    case "qqqq":
                    default:
                        return match.quarter(dateString, {
                            width: "wide",
                            context: "standalone"
                        }) || match.quarter(dateString, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || match.quarter(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 4;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth((value - 1) * 3, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneQuarterParser;
}((0, $4uOoB.Parser));

});

parcelRegister("5GKFP", function(module, exports) {

$parcel$export(module.exports, "MonthParser", function () { return $4245146bf002e339$export$400dd8b40ef138a3; });

var $7bxB9 = parcelRequire("7bxB9");

var $6d01N = parcelRequire("6d01N");

var $k7KFa = parcelRequire("k7KFa");

var $11RWQ = parcelRequire("11RWQ");

var $f2A3W = parcelRequire("f2A3W");

var $dPXH7 = parcelRequire("dPXH7");

var $ASfFO = parcelRequire("ASfFO");

var $4uOoB = parcelRequire("4uOoB");

var $kaekb = parcelRequire("kaekb");
var $4245146bf002e339$export$400dd8b40ef138a3 = /*#__PURE__*/ function(_Parser) {
    (0, $11RWQ.default)(MonthParser, _Parser);
    var _super = (0, $f2A3W.default)(MonthParser);
    function MonthParser() {
        var _this;
        (0, $7bxB9.default)(this, MonthParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $dPXH7.default)((0, $k7KFa.default)(_this), "incompatibleTokens", [
            "Y",
            "R",
            "q",
            "Q",
            "L",
            "w",
            "I",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        (0, $dPXH7.default)((0, $k7KFa.default)(_this), "priority", 110);
        return _this;
    }
    (0, $6d01N.default)(MonthParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    return value - 1;
                };
                switch(token){
                    // 1, 2, ..., 12
                    case "M":
                        return (0, $ASfFO.mapValue)((0, $ASfFO.parseNumericPattern)((0, $kaekb.numericPatterns).month, dateString), valueCallback);
                    // 01, 02, ..., 12
                    case "MM":
                        return (0, $ASfFO.mapValue)((0, $ASfFO.parseNDigits)(2, dateString), valueCallback);
                    // 1st, 2nd, ..., 12th
                    case "Mo":
                        return (0, $ASfFO.mapValue)(match.ordinalNumber(dateString, {
                            unit: "month"
                        }), valueCallback);
                    // Jan, Feb, ..., Dec
                    case "MMM":
                        return match.month(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.month(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // J, F, ..., D
                    case "MMMMM":
                        return match.month(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // January, February, ..., December
                    case "MMMM":
                    default:
                        return match.month(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.month(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.month(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(value, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return MonthParser;
}((0, $4uOoB.Parser));

});

parcelRegister("kkptF", function(module, exports) {

$parcel$export(module.exports, "StandAloneMonthParser", function () { return $ecc97031e86c2a18$export$1d7eaa53eaa5deba; });

var $7bxB9 = parcelRequire("7bxB9");

var $6d01N = parcelRequire("6d01N");

var $k7KFa = parcelRequire("k7KFa");

var $11RWQ = parcelRequire("11RWQ");

var $f2A3W = parcelRequire("f2A3W");

var $dPXH7 = parcelRequire("dPXH7");

var $4uOoB = parcelRequire("4uOoB");

var $kaekb = parcelRequire("kaekb");

var $ASfFO = parcelRequire("ASfFO");
var $ecc97031e86c2a18$export$1d7eaa53eaa5deba = /*#__PURE__*/ function(_Parser) {
    (0, $11RWQ.default)(StandAloneMonthParser, _Parser);
    var _super = (0, $f2A3W.default)(StandAloneMonthParser);
    function StandAloneMonthParser() {
        var _this;
        (0, $7bxB9.default)(this, StandAloneMonthParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $dPXH7.default)((0, $k7KFa.default)(_this), "priority", 110);
        (0, $dPXH7.default)((0, $k7KFa.default)(_this), "incompatibleTokens", [
            "Y",
            "R",
            "q",
            "Q",
            "M",
            "w",
            "I",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $6d01N.default)(StandAloneMonthParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    return value - 1;
                };
                switch(token){
                    // 1, 2, ..., 12
                    case "L":
                        return (0, $ASfFO.mapValue)((0, $ASfFO.parseNumericPattern)((0, $kaekb.numericPatterns).month, dateString), valueCallback);
                    // 01, 02, ..., 12
                    case "LL":
                        return (0, $ASfFO.mapValue)((0, $ASfFO.parseNDigits)(2, dateString), valueCallback);
                    // 1st, 2nd, ..., 12th
                    case "Lo":
                        return (0, $ASfFO.mapValue)(match.ordinalNumber(dateString, {
                            unit: "month"
                        }), valueCallback);
                    // Jan, Feb, ..., Dec
                    case "LLL":
                        return match.month(dateString, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || match.month(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // J, F, ..., D
                    case "LLLLL":
                        return match.month(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // January, February, ..., December
                    case "LLLL":
                    default:
                        return match.month(dateString, {
                            width: "wide",
                            context: "standalone"
                        }) || match.month(dateString, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || match.month(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(value, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneMonthParser;
}((0, $4uOoB.Parser));

});

parcelRegister("8kKQW", function(module, exports) {

$parcel$export(module.exports, "LocalWeekParser", function () { return $611488fb7c20ec06$export$c4005ffc174e07c0; });

var $7bxB9 = parcelRequire("7bxB9");

var $6d01N = parcelRequire("6d01N");

var $k7KFa = parcelRequire("k7KFa");

var $11RWQ = parcelRequire("11RWQ");

var $f2A3W = parcelRequire("f2A3W");

var $dPXH7 = parcelRequire("dPXH7");

var $4uOoB = parcelRequire("4uOoB");

var $kaekb = parcelRequire("kaekb");

var $ASfFO = parcelRequire("ASfFO");

var $lqzGh = parcelRequire("lqzGh");

var $fmTWq = parcelRequire("fmTWq");
var $611488fb7c20ec06$export$c4005ffc174e07c0 = /*#__PURE__*/ function(_Parser) {
    (0, $11RWQ.default)(LocalWeekParser, _Parser);
    var _super = (0, $f2A3W.default)(LocalWeekParser);
    function LocalWeekParser() {
        var _this;
        (0, $7bxB9.default)(this, LocalWeekParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $dPXH7.default)((0, $k7KFa.default)(_this), "priority", 100);
        (0, $dPXH7.default)((0, $k7KFa.default)(_this), "incompatibleTokens", [
            "y",
            "R",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "I",
            "d",
            "D",
            "i",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $6d01N.default)(LocalWeekParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "w":
                        return (0, $ASfFO.parseNumericPattern)((0, $kaekb.numericPatterns).week, dateString);
                    case "wo":
                        return match.ordinalNumber(dateString, {
                            unit: "week"
                        });
                    default:
                        return (0, $ASfFO.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 53;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                return (0, $fmTWq.default)((0, $lqzGh.default)(date, value, options), options);
            }
        }
    ]);
    return LocalWeekParser;
}((0, $4uOoB.Parser));

});
parcelRegister("lqzGh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f997b43150346fe5$export$2e2bcd8739ae039; });

var $hkULo = parcelRequire("hkULo");

var $j2DA4 = parcelRequire("j2DA4");

var $kXZrS = parcelRequire("kXZrS");

var $1BahA = parcelRequire("1BahA");
function $f997b43150346fe5$export$2e2bcd8739ae039(dirtyDate, dirtyWeek, options) {
    (0, $1BahA.default)(2, arguments);
    var date = (0, $j2DA4.default)(dirtyDate);
    var week = (0, $hkULo.default)(dirtyWeek);
    var diff = (0, $kXZrS.default)(date, options) - week;
    date.setUTCDate(date.getUTCDate() - diff * 7);
    return date;
}

});
parcelRegister("kXZrS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f438fbc40b3b160f$export$2e2bcd8739ae039; });

var $j2DA4 = parcelRequire("j2DA4");

var $fmTWq = parcelRequire("fmTWq");

var $4WAwD = parcelRequire("4WAwD");

var $1BahA = parcelRequire("1BahA");
var $f438fbc40b3b160f$var$MILLISECONDS_IN_WEEK = 604800000;
function $f438fbc40b3b160f$export$2e2bcd8739ae039(dirtyDate, options) {
    (0, $1BahA.default)(1, arguments);
    var date = (0, $j2DA4.default)(dirtyDate);
    var diff = (0, $fmTWq.default)(date, options).getTime() - (0, $4WAwD.default)(date, options).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $f438fbc40b3b160f$var$MILLISECONDS_IN_WEEK) + 1;
}

});
parcelRegister("4WAwD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3998e961458b5632$export$2e2bcd8739ae039; });

var $1G1jh = parcelRequire("1G1jh");

var $1BahA = parcelRequire("1BahA");

var $fmTWq = parcelRequire("fmTWq");

var $hkULo = parcelRequire("hkULo");

var $2Kxhf = parcelRequire("2Kxhf");
function $3998e961458b5632$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $1BahA.default)(1, arguments);
    var defaultOptions = (0, $2Kxhf.getDefaultOptions)();
    var firstWeekContainsDate = (0, $hkULo.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    var year = (0, $1G1jh.default)(dirtyDate, options);
    var firstWeek = new Date(0);
    firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setUTCHours(0, 0, 0, 0);
    var date = (0, $fmTWq.default)(firstWeek, options);
    return date;
}

});




parcelRegister("6ACIQ", function(module, exports) {

$parcel$export(module.exports, "ISOWeekParser", function () { return $4cc42454c2d22db4$export$6fc8dbedd560a6af; });

var $7bxB9 = parcelRequire("7bxB9");

var $6d01N = parcelRequire("6d01N");

var $k7KFa = parcelRequire("k7KFa");

var $11RWQ = parcelRequire("11RWQ");

var $f2A3W = parcelRequire("f2A3W");

var $dPXH7 = parcelRequire("dPXH7");

var $4uOoB = parcelRequire("4uOoB");

var $kaekb = parcelRequire("kaekb");

var $ASfFO = parcelRequire("ASfFO");

var $8mZFl = parcelRequire("8mZFl");

var $14ftT = parcelRequire("14ftT");
var $4cc42454c2d22db4$export$6fc8dbedd560a6af = /*#__PURE__*/ function(_Parser) {
    (0, $11RWQ.default)(ISOWeekParser, _Parser);
    var _super = (0, $f2A3W.default)(ISOWeekParser);
    function ISOWeekParser() {
        var _this;
        (0, $7bxB9.default)(this, ISOWeekParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $dPXH7.default)((0, $k7KFa.default)(_this), "priority", 100);
        (0, $dPXH7.default)((0, $k7KFa.default)(_this), "incompatibleTokens", [
            "y",
            "Y",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "w",
            "d",
            "D",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $6d01N.default)(ISOWeekParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "I":
                        return (0, $ASfFO.parseNumericPattern)((0, $kaekb.numericPatterns).week, dateString);
                    case "Io":
                        return match.ordinalNumber(dateString, {
                            unit: "week"
                        });
                    default:
                        return (0, $ASfFO.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 53;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                return (0, $14ftT.default)((0, $8mZFl.default)(date, value));
            }
        }
    ]);
    return ISOWeekParser;
}((0, $4uOoB.Parser));

});
parcelRegister("8mZFl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6180365505f75541$export$2e2bcd8739ae039; });

var $hkULo = parcelRequire("hkULo");

var $j2DA4 = parcelRequire("j2DA4");

var $6bAaj = parcelRequire("6bAaj");

var $1BahA = parcelRequire("1BahA");
function $6180365505f75541$export$2e2bcd8739ae039(dirtyDate, dirtyISOWeek) {
    (0, $1BahA.default)(2, arguments);
    var date = (0, $j2DA4.default)(dirtyDate);
    var isoWeek = (0, $hkULo.default)(dirtyISOWeek);
    var diff = (0, $6bAaj.default)(date) - isoWeek;
    date.setUTCDate(date.getUTCDate() - diff * 7);
    return date;
}

});
parcelRegister("6bAaj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $480fd2d2be52808a$export$2e2bcd8739ae039; });

var $j2DA4 = parcelRequire("j2DA4");

var $14ftT = parcelRequire("14ftT");

var $jBjMN = parcelRequire("jBjMN");

var $1BahA = parcelRequire("1BahA");
var $480fd2d2be52808a$var$MILLISECONDS_IN_WEEK = 604800000;
function $480fd2d2be52808a$export$2e2bcd8739ae039(dirtyDate) {
    (0, $1BahA.default)(1, arguments);
    var date = (0, $j2DA4.default)(dirtyDate);
    var diff = (0, $14ftT.default)(date).getTime() - (0, $jBjMN.default)(date).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $480fd2d2be52808a$var$MILLISECONDS_IN_WEEK) + 1;
}

});
parcelRegister("jBjMN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e450d21d8af7b3cd$export$2e2bcd8739ae039; });

var $7F5O4 = parcelRequire("7F5O4");

var $14ftT = parcelRequire("14ftT");

var $1BahA = parcelRequire("1BahA");
function $e450d21d8af7b3cd$export$2e2bcd8739ae039(dirtyDate) {
    (0, $1BahA.default)(1, arguments);
    var year = (0, $7F5O4.default)(dirtyDate);
    var fourthOfJanuary = new Date(0);
    fourthOfJanuary.setUTCFullYear(year, 0, 4);
    fourthOfJanuary.setUTCHours(0, 0, 0, 0);
    var date = (0, $14ftT.default)(fourthOfJanuary);
    return date;
}

});
parcelRegister("7F5O4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5940ddd1cb8a4ea0$export$2e2bcd8739ae039; });

var $j2DA4 = parcelRequire("j2DA4");

var $1BahA = parcelRequire("1BahA");

var $14ftT = parcelRequire("14ftT");
function $5940ddd1cb8a4ea0$export$2e2bcd8739ae039(dirtyDate) {
    (0, $1BahA.default)(1, arguments);
    var date = (0, $j2DA4.default)(dirtyDate);
    var year = date.getUTCFullYear();
    var fourthOfJanuaryOfNextYear = new Date(0);
    fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $14ftT.default)(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = new Date(0);
    fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $14ftT.default)(fourthOfJanuaryOfThisYear);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}

});





parcelRegister("cEvg5", function(module, exports) {

$parcel$export(module.exports, "DateParser", function () { return $936177bf4e7cff89$export$e8d4b28a20981dd2; });

var $7bxB9 = parcelRequire("7bxB9");

var $6d01N = parcelRequire("6d01N");

var $k7KFa = parcelRequire("k7KFa");

var $11RWQ = parcelRequire("11RWQ");

var $f2A3W = parcelRequire("f2A3W");

var $dPXH7 = parcelRequire("dPXH7");

var $ASfFO = parcelRequire("ASfFO");

var $4uOoB = parcelRequire("4uOoB");

var $kaekb = parcelRequire("kaekb");
var $936177bf4e7cff89$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $936177bf4e7cff89$var$DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $936177bf4e7cff89$export$e8d4b28a20981dd2 = /*#__PURE__*/ function(_Parser) {
    (0, $11RWQ.default)(DateParser, _Parser);
    var _super = (0, $f2A3W.default)(DateParser);
    function DateParser() {
        var _this;
        (0, $7bxB9.default)(this, DateParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $dPXH7.default)((0, $k7KFa.default)(_this), "priority", 90);
        (0, $dPXH7.default)((0, $k7KFa.default)(_this), "subPriority", 1);
        (0, $dPXH7.default)((0, $k7KFa.default)(_this), "incompatibleTokens", [
            "Y",
            "R",
            "q",
            "Q",
            "w",
            "I",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $6d01N.default)(DateParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "d":
                        return (0, $ASfFO.parseNumericPattern)((0, $kaekb.numericPatterns).date, dateString);
                    case "do":
                        return match.ordinalNumber(dateString, {
                            unit: "date"
                        });
                    default:
                        return (0, $ASfFO.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(date, value) {
                var year = date.getUTCFullYear();
                var isLeapYear = (0, $ASfFO.isLeapYearIndex)(year);
                var month = date.getUTCMonth();
                if (isLeapYear) return value >= 1 && value <= $936177bf4e7cff89$var$DAYS_IN_MONTH_LEAP_YEAR[month];
                else return value >= 1 && value <= $936177bf4e7cff89$var$DAYS_IN_MONTH[month];
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCDate(value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DateParser;
}((0, $4uOoB.Parser));

});

parcelRegister("ZxJer", function(module, exports) {

$parcel$export(module.exports, "DayOfYearParser", function () { return $0b8fdc680fad6d59$export$6cfe0d613455f615; });

var $7bxB9 = parcelRequire("7bxB9");

var $6d01N = parcelRequire("6d01N");

var $k7KFa = parcelRequire("k7KFa");

var $11RWQ = parcelRequire("11RWQ");

var $f2A3W = parcelRequire("f2A3W");

var $dPXH7 = parcelRequire("dPXH7");

var $4uOoB = parcelRequire("4uOoB");

var $kaekb = parcelRequire("kaekb");

var $ASfFO = parcelRequire("ASfFO");
var $0b8fdc680fad6d59$export$6cfe0d613455f615 = /*#__PURE__*/ function(_Parser) {
    (0, $11RWQ.default)(DayOfYearParser, _Parser);
    var _super = (0, $f2A3W.default)(DayOfYearParser);
    function DayOfYearParser() {
        var _this;
        (0, $7bxB9.default)(this, DayOfYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $dPXH7.default)((0, $k7KFa.default)(_this), "priority", 90);
        (0, $dPXH7.default)((0, $k7KFa.default)(_this), "subpriority", 1);
        (0, $dPXH7.default)((0, $k7KFa.default)(_this), "incompatibleTokens", [
            "Y",
            "R",
            "q",
            "Q",
            "M",
            "L",
            "w",
            "I",
            "d",
            "E",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $6d01N.default)(DayOfYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "D":
                    case "DD":
                        return (0, $ASfFO.parseNumericPattern)((0, $kaekb.numericPatterns).dayOfYear, dateString);
                    case "Do":
                        return match.ordinalNumber(dateString, {
                            unit: "date"
                        });
                    default:
                        return (0, $ASfFO.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(date, value) {
                var year = date.getUTCFullYear();
                var isLeapYear = (0, $ASfFO.isLeapYearIndex)(year);
                if (isLeapYear) return value >= 1 && value <= 366;
                else return value >= 1 && value <= 365;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(0, value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayOfYearParser;
}((0, $4uOoB.Parser));

});

parcelRegister("6GWID", function(module, exports) {

$parcel$export(module.exports, "DayParser", function () { return $4df436a82e1b4fcb$export$1b03c8b76262f7bd; });

var $7bxB9 = parcelRequire("7bxB9");

var $6d01N = parcelRequire("6d01N");

var $k7KFa = parcelRequire("k7KFa");

var $11RWQ = parcelRequire("11RWQ");

var $f2A3W = parcelRequire("f2A3W");

var $dPXH7 = parcelRequire("dPXH7");

var $4uOoB = parcelRequire("4uOoB");

var $ibQYD = parcelRequire("ibQYD");
var $4df436a82e1b4fcb$export$1b03c8b76262f7bd = /*#__PURE__*/ function(_Parser) {
    (0, $11RWQ.default)(DayParser, _Parser);
    var _super = (0, $f2A3W.default)(DayParser);
    function DayParser() {
        var _this;
        (0, $7bxB9.default)(this, DayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $dPXH7.default)((0, $k7KFa.default)(_this), "priority", 90);
        (0, $dPXH7.default)((0, $k7KFa.default)(_this), "incompatibleTokens", [
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $6d01N.default)(DayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // Tue
                    case "E":
                    case "EE":
                    case "EEE":
                        return match.day(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // T
                    case "EEEEE":
                        return match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // Tu
                    case "EEEEEE":
                        return match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // Tuesday
                    case "EEEE":
                    default:
                        return match.day(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, $ibQYD.default)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayParser;
}((0, $4uOoB.Parser));

});
parcelRegister("ibQYD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d3e2593186a3b8ab$export$2e2bcd8739ae039; });

var $j2DA4 = parcelRequire("j2DA4");

var $1BahA = parcelRequire("1BahA");

var $hkULo = parcelRequire("hkULo");

var $2Kxhf = parcelRequire("2Kxhf");
function $d3e2593186a3b8ab$export$2e2bcd8739ae039(dirtyDate, dirtyDay, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $1BahA.default)(2, arguments);
    var defaultOptions = (0, $2Kxhf.getDefaultOptions)();
    var weekStartsOn = (0, $hkULo.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var date = (0, $j2DA4.default)(dirtyDate);
    var day = (0, $hkULo.default)(dirtyDay);
    var currentDay = date.getUTCDay();
    var remainder = day % 7;
    var dayIndex = (remainder + 7) % 7;
    var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}

});


parcelRegister("f4rfa", function(module, exports) {

$parcel$export(module.exports, "LocalDayParser", function () { return $af8c5cc3560f28c4$export$44d1c127ab42c480; });

var $7bxB9 = parcelRequire("7bxB9");

var $6d01N = parcelRequire("6d01N");

var $k7KFa = parcelRequire("k7KFa");

var $11RWQ = parcelRequire("11RWQ");

var $f2A3W = parcelRequire("f2A3W");

var $dPXH7 = parcelRequire("dPXH7");

var $4uOoB = parcelRequire("4uOoB");

var $ASfFO = parcelRequire("ASfFO");

var $ibQYD = parcelRequire("ibQYD");
var $af8c5cc3560f28c4$export$44d1c127ab42c480 = /*#__PURE__*/ function(_Parser) {
    (0, $11RWQ.default)(LocalDayParser, _Parser);
    var _super = (0, $f2A3W.default)(LocalDayParser);
    function LocalDayParser() {
        var _this;
        (0, $7bxB9.default)(this, LocalDayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $dPXH7.default)((0, $k7KFa.default)(_this), "priority", 90);
        (0, $dPXH7.default)((0, $k7KFa.default)(_this), "incompatibleTokens", [
            "y",
            "R",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "I",
            "d",
            "D",
            "E",
            "i",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $6d01N.default)(LocalDayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match, options) {
                var valueCallback = function valueCallback(value) {
                    var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
                    return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
                };
                switch(token){
                    // 3
                    case "e":
                    case "ee":
                        // 03
                        return (0, $ASfFO.mapValue)((0, $ASfFO.parseNDigits)(token.length, dateString), valueCallback);
                    // 3rd
                    case "eo":
                        return (0, $ASfFO.mapValue)(match.ordinalNumber(dateString, {
                            unit: "day"
                        }), valueCallback);
                    // Tue
                    case "eee":
                        return match.day(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // T
                    case "eeeee":
                        return match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // Tu
                    case "eeeeee":
                        return match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // Tuesday
                    case "eeee":
                    default:
                        return match.day(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, $ibQYD.default)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return LocalDayParser;
}((0, $4uOoB.Parser));

});

parcelRegister("esKF5", function(module, exports) {

$parcel$export(module.exports, "StandAloneLocalDayParser", function () { return $a877e03a1979b943$export$e447a647caaaec1d; });

var $7bxB9 = parcelRequire("7bxB9");

var $6d01N = parcelRequire("6d01N");

var $k7KFa = parcelRequire("k7KFa");

var $11RWQ = parcelRequire("11RWQ");

var $f2A3W = parcelRequire("f2A3W");

var $dPXH7 = parcelRequire("dPXH7");

var $4uOoB = parcelRequire("4uOoB");

var $ASfFO = parcelRequire("ASfFO");

var $ibQYD = parcelRequire("ibQYD");
var $a877e03a1979b943$export$e447a647caaaec1d = /*#__PURE__*/ function(_Parser) {
    (0, $11RWQ.default)(StandAloneLocalDayParser, _Parser);
    var _super = (0, $f2A3W.default)(StandAloneLocalDayParser);
    function StandAloneLocalDayParser() {
        var _this;
        (0, $7bxB9.default)(this, StandAloneLocalDayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $dPXH7.default)((0, $k7KFa.default)(_this), "priority", 90);
        (0, $dPXH7.default)((0, $k7KFa.default)(_this), "incompatibleTokens", [
            "y",
            "R",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "I",
            "d",
            "D",
            "E",
            "i",
            "e",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $6d01N.default)(StandAloneLocalDayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match, options) {
                var valueCallback = function valueCallback(value) {
                    var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
                    return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
                };
                switch(token){
                    // 3
                    case "c":
                    case "cc":
                        // 03
                        return (0, $ASfFO.mapValue)((0, $ASfFO.parseNDigits)(token.length, dateString), valueCallback);
                    // 3rd
                    case "co":
                        return (0, $ASfFO.mapValue)(match.ordinalNumber(dateString, {
                            unit: "day"
                        }), valueCallback);
                    // Tue
                    case "ccc":
                        return match.day(dateString, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "standalone"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // T
                    case "ccccc":
                        return match.day(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // Tu
                    case "cccccc":
                        return match.day(dateString, {
                            width: "short",
                            context: "standalone"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // Tuesday
                    case "cccc":
                    default:
                        return match.day(dateString, {
                            width: "wide",
                            context: "standalone"
                        }) || match.day(dateString, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "standalone"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, $ibQYD.default)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneLocalDayParser;
}((0, $4uOoB.Parser));

});

parcelRegister("j7aNS", function(module, exports) {

$parcel$export(module.exports, "ISODayParser", function () { return $dea70d17d8410f16$export$693fb1e525095b2a; });

var $7bxB9 = parcelRequire("7bxB9");

var $6d01N = parcelRequire("6d01N");

var $k7KFa = parcelRequire("k7KFa");

var $11RWQ = parcelRequire("11RWQ");

var $f2A3W = parcelRequire("f2A3W");

var $dPXH7 = parcelRequire("dPXH7");

var $4uOoB = parcelRequire("4uOoB");

var $ASfFO = parcelRequire("ASfFO");

var $idJuT = parcelRequire("idJuT");
var $dea70d17d8410f16$export$693fb1e525095b2a = /*#__PURE__*/ function(_Parser) {
    (0, $11RWQ.default)(ISODayParser, _Parser);
    var _super = (0, $f2A3W.default)(ISODayParser);
    function ISODayParser() {
        var _this;
        (0, $7bxB9.default)(this, ISODayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $dPXH7.default)((0, $k7KFa.default)(_this), "priority", 90);
        (0, $dPXH7.default)((0, $k7KFa.default)(_this), "incompatibleTokens", [
            "y",
            "Y",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "w",
            "d",
            "D",
            "E",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $6d01N.default)(ISODayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    if (value === 0) return 7;
                    return value;
                };
                switch(token){
                    // 2
                    case "i":
                    case "ii":
                        // 02
                        return (0, $ASfFO.parseNDigits)(token.length, dateString);
                    // 2nd
                    case "io":
                        return match.ordinalNumber(dateString, {
                            unit: "day"
                        });
                    // Tue
                    case "iii":
                        return (0, $ASfFO.mapValue)(match.day(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        }), valueCallback);
                    // T
                    case "iiiii":
                        return (0, $ASfFO.mapValue)(match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        }), valueCallback);
                    // Tu
                    case "iiiiii":
                        return (0, $ASfFO.mapValue)(match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        }), valueCallback);
                    // Tuesday
                    case "iiii":
                    default:
                        return (0, $ASfFO.mapValue)(match.day(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        }), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 7;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date = (0, $idJuT.default)(date, value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return ISODayParser;
}((0, $4uOoB.Parser));

});
parcelRegister("idJuT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d43cbbb9266da81e$export$2e2bcd8739ae039; });

var $j2DA4 = parcelRequire("j2DA4");

var $1BahA = parcelRequire("1BahA");

var $hkULo = parcelRequire("hkULo");
function $d43cbbb9266da81e$export$2e2bcd8739ae039(dirtyDate, dirtyDay) {
    (0, $1BahA.default)(2, arguments);
    var day = (0, $hkULo.default)(dirtyDay);
    if (day % 7 === 0) day = day - 7;
    var weekStartsOn = 1;
    var date = (0, $j2DA4.default)(dirtyDate);
    var currentDay = date.getUTCDay();
    var remainder = day % 7;
    var dayIndex = (remainder + 7) % 7;
    var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}

});


parcelRegister("33HbA", function(module, exports) {

$parcel$export(module.exports, "AMPMParser", function () { return $23a326b3de64ad4d$export$8d1e08492351df91; });

var $7bxB9 = parcelRequire("7bxB9");

var $6d01N = parcelRequire("6d01N");

var $k7KFa = parcelRequire("k7KFa");

var $11RWQ = parcelRequire("11RWQ");

var $f2A3W = parcelRequire("f2A3W");

var $dPXH7 = parcelRequire("dPXH7");

var $4uOoB = parcelRequire("4uOoB");

var $ASfFO = parcelRequire("ASfFO");
var $23a326b3de64ad4d$export$8d1e08492351df91 = /*#__PURE__*/ function(_Parser) {
    (0, $11RWQ.default)(AMPMParser, _Parser);
    var _super = (0, $f2A3W.default)(AMPMParser);
    function AMPMParser() {
        var _this;
        (0, $7bxB9.default)(this, AMPMParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $dPXH7.default)((0, $k7KFa.default)(_this), "priority", 80);
        (0, $dPXH7.default)((0, $k7KFa.default)(_this), "incompatibleTokens", [
            "b",
            "B",
            "H",
            "k",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $6d01N.default)(AMPMParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "a":
                    case "aa":
                    case "aaa":
                        return match.dayPeriod(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "aaaaa":
                        return match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "aaaa":
                    default:
                        return match.dayPeriod(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, $ASfFO.dayPeriodEnumToHours)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return AMPMParser;
}((0, $4uOoB.Parser));

});

parcelRegister("8i39i", function(module, exports) {

$parcel$export(module.exports, "AMPMMidnightParser", function () { return $6092727fdcc38b8f$export$73ca2bd0a17d273; });

var $7bxB9 = parcelRequire("7bxB9");

var $6d01N = parcelRequire("6d01N");

var $k7KFa = parcelRequire("k7KFa");

var $11RWQ = parcelRequire("11RWQ");

var $f2A3W = parcelRequire("f2A3W");

var $dPXH7 = parcelRequire("dPXH7");

var $4uOoB = parcelRequire("4uOoB");

var $ASfFO = parcelRequire("ASfFO");
var $6092727fdcc38b8f$export$73ca2bd0a17d273 = /*#__PURE__*/ function(_Parser) {
    (0, $11RWQ.default)(AMPMMidnightParser, _Parser);
    var _super = (0, $f2A3W.default)(AMPMMidnightParser);
    function AMPMMidnightParser() {
        var _this;
        (0, $7bxB9.default)(this, AMPMMidnightParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $dPXH7.default)((0, $k7KFa.default)(_this), "priority", 80);
        (0, $dPXH7.default)((0, $k7KFa.default)(_this), "incompatibleTokens", [
            "a",
            "B",
            "H",
            "k",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $6d01N.default)(AMPMMidnightParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "b":
                    case "bb":
                    case "bbb":
                        return match.dayPeriod(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "bbbbb":
                        return match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "bbbb":
                    default:
                        return match.dayPeriod(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, $ASfFO.dayPeriodEnumToHours)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return AMPMMidnightParser;
}((0, $4uOoB.Parser));

});

parcelRegister("eXXBv", function(module, exports) {

$parcel$export(module.exports, "DayPeriodParser", function () { return $ae54cf7e82a1a4cf$export$bb9212adf05373db; });

var $7bxB9 = parcelRequire("7bxB9");

var $6d01N = parcelRequire("6d01N");

var $k7KFa = parcelRequire("k7KFa");

var $11RWQ = parcelRequire("11RWQ");

var $f2A3W = parcelRequire("f2A3W");

var $dPXH7 = parcelRequire("dPXH7");

var $4uOoB = parcelRequire("4uOoB");

var $ASfFO = parcelRequire("ASfFO");
var $ae54cf7e82a1a4cf$export$bb9212adf05373db = /*#__PURE__*/ function(_Parser) {
    (0, $11RWQ.default)(DayPeriodParser, _Parser);
    var _super = (0, $f2A3W.default)(DayPeriodParser);
    function DayPeriodParser() {
        var _this;
        (0, $7bxB9.default)(this, DayPeriodParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $dPXH7.default)((0, $k7KFa.default)(_this), "priority", 80);
        (0, $dPXH7.default)((0, $k7KFa.default)(_this), "incompatibleTokens", [
            "a",
            "b",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $6d01N.default)(DayPeriodParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "B":
                    case "BB":
                    case "BBB":
                        return match.dayPeriod(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "BBBBB":
                        return match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "BBBB":
                    default:
                        return match.dayPeriod(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, $ASfFO.dayPeriodEnumToHours)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayPeriodParser;
}((0, $4uOoB.Parser));

});

parcelRegister("lfTyN", function(module, exports) {

$parcel$export(module.exports, "Hour1to12Parser", function () { return $f79618cdec999f94$export$8a04050a727a1756; });

var $7bxB9 = parcelRequire("7bxB9");

var $6d01N = parcelRequire("6d01N");

var $k7KFa = parcelRequire("k7KFa");

var $11RWQ = parcelRequire("11RWQ");

var $f2A3W = parcelRequire("f2A3W");

var $dPXH7 = parcelRequire("dPXH7");

var $4uOoB = parcelRequire("4uOoB");

var $kaekb = parcelRequire("kaekb");

var $ASfFO = parcelRequire("ASfFO");
var $f79618cdec999f94$export$8a04050a727a1756 = /*#__PURE__*/ function(_Parser) {
    (0, $11RWQ.default)(Hour1to12Parser, _Parser);
    var _super = (0, $f2A3W.default)(Hour1to12Parser);
    function Hour1to12Parser() {
        var _this;
        (0, $7bxB9.default)(this, Hour1to12Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $dPXH7.default)((0, $k7KFa.default)(_this), "priority", 70);
        (0, $dPXH7.default)((0, $k7KFa.default)(_this), "incompatibleTokens", [
            "H",
            "K",
            "k",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $6d01N.default)(Hour1to12Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "h":
                        return (0, $ASfFO.parseNumericPattern)((0, $kaekb.numericPatterns).hour12h, dateString);
                    case "ho":
                        return match.ordinalNumber(dateString, {
                            unit: "hour"
                        });
                    default:
                        return (0, $ASfFO.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 12;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var isPM = date.getUTCHours() >= 12;
                if (isPM && value < 12) date.setUTCHours(value + 12, 0, 0, 0);
                else if (!isPM && value === 12) date.setUTCHours(0, 0, 0, 0);
                else date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour1to12Parser;
}((0, $4uOoB.Parser));

});

parcelRegister("51hYf", function(module, exports) {

$parcel$export(module.exports, "Hour0to23Parser", function () { return $3a7afc5b01ec7b27$export$e56f4dea2c3e56dd; });

var $7bxB9 = parcelRequire("7bxB9");

var $6d01N = parcelRequire("6d01N");

var $k7KFa = parcelRequire("k7KFa");

var $11RWQ = parcelRequire("11RWQ");

var $f2A3W = parcelRequire("f2A3W");

var $dPXH7 = parcelRequire("dPXH7");

var $4uOoB = parcelRequire("4uOoB");

var $kaekb = parcelRequire("kaekb");

var $ASfFO = parcelRequire("ASfFO");
var $3a7afc5b01ec7b27$export$e56f4dea2c3e56dd = /*#__PURE__*/ function(_Parser) {
    (0, $11RWQ.default)(Hour0to23Parser, _Parser);
    var _super = (0, $f2A3W.default)(Hour0to23Parser);
    function Hour0to23Parser() {
        var _this;
        (0, $7bxB9.default)(this, Hour0to23Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $dPXH7.default)((0, $k7KFa.default)(_this), "priority", 70);
        (0, $dPXH7.default)((0, $k7KFa.default)(_this), "incompatibleTokens", [
            "a",
            "b",
            "h",
            "K",
            "k",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $6d01N.default)(Hour0to23Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "H":
                        return (0, $ASfFO.parseNumericPattern)((0, $kaekb.numericPatterns).hour23h, dateString);
                    case "Ho":
                        return match.ordinalNumber(dateString, {
                            unit: "hour"
                        });
                    default:
                        return (0, $ASfFO.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 23;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour0to23Parser;
}((0, $4uOoB.Parser));

});

parcelRegister("6fdZG", function(module, exports) {

$parcel$export(module.exports, "Hour0To11Parser", function () { return $48beffaa49deb4ef$export$cbbe855312f87d77; });

var $7bxB9 = parcelRequire("7bxB9");

var $6d01N = parcelRequire("6d01N");

var $k7KFa = parcelRequire("k7KFa");

var $11RWQ = parcelRequire("11RWQ");

var $f2A3W = parcelRequire("f2A3W");

var $dPXH7 = parcelRequire("dPXH7");

var $4uOoB = parcelRequire("4uOoB");

var $kaekb = parcelRequire("kaekb");

var $ASfFO = parcelRequire("ASfFO");
var $48beffaa49deb4ef$export$cbbe855312f87d77 = /*#__PURE__*/ function(_Parser) {
    (0, $11RWQ.default)(Hour0To11Parser, _Parser);
    var _super = (0, $f2A3W.default)(Hour0To11Parser);
    function Hour0To11Parser() {
        var _this;
        (0, $7bxB9.default)(this, Hour0To11Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $dPXH7.default)((0, $k7KFa.default)(_this), "priority", 70);
        (0, $dPXH7.default)((0, $k7KFa.default)(_this), "incompatibleTokens", [
            "h",
            "H",
            "k",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $6d01N.default)(Hour0To11Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "K":
                        return (0, $ASfFO.parseNumericPattern)((0, $kaekb.numericPatterns).hour11h, dateString);
                    case "Ko":
                        return match.ordinalNumber(dateString, {
                            unit: "hour"
                        });
                    default:
                        return (0, $ASfFO.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var isPM = date.getUTCHours() >= 12;
                if (isPM && value < 12) date.setUTCHours(value + 12, 0, 0, 0);
                else date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour0To11Parser;
}((0, $4uOoB.Parser));

});

parcelRegister("hI6v8", function(module, exports) {

$parcel$export(module.exports, "Hour1To24Parser", function () { return $ce4b96bbefc00a6f$export$6008046d2b34b6a5; });

var $7bxB9 = parcelRequire("7bxB9");

var $6d01N = parcelRequire("6d01N");

var $k7KFa = parcelRequire("k7KFa");

var $11RWQ = parcelRequire("11RWQ");

var $f2A3W = parcelRequire("f2A3W");

var $dPXH7 = parcelRequire("dPXH7");

var $4uOoB = parcelRequire("4uOoB");

var $kaekb = parcelRequire("kaekb");

var $ASfFO = parcelRequire("ASfFO");
var $ce4b96bbefc00a6f$export$6008046d2b34b6a5 = /*#__PURE__*/ function(_Parser) {
    (0, $11RWQ.default)(Hour1To24Parser, _Parser);
    var _super = (0, $f2A3W.default)(Hour1To24Parser);
    function Hour1To24Parser() {
        var _this;
        (0, $7bxB9.default)(this, Hour1To24Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $dPXH7.default)((0, $k7KFa.default)(_this), "priority", 70);
        (0, $dPXH7.default)((0, $k7KFa.default)(_this), "incompatibleTokens", [
            "a",
            "b",
            "h",
            "H",
            "K",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $6d01N.default)(Hour1To24Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "k":
                        return (0, $ASfFO.parseNumericPattern)((0, $kaekb.numericPatterns).hour24h, dateString);
                    case "ko":
                        return match.ordinalNumber(dateString, {
                            unit: "hour"
                        });
                    default:
                        return (0, $ASfFO.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 24;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var hours = value <= 24 ? value % 24 : value;
                date.setUTCHours(hours, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour1To24Parser;
}((0, $4uOoB.Parser));

});

parcelRegister("4ZvMw", function(module, exports) {

$parcel$export(module.exports, "MinuteParser", function () { return $3a258315cdebcb08$export$2b52670d9e2be53; });

var $7bxB9 = parcelRequire("7bxB9");

var $6d01N = parcelRequire("6d01N");

var $k7KFa = parcelRequire("k7KFa");

var $11RWQ = parcelRequire("11RWQ");

var $f2A3W = parcelRequire("f2A3W");

var $dPXH7 = parcelRequire("dPXH7");

var $4uOoB = parcelRequire("4uOoB");

var $kaekb = parcelRequire("kaekb");

var $ASfFO = parcelRequire("ASfFO");
var $3a258315cdebcb08$export$2b52670d9e2be53 = /*#__PURE__*/ function(_Parser) {
    (0, $11RWQ.default)(MinuteParser, _Parser);
    var _super = (0, $f2A3W.default)(MinuteParser);
    function MinuteParser() {
        var _this;
        (0, $7bxB9.default)(this, MinuteParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $dPXH7.default)((0, $k7KFa.default)(_this), "priority", 60);
        (0, $dPXH7.default)((0, $k7KFa.default)(_this), "incompatibleTokens", [
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $6d01N.default)(MinuteParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "m":
                        return (0, $ASfFO.parseNumericPattern)((0, $kaekb.numericPatterns).minute, dateString);
                    case "mo":
                        return match.ordinalNumber(dateString, {
                            unit: "minute"
                        });
                    default:
                        return (0, $ASfFO.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 59;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMinutes(value, 0, 0);
                return date;
            }
        }
    ]);
    return MinuteParser;
}((0, $4uOoB.Parser));

});

parcelRegister("f2DrF", function(module, exports) {

$parcel$export(module.exports, "SecondParser", function () { return $af35a3e782835078$export$94d46d540cf1366a; });

var $7bxB9 = parcelRequire("7bxB9");

var $6d01N = parcelRequire("6d01N");

var $k7KFa = parcelRequire("k7KFa");

var $11RWQ = parcelRequire("11RWQ");

var $f2A3W = parcelRequire("f2A3W");

var $dPXH7 = parcelRequire("dPXH7");

var $4uOoB = parcelRequire("4uOoB");

var $kaekb = parcelRequire("kaekb");

var $ASfFO = parcelRequire("ASfFO");
var $af35a3e782835078$export$94d46d540cf1366a = /*#__PURE__*/ function(_Parser) {
    (0, $11RWQ.default)(SecondParser, _Parser);
    var _super = (0, $f2A3W.default)(SecondParser);
    function SecondParser() {
        var _this;
        (0, $7bxB9.default)(this, SecondParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $dPXH7.default)((0, $k7KFa.default)(_this), "priority", 50);
        (0, $dPXH7.default)((0, $k7KFa.default)(_this), "incompatibleTokens", [
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $6d01N.default)(SecondParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "s":
                        return (0, $ASfFO.parseNumericPattern)((0, $kaekb.numericPatterns).second, dateString);
                    case "so":
                        return match.ordinalNumber(dateString, {
                            unit: "second"
                        });
                    default:
                        return (0, $ASfFO.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 59;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCSeconds(value, 0);
                return date;
            }
        }
    ]);
    return SecondParser;
}((0, $4uOoB.Parser));

});

parcelRegister("2BnLa", function(module, exports) {

$parcel$export(module.exports, "FractionOfSecondParser", function () { return $1e5177ae0262393a$export$b8e6f8b2d70893b1; });

var $7bxB9 = parcelRequire("7bxB9");

var $6d01N = parcelRequire("6d01N");

var $k7KFa = parcelRequire("k7KFa");

var $11RWQ = parcelRequire("11RWQ");

var $f2A3W = parcelRequire("f2A3W");

var $dPXH7 = parcelRequire("dPXH7");

var $4uOoB = parcelRequire("4uOoB");

var $ASfFO = parcelRequire("ASfFO");
var $1e5177ae0262393a$export$b8e6f8b2d70893b1 = /*#__PURE__*/ function(_Parser) {
    (0, $11RWQ.default)(FractionOfSecondParser, _Parser);
    var _super = (0, $f2A3W.default)(FractionOfSecondParser);
    function FractionOfSecondParser() {
        var _this;
        (0, $7bxB9.default)(this, FractionOfSecondParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $dPXH7.default)((0, $k7KFa.default)(_this), "priority", 30);
        (0, $dPXH7.default)((0, $k7KFa.default)(_this), "incompatibleTokens", [
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $6d01N.default)(FractionOfSecondParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                var valueCallback = function valueCallback(value) {
                    return Math.floor(value * Math.pow(10, -token.length + 3));
                };
                return (0, $ASfFO.mapValue)((0, $ASfFO.parseNDigits)(token.length, dateString), valueCallback);
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMilliseconds(value);
                return date;
            }
        }
    ]);
    return FractionOfSecondParser;
}((0, $4uOoB.Parser));

});

parcelRegister("axbcL", function(module, exports) {

$parcel$export(module.exports, "ISOTimezoneWithZParser", function () { return $7ab5ad8742d0d497$export$104d901d49fea29b; });

var $7bxB9 = parcelRequire("7bxB9");

var $6d01N = parcelRequire("6d01N");

var $k7KFa = parcelRequire("k7KFa");

var $11RWQ = parcelRequire("11RWQ");

var $f2A3W = parcelRequire("f2A3W");

var $dPXH7 = parcelRequire("dPXH7");

var $4uOoB = parcelRequire("4uOoB");

var $kaekb = parcelRequire("kaekb");

var $ASfFO = parcelRequire("ASfFO");
var $7ab5ad8742d0d497$export$104d901d49fea29b = /*#__PURE__*/ function(_Parser) {
    (0, $11RWQ.default)(ISOTimezoneWithZParser, _Parser);
    var _super = (0, $f2A3W.default)(ISOTimezoneWithZParser);
    function ISOTimezoneWithZParser() {
        var _this;
        (0, $7bxB9.default)(this, ISOTimezoneWithZParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $dPXH7.default)((0, $k7KFa.default)(_this), "priority", 10);
        (0, $dPXH7.default)((0, $k7KFa.default)(_this), "incompatibleTokens", [
            "t",
            "T",
            "x"
        ]);
        return _this;
    }
    (0, $6d01N.default)(ISOTimezoneWithZParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                switch(token){
                    case "X":
                        return (0, $ASfFO.parseTimezonePattern)((0, $kaekb.timezonePatterns).basicOptionalMinutes, dateString);
                    case "XX":
                        return (0, $ASfFO.parseTimezonePattern)((0, $kaekb.timezonePatterns).basic, dateString);
                    case "XXXX":
                        return (0, $ASfFO.parseTimezonePattern)((0, $kaekb.timezonePatterns).basicOptionalSeconds, dateString);
                    case "XXXXX":
                        return (0, $ASfFO.parseTimezonePattern)((0, $kaekb.timezonePatterns).extendedOptionalSeconds, dateString);
                    case "XXX":
                    default:
                        return (0, $ASfFO.parseTimezonePattern)((0, $kaekb.timezonePatterns).extended, dateString);
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                if (flags.timestampIsSet) return date;
                return new Date(date.getTime() - value);
            }
        }
    ]);
    return ISOTimezoneWithZParser;
}((0, $4uOoB.Parser));

});

parcelRegister("264rY", function(module, exports) {

$parcel$export(module.exports, "ISOTimezoneParser", function () { return $186f980b829f28f9$export$12910e5204b52b9; });

var $7bxB9 = parcelRequire("7bxB9");

var $6d01N = parcelRequire("6d01N");

var $k7KFa = parcelRequire("k7KFa");

var $11RWQ = parcelRequire("11RWQ");

var $f2A3W = parcelRequire("f2A3W");

var $dPXH7 = parcelRequire("dPXH7");

var $4uOoB = parcelRequire("4uOoB");

var $kaekb = parcelRequire("kaekb");

var $ASfFO = parcelRequire("ASfFO");
var $186f980b829f28f9$export$12910e5204b52b9 = /*#__PURE__*/ function(_Parser) {
    (0, $11RWQ.default)(ISOTimezoneParser, _Parser);
    var _super = (0, $f2A3W.default)(ISOTimezoneParser);
    function ISOTimezoneParser() {
        var _this;
        (0, $7bxB9.default)(this, ISOTimezoneParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $dPXH7.default)((0, $k7KFa.default)(_this), "priority", 10);
        (0, $dPXH7.default)((0, $k7KFa.default)(_this), "incompatibleTokens", [
            "t",
            "T",
            "X"
        ]);
        return _this;
    }
    (0, $6d01N.default)(ISOTimezoneParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                switch(token){
                    case "x":
                        return (0, $ASfFO.parseTimezonePattern)((0, $kaekb.timezonePatterns).basicOptionalMinutes, dateString);
                    case "xx":
                        return (0, $ASfFO.parseTimezonePattern)((0, $kaekb.timezonePatterns).basic, dateString);
                    case "xxxx":
                        return (0, $ASfFO.parseTimezonePattern)((0, $kaekb.timezonePatterns).basicOptionalSeconds, dateString);
                    case "xxxxx":
                        return (0, $ASfFO.parseTimezonePattern)((0, $kaekb.timezonePatterns).extendedOptionalSeconds, dateString);
                    case "xxx":
                    default:
                        return (0, $ASfFO.parseTimezonePattern)((0, $kaekb.timezonePatterns).extended, dateString);
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                if (flags.timestampIsSet) return date;
                return new Date(date.getTime() - value);
            }
        }
    ]);
    return ISOTimezoneParser;
}((0, $4uOoB.Parser));

});

parcelRegister("fUVYu", function(module, exports) {

$parcel$export(module.exports, "TimestampSecondsParser", function () { return $b9690e851888ff28$export$2cd8bf877a05e96; });

var $7bxB9 = parcelRequire("7bxB9");

var $6d01N = parcelRequire("6d01N");

var $k7KFa = parcelRequire("k7KFa");

var $11RWQ = parcelRequire("11RWQ");

var $f2A3W = parcelRequire("f2A3W");

var $dPXH7 = parcelRequire("dPXH7");

var $4uOoB = parcelRequire("4uOoB");

var $ASfFO = parcelRequire("ASfFO");
var $b9690e851888ff28$export$2cd8bf877a05e96 = /*#__PURE__*/ function(_Parser) {
    (0, $11RWQ.default)(TimestampSecondsParser, _Parser);
    var _super = (0, $f2A3W.default)(TimestampSecondsParser);
    function TimestampSecondsParser() {
        var _this;
        (0, $7bxB9.default)(this, TimestampSecondsParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $dPXH7.default)((0, $k7KFa.default)(_this), "priority", 40);
        (0, $dPXH7.default)((0, $k7KFa.default)(_this), "incompatibleTokens", "*");
        return _this;
    }
    (0, $6d01N.default)(TimestampSecondsParser, [
        {
            key: "parse",
            value: function parse(dateString) {
                return (0, $ASfFO.parseAnyDigitsSigned)(dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                return [
                    new Date(value * 1000),
                    {
                        timestampIsSet: true
                    }
                ];
            }
        }
    ]);
    return TimestampSecondsParser;
}((0, $4uOoB.Parser));

});

parcelRegister("gscNR", function(module, exports) {

$parcel$export(module.exports, "TimestampMillisecondsParser", function () { return $bfa9314ee5bd2735$export$6d8f69c6906d6368; });

var $7bxB9 = parcelRequire("7bxB9");

var $6d01N = parcelRequire("6d01N");

var $k7KFa = parcelRequire("k7KFa");

var $11RWQ = parcelRequire("11RWQ");

var $f2A3W = parcelRequire("f2A3W");

var $dPXH7 = parcelRequire("dPXH7");

var $4uOoB = parcelRequire("4uOoB");

var $ASfFO = parcelRequire("ASfFO");
var $bfa9314ee5bd2735$export$6d8f69c6906d6368 = /*#__PURE__*/ function(_Parser) {
    (0, $11RWQ.default)(TimestampMillisecondsParser, _Parser);
    var _super = (0, $f2A3W.default)(TimestampMillisecondsParser);
    function TimestampMillisecondsParser() {
        var _this;
        (0, $7bxB9.default)(this, TimestampMillisecondsParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $dPXH7.default)((0, $k7KFa.default)(_this), "priority", 20);
        (0, $dPXH7.default)((0, $k7KFa.default)(_this), "incompatibleTokens", "*");
        return _this;
    }
    (0, $6d01N.default)(TimestampMillisecondsParser, [
        {
            key: "parse",
            value: function parse(dateString) {
                return (0, $ASfFO.parseAnyDigitsSigned)(dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                return [
                    new Date(value),
                    {
                        timestampIsSet: true
                    }
                ];
            }
        }
    ]);
    return TimestampMillisecondsParser;
}((0, $4uOoB.Parser));

});




parcelRegister("aXWPy", function(module, exports) {
module.exports = class IntercomTransformer {
    transform() {
        const email = this.contact.email || "";
        const classification = email.length > 0 || this.contact.last_replied_at ? "Lead" : "Visitor";
        return {
            classification: classification,
            email: email,
            identifier: email.length > 0 ? email : this.contact.id,
            name: this.contact.name,
            createdAt: typeof this.contact.created_at == "string" ? new Date(this.contact.created_at) : new Date(this.contact.created_at * 1000)
        };
    }
    constructor(contact){
        this.contact = contact;
    }
};

});

parcelRegister("iyilw", function(module, exports) {
module.exports = class StripeTransformer {
    transform() {
        return {
            classification: "User",
            email: this.customer.email,
            identifier: this.customer.email,
            name: this.customer.name,
            createdAt: new Date(this.customer.created * 1000)
        };
    }
    constructor(customer){
        this.customer = customer;
    }
};

});


parcelRegister("hF8pm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cdbcc9ad1e75b0c5$var$_react = $cdbcc9ad1e75b0c5$var$_interopRequireWildcard((parcelRequire("b6HlZ")));

var $cdbcc9ad1e75b0c5$var$_reactEasySwipe = $cdbcc9ad1e75b0c5$var$_interopRequireDefault((parcelRequire("ems6E")));

var $cdbcc9ad1e75b0c5$var$_cssClasses = $cdbcc9ad1e75b0c5$var$_interopRequireDefault((parcelRequire("2roV5")));

var $cdbcc9ad1e75b0c5$var$_Thumbs = $cdbcc9ad1e75b0c5$var$_interopRequireDefault((parcelRequire("lRg1u")));

var $cdbcc9ad1e75b0c5$var$_document = $cdbcc9ad1e75b0c5$var$_interopRequireDefault((parcelRequire("lzGH4")));

var $cdbcc9ad1e75b0c5$var$_window = $cdbcc9ad1e75b0c5$var$_interopRequireDefault((parcelRequire("2VKi9")));

var $c4AIV = parcelRequire("c4AIV");

var $aGBOI = parcelRequire("aGBOI");
function $cdbcc9ad1e75b0c5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $cdbcc9ad1e75b0c5$var$_getRequireWildcardCache() {
    if (typeof WeakMap !== "function") return null;
    var cache = new WeakMap();
    $cdbcc9ad1e75b0c5$var$_getRequireWildcardCache = function _getRequireWildcardCache() {
        return cache;
    };
    return cache;
}
function $cdbcc9ad1e75b0c5$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    if (obj === null || $cdbcc9ad1e75b0c5$var$_typeof(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $cdbcc9ad1e75b0c5$var$_getRequireWildcardCache();
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $cdbcc9ad1e75b0c5$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $cdbcc9ad1e75b0c5$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $cdbcc9ad1e75b0c5$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $cdbcc9ad1e75b0c5$var$_typeof(obj);
}
function $cdbcc9ad1e75b0c5$var$_extends() {
    $cdbcc9ad1e75b0c5$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $cdbcc9ad1e75b0c5$var$_extends.apply(this, arguments);
}
function $cdbcc9ad1e75b0c5$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $cdbcc9ad1e75b0c5$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $cdbcc9ad1e75b0c5$var$ownKeys(Object(source), true).forEach(function(key) {
            $cdbcc9ad1e75b0c5$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $cdbcc9ad1e75b0c5$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $cdbcc9ad1e75b0c5$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $cdbcc9ad1e75b0c5$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $cdbcc9ad1e75b0c5$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $cdbcc9ad1e75b0c5$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $cdbcc9ad1e75b0c5$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $cdbcc9ad1e75b0c5$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $cdbcc9ad1e75b0c5$var$_setPrototypeOf(subClass, superClass);
}
function $cdbcc9ad1e75b0c5$var$_setPrototypeOf(o, p) {
    $cdbcc9ad1e75b0c5$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $cdbcc9ad1e75b0c5$var$_setPrototypeOf(o, p);
}
function $cdbcc9ad1e75b0c5$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $cdbcc9ad1e75b0c5$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $cdbcc9ad1e75b0c5$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $cdbcc9ad1e75b0c5$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $cdbcc9ad1e75b0c5$var$_possibleConstructorReturn(this, result);
    };
}
function $cdbcc9ad1e75b0c5$var$_possibleConstructorReturn(self, call) {
    if (call && ($cdbcc9ad1e75b0c5$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $cdbcc9ad1e75b0c5$var$_assertThisInitialized(self);
}
function $cdbcc9ad1e75b0c5$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $cdbcc9ad1e75b0c5$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $cdbcc9ad1e75b0c5$var$_getPrototypeOf(o) {
    $cdbcc9ad1e75b0c5$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $cdbcc9ad1e75b0c5$var$_getPrototypeOf(o);
}
function $cdbcc9ad1e75b0c5$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $cdbcc9ad1e75b0c5$var$Carousel = /*#__PURE__*/ function(_React$Component) {
    $cdbcc9ad1e75b0c5$var$_inherits(Carousel, _React$Component);
    var _super = $cdbcc9ad1e75b0c5$var$_createSuper(Carousel);
    // @ts-ignore
    function Carousel(props) {
        var _this;
        $cdbcc9ad1e75b0c5$var$_classCallCheck(this, Carousel);
        _this = _super.call(this, props);
        $cdbcc9ad1e75b0c5$var$_defineProperty($cdbcc9ad1e75b0c5$var$_assertThisInitialized(_this), "thumbsRef", void 0);
        $cdbcc9ad1e75b0c5$var$_defineProperty($cdbcc9ad1e75b0c5$var$_assertThisInitialized(_this), "carouselWrapperRef", void 0);
        $cdbcc9ad1e75b0c5$var$_defineProperty($cdbcc9ad1e75b0c5$var$_assertThisInitialized(_this), "listRef", void 0);
        $cdbcc9ad1e75b0c5$var$_defineProperty($cdbcc9ad1e75b0c5$var$_assertThisInitialized(_this), "itemsRef", void 0);
        $cdbcc9ad1e75b0c5$var$_defineProperty($cdbcc9ad1e75b0c5$var$_assertThisInitialized(_this), "timer", void 0);
        $cdbcc9ad1e75b0c5$var$_defineProperty($cdbcc9ad1e75b0c5$var$_assertThisInitialized(_this), "animationHandler", void 0);
        $cdbcc9ad1e75b0c5$var$_defineProperty($cdbcc9ad1e75b0c5$var$_assertThisInitialized(_this), "setThumbsRef", function(node) {
            _this.thumbsRef = node;
        });
        $cdbcc9ad1e75b0c5$var$_defineProperty($cdbcc9ad1e75b0c5$var$_assertThisInitialized(_this), "setCarouselWrapperRef", function(node) {
            _this.carouselWrapperRef = node;
        });
        $cdbcc9ad1e75b0c5$var$_defineProperty($cdbcc9ad1e75b0c5$var$_assertThisInitialized(_this), "setListRef", function(node) {
            _this.listRef = node;
        });
        $cdbcc9ad1e75b0c5$var$_defineProperty($cdbcc9ad1e75b0c5$var$_assertThisInitialized(_this), "setItemsRef", function(node, index) {
            if (!_this.itemsRef) _this.itemsRef = [];
            _this.itemsRef[index] = node;
        });
        $cdbcc9ad1e75b0c5$var$_defineProperty($cdbcc9ad1e75b0c5$var$_assertThisInitialized(_this), "autoPlay", function() {
            if ($cdbcc9ad1e75b0c5$var$_react.Children.count(_this.props.children) <= 1) return;
            _this.clearAutoPlay();
            if (!_this.props.autoPlay) return;
            _this.timer = setTimeout(function() {
                _this.increment();
            }, _this.props.interval);
        });
        $cdbcc9ad1e75b0c5$var$_defineProperty($cdbcc9ad1e75b0c5$var$_assertThisInitialized(_this), "clearAutoPlay", function() {
            if (_this.timer) clearTimeout(_this.timer);
        });
        $cdbcc9ad1e75b0c5$var$_defineProperty($cdbcc9ad1e75b0c5$var$_assertThisInitialized(_this), "resetAutoPlay", function() {
            _this.clearAutoPlay();
            _this.autoPlay();
        });
        $cdbcc9ad1e75b0c5$var$_defineProperty($cdbcc9ad1e75b0c5$var$_assertThisInitialized(_this), "stopOnHover", function() {
            _this.setState({
                isMouseEntered: true
            }, _this.clearAutoPlay);
        });
        $cdbcc9ad1e75b0c5$var$_defineProperty($cdbcc9ad1e75b0c5$var$_assertThisInitialized(_this), "startOnLeave", function() {
            _this.setState({
                isMouseEntered: false
            }, _this.autoPlay);
        });
        $cdbcc9ad1e75b0c5$var$_defineProperty($cdbcc9ad1e75b0c5$var$_assertThisInitialized(_this), "isFocusWithinTheCarousel", function() {
            if (!_this.carouselWrapperRef) return false;
            if ((0, $cdbcc9ad1e75b0c5$var$_document.default)().activeElement === _this.carouselWrapperRef || _this.carouselWrapperRef.contains((0, $cdbcc9ad1e75b0c5$var$_document.default)().activeElement)) return true;
            return false;
        });
        $cdbcc9ad1e75b0c5$var$_defineProperty($cdbcc9ad1e75b0c5$var$_assertThisInitialized(_this), "navigateWithKeyboard", function(e) {
            if (!_this.isFocusWithinTheCarousel()) return;
            var axis = _this.props.axis;
            var isHorizontal = axis === "horizontal";
            var keyNames = {
                ArrowUp: 38,
                ArrowRight: 39,
                ArrowDown: 40,
                ArrowLeft: 37
            };
            var nextKey = isHorizontal ? keyNames.ArrowRight : keyNames.ArrowDown;
            var prevKey = isHorizontal ? keyNames.ArrowLeft : keyNames.ArrowUp;
            if (nextKey === e.keyCode) _this.increment();
            else if (prevKey === e.keyCode) _this.decrement();
        });
        $cdbcc9ad1e75b0c5$var$_defineProperty($cdbcc9ad1e75b0c5$var$_assertThisInitialized(_this), "updateSizes", function() {
            if (!_this.state.initialized || !_this.itemsRef || _this.itemsRef.length === 0) return;
            var isHorizontal = _this.props.axis === "horizontal";
            var firstItem = _this.itemsRef[0];
            if (!firstItem) return;
            var itemSize = isHorizontal ? firstItem.clientWidth : firstItem.clientHeight;
            _this.setState({
                itemSize: itemSize
            });
            if (_this.thumbsRef) _this.thumbsRef.updateSizes();
        });
        $cdbcc9ad1e75b0c5$var$_defineProperty($cdbcc9ad1e75b0c5$var$_assertThisInitialized(_this), "setMountState", function() {
            _this.setState({
                hasMount: true
            });
            _this.updateSizes();
        });
        $cdbcc9ad1e75b0c5$var$_defineProperty($cdbcc9ad1e75b0c5$var$_assertThisInitialized(_this), "handleClickItem", function(index, item) {
            if ($cdbcc9ad1e75b0c5$var$_react.Children.count(_this.props.children) === 0) return;
            if (_this.state.cancelClick) {
                _this.setState({
                    cancelClick: false
                });
                return;
            }
            _this.props.onClickItem(index, item);
            if (index !== _this.state.selectedItem) _this.setState({
                selectedItem: index
            });
        });
        $cdbcc9ad1e75b0c5$var$_defineProperty($cdbcc9ad1e75b0c5$var$_assertThisInitialized(_this), "handleOnChange", function(index, item) {
            if ($cdbcc9ad1e75b0c5$var$_react.Children.count(_this.props.children) <= 1) return;
            _this.props.onChange(index, item);
        });
        $cdbcc9ad1e75b0c5$var$_defineProperty($cdbcc9ad1e75b0c5$var$_assertThisInitialized(_this), "handleClickThumb", function(index, item) {
            _this.props.onClickThumb(index, item);
            _this.moveTo(index);
        });
        $cdbcc9ad1e75b0c5$var$_defineProperty($cdbcc9ad1e75b0c5$var$_assertThisInitialized(_this), "onSwipeStart", function(event) {
            _this.setState({
                swiping: true
            });
            _this.props.onSwipeStart(event);
        });
        $cdbcc9ad1e75b0c5$var$_defineProperty($cdbcc9ad1e75b0c5$var$_assertThisInitialized(_this), "onSwipeEnd", function(event) {
            _this.setState({
                swiping: false,
                cancelClick: false,
                swipeMovementStarted: false
            });
            _this.props.onSwipeEnd(event);
            _this.clearAutoPlay();
            if (_this.state.autoPlay) _this.autoPlay();
        });
        $cdbcc9ad1e75b0c5$var$_defineProperty($cdbcc9ad1e75b0c5$var$_assertThisInitialized(_this), "onSwipeMove", function(delta, event) {
            _this.props.onSwipeMove(event);
            var animationHandlerResponse = _this.props.swipeAnimationHandler(delta, _this.props, _this.state, _this.setState.bind($cdbcc9ad1e75b0c5$var$_assertThisInitialized(_this)));
            _this.setState($cdbcc9ad1e75b0c5$var$_objectSpread({}, animationHandlerResponse)); // If we have not moved, we should have an empty object returned
            // Return false to allow scrolling when not swiping
            return !!Object.keys(animationHandlerResponse).length;
        });
        $cdbcc9ad1e75b0c5$var$_defineProperty($cdbcc9ad1e75b0c5$var$_assertThisInitialized(_this), "decrement", function() {
            var positions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
            _this.moveTo(_this.state.selectedItem - (typeof positions === "number" ? positions : 1));
        });
        $cdbcc9ad1e75b0c5$var$_defineProperty($cdbcc9ad1e75b0c5$var$_assertThisInitialized(_this), "increment", function() {
            var positions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
            _this.moveTo(_this.state.selectedItem + (typeof positions === "number" ? positions : 1));
        });
        $cdbcc9ad1e75b0c5$var$_defineProperty($cdbcc9ad1e75b0c5$var$_assertThisInitialized(_this), "moveTo", function(position) {
            if (typeof position !== "number") return;
            var lastPosition = $cdbcc9ad1e75b0c5$var$_react.Children.count(_this.props.children) - 1;
            if (position < 0) position = _this.props.infiniteLoop ? lastPosition : 0;
            if (position > lastPosition) position = _this.props.infiniteLoop ? 0 : lastPosition;
            _this.selectItem({
                // if it's not a slider, we don't need to set position here
                selectedItem: position
            }); // don't reset auto play when stop on hover is enabled, doing so will trigger a call to auto play more than once
            // and will result in the interval function not being cleared correctly.
            if (_this.state.autoPlay && _this.state.isMouseEntered === false) _this.resetAutoPlay();
        });
        $cdbcc9ad1e75b0c5$var$_defineProperty($cdbcc9ad1e75b0c5$var$_assertThisInitialized(_this), "onClickNext", function() {
            _this.increment(1);
        });
        $cdbcc9ad1e75b0c5$var$_defineProperty($cdbcc9ad1e75b0c5$var$_assertThisInitialized(_this), "onClickPrev", function() {
            _this.decrement(1);
        });
        $cdbcc9ad1e75b0c5$var$_defineProperty($cdbcc9ad1e75b0c5$var$_assertThisInitialized(_this), "onSwipeForward", function() {
            _this.increment(1);
            if (_this.props.emulateTouch) _this.setState({
                cancelClick: true
            });
        });
        $cdbcc9ad1e75b0c5$var$_defineProperty($cdbcc9ad1e75b0c5$var$_assertThisInitialized(_this), "onSwipeBackwards", function() {
            _this.decrement(1);
            if (_this.props.emulateTouch) _this.setState({
                cancelClick: true
            });
        });
        $cdbcc9ad1e75b0c5$var$_defineProperty($cdbcc9ad1e75b0c5$var$_assertThisInitialized(_this), "changeItem", function(newIndex) {
            return function(e) {
                if (!(0, $c4AIV.isKeyboardEvent)(e) || e.key === "Enter") _this.moveTo(newIndex);
            };
        });
        $cdbcc9ad1e75b0c5$var$_defineProperty($cdbcc9ad1e75b0c5$var$_assertThisInitialized(_this), "selectItem", function(state) {
            // Merge in the new state while updating updating previous item
            _this.setState($cdbcc9ad1e75b0c5$var$_objectSpread({
                previousItem: _this.state.selectedItem
            }, state), function() {
                // Run animation handler and update styles based on it
                _this.setState(_this.animationHandler(_this.props, _this.state));
            });
            _this.handleOnChange(state.selectedItem, $cdbcc9ad1e75b0c5$var$_react.Children.toArray(_this.props.children)[state.selectedItem]);
        });
        $cdbcc9ad1e75b0c5$var$_defineProperty($cdbcc9ad1e75b0c5$var$_assertThisInitialized(_this), "getInitialImage", function() {
            var selectedItem = _this.props.selectedItem;
            var item = _this.itemsRef && _this.itemsRef[selectedItem];
            var images = item && item.getElementsByTagName("img") || [];
            return images[0];
        });
        $cdbcc9ad1e75b0c5$var$_defineProperty($cdbcc9ad1e75b0c5$var$_assertThisInitialized(_this), "getVariableItemHeight", function(position) {
            var item = _this.itemsRef && _this.itemsRef[position];
            if (_this.state.hasMount && item && item.children.length) {
                var slideImages = item.children[0].getElementsByTagName("img") || [];
                if (slideImages.length > 0) {
                    var image = slideImages[0];
                    if (!image.complete) {
                        // if the image is still loading, the size won't be available so we trigger a new render after it's done
                        var onImageLoad = function onImageLoad() {
                            _this.forceUpdate();
                            image.removeEventListener("load", onImageLoad);
                        };
                        image.addEventListener("load", onImageLoad);
                    }
                } // try to get img first, if img not there find first display tag
                var displayItem = slideImages[0] || item.children[0];
                var height = displayItem.clientHeight;
                return height > 0 ? height : null;
            }
            return null;
        });
        var initState = {
            initialized: false,
            previousItem: props.selectedItem,
            selectedItem: props.selectedItem,
            hasMount: false,
            isMouseEntered: false,
            autoPlay: props.autoPlay,
            swiping: false,
            swipeMovementStarted: false,
            cancelClick: false,
            itemSize: 1,
            itemListStyle: {},
            slideStyle: {},
            selectedStyle: {},
            prevStyle: {}
        };
        _this.animationHandler = typeof props.animationHandler === "function" && props.animationHandler || props.animationHandler === "fade" && $aGBOI.fadeAnimationHandler || $aGBOI.slideAnimationHandler;
        _this.state = $cdbcc9ad1e75b0c5$var$_objectSpread($cdbcc9ad1e75b0c5$var$_objectSpread({}, initState), _this.animationHandler(props, initState));
        return _this;
    }
    $cdbcc9ad1e75b0c5$var$_createClass(Carousel, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                if (!this.props.children) return;
                this.setupCarousel();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps, prevState) {
                if (!prevProps.children && this.props.children && !this.state.initialized) this.setupCarousel();
                if (!prevProps.autoFocus && this.props.autoFocus) this.forceFocus();
                if (prevState.swiping && !this.state.swiping) // We stopped swiping, ensure we are heading to the new/current slide and not stuck
                this.setState($cdbcc9ad1e75b0c5$var$_objectSpread({}, this.props.stopSwipingHandler(this.props, this.state)));
                if (prevProps.selectedItem !== this.props.selectedItem || prevProps.centerMode !== this.props.centerMode) {
                    this.updateSizes();
                    this.moveTo(this.props.selectedItem);
                }
                if (prevProps.autoPlay !== this.props.autoPlay) {
                    if (this.props.autoPlay) this.setupAutoPlay();
                    else this.destroyAutoPlay();
                    this.setState({
                        autoPlay: this.props.autoPlay
                    });
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.destroyCarousel();
            }
        },
        {
            key: "setupCarousel",
            value: function setupCarousel() {
                var _this2 = this;
                this.bindEvents();
                if (this.state.autoPlay && $cdbcc9ad1e75b0c5$var$_react.Children.count(this.props.children) > 1) this.setupAutoPlay();
                if (this.props.autoFocus) this.forceFocus();
                this.setState({
                    initialized: true
                }, function() {
                    var initialImage = _this2.getInitialImage();
                    if (initialImage && !initialImage.complete) // if it's a carousel of images, we set the mount state after the first image is loaded
                    initialImage.addEventListener("load", _this2.setMountState);
                    else _this2.setMountState();
                });
            }
        },
        {
            key: "destroyCarousel",
            value: function destroyCarousel() {
                if (this.state.initialized) {
                    this.unbindEvents();
                    this.destroyAutoPlay();
                }
            }
        },
        {
            key: "setupAutoPlay",
            value: function setupAutoPlay() {
                this.autoPlay();
                var carouselWrapper = this.carouselWrapperRef;
                if (this.props.stopOnHover && carouselWrapper) {
                    carouselWrapper.addEventListener("mouseenter", this.stopOnHover);
                    carouselWrapper.addEventListener("mouseleave", this.startOnLeave);
                }
            }
        },
        {
            key: "destroyAutoPlay",
            value: function destroyAutoPlay() {
                this.clearAutoPlay();
                var carouselWrapper = this.carouselWrapperRef;
                if (this.props.stopOnHover && carouselWrapper) {
                    carouselWrapper.removeEventListener("mouseenter", this.stopOnHover);
                    carouselWrapper.removeEventListener("mouseleave", this.startOnLeave);
                }
            }
        },
        {
            key: "bindEvents",
            value: function bindEvents() {
                // as the widths are calculated, we need to resize
                // the carousel when the window is resized
                (0, $cdbcc9ad1e75b0c5$var$_window.default)().addEventListener("resize", this.updateSizes); // issue #2 - image loading smaller
                (0, $cdbcc9ad1e75b0c5$var$_window.default)().addEventListener("DOMContentLoaded", this.updateSizes);
                if (this.props.useKeyboardArrows) (0, $cdbcc9ad1e75b0c5$var$_document.default)().addEventListener("keydown", this.navigateWithKeyboard);
            }
        },
        {
            key: "unbindEvents",
            value: function unbindEvents() {
                // removing listeners
                (0, $cdbcc9ad1e75b0c5$var$_window.default)().removeEventListener("resize", this.updateSizes);
                (0, $cdbcc9ad1e75b0c5$var$_window.default)().removeEventListener("DOMContentLoaded", this.updateSizes);
                var initialImage = this.getInitialImage();
                if (initialImage) initialImage.removeEventListener("load", this.setMountState);
                if (this.props.useKeyboardArrows) (0, $cdbcc9ad1e75b0c5$var$_document.default)().removeEventListener("keydown", this.navigateWithKeyboard);
            }
        },
        {
            key: "forceFocus",
            value: function forceFocus() {
                var _this$carouselWrapper;
                (_this$carouselWrapper = this.carouselWrapperRef) === null || _this$carouselWrapper === void 0 || _this$carouselWrapper.focus();
            }
        },
        {
            key: "renderItems",
            value: function renderItems(isClone) {
                var _this3 = this;
                if (!this.props.children) return [];
                return $cdbcc9ad1e75b0c5$var$_react.Children.map(this.props.children, function(item, index) {
                    var isSelected = index === _this3.state.selectedItem;
                    var isPrevious = index === _this3.state.previousItem;
                    var style = isSelected && _this3.state.selectedStyle || isPrevious && _this3.state.prevStyle || _this3.state.slideStyle || {};
                    if (_this3.props.centerMode && _this3.props.axis === "horizontal") style = $cdbcc9ad1e75b0c5$var$_objectSpread($cdbcc9ad1e75b0c5$var$_objectSpread({}, style), {}, {
                        minWidth: _this3.props.centerSlidePercentage + "%"
                    });
                    if (_this3.state.swiping && _this3.state.swipeMovementStarted) style = $cdbcc9ad1e75b0c5$var$_objectSpread($cdbcc9ad1e75b0c5$var$_objectSpread({}, style), {}, {
                        pointerEvents: "none"
                    });
                    var slideProps = {
                        ref: function ref(e) {
                            return _this3.setItemsRef(e, index);
                        },
                        key: "itemKey" + index + (isClone ? "clone" : ""),
                        className: $cdbcc9ad1e75b0c5$var$_cssClasses.default.ITEM(true, index === _this3.state.selectedItem, index === _this3.state.previousItem),
                        onClick: _this3.handleClickItem.bind(_this3, index, item),
                        style: style
                    };
                    return /*#__PURE__*/ $cdbcc9ad1e75b0c5$var$_react.default.createElement("li", slideProps, _this3.props.renderItem(item, {
                        isSelected: index === _this3.state.selectedItem,
                        isPrevious: index === _this3.state.previousItem
                    }));
                });
            }
        },
        {
            key: "renderControls",
            value: function renderControls() {
                var _this4 = this;
                var _this$props = this.props, showIndicators = _this$props.showIndicators, labels = _this$props.labels, renderIndicator = _this$props.renderIndicator, children = _this$props.children;
                if (!showIndicators) return null;
                return /*#__PURE__*/ $cdbcc9ad1e75b0c5$var$_react.default.createElement("ul", {
                    className: "control-dots"
                }, $cdbcc9ad1e75b0c5$var$_react.Children.map(children, function(_, index) {
                    return renderIndicator && renderIndicator(_this4.changeItem(index), index === _this4.state.selectedItem, index, labels.item);
                }));
            }
        },
        {
            key: "renderStatus",
            value: function renderStatus() {
                if (!this.props.showStatus) return null;
                return /*#__PURE__*/ $cdbcc9ad1e75b0c5$var$_react.default.createElement("p", {
                    className: "carousel-status"
                }, this.props.statusFormatter(this.state.selectedItem + 1, $cdbcc9ad1e75b0c5$var$_react.Children.count(this.props.children)));
            }
        },
        {
            key: "renderThumbs",
            value: function renderThumbs() {
                if (!this.props.showThumbs || !this.props.children || $cdbcc9ad1e75b0c5$var$_react.Children.count(this.props.children) === 0) return null;
                return /*#__PURE__*/ $cdbcc9ad1e75b0c5$var$_react.default.createElement($cdbcc9ad1e75b0c5$var$_Thumbs.default, {
                    ref: this.setThumbsRef,
                    onSelectItem: this.handleClickThumb,
                    selectedItem: this.state.selectedItem,
                    transitionTime: this.props.transitionTime,
                    thumbWidth: this.props.thumbWidth,
                    labels: this.props.labels,
                    emulateTouch: this.props.emulateTouch
                }, this.props.renderThumbs(this.props.children));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this5 = this;
                if (!this.props.children || $cdbcc9ad1e75b0c5$var$_react.Children.count(this.props.children) === 0) return null;
                var isSwipeable = this.props.swipeable && $cdbcc9ad1e75b0c5$var$_react.Children.count(this.props.children) > 1;
                var isHorizontal = this.props.axis === "horizontal";
                var canShowArrows = this.props.showArrows && $cdbcc9ad1e75b0c5$var$_react.Children.count(this.props.children) > 1; // show left arrow?
                var hasPrev = canShowArrows && (this.state.selectedItem > 0 || this.props.infiniteLoop) || false; // show right arrow
                var hasNext = canShowArrows && (this.state.selectedItem < $cdbcc9ad1e75b0c5$var$_react.Children.count(this.props.children) - 1 || this.props.infiniteLoop) || false;
                var itemsClone = this.renderItems(true);
                var firstClone = itemsClone.shift();
                var lastClone = itemsClone.pop();
                var swiperProps = {
                    className: $cdbcc9ad1e75b0c5$var$_cssClasses.default.SLIDER(true, this.state.swiping),
                    onSwipeMove: this.onSwipeMove,
                    onSwipeStart: this.onSwipeStart,
                    onSwipeEnd: this.onSwipeEnd,
                    style: this.state.itemListStyle,
                    tolerance: this.props.swipeScrollTolerance
                };
                var containerStyles = {};
                if (isHorizontal) {
                    swiperProps.onSwipeLeft = this.onSwipeForward;
                    swiperProps.onSwipeRight = this.onSwipeBackwards;
                    if (this.props.dynamicHeight) {
                        var itemHeight = this.getVariableItemHeight(this.state.selectedItem); // swiperProps.style.height = itemHeight || 'auto';
                        containerStyles.height = itemHeight || "auto";
                    }
                } else {
                    swiperProps.onSwipeUp = this.props.verticalSwipe === "natural" ? this.onSwipeBackwards : this.onSwipeForward;
                    swiperProps.onSwipeDown = this.props.verticalSwipe === "natural" ? this.onSwipeForward : this.onSwipeBackwards;
                    swiperProps.style = $cdbcc9ad1e75b0c5$var$_objectSpread($cdbcc9ad1e75b0c5$var$_objectSpread({}, swiperProps.style), {}, {
                        height: this.state.itemSize
                    });
                    containerStyles.height = this.state.itemSize;
                }
                return /*#__PURE__*/ $cdbcc9ad1e75b0c5$var$_react.default.createElement("div", {
                    "aria-label": this.props.ariaLabel,
                    className: $cdbcc9ad1e75b0c5$var$_cssClasses.default.ROOT(this.props.className),
                    ref: this.setCarouselWrapperRef,
                    tabIndex: this.props.useKeyboardArrows ? 0 : undefined
                }, /*#__PURE__*/ $cdbcc9ad1e75b0c5$var$_react.default.createElement("div", {
                    className: $cdbcc9ad1e75b0c5$var$_cssClasses.default.CAROUSEL(true),
                    style: {
                        width: this.props.width
                    }
                }, this.renderControls(), this.props.renderArrowPrev(this.onClickPrev, hasPrev, this.props.labels.leftArrow), /*#__PURE__*/ $cdbcc9ad1e75b0c5$var$_react.default.createElement("div", {
                    className: $cdbcc9ad1e75b0c5$var$_cssClasses.default.WRAPPER(true, this.props.axis),
                    style: containerStyles
                }, isSwipeable ? /*#__PURE__*/ $cdbcc9ad1e75b0c5$var$_react.default.createElement($cdbcc9ad1e75b0c5$var$_reactEasySwipe.default, $cdbcc9ad1e75b0c5$var$_extends({
                    tagName: "ul",
                    innerRef: this.setListRef
                }, swiperProps, {
                    allowMouseEvents: this.props.emulateTouch
                }), this.props.infiniteLoop && lastClone, this.renderItems(), this.props.infiniteLoop && firstClone) : /*#__PURE__*/ $cdbcc9ad1e75b0c5$var$_react.default.createElement("ul", {
                    className: $cdbcc9ad1e75b0c5$var$_cssClasses.default.SLIDER(true, this.state.swiping),
                    ref: function ref(node) {
                        return _this5.setListRef(node);
                    },
                    style: this.state.itemListStyle || {}
                }, this.props.infiniteLoop && lastClone, this.renderItems(), this.props.infiniteLoop && firstClone)), this.props.renderArrowNext(this.onClickNext, hasNext, this.props.labels.rightArrow), this.renderStatus()), this.renderThumbs());
            }
        }
    ]);
    return Carousel;
}($cdbcc9ad1e75b0c5$var$_react.default.Component);
module.exports.default = $cdbcc9ad1e75b0c5$var$Carousel;
$cdbcc9ad1e75b0c5$var$_defineProperty($cdbcc9ad1e75b0c5$var$Carousel, "displayName", "Carousel");
$cdbcc9ad1e75b0c5$var$_defineProperty($cdbcc9ad1e75b0c5$var$Carousel, "defaultProps", {
    ariaLabel: undefined,
    axis: "horizontal",
    centerSlidePercentage: 80,
    interval: 3000,
    labels: {
        leftArrow: "previous slide / item",
        rightArrow: "next slide / item",
        item: "slide item"
    },
    onClickItem: $c4AIV.noop,
    onClickThumb: $c4AIV.noop,
    onChange: $c4AIV.noop,
    onSwipeStart: function onSwipeStart() {},
    onSwipeEnd: function onSwipeEnd() {},
    onSwipeMove: function onSwipeMove() {
        return false;
    },
    preventMovementUntilSwipeScrollTolerance: false,
    renderArrowPrev: function renderArrowPrev(onClickHandler, hasPrev, label) {
        return /*#__PURE__*/ $cdbcc9ad1e75b0c5$var$_react.default.createElement("button", {
            type: "button",
            "aria-label": label,
            className: $cdbcc9ad1e75b0c5$var$_cssClasses.default.ARROW_PREV(!hasPrev),
            onClick: onClickHandler
        });
    },
    renderArrowNext: function renderArrowNext(onClickHandler, hasNext, label) {
        return /*#__PURE__*/ $cdbcc9ad1e75b0c5$var$_react.default.createElement("button", {
            type: "button",
            "aria-label": label,
            className: $cdbcc9ad1e75b0c5$var$_cssClasses.default.ARROW_NEXT(!hasNext),
            onClick: onClickHandler
        });
    },
    renderIndicator: function renderIndicator(onClickHandler, isSelected, index, label) {
        return /*#__PURE__*/ $cdbcc9ad1e75b0c5$var$_react.default.createElement("li", {
            className: $cdbcc9ad1e75b0c5$var$_cssClasses.default.DOT(isSelected),
            onClick: onClickHandler,
            onKeyDown: onClickHandler,
            value: index,
            key: index,
            role: "button",
            tabIndex: 0,
            "aria-label": "".concat(label, " ").concat(index + 1)
        });
    },
    renderItem: function renderItem(item) {
        return item;
    },
    renderThumbs: function renderThumbs(children) {
        var images = $cdbcc9ad1e75b0c5$var$_react.Children.map(children, function(item) {
            var img = item; // if the item is not an image, try to find the first image in the item's children.
            if (item.type !== "img") img = $cdbcc9ad1e75b0c5$var$_react.Children.toArray(item.props.children).find(function(children) {
                return children.type === "img";
            });
            if (!img) return undefined;
            return img;
        });
        if (images.filter(function(image) {
            return image;
        }).length === 0) {
            console.warn("No images found! Can't build the thumb list without images. If you don't need thumbs, set showThumbs={false} in the Carousel. Note that it's not possible to get images rendered inside custom components. More info at https://github.com/leandrowd/react-responsive-carousel/blob/master/TROUBLESHOOTING.md");
            return [];
        }
        return images;
    },
    statusFormatter: $c4AIV.defaultStatusFormatter,
    selectedItem: 0,
    showArrows: true,
    showIndicators: true,
    showStatus: true,
    showThumbs: true,
    stopOnHover: true,
    swipeScrollTolerance: 5,
    swipeable: true,
    transitionTime: 350,
    verticalSwipe: "standard",
    width: "100%",
    animationHandler: "slide",
    swipeAnimationHandler: $aGBOI.slideSwipeAnimationHandler,
    stopSwipingHandler: $aGBOI.slideStopSwipingHandler
});

});
parcelRegister("ems6E", function(module, exports) {

(function(global, factory) {
    if (typeof define === "function" && define.amd) define([
        "exports",
        "./react-swipe"
    ], factory);
    else {
        var mod;
        factory(module.exports, (parcelRequire("jBjNs")));
    }
})(module.exports, function(exports1, _reactSwipe) {
    "use strict";
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
    var _reactSwipe2 = _interopRequireDefault(_reactSwipe);
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    exports1.default = _reactSwipe2.default;
});

});
parcelRegister("jBjNs", function(module, exports) {


(function(global, factory) {
    if (typeof define === "function" && define.amd) define([
        "exports",
        "react",
        "prop-types"
    ], factory);
    else {
        var mod;
        factory(module.exports, (parcelRequire("b6HlZ")), (parcelRequire("aRbOc")));
    }
})(module.exports, function(exports1, _react, _propTypes) {
    "use strict";
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
    exports1.setHasSupportToCaptureOption = setHasSupportToCaptureOption;
    var _react2 = _interopRequireDefault(_react);
    var _propTypes2 = _interopRequireDefault(_propTypes);
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    var _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    function _objectWithoutProperties(obj, keys) {
        var target = {};
        for(var i in obj){
            if (keys.indexOf(i) >= 0) continue;
            if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
            target[i] = obj[i];
        }
        return target;
    }
    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    }
    var _createClass = function() {
        function defineProperties(target, props) {
            for(var i = 0; i < props.length; i++){
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }
        return function(Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
        };
    }();
    function _possibleConstructorReturn(self, call) {
        if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return call && (typeof call === "object" || typeof call === "function") ? call : self;
    }
    function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }
    var supportsCaptureOption = false;
    function setHasSupportToCaptureOption(hasSupport) {
        supportsCaptureOption = hasSupport;
    }
    try {
        addEventListener("test", null, Object.defineProperty({}, "capture", {
            get: function get() {
                setHasSupportToCaptureOption(true);
            }
        }));
    } catch (e) {} // eslint-disable-line no-empty
    function getSafeEventHandlerOpts() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
            capture: true
        };
        return supportsCaptureOption ? options : options.capture;
    }
    /**
   * [getPosition returns a position element that works for mouse or touch events]
   * @param  {[Event]} event [the received event]
   * @return {[Object]}      [x and y coords]
   */ function getPosition(event) {
        if ("touches" in event) {
            var _event$touches$ = event.touches[0], pageX = _event$touches$.pageX, pageY = _event$touches$.pageY;
            return {
                x: pageX,
                y: pageY
            };
        }
        var screenX = event.screenX, screenY = event.screenY;
        return {
            x: screenX,
            y: screenY
        };
    }
    var ReactSwipe = function(_Component) {
        _inherits(ReactSwipe, _Component);
        function ReactSwipe() {
            var _ref;
            _classCallCheck(this, ReactSwipe);
            for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            var _this = _possibleConstructorReturn(this, (_ref = ReactSwipe.__proto__ || Object.getPrototypeOf(ReactSwipe)).call.apply(_ref, [
                this
            ].concat(args)));
            _this._handleSwipeStart = _this._handleSwipeStart.bind(_this);
            _this._handleSwipeMove = _this._handleSwipeMove.bind(_this);
            _this._handleSwipeEnd = _this._handleSwipeEnd.bind(_this);
            _this._onMouseDown = _this._onMouseDown.bind(_this);
            _this._onMouseMove = _this._onMouseMove.bind(_this);
            _this._onMouseUp = _this._onMouseUp.bind(_this);
            _this._setSwiperRef = _this._setSwiperRef.bind(_this);
            return _this;
        }
        _createClass(ReactSwipe, [
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    if (this.swiper) this.swiper.addEventListener("touchmove", this._handleSwipeMove, getSafeEventHandlerOpts({
                        capture: true,
                        passive: false
                    }));
                }
            },
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    if (this.swiper) this.swiper.removeEventListener("touchmove", this._handleSwipeMove, getSafeEventHandlerOpts({
                        capture: true,
                        passive: false
                    }));
                }
            },
            {
                key: "_onMouseDown",
                value: function _onMouseDown(event) {
                    if (!this.props.allowMouseEvents) return;
                    this.mouseDown = true;
                    document.addEventListener("mouseup", this._onMouseUp);
                    document.addEventListener("mousemove", this._onMouseMove);
                    this._handleSwipeStart(event);
                }
            },
            {
                key: "_onMouseMove",
                value: function _onMouseMove(event) {
                    if (!this.mouseDown) return;
                    this._handleSwipeMove(event);
                }
            },
            {
                key: "_onMouseUp",
                value: function _onMouseUp(event) {
                    this.mouseDown = false;
                    document.removeEventListener("mouseup", this._onMouseUp);
                    document.removeEventListener("mousemove", this._onMouseMove);
                    this._handleSwipeEnd(event);
                }
            },
            {
                key: "_handleSwipeStart",
                value: function _handleSwipeStart(event) {
                    var _getPosition = getPosition(event), x = _getPosition.x, y = _getPosition.y;
                    this.moveStart = {
                        x: x,
                        y: y
                    };
                    this.props.onSwipeStart(event);
                }
            },
            {
                key: "_handleSwipeMove",
                value: function _handleSwipeMove(event) {
                    if (!this.moveStart) return;
                    var _getPosition2 = getPosition(event), x = _getPosition2.x, y = _getPosition2.y;
                    var deltaX = x - this.moveStart.x;
                    var deltaY = y - this.moveStart.y;
                    this.moving = true;
                    // handling the responsability of cancelling the scroll to
                    // the component handling the event
                    var shouldPreventDefault = this.props.onSwipeMove({
                        x: deltaX,
                        y: deltaY
                    }, event);
                    if (shouldPreventDefault && event.cancelable) event.preventDefault();
                    this.movePosition = {
                        deltaX: deltaX,
                        deltaY: deltaY
                    };
                }
            },
            {
                key: "_handleSwipeEnd",
                value: function _handleSwipeEnd(event) {
                    this.props.onSwipeEnd(event);
                    var tolerance = this.props.tolerance;
                    if (this.moving && this.movePosition) {
                        if (this.movePosition.deltaX < -tolerance) this.props.onSwipeLeft(1, event);
                        else if (this.movePosition.deltaX > tolerance) this.props.onSwipeRight(1, event);
                        if (this.movePosition.deltaY < -tolerance) this.props.onSwipeUp(1, event);
                        else if (this.movePosition.deltaY > tolerance) this.props.onSwipeDown(1, event);
                    }
                    this.moveStart = null;
                    this.moving = false;
                    this.movePosition = null;
                }
            },
            {
                key: "_setSwiperRef",
                value: function _setSwiperRef(node) {
                    this.swiper = node;
                    this.props.innerRef(node);
                }
            },
            {
                key: "render",
                value: function render() {
                    var _props = this.props, tagName = _props.tagName, className = _props.className, style = _props.style, children = _props.children, allowMouseEvents = _props.allowMouseEvents, onSwipeUp = _props.onSwipeUp, onSwipeDown = _props.onSwipeDown, onSwipeLeft = _props.onSwipeLeft, onSwipeRight = _props.onSwipeRight, onSwipeStart = _props.onSwipeStart, onSwipeMove = _props.onSwipeMove, onSwipeEnd = _props.onSwipeEnd, innerRef = _props.innerRef, tolerance = _props.tolerance, props = _objectWithoutProperties(_props, [
                        "tagName",
                        "className",
                        "style",
                        "children",
                        "allowMouseEvents",
                        "onSwipeUp",
                        "onSwipeDown",
                        "onSwipeLeft",
                        "onSwipeRight",
                        "onSwipeStart",
                        "onSwipeMove",
                        "onSwipeEnd",
                        "innerRef",
                        "tolerance"
                    ]);
                    return _react2.default.createElement(this.props.tagName, _extends({
                        ref: this._setSwiperRef,
                        onMouseDown: this._onMouseDown,
                        onTouchStart: this._handleSwipeStart,
                        onTouchEnd: this._handleSwipeEnd,
                        className: className,
                        style: style
                    }, props), children);
                }
            }
        ]);
        return ReactSwipe;
    }(_react.Component);
    ReactSwipe.displayName = "ReactSwipe";
    ReactSwipe.propTypes = {
        tagName: _propTypes2.default.string,
        className: _propTypes2.default.string,
        style: _propTypes2.default.object,
        children: _propTypes2.default.node,
        allowMouseEvents: _propTypes2.default.bool,
        onSwipeUp: _propTypes2.default.func,
        onSwipeDown: _propTypes2.default.func,
        onSwipeLeft: _propTypes2.default.func,
        onSwipeRight: _propTypes2.default.func,
        onSwipeStart: _propTypes2.default.func,
        onSwipeMove: _propTypes2.default.func,
        onSwipeEnd: _propTypes2.default.func,
        innerRef: _propTypes2.default.func,
        tolerance: _propTypes2.default.number.isRequired
    };
    ReactSwipe.defaultProps = {
        tagName: "div",
        allowMouseEvents: false,
        onSwipeUp: function onSwipeUp() {},
        onSwipeDown: function onSwipeDown() {},
        onSwipeLeft: function onSwipeLeft() {},
        onSwipeRight: function onSwipeRight() {},
        onSwipeStart: function onSwipeStart() {},
        onSwipeMove: function onSwipeMove() {},
        onSwipeEnd: function onSwipeEnd() {},
        innerRef: function innerRef() {},
        tolerance: 0
    };
    exports1.default = ReactSwipe;
});

});


parcelRegister("2roV5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1c716eeb8421c7dc$var$_classnames = $1c716eeb8421c7dc$var$_interopRequireDefault((parcelRequire("l1iZ3")));
function $1c716eeb8421c7dc$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $1c716eeb8421c7dc$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $1c716eeb8421c7dc$var$_default = {
    ROOT: function ROOT(customClassName) {
        return (0, $1c716eeb8421c7dc$var$_classnames.default)($1c716eeb8421c7dc$var$_defineProperty({
            "carousel-root": true
        }, customClassName || "", !!customClassName));
    },
    CAROUSEL: function CAROUSEL(isSlider) {
        return (0, $1c716eeb8421c7dc$var$_classnames.default)({
            carousel: true,
            "carousel-slider": isSlider
        });
    },
    WRAPPER: function WRAPPER(isSlider, axis) {
        return (0, $1c716eeb8421c7dc$var$_classnames.default)({
            "thumbs-wrapper": !isSlider,
            "slider-wrapper": isSlider,
            "axis-horizontal": axis === "horizontal",
            "axis-vertical": axis !== "horizontal"
        });
    },
    SLIDER: function SLIDER(isSlider, isSwiping) {
        return (0, $1c716eeb8421c7dc$var$_classnames.default)({
            thumbs: !isSlider,
            slider: isSlider,
            animated: !isSwiping
        });
    },
    ITEM: function ITEM(isSlider, selected, previous) {
        return (0, $1c716eeb8421c7dc$var$_classnames.default)({
            thumb: !isSlider,
            slide: isSlider,
            selected: selected,
            previous: previous
        });
    },
    ARROW_PREV: function ARROW_PREV(disabled) {
        return (0, $1c716eeb8421c7dc$var$_classnames.default)({
            "control-arrow control-prev": true,
            "control-disabled": disabled
        });
    },
    ARROW_NEXT: function ARROW_NEXT(disabled) {
        return (0, $1c716eeb8421c7dc$var$_classnames.default)({
            "control-arrow control-next": true,
            "control-disabled": disabled
        });
    },
    DOT: function DOT(selected) {
        return (0, $1c716eeb8421c7dc$var$_classnames.default)({
            dot: true,
            selected: selected
        });
    }
};
module.exports.default = $1c716eeb8421c7dc$var$_default;

});
parcelRegister("l1iZ3", function(module, exports) {
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    "use strict";
    var hasOwn = {}.hasOwnProperty;
    var nativeCodeString = "[native code]";
    function classNames() {
        var classes = [];
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (!arg) continue;
            var argType = typeof arg;
            if (argType === "string" || argType === "number") classes.push(arg);
            else if (Array.isArray(arg)) {
                if (arg.length) {
                    var inner = classNames.apply(null, arg);
                    if (inner) classes.push(inner);
                }
            } else if (argType === "object") {
                if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes("[native code]")) {
                    classes.push(arg.toString());
                    continue;
                }
                for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes.push(key);
            }
        }
        return classes.join(" ");
    }
    if (0, module.exports) {
        classNames.default = classNames;
        module.exports = classNames;
    } else if (typeof define === "function" && typeof define.amd === "object" && define.amd) // register as 'classnames', consistent with npm package name
    define("classnames", [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();

});


parcelRegister("lRg1u", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fe9afa12927c55d5$var$_react = $fe9afa12927c55d5$var$_interopRequireWildcard((parcelRequire("b6HlZ")));

var $fe9afa12927c55d5$var$_cssClasses = $fe9afa12927c55d5$var$_interopRequireDefault((parcelRequire("2roV5")));

var $9RT1M = parcelRequire("9RT1M");

var $fe9afa12927c55d5$var$_CSSTranslate = $fe9afa12927c55d5$var$_interopRequireDefault((parcelRequire("jnjuc")));

var $fe9afa12927c55d5$var$_reactEasySwipe = $fe9afa12927c55d5$var$_interopRequireDefault((parcelRequire("ems6E")));

var $fe9afa12927c55d5$var$_window = $fe9afa12927c55d5$var$_interopRequireDefault((parcelRequire("2VKi9")));
function $fe9afa12927c55d5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $fe9afa12927c55d5$var$_getRequireWildcardCache() {
    if (typeof WeakMap !== "function") return null;
    var cache = new WeakMap();
    $fe9afa12927c55d5$var$_getRequireWildcardCache = function _getRequireWildcardCache() {
        return cache;
    };
    return cache;
}
function $fe9afa12927c55d5$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    if (obj === null || $fe9afa12927c55d5$var$_typeof(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $fe9afa12927c55d5$var$_getRequireWildcardCache();
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $fe9afa12927c55d5$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $fe9afa12927c55d5$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $fe9afa12927c55d5$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $fe9afa12927c55d5$var$_typeof(obj);
}
function $fe9afa12927c55d5$var$_extends() {
    $fe9afa12927c55d5$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $fe9afa12927c55d5$var$_extends.apply(this, arguments);
}
function $fe9afa12927c55d5$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $fe9afa12927c55d5$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $fe9afa12927c55d5$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $fe9afa12927c55d5$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $fe9afa12927c55d5$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $fe9afa12927c55d5$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $fe9afa12927c55d5$var$_setPrototypeOf(subClass, superClass);
}
function $fe9afa12927c55d5$var$_setPrototypeOf(o, p) {
    $fe9afa12927c55d5$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $fe9afa12927c55d5$var$_setPrototypeOf(o, p);
}
function $fe9afa12927c55d5$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $fe9afa12927c55d5$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $fe9afa12927c55d5$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $fe9afa12927c55d5$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $fe9afa12927c55d5$var$_possibleConstructorReturn(this, result);
    };
}
function $fe9afa12927c55d5$var$_possibleConstructorReturn(self, call) {
    if (call && ($fe9afa12927c55d5$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $fe9afa12927c55d5$var$_assertThisInitialized(self);
}
function $fe9afa12927c55d5$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $fe9afa12927c55d5$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $fe9afa12927c55d5$var$_getPrototypeOf(o) {
    $fe9afa12927c55d5$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $fe9afa12927c55d5$var$_getPrototypeOf(o);
}
function $fe9afa12927c55d5$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $fe9afa12927c55d5$var$isKeyboardEvent = function isKeyboardEvent(e) {
    return e.hasOwnProperty("key");
};
var $fe9afa12927c55d5$var$Thumbs = /*#__PURE__*/ function(_Component) {
    $fe9afa12927c55d5$var$_inherits(Thumbs, _Component);
    var _super = $fe9afa12927c55d5$var$_createSuper(Thumbs);
    function Thumbs(_props) {
        var _this;
        $fe9afa12927c55d5$var$_classCallCheck(this, Thumbs);
        _this = _super.call(this, _props);
        $fe9afa12927c55d5$var$_defineProperty($fe9afa12927c55d5$var$_assertThisInitialized(_this), "itemsWrapperRef", void 0);
        $fe9afa12927c55d5$var$_defineProperty($fe9afa12927c55d5$var$_assertThisInitialized(_this), "itemsListRef", void 0);
        $fe9afa12927c55d5$var$_defineProperty($fe9afa12927c55d5$var$_assertThisInitialized(_this), "thumbsRef", void 0);
        $fe9afa12927c55d5$var$_defineProperty($fe9afa12927c55d5$var$_assertThisInitialized(_this), "setItemsWrapperRef", function(node) {
            _this.itemsWrapperRef = node;
        });
        $fe9afa12927c55d5$var$_defineProperty($fe9afa12927c55d5$var$_assertThisInitialized(_this), "setItemsListRef", function(node) {
            _this.itemsListRef = node;
        });
        $fe9afa12927c55d5$var$_defineProperty($fe9afa12927c55d5$var$_assertThisInitialized(_this), "setThumbsRef", function(node, index) {
            if (!_this.thumbsRef) _this.thumbsRef = [];
            _this.thumbsRef[index] = node;
        });
        $fe9afa12927c55d5$var$_defineProperty($fe9afa12927c55d5$var$_assertThisInitialized(_this), "updateSizes", function() {
            if (!_this.props.children || !_this.itemsWrapperRef || !_this.thumbsRef) return;
            var total = $fe9afa12927c55d5$var$_react.Children.count(_this.props.children);
            var wrapperSize = _this.itemsWrapperRef.clientWidth;
            var itemSize = _this.props.thumbWidth ? _this.props.thumbWidth : (0, $9RT1M.outerWidth)(_this.thumbsRef[0]);
            var visibleItems = Math.floor(wrapperSize / itemSize);
            var showArrows = visibleItems < total;
            var lastPosition = showArrows ? total - visibleItems : 0;
            _this.setState(function(_state, props) {
                return {
                    itemSize: itemSize,
                    visibleItems: visibleItems,
                    firstItem: showArrows ? _this.getFirstItem(props.selectedItem) : 0,
                    lastPosition: lastPosition,
                    showArrows: showArrows
                };
            });
        });
        $fe9afa12927c55d5$var$_defineProperty($fe9afa12927c55d5$var$_assertThisInitialized(_this), "handleClickItem", function(index, item, e) {
            if (!$fe9afa12927c55d5$var$isKeyboardEvent(e) || e.key === "Enter") {
                var handler = _this.props.onSelectItem;
                if (typeof handler === "function") handler(index, item);
            }
        });
        $fe9afa12927c55d5$var$_defineProperty($fe9afa12927c55d5$var$_assertThisInitialized(_this), "onSwipeStart", function() {
            _this.setState({
                swiping: true
            });
        });
        $fe9afa12927c55d5$var$_defineProperty($fe9afa12927c55d5$var$_assertThisInitialized(_this), "onSwipeEnd", function() {
            _this.setState({
                swiping: false
            });
        });
        $fe9afa12927c55d5$var$_defineProperty($fe9afa12927c55d5$var$_assertThisInitialized(_this), "onSwipeMove", function(delta) {
            var deltaX = delta.x;
            if (!_this.state.itemSize || !_this.itemsWrapperRef || !_this.state.visibleItems) return false;
            var leftBoundary = 0;
            var childrenLength = $fe9afa12927c55d5$var$_react.Children.count(_this.props.children);
            var currentPosition = -(_this.state.firstItem * 100) / _this.state.visibleItems;
            var lastLeftItem = Math.max(childrenLength - _this.state.visibleItems, 0);
            var lastLeftBoundary = -lastLeftItem * 100 / _this.state.visibleItems; // prevent user from swiping left out of boundaries
            if (currentPosition === leftBoundary && deltaX > 0) deltaX = 0;
             // prevent user from swiping right out of boundaries
            if (currentPosition === lastLeftBoundary && deltaX < 0) deltaX = 0;
            var wrapperSize = _this.itemsWrapperRef.clientWidth;
            var position = currentPosition + 100 / (wrapperSize / deltaX); // if 3d isn't available we will use left to move
            if (_this.itemsListRef) [
                "WebkitTransform",
                "MozTransform",
                "MsTransform",
                "OTransform",
                "transform",
                "msTransform"
            ].forEach(function(prop) {
                _this.itemsListRef.style[prop] = (0, $fe9afa12927c55d5$var$_CSSTranslate.default)(position, "%", _this.props.axis);
            });
            return true;
        });
        $fe9afa12927c55d5$var$_defineProperty($fe9afa12927c55d5$var$_assertThisInitialized(_this), "slideRight", function(positions) {
            _this.moveTo(_this.state.firstItem - (typeof positions === "number" ? positions : 1));
        });
        $fe9afa12927c55d5$var$_defineProperty($fe9afa12927c55d5$var$_assertThisInitialized(_this), "slideLeft", function(positions) {
            _this.moveTo(_this.state.firstItem + (typeof positions === "number" ? positions : 1));
        });
        $fe9afa12927c55d5$var$_defineProperty($fe9afa12927c55d5$var$_assertThisInitialized(_this), "moveTo", function(position) {
            // position can't be lower than 0
            position = position < 0 ? 0 : position; // position can't be higher than last postion
            position = position >= _this.state.lastPosition ? _this.state.lastPosition : position;
            _this.setState({
                firstItem: position
            });
        });
        _this.state = {
            selectedItem: _props.selectedItem,
            swiping: false,
            showArrows: false,
            firstItem: 0,
            visibleItems: 0,
            lastPosition: 0
        };
        return _this;
    }
    $fe9afa12927c55d5$var$_createClass(Thumbs, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.setupThumbs();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                if (this.props.selectedItem !== this.state.selectedItem) this.setState({
                    selectedItem: this.props.selectedItem,
                    firstItem: this.getFirstItem(this.props.selectedItem)
                });
                if (this.props.children === prevProps.children) return;
                 // This will capture any size changes for arrow adjustments etc.
                // usually in the same render cycle so we don't see any flickers
                this.updateSizes();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.destroyThumbs();
            }
        },
        {
            key: "setupThumbs",
            value: function setupThumbs() {
                // as the widths are calculated, we need to resize
                // the carousel when the window is resized
                (0, $fe9afa12927c55d5$var$_window.default)().addEventListener("resize", this.updateSizes); // issue #2 - image loading smaller
                (0, $fe9afa12927c55d5$var$_window.default)().addEventListener("DOMContentLoaded", this.updateSizes); // when the component is rendered we need to calculate
                // the container size to adjust the responsive behaviour
                this.updateSizes();
            }
        },
        {
            key: "destroyThumbs",
            value: function destroyThumbs() {
                // removing listeners
                (0, $fe9afa12927c55d5$var$_window.default)().removeEventListener("resize", this.updateSizes);
                (0, $fe9afa12927c55d5$var$_window.default)().removeEventListener("DOMContentLoaded", this.updateSizes);
            }
        },
        {
            key: "getFirstItem",
            value: function getFirstItem(selectedItem) {
                var firstItem = selectedItem;
                if (selectedItem >= this.state.lastPosition) firstItem = this.state.lastPosition;
                if (selectedItem < this.state.firstItem + this.state.visibleItems) firstItem = this.state.firstItem;
                if (selectedItem < this.state.firstItem) firstItem = selectedItem;
                return firstItem;
            }
        },
        {
            key: "renderItems",
            value: function renderItems() {
                var _this2 = this;
                return this.props.children.map(function(img, index) {
                    var itemClass = $fe9afa12927c55d5$var$_cssClasses.default.ITEM(false, index === _this2.state.selectedItem);
                    var thumbProps = {
                        key: index,
                        ref: function ref(e) {
                            return _this2.setThumbsRef(e, index);
                        },
                        className: itemClass,
                        onClick: _this2.handleClickItem.bind(_this2, index, _this2.props.children[index]),
                        onKeyDown: _this2.handleClickItem.bind(_this2, index, _this2.props.children[index]),
                        "aria-label": "".concat(_this2.props.labels.item, " ").concat(index + 1),
                        style: {
                            width: _this2.props.thumbWidth
                        }
                    };
                    return /*#__PURE__*/ $fe9afa12927c55d5$var$_react.default.createElement("li", $fe9afa12927c55d5$var$_extends({}, thumbProps, {
                        role: "button",
                        tabIndex: 0
                    }), img);
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this3 = this;
                if (!this.props.children) return null;
                var isSwipeable = $fe9afa12927c55d5$var$_react.Children.count(this.props.children) > 1; // show left arrow?
                var hasPrev = this.state.showArrows && this.state.firstItem > 0; // show right arrow
                var hasNext = this.state.showArrows && this.state.firstItem < this.state.lastPosition; // obj to hold the transformations and styles
                var itemListStyles = {};
                var currentPosition = -this.state.firstItem * (this.state.itemSize || 0);
                var transformProp = (0, $fe9afa12927c55d5$var$_CSSTranslate.default)(currentPosition, "px", this.props.axis);
                var transitionTime = this.props.transitionTime + "ms";
                itemListStyles = {
                    WebkitTransform: transformProp,
                    MozTransform: transformProp,
                    MsTransform: transformProp,
                    OTransform: transformProp,
                    transform: transformProp,
                    msTransform: transformProp,
                    WebkitTransitionDuration: transitionTime,
                    MozTransitionDuration: transitionTime,
                    MsTransitionDuration: transitionTime,
                    OTransitionDuration: transitionTime,
                    transitionDuration: transitionTime,
                    msTransitionDuration: transitionTime
                };
                return /*#__PURE__*/ $fe9afa12927c55d5$var$_react.default.createElement("div", {
                    className: $fe9afa12927c55d5$var$_cssClasses.default.CAROUSEL(false)
                }, /*#__PURE__*/ $fe9afa12927c55d5$var$_react.default.createElement("div", {
                    className: $fe9afa12927c55d5$var$_cssClasses.default.WRAPPER(false),
                    ref: this.setItemsWrapperRef
                }, /*#__PURE__*/ $fe9afa12927c55d5$var$_react.default.createElement("button", {
                    type: "button",
                    className: $fe9afa12927c55d5$var$_cssClasses.default.ARROW_PREV(!hasPrev),
                    onClick: function onClick() {
                        return _this3.slideRight();
                    },
                    "aria-label": this.props.labels.leftArrow
                }), isSwipeable ? /*#__PURE__*/ $fe9afa12927c55d5$var$_react.default.createElement($fe9afa12927c55d5$var$_reactEasySwipe.default, {
                    tagName: "ul",
                    className: $fe9afa12927c55d5$var$_cssClasses.default.SLIDER(false, this.state.swiping),
                    onSwipeLeft: this.slideLeft,
                    onSwipeRight: this.slideRight,
                    onSwipeMove: this.onSwipeMove,
                    onSwipeStart: this.onSwipeStart,
                    onSwipeEnd: this.onSwipeEnd,
                    style: itemListStyles,
                    innerRef: this.setItemsListRef,
                    allowMouseEvents: this.props.emulateTouch
                }, this.renderItems()) : /*#__PURE__*/ $fe9afa12927c55d5$var$_react.default.createElement("ul", {
                    className: $fe9afa12927c55d5$var$_cssClasses.default.SLIDER(false, this.state.swiping),
                    ref: function ref(node) {
                        return _this3.setItemsListRef(node);
                    },
                    style: itemListStyles
                }, this.renderItems()), /*#__PURE__*/ $fe9afa12927c55d5$var$_react.default.createElement("button", {
                    type: "button",
                    className: $fe9afa12927c55d5$var$_cssClasses.default.ARROW_NEXT(!hasNext),
                    onClick: function onClick() {
                        return _this3.slideLeft();
                    },
                    "aria-label": this.props.labels.rightArrow
                })));
            }
        }
    ]);
    return Thumbs;
}($fe9afa12927c55d5$var$_react.Component);
module.exports.default = $fe9afa12927c55d5$var$Thumbs;
$fe9afa12927c55d5$var$_defineProperty($fe9afa12927c55d5$var$Thumbs, "displayName", "Thumbs");
$fe9afa12927c55d5$var$_defineProperty($fe9afa12927c55d5$var$Thumbs, "defaultProps", {
    axis: "horizontal",
    labels: {
        leftArrow: "previous slide / item",
        rightArrow: "next slide / item",
        item: "slide item"
    },
    selectedItem: 0,
    thumbWidth: 80,
    transitionTime: 350
});

});
parcelRegister("9RT1M", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.outerWidth = void 0;
var $72f3bfabb13a82a3$var$outerWidth = function outerWidth(el) {
    var width = el.offsetWidth;
    var style = getComputedStyle(el);
    width += parseInt(style.marginLeft) + parseInt(style.marginRight);
    return width;
};
module.exports.outerWidth = $72f3bfabb13a82a3$var$outerWidth;

});

parcelRegister("jnjuc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $e1af47d354a9ee6b$var$_default = function _default(position, metric, axis) {
    var positionPercent = position === 0 ? position : position + metric;
    var positionCss = axis === "horizontal" ? [
        positionPercent,
        0,
        0
    ] : [
        0,
        positionPercent,
        0
    ];
    var transitionProp = "translate3d";
    var translatedPosition = "(" + positionCss.join(",") + ")";
    return transitionProp + translatedPosition;
};
module.exports.default = $e1af47d354a9ee6b$var$_default;

});

parcelRegister("2VKi9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $2224d037f9f5df32$var$_default = function _default() {
    return window;
};
module.exports.default = $2224d037f9f5df32$var$_default;

});


parcelRegister("lzGH4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $fb4dfbf587b1d2b2$var$_default = function _default() {
    return document;
};
module.exports.default = $fb4dfbf587b1d2b2$var$_default;

});

parcelRegister("c4AIV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.setPosition = module.exports.getPosition = module.exports.isKeyboardEvent = module.exports.defaultStatusFormatter = module.exports.noop = void 0;

var $b6HlZ = parcelRequire("b6HlZ");

var $8ca2584c09c169e0$var$_CSSTranslate = $8ca2584c09c169e0$var$_interopRequireDefault((parcelRequire("jnjuc")));
function $8ca2584c09c169e0$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $8ca2584c09c169e0$var$noop = function noop() {};
module.exports.noop = $8ca2584c09c169e0$var$noop;
var $8ca2584c09c169e0$var$defaultStatusFormatter = function defaultStatusFormatter(current, total) {
    return "".concat(current, " of ").concat(total);
};
module.exports.defaultStatusFormatter = $8ca2584c09c169e0$var$defaultStatusFormatter;
var $8ca2584c09c169e0$var$isKeyboardEvent = function isKeyboardEvent(e) {
    return e ? e.hasOwnProperty("key") : false;
};
/**
 * Gets the list 'position' relative to a current index
 * @param index
 */ module.exports.isKeyboardEvent = $8ca2584c09c169e0$var$isKeyboardEvent;
var $8ca2584c09c169e0$var$getPosition = function getPosition(index, props) {
    if (props.infiniteLoop) // index has to be added by 1 because of the first cloned slide
    ++index;
    if (index === 0) return 0;
    var childrenLength = $b6HlZ.Children.count(props.children);
    if (props.centerMode && props.axis === "horizontal") {
        var currentPosition = -index * props.centerSlidePercentage;
        var lastPosition = childrenLength - 1;
        if (index && (index !== lastPosition || props.infiniteLoop)) currentPosition += (100 - props.centerSlidePercentage) / 2;
        else if (index === lastPosition) currentPosition += 100 - props.centerSlidePercentage;
        return currentPosition;
    }
    return -index * 100;
};
/**
 * Sets the 'position' transform for sliding animations
 * @param position
 * @param forceReflow
 */ module.exports.getPosition = $8ca2584c09c169e0$var$getPosition;
var $8ca2584c09c169e0$var$setPosition = function setPosition(position, axis) {
    var style = {};
    [
        "WebkitTransform",
        "MozTransform",
        "MsTransform",
        "OTransform",
        "transform",
        "msTransform"
    ].forEach(function(prop) {
        // @ts-ignore
        style[prop] = (0, $8ca2584c09c169e0$var$_CSSTranslate.default)(position, "%", axis);
    });
    return style;
};
module.exports.setPosition = $8ca2584c09c169e0$var$setPosition;

});

parcelRegister("aGBOI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.fadeAnimationHandler = module.exports.slideStopSwipingHandler = module.exports.slideSwipeAnimationHandler = module.exports.slideAnimationHandler = void 0;

var $b6HlZ = parcelRequire("b6HlZ");

var $7c7b29471445f17e$var$_CSSTranslate = $7c7b29471445f17e$var$_interopRequireDefault((parcelRequire("jnjuc")));

var $c4AIV = parcelRequire("c4AIV");
function $7c7b29471445f17e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $7c7b29471445f17e$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $7c7b29471445f17e$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $7c7b29471445f17e$var$ownKeys(Object(source), true).forEach(function(key) {
            $7c7b29471445f17e$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $7c7b29471445f17e$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $7c7b29471445f17e$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
/**
 * Main animation handler for the default 'sliding' style animation
 * @param props
 * @param state
 */ var $7c7b29471445f17e$var$slideAnimationHandler = function slideAnimationHandler(props, state) {
    var returnStyles = {};
    var selectedItem = state.selectedItem;
    var previousItem = selectedItem;
    var lastPosition = $b6HlZ.Children.count(props.children) - 1;
    var needClonedSlide = props.infiniteLoop && (selectedItem < 0 || selectedItem > lastPosition); // Handle list position if it needs a clone
    if (needClonedSlide) {
        if (previousItem < 0) {
            if (props.centerMode && props.centerSlidePercentage && props.axis === "horizontal") returnStyles.itemListStyle = (0, $c4AIV.setPosition)(-(lastPosition + 2) * props.centerSlidePercentage - (100 - props.centerSlidePercentage) / 2, props.axis);
            else returnStyles.itemListStyle = (0, $c4AIV.setPosition)(-(lastPosition + 2) * 100, props.axis);
        } else if (previousItem > lastPosition) returnStyles.itemListStyle = (0, $c4AIV.setPosition)(0, props.axis);
        return returnStyles;
    }
    var currentPosition = (0, $c4AIV.getPosition)(selectedItem, props); // if 3d is available, let's take advantage of the performance of transform
    var transformProp = (0, $7c7b29471445f17e$var$_CSSTranslate.default)(currentPosition, "%", props.axis);
    var transitionTime = props.transitionTime + "ms";
    returnStyles.itemListStyle = {
        WebkitTransform: transformProp,
        msTransform: transformProp,
        OTransform: transformProp,
        transform: transformProp
    };
    if (!state.swiping) returnStyles.itemListStyle = $7c7b29471445f17e$var$_objectSpread($7c7b29471445f17e$var$_objectSpread({}, returnStyles.itemListStyle), {}, {
        WebkitTransitionDuration: transitionTime,
        MozTransitionDuration: transitionTime,
        OTransitionDuration: transitionTime,
        transitionDuration: transitionTime,
        msTransitionDuration: transitionTime
    });
    return returnStyles;
};
/**
 * Swiping animation handler for the default 'sliding' style animation
 * @param delta
 * @param props
 * @param state
 * @param setState
 */ module.exports.slideAnimationHandler = $7c7b29471445f17e$var$slideAnimationHandler;
var $7c7b29471445f17e$var$slideSwipeAnimationHandler = function slideSwipeAnimationHandler(delta, props, state, setState) {
    var returnStyles = {};
    var isHorizontal = props.axis === "horizontal";
    var childrenLength = $b6HlZ.Children.count(props.children);
    var initialBoundry = 0;
    var currentPosition = (0, $c4AIV.getPosition)(state.selectedItem, props);
    var finalBoundry = props.infiniteLoop ? (0, $c4AIV.getPosition)(childrenLength - 1, props) - 100 : (0, $c4AIV.getPosition)(childrenLength - 1, props);
    var axisDelta = isHorizontal ? delta.x : delta.y;
    var handledDelta = axisDelta; // prevent user from swiping left out of boundaries
    if (currentPosition === initialBoundry && axisDelta > 0) handledDelta = 0;
     // prevent user from swiping right out of boundaries
    if (currentPosition === finalBoundry && axisDelta < 0) handledDelta = 0;
    var position = currentPosition + 100 / (state.itemSize / handledDelta);
    var hasMoved = Math.abs(axisDelta) > props.swipeScrollTolerance;
    if (props.infiniteLoop && hasMoved) {
        // When allowing infinite loop, if we slide left from position 0 we reveal the cloned last slide that appears before it
        // if we slide even further we need to jump to other side so it can continue - and vice versa for the last slide
        if (state.selectedItem === 0 && position > -100) position -= childrenLength * 100;
        else if (state.selectedItem === childrenLength - 1 && position < -childrenLength * 100) position += childrenLength * 100;
    }
    if (!props.preventMovementUntilSwipeScrollTolerance || hasMoved || state.swipeMovementStarted) {
        if (!state.swipeMovementStarted) setState({
            swipeMovementStarted: true
        });
        returnStyles.itemListStyle = (0, $c4AIV.setPosition)(position, props.axis);
    } //allows scroll if the swipe was within the tolerance
    if (hasMoved && !state.cancelClick) setState({
        cancelClick: true
    });
    return returnStyles;
};
/**
 * Default 'sliding' style animination handler for when a swipe action stops.
 * @param props
 * @param state
 */ module.exports.slideSwipeAnimationHandler = $7c7b29471445f17e$var$slideSwipeAnimationHandler;
var $7c7b29471445f17e$var$slideStopSwipingHandler = function slideStopSwipingHandler(props, state) {
    var currentPosition = (0, $c4AIV.getPosition)(state.selectedItem, props);
    var itemListStyle = (0, $c4AIV.setPosition)(currentPosition, props.axis);
    return {
        itemListStyle: itemListStyle
    };
};
/**
 * Main animation handler for the default 'fade' style animation
 * @param props
 * @param state
 */ module.exports.slideStopSwipingHandler = $7c7b29471445f17e$var$slideStopSwipingHandler;
var $7c7b29471445f17e$var$fadeAnimationHandler = function fadeAnimationHandler(props, state) {
    var transitionTime = props.transitionTime + "ms";
    var transitionTimingFunction = "ease-in-out";
    var slideStyle = {
        position: "absolute",
        display: "block",
        zIndex: -2,
        minHeight: "100%",
        opacity: 0,
        top: 0,
        right: 0,
        left: 0,
        bottom: 0,
        transitionTimingFunction: transitionTimingFunction,
        msTransitionTimingFunction: transitionTimingFunction,
        MozTransitionTimingFunction: transitionTimingFunction,
        WebkitTransitionTimingFunction: transitionTimingFunction,
        OTransitionTimingFunction: transitionTimingFunction
    };
    if (!state.swiping) slideStyle = $7c7b29471445f17e$var$_objectSpread($7c7b29471445f17e$var$_objectSpread({}, slideStyle), {}, {
        WebkitTransitionDuration: transitionTime,
        MozTransitionDuration: transitionTime,
        OTransitionDuration: transitionTime,
        transitionDuration: transitionTime,
        msTransitionDuration: transitionTime
    });
    return {
        slideStyle: slideStyle,
        selectedStyle: $7c7b29471445f17e$var$_objectSpread($7c7b29471445f17e$var$_objectSpread({}, slideStyle), {}, {
            opacity: 1,
            position: "relative"
        }),
        prevStyle: $7c7b29471445f17e$var$_objectSpread({}, slideStyle)
    };
};
module.exports.fadeAnimationHandler = $7c7b29471445f17e$var$fadeAnimationHandler;

});


parcelRegister("gdCxA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function get() {
        return $bcebc19a312affa6$var$_ReactGoogleAutocomplete.default;
    }
});
Object.defineProperty(module.exports, "usePlacesWidget", {
    enumerable: true,
    get: function get() {
        return $bcebc19a312affa6$var$_usePlacesWidget.default;
    }
});

var $bcebc19a312affa6$var$_ReactGoogleAutocomplete = $bcebc19a312affa6$var$_interopRequireDefault((parcelRequire("7Sgdl")));

var $bcebc19a312affa6$var$_usePlacesWidget = $bcebc19a312affa6$var$_interopRequireDefault((parcelRequire("8boNz")));
function $bcebc19a312affa6$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRegister("7Sgdl", function(module, exports) {
"use strict";
function $5bba275e9e0e76af$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $5bba275e9e0e76af$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $5bba275e9e0e76af$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $5bba275e9e0e76af$var$_typeof(obj);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5bba275e9e0e76af$var$_react = $5bba275e9e0e76af$var$_interopRequireWildcard((parcelRequire("b6HlZ")));

var $5bba275e9e0e76af$var$_propTypes = $5bba275e9e0e76af$var$_interopRequireDefault((parcelRequire("aRbOc")));

var $5bba275e9e0e76af$var$_usePlacesWidget2 = $5bba275e9e0e76af$var$_interopRequireDefault((parcelRequire("8boNz")));
function $5bba275e9e0e76af$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $5bba275e9e0e76af$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($5bba275e9e0e76af$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $5bba275e9e0e76af$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $5bba275e9e0e76af$var$_typeof(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $5bba275e9e0e76af$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $5bba275e9e0e76af$var$_extends() {
    $5bba275e9e0e76af$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $5bba275e9e0e76af$var$_extends.apply(this, arguments);
}
function $5bba275e9e0e76af$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $5bba275e9e0e76af$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $5bba275e9e0e76af$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $5bba275e9e0e76af$var$ReactGoogleAutocomplete(props) {
    var onPlaceSelected = props.onPlaceSelected, apiKey = props.apiKey, libraries = props.libraries, inputAutocompleteValue = props.inputAutocompleteValue, options = props.options, googleMapsScriptBaseUrl = props.googleMapsScriptBaseUrl, refProp = props.refProp, language = props.language, rest = $5bba275e9e0e76af$var$_objectWithoutProperties(props, [
        "onPlaceSelected",
        "apiKey",
        "libraries",
        "inputAutocompleteValue",
        "options",
        "googleMapsScriptBaseUrl",
        "refProp",
        "language"
    ]);
    var _usePlacesWidget = (0, $5bba275e9e0e76af$var$_usePlacesWidget2.default)({
        ref: refProp,
        googleMapsScriptBaseUrl: googleMapsScriptBaseUrl,
        onPlaceSelected: onPlaceSelected,
        apiKey: apiKey,
        libraries: libraries,
        inputAutocompleteValue: inputAutocompleteValue,
        options: options,
        language: language
    }), ref = _usePlacesWidget.ref;
    return /*#__PURE__*/ $5bba275e9e0e76af$var$_react.default.createElement("input", $5bba275e9e0e76af$var$_extends({
        ref: ref
    }, rest));
}
$5bba275e9e0e76af$var$ReactGoogleAutocomplete.propTypes = {
    apiKey: $5bba275e9e0e76af$var$_propTypes.default.string,
    libraries: $5bba275e9e0e76af$var$_propTypes.default.arrayOf($5bba275e9e0e76af$var$_propTypes.default.string),
    ref: $5bba275e9e0e76af$var$_propTypes.default.oneOfType([
        $5bba275e9e0e76af$var$_propTypes.default.func,
        $5bba275e9e0e76af$var$_propTypes.default.shape({
            current: $5bba275e9e0e76af$var$_propTypes.default.any
        })
    ]),
    googleMapsScriptBaseUrl: $5bba275e9e0e76af$var$_propTypes.default.string,
    onPlaceSelected: $5bba275e9e0e76af$var$_propTypes.default.func,
    inputAutocompleteValue: $5bba275e9e0e76af$var$_propTypes.default.string,
    options: $5bba275e9e0e76af$var$_propTypes.default.shape({
        componentRestrictions: $5bba275e9e0e76af$var$_propTypes.default.object,
        bounds: $5bba275e9e0e76af$var$_propTypes.default.object,
        location: $5bba275e9e0e76af$var$_propTypes.default.object,
        offset: $5bba275e9e0e76af$var$_propTypes.default.number,
        origin: $5bba275e9e0e76af$var$_propTypes.default.object,
        radius: $5bba275e9e0e76af$var$_propTypes.default.number,
        sessionToken: $5bba275e9e0e76af$var$_propTypes.default.object,
        types: $5bba275e9e0e76af$var$_propTypes.default.arrayOf($5bba275e9e0e76af$var$_propTypes.default.string)
    }),
    language: $5bba275e9e0e76af$var$_propTypes.default.string
};
var $5bba275e9e0e76af$var$_default = /*#__PURE__*/ (0, $5bba275e9e0e76af$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $5bba275e9e0e76af$var$_react.default.createElement($5bba275e9e0e76af$var$ReactGoogleAutocomplete, $5bba275e9e0e76af$var$_extends({}, props, {
        refProp: ref
    }));
});
module.exports.default = $5bba275e9e0e76af$var$_default;

});
parcelRegister("8boNz", function(module, exports) {
"use strict";
function $5f5296443dfce280$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $5f5296443dfce280$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $5f5296443dfce280$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $5f5296443dfce280$var$_typeof(obj);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5f5296443dfce280$var$usePlacesWidget;

var $5f5296443dfce280$var$_react = $5f5296443dfce280$var$_interopRequireWildcard((parcelRequire("b6HlZ")));

var $dxqNt = parcelRequire("dxqNt");

var $8ZL6A = parcelRequire("8ZL6A");
function $5f5296443dfce280$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($5f5296443dfce280$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $5f5296443dfce280$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $5f5296443dfce280$var$_typeof(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $5f5296443dfce280$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $5f5296443dfce280$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $5f5296443dfce280$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $5f5296443dfce280$var$ownKeys(Object(source), true).forEach(function(key) {
            $5f5296443dfce280$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $5f5296443dfce280$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $5f5296443dfce280$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $5f5296443dfce280$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $5f5296443dfce280$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $5f5296443dfce280$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $5f5296443dfce280$var$usePlacesWidget(props) {
    var ref = props.ref, onPlaceSelected = props.onPlaceSelected, apiKey = props.apiKey, _props$libraries = props.libraries, libraries = _props$libraries === void 0 ? "places" : _props$libraries, _props$inputAutocompl = props.inputAutocompleteValue, inputAutocompleteValue = _props$inputAutocompl === void 0 ? "new-password" : _props$inputAutocompl, _props$options = props.options;
    _props$options = _props$options === void 0 ? {} : _props$options;
    var _props$options$types = _props$options.types, types = _props$options$types === void 0 ? [
        "(cities)"
    ] : _props$options$types, componentRestrictions = _props$options.componentRestrictions, _props$options$fields = _props$options.fields, fields = _props$options$fields === void 0 ? [
        "address_components",
        "geometry.location",
        "place_id",
        "formatted_address"
    ] : _props$options$fields, bounds = _props$options.bounds, options = $5f5296443dfce280$var$_objectWithoutProperties(_props$options, [
        "types",
        "componentRestrictions",
        "fields",
        "bounds"
    ]), _props$googleMapsScri = props.googleMapsScriptBaseUrl, googleMapsScriptBaseUrl = _props$googleMapsScri === void 0 ? $8ZL6A.GOOGLE_MAP_SCRIPT_BASE_URL : _props$googleMapsScri, language = props.language;
    var inputRef = (0, $5f5296443dfce280$var$_react.useRef)(null);
    var event = (0, $5f5296443dfce280$var$_react.useRef)(null);
    var autocompleteRef = (0, $5f5296443dfce280$var$_react.useRef)(null);
    var observerHack = (0, $5f5296443dfce280$var$_react.useRef)(null);
    var languageQueryParam = language ? "&language=".concat(language) : "";
    var googleMapsScriptUrl = "".concat(googleMapsScriptBaseUrl, "?libraries=").concat(libraries, "&key=").concat(apiKey).concat(languageQueryParam);
    var handleLoadScript = (0, $5f5296443dfce280$var$_react.useCallback)(function() {
        return (0, $dxqNt.loadGoogleMapScript)(googleMapsScriptBaseUrl, googleMapsScriptUrl);
    }, [
        googleMapsScriptBaseUrl,
        googleMapsScriptUrl
    ]);
    (0, $5f5296443dfce280$var$_react.useEffect)(function() {
        var config = $5f5296443dfce280$var$_objectSpread($5f5296443dfce280$var$_objectSpread({}, options), {}, {
            fields: fields,
            types: types,
            bounds: bounds
        });
        if (componentRestrictions) config.componentRestrictions = componentRestrictions;
        if (autocompleteRef.current || !inputRef.current || !$dxqNt.isBrowser) return;
        if (ref && !ref.current) ref.current = inputRef.current;
        var handleAutoComplete = function handleAutoComplete() {
            var _google$maps;
            if (typeof google === "undefined") return console.error("Google has not been found. Make sure your provide apiKey prop.");
            if (!((_google$maps = google.maps) !== null && _google$maps !== void 0 && _google$maps.places)) return console.error("Google maps places API must be loaded.");
            if (!inputRef.current instanceof HTMLInputElement) return console.error("Input ref must be HTMLInputElement.");
            autocompleteRef.current = new google.maps.places.Autocomplete(inputRef.current, config);
            if (autocompleteRef.current) event.current = autocompleteRef.current.addListener("place_changed", function() {
                if (onPlaceSelected && autocompleteRef && autocompleteRef.current) onPlaceSelected(autocompleteRef.current.getPlace(), inputRef.current, autocompleteRef.current);
            });
        };
        if (apiKey) handleLoadScript().then(function() {
            return handleAutoComplete();
        });
        else handleAutoComplete();
        return function() {
            return event.current ? event.current.remove() : undefined;
        };
    }, []); // Autofill workaround adapted from https://stackoverflow.com/questions/29931712/chrome-autofill-covers-autocomplete-for-google-maps-api-v3/49161445#49161445
    (0, $5f5296443dfce280$var$_react.useEffect)(function() {
        var _React$version;
        // TODO find out why react 18(strict mode) hangs the page loading
        if (!($5f5296443dfce280$var$_react.default !== null && $5f5296443dfce280$var$_react.default !== void 0 && (_React$version = $5f5296443dfce280$var$_react.default.version) !== null && _React$version !== void 0 && _React$version.startsWith("18")) && $dxqNt.isBrowser && window.MutationObserver && inputRef.current && inputRef.current instanceof HTMLInputElement) {
            observerHack.current = new MutationObserver(function() {
                observerHack.current.disconnect();
                if (inputRef.current) inputRef.current.autocomplete = inputAutocompleteValue;
            });
            observerHack.current.observe(inputRef.current, {
                attributes: true,
                attributeFilter: [
                    "autocomplete"
                ]
            });
        }
    }, [
        inputAutocompleteValue
    ]);
    (0, $5f5296443dfce280$var$_react.useEffect)(function() {
        if (autocompleteRef.current) autocompleteRef.current.setFields(fields);
    }, [
        fields
    ]);
    (0, $5f5296443dfce280$var$_react.useEffect)(function() {
        if (autocompleteRef.current) autocompleteRef.current.setBounds(bounds);
    }, [
        bounds
    ]);
    (0, $5f5296443dfce280$var$_react.useEffect)(function() {
        if (autocompleteRef.current) autocompleteRef.current.setComponentRestrictions(componentRestrictions);
    }, [
        componentRestrictions
    ]);
    (0, $5f5296443dfce280$var$_react.useEffect)(function() {
        if (autocompleteRef.current) autocompleteRef.current.setOptions(options);
    }, [
        options
    ]);
    return {
        ref: inputRef,
        autocompleteRef: autocompleteRef
    };
}

});
parcelRegister("dxqNt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.loadGoogleMapScript = module.exports.isBrowser = void 0;
var $9db324bcc4bdf26c$var$isBrowser = typeof window !== "undefined" && window.document;
module.exports.isBrowser = $9db324bcc4bdf26c$var$isBrowser;
var $9db324bcc4bdf26c$var$loadGoogleMapScript = function loadGoogleMapScript(googleMapsScriptBaseUrl, googleMapsScriptUrl) {
    if (!$9db324bcc4bdf26c$var$isBrowser) return Promise.resolve();
    if (typeof google !== "undefined") {
        if (google.maps && google.maps.api) return Promise.resolve();
    }
    var scriptElements = document.querySelectorAll('script[src*="'.concat(googleMapsScriptBaseUrl, '"]'));
    if (scriptElements && scriptElements.length) return new Promise(function(resolve) {
        // in case we already have a script on the page and it's loaded we resolve
        if (typeof google !== "undefined") return resolve(); // otherwise we wait until it's loaded and resolve
        scriptElements[0].addEventListener("load", function() {
            return resolve();
        });
    });
    var scriptUrl = new URL(googleMapsScriptUrl);
    scriptUrl.searchParams.set("callback", "__REACT_GOOGLE_AUTOCOMPLETE_CALLBACK__");
    var el = document.createElement("script");
    el.src = scriptUrl.toString();
    return new Promise(function(resolve) {
        window.__REACT_GOOGLE_AUTOCOMPLETE_CALLBACK__ = resolve;
        document.body.appendChild(el);
    });
};
module.exports.loadGoogleMapScript = $9db324bcc4bdf26c$var$loadGoogleMapScript;

});

parcelRegister("8ZL6A", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GOOGLE_MAP_SCRIPT_BASE_URL = void 0;
var $68c88f610324a268$var$GOOGLE_MAP_SCRIPT_BASE_URL = "https://maps.googleapis.com/maps/api/js";
module.exports.GOOGLE_MAP_SCRIPT_BASE_URL = $68c88f610324a268$var$GOOGLE_MAP_SCRIPT_BASE_URL;

});




var $23a5a59c8bbc016b$exports = {};


(parcelRequire("8rEqs")).register((parcelRequire("fF0r8")).getBundleURL("7lpHJ"), JSON.parse('["7lpHJ","index.js","jD60Z","web-vitals.c0e2d029.js","egTCL","clock.590229c4.png","4Mk7P","chat.9aae76f3.svg","dyrKA","left.3207b72d.svg","a3DBV","right.61dca77f.svg","aKOY1","tick.8befb6e6.svg","l5CmB","info.2c5cb62a.svg","jBb4p","meeting-room.40860c11.svg","6bM9m","meeting-room-selected.ca0016ad.svg","ezhBS","flexday-suite.57a38e46.svg","hK1jj","flexday-suite-selected.8bf617a1.svg","jQi3r","private-office.81c04e3b.svg","d2w9F","private-office-selected.9912a0e1.svg","3gsJZ","map-center.1f48b751.svg","b0Bof","initial-center.47f7c0e5.svg","f4wFV","cross.f890e3df.svg","azVUt","check.d1f29035.svg","94rLu","apple_si.481ec491.png","6mUns","google_si.0c9940fa.svg","9mT8N","apple_su.41cbc952.png","hpaJl","google_su.aeff0ed2.svg","b55N7","user.66199745.svg","6hIYx","menu.5d9374a3.svg","bovx8","index.css"]'));

var $94829a8b99aa12e4$exports = {};
"use strict";

$94829a8b99aa12e4$exports = (parcelRequire("kl2BW"));


parcelRequire("b6HlZ");

var $3uMgk = parcelRequire("3uMgk");

const $ea833559f5a67bb4$var$reportWebVitals = (onPerfEntry)=>{
    if (onPerfEntry && onPerfEntry instanceof Function) (parcelRequire("e0pK3")).then(({ getCLS: getCLS, getFID: getFID, getFCP: getFCP, getLCP: getLCP, getTTFB: getTTFB })=>{
        getCLS(onPerfEntry);
        getFID(onPerfEntry);
        getFCP(onPerfEntry);
        getLCP(onPerfEntry);
        getTTFB(onPerfEntry);
    });
};
var $ea833559f5a67bb4$export$2e2bcd8739ae039 = $ea833559f5a67bb4$var$reportWebVitals;





var $b6HlZ = parcelRequire("b6HlZ");
/**
 * @typedef {import('mdast').Root} Root
 * @typedef {import('micromark-extension-gfm').Options & import('mdast-util-gfm').Options} Options
 */ /**
 * @typedef {import('micromark-extension-gfm-footnote').HtmlOptions} HtmlOptions
 * @typedef {import('micromark-extension-gfm-strikethrough').Options} Options
 * @typedef {import('micromark-util-types').Extension} Extension
 * @typedef {import('micromark-util-types').HtmlExtension} HtmlExtension
 */ /**
 * @typedef {import('micromark-util-types').Extension} Extension
 * @typedef {import('micromark-util-types').Handles} Handles
 * @typedef {import('micromark-util-types').HtmlExtension} HtmlExtension
 * @typedef {import('micromark-util-types').NormalizedExtension} NormalizedExtension
 */ /**
 * Like `Array#splice`, but smarter for giant arrays.
 *
 * `Array#splice` takes all items to be inserted as individual argument which
 * causes a stack overflow in V8 when trying to insert 100k items for instance.
 *
 * Otherwise, this does not return the removed items, and takes `items` as an
 * array instead of rest parameters.
 *
 * @template {unknown} T
 *   Item type.
 * @param {Array<T>} list
 *   List to operate on.
 * @param {number} start
 *   Index to remove/insert at (can be negative).
 * @param {number} remove
 *   Number of items to remove.
 * @param {Array<T>} items
 *   Items to inject into `list`.
 * @returns {void}
 *   Nothing.
 */ function $76c325c59203cf92$export$869882364835d202(list, start, remove, items) {
    const end = list.length;
    let chunkStart = 0;
    /** @type {Array<unknown>} */ let parameters;
    // Make start between zero and `end` (included).
    if (start < 0) start = -start > end ? 0 : end + start;
    else start = start > end ? end : start;
    remove = remove > 0 ? remove : 0;
    // No need to chunk the items if there’s only a couple (10k) items.
    if (items.length < 10000) {
        parameters = Array.from(items);
        parameters.unshift(start, remove);
        // @ts-expect-error Hush, it’s fine.
        list.splice(...parameters);
    } else {
        // Delete `remove` items starting from `start`
        if (remove) list.splice(start, remove);
        // Insert the items in chunks to not cause stack overflows.
        while(chunkStart < items.length){
            parameters = items.slice(chunkStart, chunkStart + 10000);
            parameters.unshift(start, 0);
            // @ts-expect-error Hush, it’s fine.
            list.splice(...parameters);
            chunkStart += 10000;
            start += 10000;
        }
    }
}
function $76c325c59203cf92$export$4cbf152802aa238(list, items) {
    if (list.length > 0) {
        $76c325c59203cf92$export$869882364835d202(list, list.length, 0, items);
        return list;
    }
    return items;
}


const $68d1ffdc2f9ceacd$var$hasOwnProperty = {}.hasOwnProperty;
function $68d1ffdc2f9ceacd$export$86a865d89ef3c690(extensions) {
    /** @type {NormalizedExtension} */ const all = {};
    let index = -1;
    while(++index < extensions.length)$68d1ffdc2f9ceacd$var$syntaxExtension(all, extensions[index]);
    return all;
}
/**
 * Merge `extension` into `all`.
 *
 * @param {NormalizedExtension} all
 *   Extension to merge into.
 * @param {Extension} extension
 *   Extension to merge.
 * @returns {void}
 */ function $68d1ffdc2f9ceacd$var$syntaxExtension(all, extension) {
    /** @type {keyof Extension} */ let hook;
    for(hook in extension){
        const maybe = $68d1ffdc2f9ceacd$var$hasOwnProperty.call(all, hook) ? all[hook] : undefined;
        /** @type {Record<string, unknown>} */ const left = maybe || (all[hook] = {});
        /** @type {Record<string, unknown> | undefined} */ const right = extension[hook];
        /** @type {string} */ let code;
        if (right) for(code in right){
            if (!$68d1ffdc2f9ceacd$var$hasOwnProperty.call(left, code)) left[code] = [];
            const value = right[code];
            $68d1ffdc2f9ceacd$var$constructs(// @ts-expect-error Looks like a list.
            left[code], Array.isArray(value) ? value : value ? [
                value
            ] : []);
        }
    }
}
/**
 * Merge `list` into `existing` (both lists of constructs).
 * Mutates `existing`.
 *
 * @param {Array<unknown>} existing
 * @param {Array<unknown>} list
 * @returns {void}
 */ function $68d1ffdc2f9ceacd$var$constructs(existing, list) {
    let index = -1;
    /** @type {Array<unknown>} */ const before = [];
    while(++index < list.length)(list[index].add === "after" ? existing : before).push(list[index]);
    (0, $76c325c59203cf92$export$869882364835d202)(existing, 0, 0, before);
}
function $68d1ffdc2f9ceacd$export$eaf8c406dfb0a620(htmlExtensions) {
    /** @type {HtmlExtension} */ const handlers = {};
    let index = -1;
    while(++index < htmlExtensions.length)$68d1ffdc2f9ceacd$var$htmlExtension(handlers, htmlExtensions[index]);
    return handlers;
}
/**
 * Merge `extension` into `all`.
 *
 * @param {HtmlExtension} all
 *   Extension to merge into.
 * @param {HtmlExtension} extension
 *   Extension to merge.
 * @returns {void}
 */ function $68d1ffdc2f9ceacd$var$htmlExtension(all, extension) {
    /** @type {keyof HtmlExtension} */ let hook;
    for(hook in extension){
        const maybe = $68d1ffdc2f9ceacd$var$hasOwnProperty.call(all, hook) ? all[hook] : undefined;
        const left = maybe || (all[hook] = {});
        const right = extension[hook];
        /** @type {keyof Handles} */ let type;
        if (right) for(type in right)// @ts-expect-error assume document vs regular handler are managed correctly.
        left[type] = right[type];
    }
}


/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').ConstructRecord} ConstructRecord
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Extension} Extension
 * @typedef {import('micromark-util-types').Previous} Previous
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ /**
 * @typedef {import('micromark-util-types').Code} Code
 */ // This module is generated by `script/`.
//
// CommonMark handles attention (emphasis, strong) markers based on what comes
// before or after them.
// One such difference is if those characters are Unicode punctuation.
// This script is generated from the Unicode data.
/**
 * Regular expression that matches a unicode punctuation character.
 */ const $7e4819415b6a4719$export$85b5101f24802e8c = /[!-\/:-@\[-`\{-~\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061D-\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0A76\u0AF0\u0C77\u0C84\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1B7D\u1B7E\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E4F\u2E52-\u2E5D\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]/;


const $d81ad7e99936a248$export$d65d6b62c24d5436 = $d81ad7e99936a248$var$regexCheck(/[A-Za-z]/);
const $d81ad7e99936a248$export$75c76db11865a9f4 = $d81ad7e99936a248$var$regexCheck(/[\dA-Za-z]/);
const $d81ad7e99936a248$export$4397998b34fe597d = $d81ad7e99936a248$var$regexCheck(/[#-'*+\--9=?A-Z^-~]/);
function $d81ad7e99936a248$export$67dbf494fc8394df(code) {
    return(// Special whitespace codes (which have negative values), C0 and Control
    // character DEL
    code !== null && (code < 32 || code === 127));
}
const $d81ad7e99936a248$export$ca8b5b1a6c320e6e = $d81ad7e99936a248$var$regexCheck(/\d/);
const $d81ad7e99936a248$export$eca2752363989806 = $d81ad7e99936a248$var$regexCheck(/[\dA-Fa-f]/);
const $d81ad7e99936a248$export$35794a7d1db99380 = $d81ad7e99936a248$var$regexCheck(/[!-/:-@[-`{-~]/);
function $d81ad7e99936a248$export$34a1dff1c0936953(code) {
    return code !== null && code < -2;
}
function $d81ad7e99936a248$export$a30284361b3814b7(code) {
    return code !== null && (code < 0 || code === 32);
}
function $d81ad7e99936a248$export$2c6cf65c1127992a(code) {
    return code === -2 || code === -1 || code === 32;
}
const $d81ad7e99936a248$export$aa04114dd888a7a0 = $d81ad7e99936a248$var$regexCheck((0, $7e4819415b6a4719$export$85b5101f24802e8c));
const $d81ad7e99936a248$export$a0ff789c034ffdf4 = $d81ad7e99936a248$var$regexCheck(/\s/);
/**
 * Create a code check from a regex.
 *
 * @param {RegExp} regex
 * @returns {(code: Code) => boolean}
 */ function $d81ad7e99936a248$var$regexCheck(regex) {
    return check;
    /**
   * Check whether a code matches the bound regex.
   *
   * @param {Code} code
   *   Character code.
   * @returns {boolean}
   *   Whether the character code matches the bound regex.
   */ function check(code) {
        return code !== null && regex.test(String.fromCharCode(code));
    }
}


const $87800cd4895ef869$var$wwwPrefix = {
    tokenize: $87800cd4895ef869$var$tokenizeWwwPrefix,
    partial: true
};
const $87800cd4895ef869$var$domain = {
    tokenize: $87800cd4895ef869$var$tokenizeDomain,
    partial: true
};
const $87800cd4895ef869$var$path = {
    tokenize: $87800cd4895ef869$var$tokenizePath,
    partial: true
};
const $87800cd4895ef869$var$trail = {
    tokenize: $87800cd4895ef869$var$tokenizeTrail,
    partial: true
};
const $87800cd4895ef869$var$emailDomainDotTrail = {
    tokenize: $87800cd4895ef869$var$tokenizeEmailDomainDotTrail,
    partial: true
};
const $87800cd4895ef869$var$wwwAutolink = {
    tokenize: $87800cd4895ef869$var$tokenizeWwwAutolink,
    previous: $87800cd4895ef869$var$previousWww
};
const $87800cd4895ef869$var$protocolAutolink = {
    tokenize: $87800cd4895ef869$var$tokenizeProtocolAutolink,
    previous: $87800cd4895ef869$var$previousProtocol
};
const $87800cd4895ef869$var$emailAutolink = {
    tokenize: $87800cd4895ef869$var$tokenizeEmailAutolink,
    previous: $87800cd4895ef869$var$previousEmail
};
/** @type {ConstructRecord} */ const $87800cd4895ef869$var$text = {};
const $87800cd4895ef869$export$608123d9b549151 = {
    text: $87800cd4895ef869$var$text
};
/** @type {Code} */ let $87800cd4895ef869$var$code = 48;
// Add alphanumerics.
while($87800cd4895ef869$var$code < 123){
    $87800cd4895ef869$var$text[$87800cd4895ef869$var$code] = $87800cd4895ef869$var$emailAutolink;
    $87800cd4895ef869$var$code++;
    if ($87800cd4895ef869$var$code === 58) $87800cd4895ef869$var$code = 65;
    else if ($87800cd4895ef869$var$code === 91) $87800cd4895ef869$var$code = 97;
}
$87800cd4895ef869$var$text[43] = $87800cd4895ef869$var$emailAutolink;
$87800cd4895ef869$var$text[45] = $87800cd4895ef869$var$emailAutolink;
$87800cd4895ef869$var$text[46] = $87800cd4895ef869$var$emailAutolink;
$87800cd4895ef869$var$text[95] = $87800cd4895ef869$var$emailAutolink;
$87800cd4895ef869$var$text[72] = [
    $87800cd4895ef869$var$emailAutolink,
    $87800cd4895ef869$var$protocolAutolink
];
$87800cd4895ef869$var$text[104] = [
    $87800cd4895ef869$var$emailAutolink,
    $87800cd4895ef869$var$protocolAutolink
];
$87800cd4895ef869$var$text[87] = [
    $87800cd4895ef869$var$emailAutolink,
    $87800cd4895ef869$var$wwwAutolink
];
$87800cd4895ef869$var$text[119] = [
    $87800cd4895ef869$var$emailAutolink,
    $87800cd4895ef869$var$wwwAutolink
];
// To do: perform email autolink literals on events, afterwards.
// That’s where `markdown-rs` and `cmark-gfm` perform it.
// It should look for `@`, then for atext backwards, and then for a label
// forwards.
// To do: `mailto:`, `xmpp:` protocol as prefix.
/**
 * Email autolink literal.
 *
 * ```markdown
 * > | a contact@example.org b
 *       ^^^^^^^^^^^^^^^^^^^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $87800cd4895ef869$var$tokenizeEmailAutolink(effects, ok, nok) {
    const self = this;
    /** @type {boolean | undefined} */ let dot;
    /** @type {boolean} */ let data;
    return start;
    /**
   * Start of email autolink literal.
   *
   * ```markdown
   * > | a contact@example.org b
   *       ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        if (!$87800cd4895ef869$var$gfmAtext(code) || !$87800cd4895ef869$var$previousEmail.call(self, self.previous) || $87800cd4895ef869$var$previousUnbalanced(self.events)) return nok(code);
        effects.enter("literalAutolink");
        effects.enter("literalAutolinkEmail");
        return atext(code);
    }
    /**
   * In email atext.
   *
   * ```markdown
   * > | a contact@example.org b
   *       ^
   * ```
   *
   * @type {State}
   */ function atext(code) {
        if ($87800cd4895ef869$var$gfmAtext(code)) {
            effects.consume(code);
            return atext;
        }
        if (code === 64) {
            effects.consume(code);
            return emailDomain;
        }
        return nok(code);
    }
    /**
   * In email domain.
   *
   * The reference code is a bit overly complex as it handles the `@`, of which
   * there may be just one.
   * Source: <https://github.com/github/cmark-gfm/blob/ef1cfcb/extensions/autolink.c#L318>
   *
   * ```markdown
   * > | a contact@example.org b
   *               ^
   * ```
   *
   * @type {State}
   */ function emailDomain(code) {
        // Dot followed by alphanumerical (not `-` or `_`).
        if (code === 46) return effects.check($87800cd4895ef869$var$emailDomainDotTrail, emailDomainAfter, emailDomainDot)(code);
        // Alphanumerical, `-`, and `_`.
        if (code === 45 || code === 95 || (0, $d81ad7e99936a248$export$75c76db11865a9f4)(code)) {
            data = true;
            effects.consume(code);
            return emailDomain;
        }
        // To do: `/` if xmpp.
        // Note: normally we’d truncate trailing punctuation from the link.
        // However, email autolink literals cannot contain any of those markers,
        // except for `.`, but that can only occur if it isn’t trailing.
        // So we can ignore truncating!
        return emailDomainAfter(code);
    }
    /**
   * In email domain, on dot that is not a trail.
   *
   * ```markdown
   * > | a contact@example.org b
   *                      ^
   * ```
   *
   * @type {State}
   */ function emailDomainDot(code) {
        effects.consume(code);
        dot = true;
        return emailDomain;
    }
    /**
   * After email domain.
   *
   * ```markdown
   * > | a contact@example.org b
   *                          ^
   * ```
   *
   * @type {State}
   */ function emailDomainAfter(code) {
        // Domain must not be empty, must include a dot, and must end in alphabetical.
        // Source: <https://github.com/github/cmark-gfm/blob/ef1cfcb/extensions/autolink.c#L332>.
        if (data && dot && (0, $d81ad7e99936a248$export$d65d6b62c24d5436)(self.previous)) {
            effects.exit("literalAutolinkEmail");
            effects.exit("literalAutolink");
            return ok(code);
        }
        return nok(code);
    }
}
/**
 * `www` autolink literal.
 *
 * ```markdown
 * > | a www.example.org b
 *       ^^^^^^^^^^^^^^^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $87800cd4895ef869$var$tokenizeWwwAutolink(effects, ok, nok) {
    const self = this;
    return wwwStart;
    /**
   * Start of www autolink literal.
   *
   * ```markdown
   * > | www.example.com/a?b#c
   *     ^
   * ```
   *
   * @type {State}
   */ function wwwStart(code) {
        if (code !== 87 && code !== 119 || !$87800cd4895ef869$var$previousWww.call(self, self.previous) || $87800cd4895ef869$var$previousUnbalanced(self.events)) return nok(code);
        effects.enter("literalAutolink");
        effects.enter("literalAutolinkWww");
        // Note: we *check*, so we can discard the `www.` we parsed.
        // If it worked, we consider it as a part of the domain.
        return effects.check($87800cd4895ef869$var$wwwPrefix, effects.attempt($87800cd4895ef869$var$domain, effects.attempt($87800cd4895ef869$var$path, wwwAfter), nok), nok)(code);
    }
    /**
   * After a www autolink literal.
   *
   * ```markdown
   * > | www.example.com/a?b#c
   *                          ^
   * ```
   *
   * @type {State}
   */ function wwwAfter(code) {
        effects.exit("literalAutolinkWww");
        effects.exit("literalAutolink");
        return ok(code);
    }
}
/**
 * Protocol autolink literal.
 *
 * ```markdown
 * > | a https://example.org b
 *       ^^^^^^^^^^^^^^^^^^^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $87800cd4895ef869$var$tokenizeProtocolAutolink(effects, ok, nok) {
    const self = this;
    let buffer = "";
    let seen = false;
    return protocolStart;
    /**
   * Start of protocol autolink literal.
   *
   * ```markdown
   * > | https://example.com/a?b#c
   *     ^
   * ```
   *
   * @type {State}
   */ function protocolStart(code) {
        if ((code === 72 || code === 104) && $87800cd4895ef869$var$previousProtocol.call(self, self.previous) && !$87800cd4895ef869$var$previousUnbalanced(self.events)) {
            effects.enter("literalAutolink");
            effects.enter("literalAutolinkHttp");
            buffer += String.fromCodePoint(code);
            effects.consume(code);
            return protocolPrefixInside;
        }
        return nok(code);
    }
    /**
   * In protocol.
   *
   * ```markdown
   * > | https://example.com/a?b#c
   *     ^^^^^
   * ```
   *
   * @type {State}
   */ function protocolPrefixInside(code) {
        // `5` is size of `https`
        if ((0, $d81ad7e99936a248$export$d65d6b62c24d5436)(code) && buffer.length < 5) {
            // @ts-expect-error: definitely number.
            buffer += String.fromCodePoint(code);
            effects.consume(code);
            return protocolPrefixInside;
        }
        if (code === 58) {
            const protocol = buffer.toLowerCase();
            if (protocol === "http" || protocol === "https") {
                effects.consume(code);
                return protocolSlashesInside;
            }
        }
        return nok(code);
    }
    /**
   * In slashes.
   *
   * ```markdown
   * > | https://example.com/a?b#c
   *           ^^
   * ```
   *
   * @type {State}
   */ function protocolSlashesInside(code) {
        if (code === 47) {
            effects.consume(code);
            if (seen) return afterProtocol;
            seen = true;
            return protocolSlashesInside;
        }
        return nok(code);
    }
    /**
   * After protocol, before domain.
   *
   * ```markdown
   * > | https://example.com/a?b#c
   *             ^
   * ```
   *
   * @type {State}
   */ function afterProtocol(code) {
        // To do: this is different from `markdown-rs`:
        // https://github.com/wooorm/markdown-rs/blob/b3a921c761309ae00a51fe348d8a43adbc54b518/src/construct/gfm_autolink_literal.rs#L172-L182
        return code === null || (0, $d81ad7e99936a248$export$67dbf494fc8394df)(code) || (0, $d81ad7e99936a248$export$a30284361b3814b7)(code) || (0, $d81ad7e99936a248$export$a0ff789c034ffdf4)(code) || (0, $d81ad7e99936a248$export$aa04114dd888a7a0)(code) ? nok(code) : effects.attempt($87800cd4895ef869$var$domain, effects.attempt($87800cd4895ef869$var$path, protocolAfter), nok)(code);
    }
    /**
   * After a protocol autolink literal.
   *
   * ```markdown
   * > | https://example.com/a?b#c
   *                              ^
   * ```
   *
   * @type {State}
   */ function protocolAfter(code) {
        effects.exit("literalAutolinkHttp");
        effects.exit("literalAutolink");
        return ok(code);
    }
}
/**
 * `www` prefix.
 *
 * ```markdown
 * > | a www.example.org b
 *       ^^^^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $87800cd4895ef869$var$tokenizeWwwPrefix(effects, ok, nok) {
    let size = 0;
    return wwwPrefixInside;
    /**
   * In www prefix.
   *
   * ```markdown
   * > | www.example.com
   *     ^^^^
   * ```
   *
   * @type {State}
   */ function wwwPrefixInside(code) {
        if ((code === 87 || code === 119) && size < 3) {
            size++;
            effects.consume(code);
            return wwwPrefixInside;
        }
        if (code === 46 && size === 3) {
            effects.consume(code);
            return wwwPrefixAfter;
        }
        return nok(code);
    }
    /**
   * After www prefix.
   *
   * ```markdown
   * > | www.example.com
   *         ^
   * ```
   *
   * @type {State}
   */ function wwwPrefixAfter(code) {
        // If there is *anything*, we can link.
        return code === null ? nok(code) : ok(code);
    }
}
/**
 * Domain.
 *
 * ```markdown
 * > | a https://example.org b
 *               ^^^^^^^^^^^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $87800cd4895ef869$var$tokenizeDomain(effects, ok, nok) {
    /** @type {boolean | undefined} */ let underscoreInLastSegment;
    /** @type {boolean | undefined} */ let underscoreInLastLastSegment;
    /** @type {boolean | undefined} */ let seen;
    return domainInside;
    /**
   * In domain.
   *
   * ```markdown
   * > | https://example.com/a
   *             ^^^^^^^^^^^
   * ```
   *
   * @type {State}
   */ function domainInside(code) {
        // Check whether this marker, which is a trailing punctuation
        // marker, optionally followed by more trailing markers, and then
        // followed by an end.
        if (code === 46 || code === 95) return effects.check($87800cd4895ef869$var$trail, domainAfter, domainAtPunctuation)(code);
        // GH documents that only alphanumerics (other than `-`, `.`, and `_`) can
        // occur, which sounds like ASCII only, but they also support `www.點看.com`,
        // so that’s Unicode.
        // Instead of some new production for Unicode alphanumerics, markdown
        // already has that for Unicode punctuation and whitespace, so use those.
        // Source: <https://github.com/github/cmark-gfm/blob/ef1cfcb/extensions/autolink.c#L12>.
        if (code === null || (0, $d81ad7e99936a248$export$a30284361b3814b7)(code) || (0, $d81ad7e99936a248$export$a0ff789c034ffdf4)(code) || code !== 45 && (0, $d81ad7e99936a248$export$aa04114dd888a7a0)(code)) return domainAfter(code);
        seen = true;
        effects.consume(code);
        return domainInside;
    }
    /**
   * In domain, at potential trailing punctuation, that was not trailing.
   *
   * ```markdown
   * > | https://example.com
   *                    ^
   * ```
   *
   * @type {State}
   */ function domainAtPunctuation(code) {
        // There is an underscore in the last segment of the domain
        if (code === 95) underscoreInLastSegment = true;
        else {
            underscoreInLastLastSegment = underscoreInLastSegment;
            underscoreInLastSegment = undefined;
        }
        effects.consume(code);
        return domainInside;
    }
    /**
   * After domain.
   *
   * ```markdown
   * > | https://example.com/a
   *                        ^
   * ```
   *
   * @type {State} */ function domainAfter(code) {
        // Note: that’s GH says a dot is needed, but it’s not true:
        // <https://github.com/github/cmark-gfm/issues/279>
        if (underscoreInLastLastSegment || underscoreInLastSegment || !seen) return nok(code);
        return ok(code);
    }
}
/**
 * Path.
 *
 * ```markdown
 * > | a https://example.org/stuff b
 *                          ^^^^^^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $87800cd4895ef869$var$tokenizePath(effects, ok) {
    let sizeOpen = 0;
    let sizeClose = 0;
    return pathInside;
    /**
   * In path.
   *
   * ```markdown
   * > | https://example.com/a
   *                        ^^
   * ```
   *
   * @type {State}
   */ function pathInside(code) {
        if (code === 40) {
            sizeOpen++;
            effects.consume(code);
            return pathInside;
        }
        // To do: `markdown-rs` also needs this.
        // If this is a paren, and there are less closings than openings,
        // we don’t check for a trail.
        if (code === 41 && sizeClose < sizeOpen) return pathAtPunctuation(code);
        // Check whether this trailing punctuation marker is optionally
        // followed by more trailing markers, and then followed
        // by an end.
        if (code === 33 || code === 34 || code === 38 || code === 39 || code === 41 || code === 42 || code === 44 || code === 46 || code === 58 || code === 59 || code === 60 || code === 63 || code === 93 || code === 95 || code === 126) return effects.check($87800cd4895ef869$var$trail, ok, pathAtPunctuation)(code);
        if (code === null || (0, $d81ad7e99936a248$export$a30284361b3814b7)(code) || (0, $d81ad7e99936a248$export$a0ff789c034ffdf4)(code)) return ok(code);
        effects.consume(code);
        return pathInside;
    }
    /**
   * In path, at potential trailing punctuation, that was not trailing.
   *
   * ```markdown
   * > | https://example.com/a"b
   *                          ^
   * ```
   *
   * @type {State}
   */ function pathAtPunctuation(code) {
        // Count closing parens.
        if (code === 41) sizeClose++;
        effects.consume(code);
        return pathInside;
    }
}
/**
 * Trail.
 *
 * This calls `ok` if this *is* the trail, followed by an end, which means
 * the entire trail is not part of the link.
 * It calls `nok` if this *is* part of the link.
 *
 * ```markdown
 * > | https://example.com").
 *                        ^^^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $87800cd4895ef869$var$tokenizeTrail(effects, ok, nok) {
    return trail;
    /**
   * In trail of domain or path.
   *
   * ```markdown
   * > | https://example.com").
   *                        ^
   * ```
   *
   * @type {State}
   */ function trail(code) {
        // Regular trailing punctuation.
        if (code === 33 || code === 34 || code === 39 || code === 41 || code === 42 || code === 44 || code === 46 || code === 58 || code === 59 || code === 63 || code === 95 || code === 126) {
            effects.consume(code);
            return trail;
        }
        // `&` followed by one or more alphabeticals and then a `;`, is
        // as a whole considered as trailing punctuation.
        // In all other cases, it is considered as continuation of the URL.
        if (code === 38) {
            effects.consume(code);
            return trailCharRefStart;
        }
        // Needed because we allow literals after `[`, as we fix:
        // <https://github.com/github/cmark-gfm/issues/278>.
        // Check that it is not followed by `(` or `[`.
        if (code === 93) {
            effects.consume(code);
            return trailBracketAfter;
        }
        if (// `<` is an end.
        code === 60 || // So is whitespace.
        code === null || (0, $d81ad7e99936a248$export$a30284361b3814b7)(code) || (0, $d81ad7e99936a248$export$a0ff789c034ffdf4)(code)) return ok(code);
        return nok(code);
    }
    /**
   * In trail, after `]`.
   *
   * > 👉 **Note**: this deviates from `cmark-gfm` to fix a bug.
   * > See end of <https://github.com/github/cmark-gfm/issues/278> for more.
   *
   * ```markdown
   * > | https://example.com](
   *                         ^
   * ```
   *
   * @type {State}
   */ function trailBracketAfter(code) {
        // Whitespace or something that could start a resource or reference is the end.
        // Switch back to trail otherwise.
        if (code === null || code === 40 || code === 91 || (0, $d81ad7e99936a248$export$a30284361b3814b7)(code) || (0, $d81ad7e99936a248$export$a0ff789c034ffdf4)(code)) return ok(code);
        return trail(code);
    }
    /**
   * In character-reference like trail, after `&`.
   *
   * ```markdown
   * > | https://example.com&amp;).
   *                         ^
   * ```
   *
   * @type {State}
   */ function trailCharRefStart(code) {
        // When non-alpha, it’s not a trail.
        return (0, $d81ad7e99936a248$export$d65d6b62c24d5436)(code) ? trailCharRefInside(code) : nok(code);
    }
    /**
   * In character-reference like trail.
   *
   * ```markdown
   * > | https://example.com&amp;).
   *                         ^
   * ```
   *
   * @type {State}
   */ function trailCharRefInside(code) {
        // Switch back to trail if this is well-formed.
        if (code === 59) {
            effects.consume(code);
            return trail;
        }
        if ((0, $d81ad7e99936a248$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return trailCharRefInside;
        }
        // It’s not a trail.
        return nok(code);
    }
}
/**
 * Dot in email domain trail.
 *
 * This calls `ok` if this *is* the trail, followed by an end, which means
 * the trail is not part of the link.
 * It calls `nok` if this *is* part of the link.
 *
 * ```markdown
 * > | contact@example.org.
 *                        ^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $87800cd4895ef869$var$tokenizeEmailDomainDotTrail(effects, ok, nok) {
    return start;
    /**
   * Dot.
   *
   * ```markdown
   * > | contact@example.org.
   *                    ^   ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        // Must be dot.
        effects.consume(code);
        return after;
    }
    /**
   * After dot.
   *
   * ```markdown
   * > | contact@example.org.
   *                     ^   ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        // Not a trail if alphanumeric.
        return (0, $d81ad7e99936a248$export$75c76db11865a9f4)(code) ? nok(code) : ok(code);
    }
}
/**
 * See:
 * <https://github.com/github/cmark-gfm/blob/ef1cfcb/extensions/autolink.c#L156>.
 *
 * @type {Previous}
 */ function $87800cd4895ef869$var$previousWww(code) {
    return code === null || code === 40 || code === 42 || code === 95 || code === 91 || code === 93 || code === 126 || (0, $d81ad7e99936a248$export$a30284361b3814b7)(code);
}
/**
 * See:
 * <https://github.com/github/cmark-gfm/blob/ef1cfcb/extensions/autolink.c#L214>.
 *
 * @type {Previous}
 */ function $87800cd4895ef869$var$previousProtocol(code) {
    return !(0, $d81ad7e99936a248$export$d65d6b62c24d5436)(code);
}
/**
 * @this {TokenizeContext}
 * @type {Previous}
 */ function $87800cd4895ef869$var$previousEmail(code) {
    // Do not allow a slash “inside” atext.
    // The reference code is a bit weird, but that’s what it results in.
    // Source: <https://github.com/github/cmark-gfm/blob/ef1cfcb/extensions/autolink.c#L307>.
    // Other than slash, every preceding character is allowed.
    return !(code === 47 || $87800cd4895ef869$var$gfmAtext(code));
}
/**
 * @param {Code} code
 * @returns {boolean}
 */ function $87800cd4895ef869$var$gfmAtext(code) {
    return code === 43 || code === 45 || code === 46 || code === 95 || (0, $d81ad7e99936a248$export$75c76db11865a9f4)(code);
}
/**
 * @param {Array<Event>} events
 * @returns {boolean}
 */ function $87800cd4895ef869$var$previousUnbalanced(events) {
    let index = events.length;
    let result = false;
    while(index--){
        const token = events[index][1];
        if ((token.type === "labelLink" || token.type === "labelImage") && !token._balanced) {
            result = true;
            break;
        }
        // If we’ve seen this token, and it was marked as not having any unbalanced
        // bracket before it, we can exit.
        if (token._gfmAutolinkLiteralWalkedInto) {
            result = false;
            break;
        }
    }
    if (events.length > 0 && !result) // Mark the last token as “walked into” w/o finding
    // anything.
    events[events.length - 1][1]._gfmAutolinkLiteralWalkedInto = true;
    return result;
}

/**
 * @typedef {import('micromark-util-types').CompileContext} CompileContext
 * @typedef {import('micromark-util-types').Handle} Handle
 * @typedef {import('micromark-util-types').HtmlExtension} HtmlExtension
 * @typedef {import('micromark-util-types').Token} Token
 */ 
const $daee573aa38d4dce$var$characterReferences = {
    '"': "quot",
    "&": "amp",
    "<": "lt",
    ">": "gt"
};
function $daee573aa38d4dce$export$c564cdbbe6da493(value) {
    return value.replace(/["&<>]/g, replace);
    /**
   * @param {string} value
   * @returns {string}
   */ function replace(value) {
        // @ts-expect-error Hush, it’s fine.
        return "&" + $daee573aa38d4dce$var$characterReferences[value] + ";";
    }
}


function $4c6cf17b0d868e76$export$d130a2d684099e5a(url, protocol) {
    const value = (0, $daee573aa38d4dce$export$c564cdbbe6da493)($4c6cf17b0d868e76$export$e42a3e39590d28b5(url || ""));
    if (!protocol) return value;
    const colon = value.indexOf(":");
    const questionMark = value.indexOf("?");
    const numberSign = value.indexOf("#");
    const slash = value.indexOf("/");
    if (// If there is no protocol, it’s relative.
    colon < 0 || // If the first colon is after a `?`, `#`, or `/`, it’s not a protocol.
    slash > -1 && colon > slash || questionMark > -1 && colon > questionMark || numberSign > -1 && colon > numberSign || // It is a protocol, it should be allowed.
    protocol.test(value.slice(0, colon))) return value;
    return "";
}
function $4c6cf17b0d868e76$export$e42a3e39590d28b5(value) {
    /** @type {Array<string>} */ const result = [];
    let index = -1;
    let start = 0;
    let skip = 0;
    while(++index < value.length){
        const code = value.charCodeAt(index);
        /** @type {string} */ let replace = "";
        // A correct percent encoded value.
        if (code === 37 && (0, $d81ad7e99936a248$export$75c76db11865a9f4)(value.charCodeAt(index + 1)) && (0, $d81ad7e99936a248$export$75c76db11865a9f4)(value.charCodeAt(index + 2))) skip = 2;
        else if (code < 128) {
            if (!/[!#$&-;=?-Z_a-z~]/.test(String.fromCharCode(code))) replace = String.fromCharCode(code);
        } else if (code > 55295 && code < 57344) {
            const next = value.charCodeAt(index + 1);
            // A correct surrogate pair.
            if (code < 56320 && next > 56319 && next < 57344) {
                replace = String.fromCharCode(code, next);
                skip = 1;
            } else replace = "\uFFFD";
        } else replace = String.fromCharCode(code);
        if (replace) {
            result.push(value.slice(start, index), encodeURIComponent(replace));
            start = index + skip + 1;
            replace = "";
        }
        if (skip) {
            index += skip;
            skip = 0;
        }
    }
    return result.join("") + value.slice(start);
}


const $473d0cdfb43c46c1$export$999603f1f1c3d2f9 = {
    exit: {
        literalAutolinkEmail: $473d0cdfb43c46c1$var$literalAutolinkEmail,
        literalAutolinkHttp: $473d0cdfb43c46c1$var$literalAutolinkHttp,
        literalAutolinkWww: $473d0cdfb43c46c1$var$literalAutolinkWww
    }
};
/**
 * @this {CompileContext}
 * @type {Handle}
 */ function $473d0cdfb43c46c1$var$literalAutolinkWww(token) {
    $473d0cdfb43c46c1$var$anchorFromToken.call(this, token, "http://");
}
/**
 * @this {CompileContext}
 * @type {Handle}
 */ function $473d0cdfb43c46c1$var$literalAutolinkEmail(token) {
    $473d0cdfb43c46c1$var$anchorFromToken.call(this, token, "mailto:");
}
/**
 * @this {CompileContext}
 * @type {Handle}
 */ function $473d0cdfb43c46c1$var$literalAutolinkHttp(token) {
    $473d0cdfb43c46c1$var$anchorFromToken.call(this, token);
}
/**
 * @this CompileContext
 * @param {Token} token
 * @param {string | null | undefined} [protocol]
 * @returns {void}
 */ function $473d0cdfb43c46c1$var$anchorFromToken(token, protocol) {
    const url = this.sliceSerialize(token);
    this.tag('<a href="' + (0, $4c6cf17b0d868e76$export$d130a2d684099e5a)((protocol || "") + url) + '">');
    this.raw(this.encode(url));
    this.tag("</a>");
}


/**
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Exiter} Exiter
 * @typedef {import('micromark-util-types').Extension} Extension
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ /**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ /**
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenType} TokenType
 */ 
function $6b1271da345f2eae$export$ae105c1eb063a0a2(effects, ok, type, max) {
    const limit = max ? max - 1 : Number.POSITIVE_INFINITY;
    let size = 0;
    return start;
    /** @type {State} */ function start(code) {
        if ((0, $d81ad7e99936a248$export$2c6cf65c1127992a)(code)) {
            effects.enter(type);
            return prefix(code);
        }
        return ok(code);
    }
    /** @type {State} */ function prefix(code) {
        if ((0, $d81ad7e99936a248$export$2c6cf65c1127992a)(code) && size++ < limit) {
            effects.consume(code);
            return prefix;
        }
        effects.exit(type);
        return ok(code);
    }
}



const $9a8f432cf07da3bc$export$d50d28ce3ab2a612 = {
    tokenize: $9a8f432cf07da3bc$var$tokenizeBlankLine,
    partial: true
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $9a8f432cf07da3bc$var$tokenizeBlankLine(effects, ok, nok) {
    return start;
    /**
   * Start of blank line.
   *
   * > 👉 **Note**: `␠` represents a space character.
   *
   * ```markdown
   * > | ␠␠␊
   *     ^
   * > | ␊
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        return (0, $d81ad7e99936a248$export$2c6cf65c1127992a)(code) ? (0, $6b1271da345f2eae$export$ae105c1eb063a0a2)(effects, after, "linePrefix")(code) : after(code);
    }
    /**
   * At eof/eol, after optional whitespace.
   *
   * > 👉 **Note**: `␠` represents a space character.
   *
   * ```markdown
   * > | ␠␠␊
   *       ^
   * > | ␊
   *     ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        return code === null || (0, $d81ad7e99936a248$export$34a1dff1c0936953)(code) ? ok(code) : nok(code);
    }
}




/**
 * Normalize an identifier (as found in references, definitions).
 *
 * Collapses markdown whitespace, trim, and then lower- and uppercase.
 *
 * Some characters are considered “uppercase”, such as U+03F4 (`ϴ`), but if their
 * lowercase counterpart (U+03B8 (`θ`)) is uppercased will result in a different
 * uppercase character (U+0398 (`Θ`)).
 * So, to get a canonical form, we perform both lower- and uppercase.
 *
 * Using uppercase last makes sure keys will never interact with default
 * prototypal values (such as `constructor`): nothing in the prototype of
 * `Object` is uppercase.
 *
 * @param {string} value
 *   Identifier to normalize.
 * @returns {string}
 *   Normalized identifier.
 */ function $17274a453d2d9545$export$806d55e226cfcd08(value) {
    return value// Collapse markdown whitespace.
    .replace(/[\t\n\r ]+/g, " ")// Trim.
    .replace(/^ | $/g, "")// Some characters are considered “uppercase”, but if their lowercase
    // counterpart is uppercased will result in a different uppercase
    // character.
    // Hence, to get that form, we perform both lower- and uppercase.
    // Upper case makes sure keys will not interact with default prototypal
    // methods: no method is uppercase.
    .toLowerCase().toUpperCase();
}


const $699a5709302bc5fd$var$indent = {
    tokenize: $699a5709302bc5fd$var$tokenizeIndent,
    partial: true
};
function $699a5709302bc5fd$export$c82499b6656305df() {
    /** @type {Extension} */ return {
        document: {
            [91]: {
                tokenize: $699a5709302bc5fd$var$tokenizeDefinitionStart,
                continuation: {
                    tokenize: $699a5709302bc5fd$var$tokenizeDefinitionContinuation
                },
                exit: $699a5709302bc5fd$var$gfmFootnoteDefinitionEnd
            }
        },
        text: {
            [91]: {
                tokenize: $699a5709302bc5fd$var$tokenizeGfmFootnoteCall
            },
            [93]: {
                add: "after",
                tokenize: $699a5709302bc5fd$var$tokenizePotentialGfmFootnoteCall,
                resolveTo: $699a5709302bc5fd$var$resolveToPotentialGfmFootnoteCall
            }
        }
    };
}
// To do: remove after micromark update.
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $699a5709302bc5fd$var$tokenizePotentialGfmFootnoteCall(effects, ok, nok) {
    const self = this;
    let index = self.events.length;
    /** @type {Array<string>} */ // @ts-expect-error It’s fine!
    const defined = self.parser.gfmFootnotes || (self.parser.gfmFootnotes = []);
    /** @type {Token} */ let labelStart;
    // Find an opening.
    while(index--){
        const token = self.events[index][1];
        if (token.type === "labelImage") {
            labelStart = token;
            break;
        }
        // Exit if we’ve walked far enough.
        if (token.type === "gfmFootnoteCall" || token.type === "labelLink" || token.type === "label" || token.type === "image" || token.type === "link") break;
    }
    return start;
    /**
   * @type {State}
   */ function start(code) {
        if (!labelStart || !labelStart._balanced) return nok(code);
        const id = (0, $17274a453d2d9545$export$806d55e226cfcd08)(self.sliceSerialize({
            start: labelStart.end,
            end: self.now()
        }));
        if (id.codePointAt(0) !== 94 || !defined.includes(id.slice(1))) return nok(code);
        effects.enter("gfmFootnoteCallLabelMarker");
        effects.consume(code);
        effects.exit("gfmFootnoteCallLabelMarker");
        return ok(code);
    }
}
// To do: remove after micromark update.
/** @type {Resolver} */ function $699a5709302bc5fd$var$resolveToPotentialGfmFootnoteCall(events, context) {
    let index = events.length;
    /** @type {Token | undefined} */ let labelStart;
    // Find an opening.
    while(index--)if (events[index][1].type === "labelImage" && events[index][0] === "enter") {
        labelStart = events[index][1];
        break;
    }
    // Change the `labelImageMarker` to a `data`.
    events[index + 1][1].type = "data";
    events[index + 3][1].type = "gfmFootnoteCallLabelMarker";
    // The whole (without `!`):
    /** @type {Token} */ const call = {
        type: "gfmFootnoteCall",
        start: Object.assign({}, events[index + 3][1].start),
        end: Object.assign({}, events[events.length - 1][1].end)
    };
    // The `^` marker
    /** @type {Token} */ const marker = {
        type: "gfmFootnoteCallMarker",
        start: Object.assign({}, events[index + 3][1].end),
        end: Object.assign({}, events[index + 3][1].end)
    };
    // Increment the end 1 character.
    marker.end.column++;
    marker.end.offset++;
    marker.end._bufferIndex++;
    /** @type {Token} */ const string = {
        type: "gfmFootnoteCallString",
        start: Object.assign({}, marker.end),
        end: Object.assign({}, events[events.length - 1][1].start)
    };
    /** @type {Token} */ const chunk = {
        type: "chunkString",
        contentType: "string",
        start: Object.assign({}, string.start),
        end: Object.assign({}, string.end)
    };
    /** @type {Array<Event>} */ const replacement = [
        // Take the `labelImageMarker` (now `data`, the `!`)
        events[index + 1],
        events[index + 2],
        [
            "enter",
            call,
            context
        ],
        // The `[`
        events[index + 3],
        events[index + 4],
        // The `^`.
        [
            "enter",
            marker,
            context
        ],
        [
            "exit",
            marker,
            context
        ],
        // Everything in between.
        [
            "enter",
            string,
            context
        ],
        [
            "enter",
            chunk,
            context
        ],
        [
            "exit",
            chunk,
            context
        ],
        [
            "exit",
            string,
            context
        ],
        // The ending (`]`, properly parsed and labelled).
        events[events.length - 2],
        events[events.length - 1],
        [
            "exit",
            call,
            context
        ]
    ];
    events.splice(index, events.length - index + 1, ...replacement);
    return events;
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $699a5709302bc5fd$var$tokenizeGfmFootnoteCall(effects, ok, nok) {
    const self = this;
    /** @type {Array<string>} */ // @ts-expect-error It’s fine!
    const defined = self.parser.gfmFootnotes || (self.parser.gfmFootnotes = []);
    let size = 0;
    /** @type {boolean} */ let data;
    // Note: the implementation of `markdown-rs` is different, because it houses
    // core *and* extensions in one project.
    // Therefore, it can include footnote logic inside `label-end`.
    // We can’t do that, but luckily, we can parse footnotes in a simpler way than
    // needed for labels.
    return start;
    /**
   * Start of footnote label.
   *
   * ```markdown
   * > | a [^b] c
   *       ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("gfmFootnoteCall");
        effects.enter("gfmFootnoteCallLabelMarker");
        effects.consume(code);
        effects.exit("gfmFootnoteCallLabelMarker");
        return callStart;
    }
    /**
   * After `[`, at `^`.
   *
   * ```markdown
   * > | a [^b] c
   *        ^
   * ```
   *
   * @type {State}
   */ function callStart(code) {
        if (code !== 94) return nok(code);
        effects.enter("gfmFootnoteCallMarker");
        effects.consume(code);
        effects.exit("gfmFootnoteCallMarker");
        effects.enter("gfmFootnoteCallString");
        effects.enter("chunkString").contentType = "string";
        return callData;
    }
    /**
   * In label.
   *
   * ```markdown
   * > | a [^b] c
   *         ^
   * ```
   *
   * @type {State}
   */ function callData(code) {
        if (// Too long.
        size > 999 || // Closing brace with nothing.
        code === 93 && !data || // Space or tab is not supported by GFM for some reason.
        // `\n` and `[` not being supported makes sense.
        code === null || code === 91 || (0, $d81ad7e99936a248$export$a30284361b3814b7)(code)) return nok(code);
        if (code === 93) {
            effects.exit("chunkString");
            const token = effects.exit("gfmFootnoteCallString");
            if (!defined.includes((0, $17274a453d2d9545$export$806d55e226cfcd08)(self.sliceSerialize(token)))) return nok(code);
            effects.enter("gfmFootnoteCallLabelMarker");
            effects.consume(code);
            effects.exit("gfmFootnoteCallLabelMarker");
            effects.exit("gfmFootnoteCall");
            return ok;
        }
        if (!(0, $d81ad7e99936a248$export$a30284361b3814b7)(code)) data = true;
        size++;
        effects.consume(code);
        return code === 92 ? callEscape : callData;
    }
    /**
   * On character after escape.
   *
   * ```markdown
   * > | a [^b\c] d
   *           ^
   * ```
   *
   * @type {State}
   */ function callEscape(code) {
        if (code === 91 || code === 92 || code === 93) {
            effects.consume(code);
            size++;
            return callData;
        }
        return callData(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $699a5709302bc5fd$var$tokenizeDefinitionStart(effects, ok, nok) {
    const self = this;
    /** @type {Array<string>} */ // @ts-expect-error It’s fine!
    const defined = self.parser.gfmFootnotes || (self.parser.gfmFootnotes = []);
    /** @type {string} */ let identifier;
    let size = 0;
    /** @type {boolean | undefined} */ let data;
    return start;
    /**
   * Start of GFM footnote definition.
   *
   * ```markdown
   * > | [^a]: b
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("gfmFootnoteDefinition")._container = true;
        effects.enter("gfmFootnoteDefinitionLabel");
        effects.enter("gfmFootnoteDefinitionLabelMarker");
        effects.consume(code);
        effects.exit("gfmFootnoteDefinitionLabelMarker");
        return labelAtMarker;
    }
    /**
   * In label, at caret.
   *
   * ```markdown
   * > | [^a]: b
   *      ^
   * ```
   *
   * @type {State}
   */ function labelAtMarker(code) {
        if (code === 94) {
            effects.enter("gfmFootnoteDefinitionMarker");
            effects.consume(code);
            effects.exit("gfmFootnoteDefinitionMarker");
            effects.enter("gfmFootnoteDefinitionLabelString");
            effects.enter("chunkString").contentType = "string";
            return labelInside;
        }
        return nok(code);
    }
    /**
   * In label.
   *
   * > 👉 **Note**: `cmark-gfm` prevents whitespace from occurring in footnote
   * > definition labels.
   *
   * ```markdown
   * > | [^a]: b
   *       ^
   * ```
   *
   * @type {State}
   */ function labelInside(code) {
        if (// Too long.
        size > 999 || // Closing brace with nothing.
        code === 93 && !data || // Space or tab is not supported by GFM for some reason.
        // `\n` and `[` not being supported makes sense.
        code === null || code === 91 || (0, $d81ad7e99936a248$export$a30284361b3814b7)(code)) return nok(code);
        if (code === 93) {
            effects.exit("chunkString");
            const token = effects.exit("gfmFootnoteDefinitionLabelString");
            identifier = (0, $17274a453d2d9545$export$806d55e226cfcd08)(self.sliceSerialize(token));
            effects.enter("gfmFootnoteDefinitionLabelMarker");
            effects.consume(code);
            effects.exit("gfmFootnoteDefinitionLabelMarker");
            effects.exit("gfmFootnoteDefinitionLabel");
            return labelAfter;
        }
        if (!(0, $d81ad7e99936a248$export$a30284361b3814b7)(code)) data = true;
        size++;
        effects.consume(code);
        return code === 92 ? labelEscape : labelInside;
    }
    /**
   * After `\`, at a special character.
   *
   * > 👉 **Note**: `cmark-gfm` currently does not support escaped brackets:
   * > <https://github.com/github/cmark-gfm/issues/240>
   *
   * ```markdown
   * > | [^a\*b]: c
   *         ^
   * ```
   *
   * @type {State}
   */ function labelEscape(code) {
        if (code === 91 || code === 92 || code === 93) {
            effects.consume(code);
            size++;
            return labelInside;
        }
        return labelInside(code);
    }
    /**
   * After definition label.
   *
   * ```markdown
   * > | [^a]: b
   *         ^
   * ```
   *
   * @type {State}
   */ function labelAfter(code) {
        if (code === 58) {
            effects.enter("definitionMarker");
            effects.consume(code);
            effects.exit("definitionMarker");
            if (!defined.includes(identifier)) defined.push(identifier);
            // Any whitespace after the marker is eaten, forming indented code
            // is not possible.
            // No space is also fine, just like a block quote marker.
            return (0, $6b1271da345f2eae$export$ae105c1eb063a0a2)(effects, whitespaceAfter, "gfmFootnoteDefinitionWhitespace");
        }
        return nok(code);
    }
    /**
   * After definition prefix.
   *
   * ```markdown
   * > | [^a]: b
   *           ^
   * ```
   *
   * @type {State}
   */ function whitespaceAfter(code) {
        // `markdown-rs` has a wrapping token for the prefix that is closed here.
        return ok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $699a5709302bc5fd$var$tokenizeDefinitionContinuation(effects, ok, nok) {
    /// Start of footnote definition continuation.
    ///
    /// ```markdown
    ///   | [^a]: b
    /// > |     c
    ///     ^
    /// ```
    //
    // Either a blank line, which is okay, or an indented thing.
    return effects.check((0, $9a8f432cf07da3bc$export$d50d28ce3ab2a612), ok, effects.attempt($699a5709302bc5fd$var$indent, ok, nok));
}
/** @type {Exiter} */ function $699a5709302bc5fd$var$gfmFootnoteDefinitionEnd(effects) {
    effects.exit("gfmFootnoteDefinition");
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $699a5709302bc5fd$var$tokenizeIndent(effects, ok, nok) {
    const self = this;
    return (0, $6b1271da345f2eae$export$ae105c1eb063a0a2)(effects, afterPrefix, "gfmFootnoteDefinitionIndent", 5);
    /**
   * @type {State}
   */ function afterPrefix(code) {
        const tail = self.events[self.events.length - 1];
        return tail && tail[1].type === "gfmFootnoteDefinitionIndent" && tail[2].sliceSerialize(tail[1], true).length === 4 ? ok(code) : nok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').HtmlExtension} HtmlExtension
 */ /**
 * @callback BackLabelTemplate
 *   Generate a back label dynamically.
 *
 *   For the following markdown:
 *
 *   ```markdown
 *   Alpha[^micromark], bravo[^micromark], and charlie[^remark].
 *
 *   [^remark]: things about remark
 *   [^micromark]: things about micromark
 *   ```
 *
 *   This function will be called with:
 *
 *   * `0` and `0` for the backreference from `things about micromark` to
 *      `alpha`, as it is the first used definition, and the first call to it
 *   * `0` and `1` for the backreference from `things about micromark` to
 *      `bravo`, as it is the first used definition, and the second call to it
 *   * `1` and `0` for the backreference from `things about remark` to
 *      `charlie`, as it is the second used definition
 * @param {number} referenceIndex
 *   Index of the definition in the order that they are first referenced,
 *   0-indexed.
 * @param {number} rereferenceIndex
 *   Index of calls to the same definition, 0-indexed.
 * @returns {string}
 *   Back label to use when linking back from definitions to their reference.
 */ /**
 * @typedef Options
 *   Configuration.
 * @property {string} [clobberPrefix='user-content-']
 *   Prefix to use before the `id` attribute on footnotes to prevent them from
 *   *clobbering*.
 *
 *   The default is `'user-content-'`.
 *   Pass `''` for trusted markdown and when you are careful with
 *   polyfilling.
 *   You could pass a different prefix.
 *
 *   DOM clobbering is this:
 *
 *   ```html
 *   <p id="x"></p>
 *   <script>alert(x) // `x` now refers to the `p#x` DOM element</script>
 *   ```
 *
 *   The above example shows that elements are made available by browsers, by
 *   their ID, on the `window` object.
 *   This is a security risk because you might be expecting some other variable
 *   at that place.
 *   It can also break polyfills.
 *   Using a prefix solves these problems.
 * @property {string} [label='Footnotes']
 *   Textual label to use for the footnotes section.
 *
 *   The default value is `'Footnotes'`.
 *   Change it when the markdown is not in English.
 *
 *   This label is typically hidden visually (assuming a `sr-only` CSS class
 *   is defined that does that) and so affects screen readers only.
 *   If you do have such a class, but want to show this section to everyone,
 *   pass different attributes with the `labelAttributes` option.
 * @property {string} [labelAttributes='class="sr-only"']
 *   Attributes to use on the footnote label.
 *
 *   Change it to show the label and add other attributes.
 *
 *   This label is typically hidden visually (assuming an `sr-only` CSS class
 *   is defined that does that) and so affects screen readers only.
 *   If you do have such a class, but want to show this section to everyone,
 *   pass an empty string.
 *   You can also add different attributes.
 *
 *   > 👉 **Note**: `id="footnote-label"` is always added, because footnote
 *   > calls use it with `aria-describedby` to provide an accessible label.
 * @property {string} [labelTagName='h2']
 *   HTML tag name to use for the footnote label element.
 *
 *   Change it to match your document structure.
 *
 *   This label is typically hidden visually (assuming a `sr-only` CSS class
 *   is defined that does that) and so affects screen readers only.
 *   If you do have such a class, but want to show this section to everyone,
 *   pass different attributes with the `labelAttributes` option.
 * @property {BackLabelTemplate | string} [backLabel]
 *   Textual label to describe the backreference back to references.
 *
 *   The default value is:
 *
 *   ```js
 *   function defaultBackLabel(referenceIndex, rereferenceIndex) {
 *    return (
 *      'Back to reference ' +
 *      (referenceIndex + 1) +
 *      (rereferenceIndex > 1 ? '-' + rereferenceIndex : '')
 *    )
 *  }
 *   ```
 *
 *   Change it when the markdown is not in English.
 *
 *   This label is used in the `aria-label` attribute on each backreference
 *   (the `↩` links).
 *   It affects users of assistive technology.
 */ 

const $3c491ce8afba9b9e$var$own = {}.hasOwnProperty;
/** @type {Options} */ const $3c491ce8afba9b9e$var$emptyOptions = {};
function $3c491ce8afba9b9e$export$a18c77a47f4154b6(referenceIndex, rereferenceIndex) {
    return "Back to reference " + (referenceIndex + 1) + (rereferenceIndex > 1 ? "-" + rereferenceIndex : "");
}
function $3c491ce8afba9b9e$export$a731a1f6cf81900c(options) {
    const config = options || $3c491ce8afba9b9e$var$emptyOptions;
    const label = config.label || "Footnotes";
    const labelTagName = config.labelTagName || "h2";
    const labelAttributes = config.labelAttributes === null || config.labelAttributes === undefined ? 'class="sr-only"' : config.labelAttributes;
    const backLabel = config.backLabel || $3c491ce8afba9b9e$export$a18c77a47f4154b6;
    const clobberPrefix = config.clobberPrefix === null || config.clobberPrefix === undefined ? "user-content-" : config.clobberPrefix;
    return {
        enter: {
            gfmFootnoteDefinition () {
                const stack = this.getData("tightStack");
                stack.push(false);
            },
            gfmFootnoteDefinitionLabelString () {
                this.buffer();
            },
            gfmFootnoteCallString () {
                this.buffer();
            }
        },
        exit: {
            gfmFootnoteDefinition () {
                let definitions = this.getData("gfmFootnoteDefinitions");
                const footnoteStack = this.getData("gfmFootnoteDefinitionStack");
                const tightStack = this.getData("tightStack");
                const current = footnoteStack.pop();
                const value = this.resume();
                if (!definitions) this.setData("gfmFootnoteDefinitions", definitions = {});
                if (!$3c491ce8afba9b9e$var$own.call(definitions, current)) definitions[current] = value;
                tightStack.pop();
                this.setData("slurpOneLineEnding", true);
                // “Hack” to prevent a line ending from showing up if we’re in a definition in
                // an empty list item.
                this.setData("lastWasTag");
            },
            gfmFootnoteDefinitionLabelString (token) {
                let footnoteStack = /** @type {Array<string>} */ this.getData("gfmFootnoteDefinitionStack");
                if (!footnoteStack) this.setData("gfmFootnoteDefinitionStack", footnoteStack = []);
                footnoteStack.push((0, $17274a453d2d9545$export$806d55e226cfcd08)(this.sliceSerialize(token)));
                this.resume() // Drop the label.
                ;
                this.buffer() // Get ready for a value.
                ;
            },
            gfmFootnoteCallString (token) {
                let calls = this.getData("gfmFootnoteCallOrder");
                let counts = this.getData("gfmFootnoteCallCounts");
                const id = (0, $17274a453d2d9545$export$806d55e226cfcd08)(this.sliceSerialize(token));
                /** @type {number} */ let counter;
                this.resume();
                if (!calls) this.setData("gfmFootnoteCallOrder", calls = []);
                if (!counts) this.setData("gfmFootnoteCallCounts", counts = {});
                const index = calls.indexOf(id);
                const safeId = (0, $4c6cf17b0d868e76$export$d130a2d684099e5a)(id.toLowerCase());
                if (index === -1) {
                    calls.push(id);
                    counts[id] = 1;
                    counter = calls.length;
                } else {
                    counts[id]++;
                    counter = index + 1;
                }
                const reuseCounter = counts[id];
                this.tag('<sup><a href="#' + clobberPrefix + "fn-" + safeId + '" id="' + clobberPrefix + "fnref-" + safeId + (reuseCounter > 1 ? "-" + reuseCounter : "") + '" data-footnote-ref="" aria-describedby="footnote-label">' + String(counter) + "</a></sup>");
            },
            null () {
                const calls = /** @type {Array<string>} */ this.getData("gfmFootnoteCallOrder") || [];
                const counts = /** @type {Record<string, number>} */ this.getData("gfmFootnoteCallCounts") || {};
                const definitions = /** @type {Record<string, string>} */ this.getData("gfmFootnoteDefinitions") || {};
                let index = -1;
                if (calls.length > 0) {
                    this.lineEndingIfNeeded();
                    this.tag('<section data-footnotes="" class="footnotes"><' + labelTagName + ' id="footnote-label"' + (labelAttributes ? " " + labelAttributes : "") + ">");
                    this.raw(this.encode(label));
                    this.tag("</" + labelTagName + ">");
                    this.lineEndingIfNeeded();
                    this.tag("<ol>");
                }
                while(++index < calls.length){
                    // Called definitions are always defined.
                    const id = calls[index];
                    const safeId = (0, $4c6cf17b0d868e76$export$d130a2d684099e5a)(id.toLowerCase());
                    let referenceIndex = 0;
                    /** @type {Array<string>} */ const references = [];
                    while(++referenceIndex <= counts[id])references.push('<a href="#' + clobberPrefix + "fnref-" + safeId + (referenceIndex > 1 ? "-" + referenceIndex : "") + '" data-footnote-backref="" aria-label="' + this.encode(typeof backLabel === "string" ? backLabel : backLabel(index, referenceIndex)) + '" class="data-footnote-backref">\u21A9' + (referenceIndex > 1 ? "<sup>" + referenceIndex + "</sup>" : "") + "</a>");
                    const reference = references.join(" ");
                    let injected = false;
                    this.lineEndingIfNeeded();
                    this.tag('<li id="' + clobberPrefix + "fn-" + safeId + '">');
                    this.lineEndingIfNeeded();
                    this.tag(definitions[id].replace(/<\/p>(?:\r?\n|\r)?$/, (/** @type {string} */ $0)=>{
                        injected = true;
                        return " " + reference + $0;
                    }));
                    if (!injected) {
                        this.lineEndingIfNeeded();
                        this.tag(reference);
                    }
                    this.lineEndingIfNeeded();
                    this.tag("</li>");
                }
                if (calls.length > 0) {
                    this.lineEndingIfNeeded();
                    this.tag("</ol>");
                    this.lineEndingIfNeeded();
                    this.tag("</section>");
                }
            }
        }
    };
}


/**
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Extension} Extension
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 *
 * @typedef Options
 *   Configuration (optional).
 * @property {boolean} [singleTilde=true]
 *   Whether to support strikethrough with a single tilde.
 *
 *   Single tildes work on github.com, but are technically prohibited by the
 *   GFM spec.
 */ 
/**
 * @typedef {import('micromark-util-types').Code} Code
 */ 
function $9e0904f98da5bb5d$export$e3902bc0d835cad0(code) {
    if (code === null || (0, $d81ad7e99936a248$export$a30284361b3814b7)(code) || (0, $d81ad7e99936a248$export$a0ff789c034ffdf4)(code)) return 1;
    if ((0, $d81ad7e99936a248$export$aa04114dd888a7a0)(code)) return 2;
}


/**
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 */ /**
 * Call all `resolveAll`s.
 *
 * @param {Array<{resolveAll?: Resolver | undefined}>} constructs
 *   List of constructs, optionally with `resolveAll`s.
 * @param {Array<Event>} events
 *   List of events.
 * @param {TokenizeContext} context
 *   Context used by `tokenize`.
 * @returns {Array<Event>}
 *   Changed events.
 */ function $8c627d7d8981f0bc$export$3ff61ec196ff408b(constructs, events, context) {
    /** @type {Array<Resolver>} */ const called = [];
    let index = -1;
    while(++index < constructs.length){
        const resolve = constructs[index].resolveAll;
        if (resolve && !called.includes(resolve)) {
            events = resolve(events, context);
            called.push(resolve);
        }
    }
    return events;
}


function $877e44affd18fa60$export$8bbec8ea1400a00e(options) {
    const options_ = options || {};
    let single = options_.singleTilde;
    const tokenizer = {
        tokenize: tokenizeStrikethrough,
        resolveAll: resolveAllStrikethrough
    };
    if (single === null || single === undefined) single = true;
    return {
        text: {
            [126]: tokenizer
        },
        insideSpan: {
            null: [
                tokenizer
            ]
        },
        attentionMarkers: {
            null: [
                126
            ]
        }
    };
    /**
   * Take events and resolve strikethrough.
   *
   * @type {Resolver}
   */ function resolveAllStrikethrough(events, context) {
        let index = -1;
        // Walk through all events.
        while(++index < events.length)// Find a token that can close.
        if (events[index][0] === "enter" && events[index][1].type === "strikethroughSequenceTemporary" && events[index][1]._close) {
            let open = index;
            // Now walk back to find an opener.
            while(open--)// Find a token that can open the closer.
            if (events[open][0] === "exit" && events[open][1].type === "strikethroughSequenceTemporary" && events[open][1]._open && // If the sizes are the same:
            events[index][1].end.offset - events[index][1].start.offset === events[open][1].end.offset - events[open][1].start.offset) {
                events[index][1].type = "strikethroughSequence";
                events[open][1].type = "strikethroughSequence";
                /** @type {Token} */ const strikethrough = {
                    type: "strikethrough",
                    start: Object.assign({}, events[open][1].start),
                    end: Object.assign({}, events[index][1].end)
                };
                /** @type {Token} */ const text = {
                    type: "strikethroughText",
                    start: Object.assign({}, events[open][1].end),
                    end: Object.assign({}, events[index][1].start)
                };
                // Opening.
                /** @type {Array<Event>} */ const nextEvents = [
                    [
                        "enter",
                        strikethrough,
                        context
                    ],
                    [
                        "enter",
                        events[open][1],
                        context
                    ],
                    [
                        "exit",
                        events[open][1],
                        context
                    ],
                    [
                        "enter",
                        text,
                        context
                    ]
                ];
                const insideSpan = context.parser.constructs.insideSpan.null;
                if (insideSpan) // Between.
                (0, $76c325c59203cf92$export$869882364835d202)(nextEvents, nextEvents.length, 0, (0, $8c627d7d8981f0bc$export$3ff61ec196ff408b)(insideSpan, events.slice(open + 1, index), context));
                // Closing.
                (0, $76c325c59203cf92$export$869882364835d202)(nextEvents, nextEvents.length, 0, [
                    [
                        "exit",
                        text,
                        context
                    ],
                    [
                        "enter",
                        events[index][1],
                        context
                    ],
                    [
                        "exit",
                        events[index][1],
                        context
                    ],
                    [
                        "exit",
                        strikethrough,
                        context
                    ]
                ]);
                (0, $76c325c59203cf92$export$869882364835d202)(events, open - 1, index - open + 3, nextEvents);
                index = open + nextEvents.length - 2;
                break;
            }
        }
        index = -1;
        while(++index < events.length)if (events[index][1].type === "strikethroughSequenceTemporary") events[index][1].type = "data";
        return events;
    }
    /**
   * @this {TokenizeContext}
   * @type {Tokenizer}
   */ function tokenizeStrikethrough(effects, ok, nok) {
        const previous = this.previous;
        const events = this.events;
        let size = 0;
        return start;
        /** @type {State} */ function start(code) {
            if (previous === 126 && events[events.length - 1][1].type !== "characterEscape") return nok(code);
            effects.enter("strikethroughSequenceTemporary");
            return more(code);
        }
        /** @type {State} */ function more(code) {
            const before = (0, $9e0904f98da5bb5d$export$e3902bc0d835cad0)(previous);
            if (code === 126) {
                // If this is the third marker, exit.
                if (size > 1) return nok(code);
                effects.consume(code);
                size++;
                return more;
            }
            if (size < 2 && !single) return nok(code);
            const token = effects.exit("strikethroughSequenceTemporary");
            const after = (0, $9e0904f98da5bb5d$export$e3902bc0d835cad0)(code);
            token._open = !after || after === 2 && Boolean(before);
            token._close = !before || before === 2 && Boolean(after);
            return ok(code);
        }
    }
}

/**
 * @typedef {import('micromark-util-types').HtmlExtension} HtmlExtension
 */ // To do: next major: expose function instead of object.
/**
 * Extension for `micromark` that can be passed in `htmlExtensions`, to
 * support GFM strikethrough when serializing to HTML.
 *
 * @type {HtmlExtension}
 */ const $6b6e14a9d67bb215$export$58acedca46108820 = {
    enter: {
        strikethrough () {
            this.tag("<del>");
        }
    },
    exit: {
        strikethrough () {
            this.tag("</del>");
        }
    }
};


/**
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Extension} Extension
 * @typedef {import('micromark-util-types').Point} Point
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ /**
 * @typedef {[number, number, number, number]} Range
 *   Cell info.
 *
 * @typedef {0 | 1 | 2 | 3} RowKind
 *   Where we are: `1` for head row, `2` for delimiter row, `3` for body row.
 */ 

/**
 * @typedef {import('micromark-util-types').Event} Event
 */ // Port of `edit_map.rs` from `markdown-rs`.
// This should move to `markdown-js` later.
// Deal with several changes in events, batching them together.
//
// Preferably, changes should be kept to a minimum.
// Sometimes, it’s needed to change the list of events, because parsing can be
// messy, and it helps to expose a cleaner interface of events to the compiler
// and other users.
// It can also help to merge many adjacent similar events.
// And, in other cases, it’s needed to parse subcontent: pass some events
// through another tokenizer and inject the result.
/**
 * @typedef {[number, number, Array<Event>]} Change
 * @typedef {[number, number, number]} Jump
 */ /**
 * Tracks a bunch of edits.
 */ class $89888e3da077dd77$export$9348908dd4518b4a {
    /**
   * Create an edit: a remove and/or add at a certain place.
   *
   * @param {number} index
   * @param {number} remove
   * @param {Array<Event>} add
   * @returns {void}
   */ add(index, remove, add) {
        $89888e3da077dd77$var$addImpl(this, index, remove, add);
    }
    // To do: not used here.
    // /**
    //  * Create an edit: but insert `add` before existing additions.
    //  *
    //  * @param {number} index
    //  * @param {number} remove
    //  * @param {Array<Event>} add
    //  * @returns {void}
    //  */
    // addBefore(index, remove, add) {
    //   addImpl(this, index, remove, add, true)
    // }
    /**
   * Done, change the events.
   *
   * @param {Array<Event>} events
   * @returns {void}
   */ consume(events) {
        this.map.sort((a, b)=>a[0] - b[0]);
        /* c8 ignore next 3 -- `resolve` is never called without tables, so without edits. */ if (this.map.length === 0) return;
        // To do: if links are added in events, like they are in `markdown-rs`,
        // this is needed.
        // // Calculate jumps: where items in the current list move to.
        // /** @type {Array<Jump>} */
        // const jumps = []
        // let index = 0
        // let addAcc = 0
        // let removeAcc = 0
        // while (index < this.map.length) {
        //   const [at, remove, add] = this.map[index]
        //   removeAcc += remove
        //   addAcc += add.length
        //   jumps.push([at, removeAcc, addAcc])
        //   index += 1
        // }
        //
        // . shiftLinks(events, jumps)
        let index = this.map.length;
        /** @type {Array<Array<Event>>} */ const vecs = [];
        while(index > 0){
            index -= 1;
            vecs.push(events.slice(this.map[index][0] + this.map[index][1]));
            // eslint-disable-next-line unicorn/no-array-push-push
            vecs.push(this.map[index][2]);
            // Truncate rest.
            events.length = this.map[index][0];
        }
        vecs.push([
            ...events
        ]);
        events.length = 0;
        let slice = vecs.pop();
        while(slice){
            events.push(...slice);
            slice = vecs.pop();
        }
        // Truncate everything.
        this.map.length = 0;
    }
    /**
   * Create a new edit map.
   */ constructor(){
        /**
     * Record of changes.
     *
     * @type {Array<Change>}
     */ this.map = [];
    }
}
/**
 * Create an edit.
 *
 * @param {EditMap} editMap
 * @param {number} at
 * @param {number} remove
 * @param {Array<Event>} add
 * @returns {void}
 */ function $89888e3da077dd77$var$addImpl(editMap, at, remove, add) {
    let index = 0;
    /* c8 ignore next 3 -- `resolve` is never called without tables, so without edits. */ if (remove === 0 && add.length === 0) return;
    while(index < editMap.map.length){
        if (editMap.map[index][0] === at) {
            editMap.map[index][1] += remove;
            // To do: before not used.
            // if (before) {
            //   add.push(...editMap.map[index][2])
            //   editMap.map[index][2] = add
            // } else {
            editMap.map[index][2].push(...add);
            // }
            return;
        }
        index += 1;
    }
    editMap.map.push([
        at,
        remove,
        add
    ]);
} // /**
 //  * Shift `previous` and `next` links according to `jumps`.
 //  *
 //  * This fixes links in case there are events removed or added between them.
 //  *
 //  * @param {Array<Event>} events
 //  * @param {Array<Jump>} jumps
 //  */
 // function shiftLinks(events, jumps) {
 //   let jumpIndex = 0
 //   let index = 0
 //   let add = 0
 //   let rm = 0
 //   while (index < events.length) {
 //     const rmCurr = rm
 //     while (jumpIndex < jumps.length && jumps[jumpIndex][0] <= index) {
 //       add = jumps[jumpIndex][2]
 //       rm = jumps[jumpIndex][1]
 //       jumpIndex += 1
 //     }
 //     // Ignore items that will be removed.
 //     if (rm > rmCurr) {
 //       index += rm - rmCurr
 //     } else {
 //       console.log('to do: links?', add, rmCurr)
 //       // ?
 //       // if let Some(link) = &events[index].link {
 //       //     if let Some(next) = link.next {
 //       //         events[next].link.as_mut().unwrap().previous = Some(index + add - rm);
 //       //         while jumpIndex < jumps.len() && jumps[jumpIndex].0 <= next {
 //       //             add = jumps[jumpIndex].2;
 //       //             rm = jumps[jumpIndex].1;
 //       //             jumpIndex += 1;
 //       //         }
 //       //         events[index].link.as_mut().unwrap().next = Some(next + add - rm);
 //       //         index = next;
 //       //         continue;
 //       //     }
 //       // }
 //       index += 1
 //     }
 //   }
 // }


/**
 * @typedef {import('micromark-util-types').Event} Event
 */ /**
 * @typedef {'left' | 'center' | 'right' | 'none'} Align
 */ /**
 * Figure out the alignment of a GFM table.
 *
 * @param {Array<Event>} events
 * @param {number} index
 * @returns {Array<Align>}
 */ function $b60ac8834b3f6326$export$bbf4fe2c547a4878(events, index) {
    let inDelimiterRow = false;
    /** @type {Array<Align>} */ const align = [];
    while(index < events.length){
        const event = events[index];
        if (inDelimiterRow) {
            if (event[0] === "enter") // Start of alignment value: set a new column.
            // To do: `markdown-rs` uses `tableDelimiterCellValue`.
            {
                if (event[1].type === "tableContent") align.push(events[index + 1][1].type === "tableDelimiterMarker" ? "left" : "none");
            } else if (event[1].type === "tableContent") {
                if (events[index - 1][1].type === "tableDelimiterMarker") {
                    const alignIndex = align.length - 1;
                    align[alignIndex] = align[alignIndex] === "left" ? "center" : "right";
                }
            } else if (event[1].type === "tableDelimiterRow") break;
        } else if (event[0] === "enter" && event[1].type === "tableDelimiterRow") inDelimiterRow = true;
        index += 1;
    }
    return align;
}


const $04ca2df6a40f6310$export$e36cebda627bf2dd = {
    flow: {
        null: {
            tokenize: $04ca2df6a40f6310$var$tokenizeTable,
            resolveAll: $04ca2df6a40f6310$var$resolveTable
        }
    }
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $04ca2df6a40f6310$var$tokenizeTable(effects, ok, nok) {
    const self = this;
    let size = 0;
    let sizeB = 0;
    /** @type {boolean | undefined} */ let seen;
    return start;
    /**
   * Start of a GFM table.
   *
   * If there is a valid table row or table head before, then we try to parse
   * another row.
   * Otherwise, we try to parse a head.
   *
   * ```markdown
   * > | | a |
   *     ^
   *   | | - |
   * > | | b |
   *     ^
   * ```
   * @type {State}
   */ function start(code) {
        let index = self.events.length - 1;
        while(index > -1){
            const type = self.events[index][1].type;
            if (type === "lineEnding" || // Note: markdown-rs uses `whitespace` instead of `linePrefix`
            type === "linePrefix") index--;
            else break;
        }
        const tail = index > -1 ? self.events[index][1].type : null;
        const next = tail === "tableHead" || tail === "tableRow" ? bodyRowStart : headRowBefore;
        // Don’t allow lazy body rows.
        if (next === bodyRowStart && self.parser.lazy[self.now().line]) return nok(code);
        return next(code);
    }
    /**
   * Before table head row.
   *
   * ```markdown
   * > | | a |
   *     ^
   *   | | - |
   *   | | b |
   * ```
   *
   * @type {State}
   */ function headRowBefore(code) {
        effects.enter("tableHead");
        effects.enter("tableRow");
        return headRowStart(code);
    }
    /**
   * Before table head row, after whitespace.
   *
   * ```markdown
   * > | | a |
   *     ^
   *   | | - |
   *   | | b |
   * ```
   *
   * @type {State}
   */ function headRowStart(code) {
        if (code === 124) return headRowBreak(code);
        // To do: micromark-js should let us parse our own whitespace in extensions,
        // like `markdown-rs`:
        //
        // ```js
        // // 4+ spaces.
        // if (markdownSpace(code)) {
        //   return nok(code)
        // }
        // ```
        seen = true;
        // Count the first character, that isn’t a pipe, double.
        sizeB += 1;
        return headRowBreak(code);
    }
    /**
   * At break in table head row.
   *
   * ```markdown
   * > | | a |
   *     ^
   *       ^
   *         ^
   *   | | - |
   *   | | b |
   * ```
   *
   * @type {State}
   */ function headRowBreak(code) {
        if (code === null) // Note: in `markdown-rs`, we need to reset, in `micromark-js` we don‘t.
        return nok(code);
        if ((0, $d81ad7e99936a248$export$34a1dff1c0936953)(code)) {
            // If anything other than one pipe (ignoring whitespace) was used, it’s fine.
            if (sizeB > 1) {
                sizeB = 0;
                // To do: check if this works.
                // Feel free to interrupt:
                self.interrupt = true;
                effects.exit("tableRow");
                effects.enter("lineEnding");
                effects.consume(code);
                effects.exit("lineEnding");
                return headDelimiterStart;
            }
            // Note: in `markdown-rs`, we need to reset, in `micromark-js` we don‘t.
            return nok(code);
        }
        if ((0, $d81ad7e99936a248$export$2c6cf65c1127992a)(code)) // To do: check if this is fine.
        // effects.attempt(State::Next(StateName::GfmTableHeadRowBreak), State::Nok)
        // State::Retry(space_or_tab(tokenizer))
        return (0, $6b1271da345f2eae$export$ae105c1eb063a0a2)(effects, headRowBreak, "whitespace")(code);
        sizeB += 1;
        if (seen) {
            seen = false;
            // Header cell count.
            size += 1;
        }
        if (code === 124) {
            effects.enter("tableCellDivider");
            effects.consume(code);
            effects.exit("tableCellDivider");
            // Whether a delimiter was seen.
            seen = true;
            return headRowBreak;
        }
        // Anything else is cell data.
        effects.enter("data");
        return headRowData(code);
    }
    /**
   * In table head row data.
   *
   * ```markdown
   * > | | a |
   *       ^
   *   | | - |
   *   | | b |
   * ```
   *
   * @type {State}
   */ function headRowData(code) {
        if (code === null || code === 124 || (0, $d81ad7e99936a248$export$a30284361b3814b7)(code)) {
            effects.exit("data");
            return headRowBreak(code);
        }
        effects.consume(code);
        return code === 92 ? headRowEscape : headRowData;
    }
    /**
   * In table head row escape.
   *
   * ```markdown
   * > | | a\-b |
   *         ^
   *   | | ---- |
   *   | | c    |
   * ```
   *
   * @type {State}
   */ function headRowEscape(code) {
        if (code === 92 || code === 124) {
            effects.consume(code);
            return headRowData;
        }
        return headRowData(code);
    }
    /**
   * Before delimiter row.
   *
   * ```markdown
   *   | | a |
   * > | | - |
   *     ^
   *   | | b |
   * ```
   *
   * @type {State}
   */ function headDelimiterStart(code) {
        // Reset `interrupt`.
        self.interrupt = false;
        // Note: in `markdown-rs`, we need to handle piercing here too.
        if (self.parser.lazy[self.now().line]) return nok(code);
        effects.enter("tableDelimiterRow");
        // Track if we’ve seen a `:` or `|`.
        seen = false;
        if ((0, $d81ad7e99936a248$export$2c6cf65c1127992a)(code)) return (0, $6b1271da345f2eae$export$ae105c1eb063a0a2)(effects, headDelimiterBefore, "linePrefix", self.parser.constructs.disable.null.includes("codeIndented") ? undefined : 4)(code);
        return headDelimiterBefore(code);
    }
    /**
   * Before delimiter row, after optional whitespace.
   *
   * Reused when a `|` is found later, to parse another cell.
   *
   * ```markdown
   *   | | a |
   * > | | - |
   *     ^
   *   | | b |
   * ```
   *
   * @type {State}
   */ function headDelimiterBefore(code) {
        if (code === 45 || code === 58) return headDelimiterValueBefore(code);
        if (code === 124) {
            seen = true;
            // If we start with a pipe, we open a cell marker.
            effects.enter("tableCellDivider");
            effects.consume(code);
            effects.exit("tableCellDivider");
            return headDelimiterCellBefore;
        }
        // More whitespace / empty row not allowed at start.
        return headDelimiterNok(code);
    }
    /**
   * After `|`, before delimiter cell.
   *
   * ```markdown
   *   | | a |
   * > | | - |
   *      ^
   * ```
   *
   * @type {State}
   */ function headDelimiterCellBefore(code) {
        if ((0, $d81ad7e99936a248$export$2c6cf65c1127992a)(code)) return (0, $6b1271da345f2eae$export$ae105c1eb063a0a2)(effects, headDelimiterValueBefore, "whitespace")(code);
        return headDelimiterValueBefore(code);
    }
    /**
   * Before delimiter cell value.
   *
   * ```markdown
   *   | | a |
   * > | | - |
   *       ^
   * ```
   *
   * @type {State}
   */ function headDelimiterValueBefore(code) {
        // Align: left.
        if (code === 58) {
            sizeB += 1;
            seen = true;
            effects.enter("tableDelimiterMarker");
            effects.consume(code);
            effects.exit("tableDelimiterMarker");
            return headDelimiterLeftAlignmentAfter;
        }
        // Align: none.
        if (code === 45) {
            sizeB += 1;
            // To do: seems weird that this *isn’t* left aligned, but that state is used?
            return headDelimiterLeftAlignmentAfter(code);
        }
        if (code === null || (0, $d81ad7e99936a248$export$34a1dff1c0936953)(code)) return headDelimiterCellAfter(code);
        return headDelimiterNok(code);
    }
    /**
   * After delimiter cell left alignment marker.
   *
   * ```markdown
   *   | | a  |
   * > | | :- |
   *        ^
   * ```
   *
   * @type {State}
   */ function headDelimiterLeftAlignmentAfter(code) {
        if (code === 45) {
            effects.enter("tableDelimiterFiller");
            return headDelimiterFiller(code);
        }
        // Anything else is not ok after the left-align colon.
        return headDelimiterNok(code);
    }
    /**
   * In delimiter cell filler.
   *
   * ```markdown
   *   | | a |
   * > | | - |
   *       ^
   * ```
   *
   * @type {State}
   */ function headDelimiterFiller(code) {
        if (code === 45) {
            effects.consume(code);
            return headDelimiterFiller;
        }
        // Align is `center` if it was `left`, `right` otherwise.
        if (code === 58) {
            seen = true;
            effects.exit("tableDelimiterFiller");
            effects.enter("tableDelimiterMarker");
            effects.consume(code);
            effects.exit("tableDelimiterMarker");
            return headDelimiterRightAlignmentAfter;
        }
        effects.exit("tableDelimiterFiller");
        return headDelimiterRightAlignmentAfter(code);
    }
    /**
   * After delimiter cell right alignment marker.
   *
   * ```markdown
   *   | |  a |
   * > | | -: |
   *         ^
   * ```
   *
   * @type {State}
   */ function headDelimiterRightAlignmentAfter(code) {
        if ((0, $d81ad7e99936a248$export$2c6cf65c1127992a)(code)) return (0, $6b1271da345f2eae$export$ae105c1eb063a0a2)(effects, headDelimiterCellAfter, "whitespace")(code);
        return headDelimiterCellAfter(code);
    }
    /**
   * After delimiter cell.
   *
   * ```markdown
   *   | |  a |
   * > | | -: |
   *          ^
   * ```
   *
   * @type {State}
   */ function headDelimiterCellAfter(code) {
        if (code === 124) return headDelimiterBefore(code);
        if (code === null || (0, $d81ad7e99936a248$export$34a1dff1c0936953)(code)) {
            // Exit when:
            // * there was no `:` or `|` at all (it’s a thematic break or setext
            //   underline instead)
            // * the header cell count is not the delimiter cell count
            if (!seen || size !== sizeB) return headDelimiterNok(code);
            // Note: in markdown-rs`, a reset is needed here.
            effects.exit("tableDelimiterRow");
            effects.exit("tableHead");
            // To do: in `markdown-rs`, resolvers need to be registered manually.
            // effects.register_resolver(ResolveName::GfmTable)
            return ok(code);
        }
        return headDelimiterNok(code);
    }
    /**
   * In delimiter row, at a disallowed byte.
   *
   * ```markdown
   *   | | a |
   * > | | x |
   *       ^
   * ```
   *
   * @type {State}
   */ function headDelimiterNok(code) {
        // Note: in `markdown-rs`, we need to reset, in `micromark-js` we don‘t.
        return nok(code);
    }
    /**
   * Before table body row.
   *
   * ```markdown
   *   | | a |
   *   | | - |
   * > | | b |
   *     ^
   * ```
   *
   * @type {State}
   */ function bodyRowStart(code) {
        // Note: in `markdown-rs` we need to manually take care of a prefix,
        // but in `micromark-js` that is done for us, so if we’re here, we’re
        // never at whitespace.
        effects.enter("tableRow");
        return bodyRowBreak(code);
    }
    /**
   * At break in table body row.
   *
   * ```markdown
   *   | | a |
   *   | | - |
   * > | | b |
   *     ^
   *       ^
   *         ^
   * ```
   *
   * @type {State}
   */ function bodyRowBreak(code) {
        if (code === 124) {
            effects.enter("tableCellDivider");
            effects.consume(code);
            effects.exit("tableCellDivider");
            return bodyRowBreak;
        }
        if (code === null || (0, $d81ad7e99936a248$export$34a1dff1c0936953)(code)) {
            effects.exit("tableRow");
            return ok(code);
        }
        if ((0, $d81ad7e99936a248$export$2c6cf65c1127992a)(code)) return (0, $6b1271da345f2eae$export$ae105c1eb063a0a2)(effects, bodyRowBreak, "whitespace")(code);
        // Anything else is cell content.
        effects.enter("data");
        return bodyRowData(code);
    }
    /**
   * In table body row data.
   *
   * ```markdown
   *   | | a |
   *   | | - |
   * > | | b |
   *       ^
   * ```
   *
   * @type {State}
   */ function bodyRowData(code) {
        if (code === null || code === 124 || (0, $d81ad7e99936a248$export$a30284361b3814b7)(code)) {
            effects.exit("data");
            return bodyRowBreak(code);
        }
        effects.consume(code);
        return code === 92 ? bodyRowEscape : bodyRowData;
    }
    /**
   * In table body row escape.
   *
   * ```markdown
   *   | | a    |
   *   | | ---- |
   * > | | b\-c |
   *         ^
   * ```
   *
   * @type {State}
   */ function bodyRowEscape(code) {
        if (code === 92 || code === 124) {
            effects.consume(code);
            return bodyRowData;
        }
        return bodyRowData(code);
    }
}
/** @type {Resolver} */ // eslint-disable-next-line complexity
function $04ca2df6a40f6310$var$resolveTable(events, context) {
    let index = -1;
    let inFirstCellAwaitingPipe = true;
    /** @type {RowKind} */ let rowKind = 0;
    /** @type {Range} */ let lastCell = [
        0,
        0,
        0,
        0
    ];
    /** @type {Range} */ let cell = [
        0,
        0,
        0,
        0
    ];
    let afterHeadAwaitingFirstBodyRow = false;
    let lastTableEnd = 0;
    /** @type {Token | undefined} */ let currentTable;
    /** @type {Token | undefined} */ let currentBody;
    /** @type {Token | undefined} */ let currentCell;
    const map = new (0, $89888e3da077dd77$export$9348908dd4518b4a)();
    while(++index < events.length){
        const event = events[index];
        const token = event[1];
        if (event[0] === "enter") {
            // Start of head.
            if (token.type === "tableHead") {
                afterHeadAwaitingFirstBodyRow = false;
                // Inject previous (body end and) table end.
                if (lastTableEnd !== 0) {
                    $04ca2df6a40f6310$var$flushTableEnd(map, context, lastTableEnd, currentTable, currentBody);
                    currentBody = undefined;
                    lastTableEnd = 0;
                }
                // Inject table start.
                currentTable = {
                    type: "table",
                    start: Object.assign({}, token.start),
                    // Note: correct end is set later.
                    end: Object.assign({}, token.end)
                };
                map.add(index, 0, [
                    [
                        "enter",
                        currentTable,
                        context
                    ]
                ]);
            } else if (token.type === "tableRow" || token.type === "tableDelimiterRow") {
                inFirstCellAwaitingPipe = true;
                currentCell = undefined;
                lastCell = [
                    0,
                    0,
                    0,
                    0
                ];
                cell = [
                    0,
                    index + 1,
                    0,
                    0
                ];
                // Inject table body start.
                if (afterHeadAwaitingFirstBodyRow) {
                    afterHeadAwaitingFirstBodyRow = false;
                    currentBody = {
                        type: "tableBody",
                        start: Object.assign({}, token.start),
                        // Note: correct end is set later.
                        end: Object.assign({}, token.end)
                    };
                    map.add(index, 0, [
                        [
                            "enter",
                            currentBody,
                            context
                        ]
                    ]);
                }
                rowKind = token.type === "tableDelimiterRow" ? 2 : currentBody ? 3 : 1;
            } else if (rowKind && (token.type === "data" || token.type === "tableDelimiterMarker" || token.type === "tableDelimiterFiller")) {
                inFirstCellAwaitingPipe = false;
                // First value in cell.
                if (cell[2] === 0) {
                    if (lastCell[1] !== 0) {
                        cell[0] = cell[1];
                        currentCell = $04ca2df6a40f6310$var$flushCell(map, context, lastCell, rowKind, undefined, currentCell);
                        lastCell = [
                            0,
                            0,
                            0,
                            0
                        ];
                    }
                    cell[2] = index;
                }
            } else if (token.type === "tableCellDivider") {
                if (inFirstCellAwaitingPipe) inFirstCellAwaitingPipe = false;
                else {
                    if (lastCell[1] !== 0) {
                        cell[0] = cell[1];
                        currentCell = $04ca2df6a40f6310$var$flushCell(map, context, lastCell, rowKind, undefined, currentCell);
                    }
                    lastCell = cell;
                    cell = [
                        lastCell[1],
                        index,
                        0,
                        0
                    ];
                }
            }
        } else if (token.type === "tableHead") {
            afterHeadAwaitingFirstBodyRow = true;
            lastTableEnd = index;
        } else if (token.type === "tableRow" || token.type === "tableDelimiterRow") {
            lastTableEnd = index;
            if (lastCell[1] !== 0) {
                cell[0] = cell[1];
                currentCell = $04ca2df6a40f6310$var$flushCell(map, context, lastCell, rowKind, index, currentCell);
            } else if (cell[1] !== 0) currentCell = $04ca2df6a40f6310$var$flushCell(map, context, cell, rowKind, index, currentCell);
            rowKind = 0;
        } else if (rowKind && (token.type === "data" || token.type === "tableDelimiterMarker" || token.type === "tableDelimiterFiller")) cell[3] = index;
    }
    if (lastTableEnd !== 0) $04ca2df6a40f6310$var$flushTableEnd(map, context, lastTableEnd, currentTable, currentBody);
    map.consume(context.events);
    // To do: move this into `html`, when events are exposed there.
    // That’s what `markdown-rs` does.
    // That needs updates to `mdast-util-gfm-table`.
    index = -1;
    while(++index < context.events.length){
        const event = context.events[index];
        if (event[0] === "enter" && event[1].type === "table") event[1]._align = (0, $b60ac8834b3f6326$export$bbf4fe2c547a4878)(context.events, index);
    }
    return events;
}
/// Generate a cell.
/**
 *
 * @param {EditMap} map
 * @param {TokenizeContext} context
 * @param {Range} range
 * @param {RowKind} rowKind
 * @param {number | undefined} rowEnd
 * @param {Token | undefined} previousCell
 * @returns {Token | undefined}
 */ // eslint-disable-next-line max-params
function $04ca2df6a40f6310$var$flushCell(map, context, range, rowKind, rowEnd, previousCell) {
    // `markdown-rs` uses:
    // rowKind === 2 ? 'tableDelimiterCell' : 'tableCell'
    const groupName = rowKind === 1 ? "tableHeader" : rowKind === 2 ? "tableDelimiter" : "tableData";
    // `markdown-rs` uses:
    // rowKind === 2 ? 'tableDelimiterCellValue' : 'tableCellText'
    const valueName = "tableContent";
    // Insert an exit for the previous cell, if there is one.
    //
    // ```markdown
    // > | | aa | bb | cc |
    //          ^-- exit
    //           ^^^^-- this cell
    // ```
    if (range[0] !== 0) {
        previousCell.end = Object.assign({}, $04ca2df6a40f6310$var$getPoint(context.events, range[0]));
        map.add(range[0], 0, [
            [
                "exit",
                previousCell,
                context
            ]
        ]);
    }
    // Insert enter of this cell.
    //
    // ```markdown
    // > | | aa | bb | cc |
    //           ^-- enter
    //           ^^^^-- this cell
    // ```
    const now = $04ca2df6a40f6310$var$getPoint(context.events, range[1]);
    previousCell = {
        type: groupName,
        start: Object.assign({}, now),
        // Note: correct end is set later.
        end: Object.assign({}, now)
    };
    map.add(range[1], 0, [
        [
            "enter",
            previousCell,
            context
        ]
    ]);
    // Insert text start at first data start and end at last data end, and
    // remove events between.
    //
    // ```markdown
    // > | | aa | bb | cc |
    //            ^-- enter
    //             ^-- exit
    //           ^^^^-- this cell
    // ```
    if (range[2] !== 0) {
        const relatedStart = $04ca2df6a40f6310$var$getPoint(context.events, range[2]);
        const relatedEnd = $04ca2df6a40f6310$var$getPoint(context.events, range[3]);
        /** @type {Token} */ const valueToken = {
            type: valueName,
            start: Object.assign({}, relatedStart),
            end: Object.assign({}, relatedEnd)
        };
        map.add(range[2], 0, [
            [
                "enter",
                valueToken,
                context
            ]
        ]);
        if (rowKind !== 2) {
            // Fix positional info on remaining events
            const start = context.events[range[2]];
            const end = context.events[range[3]];
            start[1].end = Object.assign({}, end[1].end);
            start[1].type = "chunkText";
            start[1].contentType = "text";
            // Remove if needed.
            if (range[3] > range[2] + 1) {
                const a = range[2] + 1;
                const b = range[3] - range[2] - 1;
                map.add(a, b, []);
            }
        }
        map.add(range[3] + 1, 0, [
            [
                "exit",
                valueToken,
                context
            ]
        ]);
    }
    // Insert an exit for the last cell, if at the row end.
    //
    // ```markdown
    // > | | aa | bb | cc |
    //                    ^-- exit
    //               ^^^^^^-- this cell (the last one contains two “between” parts)
    // ```
    if (rowEnd !== undefined) {
        previousCell.end = Object.assign({}, $04ca2df6a40f6310$var$getPoint(context.events, rowEnd));
        map.add(rowEnd, 0, [
            [
                "exit",
                previousCell,
                context
            ]
        ]);
        previousCell = undefined;
    }
    return previousCell;
}
/**
 * Generate table end (and table body end).
 *
 * @param {EditMap} map
 * @param {TokenizeContext} context
 * @param {number} index
 * @param {Token} table
 * @param {Token | undefined} tableBody
 */ // eslint-disable-next-line max-params
function $04ca2df6a40f6310$var$flushTableEnd(map, context, index, table, tableBody) {
    /** @type {Array<Event>} */ const exits = [];
    const related = $04ca2df6a40f6310$var$getPoint(context.events, index);
    if (tableBody) {
        tableBody.end = Object.assign({}, related);
        exits.push([
            "exit",
            tableBody,
            context
        ]);
    }
    table.end = Object.assign({}, related);
    exits.push([
        "exit",
        table,
        context
    ]);
    map.add(index + 1, 0, exits);
}
/**
 * @param {Array<Event>} events
 * @param {number} index
 * @returns {readonly Point}
 */ function $04ca2df6a40f6310$var$getPoint(events, index) {
    const event = events[index];
    const side = event[0] === "enter" ? "start" : "end";
    return event[1][side];
}

/**
 * @typedef {import('micromark-util-types').HtmlExtension} HtmlExtension
 */ /**
 * @typedef {import('./infer.js').Align} Align
 */ const $d7ebc355cc78e280$var$alignment = {
    none: "",
    left: ' align="left"',
    right: ' align="right"',
    center: ' align="center"'
};
const $d7ebc355cc78e280$export$c64626c032567c7f = {
    enter: {
        table (token) {
            const tableAlign = token._align;
            this.lineEndingIfNeeded();
            this.tag("<table>");
            this.setData("tableAlign", tableAlign);
        },
        tableBody () {
            this.tag("<tbody>");
        },
        tableData () {
            const tableAlign = this.getData("tableAlign");
            const tableColumn = this.getData("tableColumn");
            const align = $d7ebc355cc78e280$var$alignment[tableAlign[tableColumn]];
            if (align === undefined) // Capture results to ignore them.
            this.buffer();
            else {
                this.lineEndingIfNeeded();
                this.tag("<td" + align + ">");
            }
        },
        tableHead () {
            this.lineEndingIfNeeded();
            this.tag("<thead>");
        },
        tableHeader () {
            const tableAlign = this.getData("tableAlign");
            const tableColumn = this.getData("tableColumn");
            const align = $d7ebc355cc78e280$var$alignment[tableAlign[tableColumn]];
            this.lineEndingIfNeeded();
            this.tag("<th" + align + ">");
        },
        tableRow () {
            this.setData("tableColumn", 0);
            this.lineEndingIfNeeded();
            this.tag("<tr>");
        }
    },
    exit: {
        // Overwrite the default code text data handler to unescape escaped pipes when
        // they are in tables.
        codeTextData (token) {
            let value = this.sliceSerialize(token);
            if (this.getData("tableAlign")) value = value.replace(/\\([\\|])/g, $d7ebc355cc78e280$var$replace);
            this.raw(this.encode(value));
        },
        table () {
            this.setData("tableAlign");
            // Note: we don’t set `slurpAllLineEndings` anymore, in delimiter rows,
            // but we do need to reset it to match a funky newline GH generates for
            // list items combined with tables.
            this.setData("slurpAllLineEndings");
            this.lineEndingIfNeeded();
            this.tag("</table>");
        },
        tableBody () {
            this.lineEndingIfNeeded();
            this.tag("</tbody>");
        },
        tableData () {
            const tableAlign = this.getData("tableAlign");
            const tableColumn = this.getData("tableColumn");
            if (tableColumn in tableAlign) {
                this.tag("</td>");
                this.setData("tableColumn", tableColumn + 1);
            } else // Stop capturing.
            this.resume();
        },
        tableHead () {
            this.lineEndingIfNeeded();
            this.tag("</thead>");
        },
        tableHeader () {
            const tableColumn = this.getData("tableColumn");
            this.tag("</th>");
            this.setData("tableColumn", tableColumn + 1);
        },
        tableRow () {
            const tableAlign = this.getData("tableAlign");
            let tableColumn = this.getData("tableColumn");
            while(tableColumn < tableAlign.length){
                this.lineEndingIfNeeded();
                this.tag("<td" + $d7ebc355cc78e280$var$alignment[tableAlign[tableColumn]] + "></td>");
                tableColumn++;
            }
            this.setData("tableColumn", tableColumn);
            this.lineEndingIfNeeded();
            this.tag("</tr>");
        }
    }
};
/**
 * @param {string} $0
 * @param {string} $1
 * @returns {string}
 */ function $d7ebc355cc78e280$var$replace($0, $1) {
    // Pipes work, backslashes don’t (but can’t escape pipes).
    return $1 === "|" ? $1 : $0;
}


/**
 * @typedef {import('micromark-util-types').CompileContext} CompileContext
 * @typedef {import('micromark-util-types').HtmlExtension} HtmlExtension
 * @typedef {import('micromark-util-types').Token} Token
 */ // An opening or closing tag start, followed by a case-insensitive specific tag name,
// followed by HTML whitespace, a greater than, or a slash.
const $a1588d2eba0a6fc7$var$reFlow = /<(\/?)(iframe|noembed|noframes|plaintext|script|style|title|textarea|xmp)(?=[\t\n\f\r />])/gi;
// As HTML (text) parses tags separately (and very strictly), we don’t need to be
// global.
const $a1588d2eba0a6fc7$var$reText = new RegExp("^" + $a1588d2eba0a6fc7$var$reFlow.source, "i");
const $a1588d2eba0a6fc7$export$c9bf87ea36d00682 = {
    exit: {
        htmlFlowData (token) {
            $a1588d2eba0a6fc7$var$exitHtmlData.call(this, token, $a1588d2eba0a6fc7$var$reFlow);
        },
        htmlTextData (token) {
            $a1588d2eba0a6fc7$var$exitHtmlData.call(this, token, $a1588d2eba0a6fc7$var$reText);
        }
    }
};
/**
 * @this {CompileContext}
 * @param {Token} token
 * @param {RegExp} filter
 */ function $a1588d2eba0a6fc7$var$exitHtmlData(token, filter) {
    let value = this.sliceSerialize(token);
    if (this.options.allowDangerousHtml) value = value.replace(filter, "&lt;$1$2");
    this.raw(this.encode(value));
}


/**
 * @typedef {import('micromark-util-types').Extension} Extension
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 

const $30fc560e696b8d01$var$tasklistCheck = {
    tokenize: $30fc560e696b8d01$var$tokenizeTasklistCheck
};
const $30fc560e696b8d01$export$2912e8b2802475ff = {
    text: {
        [91]: $30fc560e696b8d01$var$tasklistCheck
    }
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $30fc560e696b8d01$var$tokenizeTasklistCheck(effects, ok, nok) {
    const self = this;
    return open;
    /**
   * At start of task list item check.
   *
   * ```markdown
   * > | * [x] y.
   *       ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if (// Exit if there’s stuff before.
        self.previous !== null || // Exit if not in the first content that is the first child of a list
        // item.
        !self._gfmTasklistFirstContentOfListItem) return nok(code);
        effects.enter("taskListCheck");
        effects.enter("taskListCheckMarker");
        effects.consume(code);
        effects.exit("taskListCheckMarker");
        return inside;
    }
    /**
   * In task list item check.
   *
   * ```markdown
   * > | * [x] y.
   *        ^
   * ```
   *
   * @type {State}
   */ function inside(code) {
        // Currently we match how GH works in files.
        // To match how GH works in comments, use `markdownSpace` (`[\t ]`) instead
        // of `markdownLineEndingOrSpace` (`[\t\n\r ]`).
        if ((0, $d81ad7e99936a248$export$a30284361b3814b7)(code)) {
            effects.enter("taskListCheckValueUnchecked");
            effects.consume(code);
            effects.exit("taskListCheckValueUnchecked");
            return close;
        }
        if (code === 88 || code === 120) {
            effects.enter("taskListCheckValueChecked");
            effects.consume(code);
            effects.exit("taskListCheckValueChecked");
            return close;
        }
        return nok(code);
    }
    /**
   * At close of task list item check.
   *
   * ```markdown
   * > | * [x] y.
   *         ^
   * ```
   *
   * @type {State}
   */ function close(code) {
        if (code === 93) {
            effects.enter("taskListCheckMarker");
            effects.consume(code);
            effects.exit("taskListCheckMarker");
            effects.exit("taskListCheck");
            return after;
        }
        return nok(code);
    }
    /**
   * @type {State}
   */ function after(code) {
        // EOL in paragraph means there must be something else after it.
        if ((0, $d81ad7e99936a248$export$34a1dff1c0936953)(code)) return ok(code);
        // Space or tab?
        // Check what comes after.
        if ((0, $d81ad7e99936a248$export$2c6cf65c1127992a)(code)) return effects.check({
            tokenize: $30fc560e696b8d01$var$spaceThenNonSpace
        }, ok, nok)(code);
        // EOF, or non-whitespace, both wrong.
        return nok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $30fc560e696b8d01$var$spaceThenNonSpace(effects, ok, nok) {
    return (0, $6b1271da345f2eae$export$ae105c1eb063a0a2)(effects, after, "whitespace");
    /**
   * After whitespace, after task list item check.
   *
   * ```markdown
   * > | * [x] y.
   *           ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        // EOF means there was nothing, so bad.
        // EOL means there’s content after it, so good.
        // Impossible to have more spaces.
        // Anything else is good.
        return code === null ? nok(code) : ok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').HtmlExtension} HtmlExtension
 */ // To do: next major: expose function to make extension.
/**
 * Extension for `micromark` that can be passed in `htmlExtensions` to
 * support GFM task list items when serializing to HTML.
 *
 * @type {HtmlExtension}
 */ const $ab301fb498bfeb17$export$4b6a13e2af1b08ed = {
    enter: {
        taskListCheck () {
            this.tag('<input type="checkbox" disabled="" ');
        }
    },
    exit: {
        taskListCheck () {
            this.tag("/>");
        },
        taskListCheckValueChecked () {
            this.tag('checked="" ');
        }
    }
};


function $bf0bdde66bbeb6d8$export$59ffe8c4d7a4aab2(options) {
    return (0, $68d1ffdc2f9ceacd$export$86a865d89ef3c690)([
        (0, $87800cd4895ef869$export$608123d9b549151),
        (0, $699a5709302bc5fd$export$c82499b6656305df)(),
        (0, $877e44affd18fa60$export$8bbec8ea1400a00e)(options),
        (0, $04ca2df6a40f6310$export$e36cebda627bf2dd),
        (0, $30fc560e696b8d01$export$2912e8b2802475ff)
    ]);
}
function $bf0bdde66bbeb6d8$export$6983b82e6105d62a(options) {
    return (0, $68d1ffdc2f9ceacd$export$eaf8c406dfb0a620)([
        (0, $473d0cdfb43c46c1$export$999603f1f1c3d2f9),
        (0, $3c491ce8afba9b9e$export$a731a1f6cf81900c)(options),
        (0, $6b6e14a9d67bb215$export$58acedca46108820),
        (0, $d7ebc355cc78e280$export$c64626c032567c7f),
        (0, $a1588d2eba0a6fc7$export$c9bf87ea36d00682),
        (0, $ab301fb498bfeb17$export$4b6a13e2af1b08ed)
    ]);
}


/**
 * @typedef {import('mdast-util-from-markdown').Extension} FromMarkdownExtension
 * @typedef {import('mdast-util-to-markdown').Options} ToMarkdownExtension
 */ /**
 * @typedef {import('mdast-util-gfm-table').Options} Options
 *   Configuration.
 */ /**
 * @typedef {import('mdast').Link} Link
 * @typedef {import('mdast').PhrasingContent} PhrasingContent
 *
 * @typedef {import('mdast-util-from-markdown').CompileContext} CompileContext
 * @typedef {import('mdast-util-from-markdown').Extension} FromMarkdownExtension
 * @typedef {import('mdast-util-from-markdown').Handle} FromMarkdownHandle
 * @typedef {import('mdast-util-from-markdown').Transform} FromMarkdownTransform
 *
 * @typedef {import('mdast-util-to-markdown').ConstructName} ConstructName
 * @typedef {import('mdast-util-to-markdown').Options} ToMarkdownExtension
 *
 * @typedef {import('mdast-util-find-and-replace').ReplaceFunction} ReplaceFunction
 * @typedef {import('mdast-util-find-and-replace').RegExpMatchObject} RegExpMatchObject
 */ /**
 * Count how often a character (or substring) is used in a string.
 *
 * @param {string} value
 *   Value to search in.
 * @param {string} character
 *   Character (or substring) to look for.
 * @return {number}
 *   Number of times `character` occurred in `value`.
 */ function $36540aa4f45c18b0$export$fa42eaa97a352e23(value, character) {
    const source = String(value);
    if (typeof character !== "string") throw new TypeError("Expected character");
    let count = 0;
    let index = source.indexOf(character);
    while(index !== -1){
        count++;
        index = source.indexOf(character, index + character.length);
    }
    return count;
}


/**
 * @typedef {import('mdast').Parent} MdastParent
 * @typedef {import('mdast').Root} Root
 * @typedef {import('mdast').Content} Content
 * @typedef {import('mdast').PhrasingContent} PhrasingContent
 * @typedef {import('mdast').Text} Text
 * @typedef {import('unist-util-visit-parents').Test} Test
 * @typedef {import('unist-util-visit-parents').VisitorResult} VisitorResult
 */ /**
 * @typedef {Content | Root} Node
 * @typedef {Extract<Node, MdastParent>} Parent
 * @typedef {Exclude<Parent, Root>} ContentParent
 *
 * @typedef RegExpMatchObject
 *   Info on the match.
 * @property {number} index
 *   The index of the search at which the result was found.
 * @property {string} input
 *   A copy of the search string in the text node.
 * @property {[Root, ...Array<ContentParent>, Text]} stack
 *   All ancestors of the text node, where the last node is the text itself.
 *
 * @callback ReplaceFunction
 *   Callback called when a search matches.
 * @param {...any} parameters
 *   The parameters are the result of corresponding search expression:
 *
 *   * `value` (`string`) — whole match
 *   * `...capture` (`Array<string>`) — matches from regex capture groups
 *   * `match` (`RegExpMatchObject`) — info on the match
 * @returns {Array<PhrasingContent> | PhrasingContent | string | false | undefined | null}
 *   Thing to replace with.
 *
 *   * when `null`, `undefined`, `''`, remove the match
 *   * …or when `false`, do not replace at all
 *   * …or when `string`, replace with a text node of that value
 *   * …or when `Node` or `Array<Node>`, replace with those nodes
 *
 * @typedef {string | RegExp} Find
 *   Pattern to find.
 *
 *   Strings are escaped and then turned into global expressions.
 *
 * @typedef {Array<FindAndReplaceTuple>} FindAndReplaceList
 *   Several find and replaces, in array form.
 * @typedef {Record<string, Replace>} FindAndReplaceSchema
 *   Several find and replaces, in object form.
 * @typedef {[Find, Replace]} FindAndReplaceTuple
 *   Find and replace in tuple form.
 * @typedef {string | ReplaceFunction} Replace
 *   Thing to replace with.
 * @typedef {[RegExp, ReplaceFunction]} Pair
 *   Normalized find and replace.
 * @typedef {Array<Pair>} Pairs
 *   All find and replaced.
 *
 * @typedef Options
 *   Configuration.
 * @property {Test | null | undefined} [ignore]
 *   Test for which nodes to ignore.
 */ function $5267f8a0ffe00049$export$2e2bcd8739ae039(string) {
    if (typeof string !== "string") throw new TypeError("Expected a string");
    // Escape characters with special meaning either inside or outside character sets.
    // Use a simple backslash escape when it’s always valid, and a `\xnn` escape when the simpler form would be disallowed by Unicode patterns’ stricter grammar.
    return string.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
}


/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Parent} Parent
 * @typedef {import('unist-util-is').Test} Test
 */ /**
 * @typedef {boolean | 'skip'} Action
 *   Union of the action types.
 *
 * @typedef {number} Index
 *   Move to the sibling at `index` next (after node itself is completely
 *   traversed).
 *
 *   Useful if mutating the tree, such as removing the node the visitor is
 *   currently on, or any of its previous siblings.
 *   Results less than 0 or greater than or equal to `children.length` stop
 *   traversing the parent.
 *
 * @typedef {[(Action | null | undefined | void)?, (Index | null | undefined)?]} ActionTuple
 *   List with one or two values, the first an action, the second an index.
 *
 * @typedef {Action | ActionTuple | Index | null | undefined | void} VisitorResult
 *   Any value that can be returned from a visitor.
 */ /**
 * @template {Node} [Visited=Node]
 *   Visited node type.
 * @template {Parent} [Ancestor=Parent]
 *   Ancestor type.
 * @callback Visitor
 *   Handle a node (matching `test`, if given).
 *
 *   Visitors are free to transform `node`.
 *   They can also transform the parent of node (the last of `ancestors`).
 *
 *   Replacing `node` itself, if `SKIP` is not returned, still causes its
 *   descendants to be walked (which is a bug).
 *
 *   When adding or removing previous siblings of `node` (or next siblings, in
 *   case of reverse), the `Visitor` should return a new `Index` to specify the
 *   sibling to traverse after `node` is traversed.
 *   Adding or removing next siblings of `node` (or previous siblings, in case
 *   of reverse) is handled as expected without needing to return a new `Index`.
 *
 *   Removing the children property of an ancestor still results in them being
 *   traversed.
 * @param {Visited} node
 *   Found node.
 * @param {Array<Ancestor>} ancestors
 *   Ancestors of `node`.
 * @returns {VisitorResult}
 *   What to do next.
 *
 *   An `Index` is treated as a tuple of `[CONTINUE, Index]`.
 *   An `Action` is treated as a tuple of `[Action]`.
 *
 *   Passing a tuple back only makes sense if the `Action` is `SKIP`.
 *   When the `Action` is `EXIT`, that action can be returned.
 *   When the `Action` is `CONTINUE`, `Index` can be returned.
 */ /**
 * @template {Node} [Tree=Node]
 *   Tree type.
 * @template {Test} [Check=string]
 *   Test type.
 * @typedef {Visitor<import('./complex-types.js').Matches<import('./complex-types.js').InclusiveDescendant<Tree>, Check>, Extract<import('./complex-types.js').InclusiveDescendant<Tree>, Parent>>} BuildVisitor
 *   Build a typed `Visitor` function from a tree and a test.
 *
 *   It will infer which values are passed as `node` and which as `parents`.
 */ /**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Parent} Parent
 */ /**
 * @typedef {Record<string, unknown>} Props
 * @typedef {null | undefined | string | Props | TestFunctionAnything | Array<string | Props | TestFunctionAnything>} Test
 *   Check for an arbitrary node, unaware of TypeScript inferral.
 *
 * @callback TestFunctionAnything
 *   Check if a node passes a test, unaware of TypeScript inferral.
 * @param {unknown} this
 *   The given context.
 * @param {Node} node
 *   A node.
 * @param {number | null | undefined} [index]
 *   The node’s position in its parent.
 * @param {Parent | null | undefined} [parent]
 *   The node’s parent.
 * @returns {boolean | void}
 *   Whether this node passes the test.
 */ /**
 * @template {Node} Kind
 *   Node type.
 * @typedef {Kind['type'] | Partial<Kind> | TestFunctionPredicate<Kind> | Array<Kind['type'] | Partial<Kind> | TestFunctionPredicate<Kind>>} PredicateTest
 *   Check for a node that can be inferred by TypeScript.
 */ /**
 * Check if a node passes a certain test.
 *
 * @template {Node} Kind
 *   Node type.
 * @callback TestFunctionPredicate
 *   Complex test function for a node that can be inferred by TypeScript.
 * @param {Node} node
 *   A node.
 * @param {number | null | undefined} [index]
 *   The node’s position in its parent.
 * @param {Parent | null | undefined} [parent]
 *   The node’s parent.
 * @returns {node is Kind}
 *   Whether this node passes the test.
 */ /**
 * @callback AssertAnything
 *   Check that an arbitrary value is a node, unaware of TypeScript inferral.
 * @param {unknown} [node]
 *   Anything (typically a node).
 * @param {number | null | undefined} [index]
 *   The node’s position in its parent.
 * @param {Parent | null | undefined} [parent]
 *   The node’s parent.
 * @returns {boolean}
 *   Whether this is a node and passes a test.
 */ /**
 * Check if a node is a node and passes a certain node test.
 *
 * @template {Node} Kind
 *   Node type.
 * @callback AssertPredicate
 *   Check that an arbitrary value is a specific node, aware of TypeScript.
 * @param {unknown} [node]
 *   Anything (typically a node).
 * @param {number | null | undefined} [index]
 *   The node’s position in its parent.
 * @param {Parent | null | undefined} [parent]
 *   The node’s parent.
 * @returns {node is Kind}
 *   Whether this is a node and passes a test.
 */ /**
 * Check if `node` is a `Node` and whether it passes the given test.
 *
 * @param node
 *   Thing to check, typically `Node`.
 * @param test
 *   A check for a specific node.
 * @param index
 *   The node’s position in its parent.
 * @param parent
 *   The node’s parent.
 * @returns
 *   Whether `node` is a node and passes a test.
 */ const $d39a51154bea3461$export$226b3eccf92c9ed9 = /**
   * @type {(
   *   (() => false) &
   *   (<Kind extends Node = Node>(node: unknown, test: PredicateTest<Kind>, index: number, parent: Parent, context?: unknown) => node is Kind) &
   *   (<Kind extends Node = Node>(node: unknown, test: PredicateTest<Kind>, index?: null | undefined, parent?: null | undefined, context?: unknown) => node is Kind) &
   *   ((node: unknown, test: Test, index: number, parent: Parent, context?: unknown) => boolean) &
   *   ((node: unknown, test?: Test, index?: null | undefined, parent?: null | undefined, context?: unknown) => boolean)
   * )}
   */ /**
     * @param {unknown} [node]
     * @param {Test} [test]
     * @param {number | null | undefined} [index]
     * @param {Parent | null | undefined} [parent]
     * @param {unknown} [context]
     * @returns {boolean}
     */ // eslint-disable-next-line max-params
function is(node, test, index, parent, context) {
    const check = $d39a51154bea3461$export$9c68d69a4c5bbcf9(test);
    if (index !== undefined && index !== null && (typeof index !== "number" || index < 0 || index === Number.POSITIVE_INFINITY)) throw new Error("Expected positive finite index");
    if (parent !== undefined && parent !== null && (!is(parent) || !parent.children)) throw new Error("Expected parent node");
    if ((parent === undefined || parent === null) !== (index === undefined || index === null)) throw new Error("Expected both parent and index");
    // @ts-expect-error Looks like a node.
    return node && node.type && typeof node.type === "string" ? Boolean(check.call(context, node, index, parent)) : false;
};
const $d39a51154bea3461$export$9c68d69a4c5bbcf9 = /**
   * @type {(
   *   (<Kind extends Node>(test: PredicateTest<Kind>) => AssertPredicate<Kind>) &
   *   ((test?: Test) => AssertAnything)
   * )}
   */ /**
     * @param {Test} [test]
     * @returns {AssertAnything}
     */ function(test) {
    if (test === undefined || test === null) return $d39a51154bea3461$var$ok;
    if (typeof test === "string") return $d39a51154bea3461$var$typeFactory(test);
    if (typeof test === "object") return Array.isArray(test) ? $d39a51154bea3461$var$anyFactory(test) : $d39a51154bea3461$var$propsFactory(test);
    if (typeof test === "function") return $d39a51154bea3461$var$castFactory(test);
    throw new Error("Expected function, string, or object as test");
};
/**
 * @param {Array<string | Props | TestFunctionAnything>} tests
 * @returns {AssertAnything}
 */ function $d39a51154bea3461$var$anyFactory(tests) {
    /** @type {Array<AssertAnything>} */ const checks = [];
    let index = -1;
    while(++index < tests.length)checks[index] = $d39a51154bea3461$export$9c68d69a4c5bbcf9(tests[index]);
    return $d39a51154bea3461$var$castFactory(any);
    /**
   * @this {unknown}
   * @param {Array<unknown>} parameters
   * @returns {boolean}
   */ function any(...parameters) {
        let index = -1;
        while(++index < checks.length){
            if (checks[index].call(this, ...parameters)) return true;
        }
        return false;
    }
}
/**
 * Turn an object into a test for a node with a certain fields.
 *
 * @param {Props} check
 * @returns {AssertAnything}
 */ function $d39a51154bea3461$var$propsFactory(check) {
    return $d39a51154bea3461$var$castFactory(all);
    /**
   * @param {Node} node
   * @returns {boolean}
   */ function all(node) {
        /** @type {string} */ let key;
        for(key in check){
            // @ts-expect-error: hush, it sure works as an index.
            if (node[key] !== check[key]) return false;
        }
        return true;
    }
}
/**
 * Turn a string into a test for a node with a certain type.
 *
 * @param {string} check
 * @returns {AssertAnything}
 */ function $d39a51154bea3461$var$typeFactory(check) {
    return $d39a51154bea3461$var$castFactory(type);
    /**
   * @param {Node} node
   */ function type(node) {
        return node && node.type === check;
    }
}
/**
 * Turn a custom test into a test for a node that passes that test.
 *
 * @param {TestFunctionAnything} check
 * @returns {AssertAnything}
 */ function $d39a51154bea3461$var$castFactory(check) {
    return assertion;
    /**
   * @this {unknown}
   * @param {unknown} node
   * @param {Array<unknown>} parameters
   * @returns {boolean}
   */ function assertion(node, ...parameters) {
        return Boolean(node && typeof node === "object" && "type" in node && // @ts-expect-error: fine.
        Boolean(check.call(this, node, ...parameters)));
    }
}
function $d39a51154bea3461$var$ok() {
    return true;
}


/**
 * @param {string} d
 * @returns {string}
 */ function $a3d76d7117445246$export$35e9368ef982300f(d) {
    return d;
}


const $50f8853af3000e7e$export$f4d8133c446fe484 = true;
const $50f8853af3000e7e$export$7f100f842f565dc9 = false;
const $50f8853af3000e7e$export$8773f85c2fb2c116 = "skip";
const $50f8853af3000e7e$export$70008a21eb6de899 = /**
   * @type {(
   *   (<Tree extends Node, Check extends Test>(tree: Tree, test: Check, visitor: BuildVisitor<Tree, Check>, reverse?: boolean | null | undefined) => void) &
   *   (<Tree extends Node>(tree: Tree, visitor: BuildVisitor<Tree>, reverse?: boolean | null | undefined) => void)
   * )}
   */ /**
     * @param {Node} tree
     * @param {Test} test
     * @param {Visitor<Node>} visitor
     * @param {boolean | null | undefined} [reverse]
     * @returns {void}
     */ function(tree, test, visitor, reverse) {
    if (typeof test === "function" && typeof visitor !== "function") {
        reverse = visitor;
        // @ts-expect-error no visitor given, so `visitor` is test.
        visitor = test;
        test = null;
    }
    const is = (0, $d39a51154bea3461$export$9c68d69a4c5bbcf9)(test);
    const step = reverse ? -1 : 1;
    factory(tree, undefined, [])();
    /**
       * @param {Node} node
       * @param {number | undefined} index
       * @param {Array<Parent>} parents
       */ function factory(node, index, parents) {
        /** @type {Record<string, unknown>} */ // @ts-expect-error: hush
        const value = node && typeof node === "object" ? node : {};
        if (typeof value.type === "string") {
            const name = // `hast`
            typeof value.tagName === "string" ? value.tagName : typeof value.name === "string" ? value.name : undefined;
            Object.defineProperty(visit, "name", {
                value: "node (" + (0, $a3d76d7117445246$export$35e9368ef982300f)(node.type + (name ? "<" + name + ">" : "")) + ")"
            });
        }
        return visit;
        function visit() {
            /** @type {ActionTuple} */ let result = [];
            /** @type {ActionTuple} */ let subresult;
            /** @type {number} */ let offset;
            /** @type {Array<Parent>} */ let grandparents;
            if (!test || is(node, index, parents[parents.length - 1] || null)) {
                result = $50f8853af3000e7e$var$toResult(visitor(node, parents));
                if (result[0] === $50f8853af3000e7e$export$7f100f842f565dc9) return result;
            }
            // @ts-expect-error looks like a parent.
            if (node.children && result[0] !== $50f8853af3000e7e$export$8773f85c2fb2c116) {
                // @ts-expect-error looks like a parent.
                offset = (reverse ? node.children.length : -1) + step;
                // @ts-expect-error looks like a parent.
                grandparents = parents.concat(node);
                // @ts-expect-error looks like a parent.
                while(offset > -1 && offset < node.children.length){
                    // @ts-expect-error looks like a parent.
                    subresult = factory(node.children[offset], offset, grandparents)();
                    if (subresult[0] === $50f8853af3000e7e$export$7f100f842f565dc9) return subresult;
                    offset = typeof subresult[1] === "number" ? subresult[1] : offset + step;
                }
            }
            return result;
        }
    }
};
/**
 * Turn a return value into a clean result.
 *
 * @param {VisitorResult} value
 *   Valid return values from visitors.
 * @returns {ActionTuple}
 *   Clean result.
 */ function $50f8853af3000e7e$var$toResult(value) {
    if (Array.isArray(value)) return value;
    if (typeof value === "number") return [
        $50f8853af3000e7e$export$f4d8133c446fe484,
        value
    ];
    return [
        value
    ];
}



const $80021cbffb8ae2c4$var$own = {}.hasOwnProperty;
const $80021cbffb8ae2c4$export$fb306ebf003fc574 = /**
   * @type {(
   *   (<Tree extends Node>(tree: Tree, find: Find, replace?: Replace | null | undefined, options?: Options | null | undefined) => Tree) &
   *   (<Tree extends Node>(tree: Tree, schema: FindAndReplaceSchema | FindAndReplaceList, options?: Options | null | undefined) => Tree)
   * )}
   **/ /**
     * @template {Node} Tree
     * @param {Tree} tree
     * @param {Find | FindAndReplaceSchema | FindAndReplaceList} find
     * @param {Replace | Options | null | undefined} [replace]
     * @param {Options | null | undefined} [options]
     * @returns {Tree}
     */ function(tree, find, replace, options) {
    /** @type {Options | null | undefined} */ let settings;
    /** @type {FindAndReplaceSchema|FindAndReplaceList} */ let schema;
    if (typeof find === "string" || find instanceof RegExp) {
        // @ts-expect-error don’t expect options twice.
        schema = [
            [
                find,
                replace
            ]
        ];
        settings = options;
    } else {
        schema = find;
        // @ts-expect-error don’t expect replace twice.
        settings = replace;
    }
    if (!settings) settings = {};
    const ignored = (0, $d39a51154bea3461$export$9c68d69a4c5bbcf9)(settings.ignore || []);
    const pairs = $80021cbffb8ae2c4$var$toPairs(schema);
    let pairIndex = -1;
    while(++pairIndex < pairs.length)(0, $50f8853af3000e7e$export$70008a21eb6de899)(tree, "text", visitor);
    // To do next major: don’t return the given tree.
    return tree;
    /** @type {import('unist-util-visit-parents/complex-types.js').BuildVisitor<Root, 'text'>} */ function visitor(node, parents) {
        let index = -1;
        /** @type {Parent | undefined} */ let grandparent;
        while(++index < parents.length){
            const parent = parents[index];
            if (ignored(parent, // @ts-expect-error: TS doesn’t understand but it’s perfect.
            grandparent ? grandparent.children.indexOf(parent) : undefined, grandparent)) return;
            grandparent = parent;
        }
        if (grandparent) return handler(node, parents);
    }
    /**
       * Handle a text node which is not in an ignored parent.
       *
       * @param {Text} node
       *   Text node.
       * @param {Array<Parent>} parents
       *   Parents.
       * @returns {VisitorResult}
       *   Result.
       */ function handler(node, parents) {
        const parent = parents[parents.length - 1];
        const find = pairs[pairIndex][0];
        const replace = pairs[pairIndex][1];
        let start = 0;
        // @ts-expect-error: TS is wrong, some of these children can be text.
        const index = parent.children.indexOf(node);
        let change = false;
        /** @type {Array<PhrasingContent>} */ let nodes = [];
        find.lastIndex = 0;
        let match = find.exec(node.value);
        while(match){
            const position = match.index;
            /** @type {RegExpMatchObject} */ const matchObject = {
                index: match.index,
                input: match.input,
                // @ts-expect-error: stack is fine.
                stack: [
                    ...parents,
                    node
                ]
            };
            let value = replace(...match, matchObject);
            if (typeof value === "string") value = value.length > 0 ? {
                type: "text",
                value: value
            } : undefined;
            // It wasn’t a match after all.
            if (value !== false) {
                if (start !== position) nodes.push({
                    type: "text",
                    value: node.value.slice(start, position)
                });
                if (Array.isArray(value)) nodes.push(...value);
                else if (value) nodes.push(value);
                start = position + match[0].length;
                change = true;
            }
            if (!find.global) break;
            match = find.exec(node.value);
        }
        if (change) {
            if (start < node.value.length) nodes.push({
                type: "text",
                value: node.value.slice(start)
            });
            parent.children.splice(index, 1, ...nodes);
        } else nodes = [
            node
        ];
        return index + nodes.length;
    }
};
/**
 * Turn a schema into pairs.
 *
 * @param {FindAndReplaceSchema | FindAndReplaceList} schema
 *   Schema.
 * @returns {Pairs}
 *   Clean pairs.
 */ function $80021cbffb8ae2c4$var$toPairs(schema) {
    /** @type {Pairs} */ const result = [];
    if (typeof schema !== "object") throw new TypeError("Expected array or object as schema");
    if (Array.isArray(schema)) {
        let index = -1;
        while(++index < schema.length)result.push([
            $80021cbffb8ae2c4$var$toExpression(schema[index][0]),
            $80021cbffb8ae2c4$var$toFunction(schema[index][1])
        ]);
    } else {
        /** @type {string} */ let key;
        for(key in schema)if ($80021cbffb8ae2c4$var$own.call(schema, key)) result.push([
            $80021cbffb8ae2c4$var$toExpression(key),
            $80021cbffb8ae2c4$var$toFunction(schema[key])
        ]);
    }
    return result;
}
/**
 * Turn a find into an expression.
 *
 * @param {Find} find
 *   Find.
 * @returns {RegExp}
 *   Expression.
 */ function $80021cbffb8ae2c4$var$toExpression(find) {
    return typeof find === "string" ? new RegExp((0, $5267f8a0ffe00049$export$2e2bcd8739ae039)(find), "g") : find;
}
/**
 * Turn a replace into a function.
 *
 * @param {Replace} replace
 *   Replace.
 * @returns {ReplaceFunction}
 *   Function.
 */ function $80021cbffb8ae2c4$var$toFunction(replace) {
    return typeof replace === "function" ? replace : ()=>replace;
}



/** @type {ConstructName} */ const $a08f89846789bc37$var$inConstruct = "phrasing";
/** @type {Array<ConstructName>} */ const $a08f89846789bc37$var$notInConstruct = [
    "autolink",
    "link",
    "image",
    "label"
];
const $a08f89846789bc37$export$b6afdfff2163546f = {
    transforms: [
        $a08f89846789bc37$var$transformGfmAutolinkLiterals
    ],
    enter: {
        literalAutolink: $a08f89846789bc37$var$enterLiteralAutolink,
        literalAutolinkEmail: $a08f89846789bc37$var$enterLiteralAutolinkValue,
        literalAutolinkHttp: $a08f89846789bc37$var$enterLiteralAutolinkValue,
        literalAutolinkWww: $a08f89846789bc37$var$enterLiteralAutolinkValue
    },
    exit: {
        literalAutolink: $a08f89846789bc37$var$exitLiteralAutolink,
        literalAutolinkEmail: $a08f89846789bc37$var$exitLiteralAutolinkEmail,
        literalAutolinkHttp: $a08f89846789bc37$var$exitLiteralAutolinkHttp,
        literalAutolinkWww: $a08f89846789bc37$var$exitLiteralAutolinkWww
    }
};
const $a08f89846789bc37$export$d3ace9096b01c39d = {
    unsafe: [
        {
            character: "@",
            before: "[+\\-.\\w]",
            after: "[\\-.\\w]",
            inConstruct: $a08f89846789bc37$var$inConstruct,
            notInConstruct: $a08f89846789bc37$var$notInConstruct
        },
        {
            character: ".",
            before: "[Ww]",
            after: "[\\-.\\w]",
            inConstruct: $a08f89846789bc37$var$inConstruct,
            notInConstruct: $a08f89846789bc37$var$notInConstruct
        },
        {
            character: ":",
            before: "[ps]",
            after: "\\/",
            inConstruct: $a08f89846789bc37$var$inConstruct,
            notInConstruct: $a08f89846789bc37$var$notInConstruct
        }
    ]
};
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $a08f89846789bc37$var$enterLiteralAutolink(token) {
    this.enter({
        type: "link",
        title: null,
        url: "",
        children: []
    }, token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $a08f89846789bc37$var$enterLiteralAutolinkValue(token) {
    this.config.enter.autolinkProtocol.call(this, token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $a08f89846789bc37$var$exitLiteralAutolinkHttp(token) {
    this.config.exit.autolinkProtocol.call(this, token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $a08f89846789bc37$var$exitLiteralAutolinkWww(token) {
    this.config.exit.data.call(this, token);
    const node = /** @type {Link} */ this.stack[this.stack.length - 1];
    node.url = "http://" + this.sliceSerialize(token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $a08f89846789bc37$var$exitLiteralAutolinkEmail(token) {
    this.config.exit.autolinkEmail.call(this, token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $a08f89846789bc37$var$exitLiteralAutolink(token) {
    this.exit(token);
}
/** @type {FromMarkdownTransform} */ function $a08f89846789bc37$var$transformGfmAutolinkLiterals(tree) {
    (0, $80021cbffb8ae2c4$export$fb306ebf003fc574)(tree, [
        [
            /(https?:\/\/|www(?=\.))([-.\w]+)([^ \t\r\n]*)/gi,
            $a08f89846789bc37$var$findUrl
        ],
        [
            /([-.\w+]+)@([-\w]+(?:\.[-\w]+)+)/g,
            $a08f89846789bc37$var$findEmail
        ]
    ], {
        ignore: [
            "link",
            "linkReference"
        ]
    });
}
/**
 * @type {ReplaceFunction}
 * @param {string} _
 * @param {string} protocol
 * @param {string} domain
 * @param {string} path
 * @param {RegExpMatchObject} match
 * @returns {Link | Array<PhrasingContent> | false}
 */ // eslint-disable-next-line max-params
function $a08f89846789bc37$var$findUrl(_, protocol, domain, path, match) {
    let prefix = "";
    // Not an expected previous character.
    if (!$a08f89846789bc37$var$previous(match)) return false;
    // Treat `www` as part of the domain.
    if (/^w/i.test(protocol)) {
        domain = protocol + domain;
        protocol = "";
        prefix = "http://";
    }
    if (!$a08f89846789bc37$var$isCorrectDomain(domain)) return false;
    const parts = $a08f89846789bc37$var$splitUrl(domain + path);
    if (!parts[0]) return false;
    /** @type {Link} */ const result = {
        type: "link",
        title: null,
        url: prefix + protocol + parts[0],
        children: [
            {
                type: "text",
                value: protocol + parts[0]
            }
        ]
    };
    if (parts[1]) return [
        result,
        {
            type: "text",
            value: parts[1]
        }
    ];
    return result;
}
/**
 * @type {ReplaceFunction}
 * @param {string} _
 * @param {string} atext
 * @param {string} label
 * @param {RegExpMatchObject} match
 * @returns {Link | false}
 */ function $a08f89846789bc37$var$findEmail(_, atext, label, match) {
    if (// Not an expected previous character.
    !$a08f89846789bc37$var$previous(match, true) || // Label ends in not allowed character.
    /[-\d_]$/.test(label)) return false;
    return {
        type: "link",
        title: null,
        url: "mailto:" + atext + "@" + label,
        children: [
            {
                type: "text",
                value: atext + "@" + label
            }
        ]
    };
}
/**
 * @param {string} domain
 * @returns {boolean}
 */ function $a08f89846789bc37$var$isCorrectDomain(domain) {
    const parts = domain.split(".");
    if (parts.length < 2 || parts[parts.length - 1] && (/_/.test(parts[parts.length - 1]) || !/[a-zA-Z\d]/.test(parts[parts.length - 1])) || parts[parts.length - 2] && (/_/.test(parts[parts.length - 2]) || !/[a-zA-Z\d]/.test(parts[parts.length - 2]))) return false;
    return true;
}
/**
 * @param {string} url
 * @returns {[string, string | undefined]}
 */ function $a08f89846789bc37$var$splitUrl(url) {
    const trailExec = /[!"&'),.:;<>?\]}]+$/.exec(url);
    if (!trailExec) return [
        url,
        undefined
    ];
    url = url.slice(0, trailExec.index);
    let trail = trailExec[0];
    let closingParenIndex = trail.indexOf(")");
    const openingParens = (0, $36540aa4f45c18b0$export$fa42eaa97a352e23)(url, "(");
    let closingParens = (0, $36540aa4f45c18b0$export$fa42eaa97a352e23)(url, ")");
    while(closingParenIndex !== -1 && openingParens > closingParens){
        url += trail.slice(0, closingParenIndex + 1);
        trail = trail.slice(closingParenIndex + 1);
        closingParenIndex = trail.indexOf(")");
        closingParens++;
    }
    return [
        url,
        trail
    ];
}
/**
 * @param {RegExpMatchObject} match
 * @param {boolean | null | undefined} [email=false]
 * @returns {boolean}
 */ function $a08f89846789bc37$var$previous(match, email) {
    const code = match.input.charCodeAt(match.index - 1);
    return (match.index === 0 || (0, $d81ad7e99936a248$export$a0ff789c034ffdf4)(code) || (0, $d81ad7e99936a248$export$aa04114dd888a7a0)(code)) && (!email || code !== 47);
}


/**
 * @typedef {import('mdast').FootnoteReference} FootnoteReference
 * @typedef {import('mdast').FootnoteDefinition} FootnoteDefinition
 * @typedef {import('mdast-util-from-markdown').CompileContext} CompileContext
 * @typedef {import('mdast-util-from-markdown').Extension} FromMarkdownExtension
 * @typedef {import('mdast-util-from-markdown').Handle} FromMarkdownHandle
 * @typedef {import('mdast-util-to-markdown').Options} ToMarkdownExtension
 * @typedef {import('mdast-util-to-markdown').Handle} ToMarkdownHandle
 * @typedef {import('mdast-util-to-markdown').Map} Map
 */ 
/**
 * @typedef {import('../types.js').AssociationId} AssociationId
 */ /**
 * Map of named character references.
 *
 * @type {Record<string, string>}
 */ const $4db4afe2316c32ea$export$ec810d1aafce79a7 = {
    AElig: "\xc6",
    AMP: "&",
    Aacute: "\xc1",
    Abreve: "\u0102",
    Acirc: "\xc2",
    Acy: "\u0410",
    Afr: "\uD835\uDD04",
    Agrave: "\xc0",
    Alpha: "\u0391",
    Amacr: "\u0100",
    And: "\u2A53",
    Aogon: "\u0104",
    Aopf: "\uD835\uDD38",
    ApplyFunction: "\u2061",
    Aring: "\xc5",
    Ascr: "\uD835\uDC9C",
    Assign: "\u2254",
    Atilde: "\xc3",
    Auml: "\xc4",
    Backslash: "\u2216",
    Barv: "\u2AE7",
    Barwed: "\u2306",
    Bcy: "\u0411",
    Because: "\u2235",
    Bernoullis: "\u212C",
    Beta: "\u0392",
    Bfr: "\uD835\uDD05",
    Bopf: "\uD835\uDD39",
    Breve: "\u02D8",
    Bscr: "\u212C",
    Bumpeq: "\u224E",
    CHcy: "\u0427",
    COPY: "\xa9",
    Cacute: "\u0106",
    Cap: "\u22D2",
    CapitalDifferentialD: "\u2145",
    Cayleys: "\u212D",
    Ccaron: "\u010C",
    Ccedil: "\xc7",
    Ccirc: "\u0108",
    Cconint: "\u2230",
    Cdot: "\u010A",
    Cedilla: "\xb8",
    CenterDot: "\xb7",
    Cfr: "\u212D",
    Chi: "\u03A7",
    CircleDot: "\u2299",
    CircleMinus: "\u2296",
    CirclePlus: "\u2295",
    CircleTimes: "\u2297",
    ClockwiseContourIntegral: "\u2232",
    CloseCurlyDoubleQuote: "\u201D",
    CloseCurlyQuote: "\u2019",
    Colon: "\u2237",
    Colone: "\u2A74",
    Congruent: "\u2261",
    Conint: "\u222F",
    ContourIntegral: "\u222E",
    Copf: "\u2102",
    Coproduct: "\u2210",
    CounterClockwiseContourIntegral: "\u2233",
    Cross: "\u2A2F",
    Cscr: "\uD835\uDC9E",
    Cup: "\u22D3",
    CupCap: "\u224D",
    DD: "\u2145",
    DDotrahd: "\u2911",
    DJcy: "\u0402",
    DScy: "\u0405",
    DZcy: "\u040F",
    Dagger: "\u2021",
    Darr: "\u21A1",
    Dashv: "\u2AE4",
    Dcaron: "\u010E",
    Dcy: "\u0414",
    Del: "\u2207",
    Delta: "\u0394",
    Dfr: "\uD835\uDD07",
    DiacriticalAcute: "\xb4",
    DiacriticalDot: "\u02D9",
    DiacriticalDoubleAcute: "\u02DD",
    DiacriticalGrave: "`",
    DiacriticalTilde: "\u02DC",
    Diamond: "\u22C4",
    DifferentialD: "\u2146",
    Dopf: "\uD835\uDD3B",
    Dot: "\xa8",
    DotDot: "\u20DC",
    DotEqual: "\u2250",
    DoubleContourIntegral: "\u222F",
    DoubleDot: "\xa8",
    DoubleDownArrow: "\u21D3",
    DoubleLeftArrow: "\u21D0",
    DoubleLeftRightArrow: "\u21D4",
    DoubleLeftTee: "\u2AE4",
    DoubleLongLeftArrow: "\u27F8",
    DoubleLongLeftRightArrow: "\u27FA",
    DoubleLongRightArrow: "\u27F9",
    DoubleRightArrow: "\u21D2",
    DoubleRightTee: "\u22A8",
    DoubleUpArrow: "\u21D1",
    DoubleUpDownArrow: "\u21D5",
    DoubleVerticalBar: "\u2225",
    DownArrow: "\u2193",
    DownArrowBar: "\u2913",
    DownArrowUpArrow: "\u21F5",
    DownBreve: "\u0311",
    DownLeftRightVector: "\u2950",
    DownLeftTeeVector: "\u295E",
    DownLeftVector: "\u21BD",
    DownLeftVectorBar: "\u2956",
    DownRightTeeVector: "\u295F",
    DownRightVector: "\u21C1",
    DownRightVectorBar: "\u2957",
    DownTee: "\u22A4",
    DownTeeArrow: "\u21A7",
    Downarrow: "\u21D3",
    Dscr: "\uD835\uDC9F",
    Dstrok: "\u0110",
    ENG: "\u014A",
    ETH: "\xd0",
    Eacute: "\xc9",
    Ecaron: "\u011A",
    Ecirc: "\xca",
    Ecy: "\u042D",
    Edot: "\u0116",
    Efr: "\uD835\uDD08",
    Egrave: "\xc8",
    Element: "\u2208",
    Emacr: "\u0112",
    EmptySmallSquare: "\u25FB",
    EmptyVerySmallSquare: "\u25AB",
    Eogon: "\u0118",
    Eopf: "\uD835\uDD3C",
    Epsilon: "\u0395",
    Equal: "\u2A75",
    EqualTilde: "\u2242",
    Equilibrium: "\u21CC",
    Escr: "\u2130",
    Esim: "\u2A73",
    Eta: "\u0397",
    Euml: "\xcb",
    Exists: "\u2203",
    ExponentialE: "\u2147",
    Fcy: "\u0424",
    Ffr: "\uD835\uDD09",
    FilledSmallSquare: "\u25FC",
    FilledVerySmallSquare: "\u25AA",
    Fopf: "\uD835\uDD3D",
    ForAll: "\u2200",
    Fouriertrf: "\u2131",
    Fscr: "\u2131",
    GJcy: "\u0403",
    GT: ">",
    Gamma: "\u0393",
    Gammad: "\u03DC",
    Gbreve: "\u011E",
    Gcedil: "\u0122",
    Gcirc: "\u011C",
    Gcy: "\u0413",
    Gdot: "\u0120",
    Gfr: "\uD835\uDD0A",
    Gg: "\u22D9",
    Gopf: "\uD835\uDD3E",
    GreaterEqual: "\u2265",
    GreaterEqualLess: "\u22DB",
    GreaterFullEqual: "\u2267",
    GreaterGreater: "\u2AA2",
    GreaterLess: "\u2277",
    GreaterSlantEqual: "\u2A7E",
    GreaterTilde: "\u2273",
    Gscr: "\uD835\uDCA2",
    Gt: "\u226B",
    HARDcy: "\u042A",
    Hacek: "\u02C7",
    Hat: "^",
    Hcirc: "\u0124",
    Hfr: "\u210C",
    HilbertSpace: "\u210B",
    Hopf: "\u210D",
    HorizontalLine: "\u2500",
    Hscr: "\u210B",
    Hstrok: "\u0126",
    HumpDownHump: "\u224E",
    HumpEqual: "\u224F",
    IEcy: "\u0415",
    IJlig: "\u0132",
    IOcy: "\u0401",
    Iacute: "\xcd",
    Icirc: "\xce",
    Icy: "\u0418",
    Idot: "\u0130",
    Ifr: "\u2111",
    Igrave: "\xcc",
    Im: "\u2111",
    Imacr: "\u012A",
    ImaginaryI: "\u2148",
    Implies: "\u21D2",
    Int: "\u222C",
    Integral: "\u222B",
    Intersection: "\u22C2",
    InvisibleComma: "\u2063",
    InvisibleTimes: "\u2062",
    Iogon: "\u012E",
    Iopf: "\uD835\uDD40",
    Iota: "\u0399",
    Iscr: "\u2110",
    Itilde: "\u0128",
    Iukcy: "\u0406",
    Iuml: "\xcf",
    Jcirc: "\u0134",
    Jcy: "\u0419",
    Jfr: "\uD835\uDD0D",
    Jopf: "\uD835\uDD41",
    Jscr: "\uD835\uDCA5",
    Jsercy: "\u0408",
    Jukcy: "\u0404",
    KHcy: "\u0425",
    KJcy: "\u040C",
    Kappa: "\u039A",
    Kcedil: "\u0136",
    Kcy: "\u041A",
    Kfr: "\uD835\uDD0E",
    Kopf: "\uD835\uDD42",
    Kscr: "\uD835\uDCA6",
    LJcy: "\u0409",
    LT: "<",
    Lacute: "\u0139",
    Lambda: "\u039B",
    Lang: "\u27EA",
    Laplacetrf: "\u2112",
    Larr: "\u219E",
    Lcaron: "\u013D",
    Lcedil: "\u013B",
    Lcy: "\u041B",
    LeftAngleBracket: "\u27E8",
    LeftArrow: "\u2190",
    LeftArrowBar: "\u21E4",
    LeftArrowRightArrow: "\u21C6",
    LeftCeiling: "\u2308",
    LeftDoubleBracket: "\u27E6",
    LeftDownTeeVector: "\u2961",
    LeftDownVector: "\u21C3",
    LeftDownVectorBar: "\u2959",
    LeftFloor: "\u230A",
    LeftRightArrow: "\u2194",
    LeftRightVector: "\u294E",
    LeftTee: "\u22A3",
    LeftTeeArrow: "\u21A4",
    LeftTeeVector: "\u295A",
    LeftTriangle: "\u22B2",
    LeftTriangleBar: "\u29CF",
    LeftTriangleEqual: "\u22B4",
    LeftUpDownVector: "\u2951",
    LeftUpTeeVector: "\u2960",
    LeftUpVector: "\u21BF",
    LeftUpVectorBar: "\u2958",
    LeftVector: "\u21BC",
    LeftVectorBar: "\u2952",
    Leftarrow: "\u21D0",
    Leftrightarrow: "\u21D4",
    LessEqualGreater: "\u22DA",
    LessFullEqual: "\u2266",
    LessGreater: "\u2276",
    LessLess: "\u2AA1",
    LessSlantEqual: "\u2A7D",
    LessTilde: "\u2272",
    Lfr: "\uD835\uDD0F",
    Ll: "\u22D8",
    Lleftarrow: "\u21DA",
    Lmidot: "\u013F",
    LongLeftArrow: "\u27F5",
    LongLeftRightArrow: "\u27F7",
    LongRightArrow: "\u27F6",
    Longleftarrow: "\u27F8",
    Longleftrightarrow: "\u27FA",
    Longrightarrow: "\u27F9",
    Lopf: "\uD835\uDD43",
    LowerLeftArrow: "\u2199",
    LowerRightArrow: "\u2198",
    Lscr: "\u2112",
    Lsh: "\u21B0",
    Lstrok: "\u0141",
    Lt: "\u226A",
    Map: "\u2905",
    Mcy: "\u041C",
    MediumSpace: "\u205F",
    Mellintrf: "\u2133",
    Mfr: "\uD835\uDD10",
    MinusPlus: "\u2213",
    Mopf: "\uD835\uDD44",
    Mscr: "\u2133",
    Mu: "\u039C",
    NJcy: "\u040A",
    Nacute: "\u0143",
    Ncaron: "\u0147",
    Ncedil: "\u0145",
    Ncy: "\u041D",
    NegativeMediumSpace: "\u200B",
    NegativeThickSpace: "\u200B",
    NegativeThinSpace: "\u200B",
    NegativeVeryThinSpace: "\u200B",
    NestedGreaterGreater: "\u226B",
    NestedLessLess: "\u226A",
    NewLine: "\n",
    Nfr: "\uD835\uDD11",
    NoBreak: "\u2060",
    NonBreakingSpace: "\xa0",
    Nopf: "\u2115",
    Not: "\u2AEC",
    NotCongruent: "\u2262",
    NotCupCap: "\u226D",
    NotDoubleVerticalBar: "\u2226",
    NotElement: "\u2209",
    NotEqual: "\u2260",
    NotEqualTilde: "\u2242\u0338",
    NotExists: "\u2204",
    NotGreater: "\u226F",
    NotGreaterEqual: "\u2271",
    NotGreaterFullEqual: "\u2267\u0338",
    NotGreaterGreater: "\u226B\u0338",
    NotGreaterLess: "\u2279",
    NotGreaterSlantEqual: "\u2A7E\u0338",
    NotGreaterTilde: "\u2275",
    NotHumpDownHump: "\u224E\u0338",
    NotHumpEqual: "\u224F\u0338",
    NotLeftTriangle: "\u22EA",
    NotLeftTriangleBar: "\u29CF\u0338",
    NotLeftTriangleEqual: "\u22EC",
    NotLess: "\u226E",
    NotLessEqual: "\u2270",
    NotLessGreater: "\u2278",
    NotLessLess: "\u226A\u0338",
    NotLessSlantEqual: "\u2A7D\u0338",
    NotLessTilde: "\u2274",
    NotNestedGreaterGreater: "\u2AA2\u0338",
    NotNestedLessLess: "\u2AA1\u0338",
    NotPrecedes: "\u2280",
    NotPrecedesEqual: "\u2AAF\u0338",
    NotPrecedesSlantEqual: "\u22E0",
    NotReverseElement: "\u220C",
    NotRightTriangle: "\u22EB",
    NotRightTriangleBar: "\u29D0\u0338",
    NotRightTriangleEqual: "\u22ED",
    NotSquareSubset: "\u228F\u0338",
    NotSquareSubsetEqual: "\u22E2",
    NotSquareSuperset: "\u2290\u0338",
    NotSquareSupersetEqual: "\u22E3",
    NotSubset: "\u2282\u20D2",
    NotSubsetEqual: "\u2288",
    NotSucceeds: "\u2281",
    NotSucceedsEqual: "\u2AB0\u0338",
    NotSucceedsSlantEqual: "\u22E1",
    NotSucceedsTilde: "\u227F\u0338",
    NotSuperset: "\u2283\u20D2",
    NotSupersetEqual: "\u2289",
    NotTilde: "\u2241",
    NotTildeEqual: "\u2244",
    NotTildeFullEqual: "\u2247",
    NotTildeTilde: "\u2249",
    NotVerticalBar: "\u2224",
    Nscr: "\uD835\uDCA9",
    Ntilde: "\xd1",
    Nu: "\u039D",
    OElig: "\u0152",
    Oacute: "\xd3",
    Ocirc: "\xd4",
    Ocy: "\u041E",
    Odblac: "\u0150",
    Ofr: "\uD835\uDD12",
    Ograve: "\xd2",
    Omacr: "\u014C",
    Omega: "\u03A9",
    Omicron: "\u039F",
    Oopf: "\uD835\uDD46",
    OpenCurlyDoubleQuote: "\u201C",
    OpenCurlyQuote: "\u2018",
    Or: "\u2A54",
    Oscr: "\uD835\uDCAA",
    Oslash: "\xd8",
    Otilde: "\xd5",
    Otimes: "\u2A37",
    Ouml: "\xd6",
    OverBar: "\u203E",
    OverBrace: "\u23DE",
    OverBracket: "\u23B4",
    OverParenthesis: "\u23DC",
    PartialD: "\u2202",
    Pcy: "\u041F",
    Pfr: "\uD835\uDD13",
    Phi: "\u03A6",
    Pi: "\u03A0",
    PlusMinus: "\xb1",
    Poincareplane: "\u210C",
    Popf: "\u2119",
    Pr: "\u2ABB",
    Precedes: "\u227A",
    PrecedesEqual: "\u2AAF",
    PrecedesSlantEqual: "\u227C",
    PrecedesTilde: "\u227E",
    Prime: "\u2033",
    Product: "\u220F",
    Proportion: "\u2237",
    Proportional: "\u221D",
    Pscr: "\uD835\uDCAB",
    Psi: "\u03A8",
    QUOT: '"',
    Qfr: "\uD835\uDD14",
    Qopf: "\u211A",
    Qscr: "\uD835\uDCAC",
    RBarr: "\u2910",
    REG: "\xae",
    Racute: "\u0154",
    Rang: "\u27EB",
    Rarr: "\u21A0",
    Rarrtl: "\u2916",
    Rcaron: "\u0158",
    Rcedil: "\u0156",
    Rcy: "\u0420",
    Re: "\u211C",
    ReverseElement: "\u220B",
    ReverseEquilibrium: "\u21CB",
    ReverseUpEquilibrium: "\u296F",
    Rfr: "\u211C",
    Rho: "\u03A1",
    RightAngleBracket: "\u27E9",
    RightArrow: "\u2192",
    RightArrowBar: "\u21E5",
    RightArrowLeftArrow: "\u21C4",
    RightCeiling: "\u2309",
    RightDoubleBracket: "\u27E7",
    RightDownTeeVector: "\u295D",
    RightDownVector: "\u21C2",
    RightDownVectorBar: "\u2955",
    RightFloor: "\u230B",
    RightTee: "\u22A2",
    RightTeeArrow: "\u21A6",
    RightTeeVector: "\u295B",
    RightTriangle: "\u22B3",
    RightTriangleBar: "\u29D0",
    RightTriangleEqual: "\u22B5",
    RightUpDownVector: "\u294F",
    RightUpTeeVector: "\u295C",
    RightUpVector: "\u21BE",
    RightUpVectorBar: "\u2954",
    RightVector: "\u21C0",
    RightVectorBar: "\u2953",
    Rightarrow: "\u21D2",
    Ropf: "\u211D",
    RoundImplies: "\u2970",
    Rrightarrow: "\u21DB",
    Rscr: "\u211B",
    Rsh: "\u21B1",
    RuleDelayed: "\u29F4",
    SHCHcy: "\u0429",
    SHcy: "\u0428",
    SOFTcy: "\u042C",
    Sacute: "\u015A",
    Sc: "\u2ABC",
    Scaron: "\u0160",
    Scedil: "\u015E",
    Scirc: "\u015C",
    Scy: "\u0421",
    Sfr: "\uD835\uDD16",
    ShortDownArrow: "\u2193",
    ShortLeftArrow: "\u2190",
    ShortRightArrow: "\u2192",
    ShortUpArrow: "\u2191",
    Sigma: "\u03A3",
    SmallCircle: "\u2218",
    Sopf: "\uD835\uDD4A",
    Sqrt: "\u221A",
    Square: "\u25A1",
    SquareIntersection: "\u2293",
    SquareSubset: "\u228F",
    SquareSubsetEqual: "\u2291",
    SquareSuperset: "\u2290",
    SquareSupersetEqual: "\u2292",
    SquareUnion: "\u2294",
    Sscr: "\uD835\uDCAE",
    Star: "\u22C6",
    Sub: "\u22D0",
    Subset: "\u22D0",
    SubsetEqual: "\u2286",
    Succeeds: "\u227B",
    SucceedsEqual: "\u2AB0",
    SucceedsSlantEqual: "\u227D",
    SucceedsTilde: "\u227F",
    SuchThat: "\u220B",
    Sum: "\u2211",
    Sup: "\u22D1",
    Superset: "\u2283",
    SupersetEqual: "\u2287",
    Supset: "\u22D1",
    THORN: "\xde",
    TRADE: "\u2122",
    TSHcy: "\u040B",
    TScy: "\u0426",
    Tab: "	",
    Tau: "\u03A4",
    Tcaron: "\u0164",
    Tcedil: "\u0162",
    Tcy: "\u0422",
    Tfr: "\uD835\uDD17",
    Therefore: "\u2234",
    Theta: "\u0398",
    ThickSpace: "\u205F\u200A",
    ThinSpace: "\u2009",
    Tilde: "\u223C",
    TildeEqual: "\u2243",
    TildeFullEqual: "\u2245",
    TildeTilde: "\u2248",
    Topf: "\uD835\uDD4B",
    TripleDot: "\u20DB",
    Tscr: "\uD835\uDCAF",
    Tstrok: "\u0166",
    Uacute: "\xda",
    Uarr: "\u219F",
    Uarrocir: "\u2949",
    Ubrcy: "\u040E",
    Ubreve: "\u016C",
    Ucirc: "\xdb",
    Ucy: "\u0423",
    Udblac: "\u0170",
    Ufr: "\uD835\uDD18",
    Ugrave: "\xd9",
    Umacr: "\u016A",
    UnderBar: "_",
    UnderBrace: "\u23DF",
    UnderBracket: "\u23B5",
    UnderParenthesis: "\u23DD",
    Union: "\u22C3",
    UnionPlus: "\u228E",
    Uogon: "\u0172",
    Uopf: "\uD835\uDD4C",
    UpArrow: "\u2191",
    UpArrowBar: "\u2912",
    UpArrowDownArrow: "\u21C5",
    UpDownArrow: "\u2195",
    UpEquilibrium: "\u296E",
    UpTee: "\u22A5",
    UpTeeArrow: "\u21A5",
    Uparrow: "\u21D1",
    Updownarrow: "\u21D5",
    UpperLeftArrow: "\u2196",
    UpperRightArrow: "\u2197",
    Upsi: "\u03D2",
    Upsilon: "\u03A5",
    Uring: "\u016E",
    Uscr: "\uD835\uDCB0",
    Utilde: "\u0168",
    Uuml: "\xdc",
    VDash: "\u22AB",
    Vbar: "\u2AEB",
    Vcy: "\u0412",
    Vdash: "\u22A9",
    Vdashl: "\u2AE6",
    Vee: "\u22C1",
    Verbar: "\u2016",
    Vert: "\u2016",
    VerticalBar: "\u2223",
    VerticalLine: "|",
    VerticalSeparator: "\u2758",
    VerticalTilde: "\u2240",
    VeryThinSpace: "\u200A",
    Vfr: "\uD835\uDD19",
    Vopf: "\uD835\uDD4D",
    Vscr: "\uD835\uDCB1",
    Vvdash: "\u22AA",
    Wcirc: "\u0174",
    Wedge: "\u22C0",
    Wfr: "\uD835\uDD1A",
    Wopf: "\uD835\uDD4E",
    Wscr: "\uD835\uDCB2",
    Xfr: "\uD835\uDD1B",
    Xi: "\u039E",
    Xopf: "\uD835\uDD4F",
    Xscr: "\uD835\uDCB3",
    YAcy: "\u042F",
    YIcy: "\u0407",
    YUcy: "\u042E",
    Yacute: "\xdd",
    Ycirc: "\u0176",
    Ycy: "\u042B",
    Yfr: "\uD835\uDD1C",
    Yopf: "\uD835\uDD50",
    Yscr: "\uD835\uDCB4",
    Yuml: "\u0178",
    ZHcy: "\u0416",
    Zacute: "\u0179",
    Zcaron: "\u017D",
    Zcy: "\u0417",
    Zdot: "\u017B",
    ZeroWidthSpace: "\u200B",
    Zeta: "\u0396",
    Zfr: "\u2128",
    Zopf: "\u2124",
    Zscr: "\uD835\uDCB5",
    aacute: "\xe1",
    abreve: "\u0103",
    ac: "\u223E",
    acE: "\u223E\u0333",
    acd: "\u223F",
    acirc: "\xe2",
    acute: "\xb4",
    acy: "\u0430",
    aelig: "\xe6",
    af: "\u2061",
    afr: "\uD835\uDD1E",
    agrave: "\xe0",
    alefsym: "\u2135",
    aleph: "\u2135",
    alpha: "\u03B1",
    amacr: "\u0101",
    amalg: "\u2A3F",
    amp: "&",
    and: "\u2227",
    andand: "\u2A55",
    andd: "\u2A5C",
    andslope: "\u2A58",
    andv: "\u2A5A",
    ang: "\u2220",
    ange: "\u29A4",
    angle: "\u2220",
    angmsd: "\u2221",
    angmsdaa: "\u29A8",
    angmsdab: "\u29A9",
    angmsdac: "\u29AA",
    angmsdad: "\u29AB",
    angmsdae: "\u29AC",
    angmsdaf: "\u29AD",
    angmsdag: "\u29AE",
    angmsdah: "\u29AF",
    angrt: "\u221F",
    angrtvb: "\u22BE",
    angrtvbd: "\u299D",
    angsph: "\u2222",
    angst: "\xc5",
    angzarr: "\u237C",
    aogon: "\u0105",
    aopf: "\uD835\uDD52",
    ap: "\u2248",
    apE: "\u2A70",
    apacir: "\u2A6F",
    ape: "\u224A",
    apid: "\u224B",
    apos: "'",
    approx: "\u2248",
    approxeq: "\u224A",
    aring: "\xe5",
    ascr: "\uD835\uDCB6",
    ast: "*",
    asymp: "\u2248",
    asympeq: "\u224D",
    atilde: "\xe3",
    auml: "\xe4",
    awconint: "\u2233",
    awint: "\u2A11",
    bNot: "\u2AED",
    backcong: "\u224C",
    backepsilon: "\u03F6",
    backprime: "\u2035",
    backsim: "\u223D",
    backsimeq: "\u22CD",
    barvee: "\u22BD",
    barwed: "\u2305",
    barwedge: "\u2305",
    bbrk: "\u23B5",
    bbrktbrk: "\u23B6",
    bcong: "\u224C",
    bcy: "\u0431",
    bdquo: "\u201E",
    becaus: "\u2235",
    because: "\u2235",
    bemptyv: "\u29B0",
    bepsi: "\u03F6",
    bernou: "\u212C",
    beta: "\u03B2",
    beth: "\u2136",
    between: "\u226C",
    bfr: "\uD835\uDD1F",
    bigcap: "\u22C2",
    bigcirc: "\u25EF",
    bigcup: "\u22C3",
    bigodot: "\u2A00",
    bigoplus: "\u2A01",
    bigotimes: "\u2A02",
    bigsqcup: "\u2A06",
    bigstar: "\u2605",
    bigtriangledown: "\u25BD",
    bigtriangleup: "\u25B3",
    biguplus: "\u2A04",
    bigvee: "\u22C1",
    bigwedge: "\u22C0",
    bkarow: "\u290D",
    blacklozenge: "\u29EB",
    blacksquare: "\u25AA",
    blacktriangle: "\u25B4",
    blacktriangledown: "\u25BE",
    blacktriangleleft: "\u25C2",
    blacktriangleright: "\u25B8",
    blank: "\u2423",
    blk12: "\u2592",
    blk14: "\u2591",
    blk34: "\u2593",
    block: "\u2588",
    bne: "=\u20E5",
    bnequiv: "\u2261\u20E5",
    bnot: "\u2310",
    bopf: "\uD835\uDD53",
    bot: "\u22A5",
    bottom: "\u22A5",
    bowtie: "\u22C8",
    boxDL: "\u2557",
    boxDR: "\u2554",
    boxDl: "\u2556",
    boxDr: "\u2553",
    boxH: "\u2550",
    boxHD: "\u2566",
    boxHU: "\u2569",
    boxHd: "\u2564",
    boxHu: "\u2567",
    boxUL: "\u255D",
    boxUR: "\u255A",
    boxUl: "\u255C",
    boxUr: "\u2559",
    boxV: "\u2551",
    boxVH: "\u256C",
    boxVL: "\u2563",
    boxVR: "\u2560",
    boxVh: "\u256B",
    boxVl: "\u2562",
    boxVr: "\u255F",
    boxbox: "\u29C9",
    boxdL: "\u2555",
    boxdR: "\u2552",
    boxdl: "\u2510",
    boxdr: "\u250C",
    boxh: "\u2500",
    boxhD: "\u2565",
    boxhU: "\u2568",
    boxhd: "\u252C",
    boxhu: "\u2534",
    boxminus: "\u229F",
    boxplus: "\u229E",
    boxtimes: "\u22A0",
    boxuL: "\u255B",
    boxuR: "\u2558",
    boxul: "\u2518",
    boxur: "\u2514",
    boxv: "\u2502",
    boxvH: "\u256A",
    boxvL: "\u2561",
    boxvR: "\u255E",
    boxvh: "\u253C",
    boxvl: "\u2524",
    boxvr: "\u251C",
    bprime: "\u2035",
    breve: "\u02D8",
    brvbar: "\xa6",
    bscr: "\uD835\uDCB7",
    bsemi: "\u204F",
    bsim: "\u223D",
    bsime: "\u22CD",
    bsol: "\\",
    bsolb: "\u29C5",
    bsolhsub: "\u27C8",
    bull: "\u2022",
    bullet: "\u2022",
    bump: "\u224E",
    bumpE: "\u2AAE",
    bumpe: "\u224F",
    bumpeq: "\u224F",
    cacute: "\u0107",
    cap: "\u2229",
    capand: "\u2A44",
    capbrcup: "\u2A49",
    capcap: "\u2A4B",
    capcup: "\u2A47",
    capdot: "\u2A40",
    caps: "\u2229\uFE00",
    caret: "\u2041",
    caron: "\u02C7",
    ccaps: "\u2A4D",
    ccaron: "\u010D",
    ccedil: "\xe7",
    ccirc: "\u0109",
    ccups: "\u2A4C",
    ccupssm: "\u2A50",
    cdot: "\u010B",
    cedil: "\xb8",
    cemptyv: "\u29B2",
    cent: "\xa2",
    centerdot: "\xb7",
    cfr: "\uD835\uDD20",
    chcy: "\u0447",
    check: "\u2713",
    checkmark: "\u2713",
    chi: "\u03C7",
    cir: "\u25CB",
    cirE: "\u29C3",
    circ: "\u02C6",
    circeq: "\u2257",
    circlearrowleft: "\u21BA",
    circlearrowright: "\u21BB",
    circledR: "\xae",
    circledS: "\u24C8",
    circledast: "\u229B",
    circledcirc: "\u229A",
    circleddash: "\u229D",
    cire: "\u2257",
    cirfnint: "\u2A10",
    cirmid: "\u2AEF",
    cirscir: "\u29C2",
    clubs: "\u2663",
    clubsuit: "\u2663",
    colon: ":",
    colone: "\u2254",
    coloneq: "\u2254",
    comma: ",",
    commat: "@",
    comp: "\u2201",
    compfn: "\u2218",
    complement: "\u2201",
    complexes: "\u2102",
    cong: "\u2245",
    congdot: "\u2A6D",
    conint: "\u222E",
    copf: "\uD835\uDD54",
    coprod: "\u2210",
    copy: "\xa9",
    copysr: "\u2117",
    crarr: "\u21B5",
    cross: "\u2717",
    cscr: "\uD835\uDCB8",
    csub: "\u2ACF",
    csube: "\u2AD1",
    csup: "\u2AD0",
    csupe: "\u2AD2",
    ctdot: "\u22EF",
    cudarrl: "\u2938",
    cudarrr: "\u2935",
    cuepr: "\u22DE",
    cuesc: "\u22DF",
    cularr: "\u21B6",
    cularrp: "\u293D",
    cup: "\u222A",
    cupbrcap: "\u2A48",
    cupcap: "\u2A46",
    cupcup: "\u2A4A",
    cupdot: "\u228D",
    cupor: "\u2A45",
    cups: "\u222A\uFE00",
    curarr: "\u21B7",
    curarrm: "\u293C",
    curlyeqprec: "\u22DE",
    curlyeqsucc: "\u22DF",
    curlyvee: "\u22CE",
    curlywedge: "\u22CF",
    curren: "\xa4",
    curvearrowleft: "\u21B6",
    curvearrowright: "\u21B7",
    cuvee: "\u22CE",
    cuwed: "\u22CF",
    cwconint: "\u2232",
    cwint: "\u2231",
    cylcty: "\u232D",
    dArr: "\u21D3",
    dHar: "\u2965",
    dagger: "\u2020",
    daleth: "\u2138",
    darr: "\u2193",
    dash: "\u2010",
    dashv: "\u22A3",
    dbkarow: "\u290F",
    dblac: "\u02DD",
    dcaron: "\u010F",
    dcy: "\u0434",
    dd: "\u2146",
    ddagger: "\u2021",
    ddarr: "\u21CA",
    ddotseq: "\u2A77",
    deg: "\xb0",
    delta: "\u03B4",
    demptyv: "\u29B1",
    dfisht: "\u297F",
    dfr: "\uD835\uDD21",
    dharl: "\u21C3",
    dharr: "\u21C2",
    diam: "\u22C4",
    diamond: "\u22C4",
    diamondsuit: "\u2666",
    diams: "\u2666",
    die: "\xa8",
    digamma: "\u03DD",
    disin: "\u22F2",
    div: "\xf7",
    divide: "\xf7",
    divideontimes: "\u22C7",
    divonx: "\u22C7",
    djcy: "\u0452",
    dlcorn: "\u231E",
    dlcrop: "\u230D",
    dollar: "$",
    dopf: "\uD835\uDD55",
    dot: "\u02D9",
    doteq: "\u2250",
    doteqdot: "\u2251",
    dotminus: "\u2238",
    dotplus: "\u2214",
    dotsquare: "\u22A1",
    doublebarwedge: "\u2306",
    downarrow: "\u2193",
    downdownarrows: "\u21CA",
    downharpoonleft: "\u21C3",
    downharpoonright: "\u21C2",
    drbkarow: "\u2910",
    drcorn: "\u231F",
    drcrop: "\u230C",
    dscr: "\uD835\uDCB9",
    dscy: "\u0455",
    dsol: "\u29F6",
    dstrok: "\u0111",
    dtdot: "\u22F1",
    dtri: "\u25BF",
    dtrif: "\u25BE",
    duarr: "\u21F5",
    duhar: "\u296F",
    dwangle: "\u29A6",
    dzcy: "\u045F",
    dzigrarr: "\u27FF",
    eDDot: "\u2A77",
    eDot: "\u2251",
    eacute: "\xe9",
    easter: "\u2A6E",
    ecaron: "\u011B",
    ecir: "\u2256",
    ecirc: "\xea",
    ecolon: "\u2255",
    ecy: "\u044D",
    edot: "\u0117",
    ee: "\u2147",
    efDot: "\u2252",
    efr: "\uD835\uDD22",
    eg: "\u2A9A",
    egrave: "\xe8",
    egs: "\u2A96",
    egsdot: "\u2A98",
    el: "\u2A99",
    elinters: "\u23E7",
    ell: "\u2113",
    els: "\u2A95",
    elsdot: "\u2A97",
    emacr: "\u0113",
    empty: "\u2205",
    emptyset: "\u2205",
    emptyv: "\u2205",
    emsp13: "\u2004",
    emsp14: "\u2005",
    emsp: "\u2003",
    eng: "\u014B",
    ensp: "\u2002",
    eogon: "\u0119",
    eopf: "\uD835\uDD56",
    epar: "\u22D5",
    eparsl: "\u29E3",
    eplus: "\u2A71",
    epsi: "\u03B5",
    epsilon: "\u03B5",
    epsiv: "\u03F5",
    eqcirc: "\u2256",
    eqcolon: "\u2255",
    eqsim: "\u2242",
    eqslantgtr: "\u2A96",
    eqslantless: "\u2A95",
    equals: "=",
    equest: "\u225F",
    equiv: "\u2261",
    equivDD: "\u2A78",
    eqvparsl: "\u29E5",
    erDot: "\u2253",
    erarr: "\u2971",
    escr: "\u212F",
    esdot: "\u2250",
    esim: "\u2242",
    eta: "\u03B7",
    eth: "\xf0",
    euml: "\xeb",
    euro: "\u20AC",
    excl: "!",
    exist: "\u2203",
    expectation: "\u2130",
    exponentiale: "\u2147",
    fallingdotseq: "\u2252",
    fcy: "\u0444",
    female: "\u2640",
    ffilig: "\uFB03",
    fflig: "\uFB00",
    ffllig: "\uFB04",
    ffr: "\uD835\uDD23",
    filig: "\uFB01",
    fjlig: "fj",
    flat: "\u266D",
    fllig: "\uFB02",
    fltns: "\u25B1",
    fnof: "\u0192",
    fopf: "\uD835\uDD57",
    forall: "\u2200",
    fork: "\u22D4",
    forkv: "\u2AD9",
    fpartint: "\u2A0D",
    frac12: "\xbd",
    frac13: "\u2153",
    frac14: "\xbc",
    frac15: "\u2155",
    frac16: "\u2159",
    frac18: "\u215B",
    frac23: "\u2154",
    frac25: "\u2156",
    frac34: "\xbe",
    frac35: "\u2157",
    frac38: "\u215C",
    frac45: "\u2158",
    frac56: "\u215A",
    frac58: "\u215D",
    frac78: "\u215E",
    frasl: "\u2044",
    frown: "\u2322",
    fscr: "\uD835\uDCBB",
    gE: "\u2267",
    gEl: "\u2A8C",
    gacute: "\u01F5",
    gamma: "\u03B3",
    gammad: "\u03DD",
    gap: "\u2A86",
    gbreve: "\u011F",
    gcirc: "\u011D",
    gcy: "\u0433",
    gdot: "\u0121",
    ge: "\u2265",
    gel: "\u22DB",
    geq: "\u2265",
    geqq: "\u2267",
    geqslant: "\u2A7E",
    ges: "\u2A7E",
    gescc: "\u2AA9",
    gesdot: "\u2A80",
    gesdoto: "\u2A82",
    gesdotol: "\u2A84",
    gesl: "\u22DB\uFE00",
    gesles: "\u2A94",
    gfr: "\uD835\uDD24",
    gg: "\u226B",
    ggg: "\u22D9",
    gimel: "\u2137",
    gjcy: "\u0453",
    gl: "\u2277",
    glE: "\u2A92",
    gla: "\u2AA5",
    glj: "\u2AA4",
    gnE: "\u2269",
    gnap: "\u2A8A",
    gnapprox: "\u2A8A",
    gne: "\u2A88",
    gneq: "\u2A88",
    gneqq: "\u2269",
    gnsim: "\u22E7",
    gopf: "\uD835\uDD58",
    grave: "`",
    gscr: "\u210A",
    gsim: "\u2273",
    gsime: "\u2A8E",
    gsiml: "\u2A90",
    gt: ">",
    gtcc: "\u2AA7",
    gtcir: "\u2A7A",
    gtdot: "\u22D7",
    gtlPar: "\u2995",
    gtquest: "\u2A7C",
    gtrapprox: "\u2A86",
    gtrarr: "\u2978",
    gtrdot: "\u22D7",
    gtreqless: "\u22DB",
    gtreqqless: "\u2A8C",
    gtrless: "\u2277",
    gtrsim: "\u2273",
    gvertneqq: "\u2269\uFE00",
    gvnE: "\u2269\uFE00",
    hArr: "\u21D4",
    hairsp: "\u200A",
    half: "\xbd",
    hamilt: "\u210B",
    hardcy: "\u044A",
    harr: "\u2194",
    harrcir: "\u2948",
    harrw: "\u21AD",
    hbar: "\u210F",
    hcirc: "\u0125",
    hearts: "\u2665",
    heartsuit: "\u2665",
    hellip: "\u2026",
    hercon: "\u22B9",
    hfr: "\uD835\uDD25",
    hksearow: "\u2925",
    hkswarow: "\u2926",
    hoarr: "\u21FF",
    homtht: "\u223B",
    hookleftarrow: "\u21A9",
    hookrightarrow: "\u21AA",
    hopf: "\uD835\uDD59",
    horbar: "\u2015",
    hscr: "\uD835\uDCBD",
    hslash: "\u210F",
    hstrok: "\u0127",
    hybull: "\u2043",
    hyphen: "\u2010",
    iacute: "\xed",
    ic: "\u2063",
    icirc: "\xee",
    icy: "\u0438",
    iecy: "\u0435",
    iexcl: "\xa1",
    iff: "\u21D4",
    ifr: "\uD835\uDD26",
    igrave: "\xec",
    ii: "\u2148",
    iiiint: "\u2A0C",
    iiint: "\u222D",
    iinfin: "\u29DC",
    iiota: "\u2129",
    ijlig: "\u0133",
    imacr: "\u012B",
    image: "\u2111",
    imagline: "\u2110",
    imagpart: "\u2111",
    imath: "\u0131",
    imof: "\u22B7",
    imped: "\u01B5",
    in: "\u2208",
    incare: "\u2105",
    infin: "\u221E",
    infintie: "\u29DD",
    inodot: "\u0131",
    int: "\u222B",
    intcal: "\u22BA",
    integers: "\u2124",
    intercal: "\u22BA",
    intlarhk: "\u2A17",
    intprod: "\u2A3C",
    iocy: "\u0451",
    iogon: "\u012F",
    iopf: "\uD835\uDD5A",
    iota: "\u03B9",
    iprod: "\u2A3C",
    iquest: "\xbf",
    iscr: "\uD835\uDCBE",
    isin: "\u2208",
    isinE: "\u22F9",
    isindot: "\u22F5",
    isins: "\u22F4",
    isinsv: "\u22F3",
    isinv: "\u2208",
    it: "\u2062",
    itilde: "\u0129",
    iukcy: "\u0456",
    iuml: "\xef",
    jcirc: "\u0135",
    jcy: "\u0439",
    jfr: "\uD835\uDD27",
    jmath: "\u0237",
    jopf: "\uD835\uDD5B",
    jscr: "\uD835\uDCBF",
    jsercy: "\u0458",
    jukcy: "\u0454",
    kappa: "\u03BA",
    kappav: "\u03F0",
    kcedil: "\u0137",
    kcy: "\u043A",
    kfr: "\uD835\uDD28",
    kgreen: "\u0138",
    khcy: "\u0445",
    kjcy: "\u045C",
    kopf: "\uD835\uDD5C",
    kscr: "\uD835\uDCC0",
    lAarr: "\u21DA",
    lArr: "\u21D0",
    lAtail: "\u291B",
    lBarr: "\u290E",
    lE: "\u2266",
    lEg: "\u2A8B",
    lHar: "\u2962",
    lacute: "\u013A",
    laemptyv: "\u29B4",
    lagran: "\u2112",
    lambda: "\u03BB",
    lang: "\u27E8",
    langd: "\u2991",
    langle: "\u27E8",
    lap: "\u2A85",
    laquo: "\xab",
    larr: "\u2190",
    larrb: "\u21E4",
    larrbfs: "\u291F",
    larrfs: "\u291D",
    larrhk: "\u21A9",
    larrlp: "\u21AB",
    larrpl: "\u2939",
    larrsim: "\u2973",
    larrtl: "\u21A2",
    lat: "\u2AAB",
    latail: "\u2919",
    late: "\u2AAD",
    lates: "\u2AAD\uFE00",
    lbarr: "\u290C",
    lbbrk: "\u2772",
    lbrace: "{",
    lbrack: "[",
    lbrke: "\u298B",
    lbrksld: "\u298F",
    lbrkslu: "\u298D",
    lcaron: "\u013E",
    lcedil: "\u013C",
    lceil: "\u2308",
    lcub: "{",
    lcy: "\u043B",
    ldca: "\u2936",
    ldquo: "\u201C",
    ldquor: "\u201E",
    ldrdhar: "\u2967",
    ldrushar: "\u294B",
    ldsh: "\u21B2",
    le: "\u2264",
    leftarrow: "\u2190",
    leftarrowtail: "\u21A2",
    leftharpoondown: "\u21BD",
    leftharpoonup: "\u21BC",
    leftleftarrows: "\u21C7",
    leftrightarrow: "\u2194",
    leftrightarrows: "\u21C6",
    leftrightharpoons: "\u21CB",
    leftrightsquigarrow: "\u21AD",
    leftthreetimes: "\u22CB",
    leg: "\u22DA",
    leq: "\u2264",
    leqq: "\u2266",
    leqslant: "\u2A7D",
    les: "\u2A7D",
    lescc: "\u2AA8",
    lesdot: "\u2A7F",
    lesdoto: "\u2A81",
    lesdotor: "\u2A83",
    lesg: "\u22DA\uFE00",
    lesges: "\u2A93",
    lessapprox: "\u2A85",
    lessdot: "\u22D6",
    lesseqgtr: "\u22DA",
    lesseqqgtr: "\u2A8B",
    lessgtr: "\u2276",
    lesssim: "\u2272",
    lfisht: "\u297C",
    lfloor: "\u230A",
    lfr: "\uD835\uDD29",
    lg: "\u2276",
    lgE: "\u2A91",
    lhard: "\u21BD",
    lharu: "\u21BC",
    lharul: "\u296A",
    lhblk: "\u2584",
    ljcy: "\u0459",
    ll: "\u226A",
    llarr: "\u21C7",
    llcorner: "\u231E",
    llhard: "\u296B",
    lltri: "\u25FA",
    lmidot: "\u0140",
    lmoust: "\u23B0",
    lmoustache: "\u23B0",
    lnE: "\u2268",
    lnap: "\u2A89",
    lnapprox: "\u2A89",
    lne: "\u2A87",
    lneq: "\u2A87",
    lneqq: "\u2268",
    lnsim: "\u22E6",
    loang: "\u27EC",
    loarr: "\u21FD",
    lobrk: "\u27E6",
    longleftarrow: "\u27F5",
    longleftrightarrow: "\u27F7",
    longmapsto: "\u27FC",
    longrightarrow: "\u27F6",
    looparrowleft: "\u21AB",
    looparrowright: "\u21AC",
    lopar: "\u2985",
    lopf: "\uD835\uDD5D",
    loplus: "\u2A2D",
    lotimes: "\u2A34",
    lowast: "\u2217",
    lowbar: "_",
    loz: "\u25CA",
    lozenge: "\u25CA",
    lozf: "\u29EB",
    lpar: "(",
    lparlt: "\u2993",
    lrarr: "\u21C6",
    lrcorner: "\u231F",
    lrhar: "\u21CB",
    lrhard: "\u296D",
    lrm: "\u200E",
    lrtri: "\u22BF",
    lsaquo: "\u2039",
    lscr: "\uD835\uDCC1",
    lsh: "\u21B0",
    lsim: "\u2272",
    lsime: "\u2A8D",
    lsimg: "\u2A8F",
    lsqb: "[",
    lsquo: "\u2018",
    lsquor: "\u201A",
    lstrok: "\u0142",
    lt: "<",
    ltcc: "\u2AA6",
    ltcir: "\u2A79",
    ltdot: "\u22D6",
    lthree: "\u22CB",
    ltimes: "\u22C9",
    ltlarr: "\u2976",
    ltquest: "\u2A7B",
    ltrPar: "\u2996",
    ltri: "\u25C3",
    ltrie: "\u22B4",
    ltrif: "\u25C2",
    lurdshar: "\u294A",
    luruhar: "\u2966",
    lvertneqq: "\u2268\uFE00",
    lvnE: "\u2268\uFE00",
    mDDot: "\u223A",
    macr: "\xaf",
    male: "\u2642",
    malt: "\u2720",
    maltese: "\u2720",
    map: "\u21A6",
    mapsto: "\u21A6",
    mapstodown: "\u21A7",
    mapstoleft: "\u21A4",
    mapstoup: "\u21A5",
    marker: "\u25AE",
    mcomma: "\u2A29",
    mcy: "\u043C",
    mdash: "\u2014",
    measuredangle: "\u2221",
    mfr: "\uD835\uDD2A",
    mho: "\u2127",
    micro: "\xb5",
    mid: "\u2223",
    midast: "*",
    midcir: "\u2AF0",
    middot: "\xb7",
    minus: "\u2212",
    minusb: "\u229F",
    minusd: "\u2238",
    minusdu: "\u2A2A",
    mlcp: "\u2ADB",
    mldr: "\u2026",
    mnplus: "\u2213",
    models: "\u22A7",
    mopf: "\uD835\uDD5E",
    mp: "\u2213",
    mscr: "\uD835\uDCC2",
    mstpos: "\u223E",
    mu: "\u03BC",
    multimap: "\u22B8",
    mumap: "\u22B8",
    nGg: "\u22D9\u0338",
    nGt: "\u226B\u20D2",
    nGtv: "\u226B\u0338",
    nLeftarrow: "\u21CD",
    nLeftrightarrow: "\u21CE",
    nLl: "\u22D8\u0338",
    nLt: "\u226A\u20D2",
    nLtv: "\u226A\u0338",
    nRightarrow: "\u21CF",
    nVDash: "\u22AF",
    nVdash: "\u22AE",
    nabla: "\u2207",
    nacute: "\u0144",
    nang: "\u2220\u20D2",
    nap: "\u2249",
    napE: "\u2A70\u0338",
    napid: "\u224B\u0338",
    napos: "\u0149",
    napprox: "\u2249",
    natur: "\u266E",
    natural: "\u266E",
    naturals: "\u2115",
    nbsp: "\xa0",
    nbump: "\u224E\u0338",
    nbumpe: "\u224F\u0338",
    ncap: "\u2A43",
    ncaron: "\u0148",
    ncedil: "\u0146",
    ncong: "\u2247",
    ncongdot: "\u2A6D\u0338",
    ncup: "\u2A42",
    ncy: "\u043D",
    ndash: "\u2013",
    ne: "\u2260",
    neArr: "\u21D7",
    nearhk: "\u2924",
    nearr: "\u2197",
    nearrow: "\u2197",
    nedot: "\u2250\u0338",
    nequiv: "\u2262",
    nesear: "\u2928",
    nesim: "\u2242\u0338",
    nexist: "\u2204",
    nexists: "\u2204",
    nfr: "\uD835\uDD2B",
    ngE: "\u2267\u0338",
    nge: "\u2271",
    ngeq: "\u2271",
    ngeqq: "\u2267\u0338",
    ngeqslant: "\u2A7E\u0338",
    nges: "\u2A7E\u0338",
    ngsim: "\u2275",
    ngt: "\u226F",
    ngtr: "\u226F",
    nhArr: "\u21CE",
    nharr: "\u21AE",
    nhpar: "\u2AF2",
    ni: "\u220B",
    nis: "\u22FC",
    nisd: "\u22FA",
    niv: "\u220B",
    njcy: "\u045A",
    nlArr: "\u21CD",
    nlE: "\u2266\u0338",
    nlarr: "\u219A",
    nldr: "\u2025",
    nle: "\u2270",
    nleftarrow: "\u219A",
    nleftrightarrow: "\u21AE",
    nleq: "\u2270",
    nleqq: "\u2266\u0338",
    nleqslant: "\u2A7D\u0338",
    nles: "\u2A7D\u0338",
    nless: "\u226E",
    nlsim: "\u2274",
    nlt: "\u226E",
    nltri: "\u22EA",
    nltrie: "\u22EC",
    nmid: "\u2224",
    nopf: "\uD835\uDD5F",
    not: "\xac",
    notin: "\u2209",
    notinE: "\u22F9\u0338",
    notindot: "\u22F5\u0338",
    notinva: "\u2209",
    notinvb: "\u22F7",
    notinvc: "\u22F6",
    notni: "\u220C",
    notniva: "\u220C",
    notnivb: "\u22FE",
    notnivc: "\u22FD",
    npar: "\u2226",
    nparallel: "\u2226",
    nparsl: "\u2AFD\u20E5",
    npart: "\u2202\u0338",
    npolint: "\u2A14",
    npr: "\u2280",
    nprcue: "\u22E0",
    npre: "\u2AAF\u0338",
    nprec: "\u2280",
    npreceq: "\u2AAF\u0338",
    nrArr: "\u21CF",
    nrarr: "\u219B",
    nrarrc: "\u2933\u0338",
    nrarrw: "\u219D\u0338",
    nrightarrow: "\u219B",
    nrtri: "\u22EB",
    nrtrie: "\u22ED",
    nsc: "\u2281",
    nsccue: "\u22E1",
    nsce: "\u2AB0\u0338",
    nscr: "\uD835\uDCC3",
    nshortmid: "\u2224",
    nshortparallel: "\u2226",
    nsim: "\u2241",
    nsime: "\u2244",
    nsimeq: "\u2244",
    nsmid: "\u2224",
    nspar: "\u2226",
    nsqsube: "\u22E2",
    nsqsupe: "\u22E3",
    nsub: "\u2284",
    nsubE: "\u2AC5\u0338",
    nsube: "\u2288",
    nsubset: "\u2282\u20D2",
    nsubseteq: "\u2288",
    nsubseteqq: "\u2AC5\u0338",
    nsucc: "\u2281",
    nsucceq: "\u2AB0\u0338",
    nsup: "\u2285",
    nsupE: "\u2AC6\u0338",
    nsupe: "\u2289",
    nsupset: "\u2283\u20D2",
    nsupseteq: "\u2289",
    nsupseteqq: "\u2AC6\u0338",
    ntgl: "\u2279",
    ntilde: "\xf1",
    ntlg: "\u2278",
    ntriangleleft: "\u22EA",
    ntrianglelefteq: "\u22EC",
    ntriangleright: "\u22EB",
    ntrianglerighteq: "\u22ED",
    nu: "\u03BD",
    num: "#",
    numero: "\u2116",
    numsp: "\u2007",
    nvDash: "\u22AD",
    nvHarr: "\u2904",
    nvap: "\u224D\u20D2",
    nvdash: "\u22AC",
    nvge: "\u2265\u20D2",
    nvgt: ">\u20D2",
    nvinfin: "\u29DE",
    nvlArr: "\u2902",
    nvle: "\u2264\u20D2",
    nvlt: "<\u20D2",
    nvltrie: "\u22B4\u20D2",
    nvrArr: "\u2903",
    nvrtrie: "\u22B5\u20D2",
    nvsim: "\u223C\u20D2",
    nwArr: "\u21D6",
    nwarhk: "\u2923",
    nwarr: "\u2196",
    nwarrow: "\u2196",
    nwnear: "\u2927",
    oS: "\u24C8",
    oacute: "\xf3",
    oast: "\u229B",
    ocir: "\u229A",
    ocirc: "\xf4",
    ocy: "\u043E",
    odash: "\u229D",
    odblac: "\u0151",
    odiv: "\u2A38",
    odot: "\u2299",
    odsold: "\u29BC",
    oelig: "\u0153",
    ofcir: "\u29BF",
    ofr: "\uD835\uDD2C",
    ogon: "\u02DB",
    ograve: "\xf2",
    ogt: "\u29C1",
    ohbar: "\u29B5",
    ohm: "\u03A9",
    oint: "\u222E",
    olarr: "\u21BA",
    olcir: "\u29BE",
    olcross: "\u29BB",
    oline: "\u203E",
    olt: "\u29C0",
    omacr: "\u014D",
    omega: "\u03C9",
    omicron: "\u03BF",
    omid: "\u29B6",
    ominus: "\u2296",
    oopf: "\uD835\uDD60",
    opar: "\u29B7",
    operp: "\u29B9",
    oplus: "\u2295",
    or: "\u2228",
    orarr: "\u21BB",
    ord: "\u2A5D",
    order: "\u2134",
    orderof: "\u2134",
    ordf: "\xaa",
    ordm: "\xba",
    origof: "\u22B6",
    oror: "\u2A56",
    orslope: "\u2A57",
    orv: "\u2A5B",
    oscr: "\u2134",
    oslash: "\xf8",
    osol: "\u2298",
    otilde: "\xf5",
    otimes: "\u2297",
    otimesas: "\u2A36",
    ouml: "\xf6",
    ovbar: "\u233D",
    par: "\u2225",
    para: "\xb6",
    parallel: "\u2225",
    parsim: "\u2AF3",
    parsl: "\u2AFD",
    part: "\u2202",
    pcy: "\u043F",
    percnt: "%",
    period: ".",
    permil: "\u2030",
    perp: "\u22A5",
    pertenk: "\u2031",
    pfr: "\uD835\uDD2D",
    phi: "\u03C6",
    phiv: "\u03D5",
    phmmat: "\u2133",
    phone: "\u260E",
    pi: "\u03C0",
    pitchfork: "\u22D4",
    piv: "\u03D6",
    planck: "\u210F",
    planckh: "\u210E",
    plankv: "\u210F",
    plus: "+",
    plusacir: "\u2A23",
    plusb: "\u229E",
    pluscir: "\u2A22",
    plusdo: "\u2214",
    plusdu: "\u2A25",
    pluse: "\u2A72",
    plusmn: "\xb1",
    plussim: "\u2A26",
    plustwo: "\u2A27",
    pm: "\xb1",
    pointint: "\u2A15",
    popf: "\uD835\uDD61",
    pound: "\xa3",
    pr: "\u227A",
    prE: "\u2AB3",
    prap: "\u2AB7",
    prcue: "\u227C",
    pre: "\u2AAF",
    prec: "\u227A",
    precapprox: "\u2AB7",
    preccurlyeq: "\u227C",
    preceq: "\u2AAF",
    precnapprox: "\u2AB9",
    precneqq: "\u2AB5",
    precnsim: "\u22E8",
    precsim: "\u227E",
    prime: "\u2032",
    primes: "\u2119",
    prnE: "\u2AB5",
    prnap: "\u2AB9",
    prnsim: "\u22E8",
    prod: "\u220F",
    profalar: "\u232E",
    profline: "\u2312",
    profsurf: "\u2313",
    prop: "\u221D",
    propto: "\u221D",
    prsim: "\u227E",
    prurel: "\u22B0",
    pscr: "\uD835\uDCC5",
    psi: "\u03C8",
    puncsp: "\u2008",
    qfr: "\uD835\uDD2E",
    qint: "\u2A0C",
    qopf: "\uD835\uDD62",
    qprime: "\u2057",
    qscr: "\uD835\uDCC6",
    quaternions: "\u210D",
    quatint: "\u2A16",
    quest: "?",
    questeq: "\u225F",
    quot: '"',
    rAarr: "\u21DB",
    rArr: "\u21D2",
    rAtail: "\u291C",
    rBarr: "\u290F",
    rHar: "\u2964",
    race: "\u223D\u0331",
    racute: "\u0155",
    radic: "\u221A",
    raemptyv: "\u29B3",
    rang: "\u27E9",
    rangd: "\u2992",
    range: "\u29A5",
    rangle: "\u27E9",
    raquo: "\xbb",
    rarr: "\u2192",
    rarrap: "\u2975",
    rarrb: "\u21E5",
    rarrbfs: "\u2920",
    rarrc: "\u2933",
    rarrfs: "\u291E",
    rarrhk: "\u21AA",
    rarrlp: "\u21AC",
    rarrpl: "\u2945",
    rarrsim: "\u2974",
    rarrtl: "\u21A3",
    rarrw: "\u219D",
    ratail: "\u291A",
    ratio: "\u2236",
    rationals: "\u211A",
    rbarr: "\u290D",
    rbbrk: "\u2773",
    rbrace: "}",
    rbrack: "]",
    rbrke: "\u298C",
    rbrksld: "\u298E",
    rbrkslu: "\u2990",
    rcaron: "\u0159",
    rcedil: "\u0157",
    rceil: "\u2309",
    rcub: "}",
    rcy: "\u0440",
    rdca: "\u2937",
    rdldhar: "\u2969",
    rdquo: "\u201D",
    rdquor: "\u201D",
    rdsh: "\u21B3",
    real: "\u211C",
    realine: "\u211B",
    realpart: "\u211C",
    reals: "\u211D",
    rect: "\u25AD",
    reg: "\xae",
    rfisht: "\u297D",
    rfloor: "\u230B",
    rfr: "\uD835\uDD2F",
    rhard: "\u21C1",
    rharu: "\u21C0",
    rharul: "\u296C",
    rho: "\u03C1",
    rhov: "\u03F1",
    rightarrow: "\u2192",
    rightarrowtail: "\u21A3",
    rightharpoondown: "\u21C1",
    rightharpoonup: "\u21C0",
    rightleftarrows: "\u21C4",
    rightleftharpoons: "\u21CC",
    rightrightarrows: "\u21C9",
    rightsquigarrow: "\u219D",
    rightthreetimes: "\u22CC",
    ring: "\u02DA",
    risingdotseq: "\u2253",
    rlarr: "\u21C4",
    rlhar: "\u21CC",
    rlm: "\u200F",
    rmoust: "\u23B1",
    rmoustache: "\u23B1",
    rnmid: "\u2AEE",
    roang: "\u27ED",
    roarr: "\u21FE",
    robrk: "\u27E7",
    ropar: "\u2986",
    ropf: "\uD835\uDD63",
    roplus: "\u2A2E",
    rotimes: "\u2A35",
    rpar: ")",
    rpargt: "\u2994",
    rppolint: "\u2A12",
    rrarr: "\u21C9",
    rsaquo: "\u203A",
    rscr: "\uD835\uDCC7",
    rsh: "\u21B1",
    rsqb: "]",
    rsquo: "\u2019",
    rsquor: "\u2019",
    rthree: "\u22CC",
    rtimes: "\u22CA",
    rtri: "\u25B9",
    rtrie: "\u22B5",
    rtrif: "\u25B8",
    rtriltri: "\u29CE",
    ruluhar: "\u2968",
    rx: "\u211E",
    sacute: "\u015B",
    sbquo: "\u201A",
    sc: "\u227B",
    scE: "\u2AB4",
    scap: "\u2AB8",
    scaron: "\u0161",
    sccue: "\u227D",
    sce: "\u2AB0",
    scedil: "\u015F",
    scirc: "\u015D",
    scnE: "\u2AB6",
    scnap: "\u2ABA",
    scnsim: "\u22E9",
    scpolint: "\u2A13",
    scsim: "\u227F",
    scy: "\u0441",
    sdot: "\u22C5",
    sdotb: "\u22A1",
    sdote: "\u2A66",
    seArr: "\u21D8",
    searhk: "\u2925",
    searr: "\u2198",
    searrow: "\u2198",
    sect: "\xa7",
    semi: ";",
    seswar: "\u2929",
    setminus: "\u2216",
    setmn: "\u2216",
    sext: "\u2736",
    sfr: "\uD835\uDD30",
    sfrown: "\u2322",
    sharp: "\u266F",
    shchcy: "\u0449",
    shcy: "\u0448",
    shortmid: "\u2223",
    shortparallel: "\u2225",
    shy: "\xad",
    sigma: "\u03C3",
    sigmaf: "\u03C2",
    sigmav: "\u03C2",
    sim: "\u223C",
    simdot: "\u2A6A",
    sime: "\u2243",
    simeq: "\u2243",
    simg: "\u2A9E",
    simgE: "\u2AA0",
    siml: "\u2A9D",
    simlE: "\u2A9F",
    simne: "\u2246",
    simplus: "\u2A24",
    simrarr: "\u2972",
    slarr: "\u2190",
    smallsetminus: "\u2216",
    smashp: "\u2A33",
    smeparsl: "\u29E4",
    smid: "\u2223",
    smile: "\u2323",
    smt: "\u2AAA",
    smte: "\u2AAC",
    smtes: "\u2AAC\uFE00",
    softcy: "\u044C",
    sol: "/",
    solb: "\u29C4",
    solbar: "\u233F",
    sopf: "\uD835\uDD64",
    spades: "\u2660",
    spadesuit: "\u2660",
    spar: "\u2225",
    sqcap: "\u2293",
    sqcaps: "\u2293\uFE00",
    sqcup: "\u2294",
    sqcups: "\u2294\uFE00",
    sqsub: "\u228F",
    sqsube: "\u2291",
    sqsubset: "\u228F",
    sqsubseteq: "\u2291",
    sqsup: "\u2290",
    sqsupe: "\u2292",
    sqsupset: "\u2290",
    sqsupseteq: "\u2292",
    squ: "\u25A1",
    square: "\u25A1",
    squarf: "\u25AA",
    squf: "\u25AA",
    srarr: "\u2192",
    sscr: "\uD835\uDCC8",
    ssetmn: "\u2216",
    ssmile: "\u2323",
    sstarf: "\u22C6",
    star: "\u2606",
    starf: "\u2605",
    straightepsilon: "\u03F5",
    straightphi: "\u03D5",
    strns: "\xaf",
    sub: "\u2282",
    subE: "\u2AC5",
    subdot: "\u2ABD",
    sube: "\u2286",
    subedot: "\u2AC3",
    submult: "\u2AC1",
    subnE: "\u2ACB",
    subne: "\u228A",
    subplus: "\u2ABF",
    subrarr: "\u2979",
    subset: "\u2282",
    subseteq: "\u2286",
    subseteqq: "\u2AC5",
    subsetneq: "\u228A",
    subsetneqq: "\u2ACB",
    subsim: "\u2AC7",
    subsub: "\u2AD5",
    subsup: "\u2AD3",
    succ: "\u227B",
    succapprox: "\u2AB8",
    succcurlyeq: "\u227D",
    succeq: "\u2AB0",
    succnapprox: "\u2ABA",
    succneqq: "\u2AB6",
    succnsim: "\u22E9",
    succsim: "\u227F",
    sum: "\u2211",
    sung: "\u266A",
    sup1: "\xb9",
    sup2: "\xb2",
    sup3: "\xb3",
    sup: "\u2283",
    supE: "\u2AC6",
    supdot: "\u2ABE",
    supdsub: "\u2AD8",
    supe: "\u2287",
    supedot: "\u2AC4",
    suphsol: "\u27C9",
    suphsub: "\u2AD7",
    suplarr: "\u297B",
    supmult: "\u2AC2",
    supnE: "\u2ACC",
    supne: "\u228B",
    supplus: "\u2AC0",
    supset: "\u2283",
    supseteq: "\u2287",
    supseteqq: "\u2AC6",
    supsetneq: "\u228B",
    supsetneqq: "\u2ACC",
    supsim: "\u2AC8",
    supsub: "\u2AD4",
    supsup: "\u2AD6",
    swArr: "\u21D9",
    swarhk: "\u2926",
    swarr: "\u2199",
    swarrow: "\u2199",
    swnwar: "\u292A",
    szlig: "\xdf",
    target: "\u2316",
    tau: "\u03C4",
    tbrk: "\u23B4",
    tcaron: "\u0165",
    tcedil: "\u0163",
    tcy: "\u0442",
    tdot: "\u20DB",
    telrec: "\u2315",
    tfr: "\uD835\uDD31",
    there4: "\u2234",
    therefore: "\u2234",
    theta: "\u03B8",
    thetasym: "\u03D1",
    thetav: "\u03D1",
    thickapprox: "\u2248",
    thicksim: "\u223C",
    thinsp: "\u2009",
    thkap: "\u2248",
    thksim: "\u223C",
    thorn: "\xfe",
    tilde: "\u02DC",
    times: "\xd7",
    timesb: "\u22A0",
    timesbar: "\u2A31",
    timesd: "\u2A30",
    tint: "\u222D",
    toea: "\u2928",
    top: "\u22A4",
    topbot: "\u2336",
    topcir: "\u2AF1",
    topf: "\uD835\uDD65",
    topfork: "\u2ADA",
    tosa: "\u2929",
    tprime: "\u2034",
    trade: "\u2122",
    triangle: "\u25B5",
    triangledown: "\u25BF",
    triangleleft: "\u25C3",
    trianglelefteq: "\u22B4",
    triangleq: "\u225C",
    triangleright: "\u25B9",
    trianglerighteq: "\u22B5",
    tridot: "\u25EC",
    trie: "\u225C",
    triminus: "\u2A3A",
    triplus: "\u2A39",
    trisb: "\u29CD",
    tritime: "\u2A3B",
    trpezium: "\u23E2",
    tscr: "\uD835\uDCC9",
    tscy: "\u0446",
    tshcy: "\u045B",
    tstrok: "\u0167",
    twixt: "\u226C",
    twoheadleftarrow: "\u219E",
    twoheadrightarrow: "\u21A0",
    uArr: "\u21D1",
    uHar: "\u2963",
    uacute: "\xfa",
    uarr: "\u2191",
    ubrcy: "\u045E",
    ubreve: "\u016D",
    ucirc: "\xfb",
    ucy: "\u0443",
    udarr: "\u21C5",
    udblac: "\u0171",
    udhar: "\u296E",
    ufisht: "\u297E",
    ufr: "\uD835\uDD32",
    ugrave: "\xf9",
    uharl: "\u21BF",
    uharr: "\u21BE",
    uhblk: "\u2580",
    ulcorn: "\u231C",
    ulcorner: "\u231C",
    ulcrop: "\u230F",
    ultri: "\u25F8",
    umacr: "\u016B",
    uml: "\xa8",
    uogon: "\u0173",
    uopf: "\uD835\uDD66",
    uparrow: "\u2191",
    updownarrow: "\u2195",
    upharpoonleft: "\u21BF",
    upharpoonright: "\u21BE",
    uplus: "\u228E",
    upsi: "\u03C5",
    upsih: "\u03D2",
    upsilon: "\u03C5",
    upuparrows: "\u21C8",
    urcorn: "\u231D",
    urcorner: "\u231D",
    urcrop: "\u230E",
    uring: "\u016F",
    urtri: "\u25F9",
    uscr: "\uD835\uDCCA",
    utdot: "\u22F0",
    utilde: "\u0169",
    utri: "\u25B5",
    utrif: "\u25B4",
    uuarr: "\u21C8",
    uuml: "\xfc",
    uwangle: "\u29A7",
    vArr: "\u21D5",
    vBar: "\u2AE8",
    vBarv: "\u2AE9",
    vDash: "\u22A8",
    vangrt: "\u299C",
    varepsilon: "\u03F5",
    varkappa: "\u03F0",
    varnothing: "\u2205",
    varphi: "\u03D5",
    varpi: "\u03D6",
    varpropto: "\u221D",
    varr: "\u2195",
    varrho: "\u03F1",
    varsigma: "\u03C2",
    varsubsetneq: "\u228A\uFE00",
    varsubsetneqq: "\u2ACB\uFE00",
    varsupsetneq: "\u228B\uFE00",
    varsupsetneqq: "\u2ACC\uFE00",
    vartheta: "\u03D1",
    vartriangleleft: "\u22B2",
    vartriangleright: "\u22B3",
    vcy: "\u0432",
    vdash: "\u22A2",
    vee: "\u2228",
    veebar: "\u22BB",
    veeeq: "\u225A",
    vellip: "\u22EE",
    verbar: "|",
    vert: "|",
    vfr: "\uD835\uDD33",
    vltri: "\u22B2",
    vnsub: "\u2282\u20D2",
    vnsup: "\u2283\u20D2",
    vopf: "\uD835\uDD67",
    vprop: "\u221D",
    vrtri: "\u22B3",
    vscr: "\uD835\uDCCB",
    vsubnE: "\u2ACB\uFE00",
    vsubne: "\u228A\uFE00",
    vsupnE: "\u2ACC\uFE00",
    vsupne: "\u228B\uFE00",
    vzigzag: "\u299A",
    wcirc: "\u0175",
    wedbar: "\u2A5F",
    wedge: "\u2227",
    wedgeq: "\u2259",
    weierp: "\u2118",
    wfr: "\uD835\uDD34",
    wopf: "\uD835\uDD68",
    wp: "\u2118",
    wr: "\u2240",
    wreath: "\u2240",
    wscr: "\uD835\uDCCC",
    xcap: "\u22C2",
    xcirc: "\u25EF",
    xcup: "\u22C3",
    xdtri: "\u25BD",
    xfr: "\uD835\uDD35",
    xhArr: "\u27FA",
    xharr: "\u27F7",
    xi: "\u03BE",
    xlArr: "\u27F8",
    xlarr: "\u27F5",
    xmap: "\u27FC",
    xnis: "\u22FB",
    xodot: "\u2A00",
    xopf: "\uD835\uDD69",
    xoplus: "\u2A01",
    xotime: "\u2A02",
    xrArr: "\u27F9",
    xrarr: "\u27F6",
    xscr: "\uD835\uDCCD",
    xsqcup: "\u2A06",
    xuplus: "\u2A04",
    xutri: "\u25B3",
    xvee: "\u22C1",
    xwedge: "\u22C0",
    yacute: "\xfd",
    yacy: "\u044F",
    ycirc: "\u0177",
    ycy: "\u044B",
    yen: "\xa5",
    yfr: "\uD835\uDD36",
    yicy: "\u0457",
    yopf: "\uD835\uDD6A",
    yscr: "\uD835\uDCCE",
    yucy: "\u044E",
    yuml: "\xff",
    zacute: "\u017A",
    zcaron: "\u017E",
    zcy: "\u0437",
    zdot: "\u017C",
    zeetrf: "\u2128",
    zeta: "\u03B6",
    zfr: "\uD835\uDD37",
    zhcy: "\u0436",
    zigrarr: "\u21DD",
    zopf: "\uD835\uDD6B",
    zscr: "\uD835\uDCCF",
    zwj: "\u200D",
    zwnj: "\u200C"
};


const $129f834d276cd569$var$own = {}.hasOwnProperty;
function $129f834d276cd569$export$289b6a6320f709b4(value) {
    return $129f834d276cd569$var$own.call((0, $4db4afe2316c32ea$export$ec810d1aafce79a7), value) ? (0, $4db4afe2316c32ea$export$ec810d1aafce79a7)[value] : false;
}


/**
 * Turn the number (in string form as either hexa- or plain decimal) coming from
 * a numeric character reference into a character.
 *
 * Sort of like `String.fromCharCode(Number.parseInt(value, base))`, but makes
 * non-characters and control characters safe.
 *
 * @param {string} value
 *   Value to decode.
 * @param {number} base
 *   Numeric base.
 * @returns {string}
 *   Character.
 */ function $4b172571e380aaa9$export$15a69557afac2c20(value, base) {
    const code = Number.parseInt(value, base);
    if (// C0 except for HT, LF, FF, CR, space.
    code < 9 || code === 11 || code > 13 && code < 32 || // Control character (DEL) of C0, and C1 controls.
    code > 126 && code < 160 || // Lone high surrogates and low surrogates.
    code > 55295 && code < 57344 || // Noncharacters.
    code > 64975 && code < 65008 || (code & 65535) === 65535 || (code & 65535) === 65534 /* eslint-enable no-bitwise */  || // Out of range
    code > 1114111) return "\uFFFD";
    return String.fromCharCode(code);
}


const $569ad8210d6abecb$var$characterEscapeOrReference = /\\([!-/:-@[-`{-~])|&(#(?:\d{1,7}|x[\da-f]{1,6})|[\da-z]{1,31});/gi;
function $569ad8210d6abecb$export$a0fb664af7d0cc44(value) {
    return value.replace($569ad8210d6abecb$var$characterEscapeOrReference, $569ad8210d6abecb$var$decode);
}
/**
 * @param {string} $0
 * @param {string} $1
 * @param {string} $2
 * @returns {string}
 */ function $569ad8210d6abecb$var$decode($0, $1, $2) {
    if ($1) // Escape.
    return $1;
    // Reference.
    const head = $2.charCodeAt(0);
    if (head === 35) {
        const head = $2.charCodeAt(1);
        const hex = head === 120 || head === 88;
        return (0, $4b172571e380aaa9$export$15a69557afac2c20)($2.slice(hex ? 2 : 1), hex ? 16 : 10);
    }
    return (0, $129f834d276cd569$export$289b6a6320f709b4)($2) || $0;
}


function $52316a4c72b2f63e$export$c4ca1a6065421754(node) {
    if (node.label || !node.identifier) return node.label || "";
    return (0, $569ad8210d6abecb$export$a0fb664af7d0cc44)(node.identifier);
}


/**
 * @typedef {import('../types.js').FlowContent} FlowContent
 * @typedef {import('../types.js').Node} Node
 * @typedef {import('../types.js').Parent} Parent
 * @typedef {import('../types.js').State} State
 * @typedef {import('../types.js').TrackFields} TrackFields
 */ /**
 * @param {Parent & {children: Array<FlowContent>}} parent
 *   Parent of flow nodes.
 * @param {State} state
 *   Info passed around about the current state.
 * @param {TrackFields} info
 *   Info on where we are in the document we are generating.
 * @returns {string}
 *   Serialized children, joined by (blank) lines.
 */ function $492b739e3f96c46d$export$134f7fdacfea8b16(parent, state, info) {
    const indexStack = state.indexStack;
    const children = parent.children || [];
    const tracker = state.createTracker(info);
    /** @type {Array<string>} */ const results = [];
    let index = -1;
    indexStack.push(-1);
    while(++index < children.length){
        const child = children[index];
        indexStack[indexStack.length - 1] = index;
        results.push(tracker.move(state.handle(child, parent, state, {
            before: "\n",
            after: "\n",
            ...tracker.current()
        })));
        if (child.type !== "list") state.bulletLastUsed = undefined;
        if (index < children.length - 1) results.push(tracker.move($492b739e3f96c46d$var$between(child, children[index + 1], parent, state)));
    }
    indexStack.pop();
    return results.join("");
}
/**
 * @param {Node} left
 * @param {Node} right
 * @param {Parent} parent
 * @param {State} state
 * @returns {string}
 */ function $492b739e3f96c46d$var$between(left, right, parent, state) {
    let index = state.join.length;
    while(index--){
        const result = state.join[index](left, right, parent, state);
        if (result === true || result === 1) break;
        if (typeof result === "number") return "\n".repeat(1 + result);
        if (result === false) return "\n\n<!---->\n\n";
    }
    return "\n\n";
}


/**
 * @typedef {import('../types.js').IndentLines} IndentLines
 */ const $d31bf43d75fde216$var$eol = /\r?\n|\r/g;
function $d31bf43d75fde216$export$7c3cf23d514b264a(value, map) {
    /** @type {Array<string>} */ const result = [];
    let start = 0;
    let line = 0;
    /** @type {RegExpExecArray | null} */ let match;
    while(match = $d31bf43d75fde216$var$eol.exec(value)){
        one(value.slice(start, match.index));
        result.push(match[0]);
        start = match.index + match[0].length;
        line++;
    }
    one(value.slice(start));
    return result.join("");
    /**
   * @param {string} value
   */ function one(value) {
        result.push(map(value, line, !value));
    }
}


/**
 * @typedef {import('../types.js').State} State
 * @typedef {import('../types.js').SafeConfig} SafeConfig
 */ /**
 * @typedef {import('../types.js').Unsafe} Unsafe
 */ /**
 * @param {Unsafe} pattern
 * @returns {RegExp}
 */ function $98336dc812f1620b$export$7993761911514c15(pattern) {
    if (!pattern._compiled) {
        const before = (pattern.atBreak ? "[\\r\\n][\\t ]*" : "") + (pattern.before ? "(?:" + pattern.before + ")" : "");
        pattern._compiled = new RegExp((before ? "(" + before + ")" : "") + (/[|\\{}()[\]^$+*?.-]/.test(pattern.character) ? "\\" : "") + pattern.character + (pattern.after ? "(?:" + pattern.after + ")" : ""), "g");
    }
    return pattern._compiled;
}


/**
 * @typedef {import('../types.js').Unsafe} Unsafe
 * @typedef {import('../types.js').ConstructName} ConstructName
 */ /**
 * @param {Array<ConstructName>} stack
 * @param {Unsafe} pattern
 * @returns {boolean}
 */ function $712bd8b4d993b137$export$78221a09424368d(stack, pattern) {
    return $712bd8b4d993b137$var$listInScope(stack, pattern.inConstruct, true) && !$712bd8b4d993b137$var$listInScope(stack, pattern.notInConstruct, false);
}
/**
 * @param {Array<ConstructName>} stack
 * @param {Unsafe['inConstruct']} list
 * @param {boolean} none
 * @returns {boolean}
 */ function $712bd8b4d993b137$var$listInScope(stack, list, none) {
    if (typeof list === "string") list = [
        list
    ];
    if (!list || list.length === 0) return none;
    let index = -1;
    while(++index < list.length){
        if (stack.includes(list[index])) return true;
    }
    return false;
}


function $a61a26c7aebae70d$export$170b8c323eee7bec(state, input, config) {
    const value = (config.before || "") + (input || "") + (config.after || "");
    /** @type {Array<number>} */ const positions = [];
    /** @type {Array<string>} */ const result = [];
    /** @type {Record<number, {before: boolean, after: boolean}>} */ const infos = {};
    let index = -1;
    while(++index < state.unsafe.length){
        const pattern = state.unsafe[index];
        if (!(0, $712bd8b4d993b137$export$78221a09424368d)(state.stack, pattern)) continue;
        const expression = (0, $98336dc812f1620b$export$7993761911514c15)(pattern);
        /** @type {RegExpExecArray | null} */ let match;
        while(match = expression.exec(value)){
            const before = "before" in pattern || Boolean(pattern.atBreak);
            const after = "after" in pattern;
            const position = match.index + (before ? match[1].length : 0);
            if (positions.includes(position)) {
                if (infos[position].before && !before) infos[position].before = false;
                if (infos[position].after && !after) infos[position].after = false;
            } else {
                positions.push(position);
                infos[position] = {
                    before: before,
                    after: after
                };
            }
        }
    }
    positions.sort($a61a26c7aebae70d$var$numerical);
    let start = config.before ? config.before.length : 0;
    const end = value.length - (config.after ? config.after.length : 0);
    index = -1;
    while(++index < positions.length){
        const position = positions[index];
        // Character before or after matched:
        if (position < start || position >= end) continue;
        // If this character is supposed to be escaped because it has a condition on
        // the next character, and the next character is definitly being escaped,
        // then skip this escape.
        if (position + 1 < end && positions[index + 1] === position + 1 && infos[position].after && !infos[position + 1].before && !infos[position + 1].after || positions[index - 1] === position - 1 && infos[position].before && !infos[position - 1].before && !infos[position - 1].after) continue;
        if (start !== position) // If we have to use a character reference, an ampersand would be more
        // correct, but as backslashes only care about punctuation, either will
        // do the trick
        result.push($a61a26c7aebae70d$var$escapeBackslashes(value.slice(start, position), "\\"));
        start = position;
        if (/[!-/:-@[-`{-~]/.test(value.charAt(position)) && (!config.encode || !config.encode.includes(value.charAt(position)))) // Character escape.
        result.push("\\");
        else {
            // Character reference.
            result.push("&#x" + value.charCodeAt(position).toString(16).toUpperCase() + ";");
            start++;
        }
    }
    result.push($a61a26c7aebae70d$var$escapeBackslashes(value.slice(start, end), config.after));
    return result.join("");
}
/**
 * @param {number} a
 * @param {number} b
 * @returns {number}
 */ function $a61a26c7aebae70d$var$numerical(a, b) {
    return a - b;
}
/**
 * @param {string} value
 * @param {string} after
 * @returns {string}
 */ function $a61a26c7aebae70d$var$escapeBackslashes(value, after) {
    const expression = /\\(?=[!-/:-@[-`{-~])/g;
    /** @type {Array<number>} */ const positions = [];
    /** @type {Array<string>} */ const results = [];
    const whole = value + after;
    let index = -1;
    let start = 0;
    /** @type {RegExpExecArray | null} */ let match;
    while(match = expression.exec(whole))positions.push(match.index);
    while(++index < positions.length){
        if (start !== positions[index]) results.push(value.slice(start, positions[index]));
        results.push("\\");
        start = positions[index];
    }
    results.push(value.slice(start));
    return results.join("");
}


/**
 * @typedef {import('../types.js').CreateTracker} CreateTracker
 * @typedef {import('../types.js').TrackCurrent} TrackCurrent
 * @typedef {import('../types.js').TrackMove} TrackMove
 * @typedef {import('../types.js').TrackShift} TrackShift
 */ /**
 * Track positional info in the output.
 *
 * @type {CreateTracker}
 */ function $5bebca9ef38cb3ce$export$6b2a7d5132615086(config) {
    // Defaults are used to prevent crashes when older utilities somehow activate
    // this code.
    /* c8 ignore next 5 */ const options = config || {};
    const now = options.now || {};
    let lineShift = options.lineShift || 0;
    let line = now.line || 1;
    let column = now.column || 1;
    return {
        move: move,
        current: current,
        shift: shift
    };
    /**
   * Get the current tracked info.
   *
   * @type {TrackCurrent}
   */ function current() {
        return {
            now: {
                line: line,
                column: column
            },
            lineShift: lineShift
        };
    }
    /**
   * Define an increased line shift (the typical indent for lines).
   *
   * @type {TrackShift}
   */ function shift(value) {
        lineShift += value;
    }
    /**
   * Move past some generated markdown.
   *
   * @type {TrackMove}
   */ function move(input) {
        // eslint-disable-next-line unicorn/prefer-default-parameters
        const value = input || "";
        const chunks = value.split(/\r?\n|\r/g);
        const tail = chunks[chunks.length - 1];
        line += chunks.length - 1;
        column = chunks.length === 1 ? column + tail.length : 1 + tail.length + lineShift;
        return value;
    }
}


$83b2b01bc921025b$var$footnoteReference.peek = $83b2b01bc921025b$var$footnoteReferencePeek;
function $83b2b01bc921025b$export$c9d5ad4bdf6ff801() {
    return {
        enter: {
            gfmFootnoteDefinition: $83b2b01bc921025b$var$enterFootnoteDefinition,
            gfmFootnoteDefinitionLabelString: $83b2b01bc921025b$var$enterFootnoteDefinitionLabelString,
            gfmFootnoteCall: $83b2b01bc921025b$var$enterFootnoteCall,
            gfmFootnoteCallString: $83b2b01bc921025b$var$enterFootnoteCallString
        },
        exit: {
            gfmFootnoteDefinition: $83b2b01bc921025b$var$exitFootnoteDefinition,
            gfmFootnoteDefinitionLabelString: $83b2b01bc921025b$var$exitFootnoteDefinitionLabelString,
            gfmFootnoteCall: $83b2b01bc921025b$var$exitFootnoteCall,
            gfmFootnoteCallString: $83b2b01bc921025b$var$exitFootnoteCallString
        }
    };
}
function $83b2b01bc921025b$export$3727766a73a6c09f() {
    return {
        // This is on by default already.
        unsafe: [
            {
                character: "[",
                inConstruct: [
                    "phrasing",
                    "label",
                    "reference"
                ]
            }
        ],
        handlers: {
            footnoteDefinition: $83b2b01bc921025b$var$footnoteDefinition,
            footnoteReference: $83b2b01bc921025b$var$footnoteReference
        }
    };
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $83b2b01bc921025b$var$enterFootnoteDefinition(token) {
    this.enter({
        type: "footnoteDefinition",
        identifier: "",
        label: "",
        children: []
    }, token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $83b2b01bc921025b$var$enterFootnoteDefinitionLabelString() {
    this.buffer();
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $83b2b01bc921025b$var$exitFootnoteDefinitionLabelString(token) {
    const label = this.resume();
    const node = /** @type {FootnoteDefinition} */ this.stack[this.stack.length - 1];
    node.label = label;
    node.identifier = (0, $17274a453d2d9545$export$806d55e226cfcd08)(this.sliceSerialize(token)).toLowerCase();
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $83b2b01bc921025b$var$exitFootnoteDefinition(token) {
    this.exit(token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $83b2b01bc921025b$var$enterFootnoteCall(token) {
    this.enter({
        type: "footnoteReference",
        identifier: "",
        label: ""
    }, token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $83b2b01bc921025b$var$enterFootnoteCallString() {
    this.buffer();
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $83b2b01bc921025b$var$exitFootnoteCallString(token) {
    const label = this.resume();
    const node = /** @type {FootnoteDefinition} */ this.stack[this.stack.length - 1];
    node.label = label;
    node.identifier = (0, $17274a453d2d9545$export$806d55e226cfcd08)(this.sliceSerialize(token)).toLowerCase();
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $83b2b01bc921025b$var$exitFootnoteCall(token) {
    this.exit(token);
}
/**
 * @type {ToMarkdownHandle}
 * @param {FootnoteReference} node
 */ function $83b2b01bc921025b$var$footnoteReference(node, _, context, safeOptions) {
    const tracker = (0, $5bebca9ef38cb3ce$export$6b2a7d5132615086)(safeOptions);
    let value = tracker.move("[^");
    const exit = context.enter("footnoteReference");
    const subexit = context.enter("reference");
    value += tracker.move((0, $a61a26c7aebae70d$export$170b8c323eee7bec)(context, (0, $52316a4c72b2f63e$export$c4ca1a6065421754)(node), {
        ...tracker.current(),
        before: value,
        after: "]"
    }));
    subexit();
    exit();
    value += tracker.move("]");
    return value;
}
/** @type {ToMarkdownHandle} */ function $83b2b01bc921025b$var$footnoteReferencePeek() {
    return "[";
}
/**
 * @type {ToMarkdownHandle}
 * @param {FootnoteDefinition} node
 */ function $83b2b01bc921025b$var$footnoteDefinition(node, _, context, safeOptions) {
    const tracker = (0, $5bebca9ef38cb3ce$export$6b2a7d5132615086)(safeOptions);
    let value = tracker.move("[^");
    const exit = context.enter("footnoteDefinition");
    const subexit = context.enter("label");
    value += tracker.move((0, $a61a26c7aebae70d$export$170b8c323eee7bec)(context, (0, $52316a4c72b2f63e$export$c4ca1a6065421754)(node), {
        ...tracker.current(),
        before: value,
        after: "]"
    }));
    subexit();
    value += tracker.move("]:" + (node.children && node.children.length > 0 ? " " : ""));
    tracker.shift(4);
    value += tracker.move((0, $d31bf43d75fde216$export$7c3cf23d514b264a)((0, $492b739e3f96c46d$export$134f7fdacfea8b16)(node, context, tracker.current()), $83b2b01bc921025b$var$map));
    exit();
    return value;
}
/** @type {Map} */ function $83b2b01bc921025b$var$map(line, index, blank) {
    if (index === 0) return line;
    return (blank ? "" : "    ") + line;
}


/**
 * @typedef {import('mdast').Delete} Delete
 *
 * @typedef {import('mdast-util-from-markdown').CompileContext} CompileContext
 * @typedef {import('mdast-util-from-markdown').Extension} FromMarkdownExtension
 * @typedef {import('mdast-util-from-markdown').Handle} FromMarkdownHandle
 *
 * @typedef {import('mdast-util-to-markdown').ConstructName} ConstructName
 * @typedef {import('mdast-util-to-markdown').Options} ToMarkdownExtension
 * @typedef {import('mdast-util-to-markdown').Handle} ToMarkdownHandle
 */ /**
 * @typedef {import('../types.js').Handle} Handle
 * @typedef {import('../types.js').Info} Info
 * @typedef {import('../types.js').Parent} Parent
 * @typedef {import('../types.js').PhrasingContent} PhrasingContent
 * @typedef {import('../types.js').State} State
 */ /**
 * Serialize the children of a parent that contains phrasing children.
 *
 * These children will be joined flush together.
 *
 * @param {Parent & {children: Array<PhrasingContent>}} parent
 *   Parent of flow nodes.
 * @param {State} state
 *   Info passed around about the current state.
 * @param {Info} info
 *   Info on where we are in the document we are generating.
 * @returns {string}
 *   Serialized children, joined together.
 */ function $e2a6bca7d0970543$export$f4090a9439f37631(parent, state, info) {
    const indexStack = state.indexStack;
    const children = parent.children || [];
    /** @type {Array<string>} */ const results = [];
    let index = -1;
    let before = info.before;
    indexStack.push(-1);
    let tracker = state.createTracker(info);
    while(++index < children.length){
        const child = children[index];
        /** @type {string} */ let after;
        indexStack[indexStack.length - 1] = index;
        if (index + 1 < children.length) {
            /** @type {Handle} */ // @ts-expect-error: hush, it’s actually a `zwitch`.
            let handle = state.handle.handlers[children[index + 1].type];
            /** @type {Handle} */ // @ts-expect-error: hush, it’s actually a `zwitch`.
            if (handle && handle.peek) handle = handle.peek;
            after = handle ? handle(children[index + 1], parent, state, {
                before: "",
                after: "",
                ...tracker.current()
            }).charAt(0) : "";
        } else after = info.after;
        // In some cases, html (text) can be found in phrasing right after an eol.
        // When we’d serialize that, in most cases that would be seen as html
        // (flow).
        // As we can’t escape or so to prevent it from happening, we take a somewhat
        // reasonable approach: replace that eol with a space.
        // See: <https://github.com/syntax-tree/mdast-util-to-markdown/issues/15>
        if (results.length > 0 && (before === "\r" || before === "\n") && child.type === "html") {
            results[results.length - 1] = results[results.length - 1].replace(/(\r?\n|\r)$/, " ");
            before = " ";
            // To do: does this work to reset tracker?
            tracker = state.createTracker(info);
            tracker.move(results.join(""));
        }
        results.push(tracker.move(state.handle(child, parent, state, {
            ...tracker.current(),
            before: before,
            after: after
        })));
        before = results[results.length - 1].slice(-1);
    }
    indexStack.pop();
    return results.join("");
}



// To do: next major: expose functions.
// To do: next major: use `state`, state utilities.
/**
 * List of constructs that occur in phrasing (paragraphs, headings), but cannot
 * contain strikethrough.
 * So they sort of cancel each other out.
 * Note: could use a better name.
 *
 * Note: keep in sync with: <https://github.com/syntax-tree/mdast-util-to-markdown/blob/8ce8dbf/lib/unsafe.js#L14>
 *
 * @type {Array<ConstructName>}
 */ const $860747f28994177b$var$constructsWithoutStrikethrough = [
    "autolink",
    "destinationLiteral",
    "destinationRaw",
    "reference",
    "titleQuote",
    "titleApostrophe"
];
$860747f28994177b$var$handleDelete.peek = $860747f28994177b$var$peekDelete;
const $860747f28994177b$export$34d64e709dd0b9bb = {
    canContainEols: [
        "delete"
    ],
    enter: {
        strikethrough: $860747f28994177b$var$enterStrikethrough
    },
    exit: {
        strikethrough: $860747f28994177b$var$exitStrikethrough
    }
};
const $860747f28994177b$export$1632835bd2c84956 = {
    unsafe: [
        {
            character: "~",
            inConstruct: "phrasing",
            notInConstruct: $860747f28994177b$var$constructsWithoutStrikethrough
        }
    ],
    handlers: {
        delete: $860747f28994177b$var$handleDelete
    }
};
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $860747f28994177b$var$enterStrikethrough(token) {
    this.enter({
        type: "delete",
        children: []
    }, token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $860747f28994177b$var$exitStrikethrough(token) {
    this.exit(token);
}
/**
 * @type {ToMarkdownHandle}
 * @param {Delete} node
 */ function $860747f28994177b$var$handleDelete(node, _, context, safeOptions) {
    const tracker = (0, $5bebca9ef38cb3ce$export$6b2a7d5132615086)(safeOptions);
    const exit = context.enter("strikethrough");
    let value = tracker.move("~~");
    value += (0, $e2a6bca7d0970543$export$f4090a9439f37631)(node, context, {
        ...tracker.current(),
        before: value,
        after: "~"
    });
    value += tracker.move("~~");
    exit();
    return value;
}
/** @type {ToMarkdownHandle} */ function $860747f28994177b$var$peekDelete() {
    return "~";
}


/**
 * @typedef {import('mdast').Table} Table
 * @typedef {import('mdast').TableRow} TableRow
 * @typedef {import('mdast').TableCell} TableCell
 * @typedef {import('mdast').InlineCode} InlineCode
 *
 * @typedef {import('markdown-table').MarkdownTableOptions} MarkdownTableOptions
 *
 * @typedef {import('mdast-util-from-markdown').CompileContext} CompileContext
 * @typedef {import('mdast-util-from-markdown').Extension} FromMarkdownExtension
 * @typedef {import('mdast-util-from-markdown').Handle} FromMarkdownHandle
 *
 * @typedef {import('mdast-util-to-markdown').Options} ToMarkdownExtension
 * @typedef {import('mdast-util-to-markdown').Handle} ToMarkdownHandle
 * @typedef {import('mdast-util-to-markdown').Context} ToMarkdownContext
 * @typedef {import('mdast-util-to-markdown').SafeOptions} SafeOptions
 */ /**
 * @typedef Options
 *   Configuration.
 * @property {boolean | null | undefined} [tableCellPadding=true]
 *   Whether to add a space of padding between delimiters and cells.
 * @property {boolean | null | undefined} [tablePipeAlign=true]
 *   Whether to align the delimiters.
 * @property {MarkdownTableOptions['stringLength'] | null | undefined} [stringLength]
 *   Function to detect the length of table cell content, used when aligning
 *   the delimiters between cells
 */ 
/**
 * @typedef {import('mdast').InlineCode} InlineCode
 * @typedef {import('../types.js').Parent} Parent
 * @typedef {import('../types.js').State} State
 */ 
$b1a4901d8e8fcdd9$export$91b9bee19a0d8569.peek = $b1a4901d8e8fcdd9$var$inlineCodePeek;
function $b1a4901d8e8fcdd9$export$91b9bee19a0d8569(node, _, state) {
    let value = node.value || "";
    let sequence = "`";
    let index = -1;
    // If there is a single grave accent on its own in the code, use a fence of
    // two.
    // If there are two in a row, use one.
    while(new RegExp("(^|[^`])" + sequence + "([^`]|$)").test(value))sequence += "`";
    // If this is not just spaces or eols (tabs don’t count), and either the
    // first or last character are a space, eol, or tick, then pad with spaces.
    if (/[^ \r\n]/.test(value) && (/^[ \r\n]/.test(value) && /[ \r\n]$/.test(value) || /^`|`$/.test(value))) value = " " + value + " ";
    // We have a potential problem: certain characters after eols could result in
    // blocks being seen.
    // For example, if someone injected the string `'\n# b'`, then that would
    // result in an ATX heading.
    // We can’t escape characters in `inlineCode`, but because eols are
    // transformed to spaces when going from markdown to HTML anyway, we can swap
    // them out.
    while(++index < state.unsafe.length){
        const pattern = state.unsafe[index];
        const expression = (0, $98336dc812f1620b$export$7993761911514c15)(pattern);
        /** @type {RegExpExecArray | null} */ let match;
        // Only look for `atBreak`s.
        // Btw: note that `atBreak` patterns will always start the regex at LF or
        // CR.
        if (!pattern.atBreak) continue;
        while(match = expression.exec(value)){
            let position = match.index;
            // Support CRLF (patterns only look for one of the characters).
            if (value.charCodeAt(position) === 10 /* `\n` */  && value.charCodeAt(position - 1) === 13 /* `\r` */ ) position--;
            value = value.slice(0, position) + " " + value.slice(match.index + 1);
        }
    }
    return sequence + value + sequence;
}
/**
 * @returns {string}
 */ function $b1a4901d8e8fcdd9$var$inlineCodePeek() {
    return "`";
}


/**
 * @typedef Options
 *   Configuration (optional).
 * @property {string|null|ReadonlyArray<string|null|undefined>} [align]
 *   One style for all columns, or styles for their respective columns.
 *   Each style is either `'l'` (left), `'r'` (right), or `'c'` (center).
 *   Other values are treated as `''`, which doesn’t place the colon in the
 *   alignment row but does align left.
 *   *Only the lowercased first character is used, so `Right` is fine.*
 * @property {boolean} [padding=true]
 *   Whether to add a space of padding between delimiters and cells.
 *
 *   When `true`, there is padding:
 *
 *   ```markdown
 *   | Alpha | B     |
 *   | ----- | ----- |
 *   | C     | Delta |
 *   ```
 *
 *   When `false`, there is no padding:
 *
 *   ```markdown
 *   |Alpha|B    |
 *   |-----|-----|
 *   |C    |Delta|
 *   ```
 * @property {boolean} [delimiterStart=true]
 *   Whether to begin each row with the delimiter.
 *
 *   > 👉 **Note**: please don’t use this: it could create fragile structures
 *   > that aren’t understandable to some markdown parsers.
 *
 *   When `true`, there are starting delimiters:
 *
 *   ```markdown
 *   | Alpha | B     |
 *   | ----- | ----- |
 *   | C     | Delta |
 *   ```
 *
 *   When `false`, there are no starting delimiters:
 *
 *   ```markdown
 *   Alpha | B     |
 *   ----- | ----- |
 *   C     | Delta |
 *   ```
 * @property {boolean} [delimiterEnd=true]
 *   Whether to end each row with the delimiter.
 *
 *   > 👉 **Note**: please don’t use this: it could create fragile structures
 *   > that aren’t understandable to some markdown parsers.
 *
 *   When `true`, there are ending delimiters:
 *
 *   ```markdown
 *   | Alpha | B     |
 *   | ----- | ----- |
 *   | C     | Delta |
 *   ```
 *
 *   When `false`, there are no ending delimiters:
 *
 *   ```markdown
 *   | Alpha | B
 *   | ----- | -----
 *   | C     | Delta
 *   ```
 * @property {boolean} [alignDelimiters=true]
 *   Whether to align the delimiters.
 *   By default, they are aligned:
 *
 *   ```markdown
 *   | Alpha | B     |
 *   | ----- | ----- |
 *   | C     | Delta |
 *   ```
 *
 *   Pass `false` to make them staggered:
 *
 *   ```markdown
 *   | Alpha | B |
 *   | - | - |
 *   | C | Delta |
 *   ```
 * @property {(value: string) => number} [stringLength]
 *   Function to detect the length of table cell content.
 *   This is used when aligning the delimiters (`|`) between table cells.
 *   Full-width characters and emoji mess up delimiter alignment when viewing
 *   the markdown source.
 *   To fix this, you can pass this function, which receives the cell content
 *   and returns its “visible” size.
 *   Note that what is and isn’t visible depends on where the text is displayed.
 *
 *   Without such a function, the following:
 *
 *   ```js
 *   markdownTable([
 *     ['Alpha', 'Bravo'],
 *     ['中文', 'Charlie'],
 *     ['👩‍❤️‍👩', 'Delta']
 *   ])
 *   ```
 *
 *   Yields:
 *
 *   ```markdown
 *   | Alpha | Bravo |
 *   | - | - |
 *   | 中文 | Charlie |
 *   | 👩‍❤️‍👩 | Delta |
 *   ```
 *
 *   With [`string-width`](https://github.com/sindresorhus/string-width):
 *
 *   ```js
 *   import stringWidth from 'string-width'
 *
 *   markdownTable(
 *     [
 *       ['Alpha', 'Bravo'],
 *       ['中文', 'Charlie'],
 *       ['👩‍❤️‍👩', 'Delta']
 *     ],
 *     {stringLength: stringWidth}
 *   )
 *   ```
 *
 *   Yields:
 *
 *   ```markdown
 *   | Alpha | Bravo   |
 *   | ----- | ------- |
 *   | 中文  | Charlie |
 *   | 👩‍❤️‍👩    | Delta   |
 *   ```
 */ /**
 * @typedef {Options} MarkdownTableOptions
 * @todo
 *   Remove next major.
 */ /**
 * Generate a markdown ([GFM](https://docs.github.com/en/github/writing-on-github/working-with-advanced-formatting/organizing-information-with-tables)) table..
 *
 * @param {ReadonlyArray<ReadonlyArray<string|null|undefined>>} table
 *   Table data (matrix of strings).
 * @param {Options} [options]
 *   Configuration (optional).
 * @returns {string}
 */ function $4e44d0885684464b$export$cdb7288612c4f3d6(table, options = {}) {
    const align = (options.align || []).concat();
    const stringLength = options.stringLength || $4e44d0885684464b$var$defaultStringLength;
    /** @type {Array<number>} Character codes as symbols for alignment per column. */ const alignments = [];
    /** @type {Array<Array<string>>} Cells per row. */ const cellMatrix = [];
    /** @type {Array<Array<number>>} Sizes of each cell per row. */ const sizeMatrix = [];
    /** @type {Array<number>} */ const longestCellByColumn = [];
    let mostCellsPerRow = 0;
    let rowIndex = -1;
    // This is a superfluous loop if we don’t align delimiters, but otherwise we’d
    // do superfluous work when aligning, so optimize for aligning.
    while(++rowIndex < table.length){
        /** @type {Array<string>} */ const row = [];
        /** @type {Array<number>} */ const sizes = [];
        let columnIndex = -1;
        if (table[rowIndex].length > mostCellsPerRow) mostCellsPerRow = table[rowIndex].length;
        while(++columnIndex < table[rowIndex].length){
            const cell = $4e44d0885684464b$var$serialize(table[rowIndex][columnIndex]);
            if (options.alignDelimiters !== false) {
                const size = stringLength(cell);
                sizes[columnIndex] = size;
                if (longestCellByColumn[columnIndex] === undefined || size > longestCellByColumn[columnIndex]) longestCellByColumn[columnIndex] = size;
            }
            row.push(cell);
        }
        cellMatrix[rowIndex] = row;
        sizeMatrix[rowIndex] = sizes;
    }
    // Figure out which alignments to use.
    let columnIndex = -1;
    if (typeof align === "object" && "length" in align) while(++columnIndex < mostCellsPerRow)alignments[columnIndex] = $4e44d0885684464b$var$toAlignment(align[columnIndex]);
    else {
        const code = $4e44d0885684464b$var$toAlignment(align);
        while(++columnIndex < mostCellsPerRow)alignments[columnIndex] = code;
    }
    // Inject the alignment row.
    columnIndex = -1;
    /** @type {Array<string>} */ const row = [];
    /** @type {Array<number>} */ const sizes = [];
    while(++columnIndex < mostCellsPerRow){
        const code = alignments[columnIndex];
        let before = "";
        let after = "";
        if (code === 99 /* `c` */ ) {
            before = ":";
            after = ":";
        } else if (code === 108 /* `l` */ ) before = ":";
        else if (code === 114 /* `r` */ ) after = ":";
        // There *must* be at least one hyphen-minus in each alignment cell.
        let size = options.alignDelimiters === false ? 1 : Math.max(1, longestCellByColumn[columnIndex] - before.length - after.length);
        const cell = before + "-".repeat(size) + after;
        if (options.alignDelimiters !== false) {
            size = before.length + size + after.length;
            if (size > longestCellByColumn[columnIndex]) longestCellByColumn[columnIndex] = size;
            sizes[columnIndex] = size;
        }
        row[columnIndex] = cell;
    }
    // Inject the alignment row.
    cellMatrix.splice(1, 0, row);
    sizeMatrix.splice(1, 0, sizes);
    rowIndex = -1;
    /** @type {Array<string>} */ const lines = [];
    while(++rowIndex < cellMatrix.length){
        const row = cellMatrix[rowIndex];
        const sizes = sizeMatrix[rowIndex];
        columnIndex = -1;
        /** @type {Array<string>} */ const line = [];
        while(++columnIndex < mostCellsPerRow){
            const cell = row[columnIndex] || "";
            let before = "";
            let after = "";
            if (options.alignDelimiters !== false) {
                const size = longestCellByColumn[columnIndex] - (sizes[columnIndex] || 0);
                const code = alignments[columnIndex];
                if (code === 114 /* `r` */ ) before = " ".repeat(size);
                else if (code === 99 /* `c` */ ) {
                    if (size % 2) {
                        before = " ".repeat(size / 2 + 0.5);
                        after = " ".repeat(size / 2 - 0.5);
                    } else {
                        before = " ".repeat(size / 2);
                        after = before;
                    }
                } else after = " ".repeat(size);
            }
            if (options.delimiterStart !== false && !columnIndex) line.push("|");
            if (options.padding !== false && // Don’t add the opening space if we’re not aligning and the cell is
            // empty: there will be a closing space.
            !(options.alignDelimiters === false && cell === "") && (options.delimiterStart !== false || columnIndex)) line.push(" ");
            if (options.alignDelimiters !== false) line.push(before);
            line.push(cell);
            if (options.alignDelimiters !== false) line.push(after);
            if (options.padding !== false) line.push(" ");
            if (options.delimiterEnd !== false || columnIndex !== mostCellsPerRow - 1) line.push("|");
        }
        lines.push(options.delimiterEnd === false ? line.join("").replace(/ +$/, "") : line.join(""));
    }
    return lines.join("\n");
}
/**
 * @param {string|null|undefined} [value]
 * @returns {string}
 */ function $4e44d0885684464b$var$serialize(value) {
    return value === null || value === undefined ? "" : String(value);
}
/**
 * @param {string} value
 * @returns {number}
 */ function $4e44d0885684464b$var$defaultStringLength(value) {
    return value.length;
}
/**
 * @param {string|null|undefined} value
 * @returns {number}
 */ function $4e44d0885684464b$var$toAlignment(value) {
    const code = typeof value === "string" ? value.codePointAt(0) : 0;
    return code === 67 /* `C` */  || code === 99 /* `c` */  ? 99 /* `c` */  : code === 76 /* `L` */  || code === 108 /* `l` */  ? 108 /* `l` */  : code === 82 /* `R` */  || code === 114 /* `r` */  ? 114 /* `r` */  : 0;
}


const $3e1410f020a601c0$export$8bd0ec8ecf6adb7d = {
    enter: {
        table: $3e1410f020a601c0$var$enterTable,
        tableData: $3e1410f020a601c0$var$enterCell,
        tableHeader: $3e1410f020a601c0$var$enterCell,
        tableRow: $3e1410f020a601c0$var$enterRow
    },
    exit: {
        codeText: $3e1410f020a601c0$var$exitCodeText,
        table: $3e1410f020a601c0$var$exitTable,
        tableData: $3e1410f020a601c0$var$exit,
        tableHeader: $3e1410f020a601c0$var$exit,
        tableRow: $3e1410f020a601c0$var$exit
    }
};
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $3e1410f020a601c0$var$enterTable(token) {
    /** @type {Array<'left' | 'right' | 'center' | 'none'>} */ // @ts-expect-error: `align` is custom.
    const align = token._align;
    this.enter({
        type: "table",
        align: align.map((d)=>d === "none" ? null : d),
        children: []
    }, token);
    this.setData("inTable", true);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $3e1410f020a601c0$var$exitTable(token) {
    this.exit(token);
    this.setData("inTable");
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $3e1410f020a601c0$var$enterRow(token) {
    this.enter({
        type: "tableRow",
        children: []
    }, token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $3e1410f020a601c0$var$exit(token) {
    this.exit(token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $3e1410f020a601c0$var$enterCell(token) {
    this.enter({
        type: "tableCell",
        children: []
    }, token);
}
// Overwrite the default code text data handler to unescape escaped pipes when
// they are in tables.
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $3e1410f020a601c0$var$exitCodeText(token) {
    let value = this.resume();
    if (this.getData("inTable")) value = value.replace(/\\([\\|])/g, $3e1410f020a601c0$var$replace);
    const node = /** @type {InlineCode} */ this.stack[this.stack.length - 1];
    node.value = value;
    this.exit(token);
}
/**
 * @param {string} $0
 * @param {string} $1
 * @returns {string}
 */ function $3e1410f020a601c0$var$replace($0, $1) {
    // Pipes work, backslashes don’t (but can’t escape pipes).
    return $1 === "|" ? $1 : $0;
}
function $3e1410f020a601c0$export$dafcad76ea6e0045(options) {
    const settings = options || {};
    const padding = settings.tableCellPadding;
    const alignDelimiters = settings.tablePipeAlign;
    const stringLength = settings.stringLength;
    const around = padding ? " " : "|";
    return {
        unsafe: [
            {
                character: "\r",
                inConstruct: "tableCell"
            },
            {
                character: "\n",
                inConstruct: "tableCell"
            },
            // A pipe, when followed by a tab or space (padding), or a dash or colon
            // (unpadded delimiter row), could result in a table.
            {
                atBreak: true,
                character: "|",
                after: "[	 :-]"
            },
            // A pipe in a cell must be encoded.
            {
                character: "|",
                inConstruct: "tableCell"
            },
            // A colon must be followed by a dash, in which case it could start a
            // delimiter row.
            {
                atBreak: true,
                character: ":",
                after: "-"
            },
            // A delimiter row can also start with a dash, when followed by more
            // dashes, a colon, or a pipe.
            // This is a stricter version than the built in check for lists, thematic
            // breaks, and setex heading underlines though:
            // <https://github.com/syntax-tree/mdast-util-to-markdown/blob/51a2038/lib/unsafe.js#L57>
            {
                atBreak: true,
                character: "-",
                after: "[:|-]"
            }
        ],
        handlers: {
            table: handleTable,
            tableRow: handleTableRow,
            tableCell: handleTableCell,
            inlineCode: inlineCodeWithTable
        }
    };
    /**
   * @type {ToMarkdownHandle}
   * @param {Table} node
   */ function handleTable(node, _, context, safeOptions) {
        return serializeData(handleTableAsData(node, context, safeOptions), node.align);
    }
    /**
   * This function isn’t really used normally, because we handle rows at the
   * table level.
   * But, if someone passes in a table row, this ensures we make somewhat sense.
   *
   * @type {ToMarkdownHandle}
   * @param {TableRow} node
   */ function handleTableRow(node, _, context, safeOptions) {
        const row = handleTableRowAsData(node, context, safeOptions);
        const value = serializeData([
            row
        ]);
        // `markdown-table` will always add an align row
        return value.slice(0, value.indexOf("\n"));
    }
    /**
   * @type {ToMarkdownHandle}
   * @param {TableCell} node
   */ function handleTableCell(node, _, context, safeOptions) {
        const exit = context.enter("tableCell");
        const subexit = context.enter("phrasing");
        const value = (0, $e2a6bca7d0970543$export$f4090a9439f37631)(node, context, {
            ...safeOptions,
            before: around,
            after: around
        });
        subexit();
        exit();
        return value;
    }
    /**
   * @param {Array<Array<string>>} matrix
   * @param {Array<string | null | undefined> | null | undefined} [align]
   */ function serializeData(matrix, align) {
        return (0, $4e44d0885684464b$export$cdb7288612c4f3d6)(matrix, {
            align: align,
            alignDelimiters: // @ts-expect-error: `markdown-table` types should support `null`.
            alignDelimiters,
            padding: // @ts-expect-error: `markdown-table` types should support `null`.
            padding,
            stringLength: // @ts-expect-error: `markdown-table` types should support `null`.
            stringLength
        });
    }
    /**
   * @param {Table} node
   * @param {ToMarkdownContext} context
   * @param {SafeOptions} safeOptions
   */ function handleTableAsData(node, context, safeOptions) {
        const children = node.children;
        let index = -1;
        /** @type {Array<Array<string>>} */ const result = [];
        const subexit = context.enter("table");
        while(++index < children.length)result[index] = handleTableRowAsData(children[index], context, safeOptions);
        subexit();
        return result;
    }
    /**
   * @param {TableRow} node
   * @param {ToMarkdownContext} context
   * @param {SafeOptions} safeOptions
   */ function handleTableRowAsData(node, context, safeOptions) {
        const children = node.children;
        let index = -1;
        /** @type {Array<string>} */ const result = [];
        const subexit = context.enter("tableRow");
        while(++index < children.length)// Note: the positional info as used here is incorrect.
        // Making it correct would be impossible due to aligning cells?
        // And it would need copy/pasting `markdown-table` into this project.
        result[index] = handleTableCell(children[index], node, context, safeOptions);
        subexit();
        return result;
    }
    /**
   * @type {ToMarkdownHandle}
   * @param {InlineCode} node
   */ function inlineCodeWithTable(node, parent, context) {
        let value = (0, $b1a4901d8e8fcdd9$export$91b9bee19a0d8569)(node, parent, context);
        if (context.stack.includes("tableCell")) value = value.replace(/\|/g, "\\$&");
        return value;
    }
}


/**
 * @typedef {import('mdast').Content} Content
 * @typedef {import('mdast').ListItem} ListItem
 * @typedef {import('mdast').Paragraph} Paragraph
 * @typedef {import('mdast').Parent} Parent
 * @typedef {import('mdast').Root} Root
 * @typedef {import('mdast-util-from-markdown').CompileContext} CompileContext
 * @typedef {import('mdast-util-from-markdown').Extension} FromMarkdownExtension
 * @typedef {import('mdast-util-from-markdown').Handle} FromMarkdownHandle
 * @typedef {import('mdast-util-to-markdown').Options} ToMarkdownExtension
 * @typedef {import('mdast-util-to-markdown').Handle} ToMarkdownHandle
 */ /**
 * @typedef {Extract<Root | Content, Parent>} Parents
 */ /**
 * @typedef {import('mdast').ListItem} ListItem
 * @typedef {import('../types.js').Map} Map
 * @typedef {import('../types.js').Parent} Parent
 * @typedef {import('../types.js').State} State
 * @typedef {import('../types.js').Info} Info
 */ /**
 * @typedef {import('../types.js').State} State
 * @typedef {import('../types.js').Options} Options
 */ /**
 * @param {State} state
 * @returns {Exclude<Options['bullet'], null | undefined>}
 */ function $94f517c88cd8121d$export$7425517207a4d0ae(state) {
    const marker = state.options.bullet || "*";
    if (marker !== "*" && marker !== "+" && marker !== "-") throw new Error("Cannot serialize items with `" + marker + "` for `options.bullet`, expected `*`, `+`, or `-`");
    return marker;
}


/**
 * @typedef {import('../types.js').State} State
 * @typedef {import('../types.js').Options} Options
 */ /**
 * @param {State} state
 * @returns {Exclude<Options['listItemIndent'], null | undefined>}
 */ function $12fb9118930d5bc5$export$2d5358b63da92261(state) {
    const style = state.options.listItemIndent || "tab";
    // To do: remove in a major.
    // @ts-expect-error: deprecated.
    if (style === 1 || style === "1") return "one";
    if (style !== "tab" && style !== "one" && style !== "mixed") throw new Error("Cannot serialize items with `" + style + "` for `options.listItemIndent`, expected `tab`, `one`, or `mixed`");
    return style;
}


function $a3e8d348cf9e47b9$export$76c7e83ecc9cdf05(node, parent, state, info) {
    const listItemIndent = (0, $12fb9118930d5bc5$export$2d5358b63da92261)(state);
    let bullet = state.bulletCurrent || (0, $94f517c88cd8121d$export$7425517207a4d0ae)(state);
    // Add the marker value for ordered lists.
    if (parent && parent.type === "list" && parent.ordered) bullet = (typeof parent.start === "number" && parent.start > -1 ? parent.start : 1) + (state.options.incrementListMarker === false ? 0 : parent.children.indexOf(node)) + bullet;
    let size = bullet.length + 1;
    if (listItemIndent === "tab" || listItemIndent === "mixed" && (parent && parent.type === "list" && parent.spread || node.spread)) size = Math.ceil(size / 4) * 4;
    const tracker = state.createTracker(info);
    tracker.move(bullet + " ".repeat(size - bullet.length));
    tracker.shift(size);
    const exit = state.enter("listItem");
    const value = state.indentLines(state.containerFlow(node, tracker.current()), map);
    exit();
    return value;
    /** @type {Map} */ function map(line, index, blank) {
        if (index) return (blank ? "" : " ".repeat(size)) + line;
        return (blank ? bullet : bullet + " ".repeat(size - bullet.length)) + line;
    }
}



const $d7fcd31c712ce032$export$a427a608608b215f = {
    exit: {
        taskListCheckValueChecked: $d7fcd31c712ce032$var$exitCheck,
        taskListCheckValueUnchecked: $d7fcd31c712ce032$var$exitCheck,
        paragraph: $d7fcd31c712ce032$var$exitParagraphWithTaskListItem
    }
};
const $d7fcd31c712ce032$export$9975722e7e834b78 = {
    unsafe: [
        {
            atBreak: true,
            character: "-",
            after: "[:|-]"
        }
    ],
    handlers: {
        listItem: $d7fcd31c712ce032$var$listItemWithTaskListItem
    }
};
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $d7fcd31c712ce032$var$exitCheck(token) {
    const node = /** @type {ListItem} */ this.stack[this.stack.length - 2];
    // We’re always in a paragraph, in a list item.
    node.checked = token.type === "taskListCheckValueChecked";
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $d7fcd31c712ce032$var$exitParagraphWithTaskListItem(token) {
    const parent = /** @type {Parents} */ this.stack[this.stack.length - 2];
    if (parent && parent.type === "listItem" && typeof parent.checked === "boolean") {
        const node = /** @type {Paragraph} */ this.stack[this.stack.length - 1];
        const head = node.children[0];
        if (head && head.type === "text") {
            const siblings = parent.children;
            let index = -1;
            /** @type {Paragraph | undefined} */ let firstParaghraph;
            while(++index < siblings.length){
                const sibling = siblings[index];
                if (sibling.type === "paragraph") {
                    firstParaghraph = sibling;
                    break;
                }
            }
            if (firstParaghraph === node) {
                // Must start with a space or a tab.
                head.value = head.value.slice(1);
                if (head.value.length === 0) node.children.shift();
                else if (node.position && head.position && typeof head.position.start.offset === "number") {
                    head.position.start.column++;
                    head.position.start.offset++;
                    node.position.start = Object.assign({}, head.position.start);
                }
            }
        }
    }
    this.exit(token);
}
/**
 * @type {ToMarkdownHandle}
 * @param {ListItem} node
 */ function $d7fcd31c712ce032$var$listItemWithTaskListItem(node, parent, context, safeOptions) {
    const head = node.children[0];
    const checkable = typeof node.checked === "boolean" && head && head.type === "paragraph";
    const checkbox = "[" + (node.checked ? "x" : " ") + "] ";
    const tracker = (0, $5bebca9ef38cb3ce$export$6b2a7d5132615086)(safeOptions);
    if (checkable) tracker.move(checkbox);
    let value = (0, $a3e8d348cf9e47b9$export$76c7e83ecc9cdf05)(node, parent, context, {
        ...safeOptions,
        ...tracker.current()
    });
    if (checkable) value = value.replace(/^(?:[*+-]|\d+\.)([\r\n]| {1,3})/, check);
    return value;
    /**
   * @param {string} $0
   * @returns {string}
   */ function check($0) {
        return $0 + checkbox;
    }
}


function $0afbfe2eb1b0bbce$export$95adae814eb7433e() {
    return [
        (0, $a08f89846789bc37$export$b6afdfff2163546f),
        (0, $83b2b01bc921025b$export$c9d5ad4bdf6ff801)(),
        (0, $860747f28994177b$export$34d64e709dd0b9bb),
        (0, $3e1410f020a601c0$export$8bd0ec8ecf6adb7d),
        (0, $d7fcd31c712ce032$export$a427a608608b215f)
    ];
}
function $0afbfe2eb1b0bbce$export$ea77de6901e7c72b(options) {
    return {
        extensions: [
            (0, $a08f89846789bc37$export$d3ace9096b01c39d),
            (0, $83b2b01bc921025b$export$3727766a73a6c09f)(),
            (0, $860747f28994177b$export$1632835bd2c84956),
            (0, $3e1410f020a601c0$export$dafcad76ea6e0045)(options),
            (0, $d7fcd31c712ce032$export$9975722e7e834b78)
        ]
    };
}


function $1185306d23556d57$export$2e2bcd8739ae039(options = {}) {
    const data = this.data();
    add("micromarkExtensions", (0, $bf0bdde66bbeb6d8$export$59ffe8c4d7a4aab2)(options));
    add("fromMarkdownExtensions", (0, $0afbfe2eb1b0bbce$export$95adae814eb7433e)());
    add("toMarkdownExtensions", (0, $0afbfe2eb1b0bbce$export$ea77de6901e7c72b)(options));
    /**
   * @param {string} field
   * @param {unknown} value
   */ function add(field, value) {
        const list = /** @type {unknown[]} */ // Other extensions
        /* c8 ignore next 2 */ data[field] ? data[field] : data[field] = [];
        list.push(value);
    }
}


/**
 * @typedef {import('react').ReactNode} ReactNode
 * @typedef {import('react').ReactElement<{}>} ReactElement
 * @typedef {import('unified').PluggableList} PluggableList
 * @typedef {import('hast').Root} Root
 * @typedef {import('./rehype-filter.js').Options} FilterOptions
 * @typedef {import('./ast-to-react.js').Options} TransformOptions
 *
 * @typedef CoreOptions
 * @property {string} children
 *
 * @typedef PluginOptions
 * @property {PluggableList} [remarkPlugins=[]]
 * @property {PluggableList} [rehypePlugins=[]]
 * @property {import('remark-rehype').Options | undefined} [remarkRehypeOptions={}]
 *
 * @typedef LayoutOptions
 * @property {string} [className]
 *
 * @typedef {CoreOptions & PluginOptions & LayoutOptions & FilterOptions & TransformOptions} ReactMarkdownOptions
 *
 * @typedef Deprecation
 * @property {string} id
 * @property {string} [to]
 */ 
var $b6HlZ = parcelRequire("b6HlZ");
/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Position} Position
 * @typedef {import('unist').Point} Point
 * @typedef {import('./minurl.shared.js').URL} URL
 * @typedef {import('../index.js').Data} Data
 * @typedef {import('../index.js').Value} Value
 */ /**
 * @typedef {Record<string, unknown> & {type: string, position?: Position | undefined}} NodeLike
 *
 * @typedef {'ascii' | 'utf8' | 'utf-8' | 'utf16le' | 'ucs2' | 'ucs-2' | 'base64' | 'base64url' | 'latin1' | 'binary' | 'hex'} BufferEncoding
 *   Encodings supported by the buffer class.
 *
 *   This is a copy of the types from Node, copied to prevent Node globals from
 *   being needed.
 *   Copied from: <https://github.com/DefinitelyTyped/DefinitelyTyped/blob/90a4ec8/types/node/buffer.d.ts#L170>
 *
 * @typedef {Options | URL | Value | VFile} Compatible
 *   Things that can be passed to the constructor.
 *
 * @typedef VFileCoreOptions
 *   Set multiple values.
 * @property {Value | null | undefined} [value]
 *   Set `value`.
 * @property {string | null | undefined} [cwd]
 *   Set `cwd`.
 * @property {Array<string> | null | undefined} [history]
 *   Set `history`.
 * @property {URL | string | null | undefined} [path]
 *   Set `path`.
 * @property {string | null | undefined} [basename]
 *   Set `basename`.
 * @property {string | null | undefined} [stem]
 *   Set `stem`.
 * @property {string | null | undefined} [extname]
 *   Set `extname`.
 * @property {string | null | undefined} [dirname]
 *   Set `dirname`.
 * @property {Data | null | undefined} [data]
 *   Set `data`.
 *
 * @typedef Map
 *   Raw source map.
 *
 *   See:
 *   <https://github.com/mozilla/source-map/blob/58819f0/source-map.d.ts#L15-L23>.
 * @property {number} version
 *   Which version of the source map spec this map is following.
 * @property {Array<string>} sources
 *   An array of URLs to the original source files.
 * @property {Array<string>} names
 *   An array of identifiers which can be referenced by individual mappings.
 * @property {string | undefined} [sourceRoot]
 *   The URL root from which all sources are relative.
 * @property {Array<string> | undefined} [sourcesContent]
 *   An array of contents of the original source files.
 * @property {string} mappings
 *   A string of base64 VLQs which contain the actual mappings.
 * @property {string} file
 *   The generated file this source map is associated with.
 *
 * @typedef {{[key: string]: unknown} & VFileCoreOptions} Options
 *   Configuration.
 *
 *   A bunch of keys that will be shallow copied over to the new file.
 *
 * @typedef {Record<string, unknown>} ReporterSettings
 *   Configuration for reporters.
 */ /**
 * @template {ReporterSettings} Settings
 *   Options type.
 * @callback Reporter
 *   Type for a reporter.
 * @param {Array<VFile>} files
 *   Files to report.
 * @param {Settings} options
 *   Configuration.
 * @returns {string}
 *   Report.
 */ var $9b03776ceb792a82$exports = {};
/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ $9b03776ceb792a82$exports = function isBuffer(obj) {
    return obj != null && obj.constructor != null && typeof obj.constructor.isBuffer === "function" && obj.constructor.isBuffer(obj);
};


/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Position} Position
 * @typedef {import('unist').Point} Point
 * @typedef {object & {type: string, position?: Position | undefined}} NodeLike
 */ /**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Point} Point
 * @typedef {import('unist').Position} Position
 */ /**
 * @typedef NodeLike
 * @property {string} type
 * @property {PositionLike | null | undefined} [position]
 *
 * @typedef PositionLike
 * @property {PointLike | null | undefined} [start]
 * @property {PointLike | null | undefined} [end]
 *
 * @typedef PointLike
 * @property {number | null | undefined} [line]
 * @property {number | null | undefined} [column]
 * @property {number | null | undefined} [offset]
 */ /**
 * Serialize the positional info of a point, position (start and end points),
 * or node.
 *
 * @param {Node | NodeLike | Position | PositionLike | Point | PointLike | null | undefined} [value]
 *   Node, position, or point.
 * @returns {string}
 *   Pretty printed positional info of a node (`string`).
 *
 *   In the format of a range `ls:cs-le:ce` (when given `node` or `position`)
 *   or a point `l:c` (when given `point`), where `l` stands for line, `c` for
 *   column, `s` for `start`, and `e` for end.
 *   An empty string (`''`) is returned if the given value is neither `node`,
 *   `position`, nor `point`.
 */ function $06fafbeb21cd8799$export$c304dd45fe166145(value) {
    // Nothing.
    if (!value || typeof value !== "object") return "";
    // Node.
    if ("position" in value || "type" in value) return $06fafbeb21cd8799$var$position(value.position);
    // Position.
    if ("start" in value || "end" in value) return $06fafbeb21cd8799$var$position(value);
    // Point.
    if ("line" in value || "column" in value) return $06fafbeb21cd8799$var$point(value);
    // ?
    return "";
}
/**
 * @param {Point | PointLike | null | undefined} point
 * @returns {string}
 */ function $06fafbeb21cd8799$var$point(point) {
    return $06fafbeb21cd8799$var$index(point && point.line) + ":" + $06fafbeb21cd8799$var$index(point && point.column);
}
/**
 * @param {Position | PositionLike | null | undefined} pos
 * @returns {string}
 */ function $06fafbeb21cd8799$var$position(pos) {
    return $06fafbeb21cd8799$var$point(pos && pos.start) + "-" + $06fafbeb21cd8799$var$point(pos && pos.end);
}
/**
 * @param {number | null | undefined} value
 * @returns {number}
 */ function $06fafbeb21cd8799$var$index(value) {
    return value && typeof value === "number" ? value : 1;
}


class $a84e37f26c696289$export$752e5c445fe834ef extends Error {
    /**
   * Create a message for `reason` at `place` from `origin`.
   *
   * When an error is passed in as `reason`, the `stack` is copied.
   *
   * @param {string | Error | VFileMessage} reason
   *   Reason for message, uses the stack and message of the error if given.
   *
   *   > 👉 **Note**: you should use markdown.
   * @param {Node | NodeLike | Position | Point | null | undefined} [place]
   *   Place in file where the message occurred.
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns
   *   Instance of `VFileMessage`.
   */ // To do: next major: expose `undefined` everywhere instead of `null`.
    constructor(reason, place, origin){
        /** @type {[string | null, string | null]} */ const parts = [
            null,
            null
        ];
        /** @type {Position} */ let position = {
            // @ts-expect-error: we always follows the structure of `position`.
            start: {
                line: null,
                column: null
            },
            // @ts-expect-error: "
            end: {
                line: null,
                column: null
            }
        };
        super();
        if (typeof place === "string") {
            origin = place;
            place = undefined;
        }
        if (typeof origin === "string") {
            const index = origin.indexOf(":");
            if (index === -1) parts[1] = origin;
            else {
                parts[0] = origin.slice(0, index);
                parts[1] = origin.slice(index + 1);
            }
        }
        if (place) {
            // Node.
            if ("type" in place || "position" in place) {
                if (place.position) // To do: next major: deep clone.
                // @ts-expect-error: looks like a position.
                position = place.position;
            } else if ("start" in place || "end" in place) // @ts-expect-error: looks like a position.
            // To do: next major: deep clone.
            position = place;
            else if ("line" in place || "column" in place) // To do: next major: deep clone.
            position.start = place;
        }
        // Fields from `Error`.
        /**
     * Serialized positional info of error.
     *
     * On normal errors, this would be something like `ParseError`, buit in
     * `VFile` messages we use this space to show where an error happened.
     */ this.name = (0, $06fafbeb21cd8799$export$c304dd45fe166145)(place) || "1:1";
        /**
     * Reason for message.
     *
     * @type {string}
     */ this.message = typeof reason === "object" ? reason.message : reason;
        /**
     * Stack of message.
     *
     * This is used by normal errors to show where something happened in
     * programming code, irrelevant for `VFile` messages,
     *
     * @type {string}
     */ this.stack = "";
        if (typeof reason === "object" && reason.stack) this.stack = reason.stack;
        /**
     * Reason for message.
     *
     * > 👉 **Note**: you should use markdown.
     *
     * @type {string}
     */ this.reason = this.message;
        /* eslint-disable no-unused-expressions */ /**
     * State of problem.
     *
     * * `true` — marks associated file as no longer processable (error)
     * * `false` — necessitates a (potential) change (warning)
     * * `null | undefined` — for things that might not need changing (info)
     *
     * @type {boolean | null | undefined}
     */ this.fatal;
        /**
     * Starting line of error.
     *
     * @type {number | null}
     */ this.line = position.start.line;
        /**
     * Starting column of error.
     *
     * @type {number | null}
     */ this.column = position.start.column;
        /**
     * Full unist position.
     *
     * @type {Position | null}
     */ this.position = position;
        /**
     * Namespace of message (example: `'my-package'`).
     *
     * @type {string | null}
     */ this.source = parts[0];
        /**
     * Category of message (example: `'my-rule'`).
     *
     * @type {string | null}
     */ this.ruleId = parts[1];
        /**
     * Path of a file (used throughout the `VFile` ecosystem).
     *
     * @type {string | null}
     */ this.file;
        // The following fields are “well known”.
        // Not standard.
        // Feel free to add other non-standard fields to your messages.
        /**
     * Specify the source value that’s being reported, which is deemed
     * incorrect.
     *
     * @type {string | null}
     */ this.actual;
        /**
     * Suggest acceptable values that can be used instead of `actual`.
     *
     * @type {Array<string> | null}
     */ this.expected;
        /**
     * Link to docs for the message.
     *
     * > 👉 **Note**: this must be an absolute URL that can be passed as `x`
     * > to `new URL(x)`.
     *
     * @type {string | null}
     */ this.url;
        /**
     * Long form description of the message (you should use markdown).
     *
     * @type {string | null}
     */ this.note;
    /* eslint-enable no-unused-expressions */ }
}
$a84e37f26c696289$export$752e5c445fe834ef.prototype.file = "";
$a84e37f26c696289$export$752e5c445fe834ef.prototype.name = "";
$a84e37f26c696289$export$752e5c445fe834ef.prototype.reason = "";
$a84e37f26c696289$export$752e5c445fe834ef.prototype.message = "";
$a84e37f26c696289$export$752e5c445fe834ef.prototype.stack = "";
$a84e37f26c696289$export$752e5c445fe834ef.prototype.fatal = null;
$a84e37f26c696289$export$752e5c445fe834ef.prototype.column = null;
$a84e37f26c696289$export$752e5c445fe834ef.prototype.line = null;
$a84e37f26c696289$export$752e5c445fe834ef.prototype.source = null;
$a84e37f26c696289$export$752e5c445fe834ef.prototype.ruleId = null;
$a84e37f26c696289$export$752e5c445fe834ef.prototype.position = null;


// A derivative work based on:
// <https://github.com/browserify/path-browserify>.
// Which is licensed:
//
// MIT License
//
// Copyright (c) 2013 James Halliday
//
// Permission is hereby granted, free of charge, to any person obtaining a copy of
// this software and associated documentation files (the "Software"), to deal in
// the Software without restriction, including without limitation the rights to
// use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of
// the Software, and to permit persons to whom the Software is furnished to do so,
// subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
// FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
// COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
// IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
// CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
// A derivative work based on:
//
// Parts of that are extracted from Node’s internal `path` module:
// <https://github.com/nodejs/node/blob/master/lib/path.js>.
// Which is licensed:
//
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
const $9f8f8555caad5cdc$export$bb654e07daaf8c3a = {
    basename: $9f8f8555caad5cdc$var$basename,
    dirname: $9f8f8555caad5cdc$var$dirname,
    extname: $9f8f8555caad5cdc$var$extname,
    join: $9f8f8555caad5cdc$var$join,
    sep: "/"
};
/* eslint-disable max-depth, complexity */ /**
 * Get the basename from a path.
 *
 * @param {string} path
 *   File path.
 * @param {string | undefined} [ext]
 *   Extension to strip.
 * @returns {string}
 *   Stem or basename.
 */ function $9f8f8555caad5cdc$var$basename(path, ext) {
    if (ext !== undefined && typeof ext !== "string") throw new TypeError('"ext" argument must be a string');
    $9f8f8555caad5cdc$var$assertPath(path);
    let start = 0;
    let end = -1;
    let index = path.length;
    /** @type {boolean | undefined} */ let seenNonSlash;
    if (ext === undefined || ext.length === 0 || ext.length > path.length) {
        while(index--){
            if (path.charCodeAt(index) === 47 /* `/` */ ) // If we reached a path separator that was not part of a set of path
            // separators at the end of the string, stop now.
            {
                if (seenNonSlash) {
                    start = index + 1;
                    break;
                }
            } else if (end < 0) {
                // We saw the first non-path separator, mark this as the end of our
                // path component.
                seenNonSlash = true;
                end = index + 1;
            }
        }
        return end < 0 ? "" : path.slice(start, end);
    }
    if (ext === path) return "";
    let firstNonSlashEnd = -1;
    let extIndex = ext.length - 1;
    while(index--){
        if (path.charCodeAt(index) === 47 /* `/` */ ) // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now.
        {
            if (seenNonSlash) {
                start = index + 1;
                break;
            }
        } else {
            if (firstNonSlashEnd < 0) {
                // We saw the first non-path separator, remember this index in case
                // we need it if the extension ends up not matching.
                seenNonSlash = true;
                firstNonSlashEnd = index + 1;
            }
            if (extIndex > -1) {
                // Try to match the explicit extension.
                if (path.charCodeAt(index) === ext.charCodeAt(extIndex--)) {
                    if (extIndex < 0) // We matched the extension, so mark this as the end of our path
                    // component
                    end = index;
                } else {
                    // Extension does not match, so our result is the entire path
                    // component
                    extIndex = -1;
                    end = firstNonSlashEnd;
                }
            }
        }
    }
    if (start === end) end = firstNonSlashEnd;
    else if (end < 0) end = path.length;
    return path.slice(start, end);
}
/**
 * Get the dirname from a path.
 *
 * @param {string} path
 *   File path.
 * @returns {string}
 *   File path.
 */ function $9f8f8555caad5cdc$var$dirname(path) {
    $9f8f8555caad5cdc$var$assertPath(path);
    if (path.length === 0) return ".";
    let end = -1;
    let index = path.length;
    /** @type {boolean | undefined} */ let unmatchedSlash;
    // Prefix `--` is important to not run on `0`.
    while(--index){
        if (path.charCodeAt(index) === 47 /* `/` */ ) {
            if (unmatchedSlash) {
                end = index;
                break;
            }
        } else if (!unmatchedSlash) // We saw the first non-path separator
        unmatchedSlash = true;
    }
    return end < 0 ? path.charCodeAt(0) === 47 /* `/` */  ? "/" : "." : end === 1 && path.charCodeAt(0) === 47 /* `/` */  ? "//" : path.slice(0, end);
}
/**
 * Get an extname from a path.
 *
 * @param {string} path
 *   File path.
 * @returns {string}
 *   Extname.
 */ function $9f8f8555caad5cdc$var$extname(path) {
    $9f8f8555caad5cdc$var$assertPath(path);
    let index = path.length;
    let end = -1;
    let startPart = 0;
    let startDot = -1;
    // Track the state of characters (if any) we see before our first dot and
    // after any path separator we find.
    let preDotState = 0;
    /** @type {boolean | undefined} */ let unmatchedSlash;
    while(index--){
        const code = path.charCodeAt(index);
        if (code === 47 /* `/` */ ) {
            // If we reached a path separator that was not part of a set of path
            // separators at the end of the string, stop now.
            if (unmatchedSlash) {
                startPart = index + 1;
                break;
            }
            continue;
        }
        if (end < 0) {
            // We saw the first non-path separator, mark this as the end of our
            // extension.
            unmatchedSlash = true;
            end = index + 1;
        }
        if (code === 46 /* `.` */ ) {
            // If this is our first dot, mark it as the start of our extension.
            if (startDot < 0) startDot = index;
            else if (preDotState !== 1) preDotState = 1;
        } else if (startDot > -1) // We saw a non-dot and non-path separator before our dot, so we should
        // have a good chance at having a non-empty extension.
        preDotState = -1;
    }
    if (startDot < 0 || end < 0 || // We saw a non-dot character immediately before the dot.
    preDotState === 0 || // The (right-most) trimmed path component is exactly `..`.
    preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) return "";
    return path.slice(startDot, end);
}
/**
 * Join segments from a path.
 *
 * @param {Array<string>} segments
 *   Path segments.
 * @returns {string}
 *   File path.
 */ function $9f8f8555caad5cdc$var$join(...segments) {
    let index = -1;
    /** @type {string | undefined} */ let joined;
    while(++index < segments.length){
        $9f8f8555caad5cdc$var$assertPath(segments[index]);
        if (segments[index]) joined = joined === undefined ? segments[index] : joined + "/" + segments[index];
    }
    return joined === undefined ? "." : $9f8f8555caad5cdc$var$normalize(joined);
}
/**
 * Normalize a basic file path.
 *
 * @param {string} path
 *   File path.
 * @returns {string}
 *   File path.
 */ // Note: `normalize` is not exposed as `path.normalize`, so some code is
// manually removed from it.
function $9f8f8555caad5cdc$var$normalize(path) {
    $9f8f8555caad5cdc$var$assertPath(path);
    const absolute = path.charCodeAt(0) === 47 /* `/` */ ;
    // Normalize the path according to POSIX rules.
    let value = $9f8f8555caad5cdc$var$normalizeString(path, !absolute);
    if (value.length === 0 && !absolute) value = ".";
    if (value.length > 0 && path.charCodeAt(path.length - 1) === 47 /* / */ ) value += "/";
    return absolute ? "/" + value : value;
}
/**
 * Resolve `.` and `..` elements in a path with directory names.
 *
 * @param {string} path
 *   File path.
 * @param {boolean} allowAboveRoot
 *   Whether `..` can move above root.
 * @returns {string}
 *   File path.
 */ function $9f8f8555caad5cdc$var$normalizeString(path, allowAboveRoot) {
    let result = "";
    let lastSegmentLength = 0;
    let lastSlash = -1;
    let dots = 0;
    let index = -1;
    /** @type {number | undefined} */ let code;
    /** @type {number} */ let lastSlashIndex;
    while(++index <= path.length){
        if (index < path.length) code = path.charCodeAt(index);
        else if (code === 47 /* `/` */ ) break;
        else code = 47 /* `/` */ ;
        if (code === 47 /* `/` */ ) {
            if (lastSlash === index - 1 || dots === 1) ;
            else if (lastSlash !== index - 1 && dots === 2) {
                if (result.length < 2 || lastSegmentLength !== 2 || result.charCodeAt(result.length - 1) !== 46 /* `.` */  || result.charCodeAt(result.length - 2) !== 46 /* `.` */ ) {
                    if (result.length > 2) {
                        lastSlashIndex = result.lastIndexOf("/");
                        if (lastSlashIndex !== result.length - 1) {
                            if (lastSlashIndex < 0) {
                                result = "";
                                lastSegmentLength = 0;
                            } else {
                                result = result.slice(0, lastSlashIndex);
                                lastSegmentLength = result.length - 1 - result.lastIndexOf("/");
                            }
                            lastSlash = index;
                            dots = 0;
                            continue;
                        }
                    } else if (result.length > 0) {
                        result = "";
                        lastSegmentLength = 0;
                        lastSlash = index;
                        dots = 0;
                        continue;
                    }
                }
                if (allowAboveRoot) {
                    result = result.length > 0 ? result + "/.." : "..";
                    lastSegmentLength = 2;
                }
            } else {
                if (result.length > 0) result += "/" + path.slice(lastSlash + 1, index);
                else result = path.slice(lastSlash + 1, index);
                lastSegmentLength = index - lastSlash - 1;
            }
            lastSlash = index;
            dots = 0;
        } else if (code === 46 /* `.` */  && dots > -1) dots++;
        else dots = -1;
    }
    return result;
}
/**
 * Make sure `path` is a string.
 *
 * @param {string} path
 *   File path.
 * @returns {asserts path is string}
 *   Nothing.
 */ function $9f8f8555caad5cdc$var$assertPath(path) {
    if (typeof path !== "string") throw new TypeError("Path must be a string. Received " + JSON.stringify(path));
} /* eslint-enable max-depth, complexity */ 


// Somewhat based on:
// <https://github.com/defunctzombie/node-process/blob/master/browser.js>.
// But I don’t think one tiny line of code can be copyrighted. 😅
const $dcf31fdf8dbdf1e6$export$97a5aaf482767187 = {
    cwd: $dcf31fdf8dbdf1e6$var$cwd
};
function $dcf31fdf8dbdf1e6$var$cwd() {
    return "/";
}


/// <reference lib="dom" />
/**
 * @typedef URL
 * @property {string} hash
 * @property {string} host
 * @property {string} hostname
 * @property {string} href
 * @property {string} origin
 * @property {string} password
 * @property {string} pathname
 * @property {string} port
 * @property {string} protocol
 * @property {string} search
 * @property {any} searchParams
 * @property {string} username
 * @property {() => string} toString
 * @property {() => string} toJSON
 */ /**
 * Check if `fileUrlOrPath` looks like a URL.
 *
 * @param {unknown} fileUrlOrPath
 *   File path or URL.
 * @returns {fileUrlOrPath is URL}
 *   Whether it’s a URL.
 */ // From: <https://github.com/nodejs/node/blob/fcf8ba4/lib/internal/url.js#L1501>
function $e2c2a9ad71de1fe8$export$8304a22d431f958(fileUrlOrPath) {
    return fileUrlOrPath !== null && typeof fileUrlOrPath === "object" && // @ts-expect-error: indexable.
    fileUrlOrPath.href && // @ts-expect-error: indexable.
    fileUrlOrPath.origin;
}


function $076d247e253e053f$export$9b2b676c902de799(path) {
    if (typeof path === "string") path = new URL(path);
    else if (!(0, $e2c2a9ad71de1fe8$export$8304a22d431f958)(path)) {
        /** @type {NodeJS.ErrnoException} */ const error = new TypeError('The "path" argument must be of type string or an instance of URL. Received `' + path + "`");
        error.code = "ERR_INVALID_ARG_TYPE";
        throw error;
    }
    if (path.protocol !== "file:") {
        /** @type {NodeJS.ErrnoException} */ const error = new TypeError("The URL must be of scheme file");
        error.code = "ERR_INVALID_URL_SCHEME";
        throw error;
    }
    return $076d247e253e053f$var$getPathFromURLPosix(path);
}
/**
 * Get a path from a POSIX URL.
 *
 * @param {URL} url
 *   URL.
 * @returns {string}
 *   File path.
 */ function $076d247e253e053f$var$getPathFromURLPosix(url) {
    if (url.hostname !== "") {
        /** @type {NodeJS.ErrnoException} */ const error = new TypeError('File URL host must be "localhost" or empty on darwin');
        error.code = "ERR_INVALID_FILE_URL_HOST";
        throw error;
    }
    const pathname = url.pathname;
    let index = -1;
    while(++index < pathname.length)if (pathname.charCodeAt(index) === 37 /* `%` */  && pathname.charCodeAt(index + 1) === 50 /* `2` */ ) {
        const third = pathname.charCodeAt(index + 2);
        if (third === 70 /* `F` */  || third === 102 /* `f` */ ) {
            /** @type {NodeJS.ErrnoException} */ const error = new TypeError("File URL path must not include encoded / characters");
            error.code = "ERR_INVALID_FILE_URL_PATH";
            throw error;
        }
    }
    return decodeURIComponent(pathname);
}


/**
 * Order of setting (least specific to most), we need this because otherwise
 * `{stem: 'a', path: '~/b.js'}` would throw, as a path is needed before a
 * stem can be set.
 *
 * @type {Array<'basename' | 'dirname' | 'extname' | 'history' | 'path' | 'stem'>}
 */ const $bfee953aeca75867$var$order = [
    "history",
    "path",
    "basename",
    "stem",
    "extname",
    "dirname"
];
class $bfee953aeca75867$export$93dff69eb10dc7ce {
    /**
   * Get the full path (example: `'~/index.min.js'`).
   *
   * @returns {string}
   */ get path() {
        return this.history[this.history.length - 1];
    }
    /**
   * Set the full path (example: `'~/index.min.js'`).
   *
   * Cannot be nullified.
   * You can set a file URL (a `URL` object with a `file:` protocol) which will
   * be turned into a path with `url.fileURLToPath`.
   *
   * @param {string | URL} path
   */ set path(path) {
        if ((0, $e2c2a9ad71de1fe8$export$8304a22d431f958)(path)) path = (0, $076d247e253e053f$export$9b2b676c902de799)(path);
        $bfee953aeca75867$var$assertNonEmpty(path, "path");
        if (this.path !== path) this.history.push(path);
    }
    /**
   * Get the parent path (example: `'~'`).
   */ get dirname() {
        return typeof this.path === "string" ? (0, $9f8f8555caad5cdc$export$bb654e07daaf8c3a).dirname(this.path) : undefined;
    }
    /**
   * Set the parent path (example: `'~'`).
   *
   * Cannot be set if there’s no `path` yet.
   */ set dirname(dirname) {
        $bfee953aeca75867$var$assertPath(this.basename, "dirname");
        this.path = (0, $9f8f8555caad5cdc$export$bb654e07daaf8c3a).join(dirname || "", this.basename);
    }
    /**
   * Get the basename (including extname) (example: `'index.min.js'`).
   */ get basename() {
        return typeof this.path === "string" ? (0, $9f8f8555caad5cdc$export$bb654e07daaf8c3a).basename(this.path) : undefined;
    }
    /**
   * Set basename (including extname) (`'index.min.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   */ set basename(basename) {
        $bfee953aeca75867$var$assertNonEmpty(basename, "basename");
        $bfee953aeca75867$var$assertPart(basename, "basename");
        this.path = (0, $9f8f8555caad5cdc$export$bb654e07daaf8c3a).join(this.dirname || "", basename);
    }
    /**
   * Get the extname (including dot) (example: `'.js'`).
   */ get extname() {
        return typeof this.path === "string" ? (0, $9f8f8555caad5cdc$export$bb654e07daaf8c3a).extname(this.path) : undefined;
    }
    /**
   * Set the extname (including dot) (example: `'.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be set if there’s no `path` yet.
   */ set extname(extname) {
        $bfee953aeca75867$var$assertPart(extname, "extname");
        $bfee953aeca75867$var$assertPath(this.dirname, "extname");
        if (extname) {
            if (extname.charCodeAt(0) !== 46 /* `.` */ ) throw new Error("`extname` must start with `.`");
            if (extname.includes(".", 1)) throw new Error("`extname` cannot contain multiple dots");
        }
        this.path = (0, $9f8f8555caad5cdc$export$bb654e07daaf8c3a).join(this.dirname, this.stem + (extname || ""));
    }
    /**
   * Get the stem (basename w/o extname) (example: `'index.min'`).
   */ get stem() {
        return typeof this.path === "string" ? (0, $9f8f8555caad5cdc$export$bb654e07daaf8c3a).basename(this.path, this.extname) : undefined;
    }
    /**
   * Set the stem (basename w/o extname) (example: `'index.min'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   */ set stem(stem) {
        $bfee953aeca75867$var$assertNonEmpty(stem, "stem");
        $bfee953aeca75867$var$assertPart(stem, "stem");
        this.path = (0, $9f8f8555caad5cdc$export$bb654e07daaf8c3a).join(this.dirname || "", stem + (this.extname || ""));
    }
    /**
   * Serialize the file.
   *
   * @param {BufferEncoding | null | undefined} [encoding='utf8']
   *   Character encoding to understand `value` as when it’s a `Buffer`
   *   (default: `'utf8'`).
   * @returns {string}
   *   Serialized file.
   */ toString(encoding) {
        return (this.value || "").toString(encoding || undefined);
    }
    /**
   * Create a warning message associated with the file.
   *
   * Its `fatal` is set to `false` and `file` is set to the current file path.
   * Its added to `file.messages`.
   *
   * @param {string | Error | VFileMessage} reason
   *   Reason for message, uses the stack and message of the error if given.
   * @param {Node | NodeLike | Position | Point | null | undefined} [place]
   *   Place in file where the message occurred.
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */ message(reason, place, origin) {
        const message = new (0, $a84e37f26c696289$export$752e5c445fe834ef)(reason, place, origin);
        if (this.path) {
            message.name = this.path + ":" + message.name;
            message.file = this.path;
        }
        message.fatal = false;
        this.messages.push(message);
        return message;
    }
    /**
   * Create an info message associated with the file.
   *
   * Its `fatal` is set to `null` and `file` is set to the current file path.
   * Its added to `file.messages`.
   *
   * @param {string | Error | VFileMessage} reason
   *   Reason for message, uses the stack and message of the error if given.
   * @param {Node | NodeLike | Position | Point | null | undefined} [place]
   *   Place in file where the message occurred.
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */ info(reason, place, origin) {
        const message = this.message(reason, place, origin);
        message.fatal = null;
        return message;
    }
    /**
   * Create a fatal error associated with the file.
   *
   * Its `fatal` is set to `true` and `file` is set to the current file path.
   * Its added to `file.messages`.
   *
   * > 👉 **Note**: a fatal error means that a file is no longer processable.
   *
   * @param {string | Error | VFileMessage} reason
   *   Reason for message, uses the stack and message of the error if given.
   * @param {Node | NodeLike | Position | Point | null | undefined} [place]
   *   Place in file where the message occurred.
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {never}
   *   Message.
   * @throws {VFileMessage}
   *   Message.
   */ fail(reason, place, origin) {
        const message = this.message(reason, place, origin);
        message.fatal = true;
        throw message;
    }
    /**
   * Create a new virtual file.
   *
   * `options` is treated as:
   *
   * *   `string` or `Buffer` — `{value: options}`
   * *   `URL` — `{path: options}`
   * *   `VFile` — shallow copies its data over to the new file
   * *   `object` — all fields are shallow copied over to the new file
   *
   * Path related fields are set in the following order (least specific to
   * most specific): `history`, `path`, `basename`, `stem`, `extname`,
   * `dirname`.
   *
   * You cannot set `dirname` or `extname` without setting either `history`,
   * `path`, `basename`, or `stem` too.
   *
   * @param {Compatible | null | undefined} [value]
   *   File value.
   * @returns
   *   New instance.
   */ constructor(value){
        /** @type {Options | VFile} */ let options;
        if (!value) options = {};
        else if (typeof value === "string" || $bfee953aeca75867$var$buffer(value)) options = {
            value: value
        };
        else if ((0, $e2c2a9ad71de1fe8$export$8304a22d431f958)(value)) options = {
            path: value
        };
        else options = value;
        /**
     * Place to store custom information (default: `{}`).
     *
     * It’s OK to store custom data directly on the file but moving it to
     * `data` is recommended.
     *
     * @type {Data}
     */ this.data = {};
        /**
     * List of messages associated with the file.
     *
     * @type {Array<VFileMessage>}
     */ this.messages = [];
        /**
     * List of filepaths the file moved between.
     *
     * The first is the original path and the last is the current path.
     *
     * @type {Array<string>}
     */ this.history = [];
        /**
     * Base of `path` (default: `process.cwd()` or `'/'` in browsers).
     *
     * @type {string}
     */ this.cwd = (0, $dcf31fdf8dbdf1e6$export$97a5aaf482767187).cwd();
        /* eslint-disable no-unused-expressions */ /**
     * Raw value.
     *
     * @type {Value}
     */ this.value;
        // The below are non-standard, they are “well-known”.
        // As in, used in several tools.
        /**
     * Whether a file was saved to disk.
     *
     * This is used by vfile reporters.
     *
     * @type {boolean}
     */ this.stored;
        /**
     * Custom, non-string, compiled, representation.
     *
     * This is used by unified to store non-string results.
     * One example is when turning markdown into React nodes.
     *
     * @type {unknown}
     */ this.result;
        /**
     * Source map.
     *
     * This type is equivalent to the `RawSourceMap` type from the `source-map`
     * module.
     *
     * @type {Map | null | undefined}
     */ this.map;
        /* eslint-enable no-unused-expressions */ // Set path related properties in the correct order.
        let index = -1;
        while(++index < $bfee953aeca75867$var$order.length){
            const prop = $bfee953aeca75867$var$order[index];
            // Note: we specifically use `in` instead of `hasOwnProperty` to accept
            // `vfile`s too.
            if (prop in options && options[prop] !== undefined && options[prop] !== null) // @ts-expect-error: TS doesn’t understand basic reality.
            this[prop] = prop === "history" ? [
                ...options[prop]
            ] : options[prop];
        }
        /** @type {string} */ let prop;
        // Set non-path related properties.
        for(prop in options)// @ts-expect-error: fine to set other things.
        if (!$bfee953aeca75867$var$order.includes(prop)) // @ts-expect-error: fine to set other things.
        this[prop] = options[prop];
    }
}
/**
 * Assert that `part` is not a path (as in, does not contain `path.sep`).
 *
 * @param {string | null | undefined} part
 *   File path part.
 * @param {string} name
 *   Part name.
 * @returns {void}
 *   Nothing.
 */ function $bfee953aeca75867$var$assertPart(part, name) {
    if (part && part.includes((0, $9f8f8555caad5cdc$export$bb654e07daaf8c3a).sep)) throw new Error("`" + name + "` cannot be a path: did not expect `" + (0, $9f8f8555caad5cdc$export$bb654e07daaf8c3a).sep + "`");
}
/**
 * Assert that `part` is not empty.
 *
 * @param {string | undefined} part
 *   Thing.
 * @param {string} name
 *   Part name.
 * @returns {asserts part is string}
 *   Nothing.
 */ function $bfee953aeca75867$var$assertNonEmpty(part, name) {
    if (!part) throw new Error("`" + name + "` cannot be empty");
}
/**
 * Assert `path` exists.
 *
 * @param {string | undefined} path
 *   Path.
 * @param {string} name
 *   Dependency name.
 * @returns {asserts path is string}
 *   Nothing.
 */ function $bfee953aeca75867$var$assertPath(path, name) {
    if (!path) throw new Error("Setting `" + name + "` requires `path` to be set too");
}
/**
 * Assert `value` is a buffer.
 *
 * @param {unknown} value
 *   thing.
 * @returns {value is Buffer}
 *   Whether `value` is a Node.js buffer.
 */ function $bfee953aeca75867$var$buffer(value) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($9b03776ceb792a82$exports)))(value);
}


/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('vfile').VFileCompatible} VFileCompatible
 * @typedef {import('vfile').VFileValue} VFileValue
 * @typedef {import('..').Processor} Processor
 * @typedef {import('..').Plugin} Plugin
 * @typedef {import('..').Preset} Preset
 * @typedef {import('..').Pluggable} Pluggable
 * @typedef {import('..').PluggableList} PluggableList
 * @typedef {import('..').Transformer} Transformer
 * @typedef {import('..').Parser} Parser
 * @typedef {import('..').Compiler} Compiler
 * @typedef {import('..').RunCallback} RunCallback
 * @typedef {import('..').ProcessCallback} ProcessCallback
 *
 * @typedef Context
 * @property {Node} tree
 * @property {VFile} file
 */ /**
 * Throw a given error.
 *
 * @param {Error|null|undefined} [error]
 *   Maybe error.
 * @returns {asserts error is null|undefined}
 */ function $c193ade91148a4c8$export$dd911e13ecb11e05(error) {
    if (error) throw error;
}



var $f1f7ad6914f0e27c$exports = {};
"use strict";
var $f1f7ad6914f0e27c$var$hasOwn = Object.prototype.hasOwnProperty;
var $f1f7ad6914f0e27c$var$toStr = Object.prototype.toString;
var $f1f7ad6914f0e27c$var$defineProperty = Object.defineProperty;
var $f1f7ad6914f0e27c$var$gOPD = Object.getOwnPropertyDescriptor;
var $f1f7ad6914f0e27c$var$isArray = function isArray(arr) {
    if (typeof Array.isArray === "function") return Array.isArray(arr);
    return $f1f7ad6914f0e27c$var$toStr.call(arr) === "[object Array]";
};
var $f1f7ad6914f0e27c$var$isPlainObject = function isPlainObject(obj) {
    if (!obj || $f1f7ad6914f0e27c$var$toStr.call(obj) !== "[object Object]") return false;
    var hasOwnConstructor = $f1f7ad6914f0e27c$var$hasOwn.call(obj, "constructor");
    var hasIsPrototypeOf = obj.constructor && obj.constructor.prototype && $f1f7ad6914f0e27c$var$hasOwn.call(obj.constructor.prototype, "isPrototypeOf");
    // Not own constructor property must be Object
    if (obj.constructor && !hasOwnConstructor && !hasIsPrototypeOf) return false;
    // Own properties are enumerated firstly, so to speed up,
    // if last one is own, then all properties are own.
    var key;
    for(key in obj);
    return typeof key === "undefined" || $f1f7ad6914f0e27c$var$hasOwn.call(obj, key);
};
// If name is '__proto__', and Object.defineProperty is available, define __proto__ as an own property on target
var $f1f7ad6914f0e27c$var$setProperty = function setProperty(target, options) {
    if ($f1f7ad6914f0e27c$var$defineProperty && options.name === "__proto__") $f1f7ad6914f0e27c$var$defineProperty(target, options.name, {
        enumerable: true,
        configurable: true,
        value: options.newValue,
        writable: true
    });
    else target[options.name] = options.newValue;
};
// Return undefined instead of __proto__ if '__proto__' is not an own property
var $f1f7ad6914f0e27c$var$getProperty = function getProperty(obj, name) {
    if (name === "__proto__") {
        if (!$f1f7ad6914f0e27c$var$hasOwn.call(obj, name)) return void 0;
        else if ($f1f7ad6914f0e27c$var$gOPD) // In early versions of node, obj['__proto__'] is buggy when obj has
        // __proto__ as an own property. Object.getOwnPropertyDescriptor() works.
        return $f1f7ad6914f0e27c$var$gOPD(obj, name).value;
    }
    return obj[name];
};
$f1f7ad6914f0e27c$exports = function extend() {
    var options, name, src, copy, copyIsArray, clone;
    var target = arguments[0];
    var i = 1;
    var length = arguments.length;
    var deep = false;
    // Handle a deep copy situation
    if (typeof target === "boolean") {
        deep = target;
        target = arguments[1] || {};
        // skip the boolean and the target
        i = 2;
    }
    if (target == null || typeof target !== "object" && typeof target !== "function") target = {};
    for(; i < length; ++i){
        options = arguments[i];
        // Only deal with non-null/undefined values
        if (options != null) // Extend the base object
        for(name in options){
            src = $f1f7ad6914f0e27c$var$getProperty(target, name);
            copy = $f1f7ad6914f0e27c$var$getProperty(options, name);
            // Prevent never-ending loop
            if (target !== copy) {
                // Recurse if we're merging plain objects or arrays
                if (deep && copy && ($f1f7ad6914f0e27c$var$isPlainObject(copy) || (copyIsArray = $f1f7ad6914f0e27c$var$isArray(copy)))) {
                    if (copyIsArray) {
                        copyIsArray = false;
                        clone = src && $f1f7ad6914f0e27c$var$isArray(src) ? src : [];
                    } else clone = src && $f1f7ad6914f0e27c$var$isPlainObject(src) ? src : {};
                    // Never move original objects, clone them
                    $f1f7ad6914f0e27c$var$setProperty(target, {
                        name: name,
                        newValue: extend(deep, clone, copy)
                    });
                // Don't bring in undefined values
                } else if (typeof copy !== "undefined") $f1f7ad6914f0e27c$var$setProperty(target, {
                    name: name,
                    newValue: copy
                });
            }
        }
    }
    // Return the modified object
    return target;
};


function $01cfdf044662e73e$export$2e2bcd8739ae039(value) {
    if (typeof value !== "object" || value === null) return false;
    const prototype = Object.getPrototypeOf(value);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in value) && !(Symbol.iterator in value);
}


/**
 * @typedef {(error?: Error|null|undefined, ...output: Array<any>) => void} Callback
 * @typedef {(...input: Array<any>) => any} Middleware
 *
 * @typedef {(...input: Array<any>) => void} Run
 *   Call all middleware.
 * @typedef {(fn: Middleware) => Pipeline} Use
 *   Add `fn` (middleware) to the list.
 * @typedef {{run: Run, use: Use}} Pipeline
 *   Middleware.
 */ /**
 * Create new middleware.
 *
 * @returns {Pipeline}
 */ function $efd47b69a0bd68f9$export$91b56f5ca106aa43() {
    /** @type {Array<Middleware>} */ const fns = [];
    /** @type {Pipeline} */ const pipeline = {
        run: run,
        use: use
    };
    return pipeline;
    /** @type {Run} */ function run(...values) {
        let middlewareIndex = -1;
        /** @type {Callback} */ const callback = values.pop();
        if (typeof callback !== "function") throw new TypeError("Expected function as last argument, not " + callback);
        next(null, ...values);
        /**
     * Run the next `fn`, or we’re done.
     *
     * @param {Error|null|undefined} error
     * @param {Array<any>} output
     */ function next(error, ...output) {
            const fn = fns[++middlewareIndex];
            let index = -1;
            if (error) {
                callback(error);
                return;
            }
            // Copy non-nullish input into values.
            while(++index < values.length)if (output[index] === null || output[index] === undefined) output[index] = values[index];
            // Save the newly created `output` for the next call.
            values = output;
            // Next or done.
            if (fn) $efd47b69a0bd68f9$export$4997ffc0176396a6(fn, next)(...output);
            else callback(null, ...output);
        }
    }
    /** @type {Use} */ function use(middelware) {
        if (typeof middelware !== "function") throw new TypeError("Expected `middelware` to be a function, not " + middelware);
        fns.push(middelware);
        return pipeline;
    }
}
function $efd47b69a0bd68f9$export$4997ffc0176396a6(middleware, callback) {
    /** @type {boolean} */ let called;
    return wrapped;
    /**
   * Call `middleware`.
   * @this {any}
   * @param {Array<any>} parameters
   * @returns {void}
   */ function wrapped(...parameters) {
        const fnExpectsCallback = middleware.length > parameters.length;
        /** @type {any} */ let result;
        if (fnExpectsCallback) parameters.push(done);
        try {
            result = middleware.apply(this, parameters);
        } catch (error) {
            const exception = /** @type {Error} */ error;
            // Well, this is quite the pickle.
            // `middleware` received a callback and called it synchronously, but that
            // threw an error.
            // The only thing left to do is to throw the thing instead.
            if (fnExpectsCallback && called) throw exception;
            return done(exception);
        }
        if (!fnExpectsCallback) {
            if (result instanceof Promise) result.then(then, done);
            else if (result instanceof Error) done(result);
            else then(result);
        }
    }
    /**
   * Call `callback`, only once.
   * @type {Callback}
   */ function done(error, ...output) {
        if (!called) {
            called = true;
            callback(error, ...output);
        }
    }
    /**
   * Call `done` with one value.
   *
   * @param {any} [value]
   */ function then(value) {
        done(null, value);
    }
}



const $0ac0148904b4dd9c$export$7cc1b2fe10c52bb = $0ac0148904b4dd9c$var$base().freeze();
const $0ac0148904b4dd9c$var$own = {}.hasOwnProperty;
// Function to create the first processor.
/**
 * @returns {Processor}
 */ function $0ac0148904b4dd9c$var$base() {
    const transformers = (0, $efd47b69a0bd68f9$export$91b56f5ca106aa43)();
    /** @type {Processor['attachers']} */ const attachers = [];
    /** @type {Record<string, unknown>} */ let namespace = {};
    /** @type {boolean|undefined} */ let frozen;
    let freezeIndex = -1;
    // Data management.
    // @ts-expect-error: overloads are handled.
    processor.data = data;
    processor.Parser = undefined;
    processor.Compiler = undefined;
    // Lock.
    processor.freeze = freeze;
    // Plugins.
    processor.attachers = attachers;
    // @ts-expect-error: overloads are handled.
    processor.use = use;
    // API.
    processor.parse = parse;
    processor.stringify = stringify;
    // @ts-expect-error: overloads are handled.
    processor.run = run;
    processor.runSync = runSync;
    // @ts-expect-error: overloads are handled.
    processor.process = process;
    processor.processSync = processSync;
    // Expose.
    return processor;
    // Create a new processor based on the processor in the current scope.
    /** @type {Processor} */ function processor() {
        const destination = $0ac0148904b4dd9c$var$base();
        let index = -1;
        while(++index < attachers.length)destination.use(...attachers[index]);
        destination.data((0, (/*@__PURE__*/$parcel$interopDefault($f1f7ad6914f0e27c$exports)))(true, {}, namespace));
        return destination;
    }
    /**
   * @param {string|Record<string, unknown>} [key]
   * @param {unknown} [value]
   * @returns {unknown}
   */ function data(key, value) {
        if (typeof key === "string") {
            // Set `key`.
            if (arguments.length === 2) {
                $0ac0148904b4dd9c$var$assertUnfrozen("data", frozen);
                namespace[key] = value;
                return processor;
            }
            // Get `key`.
            return $0ac0148904b4dd9c$var$own.call(namespace, key) && namespace[key] || null;
        }
        // Set space.
        if (key) {
            $0ac0148904b4dd9c$var$assertUnfrozen("data", frozen);
            namespace = key;
            return processor;
        }
        // Get space.
        return namespace;
    }
    /** @type {Processor['freeze']} */ function freeze() {
        if (frozen) return processor;
        while(++freezeIndex < attachers.length){
            const [attacher, ...options] = attachers[freezeIndex];
            if (options[0] === false) continue;
            if (options[0] === true) options[0] = undefined;
            /** @type {Transformer|void} */ const transformer = attacher.call(processor, ...options);
            if (typeof transformer === "function") transformers.use(transformer);
        }
        frozen = true;
        freezeIndex = Number.POSITIVE_INFINITY;
        return processor;
    }
    /**
   * @param {Pluggable|null|undefined} [value]
   * @param {...unknown} options
   * @returns {Processor}
   */ function use(value, ...options) {
        /** @type {Record<string, unknown>|undefined} */ let settings;
        $0ac0148904b4dd9c$var$assertUnfrozen("use", frozen);
        if (value === null || value === undefined) ;
        else if (typeof value === "function") addPlugin(value, ...options);
        else if (typeof value === "object") {
            if (Array.isArray(value)) addList(value);
            else addPreset(value);
        } else throw new TypeError("Expected usable value, not `" + value + "`");
        if (settings) namespace.settings = Object.assign(namespace.settings || {}, settings);
        return processor;
        /**
     * @param {import('..').Pluggable<unknown[]>} value
     * @returns {void}
     */ function add(value) {
            if (typeof value === "function") addPlugin(value);
            else if (typeof value === "object") {
                if (Array.isArray(value)) {
                    const [plugin, ...options] = value;
                    addPlugin(plugin, ...options);
                } else addPreset(value);
            } else throw new TypeError("Expected usable value, not `" + value + "`");
        }
        /**
     * @param {Preset} result
     * @returns {void}
     */ function addPreset(result) {
            addList(result.plugins);
            if (result.settings) settings = Object.assign(settings || {}, result.settings);
        }
        /**
     * @param {PluggableList|null|undefined} [plugins]
     * @returns {void}
     */ function addList(plugins) {
            let index = -1;
            if (plugins === null || plugins === undefined) ;
            else if (Array.isArray(plugins)) while(++index < plugins.length){
                const thing = plugins[index];
                add(thing);
            }
            else throw new TypeError("Expected a list of plugins, not `" + plugins + "`");
        }
        /**
     * @param {Plugin} plugin
     * @param {...unknown} [value]
     * @returns {void}
     */ function addPlugin(plugin, value) {
            let index = -1;
            /** @type {Processor['attachers'][number]|undefined} */ let entry;
            while(++index < attachers.length)if (attachers[index][0] === plugin) {
                entry = attachers[index];
                break;
            }
            if (entry) {
                if ((0, $01cfdf044662e73e$export$2e2bcd8739ae039)(entry[1]) && (0, $01cfdf044662e73e$export$2e2bcd8739ae039)(value)) value = (0, (/*@__PURE__*/$parcel$interopDefault($f1f7ad6914f0e27c$exports)))(true, entry[1], value);
                entry[1] = value;
            } else // @ts-expect-error: fine.
            attachers.push([
                ...arguments
            ]);
        }
    }
    /** @type {Processor['parse']} */ function parse(doc) {
        processor.freeze();
        const file = $0ac0148904b4dd9c$var$vfile(doc);
        const Parser = processor.Parser;
        $0ac0148904b4dd9c$var$assertParser("parse", Parser);
        if ($0ac0148904b4dd9c$var$newable(Parser, "parse")) // @ts-expect-error: `newable` checks this.
        return new Parser(String(file), file).parse();
        // @ts-expect-error: `newable` checks this.
        return Parser(String(file), file) // eslint-disable-line new-cap
        ;
    }
    /** @type {Processor['stringify']} */ function stringify(node, doc) {
        processor.freeze();
        const file = $0ac0148904b4dd9c$var$vfile(doc);
        const Compiler = processor.Compiler;
        $0ac0148904b4dd9c$var$assertCompiler("stringify", Compiler);
        $0ac0148904b4dd9c$var$assertNode(node);
        if ($0ac0148904b4dd9c$var$newable(Compiler, "compile")) // @ts-expect-error: `newable` checks this.
        return new Compiler(node, file).compile();
        // @ts-expect-error: `newable` checks this.
        return Compiler(node, file) // eslint-disable-line new-cap
        ;
    }
    /**
   * @param {Node} node
   * @param {VFileCompatible|RunCallback} [doc]
   * @param {RunCallback} [callback]
   * @returns {Promise<Node>|void}
   */ function run(node, doc, callback) {
        $0ac0148904b4dd9c$var$assertNode(node);
        processor.freeze();
        if (!callback && typeof doc === "function") {
            callback = doc;
            doc = undefined;
        }
        if (!callback) return new Promise(executor);
        executor(null, callback);
        /**
     * @param {null|((node: Node) => void)} resolve
     * @param {(error: Error) => void} reject
     * @returns {void}
     */ function executor(resolve, reject) {
            // @ts-expect-error: `doc` can’t be a callback anymore, we checked.
            transformers.run(node, $0ac0148904b4dd9c$var$vfile(doc), done);
            /**
       * @param {Error|null} error
       * @param {Node} tree
       * @param {VFile} file
       * @returns {void}
       */ function done(error, tree, file) {
                tree = tree || node;
                if (error) reject(error);
                else if (resolve) resolve(tree);
                else // @ts-expect-error: `callback` is defined if `resolve` is not.
                callback(null, tree, file);
            }
        }
    }
    /** @type {Processor['runSync']} */ function runSync(node, file) {
        /** @type {Node|undefined} */ let result;
        /** @type {boolean|undefined} */ let complete;
        processor.run(node, file, done);
        $0ac0148904b4dd9c$var$assertDone("runSync", "run", complete);
        // @ts-expect-error: we either bailed on an error or have a tree.
        return result;
        /**
     * @param {Error|null} [error]
     * @param {Node} [tree]
     * @returns {void}
     */ function done(error, tree) {
            (0, $c193ade91148a4c8$export$dd911e13ecb11e05)(error);
            result = tree;
            complete = true;
        }
    }
    /**
   * @param {VFileCompatible} doc
   * @param {ProcessCallback} [callback]
   * @returns {Promise<VFile>|undefined}
   */ function process(doc, callback) {
        processor.freeze();
        $0ac0148904b4dd9c$var$assertParser("process", processor.Parser);
        $0ac0148904b4dd9c$var$assertCompiler("process", processor.Compiler);
        if (!callback) return new Promise(executor);
        executor(null, callback);
        /**
     * @param {null|((file: VFile) => void)} resolve
     * @param {(error?: Error|null|undefined) => void} reject
     * @returns {void}
     */ function executor(resolve, reject) {
            const file = $0ac0148904b4dd9c$var$vfile(doc);
            processor.run(processor.parse(file), file, (error, tree, file)=>{
                if (error || !tree || !file) done(error);
                else {
                    /** @type {unknown} */ const result = processor.stringify(tree, file);
                    if (result === undefined || result === null) ;
                    else if ($0ac0148904b4dd9c$var$looksLikeAVFileValue(result)) file.value = result;
                    else file.result = result;
                    done(error, file);
                }
            });
            /**
       * @param {Error|null|undefined} [error]
       * @param {VFile|undefined} [file]
       * @returns {void}
       */ function done(error, file) {
                if (error || !file) reject(error);
                else if (resolve) resolve(file);
                else // @ts-expect-error: `callback` is defined if `resolve` is not.
                callback(null, file);
            }
        }
    }
    /** @type {Processor['processSync']} */ function processSync(doc) {
        /** @type {boolean|undefined} */ let complete;
        processor.freeze();
        $0ac0148904b4dd9c$var$assertParser("processSync", processor.Parser);
        $0ac0148904b4dd9c$var$assertCompiler("processSync", processor.Compiler);
        const file = $0ac0148904b4dd9c$var$vfile(doc);
        processor.process(file, done);
        $0ac0148904b4dd9c$var$assertDone("processSync", "process", complete);
        return file;
        /**
     * @param {Error|null|undefined} [error]
     * @returns {void}
     */ function done(error) {
            complete = true;
            (0, $c193ade91148a4c8$export$dd911e13ecb11e05)(error);
        }
    }
}
/**
 * Check if `value` is a constructor.
 *
 * @param {unknown} value
 * @param {string} name
 * @returns {boolean}
 */ function $0ac0148904b4dd9c$var$newable(value, name) {
    return typeof value === "function" && // Prototypes do exist.
    // type-coverage:ignore-next-line
    value.prototype && // A function with keys in its prototype is probably a constructor.
    // Classes’ prototype methods are not enumerable, so we check if some value
    // exists in the prototype.
    // type-coverage:ignore-next-line
    ($0ac0148904b4dd9c$var$keys(value.prototype) || name in value.prototype);
}
/**
 * Check if `value` is an object with keys.
 *
 * @param {Record<string, unknown>} value
 * @returns {boolean}
 */ function $0ac0148904b4dd9c$var$keys(value) {
    /** @type {string} */ let key;
    for(key in value){
        if ($0ac0148904b4dd9c$var$own.call(value, key)) return true;
    }
    return false;
}
/**
 * Assert a parser is available.
 *
 * @param {string} name
 * @param {unknown} value
 * @returns {asserts value is Parser}
 */ function $0ac0148904b4dd9c$var$assertParser(name, value) {
    if (typeof value !== "function") throw new TypeError("Cannot `" + name + "` without `Parser`");
}
/**
 * Assert a compiler is available.
 *
 * @param {string} name
 * @param {unknown} value
 * @returns {asserts value is Compiler}
 */ function $0ac0148904b4dd9c$var$assertCompiler(name, value) {
    if (typeof value !== "function") throw new TypeError("Cannot `" + name + "` without `Compiler`");
}
/**
 * Assert the processor is not frozen.
 *
 * @param {string} name
 * @param {unknown} frozen
 * @returns {asserts frozen is false}
 */ function $0ac0148904b4dd9c$var$assertUnfrozen(name, frozen) {
    if (frozen) throw new Error("Cannot call `" + name + "` on a frozen processor.\nCreate a new processor first, by calling it: use `processor()` instead of `processor`.");
}
/**
 * Assert `node` is a unist node.
 *
 * @param {unknown} node
 * @returns {asserts node is Node}
 */ function $0ac0148904b4dd9c$var$assertNode(node) {
    // `isPlainObj` unfortunately uses `any` instead of `unknown`.
    // type-coverage:ignore-next-line
    if (!(0, $01cfdf044662e73e$export$2e2bcd8739ae039)(node) || typeof node.type !== "string") throw new TypeError("Expected node, got `" + node + "`");
}
/**
 * Assert that `complete` is `true`.
 *
 * @param {string} name
 * @param {string} asyncName
 * @param {unknown} complete
 * @returns {asserts complete is true}
 */ function $0ac0148904b4dd9c$var$assertDone(name, asyncName, complete) {
    if (!complete) throw new Error("`" + name + "` finished async. Use `" + asyncName + "` instead");
}
/**
 * @param {VFileCompatible} [value]
 * @returns {VFile}
 */ function $0ac0148904b4dd9c$var$vfile(value) {
    return $0ac0148904b4dd9c$var$looksLikeAVFile(value) ? value : new (0, $bfee953aeca75867$export$93dff69eb10dc7ce)(value);
}
/**
 * @param {VFileCompatible} [value]
 * @returns {value is VFile}
 */ function $0ac0148904b4dd9c$var$looksLikeAVFile(value) {
    return Boolean(value && typeof value === "object" && "message" in value && "messages" in value);
}
/**
 * @param {unknown} [value]
 * @returns {value is VFileValue}
 */ function $0ac0148904b4dd9c$var$looksLikeAVFileValue(value) {
    return typeof value === "string" || (0, (/*@__PURE__*/$parcel$interopDefault($9b03776ceb792a82$exports)))(value);
}


/**
 * @typedef {import('mdast').Root} Root
 * @typedef {import('mdast-util-from-markdown').Options} Options
 */ /**
 * @typedef {import('micromark-util-types').Encoding} Encoding
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').ParseOptions} ParseOptions
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Value} Value
 *
 * @typedef {import('unist').Parent} UnistParent
 * @typedef {import('unist').Point} Point
 *
 * @typedef {import('mdast').PhrasingContent} PhrasingContent
 * @typedef {import('mdast').StaticPhrasingContent} StaticPhrasingContent
 * @typedef {import('mdast').Content} Content
 * @typedef {import('mdast').Break} Break
 * @typedef {import('mdast').Blockquote} Blockquote
 * @typedef {import('mdast').Code} Code
 * @typedef {import('mdast').Definition} Definition
 * @typedef {import('mdast').Emphasis} Emphasis
 * @typedef {import('mdast').Heading} Heading
 * @typedef {import('mdast').HTML} HTML
 * @typedef {import('mdast').Image} Image
 * @typedef {import('mdast').ImageReference} ImageReference
 * @typedef {import('mdast').InlineCode} InlineCode
 * @typedef {import('mdast').Link} Link
 * @typedef {import('mdast').LinkReference} LinkReference
 * @typedef {import('mdast').List} List
 * @typedef {import('mdast').ListItem} ListItem
 * @typedef {import('mdast').Paragraph} Paragraph
 * @typedef {import('mdast').Root} Root
 * @typedef {import('mdast').Strong} Strong
 * @typedef {import('mdast').Text} Text
 * @typedef {import('mdast').ThematicBreak} ThematicBreak
 * @typedef {import('mdast').ReferenceType} ReferenceType
 * @typedef {import('../index.js').CompileData} CompileData
 */ /**
 * @typedef {Root | Content} Node
 * @typedef {Extract<Node, UnistParent>} Parent
 *
 * @typedef {Omit<UnistParent, 'type' | 'children'> & {type: 'fragment', children: Array<PhrasingContent>}} Fragment
 */ /**
 * @callback Transform
 *   Extra transform, to change the AST afterwards.
 * @param {Root} tree
 *   Tree to transform.
 * @returns {Root | undefined | null | void}
 *   New tree or nothing (in which case the current tree is used).
 *
 * @callback Handle
 *   Handle a token.
 * @param {CompileContext} this
 *   Context.
 * @param {Token} token
 *   Current token.
 * @returns {void}
 *   Nothing.
 *
 * @typedef {Record<string, Handle>} Handles
 *   Token types mapping to handles
 *
 * @callback OnEnterError
 *   Handle the case where the `right` token is open, but it is closed (by the
 *   `left` token) or because we reached the end of the document.
 * @param {Omit<CompileContext, 'sliceSerialize'>} this
 *   Context.
 * @param {Token | undefined} left
 *   Left token.
 * @param {Token} right
 *   Right token.
 * @returns {void}
 *   Nothing.
 *
 * @callback OnExitError
 *   Handle the case where the `right` token is open but it is closed by
 *   exiting the `left` token.
 * @param {Omit<CompileContext, 'sliceSerialize'>} this
 *   Context.
 * @param {Token} left
 *   Left token.
 * @param {Token} right
 *   Right token.
 * @returns {void}
 *   Nothing.
 *
 * @typedef {[Token, OnEnterError | undefined]} TokenTuple
 *   Open token on the stack, with an optional error handler for when
 *   that token isn’t closed properly.
 */ /**
 * @typedef Config
 *   Configuration.
 *
 *   We have our defaults, but extensions will add more.
 * @property {Array<string>} canContainEols
 *   Token types where line endings are used.
 * @property {Handles} enter
 *   Opening handles.
 * @property {Handles} exit
 *   Closing handles.
 * @property {Array<Transform>} transforms
 *   Tree transforms.
 *
 * @typedef {Partial<Config>} Extension
 *   Change how markdown tokens from micromark are turned into mdast.
 *
 * @typedef CompileContext
 *   mdast compiler context.
 * @property {Array<Node | Fragment>} stack
 *   Stack of nodes.
 * @property {Array<TokenTuple>} tokenStack
 *   Stack of tokens.
 * @property {<Key extends keyof CompileData>(key: Key) => CompileData[Key]} getData
 *   Get data from the key/value store.
 * @property {<Key extends keyof CompileData>(key: Key, value?: CompileData[Key]) => void} setData
 *   Set data into the key/value store.
 * @property {(this: CompileContext) => void} buffer
 *   Capture some of the output data.
 * @property {(this: CompileContext) => string} resume
 *   Stop capturing and access the output data.
 * @property {<Kind extends Node>(this: CompileContext, node: Kind, token: Token, onError?: OnEnterError) => Kind} enter
 *   Enter a token.
 * @property {(this: CompileContext, token: Token, onError?: OnExitError) => Node} exit
 *   Exit a token.
 * @property {TokenizeContext['sliceSerialize']} sliceSerialize
 *   Get the string value of a token.
 * @property {Config} config
 *   Configuration.
 *
 * @typedef FromMarkdownOptions
 *   Configuration for how to build mdast.
 * @property {Array<Extension | Array<Extension>> | null | undefined} [mdastExtensions]
 *   Extensions for this utility to change how tokens are turned into a tree.
 *
 * @typedef {ParseOptions & FromMarkdownOptions} Options
 *   Configuration.
 */ // To do: micromark: create a registry of tokens?
// To do: next major: don’t return given `Node` from `enter`.
// To do: next major: remove setter/getter.
/**
 * @typedef {import('mdast').Root|import('mdast').Content} Node
 *
 * @typedef Options
 *   Configuration (optional).
 * @property {boolean | null | undefined} [includeImageAlt=true]
 *   Whether to use `alt` for `image`s.
 * @property {boolean | null | undefined} [includeHtml=true]
 *   Whether to use `value` of HTML.
 */ /** @type {Options} */ const $9213cecfd60df247$var$emptyOptions = {};
function $9213cecfd60df247$export$f84e8e69fd4488a5(value, options) {
    const settings = options || $9213cecfd60df247$var$emptyOptions;
    const includeImageAlt = typeof settings.includeImageAlt === "boolean" ? settings.includeImageAlt : true;
    const includeHtml = typeof settings.includeHtml === "boolean" ? settings.includeHtml : true;
    return $9213cecfd60df247$var$one(value, includeImageAlt, includeHtml);
}
/**
 * One node or several nodes.
 *
 * @param {unknown} value
 *   Thing to serialize.
 * @param {boolean} includeImageAlt
 *   Include image `alt`s.
 * @param {boolean} includeHtml
 *   Include HTML.
 * @returns {string}
 *   Serialized node.
 */ function $9213cecfd60df247$var$one(value, includeImageAlt, includeHtml) {
    if ($9213cecfd60df247$var$node(value)) {
        if ("value" in value) return value.type === "html" && !includeHtml ? "" : value.value;
        if (includeImageAlt && "alt" in value && value.alt) return value.alt;
        if ("children" in value) return $9213cecfd60df247$var$all(value.children, includeImageAlt, includeHtml);
    }
    if (Array.isArray(value)) return $9213cecfd60df247$var$all(value, includeImageAlt, includeHtml);
    return "";
}
/**
 * Serialize a list of nodes.
 *
 * @param {Array<unknown>} values
 *   Thing to serialize.
 * @param {boolean} includeImageAlt
 *   Include image `alt`s.
 * @param {boolean} includeHtml
 *   Include HTML.
 * @returns {string}
 *   Serialized nodes.
 */ function $9213cecfd60df247$var$all(values, includeImageAlt, includeHtml) {
    /** @type {Array<string>} */ const result = [];
    let index = -1;
    while(++index < values.length)result[index] = $9213cecfd60df247$var$one(values[index], includeImageAlt, includeHtml);
    return result.join("");
}
/**
 * Check if `value` looks like a node.
 *
 * @param {unknown} value
 *   Thing.
 * @returns {value is Node}
 *   Whether `value` is a node.
 */ function $9213cecfd60df247$var$node(value) {
    return Boolean(value && typeof value === "object");
}


/**
 * @typedef {import('micromark-util-types').Create} Create
 * @typedef {import('micromark-util-types').FullNormalizedExtension} FullNormalizedExtension
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').ParseContext} ParseContext
 * @typedef {import('micromark-util-types').ParseOptions} ParseOptions
 */ 
/**
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').Initializer} Initializer
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 */ 

const $b17da7b71db961f1$export$a7db06668cad9adb = {
    tokenize: $b17da7b71db961f1$var$initializeContent
};
/**
 * @this {TokenizeContext}
 * @type {Initializer}
 */ function $b17da7b71db961f1$var$initializeContent(effects) {
    const contentStart = effects.attempt(this.parser.constructs.contentInitial, afterContentStartConstruct, paragraphInitial);
    /** @type {Token} */ let previous;
    return contentStart;
    /** @type {State} */ function afterContentStartConstruct(code) {
        if (code === null) {
            effects.consume(code);
            return;
        }
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return (0, $6b1271da345f2eae$export$ae105c1eb063a0a2)(effects, contentStart, "linePrefix");
    }
    /** @type {State} */ function paragraphInitial(code) {
        effects.enter("paragraph");
        return lineStart(code);
    }
    /** @type {State} */ function lineStart(code) {
        const token = effects.enter("chunkText", {
            contentType: "text",
            previous: previous
        });
        if (previous) previous.next = token;
        previous = token;
        return data(code);
    }
    /** @type {State} */ function data(code) {
        if (code === null) {
            effects.exit("chunkText");
            effects.exit("paragraph");
            effects.consume(code);
            return;
        }
        if ((0, $d81ad7e99936a248$export$34a1dff1c0936953)(code)) {
            effects.consume(code);
            effects.exit("chunkText");
            return lineStart;
        }
        // Data.
        effects.consume(code);
        return data;
    }
}


/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').ContainerState} ContainerState
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').Initializer} Initializer
 * @typedef {import('micromark-util-types').Point} Point
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ /**
 * @typedef {[Construct, ContainerState]} StackItem
 */ 


const $1d851c3e054f4ef9$export$5a7bfc01df82fcd1 = {
    tokenize: $1d851c3e054f4ef9$var$initializeDocument
};
/** @type {Construct} */ const $1d851c3e054f4ef9$var$containerConstruct = {
    tokenize: $1d851c3e054f4ef9$var$tokenizeContainer
};
/**
 * @this {TokenizeContext}
 * @type {Initializer}
 */ function $1d851c3e054f4ef9$var$initializeDocument(effects) {
    const self = this;
    /** @type {Array<StackItem>} */ const stack = [];
    let continued = 0;
    /** @type {TokenizeContext | undefined} */ let childFlow;
    /** @type {Token | undefined} */ let childToken;
    /** @type {number} */ let lineStartOffset;
    return start;
    /** @type {State} */ function start(code) {
        // First we iterate through the open blocks, starting with the root
        // document, and descending through last children down to the last open
        // block.
        // Each block imposes a condition that the line must satisfy if the block is
        // to remain open.
        // For example, a block quote requires a `>` character.
        // A paragraph requires a non-blank line.
        // In this phase we may match all or just some of the open blocks.
        // But we cannot close unmatched blocks yet, because we may have a lazy
        // continuation line.
        if (continued < stack.length) {
            const item = stack[continued];
            self.containerState = item[1];
            return effects.attempt(item[0].continuation, documentContinue, checkNewContainers)(code);
        }
        // Done.
        return checkNewContainers(code);
    }
    /** @type {State} */ function documentContinue(code) {
        continued++;
        // Note: this field is called `_closeFlow` but it also closes containers.
        // Perhaps a good idea to rename it but it’s already used in the wild by
        // extensions.
        if (self.containerState._closeFlow) {
            self.containerState._closeFlow = undefined;
            if (childFlow) closeFlow();
            // Note: this algorithm for moving events around is similar to the
            // algorithm when dealing with lazy lines in `writeToChild`.
            const indexBeforeExits = self.events.length;
            let indexBeforeFlow = indexBeforeExits;
            /** @type {Point | undefined} */ let point;
            // Find the flow chunk.
            while(indexBeforeFlow--)if (self.events[indexBeforeFlow][0] === "exit" && self.events[indexBeforeFlow][1].type === "chunkFlow") {
                point = self.events[indexBeforeFlow][1].end;
                break;
            }
            exitContainers(continued);
            // Fix positions.
            let index = indexBeforeExits;
            while(index < self.events.length){
                self.events[index][1].end = Object.assign({}, point);
                index++;
            }
            // Inject the exits earlier (they’re still also at the end).
            (0, $76c325c59203cf92$export$869882364835d202)(self.events, indexBeforeFlow + 1, 0, self.events.slice(indexBeforeExits));
            // Discard the duplicate exits.
            self.events.length = index;
            return checkNewContainers(code);
        }
        return start(code);
    }
    /** @type {State} */ function checkNewContainers(code) {
        // Next, after consuming the continuation markers for existing blocks, we
        // look for new block starts (e.g. `>` for a block quote).
        // If we encounter a new block start, we close any blocks unmatched in
        // step 1 before creating the new block as a child of the last matched
        // block.
        if (continued === stack.length) {
            // No need to `check` whether there’s a container, of `exitContainers`
            // would be moot.
            // We can instead immediately `attempt` to parse one.
            if (!childFlow) return documentContinued(code);
            // If we have concrete content, such as block HTML or fenced code,
            // we can’t have containers “pierce” into them, so we can immediately
            // start.
            if (childFlow.currentConstruct && childFlow.currentConstruct.concrete) return flowStart(code);
            // If we do have flow, it could still be a blank line,
            // but we’d be interrupting it w/ a new container if there’s a current
            // construct.
            // To do: next major: remove `_gfmTableDynamicInterruptHack` (no longer
            // needed in micromark-extension-gfm-table@1.0.6).
            self.interrupt = Boolean(childFlow.currentConstruct && !childFlow._gfmTableDynamicInterruptHack);
        }
        // Check if there is a new container.
        self.containerState = {};
        return effects.check($1d851c3e054f4ef9$var$containerConstruct, thereIsANewContainer, thereIsNoNewContainer)(code);
    }
    /** @type {State} */ function thereIsANewContainer(code) {
        if (childFlow) closeFlow();
        exitContainers(continued);
        return documentContinued(code);
    }
    /** @type {State} */ function thereIsNoNewContainer(code) {
        self.parser.lazy[self.now().line] = continued !== stack.length;
        lineStartOffset = self.now().offset;
        return flowStart(code);
    }
    /** @type {State} */ function documentContinued(code) {
        // Try new containers.
        self.containerState = {};
        return effects.attempt($1d851c3e054f4ef9$var$containerConstruct, containerContinue, flowStart)(code);
    }
    /** @type {State} */ function containerContinue(code) {
        continued++;
        stack.push([
            self.currentConstruct,
            self.containerState
        ]);
        // Try another.
        return documentContinued(code);
    }
    /** @type {State} */ function flowStart(code) {
        if (code === null) {
            if (childFlow) closeFlow();
            exitContainers(0);
            effects.consume(code);
            return;
        }
        childFlow = childFlow || self.parser.flow(self.now());
        effects.enter("chunkFlow", {
            contentType: "flow",
            previous: childToken,
            _tokenizer: childFlow
        });
        return flowContinue(code);
    }
    /** @type {State} */ function flowContinue(code) {
        if (code === null) {
            writeToChild(effects.exit("chunkFlow"), true);
            exitContainers(0);
            effects.consume(code);
            return;
        }
        if ((0, $d81ad7e99936a248$export$34a1dff1c0936953)(code)) {
            effects.consume(code);
            writeToChild(effects.exit("chunkFlow"));
            // Get ready for the next line.
            continued = 0;
            self.interrupt = undefined;
            return start;
        }
        effects.consume(code);
        return flowContinue;
    }
    /**
   * @param {Token} token
   * @param {boolean | undefined} [eof]
   * @returns {void}
   */ function writeToChild(token, eof) {
        const stream = self.sliceStream(token);
        if (eof) stream.push(null);
        token.previous = childToken;
        if (childToken) childToken.next = token;
        childToken = token;
        childFlow.defineSkip(token.start);
        childFlow.write(stream);
        // Alright, so we just added a lazy line:
        //
        // ```markdown
        // > a
        // b.
        //
        // Or:
        //
        // > ~~~c
        // d
        //
        // Or:
        //
        // > | e |
        // f
        // ```
        //
        // The construct in the second example (fenced code) does not accept lazy
        // lines, so it marked itself as done at the end of its first line, and
        // then the content construct parses `d`.
        // Most constructs in markdown match on the first line: if the first line
        // forms a construct, a non-lazy line can’t “unmake” it.
        //
        // The construct in the third example is potentially a GFM table, and
        // those are *weird*.
        // It *could* be a table, from the first line, if the following line
        // matches a condition.
        // In this case, that second line is lazy, which “unmakes” the first line
        // and turns the whole into one content block.
        //
        // We’ve now parsed the non-lazy and the lazy line, and can figure out
        // whether the lazy line started a new flow block.
        // If it did, we exit the current containers between the two flow blocks.
        if (self.parser.lazy[token.start.line]) {
            let index = childFlow.events.length;
            while(index--){
                if (// The token starts before the line ending…
                childFlow.events[index][1].start.offset < lineStartOffset && // …and either is not ended yet…
                (!childFlow.events[index][1].end || // …or ends after it.
                childFlow.events[index][1].end.offset > lineStartOffset)) // Exit: there’s still something open, which means it’s a lazy line
                // part of something.
                return;
            }
            // Note: this algorithm for moving events around is similar to the
            // algorithm when closing flow in `documentContinue`.
            const indexBeforeExits = self.events.length;
            let indexBeforeFlow = indexBeforeExits;
            /** @type {boolean | undefined} */ let seen;
            /** @type {Point | undefined} */ let point;
            // Find the previous chunk (the one before the lazy line).
            while(indexBeforeFlow--)if (self.events[indexBeforeFlow][0] === "exit" && self.events[indexBeforeFlow][1].type === "chunkFlow") {
                if (seen) {
                    point = self.events[indexBeforeFlow][1].end;
                    break;
                }
                seen = true;
            }
            exitContainers(continued);
            // Fix positions.
            index = indexBeforeExits;
            while(index < self.events.length){
                self.events[index][1].end = Object.assign({}, point);
                index++;
            }
            // Inject the exits earlier (they’re still also at the end).
            (0, $76c325c59203cf92$export$869882364835d202)(self.events, indexBeforeFlow + 1, 0, self.events.slice(indexBeforeExits));
            // Discard the duplicate exits.
            self.events.length = index;
        }
    }
    /**
   * @param {number} size
   * @returns {void}
   */ function exitContainers(size) {
        let index = stack.length;
        // Exit open containers.
        while(index-- > size){
            const entry = stack[index];
            self.containerState = entry[1];
            entry[0].exit.call(self, effects);
        }
        stack.length = size;
    }
    function closeFlow() {
        childFlow.write([
            null
        ]);
        childToken = undefined;
        childFlow = undefined;
        self.containerState._closeFlow = undefined;
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $1d851c3e054f4ef9$var$tokenizeContainer(effects, ok, nok) {
    // Always populated by defaults.
    return (0, $6b1271da345f2eae$export$ae105c1eb063a0a2)(effects, effects.attempt(this.parser.constructs.document, ok, nok), "linePrefix", this.parser.constructs.disable.null.includes("codeIndented") ? undefined : 4);
}


/**
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').Initializer} Initializer
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 */ /**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 

/**
 * @typedef {import('micromark-util-types').Chunk} Chunk
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Token} Token
 */ 
function $cdb27b5ff11c315a$export$12949d1dd00fddf4(events) {
    /** @type {Record<string, number>} */ const jumps = {};
    let index = -1;
    /** @type {Event} */ let event;
    /** @type {number | undefined} */ let lineIndex;
    /** @type {number} */ let otherIndex;
    /** @type {Event} */ let otherEvent;
    /** @type {Array<Event>} */ let parameters;
    /** @type {Array<Event>} */ let subevents;
    /** @type {boolean | undefined} */ let more;
    while(++index < events.length){
        while(index in jumps)index = jumps[index];
        event = events[index];
        // Add a hook for the GFM tasklist extension, which needs to know if text
        // is in the first content of a list item.
        if (index && event[1].type === "chunkFlow" && events[index - 1][1].type === "listItemPrefix") {
            subevents = event[1]._tokenizer.events;
            otherIndex = 0;
            if (otherIndex < subevents.length && subevents[otherIndex][1].type === "lineEndingBlank") otherIndex += 2;
            if (otherIndex < subevents.length && subevents[otherIndex][1].type === "content") while(++otherIndex < subevents.length){
                if (subevents[otherIndex][1].type === "content") break;
                if (subevents[otherIndex][1].type === "chunkText") {
                    subevents[otherIndex][1]._isInFirstContentOfListItem = true;
                    otherIndex++;
                }
            }
        }
        // Enter.
        if (event[0] === "enter") {
            if (event[1].contentType) {
                Object.assign(jumps, $cdb27b5ff11c315a$var$subcontent(events, index));
                index = jumps[index];
                more = true;
            }
        } else if (event[1]._container) {
            otherIndex = index;
            lineIndex = undefined;
            while(otherIndex--){
                otherEvent = events[otherIndex];
                if (otherEvent[1].type === "lineEnding" || otherEvent[1].type === "lineEndingBlank") {
                    if (otherEvent[0] === "enter") {
                        if (lineIndex) events[lineIndex][1].type = "lineEndingBlank";
                        otherEvent[1].type = "lineEnding";
                        lineIndex = otherIndex;
                    }
                } else break;
            }
            if (lineIndex) {
                // Fix position.
                event[1].end = Object.assign({}, events[lineIndex][1].start);
                // Switch container exit w/ line endings.
                parameters = events.slice(lineIndex, index);
                parameters.unshift(event);
                (0, $76c325c59203cf92$export$869882364835d202)(events, lineIndex, index - lineIndex + 1, parameters);
            }
        }
    }
    return !more;
}
/**
 * Tokenize embedded tokens.
 *
 * @param {Array<Event>} events
 * @param {number} eventIndex
 * @returns {Record<string, number>}
 */ function $cdb27b5ff11c315a$var$subcontent(events, eventIndex) {
    const token = events[eventIndex][1];
    const context = events[eventIndex][2];
    let startPosition = eventIndex - 1;
    /** @type {Array<number>} */ const startPositions = [];
    const tokenizer = token._tokenizer || context.parser[token.contentType](token.start);
    const childEvents = tokenizer.events;
    /** @type {Array<[number, number]>} */ const jumps = [];
    /** @type {Record<string, number>} */ const gaps = {};
    /** @type {Array<Chunk>} */ let stream;
    /** @type {Token | undefined} */ let previous;
    let index = -1;
    /** @type {Token | undefined} */ let current = token;
    let adjust = 0;
    let start = 0;
    const breaks = [
        start
    ];
    // Loop forward through the linked tokens to pass them in order to the
    // subtokenizer.
    while(current){
        // Find the position of the event for this token.
        while(events[++startPosition][1] !== current);
        startPositions.push(startPosition);
        if (!current._tokenizer) {
            stream = context.sliceStream(current);
            if (!current.next) stream.push(null);
            if (previous) tokenizer.defineSkip(current.start);
            if (current._isInFirstContentOfListItem) tokenizer._gfmTasklistFirstContentOfListItem = true;
            tokenizer.write(stream);
            if (current._isInFirstContentOfListItem) tokenizer._gfmTasklistFirstContentOfListItem = undefined;
        }
        // Unravel the next token.
        previous = current;
        current = current.next;
    }
    // Now, loop back through all events (and linked tokens), to figure out which
    // parts belong where.
    current = token;
    while(++index < childEvents.length)if (// Find a void token that includes a break.
    childEvents[index][0] === "exit" && childEvents[index - 1][0] === "enter" && childEvents[index][1].type === childEvents[index - 1][1].type && childEvents[index][1].start.line !== childEvents[index][1].end.line) {
        start = index + 1;
        breaks.push(start);
        // Help GC.
        current._tokenizer = undefined;
        current.previous = undefined;
        current = current.next;
    }
    // Help GC.
    tokenizer.events = [];
    // If there’s one more token (which is the cases for lines that end in an
    // EOF), that’s perfect: the last point we found starts it.
    // If there isn’t then make sure any remaining content is added to it.
    if (current) {
        // Help GC.
        current._tokenizer = undefined;
        current.previous = undefined;
    } else breaks.pop();
    // Now splice the events from the subtokenizer into the current events,
    // moving back to front so that splice indices aren’t affected.
    index = breaks.length;
    while(index--){
        const slice = childEvents.slice(breaks[index], breaks[index + 1]);
        const start = startPositions.pop();
        jumps.unshift([
            start,
            start + slice.length - 1
        ]);
        (0, $76c325c59203cf92$export$869882364835d202)(events, start, 2, slice);
    }
    index = -1;
    while(++index < jumps.length){
        gaps[adjust + jumps[index][0]] = adjust + jumps[index][1];
        adjust += jumps[index][1] - jumps[index][0] - 1;
    }
    return gaps;
}


const $3b4ae580c8815469$export$a7db06668cad9adb = {
    tokenize: $3b4ae580c8815469$var$tokenizeContent,
    resolve: $3b4ae580c8815469$var$resolveContent
};
/** @type {Construct} */ const $3b4ae580c8815469$var$continuationConstruct = {
    tokenize: $3b4ae580c8815469$var$tokenizeContinuation,
    partial: true
};
/**
 * Content is transparent: it’s parsed right now. That way, definitions are also
 * parsed right now: before text in paragraphs (specifically, media) are parsed.
 *
 * @type {Resolver}
 */ function $3b4ae580c8815469$var$resolveContent(events) {
    (0, $cdb27b5ff11c315a$export$12949d1dd00fddf4)(events);
    return events;
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $3b4ae580c8815469$var$tokenizeContent(effects, ok) {
    /** @type {Token | undefined} */ let previous;
    return chunkStart;
    /**
   * Before a content chunk.
   *
   * ```markdown
   * > | abc
   *     ^
   * ```
   *
   * @type {State}
   */ function chunkStart(code) {
        effects.enter("content");
        previous = effects.enter("chunkContent", {
            contentType: "content"
        });
        return chunkInside(code);
    }
    /**
   * In a content chunk.
   *
   * ```markdown
   * > | abc
   *     ^^^
   * ```
   *
   * @type {State}
   */ function chunkInside(code) {
        if (code === null) return contentEnd(code);
        // To do: in `markdown-rs`, each line is parsed on its own, and everything
        // is stitched together resolving.
        if ((0, $d81ad7e99936a248$export$34a1dff1c0936953)(code)) return effects.check($3b4ae580c8815469$var$continuationConstruct, contentContinue, contentEnd)(code);
        // Data.
        effects.consume(code);
        return chunkInside;
    }
    /**
   *
   *
   * @type {State}
   */ function contentEnd(code) {
        effects.exit("chunkContent");
        effects.exit("content");
        return ok(code);
    }
    /**
   *
   *
   * @type {State}
   */ function contentContinue(code) {
        effects.consume(code);
        effects.exit("chunkContent");
        previous.next = effects.enter("chunkContent", {
            contentType: "content",
            previous: previous
        });
        previous = previous.next;
        return chunkInside;
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $3b4ae580c8815469$var$tokenizeContinuation(effects, ok, nok) {
    const self = this;
    return startLookahead;
    /**
   *
   *
   * @type {State}
   */ function startLookahead(code) {
        effects.exit("chunkContent");
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return (0, $6b1271da345f2eae$export$ae105c1eb063a0a2)(effects, prefixed, "linePrefix");
    }
    /**
   *
   *
   * @type {State}
   */ function prefixed(code) {
        if (code === null || (0, $d81ad7e99936a248$export$34a1dff1c0936953)(code)) return nok(code);
        // Always populated by defaults.
        const tail = self.events[self.events.length - 1];
        if (!self.parser.constructs.disable.null.includes("codeIndented") && tail && tail[1].type === "linePrefix" && tail[2].sliceSerialize(tail[1], true).length >= 4) return ok(code);
        return effects.interrupt(self.parser.constructs.flow, nok, ok)(code);
    }
}




const $ce4f9ce193a3c63d$export$ccc7b0636abaffc3 = {
    tokenize: $ce4f9ce193a3c63d$var$initializeFlow
};
/**
 * @this {TokenizeContext}
 * @type {Initializer}
 */ function $ce4f9ce193a3c63d$var$initializeFlow(effects) {
    const self = this;
    const initial = effects.attempt(// Try to parse a blank line.
    (0, $9a8f432cf07da3bc$export$d50d28ce3ab2a612), atBlankEnding, // Try to parse initial flow (essentially, only code).
    effects.attempt(this.parser.constructs.flowInitial, afterConstruct, (0, $6b1271da345f2eae$export$ae105c1eb063a0a2)(effects, effects.attempt(this.parser.constructs.flow, afterConstruct, effects.attempt((0, $3b4ae580c8815469$export$a7db06668cad9adb), afterConstruct)), "linePrefix")));
    return initial;
    /** @type {State} */ function atBlankEnding(code) {
        if (code === null) {
            effects.consume(code);
            return;
        }
        effects.enter("lineEndingBlank");
        effects.consume(code);
        effects.exit("lineEndingBlank");
        self.currentConstruct = undefined;
        return initial;
    }
    /** @type {State} */ function afterConstruct(code) {
        if (code === null) {
            effects.consume(code);
            return;
        }
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        self.currentConstruct = undefined;
        return initial;
    }
}


/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').Initializer} Initializer
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 */ const $b239fcee5de6bd06$export$50397835cbfdbc24 = {
    resolveAll: $b239fcee5de6bd06$var$createResolver()
};
const $b239fcee5de6bd06$export$22b082955e083ec3 = $b239fcee5de6bd06$var$initializeFactory("string");
const $b239fcee5de6bd06$export$6f093cfa640b7166 = $b239fcee5de6bd06$var$initializeFactory("text");
/**
 * @param {'string' | 'text'} field
 * @returns {InitialConstruct}
 */ function $b239fcee5de6bd06$var$initializeFactory(field) {
    return {
        tokenize: initializeText,
        resolveAll: $b239fcee5de6bd06$var$createResolver(field === "text" ? $b239fcee5de6bd06$var$resolveAllLineSuffixes : undefined)
    };
    /**
   * @this {TokenizeContext}
   * @type {Initializer}
   */ function initializeText(effects) {
        const self = this;
        const constructs = this.parser.constructs[field];
        const text = effects.attempt(constructs, start, notText);
        return start;
        /** @type {State} */ function start(code) {
            return atBreak(code) ? text(code) : notText(code);
        }
        /** @type {State} */ function notText(code) {
            if (code === null) {
                effects.consume(code);
                return;
            }
            effects.enter("data");
            effects.consume(code);
            return data;
        }
        /** @type {State} */ function data(code) {
            if (atBreak(code)) {
                effects.exit("data");
                return text(code);
            }
            // Data.
            effects.consume(code);
            return data;
        }
        /**
     * @param {Code} code
     * @returns {boolean}
     */ function atBreak(code) {
            if (code === null) return true;
            const list = constructs[code];
            let index = -1;
            if (list) // Always populated by defaults.
            while(++index < list.length){
                const item = list[index];
                if (!item.previous || item.previous.call(self, self.previous)) return true;
            }
            return false;
        }
    }
}
/**
 * @param {Resolver | undefined} [extraResolver]
 * @returns {Resolver}
 */ function $b239fcee5de6bd06$var$createResolver(extraResolver) {
    return resolveAllText;
    /** @type {Resolver} */ function resolveAllText(events, context) {
        let index = -1;
        /** @type {number | undefined} */ let enter;
        // A rather boring computation (to merge adjacent `data` events) which
        // improves mm performance by 29%.
        while(++index <= events.length){
            if (enter === undefined) {
                if (events[index] && events[index][1].type === "data") {
                    enter = index;
                    index++;
                }
            } else if (!events[index] || events[index][1].type !== "data") {
                // Don’t do anything if there is one data token.
                if (index !== enter + 2) {
                    events[enter][1].end = events[index - 1][1].end;
                    events.splice(enter + 2, index - enter - 2);
                    index = enter + 2;
                }
                enter = undefined;
            }
        }
        return extraResolver ? extraResolver(events, context) : events;
    }
}
/**
 * A rather ugly set of instructions which again looks at chunks in the input
 * stream.
 * The reason to do this here is that it is *much* faster to parse in reverse.
 * And that we can’t hook into `null` to split the line suffix before an EOF.
 * To do: figure out if we can make this into a clean utility, or even in core.
 * As it will be useful for GFMs literal autolink extension (and maybe even
 * tables?)
 *
 * @type {Resolver}
 */ function $b239fcee5de6bd06$var$resolveAllLineSuffixes(events, context) {
    let eventIndex = 0 // Skip first.
    ;
    while(++eventIndex <= events.length)if ((eventIndex === events.length || events[eventIndex][1].type === "lineEnding") && events[eventIndex - 1][1].type === "data") {
        const data = events[eventIndex - 1][1];
        const chunks = context.sliceStream(data);
        let index = chunks.length;
        let bufferIndex = -1;
        let size = 0;
        /** @type {boolean | undefined} */ let tabs;
        while(index--){
            const chunk = chunks[index];
            if (typeof chunk === "string") {
                bufferIndex = chunk.length;
                while(chunk.charCodeAt(bufferIndex - 1) === 32){
                    size++;
                    bufferIndex--;
                }
                if (bufferIndex) break;
                bufferIndex = -1;
            } else if (chunk === -2) {
                tabs = true;
                size++;
            } else if (chunk === -1) ;
            else {
                // Replacement character, exit.
                index++;
                break;
            }
        }
        if (size) {
            const token = {
                type: eventIndex === events.length || tabs || size < 2 ? "lineSuffix" : "hardBreakTrailing",
                start: {
                    line: data.end.line,
                    column: data.end.column - size,
                    offset: data.end.offset - size,
                    _index: data.start._index + index,
                    _bufferIndex: index ? bufferIndex : data.start._bufferIndex + bufferIndex
                },
                end: Object.assign({}, data.end)
            };
            data.end = Object.assign({}, token.start);
            if (data.start.offset === data.end.offset) Object.assign(data, token);
            else {
                events.splice(eventIndex, 0, [
                    "enter",
                    token,
                    context
                ], [
                    "exit",
                    token,
                    context
                ]);
                eventIndex += 2;
            }
        }
        eventIndex++;
    }
    return events;
}


/**
 * @typedef {import('micromark-util-types').Chunk} Chunk
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').ConstructRecord} ConstructRecord
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').ParseContext} ParseContext
 * @typedef {import('micromark-util-types').Point} Point
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenType} TokenType
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 */ /**
 * @callback Restore
 * @returns {void}
 *
 * @typedef Info
 * @property {Restore} restore
 * @property {number} from
 *
 * @callback ReturnHandle
 *   Handle a successful run.
 * @param {Construct} construct
 * @param {Info} info
 * @returns {void}
 */ 


function $a1fbefe644618fda$export$ae34f10ee4b29837(parser, initialize, from) {
    /** @type {Point} */ let point = Object.assign(from ? Object.assign({}, from) : {
        line: 1,
        column: 1,
        offset: 0
    }, {
        _index: 0,
        _bufferIndex: -1
    });
    /** @type {Record<string, number>} */ const columnStart = {};
    /** @type {Array<Construct>} */ const resolveAllConstructs = [];
    /** @type {Array<Chunk>} */ let chunks = [];
    /** @type {Array<Token>} */ let stack = [];
    /** @type {boolean | undefined} */ let consumed = true;
    /**
   * Tools used for tokenizing.
   *
   * @type {Effects}
   */ const effects = {
        consume: consume,
        enter: enter,
        exit: exit,
        attempt: constructFactory(onsuccessfulconstruct),
        check: constructFactory(onsuccessfulcheck),
        interrupt: constructFactory(onsuccessfulcheck, {
            interrupt: true
        })
    };
    /**
   * State and tools for resolving and serializing.
   *
   * @type {TokenizeContext}
   */ const context = {
        previous: null,
        code: null,
        containerState: {},
        events: [],
        parser: parser,
        sliceStream: sliceStream,
        sliceSerialize: sliceSerialize,
        now: now,
        defineSkip: defineSkip,
        write: write
    };
    /**
   * The state function.
   *
   * @type {State | void}
   */ let state = initialize.tokenize.call(context, effects);
    /**
   * Track which character we expect to be consumed, to catch bugs.
   *
   * @type {Code}
   */ let expectedCode;
    if (initialize.resolveAll) resolveAllConstructs.push(initialize);
    return context;
    /** @type {TokenizeContext['write']} */ function write(slice) {
        chunks = (0, $76c325c59203cf92$export$4cbf152802aa238)(chunks, slice);
        main();
        // Exit if we’re not done, resolve might change stuff.
        if (chunks[chunks.length - 1] !== null) return [];
        addResult(initialize, 0);
        // Otherwise, resolve, and exit.
        context.events = (0, $8c627d7d8981f0bc$export$3ff61ec196ff408b)(resolveAllConstructs, context.events, context);
        return context.events;
    }
    //
    // Tools.
    //
    /** @type {TokenizeContext['sliceSerialize']} */ function sliceSerialize(token, expandTabs) {
        return $a1fbefe644618fda$var$serializeChunks(sliceStream(token), expandTabs);
    }
    /** @type {TokenizeContext['sliceStream']} */ function sliceStream(token) {
        return $a1fbefe644618fda$var$sliceChunks(chunks, token);
    }
    /** @type {TokenizeContext['now']} */ function now() {
        // This is a hot path, so we clone manually instead of `Object.assign({}, point)`
        const { line: line, column: column, offset: offset, _index: _index, _bufferIndex: _bufferIndex } = point;
        return {
            line: line,
            column: column,
            offset: offset,
            _index: _index,
            _bufferIndex: _bufferIndex
        };
    }
    /** @type {TokenizeContext['defineSkip']} */ function defineSkip(value) {
        columnStart[value.line] = value.column;
        accountForPotentialSkip();
    }
    //
    // State management.
    //
    /**
   * Main loop (note that `_index` and `_bufferIndex` in `point` are modified by
   * `consume`).
   * Here is where we walk through the chunks, which either include strings of
   * several characters, or numerical character codes.
   * The reason to do this in a loop instead of a call is so the stack can
   * drain.
   *
   * @returns {void}
   */ function main() {
        /** @type {number} */ let chunkIndex;
        while(point._index < chunks.length){
            const chunk = chunks[point._index];
            // If we’re in a buffer chunk, loop through it.
            if (typeof chunk === "string") {
                chunkIndex = point._index;
                if (point._bufferIndex < 0) point._bufferIndex = 0;
                while(point._index === chunkIndex && point._bufferIndex < chunk.length)go(chunk.charCodeAt(point._bufferIndex));
            } else go(chunk);
        }
    }
    /**
   * Deal with one code.
   *
   * @param {Code} code
   * @returns {void}
   */ function go(code) {
        consumed = undefined;
        expectedCode = code;
        state = state(code);
    }
    /** @type {Effects['consume']} */ function consume(code) {
        if ((0, $d81ad7e99936a248$export$34a1dff1c0936953)(code)) {
            point.line++;
            point.column = 1;
            point.offset += code === -3 ? 2 : 1;
            accountForPotentialSkip();
        } else if (code !== -1) {
            point.column++;
            point.offset++;
        }
        // Not in a string chunk.
        if (point._bufferIndex < 0) point._index++;
        else {
            point._bufferIndex++;
            // At end of string chunk.
            // @ts-expect-error Points w/ non-negative `_bufferIndex` reference
            // strings.
            if (point._bufferIndex === chunks[point._index].length) {
                point._bufferIndex = -1;
                point._index++;
            }
        }
        // Expose the previous character.
        context.previous = code;
        // Mark as consumed.
        consumed = true;
    }
    /** @type {Effects['enter']} */ function enter(type, fields) {
        /** @type {Token} */ // @ts-expect-error Patch instead of assign required fields to help GC.
        const token = fields || {};
        token.type = type;
        token.start = now();
        context.events.push([
            "enter",
            token,
            context
        ]);
        stack.push(token);
        return token;
    }
    /** @type {Effects['exit']} */ function exit(type) {
        const token = stack.pop();
        token.end = now();
        context.events.push([
            "exit",
            token,
            context
        ]);
        return token;
    }
    /**
   * Use results.
   *
   * @type {ReturnHandle}
   */ function onsuccessfulconstruct(construct, info) {
        addResult(construct, info.from);
    }
    /**
   * Discard results.
   *
   * @type {ReturnHandle}
   */ function onsuccessfulcheck(_, info) {
        info.restore();
    }
    /**
   * Factory to attempt/check/interrupt.
   *
   * @param {ReturnHandle} onreturn
   * @param {{interrupt?: boolean | undefined} | undefined} [fields]
   */ function constructFactory(onreturn, fields) {
        return hook;
        /**
     * Handle either an object mapping codes to constructs, a list of
     * constructs, or a single construct.
     *
     * @param {Array<Construct> | Construct | ConstructRecord} constructs
     * @param {State} returnState
     * @param {State | undefined} [bogusState]
     * @returns {State}
     */ function hook(constructs, returnState, bogusState) {
            /** @type {Array<Construct>} */ let listOfConstructs;
            /** @type {number} */ let constructIndex;
            /** @type {Construct} */ let currentConstruct;
            /** @type {Info} */ let info;
            return Array.isArray(constructs) ? handleListOfConstructs(constructs) : "tokenize" in constructs ? handleListOfConstructs([
                constructs
            ]) : handleMapOfConstructs(constructs);
            /**
       * Handle a list of construct.
       *
       * @param {ConstructRecord} map
       * @returns {State}
       */ function handleMapOfConstructs(map) {
                return start;
                /** @type {State} */ function start(code) {
                    const def = code !== null && map[code];
                    const all = code !== null && map.null;
                    const list = [
                        // To do: add more extension tests.
                        /* c8 ignore next 2 */ ...Array.isArray(def) ? def : def ? [
                            def
                        ] : [],
                        ...Array.isArray(all) ? all : all ? [
                            all
                        ] : []
                    ];
                    return handleListOfConstructs(list)(code);
                }
            }
            /**
       * Handle a list of construct.
       *
       * @param {Array<Construct>} list
       * @returns {State}
       */ function handleListOfConstructs(list) {
                listOfConstructs = list;
                constructIndex = 0;
                if (list.length === 0) return bogusState;
                return handleConstruct(list[constructIndex]);
            }
            /**
       * Handle a single construct.
       *
       * @param {Construct} construct
       * @returns {State}
       */ function handleConstruct(construct) {
                return start;
                /** @type {State} */ function start(code) {
                    // To do: not needed to store if there is no bogus state, probably?
                    // Currently doesn’t work because `inspect` in document does a check
                    // w/o a bogus, which doesn’t make sense. But it does seem to help perf
                    // by not storing.
                    info = store();
                    currentConstruct = construct;
                    if (!construct.partial) context.currentConstruct = construct;
                    // Always populated by defaults.
                    if (construct.name && context.parser.constructs.disable.null.includes(construct.name)) return nok(code);
                    return construct.tokenize.call(// If we do have fields, create an object w/ `context` as its
                    // prototype.
                    // This allows a “live binding”, which is needed for `interrupt`.
                    fields ? Object.assign(Object.create(context), fields) : context, effects, ok, nok)(code);
                }
            }
            /** @type {State} */ function ok(code) {
                consumed = true;
                onreturn(currentConstruct, info);
                return returnState;
            }
            /** @type {State} */ function nok(code) {
                consumed = true;
                info.restore();
                if (++constructIndex < listOfConstructs.length) return handleConstruct(listOfConstructs[constructIndex]);
                return bogusState;
            }
        }
    }
    /**
   * @param {Construct} construct
   * @param {number} from
   * @returns {void}
   */ function addResult(construct, from) {
        if (construct.resolveAll && !resolveAllConstructs.includes(construct)) resolveAllConstructs.push(construct);
        if (construct.resolve) (0, $76c325c59203cf92$export$869882364835d202)(context.events, from, context.events.length - from, construct.resolve(context.events.slice(from), context));
        if (construct.resolveTo) context.events = construct.resolveTo(context.events, context);
    }
    /**
   * Store state.
   *
   * @returns {Info}
   */ function store() {
        const startPoint = now();
        const startPrevious = context.previous;
        const startCurrentConstruct = context.currentConstruct;
        const startEventsIndex = context.events.length;
        const startStack = Array.from(stack);
        return {
            restore: restore,
            from: startEventsIndex
        };
        /**
     * Restore state.
     *
     * @returns {void}
     */ function restore() {
            point = startPoint;
            context.previous = startPrevious;
            context.currentConstruct = startCurrentConstruct;
            context.events.length = startEventsIndex;
            stack = startStack;
            accountForPotentialSkip();
        }
    }
    /**
   * Move the current point a bit forward in the line when it’s on a column
   * skip.
   *
   * @returns {void}
   */ function accountForPotentialSkip() {
        if (point.line in columnStart && point.column < 2) {
            point.column = columnStart[point.line];
            point.offset += columnStart[point.line] - 1;
        }
    }
}
/**
 * Get the chunks from a slice of chunks in the range of a token.
 *
 * @param {Array<Chunk>} chunks
 * @param {Pick<Token, 'end' | 'start'>} token
 * @returns {Array<Chunk>}
 */ function $a1fbefe644618fda$var$sliceChunks(chunks, token) {
    const startIndex = token.start._index;
    const startBufferIndex = token.start._bufferIndex;
    const endIndex = token.end._index;
    const endBufferIndex = token.end._bufferIndex;
    /** @type {Array<Chunk>} */ let view;
    if (startIndex === endIndex) // @ts-expect-error `_bufferIndex` is used on string chunks.
    view = [
        chunks[startIndex].slice(startBufferIndex, endBufferIndex)
    ];
    else {
        view = chunks.slice(startIndex, endIndex);
        if (startBufferIndex > -1) {
            const head = view[0];
            if (typeof head === "string") view[0] = head.slice(startBufferIndex);
            else view.shift();
        }
        if (endBufferIndex > 0) // @ts-expect-error `_bufferIndex` is used on string chunks.
        view.push(chunks[endIndex].slice(0, endBufferIndex));
    }
    return view;
}
/**
 * Get the string value of a slice of chunks.
 *
 * @param {Array<Chunk>} chunks
 * @param {boolean | undefined} [expandTabs=false]
 * @returns {string}
 */ function $a1fbefe644618fda$var$serializeChunks(chunks, expandTabs) {
    let index = -1;
    /** @type {Array<string>} */ const result = [];
    /** @type {boolean | undefined} */ let atTab;
    while(++index < chunks.length){
        const chunk = chunks[index];
        /** @type {string} */ let value;
        if (typeof chunk === "string") value = chunk;
        else switch(chunk){
            case -5:
                value = "\r";
                break;
            case -4:
                value = "\n";
                break;
            case -3:
                value = "\r\n";
                break;
            case -2:
                value = expandTabs ? " " : "	";
                break;
            case -1:
                if (!expandTabs && atTab) continue;
                value = " ";
                break;
            default:
                // Currently only replacement character.
                value = String.fromCharCode(chunk);
        }
        atTab = chunk === -2;
        result.push(value);
    }
    return result.join("");
}


var $1090fe39f413abf4$exports = {};

$parcel$export($1090fe39f413abf4$exports, "document", function () { return $1090fe39f413abf4$export$5a7bfc01df82fcd1; });
$parcel$export($1090fe39f413abf4$exports, "contentInitial", function () { return $1090fe39f413abf4$export$5a2181fb44b58173; });
$parcel$export($1090fe39f413abf4$exports, "flowInitial", function () { return $1090fe39f413abf4$export$cf8bead395eff824; });
$parcel$export($1090fe39f413abf4$exports, "flow", function () { return $1090fe39f413abf4$export$ccc7b0636abaffc3; });
$parcel$export($1090fe39f413abf4$exports, "string", function () { return $1090fe39f413abf4$export$22b082955e083ec3; });
$parcel$export($1090fe39f413abf4$exports, "text", function () { return $1090fe39f413abf4$export$6f093cfa640b7166; });
$parcel$export($1090fe39f413abf4$exports, "insideSpan", function () { return $1090fe39f413abf4$export$d44f260a3f9b69f5; });
$parcel$export($1090fe39f413abf4$exports, "attentionMarkers", function () { return $1090fe39f413abf4$export$b9c0b60d74426aea; });
$parcel$export($1090fe39f413abf4$exports, "disable", function () { return $1090fe39f413abf4$export$e20fbacbb41798b; });
/**
 * @typedef {import('micromark-util-types').Extension} Extension
 */ /**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Point} Point
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 


const $ce367f8ac9c782b1$export$45b92471da762af7 = {
    name: "attention",
    tokenize: $ce367f8ac9c782b1$var$tokenizeAttention,
    resolveAll: $ce367f8ac9c782b1$var$resolveAllAttention
};
/**
 * Take all events and resolve attention to emphasis or strong.
 *
 * @type {Resolver}
 */ function $ce367f8ac9c782b1$var$resolveAllAttention(events, context) {
    let index = -1;
    /** @type {number} */ let open;
    /** @type {Token} */ let group;
    /** @type {Token} */ let text;
    /** @type {Token} */ let openingSequence;
    /** @type {Token} */ let closingSequence;
    /** @type {number} */ let use;
    /** @type {Array<Event>} */ let nextEvents;
    /** @type {number} */ let offset;
    // Walk through all events.
    //
    // Note: performance of this is fine on an mb of normal markdown, but it’s
    // a bottleneck for malicious stuff.
    while(++index < events.length)// Find a token that can close.
    if (events[index][0] === "enter" && events[index][1].type === "attentionSequence" && events[index][1]._close) {
        open = index;
        // Now walk back to find an opener.
        while(open--)// Find a token that can open the closer.
        if (events[open][0] === "exit" && events[open][1].type === "attentionSequence" && events[open][1]._open && // If the markers are the same:
        context.sliceSerialize(events[open][1]).charCodeAt(0) === context.sliceSerialize(events[index][1]).charCodeAt(0)) {
            // If the opening can close or the closing can open,
            // and the close size *is not* a multiple of three,
            // but the sum of the opening and closing size *is* multiple of three,
            // then don’t match.
            if ((events[open][1]._close || events[index][1]._open) && (events[index][1].end.offset - events[index][1].start.offset) % 3 && !((events[open][1].end.offset - events[open][1].start.offset + events[index][1].end.offset - events[index][1].start.offset) % 3)) continue;
            // Number of markers to use from the sequence.
            use = events[open][1].end.offset - events[open][1].start.offset > 1 && events[index][1].end.offset - events[index][1].start.offset > 1 ? 2 : 1;
            const start = Object.assign({}, events[open][1].end);
            const end = Object.assign({}, events[index][1].start);
            $ce367f8ac9c782b1$var$movePoint(start, -use);
            $ce367f8ac9c782b1$var$movePoint(end, use);
            openingSequence = {
                type: use > 1 ? "strongSequence" : "emphasisSequence",
                start: start,
                end: Object.assign({}, events[open][1].end)
            };
            closingSequence = {
                type: use > 1 ? "strongSequence" : "emphasisSequence",
                start: Object.assign({}, events[index][1].start),
                end: end
            };
            text = {
                type: use > 1 ? "strongText" : "emphasisText",
                start: Object.assign({}, events[open][1].end),
                end: Object.assign({}, events[index][1].start)
            };
            group = {
                type: use > 1 ? "strong" : "emphasis",
                start: Object.assign({}, openingSequence.start),
                end: Object.assign({}, closingSequence.end)
            };
            events[open][1].end = Object.assign({}, openingSequence.start);
            events[index][1].start = Object.assign({}, closingSequence.end);
            nextEvents = [];
            // If there are more markers in the opening, add them before.
            if (events[open][1].end.offset - events[open][1].start.offset) nextEvents = (0, $76c325c59203cf92$export$4cbf152802aa238)(nextEvents, [
                [
                    "enter",
                    events[open][1],
                    context
                ],
                [
                    "exit",
                    events[open][1],
                    context
                ]
            ]);
            // Opening.
            nextEvents = (0, $76c325c59203cf92$export$4cbf152802aa238)(nextEvents, [
                [
                    "enter",
                    group,
                    context
                ],
                [
                    "enter",
                    openingSequence,
                    context
                ],
                [
                    "exit",
                    openingSequence,
                    context
                ],
                [
                    "enter",
                    text,
                    context
                ]
            ]);
            // Always populated by defaults.
            // Between.
            nextEvents = (0, $76c325c59203cf92$export$4cbf152802aa238)(nextEvents, (0, $8c627d7d8981f0bc$export$3ff61ec196ff408b)(context.parser.constructs.insideSpan.null, events.slice(open + 1, index), context));
            // Closing.
            nextEvents = (0, $76c325c59203cf92$export$4cbf152802aa238)(nextEvents, [
                [
                    "exit",
                    text,
                    context
                ],
                [
                    "enter",
                    closingSequence,
                    context
                ],
                [
                    "exit",
                    closingSequence,
                    context
                ],
                [
                    "exit",
                    group,
                    context
                ]
            ]);
            // If there are more markers in the closing, add them after.
            if (events[index][1].end.offset - events[index][1].start.offset) {
                offset = 2;
                nextEvents = (0, $76c325c59203cf92$export$4cbf152802aa238)(nextEvents, [
                    [
                        "enter",
                        events[index][1],
                        context
                    ],
                    [
                        "exit",
                        events[index][1],
                        context
                    ]
                ]);
            } else offset = 0;
            (0, $76c325c59203cf92$export$869882364835d202)(events, open - 1, index - open + 3, nextEvents);
            index = open + nextEvents.length - offset - 2;
            break;
        }
    }
    // Remove remaining sequences.
    index = -1;
    while(++index < events.length)if (events[index][1].type === "attentionSequence") events[index][1].type = "data";
    return events;
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $ce367f8ac9c782b1$var$tokenizeAttention(effects, ok) {
    const attentionMarkers = this.parser.constructs.attentionMarkers.null;
    const previous = this.previous;
    const before = (0, $9e0904f98da5bb5d$export$e3902bc0d835cad0)(previous);
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /**
   * Before a sequence.
   *
   * ```markdown
   * > | **
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        marker = code;
        effects.enter("attentionSequence");
        return inside(code);
    }
    /**
   * In a sequence.
   *
   * ```markdown
   * > | **
   *     ^^
   * ```
   *
   * @type {State}
   */ function inside(code) {
        if (code === marker) {
            effects.consume(code);
            return inside;
        }
        const token = effects.exit("attentionSequence");
        // To do: next major: move this to resolver, just like `markdown-rs`.
        const after = (0, $9e0904f98da5bb5d$export$e3902bc0d835cad0)(code);
        // Always populated by defaults.
        const open = !after || after === 2 && before || attentionMarkers.includes(code);
        const close = !before || before === 2 && after || attentionMarkers.includes(previous);
        token._open = Boolean(marker === 42 ? open : open && (before || !close));
        token._close = Boolean(marker === 42 ? close : close && (after || !open));
        return ok(code);
    }
}
/**
 * Move a point a bit.
 *
 * Note: `move` only works inside lines! It’s not possible to move past other
 * chunks (replacement characters, tabs, or line endings).
 *
 * @param {Point} point
 * @param {number} offset
 * @returns {void}
 */ function $ce367f8ac9c782b1$var$movePoint(point, offset) {
    point.column += offset;
    point.offset += offset;
    point._bufferIndex += offset;
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
const $7be1ff4bb2d3c2bf$export$17ddf85e4c916ad6 = {
    name: "autolink",
    tokenize: $7be1ff4bb2d3c2bf$var$tokenizeAutolink
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $7be1ff4bb2d3c2bf$var$tokenizeAutolink(effects, ok, nok) {
    let size = 0;
    return start;
    /**
   * Start of an autolink.
   *
   * ```markdown
   * > | a<https://example.com>b
   *      ^
   * > | a<user@example.com>b
   *      ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("autolink");
        effects.enter("autolinkMarker");
        effects.consume(code);
        effects.exit("autolinkMarker");
        effects.enter("autolinkProtocol");
        return open;
    }
    /**
   * After `<`, at protocol or atext.
   *
   * ```markdown
   * > | a<https://example.com>b
   *       ^
   * > | a<user@example.com>b
   *       ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if ((0, $d81ad7e99936a248$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return schemeOrEmailAtext;
        }
        return emailAtext(code);
    }
    /**
   * At second byte of protocol or atext.
   *
   * ```markdown
   * > | a<https://example.com>b
   *        ^
   * > | a<user@example.com>b
   *        ^
   * ```
   *
   * @type {State}
   */ function schemeOrEmailAtext(code) {
        // ASCII alphanumeric and `+`, `-`, and `.`.
        if (code === 43 || code === 45 || code === 46 || (0, $d81ad7e99936a248$export$75c76db11865a9f4)(code)) {
            // Count the previous alphabetical from `open` too.
            size = 1;
            return schemeInsideOrEmailAtext(code);
        }
        return emailAtext(code);
    }
    /**
   * In ambiguous protocol or atext.
   *
   * ```markdown
   * > | a<https://example.com>b
   *        ^
   * > | a<user@example.com>b
   *        ^
   * ```
   *
   * @type {State}
   */ function schemeInsideOrEmailAtext(code) {
        if (code === 58) {
            effects.consume(code);
            size = 0;
            return urlInside;
        }
        // ASCII alphanumeric and `+`, `-`, and `.`.
        if ((code === 43 || code === 45 || code === 46 || (0, $d81ad7e99936a248$export$75c76db11865a9f4)(code)) && size++ < 32) {
            effects.consume(code);
            return schemeInsideOrEmailAtext;
        }
        size = 0;
        return emailAtext(code);
    }
    /**
   * After protocol, in URL.
   *
   * ```markdown
   * > | a<https://example.com>b
   *             ^
   * ```
   *
   * @type {State}
   */ function urlInside(code) {
        if (code === 62) {
            effects.exit("autolinkProtocol");
            effects.enter("autolinkMarker");
            effects.consume(code);
            effects.exit("autolinkMarker");
            effects.exit("autolink");
            return ok;
        }
        // ASCII control, space, or `<`.
        if (code === null || code === 32 || code === 60 || (0, $d81ad7e99936a248$export$67dbf494fc8394df)(code)) return nok(code);
        effects.consume(code);
        return urlInside;
    }
    /**
   * In email atext.
   *
   * ```markdown
   * > | a<user.name@example.com>b
   *              ^
   * ```
   *
   * @type {State}
   */ function emailAtext(code) {
        if (code === 64) {
            effects.consume(code);
            return emailAtSignOrDot;
        }
        if ((0, $d81ad7e99936a248$export$4397998b34fe597d)(code)) {
            effects.consume(code);
            return emailAtext;
        }
        return nok(code);
    }
    /**
   * In label, after at-sign or dot.
   *
   * ```markdown
   * > | a<user.name@example.com>b
   *                 ^       ^
   * ```
   *
   * @type {State}
   */ function emailAtSignOrDot(code) {
        return (0, $d81ad7e99936a248$export$75c76db11865a9f4)(code) ? emailLabel(code) : nok(code);
    }
    /**
   * In label, where `.` and `>` are allowed.
   *
   * ```markdown
   * > | a<user.name@example.com>b
   *                   ^
   * ```
   *
   * @type {State}
   */ function emailLabel(code) {
        if (code === 46) {
            effects.consume(code);
            size = 0;
            return emailAtSignOrDot;
        }
        if (code === 62) {
            // Exit, then change the token type.
            effects.exit("autolinkProtocol").type = "autolinkEmail";
            effects.enter("autolinkMarker");
            effects.consume(code);
            effects.exit("autolinkMarker");
            effects.exit("autolink");
            return ok;
        }
        return emailValue(code);
    }
    /**
   * In label, where `.` and `>` are *not* allowed.
   *
   * Though, this is also used in `emailLabel` to parse other values.
   *
   * ```markdown
   * > | a<user.name@ex-ample.com>b
   *                    ^
   * ```
   *
   * @type {State}
   */ function emailValue(code) {
        // ASCII alphanumeric or `-`.
        if ((code === 45 || (0, $d81ad7e99936a248$export$75c76db11865a9f4)(code)) && size++ < 63) {
            const next = code === 45 ? emailValue : emailLabel;
            effects.consume(code);
            return next;
        }
        return nok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Exiter} Exiter
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 

const $900bbb622fb7b735$export$200dcd0a5903c968 = {
    name: "blockQuote",
    tokenize: $900bbb622fb7b735$var$tokenizeBlockQuoteStart,
    continuation: {
        tokenize: $900bbb622fb7b735$var$tokenizeBlockQuoteContinuation
    },
    exit: $900bbb622fb7b735$var$exit
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $900bbb622fb7b735$var$tokenizeBlockQuoteStart(effects, ok, nok) {
    const self = this;
    return start;
    /**
   * Start of block quote.
   *
   * ```markdown
   * > | > a
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        if (code === 62) {
            const state = self.containerState;
            if (!state.open) {
                effects.enter("blockQuote", {
                    _container: true
                });
                state.open = true;
            }
            effects.enter("blockQuotePrefix");
            effects.enter("blockQuoteMarker");
            effects.consume(code);
            effects.exit("blockQuoteMarker");
            return after;
        }
        return nok(code);
    }
    /**
   * After `>`, before optional whitespace.
   *
   * ```markdown
   * > | > a
   *      ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        if ((0, $d81ad7e99936a248$export$2c6cf65c1127992a)(code)) {
            effects.enter("blockQuotePrefixWhitespace");
            effects.consume(code);
            effects.exit("blockQuotePrefixWhitespace");
            effects.exit("blockQuotePrefix");
            return ok;
        }
        effects.exit("blockQuotePrefix");
        return ok(code);
    }
}
/**
 * Start of block quote continuation.
 *
 * ```markdown
 *   | > a
 * > | > b
 *     ^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $900bbb622fb7b735$var$tokenizeBlockQuoteContinuation(effects, ok, nok) {
    const self = this;
    return contStart;
    /**
   * Start of block quote continuation.
   *
   * Also used to parse the first block quote opening.
   *
   * ```markdown
   *   | > a
   * > | > b
   *     ^
   * ```
   *
   * @type {State}
   */ function contStart(code) {
        if ((0, $d81ad7e99936a248$export$2c6cf65c1127992a)(code)) // Always populated by defaults.
        return (0, $6b1271da345f2eae$export$ae105c1eb063a0a2)(effects, contBefore, "linePrefix", self.parser.constructs.disable.null.includes("codeIndented") ? undefined : 4)(code);
        return contBefore(code);
    }
    /**
   * At `>`, after optional whitespace.
   *
   * Also used to parse the first block quote opening.
   *
   * ```markdown
   *   | > a
   * > | > b
   *     ^
   * ```
   *
   * @type {State}
   */ function contBefore(code) {
        return effects.attempt($900bbb622fb7b735$export$200dcd0a5903c968, ok, nok)(code);
    }
}
/** @type {Exiter} */ function $900bbb622fb7b735$var$exit(effects) {
    effects.exit("blockQuote");
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
const $26b6f01e555220c8$export$2005478564e78d96 = {
    name: "characterEscape",
    tokenize: $26b6f01e555220c8$var$tokenizeCharacterEscape
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $26b6f01e555220c8$var$tokenizeCharacterEscape(effects, ok, nok) {
    return start;
    /**
   * Start of character escape.
   *
   * ```markdown
   * > | a\*b
   *      ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("characterEscape");
        effects.enter("escapeMarker");
        effects.consume(code);
        effects.exit("escapeMarker");
        return inside;
    }
    /**
   * After `\`, at punctuation.
   *
   * ```markdown
   * > | a\*b
   *       ^
   * ```
   *
   * @type {State}
   */ function inside(code) {
        // ASCII punctuation.
        if ((0, $d81ad7e99936a248$export$35794a7d1db99380)(code)) {
            effects.enter("characterEscapeValue");
            effects.consume(code);
            effects.exit("characterEscapeValue");
            effects.exit("characterEscape");
            return ok;
        }
        return nok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 

const $a6d6696ff4e6734a$export$e31905600aaf3d8e = {
    name: "characterReference",
    tokenize: $a6d6696ff4e6734a$var$tokenizeCharacterReference
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $a6d6696ff4e6734a$var$tokenizeCharacterReference(effects, ok, nok) {
    const self = this;
    let size = 0;
    /** @type {number} */ let max;
    /** @type {(code: Code) => boolean} */ let test;
    return start;
    /**
   * Start of character reference.
   *
   * ```markdown
   * > | a&amp;b
   *      ^
   * > | a&#123;b
   *      ^
   * > | a&#x9;b
   *      ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("characterReference");
        effects.enter("characterReferenceMarker");
        effects.consume(code);
        effects.exit("characterReferenceMarker");
        return open;
    }
    /**
   * After `&`, at `#` for numeric references or alphanumeric for named
   * references.
   *
   * ```markdown
   * > | a&amp;b
   *       ^
   * > | a&#123;b
   *       ^
   * > | a&#x9;b
   *       ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if (code === 35) {
            effects.enter("characterReferenceMarkerNumeric");
            effects.consume(code);
            effects.exit("characterReferenceMarkerNumeric");
            return numeric;
        }
        effects.enter("characterReferenceValue");
        max = 31;
        test = (0, $d81ad7e99936a248$export$75c76db11865a9f4);
        return value(code);
    }
    /**
   * After `#`, at `x` for hexadecimals or digit for decimals.
   *
   * ```markdown
   * > | a&#123;b
   *        ^
   * > | a&#x9;b
   *        ^
   * ```
   *
   * @type {State}
   */ function numeric(code) {
        if (code === 88 || code === 120) {
            effects.enter("characterReferenceMarkerHexadecimal");
            effects.consume(code);
            effects.exit("characterReferenceMarkerHexadecimal");
            effects.enter("characterReferenceValue");
            max = 6;
            test = (0, $d81ad7e99936a248$export$eca2752363989806);
            return value;
        }
        effects.enter("characterReferenceValue");
        max = 7;
        test = (0, $d81ad7e99936a248$export$ca8b5b1a6c320e6e);
        return value(code);
    }
    /**
   * After markers (`&#x`, `&#`, or `&`), in value, before `;`.
   *
   * The character reference kind defines what and how many characters are
   * allowed.
   *
   * ```markdown
   * > | a&amp;b
   *       ^^^
   * > | a&#123;b
   *        ^^^
   * > | a&#x9;b
   *         ^
   * ```
   *
   * @type {State}
   */ function value(code) {
        if (code === 59 && size) {
            const token = effects.exit("characterReferenceValue");
            if (test === (0, $d81ad7e99936a248$export$75c76db11865a9f4) && !(0, $129f834d276cd569$export$289b6a6320f709b4)(self.sliceSerialize(token))) return nok(code);
            // To do: `markdown-rs` uses a different name:
            // `CharacterReferenceMarkerSemi`.
            effects.enter("characterReferenceMarker");
            effects.consume(code);
            effects.exit("characterReferenceMarker");
            effects.exit("characterReference");
            return ok;
        }
        if (test(code) && size++ < max) {
            effects.consume(code);
            return value;
        }
        return nok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 

/** @type {Construct} */ const $9249db89b677551f$var$nonLazyContinuation = {
    tokenize: $9249db89b677551f$var$tokenizeNonLazyContinuation,
    partial: true
};
const $9249db89b677551f$export$c23e4921f8d87e7c = {
    name: "codeFenced",
    tokenize: $9249db89b677551f$var$tokenizeCodeFenced,
    concrete: true
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $9249db89b677551f$var$tokenizeCodeFenced(effects, ok, nok) {
    const self = this;
    /** @type {Construct} */ const closeStart = {
        tokenize: tokenizeCloseStart,
        partial: true
    };
    let initialPrefix = 0;
    let sizeOpen = 0;
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /**
   * Start of code.
   *
   * ```markdown
   * > | ~~~js
   *     ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function start(code) {
        // To do: parse whitespace like `markdown-rs`.
        return beforeSequenceOpen(code);
    }
    /**
   * In opening fence, after prefix, at sequence.
   *
   * ```markdown
   * > | ~~~js
   *     ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function beforeSequenceOpen(code) {
        const tail = self.events[self.events.length - 1];
        initialPrefix = tail && tail[1].type === "linePrefix" ? tail[2].sliceSerialize(tail[1], true).length : 0;
        marker = code;
        effects.enter("codeFenced");
        effects.enter("codeFencedFence");
        effects.enter("codeFencedFenceSequence");
        return sequenceOpen(code);
    }
    /**
   * In opening fence sequence.
   *
   * ```markdown
   * > | ~~~js
   *      ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function sequenceOpen(code) {
        if (code === marker) {
            sizeOpen++;
            effects.consume(code);
            return sequenceOpen;
        }
        if (sizeOpen < 3) return nok(code);
        effects.exit("codeFencedFenceSequence");
        return (0, $d81ad7e99936a248$export$2c6cf65c1127992a)(code) ? (0, $6b1271da345f2eae$export$ae105c1eb063a0a2)(effects, infoBefore, "whitespace")(code) : infoBefore(code);
    }
    /**
   * In opening fence, after the sequence (and optional whitespace), before info.
   *
   * ```markdown
   * > | ~~~js
   *        ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function infoBefore(code) {
        if (code === null || (0, $d81ad7e99936a248$export$34a1dff1c0936953)(code)) {
            effects.exit("codeFencedFence");
            return self.interrupt ? ok(code) : effects.check($9249db89b677551f$var$nonLazyContinuation, atNonLazyBreak, after)(code);
        }
        effects.enter("codeFencedFenceInfo");
        effects.enter("chunkString", {
            contentType: "string"
        });
        return info(code);
    }
    /**
   * In info.
   *
   * ```markdown
   * > | ~~~js
   *        ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function info(code) {
        if (code === null || (0, $d81ad7e99936a248$export$34a1dff1c0936953)(code)) {
            effects.exit("chunkString");
            effects.exit("codeFencedFenceInfo");
            return infoBefore(code);
        }
        if ((0, $d81ad7e99936a248$export$2c6cf65c1127992a)(code)) {
            effects.exit("chunkString");
            effects.exit("codeFencedFenceInfo");
            return (0, $6b1271da345f2eae$export$ae105c1eb063a0a2)(effects, metaBefore, "whitespace")(code);
        }
        if (code === 96 && code === marker) return nok(code);
        effects.consume(code);
        return info;
    }
    /**
   * In opening fence, after info and whitespace, before meta.
   *
   * ```markdown
   * > | ~~~js eval
   *           ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function metaBefore(code) {
        if (code === null || (0, $d81ad7e99936a248$export$34a1dff1c0936953)(code)) return infoBefore(code);
        effects.enter("codeFencedFenceMeta");
        effects.enter("chunkString", {
            contentType: "string"
        });
        return meta(code);
    }
    /**
   * In meta.
   *
   * ```markdown
   * > | ~~~js eval
   *           ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function meta(code) {
        if (code === null || (0, $d81ad7e99936a248$export$34a1dff1c0936953)(code)) {
            effects.exit("chunkString");
            effects.exit("codeFencedFenceMeta");
            return infoBefore(code);
        }
        if (code === 96 && code === marker) return nok(code);
        effects.consume(code);
        return meta;
    }
    /**
   * At eol/eof in code, before a non-lazy closing fence or content.
   *
   * ```markdown
   * > | ~~~js
   *          ^
   * > | alert(1)
   *             ^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function atNonLazyBreak(code) {
        return effects.attempt(closeStart, after, contentBefore)(code);
    }
    /**
   * Before code content, not a closing fence, at eol.
   *
   * ```markdown
   *   | ~~~js
   * > | alert(1)
   *             ^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function contentBefore(code) {
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return contentStart;
    }
    /**
   * Before code content, not a closing fence.
   *
   * ```markdown
   *   | ~~~js
   * > | alert(1)
   *     ^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function contentStart(code) {
        return initialPrefix > 0 && (0, $d81ad7e99936a248$export$2c6cf65c1127992a)(code) ? (0, $6b1271da345f2eae$export$ae105c1eb063a0a2)(effects, beforeContentChunk, "linePrefix", initialPrefix + 1)(code) : beforeContentChunk(code);
    }
    /**
   * Before code content, after optional prefix.
   *
   * ```markdown
   *   | ~~~js
   * > | alert(1)
   *     ^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function beforeContentChunk(code) {
        if (code === null || (0, $d81ad7e99936a248$export$34a1dff1c0936953)(code)) return effects.check($9249db89b677551f$var$nonLazyContinuation, atNonLazyBreak, after)(code);
        effects.enter("codeFlowValue");
        return contentChunk(code);
    }
    /**
   * In code content.
   *
   * ```markdown
   *   | ~~~js
   * > | alert(1)
   *     ^^^^^^^^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function contentChunk(code) {
        if (code === null || (0, $d81ad7e99936a248$export$34a1dff1c0936953)(code)) {
            effects.exit("codeFlowValue");
            return beforeContentChunk(code);
        }
        effects.consume(code);
        return contentChunk;
    }
    /**
   * After code.
   *
   * ```markdown
   *   | ~~~js
   *   | alert(1)
   * > | ~~~
   *        ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        effects.exit("codeFenced");
        return ok(code);
    }
    /**
   * @this {TokenizeContext}
   * @type {Tokenizer}
   */ function tokenizeCloseStart(effects, ok, nok) {
        let size = 0;
        return startBefore;
        /**
     *
     *
     * @type {State}
     */ function startBefore(code) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return start;
        }
        /**
     * Before closing fence, at optional whitespace.
     *
     * ```markdown
     *   | ~~~js
     *   | alert(1)
     * > | ~~~
     *     ^
     * ```
     *
     * @type {State}
     */ function start(code) {
            // Always populated by defaults.
            // To do: `enter` here or in next state?
            effects.enter("codeFencedFence");
            return (0, $d81ad7e99936a248$export$2c6cf65c1127992a)(code) ? (0, $6b1271da345f2eae$export$ae105c1eb063a0a2)(effects, beforeSequenceClose, "linePrefix", self.parser.constructs.disable.null.includes("codeIndented") ? undefined : 4)(code) : beforeSequenceClose(code);
        }
        /**
     * In closing fence, after optional whitespace, at sequence.
     *
     * ```markdown
     *   | ~~~js
     *   | alert(1)
     * > | ~~~
     *     ^
     * ```
     *
     * @type {State}
     */ function beforeSequenceClose(code) {
            if (code === marker) {
                effects.enter("codeFencedFenceSequence");
                return sequenceClose(code);
            }
            return nok(code);
        }
        /**
     * In closing fence sequence.
     *
     * ```markdown
     *   | ~~~js
     *   | alert(1)
     * > | ~~~
     *     ^
     * ```
     *
     * @type {State}
     */ function sequenceClose(code) {
            if (code === marker) {
                size++;
                effects.consume(code);
                return sequenceClose;
            }
            if (size >= sizeOpen) {
                effects.exit("codeFencedFenceSequence");
                return (0, $d81ad7e99936a248$export$2c6cf65c1127992a)(code) ? (0, $6b1271da345f2eae$export$ae105c1eb063a0a2)(effects, sequenceCloseAfter, "whitespace")(code) : sequenceCloseAfter(code);
            }
            return nok(code);
        }
        /**
     * After closing fence sequence, after optional whitespace.
     *
     * ```markdown
     *   | ~~~js
     *   | alert(1)
     * > | ~~~
     *        ^
     * ```
     *
     * @type {State}
     */ function sequenceCloseAfter(code) {
            if (code === null || (0, $d81ad7e99936a248$export$34a1dff1c0936953)(code)) {
                effects.exit("codeFencedFence");
                return ok(code);
            }
            return nok(code);
        }
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $9249db89b677551f$var$tokenizeNonLazyContinuation(effects, ok, nok) {
    const self = this;
    return start;
    /**
   *
   *
   * @type {State}
   */ function start(code) {
        if (code === null) return nok(code);
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return lineStart;
    }
    /**
   *
   *
   * @type {State}
   */ function lineStart(code) {
        return self.parser.lazy[self.now().line] ? nok(code) : ok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 

const $6937836985201beb$export$47910b7ab28d1853 = {
    name: "codeIndented",
    tokenize: $6937836985201beb$var$tokenizeCodeIndented
};
/** @type {Construct} */ const $6937836985201beb$var$furtherStart = {
    tokenize: $6937836985201beb$var$tokenizeFurtherStart,
    partial: true
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $6937836985201beb$var$tokenizeCodeIndented(effects, ok, nok) {
    const self = this;
    return start;
    /**
   * Start of code (indented).
   *
   * > **Parsing note**: it is not needed to check if this first line is a
   * > filled line (that it has a non-whitespace character), because blank lines
   * > are parsed already, so we never run into that.
   *
   * ```markdown
   * > |     aaa
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        // To do: manually check if interrupting like `markdown-rs`.
        effects.enter("codeIndented");
        // To do: use an improved `space_or_tab` function like `markdown-rs`,
        // so that we can drop the next state.
        return (0, $6b1271da345f2eae$export$ae105c1eb063a0a2)(effects, afterPrefix, "linePrefix", 5)(code);
    }
    /**
   * At start, after 1 or 4 spaces.
   *
   * ```markdown
   * > |     aaa
   *         ^
   * ```
   *
   * @type {State}
   */ function afterPrefix(code) {
        const tail = self.events[self.events.length - 1];
        return tail && tail[1].type === "linePrefix" && tail[2].sliceSerialize(tail[1], true).length >= 4 ? atBreak(code) : nok(code);
    }
    /**
   * At a break.
   *
   * ```markdown
   * > |     aaa
   *         ^  ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (code === null) return after(code);
        if ((0, $d81ad7e99936a248$export$34a1dff1c0936953)(code)) return effects.attempt($6937836985201beb$var$furtherStart, atBreak, after)(code);
        effects.enter("codeFlowValue");
        return inside(code);
    }
    /**
   * In code content.
   *
   * ```markdown
   * > |     aaa
   *         ^^^^
   * ```
   *
   * @type {State}
   */ function inside(code) {
        if (code === null || (0, $d81ad7e99936a248$export$34a1dff1c0936953)(code)) {
            effects.exit("codeFlowValue");
            return atBreak(code);
        }
        effects.consume(code);
        return inside;
    }
    /** @type {State} */ function after(code) {
        effects.exit("codeIndented");
        // To do: allow interrupting like `markdown-rs`.
        // Feel free to interrupt.
        // tokenizer.interrupt = false
        return ok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $6937836985201beb$var$tokenizeFurtherStart(effects, ok, nok) {
    const self = this;
    return furtherStart;
    /**
   * At eol, trying to parse another indent.
   *
   * ```markdown
   * > |     aaa
   *            ^
   *   |     bbb
   * ```
   *
   * @type {State}
   */ function furtherStart(code) {
        // To do: improve `lazy` / `pierce` handling.
        // If this is a lazy line, it can’t be code.
        if (self.parser.lazy[self.now().line]) return nok(code);
        if ((0, $d81ad7e99936a248$export$34a1dff1c0936953)(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return furtherStart;
        }
        // To do: the code here in `micromark-js` is a bit different from
        // `markdown-rs` because there it can attempt spaces.
        // We can’t yet.
        //
        // To do: use an improved `space_or_tab` function like `markdown-rs`,
        // so that we can drop the next state.
        return (0, $6b1271da345f2eae$export$ae105c1eb063a0a2)(effects, afterPrefix, "linePrefix", 5)(code);
    }
    /**
   * At start, after 1 or 4 spaces.
   *
   * ```markdown
   * > |     aaa
   *         ^
   * ```
   *
   * @type {State}
   */ function afterPrefix(code) {
        const tail = self.events[self.events.length - 1];
        return tail && tail[1].type === "linePrefix" && tail[2].sliceSerialize(tail[1], true).length >= 4 ? ok(code) : (0, $d81ad7e99936a248$export$34a1dff1c0936953)(code) ? furtherStart(code) : nok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Previous} Previous
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
const $45a5b87f264f3656$export$d24f93e715f9df88 = {
    name: "codeText",
    tokenize: $45a5b87f264f3656$var$tokenizeCodeText,
    resolve: $45a5b87f264f3656$var$resolveCodeText,
    previous: $45a5b87f264f3656$var$previous
};
// To do: next major: don’t resolve, like `markdown-rs`.
/** @type {Resolver} */ function $45a5b87f264f3656$var$resolveCodeText(events) {
    let tailExitIndex = events.length - 4;
    let headEnterIndex = 3;
    /** @type {number} */ let index;
    /** @type {number | undefined} */ let enter;
    // If we start and end with an EOL or a space.
    if ((events[headEnterIndex][1].type === "lineEnding" || events[headEnterIndex][1].type === "space") && (events[tailExitIndex][1].type === "lineEnding" || events[tailExitIndex][1].type === "space")) {
        index = headEnterIndex;
        // And we have data.
        while(++index < tailExitIndex)if (events[index][1].type === "codeTextData") {
            // Then we have padding.
            events[headEnterIndex][1].type = "codeTextPadding";
            events[tailExitIndex][1].type = "codeTextPadding";
            headEnterIndex += 2;
            tailExitIndex -= 2;
            break;
        }
    }
    // Merge adjacent spaces and data.
    index = headEnterIndex - 1;
    tailExitIndex++;
    while(++index <= tailExitIndex){
        if (enter === undefined) {
            if (index !== tailExitIndex && events[index][1].type !== "lineEnding") enter = index;
        } else if (index === tailExitIndex || events[index][1].type === "lineEnding") {
            events[enter][1].type = "codeTextData";
            if (index !== enter + 2) {
                events[enter][1].end = events[index - 1][1].end;
                events.splice(enter + 2, index - enter - 2);
                tailExitIndex -= index - enter - 2;
                index = enter + 2;
            }
            enter = undefined;
        }
    }
    return events;
}
/**
 * @this {TokenizeContext}
 * @type {Previous}
 */ function $45a5b87f264f3656$var$previous(code) {
    // If there is a previous code, there will always be a tail.
    return code !== 96 || this.events[this.events.length - 1][1].type === "characterEscape";
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $45a5b87f264f3656$var$tokenizeCodeText(effects, ok, nok) {
    const self = this;
    let sizeOpen = 0;
    /** @type {number} */ let size;
    /** @type {Token} */ let token;
    return start;
    /**
   * Start of code (text).
   *
   * ```markdown
   * > | `a`
   *     ^
   * > | \`a`
   *      ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("codeText");
        effects.enter("codeTextSequence");
        return sequenceOpen(code);
    }
    /**
   * In opening sequence.
   *
   * ```markdown
   * > | `a`
   *     ^
   * ```
   *
   * @type {State}
   */ function sequenceOpen(code) {
        if (code === 96) {
            effects.consume(code);
            sizeOpen++;
            return sequenceOpen;
        }
        effects.exit("codeTextSequence");
        return between(code);
    }
    /**
   * Between something and something else.
   *
   * ```markdown
   * > | `a`
   *      ^^
   * ```
   *
   * @type {State}
   */ function between(code) {
        // EOF.
        if (code === null) return nok(code);
        // To do: next major: don’t do spaces in resolve, but when compiling,
        // like `markdown-rs`.
        // Tabs don’t work, and virtual spaces don’t make sense.
        if (code === 32) {
            effects.enter("space");
            effects.consume(code);
            effects.exit("space");
            return between;
        }
        // Closing fence? Could also be data.
        if (code === 96) {
            token = effects.enter("codeTextSequence");
            size = 0;
            return sequenceClose(code);
        }
        if ((0, $d81ad7e99936a248$export$34a1dff1c0936953)(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return between;
        }
        // Data.
        effects.enter("codeTextData");
        return data(code);
    }
    /**
   * In data.
   *
   * ```markdown
   * > | `a`
   *      ^
   * ```
   *
   * @type {State}
   */ function data(code) {
        if (code === null || code === 32 || code === 96 || (0, $d81ad7e99936a248$export$34a1dff1c0936953)(code)) {
            effects.exit("codeTextData");
            return between(code);
        }
        effects.consume(code);
        return data;
    }
    /**
   * In closing sequence.
   *
   * ```markdown
   * > | `a`
   *       ^
   * ```
   *
   * @type {State}
   */ function sequenceClose(code) {
        // More.
        if (code === 96) {
            effects.consume(code);
            size++;
            return sequenceClose;
        }
        // Done!
        if (size === sizeOpen) {
            effects.exit("codeTextSequence");
            effects.exit("codeText");
            return ok(code);
        }
        // More or less accents: mark as data.
        token.type = "codeTextData";
        return data(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ /**
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenType} TokenType
 */ 
function $71821775439d38d1$export$2e6c8deaa96af245(effects, ok, nok, type, literalType, literalMarkerType, rawType, stringType, max) {
    const limit = max || Number.POSITIVE_INFINITY;
    let balance = 0;
    return start;
    /**
   * Start of destination.
   *
   * ```markdown
   * > | <aa>
   *     ^
   * > | aa
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        if (code === 60) {
            effects.enter(type);
            effects.enter(literalType);
            effects.enter(literalMarkerType);
            effects.consume(code);
            effects.exit(literalMarkerType);
            return enclosedBefore;
        }
        // ASCII control, space, closing paren.
        if (code === null || code === 32 || code === 41 || (0, $d81ad7e99936a248$export$67dbf494fc8394df)(code)) return nok(code);
        effects.enter(type);
        effects.enter(rawType);
        effects.enter(stringType);
        effects.enter("chunkString", {
            contentType: "string"
        });
        return raw(code);
    }
    /**
   * After `<`, at an enclosed destination.
   *
   * ```markdown
   * > | <aa>
   *      ^
   * ```
   *
   * @type {State}
   */ function enclosedBefore(code) {
        if (code === 62) {
            effects.enter(literalMarkerType);
            effects.consume(code);
            effects.exit(literalMarkerType);
            effects.exit(literalType);
            effects.exit(type);
            return ok;
        }
        effects.enter(stringType);
        effects.enter("chunkString", {
            contentType: "string"
        });
        return enclosed(code);
    }
    /**
   * In enclosed destination.
   *
   * ```markdown
   * > | <aa>
   *      ^
   * ```
   *
   * @type {State}
   */ function enclosed(code) {
        if (code === 62) {
            effects.exit("chunkString");
            effects.exit(stringType);
            return enclosedBefore(code);
        }
        if (code === null || code === 60 || (0, $d81ad7e99936a248$export$34a1dff1c0936953)(code)) return nok(code);
        effects.consume(code);
        return code === 92 ? enclosedEscape : enclosed;
    }
    /**
   * After `\`, at a special character.
   *
   * ```markdown
   * > | <a\*a>
   *        ^
   * ```
   *
   * @type {State}
   */ function enclosedEscape(code) {
        if (code === 60 || code === 62 || code === 92) {
            effects.consume(code);
            return enclosed;
        }
        return enclosed(code);
    }
    /**
   * In raw destination.
   *
   * ```markdown
   * > | aa
   *     ^
   * ```
   *
   * @type {State}
   */ function raw(code) {
        if (!balance && (code === null || code === 41 || (0, $d81ad7e99936a248$export$a30284361b3814b7)(code))) {
            effects.exit("chunkString");
            effects.exit(stringType);
            effects.exit(rawType);
            effects.exit(type);
            return ok(code);
        }
        if (balance < limit && code === 40) {
            effects.consume(code);
            balance++;
            return raw;
        }
        if (code === 41) {
            effects.consume(code);
            balance--;
            return raw;
        }
        // ASCII control (but *not* `\0`) and space and `(`.
        // Note: in `markdown-rs`, `\0` exists in codes, in `micromark-js` it
        // doesn’t.
        if (code === null || code === 32 || code === 40 || (0, $d81ad7e99936a248$export$67dbf494fc8394df)(code)) return nok(code);
        effects.consume(code);
        return code === 92 ? rawEscape : raw;
    }
    /**
   * After `\`, at special character.
   *
   * ```markdown
   * > | a\*a
   *       ^
   * ```
   *
   * @type {State}
   */ function rawEscape(code) {
        if (code === 40 || code === 41 || code === 92) {
            effects.consume(code);
            return raw;
        }
        return raw(code);
    }
}


/**
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').TokenType} TokenType
 */ 
function $619fab19b6d70741$export$7b768614d8ba97a7(effects, ok, nok, type, markerType, stringType) {
    const self = this;
    let size = 0;
    /** @type {boolean} */ let seen;
    return start;
    /**
   * Start of label.
   *
   * ```markdown
   * > | [a]
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter(type);
        effects.enter(markerType);
        effects.consume(code);
        effects.exit(markerType);
        effects.enter(stringType);
        return atBreak;
    }
    /**
   * In label, at something, before something else.
   *
   * ```markdown
   * > | [a]
   *      ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (size > 999 || code === null || code === 91 || code === 93 && !seen || // To do: remove in the future once we’ve switched from
        // `micromark-extension-footnote` to `micromark-extension-gfm-footnote`,
        // which doesn’t need this.
        // Hidden footnotes hook.
        /* c8 ignore next 3 */ code === 94 && !size && "_hiddenFootnoteSupport" in self.parser.constructs) return nok(code);
        if (code === 93) {
            effects.exit(stringType);
            effects.enter(markerType);
            effects.consume(code);
            effects.exit(markerType);
            effects.exit(type);
            return ok;
        }
        // To do: indent? Link chunks and EOLs together?
        if ((0, $d81ad7e99936a248$export$34a1dff1c0936953)(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return atBreak;
        }
        effects.enter("chunkString", {
            contentType: "string"
        });
        return labelInside(code);
    }
    /**
   * In label, in text.
   *
   * ```markdown
   * > | [a]
   *      ^
   * ```
   *
   * @type {State}
   */ function labelInside(code) {
        if (code === null || code === 91 || code === 93 || (0, $d81ad7e99936a248$export$34a1dff1c0936953)(code) || size++ > 999) {
            effects.exit("chunkString");
            return atBreak(code);
        }
        effects.consume(code);
        if (!seen) seen = !(0, $d81ad7e99936a248$export$2c6cf65c1127992a)(code);
        return code === 92 ? labelEscape : labelInside;
    }
    /**
   * After `\`, at a special character.
   *
   * ```markdown
   * > | [a\*a]
   *        ^
   * ```
   *
   * @type {State}
   */ function labelEscape(code) {
        if (code === 91 || code === 92 || code === 93) {
            effects.consume(code);
            size++;
            return labelInside;
        }
        return labelInside(code);
    }
}



/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenType} TokenType
 */ 

function $cbf87fb23aedd207$export$f970569cc855e483(effects, ok, nok, type, markerType, stringType) {
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /**
   * Start of title.
   *
   * ```markdown
   * > | "a"
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        if (code === 34 || code === 39 || code === 40) {
            effects.enter(type);
            effects.enter(markerType);
            effects.consume(code);
            effects.exit(markerType);
            marker = code === 40 ? 41 : code;
            return begin;
        }
        return nok(code);
    }
    /**
   * After opening marker.
   *
   * This is also used at the closing marker.
   *
   * ```markdown
   * > | "a"
   *      ^
   * ```
   *
   * @type {State}
   */ function begin(code) {
        if (code === marker) {
            effects.enter(markerType);
            effects.consume(code);
            effects.exit(markerType);
            effects.exit(type);
            return ok;
        }
        effects.enter(stringType);
        return atBreak(code);
    }
    /**
   * At something, before something else.
   *
   * ```markdown
   * > | "a"
   *      ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (code === marker) {
            effects.exit(stringType);
            return begin(marker);
        }
        if (code === null) return nok(code);
        // Note: blank lines can’t exist in content.
        if ((0, $d81ad7e99936a248$export$34a1dff1c0936953)(code)) {
            // To do: use `space_or_tab_eol_with_options`, connect.
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return (0, $6b1271da345f2eae$export$ae105c1eb063a0a2)(effects, atBreak, "linePrefix");
        }
        effects.enter("chunkString", {
            contentType: "string"
        });
        return inside(code);
    }
    /**
   *
   *
   * @type {State}
   */ function inside(code) {
        if (code === marker || code === null || (0, $d81ad7e99936a248$export$34a1dff1c0936953)(code)) {
            effects.exit("chunkString");
            return atBreak(code);
        }
        effects.consume(code);
        return code === 92 ? escape : inside;
    }
    /**
   * After `\`, at a special character.
   *
   * ```markdown
   * > | "a\*b"
   *      ^
   * ```
   *
   * @type {State}
   */ function escape(code) {
        if (code === marker || code === 92) {
            effects.consume(code);
            return inside;
        }
        return inside(code);
    }
}


/**
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').State} State
 */ 

function $83988bbaf37562ec$export$1f27bd1aa33ce173(effects, ok) {
    /** @type {boolean} */ let seen;
    return start;
    /** @type {State} */ function start(code) {
        if ((0, $d81ad7e99936a248$export$34a1dff1c0936953)(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            seen = true;
            return start;
        }
        if ((0, $d81ad7e99936a248$export$2c6cf65c1127992a)(code)) return (0, $6b1271da345f2eae$export$ae105c1eb063a0a2)(effects, start, seen ? "linePrefix" : "lineSuffix")(code);
        return ok(code);
    }
}




const $39908b58f48f618f$export$69f215ed977cdb73 = {
    name: "definition",
    tokenize: $39908b58f48f618f$var$tokenizeDefinition
};
/** @type {Construct} */ const $39908b58f48f618f$var$titleBefore = {
    tokenize: $39908b58f48f618f$var$tokenizeTitleBefore,
    partial: true
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $39908b58f48f618f$var$tokenizeDefinition(effects, ok, nok) {
    const self = this;
    /** @type {string} */ let identifier;
    return start;
    /**
   * At start of a definition.
   *
   * ```markdown
   * > | [a]: b "c"
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        // Do not interrupt paragraphs (but do follow definitions).
        // To do: do `interrupt` the way `markdown-rs` does.
        // To do: parse whitespace the way `markdown-rs` does.
        effects.enter("definition");
        return before(code);
    }
    /**
   * After optional whitespace, at `[`.
   *
   * ```markdown
   * > | [a]: b "c"
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        // To do: parse whitespace the way `markdown-rs` does.
        return (0, $619fab19b6d70741$export$7b768614d8ba97a7).call(self, effects, labelAfter, // Note: we don’t need to reset the way `markdown-rs` does.
        nok, "definitionLabel", "definitionLabelMarker", "definitionLabelString")(code);
    }
    /**
   * After label.
   *
   * ```markdown
   * > | [a]: b "c"
   *        ^
   * ```
   *
   * @type {State}
   */ function labelAfter(code) {
        identifier = (0, $17274a453d2d9545$export$806d55e226cfcd08)(self.sliceSerialize(self.events[self.events.length - 1][1]).slice(1, -1));
        if (code === 58) {
            effects.enter("definitionMarker");
            effects.consume(code);
            effects.exit("definitionMarker");
            return markerAfter;
        }
        return nok(code);
    }
    /**
   * After marker.
   *
   * ```markdown
   * > | [a]: b "c"
   *         ^
   * ```
   *
   * @type {State}
   */ function markerAfter(code) {
        // Note: whitespace is optional.
        return (0, $d81ad7e99936a248$export$a30284361b3814b7)(code) ? (0, $83988bbaf37562ec$export$1f27bd1aa33ce173)(effects, destinationBefore)(code) : destinationBefore(code);
    }
    /**
   * Before destination.
   *
   * ```markdown
   * > | [a]: b "c"
   *          ^
   * ```
   *
   * @type {State}
   */ function destinationBefore(code) {
        return (0, $71821775439d38d1$export$2e6c8deaa96af245)(effects, destinationAfter, // Note: we don’t need to reset the way `markdown-rs` does.
        nok, "definitionDestination", "definitionDestinationLiteral", "definitionDestinationLiteralMarker", "definitionDestinationRaw", "definitionDestinationString")(code);
    }
    /**
   * After destination.
   *
   * ```markdown
   * > | [a]: b "c"
   *           ^
   * ```
   *
   * @type {State}
   */ function destinationAfter(code) {
        return effects.attempt($39908b58f48f618f$var$titleBefore, after, after)(code);
    }
    /**
   * After definition.
   *
   * ```markdown
   * > | [a]: b
   *           ^
   * > | [a]: b "c"
   *               ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        return (0, $d81ad7e99936a248$export$2c6cf65c1127992a)(code) ? (0, $6b1271da345f2eae$export$ae105c1eb063a0a2)(effects, afterWhitespace, "whitespace")(code) : afterWhitespace(code);
    }
    /**
   * After definition, after optional whitespace.
   *
   * ```markdown
   * > | [a]: b
   *           ^
   * > | [a]: b "c"
   *               ^
   * ```
   *
   * @type {State}
   */ function afterWhitespace(code) {
        if (code === null || (0, $d81ad7e99936a248$export$34a1dff1c0936953)(code)) {
            effects.exit("definition");
            // Note: we don’t care about uniqueness.
            // It’s likely that that doesn’t happen very frequently.
            // It is more likely that it wastes precious time.
            self.parser.defined.push(identifier);
            // To do: `markdown-rs` interrupt.
            // // You’d be interrupting.
            // tokenizer.interrupt = true
            return ok(code);
        }
        return nok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $39908b58f48f618f$var$tokenizeTitleBefore(effects, ok, nok) {
    return titleBefore;
    /**
   * After destination, at whitespace.
   *
   * ```markdown
   * > | [a]: b
   *           ^
   * > | [a]: b "c"
   *           ^
   * ```
   *
   * @type {State}
   */ function titleBefore(code) {
        return (0, $d81ad7e99936a248$export$a30284361b3814b7)(code) ? (0, $83988bbaf37562ec$export$1f27bd1aa33ce173)(effects, beforeMarker)(code) : nok(code);
    }
    /**
   * At title.
   *
   * ```markdown
   *   | [a]: b
   * > | "c"
   *     ^
   * ```
   *
   * @type {State}
   */ function beforeMarker(code) {
        return (0, $cbf87fb23aedd207$export$f970569cc855e483)(effects, titleAfter, nok, "definitionTitle", "definitionTitleMarker", "definitionTitleString")(code);
    }
    /**
   * After title.
   *
   * ```markdown
   * > | [a]: b "c"
   *               ^
   * ```
   *
   * @type {State}
   */ function titleAfter(code) {
        return (0, $d81ad7e99936a248$export$2c6cf65c1127992a)(code) ? (0, $6b1271da345f2eae$export$ae105c1eb063a0a2)(effects, titleAfterOptionalWhitespace, "whitespace")(code) : titleAfterOptionalWhitespace(code);
    }
    /**
   * After title, after optional whitespace.
   *
   * ```markdown
   * > | [a]: b "c"
   *               ^
   * ```
   *
   * @type {State}
   */ function titleAfterOptionalWhitespace(code) {
        return code === null || (0, $d81ad7e99936a248$export$34a1dff1c0936953)(code) ? ok(code) : nok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
const $ae7f6631b895185e$export$86c573ab9e06f418 = {
    name: "hardBreakEscape",
    tokenize: $ae7f6631b895185e$var$tokenizeHardBreakEscape
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $ae7f6631b895185e$var$tokenizeHardBreakEscape(effects, ok, nok) {
    return start;
    /**
   * Start of a hard break (escape).
   *
   * ```markdown
   * > | a\
   *      ^
   *   | b
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("hardBreakEscape");
        effects.consume(code);
        return after;
    }
    /**
   * After `\`, at eol.
   *
   * ```markdown
   * > | a\
   *       ^
   *   | b
   * ```
   *
   *  @type {State}
   */ function after(code) {
        if ((0, $d81ad7e99936a248$export$34a1dff1c0936953)(code)) {
            effects.exit("hardBreakEscape");
            return ok(code);
        }
        return nok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 


const $75419b66e74e72ff$export$3871e9deb360695c = {
    name: "headingAtx",
    tokenize: $75419b66e74e72ff$var$tokenizeHeadingAtx,
    resolve: $75419b66e74e72ff$var$resolveHeadingAtx
};
/** @type {Resolver} */ function $75419b66e74e72ff$var$resolveHeadingAtx(events, context) {
    let contentEnd = events.length - 2;
    let contentStart = 3;
    /** @type {Token} */ let content;
    /** @type {Token} */ let text;
    // Prefix whitespace, part of the opening.
    if (events[contentStart][1].type === "whitespace") contentStart += 2;
    // Suffix whitespace, part of the closing.
    if (contentEnd - 2 > contentStart && events[contentEnd][1].type === "whitespace") contentEnd -= 2;
    if (events[contentEnd][1].type === "atxHeadingSequence" && (contentStart === contentEnd - 1 || contentEnd - 4 > contentStart && events[contentEnd - 2][1].type === "whitespace")) contentEnd -= contentStart + 1 === contentEnd ? 2 : 4;
    if (contentEnd > contentStart) {
        content = {
            type: "atxHeadingText",
            start: events[contentStart][1].start,
            end: events[contentEnd][1].end
        };
        text = {
            type: "chunkText",
            start: events[contentStart][1].start,
            end: events[contentEnd][1].end,
            contentType: "text"
        };
        (0, $76c325c59203cf92$export$869882364835d202)(events, contentStart, contentEnd - contentStart + 1, [
            [
                "enter",
                content,
                context
            ],
            [
                "enter",
                text,
                context
            ],
            [
                "exit",
                text,
                context
            ],
            [
                "exit",
                content,
                context
            ]
        ]);
    }
    return events;
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $75419b66e74e72ff$var$tokenizeHeadingAtx(effects, ok, nok) {
    let size = 0;
    return start;
    /**
   * Start of a heading (atx).
   *
   * ```markdown
   * > | ## aa
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        // To do: parse indent like `markdown-rs`.
        effects.enter("atxHeading");
        return before(code);
    }
    /**
   * After optional whitespace, at `#`.
   *
   * ```markdown
   * > | ## aa
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        effects.enter("atxHeadingSequence");
        return sequenceOpen(code);
    }
    /**
   * In opening sequence.
   *
   * ```markdown
   * > | ## aa
   *     ^
   * ```
   *
   * @type {State}
   */ function sequenceOpen(code) {
        if (code === 35 && size++ < 6) {
            effects.consume(code);
            return sequenceOpen;
        }
        // Always at least one `#`.
        if (code === null || (0, $d81ad7e99936a248$export$a30284361b3814b7)(code)) {
            effects.exit("atxHeadingSequence");
            return atBreak(code);
        }
        return nok(code);
    }
    /**
   * After something, before something else.
   *
   * ```markdown
   * > | ## aa
   *       ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (code === 35) {
            effects.enter("atxHeadingSequence");
            return sequenceFurther(code);
        }
        if (code === null || (0, $d81ad7e99936a248$export$34a1dff1c0936953)(code)) {
            effects.exit("atxHeading");
            // To do: interrupt like `markdown-rs`.
            // // Feel free to interrupt.
            // tokenizer.interrupt = false
            return ok(code);
        }
        if ((0, $d81ad7e99936a248$export$2c6cf65c1127992a)(code)) return (0, $6b1271da345f2eae$export$ae105c1eb063a0a2)(effects, atBreak, "whitespace")(code);
        // To do: generate `data` tokens, add the `text` token later.
        // Needs edit map, see: `markdown.rs`.
        effects.enter("atxHeadingText");
        return data(code);
    }
    /**
   * In further sequence (after whitespace).
   *
   * Could be normal “visible” hashes in the heading or a final sequence.
   *
   * ```markdown
   * > | ## aa ##
   *           ^
   * ```
   *
   * @type {State}
   */ function sequenceFurther(code) {
        if (code === 35) {
            effects.consume(code);
            return sequenceFurther;
        }
        effects.exit("atxHeadingSequence");
        return atBreak(code);
    }
    /**
   * In text.
   *
   * ```markdown
   * > | ## aa
   *        ^
   * ```
   *
   * @type {State}
   */ function data(code) {
        if (code === null || code === 35 || (0, $d81ad7e99936a248$export$a30284361b3814b7)(code)) {
            effects.exit("atxHeadingText");
            return atBreak(code);
        }
        effects.consume(code);
        return data;
    }
}

/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
/**
 * List of lowercase HTML “block” tag names.
 *
 * The list, when parsing HTML (flow), results in more relaxed rules (condition
 * 6).
 * Because they are known blocks, the HTML-like syntax doesn’t have to be
 * strictly parsed.
 * For tag names not in this list, a more strict algorithm (condition 7) is used
 * to detect whether the HTML-like syntax is seen as HTML (flow) or not.
 *
 * This is copied from:
 * <https://spec.commonmark.org/0.30/#html-blocks>.
 *
 * > 👉 **Note**: `search` was added in `CommonMark@0.31`.
 */ const $7da17022313d5182$export$7364aee1c59d1879 = [
    "address",
    "article",
    "aside",
    "base",
    "basefont",
    "blockquote",
    "body",
    "caption",
    "center",
    "col",
    "colgroup",
    "dd",
    "details",
    "dialog",
    "dir",
    "div",
    "dl",
    "dt",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "frame",
    "frameset",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hr",
    "html",
    "iframe",
    "legend",
    "li",
    "link",
    "main",
    "menu",
    "menuitem",
    "nav",
    "noframes",
    "ol",
    "optgroup",
    "option",
    "p",
    "param",
    "search",
    "section",
    "summary",
    "table",
    "tbody",
    "td",
    "tfoot",
    "th",
    "thead",
    "title",
    "tr",
    "track",
    "ul"
];
const $7da17022313d5182$export$948e66da505d080 = [
    "pre",
    "script",
    "style",
    "textarea"
];



const $0c7f966054a57f62$export$476ac411cb7d0d8f = {
    name: "htmlFlow",
    tokenize: $0c7f966054a57f62$var$tokenizeHtmlFlow,
    resolveTo: $0c7f966054a57f62$var$resolveToHtmlFlow,
    concrete: true
};
/** @type {Construct} */ const $0c7f966054a57f62$var$blankLineBefore = {
    tokenize: $0c7f966054a57f62$var$tokenizeBlankLineBefore,
    partial: true
};
const $0c7f966054a57f62$var$nonLazyContinuationStart = {
    tokenize: $0c7f966054a57f62$var$tokenizeNonLazyContinuationStart,
    partial: true
};
/** @type {Resolver} */ function $0c7f966054a57f62$var$resolveToHtmlFlow(events) {
    let index = events.length;
    while(index--){
        if (events[index][0] === "enter" && events[index][1].type === "htmlFlow") break;
    }
    if (index > 1 && events[index - 2][1].type === "linePrefix") {
        // Add the prefix start to the HTML token.
        events[index][1].start = events[index - 2][1].start;
        // Add the prefix start to the HTML line token.
        events[index + 1][1].start = events[index - 2][1].start;
        // Remove the line prefix.
        events.splice(index - 2, 2);
    }
    return events;
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $0c7f966054a57f62$var$tokenizeHtmlFlow(effects, ok, nok) {
    const self = this;
    /** @type {number} */ let marker;
    /** @type {boolean} */ let closingTag;
    /** @type {string} */ let buffer;
    /** @type {number} */ let index;
    /** @type {Code} */ let markerB;
    return start;
    /**
   * Start of HTML (flow).
   *
   * ```markdown
   * > | <x />
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        // To do: parse indent like `markdown-rs`.
        return before(code);
    }
    /**
   * At `<`, after optional whitespace.
   *
   * ```markdown
   * > | <x />
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        effects.enter("htmlFlow");
        effects.enter("htmlFlowData");
        effects.consume(code);
        return open;
    }
    /**
   * After `<`, at tag name or other stuff.
   *
   * ```markdown
   * > | <x />
   *      ^
   * > | <!doctype>
   *      ^
   * > | <!--xxx-->
   *      ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if (code === 33) {
            effects.consume(code);
            return declarationOpen;
        }
        if (code === 47) {
            effects.consume(code);
            closingTag = true;
            return tagCloseStart;
        }
        if (code === 63) {
            effects.consume(code);
            marker = 3;
            // To do:
            // tokenizer.concrete = true
            // To do: use `markdown-rs` style interrupt.
            // While we’re in an instruction instead of a declaration, we’re on a `?`
            // right now, so we do need to search for `>`, similar to declarations.
            return self.interrupt ? ok : continuationDeclarationInside;
        }
        // ASCII alphabetical.
        if ((0, $d81ad7e99936a248$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            // @ts-expect-error: not null.
            buffer = String.fromCharCode(code);
            return tagName;
        }
        return nok(code);
    }
    /**
   * After `<!`, at declaration, comment, or CDATA.
   *
   * ```markdown
   * > | <!doctype>
   *       ^
   * > | <!--xxx-->
   *       ^
   * > | <![CDATA[>&<]]>
   *       ^
   * ```
   *
   * @type {State}
   */ function declarationOpen(code) {
        if (code === 45) {
            effects.consume(code);
            marker = 2;
            return commentOpenInside;
        }
        if (code === 91) {
            effects.consume(code);
            marker = 5;
            index = 0;
            return cdataOpenInside;
        }
        // ASCII alphabetical.
        if ((0, $d81ad7e99936a248$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            marker = 4;
            // // Do not form containers.
            // tokenizer.concrete = true
            return self.interrupt ? ok : continuationDeclarationInside;
        }
        return nok(code);
    }
    /**
   * After `<!-`, inside a comment, at another `-`.
   *
   * ```markdown
   * > | <!--xxx-->
   *        ^
   * ```
   *
   * @type {State}
   */ function commentOpenInside(code) {
        if (code === 45) {
            effects.consume(code);
            // // Do not form containers.
            // tokenizer.concrete = true
            return self.interrupt ? ok : continuationDeclarationInside;
        }
        return nok(code);
    }
    /**
   * After `<![`, inside CDATA, expecting `CDATA[`.
   *
   * ```markdown
   * > | <![CDATA[>&<]]>
   *        ^^^^^^
   * ```
   *
   * @type {State}
   */ function cdataOpenInside(code) {
        const value = "CDATA[";
        if (code === value.charCodeAt(index++)) {
            effects.consume(code);
            if (index === value.length) // // Do not form containers.
            // tokenizer.concrete = true
            return self.interrupt ? ok : continuation;
            return cdataOpenInside;
        }
        return nok(code);
    }
    /**
   * After `</`, in closing tag, at tag name.
   *
   * ```markdown
   * > | </x>
   *       ^
   * ```
   *
   * @type {State}
   */ function tagCloseStart(code) {
        if ((0, $d81ad7e99936a248$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            // @ts-expect-error: not null.
            buffer = String.fromCharCode(code);
            return tagName;
        }
        return nok(code);
    }
    /**
   * In tag name.
   *
   * ```markdown
   * > | <ab>
   *      ^^
   * > | </ab>
   *       ^^
   * ```
   *
   * @type {State}
   */ function tagName(code) {
        if (code === null || code === 47 || code === 62 || (0, $d81ad7e99936a248$export$a30284361b3814b7)(code)) {
            const slash = code === 47;
            const name = buffer.toLowerCase();
            if (!slash && !closingTag && (0, $7da17022313d5182$export$948e66da505d080).includes(name)) {
                marker = 1;
                // // Do not form containers.
                // tokenizer.concrete = true
                return self.interrupt ? ok(code) : continuation(code);
            }
            if ((0, $7da17022313d5182$export$7364aee1c59d1879).includes(buffer.toLowerCase())) {
                marker = 6;
                if (slash) {
                    effects.consume(code);
                    return basicSelfClosing;
                }
                // // Do not form containers.
                // tokenizer.concrete = true
                return self.interrupt ? ok(code) : continuation(code);
            }
            marker = 7;
            // Do not support complete HTML when interrupting.
            return self.interrupt && !self.parser.lazy[self.now().line] ? nok(code) : closingTag ? completeClosingTagAfter(code) : completeAttributeNameBefore(code);
        }
        // ASCII alphanumerical and `-`.
        if (code === 45 || (0, $d81ad7e99936a248$export$75c76db11865a9f4)(code)) {
            effects.consume(code);
            buffer += String.fromCharCode(code);
            return tagName;
        }
        return nok(code);
    }
    /**
   * After closing slash of a basic tag name.
   *
   * ```markdown
   * > | <div/>
   *          ^
   * ```
   *
   * @type {State}
   */ function basicSelfClosing(code) {
        if (code === 62) {
            effects.consume(code);
            // // Do not form containers.
            // tokenizer.concrete = true
            return self.interrupt ? ok : continuation;
        }
        return nok(code);
    }
    /**
   * After closing slash of a complete tag name.
   *
   * ```markdown
   * > | <x/>
   *        ^
   * ```
   *
   * @type {State}
   */ function completeClosingTagAfter(code) {
        if ((0, $d81ad7e99936a248$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return completeClosingTagAfter;
        }
        return completeEnd(code);
    }
    /**
   * At an attribute name.
   *
   * At first, this state is used after a complete tag name, after whitespace,
   * where it expects optional attributes or the end of the tag.
   * It is also reused after attributes, when expecting more optional
   * attributes.
   *
   * ```markdown
   * > | <a />
   *        ^
   * > | <a :b>
   *        ^
   * > | <a _b>
   *        ^
   * > | <a b>
   *        ^
   * > | <a >
   *        ^
   * ```
   *
   * @type {State}
   */ function completeAttributeNameBefore(code) {
        if (code === 47) {
            effects.consume(code);
            return completeEnd;
        }
        // ASCII alphanumerical and `:` and `_`.
        if (code === 58 || code === 95 || (0, $d81ad7e99936a248$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return completeAttributeName;
        }
        if ((0, $d81ad7e99936a248$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return completeAttributeNameBefore;
        }
        return completeEnd(code);
    }
    /**
   * In attribute name.
   *
   * ```markdown
   * > | <a :b>
   *         ^
   * > | <a _b>
   *         ^
   * > | <a b>
   *         ^
   * ```
   *
   * @type {State}
   */ function completeAttributeName(code) {
        // ASCII alphanumerical and `-`, `.`, `:`, and `_`.
        if (code === 45 || code === 46 || code === 58 || code === 95 || (0, $d81ad7e99936a248$export$75c76db11865a9f4)(code)) {
            effects.consume(code);
            return completeAttributeName;
        }
        return completeAttributeNameAfter(code);
    }
    /**
   * After attribute name, at an optional initializer, the end of the tag, or
   * whitespace.
   *
   * ```markdown
   * > | <a b>
   *         ^
   * > | <a b=c>
   *         ^
   * ```
   *
   * @type {State}
   */ function completeAttributeNameAfter(code) {
        if (code === 61) {
            effects.consume(code);
            return completeAttributeValueBefore;
        }
        if ((0, $d81ad7e99936a248$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return completeAttributeNameAfter;
        }
        return completeAttributeNameBefore(code);
    }
    /**
   * Before unquoted, double quoted, or single quoted attribute value, allowing
   * whitespace.
   *
   * ```markdown
   * > | <a b=c>
   *          ^
   * > | <a b="c">
   *          ^
   * ```
   *
   * @type {State}
   */ function completeAttributeValueBefore(code) {
        if (code === null || code === 60 || code === 61 || code === 62 || code === 96) return nok(code);
        if (code === 34 || code === 39) {
            effects.consume(code);
            markerB = code;
            return completeAttributeValueQuoted;
        }
        if ((0, $d81ad7e99936a248$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return completeAttributeValueBefore;
        }
        return completeAttributeValueUnquoted(code);
    }
    /**
   * In double or single quoted attribute value.
   *
   * ```markdown
   * > | <a b="c">
   *           ^
   * > | <a b='c'>
   *           ^
   * ```
   *
   * @type {State}
   */ function completeAttributeValueQuoted(code) {
        if (code === markerB) {
            effects.consume(code);
            markerB = null;
            return completeAttributeValueQuotedAfter;
        }
        if (code === null || (0, $d81ad7e99936a248$export$34a1dff1c0936953)(code)) return nok(code);
        effects.consume(code);
        return completeAttributeValueQuoted;
    }
    /**
   * In unquoted attribute value.
   *
   * ```markdown
   * > | <a b=c>
   *          ^
   * ```
   *
   * @type {State}
   */ function completeAttributeValueUnquoted(code) {
        if (code === null || code === 34 || code === 39 || code === 47 || code === 60 || code === 61 || code === 62 || code === 96 || (0, $d81ad7e99936a248$export$a30284361b3814b7)(code)) return completeAttributeNameAfter(code);
        effects.consume(code);
        return completeAttributeValueUnquoted;
    }
    /**
   * After double or single quoted attribute value, before whitespace or the
   * end of the tag.
   *
   * ```markdown
   * > | <a b="c">
   *            ^
   * ```
   *
   * @type {State}
   */ function completeAttributeValueQuotedAfter(code) {
        if (code === 47 || code === 62 || (0, $d81ad7e99936a248$export$2c6cf65c1127992a)(code)) return completeAttributeNameBefore(code);
        return nok(code);
    }
    /**
   * In certain circumstances of a complete tag where only an `>` is allowed.
   *
   * ```markdown
   * > | <a b="c">
   *             ^
   * ```
   *
   * @type {State}
   */ function completeEnd(code) {
        if (code === 62) {
            effects.consume(code);
            return completeAfter;
        }
        return nok(code);
    }
    /**
   * After `>` in a complete tag.
   *
   * ```markdown
   * > | <x>
   *        ^
   * ```
   *
   * @type {State}
   */ function completeAfter(code) {
        if (code === null || (0, $d81ad7e99936a248$export$34a1dff1c0936953)(code)) // // Do not form containers.
        // tokenizer.concrete = true
        return continuation(code);
        if ((0, $d81ad7e99936a248$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return completeAfter;
        }
        return nok(code);
    }
    /**
   * In continuation of any HTML kind.
   *
   * ```markdown
   * > | <!--xxx-->
   *          ^
   * ```
   *
   * @type {State}
   */ function continuation(code) {
        if (code === 45 && marker === 2) {
            effects.consume(code);
            return continuationCommentInside;
        }
        if (code === 60 && marker === 1) {
            effects.consume(code);
            return continuationRawTagOpen;
        }
        if (code === 62 && marker === 4) {
            effects.consume(code);
            return continuationClose;
        }
        if (code === 63 && marker === 3) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        if (code === 93 && marker === 5) {
            effects.consume(code);
            return continuationCdataInside;
        }
        if ((0, $d81ad7e99936a248$export$34a1dff1c0936953)(code) && (marker === 6 || marker === 7)) {
            effects.exit("htmlFlowData");
            return effects.check($0c7f966054a57f62$var$blankLineBefore, continuationAfter, continuationStart)(code);
        }
        if (code === null || (0, $d81ad7e99936a248$export$34a1dff1c0936953)(code)) {
            effects.exit("htmlFlowData");
            return continuationStart(code);
        }
        effects.consume(code);
        return continuation;
    }
    /**
   * In continuation, at eol.
   *
   * ```markdown
   * > | <x>
   *        ^
   *   | asd
   * ```
   *
   * @type {State}
   */ function continuationStart(code) {
        return effects.check($0c7f966054a57f62$var$nonLazyContinuationStart, continuationStartNonLazy, continuationAfter)(code);
    }
    /**
   * In continuation, at eol, before non-lazy content.
   *
   * ```markdown
   * > | <x>
   *        ^
   *   | asd
   * ```
   *
   * @type {State}
   */ function continuationStartNonLazy(code) {
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return continuationBefore;
    }
    /**
   * In continuation, before non-lazy content.
   *
   * ```markdown
   *   | <x>
   * > | asd
   *     ^
   * ```
   *
   * @type {State}
   */ function continuationBefore(code) {
        if (code === null || (0, $d81ad7e99936a248$export$34a1dff1c0936953)(code)) return continuationStart(code);
        effects.enter("htmlFlowData");
        return continuation(code);
    }
    /**
   * In comment continuation, after one `-`, expecting another.
   *
   * ```markdown
   * > | <!--xxx-->
   *             ^
   * ```
   *
   * @type {State}
   */ function continuationCommentInside(code) {
        if (code === 45) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        return continuation(code);
    }
    /**
   * In raw continuation, after `<`, at `/`.
   *
   * ```markdown
   * > | <script>console.log(1)</script>
   *                            ^
   * ```
   *
   * @type {State}
   */ function continuationRawTagOpen(code) {
        if (code === 47) {
            effects.consume(code);
            buffer = "";
            return continuationRawEndTag;
        }
        return continuation(code);
    }
    /**
   * In raw continuation, after `</`, in a raw tag name.
   *
   * ```markdown
   * > | <script>console.log(1)</script>
   *                             ^^^^^^
   * ```
   *
   * @type {State}
   */ function continuationRawEndTag(code) {
        if (code === 62) {
            const name = buffer.toLowerCase();
            if ((0, $7da17022313d5182$export$948e66da505d080).includes(name)) {
                effects.consume(code);
                return continuationClose;
            }
            return continuation(code);
        }
        if ((0, $d81ad7e99936a248$export$d65d6b62c24d5436)(code) && buffer.length < 8) {
            effects.consume(code);
            // @ts-expect-error: not null.
            buffer += String.fromCharCode(code);
            return continuationRawEndTag;
        }
        return continuation(code);
    }
    /**
   * In cdata continuation, after `]`, expecting `]>`.
   *
   * ```markdown
   * > | <![CDATA[>&<]]>
   *                  ^
   * ```
   *
   * @type {State}
   */ function continuationCdataInside(code) {
        if (code === 93) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        return continuation(code);
    }
    /**
   * In declaration or instruction continuation, at `>`.
   *
   * ```markdown
   * > | <!-->
   *         ^
   * > | <?>
   *       ^
   * > | <!q>
   *        ^
   * > | <!--ab-->
   *             ^
   * > | <![CDATA[>&<]]>
   *                   ^
   * ```
   *
   * @type {State}
   */ function continuationDeclarationInside(code) {
        if (code === 62) {
            effects.consume(code);
            return continuationClose;
        }
        // More dashes.
        if (code === 45 && marker === 2) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        return continuation(code);
    }
    /**
   * In closed continuation: everything we get until the eol/eof is part of it.
   *
   * ```markdown
   * > | <!doctype>
   *               ^
   * ```
   *
   * @type {State}
   */ function continuationClose(code) {
        if (code === null || (0, $d81ad7e99936a248$export$34a1dff1c0936953)(code)) {
            effects.exit("htmlFlowData");
            return continuationAfter(code);
        }
        effects.consume(code);
        return continuationClose;
    }
    /**
   * Done.
   *
   * ```markdown
   * > | <!doctype>
   *               ^
   * ```
   *
   * @type {State}
   */ function continuationAfter(code) {
        effects.exit("htmlFlow");
        // // Feel free to interrupt.
        // tokenizer.interrupt = false
        // // No longer concrete.
        // tokenizer.concrete = false
        return ok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $0c7f966054a57f62$var$tokenizeNonLazyContinuationStart(effects, ok, nok) {
    const self = this;
    return start;
    /**
   * At eol, before continuation.
   *
   * ```markdown
   * > | * ```js
   *            ^
   *   | b
   * ```
   *
   * @type {State}
   */ function start(code) {
        if ((0, $d81ad7e99936a248$export$34a1dff1c0936953)(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return after;
        }
        return nok(code);
    }
    /**
   * A continuation.
   *
   * ```markdown
   *   | * ```js
   * > | b
   *     ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        return self.parser.lazy[self.now().line] ? nok(code) : ok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $0c7f966054a57f62$var$tokenizeBlankLineBefore(effects, ok, nok) {
    return start;
    /**
   * Before eol, expecting blank line.
   *
   * ```markdown
   * > | <div>
   *          ^
   *   |
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return effects.attempt((0, $9a8f432cf07da3bc$export$d50d28ce3ab2a612), ok, nok);
    }
}

/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 

const $6f60a2a163fa1ea8$export$398af27f284914fe = {
    name: "htmlText",
    tokenize: $6f60a2a163fa1ea8$var$tokenizeHtmlText
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $6f60a2a163fa1ea8$var$tokenizeHtmlText(effects, ok, nok) {
    const self = this;
    /** @type {NonNullable<Code> | undefined} */ let marker;
    /** @type {number} */ let index;
    /** @type {State} */ let returnState;
    return start;
    /**
   * Start of HTML (text).
   *
   * ```markdown
   * > | a <b> c
   *       ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("htmlText");
        effects.enter("htmlTextData");
        effects.consume(code);
        return open;
    }
    /**
   * After `<`, at tag name or other stuff.
   *
   * ```markdown
   * > | a <b> c
   *        ^
   * > | a <!doctype> c
   *        ^
   * > | a <!--b--> c
   *        ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if (code === 33) {
            effects.consume(code);
            return declarationOpen;
        }
        if (code === 47) {
            effects.consume(code);
            return tagCloseStart;
        }
        if (code === 63) {
            effects.consume(code);
            return instruction;
        }
        // ASCII alphabetical.
        if ((0, $d81ad7e99936a248$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return tagOpen;
        }
        return nok(code);
    }
    /**
   * After `<!`, at declaration, comment, or CDATA.
   *
   * ```markdown
   * > | a <!doctype> c
   *         ^
   * > | a <!--b--> c
   *         ^
   * > | a <![CDATA[>&<]]> c
   *         ^
   * ```
   *
   * @type {State}
   */ function declarationOpen(code) {
        if (code === 45) {
            effects.consume(code);
            return commentOpenInside;
        }
        if (code === 91) {
            effects.consume(code);
            index = 0;
            return cdataOpenInside;
        }
        if ((0, $d81ad7e99936a248$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return declaration;
        }
        return nok(code);
    }
    /**
   * In a comment, after `<!-`, at another `-`.
   *
   * ```markdown
   * > | a <!--b--> c
   *          ^
   * ```
   *
   * @type {State}
   */ function commentOpenInside(code) {
        if (code === 45) {
            effects.consume(code);
            return commentEnd;
        }
        return nok(code);
    }
    /**
   * In comment.
   *
   * ```markdown
   * > | a <!--b--> c
   *           ^
   * ```
   *
   * @type {State}
   */ function comment(code) {
        if (code === null) return nok(code);
        if (code === 45) {
            effects.consume(code);
            return commentClose;
        }
        if ((0, $d81ad7e99936a248$export$34a1dff1c0936953)(code)) {
            returnState = comment;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return comment;
    }
    /**
   * In comment, after `-`.
   *
   * ```markdown
   * > | a <!--b--> c
   *             ^
   * ```
   *
   * @type {State}
   */ function commentClose(code) {
        if (code === 45) {
            effects.consume(code);
            return commentEnd;
        }
        return comment(code);
    }
    /**
   * In comment, after `--`.
   *
   * ```markdown
   * > | a <!--b--> c
   *              ^
   * ```
   *
   * @type {State}
   */ function commentEnd(code) {
        return code === 62 ? end(code) : code === 45 ? commentClose(code) : comment(code);
    }
    /**
   * After `<![`, in CDATA, expecting `CDATA[`.
   *
   * ```markdown
   * > | a <![CDATA[>&<]]> b
   *          ^^^^^^
   * ```
   *
   * @type {State}
   */ function cdataOpenInside(code) {
        const value = "CDATA[";
        if (code === value.charCodeAt(index++)) {
            effects.consume(code);
            return index === value.length ? cdata : cdataOpenInside;
        }
        return nok(code);
    }
    /**
   * In CDATA.
   *
   * ```markdown
   * > | a <![CDATA[>&<]]> b
   *                ^^^
   * ```
   *
   * @type {State}
   */ function cdata(code) {
        if (code === null) return nok(code);
        if (code === 93) {
            effects.consume(code);
            return cdataClose;
        }
        if ((0, $d81ad7e99936a248$export$34a1dff1c0936953)(code)) {
            returnState = cdata;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return cdata;
    }
    /**
   * In CDATA, after `]`, at another `]`.
   *
   * ```markdown
   * > | a <![CDATA[>&<]]> b
   *                    ^
   * ```
   *
   * @type {State}
   */ function cdataClose(code) {
        if (code === 93) {
            effects.consume(code);
            return cdataEnd;
        }
        return cdata(code);
    }
    /**
   * In CDATA, after `]]`, at `>`.
   *
   * ```markdown
   * > | a <![CDATA[>&<]]> b
   *                     ^
   * ```
   *
   * @type {State}
   */ function cdataEnd(code) {
        if (code === 62) return end(code);
        if (code === 93) {
            effects.consume(code);
            return cdataEnd;
        }
        return cdata(code);
    }
    /**
   * In declaration.
   *
   * ```markdown
   * > | a <!b> c
   *          ^
   * ```
   *
   * @type {State}
   */ function declaration(code) {
        if (code === null || code === 62) return end(code);
        if ((0, $d81ad7e99936a248$export$34a1dff1c0936953)(code)) {
            returnState = declaration;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return declaration;
    }
    /**
   * In instruction.
   *
   * ```markdown
   * > | a <?b?> c
   *         ^
   * ```
   *
   * @type {State}
   */ function instruction(code) {
        if (code === null) return nok(code);
        if (code === 63) {
            effects.consume(code);
            return instructionClose;
        }
        if ((0, $d81ad7e99936a248$export$34a1dff1c0936953)(code)) {
            returnState = instruction;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return instruction;
    }
    /**
   * In instruction, after `?`, at `>`.
   *
   * ```markdown
   * > | a <?b?> c
   *           ^
   * ```
   *
   * @type {State}
   */ function instructionClose(code) {
        return code === 62 ? end(code) : instruction(code);
    }
    /**
   * After `</`, in closing tag, at tag name.
   *
   * ```markdown
   * > | a </b> c
   *         ^
   * ```
   *
   * @type {State}
   */ function tagCloseStart(code) {
        // ASCII alphabetical.
        if ((0, $d81ad7e99936a248$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return tagClose;
        }
        return nok(code);
    }
    /**
   * After `</x`, in a tag name.
   *
   * ```markdown
   * > | a </b> c
   *          ^
   * ```
   *
   * @type {State}
   */ function tagClose(code) {
        // ASCII alphanumerical and `-`.
        if (code === 45 || (0, $d81ad7e99936a248$export$75c76db11865a9f4)(code)) {
            effects.consume(code);
            return tagClose;
        }
        return tagCloseBetween(code);
    }
    /**
   * In closing tag, after tag name.
   *
   * ```markdown
   * > | a </b> c
   *          ^
   * ```
   *
   * @type {State}
   */ function tagCloseBetween(code) {
        if ((0, $d81ad7e99936a248$export$34a1dff1c0936953)(code)) {
            returnState = tagCloseBetween;
            return lineEndingBefore(code);
        }
        if ((0, $d81ad7e99936a248$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return tagCloseBetween;
        }
        return end(code);
    }
    /**
   * After `<x`, in opening tag name.
   *
   * ```markdown
   * > | a <b> c
   *         ^
   * ```
   *
   * @type {State}
   */ function tagOpen(code) {
        // ASCII alphanumerical and `-`.
        if (code === 45 || (0, $d81ad7e99936a248$export$75c76db11865a9f4)(code)) {
            effects.consume(code);
            return tagOpen;
        }
        if (code === 47 || code === 62 || (0, $d81ad7e99936a248$export$a30284361b3814b7)(code)) return tagOpenBetween(code);
        return nok(code);
    }
    /**
   * In opening tag, after tag name.
   *
   * ```markdown
   * > | a <b> c
   *         ^
   * ```
   *
   * @type {State}
   */ function tagOpenBetween(code) {
        if (code === 47) {
            effects.consume(code);
            return end;
        }
        // ASCII alphabetical and `:` and `_`.
        if (code === 58 || code === 95 || (0, $d81ad7e99936a248$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return tagOpenAttributeName;
        }
        if ((0, $d81ad7e99936a248$export$34a1dff1c0936953)(code)) {
            returnState = tagOpenBetween;
            return lineEndingBefore(code);
        }
        if ((0, $d81ad7e99936a248$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return tagOpenBetween;
        }
        return end(code);
    }
    /**
   * In attribute name.
   *
   * ```markdown
   * > | a <b c> d
   *          ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeName(code) {
        // ASCII alphabetical and `-`, `.`, `:`, and `_`.
        if (code === 45 || code === 46 || code === 58 || code === 95 || (0, $d81ad7e99936a248$export$75c76db11865a9f4)(code)) {
            effects.consume(code);
            return tagOpenAttributeName;
        }
        return tagOpenAttributeNameAfter(code);
    }
    /**
   * After attribute name, before initializer, the end of the tag, or
   * whitespace.
   *
   * ```markdown
   * > | a <b c> d
   *           ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeNameAfter(code) {
        if (code === 61) {
            effects.consume(code);
            return tagOpenAttributeValueBefore;
        }
        if ((0, $d81ad7e99936a248$export$34a1dff1c0936953)(code)) {
            returnState = tagOpenAttributeNameAfter;
            return lineEndingBefore(code);
        }
        if ((0, $d81ad7e99936a248$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return tagOpenAttributeNameAfter;
        }
        return tagOpenBetween(code);
    }
    /**
   * Before unquoted, double quoted, or single quoted attribute value, allowing
   * whitespace.
   *
   * ```markdown
   * > | a <b c=d> e
   *            ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeValueBefore(code) {
        if (code === null || code === 60 || code === 61 || code === 62 || code === 96) return nok(code);
        if (code === 34 || code === 39) {
            effects.consume(code);
            marker = code;
            return tagOpenAttributeValueQuoted;
        }
        if ((0, $d81ad7e99936a248$export$34a1dff1c0936953)(code)) {
            returnState = tagOpenAttributeValueBefore;
            return lineEndingBefore(code);
        }
        if ((0, $d81ad7e99936a248$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return tagOpenAttributeValueBefore;
        }
        effects.consume(code);
        return tagOpenAttributeValueUnquoted;
    }
    /**
   * In double or single quoted attribute value.
   *
   * ```markdown
   * > | a <b c="d"> e
   *             ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeValueQuoted(code) {
        if (code === marker) {
            effects.consume(code);
            marker = undefined;
            return tagOpenAttributeValueQuotedAfter;
        }
        if (code === null) return nok(code);
        if ((0, $d81ad7e99936a248$export$34a1dff1c0936953)(code)) {
            returnState = tagOpenAttributeValueQuoted;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return tagOpenAttributeValueQuoted;
    }
    /**
   * In unquoted attribute value.
   *
   * ```markdown
   * > | a <b c=d> e
   *            ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeValueUnquoted(code) {
        if (code === null || code === 34 || code === 39 || code === 60 || code === 61 || code === 96) return nok(code);
        if (code === 47 || code === 62 || (0, $d81ad7e99936a248$export$a30284361b3814b7)(code)) return tagOpenBetween(code);
        effects.consume(code);
        return tagOpenAttributeValueUnquoted;
    }
    /**
   * After double or single quoted attribute value, before whitespace or the end
   * of the tag.
   *
   * ```markdown
   * > | a <b c="d"> e
   *               ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeValueQuotedAfter(code) {
        if (code === 47 || code === 62 || (0, $d81ad7e99936a248$export$a30284361b3814b7)(code)) return tagOpenBetween(code);
        return nok(code);
    }
    /**
   * In certain circumstances of a tag where only an `>` is allowed.
   *
   * ```markdown
   * > | a <b c="d"> e
   *               ^
   * ```
   *
   * @type {State}
   */ function end(code) {
        if (code === 62) {
            effects.consume(code);
            effects.exit("htmlTextData");
            effects.exit("htmlText");
            return ok;
        }
        return nok(code);
    }
    /**
   * At eol.
   *
   * > 👉 **Note**: we can’t have blank lines in text, so no need to worry about
   * > empty tokens.
   *
   * ```markdown
   * > | a <!--a
   *            ^
   *   | b-->
   * ```
   *
   * @type {State}
   */ function lineEndingBefore(code) {
        effects.exit("htmlTextData");
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return lineEndingAfter;
    }
    /**
   * After eol, at optional whitespace.
   *
   * > 👉 **Note**: we can’t have blank lines in text, so no need to worry about
   * > empty tokens.
   *
   * ```markdown
   *   | a <!--a
   * > | b-->
   *     ^
   * ```
   *
   * @type {State}
   */ function lineEndingAfter(code) {
        // Always populated by defaults.
        return (0, $d81ad7e99936a248$export$2c6cf65c1127992a)(code) ? (0, $6b1271da345f2eae$export$ae105c1eb063a0a2)(effects, lineEndingAfterPrefix, "linePrefix", self.parser.constructs.disable.null.includes("codeIndented") ? undefined : 4)(code) : lineEndingAfterPrefix(code);
    }
    /**
   * After eol, after optional whitespace.
   *
   * > 👉 **Note**: we can’t have blank lines in text, so no need to worry about
   * > empty tokens.
   *
   * ```markdown
   *   | a <!--a
   * > | b-->
   *     ^
   * ```
   *
   * @type {State}
   */ function lineEndingAfterPrefix(code) {
        effects.enter("htmlTextData");
        return returnState(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 







const $d51702a396f5d9b9$export$470a5dafbbf62654 = {
    name: "labelEnd",
    tokenize: $d51702a396f5d9b9$var$tokenizeLabelEnd,
    resolveTo: $d51702a396f5d9b9$var$resolveToLabelEnd,
    resolveAll: $d51702a396f5d9b9$var$resolveAllLabelEnd
};
/** @type {Construct} */ const $d51702a396f5d9b9$var$resourceConstruct = {
    tokenize: $d51702a396f5d9b9$var$tokenizeResource
};
/** @type {Construct} */ const $d51702a396f5d9b9$var$referenceFullConstruct = {
    tokenize: $d51702a396f5d9b9$var$tokenizeReferenceFull
};
/** @type {Construct} */ const $d51702a396f5d9b9$var$referenceCollapsedConstruct = {
    tokenize: $d51702a396f5d9b9$var$tokenizeReferenceCollapsed
};
/** @type {Resolver} */ function $d51702a396f5d9b9$var$resolveAllLabelEnd(events) {
    let index = -1;
    while(++index < events.length){
        const token = events[index][1];
        if (token.type === "labelImage" || token.type === "labelLink" || token.type === "labelEnd") {
            // Remove the marker.
            events.splice(index + 1, token.type === "labelImage" ? 4 : 2);
            token.type = "data";
            index++;
        }
    }
    return events;
}
/** @type {Resolver} */ function $d51702a396f5d9b9$var$resolveToLabelEnd(events, context) {
    let index = events.length;
    let offset = 0;
    /** @type {Token} */ let token;
    /** @type {number | undefined} */ let open;
    /** @type {number | undefined} */ let close;
    /** @type {Array<Event>} */ let media;
    // Find an opening.
    while(index--){
        token = events[index][1];
        if (open) {
            // If we see another link, or inactive link label, we’ve been here before.
            if (token.type === "link" || token.type === "labelLink" && token._inactive) break;
            // Mark other link openings as inactive, as we can’t have links in
            // links.
            if (events[index][0] === "enter" && token.type === "labelLink") token._inactive = true;
        } else if (close) {
            if (events[index][0] === "enter" && (token.type === "labelImage" || token.type === "labelLink") && !token._balanced) {
                open = index;
                if (token.type !== "labelLink") {
                    offset = 2;
                    break;
                }
            }
        } else if (token.type === "labelEnd") close = index;
    }
    const group = {
        type: events[open][1].type === "labelLink" ? "link" : "image",
        start: Object.assign({}, events[open][1].start),
        end: Object.assign({}, events[events.length - 1][1].end)
    };
    const label = {
        type: "label",
        start: Object.assign({}, events[open][1].start),
        end: Object.assign({}, events[close][1].end)
    };
    const text = {
        type: "labelText",
        start: Object.assign({}, events[open + offset + 2][1].end),
        end: Object.assign({}, events[close - 2][1].start)
    };
    media = [
        [
            "enter",
            group,
            context
        ],
        [
            "enter",
            label,
            context
        ]
    ];
    // Opening marker.
    media = (0, $76c325c59203cf92$export$4cbf152802aa238)(media, events.slice(open + 1, open + offset + 3));
    // Text open.
    media = (0, $76c325c59203cf92$export$4cbf152802aa238)(media, [
        [
            "enter",
            text,
            context
        ]
    ]);
    // Always populated by defaults.
    // Between.
    media = (0, $76c325c59203cf92$export$4cbf152802aa238)(media, (0, $8c627d7d8981f0bc$export$3ff61ec196ff408b)(context.parser.constructs.insideSpan.null, events.slice(open + offset + 4, close - 3), context));
    // Text close, marker close, label close.
    media = (0, $76c325c59203cf92$export$4cbf152802aa238)(media, [
        [
            "exit",
            text,
            context
        ],
        events[close - 2],
        events[close - 1],
        [
            "exit",
            label,
            context
        ]
    ]);
    // Reference, resource, or so.
    media = (0, $76c325c59203cf92$export$4cbf152802aa238)(media, events.slice(close + 1));
    // Media close.
    media = (0, $76c325c59203cf92$export$4cbf152802aa238)(media, [
        [
            "exit",
            group,
            context
        ]
    ]);
    (0, $76c325c59203cf92$export$869882364835d202)(events, open, events.length, media);
    return events;
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $d51702a396f5d9b9$var$tokenizeLabelEnd(effects, ok, nok) {
    const self = this;
    let index = self.events.length;
    /** @type {Token} */ let labelStart;
    /** @type {boolean} */ let defined;
    // Find an opening.
    while(index--)if ((self.events[index][1].type === "labelImage" || self.events[index][1].type === "labelLink") && !self.events[index][1]._balanced) {
        labelStart = self.events[index][1];
        break;
    }
    return start;
    /**
   * Start of label end.
   *
   * ```markdown
   * > | [a](b) c
   *       ^
   * > | [a][b] c
   *       ^
   * > | [a][] b
   *       ^
   * > | [a] b
   * ```
   *
   * @type {State}
   */ function start(code) {
        // If there is not an okay opening.
        if (!labelStart) return nok(code);
        // If the corresponding label (link) start is marked as inactive,
        // it means we’d be wrapping a link, like this:
        //
        // ```markdown
        // > | a [b [c](d) e](f) g.
        //                  ^
        // ```
        //
        // We can’t have that, so it’s just balanced brackets.
        if (labelStart._inactive) return labelEndNok(code);
        defined = self.parser.defined.includes((0, $17274a453d2d9545$export$806d55e226cfcd08)(self.sliceSerialize({
            start: labelStart.end,
            end: self.now()
        })));
        effects.enter("labelEnd");
        effects.enter("labelMarker");
        effects.consume(code);
        effects.exit("labelMarker");
        effects.exit("labelEnd");
        return after;
    }
    /**
   * After `]`.
   *
   * ```markdown
   * > | [a](b) c
   *       ^
   * > | [a][b] c
   *       ^
   * > | [a][] b
   *       ^
   * > | [a] b
   *       ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        // Note: `markdown-rs` also parses GFM footnotes here, which for us is in
        // an extension.
        // Resource (`[asd](fgh)`)?
        if (code === 40) return effects.attempt($d51702a396f5d9b9$var$resourceConstruct, labelEndOk, defined ? labelEndOk : labelEndNok)(code);
        // Full (`[asd][fgh]`) or collapsed (`[asd][]`) reference?
        if (code === 91) return effects.attempt($d51702a396f5d9b9$var$referenceFullConstruct, labelEndOk, defined ? referenceNotFull : labelEndNok)(code);
        // Shortcut (`[asd]`) reference?
        return defined ? labelEndOk(code) : labelEndNok(code);
    }
    /**
   * After `]`, at `[`, but not at a full reference.
   *
   * > 👉 **Note**: we only get here if the label is defined.
   *
   * ```markdown
   * > | [a][] b
   *        ^
   * > | [a] b
   *        ^
   * ```
   *
   * @type {State}
   */ function referenceNotFull(code) {
        return effects.attempt($d51702a396f5d9b9$var$referenceCollapsedConstruct, labelEndOk, labelEndNok)(code);
    }
    /**
   * Done, we found something.
   *
   * ```markdown
   * > | [a](b) c
   *           ^
   * > | [a][b] c
   *           ^
   * > | [a][] b
   *          ^
   * > | [a] b
   *        ^
   * ```
   *
   * @type {State}
   */ function labelEndOk(code) {
        // Note: `markdown-rs` does a bunch of stuff here.
        return ok(code);
    }
    /**
   * Done, it’s nothing.
   *
   * There was an okay opening, but we didn’t match anything.
   *
   * ```markdown
   * > | [a](b c
   *        ^
   * > | [a][b c
   *        ^
   * > | [a] b
   *        ^
   * ```
   *
   * @type {State}
   */ function labelEndNok(code) {
        labelStart._balanced = true;
        return nok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $d51702a396f5d9b9$var$tokenizeResource(effects, ok, nok) {
    return resourceStart;
    /**
   * At a resource.
   *
   * ```markdown
   * > | [a](b) c
   *        ^
   * ```
   *
   * @type {State}
   */ function resourceStart(code) {
        effects.enter("resource");
        effects.enter("resourceMarker");
        effects.consume(code);
        effects.exit("resourceMarker");
        return resourceBefore;
    }
    /**
   * In resource, after `(`, at optional whitespace.
   *
   * ```markdown
   * > | [a](b) c
   *         ^
   * ```
   *
   * @type {State}
   */ function resourceBefore(code) {
        return (0, $d81ad7e99936a248$export$a30284361b3814b7)(code) ? (0, $83988bbaf37562ec$export$1f27bd1aa33ce173)(effects, resourceOpen)(code) : resourceOpen(code);
    }
    /**
   * In resource, after optional whitespace, at `)` or a destination.
   *
   * ```markdown
   * > | [a](b) c
   *         ^
   * ```
   *
   * @type {State}
   */ function resourceOpen(code) {
        if (code === 41) return resourceEnd(code);
        return (0, $71821775439d38d1$export$2e6c8deaa96af245)(effects, resourceDestinationAfter, resourceDestinationMissing, "resourceDestination", "resourceDestinationLiteral", "resourceDestinationLiteralMarker", "resourceDestinationRaw", "resourceDestinationString", 32)(code);
    }
    /**
   * In resource, after destination, at optional whitespace.
   *
   * ```markdown
   * > | [a](b) c
   *          ^
   * ```
   *
   * @type {State}
   */ function resourceDestinationAfter(code) {
        return (0, $d81ad7e99936a248$export$a30284361b3814b7)(code) ? (0, $83988bbaf37562ec$export$1f27bd1aa33ce173)(effects, resourceBetween)(code) : resourceEnd(code);
    }
    /**
   * At invalid destination.
   *
   * ```markdown
   * > | [a](<<) b
   *         ^
   * ```
   *
   * @type {State}
   */ function resourceDestinationMissing(code) {
        return nok(code);
    }
    /**
   * In resource, after destination and whitespace, at `(` or title.
   *
   * ```markdown
   * > | [a](b ) c
   *           ^
   * ```
   *
   * @type {State}
   */ function resourceBetween(code) {
        if (code === 34 || code === 39 || code === 40) return (0, $cbf87fb23aedd207$export$f970569cc855e483)(effects, resourceTitleAfter, nok, "resourceTitle", "resourceTitleMarker", "resourceTitleString")(code);
        return resourceEnd(code);
    }
    /**
   * In resource, after title, at optional whitespace.
   *
   * ```markdown
   * > | [a](b "c") d
   *              ^
   * ```
   *
   * @type {State}
   */ function resourceTitleAfter(code) {
        return (0, $d81ad7e99936a248$export$a30284361b3814b7)(code) ? (0, $83988bbaf37562ec$export$1f27bd1aa33ce173)(effects, resourceEnd)(code) : resourceEnd(code);
    }
    /**
   * In resource, at `)`.
   *
   * ```markdown
   * > | [a](b) d
   *          ^
   * ```
   *
   * @type {State}
   */ function resourceEnd(code) {
        if (code === 41) {
            effects.enter("resourceMarker");
            effects.consume(code);
            effects.exit("resourceMarker");
            effects.exit("resource");
            return ok;
        }
        return nok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $d51702a396f5d9b9$var$tokenizeReferenceFull(effects, ok, nok) {
    const self = this;
    return referenceFull;
    /**
   * In a reference (full), at the `[`.
   *
   * ```markdown
   * > | [a][b] d
   *        ^
   * ```
   *
   * @type {State}
   */ function referenceFull(code) {
        return (0, $619fab19b6d70741$export$7b768614d8ba97a7).call(self, effects, referenceFullAfter, referenceFullMissing, "reference", "referenceMarker", "referenceString")(code);
    }
    /**
   * In a reference (full), after `]`.
   *
   * ```markdown
   * > | [a][b] d
   *          ^
   * ```
   *
   * @type {State}
   */ function referenceFullAfter(code) {
        return self.parser.defined.includes((0, $17274a453d2d9545$export$806d55e226cfcd08)(self.sliceSerialize(self.events[self.events.length - 1][1]).slice(1, -1))) ? ok(code) : nok(code);
    }
    /**
   * In reference (full) that was missing.
   *
   * ```markdown
   * > | [a][b d
   *        ^
   * ```
   *
   * @type {State}
   */ function referenceFullMissing(code) {
        return nok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $d51702a396f5d9b9$var$tokenizeReferenceCollapsed(effects, ok, nok) {
    return referenceCollapsedStart;
    /**
   * In reference (collapsed), at `[`.
   *
   * > 👉 **Note**: we only get here if the label is defined.
   *
   * ```markdown
   * > | [a][] d
   *        ^
   * ```
   *
   * @type {State}
   */ function referenceCollapsedStart(code) {
        // We only attempt a collapsed label if there’s a `[`.
        effects.enter("reference");
        effects.enter("referenceMarker");
        effects.consume(code);
        effects.exit("referenceMarker");
        return referenceCollapsedOpen;
    }
    /**
   * In reference (collapsed), at `]`.
   *
   * > 👉 **Note**: we only get here if the label is defined.
   *
   * ```markdown
   * > | [a][] d
   *         ^
   * ```
   *
   *  @type {State}
   */ function referenceCollapsedOpen(code) {
        if (code === 93) {
            effects.enter("referenceMarker");
            effects.consume(code);
            effects.exit("referenceMarker");
            effects.exit("reference");
            return ok;
        }
        return nok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
const $11a2c74be80df68e$export$3d754936e25aa5f5 = {
    name: "labelStartImage",
    tokenize: $11a2c74be80df68e$var$tokenizeLabelStartImage,
    resolveAll: (0, $d51702a396f5d9b9$export$470a5dafbbf62654).resolveAll
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $11a2c74be80df68e$var$tokenizeLabelStartImage(effects, ok, nok) {
    const self = this;
    return start;
    /**
   * Start of label (image) start.
   *
   * ```markdown
   * > | a ![b] c
   *       ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("labelImage");
        effects.enter("labelImageMarker");
        effects.consume(code);
        effects.exit("labelImageMarker");
        return open;
    }
    /**
   * After `!`, at `[`.
   *
   * ```markdown
   * > | a ![b] c
   *        ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if (code === 91) {
            effects.enter("labelMarker");
            effects.consume(code);
            effects.exit("labelMarker");
            effects.exit("labelImage");
            return after;
        }
        return nok(code);
    }
    /**
   * After `![`.
   *
   * ```markdown
   * > | a ![b] c
   *         ^
   * ```
   *
   * This is needed in because, when GFM footnotes are enabled, images never
   * form when started with a `^`.
   * Instead, links form:
   *
   * ```markdown
   * ![^a](b)
   *
   * ![^a][b]
   *
   * [b]: c
   * ```
   *
   * ```html
   * <p>!<a href=\"b\">^a</a></p>
   * <p>!<a href=\"c\">^a</a></p>
   * ```
   *
   * @type {State}
   */ function after(code) {
        // To do: use a new field to do this, this is still needed for
        // `micromark-extension-gfm-footnote`, but the `label-start-link`
        // behavior isn’t.
        // Hidden footnotes hook.
        /* c8 ignore next 3 */ return code === 94 && "_hiddenFootnoteSupport" in self.parser.constructs ? nok(code) : ok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
const $226bfba7ed415ca9$export$5c0cee0701a3b584 = {
    name: "labelStartLink",
    tokenize: $226bfba7ed415ca9$var$tokenizeLabelStartLink,
    resolveAll: (0, $d51702a396f5d9b9$export$470a5dafbbf62654).resolveAll
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $226bfba7ed415ca9$var$tokenizeLabelStartLink(effects, ok, nok) {
    const self = this;
    return start;
    /**
   * Start of label (link) start.
   *
   * ```markdown
   * > | a [b] c
   *       ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("labelLink");
        effects.enter("labelMarker");
        effects.consume(code);
        effects.exit("labelMarker");
        effects.exit("labelLink");
        return after;
    }
    /** @type {State} */ function after(code) {
        // To do: this isn’t needed in `micromark-extension-gfm-footnote`,
        // remove.
        // Hidden footnotes hook.
        /* c8 ignore next 3 */ return code === 94 && "_hiddenFootnoteSupport" in self.parser.constructs ? nok(code) : ok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 

const $6695eeb6fd367e78$export$8e62e0ad51c97b2 = {
    name: "lineEnding",
    tokenize: $6695eeb6fd367e78$var$tokenizeLineEnding
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $6695eeb6fd367e78$var$tokenizeLineEnding(effects, ok) {
    return start;
    /** @type {State} */ function start(code) {
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return (0, $6b1271da345f2eae$export$ae105c1eb063a0a2)(effects, ok, "linePrefix");
    }
}

/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').ContainerState} ContainerState
 * @typedef {import('micromark-util-types').Exiter} Exiter
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 


/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 

const $ee88a864226f8b1b$export$ba7b13e047416c03 = {
    name: "thematicBreak",
    tokenize: $ee88a864226f8b1b$var$tokenizeThematicBreak
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $ee88a864226f8b1b$var$tokenizeThematicBreak(effects, ok, nok) {
    let size = 0;
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /**
   * Start of thematic break.
   *
   * ```markdown
   * > | ***
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("thematicBreak");
        // To do: parse indent like `markdown-rs`.
        return before(code);
    }
    /**
   * After optional whitespace, at marker.
   *
   * ```markdown
   * > | ***
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        marker = code;
        return atBreak(code);
    }
    /**
   * After something, before something else.
   *
   * ```markdown
   * > | ***
   *     ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (code === marker) {
            effects.enter("thematicBreakSequence");
            return sequence(code);
        }
        if (size >= 3 && (code === null || (0, $d81ad7e99936a248$export$34a1dff1c0936953)(code))) {
            effects.exit("thematicBreak");
            return ok(code);
        }
        return nok(code);
    }
    /**
   * In sequence.
   *
   * ```markdown
   * > | ***
   *     ^
   * ```
   *
   * @type {State}
   */ function sequence(code) {
        if (code === marker) {
            effects.consume(code);
            size++;
            return sequence;
        }
        effects.exit("thematicBreakSequence");
        return (0, $d81ad7e99936a248$export$2c6cf65c1127992a)(code) ? (0, $6b1271da345f2eae$export$ae105c1eb063a0a2)(effects, atBreak, "whitespace")(code) : atBreak(code);
    }
}


const $eb029944e4ce5dec$export$8837f4fc672e936d = {
    name: "list",
    tokenize: $eb029944e4ce5dec$var$tokenizeListStart,
    continuation: {
        tokenize: $eb029944e4ce5dec$var$tokenizeListContinuation
    },
    exit: $eb029944e4ce5dec$var$tokenizeListEnd
};
/** @type {Construct} */ const $eb029944e4ce5dec$var$listItemPrefixWhitespaceConstruct = {
    tokenize: $eb029944e4ce5dec$var$tokenizeListItemPrefixWhitespace,
    partial: true
};
/** @type {Construct} */ const $eb029944e4ce5dec$var$indentConstruct = {
    tokenize: $eb029944e4ce5dec$var$tokenizeIndent,
    partial: true
};
// To do: `markdown-rs` parses list items on their own and later stitches them
// together.
/**
 * @type {Tokenizer}
 * @this {TokenizeContext}
 */ function $eb029944e4ce5dec$var$tokenizeListStart(effects, ok, nok) {
    const self = this;
    const tail = self.events[self.events.length - 1];
    let initialSize = tail && tail[1].type === "linePrefix" ? tail[2].sliceSerialize(tail[1], true).length : 0;
    let size = 0;
    return start;
    /** @type {State} */ function start(code) {
        const kind = self.containerState.type || (code === 42 || code === 43 || code === 45 ? "listUnordered" : "listOrdered");
        if (kind === "listUnordered" ? !self.containerState.marker || code === self.containerState.marker : (0, $d81ad7e99936a248$export$ca8b5b1a6c320e6e)(code)) {
            if (!self.containerState.type) {
                self.containerState.type = kind;
                effects.enter(kind, {
                    _container: true
                });
            }
            if (kind === "listUnordered") {
                effects.enter("listItemPrefix");
                return code === 42 || code === 45 ? effects.check((0, $ee88a864226f8b1b$export$ba7b13e047416c03), nok, atMarker)(code) : atMarker(code);
            }
            if (!self.interrupt || code === 49) {
                effects.enter("listItemPrefix");
                effects.enter("listItemValue");
                return inside(code);
            }
        }
        return nok(code);
    }
    /** @type {State} */ function inside(code) {
        if ((0, $d81ad7e99936a248$export$ca8b5b1a6c320e6e)(code) && ++size < 10) {
            effects.consume(code);
            return inside;
        }
        if ((!self.interrupt || size < 2) && (self.containerState.marker ? code === self.containerState.marker : code === 41 || code === 46)) {
            effects.exit("listItemValue");
            return atMarker(code);
        }
        return nok(code);
    }
    /**
   * @type {State}
   **/ function atMarker(code) {
        effects.enter("listItemMarker");
        effects.consume(code);
        effects.exit("listItemMarker");
        self.containerState.marker = self.containerState.marker || code;
        return effects.check((0, $9a8f432cf07da3bc$export$d50d28ce3ab2a612), // Can’t be empty when interrupting.
        self.interrupt ? nok : onBlank, effects.attempt($eb029944e4ce5dec$var$listItemPrefixWhitespaceConstruct, endOfPrefix, otherPrefix));
    }
    /** @type {State} */ function onBlank(code) {
        self.containerState.initialBlankLine = true;
        initialSize++;
        return endOfPrefix(code);
    }
    /** @type {State} */ function otherPrefix(code) {
        if ((0, $d81ad7e99936a248$export$2c6cf65c1127992a)(code)) {
            effects.enter("listItemPrefixWhitespace");
            effects.consume(code);
            effects.exit("listItemPrefixWhitespace");
            return endOfPrefix;
        }
        return nok(code);
    }
    /** @type {State} */ function endOfPrefix(code) {
        self.containerState.size = initialSize + self.sliceSerialize(effects.exit("listItemPrefix"), true).length;
        return ok(code);
    }
}
/**
 * @type {Tokenizer}
 * @this {TokenizeContext}
 */ function $eb029944e4ce5dec$var$tokenizeListContinuation(effects, ok, nok) {
    const self = this;
    self.containerState._closeFlow = undefined;
    return effects.check((0, $9a8f432cf07da3bc$export$d50d28ce3ab2a612), onBlank, notBlank);
    /** @type {State} */ function onBlank(code) {
        self.containerState.furtherBlankLines = self.containerState.furtherBlankLines || self.containerState.initialBlankLine;
        // We have a blank line.
        // Still, try to consume at most the items size.
        return (0, $6b1271da345f2eae$export$ae105c1eb063a0a2)(effects, ok, "listItemIndent", self.containerState.size + 1)(code);
    }
    /** @type {State} */ function notBlank(code) {
        if (self.containerState.furtherBlankLines || !(0, $d81ad7e99936a248$export$2c6cf65c1127992a)(code)) {
            self.containerState.furtherBlankLines = undefined;
            self.containerState.initialBlankLine = undefined;
            return notInCurrentItem(code);
        }
        self.containerState.furtherBlankLines = undefined;
        self.containerState.initialBlankLine = undefined;
        return effects.attempt($eb029944e4ce5dec$var$indentConstruct, ok, notInCurrentItem)(code);
    }
    /** @type {State} */ function notInCurrentItem(code) {
        // While we do continue, we signal that the flow should be closed.
        self.containerState._closeFlow = true;
        // As we’re closing flow, we’re no longer interrupting.
        self.interrupt = undefined;
        // Always populated by defaults.
        return (0, $6b1271da345f2eae$export$ae105c1eb063a0a2)(effects, effects.attempt($eb029944e4ce5dec$export$8837f4fc672e936d, ok, nok), "linePrefix", self.parser.constructs.disable.null.includes("codeIndented") ? undefined : 4)(code);
    }
}
/**
 * @type {Tokenizer}
 * @this {TokenizeContext}
 */ function $eb029944e4ce5dec$var$tokenizeIndent(effects, ok, nok) {
    const self = this;
    return (0, $6b1271da345f2eae$export$ae105c1eb063a0a2)(effects, afterPrefix, "listItemIndent", self.containerState.size + 1);
    /** @type {State} */ function afterPrefix(code) {
        const tail = self.events[self.events.length - 1];
        return tail && tail[1].type === "listItemIndent" && tail[2].sliceSerialize(tail[1], true).length === self.containerState.size ? ok(code) : nok(code);
    }
}
/**
 * @type {Exiter}
 * @this {TokenizeContext}
 */ function $eb029944e4ce5dec$var$tokenizeListEnd(effects) {
    effects.exit(this.containerState.type);
}
/**
 * @type {Tokenizer}
 * @this {TokenizeContext}
 */ function $eb029944e4ce5dec$var$tokenizeListItemPrefixWhitespace(effects, ok, nok) {
    const self = this;
    // Always populated by defaults.
    return (0, $6b1271da345f2eae$export$ae105c1eb063a0a2)(effects, afterPrefix, "listItemPrefixWhitespace", self.parser.constructs.disable.null.includes("codeIndented") ? undefined : 5);
    /** @type {State} */ function afterPrefix(code) {
        const tail = self.events[self.events.length - 1];
        return !(0, $d81ad7e99936a248$export$2c6cf65c1127992a)(code) && tail && tail[1].type === "listItemPrefixWhitespace" ? ok(code) : nok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 

const $edc779c1e7be74e6$export$e104e2de391dfde9 = {
    name: "setextUnderline",
    tokenize: $edc779c1e7be74e6$var$tokenizeSetextUnderline,
    resolveTo: $edc779c1e7be74e6$var$resolveToSetextUnderline
};
/** @type {Resolver} */ function $edc779c1e7be74e6$var$resolveToSetextUnderline(events, context) {
    // To do: resolve like `markdown-rs`.
    let index = events.length;
    /** @type {number | undefined} */ let content;
    /** @type {number | undefined} */ let text;
    /** @type {number | undefined} */ let definition;
    // Find the opening of the content.
    // It’ll always exist: we don’t tokenize if it isn’t there.
    while(index--)if (events[index][0] === "enter") {
        if (events[index][1].type === "content") {
            content = index;
            break;
        }
        if (events[index][1].type === "paragraph") text = index;
    } else {
        if (events[index][1].type === "content") // Remove the content end (if needed we’ll add it later)
        events.splice(index, 1);
        if (!definition && events[index][1].type === "definition") definition = index;
    }
    const heading = {
        type: "setextHeading",
        start: Object.assign({}, events[text][1].start),
        end: Object.assign({}, events[events.length - 1][1].end)
    };
    // Change the paragraph to setext heading text.
    events[text][1].type = "setextHeadingText";
    // If we have definitions in the content, we’ll keep on having content,
    // but we need move it.
    if (definition) {
        events.splice(text, 0, [
            "enter",
            heading,
            context
        ]);
        events.splice(definition + 1, 0, [
            "exit",
            events[content][1],
            context
        ]);
        events[content][1].end = Object.assign({}, events[definition][1].end);
    } else events[content][1] = heading;
    // Add the heading exit at the end.
    events.push([
        "exit",
        heading,
        context
    ]);
    return events;
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $edc779c1e7be74e6$var$tokenizeSetextUnderline(effects, ok, nok) {
    const self = this;
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /**
   * At start of heading (setext) underline.
   *
   * ```markdown
   *   | aa
   * > | ==
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        let index = self.events.length;
        /** @type {boolean | undefined} */ let paragraph;
        // Find an opening.
        while(index--)// Skip enter/exit of line ending, line prefix, and content.
        // We can now either have a definition or a paragraph.
        if (self.events[index][1].type !== "lineEnding" && self.events[index][1].type !== "linePrefix" && self.events[index][1].type !== "content") {
            paragraph = self.events[index][1].type === "paragraph";
            break;
        }
        // To do: handle lazy/pierce like `markdown-rs`.
        // To do: parse indent like `markdown-rs`.
        if (!self.parser.lazy[self.now().line] && (self.interrupt || paragraph)) {
            effects.enter("setextHeadingLine");
            marker = code;
            return before(code);
        }
        return nok(code);
    }
    /**
   * After optional whitespace, at `-` or `=`.
   *
   * ```markdown
   *   | aa
   * > | ==
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        effects.enter("setextHeadingLineSequence");
        return inside(code);
    }
    /**
   * In sequence.
   *
   * ```markdown
   *   | aa
   * > | ==
   *     ^
   * ```
   *
   * @type {State}
   */ function inside(code) {
        if (code === marker) {
            effects.consume(code);
            return inside;
        }
        effects.exit("setextHeadingLineSequence");
        return (0, $d81ad7e99936a248$export$2c6cf65c1127992a)(code) ? (0, $6b1271da345f2eae$export$ae105c1eb063a0a2)(effects, after, "lineSuffix")(code) : after(code);
    }
    /**
   * After sequence, after optional whitespace.
   *
   * ```markdown
   *   | aa
   * > | ==
   *       ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        if (code === null || (0, $d81ad7e99936a248$export$34a1dff1c0936953)(code)) {
            effects.exit("setextHeadingLine");
            return ok(code);
        }
        return nok(code);
    }
}



const $1090fe39f413abf4$export$5a7bfc01df82fcd1 = {
    [42]: (0, $eb029944e4ce5dec$export$8837f4fc672e936d),
    [43]: (0, $eb029944e4ce5dec$export$8837f4fc672e936d),
    [45]: (0, $eb029944e4ce5dec$export$8837f4fc672e936d),
    [48]: (0, $eb029944e4ce5dec$export$8837f4fc672e936d),
    [49]: (0, $eb029944e4ce5dec$export$8837f4fc672e936d),
    [50]: (0, $eb029944e4ce5dec$export$8837f4fc672e936d),
    [51]: (0, $eb029944e4ce5dec$export$8837f4fc672e936d),
    [52]: (0, $eb029944e4ce5dec$export$8837f4fc672e936d),
    [53]: (0, $eb029944e4ce5dec$export$8837f4fc672e936d),
    [54]: (0, $eb029944e4ce5dec$export$8837f4fc672e936d),
    [55]: (0, $eb029944e4ce5dec$export$8837f4fc672e936d),
    [56]: (0, $eb029944e4ce5dec$export$8837f4fc672e936d),
    [57]: (0, $eb029944e4ce5dec$export$8837f4fc672e936d),
    [62]: (0, $900bbb622fb7b735$export$200dcd0a5903c968)
};
const $1090fe39f413abf4$export$5a2181fb44b58173 = {
    [91]: (0, $39908b58f48f618f$export$69f215ed977cdb73)
};
const $1090fe39f413abf4$export$cf8bead395eff824 = {
    [-2]: (0, $6937836985201beb$export$47910b7ab28d1853),
    [-1]: (0, $6937836985201beb$export$47910b7ab28d1853),
    [32]: (0, $6937836985201beb$export$47910b7ab28d1853)
};
const $1090fe39f413abf4$export$ccc7b0636abaffc3 = {
    [35]: (0, $75419b66e74e72ff$export$3871e9deb360695c),
    [42]: (0, $ee88a864226f8b1b$export$ba7b13e047416c03),
    [45]: [
        (0, $edc779c1e7be74e6$export$e104e2de391dfde9),
        (0, $ee88a864226f8b1b$export$ba7b13e047416c03)
    ],
    [60]: (0, $0c7f966054a57f62$export$476ac411cb7d0d8f),
    [61]: (0, $edc779c1e7be74e6$export$e104e2de391dfde9),
    [95]: (0, $ee88a864226f8b1b$export$ba7b13e047416c03),
    [96]: (0, $9249db89b677551f$export$c23e4921f8d87e7c),
    [126]: (0, $9249db89b677551f$export$c23e4921f8d87e7c)
};
const $1090fe39f413abf4$export$22b082955e083ec3 = {
    [38]: (0, $a6d6696ff4e6734a$export$e31905600aaf3d8e),
    [92]: (0, $26b6f01e555220c8$export$2005478564e78d96)
};
const $1090fe39f413abf4$export$6f093cfa640b7166 = {
    [-5]: (0, $6695eeb6fd367e78$export$8e62e0ad51c97b2),
    [-4]: (0, $6695eeb6fd367e78$export$8e62e0ad51c97b2),
    [-3]: (0, $6695eeb6fd367e78$export$8e62e0ad51c97b2),
    [33]: (0, $11a2c74be80df68e$export$3d754936e25aa5f5),
    [38]: (0, $a6d6696ff4e6734a$export$e31905600aaf3d8e),
    [42]: (0, $ce367f8ac9c782b1$export$45b92471da762af7),
    [60]: [
        (0, $7be1ff4bb2d3c2bf$export$17ddf85e4c916ad6),
        (0, $6f60a2a163fa1ea8$export$398af27f284914fe)
    ],
    [91]: (0, $226bfba7ed415ca9$export$5c0cee0701a3b584),
    [92]: [
        (0, $ae7f6631b895185e$export$86c573ab9e06f418),
        (0, $26b6f01e555220c8$export$2005478564e78d96)
    ],
    [93]: (0, $d51702a396f5d9b9$export$470a5dafbbf62654),
    [95]: (0, $ce367f8ac9c782b1$export$45b92471da762af7),
    [96]: (0, $45a5b87f264f3656$export$d24f93e715f9df88)
};
const $1090fe39f413abf4$export$d44f260a3f9b69f5 = {
    null: [
        (0, $ce367f8ac9c782b1$export$45b92471da762af7),
        (0, $b239fcee5de6bd06$export$50397835cbfdbc24)
    ]
};
const $1090fe39f413abf4$export$b9c0b60d74426aea = {
    null: [
        42,
        95
    ]
};
const $1090fe39f413abf4$export$e20fbacbb41798b = {
    null: []
};


function $d4b5b23891220d8a$export$98e6a39c04603d36(options) {
    const settings = options || {};
    const constructs = /** @type {FullNormalizedExtension} */ (0, $68d1ffdc2f9ceacd$export$86a865d89ef3c690)([
        $1090fe39f413abf4$exports,
        ...settings.extensions || []
    ]);
    /** @type {ParseContext} */ const parser = {
        defined: [],
        lazy: {},
        constructs: constructs,
        content: create((0, $b17da7b71db961f1$export$a7db06668cad9adb)),
        document: create((0, $1d851c3e054f4ef9$export$5a7bfc01df82fcd1)),
        flow: create((0, $ce4f9ce193a3c63d$export$ccc7b0636abaffc3)),
        string: create((0, $b239fcee5de6bd06$export$22b082955e083ec3)),
        text: create((0, $b239fcee5de6bd06$export$6f093cfa640b7166))
    };
    return parser;
    /**
   * @param {InitialConstruct} initial
   */ function create(initial) {
        return creator;
        /** @type {Create} */ function creator(from) {
            return (0, $a1fbefe644618fda$export$ae34f10ee4b29837)(parser, initial, from);
        }
    }
}


/**
 * @typedef {import('micromark-util-types').Chunk} Chunk
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Encoding} Encoding
 * @typedef {import('micromark-util-types').Value} Value
 */ /**
 * @callback Preprocessor
 * @param {Value} value
 * @param {Encoding | null | undefined} [encoding]
 * @param {boolean | null | undefined} [end=false]
 * @returns {Array<Chunk>}
 */ const $52c231118c422278$var$search = /[\0\t\n\r]/g;
function $52c231118c422278$export$fc37fe19dfda43ee() {
    let column = 1;
    let buffer = "";
    /** @type {boolean | undefined} */ let start = true;
    /** @type {boolean | undefined} */ let atCarriageReturn;
    return preprocessor;
    /** @type {Preprocessor} */ function preprocessor(value, encoding, end) {
        /** @type {Array<Chunk>} */ const chunks = [];
        /** @type {RegExpMatchArray | null} */ let match;
        /** @type {number} */ let next;
        /** @type {number} */ let startPosition;
        /** @type {number} */ let endPosition;
        /** @type {Code} */ let code;
        // @ts-expect-error `Buffer` does allow an encoding.
        value = buffer + value.toString(encoding);
        startPosition = 0;
        buffer = "";
        if (start) {
            // To do: `markdown-rs` actually parses BOMs (byte order mark).
            if (value.charCodeAt(0) === 65279) startPosition++;
            start = undefined;
        }
        while(startPosition < value.length){
            $52c231118c422278$var$search.lastIndex = startPosition;
            match = $52c231118c422278$var$search.exec(value);
            endPosition = match && match.index !== undefined ? match.index : value.length;
            code = value.charCodeAt(endPosition);
            if (!match) {
                buffer = value.slice(startPosition);
                break;
            }
            if (code === 10 && startPosition === endPosition && atCarriageReturn) {
                chunks.push(-3);
                atCarriageReturn = undefined;
            } else {
                if (atCarriageReturn) {
                    chunks.push(-5);
                    atCarriageReturn = undefined;
                }
                if (startPosition < endPosition) {
                    chunks.push(value.slice(startPosition, endPosition));
                    column += endPosition - startPosition;
                }
                switch(code){
                    case 0:
                        chunks.push(65533);
                        column++;
                        break;
                    case 9:
                        next = Math.ceil(column / 4) * 4;
                        chunks.push(-2);
                        while(column++ < next)chunks.push(-1);
                        break;
                    case 10:
                        chunks.push(-4);
                        column = 1;
                        break;
                    default:
                        atCarriageReturn = true;
                        column = 1;
                }
            }
            startPosition = endPosition + 1;
        }
        if (end) {
            if (atCarriageReturn) chunks.push(-5);
            if (buffer) chunks.push(buffer);
            chunks.push(null);
        }
        return chunks;
    }
}


/**
 * @typedef {import('micromark-util-types').Event} Event
 */ 
function $58f822a984b96dda$export$bd0e6e1378a871d7(events) {
    while(!(0, $cdb27b5ff11c315a$export$12949d1dd00fddf4)(events));
    return events;
}







const $fe273cf4adb912a5$var$own = {}.hasOwnProperty;
const $fe273cf4adb912a5$export$d744d789c09bfde6 = /**
   * @type {(
   *   ((value: Value, encoding: Encoding, options?: Options | null | undefined) => Root) &
   *   ((value: Value, options?: Options | null | undefined) => Root)
   * )}
   */ /**
   * @param {Value} value
   * @param {Encoding | Options | null | undefined} [encoding]
   * @param {Options | null | undefined} [options]
   * @returns {Root}
   */ function(value, encoding, options) {
    if (typeof encoding !== "string") {
        options = encoding;
        encoding = undefined;
    }
    return $fe273cf4adb912a5$var$compiler(options)((0, $58f822a984b96dda$export$bd0e6e1378a871d7)((0, $d4b5b23891220d8a$export$98e6a39c04603d36)(options).document().write((0, $52c231118c422278$export$fc37fe19dfda43ee)()(value, encoding, true))));
};
/**
 * Note this compiler only understand complete buffering, not streaming.
 *
 * @param {Options | null | undefined} [options]
 */ function $fe273cf4adb912a5$var$compiler(options) {
    /** @type {Config} */ const config = {
        transforms: [],
        canContainEols: [
            "emphasis",
            "fragment",
            "heading",
            "paragraph",
            "strong"
        ],
        enter: {
            autolink: opener(link),
            autolinkProtocol: onenterdata,
            autolinkEmail: onenterdata,
            atxHeading: opener(heading),
            blockQuote: opener(blockQuote),
            characterEscape: onenterdata,
            characterReference: onenterdata,
            codeFenced: opener(codeFlow),
            codeFencedFenceInfo: buffer,
            codeFencedFenceMeta: buffer,
            codeIndented: opener(codeFlow, buffer),
            codeText: opener(codeText, buffer),
            codeTextData: onenterdata,
            data: onenterdata,
            codeFlowValue: onenterdata,
            definition: opener(definition),
            definitionDestinationString: buffer,
            definitionLabelString: buffer,
            definitionTitleString: buffer,
            emphasis: opener(emphasis),
            hardBreakEscape: opener(hardBreak),
            hardBreakTrailing: opener(hardBreak),
            htmlFlow: opener(html, buffer),
            htmlFlowData: onenterdata,
            htmlText: opener(html, buffer),
            htmlTextData: onenterdata,
            image: opener(image),
            label: buffer,
            link: opener(link),
            listItem: opener(listItem),
            listItemValue: onenterlistitemvalue,
            listOrdered: opener(list, onenterlistordered),
            listUnordered: opener(list),
            paragraph: opener(paragraph),
            reference: onenterreference,
            referenceString: buffer,
            resourceDestinationString: buffer,
            resourceTitleString: buffer,
            setextHeading: opener(heading),
            strong: opener(strong),
            thematicBreak: opener(thematicBreak)
        },
        exit: {
            atxHeading: closer(),
            atxHeadingSequence: onexitatxheadingsequence,
            autolink: closer(),
            autolinkEmail: onexitautolinkemail,
            autolinkProtocol: onexitautolinkprotocol,
            blockQuote: closer(),
            characterEscapeValue: onexitdata,
            characterReferenceMarkerHexadecimal: onexitcharacterreferencemarker,
            characterReferenceMarkerNumeric: onexitcharacterreferencemarker,
            characterReferenceValue: onexitcharacterreferencevalue,
            codeFenced: closer(onexitcodefenced),
            codeFencedFence: onexitcodefencedfence,
            codeFencedFenceInfo: onexitcodefencedfenceinfo,
            codeFencedFenceMeta: onexitcodefencedfencemeta,
            codeFlowValue: onexitdata,
            codeIndented: closer(onexitcodeindented),
            codeText: closer(onexitcodetext),
            codeTextData: onexitdata,
            data: onexitdata,
            definition: closer(),
            definitionDestinationString: onexitdefinitiondestinationstring,
            definitionLabelString: onexitdefinitionlabelstring,
            definitionTitleString: onexitdefinitiontitlestring,
            emphasis: closer(),
            hardBreakEscape: closer(onexithardbreak),
            hardBreakTrailing: closer(onexithardbreak),
            htmlFlow: closer(onexithtmlflow),
            htmlFlowData: onexitdata,
            htmlText: closer(onexithtmltext),
            htmlTextData: onexitdata,
            image: closer(onexitimage),
            label: onexitlabel,
            labelText: onexitlabeltext,
            lineEnding: onexitlineending,
            link: closer(onexitlink),
            listItem: closer(),
            listOrdered: closer(),
            listUnordered: closer(),
            paragraph: closer(),
            referenceString: onexitreferencestring,
            resourceDestinationString: onexitresourcedestinationstring,
            resourceTitleString: onexitresourcetitlestring,
            resource: onexitresource,
            setextHeading: closer(onexitsetextheading),
            setextHeadingLineSequence: onexitsetextheadinglinesequence,
            setextHeadingText: onexitsetextheadingtext,
            strong: closer(),
            thematicBreak: closer()
        }
    };
    $fe273cf4adb912a5$var$configure(config, (options || {}).mdastExtensions || []);
    /** @type {CompileData} */ const data = {};
    return compile;
    /**
   * Turn micromark events into an mdast tree.
   *
   * @param {Array<Event>} events
   *   Events.
   * @returns {Root}
   *   mdast tree.
   */ function compile(events) {
        /** @type {Root} */ let tree = {
            type: "root",
            children: []
        };
        /** @type {Omit<CompileContext, 'sliceSerialize'>} */ const context = {
            stack: [
                tree
            ],
            tokenStack: [],
            config: config,
            enter: enter,
            exit: exit,
            buffer: buffer,
            resume: resume,
            setData: setData,
            getData: getData
        };
        /** @type {Array<number>} */ const listStack = [];
        let index = -1;
        while(++index < events.length)// We preprocess lists to add `listItem` tokens, and to infer whether
        // items the list itself are spread out.
        if (events[index][1].type === "listOrdered" || events[index][1].type === "listUnordered") {
            if (events[index][0] === "enter") listStack.push(index);
            else {
                const tail = listStack.pop();
                index = prepareList(events, tail, index);
            }
        }
        index = -1;
        while(++index < events.length){
            const handler = config[events[index][0]];
            if ($fe273cf4adb912a5$var$own.call(handler, events[index][1].type)) handler[events[index][1].type].call(Object.assign({
                sliceSerialize: events[index][2].sliceSerialize
            }, context), events[index][1]);
        }
        // Handle tokens still being open.
        if (context.tokenStack.length > 0) {
            const tail = context.tokenStack[context.tokenStack.length - 1];
            const handler = tail[1] || $fe273cf4adb912a5$var$defaultOnError;
            handler.call(context, undefined, tail[0]);
        }
        // Figure out `root` position.
        tree.position = {
            start: $fe273cf4adb912a5$var$point(events.length > 0 ? events[0][1].start : {
                line: 1,
                column: 1,
                offset: 0
            }),
            end: $fe273cf4adb912a5$var$point(events.length > 0 ? events[events.length - 2][1].end : {
                line: 1,
                column: 1,
                offset: 0
            })
        };
        // Call transforms.
        index = -1;
        while(++index < config.transforms.length)tree = config.transforms[index](tree) || tree;
        return tree;
    }
    /**
   * @param {Array<Event>} events
   * @param {number} start
   * @param {number} length
   * @returns {number}
   */ function prepareList(events, start, length) {
        let index = start - 1;
        let containerBalance = -1;
        let listSpread = false;
        /** @type {Token | undefined} */ let listItem;
        /** @type {number | undefined} */ let lineIndex;
        /** @type {number | undefined} */ let firstBlankLineIndex;
        /** @type {boolean | undefined} */ let atMarker;
        while(++index <= length){
            const event = events[index];
            if (event[1].type === "listUnordered" || event[1].type === "listOrdered" || event[1].type === "blockQuote") {
                if (event[0] === "enter") containerBalance++;
                else containerBalance--;
                atMarker = undefined;
            } else if (event[1].type === "lineEndingBlank") {
                if (event[0] === "enter") {
                    if (listItem && !atMarker && !containerBalance && !firstBlankLineIndex) firstBlankLineIndex = index;
                    atMarker = undefined;
                }
            } else if (event[1].type === "linePrefix" || event[1].type === "listItemValue" || event[1].type === "listItemMarker" || event[1].type === "listItemPrefix" || event[1].type === "listItemPrefixWhitespace") ;
            else atMarker = undefined;
            if (!containerBalance && event[0] === "enter" && event[1].type === "listItemPrefix" || containerBalance === -1 && event[0] === "exit" && (event[1].type === "listUnordered" || event[1].type === "listOrdered")) {
                if (listItem) {
                    let tailIndex = index;
                    lineIndex = undefined;
                    while(tailIndex--){
                        const tailEvent = events[tailIndex];
                        if (tailEvent[1].type === "lineEnding" || tailEvent[1].type === "lineEndingBlank") {
                            if (tailEvent[0] === "exit") continue;
                            if (lineIndex) {
                                events[lineIndex][1].type = "lineEndingBlank";
                                listSpread = true;
                            }
                            tailEvent[1].type = "lineEnding";
                            lineIndex = tailIndex;
                        } else if (tailEvent[1].type === "linePrefix" || tailEvent[1].type === "blockQuotePrefix" || tailEvent[1].type === "blockQuotePrefixWhitespace" || tailEvent[1].type === "blockQuoteMarker" || tailEvent[1].type === "listItemIndent") ;
                        else break;
                    }
                    if (firstBlankLineIndex && (!lineIndex || firstBlankLineIndex < lineIndex)) listItem._spread = true;
                    // Fix position.
                    listItem.end = Object.assign({}, lineIndex ? events[lineIndex][1].start : event[1].end);
                    events.splice(lineIndex || index, 0, [
                        "exit",
                        listItem,
                        event[2]
                    ]);
                    index++;
                    length++;
                }
                // Create a new list item.
                if (event[1].type === "listItemPrefix") {
                    listItem = {
                        type: "listItem",
                        _spread: false,
                        start: Object.assign({}, event[1].start),
                        // @ts-expect-error: we’ll add `end` in a second.
                        end: undefined
                    };
                    // @ts-expect-error: `listItem` is most definitely defined, TS...
                    events.splice(index, 0, [
                        "enter",
                        listItem,
                        event[2]
                    ]);
                    index++;
                    length++;
                    firstBlankLineIndex = undefined;
                    atMarker = true;
                }
            }
        }
        events[start][1]._spread = listSpread;
        return length;
    }
    /**
   * Set data.
   *
   * @template {keyof CompileData} Key
   *   Field type.
   * @param {Key} key
   *   Key of field.
   * @param {CompileData[Key]} [value]
   *   New value.
   * @returns {void}
   *   Nothing.
   */ function setData(key, value) {
        data[key] = value;
    }
    /**
   * Get data.
   *
   * @template {keyof CompileData} Key
   *   Field type.
   * @param {Key} key
   *   Key of field.
   * @returns {CompileData[Key]}
   *   Value.
   */ function getData(key) {
        return data[key];
    }
    /**
   * Create an opener handle.
   *
   * @param {(token: Token) => Node} create
   *   Create a node.
   * @param {Handle} [and]
   *   Optional function to also run.
   * @returns {Handle}
   *   Handle.
   */ function opener(create, and) {
        return open;
        /**
     * @this {CompileContext}
     * @param {Token} token
     * @returns {void}
     */ function open(token) {
            enter.call(this, create(token), token);
            if (and) and.call(this, token);
        }
    }
    /**
   * @this {CompileContext}
   * @returns {void}
   */ function buffer() {
        this.stack.push({
            type: "fragment",
            children: []
        });
    }
    /**
   * @template {Node} Kind
   *   Node type.
   * @this {CompileContext}
   *   Context.
   * @param {Kind} node
   *   Node to enter.
   * @param {Token} token
   *   Corresponding token.
   * @param {OnEnterError | undefined} [errorHandler]
   *   Handle the case where this token is open, but it is closed by something else.
   * @returns {Kind}
   *   The given node.
   */ function enter(node, token, errorHandler) {
        const parent = this.stack[this.stack.length - 1];
        // @ts-expect-error: Assume `Node` can exist as a child of `parent`.
        parent.children.push(node);
        this.stack.push(node);
        this.tokenStack.push([
            token,
            errorHandler
        ]);
        // @ts-expect-error: `end` will be patched later.
        node.position = {
            start: $fe273cf4adb912a5$var$point(token.start)
        };
        return node;
    }
    /**
   * Create a closer handle.
   *
   * @param {Handle} [and]
   *   Optional function to also run.
   * @returns {Handle}
   *   Handle.
   */ function closer(and) {
        return close;
        /**
     * @this {CompileContext}
     * @param {Token} token
     * @returns {void}
     */ function close(token) {
            if (and) and.call(this, token);
            exit.call(this, token);
        }
    }
    /**
   * @this {CompileContext}
   *   Context.
   * @param {Token} token
   *   Corresponding token.
   * @param {OnExitError | undefined} [onExitError]
   *   Handle the case where another token is open.
   * @returns {Node}
   *   The closed node.
   */ function exit(token, onExitError) {
        const node = this.stack.pop();
        const open = this.tokenStack.pop();
        if (!open) throw new Error("Cannot close `" + token.type + "` (" + (0, $06fafbeb21cd8799$export$c304dd45fe166145)({
            start: token.start,
            end: token.end
        }) + "): it\u2019s not open");
        else if (open[0].type !== token.type) {
            if (onExitError) onExitError.call(this, token, open[0]);
            else {
                const handler = open[1] || $fe273cf4adb912a5$var$defaultOnError;
                handler.call(this, token, open[0]);
            }
        }
        node.position.end = $fe273cf4adb912a5$var$point(token.end);
        return node;
    }
    /**
   * @this {CompileContext}
   * @returns {string}
   */ function resume() {
        return (0, $9213cecfd60df247$export$f84e8e69fd4488a5)(this.stack.pop());
    }
    //
    // Handlers.
    //
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterlistordered() {
        setData("expectingFirstListItemValue", true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterlistitemvalue(token) {
        if (getData("expectingFirstListItemValue")) {
            const ancestor = this.stack[this.stack.length - 2];
            ancestor.start = Number.parseInt(this.sliceSerialize(token), 10);
            setData("expectingFirstListItemValue");
        }
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefencedfenceinfo() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.lang = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefencedfencemeta() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.meta = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefencedfence() {
        // Exit if this is the closing fence.
        if (getData("flowCodeInside")) return;
        this.buffer();
        setData("flowCodeInside", true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefenced() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data.replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, "");
        setData("flowCodeInside");
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodeindented() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data.replace(/(\r?\n|\r)$/g, "");
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitionlabelstring(token) {
        const label = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.label = label;
        node.identifier = (0, $17274a453d2d9545$export$806d55e226cfcd08)(this.sliceSerialize(token)).toLowerCase();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitiontitlestring() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.title = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitiondestinationstring() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.url = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitatxheadingsequence(token) {
        const node = this.stack[this.stack.length - 1];
        if (!node.depth) {
            const depth = this.sliceSerialize(token).length;
            node.depth = depth;
        }
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheadingtext() {
        setData("setextHeadingSlurpLineEnding", true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheadinglinesequence(token) {
        const node = this.stack[this.stack.length - 1];
        node.depth = this.sliceSerialize(token).charCodeAt(0) === 61 ? 1 : 2;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheading() {
        setData("setextHeadingSlurpLineEnding");
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterdata(token) {
        const node = this.stack[this.stack.length - 1];
        let tail = node.children[node.children.length - 1];
        if (!tail || tail.type !== "text") {
            // Add a new text node.
            tail = text();
            // @ts-expect-error: we’ll add `end` later.
            tail.position = {
                start: $fe273cf4adb912a5$var$point(token.start)
            };
            // @ts-expect-error: Assume `parent` accepts `text`.
            node.children.push(tail);
        }
        this.stack.push(tail);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdata(token) {
        const tail = this.stack.pop();
        tail.value += this.sliceSerialize(token);
        tail.position.end = $fe273cf4adb912a5$var$point(token.end);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlineending(token) {
        const context = this.stack[this.stack.length - 1];
        // If we’re at a hard break, include the line ending in there.
        if (getData("atHardBreak")) {
            const tail = context.children[context.children.length - 1];
            tail.position.end = $fe273cf4adb912a5$var$point(token.end);
            setData("atHardBreak");
            return;
        }
        if (!getData("setextHeadingSlurpLineEnding") && config.canContainEols.includes(context.type)) {
            onenterdata.call(this, token);
            onexitdata.call(this, token);
        }
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexithardbreak() {
        setData("atHardBreak", true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexithtmlflow() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexithtmltext() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodetext() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlink() {
        const node = this.stack[this.stack.length - 1];
        // Note: there are also `identifier` and `label` fields on this link node!
        // These are used / cleaned here.
        // To do: clean.
        if (getData("inReference")) {
            /** @type {ReferenceType} */ const referenceType = getData("referenceType") || "shortcut";
            node.type += "Reference";
            // @ts-expect-error: mutate.
            node.referenceType = referenceType;
            // @ts-expect-error: mutate.
            delete node.url;
            delete node.title;
        } else {
            // @ts-expect-error: mutate.
            delete node.identifier;
            // @ts-expect-error: mutate.
            delete node.label;
        }
        setData("referenceType");
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitimage() {
        const node = this.stack[this.stack.length - 1];
        // Note: there are also `identifier` and `label` fields on this link node!
        // These are used / cleaned here.
        // To do: clean.
        if (getData("inReference")) {
            /** @type {ReferenceType} */ const referenceType = getData("referenceType") || "shortcut";
            node.type += "Reference";
            // @ts-expect-error: mutate.
            node.referenceType = referenceType;
            // @ts-expect-error: mutate.
            delete node.url;
            delete node.title;
        } else {
            // @ts-expect-error: mutate.
            delete node.identifier;
            // @ts-expect-error: mutate.
            delete node.label;
        }
        setData("referenceType");
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlabeltext(token) {
        const string = this.sliceSerialize(token);
        const ancestor = this.stack[this.stack.length - 2];
        // @ts-expect-error: stash this on the node, as it might become a reference
        // later.
        ancestor.label = (0, $569ad8210d6abecb$export$a0fb664af7d0cc44)(string);
        // @ts-expect-error: same as above.
        ancestor.identifier = (0, $17274a453d2d9545$export$806d55e226cfcd08)(string).toLowerCase();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlabel() {
        const fragment = this.stack[this.stack.length - 1];
        const value = this.resume();
        const node = this.stack[this.stack.length - 1];
        // Assume a reference.
        setData("inReference", true);
        if (node.type === "link") {
            /** @type {Array<StaticPhrasingContent>} */ // @ts-expect-error: Assume static phrasing content.
            const children = fragment.children;
            node.children = children;
        } else node.alt = value;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitresourcedestinationstring() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.url = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitresourcetitlestring() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.title = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitresource() {
        setData("inReference");
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterreference() {
        setData("referenceType", "collapsed");
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitreferencestring(token) {
        const label = this.resume();
        const node = this.stack[this.stack.length - 1];
        // @ts-expect-error: stash this on the node, as it might become a reference
        // later.
        node.label = label;
        // @ts-expect-error: same as above.
        node.identifier = (0, $17274a453d2d9545$export$806d55e226cfcd08)(this.sliceSerialize(token)).toLowerCase();
        setData("referenceType", "full");
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcharacterreferencemarker(token) {
        setData("characterReferenceType", token.type);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcharacterreferencevalue(token) {
        const data = this.sliceSerialize(token);
        const type = getData("characterReferenceType");
        /** @type {string} */ let value;
        if (type) {
            value = (0, $4b172571e380aaa9$export$15a69557afac2c20)(data, type === "characterReferenceMarkerNumeric" ? 10 : 16);
            setData("characterReferenceType");
        } else {
            const result = (0, $129f834d276cd569$export$289b6a6320f709b4)(data);
            value = result;
        }
        const tail = this.stack.pop();
        tail.value += value;
        tail.position.end = $fe273cf4adb912a5$var$point(token.end);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitautolinkprotocol(token) {
        onexitdata.call(this, token);
        const node = this.stack[this.stack.length - 1];
        node.url = this.sliceSerialize(token);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitautolinkemail(token) {
        onexitdata.call(this, token);
        const node = this.stack[this.stack.length - 1];
        node.url = "mailto:" + this.sliceSerialize(token);
    }
    //
    // Creaters.
    //
    /** @returns {Blockquote} */ function blockQuote() {
        return {
            type: "blockquote",
            children: []
        };
    }
    /** @returns {Code} */ function codeFlow() {
        return {
            type: "code",
            lang: null,
            meta: null,
            value: ""
        };
    }
    /** @returns {InlineCode} */ function codeText() {
        return {
            type: "inlineCode",
            value: ""
        };
    }
    /** @returns {Definition} */ function definition() {
        return {
            type: "definition",
            identifier: "",
            label: null,
            title: null,
            url: ""
        };
    }
    /** @returns {Emphasis} */ function emphasis() {
        return {
            type: "emphasis",
            children: []
        };
    }
    /** @returns {Heading} */ function heading() {
        // @ts-expect-error `depth` will be set later.
        return {
            type: "heading",
            depth: undefined,
            children: []
        };
    }
    /** @returns {Break} */ function hardBreak() {
        return {
            type: "break"
        };
    }
    /** @returns {HTML} */ function html() {
        return {
            type: "html",
            value: ""
        };
    }
    /** @returns {Image} */ function image() {
        return {
            type: "image",
            title: null,
            url: "",
            alt: null
        };
    }
    /** @returns {Link} */ function link() {
        return {
            type: "link",
            title: null,
            url: "",
            children: []
        };
    }
    /**
   * @param {Token} token
   * @returns {List}
   */ function list(token) {
        return {
            type: "list",
            ordered: token.type === "listOrdered",
            start: null,
            spread: token._spread,
            children: []
        };
    }
    /**
   * @param {Token} token
   * @returns {ListItem}
   */ function listItem(token) {
        return {
            type: "listItem",
            spread: token._spread,
            checked: null,
            children: []
        };
    }
    /** @returns {Paragraph} */ function paragraph() {
        return {
            type: "paragraph",
            children: []
        };
    }
    /** @returns {Strong} */ function strong() {
        return {
            type: "strong",
            children: []
        };
    }
    /** @returns {Text} */ function text() {
        return {
            type: "text",
            value: ""
        };
    }
    /** @returns {ThematicBreak} */ function thematicBreak() {
        return {
            type: "thematicBreak"
        };
    }
}
/**
 * Copy a point-like value.
 *
 * @param {Point} d
 *   Point-like value.
 * @returns {Point}
 *   unist point.
 */ function $fe273cf4adb912a5$var$point(d) {
    return {
        line: d.line,
        column: d.column,
        offset: d.offset
    };
}
/**
 * @param {Config} combined
 * @param {Array<Extension | Array<Extension>>} extensions
 * @returns {void}
 */ function $fe273cf4adb912a5$var$configure(combined, extensions) {
    let index = -1;
    while(++index < extensions.length){
        const value = extensions[index];
        if (Array.isArray(value)) $fe273cf4adb912a5$var$configure(combined, value);
        else $fe273cf4adb912a5$var$extension(combined, value);
    }
}
/**
 * @param {Config} combined
 * @param {Extension} extension
 * @returns {void}
 */ function $fe273cf4adb912a5$var$extension(combined, extension) {
    /** @type {keyof Extension} */ let key;
    for(key in extension)if ($fe273cf4adb912a5$var$own.call(extension, key)) {
        if (key === "canContainEols") {
            const right = extension[key];
            if (right) combined[key].push(...right);
        } else if (key === "transforms") {
            const right = extension[key];
            if (right) combined[key].push(...right);
        } else if (key === "enter" || key === "exit") {
            const right = extension[key];
            if (right) Object.assign(combined[key], right);
        }
    }
}
/** @type {OnEnterError} */ function $fe273cf4adb912a5$var$defaultOnError(left, right) {
    if (left) throw new Error("Cannot close `" + left.type + "` (" + (0, $06fafbeb21cd8799$export$c304dd45fe166145)({
        start: left.start,
        end: left.end
    }) + "): a different token (`" + right.type + "`, " + (0, $06fafbeb21cd8799$export$c304dd45fe166145)({
        start: right.start,
        end: right.end
    }) + ") is open");
    else throw new Error("Cannot close document, a token (`" + right.type + "`, " + (0, $06fafbeb21cd8799$export$c304dd45fe166145)({
        start: right.start,
        end: right.end
    }) + ") is still open");
}


function $fe0e02f11b434e10$export$2e2bcd8739ae039(options) {
    /** @type {import('unified').ParserFunction<Root>} */ const parser = (doc)=>{
        // Assume options.
        const settings = /** @type {Options} */ this.data("settings");
        return (0, $fe273cf4adb912a5$export$d744d789c09bfde6)(doc, Object.assign({}, settings, options, {
            // Note: these options are not in the readme.
            // The goal is for them to be set by plugins on `data` instead of being
            // passed by users.
            extensions: this.data("micromarkExtensions") || [],
            mdastExtensions: this.data("fromMarkdownExtensions") || []
        }));
    };
    Object.assign(this, {
        Parser: parser
    });
}


/**
 * @typedef {import('hast').Root} HastRoot
 * @typedef {import('mdast').Root} MdastRoot
 * @typedef {import('mdast-util-to-hast').Options} Options
 * @typedef {import('unified').Processor<any, any, any, any>} Processor
 *
 * @typedef {import('mdast-util-to-hast')} DoNotTouchAsThisImportIncludesRawInTree
 */ /**
 * @typedef {import('hast').Content} HastContent
 * @typedef {import('hast').Root} HastRoot
 *
 * @typedef {import('mdast').Content} MdastContent
 * @typedef {import('mdast').Root} MdastRoot
 *
 * @typedef {import('./state.js').Options} Options
 */ /**
 * @typedef {HastRoot | HastContent} HastNodes
 * @typedef {MdastRoot | MdastContent} MdastNodes
 */ /**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').ElementContent} ElementContent
 *
 * @typedef {import('./state.js').State} State
 */ 
function $914e37c8c11f9557$export$adb608be33961c98(state) {
    /** @type {Array<ElementContent>} */ const listItems = [];
    let index = -1;
    while(++index < state.footnoteOrder.length){
        const def = state.footnoteById[state.footnoteOrder[index]];
        if (!def) continue;
        const content = state.all(def);
        const id = String(def.identifier).toUpperCase();
        const safeId = (0, $4c6cf17b0d868e76$export$e42a3e39590d28b5)(id.toLowerCase());
        let referenceIndex = 0;
        /** @type {Array<ElementContent>} */ const backReferences = [];
        while(++referenceIndex <= state.footnoteCounts[id]){
            /** @type {Element} */ const backReference = {
                type: "element",
                tagName: "a",
                properties: {
                    href: "#" + state.clobberPrefix + "fnref-" + safeId + (referenceIndex > 1 ? "-" + referenceIndex : ""),
                    dataFootnoteBackref: true,
                    className: [
                        "data-footnote-backref"
                    ],
                    ariaLabel: state.footnoteBackLabel
                },
                children: [
                    {
                        type: "text",
                        value: "\u21A9"
                    }
                ]
            };
            if (referenceIndex > 1) backReference.children.push({
                type: "element",
                tagName: "sup",
                children: [
                    {
                        type: "text",
                        value: String(referenceIndex)
                    }
                ]
            });
            if (backReferences.length > 0) backReferences.push({
                type: "text",
                value: " "
            });
            backReferences.push(backReference);
        }
        const tail = content[content.length - 1];
        if (tail && tail.type === "element" && tail.tagName === "p") {
            const tailTail = tail.children[tail.children.length - 1];
            if (tailTail && tailTail.type === "text") tailTail.value += " ";
            else tail.children.push({
                type: "text",
                value: " "
            });
            tail.children.push(...backReferences);
        } else content.push(...backReferences);
        /** @type {Element} */ const listItem = {
            type: "element",
            tagName: "li",
            properties: {
                id: state.clobberPrefix + "fn-" + safeId
            },
            children: state.wrap(content, true)
        };
        state.patch(def, listItem);
        listItems.push(listItem);
    }
    if (listItems.length === 0) return;
    return {
        type: "element",
        tagName: "section",
        properties: {
            dataFootnotes: true,
            className: [
                "footnotes"
            ]
        },
        children: [
            {
                type: "element",
                tagName: state.footnoteLabelTagName,
                properties: {
                    // To do: use structured clone.
                    ...JSON.parse(JSON.stringify(state.footnoteLabelProperties)),
                    id: "footnote-label"
                },
                children: [
                    {
                        type: "text",
                        value: state.footnoteLabel
                    }
                ]
            },
            {
                type: "text",
                value: "\n"
            },
            {
                type: "element",
                tagName: "ol",
                properties: {},
                children: state.wrap(listItems, true)
            },
            {
                type: "text",
                value: "\n"
            }
        ]
    };
}


/**
 * @typedef {import('hast').Content} HastContent
 * @typedef {import('hast').Element} HastElement
 * @typedef {import('hast').ElementContent} HastElementContent
 * @typedef {import('hast').Properties} HastProperties
 * @typedef {import('hast').Root} HastRoot
 * @typedef {import('hast').Text} HastText
 *
 * @typedef {import('mdast').Content} MdastContent
 * @typedef {import('mdast').Definition} MdastDefinition
 * @typedef {import('mdast').FootnoteDefinition} MdastFootnoteDefinition
 * @typedef {import('mdast').Parent} MdastParent
 * @typedef {import('mdast').Root} MdastRoot
 */ /**
 * @typedef {HastRoot | HastContent} HastNodes
 * @typedef {MdastRoot | MdastContent} MdastNodes
 * @typedef {Extract<MdastNodes, MdastParent>} MdastParents
 *
 * @typedef EmbeddedHastFields
 *   hast fields.
 * @property {string | null | undefined} [hName]
 *   Generate a specific element with this tag name instead.
 * @property {HastProperties | null | undefined} [hProperties]
 *   Generate an element with these properties instead.
 * @property {Array<HastElementContent> | null | undefined} [hChildren]
 *   Generate an element with this content instead.
 *
 * @typedef {Record<string, unknown> & EmbeddedHastFields} MdastData
 *   mdast data with embedded hast fields.
 *
 * @typedef {MdastNodes & {data?: MdastData | null | undefined}} MdastNodeWithData
 *   mdast node with embedded hast data.
 *
 * @typedef PointLike
 *   Point-like value.
 * @property {number | null | undefined} [line]
 *   Line.
 * @property {number | null | undefined} [column]
 *   Column.
 * @property {number | null | undefined} [offset]
 *   Offset.
 *
 * @typedef PositionLike
 *   Position-like value.
 * @property {PointLike | null | undefined} [start]
 *   Point-like value.
 * @property {PointLike | null | undefined} [end]
 *   Point-like value.
 *
 * @callback Handler
 *   Handle a node.
 * @param {State} state
 *   Info passed around.
 * @param {any} node
 *   mdast node to handle.
 * @param {MdastParents | null | undefined} parent
 *   Parent of `node`.
 * @returns {HastElementContent | Array<HastElementContent> | null | undefined}
 *   hast node.
 *
 * @callback HFunctionProps
 *   Signature of `state` for when props are passed.
 * @param {MdastNodes | PositionLike | null | undefined} node
 *   mdast node or unist position.
 * @param {string} tagName
 *   HTML tag name.
 * @param {HastProperties} props
 *   Properties.
 * @param {Array<HastElementContent> | null | undefined} [children]
 *   hast content.
 * @returns {HastElement}
 *   Compiled element.
 *
 * @callback HFunctionNoProps
 *   Signature of `state` for when no props are passed.
 * @param {MdastNodes | PositionLike | null | undefined} node
 *   mdast node or unist position.
 * @param {string} tagName
 *   HTML tag name.
 * @param {Array<HastElementContent> | null | undefined} [children]
 *   hast content.
 * @returns {HastElement}
 *   Compiled element.
 *
 * @typedef HFields
 *   Info on `state`.
 * @property {boolean} dangerous
 *   Whether HTML is allowed.
 * @property {string} clobberPrefix
 *   Prefix to use to prevent DOM clobbering.
 * @property {string} footnoteLabel
 *   Label to use to introduce the footnote section.
 * @property {string} footnoteLabelTagName
 *   HTML used for the footnote label.
 * @property {HastProperties} footnoteLabelProperties
 *   Properties on the HTML tag used for the footnote label.
 * @property {string} footnoteBackLabel
 *   Label to use from backreferences back to their footnote call.
 * @property {(identifier: string) => MdastDefinition | null} definition
 *   Definition cache.
 * @property {Record<string, MdastFootnoteDefinition>} footnoteById
 *   Footnote definitions by their identifier.
 * @property {Array<string>} footnoteOrder
 *   Identifiers of order when footnote calls first appear in tree order.
 * @property {Record<string, number>} footnoteCounts
 *   Counts for how often the same footnote was called.
 * @property {Handlers} handlers
 *   Applied handlers.
 * @property {Handler} unknownHandler
 *   Handler for any none not in `passThrough` or otherwise handled.
 * @property {(from: MdastNodes, node: HastNodes) => void} patch
 *   Copy a node’s positional info.
 * @property {<Type extends HastNodes>(from: MdastNodes, to: Type) => Type | HastElement} applyData
 *   Honor the `data` of `from`, and generate an element instead of `node`.
 * @property {(node: MdastNodes, parent: MdastParents | null | undefined) => HastElementContent | Array<HastElementContent> | null | undefined} one
 *   Transform an mdast node to hast.
 * @property {(node: MdastNodes) => Array<HastElementContent>} all
 *   Transform the children of an mdast parent to hast.
 * @property {<Type extends HastContent>(nodes: Array<Type>, loose?: boolean | null | undefined) => Array<Type | HastText>} wrap
 *   Wrap `nodes` with line endings between each node, adds initial/final line endings when `loose`.
 * @property {(left: MdastNodeWithData | PositionLike | null | undefined, right: HastElementContent) => HastElementContent} augment
 *   Like `state` but lower-level and usable on non-elements.
 *   Deprecated: use `patch` and `applyData`.
 * @property {Array<string>} passThrough
 *   List of node types to pass through untouched (except for their children).
 *
 * @typedef Options
 *   Configuration (optional).
 * @property {boolean | null | undefined} [allowDangerousHtml=false]
 *   Whether to persist raw HTML in markdown in the hast tree.
 * @property {string | null | undefined} [clobberPrefix='user-content-']
 *   Prefix to use before the `id` attribute on footnotes to prevent it from
 *   *clobbering*.
 * @property {string | null | undefined} [footnoteBackLabel='Back to content']
 *   Label to use from backreferences back to their footnote call (affects
 *   screen readers).
 * @property {string | null | undefined} [footnoteLabel='Footnotes']
 *   Label to use for the footnotes section (affects screen readers).
 * @property {HastProperties | null | undefined} [footnoteLabelProperties={className: ['sr-only']}]
 *   Properties to use on the footnote label (note that `id: 'footnote-label'`
 *   is always added as footnote calls use it with `aria-describedby` to
 *   provide an accessible label).
 * @property {string | null | undefined} [footnoteLabelTagName='h2']
 *   Tag name to use for the footnote label.
 * @property {Handlers | null | undefined} [handlers]
 *   Extra handlers for nodes.
 * @property {Array<string> | null | undefined} [passThrough]
 *   List of custom mdast node types to pass through (keep) in hast (note that
 *   the node itself is passed, but eventual children are transformed).
 * @property {Handler | null | undefined} [unknownHandler]
 *   Handler for all unknown nodes.
 *
 * @typedef {Record<string, Handler>} Handlers
 *   Handle nodes.
 *
 * @typedef {HFunctionProps & HFunctionNoProps & HFields} State
 *   Info passed around.
 */ /**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Parent} Parent
 * @typedef {import('unist-util-is').Test} Test
 * @typedef {import('unist-util-visit-parents').VisitorResult} VisitorResult
 */ /**
 * Check if `Child` can be a child of `Ancestor`.
 *
 * Returns the ancestor when `Child` can be a child of `Ancestor`, or returns
 * `never`.
 *
 * @template {Node} Ancestor
 *   Node type.
 * @template {Node} Child
 *   Node type.
 * @typedef {(
 *   Ancestor extends Parent
 *     ? Child extends Ancestor['children'][number]
 *       ? Ancestor
 *       : never
 *     : never
 * )} ParentsOf
 */ /**
 * @template {Node} [Visited=Node]
 *   Visited node type.
 * @template {Parent} [Ancestor=Parent]
 *   Ancestor type.
 * @callback Visitor
 *   Handle a node (matching `test`, if given).
 *
 *   Visitors are free to transform `node`.
 *   They can also transform `parent`.
 *
 *   Replacing `node` itself, if `SKIP` is not returned, still causes its
 *   descendants to be walked (which is a bug).
 *
 *   When adding or removing previous siblings of `node` (or next siblings, in
 *   case of reverse), the `Visitor` should return a new `Index` to specify the
 *   sibling to traverse after `node` is traversed.
 *   Adding or removing next siblings of `node` (or previous siblings, in case
 *   of reverse) is handled as expected without needing to return a new `Index`.
 *
 *   Removing the children property of `parent` still results in them being
 *   traversed.
 * @param {Visited} node
 *   Found node.
 * @param {Visited extends Node ? number | null : never} index
 *   Index of `node` in `parent`.
 * @param {Ancestor extends Node ? Ancestor | null : never} parent
 *   Parent of `node`.
 * @returns {VisitorResult}
 *   What to do next.
 *
 *   An `Index` is treated as a tuple of `[CONTINUE, Index]`.
 *   An `Action` is treated as a tuple of `[Action]`.
 *
 *   Passing a tuple back only makes sense if the `Action` is `SKIP`.
 *   When the `Action` is `EXIT`, that action can be returned.
 *   When the `Action` is `CONTINUE`, `Index` can be returned.
 */ /**
 * Build a typed `Visitor` function from a node and all possible parents.
 *
 * It will infer which values are passed as `node` and which as `parent`.
 *
 * @template {Node} Visited
 *   Node type.
 * @template {Parent} Ancestor
 *   Parent type.
 * @typedef {Visitor<Visited, ParentsOf<Ancestor, Visited>>} BuildVisitorFromMatch
 */ /**
 * Build a typed `Visitor` function from a list of descendants and a test.
 *
 * It will infer which values are passed as `node` and which as `parent`.
 *
 * @template {Node} Descendant
 *   Node type.
 * @template {Test} Check
 *   Test type.
 * @typedef {(
 *   BuildVisitorFromMatch<
 *     import('unist-util-visit-parents/complex-types.js').Matches<Descendant, Check>,
 *     Extract<Descendant, Parent>
 *   >
 * )} BuildVisitorFromDescendants
 */ /**
 * Build a typed `Visitor` function from a tree and a test.
 *
 * It will infer which values are passed as `node` and which as `parent`.
 *
 * @template {Node} [Tree=Node]
 *   Node type.
 * @template {Test} [Check=string]
 *   Test type.
 * @typedef {(
 *   BuildVisitorFromDescendants<
 *     import('unist-util-visit-parents/complex-types.js').InclusiveDescendant<Tree>,
 *     Check
 *   >
 * )} BuildVisitor
 */ 
const $8b61ffc0b5f74a03$export$bf638b60ea8b89b7 = /**
   * @type {(
   *   (<Tree extends Node, Check extends Test>(tree: Tree, test: Check, visitor: BuildVisitor<Tree, Check>, reverse?: boolean | null | undefined) => void) &
   *   (<Tree extends Node>(tree: Tree, visitor: BuildVisitor<Tree>, reverse?: boolean | null | undefined) => void)
   * )}
   */ /**
     * @param {Node} tree
     * @param {Test} test
     * @param {Visitor} visitor
     * @param {boolean | null | undefined} [reverse]
     * @returns {void}
     */ function(tree, test, visitor, reverse) {
    if (typeof test === "function" && typeof visitor !== "function") {
        reverse = visitor;
        visitor = test;
        test = null;
    }
    (0, $50f8853af3000e7e$export$70008a21eb6de899)(tree, test, overload, reverse);
    /**
       * @param {Node} node
       * @param {Array<Parent>} parents
       */ function overload(node, parents) {
        const parent = parents[parents.length - 1];
        return visitor(node, parent ? parent.children.indexOf(node) : null, parent);
    }
};


/**
 * @typedef {import('unist').Position} Position
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Point} Point
 */ /**
 * @typedef NodeLike
 * @property {string} type
 * @property {PositionLike | null | undefined} [position]
 *
 * @typedef PositionLike
 * @property {PointLike | null | undefined} [start]
 * @property {PointLike | null | undefined} [end]
 *
 * @typedef PointLike
 * @property {number | null | undefined} [line]
 * @property {number | null | undefined} [column]
 * @property {number | null | undefined} [offset]
 */ /**
 * Get the starting point of `node`.
 *
 * @param node
 *   Node.
 * @returns
 *   Point.
 */ const $8fa199b8e09e39ed$export$771bf3e4949bfbee = $8fa199b8e09e39ed$var$point("start");
const $8fa199b8e09e39ed$export$da309cdce9dc2a25 = $8fa199b8e09e39ed$var$point("end");
function $8fa199b8e09e39ed$export$5880b8b5730aff45(node) {
    return {
        start: $8fa199b8e09e39ed$export$771bf3e4949bfbee(node),
        end: $8fa199b8e09e39ed$export$da309cdce9dc2a25(node)
    };
}
/**
 * Get the positional info of `node`.
 *
 * @param {'start' | 'end'} type
 *   Side.
 * @returns
 *   Getter.
 */ function $8fa199b8e09e39ed$var$point(type) {
    return point;
    /**
   * Get the point info of `node` at a bound side.
   *
   * @param {NodeLike | Node | null | undefined} [node]
   * @returns {Point}
   */ function point(node) {
        const point = node && node.position && node.position[type] || {};
        // To do: next major: don’t return points when invalid.
        return {
            // @ts-expect-error: in practice, null is allowed.
            line: point.line || null,
            // @ts-expect-error: in practice, null is allowed.
            column: point.column || null,
            // @ts-expect-error: in practice, null is allowed.
            offset: point.offset > -1 ? point.offset : null
        };
    }
}


/**
 * @typedef PointLike
 * @property {number | null | undefined} [line]
 * @property {number | null | undefined} [column]
 * @property {number | null | undefined} [offset]
 *
 * @typedef PositionLike
 * @property {PointLike | null | undefined} [start]
 * @property {PointLike | null | undefined} [end]
 *
 * @typedef NodeLike
 * @property {PositionLike | null | undefined} [position]
 */ /**
 * Check if `node` is generated.
 *
 * @param {NodeLike | null | undefined} [node]
 *   Node to check.
 * @returns {boolean}
 *   Whether `node` is generated (does not have positional info).
 */ function $a2b36f237fbb3f65$export$41ad1363166ec91a(node) {
    return !node || !node.position || !node.position.start || !node.position.start.line || !node.position.start.column || !node.position.end || !node.position.end.line || !node.position.end.column;
}


/**
 * @typedef {import('mdast').Root} Root
 * @typedef {import('mdast').Content} Content
 * @typedef {import('mdast').Definition} Definition
 */ /**
 * @typedef {Root | Content} Node
 *
 * @callback GetDefinition
 *   Get a definition by identifier.
 * @param {string | null | undefined} [identifier]
 *   Identifier of definition.
 * @returns {Definition | null}
 *   Definition corresponding to `identifier` or `null`.
 */ 
const $b619b8f4dbecce36$var$own = {}.hasOwnProperty;
function $b619b8f4dbecce36$export$d79264f26953ec1(tree) {
    /** @type {Record<string, Definition>} */ const cache = Object.create(null);
    if (!tree || !tree.type) throw new Error("mdast-util-definitions expected node");
    (0, $8b61ffc0b5f74a03$export$bf638b60ea8b89b7)(tree, "definition", (definition)=>{
        const id = $b619b8f4dbecce36$var$clean(definition.identifier);
        if (id && !$b619b8f4dbecce36$var$own.call(cache, id)) cache[id] = definition;
    });
    return definition;
    /** @type {GetDefinition} */ function definition(identifier) {
        const id = $b619b8f4dbecce36$var$clean(identifier);
        // To do: next major: return `undefined` when not found.
        return id && $b619b8f4dbecce36$var$own.call(cache, id) ? cache[id] : null;
    }
}
/**
 * @param {string | null | undefined} [value]
 * @returns {string}
 */ function $b619b8f4dbecce36$var$clean(value) {
    return String(value || "").toUpperCase();
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Blockquote} Blockquote
 * @typedef {import('../state.js').State} State
 */ /**
 * Turn an mdast `blockquote` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Blockquote} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $c12729c87a5a414f$export$67dc04e652a298ca(state, node) {
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "blockquote",
        properties: {},
        children: state.wrap(state.all(node), true)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Text} Text
 * @typedef {import('mdast').Break} Break
 * @typedef {import('../state.js').State} State
 */ /**
 * Turn an mdast `break` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Break} node
 *   mdast node.
 * @returns {Array<Element | Text>}
 *   hast element content.
 */ function $e97c925e1016387b$export$371da9dd35aba193(state, node) {
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "br",
        properties: {},
        children: []
    };
    state.patch(node, result);
    return [
        state.applyData(node, result),
        {
            type: "text",
            value: "\n"
        }
    ];
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').Code} Code
 * @typedef {import('../state.js').State} State

 */ /**
 * Turn an mdast `code` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Code} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $04048daab94d118d$export$6565f9f03506010b(state, node) {
    const value = node.value ? node.value + "\n" : "";
    // To do: next major, use `node.lang` w/o regex, the splitting’s been going
    // on for years in remark now.
    const lang = node.lang ? node.lang.match(/^[^ \t]+(?=[ \t]|$)/) : null;
    /** @type {Properties} */ const properties = {};
    if (lang) properties.className = [
        "language-" + lang
    ];
    // Create `<code>`.
    /** @type {Element} */ let result = {
        type: "element",
        tagName: "code",
        properties: properties,
        children: [
            {
                type: "text",
                value: value
            }
        ]
    };
    if (node.meta) result.data = {
        meta: node.meta
    };
    state.patch(node, result);
    result = state.applyData(node, result);
    // Create `<pre>`.
    result = {
        type: "element",
        tagName: "pre",
        properties: {},
        children: [
            result
        ]
    };
    state.patch(node, result);
    return result;
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Delete} Delete
 * @typedef {import('../state.js').State} State

 */ /**
 * Turn an mdast `delete` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Delete} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $cb122fe63cf2dd36$export$19426ff118fe8be(state, node) {
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "del",
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Emphasis} Emphasis
 * @typedef {import('../state.js').State} State
 */ /**
 * Turn an mdast `emphasis` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Emphasis} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $3d217e6693ed612b$export$bef81ba411953b51(state, node) {
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "em",
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('mdast').FootnoteReference} FootnoteReference
 * @typedef {import('hast').Element} Element
 * @typedef {import('../state.js').State} State
 */ 
function $e202f0d677cbb15e$export$7f87ee744075c1ba(state, node) {
    const id = String(node.identifier).toUpperCase();
    const safeId = (0, $4c6cf17b0d868e76$export$e42a3e39590d28b5)(id.toLowerCase());
    const index = state.footnoteOrder.indexOf(id);
    /** @type {number} */ let counter;
    if (index === -1) {
        state.footnoteOrder.push(id);
        state.footnoteCounts[id] = 1;
        counter = state.footnoteOrder.length;
    } else {
        state.footnoteCounts[id]++;
        counter = index + 1;
    }
    const reuseCounter = state.footnoteCounts[id];
    /** @type {Element} */ const link = {
        type: "element",
        tagName: "a",
        properties: {
            href: "#" + state.clobberPrefix + "fn-" + safeId,
            id: state.clobberPrefix + "fnref-" + safeId + (reuseCounter > 1 ? "-" + reuseCounter : ""),
            dataFootnoteRef: true,
            ariaDescribedBy: [
                "footnote-label"
            ]
        },
        children: [
            {
                type: "text",
                value: String(counter)
            }
        ]
    };
    state.patch(node, link);
    /** @type {Element} */ const sup = {
        type: "element",
        tagName: "sup",
        properties: {},
        children: [
            link
        ]
    };
    state.patch(node, sup);
    return state.applyData(node, sup);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Footnote} Footnote
 * @typedef {import('../state.js').State} State
 */ 
function $8503029556474d7f$export$3b6a720baa2c20ec(state, node) {
    const footnoteById = state.footnoteById;
    let no = 1;
    while(no in footnoteById)no++;
    const identifier = String(no);
    footnoteById[identifier] = {
        type: "footnoteDefinition",
        identifier: identifier,
        children: [
            {
                type: "paragraph",
                children: node.children
            }
        ],
        position: node.position
    };
    return (0, $e202f0d677cbb15e$export$7f87ee744075c1ba)(state, {
        type: "footnoteReference",
        identifier: identifier,
        position: node.position
    });
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Heading} Heading
 * @typedef {import('../state.js').State} State
 */ /**
 * Turn an mdast `heading` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Heading} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $eacd473d6978233a$export$46e4a324ac90507f(state, node) {
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "h" + node.depth,
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').HTML} Html
 * @typedef {import('../state.js').State} State
 * @typedef {import('../../index.js').Raw} Raw
 */ /**
 * Turn an mdast `html` node into hast (`raw` node in dangerous mode, otherwise
 * nothing).
 *
 * @param {State} state
 *   Info passed around.
 * @param {Html} node
 *   mdast node.
 * @returns {Raw | Element | null}
 *   hast node.
 */ function $f5dd27aa8391c633$export$c0bb0b647f701bb5(state, node) {
    if (state.dangerous) {
        /** @type {Raw} */ const result = {
            type: "raw",
            value: node.value
        };
        state.patch(node, result);
        return state.applyData(node, result);
    }
    // To do: next major: return `undefined`.
    return null;
}


/**
 * @typedef {import('hast').ElementContent} ElementContent
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').ImageReference} ImageReference
 * @typedef {import('../state.js').State} State
 */ 
/**
 * @typedef {import('hast').ElementContent} ElementContent
 *
 * @typedef {import('mdast').Content} Content
 * @typedef {import('mdast').Reference} Reference
 * @typedef {import('mdast').Root} Root
 *
 * @typedef {import('./state.js').State} State
 */ /**
 * @typedef {Root | Content} Nodes
 * @typedef {Extract<Nodes, Reference>} References
 */ // To do: next major: always return array.
/**
 * Return the content of a reference without definition as plain text.
 *
 * @param {State} state
 *   Info passed around.
 * @param {References} node
 *   Reference node (image, link).
 * @returns {ElementContent | Array<ElementContent>}
 *   hast content.
 */ function $dd125cc317584fc5$export$3fdd26f3d9e7dc78(state, node) {
    const subtype = node.referenceType;
    let suffix = "]";
    if (subtype === "collapsed") suffix += "[]";
    else if (subtype === "full") suffix += "[" + (node.label || node.identifier) + "]";
    if (node.type === "imageReference") return {
        type: "text",
        value: "![" + node.alt + suffix
    };
    const contents = state.all(node);
    const head = contents[0];
    if (head && head.type === "text") head.value = "[" + head.value;
    else contents.unshift({
        type: "text",
        value: "["
    });
    const tail = contents[contents.length - 1];
    if (tail && tail.type === "text") tail.value += suffix;
    else contents.push({
        type: "text",
        value: suffix
    });
    return contents;
}


function $cc30f987767a2c8f$export$f281796f6bc3b8db(state, node) {
    const def = state.definition(node.identifier);
    if (!def) return (0, $dd125cc317584fc5$export$3fdd26f3d9e7dc78)(state, node);
    /** @type {Properties} */ const properties = {
        src: (0, $4c6cf17b0d868e76$export$e42a3e39590d28b5)(def.url || ""),
        alt: node.alt
    };
    if (def.title !== null && def.title !== undefined) properties.title = def.title;
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "img",
        properties: properties,
        children: []
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').Image} Image
 * @typedef {import('../state.js').State} State
 */ 
function $2b5deaa445d05843$export$5c452ff88e35e47d(state, node) {
    /** @type {Properties} */ const properties = {
        src: (0, $4c6cf17b0d868e76$export$e42a3e39590d28b5)(node.url)
    };
    if (node.alt !== null && node.alt !== undefined) properties.alt = node.alt;
    if (node.title !== null && node.title !== undefined) properties.title = node.title;
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "img",
        properties: properties,
        children: []
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Text} Text
 * @typedef {import('mdast').InlineCode} InlineCode
 * @typedef {import('../state.js').State} State
 */ /**
 * Turn an mdast `inlineCode` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {InlineCode} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $57e227e81f881b06$export$91b9bee19a0d8569(state, node) {
    /** @type {Text} */ const text = {
        type: "text",
        value: node.value.replace(/\r?\n|\r/g, " ")
    };
    state.patch(node, text);
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "code",
        properties: {},
        children: [
            text
        ]
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').ElementContent} ElementContent
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').LinkReference} LinkReference
 * @typedef {import('../state.js').State} State
 */ 

function $1dd6021a94d8d17a$export$e6c469b1b7b2bc6a(state, node) {
    const def = state.definition(node.identifier);
    if (!def) return (0, $dd125cc317584fc5$export$3fdd26f3d9e7dc78)(state, node);
    /** @type {Properties} */ const properties = {
        href: (0, $4c6cf17b0d868e76$export$e42a3e39590d28b5)(def.url || "")
    };
    if (def.title !== null && def.title !== undefined) properties.title = def.title;
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "a",
        properties: properties,
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').Link} Link
 * @typedef {import('../state.js').State} State
 */ 
function $993247f246832b00$export$9c30223ca0a664fb(state, node) {
    /** @type {Properties} */ const properties = {
        href: (0, $4c6cf17b0d868e76$export$e42a3e39590d28b5)(node.url)
    };
    if (node.title !== null && node.title !== undefined) properties.title = node.title;
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "a",
        properties: properties,
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').ElementContent} ElementContent
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').Content} Content
 * @typedef {import('mdast').ListItem} ListItem
 * @typedef {import('mdast').Parent} Parent
 * @typedef {import('mdast').Root} Root
 * @typedef {import('../state.js').State} State
 */ /**
 * @typedef {Root | Content} Nodes
 * @typedef {Extract<Nodes, Parent>} Parents
 */ /**
 * Turn an mdast `listItem` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {ListItem} node
 *   mdast node.
 * @param {Parents | null | undefined} parent
 *   Parent of `node`.
 * @returns {Element}
 *   hast node.
 */ function $8545d760ae56123d$export$76c7e83ecc9cdf05(state, node, parent) {
    const results = state.all(node);
    const loose = parent ? $8545d760ae56123d$var$listLoose(parent) : $8545d760ae56123d$var$listItemLoose(node);
    /** @type {Properties} */ const properties = {};
    /** @type {Array<ElementContent>} */ const children = [];
    if (typeof node.checked === "boolean") {
        const head = results[0];
        /** @type {Element} */ let paragraph;
        if (head && head.type === "element" && head.tagName === "p") paragraph = head;
        else {
            paragraph = {
                type: "element",
                tagName: "p",
                properties: {},
                children: []
            };
            results.unshift(paragraph);
        }
        if (paragraph.children.length > 0) paragraph.children.unshift({
            type: "text",
            value: " "
        });
        paragraph.children.unshift({
            type: "element",
            tagName: "input",
            properties: {
                type: "checkbox",
                checked: node.checked,
                disabled: true
            },
            children: []
        });
        // According to github-markdown-css, this class hides bullet.
        // See: <https://github.com/sindresorhus/github-markdown-css>.
        properties.className = [
            "task-list-item"
        ];
    }
    let index = -1;
    while(++index < results.length){
        const child = results[index];
        // Add eols before nodes, except if this is a loose, first paragraph.
        if (loose || index !== 0 || child.type !== "element" || child.tagName !== "p") children.push({
            type: "text",
            value: "\n"
        });
        if (child.type === "element" && child.tagName === "p" && !loose) children.push(...child.children);
        else children.push(child);
    }
    const tail = results[results.length - 1];
    // Add a final eol.
    if (tail && (loose || tail.type !== "element" || tail.tagName !== "p")) children.push({
        type: "text",
        value: "\n"
    });
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "li",
        properties: properties,
        children: children
    };
    state.patch(node, result);
    return state.applyData(node, result);
}
/**
 * @param {Parents} node
 * @return {Boolean}
 */ function $8545d760ae56123d$var$listLoose(node) {
    let loose = false;
    if (node.type === "list") {
        loose = node.spread || false;
        const children = node.children;
        let index = -1;
        while(!loose && ++index < children.length)loose = $8545d760ae56123d$var$listItemLoose(children[index]);
    }
    return loose;
}
/**
 * @param {ListItem} node
 * @return {Boolean}
 */ function $8545d760ae56123d$var$listItemLoose(node) {
    const spread = node.spread;
    return spread === undefined || spread === null ? node.children.length > 1 : spread;
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').List} List
 * @typedef {import('../state.js').State} State
 */ /**
 * Turn an mdast `list` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {List} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $2b226c768fc7a5ae$export$8837f4fc672e936d(state, node) {
    /** @type {Properties} */ const properties = {};
    const results = state.all(node);
    let index = -1;
    if (typeof node.start === "number" && node.start !== 1) properties.start = node.start;
    // Like GitHub, add a class for custom styling.
    while(++index < results.length){
        const child = results[index];
        if (child.type === "element" && child.tagName === "li" && child.properties && Array.isArray(child.properties.className) && child.properties.className.includes("task-list-item")) {
            properties.className = [
                "contains-task-list"
            ];
            break;
        }
    }
    /** @type {Element} */ const result = {
        type: "element",
        tagName: node.ordered ? "ol" : "ul",
        properties: properties,
        children: state.wrap(results, true)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Paragraph} Paragraph
 * @typedef {import('../state.js').State} State
 */ /**
 * Turn an mdast `paragraph` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Paragraph} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $f6f8767b74789421$export$9c206ddddb32a9b(state, node) {
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "p",
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Root} HastRoot
 * @typedef {import('hast').Element} HastElement
 * @typedef {import('mdast').Root} MdastRoot
 * @typedef {import('../state.js').State} State
 */ /**
 * Turn an mdast `root` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {MdastRoot} node
 *   mdast node.
 * @returns {HastRoot | HastElement}
 *   hast node.
 */ function $9bcde0a552bc8c16$export$e8e78c978b129247(state, node) {
    /** @type {HastRoot} */ const result = {
        type: "root",
        children: state.wrap(state.all(node))
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Strong} Strong
 * @typedef {import('../state.js').State} State
 */ /**
 * Turn an mdast `strong` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Strong} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $c1beab527e958514$export$59ae2c325a998f89(state, node) {
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "strong",
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Table} Table
 * @typedef {import('../state.js').State} State
 */ 
function $61e0aeca9863b43d$export$9852986a3ec5f6a0(state, node) {
    const rows = state.all(node);
    const firstRow = rows.shift();
    /** @type {Array<Element>} */ const tableContent = [];
    if (firstRow) {
        /** @type {Element} */ const head = {
            type: "element",
            tagName: "thead",
            properties: {},
            children: state.wrap([
                firstRow
            ], true)
        };
        state.patch(node.children[0], head);
        tableContent.push(head);
    }
    if (rows.length > 0) {
        /** @type {Element} */ const body = {
            type: "element",
            tagName: "tbody",
            properties: {},
            children: state.wrap(rows, true)
        };
        const start = (0, $8fa199b8e09e39ed$export$771bf3e4949bfbee)(node.children[1]);
        const end = (0, $8fa199b8e09e39ed$export$da309cdce9dc2a25)(node.children[node.children.length - 1]);
        if (start.line && end.line) body.position = {
            start: start,
            end: end
        };
        tableContent.push(body);
    }
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "table",
        properties: {},
        children: state.wrap(tableContent, true)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').ElementContent} ElementContent
 * @typedef {import('mdast').Content} Content
 * @typedef {import('mdast').Parent} Parent
 * @typedef {import('mdast').Root} Root
 * @typedef {import('mdast').TableRow} TableRow
 * @typedef {import('../state.js').State} State
 */ /**
 * @typedef {Root | Content} Nodes
 * @typedef {Extract<Nodes, Parent>} Parents
 */ /**
 * Turn an mdast `tableRow` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {TableRow} node
 *   mdast node.
 * @param {Parents | null | undefined} parent
 *   Parent of `node`.
 * @returns {Element}
 *   hast node.
 */ function $6a0f1dd34d8b410e$export$ce666bf02318c957(state, node, parent) {
    const siblings = parent ? parent.children : undefined;
    // Generate a body row when without parent.
    const rowIndex = siblings ? siblings.indexOf(node) : 1;
    const tagName = rowIndex === 0 ? "th" : "td";
    const align = parent && parent.type === "table" ? parent.align : undefined;
    const length = align ? align.length : node.children.length;
    let cellIndex = -1;
    /** @type {Array<ElementContent>} */ const cells = [];
    while(++cellIndex < length){
        // Note: can also be undefined.
        const cell = node.children[cellIndex];
        /** @type {Properties} */ const properties = {};
        const alignValue = align ? align[cellIndex] : undefined;
        if (alignValue) properties.align = alignValue;
        /** @type {Element} */ let result = {
            type: "element",
            tagName: tagName,
            properties: properties,
            children: []
        };
        if (cell) {
            result.children = state.all(cell);
            state.patch(cell, result);
            result = state.applyData(node, result);
        }
        cells.push(result);
    }
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "tr",
        properties: {},
        children: state.wrap(cells, true)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').TableCell} TableCell
 * @typedef {import('../state.js').State} State
 */ /**
 * Turn an mdast `tableCell` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {TableCell} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $220db78f65bb3150$export$e1e720e5f4603e6a(state, node) {
    // Note: this function is normally not called: see `table-row` for how rows
    // and their cells are compiled.
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "td",
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} HastElement
 * @typedef {import('hast').Text} HastText
 * @typedef {import('mdast').Text} MdastText
 * @typedef {import('../state.js').State} State
 */ const $76e892234236f11a$var$tab = 9 /* `\t` */ ;
const $76e892234236f11a$var$space = 32 /* ` ` */ ;
function $76e892234236f11a$export$a771f20bdd13def9(value) {
    const source = String(value);
    const search = /\r?\n|\r/g;
    let match = search.exec(source);
    let last = 0;
    /** @type {Array<string>} */ const lines = [];
    while(match){
        lines.push($76e892234236f11a$var$trimLine(source.slice(last, match.index), last > 0, true), match[0]);
        last = match.index + match[0].length;
        match = search.exec(source);
    }
    lines.push($76e892234236f11a$var$trimLine(source.slice(last), last > 0, false));
    return lines.join("");
}
/**
 * @param {string} value
 *   Line to trim.
 * @param {boolean} start
 *   Whether to trim the start of the line.
 * @param {boolean} end
 *   Whether to trim the end of the line.
 * @returns {string}
 *   Trimmed line.
 */ function $76e892234236f11a$var$trimLine(value, start, end) {
    let startIndex = 0;
    let endIndex = value.length;
    if (start) {
        let code = value.codePointAt(startIndex);
        while(code === $76e892234236f11a$var$tab || code === $76e892234236f11a$var$space){
            startIndex++;
            code = value.codePointAt(startIndex);
        }
    }
    if (end) {
        let code = value.codePointAt(endIndex - 1);
        while(code === $76e892234236f11a$var$tab || code === $76e892234236f11a$var$space){
            endIndex--;
            code = value.codePointAt(endIndex - 1);
        }
    }
    return endIndex > startIndex ? value.slice(startIndex, endIndex) : "";
}


function $006cdf02abd02253$export$6f093cfa640b7166(state, node) {
    /** @type {HastText} */ const result = {
        type: "text",
        value: (0, $76e892234236f11a$export$a771f20bdd13def9)(String(node.value))
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').ThematicBreak} ThematicBreak
 * @typedef {import('../state.js').State} State
 */ /**
 * Turn an mdast `thematicBreak` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {ThematicBreak} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $3e44a169233e70ed$export$ba7b13e047416c03(state, node) {
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "hr",
        properties: {},
        children: []
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


const $3d43b8c0b4ae1acf$export$455ce229eb3d2472 = {
    blockquote: $c12729c87a5a414f$export$67dc04e652a298ca,
    break: (0, $e97c925e1016387b$export$371da9dd35aba193),
    code: $04048daab94d118d$export$6565f9f03506010b,
    delete: (0, $cb122fe63cf2dd36$export$19426ff118fe8be),
    emphasis: $3d217e6693ed612b$export$bef81ba411953b51,
    footnoteReference: $e202f0d677cbb15e$export$7f87ee744075c1ba,
    footnote: $8503029556474d7f$export$3b6a720baa2c20ec,
    heading: $eacd473d6978233a$export$46e4a324ac90507f,
    html: $f5dd27aa8391c633$export$c0bb0b647f701bb5,
    imageReference: $cc30f987767a2c8f$export$f281796f6bc3b8db,
    image: $2b5deaa445d05843$export$5c452ff88e35e47d,
    inlineCode: $57e227e81f881b06$export$91b9bee19a0d8569,
    linkReference: $1dd6021a94d8d17a$export$e6c469b1b7b2bc6a,
    link: $993247f246832b00$export$9c30223ca0a664fb,
    listItem: $8545d760ae56123d$export$76c7e83ecc9cdf05,
    list: $2b226c768fc7a5ae$export$8837f4fc672e936d,
    paragraph: $f6f8767b74789421$export$9c206ddddb32a9b,
    root: $9bcde0a552bc8c16$export$e8e78c978b129247,
    strong: $c1beab527e958514$export$59ae2c325a998f89,
    table: $61e0aeca9863b43d$export$9852986a3ec5f6a0,
    tableCell: $220db78f65bb3150$export$e1e720e5f4603e6a,
    tableRow: $6a0f1dd34d8b410e$export$ce666bf02318c957,
    text: $006cdf02abd02253$export$6f093cfa640b7166,
    thematicBreak: $3e44a169233e70ed$export$ba7b13e047416c03,
    toml: $3d43b8c0b4ae1acf$var$ignore,
    yaml: $3d43b8c0b4ae1acf$var$ignore,
    definition: $3d43b8c0b4ae1acf$var$ignore,
    footnoteDefinition: $3d43b8c0b4ae1acf$var$ignore
};
// Return nothing for nodes that are ignored.
function $3d43b8c0b4ae1acf$var$ignore() {
    // To do: next major: return `undefined`.
    return null;
}


const $78f9463a77c540af$var$own = {}.hasOwnProperty;
function $78f9463a77c540af$export$e6a0daad8304de(tree, options) {
    const settings = options || {};
    const dangerous = settings.allowDangerousHtml || false;
    /** @type {Record<string, MdastFootnoteDefinition>} */ const footnoteById = {};
    // To do: next major: add `options` to state, remove:
    // `dangerous`, `clobberPrefix`, `footnoteLabel`, `footnoteLabelTagName`,
    // `footnoteLabelProperties`, `footnoteBackLabel`, `passThrough`,
    // `unknownHandler`.
    // To do: next major: move to `state.options.allowDangerousHtml`.
    state.dangerous = dangerous;
    // To do: next major: move to `state.options`.
    state.clobberPrefix = settings.clobberPrefix === undefined || settings.clobberPrefix === null ? "user-content-" : settings.clobberPrefix;
    // To do: next major: move to `state.options`.
    state.footnoteLabel = settings.footnoteLabel || "Footnotes";
    // To do: next major: move to `state.options`.
    state.footnoteLabelTagName = settings.footnoteLabelTagName || "h2";
    // To do: next major: move to `state.options`.
    state.footnoteLabelProperties = settings.footnoteLabelProperties || {
        className: [
            "sr-only"
        ]
    };
    // To do: next major: move to `state.options`.
    state.footnoteBackLabel = settings.footnoteBackLabel || "Back to content";
    // To do: next major: move to `state.options`.
    state.unknownHandler = settings.unknownHandler;
    // To do: next major: move to `state.options`.
    state.passThrough = settings.passThrough;
    state.handlers = {
        ...(0, $3d43b8c0b4ae1acf$export$455ce229eb3d2472),
        ...settings.handlers
    };
    // To do: next major: replace utility with `definitionById` object, so we
    // only walk once (as we need footnotes too).
    state.definition = (0, $b619b8f4dbecce36$export$d79264f26953ec1)(tree);
    state.footnoteById = footnoteById;
    /** @type {Array<string>} */ state.footnoteOrder = [];
    /** @type {Record<string, number>} */ state.footnoteCounts = {};
    state.patch = $78f9463a77c540af$var$patch;
    state.applyData = $78f9463a77c540af$var$applyData;
    state.one = oneBound;
    state.all = allBound;
    state.wrap = $78f9463a77c540af$export$4997ffc0176396a6;
    // To do: next major: remove `augment`.
    state.augment = augment;
    (0, $8b61ffc0b5f74a03$export$bf638b60ea8b89b7)(tree, "footnoteDefinition", (definition)=>{
        const id = String(definition.identifier).toUpperCase();
        // Mimick CM behavior of link definitions.
        // See: <https://github.com/syntax-tree/mdast-util-definitions/blob/8290999/index.js#L26>.
        if (!$78f9463a77c540af$var$own.call(footnoteById, id)) footnoteById[id] = definition;
    });
    // @ts-expect-error Hush, it’s fine!
    return state;
    /**
   * Finalise the created `right`, a hast node, from `left`, an mdast node.
   *
   * @param {MdastNodeWithData | PositionLike | null | undefined} left
   * @param {HastElementContent} right
   * @returns {HastElementContent}
   */ /* c8 ignore start */ // To do: next major: remove.
    function augment(left, right) {
        // Handle `data.hName`, `data.hProperties, `data.hChildren`.
        if (left && "data" in left && left.data) {
            /** @type {MdastData} */ const data = left.data;
            if (data.hName) {
                if (right.type !== "element") right = {
                    type: "element",
                    tagName: "",
                    properties: {},
                    children: []
                };
                right.tagName = data.hName;
            }
            if (right.type === "element" && data.hProperties) right.properties = {
                ...right.properties,
                ...data.hProperties
            };
            if ("children" in right && right.children && data.hChildren) right.children = data.hChildren;
        }
        if (left) {
            const ctx = "type" in left ? left : {
                position: left
            };
            if (!(0, $a2b36f237fbb3f65$export$41ad1363166ec91a)(ctx)) // @ts-expect-error: fine.
            right.position = {
                start: (0, $8fa199b8e09e39ed$export$771bf3e4949bfbee)(ctx),
                end: (0, $8fa199b8e09e39ed$export$da309cdce9dc2a25)(ctx)
            };
        }
        return right;
    }
    /* c8 ignore stop */ /**
   * Create an element for `node`.
   *
   * @type {HFunctionProps}
   */ /* c8 ignore start */ // To do: next major: remove.
    function state(node, tagName, props, children) {
        if (Array.isArray(props)) {
            children = props;
            props = {};
        }
        // @ts-expect-error augmenting an element yields an element.
        return augment(node, {
            type: "element",
            tagName: tagName,
            properties: props || {},
            children: children || []
        });
    }
    /* c8 ignore stop */ /**
   * Transform an mdast node into a hast node.
   *
   * @param {MdastNodes} node
   *   mdast node.
   * @param {MdastParents | null | undefined} [parent]
   *   Parent of `node`.
   * @returns {HastElementContent | Array<HastElementContent> | null | undefined}
   *   Resulting hast node.
   */ function oneBound(node, parent) {
        // @ts-expect-error: that’s a state :)
        return $78f9463a77c540af$export$80bf7733f1207381(state, node, parent);
    }
    /**
   * Transform the children of an mdast node into hast nodes.
   *
   * @param {MdastNodes} parent
   *   mdast node to compile
   * @returns {Array<HastElementContent>}
   *   Resulting hast nodes.
   */ function allBound(parent) {
        // @ts-expect-error: that’s a state :)
        return $78f9463a77c540af$export$84bf76cd7afc7469(state, parent);
    }
}
/**
 * Copy a node’s positional info.
 *
 * @param {MdastNodes} from
 *   mdast node to copy from.
 * @param {HastNodes} to
 *   hast node to copy into.
 * @returns {void}
 *   Nothing.
 */ function $78f9463a77c540af$var$patch(from, to) {
    if (from.position) to.position = (0, $8fa199b8e09e39ed$export$5880b8b5730aff45)(from);
}
/**
 * Honor the `data` of `from` and maybe generate an element instead of `to`.
 *
 * @template {HastNodes} Type
 *   Node type.
 * @param {MdastNodes} from
 *   mdast node to use data from.
 * @param {Type} to
 *   hast node to change.
 * @returns {Type | HastElement}
 *   Nothing.
 */ function $78f9463a77c540af$var$applyData(from, to) {
    /** @type {Type | HastElement} */ let result = to;
    // Handle `data.hName`, `data.hProperties, `data.hChildren`.
    if (from && from.data) {
        const hName = from.data.hName;
        const hChildren = from.data.hChildren;
        const hProperties = from.data.hProperties;
        if (typeof hName === "string") {
            // Transforming the node resulted in an element with a different name
            // than wanted:
            if (result.type === "element") result.tagName = hName;
            else result = {
                type: "element",
                tagName: hName,
                properties: {},
                children: []
            };
        }
        if (result.type === "element" && hProperties) result.properties = {
            ...result.properties,
            ...hProperties
        };
        if ("children" in result && result.children && hChildren !== null && hChildren !== undefined) // @ts-expect-error: assume valid children are defined.
        result.children = hChildren;
    }
    return result;
}
function $78f9463a77c540af$export$80bf7733f1207381(state, node, parent) {
    const type = node && node.type;
    // Fail on non-nodes.
    if (!type) throw new Error("Expected node, got `" + node + "`");
    if ($78f9463a77c540af$var$own.call(state.handlers, type)) return state.handlers[type](state, node, parent);
    if (state.passThrough && state.passThrough.includes(type)) // To do: next major: deep clone.
    // @ts-expect-error: types of passed through nodes are expected to be added manually.
    return "children" in node ? {
        ...node,
        children: $78f9463a77c540af$export$84bf76cd7afc7469(state, node)
    } : node;
    if (state.unknownHandler) return state.unknownHandler(state, node, parent);
    return $78f9463a77c540af$var$defaultUnknownHandler(state, node);
}
function $78f9463a77c540af$export$84bf76cd7afc7469(state, parent) {
    /** @type {Array<HastElementContent>} */ const values = [];
    if ("children" in parent) {
        const nodes = parent.children;
        let index = -1;
        while(++index < nodes.length){
            const result = $78f9463a77c540af$export$80bf7733f1207381(state, nodes[index], parent);
            // To do: see if we van clean this? Can we merge texts?
            if (result) {
                if (index && nodes[index - 1].type === "break") {
                    if (!Array.isArray(result) && result.type === "text") result.value = result.value.replace(/^\s+/, "");
                    if (!Array.isArray(result) && result.type === "element") {
                        const head = result.children[0];
                        if (head && head.type === "text") head.value = head.value.replace(/^\s+/, "");
                    }
                }
                if (Array.isArray(result)) values.push(...result);
                else values.push(result);
            }
        }
    }
    return values;
}
/**
 * Transform an unknown node.
 *
 * @param {State} state
 *   Info passed around.
 * @param {MdastNodes} node
 *   Unknown mdast node.
 * @returns {HastText | HastElement}
 *   Resulting hast node.
 */ function $78f9463a77c540af$var$defaultUnknownHandler(state, node) {
    const data = node.data || {};
    /** @type {HastText | HastElement} */ const result = "value" in node && !($78f9463a77c540af$var$own.call(data, "hProperties") || $78f9463a77c540af$var$own.call(data, "hChildren")) ? {
        type: "text",
        value: node.value
    } : {
        type: "element",
        tagName: "div",
        properties: {},
        children: $78f9463a77c540af$export$84bf76cd7afc7469(state, node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}
function $78f9463a77c540af$export$4997ffc0176396a6(nodes, loose) {
    /** @type {Array<Type | HastText>} */ const result = [];
    let index = -1;
    if (loose) result.push({
        type: "text",
        value: "\n"
    });
    while(++index < nodes.length){
        if (index) result.push({
            type: "text",
            value: "\n"
        });
        result.push(nodes[index]);
    }
    if (loose && nodes.length > 0) result.push({
        type: "text",
        value: "\n"
    });
    return result;
}


function $e96c612a88e284b2$export$c0e4c5cf07538633(tree, options) {
    const state = (0, $78f9463a77c540af$export$e6a0daad8304de)(tree, options);
    const node = state.one(tree, null);
    const foot = (0, $914e37c8c11f9557$export$adb608be33961c98)(state);
    if (foot) // @ts-expect-error If there’s a footer, there were definitions, meaning block
    // content.
    // So assume `node` is a parent node.
    node.children.push({
        type: "text",
        value: "\n"
    }, foot);
    // To do: next major: always return root?
    return Array.isArray(node) ? {
        type: "root",
        children: node
    } : node;
}


// Note: the `<MdastRoot, HastRoot>` overload doesn’t seem to work :'(
/**
 * Plugin that turns markdown into HTML to support rehype.
 *
 * *   If a destination processor is given, that processor runs with a new HTML
 *     (hast) tree (bridge-mode).
 *     As the given processor runs with a hast tree, and rehype plugins support
 *     hast, that means rehype plugins can be used with the given processor.
 *     The hast tree is discarded in the end.
 *     It’s highly unlikely that you want to do this.
 * *   The common case is to not pass a destination processor, in which case the
 *     current processor continues running with a new HTML (hast) tree
 *     (mutate-mode).
 *     As the current processor continues with a hast tree, and rehype plugins
 *     support hast, that means rehype plugins can be used after
 *     `remark-rehype`.
 *     It’s likely that this is what you want to do.
 *
 * @param destination
 *   Optional unified processor.
 * @param options
 *   Options passed to `mdast-util-to-hast`.
 */ const $876b7a4dcfba7013$var$remarkRehype = /** @type {(import('unified').Plugin<[Processor, Options?]|[null|undefined, Options?]|[Options]|[], MdastRoot>)} */ function(destination, options) {
    return destination && "run" in destination ? $876b7a4dcfba7013$var$bridge(destination, options) : $876b7a4dcfba7013$var$mutate(destination || options);
};
var $876b7a4dcfba7013$export$2e2bcd8739ae039 = $876b7a4dcfba7013$var$remarkRehype;
/**
 * Bridge-mode.
 * Runs the destination with the new hast tree.
 *
 * @type {import('unified').Plugin<[Processor, Options?], MdastRoot>}
 */ function $876b7a4dcfba7013$var$bridge(destination, options) {
    return (node, file, next)=>{
        destination.run((0, $e96c612a88e284b2$export$c0e4c5cf07538633)(node, options), file, (error)=>{
            next(error);
        });
    };
}
/**
 * Mutate-mode.
 * Further plugins run on the hast tree.
 *
 * @type {import('unified').Plugin<[Options?]|void[], MdastRoot, HastRoot>}
 */ function $876b7a4dcfba7013$var$mutate(options) {
    // @ts-expect-error: assume a corresponding node is returned by `toHast`.
    return (node)=>(0, $e96c612a88e284b2$export$c0e4c5cf07538633)(node, options);
}



var $aRbOc = parcelRequire("aRbOc");
/**
 * @typedef {import('./lib/util/info.js').Info} Info
 * @typedef {import('./lib/util/schema.js').Schema} Schema
 */ /**
 * @typedef {import('./schema.js').Properties} Properties
 * @typedef {import('./schema.js').Normal} Normal
 */ /**
 * @typedef {import('./info.js').Info} Info
 * @typedef {Record<string, Info>} Properties
 * @typedef {Record<string, string>} Normal
 */ class $d78a8a70b1ddedcb$export$19342e026b58ebb7 {
    /**
   * @constructor
   * @param {Properties} property
   * @param {Normal} normal
   * @param {string} [space]
   */ constructor(property, normal, space){
        this.property = property;
        this.normal = normal;
        if (space) this.space = space;
    }
}
/** @type {Properties} */ $d78a8a70b1ddedcb$export$19342e026b58ebb7.prototype.property = {};
/** @type {Normal} */ $d78a8a70b1ddedcb$export$19342e026b58ebb7.prototype.normal = {};
/** @type {string|null} */ $d78a8a70b1ddedcb$export$19342e026b58ebb7.prototype.space = null;


function $66399e7c5d194295$export$4950aa0f605343fb(definitions, space) {
    /** @type {Properties} */ const property = {};
    /** @type {Normal} */ const normal = {};
    let index = -1;
    while(++index < definitions.length){
        Object.assign(property, definitions[index].property);
        Object.assign(normal, definitions[index].normal);
    }
    return new (0, $d78a8a70b1ddedcb$export$19342e026b58ebb7)(property, normal, space);
}


/**
 * @typedef {import('./schema.js').Properties} Properties
 * @typedef {import('./schema.js').Normal} Normal
 *
 * @typedef {Record<string, string>} Attributes
 *
 * @typedef {Object} Definition
 * @property {Record<string, number|null>} properties
 * @property {(attributes: Attributes, property: string) => string} transform
 * @property {string} [space]
 * @property {Attributes} [attributes]
 * @property {Array<string>} [mustUseProperty]
 */ /**
 * @param {string} value
 * @returns {string}
 */ function $634422beaed366ba$export$a3295358bff77e(value) {
    return value.toLowerCase();
}



class $bfbdbc236dd61c9c$export$c4868e4a24d48fad {
    /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   */ constructor(property, attribute){
        /** @type {string} */ this.property = property;
        /** @type {string} */ this.attribute = attribute;
    }
}
/** @type {string|null} */ $bfbdbc236dd61c9c$export$c4868e4a24d48fad.prototype.space = null;
$bfbdbc236dd61c9c$export$c4868e4a24d48fad.prototype.boolean = false;
$bfbdbc236dd61c9c$export$c4868e4a24d48fad.prototype.booleanish = false;
$bfbdbc236dd61c9c$export$c4868e4a24d48fad.prototype.overloadedBoolean = false;
$bfbdbc236dd61c9c$export$c4868e4a24d48fad.prototype.number = false;
$bfbdbc236dd61c9c$export$c4868e4a24d48fad.prototype.commaSeparated = false;
$bfbdbc236dd61c9c$export$c4868e4a24d48fad.prototype.spaceSeparated = false;
$bfbdbc236dd61c9c$export$c4868e4a24d48fad.prototype.commaOrSpaceSeparated = false;
$bfbdbc236dd61c9c$export$c4868e4a24d48fad.prototype.mustUseProperty = false;
$bfbdbc236dd61c9c$export$c4868e4a24d48fad.prototype.defined = false;


var $c8d066c53684dd82$exports = {};

$parcel$export($c8d066c53684dd82$exports, "boolean", function () { return $c8d066c53684dd82$export$4a21f16c33752377; });
$parcel$export($c8d066c53684dd82$exports, "booleanish", function () { return $c8d066c53684dd82$export$55e9e1fbc638dc8f; });
$parcel$export($c8d066c53684dd82$exports, "overloadedBoolean", function () { return $c8d066c53684dd82$export$242ac3d3042558aa; });
$parcel$export($c8d066c53684dd82$exports, "number", function () { return $c8d066c53684dd82$export$98e628dec113755e; });
$parcel$export($c8d066c53684dd82$exports, "spaceSeparated", function () { return $c8d066c53684dd82$export$ab8645c862eb5a3e; });
$parcel$export($c8d066c53684dd82$exports, "commaSeparated", function () { return $c8d066c53684dd82$export$9c8d678629b3d3; });
$parcel$export($c8d066c53684dd82$exports, "commaOrSpaceSeparated", function () { return $c8d066c53684dd82$export$2ad25cfebf36cacd; });
let $c8d066c53684dd82$var$powers = 0;
const $c8d066c53684dd82$export$4a21f16c33752377 = $c8d066c53684dd82$var$increment();
const $c8d066c53684dd82$export$55e9e1fbc638dc8f = $c8d066c53684dd82$var$increment();
const $c8d066c53684dd82$export$242ac3d3042558aa = $c8d066c53684dd82$var$increment();
const $c8d066c53684dd82$export$98e628dec113755e = $c8d066c53684dd82$var$increment();
const $c8d066c53684dd82$export$ab8645c862eb5a3e = $c8d066c53684dd82$var$increment();
const $c8d066c53684dd82$export$9c8d678629b3d3 = $c8d066c53684dd82$var$increment();
const $c8d066c53684dd82$export$2ad25cfebf36cacd = $c8d066c53684dd82$var$increment();
function $c8d066c53684dd82$var$increment() {
    return 2 ** ++$c8d066c53684dd82$var$powers;
}


/** @type {Array<keyof types>} */ // @ts-expect-error: hush.
const $af72fcf7da1b3dd5$var$checks = Object.keys($c8d066c53684dd82$exports);
class $af72fcf7da1b3dd5$export$ea6b9f0064e88c9b extends (0, $bfbdbc236dd61c9c$export$c4868e4a24d48fad) {
    /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   * @param {number|null} [mask]
   * @param {string} [space]
   */ constructor(property, attribute, mask, space){
        let index = -1;
        super(property, attribute);
        $af72fcf7da1b3dd5$var$mark(this, "space", space);
        if (typeof mask === "number") while(++index < $af72fcf7da1b3dd5$var$checks.length){
            const check = $af72fcf7da1b3dd5$var$checks[index];
            $af72fcf7da1b3dd5$var$mark(this, $af72fcf7da1b3dd5$var$checks[index], (mask & $c8d066c53684dd82$exports[check]) === $c8d066c53684dd82$exports[check]);
        }
    }
}
$af72fcf7da1b3dd5$export$ea6b9f0064e88c9b.prototype.defined = true;
/**
 * @param {DefinedInfo} values
 * @param {string} key
 * @param {unknown} value
 */ function $af72fcf7da1b3dd5$var$mark(values, key, value) {
    if (value) // @ts-expect-error: assume `value` matches the expected value of `key`.
    values[key] = value;
}


const $1fbc591bf1629265$var$own = {}.hasOwnProperty;
function $1fbc591bf1629265$export$185802fd694ee1f5(definition) {
    /** @type {Properties} */ const property = {};
    /** @type {Normal} */ const normal = {};
    /** @type {string} */ let prop;
    for(prop in definition.properties)if ($1fbc591bf1629265$var$own.call(definition.properties, prop)) {
        const value = definition.properties[prop];
        const info = new (0, $af72fcf7da1b3dd5$export$ea6b9f0064e88c9b)(prop, definition.transform(definition.attributes || {}, prop), value, definition.space);
        if (definition.mustUseProperty && definition.mustUseProperty.includes(prop)) info.mustUseProperty = true;
        property[prop] = info;
        normal[(0, $634422beaed366ba$export$a3295358bff77e)(prop)] = prop;
        normal[(0, $634422beaed366ba$export$a3295358bff77e)(info.attribute)] = prop;
    }
    return new (0, $d78a8a70b1ddedcb$export$19342e026b58ebb7)(property, normal, definition.space);
}


const $5404a662829d01e5$export$2bd1230ec7600845 = (0, $1fbc591bf1629265$export$185802fd694ee1f5)({
    space: "xlink",
    transform (_, prop) {
        return "xlink:" + prop.slice(5).toLowerCase();
    },
    properties: {
        xLinkActuate: null,
        xLinkArcRole: null,
        xLinkHref: null,
        xLinkRole: null,
        xLinkShow: null,
        xLinkTitle: null,
        xLinkType: null
    }
});



const $e92f2ee088291e50$export$f2913fe8983302e = (0, $1fbc591bf1629265$export$185802fd694ee1f5)({
    space: "xml",
    transform (_, prop) {
        return "xml:" + prop.slice(3).toLowerCase();
    },
    properties: {
        xmlLang: null,
        xmlBase: null,
        xmlSpace: null
    }
});



/**
 * @param {Record<string, string>} attributes
 * @param {string} attribute
 * @returns {string}
 */ function $650cd82c9112aa37$export$5b10b3bc32d7efbc(attributes, attribute) {
    return attribute in attributes ? attributes[attribute] : attribute;
}


function $89afee68db738fb9$export$32b9e4cec9c208e1(attributes, property) {
    return (0, $650cd82c9112aa37$export$5b10b3bc32d7efbc)(attributes, property.toLowerCase());
}


const $3d4855207f5fdab3$export$e20c24a128671213 = (0, $1fbc591bf1629265$export$185802fd694ee1f5)({
    space: "xmlns",
    attributes: {
        xmlnsxlink: "xmlns:xlink"
    },
    transform: (0, $89afee68db738fb9$export$32b9e4cec9c208e1),
    properties: {
        xmlns: null,
        xmlnsXLink: null
    }
});




const $d7c08daac2588403$export$4d2d26490572750a = (0, $1fbc591bf1629265$export$185802fd694ee1f5)({
    transform (_, prop) {
        return prop === "role" ? prop : "aria-" + prop.slice(4).toLowerCase();
    },
    properties: {
        ariaActiveDescendant: null,
        ariaAtomic: (0, $c8d066c53684dd82$export$55e9e1fbc638dc8f),
        ariaAutoComplete: null,
        ariaBusy: (0, $c8d066c53684dd82$export$55e9e1fbc638dc8f),
        ariaChecked: (0, $c8d066c53684dd82$export$55e9e1fbc638dc8f),
        ariaColCount: (0, $c8d066c53684dd82$export$98e628dec113755e),
        ariaColIndex: (0, $c8d066c53684dd82$export$98e628dec113755e),
        ariaColSpan: (0, $c8d066c53684dd82$export$98e628dec113755e),
        ariaControls: (0, $c8d066c53684dd82$export$ab8645c862eb5a3e),
        ariaCurrent: null,
        ariaDescribedBy: (0, $c8d066c53684dd82$export$ab8645c862eb5a3e),
        ariaDetails: null,
        ariaDisabled: (0, $c8d066c53684dd82$export$55e9e1fbc638dc8f),
        ariaDropEffect: (0, $c8d066c53684dd82$export$ab8645c862eb5a3e),
        ariaErrorMessage: null,
        ariaExpanded: (0, $c8d066c53684dd82$export$55e9e1fbc638dc8f),
        ariaFlowTo: (0, $c8d066c53684dd82$export$ab8645c862eb5a3e),
        ariaGrabbed: (0, $c8d066c53684dd82$export$55e9e1fbc638dc8f),
        ariaHasPopup: null,
        ariaHidden: (0, $c8d066c53684dd82$export$55e9e1fbc638dc8f),
        ariaInvalid: null,
        ariaKeyShortcuts: null,
        ariaLabel: null,
        ariaLabelledBy: (0, $c8d066c53684dd82$export$ab8645c862eb5a3e),
        ariaLevel: (0, $c8d066c53684dd82$export$98e628dec113755e),
        ariaLive: null,
        ariaModal: (0, $c8d066c53684dd82$export$55e9e1fbc638dc8f),
        ariaMultiLine: (0, $c8d066c53684dd82$export$55e9e1fbc638dc8f),
        ariaMultiSelectable: (0, $c8d066c53684dd82$export$55e9e1fbc638dc8f),
        ariaOrientation: null,
        ariaOwns: (0, $c8d066c53684dd82$export$ab8645c862eb5a3e),
        ariaPlaceholder: null,
        ariaPosInSet: (0, $c8d066c53684dd82$export$98e628dec113755e),
        ariaPressed: (0, $c8d066c53684dd82$export$55e9e1fbc638dc8f),
        ariaReadOnly: (0, $c8d066c53684dd82$export$55e9e1fbc638dc8f),
        ariaRelevant: null,
        ariaRequired: (0, $c8d066c53684dd82$export$55e9e1fbc638dc8f),
        ariaRoleDescription: (0, $c8d066c53684dd82$export$ab8645c862eb5a3e),
        ariaRowCount: (0, $c8d066c53684dd82$export$98e628dec113755e),
        ariaRowIndex: (0, $c8d066c53684dd82$export$98e628dec113755e),
        ariaRowSpan: (0, $c8d066c53684dd82$export$98e628dec113755e),
        ariaSelected: (0, $c8d066c53684dd82$export$55e9e1fbc638dc8f),
        ariaSetSize: (0, $c8d066c53684dd82$export$98e628dec113755e),
        ariaSort: null,
        ariaValueMax: (0, $c8d066c53684dd82$export$98e628dec113755e),
        ariaValueMin: (0, $c8d066c53684dd82$export$98e628dec113755e),
        ariaValueNow: (0, $c8d066c53684dd82$export$98e628dec113755e),
        ariaValueText: null,
        role: null
    }
});





const $5778b7181fe1951d$export$c0bb0b647f701bb5 = (0, $1fbc591bf1629265$export$185802fd694ee1f5)({
    space: "html",
    attributes: {
        acceptcharset: "accept-charset",
        classname: "class",
        htmlfor: "for",
        httpequiv: "http-equiv"
    },
    transform: (0, $89afee68db738fb9$export$32b9e4cec9c208e1),
    mustUseProperty: [
        "checked",
        "multiple",
        "muted",
        "selected"
    ],
    properties: {
        // Standard Properties.
        abbr: null,
        accept: (0, $c8d066c53684dd82$export$9c8d678629b3d3),
        acceptCharset: (0, $c8d066c53684dd82$export$ab8645c862eb5a3e),
        accessKey: (0, $c8d066c53684dd82$export$ab8645c862eb5a3e),
        action: null,
        allow: null,
        allowFullScreen: (0, $c8d066c53684dd82$export$4a21f16c33752377),
        allowPaymentRequest: (0, $c8d066c53684dd82$export$4a21f16c33752377),
        allowUserMedia: (0, $c8d066c53684dd82$export$4a21f16c33752377),
        alt: null,
        as: null,
        async: (0, $c8d066c53684dd82$export$4a21f16c33752377),
        autoCapitalize: null,
        autoComplete: (0, $c8d066c53684dd82$export$ab8645c862eb5a3e),
        autoFocus: (0, $c8d066c53684dd82$export$4a21f16c33752377),
        autoPlay: (0, $c8d066c53684dd82$export$4a21f16c33752377),
        blocking: (0, $c8d066c53684dd82$export$ab8645c862eb5a3e),
        capture: (0, $c8d066c53684dd82$export$4a21f16c33752377),
        charSet: null,
        checked: (0, $c8d066c53684dd82$export$4a21f16c33752377),
        cite: null,
        className: (0, $c8d066c53684dd82$export$ab8645c862eb5a3e),
        cols: (0, $c8d066c53684dd82$export$98e628dec113755e),
        colSpan: null,
        content: null,
        contentEditable: (0, $c8d066c53684dd82$export$55e9e1fbc638dc8f),
        controls: (0, $c8d066c53684dd82$export$4a21f16c33752377),
        controlsList: (0, $c8d066c53684dd82$export$ab8645c862eb5a3e),
        coords: (0, $c8d066c53684dd82$export$98e628dec113755e) | (0, $c8d066c53684dd82$export$9c8d678629b3d3),
        crossOrigin: null,
        data: null,
        dateTime: null,
        decoding: null,
        default: (0, $c8d066c53684dd82$export$4a21f16c33752377),
        defer: (0, $c8d066c53684dd82$export$4a21f16c33752377),
        dir: null,
        dirName: null,
        disabled: (0, $c8d066c53684dd82$export$4a21f16c33752377),
        download: (0, $c8d066c53684dd82$export$242ac3d3042558aa),
        draggable: (0, $c8d066c53684dd82$export$55e9e1fbc638dc8f),
        encType: null,
        enterKeyHint: null,
        fetchPriority: null,
        form: null,
        formAction: null,
        formEncType: null,
        formMethod: null,
        formNoValidate: (0, $c8d066c53684dd82$export$4a21f16c33752377),
        formTarget: null,
        headers: (0, $c8d066c53684dd82$export$ab8645c862eb5a3e),
        height: (0, $c8d066c53684dd82$export$98e628dec113755e),
        hidden: (0, $c8d066c53684dd82$export$4a21f16c33752377),
        high: (0, $c8d066c53684dd82$export$98e628dec113755e),
        href: null,
        hrefLang: null,
        htmlFor: (0, $c8d066c53684dd82$export$ab8645c862eb5a3e),
        httpEquiv: (0, $c8d066c53684dd82$export$ab8645c862eb5a3e),
        id: null,
        imageSizes: null,
        imageSrcSet: null,
        inert: (0, $c8d066c53684dd82$export$4a21f16c33752377),
        inputMode: null,
        integrity: null,
        is: null,
        isMap: (0, $c8d066c53684dd82$export$4a21f16c33752377),
        itemId: null,
        itemProp: (0, $c8d066c53684dd82$export$ab8645c862eb5a3e),
        itemRef: (0, $c8d066c53684dd82$export$ab8645c862eb5a3e),
        itemScope: (0, $c8d066c53684dd82$export$4a21f16c33752377),
        itemType: (0, $c8d066c53684dd82$export$ab8645c862eb5a3e),
        kind: null,
        label: null,
        lang: null,
        language: null,
        list: null,
        loading: null,
        loop: (0, $c8d066c53684dd82$export$4a21f16c33752377),
        low: (0, $c8d066c53684dd82$export$98e628dec113755e),
        manifest: null,
        max: null,
        maxLength: (0, $c8d066c53684dd82$export$98e628dec113755e),
        media: null,
        method: null,
        min: null,
        minLength: (0, $c8d066c53684dd82$export$98e628dec113755e),
        multiple: (0, $c8d066c53684dd82$export$4a21f16c33752377),
        muted: (0, $c8d066c53684dd82$export$4a21f16c33752377),
        name: null,
        nonce: null,
        noModule: (0, $c8d066c53684dd82$export$4a21f16c33752377),
        noValidate: (0, $c8d066c53684dd82$export$4a21f16c33752377),
        onAbort: null,
        onAfterPrint: null,
        onAuxClick: null,
        onBeforeMatch: null,
        onBeforePrint: null,
        onBeforeToggle: null,
        onBeforeUnload: null,
        onBlur: null,
        onCancel: null,
        onCanPlay: null,
        onCanPlayThrough: null,
        onChange: null,
        onClick: null,
        onClose: null,
        onContextLost: null,
        onContextMenu: null,
        onContextRestored: null,
        onCopy: null,
        onCueChange: null,
        onCut: null,
        onDblClick: null,
        onDrag: null,
        onDragEnd: null,
        onDragEnter: null,
        onDragExit: null,
        onDragLeave: null,
        onDragOver: null,
        onDragStart: null,
        onDrop: null,
        onDurationChange: null,
        onEmptied: null,
        onEnded: null,
        onError: null,
        onFocus: null,
        onFormData: null,
        onHashChange: null,
        onInput: null,
        onInvalid: null,
        onKeyDown: null,
        onKeyPress: null,
        onKeyUp: null,
        onLanguageChange: null,
        onLoad: null,
        onLoadedData: null,
        onLoadedMetadata: null,
        onLoadEnd: null,
        onLoadStart: null,
        onMessage: null,
        onMessageError: null,
        onMouseDown: null,
        onMouseEnter: null,
        onMouseLeave: null,
        onMouseMove: null,
        onMouseOut: null,
        onMouseOver: null,
        onMouseUp: null,
        onOffline: null,
        onOnline: null,
        onPageHide: null,
        onPageShow: null,
        onPaste: null,
        onPause: null,
        onPlay: null,
        onPlaying: null,
        onPopState: null,
        onProgress: null,
        onRateChange: null,
        onRejectionHandled: null,
        onReset: null,
        onResize: null,
        onScroll: null,
        onScrollEnd: null,
        onSecurityPolicyViolation: null,
        onSeeked: null,
        onSeeking: null,
        onSelect: null,
        onSlotChange: null,
        onStalled: null,
        onStorage: null,
        onSubmit: null,
        onSuspend: null,
        onTimeUpdate: null,
        onToggle: null,
        onUnhandledRejection: null,
        onUnload: null,
        onVolumeChange: null,
        onWaiting: null,
        onWheel: null,
        open: (0, $c8d066c53684dd82$export$4a21f16c33752377),
        optimum: (0, $c8d066c53684dd82$export$98e628dec113755e),
        pattern: null,
        ping: (0, $c8d066c53684dd82$export$ab8645c862eb5a3e),
        placeholder: null,
        playsInline: (0, $c8d066c53684dd82$export$4a21f16c33752377),
        popover: null,
        popoverTarget: null,
        popoverTargetAction: null,
        poster: null,
        preload: null,
        readOnly: (0, $c8d066c53684dd82$export$4a21f16c33752377),
        referrerPolicy: null,
        rel: (0, $c8d066c53684dd82$export$ab8645c862eb5a3e),
        required: (0, $c8d066c53684dd82$export$4a21f16c33752377),
        reversed: (0, $c8d066c53684dd82$export$4a21f16c33752377),
        rows: (0, $c8d066c53684dd82$export$98e628dec113755e),
        rowSpan: (0, $c8d066c53684dd82$export$98e628dec113755e),
        sandbox: (0, $c8d066c53684dd82$export$ab8645c862eb5a3e),
        scope: null,
        scoped: (0, $c8d066c53684dd82$export$4a21f16c33752377),
        seamless: (0, $c8d066c53684dd82$export$4a21f16c33752377),
        selected: (0, $c8d066c53684dd82$export$4a21f16c33752377),
        shadowRootDelegatesFocus: (0, $c8d066c53684dd82$export$4a21f16c33752377),
        shadowRootMode: null,
        shape: null,
        size: (0, $c8d066c53684dd82$export$98e628dec113755e),
        sizes: null,
        slot: null,
        span: (0, $c8d066c53684dd82$export$98e628dec113755e),
        spellCheck: (0, $c8d066c53684dd82$export$55e9e1fbc638dc8f),
        src: null,
        srcDoc: null,
        srcLang: null,
        srcSet: null,
        start: (0, $c8d066c53684dd82$export$98e628dec113755e),
        step: null,
        style: null,
        tabIndex: (0, $c8d066c53684dd82$export$98e628dec113755e),
        target: null,
        title: null,
        translate: null,
        type: null,
        typeMustMatch: (0, $c8d066c53684dd82$export$4a21f16c33752377),
        useMap: null,
        value: (0, $c8d066c53684dd82$export$55e9e1fbc638dc8f),
        width: (0, $c8d066c53684dd82$export$98e628dec113755e),
        wrap: null,
        // Legacy.
        // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
        align: null,
        aLink: null,
        archive: (0, $c8d066c53684dd82$export$ab8645c862eb5a3e),
        axis: null,
        background: null,
        bgColor: null,
        border: (0, $c8d066c53684dd82$export$98e628dec113755e),
        borderColor: null,
        bottomMargin: (0, $c8d066c53684dd82$export$98e628dec113755e),
        cellPadding: null,
        cellSpacing: null,
        char: null,
        charOff: null,
        classId: null,
        clear: null,
        code: null,
        codeBase: null,
        codeType: null,
        color: null,
        compact: (0, $c8d066c53684dd82$export$4a21f16c33752377),
        declare: (0, $c8d066c53684dd82$export$4a21f16c33752377),
        event: null,
        face: null,
        frame: null,
        frameBorder: null,
        hSpace: (0, $c8d066c53684dd82$export$98e628dec113755e),
        leftMargin: (0, $c8d066c53684dd82$export$98e628dec113755e),
        link: null,
        longDesc: null,
        lowSrc: null,
        marginHeight: (0, $c8d066c53684dd82$export$98e628dec113755e),
        marginWidth: (0, $c8d066c53684dd82$export$98e628dec113755e),
        noResize: (0, $c8d066c53684dd82$export$4a21f16c33752377),
        noHref: (0, $c8d066c53684dd82$export$4a21f16c33752377),
        noShade: (0, $c8d066c53684dd82$export$4a21f16c33752377),
        noWrap: (0, $c8d066c53684dd82$export$4a21f16c33752377),
        object: null,
        profile: null,
        prompt: null,
        rev: null,
        rightMargin: (0, $c8d066c53684dd82$export$98e628dec113755e),
        rules: null,
        scheme: null,
        scrolling: (0, $c8d066c53684dd82$export$55e9e1fbc638dc8f),
        standby: null,
        summary: null,
        text: null,
        topMargin: (0, $c8d066c53684dd82$export$98e628dec113755e),
        valueType: null,
        version: null,
        vAlign: null,
        vLink: null,
        vSpace: (0, $c8d066c53684dd82$export$98e628dec113755e),
        // Non-standard Properties.
        allowTransparency: null,
        autoCorrect: null,
        autoSave: null,
        disablePictureInPicture: (0, $c8d066c53684dd82$export$4a21f16c33752377),
        disableRemotePlayback: (0, $c8d066c53684dd82$export$4a21f16c33752377),
        prefix: null,
        property: null,
        results: (0, $c8d066c53684dd82$export$98e628dec113755e),
        security: null,
        unselectable: null
    }
});





const $0d66bd6666813744$export$7ed1367e7fa1ad68 = (0, $1fbc591bf1629265$export$185802fd694ee1f5)({
    space: "svg",
    attributes: {
        accentHeight: "accent-height",
        alignmentBaseline: "alignment-baseline",
        arabicForm: "arabic-form",
        baselineShift: "baseline-shift",
        capHeight: "cap-height",
        className: "class",
        clipPath: "clip-path",
        clipRule: "clip-rule",
        colorInterpolation: "color-interpolation",
        colorInterpolationFilters: "color-interpolation-filters",
        colorProfile: "color-profile",
        colorRendering: "color-rendering",
        crossOrigin: "crossorigin",
        dataType: "datatype",
        dominantBaseline: "dominant-baseline",
        enableBackground: "enable-background",
        fillOpacity: "fill-opacity",
        fillRule: "fill-rule",
        floodColor: "flood-color",
        floodOpacity: "flood-opacity",
        fontFamily: "font-family",
        fontSize: "font-size",
        fontSizeAdjust: "font-size-adjust",
        fontStretch: "font-stretch",
        fontStyle: "font-style",
        fontVariant: "font-variant",
        fontWeight: "font-weight",
        glyphName: "glyph-name",
        glyphOrientationHorizontal: "glyph-orientation-horizontal",
        glyphOrientationVertical: "glyph-orientation-vertical",
        hrefLang: "hreflang",
        horizAdvX: "horiz-adv-x",
        horizOriginX: "horiz-origin-x",
        horizOriginY: "horiz-origin-y",
        imageRendering: "image-rendering",
        letterSpacing: "letter-spacing",
        lightingColor: "lighting-color",
        markerEnd: "marker-end",
        markerMid: "marker-mid",
        markerStart: "marker-start",
        navDown: "nav-down",
        navDownLeft: "nav-down-left",
        navDownRight: "nav-down-right",
        navLeft: "nav-left",
        navNext: "nav-next",
        navPrev: "nav-prev",
        navRight: "nav-right",
        navUp: "nav-up",
        navUpLeft: "nav-up-left",
        navUpRight: "nav-up-right",
        onAbort: "onabort",
        onActivate: "onactivate",
        onAfterPrint: "onafterprint",
        onBeforePrint: "onbeforeprint",
        onBegin: "onbegin",
        onCancel: "oncancel",
        onCanPlay: "oncanplay",
        onCanPlayThrough: "oncanplaythrough",
        onChange: "onchange",
        onClick: "onclick",
        onClose: "onclose",
        onCopy: "oncopy",
        onCueChange: "oncuechange",
        onCut: "oncut",
        onDblClick: "ondblclick",
        onDrag: "ondrag",
        onDragEnd: "ondragend",
        onDragEnter: "ondragenter",
        onDragExit: "ondragexit",
        onDragLeave: "ondragleave",
        onDragOver: "ondragover",
        onDragStart: "ondragstart",
        onDrop: "ondrop",
        onDurationChange: "ondurationchange",
        onEmptied: "onemptied",
        onEnd: "onend",
        onEnded: "onended",
        onError: "onerror",
        onFocus: "onfocus",
        onFocusIn: "onfocusin",
        onFocusOut: "onfocusout",
        onHashChange: "onhashchange",
        onInput: "oninput",
        onInvalid: "oninvalid",
        onKeyDown: "onkeydown",
        onKeyPress: "onkeypress",
        onKeyUp: "onkeyup",
        onLoad: "onload",
        onLoadedData: "onloadeddata",
        onLoadedMetadata: "onloadedmetadata",
        onLoadStart: "onloadstart",
        onMessage: "onmessage",
        onMouseDown: "onmousedown",
        onMouseEnter: "onmouseenter",
        onMouseLeave: "onmouseleave",
        onMouseMove: "onmousemove",
        onMouseOut: "onmouseout",
        onMouseOver: "onmouseover",
        onMouseUp: "onmouseup",
        onMouseWheel: "onmousewheel",
        onOffline: "onoffline",
        onOnline: "ononline",
        onPageHide: "onpagehide",
        onPageShow: "onpageshow",
        onPaste: "onpaste",
        onPause: "onpause",
        onPlay: "onplay",
        onPlaying: "onplaying",
        onPopState: "onpopstate",
        onProgress: "onprogress",
        onRateChange: "onratechange",
        onRepeat: "onrepeat",
        onReset: "onreset",
        onResize: "onresize",
        onScroll: "onscroll",
        onSeeked: "onseeked",
        onSeeking: "onseeking",
        onSelect: "onselect",
        onShow: "onshow",
        onStalled: "onstalled",
        onStorage: "onstorage",
        onSubmit: "onsubmit",
        onSuspend: "onsuspend",
        onTimeUpdate: "ontimeupdate",
        onToggle: "ontoggle",
        onUnload: "onunload",
        onVolumeChange: "onvolumechange",
        onWaiting: "onwaiting",
        onZoom: "onzoom",
        overlinePosition: "overline-position",
        overlineThickness: "overline-thickness",
        paintOrder: "paint-order",
        panose1: "panose-1",
        pointerEvents: "pointer-events",
        referrerPolicy: "referrerpolicy",
        renderingIntent: "rendering-intent",
        shapeRendering: "shape-rendering",
        stopColor: "stop-color",
        stopOpacity: "stop-opacity",
        strikethroughPosition: "strikethrough-position",
        strikethroughThickness: "strikethrough-thickness",
        strokeDashArray: "stroke-dasharray",
        strokeDashOffset: "stroke-dashoffset",
        strokeLineCap: "stroke-linecap",
        strokeLineJoin: "stroke-linejoin",
        strokeMiterLimit: "stroke-miterlimit",
        strokeOpacity: "stroke-opacity",
        strokeWidth: "stroke-width",
        tabIndex: "tabindex",
        textAnchor: "text-anchor",
        textDecoration: "text-decoration",
        textRendering: "text-rendering",
        transformOrigin: "transform-origin",
        typeOf: "typeof",
        underlinePosition: "underline-position",
        underlineThickness: "underline-thickness",
        unicodeBidi: "unicode-bidi",
        unicodeRange: "unicode-range",
        unitsPerEm: "units-per-em",
        vAlphabetic: "v-alphabetic",
        vHanging: "v-hanging",
        vIdeographic: "v-ideographic",
        vMathematical: "v-mathematical",
        vectorEffect: "vector-effect",
        vertAdvY: "vert-adv-y",
        vertOriginX: "vert-origin-x",
        vertOriginY: "vert-origin-y",
        wordSpacing: "word-spacing",
        writingMode: "writing-mode",
        xHeight: "x-height",
        // These were camelcased in Tiny. Now lowercased in SVG 2
        playbackOrder: "playbackorder",
        timelineBegin: "timelinebegin"
    },
    transform: (0, $650cd82c9112aa37$export$5b10b3bc32d7efbc),
    properties: {
        about: (0, $c8d066c53684dd82$export$2ad25cfebf36cacd),
        accentHeight: (0, $c8d066c53684dd82$export$98e628dec113755e),
        accumulate: null,
        additive: null,
        alignmentBaseline: null,
        alphabetic: (0, $c8d066c53684dd82$export$98e628dec113755e),
        amplitude: (0, $c8d066c53684dd82$export$98e628dec113755e),
        arabicForm: null,
        ascent: (0, $c8d066c53684dd82$export$98e628dec113755e),
        attributeName: null,
        attributeType: null,
        azimuth: (0, $c8d066c53684dd82$export$98e628dec113755e),
        bandwidth: null,
        baselineShift: null,
        baseFrequency: null,
        baseProfile: null,
        bbox: null,
        begin: null,
        bias: (0, $c8d066c53684dd82$export$98e628dec113755e),
        by: null,
        calcMode: null,
        capHeight: (0, $c8d066c53684dd82$export$98e628dec113755e),
        className: (0, $c8d066c53684dd82$export$ab8645c862eb5a3e),
        clip: null,
        clipPath: null,
        clipPathUnits: null,
        clipRule: null,
        color: null,
        colorInterpolation: null,
        colorInterpolationFilters: null,
        colorProfile: null,
        colorRendering: null,
        content: null,
        contentScriptType: null,
        contentStyleType: null,
        crossOrigin: null,
        cursor: null,
        cx: null,
        cy: null,
        d: null,
        dataType: null,
        defaultAction: null,
        descent: (0, $c8d066c53684dd82$export$98e628dec113755e),
        diffuseConstant: (0, $c8d066c53684dd82$export$98e628dec113755e),
        direction: null,
        display: null,
        dur: null,
        divisor: (0, $c8d066c53684dd82$export$98e628dec113755e),
        dominantBaseline: null,
        download: (0, $c8d066c53684dd82$export$4a21f16c33752377),
        dx: null,
        dy: null,
        edgeMode: null,
        editable: null,
        elevation: (0, $c8d066c53684dd82$export$98e628dec113755e),
        enableBackground: null,
        end: null,
        event: null,
        exponent: (0, $c8d066c53684dd82$export$98e628dec113755e),
        externalResourcesRequired: null,
        fill: null,
        fillOpacity: (0, $c8d066c53684dd82$export$98e628dec113755e),
        fillRule: null,
        filter: null,
        filterRes: null,
        filterUnits: null,
        floodColor: null,
        floodOpacity: null,
        focusable: null,
        focusHighlight: null,
        fontFamily: null,
        fontSize: null,
        fontSizeAdjust: null,
        fontStretch: null,
        fontStyle: null,
        fontVariant: null,
        fontWeight: null,
        format: null,
        fr: null,
        from: null,
        fx: null,
        fy: null,
        g1: (0, $c8d066c53684dd82$export$9c8d678629b3d3),
        g2: (0, $c8d066c53684dd82$export$9c8d678629b3d3),
        glyphName: (0, $c8d066c53684dd82$export$9c8d678629b3d3),
        glyphOrientationHorizontal: null,
        glyphOrientationVertical: null,
        glyphRef: null,
        gradientTransform: null,
        gradientUnits: null,
        handler: null,
        hanging: (0, $c8d066c53684dd82$export$98e628dec113755e),
        hatchContentUnits: null,
        hatchUnits: null,
        height: null,
        href: null,
        hrefLang: null,
        horizAdvX: (0, $c8d066c53684dd82$export$98e628dec113755e),
        horizOriginX: (0, $c8d066c53684dd82$export$98e628dec113755e),
        horizOriginY: (0, $c8d066c53684dd82$export$98e628dec113755e),
        id: null,
        ideographic: (0, $c8d066c53684dd82$export$98e628dec113755e),
        imageRendering: null,
        initialVisibility: null,
        in: null,
        in2: null,
        intercept: (0, $c8d066c53684dd82$export$98e628dec113755e),
        k: (0, $c8d066c53684dd82$export$98e628dec113755e),
        k1: (0, $c8d066c53684dd82$export$98e628dec113755e),
        k2: (0, $c8d066c53684dd82$export$98e628dec113755e),
        k3: (0, $c8d066c53684dd82$export$98e628dec113755e),
        k4: (0, $c8d066c53684dd82$export$98e628dec113755e),
        kernelMatrix: (0, $c8d066c53684dd82$export$2ad25cfebf36cacd),
        kernelUnitLength: null,
        keyPoints: null,
        keySplines: null,
        keyTimes: null,
        kerning: null,
        lang: null,
        lengthAdjust: null,
        letterSpacing: null,
        lightingColor: null,
        limitingConeAngle: (0, $c8d066c53684dd82$export$98e628dec113755e),
        local: null,
        markerEnd: null,
        markerMid: null,
        markerStart: null,
        markerHeight: null,
        markerUnits: null,
        markerWidth: null,
        mask: null,
        maskContentUnits: null,
        maskUnits: null,
        mathematical: null,
        max: null,
        media: null,
        mediaCharacterEncoding: null,
        mediaContentEncodings: null,
        mediaSize: (0, $c8d066c53684dd82$export$98e628dec113755e),
        mediaTime: null,
        method: null,
        min: null,
        mode: null,
        name: null,
        navDown: null,
        navDownLeft: null,
        navDownRight: null,
        navLeft: null,
        navNext: null,
        navPrev: null,
        navRight: null,
        navUp: null,
        navUpLeft: null,
        navUpRight: null,
        numOctaves: null,
        observer: null,
        offset: null,
        onAbort: null,
        onActivate: null,
        onAfterPrint: null,
        onBeforePrint: null,
        onBegin: null,
        onCancel: null,
        onCanPlay: null,
        onCanPlayThrough: null,
        onChange: null,
        onClick: null,
        onClose: null,
        onCopy: null,
        onCueChange: null,
        onCut: null,
        onDblClick: null,
        onDrag: null,
        onDragEnd: null,
        onDragEnter: null,
        onDragExit: null,
        onDragLeave: null,
        onDragOver: null,
        onDragStart: null,
        onDrop: null,
        onDurationChange: null,
        onEmptied: null,
        onEnd: null,
        onEnded: null,
        onError: null,
        onFocus: null,
        onFocusIn: null,
        onFocusOut: null,
        onHashChange: null,
        onInput: null,
        onInvalid: null,
        onKeyDown: null,
        onKeyPress: null,
        onKeyUp: null,
        onLoad: null,
        onLoadedData: null,
        onLoadedMetadata: null,
        onLoadStart: null,
        onMessage: null,
        onMouseDown: null,
        onMouseEnter: null,
        onMouseLeave: null,
        onMouseMove: null,
        onMouseOut: null,
        onMouseOver: null,
        onMouseUp: null,
        onMouseWheel: null,
        onOffline: null,
        onOnline: null,
        onPageHide: null,
        onPageShow: null,
        onPaste: null,
        onPause: null,
        onPlay: null,
        onPlaying: null,
        onPopState: null,
        onProgress: null,
        onRateChange: null,
        onRepeat: null,
        onReset: null,
        onResize: null,
        onScroll: null,
        onSeeked: null,
        onSeeking: null,
        onSelect: null,
        onShow: null,
        onStalled: null,
        onStorage: null,
        onSubmit: null,
        onSuspend: null,
        onTimeUpdate: null,
        onToggle: null,
        onUnload: null,
        onVolumeChange: null,
        onWaiting: null,
        onZoom: null,
        opacity: null,
        operator: null,
        order: null,
        orient: null,
        orientation: null,
        origin: null,
        overflow: null,
        overlay: null,
        overlinePosition: (0, $c8d066c53684dd82$export$98e628dec113755e),
        overlineThickness: (0, $c8d066c53684dd82$export$98e628dec113755e),
        paintOrder: null,
        panose1: null,
        path: null,
        pathLength: (0, $c8d066c53684dd82$export$98e628dec113755e),
        patternContentUnits: null,
        patternTransform: null,
        patternUnits: null,
        phase: null,
        ping: (0, $c8d066c53684dd82$export$ab8645c862eb5a3e),
        pitch: null,
        playbackOrder: null,
        pointerEvents: null,
        points: null,
        pointsAtX: (0, $c8d066c53684dd82$export$98e628dec113755e),
        pointsAtY: (0, $c8d066c53684dd82$export$98e628dec113755e),
        pointsAtZ: (0, $c8d066c53684dd82$export$98e628dec113755e),
        preserveAlpha: null,
        preserveAspectRatio: null,
        primitiveUnits: null,
        propagate: null,
        property: (0, $c8d066c53684dd82$export$2ad25cfebf36cacd),
        r: null,
        radius: null,
        referrerPolicy: null,
        refX: null,
        refY: null,
        rel: (0, $c8d066c53684dd82$export$2ad25cfebf36cacd),
        rev: (0, $c8d066c53684dd82$export$2ad25cfebf36cacd),
        renderingIntent: null,
        repeatCount: null,
        repeatDur: null,
        requiredExtensions: (0, $c8d066c53684dd82$export$2ad25cfebf36cacd),
        requiredFeatures: (0, $c8d066c53684dd82$export$2ad25cfebf36cacd),
        requiredFonts: (0, $c8d066c53684dd82$export$2ad25cfebf36cacd),
        requiredFormats: (0, $c8d066c53684dd82$export$2ad25cfebf36cacd),
        resource: null,
        restart: null,
        result: null,
        rotate: null,
        rx: null,
        ry: null,
        scale: null,
        seed: null,
        shapeRendering: null,
        side: null,
        slope: null,
        snapshotTime: null,
        specularConstant: (0, $c8d066c53684dd82$export$98e628dec113755e),
        specularExponent: (0, $c8d066c53684dd82$export$98e628dec113755e),
        spreadMethod: null,
        spacing: null,
        startOffset: null,
        stdDeviation: null,
        stemh: null,
        stemv: null,
        stitchTiles: null,
        stopColor: null,
        stopOpacity: null,
        strikethroughPosition: (0, $c8d066c53684dd82$export$98e628dec113755e),
        strikethroughThickness: (0, $c8d066c53684dd82$export$98e628dec113755e),
        string: null,
        stroke: null,
        strokeDashArray: (0, $c8d066c53684dd82$export$2ad25cfebf36cacd),
        strokeDashOffset: null,
        strokeLineCap: null,
        strokeLineJoin: null,
        strokeMiterLimit: (0, $c8d066c53684dd82$export$98e628dec113755e),
        strokeOpacity: (0, $c8d066c53684dd82$export$98e628dec113755e),
        strokeWidth: null,
        style: null,
        surfaceScale: (0, $c8d066c53684dd82$export$98e628dec113755e),
        syncBehavior: null,
        syncBehaviorDefault: null,
        syncMaster: null,
        syncTolerance: null,
        syncToleranceDefault: null,
        systemLanguage: (0, $c8d066c53684dd82$export$2ad25cfebf36cacd),
        tabIndex: (0, $c8d066c53684dd82$export$98e628dec113755e),
        tableValues: null,
        target: null,
        targetX: (0, $c8d066c53684dd82$export$98e628dec113755e),
        targetY: (0, $c8d066c53684dd82$export$98e628dec113755e),
        textAnchor: null,
        textDecoration: null,
        textRendering: null,
        textLength: null,
        timelineBegin: null,
        title: null,
        transformBehavior: null,
        type: null,
        typeOf: (0, $c8d066c53684dd82$export$2ad25cfebf36cacd),
        to: null,
        transform: null,
        transformOrigin: null,
        u1: null,
        u2: null,
        underlinePosition: (0, $c8d066c53684dd82$export$98e628dec113755e),
        underlineThickness: (0, $c8d066c53684dd82$export$98e628dec113755e),
        unicode: null,
        unicodeBidi: null,
        unicodeRange: null,
        unitsPerEm: (0, $c8d066c53684dd82$export$98e628dec113755e),
        values: null,
        vAlphabetic: (0, $c8d066c53684dd82$export$98e628dec113755e),
        vMathematical: (0, $c8d066c53684dd82$export$98e628dec113755e),
        vectorEffect: null,
        vHanging: (0, $c8d066c53684dd82$export$98e628dec113755e),
        vIdeographic: (0, $c8d066c53684dd82$export$98e628dec113755e),
        version: null,
        vertAdvY: (0, $c8d066c53684dd82$export$98e628dec113755e),
        vertOriginX: (0, $c8d066c53684dd82$export$98e628dec113755e),
        vertOriginY: (0, $c8d066c53684dd82$export$98e628dec113755e),
        viewBox: null,
        viewTarget: null,
        visibility: null,
        width: null,
        widths: null,
        wordSpacing: null,
        writingMode: null,
        x: null,
        x1: null,
        x2: null,
        xChannelSelector: null,
        xHeight: (0, $c8d066c53684dd82$export$98e628dec113755e),
        y: null,
        y1: null,
        y2: null,
        yChannelSelector: null,
        z: null,
        zoomAndPan: null
    }
});


/**
 * @typedef {import('./util/schema.js').Schema} Schema
 */ 


const $c4d172bb3cb180fa$var$valid = /^data[-\w.:]+$/i;
const $c4d172bb3cb180fa$var$dash = /-[a-z]/g;
const $c4d172bb3cb180fa$var$cap = /[A-Z]/g;
function $c4d172bb3cb180fa$export$71aa6c912b956294(schema, value) {
    const normal = (0, $634422beaed366ba$export$a3295358bff77e)(value);
    let prop = value;
    let Type = (0, $bfbdbc236dd61c9c$export$c4868e4a24d48fad);
    if (normal in schema.normal) return schema.property[schema.normal[normal]];
    if (normal.length > 4 && normal.slice(0, 4) === "data" && $c4d172bb3cb180fa$var$valid.test(value)) {
        // Attribute or property.
        if (value.charAt(4) === "-") {
            // Turn it into a property.
            const rest = value.slice(5).replace($c4d172bb3cb180fa$var$dash, $c4d172bb3cb180fa$var$camelcase);
            prop = "data" + rest.charAt(0).toUpperCase() + rest.slice(1);
        } else {
            // Turn it into an attribute.
            const rest = value.slice(4);
            if (!$c4d172bb3cb180fa$var$dash.test(rest)) {
                let dashes = rest.replace($c4d172bb3cb180fa$var$cap, $c4d172bb3cb180fa$var$kebab);
                if (dashes.charAt(0) !== "-") dashes = "-" + dashes;
                value = "data" + dashes;
            }
        }
        Type = (0, $af72fcf7da1b3dd5$export$ea6b9f0064e88c9b);
    }
    return new Type(prop, value);
}
/**
 * @param {string} $0
 * @returns {string}
 */ function $c4d172bb3cb180fa$var$kebab($0) {
    return "-" + $0.toLowerCase();
}
/**
 * @param {string} $0
 * @returns {string}
 */ function $c4d172bb3cb180fa$var$camelcase($0) {
    return $0.charAt(1).toUpperCase();
}


/**
 * `hast` is close to `React`, but differs in a couple of cases.
 *
 * To get a React property from a hast property, check if it is in
 * `hastToReact`, if it is, then use the corresponding value,
 * otherwise, use the hast property.
 *
 * @type {Record<string, string>}
 */ const $d38ade3dc87c14e4$export$d8abd7e5fb6871f9 = {
    classId: "classID",
    dataType: "datatype",
    itemId: "itemID",
    strokeDashArray: "strokeDasharray",
    strokeDashOffset: "strokeDashoffset",
    strokeLineCap: "strokeLinecap",
    strokeLineJoin: "strokeLinejoin",
    strokeMiterLimit: "strokeMiterlimit",
    typeOf: "typeof",
    xLinkActuate: "xlinkActuate",
    xLinkArcRole: "xlinkArcrole",
    xLinkHref: "xlinkHref",
    xLinkRole: "xlinkRole",
    xLinkShow: "xlinkShow",
    xLinkTitle: "xlinkTitle",
    xLinkType: "xlinkType",
    xmlnsXLink: "xmlnsXlink"
};



const $8bc91675ca6c3138$export$c0bb0b647f701bb5 = (0, $66399e7c5d194295$export$4950aa0f605343fb)([
    (0, $e92f2ee088291e50$export$f2913fe8983302e),
    (0, $5404a662829d01e5$export$2bd1230ec7600845),
    (0, $3d4855207f5fdab3$export$e20c24a128671213),
    (0, $d7c08daac2588403$export$4d2d26490572750a),
    (0, $5778b7181fe1951d$export$c0bb0b647f701bb5)
], "html");
const $8bc91675ca6c3138$export$7ed1367e7fa1ad68 = (0, $66399e7c5d194295$export$4950aa0f605343fb)([
    (0, $e92f2ee088291e50$export$f2913fe8983302e),
    (0, $5404a662829d01e5$export$2bd1230ec7600845),
    (0, $3d4855207f5fdab3$export$e20c24a128671213),
    (0, $d7c08daac2588403$export$4d2d26490572750a),
    (0, $0d66bd6666813744$export$7ed1367e7fa1ad68)
], "svg");



function $45d6e047139bb4aa$export$2e2bcd8739ae039(options) {
    if (options.allowedElements && options.disallowedElements) throw new TypeError("Only one of `allowedElements` and `disallowedElements` should be defined");
    if (options.allowedElements || options.disallowedElements || options.allowElement) return (tree)=>{
        (0, $8b61ffc0b5f74a03$export$bf638b60ea8b89b7)(tree, "element", (node, index, parent_)=>{
            const parent = /** @type {Element|Root} */ parent_;
            /** @type {boolean|undefined} */ let remove;
            if (options.allowedElements) remove = !options.allowedElements.includes(node.tagName);
            else if (options.disallowedElements) remove = options.disallowedElements.includes(node.tagName);
            if (!remove && options.allowElement && typeof index === "number") remove = !options.allowElement(node, index, parent);
            if (remove && typeof index === "number") {
                if (options.unwrapDisallowed && node.children) parent.children.splice(index, 1, ...node.children);
                else parent.children.splice(index, 1);
                return index;
            }
            return undefined;
        });
    };
}


/**
 * @template T
 * @typedef {import('react').ComponentType<T>} ComponentType<T>
 */ /**
 * @template {import('react').ElementType} T
 * @typedef {import('react').ComponentPropsWithoutRef<T>} ComponentPropsWithoutRef<T>
 */ /**
 * @typedef {import('react').ReactNode} ReactNode
 * @typedef {import('unist').Position} Position
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').ElementContent} ElementContent
 * @typedef {import('hast').Root} Root
 * @typedef {import('hast').Text} Text
 * @typedef {import('hast').Comment} Comment
 * @typedef {import('hast').DocType} Doctype
 * @typedef {import('property-information').Info} Info
 * @typedef {import('property-information').Schema} Schema
 * @typedef {import('./complex-types.js').ReactMarkdownProps} ReactMarkdownProps
 *
 * @typedef Raw
 * @property {'raw'} type
 * @property {string} value
 *
 * @typedef Context
 * @property {Options} options
 * @property {Schema} schema
 * @property {number} listDepth
 *
 * @callback TransformLink
 * @param {string} href
 * @param {Array<ElementContent>} children
 * @param {string?} title
 * @returns {string}
 *
 * @callback TransformImage
 * @param {string} src
 * @param {string} alt
 * @param {string?} title
 * @returns {string}
 *
 * @typedef {import('react').HTMLAttributeAnchorTarget} TransformLinkTargetType
 *
 * @callback TransformLinkTarget
 * @param {string} href
 * @param {Array<ElementContent>} children
 * @param {string?} title
 * @returns {TransformLinkTargetType|undefined}
 *
 * @typedef {keyof JSX.IntrinsicElements} ReactMarkdownNames
 *
 * To do: is `data-sourcepos` typeable?
 *
 * @typedef {ComponentPropsWithoutRef<'code'> & ReactMarkdownProps & {inline?: boolean}} CodeProps
 * @typedef {ComponentPropsWithoutRef<'h1'> & ReactMarkdownProps & {level: number}} HeadingProps
 * @typedef {ComponentPropsWithoutRef<'li'> & ReactMarkdownProps & {checked: boolean|null, index: number, ordered: boolean}} LiProps
 * @typedef {ComponentPropsWithoutRef<'ol'> & ReactMarkdownProps & {depth: number, ordered: true}} OrderedListProps
 * @typedef {ComponentPropsWithoutRef<'td'> & ReactMarkdownProps & {style?: Record<string, unknown>, isHeader: false}} TableDataCellProps
 * @typedef {ComponentPropsWithoutRef<'th'> & ReactMarkdownProps & {style?: Record<string, unknown>, isHeader: true}} TableHeaderCellProps
 * @typedef {ComponentPropsWithoutRef<'tr'> & ReactMarkdownProps & {isHeader: boolean}} TableRowProps
 * @typedef {ComponentPropsWithoutRef<'ul'> & ReactMarkdownProps & {depth: number, ordered: false}} UnorderedListProps
 *
 * @typedef {ComponentType<CodeProps>} CodeComponent
 * @typedef {ComponentType<HeadingProps>} HeadingComponent
 * @typedef {ComponentType<LiProps>} LiComponent
 * @typedef {ComponentType<OrderedListProps>} OrderedListComponent
 * @typedef {ComponentType<TableDataCellProps>} TableDataCellComponent
 * @typedef {ComponentType<TableHeaderCellProps>} TableHeaderCellComponent
 * @typedef {ComponentType<TableRowProps>} TableRowComponent
 * @typedef {ComponentType<UnorderedListProps>} UnorderedListComponent
 *
 * @typedef SpecialComponents
 * @property {CodeComponent|ReactMarkdownNames} code
 * @property {HeadingComponent|ReactMarkdownNames} h1
 * @property {HeadingComponent|ReactMarkdownNames} h2
 * @property {HeadingComponent|ReactMarkdownNames} h3
 * @property {HeadingComponent|ReactMarkdownNames} h4
 * @property {HeadingComponent|ReactMarkdownNames} h5
 * @property {HeadingComponent|ReactMarkdownNames} h6
 * @property {LiComponent|ReactMarkdownNames} li
 * @property {OrderedListComponent|ReactMarkdownNames} ol
 * @property {TableDataCellComponent|ReactMarkdownNames} td
 * @property {TableHeaderCellComponent|ReactMarkdownNames} th
 * @property {TableRowComponent|ReactMarkdownNames} tr
 * @property {UnorderedListComponent|ReactMarkdownNames} ul
 *
 * @typedef {Partial<Omit<import('./complex-types.js').NormalComponents, keyof SpecialComponents> & SpecialComponents>} Components
 *
 * @typedef Options
 * @property {boolean} [sourcePos=false]
 * @property {boolean} [rawSourcePos=false]
 * @property {boolean} [skipHtml=false]
 * @property {boolean} [includeElementIndex=false]
 * @property {null|false|TransformLink} [transformLinkUri]
 * @property {TransformImage} [transformImageUri]
 * @property {TransformLinkTargetType|TransformLinkTarget} [linkTarget]
 * @property {Components} [components]
 */ 
var $b6HlZ = parcelRequire("b6HlZ");
var $a7ea0a05cd1d18d9$exports = {};
"use strict";

$a7ea0a05cd1d18d9$exports = (parcelRequire("gB0MJ"));


/**
 * Check if the given value is *inter-element whitespace*.
 *
 * @param {unknown} thing
 *   Thing to check (typically `Node` or `string`).
 * @returns {boolean}
 *   Whether the `value` is inter-element whitespace (`boolean`): consisting of
 *   zero or more of space, tab (`\t`), line feed (`\n`), carriage return
 *   (`\r`), or form feed (`\f`).
 *   If a node is passed it must be a `Text` node, whose `value` field is
 *   checked.
 */ function $256b9b8ddc73a04f$export$7af1228ff777d175(thing) {
    /** @type {string} */ const value = // @ts-expect-error looks like a node.
    thing && typeof thing === "object" && thing.type === "text" ? thing.value || "" : thing;
    // HTML whitespace expression.
    // See <https://infra.spec.whatwg.org/#ascii-whitespace>.
    return typeof value === "string" && value.replace(/[ \t\n\f\r]/g, "") === "";
}



/**
 * Parse space-separated tokens to an array of strings.
 *
 * @param {string} value
 *   Space-separated tokens.
 * @returns {Array<string>}
 *   List of tokens.
 */ function $71818ef4a329bb5a$export$98e6a39c04603d36(value) {
    const input = String(value || "").trim();
    return input ? input.split(/[ \t\n\r\f]+/g) : [];
}
function $71818ef4a329bb5a$export$fac44ee5b035f737(values) {
    return values.join(" ").trim();
}


/**
 * @typedef Options
 *   Configuration for `stringify`.
 * @property {boolean} [padLeft=true]
 *   Whether to pad a space before a token.
 * @property {boolean} [padRight=false]
 *   Whether to pad a space after a token.
 */ /**
 * @typedef {Options} StringifyOptions
 *   Please use `StringifyOptions` instead.
 */ /**
 * Parse comma-separated tokens to an array.
 *
 * @param {string} value
 *   Comma-separated tokens.
 * @returns {Array<string>}
 *   List of tokens.
 */ function $7180a08580bcff74$export$98e6a39c04603d36(value) {
    /** @type {Array<string>} */ const tokens = [];
    const input = String(value || "");
    let index = input.indexOf(",");
    let start = 0;
    /** @type {boolean} */ let end = false;
    while(!end){
        if (index === -1) {
            index = input.length;
            end = true;
        }
        const token = input.slice(start, index).trim();
        if (token || !end) tokens.push(token);
        start = index + 1;
        index = input.indexOf(",", start);
    }
    return tokens;
}
function $7180a08580bcff74$export$fac44ee5b035f737(values, options) {
    const settings = options || {};
    // Ensure the last empty entry is seen.
    const input = values[values.length - 1] === "" ? [
        ...values,
        ""
    ] : values;
    return input.join((settings.padRight ? " " : "") + "," + (settings.padLeft === false ? "" : " ")).trim();
}


var $56a200b8456f2c7d$exports = {};
var $290fbc945a77dcda$exports = {};
// http://www.w3.org/TR/CSS21/grammar.html
// https://github.com/visionmedia/css-parse/pull/49#issuecomment-30088027
var $290fbc945a77dcda$var$COMMENT_REGEX = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g;
var $290fbc945a77dcda$var$NEWLINE_REGEX = /\n/g;
var $290fbc945a77dcda$var$WHITESPACE_REGEX = /^\s*/;
// declaration
var $290fbc945a77dcda$var$PROPERTY_REGEX = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/;
var $290fbc945a77dcda$var$COLON_REGEX = /^:\s*/;
var $290fbc945a77dcda$var$VALUE_REGEX = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/;
var $290fbc945a77dcda$var$SEMICOLON_REGEX = /^[;\s]*/;
// https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/Trim#Polyfill
var $290fbc945a77dcda$var$TRIM_REGEX = /^\s+|\s+$/g;
// strings
var $290fbc945a77dcda$var$NEWLINE = "\n";
var $290fbc945a77dcda$var$FORWARD_SLASH = "/";
var $290fbc945a77dcda$var$ASTERISK = "*";
var $290fbc945a77dcda$var$EMPTY_STRING = "";
// types
var $290fbc945a77dcda$var$TYPE_COMMENT = "comment";
var $290fbc945a77dcda$var$TYPE_DECLARATION = "declaration";
/**
 * @param {String} style
 * @param {Object} [options]
 * @return {Object[]}
 * @throws {TypeError}
 * @throws {Error}
 */ $290fbc945a77dcda$exports = function(style, options) {
    if (typeof style !== "string") throw new TypeError("First argument must be a string");
    if (!style) return [];
    options = options || {};
    /**
   * Positional.
   */ var lineno = 1;
    var column = 1;
    /**
   * Update lineno and column based on `str`.
   *
   * @param {String} str
   */ function updatePosition(str) {
        var lines = str.match($290fbc945a77dcda$var$NEWLINE_REGEX);
        if (lines) lineno += lines.length;
        var i = str.lastIndexOf($290fbc945a77dcda$var$NEWLINE);
        column = ~i ? str.length - i : column + str.length;
    }
    /**
   * Mark position and patch `node.position`.
   *
   * @return {Function}
   */ function position() {
        var start = {
            line: lineno,
            column: column
        };
        return function(node) {
            node.position = new Position(start);
            whitespace();
            return node;
        };
    }
    /**
   * Store position information for a node.
   *
   * @constructor
   * @property {Object} start
   * @property {Object} end
   * @property {undefined|String} source
   */ function Position(start) {
        this.start = start;
        this.end = {
            line: lineno,
            column: column
        };
        this.source = options.source;
    }
    /**
   * Non-enumerable source string.
   */ Position.prototype.content = style;
    var errorsList = [];
    /**
   * Error `msg`.
   *
   * @param {String} msg
   * @throws {Error}
   */ function error(msg) {
        var err = new Error(options.source + ":" + lineno + ":" + column + ": " + msg);
        err.reason = msg;
        err.filename = options.source;
        err.line = lineno;
        err.column = column;
        err.source = style;
        if (options.silent) errorsList.push(err);
        else throw err;
    }
    /**
   * Match `re` and return captures.
   *
   * @param {RegExp} re
   * @return {undefined|Array}
   */ function match(re) {
        var m = re.exec(style);
        if (!m) return;
        var str = m[0];
        updatePosition(str);
        style = style.slice(str.length);
        return m;
    }
    /**
   * Parse whitespace.
   */ function whitespace() {
        match($290fbc945a77dcda$var$WHITESPACE_REGEX);
    }
    /**
   * Parse comments.
   *
   * @param {Object[]} [rules]
   * @return {Object[]}
   */ function comments(rules) {
        var c;
        rules = rules || [];
        while(c = comment())if (c !== false) rules.push(c);
        return rules;
    }
    /**
   * Parse comment.
   *
   * @return {Object}
   * @throws {Error}
   */ function comment() {
        var pos = position();
        if ($290fbc945a77dcda$var$FORWARD_SLASH != style.charAt(0) || $290fbc945a77dcda$var$ASTERISK != style.charAt(1)) return;
        var i = 2;
        while($290fbc945a77dcda$var$EMPTY_STRING != style.charAt(i) && ($290fbc945a77dcda$var$ASTERISK != style.charAt(i) || $290fbc945a77dcda$var$FORWARD_SLASH != style.charAt(i + 1)))++i;
        i += 2;
        if ($290fbc945a77dcda$var$EMPTY_STRING === style.charAt(i - 1)) return error("End of comment missing");
        var str = style.slice(2, i - 2);
        column += 2;
        updatePosition(str);
        style = style.slice(i);
        column += 2;
        return pos({
            type: $290fbc945a77dcda$var$TYPE_COMMENT,
            comment: str
        });
    }
    /**
   * Parse declaration.
   *
   * @return {Object}
   * @throws {Error}
   */ function declaration() {
        var pos = position();
        // prop
        var prop = match($290fbc945a77dcda$var$PROPERTY_REGEX);
        if (!prop) return;
        comment();
        // :
        if (!match($290fbc945a77dcda$var$COLON_REGEX)) return error("property missing ':'");
        // val
        var val = match($290fbc945a77dcda$var$VALUE_REGEX);
        var ret = pos({
            type: $290fbc945a77dcda$var$TYPE_DECLARATION,
            property: $290fbc945a77dcda$var$trim(prop[0].replace($290fbc945a77dcda$var$COMMENT_REGEX, $290fbc945a77dcda$var$EMPTY_STRING)),
            value: val ? $290fbc945a77dcda$var$trim(val[0].replace($290fbc945a77dcda$var$COMMENT_REGEX, $290fbc945a77dcda$var$EMPTY_STRING)) : $290fbc945a77dcda$var$EMPTY_STRING
        });
        // ;
        match($290fbc945a77dcda$var$SEMICOLON_REGEX);
        return ret;
    }
    /**
   * Parse declarations.
   *
   * @return {Object[]}
   */ function declarations() {
        var decls = [];
        comments(decls);
        // declarations
        var decl;
        while(decl = declaration())if (decl !== false) {
            decls.push(decl);
            comments(decls);
        }
        return decls;
    }
    whitespace();
    return declarations();
};
/**
 * Trim `str`.
 *
 * @param {String} str
 * @return {String}
 */ function $290fbc945a77dcda$var$trim(str) {
    return str ? str.replace($290fbc945a77dcda$var$TRIM_REGEX, $290fbc945a77dcda$var$EMPTY_STRING) : $290fbc945a77dcda$var$EMPTY_STRING;
}


/**
 * Parses inline style to object.
 *
 * @example
 * // returns { 'line-height': '42' }
 * StyleToObject('line-height: 42;');
 *
 * @param  {String}      style      - The inline style.
 * @param  {Function}    [iterator] - The iterator function.
 * @return {null|Object}
 */ function $56a200b8456f2c7d$var$StyleToObject(style, iterator) {
    var output = null;
    if (!style || typeof style !== "string") return output;
    var declaration;
    var declarations = $290fbc945a77dcda$exports(style);
    var hasIterator = typeof iterator === "function";
    var property;
    var value;
    for(var i = 0, len = declarations.length; i < len; i++){
        declaration = declarations[i];
        property = declaration.property;
        value = declaration.value;
        if (hasIterator) iterator(property, value, declaration);
        else if (value) {
            output || (output = {});
            output[property] = value;
        }
    }
    return output;
}
$56a200b8456f2c7d$exports = $56a200b8456f2c7d$var$StyleToObject;
$56a200b8456f2c7d$exports.default = $56a200b8456f2c7d$var$StyleToObject; // ESM support


var $b05cd11e9d418009$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($56a200b8456f2c7d$exports)));


const $16a8883b4f0f99cf$var$protocols = [
    "http",
    "https",
    "mailto",
    "tel"
];
function $16a8883b4f0f99cf$export$b83532a10e2e268b(uri) {
    const url = (uri || "").trim();
    const first = url.charAt(0);
    if (first === "#" || first === "/") return url;
    const colon = url.indexOf(":");
    if (colon === -1) return url;
    let index = -1;
    while(++index < $16a8883b4f0f99cf$var$protocols.length){
        const protocol = $16a8883b4f0f99cf$var$protocols[index];
        if (colon === protocol.length && url.slice(0, protocol.length).toLowerCase() === protocol) return url;
    }
    index = url.indexOf("?");
    if (index !== -1 && colon > index) return url;
    index = url.indexOf("#");
    if (index !== -1 && colon > index) return url;
    // eslint-disable-next-line no-script-url
    return "javascript:void(0)";
}


const $76c43674f65974bd$var$own = {}.hasOwnProperty;
// The table-related elements that must not contain whitespace text according
// to React.
const $76c43674f65974bd$var$tableElements = new Set([
    "table",
    "thead",
    "tbody",
    "tfoot",
    "tr"
]);
function $76c43674f65974bd$export$4b745c302603ab5d(context, node) {
    /** @type {Array<ReactNode>} */ const children = [];
    let childIndex = -1;
    /** @type {Comment|Doctype|Element|Raw|Text} */ let child;
    while(++childIndex < node.children.length){
        child = node.children[childIndex];
        if (child.type === "element") children.push($76c43674f65974bd$var$toReact(context, child, childIndex, node));
        else if (child.type === "text") // Currently, a warning is triggered by react for *any* white space in
        // tables.
        // So we drop it.
        // See: <https://github.com/facebook/react/pull/7081>.
        // See: <https://github.com/facebook/react/pull/7515>.
        // See: <https://github.com/remarkjs/remark-react/issues/64>.
        // See: <https://github.com/remarkjs/react-markdown/issues/576>.
        {
            if (node.type !== "element" || !$76c43674f65974bd$var$tableElements.has(node.tagName) || !(0, $256b9b8ddc73a04f$export$7af1228ff777d175)(child)) children.push(child.value);
        } else if (child.type === "raw" && !context.options.skipHtml) // Default behavior is to show (encoded) HTML.
        children.push(child.value);
    }
    return children;
}
/**
 * @param {Context} context
 * @param {Element} node
 * @param {number} index
 * @param {Element|Root} parent
 */ function $76c43674f65974bd$var$toReact(context, node, index, parent) {
    const options = context.options;
    const transform = options.transformLinkUri === undefined ? (0, $16a8883b4f0f99cf$export$b83532a10e2e268b) : options.transformLinkUri;
    const parentSchema = context.schema;
    /** @type {ReactMarkdownNames} */ // @ts-expect-error assume a known HTML/SVG element.
    const name = node.tagName;
    /** @type {Record<string, unknown>} */ const properties = {};
    let schema = parentSchema;
    /** @type {string} */ let property;
    if (parentSchema.space === "html" && name === "svg") {
        schema = (0, $8bc91675ca6c3138$export$7ed1367e7fa1ad68);
        context.schema = schema;
    }
    if (node.properties) {
        for(property in node.properties)if ($76c43674f65974bd$var$own.call(node.properties, property)) $76c43674f65974bd$var$addProperty(properties, property, node.properties[property], context);
    }
    if (name === "ol" || name === "ul") context.listDepth++;
    const children = $76c43674f65974bd$export$4b745c302603ab5d(context, node);
    if (name === "ol" || name === "ul") context.listDepth--;
    // Restore parent schema.
    context.schema = parentSchema;
    // Nodes created by plugins do not have positional info, in which case we use
    // an object that matches the position interface.
    const position = node.position || {
        start: {
            line: null,
            column: null,
            offset: null
        },
        end: {
            line: null,
            column: null,
            offset: null
        }
    };
    const component = options.components && $76c43674f65974bd$var$own.call(options.components, name) ? options.components[name] : name;
    const basic = typeof component === "string" || component === (0, (/*@__PURE__*/$parcel$interopDefault($b6HlZ))).Fragment;
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($a7ea0a05cd1d18d9$exports))).isValidElementType(component)) throw new TypeError(`Component for name \`${name}\` not defined or is not renderable`);
    properties.key = index;
    if (name === "a" && options.linkTarget) properties.target = typeof options.linkTarget === "function" ? options.linkTarget(String(properties.href || ""), node.children, typeof properties.title === "string" ? properties.title : null) : options.linkTarget;
    if (name === "a" && transform) properties.href = transform(String(properties.href || ""), node.children, typeof properties.title === "string" ? properties.title : null);
    if (!basic && name === "code" && parent.type === "element" && parent.tagName !== "pre") properties.inline = true;
    if (!basic && (name === "h1" || name === "h2" || name === "h3" || name === "h4" || name === "h5" || name === "h6")) properties.level = Number.parseInt(name.charAt(1), 10);
    if (name === "img" && options.transformImageUri) properties.src = options.transformImageUri(String(properties.src || ""), String(properties.alt || ""), typeof properties.title === "string" ? properties.title : null);
    if (!basic && name === "li" && parent.type === "element") {
        const input = $76c43674f65974bd$var$getInputElement(node);
        properties.checked = input && input.properties ? Boolean(input.properties.checked) : null;
        properties.index = $76c43674f65974bd$var$getElementsBeforeCount(parent, node);
        properties.ordered = parent.tagName === "ol";
    }
    if (!basic && (name === "ol" || name === "ul")) {
        properties.ordered = name === "ol";
        properties.depth = context.listDepth;
    }
    if (name === "td" || name === "th") {
        if (properties.align) {
            if (!properties.style) properties.style = {};
            // @ts-expect-error assume `style` is an object
            properties.style.textAlign = properties.align;
            delete properties.align;
        }
        if (!basic) properties.isHeader = name === "th";
    }
    if (!basic && name === "tr" && parent.type === "element") properties.isHeader = Boolean(parent.tagName === "thead");
    // If `sourcePos` is given, pass source information (line/column info from markdown source).
    if (options.sourcePos) properties["data-sourcepos"] = $76c43674f65974bd$var$flattenPosition(position);
    if (!basic && options.rawSourcePos) properties.sourcePosition = node.position;
    // If `includeElementIndex` is given, pass node index info to components.
    if (!basic && options.includeElementIndex) {
        properties.index = $76c43674f65974bd$var$getElementsBeforeCount(parent, node);
        properties.siblingCount = $76c43674f65974bd$var$getElementsBeforeCount(parent);
    }
    if (!basic) properties.node = node;
    // Ensure no React warnings are emitted for void elements w/ children.
    return children.length > 0 ? (0, (/*@__PURE__*/$parcel$interopDefault($b6HlZ))).createElement(component, properties, children) : (0, (/*@__PURE__*/$parcel$interopDefault($b6HlZ))).createElement(component, properties);
}
/**
 * @param {Element|Root} node
 * @returns {Element?}
 */ function $76c43674f65974bd$var$getInputElement(node) {
    let index = -1;
    while(++index < node.children.length){
        const child = node.children[index];
        if (child.type === "element" && child.tagName === "input") return child;
    }
    return null;
}
/**
 * @param {Element|Root} parent
 * @param {Element} [node]
 * @returns {number}
 */ function $76c43674f65974bd$var$getElementsBeforeCount(parent, node) {
    let index = -1;
    let count = 0;
    while(++index < parent.children.length){
        if (parent.children[index] === node) break;
        if (parent.children[index].type === "element") count++;
    }
    return count;
}
/**
 * @param {Record<string, unknown>} props
 * @param {string} prop
 * @param {unknown} value
 * @param {Context} ctx
 */ function $76c43674f65974bd$var$addProperty(props, prop, value, ctx) {
    const info = (0, $c4d172bb3cb180fa$export$71aa6c912b956294)(ctx.schema, prop);
    let result = value;
    // Ignore nullish and `NaN` values.
    // eslint-disable-next-line no-self-compare
    if (result === null || result === undefined || result !== result) return;
    // Accept `array`.
    // Most props are space-separated.
    if (Array.isArray(result)) result = info.commaSeparated ? (0, $7180a08580bcff74$export$fac44ee5b035f737)(result) : (0, $71818ef4a329bb5a$export$fac44ee5b035f737)(result);
    if (info.property === "style" && typeof result === "string") result = $76c43674f65974bd$var$parseStyle(result);
    if (info.space && info.property) props[$76c43674f65974bd$var$own.call((0, $d38ade3dc87c14e4$export$d8abd7e5fb6871f9), info.property) ? (0, $d38ade3dc87c14e4$export$d8abd7e5fb6871f9)[info.property] : info.property] = result;
    else if (info.attribute) props[info.attribute] = result;
}
/**
 * @param {string} value
 * @returns {Record<string, string>}
 */ function $76c43674f65974bd$var$parseStyle(value) {
    /** @type {Record<string, string>} */ const result = {};
    try {
        (0, $b05cd11e9d418009$export$2e2bcd8739ae039)(value, iterator);
    } catch  {
    // Silent.
    }
    return result;
    /**
   * @param {string} name
   * @param {string} v
   */ function iterator(name, v) {
        const k = name.slice(0, 4) === "-ms-" ? `ms-${name.slice(4)}` : name;
        result[k.replace(/-([a-z])/g, $76c43674f65974bd$var$styleReplacer)] = v;
    }
}
/**
 * @param {unknown} _
 * @param {string} $1
 */ function $76c43674f65974bd$var$styleReplacer(_, $1) {
    return $1.toUpperCase();
}
/**
 * @param {Position|{start: {line: null, column: null, offset: null}, end: {line: null, column: null, offset: null}}} pos
 * @returns {string}
 */ function $76c43674f65974bd$var$flattenPosition(pos) {
    return [
        pos.start.line,
        ":",
        pos.start.column,
        "-",
        pos.end.line,
        ":",
        pos.end.column
    ].map(String).join("");
}


const $fcd6f0226a0ae730$var$own = {}.hasOwnProperty;
const $fcd6f0226a0ae730$var$changelog = "https://github.com/remarkjs/react-markdown/blob/main/changelog.md";
/** @type {Record<string, Deprecation>} */ const $fcd6f0226a0ae730$var$deprecated = {
    plugins: {
        to: "remarkPlugins",
        id: "change-plugins-to-remarkplugins"
    },
    renderers: {
        to: "components",
        id: "change-renderers-to-components"
    },
    astPlugins: {
        id: "remove-buggy-html-in-markdown-parser"
    },
    allowDangerousHtml: {
        id: "remove-buggy-html-in-markdown-parser"
    },
    escapeHtml: {
        id: "remove-buggy-html-in-markdown-parser"
    },
    source: {
        to: "children",
        id: "change-source-to-children"
    },
    allowNode: {
        to: "allowElement",
        id: "replace-allownode-allowedtypes-and-disallowedtypes"
    },
    allowedTypes: {
        to: "allowedElements",
        id: "replace-allownode-allowedtypes-and-disallowedtypes"
    },
    disallowedTypes: {
        to: "disallowedElements",
        id: "replace-allownode-allowedtypes-and-disallowedtypes"
    },
    includeNodeIndex: {
        to: "includeElementIndex",
        id: "change-includenodeindex-to-includeelementindex"
    }
};
function $fcd6f0226a0ae730$export$83ef7ab426386201(options) {
    for(const key in $fcd6f0226a0ae730$var$deprecated)if ($fcd6f0226a0ae730$var$own.call($fcd6f0226a0ae730$var$deprecated, key) && $fcd6f0226a0ae730$var$own.call(options, key)) {
        const deprecation = $fcd6f0226a0ae730$var$deprecated[key];
        console.warn(`[react-markdown] Warning: please ${deprecation.to ? `use \`${deprecation.to}\` instead of` : "remove"} \`${key}\` (see <${$fcd6f0226a0ae730$var$changelog}#${deprecation.id}> for more info)`);
        delete $fcd6f0226a0ae730$var$deprecated[key];
    }
    const processor = (0, $0ac0148904b4dd9c$export$7cc1b2fe10c52bb)().use((0, $fe0e02f11b434e10$export$2e2bcd8739ae039)).use(options.remarkPlugins || []).use((0, $876b7a4dcfba7013$export$2e2bcd8739ae039), {
        ...options.remarkRehypeOptions,
        allowDangerousHtml: true
    }).use(options.rehypePlugins || []).use((0, $45d6e047139bb4aa$export$2e2bcd8739ae039), options);
    const file = new (0, $bfee953aeca75867$export$93dff69eb10dc7ce)();
    if (typeof options.children === "string") file.value = options.children;
    else if (options.children !== undefined && options.children !== null) console.warn(`[react-markdown] Warning: please pass a string as \`children\` (not: \`${options.children}\`)`);
    const hastNode = processor.runSync(processor.parse(file), file);
    if (hastNode.type !== "root") throw new TypeError("Expected a `root` node");
    /** @type {ReactElement} */ let result = (0, (/*@__PURE__*/$parcel$interopDefault($b6HlZ))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($b6HlZ))).Fragment, {}, (0, $76c43674f65974bd$export$4b745c302603ab5d)({
        options: options,
        schema: (0, $8bc91675ca6c3138$export$c0bb0b647f701bb5),
        listDepth: 0
    }, hastNode));
    if (options.className) result = (0, (/*@__PURE__*/$parcel$interopDefault($b6HlZ))).createElement("div", {
        className: options.className
    }, result);
    return result;
}
$fcd6f0226a0ae730$export$83ef7ab426386201.propTypes = {
    // Core options:
    children: (0, (/*@__PURE__*/$parcel$interopDefault($aRbOc))).string,
    // Layout options:
    className: (0, (/*@__PURE__*/$parcel$interopDefault($aRbOc))).string,
    // Filter options:
    allowElement: (0, (/*@__PURE__*/$parcel$interopDefault($aRbOc))).func,
    allowedElements: (0, (/*@__PURE__*/$parcel$interopDefault($aRbOc))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($aRbOc))).string),
    disallowedElements: (0, (/*@__PURE__*/$parcel$interopDefault($aRbOc))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($aRbOc))).string),
    unwrapDisallowed: (0, (/*@__PURE__*/$parcel$interopDefault($aRbOc))).bool,
    // Plugin options:
    remarkPlugins: (0, (/*@__PURE__*/$parcel$interopDefault($aRbOc))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($aRbOc))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($aRbOc))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($aRbOc))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($aRbOc))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($aRbOc))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($aRbOc))).bool,
            (0, (/*@__PURE__*/$parcel$interopDefault($aRbOc))).string,
            (0, (/*@__PURE__*/$parcel$interopDefault($aRbOc))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($aRbOc))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($aRbOc))).arrayOf(// prettier-ignore
            // type-coverage:ignore-next-line
            (0, (/*@__PURE__*/$parcel$interopDefault($aRbOc))).any)
        ]))
    ])),
    rehypePlugins: (0, (/*@__PURE__*/$parcel$interopDefault($aRbOc))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($aRbOc))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($aRbOc))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($aRbOc))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($aRbOc))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($aRbOc))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($aRbOc))).bool,
            (0, (/*@__PURE__*/$parcel$interopDefault($aRbOc))).string,
            (0, (/*@__PURE__*/$parcel$interopDefault($aRbOc))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($aRbOc))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($aRbOc))).arrayOf(// prettier-ignore
            // type-coverage:ignore-next-line
            (0, (/*@__PURE__*/$parcel$interopDefault($aRbOc))).any)
        ]))
    ])),
    // Transform options:
    sourcePos: (0, (/*@__PURE__*/$parcel$interopDefault($aRbOc))).bool,
    rawSourcePos: (0, (/*@__PURE__*/$parcel$interopDefault($aRbOc))).bool,
    skipHtml: (0, (/*@__PURE__*/$parcel$interopDefault($aRbOc))).bool,
    includeElementIndex: (0, (/*@__PURE__*/$parcel$interopDefault($aRbOc))).bool,
    transformLinkUri: (0, (/*@__PURE__*/$parcel$interopDefault($aRbOc))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($aRbOc))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($aRbOc))).bool
    ]),
    linkTarget: (0, (/*@__PURE__*/$parcel$interopDefault($aRbOc))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($aRbOc))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($aRbOc))).string
    ]),
    transformImageUri: (0, (/*@__PURE__*/$parcel$interopDefault($aRbOc))).func,
    components: (0, (/*@__PURE__*/$parcel$interopDefault($aRbOc))).object
};




var $b6HlZ = parcelRequire("b6HlZ");

var $hkULo = parcelRequire("hkULo");

var $j2DA4 = parcelRequire("j2DA4");

var $1BahA = parcelRequire("1BahA");
function $cab34702696efb7b$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $1BahA.default)(2, arguments);
    var date = (0, $j2DA4.default)(dirtyDate);
    var amount = (0, $hkULo.default)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 days, no-op to avoid changing times in the hour before end of DST
    return date;
    date.setDate(date.getDate() + amount);
    return date;
}


var $hkULo = parcelRequire("hkULo");

var $j2DA4 = parcelRequire("j2DA4");

var $1BahA = parcelRequire("1BahA");
function $623e079afbe8c632$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $1BahA.default)(2, arguments);
    var date = (0, $j2DA4.default)(dirtyDate);
    var amount = (0, $hkULo.default)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 months, no-op to avoid changing times in the hour before end of DST
    return date;
    var dayOfMonth = date.getDate();
    // The JS Date object supports date math by accepting out-of-bounds values for
    // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
    // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
    // want except that dates will wrap around the end of a month, meaning that
    // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
    // we'll default to the end of the desired month by adding 1 to the desired
    // month and using a date of 0 to back up one day to the end of the desired
    // month.
    var endOfDesiredMonth = new Date(date.getTime());
    endOfDesiredMonth.setMonth(date.getMonth() + amount + 1, 0);
    var daysInMonth = endOfDesiredMonth.getDate();
    if (dayOfMonth >= daysInMonth) // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
    else {
        // Otherwise, we now know that setting the original day-of-month value won't
        // cause an overflow, so set the desired day-of-month. Note that we can't
        // just set the date of `endOfDesiredMonth` because that object may have had
        // its time changed in the unusual case where where a DST transition was on
        // the last day of the month and its local time was in the hour skipped or
        // repeated next to a DST transition.  So we use `date` instead which is
        // guaranteed to still have the original time.
        date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
        return date;
    }
}


var $hkULo = parcelRequire("hkULo");


var $1BahA = parcelRequire("1BahA");
function $af4693c3eab78194$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $1BahA.default)(2, arguments);
    var amount = (0, $hkULo.default)(dirtyAmount);
    var days = amount * 7;
    return (0, $cab34702696efb7b$export$2e2bcd8739ae039)(dirtyDate, days);
}


var $hkULo = parcelRequire("hkULo");


var $1BahA = parcelRequire("1BahA");
function $5632dd425e7055b1$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $1BahA.default)(2, arguments);
    var amount = (0, $hkULo.default)(dirtyAmount);
    return (0, $623e079afbe8c632$export$2e2bcd8739ae039)(dirtyDate, amount * 12);
}


var $8Tuqe = parcelRequire("8Tuqe");

var $j2DA4 = parcelRequire("j2DA4");

var $1BahA = parcelRequire("1BahA");
function $bbc8a30b3b9c13e7$export$2e2bcd8739ae039(dirtyDate) {
    (0, $1BahA.default)(1, arguments);
    var date = (0, $j2DA4.default)(dirtyDate);
    date.setHours(0, 0, 0, 0);
    return date;
}



var $1BahA = parcelRequire("1BahA");
var $bc9a368e85fd9df6$var$MILLISECONDS_IN_DAY = 86400000;
function $bc9a368e85fd9df6$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $1BahA.default)(2, arguments);
    var startOfDayLeft = (0, $bbc8a30b3b9c13e7$export$2e2bcd8739ae039)(dirtyDateLeft);
    var startOfDayRight = (0, $bbc8a30b3b9c13e7$export$2e2bcd8739ae039)(dirtyDateRight);
    var timestampLeft = startOfDayLeft.getTime() - (0, $8Tuqe.default)(startOfDayLeft);
    var timestampRight = startOfDayRight.getTime() - (0, $8Tuqe.default)(startOfDayRight);
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a day is not constant
    // (e.g. it's different in the day of the daylight saving time clock shift)
    return Math.round((timestampLeft - timestampRight) / $bc9a368e85fd9df6$var$MILLISECONDS_IN_DAY);
}


var $j2DA4 = parcelRequire("j2DA4");

var $1BahA = parcelRequire("1BahA");
function $54c77849534ac91c$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $1BahA.default)(2, arguments);
    var dateLeft = (0, $j2DA4.default)(dirtyDateLeft);
    var dateRight = (0, $j2DA4.default)(dirtyDateRight);
    var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear();
    var monthDiff = dateLeft.getMonth() - dateRight.getMonth();
    return yearDiff * 12 + monthDiff;
}


var $2Kxhf = parcelRequire("2Kxhf");

var $j2DA4 = parcelRequire("j2DA4");

var $hkULo = parcelRequire("hkULo");

var $1BahA = parcelRequire("1BahA");
function $9856a141db4f5eb8$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $1BahA.default)(1, arguments);
    var defaultOptions = (0, $2Kxhf.getDefaultOptions)();
    var weekStartsOn = (0, $hkULo.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var date = (0, $j2DA4.default)(dirtyDate);
    var day = date.getDay();
    var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
    date.setDate(date.getDate() + diff);
    date.setHours(23, 59, 59, 999);
    return date;
}



var $1BahA = parcelRequire("1BahA");
function $a92ab20ed83b4ee2$export$2e2bcd8739ae039(dirtyDate) {
    (0, $1BahA.default)(1, arguments);
    return (0, $9856a141db4f5eb8$export$2e2bcd8739ae039)(dirtyDate, {
        weekStartsOn: 1
    });
}


var $j2DA4 = parcelRequire("j2DA4");

var $1BahA = parcelRequire("1BahA");
function $dde476f98780dbbe$export$2e2bcd8739ae039(dirtyDate) {
    (0, $1BahA.default)(1, arguments);
    var date = (0, $j2DA4.default)(dirtyDate);
    var month = date.getMonth();
    date.setFullYear(date.getFullYear(), month + 1, 0);
    date.setHours(23, 59, 59, 999);
    return date;
}


var $64KdH = parcelRequire("64KdH");

var $1BahA = parcelRequire("1BahA");
function $f8e700f283ae2061$export$2e2bcd8739ae039(value) {
    (0, $1BahA.default)(1, arguments);
    return value instanceof Date || (0, $64KdH.default)(value) === "object" && Object.prototype.toString.call(value) === "[object Date]";
}



var $j2DA4 = parcelRequire("j2DA4");

var $1BahA = parcelRequire("1BahA");
function $cb87bacf93312499$export$2e2bcd8739ae039(dirtyDate) {
    (0, $1BahA.default)(1, arguments);
    if (!(0, $f8e700f283ae2061$export$2e2bcd8739ae039)(dirtyDate) && typeof dirtyDate !== "number") return false;
    var date = (0, $j2DA4.default)(dirtyDate);
    return !isNaN(Number(date));
}



var $9aLpV = parcelRequire("9aLpV");

var $j2DA4 = parcelRequire("j2DA4");

var $j2DA4 = parcelRequire("j2DA4");

var $1BahA = parcelRequire("1BahA");
var $c34513c0441d7b59$var$MILLISECONDS_IN_DAY = 86400000;
function $c34513c0441d7b59$export$2e2bcd8739ae039(dirtyDate) {
    (0, $1BahA.default)(1, arguments);
    var date = (0, $j2DA4.default)(dirtyDate);
    var timestamp = date.getTime();
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
    var startOfYearTimestamp = date.getTime();
    var difference = timestamp - startOfYearTimestamp;
    return Math.floor(difference / $c34513c0441d7b59$var$MILLISECONDS_IN_DAY) + 1;
}



var $6bAaj = parcelRequire("6bAaj");

var $7F5O4 = parcelRequire("7F5O4");

var $kXZrS = parcelRequire("kXZrS");

var $1G1jh = parcelRequire("1G1jh");
function $a5b0225e85f80e29$export$2e2bcd8739ae039(number, targetLength) {
    var sign = number < 0 ? "-" : "";
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = "0" + output;
    return sign + output;
}



/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */ var $376436168c9e1b5a$var$formatters = {
    // Year
    y: function y(date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        var signedYear = date.getUTCFullYear();
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, $a5b0225e85f80e29$export$2e2bcd8739ae039)(token === "yy" ? year % 100 : year, token.length);
    },
    // Month
    M: function M(date, token) {
        var month = date.getUTCMonth();
        return token === "M" ? String(month + 1) : (0, $a5b0225e85f80e29$export$2e2bcd8739ae039)(month + 1, 2);
    },
    // Day of the month
    d: function d(date, token) {
        return (0, $a5b0225e85f80e29$export$2e2bcd8739ae039)(date.getUTCDate(), token.length);
    },
    // AM or PM
    a: function a(date, token) {
        var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return dayPeriodEnumValue.toUpperCase();
            case "aaa":
                return dayPeriodEnumValue;
            case "aaaaa":
                return dayPeriodEnumValue[0];
            case "aaaa":
            default:
                return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
        }
    },
    // Hour [1-12]
    h: function h(date, token) {
        return (0, $a5b0225e85f80e29$export$2e2bcd8739ae039)(date.getUTCHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H: function H(date, token) {
        return (0, $a5b0225e85f80e29$export$2e2bcd8739ae039)(date.getUTCHours(), token.length);
    },
    // Minute
    m: function m(date, token) {
        return (0, $a5b0225e85f80e29$export$2e2bcd8739ae039)(date.getUTCMinutes(), token.length);
    },
    // Second
    s: function s(date, token) {
        return (0, $a5b0225e85f80e29$export$2e2bcd8739ae039)(date.getUTCSeconds(), token.length);
    },
    // Fraction of second
    S: function S(date, token) {
        var numberOfDigits = token.length;
        var milliseconds = date.getUTCMilliseconds();
        var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, $a5b0225e85f80e29$export$2e2bcd8739ae039)(fractionalSeconds, token.length);
    }
};
var $376436168c9e1b5a$export$2e2bcd8739ae039 = $376436168c9e1b5a$var$formatters;


var $7dbb6f3eeb1b9512$var$dayPeriodEnum = {
    am: "am",
    pm: "pm",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */ var $7dbb6f3eeb1b9512$var$formatters = {
    // Era
    G: function G(date, token, localize) {
        var era = date.getUTCFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case "G":
            case "GG":
            case "GGG":
                return localize.era(era, {
                    width: "abbreviated"
                });
            // A, B
            case "GGGGG":
                return localize.era(era, {
                    width: "narrow"
                });
            // Anno Domini, Before Christ
            case "GGGG":
            default:
                return localize.era(era, {
                    width: "wide"
                });
        }
    },
    // Year
    y: function y(date, token, localize) {
        // Ordinal number
        if (token === "yo") {
            var signedYear = date.getUTCFullYear();
            // Returns 1 for 1 BC (which is year 0 in JavaScript)
            var year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: "year"
            });
        }
        return (0, $376436168c9e1b5a$export$2e2bcd8739ae039).y(date, token);
    },
    // Local week-numbering year
    Y: function Y(date, token, localize, options) {
        var signedWeekYear = (0, $1G1jh.default)(date, options);
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
        // Two digit year
        if (token === "YY") {
            var twoDigitYear = weekYear % 100;
            return (0, $a5b0225e85f80e29$export$2e2bcd8739ae039)(twoDigitYear, 2);
        }
        // Ordinal number
        if (token === "Yo") return localize.ordinalNumber(weekYear, {
            unit: "year"
        });
        // Padding
        return (0, $a5b0225e85f80e29$export$2e2bcd8739ae039)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function R(date, token) {
        var isoWeekYear = (0, $7F5O4.default)(date);
        // Padding
        return (0, $a5b0225e85f80e29$export$2e2bcd8739ae039)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function u(date, token) {
        var year = date.getUTCFullYear();
        return (0, $a5b0225e85f80e29$export$2e2bcd8739ae039)(year, token.length);
    },
    // Quarter
    Q: function Q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "Q":
                return String(quarter);
            // 01, 02, 03, 04
            case "QQ":
                return (0, $a5b0225e85f80e29$export$2e2bcd8739ae039)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "Qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "QQQ":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "QQQQQ":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1st quarter, 2nd quarter, ...
            case "QQQQ":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone quarter
    q: function q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "q":
                return String(quarter);
            // 01, 02, 03, 04
            case "qq":
                return (0, $a5b0225e85f80e29$export$2e2bcd8739ae039)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "qqq":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "qqqqq":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1st quarter, 2nd quarter, ...
            case "qqqq":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Month
    M: function M(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            case "M":
            case "MM":
                return (0, $376436168c9e1b5a$export$2e2bcd8739ae039).M(date, token);
            // 1st, 2nd, ..., 12th
            case "Mo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "MMM":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // J, F, ..., D
            case "MMMMM":
                return localize.month(month, {
                    width: "narrow",
                    context: "formatting"
                });
            // January, February, ..., December
            case "MMMM":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone month
    L: function L(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            // 1, 2, ..., 12
            case "L":
                return String(month + 1);
            // 01, 02, ..., 12
            case "LL":
                return (0, $a5b0225e85f80e29$export$2e2bcd8739ae039)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case "Lo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "LLL":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // J, F, ..., D
            case "LLLLL":
                return localize.month(month, {
                    width: "narrow",
                    context: "standalone"
                });
            // January, February, ..., December
            case "LLLL":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Local week of year
    w: function w(date, token, localize, options) {
        var week = (0, $kXZrS.default)(date, options);
        if (token === "wo") return localize.ordinalNumber(week, {
            unit: "week"
        });
        return (0, $a5b0225e85f80e29$export$2e2bcd8739ae039)(week, token.length);
    },
    // ISO week of year
    I: function I(date, token, localize) {
        var isoWeek = (0, $6bAaj.default)(date);
        if (token === "Io") return localize.ordinalNumber(isoWeek, {
            unit: "week"
        });
        return (0, $a5b0225e85f80e29$export$2e2bcd8739ae039)(isoWeek, token.length);
    },
    // Day of the month
    d: function d(date, token, localize) {
        if (token === "do") return localize.ordinalNumber(date.getUTCDate(), {
            unit: "date"
        });
        return (0, $376436168c9e1b5a$export$2e2bcd8739ae039).d(date, token);
    },
    // Day of year
    D: function D(date, token, localize) {
        var dayOfYear = (0, $c34513c0441d7b59$export$2e2bcd8739ae039)(date);
        if (token === "Do") return localize.ordinalNumber(dayOfYear, {
            unit: "dayOfYear"
        });
        return (0, $a5b0225e85f80e29$export$2e2bcd8739ae039)(dayOfYear, token.length);
    },
    // Day of week
    E: function E(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        switch(token){
            // Tue
            case "E":
            case "EE":
            case "EEE":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "EEEEE":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "EEEEEE":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "EEEE":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Local day of week
    e: function e(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case "e":
                return String(localDayOfWeek);
            // Padded numerical value
            case "ee":
                return (0, $a5b0225e85f80e29$export$2e2bcd8739ae039)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case "eo":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "eee":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "eeeee":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "eeeeee":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "eeee":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone local day of week
    c: function c(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case "c":
                return String(localDayOfWeek);
            // Padded numerical value
            case "cc":
                return (0, $a5b0225e85f80e29$export$2e2bcd8739ae039)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case "co":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "ccc":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // T
            case "ccccc":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tu
            case "cccccc":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "standalone"
                });
            // Tuesday
            case "cccc":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // ISO day of week
    i: function i(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case "i":
                return String(isoDayOfWeek);
            // 02
            case "ii":
                return (0, $a5b0225e85f80e29$export$2e2bcd8739ae039)(isoDayOfWeek, token.length);
            // 2nd
            case "io":
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: "day"
                });
            // Tue
            case "iii":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "iiiii":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "iiiiii":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "iiii":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM or PM
    a: function a(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "aaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "aaaaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaa":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM, PM, midnight, noon
    b: function b(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = $7dbb6f3eeb1b9512$var$dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = $7dbb6f3eeb1b9512$var$dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "b":
            case "bb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "bbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "bbbbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbb":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function B(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = $7dbb6f3eeb1b9512$var$dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = $7dbb6f3eeb1b9512$var$dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = $7dbb6f3eeb1b9512$var$dayPeriodEnum.morning;
        else dayPeriodEnumValue = $7dbb6f3eeb1b9512$var$dayPeriodEnum.night;
        switch(token){
            case "B":
            case "BB":
            case "BBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "BBBBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBB":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Hour [1-12]
    h: function h(date, token, localize) {
        if (token === "ho") {
            var hours = date.getUTCHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: "hour"
            });
        }
        return (0, $376436168c9e1b5a$export$2e2bcd8739ae039).h(date, token);
    },
    // Hour [0-23]
    H: function H(date, token, localize) {
        if (token === "Ho") return localize.ordinalNumber(date.getUTCHours(), {
            unit: "hour"
        });
        return (0, $376436168c9e1b5a$export$2e2bcd8739ae039).H(date, token);
    },
    // Hour [0-11]
    K: function K(date, token, localize) {
        var hours = date.getUTCHours() % 12;
        if (token === "Ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $a5b0225e85f80e29$export$2e2bcd8739ae039)(hours, token.length);
    },
    // Hour [1-24]
    k: function k(date, token, localize) {
        var hours = date.getUTCHours();
        if (hours === 0) hours = 24;
        if (token === "ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $a5b0225e85f80e29$export$2e2bcd8739ae039)(hours, token.length);
    },
    // Minute
    m: function m(date, token, localize) {
        if (token === "mo") return localize.ordinalNumber(date.getUTCMinutes(), {
            unit: "minute"
        });
        return (0, $376436168c9e1b5a$export$2e2bcd8739ae039).m(date, token);
    },
    // Second
    s: function s(date, token, localize) {
        if (token === "so") return localize.ordinalNumber(date.getUTCSeconds(), {
            unit: "second"
        });
        return (0, $376436168c9e1b5a$export$2e2bcd8739ae039).s(date, token);
    },
    // Fraction of second
    S: function S(date, token) {
        return (0, $376436168c9e1b5a$export$2e2bcd8739ae039).S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function X(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        if (timezoneOffset === 0) return "Z";
        switch(token){
            // Hours and optional minutes
            case "X":
                return $7dbb6f3eeb1b9512$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case "XXXX":
            case "XX":
                // Hours and minutes without `:` delimiter
                return $7dbb6f3eeb1b9512$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case "XXXXX":
            case "XXX":
            default:
                return $7dbb6f3eeb1b9512$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function x(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case "x":
                return $7dbb6f3eeb1b9512$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case "xxxx":
            case "xx":
                // Hours and minutes without `:` delimiter
                return $7dbb6f3eeb1b9512$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case "xxxxx":
            case "xxx":
            default:
                return $7dbb6f3eeb1b9512$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (GMT)
    O: function O(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case "O":
            case "OO":
            case "OOO":
                return "GMT" + $7dbb6f3eeb1b9512$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "OOOO":
            default:
                return "GMT" + $7dbb6f3eeb1b9512$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (specific non-location)
    z: function z(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case "z":
            case "zz":
            case "zzz":
                return "GMT" + $7dbb6f3eeb1b9512$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "zzzz":
            default:
                return "GMT" + $7dbb6f3eeb1b9512$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Seconds timestamp
    t: function t(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = Math.floor(originalDate.getTime() / 1000);
        return (0, $a5b0225e85f80e29$export$2e2bcd8739ae039)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function T(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = originalDate.getTime();
        return (0, $a5b0225e85f80e29$export$2e2bcd8739ae039)(timestamp, token.length);
    }
};
function $7dbb6f3eeb1b9512$var$formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? "-" : "+";
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || "";
    return sign + String(hours) + delimiter + (0, $a5b0225e85f80e29$export$2e2bcd8739ae039)(minutes, 2);
}
function $7dbb6f3eeb1b9512$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? "-" : "+";
        return sign + (0, $a5b0225e85f80e29$export$2e2bcd8739ae039)(Math.abs(offset) / 60, 2);
    }
    return $7dbb6f3eeb1b9512$var$formatTimezone(offset, dirtyDelimiter);
}
function $7dbb6f3eeb1b9512$var$formatTimezone(offset, dirtyDelimiter) {
    var delimiter = dirtyDelimiter || "";
    var sign = offset > 0 ? "-" : "+";
    var absOffset = Math.abs(offset);
    var hours = (0, $a5b0225e85f80e29$export$2e2bcd8739ae039)(Math.floor(absOffset / 60), 2);
    var minutes = (0, $a5b0225e85f80e29$export$2e2bcd8739ae039)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}
var $7dbb6f3eeb1b9512$export$2e2bcd8739ae039 = $7dbb6f3eeb1b9512$var$formatters;



var $l4BdG = parcelRequire("l4BdG");

var $8Tuqe = parcelRequire("8Tuqe");

var $kJsk3 = parcelRequire("kJsk3");

var $hkULo = parcelRequire("hkULo");

var $1BahA = parcelRequire("1BahA");

var $2Kxhf = parcelRequire("2Kxhf");

var $5RKOy = parcelRequire("5RKOy");
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var $8a568d5cdba66624$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var $8a568d5cdba66624$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var $8a568d5cdba66624$var$escapedStringRegExp = /^'([^]*?)'?$/;
var $8a568d5cdba66624$var$doubleQuoteRegExp = /''/g;
var $8a568d5cdba66624$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $8a568d5cdba66624$export$2e2bcd8739ae039(dirtyDate, dirtyFormatStr, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
    (0, $1BahA.default)(2, arguments);
    var formatStr = String(dirtyFormatStr);
    var defaultOptions = (0, $2Kxhf.getDefaultOptions)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $5RKOy.default);
    var firstWeekContainsDate = (0, $hkULo.default)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var weekStartsOn = (0, $hkULo.default)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    if (!locale.localize) throw new RangeError("locale must contain localize property");
    if (!locale.formatLong) throw new RangeError("locale must contain formatLong property");
    var originalDate = (0, $j2DA4.default)(dirtyDate);
    if (!(0, $cb87bacf93312499$export$2e2bcd8739ae039)(originalDate)) throw new RangeError("Invalid time value");
    // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    // This ensures that when UTC functions will be implemented, locales will be compatible with them.
    // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
    var timezoneOffset = (0, $8Tuqe.default)(originalDate);
    var utcDate = (0, $9aLpV.default)(originalDate, timezoneOffset);
    var formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale,
        _originalDate: originalDate
    };
    var result = formatStr.match($8a568d5cdba66624$var$longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter === "p" || firstCharacter === "P") {
            var longFormatter = (0, $l4BdG.default)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match($8a568d5cdba66624$var$formattingTokensRegExp).map(function(substring) {
        // Replace two single quote characters with one single quote character
        if (substring === "''") return "'";
        var firstCharacter = substring[0];
        if (firstCharacter === "'") return $8a568d5cdba66624$var$cleanEscapedString(substring);
        var formatter = (0, $7dbb6f3eeb1b9512$export$2e2bcd8739ae039)[firstCharacter];
        if (formatter) {
            if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, $kJsk3.isProtectedWeekYearToken)(substring)) (0, $kJsk3.throwProtectedError)(substring, dirtyFormatStr, String(dirtyDate));
            if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, $kJsk3.isProtectedDayOfYearToken)(substring)) (0, $kJsk3.throwProtectedError)(substring, dirtyFormatStr, String(dirtyDate));
            return formatter(utcDate, substring, locale.localize, formatterOptions);
        }
        if (firstCharacter.match($8a568d5cdba66624$var$unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
        return substring;
    }).join("");
    return result;
}
function $8a568d5cdba66624$var$cleanEscapedString(input) {
    var matched = input.match($8a568d5cdba66624$var$escapedStringRegExp);
    if (!matched) return input;
    return matched[1].replace($8a568d5cdba66624$var$doubleQuoteRegExp, "'");
}


var $j2DA4 = parcelRequire("j2DA4");

var $j2DA4 = parcelRequire("j2DA4");

var $hkULo = parcelRequire("hkULo");

var $1BahA = parcelRequire("1BahA");

var $2Kxhf = parcelRequire("2Kxhf");
function $97cce5fde4647ac6$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $1BahA.default)(1, arguments);
    var defaultOptions = (0, $2Kxhf.getDefaultOptions)();
    var weekStartsOn = (0, $hkULo.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var date = (0, $j2DA4.default)(dirtyDate);
    var day = date.getDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setDate(date.getDate() - diff);
    date.setHours(0, 0, 0, 0);
    return date;
}



var $1BahA = parcelRequire("1BahA");
function $33926cd4b89b52a2$export$2e2bcd8739ae039(dirtyDate) {
    (0, $1BahA.default)(1, arguments);
    return (0, $97cce5fde4647ac6$export$2e2bcd8739ae039)(dirtyDate, {
        weekStartsOn: 1
    });
}



var $j2DA4 = parcelRequire("j2DA4");


var $1BahA = parcelRequire("1BahA");
function $cb5fa212f56c80a7$export$2e2bcd8739ae039(dirtyDate) {
    (0, $1BahA.default)(1, arguments);
    var date = (0, $j2DA4.default)(dirtyDate);
    var year = date.getFullYear();
    var fourthOfJanuaryOfNextYear = new Date(0);
    fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
    var startOfNextYear = (0, $33926cd4b89b52a2$export$2e2bcd8739ae039)(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = new Date(0);
    fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
    var startOfThisYear = (0, $33926cd4b89b52a2$export$2e2bcd8739ae039)(fourthOfJanuaryOfThisYear);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}




var $1BahA = parcelRequire("1BahA");
function $29d1b8e569b5c99a$export$2e2bcd8739ae039(dirtyDate) {
    (0, $1BahA.default)(1, arguments);
    var year = (0, $cb5fa212f56c80a7$export$2e2bcd8739ae039)(dirtyDate);
    var fourthOfJanuary = new Date(0);
    fourthOfJanuary.setFullYear(year, 0, 4);
    fourthOfJanuary.setHours(0, 0, 0, 0);
    var date = (0, $33926cd4b89b52a2$export$2e2bcd8739ae039)(fourthOfJanuary);
    return date;
}



var $1BahA = parcelRequire("1BahA");
var $8e5c961712773f8f$var$MILLISECONDS_IN_WEEK = 604800000;
function $8e5c961712773f8f$export$2e2bcd8739ae039(dirtyDate) {
    (0, $1BahA.default)(1, arguments);
    var date = (0, $j2DA4.default)(dirtyDate);
    var diff = (0, $33926cd4b89b52a2$export$2e2bcd8739ae039)(date).getTime() - (0, $29d1b8e569b5c99a$export$2e2bcd8739ae039)(date).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $8e5c961712773f8f$var$MILLISECONDS_IN_WEEK) + 1;
}


var $j2DA4 = parcelRequire("j2DA4");

var $1BahA = parcelRequire("1BahA");
function $edba9c70c5e9467a$export$2e2bcd8739ae039(dirtyDate) {
    (0, $1BahA.default)(1, arguments);
    var date = (0, $j2DA4.default)(dirtyDate);
    var timestamp = date.getTime();
    return timestamp;
}



var $1BahA = parcelRequire("1BahA");
function $2105347126e6239c$export$2e2bcd8739ae039(dirtyDate) {
    (0, $1BahA.default)(1, arguments);
    return Math.floor((0, $edba9c70c5e9467a$export$2e2bcd8739ae039)(dirtyDate) / 1000);
}




var $j2DA4 = parcelRequire("j2DA4");

var $hkULo = parcelRequire("hkULo");

var $1BahA = parcelRequire("1BahA");

var $2Kxhf = parcelRequire("2Kxhf");
function $7adec406bf493aa3$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $1BahA.default)(1, arguments);
    var date = (0, $j2DA4.default)(dirtyDate);
    var year = date.getFullYear();
    var defaultOptions = (0, $2Kxhf.getDefaultOptions)();
    var firstWeekContainsDate = (0, $hkULo.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var firstWeekOfNextYear = new Date(0);
    firstWeekOfNextYear.setFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setHours(0, 0, 0, 0);
    var startOfNextYear = (0, $97cce5fde4647ac6$export$2e2bcd8739ae039)(firstWeekOfNextYear, options);
    var firstWeekOfThisYear = new Date(0);
    firstWeekOfThisYear.setFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setHours(0, 0, 0, 0);
    var startOfThisYear = (0, $97cce5fde4647ac6$export$2e2bcd8739ae039)(firstWeekOfThisYear, options);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}




var $hkULo = parcelRequire("hkULo");

var $1BahA = parcelRequire("1BahA");

var $2Kxhf = parcelRequire("2Kxhf");
function $c64069e4104cac90$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $1BahA.default)(1, arguments);
    var defaultOptions = (0, $2Kxhf.getDefaultOptions)();
    var firstWeekContainsDate = (0, $hkULo.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    var year = (0, $7adec406bf493aa3$export$2e2bcd8739ae039)(dirtyDate, options);
    var firstWeek = new Date(0);
    firstWeek.setFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setHours(0, 0, 0, 0);
    var date = (0, $97cce5fde4647ac6$export$2e2bcd8739ae039)(firstWeek, options);
    return date;
}



var $j2DA4 = parcelRequire("j2DA4");

var $1BahA = parcelRequire("1BahA");
var $afa71c803d1c325c$var$MILLISECONDS_IN_WEEK = 604800000;
function $afa71c803d1c325c$export$2e2bcd8739ae039(dirtyDate, options) {
    (0, $1BahA.default)(1, arguments);
    var date = (0, $j2DA4.default)(dirtyDate);
    var diff = (0, $97cce5fde4647ac6$export$2e2bcd8739ae039)(date, options).getTime() - (0, $c64069e4104cac90$export$2e2bcd8739ae039)(date, options).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $afa71c803d1c325c$var$MILLISECONDS_IN_WEEK) + 1;
}



var $8Tuqe = parcelRequire("8Tuqe");

var $1BahA = parcelRequire("1BahA");
var $7c00c2c58277545b$var$MILLISECONDS_IN_WEEK = 604800000;
function $7c00c2c58277545b$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight, options) {
    (0, $1BahA.default)(2, arguments);
    var startOfWeekLeft = (0, $97cce5fde4647ac6$export$2e2bcd8739ae039)(dirtyDateLeft, options);
    var startOfWeekRight = (0, $97cce5fde4647ac6$export$2e2bcd8739ae039)(dirtyDateRight, options);
    var timestampLeft = startOfWeekLeft.getTime() - (0, $8Tuqe.default)(startOfWeekLeft);
    var timestampRight = startOfWeekRight.getTime() - (0, $8Tuqe.default)(startOfWeekRight);
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round((timestampLeft - timestampRight) / $7c00c2c58277545b$var$MILLISECONDS_IN_WEEK);
}



var $j2DA4 = parcelRequire("j2DA4");

var $1BahA = parcelRequire("1BahA");
function $93de3c4a21c3038b$export$2e2bcd8739ae039(dirtyDate) {
    (0, $1BahA.default)(1, arguments);
    var date = (0, $j2DA4.default)(dirtyDate);
    var month = date.getMonth();
    date.setFullYear(date.getFullYear(), month + 1, 0);
    date.setHours(0, 0, 0, 0);
    return date;
}



var $j2DA4 = parcelRequire("j2DA4");

var $1BahA = parcelRequire("1BahA");
function $456b685109e85eeb$export$2e2bcd8739ae039(dirtyDate) {
    (0, $1BahA.default)(1, arguments);
    var date = (0, $j2DA4.default)(dirtyDate);
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
    return date;
}



var $1BahA = parcelRequire("1BahA");
function $65346f75b9bc392d$export$2e2bcd8739ae039(date, options) {
    (0, $1BahA.default)(1, arguments);
    return (0, $7c00c2c58277545b$export$2e2bcd8739ae039)((0, $93de3c4a21c3038b$export$2e2bcd8739ae039)(date), (0, $456b685109e85eeb$export$2e2bcd8739ae039)(date), options) + 1;
}


var $j2DA4 = parcelRequire("j2DA4");

var $1BahA = parcelRequire("1BahA");
function $b2aab07c3dbca894$export$2e2bcd8739ae039(dirtyDate, dirtyDateToCompare) {
    (0, $1BahA.default)(2, arguments);
    var date = (0, $j2DA4.default)(dirtyDate);
    var dateToCompare = (0, $j2DA4.default)(dirtyDateToCompare);
    return date.getTime() > dateToCompare.getTime();
}


var $j2DA4 = parcelRequire("j2DA4");

var $1BahA = parcelRequire("1BahA");
function $1aebcd0561bacc73$export$2e2bcd8739ae039(dirtyDate, dirtyDateToCompare) {
    (0, $1BahA.default)(2, arguments);
    var date = (0, $j2DA4.default)(dirtyDate);
    var dateToCompare = (0, $j2DA4.default)(dirtyDateToCompare);
    return date.getTime() < dateToCompare.getTime();
}



var $1BahA = parcelRequire("1BahA");
function $1393872aaf394788$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $1BahA.default)(2, arguments);
    var dateLeftStartOfDay = (0, $bbc8a30b3b9c13e7$export$2e2bcd8739ae039)(dirtyDateLeft);
    var dateRightStartOfDay = (0, $bbc8a30b3b9c13e7$export$2e2bcd8739ae039)(dirtyDateRight);
    return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime();
}


var $j2DA4 = parcelRequire("j2DA4");

var $1BahA = parcelRequire("1BahA");
function $9a3632b3cc120583$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $1BahA.default)(2, arguments);
    var dateLeft = (0, $j2DA4.default)(dirtyDateLeft);
    var dateRight = (0, $j2DA4.default)(dirtyDateRight);
    return dateLeft.getFullYear() === dateRight.getFullYear() && dateLeft.getMonth() === dateRight.getMonth();
}


var $j2DA4 = parcelRequire("j2DA4");

var $1BahA = parcelRequire("1BahA");
function $705899d11bf48017$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $1BahA.default)(2, arguments);
    var dateLeft = (0, $j2DA4.default)(dirtyDateLeft);
    var dateRight = (0, $j2DA4.default)(dirtyDateRight);
    return dateLeft.getFullYear() === dateRight.getFullYear();
}


var $64KdH = parcelRequire("64KdH");

var $j2DA4 = parcelRequire("j2DA4");

var $1BahA = parcelRequire("1BahA");
function $73d25d54a277ce0d$export$2e2bcd8739ae039(dirtyDatesArray) {
    (0, $1BahA.default)(1, arguments);
    var datesArray;
    // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method
    if (dirtyDatesArray && typeof dirtyDatesArray.forEach === "function") datesArray = dirtyDatesArray;
    else if ((0, $64KdH.default)(dirtyDatesArray) === "object" && dirtyDatesArray !== null) datesArray = Array.prototype.slice.call(dirtyDatesArray);
    else // `dirtyDatesArray` is non-iterable, return Invalid Date
    return new Date(NaN);
    var result;
    datesArray.forEach(function(dirtyDate) {
        var currentDate = (0, $j2DA4.default)(dirtyDate);
        if (result === undefined || result < currentDate || isNaN(Number(currentDate))) result = currentDate;
    });
    return result || new Date(NaN);
}


var $64KdH = parcelRequire("64KdH");

var $j2DA4 = parcelRequire("j2DA4");

var $1BahA = parcelRequire("1BahA");
function $291696af888c6902$export$2e2bcd8739ae039(dirtyDatesArray) {
    (0, $1BahA.default)(1, arguments);
    var datesArray;
    // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method
    if (dirtyDatesArray && typeof dirtyDatesArray.forEach === "function") datesArray = dirtyDatesArray;
    else if ((0, $64KdH.default)(dirtyDatesArray) === "object" && dirtyDatesArray !== null) datesArray = Array.prototype.slice.call(dirtyDatesArray);
    else // `dirtyDatesArray` is non-iterable, return Invalid Date
    return new Date(NaN);
    var result;
    datesArray.forEach(function(dirtyDate) {
        var currentDate = (0, $j2DA4.default)(dirtyDate);
        if (result === undefined || result > currentDate || isNaN(currentDate.getDate())) result = currentDate;
    });
    return result || new Date(NaN);
}


var $9sLUZ = parcelRequire("9sLUZ");
var $hkULo = parcelRequire("hkULo");

var $j2DA4 = parcelRequire("j2DA4");

var $j2DA4 = parcelRequire("j2DA4");

var $1BahA = parcelRequire("1BahA");
function $98f29519ea2b3658$export$2e2bcd8739ae039(dirtyDate) {
    (0, $1BahA.default)(1, arguments);
    var date = (0, $j2DA4.default)(dirtyDate);
    var year = date.getFullYear();
    var monthIndex = date.getMonth();
    var lastDayOfMonth = new Date(0);
    lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
    lastDayOfMonth.setHours(0, 0, 0, 0);
    return lastDayOfMonth.getDate();
}



var $1BahA = parcelRequire("1BahA");
function $6be41408aceb6712$export$2e2bcd8739ae039(dirtyDate, dirtyMonth) {
    (0, $1BahA.default)(2, arguments);
    var date = (0, $j2DA4.default)(dirtyDate);
    var month = (0, $hkULo.default)(dirtyMonth);
    var year = date.getFullYear();
    var day = date.getDate();
    var dateWithDesiredMonth = new Date(0);
    dateWithDesiredMonth.setFullYear(year, month, 15);
    dateWithDesiredMonth.setHours(0, 0, 0, 0);
    var daysInMonth = (0, $98f29519ea2b3658$export$2e2bcd8739ae039)(dateWithDesiredMonth);
    // Set the last day of the new month
    // if the original date was the last day of the longer month
    date.setMonth(month, Math.min(day, daysInMonth));
    return date;
}


var $hkULo = parcelRequire("hkULo");

var $j2DA4 = parcelRequire("j2DA4");

var $1BahA = parcelRequire("1BahA");
function $e877a00a87494bb7$export$2e2bcd8739ae039(dirtyDate, dirtyYear) {
    (0, $1BahA.default)(2, arguments);
    var date = (0, $j2DA4.default)(dirtyDate);
    var year = (0, $hkULo.default)(dirtyYear);
    // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date
    if (isNaN(date.getTime())) return new Date(NaN);
    date.setFullYear(year);
    return date;
}


var $j2DA4 = parcelRequire("j2DA4");

var $1BahA = parcelRequire("1BahA");
function $ca03fcf48af63ebc$export$2e2bcd8739ae039(dirtyDate) {
    (0, $1BahA.default)(1, arguments);
    var cleanDate = (0, $j2DA4.default)(dirtyDate);
    var date = new Date(0);
    date.setFullYear(cleanDate.getFullYear(), 0, 1);
    date.setHours(0, 0, 0, 0);
    return date;
}



var $1BahA = parcelRequire("1BahA");

var $hkULo = parcelRequire("hkULo");
function $d96f67c3c2cbd49c$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $1BahA.default)(2, arguments);
    var amount = (0, $hkULo.default)(dirtyAmount);
    return (0, $cab34702696efb7b$export$2e2bcd8739ae039)(dirtyDate, -amount);
}



var $b0hzc = parcelRequire("b0hzc");
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $89da45f89b022bca$var$__assign = function() {
    $89da45f89b022bca$var$__assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $89da45f89b022bca$var$__assign.apply(this, arguments);
};
function $89da45f89b022bca$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $89da45f89b022bca$var$__spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
typeof SuppressedError === "function" && SuppressedError;
var $89da45f89b022bca$var$jsxRuntime = {
    exports: {}
};
var $89da45f89b022bca$var$reactJsxRuntime_production_min = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $89da45f89b022bca$var$hasRequiredReactJsxRuntime_production_min;
function $89da45f89b022bca$var$requireReactJsxRuntime_production_min() {
    if ($89da45f89b022bca$var$hasRequiredReactJsxRuntime_production_min) return $89da45f89b022bca$var$reactJsxRuntime_production_min;
    $89da45f89b022bca$var$hasRequiredReactJsxRuntime_production_min = 1;
    var f = (0, (/*@__PURE__*/$parcel$interopDefault($b6HlZ))), k = Symbol.for("react.element"), l = Symbol.for("react.fragment"), m = Object.prototype.hasOwnProperty, n = f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, p = {
        key: !0,
        ref: !0,
        __self: !0,
        __source: !0
    };
    function q(c, a, g) {
        var b, d = {}, e = null, h = null;
        void 0 !== g && (e = "" + g);
        void 0 !== a.key && (e = "" + a.key);
        void 0 !== a.ref && (h = a.ref);
        for(b in a)m.call(a, b) && !p.hasOwnProperty(b) && (d[b] = a[b]);
        if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
        return {
            $$typeof: k,
            type: c,
            key: e,
            ref: h,
            props: d,
            _owner: n.current
        };
    }
    $89da45f89b022bca$var$reactJsxRuntime_production_min.Fragment = l;
    $89da45f89b022bca$var$reactJsxRuntime_production_min.jsx = q;
    $89da45f89b022bca$var$reactJsxRuntime_production_min.jsxs = q;
    return $89da45f89b022bca$var$reactJsxRuntime_production_min;
}
var $89da45f89b022bca$var$reactJsxRuntime_development = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $89da45f89b022bca$var$hasRequiredReactJsxRuntime_development;
function $89da45f89b022bca$var$requireReactJsxRuntime_development() {
    if ($89da45f89b022bca$var$hasRequiredReactJsxRuntime_development) return $89da45f89b022bca$var$reactJsxRuntime_development;
    $89da45f89b022bca$var$hasRequiredReactJsxRuntime_development = 1;
    return $89da45f89b022bca$var$reactJsxRuntime_development;
}
$89da45f89b022bca$var$jsxRuntime.exports = $89da45f89b022bca$var$requireReactJsxRuntime_production_min();
var $89da45f89b022bca$var$jsxRuntimeExports = $89da45f89b022bca$var$jsxRuntime.exports;
/** Returns true when the props are of type {@link DayPickerMultipleProps}. */ function $89da45f89b022bca$export$2d8c2b43ec0e528(props) {
    return props.mode === "multiple";
}
/** Returns true when the props are of type {@link DayPickerRangeProps}. */ function $89da45f89b022bca$export$f7b9f96866ec1964(props) {
    return props.mode === "range";
}
/** Returns true when the props are of type {@link DayPickerSingleProps}. */ function $89da45f89b022bca$export$e659ce9b264ea61(props) {
    return props.mode === "single";
}
/**
 * The name of the default CSS classes.
 */ var $89da45f89b022bca$var$defaultClassNames = {
    root: "rdp",
    multiple_months: "rdp-multiple_months",
    with_weeknumber: "rdp-with_weeknumber",
    vhidden: "rdp-vhidden",
    button_reset: "rdp-button_reset",
    button: "rdp-button",
    caption: "rdp-caption",
    caption_start: "rdp-caption_start",
    caption_end: "rdp-caption_end",
    caption_between: "rdp-caption_between",
    caption_label: "rdp-caption_label",
    caption_dropdowns: "rdp-caption_dropdowns",
    dropdown: "rdp-dropdown",
    dropdown_month: "rdp-dropdown_month",
    dropdown_year: "rdp-dropdown_year",
    dropdown_icon: "rdp-dropdown_icon",
    months: "rdp-months",
    month: "rdp-month",
    table: "rdp-table",
    tbody: "rdp-tbody",
    tfoot: "rdp-tfoot",
    head: "rdp-head",
    head_row: "rdp-head_row",
    head_cell: "rdp-head_cell",
    nav: "rdp-nav",
    nav_button: "rdp-nav_button",
    nav_button_previous: "rdp-nav_button_previous",
    nav_button_next: "rdp-nav_button_next",
    nav_icon: "rdp-nav_icon",
    row: "rdp-row",
    weeknumber: "rdp-weeknumber",
    cell: "rdp-cell",
    day: "rdp-day",
    day_today: "rdp-day_today",
    day_outside: "rdp-day_outside",
    day_selected: "rdp-day_selected",
    day_disabled: "rdp-day_disabled",
    day_hidden: "rdp-day_hidden",
    day_range_start: "rdp-day_range_start",
    day_range_end: "rdp-day_range_end",
    day_range_middle: "rdp-day_range_middle"
};
/**
 * The default formatter for the caption.
 */ function $89da45f89b022bca$var$formatCaption(month, options) {
    return (0, $8a568d5cdba66624$export$2e2bcd8739ae039)(month, "LLLL y", options);
}
/**
 * The default formatter for the Day button.
 */ function $89da45f89b022bca$var$formatDay(day, options) {
    return (0, $8a568d5cdba66624$export$2e2bcd8739ae039)(day, "d", options);
}
/**
 * The default formatter for the Month caption.
 */ function $89da45f89b022bca$var$formatMonthCaption(month, options) {
    return (0, $8a568d5cdba66624$export$2e2bcd8739ae039)(month, "LLLL", options);
}
/**
 * The default formatter for the week number.
 */ function $89da45f89b022bca$var$formatWeekNumber(weekNumber) {
    return "".concat(weekNumber);
}
/**
 * The default formatter for the name of the weekday.
 */ function $89da45f89b022bca$var$formatWeekdayName(weekday, options) {
    return (0, $8a568d5cdba66624$export$2e2bcd8739ae039)(weekday, "cccccc", options);
}
/**
 * The default formatter for the Year caption.
 */ function $89da45f89b022bca$var$formatYearCaption(year, options) {
    return (0, $8a568d5cdba66624$export$2e2bcd8739ae039)(year, "yyyy", options);
}
var $89da45f89b022bca$var$formatters = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    formatCaption: $89da45f89b022bca$var$formatCaption,
    formatDay: $89da45f89b022bca$var$formatDay,
    formatMonthCaption: $89da45f89b022bca$var$formatMonthCaption,
    formatWeekNumber: $89da45f89b022bca$var$formatWeekNumber,
    formatWeekdayName: $89da45f89b022bca$var$formatWeekdayName,
    formatYearCaption: $89da45f89b022bca$var$formatYearCaption
});
/**
 * The default ARIA label for the day button.
 */ var $89da45f89b022bca$var$labelDay = function(day, activeModifiers, options) {
    return (0, $8a568d5cdba66624$export$2e2bcd8739ae039)(day, "do MMMM (EEEE)", options);
};
/**
 * The default ARIA label for the WeekNumber element.
 */ var $89da45f89b022bca$var$labelMonthDropdown = function() {
    return "Month: ";
};
/**
 * The default ARIA label for next month button in navigation
 */ var $89da45f89b022bca$var$labelNext = function() {
    return "Go to next month";
};
/**
 * The default ARIA label for previous month button in navigation
 */ var $89da45f89b022bca$var$labelPrevious = function() {
    return "Go to previous month";
};
/**
 * The default ARIA label for the Weekday element.
 */ var $89da45f89b022bca$var$labelWeekday = function(day, options) {
    return (0, $8a568d5cdba66624$export$2e2bcd8739ae039)(day, "cccc", options);
};
/**
 * The default ARIA label for the WeekNumber element.
 */ var $89da45f89b022bca$var$labelWeekNumber = function(n) {
    return "Week n. ".concat(n);
};
/**
 * The default ARIA label for the WeekNumber element.
 */ var $89da45f89b022bca$var$labelYearDropdown = function() {
    return "Year: ";
};
var $89da45f89b022bca$var$labels = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    labelDay: $89da45f89b022bca$var$labelDay,
    labelMonthDropdown: $89da45f89b022bca$var$labelMonthDropdown,
    labelNext: $89da45f89b022bca$var$labelNext,
    labelPrevious: $89da45f89b022bca$var$labelPrevious,
    labelWeekNumber: $89da45f89b022bca$var$labelWeekNumber,
    labelWeekday: $89da45f89b022bca$var$labelWeekday,
    labelYearDropdown: $89da45f89b022bca$var$labelYearDropdown
});
/**
 * Returns the default values to use in the DayPickerContext, in case they are
 * not passed down with the DayPicker initial props.
 */ function $89da45f89b022bca$var$getDefaultContextValues() {
    var captionLayout = "buttons";
    var classNames = $89da45f89b022bca$var$defaultClassNames;
    var locale = (0, $b0hzc.default);
    var modifiersClassNames = {};
    var modifiers = {};
    var numberOfMonths = 1;
    var styles = {};
    var today = new Date();
    return {
        captionLayout: captionLayout,
        classNames: classNames,
        formatters: $89da45f89b022bca$var$formatters,
        labels: $89da45f89b022bca$var$labels,
        locale: locale,
        modifiersClassNames: modifiersClassNames,
        modifiers: modifiers,
        numberOfMonths: numberOfMonths,
        styles: styles,
        today: today,
        mode: "default"
    };
}
/** Return the `fromDate` and `toDate` prop values values parsing the DayPicker props. */ function $89da45f89b022bca$var$parseFromToProps(props) {
    var fromYear = props.fromYear, toYear = props.toYear, fromMonth = props.fromMonth, toMonth = props.toMonth;
    var fromDate = props.fromDate, toDate = props.toDate;
    if (fromMonth) fromDate = (0, $456b685109e85eeb$export$2e2bcd8739ae039)(fromMonth);
    else if (fromYear) fromDate = new Date(fromYear, 0, 1);
    if (toMonth) toDate = (0, $dde476f98780dbbe$export$2e2bcd8739ae039)(toMonth);
    else if (toYear) toDate = new Date(toYear, 11, 31);
    return {
        fromDate: fromDate ? (0, $bbc8a30b3b9c13e7$export$2e2bcd8739ae039)(fromDate) : undefined,
        toDate: toDate ? (0, $bbc8a30b3b9c13e7$export$2e2bcd8739ae039)(toDate) : undefined
    };
}
/**
 * The DayPicker context shares the props passed to DayPicker within internal
 * and custom components. It is used to set the default values and perform
 * one-time calculations required to render the days.
 *
 * Access to this context from the {@link useDayPicker} hook.
 */ var $89da45f89b022bca$export$5e463664ac32e9a9 = (0, $b6HlZ.createContext)(undefined);
/**
 * The provider for the {@link DayPickerContext}, assigning the defaults from the
 * initial DayPicker props.
 */ function $89da45f89b022bca$export$a84f964d022d25c(props) {
    var _a;
    var initialProps = props.initialProps;
    var defaultContextValues = $89da45f89b022bca$var$getDefaultContextValues();
    var _b = $89da45f89b022bca$var$parseFromToProps(initialProps), fromDate = _b.fromDate, toDate = _b.toDate;
    var captionLayout = (_a = initialProps.captionLayout) !== null && _a !== void 0 ? _a : defaultContextValues.captionLayout;
    if (captionLayout !== "buttons" && (!fromDate || !toDate)) // When no from/to dates are set, the caption is always buttons
    captionLayout = "buttons";
    var onSelect;
    if ($89da45f89b022bca$export$e659ce9b264ea61(initialProps) || $89da45f89b022bca$export$2d8c2b43ec0e528(initialProps) || $89da45f89b022bca$export$f7b9f96866ec1964(initialProps)) onSelect = initialProps.onSelect;
    var value = $89da45f89b022bca$var$__assign($89da45f89b022bca$var$__assign($89da45f89b022bca$var$__assign({}, defaultContextValues), initialProps), {
        captionLayout: captionLayout,
        classNames: $89da45f89b022bca$var$__assign($89da45f89b022bca$var$__assign({}, defaultContextValues.classNames), initialProps.classNames),
        components: $89da45f89b022bca$var$__assign({}, initialProps.components),
        formatters: $89da45f89b022bca$var$__assign($89da45f89b022bca$var$__assign({}, defaultContextValues.formatters), initialProps.formatters),
        fromDate: fromDate,
        labels: $89da45f89b022bca$var$__assign($89da45f89b022bca$var$__assign({}, defaultContextValues.labels), initialProps.labels),
        mode: initialProps.mode || defaultContextValues.mode,
        modifiers: $89da45f89b022bca$var$__assign($89da45f89b022bca$var$__assign({}, defaultContextValues.modifiers), initialProps.modifiers),
        modifiersClassNames: $89da45f89b022bca$var$__assign($89da45f89b022bca$var$__assign({}, defaultContextValues.modifiersClassNames), initialProps.modifiersClassNames),
        onSelect: onSelect,
        styles: $89da45f89b022bca$var$__assign($89da45f89b022bca$var$__assign({}, defaultContextValues.styles), initialProps.styles),
        toDate: toDate
    });
    return $89da45f89b022bca$var$jsxRuntimeExports.jsx($89da45f89b022bca$export$5e463664ac32e9a9.Provider, $89da45f89b022bca$var$__assign({
        value: value
    }, {
        children: props.children
    }));
}
/**
 * Hook to access the {@link DayPickerContextValue}.
 *
 * Use the DayPicker context to access to the props passed to DayPicker inside
 * internal or custom components.
 */ function $89da45f89b022bca$export$332e9e0d64b1f294() {
    var context = (0, $b6HlZ.useContext)($89da45f89b022bca$export$5e463664ac32e9a9);
    if (!context) throw new Error("useDayPicker must be used within a DayPickerProvider.");
    return context;
}
/** Render the caption for the displayed month. This component is used when `captionLayout="buttons"`. */ function $89da45f89b022bca$export$5b9f95302ae85eba(props) {
    var _a = $89da45f89b022bca$export$332e9e0d64b1f294(), locale = _a.locale, classNames = _a.classNames, styles = _a.styles, formatCaption = _a.formatters.formatCaption;
    return $89da45f89b022bca$var$jsxRuntimeExports.jsx("div", $89da45f89b022bca$var$__assign({
        className: classNames.caption_label,
        style: styles.caption_label,
        "aria-live": "polite",
        role: "presentation",
        id: props.id
    }, {
        children: formatCaption(props.displayMonth, {
            locale: locale
        })
    }));
}
/**
 * Render the icon in the styled drop-down.
 */ function $89da45f89b022bca$export$eaf28e65c2d9267c(props) {
    return $89da45f89b022bca$var$jsxRuntimeExports.jsx("svg", $89da45f89b022bca$var$__assign({
        width: "8px",
        height: "8px",
        viewBox: "0 0 120 120",
        "data-testid": "iconDropdown"
    }, props, {
        children: $89da45f89b022bca$var$jsxRuntimeExports.jsx("path", {
            d: "M4.22182541,48.2218254 C8.44222828,44.0014225 15.2388494,43.9273804 19.5496459,47.9996989 L19.7781746,48.2218254 L60,88.443 L100.221825,48.2218254 C104.442228,44.0014225 111.238849,43.9273804 115.549646,47.9996989 L115.778175,48.2218254 C119.998577,52.4422283 120.07262,59.2388494 116.000301,63.5496459 L115.778175,63.7781746 L67.7781746,111.778175 C63.5577717,115.998577 56.7611506,116.07262 52.4503541,112.000301 L52.2218254,111.778175 L4.22182541,63.7781746 C-0.0739418023,59.4824074 -0.0739418023,52.5175926 4.22182541,48.2218254 Z",
            fill: "currentColor",
            fillRule: "nonzero"
        })
    }));
}
/**
 * Render a styled select component – displaying a caption and a custom
 * drop-down icon.
 */ function $89da45f89b022bca$export$931cbfb6bfb85fc(props) {
    var _a, _b;
    var onChange = props.onChange, value = props.value, children = props.children, caption = props.caption, className = props.className, style = props.style;
    var dayPicker = $89da45f89b022bca$export$332e9e0d64b1f294();
    var IconDropdownComponent = (_b = (_a = dayPicker.components) === null || _a === void 0 ? void 0 : _a.IconDropdown) !== null && _b !== void 0 ? _b : $89da45f89b022bca$export$eaf28e65c2d9267c;
    return $89da45f89b022bca$var$jsxRuntimeExports.jsxs("div", $89da45f89b022bca$var$__assign({
        className: className,
        style: style
    }, {
        children: [
            $89da45f89b022bca$var$jsxRuntimeExports.jsx("span", $89da45f89b022bca$var$__assign({
                className: dayPicker.classNames.vhidden
            }, {
                children: props["aria-label"]
            })),
            $89da45f89b022bca$var$jsxRuntimeExports.jsx("select", $89da45f89b022bca$var$__assign({
                name: props.name,
                "aria-label": props["aria-label"],
                className: dayPicker.classNames.dropdown,
                style: dayPicker.styles.dropdown,
                value: value,
                onChange: onChange
            }, {
                children: children
            })),
            $89da45f89b022bca$var$jsxRuntimeExports.jsxs("div", $89da45f89b022bca$var$__assign({
                className: dayPicker.classNames.caption_label,
                style: dayPicker.styles.caption_label,
                "aria-hidden": "true"
            }, {
                children: [
                    caption,
                    $89da45f89b022bca$var$jsxRuntimeExports.jsx(IconDropdownComponent, {
                        className: dayPicker.classNames.dropdown_icon,
                        style: dayPicker.styles.dropdown_icon
                    })
                ]
            }))
        ]
    }));
}
/** Render the dropdown to navigate between months. */ function $89da45f89b022bca$var$MonthsDropdown(props) {
    var _a;
    var _b = $89da45f89b022bca$export$332e9e0d64b1f294(), fromDate = _b.fromDate, toDate = _b.toDate, styles = _b.styles, locale = _b.locale, formatMonthCaption = _b.formatters.formatMonthCaption, classNames = _b.classNames, components = _b.components, labelMonthDropdown = _b.labels.labelMonthDropdown;
    // Dropdown should appear only when both from/toDate is set
    if (!fromDate) return $89da45f89b022bca$var$jsxRuntimeExports.jsx($89da45f89b022bca$var$jsxRuntimeExports.Fragment, {});
    if (!toDate) return $89da45f89b022bca$var$jsxRuntimeExports.jsx($89da45f89b022bca$var$jsxRuntimeExports.Fragment, {});
    var dropdownMonths = [];
    if ((0, $705899d11bf48017$export$2e2bcd8739ae039)(fromDate, toDate)) {
        // only display the months included in the range
        var date = (0, $456b685109e85eeb$export$2e2bcd8739ae039)(fromDate);
        for(var month = fromDate.getMonth(); month <= toDate.getMonth(); month++)dropdownMonths.push((0, $6be41408aceb6712$export$2e2bcd8739ae039)(date, month));
    } else {
        // display all the 12 months
        var date = (0, $456b685109e85eeb$export$2e2bcd8739ae039)(new Date()); // Any date should be OK, as we just need the year
        for(var month = 0; month <= 11; month++)dropdownMonths.push((0, $6be41408aceb6712$export$2e2bcd8739ae039)(date, month));
    }
    var handleChange = function(e) {
        var selectedMonth = Number(e.target.value);
        var newMonth = (0, $6be41408aceb6712$export$2e2bcd8739ae039)((0, $456b685109e85eeb$export$2e2bcd8739ae039)(props.displayMonth), selectedMonth);
        props.onChange(newMonth);
    };
    var DropdownComponent = (_a = components === null || components === void 0 ? void 0 : components.Dropdown) !== null && _a !== void 0 ? _a : $89da45f89b022bca$export$931cbfb6bfb85fc;
    return $89da45f89b022bca$var$jsxRuntimeExports.jsx(DropdownComponent, $89da45f89b022bca$var$__assign({
        name: "months",
        "aria-label": labelMonthDropdown(),
        className: classNames.dropdown_month,
        style: styles.dropdown_month,
        onChange: handleChange,
        value: props.displayMonth.getMonth(),
        caption: formatMonthCaption(props.displayMonth, {
            locale: locale
        })
    }, {
        children: dropdownMonths.map(function(m) {
            return $89da45f89b022bca$var$jsxRuntimeExports.jsx("option", $89da45f89b022bca$var$__assign({
                value: m.getMonth()
            }, {
                children: formatMonthCaption(m, {
                    locale: locale
                })
            }), m.getMonth());
        })
    }));
}
/**
 * Render a dropdown to change the year. Take in account the `nav.fromDate` and
 * `toDate` from context.
 */ function $89da45f89b022bca$var$YearsDropdown(props) {
    var _a;
    var displayMonth = props.displayMonth;
    var _b = $89da45f89b022bca$export$332e9e0d64b1f294(), fromDate = _b.fromDate, toDate = _b.toDate, locale = _b.locale, styles = _b.styles, classNames = _b.classNames, components = _b.components, formatYearCaption = _b.formatters.formatYearCaption, labelYearDropdown = _b.labels.labelYearDropdown;
    var years = [];
    // Dropdown should appear only when both from/toDate is set
    if (!fromDate) return $89da45f89b022bca$var$jsxRuntimeExports.jsx($89da45f89b022bca$var$jsxRuntimeExports.Fragment, {});
    if (!toDate) return $89da45f89b022bca$var$jsxRuntimeExports.jsx($89da45f89b022bca$var$jsxRuntimeExports.Fragment, {});
    var fromYear = fromDate.getFullYear();
    var toYear = toDate.getFullYear();
    for(var year = fromYear; year <= toYear; year++)years.push((0, $e877a00a87494bb7$export$2e2bcd8739ae039)((0, $ca03fcf48af63ebc$export$2e2bcd8739ae039)(new Date()), year));
    var handleChange = function(e) {
        var newMonth = (0, $e877a00a87494bb7$export$2e2bcd8739ae039)((0, $456b685109e85eeb$export$2e2bcd8739ae039)(displayMonth), Number(e.target.value));
        props.onChange(newMonth);
    };
    var DropdownComponent = (_a = components === null || components === void 0 ? void 0 : components.Dropdown) !== null && _a !== void 0 ? _a : $89da45f89b022bca$export$931cbfb6bfb85fc;
    return $89da45f89b022bca$var$jsxRuntimeExports.jsx(DropdownComponent, $89da45f89b022bca$var$__assign({
        name: "years",
        "aria-label": labelYearDropdown(),
        className: classNames.dropdown_year,
        style: styles.dropdown_year,
        onChange: handleChange,
        value: displayMonth.getFullYear(),
        caption: formatYearCaption(displayMonth, {
            locale: locale
        })
    }, {
        children: years.map(function(year) {
            return $89da45f89b022bca$var$jsxRuntimeExports.jsx("option", $89da45f89b022bca$var$__assign({
                value: year.getFullYear()
            }, {
                children: formatYearCaption(year, {
                    locale: locale
                })
            }), year.getFullYear());
        })
    }));
}
/**
 * Helper hook for using controlled/uncontrolled values from a component props.
 *
 * When the value is not controlled, pass `undefined` as `controlledValue` and
 * use the returned setter to update it.
 *
 * When the value is controlled, pass the controlled value as second
 * argument, which will be always returned as `value`.
 */ function $89da45f89b022bca$var$useControlledValue(defaultValue, controlledValue) {
    var _a = (0, $b6HlZ.useState)(defaultValue), uncontrolledValue = _a[0], setValue = _a[1];
    var value = controlledValue === undefined ? uncontrolledValue : controlledValue;
    return [
        value,
        setValue
    ];
}
/** Return the initial month according to the given options. */ function $89da45f89b022bca$var$getInitialMonth(context) {
    var month = context.month, defaultMonth = context.defaultMonth, today = context.today;
    var initialMonth = month || defaultMonth || today || new Date();
    var toDate = context.toDate, fromDate = context.fromDate, _a = context.numberOfMonths, numberOfMonths = _a === void 0 ? 1 : _a;
    // Fix the initialMonth if is after the to-date
    if (toDate && (0, $54c77849534ac91c$export$2e2bcd8739ae039)(toDate, initialMonth) < 0) {
        var offset = -1 * (numberOfMonths - 1);
        initialMonth = (0, $623e079afbe8c632$export$2e2bcd8739ae039)(toDate, offset);
    }
    // Fix the initialMonth if is before the from-date
    if (fromDate && (0, $54c77849534ac91c$export$2e2bcd8739ae039)(initialMonth, fromDate) < 0) initialMonth = fromDate;
    return (0, $456b685109e85eeb$export$2e2bcd8739ae039)(initialMonth);
}
/** Controls the navigation state. */ function $89da45f89b022bca$var$useNavigationState() {
    var context = $89da45f89b022bca$export$332e9e0d64b1f294();
    var initialMonth = $89da45f89b022bca$var$getInitialMonth(context);
    var _a = $89da45f89b022bca$var$useControlledValue(initialMonth, context.month), month = _a[0], setMonth = _a[1];
    var goToMonth = function(date) {
        var _a;
        if (context.disableNavigation) return;
        var month = (0, $456b685109e85eeb$export$2e2bcd8739ae039)(date);
        setMonth(month);
        (_a = context.onMonthChange) === null || _a === void 0 || _a.call(context, month);
    };
    return [
        month,
        goToMonth
    ];
}
/**
 * Return the months to display in the component according to the number of
 * months and the from/to date.
 */ function $89da45f89b022bca$var$getDisplayMonths(month, _a) {
    var reverseMonths = _a.reverseMonths, numberOfMonths = _a.numberOfMonths;
    var start = (0, $456b685109e85eeb$export$2e2bcd8739ae039)(month);
    var end = (0, $456b685109e85eeb$export$2e2bcd8739ae039)((0, $623e079afbe8c632$export$2e2bcd8739ae039)(start, numberOfMonths));
    var monthsDiff = (0, $54c77849534ac91c$export$2e2bcd8739ae039)(end, start);
    var months = [];
    for(var i = 0; i < monthsDiff; i++){
        var nextMonth = (0, $623e079afbe8c632$export$2e2bcd8739ae039)(start, i);
        months.push(nextMonth);
    }
    if (reverseMonths) months = months.reverse();
    return months;
}
/**
 * Returns the next month the user can navigate to according to the given
 * options.
 *
 * Please note that the next month is not always the next calendar month:
 *
 * - if after the `toDate` range, is undefined;
 * - if the navigation is paged, is the number of months displayed ahead.
 *
 */ function $89da45f89b022bca$var$getNextMonth(startingMonth, options) {
    if (options.disableNavigation) return undefined;
    var toDate = options.toDate, pagedNavigation = options.pagedNavigation, _a = options.numberOfMonths, numberOfMonths = _a === void 0 ? 1 : _a;
    var offset = pagedNavigation ? numberOfMonths : 1;
    var month = (0, $456b685109e85eeb$export$2e2bcd8739ae039)(startingMonth);
    if (!toDate) return (0, $623e079afbe8c632$export$2e2bcd8739ae039)(month, offset);
    var monthsDiff = (0, $54c77849534ac91c$export$2e2bcd8739ae039)(toDate, startingMonth);
    if (monthsDiff < numberOfMonths) return undefined;
    // Jump forward as the number of months when paged navigation
    return (0, $623e079afbe8c632$export$2e2bcd8739ae039)(month, offset);
}
/**
 * Returns the next previous the user can navigate to, according to the given
 * options.
 *
 * Please note that the previous month is not always the previous calendar
 * month:
 *
 * - if before the `fromDate` date, is `undefined`;
 * - if the navigation is paged, is the number of months displayed before.
 *
 */ function $89da45f89b022bca$var$getPreviousMonth(startingMonth, options) {
    if (options.disableNavigation) return undefined;
    var fromDate = options.fromDate, pagedNavigation = options.pagedNavigation, _a = options.numberOfMonths, numberOfMonths = _a === void 0 ? 1 : _a;
    var offset = pagedNavigation ? numberOfMonths : 1;
    var month = (0, $456b685109e85eeb$export$2e2bcd8739ae039)(startingMonth);
    if (!fromDate) return (0, $623e079afbe8c632$export$2e2bcd8739ae039)(month, -offset);
    var monthsDiff = (0, $54c77849534ac91c$export$2e2bcd8739ae039)(month, fromDate);
    if (monthsDiff <= 0) return undefined;
    // Jump back as the number of months when paged navigation
    return (0, $623e079afbe8c632$export$2e2bcd8739ae039)(month, -offset);
}
/**
 * The Navigation context shares details and methods to navigate the months in DayPicker.
 * Access this context from the {@link useNavigation} hook.
 */ var $89da45f89b022bca$export$3044ab7fdabeaee6 = (0, $b6HlZ.createContext)(undefined);
/** Provides the values for the {@link NavigationContext}. */ function $89da45f89b022bca$export$d91daf425539f32f(props) {
    var dayPicker = $89da45f89b022bca$export$332e9e0d64b1f294();
    var _a = $89da45f89b022bca$var$useNavigationState(), currentMonth = _a[0], goToMonth = _a[1];
    var displayMonths = $89da45f89b022bca$var$getDisplayMonths(currentMonth, dayPicker);
    var nextMonth = $89da45f89b022bca$var$getNextMonth(currentMonth, dayPicker);
    var previousMonth = $89da45f89b022bca$var$getPreviousMonth(currentMonth, dayPicker);
    var isDateDisplayed = function(date) {
        return displayMonths.some(function(displayMonth) {
            return (0, $9a3632b3cc120583$export$2e2bcd8739ae039)(date, displayMonth);
        });
    };
    var goToDate = function(date, refDate) {
        if (isDateDisplayed(date)) return;
        if (refDate && (0, $1aebcd0561bacc73$export$2e2bcd8739ae039)(date, refDate)) goToMonth((0, $623e079afbe8c632$export$2e2bcd8739ae039)(date, 1 + dayPicker.numberOfMonths * -1));
        else goToMonth(date);
    };
    var value = {
        currentMonth: currentMonth,
        displayMonths: displayMonths,
        goToMonth: goToMonth,
        goToDate: goToDate,
        previousMonth: previousMonth,
        nextMonth: nextMonth,
        isDateDisplayed: isDateDisplayed
    };
    return $89da45f89b022bca$var$jsxRuntimeExports.jsx($89da45f89b022bca$export$3044ab7fdabeaee6.Provider, $89da45f89b022bca$var$__assign({
        value: value
    }, {
        children: props.children
    }));
}
/**
 * Hook to access the {@link NavigationContextValue}. Use this hook to navigate
 * between months or years in DayPicker.
 *
 * This hook is meant to be used inside internal or custom components.
 */ function $89da45f89b022bca$export$d0fd4b7106de2769() {
    var context = (0, $b6HlZ.useContext)($89da45f89b022bca$export$3044ab7fdabeaee6);
    if (!context) throw new Error("useNavigation must be used within a NavigationProvider");
    return context;
}
/**
 * Render a caption with the dropdowns to navigate between months and years.
 */ function $89da45f89b022bca$export$6a3605aba74bcb3d(props) {
    var _a;
    var _b = $89da45f89b022bca$export$332e9e0d64b1f294(), classNames = _b.classNames, styles = _b.styles, components = _b.components;
    var goToMonth = $89da45f89b022bca$export$d0fd4b7106de2769().goToMonth;
    var handleMonthChange = function(newMonth) {
        goToMonth((0, $623e079afbe8c632$export$2e2bcd8739ae039)(newMonth, props.displayIndex ? -props.displayIndex : 0));
    };
    var CaptionLabelComponent = (_a = components === null || components === void 0 ? void 0 : components.CaptionLabel) !== null && _a !== void 0 ? _a : $89da45f89b022bca$export$5b9f95302ae85eba;
    var captionLabel = $89da45f89b022bca$var$jsxRuntimeExports.jsx(CaptionLabelComponent, {
        id: props.id,
        displayMonth: props.displayMonth
    });
    return $89da45f89b022bca$var$jsxRuntimeExports.jsxs("div", $89da45f89b022bca$var$__assign({
        className: classNames.caption_dropdowns,
        style: styles.caption_dropdowns
    }, {
        children: [
            $89da45f89b022bca$var$jsxRuntimeExports.jsx("div", $89da45f89b022bca$var$__assign({
                className: classNames.vhidden
            }, {
                children: captionLabel
            })),
            $89da45f89b022bca$var$jsxRuntimeExports.jsx($89da45f89b022bca$var$MonthsDropdown, {
                onChange: handleMonthChange,
                displayMonth: props.displayMonth
            }),
            $89da45f89b022bca$var$jsxRuntimeExports.jsx($89da45f89b022bca$var$YearsDropdown, {
                onChange: handleMonthChange,
                displayMonth: props.displayMonth
            })
        ]
    }));
}
/**
 * Render the "previous month" button in the navigation.
 */ function $89da45f89b022bca$export$fac286bb0d0d0385(props) {
    return $89da45f89b022bca$var$jsxRuntimeExports.jsx("svg", $89da45f89b022bca$var$__assign({
        width: "16px",
        height: "16px",
        viewBox: "0 0 120 120"
    }, props, {
        children: $89da45f89b022bca$var$jsxRuntimeExports.jsx("path", {
            d: "M69.490332,3.34314575 C72.6145263,0.218951416 77.6798462,0.218951416 80.8040405,3.34314575 C83.8617626,6.40086786 83.9268205,11.3179931 80.9992143,14.4548388 L80.8040405,14.6568542 L35.461,60 L80.8040405,105.343146 C83.8617626,108.400868 83.9268205,113.317993 80.9992143,116.454839 L80.8040405,116.656854 C77.7463184,119.714576 72.8291931,119.779634 69.6923475,116.852028 L69.490332,116.656854 L18.490332,65.6568542 C15.4326099,62.5991321 15.367552,57.6820069 18.2951583,54.5451612 L18.490332,54.3431458 L69.490332,3.34314575 Z",
            fill: "currentColor",
            fillRule: "nonzero"
        })
    }));
}
/**
 * Render the "next month" button in the navigation.
 */ function $89da45f89b022bca$export$142e5a7835580ff5(props) {
    return $89da45f89b022bca$var$jsxRuntimeExports.jsx("svg", $89da45f89b022bca$var$__assign({
        width: "16px",
        height: "16px",
        viewBox: "0 0 120 120"
    }, props, {
        children: $89da45f89b022bca$var$jsxRuntimeExports.jsx("path", {
            d: "M49.8040405,3.34314575 C46.6798462,0.218951416 41.6145263,0.218951416 38.490332,3.34314575 C35.4326099,6.40086786 35.367552,11.3179931 38.2951583,14.4548388 L38.490332,14.6568542 L83.8333725,60 L38.490332,105.343146 C35.4326099,108.400868 35.367552,113.317993 38.2951583,116.454839 L38.490332,116.656854 C41.5480541,119.714576 46.4651794,119.779634 49.602025,116.852028 L49.8040405,116.656854 L100.804041,65.6568542 C103.861763,62.5991321 103.926821,57.6820069 100.999214,54.5451612 L100.804041,54.3431458 L49.8040405,3.34314575 Z",
            fill: "currentColor"
        })
    }));
}
/** Render a button HTML element applying the reset class name. */ var $89da45f89b022bca$export$353f5b6fc5456de1 = (0, $b6HlZ.forwardRef)(function(props, ref) {
    var _a = $89da45f89b022bca$export$332e9e0d64b1f294(), classNames = _a.classNames, styles = _a.styles;
    var classNamesArr = [
        classNames.button_reset,
        classNames.button
    ];
    if (props.className) classNamesArr.push(props.className);
    var className = classNamesArr.join(" ");
    var style = $89da45f89b022bca$var$__assign($89da45f89b022bca$var$__assign({}, styles.button_reset), styles.button);
    if (props.style) Object.assign(style, props.style);
    return $89da45f89b022bca$var$jsxRuntimeExports.jsx("button", $89da45f89b022bca$var$__assign({}, props, {
        ref: ref,
        type: "button",
        className: className,
        style: style
    }));
});
/** A component rendering the navigation buttons or the drop-downs. */ function $89da45f89b022bca$var$Navigation(props) {
    var _a, _b;
    var _c = $89da45f89b022bca$export$332e9e0d64b1f294(), dir = _c.dir, locale = _c.locale, classNames = _c.classNames, styles = _c.styles, _d = _c.labels, labelPrevious = _d.labelPrevious, labelNext = _d.labelNext, components = _c.components;
    if (!props.nextMonth && !props.previousMonth) return $89da45f89b022bca$var$jsxRuntimeExports.jsx($89da45f89b022bca$var$jsxRuntimeExports.Fragment, {});
    var previousLabel = labelPrevious(props.previousMonth, {
        locale: locale
    });
    var previousClassName = [
        classNames.nav_button,
        classNames.nav_button_previous
    ].join(" ");
    var nextLabel = labelNext(props.nextMonth, {
        locale: locale
    });
    var nextClassName = [
        classNames.nav_button,
        classNames.nav_button_next
    ].join(" ");
    var IconRightComponent = (_a = components === null || components === void 0 ? void 0 : components.IconRight) !== null && _a !== void 0 ? _a : $89da45f89b022bca$export$142e5a7835580ff5;
    var IconLeftComponent = (_b = components === null || components === void 0 ? void 0 : components.IconLeft) !== null && _b !== void 0 ? _b : $89da45f89b022bca$export$fac286bb0d0d0385;
    return $89da45f89b022bca$var$jsxRuntimeExports.jsxs("div", $89da45f89b022bca$var$__assign({
        className: classNames.nav,
        style: styles.nav
    }, {
        children: [
            !props.hidePrevious && $89da45f89b022bca$var$jsxRuntimeExports.jsx($89da45f89b022bca$export$353f5b6fc5456de1, $89da45f89b022bca$var$__assign({
                name: "previous-month",
                "aria-label": previousLabel,
                className: previousClassName,
                style: styles.nav_button_previous,
                disabled: !props.previousMonth,
                onClick: props.onPreviousClick
            }, {
                children: dir === "rtl" ? $89da45f89b022bca$var$jsxRuntimeExports.jsx(IconRightComponent, {
                    className: classNames.nav_icon,
                    style: styles.nav_icon
                }) : $89da45f89b022bca$var$jsxRuntimeExports.jsx(IconLeftComponent, {
                    className: classNames.nav_icon,
                    style: styles.nav_icon
                })
            })),
            !props.hideNext && $89da45f89b022bca$var$jsxRuntimeExports.jsx($89da45f89b022bca$export$353f5b6fc5456de1, $89da45f89b022bca$var$__assign({
                name: "next-month",
                "aria-label": nextLabel,
                className: nextClassName,
                style: styles.nav_button_next,
                disabled: !props.nextMonth,
                onClick: props.onNextClick
            }, {
                children: dir === "rtl" ? $89da45f89b022bca$var$jsxRuntimeExports.jsx(IconLeftComponent, {
                    className: classNames.nav_icon,
                    style: styles.nav_icon
                }) : $89da45f89b022bca$var$jsxRuntimeExports.jsx(IconRightComponent, {
                    className: classNames.nav_icon,
                    style: styles.nav_icon
                })
            }))
        ]
    }));
}
/**
 * Render a caption with a button-based navigation.
 */ function $89da45f89b022bca$export$f6e46da460a028c1(props) {
    var numberOfMonths = $89da45f89b022bca$export$332e9e0d64b1f294().numberOfMonths;
    var _a = $89da45f89b022bca$export$d0fd4b7106de2769(), previousMonth = _a.previousMonth, nextMonth = _a.nextMonth, goToMonth = _a.goToMonth, displayMonths = _a.displayMonths;
    var displayIndex = displayMonths.findIndex(function(month) {
        return (0, $9a3632b3cc120583$export$2e2bcd8739ae039)(props.displayMonth, month);
    });
    var isFirst = displayIndex === 0;
    var isLast = displayIndex === displayMonths.length - 1;
    var hideNext = numberOfMonths > 1 && (isFirst || !isLast);
    var hidePrevious = numberOfMonths > 1 && (isLast || !isFirst);
    var handlePreviousClick = function() {
        if (!previousMonth) return;
        goToMonth(previousMonth);
    };
    var handleNextClick = function() {
        if (!nextMonth) return;
        goToMonth(nextMonth);
    };
    return $89da45f89b022bca$var$jsxRuntimeExports.jsx($89da45f89b022bca$var$Navigation, {
        displayMonth: props.displayMonth,
        hideNext: hideNext,
        hidePrevious: hidePrevious,
        nextMonth: nextMonth,
        previousMonth: previousMonth,
        onPreviousClick: handlePreviousClick,
        onNextClick: handleNextClick
    });
}
/**
 * Render the caption of a month. The caption has a different layout when
 * setting the {@link DayPickerBase.captionLayout} prop.
 */ function $89da45f89b022bca$export$32fbfacc5d962e0c(props) {
    var _a;
    var _b = $89da45f89b022bca$export$332e9e0d64b1f294(), classNames = _b.classNames, disableNavigation = _b.disableNavigation, styles = _b.styles, captionLayout = _b.captionLayout, components = _b.components;
    var CaptionLabelComponent = (_a = components === null || components === void 0 ? void 0 : components.CaptionLabel) !== null && _a !== void 0 ? _a : $89da45f89b022bca$export$5b9f95302ae85eba;
    var caption;
    if (disableNavigation) caption = $89da45f89b022bca$var$jsxRuntimeExports.jsx(CaptionLabelComponent, {
        id: props.id,
        displayMonth: props.displayMonth
    });
    else if (captionLayout === "dropdown") caption = $89da45f89b022bca$var$jsxRuntimeExports.jsx($89da45f89b022bca$export$6a3605aba74bcb3d, {
        displayMonth: props.displayMonth,
        id: props.id
    });
    else if (captionLayout === "dropdown-buttons") caption = $89da45f89b022bca$var$jsxRuntimeExports.jsxs($89da45f89b022bca$var$jsxRuntimeExports.Fragment, {
        children: [
            $89da45f89b022bca$var$jsxRuntimeExports.jsx($89da45f89b022bca$export$6a3605aba74bcb3d, {
                displayMonth: props.displayMonth,
                displayIndex: props.displayIndex,
                id: props.id
            }),
            $89da45f89b022bca$var$jsxRuntimeExports.jsx($89da45f89b022bca$export$f6e46da460a028c1, {
                displayMonth: props.displayMonth,
                displayIndex: props.displayIndex,
                id: props.id
            })
        ]
    });
    else caption = $89da45f89b022bca$var$jsxRuntimeExports.jsxs($89da45f89b022bca$var$jsxRuntimeExports.Fragment, {
        children: [
            $89da45f89b022bca$var$jsxRuntimeExports.jsx(CaptionLabelComponent, {
                id: props.id,
                displayMonth: props.displayMonth,
                displayIndex: props.displayIndex
            }),
            $89da45f89b022bca$var$jsxRuntimeExports.jsx($89da45f89b022bca$export$f6e46da460a028c1, {
                displayMonth: props.displayMonth,
                id: props.id
            })
        ]
    });
    return $89da45f89b022bca$var$jsxRuntimeExports.jsx("div", $89da45f89b022bca$var$__assign({
        className: classNames.caption,
        style: styles.caption
    }, {
        children: caption
    }));
}
/** Render the Footer component (empty as default).*/ // eslint-disable-next-line @typescript-eslint/no-unused-vars
function $89da45f89b022bca$export$a06f1c675e846f6f(props) {
    var _a = $89da45f89b022bca$export$332e9e0d64b1f294(), footer = _a.footer, styles = _a.styles, tfoot = _a.classNames.tfoot;
    if (!footer) return $89da45f89b022bca$var$jsxRuntimeExports.jsx($89da45f89b022bca$var$jsxRuntimeExports.Fragment, {});
    return $89da45f89b022bca$var$jsxRuntimeExports.jsx("tfoot", $89da45f89b022bca$var$__assign({
        className: tfoot,
        style: styles.tfoot
    }, {
        children: $89da45f89b022bca$var$jsxRuntimeExports.jsx("tr", {
            children: $89da45f89b022bca$var$jsxRuntimeExports.jsx("td", $89da45f89b022bca$var$__assign({
                colSpan: 8
            }, {
                children: footer
            }))
        })
    }));
}
/**
 * Generate a series of 7 days, starting from the week, to use for formatting
 * the weekday names (Monday, Tuesday, etc.).
 */ function $89da45f89b022bca$var$getWeekdays(locale, /** The index of the first day of the week (0 - Sunday). */ weekStartsOn, /** Use ISOWeek instead of locale/ */ ISOWeek) {
    var start = ISOWeek ? (0, $33926cd4b89b52a2$export$2e2bcd8739ae039)(new Date()) : (0, $97cce5fde4647ac6$export$2e2bcd8739ae039)(new Date(), {
        locale: locale,
        weekStartsOn: weekStartsOn
    });
    var days = [];
    for(var i = 0; i < 7; i++){
        var day = (0, $cab34702696efb7b$export$2e2bcd8739ae039)(start, i);
        days.push(day);
    }
    return days;
}
/**
 * Render the HeadRow component - i.e. the table head row with the weekday names.
 */ function $89da45f89b022bca$export$b008e842a2213343() {
    var _a = $89da45f89b022bca$export$332e9e0d64b1f294(), classNames = _a.classNames, styles = _a.styles, showWeekNumber = _a.showWeekNumber, locale = _a.locale, weekStartsOn = _a.weekStartsOn, ISOWeek = _a.ISOWeek, formatWeekdayName = _a.formatters.formatWeekdayName, labelWeekday = _a.labels.labelWeekday;
    var weekdays = $89da45f89b022bca$var$getWeekdays(locale, weekStartsOn, ISOWeek);
    return $89da45f89b022bca$var$jsxRuntimeExports.jsxs("tr", $89da45f89b022bca$var$__assign({
        style: styles.head_row,
        className: classNames.head_row
    }, {
        children: [
            showWeekNumber && $89da45f89b022bca$var$jsxRuntimeExports.jsx("td", {
                style: styles.head_cell,
                className: classNames.head_cell
            }),
            weekdays.map(function(weekday, i) {
                return $89da45f89b022bca$var$jsxRuntimeExports.jsx("th", $89da45f89b022bca$var$__assign({
                    scope: "col",
                    className: classNames.head_cell,
                    style: styles.head_cell,
                    "aria-label": labelWeekday(weekday, {
                        locale: locale
                    })
                }, {
                    children: formatWeekdayName(weekday, {
                        locale: locale
                    })
                }), i);
            })
        ]
    }));
}
/** Render the table head. */ function $89da45f89b022bca$export$e93312b7773dfcac() {
    var _a;
    var _b = $89da45f89b022bca$export$332e9e0d64b1f294(), classNames = _b.classNames, styles = _b.styles, components = _b.components;
    var HeadRowComponent = (_a = components === null || components === void 0 ? void 0 : components.HeadRow) !== null && _a !== void 0 ? _a : $89da45f89b022bca$export$b008e842a2213343;
    return $89da45f89b022bca$var$jsxRuntimeExports.jsx("thead", $89da45f89b022bca$var$__assign({
        style: styles.head,
        className: classNames.head
    }, {
        children: $89da45f89b022bca$var$jsxRuntimeExports.jsx(HeadRowComponent, {})
    }));
}
/** Render the content of the day cell. */ function $89da45f89b022bca$export$16d0634337daf8ec(props) {
    var _a = $89da45f89b022bca$export$332e9e0d64b1f294(), locale = _a.locale, formatDay = _a.formatters.formatDay;
    return $89da45f89b022bca$var$jsxRuntimeExports.jsx($89da45f89b022bca$var$jsxRuntimeExports.Fragment, {
        children: formatDay(props.date, {
            locale: locale
        })
    });
}
/**
 * The SelectMultiple context shares details about the selected days when in
 * multiple selection mode.
 *
 * Access this context from the {@link useSelectMultiple} hook.
 */ var $89da45f89b022bca$export$26e3e4d6f601d4d6 = (0, $b6HlZ.createContext)(undefined);
/** Provides the values for the {@link SelectMultipleContext}. */ function $89da45f89b022bca$export$913827019032c8d4(props) {
    if (!$89da45f89b022bca$export$2d8c2b43ec0e528(props.initialProps)) {
        var emptyContextValue = {
            selected: undefined,
            modifiers: {
                disabled: []
            }
        };
        return $89da45f89b022bca$var$jsxRuntimeExports.jsx($89da45f89b022bca$export$26e3e4d6f601d4d6.Provider, $89da45f89b022bca$var$__assign({
            value: emptyContextValue
        }, {
            children: props.children
        }));
    }
    return $89da45f89b022bca$var$jsxRuntimeExports.jsx($89da45f89b022bca$export$91128e1c5ca64a0d, {
        initialProps: props.initialProps,
        children: props.children
    });
}
function $89da45f89b022bca$export$91128e1c5ca64a0d(_a) {
    var initialProps = _a.initialProps, children = _a.children;
    var selected = initialProps.selected, min = initialProps.min, max = initialProps.max;
    var onDayClick = function(day, activeModifiers, e) {
        var _a, _b;
        (_a = initialProps.onDayClick) === null || _a === void 0 || _a.call(initialProps, day, activeModifiers, e);
        var isMinSelected = Boolean(activeModifiers.selected && min && (selected === null || selected === void 0 ? void 0 : selected.length) === min);
        if (isMinSelected) return;
        var isMaxSelected = Boolean(!activeModifiers.selected && max && (selected === null || selected === void 0 ? void 0 : selected.length) === max);
        if (isMaxSelected) return;
        var selectedDays = selected ? $89da45f89b022bca$var$__spreadArray([], selected, true) : [];
        if (activeModifiers.selected) {
            var index = selectedDays.findIndex(function(selectedDay) {
                return (0, $1393872aaf394788$export$2e2bcd8739ae039)(day, selectedDay);
            });
            selectedDays.splice(index, 1);
        } else selectedDays.push(day);
        (_b = initialProps.onSelect) === null || _b === void 0 || _b.call(initialProps, selectedDays, day, activeModifiers, e);
    };
    var modifiers = {
        disabled: []
    };
    if (selected) modifiers.disabled.push(function(day) {
        var isMaxSelected = max && selected.length > max - 1;
        var isSelected = selected.some(function(selectedDay) {
            return (0, $1393872aaf394788$export$2e2bcd8739ae039)(selectedDay, day);
        });
        return Boolean(isMaxSelected && !isSelected);
    });
    var contextValue = {
        selected: selected,
        onDayClick: onDayClick,
        modifiers: modifiers
    };
    return $89da45f89b022bca$var$jsxRuntimeExports.jsx($89da45f89b022bca$export$26e3e4d6f601d4d6.Provider, $89da45f89b022bca$var$__assign({
        value: contextValue
    }, {
        children: children
    }));
}
/**
 * Hook to access the {@link SelectMultipleContextValue}.
 *
 * This hook is meant to be used inside internal or custom components.
 */ function $89da45f89b022bca$export$458361db477d8ed0() {
    var context = (0, $b6HlZ.useContext)($89da45f89b022bca$export$26e3e4d6f601d4d6);
    if (!context) throw new Error("useSelectMultiple must be used within a SelectMultipleProvider");
    return context;
}
/**
 * Add a day to an existing range.
 *
 * The returned range takes in account the `undefined` values and if the added
 * day is already present in the range.
 */ function $89da45f89b022bca$export$27ef550b4e6acc0c(day, range) {
    var _a = range || {}, from = _a.from, to = _a.to;
    if (from && to) {
        if ((0, $1393872aaf394788$export$2e2bcd8739ae039)(to, day) && (0, $1393872aaf394788$export$2e2bcd8739ae039)(from, day)) return undefined;
        if ((0, $1393872aaf394788$export$2e2bcd8739ae039)(to, day)) return {
            from: to,
            to: undefined
        };
        if ((0, $1393872aaf394788$export$2e2bcd8739ae039)(from, day)) return undefined;
        if ((0, $b2aab07c3dbca894$export$2e2bcd8739ae039)(from, day)) return {
            from: day,
            to: to
        };
        return {
            from: from,
            to: day
        };
    }
    if (to) {
        if ((0, $b2aab07c3dbca894$export$2e2bcd8739ae039)(day, to)) return {
            from: to,
            to: day
        };
        return {
            from: day,
            to: to
        };
    }
    if (from) {
        if ((0, $1aebcd0561bacc73$export$2e2bcd8739ae039)(day, from)) return {
            from: day,
            to: from
        };
        return {
            from: from,
            to: day
        };
    }
    return {
        from: day,
        to: undefined
    };
}
/**
 * The SelectRange context shares details about the selected days when in
 * range selection mode.
 *
 * Access this context from the {@link useSelectRange} hook.
 */ var $89da45f89b022bca$export$49c734aed8c840bb = (0, $b6HlZ.createContext)(undefined);
/** Provides the values for the {@link SelectRangeProvider}. */ function $89da45f89b022bca$export$deb49a47c7ee5fdf(props) {
    if (!$89da45f89b022bca$export$f7b9f96866ec1964(props.initialProps)) {
        var emptyContextValue = {
            selected: undefined,
            modifiers: {
                range_start: [],
                range_end: [],
                range_middle: [],
                disabled: []
            }
        };
        return $89da45f89b022bca$var$jsxRuntimeExports.jsx($89da45f89b022bca$export$49c734aed8c840bb.Provider, $89da45f89b022bca$var$__assign({
            value: emptyContextValue
        }, {
            children: props.children
        }));
    }
    return $89da45f89b022bca$var$jsxRuntimeExports.jsx($89da45f89b022bca$export$cca59e032fbbe71f, {
        initialProps: props.initialProps,
        children: props.children
    });
}
function $89da45f89b022bca$export$cca59e032fbbe71f(_a) {
    var initialProps = _a.initialProps, children = _a.children;
    var selected = initialProps.selected;
    var _b = selected || {}, selectedFrom = _b.from, selectedTo = _b.to;
    var min = initialProps.min;
    var max = initialProps.max;
    var onDayClick = function(day, activeModifiers, e) {
        var _a, _b;
        (_a = initialProps.onDayClick) === null || _a === void 0 || _a.call(initialProps, day, activeModifiers, e);
        var newRange = $89da45f89b022bca$export$27ef550b4e6acc0c(day, selected);
        (_b = initialProps.onSelect) === null || _b === void 0 || _b.call(initialProps, newRange, day, activeModifiers, e);
    };
    var modifiers = {
        range_start: [],
        range_end: [],
        range_middle: [],
        disabled: []
    };
    if (selectedFrom) {
        modifiers.range_start = [
            selectedFrom
        ];
        if (!selectedTo) modifiers.range_end = [
            selectedFrom
        ];
        else {
            modifiers.range_end = [
                selectedTo
            ];
            if (!(0, $1393872aaf394788$export$2e2bcd8739ae039)(selectedFrom, selectedTo)) modifiers.range_middle = [
                {
                    after: selectedFrom,
                    before: selectedTo
                }
            ];
        }
    } else if (selectedTo) {
        modifiers.range_start = [
            selectedTo
        ];
        modifiers.range_end = [
            selectedTo
        ];
    }
    if (min) {
        if (selectedFrom && !selectedTo) modifiers.disabled.push({
            after: (0, $d96f67c3c2cbd49c$export$2e2bcd8739ae039)(selectedFrom, min - 1),
            before: (0, $cab34702696efb7b$export$2e2bcd8739ae039)(selectedFrom, min - 1)
        });
        if (selectedFrom && selectedTo) modifiers.disabled.push({
            after: selectedFrom,
            before: (0, $cab34702696efb7b$export$2e2bcd8739ae039)(selectedFrom, min - 1)
        });
        if (!selectedFrom && selectedTo) modifiers.disabled.push({
            after: (0, $d96f67c3c2cbd49c$export$2e2bcd8739ae039)(selectedTo, min - 1),
            before: (0, $cab34702696efb7b$export$2e2bcd8739ae039)(selectedTo, min - 1)
        });
    }
    if (max) {
        if (selectedFrom && !selectedTo) {
            modifiers.disabled.push({
                before: (0, $cab34702696efb7b$export$2e2bcd8739ae039)(selectedFrom, -max + 1)
            });
            modifiers.disabled.push({
                after: (0, $cab34702696efb7b$export$2e2bcd8739ae039)(selectedFrom, max - 1)
            });
        }
        if (selectedFrom && selectedTo) {
            var selectedCount = (0, $bc9a368e85fd9df6$export$2e2bcd8739ae039)(selectedTo, selectedFrom) + 1;
            var offset = max - selectedCount;
            modifiers.disabled.push({
                before: (0, $d96f67c3c2cbd49c$export$2e2bcd8739ae039)(selectedFrom, offset)
            });
            modifiers.disabled.push({
                after: (0, $cab34702696efb7b$export$2e2bcd8739ae039)(selectedTo, offset)
            });
        }
        if (!selectedFrom && selectedTo) {
            modifiers.disabled.push({
                before: (0, $cab34702696efb7b$export$2e2bcd8739ae039)(selectedTo, -max + 1)
            });
            modifiers.disabled.push({
                after: (0, $cab34702696efb7b$export$2e2bcd8739ae039)(selectedTo, max - 1)
            });
        }
    }
    return $89da45f89b022bca$var$jsxRuntimeExports.jsx($89da45f89b022bca$export$49c734aed8c840bb.Provider, $89da45f89b022bca$var$__assign({
        value: {
            selected: selected,
            onDayClick: onDayClick,
            modifiers: modifiers
        }
    }, {
        children: children
    }));
}
/**
 * Hook to access the {@link SelectRangeContextValue}.
 *
 * This hook is meant to be used inside internal or custom components.
 */ function $89da45f89b022bca$export$ad0998138eb321e7() {
    var context = (0, $b6HlZ.useContext)($89da45f89b022bca$export$49c734aed8c840bb);
    if (!context) throw new Error("useSelectRange must be used within a SelectRangeProvider");
    return context;
}
/** Normalize to array a matcher input. */ function $89da45f89b022bca$var$matcherToArray(matcher) {
    if (Array.isArray(matcher)) return $89da45f89b022bca$var$__spreadArray([], matcher, true);
    else if (matcher !== undefined) return [
        matcher
    ];
    else return [];
}
/** Create CustomModifiers from dayModifiers */ function $89da45f89b022bca$var$getCustomModifiers(dayModifiers) {
    var customModifiers = {};
    Object.entries(dayModifiers).forEach(function(_a) {
        var modifier = _a[0], matcher = _a[1];
        customModifiers[modifier] = $89da45f89b022bca$var$matcherToArray(matcher);
    });
    return customModifiers;
}
/** The name of the modifiers that are used internally by DayPicker. */ var $89da45f89b022bca$export$7652a4f8ecc53eb5;
(function(InternalModifier) {
    InternalModifier["Outside"] = "outside";
    /** Name of the modifier applied to the disabled days, using the `disabled` prop. */ InternalModifier["Disabled"] = "disabled";
    /** Name of the modifier applied to the selected days using the `selected` prop). */ InternalModifier["Selected"] = "selected";
    /** Name of the modifier applied to the hidden days using the `hidden` prop). */ InternalModifier["Hidden"] = "hidden";
    /** Name of the modifier applied to the day specified using the `today` prop). */ InternalModifier["Today"] = "today";
    /** The modifier applied to the day starting a selected range, when in range selection mode.  */ InternalModifier["RangeStart"] = "range_start";
    /** The modifier applied to the day ending a selected range, when in range selection mode.  */ InternalModifier["RangeEnd"] = "range_end";
    /** The modifier applied to the days between the start and the end of a selected range, when in range selection mode.  */ InternalModifier["RangeMiddle"] = "range_middle";
})($89da45f89b022bca$export$7652a4f8ecc53eb5 || ($89da45f89b022bca$export$7652a4f8ecc53eb5 = {}));
var $89da45f89b022bca$var$Selected = $89da45f89b022bca$export$7652a4f8ecc53eb5.Selected, $89da45f89b022bca$var$Disabled = $89da45f89b022bca$export$7652a4f8ecc53eb5.Disabled, $89da45f89b022bca$var$Hidden = $89da45f89b022bca$export$7652a4f8ecc53eb5.Hidden, $89da45f89b022bca$var$Today = $89da45f89b022bca$export$7652a4f8ecc53eb5.Today, $89da45f89b022bca$var$RangeEnd = $89da45f89b022bca$export$7652a4f8ecc53eb5.RangeEnd, $89da45f89b022bca$var$RangeMiddle = $89da45f89b022bca$export$7652a4f8ecc53eb5.RangeMiddle, $89da45f89b022bca$var$RangeStart = $89da45f89b022bca$export$7652a4f8ecc53eb5.RangeStart, $89da45f89b022bca$var$Outside = $89da45f89b022bca$export$7652a4f8ecc53eb5.Outside;
/** Return the {@link InternalModifiers} from the DayPicker and select contexts. */ function $89da45f89b022bca$var$getInternalModifiers(dayPicker, selectMultiple, selectRange) {
    var _a;
    var internalModifiers = (_a = {}, _a[$89da45f89b022bca$var$Selected] = $89da45f89b022bca$var$matcherToArray(dayPicker.selected), _a[$89da45f89b022bca$var$Disabled] = $89da45f89b022bca$var$matcherToArray(dayPicker.disabled), _a[$89da45f89b022bca$var$Hidden] = $89da45f89b022bca$var$matcherToArray(dayPicker.hidden), _a[$89da45f89b022bca$var$Today] = [
        dayPicker.today
    ], _a[$89da45f89b022bca$var$RangeEnd] = [], _a[$89da45f89b022bca$var$RangeMiddle] = [], _a[$89da45f89b022bca$var$RangeStart] = [], _a[$89da45f89b022bca$var$Outside] = [], _a);
    if (dayPicker.fromDate) internalModifiers[$89da45f89b022bca$var$Disabled].push({
        before: dayPicker.fromDate
    });
    if (dayPicker.toDate) internalModifiers[$89da45f89b022bca$var$Disabled].push({
        after: dayPicker.toDate
    });
    if ($89da45f89b022bca$export$2d8c2b43ec0e528(dayPicker)) internalModifiers[$89da45f89b022bca$var$Disabled] = internalModifiers[$89da45f89b022bca$var$Disabled].concat(selectMultiple.modifiers[$89da45f89b022bca$var$Disabled]);
    else if ($89da45f89b022bca$export$f7b9f96866ec1964(dayPicker)) {
        internalModifiers[$89da45f89b022bca$var$Disabled] = internalModifiers[$89da45f89b022bca$var$Disabled].concat(selectRange.modifiers[$89da45f89b022bca$var$Disabled]);
        internalModifiers[$89da45f89b022bca$var$RangeStart] = selectRange.modifiers[$89da45f89b022bca$var$RangeStart];
        internalModifiers[$89da45f89b022bca$var$RangeMiddle] = selectRange.modifiers[$89da45f89b022bca$var$RangeMiddle];
        internalModifiers[$89da45f89b022bca$var$RangeEnd] = selectRange.modifiers[$89da45f89b022bca$var$RangeEnd];
    }
    return internalModifiers;
}
/** The Modifiers context store the modifiers used in DayPicker. To access the value of this context, use {@link useModifiers}. */ var $89da45f89b022bca$var$ModifiersContext = (0, $b6HlZ.createContext)(undefined);
/** Provide the value for the {@link ModifiersContext}. */ function $89da45f89b022bca$var$ModifiersProvider(props) {
    var dayPicker = $89da45f89b022bca$export$332e9e0d64b1f294();
    var selectMultiple = $89da45f89b022bca$export$458361db477d8ed0();
    var selectRange = $89da45f89b022bca$export$ad0998138eb321e7();
    var internalModifiers = $89da45f89b022bca$var$getInternalModifiers(dayPicker, selectMultiple, selectRange);
    var customModifiers = $89da45f89b022bca$var$getCustomModifiers(dayPicker.modifiers);
    var modifiers = $89da45f89b022bca$var$__assign($89da45f89b022bca$var$__assign({}, internalModifiers), customModifiers);
    return $89da45f89b022bca$var$jsxRuntimeExports.jsx($89da45f89b022bca$var$ModifiersContext.Provider, $89da45f89b022bca$var$__assign({
        value: modifiers
    }, {
        children: props.children
    }));
}
/**
 * Return the modifiers used by DayPicker.
 *
 * This hook is meant to be used inside internal or custom components.
 * Requires to be wrapped into {@link ModifiersProvider}.
 *
 */ function $89da45f89b022bca$var$useModifiers() {
    var context = (0, $b6HlZ.useContext)($89da45f89b022bca$var$ModifiersContext);
    if (!context) throw new Error("useModifiers must be used within a ModifiersProvider");
    return context;
}
/** Returns true if `matcher` is of type {@link DateInterval}. */ function $89da45f89b022bca$export$654311eaff47f3cd(matcher) {
    return Boolean(matcher && typeof matcher === "object" && "before" in matcher && "after" in matcher);
}
/** Returns true if `value` is a {@link DateRange} type. */ function $89da45f89b022bca$export$dd455b9c98fea187(value) {
    return Boolean(value && typeof value === "object" && "from" in value);
}
/** Returns true if `value` is of type {@link DateAfter}. */ function $89da45f89b022bca$export$4760905e07020cd4(value) {
    return Boolean(value && typeof value === "object" && "after" in value);
}
/** Returns true if `value` is of type {@link DateBefore}. */ function $89da45f89b022bca$export$a3bef2c4e855ef4e(value) {
    return Boolean(value && typeof value === "object" && "before" in value);
}
/** Returns true if `value` is a {@link DayOfWeek} type. */ function $89da45f89b022bca$export$483c833837970a3(value) {
    return Boolean(value && typeof value === "object" && "dayOfWeek" in value);
}
/** Return `true` whether `date` is inside `range`. */ function $89da45f89b022bca$var$isDateInRange(date, range) {
    var _a;
    var from = range.from, to = range.to;
    if (from && to) {
        var isRangeInverted = (0, $bc9a368e85fd9df6$export$2e2bcd8739ae039)(to, from) < 0;
        if (isRangeInverted) _a = [
            to,
            from
        ], from = _a[0], to = _a[1];
        var isInRange = (0, $bc9a368e85fd9df6$export$2e2bcd8739ae039)(date, from) >= 0 && (0, $bc9a368e85fd9df6$export$2e2bcd8739ae039)(to, date) >= 0;
        return isInRange;
    }
    if (to) return (0, $1393872aaf394788$export$2e2bcd8739ae039)(to, date);
    if (from) return (0, $1393872aaf394788$export$2e2bcd8739ae039)(from, date);
    return false;
}
/** Returns true if `value` is a Date type. */ function $89da45f89b022bca$var$isDateType(value) {
    return (0, $f8e700f283ae2061$export$2e2bcd8739ae039)(value);
}
/** Returns true if `value` is an array of valid dates. */ function $89da45f89b022bca$var$isArrayOfDates(value) {
    return Array.isArray(value) && value.every((0, $f8e700f283ae2061$export$2e2bcd8739ae039));
}
/**
 * Returns whether a day matches against at least one of the given Matchers.
 *
 * ```
 * const day = new Date(2022, 5, 19);
 * const matcher1: DateRange = {
 *    from: new Date(2021, 12, 21),
 *    to: new Date(2021, 12, 30)
 * }
 * const matcher2: DateRange = {
 *    from: new Date(2022, 5, 1),
 *    to: new Date(2022, 5, 23)
 * }
 *
 * const isMatch(day, [matcher1, matcher2]); // true, since day is in the matcher1 range.
 * ```
 * */ function $89da45f89b022bca$export$b74c33566721f70f(day, matchers) {
    return matchers.some(function(matcher) {
        if (typeof matcher === "boolean") return matcher;
        if ($89da45f89b022bca$var$isDateType(matcher)) return (0, $1393872aaf394788$export$2e2bcd8739ae039)(day, matcher);
        if ($89da45f89b022bca$var$isArrayOfDates(matcher)) return matcher.includes(day);
        if ($89da45f89b022bca$export$dd455b9c98fea187(matcher)) return $89da45f89b022bca$var$isDateInRange(day, matcher);
        if ($89da45f89b022bca$export$483c833837970a3(matcher)) return matcher.dayOfWeek.includes(day.getDay());
        if ($89da45f89b022bca$export$654311eaff47f3cd(matcher)) {
            var diffBefore = (0, $bc9a368e85fd9df6$export$2e2bcd8739ae039)(matcher.before, day);
            var diffAfter = (0, $bc9a368e85fd9df6$export$2e2bcd8739ae039)(matcher.after, day);
            var isDayBefore = diffBefore > 0;
            var isDayAfter = diffAfter < 0;
            var isClosedInterval = (0, $b2aab07c3dbca894$export$2e2bcd8739ae039)(matcher.before, matcher.after);
            if (isClosedInterval) return isDayAfter && isDayBefore;
            else return isDayBefore || isDayAfter;
        }
        if ($89da45f89b022bca$export$4760905e07020cd4(matcher)) return (0, $bc9a368e85fd9df6$export$2e2bcd8739ae039)(day, matcher.after) > 0;
        if ($89da45f89b022bca$export$a3bef2c4e855ef4e(matcher)) return (0, $bc9a368e85fd9df6$export$2e2bcd8739ae039)(matcher.before, day) > 0;
        if (typeof matcher === "function") return matcher(day);
        return false;
    });
}
/** Return the active modifiers for the given day. */ function $89da45f89b022bca$var$getActiveModifiers(day, /** The modifiers to match for the given date. */ modifiers, /** The month where the day is displayed, to add the "outside" modifiers.  */ displayMonth) {
    var matchedModifiers = Object.keys(modifiers).reduce(function(result, key) {
        var modifier = modifiers[key];
        if ($89da45f89b022bca$export$b74c33566721f70f(day, modifier)) result.push(key);
        return result;
    }, []);
    var activeModifiers = {};
    matchedModifiers.forEach(function(modifier) {
        return activeModifiers[modifier] = true;
    });
    if (displayMonth && !(0, $9a3632b3cc120583$export$2e2bcd8739ae039)(day, displayMonth)) activeModifiers.outside = true;
    return activeModifiers;
}
/**
 * Returns the day that should be the target of the focus when DayPicker is
 * rendered the first time.
 *
 * TODO: this function doesn't consider if the day is outside the month. We
 * implemented this check in `useDayRender` but it should probably go here. See
 * https://github.com/gpbl/react-day-picker/pull/1576
 */ function $89da45f89b022bca$var$getInitialFocusTarget(displayMonths, modifiers) {
    var firstDayInMonth = (0, $456b685109e85eeb$export$2e2bcd8739ae039)(displayMonths[0]);
    var lastDayInMonth = (0, $dde476f98780dbbe$export$2e2bcd8739ae039)(displayMonths[displayMonths.length - 1]);
    // TODO: cleanup code
    var firstFocusableDay;
    var today;
    var date = firstDayInMonth;
    while(date <= lastDayInMonth){
        var activeModifiers = $89da45f89b022bca$var$getActiveModifiers(date, modifiers);
        var isFocusable = !activeModifiers.disabled && !activeModifiers.hidden;
        if (!isFocusable) {
            date = (0, $cab34702696efb7b$export$2e2bcd8739ae039)(date, 1);
            continue;
        }
        if (activeModifiers.selected) return date;
        if (activeModifiers.today && !today) today = date;
        if (!firstFocusableDay) firstFocusableDay = date;
        date = (0, $cab34702696efb7b$export$2e2bcd8739ae039)(date, 1);
    }
    if (today) return today;
    else return firstFocusableDay;
}
var $89da45f89b022bca$var$MAX_RETRY = 365;
/** Return the next date to be focused. */ function $89da45f89b022bca$var$getNextFocus(focusedDay, options) {
    var moveBy = options.moveBy, direction = options.direction, context = options.context, modifiers = options.modifiers, _a = options.retry, retry = _a === void 0 ? {
        count: 0,
        lastFocused: focusedDay
    } : _a;
    var weekStartsOn = context.weekStartsOn, fromDate = context.fromDate, toDate = context.toDate, locale = context.locale;
    var moveFns = {
        day: (0, $cab34702696efb7b$export$2e2bcd8739ae039),
        week: (0, $af4693c3eab78194$export$2e2bcd8739ae039),
        month: (0, $623e079afbe8c632$export$2e2bcd8739ae039),
        year: (0, $5632dd425e7055b1$export$2e2bcd8739ae039),
        startOfWeek: function(date) {
            return context.ISOWeek ? (0, $33926cd4b89b52a2$export$2e2bcd8739ae039)(date) : (0, $97cce5fde4647ac6$export$2e2bcd8739ae039)(date, {
                locale: locale,
                weekStartsOn: weekStartsOn
            });
        },
        endOfWeek: function(date) {
            return context.ISOWeek ? (0, $a92ab20ed83b4ee2$export$2e2bcd8739ae039)(date) : (0, $9856a141db4f5eb8$export$2e2bcd8739ae039)(date, {
                locale: locale,
                weekStartsOn: weekStartsOn
            });
        }
    };
    var newFocusedDay = moveFns[moveBy](focusedDay, direction === "after" ? 1 : -1);
    if (direction === "before" && fromDate) newFocusedDay = (0, $73d25d54a277ce0d$export$2e2bcd8739ae039)([
        fromDate,
        newFocusedDay
    ]);
    else if (direction === "after" && toDate) newFocusedDay = (0, $291696af888c6902$export$2e2bcd8739ae039)([
        toDate,
        newFocusedDay
    ]);
    var isFocusable = true;
    if (modifiers) {
        var activeModifiers = $89da45f89b022bca$var$getActiveModifiers(newFocusedDay, modifiers);
        isFocusable = !activeModifiers.disabled && !activeModifiers.hidden;
    }
    if (isFocusable) return newFocusedDay;
    else {
        if (retry.count > $89da45f89b022bca$var$MAX_RETRY) return retry.lastFocused;
        return $89da45f89b022bca$var$getNextFocus(newFocusedDay, {
            moveBy: moveBy,
            direction: direction,
            context: context,
            modifiers: modifiers,
            retry: $89da45f89b022bca$var$__assign($89da45f89b022bca$var$__assign({}, retry), {
                count: retry.count + 1
            })
        });
    }
}
/**
 * The Focus context shares details about the focused day for the keyboard
 *
 * Access this context from the {@link useFocusContext} hook.
 */ var $89da45f89b022bca$export$e1f21ba6aeca320f = (0, $b6HlZ.createContext)(undefined);
/** The provider for the {@link FocusContext}. */ function $89da45f89b022bca$export$97cf4ab9b312b61a(props) {
    var navigation = $89da45f89b022bca$export$d0fd4b7106de2769();
    var modifiers = $89da45f89b022bca$var$useModifiers();
    var _a = (0, $b6HlZ.useState)(), focusedDay = _a[0], setFocusedDay = _a[1];
    var _b = (0, $b6HlZ.useState)(), lastFocused = _b[0], setLastFocused = _b[1];
    var initialFocusTarget = $89da45f89b022bca$var$getInitialFocusTarget(navigation.displayMonths, modifiers);
    // TODO: cleanup and test obscure code below
    var focusTarget = (focusedDay !== null && focusedDay !== void 0 ? focusedDay : lastFocused && navigation.isDateDisplayed(lastFocused)) ? lastFocused : initialFocusTarget;
    var blur = function() {
        setLastFocused(focusedDay);
        setFocusedDay(undefined);
    };
    var focus = function(date) {
        setFocusedDay(date);
    };
    var context = $89da45f89b022bca$export$332e9e0d64b1f294();
    var moveFocus = function(moveBy, direction) {
        if (!focusedDay) return;
        var nextFocused = $89da45f89b022bca$var$getNextFocus(focusedDay, {
            moveBy: moveBy,
            direction: direction,
            context: context,
            modifiers: modifiers
        });
        if ((0, $1393872aaf394788$export$2e2bcd8739ae039)(focusedDay, nextFocused)) return undefined;
        navigation.goToDate(nextFocused, focusedDay);
        focus(nextFocused);
    };
    var value = {
        focusedDay: focusedDay,
        focusTarget: focusTarget,
        blur: blur,
        focus: focus,
        focusDayAfter: function() {
            return moveFocus("day", "after");
        },
        focusDayBefore: function() {
            return moveFocus("day", "before");
        },
        focusWeekAfter: function() {
            return moveFocus("week", "after");
        },
        focusWeekBefore: function() {
            return moveFocus("week", "before");
        },
        focusMonthBefore: function() {
            return moveFocus("month", "before");
        },
        focusMonthAfter: function() {
            return moveFocus("month", "after");
        },
        focusYearBefore: function() {
            return moveFocus("year", "before");
        },
        focusYearAfter: function() {
            return moveFocus("year", "after");
        },
        focusStartOfWeek: function() {
            return moveFocus("startOfWeek", "before");
        },
        focusEndOfWeek: function() {
            return moveFocus("endOfWeek", "after");
        }
    };
    return $89da45f89b022bca$var$jsxRuntimeExports.jsx($89da45f89b022bca$export$e1f21ba6aeca320f.Provider, $89da45f89b022bca$var$__assign({
        value: value
    }, {
        children: props.children
    }));
}
/**
 * Hook to access the {@link FocusContextValue}. Use this hook to handle the
 * focus state of the elements.
 *
 * This hook is meant to be used inside internal or custom components.
 */ function $89da45f89b022bca$export$69130071837c676e() {
    var context = (0, $b6HlZ.useContext)($89da45f89b022bca$export$e1f21ba6aeca320f);
    if (!context) throw new Error("useFocusContext must be used within a FocusProvider");
    return context;
}
/**
 * Return the active modifiers for the specified day.
 *
 * This hook is meant to be used inside internal or custom components.
 *
 * @param day
 * @param displayMonth
 */ function $89da45f89b022bca$export$174df9b23ec1eb4b(day, /**
 * The month where the date is displayed. If not the same as `date`, the day
 * is an "outside day".
 */ displayMonth) {
    var modifiers = $89da45f89b022bca$var$useModifiers();
    var activeModifiers = $89da45f89b022bca$var$getActiveModifiers(day, modifiers, displayMonth);
    return activeModifiers;
}
/**
 * The SelectSingle context shares details about the selected days when in
 * single selection mode.
 *
 * Access this context from the {@link useSelectSingle} hook.
 */ var $89da45f89b022bca$export$9632b0427d86eff3 = (0, $b6HlZ.createContext)(undefined);
/** Provides the values for the {@link SelectSingleProvider}. */ function $89da45f89b022bca$export$d40a11a5bbe785ba(props) {
    if (!$89da45f89b022bca$export$e659ce9b264ea61(props.initialProps)) {
        var emptyContextValue = {
            selected: undefined
        };
        return $89da45f89b022bca$var$jsxRuntimeExports.jsx($89da45f89b022bca$export$9632b0427d86eff3.Provider, $89da45f89b022bca$var$__assign({
            value: emptyContextValue
        }, {
            children: props.children
        }));
    }
    return $89da45f89b022bca$var$jsxRuntimeExports.jsx($89da45f89b022bca$export$37bf09040cff7c3b, {
        initialProps: props.initialProps,
        children: props.children
    });
}
function $89da45f89b022bca$export$37bf09040cff7c3b(_a) {
    var initialProps = _a.initialProps, children = _a.children;
    var onDayClick = function(day, activeModifiers, e) {
        var _a, _b, _c;
        (_a = initialProps.onDayClick) === null || _a === void 0 || _a.call(initialProps, day, activeModifiers, e);
        if (activeModifiers.selected && !initialProps.required) {
            (_b = initialProps.onSelect) === null || _b === void 0 || _b.call(initialProps, undefined, day, activeModifiers, e);
            return;
        }
        (_c = initialProps.onSelect) === null || _c === void 0 || _c.call(initialProps, day, day, activeModifiers, e);
    };
    var contextValue = {
        selected: initialProps.selected,
        onDayClick: onDayClick
    };
    return $89da45f89b022bca$var$jsxRuntimeExports.jsx($89da45f89b022bca$export$9632b0427d86eff3.Provider, $89da45f89b022bca$var$__assign({
        value: contextValue
    }, {
        children: children
    }));
}
/**
 * Hook to access the {@link SelectSingleContextValue}.
 *
 * This hook is meant to be used inside internal or custom components.
 */ function $89da45f89b022bca$export$2d75d772c98e4b05() {
    var context = (0, $b6HlZ.useContext)($89da45f89b022bca$export$9632b0427d86eff3);
    if (!context) throw new Error("useSelectSingle must be used within a SelectSingleProvider");
    return context;
}
/**
 * This hook returns details about the content to render in the day cell.
 *
 *
 * When a day cell is rendered in the table, DayPicker can either:
 *
 * - render nothing: when the day is outside the month or has matched the
 *   "hidden" modifier.
 * - render a button when `onDayClick` or a selection mode is set.
 * - render a non-interactive element: when no selection mode is set, the day
 *   cell shouldn’t respond to any interaction. DayPicker should render a `div`
 *   or a `span`.
 *
 * ### Usage
 *
 * Use this hook to customize the behavior of the {@link Day} component. Create a
 * new `Day` component using this hook and pass it to the `components` prop.
 * The source of {@link Day} can be a good starting point.
 *
 */ function $89da45f89b022bca$var$useDayEventHandlers(date, activeModifiers) {
    var dayPicker = $89da45f89b022bca$export$332e9e0d64b1f294();
    var single = $89da45f89b022bca$export$2d75d772c98e4b05();
    var multiple = $89da45f89b022bca$export$458361db477d8ed0();
    var range = $89da45f89b022bca$export$ad0998138eb321e7();
    var _a = $89da45f89b022bca$export$69130071837c676e(), focusDayAfter = _a.focusDayAfter, focusDayBefore = _a.focusDayBefore, focusWeekAfter = _a.focusWeekAfter, focusWeekBefore = _a.focusWeekBefore, blur = _a.blur, focus = _a.focus, focusMonthBefore = _a.focusMonthBefore, focusMonthAfter = _a.focusMonthAfter, focusYearBefore = _a.focusYearBefore, focusYearAfter = _a.focusYearAfter, focusStartOfWeek = _a.focusStartOfWeek, focusEndOfWeek = _a.focusEndOfWeek;
    var onClick = function(e) {
        var _a, _b, _c, _d;
        if ($89da45f89b022bca$export$e659ce9b264ea61(dayPicker)) (_a = single.onDayClick) === null || _a === void 0 || _a.call(single, date, activeModifiers, e);
        else if ($89da45f89b022bca$export$2d8c2b43ec0e528(dayPicker)) (_b = multiple.onDayClick) === null || _b === void 0 || _b.call(multiple, date, activeModifiers, e);
        else if ($89da45f89b022bca$export$f7b9f96866ec1964(dayPicker)) (_c = range.onDayClick) === null || _c === void 0 || _c.call(range, date, activeModifiers, e);
        else (_d = dayPicker.onDayClick) === null || _d === void 0 || _d.call(dayPicker, date, activeModifiers, e);
    };
    var onFocus = function(e) {
        var _a;
        focus(date);
        (_a = dayPicker.onDayFocus) === null || _a === void 0 || _a.call(dayPicker, date, activeModifiers, e);
    };
    var onBlur = function(e) {
        var _a;
        blur();
        (_a = dayPicker.onDayBlur) === null || _a === void 0 || _a.call(dayPicker, date, activeModifiers, e);
    };
    var onMouseEnter = function(e) {
        var _a;
        (_a = dayPicker.onDayMouseEnter) === null || _a === void 0 || _a.call(dayPicker, date, activeModifiers, e);
    };
    var onMouseLeave = function(e) {
        var _a;
        (_a = dayPicker.onDayMouseLeave) === null || _a === void 0 || _a.call(dayPicker, date, activeModifiers, e);
    };
    var onPointerEnter = function(e) {
        var _a;
        (_a = dayPicker.onDayPointerEnter) === null || _a === void 0 || _a.call(dayPicker, date, activeModifiers, e);
    };
    var onPointerLeave = function(e) {
        var _a;
        (_a = dayPicker.onDayPointerLeave) === null || _a === void 0 || _a.call(dayPicker, date, activeModifiers, e);
    };
    var onTouchCancel = function(e) {
        var _a;
        (_a = dayPicker.onDayTouchCancel) === null || _a === void 0 || _a.call(dayPicker, date, activeModifiers, e);
    };
    var onTouchEnd = function(e) {
        var _a;
        (_a = dayPicker.onDayTouchEnd) === null || _a === void 0 || _a.call(dayPicker, date, activeModifiers, e);
    };
    var onTouchMove = function(e) {
        var _a;
        (_a = dayPicker.onDayTouchMove) === null || _a === void 0 || _a.call(dayPicker, date, activeModifiers, e);
    };
    var onTouchStart = function(e) {
        var _a;
        (_a = dayPicker.onDayTouchStart) === null || _a === void 0 || _a.call(dayPicker, date, activeModifiers, e);
    };
    var onKeyUp = function(e) {
        var _a;
        (_a = dayPicker.onDayKeyUp) === null || _a === void 0 || _a.call(dayPicker, date, activeModifiers, e);
    };
    var onKeyDown = function(e) {
        var _a;
        switch(e.key){
            case "ArrowLeft":
                e.preventDefault();
                e.stopPropagation();
                dayPicker.dir === "rtl" ? focusDayAfter() : focusDayBefore();
                break;
            case "ArrowRight":
                e.preventDefault();
                e.stopPropagation();
                dayPicker.dir === "rtl" ? focusDayBefore() : focusDayAfter();
                break;
            case "ArrowDown":
                e.preventDefault();
                e.stopPropagation();
                focusWeekAfter();
                break;
            case "ArrowUp":
                e.preventDefault();
                e.stopPropagation();
                focusWeekBefore();
                break;
            case "PageUp":
                e.preventDefault();
                e.stopPropagation();
                e.shiftKey ? focusYearBefore() : focusMonthBefore();
                break;
            case "PageDown":
                e.preventDefault();
                e.stopPropagation();
                e.shiftKey ? focusYearAfter() : focusMonthAfter();
                break;
            case "Home":
                e.preventDefault();
                e.stopPropagation();
                focusStartOfWeek();
                break;
            case "End":
                e.preventDefault();
                e.stopPropagation();
                focusEndOfWeek();
                break;
        }
        (_a = dayPicker.onDayKeyDown) === null || _a === void 0 || _a.call(dayPicker, date, activeModifiers, e);
    };
    var eventHandlers = {
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur,
        onKeyDown: onKeyDown,
        onKeyUp: onKeyUp,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onPointerEnter: onPointerEnter,
        onPointerLeave: onPointerLeave,
        onTouchCancel: onTouchCancel,
        onTouchEnd: onTouchEnd,
        onTouchMove: onTouchMove,
        onTouchStart: onTouchStart
    };
    return eventHandlers;
}
/**
 * Return the current selected days when DayPicker is in selection mode. Days
 * selected by the custom selection mode are not returned.
 *
 * This hook is meant to be used inside internal or custom components.
 *
 */ function $89da45f89b022bca$var$useSelectedDays() {
    var dayPicker = $89da45f89b022bca$export$332e9e0d64b1f294();
    var single = $89da45f89b022bca$export$2d75d772c98e4b05();
    var multiple = $89da45f89b022bca$export$458361db477d8ed0();
    var range = $89da45f89b022bca$export$ad0998138eb321e7();
    var selectedDays = $89da45f89b022bca$export$e659ce9b264ea61(dayPicker) ? single.selected : $89da45f89b022bca$export$2d8c2b43ec0e528(dayPicker) ? multiple.selected : $89da45f89b022bca$export$f7b9f96866ec1964(dayPicker) ? range.selected : undefined;
    return selectedDays;
}
function $89da45f89b022bca$var$isInternalModifier(modifier) {
    return Object.values($89da45f89b022bca$export$7652a4f8ecc53eb5).includes(modifier);
}
/**
 * Return the class names for the Day element, according to the given active
 * modifiers.
 *
 * Custom class names are set via `modifiersClassNames` or `classNames`,
 * where the first have the precedence.
 */ function $89da45f89b022bca$var$getDayClassNames(dayPicker, activeModifiers) {
    var classNames = [
        dayPicker.classNames.day
    ];
    Object.keys(activeModifiers).forEach(function(modifier) {
        var customClassName = dayPicker.modifiersClassNames[modifier];
        if (customClassName) classNames.push(customClassName);
        else if ($89da45f89b022bca$var$isInternalModifier(modifier)) {
            var internalClassName = dayPicker.classNames["day_".concat(modifier)];
            if (internalClassName) classNames.push(internalClassName);
        }
    });
    return classNames;
}
/** Return the style for the Day element, according to the given active modifiers. */ function $89da45f89b022bca$var$getDayStyle(dayPicker, activeModifiers) {
    var style = $89da45f89b022bca$var$__assign({}, dayPicker.styles.day);
    Object.keys(activeModifiers).forEach(function(modifier) {
        var _a;
        style = $89da45f89b022bca$var$__assign($89da45f89b022bca$var$__assign({}, style), (_a = dayPicker.modifiersStyles) === null || _a === void 0 ? void 0 : _a[modifier]);
    });
    return style;
}
/**
 * Return props and data used to render the {@link Day} component.
 *
 * Use this hook when creating a component to replace the built-in `Day`
 * component.
 */ function $89da45f89b022bca$export$634dab6d85b953fc(/** The date to render. */ day, /** The month where the date is displayed (if not the same as `date`, it means it is an "outside" day). */ displayMonth, /** A ref to the button element that will be target of focus when rendered (if required). */ buttonRef) {
    var _a;
    var _b, _c;
    var dayPicker = $89da45f89b022bca$export$332e9e0d64b1f294();
    var focusContext = $89da45f89b022bca$export$69130071837c676e();
    var activeModifiers = $89da45f89b022bca$export$174df9b23ec1eb4b(day, displayMonth);
    var eventHandlers = $89da45f89b022bca$var$useDayEventHandlers(day, activeModifiers);
    var selectedDays = $89da45f89b022bca$var$useSelectedDays();
    var isButton = Boolean(dayPicker.onDayClick || dayPicker.mode !== "default");
    // Focus the button if the day is focused according to the focus context
    (0, $b6HlZ.useEffect)(function() {
        var _a;
        if (activeModifiers.outside) return;
        if (!focusContext.focusedDay) return;
        if (!isButton) return;
        if ((0, $1393872aaf394788$export$2e2bcd8739ae039)(focusContext.focusedDay, day)) (_a = buttonRef.current) === null || _a === void 0 || _a.focus();
    }, [
        focusContext.focusedDay,
        day,
        buttonRef,
        isButton,
        activeModifiers.outside
    ]);
    var className = $89da45f89b022bca$var$getDayClassNames(dayPicker, activeModifiers).join(" ");
    var style = $89da45f89b022bca$var$getDayStyle(dayPicker, activeModifiers);
    var isHidden = Boolean(activeModifiers.outside && !dayPicker.showOutsideDays || activeModifiers.hidden);
    var DayContentComponent = (_c = (_b = dayPicker.components) === null || _b === void 0 ? void 0 : _b.DayContent) !== null && _c !== void 0 ? _c : $89da45f89b022bca$export$16d0634337daf8ec;
    var children = $89da45f89b022bca$var$jsxRuntimeExports.jsx(DayContentComponent, {
        date: day,
        displayMonth: displayMonth,
        activeModifiers: activeModifiers
    });
    var divProps = {
        style: style,
        className: className,
        children: children,
        role: "gridcell"
    };
    var isFocusTarget = focusContext.focusTarget && (0, $1393872aaf394788$export$2e2bcd8739ae039)(focusContext.focusTarget, day) && !activeModifiers.outside;
    var isFocused = focusContext.focusedDay && (0, $1393872aaf394788$export$2e2bcd8739ae039)(focusContext.focusedDay, day);
    var buttonProps = $89da45f89b022bca$var$__assign($89da45f89b022bca$var$__assign($89da45f89b022bca$var$__assign({}, divProps), (_a = {
        disabled: activeModifiers.disabled,
        role: "gridcell"
    }, _a["aria-selected"] = activeModifiers.selected, _a.tabIndex = isFocused || isFocusTarget ? 0 : -1, _a)), eventHandlers);
    var dayRender = {
        isButton: isButton,
        isHidden: isHidden,
        activeModifiers: activeModifiers,
        selectedDays: selectedDays,
        buttonProps: buttonProps,
        divProps: divProps
    };
    return dayRender;
}
/**
 * The content of a day cell – as a button or span element according to its
 * modifiers.
 */ function $89da45f89b022bca$export$7a9a31a911eb9a20(props) {
    var buttonRef = (0, $b6HlZ.useRef)(null);
    var dayRender = $89da45f89b022bca$export$634dab6d85b953fc(props.date, props.displayMonth, buttonRef);
    if (dayRender.isHidden) return $89da45f89b022bca$var$jsxRuntimeExports.jsx("div", {
        role: "gridcell"
    });
    if (!dayRender.isButton) return $89da45f89b022bca$var$jsxRuntimeExports.jsx("div", $89da45f89b022bca$var$__assign({}, dayRender.divProps));
    return $89da45f89b022bca$var$jsxRuntimeExports.jsx($89da45f89b022bca$export$353f5b6fc5456de1, $89da45f89b022bca$var$__assign({
        name: "day",
        ref: buttonRef
    }, dayRender.buttonProps));
}
/**
 * Render the week number element. If `onWeekNumberClick` is passed to DayPicker, it
 * renders a button, otherwise a span element.
 */ function $89da45f89b022bca$export$f52f5e0fedb732da(props) {
    var weekNumber = props.number, dates = props.dates;
    var _a = $89da45f89b022bca$export$332e9e0d64b1f294(), onWeekNumberClick = _a.onWeekNumberClick, styles = _a.styles, classNames = _a.classNames, locale = _a.locale, labelWeekNumber = _a.labels.labelWeekNumber, formatWeekNumber = _a.formatters.formatWeekNumber;
    var content = formatWeekNumber(Number(weekNumber), {
        locale: locale
    });
    if (!onWeekNumberClick) return $89da45f89b022bca$var$jsxRuntimeExports.jsx("span", $89da45f89b022bca$var$__assign({
        className: classNames.weeknumber,
        style: styles.weeknumber
    }, {
        children: content
    }));
    var label = labelWeekNumber(Number(weekNumber), {
        locale: locale
    });
    var handleClick = function(e) {
        onWeekNumberClick(weekNumber, dates, e);
    };
    return $89da45f89b022bca$var$jsxRuntimeExports.jsx($89da45f89b022bca$export$353f5b6fc5456de1, $89da45f89b022bca$var$__assign({
        name: "week-number",
        "aria-label": label,
        className: classNames.weeknumber,
        style: styles.weeknumber,
        onClick: handleClick
    }, {
        children: content
    }));
}
/** Render a row in the calendar, with the days and the week number. */ function $89da45f89b022bca$export$b59bdbef9ce70de2(props) {
    var _a, _b;
    var _c = $89da45f89b022bca$export$332e9e0d64b1f294(), styles = _c.styles, classNames = _c.classNames, showWeekNumber = _c.showWeekNumber, components = _c.components;
    var DayComponent = (_a = components === null || components === void 0 ? void 0 : components.Day) !== null && _a !== void 0 ? _a : $89da45f89b022bca$export$7a9a31a911eb9a20;
    var WeeknumberComponent = (_b = components === null || components === void 0 ? void 0 : components.WeekNumber) !== null && _b !== void 0 ? _b : $89da45f89b022bca$export$f52f5e0fedb732da;
    var weekNumberCell;
    if (showWeekNumber) weekNumberCell = $89da45f89b022bca$var$jsxRuntimeExports.jsx("td", $89da45f89b022bca$var$__assign({
        className: classNames.cell,
        style: styles.cell
    }, {
        children: $89da45f89b022bca$var$jsxRuntimeExports.jsx(WeeknumberComponent, {
            number: props.weekNumber,
            dates: props.dates
        })
    }));
    return $89da45f89b022bca$var$jsxRuntimeExports.jsxs("tr", $89da45f89b022bca$var$__assign({
        className: classNames.row,
        style: styles.row
    }, {
        children: [
            weekNumberCell,
            props.dates.map(function(date) {
                return $89da45f89b022bca$var$jsxRuntimeExports.jsx("td", $89da45f89b022bca$var$__assign({
                    className: classNames.cell,
                    style: styles.cell,
                    role: "presentation"
                }, {
                    children: $89da45f89b022bca$var$jsxRuntimeExports.jsx(DayComponent, {
                        displayMonth: props.displayMonth,
                        date: date
                    })
                }), (0, $2105347126e6239c$export$2e2bcd8739ae039)(date));
            })
        ]
    }));
}
/** Return the weeks between two dates.  */ function $89da45f89b022bca$var$daysToMonthWeeks(fromDate, toDate, options) {
    var toWeek = (options === null || options === void 0 ? void 0 : options.ISOWeek) ? (0, $a92ab20ed83b4ee2$export$2e2bcd8739ae039)(toDate) : (0, $9856a141db4f5eb8$export$2e2bcd8739ae039)(toDate, options);
    var fromWeek = (options === null || options === void 0 ? void 0 : options.ISOWeek) ? (0, $33926cd4b89b52a2$export$2e2bcd8739ae039)(fromDate) : (0, $97cce5fde4647ac6$export$2e2bcd8739ae039)(fromDate, options);
    var nOfDays = (0, $bc9a368e85fd9df6$export$2e2bcd8739ae039)(toWeek, fromWeek);
    var days = [];
    for(var i = 0; i <= nOfDays; i++)days.push((0, $cab34702696efb7b$export$2e2bcd8739ae039)(fromWeek, i));
    var weeksInMonth = days.reduce(function(result, date) {
        var weekNumber = (options === null || options === void 0 ? void 0 : options.ISOWeek) ? (0, $8e5c961712773f8f$export$2e2bcd8739ae039)(date) : (0, $afa71c803d1c325c$export$2e2bcd8739ae039)(date, options);
        var existingWeek = result.find(function(value) {
            return value.weekNumber === weekNumber;
        });
        if (existingWeek) {
            existingWeek.dates.push(date);
            return result;
        }
        result.push({
            weekNumber: weekNumber,
            dates: [
                date
            ]
        });
        return result;
    }, []);
    return weeksInMonth;
}
/**
 * Return the weeks belonging to the given month, adding the "outside days" to
 * the first and last week.
 */ function $89da45f89b022bca$var$getMonthWeeks(month, options) {
    var weeksInMonth = $89da45f89b022bca$var$daysToMonthWeeks((0, $456b685109e85eeb$export$2e2bcd8739ae039)(month), (0, $dde476f98780dbbe$export$2e2bcd8739ae039)(month), options);
    if (options === null || options === void 0 ? void 0 : options.useFixedWeeks) {
        // Add extra weeks to the month, up to 6 weeks
        var nrOfMonthWeeks = (0, $65346f75b9bc392d$export$2e2bcd8739ae039)(month, options);
        if (nrOfMonthWeeks < 6) {
            var lastWeek = weeksInMonth[weeksInMonth.length - 1];
            var lastDate = lastWeek.dates[lastWeek.dates.length - 1];
            var toDate = (0, $af4693c3eab78194$export$2e2bcd8739ae039)(lastDate, 6 - nrOfMonthWeeks);
            var extraWeeks = $89da45f89b022bca$var$daysToMonthWeeks((0, $af4693c3eab78194$export$2e2bcd8739ae039)(lastDate, 1), toDate, options);
            weeksInMonth.push.apply(weeksInMonth, extraWeeks);
        }
    }
    return weeksInMonth;
}
/** Render the table with the calendar. */ function $89da45f89b022bca$var$Table(props) {
    var _a, _b, _c;
    var _d = $89da45f89b022bca$export$332e9e0d64b1f294(), locale = _d.locale, classNames = _d.classNames, styles = _d.styles, hideHead = _d.hideHead, fixedWeeks = _d.fixedWeeks, components = _d.components, weekStartsOn = _d.weekStartsOn, firstWeekContainsDate = _d.firstWeekContainsDate, ISOWeek = _d.ISOWeek;
    var weeks = $89da45f89b022bca$var$getMonthWeeks(props.displayMonth, {
        useFixedWeeks: Boolean(fixedWeeks),
        ISOWeek: ISOWeek,
        locale: locale,
        weekStartsOn: weekStartsOn,
        firstWeekContainsDate: firstWeekContainsDate
    });
    var HeadComponent = (_a = components === null || components === void 0 ? void 0 : components.Head) !== null && _a !== void 0 ? _a : $89da45f89b022bca$export$e93312b7773dfcac;
    var RowComponent = (_b = components === null || components === void 0 ? void 0 : components.Row) !== null && _b !== void 0 ? _b : $89da45f89b022bca$export$b59bdbef9ce70de2;
    var FooterComponent = (_c = components === null || components === void 0 ? void 0 : components.Footer) !== null && _c !== void 0 ? _c : $89da45f89b022bca$export$a06f1c675e846f6f;
    return $89da45f89b022bca$var$jsxRuntimeExports.jsxs("table", $89da45f89b022bca$var$__assign({
        id: props.id,
        className: classNames.table,
        style: styles.table,
        role: "grid",
        "aria-labelledby": props["aria-labelledby"]
    }, {
        children: [
            !hideHead && $89da45f89b022bca$var$jsxRuntimeExports.jsx(HeadComponent, {}),
            $89da45f89b022bca$var$jsxRuntimeExports.jsx("tbody", $89da45f89b022bca$var$__assign({
                className: classNames.tbody,
                style: styles.tbody
            }, {
                children: weeks.map(function(week) {
                    return $89da45f89b022bca$var$jsxRuntimeExports.jsx(RowComponent, {
                        displayMonth: props.displayMonth,
                        dates: week.dates,
                        weekNumber: week.weekNumber
                    }, week.weekNumber);
                })
            })),
            $89da45f89b022bca$var$jsxRuntimeExports.jsx(FooterComponent, {
                displayMonth: props.displayMonth
            })
        ]
    }));
}
/*
The MIT License (MIT)

Copyright (c) 2018-present, React Training LLC

Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
*/ /* eslint-disable prefer-const */ /* eslint-disable @typescript-eslint/ban-ts-comment */ /*
 * Welcome to @reach/auto-id!
 * Let's see if we can make sense of why this hook exists and its
 * implementation.
 *
 * Some background:
 *   1. Accessibility APIs rely heavily on element IDs
 *   2. Requiring developers to put IDs on every element in Reach UI is both
 *      cumbersome and error-prone
 *   3. With a component model, we can generate IDs for them!
 *
 * Solution 1: Generate random IDs.
 *
 * This works great as long as you don't server render your app. When React (in
 * the client) tries to reuse the markup from the server, the IDs won't match
 * and React will then recreate the entire DOM tree.
 *
 * Solution 2: Increment an integer
 *
 * This sounds great. Since we're rendering the exact same tree on the server
 * and client, we can increment a counter and get a deterministic result between
 * client and server. Also, JS integers can go up to nine-quadrillion. I'm
 * pretty sure the tab will be closed before an app never needs
 * 10 quadrillion IDs!
 *
 * Problem solved, right?
 *
 * Ah, but there's a catch! React's concurrent rendering makes this approach
 * non-deterministic. While the client and server will end up with the same
 * elements in the end, depending on suspense boundaries (and possibly some user
 * input during the initial render) the incrementing integers won't always match
 * up.
 *
 * Solution 3: Don't use IDs at all on the server; patch after first render.
 *
 * What we've done here is solution 2 with some tricks. With this approach, the
 * ID returned is an empty string on the first render. This way the server and
 * client have the same markup no matter how wild the concurrent rendering may
 * have gotten.
 *
 * After the render, we patch up the components with an incremented ID. This
 * causes a double render on any components with `useId`. Shouldn't be a problem
 * since the components using this hook should be small, and we're only updating
 * the ID attribute on the DOM, nothing big is happening.
 *
 * It doesn't have to be an incremented number, though--we could do generate
 * random strings instead, but incrementing a number is probably the cheapest
 * thing we can do.
 *
 * Additionally, we only do this patchup on the very first client render ever.
 * Any calls to `useId` that happen dynamically in the client will be
 * populated immediately with a value. So, we only get the double render after
 * server hydration and never again, SO BACK OFF ALRIGHT?
 */ function $89da45f89b022bca$var$canUseDOM() {
    return !!(typeof window !== "undefined" && window.document && window.document.createElement);
}
/**
 * React currently throws a warning when using useLayoutEffect on the server. To
 * get around it, we can conditionally useEffect on the server (no-op) and
 * useLayoutEffect in the browser. We occasionally need useLayoutEffect to
 * ensure we don't get a render flash for certain operations, but we may also
 * need affected components to render on the server. One example is when setting
 * a component's descendants to retrieve their index values.
 *
 * Important to note that using this hook as an escape hatch will break the
 * eslint dependency warnings unless you rename the import to `useLayoutEffect`.
 * Use sparingly only when the effect won't effect the rendered HTML to avoid
 * any server/client mismatch.
 *
 * If a useLayoutEffect is needed and the result would create a mismatch, it's
 * likely that the component in question shouldn't be rendered on the server at
 * all, so a better approach would be to lazily render those in a parent
 * component after client-side hydration.
 *
 * https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
 * https://github.com/reduxjs/react-redux/blob/master/src/utils/useIsomorphicLayoutEffect.js
 *
 * @param effect
 * @param deps
 */ var $89da45f89b022bca$var$useIsomorphicLayoutEffect = $89da45f89b022bca$var$canUseDOM() ? (0, $b6HlZ.useLayoutEffect) : (0, $b6HlZ.useEffect);
var $89da45f89b022bca$var$serverHandoffComplete = false;
var $89da45f89b022bca$var$id = 0;
function $89da45f89b022bca$var$genId() {
    return "react-day-picker-".concat(++$89da45f89b022bca$var$id);
}
function $89da45f89b022bca$var$useId(providedId) {
    // TODO: Remove error flag when updating internal deps to React 18. None of
    // our tricks will play well with concurrent rendering anyway.
    var _a;
    // If this instance isn't part of the initial render, we don't have to do the
    // double render/patch-up dance. We can just generate the ID and return it.
    var initialId = providedId !== null && providedId !== void 0 ? providedId : $89da45f89b022bca$var$serverHandoffComplete ? $89da45f89b022bca$var$genId() : null;
    var _b = (0, $b6HlZ.useState)(initialId), id = _b[0], setId = _b[1];
    $89da45f89b022bca$var$useIsomorphicLayoutEffect(function() {
        if (id === null) // Patch the ID after render. We do this in `useLayoutEffect` to avoid any
        // rendering flicker, though it'll make the first render slower (unlikely
        // to matter, but you're welcome to measure your app and let us know if
        // it's a problem).
        setId($89da45f89b022bca$var$genId());
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $b6HlZ.useEffect)(function() {
        if ($89da45f89b022bca$var$serverHandoffComplete === false) // Flag all future uses of `useId` to skip the update dance. This is in
        // `useEffect` because it goes after `useLayoutEffect`, ensuring we don't
        // accidentally bail out of the patch-up dance prematurely.
        $89da45f89b022bca$var$serverHandoffComplete = true;
    }, []);
    return (_a = providedId !== null && providedId !== void 0 ? providedId : id) !== null && _a !== void 0 ? _a : undefined;
}
/** Render a month. */ function $89da45f89b022bca$var$Month(props) {
    var _a;
    var _b;
    var dayPicker = $89da45f89b022bca$export$332e9e0d64b1f294();
    var dir = dayPicker.dir, classNames = dayPicker.classNames, styles = dayPicker.styles, components = dayPicker.components;
    var displayMonths = $89da45f89b022bca$export$d0fd4b7106de2769().displayMonths;
    var captionId = $89da45f89b022bca$var$useId(dayPicker.id ? "".concat(dayPicker.id, "-").concat(props.displayIndex) : undefined);
    var tableId = dayPicker.id ? "".concat(dayPicker.id, "-grid-").concat(props.displayIndex) : undefined;
    var className = [
        classNames.month
    ];
    var style = styles.month;
    var isStart = props.displayIndex === 0;
    var isEnd = props.displayIndex === displayMonths.length - 1;
    var isCenter = !isStart && !isEnd;
    if (dir === "rtl") _a = [
        isStart,
        isEnd
    ], isEnd = _a[0], isStart = _a[1];
    if (isStart) {
        className.push(classNames.caption_start);
        style = $89da45f89b022bca$var$__assign($89da45f89b022bca$var$__assign({}, style), styles.caption_start);
    }
    if (isEnd) {
        className.push(classNames.caption_end);
        style = $89da45f89b022bca$var$__assign($89da45f89b022bca$var$__assign({}, style), styles.caption_end);
    }
    if (isCenter) {
        className.push(classNames.caption_between);
        style = $89da45f89b022bca$var$__assign($89da45f89b022bca$var$__assign({}, style), styles.caption_between);
    }
    var CaptionComponent = (_b = components === null || components === void 0 ? void 0 : components.Caption) !== null && _b !== void 0 ? _b : $89da45f89b022bca$export$32fbfacc5d962e0c;
    return $89da45f89b022bca$var$jsxRuntimeExports.jsxs("div", $89da45f89b022bca$var$__assign({
        className: className.join(" "),
        style: style
    }, {
        children: [
            $89da45f89b022bca$var$jsxRuntimeExports.jsx(CaptionComponent, {
                id: captionId,
                displayMonth: props.displayMonth,
                displayIndex: props.displayIndex
            }),
            $89da45f89b022bca$var$jsxRuntimeExports.jsx($89da45f89b022bca$var$Table, {
                id: tableId,
                "aria-labelledby": captionId,
                displayMonth: props.displayMonth
            })
        ]
    }), props.displayIndex);
}
/**
 * Render the wrapper for the month grids.
 */ function $89da45f89b022bca$export$a0ec4efdb90fa181(props) {
    var _a = $89da45f89b022bca$export$332e9e0d64b1f294(), classNames = _a.classNames, styles = _a.styles;
    return $89da45f89b022bca$var$jsxRuntimeExports.jsx("div", $89da45f89b022bca$var$__assign({
        className: classNames.months,
        style: styles.months
    }, {
        children: props.children
    }));
}
/** Render the container with the months according to the number of months to display. */ function $89da45f89b022bca$var$Root(_a) {
    var _b, _c;
    var initialProps = _a.initialProps;
    var dayPicker = $89da45f89b022bca$export$332e9e0d64b1f294();
    var focusContext = $89da45f89b022bca$export$69130071837c676e();
    var navigation = $89da45f89b022bca$export$d0fd4b7106de2769();
    var _d = (0, $b6HlZ.useState)(false), hasInitialFocus = _d[0], setHasInitialFocus = _d[1];
    // Focus the focus target when initialFocus is passed in
    (0, $b6HlZ.useEffect)(function() {
        if (!dayPicker.initialFocus) return;
        if (!focusContext.focusTarget) return;
        if (hasInitialFocus) return;
        focusContext.focus(focusContext.focusTarget);
        setHasInitialFocus(true);
    }, [
        dayPicker.initialFocus,
        hasInitialFocus,
        focusContext.focus,
        focusContext.focusTarget,
        focusContext
    ]);
    // Apply classnames according to props
    var classNames = [
        dayPicker.classNames.root,
        dayPicker.className
    ];
    if (dayPicker.numberOfMonths > 1) classNames.push(dayPicker.classNames.multiple_months);
    if (dayPicker.showWeekNumber) classNames.push(dayPicker.classNames.with_weeknumber);
    var style = $89da45f89b022bca$var$__assign($89da45f89b022bca$var$__assign({}, dayPicker.styles.root), dayPicker.style);
    var dataAttributes = Object.keys(initialProps).filter(function(key) {
        return key.startsWith("data-");
    }).reduce(function(attrs, key) {
        var _a;
        return $89da45f89b022bca$var$__assign($89da45f89b022bca$var$__assign({}, attrs), (_a = {}, _a[key] = initialProps[key], _a));
    }, {});
    var MonthsComponent = (_c = (_b = initialProps.components) === null || _b === void 0 ? void 0 : _b.Months) !== null && _c !== void 0 ? _c : $89da45f89b022bca$export$a0ec4efdb90fa181;
    return $89da45f89b022bca$var$jsxRuntimeExports.jsx("div", $89da45f89b022bca$var$__assign({
        className: classNames.join(" "),
        style: style,
        dir: dayPicker.dir,
        id: dayPicker.id,
        nonce: initialProps.nonce,
        title: initialProps.title,
        lang: initialProps.lang
    }, dataAttributes, {
        children: $89da45f89b022bca$var$jsxRuntimeExports.jsx(MonthsComponent, {
            children: navigation.displayMonths.map(function(month, i) {
                return $89da45f89b022bca$var$jsxRuntimeExports.jsx($89da45f89b022bca$var$Month, {
                    displayIndex: i,
                    displayMonth: month
                }, i);
            })
        })
    }));
}
/** Provide the value for all the context providers. */ function $89da45f89b022bca$export$8f349d07558f59c4(props) {
    var children = props.children, initialProps = $89da45f89b022bca$var$__rest(props, [
        "children"
    ]);
    return $89da45f89b022bca$var$jsxRuntimeExports.jsx($89da45f89b022bca$export$a84f964d022d25c, $89da45f89b022bca$var$__assign({
        initialProps: initialProps
    }, {
        children: $89da45f89b022bca$var$jsxRuntimeExports.jsx($89da45f89b022bca$export$d91daf425539f32f, {
            children: $89da45f89b022bca$var$jsxRuntimeExports.jsx($89da45f89b022bca$export$d40a11a5bbe785ba, $89da45f89b022bca$var$__assign({
                initialProps: initialProps
            }, {
                children: $89da45f89b022bca$var$jsxRuntimeExports.jsx($89da45f89b022bca$export$913827019032c8d4, $89da45f89b022bca$var$__assign({
                    initialProps: initialProps
                }, {
                    children: $89da45f89b022bca$var$jsxRuntimeExports.jsx($89da45f89b022bca$export$deb49a47c7ee5fdf, $89da45f89b022bca$var$__assign({
                        initialProps: initialProps
                    }, {
                        children: $89da45f89b022bca$var$jsxRuntimeExports.jsx($89da45f89b022bca$var$ModifiersProvider, {
                            children: $89da45f89b022bca$var$jsxRuntimeExports.jsx($89da45f89b022bca$export$97cf4ab9b312b61a, {
                                children: children
                            })
                        })
                    }))
                }))
            }))
        })
    }));
}
/**
 * DayPicker render a date picker component to let users pick dates from a
 * calendar. See http://react-day-picker.js.org for updated documentation and
 * examples.
 *
 * ### Customization
 *
 * DayPicker offers different customization props. For example,
 *
 * - show multiple months using `numberOfMonths`
 * - display a dropdown to navigate the months via `captionLayout`
 * - display the week numbers with `showWeekNumbers`
 * - disable or hide days with `disabled` or `hidden`
 *
 * ### Controlling the months
 *
 * Change the initially displayed month using the `defaultMonth` prop. The
 * displayed months are controlled by DayPicker and stored in its internal
 * state. To control the months yourself, use `month` instead of `defaultMonth`
 * and use the `onMonthChange` event to set it.
 *
 * To limit the months the user can navigate to, use
 * `fromDate`/`fromMonth`/`fromYear` or `toDate`/`toMonth`/`toYear`.
 *
 * ### Selection modes
 *
 * DayPicker supports different selection mode that can be toggled using the
 * `mode` prop:
 *
 * - `mode="single"`: only one day can be selected. Use `required` to make the
 *   selection required. Use the `onSelect` event handler to get the selected
 *   days.
 * - `mode="multiple"`: users can select one or more days. Limit the amount of
 *   days that can be selected with the `min` or the `max` props.
 * - `mode="range"`: users can select a range of days. Limit the amount of days
 *   in the range with the `min` or the `max` props.
 * - `mode="default"` (default): the built-in selections are disabled. Implement
 *   your own selection mode with `onDayClick`.
 *
 * The selection modes should cover the most common use cases. In case you
 * need a more refined way of selecting days, use `mode="default"`. Use the
 * `selected` props and add the day event handlers to add/remove days from the
 * selection.
 *
 * ### Modifiers
 *
 * A _modifier_ represents different styles or states for the days displayed in
 * the calendar (like "selected" or "disabled"). Define custom modifiers using
 * the `modifiers` prop.
 *
 * ### Formatters and custom component
 *
 * You can customize how the content is displayed in the date picker by using
 * either the formatters or replacing the internal components.
 *
 * For the most common cases you want to use the `formatters` prop to change how
 * the content is formatted in the calendar. Use the `components` prop to
 * replace the internal components, like the navigation icons.
 *
 * ### Styling
 *
 * DayPicker comes with a default, basic style in `react-day-picker/style` – use
 * it as template for your own style.
 *
 * If you are using CSS modules, pass the imported styles object the
 * `classNames` props.
 *
 * You can also style the elements via inline styles using the `styles` prop.
 *
 * ### Form fields
 *
 * If you need to bind the date picker to a form field, you can use the
 * `useInput` hooks for a basic behavior. See the `useInput` source as an
 * example to bind the date picker with form fields.
 *
 * ### Localization
 *
 * To localize DayPicker, import the locale from `date-fns` package and use the
 * `locale` prop.
 *
 * For example, to use Spanish locale:
 *
 * ```
 * import { es } from 'date-fns/locale';
 * <DayPicker locale={es} />
 * ```
 */ function $89da45f89b022bca$export$97e6db89a86ff7ab(props) {
    return $89da45f89b022bca$var$jsxRuntimeExports.jsx($89da45f89b022bca$export$8f349d07558f59c4, $89da45f89b022bca$var$__assign({}, props, {
        children: $89da45f89b022bca$var$jsxRuntimeExports.jsx($89da45f89b022bca$var$Root, {
            initialProps: props
        })
    }));
}
/** @private */ function $89da45f89b022bca$var$isValidDate(day) {
    return !isNaN(day.getTime());
}
/** Return props and setters for binding an input field to DayPicker. */ function $89da45f89b022bca$export$1e36b9f257eee5fa(options) {
    if (options === void 0) options = {};
    var _a = options.locale, locale = _a === void 0 ? (0, $b0hzc.default) : _a, required = options.required, _b = options.format, format$1 = _b === void 0 ? "PP" : _b, defaultSelected = options.defaultSelected, _c = options.today, today = _c === void 0 ? new Date() : _c;
    var _d = $89da45f89b022bca$var$parseFromToProps(options), fromDate = _d.fromDate, toDate = _d.toDate;
    // Shortcut to the DateFns functions
    var parseValue = function(value) {
        return (0, $9sLUZ.default)(value, format$1, today, {
            locale: locale
        });
    };
    // Initialize states
    var _e = (0, $b6HlZ.useState)(defaultSelected !== null && defaultSelected !== void 0 ? defaultSelected : today), month = _e[0], setMonth = _e[1];
    var _f = (0, $b6HlZ.useState)(defaultSelected), selectedDay = _f[0], setSelectedDay = _f[1];
    var defaultInputValue = defaultSelected ? (0, $8a568d5cdba66624$export$2e2bcd8739ae039)(defaultSelected, format$1, {
        locale: locale
    }) : "";
    var _g = (0, $b6HlZ.useState)(defaultInputValue), inputValue = _g[0], setInputValue = _g[1];
    var reset = function() {
        setSelectedDay(defaultSelected);
        setMonth(defaultSelected !== null && defaultSelected !== void 0 ? defaultSelected : today);
        setInputValue(defaultInputValue !== null && defaultInputValue !== void 0 ? defaultInputValue : "");
    };
    var setSelected = function(date) {
        setSelectedDay(date);
        setMonth(date !== null && date !== void 0 ? date : today);
        setInputValue(date ? (0, $8a568d5cdba66624$export$2e2bcd8739ae039)(date, format$1, {
            locale: locale
        }) : "");
    };
    var handleDayClick = function(day, _a) {
        var selected = _a.selected;
        if (!required && selected) {
            setSelectedDay(undefined);
            setInputValue("");
            return;
        }
        setSelectedDay(day);
        setInputValue(day ? (0, $8a568d5cdba66624$export$2e2bcd8739ae039)(day, format$1, {
            locale: locale
        }) : "");
    };
    var handleMonthChange = function(month) {
        setMonth(month);
    };
    // When changing the input field, save its value in state and check if the
    // string is a valid date. If it is a valid day, set it as selected and update
    // the calendar’s month.
    var handleChange = function(e) {
        setInputValue(e.target.value);
        var day = parseValue(e.target.value);
        var isBefore = fromDate && (0, $bc9a368e85fd9df6$export$2e2bcd8739ae039)(fromDate, day) > 0;
        var isAfter = toDate && (0, $bc9a368e85fd9df6$export$2e2bcd8739ae039)(day, toDate) > 0;
        if (!$89da45f89b022bca$var$isValidDate(day) || isBefore || isAfter) {
            setSelectedDay(undefined);
            return;
        }
        setSelectedDay(day);
        setMonth(day);
    };
    // Special case for _required_ fields: on blur, if the value of the input is not
    // a valid date, reset the calendar and the input value.
    var handleBlur = function(e) {
        var day = parseValue(e.target.value);
        if (!$89da45f89b022bca$var$isValidDate(day)) reset();
    };
    // When focusing, make sure DayPicker visualizes the month of the date in the
    // input field.
    var handleFocus = function(e) {
        if (!e.target.value) {
            reset();
            return;
        }
        var day = parseValue(e.target.value);
        if ($89da45f89b022bca$var$isValidDate(day)) setMonth(day);
    };
    var dayPickerProps = {
        month: month,
        onDayClick: handleDayClick,
        onMonthChange: handleMonthChange,
        selected: selectedDay,
        locale: locale,
        fromDate: fromDate,
        toDate: toDate,
        today: today
    };
    var inputProps = {
        onBlur: handleBlur,
        onChange: handleChange,
        onFocus: handleFocus,
        value: inputValue,
        placeholder: (0, $8a568d5cdba66624$export$2e2bcd8739ae039)(new Date(), format$1, {
            locale: locale
        })
    };
    return {
        dayPickerProps: dayPickerProps,
        inputProps: inputProps,
        reset: reset,
        setSelected: setSelected
    };
}
/** Returns true when the props are of type {@link DayPickerDefaultProps}. */ function $89da45f89b022bca$export$92cab9761365b1ec(props) {
    return props.mode === undefined || props.mode === "default";
}



var $iXpG9 = parcelRequire("iXpG9");
var $9dcc616f2d1487ee$var$name = "firebase";
var $9dcc616f2d1487ee$var$version = "9.8.3";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (0, $iXpG9.registerVersion)($9dcc616f2d1487ee$var$name, $9dcc616f2d1487ee$var$version, "app");


var $iXpG9 = parcelRequire("iXpG9");

var $a5a6fab2525fdce6$exports = {};




!function(e, t) {
    $a5a6fab2525fdce6$exports = t((parcelRequire("b6HlZ")), (parcelRequire("cyuoq")), (parcelRequire("ehmfL")), (parcelRequire("8vofH")));
}(self, (e, t, a, n)=>(()=>{
        "use strict";
        var r = {
            703: (e)=>{
                e.exports = a;
            },
            462: (e)=>{
                e.exports = n;
            },
            156: (t)=>{
                t.exports = e;
            },
            369: (e)=>{
                e.exports = t;
            }
        }, o = {};
        function i(e) {
            var t = o[e];
            if (void 0 !== t) return t.exports;
            var a = o[e] = {
                exports: {}
            };
            return r[e](a, a.exports, i), a.exports;
        }
        i.n = (e)=>{
            var t = e && e.__esModule ? ()=>e.default : ()=>e;
            return i.d(t, {
                a: t
            }), t;
        }, i.d = (e, t)=>{
            for(var a in t)i.o(t, a) && !i.o(e, a) && Object.defineProperty(e, a, {
                enumerable: !0,
                get: t[a]
            });
        }, i.o = (e, t)=>Object.prototype.hasOwnProperty.call(e, t), i.r = (e)=>{
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(e, "__esModule", {
                value: !0
            });
        };
        var l = {};
        return (()=>{
            i.r(l), i.d(l, {
                Errors: ()=>s,
                Helpers: ()=>r,
                Icons: ()=>t,
                Login: ()=>a,
                Overview: ()=>e,
                PartnerBilling: ()=>o
            });
            var e = {};
            i.r(e), i.d(e, {
                OverviewView: ()=>re
            });
            var t = {};
            i.r(t), i.d(t, {
                CheckSolid: ()=>he,
                EyeOffSolid: ()=>fe,
                InboxInSolid: ()=>xe,
                LoadingSolid: ()=>me,
                LogOutOutline: ()=>Ee,
                MailSolid: ()=>Ae,
                StatusOffline: ()=>pe,
                StatusOnline: ()=>be,
                Trash: ()=>we
            });
            var a = {};
            i.r(a), i.d(a, {
                EmailLogin: ()=>Te,
                EmailSignIn: ()=>Ne,
                Login: ()=>ke
            });
            var n = {};
            i.r(n), i.d(n, {
                formatAmountInCents: ()=>Se,
                formatShortDate: ()=>Oe
            });
            var r = {};
            i.r(r), i.d(r, {
                Formatters: ()=>De,
                fetchPartnersForUser: ()=>Ye,
                getFirebaseConfig: ()=>We,
                isFlexdayStaff: ()=>Ue
            });
            var o = {};
            i.r(o), i.d(o, {
                Report: ()=>Fe
            });
            var s = {};
            i.r(s), i.d(s, {
                Errors: ()=>je
            });
            var c = i(156), u = i.n(c);
            function d(e) {
                return d = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                    return typeof e;
                } : function(e) {
                    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                }, d(e);
            }
            function m(e, t) {
                if (t.length < e) throw new TypeError(e + " argument" + (e > 1 ? "s" : "") + " required, but only " + t.length + " present");
            }
            function f(e) {
                m(1, arguments);
                var t = Object.prototype.toString.call(e);
                return e instanceof Date || "object" === d(e) && "[object Date]" === t ? new Date(e.getTime()) : "number" == typeof e || "[object Number]" === t ? new Date(e) : ("string" != typeof e && "[object String]" !== t || "undefined" == typeof console || (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"), console.warn((new Error).stack)), new Date(NaN));
            }
            function h(e) {
                if (null === e || !0 === e || !1 === e) return NaN;
                var t = Number(e);
                return isNaN(t) ? t : t < 0 ? Math.ceil(t) : Math.floor(t);
            }
            function g(e) {
                m(1, arguments);
                var t = f(e), a = t.getUTCDay(), n = (a < 1 ? 7 : 0) + a - 1;
                return t.setUTCDate(t.getUTCDate() - n), t.setUTCHours(0, 0, 0, 0), t;
            }
            function v(e) {
                m(1, arguments);
                var t = f(e), a = t.getUTCFullYear(), n = new Date(0);
                n.setUTCFullYear(a + 1, 0, 4), n.setUTCHours(0, 0, 0, 0);
                var r = g(n), o = new Date(0);
                o.setUTCFullYear(a, 0, 4), o.setUTCHours(0, 0, 0, 0);
                var i = g(o);
                return t.getTime() >= r.getTime() ? a + 1 : t.getTime() >= i.getTime() ? a : a - 1;
            }
            var b = {};
            function p() {
                return b;
            }
            function w(e, t) {
                var a, n, r, o, i, l, s, c;
                m(1, arguments);
                var u = p(), d = h(null !== (a = null !== (n = null !== (r = null !== (o = null == t ? void 0 : t.weekStartsOn) && void 0 !== o ? o : null == t || null === (i = t.locale) || void 0 === i || null === (l = i.options) || void 0 === l ? void 0 : l.weekStartsOn) && void 0 !== r ? r : u.weekStartsOn) && void 0 !== n ? n : null === (s = u.locale) || void 0 === s || null === (c = s.options) || void 0 === c ? void 0 : c.weekStartsOn) && void 0 !== a ? a : 0);
                if (!(d >= 0 && d <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
                var g = f(e), v = g.getUTCDay(), b = (v < d ? 7 : 0) + v - d;
                return g.setUTCDate(g.getUTCDate() - b), g.setUTCHours(0, 0, 0, 0), g;
            }
            function E(e, t) {
                var a, n, r, o, i, l, s, c;
                m(1, arguments);
                var u = f(e), d = u.getUTCFullYear(), g = p(), v = h(null !== (a = null !== (n = null !== (r = null !== (o = null == t ? void 0 : t.firstWeekContainsDate) && void 0 !== o ? o : null == t || null === (i = t.locale) || void 0 === i || null === (l = i.options) || void 0 === l ? void 0 : l.firstWeekContainsDate) && void 0 !== r ? r : g.firstWeekContainsDate) && void 0 !== n ? n : null === (s = g.locale) || void 0 === s || null === (c = s.options) || void 0 === c ? void 0 : c.firstWeekContainsDate) && void 0 !== a ? a : 1);
                if (!(v >= 1 && v <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
                var b = new Date(0);
                b.setUTCFullYear(d + 1, 0, v), b.setUTCHours(0, 0, 0, 0);
                var E = w(b, t), A = new Date(0);
                A.setUTCFullYear(d, 0, v), A.setUTCHours(0, 0, 0, 0);
                var x = w(A, t);
                return u.getTime() >= E.getTime() ? d + 1 : u.getTime() >= x.getTime() ? d : d - 1;
            }
            function A(e, t) {
                for(var a = e < 0 ? "-" : "", n = Math.abs(e).toString(); n.length < t;)n = "0" + n;
                return a + n;
            }
            const x = function(e, t) {
                var a = e.getUTCFullYear(), n = a > 0 ? a : 1 - a;
                return A("yy" === t ? n % 100 : n, t.length);
            }, y = function(e, t) {
                var a = e.getUTCMonth();
                return "M" === t ? String(a + 1) : A(a + 1, 2);
            }, C = function(e, t) {
                return A(e.getUTCDate(), t.length);
            }, M = function(e, t) {
                return A(e.getUTCHours() % 12 || 12, t.length);
            }, T = function(e, t) {
                return A(e.getUTCHours(), t.length);
            }, N = function(e, t) {
                return A(e.getUTCMinutes(), t.length);
            }, k = function(e, t) {
                return A(e.getUTCSeconds(), t.length);
            }, P = function(e, t) {
                var a = t.length, n = e.getUTCMilliseconds();
                return A(Math.floor(n * Math.pow(10, a - 3)), t.length);
            };
            var S = {
                G: function(e, t, a) {
                    var n = e.getUTCFullYear() > 0 ? 1 : 0;
                    switch(t){
                        case "G":
                        case "GG":
                        case "GGG":
                            return a.era(n, {
                                width: "abbreviated"
                            });
                        case "GGGGG":
                            return a.era(n, {
                                width: "narrow"
                            });
                        default:
                            return a.era(n, {
                                width: "wide"
                            });
                    }
                },
                y: function(e, t, a) {
                    if ("yo" === t) {
                        var n = e.getUTCFullYear(), r = n > 0 ? n : 1 - n;
                        return a.ordinalNumber(r, {
                            unit: "year"
                        });
                    }
                    return x(e, t);
                },
                Y: function(e, t, a, n) {
                    var r = E(e, n), o = r > 0 ? r : 1 - r;
                    return "YY" === t ? A(o % 100, 2) : "Yo" === t ? a.ordinalNumber(o, {
                        unit: "year"
                    }) : A(o, t.length);
                },
                R: function(e, t) {
                    return A(v(e), t.length);
                },
                u: function(e, t) {
                    return A(e.getUTCFullYear(), t.length);
                },
                Q: function(e, t, a) {
                    var n = Math.ceil((e.getUTCMonth() + 1) / 3);
                    switch(t){
                        case "Q":
                            return String(n);
                        case "QQ":
                            return A(n, 2);
                        case "Qo":
                            return a.ordinalNumber(n, {
                                unit: "quarter"
                            });
                        case "QQQ":
                            return a.quarter(n, {
                                width: "abbreviated",
                                context: "formatting"
                            });
                        case "QQQQQ":
                            return a.quarter(n, {
                                width: "narrow",
                                context: "formatting"
                            });
                        default:
                            return a.quarter(n, {
                                width: "wide",
                                context: "formatting"
                            });
                    }
                },
                q: function(e, t, a) {
                    var n = Math.ceil((e.getUTCMonth() + 1) / 3);
                    switch(t){
                        case "q":
                            return String(n);
                        case "qq":
                            return A(n, 2);
                        case "qo":
                            return a.ordinalNumber(n, {
                                unit: "quarter"
                            });
                        case "qqq":
                            return a.quarter(n, {
                                width: "abbreviated",
                                context: "standalone"
                            });
                        case "qqqqq":
                            return a.quarter(n, {
                                width: "narrow",
                                context: "standalone"
                            });
                        default:
                            return a.quarter(n, {
                                width: "wide",
                                context: "standalone"
                            });
                    }
                },
                M: function(e, t, a) {
                    var n = e.getUTCMonth();
                    switch(t){
                        case "M":
                        case "MM":
                            return y(e, t);
                        case "Mo":
                            return a.ordinalNumber(n + 1, {
                                unit: "month"
                            });
                        case "MMM":
                            return a.month(n, {
                                width: "abbreviated",
                                context: "formatting"
                            });
                        case "MMMMM":
                            return a.month(n, {
                                width: "narrow",
                                context: "formatting"
                            });
                        default:
                            return a.month(n, {
                                width: "wide",
                                context: "formatting"
                            });
                    }
                },
                L: function(e, t, a) {
                    var n = e.getUTCMonth();
                    switch(t){
                        case "L":
                            return String(n + 1);
                        case "LL":
                            return A(n + 1, 2);
                        case "Lo":
                            return a.ordinalNumber(n + 1, {
                                unit: "month"
                            });
                        case "LLL":
                            return a.month(n, {
                                width: "abbreviated",
                                context: "standalone"
                            });
                        case "LLLLL":
                            return a.month(n, {
                                width: "narrow",
                                context: "standalone"
                            });
                        default:
                            return a.month(n, {
                                width: "wide",
                                context: "standalone"
                            });
                    }
                },
                w: function(e, t, a, n) {
                    var r = function(e, t) {
                        m(1, arguments);
                        var a = f(e), n = w(a, t).getTime() - (function(e, t) {
                            var a, n, r, o, i, l, s, c;
                            m(1, arguments);
                            var u = p(), d = h(null !== (a = null !== (n = null !== (r = null !== (o = null == t ? void 0 : t.firstWeekContainsDate) && void 0 !== o ? o : null == t || null === (i = t.locale) || void 0 === i || null === (l = i.options) || void 0 === l ? void 0 : l.firstWeekContainsDate) && void 0 !== r ? r : u.firstWeekContainsDate) && void 0 !== n ? n : null === (s = u.locale) || void 0 === s || null === (c = s.options) || void 0 === c ? void 0 : c.firstWeekContainsDate) && void 0 !== a ? a : 1), f = E(e, t), g = new Date(0);
                            return g.setUTCFullYear(f, 0, d), g.setUTCHours(0, 0, 0, 0), w(g, t);
                        })(a, t).getTime();
                        return Math.round(n / 6048e5) + 1;
                    }(e, n);
                    return "wo" === t ? a.ordinalNumber(r, {
                        unit: "week"
                    }) : A(r, t.length);
                },
                I: function(e, t, a) {
                    var n = function(e) {
                        m(1, arguments);
                        var t = f(e), a = g(t).getTime() - (function(e) {
                            m(1, arguments);
                            var t = v(e), a = new Date(0);
                            return a.setUTCFullYear(t, 0, 4), a.setUTCHours(0, 0, 0, 0), g(a);
                        })(t).getTime();
                        return Math.round(a / 6048e5) + 1;
                    }(e);
                    return "Io" === t ? a.ordinalNumber(n, {
                        unit: "week"
                    }) : A(n, t.length);
                },
                d: function(e, t, a) {
                    return "do" === t ? a.ordinalNumber(e.getUTCDate(), {
                        unit: "date"
                    }) : C(e, t);
                },
                D: function(e, t, a) {
                    var n = function(e) {
                        m(1, arguments);
                        var t = f(e), a = t.getTime();
                        t.setUTCMonth(0, 1), t.setUTCHours(0, 0, 0, 0);
                        var n = a - t.getTime();
                        return Math.floor(n / 864e5) + 1;
                    }(e);
                    return "Do" === t ? a.ordinalNumber(n, {
                        unit: "dayOfYear"
                    }) : A(n, t.length);
                },
                E: function(e, t, a) {
                    var n = e.getUTCDay();
                    switch(t){
                        case "E":
                        case "EE":
                        case "EEE":
                            return a.day(n, {
                                width: "abbreviated",
                                context: "formatting"
                            });
                        case "EEEEE":
                            return a.day(n, {
                                width: "narrow",
                                context: "formatting"
                            });
                        case "EEEEEE":
                            return a.day(n, {
                                width: "short",
                                context: "formatting"
                            });
                        default:
                            return a.day(n, {
                                width: "wide",
                                context: "formatting"
                            });
                    }
                },
                e: function(e, t, a, n) {
                    var r = e.getUTCDay(), o = (r - n.weekStartsOn + 8) % 7 || 7;
                    switch(t){
                        case "e":
                            return String(o);
                        case "ee":
                            return A(o, 2);
                        case "eo":
                            return a.ordinalNumber(o, {
                                unit: "day"
                            });
                        case "eee":
                            return a.day(r, {
                                width: "abbreviated",
                                context: "formatting"
                            });
                        case "eeeee":
                            return a.day(r, {
                                width: "narrow",
                                context: "formatting"
                            });
                        case "eeeeee":
                            return a.day(r, {
                                width: "short",
                                context: "formatting"
                            });
                        default:
                            return a.day(r, {
                                width: "wide",
                                context: "formatting"
                            });
                    }
                },
                c: function(e, t, a, n) {
                    var r = e.getUTCDay(), o = (r - n.weekStartsOn + 8) % 7 || 7;
                    switch(t){
                        case "c":
                            return String(o);
                        case "cc":
                            return A(o, t.length);
                        case "co":
                            return a.ordinalNumber(o, {
                                unit: "day"
                            });
                        case "ccc":
                            return a.day(r, {
                                width: "abbreviated",
                                context: "standalone"
                            });
                        case "ccccc":
                            return a.day(r, {
                                width: "narrow",
                                context: "standalone"
                            });
                        case "cccccc":
                            return a.day(r, {
                                width: "short",
                                context: "standalone"
                            });
                        default:
                            return a.day(r, {
                                width: "wide",
                                context: "standalone"
                            });
                    }
                },
                i: function(e, t, a) {
                    var n = e.getUTCDay(), r = 0 === n ? 7 : n;
                    switch(t){
                        case "i":
                            return String(r);
                        case "ii":
                            return A(r, t.length);
                        case "io":
                            return a.ordinalNumber(r, {
                                unit: "day"
                            });
                        case "iii":
                            return a.day(n, {
                                width: "abbreviated",
                                context: "formatting"
                            });
                        case "iiiii":
                            return a.day(n, {
                                width: "narrow",
                                context: "formatting"
                            });
                        case "iiiiii":
                            return a.day(n, {
                                width: "short",
                                context: "formatting"
                            });
                        default:
                            return a.day(n, {
                                width: "wide",
                                context: "formatting"
                            });
                    }
                },
                a: function(e, t, a) {
                    var n = e.getUTCHours() / 12 >= 1 ? "pm" : "am";
                    switch(t){
                        case "a":
                        case "aa":
                            return a.dayPeriod(n, {
                                width: "abbreviated",
                                context: "formatting"
                            });
                        case "aaa":
                            return a.dayPeriod(n, {
                                width: "abbreviated",
                                context: "formatting"
                            }).toLowerCase();
                        case "aaaaa":
                            return a.dayPeriod(n, {
                                width: "narrow",
                                context: "formatting"
                            });
                        default:
                            return a.dayPeriod(n, {
                                width: "wide",
                                context: "formatting"
                            });
                    }
                },
                b: function(e, t, a) {
                    var n, r = e.getUTCHours();
                    switch(n = 12 === r ? "noon" : 0 === r ? "midnight" : r / 12 >= 1 ? "pm" : "am", t){
                        case "b":
                        case "bb":
                            return a.dayPeriod(n, {
                                width: "abbreviated",
                                context: "formatting"
                            });
                        case "bbb":
                            return a.dayPeriod(n, {
                                width: "abbreviated",
                                context: "formatting"
                            }).toLowerCase();
                        case "bbbbb":
                            return a.dayPeriod(n, {
                                width: "narrow",
                                context: "formatting"
                            });
                        default:
                            return a.dayPeriod(n, {
                                width: "wide",
                                context: "formatting"
                            });
                    }
                },
                B: function(e, t, a) {
                    var n, r = e.getUTCHours();
                    switch(n = r >= 17 ? "evening" : r >= 12 ? "afternoon" : r >= 4 ? "morning" : "night", t){
                        case "B":
                        case "BB":
                        case "BBB":
                            return a.dayPeriod(n, {
                                width: "abbreviated",
                                context: "formatting"
                            });
                        case "BBBBB":
                            return a.dayPeriod(n, {
                                width: "narrow",
                                context: "formatting"
                            });
                        default:
                            return a.dayPeriod(n, {
                                width: "wide",
                                context: "formatting"
                            });
                    }
                },
                h: function(e, t, a) {
                    if ("ho" === t) {
                        var n = e.getUTCHours() % 12;
                        return 0 === n && (n = 12), a.ordinalNumber(n, {
                            unit: "hour"
                        });
                    }
                    return M(e, t);
                },
                H: function(e, t, a) {
                    return "Ho" === t ? a.ordinalNumber(e.getUTCHours(), {
                        unit: "hour"
                    }) : T(e, t);
                },
                K: function(e, t, a) {
                    var n = e.getUTCHours() % 12;
                    return "Ko" === t ? a.ordinalNumber(n, {
                        unit: "hour"
                    }) : A(n, t.length);
                },
                k: function(e, t, a) {
                    var n = e.getUTCHours();
                    return 0 === n && (n = 24), "ko" === t ? a.ordinalNumber(n, {
                        unit: "hour"
                    }) : A(n, t.length);
                },
                m: function(e, t, a) {
                    return "mo" === t ? a.ordinalNumber(e.getUTCMinutes(), {
                        unit: "minute"
                    }) : N(e, t);
                },
                s: function(e, t, a) {
                    return "so" === t ? a.ordinalNumber(e.getUTCSeconds(), {
                        unit: "second"
                    }) : k(e, t);
                },
                S: function(e, t) {
                    return P(e, t);
                },
                X: function(e, t, a, n) {
                    var r = (n._originalDate || e).getTimezoneOffset();
                    if (0 === r) return "Z";
                    switch(t){
                        case "X":
                            return U(r);
                        case "XXXX":
                        case "XX":
                            return Y(r);
                        default:
                            return Y(r, ":");
                    }
                },
                x: function(e, t, a, n) {
                    var r = (n._originalDate || e).getTimezoneOffset();
                    switch(t){
                        case "x":
                            return U(r);
                        case "xxxx":
                        case "xx":
                            return Y(r);
                        default:
                            return Y(r, ":");
                    }
                },
                O: function(e, t, a, n) {
                    var r = (n._originalDate || e).getTimezoneOffset();
                    switch(t){
                        case "O":
                        case "OO":
                        case "OOO":
                            return "GMT" + O(r, ":");
                        default:
                            return "GMT" + Y(r, ":");
                    }
                },
                z: function(e, t, a, n) {
                    var r = (n._originalDate || e).getTimezoneOffset();
                    switch(t){
                        case "z":
                        case "zz":
                        case "zzz":
                            return "GMT" + O(r, ":");
                        default:
                            return "GMT" + Y(r, ":");
                    }
                },
                t: function(e, t, a, n) {
                    var r = n._originalDate || e;
                    return A(Math.floor(r.getTime() / 1e3), t.length);
                },
                T: function(e, t, a, n) {
                    return A((n._originalDate || e).getTime(), t.length);
                }
            };
            function O(e, t) {
                var a = e > 0 ? "-" : "+", n = Math.abs(e), r = Math.floor(n / 60), o = n % 60;
                if (0 === o) return a + String(r);
                var i = t || "";
                return a + String(r) + i + A(o, 2);
            }
            function U(e, t) {
                return e % 60 == 0 ? (e > 0 ? "-" : "+") + A(Math.abs(e) / 60, 2) : Y(e, t);
            }
            function Y(e, t) {
                var a = t || "", n = e > 0 ? "-" : "+", r = Math.abs(e);
                return n + A(Math.floor(r / 60), 2) + a + A(r % 60, 2);
            }
            const W = S;
            var D = function(e, t) {
                switch(e){
                    case "P":
                        return t.date({
                            width: "short"
                        });
                    case "PP":
                        return t.date({
                            width: "medium"
                        });
                    case "PPP":
                        return t.date({
                            width: "long"
                        });
                    default:
                        return t.date({
                            width: "full"
                        });
                }
            }, F = function(e, t) {
                switch(e){
                    case "p":
                        return t.time({
                            width: "short"
                        });
                    case "pp":
                        return t.time({
                            width: "medium"
                        });
                    case "ppp":
                        return t.time({
                            width: "long"
                        });
                    default:
                        return t.time({
                            width: "full"
                        });
                }
            }, j = {
                p: F,
                P: function(e, t) {
                    var a, n = e.match(/(P+)(p+)?/) || [], r = n[1], o = n[2];
                    if (!o) return D(e, t);
                    switch(r){
                        case "P":
                            a = t.dateTime({
                                width: "short"
                            });
                            break;
                        case "PP":
                            a = t.dateTime({
                                width: "medium"
                            });
                            break;
                        case "PPP":
                            a = t.dateTime({
                                width: "long"
                            });
                            break;
                        default:
                            a = t.dateTime({
                                width: "full"
                            });
                    }
                    return a.replace("{{date}}", D(r, t)).replace("{{time}}", F(o, t));
                }
            };
            const R = j;
            var I = [
                "D",
                "DD"
            ], V = [
                "YY",
                "YYYY"
            ];
            function H(e, t, a) {
                if ("YYYY" === e) throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(t, "`) for formatting years to the input `").concat(a, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
                if ("YY" === e) throw new RangeError("Use `yy` instead of `YY` (in `".concat(t, "`) for formatting years to the input `").concat(a, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
                if ("D" === e) throw new RangeError("Use `d` instead of `D` (in `".concat(t, "`) for formatting days of the month to the input `").concat(a, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
                if ("DD" === e) throw new RangeError("Use `dd` instead of `DD` (in `".concat(t, "`) for formatting days of the month to the input `").concat(a, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
            }
            var B = {
                lessThanXSeconds: {
                    one: "less than a second",
                    other: "less than {{count}} seconds"
                },
                xSeconds: {
                    one: "1 second",
                    other: "{{count}} seconds"
                },
                halfAMinute: "half a minute",
                lessThanXMinutes: {
                    one: "less than a minute",
                    other: "less than {{count}} minutes"
                },
                xMinutes: {
                    one: "1 minute",
                    other: "{{count}} minutes"
                },
                aboutXHours: {
                    one: "about 1 hour",
                    other: "about {{count}} hours"
                },
                xHours: {
                    one: "1 hour",
                    other: "{{count}} hours"
                },
                xDays: {
                    one: "1 day",
                    other: "{{count}} days"
                },
                aboutXWeeks: {
                    one: "about 1 week",
                    other: "about {{count}} weeks"
                },
                xWeeks: {
                    one: "1 week",
                    other: "{{count}} weeks"
                },
                aboutXMonths: {
                    one: "about 1 month",
                    other: "about {{count}} months"
                },
                xMonths: {
                    one: "1 month",
                    other: "{{count}} months"
                },
                aboutXYears: {
                    one: "about 1 year",
                    other: "about {{count}} years"
                },
                xYears: {
                    one: "1 year",
                    other: "{{count}} years"
                },
                overXYears: {
                    one: "over 1 year",
                    other: "over {{count}} years"
                },
                almostXYears: {
                    one: "almost 1 year",
                    other: "almost {{count}} years"
                }
            };
            function Q(e) {
                return function() {
                    var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, a = t.width ? String(t.width) : e.defaultWidth;
                    return e.formats[a] || e.formats[e.defaultWidth];
                };
            }
            var q, J = {
                date: Q({
                    formats: {
                        full: "EEEE, MMMM do, y",
                        long: "MMMM do, y",
                        medium: "MMM d, y",
                        short: "MM/dd/yyyy"
                    },
                    defaultWidth: "full"
                }),
                time: Q({
                    formats: {
                        full: "h:mm:ss a zzzz",
                        long: "h:mm:ss a z",
                        medium: "h:mm:ss a",
                        short: "h:mm a"
                    },
                    defaultWidth: "full"
                }),
                dateTime: Q({
                    formats: {
                        full: "{{date}} 'at' {{time}}",
                        long: "{{date}} 'at' {{time}}",
                        medium: "{{date}}, {{time}}",
                        short: "{{date}}, {{time}}"
                    },
                    defaultWidth: "full"
                })
            }, z = {
                lastWeek: "'last' eeee 'at' p",
                yesterday: "'yesterday at' p",
                today: "'today at' p",
                tomorrow: "'tomorrow at' p",
                nextWeek: "eeee 'at' p",
                other: "P"
            };
            function G(e) {
                return function(t, a) {
                    var n;
                    if ("formatting" === (null != a && a.context ? String(a.context) : "standalone") && e.formattingValues) {
                        var r = e.defaultFormattingWidth || e.defaultWidth, o = null != a && a.width ? String(a.width) : r;
                        n = e.formattingValues[o] || e.formattingValues[r];
                    } else {
                        var i = e.defaultWidth, l = null != a && a.width ? String(a.width) : e.defaultWidth;
                        n = e.values[l] || e.values[i];
                    }
                    return n[e.argumentCallback ? e.argumentCallback(t) : t];
                };
            }
            function L(e) {
                return function(t) {
                    var a = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, n = a.width, r = n && e.matchPatterns[n] || e.matchPatterns[e.defaultMatchWidth], o = t.match(r);
                    if (!o) return null;
                    var i, l = o[0], s = n && e.parsePatterns[n] || e.parsePatterns[e.defaultParseWidth], c = Array.isArray(s) ? function(e, t) {
                        for(var a = 0; a < e.length; a++)if (e[a].test(l)) return a;
                    }(s) : function(e, t) {
                        for(var a in e)if (e.hasOwnProperty(a) && e[a].test(l)) return a;
                    }(s);
                    return i = e.valueCallback ? e.valueCallback(c) : c, {
                        value: i = a.valueCallback ? a.valueCallback(i) : i,
                        rest: t.slice(l.length)
                    };
                };
            }
            const X = {
                code: "en-US",
                formatDistance: function(e, t, a) {
                    var n, r = B[e];
                    return n = "string" == typeof r ? r : 1 === t ? r.one : r.other.replace("{{count}}", t.toString()), null != a && a.addSuffix ? a.comparison && a.comparison > 0 ? "in " + n : n + " ago" : n;
                },
                formatLong: J,
                formatRelative: function(e, t, a, n) {
                    return z[e];
                },
                localize: {
                    ordinalNumber: function(e, t) {
                        var a = Number(e), n = a % 100;
                        if (n > 20 || n < 10) switch(n % 10){
                            case 1:
                                return a + "st";
                            case 2:
                                return a + "nd";
                            case 3:
                                return a + "rd";
                        }
                        return a + "th";
                    },
                    era: G({
                        values: {
                            narrow: [
                                "B",
                                "A"
                            ],
                            abbreviated: [
                                "BC",
                                "AD"
                            ],
                            wide: [
                                "Before Christ",
                                "Anno Domini"
                            ]
                        },
                        defaultWidth: "wide"
                    }),
                    quarter: G({
                        values: {
                            narrow: [
                                "1",
                                "2",
                                "3",
                                "4"
                            ],
                            abbreviated: [
                                "Q1",
                                "Q2",
                                "Q3",
                                "Q4"
                            ],
                            wide: [
                                "1st quarter",
                                "2nd quarter",
                                "3rd quarter",
                                "4th quarter"
                            ]
                        },
                        defaultWidth: "wide",
                        argumentCallback: function(e) {
                            return e - 1;
                        }
                    }),
                    month: G({
                        values: {
                            narrow: [
                                "J",
                                "F",
                                "M",
                                "A",
                                "M",
                                "J",
                                "J",
                                "A",
                                "S",
                                "O",
                                "N",
                                "D"
                            ],
                            abbreviated: [
                                "Jan",
                                "Feb",
                                "Mar",
                                "Apr",
                                "May",
                                "Jun",
                                "Jul",
                                "Aug",
                                "Sep",
                                "Oct",
                                "Nov",
                                "Dec"
                            ],
                            wide: [
                                "January",
                                "February",
                                "March",
                                "April",
                                "May",
                                "June",
                                "July",
                                "August",
                                "September",
                                "October",
                                "November",
                                "December"
                            ]
                        },
                        defaultWidth: "wide"
                    }),
                    day: G({
                        values: {
                            narrow: [
                                "S",
                                "M",
                                "T",
                                "W",
                                "T",
                                "F",
                                "S"
                            ],
                            short: [
                                "Su",
                                "Mo",
                                "Tu",
                                "We",
                                "Th",
                                "Fr",
                                "Sa"
                            ],
                            abbreviated: [
                                "Sun",
                                "Mon",
                                "Tue",
                                "Wed",
                                "Thu",
                                "Fri",
                                "Sat"
                            ],
                            wide: [
                                "Sunday",
                                "Monday",
                                "Tuesday",
                                "Wednesday",
                                "Thursday",
                                "Friday",
                                "Saturday"
                            ]
                        },
                        defaultWidth: "wide"
                    }),
                    dayPeriod: G({
                        values: {
                            narrow: {
                                am: "a",
                                pm: "p",
                                midnight: "mi",
                                noon: "n",
                                morning: "morning",
                                afternoon: "afternoon",
                                evening: "evening",
                                night: "night"
                            },
                            abbreviated: {
                                am: "AM",
                                pm: "PM",
                                midnight: "midnight",
                                noon: "noon",
                                morning: "morning",
                                afternoon: "afternoon",
                                evening: "evening",
                                night: "night"
                            },
                            wide: {
                                am: "a.m.",
                                pm: "p.m.",
                                midnight: "midnight",
                                noon: "noon",
                                morning: "morning",
                                afternoon: "afternoon",
                                evening: "evening",
                                night: "night"
                            }
                        },
                        defaultWidth: "wide",
                        formattingValues: {
                            narrow: {
                                am: "a",
                                pm: "p",
                                midnight: "mi",
                                noon: "n",
                                morning: "in the morning",
                                afternoon: "in the afternoon",
                                evening: "in the evening",
                                night: "at night"
                            },
                            abbreviated: {
                                am: "AM",
                                pm: "PM",
                                midnight: "midnight",
                                noon: "noon",
                                morning: "in the morning",
                                afternoon: "in the afternoon",
                                evening: "in the evening",
                                night: "at night"
                            },
                            wide: {
                                am: "a.m.",
                                pm: "p.m.",
                                midnight: "midnight",
                                noon: "noon",
                                morning: "in the morning",
                                afternoon: "in the afternoon",
                                evening: "in the evening",
                                night: "at night"
                            }
                        },
                        defaultFormattingWidth: "wide"
                    })
                },
                match: {
                    ordinalNumber: (q = {
                        matchPattern: /^(\d+)(th|st|nd|rd)?/i,
                        parsePattern: /\d+/i,
                        valueCallback: function(e) {
                            return parseInt(e, 10);
                        }
                    }, function(e) {
                        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, a = e.match(q.matchPattern);
                        if (!a) return null;
                        var n = a[0], r = e.match(q.parsePattern);
                        if (!r) return null;
                        var o = q.valueCallback ? q.valueCallback(r[0]) : r[0];
                        return {
                            value: o = t.valueCallback ? t.valueCallback(o) : o,
                            rest: e.slice(n.length)
                        };
                    }),
                    era: L({
                        matchPatterns: {
                            narrow: /^(b|a)/i,
                            abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
                            wide: /^(before christ|before common era|anno domini|common era)/i
                        },
                        defaultMatchWidth: "wide",
                        parsePatterns: {
                            any: [
                                /^b/i,
                                /^(a|c)/i
                            ]
                        },
                        defaultParseWidth: "any"
                    }),
                    quarter: L({
                        matchPatterns: {
                            narrow: /^[1234]/i,
                            abbreviated: /^q[1234]/i,
                            wide: /^[1234](th|st|nd|rd)? quarter/i
                        },
                        defaultMatchWidth: "wide",
                        parsePatterns: {
                            any: [
                                /1/i,
                                /2/i,
                                /3/i,
                                /4/i
                            ]
                        },
                        defaultParseWidth: "any",
                        valueCallback: function(e) {
                            return e + 1;
                        }
                    }),
                    month: L({
                        matchPatterns: {
                            narrow: /^[jfmasond]/i,
                            abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
                            wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
                        },
                        defaultMatchWidth: "wide",
                        parsePatterns: {
                            narrow: [
                                /^j/i,
                                /^f/i,
                                /^m/i,
                                /^a/i,
                                /^m/i,
                                /^j/i,
                                /^j/i,
                                /^a/i,
                                /^s/i,
                                /^o/i,
                                /^n/i,
                                /^d/i
                            ],
                            any: [
                                /^ja/i,
                                /^f/i,
                                /^mar/i,
                                /^ap/i,
                                /^may/i,
                                /^jun/i,
                                /^jul/i,
                                /^au/i,
                                /^s/i,
                                /^o/i,
                                /^n/i,
                                /^d/i
                            ]
                        },
                        defaultParseWidth: "any"
                    }),
                    day: L({
                        matchPatterns: {
                            narrow: /^[smtwf]/i,
                            short: /^(su|mo|tu|we|th|fr|sa)/i,
                            abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
                            wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
                        },
                        defaultMatchWidth: "wide",
                        parsePatterns: {
                            narrow: [
                                /^s/i,
                                /^m/i,
                                /^t/i,
                                /^w/i,
                                /^t/i,
                                /^f/i,
                                /^s/i
                            ],
                            any: [
                                /^su/i,
                                /^m/i,
                                /^tu/i,
                                /^w/i,
                                /^th/i,
                                /^f/i,
                                /^sa/i
                            ]
                        },
                        defaultParseWidth: "any"
                    }),
                    dayPeriod: L({
                        matchPatterns: {
                            narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
                            any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
                        },
                        defaultMatchWidth: "any",
                        parsePatterns: {
                            any: {
                                am: /^a/i,
                                pm: /^p/i,
                                midnight: /^mi/i,
                                noon: /^no/i,
                                morning: /morning/i,
                                afternoon: /afternoon/i,
                                evening: /evening/i,
                                night: /night/i
                            }
                        },
                        defaultParseWidth: "any"
                    })
                },
                options: {
                    weekStartsOn: 0,
                    firstWeekContainsDate: 1
                }
            };
            var K = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, Z = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, _ = /^'([^]*?)'?$/, $ = /''/g, ee = /[a-zA-Z]/;
            function te(e, t, a) {
                var n, r, o, i, l, s, c, u, g, v, b, w, E, A, x, y, C, M;
                m(2, arguments);
                var T = String(t), N = p(), k = null !== (n = null !== (r = null == a ? void 0 : a.locale) && void 0 !== r ? r : N.locale) && void 0 !== n ? n : X, P = h(null !== (o = null !== (i = null !== (l = null !== (s = null == a ? void 0 : a.firstWeekContainsDate) && void 0 !== s ? s : null == a || null === (c = a.locale) || void 0 === c || null === (u = c.options) || void 0 === u ? void 0 : u.firstWeekContainsDate) && void 0 !== l ? l : N.firstWeekContainsDate) && void 0 !== i ? i : null === (g = N.locale) || void 0 === g || null === (v = g.options) || void 0 === v ? void 0 : v.firstWeekContainsDate) && void 0 !== o ? o : 1);
                if (!(P >= 1 && P <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
                var S = h(null !== (b = null !== (w = null !== (E = null !== (A = null == a ? void 0 : a.weekStartsOn) && void 0 !== A ? A : null == a || null === (x = a.locale) || void 0 === x || null === (y = x.options) || void 0 === y ? void 0 : y.weekStartsOn) && void 0 !== E ? E : N.weekStartsOn) && void 0 !== w ? w : null === (C = N.locale) || void 0 === C || null === (M = C.options) || void 0 === M ? void 0 : M.weekStartsOn) && void 0 !== b ? b : 0);
                if (!(S >= 0 && S <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
                if (!k.localize) throw new RangeError("locale must contain localize property");
                if (!k.formatLong) throw new RangeError("locale must contain formatLong property");
                var O = f(e);
                if (!function(e) {
                    if (m(1, arguments), !function(e) {
                        return m(1, arguments), e instanceof Date || "object" === d(e) && "[object Date]" === Object.prototype.toString.call(e);
                    }(e) && "number" != typeof e) return !1;
                    var t = f(e);
                    return !isNaN(Number(t));
                }(O)) throw new RangeError("Invalid time value");
                var U = function(e) {
                    var t = new Date(Date.UTC(e.getFullYear(), e.getMonth(), e.getDate(), e.getHours(), e.getMinutes(), e.getSeconds(), e.getMilliseconds()));
                    return t.setUTCFullYear(e.getFullYear()), e.getTime() - t.getTime();
                }(O), Y = function(e, t) {
                    return m(2, arguments), function(e, t) {
                        m(2, arguments);
                        var a = f(e).getTime(), n = h(t);
                        return new Date(a + n);
                    }(e, -h(t));
                }(O, U), D = {
                    firstWeekContainsDate: P,
                    weekStartsOn: S,
                    locale: k,
                    _originalDate: O
                };
                return T.match(Z).map(function(e) {
                    var t = e[0];
                    return "p" === t || "P" === t ? (0, R[t])(e, k.formatLong) : e;
                }).join("").match(K).map(function(n) {
                    if ("''" === n) return "'";
                    var r, o, i = n[0];
                    if ("'" === i) return (o = (r = n).match(_)) ? o[1].replace($, "'") : r;
                    var l, s = W[i];
                    if (s) return null != a && a.useAdditionalWeekYearTokens || (l = n, -1 === V.indexOf(l)) || H(n, t, String(e)), null != a && a.useAdditionalDayOfYearTokens || !function(e) {
                        return -1 !== I.indexOf(e);
                    }(n) || H(n, t, String(e)), s(Y, n, k.localize, D);
                    if (i.match(ee)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + i + "`");
                    return n;
                }).join("");
            }
            const ae = c.forwardRef(function(e, t) {
                return c.createElement("svg", Object.assign({
                    xmlns: "http://www.w3.org/2000/svg",
                    viewBox: "0 0 20 20",
                    fill: "currentColor",
                    "aria-hidden": "true",
                    ref: t
                }, e), c.createElement("path", {
                    d: "M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"
                }));
            }), ne = c.forwardRef(function(e, t) {
                return c.createElement("svg", Object.assign({
                    xmlns: "http://www.w3.org/2000/svg",
                    viewBox: "0 0 20 20",
                    fill: "currentColor",
                    "aria-hidden": "true",
                    ref: t
                }, e), c.createElement("path", {
                    fillRule: "evenodd",
                    d: "M6 6V5a3 3 0 013-3h2a3 3 0 013 3v1h2a2 2 0 012 2v3.57A22.952 22.952 0 0110 13a22.95 22.95 0 01-8-1.43V8a2 2 0 012-2h2zm2-1a1 1 0 011-1h2a1 1 0 011 1v1H8V5zm1 5a1 1 0 011-1h.01a1 1 0 110 2H10a1 1 0 01-1-1z",
                    clipRule: "evenodd"
                }), c.createElement("path", {
                    d: "M2 13.692V16a2 2 0 002 2h12a2 2 0 002-2v-2.308A24.974 24.974 0 0110 15c-2.796 0-5.487-.46-8-1.308z"
                }));
            }), re = ({ bookings: e, reservations: t, conciergeBookings: a })=>u().createElement("div", null, u().createElement("h1", {
                    className: "mb-6 sm:mb-12 font-semibold text-2xl sm:text-4xl dark:text-gray-200"
                }, "Here's what's new today."), u().createElement("div", {
                    className: "grid grid-cols-1 md:grid-cols-2 gap-4 gap-y-12 text-sm sm:text-base"
                }, u().createElement("div", {
                    className: "flex flex-col gap-16"
                }, a && u().createElement(le, {
                    bookings: a
                }), e && u().createElement(se, {
                    bookings: e
                })), t && u().createElement(ue, {
                    reservations: t
                }))), oe = ({ name: e, className: t })=>{
                const a = {
                    firstCheckIn: {
                        icon: u().createElement(ae, {
                            className: "w-4 h-4 text-yellow-500"
                        }),
                        description: "First check-in"
                    }
                }[e];
                return a ? u().createElement("span", {
                    className: t,
                    title: a.description
                }, a.icon) : null;
            }, ie = ({ user: e, className: t })=>{
                const a = e.photoUrl || "";
                return 0 === a.length ? u().createElement("div", {
                    className: `inline-block ${t}`
                }, u().createElement("div", {
                    className: "font-semibold w-8 h-8 rounded-full bg-gray-900 dark:bg-gray-700 text-gray-200 flex items-center justify-center"
                }, (e.name || "").charAt(0))) : u().createElement("div", {
                    className: t
                }, u().createElement("img", {
                    src: a,
                    className: "object-cover inline-block w-8 h-8 rounded-full"
                }));
            }, le = ({ bookings: e })=>u().createElement("div", {
                    className: "text-gray-700 dark:text-gray-300"
                }, u().createElement("h1", {
                    className: "font-bold mb-2"
                }, "Upcoming Concierge Bookings (", e.length, ")"), u().createElement("ul", null, e.map((e)=>{
                    var _e_computed, _e_computed_team, _e_computed1, _e_computed2, _e_computed3;
                    const t = ((_e_computed = e.computed) === null || _e_computed === void 0 ? void 0 : _e_computed.user) || {
                        name: "Concierge Booking",
                        photoUrl: ""
                    }, a = {
                        abbreviation: (((_e_computed1 = e.computed) === null || _e_computed1 === void 0 ? void 0 : (_e_computed_team = _e_computed1.team) === null || _e_computed_team === void 0 ? void 0 : _e_computed_team.name) || "Team").charAt(0),
                        accentColor: "#aaa",
                        ...(_e_computed2 = e.computed) === null || _e_computed2 === void 0 ? void 0 : _e_computed2.team
                    };
                    return u().createElement("li", {
                        key: e.id,
                        className: "flex gap-2 pt-2 pb-6 border-b-solid border-b border-gray-200"
                    }, u().createElement(ie, {
                        user: t,
                        className: "pt-2"
                    }), u().createElement("div", null, u().createElement("div", {
                        className: "flex items-center gap-2"
                    }, u().createElement("span", {
                        className: "font-bold"
                    }, t.name), ((_e_computed3 = e.computed) === null || _e_computed3 === void 0 ? void 0 : _e_computed3.team) && u().createElement(ce, {
                        team: a
                    }), u().createElement("span", {
                        className: "text-gray-400 dark:text-gray-600"
                    }, "\xb7 ", te(new Date(e.startedAt), "LLL d"))), u().createElement("div", {
                        className: "flex-1"
                    }, u().createElement("a", {
                        href: `https://dashboard.stripe.com/invoices/${e.invoiceId}`
                    }, e.title))));
                }), 0 === e.length && u().createElement("li", null, "No upcoming concierge bookings."))), se = ({ bookings: e })=>u().createElement("div", {
                    className: "text-gray-700 dark:text-gray-300"
                }, u().createElement("h1", {
                    className: "font-bold mb-2"
                }, "Check-ins (", e.filter((e)=>"active" === e.status).length, ")"), u().createElement("ul", null, e.map((e)=>{
                    var _e_computed_team, _e_computed, _e_computed1, _e_computed2;
                    const t = e.user || {
                        name: "Day Pass",
                        photoUrl: ""
                    }, a = {
                        abbreviation: (((_e_computed = e.computed) === null || _e_computed === void 0 ? void 0 : (_e_computed_team = _e_computed.team) === null || _e_computed_team === void 0 ? void 0 : _e_computed_team.name) || "Team").charAt(0),
                        accentColor: "#aaa",
                        ...(_e_computed1 = e.computed) === null || _e_computed1 === void 0 ? void 0 : _e_computed1.team
                    };
                    return u().createElement("li", {
                        key: e.id,
                        className: `flex gap-2 pt-2 pb-6 border-b-solid border-b border-gray-200 ${"cancelled" === e.status && "opacity-50"}`
                    }, u().createElement(ie, {
                        user: t,
                        className: "pt-2"
                    }), u().createElement("div", null, u().createElement("div", {
                        className: "flex items-center gap-2"
                    }, u().createElement("span", {
                        className: "font-bold"
                    }, t.name), (e.badges || []).map((e)=>u().createElement(oe, {
                            name: e
                        })), ((_e_computed2 = e.computed) === null || _e_computed2 === void 0 ? void 0 : _e_computed2.team) && u().createElement(ce, {
                        team: a
                    }), u().createElement("span", {
                        className: "text-gray-400 dark:text-gray-600"
                    }, "\xb7 ", te(new Date(e.createdAt), "h:mm a"))), u().createElement("div", {
                        className: "flex-1"
                    }, e.title.replace("Day Pass - ", ""))));
                }), 0 === e.length && u().createElement("li", null, "No check-ins yet."))), ce = ({ team: e })=>u().createElement("div", {
                    title: e.name,
                    className: "flex gap-1 items-center text-white rounded px-2 py-1",
                    style: {
                        backgroundColor: e.accentColor
                    }
                }, u().createElement(ne, {
                    className: "h-3 w-3"
                }), u().createElement("div", {
                    className: "text-xs"
                }, e.abbreviation)), ue = ({ reservations: e })=>u().createElement("div", {
                    className: "text-gray-700 dark:text-gray-300"
                }, u().createElement("h1", {
                    className: "font-bold mb-2"
                }, "Upcoming Reservations (", e.filter((e)=>"active" === e.status).length, ")"), u().createElement("ul", null, e.filter((e)=>"completed" !== e.status).map((e)=>{
                    const t = e.user || {
                        name: "Reservation",
                        photoUrl: ""
                    };
                    return u().createElement("li", {
                        key: e.id,
                        className: "flex items-center gap-2 mb-2"
                    }, u().createElement("span", {
                        className: "flex-none w-16 text-center inline-block text-xs uppercase bg-gray-500 text-gray-100 px-2 py-1 rounded dark:text-gray-700"
                    }, te(new Date(e.scheduledAt), "MMM d")), u().createElement(ie, {
                        user: t
                    }), u().createElement("span", {
                        className: `${"cancelled" === e.status && "line-through text-gray-400 dark:text-gray-600"}`
                    }, t.name, " @", " ", u().createElement("span", {
                        className: "font-semibold"
                    }, e.title.replace("Day Pass - ", ""))));
                }), 0 === e.length && u().createElement("li", null, "No reservations yet.")));
            function de() {
                return de = Object.assign ? Object.assign.bind() : function(e) {
                    for(var t = 1; t < arguments.length; t++){
                        var a = arguments[t];
                        for(var n in a)Object.prototype.hasOwnProperty.call(a, n) && (e[n] = a[n]);
                    }
                    return e;
                }, de.apply(this, arguments);
            }
            const me = ({ ...e })=>u().createElement(ge, e, u().createElement("path", {
                    fillRule: "evenodd",
                    d: "M4 2a1 1 0 011 1v2.101a7.002 7.002 0 0111.601 2.566 1 1 0 11-1.885.666A5.002 5.002 0 005.999 7H9a1 1 0 010 2H4a1 1 0 01-1-1V3a1 1 0 011-1zm.008 9.057a1 1 0 011.276.61A5.002 5.002 0 0014.001 13H11a1 1 0 110-2h5a1 1 0 011 1v5a1 1 0 11-2 0v-2.101a7.002 7.002 0 01-11.601-2.566 1 1 0 01.61-1.276z",
                    clipRule: "evenodd"
                })), fe = ({ ...e })=>u().createElement(ge, e, u().createElement("path", {
                    fillRule: "evenodd",
                    d: "M3.707 2.293a1 1 0 00-1.414 1.414l14 14a1 1 0 001.414-1.414l-1.473-1.473A10.014 10.014 0 0019.542 10C18.268 5.943 14.478 3 10 3a9.958 9.958 0 00-4.512 1.074l-1.78-1.781zm4.261 4.26l1.514 1.515a2.003 2.003 0 012.45 2.45l1.514 1.514a4 4 0 00-5.478-5.478z",
                    clipRule: "evenodd"
                }), u().createElement("path", {
                    d: "M12.454 16.697L9.75 13.992a4 4 0 01-3.742-3.741L2.335 6.578A9.98 9.98 0 00.458 10c1.274 4.057 5.065 7 9.542 7 .847 0 1.669-.105 2.454-.303z"
                })), he = ({ ...e })=>u().createElement(ge, e, u().createElement("path", {
                    fillRule: "evenodd",
                    d: "M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z",
                    clipRule: "evenodd"
                })), ge = ({ children: e, ...t })=>u().createElement("svg", de({
                    xmlns: "http://www.w3.org/2000/svg",
                    className: "h-5 w-5",
                    viewBox: "0 0 20 20",
                    fill: "currentColor"
                }, t), e), ve = ({ children: e, ...t })=>u().createElement("svg", de({
                    xmlns: "http://www.w3.org/2000/svg",
                    className: "h-6 w-6",
                    fill: "none",
                    viewBox: "0 0 24 24",
                    stroke: "currentColor"
                }, t), e), be = ({ ...e })=>u().createElement(ge, e, u().createElement("path", {
                    fillRule: "evenodd",
                    d: "M5.05 3.636a1 1 0 010 1.414 7 7 0 000 9.9 1 1 0 11-1.414 1.414 9 9 0 010-12.728 1 1 0 011.414 0zm9.9 0a1 1 0 011.414 0 9 9 0 010 12.728 1 1 0 11-1.414-1.414 7 7 0 000-9.9 1 1 0 010-1.414zM7.879 6.464a1 1 0 010 1.414 3 3 0 000 4.243 1 1 0 11-1.415 1.414 5 5 0 010-7.07 1 1 0 011.415 0zm4.242 0a1 1 0 011.415 0 5 5 0 010 7.072 1 1 0 01-1.415-1.415 3 3 0 000-4.242 1 1 0 010-1.415zM10 9a1 1 0 011 1v.01a1 1 0 11-2 0V10a1 1 0 011-1z",
                    clipRule: "evenodd"
                })), pe = ({ ...e })=>u().createElement(ge, e, u().createElement("path", {
                    d: "M3.707 2.293a1 1 0 00-1.414 1.414l6.921 6.922c.05.062.105.118.168.167l6.91 6.911a1 1 0 001.415-1.414l-.675-.675a9.001 9.001 0 00-.668-11.982A1 1 0 1014.95 5.05a7.002 7.002 0 01.657 9.143l-1.435-1.435a5.002 5.002 0 00-.636-6.294A1 1 0 0012.12 7.88c.924.923 1.12 2.3.587 3.415l-1.992-1.992a.922.922 0 00-.018-.018l-6.99-6.991zM3.238 8.187a1 1 0 00-1.933-.516c-.8 3-.025 6.336 2.331 8.693a1 1 0 001.414-1.415 6.997 6.997 0 01-1.812-6.762zM7.4 11.5a1 1 0 10-1.73 1c.214.371.48.72.795 1.035a1 1 0 001.414-1.414c-.191-.191-.35-.4-.478-.622z"
                })), we = ({ ...e })=>u().createElement(ge, e, u().createElement("path", {
                    fillRule: "evenodd",
                    d: "M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z",
                    clipRule: "evenodd"
                })), Ee = ({ ...e })=>u().createElement(ve, e, u().createElement("path", {
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    strokeWidth: 2,
                    d: "M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
                })), Ae = ({ ...e })=>u().createElement(ve, e, u().createElement("path", {
                    d: "M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z"
                }), u().createElement("path", {
                    d: "M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z"
                })), xe = ({ ...e })=>u().createElement(ve, e, u().createElement("path", {
                    d: "M8.707 7.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l2-2a1 1 0 00-1.414-1.414L11 7.586V3a1 1 0 10-2 0v4.586l-.293-.293z"
                }), u().createElement("path", {
                    d: "M3 5a2 2 0 012-2h1a1 1 0 010 2H5v7h2l1 2h4l1-2h2V5h-1a1 1 0 110-2h1a2 2 0 012 2v10a2 2 0 01-2 2H5a2 2 0 01-2-2V5z"
                }));
            var ye = i(369), Ce = i(703);
            function Me() {
                return Me = Object.assign ? Object.assign.bind() : function(e) {
                    for(var t = 1; t < arguments.length; t++){
                        var a = arguments[t];
                        for(var n in a)Object.prototype.hasOwnProperty.call(a, n) && (e[n] = a[n]);
                    }
                    return e;
                }, Me.apply(this, arguments);
            }
            const Te = function({ logo: e, signInUrl: t, app: a }) {
                const { register: n, handleSubmit: r } = (0, ye.useForm)(), [o, i] = (0, c.useState)(!1), [l, s] = (0, c.useState)(!1);
                return u().createElement("div", {
                    className: "flex flex-col h-screen"
                }, e, u().createElement("div", {
                    className: "m-auto max-w-full px-4"
                }, u().createElement("form", {
                    onSubmit: r(async ({ email: e })=>{
                        i(!1), s(!0);
                        const n = {
                            url: t,
                            handleCodeInApp: !0
                        };
                        try {
                            const t = (0, Ce.getAuth)(a);
                            await (0, Ce.sendSignInLinkToEmail)(t, e, n), window.localStorage.setItem("emailForSignIn", e), i(!0);
                        } catch (e) {
                            console.error("failed to send email link: ", e);
                        }
                        s(!1);
                    }),
                    className: "flex flex-col"
                }, u().createElement("input", Me({
                    className: "rounded border px-4 py-2 mb-4 dark:bg-gray-600 dark:border-gray-400 max-w-full w-96",
                    type: "text",
                    placeholder: "Email",
                    disabled: l
                }, n("email", {
                    required: !0
                }))), u().createElement("div", {
                    className: "flex mx-auto items-center relative"
                }, u().createElement("button", {
                    type: "submit",
                    className: "text-gray-100",
                    disabled: l
                }, u().createElement("div", {
                    className: "flex items-center rounded px-4 py-2 bg-gray-900 dark:bg-gray-700"
                }, u().createElement("div", {
                    className: "mt-1 mr-2"
                }, u().createElement(Ae, null)), u().createElement("div", null, "Send login link"))), l && u().createElement("div", {
                    className: "animate-spin absolute -right-8 text-gray-400"
                }, u().createElement(me, null)), o && u().createElement("div", {
                    className: "absolute -right-8 text-green-400"
                }, u().createElement(he, null))))));
            }, Ne = function({ app: e, onSuccess: t, onError: a }) {
                return (0, c.useEffect)(()=>{
                    (async ()=>{
                        try {
                            const a = (0, Ce.getAuth)(e);
                            if ((0, Ce.isSignInWithEmailLink)(a, window.location.href)) {
                                const e = window.localStorage.getItem("emailForSignIn") || window.prompt("Please verify your email address:");
                                await (0, Ce.signInWithEmailLink)(a, e, window.location.href), window.localStorage.removeItem("emailForSignIn"), t();
                            }
                        } catch (e) {
                            a(e);
                        }
                    })();
                }), u().createElement("div", null, "Signing in...");
            }, ke = function({ logo: e, app: t, onSuccess: a, onError: n, onEmailSignInClick: r }) {
                const o = (0, Ce.getAuth)(t), i = async ()=>{
                    try {
                        const e = new Ce.GoogleAuthProvider;
                        await (0, Ce.signInWithPopup)(o, e, Ce.browserPopupRedirectResolver), a();
                    } catch (e) {
                        n(e);
                    }
                };
                return u().createElement("div", {
                    className: "flex flex-col h-screen"
                }, e, u().createElement("div", {
                    className: "m-auto"
                }, u().createElement("div", {
                    className: "scale-50"
                }, u().createElement("input", {
                    type: "image",
                    src: "data:image/png;base64,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",
                    className: "dark:hidden",
                    onClick: ()=>i(),
                    alt: "Log in"
                }), u().createElement("input", {
                    type: "image",
                    src: "data:image/png;base64,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",
                    className: "hidden dark:block",
                    onClick: ()=>i(),
                    alt: "Log in"
                })), u().createElement("button", {
                    className: "mx-auto flex items-center px-4 py-2 bg-gray-900 dark:bg-gray-700 rounded text-gray-100",
                    onClick: r
                }, u().createElement("div", {
                    className: "mt-1 mr-2"
                }, u().createElement(Ae, null)), u().createElement("div", null, "Sign in with Email"))));
            };
            var Pe = i(462);
            const Se = (e)=>new Intl.NumberFormat("en-CA", {
                    style: "currency",
                    currency: "CAD"
                }).format(e / 100), Oe = (e)=>te(new Date(e), "MMM d");
            window.gfs1 = Pe.getFirestore, window.React1 = u();
            const Ue = (e)=>!!e && e.email.endsWith("@flexday.com"), Ye = (e, t)=>{
                if (!e) return [];
                const a = (0, Pe.getFirestore)(t), n = (0, Pe.collection)(a, "partners"), r = (0, Pe.where)("users", "array-contains", e), o = (0, Pe.query)(n, r);
                return (0, Pe.getDocs)(o);
            }, We = (e)=>({
                    apiKey: e.REACT_APP_FIREBASE_API_KEY,
                    appId: e.REACT_APP_FIREBASE_APP_ID,
                    authDomain: `${e.REACT_APP_FIREBASE_PROJECT_ID}.firebaseapp.com`,
                    databaseURL: `https://${e.REACT_APP_FIREBASE_PROJECT_ID}.firebaseio.com`,
                    messagingSenderId: e.REACT_APP_FIREBASE_MESSAGE_SENDER_ID,
                    projectId: e.REACT_APP_FIREBASE_PROJECT_ID,
                    storageBucket: `${e.REACT_APP_FIREBASE_PROJECT_ID}.appspot.com`
                }), De = n, Fe = ({ report: e, onApprove: t, approvalEnabled: a })=>u().createElement("div", null, u().createElement("div", {
                    className: "max-w-prose mx-auto px-4"
                }, u().createElement("h1", {
                    className: "text-xl font-semibold mb-4"
                }, e.title), u().createElement("ul", {
                    className: "mb-8"
                }, u().createElement("li", null, u().createElement("span", {
                    className: "font-semibold"
                }, "Flexday Partner:"), " ", e.partner.name), e.taxes.map((e)=>u().createElement("li", {
                        key: e.identifier
                    }, e.label, " - ", e.identifier))), u().createElement("h2", {
                    className: "texl-lg font-semibold mb-4"
                }, "Day Pass Check-ins")), u().createElement("div", {
                    className: "overflow-x-auto min-w-full"
                }, u().createElement("table", {
                    className: "table-fixed w-full max-w-6xl mx-auto"
                }, u().createElement("thead", null, u().createElement("tr", {
                    className: "bg-gray-300 dark:bg-gray-800"
                }, u().createElement("th", {
                    className: "px-2 border text-left w-72"
                }, "Location"), u().createElement("th", {
                    className: "px-2 border text-right w-28"
                }, "First Visits"), u().createElement("th", {
                    className: "px-2 border text-right w-28"
                }, Se(e.locations[0].firstVisits.unitPrice)), u().createElement("th", {
                    className: "px-2 border text-right w-32"
                }, "Repeat Visits"), u().createElement("th", {
                    className: "px-2 border text-right w-28"
                }, Se(e.locations[0].repeatedVisits.unitPrice)), u().createElement("th", {
                    className: "px-2 border text-right w-24"
                }, "Guests"), u().createElement("th", {
                    className: "px-2 border text-right w-28"
                }, Se(e.locations[0].guests.unitPrice)), u().createElement("th", {
                    className: "px-2 border text-right w-28"
                }, "Total"))), u().createElement("tbody", null, e.locations.map((e, t)=>u().createElement("tr", {
                        className: "even:bg-gray-100 dark:even:bg-gray-800",
                        key: `location-${t}`
                    }, u().createElement("td", {
                        className: "px-2 border text-left max-w-7xl"
                    }, e.name), u().createElement("td", {
                        className: "px-2 border text-right"
                    }, e.firstVisits.units), u().createElement("td", {
                        className: "px-2 border text-right"
                    }, Se(e.firstVisits.amount)), u().createElement("td", {
                        className: "px-2 border text-right"
                    }, e.repeatedVisits.units), u().createElement("td", {
                        className: "px-2 border text-right"
                    }, Se(e.repeatedVisits.amount)), u().createElement("td", {
                        className: "px-2 border text-right"
                    }, e.guests.units), u().createElement("td", {
                        className: "px-2 border text-right"
                    }, Se(e.guests.amount)), u().createElement("td", {
                        className: "px-2 border text-right"
                    }, Se(e.total.amount)))), u().createElement("tr", null, u().createElement("td", {
                    className: "px-2 border font-semibold text-left"
                }, "Total"), u().createElement("td", {
                    className: "px-2 border font-semibold text-right"
                }, e.total.firstVisits.units), u().createElement("td", {
                    className: "px-2 border font-semibold text-right"
                }, Se(e.total.firstVisits.amount)), u().createElement("td", {
                    className: "px-2 border font-semibold text-right"
                }, e.total.repeatedVisits.units), u().createElement("td", {
                    className: "px-2 border font-semibold text-right"
                }, Se(e.total.repeatedVisits.amount)), u().createElement("td", {
                    className: "px-2 border font-semibold text-right"
                }, e.total.guests.units), u().createElement("td", {
                    className: "px-2 border font-semibold text-right"
                }, Se(e.total.guests.amount)), u().createElement("td", {
                    className: "px-2 border font-semibold text-right"
                }, Se(e.total.total.amount)))))), u().createElement("div", {
                    className: "max-w-prose mx-auto px-4"
                }, u().createElement("div", {
                    className: "mt-4 text-sm"
                }, e.taxes.map((e, t)=>u().createElement("p", {
                        key: `tax-${t}`,
                        className: "text-right mt-4"
                    }, u().createElement("span", {
                        className: "px-2"
                    }, e.label, " - ", e.identifier, ":"), Se(e.amount))), u().createElement("p", {
                    className: "text-right font-bold text-lg mt-2"
                }, u().createElement("span", {
                    className: "px-2"
                }, "Total:"), " ", Se(e.total.total.amountAfterTaxes))), u().createElement("div", {
                    className: "mt-12"
                }, u().createElement("h3", {
                    className: "font-semibold"
                }, "Steps to receive payment:"), u().createElement("ol", {
                    className: "list-decimal ml-6"
                }, u().createElement("li", null, "Review summary to ensure accuracy."), u().createElement("li", null, "Submit an invoice with tax to", " ", u().createElement("a", {
                    className: "font-semibold",
                    href: "mailto:billings@flexday.com"
                }, "blair@flexday.com"), "."), u().createElement("li", null, "Payment will be issued within 7 days."))))), je = ({ errors: e })=>u().createElement("div", null, u().createElement("div", {
                    className: "text-2xl sm:text-6xl p-4"
                }, "\uD83E\uDD15 "), e.map((e)=>u().createElement("div", {
                        className: "bg-red-100 p-4 sm:text-xl font-mono overflow-x-auto"
                    }, e.toString())));
        })(), l;
    })());


var $12f14e722131d005$exports = {};



$12f14e722131d005$exports = {
    Utils: (parcelRequire("3rass")),
    Customers: (parcelRequire("awSij")),
    CustomerTransformers: (parcelRequire("gEP1k"))
};


var $d77b1014b2d60259$exports = {};
"use strict";
var $d77b1014b2d60259$var$__rest = $d77b1014b2d60259$exports && $d77b1014b2d60259$exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
Object.defineProperty($d77b1014b2d60259$exports, "__esModule", {
    value: true
});
$d77b1014b2d60259$exports.onUserEmailSupplied = $d77b1014b2d60259$exports.showConversation = $d77b1014b2d60259$exports.showTicket = $d77b1014b2d60259$exports.startChecklist = $d77b1014b2d60259$exports.startSurvey = $d77b1014b2d60259$exports.showNews = $d77b1014b2d60259$exports.showArticle = $d77b1014b2d60259$exports.startTour = $d77b1014b2d60259$exports.getVisitorId = $d77b1014b2d60259$exports.trackEvent = $d77b1014b2d60259$exports.onUnreadCountChange = $d77b1014b2d60259$exports.onShow = $d77b1014b2d60259$exports.onHide = $d77b1014b2d60259$exports.showNewMessage = $d77b1014b2d60259$exports.showMessages = $d77b1014b2d60259$exports.showSpace = $d77b1014b2d60259$exports.show = $d77b1014b2d60259$exports.hide = $d77b1014b2d60259$exports.update = $d77b1014b2d60259$exports.shutdown = $d77b1014b2d60259$exports.boot = $d77b1014b2d60259$exports.Intercom = void 0;
var $39e7dbc5f55108d0$exports = {};
"use strict";
Object.defineProperty($39e7dbc5f55108d0$exports, "__esModule", {
    value: true
});
$39e7dbc5f55108d0$exports.regionAPIs = void 0;
$39e7dbc5f55108d0$exports.regionAPIs = new Map([
    [
        "us",
        "https://api-iam.intercom.io"
    ],
    [
        "eu",
        "https://api-iam.eu.intercom.io"
    ],
    [
        "ap",
        "https://api-iam.au.intercom.io"
    ]
]);


var $6b7eba94662c16f5$exports = {};
"use strict";
var $6b7eba94662c16f5$var$__awaiter = $6b7eba94662c16f5$exports && $6b7eba94662c16f5$exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty($6b7eba94662c16f5$exports, "__esModule", {
    value: true
});
$6b7eba94662c16f5$exports.getIntercomRef = $6b7eba94662c16f5$exports.ref = $6b7eba94662c16f5$exports.init = void 0;
const $6b7eba94662c16f5$var$init = ()=>$6b7eba94662c16f5$var$__awaiter(void 0, void 0, void 0, function*() {
        var w = window;
        var ic = w.Intercom;
        if (w.intercomSettings) w.intercomSettings.installation_type = "npm-package";
        if (typeof ic === "function") {
            ic("reattach_activator");
            ic("update", w.intercomSettings);
        } else {
            var d = document;
            var i = function() {
                i.c(arguments);
            };
            i.q = [];
            i.c = function(args) {
                i.q.push(args);
            };
            w.Intercom = i;
            var l = function() {
                var _a, _b;
                var s = d.createElement("script");
                s.type = "text/javascript";
                s.async = true;
                s.src = "https://widget.intercom.io/widget/" + ((_a = window.intercomSettings) === null || _a === void 0 ? void 0 : _a.app_id);
                var x = d.getElementsByTagName("script")[0];
                (_b = x.parentNode) === null || _b === void 0 || _b.insertBefore(s, x);
            };
            if (document.readyState === "complete") l();
            else if (w.attachEvent) w.attachEvent("onload", l);
            else w.addEventListener("load", l, false);
        }
    });
$6b7eba94662c16f5$exports.init = $6b7eba94662c16f5$var$init;
$6b7eba94662c16f5$exports.ref = undefined;
const $6b7eba94662c16f5$var$getIntercomRef = ()=>{
    if (typeof window !== "undefined" && !$6b7eba94662c16f5$exports.ref) $6b7eba94662c16f5$exports.ref = window.Intercom;
    if (!$6b7eba94662c16f5$exports.ref || typeof window === "undefined") {
        console.warn("Intercom not booted or setup incomplete.");
        if (typeof window === "undefined") console.warn("Are you sure you are running on client-side?");
        return ()=>{};
    }
    return $6b7eba94662c16f5$exports.ref;
};
$6b7eba94662c16f5$exports.getIntercomRef = $6b7eba94662c16f5$var$getIntercomRef;


const $d77b1014b2d60259$var$Intercom = (_a)=>{
    var { region: region = "us" } = _a, args = $d77b1014b2d60259$var$__rest(_a, [
        "region"
    ]);
    if (typeof window !== "undefined" && !$6b7eba94662c16f5$exports.ref) {
        window.intercomSettings = Object.assign(Object.assign({}, args), {
            api_base: $39e7dbc5f55108d0$exports.regionAPIs.get(region)
        });
        (0, $6b7eba94662c16f5$exports.init)();
    }
};
$d77b1014b2d60259$exports.Intercom = $d77b1014b2d60259$var$Intercom;
// Public functions that can be called from outside the module
$d77b1014b2d60259$exports.default = $d77b1014b2d60259$exports.Intercom;
const $d77b1014b2d60259$var$boot = (arg)=>{
    (0, $6b7eba94662c16f5$exports.getIntercomRef)()("boot", arg);
};
$d77b1014b2d60259$exports.boot = $d77b1014b2d60259$var$boot;
const $d77b1014b2d60259$var$shutdown = ()=>{
    (0, $6b7eba94662c16f5$exports.getIntercomRef)()("shutdown");
};
$d77b1014b2d60259$exports.shutdown = $d77b1014b2d60259$var$shutdown;
const $d77b1014b2d60259$var$update = (arg)=>{
    (0, $6b7eba94662c16f5$exports.getIntercomRef)()("update", arg);
};
$d77b1014b2d60259$exports.update = $d77b1014b2d60259$var$update;
const $d77b1014b2d60259$var$hide = ()=>{
    (0, $6b7eba94662c16f5$exports.getIntercomRef)()("hide");
};
$d77b1014b2d60259$exports.hide = $d77b1014b2d60259$var$hide;
const $d77b1014b2d60259$var$show = ()=>{
    (0, $6b7eba94662c16f5$exports.getIntercomRef)()("show");
};
$d77b1014b2d60259$exports.show = $d77b1014b2d60259$var$show;
const $d77b1014b2d60259$var$showSpace = (spaceName)=>{
    (0, $6b7eba94662c16f5$exports.getIntercomRef)()("showSpace", spaceName);
};
$d77b1014b2d60259$exports.showSpace = $d77b1014b2d60259$var$showSpace;
const $d77b1014b2d60259$var$showMessages = ()=>{
    (0, $6b7eba94662c16f5$exports.getIntercomRef)()("showMessages");
};
$d77b1014b2d60259$exports.showMessages = $d77b1014b2d60259$var$showMessages;
const $d77b1014b2d60259$var$showNewMessage = (prePopulatedContent)=>{
    (0, $6b7eba94662c16f5$exports.getIntercomRef)()("showNewMessage", prePopulatedContent);
};
$d77b1014b2d60259$exports.showNewMessage = $d77b1014b2d60259$var$showNewMessage;
const $d77b1014b2d60259$var$onHide = (callback)=>{
    (0, $6b7eba94662c16f5$exports.getIntercomRef)()("onHide", callback);
};
$d77b1014b2d60259$exports.onHide = $d77b1014b2d60259$var$onHide;
const $d77b1014b2d60259$var$onShow = (callback)=>{
    (0, $6b7eba94662c16f5$exports.getIntercomRef)()("onShow", callback);
};
$d77b1014b2d60259$exports.onShow = $d77b1014b2d60259$var$onShow;
const $d77b1014b2d60259$var$onUnreadCountChange = (callback)=>{
    (0, $6b7eba94662c16f5$exports.getIntercomRef)()("onUnreadCountChange", callback);
};
$d77b1014b2d60259$exports.onUnreadCountChange = $d77b1014b2d60259$var$onUnreadCountChange;
const $d77b1014b2d60259$var$trackEvent = (...args)=>{
    (0, $6b7eba94662c16f5$exports.getIntercomRef)()("trackEvent", ...args);
};
$d77b1014b2d60259$exports.trackEvent = $d77b1014b2d60259$var$trackEvent;
const $d77b1014b2d60259$var$getVisitorId = ()=>{
    (0, $6b7eba94662c16f5$exports.getIntercomRef)()("getVisitorId");
};
$d77b1014b2d60259$exports.getVisitorId = $d77b1014b2d60259$var$getVisitorId;
const $d77b1014b2d60259$var$startTour = (tourId)=>{
    (0, $6b7eba94662c16f5$exports.getIntercomRef)()("startTour", tourId);
};
$d77b1014b2d60259$exports.startTour = $d77b1014b2d60259$var$startTour;
const $d77b1014b2d60259$var$showArticle = (articleId)=>{
    (0, $6b7eba94662c16f5$exports.getIntercomRef)()("showArticle", articleId);
};
$d77b1014b2d60259$exports.showArticle = $d77b1014b2d60259$var$showArticle;
const $d77b1014b2d60259$var$showNews = (newsItemId)=>{
    (0, $6b7eba94662c16f5$exports.getIntercomRef)()("showNews", newsItemId);
};
$d77b1014b2d60259$exports.showNews = $d77b1014b2d60259$var$showNews;
const $d77b1014b2d60259$var$startSurvey = (surveyId)=>{
    (0, $6b7eba94662c16f5$exports.getIntercomRef)()("startSurvey", surveyId);
};
$d77b1014b2d60259$exports.startSurvey = $d77b1014b2d60259$var$startSurvey;
const $d77b1014b2d60259$var$startChecklist = (checklistId)=>{
    (0, $6b7eba94662c16f5$exports.getIntercomRef)()("startChecklist", checklistId);
};
$d77b1014b2d60259$exports.startChecklist = $d77b1014b2d60259$var$startChecklist;
const $d77b1014b2d60259$var$showTicket = (ticketId)=>{
    (0, $6b7eba94662c16f5$exports.getIntercomRef)()("showTicket", ticketId);
};
$d77b1014b2d60259$exports.showTicket = $d77b1014b2d60259$var$showTicket;
const $d77b1014b2d60259$var$showConversation = (conversationId)=>{
    (0, $6b7eba94662c16f5$exports.getIntercomRef)()("showConversation", conversationId);
};
$d77b1014b2d60259$exports.showConversation = $d77b1014b2d60259$var$showConversation;
const $d77b1014b2d60259$var$onUserEmailSupplied = (callback)=>{
    (0, $6b7eba94662c16f5$exports.getIntercomRef)()("onUserEmailSupplied", callback);
};
$d77b1014b2d60259$exports.onUserEmailSupplied = $d77b1014b2d60259$var$onUserEmailSupplied;


parcelRequire("8vofH");
var $7TObl = parcelRequire("7TObl");
parcelRequire("8vofH");
var $7TObl = parcelRequire("7TObl");

var $b6HlZ = parcelRequire("b6HlZ");
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function $603d4f5da0d29b2c$var$__awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $603d4f5da0d29b2c$var$__generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ var $603d4f5da0d29b2c$var$__assign = function() {
    $603d4f5da0d29b2c$var$__assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $603d4f5da0d29b2c$var$__assign.apply(this, arguments);
};
var $603d4f5da0d29b2c$var$defaultState = function(defaultValue) {
    return {
        loading: defaultValue === undefined || defaultValue === null,
        value: defaultValue
    };
};
var $603d4f5da0d29b2c$var$reducer = function() {
    return function(state, action) {
        switch(action.type){
            case "error":
                return $603d4f5da0d29b2c$var$__assign($603d4f5da0d29b2c$var$__assign({}, state), {
                    error: action.error,
                    loading: false,
                    value: undefined
                });
            case "reset":
                return $603d4f5da0d29b2c$var$defaultState(action.defaultValue);
            case "value":
                return $603d4f5da0d29b2c$var$__assign($603d4f5da0d29b2c$var$__assign({}, state), {
                    error: undefined,
                    loading: false,
                    value: action.value
                });
            default:
                return state;
        }
    };
};
var $603d4f5da0d29b2c$var$useLoadingValue = function(getDefaultValue) {
    var defaultValue = getDefaultValue ? getDefaultValue() : undefined;
    var _a = (0, $b6HlZ.useReducer)($603d4f5da0d29b2c$var$reducer(), $603d4f5da0d29b2c$var$defaultState(defaultValue)), state = _a[0], dispatch = _a[1];
    var reset = (0, $b6HlZ.useCallback)(function() {
        var defaultValue = getDefaultValue ? getDefaultValue() : undefined;
        dispatch({
            type: "reset",
            defaultValue: defaultValue
        });
    }, [
        getDefaultValue
    ]);
    var setError = (0, $b6HlZ.useCallback)(function(error) {
        dispatch({
            type: "error",
            error: error
        });
    }, []);
    var setValue = (0, $b6HlZ.useCallback)(function(value) {
        dispatch({
            type: "value",
            value: value
        });
    }, []);
    return (0, $b6HlZ.useMemo)(function() {
        return {
            error: state.error,
            loading: state.loading,
            reset: reset,
            setError: setError,
            setValue: setValue,
            value: state.value
        };
    }, [
        state.error,
        state.loading,
        reset,
        setError,
        setValue,
        state.value
    ]);
};
var $603d4f5da0d29b2c$var$useComparatorRef = function(value, isEqual, onChange) {
    var ref = (0, $b6HlZ.useRef)(value);
    (0, $b6HlZ.useEffect)(function() {
        if (!isEqual(value, ref.current)) {
            ref.current = value;
            if (onChange) onChange();
        }
    });
    return ref;
};
var $603d4f5da0d29b2c$var$useIsMounted = function() {
    var _a = (0, $b6HlZ.useState)(true), isMounted = _a[0], setIsMounted = _a[1];
    (0, $b6HlZ.useEffect)(function() {
        return function() {
            setIsMounted(false);
        };
    }, []);
    return isMounted;
};
var $603d4f5da0d29b2c$var$isRefEqual = function(v1, v2) {
    var bothNull = !v1 && !v2;
    var equal = !!v1 && !!v2 && (0, $7TObl.refEqual)(v1, v2);
    return bothNull || equal;
};
var $603d4f5da0d29b2c$var$useIsFirestoreRefEqual = function(value, onChange) {
    return $603d4f5da0d29b2c$var$useComparatorRef(value, $603d4f5da0d29b2c$var$isRefEqual, onChange);
};
var $603d4f5da0d29b2c$var$isQueryEqual = function(v1, v2) {
    var bothNull = !v1 && !v2;
    var equal = !!v1 && !!v2 && (0, $7TObl.queryEqual)(v1, v2);
    return bothNull || equal;
};
var $603d4f5da0d29b2c$var$useIsFirestoreQueryEqual = function(value, onChange) {
    return $603d4f5da0d29b2c$var$useComparatorRef(value, $603d4f5da0d29b2c$var$isQueryEqual, onChange);
};
var $603d4f5da0d29b2c$export$6cd28814d92fa9c9 = function(query, options) {
    var _a = $603d4f5da0d29b2c$var$useLoadingValue(), error = _a.error, loading = _a.loading, reset = _a.reset, setError = _a.setError, setValue = _a.setValue, value = _a.value;
    var ref = $603d4f5da0d29b2c$var$useIsFirestoreQueryEqual(query, reset);
    (0, $b6HlZ.useEffect)(function() {
        if (!ref.current) {
            setValue(undefined);
            return;
        }
        var unsubscribe = (options === null || options === void 0 ? void 0 : options.snapshotListenOptions) ? (0, $7TObl.onSnapshot)(ref.current, options.snapshotListenOptions, setValue, setError) : (0, $7TObl.onSnapshot)(ref.current, setValue, setError);
        return function() {
            unsubscribe();
        };
    }, [
        ref.current
    ]);
    return [
        value,
        loading,
        error
    ];
};
var $603d4f5da0d29b2c$export$b806f8b31e648973 = function(query, options) {
    var _a = $603d4f5da0d29b2c$var$useLoadingValue(), error = _a.error, loading = _a.loading, reset = _a.reset, setError = _a.setError, setValue = _a.setValue, value = _a.value;
    var isMounted = $603d4f5da0d29b2c$var$useIsMounted();
    var ref = $603d4f5da0d29b2c$var$useIsFirestoreQueryEqual(query, reset);
    var loadData = (0, $b6HlZ.useCallback)(function(query, options) {
        return $603d4f5da0d29b2c$var$__awaiter(void 0, void 0, void 0, function() {
            var get, result, error_1;
            return $603d4f5da0d29b2c$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!query) {
                            setValue(undefined);
                            return [
                                2 /*return*/ 
                            ];
                        }
                        get = $603d4f5da0d29b2c$var$getDocsFnFromGetOptions(options === null || options === void 0 ? void 0 : options.getOptions);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            get(query)
                        ];
                    case 2:
                        result = _a.sent();
                        if (isMounted) setValue(result);
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        error_1 = _a.sent();
                        if (isMounted) setError(error_1);
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }, []);
    var reloadData = (0, $b6HlZ.useCallback)(function() {
        return loadData(ref.current, options);
    }, [
        loadData,
        ref.current
    ]);
    (0, $b6HlZ.useEffect)(function() {
        loadData(ref.current, options);
    }, [
        ref.current
    ]);
    return [
        value,
        loading,
        error,
        reloadData
    ];
};
var $603d4f5da0d29b2c$export$f976898995c345b4 = function(query, options) {
    var _a = $603d4f5da0d29b2c$export$6cd28814d92fa9c9(query, options), snapshots = _a[0], loading = _a[1], error = _a[2];
    var values = $603d4f5da0d29b2c$var$getValuesFromSnapshots(snapshots, options === null || options === void 0 ? void 0 : options.snapshotOptions, options === null || options === void 0 ? void 0 : options.initialValue);
    return [
        values,
        loading,
        error,
        snapshots
    ];
};
var $603d4f5da0d29b2c$export$97bdb71edd3a292f = function(query, options) {
    var _a = $603d4f5da0d29b2c$export$b806f8b31e648973(query, options), snapshots = _a[0], loading = _a[1], error = _a[2], reloadData = _a[3];
    var values = $603d4f5da0d29b2c$var$getValuesFromSnapshots(snapshots, options === null || options === void 0 ? void 0 : options.snapshotOptions, options === null || options === void 0 ? void 0 : options.initialValue);
    return [
        values,
        loading,
        error,
        snapshots,
        reloadData
    ];
};
var $603d4f5da0d29b2c$var$getValuesFromSnapshots = function(snapshots, options, initialValue) {
    return (0, $b6HlZ.useMemo)(function() {
        var _a;
        return (_a = snapshots === null || snapshots === void 0 ? void 0 : snapshots.docs.map(function(doc) {
            return doc.data(options);
        })) !== null && _a !== void 0 ? _a : initialValue;
    }, [
        snapshots,
        options
    ]);
};
var $603d4f5da0d29b2c$var$getDocsFnFromGetOptions = function(_a) {
    var _b = _a === void 0 ? {
        source: "default"
    } : _a, source = _b.source;
    switch(source){
        default:
        case "default":
            return 0, $7TObl.getDocs;
        case "cache":
            return 0, $7TObl.getDocsFromCache;
        case "server":
            return 0, $7TObl.getDocsFromServer;
    }
};
var $603d4f5da0d29b2c$export$e71e2fb5c5c476d5 = function(docRef, options) {
    var _a = $603d4f5da0d29b2c$var$useLoadingValue(), error = _a.error, loading = _a.loading, reset = _a.reset, setError = _a.setError, setValue = _a.setValue, value = _a.value;
    var ref = $603d4f5da0d29b2c$var$useIsFirestoreRefEqual(docRef, reset);
    (0, $b6HlZ.useEffect)(function() {
        if (!ref.current) {
            setValue(undefined);
            return;
        }
        var unsubscribe = (options === null || options === void 0 ? void 0 : options.snapshotListenOptions) ? (0, $7TObl.onSnapshot)(ref.current, options.snapshotListenOptions, setValue, setError) : (0, $7TObl.onSnapshot)(ref.current, setValue, setError);
        return function() {
            unsubscribe();
        };
    }, [
        ref.current
    ]);
    return [
        value,
        loading,
        error
    ];
};
var $603d4f5da0d29b2c$export$7d9b51c0f5747a63 = function(docRef, options) {
    var _a = $603d4f5da0d29b2c$var$useLoadingValue(), error = _a.error, loading = _a.loading, reset = _a.reset, setError = _a.setError, setValue = _a.setValue, value = _a.value;
    var isMounted = $603d4f5da0d29b2c$var$useIsMounted();
    var ref = $603d4f5da0d29b2c$var$useIsFirestoreRefEqual(docRef, reset);
    var loadData = (0, $b6HlZ.useCallback)(function(reference, options) {
        return $603d4f5da0d29b2c$var$__awaiter(void 0, void 0, void 0, function() {
            var get, result, error_1;
            return $603d4f5da0d29b2c$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!reference) {
                            setValue(undefined);
                            return [
                                2 /*return*/ 
                            ];
                        }
                        get = $603d4f5da0d29b2c$var$getDocFnFromGetOptions(options === null || options === void 0 ? void 0 : options.getOptions);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            get(reference)
                        ];
                    case 2:
                        result = _a.sent();
                        if (isMounted) setValue(result);
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        error_1 = _a.sent();
                        if (isMounted) setError(error_1);
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }, []);
    var reloadData = (0, $b6HlZ.useCallback)(function() {
        return loadData(ref.current, options);
    }, [
        loadData,
        ref.current
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (!ref.current) {
            setValue(undefined);
            return;
        }
        loadData(ref.current, options);
    }, [
        ref.current
    ]);
    return [
        value,
        loading,
        error,
        reloadData
    ];
};
var $603d4f5da0d29b2c$export$d8c0c0b7453663d0 = function(docRef, options) {
    var _a = $603d4f5da0d29b2c$export$e71e2fb5c5c476d5(docRef, options), snapshot = _a[0], loading = _a[1], error = _a[2];
    var value = $603d4f5da0d29b2c$var$getValueFromSnapshot(snapshot, options === null || options === void 0 ? void 0 : options.snapshotOptions, options === null || options === void 0 ? void 0 : options.initialValue);
    return [
        value,
        loading,
        error,
        snapshot
    ];
};
var $603d4f5da0d29b2c$export$3d94ca782eda2c23 = function(docRef, options) {
    var _a = $603d4f5da0d29b2c$export$7d9b51c0f5747a63(docRef, options), snapshot = _a[0], loading = _a[1], error = _a[2], reloadData = _a[3];
    var value = $603d4f5da0d29b2c$var$getValueFromSnapshot(snapshot, options === null || options === void 0 ? void 0 : options.snapshotOptions, options === null || options === void 0 ? void 0 : options.initialValue);
    return [
        value,
        loading,
        error,
        snapshot,
        reloadData
    ];
};
var $603d4f5da0d29b2c$var$getDocFnFromGetOptions = function(_a) {
    var _b = _a === void 0 ? {
        source: "default"
    } : _a, source = _b.source;
    switch(source){
        default:
        case "default":
            return 0, $7TObl.getDoc;
        case "cache":
            return 0, $7TObl.getDocFromCache;
        case "server":
            return 0, $7TObl.getDocFromServer;
    }
};
var $603d4f5da0d29b2c$var$getValueFromSnapshot = function(snapshot, options, initialValue) {
    return (0, $b6HlZ.useMemo)(function() {
        var _a;
        return (_a = snapshot === null || snapshot === void 0 ? void 0 : snapshot.data(options)) !== null && _a !== void 0 ? _a : initialValue;
    }, [
        snapshot,
        options,
        initialValue
    ]);
};




parcelRequire("b6HlZ");
var $3468f4655cb34353$exports = {};
$3468f4655cb34353$exports = {
    formatCurrencyCompact: (amountInCents, currency)=>{
        const amount = amountInCents / 100.0;
        return `${new Intl.NumberFormat("en-CA", {
            style: "currency",
            currency: currency,
            currencyDisplay: "narrowSymbol",
            minimumFractionDigits: amount % 1 === 0 ? 0 : 2,
            maximumFractionDigits: 2
        }).format(amount).replace("US$", "$")}`;
    },
    formatCurrency: (amountInCents, currency)=>{
        const amount = amountInCents / 100.0;
        const symbol = currency.toLowerCase() === "cad" ? "CA$" : "US$";
        return `${new Intl.NumberFormat("en-CA", {
            style: "currency",
            currency: currency,
            minimumFractionDigits: amount % 1 === 0 ? 0 : 2,
            maximumFractionDigits: 2
        }).format(amount).replace("US$", "$").replace("$", symbol)}`;
    },
    formatDiscount: (discount)=>{
        return new Intl.NumberFormat("en-US", {
            style: "percent",
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        }).format(discount);
    }
};


const $77e4b6b5b316a4cb$var$InvoiceItem = ({ label: label, value: value, currency: currency, boldLabel: boldLabel = false })=>{
    return /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsxs)("div", {
        className: "flex flex-row justify-between items-center gap-2",
        children: [
            /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)("p", {
                className: `${boldLabel ? "font-bold" : ""}`,
                children: label
            }),
            /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)("p", {
                children: value === 0 ? "TBD" : (0, $3468f4655cb34353$exports.formatCurrency)(value, currency)
            })
        ]
    });
};
var $77e4b6b5b316a4cb$export$2e2bcd8739ae039 = $77e4b6b5b316a4cb$var$InvoiceItem;



parcelRequire("b6HlZ");

const $2b4669b8fe7a2697$export$7f7cbe89f1eacd2 = ({ className: className, ...options })=>/*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsxs)("svg", {
        fill: "none",
        "aria-hidden": "true",
        viewBox: "0 0 100 101",
        xmlns: "http://www.w3.org/2000/svg",
        className: `w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-purple-400 ${className}`,
        ...options,
        children: [
            /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)("path", {
                d: "M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)("path", {
                d: "M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z",
                fill: "currentFill"
            })
        ]
    });


const $b10e2d2452b40b3d$var$Button = ({ title: title, icon: icon, loading: loading, disabled: disabled, className: className, ...rest })=>{
    return /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsxs)("button", {
        disabled: loading || disabled,
        className: `relative inline-flex justify-center items-center w-full bg-primary px-2 gap-1 h-11 text-white rounded-full ${className} ${loading || disabled ? "opacity-70 cursor-not-allowed" : ""}`,
        ...rest,
        children: [
            /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)("img", {
                src: icon,
                alt: ""
            }),
            title,
            loading && /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)((0, $2b4669b8fe7a2697$export$7f7cbe89f1eacd2), {
                className: "absolute right-4 !w-4 !h-4"
            })
        ]
    });
};
var $b10e2d2452b40b3d$export$2e2bcd8739ae039 = $b10e2d2452b40b3d$var$Button;


var $de2817a4dbca19db$exports = {};

$de2817a4dbca19db$exports = (parcelRequire("fF0r8")).getBundleURL("7lpHJ") + "clock.590229c4.png";



const $831bd3f164fcae83$export$cbb02010c362b2ab = {
    lat: 43.644379939764086,
    lng: -79.39865381355503
};
const $831bd3f164fcae83$export$2b2d40e59ff98185 = {
    "Meeting Room": "Meeting-Space",
    "Private Office": "Private-Office",
    "Flexday Suite": "Flexday-Suite"
};


const $407defcb875a9eb9$var$BookingConfigurator = ({ inventoryPageId: inventoryPageId, currency: currency })=>{
    const MIN_DISCOUNT_DAYS = 3;
    const [dates, setDates] = (0, $b6HlZ.useState)([]);
    const [loading, setLoading] = (0, $b6HlZ.useState)(false);
    const [inventory, setInventory] = (0, $b6HlZ.useState)({});
    const [isCartEmpty, setIsCartEmpty] = (0, $b6HlZ.useState)(true);
    const cartId = window.localStorage.getItem("cartId");
    const { getFirebaseConfig: getFirebaseConfig } = (0, $a5a6fab2525fdce6$exports.Helpers);
    const firebaseConfig = getFirebaseConfig({
        REACT_APP_FIREBASE_API_KEY: "AIzaSyBoIeHTyO2Zr6jARvqrWPPAlqi3pdu2-KA",
        REACT_APP_FIREBASE_APP_ID: "1:717114758534:web:c0f5a5118efc5855164807",
        REACT_APP_FIREBASE_MESSAGE_SENDER_ID: "717114758534",
        REACT_APP_FIREBASE_PROJECT_ID: "flexday-6dacf"
    });
    const app = (0, $iXpG9.initializeApp)(firebaseConfig);
    const firestore = (0, $7TObl.getFirestore)(app);
    (0, $b6HlZ.useEffect)(()=>{
        async function getCart() {
            const snapshot = await (0, $7TObl.getDoc)((0, $7TObl.doc)(firestore, "carts", cartId));
            const cart = snapshot.data();
            if (cart) {
                const inventoryPageIds = Object.keys(cart || {}).filter((_)=>_ !== "createdAt");
                setIsCartEmpty(!inventoryPageIds.length);
                setDates(cart[inventoryPageId] ? cart[inventoryPageId].data.dates.map((_)=>new Date(_)) : []);
            } else {
                const docRef = await (0, $7TObl.addDoc)((0, $7TObl.collection)(firestore, "carts"), {});
                window.localStorage.setItem("cartId", docRef.id);
            }
        }
        if (cartId) getCart();
    }, [
        inventoryPageId,
        cartId,
        firestore
    ]);
    const addToCart = async ()=>{
        setLoading(true);
        const document = {
            [inventoryPageId]: {
                quantity: dates.length,
                discount: dates.length >= MIN_DISCOUNT_DAYS ? inventoryPage.stripeDiscount : null,
                price: inventoryPage.stripePrice,
                name: inventoryPage.name,
                images: inventoryPage.images.map((img)=>img.downloadURL),
                currency: currency,
                data: {
                    dates: dates.map((_)=>(0, $8a568d5cdba66624$export$2e2bcd8739ae039)(new Date(_), "yyyy/MM/dd"))
                },
                taxRates: inventoryPage.taxRates
            },
            createdAt: (0, $7TObl.serverTimestamp)()
        };
        try {
            await (0, $d77b1014b2d60259$exports.trackEvent)("User Tapped Inventory CTA", (0, $12f14e722131d005$exports.Utils).flattenObject({
                ctaLabel: isCartEmpty ? "Reserve Now" : "Update Cart",
                inventoryPageId: inventoryPageId,
                name: inventoryPage.name,
                address: inventoryPage.address,
                url: url,
                partnerName: inventoryPage.partnerName,
                partnerAvatar: (inventoryPage.partnerAvatar || []).map((avatar)=>avatar.downloadURL),
                description: inventoryPage.description,
                vanityDescription: inventoryPage.vanityDescription,
                images: document[inventoryPageId].images,
                selectedDates: document[inventoryPageId].data.dates.sort(),
                page: {
                    price: (0, $3468f4655cb34353$exports.formatCurrency)(amountInCents, currency),
                    quantity: dates.length,
                    discountPercentage: (0, $3468f4655cb34353$exports.formatDiscount)(inventoryPage.discount),
                    discountAmount: (0, $3468f4655cb34353$exports.formatCurrency)(discount, currency),
                    total: (0, $3468f4655cb34353$exports.formatCurrency)(totalInCents, currency),
                    subTotal: (0, $3468f4655cb34353$exports.formatCurrency)(totalInCents - discount, currency)
                }
            }));
        } catch (error) {
            console.error("Failed to send to Intercom", error);
        }
        if (cartId) await (0, $7TObl.updateDoc)((0, $7TObl.doc)(firestore, "carts", cartId), document);
        else {
            const docRef = await (0, $7TObl.addDoc)((0, $7TObl.collection)(firestore, "carts"), document);
            window.localStorage.setItem("cartId", docRef.id);
        }
        setTimeout(()=>{
            setLoading(false);
            window.location.href = `${"https://www.flexday.com"}/cart`;
        }, 1500);
    };
    const getFirstAvailableDate = (leadTimeInDays = 0)=>{
        let remainingDays = leadTimeInDays;
        const startDate = new Date();
        while(remainingDays > 0){
            startDate.setDate(startDate.getDate() + 1);
            // Exclude weekends (Saturday & Sunday)
            if (startDate.getDay() !== 6 && startDate.getDay() !== 0) remainingDays--;
        }
        return startDate;
    };
    const fromDate = getFirstAvailableDate(inventory === null || inventory === void 0 ? void 0 : inventory.leadTimeInDays);
    const getInventoryEventData = ()=>{
        return (0, $12f14e722131d005$exports.Utils).flattenObject({
            inventoryPageId: inventoryPageId,
            name: inventoryPage.name,
            address: inventoryPage.address,
            url: url,
            partnerName: inventoryPage.partnerName,
            partnerAvatar: (inventoryPage.partnerAvatar || []).map((avatar)=>avatar.downloadURL),
            description: inventoryPage.description,
            vanityDescription: inventoryPage.vanityDescription,
            images: inventoryPage.images.map((image)=>image.downloadURL)
        });
    };
    const [inventoryPage] = (0, $603d4f5da0d29b2c$export$d8c0c0b7453663d0)((0, $7TObl.doc)(firestore, "inventoryPages", inventoryPageId));
    const slug = (0, $12f14e722131d005$exports.Utils).slugifyName(inventoryPage === null || inventoryPage === void 0 ? void 0 : inventoryPage.name);
    const url = `${"https://www.flexday.com"}/suite/${slug}`;
    (0, $b6HlZ.useEffect)(async ()=>{
        if (inventoryPage) {
            try {
                await (0, $d77b1014b2d60259$exports.trackEvent)("User Viewed Inventory", getInventoryEventData());
            } catch (error) {
                console.error("Failed to send to Intercom", error);
            }
            setInventory((await (0, $7TObl.getDoc)(inventoryPage.inventory)).data());
        }
    }, [
        inventoryPage
    ]);
    // Helper function to check if a date is a weekend (Saturday or Sunday)
    const isWeekend = (date)=>{
        const day = date.getDay();
        return day === 0 || day === 6;
    };
    // Helper function to check if a date is unavailable
    const isUnavailableDate = (date)=>{
        return (inventory.unavailableDates || []).includes((0, $8a568d5cdba66624$export$2e2bcd8739ae039)(new Date(date), "yyyy/MM/dd"));
    };
    // Helper function to determine if a date should be disabled
    const isDisabled = (date)=>{
        return isWeekend(date) || isUnavailableDate(date);
    };
    const onPromoCTA = ()=>{
        let url = new URL(`${"https://www.flexday.com"}/book-workspace`);
        url.searchParams.append("selectedlocation", inventoryPage.address);
        url.searchParams.append("selectedSpace", (0, $831bd3f164fcae83$export$2b2d40e59ff98185)["Flexday Suite"]);
        window.location.href = url.href;
    };
    if (!inventoryPage) return null;
    const isOnDemand = inventoryPage.commitmentTerms.includes("On Demand");
    const amountInCents = isOnDemand ? inventoryPage.prices.onDemand[currency.toLowerCase()].amountInCents : inventoryPage.prices.longTerm[currency.toLowerCase()].amountInCents;
    const totalInCents = amountInCents * dates.length || 0;
    const discount = dates.length >= MIN_DISCOUNT_DAYS ? dates.length * amountInCents * (inventoryPage.discount || 0) : 0;
    return /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsxs)("div", {
        className: "flex flex-col items-center gap-4 bg-white p-4 rounded-[20px]",
        children: [
            /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsxs)("div", {
                className: "flex w-full justify-stretch items-center gap-2 mb-2",
                children: [
                    /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsxs)("p", {
                        className: "font-bold text-2xl text-center whitespace-nowrap flex-initial w-1/2",
                        children: [
                            (0, $3468f4655cb34353$exports.formatCurrencyCompact)(amountInCents, currency),
                            " ",
                            /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)("br", {}),
                            isOnDemand && "per day",
                            !isOnDemand && /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)("span", {
                                className: "text-base",
                                children: "starting per month"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)("p", {
                        className: "w-full text-sm text-center flex-auto w-1/2",
                        children: /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)("span", {
                            className: "border-b border-slate-600",
                            children: inventoryPage.generalLocation
                        })
                    })
                ]
            }),
            inventoryPage.discount > 0 && /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsxs)("div", {
                className: "flex justify-center items-center p-2 gap-2",
                children: [
                    /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)("div", {
                        className: "bg-slate-100 p-2 rounded-full",
                        children: /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)("img", {
                            alt: "clock",
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($de2817a4dbca19db$exports))),
                            className: "text-slate-400 w-12 opacity-[0.15]"
                        })
                    }),
                    /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsxs)("p", {
                        className: "text-sm text-center",
                        children: [
                            "Reserve ",
                            MIN_DISCOUNT_DAYS,
                            " or more days and get a",
                            " ",
                            /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsxs)("strong", {
                                children: [
                                    (0, $3468f4655cb34353$exports.formatDiscount)(inventoryPage.discount),
                                    " discount"
                                ]
                            }),
                            " ",
                            "on this fractional office."
                        ]
                    })
                ]
            }),
            isOnDemand && /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsxs)((0, $94829a8b99aa12e4$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsxs)("div", {
                        className: "flex flex-col items-center gap-2",
                        children: [
                            /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)((0, $89da45f89b022bca$export$97e6db89a86ff7ab), {
                                fixedWeeks: true,
                                mode: "multiple",
                                selected: dates,
                                onSelect: setDates,
                                disabled: isDisabled,
                                fromDate: fromDate,
                                className: "border border-slate-200 p-2 rounded m-0"
                            }),
                            /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)("p", {
                                className: "text-xs text-center",
                                children: "Please mark specific dates needed."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsxs)("p", {
                        className: "text-sm text-center italic",
                        children: [
                            /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)("strong", {
                                children: "Note:"
                            }),
                            " This room holds up to",
                            " ",
                            /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)("b", {
                                children: inventoryPage.maxCapacity
                            }),
                            " people."
                        ]
                    }),
                    /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsxs)("div", {
                        className: "flex flex-col items-center gap-2 my-2",
                        children: [
                            /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)((0, $b10e2d2452b40b3d$export$2e2bcd8739ae039), {
                                loading: loading,
                                title: isCartEmpty ? "Reserve Now" : "Update Cart",
                                className: "!w-44 !bg-[#652cb3] rounded-lg hover:opacity-75 transition-opacity",
                                onClick: addToCart,
                                disabled: !dates.length
                            }),
                            /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)("p", {
                                className: "text-xs text-center",
                                children: "Below is an estimate. You won't be charged yet."
                            })
                        ]
                    }),
                    totalInCents > 0 && /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsxs)("div", {
                        className: "flex flex-col gap-4 mt-4 w-full",
                        children: [
                            /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)((0, $77e4b6b5b316a4cb$export$2e2bcd8739ae039), {
                                value: totalInCents,
                                currency: currency,
                                label: `${(0, $3468f4655cb34353$exports.formatCurrency)(amountInCents, currency)} \xd7 ${dates.length} day${dates.length === 1 ? "" : "s"}`
                            }),
                            discount ? /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)((0, $77e4b6b5b316a4cb$export$2e2bcd8739ae039), {
                                value: discount,
                                currency: currency,
                                label: `Discount (${(0, $3468f4655cb34353$exports.formatDiscount)(inventoryPage.discount)})`
                            }) : null,
                            /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)((0, $77e4b6b5b316a4cb$export$2e2bcd8739ae039), {
                                boldLabel: true,
                                label: "Sub-Total *",
                                value: `${totalInCents - discount}`,
                                currency: currency
                            }),
                            /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)("p", {
                                className: "text-sm mt-2 italic",
                                children: "* Plus applicable taxes."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)("hr", {
                        className: "h-px bg-slate-200 border-1 w-full"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsxs)("div", {
                className: "self-stretch flex flex-col gap-1 mt-4",
                children: [
                    /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)("p", {
                        className: "font-bold italic",
                        children: inventoryPage.promoHeadline
                    }),
                    /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)("div", {
                        className: "markdown-container",
                        children: /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)((0, $fcd6f0226a0ae730$export$83ef7ab426386201), {
                            remarkPlugins: [
                                (0, $1185306d23556d57$export$2e2bcd8739ae039)
                            ],
                            children: inventoryPage.promoDescription
                        })
                    }),
                    /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)((0, $b10e2d2452b40b3d$export$2e2bcd8739ae039), {
                        title: inventoryPage.promoCta,
                        className: "self-center !w-32 mt-2 !bg-[#652cb3] rounded-lg hover:opacity-75 transition-opacity",
                        onClick: onPromoCTA
                    })
                ]
            })
        ]
    });
};
var $407defcb875a9eb9$export$2e2bcd8739ae039 = $407defcb875a9eb9$var$BookingConfigurator;




var $b6HlZ = parcelRequire("b6HlZ");

var $iXpG9 = parcelRequire("iXpG9");
parcelRequire("8vofH");
var $7TObl = parcelRequire("7TObl");


parcelRequire("b6HlZ");
var $873df070a83fdd16$exports = {};

$873df070a83fdd16$exports = (parcelRequire("fF0r8")).getBundleURL("7lpHJ") + "chat.9aae76f3.svg";




parcelRequire("b6HlZ");
var $840450214059b8a0$exports = {};
"use strict";
Object.defineProperty($840450214059b8a0$exports, "__esModule", {
    value: true
});
Object.defineProperty($840450214059b8a0$exports, "Carousel", {
    enumerable: true,
    get: function get() {
        return $840450214059b8a0$var$_Carousel.default;
    }
});
Object.defineProperty($840450214059b8a0$exports, "CarouselProps", {
    enumerable: true,
    get: function get() {
        return $4e5f51f316ee16bf$exports.CarouselProps;
    }
});
Object.defineProperty($840450214059b8a0$exports, "Thumbs", {
    enumerable: true,
    get: function get() {
        return $840450214059b8a0$var$_Thumbs.default;
    }
});

var $840450214059b8a0$var$_Carousel = $840450214059b8a0$var$_interopRequireDefault((parcelRequire("hF8pm")));
var $4e5f51f316ee16bf$exports = {};
"use strict";



var $840450214059b8a0$var$_Thumbs = $840450214059b8a0$var$_interopRequireDefault((parcelRequire("lRg1u")));
function $840450214059b8a0$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}



var $ed94513a3acda713$exports = {};


(()=>{
    var e = {
        296: (e, t, r)=>{
            var o = /^\s+|\s+$/g, n = /^[-+]0x[0-9a-f]+$/i, i = /^0b[01]+$/i, c = /^0o[0-7]+$/i, u = parseInt, s = "object" == typeof r.g && r.g && r.g.Object === Object && r.g, l = "object" == typeof self && self && self.Object === Object && self, a = s || l || Function("return this")(), f = Object.prototype.toString, p = Math.max, y = Math.min, d = function() {
                return a.Date.now();
            };
            function b(e) {
                var t = typeof e;
                return !!e && ("object" == t || "function" == t);
            }
            function h(e) {
                if ("number" == typeof e) return e;
                if (function(e) {
                    return "symbol" == typeof e || function(e) {
                        return !!e && "object" == typeof e;
                    }(e) && "[object Symbol]" == f.call(e);
                }(e)) return NaN;
                if (b(e)) {
                    var t = "function" == typeof e.valueOf ? e.valueOf() : e;
                    e = b(t) ? t + "" : t;
                }
                if ("string" != typeof e) return 0 === e ? e : +e;
                e = e.replace(o, "");
                var r = i.test(e);
                return r || c.test(e) ? u(e.slice(2), r ? 2 : 8) : n.test(e) ? NaN : +e;
            }
            e.exports = function(e, t, r) {
                var o, n, i, c, u, s, l = 0, a = !1, f = !1, v = !0;
                if ("function" != typeof e) throw new TypeError("Expected a function");
                function m(t) {
                    var r = o, i = n;
                    return o = n = void 0, l = t, c = e.apply(i, r);
                }
                function O(e) {
                    var r = e - s;
                    return void 0 === s || r >= t || r < 0 || f && e - l >= i;
                }
                function w() {
                    var e = d();
                    if (O(e)) return g(e);
                    u = setTimeout(w, function(e) {
                        var r = t - (e - s);
                        return f ? y(r, i - (e - l)) : r;
                    }(e));
                }
                function g(e) {
                    return u = void 0, v && o ? m(e) : (o = n = void 0, c);
                }
                function P() {
                    var e = d(), r = O(e);
                    if (o = arguments, n = this, s = e, r) {
                        if (void 0 === u) return function(e) {
                            return l = e, u = setTimeout(w, t), a ? m(e) : c;
                        }(s);
                        if (f) return u = setTimeout(w, t), m(s);
                    }
                    return void 0 === u && (u = setTimeout(w, t)), c;
                }
                return t = h(t) || 0, b(r) && (a = !!r.leading, i = (f = "maxWait" in r) ? p(h(r.maxWait) || 0, t) : i, v = "trailing" in r ? !!r.trailing : v), P.cancel = function() {
                    void 0 !== u && clearTimeout(u), l = 0, o = s = n = u = void 0;
                }, P.flush = function() {
                    return void 0 === u ? c : g(d());
                }, P;
            };
        },
        96: (e, t, r)=>{
            var o = "Expected a function", n = NaN, i = "[object Symbol]", c = /^\s+|\s+$/g, u = /^[-+]0x[0-9a-f]+$/i, s = /^0b[01]+$/i, l = /^0o[0-7]+$/i, a = parseInt, f = "object" == typeof r.g && r.g && r.g.Object === Object && r.g, p = "object" == typeof self && self && self.Object === Object && self, y = f || p || Function("return this")(), d = Object.prototype.toString, b = Math.max, h = Math.min, v = function() {
                return y.Date.now();
            };
            function m(e) {
                var t = typeof e;
                return !!e && ("object" == t || "function" == t);
            }
            function O(e) {
                if ("number" == typeof e) return e;
                if (function(e) {
                    return "symbol" == typeof e || function(e) {
                        return !!e && "object" == typeof e;
                    }(e) && d.call(e) == i;
                }(e)) return n;
                if (m(e)) {
                    var t = "function" == typeof e.valueOf ? e.valueOf() : e;
                    e = m(t) ? t + "" : t;
                }
                if ("string" != typeof e) return 0 === e ? e : +e;
                e = e.replace(c, "");
                var r = s.test(e);
                return r || l.test(e) ? a(e.slice(2), r ? 2 : 8) : u.test(e) ? n : +e;
            }
            e.exports = function(e, t, r) {
                var n = !0, i = !0;
                if ("function" != typeof e) throw new TypeError(o);
                return m(r) && (n = "leading" in r ? !!r.leading : n, i = "trailing" in r ? !!r.trailing : i), function(e, t, r) {
                    var n, i, c, u, s, l, a = 0, f = !1, p = !1, y = !0;
                    if ("function" != typeof e) throw new TypeError(o);
                    function d(t) {
                        var r = n, o = i;
                        return n = i = void 0, a = t, u = e.apply(o, r);
                    }
                    function w(e) {
                        var r = e - l;
                        return void 0 === l || r >= t || r < 0 || p && e - a >= c;
                    }
                    function g() {
                        var e = v();
                        if (w(e)) return P(e);
                        s = setTimeout(g, function(e) {
                            var r = t - (e - l);
                            return p ? h(r, c - (e - a)) : r;
                        }(e));
                    }
                    function P(e) {
                        return s = void 0, y && n ? d(e) : (n = i = void 0, u);
                    }
                    function j() {
                        var e = v(), r = w(e);
                        if (n = arguments, i = this, l = e, r) {
                            if (void 0 === s) return function(e) {
                                return a = e, s = setTimeout(g, t), f ? d(e) : u;
                            }(l);
                            if (p) return s = setTimeout(g, t), d(l);
                        }
                        return void 0 === s && (s = setTimeout(g, t)), u;
                    }
                    return t = O(t) || 0, m(r) && (f = !!r.leading, c = (p = "maxWait" in r) ? b(O(r.maxWait) || 0, t) : c, y = "trailing" in r ? !!r.trailing : y), j.cancel = function() {
                        void 0 !== s && clearTimeout(s), a = 0, n = l = i = s = void 0;
                    }, j.flush = function() {
                        return void 0 === s ? u : P(v());
                    }, j;
                }(e, t, {
                    leading: n,
                    maxWait: t,
                    trailing: i
                });
            };
        },
        703: (e, t, r)=>{
            "use strict";
            var o = r(414);
            function n() {}
            function i() {}
            i.resetWarningCache = n, e.exports = function() {
                function e(e, t, r, n, i, c) {
                    if (c !== o) {
                        var u = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
                        throw u.name = "Invariant Violation", u;
                    }
                }
                function t() {
                    return e;
                }
                e.isRequired = e;
                var r = {
                    array: e,
                    bigint: e,
                    bool: e,
                    func: e,
                    number: e,
                    object: e,
                    string: e,
                    symbol: e,
                    any: e,
                    arrayOf: t,
                    element: e,
                    elementType: e,
                    instanceOf: t,
                    node: e,
                    objectOf: t,
                    oneOf: t,
                    oneOfType: t,
                    shape: t,
                    exact: t,
                    checkPropTypes: i,
                    resetWarningCache: n
                };
                return r.PropTypes = r, r;
            };
        },
        697: (e, t, r)=>{
            e.exports = r(703)();
        },
        414: (e)=>{
            "use strict";
            e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
        }
    }, t = {};
    function r(o) {
        var n = t[o];
        if (void 0 !== n) return n.exports;
        var i = t[o] = {
            exports: {}
        };
        return e[o](i, i.exports, r), i.exports;
    }
    r.n = (e)=>{
        var t = e && e.__esModule ? ()=>e.default : ()=>e;
        return r.d(t, {
            a: t
        }), t;
    }, r.d = (e, t)=>{
        for(var o in t)r.o(t, o) && !r.o(e, o) && Object.defineProperty(e, o, {
            enumerable: !0,
            get: t[o]
        });
    }, r.g = function() {
        if ("object" == typeof globalThis) return globalThis;
        try {
            return this || new Function("return this")();
        } catch (e) {
            if ("object" == typeof window) return window;
        }
    }(), r.o = (e, t)=>Object.prototype.hasOwnProperty.call(e, t), r.r = (e)=>{
        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
            value: "Module"
        }), Object.defineProperty(e, "__esModule", {
            value: !0
        });
    };
    var o = {};
    (()=>{
        "use strict";
        r.r(o), r.d(o, {
            LazyLoadComponent: ()=>A,
            LazyLoadImage: ()=>ce,
            trackWindowScroll: ()=>M
        });
        const e = (parcelRequire("b6HlZ"));
        var t = r.n(e), n = r(697);
        const i = (parcelRequire("3uMgk"));
        var c = r.n(i);
        function u() {
            return "undefined" != typeof window && "IntersectionObserver" in window && "isIntersecting" in window.IntersectionObserverEntry.prototype;
        }
        function s(e) {
            return s = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e;
            } : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
            }, s(e);
        }
        function l(e, t) {
            var r = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
                var o = Object.getOwnPropertySymbols(e);
                t && (o = o.filter(function(t) {
                    return Object.getOwnPropertyDescriptor(e, t).enumerable;
                })), r.push.apply(r, o);
            }
            return r;
        }
        function a(e, t, r) {
            return (t = p(t)) in e ? Object.defineProperty(e, t, {
                value: r,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e[t] = r, e;
        }
        function f(e, t) {
            for(var r = 0; r < t.length; r++){
                var o = t[r];
                o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, p(o.key), o);
            }
        }
        function p(e) {
            var t = function(e, t) {
                if ("object" !== s(e) || null === e) return e;
                var r = e[Symbol.toPrimitive];
                if (void 0 !== r) {
                    var o = r.call(e, "string");
                    if ("object" !== s(o)) return o;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return String(e);
            }(e);
            return "symbol" === s(t) ? t : String(t);
        }
        function y(e, t) {
            return y = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
                return e.__proto__ = t, e;
            }, y(e, t);
        }
        function d(e) {
            return d = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            }, d(e);
        }
        var b = function(e) {
            e.forEach(function(e) {
                e.isIntersecting && e.target.onVisible();
            });
        }, h = {}, v = function(e) {
            !function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), Object.defineProperty(e, "prototype", {
                    writable: !1
                }), t && y(e, t);
            }(v, e);
            var r, o, n, i, p = (n = v, i = function() {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                } catch (e) {
                    return !1;
                }
            }(), function() {
                var e, t = d(n);
                if (i) {
                    var r = d(this).constructor;
                    e = Reflect.construct(t, arguments, r);
                } else e = t.apply(this, arguments);
                return function(e, t) {
                    if (t && ("object" === s(t) || "function" == typeof t)) return t;
                    if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
                    return function(e) {
                        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                        return e;
                    }(e);
                }(this, e);
            });
            function v(e) {
                var t;
                if (function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, v), (t = p.call(this, e)).supportsObserver = !e.scrollPosition && e.useIntersectionObserver && u(), t.supportsObserver) {
                    var r = e.threshold;
                    t.observer = function(e) {
                        return h[e] = h[e] || new IntersectionObserver(b, {
                            rootMargin: e + "px"
                        }), h[e];
                    }(r);
                }
                return t;
            }
            return r = v, o = [
                {
                    key: "componentDidMount",
                    value: function() {
                        this.placeholder && this.observer && (this.placeholder.onVisible = this.props.onVisible, this.observer.observe(this.placeholder)), this.supportsObserver || this.updateVisibility();
                    }
                },
                {
                    key: "componentWillUnmount",
                    value: function() {
                        this.observer && this.placeholder && this.observer.unobserve(this.placeholder);
                    }
                },
                {
                    key: "componentDidUpdate",
                    value: function() {
                        this.supportsObserver || this.updateVisibility();
                    }
                },
                {
                    key: "getPlaceholderBoundingBox",
                    value: function() {
                        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this.props.scrollPosition, t = this.placeholder.getBoundingClientRect(), r = c().findDOMNode(this.placeholder).style, o = parseInt(r.getPropertyValue("margin-left"), 10) || 0, n = parseInt(r.getPropertyValue("margin-top"), 10) || 0;
                        return {
                            bottom: e.y + t.bottom + n,
                            left: e.x + t.left + o,
                            right: e.x + t.right + o,
                            top: e.y + t.top + n
                        };
                    }
                },
                {
                    key: "isPlaceholderInViewport",
                    value: function() {
                        if ("undefined" == typeof window || !this.placeholder) return !1;
                        var e = this.props, t = e.scrollPosition, r = e.threshold, o = this.getPlaceholderBoundingBox(t), n = t.y + window.innerHeight, i = t.x, c = t.x + window.innerWidth, u = t.y;
                        return Boolean(u - r <= o.bottom && n + r >= o.top && i - r <= o.right && c + r >= o.left);
                    }
                },
                {
                    key: "updateVisibility",
                    value: function() {
                        this.isPlaceholderInViewport() && this.props.onVisible();
                    }
                },
                {
                    key: "render",
                    value: function() {
                        var e = this, r = this.props, o = r.className, n = r.height, i = r.placeholder, c = r.style, u = r.width;
                        if (i && "function" != typeof i.type) return t().cloneElement(i, {
                            ref: function(t) {
                                return e.placeholder = t;
                            }
                        });
                        var s = function(e) {
                            for(var t = 1; t < arguments.length; t++){
                                var r = null != arguments[t] ? arguments[t] : {};
                                t % 2 ? l(Object(r), !0).forEach(function(t) {
                                    a(e, t, r[t]);
                                }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : l(Object(r)).forEach(function(t) {
                                    Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
                                });
                            }
                            return e;
                        }({
                            display: "inline-block"
                        }, c);
                        return void 0 !== u && (s.width = u), void 0 !== n && (s.height = n), t().createElement("span", {
                            className: o,
                            ref: function(t) {
                                return e.placeholder = t;
                            },
                            style: s
                        }, i);
                    }
                }
            ], o && f(r.prototype, o), Object.defineProperty(r, "prototype", {
                writable: !1
            }), v;
        }(t().Component);
        v.propTypes = {
            onVisible: n.PropTypes.func.isRequired,
            className: n.PropTypes.string,
            height: n.PropTypes.oneOfType([
                n.PropTypes.number,
                n.PropTypes.string
            ]),
            placeholder: n.PropTypes.element,
            threshold: n.PropTypes.number,
            useIntersectionObserver: n.PropTypes.bool,
            scrollPosition: n.PropTypes.shape({
                x: n.PropTypes.number.isRequired,
                y: n.PropTypes.number.isRequired
            }),
            width: n.PropTypes.oneOfType([
                n.PropTypes.number,
                n.PropTypes.string
            ])
        }, v.defaultProps = {
            className: "",
            placeholder: null,
            threshold: 100,
            useIntersectionObserver: !0
        };
        const m = v;
        var O = r(296), w = r.n(O), g = r(96), P = r.n(g), j = function(e) {
            var t = getComputedStyle(e, null);
            return t.getPropertyValue("overflow") + t.getPropertyValue("overflow-y") + t.getPropertyValue("overflow-x");
        };
        const T = function(e) {
            if (!(e instanceof HTMLElement)) return window;
            for(var t = e; t && t instanceof HTMLElement;){
                if (/(scroll|auto)/.test(j(t))) return t;
                t = t.parentNode;
            }
            return window;
        };
        function S(e) {
            return S = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e;
            } : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
            }, S(e);
        }
        var E = [
            "delayMethod",
            "delayTime"
        ];
        function L() {
            return L = Object.assign ? Object.assign.bind() : function(e) {
                for(var t = 1; t < arguments.length; t++){
                    var r = arguments[t];
                    for(var o in r)Object.prototype.hasOwnProperty.call(r, o) && (e[o] = r[o]);
                }
                return e;
            }, L.apply(this, arguments);
        }
        function _(e, t) {
            for(var r = 0; r < t.length; r++){
                var o = t[r];
                o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (n = function(e, t) {
                    if ("object" !== S(e) || null === e) return e;
                    var r = e[Symbol.toPrimitive];
                    if (void 0 !== r) {
                        var o = r.call(e, "string");
                        if ("object" !== S(o)) return o;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(e);
                }(o.key), "symbol" === S(n) ? n : String(n)), o);
            }
            var n;
        }
        function I(e, t) {
            return I = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
                return e.__proto__ = t, e;
            }, I(e, t);
        }
        function x(e, t) {
            if (t && ("object" === S(t) || "function" == typeof t)) return t;
            if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
            return R(e);
        }
        function R(e) {
            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return e;
        }
        function k(e) {
            return k = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            }, k(e);
        }
        var D = function() {
            return "undefined" == typeof window ? 0 : window.scrollX || window.pageXOffset;
        }, C = function() {
            return "undefined" == typeof window ? 0 : window.scrollY || window.pageYOffset;
        };
        const M = function(e) {
            var r = function(r) {
                !function(e, t) {
                    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                    e.prototype = Object.create(t && t.prototype, {
                        constructor: {
                            value: e,
                            writable: !0,
                            configurable: !0
                        }
                    }), Object.defineProperty(e, "prototype", {
                        writable: !1
                    }), t && I(e, t);
                }(a, r);
                var o, n, i, s, l = (i = a, s = function() {
                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                    if (Reflect.construct.sham) return !1;
                    if ("function" == typeof Proxy) return !0;
                    try {
                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                    } catch (e) {
                        return !1;
                    }
                }(), function() {
                    var e, t = k(i);
                    if (s) {
                        var r = k(this).constructor;
                        e = Reflect.construct(t, arguments, r);
                    } else e = t.apply(this, arguments);
                    return x(this, e);
                });
                function a(e) {
                    var r;
                    if (function(e, t) {
                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                    }(this, a), (r = l.call(this, e)).useIntersectionObserver = e.useIntersectionObserver && u(), r.useIntersectionObserver) return x(r);
                    var o = r.onChangeScroll.bind(R(r));
                    return "debounce" === e.delayMethod ? r.delayedScroll = w()(o, e.delayTime) : "throttle" === e.delayMethod && (r.delayedScroll = P()(o, e.delayTime)), r.state = {
                        scrollPosition: {
                            x: D(),
                            y: C()
                        }
                    }, r.baseComponentRef = t().createRef(), r;
                }
                return o = a, n = [
                    {
                        key: "componentDidMount",
                        value: function() {
                            this.addListeners();
                        }
                    },
                    {
                        key: "componentWillUnmount",
                        value: function() {
                            this.removeListeners();
                        }
                    },
                    {
                        key: "componentDidUpdate",
                        value: function() {
                            "undefined" == typeof window || this.useIntersectionObserver || T(c().findDOMNode(this.baseComponentRef.current)) !== this.scrollElement && (this.removeListeners(), this.addListeners());
                        }
                    },
                    {
                        key: "addListeners",
                        value: function() {
                            "undefined" == typeof window || this.useIntersectionObserver || (this.scrollElement = T(c().findDOMNode(this.baseComponentRef.current)), this.scrollElement.addEventListener("scroll", this.delayedScroll, {
                                passive: !0
                            }), window.addEventListener("resize", this.delayedScroll, {
                                passive: !0
                            }), this.scrollElement !== window && window.addEventListener("scroll", this.delayedScroll, {
                                passive: !0
                            }));
                        }
                    },
                    {
                        key: "removeListeners",
                        value: function() {
                            "undefined" == typeof window || this.useIntersectionObserver || (this.scrollElement.removeEventListener("scroll", this.delayedScroll), window.removeEventListener("resize", this.delayedScroll), this.scrollElement !== window && window.removeEventListener("scroll", this.delayedScroll));
                        }
                    },
                    {
                        key: "onChangeScroll",
                        value: function() {
                            this.useIntersectionObserver || this.setState({
                                scrollPosition: {
                                    x: D(),
                                    y: C()
                                }
                            });
                        }
                    },
                    {
                        key: "render",
                        value: function() {
                            var r = this.props, o = (r.delayMethod, r.delayTime, function(e, t) {
                                if (null == e) return {};
                                var r, o, n = function(e, t) {
                                    if (null == e) return {};
                                    var r, o, n = {}, i = Object.keys(e);
                                    for(o = 0; o < i.length; o++)r = i[o], t.indexOf(r) >= 0 || (n[r] = e[r]);
                                    return n;
                                }(e, t);
                                if (Object.getOwnPropertySymbols) {
                                    var i = Object.getOwnPropertySymbols(e);
                                    for(o = 0; o < i.length; o++)r = i[o], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
                                }
                                return n;
                            }(r, E)), n = this.useIntersectionObserver ? null : this.state.scrollPosition;
                            return t().createElement(e, L({
                                forwardRef: this.baseComponentRef,
                                scrollPosition: n
                            }, o));
                        }
                    }
                ], _(o.prototype, n), Object.defineProperty(o, "prototype", {
                    writable: !1
                }), a;
            }(t().Component);
            return r.propTypes = {
                delayMethod: n.PropTypes.oneOf([
                    "debounce",
                    "throttle"
                ]),
                delayTime: n.PropTypes.number,
                useIntersectionObserver: n.PropTypes.bool
            }, r.defaultProps = {
                delayMethod: "throttle",
                delayTime: 300,
                useIntersectionObserver: !0
            }, r;
        };
        function N(e) {
            return N = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e;
            } : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
            }, N(e);
        }
        function B(e, t) {
            for(var r = 0; r < t.length; r++){
                var o = t[r];
                o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (n = function(e, t) {
                    if ("object" !== N(e) || null === e) return e;
                    var r = e[Symbol.toPrimitive];
                    if (void 0 !== r) {
                        var o = r.call(e, "string");
                        if ("object" !== N(o)) return o;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(e);
                }(o.key), "symbol" === N(n) ? n : String(n)), o);
            }
            var n;
        }
        function V(e, t) {
            return V = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
                return e.__proto__ = t, e;
            }, V(e, t);
        }
        function W(e) {
            return W = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            }, W(e);
        }
        var z = function(e) {
            !function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), Object.defineProperty(e, "prototype", {
                    writable: !1
                }), t && V(e, t);
            }(u, e);
            var r, o, n, i, c = (n = u, i = function() {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                } catch (e) {
                    return !1;
                }
            }(), function() {
                var e, t = W(n);
                if (i) {
                    var r = W(this).constructor;
                    e = Reflect.construct(t, arguments, r);
                } else e = t.apply(this, arguments);
                return function(e, t) {
                    if (t && ("object" === N(t) || "function" == typeof t)) return t;
                    if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
                    return function(e) {
                        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                        return e;
                    }(e);
                }(this, e);
            });
            function u(e) {
                return function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, u), c.call(this, e);
            }
            return r = u, o = [
                {
                    key: "render",
                    value: function() {
                        return t().createElement(m, this.props);
                    }
                }
            ], B(r.prototype, o), Object.defineProperty(r, "prototype", {
                writable: !1
            }), u;
        }(t().Component);
        const $ = M(z);
        function U(e) {
            return U = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e;
            } : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
            }, U(e);
        }
        function q(e, t) {
            for(var r = 0; r < t.length; r++){
                var o = t[r];
                o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (n = function(e, t) {
                    if ("object" !== U(e) || null === e) return e;
                    var r = e[Symbol.toPrimitive];
                    if (void 0 !== r) {
                        var o = r.call(e, "string");
                        if ("object" !== U(o)) return o;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(e);
                }(o.key), "symbol" === U(n) ? n : String(n)), o);
            }
            var n;
        }
        function F(e, t) {
            return F = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
                return e.__proto__ = t, e;
            }, F(e, t);
        }
        function H(e) {
            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return e;
        }
        function Y(e) {
            return Y = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            }, Y(e);
        }
        var X = function(e) {
            !function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), Object.defineProperty(e, "prototype", {
                    writable: !1
                }), t && F(e, t);
            }(s, e);
            var r, o, n, i, c = (n = s, i = function() {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                } catch (e) {
                    return !1;
                }
            }(), function() {
                var e, t = Y(n);
                if (i) {
                    var r = Y(this).constructor;
                    e = Reflect.construct(t, arguments, r);
                } else e = t.apply(this, arguments);
                return function(e, t) {
                    if (t && ("object" === U(t) || "function" == typeof t)) return t;
                    if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
                    return H(e);
                }(this, e);
            });
            function s(e) {
                var t;
                !function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, s), t = c.call(this, e);
                var r = e.afterLoad, o = e.beforeLoad, n = e.scrollPosition, i = e.visibleByDefault;
                return t.state = {
                    visible: i
                }, i && (o(), r()), t.onVisible = t.onVisible.bind(H(t)), t.isScrollTracked = Boolean(n && Number.isFinite(n.x) && n.x >= 0 && Number.isFinite(n.y) && n.y >= 0), t;
            }
            return r = s, o = [
                {
                    key: "componentDidUpdate",
                    value: function(e, t) {
                        t.visible !== this.state.visible && this.props.afterLoad();
                    }
                },
                {
                    key: "onVisible",
                    value: function() {
                        this.props.beforeLoad(), this.setState({
                            visible: !0
                        });
                    }
                },
                {
                    key: "render",
                    value: function() {
                        if (this.state.visible) return this.props.children;
                        var e = this.props, r = e.className, o = e.delayMethod, n = e.delayTime, i = e.height, c = e.placeholder, s = e.scrollPosition, l = e.style, a = e.threshold, f = e.useIntersectionObserver, p = e.width;
                        return this.isScrollTracked || f && u() ? t().createElement(m, {
                            className: r,
                            height: i,
                            onVisible: this.onVisible,
                            placeholder: c,
                            scrollPosition: s,
                            style: l,
                            threshold: a,
                            useIntersectionObserver: f,
                            width: p
                        }) : t().createElement($, {
                            className: r,
                            delayMethod: o,
                            delayTime: n,
                            height: i,
                            onVisible: this.onVisible,
                            placeholder: c,
                            style: l,
                            threshold: a,
                            width: p
                        });
                    }
                }
            ], q(r.prototype, o), Object.defineProperty(r, "prototype", {
                writable: !1
            }), s;
        }(t().Component);
        X.propTypes = {
            afterLoad: n.PropTypes.func,
            beforeLoad: n.PropTypes.func,
            useIntersectionObserver: n.PropTypes.bool,
            visibleByDefault: n.PropTypes.bool
        }, X.defaultProps = {
            afterLoad: function() {
                return {};
            },
            beforeLoad: function() {
                return {};
            },
            useIntersectionObserver: !0,
            visibleByDefault: !1
        };
        const A = X;
        function G(e) {
            return G = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e;
            } : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
            }, G(e);
        }
        var J = [
            "afterLoad",
            "beforeLoad",
            "delayMethod",
            "delayTime",
            "effect",
            "placeholder",
            "placeholderSrc",
            "scrollPosition",
            "threshold",
            "useIntersectionObserver",
            "visibleByDefault",
            "wrapperClassName",
            "wrapperProps"
        ];
        function K(e, t) {
            var r = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
                var o = Object.getOwnPropertySymbols(e);
                t && (o = o.filter(function(t) {
                    return Object.getOwnPropertyDescriptor(e, t).enumerable;
                })), r.push.apply(r, o);
            }
            return r;
        }
        function Q(e) {
            for(var t = 1; t < arguments.length; t++){
                var r = null != arguments[t] ? arguments[t] : {};
                t % 2 ? K(Object(r), !0).forEach(function(t) {
                    Z(e, t, r[t]);
                }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : K(Object(r)).forEach(function(t) {
                    Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
                });
            }
            return e;
        }
        function Z(e, t, r) {
            return (t = re(t)) in e ? Object.defineProperty(e, t, {
                value: r,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e[t] = r, e;
        }
        function ee() {
            return ee = Object.assign ? Object.assign.bind() : function(e) {
                for(var t = 1; t < arguments.length; t++){
                    var r = arguments[t];
                    for(var o in r)Object.prototype.hasOwnProperty.call(r, o) && (e[o] = r[o]);
                }
                return e;
            }, ee.apply(this, arguments);
        }
        function te(e, t) {
            for(var r = 0; r < t.length; r++){
                var o = t[r];
                o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, re(o.key), o);
            }
        }
        function re(e) {
            var t = function(e, t) {
                if ("object" !== G(e) || null === e) return e;
                var r = e[Symbol.toPrimitive];
                if (void 0 !== r) {
                    var o = r.call(e, "string");
                    if ("object" !== G(o)) return o;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return String(e);
            }(e);
            return "symbol" === G(t) ? t : String(t);
        }
        function oe(e, t) {
            return oe = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
                return e.__proto__ = t, e;
            }, oe(e, t);
        }
        function ne(e) {
            return ne = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            }, ne(e);
        }
        var ie = function(e) {
            !function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), Object.defineProperty(e, "prototype", {
                    writable: !1
                }), t && oe(e, t);
            }(u, e);
            var r, o, n, i, c = (n = u, i = function() {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                } catch (e) {
                    return !1;
                }
            }(), function() {
                var e, t = ne(n);
                if (i) {
                    var r = ne(this).constructor;
                    e = Reflect.construct(t, arguments, r);
                } else e = t.apply(this, arguments);
                return function(e, t) {
                    if (t && ("object" === G(t) || "function" == typeof t)) return t;
                    if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
                    return function(e) {
                        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                        return e;
                    }(e);
                }(this, e);
            });
            function u(e) {
                var t;
                return function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, u), (t = c.call(this, e)).state = {
                    loaded: !1
                }, t;
            }
            return r = u, o = [
                {
                    key: "onImageLoad",
                    value: function() {
                        var e = this;
                        return this.state.loaded ? null : function(t) {
                            e.props.onLoad(t), e.props.afterLoad(), e.setState({
                                loaded: !0
                            });
                        };
                    }
                },
                {
                    key: "getImg",
                    value: function() {
                        var e = this.props, r = (e.afterLoad, e.beforeLoad, e.delayMethod, e.delayTime, e.effect, e.placeholder, e.placeholderSrc, e.scrollPosition, e.threshold, e.useIntersectionObserver, e.visibleByDefault, e.wrapperClassName, e.wrapperProps, function(e, t) {
                            if (null == e) return {};
                            var r, o, n = function(e, t) {
                                if (null == e) return {};
                                var r, o, n = {}, i = Object.keys(e);
                                for(o = 0; o < i.length; o++)r = i[o], t.indexOf(r) >= 0 || (n[r] = e[r]);
                                return n;
                            }(e, t);
                            if (Object.getOwnPropertySymbols) {
                                var i = Object.getOwnPropertySymbols(e);
                                for(o = 0; o < i.length; o++)r = i[o], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
                            }
                            return n;
                        }(e, J));
                        return t().createElement("img", ee({}, r, {
                            onLoad: this.onImageLoad()
                        }));
                    }
                },
                {
                    key: "getLazyLoadImage",
                    value: function() {
                        var e = this.props, r = e.beforeLoad, o = e.className, n = e.delayMethod, i = e.delayTime, c = e.height, u = e.placeholder, s = e.scrollPosition, l = e.style, a = e.threshold, f = e.useIntersectionObserver, p = e.visibleByDefault, y = e.width;
                        return t().createElement(A, {
                            beforeLoad: r,
                            className: o,
                            delayMethod: n,
                            delayTime: i,
                            height: c,
                            placeholder: u,
                            scrollPosition: s,
                            style: l,
                            threshold: a,
                            useIntersectionObserver: f,
                            visibleByDefault: p,
                            width: y
                        }, this.getImg());
                    }
                },
                {
                    key: "getWrappedLazyLoadImage",
                    value: function(e) {
                        var r = this.props, o = r.effect, n = r.height, i = r.placeholderSrc, c = r.width, u = r.wrapperClassName, s = r.wrapperProps, l = this.state.loaded, a = l ? " lazy-load-image-loaded" : "", f = l || !i ? {} : {
                            backgroundImage: "url(".concat(i, ")"),
                            backgroundSize: "100% 100%"
                        };
                        return t().createElement("span", ee({
                            className: u + " lazy-load-image-background " + o + a,
                            style: Q(Q({}, f), {}, {
                                color: "transparent",
                                display: "inline-block",
                                height: n,
                                width: c
                            })
                        }, s), e);
                    }
                },
                {
                    key: "render",
                    value: function() {
                        var e = this.props, t = e.effect, r = e.placeholderSrc, o = e.visibleByDefault, n = e.wrapperClassName, i = e.wrapperProps, c = this.getLazyLoadImage();
                        return (t || r) && !o || n || i ? this.getWrappedLazyLoadImage(c) : c;
                    }
                }
            ], te(r.prototype, o), Object.defineProperty(r, "prototype", {
                writable: !1
            }), u;
        }(t().Component);
        ie.propTypes = {
            onLoad: n.PropTypes.func,
            afterLoad: n.PropTypes.func,
            beforeLoad: n.PropTypes.func,
            delayMethod: n.PropTypes.string,
            delayTime: n.PropTypes.number,
            effect: n.PropTypes.string,
            placeholderSrc: n.PropTypes.string,
            threshold: n.PropTypes.number,
            useIntersectionObserver: n.PropTypes.bool,
            visibleByDefault: n.PropTypes.bool,
            wrapperClassName: n.PropTypes.string,
            wrapperProps: n.PropTypes.object
        }, ie.defaultProps = {
            onLoad: function() {},
            afterLoad: function() {
                return {};
            },
            beforeLoad: function() {
                return {};
            },
            delayMethod: "throttle",
            delayTime: 300,
            effect: "",
            placeholderSrc: null,
            threshold: 100,
            useIntersectionObserver: !0,
            visibleByDefault: !1,
            wrapperClassName: ""
        };
        const ce = ie;
    })(), $ed94513a3acda713$exports = o;
})();



parcelRequire("b6HlZ");
const $cf12b864f8a1636a$var$IconButton = ({ icon: icon, className: className, imgClassName: imgClassName, ...rest })=>{
    return /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)("button", {
        className: `inline-flex items-center justify-center bg-primary w-8 h-8 sm:w-12 sm:h-12 rounded-full shadow-icon-button ${className} disabled:opacity-75 disabled:cursor-not-allowed disabled:bg-disabled `,
        ...rest,
        children: /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)("img", {
            src: icon,
            alt: "",
            className: imgClassName
        })
    });
};
var $cf12b864f8a1636a$export$2e2bcd8739ae039 = $cf12b864f8a1636a$var$IconButton;


var $e4b0b8223c527601$exports = {};

$e4b0b8223c527601$exports = (parcelRequire("fF0r8")).getBundleURL("7lpHJ") + "left.3207b72d.svg";


var $28443d5351442cf5$exports = {};

$28443d5351442cf5$exports = (parcelRequire("fF0r8")).getBundleURL("7lpHJ") + "right.61dca77f.svg";



const $242823de2d11a994$var$CustomCarousel = ({ images: images = [], selectedTab: selectedTab })=>{
    const renderImages = ()=>{
        return images.map((image, index)=>{
            return /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)("div", {
                className: "h-52 sm:h-60 flex justify-center",
                children: /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)((0, $ed94513a3acda713$exports.LazyLoadImage), {
                    placeholder: /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)("div", {
                        className: "!w-full h-full flex items-center justify-center",
                        children: "Loading.."
                    }),
                    src: image,
                    alt: "",
                    className: "!w-full rounded-t-lg block object-cover object-center"
                })
            }, index);
        });
    };
    return /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)((0, $840450214059b8a0$exports.Carousel), {
        showThumbs: false,
        showStatus: false,
        selectedItem: 0,
        infiniteLoop: true,
        className: "w-full",
        renderArrowPrev: (onClickHandler, _hasPrev, label)=>{
            if (images.length > 1) return /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)((0, $cf12b864f8a1636a$export$2e2bcd8739ae039), {
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($e4b0b8223c527601$exports))),
                className: "bg-white absolute top-24 -left-4 sm:-left-6 z-10",
                onClick: (event)=>{
                    event.stopPropagation();
                    onClickHandler();
                },
                title: label,
                imgClassName: "!w-6 !h-6"
            });
        },
        renderArrowNext: (onClickHandler, _hasNext, label)=>{
            if (images.length > 1) return /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)((0, $cf12b864f8a1636a$export$2e2bcd8739ae039), {
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($28443d5351442cf5$exports))),
                className: "bg-white absolute top-24 -right-4 sm:-right-6 z-10",
                onClick: (event)=>{
                    event.stopPropagation();
                    onClickHandler();
                },
                title: label,
                imgClassName: "!w-6 !h-6"
            });
        },
        renderIndicator: (onClickHandler, isSelected, index, label)=>{
            if (isSelected) return /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)("li", {
                className: "inline-block mx-0.5 bg-gray-600 border border-white w-4 h-4 rounded-full",
                "aria-label": `Selected: ${label} ${index + 1}`,
                title: `Selected: ${label} ${index + 1}`
            });
            return /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)("li", {
                className: "inline-block mx-0.5 bg-gray-100 border border-white w-4 h-4 rounded-full",
                onClick: (event)=>{
                    event.stopPropagation();
                    onClickHandler();
                },
                onKeyDown: (event)=>{
                    event.stopPropagation();
                    onClickHandler();
                },
                value: index,
                role: "button",
                tabIndex: 0,
                title: `${label} ${index + 1}`,
                "aria-label": `${label} ${index + 1}`
            }, index);
        },
        children: renderImages()
    }, selectedTab);
};
var $242823de2d11a994$export$2e2bcd8739ae039 = $242823de2d11a994$var$CustomCarousel;



const $e6c8847e4c8355ed$var$tabColors = {
    "Meeting Room": "bg-purple-200",
    "Flexday Suite": "bg-red-200",
    "Private Office": "bg-blue-200"
};
const $e6c8847e4c8355ed$var$InventoryCard = ({ location: location, selectedTab: selectedTab, selected: selected, onSelected: onSelected })=>{
    const handleInquire = (event)=>{
        event.stopPropagation();
        let url = new URL(`${"https://www.flexday.com"}/book-workspace`);
        url.searchParams.append("selectedlocation", location.address);
        url.searchParams.append("selectedSpace", (0, $831bd3f164fcae83$export$2b2d40e59ff98185)[selectedTab]);
        window.location.href = url.href;
    };
    return /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsxs)("div", {
        className: `w-full flex flex-col justify-start items-center border-2 ${selected ? "border-primary" : "border-gray-400"}  rounded-xl cursor-pointer`,
        onClick: ()=>onSelected(location.id),
        id: location.id,
        children: [
            /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)((0, $242823de2d11a994$export$2e2bcd8739ae039), {
                images: location.images,
                selectedTab: selectedTab
            }),
            /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsxs)("div", {
                className: "flex flex-col items-start justify-start w-full gap-1 sm:gap-2 px-3 py-2 sm:py-6",
                children: [
                    /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)("div", {
                        className: `w-fit ${$e6c8847e4c8355ed$var$tabColors[selectedTab]} px-2 py-1 rounded-md`,
                        children: /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)("p", {
                            className: "text-base font-medium",
                            children: selectedTab
                        })
                    }),
                    /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)("p", {
                        className: "h-12 text-base font-medium line-clamp-2",
                        children: location.name
                    }),
                    /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)("p", {
                        className: "h-12 text-base font-normal line-clamp-2",
                        children: location.address
                    }),
                    /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)((0, $b10e2d2452b40b3d$export$2e2bcd8739ae039), {
                        title: "Inquire",
                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($873df070a83fdd16$exports))),
                        className: "mt-0 sm:mt-4",
                        onClick: handleInquire
                    })
                ]
            })
        ]
    });
};
var $e6c8847e4c8355ed$export$2e2bcd8739ae039 = $e6c8847e4c8355ed$var$InventoryCard;


const $ee969eb065807adf$var$collectionOptions = {
    "Meeting Room": "meetingRoomLocations",
    "Flexday Suite": "privateOfficeLocations",
    "Private Office": "privateOfficeLocations"
};
const $ee969eb065807adf$var$StandaloneInventoryCard = ({ id: id, inventoryType: inventoryType })=>{
    const [location, setLocation] = (0, $b6HlZ.useState)(null);
    const getLocation = async ()=>{
        const { getFirebaseConfig: getFirebaseConfig } = (0, $a5a6fab2525fdce6$exports.Helpers);
        const firebaseConfig = getFirebaseConfig({
            REACT_APP_FIREBASE_API_KEY: "AIzaSyBoIeHTyO2Zr6jARvqrWPPAlqi3pdu2-KA",
            REACT_APP_FIREBASE_APP_ID: "1:717114758534:web:c0f5a5118efc5855164807",
            REACT_APP_FIREBASE_MESSAGE_SENDER_ID: "717114758534",
            REACT_APP_FIREBASE_PROJECT_ID: "flexday-6dacf"
        });
        const app = (0, $iXpG9.initializeApp)(firebaseConfig);
        const firestore = (0, $7TObl.getFirestore)(app);
        const inventoryCollectionRef = (0, $7TObl.collection)(firestore, $ee969eb065807adf$var$collectionOptions[inventoryType]);
        const querySnapshot = await (0, $7TObl.getDocs)((0, $7TObl.query)(inventoryCollectionRef, (0, $7TObl.where)("id", "==", id), (0, $7TObl.where)("isVisible", "==", true)));
        querySnapshot.forEach((doc)=>{
            setLocation(doc.data());
        });
    };
    (0, $b6HlZ.useEffect)(()=>{
        getLocation();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        id,
        inventoryType
    ]);
    if (!location) return null;
    const onSelected = (locationId)=>{};
    return /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)("div", {
        className: "w-72",
        children: /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)((0, $e6c8847e4c8355ed$export$2e2bcd8739ae039), {
            location: location,
            selectedTab: inventoryType,
            onSelected: onSelected
        })
    });
};
var $ee969eb065807adf$export$2e2bcd8739ae039 = $ee969eb065807adf$var$StandaloneInventoryCard;




var $b6HlZ = parcelRequire("b6HlZ");

var $iXpG9 = parcelRequire("iXpG9");
parcelRequire("8vofH");
var $7TObl = parcelRequire("7TObl");






var $b6HlZ = parcelRequire("b6HlZ");
function $96c8a3944825404e$var$PaperAirplaneIcon(props, svgRef) {
    return /*#__PURE__*/ $b6HlZ.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $b6HlZ.createElement("path", {
        d: "M10.894 2.553a1 1 0 00-1.788 0l-7 14a1 1 0 001.169 1.409l5-1.429A1 1 0 009 15.571V11a1 1 0 112 0v4.571a1 1 0 00.725.962l5 1.428a1 1 0 001.17-1.408l-7-14z"
    }));
}
const $96c8a3944825404e$var$ForwardRef = $b6HlZ.forwardRef($96c8a3944825404e$var$PaperAirplaneIcon);
var $96c8a3944825404e$export$2e2bcd8739ae039 = $96c8a3944825404e$var$ForwardRef;


const $e9527ac5b503f28e$var$TypingIndicator = ()=>/*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)("div", {
        className: "flex justify-start mb-2",
        children: /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)("div", {
            className: "bg-white border border-gray-200 p-3 rounded-lg",
            children: /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsxs)("div", {
                className: "flex space-x-1",
                children: [
                    /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)("div", {
                        className: "w-2 h-2 bg-gray-400 rounded-full animate-bounce",
                        style: {
                            animationDelay: "0ms"
                        }
                    }),
                    /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)("div", {
                        className: "w-2 h-2 bg-gray-400 rounded-full animate-bounce",
                        style: {
                            animationDelay: "150ms"
                        }
                    }),
                    /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)("div", {
                        className: "w-2 h-2 bg-gray-400 rounded-full animate-bounce",
                        style: {
                            animationDelay: "300ms"
                        }
                    })
                ]
            })
        })
    });
const $e9527ac5b503f28e$var$BookingAgent = ({ settingsId: settingsId, autoJoin: autoJoin = false })=>{
    var _conversation_closedAt;
    const [conversationRef, setConversationRef] = (0, $b6HlZ.useState)(null);
    const [conversation, conversationLoading, conversationError] = (0, $603d4f5da0d29b2c$export$d8c0c0b7453663d0)(conversationRef);
    const [newMessage, setNewMessage] = (0, $b6HlZ.useState)("");
    const messagesEndRef = (0, $b6HlZ.useRef)(null);
    const chatContainerRef = (0, $b6HlZ.useRef)(null);
    const { getFirebaseConfig: getFirebaseConfig } = (0, $a5a6fab2525fdce6$exports.Helpers);
    const firebaseConfig = getFirebaseConfig({
        REACT_APP_FIREBASE_API_KEY: "AIzaSyBoIeHTyO2Zr6jARvqrWPPAlqi3pdu2-KA",
        REACT_APP_FIREBASE_APP_ID: "1:717114758534:web:c0f5a5118efc5855164807",
        REACT_APP_FIREBASE_MESSAGE_SENDER_ID: "717114758534",
        REACT_APP_FIREBASE_PROJECT_ID: "flexday-6dacf"
    });
    const app = (0, $iXpG9.initializeApp)(firebaseConfig);
    const firestore = (0, $7TObl.getFirestore)(app);
    // Fetch settings from Firestore
    const settingsRef = settingsId ? (0, $7TObl.doc)(firestore, "settings", settingsId) : null;
    const [settings, settingsLoading, settingsError] = (0, $603d4f5da0d29b2c$export$d8c0c0b7453663d0)(settingsRef);
    const messagesRef = conversationRef && (0, $7TObl.collection)(conversationRef, "messages");
    const messagesQuery = messagesRef && (0, $7TObl.query)(messagesRef, (0, $7TObl.orderBy)("createdAt"));
    const [messages, messagesLoading, messagesError] = (0, $603d4f5da0d29b2c$export$f976898995c345b4)(messagesQuery, {
        idField: "id"
    });
    const conversationKey = `booking_conversation_${new Date().toISOString().split("T")[0]}`;
    const saveConversation = (conversationId)=>{
        localStorage.setItem(conversationKey, conversationId);
    };
    const loadConversationId = ()=>{
        return localStorage.getItem(conversationKey);
    };
    const onConnect = async ()=>{
        const savedConversationId = loadConversationId();
        if (savedConversationId) setConversationRef((0, $7TObl.doc)(firestore, "conversations", savedConversationId));
        else {
            const newConversationRef = await (0, $7TObl.addDoc)((0, $7TObl.collection)(firestore, "conversations"), {
                type: "workspace_booking",
                createdAt: (0, $7TObl.serverTimestamp)(),
                agentReplying: true,
                status: "active",
                settings: (0, $7TObl.doc)(firestore, "settings", settingsId)
            });
            setConversationRef(newConversationRef);
            saveConversation(newConversationRef.id);
        }
    };
    (0, $b6HlZ.useEffect)(()=>{
        const savedConversationId = loadConversationId();
        if (savedConversationId) setConversationRef((0, $7TObl.doc)(firestore, "conversations", savedConversationId));
    }, []);
    (0, $b6HlZ.useEffect)(()=>{
        const urlParams = new URLSearchParams(window.location.search);
        const urlAutoJoinEnabled = urlParams.get("autoJoin") === "true";
        const existingConversationId = loadConversationId();
        // Auto-join if enabled via URL params OR via data attribute
        if ((urlAutoJoinEnabled || autoJoin) && !existingConversationId) onConnect();
    }, [
        autoJoin
    ]);
    const handleSendMessage = async ()=>{
        if (!newMessage.trim() || !messagesRef) return;
        await (0, $7TObl.addDoc)(messagesRef, {
            content: newMessage,
            role: "user",
            createdAt: (0, $7TObl.serverTimestamp)()
        });
        setNewMessage("");
    };
    const handleKeyPress = (e)=>{
        if (e.key === "Enter" && !e.shiftKey) {
            e.preventDefault();
            handleSendMessage();
        }
    };
    const scrollToBottom = ()=>{
        if (chatContainerRef.current) chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;
    };
    (0, $b6HlZ.useEffect)(()=>{
        scrollToBottom();
    }, [
        messages === null || messages === void 0 ? void 0 : messages.length,
        conversation === null || conversation === void 0 ? void 0 : conversation.agentReplying
    ]);
    const handleEndConversation = async ()=>{
        if (conversationRef) await (0, $7TObl.updateDoc)(conversationRef, {
            status: "closed",
            closedAt: (0, $7TObl.serverTimestamp)()
        });
        localStorage.removeItem(conversationKey);
    };
    if (!settings) return null;
    const isConversationClosed = (conversation === null || conversation === void 0 ? void 0 : conversation.status) === "closed";
    return /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsxs)("div", {
        className: "flex flex-col items-center gap-4 bg-white p-4 rounded-[20px]",
        children: [
            !conversation && !conversationLoading && !autoJoin && /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)("div", {
                className: "w-96",
                children: /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)("button", {
                    className: "self-center mt-2 w-full py-2 hover:opacity-75 transition-opacity px-16",
                    style: settings === null || settings === void 0 ? void 0 : settings.buttonStyles,
                    onClick: onConnect,
                    disabled: conversationLoading || settingsLoading,
                    children: settings.bookWorkspaceCTA
                })
            }),
            conversation && /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsxs)("div", {
                className: "flex flex-col w-full h-[500px]",
                children: [
                    /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsxs)("div", {
                        className: "flex-1 overflow-y-auto p-4 bg-gray-50 rounded-t-lg",
                        ref: chatContainerRef,
                        children: [
                            messagesLoading || settingsLoading ? /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)("div", {
                                className: "text-center text-gray-500",
                                children: "Loading messages..."
                            }) : messagesError || settingsError ? /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)("div", {
                                className: "text-center text-red-500",
                                children: "Error loading messages"
                            }) : /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsxs)((0, $94829a8b99aa12e4$exports.Fragment), {
                                children: [
                                    messages === null || messages === void 0 ? void 0 : messages.map((message)=>{
                                        var _message_createdAt;
                                        return /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)("div", {
                                            className: `flex ${message.role === "assistant" ? "justify-start" : "justify-end"} mb-2`,
                                            children: /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsxs)("div", {
                                                className: `max-w-[80%] p-3 rounded-lg ${message.role === "assistant" ? "bg-white border border-gray-200" : ""}`,
                                                style: message.role === "user" ? {
                                                    backgroundColor: settings === null || settings === void 0 ? void 0 : settings.accentColor,
                                                    color: settings === null || settings === void 0 ? void 0 : settings.accentFontColor
                                                } : {},
                                                children: [
                                                    /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)("div", {
                                                        className: "prose prose-sm max-w-none",
                                                        children: /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)((0, $fcd6f0226a0ae730$export$83ef7ab426386201), {
                                                            components: {
                                                                p: ({ node: node, ...props })=>/*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)("p", {
                                                                        className: "mb-4",
                                                                        ...props
                                                                    }),
                                                                ul: ({ node: node, ...props })=>/*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)("ul", {
                                                                        className: "mb-4",
                                                                        ...props
                                                                    }),
                                                                hr: ({ node: node, ...props })=>/*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)("hr", {
                                                                        className: "mb-4",
                                                                        ...props
                                                                    })
                                                            },
                                                            children: message.content
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)("span", {
                                                        className: "text-xs text-gray-500 mt-1 block",
                                                        children: (_message_createdAt = message.createdAt) === null || _message_createdAt === void 0 ? void 0 : _message_createdAt.toDate().toLocaleTimeString()
                                                    })
                                                ]
                                            })
                                        }, message.id);
                                    }),
                                    (conversation === null || conversation === void 0 ? void 0 : conversation.agentReplying) && !isConversationClosed && /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)($e9527ac5b503f28e$var$TypingIndicator, {}),
                                    isConversationClosed && /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)("div", {
                                        className: "text-center mt-4",
                                        children: /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsxs)("span", {
                                            className: "text-gray-600 text-sm",
                                            children: [
                                                "Conversation ended at",
                                                " ",
                                                (_conversation_closedAt = conversation.closedAt) === null || _conversation_closedAt === void 0 ? void 0 : _conversation_closedAt.toDate().toLocaleTimeString([], {
                                                    hour: "numeric",
                                                    minute: "2-digit",
                                                    hour12: true
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)("div", {
                                ref: messagesEndRef
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsxs)("div", {
                        className: "flex gap-2 w-full p-4 bg-white border-t border-gray-200 rounded-b-lg",
                        children: [
                            /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)("textarea", {
                                value: newMessage,
                                onChange: (e)=>setNewMessage(e.target.value),
                                onKeyPress: handleKeyPress,
                                placeholder: "Type your message...",
                                className: `flex-1 p-2 border border-gray-200 rounded-lg resize-none focus:outline-none focus:ring-2 focus:ring-[${settings.accentColor}] focus:border-transparent ${isConversationClosed ? "bg-gray-100 cursor-not-allowed" : ""}`,
                                rows: 2,
                                disabled: isConversationClosed
                            }),
                            /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)("div", {
                                className: "w-12",
                                children: /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)("button", {
                                    className: `w-full h-full flex items-center justify-center self-end rounded-lg transition-opacity ${isConversationClosed ? "cursor-not-allowed opacity-50" : "hover:opacity-75"}`,
                                    style: {
                                        backgroundColor: settings === null || settings === void 0 ? void 0 : settings.accentColor,
                                        color: settings === null || settings === void 0 ? void 0 : settings.accentFontColor
                                    },
                                    onClick: handleSendMessage,
                                    disabled: !newMessage.trim() || isConversationClosed,
                                    children: /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)((0, $96c8a3944825404e$export$2e2bcd8739ae039), {
                                        className: "w-4 rotate-90"
                                    })
                                })
                            })
                        ]
                    }),
                    !isConversationClosed && /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)("button", {
                        onClick: handleEndConversation,
                        className: "text-sm text-gray-500 hover:text-gray-700 transition-colors self-center mt-2",
                        children: "End Conversation"
                    })
                ]
            })
        ]
    });
};
var $e9527ac5b503f28e$export$2e2bcd8739ae039 = $e9527ac5b503f28e$var$BookingAgent;




var $b6HlZ = parcelRequire("b6HlZ");

var $iXpG9 = parcelRequire("iXpG9");
parcelRequire("8vofH");
var $7TObl = parcelRequire("7TObl");

var $514cd3351bbd55bc$exports = {};

(function webpackUniversalModuleDefinition(root, factory) {
    $514cd3351bbd55bc$exports = factory((parcelRequire("b6HlZ")));
})($514cd3351bbd55bc$exports, (__WEBPACK_EXTERNAL_MODULE_react__)=>{
    return /******/ (()=>{
        /******/ var __webpack_modules__ = {
            /***/ "./node_modules/css-mediaquery/index.js": /*!**********************************************!*\
  !*** ./node_modules/css-mediaquery/index.js ***!
  \**********************************************/ /***/ (__unused_webpack_module, exports)=>{
                "use strict";
                /*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ exports.match = matchQuery;
                exports.parse = parseQuery;
                // -----------------------------------------------------------------------------
                var RE_MEDIA_QUERY = /(?:(only|not)?\s*([^\s\(\)]+)(?:\s*and)?\s*)?(.+)?/i, RE_MQ_EXPRESSION = /\(\s*([^\s\:\)]+)\s*(?:\:\s*([^\s\)]+))?\s*\)/, RE_MQ_FEATURE = /^(?:(min|max)-)?(.+)/, RE_LENGTH_UNIT = /(em|rem|px|cm|mm|in|pt|pc)?$/, RE_RESOLUTION_UNIT = /(dpi|dpcm|dppx)?$/;
                function matchQuery(mediaQuery, values) {
                    return parseQuery(mediaQuery).some(function(query) {
                        var inverse = query.inverse;
                        // Either the parsed or specified `type` is "all", or the types must be
                        // equal for a match.
                        var typeMatch = query.type === "all" || values.type === query.type;
                        // Quit early when `type` doesn't match, but take "not" into account.
                        if (typeMatch && inverse || !(typeMatch || inverse)) return false;
                        var expressionsMatch = query.expressions.every(function(expression) {
                            var feature = expression.feature, modifier = expression.modifier, expValue = expression.value, value = values[feature];
                            // Missing or falsy values don't match.
                            if (!value) return false;
                            switch(feature){
                                case "orientation":
                                case "scan":
                                    return value.toLowerCase() === expValue.toLowerCase();
                                case "width":
                                case "height":
                                case "device-width":
                                case "device-height":
                                    expValue = toPx(expValue);
                                    value = toPx(value);
                                    break;
                                case "resolution":
                                    expValue = toDpi(expValue);
                                    value = toDpi(value);
                                    break;
                                case "aspect-ratio":
                                case "device-aspect-ratio":
                                case /* Deprecated */ "device-pixel-ratio":
                                    expValue = toDecimal(expValue);
                                    value = toDecimal(value);
                                    break;
                                case "grid":
                                case "color":
                                case "color-index":
                                case "monochrome":
                                    expValue = parseInt(expValue, 10) || 1;
                                    value = parseInt(value, 10) || 0;
                                    break;
                            }
                            switch(modifier){
                                case "min":
                                    return value >= expValue;
                                case "max":
                                    return value <= expValue;
                                default:
                                    return value === expValue;
                            }
                        });
                        return expressionsMatch && !inverse || !expressionsMatch && inverse;
                    });
                }
                function parseQuery(mediaQuery) {
                    return mediaQuery.split(",").map(function(query) {
                        query = query.trim();
                        var captures = query.match(RE_MEDIA_QUERY), modifier = captures[1], type = captures[2], expressions = captures[3] || "", parsed = {};
                        parsed.inverse = !!modifier && modifier.toLowerCase() === "not";
                        parsed.type = type ? type.toLowerCase() : "all";
                        // Split expressions into a list.
                        expressions = expressions.match(/\([^\)]+\)/g) || [];
                        parsed.expressions = expressions.map(function(expression) {
                            var captures = expression.match(RE_MQ_EXPRESSION), feature = captures[1].toLowerCase().match(RE_MQ_FEATURE);
                            return {
                                modifier: feature[1],
                                feature: feature[2],
                                value: captures[2]
                            };
                        });
                        return parsed;
                    });
                }
                // -- Utilities ----------------------------------------------------------------
                function toDecimal(ratio) {
                    var decimal = Number(ratio), numbers;
                    if (!decimal) {
                        numbers = ratio.match(/^(\d+)\s*\/\s*(\d+)$/);
                        decimal = numbers[1] / numbers[2];
                    }
                    return decimal;
                }
                function toDpi(resolution) {
                    var value = parseFloat(resolution), units = String(resolution).match(RE_RESOLUTION_UNIT)[1];
                    switch(units){
                        case "dpcm":
                            return value / 2.54;
                        case "dppx":
                            return value * 96;
                        default:
                            return value;
                    }
                }
                function toPx(length) {
                    var value = parseFloat(length), units = String(length).match(RE_LENGTH_UNIT)[1];
                    switch(units){
                        case "em":
                            return value * 16;
                        case "rem":
                            return value * 16;
                        case "cm":
                            return value * 96 / 2.54;
                        case "mm":
                            return value * 96 / 2.54 / 10;
                        case "in":
                            return value * 96;
                        case "pt":
                            return value * 72;
                        case "pc":
                            return value * 72 / 12;
                        default:
                            return value;
                    }
                }
            /***/ },
            /***/ "./node_modules/hyphenate-style-name/index.js": /*!****************************************************!*\
  !*** ./node_modules/hyphenate-style-name/index.js ***!
  \****************************************************/ /***/ (__unused_webpack_module, __webpack_exports__, __webpack_require__)=>{
                "use strict";
                __webpack_require__.r(__webpack_exports__);
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ "default": ()=>__WEBPACK_DEFAULT_EXPORT__
                });
                /* eslint-disable no-var, prefer-template */ var uppercasePattern = /[A-Z]/g;
                var msPattern = /^ms-/;
                var cache = {};
                function toHyphenLower(match) {
                    return "-" + match.toLowerCase();
                }
                function hyphenateStyleName(name) {
                    if (cache.hasOwnProperty(name)) return cache[name];
                    var hName = name.replace(uppercasePattern, toHyphenLower);
                    return cache[name] = msPattern.test(hName) ? "-" + hName : hName;
                }
                /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = hyphenateStyleName;
            /***/ },
            /***/ "./node_modules/matchmediaquery/index.js": /*!***********************************************!*\
  !*** ./node_modules/matchmediaquery/index.js ***!
  \***********************************************/ /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                "use strict";
                var staticMatch = __webpack_require__(/*! css-mediaquery */ "./node_modules/css-mediaquery/index.js").match;
                var dynamicMatch = typeof window !== "undefined" ? window.matchMedia : null;
                // our fake MediaQueryList
                function Mql(query, values, forceStatic) {
                    var self = this;
                    if (dynamicMatch && !forceStatic) {
                        var mql = dynamicMatch.call(window, query);
                        this.matches = mql.matches;
                        this.media = mql.media;
                        // TODO: is there a time it makes sense to remove this listener?
                        mql.addListener(update);
                    } else {
                        this.matches = staticMatch(query, values);
                        this.media = query;
                    }
                    this.addListener = addListener;
                    this.removeListener = removeListener;
                    this.dispose = dispose;
                    function addListener(listener) {
                        if (mql) mql.addListener(listener);
                    }
                    function removeListener(listener) {
                        if (mql) mql.removeListener(listener);
                    }
                    // update ourselves!
                    function update(evt) {
                        self.matches = evt.matches;
                        self.media = evt.media;
                    }
                    function dispose() {
                        if (mql) mql.removeListener(update);
                    }
                }
                function matchMedia(query, values, forceStatic) {
                    return new Mql(query, values, forceStatic);
                }
                module1.exports = matchMedia;
            /***/ },
            /***/ "./node_modules/object-assign/index.js": /*!*********************************************!*\
  !*** ./node_modules/object-assign/index.js ***!
  \*********************************************/ /***/ (module1)=>{
                "use strict";
                /*
object-assign
(c) Sindre Sorhus
@license MIT
*/ /* eslint-disable no-unused-vars */ var getOwnPropertySymbols = Object.getOwnPropertySymbols;
                var hasOwnProperty = Object.prototype.hasOwnProperty;
                var propIsEnumerable = Object.prototype.propertyIsEnumerable;
                function toObject(val) {
                    if (val === null || val === undefined) throw new TypeError("Object.assign cannot be called with null or undefined");
                    return Object(val);
                }
                function shouldUseNative() {
                    try {
                        if (!Object.assign) return false;
                        // Detect buggy property enumeration order in older V8 versions.
                        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
                        var test1 = new String("abc"); // eslint-disable-line no-new-wrappers
                        test1[5] = "de";
                        if (Object.getOwnPropertyNames(test1)[0] === "5") return false;
                        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
                        var test2 = {};
                        for(var i = 0; i < 10; i++)test2["_" + String.fromCharCode(i)] = i;
                        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
                            return test2[n];
                        });
                        if (order2.join("") !== "0123456789") return false;
                        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
                        var test3 = {};
                        "abcdefghijklmnopqrst".split("").forEach(function(letter) {
                            test3[letter] = letter;
                        });
                        if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") return false;
                        return true;
                    } catch (err) {
                        // We don't expect any of the above to throw, but better to be safe.
                        return false;
                    }
                }
                module1.exports = shouldUseNative() ? Object.assign : function(target, source) {
                    var from;
                    var to = toObject(target);
                    var symbols;
                    for(var s = 1; s < arguments.length; s++){
                        from = Object(arguments[s]);
                        for(var key in from)if (hasOwnProperty.call(from, key)) to[key] = from[key];
                        if (getOwnPropertySymbols) {
                            symbols = getOwnPropertySymbols(from);
                            for(var i = 0; i < symbols.length; i++)if (propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
                        }
                    }
                    return to;
                };
            /***/ },
            /***/ "./node_modules/prop-types/checkPropTypes.js": /*!***************************************************!*\
  !*** ./node_modules/prop-types/checkPropTypes.js ***!
  \***************************************************/ /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                "use strict";
                /**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var printWarning = function() {};
                var ReactPropTypesSecret = __webpack_require__(/*! ./lib/ReactPropTypesSecret */ "./node_modules/prop-types/lib/ReactPropTypesSecret.js");
                var loggedTypeFailures = {};
                var has = __webpack_require__(/*! ./lib/has */ "./node_modules/prop-types/lib/has.js");
                printWarning = function(text) {
                    var message = "Warning: " + text;
                    if (typeof console !== "undefined") console.error(message);
                    try {
                        // --- Welcome to debugging React ---
                        // This error was thrown as a convenience so that you can use this stack
                        // to find the callsite that caused this warning to fire.
                        throw new Error(message);
                    } catch (x) {}
                };
                /**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */ function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
                    for(var typeSpecName in typeSpecs)if (has(typeSpecs, typeSpecName)) {
                        var error;
                        // Prop type validation may throw. In case they do, we don't want to
                        // fail the render phase where it didn't fail before. So we log it.
                        // After these have been cleaned up, we'll let them throw.
                        try {
                            // This is intentionally an invariant that gets caught. It's the same
                            // behavior as without this statement except with a better message.
                            if (typeof typeSpecs[typeSpecName] !== "function") {
                                var err = Error((componentName || "React class") + ": " + location + " type `" + typeSpecName + "` is invalid; " + "it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`." + "This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                                err.name = "Invariant Violation";
                                throw err;
                            }
                            error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
                        } catch (ex) {
                            error = ex;
                        }
                        if (error && !(error instanceof Error)) printWarning((componentName || "React class") + ": type specification of " + location + " `" + typeSpecName + "` is invalid; the type checker " + "function must return `null` or an `Error` but returned a " + typeof error + ". " + "You may have forgotten to pass an argument to the type checker " + "creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and " + "shape all require an argument).");
                        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
                            // Only monitor this failure once because there tends to be a lot of the
                            // same error.
                            loggedTypeFailures[error.message] = true;
                            var stack = getStack ? getStack() : "";
                            printWarning("Failed " + location + " type: " + error.message + (stack != null ? stack : ""));
                        }
                    }
                }
                /**
 * Resets warning cache when testing.
 *
 * @private
 */ checkPropTypes.resetWarningCache = function() {
                    loggedTypeFailures = {};
                };
                module1.exports = checkPropTypes;
            /***/ },
            /***/ "./node_modules/prop-types/factoryWithTypeCheckers.js": /*!************************************************************!*\
  !*** ./node_modules/prop-types/factoryWithTypeCheckers.js ***!
  \************************************************************/ /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                "use strict";
                /**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var ReactIs = __webpack_require__(/*! react-is */ "./node_modules/react-is/index.js");
                var assign = __webpack_require__(/*! object-assign */ "./node_modules/object-assign/index.js");
                var ReactPropTypesSecret = __webpack_require__(/*! ./lib/ReactPropTypesSecret */ "./node_modules/prop-types/lib/ReactPropTypesSecret.js");
                var has = __webpack_require__(/*! ./lib/has */ "./node_modules/prop-types/lib/has.js");
                var checkPropTypes = __webpack_require__(/*! ./checkPropTypes */ "./node_modules/prop-types/checkPropTypes.js");
                var printWarning = function() {};
                printWarning = function(text) {
                    var message = "Warning: " + text;
                    if (typeof console !== "undefined") console.error(message);
                    try {
                        // --- Welcome to debugging React ---
                        // This error was thrown as a convenience so that you can use this stack
                        // to find the callsite that caused this warning to fire.
                        throw new Error(message);
                    } catch (x) {}
                };
                function emptyFunctionThatReturnsNull() {
                    return null;
                }
                module1.exports = function(isValidElement, throwOnDirectAccess) {
                    /* global Symbol */ var ITERATOR_SYMBOL = typeof Symbol === "function" && Symbol.iterator;
                    var FAUX_ITERATOR_SYMBOL = "@@iterator"; // Before Symbol spec.
                    /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */ function getIteratorFn(maybeIterable) {
                        var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
                        if (typeof iteratorFn === "function") return iteratorFn;
                    }
                    /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */ var ANONYMOUS = "<<anonymous>>";
                    // Important!
                    // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
                    var ReactPropTypes = {
                        array: createPrimitiveTypeChecker("array"),
                        bigint: createPrimitiveTypeChecker("bigint"),
                        bool: createPrimitiveTypeChecker("boolean"),
                        func: createPrimitiveTypeChecker("function"),
                        number: createPrimitiveTypeChecker("number"),
                        object: createPrimitiveTypeChecker("object"),
                        string: createPrimitiveTypeChecker("string"),
                        symbol: createPrimitiveTypeChecker("symbol"),
                        any: createAnyTypeChecker(),
                        arrayOf: createArrayOfTypeChecker,
                        element: createElementTypeChecker(),
                        elementType: createElementTypeTypeChecker(),
                        instanceOf: createInstanceTypeChecker,
                        node: createNodeChecker(),
                        objectOf: createObjectOfTypeChecker,
                        oneOf: createEnumTypeChecker,
                        oneOfType: createUnionTypeChecker,
                        shape: createShapeTypeChecker,
                        exact: createStrictShapeTypeChecker
                    };
                    /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */ /*eslint-disable no-self-compare*/ function is(x, y) {
                        // SameValue algorithm
                        if (x === y) // Steps 1-5, 7-10
                        // Steps 6.b-6.e: +0 != -0
                        return x !== 0 || 1 / x === 1 / y;
                        else // Step 6.a: NaN == NaN
                        return x !== x && y !== y;
                    }
                    /*eslint-enable no-self-compare*/ /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */ function PropTypeError(message, data) {
                        this.message = message;
                        this.data = data && typeof data === "object" ? data : {};
                        this.stack = "";
                    }
                    // Make `instanceof Error` still work for returned errors.
                    PropTypeError.prototype = Error.prototype;
                    function createChainableTypeChecker(validate) {
                        var manualPropTypeCallCache = {};
                        var manualPropTypeWarningCount = 0;
                        function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
                            componentName = componentName || ANONYMOUS;
                            propFullName = propFullName || propName;
                            if (secret !== ReactPropTypesSecret) {
                                if (throwOnDirectAccess) {
                                    // New behavior only for users of `prop-types` package
                                    var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");
                                    err.name = "Invariant Violation";
                                    throw err;
                                } else if (typeof console !== "undefined") {
                                    // Old behavior for people using React.PropTypes
                                    var cacheKey = componentName + ":" + propName;
                                    if (!manualPropTypeCallCache[cacheKey] && // Avoid spamming the console because they are often not actionable except for lib authors
                                    manualPropTypeWarningCount < 3) {
                                        printWarning("You are manually calling a React.PropTypes validation function for the `" + propFullName + "` prop on `" + componentName + "`. This is deprecated " + "and will throw in the standalone `prop-types` package. " + "You may be seeing this warning due to a third-party PropTypes " + "library. See https://fb.me/react-warning-dont-call-proptypes " + "for details.");
                                        manualPropTypeCallCache[cacheKey] = true;
                                        manualPropTypeWarningCount++;
                                    }
                                }
                            }
                            if (props[propName] == null) {
                                if (isRequired) {
                                    if (props[propName] === null) return new PropTypeError("The " + location + " `" + propFullName + "` is marked as required " + ("in `" + componentName + "`, but its value is `null`."));
                                    return new PropTypeError("The " + location + " `" + propFullName + "` is marked as required in " + ("`" + componentName + "`, but its value is `undefined`."));
                                }
                                return null;
                            } else return validate(props, propName, componentName, location, propFullName);
                        }
                        var chainedCheckType = checkType.bind(null, false);
                        chainedCheckType.isRequired = checkType.bind(null, true);
                        return chainedCheckType;
                    }
                    function createPrimitiveTypeChecker(expectedType) {
                        function validate(props, propName, componentName, location, propFullName, secret) {
                            var propValue = props[propName];
                            var propType = getPropType(propValue);
                            if (propType !== expectedType) {
                                // `propValue` being instance of, say, date/regexp, pass the 'object'
                                // check, but we can offer a more precise error message here rather than
                                // 'of type `object`'.
                                var preciseType = getPreciseType(propValue);
                                return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + preciseType + "` supplied to `" + componentName + "`, expected ") + ("`" + expectedType + "`."), {
                                    expectedType: expectedType
                                });
                            }
                            return null;
                        }
                        return createChainableTypeChecker(validate);
                    }
                    function createAnyTypeChecker() {
                        return createChainableTypeChecker(emptyFunctionThatReturnsNull);
                    }
                    function createArrayOfTypeChecker(typeChecker) {
                        function validate(props, propName, componentName, location, propFullName) {
                            if (typeof typeChecker !== "function") return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside arrayOf.");
                            var propValue = props[propName];
                            if (!Array.isArray(propValue)) {
                                var propType = getPropType(propValue);
                                return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an array."));
                            }
                            for(var i = 0; i < propValue.length; i++){
                                var error = typeChecker(propValue, i, componentName, location, propFullName + "[" + i + "]", ReactPropTypesSecret);
                                if (error instanceof Error) return error;
                            }
                            return null;
                        }
                        return createChainableTypeChecker(validate);
                    }
                    function createElementTypeChecker() {
                        function validate(props, propName, componentName, location, propFullName) {
                            var propValue = props[propName];
                            if (!isValidElement(propValue)) {
                                var propType = getPropType(propValue);
                                return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected a single ReactElement."));
                            }
                            return null;
                        }
                        return createChainableTypeChecker(validate);
                    }
                    function createElementTypeTypeChecker() {
                        function validate(props, propName, componentName, location, propFullName) {
                            var propValue = props[propName];
                            if (!ReactIs.isValidElementType(propValue)) {
                                var propType = getPropType(propValue);
                                return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected a single ReactElement type."));
                            }
                            return null;
                        }
                        return createChainableTypeChecker(validate);
                    }
                    function createInstanceTypeChecker(expectedClass) {
                        function validate(props, propName, componentName, location, propFullName) {
                            if (!(props[propName] instanceof expectedClass)) {
                                var expectedClassName = expectedClass.name || ANONYMOUS;
                                var actualClassName = getClassName(props[propName]);
                                return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + actualClassName + "` supplied to `" + componentName + "`, expected ") + ("instance of `" + expectedClassName + "`."));
                            }
                            return null;
                        }
                        return createChainableTypeChecker(validate);
                    }
                    function createEnumTypeChecker(expectedValues) {
                        if (!Array.isArray(expectedValues)) {
                            {
                                if (arguments.length > 1) printWarning("Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. " + "A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).");
                                else printWarning("Invalid argument supplied to oneOf, expected an array.");
                            }
                            return emptyFunctionThatReturnsNull;
                        }
                        function validate(props, propName, componentName, location, propFullName) {
                            var propValue = props[propName];
                            for(var i = 0; i < expectedValues.length; i++){
                                if (is(propValue, expectedValues[i])) return null;
                            }
                            var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
                                var type = getPreciseType(value);
                                if (type === "symbol") return String(value);
                                return value;
                            });
                            return new PropTypeError("Invalid " + location + " `" + propFullName + "` of value `" + String(propValue) + "` " + ("supplied to `" + componentName + "`, expected one of " + valuesString + "."));
                        }
                        return createChainableTypeChecker(validate);
                    }
                    function createObjectOfTypeChecker(typeChecker) {
                        function validate(props, propName, componentName, location, propFullName) {
                            if (typeof typeChecker !== "function") return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside objectOf.");
                            var propValue = props[propName];
                            var propType = getPropType(propValue);
                            if (propType !== "object") return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an object."));
                            for(var key in propValue)if (has(propValue, key)) {
                                var error = typeChecker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
                                if (error instanceof Error) return error;
                            }
                            return null;
                        }
                        return createChainableTypeChecker(validate);
                    }
                    function createUnionTypeChecker(arrayOfTypeCheckers) {
                        if (!Array.isArray(arrayOfTypeCheckers)) {
                            printWarning("Invalid argument supplied to oneOfType, expected an instance of array.");
                            return emptyFunctionThatReturnsNull;
                        }
                        for(var i = 0; i < arrayOfTypeCheckers.length; i++){
                            var checker = arrayOfTypeCheckers[i];
                            if (typeof checker !== "function") {
                                printWarning("Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + getPostfixForTypeWarning(checker) + " at index " + i + ".");
                                return emptyFunctionThatReturnsNull;
                            }
                        }
                        function validate(props, propName, componentName, location, propFullName) {
                            var expectedTypes = [];
                            for(var i = 0; i < arrayOfTypeCheckers.length; i++){
                                var checker = arrayOfTypeCheckers[i];
                                var checkerResult = checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret);
                                if (checkerResult == null) return null;
                                if (checkerResult.data && has(checkerResult.data, "expectedType")) expectedTypes.push(checkerResult.data.expectedType);
                            }
                            var expectedTypesMessage = expectedTypes.length > 0 ? ", expected one of type [" + expectedTypes.join(", ") + "]" : "";
                            return new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to " + ("`" + componentName + "`" + expectedTypesMessage + "."));
                        }
                        return createChainableTypeChecker(validate);
                    }
                    function createNodeChecker() {
                        function validate(props, propName, componentName, location, propFullName) {
                            if (!isNode(props[propName])) return new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to " + ("`" + componentName + "`, expected a ReactNode."));
                            return null;
                        }
                        return createChainableTypeChecker(validate);
                    }
                    function invalidValidatorError(componentName, location, propFullName, key, type) {
                        return new PropTypeError((componentName || "React class") + ": " + location + " type `" + propFullName + "." + key + "` is invalid; " + "it must be a function, usually from the `prop-types` package, but received `" + type + "`.");
                    }
                    function createShapeTypeChecker(shapeTypes) {
                        function validate(props, propName, componentName, location, propFullName) {
                            var propValue = props[propName];
                            var propType = getPropType(propValue);
                            if (propType !== "object") return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
                            for(var key in shapeTypes){
                                var checker = shapeTypes[key];
                                if (typeof checker !== "function") return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
                                var error = checker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
                                if (error) return error;
                            }
                            return null;
                        }
                        return createChainableTypeChecker(validate);
                    }
                    function createStrictShapeTypeChecker(shapeTypes) {
                        function validate(props, propName, componentName, location, propFullName) {
                            var propValue = props[propName];
                            var propType = getPropType(propValue);
                            if (propType !== "object") return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
                            // We need to check all keys in case some are required but missing from props.
                            var allKeys = assign({}, props[propName], shapeTypes);
                            for(var key in allKeys){
                                var checker = shapeTypes[key];
                                if (has(shapeTypes, key) && typeof checker !== "function") return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
                                if (!checker) return new PropTypeError("Invalid " + location + " `" + propFullName + "` key `" + key + "` supplied to `" + componentName + "`." + "\nBad object: " + JSON.stringify(props[propName], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(shapeTypes), null, "  "));
                                var error = checker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
                                if (error) return error;
                            }
                            return null;
                        }
                        return createChainableTypeChecker(validate);
                    }
                    function isNode(propValue) {
                        switch(typeof propValue){
                            case "number":
                            case "string":
                            case "undefined":
                                return true;
                            case "boolean":
                                return !propValue;
                            case "object":
                                if (Array.isArray(propValue)) return propValue.every(isNode);
                                if (propValue === null || isValidElement(propValue)) return true;
                                var iteratorFn = getIteratorFn(propValue);
                                if (iteratorFn) {
                                    var iterator = iteratorFn.call(propValue);
                                    var step;
                                    if (iteratorFn !== propValue.entries) while(!(step = iterator.next()).done){
                                        if (!isNode(step.value)) return false;
                                    }
                                    else // Iterator will provide entry [k,v] tuples rather than values.
                                    while(!(step = iterator.next()).done){
                                        var entry = step.value;
                                        if (entry) {
                                            if (!isNode(entry[1])) return false;
                                        }
                                    }
                                } else return false;
                                return true;
                            default:
                                return false;
                        }
                    }
                    function isSymbol(propType, propValue) {
                        // Native Symbol.
                        if (propType === "symbol") return true;
                        // falsy value can't be a Symbol
                        if (!propValue) return false;
                        // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
                        if (propValue["@@toStringTag"] === "Symbol") return true;
                        // Fallback for non-spec compliant Symbols which are polyfilled.
                        if (typeof Symbol === "function" && propValue instanceof Symbol) return true;
                        return false;
                    }
                    // Equivalent of `typeof` but with special handling for array and regexp.
                    function getPropType(propValue) {
                        var propType = typeof propValue;
                        if (Array.isArray(propValue)) return "array";
                        if (propValue instanceof RegExp) // Old webkits (at least until Android 4.0) return 'function' rather than
                        // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
                        // passes PropTypes.object.
                        return "object";
                        if (isSymbol(propType, propValue)) return "symbol";
                        return propType;
                    }
                    // This handles more types than `getPropType`. Only used for error messages.
                    // See `createPrimitiveTypeChecker`.
                    function getPreciseType(propValue) {
                        if (typeof propValue === "undefined" || propValue === null) return "" + propValue;
                        var propType = getPropType(propValue);
                        if (propType === "object") {
                            if (propValue instanceof Date) return "date";
                            else if (propValue instanceof RegExp) return "regexp";
                        }
                        return propType;
                    }
                    // Returns a string that is postfixed to a warning about an invalid type.
                    // For example, "undefined" or "of type array"
                    function getPostfixForTypeWarning(value) {
                        var type = getPreciseType(value);
                        switch(type){
                            case "array":
                            case "object":
                                return "an " + type;
                            case "boolean":
                            case "date":
                            case "regexp":
                                return "a " + type;
                            default:
                                return type;
                        }
                    }
                    // Returns class name of the object, if any.
                    function getClassName(propValue) {
                        if (!propValue.constructor || !propValue.constructor.name) return ANONYMOUS;
                        return propValue.constructor.name;
                    }
                    ReactPropTypes.checkPropTypes = checkPropTypes;
                    ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
                    ReactPropTypes.PropTypes = ReactPropTypes;
                    return ReactPropTypes;
                };
            /***/ },
            /***/ "./node_modules/prop-types/index.js": /*!******************************************!*\
  !*** ./node_modules/prop-types/index.js ***!
  \******************************************/ /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                var ReactIs = __webpack_require__(/*! react-is */ "./node_modules/react-is/index.js");
                // By explicitly using `prop-types` you are opting into new development behavior.
                // http://fb.me/prop-types-in-prod
                var throwOnDirectAccess = true;
                module1.exports = __webpack_require__(/*! ./factoryWithTypeCheckers */ "./node_modules/prop-types/factoryWithTypeCheckers.js")(ReactIs.isElement, throwOnDirectAccess);
            /***/ },
            /***/ "./node_modules/prop-types/lib/ReactPropTypesSecret.js": /*!*************************************************************!*\
  !*** ./node_modules/prop-types/lib/ReactPropTypesSecret.js ***!
  \*************************************************************/ /***/ (module1)=>{
                "use strict";
                /**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
                module1.exports = ReactPropTypesSecret;
            /***/ },
            /***/ "./node_modules/prop-types/lib/has.js": /*!********************************************!*\
  !*** ./node_modules/prop-types/lib/has.js ***!
  \********************************************/ /***/ (module1)=>{
                module1.exports = Function.call.bind(Object.prototype.hasOwnProperty);
            /***/ },
            /***/ "./node_modules/react-is/cjs/react-is.development.js": /*!***********************************************************!*\
  !*** ./node_modules/react-is/cjs/react-is.development.js ***!
  \***********************************************************/ /***/ (__unused_webpack_module, exports)=>{
                "use strict";
                (function() {
                    "use strict";
                    // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
                    // nor polyfill, then a plain number is used for performance.
                    var hasSymbol = typeof Symbol === "function" && Symbol.for;
                    var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for("react.element") : 0xeac7;
                    var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for("react.portal") : 0xeaca;
                    var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for("react.fragment") : 0xeacb;
                    var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for("react.strict_mode") : 0xeacc;
                    var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for("react.profiler") : 0xead2;
                    var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for("react.provider") : 0xeacd;
                    var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for("react.context") : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
                    // (unstable) APIs that have been removed. Can we remove the symbols?
                    var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for("react.async_mode") : 0xeacf;
                    var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for("react.concurrent_mode") : 0xeacf;
                    var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for("react.forward_ref") : 0xead0;
                    var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for("react.suspense") : 0xead1;
                    var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for("react.suspense_list") : 0xead8;
                    var REACT_MEMO_TYPE = hasSymbol ? Symbol.for("react.memo") : 0xead3;
                    var REACT_LAZY_TYPE = hasSymbol ? Symbol.for("react.lazy") : 0xead4;
                    var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for("react.block") : 0xead9;
                    var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for("react.fundamental") : 0xead5;
                    var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for("react.responder") : 0xead6;
                    var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for("react.scope") : 0xead7;
                    function isValidElementType(type) {
                        return typeof type === "string" || typeof type === "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
                        type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === "object" && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
                    }
                    function typeOf(object) {
                        if (typeof object === "object" && object !== null) {
                            var $$typeof = object.$$typeof;
                            switch($$typeof){
                                case REACT_ELEMENT_TYPE:
                                    var type = object.type;
                                    switch(type){
                                        case REACT_ASYNC_MODE_TYPE:
                                        case REACT_CONCURRENT_MODE_TYPE:
                                        case REACT_FRAGMENT_TYPE:
                                        case REACT_PROFILER_TYPE:
                                        case REACT_STRICT_MODE_TYPE:
                                        case REACT_SUSPENSE_TYPE:
                                            return type;
                                        default:
                                            var $$typeofType = type && type.$$typeof;
                                            switch($$typeofType){
                                                case REACT_CONTEXT_TYPE:
                                                case REACT_FORWARD_REF_TYPE:
                                                case REACT_LAZY_TYPE:
                                                case REACT_MEMO_TYPE:
                                                case REACT_PROVIDER_TYPE:
                                                    return $$typeofType;
                                                default:
                                                    return $$typeof;
                                            }
                                    }
                                case REACT_PORTAL_TYPE:
                                    return $$typeof;
                            }
                        }
                        return undefined;
                    } // AsyncMode is deprecated along with isAsyncMode
                    var AsyncMode = REACT_ASYNC_MODE_TYPE;
                    var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
                    var ContextConsumer = REACT_CONTEXT_TYPE;
                    var ContextProvider = REACT_PROVIDER_TYPE;
                    var Element = REACT_ELEMENT_TYPE;
                    var ForwardRef = REACT_FORWARD_REF_TYPE;
                    var Fragment = REACT_FRAGMENT_TYPE;
                    var Lazy = REACT_LAZY_TYPE;
                    var Memo = REACT_MEMO_TYPE;
                    var Portal = REACT_PORTAL_TYPE;
                    var Profiler = REACT_PROFILER_TYPE;
                    var StrictMode = REACT_STRICT_MODE_TYPE;
                    var Suspense = REACT_SUSPENSE_TYPE;
                    var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated
                    function isAsyncMode(object) {
                        if (!hasWarnedAboutDeprecatedIsAsyncMode) {
                            hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint
                            console["warn"]("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.");
                        }
                        return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
                    }
                    function isConcurrentMode(object) {
                        return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
                    }
                    function isContextConsumer(object) {
                        return typeOf(object) === REACT_CONTEXT_TYPE;
                    }
                    function isContextProvider(object) {
                        return typeOf(object) === REACT_PROVIDER_TYPE;
                    }
                    function isElement(object) {
                        return typeof object === "object" && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
                    }
                    function isForwardRef(object) {
                        return typeOf(object) === REACT_FORWARD_REF_TYPE;
                    }
                    function isFragment(object) {
                        return typeOf(object) === REACT_FRAGMENT_TYPE;
                    }
                    function isLazy(object) {
                        return typeOf(object) === REACT_LAZY_TYPE;
                    }
                    function isMemo(object) {
                        return typeOf(object) === REACT_MEMO_TYPE;
                    }
                    function isPortal(object) {
                        return typeOf(object) === REACT_PORTAL_TYPE;
                    }
                    function isProfiler(object) {
                        return typeOf(object) === REACT_PROFILER_TYPE;
                    }
                    function isStrictMode(object) {
                        return typeOf(object) === REACT_STRICT_MODE_TYPE;
                    }
                    function isSuspense(object) {
                        return typeOf(object) === REACT_SUSPENSE_TYPE;
                    }
                    exports.AsyncMode = AsyncMode;
                    exports.ConcurrentMode = ConcurrentMode;
                    exports.ContextConsumer = ContextConsumer;
                    exports.ContextProvider = ContextProvider;
                    exports.Element = Element;
                    exports.ForwardRef = ForwardRef;
                    exports.Fragment = Fragment;
                    exports.Lazy = Lazy;
                    exports.Memo = Memo;
                    exports.Portal = Portal;
                    exports.Profiler = Profiler;
                    exports.StrictMode = StrictMode;
                    exports.Suspense = Suspense;
                    exports.isAsyncMode = isAsyncMode;
                    exports.isConcurrentMode = isConcurrentMode;
                    exports.isContextConsumer = isContextConsumer;
                    exports.isContextProvider = isContextProvider;
                    exports.isElement = isElement;
                    exports.isForwardRef = isForwardRef;
                    exports.isFragment = isFragment;
                    exports.isLazy = isLazy;
                    exports.isMemo = isMemo;
                    exports.isPortal = isPortal;
                    exports.isProfiler = isProfiler;
                    exports.isStrictMode = isStrictMode;
                    exports.isSuspense = isSuspense;
                    exports.isValidElementType = isValidElementType;
                    exports.typeOf = typeOf;
                })();
            /***/ },
            /***/ "./node_modules/react-is/index.js": /*!****************************************!*\
  !*** ./node_modules/react-is/index.js ***!
  \****************************************/ /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                "use strict";
                module1.exports = __webpack_require__(/*! ./cjs/react-is.development.js */ "./node_modules/react-is/cjs/react-is.development.js");
            /***/ },
            /***/ "./node_modules/shallow-equal/dist/index.esm.js": /*!******************************************************!*\
  !*** ./node_modules/shallow-equal/dist/index.esm.js ***!
  \******************************************************/ /***/ (__unused_webpack_module, __webpack_exports__, __webpack_require__)=>{
                "use strict";
                __webpack_require__.r(__webpack_exports__);
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ "shallowEqualArrays": ()=>/* binding */ shallowEqualArrays,
                    /* harmony export */ "shallowEqualObjects": ()=>/* binding */ shallowEqualObjects
                });
                function shallowEqualObjects(objA, objB) {
                    if (objA === objB) return true;
                    if (!objA || !objB) return false;
                    var aKeys = Object.keys(objA);
                    var bKeys = Object.keys(objB);
                    var len = aKeys.length;
                    if (bKeys.length !== len) return false;
                    for(var i = 0; i < len; i++){
                        var key = aKeys[i];
                        if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) return false;
                    }
                    return true;
                }
                function shallowEqualArrays(arrA, arrB) {
                    if (arrA === arrB) return true;
                    if (!arrA || !arrB) return false;
                    var len = arrA.length;
                    if (arrB.length !== len) return false;
                    for(var i = 0; i < len; i++){
                        if (arrA[i] !== arrB[i]) return false;
                    }
                    return true;
                }
            /***/ },
            /***/ "./src/Component.ts": /*!**************************!*\
  !*** ./src/Component.ts ***!
  \**************************/ /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                "use strict";
                var __rest = this && this.__rest || function(s, e) {
                    var t = {};
                    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
                    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
                        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
                    }
                    return t;
                };
                var __importDefault = this && this.__importDefault || function(mod) {
                    return mod && mod.__esModule ? mod : {
                        "default": mod
                    };
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var useMediaQuery_1 = __importDefault(__webpack_require__(/*! ./useMediaQuery */ "./src/useMediaQuery.ts"));
                // ReactNode and ReactElement typings are a little funky for functional components, so the ReactElement cast is needed on the return
                var MediaQuery = function(_a) {
                    var children = _a.children, device = _a.device, onChange = _a.onChange, settings = __rest(_a, [
                        "children",
                        "device",
                        "onChange"
                    ]);
                    var matches = (0, useMediaQuery_1.default)(settings, device, onChange);
                    if (typeof children === "function") return children(matches);
                    return matches ? children : null;
                };
                exports["default"] = MediaQuery;
            /***/ },
            /***/ "./src/Context.ts": /*!************************!*\
  !*** ./src/Context.ts ***!
  \************************/ /***/ (__unused_webpack_module, exports, __webpack_require__)=>{
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var react_1 = __webpack_require__(/*! react */ "react");
                var Context = (0, react_1.createContext)(undefined);
                exports["default"] = Context;
            /***/ },
            /***/ "./src/index.ts": /*!**********************!*\
  !*** ./src/index.ts ***!
  \**********************/ /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                "use strict";
                var __importDefault = this && this.__importDefault || function(mod) {
                    return mod && mod.__esModule ? mod : {
                        "default": mod
                    };
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.Context = exports.toQuery = exports.useMediaQuery = exports["default"] = void 0;
                var useMediaQuery_1 = __importDefault(__webpack_require__(/*! ./useMediaQuery */ "./src/useMediaQuery.ts"));
                exports.useMediaQuery = useMediaQuery_1.default;
                var Component_1 = __importDefault(__webpack_require__(/*! ./Component */ "./src/Component.ts"));
                exports["default"] = Component_1.default;
                var toQuery_1 = __importDefault(__webpack_require__(/*! ./toQuery */ "./src/toQuery.ts"));
                exports.toQuery = toQuery_1.default;
                var Context_1 = __importDefault(__webpack_require__(/*! ./Context */ "./src/Context.ts"));
                exports.Context = Context_1.default;
            /***/ },
            /***/ "./src/mediaQuery.ts": /*!***************************!*\
  !*** ./src/mediaQuery.ts ***!
  \***************************/ /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                "use strict";
                var __assign = this && this.__assign || function() {
                    __assign = Object.assign || function(t) {
                        for(var s, i = 1, n = arguments.length; i < n; i++){
                            s = arguments[i];
                            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                        }
                        return t;
                    };
                    return __assign.apply(this, arguments);
                };
                var __rest = this && this.__rest || function(s, e) {
                    var t = {};
                    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
                    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
                        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
                    }
                    return t;
                };
                var __importDefault = this && this.__importDefault || function(mod) {
                    return mod && mod.__esModule ? mod : {
                        "default": mod
                    };
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var prop_types_1 = __importDefault(__webpack_require__(/*! prop-types */ "./node_modules/prop-types/index.js"));
                var stringOrNumber = prop_types_1.default.oneOfType([
                    prop_types_1.default.string,
                    prop_types_1.default.number
                ]);
                // media types
                var types = {
                    all: prop_types_1.default.bool,
                    grid: prop_types_1.default.bool,
                    aural: prop_types_1.default.bool,
                    braille: prop_types_1.default.bool,
                    handheld: prop_types_1.default.bool,
                    print: prop_types_1.default.bool,
                    projection: prop_types_1.default.bool,
                    screen: prop_types_1.default.bool,
                    tty: prop_types_1.default.bool,
                    tv: prop_types_1.default.bool,
                    embossed: prop_types_1.default.bool
                };
                // properties that match media queries
                var matchers = {
                    orientation: prop_types_1.default.oneOf([
                        "portrait",
                        "landscape"
                    ]),
                    scan: prop_types_1.default.oneOf([
                        "progressive",
                        "interlace"
                    ]),
                    aspectRatio: prop_types_1.default.string,
                    deviceAspectRatio: prop_types_1.default.string,
                    height: stringOrNumber,
                    deviceHeight: stringOrNumber,
                    width: stringOrNumber,
                    deviceWidth: stringOrNumber,
                    color: prop_types_1.default.bool,
                    colorIndex: prop_types_1.default.bool,
                    monochrome: prop_types_1.default.bool,
                    resolution: stringOrNumber,
                    type: Object.keys(types)
                };
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                var type = matchers.type, featureMatchers = __rest(matchers, [
                    "type"
                ]);
                // media features
                var features = __assign({
                    minAspectRatio: prop_types_1.default.string,
                    maxAspectRatio: prop_types_1.default.string,
                    minDeviceAspectRatio: prop_types_1.default.string,
                    maxDeviceAspectRatio: prop_types_1.default.string,
                    minHeight: stringOrNumber,
                    maxHeight: stringOrNumber,
                    minDeviceHeight: stringOrNumber,
                    maxDeviceHeight: stringOrNumber,
                    minWidth: stringOrNumber,
                    maxWidth: stringOrNumber,
                    minDeviceWidth: stringOrNumber,
                    maxDeviceWidth: stringOrNumber,
                    minColor: prop_types_1.default.number,
                    maxColor: prop_types_1.default.number,
                    minColorIndex: prop_types_1.default.number,
                    maxColorIndex: prop_types_1.default.number,
                    minMonochrome: prop_types_1.default.number,
                    maxMonochrome: prop_types_1.default.number,
                    minResolution: stringOrNumber,
                    maxResolution: stringOrNumber
                }, featureMatchers);
                var all = __assign(__assign({}, types), features);
                exports["default"] = {
                    all: all,
                    types: types,
                    matchers: matchers,
                    features: features
                };
            /***/ },
            /***/ "./src/toQuery.ts": /*!************************!*\
  !*** ./src/toQuery.ts ***!
  \************************/ /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                "use strict";
                var __importDefault = this && this.__importDefault || function(mod) {
                    return mod && mod.__esModule ? mod : {
                        "default": mod
                    };
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var hyphenate_style_name_1 = __importDefault(__webpack_require__(/*! hyphenate-style-name */ "./node_modules/hyphenate-style-name/index.js"));
                var mediaQuery_1 = __importDefault(__webpack_require__(/*! ./mediaQuery */ "./src/mediaQuery.ts"));
                var negate = function(cond) {
                    return "not ".concat(cond);
                };
                var keyVal = function(k, v) {
                    var realKey = (0, hyphenate_style_name_1.default)(k);
                    // px shorthand
                    if (typeof v === "number") v = "".concat(v, "px");
                    if (v === true) return realKey;
                    if (v === false) return negate(realKey);
                    return "(".concat(realKey, ": ").concat(v, ")");
                };
                var join = function(conds) {
                    return conds.join(" and ");
                };
                var toQuery = function(obj) {
                    var rules = [];
                    Object.keys(mediaQuery_1.default.all).forEach(function(k) {
                        var v = obj[k];
                        if (v != null) rules.push(keyVal(k, v));
                    });
                    return join(rules);
                };
                exports["default"] = toQuery;
            /***/ },
            /***/ "./src/useMediaQuery.ts": /*!******************************!*\
  !*** ./src/useMediaQuery.ts ***!
  \******************************/ /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                "use strict";
                var __importDefault = this && this.__importDefault || function(mod) {
                    return mod && mod.__esModule ? mod : {
                        "default": mod
                    };
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var react_1 = __webpack_require__(/*! react */ "react");
                var matchmediaquery_1 = __importDefault(__webpack_require__(/*! matchmediaquery */ "./node_modules/matchmediaquery/index.js"));
                var hyphenate_style_name_1 = __importDefault(__webpack_require__(/*! hyphenate-style-name */ "./node_modules/hyphenate-style-name/index.js"));
                var shallow_equal_1 = __webpack_require__(/*! shallow-equal */ "./node_modules/shallow-equal/dist/index.esm.js");
                var toQuery_1 = __importDefault(__webpack_require__(/*! ./toQuery */ "./src/toQuery.ts"));
                var Context_1 = __importDefault(__webpack_require__(/*! ./Context */ "./src/Context.ts"));
                var makeQuery = function(settings) {
                    return settings.query || (0, toQuery_1.default)(settings);
                };
                var hyphenateKeys = function(obj) {
                    if (!obj) return undefined;
                    var keys = Object.keys(obj);
                    return keys.reduce(function(result, key) {
                        result[(0, hyphenate_style_name_1.default)(key)] = obj[key];
                        return result;
                    }, {});
                };
                var useIsUpdate = function() {
                    var ref = (0, react_1.useRef)(false);
                    (0, react_1.useEffect)(function() {
                        ref.current = true;
                    }, []);
                    return ref.current;
                };
                var useDevice = function(deviceFromProps) {
                    var deviceFromContext = (0, react_1.useContext)(Context_1.default);
                    var getDevice = function() {
                        return hyphenateKeys(deviceFromProps) || hyphenateKeys(deviceFromContext);
                    };
                    var _a = (0, react_1.useState)(getDevice), device = _a[0], setDevice = _a[1];
                    (0, react_1.useEffect)(function() {
                        var newDevice = getDevice();
                        if (!(0, shallow_equal_1.shallowEqualObjects)(device, newDevice)) setDevice(newDevice);
                    }, [
                        deviceFromProps,
                        deviceFromContext
                    ]);
                    return device;
                };
                var useQuery = function(settings) {
                    var getQuery = function() {
                        return makeQuery(settings);
                    };
                    var _a = (0, react_1.useState)(getQuery), query = _a[0], setQuery = _a[1];
                    (0, react_1.useEffect)(function() {
                        var newQuery = getQuery();
                        if (query !== newQuery) setQuery(newQuery);
                    }, [
                        settings
                    ]);
                    return query;
                };
                var useMatchMedia = function(query, device) {
                    var getMatchMedia = function() {
                        return (0, matchmediaquery_1.default)(query, device || {}, !!device);
                    };
                    var _a = (0, react_1.useState)(getMatchMedia), mq = _a[0], setMq = _a[1];
                    var isUpdate = useIsUpdate();
                    (0, react_1.useEffect)(function() {
                        if (isUpdate) {
                            // skip on mounting, it has already been set
                            var newMq_1 = getMatchMedia();
                            setMq(newMq_1);
                            return function() {
                                if (newMq_1) newMq_1.dispose();
                            };
                        }
                    }, [
                        query,
                        device
                    ]);
                    return mq;
                };
                var useMatches = function(mediaQuery) {
                    var _a = (0, react_1.useState)(mediaQuery.matches), matches = _a[0], setMatches = _a[1];
                    (0, react_1.useEffect)(function() {
                        var updateMatches = function(ev) {
                            setMatches(ev.matches);
                        };
                        mediaQuery.addListener(updateMatches);
                        setMatches(mediaQuery.matches);
                        return function() {
                            mediaQuery.removeListener(updateMatches);
                        };
                    }, [
                        mediaQuery
                    ]);
                    return matches;
                };
                var useMediaQuery = function(settings, device, onChange) {
                    var deviceSettings = useDevice(device);
                    var query = useQuery(settings);
                    if (!query) throw new Error("Invalid or missing MediaQuery!");
                    var mq = useMatchMedia(query, deviceSettings);
                    var matches = useMatches(mq);
                    var isUpdate = useIsUpdate();
                    (0, react_1.useEffect)(function() {
                        if (isUpdate && onChange) onChange(matches);
                    }, [
                        matches
                    ]);
                    (0, react_1.useEffect)(function() {
                        return function() {
                            if (mq) mq.dispose();
                        };
                    }, []);
                    return matches;
                };
                exports["default"] = useMediaQuery;
            /***/ },
            /***/ "react": /*!**************************************************************************************!*\
  !*** external {"commonjs":"react","commonjs2":"react","amd":"react","root":"React"} ***!
  \**************************************************************************************/ /***/ (module1)=>{
                "use strict";
                module1.exports = __WEBPACK_EXTERNAL_MODULE_react__;
            /***/ }
        };
        /************************************************************************/ /******/ // The module cache
        /******/ var __webpack_module_cache__ = {};
        /******/ /******/ // The require function
        /******/ function __webpack_require__(moduleId) {
            /******/ // Check if module is in cache
            /******/ var cachedModule = __webpack_module_cache__[moduleId];
            /******/ if (cachedModule !== undefined) /******/ return cachedModule.exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = __webpack_module_cache__[moduleId] = {
                /******/ // no module.id needed
                /******/ // no module.loaded needed
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ __webpack_modules__[moduleId].call(module1.exports, module1, module1.exports, __webpack_require__);
            /******/ /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ /************************************************************************/ /******/ /* webpack/runtime/define property getters */ /******/ (()=>{
            /******/ // define getter functions for harmony exports
            /******/ __webpack_require__.d = (exports, definition)=>{
                /******/ for(var key in definition)/******/ if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) /******/ Object.defineProperty(exports, key, {
                    enumerable: true,
                    get: definition[key]
                });
            /******/ };
        /******/ })();
        /******/ /******/ /* webpack/runtime/hasOwnProperty shorthand */ /******/ (()=>{
            /******/ __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
        /******/ })();
        /******/ /******/ /* webpack/runtime/make namespace object */ /******/ (()=>{
            /******/ // define __esModule on exports
            /******/ __webpack_require__.r = (exports)=>{
                /******/ if (typeof Symbol !== "undefined" && Symbol.toStringTag) /******/ Object.defineProperty(exports, Symbol.toStringTag, {
                    value: "Module"
                });
                /******/ Object.defineProperty(exports, "__esModule", {
                    value: true
                });
            /******/ };
        /******/ })();
        /******/ /************************************************************************/ /******/ /******/ // startup
        /******/ // Load entry module and return exports
        /******/ // This entry module is referenced by other modules so it can't be inlined
        /******/ var __webpack_exports__ = __webpack_require__("./src/index.ts");
        /******/ /******/ return __webpack_exports__;
    /******/ })();
});




const $9f66bc724b88f519$export$55ad5c77306bdcab = (lat1, lon1, lat2, lon2)=>{
    let R = 6371;
    let dLat = $9f66bc724b88f519$var$deg2rad(lat2 - lat1);
    let dLon = $9f66bc724b88f519$var$deg2rad(lon2 - lon1);
    let a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos($9f66bc724b88f519$var$deg2rad(lat1)) * Math.cos($9f66bc724b88f519$var$deg2rad(lat2)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
    let c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    let d = R * c;
    return d;
};
const $9f66bc724b88f519$var$deg2rad = (deg)=>{
    return deg * (Math.PI / 180);
};
const $9f66bc724b88f519$export$be63e0664592e141 = (user)=>{
    if (user.displayName !== null) return user.displayName;
    const providerWithName = user.providerData.find((provider)=>provider.displayName != null);
    return (providerWithName === null || providerWithName === void 0 ? void 0 : providerWithName.displayName) || "";
};


const $5e76e72696cf68eb$export$6cb588e60034a5f2 = [
    {
        name: "Meeting Room",
        className: "bg-purple-200",
        popoverTitle: "Meeting Room: Your own meeting room or event space in a coworking space.",
        popoverDescription: "Get hours of focus with clients or have an offsite meeting with your team in a staffed coworking space environment.",
        popoverList: [
            "Ideal for 2-20 person (starts 50 sq. ft.)",
            "Secure conference- or classroom-style",
            "Per-Hour, No Commitment Room Booking",
            "Basic Amenities: Wifi, Coffee/Tea, Kitchen Appliances (Microwave, Fridge), Washrooms, Cleaning",
            "By Request: Office Supplies, White Board, A/V Equipment, TV, Catering, Extended Hours"
        ]
    },
    {
        name: "Private Office",
        className: "bg-blue-200",
        popoverTitle: "Private Office: Your own flex office in a coworking space.",
        popoverDescription: "Experience privacy with the team with your own office room in a staffed coworking space environment.",
        popoverList: [
            "Ideal for 2-10 people (starts 150 sq. ft.) ",
            "Secure, private podcast- or standard-style offices",
            "Per-Day, No Lease Office Booking",
            "Basic Amenities: Wifi, Coffee/Tea, Kitchen Appliances (Microwave, Fridge), Washrooms, Cleaning",
            "By Request: Office Supplies, White Board, A/V Equipment, TV, Catering, Extended Hours"
        ]
    },
    {
        name: "Flexday Suite",
        className: "bg-red-200",
        popoverTitle: "Flexday Suite: Your own flex office for a day (or three).",
        popoverDescription: "Vibe with your whole company in your own fully-equipped, private office suite with multiple space configurations.",
        popoverList: [
            "Ideal for 5-50 people (starts 700 sq. ft.)",
            "Secure, private podcast-style or full team office suites w/ sub-rooms and spaces",
            "Per-Day to Short-Term, No Lease Office Booking",
            "Basic Amenities: Wifi, Coffee/Tea, Kitchen Appliances (Microwave, Fridge), Washrooms, Cleaning",
            "By Request: Office Supplies, White Board, A/V Equipment, TV, Catering, Extended Hours"
        ]
    }
];
const $5e76e72696cf68eb$export$cbf506743859cf23 = {
    MeetingRoom: "Meeting Room",
    PrivateOffice: "Private Office",
    FlexdaySuite: "Flexday Suite"
};




var $b6HlZ = parcelRequire("b6HlZ");


var $b6HlZ = parcelRequire("b6HlZ");

var $3uMgk = parcelRequire("3uMgk");
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $de370fea0b9a0328$var$extendStatics = function(d, b) {
    $de370fea0b9a0328$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $de370fea0b9a0328$var$extendStatics(d, b);
};
function $de370fea0b9a0328$var$__extends(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $de370fea0b9a0328$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $de370fea0b9a0328$var$__assign = function() {
    $de370fea0b9a0328$var$__assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $de370fea0b9a0328$var$__assign.apply(this, arguments);
};
function $de370fea0b9a0328$var$__rest$1(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $de370fea0b9a0328$var$__awaiter$1(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $de370fea0b9a0328$var$__generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $de370fea0b9a0328$var$getDefaultExportFromCjs(x) {
    return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
}
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */ var $de370fea0b9a0328$var$NODE_ENV = "production";
var $de370fea0b9a0328$var$invariant = function(condition, format, a, b, c, d, e, f) {
    if ($de370fea0b9a0328$var$NODE_ENV !== "production") {
        if (format === undefined) throw new Error("invariant requires an error message argument");
    }
    if (!condition) {
        var error;
        if (format === undefined) error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        else {
            var args = [
                a,
                b,
                c,
                d,
                e,
                f
            ];
            var argIndex = 0;
            error = new Error(format.replace(/%s/g, function() {
                return args[argIndex++];
            }));
            error.name = "Invariant Violation";
        }
        error.framesToPop = 1; // we don't care about invariant's own frame
        throw error;
    }
};
var $de370fea0b9a0328$var$invariant_1 = $de370fea0b9a0328$var$invariant;
var $de370fea0b9a0328$var$invariant$1 = /*@__PURE__*/ $de370fea0b9a0328$var$getDefaultExportFromCjs($de370fea0b9a0328$var$invariant_1);
var $de370fea0b9a0328$export$dc7344301ae78f85 = (0, $b6HlZ.createContext)(null);
function $de370fea0b9a0328$export$7105827ad5b8fcc3() {
    $de370fea0b9a0328$var$invariant$1(!!(0, $b6HlZ.useContext), "useGoogleMap is React hook and requires React version 16.8+");
    var map = (0, $b6HlZ.useContext)($de370fea0b9a0328$export$dc7344301ae78f85);
    $de370fea0b9a0328$var$invariant$1(!!map, "useGoogleMap needs a GoogleMap available up in the tree");
    return map;
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $de370fea0b9a0328$var$reduce(obj, fn, acc) {
    return Object.keys(obj).reduce(function reducer(newAcc, key) {
        return fn(newAcc, obj[key], key);
    }, acc);
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $de370fea0b9a0328$var$forEach(obj, fn) {
    Object.keys(obj).forEach(function(key) {
        return fn(obj[key], key);
    });
}
/* global google */ function $de370fea0b9a0328$var$applyUpdaterToNextProps(// eslint-disable-next-line @typescript-eslint/no-explicit-any
updaterMap, // eslint-disable-next-line @typescript-eslint/no-explicit-any
prevProps, // eslint-disable-next-line @typescript-eslint/no-explicit-any
nextProps, // eslint-disable-next-line @typescript-eslint/no-explicit-any
instance) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var map = {};
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var iter = function(fn, key) {
        var nextValue = nextProps[key];
        if (nextValue !== prevProps[key]) {
            map[key] = nextValue;
            fn(instance, nextValue);
        }
    };
    $de370fea0b9a0328$var$forEach(updaterMap, iter);
    return map;
}
function $de370fea0b9a0328$var$registerEvents(// eslint-disable-next-line @typescript-eslint/no-explicit-any
props, // eslint-disable-next-line @typescript-eslint/no-explicit-any
instance, eventMap) {
    var registeredList = $de370fea0b9a0328$var$reduce(eventMap, function reducer(acc, googleEventName, // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onEventName) {
        if (typeof props[onEventName] === "function") acc.push(google.maps.event.addListener(instance, googleEventName, props[onEventName]));
        return acc;
    }, []);
    return registeredList;
}
function $de370fea0b9a0328$var$unregisterEvent(registered) {
    google.maps.event.removeListener(registered);
}
function $de370fea0b9a0328$var$unregisterEvents(events) {
    if (events === void 0) events = [];
    events.forEach($de370fea0b9a0328$var$unregisterEvent);
}
function $de370fea0b9a0328$var$applyUpdatersToPropsAndRegisterEvents(_a) {
    var updaterMap = _a.updaterMap, eventMap = _a.eventMap, prevProps = _a.prevProps, nextProps = _a.nextProps, instance = _a.instance;
    var registeredEvents = $de370fea0b9a0328$var$registerEvents(nextProps, instance, eventMap);
    $de370fea0b9a0328$var$applyUpdaterToNextProps(updaterMap, prevProps, nextProps, instance);
    return registeredEvents;
}
var $de370fea0b9a0328$var$eventMap$i = {
    onDblClick: "dblclick",
    onDragEnd: "dragend",
    onDragStart: "dragstart",
    onMapTypeIdChanged: "maptypeid_changed",
    onMouseMove: "mousemove",
    onMouseOut: "mouseout",
    onMouseOver: "mouseover",
    onMouseDown: "mousedown",
    onMouseUp: "mouseup",
    onRightClick: "rightclick",
    onTilesLoaded: "tilesloaded",
    onBoundsChanged: "bounds_changed",
    onCenterChanged: "center_changed",
    onClick: "click",
    onDrag: "drag",
    onHeadingChanged: "heading_changed",
    onIdle: "idle",
    onProjectionChanged: "projection_changed",
    onResize: "resize",
    onTiltChanged: "tilt_changed",
    onZoomChanged: "zoom_changed"
};
var $de370fea0b9a0328$var$updaterMap$i = {
    extraMapTypes: function(map, extra) {
        extra.forEach(function forEachExtra(it, i) {
            map.mapTypes.set(String(i), it);
        });
    },
    center: function(map, center) {
        map.setCenter(center);
    },
    clickableIcons: function(map, clickable) {
        map.setClickableIcons(clickable);
    },
    heading: function(map, heading) {
        map.setHeading(heading);
    },
    mapTypeId: function(map, mapTypeId) {
        map.setMapTypeId(mapTypeId);
    },
    options: function(map, options) {
        map.setOptions(options);
    },
    streetView: function(map, streetView) {
        map.setStreetView(streetView);
    },
    tilt: function(map, tilt) {
        map.setTilt(tilt);
    },
    zoom: function(map, zoom) {
        map.setZoom(zoom);
    }
};
// TODO: unfinished!
function $de370fea0b9a0328$var$GoogleMapFunctional(_a) {
    var children = _a.children, options = _a.options, id = _a.id, mapContainerStyle = _a.mapContainerStyle, mapContainerClassName = _a.mapContainerClassName, center = _a.center, // clickableIcons,
    // extraMapTypes,
    // heading,
    // mapTypeId,
    onClick = _a.onClick, onDblClick = _a.onDblClick, onDrag = _a.onDrag, onDragEnd = _a.onDragEnd, onDragStart = _a.onDragStart, onMouseMove = _a.onMouseMove, onMouseOut = _a.onMouseOut, onMouseOver = _a.onMouseOver, onMouseDown = _a.onMouseDown, onMouseUp = _a.onMouseUp, onRightClick = _a.onRightClick, // onMapTypeIdChanged,
    // onTilesLoaded,
    // onBoundsChanged,
    onCenterChanged = _a.onCenterChanged, // onHeadingChanged,
    // onIdle,
    // onProjectionChanged,
    // onResize,
    // onTiltChanged,
    // onZoomChanged,
    onLoad = _a.onLoad, onUnmount = _a.onUnmount;
    var _b = (0, $b6HlZ.useState)(null), map = _b[0], setMap = _b[1];
    var ref = (0, $b6HlZ.useRef)(null);
    // const [extraMapTypesListener, setExtraMapTypesListener] = useState<google.maps.MapsEventListener | null>(null)
    var _c = (0, $b6HlZ.useState)(null), centerChangedListener = _c[0], setCenterChangedListener = _c[1];
    var _d = (0, $b6HlZ.useState)(null), dblclickListener = _d[0], setDblclickListener = _d[1];
    var _e = (0, $b6HlZ.useState)(null), dragendListener = _e[0], setDragendListener = _e[1];
    var _f = (0, $b6HlZ.useState)(null), dragstartListener = _f[0], setDragstartListener = _f[1];
    var _g = (0, $b6HlZ.useState)(null), mousedownListener = _g[0], setMousedownListener = _g[1];
    var _h = (0, $b6HlZ.useState)(null), mousemoveListener = _h[0], setMousemoveListener = _h[1];
    var _j = (0, $b6HlZ.useState)(null), mouseoutListener = _j[0], setMouseoutListener = _j[1];
    var _k = (0, $b6HlZ.useState)(null), mouseoverListener = _k[0], setMouseoverListener = _k[1];
    var _l = (0, $b6HlZ.useState)(null), mouseupListener = _l[0], setMouseupListener = _l[1];
    var _m = (0, $b6HlZ.useState)(null), rightclickListener = _m[0], setRightclickListener = _m[1];
    var _o = (0, $b6HlZ.useState)(null), clickListener = _o[0], setClickListener = _o[1];
    var _p = (0, $b6HlZ.useState)(null), dragListener = _p[0], setDragListener = _p[1];
    // Order does matter
    (0, $b6HlZ.useEffect)(function() {
        if (options && map !== null) map.setOptions(options);
    }, [
        map,
        options
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (map !== null && typeof center !== "undefined") map.setCenter(center);
    }, [
        map,
        center
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (map && onDblClick) {
            if (dblclickListener !== null) google.maps.event.removeListener(dblclickListener);
            setDblclickListener(google.maps.event.addListener(map, "dblclick", onDblClick));
        }
    }, [
        onDblClick
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (map && onDragEnd) {
            if (dragendListener !== null) google.maps.event.removeListener(dragendListener);
            setDragendListener(google.maps.event.addListener(map, "dragend", onDragEnd));
        }
    }, [
        onDragEnd
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (map && onDragStart) {
            if (dragstartListener !== null) google.maps.event.removeListener(dragstartListener);
            setDragstartListener(google.maps.event.addListener(map, "dragstart", onDragStart));
        }
    }, [
        onDragStart
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (map && onMouseDown) {
            if (mousedownListener !== null) google.maps.event.removeListener(mousedownListener);
            setMousedownListener(google.maps.event.addListener(map, "mousedown", onMouseDown));
        }
    }, [
        onMouseDown
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (map && onMouseMove) {
            if (mousemoveListener !== null) google.maps.event.removeListener(mousemoveListener);
            setMousemoveListener(google.maps.event.addListener(map, "mousemove", onMouseMove));
        }
    }, [
        onMouseMove
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (map && onMouseOut) {
            if (mouseoutListener !== null) google.maps.event.removeListener(mouseoutListener);
            setMouseoutListener(google.maps.event.addListener(map, "mouseout", onMouseOut));
        }
    }, [
        onMouseOut
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (map && onMouseOver) {
            if (mouseoverListener !== null) google.maps.event.removeListener(mouseoverListener);
            setMouseoverListener(google.maps.event.addListener(map, "mouseover", onMouseOver));
        }
    }, [
        onMouseOver
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (map && onMouseUp) {
            if (mouseupListener !== null) google.maps.event.removeListener(mouseupListener);
            setMouseupListener(google.maps.event.addListener(map, "mouseup", onMouseUp));
        }
    }, [
        onMouseUp
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (map && onRightClick) {
            if (rightclickListener !== null) google.maps.event.removeListener(rightclickListener);
            setRightclickListener(google.maps.event.addListener(map, "rightclick", onRightClick));
        }
    }, [
        onRightClick
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (map && onClick) {
            if (clickListener !== null) google.maps.event.removeListener(clickListener);
            setClickListener(google.maps.event.addListener(map, "click", onClick));
        }
    }, [
        onClick
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (map && onDrag) {
            if (dragListener !== null) google.maps.event.removeListener(dragListener);
            setDragListener(google.maps.event.addListener(map, "drag", onDrag));
        }
    }, [
        onDrag
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (map && onCenterChanged) {
            if (centerChangedListener !== null) google.maps.event.removeListener(centerChangedListener);
            setCenterChangedListener(google.maps.event.addListener(map, "center_changed", onCenterChanged));
        }
    }, [
        onClick
    ]);
    (0, $b6HlZ.useEffect)(function() {
        var map = ref.current === null ? null : new google.maps.Map(ref.current, options);
        setMap(map);
        if (map !== null && onLoad) onLoad(map);
        return function() {
            if (map !== null) {
                if (onUnmount) onUnmount(map);
            }
        };
    }, []);
    return (0, $94829a8b99aa12e4$exports.jsx)("div", {
        id: id,
        ref: ref,
        style: mapContainerStyle,
        className: mapContainerClassName,
        children: (0, $94829a8b99aa12e4$exports.jsx)($de370fea0b9a0328$export$dc7344301ae78f85.Provider, {
            value: map,
            children: map !== null ? children : (0, $94829a8b99aa12e4$exports.jsx)((0, $94829a8b99aa12e4$exports.Fragment), {})
        })
    });
}
(0, $b6HlZ.memo)($de370fea0b9a0328$var$GoogleMapFunctional);
var $de370fea0b9a0328$export$4ad1bae46276c5ce = /** @class */ function(_super) {
    $de370fea0b9a0328$var$__extends(GoogleMap, _super);
    function GoogleMap() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            map: null
        };
        _this.registeredEvents = [];
        _this.mapRef = null;
        _this.getInstance = function() {
            if (_this.mapRef === null) return null;
            return new google.maps.Map(_this.mapRef, _this.props.options);
        };
        _this.panTo = function(latLng) {
            var map = _this.getInstance();
            if (map) map.panTo(latLng);
        };
        _this.setMapCallback = function() {
            if (_this.state.map !== null) {
                if (_this.props.onLoad) _this.props.onLoad(_this.state.map);
            }
        };
        _this.getRef = function(ref) {
            _this.mapRef = ref;
        };
        return _this;
    }
    GoogleMap.prototype.componentDidMount = function() {
        var map = this.getInstance();
        this.registeredEvents = $de370fea0b9a0328$var$applyUpdatersToPropsAndRegisterEvents({
            updaterMap: $de370fea0b9a0328$var$updaterMap$i,
            eventMap: $de370fea0b9a0328$var$eventMap$i,
            prevProps: {},
            nextProps: this.props,
            instance: map
        });
        this.setState(function setMap() {
            return {
                map: map
            };
        }, this.setMapCallback);
    };
    GoogleMap.prototype.componentDidUpdate = function(prevProps) {
        if (this.state.map !== null) {
            $de370fea0b9a0328$var$unregisterEvents(this.registeredEvents);
            this.registeredEvents = $de370fea0b9a0328$var$applyUpdatersToPropsAndRegisterEvents({
                updaterMap: $de370fea0b9a0328$var$updaterMap$i,
                eventMap: $de370fea0b9a0328$var$eventMap$i,
                prevProps: prevProps,
                nextProps: this.props,
                instance: this.state.map
            });
        }
    };
    GoogleMap.prototype.componentWillUnmount = function() {
        if (this.state.map !== null) {
            if (this.props.onUnmount) this.props.onUnmount(this.state.map);
            $de370fea0b9a0328$var$unregisterEvents(this.registeredEvents);
        }
    };
    GoogleMap.prototype.render = function() {
        return (0, $94829a8b99aa12e4$exports.jsx)("div", {
            id: this.props.id,
            ref: this.getRef,
            style: this.props.mapContainerStyle,
            className: this.props.mapContainerClassName,
            children: (0, $94829a8b99aa12e4$exports.jsx)($de370fea0b9a0328$export$dc7344301ae78f85.Provider, {
                value: this.state.map,
                children: this.state.map !== null ? this.props.children : (0, $94829a8b99aa12e4$exports.jsx)((0, $94829a8b99aa12e4$exports.Fragment), {})
            })
        });
    };
    return GoogleMap;
}((0, $b6HlZ.PureComponent));
var $de370fea0b9a0328$var$isBrowser = typeof document !== "undefined";
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $de370fea0b9a0328$var$injectScript(_a) {
    var url = _a.url, id = _a.id, nonce = _a.nonce;
    if (!$de370fea0b9a0328$var$isBrowser) return Promise.reject(new Error("document is undefined"));
    return new Promise(function injectScriptCallback(resolve, reject) {
        var existingScript = document.getElementById(id);
        var windowWithGoogleMap = window;
        if (existingScript) {
            // Same script id/url: keep same script
            var dataStateAttribute = existingScript.getAttribute("data-state");
            if (existingScript.src === url && dataStateAttribute !== "error") {
                if (dataStateAttribute === "ready") return resolve(id);
                else {
                    var originalInitMap_1 = windowWithGoogleMap.initMap;
                    var originalErrorCallback_1 = existingScript.onerror;
                    windowWithGoogleMap.initMap = function initMap() {
                        if (originalInitMap_1) originalInitMap_1();
                        resolve(id);
                    };
                    existingScript.onerror = function(err) {
                        if (originalErrorCallback_1) originalErrorCallback_1(err);
                        reject(err);
                    };
                    return;
                }
            } else existingScript.remove();
        }
        var script = document.createElement("script");
        script.type = "text/javascript";
        script.src = url;
        script.id = id;
        script.async = true;
        script.nonce = nonce || "";
        script.onerror = function onerror(err) {
            script.setAttribute("data-state", "error");
            reject(err);
        };
        windowWithGoogleMap.initMap = function onload() {
            script.setAttribute("data-state", "ready");
            resolve(id);
        };
        document.head.appendChild(script);
    }).catch(function(err) {
        console.error("injectScript error: ", err);
        throw err;
    });
}
function $de370fea0b9a0328$var$isGoogleFontStyle(element) {
    // 'Roboto' or 'Google Sans Text' font download
    var href = element.href;
    if (href && (href.indexOf("https://fonts.googleapis.com/css?family=Roboto") === 0 || href.indexOf("https://fonts.googleapis.com/css?family=Google+Sans+Text") === 0)) return true;
    // font style elements
    if (// eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    element.tagName.toLowerCase() === "style" && // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    element.styleSheet && // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    element.styleSheet.cssText && // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    element.styleSheet.cssText.replace("\r\n", "").indexOf(".gm-style") === 0) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        element.styleSheet.cssText = "";
        return true;
    }
    // font style elements for other browsers
    if (// eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    element.tagName.toLowerCase() === "style" && // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    element.innerHTML && // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    element.innerHTML.replace("\r\n", "").indexOf(".gm-style") === 0) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        element.innerHTML = "";
        return true;
    }
    // when google tries to add empty style
    if (// eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    element.tagName.toLowerCase() === "style" && // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    !element.styleSheet && // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    !element.innerHTML) return true;
    return false;
}
// Preventing the Google Maps library from downloading an extra font
function $de370fea0b9a0328$var$preventGoogleFonts() {
    // we override these methods only for one particular head element
    // default methods for other elements are not affected
    var head = document.getElementsByTagName("head")[0];
    if (head) {
        var trueInsertBefore_1 = head.insertBefore.bind(head);
        // TODO: adding return before reflect solves the TS issue
        head.insertBefore = function insertBefore(newElement, referenceElement) {
            if (!$de370fea0b9a0328$var$isGoogleFontStyle(newElement)) Reflect.apply(trueInsertBefore_1, head, [
                newElement,
                referenceElement
            ]);
            return newElement;
        };
        var trueAppend_1 = head.appendChild.bind(head);
        // TODO: adding return before reflect solves the TS issue
        head.appendChild = function appendChild(textNode) {
            if (!$de370fea0b9a0328$var$isGoogleFontStyle(textNode)) Reflect.apply(trueAppend_1, head, [
                textNode
            ]);
            return textNode;
        };
    }
}
function $de370fea0b9a0328$var$makeLoadScriptUrl(_a) {
    var googleMapsApiKey = _a.googleMapsApiKey, googleMapsClientId = _a.googleMapsClientId, _b = _a.version, version = _b === void 0 ? "weekly" : _b, language = _a.language, region = _a.region, libraries = _a.libraries, channel = _a.channel, mapIds = _a.mapIds, authReferrerPolicy = _a.authReferrerPolicy;
    var params = [];
    $de370fea0b9a0328$var$invariant$1(googleMapsApiKey && googleMapsClientId || !(googleMapsApiKey && googleMapsClientId), "You need to specify either googleMapsApiKey or googleMapsClientId for @react-google-maps/api load script to work. You cannot use both at the same time.");
    if (googleMapsApiKey) params.push("key=".concat(googleMapsApiKey));
    else if (googleMapsClientId) params.push("client=".concat(googleMapsClientId));
    if (version) params.push("v=".concat(version));
    if (language) params.push("language=".concat(language));
    if (region) params.push("region=".concat(region));
    if (libraries && libraries.length) params.push("libraries=".concat(libraries.sort().join(",")));
    if (channel) params.push("channel=".concat(channel));
    if (mapIds && mapIds.length) params.push("map_ids=".concat(mapIds.join(",")));
    if (authReferrerPolicy) params.push("auth_referrer_policy=".concat(authReferrerPolicy));
    params.push("callback=initMap");
    return "https://maps.googleapis.com/maps/api/js?".concat(params.join("&"));
}
var $de370fea0b9a0328$var$cleaningUp = false;
function $de370fea0b9a0328$var$DefaultLoadingElement() {
    return (0, $94829a8b99aa12e4$exports.jsx)("div", {
        children: "Loading..."
    });
}
var $de370fea0b9a0328$var$defaultLoadScriptProps = {
    id: "script-loader",
    version: "weekly"
};
var $de370fea0b9a0328$export$cd712c6fb2ecba2b = /** @class */ function(_super) {
    $de370fea0b9a0328$var$__extends(LoadScript, _super);
    function LoadScript() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.check = (0, $b6HlZ.createRef)();
        _this.state = {
            loaded: false
        };
        _this.cleanupCallback = function() {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            delete window.google.maps;
            _this.injectScript();
        };
        _this.isCleaningUp = function() {
            return $de370fea0b9a0328$var$__awaiter$1(_this, void 0, void 0, function() {
                function promiseCallback(resolve) {
                    if (!$de370fea0b9a0328$var$cleaningUp) resolve();
                    else if ($de370fea0b9a0328$var$isBrowser) var timer_1 = window.setInterval(function interval() {
                        if (!$de370fea0b9a0328$var$cleaningUp) {
                            window.clearInterval(timer_1);
                            resolve();
                        }
                    }, 1);
                    return;
                }
                return $de370fea0b9a0328$var$__generator(this, function(_a) {
                    return [
                        2 /*return*/ ,
                        new Promise(promiseCallback)
                    ];
                });
            });
        };
        _this.cleanup = function() {
            $de370fea0b9a0328$var$cleaningUp = true;
            var script = document.getElementById(_this.props.id);
            if (script && script.parentNode) script.parentNode.removeChild(script);
            Array.prototype.slice.call(document.getElementsByTagName("script")).filter(function filter(script) {
                return typeof script.src === "string" && script.src.includes("maps.googleapis");
            }).forEach(function forEach(script) {
                if (script.parentNode) script.parentNode.removeChild(script);
            });
            Array.prototype.slice.call(document.getElementsByTagName("link")).filter(function filter(link) {
                return link.href === "https://fonts.googleapis.com/css?family=Roboto:300,400,500,700|Google+Sans";
            }).forEach(function forEach(link) {
                if (link.parentNode) link.parentNode.removeChild(link);
            });
            Array.prototype.slice.call(document.getElementsByTagName("style")).filter(function filter(style) {
                return style.innerText !== undefined && style.innerText.length > 0 && style.innerText.includes(".gm-");
            }).forEach(function forEach(style) {
                if (style.parentNode) style.parentNode.removeChild(style);
            });
        };
        _this.injectScript = function() {
            if (_this.props.preventGoogleFontsLoading) $de370fea0b9a0328$var$preventGoogleFonts();
            $de370fea0b9a0328$var$invariant$1(!!_this.props.id, 'LoadScript requires "id" prop to be a string: %s', _this.props.id);
            var injectScriptOptions = {
                id: _this.props.id,
                nonce: _this.props.nonce,
                url: $de370fea0b9a0328$var$makeLoadScriptUrl(_this.props)
            };
            $de370fea0b9a0328$var$injectScript(injectScriptOptions).then(function() {
                if (_this.props.onLoad) _this.props.onLoad();
                _this.setState(function setLoaded() {
                    return {
                        loaded: true
                    };
                });
                return;
            }).catch(function(err) {
                if (_this.props.onError) _this.props.onError(err);
                console.error("\n          There has been an Error with loading Google Maps API script, please check that you provided correct google API key (".concat(_this.props.googleMapsApiKey || "-", ") or Client ID (").concat(_this.props.googleMapsClientId || "-", ") to <LoadScript />\n          Otherwise it is a Network issue.\n        "));
            });
        };
        return _this;
    }
    LoadScript.prototype.componentDidMount = function() {
        if ($de370fea0b9a0328$var$isBrowser) {
            if (window.google && window.google.maps && !$de370fea0b9a0328$var$cleaningUp) {
                console.error("google api is already presented");
                return;
            }
            this.isCleaningUp().then(this.injectScript).catch(function error(err) {
                console.error("Error at injecting script after cleaning up: ", err);
            });
        }
    };
    LoadScript.prototype.componentDidUpdate = function(prevProps) {
        if (this.props.libraries !== prevProps.libraries) console.warn("Performance warning! LoadScript has been reloaded unintentionally! You should not pass `libraries` prop as new array. Please keep an array of libraries as static class property for Components and PureComponents, or just a const variable outside of component, or somewhere in config files or ENV variables");
        if ($de370fea0b9a0328$var$isBrowser && prevProps.language !== this.props.language) {
            this.cleanup();
            // TODO: refactor to use gDSFP maybe... wait for hooks refactoring.
            this.setState(function setLoaded() {
                return {
                    loaded: false
                };
            }, this.cleanupCallback);
        }
    };
    LoadScript.prototype.componentWillUnmount = function() {
        var _this = this;
        if ($de370fea0b9a0328$var$isBrowser) {
            this.cleanup();
            var timeoutCallback = function() {
                if (!_this.check.current) {
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    delete window.google;
                    $de370fea0b9a0328$var$cleaningUp = false;
                }
            };
            window.setTimeout(timeoutCallback, 1);
            if (this.props.onUnmount) this.props.onUnmount();
        }
    };
    LoadScript.prototype.render = function() {
        return (0, $94829a8b99aa12e4$exports.jsxs)((0, $94829a8b99aa12e4$exports.Fragment), {
            children: [
                (0, $94829a8b99aa12e4$exports.jsx)("div", {
                    ref: this.check
                }),
                this.state.loaded ? this.props.children : this.props.loadingElement || (0, $94829a8b99aa12e4$exports.jsx)($de370fea0b9a0328$var$DefaultLoadingElement, {})
            ]
        });
    };
    LoadScript.defaultProps = $de370fea0b9a0328$var$defaultLoadScriptProps;
    return LoadScript;
}((0, $b6HlZ.PureComponent));
/* eslint-disable filenames/match-regex */ var $de370fea0b9a0328$var$previouslyLoadedUrl;
function $de370fea0b9a0328$export$4a4360ced6c2c728(_a) {
    var _b = _a.id, id = _b === void 0 ? $de370fea0b9a0328$var$defaultLoadScriptProps.id : _b, _c = _a.version, version = _c === void 0 ? $de370fea0b9a0328$var$defaultLoadScriptProps.version : _c, nonce = _a.nonce, googleMapsApiKey = _a.googleMapsApiKey, googleMapsClientId = _a.googleMapsClientId, language = _a.language, region = _a.region, libraries = _a.libraries, preventGoogleFontsLoading = _a.preventGoogleFontsLoading, channel = _a.channel, mapIds = _a.mapIds, authReferrerPolicy = _a.authReferrerPolicy;
    var isMounted = (0, $b6HlZ.useRef)(false);
    var _d = (0, $b6HlZ.useState)(false), isLoaded = _d[0], setLoaded = _d[1];
    var _e = (0, $b6HlZ.useState)(undefined), loadError = _e[0], setLoadError = _e[1];
    (0, $b6HlZ.useEffect)(function trackMountedState() {
        isMounted.current = true;
        return function() {
            isMounted.current = false;
        };
    }, []);
    (0, $b6HlZ.useEffect)(function applyPreventGoogleFonts() {
        if ($de370fea0b9a0328$var$isBrowser && preventGoogleFontsLoading) $de370fea0b9a0328$var$preventGoogleFonts();
    }, [
        preventGoogleFontsLoading
    ]);
    (0, $b6HlZ.useEffect)(function validateLoadedState() {
        if (isLoaded) $de370fea0b9a0328$var$invariant$1(!!window.google, "useLoadScript was marked as loaded, but window.google is not present. Something went wrong.");
    }, [
        isLoaded
    ]);
    var url = $de370fea0b9a0328$var$makeLoadScriptUrl({
        version: version,
        googleMapsApiKey: googleMapsApiKey,
        googleMapsClientId: googleMapsClientId,
        language: language,
        region: region,
        libraries: libraries,
        channel: channel,
        mapIds: mapIds,
        authReferrerPolicy: authReferrerPolicy
    });
    (0, $b6HlZ.useEffect)(function loadScriptAndModifyLoadedState() {
        if (!$de370fea0b9a0328$var$isBrowser) return;
        function setLoadedIfMounted() {
            if (isMounted.current) {
                setLoaded(true);
                $de370fea0b9a0328$var$previouslyLoadedUrl = url;
            }
        }
        if (window.google && window.google.maps && $de370fea0b9a0328$var$previouslyLoadedUrl === url) {
            setLoadedIfMounted();
            return;
        }
        $de370fea0b9a0328$var$injectScript({
            id: id,
            url: url,
            nonce: nonce
        }).then(setLoadedIfMounted).catch(function handleInjectError(err) {
            if (isMounted.current) setLoadError(err);
            console.warn("\n        There has been an Error with loading Google Maps API script, please check that you provided correct google API key (".concat(googleMapsApiKey || "-", ") or Client ID (").concat(googleMapsClientId || "-", ")\n        Otherwise it is a Network issue.\n      "));
            console.error(err);
        });
    }, [
        id,
        url,
        nonce
    ]);
    var prevLibraries = (0, $b6HlZ.useRef)();
    (0, $b6HlZ.useEffect)(function checkPerformance() {
        if (prevLibraries.current && libraries !== prevLibraries.current) console.warn("Performance warning! LoadScript has been reloaded unintentionally! You should not pass `libraries` prop as new array. Please keep an array of libraries as static class property for Components and PureComponents, or just a const variable outside of component, or somewhere in config files or ENV variables");
        prevLibraries.current = libraries;
    }, [
        libraries
    ]);
    return {
        isLoaded: isLoaded,
        loadError: loadError,
        url: url
    };
}
var $de370fea0b9a0328$var$defaultLoadingElement = (0, $94829a8b99aa12e4$exports.jsx)($de370fea0b9a0328$var$DefaultLoadingElement, {});
function $de370fea0b9a0328$var$LoadScriptNext(_a) {
    var loadingElement = _a.loadingElement, onLoad = _a.onLoad, onError = _a.onError, onUnmount = _a.onUnmount, children = _a.children, hookOptions = $de370fea0b9a0328$var$__rest$1(_a, [
        "loadingElement",
        "onLoad",
        "onError",
        "onUnmount",
        "children"
    ]);
    var _b = $de370fea0b9a0328$export$4a4360ced6c2c728(hookOptions), isLoaded = _b.isLoaded, loadError = _b.loadError;
    (0, $b6HlZ.useEffect)(function handleOnLoad() {
        if (isLoaded && typeof onLoad === "function") onLoad();
    }, [
        isLoaded,
        onLoad
    ]);
    (0, $b6HlZ.useEffect)(function handleOnError() {
        if (loadError && typeof onError === "function") onError(loadError);
    }, [
        loadError,
        onError
    ]);
    (0, $b6HlZ.useEffect)(function handleOnUnmount() {
        return function() {
            if (onUnmount) onUnmount();
        };
    }, [
        onUnmount
    ]);
    return isLoaded ? children : loadingElement || $de370fea0b9a0328$var$defaultLoadingElement;
}
var $de370fea0b9a0328$export$1c36d3a2ee49585b = (0, $b6HlZ.memo)($de370fea0b9a0328$var$LoadScriptNext);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function $de370fea0b9a0328$var$__awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
// do not edit .js files directly - edit src/index.jst
var $de370fea0b9a0328$var$fastDeepEqual$1 = function equal(a, b) {
    if (a === b) return true;
    if (a && b && typeof a == "object" && typeof b == "object") {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        for(i = length; i-- !== 0;){
            var key = keys[i];
            if (!equal(a[key], b[key])) return false;
        }
        return true;
    }
    // true if both NaN, false otherwise
    return a !== a && b !== b;
};
/**
 * Copyright 2019 Google LLC. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at.
 *
 *      Http://www.apache.org/licenses/LICENSE-2.0.
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $de370fea0b9a0328$var$DEFAULT_ID = "__googleMapsScriptId";
/**
 * The status of the [[Loader]].
 */ var $de370fea0b9a0328$var$LoaderStatus;
(function(LoaderStatus) {
    LoaderStatus[LoaderStatus["INITIALIZED"] = 0] = "INITIALIZED";
    LoaderStatus[LoaderStatus["LOADING"] = 1] = "LOADING";
    LoaderStatus[LoaderStatus["SUCCESS"] = 2] = "SUCCESS";
    LoaderStatus[LoaderStatus["FAILURE"] = 3] = "FAILURE";
})($de370fea0b9a0328$var$LoaderStatus || ($de370fea0b9a0328$var$LoaderStatus = {}));
/**
 * [[Loader]] makes it easier to add Google Maps JavaScript API to your application
 * dynamically using
 * [Promises](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise).
 * It works by dynamically creating and appending a script node to the the
 * document head and wrapping the callback function so as to return a promise.
 *
 * ```
 * const loader = new Loader({
 *   apiKey: "",
 *   version: "weekly",
 *   libraries: ["places"]
 * });
 *
 * loader.load().then((google) => {
 *   const map = new google.maps.Map(...)
 * })
 * ```
 */ class $de370fea0b9a0328$var$Loader {
    get options() {
        return {
            version: this.version,
            apiKey: this.apiKey,
            channel: this.channel,
            client: this.client,
            id: this.id,
            libraries: this.libraries,
            language: this.language,
            region: this.region,
            mapIds: this.mapIds,
            nonce: this.nonce,
            url: this.url,
            authReferrerPolicy: this.authReferrerPolicy
        };
    }
    get status() {
        if (this.errors.length) return $de370fea0b9a0328$var$LoaderStatus.FAILURE;
        if (this.done) return $de370fea0b9a0328$var$LoaderStatus.SUCCESS;
        if (this.loading) return $de370fea0b9a0328$var$LoaderStatus.LOADING;
        return $de370fea0b9a0328$var$LoaderStatus.INITIALIZED;
    }
    get failed() {
        return this.done && !this.loading && this.errors.length >= this.retries + 1;
    }
    /**
     * CreateUrl returns the Google Maps JavaScript API script url given the [[LoaderOptions]].
     *
     * @ignore
     * @deprecated
     */ createUrl() {
        let url = this.url;
        url += `?callback=__googleMapsCallback`;
        if (this.apiKey) url += `&key=${this.apiKey}`;
        if (this.channel) url += `&channel=${this.channel}`;
        if (this.client) url += `&client=${this.client}`;
        if (this.libraries.length > 0) url += `&libraries=${this.libraries.join(",")}`;
        if (this.language) url += `&language=${this.language}`;
        if (this.region) url += `&region=${this.region}`;
        if (this.version) url += `&v=${this.version}`;
        if (this.mapIds) url += `&map_ids=${this.mapIds.join(",")}`;
        if (this.authReferrerPolicy) url += `&auth_referrer_policy=${this.authReferrerPolicy}`;
        return url;
    }
    deleteScript() {
        const script = document.getElementById(this.id);
        if (script) script.remove();
    }
    /**
     * Load the Google Maps JavaScript API script and return a Promise.
     * @deprecated, use importLibrary() instead.
     */ load() {
        return this.loadPromise();
    }
    /**
     * Load the Google Maps JavaScript API script and return a Promise.
     *
     * @ignore
     * @deprecated, use importLibrary() instead.
     */ loadPromise() {
        return new Promise((resolve, reject)=>{
            this.loadCallback((err)=>{
                if (!err) resolve(window.google);
                else reject(err.error);
            });
        });
    }
    importLibrary(name) {
        this.execute();
        return google.maps.importLibrary(name);
    }
    /**
     * Load the Google Maps JavaScript API script with a callback.
     * @deprecated, use importLibrary() instead.
     */ loadCallback(fn) {
        this.callbacks.push(fn);
        this.execute();
    }
    /**
     * Set the script on document.
     */ setScript() {
        var _a, _b;
        if (document.getElementById(this.id)) {
            // TODO wrap onerror callback for cases where the script was loaded elsewhere
            this.callback();
            return;
        }
        const params = {
            key: this.apiKey,
            channel: this.channel,
            client: this.client,
            libraries: this.libraries.length && this.libraries,
            v: this.version,
            mapIds: this.mapIds,
            language: this.language,
            region: this.region,
            authReferrerPolicy: this.authReferrerPolicy
        };
        // keep the URL minimal:
        Object.keys(params).forEach(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (key)=>!params[key] && delete params[key]);
        if (!((_b = (_a = window === null || window === void 0 ? void 0 : window.google) === null || _a === void 0 ? void 0 : _a.maps) === null || _b === void 0 ? void 0 : _b.importLibrary)) // tweaked copy of https://developers.google.com/maps/documentation/javascript/load-maps-js-api#dynamic-library-import
        // which also sets the base url, the id, and the nonce
        /* eslint-disable */ ((g)=>{
            // @ts-ignore
            let h, a, k, p = "The Google Maps JavaScript API", c = "google", l = "importLibrary", q = "__ib__", m = document, b = window;
            // @ts-ignore
            b = b[c] || (b[c] = {});
            // @ts-ignore
            const d = b.maps || (b.maps = {}), r = new Set(), e = new URLSearchParams(), u = ()=>// @ts-ignore
                h || (h = new Promise((f, n)=>$de370fea0b9a0328$var$__awaiter(this, void 0, void 0, function*() {
                        var _a;
                        yield a = m.createElement("script");
                        a.id = this.id;
                        e.set("libraries", [
                            ...r
                        ] + "");
                        // @ts-ignore
                        for(k in g)e.set(k.replace(/[A-Z]/g, (t)=>"_" + t[0].toLowerCase()), g[k]);
                        e.set("callback", c + ".maps." + q);
                        a.src = this.url + `?` + e;
                        d[q] = f;
                        a.onerror = ()=>h = n(Error(p + " could not load."));
                        // @ts-ignore
                        a.nonce = this.nonce || ((_a = m.querySelector("script[nonce]")) === null || _a === void 0 ? void 0 : _a.nonce) || "";
                        m.head.append(a);
                    })));
            // @ts-ignore
            d[l] ? console.warn(p + " only loads once. Ignoring:", g) : d[l] = (f, ...n)=>r.add(f) && u().then(()=>d[l](f, ...n));
        })(params);
        // While most libraries populate the global namespace when loaded via bootstrap params,
        // this is not the case for "marker" when used with the inline bootstrap loader
        // (and maybe others in the future). So ensure there is an importLibrary for each:
        const libraryPromises = this.libraries.map((library)=>this.importLibrary(library));
        // ensure at least one library, to kick off loading...
        if (!libraryPromises.length) libraryPromises.push(this.importLibrary("core"));
        Promise.all(libraryPromises).then(()=>this.callback(), (error)=>{
            const event = new ErrorEvent("error", {
                error: error
            }); // for backwards compat
            this.loadErrorCallback(event);
        });
    }
    /**
     * Reset the loader state.
     */ reset() {
        this.deleteScript();
        this.done = false;
        this.loading = false;
        this.errors = [];
        this.onerrorEvent = null;
    }
    resetIfRetryingFailed() {
        if (this.failed) this.reset();
    }
    loadErrorCallback(e) {
        this.errors.push(e);
        if (this.errors.length <= this.retries) {
            const delay = this.errors.length * Math.pow(2, this.errors.length);
            console.error(`Failed to load Google Maps script, retrying in ${delay} ms.`);
            setTimeout(()=>{
                this.deleteScript();
                this.setScript();
            }, delay);
        } else {
            this.onerrorEvent = e;
            this.callback();
        }
    }
    callback() {
        this.done = true;
        this.loading = false;
        this.callbacks.forEach((cb)=>{
            cb(this.onerrorEvent);
        });
        this.callbacks = [];
    }
    execute() {
        this.resetIfRetryingFailed();
        if (this.done) this.callback();
        else {
            // short circuit and warn if google.maps is already loaded
            if (window.google && window.google.maps && window.google.maps.version) {
                console.warn("Google Maps already loaded outside @googlemaps/js-api-loader.This may result in undesirable behavior as options and script parameters may not match.");
                this.callback();
                return;
            }
            if (this.loading) ;
            else {
                this.loading = true;
                this.setScript();
            }
        }
    }
    /**
     * Creates an instance of Loader using [[LoaderOptions]]. No defaults are set
     * using this library, instead the defaults are set by the Google Maps
     * JavaScript API server.
     *
     * ```
     * const loader = Loader({apiKey, version: 'weekly', libraries: ['places']});
     * ```
     */ constructor({ apiKey: apiKey, authReferrerPolicy: authReferrerPolicy, channel: channel, client: client, id: id = $de370fea0b9a0328$var$DEFAULT_ID, language: language, libraries: libraries = [], mapIds: mapIds, nonce: nonce, region: region, retries: retries = 3, url: url = "https://maps.googleapis.com/maps/api/js", version: version }){
        this.callbacks = [];
        this.done = false;
        this.loading = false;
        this.errors = [];
        this.apiKey = apiKey;
        this.authReferrerPolicy = authReferrerPolicy;
        this.channel = channel;
        this.client = client;
        this.id = id || $de370fea0b9a0328$var$DEFAULT_ID; // Do not allow empty string
        this.language = language;
        this.libraries = libraries;
        this.mapIds = mapIds;
        this.nonce = nonce;
        this.region = region;
        this.retries = retries;
        this.url = url;
        this.version = version;
        if ($de370fea0b9a0328$var$Loader.instance) {
            if (!$de370fea0b9a0328$var$fastDeepEqual$1(this.options, $de370fea0b9a0328$var$Loader.instance.options)) throw new Error(`Loader must not be called again with different options. ${JSON.stringify(this.options)} !== ${JSON.stringify($de370fea0b9a0328$var$Loader.instance.options)}`);
            return $de370fea0b9a0328$var$Loader.instance;
        }
        $de370fea0b9a0328$var$Loader.instance = this;
    }
}
var $de370fea0b9a0328$var$defaultLibraries = [
    "maps"
];
function $de370fea0b9a0328$export$d444e954fd08ae7a(_a) {
    var _b = _a.id, id = _b === void 0 ? $de370fea0b9a0328$var$defaultLoadScriptProps.id : _b, _c = _a.version, version = _c === void 0 ? $de370fea0b9a0328$var$defaultLoadScriptProps.version : _c, nonce = _a.nonce, googleMapsApiKey = _a.googleMapsApiKey, // googleMapsClientId,
    language = _a.language, region = _a.region, _d = _a.libraries, libraries = _d === void 0 ? $de370fea0b9a0328$var$defaultLibraries : _d, preventGoogleFontsLoading = _a.preventGoogleFontsLoading, // channel,
    mapIds = _a.mapIds, authReferrerPolicy = _a.authReferrerPolicy;
    var isMounted = (0, $b6HlZ.useRef)(false);
    var _e = (0, $b6HlZ.useState)(false), isLoaded = _e[0], setLoaded = _e[1];
    var _f = (0, $b6HlZ.useState)(undefined), loadError = _f[0], setLoadError = _f[1];
    (0, $b6HlZ.useEffect)(function trackMountedState() {
        isMounted.current = true;
        return function() {
            isMounted.current = false;
        };
    }, []);
    var loader = (0, $b6HlZ.useMemo)(function() {
        return new $de370fea0b9a0328$var$Loader({
            id: id,
            apiKey: googleMapsApiKey,
            version: version,
            libraries: libraries,
            language: language || "en",
            region: region || "US",
            mapIds: mapIds || [],
            nonce: nonce || "",
            authReferrerPolicy: authReferrerPolicy || "origin"
        });
    }, [
        id,
        googleMapsApiKey,
        version,
        libraries,
        language,
        region,
        mapIds,
        nonce,
        authReferrerPolicy
    ]);
    (0, $b6HlZ.useEffect)(function effect() {
        if (isLoaded) return;
        else loader.load().then(function() {
            if (isMounted.current) setLoaded(true);
            return;
        }).catch(function(error) {
            setLoadError(error);
        });
    }, []);
    (0, $b6HlZ.useEffect)(function() {
        if ($de370fea0b9a0328$var$isBrowser && preventGoogleFontsLoading) $de370fea0b9a0328$var$preventGoogleFonts();
    }, [
        preventGoogleFontsLoading
    ]);
    var prevLibraries = (0, $b6HlZ.useRef)();
    (0, $b6HlZ.useEffect)(function() {
        if (prevLibraries.current && libraries !== prevLibraries.current) console.warn("Performance warning! LoadScript has been reloaded unintentionally! You should not pass `libraries` prop as new array. Please keep an array of libraries as static class property for Components and PureComponents, or just a const variable outside of component, or somewhere in config files or ENV variables");
        prevLibraries.current = libraries;
    }, [
        libraries
    ]);
    return {
        isLoaded: isLoaded,
        loadError: loadError
    };
}
var $de370fea0b9a0328$var$eventMap$h = {};
var $de370fea0b9a0328$var$updaterMap$h = {
    options: function(instance, options) {
        instance.setOptions(options);
    }
};
function $de370fea0b9a0328$var$TrafficLayerFunctional(_a) {
    var options = _a.options, onLoad = _a.onLoad, onUnmount = _a.onUnmount;
    var map = (0, $b6HlZ.useContext)($de370fea0b9a0328$export$dc7344301ae78f85);
    var _b = (0, $b6HlZ.useState)(null), instance = _b[0], setInstance = _b[1];
    // Order does matter
    (0, $b6HlZ.useEffect)(function() {
        if (instance !== null) instance.setMap(map);
    }, [
        map
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (options && instance !== null) instance.setOptions(options);
    }, [
        instance,
        options
    ]);
    (0, $b6HlZ.useEffect)(function() {
        var trafficLayer = new google.maps.TrafficLayer($de370fea0b9a0328$var$__assign($de370fea0b9a0328$var$__assign({}, options || {}), {
            map: map
        }));
        setInstance(trafficLayer);
        if (onLoad) onLoad(trafficLayer);
        return function() {
            if (instance !== null) {
                if (onUnmount) onUnmount(instance);
                instance.setMap(null);
            }
        };
    }, []);
    return null;
}
var $de370fea0b9a0328$export$f1d332bd2ca31f57 = (0, $b6HlZ.memo)($de370fea0b9a0328$var$TrafficLayerFunctional);
var $de370fea0b9a0328$export$aa8252582de0b23e = /** @class */ function(_super) {
    $de370fea0b9a0328$var$__extends(TrafficLayer, _super);
    function TrafficLayer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            trafficLayer: null
        };
        _this.setTrafficLayerCallback = function() {
            if (_this.state.trafficLayer !== null && _this.props.onLoad) _this.props.onLoad(_this.state.trafficLayer);
        };
        _this.registeredEvents = [];
        return _this;
    }
    TrafficLayer.prototype.componentDidMount = function() {
        var trafficLayer = new google.maps.TrafficLayer($de370fea0b9a0328$var$__assign($de370fea0b9a0328$var$__assign({}, this.props.options || {}), {
            map: this.context
        }));
        this.registeredEvents = $de370fea0b9a0328$var$applyUpdatersToPropsAndRegisterEvents({
            updaterMap: $de370fea0b9a0328$var$updaterMap$h,
            eventMap: $de370fea0b9a0328$var$eventMap$h,
            prevProps: {},
            nextProps: this.props,
            instance: trafficLayer
        });
        this.setState(function setTrafficLayer() {
            return {
                trafficLayer: trafficLayer
            };
        }, this.setTrafficLayerCallback);
    };
    TrafficLayer.prototype.componentDidUpdate = function(prevProps) {
        if (this.state.trafficLayer !== null) {
            $de370fea0b9a0328$var$unregisterEvents(this.registeredEvents);
            this.registeredEvents = $de370fea0b9a0328$var$applyUpdatersToPropsAndRegisterEvents({
                updaterMap: $de370fea0b9a0328$var$updaterMap$h,
                eventMap: $de370fea0b9a0328$var$eventMap$h,
                prevProps: prevProps,
                nextProps: this.props,
                instance: this.state.trafficLayer
            });
        }
    };
    TrafficLayer.prototype.componentWillUnmount = function() {
        if (this.state.trafficLayer !== null) {
            if (this.props.onUnmount) this.props.onUnmount(this.state.trafficLayer);
            $de370fea0b9a0328$var$unregisterEvents(this.registeredEvents);
            this.state.trafficLayer.setMap(null);
        }
    };
    TrafficLayer.prototype.render = function() {
        return null;
    };
    TrafficLayer.contextType = $de370fea0b9a0328$export$dc7344301ae78f85;
    return TrafficLayer;
}((0, $b6HlZ.PureComponent));
function $de370fea0b9a0328$var$BicyclingLayerFunctional(_a) {
    var onLoad = _a.onLoad, onUnmount = _a.onUnmount;
    var map = (0, $b6HlZ.useContext)($de370fea0b9a0328$export$dc7344301ae78f85);
    var _b = (0, $b6HlZ.useState)(null), instance = _b[0], setInstance = _b[1];
    // Order does matter
    (0, $b6HlZ.useEffect)(function() {
        if (instance !== null) instance.setMap(map);
    }, [
        map
    ]);
    (0, $b6HlZ.useEffect)(function() {
        var bicyclingLayer = new google.maps.BicyclingLayer();
        setInstance(bicyclingLayer);
        bicyclingLayer.setMap(map);
        if (onLoad) onLoad(bicyclingLayer);
        return function() {
            if (bicyclingLayer !== null) {
                if (onUnmount) onUnmount(bicyclingLayer);
                bicyclingLayer.setMap(null);
            }
        };
    }, []);
    return null;
}
var $de370fea0b9a0328$export$47993550aec06aef = (0, $b6HlZ.memo)($de370fea0b9a0328$var$BicyclingLayerFunctional);
var $de370fea0b9a0328$export$9f9b3b888f86b05e = /** @class */ function(_super) {
    $de370fea0b9a0328$var$__extends(BicyclingLayer, _super);
    function BicyclingLayer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            bicyclingLayer: null
        };
        _this.setBicyclingLayerCallback = function() {
            if (_this.state.bicyclingLayer !== null) {
                _this.state.bicyclingLayer.setMap(_this.context);
                if (_this.props.onLoad) _this.props.onLoad(_this.state.bicyclingLayer);
            }
        };
        return _this;
    }
    BicyclingLayer.prototype.componentDidMount = function() {
        var bicyclingLayer = new google.maps.BicyclingLayer();
        this.setState(function() {
            return {
                bicyclingLayer: bicyclingLayer
            };
        }, this.setBicyclingLayerCallback);
    };
    BicyclingLayer.prototype.componentWillUnmount = function() {
        if (this.state.bicyclingLayer !== null) {
            if (this.props.onUnmount) this.props.onUnmount(this.state.bicyclingLayer);
            this.state.bicyclingLayer.setMap(null);
        }
    };
    BicyclingLayer.prototype.render = function() {
        return null;
    };
    BicyclingLayer.contextType = $de370fea0b9a0328$export$dc7344301ae78f85;
    return BicyclingLayer;
}((0, $b6HlZ.PureComponent));
function $de370fea0b9a0328$var$TransitLayerFunctional(_a) {
    var onLoad = _a.onLoad, onUnmount = _a.onUnmount;
    var map = (0, $b6HlZ.useContext)($de370fea0b9a0328$export$dc7344301ae78f85);
    var _b = (0, $b6HlZ.useState)(null), instance = _b[0], setInstance = _b[1];
    // Order does matter
    (0, $b6HlZ.useEffect)(function() {
        if (instance !== null) instance.setMap(map);
    }, [
        map
    ]);
    (0, $b6HlZ.useEffect)(function() {
        var transitLayer = new google.maps.TransitLayer();
        setInstance(transitLayer);
        transitLayer.setMap(map);
        if (onLoad) onLoad(transitLayer);
        return function() {
            if (instance !== null) {
                if (onUnmount) onUnmount(instance);
                instance.setMap(null);
            }
        };
    }, []);
    return null;
}
var $de370fea0b9a0328$export$9fd3cf155641015f = (0, $b6HlZ.memo)($de370fea0b9a0328$var$TransitLayerFunctional);
var $de370fea0b9a0328$export$b4f2ddd6a5af2fbd = /** @class */ function(_super) {
    $de370fea0b9a0328$var$__extends(TransitLayer, _super);
    function TransitLayer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            transitLayer: null
        };
        _this.setTransitLayerCallback = function() {
            if (_this.state.transitLayer !== null) {
                _this.state.transitLayer.setMap(_this.context);
                if (_this.props.onLoad) _this.props.onLoad(_this.state.transitLayer);
            }
        };
        return _this;
    }
    TransitLayer.prototype.componentDidMount = function() {
        var transitLayer = new google.maps.TransitLayer();
        this.setState(function setTransitLayer() {
            return {
                transitLayer: transitLayer
            };
        }, this.setTransitLayerCallback);
    };
    TransitLayer.prototype.componentWillUnmount = function() {
        if (this.state.transitLayer !== null) {
            if (this.props.onUnmount) this.props.onUnmount(this.state.transitLayer);
            this.state.transitLayer.setMap(null);
        }
    };
    TransitLayer.prototype.render = function() {
        return null;
    };
    TransitLayer.contextType = $de370fea0b9a0328$export$dc7344301ae78f85;
    return TransitLayer;
}((0, $b6HlZ.PureComponent));
var $de370fea0b9a0328$var$eventMap$g = {
    onCircleComplete: "circlecomplete",
    onMarkerComplete: "markercomplete",
    onOverlayComplete: "overlaycomplete",
    onPolygonComplete: "polygoncomplete",
    onPolylineComplete: "polylinecomplete",
    onRectangleComplete: "rectanglecomplete"
};
var $de370fea0b9a0328$var$updaterMap$g = {
    drawingMode: function(instance, drawingMode) {
        instance.setDrawingMode(drawingMode);
    },
    options: function(instance, options) {
        instance.setOptions(options);
    }
};
function $de370fea0b9a0328$var$DrawingManagerFunctional(_a) {
    var options = _a.options, drawingMode = _a.drawingMode, onCircleComplete = _a.onCircleComplete, onMarkerComplete = _a.onMarkerComplete, onOverlayComplete = _a.onOverlayComplete, onPolygonComplete = _a.onPolygonComplete, onPolylineComplete = _a.onPolylineComplete, onRectangleComplete = _a.onRectangleComplete, onLoad = _a.onLoad, onUnmount = _a.onUnmount;
    var map = (0, $b6HlZ.useContext)($de370fea0b9a0328$export$dc7344301ae78f85);
    var _b = (0, $b6HlZ.useState)(null), instance = _b[0], setInstance = _b[1];
    var _c = (0, $b6HlZ.useState)(null), circlecompleteListener = _c[0], setCircleCompleteListener = _c[1];
    var _d = (0, $b6HlZ.useState)(null), markercompleteListener = _d[0], setMarkerCompleteListener = _d[1];
    var _e = (0, $b6HlZ.useState)(null), overlaycompleteListener = _e[0], setOverlayCompleteListener = _e[1];
    var _f = (0, $b6HlZ.useState)(null), polygoncompleteListener = _f[0], setPolygonCompleteListener = _f[1];
    var _g = (0, $b6HlZ.useState)(null), polylinecompleteListener = _g[0], setPolylineCompleteListener = _g[1];
    var _h = (0, $b6HlZ.useState)(null), rectanglecompleteListener = _h[0], setRectangleCompleteListener = _h[1];
    // Order does matter
    (0, $b6HlZ.useEffect)(function() {
        if (instance !== null) instance.setMap(map);
    }, [
        map
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (options && instance !== null) instance.setOptions(options);
    }, [
        instance,
        options
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (drawingMode && instance !== null) instance.setDrawingMode(drawingMode);
    }, [
        instance,
        drawingMode
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (instance && onCircleComplete) {
            if (circlecompleteListener !== null) google.maps.event.removeListener(circlecompleteListener);
            setCircleCompleteListener(google.maps.event.addListener(instance, "circlecomplete", onCircleComplete));
        }
    }, [
        instance,
        onCircleComplete
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (instance && onMarkerComplete) {
            if (markercompleteListener !== null) google.maps.event.removeListener(markercompleteListener);
            setMarkerCompleteListener(google.maps.event.addListener(instance, "markercomplete", onMarkerComplete));
        }
    }, [
        instance,
        onMarkerComplete
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (instance && onOverlayComplete) {
            if (overlaycompleteListener !== null) google.maps.event.removeListener(overlaycompleteListener);
            setOverlayCompleteListener(google.maps.event.addListener(instance, "overlaycomplete", onOverlayComplete));
        }
    }, [
        instance,
        onOverlayComplete
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (instance && onPolygonComplete) {
            if (polygoncompleteListener !== null) google.maps.event.removeListener(polygoncompleteListener);
            setPolygonCompleteListener(google.maps.event.addListener(instance, "polygoncomplete", onPolygonComplete));
        }
    }, [
        instance,
        onPolygonComplete
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (instance && onPolylineComplete) {
            if (polylinecompleteListener !== null) google.maps.event.removeListener(polylinecompleteListener);
            setPolylineCompleteListener(google.maps.event.addListener(instance, "polylinecomplete", onPolylineComplete));
        }
    }, [
        instance,
        onPolylineComplete
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (instance && onRectangleComplete) {
            if (rectanglecompleteListener !== null) google.maps.event.removeListener(rectanglecompleteListener);
            setRectangleCompleteListener(google.maps.event.addListener(instance, "rectanglecomplete", onRectangleComplete));
        }
    }, [
        instance,
        onRectangleComplete
    ]);
    (0, $b6HlZ.useEffect)(function() {
        $de370fea0b9a0328$var$invariant$1(!!google.maps.drawing, "Did you include prop libraries={['drawing']} in the URL? %s", google.maps.drawing);
        var drawingManager = new google.maps.drawing.DrawingManager($de370fea0b9a0328$var$__assign($de370fea0b9a0328$var$__assign({}, options || {}), {
            map: map
        }));
        if (drawingMode) drawingManager.setDrawingMode(drawingMode);
        if (onCircleComplete) setCircleCompleteListener(google.maps.event.addListener(drawingManager, "circlecomplete", onCircleComplete));
        if (onMarkerComplete) setMarkerCompleteListener(google.maps.event.addListener(drawingManager, "markercomplete", onMarkerComplete));
        if (onOverlayComplete) setOverlayCompleteListener(google.maps.event.addListener(drawingManager, "overlaycomplete", onOverlayComplete));
        if (onPolygonComplete) setPolygonCompleteListener(google.maps.event.addListener(drawingManager, "polygoncomplete", onPolygonComplete));
        if (onPolylineComplete) setPolylineCompleteListener(google.maps.event.addListener(drawingManager, "polylinecomplete", onPolylineComplete));
        if (onRectangleComplete) setRectangleCompleteListener(google.maps.event.addListener(drawingManager, "rectanglecomplete", onRectangleComplete));
        setInstance(drawingManager);
        if (onLoad) onLoad(drawingManager);
        return function() {
            if (instance !== null) {
                if (circlecompleteListener) google.maps.event.removeListener(circlecompleteListener);
                if (markercompleteListener) google.maps.event.removeListener(markercompleteListener);
                if (overlaycompleteListener) google.maps.event.removeListener(overlaycompleteListener);
                if (polygoncompleteListener) google.maps.event.removeListener(polygoncompleteListener);
                if (polylinecompleteListener) google.maps.event.removeListener(polylinecompleteListener);
                if (rectanglecompleteListener) google.maps.event.removeListener(rectanglecompleteListener);
                if (onUnmount) onUnmount(instance);
                instance.setMap(null);
            }
        };
    }, []);
    return null;
}
var $de370fea0b9a0328$export$5943163edd351e32 = (0, $b6HlZ.memo)($de370fea0b9a0328$var$DrawingManagerFunctional);
var $de370fea0b9a0328$export$d35043b1ff2dc71 = /** @class */ function(_super) {
    $de370fea0b9a0328$var$__extends(DrawingManager, _super);
    function DrawingManager(props) {
        var _this = _super.call(this, props) || this;
        _this.registeredEvents = [];
        _this.state = {
            drawingManager: null
        };
        _this.setDrawingManagerCallback = function() {
            if (_this.state.drawingManager !== null && _this.props.onLoad) _this.props.onLoad(_this.state.drawingManager);
        };
        $de370fea0b9a0328$var$invariant$1(!!google.maps.drawing, "Did you include prop libraries={['drawing']} in the URL? %s", google.maps.drawing);
        return _this;
    }
    DrawingManager.prototype.componentDidMount = function() {
        var drawingManager = new google.maps.drawing.DrawingManager($de370fea0b9a0328$var$__assign($de370fea0b9a0328$var$__assign({}, this.props.options || {}), {
            map: this.context
        }));
        this.registeredEvents = $de370fea0b9a0328$var$applyUpdatersToPropsAndRegisterEvents({
            updaterMap: $de370fea0b9a0328$var$updaterMap$g,
            eventMap: $de370fea0b9a0328$var$eventMap$g,
            prevProps: {},
            nextProps: this.props,
            instance: drawingManager
        });
        this.setState(function setDrawingManager() {
            return {
                drawingManager: drawingManager
            };
        }, this.setDrawingManagerCallback);
    };
    DrawingManager.prototype.componentDidUpdate = function(prevProps) {
        if (this.state.drawingManager !== null) {
            $de370fea0b9a0328$var$unregisterEvents(this.registeredEvents);
            this.registeredEvents = $de370fea0b9a0328$var$applyUpdatersToPropsAndRegisterEvents({
                updaterMap: $de370fea0b9a0328$var$updaterMap$g,
                eventMap: $de370fea0b9a0328$var$eventMap$g,
                prevProps: prevProps,
                nextProps: this.props,
                instance: this.state.drawingManager
            });
        }
    };
    DrawingManager.prototype.componentWillUnmount = function() {
        if (this.state.drawingManager !== null) {
            if (this.props.onUnmount) this.props.onUnmount(this.state.drawingManager);
            $de370fea0b9a0328$var$unregisterEvents(this.registeredEvents);
            this.state.drawingManager.setMap(null);
        }
    };
    DrawingManager.prototype.render = function() {
        return null;
    };
    DrawingManager.contextType = $de370fea0b9a0328$export$dc7344301ae78f85;
    return DrawingManager;
}((0, $b6HlZ.PureComponent));
var $de370fea0b9a0328$var$eventMap$f = {
    onAnimationChanged: "animation_changed",
    onClick: "click",
    onClickableChanged: "clickable_changed",
    onCursorChanged: "cursor_changed",
    onDblClick: "dblclick",
    onDrag: "drag",
    onDragEnd: "dragend",
    onDraggableChanged: "draggable_changed",
    onDragStart: "dragstart",
    onFlatChanged: "flat_changed",
    onIconChanged: "icon_changed",
    onMouseDown: "mousedown",
    onMouseOut: "mouseout",
    onMouseOver: "mouseover",
    onMouseUp: "mouseup",
    onPositionChanged: "position_changed",
    onRightClick: "rightclick",
    onShapeChanged: "shape_changed",
    onTitleChanged: "title_changed",
    onVisibleChanged: "visible_changed",
    onZindexChanged: "zindex_changed"
};
var $de370fea0b9a0328$var$updaterMap$f = {
    animation: function(instance, animation) {
        instance.setAnimation(animation);
    },
    clickable: function(instance, clickable) {
        instance.setClickable(clickable);
    },
    cursor: function(instance, cursor) {
        instance.setCursor(cursor);
    },
    draggable: function(instance, draggable) {
        instance.setDraggable(draggable);
    },
    icon: function(instance, icon) {
        instance.setIcon(icon);
    },
    label: function(instance, label) {
        instance.setLabel(label);
    },
    map: function(instance, map) {
        instance.setMap(map);
    },
    opacity: function(instance, opacity) {
        instance.setOpacity(opacity);
    },
    options: function(instance, options) {
        instance.setOptions(options);
    },
    position: function(instance, position) {
        instance.setPosition(position);
    },
    shape: function(instance, shape) {
        instance.setShape(shape);
    },
    title: function(instance, title) {
        instance.setTitle(title);
    },
    visible: function(instance, visible) {
        instance.setVisible(visible);
    },
    zIndex: function(instance, zIndex) {
        instance.setZIndex(zIndex);
    }
};
var $de370fea0b9a0328$var$defaultOptions$5 = {};
function $de370fea0b9a0328$var$MarkerFunctional(_a) {
    var position = _a.position, options = _a.options, clusterer = _a.clusterer, noClustererRedraw = _a.noClustererRedraw, children = _a.children, draggable = _a.draggable, visible = _a.visible, animation = _a.animation, clickable = _a.clickable, cursor = _a.cursor, icon = _a.icon, label = _a.label, opacity = _a.opacity, shape = _a.shape, title = _a.title, zIndex = _a.zIndex, onClick = _a.onClick, onDblClick = _a.onDblClick, onDrag = _a.onDrag, onDragEnd = _a.onDragEnd, onDragStart = _a.onDragStart, onMouseOut = _a.onMouseOut, onMouseOver = _a.onMouseOver, onMouseUp = _a.onMouseUp, onMouseDown = _a.onMouseDown, onRightClick = _a.onRightClick, onClickableChanged = _a.onClickableChanged, onCursorChanged = _a.onCursorChanged, onAnimationChanged = _a.onAnimationChanged, onDraggableChanged = _a.onDraggableChanged, onFlatChanged = _a.onFlatChanged, onIconChanged = _a.onIconChanged, onPositionChanged = _a.onPositionChanged, onShapeChanged = _a.onShapeChanged, onTitleChanged = _a.onTitleChanged, onVisibleChanged = _a.onVisibleChanged, onZindexChanged = _a.onZindexChanged, onLoad = _a.onLoad, onUnmount = _a.onUnmount;
    var map = (0, $b6HlZ.useContext)($de370fea0b9a0328$export$dc7344301ae78f85);
    var _b = (0, $b6HlZ.useState)(null), instance = _b[0], setInstance = _b[1];
    var _c = (0, $b6HlZ.useState)(null), dblclickListener = _c[0], setDblclickListener = _c[1];
    var _d = (0, $b6HlZ.useState)(null), dragendListener = _d[0], setDragendListener = _d[1];
    var _e = (0, $b6HlZ.useState)(null), dragstartListener = _e[0], setDragstartListener = _e[1];
    var _f = (0, $b6HlZ.useState)(null), mousedownListener = _f[0], setMousedownListener = _f[1];
    var _g = (0, $b6HlZ.useState)(null), mouseoutListener = _g[0], setMouseoutListener = _g[1];
    var _h = (0, $b6HlZ.useState)(null), mouseoverListener = _h[0], setMouseoverListener = _h[1];
    var _j = (0, $b6HlZ.useState)(null), mouseupListener = _j[0], setMouseupListener = _j[1];
    var _k = (0, $b6HlZ.useState)(null), rightclickListener = _k[0], setRightclickListener = _k[1];
    var _l = (0, $b6HlZ.useState)(null), clickListener = _l[0], setClickListener = _l[1];
    var _m = (0, $b6HlZ.useState)(null), dragListener = _m[0], setDragListener = _m[1];
    var _o = (0, $b6HlZ.useState)(null), clickableChangedListener = _o[0], setClickableChangedListener = _o[1];
    var _p = (0, $b6HlZ.useState)(null), cursorChangedListener = _p[0], setCursorChangedListener = _p[1];
    var _q = (0, $b6HlZ.useState)(null), animationChangedListener = _q[0], setAnimationChangedListener = _q[1];
    var _r = (0, $b6HlZ.useState)(null), draggableChangedListener = _r[0], setDraggableChangedListener = _r[1];
    var _s = (0, $b6HlZ.useState)(null), flatChangedListener = _s[0], setFlatChangedListener = _s[1];
    var _t = (0, $b6HlZ.useState)(null), iconChangedListener = _t[0], setIconChangedListener = _t[1];
    var _u = (0, $b6HlZ.useState)(null), positionChangedListener = _u[0], setPositionChangedListener = _u[1];
    var _v = (0, $b6HlZ.useState)(null), shapeChangedListener = _v[0], setShapeChangedListener = _v[1];
    var _w = (0, $b6HlZ.useState)(null), titleChangedListener = _w[0], setTitleChangedListener = _w[1];
    var _x = (0, $b6HlZ.useState)(null), visibleChangedListener = _x[0], setVisibleChangedListener = _x[1];
    var _y = (0, $b6HlZ.useState)(null), zIndexChangedListener = _y[0], setZindexChangedListener = _y[1];
    // Order does matter
    (0, $b6HlZ.useEffect)(function() {
        if (instance !== null) instance.setMap(map);
    }, [
        map
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (typeof options !== "undefined" && instance !== null) instance.setOptions(options);
    }, [
        instance,
        options
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (typeof draggable !== "undefined" && instance !== null) instance.setDraggable(draggable);
    }, [
        instance,
        draggable
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (position && instance !== null) instance.setPosition(position);
    }, [
        instance,
        position
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (typeof visible !== "undefined" && instance !== null) instance.setVisible(visible);
    }, [
        instance,
        visible
    ]);
    (0, $b6HlZ.useEffect)(function() {
        instance === null || instance === void 0 || instance.setAnimation(animation);
    }, [
        instance,
        animation
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (instance && onDblClick) {
            if (dblclickListener !== null) google.maps.event.removeListener(dblclickListener);
            setDblclickListener(google.maps.event.addListener(instance, "dblclick", onDblClick));
        }
    }, [
        onDblClick
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (instance && onDragEnd) {
            if (dragendListener !== null) google.maps.event.removeListener(dragendListener);
            setDragendListener(google.maps.event.addListener(instance, "dragend", onDragEnd));
        }
    }, [
        onDragEnd
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (instance && onDragStart) {
            if (dragstartListener !== null) google.maps.event.removeListener(dragstartListener);
            setDragstartListener(google.maps.event.addListener(instance, "dragstart", onDragStart));
        }
    }, [
        onDragStart
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (instance && onMouseDown) {
            if (mousedownListener !== null) google.maps.event.removeListener(mousedownListener);
            setMousedownListener(google.maps.event.addListener(instance, "mousedown", onMouseDown));
        }
    }, [
        onMouseDown
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (instance && onMouseOut) {
            if (mouseoutListener !== null) google.maps.event.removeListener(mouseoutListener);
            setMouseoutListener(google.maps.event.addListener(instance, "mouseout", onMouseOut));
        }
    }, [
        onMouseOut
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (instance && onMouseOver) {
            if (mouseoverListener !== null) google.maps.event.removeListener(mouseoverListener);
            setMouseoverListener(google.maps.event.addListener(instance, "mouseover", onMouseOver));
        }
    }, [
        onMouseOver
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (instance && onMouseUp) {
            if (mouseupListener !== null) google.maps.event.removeListener(mouseupListener);
            setMouseupListener(google.maps.event.addListener(instance, "mouseup", onMouseUp));
        }
    }, [
        onMouseUp
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (instance && onRightClick) {
            if (rightclickListener !== null) google.maps.event.removeListener(rightclickListener);
            setRightclickListener(google.maps.event.addListener(instance, "rightclick", onRightClick));
        }
    }, [
        onRightClick
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (instance && onClick) {
            if (clickListener !== null) google.maps.event.removeListener(clickListener);
            setClickListener(google.maps.event.addListener(instance, "click", onClick));
        }
    }, [
        onClick
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (instance && onDrag) {
            if (dragListener !== null) google.maps.event.removeListener(dragListener);
            setDragListener(google.maps.event.addListener(instance, "drag", onDrag));
        }
    }, [
        onDrag
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (instance && onClickableChanged) {
            if (clickableChangedListener !== null) google.maps.event.removeListener(clickableChangedListener);
            setClickableChangedListener(google.maps.event.addListener(instance, "clickable_changed", onClickableChanged));
        }
    }, [
        onClickableChanged
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (instance && onCursorChanged) {
            if (cursorChangedListener !== null) google.maps.event.removeListener(cursorChangedListener);
            setCursorChangedListener(google.maps.event.addListener(instance, "cursor_changed", onCursorChanged));
        }
    }, [
        onCursorChanged
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (instance && onAnimationChanged) {
            if (animationChangedListener !== null) google.maps.event.removeListener(animationChangedListener);
            setAnimationChangedListener(google.maps.event.addListener(instance, "animation_changed", onAnimationChanged));
        }
    }, [
        onAnimationChanged
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (instance && onDraggableChanged) {
            if (draggableChangedListener !== null) google.maps.event.removeListener(draggableChangedListener);
            setDraggableChangedListener(google.maps.event.addListener(instance, "draggable_changed", onDraggableChanged));
        }
    }, [
        onDraggableChanged
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (instance && onFlatChanged) {
            if (flatChangedListener !== null) google.maps.event.removeListener(flatChangedListener);
            setFlatChangedListener(google.maps.event.addListener(instance, "flat_changed", onFlatChanged));
        }
    }, [
        onFlatChanged
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (instance && onIconChanged) {
            if (iconChangedListener !== null) google.maps.event.removeListener(iconChangedListener);
            setIconChangedListener(google.maps.event.addListener(instance, "icon_changed", onIconChanged));
        }
    }, [
        onIconChanged
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (instance && onPositionChanged) {
            if (positionChangedListener !== null) google.maps.event.removeListener(positionChangedListener);
            setPositionChangedListener(google.maps.event.addListener(instance, "position_changed", onPositionChanged));
        }
    }, [
        onPositionChanged
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (instance && onShapeChanged) {
            if (shapeChangedListener !== null) google.maps.event.removeListener(shapeChangedListener);
            setShapeChangedListener(google.maps.event.addListener(instance, "shape_changed", onShapeChanged));
        }
    }, [
        onShapeChanged
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (instance && onTitleChanged) {
            if (titleChangedListener !== null) google.maps.event.removeListener(titleChangedListener);
            setTitleChangedListener(google.maps.event.addListener(instance, "title_changed", onTitleChanged));
        }
    }, [
        onTitleChanged
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (instance && onVisibleChanged) {
            if (visibleChangedListener !== null) google.maps.event.removeListener(visibleChangedListener);
            setVisibleChangedListener(google.maps.event.addListener(instance, "visible_changed", onVisibleChanged));
        }
    }, [
        onVisibleChanged
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (instance && onZindexChanged) {
            if (zIndexChangedListener !== null) google.maps.event.removeListener(zIndexChangedListener);
            setZindexChangedListener(google.maps.event.addListener(instance, "zindex_changed", onZindexChanged));
        }
    }, [
        onZindexChanged
    ]);
    (0, $b6HlZ.useEffect)(function() {
        var markerOptions = $de370fea0b9a0328$var$__assign($de370fea0b9a0328$var$__assign($de370fea0b9a0328$var$__assign({}, options || $de370fea0b9a0328$var$defaultOptions$5), clusterer ? $de370fea0b9a0328$var$defaultOptions$5 : {
            map: map
        }), {
            position: position
        });
        var marker = new google.maps.Marker(markerOptions);
        if (clusterer) clusterer.addMarker(marker, !!noClustererRedraw);
        else marker.setMap(map);
        if (position) marker.setPosition(position);
        if (typeof visible !== "undefined") marker.setVisible(visible);
        if (typeof draggable !== "undefined") marker.setDraggable(draggable);
        if (typeof clickable !== "undefined") marker.setClickable(clickable);
        if (typeof cursor === "string") marker.setCursor(cursor);
        if (icon) marker.setIcon(icon);
        if (typeof label !== "undefined") marker.setLabel(label);
        if (typeof opacity !== "undefined") marker.setOpacity(opacity);
        if (shape) marker.setShape(shape);
        if (typeof title === "string") marker.setTitle(title);
        if (typeof zIndex === "number") marker.setZIndex(zIndex);
        if (onDblClick) setDblclickListener(google.maps.event.addListener(marker, "dblclick", onDblClick));
        if (onDragEnd) setDragendListener(google.maps.event.addListener(marker, "dragend", onDragEnd));
        if (onDragStart) setDragstartListener(google.maps.event.addListener(marker, "dragstart", onDragStart));
        if (onMouseDown) setMousedownListener(google.maps.event.addListener(marker, "mousedown", onMouseDown));
        if (onMouseOut) setMouseoutListener(google.maps.event.addListener(marker, "mouseout", onMouseOut));
        if (onMouseOver) setMouseoverListener(google.maps.event.addListener(marker, "mouseover", onMouseOver));
        if (onMouseUp) setMouseupListener(google.maps.event.addListener(marker, "mouseup", onMouseUp));
        if (onRightClick) setRightclickListener(google.maps.event.addListener(marker, "rightclick", onRightClick));
        if (onClick) setClickListener(google.maps.event.addListener(marker, "click", onClick));
        if (onDrag) setDragListener(google.maps.event.addListener(marker, "drag", onDrag));
        if (onClickableChanged) setClickableChangedListener(google.maps.event.addListener(marker, "clickable_changed", onClickableChanged));
        if (onCursorChanged) setCursorChangedListener(google.maps.event.addListener(marker, "cursor_changed", onCursorChanged));
        if (onAnimationChanged) setAnimationChangedListener(google.maps.event.addListener(marker, "animation_changed", onAnimationChanged));
        if (onDraggableChanged) setDraggableChangedListener(google.maps.event.addListener(marker, "draggable_changed", onDraggableChanged));
        if (onFlatChanged) setFlatChangedListener(google.maps.event.addListener(marker, "flat_changed", onFlatChanged));
        if (onIconChanged) setIconChangedListener(google.maps.event.addListener(marker, "icon_changed", onIconChanged));
        if (onPositionChanged) setPositionChangedListener(google.maps.event.addListener(marker, "position_changed", onPositionChanged));
        if (onShapeChanged) setShapeChangedListener(google.maps.event.addListener(marker, "shape_changed", onShapeChanged));
        if (onTitleChanged) setTitleChangedListener(google.maps.event.addListener(marker, "title_changed", onTitleChanged));
        if (onVisibleChanged) setVisibleChangedListener(google.maps.event.addListener(marker, "visible_changed", onVisibleChanged));
        if (onZindexChanged) setZindexChangedListener(google.maps.event.addListener(marker, "zindex_changed", onZindexChanged));
        setInstance(marker);
        if (onLoad) onLoad(marker);
        return function() {
            if (dblclickListener !== null) google.maps.event.removeListener(dblclickListener);
            if (dragendListener !== null) google.maps.event.removeListener(dragendListener);
            if (dragstartListener !== null) google.maps.event.removeListener(dragstartListener);
            if (mousedownListener !== null) google.maps.event.removeListener(mousedownListener);
            if (mouseoutListener !== null) google.maps.event.removeListener(mouseoutListener);
            if (mouseoverListener !== null) google.maps.event.removeListener(mouseoverListener);
            if (mouseupListener !== null) google.maps.event.removeListener(mouseupListener);
            if (rightclickListener !== null) google.maps.event.removeListener(rightclickListener);
            if (clickListener !== null) google.maps.event.removeListener(clickListener);
            if (clickableChangedListener !== null) google.maps.event.removeListener(clickableChangedListener);
            if (cursorChangedListener !== null) google.maps.event.removeListener(cursorChangedListener);
            if (animationChangedListener !== null) google.maps.event.removeListener(animationChangedListener);
            if (draggableChangedListener !== null) google.maps.event.removeListener(draggableChangedListener);
            if (flatChangedListener !== null) google.maps.event.removeListener(flatChangedListener);
            if (iconChangedListener !== null) google.maps.event.removeListener(iconChangedListener);
            if (positionChangedListener !== null) google.maps.event.removeListener(positionChangedListener);
            if (titleChangedListener !== null) google.maps.event.removeListener(titleChangedListener);
            if (visibleChangedListener !== null) google.maps.event.removeListener(visibleChangedListener);
            if (zIndexChangedListener !== null) google.maps.event.removeListener(zIndexChangedListener);
            if (onUnmount) onUnmount(marker);
            if (clusterer) clusterer.removeMarker(marker, !!noClustererRedraw);
            else if (marker) marker.setMap(null);
        };
    }, []);
    var chx = (0, $b6HlZ.useMemo)(function() {
        return children ? (0, $b6HlZ.Children).map(children, function(child) {
            if (!(0, $b6HlZ.isValidElement)(child)) return child;
            var elementChild = child;
            return (0, $b6HlZ.cloneElement)(elementChild, {
                anchor: instance
            });
        }) : null;
    }, [
        children,
        instance
    ]);
    return (0, $94829a8b99aa12e4$exports.jsx)((0, $94829a8b99aa12e4$exports.Fragment), {
        children: chx
    }) || null;
}
var $de370fea0b9a0328$export$45d474b1d7219d91 = (0, $b6HlZ.memo)($de370fea0b9a0328$var$MarkerFunctional);
var $de370fea0b9a0328$export$e98856a975cab58e = /** @class */ function(_super) {
    $de370fea0b9a0328$var$__extends(Marker, _super);
    function Marker() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.registeredEvents = [];
        return _this;
    }
    Marker.prototype.componentDidMount = function() {
        var markerOptions = $de370fea0b9a0328$var$__assign($de370fea0b9a0328$var$__assign($de370fea0b9a0328$var$__assign({}, this.props.options || $de370fea0b9a0328$var$defaultOptions$5), this.props.clusterer ? $de370fea0b9a0328$var$defaultOptions$5 : {
            map: this.context
        }), {
            position: this.props.position
        });
        // Unfortunately we can't just do this in the contstructor, because the
        // `MapContext` might not be filled in yet.
        this.marker = new google.maps.Marker(markerOptions);
        if (this.props.clusterer) this.props.clusterer.addMarker(this.marker, !!this.props.noClustererRedraw);
        else this.marker.setMap(this.context);
        this.registeredEvents = $de370fea0b9a0328$var$applyUpdatersToPropsAndRegisterEvents({
            updaterMap: $de370fea0b9a0328$var$updaterMap$f,
            eventMap: $de370fea0b9a0328$var$eventMap$f,
            prevProps: {},
            nextProps: this.props,
            instance: this.marker
        });
        if (this.props.onLoad) this.props.onLoad(this.marker);
    };
    Marker.prototype.componentDidUpdate = function(prevProps) {
        if (this.marker) {
            $de370fea0b9a0328$var$unregisterEvents(this.registeredEvents);
            this.registeredEvents = $de370fea0b9a0328$var$applyUpdatersToPropsAndRegisterEvents({
                updaterMap: $de370fea0b9a0328$var$updaterMap$f,
                eventMap: $de370fea0b9a0328$var$eventMap$f,
                prevProps: prevProps,
                nextProps: this.props,
                instance: this.marker
            });
        }
    };
    Marker.prototype.componentWillUnmount = function() {
        if (this.marker) {
            if (this.props.onUnmount) this.props.onUnmount(this.marker);
            $de370fea0b9a0328$var$unregisterEvents(this.registeredEvents);
            if (this.props.clusterer) this.props.clusterer.removeMarker(this.marker, !!this.props.noClustererRedraw);
            else this.marker && this.marker.setMap(null);
        }
    };
    Marker.prototype.render = function() {
        var _this = this;
        var children = null;
        if (this.props.children) children = (0, $b6HlZ.Children).map(this.props.children, function(child) {
            if (!(0, $b6HlZ.isValidElement)(child)) return child;
            var elementChild = child;
            return (0, $b6HlZ.cloneElement)(elementChild, {
                anchor: _this.marker
            });
        });
        return children || null;
    };
    Marker.contextType = $de370fea0b9a0328$export$dc7344301ae78f85;
    return Marker;
}((0, $b6HlZ.PureComponent));
var $de370fea0b9a0328$var$ClusterIcon = /** @class */ function() {
    function ClusterIcon(cluster, styles) {
        cluster.getClusterer().extend(ClusterIcon, google.maps.OverlayView);
        this.cluster = cluster;
        this.clusterClassName = this.cluster.getClusterer().getClusterClass();
        this.className = this.clusterClassName;
        this.styles = styles;
        this.center = undefined;
        this.div = null;
        this.sums = null;
        this.visible = false;
        this.boundsChangedListener = null;
        this.url = "";
        this.height = 0;
        this.width = 0;
        this.anchorText = [
            0,
            0
        ];
        this.anchorIcon = [
            0,
            0
        ];
        this.textColor = "black";
        this.textSize = 11;
        this.textDecoration = "none";
        this.fontWeight = "bold";
        this.fontStyle = "normal";
        this.fontFamily = "Arial,sans-serif";
        this.backgroundPosition = "0 0";
        this.cMouseDownInCluster = null;
        this.cDraggingMapByCluster = null;
        this.timeOut = null;
        this.setMap(cluster.getMap()); // Note: this causes onAdd to be called
        this.onBoundsChanged = this.onBoundsChanged.bind(this);
        this.onMouseDown = this.onMouseDown.bind(this);
        this.onClick = this.onClick.bind(this);
        this.onMouseOver = this.onMouseOver.bind(this);
        this.onMouseOut = this.onMouseOut.bind(this);
        this.onAdd = this.onAdd.bind(this);
        this.onRemove = this.onRemove.bind(this);
        this.draw = this.draw.bind(this);
        this.hide = this.hide.bind(this);
        this.show = this.show.bind(this);
        this.useStyle = this.useStyle.bind(this);
        this.setCenter = this.setCenter.bind(this);
        this.getPosFromLatLng = this.getPosFromLatLng.bind(this);
    }
    ClusterIcon.prototype.onBoundsChanged = function() {
        this.cDraggingMapByCluster = this.cMouseDownInCluster;
    };
    ClusterIcon.prototype.onMouseDown = function() {
        this.cMouseDownInCluster = true;
        this.cDraggingMapByCluster = false;
    };
    ClusterIcon.prototype.onClick = function(event) {
        this.cMouseDownInCluster = false;
        if (!this.cDraggingMapByCluster) {
            var markerClusterer_1 = this.cluster.getClusterer();
            /**
             * This event is fired when a cluster marker is clicked.
             * @name MarkerClusterer#click
             * @param {Cluster} c The cluster that was clicked.
             * @event
             */ google.maps.event.trigger(markerClusterer_1, "click", this.cluster);
            google.maps.event.trigger(markerClusterer_1, "clusterclick", this.cluster); // deprecated name
            // The default click handler follows. Disable it by setting
            // the zoomOnClick property to false.
            if (markerClusterer_1.getZoomOnClick()) {
                // Zoom into the cluster.
                var maxZoom_1 = markerClusterer_1.getMaxZoom();
                var bounds_1 = this.cluster.getBounds();
                var map = markerClusterer_1.getMap();
                if (map !== null && "fitBounds" in map) map.fitBounds(bounds_1);
                // There is a fix for Issue 170 here:
                this.timeOut = window.setTimeout(function() {
                    var map = markerClusterer_1.getMap();
                    if (map !== null) {
                        if ("fitBounds" in map) map.fitBounds(bounds_1);
                        var zoom = map.getZoom() || 0;
                        // Don't zoom beyond the max zoom level
                        if (maxZoom_1 !== null && zoom > maxZoom_1) map.setZoom(maxZoom_1 + 1);
                    }
                }, 100);
            }
            // Prevent event propagation to the map:
            event.cancelBubble = true;
            if (event.stopPropagation) event.stopPropagation();
        }
    };
    ClusterIcon.prototype.onMouseOver = function() {
        /**
         * This event is fired when the mouse moves over a cluster marker.
         * @name MarkerClusterer#mouseover
         * @param {Cluster} c The cluster that the mouse moved over.
         * @event
         */ google.maps.event.trigger(this.cluster.getClusterer(), "mouseover", this.cluster);
    };
    ClusterIcon.prototype.onMouseOut = function() {
        /**
         * This event is fired when the mouse moves out of a cluster marker.
         * @name MarkerClusterer#mouseout
         * @param {Cluster} c The cluster that the mouse moved out of.
         * @event
         */ google.maps.event.trigger(this.cluster.getClusterer(), "mouseout", this.cluster);
    };
    ClusterIcon.prototype.onAdd = function() {
        var _a;
        this.div = document.createElement("div");
        this.div.className = this.className;
        if (this.visible) this.show();
        (_a = this.getPanes()) === null || _a === void 0 || _a.overlayMouseTarget.appendChild(this.div);
        var map = this.getMap();
        if (map !== null) {
            // Fix for Issue 157
            this.boundsChangedListener = google.maps.event.addListener(map, "bounds_changed", this.onBoundsChanged);
            this.div.addEventListener("mousedown", this.onMouseDown);
            this.div.addEventListener("click", this.onClick);
            this.div.addEventListener("mouseover", this.onMouseOver);
            this.div.addEventListener("mouseout", this.onMouseOut);
        }
    };
    ClusterIcon.prototype.onRemove = function() {
        if (this.div && this.div.parentNode) {
            this.hide();
            if (this.boundsChangedListener !== null) google.maps.event.removeListener(this.boundsChangedListener);
            this.div.removeEventListener("mousedown", this.onMouseDown);
            this.div.removeEventListener("click", this.onClick);
            this.div.removeEventListener("mouseover", this.onMouseOver);
            this.div.removeEventListener("mouseout", this.onMouseOut);
            this.div.parentNode.removeChild(this.div);
            if (this.timeOut !== null) {
                window.clearTimeout(this.timeOut);
                this.timeOut = null;
            }
            this.div = null;
        }
    };
    ClusterIcon.prototype.draw = function() {
        if (this.visible && this.div !== null && this.center) {
            var pos = this.getPosFromLatLng(this.center);
            this.div.style.top = pos !== null ? "".concat(pos.y, "px") : "0";
            this.div.style.left = pos !== null ? "".concat(pos.x, "px") : "0";
        }
    };
    ClusterIcon.prototype.hide = function() {
        if (this.div) this.div.style.display = "none";
        this.visible = false;
    };
    ClusterIcon.prototype.show = function() {
        var _a, _b, _c, _d, _e, _f;
        if (this.div && this.center) {
            var divTitle = this.sums === null || typeof this.sums.title === "undefined" || this.sums.title === "" ? this.cluster.getClusterer().getTitle() : this.sums.title;
            // NOTE: values must be specified in px units
            var bp = this.backgroundPosition.split(" ");
            var spriteH = parseInt(((_a = bp[0]) === null || _a === void 0 ? void 0 : _a.replace(/^\s+|\s+$/g, "")) || "0", 10);
            var spriteV = parseInt(((_b = bp[1]) === null || _b === void 0 ? void 0 : _b.replace(/^\s+|\s+$/g, "")) || "0", 10);
            var pos = this.getPosFromLatLng(this.center);
            this.div.className = this.className;
            this.div.setAttribute("style", "cursor: pointer; position: absolute; top: ".concat(pos !== null ? "".concat(pos.y, "px") : "0", "; left: ").concat(pos !== null ? "".concat(pos.x, "px") : "0", "; width: ").concat(this.width, "px; height: ").concat(this.height, "px; "));
            var img = document.createElement("img");
            img.alt = divTitle;
            img.src = this.url;
            img.width = this.width;
            img.height = this.height;
            img.setAttribute("style", "position: absolute; top: ".concat(spriteV, "px; left: ").concat(spriteH, "px"));
            if (!this.cluster.getClusterer().enableRetinaIcons) img.style.clip = "rect(-".concat(spriteV, "px, -").concat(spriteH + this.width, "px, -").concat(spriteV + this.height, ", -").concat(spriteH, ")");
            var textElm = document.createElement("div");
            textElm.setAttribute("style", "position: absolute; top: ".concat(this.anchorText[0], "px; left: ").concat(this.anchorText[1], "px; color: ").concat(this.textColor, "; font-size: ").concat(this.textSize, "px; font-family: ").concat(this.fontFamily, "; font-weight: ").concat(this.fontWeight, "; fontStyle: ").concat(this.fontStyle, "; text-decoration: ").concat(this.textDecoration, "; text-align: center; width: ").concat(this.width, "px; line-height: ").concat(this.height, "px"));
            if ((_c = this.sums) === null || _c === void 0 ? void 0 : _c.text) textElm.innerText = "".concat((_d = this.sums) === null || _d === void 0 ? void 0 : _d.text);
            if ((_e = this.sums) === null || _e === void 0 ? void 0 : _e.html) textElm.innerHTML = "".concat((_f = this.sums) === null || _f === void 0 ? void 0 : _f.html);
            this.div.innerHTML = "";
            this.div.appendChild(img);
            this.div.appendChild(textElm);
            this.div.title = divTitle;
            this.div.style.display = "";
        }
        this.visible = true;
    };
    ClusterIcon.prototype.useStyle = function(sums) {
        this.sums = sums;
        var styles = this.cluster.getClusterer().getStyles();
        var style = styles[Math.min(styles.length - 1, Math.max(0, sums.index - 1))];
        if (style) {
            this.url = style.url;
            this.height = style.height;
            this.width = style.width;
            if (style.className) this.className = "".concat(this.clusterClassName, " ").concat(style.className);
            this.anchorText = style.anchorText || [
                0,
                0
            ];
            this.anchorIcon = style.anchorIcon || [
                this.height / 2,
                this.width / 2
            ];
            this.textColor = style.textColor || "black";
            this.textSize = style.textSize || 11;
            this.textDecoration = style.textDecoration || "none";
            this.fontWeight = style.fontWeight || "bold";
            this.fontStyle = style.fontStyle || "normal";
            this.fontFamily = style.fontFamily || "Arial,sans-serif";
            this.backgroundPosition = style.backgroundPosition || "0 0";
        }
    };
    ClusterIcon.prototype.setCenter = function(center) {
        this.center = center;
    };
    ClusterIcon.prototype.getPosFromLatLng = function(latlng) {
        var pos = this.getProjection().fromLatLngToDivPixel(latlng);
        if (pos !== null) {
            pos.x -= this.anchorIcon[1];
            pos.y -= this.anchorIcon[0];
        }
        return pos;
    };
    return ClusterIcon;
}();
/* global google */ var $de370fea0b9a0328$var$Cluster$1 = /** @class */ function() {
    function Cluster(markerClusterer) {
        this.markerClusterer = markerClusterer;
        this.map = this.markerClusterer.getMap();
        this.gridSize = this.markerClusterer.getGridSize();
        this.minClusterSize = this.markerClusterer.getMinimumClusterSize();
        this.averageCenter = this.markerClusterer.getAverageCenter();
        this.markers = [];
        this.center = undefined;
        this.bounds = null;
        this.clusterIcon = new $de370fea0b9a0328$var$ClusterIcon(this, this.markerClusterer.getStyles());
        this.getSize = this.getSize.bind(this);
        this.getMarkers = this.getMarkers.bind(this);
        this.getCenter = this.getCenter.bind(this);
        this.getMap = this.getMap.bind(this);
        this.getClusterer = this.getClusterer.bind(this);
        this.getBounds = this.getBounds.bind(this);
        this.remove = this.remove.bind(this);
        this.addMarker = this.addMarker.bind(this);
        this.isMarkerInClusterBounds = this.isMarkerInClusterBounds.bind(this);
        this.calculateBounds = this.calculateBounds.bind(this);
        this.updateIcon = this.updateIcon.bind(this);
        this.isMarkerAlreadyAdded = this.isMarkerAlreadyAdded.bind(this);
    }
    Cluster.prototype.getSize = function() {
        return this.markers.length;
    };
    Cluster.prototype.getMarkers = function() {
        return this.markers;
    };
    Cluster.prototype.getCenter = function() {
        return this.center;
    };
    Cluster.prototype.getMap = function() {
        return this.map;
    };
    Cluster.prototype.getClusterer = function() {
        return this.markerClusterer;
    };
    Cluster.prototype.getBounds = function() {
        var bounds = new google.maps.LatLngBounds(this.center, this.center);
        var markers = this.getMarkers();
        for(var _i = 0, markers_1 = markers; _i < markers_1.length; _i++){
            var marker = markers_1[_i];
            var position = marker.getPosition();
            if (position) bounds.extend(position);
        }
        return bounds;
    };
    Cluster.prototype.remove = function() {
        this.clusterIcon.setMap(null);
        this.markers = [];
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        delete this.markers;
    };
    Cluster.prototype.addMarker = function(marker) {
        var _a;
        if (this.isMarkerAlreadyAdded(marker)) return false;
        if (!this.center) {
            var position = marker.getPosition();
            if (position) {
                this.center = position;
                this.calculateBounds();
            }
        } else if (this.averageCenter) {
            var position = marker.getPosition();
            if (position) {
                var length_1 = this.markers.length + 1;
                this.center = new google.maps.LatLng((this.center.lat() * (length_1 - 1) + position.lat()) / length_1, (this.center.lng() * (length_1 - 1) + position.lng()) / length_1);
                this.calculateBounds();
            }
        }
        marker.isAdded = true;
        this.markers.push(marker);
        var mCount = this.markers.length;
        var maxZoom = this.markerClusterer.getMaxZoom();
        var zoom = (_a = this.map) === null || _a === void 0 ? void 0 : _a.getZoom();
        if (maxZoom !== null && typeof zoom !== "undefined" && zoom > maxZoom) // Zoomed in past max zoom, so show the marker.
        {
            if (marker.getMap() !== this.map) marker.setMap(this.map);
        } else if (mCount < this.minClusterSize) // Min cluster size not reached so show the marker.
        {
            if (marker.getMap() !== this.map) marker.setMap(this.map);
        } else if (mCount === this.minClusterSize) // Hide the markers that were showing.
        for(var _i = 0, _b = this.markers; _i < _b.length; _i++){
            var markerElement = _b[_i];
            markerElement.setMap(null);
        }
        else marker.setMap(null);
        return true;
    };
    Cluster.prototype.isMarkerInClusterBounds = function(marker) {
        if (this.bounds !== null) {
            var position = marker.getPosition();
            if (position) return this.bounds.contains(position);
        }
        return false;
    };
    Cluster.prototype.calculateBounds = function() {
        this.bounds = this.markerClusterer.getExtendedBounds(new google.maps.LatLngBounds(this.center, this.center));
    };
    Cluster.prototype.updateIcon = function() {
        var _a;
        var mCount = this.markers.length;
        var maxZoom = this.markerClusterer.getMaxZoom();
        var zoom = (_a = this.map) === null || _a === void 0 ? void 0 : _a.getZoom();
        if (maxZoom !== null && typeof zoom !== "undefined" && zoom > maxZoom) {
            this.clusterIcon.hide();
            return;
        }
        if (mCount < this.minClusterSize) {
            // Min cluster size not yet reached.
            this.clusterIcon.hide();
            return;
        }
        if (this.center) this.clusterIcon.setCenter(this.center);
        this.clusterIcon.useStyle(this.markerClusterer.getCalculator()(this.markers, this.markerClusterer.getStyles().length));
        this.clusterIcon.show();
    };
    Cluster.prototype.isMarkerAlreadyAdded = function(marker) {
        if (this.markers.includes) return this.markers.includes(marker);
        for(var i = 0; i < this.markers.length; i++){
            if (marker === this.markers[i]) return true;
        }
        return false;
    };
    return Cluster;
}();
/* global google */ /**
 * Supports up to 9007199254740991 (Number.MAX_SAFE_INTEGER) markers
 * which is not a problem as max array length is 4294967296 (2**32)
 */ function $de370fea0b9a0328$var$CALCULATOR(markers, numStyles) {
    var count = markers.length;
    var numberOfDigits = count.toString().length;
    var index = Math.min(numberOfDigits, numStyles);
    return {
        text: count.toString(),
        index: index,
        title: ""
    };
}
var $de370fea0b9a0328$var$BATCH_SIZE = 2000;
var $de370fea0b9a0328$var$BATCH_SIZE_IE = 500;
var $de370fea0b9a0328$var$IMAGE_PATH = "https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m";
var $de370fea0b9a0328$var$IMAGE_EXTENSION = "png";
var $de370fea0b9a0328$var$IMAGE_SIZES = [
    53,
    56,
    66,
    78,
    90
];
var $de370fea0b9a0328$var$CLUSTERER_CLASS = "cluster";
var $de370fea0b9a0328$var$Clusterer = /** @class */ function() {
    function Clusterer(map, optMarkers, optOptions) {
        if (optMarkers === void 0) optMarkers = [];
        if (optOptions === void 0) optOptions = {};
        this.getMinimumClusterSize = this.getMinimumClusterSize.bind(this);
        this.setMinimumClusterSize = this.setMinimumClusterSize.bind(this);
        this.getEnableRetinaIcons = this.getEnableRetinaIcons.bind(this);
        this.setEnableRetinaIcons = this.setEnableRetinaIcons.bind(this);
        this.addToClosestCluster = this.addToClosestCluster.bind(this);
        this.getImageExtension = this.getImageExtension.bind(this);
        this.setImageExtension = this.setImageExtension.bind(this);
        this.getExtendedBounds = this.getExtendedBounds.bind(this);
        this.getAverageCenter = this.getAverageCenter.bind(this);
        this.setAverageCenter = this.setAverageCenter.bind(this);
        this.getTotalClusters = this.getTotalClusters.bind(this);
        this.fitMapToMarkers = this.fitMapToMarkers.bind(this);
        this.getIgnoreHidden = this.getIgnoreHidden.bind(this);
        this.setIgnoreHidden = this.setIgnoreHidden.bind(this);
        this.getClusterClass = this.getClusterClass.bind(this);
        this.setClusterClass = this.setClusterClass.bind(this);
        this.getTotalMarkers = this.getTotalMarkers.bind(this);
        this.getZoomOnClick = this.getZoomOnClick.bind(this);
        this.setZoomOnClick = this.setZoomOnClick.bind(this);
        this.getBatchSizeIE = this.getBatchSizeIE.bind(this);
        this.setBatchSizeIE = this.setBatchSizeIE.bind(this);
        this.createClusters = this.createClusters.bind(this);
        this.onZoomChanged = this.onZoomChanged.bind(this);
        this.getImageSizes = this.getImageSizes.bind(this);
        this.setImageSizes = this.setImageSizes.bind(this);
        this.getCalculator = this.getCalculator.bind(this);
        this.setCalculator = this.setCalculator.bind(this);
        this.removeMarkers = this.removeMarkers.bind(this);
        this.resetViewport = this.resetViewport.bind(this);
        this.getImagePath = this.getImagePath.bind(this);
        this.setImagePath = this.setImagePath.bind(this);
        this.pushMarkerTo = this.pushMarkerTo.bind(this);
        this.removeMarker = this.removeMarker.bind(this);
        this.clearMarkers = this.clearMarkers.bind(this);
        this.setupStyles = this.setupStyles.bind(this);
        this.getGridSize = this.getGridSize.bind(this);
        this.setGridSize = this.setGridSize.bind(this);
        this.getClusters = this.getClusters.bind(this);
        this.getMaxZoom = this.getMaxZoom.bind(this);
        this.setMaxZoom = this.setMaxZoom.bind(this);
        this.getMarkers = this.getMarkers.bind(this);
        this.addMarkers = this.addMarkers.bind(this);
        this.getStyles = this.getStyles.bind(this);
        this.setStyles = this.setStyles.bind(this);
        this.addMarker = this.addMarker.bind(this);
        this.onRemove = this.onRemove.bind(this);
        this.getTitle = this.getTitle.bind(this);
        this.setTitle = this.setTitle.bind(this);
        this.repaint = this.repaint.bind(this);
        this.onIdle = this.onIdle.bind(this);
        this.redraw = this.redraw.bind(this);
        this.onAdd = this.onAdd.bind(this);
        this.draw = this.draw.bind(this);
        this.extend = this.extend.bind(this);
        this.extend(Clusterer, google.maps.OverlayView);
        this.markers = [];
        this.clusters = [];
        this.listeners = [];
        this.activeMap = null;
        this.ready = false;
        this.gridSize = optOptions.gridSize || 60;
        this.minClusterSize = optOptions.minimumClusterSize || 2;
        this.maxZoom = optOptions.maxZoom || null;
        this.styles = optOptions.styles || [];
        this.title = optOptions.title || "";
        this.zoomOnClick = true;
        if (optOptions.zoomOnClick !== undefined) this.zoomOnClick = optOptions.zoomOnClick;
        this.averageCenter = false;
        if (optOptions.averageCenter !== undefined) this.averageCenter = optOptions.averageCenter;
        this.ignoreHidden = false;
        if (optOptions.ignoreHidden !== undefined) this.ignoreHidden = optOptions.ignoreHidden;
        this.enableRetinaIcons = false;
        if (optOptions.enableRetinaIcons !== undefined) this.enableRetinaIcons = optOptions.enableRetinaIcons;
        this.imagePath = optOptions.imagePath || $de370fea0b9a0328$var$IMAGE_PATH;
        this.imageExtension = optOptions.imageExtension || $de370fea0b9a0328$var$IMAGE_EXTENSION;
        this.imageSizes = optOptions.imageSizes || $de370fea0b9a0328$var$IMAGE_SIZES;
        this.calculator = optOptions.calculator || $de370fea0b9a0328$var$CALCULATOR;
        this.batchSize = optOptions.batchSize || $de370fea0b9a0328$var$BATCH_SIZE;
        this.batchSizeIE = optOptions.batchSizeIE || $de370fea0b9a0328$var$BATCH_SIZE_IE;
        this.clusterClass = optOptions.clusterClass || $de370fea0b9a0328$var$CLUSTERER_CLASS;
        if (navigator.userAgent.toLowerCase().indexOf("msie") !== -1) // Try to avoid IE timeout when processing a huge number of markers:
        this.batchSize = this.batchSizeIE;
        this.timerRefStatic = null;
        this.setupStyles();
        this.addMarkers(optMarkers, true);
        this.setMap(map); // Note: this causes onAdd to be called
    }
    Clusterer.prototype.onZoomChanged = function() {
        var _a, _b;
        this.resetViewport(false);
        // Workaround for this Google bug: when map is at level 0 and "-" of
        // zoom slider is clicked, a "zoom_changed" event is fired even though
        // the map doesn't zoom out any further. In this situation, no "idle"
        // event is triggered so the cluster markers that have been removed
        // do not get redrawn. Same goes for a zoom in at maxZoom.
        if (((_a = this.getMap()) === null || _a === void 0 ? void 0 : _a.getZoom()) === (this.get("minZoom") || 0) || ((_b = this.getMap()) === null || _b === void 0 ? void 0 : _b.getZoom()) === this.get("maxZoom")) google.maps.event.trigger(this, "idle");
    };
    Clusterer.prototype.onIdle = function() {
        this.redraw();
    };
    Clusterer.prototype.onAdd = function() {
        var map = this.getMap();
        this.activeMap = map;
        this.ready = true;
        this.repaint();
        if (map !== null) // Add the map event listeners
        this.listeners = [
            google.maps.event.addListener(map, "zoom_changed", this.onZoomChanged),
            google.maps.event.addListener(map, "idle", this.onIdle)
        ];
    };
    Clusterer.prototype.onRemove = function() {
        // Put all the managed markers back on the map:
        for(var _i = 0, _a = this.markers; _i < _a.length; _i++){
            var marker = _a[_i];
            if (marker.getMap() !== this.activeMap) marker.setMap(this.activeMap);
        }
        // Remove all clusters:
        for(var _b = 0, _c = this.clusters; _b < _c.length; _b++){
            var cluster = _c[_b];
            cluster.remove();
        }
        this.clusters = [];
        // Remove map event listeners:
        for(var _d = 0, _e = this.listeners; _d < _e.length; _d++){
            var listener = _e[_d];
            google.maps.event.removeListener(listener);
        }
        this.listeners = [];
        this.activeMap = null;
        this.ready = false;
    };
    Clusterer.prototype.draw = function() {
        return;
    };
    Clusterer.prototype.getMap = function() {
        return null;
    };
    Clusterer.prototype.getPanes = function() {
        return null;
    };
    Clusterer.prototype.getProjection = function() {
        return {
            fromContainerPixelToLatLng: function() {
                return null;
            },
            fromDivPixelToLatLng: function() {
                return null;
            },
            fromLatLngToContainerPixel: function() {
                return null;
            },
            fromLatLngToDivPixel: function() {
                return null;
            },
            getVisibleRegion: function() {
                return null;
            },
            getWorldWidth: function() {
                return 0;
            }
        };
    };
    Clusterer.prototype.setMap = function() {
        return;
    };
    Clusterer.prototype.addListener = function() {
        return {
            remove: function() {
                return;
            }
        };
    };
    Clusterer.prototype.bindTo = function() {
        return;
    };
    Clusterer.prototype.get = function() {
        return;
    };
    Clusterer.prototype.notify = function() {
        return;
    };
    Clusterer.prototype.set = function() {
        return;
    };
    Clusterer.prototype.setValues = function() {
        return;
    };
    Clusterer.prototype.unbind = function() {
        return;
    };
    Clusterer.prototype.unbindAll = function() {
        return;
    };
    Clusterer.prototype.setupStyles = function() {
        if (this.styles.length > 0) return;
        for(var i = 0; i < this.imageSizes.length; i++)this.styles.push({
            url: "".concat(this.imagePath + (i + 1), ".").concat(this.imageExtension),
            height: this.imageSizes[i] || 0,
            width: this.imageSizes[i] || 0
        });
    };
    Clusterer.prototype.fitMapToMarkers = function() {
        var markers = this.getMarkers();
        var bounds = new google.maps.LatLngBounds();
        for(var _i = 0, markers_1 = markers; _i < markers_1.length; _i++){
            var marker = markers_1[_i];
            var position = marker.getPosition();
            if (position) bounds.extend(position);
        }
        var map = this.getMap();
        if (map !== null && "fitBounds" in map) map.fitBounds(bounds);
    };
    Clusterer.prototype.getGridSize = function() {
        return this.gridSize;
    };
    Clusterer.prototype.setGridSize = function(gridSize) {
        this.gridSize = gridSize;
    };
    Clusterer.prototype.getMinimumClusterSize = function() {
        return this.minClusterSize;
    };
    Clusterer.prototype.setMinimumClusterSize = function(minimumClusterSize) {
        this.minClusterSize = minimumClusterSize;
    };
    Clusterer.prototype.getMaxZoom = function() {
        return this.maxZoom;
    };
    Clusterer.prototype.setMaxZoom = function(maxZoom) {
        this.maxZoom = maxZoom;
    };
    Clusterer.prototype.getStyles = function() {
        return this.styles;
    };
    Clusterer.prototype.setStyles = function(styles) {
        this.styles = styles;
    };
    Clusterer.prototype.getTitle = function() {
        return this.title;
    };
    Clusterer.prototype.setTitle = function(title) {
        this.title = title;
    };
    Clusterer.prototype.getZoomOnClick = function() {
        return this.zoomOnClick;
    };
    Clusterer.prototype.setZoomOnClick = function(zoomOnClick) {
        this.zoomOnClick = zoomOnClick;
    };
    Clusterer.prototype.getAverageCenter = function() {
        return this.averageCenter;
    };
    Clusterer.prototype.setAverageCenter = function(averageCenter) {
        this.averageCenter = averageCenter;
    };
    Clusterer.prototype.getIgnoreHidden = function() {
        return this.ignoreHidden;
    };
    Clusterer.prototype.setIgnoreHidden = function(ignoreHidden) {
        this.ignoreHidden = ignoreHidden;
    };
    Clusterer.prototype.getEnableRetinaIcons = function() {
        return this.enableRetinaIcons;
    };
    Clusterer.prototype.setEnableRetinaIcons = function(enableRetinaIcons) {
        this.enableRetinaIcons = enableRetinaIcons;
    };
    Clusterer.prototype.getImageExtension = function() {
        return this.imageExtension;
    };
    Clusterer.prototype.setImageExtension = function(imageExtension) {
        this.imageExtension = imageExtension;
    };
    Clusterer.prototype.getImagePath = function() {
        return this.imagePath;
    };
    Clusterer.prototype.setImagePath = function(imagePath) {
        this.imagePath = imagePath;
    };
    Clusterer.prototype.getImageSizes = function() {
        return this.imageSizes;
    };
    Clusterer.prototype.setImageSizes = function(imageSizes) {
        this.imageSizes = imageSizes;
    };
    Clusterer.prototype.getCalculator = function() {
        return this.calculator;
    };
    Clusterer.prototype.setCalculator = function(calculator) {
        this.calculator = calculator;
    };
    Clusterer.prototype.getBatchSizeIE = function() {
        return this.batchSizeIE;
    };
    Clusterer.prototype.setBatchSizeIE = function(batchSizeIE) {
        this.batchSizeIE = batchSizeIE;
    };
    Clusterer.prototype.getClusterClass = function() {
        return this.clusterClass;
    };
    Clusterer.prototype.setClusterClass = function(clusterClass) {
        this.clusterClass = clusterClass;
    };
    Clusterer.prototype.getMarkers = function() {
        return this.markers;
    };
    Clusterer.prototype.getTotalMarkers = function() {
        return this.markers.length;
    };
    Clusterer.prototype.getClusters = function() {
        return this.clusters;
    };
    Clusterer.prototype.getTotalClusters = function() {
        return this.clusters.length;
    };
    Clusterer.prototype.addMarker = function(marker, optNoDraw) {
        this.pushMarkerTo(marker);
        if (!optNoDraw) this.redraw();
    };
    Clusterer.prototype.addMarkers = function(markers, optNoDraw) {
        for(var key in markers)if (Object.prototype.hasOwnProperty.call(markers, key)) {
            var marker = markers[key];
            if (marker) this.pushMarkerTo(marker);
        }
        if (!optNoDraw) this.redraw();
    };
    Clusterer.prototype.pushMarkerTo = function(marker) {
        var _this = this;
        // If the marker is draggable add a listener so we can update the clusters on the dragend:
        if (marker.getDraggable()) google.maps.event.addListener(marker, "dragend", function() {
            if (_this.ready) {
                marker.isAdded = false;
                _this.repaint();
            }
        });
        marker.isAdded = false;
        this.markers.push(marker);
    };
    Clusterer.prototype.removeMarker_ = function(marker) {
        var index = -1;
        if (this.markers.indexOf) index = this.markers.indexOf(marker);
        else {
            for(var i = 0; i < this.markers.length; i++)if (marker === this.markers[i]) {
                index = i;
                break;
            }
        }
        if (index === -1) // Marker is not in our list of markers, so do nothing:
        return false;
        marker.setMap(null);
        this.markers.splice(index, 1); // Remove the marker from the list of managed markers
        return true;
    };
    Clusterer.prototype.removeMarker = function(marker, optNoDraw) {
        var removed = this.removeMarker_(marker);
        if (!optNoDraw && removed) this.repaint();
        return removed;
    };
    Clusterer.prototype.removeMarkers = function(markers, optNoDraw) {
        var removed = false;
        for(var _i = 0, markers_2 = markers; _i < markers_2.length; _i++){
            var marker = markers_2[_i];
            removed = removed || this.removeMarker_(marker);
        }
        if (!optNoDraw && removed) this.repaint();
        return removed;
    };
    Clusterer.prototype.clearMarkers = function() {
        this.resetViewport(true);
        this.markers = [];
    };
    Clusterer.prototype.repaint = function() {
        var oldClusters = this.clusters.slice();
        this.clusters = [];
        this.resetViewport(false);
        this.redraw();
        // Remove the old clusters.
        // Do it in a timeout to prevent blinking effect.
        setTimeout(function timeout() {
            for(var _i = 0, oldClusters_1 = oldClusters; _i < oldClusters_1.length; _i++){
                var oldCluster = oldClusters_1[_i];
                oldCluster.remove();
            }
        }, 0);
    };
    Clusterer.prototype.getExtendedBounds = function(bounds) {
        var projection = this.getProjection();
        // Convert the points to pixels and the extend out by the grid size.
        var trPix = projection.fromLatLngToDivPixel(// Turn the bounds into latlng.
        new google.maps.LatLng(bounds.getNorthEast().lat(), bounds.getNorthEast().lng()));
        if (trPix !== null) {
            trPix.x += this.gridSize;
            trPix.y -= this.gridSize;
        }
        var blPix = projection.fromLatLngToDivPixel(// Turn the bounds into latlng.
        new google.maps.LatLng(bounds.getSouthWest().lat(), bounds.getSouthWest().lng()));
        if (blPix !== null) {
            blPix.x -= this.gridSize;
            blPix.y += this.gridSize;
        }
        // Extend the bounds to contain the new bounds.
        if (trPix !== null) {
            // Convert the pixel points back to LatLng nw
            var point1 = projection.fromDivPixelToLatLng(trPix);
            if (point1 !== null) bounds.extend(point1);
        }
        if (blPix !== null) {
            // Convert the pixel points back to LatLng sw
            var point2 = projection.fromDivPixelToLatLng(blPix);
            if (point2 !== null) bounds.extend(point2);
        }
        return bounds;
    };
    Clusterer.prototype.redraw = function() {
        // Redraws all the clusters.
        this.createClusters(0);
    };
    Clusterer.prototype.resetViewport = function(optHide) {
        // Remove all the clusters
        for(var _i = 0, _a = this.clusters; _i < _a.length; _i++){
            var cluster = _a[_i];
            cluster.remove();
        }
        this.clusters = [];
        // Reset the markers to not be added and to be removed from the map.
        for(var _b = 0, _c = this.markers; _b < _c.length; _b++){
            var marker = _c[_b];
            marker.isAdded = false;
            if (optHide) marker.setMap(null);
        }
    };
    Clusterer.prototype.distanceBetweenPoints = function(p1, p2) {
        var R = 6371; // Radius of the Earth in km
        var dLat = (p2.lat() - p1.lat()) * Math.PI / 180;
        var dLon = (p2.lng() - p1.lng()) * Math.PI / 180;
        var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(p1.lat() * Math.PI / 180) * Math.cos(p2.lat() * Math.PI / 180) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
        return R * (2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a)));
    };
    Clusterer.prototype.isMarkerInBounds = function(marker, bounds) {
        var position = marker.getPosition();
        if (position) return bounds.contains(position);
        return false;
    };
    Clusterer.prototype.addToClosestCluster = function(marker) {
        var cluster;
        var distance = 40000; // Some large number
        var clusterToAddTo = null;
        for(var _i = 0, _a = this.clusters; _i < _a.length; _i++){
            var clusterElement = _a[_i];
            cluster = clusterElement;
            var center = cluster.getCenter();
            var position = marker.getPosition();
            if (center && position) {
                var d = this.distanceBetweenPoints(center, position);
                if (d < distance) {
                    distance = d;
                    clusterToAddTo = cluster;
                }
            }
        }
        if (clusterToAddTo && clusterToAddTo.isMarkerInClusterBounds(marker)) clusterToAddTo.addMarker(marker);
        else {
            cluster = new $de370fea0b9a0328$var$Cluster$1(this);
            cluster.addMarker(marker);
            this.clusters.push(cluster);
        }
    };
    Clusterer.prototype.createClusters = function(iFirst) {
        var _this = this;
        if (!this.ready) return;
        // Cancel previous batch processing if we're working on the first batch:
        if (iFirst === 0) {
            /**
             * This event is fired when the <code>Clusterer</code> begins
             *  clustering markers.
             * @name Clusterer#clusteringbegin
             * @param {Clusterer} mc The Clusterer whose markers are being clustered.
             * @event
             */ google.maps.event.trigger(this, "clusteringbegin", this);
            if (this.timerRefStatic !== null) {
                window.clearTimeout(this.timerRefStatic);
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                delete this.timerRefStatic;
            }
        }
        var map = this.getMap();
        var bounds = map !== null && "getBounds" in map ? map.getBounds() : null;
        var zoom = (map === null || map === void 0 ? void 0 : map.getZoom()) || 0;
        // Get our current map view bounds.
        // Create a new bounds object so we don't affect the map.
        //
        // See Comments 9 & 11 on Issue 3651 relating to this workaround for a Google Maps bug:
        var mapBounds = zoom > 3 ? new google.maps.LatLngBounds(bounds === null || bounds === void 0 ? void 0 : bounds.getSouthWest(), bounds === null || bounds === void 0 ? void 0 : bounds.getNorthEast()) : new google.maps.LatLngBounds(new google.maps.LatLng(85.02070771743472, -178.48388434375), new google.maps.LatLng(-85.08136444384544, 178.00048865625));
        var extendedMapBounds = this.getExtendedBounds(mapBounds);
        var iLast = Math.min(iFirst + this.batchSize, this.markers.length);
        for(var i = iFirst; i < iLast; i++){
            var marker = this.markers[i];
            if (marker && !marker.isAdded && this.isMarkerInBounds(marker, extendedMapBounds) && (!this.ignoreHidden || this.ignoreHidden && marker.getVisible())) this.addToClosestCluster(marker);
        }
        if (iLast < this.markers.length) this.timerRefStatic = window.setTimeout(function() {
            _this.createClusters(iLast);
        }, 0);
        else {
            this.timerRefStatic = null;
            /**
             * This event is fired when the <code>Clusterer</code> stops
             *  clustering markers.
             * @name Clusterer#clusteringend
             * @param {Clusterer} mc The Clusterer whose markers are being clustered.
             * @event
             */ google.maps.event.trigger(this, "clusteringend", this);
            for(var _i = 0, _a = this.clusters; _i < _a.length; _i++){
                var cluster = _a[_i];
                cluster.updateIcon();
            }
        }
    };
    Clusterer.prototype.extend = function(obj1, obj2) {
        return (function applyExtend(object) {
            for(var property in object.prototype){
                // eslint-disable-next-line @typescript-eslint/ban-types
                var prop = property;
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                this.prototype[prop] = object.prototype[prop];
            }
            return this;
        }).apply(obj1, [
            obj2
        ]);
    };
    return Clusterer;
}();
var $de370fea0b9a0328$var$eventMap$e = {
    onClick: "click",
    onClusteringBegin: "clusteringbegin",
    onClusteringEnd: "clusteringend",
    onMouseOut: "mouseout",
    onMouseOver: "mouseover"
};
var $de370fea0b9a0328$var$updaterMap$e = {
    averageCenter: function(instance, averageCenter) {
        instance.setAverageCenter(averageCenter);
    },
    batchSizeIE: function(instance, batchSizeIE) {
        instance.setBatchSizeIE(batchSizeIE);
    },
    calculator: function(instance, calculator) {
        instance.setCalculator(calculator);
    },
    clusterClass: function(instance, clusterClass) {
        instance.setClusterClass(clusterClass);
    },
    enableRetinaIcons: function(instance, enableRetinaIcons) {
        instance.setEnableRetinaIcons(enableRetinaIcons);
    },
    gridSize: function(instance, gridSize) {
        instance.setGridSize(gridSize);
    },
    ignoreHidden: function(instance, ignoreHidden) {
        instance.setIgnoreHidden(ignoreHidden);
    },
    imageExtension: function(instance, imageExtension) {
        instance.setImageExtension(imageExtension);
    },
    imagePath: function(instance, imagePath) {
        instance.setImagePath(imagePath);
    },
    imageSizes: function(instance, imageSizes) {
        instance.setImageSizes(imageSizes);
    },
    maxZoom: function(instance, maxZoom) {
        instance.setMaxZoom(maxZoom);
    },
    minimumClusterSize: function(instance, minimumClusterSize) {
        instance.setMinimumClusterSize(minimumClusterSize);
    },
    styles: function(instance, styles) {
        instance.setStyles(styles);
    },
    title: function(instance, title) {
        instance.setTitle(title);
    },
    zoomOnClick: function(instance, zoomOnClick) {
        instance.setZoomOnClick(zoomOnClick);
    }
};
var $de370fea0b9a0328$var$defaultOptions$4 = {};
function $de370fea0b9a0328$var$MarkerClustererFunctional(props) {
    var children = props.children, options = props.options, averageCenter = props.averageCenter, batchSizeIE = props.batchSizeIE, calculator = props.calculator, clusterClass = props.clusterClass, enableRetinaIcons = props.enableRetinaIcons, gridSize = props.gridSize, ignoreHidden = props.ignoreHidden, imageExtension = props.imageExtension, imagePath = props.imagePath, imageSizes = props.imageSizes, maxZoom = props.maxZoom, minimumClusterSize = props.minimumClusterSize, styles = props.styles, title = props.title, zoomOnClick = props.zoomOnClick, onClick = props.onClick, onClusteringBegin = props.onClusteringBegin, onClusteringEnd = props.onClusteringEnd, onMouseOver = props.onMouseOver, onMouseOut = props.onMouseOut, onLoad = props.onLoad, onUnmount = props.onUnmount;
    var _a = (0, $b6HlZ.useState)(null), instance = _a[0], setInstance = _a[1];
    var map = (0, $b6HlZ.useContext)($de370fea0b9a0328$export$dc7344301ae78f85);
    var _b = (0, $b6HlZ.useState)(null), clickListener = _b[0], setClickListener = _b[1];
    var _c = (0, $b6HlZ.useState)(null), clusteringBeginListener = _c[0], setClusteringBeginListener = _c[1];
    var _d = (0, $b6HlZ.useState)(null), clusteringEndListener = _d[0], setClusteringEndListener = _d[1];
    var _e = (0, $b6HlZ.useState)(null), mouseoutListener = _e[0], setMouseoutListener = _e[1];
    var _f = (0, $b6HlZ.useState)(null), mouseoverListener = _f[0], setMouseoverListener = _f[1];
    (0, $b6HlZ.useEffect)(function() {
        if (instance && onMouseOut) {
            if (mouseoutListener !== null) google.maps.event.removeListener(mouseoutListener);
            setMouseoutListener(google.maps.event.addListener(instance, $de370fea0b9a0328$var$eventMap$e.onMouseOut, onMouseOut));
        }
    }, [
        onMouseOut
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (instance && onMouseOver) {
            if (mouseoverListener !== null) google.maps.event.removeListener(mouseoverListener);
            setMouseoverListener(google.maps.event.addListener(instance, $de370fea0b9a0328$var$eventMap$e.onMouseOver, onMouseOver));
        }
    }, [
        onMouseOver
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (instance && onClick) {
            if (clickListener !== null) google.maps.event.removeListener(clickListener);
            setClickListener(google.maps.event.addListener(instance, $de370fea0b9a0328$var$eventMap$e.onClick, onClick));
        }
    }, [
        onClick
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (instance && onClusteringBegin) {
            if (clusteringBeginListener !== null) google.maps.event.removeListener(clusteringBeginListener);
            setClusteringBeginListener(google.maps.event.addListener(instance, $de370fea0b9a0328$var$eventMap$e.onClusteringBegin, onClusteringBegin));
        }
    }, [
        onClusteringBegin
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (instance && onClusteringEnd) {
            if (clusteringEndListener !== null) google.maps.event.removeListener(clusteringEndListener);
            setClusteringBeginListener(google.maps.event.addListener(instance, $de370fea0b9a0328$var$eventMap$e.onClusteringEnd, onClusteringEnd));
        }
    }, [
        onClusteringEnd
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (typeof averageCenter !== "undefined" && instance !== null) $de370fea0b9a0328$var$updaterMap$e.averageCenter(instance, averageCenter);
    }, [
        instance,
        averageCenter
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (typeof batchSizeIE !== "undefined" && instance !== null) $de370fea0b9a0328$var$updaterMap$e.batchSizeIE(instance, batchSizeIE);
    }, [
        instance,
        batchSizeIE
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (typeof calculator !== "undefined" && instance !== null) $de370fea0b9a0328$var$updaterMap$e.calculator(instance, calculator);
    }, [
        instance,
        calculator
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (typeof clusterClass !== "undefined" && instance !== null) $de370fea0b9a0328$var$updaterMap$e.clusterClass(instance, clusterClass);
    }, [
        instance,
        clusterClass
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (typeof enableRetinaIcons !== "undefined" && instance !== null) $de370fea0b9a0328$var$updaterMap$e.enableRetinaIcons(instance, enableRetinaIcons);
    }, [
        instance,
        enableRetinaIcons
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (typeof gridSize !== "undefined" && instance !== null) $de370fea0b9a0328$var$updaterMap$e.gridSize(instance, gridSize);
    }, [
        instance,
        gridSize
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (typeof ignoreHidden !== "undefined" && instance !== null) $de370fea0b9a0328$var$updaterMap$e.ignoreHidden(instance, ignoreHidden);
    }, [
        instance,
        ignoreHidden
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (typeof imageExtension !== "undefined" && instance !== null) $de370fea0b9a0328$var$updaterMap$e.imageExtension(instance, imageExtension);
    }, [
        instance,
        imageExtension
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (typeof imagePath !== "undefined" && instance !== null) $de370fea0b9a0328$var$updaterMap$e.imagePath(instance, imagePath);
    }, [
        instance,
        imagePath
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (typeof imageSizes !== "undefined" && instance !== null) $de370fea0b9a0328$var$updaterMap$e.imageSizes(instance, imageSizes);
    }, [
        instance,
        imageSizes
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (typeof maxZoom !== "undefined" && instance !== null) $de370fea0b9a0328$var$updaterMap$e.maxZoom(instance, maxZoom);
    }, [
        instance,
        maxZoom
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (typeof minimumClusterSize !== "undefined" && instance !== null) $de370fea0b9a0328$var$updaterMap$e.minimumClusterSize(instance, minimumClusterSize);
    }, [
        instance,
        minimumClusterSize
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (typeof styles !== "undefined" && instance !== null) $de370fea0b9a0328$var$updaterMap$e.styles(instance, styles);
    }, [
        instance,
        styles
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (typeof title !== "undefined" && instance !== null) $de370fea0b9a0328$var$updaterMap$e.title(instance, title);
    }, [
        instance,
        title
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (typeof zoomOnClick !== "undefined" && instance !== null) $de370fea0b9a0328$var$updaterMap$e.zoomOnClick(instance, zoomOnClick);
    }, [
        instance,
        zoomOnClick
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (!map) return;
        var clustererOptions = $de370fea0b9a0328$var$__assign({}, options || $de370fea0b9a0328$var$defaultOptions$4);
        var clusterer = new $de370fea0b9a0328$var$Clusterer(map, [], clustererOptions);
        if (averageCenter) $de370fea0b9a0328$var$updaterMap$e.averageCenter(clusterer, averageCenter);
        if (batchSizeIE) $de370fea0b9a0328$var$updaterMap$e.batchSizeIE(clusterer, batchSizeIE);
        if (calculator) $de370fea0b9a0328$var$updaterMap$e.calculator(clusterer, calculator);
        if (clusterClass) $de370fea0b9a0328$var$updaterMap$e.clusterClass(clusterer, clusterClass);
        if (enableRetinaIcons) $de370fea0b9a0328$var$updaterMap$e.enableRetinaIcons(clusterer, enableRetinaIcons);
        if (gridSize) $de370fea0b9a0328$var$updaterMap$e.gridSize(clusterer, gridSize);
        if (ignoreHidden) $de370fea0b9a0328$var$updaterMap$e.ignoreHidden(clusterer, ignoreHidden);
        if (imageExtension) $de370fea0b9a0328$var$updaterMap$e.imageExtension(clusterer, imageExtension);
        if (imagePath) $de370fea0b9a0328$var$updaterMap$e.imagePath(clusterer, imagePath);
        if (imageSizes) $de370fea0b9a0328$var$updaterMap$e.imageSizes(clusterer, imageSizes);
        if (maxZoom) $de370fea0b9a0328$var$updaterMap$e.maxZoom(clusterer, maxZoom);
        if (minimumClusterSize) $de370fea0b9a0328$var$updaterMap$e.minimumClusterSize(clusterer, minimumClusterSize);
        if (styles) $de370fea0b9a0328$var$updaterMap$e.styles(clusterer, styles);
        if (title) $de370fea0b9a0328$var$updaterMap$e.title(clusterer, title);
        if (zoomOnClick) $de370fea0b9a0328$var$updaterMap$e.zoomOnClick(clusterer, zoomOnClick);
        if (onMouseOut) setMouseoutListener(google.maps.event.addListener(clusterer, $de370fea0b9a0328$var$eventMap$e.onMouseOut, onMouseOut));
        if (onMouseOver) setMouseoverListener(google.maps.event.addListener(clusterer, $de370fea0b9a0328$var$eventMap$e.onMouseOver, onMouseOver));
        if (onClick) setClickListener(google.maps.event.addListener(clusterer, $de370fea0b9a0328$var$eventMap$e.onClick, onClick));
        if (onClusteringBegin) setClusteringBeginListener(google.maps.event.addListener(clusterer, $de370fea0b9a0328$var$eventMap$e.onClusteringBegin, onClusteringBegin));
        if (onClusteringEnd) setClusteringEndListener(google.maps.event.addListener(clusterer, $de370fea0b9a0328$var$eventMap$e.onClusteringEnd, onClusteringEnd));
        setInstance(clusterer);
        if (onLoad) onLoad(clusterer);
        return function() {
            if (mouseoutListener !== null) google.maps.event.removeListener(mouseoutListener);
            if (mouseoverListener !== null) google.maps.event.removeListener(mouseoverListener);
            if (clickListener !== null) google.maps.event.removeListener(clickListener);
            if (clusteringBeginListener !== null) google.maps.event.removeListener(clusteringBeginListener);
            if (clusteringEndListener !== null) google.maps.event.removeListener(clusteringEndListener);
            if (onUnmount) onUnmount(clusterer);
        };
    }, []);
    return instance !== null ? children(instance) || null : null;
}
var $de370fea0b9a0328$export$1b336c0de6a39582 = (0, $b6HlZ.memo)($de370fea0b9a0328$var$MarkerClustererFunctional);
var $de370fea0b9a0328$export$58bd9bb9fcf3dd4f = /** @class */ function(_super) {
    $de370fea0b9a0328$var$__extends(ClustererComponent, _super);
    function ClustererComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.registeredEvents = [];
        _this.state = {
            markerClusterer: null
        };
        _this.setClustererCallback = function() {
            if (_this.state.markerClusterer !== null && _this.props.onLoad) _this.props.onLoad(_this.state.markerClusterer);
        };
        return _this;
    }
    ClustererComponent.prototype.componentDidMount = function() {
        if (this.context) {
            var markerClusterer_1 = new $de370fea0b9a0328$var$Clusterer(this.context, [], this.props.options);
            this.registeredEvents = $de370fea0b9a0328$var$applyUpdatersToPropsAndRegisterEvents({
                updaterMap: $de370fea0b9a0328$var$updaterMap$e,
                eventMap: $de370fea0b9a0328$var$eventMap$e,
                prevProps: {},
                nextProps: this.props,
                instance: markerClusterer_1
            });
            this.setState(function() {
                return {
                    markerClusterer: markerClusterer_1
                };
            }, this.setClustererCallback);
        }
    };
    ClustererComponent.prototype.componentDidUpdate = function(prevProps) {
        if (this.state.markerClusterer) {
            $de370fea0b9a0328$var$unregisterEvents(this.registeredEvents);
            this.registeredEvents = $de370fea0b9a0328$var$applyUpdatersToPropsAndRegisterEvents({
                updaterMap: $de370fea0b9a0328$var$updaterMap$e,
                eventMap: $de370fea0b9a0328$var$eventMap$e,
                prevProps: prevProps,
                nextProps: this.props,
                instance: this.state.markerClusterer
            });
        }
    };
    ClustererComponent.prototype.componentWillUnmount = function() {
        if (this.state.markerClusterer !== null) {
            if (this.props.onUnmount) this.props.onUnmount(this.state.markerClusterer);
            $de370fea0b9a0328$var$unregisterEvents(this.registeredEvents);
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            this.state.markerClusterer.setMap(null);
        }
    };
    ClustererComponent.prototype.render = function() {
        return this.state.markerClusterer !== null ? this.props.children(this.state.markerClusterer) : null;
    };
    ClustererComponent.contextType = $de370fea0b9a0328$export$dc7344301ae78f85;
    return ClustererComponent;
}((0, $b6HlZ.PureComponent));
// This handler prevents an event in the InfoBox from being passed on to the map.
function $de370fea0b9a0328$var$cancelHandler(event) {
    event.cancelBubble = true;
    if (event.stopPropagation) event.stopPropagation();
}
var $de370fea0b9a0328$var$InfoBox = /** @class */ function() {
    function InfoBox(options) {
        if (options === void 0) options = {};
        this.getCloseClickHandler = this.getCloseClickHandler.bind(this);
        this.closeClickHandler = this.closeClickHandler.bind(this);
        this.createInfoBoxDiv = this.createInfoBoxDiv.bind(this);
        this.addClickHandler = this.addClickHandler.bind(this);
        this.getCloseBoxImg = this.getCloseBoxImg.bind(this);
        this.getBoxWidths = this.getBoxWidths.bind(this);
        this.setBoxStyle = this.setBoxStyle.bind(this);
        this.setPosition = this.setPosition.bind(this);
        this.getPosition = this.getPosition.bind(this);
        this.setOptions = this.setOptions.bind(this);
        this.setContent = this.setContent.bind(this);
        this.setVisible = this.setVisible.bind(this);
        this.getContent = this.getContent.bind(this);
        this.getVisible = this.getVisible.bind(this);
        this.setZIndex = this.setZIndex.bind(this);
        this.getZIndex = this.getZIndex.bind(this);
        this.onRemove = this.onRemove.bind(this);
        this.panBox = this.panBox.bind(this);
        this.extend = this.extend.bind(this);
        this.close = this.close.bind(this);
        this.draw = this.draw.bind(this);
        this.show = this.show.bind(this);
        this.hide = this.hide.bind(this);
        this.open = this.open.bind(this);
        this.extend(InfoBox, google.maps.OverlayView);
        // Standard options (in common with google.maps.InfoWindow):
        this.content = options.content || "";
        this.disableAutoPan = options.disableAutoPan || false;
        this.maxWidth = options.maxWidth || 0;
        this.pixelOffset = options.pixelOffset || new google.maps.Size(0, 0);
        this.position = options.position || new google.maps.LatLng(0, 0);
        this.zIndex = options.zIndex || null;
        // Additional options (unique to InfoBox):
        this.boxClass = options.boxClass || "infoBox";
        this.boxStyle = options.boxStyle || {};
        this.closeBoxMargin = options.closeBoxMargin || "2px";
        this.closeBoxURL = options.closeBoxURL || "http://www.google.com/intl/en_us/mapfiles/close.gif";
        if (options.closeBoxURL === "") this.closeBoxURL = "";
        this.infoBoxClearance = options.infoBoxClearance || new google.maps.Size(1, 1);
        if (typeof options.visible === "undefined") {
            if (typeof options.isHidden === "undefined") options.visible = true;
            else options.visible = !options.isHidden;
        }
        this.isHidden = !options.visible;
        this.alignBottom = options.alignBottom || false;
        this.pane = options.pane || "floatPane";
        this.enableEventPropagation = options.enableEventPropagation || false;
        this.div = null;
        this.closeListener = null;
        this.moveListener = null;
        this.mapListener = null;
        this.contextListener = null;
        this.eventListeners = null;
        this.fixedWidthSet = null;
    }
    InfoBox.prototype.createInfoBoxDiv = function() {
        var _this = this;
        // This handler ignores the current event in the InfoBox and conditionally prevents
        // the event from being passed on to the map. It is used for the contextmenu event.
        var ignoreHandler = function(event) {
            event.returnValue = false;
            if (event.preventDefault) event.preventDefault();
            if (!_this.enableEventPropagation) $de370fea0b9a0328$var$cancelHandler(event);
        };
        if (!this.div) {
            this.div = document.createElement("div");
            this.setBoxStyle();
            if (typeof this.content === "string") this.div.innerHTML = this.getCloseBoxImg() + this.content;
            else {
                this.div.innerHTML = this.getCloseBoxImg();
                this.div.appendChild(this.content);
            }
            var panes = this.getPanes();
            if (panes !== null) panes[this.pane].appendChild(this.div); // Add the InfoBox div to the DOM
            this.addClickHandler();
            if (this.div.style.width) this.fixedWidthSet = true;
            else if (this.maxWidth !== 0 && this.div.offsetWidth > this.maxWidth) {
                this.div.style.width = this.maxWidth + "px";
                this.fixedWidthSet = true;
            } else {
                // The following code is needed to overcome problems with MSIE
                var bw = this.getBoxWidths();
                this.div.style.width = this.div.offsetWidth - bw.left - bw.right + "px";
                this.fixedWidthSet = false;
            }
            this.panBox(this.disableAutoPan);
            if (!this.enableEventPropagation) {
                this.eventListeners = [];
                // Cancel event propagation.
                // Note: mousemove not included (to resolve Issue 152)
                var events = [
                    "mousedown",
                    "mouseover",
                    "mouseout",
                    "mouseup",
                    "click",
                    "dblclick",
                    "touchstart",
                    "touchend",
                    "touchmove"
                ];
                for(var _i = 0, events_1 = events; _i < events_1.length; _i++){
                    var event_1 = events_1[_i];
                    this.eventListeners.push(google.maps.event.addListener(this.div, event_1, $de370fea0b9a0328$var$cancelHandler));
                }
                // Workaround for Google bug that causes the cursor to change to a pointer
                // when the mouse moves over a marker underneath InfoBox.
                this.eventListeners.push(google.maps.event.addListener(this.div, "mouseover", function() {
                    if (_this.div) _this.div.style.cursor = "default";
                }));
            }
            this.contextListener = google.maps.event.addListener(this.div, "contextmenu", ignoreHandler);
            /**
             * This event is fired when the DIV containing the InfoBox's content is attached to the DOM.
             * @name InfoBox#domready
             * @event
             */ google.maps.event.trigger(this, "domready");
        }
    };
    InfoBox.prototype.getCloseBoxImg = function() {
        var img = "";
        if (this.closeBoxURL !== "") {
            img = '<img alt=""';
            img += ' aria-hidden="true"';
            img += " src='" + this.closeBoxURL + "'";
            img += " align=right"; // Do this because Opera chokes on style='float: right;'
            img += " style='";
            img += " position: relative;"; // Required by MSIE
            img += " cursor: pointer;";
            img += " margin: " + this.closeBoxMargin + ";";
            img += "'>";
        }
        return img;
    };
    InfoBox.prototype.addClickHandler = function() {
        this.closeListener = this.div && this.div.firstChild && this.closeBoxURL !== "" ? google.maps.event.addListener(this.div.firstChild, "click", this.getCloseClickHandler()) : null;
    };
    InfoBox.prototype.closeClickHandler = function(event) {
        // 1.0.3 fix: Always prevent propagation of a close box click to the map:
        event.cancelBubble = true;
        if (event.stopPropagation) event.stopPropagation();
        /**
         * This event is fired when the InfoBox's close box is clicked.
         * @name InfoBox#closeclick
         * @event
         */ google.maps.event.trigger(this, "closeclick");
        this.close();
    };
    InfoBox.prototype.getCloseClickHandler = function() {
        return this.closeClickHandler;
    };
    InfoBox.prototype.panBox = function(disablePan) {
        if (this.div && !disablePan) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            var map = this.getMap();
            // Only pan if attached to map, not panorama
            if (map instanceof google.maps.Map) {
                var xOffset = 0;
                var yOffset = 0;
                var bounds = map.getBounds();
                if (bounds && !bounds.contains(this.position)) // Marker not in visible area of map, so set center
                // of map to the marker position first.
                map.setCenter(this.position);
                var mapDiv = map.getDiv();
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                var mapWidth = mapDiv.offsetWidth;
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                var mapHeight = mapDiv.offsetHeight;
                var iwOffsetX = this.pixelOffset.width;
                var iwOffsetY = this.pixelOffset.height;
                var iwWidth = this.div.offsetWidth;
                var iwHeight = this.div.offsetHeight;
                var padX = this.infoBoxClearance.width;
                var padY = this.infoBoxClearance.height;
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                var projection = this.getProjection();
                var pixPosition = projection.fromLatLngToContainerPixel(this.position);
                if (pixPosition !== null) {
                    if (pixPosition.x < -iwOffsetX + padX) xOffset = pixPosition.x + iwOffsetX - padX;
                    else if (pixPosition.x + iwWidth + iwOffsetX + padX > mapWidth) xOffset = pixPosition.x + iwWidth + iwOffsetX + padX - mapWidth;
                    if (this.alignBottom) {
                        if (pixPosition.y < -iwOffsetY + padY + iwHeight) yOffset = pixPosition.y + iwOffsetY - padY - iwHeight;
                        else if (pixPosition.y + iwOffsetY + padY > mapHeight) yOffset = pixPosition.y + iwOffsetY + padY - mapHeight;
                    } else {
                        if (pixPosition.y < -iwOffsetY + padY) yOffset = pixPosition.y + iwOffsetY - padY;
                        else if (pixPosition.y + iwHeight + iwOffsetY + padY > mapHeight) yOffset = pixPosition.y + iwHeight + iwOffsetY + padY - mapHeight;
                    }
                }
                if (!(xOffset === 0 && yOffset === 0)) // Move the map to the shifted center.
                map.panBy(xOffset, yOffset);
            }
        }
    };
    InfoBox.prototype.setBoxStyle = function() {
        if (this.div) {
            // Apply style values from the style sheet defined in the boxClass parameter:
            this.div.className = this.boxClass;
            // Clear existing inline style values:
            this.div.style.cssText = "";
            // Apply style values defined in the boxStyle parameter:
            var boxStyle = this.boxStyle;
            for(var i in boxStyle)if (Object.prototype.hasOwnProperty.call(boxStyle, i)) // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            this.div.style[i] = boxStyle[i];
            // Fix for iOS disappearing InfoBox problem
            // See http://stackoverflow.com/questions/9229535/google-maps-markers-disappear-at-certain-zoom-level-only-on-iphone-ipad
            this.div.style.webkitTransform = "translateZ(0)";
            // Fix up opacity style for benefit of MSIE
            if (typeof this.div.style.opacity !== "undefined" && this.div.style.opacity !== "") {
                // See http://www.quirksmode.org/css/opacity.html
                var opacity = parseFloat(this.div.style.opacity || "");
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                this.div.style.msFilter = '"progid:DXImageTransform.Microsoft.Alpha(Opacity=' + opacity * 100 + ')"';
                this.div.style.filter = "alpha(opacity=" + opacity * 100 + ")";
            }
            // Apply required styles
            this.div.style.position = "absolute";
            this.div.style.visibility = "hidden";
            if (this.zIndex !== null) this.div.style.zIndex = this.zIndex + "";
            if (!this.div.style.overflow) this.div.style.overflow = "auto";
        }
    };
    InfoBox.prototype.getBoxWidths = function() {
        var bw = {
            top: 0,
            bottom: 0,
            left: 0,
            right: 0
        };
        if (!this.div) return bw;
        if (document.defaultView) {
            var ownerDocument = this.div.ownerDocument;
            var computedStyle = ownerDocument && ownerDocument.defaultView ? ownerDocument.defaultView.getComputedStyle(this.div, "") : null;
            if (computedStyle) {
                // The computed styles are always in pixel units (good!)
                bw.top = parseInt(computedStyle.borderTopWidth || "", 10) || 0;
                bw.bottom = parseInt(computedStyle.borderBottomWidth || "", 10) || 0;
                bw.left = parseInt(computedStyle.borderLeftWidth || "", 10) || 0;
                bw.right = parseInt(computedStyle.borderRightWidth || "", 10) || 0;
            }
        } else if (// eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        document.documentElement.currentStyle // MSIE
        ) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            var currentStyle = this.div.currentStyle;
            if (currentStyle) {
                // The current styles may not be in pixel units, but assume they are (bad!)
                bw.top = parseInt(currentStyle.borderTopWidth || "", 10) || 0;
                bw.bottom = parseInt(currentStyle.borderBottomWidth || "", 10) || 0;
                bw.left = parseInt(currentStyle.borderLeftWidth || "", 10) || 0;
                bw.right = parseInt(currentStyle.borderRightWidth || "", 10) || 0;
            }
        }
        return bw;
    };
    InfoBox.prototype.onRemove = function() {
        if (this.div && this.div.parentNode) {
            this.div.parentNode.removeChild(this.div);
            this.div = null;
        }
    };
    InfoBox.prototype.draw = function() {
        this.createInfoBoxDiv();
        if (this.div) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            var projection = this.getProjection();
            var pixPosition = projection.fromLatLngToDivPixel(this.position);
            if (pixPosition !== null) {
                this.div.style.left = pixPosition.x + this.pixelOffset.width + "px";
                if (this.alignBottom) this.div.style.bottom = -(pixPosition.y + this.pixelOffset.height) + "px";
                else this.div.style.top = pixPosition.y + this.pixelOffset.height + "px";
            }
            if (this.isHidden) this.div.style.visibility = "hidden";
            else this.div.style.visibility = "visible";
        }
    };
    InfoBox.prototype.setOptions = function(options) {
        if (options === void 0) options = {};
        if (typeof options.boxClass !== "undefined") {
            // Must be first
            this.boxClass = options.boxClass;
            this.setBoxStyle();
        }
        if (typeof options.boxStyle !== "undefined") {
            // Must be second
            this.boxStyle = options.boxStyle;
            this.setBoxStyle();
        }
        if (typeof options.content !== "undefined") this.setContent(options.content);
        if (typeof options.disableAutoPan !== "undefined") this.disableAutoPan = options.disableAutoPan;
        if (typeof options.maxWidth !== "undefined") this.maxWidth = options.maxWidth;
        if (typeof options.pixelOffset !== "undefined") this.pixelOffset = options.pixelOffset;
        if (typeof options.alignBottom !== "undefined") this.alignBottom = options.alignBottom;
        if (typeof options.position !== "undefined") this.setPosition(options.position);
        if (typeof options.zIndex !== "undefined") this.setZIndex(options.zIndex);
        if (typeof options.closeBoxMargin !== "undefined") this.closeBoxMargin = options.closeBoxMargin;
        if (typeof options.closeBoxURL !== "undefined") this.closeBoxURL = options.closeBoxURL;
        if (typeof options.infoBoxClearance !== "undefined") this.infoBoxClearance = options.infoBoxClearance;
        if (typeof options.isHidden !== "undefined") this.isHidden = options.isHidden;
        if (typeof options.visible !== "undefined") this.isHidden = !options.visible;
        if (typeof options.enableEventPropagation !== "undefined") this.enableEventPropagation = options.enableEventPropagation;
        if (this.div) this.draw();
    };
    InfoBox.prototype.setContent = function(content) {
        this.content = content;
        if (this.div) {
            if (this.closeListener) {
                google.maps.event.removeListener(this.closeListener);
                this.closeListener = null;
            }
            // Odd code required to make things work with MSIE.
            if (!this.fixedWidthSet) this.div.style.width = "";
            if (typeof content === "string") this.div.innerHTML = this.getCloseBoxImg() + content;
            else {
                this.div.innerHTML = this.getCloseBoxImg();
                this.div.appendChild(content);
            }
            // Perverse code required to make things work with MSIE.
            // (Ensures the close box does, in fact, float to the right.)
            if (!this.fixedWidthSet) {
                this.div.style.width = this.div.offsetWidth + "px";
                if (typeof content === "string") this.div.innerHTML = this.getCloseBoxImg() + content;
                else {
                    this.div.innerHTML = this.getCloseBoxImg();
                    this.div.appendChild(content);
                }
            }
            this.addClickHandler();
        }
        /**
         * This event is fired when the content of the InfoBox changes.
         * @name InfoBox#content_changed
         * @event
         */ google.maps.event.trigger(this, "content_changed");
    };
    InfoBox.prototype.setPosition = function(latLng) {
        this.position = latLng;
        if (this.div) this.draw();
        /**
         * This event is fired when the position of the InfoBox changes.
         * @name InfoBox#position_changed
         * @event
         */ google.maps.event.trigger(this, "position_changed");
    };
    InfoBox.prototype.setVisible = function(isVisible) {
        this.isHidden = !isVisible;
        if (this.div) this.div.style.visibility = this.isHidden ? "hidden" : "visible";
    };
    InfoBox.prototype.setZIndex = function(index) {
        this.zIndex = index;
        if (this.div) this.div.style.zIndex = index + "";
        /**
         * This event is fired when the zIndex of the InfoBox changes.
         * @name InfoBox#zindex_changed
         * @event
         */ google.maps.event.trigger(this, "zindex_changed");
    };
    InfoBox.prototype.getContent = function() {
        return this.content;
    };
    InfoBox.prototype.getPosition = function() {
        return this.position;
    };
    InfoBox.prototype.getZIndex = function() {
        return this.zIndex;
    };
    InfoBox.prototype.getVisible = function() {
        var map = this.getMap();
        return typeof map === "undefined" || map === null ? false : !this.isHidden;
    };
    InfoBox.prototype.show = function() {
        this.isHidden = false;
        if (this.div) this.div.style.visibility = "visible";
    };
    InfoBox.prototype.hide = function() {
        this.isHidden = true;
        if (this.div) this.div.style.visibility = "hidden";
    };
    InfoBox.prototype.open = function(map, anchor) {
        var _this = this;
        if (anchor) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            this.position = anchor.getPosition();
            this.moveListener = google.maps.event.addListener(anchor, "position_changed", function() {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                var position = anchor.getPosition();
                _this.setPosition(position);
            });
            this.mapListener = google.maps.event.addListener(anchor, "map_changed", function() {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                _this.setMap(anchor.map);
            });
        }
        this.setMap(map);
        if (this.div) this.panBox();
    };
    InfoBox.prototype.close = function() {
        if (this.closeListener) {
            google.maps.event.removeListener(this.closeListener);
            this.closeListener = null;
        }
        if (this.eventListeners) {
            for(var _i = 0, _a = this.eventListeners; _i < _a.length; _i++){
                var eventListener = _a[_i];
                google.maps.event.removeListener(eventListener);
            }
            this.eventListeners = null;
        }
        if (this.moveListener) {
            google.maps.event.removeListener(this.moveListener);
            this.moveListener = null;
        }
        if (this.mapListener) {
            google.maps.event.removeListener(this.mapListener);
            this.mapListener = null;
        }
        if (this.contextListener) {
            google.maps.event.removeListener(this.contextListener);
            this.contextListener = null;
        }
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        this.setMap(null);
    };
    InfoBox.prototype.extend = function(obj1, obj2) {
        return (function applyExtend(object) {
            for(var property in object.prototype)if (!Object.prototype.hasOwnProperty.call(this, property)) // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            this.prototype[property] = object.prototype[property];
            return this;
        }).apply(obj1, [
            obj2
        ]);
    };
    return InfoBox;
}();
var $de370fea0b9a0328$var$eventMap$d = {
    onCloseClick: "closeclick",
    onContentChanged: "content_changed",
    onDomReady: "domready",
    onPositionChanged: "position_changed",
    onZindexChanged: "zindex_changed"
};
var $de370fea0b9a0328$var$updaterMap$d = {
    options: function(instance, options) {
        instance.setOptions(options);
    },
    position: function(instance, position) {
        if (position instanceof google.maps.LatLng) instance.setPosition(position);
        else instance.setPosition(new google.maps.LatLng(position.lat, position.lng));
    },
    visible: function(instance, visible) {
        instance.setVisible(visible);
    },
    zIndex: function(instance, zIndex) {
        instance.setZIndex(zIndex);
    }
};
var $de370fea0b9a0328$var$defaultOptions$3 = {};
function $de370fea0b9a0328$var$InfoBoxFunctional(_a) {
    var children = _a.children, anchor = _a.anchor, options = _a.options, position = _a.position, zIndex = _a.zIndex, onCloseClick = _a.onCloseClick, onDomReady = _a.onDomReady, onContentChanged = _a.onContentChanged, onPositionChanged = _a.onPositionChanged, onZindexChanged = _a.onZindexChanged, onLoad = _a.onLoad, onUnmount = _a.onUnmount;
    var map = (0, $b6HlZ.useContext)($de370fea0b9a0328$export$dc7344301ae78f85);
    var _b = (0, $b6HlZ.useState)(null), instance = _b[0], setInstance = _b[1];
    var _c = (0, $b6HlZ.useState)(null), closeClickListener = _c[0], setCloseClickListener = _c[1];
    var _d = (0, $b6HlZ.useState)(null), domReadyClickListener = _d[0], setDomReadyClickListener = _d[1];
    var _e = (0, $b6HlZ.useState)(null), contentChangedClickListener = _e[0], setContentChangedClickListener = _e[1];
    var _f = (0, $b6HlZ.useState)(null), positionChangedClickListener = _f[0], setPositionChangedClickListener = _f[1];
    var _g = (0, $b6HlZ.useState)(null), zIndexChangedClickListener = _g[0], setZindexChangedClickListener = _g[1];
    var containerElementRef = (0, $b6HlZ.useRef)(null);
    // Order does matter
    (0, $b6HlZ.useEffect)(function() {
        if (map && instance !== null) {
            instance.close();
            if (anchor) instance.open(map, anchor);
            else if (instance.getPosition()) instance.open(map);
        }
    }, [
        map,
        instance,
        anchor
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (options && instance !== null) instance.setOptions(options);
    }, [
        instance,
        options
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (position && instance !== null) {
            var positionLatLng = position instanceof google.maps.LatLng ? position : new google.maps.LatLng(position.lat, position.lng);
            instance.setPosition(positionLatLng);
        }
    }, [
        position
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (typeof zIndex === "number" && instance !== null) instance.setZIndex(zIndex);
    }, [
        zIndex
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (instance && onCloseClick) {
            if (closeClickListener !== null) google.maps.event.removeListener(closeClickListener);
            setCloseClickListener(google.maps.event.addListener(instance, "closeclick", onCloseClick));
        }
    }, [
        onCloseClick
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (instance && onDomReady) {
            if (domReadyClickListener !== null) google.maps.event.removeListener(domReadyClickListener);
            setDomReadyClickListener(google.maps.event.addListener(instance, "domready", onDomReady));
        }
    }, [
        onDomReady
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (instance && onContentChanged) {
            if (contentChangedClickListener !== null) google.maps.event.removeListener(contentChangedClickListener);
            setContentChangedClickListener(google.maps.event.addListener(instance, "content_changed", onContentChanged));
        }
    }, [
        onContentChanged
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (instance && onPositionChanged) {
            if (positionChangedClickListener !== null) google.maps.event.removeListener(positionChangedClickListener);
            setPositionChangedClickListener(google.maps.event.addListener(instance, "position_changed", onPositionChanged));
        }
    }, [
        onPositionChanged
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (instance && onZindexChanged) {
            if (zIndexChangedClickListener !== null) google.maps.event.removeListener(zIndexChangedClickListener);
            setZindexChangedClickListener(google.maps.event.addListener(instance, "zindex_changed", onZindexChanged));
        }
    }, [
        onZindexChanged
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (map) {
            var _a = options || $de370fea0b9a0328$var$defaultOptions$3, position_1 = _a.position, infoBoxOptions = $de370fea0b9a0328$var$__rest$1(_a, [
                "position"
            ]);
            var positionLatLng = void 0;
            if (position_1 && !(position_1 instanceof google.maps.LatLng)) // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            positionLatLng = new google.maps.LatLng(position_1.lat, position_1.lng);
            var infoBox = new $de370fea0b9a0328$var$InfoBox($de370fea0b9a0328$var$__assign($de370fea0b9a0328$var$__assign({}, infoBoxOptions), positionLatLng ? {
                position: positionLatLng
            } : {}));
            containerElementRef.current = document.createElement("div");
            setInstance(infoBox);
            if (onCloseClick) setCloseClickListener(google.maps.event.addListener(infoBox, "closeclick", onCloseClick));
            if (onDomReady) setDomReadyClickListener(google.maps.event.addListener(infoBox, "domready", onDomReady));
            if (onContentChanged) setContentChangedClickListener(google.maps.event.addListener(infoBox, "content_changed", onContentChanged));
            if (onPositionChanged) setPositionChangedClickListener(google.maps.event.addListener(infoBox, "position_changed", onPositionChanged));
            if (onZindexChanged) setZindexChangedClickListener(google.maps.event.addListener(infoBox, "zindex_changed", onZindexChanged));
            infoBox.setContent(containerElementRef.current);
            if (anchor) infoBox.open(map, anchor);
            else if (infoBox.getPosition()) infoBox.open(map);
            else $de370fea0b9a0328$var$invariant$1(false, "You must provide either an anchor or a position prop for <InfoBox>.");
            if (onLoad) onLoad(infoBox);
        }
        return function() {
            if (instance !== null) {
                if (closeClickListener) google.maps.event.removeListener(closeClickListener);
                if (contentChangedClickListener) google.maps.event.removeListener(contentChangedClickListener);
                if (domReadyClickListener) google.maps.event.removeListener(domReadyClickListener);
                if (positionChangedClickListener) google.maps.event.removeListener(positionChangedClickListener);
                if (zIndexChangedClickListener) google.maps.event.removeListener(zIndexChangedClickListener);
                if (onUnmount) onUnmount(instance);
                instance.close();
            }
        };
    }, []);
    return containerElementRef.current ? (0, $3uMgk.createPortal)((0, $b6HlZ.Children).only(children), containerElementRef.current) : null;
}
var $de370fea0b9a0328$export$8dff7512164723fc = (0, $b6HlZ.memo)($de370fea0b9a0328$var$InfoBoxFunctional);
var $de370fea0b9a0328$export$aff4fc93593c3bcf = /** @class */ function(_super) {
    $de370fea0b9a0328$var$__extends(InfoBoxComponent, _super);
    function InfoBoxComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.registeredEvents = [];
        _this.containerElement = null;
        _this.state = {
            infoBox: null
        };
        _this.open = function(infoBox, anchor) {
            if (anchor) {
                if (_this.context !== null) infoBox.open(_this.context, anchor);
            } else if (infoBox.getPosition()) {
                if (_this.context !== null) infoBox.open(_this.context);
            } else $de370fea0b9a0328$var$invariant$1(false, "You must provide either an anchor or a position prop for <InfoBox>.");
        };
        _this.setInfoBoxCallback = function() {
            if (_this.state.infoBox !== null && _this.containerElement !== null) {
                _this.state.infoBox.setContent(_this.containerElement);
                _this.open(_this.state.infoBox, _this.props.anchor);
                if (_this.props.onLoad) _this.props.onLoad(_this.state.infoBox);
            }
        };
        return _this;
    }
    InfoBoxComponent.prototype.componentDidMount = function() {
        var _a = this.props.options || {}, position = _a.position, infoBoxOptions = $de370fea0b9a0328$var$__rest$1(_a, [
            "position"
        ]);
        var positionLatLng;
        if (position && !(position instanceof google.maps.LatLng)) // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        positionLatLng = new google.maps.LatLng(position.lat, position.lng);
        var infoBox = new $de370fea0b9a0328$var$InfoBox($de370fea0b9a0328$var$__assign($de370fea0b9a0328$var$__assign({}, infoBoxOptions), positionLatLng ? {
            position: positionLatLng
        } : {}));
        this.containerElement = document.createElement("div");
        this.registeredEvents = $de370fea0b9a0328$var$applyUpdatersToPropsAndRegisterEvents({
            updaterMap: $de370fea0b9a0328$var$updaterMap$d,
            eventMap: $de370fea0b9a0328$var$eventMap$d,
            prevProps: {},
            nextProps: this.props,
            instance: infoBox
        });
        this.setState({
            infoBox: infoBox
        }, this.setInfoBoxCallback);
    };
    InfoBoxComponent.prototype.componentDidUpdate = function(prevProps) {
        var infoBox = this.state.infoBox;
        if (infoBox !== null) {
            $de370fea0b9a0328$var$unregisterEvents(this.registeredEvents);
            this.registeredEvents = $de370fea0b9a0328$var$applyUpdatersToPropsAndRegisterEvents({
                updaterMap: $de370fea0b9a0328$var$updaterMap$d,
                eventMap: $de370fea0b9a0328$var$eventMap$d,
                prevProps: prevProps,
                nextProps: this.props,
                instance: infoBox
            });
        }
    };
    InfoBoxComponent.prototype.componentWillUnmount = function() {
        var onUnmount = this.props.onUnmount;
        var infoBox = this.state.infoBox;
        if (infoBox !== null) {
            if (onUnmount) onUnmount(infoBox);
            $de370fea0b9a0328$var$unregisterEvents(this.registeredEvents);
            infoBox.close();
        }
    };
    InfoBoxComponent.prototype.render = function() {
        return this.containerElement ? (0, $3uMgk.createPortal)((0, $b6HlZ.Children).only(this.props.children), this.containerElement) : null;
    };
    InfoBoxComponent.contextType = $de370fea0b9a0328$export$dc7344301ae78f85;
    return InfoBoxComponent;
}((0, $b6HlZ.PureComponent));
// do not edit .js files directly - edit src/index.jst
var $de370fea0b9a0328$var$fastDeepEqual = function equal(a, b) {
    if (a === b) return true;
    if (a && b && typeof a == "object" && typeof b == "object") {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        for(i = length; i-- !== 0;){
            var key = keys[i];
            if (!equal(a[key], b[key])) return false;
        }
        return true;
    }
    // true if both NaN, false otherwise
    return a !== a && b !== b;
};
var $de370fea0b9a0328$var$equal = /*@__PURE__*/ $de370fea0b9a0328$var$getDefaultExportFromCjs($de370fea0b9a0328$var$fastDeepEqual);
const $de370fea0b9a0328$var$ARRAY_TYPES = [
    Int8Array,
    Uint8Array,
    Uint8ClampedArray,
    Int16Array,
    Uint16Array,
    Int32Array,
    Uint32Array,
    Float32Array,
    Float64Array
];
/** @typedef {Int8ArrayConstructor | Uint8ArrayConstructor | Uint8ClampedArrayConstructor | Int16ArrayConstructor | Uint16ArrayConstructor | Int32ArrayConstructor | Uint32ArrayConstructor | Float32ArrayConstructor | Float64ArrayConstructor} TypedArrayConstructor */ const $de370fea0b9a0328$var$VERSION = 1; // serialized format version
const $de370fea0b9a0328$var$HEADER_SIZE = 8;
class $de370fea0b9a0328$var$KDBush {
    /**
     * Creates an index from raw `ArrayBuffer` data.
     * @param {ArrayBuffer} data
     */ static from(data) {
        if (!(data instanceof ArrayBuffer)) throw new Error("Data must be an instance of ArrayBuffer.");
        const [magic, versionAndType] = new Uint8Array(data, 0, 2);
        if (magic !== 0xdb) throw new Error("Data does not appear to be in a KDBush format.");
        const version = versionAndType >> 4;
        if (version !== $de370fea0b9a0328$var$VERSION) throw new Error(`Got v${version} data when expected v${$de370fea0b9a0328$var$VERSION}.`);
        const ArrayType = $de370fea0b9a0328$var$ARRAY_TYPES[versionAndType & 0x0f];
        if (!ArrayType) throw new Error("Unrecognized array type.");
        const [nodeSize] = new Uint16Array(data, 2, 1);
        const [numItems] = new Uint32Array(data, 4, 1);
        return new $de370fea0b9a0328$var$KDBush(numItems, nodeSize, ArrayType, data);
    }
    /**
     * Add a point to the index.
     * @param {number} x
     * @param {number} y
     * @returns {number} An incremental index associated with the added item (starting from `0`).
     */ add(x, y) {
        const index = this._pos >> 1;
        this.ids[index] = index;
        this.coords[this._pos++] = x;
        this.coords[this._pos++] = y;
        return index;
    }
    /**
     * Perform indexing of the added points.
     */ finish() {
        const numAdded = this._pos >> 1;
        if (numAdded !== this.numItems) throw new Error(`Added ${numAdded} items when expected ${this.numItems}.`);
        // kd-sort both arrays for efficient search
        $de370fea0b9a0328$var$sort(this.ids, this.coords, this.nodeSize, 0, this.numItems - 1, 0);
        this._finished = true;
        return this;
    }
    /**
     * Search the index for items within a given bounding box.
     * @param {number} minX
     * @param {number} minY
     * @param {number} maxX
     * @param {number} maxY
     * @returns {number[]} An array of indices correponding to the found items.
     */ range(minX, minY, maxX, maxY) {
        if (!this._finished) throw new Error("Data not yet indexed - call index.finish().");
        const { ids: ids, coords: coords, nodeSize: nodeSize } = this;
        const stack = [
            0,
            ids.length - 1,
            0
        ];
        const result = [];
        // recursively search for items in range in the kd-sorted arrays
        while(stack.length){
            const axis = stack.pop() || 0;
            const right = stack.pop() || 0;
            const left = stack.pop() || 0;
            // if we reached "tree node", search linearly
            if (right - left <= nodeSize) {
                for(let i = left; i <= right; i++){
                    const x = coords[2 * i];
                    const y = coords[2 * i + 1];
                    if (x >= minX && x <= maxX && y >= minY && y <= maxY) result.push(ids[i]);
                }
                continue;
            }
            // otherwise find the middle index
            const m = left + right >> 1;
            // include the middle item if it's in range
            const x = coords[2 * m];
            const y = coords[2 * m + 1];
            if (x >= minX && x <= maxX && y >= minY && y <= maxY) result.push(ids[m]);
            // queue search in halves that intersect the query
            if (axis === 0 ? minX <= x : minY <= y) {
                stack.push(left);
                stack.push(m - 1);
                stack.push(1 - axis);
            }
            if (axis === 0 ? maxX >= x : maxY >= y) {
                stack.push(m + 1);
                stack.push(right);
                stack.push(1 - axis);
            }
        }
        return result;
    }
    /**
     * Search the index for items within a given radius.
     * @param {number} qx
     * @param {number} qy
     * @param {number} r Query radius.
     * @returns {number[]} An array of indices correponding to the found items.
     */ within(qx, qy, r) {
        if (!this._finished) throw new Error("Data not yet indexed - call index.finish().");
        const { ids: ids, coords: coords, nodeSize: nodeSize } = this;
        const stack = [
            0,
            ids.length - 1,
            0
        ];
        const result = [];
        const r2 = r * r;
        // recursively search for items within radius in the kd-sorted arrays
        while(stack.length){
            const axis = stack.pop() || 0;
            const right = stack.pop() || 0;
            const left = stack.pop() || 0;
            // if we reached "tree node", search linearly
            if (right - left <= nodeSize) {
                for(let i = left; i <= right; i++)if ($de370fea0b9a0328$var$sqDist(coords[2 * i], coords[2 * i + 1], qx, qy) <= r2) result.push(ids[i]);
                continue;
            }
            // otherwise find the middle index
            const m = left + right >> 1;
            // include the middle item if it's in range
            const x = coords[2 * m];
            const y = coords[2 * m + 1];
            if ($de370fea0b9a0328$var$sqDist(x, y, qx, qy) <= r2) result.push(ids[m]);
            // queue search in halves that intersect the query
            if (axis === 0 ? qx - r <= x : qy - r <= y) {
                stack.push(left);
                stack.push(m - 1);
                stack.push(1 - axis);
            }
            if (axis === 0 ? qx + r >= x : qy + r >= y) {
                stack.push(m + 1);
                stack.push(right);
                stack.push(1 - axis);
            }
        }
        return result;
    }
    /**
     * Creates an index that will hold a given number of items.
     * @param {number} numItems
     * @param {number} [nodeSize=64] Size of the KD-tree node (64 by default).
     * @param {TypedArrayConstructor} [ArrayType=Float64Array] The array type used for coordinates storage (`Float64Array` by default).
     * @param {ArrayBuffer} [data] (For internal use only)
     */ constructor(numItems, nodeSize = 64, ArrayType = Float64Array, data){
        if (isNaN(numItems) || numItems < 0) throw new Error(`Unpexpected numItems value: ${numItems}.`);
        this.numItems = +numItems;
        this.nodeSize = Math.min(Math.max(+nodeSize, 2), 65535);
        this.ArrayType = ArrayType;
        this.IndexArrayType = numItems < 65536 ? Uint16Array : Uint32Array;
        const arrayTypeIndex = $de370fea0b9a0328$var$ARRAY_TYPES.indexOf(this.ArrayType);
        const coordsByteSize = numItems * 2 * this.ArrayType.BYTES_PER_ELEMENT;
        const idsByteSize = numItems * this.IndexArrayType.BYTES_PER_ELEMENT;
        const padCoords = (8 - idsByteSize % 8) % 8;
        if (arrayTypeIndex < 0) throw new Error(`Unexpected typed array class: ${ArrayType}.`);
        if (data && data instanceof ArrayBuffer) {
            this.data = data;
            this.ids = new this.IndexArrayType(this.data, $de370fea0b9a0328$var$HEADER_SIZE, numItems);
            this.coords = new this.ArrayType(this.data, $de370fea0b9a0328$var$HEADER_SIZE + idsByteSize + padCoords, numItems * 2);
            this._pos = numItems * 2;
            this._finished = true;
        } else {
            this.data = new ArrayBuffer($de370fea0b9a0328$var$HEADER_SIZE + coordsByteSize + idsByteSize + padCoords);
            this.ids = new this.IndexArrayType(this.data, $de370fea0b9a0328$var$HEADER_SIZE, numItems);
            this.coords = new this.ArrayType(this.data, $de370fea0b9a0328$var$HEADER_SIZE + idsByteSize + padCoords, numItems * 2);
            this._pos = 0;
            this._finished = false;
            // set header
            new Uint8Array(this.data, 0, 2).set([
                0xdb,
                ($de370fea0b9a0328$var$VERSION << 4) + arrayTypeIndex
            ]);
            new Uint16Array(this.data, 2, 1)[0] = nodeSize;
            new Uint32Array(this.data, 4, 1)[0] = numItems;
        }
    }
}
/**
 * @param {Uint16Array | Uint32Array} ids
 * @param {InstanceType<TypedArrayConstructor>} coords
 * @param {number} nodeSize
 * @param {number} left
 * @param {number} right
 * @param {number} axis
 */ function $de370fea0b9a0328$var$sort(ids, coords, nodeSize, left, right, axis) {
    if (right - left <= nodeSize) return;
    const m = left + right >> 1; // middle index
    // sort ids and coords around the middle index so that the halves lie
    // either left/right or top/bottom correspondingly (taking turns)
    $de370fea0b9a0328$var$select(ids, coords, m, left, right, axis);
    // recursively kd-sort first half and second half on the opposite axis
    $de370fea0b9a0328$var$sort(ids, coords, nodeSize, left, m - 1, 1 - axis);
    $de370fea0b9a0328$var$sort(ids, coords, nodeSize, m + 1, right, 1 - axis);
}
/**
 * Custom Floyd-Rivest selection algorithm: sort ids and coords so that
 * [left..k-1] items are smaller than k-th item (on either x or y axis)
 * @param {Uint16Array | Uint32Array} ids
 * @param {InstanceType<TypedArrayConstructor>} coords
 * @param {number} k
 * @param {number} left
 * @param {number} right
 * @param {number} axis
 */ function $de370fea0b9a0328$var$select(ids, coords, k, left, right, axis) {
    while(right > left){
        if (right - left > 600) {
            const n = right - left + 1;
            const m = k - left + 1;
            const z = Math.log(n);
            const s = 0.5 * Math.exp(2 * z / 3);
            const sd = 0.5 * Math.sqrt(z * s * (n - s) / n) * (m - n / 2 < 0 ? -1 : 1);
            const newLeft = Math.max(left, Math.floor(k - m * s / n + sd));
            const newRight = Math.min(right, Math.floor(k + (n - m) * s / n + sd));
            $de370fea0b9a0328$var$select(ids, coords, k, newLeft, newRight, axis);
        }
        const t = coords[2 * k + axis];
        let i = left;
        let j = right;
        $de370fea0b9a0328$var$swapItem(ids, coords, left, k);
        if (coords[2 * right + axis] > t) $de370fea0b9a0328$var$swapItem(ids, coords, left, right);
        while(i < j){
            $de370fea0b9a0328$var$swapItem(ids, coords, i, j);
            i++;
            j--;
            while(coords[2 * i + axis] < t)i++;
            while(coords[2 * j + axis] > t)j--;
        }
        if (coords[2 * left + axis] === t) $de370fea0b9a0328$var$swapItem(ids, coords, left, j);
        else {
            j++;
            $de370fea0b9a0328$var$swapItem(ids, coords, j, right);
        }
        if (j <= k) left = j + 1;
        if (k <= j) right = j - 1;
    }
}
/**
 * @param {Uint16Array | Uint32Array} ids
 * @param {InstanceType<TypedArrayConstructor>} coords
 * @param {number} i
 * @param {number} j
 */ function $de370fea0b9a0328$var$swapItem(ids, coords, i, j) {
    $de370fea0b9a0328$var$swap(ids, i, j);
    $de370fea0b9a0328$var$swap(coords, 2 * i, 2 * j);
    $de370fea0b9a0328$var$swap(coords, 2 * i + 1, 2 * j + 1);
}
/**
 * @param {InstanceType<TypedArrayConstructor>} arr
 * @param {number} i
 * @param {number} j
 */ function $de370fea0b9a0328$var$swap(arr, i, j) {
    const tmp = arr[i];
    arr[i] = arr[j];
    arr[j] = tmp;
}
/**
 * @param {number} ax
 * @param {number} ay
 * @param {number} bx
 * @param {number} by
 */ function $de370fea0b9a0328$var$sqDist(ax, ay, bx, by) {
    const dx = ax - bx;
    const dy = ay - by;
    return dx * dx + dy * dy;
}
const $de370fea0b9a0328$var$defaultOptions$2 = {
    minZoom: 0,
    maxZoom: 16,
    minPoints: 2,
    radius: 40,
    extent: 512,
    nodeSize: 64,
    log: false,
    // whether to generate numeric ids for input features (in vector tiles)
    generateId: false,
    // a reduce function for calculating custom cluster properties
    reduce: null,
    // properties to use for individual points when running the reducer
    map: (props)=>props // props => ({sum: props.my_value})
};
const $de370fea0b9a0328$var$fround = Math.fround || ((tmp)=>(x)=>{
        tmp[0] = +x;
        return tmp[0];
    })(new Float32Array(1));
const $de370fea0b9a0328$var$OFFSET_ZOOM = 2;
const $de370fea0b9a0328$var$OFFSET_ID = 3;
const $de370fea0b9a0328$var$OFFSET_PARENT = 4;
const $de370fea0b9a0328$var$OFFSET_NUM = 5;
const $de370fea0b9a0328$var$OFFSET_PROP = 6;
class $de370fea0b9a0328$var$Supercluster {
    load(points) {
        const { log: log, minZoom: minZoom, maxZoom: maxZoom } = this.options;
        if (log) console.time("total time");
        const timerId = `prepare ${points.length} points`;
        if (log) console.time(timerId);
        this.points = points;
        // generate a cluster object for each point and index input points into a KD-tree
        const data = [];
        for(let i = 0; i < points.length; i++){
            const p = points[i];
            if (!p.geometry) continue;
            const [lng, lat] = p.geometry.coordinates;
            const x = $de370fea0b9a0328$var$fround($de370fea0b9a0328$var$lngX(lng));
            const y = $de370fea0b9a0328$var$fround($de370fea0b9a0328$var$latY(lat));
            // store internal point/cluster data in flat numeric arrays for performance
            data.push(x, y, Infinity, i, -1, 1 // number of points in a cluster
            );
            if (this.options.reduce) data.push(0); // noop
        }
        let tree = this.trees[maxZoom + 1] = this._createTree(data);
        if (log) console.timeEnd(timerId);
        // cluster points on max zoom, then cluster the results on previous zoom, etc.;
        // results in a cluster hierarchy across zoom levels
        for(let z = maxZoom; z >= minZoom; z--){
            const now = +Date.now();
            // create a new set of clusters for the zoom and index them with a KD-tree
            tree = this.trees[z] = this._createTree(this._cluster(tree, z));
            if (log) console.log("z%d: %d clusters in %dms", z, tree.numItems, +Date.now() - now);
        }
        if (log) console.timeEnd("total time");
        return this;
    }
    getClusters(bbox, zoom) {
        let minLng = ((bbox[0] + 180) % 360 + 360) % 360 - 180;
        const minLat = Math.max(-90, Math.min(90, bbox[1]));
        let maxLng = bbox[2] === 180 ? 180 : ((bbox[2] + 180) % 360 + 360) % 360 - 180;
        const maxLat = Math.max(-90, Math.min(90, bbox[3]));
        if (bbox[2] - bbox[0] >= 360) {
            minLng = -180;
            maxLng = 180;
        } else if (minLng > maxLng) {
            const easternHem = this.getClusters([
                minLng,
                minLat,
                180,
                maxLat
            ], zoom);
            const westernHem = this.getClusters([
                -180,
                minLat,
                maxLng,
                maxLat
            ], zoom);
            return easternHem.concat(westernHem);
        }
        const tree = this.trees[this._limitZoom(zoom)];
        const ids = tree.range($de370fea0b9a0328$var$lngX(minLng), $de370fea0b9a0328$var$latY(maxLat), $de370fea0b9a0328$var$lngX(maxLng), $de370fea0b9a0328$var$latY(minLat));
        const data = tree.data;
        const clusters = [];
        for (const id of ids){
            const k = this.stride * id;
            clusters.push(data[k + $de370fea0b9a0328$var$OFFSET_NUM] > 1 ? $de370fea0b9a0328$var$getClusterJSON(data, k, this.clusterProps) : this.points[data[k + $de370fea0b9a0328$var$OFFSET_ID]]);
        }
        return clusters;
    }
    getChildren(clusterId) {
        const originId = this._getOriginId(clusterId);
        const originZoom = this._getOriginZoom(clusterId);
        const errorMsg = "No cluster with the specified id.";
        const tree = this.trees[originZoom];
        if (!tree) throw new Error(errorMsg);
        const data = tree.data;
        if (originId * this.stride >= data.length) throw new Error(errorMsg);
        const r = this.options.radius / (this.options.extent * Math.pow(2, originZoom - 1));
        const x = data[originId * this.stride];
        const y = data[originId * this.stride + 1];
        const ids = tree.within(x, y, r);
        const children = [];
        for (const id of ids){
            const k = id * this.stride;
            if (data[k + $de370fea0b9a0328$var$OFFSET_PARENT] === clusterId) children.push(data[k + $de370fea0b9a0328$var$OFFSET_NUM] > 1 ? $de370fea0b9a0328$var$getClusterJSON(data, k, this.clusterProps) : this.points[data[k + $de370fea0b9a0328$var$OFFSET_ID]]);
        }
        if (children.length === 0) throw new Error(errorMsg);
        return children;
    }
    getLeaves(clusterId, limit, offset) {
        limit = limit || 10;
        offset = offset || 0;
        const leaves = [];
        this._appendLeaves(leaves, clusterId, limit, offset, 0);
        return leaves;
    }
    getTile(z, x, y) {
        const tree = this.trees[this._limitZoom(z)];
        const z2 = Math.pow(2, z);
        const { extent: extent, radius: radius } = this.options;
        const p = radius / extent;
        const top = (y - p) / z2;
        const bottom = (y + 1 + p) / z2;
        const tile = {
            features: []
        };
        this._addTileFeatures(tree.range((x - p) / z2, top, (x + 1 + p) / z2, bottom), tree.data, x, y, z2, tile);
        if (x === 0) this._addTileFeatures(tree.range(1 - p / z2, top, 1, bottom), tree.data, z2, y, z2, tile);
        if (x === z2 - 1) this._addTileFeatures(tree.range(0, top, p / z2, bottom), tree.data, -1, y, z2, tile);
        return tile.features.length ? tile : null;
    }
    getClusterExpansionZoom(clusterId) {
        let expansionZoom = this._getOriginZoom(clusterId) - 1;
        while(expansionZoom <= this.options.maxZoom){
            const children = this.getChildren(clusterId);
            expansionZoom++;
            if (children.length !== 1) break;
            clusterId = children[0].properties.cluster_id;
        }
        return expansionZoom;
    }
    _appendLeaves(result, clusterId, limit, offset, skipped) {
        const children = this.getChildren(clusterId);
        for (const child of children){
            const props = child.properties;
            if (props && props.cluster) {
                if (skipped + props.point_count <= offset) // skip the whole cluster
                skipped += props.point_count;
                else // enter the cluster
                skipped = this._appendLeaves(result, props.cluster_id, limit, offset, skipped);
            } else if (skipped < offset) // skip a single point
            skipped++;
            else // add a single point
            result.push(child);
            if (result.length === limit) break;
        }
        return skipped;
    }
    _createTree(data) {
        const tree = new $de370fea0b9a0328$var$KDBush(data.length / this.stride | 0, this.options.nodeSize, Float32Array);
        for(let i = 0; i < data.length; i += this.stride)tree.add(data[i], data[i + 1]);
        tree.finish();
        tree.data = data;
        return tree;
    }
    _addTileFeatures(ids, data, x, y, z2, tile) {
        for (const i of ids){
            const k = i * this.stride;
            const isCluster = data[k + $de370fea0b9a0328$var$OFFSET_NUM] > 1;
            let tags, px, py;
            if (isCluster) {
                tags = $de370fea0b9a0328$var$getClusterProperties(data, k, this.clusterProps);
                px = data[k];
                py = data[k + 1];
            } else {
                const p = this.points[data[k + $de370fea0b9a0328$var$OFFSET_ID]];
                tags = p.properties;
                const [lng, lat] = p.geometry.coordinates;
                px = $de370fea0b9a0328$var$lngX(lng);
                py = $de370fea0b9a0328$var$latY(lat);
            }
            const f = {
                type: 1,
                geometry: [
                    [
                        Math.round(this.options.extent * (px * z2 - x)),
                        Math.round(this.options.extent * (py * z2 - y))
                    ]
                ],
                tags: tags
            };
            // assign id
            let id;
            if (isCluster || this.options.generateId) // optionally generate id for points
            id = data[k + $de370fea0b9a0328$var$OFFSET_ID];
            else // keep id if already assigned
            id = this.points[data[k + $de370fea0b9a0328$var$OFFSET_ID]].id;
            if (id !== undefined) f.id = id;
            tile.features.push(f);
        }
    }
    _limitZoom(z) {
        return Math.max(this.options.minZoom, Math.min(Math.floor(+z), this.options.maxZoom + 1));
    }
    _cluster(tree, zoom) {
        const { radius: radius, extent: extent, reduce: reduce, minPoints: minPoints } = this.options;
        const r = radius / (extent * Math.pow(2, zoom));
        const data = tree.data;
        const nextData = [];
        const stride = this.stride;
        // loop through each point
        for(let i = 0; i < data.length; i += stride){
            // if we've already visited the point at this zoom level, skip it
            if (data[i + $de370fea0b9a0328$var$OFFSET_ZOOM] <= zoom) continue;
            data[i + $de370fea0b9a0328$var$OFFSET_ZOOM] = zoom;
            // find all nearby points
            const x = data[i];
            const y = data[i + 1];
            const neighborIds = tree.within(data[i], data[i + 1], r);
            const numPointsOrigin = data[i + $de370fea0b9a0328$var$OFFSET_NUM];
            let numPoints = numPointsOrigin;
            // count the number of points in a potential cluster
            for (const neighborId of neighborIds){
                const k = neighborId * stride;
                // filter out neighbors that are already processed
                if (data[k + $de370fea0b9a0328$var$OFFSET_ZOOM] > zoom) numPoints += data[k + $de370fea0b9a0328$var$OFFSET_NUM];
            }
            // if there were neighbors to merge, and there are enough points to form a cluster
            if (numPoints > numPointsOrigin && numPoints >= minPoints) {
                let wx = x * numPointsOrigin;
                let wy = y * numPointsOrigin;
                let clusterProperties;
                let clusterPropIndex = -1;
                // encode both zoom and point index on which the cluster originated -- offset by total length of features
                const id = ((i / stride | 0) << 5) + (zoom + 1) + this.points.length;
                for (const neighborId of neighborIds){
                    const k = neighborId * stride;
                    if (data[k + $de370fea0b9a0328$var$OFFSET_ZOOM] <= zoom) continue;
                    data[k + $de370fea0b9a0328$var$OFFSET_ZOOM] = zoom; // save the zoom (so it doesn't get processed twice)
                    const numPoints2 = data[k + $de370fea0b9a0328$var$OFFSET_NUM];
                    wx += data[k] * numPoints2; // accumulate coordinates for calculating weighted center
                    wy += data[k + 1] * numPoints2;
                    data[k + $de370fea0b9a0328$var$OFFSET_PARENT] = id;
                    if (reduce) {
                        if (!clusterProperties) {
                            clusterProperties = this._map(data, i, true);
                            clusterPropIndex = this.clusterProps.length;
                            this.clusterProps.push(clusterProperties);
                        }
                        reduce(clusterProperties, this._map(data, k));
                    }
                }
                data[i + $de370fea0b9a0328$var$OFFSET_PARENT] = id;
                nextData.push(wx / numPoints, wy / numPoints, Infinity, id, -1, numPoints);
                if (reduce) nextData.push(clusterPropIndex);
            } else {
                for(let j = 0; j < stride; j++)nextData.push(data[i + j]);
                if (numPoints > 1) for (const neighborId of neighborIds){
                    const k = neighborId * stride;
                    if (data[k + $de370fea0b9a0328$var$OFFSET_ZOOM] <= zoom) continue;
                    data[k + $de370fea0b9a0328$var$OFFSET_ZOOM] = zoom;
                    for(let j = 0; j < stride; j++)nextData.push(data[k + j]);
                }
            }
        }
        return nextData;
    }
    // get index of the point from which the cluster originated
    _getOriginId(clusterId) {
        return clusterId - this.points.length >> 5;
    }
    // get zoom of the point from which the cluster originated
    _getOriginZoom(clusterId) {
        return (clusterId - this.points.length) % 32;
    }
    _map(data, i, clone) {
        if (data[i + $de370fea0b9a0328$var$OFFSET_NUM] > 1) {
            const props = this.clusterProps[data[i + $de370fea0b9a0328$var$OFFSET_PROP]];
            return clone ? Object.assign({}, props) : props;
        }
        const original = this.points[data[i + $de370fea0b9a0328$var$OFFSET_ID]].properties;
        const result = this.options.map(original);
        return clone && result === original ? Object.assign({}, result) : result;
    }
    constructor(options){
        this.options = Object.assign(Object.create($de370fea0b9a0328$var$defaultOptions$2), options);
        this.trees = new Array(this.options.maxZoom + 1);
        this.stride = this.options.reduce ? 7 : 6;
        this.clusterProps = [];
    }
}
function $de370fea0b9a0328$var$getClusterJSON(data, i, clusterProps) {
    return {
        type: "Feature",
        id: data[i + $de370fea0b9a0328$var$OFFSET_ID],
        properties: $de370fea0b9a0328$var$getClusterProperties(data, i, clusterProps),
        geometry: {
            type: "Point",
            coordinates: [
                $de370fea0b9a0328$var$xLng(data[i]),
                $de370fea0b9a0328$var$yLat(data[i + 1])
            ]
        }
    };
}
function $de370fea0b9a0328$var$getClusterProperties(data, i, clusterProps) {
    const count = data[i + $de370fea0b9a0328$var$OFFSET_NUM];
    const abbrev = count >= 10000 ? `${Math.round(count / 1000)}k` : count >= 1000 ? `${Math.round(count / 100) / 10}k` : count;
    const propIndex = data[i + $de370fea0b9a0328$var$OFFSET_PROP];
    const properties = propIndex === -1 ? {} : Object.assign({}, clusterProps[propIndex]);
    return Object.assign(properties, {
        cluster: true,
        cluster_id: data[i + $de370fea0b9a0328$var$OFFSET_ID],
        point_count: count,
        point_count_abbreviated: abbrev
    });
}
// longitude/latitude to spherical mercator in [0..1] range
function $de370fea0b9a0328$var$lngX(lng) {
    return lng / 360 + 0.5;
}
function $de370fea0b9a0328$var$latY(lat) {
    const sin = Math.sin(lat * Math.PI / 180);
    const y = 0.5 - 0.25 * Math.log((1 + sin) / (1 - sin)) / Math.PI;
    return y < 0 ? 0 : y > 1 ? 1 : y;
}
// spherical mercator to longitude/latitude
function $de370fea0b9a0328$var$xLng(x) {
    return (x - 0.5) * 360;
}
function $de370fea0b9a0328$var$yLat(y) {
    const y2 = (180 - y * 360) * Math.PI / 180;
    return 360 * Math.atan(Math.exp(y2)) / Math.PI - 90;
}
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function $de370fea0b9a0328$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
/**
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $de370fea0b9a0328$var$MarkerUtils {
    static isAdvancedMarkerAvailable(map) {
        return google.maps.marker && map.getMapCapabilities().isAdvancedMarkersAvailable === true;
    }
    static isAdvancedMarker(marker) {
        return google.maps.marker && marker instanceof google.maps.marker.AdvancedMarkerElement;
    }
    static setMap(marker, map) {
        if (this.isAdvancedMarker(marker)) marker.map = map;
        else marker.setMap(map);
    }
    static getPosition(marker) {
        // SuperClusterAlgorithm.calculate expects a LatLng instance so we fake it for Adv Markers
        if (this.isAdvancedMarker(marker)) {
            if (marker.position) {
                if (marker.position instanceof google.maps.LatLng) return marker.position;
                // since we can't cast to LatLngLiteral for reasons =(
                if (marker.position.lat && marker.position.lng) return new google.maps.LatLng(marker.position.lat, marker.position.lng);
            }
            return new google.maps.LatLng(null);
        }
        return marker.getPosition();
    }
    static getVisible(marker) {
        if (this.isAdvancedMarker(marker)) /**
             * Always return true for Advanced Markers because the clusterer
             * uses getVisible as a way to count legacy markers not as an actual
             * indicator of visibility for some reason. Even when markers are hidden
             * Marker.getVisible returns `true` and this is used to set the marker count
             * on the cluster. See the behavior of Cluster.count
             */ return true;
        return marker.getVisible();
    }
}
/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $de370fea0b9a0328$var$Cluster {
    get bounds() {
        if (this.markers.length === 0 && !this._position) return;
        const bounds = new google.maps.LatLngBounds(this._position, this._position);
        for (const marker of this.markers)bounds.extend($de370fea0b9a0328$var$MarkerUtils.getPosition(marker));
        return bounds;
    }
    get position() {
        return this._position || this.bounds.getCenter();
    }
    /**
     * Get the count of **visible** markers.
     */ get count() {
        return this.markers.filter((m)=>$de370fea0b9a0328$var$MarkerUtils.getVisible(m)).length;
    }
    /**
     * Add a marker to the cluster.
     */ push(marker) {
        this.markers.push(marker);
    }
    /**
     * Cleanup references and remove marker from map.
     */ delete() {
        if (this.marker) {
            $de370fea0b9a0328$var$MarkerUtils.setMap(this.marker, null);
            this.marker = undefined;
        }
        this.markers.length = 0;
    }
    constructor({ markers: markers, position: position }){
        this.markers = markers;
        if (position) {
            if (position instanceof google.maps.LatLng) this._position = position;
            else this._position = new google.maps.LatLng(position);
        }
    }
}
/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns the markers visible in a padded map viewport
 *
 * @param map
 * @param mapCanvasProjection
 * @param markers The list of marker to filter
 * @param viewportPaddingPixels The padding in pixel
 * @returns The list of markers in the padded viewport
 */ const $de370fea0b9a0328$var$filterMarkersToPaddedViewport = (map, mapCanvasProjection, markers, viewportPaddingPixels)=>{
    const extendedMapBounds = $de370fea0b9a0328$var$extendBoundsToPaddedViewport(map.getBounds(), mapCanvasProjection, viewportPaddingPixels);
    return markers.filter((marker)=>extendedMapBounds.contains($de370fea0b9a0328$var$MarkerUtils.getPosition(marker)));
};
/**
 * Extends a bounds by a number of pixels in each direction
 */ const $de370fea0b9a0328$var$extendBoundsToPaddedViewport = (bounds, projection, numPixels)=>{
    const { northEast: northEast, southWest: southWest } = $de370fea0b9a0328$var$latLngBoundsToPixelBounds(bounds, projection);
    const extendedPixelBounds = $de370fea0b9a0328$var$extendPixelBounds({
        northEast: northEast,
        southWest: southWest
    }, numPixels);
    return $de370fea0b9a0328$var$pixelBoundsToLatLngBounds(extendedPixelBounds, projection);
};
/**
 * Returns the distance between 2 positions.
 *
 * @hidden
 */ const $de370fea0b9a0328$var$distanceBetweenPoints = (p1, p2)=>{
    const R = 6371; // Radius of the Earth in km
    const dLat = (p2.lat - p1.lat) * Math.PI / 180;
    const dLon = (p2.lng - p1.lng) * Math.PI / 180;
    const sinDLat = Math.sin(dLat / 2);
    const sinDLon = Math.sin(dLon / 2);
    const a = sinDLat * sinDLat + Math.cos(p1.lat * Math.PI / 180) * Math.cos(p2.lat * Math.PI / 180) * sinDLon * sinDLon;
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
};
/**
 * Converts a LatLng bound to pixels.
 *
 * @hidden
 */ const $de370fea0b9a0328$var$latLngBoundsToPixelBounds = (bounds, projection)=>{
    return {
        northEast: projection.fromLatLngToDivPixel(bounds.getNorthEast()),
        southWest: projection.fromLatLngToDivPixel(bounds.getSouthWest())
    };
};
/**
 * Extends a pixel bounds by numPixels in all directions.
 *
 * @hidden
 */ const $de370fea0b9a0328$var$extendPixelBounds = ({ northEast: northEast, southWest: southWest }, numPixels)=>{
    northEast.x += numPixels;
    northEast.y -= numPixels;
    southWest.x -= numPixels;
    southWest.y += numPixels;
    return {
        northEast: northEast,
        southWest: southWest
    };
};
/**
 * @hidden
 */ const $de370fea0b9a0328$var$pixelBoundsToLatLngBounds = ({ northEast: northEast, southWest: southWest }, projection)=>{
    const sw = projection.fromDivPixelToLatLng(southWest);
    const ne = projection.fromDivPixelToLatLng(northEast);
    return new google.maps.LatLngBounds(sw, ne);
};
/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @hidden
 */ class $de370fea0b9a0328$var$AbstractAlgorithm {
    /**
     * Helper function to bypass clustering based upon some map state such as
     * zoom, number of markers, etc.
     *
     * ```typescript
     *  cluster({markers, map}: AlgorithmInput): Cluster[] {
     *    if (shouldBypassClustering(map)) {
     *      return this.noop({markers})
     *    }
     * }
     * ```
     */ noop({ markers: markers }) {
        return $de370fea0b9a0328$var$noop$1(markers);
    }
    constructor({ maxZoom: maxZoom = 16 }){
        this.maxZoom = maxZoom;
    }
}
/**
 * Abstract viewport algorithm proves a class to filter markers by a padded
 * viewport. This is a common optimization.
 *
 * @hidden
 */ class $de370fea0b9a0328$var$AbstractViewportAlgorithm extends $de370fea0b9a0328$var$AbstractAlgorithm {
    calculate({ markers: markers, map: map, mapCanvasProjection: mapCanvasProjection }) {
        if (map.getZoom() >= this.maxZoom) return {
            clusters: this.noop({
                markers: markers
            }),
            changed: false
        };
        return {
            clusters: this.cluster({
                markers: $de370fea0b9a0328$var$filterMarkersToPaddedViewport(map, mapCanvasProjection, markers, this.viewportPadding),
                map: map,
                mapCanvasProjection: mapCanvasProjection
            })
        };
    }
    constructor(_a){
        var { viewportPadding: viewportPadding = 60 } = _a, options = $de370fea0b9a0328$var$__rest(_a, [
            "viewportPadding"
        ]);
        super(options);
        this.viewportPadding = 60;
        this.viewportPadding = viewportPadding;
    }
}
/**
 * @hidden
 */ const $de370fea0b9a0328$var$noop$1 = (markers)=>{
    const clusters = markers.map((marker)=>new $de370fea0b9a0328$var$Cluster({
            position: $de370fea0b9a0328$var$MarkerUtils.getPosition(marker),
            markers: [
                marker
            ]
        }));
    return clusters;
};
/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The default Grid algorithm historically used in Google Maps marker
 * clustering.
 *
 * The Grid algorithm does not implement caching and markers may flash as the
 * viewport changes. Instead use {@link SuperClusterAlgorithm}.
 */ class $de370fea0b9a0328$var$GridAlgorithm extends $de370fea0b9a0328$var$AbstractViewportAlgorithm {
    calculate({ markers: markers, map: map, mapCanvasProjection: mapCanvasProjection }) {
        const state = {
            zoom: map.getZoom()
        };
        let changed = false;
        if (this.state.zoom >= this.maxZoom && state.zoom >= this.maxZoom) ;
        else changed = !$de370fea0b9a0328$var$equal(this.state, state);
        this.state = state;
        if (map.getZoom() >= this.maxZoom) return {
            clusters: this.noop({
                markers: markers
            }),
            changed: changed
        };
        return {
            clusters: this.cluster({
                markers: $de370fea0b9a0328$var$filterMarkersToPaddedViewport(map, mapCanvasProjection, markers, this.viewportPadding),
                map: map,
                mapCanvasProjection: mapCanvasProjection
            })
        };
    }
    cluster({ markers: markers, map: map, mapCanvasProjection: mapCanvasProjection }) {
        this.clusters = [];
        markers.forEach((marker)=>{
            this.addToClosestCluster(marker, map, mapCanvasProjection);
        });
        return this.clusters;
    }
    addToClosestCluster(marker, map, projection) {
        let maxDistance = this.maxDistance; // Some large number
        let cluster = null;
        for(let i = 0; i < this.clusters.length; i++){
            const candidate = this.clusters[i];
            const distance = $de370fea0b9a0328$var$distanceBetweenPoints(candidate.bounds.getCenter().toJSON(), $de370fea0b9a0328$var$MarkerUtils.getPosition(marker).toJSON());
            if (distance < maxDistance) {
                maxDistance = distance;
                cluster = candidate;
            }
        }
        if (cluster && $de370fea0b9a0328$var$extendBoundsToPaddedViewport(cluster.bounds, projection, this.gridSize).contains($de370fea0b9a0328$var$MarkerUtils.getPosition(marker))) cluster.push(marker);
        else {
            const cluster = new $de370fea0b9a0328$var$Cluster({
                markers: [
                    marker
                ]
            });
            this.clusters.push(cluster);
        }
    }
    constructor(_a){
        var { maxDistance: maxDistance = 40000, gridSize: gridSize = 40 } = _a, options = $de370fea0b9a0328$var$__rest(_a, [
            "maxDistance",
            "gridSize"
        ]);
        super(options);
        this.clusters = [];
        this.state = {
            zoom: -1
        };
        this.maxDistance = maxDistance;
        this.gridSize = gridSize;
    }
}
/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Noop algorithm does not generate any clusters or filter markers by the an extended viewport.
 */ class $de370fea0b9a0328$var$NoopAlgorithm extends $de370fea0b9a0328$var$AbstractAlgorithm {
    calculate({ markers: markers, map: map, mapCanvasProjection: mapCanvasProjection }) {
        return {
            clusters: this.cluster({
                markers: markers,
                map: map,
                mapCanvasProjection: mapCanvasProjection
            }),
            changed: false
        };
    }
    cluster(input) {
        return this.noop(input);
    }
    constructor(_a){
        var options = $de370fea0b9a0328$var$__rest(_a, []);
        super(options);
    }
}
/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A very fast JavaScript algorithm for geospatial point clustering using KD trees.
 *
 * @see https://www.npmjs.com/package/supercluster for more information on options.
 */ class $de370fea0b9a0328$var$SuperClusterAlgorithm extends $de370fea0b9a0328$var$AbstractAlgorithm {
    calculate(input) {
        let changed = false;
        const state = {
            zoom: input.map.getZoom()
        };
        if (!$de370fea0b9a0328$var$equal(input.markers, this.markers)) {
            changed = true;
            // TODO use proxy to avoid copy?
            this.markers = [
                ...input.markers
            ];
            const points = this.markers.map((marker)=>{
                const position = $de370fea0b9a0328$var$MarkerUtils.getPosition(marker);
                const coordinates = [
                    position.lng(),
                    position.lat()
                ];
                return {
                    type: "Feature",
                    geometry: {
                        type: "Point",
                        coordinates: coordinates
                    },
                    properties: {
                        marker: marker
                    }
                };
            });
            this.superCluster.load(points);
        }
        if (!changed) {
            if (this.state.zoom <= this.maxZoom || state.zoom <= this.maxZoom) changed = !$de370fea0b9a0328$var$equal(this.state, state);
        }
        this.state = state;
        if (changed) this.clusters = this.cluster(input);
        return {
            clusters: this.clusters,
            changed: changed
        };
    }
    cluster({ map: map }) {
        return this.superCluster.getClusters([
            -180,
            -90,
            180,
            90
        ], Math.round(map.getZoom())).map((feature)=>this.transformCluster(feature));
    }
    transformCluster({ geometry: { coordinates: [lng, lat] }, properties: properties }) {
        if (properties.cluster) return new $de370fea0b9a0328$var$Cluster({
            markers: this.superCluster.getLeaves(properties.cluster_id, Infinity).map((leaf)=>leaf.properties.marker),
            position: {
                lat: lat,
                lng: lng
            }
        });
        const marker = properties.marker;
        return new $de370fea0b9a0328$var$Cluster({
            markers: [
                marker
            ],
            position: $de370fea0b9a0328$var$MarkerUtils.getPosition(marker)
        });
    }
    constructor(_a){
        var { maxZoom: maxZoom, radius: radius = 60 } = _a, options = $de370fea0b9a0328$var$__rest(_a, [
            "maxZoom",
            "radius"
        ]);
        super({
            maxZoom: maxZoom
        });
        this.state = {
            zoom: -1
        };
        this.superCluster = new $de370fea0b9a0328$var$Supercluster(Object.assign({
            maxZoom: this.maxZoom,
            radius: radius
        }, options));
    }
}
/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provides statistics on all clusters in the current render cycle for use in {@link Renderer.render}.
 */ class $de370fea0b9a0328$var$ClusterStats {
    constructor(markers, clusters){
        this.markers = {
            sum: markers.length
        };
        const clusterMarkerCounts = clusters.map((a)=>a.count);
        const clusterMarkerSum = clusterMarkerCounts.reduce((a, b)=>a + b, 0);
        this.clusters = {
            count: clusters.length,
            markers: {
                mean: clusterMarkerSum / clusters.length,
                sum: clusterMarkerSum,
                min: Math.min(...clusterMarkerCounts),
                max: Math.max(...clusterMarkerCounts)
            }
        };
    }
}
class $de370fea0b9a0328$var$DefaultRenderer {
    /**
     * The default render function for the library used by {@link MarkerClusterer}.
     *
     * Currently set to use the following:
     *
     * ```typescript
     * // change color if this cluster has more markers than the mean cluster
     * const color =
     *   count > Math.max(10, stats.clusters.markers.mean)
     *     ? "#ff0000"
     *     : "#0000ff";
     *
     * // create svg url with fill color
     * const svg = window.btoa(`
     * <svg fill="${color}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240">
     *   <circle cx="120" cy="120" opacity=".6" r="70" />
     *   <circle cx="120" cy="120" opacity=".3" r="90" />
     *   <circle cx="120" cy="120" opacity=".2" r="110" />
     *   <circle cx="120" cy="120" opacity=".1" r="130" />
     * </svg>`);
     *
     * // create marker using svg icon
     * return new google.maps.Marker({
     *   position,
     *   icon: {
     *     url: `data:image/svg+xml;base64,${svg}`,
     *     scaledSize: new google.maps.Size(45, 45),
     *   },
     *   label: {
     *     text: String(count),
     *     color: "rgba(255,255,255,0.9)",
     *     fontSize: "12px",
     *   },
     *   // adjust zIndex to be above other markers
     *   zIndex: 1000 + count,
     * });
     * ```
     */ render({ count: count, position: position }, stats, map) {
        // change color if this cluster has more markers than the mean cluster
        const color = count > Math.max(10, stats.clusters.markers.mean) ? "#ff0000" : "#0000ff";
        // create svg literal with fill color
        const svg = `<svg fill="${color}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240" width="50" height="50">
<circle cx="120" cy="120" opacity=".6" r="70" />
<circle cx="120" cy="120" opacity=".3" r="90" />
<circle cx="120" cy="120" opacity=".2" r="110" />
<text x="50%" y="50%" style="fill:#fff" text-anchor="middle" font-size="50" dominant-baseline="middle" font-family="roboto,arial,sans-serif">${count}</text>
</svg>`;
        const title = `Cluster of ${count} markers`, // adjust zIndex to be above other markers
        zIndex = Number(google.maps.Marker.MAX_ZINDEX) + count;
        if ($de370fea0b9a0328$var$MarkerUtils.isAdvancedMarkerAvailable(map)) {
            // create cluster SVG element
            const div = document.createElement("div");
            div.innerHTML = svg;
            const svgEl = div.firstElementChild;
            svgEl.setAttribute("transform", "translate(0 25)");
            const clusterOptions = {
                map: map,
                position: position,
                zIndex: zIndex,
                title: title,
                content: svgEl
            };
            return new google.maps.marker.AdvancedMarkerElement(clusterOptions);
        }
        const clusterOptions = {
            position: position,
            zIndex: zIndex,
            title: title,
            icon: {
                url: `data:image/svg+xml;base64,${btoa(svg)}`,
                anchor: new google.maps.Point(25, 25)
            }
        };
        return new google.maps.Marker(clusterOptions);
    }
}
/**
 * Copyright 2019 Google LLC. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Extends an object's prototype by another's.
 *
 * @param type1 The Type to be extended.
 * @param type2 The Type to extend with.
 * @ignore
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $de370fea0b9a0328$var$extend(type1, type2) {
    /* istanbul ignore next */ // eslint-disable-next-line prefer-const
    for(let property in type2.prototype)type1.prototype[property] = type2.prototype[property];
}
/**
 * @ignore
 */ class $de370fea0b9a0328$var$OverlayViewSafe {
    constructor(){
        // MarkerClusterer implements google.maps.OverlayView interface. We use the
        // extend function to extend MarkerClusterer with google.maps.OverlayView
        // because it might not always be available when the code is defined so we
        // look for it at the last possible moment. If it doesn't exist now then
        // there is no point going ahead :)
        $de370fea0b9a0328$var$extend($de370fea0b9a0328$var$OverlayViewSafe, google.maps.OverlayView);
    }
}
/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $de370fea0b9a0328$var$MarkerClustererEvents;
(function(MarkerClustererEvents) {
    MarkerClustererEvents["CLUSTERING_BEGIN"] = "clusteringbegin";
    MarkerClustererEvents["CLUSTERING_END"] = "clusteringend";
    MarkerClustererEvents["CLUSTER_CLICK"] = "click";
})($de370fea0b9a0328$var$MarkerClustererEvents || ($de370fea0b9a0328$var$MarkerClustererEvents = {}));
const $de370fea0b9a0328$var$defaultOnClusterClickHandler = (_, cluster, map)=>{
    map.fitBounds(cluster.bounds);
};
/**
 * MarkerClusterer creates and manages per-zoom-level clusters for large amounts
 * of markers. See {@link MarkerClustererOptions} for more details.
 *
 */ class $de370fea0b9a0328$var$MarkerClusterer extends $de370fea0b9a0328$var$OverlayViewSafe {
    addMarker(marker, noDraw) {
        if (this.markers.includes(marker)) return;
        this.markers.push(marker);
        if (!noDraw) this.render();
    }
    addMarkers(markers, noDraw) {
        markers.forEach((marker)=>{
            this.addMarker(marker, true);
        });
        if (!noDraw) this.render();
    }
    removeMarker(marker, noDraw) {
        const index = this.markers.indexOf(marker);
        if (index === -1) // Marker is not in our list of markers, so do nothing:
        return false;
        $de370fea0b9a0328$var$MarkerUtils.setMap(marker, null);
        this.markers.splice(index, 1); // Remove the marker from the list of managed markers
        if (!noDraw) this.render();
        return true;
    }
    removeMarkers(markers, noDraw) {
        let removed = false;
        markers.forEach((marker)=>{
            removed = this.removeMarker(marker, true) || removed;
        });
        if (removed && !noDraw) this.render();
        return removed;
    }
    clearMarkers(noDraw) {
        this.markers.length = 0;
        if (!noDraw) this.render();
    }
    /**
     * Recalculates and draws all the marker clusters.
     */ render() {
        const map = this.getMap();
        if (map instanceof google.maps.Map && map.getProjection()) {
            google.maps.event.trigger(this, $de370fea0b9a0328$var$MarkerClustererEvents.CLUSTERING_BEGIN, this);
            const { clusters: clusters, changed: changed } = this.algorithm.calculate({
                markers: this.markers,
                map: map,
                mapCanvasProjection: this.getProjection()
            });
            // Allow algorithms to return flag on whether the clusters/markers have changed.
            if (changed || changed == undefined) {
                // Accumulate the markers of the clusters composed of a single marker.
                // Those clusters directly use the marker.
                // Clusters with more than one markers use a group marker generated by a renderer.
                const singleMarker = new Set();
                for (const cluster of clusters)if (cluster.markers.length == 1) singleMarker.add(cluster.markers[0]);
                const groupMarkers = [];
                // Iterate the clusters that are currently rendered.
                for (const cluster of this.clusters){
                    if (cluster.marker == null) continue;
                    if (cluster.markers.length == 1) {
                        if (!singleMarker.has(cluster.marker)) // The marker:
                        // - was previously rendered because it is from a cluster with 1 marker,
                        // - should no more be rendered as it is not in singleMarker.
                        $de370fea0b9a0328$var$MarkerUtils.setMap(cluster.marker, null);
                    } else // Delay the removal of old group markers to avoid flickering.
                    groupMarkers.push(cluster.marker);
                }
                this.clusters = clusters;
                this.renderClusters();
                // Delayed removal of the markers of the former groups.
                requestAnimationFrame(()=>groupMarkers.forEach((marker)=>$de370fea0b9a0328$var$MarkerUtils.setMap(marker, null)));
            }
            google.maps.event.trigger(this, $de370fea0b9a0328$var$MarkerClustererEvents.CLUSTERING_END, this);
        }
    }
    onAdd() {
        this.idleListener = this.getMap().addListener("idle", this.render.bind(this));
        this.render();
    }
    onRemove() {
        google.maps.event.removeListener(this.idleListener);
        this.reset();
    }
    reset() {
        this.markers.forEach((marker)=>$de370fea0b9a0328$var$MarkerUtils.setMap(marker, null));
        this.clusters.forEach((cluster)=>cluster.delete());
        this.clusters = [];
    }
    renderClusters() {
        // Generate stats to pass to renderers.
        const stats = new $de370fea0b9a0328$var$ClusterStats(this.markers, this.clusters);
        const map = this.getMap();
        this.clusters.forEach((cluster)=>{
            if (cluster.markers.length === 1) cluster.marker = cluster.markers[0];
            else {
                // Generate the marker to represent the group.
                cluster.marker = this.renderer.render(cluster, stats, map);
                // Make sure all individual markers are removed from the map.
                cluster.markers.forEach((marker)=>$de370fea0b9a0328$var$MarkerUtils.setMap(marker, null));
                if (this.onClusterClick) cluster.marker.addListener("click", /* istanbul ignore next */ (event)=>{
                    google.maps.event.trigger(this, $de370fea0b9a0328$var$MarkerClustererEvents.CLUSTER_CLICK, cluster);
                    this.onClusterClick(event, cluster, map);
                });
            }
            $de370fea0b9a0328$var$MarkerUtils.setMap(cluster.marker, map);
        });
    }
    constructor({ map: map, markers: markers = [], algorithmOptions: algorithmOptions = {}, algorithm: algorithm = new $de370fea0b9a0328$var$SuperClusterAlgorithm(algorithmOptions), renderer: renderer = new $de370fea0b9a0328$var$DefaultRenderer(), onClusterClick: onClusterClick = $de370fea0b9a0328$var$defaultOnClusterClickHandler }){
        super();
        this.markers = [
            ...markers
        ];
        this.clusters = [];
        this.algorithm = algorithm;
        this.renderer = renderer;
        this.onClusterClick = onClusterClick;
        if (map) this.setMap(map);
    }
}
var $de370fea0b9a0328$export$90b7fe3c3beeef75 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    AbstractAlgorithm: $de370fea0b9a0328$var$AbstractAlgorithm,
    AbstractViewportAlgorithm: $de370fea0b9a0328$var$AbstractViewportAlgorithm,
    Cluster: $de370fea0b9a0328$var$Cluster,
    ClusterStats: $de370fea0b9a0328$var$ClusterStats,
    DefaultRenderer: $de370fea0b9a0328$var$DefaultRenderer,
    GridAlgorithm: $de370fea0b9a0328$var$GridAlgorithm,
    MarkerClusterer: $de370fea0b9a0328$var$MarkerClusterer,
    get MarkerClustererEvents () {
        return $de370fea0b9a0328$var$MarkerClustererEvents;
    },
    NoopAlgorithm: $de370fea0b9a0328$var$NoopAlgorithm,
    SuperClusterAlgorithm: $de370fea0b9a0328$var$SuperClusterAlgorithm,
    defaultOnClusterClickHandler: $de370fea0b9a0328$var$defaultOnClusterClickHandler,
    distanceBetweenPoints: $de370fea0b9a0328$var$distanceBetweenPoints,
    extendBoundsToPaddedViewport: $de370fea0b9a0328$var$extendBoundsToPaddedViewport,
    extendPixelBounds: $de370fea0b9a0328$var$extendPixelBounds,
    filterMarkersToPaddedViewport: $de370fea0b9a0328$var$filterMarkersToPaddedViewport,
    noop: $de370fea0b9a0328$var$noop$1,
    pixelBoundsToLatLngBounds: $de370fea0b9a0328$var$pixelBoundsToLatLngBounds
});
function $de370fea0b9a0328$var$useGoogleMarkerClusterer(options) {
    var map = $de370fea0b9a0328$export$7105827ad5b8fcc3();
    var _a = (0, $b6HlZ.useState)(null), markerClusterer = _a[0], setMarkerClusterer = _a[1];
    (0, $b6HlZ.useEffect)(function() {
        if (map && markerClusterer === null) {
            var markerCluster = new $de370fea0b9a0328$var$MarkerClusterer($de370fea0b9a0328$var$__assign($de370fea0b9a0328$var$__assign({}, options), {
                map: map
            }));
            setMarkerClusterer(markerCluster);
        }
    }, [
        map
    ]);
    return markerClusterer;
}
/** Wrapper around [@googlemaps/markerclusterer](https://github.com/googlemaps/js-markerclusterer)
 *
 * Accepts {@link  MarkerClustererOptionsSubset} which is a subset of  {@link MarkerClustererOptions}
 */ function $de370fea0b9a0328$var$GoogleMarkerClusterer(_a) {
    var children = _a.children, options = _a.options;
    var markerClusterer = $de370fea0b9a0328$var$useGoogleMarkerClusterer(options);
    return markerClusterer !== null ? children(markerClusterer) : null;
}
var $de370fea0b9a0328$export$b2907449e9900b04 = (0, $b6HlZ.memo)($de370fea0b9a0328$var$GoogleMarkerClusterer);
var $de370fea0b9a0328$var$eventMap$c = {
    onCloseClick: "closeclick",
    onContentChanged: "content_changed",
    onDomReady: "domready",
    onPositionChanged: "position_changed",
    onZindexChanged: "zindex_changed"
};
var $de370fea0b9a0328$var$updaterMap$c = {
    options: function(instance, options) {
        instance.setOptions(options);
    },
    position: function(instance, position) {
        instance.setPosition(position);
    },
    zIndex: function(instance, zIndex) {
        instance.setZIndex(zIndex);
    }
};
function $de370fea0b9a0328$var$InfoWindowFunctional(_a) {
    var children = _a.children, anchor = _a.anchor, options = _a.options, position = _a.position, zIndex = _a.zIndex, onCloseClick = _a.onCloseClick, onDomReady = _a.onDomReady, onContentChanged = _a.onContentChanged, onPositionChanged = _a.onPositionChanged, onZindexChanged = _a.onZindexChanged, onLoad = _a.onLoad, onUnmount = _a.onUnmount;
    var map = (0, $b6HlZ.useContext)($de370fea0b9a0328$export$dc7344301ae78f85);
    var _b = (0, $b6HlZ.useState)(null), instance = _b[0], setInstance = _b[1];
    var _c = (0, $b6HlZ.useState)(null), closeclickListener = _c[0], setCloseClickListener = _c[1];
    var _d = (0, $b6HlZ.useState)(null), domreadyclickListener = _d[0], setDomReadyClickListener = _d[1];
    var _e = (0, $b6HlZ.useState)(null), contentchangedclickListener = _e[0], setContentChangedClickListener = _e[1];
    var _f = (0, $b6HlZ.useState)(null), positionchangedclickListener = _f[0], setPositionChangedClickListener = _f[1];
    var _g = (0, $b6HlZ.useState)(null), zindexchangedclickListener = _g[0], setZindexChangedClickListener = _g[1];
    var containerElementRef = (0, $b6HlZ.useRef)(null);
    // Order does matter
    (0, $b6HlZ.useEffect)(function() {
        if (instance !== null) {
            instance.close();
            if (anchor) instance.open(map, anchor);
            else if (instance.getPosition()) instance.open(map);
        }
    }, [
        map,
        instance,
        anchor
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (options && instance !== null) instance.setOptions(options);
    }, [
        instance,
        options
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (position && instance !== null) instance.setPosition(position);
    }, [
        position
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (typeof zIndex === "number" && instance !== null) instance.setZIndex(zIndex);
    }, [
        zIndex
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (instance && onCloseClick) {
            if (closeclickListener !== null) google.maps.event.removeListener(closeclickListener);
            setCloseClickListener(google.maps.event.addListener(instance, "closeclick", onCloseClick));
        }
    }, [
        onCloseClick
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (instance && onDomReady) {
            if (domreadyclickListener !== null) google.maps.event.removeListener(domreadyclickListener);
            setDomReadyClickListener(google.maps.event.addListener(instance, "domready", onDomReady));
        }
    }, [
        onDomReady
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (instance && onContentChanged) {
            if (contentchangedclickListener !== null) google.maps.event.removeListener(contentchangedclickListener);
            setContentChangedClickListener(google.maps.event.addListener(instance, "content_changed", onContentChanged));
        }
    }, [
        onContentChanged
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (instance && onPositionChanged) {
            if (positionchangedclickListener !== null) google.maps.event.removeListener(positionchangedclickListener);
            setPositionChangedClickListener(google.maps.event.addListener(instance, "position_changed", onPositionChanged));
        }
    }, [
        onPositionChanged
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (instance && onZindexChanged) {
            if (zindexchangedclickListener !== null) google.maps.event.removeListener(zindexchangedclickListener);
            setZindexChangedClickListener(google.maps.event.addListener(instance, "zindex_changed", onZindexChanged));
        }
    }, [
        onZindexChanged
    ]);
    (0, $b6HlZ.useEffect)(function() {
        var infoWindow = new google.maps.InfoWindow($de370fea0b9a0328$var$__assign({}, options || {}));
        setInstance(infoWindow);
        containerElementRef.current = document.createElement("div");
        if (onCloseClick) setCloseClickListener(google.maps.event.addListener(infoWindow, "closeclick", onCloseClick));
        if (onDomReady) setDomReadyClickListener(google.maps.event.addListener(infoWindow, "domready", onDomReady));
        if (onContentChanged) setContentChangedClickListener(google.maps.event.addListener(infoWindow, "content_changed", onContentChanged));
        if (onPositionChanged) setPositionChangedClickListener(google.maps.event.addListener(infoWindow, "position_changed", onPositionChanged));
        if (onZindexChanged) setZindexChangedClickListener(google.maps.event.addListener(infoWindow, "zindex_changed", onZindexChanged));
        infoWindow.setContent(containerElementRef.current);
        if (position) infoWindow.setPosition(position);
        if (zIndex) infoWindow.setZIndex(zIndex);
        if (anchor) infoWindow.open(map, anchor);
        else if (infoWindow.getPosition()) infoWindow.open(map);
        else $de370fea0b9a0328$var$invariant$1(false, "You must provide either an anchor (typically render it inside a <Marker>) or a position props for <InfoWindow>.");
        if (onLoad) onLoad(infoWindow);
        return function() {
            if (closeclickListener) google.maps.event.removeListener(closeclickListener);
            if (contentchangedclickListener) google.maps.event.removeListener(contentchangedclickListener);
            if (domreadyclickListener) google.maps.event.removeListener(domreadyclickListener);
            if (positionchangedclickListener) google.maps.event.removeListener(positionchangedclickListener);
            if (zindexchangedclickListener) google.maps.event.removeListener(zindexchangedclickListener);
            if (onUnmount) onUnmount(infoWindow);
            infoWindow.close();
        };
    }, []);
    return containerElementRef.current ? (0, $3uMgk.createPortal)((0, $b6HlZ.Children).only(children), containerElementRef.current) : null;
}
var $de370fea0b9a0328$export$b5b16f04c833e5f8 = (0, $b6HlZ.memo)($de370fea0b9a0328$var$InfoWindowFunctional);
var $de370fea0b9a0328$export$6cfec3928ae8881a = /** @class */ function(_super) {
    $de370fea0b9a0328$var$__extends(InfoWindow, _super);
    function InfoWindow() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.registeredEvents = [];
        _this.containerElement = null;
        _this.state = {
            infoWindow: null
        };
        _this.open = function(infoWindow, anchor) {
            if (anchor) infoWindow.open(_this.context, anchor);
            else if (infoWindow.getPosition()) infoWindow.open(_this.context);
            else $de370fea0b9a0328$var$invariant$1(false, "You must provide either an anchor (typically render it inside a <Marker>) or a position props for <InfoWindow>.");
        };
        _this.setInfoWindowCallback = function() {
            if (_this.state.infoWindow !== null && _this.containerElement !== null) {
                _this.state.infoWindow.setContent(_this.containerElement);
                _this.open(_this.state.infoWindow, _this.props.anchor);
                if (_this.props.onLoad) _this.props.onLoad(_this.state.infoWindow);
            }
        };
        return _this;
    }
    InfoWindow.prototype.componentDidMount = function() {
        var infoWindow = new google.maps.InfoWindow($de370fea0b9a0328$var$__assign({}, this.props.options || {}));
        this.containerElement = document.createElement("div");
        this.registeredEvents = $de370fea0b9a0328$var$applyUpdatersToPropsAndRegisterEvents({
            updaterMap: $de370fea0b9a0328$var$updaterMap$c,
            eventMap: $de370fea0b9a0328$var$eventMap$c,
            prevProps: {},
            nextProps: this.props,
            instance: infoWindow
        });
        this.setState(function() {
            return {
                infoWindow: infoWindow
            };
        }, this.setInfoWindowCallback);
    };
    InfoWindow.prototype.componentDidUpdate = function(prevProps) {
        if (this.state.infoWindow !== null) {
            $de370fea0b9a0328$var$unregisterEvents(this.registeredEvents);
            this.registeredEvents = $de370fea0b9a0328$var$applyUpdatersToPropsAndRegisterEvents({
                updaterMap: $de370fea0b9a0328$var$updaterMap$c,
                eventMap: $de370fea0b9a0328$var$eventMap$c,
                prevProps: prevProps,
                nextProps: this.props,
                instance: this.state.infoWindow
            });
        }
    };
    InfoWindow.prototype.componentWillUnmount = function() {
        if (this.state.infoWindow !== null) {
            $de370fea0b9a0328$var$unregisterEvents(this.registeredEvents);
            if (this.props.onUnmount) this.props.onUnmount(this.state.infoWindow);
            this.state.infoWindow.close();
        }
    };
    InfoWindow.prototype.render = function() {
        return this.containerElement ? (0, $3uMgk.createPortal)((0, $b6HlZ.Children).only(this.props.children), this.containerElement) : null;
    };
    InfoWindow.contextType = $de370fea0b9a0328$export$dc7344301ae78f85;
    return InfoWindow;
}((0, $b6HlZ.PureComponent));
var $de370fea0b9a0328$var$eventMap$b = {
    onClick: "click",
    onDblClick: "dblclick",
    onDrag: "drag",
    onDragEnd: "dragend",
    onDragStart: "dragstart",
    onMouseDown: "mousedown",
    onMouseMove: "mousemove",
    onMouseOut: "mouseout",
    onMouseOver: "mouseover",
    onMouseUp: "mouseup",
    onRightClick: "rightclick"
};
var $de370fea0b9a0328$var$updaterMap$b = {
    draggable: function(instance, draggable) {
        instance.setDraggable(draggable);
    },
    editable: function(instance, editable) {
        instance.setEditable(editable);
    },
    map: function(instance, map) {
        instance.setMap(map);
    },
    options: function(instance, options) {
        instance.setOptions(options);
    },
    path: function(instance, path) {
        instance.setPath(path);
    },
    visible: function(instance, visible) {
        instance.setVisible(visible);
    }
};
var $de370fea0b9a0328$var$defaultOptions$1 = {};
function $de370fea0b9a0328$var$PolylineFunctional(_a) {
    var options = _a.options, draggable = _a.draggable, editable = _a.editable, visible = _a.visible, path = _a.path, onDblClick = _a.onDblClick, onDragEnd = _a.onDragEnd, onDragStart = _a.onDragStart, onMouseDown = _a.onMouseDown, onMouseMove = _a.onMouseMove, onMouseOut = _a.onMouseOut, onMouseOver = _a.onMouseOver, onMouseUp = _a.onMouseUp, onRightClick = _a.onRightClick, onClick = _a.onClick, onDrag = _a.onDrag, onLoad = _a.onLoad, onUnmount = _a.onUnmount;
    var map = (0, $b6HlZ.useContext)($de370fea0b9a0328$export$dc7344301ae78f85);
    var _b = (0, $b6HlZ.useState)(null), instance = _b[0], setInstance = _b[1];
    var _c = (0, $b6HlZ.useState)(null), dblclickListener = _c[0], setDblclickListener = _c[1];
    var _d = (0, $b6HlZ.useState)(null), dragendListener = _d[0], setDragendListener = _d[1];
    var _e = (0, $b6HlZ.useState)(null), dragstartListener = _e[0], setDragstartListener = _e[1];
    var _f = (0, $b6HlZ.useState)(null), mousedownListener = _f[0], setMousedownListener = _f[1];
    var _g = (0, $b6HlZ.useState)(null), mousemoveListener = _g[0], setMousemoveListener = _g[1];
    var _h = (0, $b6HlZ.useState)(null), mouseoutListener = _h[0], setMouseoutListener = _h[1];
    var _j = (0, $b6HlZ.useState)(null), mouseoverListener = _j[0], setMouseoverListener = _j[1];
    var _k = (0, $b6HlZ.useState)(null), mouseupListener = _k[0], setMouseupListener = _k[1];
    var _l = (0, $b6HlZ.useState)(null), rightclickListener = _l[0], setRightclickListener = _l[1];
    var _m = (0, $b6HlZ.useState)(null), clickListener = _m[0], setClickListener = _m[1];
    var _o = (0, $b6HlZ.useState)(null), dragListener = _o[0], setDragListener = _o[1];
    // Order does matter
    (0, $b6HlZ.useEffect)(function() {
        if (instance !== null) instance.setMap(map);
    }, [
        map
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (typeof options !== "undefined" && instance !== null) instance.setOptions(options);
    }, [
        instance,
        options
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (typeof draggable !== "undefined" && instance !== null) instance.setDraggable(draggable);
    }, [
        instance,
        draggable
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (typeof editable !== "undefined" && instance !== null) instance.setEditable(editable);
    }, [
        instance,
        editable
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (typeof visible !== "undefined" && instance !== null) instance.setVisible(visible);
    }, [
        instance,
        visible
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (typeof path !== "undefined" && instance !== null) instance.setPath(path);
    }, [
        instance,
        path
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (instance && onDblClick) {
            if (dblclickListener !== null) google.maps.event.removeListener(dblclickListener);
            setDblclickListener(google.maps.event.addListener(instance, "dblclick", onDblClick));
        }
    }, [
        onDblClick
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (instance && onDragEnd) {
            if (dragendListener !== null) google.maps.event.removeListener(dragendListener);
            setDragendListener(google.maps.event.addListener(instance, "dragend", onDragEnd));
        }
    }, [
        onDragEnd
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (instance && onDragStart) {
            if (dragstartListener !== null) google.maps.event.removeListener(dragstartListener);
            setDragstartListener(google.maps.event.addListener(instance, "dragstart", onDragStart));
        }
    }, [
        onDragStart
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (instance && onMouseDown) {
            if (mousedownListener !== null) google.maps.event.removeListener(mousedownListener);
            setMousedownListener(google.maps.event.addListener(instance, "mousedown", onMouseDown));
        }
    }, [
        onMouseDown
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (instance && onMouseMove) {
            if (mousemoveListener !== null) google.maps.event.removeListener(mousemoveListener);
            setMousemoveListener(google.maps.event.addListener(instance, "mousemove", onMouseMove));
        }
    }, [
        onMouseMove
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (instance && onMouseOut) {
            if (mouseoutListener !== null) google.maps.event.removeListener(mouseoutListener);
            setMouseoutListener(google.maps.event.addListener(instance, "mouseout", onMouseOut));
        }
    }, [
        onMouseOut
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (instance && onMouseOver) {
            if (mouseoverListener !== null) google.maps.event.removeListener(mouseoverListener);
            setMouseoverListener(google.maps.event.addListener(instance, "mouseover", onMouseOver));
        }
    }, [
        onMouseOver
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (instance && onMouseUp) {
            if (mouseupListener !== null) google.maps.event.removeListener(mouseupListener);
            setMouseupListener(google.maps.event.addListener(instance, "mouseup", onMouseUp));
        }
    }, [
        onMouseUp
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (instance && onRightClick) {
            if (rightclickListener !== null) google.maps.event.removeListener(rightclickListener);
            setRightclickListener(google.maps.event.addListener(instance, "rightclick", onRightClick));
        }
    }, [
        onRightClick
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (instance && onClick) {
            if (clickListener !== null) google.maps.event.removeListener(clickListener);
            setClickListener(google.maps.event.addListener(instance, "click", onClick));
        }
    }, [
        onClick
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (instance && onDrag) {
            if (dragListener !== null) google.maps.event.removeListener(dragListener);
            setDragListener(google.maps.event.addListener(instance, "drag", onDrag));
        }
    }, [
        onDrag
    ]);
    (0, $b6HlZ.useEffect)(function() {
        var polyline = new google.maps.Polyline($de370fea0b9a0328$var$__assign($de370fea0b9a0328$var$__assign({}, options || $de370fea0b9a0328$var$defaultOptions$1), {
            map: map
        }));
        if (path) polyline.setPath(path);
        if (typeof visible !== "undefined") polyline.setVisible(visible);
        if (typeof editable !== "undefined") polyline.setEditable(editable);
        if (typeof draggable !== "undefined") polyline.setDraggable(draggable);
        if (onDblClick) setDblclickListener(google.maps.event.addListener(polyline, "dblclick", onDblClick));
        if (onDragEnd) setDragendListener(google.maps.event.addListener(polyline, "dragend", onDragEnd));
        if (onDragStart) setDragstartListener(google.maps.event.addListener(polyline, "dragstart", onDragStart));
        if (onMouseDown) setMousedownListener(google.maps.event.addListener(polyline, "mousedown", onMouseDown));
        if (onMouseMove) setMousemoveListener(google.maps.event.addListener(polyline, "mousemove", onMouseMove));
        if (onMouseOut) setMouseoutListener(google.maps.event.addListener(polyline, "mouseout", onMouseOut));
        if (onMouseOver) setMouseoverListener(google.maps.event.addListener(polyline, "mouseover", onMouseOver));
        if (onMouseUp) setMouseupListener(google.maps.event.addListener(polyline, "mouseup", onMouseUp));
        if (onRightClick) setRightclickListener(google.maps.event.addListener(polyline, "rightclick", onRightClick));
        if (onClick) setClickListener(google.maps.event.addListener(polyline, "click", onClick));
        if (onDrag) setDragListener(google.maps.event.addListener(polyline, "drag", onDrag));
        setInstance(polyline);
        if (onLoad) onLoad(polyline);
        return function() {
            if (dblclickListener !== null) google.maps.event.removeListener(dblclickListener);
            if (dragendListener !== null) google.maps.event.removeListener(dragendListener);
            if (dragstartListener !== null) google.maps.event.removeListener(dragstartListener);
            if (mousedownListener !== null) google.maps.event.removeListener(mousedownListener);
            if (mousemoveListener !== null) google.maps.event.removeListener(mousemoveListener);
            if (mouseoutListener !== null) google.maps.event.removeListener(mouseoutListener);
            if (mouseoverListener !== null) google.maps.event.removeListener(mouseoverListener);
            if (mouseupListener !== null) google.maps.event.removeListener(mouseupListener);
            if (rightclickListener !== null) google.maps.event.removeListener(rightclickListener);
            if (clickListener !== null) google.maps.event.removeListener(clickListener);
            if (onUnmount) onUnmount(polyline);
            polyline.setMap(null);
        };
    }, []);
    return null;
}
var $de370fea0b9a0328$export$39fd54d61530677a = (0, $b6HlZ.memo)($de370fea0b9a0328$var$PolylineFunctional);
var $de370fea0b9a0328$export$79f3ee03e63e7073 = /** @class */ function(_super) {
    $de370fea0b9a0328$var$__extends(Polyline, _super);
    function Polyline() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.registeredEvents = [];
        _this.state = {
            polyline: null
        };
        _this.setPolylineCallback = function() {
            if (_this.state.polyline !== null && _this.props.onLoad) _this.props.onLoad(_this.state.polyline);
        };
        return _this;
    }
    Polyline.prototype.componentDidMount = function() {
        var polyline = new google.maps.Polyline($de370fea0b9a0328$var$__assign($de370fea0b9a0328$var$__assign({}, this.props.options || {}), {
            map: this.context
        }));
        this.registeredEvents = $de370fea0b9a0328$var$applyUpdatersToPropsAndRegisterEvents({
            updaterMap: $de370fea0b9a0328$var$updaterMap$b,
            eventMap: $de370fea0b9a0328$var$eventMap$b,
            prevProps: {},
            nextProps: this.props,
            instance: polyline
        });
        this.setState(function setPolyline() {
            return {
                polyline: polyline
            };
        }, this.setPolylineCallback);
    };
    Polyline.prototype.componentDidUpdate = function(prevProps) {
        if (this.state.polyline !== null) {
            $de370fea0b9a0328$var$unregisterEvents(this.registeredEvents);
            this.registeredEvents = $de370fea0b9a0328$var$applyUpdatersToPropsAndRegisterEvents({
                updaterMap: $de370fea0b9a0328$var$updaterMap$b,
                eventMap: $de370fea0b9a0328$var$eventMap$b,
                prevProps: prevProps,
                nextProps: this.props,
                instance: this.state.polyline
            });
        }
    };
    Polyline.prototype.componentWillUnmount = function() {
        if (this.state.polyline !== null) {
            if (this.props.onUnmount) this.props.onUnmount(this.state.polyline);
            $de370fea0b9a0328$var$unregisterEvents(this.registeredEvents);
            this.state.polyline.setMap(null);
        }
    };
    Polyline.prototype.render = function() {
        return null;
    };
    Polyline.contextType = $de370fea0b9a0328$export$dc7344301ae78f85;
    return Polyline;
}((0, $b6HlZ.PureComponent));
var $de370fea0b9a0328$var$eventMap$a = {
    onClick: "click",
    onDblClick: "dblclick",
    onDrag: "drag",
    onDragEnd: "dragend",
    onDragStart: "dragstart",
    onMouseDown: "mousedown",
    onMouseMove: "mousemove",
    onMouseOut: "mouseout",
    onMouseOver: "mouseover",
    onMouseUp: "mouseup",
    onRightClick: "rightclick"
};
var $de370fea0b9a0328$var$updaterMap$a = {
    draggable: function(instance, draggable) {
        instance.setDraggable(draggable);
    },
    editable: function(instance, editable) {
        instance.setEditable(editable);
    },
    map: function(instance, map) {
        instance.setMap(map);
    },
    options: function(instance, options) {
        instance.setOptions(options);
    },
    path: function(instance, path) {
        instance.setPath(path);
    },
    paths: function(instance, paths) {
        instance.setPaths(paths);
    },
    visible: function(instance, visible) {
        instance.setVisible(visible);
    }
};
function $de370fea0b9a0328$var$PolygonFunctional(_a) {
    var options = _a.options, draggable = _a.draggable, editable = _a.editable, visible = _a.visible, path = _a.path, paths = _a.paths, onDblClick = _a.onDblClick, onDragEnd = _a.onDragEnd, onDragStart = _a.onDragStart, onMouseDown = _a.onMouseDown, onMouseMove = _a.onMouseMove, onMouseOut = _a.onMouseOut, onMouseOver = _a.onMouseOver, onMouseUp = _a.onMouseUp, onRightClick = _a.onRightClick, onClick = _a.onClick, onDrag = _a.onDrag, onLoad = _a.onLoad, onUnmount = _a.onUnmount;
    var map = (0, $b6HlZ.useContext)($de370fea0b9a0328$export$dc7344301ae78f85);
    var _b = (0, $b6HlZ.useState)(null), instance = _b[0], setInstance = _b[1];
    var _c = (0, $b6HlZ.useState)(null), dblclickListener = _c[0], setDblclickListener = _c[1];
    var _d = (0, $b6HlZ.useState)(null), dragendListener = _d[0], setDragendListener = _d[1];
    var _e = (0, $b6HlZ.useState)(null), dragstartListener = _e[0], setDragstartListener = _e[1];
    var _f = (0, $b6HlZ.useState)(null), mousedownListener = _f[0], setMousedownListener = _f[1];
    var _g = (0, $b6HlZ.useState)(null), mousemoveListener = _g[0], setMousemoveListener = _g[1];
    var _h = (0, $b6HlZ.useState)(null), mouseoutListener = _h[0], setMouseoutListener = _h[1];
    var _j = (0, $b6HlZ.useState)(null), mouseoverListener = _j[0], setMouseoverListener = _j[1];
    var _k = (0, $b6HlZ.useState)(null), mouseupListener = _k[0], setMouseupListener = _k[1];
    var _l = (0, $b6HlZ.useState)(null), rightclickListener = _l[0], setRightclickListener = _l[1];
    var _m = (0, $b6HlZ.useState)(null), clickListener = _m[0], setClickListener = _m[1];
    var _o = (0, $b6HlZ.useState)(null), dragListener = _o[0], setDragListener = _o[1];
    // Order does matter
    (0, $b6HlZ.useEffect)(function() {
        if (instance !== null) instance.setMap(map);
    }, [
        map
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (typeof options !== "undefined" && instance !== null) instance.setOptions(options);
    }, [
        instance,
        options
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (typeof draggable !== "undefined" && instance !== null) instance.setDraggable(draggable);
    }, [
        instance,
        draggable
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (typeof editable !== "undefined" && instance !== null) instance.setEditable(editable);
    }, [
        instance,
        editable
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (typeof visible !== "undefined" && instance !== null) instance.setVisible(visible);
    }, [
        instance,
        visible
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (typeof path !== "undefined" && instance !== null) instance.setPath(path);
    }, [
        instance,
        path
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (typeof paths !== "undefined" && instance !== null) instance.setPaths(paths);
    }, [
        instance,
        paths
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (instance && onDblClick) {
            if (dblclickListener !== null) google.maps.event.removeListener(dblclickListener);
            setDblclickListener(google.maps.event.addListener(instance, "dblclick", onDblClick));
        }
    }, [
        onDblClick
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (instance && onDragEnd) {
            if (dragendListener !== null) google.maps.event.removeListener(dragendListener);
            setDragendListener(google.maps.event.addListener(instance, "dragend", onDragEnd));
        }
    }, [
        onDragEnd
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (instance && onDragStart) {
            if (dragstartListener !== null) google.maps.event.removeListener(dragstartListener);
            setDragstartListener(google.maps.event.addListener(instance, "dragstart", onDragStart));
        }
    }, [
        onDragStart
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (instance && onMouseDown) {
            if (mousedownListener !== null) google.maps.event.removeListener(mousedownListener);
            setMousedownListener(google.maps.event.addListener(instance, "mousedown", onMouseDown));
        }
    }, [
        onMouseDown
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (instance && onMouseMove) {
            if (mousemoveListener !== null) google.maps.event.removeListener(mousemoveListener);
            setMousemoveListener(google.maps.event.addListener(instance, "mousemove", onMouseMove));
        }
    }, [
        onMouseMove
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (instance && onMouseOut) {
            if (mouseoutListener !== null) google.maps.event.removeListener(mouseoutListener);
            setMouseoutListener(google.maps.event.addListener(instance, "mouseout", onMouseOut));
        }
    }, [
        onMouseOut
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (instance && onMouseOver) {
            if (mouseoverListener !== null) google.maps.event.removeListener(mouseoverListener);
            setMouseoverListener(google.maps.event.addListener(instance, "mouseover", onMouseOver));
        }
    }, [
        onMouseOver
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (instance && onMouseUp) {
            if (mouseupListener !== null) google.maps.event.removeListener(mouseupListener);
            setMouseupListener(google.maps.event.addListener(instance, "mouseup", onMouseUp));
        }
    }, [
        onMouseUp
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (instance && onRightClick) {
            if (rightclickListener !== null) google.maps.event.removeListener(rightclickListener);
            setRightclickListener(google.maps.event.addListener(instance, "rightclick", onRightClick));
        }
    }, [
        onRightClick
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (instance && onClick) {
            if (clickListener !== null) google.maps.event.removeListener(clickListener);
            setClickListener(google.maps.event.addListener(instance, "click", onClick));
        }
    }, [
        onClick
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (instance && onDrag) {
            if (dragListener !== null) google.maps.event.removeListener(dragListener);
            setDragListener(google.maps.event.addListener(instance, "drag", onDrag));
        }
    }, [
        onDrag
    ]);
    (0, $b6HlZ.useEffect)(function() {
        var polygon = new google.maps.Polygon($de370fea0b9a0328$var$__assign($de370fea0b9a0328$var$__assign({}, options || {}), {
            map: map
        }));
        if (path) polygon.setPath(path);
        if (paths) polygon.setPaths(paths);
        if (typeof visible !== "undefined") polygon.setVisible(visible);
        if (typeof editable !== "undefined") polygon.setEditable(editable);
        if (typeof draggable !== "undefined") polygon.setDraggable(draggable);
        if (onDblClick) setDblclickListener(google.maps.event.addListener(polygon, "dblclick", onDblClick));
        if (onDragEnd) setDragendListener(google.maps.event.addListener(polygon, "dragend", onDragEnd));
        if (onDragStart) setDragstartListener(google.maps.event.addListener(polygon, "dragstart", onDragStart));
        if (onMouseDown) setMousedownListener(google.maps.event.addListener(polygon, "mousedown", onMouseDown));
        if (onMouseMove) setMousemoveListener(google.maps.event.addListener(polygon, "mousemove", onMouseMove));
        if (onMouseOut) setMouseoutListener(google.maps.event.addListener(polygon, "mouseout", onMouseOut));
        if (onMouseOver) setMouseoverListener(google.maps.event.addListener(polygon, "mouseover", onMouseOver));
        if (onMouseUp) setMouseupListener(google.maps.event.addListener(polygon, "mouseup", onMouseUp));
        if (onRightClick) setRightclickListener(google.maps.event.addListener(polygon, "rightclick", onRightClick));
        if (onClick) setClickListener(google.maps.event.addListener(polygon, "click", onClick));
        if (onDrag) setDragListener(google.maps.event.addListener(polygon, "drag", onDrag));
        setInstance(polygon);
        if (onLoad) onLoad(polygon);
        return function() {
            if (dblclickListener !== null) google.maps.event.removeListener(dblclickListener);
            if (dragendListener !== null) google.maps.event.removeListener(dragendListener);
            if (dragstartListener !== null) google.maps.event.removeListener(dragstartListener);
            if (mousedownListener !== null) google.maps.event.removeListener(mousedownListener);
            if (mousemoveListener !== null) google.maps.event.removeListener(mousemoveListener);
            if (mouseoutListener !== null) google.maps.event.removeListener(mouseoutListener);
            if (mouseoverListener !== null) google.maps.event.removeListener(mouseoverListener);
            if (mouseupListener !== null) google.maps.event.removeListener(mouseupListener);
            if (rightclickListener !== null) google.maps.event.removeListener(rightclickListener);
            if (clickListener !== null) google.maps.event.removeListener(clickListener);
            if (onUnmount) onUnmount(polygon);
            polygon.setMap(null);
        };
    }, []);
    return null;
}
var $de370fea0b9a0328$export$ab86017aa51932cd = (0, $b6HlZ.memo)($de370fea0b9a0328$var$PolygonFunctional);
var $de370fea0b9a0328$export$7d31b617c820d435 = /** @class */ function(_super) {
    $de370fea0b9a0328$var$__extends(Polygon, _super);
    function Polygon() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.registeredEvents = [];
        _this.state = {
            polygon: null
        };
        _this.setPolygonCallback = function() {
            if (_this.state.polygon !== null && _this.props.onLoad) _this.props.onLoad(_this.state.polygon);
        };
        return _this;
    }
    Polygon.prototype.componentDidMount = function() {
        var polygon = new google.maps.Polygon($de370fea0b9a0328$var$__assign($de370fea0b9a0328$var$__assign({}, this.props.options || {}), {
            map: this.context
        }));
        this.registeredEvents = $de370fea0b9a0328$var$applyUpdatersToPropsAndRegisterEvents({
            updaterMap: $de370fea0b9a0328$var$updaterMap$a,
            eventMap: $de370fea0b9a0328$var$eventMap$a,
            prevProps: {},
            nextProps: this.props,
            instance: polygon
        });
        this.setState(function setPolygon() {
            return {
                polygon: polygon
            };
        }, this.setPolygonCallback);
    };
    Polygon.prototype.componentDidUpdate = function(prevProps) {
        if (this.state.polygon !== null) {
            $de370fea0b9a0328$var$unregisterEvents(this.registeredEvents);
            this.registeredEvents = $de370fea0b9a0328$var$applyUpdatersToPropsAndRegisterEvents({
                updaterMap: $de370fea0b9a0328$var$updaterMap$a,
                eventMap: $de370fea0b9a0328$var$eventMap$a,
                prevProps: prevProps,
                nextProps: this.props,
                instance: this.state.polygon
            });
        }
    };
    Polygon.prototype.componentWillUnmount = function() {
        if (this.state.polygon !== null) {
            if (this.props.onUnmount) this.props.onUnmount(this.state.polygon);
            $de370fea0b9a0328$var$unregisterEvents(this.registeredEvents);
            this.state.polygon && this.state.polygon.setMap(null);
        }
    };
    Polygon.prototype.render = function() {
        return null;
    };
    Polygon.contextType = $de370fea0b9a0328$export$dc7344301ae78f85;
    return Polygon;
}((0, $b6HlZ.PureComponent));
var $de370fea0b9a0328$var$eventMap$9 = {
    onBoundsChanged: "bounds_changed",
    onClick: "click",
    onDblClick: "dblclick",
    onDrag: "drag",
    onDragEnd: "dragend",
    onDragStart: "dragstart",
    onMouseDown: "mousedown",
    onMouseMove: "mousemove",
    onMouseOut: "mouseout",
    onMouseOver: "mouseover",
    onMouseUp: "mouseup",
    onRightClick: "rightclick"
};
var $de370fea0b9a0328$var$updaterMap$9 = {
    bounds: function(instance, bounds) {
        instance.setBounds(bounds);
    },
    draggable: function(instance, draggable) {
        instance.setDraggable(draggable);
    },
    editable: function(instance, editable) {
        instance.setEditable(editable);
    },
    map: function(instance, map) {
        instance.setMap(map);
    },
    options: function(instance, options) {
        instance.setOptions(options);
    },
    visible: function(instance, visible) {
        instance.setVisible(visible);
    }
};
function $de370fea0b9a0328$var$RectangleFunctional(_a) {
    var options = _a.options, bounds = _a.bounds, draggable = _a.draggable, editable = _a.editable, visible = _a.visible, onDblClick = _a.onDblClick, onDragEnd = _a.onDragEnd, onDragStart = _a.onDragStart, onMouseDown = _a.onMouseDown, onMouseMove = _a.onMouseMove, onMouseOut = _a.onMouseOut, onMouseOver = _a.onMouseOver, onMouseUp = _a.onMouseUp, onRightClick = _a.onRightClick, onClick = _a.onClick, onDrag = _a.onDrag, onBoundsChanged = _a.onBoundsChanged, onLoad = _a.onLoad, onUnmount = _a.onUnmount;
    var map = (0, $b6HlZ.useContext)($de370fea0b9a0328$export$dc7344301ae78f85);
    var _b = (0, $b6HlZ.useState)(null), instance = _b[0], setInstance = _b[1];
    var _c = (0, $b6HlZ.useState)(null), dblclickListener = _c[0], setDblclickListener = _c[1];
    var _d = (0, $b6HlZ.useState)(null), dragendListener = _d[0], setDragendListener = _d[1];
    var _e = (0, $b6HlZ.useState)(null), dragstartListener = _e[0], setDragstartListener = _e[1];
    var _f = (0, $b6HlZ.useState)(null), mousedownListener = _f[0], setMousedownListener = _f[1];
    var _g = (0, $b6HlZ.useState)(null), mousemoveListener = _g[0], setMousemoveListener = _g[1];
    var _h = (0, $b6HlZ.useState)(null), mouseoutListener = _h[0], setMouseoutListener = _h[1];
    var _j = (0, $b6HlZ.useState)(null), mouseoverListener = _j[0], setMouseoverListener = _j[1];
    var _k = (0, $b6HlZ.useState)(null), mouseupListener = _k[0], setMouseupListener = _k[1];
    var _l = (0, $b6HlZ.useState)(null), rightClickListener = _l[0], setRightClickListener = _l[1];
    var _m = (0, $b6HlZ.useState)(null), clickListener = _m[0], setClickListener = _m[1];
    var _o = (0, $b6HlZ.useState)(null), dragListener = _o[0], setDragListener = _o[1];
    var _p = (0, $b6HlZ.useState)(null), boundsChangedListener = _p[0], setBoundsChangedListener = _p[1];
    // Order does matter
    (0, $b6HlZ.useEffect)(function() {
        if (instance !== null) instance.setMap(map);
    }, [
        map
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (typeof options !== "undefined" && instance !== null) instance.setOptions(options);
    }, [
        instance,
        options
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (typeof draggable !== "undefined" && instance !== null) instance.setDraggable(draggable);
    }, [
        instance,
        draggable
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (typeof editable !== "undefined" && instance !== null) instance.setEditable(editable);
    }, [
        instance,
        editable
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (typeof visible !== "undefined" && instance !== null) instance.setVisible(visible);
    }, [
        instance,
        visible
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (typeof bounds !== "undefined" && instance !== null) instance.setBounds(bounds);
    }, [
        instance,
        bounds
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (instance && onDblClick) {
            if (dblclickListener !== null) google.maps.event.removeListener(dblclickListener);
            setDblclickListener(google.maps.event.addListener(instance, "dblclick", onDblClick));
        }
    }, [
        onDblClick
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (instance && onDragEnd) {
            if (dragendListener !== null) google.maps.event.removeListener(dragendListener);
            setDragendListener(google.maps.event.addListener(instance, "dragend", onDragEnd));
        }
    }, [
        onDragEnd
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (instance && onDragStart) {
            if (dragstartListener !== null) google.maps.event.removeListener(dragstartListener);
            setDragstartListener(google.maps.event.addListener(instance, "dragstart", onDragStart));
        }
    }, [
        onDragStart
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (instance && onMouseDown) {
            if (mousedownListener !== null) google.maps.event.removeListener(mousedownListener);
            setMousedownListener(google.maps.event.addListener(instance, "mousedown", onMouseDown));
        }
    }, [
        onMouseDown
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (instance && onMouseMove) {
            if (mousemoveListener !== null) google.maps.event.removeListener(mousemoveListener);
            setMousemoveListener(google.maps.event.addListener(instance, "mousemove", onMouseMove));
        }
    }, [
        onMouseMove
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (instance && onMouseOut) {
            if (mouseoutListener !== null) google.maps.event.removeListener(mouseoutListener);
            setMouseoutListener(google.maps.event.addListener(instance, "mouseout", onMouseOut));
        }
    }, [
        onMouseOut
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (instance && onMouseOver) {
            if (mouseoverListener !== null) google.maps.event.removeListener(mouseoverListener);
            setMouseoverListener(google.maps.event.addListener(instance, "mouseover", onMouseOver));
        }
    }, [
        onMouseOver
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (instance && onMouseUp) {
            if (mouseupListener !== null) google.maps.event.removeListener(mouseupListener);
            setMouseupListener(google.maps.event.addListener(instance, "mouseup", onMouseUp));
        }
    }, [
        onMouseUp
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (instance && onRightClick) {
            if (rightClickListener !== null) google.maps.event.removeListener(rightClickListener);
            setRightClickListener(google.maps.event.addListener(instance, "rightclick", onRightClick));
        }
    }, [
        onRightClick
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (instance && onClick) {
            if (clickListener !== null) google.maps.event.removeListener(clickListener);
            setClickListener(google.maps.event.addListener(instance, "click", onClick));
        }
    }, [
        onClick
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (instance && onDrag) {
            if (dragListener !== null) google.maps.event.removeListener(dragListener);
            setDragListener(google.maps.event.addListener(instance, "drag", onDrag));
        }
    }, [
        onDrag
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (instance && onBoundsChanged) {
            if (boundsChangedListener !== null) google.maps.event.removeListener(boundsChangedListener);
            setBoundsChangedListener(google.maps.event.addListener(instance, "bounds_changed", onBoundsChanged));
        }
    }, [
        onBoundsChanged
    ]);
    (0, $b6HlZ.useEffect)(function() {
        var rectangle = new google.maps.Rectangle($de370fea0b9a0328$var$__assign($de370fea0b9a0328$var$__assign({}, options || {}), {
            map: map
        }));
        if (typeof visible !== "undefined") rectangle.setVisible(visible);
        if (typeof editable !== "undefined") rectangle.setEditable(editable);
        if (typeof draggable !== "undefined") rectangle.setDraggable(draggable);
        if (typeof bounds !== "undefined") rectangle.setBounds(bounds);
        if (onDblClick) setDblclickListener(google.maps.event.addListener(rectangle, "dblclick", onDblClick));
        if (onDragEnd) setDragendListener(google.maps.event.addListener(rectangle, "dragend", onDragEnd));
        if (onDragStart) setDragstartListener(google.maps.event.addListener(rectangle, "dragstart", onDragStart));
        if (onMouseDown) setMousedownListener(google.maps.event.addListener(rectangle, "mousedown", onMouseDown));
        if (onMouseMove) setMousemoveListener(google.maps.event.addListener(rectangle, "mousemove", onMouseMove));
        if (onMouseOut) setMouseoutListener(google.maps.event.addListener(rectangle, "mouseout", onMouseOut));
        if (onMouseOver) setMouseoverListener(google.maps.event.addListener(rectangle, "mouseover", onMouseOver));
        if (onMouseUp) setMouseupListener(google.maps.event.addListener(rectangle, "mouseup", onMouseUp));
        if (onRightClick) setRightClickListener(google.maps.event.addListener(rectangle, "rightclick", onRightClick));
        if (onClick) setClickListener(google.maps.event.addListener(rectangle, "click", onClick));
        if (onDrag) setDragListener(google.maps.event.addListener(rectangle, "drag", onDrag));
        if (onBoundsChanged) setBoundsChangedListener(google.maps.event.addListener(rectangle, "bounds_changed", onBoundsChanged));
        setInstance(rectangle);
        if (onLoad) onLoad(rectangle);
        return function() {
            if (dblclickListener !== null) google.maps.event.removeListener(dblclickListener);
            if (dragendListener !== null) google.maps.event.removeListener(dragendListener);
            if (dragstartListener !== null) google.maps.event.removeListener(dragstartListener);
            if (mousedownListener !== null) google.maps.event.removeListener(mousedownListener);
            if (mousemoveListener !== null) google.maps.event.removeListener(mousemoveListener);
            if (mouseoutListener !== null) google.maps.event.removeListener(mouseoutListener);
            if (mouseoverListener !== null) google.maps.event.removeListener(mouseoverListener);
            if (mouseupListener !== null) google.maps.event.removeListener(mouseupListener);
            if (rightClickListener !== null) google.maps.event.removeListener(rightClickListener);
            if (clickListener !== null) google.maps.event.removeListener(clickListener);
            if (dragListener !== null) google.maps.event.removeListener(dragListener);
            if (boundsChangedListener !== null) google.maps.event.removeListener(boundsChangedListener);
            if (onUnmount) onUnmount(rectangle);
            rectangle.setMap(null);
        };
    }, []);
    return null;
}
var $de370fea0b9a0328$export$6543fe32ba958b02 = (0, $b6HlZ.memo)($de370fea0b9a0328$var$RectangleFunctional);
var $de370fea0b9a0328$export$4617fb02663045ef = /** @class */ function(_super) {
    $de370fea0b9a0328$var$__extends(Rectangle, _super);
    function Rectangle() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.registeredEvents = [];
        _this.state = {
            rectangle: null
        };
        _this.setRectangleCallback = function() {
            if (_this.state.rectangle !== null && _this.props.onLoad) _this.props.onLoad(_this.state.rectangle);
        };
        return _this;
    }
    Rectangle.prototype.componentDidMount = function() {
        var rectangle = new google.maps.Rectangle($de370fea0b9a0328$var$__assign($de370fea0b9a0328$var$__assign({}, this.props.options || {}), {
            map: this.context
        }));
        this.registeredEvents = $de370fea0b9a0328$var$applyUpdatersToPropsAndRegisterEvents({
            updaterMap: $de370fea0b9a0328$var$updaterMap$9,
            eventMap: $de370fea0b9a0328$var$eventMap$9,
            prevProps: {},
            nextProps: this.props,
            instance: rectangle
        });
        this.setState(function setRectangle() {
            return {
                rectangle: rectangle
            };
        }, this.setRectangleCallback);
    };
    Rectangle.prototype.componentDidUpdate = function(prevProps) {
        if (this.state.rectangle !== null) {
            $de370fea0b9a0328$var$unregisterEvents(this.registeredEvents);
            this.registeredEvents = $de370fea0b9a0328$var$applyUpdatersToPropsAndRegisterEvents({
                updaterMap: $de370fea0b9a0328$var$updaterMap$9,
                eventMap: $de370fea0b9a0328$var$eventMap$9,
                prevProps: prevProps,
                nextProps: this.props,
                instance: this.state.rectangle
            });
        }
    };
    Rectangle.prototype.componentWillUnmount = function() {
        if (this.state.rectangle !== null) {
            if (this.props.onUnmount) this.props.onUnmount(this.state.rectangle);
            $de370fea0b9a0328$var$unregisterEvents(this.registeredEvents);
            this.state.rectangle.setMap(null);
        }
    };
    Rectangle.prototype.render = function() {
        return null;
    };
    Rectangle.contextType = $de370fea0b9a0328$export$dc7344301ae78f85;
    return Rectangle;
}((0, $b6HlZ.PureComponent));
var $de370fea0b9a0328$var$eventMap$8 = {
    onCenterChanged: "center_changed",
    onRadiusChanged: "radius_changed",
    onClick: "click",
    onDblClick: "dblclick",
    onDrag: "drag",
    onDragEnd: "dragend",
    onDragStart: "dragstart",
    onMouseDown: "mousedown",
    onMouseMove: "mousemove",
    onMouseOut: "mouseout",
    onMouseOver: "mouseover",
    onMouseUp: "mouseup",
    onRightClick: "rightclick"
};
var $de370fea0b9a0328$var$updaterMap$8 = {
    center: function(instance, center) {
        instance.setCenter(center);
    },
    draggable: function(instance, draggable) {
        instance.setDraggable(draggable);
    },
    editable: function(instance, editable) {
        instance.setEditable(editable);
    },
    map: function(instance, map) {
        instance.setMap(map);
    },
    options: function(instance, options) {
        instance.setOptions(options);
    },
    radius: function(instance, radius) {
        instance.setRadius(radius);
    },
    visible: function(instance, visible) {
        instance.setVisible(visible);
    }
};
var $de370fea0b9a0328$var$defaultOptions = {};
function $de370fea0b9a0328$var$CircleFunctional(_a) {
    var options = _a.options, center = _a.center, radius = _a.radius, draggable = _a.draggable, editable = _a.editable, visible = _a.visible, onDblClick = _a.onDblClick, onDragEnd = _a.onDragEnd, onDragStart = _a.onDragStart, onMouseDown = _a.onMouseDown, onMouseMove = _a.onMouseMove, onMouseOut = _a.onMouseOut, onMouseOver = _a.onMouseOver, onMouseUp = _a.onMouseUp, onRightClick = _a.onRightClick, onClick = _a.onClick, onDrag = _a.onDrag, onCenterChanged = _a.onCenterChanged, onRadiusChanged = _a.onRadiusChanged, onLoad = _a.onLoad, onUnmount = _a.onUnmount;
    var map = (0, $b6HlZ.useContext)($de370fea0b9a0328$export$dc7344301ae78f85);
    var _b = (0, $b6HlZ.useState)(null), instance = _b[0], setInstance = _b[1];
    var _c = (0, $b6HlZ.useState)(null), dblclickListener = _c[0], setDblclickListener = _c[1];
    var _d = (0, $b6HlZ.useState)(null), dragendListener = _d[0], setDragendListener = _d[1];
    var _e = (0, $b6HlZ.useState)(null), dragstartListener = _e[0], setDragstartListener = _e[1];
    var _f = (0, $b6HlZ.useState)(null), mousedownListener = _f[0], setMousedownListener = _f[1];
    var _g = (0, $b6HlZ.useState)(null), mousemoveListener = _g[0], setMousemoveListener = _g[1];
    var _h = (0, $b6HlZ.useState)(null), mouseoutListener = _h[0], setMouseoutListener = _h[1];
    var _j = (0, $b6HlZ.useState)(null), mouseoverListener = _j[0], setMouseoverListener = _j[1];
    var _k = (0, $b6HlZ.useState)(null), mouseupListener = _k[0], setMouseupListener = _k[1];
    var _l = (0, $b6HlZ.useState)(null), rightclickListener = _l[0], setRightclickListener = _l[1];
    var _m = (0, $b6HlZ.useState)(null), clickListener = _m[0], setClickListener = _m[1];
    var _o = (0, $b6HlZ.useState)(null), dragListener = _o[0], setDragListener = _o[1];
    var _p = (0, $b6HlZ.useState)(null), centerChangedListener = _p[0], setCenterChangedListener = _p[1];
    var _q = (0, $b6HlZ.useState)(null), radiusChangedListener = _q[0], setRadiusChangedListener = _q[1];
    // Order does matter
    (0, $b6HlZ.useEffect)(function() {
        if (instance !== null) instance.setMap(map);
    }, [
        map
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (typeof options !== "undefined" && instance !== null) instance.setOptions(options);
    }, [
        instance,
        options
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (typeof draggable !== "undefined" && instance !== null) instance.setDraggable(draggable);
    }, [
        instance,
        draggable
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (typeof editable !== "undefined" && instance !== null) instance.setEditable(editable);
    }, [
        instance,
        editable
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (typeof visible !== "undefined" && instance !== null) instance.setVisible(visible);
    }, [
        instance,
        visible
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (typeof radius === "number" && instance !== null) instance.setRadius(radius);
    }, [
        instance,
        radius
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (typeof center !== "undefined" && instance !== null) instance.setCenter(center);
    }, [
        instance,
        center
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (instance && onDblClick) {
            if (dblclickListener !== null) google.maps.event.removeListener(dblclickListener);
            setDblclickListener(google.maps.event.addListener(instance, "dblclick", onDblClick));
        }
    }, [
        onDblClick
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (instance && onDragEnd) {
            if (dragendListener !== null) google.maps.event.removeListener(dragendListener);
            setDragendListener(google.maps.event.addListener(instance, "dragend", onDragEnd));
        }
    }, [
        onDragEnd
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (instance && onDragStart) {
            if (dragstartListener !== null) google.maps.event.removeListener(dragstartListener);
            setDragstartListener(google.maps.event.addListener(instance, "dragstart", onDragStart));
        }
    }, [
        onDragStart
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (instance && onMouseDown) {
            if (mousedownListener !== null) google.maps.event.removeListener(mousedownListener);
            setMousedownListener(google.maps.event.addListener(instance, "mousedown", onMouseDown));
        }
    }, [
        onMouseDown
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (instance && onMouseMove) {
            if (mousemoveListener !== null) google.maps.event.removeListener(mousemoveListener);
            setMousemoveListener(google.maps.event.addListener(instance, "mousemove", onMouseMove));
        }
    }, [
        onMouseMove
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (instance && onMouseOut) {
            if (mouseoutListener !== null) google.maps.event.removeListener(mouseoutListener);
            setMouseoutListener(google.maps.event.addListener(instance, "mouseout", onMouseOut));
        }
    }, [
        onMouseOut
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (instance && onMouseOver) {
            if (mouseoverListener !== null) google.maps.event.removeListener(mouseoverListener);
            setMouseoverListener(google.maps.event.addListener(instance, "mouseover", onMouseOver));
        }
    }, [
        onMouseOver
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (instance && onMouseUp) {
            if (mouseupListener !== null) google.maps.event.removeListener(mouseupListener);
            setMouseupListener(google.maps.event.addListener(instance, "mouseup", onMouseUp));
        }
    }, [
        onMouseUp
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (instance && onRightClick) {
            if (rightclickListener !== null) google.maps.event.removeListener(rightclickListener);
            setRightclickListener(google.maps.event.addListener(instance, "rightclick", onRightClick));
        }
    }, [
        onRightClick
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (instance && onClick) {
            if (clickListener !== null) google.maps.event.removeListener(clickListener);
            setClickListener(google.maps.event.addListener(instance, "click", onClick));
        }
    }, [
        onClick
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (instance && onDrag) {
            if (dragListener !== null) google.maps.event.removeListener(dragListener);
            setDragListener(google.maps.event.addListener(instance, "drag", onDrag));
        }
    }, [
        onDrag
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (instance && onCenterChanged) {
            if (centerChangedListener !== null) google.maps.event.removeListener(centerChangedListener);
            setCenterChangedListener(google.maps.event.addListener(instance, "center_changed", onCenterChanged));
        }
    }, [
        onClick
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (instance && onRadiusChanged) {
            if (radiusChangedListener !== null) google.maps.event.removeListener(radiusChangedListener);
            setRadiusChangedListener(google.maps.event.addListener(instance, "radius_changed", onRadiusChanged));
        }
    }, [
        onRadiusChanged
    ]);
    (0, $b6HlZ.useEffect)(function() {
        var circle = new google.maps.Circle($de370fea0b9a0328$var$__assign($de370fea0b9a0328$var$__assign({}, options || $de370fea0b9a0328$var$defaultOptions), {
            map: map
        }));
        if (typeof radius === "number") circle.setRadius(radius);
        if (typeof center !== "undefined") circle.setCenter(center);
        if (typeof radius === "number") circle.setRadius(radius);
        if (typeof visible !== "undefined") circle.setVisible(visible);
        if (typeof editable !== "undefined") circle.setEditable(editable);
        if (typeof draggable !== "undefined") circle.setDraggable(draggable);
        if (onDblClick) setDblclickListener(google.maps.event.addListener(circle, "dblclick", onDblClick));
        if (onDragEnd) setDragendListener(google.maps.event.addListener(circle, "dragend", onDragEnd));
        if (onDragStart) setDragstartListener(google.maps.event.addListener(circle, "dragstart", onDragStart));
        if (onMouseDown) setMousedownListener(google.maps.event.addListener(circle, "mousedown", onMouseDown));
        if (onMouseMove) setMousemoveListener(google.maps.event.addListener(circle, "mousemove", onMouseMove));
        if (onMouseOut) setMouseoutListener(google.maps.event.addListener(circle, "mouseout", onMouseOut));
        if (onMouseOver) setMouseoverListener(google.maps.event.addListener(circle, "mouseover", onMouseOver));
        if (onMouseUp) setMouseupListener(google.maps.event.addListener(circle, "mouseup", onMouseUp));
        if (onRightClick) setRightclickListener(google.maps.event.addListener(circle, "rightclick", onRightClick));
        if (onClick) setClickListener(google.maps.event.addListener(circle, "click", onClick));
        if (onDrag) setDragListener(google.maps.event.addListener(circle, "drag", onDrag));
        if (onCenterChanged) setCenterChangedListener(google.maps.event.addListener(circle, "center_changed", onCenterChanged));
        if (onRadiusChanged) setRadiusChangedListener(google.maps.event.addListener(circle, "radius_changed", onRadiusChanged));
        setInstance(circle);
        if (onLoad) onLoad(circle);
        return function() {
            if (dblclickListener !== null) google.maps.event.removeListener(dblclickListener);
            if (dragendListener !== null) google.maps.event.removeListener(dragendListener);
            if (dragstartListener !== null) google.maps.event.removeListener(dragstartListener);
            if (mousedownListener !== null) google.maps.event.removeListener(mousedownListener);
            if (mousemoveListener !== null) google.maps.event.removeListener(mousemoveListener);
            if (mouseoutListener !== null) google.maps.event.removeListener(mouseoutListener);
            if (mouseoverListener !== null) google.maps.event.removeListener(mouseoverListener);
            if (mouseupListener !== null) google.maps.event.removeListener(mouseupListener);
            if (rightclickListener !== null) google.maps.event.removeListener(rightclickListener);
            if (clickListener !== null) google.maps.event.removeListener(clickListener);
            if (centerChangedListener !== null) google.maps.event.removeListener(centerChangedListener);
            if (radiusChangedListener !== null) google.maps.event.removeListener(radiusChangedListener);
            if (onUnmount) onUnmount(circle);
            circle.setMap(null);
        };
    }, []);
    return null;
}
var $de370fea0b9a0328$export$c8e49fafd1a7f80 = (0, $b6HlZ.memo)($de370fea0b9a0328$var$CircleFunctional);
var $de370fea0b9a0328$export$c89a927ffc67e6fa = /** @class */ function(_super) {
    $de370fea0b9a0328$var$__extends(Circle, _super);
    function Circle() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.registeredEvents = [];
        _this.state = {
            circle: null
        };
        _this.setCircleCallback = function() {
            if (_this.state.circle !== null && _this.props.onLoad) _this.props.onLoad(_this.state.circle);
        };
        return _this;
    }
    Circle.prototype.componentDidMount = function() {
        var circle = new google.maps.Circle($de370fea0b9a0328$var$__assign($de370fea0b9a0328$var$__assign({}, this.props.options || {}), {
            map: this.context
        }));
        this.registeredEvents = $de370fea0b9a0328$var$applyUpdatersToPropsAndRegisterEvents({
            updaterMap: $de370fea0b9a0328$var$updaterMap$8,
            eventMap: $de370fea0b9a0328$var$eventMap$8,
            prevProps: {},
            nextProps: this.props,
            instance: circle
        });
        this.setState(function setCircle() {
            return {
                circle: circle
            };
        }, this.setCircleCallback);
    };
    Circle.prototype.componentDidUpdate = function(prevProps) {
        if (this.state.circle !== null) {
            $de370fea0b9a0328$var$unregisterEvents(this.registeredEvents);
            this.registeredEvents = $de370fea0b9a0328$var$applyUpdatersToPropsAndRegisterEvents({
                updaterMap: $de370fea0b9a0328$var$updaterMap$8,
                eventMap: $de370fea0b9a0328$var$eventMap$8,
                prevProps: prevProps,
                nextProps: this.props,
                instance: this.state.circle
            });
        }
    };
    Circle.prototype.componentWillUnmount = function() {
        var _a;
        if (this.state.circle !== null) {
            if (this.props.onUnmount) this.props.onUnmount(this.state.circle);
            $de370fea0b9a0328$var$unregisterEvents(this.registeredEvents);
            (_a = this.state.circle) === null || _a === void 0 || _a.setMap(null);
        }
    };
    Circle.prototype.render = function() {
        return null;
    };
    Circle.contextType = $de370fea0b9a0328$export$dc7344301ae78f85;
    return Circle;
}((0, $b6HlZ.PureComponent));
var $de370fea0b9a0328$var$eventMap$7 = {
    onClick: "click",
    onDblClick: "dblclick",
    onMouseDown: "mousedown",
    onMouseOut: "mouseout",
    onMouseOver: "mouseover",
    onMouseUp: "mouseup",
    onRightClick: "rightclick",
    onAddFeature: "addfeature",
    onRemoveFeature: "removefeature",
    onRemoveProperty: "removeproperty",
    onSetGeometry: "setgeometry",
    onSetProperty: "setproperty"
};
var $de370fea0b9a0328$var$updaterMap$7 = {
    add: function(instance, feature) {
        instance.add(feature);
    },
    addgeojson: function(instance, geojson, options) {
        instance.addGeoJson(geojson, options);
    },
    contains: function(instance, feature) {
        instance.contains(feature);
    },
    foreach: function(instance, callback) {
        instance.forEach(callback);
    },
    loadgeojson: function(instance, url, options, callback) {
        instance.loadGeoJson(url, options, callback);
    },
    overridestyle: function(instance, feature, style) {
        instance.overrideStyle(feature, style);
    },
    remove: function(instance, feature) {
        instance.remove(feature);
    },
    revertstyle: function(instance, feature) {
        instance.revertStyle(feature);
    },
    controlposition: function(instance, controlPosition) {
        instance.setControlPosition(controlPosition);
    },
    controls: function(instance, controls) {
        instance.setControls(controls);
    },
    drawingmode: function(instance, mode) {
        instance.setDrawingMode(mode);
    },
    map: function(instance, map) {
        instance.setMap(map);
    },
    style: function(instance, style) {
        instance.setStyle(style);
    },
    togeojson: function(instance, callback) {
        instance.toGeoJson(callback);
    }
};
function $de370fea0b9a0328$var$DataFunctional(_a) {
    var options = _a.options, onClick = _a.onClick, onDblClick = _a.onDblClick, onMouseDown = _a.onMouseDown, onMouseMove = _a.onMouseMove, onMouseOut = _a.onMouseOut, onMouseOver = _a.onMouseOver, onMouseUp = _a.onMouseUp, onRightClick = _a.onRightClick, onAddFeature = _a.onAddFeature, onRemoveFeature = _a.onRemoveFeature, onRemoveProperty = _a.onRemoveProperty, onSetGeometry = _a.onSetGeometry, onSetProperty = _a.onSetProperty, onLoad = _a.onLoad, onUnmount = _a.onUnmount;
    var map = (0, $b6HlZ.useContext)($de370fea0b9a0328$export$dc7344301ae78f85);
    var _b = (0, $b6HlZ.useState)(null), instance = _b[0], setInstance = _b[1];
    var _c = (0, $b6HlZ.useState)(null), dblclickListener = _c[0], setDblclickListener = _c[1];
    var _d = (0, $b6HlZ.useState)(null), mousedownListener = _d[0], setMousedownListener = _d[1];
    var _e = (0, $b6HlZ.useState)(null), mousemoveListener = _e[0], setMousemoveListener = _e[1];
    var _f = (0, $b6HlZ.useState)(null), mouseoutListener = _f[0], setMouseoutListener = _f[1];
    var _g = (0, $b6HlZ.useState)(null), mouseoverListener = _g[0], setMouseoverListener = _g[1];
    var _h = (0, $b6HlZ.useState)(null), mouseupListener = _h[0], setMouseupListener = _h[1];
    var _j = (0, $b6HlZ.useState)(null), rightclickListener = _j[0], setRightclickListener = _j[1];
    var _k = (0, $b6HlZ.useState)(null), clickListener = _k[0], setClickListener = _k[1];
    var _l = (0, $b6HlZ.useState)(null), addFeatureListener = _l[0], setAddFeatureListener = _l[1];
    var _m = (0, $b6HlZ.useState)(null), removeFeatureListener = _m[0], setRemoveFeatureListener = _m[1];
    var _o = (0, $b6HlZ.useState)(null), removePropertyListener = _o[0], setRemovePropertyListener = _o[1];
    var _p = (0, $b6HlZ.useState)(null), setGeometryListener = _p[0], setSetGeometryListener = _p[1];
    var _q = (0, $b6HlZ.useState)(null), setPropertyListener = _q[0], setSetPropertyListener = _q[1];
    // Order does matter
    (0, $b6HlZ.useEffect)(function() {
        if (instance !== null) instance.setMap(map);
    }, [
        map
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (instance && onDblClick) {
            if (dblclickListener !== null) google.maps.event.removeListener(dblclickListener);
            setDblclickListener(google.maps.event.addListener(instance, "dblclick", onDblClick));
        }
    }, [
        onDblClick
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (instance && onMouseDown) {
            if (mousedownListener !== null) google.maps.event.removeListener(mousedownListener);
            setMousedownListener(google.maps.event.addListener(instance, "mousedown", onMouseDown));
        }
    }, [
        onMouseDown
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (instance && onMouseMove) {
            if (mousemoveListener !== null) google.maps.event.removeListener(mousemoveListener);
            setMousemoveListener(google.maps.event.addListener(instance, "mousemove", onMouseMove));
        }
    }, [
        onMouseMove
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (instance && onMouseOut) {
            if (mouseoutListener !== null) google.maps.event.removeListener(mouseoutListener);
            setMouseoutListener(google.maps.event.addListener(instance, "mouseout", onMouseOut));
        }
    }, [
        onMouseOut
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (instance && onMouseOver) {
            if (mouseoverListener !== null) google.maps.event.removeListener(mouseoverListener);
            setMouseoverListener(google.maps.event.addListener(instance, "mouseover", onMouseOver));
        }
    }, [
        onMouseOver
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (instance && onMouseUp) {
            if (mouseupListener !== null) google.maps.event.removeListener(mouseupListener);
            setMouseupListener(google.maps.event.addListener(instance, "mouseup", onMouseUp));
        }
    }, [
        onMouseUp
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (instance && onRightClick) {
            if (rightclickListener !== null) google.maps.event.removeListener(rightclickListener);
            setRightclickListener(google.maps.event.addListener(instance, "rightclick", onRightClick));
        }
    }, [
        onRightClick
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (instance && onClick) {
            if (clickListener !== null) google.maps.event.removeListener(clickListener);
            setClickListener(google.maps.event.addListener(instance, "click", onClick));
        }
    }, [
        onClick
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (instance && onAddFeature) {
            if (addFeatureListener !== null) google.maps.event.removeListener(addFeatureListener);
            setAddFeatureListener(google.maps.event.addListener(instance, "addfeature", onAddFeature));
        }
    }, [
        onAddFeature
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (instance && onRemoveFeature) {
            if (removeFeatureListener !== null) google.maps.event.removeListener(removeFeatureListener);
            setRemoveFeatureListener(google.maps.event.addListener(instance, "removefeature", onRemoveFeature));
        }
    }, [
        onRemoveFeature
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (instance && onRemoveProperty) {
            if (removePropertyListener !== null) google.maps.event.removeListener(removePropertyListener);
            setRemovePropertyListener(google.maps.event.addListener(instance, "removeproperty", onRemoveProperty));
        }
    }, [
        onRemoveProperty
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (instance && onSetGeometry) {
            if (setGeometryListener !== null) google.maps.event.removeListener(setGeometryListener);
            setSetGeometryListener(google.maps.event.addListener(instance, "setgeometry", onSetGeometry));
        }
    }, [
        onSetGeometry
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (instance && onSetProperty) {
            if (setPropertyListener !== null) google.maps.event.removeListener(setPropertyListener);
            setSetPropertyListener(google.maps.event.addListener(instance, "setproperty", onSetProperty));
        }
    }, [
        onSetProperty
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (map !== null) {
            var data = new google.maps.Data($de370fea0b9a0328$var$__assign($de370fea0b9a0328$var$__assign({}, options || {}), {
                map: map
            }));
            if (onDblClick) setDblclickListener(google.maps.event.addListener(data, "dblclick", onDblClick));
            if (onMouseDown) setMousedownListener(google.maps.event.addListener(data, "mousedown", onMouseDown));
            if (onMouseMove) setMousemoveListener(google.maps.event.addListener(data, "mousemove", onMouseMove));
            if (onMouseOut) setMouseoutListener(google.maps.event.addListener(data, "mouseout", onMouseOut));
            if (onMouseOver) setMouseoverListener(google.maps.event.addListener(data, "mouseover", onMouseOver));
            if (onMouseUp) setMouseupListener(google.maps.event.addListener(data, "mouseup", onMouseUp));
            if (onRightClick) setRightclickListener(google.maps.event.addListener(data, "rightclick", onRightClick));
            if (onClick) setClickListener(google.maps.event.addListener(data, "click", onClick));
            if (onAddFeature) setAddFeatureListener(google.maps.event.addListener(data, "addfeature", onAddFeature));
            if (onRemoveFeature) setRemoveFeatureListener(google.maps.event.addListener(data, "removefeature", onRemoveFeature));
            if (onRemoveProperty) setRemovePropertyListener(google.maps.event.addListener(data, "removeproperty", onRemoveProperty));
            if (onSetGeometry) setSetGeometryListener(google.maps.event.addListener(data, "setgeometry", onSetGeometry));
            if (onSetProperty) setSetPropertyListener(google.maps.event.addListener(data, "setproperty", onSetProperty));
            setInstance(data);
            if (onLoad) onLoad(data);
        }
        return function() {
            if (instance) {
                if (dblclickListener !== null) google.maps.event.removeListener(dblclickListener);
                if (mousedownListener !== null) google.maps.event.removeListener(mousedownListener);
                if (mousemoveListener !== null) google.maps.event.removeListener(mousemoveListener);
                if (mouseoutListener !== null) google.maps.event.removeListener(mouseoutListener);
                if (mouseoverListener !== null) google.maps.event.removeListener(mouseoverListener);
                if (mouseupListener !== null) google.maps.event.removeListener(mouseupListener);
                if (rightclickListener !== null) google.maps.event.removeListener(rightclickListener);
                if (clickListener !== null) google.maps.event.removeListener(clickListener);
                if (addFeatureListener !== null) google.maps.event.removeListener(addFeatureListener);
                if (removeFeatureListener !== null) google.maps.event.removeListener(removeFeatureListener);
                if (removePropertyListener !== null) google.maps.event.removeListener(removePropertyListener);
                if (setGeometryListener !== null) google.maps.event.removeListener(setGeometryListener);
                if (setPropertyListener !== null) google.maps.event.removeListener(setPropertyListener);
                if (onUnmount) onUnmount(instance);
                instance.setMap(null);
            }
        };
    }, []);
    return null;
}
var $de370fea0b9a0328$export$a64a4c3cdb71ef1b = (0, $b6HlZ.memo)($de370fea0b9a0328$var$DataFunctional);
var $de370fea0b9a0328$export$2d0294657ab35f1b = /** @class */ function(_super) {
    $de370fea0b9a0328$var$__extends(Data, _super);
    function Data() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.registeredEvents = [];
        _this.state = {
            data: null
        };
        _this.setDataCallback = function() {
            if (_this.state.data !== null && _this.props.onLoad) _this.props.onLoad(_this.state.data);
        };
        return _this;
    }
    Data.prototype.componentDidMount = function() {
        if (this.context !== null) {
            var data_1 = new google.maps.Data($de370fea0b9a0328$var$__assign($de370fea0b9a0328$var$__assign({}, this.props.options || {}), {
                map: this.context
            }));
            this.registeredEvents = $de370fea0b9a0328$var$applyUpdatersToPropsAndRegisterEvents({
                updaterMap: $de370fea0b9a0328$var$updaterMap$7,
                eventMap: $de370fea0b9a0328$var$eventMap$7,
                prevProps: {},
                nextProps: this.props,
                instance: data_1
            });
            this.setState(function() {
                return {
                    data: data_1
                };
            }, this.setDataCallback);
        }
    };
    Data.prototype.componentDidUpdate = function(prevProps) {
        if (this.state.data !== null) {
            $de370fea0b9a0328$var$unregisterEvents(this.registeredEvents);
            this.registeredEvents = $de370fea0b9a0328$var$applyUpdatersToPropsAndRegisterEvents({
                updaterMap: $de370fea0b9a0328$var$updaterMap$7,
                eventMap: $de370fea0b9a0328$var$eventMap$7,
                prevProps: prevProps,
                nextProps: this.props,
                instance: this.state.data
            });
        }
    };
    Data.prototype.componentWillUnmount = function() {
        if (this.state.data !== null) {
            if (this.props.onUnmount) this.props.onUnmount(this.state.data);
            $de370fea0b9a0328$var$unregisterEvents(this.registeredEvents);
            if (this.state.data) this.state.data.setMap(null);
        }
    };
    Data.prototype.render = function() {
        return null;
    };
    Data.contextType = $de370fea0b9a0328$export$dc7344301ae78f85;
    return Data;
}((0, $b6HlZ.PureComponent));
var $de370fea0b9a0328$var$eventMap$6 = {
    onClick: "click",
    onDefaultViewportChanged: "defaultviewport_changed",
    onStatusChanged: "status_changed"
};
var $de370fea0b9a0328$var$updaterMap$6 = {
    options: function(instance, options) {
        instance.setOptions(options);
    },
    url: function(instance, url) {
        instance.setUrl(url);
    },
    zIndex: function(instance, zIndex) {
        instance.setZIndex(zIndex);
    }
};
var $de370fea0b9a0328$export$f2e9f12fb9a3be55 = /** @class */ function(_super) {
    $de370fea0b9a0328$var$__extends(KmlLayer, _super);
    function KmlLayer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.registeredEvents = [];
        _this.state = {
            kmlLayer: null
        };
        _this.setKmlLayerCallback = function() {
            if (_this.state.kmlLayer !== null && _this.props.onLoad) _this.props.onLoad(_this.state.kmlLayer);
        };
        return _this;
    }
    KmlLayer.prototype.componentDidMount = function() {
        var kmlLayer = new google.maps.KmlLayer($de370fea0b9a0328$var$__assign($de370fea0b9a0328$var$__assign({}, this.props.options), {
            map: this.context
        }));
        this.registeredEvents = $de370fea0b9a0328$var$applyUpdatersToPropsAndRegisterEvents({
            updaterMap: $de370fea0b9a0328$var$updaterMap$6,
            eventMap: $de370fea0b9a0328$var$eventMap$6,
            prevProps: {},
            nextProps: this.props,
            instance: kmlLayer
        });
        this.setState(function setLmlLayer() {
            return {
                kmlLayer: kmlLayer
            };
        }, this.setKmlLayerCallback);
    };
    KmlLayer.prototype.componentDidUpdate = function(prevProps) {
        if (this.state.kmlLayer !== null) {
            $de370fea0b9a0328$var$unregisterEvents(this.registeredEvents);
            this.registeredEvents = $de370fea0b9a0328$var$applyUpdatersToPropsAndRegisterEvents({
                updaterMap: $de370fea0b9a0328$var$updaterMap$6,
                eventMap: $de370fea0b9a0328$var$eventMap$6,
                prevProps: prevProps,
                nextProps: this.props,
                instance: this.state.kmlLayer
            });
        }
    };
    KmlLayer.prototype.componentWillUnmount = function() {
        if (this.state.kmlLayer !== null) {
            if (this.props.onUnmount) this.props.onUnmount(this.state.kmlLayer);
            $de370fea0b9a0328$var$unregisterEvents(this.registeredEvents);
            this.state.kmlLayer.setMap(null);
        }
    };
    KmlLayer.prototype.render = function() {
        return null;
    };
    KmlLayer.contextType = $de370fea0b9a0328$export$dc7344301ae78f85;
    return KmlLayer;
}((0, $b6HlZ.PureComponent));
function $de370fea0b9a0328$var$getOffsetOverride(containerElement, getPixelPositionOffset) {
    return typeof getPixelPositionOffset === "function" ? getPixelPositionOffset(containerElement.offsetWidth, containerElement.offsetHeight) : {
        x: 0,
        y: 0
    };
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $de370fea0b9a0328$var$createLatLng(inst, Type) {
    return new Type(inst.lat, inst.lng);
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $de370fea0b9a0328$var$createLatLngBounds(inst, Type) {
    return new Type(new google.maps.LatLng(inst.ne.lat, inst.ne.lng), new google.maps.LatLng(inst.sw.lat, inst.sw.lng));
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $de370fea0b9a0328$var$ensureOfType(inst, // eslint-disable-next-line @typescript-eslint/no-explicit-any
type, // eslint-disable-next-line @typescript-eslint/no-explicit-any
factory) {
    return inst instanceof type ? inst : factory(inst, type);
}
function $de370fea0b9a0328$var$ensureOfTypeBounds(inst, // eslint-disable-next-line @typescript-eslint/no-explicit-any
type, // eslint-disable-next-line @typescript-eslint/no-explicit-any
factory) {
    return inst instanceof type ? inst : factory(inst, type);
}
function $de370fea0b9a0328$var$getLayoutStylesByBounds(mapCanvasProjection, offset, bounds) {
    var ne = mapCanvasProjection && mapCanvasProjection.fromLatLngToDivPixel(bounds.getNorthEast());
    var sw = mapCanvasProjection && mapCanvasProjection.fromLatLngToDivPixel(bounds.getSouthWest());
    if (ne && sw) return {
        left: "".concat(sw.x + offset.x, "px"),
        top: "".concat(ne.y + offset.y, "px"),
        width: "".concat(ne.x - sw.x - offset.x, "px"),
        height: "".concat(sw.y - ne.y - offset.y, "px")
    };
    return {
        left: "-9999px",
        top: "-9999px"
    };
}
function $de370fea0b9a0328$var$getLayoutStylesByPosition(mapCanvasProjection, offset, position) {
    var point = mapCanvasProjection && mapCanvasProjection.fromLatLngToDivPixel(position);
    if (point) {
        var x = point.x, y = point.y;
        return {
            left: "".concat(x + offset.x, "px"),
            top: "".concat(y + offset.y, "px")
        };
    }
    return {
        left: "-9999px",
        top: "-9999px"
    };
}
function $de370fea0b9a0328$var$getLayoutStyles(mapCanvasProjection, offset, bounds, position) {
    return bounds !== undefined ? $de370fea0b9a0328$var$getLayoutStylesByBounds(mapCanvasProjection, offset, $de370fea0b9a0328$var$ensureOfTypeBounds(bounds, google.maps.LatLngBounds, $de370fea0b9a0328$var$createLatLngBounds)) : $de370fea0b9a0328$var$getLayoutStylesByPosition(mapCanvasProjection, offset, $de370fea0b9a0328$var$ensureOfType(position, google.maps.LatLng, $de370fea0b9a0328$var$createLatLng));
}
function $de370fea0b9a0328$var$arePositionsEqual(currentPosition, previousPosition) {
    return currentPosition.left === previousPosition.left && currentPosition.top === previousPosition.top && currentPosition.width === previousPosition.height && currentPosition.height === previousPosition.height;
}
function $de370fea0b9a0328$var$createOverlay(container, pane, position, bounds, getPixelPositionOffset) {
    var Overlay = /** @class */ function(_super) {
        $de370fea0b9a0328$var$__extends(Overlay, _super);
        function Overlay(container, pane, position, bounds) {
            var _this = _super.call(this) || this;
            _this.container = container;
            _this.pane = pane;
            _this.position = position;
            _this.bounds = bounds;
            return _this;
        }
        Overlay.prototype.onAdd = function() {
            var _a;
            var pane = (_a = this.getPanes()) === null || _a === void 0 ? void 0 : _a[this.pane];
            pane === null || pane === void 0 || pane.appendChild(this.container);
        };
        Overlay.prototype.draw = function() {
            var projection = this.getProjection();
            var offset = $de370fea0b9a0328$var$__assign({}, this.container ? $de370fea0b9a0328$var$getOffsetOverride(this.container, getPixelPositionOffset) : {
                x: 0,
                y: 0
            });
            var layoutStyles = $de370fea0b9a0328$var$getLayoutStyles(projection, offset, this.bounds, this.position);
            for(var _i = 0, _a = Object.entries(layoutStyles); _i < _a.length; _i++){
                var _b = _a[_i], key = _b[0], value = _b[1];
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                this.container.style[key] = value;
            }
        };
        Overlay.prototype.onRemove = function() {
            if (this.container.parentNode !== null) this.container.parentNode.removeChild(this.container);
        };
        return Overlay;
    }(google.maps.OverlayView);
    return new Overlay(container, pane, position, bounds);
}
function $de370fea0b9a0328$var$convertToLatLngString(latLngLike) {
    if (!latLngLike) return "";
    var latLng = latLngLike instanceof google.maps.LatLng ? latLngLike : new google.maps.LatLng(latLngLike.lat, latLngLike.lng);
    return latLng + "";
}
function $de370fea0b9a0328$var$convertToLatLngBoundsString(latLngBoundsLike) {
    if (!latLngBoundsLike) return "";
    var latLngBounds = latLngBoundsLike instanceof google.maps.LatLngBounds ? latLngBoundsLike : new google.maps.LatLngBounds(new google.maps.LatLng(latLngBoundsLike.south, latLngBoundsLike.east), new google.maps.LatLng(latLngBoundsLike.north, latLngBoundsLike.west));
    return latLngBounds + "";
}
var $de370fea0b9a0328$export$e24d4b04fda79a06 = "floatPane";
var $de370fea0b9a0328$export$2eeba3db6f2d26f5 = "mapPane";
var $de370fea0b9a0328$export$5f067e8efbd514b9 = "markerLayer";
var $de370fea0b9a0328$export$b71d3f620ff59862 = "overlayLayer";
var $de370fea0b9a0328$export$3f528380a071486d = "overlayMouseTarget";
function $de370fea0b9a0328$var$OverlayViewFunctional(_a) {
    var position = _a.position, bounds = _a.bounds, mapPaneName = _a.mapPaneName, zIndex = _a.zIndex, onLoad = _a.onLoad, onUnmount = _a.onUnmount, getPixelPositionOffset = _a.getPixelPositionOffset, children = _a.children;
    var map = (0, $b6HlZ.useContext)($de370fea0b9a0328$export$dc7344301ae78f85);
    var container = (0, $b6HlZ.useMemo)(function() {
        var div = document.createElement("div");
        div.style.position = "absolute";
        return div;
    }, []);
    var overlay = (0, $b6HlZ.useMemo)(function() {
        return $de370fea0b9a0328$var$createOverlay(container, mapPaneName, position, bounds, getPixelPositionOffset);
    }, [
        container,
        mapPaneName,
        position,
        bounds
    ]);
    (0, $b6HlZ.useEffect)(function() {
        onLoad === null || onLoad === void 0 || onLoad(overlay);
        overlay === null || overlay === void 0 || overlay.setMap(map);
        return function() {
            onUnmount === null || onUnmount === void 0 || onUnmount(overlay);
            overlay === null || overlay === void 0 || overlay.setMap(null);
        };
    }, [
        map,
        overlay
    ]);
    // to move the container to the foreground and background
    (0, $b6HlZ.useEffect)(function() {
        container.style.zIndex = "".concat(zIndex);
    }, [
        zIndex,
        container
    ]);
    return $3uMgk.createPortal(children, container);
}
var $de370fea0b9a0328$export$6554248ab85c957d = (0, $b6HlZ.memo)($de370fea0b9a0328$var$OverlayViewFunctional);
var $de370fea0b9a0328$export$89acdd91182d6c5d = /** @class */ function(_super) {
    $de370fea0b9a0328$var$__extends(OverlayView, _super);
    function OverlayView(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            paneEl: null,
            containerStyle: {
                // set initial position
                position: "absolute"
            }
        };
        _this.updatePane = function() {
            var mapPaneName = _this.props.mapPaneName;
            // https://developers.google.com/maps/documentation/javascript/3.exp/reference#MapPanes
            var mapPanes = _this.overlayView.getPanes();
            $de370fea0b9a0328$var$invariant$1(!!mapPaneName, "OverlayView requires props.mapPaneName but got %s", mapPaneName);
            if (mapPanes) _this.setState({
                paneEl: mapPanes[mapPaneName]
            });
            else _this.setState({
                paneEl: null
            });
        };
        _this.onAdd = function() {
            var _a, _b;
            _this.updatePane();
            (_b = (_a = _this.props).onLoad) === null || _b === void 0 || _b.call(_a, _this.overlayView);
        };
        _this.onPositionElement = function() {
            var _a;
            var mapCanvasProjection = _this.overlayView.getProjection();
            var offset = $de370fea0b9a0328$var$__assign({
                x: 0,
                y: 0
            }, _this.containerRef.current ? $de370fea0b9a0328$var$getOffsetOverride(_this.containerRef.current, _this.props.getPixelPositionOffset) : {});
            var layoutStyles = $de370fea0b9a0328$var$getLayoutStyles(mapCanvasProjection, offset, _this.props.bounds, _this.props.position);
            var left = (_a = _this.state.containerStyle, _a.left), top = _a.top, width = _a.width, height = _a.height;
            if (!$de370fea0b9a0328$var$arePositionsEqual(layoutStyles, {
                left: left,
                top: top,
                width: width,
                height: height
            })) _this.setState({
                containerStyle: {
                    top: layoutStyles.top || 0,
                    left: layoutStyles.left || 0,
                    width: layoutStyles.width || 0,
                    height: layoutStyles.height || 0,
                    position: "absolute"
                }
            });
        };
        _this.draw = function() {
            _this.onPositionElement();
        };
        _this.onRemove = function() {
            var _a, _b;
            _this.setState(function() {
                return {
                    paneEl: null
                };
            });
            (_b = (_a = _this.props).onUnmount) === null || _b === void 0 || _b.call(_a, _this.overlayView);
        };
        _this.containerRef = (0, $b6HlZ.createRef)();
        // You must implement three methods: onAdd(), draw(), and onRemove().
        var overlayView = new google.maps.OverlayView();
        overlayView.onAdd = _this.onAdd;
        overlayView.draw = _this.draw;
        overlayView.onRemove = _this.onRemove;
        _this.overlayView = overlayView;
        return _this;
    }
    OverlayView.prototype.componentDidMount = function() {
        this.overlayView.setMap(this.context);
    };
    OverlayView.prototype.componentDidUpdate = function(prevProps) {
        var prevPositionString = $de370fea0b9a0328$var$convertToLatLngString(prevProps.position);
        var positionString = $de370fea0b9a0328$var$convertToLatLngString(this.props.position);
        var prevBoundsString = $de370fea0b9a0328$var$convertToLatLngBoundsString(prevProps.bounds);
        var boundsString = $de370fea0b9a0328$var$convertToLatLngBoundsString(this.props.bounds);
        if (prevPositionString !== positionString || prevBoundsString !== boundsString) this.overlayView.draw();
        if (prevProps.mapPaneName !== this.props.mapPaneName) this.updatePane();
    };
    OverlayView.prototype.componentWillUnmount = function() {
        this.overlayView.setMap(null);
    };
    OverlayView.prototype.render = function() {
        var paneEl = this.state.paneEl;
        if (paneEl) return $3uMgk.createPortal((0, $94829a8b99aa12e4$exports.jsx)("div", {
            ref: this.containerRef,
            style: this.state.containerStyle,
            children: (0, $b6HlZ.Children).only(this.props.children)
        }), paneEl);
        else return null;
    };
    OverlayView.FLOAT_PANE = "floatPane";
    OverlayView.MAP_PANE = "mapPane";
    OverlayView.MARKER_LAYER = "markerLayer";
    OverlayView.OVERLAY_LAYER = "overlayLayer";
    OverlayView.OVERLAY_MOUSE_TARGET = "overlayMouseTarget";
    OverlayView.contextType = $de370fea0b9a0328$export$dc7344301ae78f85;
    return OverlayView;
}((0, $b6HlZ.PureComponent));
function $de370fea0b9a0328$var$noop() {
    return;
}
var $de370fea0b9a0328$var$eventMap$5 = {
    onDblClick: "dblclick",
    onClick: "click"
};
var $de370fea0b9a0328$var$updaterMap$5 = {
    opacity: function(instance, opacity) {
        instance.setOpacity(opacity);
    }
};
function $de370fea0b9a0328$var$GroundOverlayFunctional(_a) {
    var url = _a.url, bounds = _a.bounds, options = _a.options, visible = _a.visible;
    var map = (0, $b6HlZ.useContext)($de370fea0b9a0328$export$dc7344301ae78f85);
    var imageBounds = new google.maps.LatLngBounds(new google.maps.LatLng(bounds.south, bounds.west), new google.maps.LatLng(bounds.north, bounds.east));
    var groundOverlay = (0, $b6HlZ.useMemo)(function() {
        var overlay = new google.maps.GroundOverlay(url, imageBounds, $de370fea0b9a0328$var$__assign({}, options));
        return overlay;
    }, []);
    (0, $b6HlZ.useEffect)(function() {
        if (groundOverlay !== null) groundOverlay.setMap(map);
    }, [
        map
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (typeof url !== "undefined" && groundOverlay !== null) {
            groundOverlay.set("url", url);
            groundOverlay.setMap(map);
        }
    }, [
        groundOverlay,
        url
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (typeof visible !== "undefined" && groundOverlay !== null) groundOverlay.setOpacity(visible ? 1 : 0);
    }, [
        groundOverlay,
        visible
    ]);
    (0, $b6HlZ.useEffect)(function() {
        var newBounds = new google.maps.LatLngBounds(new google.maps.LatLng(bounds.south, bounds.west), new google.maps.LatLng(bounds.north, bounds.east));
        if (typeof bounds !== "undefined" && groundOverlay !== null) {
            groundOverlay.set("bounds", newBounds);
            groundOverlay.setMap(map);
        }
    }, [
        groundOverlay,
        bounds
    ]);
    return null;
}
var $de370fea0b9a0328$export$146cd687ea7c5077 = (0, $b6HlZ.memo)($de370fea0b9a0328$var$GroundOverlayFunctional);
var $de370fea0b9a0328$export$a5034750997c6854 = /** @class */ function(_super) {
    $de370fea0b9a0328$var$__extends(GroundOverlay, _super);
    function GroundOverlay() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.registeredEvents = [];
        _this.state = {
            groundOverlay: null
        };
        _this.setGroundOverlayCallback = function() {
            if (_this.state.groundOverlay !== null && _this.props.onLoad) _this.props.onLoad(_this.state.groundOverlay);
        };
        return _this;
    }
    GroundOverlay.prototype.componentDidMount = function() {
        $de370fea0b9a0328$var$invariant$1(!!this.props.url || !!this.props.bounds, "For GroundOverlay, url and bounds are passed in to constructor and are immutable after instantiated. This is the behavior of Google Maps JavaScript API v3 ( See https://developers.google.com/maps/documentation/javascript/reference#GroundOverlay) Hence, use the corresponding two props provided by `react-google-maps-api`, url and bounds. In some cases, you'll need the GroundOverlay component to reflect the changes of url and bounds. You can leverage the React's key property to remount the component. Typically, just `key={url}` would serve your need. See https://github.com/tomchentw/react-google-maps/issues/655");
        var groundOverlay = new google.maps.GroundOverlay(this.props.url, this.props.bounds, $de370fea0b9a0328$var$__assign($de370fea0b9a0328$var$__assign({}, this.props.options), {
            map: this.context
        }));
        this.registeredEvents = $de370fea0b9a0328$var$applyUpdatersToPropsAndRegisterEvents({
            updaterMap: $de370fea0b9a0328$var$updaterMap$5,
            eventMap: $de370fea0b9a0328$var$eventMap$5,
            prevProps: {},
            nextProps: this.props,
            instance: groundOverlay
        });
        this.setState(function setGroundOverlay() {
            return {
                groundOverlay: groundOverlay
            };
        }, this.setGroundOverlayCallback);
    };
    GroundOverlay.prototype.componentDidUpdate = function(prevProps) {
        if (this.state.groundOverlay !== null) {
            $de370fea0b9a0328$var$unregisterEvents(this.registeredEvents);
            this.registeredEvents = $de370fea0b9a0328$var$applyUpdatersToPropsAndRegisterEvents({
                updaterMap: $de370fea0b9a0328$var$updaterMap$5,
                eventMap: $de370fea0b9a0328$var$eventMap$5,
                prevProps: prevProps,
                nextProps: this.props,
                instance: this.state.groundOverlay
            });
        }
    };
    GroundOverlay.prototype.componentWillUnmount = function() {
        if (this.state.groundOverlay) {
            if (this.props.onUnmount) this.props.onUnmount(this.state.groundOverlay);
            this.state.groundOverlay.setMap(null);
        }
    };
    GroundOverlay.prototype.render = function() {
        return null;
    };
    GroundOverlay.defaultProps = {
        onLoad: $de370fea0b9a0328$var$noop
    };
    GroundOverlay.contextType = $de370fea0b9a0328$export$dc7344301ae78f85;
    return GroundOverlay;
}((0, $b6HlZ.PureComponent));
var $de370fea0b9a0328$var$eventMap$4 = {};
var $de370fea0b9a0328$var$updaterMap$4 = {
    data: function(instance, data) {
        instance.setData(data);
    },
    map: function(instance, map) {
        instance.setMap(map);
    },
    options: function(instance, options) {
        instance.setOptions(options);
    }
};
function $de370fea0b9a0328$var$HeatmapLayerFunctional(_a) {
    var data = _a.data, onLoad = _a.onLoad, onUnmount = _a.onUnmount, options = _a.options;
    var map = (0, $b6HlZ.useContext)($de370fea0b9a0328$export$dc7344301ae78f85);
    var _b = (0, $b6HlZ.useState)(null), instance = _b[0], setInstance = _b[1];
    (0, $b6HlZ.useEffect)(function() {
        if (!google.maps.visualization) $de370fea0b9a0328$var$invariant$1(!!google.maps.visualization, 'Did you include prop libraries={["visualization"]} in useJsApiScript? %s', google.maps.visualization);
    }, []);
    (0, $b6HlZ.useEffect)(function() {
        $de370fea0b9a0328$var$invariant$1(!!data, "data property is required in HeatmapLayer %s", data);
    }, [
        data
    ]);
    // Order does matter
    (0, $b6HlZ.useEffect)(function() {
        if (instance !== null) instance.setMap(map);
    }, [
        map
    ]);
    (0, $b6HlZ.useEffect)(function() {
        if (options && instance !== null) instance.setOptions(options);
    }, [
        instance,
        options
    ]);
    (0, $b6HlZ.useEffect)(function() {
        var heatmapLayer = new google.maps.visualization.HeatmapLayer($de370fea0b9a0328$var$__assign($de370fea0b9a0328$var$__assign({}, options || {}), {
            data: data,
            map: map
        }));
        setInstance(heatmapLayer);
        if (onLoad) onLoad(heatmapLayer);
        return function() {
            if (instance !== null) {
                if (onUnmount) onUnmount(instance);
                instance.setMap(null);
            }
        };
    }, []);
    return null;
}
var $de370fea0b9a0328$export$efb69a92d03e2aab = (0, $b6HlZ.memo)($de370fea0b9a0328$var$HeatmapLayerFunctional);
var $de370fea0b9a0328$export$56278b847e4d6e63 = /** @class */ function(_super) {
    $de370fea0b9a0328$var$__extends(HeatmapLayer, _super);
    function HeatmapLayer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.registeredEvents = [];
        _this.state = {
            heatmapLayer: null
        };
        _this.setHeatmapLayerCallback = function() {
            if (_this.state.heatmapLayer !== null && _this.props.onLoad) _this.props.onLoad(_this.state.heatmapLayer);
        };
        return _this;
    }
    HeatmapLayer.prototype.componentDidMount = function() {
        $de370fea0b9a0328$var$invariant$1(!!google.maps.visualization, 'Did you include prop libraries={["visualization"]} to <LoadScript />? %s', google.maps.visualization);
        $de370fea0b9a0328$var$invariant$1(!!this.props.data, "data property is required in HeatmapLayer %s", this.props.data);
        var heatmapLayer = new google.maps.visualization.HeatmapLayer($de370fea0b9a0328$var$__assign($de370fea0b9a0328$var$__assign({}, this.props.options || {}), {
            data: this.props.data,
            map: this.context
        }));
        this.registeredEvents = $de370fea0b9a0328$var$applyUpdatersToPropsAndRegisterEvents({
            updaterMap: $de370fea0b9a0328$var$updaterMap$4,
            eventMap: $de370fea0b9a0328$var$eventMap$4,
            prevProps: {},
            nextProps: this.props,
            instance: heatmapLayer
        });
        this.setState(function setHeatmapLayer() {
            return {
                heatmapLayer: heatmapLayer
            };
        }, this.setHeatmapLayerCallback);
    };
    HeatmapLayer.prototype.componentDidUpdate = function(prevProps) {
        $de370fea0b9a0328$var$unregisterEvents(this.registeredEvents);
        this.registeredEvents = $de370fea0b9a0328$var$applyUpdatersToPropsAndRegisterEvents({
            updaterMap: $de370fea0b9a0328$var$updaterMap$4,
            eventMap: $de370fea0b9a0328$var$eventMap$4,
            prevProps: prevProps,
            nextProps: this.props,
            instance: this.state.heatmapLayer
        });
    };
    HeatmapLayer.prototype.componentWillUnmount = function() {
        if (this.state.heatmapLayer !== null) {
            if (this.props.onUnmount) this.props.onUnmount(this.state.heatmapLayer);
            $de370fea0b9a0328$var$unregisterEvents(this.registeredEvents);
            this.state.heatmapLayer.setMap(null);
        }
    };
    HeatmapLayer.prototype.render = function() {
        return null;
    };
    HeatmapLayer.contextType = $de370fea0b9a0328$export$dc7344301ae78f85;
    return HeatmapLayer;
}((0, $b6HlZ.PureComponent));
var $de370fea0b9a0328$var$eventMap$3 = {
    onCloseClick: "closeclick",
    onPanoChanged: "pano_changed",
    onPositionChanged: "position_changed",
    onPovChanged: "pov_changed",
    onResize: "resize",
    onStatusChanged: "status_changed",
    onVisibleChanged: "visible_changed",
    onZoomChanged: "zoom_changed"
};
var $de370fea0b9a0328$var$updaterMap$3 = {
    register: function(instance, provider, options) {
        instance.registerPanoProvider(provider, options);
    },
    links: function(instance, links) {
        instance.setLinks(links);
    },
    motionTracking: function(instance, motionTracking) {
        instance.setMotionTracking(motionTracking);
    },
    options: function(instance, options) {
        instance.setOptions(options);
    },
    pano: function(instance, pano) {
        instance.setPano(pano);
    },
    position: function(instance, position) {
        instance.setPosition(position);
    },
    pov: function(instance, pov) {
        instance.setPov(pov);
    },
    visible: function(instance, visible) {
        instance.setVisible(visible);
    },
    zoom: function(instance, zoom) {
        instance.setZoom(zoom);
    }
};
var $de370fea0b9a0328$export$6835431164726c61 = /** @class */ function(_super) {
    $de370fea0b9a0328$var$__extends(StreetViewPanorama, _super);
    function StreetViewPanorama() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.registeredEvents = [];
        _this.state = {
            streetViewPanorama: null
        };
        _this.setStreetViewPanoramaCallback = function() {
            if (_this.state.streetViewPanorama !== null && _this.props.onLoad) _this.props.onLoad(_this.state.streetViewPanorama);
        };
        return _this;
    }
    StreetViewPanorama.prototype.componentDidMount = function() {
        var _a, _b;
        var streetViewPanorama = (_b = (_a = this.context) === null || _a === void 0 ? void 0 : _a.getStreetView()) !== null && _b !== void 0 ? _b : null;
        this.registeredEvents = $de370fea0b9a0328$var$applyUpdatersToPropsAndRegisterEvents({
            updaterMap: $de370fea0b9a0328$var$updaterMap$3,
            eventMap: $de370fea0b9a0328$var$eventMap$3,
            prevProps: {},
            nextProps: this.props,
            instance: streetViewPanorama
        });
        this.setState(function() {
            return {
                streetViewPanorama: streetViewPanorama
            };
        }, this.setStreetViewPanoramaCallback);
    };
    StreetViewPanorama.prototype.componentDidUpdate = function(prevProps) {
        if (this.state.streetViewPanorama !== null) {
            $de370fea0b9a0328$var$unregisterEvents(this.registeredEvents);
            this.registeredEvents = $de370fea0b9a0328$var$applyUpdatersToPropsAndRegisterEvents({
                updaterMap: $de370fea0b9a0328$var$updaterMap$3,
                eventMap: $de370fea0b9a0328$var$eventMap$3,
                prevProps: prevProps,
                nextProps: this.props,
                instance: this.state.streetViewPanorama
            });
        }
    };
    StreetViewPanorama.prototype.componentWillUnmount = function() {
        if (this.state.streetViewPanorama !== null) {
            if (this.props.onUnmount) this.props.onUnmount(this.state.streetViewPanorama);
            $de370fea0b9a0328$var$unregisterEvents(this.registeredEvents);
            this.state.streetViewPanorama.setVisible(false);
        }
    };
    StreetViewPanorama.prototype.render = function() {
        return null;
    };
    StreetViewPanorama.contextType = $de370fea0b9a0328$export$dc7344301ae78f85;
    return StreetViewPanorama;
}((0, $b6HlZ.PureComponent));
var $de370fea0b9a0328$export$533fe900f738f6ac = /** @class */ function(_super) {
    $de370fea0b9a0328$var$__extends(StreetViewService, _super);
    function StreetViewService() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            streetViewService: null
        };
        _this.setStreetViewServiceCallback = function() {
            if (_this.state.streetViewService !== null && _this.props.onLoad) _this.props.onLoad(_this.state.streetViewService);
        };
        return _this;
    }
    StreetViewService.prototype.componentDidMount = function() {
        var streetViewService = new google.maps.StreetViewService();
        this.setState(function setStreetViewService() {
            return {
                streetViewService: streetViewService
            };
        }, this.setStreetViewServiceCallback);
    };
    StreetViewService.prototype.componentWillUnmount = function() {
        if (this.state.streetViewService !== null && this.props.onUnmount) this.props.onUnmount(this.state.streetViewService);
    };
    StreetViewService.prototype.render = function() {
        return null;
    };
    StreetViewService.contextType = $de370fea0b9a0328$export$dc7344301ae78f85;
    return StreetViewService;
}((0, $b6HlZ.PureComponent));
var $de370fea0b9a0328$export$fc221c4ee84dbd5e = /** @class */ function(_super) {
    $de370fea0b9a0328$var$__extends(DirectionsService, _super);
    function DirectionsService() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            directionsService: null
        };
        _this.setDirectionsServiceCallback = function() {
            if (_this.state.directionsService !== null && _this.props.onLoad) _this.props.onLoad(_this.state.directionsService);
        };
        return _this;
    }
    DirectionsService.prototype.componentDidMount = function() {
        $de370fea0b9a0328$var$invariant$1(!!this.props.options, "DirectionsService expected options object as parameter, but got %s", this.props.options);
        var directionsService = new google.maps.DirectionsService();
        this.setState(function setDirectionsService() {
            return {
                directionsService: directionsService
            };
        }, this.setDirectionsServiceCallback);
    };
    DirectionsService.prototype.componentDidUpdate = function() {
        if (this.state.directionsService !== null) this.state.directionsService.route(this.props.options, this.props.callback);
    };
    DirectionsService.prototype.componentWillUnmount = function() {
        if (this.state.directionsService !== null) {
            if (this.props.onUnmount) this.props.onUnmount(this.state.directionsService);
        }
    };
    DirectionsService.prototype.render = function() {
        return null;
    };
    return DirectionsService;
}((0, $b6HlZ.PureComponent));
var $de370fea0b9a0328$var$eventMap$2 = {
    onDirectionsChanged: "directions_changed"
};
var $de370fea0b9a0328$var$updaterMap$2 = {
    directions: function(instance, directions) {
        instance.setDirections(directions);
    },
    map: function(instance, map) {
        instance.setMap(map);
    },
    options: function(instance, options) {
        instance.setOptions(options);
    },
    panel: function(instance, panel) {
        instance.setPanel(panel);
    },
    routeIndex: function(instance, routeIndex) {
        instance.setRouteIndex(routeIndex);
    }
};
var $de370fea0b9a0328$export$7fd3518d0a0bb86a = /** @class */ function(_super) {
    $de370fea0b9a0328$var$__extends(DirectionsRenderer, _super);
    function DirectionsRenderer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.registeredEvents = [];
        _this.state = {
            directionsRenderer: null
        };
        _this.setDirectionsRendererCallback = function() {
            if (_this.state.directionsRenderer !== null) {
                _this.state.directionsRenderer.setMap(_this.context);
                if (_this.props.onLoad) _this.props.onLoad(_this.state.directionsRenderer);
            }
        };
        return _this;
    }
    DirectionsRenderer.prototype.componentDidMount = function() {
        var directionsRenderer = new google.maps.DirectionsRenderer(this.props.options);
        this.registeredEvents = $de370fea0b9a0328$var$applyUpdatersToPropsAndRegisterEvents({
            updaterMap: $de370fea0b9a0328$var$updaterMap$2,
            eventMap: $de370fea0b9a0328$var$eventMap$2,
            prevProps: {},
            nextProps: this.props,
            instance: directionsRenderer
        });
        this.setState(function setDirectionsRenderer() {
            return {
                directionsRenderer: directionsRenderer
            };
        }, this.setDirectionsRendererCallback);
    };
    DirectionsRenderer.prototype.componentDidUpdate = function(prevProps) {
        if (this.state.directionsRenderer !== null) {
            $de370fea0b9a0328$var$unregisterEvents(this.registeredEvents);
            this.registeredEvents = $de370fea0b9a0328$var$applyUpdatersToPropsAndRegisterEvents({
                updaterMap: $de370fea0b9a0328$var$updaterMap$2,
                eventMap: $de370fea0b9a0328$var$eventMap$2,
                prevProps: prevProps,
                nextProps: this.props,
                instance: this.state.directionsRenderer
            });
        }
    };
    DirectionsRenderer.prototype.componentWillUnmount = function() {
        if (this.state.directionsRenderer !== null) {
            if (this.props.onUnmount) this.props.onUnmount(this.state.directionsRenderer);
            $de370fea0b9a0328$var$unregisterEvents(this.registeredEvents);
            if (this.state.directionsRenderer) this.state.directionsRenderer.setMap(null);
        }
    };
    DirectionsRenderer.prototype.render = function() {
        return (0, $94829a8b99aa12e4$exports.jsx)((0, $94829a8b99aa12e4$exports.Fragment), {});
    };
    DirectionsRenderer.contextType = $de370fea0b9a0328$export$dc7344301ae78f85;
    return DirectionsRenderer;
}((0, $b6HlZ.PureComponent));
var $de370fea0b9a0328$export$4ddc3e9182efd9a8 = /** @class */ function(_super) {
    $de370fea0b9a0328$var$__extends(DistanceMatrixService, _super);
    function DistanceMatrixService() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            distanceMatrixService: null
        };
        _this.setDistanceMatrixServiceCallback = function() {
            if (_this.state.distanceMatrixService !== null && _this.props.onLoad) _this.props.onLoad(_this.state.distanceMatrixService);
        };
        return _this;
    }
    DistanceMatrixService.prototype.componentDidMount = function() {
        $de370fea0b9a0328$var$invariant$1(!!this.props.options, "DistanceMatrixService expected options object as parameter, but go %s", this.props.options);
        var distanceMatrixService = new google.maps.DistanceMatrixService();
        this.setState(function setDistanceMatrixService() {
            return {
                distanceMatrixService: distanceMatrixService
            };
        }, this.setDistanceMatrixServiceCallback);
    };
    DistanceMatrixService.prototype.componentDidUpdate = function() {
        if (this.state.distanceMatrixService !== null) this.state.distanceMatrixService.getDistanceMatrix(this.props.options, this.props.callback);
    };
    DistanceMatrixService.prototype.componentWillUnmount = function() {
        if (this.state.distanceMatrixService !== null && this.props.onUnmount) this.props.onUnmount(this.state.distanceMatrixService);
    };
    DistanceMatrixService.prototype.render = function() {
        return null;
    };
    return DistanceMatrixService;
}((0, $b6HlZ.PureComponent));
var $de370fea0b9a0328$var$eventMap$1 = {
    onPlacesChanged: "places_changed"
};
var $de370fea0b9a0328$var$updaterMap$1 = {
    bounds: function(instance, bounds) {
        instance.setBounds(bounds);
    }
};
var $de370fea0b9a0328$export$e2a0bb4d8be84b8 = /** @class */ function(_super) {
    $de370fea0b9a0328$var$__extends(StandaloneSearchBox, _super);
    function StandaloneSearchBox() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.registeredEvents = [];
        _this.containerElement = (0, $b6HlZ.createRef)();
        _this.state = {
            searchBox: null
        };
        _this.setSearchBoxCallback = function() {
            if (_this.state.searchBox !== null && _this.props.onLoad) _this.props.onLoad(_this.state.searchBox);
        };
        return _this;
    }
    StandaloneSearchBox.prototype.componentDidMount = function() {
        $de370fea0b9a0328$var$invariant$1(!!google.maps.places, 'You need to provide libraries={["places"]} prop to <LoadScript /> component %s', google.maps.places);
        if (this.containerElement !== null && this.containerElement.current !== null) {
            var input = this.containerElement.current.querySelector("input");
            if (input !== null) {
                var searchBox_1 = new google.maps.places.SearchBox(input, this.props.options);
                this.registeredEvents = $de370fea0b9a0328$var$applyUpdatersToPropsAndRegisterEvents({
                    updaterMap: $de370fea0b9a0328$var$updaterMap$1,
                    eventMap: $de370fea0b9a0328$var$eventMap$1,
                    prevProps: {},
                    nextProps: this.props,
                    instance: searchBox_1
                });
                this.setState(function setSearchBox() {
                    return {
                        searchBox: searchBox_1
                    };
                }, this.setSearchBoxCallback);
            }
        }
    };
    StandaloneSearchBox.prototype.componentDidUpdate = function(prevProps) {
        if (this.state.searchBox !== null) {
            $de370fea0b9a0328$var$unregisterEvents(this.registeredEvents);
            this.registeredEvents = $de370fea0b9a0328$var$applyUpdatersToPropsAndRegisterEvents({
                updaterMap: $de370fea0b9a0328$var$updaterMap$1,
                eventMap: $de370fea0b9a0328$var$eventMap$1,
                prevProps: prevProps,
                nextProps: this.props,
                instance: this.state.searchBox
            });
        }
    };
    StandaloneSearchBox.prototype.componentWillUnmount = function() {
        if (this.state.searchBox !== null) {
            if (this.props.onUnmount) this.props.onUnmount(this.state.searchBox);
            $de370fea0b9a0328$var$unregisterEvents(this.registeredEvents);
        }
    };
    StandaloneSearchBox.prototype.render = function() {
        return (0, $94829a8b99aa12e4$exports.jsx)("div", {
            ref: this.containerElement,
            children: (0, $b6HlZ.Children).only(this.props.children)
        });
    };
    StandaloneSearchBox.contextType = $de370fea0b9a0328$export$dc7344301ae78f85;
    return StandaloneSearchBox;
}((0, $b6HlZ.PureComponent));
var $de370fea0b9a0328$var$eventMap = {
    onPlaceChanged: "place_changed"
};
var $de370fea0b9a0328$var$updaterMap = {
    bounds: function(instance, bounds) {
        instance.setBounds(bounds);
    },
    restrictions: function(instance, restrictions) {
        instance.setComponentRestrictions(restrictions);
    },
    fields: function(instance, fields) {
        instance.setFields(fields);
    },
    options: function(instance, options) {
        instance.setOptions(options);
    },
    types: function(instance, types) {
        instance.setTypes(types);
    }
};
var $de370fea0b9a0328$export$2f2b9559550c7bbc = /** @class */ function(_super) {
    $de370fea0b9a0328$var$__extends(Autocomplete, _super);
    function Autocomplete() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.registeredEvents = [];
        _this.containerElement = (0, $b6HlZ.createRef)();
        _this.state = {
            autocomplete: null
        };
        _this.setAutocompleteCallback = function() {
            if (_this.state.autocomplete !== null && _this.props.onLoad) _this.props.onLoad(_this.state.autocomplete);
        };
        return _this;
    }
    Autocomplete.prototype.componentDidMount = function() {
        var _a;
        $de370fea0b9a0328$var$invariant$1(!!google.maps.places, 'You need to provide libraries={["places"]} prop to <LoadScript /> component %s', google.maps.places);
        // TODO: why current could be equal null?
        var input = (_a = this.containerElement.current) === null || _a === void 0 ? void 0 : _a.querySelector("input");
        if (input) {
            var autocomplete_1 = new google.maps.places.Autocomplete(input, this.props.options);
            this.registeredEvents = $de370fea0b9a0328$var$applyUpdatersToPropsAndRegisterEvents({
                updaterMap: $de370fea0b9a0328$var$updaterMap,
                eventMap: $de370fea0b9a0328$var$eventMap,
                prevProps: {},
                nextProps: this.props,
                instance: autocomplete_1
            });
            this.setState(function() {
                return {
                    autocomplete: autocomplete_1
                };
            }, this.setAutocompleteCallback);
        }
    };
    Autocomplete.prototype.componentDidUpdate = function(prevProps) {
        $de370fea0b9a0328$var$unregisterEvents(this.registeredEvents);
        this.registeredEvents = $de370fea0b9a0328$var$applyUpdatersToPropsAndRegisterEvents({
            updaterMap: $de370fea0b9a0328$var$updaterMap,
            eventMap: $de370fea0b9a0328$var$eventMap,
            prevProps: prevProps,
            nextProps: this.props,
            instance: this.state.autocomplete
        });
    };
    Autocomplete.prototype.componentWillUnmount = function() {
        if (this.state.autocomplete !== null) $de370fea0b9a0328$var$unregisterEvents(this.registeredEvents);
    };
    Autocomplete.prototype.render = function() {
        return (0, $94829a8b99aa12e4$exports.jsx)("div", {
            ref: this.containerElement,
            className: this.props.className,
            children: (0, $b6HlZ.Children).only(this.props.children)
        });
    };
    Autocomplete.defaultProps = {
        className: ""
    };
    Autocomplete.contextType = $de370fea0b9a0328$export$dc7344301ae78f85;
    return Autocomplete;
}((0, $b6HlZ.PureComponent));




parcelRequire("b6HlZ");


var $b6HlZ = parcelRequire("b6HlZ");
var $3afd05c1588cfe15$exports = {};
"use strict";
var $3afd05c1588cfe15$var$__assign = $3afd05c1588cfe15$exports && $3afd05c1588cfe15$exports.__assign || function() {
    $3afd05c1588cfe15$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $3afd05c1588cfe15$var$__assign.apply(this, arguments);
};
Object.defineProperty($3afd05c1588cfe15$exports, "__esModule", {
    value: true
});
$3afd05c1588cfe15$exports.Popover = $3afd05c1588cfe15$exports.usePopover = $3afd05c1588cfe15$exports.ArrowContainer = $3afd05c1588cfe15$exports.useArrowContainer = void 0;


var $b6HlZ = parcelRequire("b6HlZ");
var $570803c3ae7e8e57$exports = {};
"use strict";
Object.defineProperty($570803c3ae7e8e57$exports, "__esModule", {
    value: true
});
$570803c3ae7e8e57$exports.PopoverPortal = void 0;

var $b6HlZ = parcelRequire("b6HlZ");

var $3uMgk = parcelRequire("3uMgk");
var $570803c3ae7e8e57$var$PopoverPortal = function(_a) {
    var container = _a.container, element = _a.element, scoutElement = _a.scoutElement, children = _a.children;
    $b6HlZ.useLayoutEffect(function() {
        container.appendChild(element);
        container.appendChild(scoutElement);
        return function() {
            container.removeChild(element);
            container.removeChild(scoutElement);
        };
    }, [
        container,
        element,
        scoutElement
    ]);
    return $3uMgk.createPortal(children, element);
};
$570803c3ae7e8e57$exports.PopoverPortal = $570803c3ae7e8e57$var$PopoverPortal;


var $ad023f7e72eaabc6$exports = {};
"use strict";
Object.defineProperty($ad023f7e72eaabc6$exports, "__esModule", {
    value: true
});
$ad023f7e72eaabc6$exports.getNudgedPopoverRect = $ad023f7e72eaabc6$exports.getNewPopoverRect = $ad023f7e72eaabc6$exports.popoverRectForPosition = $ad023f7e72eaabc6$exports.createContainer = $ad023f7e72eaabc6$exports.rectsAreEqual = $ad023f7e72eaabc6$exports.EMPTY_CLIENT_RECT = void 0;
$ad023f7e72eaabc6$exports.EMPTY_CLIENT_RECT = {
    top: 0,
    left: 0,
    bottom: 0,
    height: 0,
    right: 0,
    width: 0
};
var $ad023f7e72eaabc6$var$rectsAreEqual = function(rectA, rectB) {
    return rectA === rectB || (rectA === null || rectA === void 0 ? void 0 : rectA.bottom) === (rectB === null || rectB === void 0 ? void 0 : rectB.bottom) && (rectA === null || rectA === void 0 ? void 0 : rectA.height) === (rectB === null || rectB === void 0 ? void 0 : rectB.height) && (rectA === null || rectA === void 0 ? void 0 : rectA.left) === (rectB === null || rectB === void 0 ? void 0 : rectB.left) && (rectA === null || rectA === void 0 ? void 0 : rectA.right) === (rectB === null || rectB === void 0 ? void 0 : rectB.right) && (rectA === null || rectA === void 0 ? void 0 : rectA.top) === (rectB === null || rectB === void 0 ? void 0 : rectB.top) && (rectA === null || rectA === void 0 ? void 0 : rectA.width) === (rectB === null || rectB === void 0 ? void 0 : rectB.width);
};
$ad023f7e72eaabc6$exports.rectsAreEqual = $ad023f7e72eaabc6$var$rectsAreEqual;
var $ad023f7e72eaabc6$var$createContainer = function(containerStyle, containerClassName) {
    var container = window.document.createElement("div");
    if (containerClassName) container.className = containerClassName;
    Object.assign(container.style, containerStyle);
    return container;
};
$ad023f7e72eaabc6$exports.createContainer = $ad023f7e72eaabc6$var$createContainer;
var $ad023f7e72eaabc6$var$popoverRectForPosition = function(position, childRect, popoverRect, padding, align) {
    var targetMidX = childRect.left + childRect.width / 2;
    var targetMidY = childRect.top + childRect.height / 2;
    var width = popoverRect.width, height = popoverRect.height;
    var top;
    var left;
    switch(position){
        case "left":
            top = targetMidY - height / 2;
            left = childRect.left - padding - width;
            if (align === "start") top = childRect.top;
            if (align === "end") top = childRect.bottom - height;
            break;
        case "bottom":
            top = childRect.bottom + padding;
            left = targetMidX - width / 2;
            if (align === "start") left = childRect.left;
            if (align === "end") left = childRect.right - width;
            break;
        case "right":
            top = targetMidY - height / 2;
            left = childRect.right + padding;
            if (align === "start") top = childRect.top;
            if (align === "end") top = childRect.bottom - height;
            break;
        default:
            top = childRect.top - height - padding;
            left = targetMidX - width / 2;
            if (align === "start") left = childRect.left;
            if (align === "end") left = childRect.right - width;
            break;
    }
    return {
        top: top,
        left: left,
        width: width,
        height: height,
        right: left + width,
        bottom: top + height
    };
};
$ad023f7e72eaabc6$exports.popoverRectForPosition = $ad023f7e72eaabc6$var$popoverRectForPosition;
var $ad023f7e72eaabc6$var$getNewPopoverRect = function(_a, boundaryInset) {
    var position = _a.position, align = _a.align, childRect = _a.childRect, popoverRect = _a.popoverRect, boundaryRect = _a.boundaryRect, padding = _a.padding, reposition = _a.reposition;
    var rect = $ad023f7e72eaabc6$exports.popoverRectForPosition(position, childRect, popoverRect, padding, align);
    var boundaryViolation = reposition && (position === "top" && rect.top < boundaryRect.top + boundaryInset || position === "left" && rect.left < boundaryRect.left + boundaryInset || position === "right" && rect.right > boundaryRect.right - boundaryInset || position === "bottom" && rect.bottom > boundaryRect.bottom - boundaryInset);
    return {
        rect: rect,
        boundaryViolation: boundaryViolation
    };
};
$ad023f7e72eaabc6$exports.getNewPopoverRect = $ad023f7e72eaabc6$var$getNewPopoverRect;
var $ad023f7e72eaabc6$var$getNudgedPopoverRect = function(popoverRect, boundaryRect, boundaryInset) {
    var topBoundary = boundaryRect.top + boundaryInset;
    var leftBoundary = boundaryRect.left + boundaryInset;
    var rightBoundary = boundaryRect.right - boundaryInset;
    var bottomBoundary = boundaryRect.bottom - boundaryInset;
    var top = popoverRect.top < topBoundary ? topBoundary : popoverRect.top;
    top = top + popoverRect.height > bottomBoundary ? bottomBoundary - popoverRect.height : top;
    var left = popoverRect.left < leftBoundary ? leftBoundary : popoverRect.left;
    left = left + popoverRect.width > rightBoundary ? rightBoundary - popoverRect.width : left;
    return {
        top: top,
        left: left,
        width: popoverRect.width,
        height: popoverRect.height,
        right: left + popoverRect.width,
        bottom: top + popoverRect.height
    };
};
$ad023f7e72eaabc6$exports.getNudgedPopoverRect = $ad023f7e72eaabc6$var$getNudgedPopoverRect;


var $59f994a1473ccf29$exports = {};
"use strict";
Object.defineProperty($59f994a1473ccf29$exports, "__esModule", {
    value: true
});
$59f994a1473ccf29$exports.usePopover = void 0;

var $b6HlZ = parcelRequire("b6HlZ");

var $b4603258d9c9d69d$exports = {};
"use strict";
Object.defineProperty($b4603258d9c9d69d$exports, "__esModule", {
    value: true
});
$b4603258d9c9d69d$exports.useElementRef = void 0;

var $b6HlZ = parcelRequire("b6HlZ");

var $b4603258d9c9d69d$var$useElementRef = function(containerClassName, containerStyle) {
    var ref = $b6HlZ.useRef();
    var element = $b6HlZ.useMemo(function() {
        return $ad023f7e72eaabc6$exports.createContainer(containerStyle, containerClassName);
    }, [
        containerClassName,
        containerStyle
    ]);
    ref.current = element;
    return ref;
};
$b4603258d9c9d69d$exports.useElementRef = $b4603258d9c9d69d$var$useElementRef;


var $59f994a1473ccf29$var$POPOVER_STYLE = {
    position: "fixed",
    overflow: "visible",
    top: "0px",
    left: "0px"
};
var $59f994a1473ccf29$var$SCOUT_STYLE = {
    position: "fixed",
    top: "0px",
    left: "0px",
    width: "0px",
    height: "0px",
    visibility: "hidden"
};
var $59f994a1473ccf29$var$usePopover = function(_a) {
    var isOpen = _a.isOpen, childRef = _a.childRef, positions = _a.positions, containerClassName = _a.containerClassName, parentElement = _a.parentElement, contentLocation = _a.contentLocation, align = _a.align, padding = _a.padding, reposition = _a.reposition, boundaryInset = _a.boundaryInset, boundaryElement = _a.boundaryElement, onPositionPopover = _a.onPositionPopover;
    var popoverRef = $b4603258d9c9d69d$exports.useElementRef(containerClassName, $59f994a1473ccf29$var$POPOVER_STYLE);
    var scoutRef = $b4603258d9c9d69d$exports.useElementRef("react-tiny-popover-scout", $59f994a1473ccf29$var$SCOUT_STYLE);
    var positionPopover = $b6HlZ.useCallback(function(_a) {
        var _b, _c;
        var _d = _a === void 0 ? {} : _a, _e = _d.positionIndex, positionIndex = _e === void 0 ? 0 : _e, _f = _d.parentRect, parentRect = _f === void 0 ? parentElement.getBoundingClientRect() : _f, _g = _d.childRect, childRect = _g === void 0 ? (_b = childRef === null || childRef === void 0 ? void 0 : childRef.current) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect() : _g, _h = _d.scoutRect, scoutRect = _h === void 0 ? (_c = scoutRef === null || scoutRef === void 0 ? void 0 : scoutRef.current) === null || _c === void 0 ? void 0 : _c.getBoundingClientRect() : _h, _j = _d.popoverRect, popoverRect = _j === void 0 ? popoverRef.current.getBoundingClientRect() : _j, _k = _d.boundaryRect, boundaryRect = _k === void 0 ? boundaryElement === parentElement ? parentRect : boundaryElement.getBoundingClientRect() : _k;
        if (!childRect || !parentRect || !isOpen) return;
        if (contentLocation) {
            var _l = typeof contentLocation === "function" ? contentLocation({
                childRect: childRect,
                popoverRect: popoverRect,
                parentRect: parentRect,
                boundaryRect: boundaryRect,
                padding: padding,
                nudgedTop: 0,
                nudgedLeft: 0,
                boundaryInset: boundaryInset,
                violations: $ad023f7e72eaabc6$exports.EMPTY_CLIENT_RECT,
                hasViolations: false
            }) : contentLocation, inputTop = _l.top, inputLeft = _l.left;
            var left_1 = Math.round(parentRect.left + inputLeft - scoutRect.left);
            var top_1 = Math.round(parentRect.top + inputTop - scoutRect.top);
            popoverRef.current.style.transform = "translate(" + left_1 + "px, " + top_1 + "px)";
            onPositionPopover({
                childRect: childRect,
                popoverRect: popoverRect,
                parentRect: parentRect,
                boundaryRect: boundaryRect,
                padding: padding,
                nudgedTop: 0,
                nudgedLeft: 0,
                boundaryInset: boundaryInset,
                violations: $ad023f7e72eaabc6$exports.EMPTY_CLIENT_RECT,
                hasViolations: false
            });
            return;
        }
        var isExhausted = positionIndex === positions.length;
        var position = isExhausted ? positions[0] : positions[positionIndex];
        var _m = $ad023f7e72eaabc6$exports.getNewPopoverRect({
            childRect: childRect,
            popoverRect: popoverRect,
            boundaryRect: boundaryRect,
            position: position,
            align: align,
            padding: padding,
            reposition: reposition
        }, boundaryInset), rect = _m.rect, boundaryViolation = _m.boundaryViolation;
        if (boundaryViolation && reposition && !isExhausted) {
            positionPopover({
                positionIndex: positionIndex + 1,
                childRect: childRect,
                popoverRect: popoverRect,
                parentRect: parentRect,
                boundaryRect: boundaryRect
            });
            return;
        }
        var top = rect.top, left = rect.left, width = rect.width, height = rect.height;
        var shouldNudge = reposition && !isExhausted;
        var _o = $ad023f7e72eaabc6$exports.getNudgedPopoverRect(rect, boundaryRect, boundaryInset), nudgedLeft = _o.left, nudgedTop = _o.top;
        var finalTop = top;
        var finalLeft = left;
        if (shouldNudge) {
            finalTop = nudgedTop;
            finalLeft = nudgedLeft;
        }
        finalTop = Math.round(finalTop - scoutRect.top);
        finalLeft = Math.round(finalLeft - scoutRect.left);
        popoverRef.current.style.transform = "translate(" + finalLeft + "px, " + finalTop + "px)";
        var potentialViolations = {
            top: boundaryRect.top + boundaryInset - finalTop,
            left: boundaryRect.left + boundaryInset - finalLeft,
            right: finalLeft + width - boundaryRect.right + boundaryInset,
            bottom: finalTop + height - boundaryRect.bottom + boundaryInset
        };
        onPositionPopover({
            childRect: childRect,
            popoverRect: {
                top: finalTop,
                left: finalLeft,
                width: width,
                height: height,
                right: finalLeft + width,
                bottom: finalTop + height
            },
            parentRect: parentRect,
            boundaryRect: boundaryRect,
            position: position,
            align: align,
            padding: padding,
            nudgedTop: nudgedTop - top,
            nudgedLeft: nudgedLeft - left,
            boundaryInset: boundaryInset,
            violations: {
                top: potentialViolations.top <= 0 ? 0 : potentialViolations.top,
                left: potentialViolations.left <= 0 ? 0 : potentialViolations.left,
                right: potentialViolations.right <= 0 ? 0 : potentialViolations.right,
                bottom: potentialViolations.bottom <= 0 ? 0 : potentialViolations.bottom
            },
            hasViolations: potentialViolations.top > 0 || potentialViolations.left > 0 || potentialViolations.right > 0 || potentialViolations.bottom > 0
        });
    }, [
        parentElement,
        childRef,
        scoutRef,
        popoverRef,
        boundaryElement,
        isOpen,
        contentLocation,
        positions,
        align,
        padding,
        reposition,
        boundaryInset,
        onPositionPopover
    ]);
    return {
        positionPopover: positionPopover,
        popoverRef: popoverRef,
        scoutRef: scoutRef
    };
};
$59f994a1473ccf29$exports.usePopover = $59f994a1473ccf29$var$usePopover;


Object.defineProperty($3afd05c1588cfe15$exports, "usePopover", {
    enumerable: true,
    get: function() {
        return $59f994a1473ccf29$exports.usePopover;
    }
});
var $0316fe3b032a990c$exports = {};
"use strict";
Object.defineProperty($0316fe3b032a990c$exports, "__esModule", {
    value: true
});
$0316fe3b032a990c$exports.useMemoizedArray = void 0;

var $b6HlZ = parcelRequire("b6HlZ");
var $0316fe3b032a990c$var$useMemoizedArray = function(externalArray) {
    var prevArrayRef = $b6HlZ.useRef(externalArray);
    var array = $b6HlZ.useMemo(function() {
        if (prevArrayRef.current === externalArray) return prevArrayRef.current;
        if (prevArrayRef.current.length !== externalArray.length) {
            prevArrayRef.current = externalArray;
            return externalArray;
        }
        for(var i = 0; i < externalArray.length; i += 1)if (externalArray[i] !== prevArrayRef.current[i]) {
            prevArrayRef.current = externalArray;
            return externalArray;
        }
        return prevArrayRef.current;
    }, [
        externalArray
    ]);
    return array;
};
$0316fe3b032a990c$exports.useMemoizedArray = $0316fe3b032a990c$var$useMemoizedArray;


var $abf9a29e3f648135$exports = {};
"use strict";
var $abf9a29e3f648135$var$__assign = $abf9a29e3f648135$exports && $abf9a29e3f648135$exports.__assign || function() {
    $abf9a29e3f648135$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $abf9a29e3f648135$var$__assign.apply(this, arguments);
};
Object.defineProperty($abf9a29e3f648135$exports, "__esModule", {
    value: true
});
$abf9a29e3f648135$exports.useArrowContainer = void 0;

var $b6HlZ = parcelRequire("b6HlZ");
var $abf9a29e3f648135$var$useArrowContainer = function(_a) {
    var childRect = _a.childRect, popoverRect = _a.popoverRect, position = _a.position, arrowSize = _a.arrowSize, arrowColor = _a.arrowColor;
    var arrowContainerStyle = $b6HlZ.useMemo(function() {
        return {
            padding: arrowSize
        };
    }, [
        arrowSize
    ]);
    var arrowStyle = $b6HlZ.useMemo(function() {
        return $abf9a29e3f648135$var$__assign({
            position: "absolute"
        }, function() {
            var arrowWidth = arrowSize * 2;
            var top = childRect.top - popoverRect.top + childRect.height / 2 - arrowWidth / 2;
            var left = childRect.left - popoverRect.left + childRect.width / 2 - arrowWidth / 2;
            var lowerBound = arrowSize;
            var leftUpperBound = popoverRect.width - arrowSize;
            var topUpperBound = popoverRect.height - arrowSize;
            left = left < lowerBound ? lowerBound : left;
            left = left + arrowWidth > leftUpperBound ? leftUpperBound - arrowWidth : left;
            top = top < lowerBound ? lowerBound : top;
            top = top + arrowWidth > topUpperBound ? topUpperBound - arrowWidth : top;
            top = Number.isNaN(top) ? 0 : top;
            left = Number.isNaN(left) ? 0 : left;
            switch(position){
                case "right":
                    return {
                        borderTop: arrowSize + "px solid transparent",
                        borderBottom: arrowSize + "px solid transparent",
                        borderRight: arrowSize + "px solid " + arrowColor,
                        left: 0,
                        top: top
                    };
                case "left":
                    return {
                        borderTop: arrowSize + "px solid transparent",
                        borderBottom: arrowSize + "px solid transparent",
                        borderLeft: arrowSize + "px solid " + arrowColor,
                        right: 0,
                        top: top
                    };
                case "bottom":
                    return {
                        borderLeft: arrowSize + "px solid transparent",
                        borderRight: arrowSize + "px solid transparent",
                        borderBottom: arrowSize + "px solid " + arrowColor,
                        top: 0,
                        left: left
                    };
                case "top":
                    return {
                        borderLeft: arrowSize + "px solid transparent",
                        borderRight: arrowSize + "px solid transparent",
                        borderTop: arrowSize + "px solid " + arrowColor,
                        bottom: 0,
                        left: left
                    };
                default:
                    return {
                        display: "hidden"
                    };
            }
        }());
    }, [
        arrowColor,
        arrowSize,
        childRect.height,
        childRect.left,
        childRect.top,
        childRect.width,
        popoverRect.height,
        popoverRect.left,
        popoverRect.top,
        popoverRect.width,
        position
    ]);
    return {
        arrowContainerStyle: arrowContainerStyle,
        arrowStyle: arrowStyle
    };
};
$abf9a29e3f648135$exports.useArrowContainer = $abf9a29e3f648135$var$useArrowContainer;


Object.defineProperty($3afd05c1588cfe15$exports, "useArrowContainer", {
    enumerable: true,
    get: function() {
        return $abf9a29e3f648135$exports.useArrowContainer;
    }
});
var $c51e7c9dbb8dc102$exports = {};
"use strict";
var $c51e7c9dbb8dc102$var$__assign = $c51e7c9dbb8dc102$exports && $c51e7c9dbb8dc102$exports.__assign || function() {
    $c51e7c9dbb8dc102$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c51e7c9dbb8dc102$var$__assign.apply(this, arguments);
};
Object.defineProperty($c51e7c9dbb8dc102$exports, "__esModule", {
    value: true
});
$c51e7c9dbb8dc102$exports.ArrowContainer = void 0;


var $b6HlZ = parcelRequire("b6HlZ");

var $c51e7c9dbb8dc102$var$ArrowContainer = function(_a) {
    var childRect = _a.childRect, popoverRect = _a.popoverRect, position = _a.position, arrowColor = _a.arrowColor, arrowSize = _a.arrowSize, arrowClassName = _a.arrowClassName, externalArrowStyle = _a.arrowStyle, className = _a.className, children = _a.children, externalArrowContainerStyle = _a.style;
    var _b = $abf9a29e3f648135$exports.useArrowContainer({
        childRect: childRect,
        popoverRect: popoverRect,
        position: position,
        arrowColor: arrowColor,
        arrowSize: arrowSize
    }), arrowContainerStyle = _b.arrowContainerStyle, arrowStyle = _b.arrowStyle;
    var mergedContainerStyle = $b6HlZ.useMemo(function() {
        return $c51e7c9dbb8dc102$var$__assign($c51e7c9dbb8dc102$var$__assign({}, arrowContainerStyle), externalArrowContainerStyle);
    }, [
        arrowContainerStyle,
        externalArrowContainerStyle
    ]);
    var mergedArrowStyle = $b6HlZ.useMemo(function() {
        return $c51e7c9dbb8dc102$var$__assign($c51e7c9dbb8dc102$var$__assign({}, arrowStyle), externalArrowStyle);
    }, [
        arrowStyle,
        externalArrowStyle
    ]);
    return $94829a8b99aa12e4$exports.jsxs("div", $c51e7c9dbb8dc102$var$__assign({
        className: className,
        style: mergedContainerStyle
    }, {
        children: [
            $94829a8b99aa12e4$exports.jsx("div", {
                style: mergedArrowStyle,
                className: arrowClassName
            }, void 0),
            children
        ]
    }), void 0);
};
$c51e7c9dbb8dc102$exports.ArrowContainer = $c51e7c9dbb8dc102$var$ArrowContainer;


Object.defineProperty($3afd05c1588cfe15$exports, "ArrowContainer", {
    enumerable: true,
    get: function() {
        return $c51e7c9dbb8dc102$exports.ArrowContainer;
    }
});
var $3afd05c1588cfe15$var$DEFAULT_POSITIONS = [
    "top",
    "left",
    "right",
    "bottom"
];
var $3afd05c1588cfe15$var$PopoverInternal = $b6HlZ.forwardRef(function(_a, externalRef) {
    var isOpen = _a.isOpen, children = _a.children, content = _a.content, _b = _a.positions, externalPositions = _b === void 0 ? $3afd05c1588cfe15$var$DEFAULT_POSITIONS : _b, _c = _a.align, align = _c === void 0 ? "center" : _c, _d = _a.padding, padding = _d === void 0 ? 0 : _d, _e = _a.reposition, reposition = _e === void 0 ? true : _e, _f = _a.parentElement, parentElement = _f === void 0 ? window.document.body : _f, _g = _a.boundaryElement, boundaryElement = _g === void 0 ? parentElement : _g, _h = _a.containerClassName, containerClassName = _h === void 0 ? "react-tiny-popover-container" : _h, containerStyle = _a.containerStyle, contentLocation = _a.contentLocation, _j = _a.boundaryInset, boundaryInset = _j === void 0 ? 0 : _j, onClickOutside = _a.onClickOutside, _k = _a.clickOutsideCapture, clickOutsideCapture = _k === void 0 ? false : _k;
    var positions = $0316fe3b032a990c$exports.useMemoizedArray(externalPositions);
    // TODO: factor prevs out into a custom prevs hook
    var prevIsOpen = $b6HlZ.useRef(false);
    var prevPositions = $b6HlZ.useRef();
    var prevContentLocation = $b6HlZ.useRef();
    var prevReposition = $b6HlZ.useRef(reposition);
    var childRef = $b6HlZ.useRef();
    var _l = $b6HlZ.useState({
        align: align,
        nudgedLeft: 0,
        nudgedTop: 0,
        position: positions[0],
        padding: padding,
        childRect: $ad023f7e72eaabc6$exports.EMPTY_CLIENT_RECT,
        popoverRect: $ad023f7e72eaabc6$exports.EMPTY_CLIENT_RECT,
        parentRect: $ad023f7e72eaabc6$exports.EMPTY_CLIENT_RECT,
        boundaryRect: $ad023f7e72eaabc6$exports.EMPTY_CLIENT_RECT,
        boundaryInset: boundaryInset,
        violations: $ad023f7e72eaabc6$exports.EMPTY_CLIENT_RECT,
        hasViolations: false
    }), popoverState = _l[0], setPopoverState = _l[1];
    var onPositionPopover = $b6HlZ.useCallback(function(popoverState) {
        return setPopoverState(popoverState);
    }, []);
    var _m = $59f994a1473ccf29$exports.usePopover({
        isOpen: isOpen,
        childRef: childRef,
        containerClassName: containerClassName,
        parentElement: parentElement,
        boundaryElement: boundaryElement,
        contentLocation: contentLocation,
        positions: positions,
        align: align,
        padding: padding,
        boundaryInset: boundaryInset,
        reposition: reposition,
        onPositionPopover: onPositionPopover
    }), positionPopover = _m.positionPopover, popoverRef = _m.popoverRef, scoutRef = _m.scoutRef;
    $b6HlZ.useLayoutEffect(function() {
        var shouldUpdate = true;
        var updatePopover = function() {
            var _a, _b;
            if (isOpen && shouldUpdate) {
                var childRect = (_a = childRef === null || childRef === void 0 ? void 0 : childRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
                var popoverRect = (_b = popoverRef === null || popoverRef === void 0 ? void 0 : popoverRef.current) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect();
                if (childRect != null && popoverRect != null && (!$ad023f7e72eaabc6$exports.rectsAreEqual(childRect, {
                    top: popoverState.childRect.top,
                    left: popoverState.childRect.left,
                    width: popoverState.childRect.width,
                    height: popoverState.childRect.height,
                    bottom: popoverState.childRect.top + popoverState.childRect.height,
                    right: popoverState.childRect.left + popoverState.childRect.width
                }) || popoverRect.width !== popoverState.popoverRect.width || popoverRect.height !== popoverState.popoverRect.height || popoverState.padding !== padding || popoverState.align !== align || positions !== prevPositions.current || contentLocation !== prevContentLocation.current || reposition !== prevReposition.current)) positionPopover();
                // TODO: factor prev checks out into the custom prevs hook
                if (positions !== prevPositions.current) prevPositions.current = positions;
                if (contentLocation !== prevContentLocation.current) prevContentLocation.current = contentLocation;
                if (reposition !== prevReposition.current) prevReposition.current = reposition;
                if (shouldUpdate) window.requestAnimationFrame(updatePopover);
            }
            prevIsOpen.current = isOpen;
        };
        window.requestAnimationFrame(updatePopover);
        return function() {
            shouldUpdate = false;
        };
    }, [
        align,
        contentLocation,
        isOpen,
        padding,
        popoverRef,
        popoverState.align,
        popoverState.childRect.height,
        popoverState.childRect.left,
        popoverState.childRect.top,
        popoverState.childRect.width,
        popoverState.padding,
        popoverState.popoverRect.height,
        popoverState.popoverRect.width,
        positionPopover,
        positions,
        reposition
    ]);
    $b6HlZ.useEffect(function() {
        var popoverElement = popoverRef.current;
        Object.assign(popoverElement.style, containerStyle);
        return function() {
            Object.keys(containerStyle !== null && containerStyle !== void 0 ? containerStyle : {}).forEach(function(key) {
                return delete popoverElement.style[key];
            });
        };
    }, [
        containerStyle,
        isOpen,
        popoverRef
    ]);
    var handleOnClickOutside = $b6HlZ.useCallback(function(e) {
        var _a, _b;
        if (isOpen && !((_a = popoverRef.current) === null || _a === void 0 ? void 0 : _a.contains(e.target)) && !((_b = childRef.current) === null || _b === void 0 ? void 0 : _b.contains(e.target))) onClickOutside === null || onClickOutside === void 0 || onClickOutside(e);
    }, [
        isOpen,
        onClickOutside,
        popoverRef
    ]);
    var handleWindowResize = $b6HlZ.useCallback(function() {
        if (childRef.current) window.requestAnimationFrame(function() {
            return positionPopover();
        });
    }, [
        positionPopover
    ]);
    $b6HlZ.useEffect(function() {
        var body = parentElement.ownerDocument.body;
        body.addEventListener("click", handleOnClickOutside, clickOutsideCapture);
        body.addEventListener("contextmenu", handleOnClickOutside, clickOutsideCapture);
        body.addEventListener("resize", handleWindowResize);
        return function() {
            body.removeEventListener("click", handleOnClickOutside, clickOutsideCapture);
            body.removeEventListener("contextmenu", handleOnClickOutside, clickOutsideCapture);
            body.removeEventListener("resize", handleWindowResize);
        };
    }, [
        clickOutsideCapture,
        handleOnClickOutside,
        handleWindowResize,
        parentElement
    ]);
    var handleRef = $b6HlZ.useCallback(function(node) {
        childRef.current = node;
        if (externalRef != null) {
            if (typeof externalRef === "object") externalRef.current = node;
            else if (typeof externalRef === "function") externalRef(node);
        }
    }, [
        externalRef
    ]);
    var renderChild = function() {
        return $b6HlZ.cloneElement(children, {
            ref: handleRef
        });
    };
    var renderPopover = function() {
        if (!isOpen) return null;
        return $94829a8b99aa12e4$exports.jsx($570803c3ae7e8e57$exports.PopoverPortal, $3afd05c1588cfe15$var$__assign({
            element: popoverRef.current,
            scoutElement: scoutRef.current,
            container: parentElement
        }, {
            children: typeof content === "function" ? content(popoverState) : content
        }), void 0);
    };
    return $94829a8b99aa12e4$exports.jsxs($94829a8b99aa12e4$exports.Fragment, {
        children: [
            renderChild(),
            renderPopover()
        ]
    }, void 0);
});
$3afd05c1588cfe15$exports.Popover = $b6HlZ.forwardRef(function(props, ref) {
    if (typeof window === "undefined") return props.children;
    return $94829a8b99aa12e4$exports.jsx($3afd05c1588cfe15$var$PopoverInternal, $3afd05c1588cfe15$var$__assign({}, props, {
        ref: ref
    }), void 0);
});


var $a6b15835e94627b5$exports = {};

$a6b15835e94627b5$exports = (parcelRequire("fF0r8")).getBundleURL("7lpHJ") + "tick.8befb6e6.svg";


var $3b06b48e9ecf1267$exports = {};

$3b06b48e9ecf1267$exports = (parcelRequire("fF0r8")).getBundleURL("7lpHJ") + "info.2c5cb62a.svg";



parcelRequire("b6HlZ");
const $3229834488658f24$var$CustomPopover = ({ title: title, description: description, list: list })=>{
    const renderList = ()=>{
        return list.map((item, index)=>{
            return /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)("li", {
                className: "text-sm text-left",
                children: item
            }, index);
        });
    };
    return /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsxs)("div", {
        className: "flex flex-col gap-3 justify-start items-start max-w-[216px] px-3 py-6 bg-white shadow-popover border border-gray-400 rounded-xl",
        children: [
            /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)("p", {
                className: " text-sm font-bold text-left",
                children: title
            }),
            /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsxs)("div", {
                className: "flex flex-col gap-5 justify-start items-start",
                children: [
                    /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)("p", {
                        className: "text-sm text-left",
                        children: description
                    }),
                    /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)("ul", {
                        className: "list-disc list-outside ml-4",
                        children: list && renderList()
                    })
                ]
            })
        ]
    });
};
var $3229834488658f24$export$2e2bcd8739ae039 = $3229834488658f24$var$CustomPopover;


const $02e15c55acc53d16$var$Tab = ({ name: name, handleTabChange: handleTabChange, selected: selected, className: className, popoverTitle: popoverTitle, popoverDescription: popoverDescription, popoverList: popoverList })=>{
    const [isPopoverOpen, setIsPopoverOpen] = (0, $b6HlZ.useState)(false);
    const handleTabClicked = ()=>{
        handleTabChange(name);
    };
    const handleMouseEnter = ()=>{
        setIsPopoverOpen(true);
    };
    const handleMouseLeave = ()=>{
        setIsPopoverOpen(false);
    };
    return /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsxs)("div", {
        className: `flex w-22 gap-1 h-8 p-2 lg:p-0 md:gap-2 lg:gap-4 md:w-28 lg:w-44 md:h-9 lg:h-11 rounded-full ${selected ? "border-2" : "border"} ${selected ? "border-primary" : "border-gray-400"} cursor-pointer ${className} justify-center items-center`,
        onClick: handleTabClicked,
        children: [
            /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)("p", {
                className: "text-xs leading-none lg:text-base font-medium",
                children: name
            }),
            /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)((0, $3afd05c1588cfe15$exports.Popover), {
                isOpen: isPopoverOpen && !selected,
                positions: [
                    "bottom"
                ],
                align: "end",
                containerClassName: "z-[100]",
                content: /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)((0, $3229834488658f24$export$2e2bcd8739ae039), {
                    title: popoverTitle,
                    description: popoverDescription,
                    list: popoverList
                }),
                children: /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)("img", {
                    src: selected ? (0, (/*@__PURE__*/$parcel$interopDefault($a6b15835e94627b5$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($3b06b48e9ecf1267$exports))),
                    alt: "",
                    onMouseEnter: handleMouseEnter,
                    onMouseLeave: handleMouseLeave
                })
            })
        ]
    });
};
var $02e15c55acc53d16$export$2e2bcd8739ae039 = $02e15c55acc53d16$var$Tab;



const $c10cb3153b21de3c$var$Tabs = ({ selectedTab: selectedTab, handleTabChange: handleTabChange, className: className })=>{
    return /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)("div", {
        className: `flex justify-around mt-3 ${className}`,
        children: (0, $5e76e72696cf68eb$export$6cb588e60034a5f2).map((tab)=>{
            return /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)((0, $02e15c55acc53d16$export$2e2bcd8739ae039), {
                ...tab,
                selected: tab.name === selectedTab,
                handleTabChange: handleTabChange
            }, tab.name);
        })
    });
};
var $c10cb3153b21de3c$export$2e2bcd8739ae039 = $c10cb3153b21de3c$var$Tabs;


var $5dd222f478db7de1$exports = {};

$5dd222f478db7de1$exports = (parcelRequire("fF0r8")).getBundleURL("7lpHJ") + "meeting-room.40860c11.svg";


var $fdc48ec73bd8ae5f$exports = {};

$fdc48ec73bd8ae5f$exports = (parcelRequire("fF0r8")).getBundleURL("7lpHJ") + "meeting-room-selected.ca0016ad.svg";


var $106da0ad5c5ff96d$exports = {};

$106da0ad5c5ff96d$exports = (parcelRequire("fF0r8")).getBundleURL("7lpHJ") + "flexday-suite.57a38e46.svg";


var $2121ae276f4fad07$exports = {};

$2121ae276f4fad07$exports = (parcelRequire("fF0r8")).getBundleURL("7lpHJ") + "flexday-suite-selected.8bf617a1.svg";


var $bdae66c0d62f7295$exports = {};

$bdae66c0d62f7295$exports = (parcelRequire("fF0r8")).getBundleURL("7lpHJ") + "private-office.81c04e3b.svg";


var $5551acfcc1c7c283$exports = {};

$5551acfcc1c7c283$exports = (parcelRequire("fF0r8")).getBundleURL("7lpHJ") + "private-office-selected.9912a0e1.svg";


const $ec417a0df3dcfaa4$export$9f2ff75bd438036d = {
    "Meeting Room": {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($5dd222f478db7de1$exports))),
        selected: (0, (/*@__PURE__*/$parcel$interopDefault($fdc48ec73bd8ae5f$exports)))
    },
    "Flexday Suite": {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($106da0ad5c5ff96d$exports))),
        selected: (0, (/*@__PURE__*/$parcel$interopDefault($2121ae276f4fad07$exports)))
    },
    "Private Office": {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($bdae66c0d62f7295$exports))),
        selected: (0, (/*@__PURE__*/$parcel$interopDefault($5551acfcc1c7c283$exports)))
    }
};


var $02aabccbc7a6e75d$exports = {};

$02aabccbc7a6e75d$exports = (parcelRequire("fF0r8")).getBundleURL("7lpHJ") + "map-center.1f48b751.svg";


var $ef5c418a131db8af$exports = {};

$ef5c418a131db8af$exports = (parcelRequire("fF0r8")).getBundleURL("7lpHJ") + "initial-center.47f7c0e5.svg";



const $980224afca407b64$var$mapOptions = {
    styles: [
        {
            featureType: "poi",
            stylers: [
                {
                    visibility: "off"
                }
            ]
        },
        {
            featureType: "administrative",
            elementType: "labels",
            stylers: [
                {
                    visibility: "off"
                }
            ]
        },
        {
            featureType: "transit",
            elementType: "labels",
            stylers: [
                {
                    visibility: "off"
                }
            ]
        },
        {
            featureType: "landscape",
            elementType: "labels",
            stylers: [
                {
                    visibility: "off"
                }
            ]
        },
        {
            featureType: "road",
            elementType: "labels",
            stylers: [
                {
                    visibility: "visible"
                }
            ]
        }
    ],
    gestureHandling: "greedy"
};
const $980224afca407b64$var$libraries = [
    "places",
    "geometry"
];
const $980224afca407b64$var$CustomGoogleMap = ({ poi: poi, locations: locations, selectedTab: selectedTab, handleTabChange: handleTabChange, geoLocation: geoLocation, isPlaceSelected: isPlaceSelected, selectedMarker: selectedMarker, handleMarkerClick: handleMarkerClick, handleMapDragged: handleMapDragged, handleResetMapCenter: handleResetMapCenter })=>{
    const [mapref, setMapRef] = (0, $b6HlZ.useState)(null);
    const handleOnLoad = (map)=>{
        setMapRef(map);
    };
    const handleDragEnd = ()=>{
        const center = mapref.getCenter();
        const lat = center.lat();
        const lng = center.lng();
        handleMapDragged({
            lat: lat,
            lng: lng
        });
    };
    return /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)((0, $de370fea0b9a0328$export$cd712c6fb2ecba2b), {
        googleMapsApiKey: "AIzaSyBua7ngKVFbHoUIQ_2Gm3Q01b9uvF5a84E",
        libraries: $980224afca407b64$var$libraries,
        children: /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsxs)("div", {
            className: "w-fit flex flex-col items-center",
            children: [
                /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsxs)("div", {
                    className: "relative w-full md:w-fit",
                    children: [
                        /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)((0, $c10cb3153b21de3c$export$2e2bcd8739ae039), {
                            className: "absolute z-50 w-full",
                            selectedTab: selectedTab,
                            handleTabChange: handleTabChange
                        }),
                        /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsxs)((0, $de370fea0b9a0328$export$4ad1bae46276c5ce), {
                            mapContainerClassName: "w-full md:w-96 lg:w-147 pt-[75%] md:h-96 lg:h-136",
                            center: geoLocation,
                            zoom: 15,
                            className: "relative",
                            options: $980224afca407b64$var$mapOptions,
                            onLoad: handleOnLoad,
                            onDragEnd: handleDragEnd,
                            children: [
                                isPlaceSelected && /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)((0, $de370fea0b9a0328$export$e98856a975cab58e), {
                                    position: poi,
                                    icon: {
                                        url: (0, (/*@__PURE__*/$parcel$interopDefault($02aabccbc7a6e75d$exports)))
                                    },
                                    clickable: false,
                                    zIndex: 1000
                                }, "map-center"),
                                locations === null || locations === void 0 ? void 0 : locations.map((location)=>{
                                    return /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)((0, $de370fea0b9a0328$export$e98856a975cab58e), {
                                        position: {
                                            lat: location.latitude,
                                            lng: location.longitude
                                        },
                                        icon: {
                                            url: selectedMarker === location.id ? (0, $ec417a0df3dcfaa4$export$9f2ff75bd438036d)[selectedTab].selected : (0, $ec417a0df3dcfaa4$export$9f2ff75bd438036d)[selectedTab].icon
                                        },
                                        onClick: (_e)=>handleMarkerClick(location.id)
                                    }, location.id);
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)((0, $cf12b864f8a1636a$export$2e2bcd8739ae039), {
                            className: "absolute z-50 bg-white left-2.5 bottom-5 md:bottom-8 !w-8 !h-8 md:!w-10 md:!h-10 lg:!w-[50px] lg:!h-[50px]",
                            icon: (0, (/*@__PURE__*/$parcel$interopDefault($ef5c418a131db8af$exports))),
                            imgClassName: " fill-black w-5 h-5 md:w-6 md:h-6",
                            title: "poi",
                            onClick: handleResetMapCenter
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)("p", {
                    className: "w-full md:w-96 lg:w-147 text-center text-primary italic",
                    children: "Browsing Tip: Click on the target icon to show workspaces in your live location."
                })
            ]
        })
    });
};
var $980224afca407b64$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b6HlZ))).memo($980224afca407b64$var$CustomGoogleMap);



parcelRequire("b6HlZ");
var $1ac03b44e3d1078d$exports = {};
"use strict";

$1ac03b44e3d1078d$exports = (parcelRequire("gdCxA"));


var $fede83877a5f9f28$exports = {};

$fede83877a5f9f28$exports = (parcelRequire("fF0r8")).getBundleURL("7lpHJ") + "cross.f890e3df.svg";


const $da70da2a82e724a1$var$CustomGooglePlacesAutoComplete = ({ handlePlaceSelected: handlePlaceSelected, handleClearPlace: handleClearPlace, geoLocation: geoLocation, className: className })=>{
    // Create a bounding box with sides ~10km away from the center point
    const defaultBounds = {
        north: (geoLocation === null || geoLocation === void 0 ? void 0 : geoLocation.lat) + 0.1,
        south: (geoLocation === null || geoLocation === void 0 ? void 0 : geoLocation.lat) - 0.1,
        east: (geoLocation === null || geoLocation === void 0 ? void 0 : geoLocation.lng) + 0.1,
        west: (geoLocation === null || geoLocation === void 0 ? void 0 : geoLocation.lng) - 0.1
    };
    const { ref: ref } = (0, $1ac03b44e3d1078d$exports.usePlacesWidget)({
        apiKey: "AIzaSyBua7ngKVFbHoUIQ_2Gm3Q01b9uvF5a84E",
        onPlaceSelected: handlePlaceSelected,
        options: {
            types: [],
            bounds: defaultBounds
        }
    });
    const handleClearClicked = ()=>{
        ref.current.value = "";
        handleClearPlace();
    };
    return /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsxs)("div", {
        className: `h-11 border border-gray-400 rounded-full px-4 py-1 relative ${className}`,
        children: [
            /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)("input", {
                ref: ref,
                placeholder: "Enter City or Neighbourhood",
                className: "w-full h-full border-none outline-none relative"
            }),
            /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($fede83877a5f9f28$exports))),
                alt: "",
                className: "absolute right-2 top-2 md:right-4 md:top-2.5 cursor-pointer",
                onClick: handleClearClicked
            })
        ]
    });
};
var $da70da2a82e724a1$export$2e2bcd8739ae039 = $da70da2a82e724a1$var$CustomGooglePlacesAutoComplete;




const $a5e02d0cf2f5ec6b$var$Map = ({ defaultLocation: defaultLocation })=>{
    const { getFirebaseConfig: getFirebaseConfig } = (0, $a5a6fab2525fdce6$exports.Helpers);
    const firebaseConfig = getFirebaseConfig({
        REACT_APP_FIREBASE_API_KEY: "AIzaSyBoIeHTyO2Zr6jARvqrWPPAlqi3pdu2-KA",
        REACT_APP_FIREBASE_APP_ID: "1:717114758534:web:c0f5a5118efc5855164807",
        REACT_APP_FIREBASE_MESSAGE_SENDER_ID: "717114758534",
        REACT_APP_FIREBASE_PROJECT_ID: "flexday-6dacf"
    });
    const app = (0, $iXpG9.initializeApp)(firebaseConfig);
    const firestore = (0, $7TObl.getFirestore)(app);
    const meetingRoomLocationsRef = (0, $7TObl.collection)(firestore, "meetingRoomLocations");
    const privateOfficeLocationsRef = (0, $7TObl.collection)(firestore, "privateOfficeLocations");
    const [meetingRoomLocations, loadingMeetingRoomLocations] = (0, $603d4f5da0d29b2c$export$f976898995c345b4)((0, $7TObl.query)(meetingRoomLocationsRef, (0, $7TObl.where)("isVisible", "==", true)));
    const [privateOfficeLocations, loadingPrivateOfficeLocations] = (0, $603d4f5da0d29b2c$export$f976898995c345b4)((0, $7TObl.query)(privateOfficeLocationsRef, (0, $7TObl.where)("isVisible", "==", true)));
    const [flexdaySuitesLocations, setFlexdaySuitesLocations] = (0, $b6HlZ.useState)([]);
    const [filteredPrivateOfficeLocations, setFilteredPrivateOfficeLocations] = (0, $b6HlZ.useState)([]);
    const [filteredMeetingRoomLocations, setFilteredMeetingRoomLocations] = (0, $b6HlZ.useState)([]);
    const [selectedTab, setSelectedTab] = (0, $b6HlZ.useState)((0, $5e76e72696cf68eb$export$cbf506743859cf23).MeetingRoom);
    const [geoLocation, setGeoLocation] = (0, $b6HlZ.useState)(defaultLocation || (0, $831bd3f164fcae83$export$cbb02010c362b2ab));
    const [poi, setPoi] = (0, $b6HlZ.useState)(null);
    const [currentUserLocation, setCurrentUserLocation] = (0, $b6HlZ.useState)(defaultLocation || (0, $831bd3f164fcae83$export$cbb02010c362b2ab));
    const [sortedLocations, setSortedLocations] = (0, $b6HlZ.useState)([]);
    const [isPlaceSelected, setIsPlaceSelected] = (0, $b6HlZ.useState)(false);
    const [selectedMarker, setSelectedMarker] = (0, $b6HlZ.useState)(null);
    const [isPermissionGranted, setIsPermissionGranted] = (0, $b6HlZ.useState)(false);
    const inventoryCardsContainerRef = (0, $b6HlZ.useRef)(null);
    const isTabletOrDesktop = (0, $514cd3351bbd55bc$exports.useMediaQuery)({
        query: "(min-width: 768px)"
    });
    const handleTabChange = (name)=>{
        setSelectedTab(name);
    };
    const getLocations = ()=>{
        switch(selectedTab){
            case (0, $5e76e72696cf68eb$export$cbf506743859cf23).FlexdaySuite:
                return flexdaySuitesLocations;
            case (0, $5e76e72696cf68eb$export$cbf506743859cf23).MeetingRoom:
                return filteredMeetingRoomLocations;
            case (0, $5e76e72696cf68eb$export$cbf506743859cf23).PrivateOffice:
                return filteredPrivateOfficeLocations;
            default:
                return [];
        }
    };
    const getSortedLocations = ()=>{
        const locations = getLocations();
        const locationsWithDistance = locations === null || locations === void 0 ? void 0 : locations.map((location)=>{
            location.distance = (0, $9f66bc724b88f519$export$55ad5c77306bdcab)(geoLocation.lat, geoLocation.lng, location.latitude, location.longitude);
            return location;
        });
        return locationsWithDistance === null || locationsWithDistance === void 0 ? void 0 : locationsWithDistance.sort((a, b)=>a.distance - b.distance);
    };
    const scrollToCard = (cardRef)=>{
        if (isTabletOrDesktop) {
            const relativeTop = window.scrollY > inventoryCardsContainerRef.current.offsetTop ? window.scrollY : inventoryCardsContainerRef.current.offsetTop;
            inventoryCardsContainerRef.current.scrollTo({
                behavior: "smooth",
                top: cardRef.offsetTop - relativeTop
            });
        }
    };
    const handleMarkerClick = (markerId)=>{
        setSelectedMarker(markerId);
        const cardRef = document.getElementById(markerId);
        scrollToCard(cardRef);
    };
    const handleMarkerReset = ()=>{
        setSelectedMarker(null);
        setSortedLocations(getSortedLocations());
    };
    const onCardSelected = (id)=>{
        handleMarkerClick(id);
        const cardRef = document.getElementById(id);
        scrollToCard(cardRef);
    };
    (0, $b6HlZ.useEffect)(()=>{
        if (!loadingMeetingRoomLocations && !loadingPrivateOfficeLocations) {
            setFlexdaySuitesLocations(privateOfficeLocations.filter((location)=>location.name.startsWith("Flexday Suites")));
            setFilteredPrivateOfficeLocations(privateOfficeLocations.filter((location)=>!location.name.startsWith("Flexday Suites")));
            setFilteredMeetingRoomLocations(meetingRoomLocations.filter((location)=>!location.name.startsWith("Flexday Suites")));
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        loadingMeetingRoomLocations,
        loadingPrivateOfficeLocations
    ]);
    (0, $b6HlZ.useEffect)(()=>{
        handleMarkerReset();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        selectedTab
    ]);
    const handlePlaceSelected = (place)=>{
        setGeoLocation({
            lat: place.geometry.location.lat(),
            lng: place.geometry.location.lng()
        });
        setPoi({
            lat: place.geometry.location.lat(),
            lng: place.geometry.location.lng()
        });
        setIsPlaceSelected(true);
    };
    const handleMapDragged = (newGeoLocation)=>{
        setGeoLocation(newGeoLocation);
    };
    const permissionGranted = (newGeoLocation)=>{
        setGeoLocation({
            lat: newGeoLocation.coords.latitude,
            lng: newGeoLocation.coords.longitude
        });
        setCurrentUserLocation({
            lat: newGeoLocation.coords.latitude,
            lng: newGeoLocation.coords.longitude
        });
        setPoi({
            lat: newGeoLocation.coords.latitude,
            lng: newGeoLocation.coords.longitude
        });
        setIsPermissionGranted(true);
        setIsPlaceSelected(true);
    };
    const getLocationPermission = ()=>{
        if (navigator.geolocation) navigator.permissions.query({
            name: "geolocation"
        }).then(function(result) {
            if (result.state === "granted") navigator.geolocation.getCurrentPosition(permissionGranted, errors, options);
            else if (result.state === "prompt") navigator.geolocation.getCurrentPosition(permissionGranted, errors, options);
            else if (result.state === "denied") {
                setGeoLocation(currentUserLocation);
                setPoi(currentUserLocation);
            }
        });
    };
    const handleResetMapCenter = ()=>{
        if (isPermissionGranted) setGeoLocation(currentUserLocation);
        else getLocationPermission();
        setIsPlaceSelected(true);
    };
    const handleClearPlace = ()=>{
        setGeoLocation(currentUserLocation);
        setIsPlaceSelected(false);
        setSelectedMarker(null);
    };
    const options = {
        enableHighAccuracy: true,
        timeout: 15000,
        maximumAge: 0
    };
    const errors = (err)=>{
        console.warn(`ERROR(${err.code}): ${err.message}`);
    };
    (0, $b6HlZ.useEffect)(()=>{
        if (navigator.geolocation) navigator.permissions.query({
            name: "geolocation"
        }).then(function(result) {
            if (result.state === "granted" && !defaultLocation) navigator.geolocation.getCurrentPosition(permissionGranted, errors, options);
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $b6HlZ.useEffect)(()=>{
        if (!loadingMeetingRoomLocations && !loadingPrivateOfficeLocations) setSortedLocations(getSortedLocations());
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        loadingMeetingRoomLocations,
        loadingPrivateOfficeLocations,
        geoLocation,
        filteredMeetingRoomLocations,
        filteredPrivateOfficeLocations
    ]);
    (0, $b6HlZ.useEffect)(()=>{
        if (sortedLocations && sortedLocations.length > 0) {
            setSelectedMarker(sortedLocations === null || sortedLocations === void 0 ? void 0 : sortedLocations[0].id);
            const cardRef = document.getElementById(sortedLocations === null || sortedLocations === void 0 ? void 0 : sortedLocations[0].id);
            scrollToCard(cardRef);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        sortedLocations,
        isTabletOrDesktop
    ]);
    if (loadingMeetingRoomLocations || loadingPrivateOfficeLocations) return /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)("div", {
        children: "Loading..."
    });
    const renderInventoryCards = ()=>{
        return sortedLocations === null || sortedLocations === void 0 ? void 0 : sortedLocations.map((location)=>{
            return /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)((0, $e6c8847e4c8355ed$export$2e2bcd8739ae039), {
                location: location,
                selectedTab: selectedTab,
                selected: selectedMarker === location.id,
                onSelected: onCardSelected
            }, location.id);
        });
    };
    const renderSelectedCard = ()=>{
        const selectedLocation = sortedLocations === null || sortedLocations === void 0 ? void 0 : sortedLocations.find((location)=>location.id === selectedMarker);
        if (selectedLocation) return /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)((0, $e6c8847e4c8355ed$export$2e2bcd8739ae039), {
            location: selectedLocation,
            selectedTab: selectedTab
        });
    };
    return /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsxs)("div", {
        className: "flex flex-col gap-2 items-center justify-start pb-2 px-3 md:px-0",
        children: [
            !isTabletOrDesktop && /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)((0, $da70da2a82e724a1$export$2e2bcd8739ae039), {
                handlePlaceSelected: handlePlaceSelected,
                handleClearPlace: handleClearPlace,
                geoLocation: geoLocation,
                className: "w-full h-9 max-w-[570px]"
            }),
            /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsxs)("div", {
                className: "flex flex-col-reverse md:flex-row justify-start items-center md:justify-center md:items-start gap-1 md:gap-2 lg:gap-4 w-full px-0 md:px-3 lg:px-8 overflow-hidden",
                children: [
                    /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsxs)("div", {
                        className: "flex flex-col gap-3 justify-start items-center",
                        children: [
                            isTabletOrDesktop && /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)((0, $da70da2a82e724a1$export$2e2bcd8739ae039), {
                                handlePlaceSelected: handlePlaceSelected,
                                handleClearPlace: handleClearPlace,
                                geoLocation: geoLocation,
                                className: "md:w-72 lg:w-84"
                            }),
                            isTabletOrDesktop && /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)("div", {
                                className: "cards-container flex flex-col gap-4 justify-start items-center w-80 md:w-84 lg:w-97 max-h-[800px] px-6 overflow-y-auto overflow-x-hidden mb-6 ml-2",
                                ref: inventoryCardsContainerRef,
                                children: renderInventoryCards()
                            }),
                            !isTabletOrDesktop && /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)("div", {
                                className: "w-72",
                                children: renderSelectedCard()
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)((0, $980224afca407b64$export$2e2bcd8739ae039), {
                        geoLocation: geoLocation,
                        locations: sortedLocations,
                        selectedTab: selectedTab,
                        handleTabChange: handleTabChange,
                        isPlaceSelected: isPlaceSelected,
                        selectedMarker: selectedMarker,
                        handleMarkerClick: handleMarkerClick,
                        handleMapDragged: handleMapDragged,
                        handleResetMapCenter: handleResetMapCenter,
                        poi: poi
                    })
                ]
            })
        ]
    });
};
var $a5e02d0cf2f5ec6b$export$2e2bcd8739ae039 = $a5e02d0cf2f5ec6b$var$Map;





var $iXpG9 = parcelRequire("iXpG9");
parcelRequire("ehmfL");
var $clAv2 = parcelRequire("clAv2");
parcelRequire("8vofH");
var $7TObl = parcelRequire("7TObl");

var $iXpG9 = parcelRequire("iXpG9");
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Firebase constants.  Some of these (@defines) can be overridden at compile-time.
 */ const $5b5cbd208826b1f8$export$588c7fdda06fbb0a = {
    /**
     * @define {boolean} Whether this is the client Node.js SDK.
     */ NODE_CLIENT: false,
    /**
     * @define {boolean} Whether this is the Admin Node.js SDK.
     */ NODE_ADMIN: false,
    /**
     * Firebase SDK Version
     */ SDK_VERSION: "${JSCORE_VERSION}"
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Throws an error if the provided assertion is falsy
 */ const $5b5cbd208826b1f8$export$a7a9523472993e97 = function(assertion, message) {
    if (!assertion) throw $5b5cbd208826b1f8$export$a39cad550e7ab28a(message);
};
/**
 * Returns an Error object suitable for throwing.
 */ const $5b5cbd208826b1f8$export$a39cad550e7ab28a = function(message) {
    return new Error("Firebase Database (" + $5b5cbd208826b1f8$export$588c7fdda06fbb0a.SDK_VERSION + ") INTERNAL ASSERT FAILED: " + message);
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $5b5cbd208826b1f8$var$stringToByteArray$1 = function(str) {
    // TODO(user): Use native implementations if/when available
    const out = [];
    let p = 0;
    for(let i = 0; i < str.length; i++){
        let c = str.charCodeAt(i);
        if (c < 128) out[p++] = c;
        else if (c < 2048) {
            out[p++] = c >> 6 | 192;
            out[p++] = c & 63 | 128;
        } else if ((c & 0xfc00) === 0xd800 && i + 1 < str.length && (str.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
            // Surrogate Pair
            c = 0x10000 + ((c & 0x03ff) << 10) + (str.charCodeAt(++i) & 0x03ff);
            out[p++] = c >> 18 | 240;
            out[p++] = c >> 12 & 63 | 128;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        } else {
            out[p++] = c >> 12 | 224;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        }
    }
    return out;
};
/**
 * Turns an array of numbers into the string given by the concatenation of the
 * characters to which the numbers correspond.
 * @param bytes Array of numbers representing characters.
 * @return Stringification of the array.
 */ const $5b5cbd208826b1f8$var$byteArrayToString = function(bytes) {
    // TODO(user): Use native implementations if/when available
    const out = [];
    let pos = 0, c = 0;
    while(pos < bytes.length){
        const c1 = bytes[pos++];
        if (c1 < 128) out[c++] = String.fromCharCode(c1);
        else if (c1 > 191 && c1 < 224) {
            const c2 = bytes[pos++];
            out[c++] = String.fromCharCode((c1 & 31) << 6 | c2 & 63);
        } else if (c1 > 239 && c1 < 365) {
            // Surrogate Pair
            const c2 = bytes[pos++];
            const c3 = bytes[pos++];
            const c4 = bytes[pos++];
            const u = ((c1 & 7) << 18 | (c2 & 63) << 12 | (c3 & 63) << 6 | c4 & 63) - 0x10000;
            out[c++] = String.fromCharCode(0xd800 + (u >> 10));
            out[c++] = String.fromCharCode(0xdc00 + (u & 1023));
        } else {
            const c2 = bytes[pos++];
            const c3 = bytes[pos++];
            out[c++] = String.fromCharCode((c1 & 15) << 12 | (c2 & 63) << 6 | c3 & 63);
        }
    }
    return out.join("");
};
// We define it as an object literal instead of a class because a class compiled down to es5 can't
// be treeshaked. https://github.com/rollup/rollup/issues/1691
// Static lookup maps, lazily populated by init_()
const $5b5cbd208826b1f8$export$b3b2de96497acc47 = {
    /**
     * Maps bytes to characters.
     */ byteToCharMap_: null,
    /**
     * Maps characters to bytes.
     */ charToByteMap_: null,
    /**
     * Maps bytes to websafe characters.
     * @private
     */ byteToCharMapWebSafe_: null,
    /**
     * Maps websafe characters to bytes.
     * @private
     */ charToByteMapWebSafe_: null,
    /**
     * Our default alphabet, shared between
     * ENCODED_VALS and ENCODED_VALS_WEBSAFE
     */ ENCODED_VALS_BASE: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789",
    /**
     * Our default alphabet. Value 64 (=) is special; it means "nothing."
     */ get ENCODED_VALS () {
        return this.ENCODED_VALS_BASE + "+/=";
    },
    /**
     * Our websafe alphabet.
     */ get ENCODED_VALS_WEBSAFE () {
        return this.ENCODED_VALS_BASE + "-_.";
    },
    /**
     * Whether this browser supports the atob and btoa functions. This extension
     * started at Mozilla but is now implemented by many browsers. We use the
     * ASSUME_* variables to avoid pulling in the full useragent detection library
     * but still allowing the standard per-browser compilations.
     *
     */ HAS_NATIVE_SUPPORT: typeof atob === "function",
    /**
     * Base64-encode an array of bytes.
     *
     * @param input An array of bytes (numbers with
     *     value in [0, 255]) to encode.
     * @param webSafe Boolean indicating we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */ encodeByteArray (input, webSafe) {
        if (!Array.isArray(input)) throw Error("encodeByteArray takes an array as a parameter");
        this.init_();
        const byteToCharMap = webSafe ? this.byteToCharMapWebSafe_ : this.byteToCharMap_;
        const output = [];
        for(let i = 0; i < input.length; i += 3){
            const byte1 = input[i];
            const haveByte2 = i + 1 < input.length;
            const byte2 = haveByte2 ? input[i + 1] : 0;
            const haveByte3 = i + 2 < input.length;
            const byte3 = haveByte3 ? input[i + 2] : 0;
            const outByte1 = byte1 >> 2;
            const outByte2 = (byte1 & 0x03) << 4 | byte2 >> 4;
            let outByte3 = (byte2 & 0x0f) << 2 | byte3 >> 6;
            let outByte4 = byte3 & 0x3f;
            if (!haveByte3) {
                outByte4 = 64;
                if (!haveByte2) outByte3 = 64;
            }
            output.push(byteToCharMap[outByte1], byteToCharMap[outByte2], byteToCharMap[outByte3], byteToCharMap[outByte4]);
        }
        return output.join("");
    },
    /**
     * Base64-encode a string.
     *
     * @param input A string to encode.
     * @param webSafe If true, we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */ encodeString (input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) return btoa(input);
        return this.encodeByteArray($5b5cbd208826b1f8$var$stringToByteArray$1(input), webSafe);
    },
    /**
     * Base64-decode a string.
     *
     * @param input to decode.
     * @param webSafe True if we should use the
     *     alternative alphabet.
     * @return string representing the decoded value.
     */ decodeString (input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) return atob(input);
        return $5b5cbd208826b1f8$var$byteArrayToString(this.decodeStringToByteArray(input, webSafe));
    },
    /**
     * Base64-decode a string.
     *
     * In base-64 decoding, groups of four characters are converted into three
     * bytes.  If the encoder did not apply padding, the input length may not
     * be a multiple of 4.
     *
     * In this case, the last group will have fewer than 4 characters, and
     * padding will be inferred.  If the group has one or two characters, it decodes
     * to one byte.  If the group has three characters, it decodes to two bytes.
     *
     * @param input Input to decode.
     * @param webSafe True if we should use the web-safe alphabet.
     * @return bytes representing the decoded value.
     */ decodeStringToByteArray (input, webSafe) {
        this.init_();
        const charToByteMap = webSafe ? this.charToByteMapWebSafe_ : this.charToByteMap_;
        const output = [];
        for(let i = 0; i < input.length;){
            const byte1 = charToByteMap[input.charAt(i++)];
            const haveByte2 = i < input.length;
            const byte2 = haveByte2 ? charToByteMap[input.charAt(i)] : 0;
            ++i;
            const haveByte3 = i < input.length;
            const byte3 = haveByte3 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            const haveByte4 = i < input.length;
            const byte4 = haveByte4 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            if (byte1 == null || byte2 == null || byte3 == null || byte4 == null) throw Error();
            const outByte1 = byte1 << 2 | byte2 >> 4;
            output.push(outByte1);
            if (byte3 !== 64) {
                const outByte2 = byte2 << 4 & 0xf0 | byte3 >> 2;
                output.push(outByte2);
                if (byte4 !== 64) {
                    const outByte3 = byte3 << 6 & 0xc0 | byte4;
                    output.push(outByte3);
                }
            }
        }
        return output;
    },
    /**
     * Lazy static initialization function. Called before
     * accessing any of the static map variables.
     * @private
     */ init_ () {
        if (!this.byteToCharMap_) {
            this.byteToCharMap_ = {};
            this.charToByteMap_ = {};
            this.byteToCharMapWebSafe_ = {};
            this.charToByteMapWebSafe_ = {};
            // We want quick mappings back and forth, so we precompute two maps.
            for(let i = 0; i < this.ENCODED_VALS.length; i++){
                this.byteToCharMap_[i] = this.ENCODED_VALS.charAt(i);
                this.charToByteMap_[this.byteToCharMap_[i]] = i;
                this.byteToCharMapWebSafe_[i] = this.ENCODED_VALS_WEBSAFE.charAt(i);
                this.charToByteMapWebSafe_[this.byteToCharMapWebSafe_[i]] = i;
                // Be forgiving when decoding and correctly decode both encodings.
                if (i >= this.ENCODED_VALS_BASE.length) {
                    this.charToByteMap_[this.ENCODED_VALS_WEBSAFE.charAt(i)] = i;
                    this.charToByteMapWebSafe_[this.ENCODED_VALS.charAt(i)] = i;
                }
            }
        }
    }
};
/**
 * URL-safe base64 encoding
 */ const $5b5cbd208826b1f8$export$e510a73ee562749 = function(str) {
    const utf8Bytes = $5b5cbd208826b1f8$var$stringToByteArray$1(str);
    return $5b5cbd208826b1f8$export$b3b2de96497acc47.encodeByteArray(utf8Bytes, true);
};
/**
 * URL-safe base64 encoding (without "." padding in the end).
 * e.g. Used in JSON Web Token (JWT) parts.
 */ const $5b5cbd208826b1f8$export$4b5284a3025a455 = function(str) {
    // Use base64url encoding and remove padding in the end (dot characters).
    return $5b5cbd208826b1f8$export$e510a73ee562749(str).replace(/\./g, "");
};
/**
 * URL-safe base64 decoding
 *
 * NOTE: DO NOT use the global atob() function - it does NOT support the
 * base64Url variant encoding.
 *
 * @param str To be decoded
 * @return Decoded result, if possible
 */ const $5b5cbd208826b1f8$export$c62426fdd000a97e = function(str) {
    try {
        return $5b5cbd208826b1f8$export$b3b2de96497acc47.decodeString(str, true);
    } catch (e) {
        console.error("base64Decode failed: ", e);
    }
    return null;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Do a deep-copy of basic JavaScript Objects or Arrays.
 */ function $5b5cbd208826b1f8$export$6c40052bed430212(value) {
    return $5b5cbd208826b1f8$export$54e9fb29908872fa(undefined, value);
}
/**
 * Copy properties from source to target (recursively allows extension
 * of Objects and Arrays).  Scalar values in the target are over-written.
 * If target is undefined, an object of the appropriate type will be created
 * (and returned).
 *
 * We recursively copy all child properties of plain Objects in the source- so
 * that namespace- like dictionaries are merged.
 *
 * Note that the target can be a function, in which case the properties in
 * the source Object are copied onto it as static properties of the Function.
 *
 * Note: we don't merge __proto__ to prevent prototype pollution
 */ function $5b5cbd208826b1f8$export$54e9fb29908872fa(target, source) {
    if (!(source instanceof Object)) return source;
    switch(source.constructor){
        case Date:
            // Treat Dates like scalars; if the target date object had any child
            // properties - they will be lost!
            const dateValue = source;
            return new Date(dateValue.getTime());
        case Object:
            if (target === undefined) target = {};
            break;
        case Array:
            // Always copy the array source and overwrite the target.
            target = [];
            break;
        default:
            // Not a plain Object - treat it as a scalar.
            return source;
    }
    for(const prop in source){
        // use isValidKey to guard against prototype pollution. See https://snyk.io/vuln/SNYK-JS-LODASH-450202
        if (!source.hasOwnProperty(prop) || !$5b5cbd208826b1f8$var$isValidKey(prop)) continue;
        target[prop] = $5b5cbd208826b1f8$export$54e9fb29908872fa(target[prop], source[prop]);
    }
    return target;
}
function $5b5cbd208826b1f8$var$isValidKey(key) {
    return key !== "__proto__";
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $5b5cbd208826b1f8$export$85f6557964517f1a {
    /**
     * Our API internals are not promiseified and cannot because our callback APIs have subtle expectations around
     * invoking promises inline, which Promises are forbidden to do. This method accepts an optional node-style callback
     * and returns a node-style callback which will resolve or reject the Deferred's promise.
     */ wrapCallback(callback) {
        return (error, value)=>{
            if (error) this.reject(error);
            else this.resolve(value);
            if (typeof callback === "function") {
                // Attaching noop handler just in case developer wasn't expecting
                // promises
                this.promise.catch(()=>{});
                // Some of our callbacks don't expect a value and our own tests
                // assert that the parameter length is 1
                if (callback.length === 1) callback(error);
                else callback(error, value);
            }
        };
    }
    constructor(){
        this.reject = ()=>{};
        this.resolve = ()=>{};
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
    }
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $5b5cbd208826b1f8$export$367bf224123348f1(token, projectId) {
    if (token.uid) throw new Error('The "uid" field is no longer supported by mockUserToken. Please use "sub" instead for Firebase Auth User ID.');
    // Unsecured JWTs use "none" as the algorithm.
    const header = {
        alg: "none",
        type: "JWT"
    };
    const project = projectId || "demo-project";
    const iat = token.iat || 0;
    const sub = token.sub || token.user_id;
    if (!sub) throw new Error("mockUserToken must contain 'sub' or 'user_id' field!");
    const payload = Object.assign({
        // Set all required fields to decent defaults
        iss: `https://securetoken.google.com/${project}`,
        aud: project,
        iat: iat,
        exp: iat + 3600,
        auth_time: iat,
        sub: sub,
        user_id: sub,
        firebase: {
            sign_in_provider: "custom",
            identities: {}
        }
    }, token);
    // Unsecured JWTs use the empty string as a signature.
    const signature = "";
    return [
        $5b5cbd208826b1f8$export$4b5284a3025a455(JSON.stringify(header)),
        $5b5cbd208826b1f8$export$4b5284a3025a455(JSON.stringify(payload)),
        signature
    ].join(".");
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns navigator.userAgent string or '' if it's not defined.
 * @return user agent string
 */ function $5b5cbd208826b1f8$export$c36915b22ce77c19() {
    if (typeof navigator !== "undefined" && typeof navigator["userAgent"] === "string") return navigator["userAgent"];
    else return "";
}
/**
 * Detect Cordova / PhoneGap / Ionic frameworks on a mobile device.
 *
 * Deliberately does not rely on checking `file://` URLs (as this fails PhoneGap
 * in the Ripple emulator) nor Cordova `onDeviceReady`, which would normally
 * wait for a callback.
 */ function $5b5cbd208826b1f8$export$872f8323f01d7ae0() {
    return typeof window !== "undefined" && // @ts-ignore Setting up an broadly applicable index signature for Window
    // just to deal with this case would probably be a bad idea.
    !!(window["cordova"] || window["phonegap"] || window["PhoneGap"]) && /ios|iphone|ipod|ipad|android|blackberry|iemobile/i.test($5b5cbd208826b1f8$export$c36915b22ce77c19());
}
/**
 * Detect Node.js.
 *
 * @return true if Node.js environment is detected.
 */ // Node detection logic from: https://github.com/iliakan/detect-node/
function $5b5cbd208826b1f8$export$8ee0fc9ee280b4ee() {
    try {
        return Object.prototype.toString.call($parcel$global.process) === "[object process]";
    } catch (e) {
        return false;
    }
}
/**
 * Detect Browser Environment
 */ function $5b5cbd208826b1f8$export$4e09c449d6c407f7() {
    return typeof self === "object" && self.self === self;
}
function $5b5cbd208826b1f8$export$caa8774a9107a58e() {
    const runtime = typeof chrome === "object" ? chrome.runtime : typeof browser === "object" ? browser.runtime : undefined;
    return typeof runtime === "object" && runtime.id !== undefined;
}
/**
 * Detect React Native.
 *
 * @return true if ReactNative environment is detected.
 */ function $5b5cbd208826b1f8$export$f7a1e23e542d38e3() {
    return typeof navigator === "object" && navigator["product"] === "ReactNative";
}
/** Detects Electron apps. */ function $5b5cbd208826b1f8$export$f2f6a8999f8ebd30() {
    return $5b5cbd208826b1f8$export$c36915b22ce77c19().indexOf("Electron/") >= 0;
}
/** Detects Internet Explorer. */ function $5b5cbd208826b1f8$export$7e7b1a9668aaed8() {
    const ua = $5b5cbd208826b1f8$export$c36915b22ce77c19();
    return ua.indexOf("MSIE ") >= 0 || ua.indexOf("Trident/") >= 0;
}
/** Detects Universal Windows Platform apps. */ function $5b5cbd208826b1f8$export$202944b2d2824246() {
    return $5b5cbd208826b1f8$export$c36915b22ce77c19().indexOf("MSAppHost/") >= 0;
}
/**
 * Detect whether the current SDK build is the Node version.
 *
 * @return true if it's the Node SDK build.
 */ function $5b5cbd208826b1f8$export$5d1d834fbbf8bab7() {
    return $5b5cbd208826b1f8$export$588c7fdda06fbb0a.NODE_CLIENT === true || $5b5cbd208826b1f8$export$588c7fdda06fbb0a.NODE_ADMIN === true;
}
/** Returns true if we are running in Safari. */ function $5b5cbd208826b1f8$export$95df08bae54cb4df() {
    return !$5b5cbd208826b1f8$export$8ee0fc9ee280b4ee() && navigator.userAgent.includes("Safari") && !navigator.userAgent.includes("Chrome");
}
/**
 * This method checks if indexedDB is supported by current browser/service worker context
 * @return true if indexedDB is supported by current browser/service worker context
 */ function $5b5cbd208826b1f8$export$3865db50535c2055() {
    return typeof indexedDB === "object";
}
/**
 * This method validates browser/sw context for indexedDB by opening a dummy indexedDB database and reject
 * if errors occur during the database open operation.
 *
 * @throws exception if current browser/sw context can't run idb.open (ex: Safari iframe, Firefox
 * private browsing)
 */ function $5b5cbd208826b1f8$export$a8a3018f3d187a4d() {
    return new Promise((resolve, reject)=>{
        try {
            let preExist = true;
            const DB_CHECK_NAME = "validate-browser-context-for-indexeddb-analytics-module";
            const request = self.indexedDB.open(DB_CHECK_NAME);
            request.onsuccess = ()=>{
                request.result.close();
                // delete database only when it doesn't pre-exist
                if (!preExist) self.indexedDB.deleteDatabase(DB_CHECK_NAME);
                resolve(true);
            };
            request.onupgradeneeded = ()=>{
                preExist = false;
            };
            request.onerror = ()=>{
                var _a;
                reject(((_a = request.error) === null || _a === void 0 ? void 0 : _a.message) || "");
            };
        } catch (error) {
            reject(error);
        }
    });
}
/**
 *
 * This method checks whether cookie is enabled within current browser
 * @return true if cookie is enabled within current browser
 */ function $5b5cbd208826b1f8$export$f172b7eb6cf60599() {
    if (typeof navigator === "undefined" || !navigator.cookieEnabled) return false;
    return true;
}
/**
 * Polyfill for `globalThis` object.
 * @returns the `globalThis` object for the given environment.
 */ function $5b5cbd208826b1f8$export$a4e55266d2135a7f() {
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw new Error("Unable to locate global object.");
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Standardized Firebase Error.
 *
 * Usage:
 *
 *   // Typescript string literals for type-safe codes
 *   type Err =
 *     'unknown' |
 *     'object-not-found'
 *     ;
 *
 *   // Closure enum for type-safe error codes
 *   // at-enum {string}
 *   var Err = {
 *     UNKNOWN: 'unknown',
 *     OBJECT_NOT_FOUND: 'object-not-found',
 *   }
 *
 *   let errors: Map<Err, string> = {
 *     'generic-error': "Unknown error",
 *     'file-not-found': "Could not find file: {$file}",
 *   };
 *
 *   // Type-safe function - must pass a valid error code as param.
 *   let error = new ErrorFactory<Err>('service', 'Service', errors);
 *
 *   ...
 *   throw error.create(Err.GENERIC);
 *   ...
 *   throw error.create(Err.FILE_NOT_FOUND, {'file': fileName});
 *   ...
 *   // Service: Could not file file: foo.txt (service/file-not-found).
 *
 *   catch (e) {
 *     assert(e.message === "Could not find file: foo.txt.");
 *     if (e.code === 'service/file-not-found') {
 *       console.log("Could not read file: " + e['file']);
 *     }
 *   }
 */ const $5b5cbd208826b1f8$var$ERROR_NAME = "FirebaseError";
// Based on code from:
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Custom_Error_Types
class $5b5cbd208826b1f8$export$dd24e9cd51226c56 extends Error {
    constructor(/** The error code for this error. */ code, message, /** Custom data for this error. */ customData){
        super(message);
        this.code = code;
        this.customData = customData;
        /** The custom name for all FirebaseErrors. */ this.name = $5b5cbd208826b1f8$var$ERROR_NAME;
        // Fix For ES5
        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $5b5cbd208826b1f8$export$dd24e9cd51226c56.prototype);
        // Maintains proper stack trace for where our error was thrown.
        // Only available on V8.
        if (Error.captureStackTrace) Error.captureStackTrace(this, $5b5cbd208826b1f8$export$3fa6e1b18a3b2d40.prototype.create);
    }
}
class $5b5cbd208826b1f8$export$3fa6e1b18a3b2d40 {
    create(code, ...data) {
        const customData = data[0] || {};
        const fullCode = `${this.service}/${code}`;
        const template = this.errors[code];
        const message = template ? $5b5cbd208826b1f8$var$replaceTemplate(template, customData) : "Error";
        // Service Name: Error message (service/code).
        const fullMessage = `${this.serviceName}: ${message} (${fullCode}).`;
        const error = new $5b5cbd208826b1f8$export$dd24e9cd51226c56(fullCode, fullMessage, customData);
        return error;
    }
    constructor(service, serviceName, errors){
        this.service = service;
        this.serviceName = serviceName;
        this.errors = errors;
    }
}
function $5b5cbd208826b1f8$var$replaceTemplate(template, data) {
    return template.replace($5b5cbd208826b1f8$var$PATTERN, (_, key)=>{
        const value = data[key];
        return value != null ? String(value) : `<${key}?>`;
    });
}
const $5b5cbd208826b1f8$var$PATTERN = /\{\$([^}]+)}/g;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Evaluates a JSON string into a javascript object.
 *
 * @param {string} str A string containing JSON.
 * @return {*} The javascript object representing the specified JSON.
 */ function $5b5cbd208826b1f8$export$c5a53ce6a17cf18d(str) {
    return JSON.parse(str);
}
/**
 * Returns JSON representing a javascript object.
 * @param {*} data Javascript object to be stringified.
 * @return {string} The JSON contents of the object.
 */ function $5b5cbd208826b1f8$export$fac44ee5b035f737(data) {
    return JSON.stringify(data);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Decodes a Firebase auth. token into constituent parts.
 *
 * Notes:
 * - May return with invalid / incomplete claims if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $5b5cbd208826b1f8$export$2f872c0f2117be69 = function(token) {
    let header = {}, claims = {}, data = {}, signature = "";
    try {
        const parts = token.split(".");
        header = $5b5cbd208826b1f8$export$c5a53ce6a17cf18d($5b5cbd208826b1f8$export$c62426fdd000a97e(parts[0]) || "");
        claims = $5b5cbd208826b1f8$export$c5a53ce6a17cf18d($5b5cbd208826b1f8$export$c62426fdd000a97e(parts[1]) || "");
        signature = parts[2];
        data = claims["d"] || {};
        delete claims["d"];
    } catch (e) {}
    return {
        header: header,
        claims: claims,
        data: data,
        signature: signature
    };
};
/**
 * Decodes a Firebase auth. token and checks the validity of its time-based claims. Will return true if the
 * token is within the time window authorized by the 'nbf' (not-before) and 'iat' (issued-at) claims.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $5b5cbd208826b1f8$export$5f870fcca7ae6a88 = function(token) {
    const claims = $5b5cbd208826b1f8$export$2f872c0f2117be69(token).claims;
    const now = Math.floor(new Date().getTime() / 1000);
    let validSince = 0, validUntil = 0;
    if (typeof claims === "object") {
        if (claims.hasOwnProperty("nbf")) validSince = claims["nbf"];
        else if (claims.hasOwnProperty("iat")) validSince = claims["iat"];
        if (claims.hasOwnProperty("exp")) validUntil = claims["exp"];
        else // token will expire after 24h by default
        validUntil = validSince + 86400;
    }
    return !!now && !!validSince && !!validUntil && now >= validSince && now <= validUntil;
};
/**
 * Decodes a Firebase auth. token and returns its issued at time if valid, null otherwise.
 *
 * Notes:
 * - May return null if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $5b5cbd208826b1f8$export$701c661ec91095f2 = function(token) {
    const claims = $5b5cbd208826b1f8$export$2f872c0f2117be69(token).claims;
    if (typeof claims === "object" && claims.hasOwnProperty("iat")) return claims["iat"];
    return null;
};
/**
 * Decodes a Firebase auth. token and checks the validity of its format. Expects a valid issued-at time.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $5b5cbd208826b1f8$export$9565ca3d387f8aa0 = function(token) {
    const decoded = $5b5cbd208826b1f8$export$2f872c0f2117be69(token), claims = decoded.claims;
    return !!claims && typeof claims === "object" && claims.hasOwnProperty("iat");
};
/**
 * Attempts to peer into an auth token and determine if it's an admin auth token by looking at the claims portion.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $5b5cbd208826b1f8$export$fc970ed23da99565 = function(token) {
    const claims = $5b5cbd208826b1f8$export$2f872c0f2117be69(token).claims;
    return typeof claims === "object" && claims["admin"] === true;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $5b5cbd208826b1f8$export$2344b14b097df817(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
}
function $5b5cbd208826b1f8$export$e51ae4db7b428f67(obj, key) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) return obj[key];
    else return undefined;
}
function $5b5cbd208826b1f8$export$dd1bc94b04021eeb(obj) {
    for(const key in obj){
        if (Object.prototype.hasOwnProperty.call(obj, key)) return false;
    }
    return true;
}
function $5b5cbd208826b1f8$export$871de8747c9eaa88(obj, fn, contextObj) {
    const res = {};
    for(const key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) res[key] = fn.call(contextObj, obj[key], key, obj);
    return res;
}
/**
 * Deep equal two objects. Support Arrays and Objects.
 */ function $5b5cbd208826b1f8$export$9cb4719e2e525b7a(a, b) {
    if (a === b) return true;
    const aKeys = Object.keys(a);
    const bKeys = Object.keys(b);
    for (const k of aKeys){
        if (!bKeys.includes(k)) return false;
        const aProp = a[k];
        const bProp = b[k];
        if ($5b5cbd208826b1f8$var$isObject(aProp) && $5b5cbd208826b1f8$var$isObject(bProp)) {
            if (!$5b5cbd208826b1f8$export$9cb4719e2e525b7a(aProp, bProp)) return false;
        } else if (aProp !== bProp) return false;
    }
    for (const k of bKeys){
        if (!aKeys.includes(k)) return false;
    }
    return true;
}
function $5b5cbd208826b1f8$var$isObject(thing) {
    return thing !== null && typeof thing === "object";
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a querystring-formatted string (e.g. &arg=val&arg2=val2) from a
 * params object (e.g. {arg: 'val', arg2: 'val2'})
 * Note: You must prepend it with ? when adding it to a URL.
 */ function $5b5cbd208826b1f8$export$ac4103b836844853(querystringParams) {
    const params = [];
    for (const [key, value] of Object.entries(querystringParams))if (Array.isArray(value)) value.forEach((arrayVal)=>{
        params.push(encodeURIComponent(key) + "=" + encodeURIComponent(arrayVal));
    });
    else params.push(encodeURIComponent(key) + "=" + encodeURIComponent(value));
    return params.length ? "&" + params.join("&") : "";
}
/**
 * Decodes a querystring (e.g. ?arg=val&arg2=val2) into a params object
 * (e.g. {arg: 'val', arg2: 'val2'})
 */ function $5b5cbd208826b1f8$export$c1271ca4c8a70741(querystring) {
    const obj = {};
    const tokens = querystring.replace(/^\?/, "").split("&");
    tokens.forEach((token)=>{
        if (token) {
            const [key, value] = token.split("=");
            obj[decodeURIComponent(key)] = decodeURIComponent(value);
        }
    });
    return obj;
}
/**
 * Extract the query string part of a URL, including the leading question mark (if present).
 */ function $5b5cbd208826b1f8$export$1a8408415472d8ed(url) {
    const queryStart = url.indexOf("?");
    if (!queryStart) return "";
    const fragmentStart = url.indexOf("#", queryStart);
    return url.substring(queryStart, fragmentStart > 0 ? fragmentStart : undefined);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview SHA-1 cryptographic hash.
 * Variable names follow the notation in FIPS PUB 180-3:
 * http://csrc.nist.gov/publications/fips/fips180-3/fips180-3_final.pdf.
 *
 * Usage:
 *   var sha1 = new sha1();
 *   sha1.update(bytes);
 *   var hash = sha1.digest();
 *
 * Performance:
 *   Chrome 23:   ~400 Mbit/s
 *   Firefox 16:  ~250 Mbit/s
 *
 */ /**
 * SHA-1 cryptographic hash constructor.
 *
 * The properties declared here are discussed in the above algorithm document.
 * @constructor
 * @final
 * @struct
 */ class $5b5cbd208826b1f8$export$c85d589bf4e25fef {
    reset() {
        this.chain_[0] = 0x67452301;
        this.chain_[1] = 0xefcdab89;
        this.chain_[2] = 0x98badcfe;
        this.chain_[3] = 0x10325476;
        this.chain_[4] = 0xc3d2e1f0;
        this.inbuf_ = 0;
        this.total_ = 0;
    }
    /**
     * Internal compress helper function.
     * @param buf Block to compress.
     * @param offset Offset of the block in the buffer.
     * @private
     */ compress_(buf, offset) {
        if (!offset) offset = 0;
        const W = this.W_;
        // get 16 big endian words
        if (typeof buf === "string") for(let i = 0; i < 16; i++){
            // TODO(user): [bug 8140122] Recent versions of Safari for Mac OS and iOS
            // have a bug that turns the post-increment ++ operator into pre-increment
            // during JIT compilation.  We have code that depends heavily on SHA-1 for
            // correctness and which is affected by this bug, so I've removed all uses
            // of post-increment ++ in which the result value is used.  We can revert
            // this change once the Safari bug
            // (https://bugs.webkit.org/show_bug.cgi?id=109036) has been fixed and
            // most clients have been updated.
            W[i] = buf.charCodeAt(offset) << 24 | buf.charCodeAt(offset + 1) << 16 | buf.charCodeAt(offset + 2) << 8 | buf.charCodeAt(offset + 3);
            offset += 4;
        }
        else for(let i = 0; i < 16; i++){
            W[i] = buf[offset] << 24 | buf[offset + 1] << 16 | buf[offset + 2] << 8 | buf[offset + 3];
            offset += 4;
        }
        // expand to 80 words
        for(let i = 16; i < 80; i++){
            const t = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
            W[i] = (t << 1 | t >>> 31) & 0xffffffff;
        }
        let a = this.chain_[0];
        let b = this.chain_[1];
        let c = this.chain_[2];
        let d = this.chain_[3];
        let e = this.chain_[4];
        let f, k;
        // TODO(user): Try to unroll this loop to speed up the computation.
        for(let i = 0; i < 80; i++){
            if (i < 40) {
                if (i < 20) {
                    f = d ^ b & (c ^ d);
                    k = 0x5a827999;
                } else {
                    f = b ^ c ^ d;
                    k = 0x6ed9eba1;
                }
            } else if (i < 60) {
                f = b & c | d & (b | c);
                k = 0x8f1bbcdc;
            } else {
                f = b ^ c ^ d;
                k = 0xca62c1d6;
            }
            const t = (a << 5 | a >>> 27) + f + e + k + W[i] & 0xffffffff;
            e = d;
            d = c;
            c = (b << 30 | b >>> 2) & 0xffffffff;
            b = a;
            a = t;
        }
        this.chain_[0] = this.chain_[0] + a & 0xffffffff;
        this.chain_[1] = this.chain_[1] + b & 0xffffffff;
        this.chain_[2] = this.chain_[2] + c & 0xffffffff;
        this.chain_[3] = this.chain_[3] + d & 0xffffffff;
        this.chain_[4] = this.chain_[4] + e & 0xffffffff;
    }
    update(bytes, length) {
        // TODO(johnlenz): tighten the function signature and remove this check
        if (bytes == null) return;
        if (length === undefined) length = bytes.length;
        const lengthMinusBlock = length - this.blockSize;
        let n = 0;
        // Using local instead of member variables gives ~5% speedup on Firefox 16.
        const buf = this.buf_;
        let inbuf = this.inbuf_;
        // The outer while loop should execute at most twice.
        while(n < length){
            // When we have no data in the block to top up, we can directly process the
            // input buffer (assuming it contains sufficient data). This gives ~25%
            // speedup on Chrome 23 and ~15% speedup on Firefox 16, but requires that
            // the data is provided in large chunks (or in multiples of 64 bytes).
            if (inbuf === 0) while(n <= lengthMinusBlock){
                this.compress_(bytes, n);
                n += this.blockSize;
            }
            if (typeof bytes === "string") while(n < length){
                buf[inbuf] = bytes.charCodeAt(n);
                ++inbuf;
                ++n;
                if (inbuf === this.blockSize) {
                    this.compress_(buf);
                    inbuf = 0;
                    break;
                }
            }
            else while(n < length){
                buf[inbuf] = bytes[n];
                ++inbuf;
                ++n;
                if (inbuf === this.blockSize) {
                    this.compress_(buf);
                    inbuf = 0;
                    break;
                }
            }
        }
        this.inbuf_ = inbuf;
        this.total_ += length;
    }
    /** @override */ digest() {
        const digest = [];
        let totalBits = this.total_ * 8;
        // Add pad 0x80 0x00*.
        if (this.inbuf_ < 56) this.update(this.pad_, 56 - this.inbuf_);
        else this.update(this.pad_, this.blockSize - (this.inbuf_ - 56));
        // Add # bits.
        for(let i = this.blockSize - 1; i >= 56; i--){
            this.buf_[i] = totalBits & 255;
            totalBits /= 256; // Don't use bit-shifting here!
        }
        this.compress_(this.buf_);
        let n = 0;
        for(let i = 0; i < 5; i++)for(let j = 24; j >= 0; j -= 8){
            digest[n] = this.chain_[i] >> j & 255;
            ++n;
        }
        return digest;
    }
    constructor(){
        /**
         * Holds the previous values of accumulated variables a-e in the compress_
         * function.
         * @private
         */ this.chain_ = [];
        /**
         * A buffer holding the partially computed hash result.
         * @private
         */ this.buf_ = [];
        /**
         * An array of 80 bytes, each a part of the message to be hashed.  Referred to
         * as the message schedule in the docs.
         * @private
         */ this.W_ = [];
        /**
         * Contains data needed to pad messages less than 64 bytes.
         * @private
         */ this.pad_ = [];
        /**
         * @private {number}
         */ this.inbuf_ = 0;
        /**
         * @private {number}
         */ this.total_ = 0;
        this.blockSize = 64;
        this.pad_[0] = 128;
        for(let i = 1; i < this.blockSize; ++i)this.pad_[i] = 0;
        this.reset();
    }
}
/**
 * Helper to make a Subscribe function (just like Promise helps make a
 * Thenable).
 *
 * @param executor Function which can make calls to a single Observer
 *     as a proxy.
 * @param onNoObservers Callback when count of Observers goes to zero.
 */ function $5b5cbd208826b1f8$export$364097d812234b3f(executor, onNoObservers) {
    const proxy = new $5b5cbd208826b1f8$var$ObserverProxy(executor, onNoObservers);
    return proxy.subscribe.bind(proxy);
}
/**
 * Implement fan-out for any number of Observers attached via a subscribe
 * function.
 */ class $5b5cbd208826b1f8$var$ObserverProxy {
    next(value) {
        this.forEachObserver((observer)=>{
            observer.next(value);
        });
    }
    error(error) {
        this.forEachObserver((observer)=>{
            observer.error(error);
        });
        this.close(error);
    }
    complete() {
        this.forEachObserver((observer)=>{
            observer.complete();
        });
        this.close();
    }
    /**
     * Subscribe function that can be used to add an Observer to the fan-out list.
     *
     * - We require that no event is sent to a subscriber sychronously to their
     *   call to subscribe().
     */ subscribe(nextOrObserver, error, complete) {
        let observer;
        if (nextOrObserver === undefined && error === undefined && complete === undefined) throw new Error("Missing Observer.");
        // Assemble an Observer object when passed as callback functions.
        if ($5b5cbd208826b1f8$var$implementsAnyMethods(nextOrObserver, [
            "next",
            "error",
            "complete"
        ])) observer = nextOrObserver;
        else observer = {
            next: nextOrObserver,
            error: error,
            complete: complete
        };
        if (observer.next === undefined) observer.next = $5b5cbd208826b1f8$var$noop;
        if (observer.error === undefined) observer.error = $5b5cbd208826b1f8$var$noop;
        if (observer.complete === undefined) observer.complete = $5b5cbd208826b1f8$var$noop;
        const unsub = this.unsubscribeOne.bind(this, this.observers.length);
        // Attempt to subscribe to a terminated Observable - we
        // just respond to the Observer with the final error or complete
        // event.
        if (this.finalized) // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            try {
                if (this.finalError) observer.error(this.finalError);
                else observer.complete();
            } catch (e) {
            // nothing
            }
            return;
        });
        this.observers.push(observer);
        return unsub;
    }
    // Unsubscribe is synchronous - we guarantee that no events are sent to
    // any unsubscribed Observer.
    unsubscribeOne(i) {
        if (this.observers === undefined || this.observers[i] === undefined) return;
        delete this.observers[i];
        this.observerCount -= 1;
        if (this.observerCount === 0 && this.onNoObservers !== undefined) this.onNoObservers(this);
    }
    forEachObserver(fn) {
        if (this.finalized) // Already closed by previous event....just eat the additional values.
        return;
        // Since sendOne calls asynchronously - there is no chance that
        // this.observers will become undefined.
        for(let i = 0; i < this.observers.length; i++)this.sendOne(i, fn);
    }
    // Call the Observer via one of it's callback function. We are careful to
    // confirm that the observe has not been unsubscribed since this asynchronous
    // function had been queued.
    sendOne(i, fn) {
        // Execute the callback asynchronously
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            if (this.observers !== undefined && this.observers[i] !== undefined) try {
                fn(this.observers[i]);
            } catch (e) {
                // Ignore exceptions raised in Observers or missing methods of an
                // Observer.
                // Log error to console. b/31404806
                if (typeof console !== "undefined" && console.error) console.error(e);
            }
        });
    }
    close(err) {
        if (this.finalized) return;
        this.finalized = true;
        if (err !== undefined) this.finalError = err;
        // Proxy is no longer needed - garbage collect references
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            this.observers = undefined;
            this.onNoObservers = undefined;
        });
    }
    /**
     * @param executor Function which can make calls to a single Observer
     *     as a proxy.
     * @param onNoObservers Callback when count of Observers goes to zero.
     */ constructor(executor, onNoObservers){
        this.observers = [];
        this.unsubscribes = [];
        this.observerCount = 0;
        // Micro-task scheduling by calling task.then().
        this.task = Promise.resolve();
        this.finalized = false;
        this.onNoObservers = onNoObservers;
        // Call the executor asynchronously so subscribers that are called
        // synchronously after the creation of the subscribe function
        // can still receive the very first value generated in the executor.
        this.task.then(()=>{
            executor(this);
        }).catch((e)=>{
            this.error(e);
        });
    }
}
/** Turn synchronous function into one called asynchronously. */ // eslint-disable-next-line @typescript-eslint/ban-types
function $5b5cbd208826b1f8$export$12af436354f1a4f7(fn, onError) {
    return (...args)=>{
        Promise.resolve(true).then(()=>{
            fn(...args);
        }).catch((error)=>{
            if (onError) onError(error);
        });
    };
}
/**
 * Return true if the object passed in implements any of the named methods.
 */ function $5b5cbd208826b1f8$var$implementsAnyMethods(obj, methods) {
    if (typeof obj !== "object" || obj === null) return false;
    for (const method of methods){
        if (method in obj && typeof obj[method] === "function") return true;
    }
    return false;
}
function $5b5cbd208826b1f8$var$noop() {
// do nothing
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Check to make sure the appropriate number of arguments are provided for a public function.
 * Throws an error if it fails.
 *
 * @param fnName The function name
 * @param minCount The minimum number of arguments to allow for the function call
 * @param maxCount The maximum number of argument to allow for the function call
 * @param argCount The actual number of arguments provided.
 */ const $5b5cbd208826b1f8$export$20164226a0ed35c3 = function(fnName, minCount, maxCount, argCount) {
    let argError;
    if (argCount < minCount) argError = "at least " + minCount;
    else if (argCount > maxCount) argError = maxCount === 0 ? "none" : "no more than " + maxCount;
    if (argError) {
        const error = fnName + " failed: Was called with " + argCount + (argCount === 1 ? " argument." : " arguments.") + " Expects " + argError + ".";
        throw new Error(error);
    }
};
/**
 * Generates a string to prefix an error message about failed argument validation
 *
 * @param fnName The function name
 * @param argName The name of the argument
 * @return The prefix to add to the error thrown for validation.
 */ function $5b5cbd208826b1f8$export$adea4917e02d93dc(fnName, argName) {
    return `${fnName} failed: ${argName} argument `;
}
/**
 * @param fnName
 * @param argumentNumber
 * @param namespace
 * @param optional
 */ function $5b5cbd208826b1f8$export$8eef22622e725943(fnName, namespace, optional) {
    if (optional && !namespace) return;
    if (typeof namespace !== "string") //TODO: I should do more validation here. We only allow certain chars in namespaces.
    throw new Error($5b5cbd208826b1f8$export$adea4917e02d93dc(fnName, "namespace") + "must be a valid firebase namespace.");
}
function $5b5cbd208826b1f8$export$5bcd2a2eb6640dfa(fnName, argumentName, // eslint-disable-next-line @typescript-eslint/ban-types
callback, optional) {
    if (optional && !callback) return;
    if (typeof callback !== "function") throw new Error($5b5cbd208826b1f8$export$adea4917e02d93dc(fnName, argumentName) + "must be a valid function.");
}
function $5b5cbd208826b1f8$export$df77539402cfb523(fnName, argumentName, context, optional) {
    if (optional && !context) return;
    if (typeof context !== "object" || context === null) throw new Error($5b5cbd208826b1f8$export$adea4917e02d93dc(fnName, argumentName) + "must be a valid context object.");
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Code originally came from goog.crypt.stringToUtf8ByteArray, but for some reason they
// automatically replaced '\r\n' with '\n', and they didn't handle surrogate pairs,
// so it's been modified.
// Note that not all Unicode characters appear as single characters in JavaScript strings.
// fromCharCode returns the UTF-16 encoding of a character - so some Unicode characters
// use 2 characters in Javascript.  All 4-byte UTF-8 characters begin with a first
// character in the range 0xD800 - 0xDBFF (the first character of a so-called surrogate
// pair).
// See http://www.ecma-international.org/ecma-262/5.1/#sec-15.1.3
/**
 * @param {string} str
 * @return {Array}
 */ const $5b5cbd208826b1f8$export$655666783217a925 = function(str) {
    const out = [];
    let p = 0;
    for(let i = 0; i < str.length; i++){
        let c = str.charCodeAt(i);
        // Is this the lead surrogate in a surrogate pair?
        if (c >= 0xd800 && c <= 0xdbff) {
            const high = c - 0xd800; // the high 10 bits.
            i++;
            $5b5cbd208826b1f8$export$a7a9523472993e97(i < str.length, "Surrogate pair missing trail surrogate.");
            const low = str.charCodeAt(i) - 0xdc00; // the low 10 bits.
            c = 0x10000 + (high << 10) + low;
        }
        if (c < 128) out[p++] = c;
        else if (c < 2048) {
            out[p++] = c >> 6 | 192;
            out[p++] = c & 63 | 128;
        } else if (c < 65536) {
            out[p++] = c >> 12 | 224;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        } else {
            out[p++] = c >> 18 | 240;
            out[p++] = c >> 12 & 63 | 128;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        }
    }
    return out;
};
/**
 * Calculate length without actually converting; useful for doing cheaper validation.
 * @param {string} str
 * @return {number}
 */ const $5b5cbd208826b1f8$export$9536dc0a75b20bf9 = function(str) {
    let p = 0;
    for(let i = 0; i < str.length; i++){
        const c = str.charCodeAt(i);
        if (c < 128) p++;
        else if (c < 2048) p += 2;
        else if (c >= 0xd800 && c <= 0xdbff) {
            // Lead surrogate of a surrogate pair.  The pair together will take 4 bytes to represent.
            p += 4;
            i++; // skip trail surrogate.
        } else p += 3;
    }
    return p;
};
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The amount of milliseconds to exponentially increase.
 */ const $5b5cbd208826b1f8$var$DEFAULT_INTERVAL_MILLIS = 1000;
/**
 * The factor to backoff by.
 * Should be a number greater than 1.
 */ const $5b5cbd208826b1f8$var$DEFAULT_BACKOFF_FACTOR = 2;
/**
 * The maximum milliseconds to increase to.
 *
 * <p>Visible for testing
 */ const $5b5cbd208826b1f8$export$bdf1213ffbdb096e = 14400000; // Four hours, like iOS and Android.
/**
 * The percentage of backoff time to randomize by.
 * See
 * http://go/safe-client-behavior#step-1-determine-the-appropriate-retry-interval-to-handle-spike-traffic
 * for context.
 *
 * <p>Visible for testing
 */ const $5b5cbd208826b1f8$export$3518ed2cfe61fa30 = 0.5;
/**
 * Based on the backoff method from
 * https://github.com/google/closure-library/blob/master/closure/goog/math/exponentialbackoff.js.
 * Extracted here so we don't need to pass metadata and a stateful ExponentialBackoff object around.
 */ function $5b5cbd208826b1f8$export$4d810c0ca64ed8e9(backoffCount, intervalMillis = $5b5cbd208826b1f8$var$DEFAULT_INTERVAL_MILLIS, backoffFactor = $5b5cbd208826b1f8$var$DEFAULT_BACKOFF_FACTOR) {
    // Calculates an exponentially increasing value.
    // Deviation: calculates value from count and a constant interval, so we only need to save value
    // and count to restore state.
    const currBaseValue = intervalMillis * Math.pow(backoffFactor, backoffCount);
    // A random "fuzz" to avoid waves of retries.
    // Deviation: randomFactor is required.
    const randomWait = Math.round(// A fraction of the backoff value to add/subtract.
    // Deviation: changes multiplication order to improve readability.
    $5b5cbd208826b1f8$export$3518ed2cfe61fa30 * currBaseValue * // A random float (rounded to int by Math.round above) in the range [-1, 1]. Determines
    // if we add or subtract.
    (Math.random() - 0.5) * 2);
    // Limits backoff to max to avoid effectively permanent backoff.
    return Math.min($5b5cbd208826b1f8$export$bdf1213ffbdb096e, currBaseValue + randomWait);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provide English ordinal letters after a number
 */ function $5b5cbd208826b1f8$export$7bb39f879164e4ac(i) {
    if (!Number.isFinite(i)) return `${i}`;
    return i + $5b5cbd208826b1f8$var$indicator(i);
}
function $5b5cbd208826b1f8$var$indicator(i) {
    i = Math.abs(i);
    const cent = i % 100;
    if (cent >= 10 && cent <= 20) return "th";
    const dec = i % 10;
    if (dec === 1) return "st";
    if (dec === 2) return "nd";
    if (dec === 3) return "rd";
    return "th";
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $5b5cbd208826b1f8$export$4befe9b5fa509a1b(service) {
    if (service && service._delegate) return service._delegate;
    else return service;
}



/**
 * Component for service name T, e.g. `auth`, `auth-internal`
 */ class $0128d935dde49bdd$export$16fa2f45be04daa8 {
    setInstantiationMode(mode) {
        this.instantiationMode = mode;
        return this;
    }
    setMultipleInstances(multipleInstances) {
        this.multipleInstances = multipleInstances;
        return this;
    }
    setServiceProps(props) {
        this.serviceProps = props;
        return this;
    }
    setInstanceCreatedCallback(callback) {
        this.onInstanceCreated = callback;
        return this;
    }
    /**
     *
     * @param name The public service name, e.g. app, auth, firestore, database
     * @param instanceFactory Service factory responsible for creating the public interface
     * @param type whether the service provided by the component is public or private
     */ constructor(name, instanceFactory, type){
        this.name = name;
        this.instanceFactory = instanceFactory;
        this.type = type;
        this.multipleInstances = false;
        /**
         * Properties to be added to the service namespace
         */ this.serviceProps = {};
        this.instantiationMode = "LAZY" /* LAZY */ ;
        this.onInstanceCreated = null;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $0128d935dde49bdd$var$DEFAULT_ENTRY_NAME = "[DEFAULT]";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for instance for service name T, e.g. 'auth', 'auth-internal'
 * NameServiceMapping[T] is an alias for the type of the instance
 */ class $0128d935dde49bdd$export$2881499e37b75b9a {
    /**
     * @param identifier A provider can provide mulitple instances of a service
     * if this.component.multipleInstances is true.
     */ get(identifier) {
        // if multipleInstances is not supported, use the default name
        const normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
        if (!this.instancesDeferred.has(normalizedIdentifier)) {
            const deferred = new (0, $5b5cbd208826b1f8$export$85f6557964517f1a)();
            this.instancesDeferred.set(normalizedIdentifier, deferred);
            if (this.isInitialized(normalizedIdentifier) || this.shouldAutoInitialize()) // initialize the service if it can be auto-initialized
            try {
                const instance = this.getOrInitializeService({
                    instanceIdentifier: normalizedIdentifier
                });
                if (instance) deferred.resolve(instance);
            } catch (e) {
            // when the instance factory throws an exception during get(), it should not cause
            // a fatal error. We just return the unresolved promise in this case.
            }
        }
        return this.instancesDeferred.get(normalizedIdentifier).promise;
    }
    getImmediate(options) {
        var _a;
        // if multipleInstances is not supported, use the default name
        const normalizedIdentifier = this.normalizeInstanceIdentifier(options === null || options === void 0 ? void 0 : options.identifier);
        const optional = (_a = options === null || options === void 0 ? void 0 : options.optional) !== null && _a !== void 0 ? _a : false;
        if (this.isInitialized(normalizedIdentifier) || this.shouldAutoInitialize()) try {
            return this.getOrInitializeService({
                instanceIdentifier: normalizedIdentifier
            });
        } catch (e) {
            if (optional) return null;
            else throw e;
        }
        else {
            // In case a component is not initialized and should/can not be auto-initialized at the moment, return null if the optional flag is set, or throw
            if (optional) return null;
            else throw Error(`Service ${this.name} is not available`);
        }
    }
    getComponent() {
        return this.component;
    }
    setComponent(component) {
        if (component.name !== this.name) throw Error(`Mismatching Component ${component.name} for Provider ${this.name}.`);
        if (this.component) throw Error(`Component for ${this.name} has already been provided`);
        this.component = component;
        // return early without attempting to initialize the component if the component requires explicit initialization (calling `Provider.initialize()`)
        if (!this.shouldAutoInitialize()) return;
        // if the service is eager, initialize the default instance
        if ($0128d935dde49bdd$var$isComponentEager(component)) try {
            this.getOrInitializeService({
                instanceIdentifier: $0128d935dde49bdd$var$DEFAULT_ENTRY_NAME
            });
        } catch (e) {
        // when the instance factory for an eager Component throws an exception during the eager
        // initialization, it should not cause a fatal error.
        // TODO: Investigate if we need to make it configurable, because some component may want to cause
        // a fatal error in this case?
        }
        // Create service instances for the pending promises and resolve them
        // NOTE: if this.multipleInstances is false, only the default instance will be created
        // and all promises with resolve with it regardless of the identifier.
        for (const [instanceIdentifier, instanceDeferred] of this.instancesDeferred.entries()){
            const normalizedIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
            try {
                // `getOrInitializeService()` should always return a valid instance since a component is guaranteed. use ! to make typescript happy.
                const instance = this.getOrInitializeService({
                    instanceIdentifier: normalizedIdentifier
                });
                instanceDeferred.resolve(instance);
            } catch (e) {
            // when the instance factory throws an exception, it should not cause
            // a fatal error. We just leave the promise unresolved.
            }
        }
    }
    clearInstance(identifier = $0128d935dde49bdd$var$DEFAULT_ENTRY_NAME) {
        this.instancesDeferred.delete(identifier);
        this.instancesOptions.delete(identifier);
        this.instances.delete(identifier);
    }
    // app.delete() will call this method on every provider to delete the services
    // TODO: should we mark the provider as deleted?
    async delete() {
        const services = Array.from(this.instances.values());
        await Promise.all([
            ...services.filter((service)=>"INTERNAL" in service) // legacy services
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .map((service)=>service.INTERNAL.delete()),
            ...services.filter((service)=>"_delete" in service) // modularized services
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .map((service)=>service._delete())
        ]);
    }
    isComponentSet() {
        return this.component != null;
    }
    isInitialized(identifier = $0128d935dde49bdd$var$DEFAULT_ENTRY_NAME) {
        return this.instances.has(identifier);
    }
    getOptions(identifier = $0128d935dde49bdd$var$DEFAULT_ENTRY_NAME) {
        return this.instancesOptions.get(identifier) || {};
    }
    initialize(opts = {}) {
        const { options: options = {} } = opts;
        const normalizedIdentifier = this.normalizeInstanceIdentifier(opts.instanceIdentifier);
        if (this.isInitialized(normalizedIdentifier)) throw Error(`${this.name}(${normalizedIdentifier}) has already been initialized`);
        if (!this.isComponentSet()) throw Error(`Component ${this.name} has not been registered yet`);
        const instance = this.getOrInitializeService({
            instanceIdentifier: normalizedIdentifier,
            options: options
        });
        // resolve any pending promise waiting for the service instance
        for (const [instanceIdentifier, instanceDeferred] of this.instancesDeferred.entries()){
            const normalizedDeferredIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
            if (normalizedIdentifier === normalizedDeferredIdentifier) instanceDeferred.resolve(instance);
        }
        return instance;
    }
    /**
     *
     * @param callback - a function that will be invoked  after the provider has been initialized by calling provider.initialize().
     * The function is invoked SYNCHRONOUSLY, so it should not execute any longrunning tasks in order to not block the program.
     *
     * @param identifier An optional instance identifier
     * @returns a function to unregister the callback
     */ onInit(callback, identifier) {
        var _a;
        const normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
        const existingCallbacks = (_a = this.onInitCallbacks.get(normalizedIdentifier)) !== null && _a !== void 0 ? _a : new Set();
        existingCallbacks.add(callback);
        this.onInitCallbacks.set(normalizedIdentifier, existingCallbacks);
        const existingInstance = this.instances.get(normalizedIdentifier);
        if (existingInstance) callback(existingInstance, normalizedIdentifier);
        return ()=>{
            existingCallbacks.delete(callback);
        };
    }
    /**
     * Invoke onInit callbacks synchronously
     * @param instance the service instance`
     */ invokeOnInitCallbacks(instance, identifier) {
        const callbacks = this.onInitCallbacks.get(identifier);
        if (!callbacks) return;
        for (const callback of callbacks)try {
            callback(instance, identifier);
        } catch (_a) {
        // ignore errors in the onInit callback
        }
    }
    getOrInitializeService({ instanceIdentifier: instanceIdentifier, options: options = {} }) {
        let instance = this.instances.get(instanceIdentifier);
        if (!instance && this.component) {
            instance = this.component.instanceFactory(this.container, {
                instanceIdentifier: $0128d935dde49bdd$var$normalizeIdentifierForFactory(instanceIdentifier),
                options: options
            });
            this.instances.set(instanceIdentifier, instance);
            this.instancesOptions.set(instanceIdentifier, options);
            /**
             * Invoke onInit listeners.
             * Note this.component.onInstanceCreated is different, which is used by the component creator,
             * while onInit listeners are registered by consumers of the provider.
             */ this.invokeOnInitCallbacks(instance, instanceIdentifier);
            /**
             * Order is important
             * onInstanceCreated() should be called after this.instances.set(instanceIdentifier, instance); which
             * makes `isInitialized()` return true.
             */ if (this.component.onInstanceCreated) try {
                this.component.onInstanceCreated(this.container, instanceIdentifier, instance);
            } catch (_a) {
            // ignore errors in the onInstanceCreatedCallback
            }
        }
        return instance || null;
    }
    normalizeInstanceIdentifier(identifier = $0128d935dde49bdd$var$DEFAULT_ENTRY_NAME) {
        if (this.component) return this.component.multipleInstances ? identifier : $0128d935dde49bdd$var$DEFAULT_ENTRY_NAME;
        else return identifier; // assume multiple instances are supported before the component is provided.
    }
    shouldAutoInitialize() {
        return !!this.component && this.component.instantiationMode !== "EXPLICIT" /* EXPLICIT */ ;
    }
    constructor(name, container){
        this.name = name;
        this.container = container;
        this.component = null;
        this.instances = new Map();
        this.instancesDeferred = new Map();
        this.instancesOptions = new Map();
        this.onInitCallbacks = new Map();
    }
}
// undefined should be passed to the service factory for the default instance
function $0128d935dde49bdd$var$normalizeIdentifierForFactory(identifier) {
    return identifier === $0128d935dde49bdd$var$DEFAULT_ENTRY_NAME ? undefined : identifier;
}
function $0128d935dde49bdd$var$isComponentEager(component) {
    return component.instantiationMode === "EAGER" /* EAGER */ ;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * ComponentContainer that provides Providers for service name T, e.g. `auth`, `auth-internal`
 */ class $0128d935dde49bdd$export$436a80eea5d5c0c5 {
    /**
     *
     * @param component Component being added
     * @param overwrite When a component with the same name has already been registered,
     * if overwrite is true: overwrite the existing component with the new component and create a new
     * provider with the new component. It can be useful in tests where you want to use different mocks
     * for different tests.
     * if overwrite is false: throw an exception
     */ addComponent(component) {
        const provider = this.getProvider(component.name);
        if (provider.isComponentSet()) throw new Error(`Component ${component.name} has already been registered with ${this.name}`);
        provider.setComponent(component);
    }
    addOrOverwriteComponent(component) {
        const provider = this.getProvider(component.name);
        if (provider.isComponentSet()) // delete the existing provider from the container, so we can register the new component
        this.providers.delete(component.name);
        this.addComponent(component);
    }
    /**
     * getProvider provides a type safe interface where it can only be called with a field name
     * present in NameServiceMapping interface.
     *
     * Firebase SDKs providing services should extend NameServiceMapping interface to register
     * themselves.
     */ getProvider(name) {
        if (this.providers.has(name)) return this.providers.get(name);
        // create a Provider for a service that hasn't registered with Firebase
        const provider = new $0128d935dde49bdd$export$2881499e37b75b9a(name, this);
        this.providers.set(name, provider);
        return provider;
    }
    getProviders() {
        return Array.from(this.providers.values());
    }
    constructor(name){
        this.name = name;
        this.providers = new Map();
    }
}


/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $6d4a5578187f8573$var$LONG_TYPE = "type.googleapis.com/google.protobuf.Int64Value";
const $6d4a5578187f8573$var$UNSIGNED_LONG_TYPE = "type.googleapis.com/google.protobuf.UInt64Value";
function $6d4a5578187f8573$var$mapValues(// { [k: string]: unknown } is no longer a wildcard assignment target after typescript 3.5
// eslint-disable-next-line @typescript-eslint/no-explicit-any
o, f) {
    const result = {};
    for(const key in o)if (o.hasOwnProperty(key)) result[key] = f(o[key]);
    return result;
}
/**
 * Takes data and encodes it in a JSON-friendly way, such that types such as
 * Date are preserved.
 * @internal
 * @param data - Data to encode.
 */ function $6d4a5578187f8573$var$encode(data) {
    if (data == null) return null;
    if (data instanceof Number) data = data.valueOf();
    if (typeof data === "number" && isFinite(data)) // Any number in JS is safe to put directly in JSON and parse as a double
    // without any loss of precision.
    return data;
    if (data === true || data === false) return data;
    if (Object.prototype.toString.call(data) === "[object String]") return data;
    if (data instanceof Date) return data.toISOString();
    if (Array.isArray(data)) return data.map((x)=>$6d4a5578187f8573$var$encode(x));
    if (typeof data === "function" || typeof data === "object") return $6d4a5578187f8573$var$mapValues(data, (x)=>$6d4a5578187f8573$var$encode(x));
    // If we got this far, the data is not encodable.
    throw new Error("Data cannot be encoded in JSON: " + data);
}
/**
 * Takes data that's been encoded in a JSON-friendly form and returns a form
 * with richer datatypes, such as Dates, etc.
 * @internal
 * @param json - JSON to convert.
 */ function $6d4a5578187f8573$var$decode(json) {
    if (json == null) return json;
    if (json["@type"]) switch(json["@type"]){
        case $6d4a5578187f8573$var$LONG_TYPE:
        // Fall through and handle this the same as unsigned.
        case $6d4a5578187f8573$var$UNSIGNED_LONG_TYPE:
            {
                // Technically, this could work return a valid number for malformed
                // data if there was a number followed by garbage. But it's just not
                // worth all the extra code to detect that case.
                const value = Number(json["value"]);
                if (isNaN(value)) throw new Error("Data cannot be decoded from JSON: " + json);
                return value;
            }
        default:
            throw new Error("Data cannot be decoded from JSON: " + json);
    }
    if (Array.isArray(json)) return json.map((x)=>$6d4a5578187f8573$var$decode(x));
    if (typeof json === "function" || typeof json === "object") return $6d4a5578187f8573$var$mapValues(json, (x)=>$6d4a5578187f8573$var$decode(x));
    // Anything else is safe to return.
    return json;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Type constant for Firebase Functions.
 */ const $6d4a5578187f8573$var$FUNCTIONS_TYPE = "functions";
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Standard error codes for different ways a request can fail, as defined by:
 * https://github.com/googleapis/googleapis/blob/master/google/rpc/code.proto
 *
 * This map is used primarily to convert from a backend error code string to
 * a client SDK error code string, and make sure it's in the supported set.
 */ const $6d4a5578187f8573$var$errorCodeMap = {
    OK: "ok",
    CANCELLED: "cancelled",
    UNKNOWN: "unknown",
    INVALID_ARGUMENT: "invalid-argument",
    DEADLINE_EXCEEDED: "deadline-exceeded",
    NOT_FOUND: "not-found",
    ALREADY_EXISTS: "already-exists",
    PERMISSION_DENIED: "permission-denied",
    UNAUTHENTICATED: "unauthenticated",
    RESOURCE_EXHAUSTED: "resource-exhausted",
    FAILED_PRECONDITION: "failed-precondition",
    ABORTED: "aborted",
    OUT_OF_RANGE: "out-of-range",
    UNIMPLEMENTED: "unimplemented",
    INTERNAL: "internal",
    UNAVAILABLE: "unavailable",
    DATA_LOSS: "data-loss"
};
/**
 * An explicit error that can be thrown from a handler to send an error to the
 * client that called the function.
 */ class $6d4a5578187f8573$var$FunctionsError extends (0, $5b5cbd208826b1f8$export$dd24e9cd51226c56) {
    constructor(/**
     * A standard error code that will be returned to the client. This also
     * determines the HTTP status code of the response, as defined in code.proto.
     */ code, message, /**
     * Extra data to be converted to JSON and included in the error response.
     */ details){
        super(`${$6d4a5578187f8573$var$FUNCTIONS_TYPE}/${code}`, message || "");
        this.details = details;
    }
}
/**
 * Takes an HTTP status code and returns the corresponding ErrorCode.
 * This is the standard HTTP status code -> error mapping defined in:
 * https://github.com/googleapis/googleapis/blob/master/google/rpc/code.proto
 *
 * @param status An HTTP status code.
 * @return The corresponding ErrorCode, or ErrorCode.UNKNOWN if none.
 */ function $6d4a5578187f8573$var$codeForHTTPStatus(status) {
    // Make sure any successful status is OK.
    if (status >= 200 && status < 300) return "ok";
    switch(status){
        case 0:
            // This can happen if the server returns 500.
            return "internal";
        case 400:
            return "invalid-argument";
        case 401:
            return "unauthenticated";
        case 403:
            return "permission-denied";
        case 404:
            return "not-found";
        case 409:
            return "aborted";
        case 429:
            return "resource-exhausted";
        case 499:
            return "cancelled";
        case 500:
            return "internal";
        case 501:
            return "unimplemented";
        case 503:
            return "unavailable";
        case 504:
            return "deadline-exceeded";
    }
    return "unknown";
}
/**
 * Takes an HTTP response and returns the corresponding Error, if any.
 */ function $6d4a5578187f8573$var$_errorForResponse(status, bodyJSON) {
    let code = $6d4a5578187f8573$var$codeForHTTPStatus(status);
    // Start with reasonable defaults from the status code.
    let description = code;
    let details = undefined;
    // Then look through the body for explicit details.
    try {
        const errorJSON = bodyJSON && bodyJSON.error;
        if (errorJSON) {
            const status = errorJSON.status;
            if (typeof status === "string") {
                if (!$6d4a5578187f8573$var$errorCodeMap[status]) // They must've included an unknown error code in the body.
                return new $6d4a5578187f8573$var$FunctionsError("internal", "internal");
                code = $6d4a5578187f8573$var$errorCodeMap[status];
                // TODO(klimt): Add better default descriptions for error enums.
                // The default description needs to be updated for the new code.
                description = status;
            }
            const message = errorJSON.message;
            if (typeof message === "string") description = message;
            details = errorJSON.details;
            if (details !== undefined) details = $6d4a5578187f8573$var$decode(details);
        }
    } catch (e) {
    // If we couldn't parse explicit error data, that's fine.
    }
    if (code === "ok") // Technically, there's an edge case where a developer could explicitly
    // return an error code of OK, and we will treat it as success, but that
    // seems reasonable.
    return null;
    return new $6d4a5578187f8573$var$FunctionsError(code, description, details);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Helper class to get metadata that should be included with a function call.
 * @internal
 */ class $6d4a5578187f8573$var$ContextProvider {
    async getAuthToken() {
        if (!this.auth) return undefined;
        try {
            const token = await this.auth.getToken();
            return token === null || token === void 0 ? void 0 : token.accessToken;
        } catch (e) {
            // If there's any error when trying to get the auth token, leave it off.
            return undefined;
        }
    }
    async getMessagingToken() {
        if (!this.messaging || !("Notification" in self) || Notification.permission !== "granted") return undefined;
        try {
            return await this.messaging.getToken();
        } catch (e) {
            // We don't warn on this, because it usually means messaging isn't set up.
            // console.warn('Failed to retrieve instance id token.', e);
            // If there's any error when trying to get the token, leave it off.
            return undefined;
        }
    }
    async getAppCheckToken() {
        if (this.appCheck) {
            const result = await this.appCheck.getToken();
            if (result.error) // Do not send the App Check header to the functions endpoint if
            // there was an error from the App Check exchange endpoint. The App
            // Check SDK will already have logged the error to console.
            return null;
            return result.token;
        }
        return null;
    }
    async getContext() {
        const authToken = await this.getAuthToken();
        const messagingToken = await this.getMessagingToken();
        const appCheckToken = await this.getAppCheckToken();
        return {
            authToken: authToken,
            messagingToken: messagingToken,
            appCheckToken: appCheckToken
        };
    }
    constructor(authProvider, messagingProvider, appCheckProvider){
        this.auth = null;
        this.messaging = null;
        this.appCheck = null;
        this.auth = authProvider.getImmediate({
            optional: true
        });
        this.messaging = messagingProvider.getImmediate({
            optional: true
        });
        if (!this.auth) authProvider.get().then((auth)=>this.auth = auth, ()=>{
        /* get() never rejects */ });
        if (!this.messaging) messagingProvider.get().then((messaging)=>this.messaging = messaging, ()=>{
        /* get() never rejects */ });
        if (!this.appCheck) appCheckProvider.get().then((appCheck)=>this.appCheck = appCheck, ()=>{
        /* get() never rejects */ });
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $6d4a5578187f8573$var$DEFAULT_REGION = "us-central1";
/**
 * Returns a Promise that will be rejected after the given duration.
 * The error will be of type FunctionsError.
 *
 * @param millis Number of milliseconds to wait before rejecting.
 */ function $6d4a5578187f8573$var$failAfter(millis) {
    // Node timers and browser timers are fundamentally incompatible, but we
    // don't care about the value here
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let timer = null;
    return {
        promise: new Promise((_, reject)=>{
            timer = setTimeout(()=>{
                reject(new $6d4a5578187f8573$var$FunctionsError("deadline-exceeded", "deadline-exceeded"));
            }, millis);
        }),
        cancel: ()=>{
            if (timer) clearTimeout(timer);
        }
    };
}
/**
 * The main class for the Firebase Functions SDK.
 * @internal
 */ class $6d4a5578187f8573$var$FunctionsService {
    _delete() {
        return this.deleteService();
    }
    /**
     * Returns the URL for a callable with the given name.
     * @param name - The name of the callable.
     * @internal
     */ _url(name) {
        const projectId = this.app.options.projectId;
        if (this.emulatorOrigin !== null) {
            const origin = this.emulatorOrigin;
            return `${origin}/${projectId}/${this.region}/${name}`;
        }
        if (this.customDomain !== null) return `${this.customDomain}/${name}`;
        return `https://${this.region}-${projectId}.cloudfunctions.net/${name}`;
    }
    /**
     * Creates a new Functions service for the given app.
     * @param app - The FirebaseApp to use.
     */ constructor(app, authProvider, messagingProvider, appCheckProvider, regionOrCustomDomain = $6d4a5578187f8573$var$DEFAULT_REGION, fetchImpl){
        this.app = app;
        this.fetchImpl = fetchImpl;
        this.emulatorOrigin = null;
        this.contextProvider = new $6d4a5578187f8573$var$ContextProvider(authProvider, messagingProvider, appCheckProvider);
        // Cancels all ongoing requests when resolved.
        this.cancelAllRequests = new Promise((resolve)=>{
            this.deleteService = ()=>{
                return Promise.resolve(resolve());
            };
        });
        // Resolve the region or custom domain overload by attempting to parse it.
        try {
            const url = new URL(regionOrCustomDomain);
            this.customDomain = url.origin;
            this.region = $6d4a5578187f8573$var$DEFAULT_REGION;
        } catch (e) {
            this.customDomain = null;
            this.region = regionOrCustomDomain;
        }
    }
}
/**
 * Modify this instance to communicate with the Cloud Functions emulator.
 *
 * Note: this must be called before this instance has been used to do any operations.
 *
 * @param host The emulator host (ex: localhost)
 * @param port The emulator port (ex: 5001)
 * @public
 */ function $6d4a5578187f8573$var$connectFunctionsEmulator$1(functionsInstance, host, port) {
    functionsInstance.emulatorOrigin = `http://${host}:${port}`;
}
/**
 * Returns a reference to the callable https trigger with the given name.
 * @param name - The name of the trigger.
 * @public
 */ function $6d4a5578187f8573$var$httpsCallable$1(functionsInstance, name, options) {
    return (data)=>{
        return $6d4a5578187f8573$var$call(functionsInstance, name, data, options || {});
    };
}
/**
 * Returns a reference to the callable https trigger with the given url.
 * @param url - The url of the trigger.
 * @public
 */ function $6d4a5578187f8573$var$httpsCallableFromURL$1(functionsInstance, url, options) {
    return (data)=>{
        return $6d4a5578187f8573$var$callAtURL(functionsInstance, url, data, options || {});
    };
}
/**
 * Does an HTTP POST and returns the completed response.
 * @param url The url to post to.
 * @param body The JSON body of the post.
 * @param headers The HTTP headers to include in the request.
 * @return A Promise that will succeed when the request finishes.
 */ async function $6d4a5578187f8573$var$postJSON(url, body, headers, fetchImpl) {
    headers["Content-Type"] = "application/json";
    let response;
    try {
        response = await fetchImpl(url, {
            method: "POST",
            body: JSON.stringify(body),
            headers: headers
        });
    } catch (e) {
        // This could be an unhandled error on the backend, or it could be a
        // network error. There's no way to know, since an unhandled error on the
        // backend will fail to set the proper CORS header, and thus will be
        // treated as a network error by fetch.
        return {
            status: 0,
            json: null
        };
    }
    let json = null;
    try {
        json = await response.json();
    } catch (e) {
    // If we fail to parse JSON, it will fail the same as an empty body.
    }
    return {
        status: response.status,
        json: json
    };
}
/**
 * Calls a callable function asynchronously and returns the result.
 * @param name The name of the callable trigger.
 * @param data The data to pass as params to the function.s
 */ function $6d4a5578187f8573$var$call(functionsInstance, name, data, options) {
    const url = functionsInstance._url(name);
    return $6d4a5578187f8573$var$callAtURL(functionsInstance, url, data, options);
}
/**
 * Calls a callable function asynchronously and returns the result.
 * @param url The url of the callable trigger.
 * @param data The data to pass as params to the function.s
 */ async function $6d4a5578187f8573$var$callAtURL(functionsInstance, url, data, options) {
    // Encode any special types, such as dates, in the input data.
    data = $6d4a5578187f8573$var$encode(data);
    const body = {
        data: data
    };
    // Add a header for the authToken.
    const headers = {};
    const context = await functionsInstance.contextProvider.getContext();
    if (context.authToken) headers["Authorization"] = "Bearer " + context.authToken;
    if (context.messagingToken) headers["Firebase-Instance-ID-Token"] = context.messagingToken;
    if (context.appCheckToken !== null) headers["X-Firebase-AppCheck"] = context.appCheckToken;
    // Default timeout to 70s, but let the options override it.
    const timeout = options.timeout || 70000;
    const failAfterHandle = $6d4a5578187f8573$var$failAfter(timeout);
    const response = await Promise.race([
        $6d4a5578187f8573$var$postJSON(url, body, headers, functionsInstance.fetchImpl),
        failAfterHandle.promise,
        functionsInstance.cancelAllRequests
    ]);
    // Always clear the failAfter timeout
    failAfterHandle.cancel();
    // If service was deleted, interrupted response throws an error.
    if (!response) throw new $6d4a5578187f8573$var$FunctionsError("cancelled", "Firebase Functions instance was deleted.");
    // Check for an error status, regardless of http status.
    const error = $6d4a5578187f8573$var$_errorForResponse(response.status, response.json);
    if (error) throw error;
    if (!response.json) throw new $6d4a5578187f8573$var$FunctionsError("internal", "Response is not valid JSON object.");
    let responseData = response.json.data;
    // TODO(klimt): For right now, allow "result" instead of "data", for
    // backwards compatibility.
    if (typeof responseData === "undefined") responseData = response.json.result;
    if (typeof responseData === "undefined") // Consider the response malformed.
    throw new $6d4a5578187f8573$var$FunctionsError("internal", "Response is missing data field.");
    // Decode any special types, such as dates, in the returned data.
    const decodedData = $6d4a5578187f8573$var$decode(responseData);
    return {
        data: decodedData
    };
}
const $6d4a5578187f8573$var$name = "@firebase/functions";
const $6d4a5578187f8573$var$version = "0.8.2";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $6d4a5578187f8573$var$AUTH_INTERNAL_NAME = "auth-internal";
const $6d4a5578187f8573$var$APP_CHECK_INTERNAL_NAME = "app-check-internal";
const $6d4a5578187f8573$var$MESSAGING_INTERNAL_NAME = "messaging-internal";
function $6d4a5578187f8573$var$registerFunctions(fetchImpl, variant) {
    const factory = (container, { instanceIdentifier: regionOrCustomDomain })=>{
        // Dependencies
        const app = container.getProvider("app").getImmediate();
        const authProvider = container.getProvider($6d4a5578187f8573$var$AUTH_INTERNAL_NAME);
        const messagingProvider = container.getProvider($6d4a5578187f8573$var$MESSAGING_INTERNAL_NAME);
        const appCheckProvider = container.getProvider($6d4a5578187f8573$var$APP_CHECK_INTERNAL_NAME);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return new $6d4a5578187f8573$var$FunctionsService(app, authProvider, messagingProvider, appCheckProvider, regionOrCustomDomain, fetchImpl);
    };
    (0, $iXpG9._registerComponent)(new (0, $0128d935dde49bdd$export$16fa2f45be04daa8)($6d4a5578187f8573$var$FUNCTIONS_TYPE, factory, "PUBLIC" /* PUBLIC */ ).setMultipleInstances(true));
    (0, $iXpG9.registerVersion)($6d4a5578187f8573$var$name, $6d4a5578187f8573$var$version, variant);
    // BUILD_TARGET will be replaced by values like esm5, esm2017, cjs5, etc during the compilation
    (0, $iXpG9.registerVersion)($6d4a5578187f8573$var$name, $6d4a5578187f8573$var$version, "esm2017");
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a {@link Functions} instance for the given app.
 * @param app - The {@link @firebase/app#FirebaseApp} to use.
 * @param regionOrCustomDomain - one of:
 *   a) The region the callable functions are located in (ex: us-central1)
 *   b) A custom domain hosting the callable functions (ex: https://mydomain.com)
 * @public
 */ function $6d4a5578187f8573$export$7d4c14593b8a2193(app = (0, $iXpG9.getApp)(), regionOrCustomDomain = $6d4a5578187f8573$var$DEFAULT_REGION) {
    // Dependencies
    const functionsProvider = (0, $iXpG9._getProvider)((0, $5b5cbd208826b1f8$export$4befe9b5fa509a1b)(app), $6d4a5578187f8573$var$FUNCTIONS_TYPE);
    const functionsInstance = functionsProvider.getImmediate({
        identifier: regionOrCustomDomain
    });
    return functionsInstance;
}
/**
 * Modify this instance to communicate with the Cloud Functions emulator.
 *
 * Note: this must be called before this instance has been used to do any operations.
 *
 * @param host - The emulator host (ex: localhost)
 * @param port - The emulator port (ex: 5001)
 * @public
 */ function $6d4a5578187f8573$export$472343ee9d485d97(functionsInstance, host, port) {
    $6d4a5578187f8573$var$connectFunctionsEmulator$1((0, $5b5cbd208826b1f8$export$4befe9b5fa509a1b)(functionsInstance), host, port);
}
/**
 * Returns a reference to the callable HTTPS trigger with the given name.
 * @param name - The name of the trigger.
 * @public
 */ function $6d4a5578187f8573$export$438b58c7f2c6bf5e(functionsInstance, name, options) {
    return $6d4a5578187f8573$var$httpsCallable$1((0, $5b5cbd208826b1f8$export$4befe9b5fa509a1b)(functionsInstance), name, options);
}
/**
 * Returns a reference to the callable HTTPS trigger with the specified url.
 * @param url - The url of the trigger.
 * @public
 */ function $6d4a5578187f8573$export$486b60b301a0b194(functionsInstance, url, options) {
    return $6d4a5578187f8573$var$httpsCallableFromURL$1((0, $5b5cbd208826b1f8$export$4befe9b5fa509a1b)(functionsInstance), url, options);
}
/**
 * Cloud Functions for Firebase
 *
 * @packageDocumentation
 */ $6d4a5578187f8573$var$registerFunctions(fetch.bind(self));





var $b6HlZ = parcelRequire("b6HlZ");

var $cyuoq = parcelRequire("cyuoq");

var $j2DA4 = parcelRequire("j2DA4");

var $1BahA = parcelRequire("1BahA");
function $523273a83adbf3f3$export$2e2bcd8739ae039(dirtyDate) {
    (0, $1BahA.default)(1, arguments);
    return (0, $j2DA4.default)(dirtyDate).getTime() < Date.now();
}



var $1BahA = parcelRequire("1BahA");
function $87f6aca8dde24030$export$2e2bcd8739ae039(dirtyDate) {
    (0, $1BahA.default)(1, arguments);
    return (0, $1393872aaf394788$export$2e2bcd8739ae039)(dirtyDate, Date.now());
}







var $250c77dc0cdca177$exports = {};

var $j2DA4 = parcelRequire("j2DA4");


var $1BahA = parcelRequire("1BahA");
// for accurate equality comparisons of UTC timestamps that end up
// having the same representation in local time, e.g. one hour before
// DST ends vs. the instant that DST ends.
function $ff677780d38bed06$var$compareLocalAsc(dateLeft, dateRight) {
    var diff = dateLeft.getFullYear() - dateRight.getFullYear() || dateLeft.getMonth() - dateRight.getMonth() || dateLeft.getDate() - dateRight.getDate() || dateLeft.getHours() - dateRight.getHours() || dateLeft.getMinutes() - dateRight.getMinutes() || dateLeft.getSeconds() - dateRight.getSeconds() || dateLeft.getMilliseconds() - dateRight.getMilliseconds();
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    else return diff;
}
function $ff677780d38bed06$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $1BahA.default)(2, arguments);
    var dateLeft = (0, $j2DA4.default)(dirtyDateLeft);
    var dateRight = (0, $j2DA4.default)(dirtyDateRight);
    var sign = $ff677780d38bed06$var$compareLocalAsc(dateLeft, dateRight);
    var difference = Math.abs((0, $bc9a368e85fd9df6$export$2e2bcd8739ae039)(dateLeft, dateRight));
    dateLeft.setDate(dateLeft.getDate() - sign * difference);
    // Math.abs(diff in full days - diff in calendar days) === 1 if last calendar day is not full
    // If so, result must be decreased by 1 in absolute value
    var isLastDayNotFull = Number($ff677780d38bed06$var$compareLocalAsc(dateLeft, dateRight) === -sign);
    var result = sign * (difference - isLastDayNotFull);
    // Prevent negative zero
    return result === 0 ? 0 : result;
}


var $250c77dc0cdca177$require$differenceInDays = $ff677780d38bed06$export$2e2bcd8739ae039;
var $250c77dc0cdca177$require$format = $8a568d5cdba66624$export$2e2bcd8739ae039;
$250c77dc0cdca177$exports = {
    groupConsecutiveDates: (dates)=>{
        const groupedDates = dates.sort().reduce((acc, date)=>{
            const group = acc[acc.length - 1];
            if ($250c77dc0cdca177$require$differenceInDays(new Date(date), new Date(group[group.length - 1] || date)) > 1) acc.push([
                date
            ]);
            else group.push(date);
            return acc;
        }, [
            []
        ]);
        return groupedDates;
    },
    formatDate: (dateString)=>{
        return $250c77dc0cdca177$require$format(new Date(dateString), "yyyy-MM-dd, eeee");
    }
};


const $d908343d8ae181a5$var$ReservationInfo = ({ cart: cart, inventoryPageSnapshots: inventoryPageSnapshots, onRemove: onRemove })=>{
    const isEmptyCart = Object.keys(cart).filter((k)=>k !== "createdAt").length === 0;
    return /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsxs)("div", {
        className: "flex flex-col md:flex-row gap-8",
        children: [
            /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)("div", {
                className: "rounded-full bg-black font-bold text-2xl w-10 h-10 text-white flex items-center justify-center flex-shrink-0",
                children: "1"
            }),
            /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)("p", {
                        className: "font-bold text-2xl whitespace-nowrap mb-4",
                        children: "Reservation Info."
                    }),
                    isEmptyCart ? /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)("p", {
                        className: "mb-8",
                        children: "Your cart is empty."
                    }) : inventoryPageSnapshots.map((snapshot)=>{
                        const inventoryPage = snapshot.data();
                        const inventoryInCart = cart[snapshot.ref.id];
                        const groupedDates = (0, $250c77dc0cdca177$exports.groupConsecutiveDates)(inventoryInCart.data.dates);
                        return /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsxs)("div", {
                            className: "flex flex-col gap-3",
                            children: [
                                /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)("p", {
                                    children: inventoryPage.name
                                }),
                                /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)("p", {
                                    children: inventoryPage.address
                                }),
                                /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)("div", {
                                    className: "flex flex-col gap-1",
                                    children: groupedDates.map((dateGroup, idx)=>{
                                        const startDate = new Date(dateGroup.at(0));
                                        const isValidRange = !(0, $523273a83adbf3f3$export$2e2bcd8739ae039)(startDate) || (0, $87f6aca8dde24030$export$2e2bcd8739ae039)(startDate);
                                        return /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsxs)("div", {
                                            className: "flex gap-4 items-center",
                                            children: [
                                                /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)("span", {
                                                    className: `${isValidRange ? "bg-gray-200" : "bg-red-200"} px-2 py-1 whitespace-nowrap w-48 text-center text-sm`,
                                                    children: (0, $250c77dc0cdca177$exports.formatDate)(dateGroup.at(0))
                                                }),
                                                /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)("span", {
                                                    children: "-"
                                                }),
                                                /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)("span", {
                                                    className: `${isValidRange ? "bg-gray-200" : "bg-red-200"} px-2 py-1 whitespace-nowrap w-48 text-center text-sm`,
                                                    children: (0, $250c77dc0cdca177$exports.formatDate)(dateGroup.at(-1))
                                                })
                                            ]
                                        }, `dates-${idx}`);
                                    })
                                }),
                                inventoryInCart.discount && /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)("p", {
                                    className: "text-xs italic text-[#652cb3]",
                                    children: "Woohoo! You got a discount on this team space for using it for more than 2 days."
                                }),
                                /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsxs)("div", {
                                    className: "flex gap-4 justify-end",
                                    children: [
                                        /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)("a", {
                                            href: $d908343d8ae181a5$var$getInventoryPageUrl(inventoryPage.name),
                                            className: "self-end underline text-[#652cb3] text-sm",
                                            children: "Edit Order"
                                        }),
                                        /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)("button", {
                                            type: "button",
                                            onClick: ()=>onRemove(snapshot.ref.id),
                                            className: "self-end underline text-red-500 text-sm",
                                            children: "Remove"
                                        })
                                    ]
                                })
                            ]
                        }, `reservation-${snapshot.ref.id}`);
                    })
                ]
            })
        ]
    });
};
const $d908343d8ae181a5$var$getInventoryPageUrl = (inventoryPageName)=>{
    const slug = (0, $12f14e722131d005$exports.Utils).slugifyName(inventoryPageName);
    return `${"https://www.flexday.com"}/suite/${slug}`;
};
var $d908343d8ae181a5$export$2e2bcd8739ae039 = $d908343d8ae181a5$var$ReservationInfo;




const $8de9b6d6695a1edd$var$Input = ({ name: name, required: required, register: register, className: className, placeholder: placeholder, type: type = "text", ...rest })=>/*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)("input", {
        name: name,
        type: type,
        required: required,
        placeholder: placeholder,
        ...register && name ? {
            ...register(name)
        } : {},
        className: `w-64 h-11 px-4 py-2.5 border border-gray-400 bg-white rounded-full font-medium focus:outline-none placeholder:text-gray-400  ${className}`,
        ...rest
    });
var $8de9b6d6695a1edd$export$2e2bcd8739ae039 = $8de9b6d6695a1edd$var$Input;


const $aa49ba5d1bf201c5$var$AccountInfo = ({ auth: auth, register: register })=>{
    const logout = async ()=>{
        await auth.signOut();
        window.location.reload();
    };
    return /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsxs)("div", {
        className: "flex flex-col md:flex-row gap-8",
        children: [
            /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)("div", {
                className: "rounded-full bg-black font-bold text-2xl w-10 h-10 text-white flex items-center justify-center flex-shrink-0",
                children: "2"
            }),
            /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsxs)("div", {
                className: "flex flex-col gap-4",
                children: [
                    /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)("p", {
                        className: "font-bold text-2xl whitespace-nowrap",
                        children: "Account Info."
                    }),
                    /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsxs)("div", {
                        className: "flex items-center gap-2",
                        children: [
                            /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)("p", {
                                className: "w-32",
                                children: "Full Name"
                            }),
                            /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)((0, $8de9b6d6695a1edd$export$2e2bcd8739ae039), {
                                name: "name",
                                type: "string",
                                placeholder: "Full Name",
                                disabled: !!auth.currentUser,
                                register: register,
                                required: true
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsxs)("div", {
                        className: "flex items-center gap-2",
                        children: [
                            /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)("p", {
                                className: "w-32",
                                children: "Email"
                            }),
                            /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)((0, $8de9b6d6695a1edd$export$2e2bcd8739ae039), {
                                name: "email",
                                type: "string",
                                placeholder: "Email",
                                disabled: !!auth.currentUser,
                                register: register,
                                required: true
                            })
                        ]
                    }),
                    auth.currentUser ? /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsxs)("p", {
                        className: "text-slate-500",
                        children: [
                            "Not ",
                            auth.currentUser.displayName,
                            "?",
                            " ",
                            /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)("span", {
                                className: "underline cursor-pointer text-[#652cb3]",
                                onClick: logout,
                                children: "Log out"
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsxs)((0, $94829a8b99aa12e4$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsxs)("p", {
                                className: "text-slate-500",
                                children: [
                                    "Already have an account?",
                                    " ",
                                    /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)("a", {
                                        href: `${"https://www.flexday.com"}/login?redirectUrl=${"https://www.flexday.com"}/cart`,
                                        className: "underline text-[#652cb3]",
                                        children: "Log in"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsxs)("p", {
                                className: "text-xs bg-purple-200 italic w-fit self-center p-2 max-w-3xl",
                                children: [
                                    /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)("span", {
                                        className: "font-bold",
                                        children: "NOTE:"
                                    }),
                                    " You need to have a Flexday Account to submit your order. Enter your full name and email above, and proceed to Summary to review and submit your order. Your Flexday Account will automatically be created with your submitted order, and an email link will be sent for you to reconfirm your Flexday Account."
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $aa49ba5d1bf201c5$export$2e2bcd8739ae039 = $aa49ba5d1bf201c5$var$AccountInfo;






parcelRequire("8vofH");
var $7TObl = parcelRequire("7TObl");

var $b6HlZ = parcelRequire("b6HlZ");



const $3d99c5d30e5e4d79$var$PromoCodeForm = ({ firestore: firestore, promoCode: promoCode, setPromoCode: setPromoCode, orderCurrency: orderCurrency, promoCodeDiscount: promoCodeDiscount })=>{
    const [code, setCode] = (0, $b6HlZ.useState)("");
    const [appliedPromoCode, setAppliedPromoCode] = (0, $b6HlZ.useState)("");
    const [invalidPromocode, setInvalidPromocode] = (0, $b6HlZ.useState)(false);
    const applyPromoCode = async (e)=>{
        e.preventDefault();
        const sanitizedCode = code.toUpperCase();
        const snapshot = await (0, $7TObl.getDoc)((0, $7TObl.doc)(firestore, "coupons", sanitizedCode));
        if (snapshot.exists()) {
            setInvalidPromocode(false);
            setPromoCode(snapshot.data());
            setAppliedPromoCode(sanitizedCode);
            setCode("");
        } else {
            setInvalidPromocode(true);
            setPromoCode(undefined);
        }
    };
    return /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsxs)("div", {
        className: "flex flex-col gap-2",
        children: [
            promoCode && /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsxs)("div", {
                className: "flex justify-between",
                children: [
                    /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsxs)("p", {
                        children: [
                            appliedPromoCode,
                            " -",
                            " ",
                            /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)("span", {
                                className: "italic",
                                children: promoCode.description
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)("p", {
                        children: (0, $3468f4655cb34353$exports.formatCurrency)(promoCodeDiscount, orderCurrency)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsxs)("div", {
                className: "flex flex-col gap-2",
                children: [
                    /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsxs)("div", {
                        className: "flex gap-4",
                        children: [
                            /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)("div", {
                                className: "relative",
                                children: /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)((0, $8de9b6d6695a1edd$export$2e2bcd8739ae039), {
                                    name: "code",
                                    type: "string",
                                    className: "w-full",
                                    placeholder: "Promo Code",
                                    value: code,
                                    onChange: (e)=>setCode(e.target.value)
                                })
                            }),
                            /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)("div", {
                                className: "flex flex-col justify-center gap-2 w-48",
                                children: /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)((0, $b10e2d2452b40b3d$export$2e2bcd8739ae039), {
                                    disabled: !code,
                                    title: "Apply",
                                    onClick: applyPromoCode
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)("div", {
                        children: invalidPromocode && /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)("p", {
                            className: "text-red-400",
                            children: "Invalid promo code"
                        })
                    })
                ]
            })
        ]
    });
};
var $3d99c5d30e5e4d79$export$2e2bcd8739ae039 = $3d99c5d30e5e4d79$var$PromoCodeForm;


const $fd6fc967d0ef6dd1$var$OrderSummary = ({ cart: cart, inventoryPageSnapshots: inventoryPageSnapshots, firestore: firestore, promoCode: promoCode, setPromoCode: setPromoCode, orderCurrency: orderCurrency, orderDiscount: orderDiscount, cartTotal: cartTotal })=>{
    const lineItemDiscounts = Object.values(cart || {}).map((_)=>_.discount).filter((_)=>_);
    const isEmptyCart = Object.keys(cart).filter((k)=>k !== "createdAt").length === 0;
    return /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsxs)((0, $94829a8b99aa12e4$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)("p", {
                className: "font-bold text-2xl whitespace-nowrap",
                children: "Summary:"
            }),
            /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)("div", {
                className: "flex flex-col gap-8",
                children: inventoryPageSnapshots.map((snapshot)=>{
                    const inventoryPage = snapshot.data();
                    const inventoryInCart = cart[snapshot.ref.id];
                    const quantity = inventoryInCart.quantity;
                    const { amountInCents: amountInCents } = inventoryPage.prices.onDemand[orderCurrency.toLowerCase()];
                    const discount = inventoryInCart.discount && inventoryPage.discount ? inventoryPage.discount : 0;
                    const discountInCents = discount * amountInCents * quantity;
                    return /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsxs)("div", {
                        className: "flex flex-col gap-2",
                        children: [
                            /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)("p", {
                                children: inventoryPage.name
                            }),
                            /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)((0, $77e4b6b5b316a4cb$export$2e2bcd8739ae039), {
                                label: `${(0, $3468f4655cb34353$exports.formatCurrency)(amountInCents, orderCurrency)} \xd7 ${quantity} day${quantity > 1 ? "s" : ""}`,
                                value: `${amountInCents * quantity}`,
                                currency: orderCurrency
                            }),
                            discountInCents > 0 && /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)((0, $77e4b6b5b316a4cb$export$2e2bcd8739ae039), {
                                label: `Discount (${(0, $3468f4655cb34353$exports.formatDiscount)(inventoryPage.discount)})`,
                                value: `${discountInCents}`,
                                currency: orderCurrency
                            })
                        ]
                    }, snapshot.ref.id);
                })
            }),
            isEmptyCart || lineItemDiscounts.length > 0 ? null : /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)("div", {
                className: "mt-6",
                children: /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)((0, $3d99c5d30e5e4d79$export$2e2bcd8739ae039), {
                    firestore: firestore,
                    promoCode: promoCode,
                    setPromoCode: setPromoCode,
                    orderCurrency: orderCurrency,
                    promoCodeDiscount: orderDiscount
                })
            }),
            !isEmptyCart && /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)("div", {
                className: "h-[1px] w-full bg-gray-300"
            }),
            /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)((0, $77e4b6b5b316a4cb$export$2e2bcd8739ae039), {
                label: "Total *",
                boldLabel: true,
                value: cartTotal,
                currency: orderCurrency
            })
        ]
    });
};
var $fd6fc967d0ef6dd1$export$2e2bcd8739ae039 = $fd6fc967d0ef6dd1$var$OrderSummary;




const $2542c92c1839082d$var$CartPreview = ({ currency: currency })=>{
    var _auth_currentUser, _auth_currentUser1;
    const { getFirebaseConfig: getFirebaseConfig } = (0, $a5a6fab2525fdce6$exports.Helpers);
    const firebaseConfig = getFirebaseConfig({
        REACT_APP_FIREBASE_API_KEY: "AIzaSyBoIeHTyO2Zr6jARvqrWPPAlqi3pdu2-KA",
        REACT_APP_FIREBASE_APP_ID: "1:717114758534:web:c0f5a5118efc5855164807",
        REACT_APP_FIREBASE_MESSAGE_SENDER_ID: "717114758534",
        REACT_APP_FIREBASE_PROJECT_ID: "flexday-6dacf"
    });
    const app = (0, $iXpG9.initializeApp)(firebaseConfig);
    const firestore = (0, $7TObl.getFirestore)(app);
    const auth = (0, $clAv2.n)(app);
    const [loading, setLoading] = (0, $b6HlZ.useState)(true);
    const [isSubmittingForm, setIsSubmittingForm] = (0, $b6HlZ.useState)(false);
    const [cart, setCart] = (0, $b6HlZ.useState)({});
    const [inventoryPageSnapshots, setInventoryPageSnapshots] = (0, $b6HlZ.useState)([]);
    const cartId = window.localStorage.getItem("cartId");
    const [promoCode, setPromoCode] = (0, $b6HlZ.useState)();
    const cartTotalBeforeDiscount = inventoryPageSnapshots.reduce((sum, snapshot)=>{
        const inventoryPage = snapshot.data();
        const inventoryInCart = cart[snapshot.ref.id];
        const quantity = inventoryInCart.quantity;
        const { amountInCents: amountInCents } = inventoryPage.prices.onDemand[currency.toLowerCase()];
        const price = amountInCents * quantity;
        const discount = inventoryInCart.discount && inventoryPage.discount ? inventoryPage.discount : 0;
        const totalPrice = price - discount * price;
        return sum + totalPrice;
    }, 0);
    const orderDiscount = (promoCode === null || promoCode === void 0 ? void 0 : promoCode.unit) === "percentage" ? promoCode.amount * cartTotalBeforeDiscount : 0;
    const cartTotal = cartTotalBeforeDiscount - orderDiscount;
    // Order summary states
    const [showLoggedOutError, setShowLoggedOutError] = (0, $b6HlZ.useState)(false);
    var _auth_currentUser_email, _auth_currentUser_displayName;
    const { register: register, handleSubmit: handleSubmit, reset: reset, formState: { isSubmitting: isSubmitting } } = (0, $cyuoq.useForm)({
        defaultValues: {
            email: (_auth_currentUser_email = (_auth_currentUser = auth.currentUser) === null || _auth_currentUser === void 0 ? void 0 : _auth_currentUser.email) !== null && _auth_currentUser_email !== void 0 ? _auth_currentUser_email : "",
            name: (_auth_currentUser_displayName = (_auth_currentUser1 = auth.currentUser) === null || _auth_currentUser1 === void 0 ? void 0 : _auth_currentUser1.displayName) !== null && _auth_currentUser_displayName !== void 0 ? _auth_currentUser_displayName : ""
        }
    });
    const cartAnalyticsEvent = (cart, inventoryPageSnapshots)=>{
        if (inventoryPageSnapshots.length < 1) return {};
        const inventoryPage = inventoryPageSnapshots[0].data();
        const { name: name, images: images, address: address, inventory: { id: inventoryId } } = inventoryPage;
        const { amountInCents: amountInCents } = inventoryPage.prices.onDemand[currency.toLowerCase()];
        const inventoryPageId = inventoryPageSnapshots[0].id;
        const { data: data, quantity: quantity } = cart[inventoryPageId];
        const slug = (0, $12f14e722131d005$exports.Utils).slugifyName(name);
        const url = `${"https://www.flexday.com"}/suite/${slug}`;
        const inventoriesCount = Object.keys(cart).filter((key)=>key !== "createdAt").length;
        const additionalNote = inventoriesCount > 2 ? `Plus, ${inventoriesCount - 1} more workspaces...` : inventoriesCount === 2 ? `Plus, 1 more workspace...` : "";
        return {
            "Inventory Name": name,
            "Inventory Address": address,
            "Inventory Image": `https://us-central1-flexday-6dacf.cloudfunctions.net/inventory-getImage?inventoryId=${inventoryId}`,
            "Inventory Url": url,
            "Selected Dates": data.dates.sort().join(", "),
            "Inventory Price": (0, $3468f4655cb34353$exports.formatCurrency)(amountInCents, currency),
            "Inventory Quantity": quantity,
            "Inventory Subtotal": (0, $3468f4655cb34353$exports.formatCurrency)(amountInCents * quantity, currency),
            "Cart Total": (0, $3468f4655cb34353$exports.formatCurrency)(cartTotal, currency),
            "Additional Inventory Note": additionalNote,
            "Request Date": (0, $12f14e722131d005$exports.Utils).getRequestDate()
        };
    };
    (0, $b6HlZ.useEffect)(()=>{
        var _auth_currentUser, _auth_currentUser1;
        var _auth_currentUser_email, _auth_currentUser_displayName;
        reset({
            email: (_auth_currentUser_email = (_auth_currentUser = auth.currentUser) === null || _auth_currentUser === void 0 ? void 0 : _auth_currentUser.email) !== null && _auth_currentUser_email !== void 0 ? _auth_currentUser_email : "",
            name: (_auth_currentUser_displayName = (_auth_currentUser1 = auth.currentUser) === null || _auth_currentUser1 === void 0 ? void 0 : _auth_currentUser1.displayName) !== null && _auth_currentUser_displayName !== void 0 ? _auth_currentUser_displayName : ""
        });
    }, [
        auth.currentUser
    ]);
    (0, $b6HlZ.useEffect)(()=>{
        async function getCart() {
            // Fetch cart from Firestore
            const snapshot = await (0, $7TObl.getDoc)((0, $7TObl.doc)(firestore, "carts", cartId));
            const cart = snapshot.data() || {};
            setCart(cart);
            const inventoryPageIds = Object.keys(cart || {}).filter((_)=>_ !== "createdAt");
            // Fetch inventory pages from Firestore
            const inventoryPageSnapshots = await Promise.all(inventoryPageIds.map((inventoryPageId)=>(0, $7TObl.getDoc)((0, $7TObl.doc)(firestore, "inventoryPages", inventoryPageId))));
            setInventoryPageSnapshots(inventoryPageSnapshots);
            await (0, $d77b1014b2d60259$exports.trackEvent)("User Viewed Cart v1", cartAnalyticsEvent(cart, inventoryPageSnapshots));
            setLoading(false);
        }
        if (cartId) getCart();
        else setLoading(false);
    }, [
        cartId,
        firestore
    ]);
    const onRemove = async (inventoryPageId)=>{
        await (0, $7TObl.updateDoc)((0, $7TObl.doc)(firestore, "carts", cartId), {
            [inventoryPageId]: (0, $7TObl.deleteField)()
        });
        const snapshot = await (0, $7TObl.getDoc)((0, $7TObl.doc)(firestore, "carts", cartId));
        setInventoryPageSnapshots((inventoryPageSnapshots)=>inventoryPageSnapshots.filter((_)=>_.ref.id !== inventoryPageId));
        setCart(snapshot.data());
    };
    const itemsInCart = Object.keys(cart || {}).filter((_)=>_ !== "createdAt");
    if (cart && itemsInCart.length > 0 && !inventoryPageSnapshots || loading) return /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)("p", {
        children: "Loading..."
    });
    const submitOrder = async ({ name: name, email: email })=>{
        setIsSubmittingForm(true);
        await (0, $d77b1014b2d60259$exports.update)({
            name: name,
            email: email
        });
        setTimeout(()=>{
            (0, $d77b1014b2d60259$exports.trackEvent)("User Tapped Cart CTA v1", cartAnalyticsEvent(cart, inventoryPageSnapshots));
        }, 300);
        // Check for past dates in order
        for (const snapshot of inventoryPageSnapshots){
            const inventoryInCart = cart[snapshot.ref.id];
            const sortedDates = inventoryInCart.data.dates.sort();
            const firstDate = new Date(sortedDates.at(0));
            if ((0, $523273a83adbf3f3$export$2e2bcd8739ae039)(firstDate) && !(0, $87f6aca8dde24030$export$2e2bcd8739ae039)(firstDate)) {
                window.alert("It looks like your order contains bookings from the past. Please remove them from your order and re-submit.");
                setIsSubmittingForm(false);
                return;
            }
        }
        const functions = (0, $6d4a5578187f8573$export$7d4c14593b8a2193)();
        const submitOrder = (0, $6d4a5578187f8573$export$438b58c7f2c6bf5e)(functions, "submitOrder-submitOrder");
        try {
            setShowLoggedOutError(false);
            const result = await submitOrder({
                data: {
                    cartId: cartId,
                    email: email,
                    name: name,
                    couponId: promoCode === null || promoCode === void 0 ? void 0 : promoCode.couponId,
                    isLoggedIn: !!auth.currentUser,
                    currency: currency.toLowerCase()
                }
            });
            const invoiceUrl = result.data;
            setIsSubmittingForm(false);
            window.location.href = invoiceUrl;
        } catch (error) {
            if (error.code === "functions/unauthenticated") {
                setShowLoggedOutError(true);
                return;
            }
            window.alert("Your order failed to process. You have not been charged. Please try again later.");
        } finally{
            setIsSubmittingForm(false);
        }
    };
    return /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)("div", {
        className: "",
        children: /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsxs)("form", {
            onSubmit: handleSubmit(submitOrder),
            className: "flex flex-col md:flex-row gap-4",
            children: [
                /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsxs)("div", {
                    className: "flex flex-col gap-8 md:gap-4 pb-8 border-b md:border-b-0 md:border-r md:pr-8 border-slate-200",
                    children: [
                        /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)((0, $d908343d8ae181a5$export$2e2bcd8739ae039), {
                            cart: cart,
                            inventoryPageSnapshots: inventoryPageSnapshots,
                            onRemove: onRemove
                        }),
                        /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)((0, $aa49ba5d1bf201c5$export$2e2bcd8739ae039), {
                            auth: auth,
                            register: register
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsxs)("div", {
                    className: "pt-4 flex flex-col gap-4",
                    children: [
                        /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)((0, $fd6fc967d0ef6dd1$export$2e2bcd8739ae039), {
                            cart: cart,
                            inventoryPageSnapshots: inventoryPageSnapshots,
                            firestore: firestore,
                            promoCode: promoCode,
                            setPromoCode: setPromoCode,
                            orderCurrency: currency,
                            orderDiscount: orderDiscount,
                            cartTotal: cartTotal
                        }),
                        /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)((0, $b10e2d2452b40b3d$export$2e2bcd8739ae039), {
                            disabled: itemsInCart.length === 0,
                            title: "Submit Order",
                            className: "!w-44 px-10 !bg-[#652cb3] self-center rounded-lg hover:opacity-75 transition-opacity",
                            loading: isSubmittingForm || isSubmitting
                        }),
                        showLoggedOutError && /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)("p", {
                            className: "text-sm text-red-500 self-center",
                            children: "It looks like there's already an account associated to this email. Please log in to place your order."
                        }),
                        /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsxs)("div", {
                            className: "text-xs text-slate-500 italic text-center",
                            children: [
                                /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)("p", {
                                    children: "* Taxes will be applied at checkout."
                                }),
                                /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)("p", {
                                    children: "Please review your reservation summary carefully."
                                }),
                                /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)("p", {
                                    children: "A Stripe receipt and personalized order confirmation from our Convierge Team will be sent to your email address on record."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsxs)("div", {
                            className: "flex flex-col gap-6 mt-4",
                            children: [
                                /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)("p", {
                                    className: "font-bold",
                                    children: "Thank you for using Flexday."
                                }),
                                /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsxs)("p", {
                                    children: [
                                        /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)("span", {
                                            className: "font-bold",
                                            children: "Reschedule / Cancellation Policy:"
                                        }),
                                        " ",
                                        "Please provide 10 business days' notice if you need to reschedule or cancel your reservation. Flexday will always do our best to accommodate."
                                    ]
                                }),
                                /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsxs)("p", {
                                    children: [
                                        /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)("span", {
                                            className: "font-bold",
                                            children: "Payment Terms:"
                                        }),
                                        " For all reservations totalling less than 3 months' room use, Flexday requires full payment upfront. For bookings that are longer, payment can be separated into 3-month installments."
                                    ]
                                }),
                                /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsxs)("p", {
                                    children: [
                                        "Email",
                                        " ",
                                        /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)("a", {
                                            href: "mailto:concierge@flexday.com",
                                            className: "text-[#652cb3]",
                                            children: "concierge@flexday.com"
                                        }),
                                        " ",
                                        "for any of these requests."
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
var $2542c92c1839082d$export$2e2bcd8739ae039 = $2542c92c1839082d$var$CartPreview;




var $b6HlZ = parcelRequire("b6HlZ");
parcelRequire("ehmfL");
var $clAv2 = parcelRequire("clAv2");

var $cyuoq = parcelRequire("cyuoq");

var $iXpG9 = parcelRequire("iXpG9");

var $iXpG9 = parcelRequire("iXpG9");
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Firebase constants.  Some of these (@defines) can be overridden at compile-time.
 */ const $f43ebbd33d4c5d93$export$588c7fdda06fbb0a = {
    /**
     * @define {boolean} Whether this is the client Node.js SDK.
     */ NODE_CLIENT: false,
    /**
     * @define {boolean} Whether this is the Admin Node.js SDK.
     */ NODE_ADMIN: false,
    /**
     * Firebase SDK Version
     */ SDK_VERSION: "${JSCORE_VERSION}"
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Throws an error if the provided assertion is falsy
 */ const $f43ebbd33d4c5d93$export$a7a9523472993e97 = function(assertion, message) {
    if (!assertion) throw $f43ebbd33d4c5d93$export$a39cad550e7ab28a(message);
};
/**
 * Returns an Error object suitable for throwing.
 */ const $f43ebbd33d4c5d93$export$a39cad550e7ab28a = function(message) {
    return new Error("Firebase Database (" + $f43ebbd33d4c5d93$export$588c7fdda06fbb0a.SDK_VERSION + ") INTERNAL ASSERT FAILED: " + message);
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $f43ebbd33d4c5d93$var$stringToByteArray$1 = function(str) {
    // TODO(user): Use native implementations if/when available
    const out = [];
    let p = 0;
    for(let i = 0; i < str.length; i++){
        let c = str.charCodeAt(i);
        if (c < 128) out[p++] = c;
        else if (c < 2048) {
            out[p++] = c >> 6 | 192;
            out[p++] = c & 63 | 128;
        } else if ((c & 0xfc00) === 0xd800 && i + 1 < str.length && (str.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
            // Surrogate Pair
            c = 0x10000 + ((c & 0x03ff) << 10) + (str.charCodeAt(++i) & 0x03ff);
            out[p++] = c >> 18 | 240;
            out[p++] = c >> 12 & 63 | 128;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        } else {
            out[p++] = c >> 12 | 224;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        }
    }
    return out;
};
/**
 * Turns an array of numbers into the string given by the concatenation of the
 * characters to which the numbers correspond.
 * @param bytes Array of numbers representing characters.
 * @return Stringification of the array.
 */ const $f43ebbd33d4c5d93$var$byteArrayToString = function(bytes) {
    // TODO(user): Use native implementations if/when available
    const out = [];
    let pos = 0, c = 0;
    while(pos < bytes.length){
        const c1 = bytes[pos++];
        if (c1 < 128) out[c++] = String.fromCharCode(c1);
        else if (c1 > 191 && c1 < 224) {
            const c2 = bytes[pos++];
            out[c++] = String.fromCharCode((c1 & 31) << 6 | c2 & 63);
        } else if (c1 > 239 && c1 < 365) {
            // Surrogate Pair
            const c2 = bytes[pos++];
            const c3 = bytes[pos++];
            const c4 = bytes[pos++];
            const u = ((c1 & 7) << 18 | (c2 & 63) << 12 | (c3 & 63) << 6 | c4 & 63) - 0x10000;
            out[c++] = String.fromCharCode(0xd800 + (u >> 10));
            out[c++] = String.fromCharCode(0xdc00 + (u & 1023));
        } else {
            const c2 = bytes[pos++];
            const c3 = bytes[pos++];
            out[c++] = String.fromCharCode((c1 & 15) << 12 | (c2 & 63) << 6 | c3 & 63);
        }
    }
    return out.join("");
};
// We define it as an object literal instead of a class because a class compiled down to es5 can't
// be treeshaked. https://github.com/rollup/rollup/issues/1691
// Static lookup maps, lazily populated by init_()
const $f43ebbd33d4c5d93$export$b3b2de96497acc47 = {
    /**
     * Maps bytes to characters.
     */ byteToCharMap_: null,
    /**
     * Maps characters to bytes.
     */ charToByteMap_: null,
    /**
     * Maps bytes to websafe characters.
     * @private
     */ byteToCharMapWebSafe_: null,
    /**
     * Maps websafe characters to bytes.
     * @private
     */ charToByteMapWebSafe_: null,
    /**
     * Our default alphabet, shared between
     * ENCODED_VALS and ENCODED_VALS_WEBSAFE
     */ ENCODED_VALS_BASE: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789",
    /**
     * Our default alphabet. Value 64 (=) is special; it means "nothing."
     */ get ENCODED_VALS () {
        return this.ENCODED_VALS_BASE + "+/=";
    },
    /**
     * Our websafe alphabet.
     */ get ENCODED_VALS_WEBSAFE () {
        return this.ENCODED_VALS_BASE + "-_.";
    },
    /**
     * Whether this browser supports the atob and btoa functions. This extension
     * started at Mozilla but is now implemented by many browsers. We use the
     * ASSUME_* variables to avoid pulling in the full useragent detection library
     * but still allowing the standard per-browser compilations.
     *
     */ HAS_NATIVE_SUPPORT: typeof atob === "function",
    /**
     * Base64-encode an array of bytes.
     *
     * @param input An array of bytes (numbers with
     *     value in [0, 255]) to encode.
     * @param webSafe Boolean indicating we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */ encodeByteArray (input, webSafe) {
        if (!Array.isArray(input)) throw Error("encodeByteArray takes an array as a parameter");
        this.init_();
        const byteToCharMap = webSafe ? this.byteToCharMapWebSafe_ : this.byteToCharMap_;
        const output = [];
        for(let i = 0; i < input.length; i += 3){
            const byte1 = input[i];
            const haveByte2 = i + 1 < input.length;
            const byte2 = haveByte2 ? input[i + 1] : 0;
            const haveByte3 = i + 2 < input.length;
            const byte3 = haveByte3 ? input[i + 2] : 0;
            const outByte1 = byte1 >> 2;
            const outByte2 = (byte1 & 0x03) << 4 | byte2 >> 4;
            let outByte3 = (byte2 & 0x0f) << 2 | byte3 >> 6;
            let outByte4 = byte3 & 0x3f;
            if (!haveByte3) {
                outByte4 = 64;
                if (!haveByte2) outByte3 = 64;
            }
            output.push(byteToCharMap[outByte1], byteToCharMap[outByte2], byteToCharMap[outByte3], byteToCharMap[outByte4]);
        }
        return output.join("");
    },
    /**
     * Base64-encode a string.
     *
     * @param input A string to encode.
     * @param webSafe If true, we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */ encodeString (input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) return btoa(input);
        return this.encodeByteArray($f43ebbd33d4c5d93$var$stringToByteArray$1(input), webSafe);
    },
    /**
     * Base64-decode a string.
     *
     * @param input to decode.
     * @param webSafe True if we should use the
     *     alternative alphabet.
     * @return string representing the decoded value.
     */ decodeString (input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) return atob(input);
        return $f43ebbd33d4c5d93$var$byteArrayToString(this.decodeStringToByteArray(input, webSafe));
    },
    /**
     * Base64-decode a string.
     *
     * In base-64 decoding, groups of four characters are converted into three
     * bytes.  If the encoder did not apply padding, the input length may not
     * be a multiple of 4.
     *
     * In this case, the last group will have fewer than 4 characters, and
     * padding will be inferred.  If the group has one or two characters, it decodes
     * to one byte.  If the group has three characters, it decodes to two bytes.
     *
     * @param input Input to decode.
     * @param webSafe True if we should use the web-safe alphabet.
     * @return bytes representing the decoded value.
     */ decodeStringToByteArray (input, webSafe) {
        this.init_();
        const charToByteMap = webSafe ? this.charToByteMapWebSafe_ : this.charToByteMap_;
        const output = [];
        for(let i = 0; i < input.length;){
            const byte1 = charToByteMap[input.charAt(i++)];
            const haveByte2 = i < input.length;
            const byte2 = haveByte2 ? charToByteMap[input.charAt(i)] : 0;
            ++i;
            const haveByte3 = i < input.length;
            const byte3 = haveByte3 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            const haveByte4 = i < input.length;
            const byte4 = haveByte4 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            if (byte1 == null || byte2 == null || byte3 == null || byte4 == null) throw Error();
            const outByte1 = byte1 << 2 | byte2 >> 4;
            output.push(outByte1);
            if (byte3 !== 64) {
                const outByte2 = byte2 << 4 & 0xf0 | byte3 >> 2;
                output.push(outByte2);
                if (byte4 !== 64) {
                    const outByte3 = byte3 << 6 & 0xc0 | byte4;
                    output.push(outByte3);
                }
            }
        }
        return output;
    },
    /**
     * Lazy static initialization function. Called before
     * accessing any of the static map variables.
     * @private
     */ init_ () {
        if (!this.byteToCharMap_) {
            this.byteToCharMap_ = {};
            this.charToByteMap_ = {};
            this.byteToCharMapWebSafe_ = {};
            this.charToByteMapWebSafe_ = {};
            // We want quick mappings back and forth, so we precompute two maps.
            for(let i = 0; i < this.ENCODED_VALS.length; i++){
                this.byteToCharMap_[i] = this.ENCODED_VALS.charAt(i);
                this.charToByteMap_[this.byteToCharMap_[i]] = i;
                this.byteToCharMapWebSafe_[i] = this.ENCODED_VALS_WEBSAFE.charAt(i);
                this.charToByteMapWebSafe_[this.byteToCharMapWebSafe_[i]] = i;
                // Be forgiving when decoding and correctly decode both encodings.
                if (i >= this.ENCODED_VALS_BASE.length) {
                    this.charToByteMap_[this.ENCODED_VALS_WEBSAFE.charAt(i)] = i;
                    this.charToByteMapWebSafe_[this.ENCODED_VALS.charAt(i)] = i;
                }
            }
        }
    }
};
/**
 * URL-safe base64 encoding
 */ const $f43ebbd33d4c5d93$export$e510a73ee562749 = function(str) {
    const utf8Bytes = $f43ebbd33d4c5d93$var$stringToByteArray$1(str);
    return $f43ebbd33d4c5d93$export$b3b2de96497acc47.encodeByteArray(utf8Bytes, true);
};
/**
 * URL-safe base64 encoding (without "." padding in the end).
 * e.g. Used in JSON Web Token (JWT) parts.
 */ const $f43ebbd33d4c5d93$export$4b5284a3025a455 = function(str) {
    // Use base64url encoding and remove padding in the end (dot characters).
    return $f43ebbd33d4c5d93$export$e510a73ee562749(str).replace(/\./g, "");
};
/**
 * URL-safe base64 decoding
 *
 * NOTE: DO NOT use the global atob() function - it does NOT support the
 * base64Url variant encoding.
 *
 * @param str To be decoded
 * @return Decoded result, if possible
 */ const $f43ebbd33d4c5d93$export$c62426fdd000a97e = function(str) {
    try {
        return $f43ebbd33d4c5d93$export$b3b2de96497acc47.decodeString(str, true);
    } catch (e) {
        console.error("base64Decode failed: ", e);
    }
    return null;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Do a deep-copy of basic JavaScript Objects or Arrays.
 */ function $f43ebbd33d4c5d93$export$6c40052bed430212(value) {
    return $f43ebbd33d4c5d93$export$54e9fb29908872fa(undefined, value);
}
/**
 * Copy properties from source to target (recursively allows extension
 * of Objects and Arrays).  Scalar values in the target are over-written.
 * If target is undefined, an object of the appropriate type will be created
 * (and returned).
 *
 * We recursively copy all child properties of plain Objects in the source- so
 * that namespace- like dictionaries are merged.
 *
 * Note that the target can be a function, in which case the properties in
 * the source Object are copied onto it as static properties of the Function.
 *
 * Note: we don't merge __proto__ to prevent prototype pollution
 */ function $f43ebbd33d4c5d93$export$54e9fb29908872fa(target, source) {
    if (!(source instanceof Object)) return source;
    switch(source.constructor){
        case Date:
            // Treat Dates like scalars; if the target date object had any child
            // properties - they will be lost!
            const dateValue = source;
            return new Date(dateValue.getTime());
        case Object:
            if (target === undefined) target = {};
            break;
        case Array:
            // Always copy the array source and overwrite the target.
            target = [];
            break;
        default:
            // Not a plain Object - treat it as a scalar.
            return source;
    }
    for(const prop in source){
        // use isValidKey to guard against prototype pollution. See https://snyk.io/vuln/SNYK-JS-LODASH-450202
        if (!source.hasOwnProperty(prop) || !$f43ebbd33d4c5d93$var$isValidKey(prop)) continue;
        target[prop] = $f43ebbd33d4c5d93$export$54e9fb29908872fa(target[prop], source[prop]);
    }
    return target;
}
function $f43ebbd33d4c5d93$var$isValidKey(key) {
    return key !== "__proto__";
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $f43ebbd33d4c5d93$export$85f6557964517f1a {
    /**
     * Our API internals are not promiseified and cannot because our callback APIs have subtle expectations around
     * invoking promises inline, which Promises are forbidden to do. This method accepts an optional node-style callback
     * and returns a node-style callback which will resolve or reject the Deferred's promise.
     */ wrapCallback(callback) {
        return (error, value)=>{
            if (error) this.reject(error);
            else this.resolve(value);
            if (typeof callback === "function") {
                // Attaching noop handler just in case developer wasn't expecting
                // promises
                this.promise.catch(()=>{});
                // Some of our callbacks don't expect a value and our own tests
                // assert that the parameter length is 1
                if (callback.length === 1) callback(error);
                else callback(error, value);
            }
        };
    }
    constructor(){
        this.reject = ()=>{};
        this.resolve = ()=>{};
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
    }
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $f43ebbd33d4c5d93$export$367bf224123348f1(token, projectId) {
    if (token.uid) throw new Error('The "uid" field is no longer supported by mockUserToken. Please use "sub" instead for Firebase Auth User ID.');
    // Unsecured JWTs use "none" as the algorithm.
    const header = {
        alg: "none",
        type: "JWT"
    };
    const project = projectId || "demo-project";
    const iat = token.iat || 0;
    const sub = token.sub || token.user_id;
    if (!sub) throw new Error("mockUserToken must contain 'sub' or 'user_id' field!");
    const payload = Object.assign({
        // Set all required fields to decent defaults
        iss: `https://securetoken.google.com/${project}`,
        aud: project,
        iat: iat,
        exp: iat + 3600,
        auth_time: iat,
        sub: sub,
        user_id: sub,
        firebase: {
            sign_in_provider: "custom",
            identities: {}
        }
    }, token);
    // Unsecured JWTs use the empty string as a signature.
    const signature = "";
    return [
        $f43ebbd33d4c5d93$export$4b5284a3025a455(JSON.stringify(header)),
        $f43ebbd33d4c5d93$export$4b5284a3025a455(JSON.stringify(payload)),
        signature
    ].join(".");
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns navigator.userAgent string or '' if it's not defined.
 * @return user agent string
 */ function $f43ebbd33d4c5d93$export$c36915b22ce77c19() {
    if (typeof navigator !== "undefined" && typeof navigator["userAgent"] === "string") return navigator["userAgent"];
    else return "";
}
/**
 * Detect Cordova / PhoneGap / Ionic frameworks on a mobile device.
 *
 * Deliberately does not rely on checking `file://` URLs (as this fails PhoneGap
 * in the Ripple emulator) nor Cordova `onDeviceReady`, which would normally
 * wait for a callback.
 */ function $f43ebbd33d4c5d93$export$872f8323f01d7ae0() {
    return typeof window !== "undefined" && // @ts-ignore Setting up an broadly applicable index signature for Window
    // just to deal with this case would probably be a bad idea.
    !!(window["cordova"] || window["phonegap"] || window["PhoneGap"]) && /ios|iphone|ipod|ipad|android|blackberry|iemobile/i.test($f43ebbd33d4c5d93$export$c36915b22ce77c19());
}
/**
 * Detect Node.js.
 *
 * @return true if Node.js environment is detected.
 */ // Node detection logic from: https://github.com/iliakan/detect-node/
function $f43ebbd33d4c5d93$export$8ee0fc9ee280b4ee() {
    try {
        return Object.prototype.toString.call($parcel$global.process) === "[object process]";
    } catch (e) {
        return false;
    }
}
/**
 * Detect Browser Environment
 */ function $f43ebbd33d4c5d93$export$4e09c449d6c407f7() {
    return typeof self === "object" && self.self === self;
}
function $f43ebbd33d4c5d93$export$caa8774a9107a58e() {
    const runtime = typeof chrome === "object" ? chrome.runtime : typeof browser === "object" ? browser.runtime : undefined;
    return typeof runtime === "object" && runtime.id !== undefined;
}
/**
 * Detect React Native.
 *
 * @return true if ReactNative environment is detected.
 */ function $f43ebbd33d4c5d93$export$f7a1e23e542d38e3() {
    return typeof navigator === "object" && navigator["product"] === "ReactNative";
}
/** Detects Electron apps. */ function $f43ebbd33d4c5d93$export$f2f6a8999f8ebd30() {
    return $f43ebbd33d4c5d93$export$c36915b22ce77c19().indexOf("Electron/") >= 0;
}
/** Detects Internet Explorer. */ function $f43ebbd33d4c5d93$export$7e7b1a9668aaed8() {
    const ua = $f43ebbd33d4c5d93$export$c36915b22ce77c19();
    return ua.indexOf("MSIE ") >= 0 || ua.indexOf("Trident/") >= 0;
}
/** Detects Universal Windows Platform apps. */ function $f43ebbd33d4c5d93$export$202944b2d2824246() {
    return $f43ebbd33d4c5d93$export$c36915b22ce77c19().indexOf("MSAppHost/") >= 0;
}
/**
 * Detect whether the current SDK build is the Node version.
 *
 * @return true if it's the Node SDK build.
 */ function $f43ebbd33d4c5d93$export$5d1d834fbbf8bab7() {
    return $f43ebbd33d4c5d93$export$588c7fdda06fbb0a.NODE_CLIENT === true || $f43ebbd33d4c5d93$export$588c7fdda06fbb0a.NODE_ADMIN === true;
}
/** Returns true if we are running in Safari. */ function $f43ebbd33d4c5d93$export$95df08bae54cb4df() {
    return !$f43ebbd33d4c5d93$export$8ee0fc9ee280b4ee() && navigator.userAgent.includes("Safari") && !navigator.userAgent.includes("Chrome");
}
/**
 * This method checks if indexedDB is supported by current browser/service worker context
 * @return true if indexedDB is supported by current browser/service worker context
 */ function $f43ebbd33d4c5d93$export$3865db50535c2055() {
    return typeof indexedDB === "object";
}
/**
 * This method validates browser/sw context for indexedDB by opening a dummy indexedDB database and reject
 * if errors occur during the database open operation.
 *
 * @throws exception if current browser/sw context can't run idb.open (ex: Safari iframe, Firefox
 * private browsing)
 */ function $f43ebbd33d4c5d93$export$a8a3018f3d187a4d() {
    return new Promise((resolve, reject)=>{
        try {
            let preExist = true;
            const DB_CHECK_NAME = "validate-browser-context-for-indexeddb-analytics-module";
            const request = self.indexedDB.open(DB_CHECK_NAME);
            request.onsuccess = ()=>{
                request.result.close();
                // delete database only when it doesn't pre-exist
                if (!preExist) self.indexedDB.deleteDatabase(DB_CHECK_NAME);
                resolve(true);
            };
            request.onupgradeneeded = ()=>{
                preExist = false;
            };
            request.onerror = ()=>{
                var _a;
                reject(((_a = request.error) === null || _a === void 0 ? void 0 : _a.message) || "");
            };
        } catch (error) {
            reject(error);
        }
    });
}
/**
 *
 * This method checks whether cookie is enabled within current browser
 * @return true if cookie is enabled within current browser
 */ function $f43ebbd33d4c5d93$export$f172b7eb6cf60599() {
    if (typeof navigator === "undefined" || !navigator.cookieEnabled) return false;
    return true;
}
/**
 * Polyfill for `globalThis` object.
 * @returns the `globalThis` object for the given environment.
 */ function $f43ebbd33d4c5d93$export$a4e55266d2135a7f() {
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw new Error("Unable to locate global object.");
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Standardized Firebase Error.
 *
 * Usage:
 *
 *   // Typescript string literals for type-safe codes
 *   type Err =
 *     'unknown' |
 *     'object-not-found'
 *     ;
 *
 *   // Closure enum for type-safe error codes
 *   // at-enum {string}
 *   var Err = {
 *     UNKNOWN: 'unknown',
 *     OBJECT_NOT_FOUND: 'object-not-found',
 *   }
 *
 *   let errors: Map<Err, string> = {
 *     'generic-error': "Unknown error",
 *     'file-not-found': "Could not find file: {$file}",
 *   };
 *
 *   // Type-safe function - must pass a valid error code as param.
 *   let error = new ErrorFactory<Err>('service', 'Service', errors);
 *
 *   ...
 *   throw error.create(Err.GENERIC);
 *   ...
 *   throw error.create(Err.FILE_NOT_FOUND, {'file': fileName});
 *   ...
 *   // Service: Could not file file: foo.txt (service/file-not-found).
 *
 *   catch (e) {
 *     assert(e.message === "Could not find file: foo.txt.");
 *     if (e.code === 'service/file-not-found') {
 *       console.log("Could not read file: " + e['file']);
 *     }
 *   }
 */ const $f43ebbd33d4c5d93$var$ERROR_NAME = "FirebaseError";
// Based on code from:
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Custom_Error_Types
class $f43ebbd33d4c5d93$export$dd24e9cd51226c56 extends Error {
    constructor(/** The error code for this error. */ code, message, /** Custom data for this error. */ customData){
        super(message);
        this.code = code;
        this.customData = customData;
        /** The custom name for all FirebaseErrors. */ this.name = $f43ebbd33d4c5d93$var$ERROR_NAME;
        // Fix For ES5
        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $f43ebbd33d4c5d93$export$dd24e9cd51226c56.prototype);
        // Maintains proper stack trace for where our error was thrown.
        // Only available on V8.
        if (Error.captureStackTrace) Error.captureStackTrace(this, $f43ebbd33d4c5d93$export$3fa6e1b18a3b2d40.prototype.create);
    }
}
class $f43ebbd33d4c5d93$export$3fa6e1b18a3b2d40 {
    create(code, ...data) {
        const customData = data[0] || {};
        const fullCode = `${this.service}/${code}`;
        const template = this.errors[code];
        const message = template ? $f43ebbd33d4c5d93$var$replaceTemplate(template, customData) : "Error";
        // Service Name: Error message (service/code).
        const fullMessage = `${this.serviceName}: ${message} (${fullCode}).`;
        const error = new $f43ebbd33d4c5d93$export$dd24e9cd51226c56(fullCode, fullMessage, customData);
        return error;
    }
    constructor(service, serviceName, errors){
        this.service = service;
        this.serviceName = serviceName;
        this.errors = errors;
    }
}
function $f43ebbd33d4c5d93$var$replaceTemplate(template, data) {
    return template.replace($f43ebbd33d4c5d93$var$PATTERN, (_, key)=>{
        const value = data[key];
        return value != null ? String(value) : `<${key}?>`;
    });
}
const $f43ebbd33d4c5d93$var$PATTERN = /\{\$([^}]+)}/g;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Evaluates a JSON string into a javascript object.
 *
 * @param {string} str A string containing JSON.
 * @return {*} The javascript object representing the specified JSON.
 */ function $f43ebbd33d4c5d93$export$c5a53ce6a17cf18d(str) {
    return JSON.parse(str);
}
/**
 * Returns JSON representing a javascript object.
 * @param {*} data Javascript object to be stringified.
 * @return {string} The JSON contents of the object.
 */ function $f43ebbd33d4c5d93$export$fac44ee5b035f737(data) {
    return JSON.stringify(data);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Decodes a Firebase auth. token into constituent parts.
 *
 * Notes:
 * - May return with invalid / incomplete claims if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $f43ebbd33d4c5d93$export$2f872c0f2117be69 = function(token) {
    let header = {}, claims = {}, data = {}, signature = "";
    try {
        const parts = token.split(".");
        header = $f43ebbd33d4c5d93$export$c5a53ce6a17cf18d($f43ebbd33d4c5d93$export$c62426fdd000a97e(parts[0]) || "");
        claims = $f43ebbd33d4c5d93$export$c5a53ce6a17cf18d($f43ebbd33d4c5d93$export$c62426fdd000a97e(parts[1]) || "");
        signature = parts[2];
        data = claims["d"] || {};
        delete claims["d"];
    } catch (e) {}
    return {
        header: header,
        claims: claims,
        data: data,
        signature: signature
    };
};
/**
 * Decodes a Firebase auth. token and checks the validity of its time-based claims. Will return true if the
 * token is within the time window authorized by the 'nbf' (not-before) and 'iat' (issued-at) claims.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $f43ebbd33d4c5d93$export$5f870fcca7ae6a88 = function(token) {
    const claims = $f43ebbd33d4c5d93$export$2f872c0f2117be69(token).claims;
    const now = Math.floor(new Date().getTime() / 1000);
    let validSince = 0, validUntil = 0;
    if (typeof claims === "object") {
        if (claims.hasOwnProperty("nbf")) validSince = claims["nbf"];
        else if (claims.hasOwnProperty("iat")) validSince = claims["iat"];
        if (claims.hasOwnProperty("exp")) validUntil = claims["exp"];
        else // token will expire after 24h by default
        validUntil = validSince + 86400;
    }
    return !!now && !!validSince && !!validUntil && now >= validSince && now <= validUntil;
};
/**
 * Decodes a Firebase auth. token and returns its issued at time if valid, null otherwise.
 *
 * Notes:
 * - May return null if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $f43ebbd33d4c5d93$export$701c661ec91095f2 = function(token) {
    const claims = $f43ebbd33d4c5d93$export$2f872c0f2117be69(token).claims;
    if (typeof claims === "object" && claims.hasOwnProperty("iat")) return claims["iat"];
    return null;
};
/**
 * Decodes a Firebase auth. token and checks the validity of its format. Expects a valid issued-at time.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $f43ebbd33d4c5d93$export$9565ca3d387f8aa0 = function(token) {
    const decoded = $f43ebbd33d4c5d93$export$2f872c0f2117be69(token), claims = decoded.claims;
    return !!claims && typeof claims === "object" && claims.hasOwnProperty("iat");
};
/**
 * Attempts to peer into an auth token and determine if it's an admin auth token by looking at the claims portion.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $f43ebbd33d4c5d93$export$fc970ed23da99565 = function(token) {
    const claims = $f43ebbd33d4c5d93$export$2f872c0f2117be69(token).claims;
    return typeof claims === "object" && claims["admin"] === true;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $f43ebbd33d4c5d93$export$2344b14b097df817(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
}
function $f43ebbd33d4c5d93$export$e51ae4db7b428f67(obj, key) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) return obj[key];
    else return undefined;
}
function $f43ebbd33d4c5d93$export$dd1bc94b04021eeb(obj) {
    for(const key in obj){
        if (Object.prototype.hasOwnProperty.call(obj, key)) return false;
    }
    return true;
}
function $f43ebbd33d4c5d93$export$871de8747c9eaa88(obj, fn, contextObj) {
    const res = {};
    for(const key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) res[key] = fn.call(contextObj, obj[key], key, obj);
    return res;
}
/**
 * Deep equal two objects. Support Arrays and Objects.
 */ function $f43ebbd33d4c5d93$export$9cb4719e2e525b7a(a, b) {
    if (a === b) return true;
    const aKeys = Object.keys(a);
    const bKeys = Object.keys(b);
    for (const k of aKeys){
        if (!bKeys.includes(k)) return false;
        const aProp = a[k];
        const bProp = b[k];
        if ($f43ebbd33d4c5d93$var$isObject(aProp) && $f43ebbd33d4c5d93$var$isObject(bProp)) {
            if (!$f43ebbd33d4c5d93$export$9cb4719e2e525b7a(aProp, bProp)) return false;
        } else if (aProp !== bProp) return false;
    }
    for (const k of bKeys){
        if (!aKeys.includes(k)) return false;
    }
    return true;
}
function $f43ebbd33d4c5d93$var$isObject(thing) {
    return thing !== null && typeof thing === "object";
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a querystring-formatted string (e.g. &arg=val&arg2=val2) from a
 * params object (e.g. {arg: 'val', arg2: 'val2'})
 * Note: You must prepend it with ? when adding it to a URL.
 */ function $f43ebbd33d4c5d93$export$ac4103b836844853(querystringParams) {
    const params = [];
    for (const [key, value] of Object.entries(querystringParams))if (Array.isArray(value)) value.forEach((arrayVal)=>{
        params.push(encodeURIComponent(key) + "=" + encodeURIComponent(arrayVal));
    });
    else params.push(encodeURIComponent(key) + "=" + encodeURIComponent(value));
    return params.length ? "&" + params.join("&") : "";
}
/**
 * Decodes a querystring (e.g. ?arg=val&arg2=val2) into a params object
 * (e.g. {arg: 'val', arg2: 'val2'})
 */ function $f43ebbd33d4c5d93$export$c1271ca4c8a70741(querystring) {
    const obj = {};
    const tokens = querystring.replace(/^\?/, "").split("&");
    tokens.forEach((token)=>{
        if (token) {
            const [key, value] = token.split("=");
            obj[decodeURIComponent(key)] = decodeURIComponent(value);
        }
    });
    return obj;
}
/**
 * Extract the query string part of a URL, including the leading question mark (if present).
 */ function $f43ebbd33d4c5d93$export$1a8408415472d8ed(url) {
    const queryStart = url.indexOf("?");
    if (!queryStart) return "";
    const fragmentStart = url.indexOf("#", queryStart);
    return url.substring(queryStart, fragmentStart > 0 ? fragmentStart : undefined);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview SHA-1 cryptographic hash.
 * Variable names follow the notation in FIPS PUB 180-3:
 * http://csrc.nist.gov/publications/fips/fips180-3/fips180-3_final.pdf.
 *
 * Usage:
 *   var sha1 = new sha1();
 *   sha1.update(bytes);
 *   var hash = sha1.digest();
 *
 * Performance:
 *   Chrome 23:   ~400 Mbit/s
 *   Firefox 16:  ~250 Mbit/s
 *
 */ /**
 * SHA-1 cryptographic hash constructor.
 *
 * The properties declared here are discussed in the above algorithm document.
 * @constructor
 * @final
 * @struct
 */ class $f43ebbd33d4c5d93$export$c85d589bf4e25fef {
    reset() {
        this.chain_[0] = 0x67452301;
        this.chain_[1] = 0xefcdab89;
        this.chain_[2] = 0x98badcfe;
        this.chain_[3] = 0x10325476;
        this.chain_[4] = 0xc3d2e1f0;
        this.inbuf_ = 0;
        this.total_ = 0;
    }
    /**
     * Internal compress helper function.
     * @param buf Block to compress.
     * @param offset Offset of the block in the buffer.
     * @private
     */ compress_(buf, offset) {
        if (!offset) offset = 0;
        const W = this.W_;
        // get 16 big endian words
        if (typeof buf === "string") for(let i = 0; i < 16; i++){
            // TODO(user): [bug 8140122] Recent versions of Safari for Mac OS and iOS
            // have a bug that turns the post-increment ++ operator into pre-increment
            // during JIT compilation.  We have code that depends heavily on SHA-1 for
            // correctness and which is affected by this bug, so I've removed all uses
            // of post-increment ++ in which the result value is used.  We can revert
            // this change once the Safari bug
            // (https://bugs.webkit.org/show_bug.cgi?id=109036) has been fixed and
            // most clients have been updated.
            W[i] = buf.charCodeAt(offset) << 24 | buf.charCodeAt(offset + 1) << 16 | buf.charCodeAt(offset + 2) << 8 | buf.charCodeAt(offset + 3);
            offset += 4;
        }
        else for(let i = 0; i < 16; i++){
            W[i] = buf[offset] << 24 | buf[offset + 1] << 16 | buf[offset + 2] << 8 | buf[offset + 3];
            offset += 4;
        }
        // expand to 80 words
        for(let i = 16; i < 80; i++){
            const t = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
            W[i] = (t << 1 | t >>> 31) & 0xffffffff;
        }
        let a = this.chain_[0];
        let b = this.chain_[1];
        let c = this.chain_[2];
        let d = this.chain_[3];
        let e = this.chain_[4];
        let f, k;
        // TODO(user): Try to unroll this loop to speed up the computation.
        for(let i = 0; i < 80; i++){
            if (i < 40) {
                if (i < 20) {
                    f = d ^ b & (c ^ d);
                    k = 0x5a827999;
                } else {
                    f = b ^ c ^ d;
                    k = 0x6ed9eba1;
                }
            } else if (i < 60) {
                f = b & c | d & (b | c);
                k = 0x8f1bbcdc;
            } else {
                f = b ^ c ^ d;
                k = 0xca62c1d6;
            }
            const t = (a << 5 | a >>> 27) + f + e + k + W[i] & 0xffffffff;
            e = d;
            d = c;
            c = (b << 30 | b >>> 2) & 0xffffffff;
            b = a;
            a = t;
        }
        this.chain_[0] = this.chain_[0] + a & 0xffffffff;
        this.chain_[1] = this.chain_[1] + b & 0xffffffff;
        this.chain_[2] = this.chain_[2] + c & 0xffffffff;
        this.chain_[3] = this.chain_[3] + d & 0xffffffff;
        this.chain_[4] = this.chain_[4] + e & 0xffffffff;
    }
    update(bytes, length) {
        // TODO(johnlenz): tighten the function signature and remove this check
        if (bytes == null) return;
        if (length === undefined) length = bytes.length;
        const lengthMinusBlock = length - this.blockSize;
        let n = 0;
        // Using local instead of member variables gives ~5% speedup on Firefox 16.
        const buf = this.buf_;
        let inbuf = this.inbuf_;
        // The outer while loop should execute at most twice.
        while(n < length){
            // When we have no data in the block to top up, we can directly process the
            // input buffer (assuming it contains sufficient data). This gives ~25%
            // speedup on Chrome 23 and ~15% speedup on Firefox 16, but requires that
            // the data is provided in large chunks (or in multiples of 64 bytes).
            if (inbuf === 0) while(n <= lengthMinusBlock){
                this.compress_(bytes, n);
                n += this.blockSize;
            }
            if (typeof bytes === "string") while(n < length){
                buf[inbuf] = bytes.charCodeAt(n);
                ++inbuf;
                ++n;
                if (inbuf === this.blockSize) {
                    this.compress_(buf);
                    inbuf = 0;
                    break;
                }
            }
            else while(n < length){
                buf[inbuf] = bytes[n];
                ++inbuf;
                ++n;
                if (inbuf === this.blockSize) {
                    this.compress_(buf);
                    inbuf = 0;
                    break;
                }
            }
        }
        this.inbuf_ = inbuf;
        this.total_ += length;
    }
    /** @override */ digest() {
        const digest = [];
        let totalBits = this.total_ * 8;
        // Add pad 0x80 0x00*.
        if (this.inbuf_ < 56) this.update(this.pad_, 56 - this.inbuf_);
        else this.update(this.pad_, this.blockSize - (this.inbuf_ - 56));
        // Add # bits.
        for(let i = this.blockSize - 1; i >= 56; i--){
            this.buf_[i] = totalBits & 255;
            totalBits /= 256; // Don't use bit-shifting here!
        }
        this.compress_(this.buf_);
        let n = 0;
        for(let i = 0; i < 5; i++)for(let j = 24; j >= 0; j -= 8){
            digest[n] = this.chain_[i] >> j & 255;
            ++n;
        }
        return digest;
    }
    constructor(){
        /**
         * Holds the previous values of accumulated variables a-e in the compress_
         * function.
         * @private
         */ this.chain_ = [];
        /**
         * A buffer holding the partially computed hash result.
         * @private
         */ this.buf_ = [];
        /**
         * An array of 80 bytes, each a part of the message to be hashed.  Referred to
         * as the message schedule in the docs.
         * @private
         */ this.W_ = [];
        /**
         * Contains data needed to pad messages less than 64 bytes.
         * @private
         */ this.pad_ = [];
        /**
         * @private {number}
         */ this.inbuf_ = 0;
        /**
         * @private {number}
         */ this.total_ = 0;
        this.blockSize = 64;
        this.pad_[0] = 128;
        for(let i = 1; i < this.blockSize; ++i)this.pad_[i] = 0;
        this.reset();
    }
}
/**
 * Helper to make a Subscribe function (just like Promise helps make a
 * Thenable).
 *
 * @param executor Function which can make calls to a single Observer
 *     as a proxy.
 * @param onNoObservers Callback when count of Observers goes to zero.
 */ function $f43ebbd33d4c5d93$export$364097d812234b3f(executor, onNoObservers) {
    const proxy = new $f43ebbd33d4c5d93$var$ObserverProxy(executor, onNoObservers);
    return proxy.subscribe.bind(proxy);
}
/**
 * Implement fan-out for any number of Observers attached via a subscribe
 * function.
 */ class $f43ebbd33d4c5d93$var$ObserverProxy {
    next(value) {
        this.forEachObserver((observer)=>{
            observer.next(value);
        });
    }
    error(error) {
        this.forEachObserver((observer)=>{
            observer.error(error);
        });
        this.close(error);
    }
    complete() {
        this.forEachObserver((observer)=>{
            observer.complete();
        });
        this.close();
    }
    /**
     * Subscribe function that can be used to add an Observer to the fan-out list.
     *
     * - We require that no event is sent to a subscriber sychronously to their
     *   call to subscribe().
     */ subscribe(nextOrObserver, error, complete) {
        let observer;
        if (nextOrObserver === undefined && error === undefined && complete === undefined) throw new Error("Missing Observer.");
        // Assemble an Observer object when passed as callback functions.
        if ($f43ebbd33d4c5d93$var$implementsAnyMethods(nextOrObserver, [
            "next",
            "error",
            "complete"
        ])) observer = nextOrObserver;
        else observer = {
            next: nextOrObserver,
            error: error,
            complete: complete
        };
        if (observer.next === undefined) observer.next = $f43ebbd33d4c5d93$var$noop;
        if (observer.error === undefined) observer.error = $f43ebbd33d4c5d93$var$noop;
        if (observer.complete === undefined) observer.complete = $f43ebbd33d4c5d93$var$noop;
        const unsub = this.unsubscribeOne.bind(this, this.observers.length);
        // Attempt to subscribe to a terminated Observable - we
        // just respond to the Observer with the final error or complete
        // event.
        if (this.finalized) // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            try {
                if (this.finalError) observer.error(this.finalError);
                else observer.complete();
            } catch (e) {
            // nothing
            }
            return;
        });
        this.observers.push(observer);
        return unsub;
    }
    // Unsubscribe is synchronous - we guarantee that no events are sent to
    // any unsubscribed Observer.
    unsubscribeOne(i) {
        if (this.observers === undefined || this.observers[i] === undefined) return;
        delete this.observers[i];
        this.observerCount -= 1;
        if (this.observerCount === 0 && this.onNoObservers !== undefined) this.onNoObservers(this);
    }
    forEachObserver(fn) {
        if (this.finalized) // Already closed by previous event....just eat the additional values.
        return;
        // Since sendOne calls asynchronously - there is no chance that
        // this.observers will become undefined.
        for(let i = 0; i < this.observers.length; i++)this.sendOne(i, fn);
    }
    // Call the Observer via one of it's callback function. We are careful to
    // confirm that the observe has not been unsubscribed since this asynchronous
    // function had been queued.
    sendOne(i, fn) {
        // Execute the callback asynchronously
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            if (this.observers !== undefined && this.observers[i] !== undefined) try {
                fn(this.observers[i]);
            } catch (e) {
                // Ignore exceptions raised in Observers or missing methods of an
                // Observer.
                // Log error to console. b/31404806
                if (typeof console !== "undefined" && console.error) console.error(e);
            }
        });
    }
    close(err) {
        if (this.finalized) return;
        this.finalized = true;
        if (err !== undefined) this.finalError = err;
        // Proxy is no longer needed - garbage collect references
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            this.observers = undefined;
            this.onNoObservers = undefined;
        });
    }
    /**
     * @param executor Function which can make calls to a single Observer
     *     as a proxy.
     * @param onNoObservers Callback when count of Observers goes to zero.
     */ constructor(executor, onNoObservers){
        this.observers = [];
        this.unsubscribes = [];
        this.observerCount = 0;
        // Micro-task scheduling by calling task.then().
        this.task = Promise.resolve();
        this.finalized = false;
        this.onNoObservers = onNoObservers;
        // Call the executor asynchronously so subscribers that are called
        // synchronously after the creation of the subscribe function
        // can still receive the very first value generated in the executor.
        this.task.then(()=>{
            executor(this);
        }).catch((e)=>{
            this.error(e);
        });
    }
}
/** Turn synchronous function into one called asynchronously. */ // eslint-disable-next-line @typescript-eslint/ban-types
function $f43ebbd33d4c5d93$export$12af436354f1a4f7(fn, onError) {
    return (...args)=>{
        Promise.resolve(true).then(()=>{
            fn(...args);
        }).catch((error)=>{
            if (onError) onError(error);
        });
    };
}
/**
 * Return true if the object passed in implements any of the named methods.
 */ function $f43ebbd33d4c5d93$var$implementsAnyMethods(obj, methods) {
    if (typeof obj !== "object" || obj === null) return false;
    for (const method of methods){
        if (method in obj && typeof obj[method] === "function") return true;
    }
    return false;
}
function $f43ebbd33d4c5d93$var$noop() {
// do nothing
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Check to make sure the appropriate number of arguments are provided for a public function.
 * Throws an error if it fails.
 *
 * @param fnName The function name
 * @param minCount The minimum number of arguments to allow for the function call
 * @param maxCount The maximum number of argument to allow for the function call
 * @param argCount The actual number of arguments provided.
 */ const $f43ebbd33d4c5d93$export$20164226a0ed35c3 = function(fnName, minCount, maxCount, argCount) {
    let argError;
    if (argCount < minCount) argError = "at least " + minCount;
    else if (argCount > maxCount) argError = maxCount === 0 ? "none" : "no more than " + maxCount;
    if (argError) {
        const error = fnName + " failed: Was called with " + argCount + (argCount === 1 ? " argument." : " arguments.") + " Expects " + argError + ".";
        throw new Error(error);
    }
};
/**
 * Generates a string to prefix an error message about failed argument validation
 *
 * @param fnName The function name
 * @param argName The name of the argument
 * @return The prefix to add to the error thrown for validation.
 */ function $f43ebbd33d4c5d93$export$adea4917e02d93dc(fnName, argName) {
    return `${fnName} failed: ${argName} argument `;
}
/**
 * @param fnName
 * @param argumentNumber
 * @param namespace
 * @param optional
 */ function $f43ebbd33d4c5d93$export$8eef22622e725943(fnName, namespace, optional) {
    if (optional && !namespace) return;
    if (typeof namespace !== "string") //TODO: I should do more validation here. We only allow certain chars in namespaces.
    throw new Error($f43ebbd33d4c5d93$export$adea4917e02d93dc(fnName, "namespace") + "must be a valid firebase namespace.");
}
function $f43ebbd33d4c5d93$export$5bcd2a2eb6640dfa(fnName, argumentName, // eslint-disable-next-line @typescript-eslint/ban-types
callback, optional) {
    if (optional && !callback) return;
    if (typeof callback !== "function") throw new Error($f43ebbd33d4c5d93$export$adea4917e02d93dc(fnName, argumentName) + "must be a valid function.");
}
function $f43ebbd33d4c5d93$export$df77539402cfb523(fnName, argumentName, context, optional) {
    if (optional && !context) return;
    if (typeof context !== "object" || context === null) throw new Error($f43ebbd33d4c5d93$export$adea4917e02d93dc(fnName, argumentName) + "must be a valid context object.");
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Code originally came from goog.crypt.stringToUtf8ByteArray, but for some reason they
// automatically replaced '\r\n' with '\n', and they didn't handle surrogate pairs,
// so it's been modified.
// Note that not all Unicode characters appear as single characters in JavaScript strings.
// fromCharCode returns the UTF-16 encoding of a character - so some Unicode characters
// use 2 characters in Javascript.  All 4-byte UTF-8 characters begin with a first
// character in the range 0xD800 - 0xDBFF (the first character of a so-called surrogate
// pair).
// See http://www.ecma-international.org/ecma-262/5.1/#sec-15.1.3
/**
 * @param {string} str
 * @return {Array}
 */ const $f43ebbd33d4c5d93$export$655666783217a925 = function(str) {
    const out = [];
    let p = 0;
    for(let i = 0; i < str.length; i++){
        let c = str.charCodeAt(i);
        // Is this the lead surrogate in a surrogate pair?
        if (c >= 0xd800 && c <= 0xdbff) {
            const high = c - 0xd800; // the high 10 bits.
            i++;
            $f43ebbd33d4c5d93$export$a7a9523472993e97(i < str.length, "Surrogate pair missing trail surrogate.");
            const low = str.charCodeAt(i) - 0xdc00; // the low 10 bits.
            c = 0x10000 + (high << 10) + low;
        }
        if (c < 128) out[p++] = c;
        else if (c < 2048) {
            out[p++] = c >> 6 | 192;
            out[p++] = c & 63 | 128;
        } else if (c < 65536) {
            out[p++] = c >> 12 | 224;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        } else {
            out[p++] = c >> 18 | 240;
            out[p++] = c >> 12 & 63 | 128;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        }
    }
    return out;
};
/**
 * Calculate length without actually converting; useful for doing cheaper validation.
 * @param {string} str
 * @return {number}
 */ const $f43ebbd33d4c5d93$export$9536dc0a75b20bf9 = function(str) {
    let p = 0;
    for(let i = 0; i < str.length; i++){
        const c = str.charCodeAt(i);
        if (c < 128) p++;
        else if (c < 2048) p += 2;
        else if (c >= 0xd800 && c <= 0xdbff) {
            // Lead surrogate of a surrogate pair.  The pair together will take 4 bytes to represent.
            p += 4;
            i++; // skip trail surrogate.
        } else p += 3;
    }
    return p;
};
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The amount of milliseconds to exponentially increase.
 */ const $f43ebbd33d4c5d93$var$DEFAULT_INTERVAL_MILLIS = 1000;
/**
 * The factor to backoff by.
 * Should be a number greater than 1.
 */ const $f43ebbd33d4c5d93$var$DEFAULT_BACKOFF_FACTOR = 2;
/**
 * The maximum milliseconds to increase to.
 *
 * <p>Visible for testing
 */ const $f43ebbd33d4c5d93$export$bdf1213ffbdb096e = 14400000; // Four hours, like iOS and Android.
/**
 * The percentage of backoff time to randomize by.
 * See
 * http://go/safe-client-behavior#step-1-determine-the-appropriate-retry-interval-to-handle-spike-traffic
 * for context.
 *
 * <p>Visible for testing
 */ const $f43ebbd33d4c5d93$export$3518ed2cfe61fa30 = 0.5;
/**
 * Based on the backoff method from
 * https://github.com/google/closure-library/blob/master/closure/goog/math/exponentialbackoff.js.
 * Extracted here so we don't need to pass metadata and a stateful ExponentialBackoff object around.
 */ function $f43ebbd33d4c5d93$export$4d810c0ca64ed8e9(backoffCount, intervalMillis = $f43ebbd33d4c5d93$var$DEFAULT_INTERVAL_MILLIS, backoffFactor = $f43ebbd33d4c5d93$var$DEFAULT_BACKOFF_FACTOR) {
    // Calculates an exponentially increasing value.
    // Deviation: calculates value from count and a constant interval, so we only need to save value
    // and count to restore state.
    const currBaseValue = intervalMillis * Math.pow(backoffFactor, backoffCount);
    // A random "fuzz" to avoid waves of retries.
    // Deviation: randomFactor is required.
    const randomWait = Math.round(// A fraction of the backoff value to add/subtract.
    // Deviation: changes multiplication order to improve readability.
    $f43ebbd33d4c5d93$export$3518ed2cfe61fa30 * currBaseValue * // A random float (rounded to int by Math.round above) in the range [-1, 1]. Determines
    // if we add or subtract.
    (Math.random() - 0.5) * 2);
    // Limits backoff to max to avoid effectively permanent backoff.
    return Math.min($f43ebbd33d4c5d93$export$bdf1213ffbdb096e, currBaseValue + randomWait);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provide English ordinal letters after a number
 */ function $f43ebbd33d4c5d93$export$7bb39f879164e4ac(i) {
    if (!Number.isFinite(i)) return `${i}`;
    return i + $f43ebbd33d4c5d93$var$indicator(i);
}
function $f43ebbd33d4c5d93$var$indicator(i) {
    i = Math.abs(i);
    const cent = i % 100;
    if (cent >= 10 && cent <= 20) return "th";
    const dec = i % 10;
    if (dec === 1) return "st";
    if (dec === 2) return "nd";
    if (dec === 3) return "rd";
    return "th";
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $f43ebbd33d4c5d93$export$4befe9b5fa509a1b(service) {
    if (service && service._delegate) return service._delegate;
    else return service;
}


/**
 * Component for service name T, e.g. `auth`, `auth-internal`
 */ class $f3262427d4ee348d$export$16fa2f45be04daa8 {
    setInstantiationMode(mode) {
        this.instantiationMode = mode;
        return this;
    }
    setMultipleInstances(multipleInstances) {
        this.multipleInstances = multipleInstances;
        return this;
    }
    setServiceProps(props) {
        this.serviceProps = props;
        return this;
    }
    setInstanceCreatedCallback(callback) {
        this.onInstanceCreated = callback;
        return this;
    }
    /**
     *
     * @param name The public service name, e.g. app, auth, firestore, database
     * @param instanceFactory Service factory responsible for creating the public interface
     * @param type whether the service provided by the component is public or private
     */ constructor(name, instanceFactory, type){
        this.name = name;
        this.instanceFactory = instanceFactory;
        this.type = type;
        this.multipleInstances = false;
        /**
         * Properties to be added to the service namespace
         */ this.serviceProps = {};
        this.instantiationMode = "LAZY" /* LAZY */ ;
        this.onInstanceCreated = null;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $f3262427d4ee348d$var$DEFAULT_ENTRY_NAME = "[DEFAULT]";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for instance for service name T, e.g. 'auth', 'auth-internal'
 * NameServiceMapping[T] is an alias for the type of the instance
 */ class $f3262427d4ee348d$export$2881499e37b75b9a {
    /**
     * @param identifier A provider can provide mulitple instances of a service
     * if this.component.multipleInstances is true.
     */ get(identifier) {
        // if multipleInstances is not supported, use the default name
        const normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
        if (!this.instancesDeferred.has(normalizedIdentifier)) {
            const deferred = new (0, $f43ebbd33d4c5d93$export$85f6557964517f1a)();
            this.instancesDeferred.set(normalizedIdentifier, deferred);
            if (this.isInitialized(normalizedIdentifier) || this.shouldAutoInitialize()) // initialize the service if it can be auto-initialized
            try {
                const instance = this.getOrInitializeService({
                    instanceIdentifier: normalizedIdentifier
                });
                if (instance) deferred.resolve(instance);
            } catch (e) {
            // when the instance factory throws an exception during get(), it should not cause
            // a fatal error. We just return the unresolved promise in this case.
            }
        }
        return this.instancesDeferred.get(normalizedIdentifier).promise;
    }
    getImmediate(options) {
        var _a;
        // if multipleInstances is not supported, use the default name
        const normalizedIdentifier = this.normalizeInstanceIdentifier(options === null || options === void 0 ? void 0 : options.identifier);
        const optional = (_a = options === null || options === void 0 ? void 0 : options.optional) !== null && _a !== void 0 ? _a : false;
        if (this.isInitialized(normalizedIdentifier) || this.shouldAutoInitialize()) try {
            return this.getOrInitializeService({
                instanceIdentifier: normalizedIdentifier
            });
        } catch (e) {
            if (optional) return null;
            else throw e;
        }
        else {
            // In case a component is not initialized and should/can not be auto-initialized at the moment, return null if the optional flag is set, or throw
            if (optional) return null;
            else throw Error(`Service ${this.name} is not available`);
        }
    }
    getComponent() {
        return this.component;
    }
    setComponent(component) {
        if (component.name !== this.name) throw Error(`Mismatching Component ${component.name} for Provider ${this.name}.`);
        if (this.component) throw Error(`Component for ${this.name} has already been provided`);
        this.component = component;
        // return early without attempting to initialize the component if the component requires explicit initialization (calling `Provider.initialize()`)
        if (!this.shouldAutoInitialize()) return;
        // if the service is eager, initialize the default instance
        if ($f3262427d4ee348d$var$isComponentEager(component)) try {
            this.getOrInitializeService({
                instanceIdentifier: $f3262427d4ee348d$var$DEFAULT_ENTRY_NAME
            });
        } catch (e) {
        // when the instance factory for an eager Component throws an exception during the eager
        // initialization, it should not cause a fatal error.
        // TODO: Investigate if we need to make it configurable, because some component may want to cause
        // a fatal error in this case?
        }
        // Create service instances for the pending promises and resolve them
        // NOTE: if this.multipleInstances is false, only the default instance will be created
        // and all promises with resolve with it regardless of the identifier.
        for (const [instanceIdentifier, instanceDeferred] of this.instancesDeferred.entries()){
            const normalizedIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
            try {
                // `getOrInitializeService()` should always return a valid instance since a component is guaranteed. use ! to make typescript happy.
                const instance = this.getOrInitializeService({
                    instanceIdentifier: normalizedIdentifier
                });
                instanceDeferred.resolve(instance);
            } catch (e) {
            // when the instance factory throws an exception, it should not cause
            // a fatal error. We just leave the promise unresolved.
            }
        }
    }
    clearInstance(identifier = $f3262427d4ee348d$var$DEFAULT_ENTRY_NAME) {
        this.instancesDeferred.delete(identifier);
        this.instancesOptions.delete(identifier);
        this.instances.delete(identifier);
    }
    // app.delete() will call this method on every provider to delete the services
    // TODO: should we mark the provider as deleted?
    async delete() {
        const services = Array.from(this.instances.values());
        await Promise.all([
            ...services.filter((service)=>"INTERNAL" in service) // legacy services
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .map((service)=>service.INTERNAL.delete()),
            ...services.filter((service)=>"_delete" in service) // modularized services
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .map((service)=>service._delete())
        ]);
    }
    isComponentSet() {
        return this.component != null;
    }
    isInitialized(identifier = $f3262427d4ee348d$var$DEFAULT_ENTRY_NAME) {
        return this.instances.has(identifier);
    }
    getOptions(identifier = $f3262427d4ee348d$var$DEFAULT_ENTRY_NAME) {
        return this.instancesOptions.get(identifier) || {};
    }
    initialize(opts = {}) {
        const { options: options = {} } = opts;
        const normalizedIdentifier = this.normalizeInstanceIdentifier(opts.instanceIdentifier);
        if (this.isInitialized(normalizedIdentifier)) throw Error(`${this.name}(${normalizedIdentifier}) has already been initialized`);
        if (!this.isComponentSet()) throw Error(`Component ${this.name} has not been registered yet`);
        const instance = this.getOrInitializeService({
            instanceIdentifier: normalizedIdentifier,
            options: options
        });
        // resolve any pending promise waiting for the service instance
        for (const [instanceIdentifier, instanceDeferred] of this.instancesDeferred.entries()){
            const normalizedDeferredIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
            if (normalizedIdentifier === normalizedDeferredIdentifier) instanceDeferred.resolve(instance);
        }
        return instance;
    }
    /**
     *
     * @param callback - a function that will be invoked  after the provider has been initialized by calling provider.initialize().
     * The function is invoked SYNCHRONOUSLY, so it should not execute any longrunning tasks in order to not block the program.
     *
     * @param identifier An optional instance identifier
     * @returns a function to unregister the callback
     */ onInit(callback, identifier) {
        var _a;
        const normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
        const existingCallbacks = (_a = this.onInitCallbacks.get(normalizedIdentifier)) !== null && _a !== void 0 ? _a : new Set();
        existingCallbacks.add(callback);
        this.onInitCallbacks.set(normalizedIdentifier, existingCallbacks);
        const existingInstance = this.instances.get(normalizedIdentifier);
        if (existingInstance) callback(existingInstance, normalizedIdentifier);
        return ()=>{
            existingCallbacks.delete(callback);
        };
    }
    /**
     * Invoke onInit callbacks synchronously
     * @param instance the service instance`
     */ invokeOnInitCallbacks(instance, identifier) {
        const callbacks = this.onInitCallbacks.get(identifier);
        if (!callbacks) return;
        for (const callback of callbacks)try {
            callback(instance, identifier);
        } catch (_a) {
        // ignore errors in the onInit callback
        }
    }
    getOrInitializeService({ instanceIdentifier: instanceIdentifier, options: options = {} }) {
        let instance = this.instances.get(instanceIdentifier);
        if (!instance && this.component) {
            instance = this.component.instanceFactory(this.container, {
                instanceIdentifier: $f3262427d4ee348d$var$normalizeIdentifierForFactory(instanceIdentifier),
                options: options
            });
            this.instances.set(instanceIdentifier, instance);
            this.instancesOptions.set(instanceIdentifier, options);
            /**
             * Invoke onInit listeners.
             * Note this.component.onInstanceCreated is different, which is used by the component creator,
             * while onInit listeners are registered by consumers of the provider.
             */ this.invokeOnInitCallbacks(instance, instanceIdentifier);
            /**
             * Order is important
             * onInstanceCreated() should be called after this.instances.set(instanceIdentifier, instance); which
             * makes `isInitialized()` return true.
             */ if (this.component.onInstanceCreated) try {
                this.component.onInstanceCreated(this.container, instanceIdentifier, instance);
            } catch (_a) {
            // ignore errors in the onInstanceCreatedCallback
            }
        }
        return instance || null;
    }
    normalizeInstanceIdentifier(identifier = $f3262427d4ee348d$var$DEFAULT_ENTRY_NAME) {
        if (this.component) return this.component.multipleInstances ? identifier : $f3262427d4ee348d$var$DEFAULT_ENTRY_NAME;
        else return identifier; // assume multiple instances are supported before the component is provided.
    }
    shouldAutoInitialize() {
        return !!this.component && this.component.instantiationMode !== "EXPLICIT" /* EXPLICIT */ ;
    }
    constructor(name, container){
        this.name = name;
        this.container = container;
        this.component = null;
        this.instances = new Map();
        this.instancesDeferred = new Map();
        this.instancesOptions = new Map();
        this.onInitCallbacks = new Map();
    }
}
// undefined should be passed to the service factory for the default instance
function $f3262427d4ee348d$var$normalizeIdentifierForFactory(identifier) {
    return identifier === $f3262427d4ee348d$var$DEFAULT_ENTRY_NAME ? undefined : identifier;
}
function $f3262427d4ee348d$var$isComponentEager(component) {
    return component.instantiationMode === "EAGER" /* EAGER */ ;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * ComponentContainer that provides Providers for service name T, e.g. `auth`, `auth-internal`
 */ class $f3262427d4ee348d$export$436a80eea5d5c0c5 {
    /**
     *
     * @param component Component being added
     * @param overwrite When a component with the same name has already been registered,
     * if overwrite is true: overwrite the existing component with the new component and create a new
     * provider with the new component. It can be useful in tests where you want to use different mocks
     * for different tests.
     * if overwrite is false: throw an exception
     */ addComponent(component) {
        const provider = this.getProvider(component.name);
        if (provider.isComponentSet()) throw new Error(`Component ${component.name} has already been registered with ${this.name}`);
        provider.setComponent(component);
    }
    addOrOverwriteComponent(component) {
        const provider = this.getProvider(component.name);
        if (provider.isComponentSet()) // delete the existing provider from the container, so we can register the new component
        this.providers.delete(component.name);
        this.addComponent(component);
    }
    /**
     * getProvider provides a type safe interface where it can only be called with a field name
     * present in NameServiceMapping interface.
     *
     * Firebase SDKs providing services should extend NameServiceMapping interface to register
     * themselves.
     */ getProvider(name) {
        if (this.providers.has(name)) return this.providers.get(name);
        // create a Provider for a service that hasn't registered with Firebase
        const provider = new $f3262427d4ee348d$export$2881499e37b75b9a(name, this);
        this.providers.set(name, provider);
        return provider;
    }
    getProviders() {
        return Array.from(this.providers.values());
    }
    constructor(name){
        this.name = name;
        this.providers = new Map();
    }
}



/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A container for all of the Logger instances
 */ const $a1112fe19640197d$var$instances = [];
/**
 * The JS SDK supports 5 log levels and also allows a user the ability to
 * silence the logs altogether.
 *
 * The order is a follows:
 * DEBUG < VERBOSE < INFO < WARN < ERROR
 *
 * All of the log types above the current log level will be captured (i.e. if
 * you set the log level to `INFO`, errors will still be logged, but `DEBUG` and
 * `VERBOSE` logs will not)
 */ var $a1112fe19640197d$export$243e62d78d3b544d;
(function(LogLevel) {
    LogLevel[LogLevel["DEBUG"] = 0] = "DEBUG";
    LogLevel[LogLevel["VERBOSE"] = 1] = "VERBOSE";
    LogLevel[LogLevel["INFO"] = 2] = "INFO";
    LogLevel[LogLevel["WARN"] = 3] = "WARN";
    LogLevel[LogLevel["ERROR"] = 4] = "ERROR";
    LogLevel[LogLevel["SILENT"] = 5] = "SILENT";
})($a1112fe19640197d$export$243e62d78d3b544d || ($a1112fe19640197d$export$243e62d78d3b544d = {}));
const $a1112fe19640197d$var$levelStringToEnum = {
    "debug": $a1112fe19640197d$export$243e62d78d3b544d.DEBUG,
    "verbose": $a1112fe19640197d$export$243e62d78d3b544d.VERBOSE,
    "info": $a1112fe19640197d$export$243e62d78d3b544d.INFO,
    "warn": $a1112fe19640197d$export$243e62d78d3b544d.WARN,
    "error": $a1112fe19640197d$export$243e62d78d3b544d.ERROR,
    "silent": $a1112fe19640197d$export$243e62d78d3b544d.SILENT
};
/**
 * The default log level
 */ const $a1112fe19640197d$var$defaultLogLevel = $a1112fe19640197d$export$243e62d78d3b544d.INFO;
/**
 * By default, `console.debug` is not displayed in the developer console (in
 * chrome). To avoid forcing users to have to opt-in to these logs twice
 * (i.e. once for firebase, and once in the console), we are sending `DEBUG`
 * logs to the `console.log` function.
 */ const $a1112fe19640197d$var$ConsoleMethod = {
    [$a1112fe19640197d$export$243e62d78d3b544d.DEBUG]: "log",
    [$a1112fe19640197d$export$243e62d78d3b544d.VERBOSE]: "log",
    [$a1112fe19640197d$export$243e62d78d3b544d.INFO]: "info",
    [$a1112fe19640197d$export$243e62d78d3b544d.WARN]: "warn",
    [$a1112fe19640197d$export$243e62d78d3b544d.ERROR]: "error"
};
/**
 * The default log handler will forward DEBUG, VERBOSE, INFO, WARN, and ERROR
 * messages on to their corresponding console counterparts (if the log method
 * is supported by the current log level)
 */ const $a1112fe19640197d$var$defaultLogHandler = (instance, logType, ...args)=>{
    if (logType < instance.logLevel) return;
    const now = new Date().toISOString();
    const method = $a1112fe19640197d$var$ConsoleMethod[logType];
    if (method) console[method](`[${now}]  ${instance.name}:`, ...args);
    else throw new Error(`Attempted to log a message with an invalid logType (value: ${logType})`);
};
class $a1112fe19640197d$export$efa9a398d6368992 {
    get logLevel() {
        return this._logLevel;
    }
    set logLevel(val) {
        if (!(val in $a1112fe19640197d$export$243e62d78d3b544d)) throw new TypeError(`Invalid value "${val}" assigned to \`logLevel\``);
        this._logLevel = val;
    }
    // Workaround for setter/getter having to be the same type.
    setLogLevel(val) {
        this._logLevel = typeof val === "string" ? $a1112fe19640197d$var$levelStringToEnum[val] : val;
    }
    get logHandler() {
        return this._logHandler;
    }
    set logHandler(val) {
        if (typeof val !== "function") throw new TypeError("Value assigned to `logHandler` must be a function");
        this._logHandler = val;
    }
    get userLogHandler() {
        return this._userLogHandler;
    }
    set userLogHandler(val) {
        this._userLogHandler = val;
    }
    /**
     * The functions below are all based on the `console` interface
     */ debug(...args) {
        this._userLogHandler && this._userLogHandler(this, $a1112fe19640197d$export$243e62d78d3b544d.DEBUG, ...args);
        this._logHandler(this, $a1112fe19640197d$export$243e62d78d3b544d.DEBUG, ...args);
    }
    log(...args) {
        this._userLogHandler && this._userLogHandler(this, $a1112fe19640197d$export$243e62d78d3b544d.VERBOSE, ...args);
        this._logHandler(this, $a1112fe19640197d$export$243e62d78d3b544d.VERBOSE, ...args);
    }
    info(...args) {
        this._userLogHandler && this._userLogHandler(this, $a1112fe19640197d$export$243e62d78d3b544d.INFO, ...args);
        this._logHandler(this, $a1112fe19640197d$export$243e62d78d3b544d.INFO, ...args);
    }
    warn(...args) {
        this._userLogHandler && this._userLogHandler(this, $a1112fe19640197d$export$243e62d78d3b544d.WARN, ...args);
        this._logHandler(this, $a1112fe19640197d$export$243e62d78d3b544d.WARN, ...args);
    }
    error(...args) {
        this._userLogHandler && this._userLogHandler(this, $a1112fe19640197d$export$243e62d78d3b544d.ERROR, ...args);
        this._logHandler(this, $a1112fe19640197d$export$243e62d78d3b544d.ERROR, ...args);
    }
    /**
     * Gives you an instance of a Logger to capture messages according to
     * Firebase's logging scheme.
     *
     * @param name The name that the logs will be associated with
     */ constructor(name){
        this.name = name;
        /**
         * The log level of the given Logger instance.
         */ this._logLevel = $a1112fe19640197d$var$defaultLogLevel;
        /**
         * The main (internal) log handler for the Logger instance.
         * Can be set to a new function in internal package code but not by user.
         */ this._logHandler = $a1112fe19640197d$var$defaultLogHandler;
        /**
         * The optional, additional, user-defined log handler for the Logger instance.
         */ this._userLogHandler = null;
        /**
         * Capture the current instance for later use
         */ $a1112fe19640197d$var$instances.push(this);
    }
}
function $a1112fe19640197d$export$c622e99c0ce7b1c9(level) {
    $a1112fe19640197d$var$instances.forEach((inst)=>{
        inst.setLogLevel(level);
    });
}
function $a1112fe19640197d$export$29577d29c84db5f6(logCallback, options) {
    for (const instance of $a1112fe19640197d$var$instances){
        let customLogLevel = null;
        if (options && options.level) customLogLevel = $a1112fe19640197d$var$levelStringToEnum[options.level];
        if (logCallback === null) instance.userLogHandler = null;
        else instance.userLogHandler = (instance, level, ...args)=>{
            const message = args.map((arg)=>{
                if (arg == null) return null;
                else if (typeof arg === "string") return arg;
                else if (typeof arg === "number" || typeof arg === "boolean") return arg.toString();
                else if (arg instanceof Error) return arg.message;
                else try {
                    return JSON.stringify(arg);
                } catch (ignored) {
                    return null;
                }
            }).filter((arg)=>arg).join(" ");
            if (level >= (customLogLevel !== null && customLogLevel !== void 0 ? customLogLevel : instance.logLevel)) logCallback({
                level: $a1112fe19640197d$export$243e62d78d3b544d[level].toLowerCase(),
                message: message,
                args: args,
                type: instance.name
            });
        };
    }
}



var $i9yYZ = parcelRequire("i9yYZ");
const $30d3a405033775a4$var$name = "@firebase/database";
const $30d3a405033775a4$var$version = "0.13.1";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** The semver (www.semver.org) version of the SDK. */ let $30d3a405033775a4$var$SDK_VERSION = "";
/**
 * SDK_VERSION should be set before any database instance is created
 * @internal
 */ function $30d3a405033775a4$export$c9fb972242fcb3c4(version) {
    $30d3a405033775a4$var$SDK_VERSION = version;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Wraps a DOM Storage object and:
 * - automatically encode objects as JSON strings before storing them to allow us to store arbitrary types.
 * - prefixes names with "firebase:" to avoid collisions with app data.
 *
 * We automatically (see storage.js) create two such wrappers, one for sessionStorage,
 * and one for localStorage.
 *
 */ class $30d3a405033775a4$var$DOMStorageWrapper {
    /**
     * @param key - The key to save the value under
     * @param value - The value being stored, or null to remove the key.
     */ set(key, value) {
        if (value == null) this.domStorage_.removeItem(this.prefixedName_(key));
        else this.domStorage_.setItem(this.prefixedName_(key), (0, $f43ebbd33d4c5d93$export$fac44ee5b035f737)(value));
    }
    /**
     * @returns The value that was stored under this key, or null
     */ get(key) {
        const storedVal = this.domStorage_.getItem(this.prefixedName_(key));
        if (storedVal == null) return null;
        else return (0, $f43ebbd33d4c5d93$export$c5a53ce6a17cf18d)(storedVal);
    }
    remove(key) {
        this.domStorage_.removeItem(this.prefixedName_(key));
    }
    prefixedName_(name) {
        return this.prefix_ + name;
    }
    toString() {
        return this.domStorage_.toString();
    }
    /**
     * @param domStorage_ - The underlying storage object (e.g. localStorage or sessionStorage)
     */ constructor(domStorage_){
        this.domStorage_ = domStorage_;
        // Use a prefix to avoid collisions with other stuff saved by the app.
        this.prefix_ = "firebase:";
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An in-memory storage implementation that matches the API of DOMStorageWrapper
 * (TODO: create interface for both to implement).
 */ class $30d3a405033775a4$var$MemoryStorage {
    set(key, value) {
        if (value == null) delete this.cache_[key];
        else this.cache_[key] = value;
    }
    get(key) {
        if ((0, $f43ebbd33d4c5d93$export$2344b14b097df817)(this.cache_, key)) return this.cache_[key];
        return null;
    }
    remove(key) {
        delete this.cache_[key];
    }
    constructor(){
        this.cache_ = {};
        this.isInMemoryStorage = true;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Helper to create a DOMStorageWrapper or else fall back to MemoryStorage.
 * TODO: Once MemoryStorage and DOMStorageWrapper have a shared interface this method annotation should change
 * to reflect this type
 *
 * @param domStorageName - Name of the underlying storage object
 *   (e.g. 'localStorage' or 'sessionStorage').
 * @returns Turning off type information until a common interface is defined.
 */ const $30d3a405033775a4$var$createStoragefor = function(domStorageName) {
    try {
        // NOTE: just accessing "localStorage" or "window['localStorage']" may throw a security exception,
        // so it must be inside the try/catch.
        if (typeof window !== "undefined" && typeof window[domStorageName] !== "undefined") {
            // Need to test cache. Just because it's here doesn't mean it works
            const domStorage = window[domStorageName];
            domStorage.setItem("firebase:sentinel", "cache");
            domStorage.removeItem("firebase:sentinel");
            return new $30d3a405033775a4$var$DOMStorageWrapper(domStorage);
        }
    } catch (e) {}
    // Failed to create wrapper.  Just return in-memory storage.
    // TODO: log?
    return new $30d3a405033775a4$var$MemoryStorage();
};
/** A storage object that lasts across sessions */ const $30d3a405033775a4$var$PersistentStorage = $30d3a405033775a4$var$createStoragefor("localStorage");
/** A storage object that only lasts one session */ const $30d3a405033775a4$var$SessionStorage = $30d3a405033775a4$var$createStoragefor("sessionStorage");
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $30d3a405033775a4$var$logClient = new (0, $a1112fe19640197d$export$efa9a398d6368992)("@firebase/database");
/**
 * Returns a locally-unique ID (generated by just incrementing up from 0 each time its called).
 */ const $30d3a405033775a4$var$LUIDGenerator = function() {
    let id = 1;
    return function() {
        return id++;
    };
}();
/**
 * Sha1 hash of the input string
 * @param str - The string to hash
 * @returns {!string} The resulting hash
 */ const $30d3a405033775a4$var$sha1 = function(str) {
    const utf8Bytes = (0, $f43ebbd33d4c5d93$export$655666783217a925)(str);
    const sha1 = new (0, $f43ebbd33d4c5d93$export$c85d589bf4e25fef)();
    sha1.update(utf8Bytes);
    const sha1Bytes = sha1.digest();
    return (0, $f43ebbd33d4c5d93$export$b3b2de96497acc47).encodeByteArray(sha1Bytes);
};
const $30d3a405033775a4$var$buildLogMessage_ = function(...varArgs) {
    let message = "";
    for(let i = 0; i < varArgs.length; i++){
        const arg = varArgs[i];
        if (Array.isArray(arg) || arg && typeof arg === "object" && // eslint-disable-next-line @typescript-eslint/no-explicit-any
        typeof arg.length === "number") message += $30d3a405033775a4$var$buildLogMessage_.apply(null, arg);
        else if (typeof arg === "object") message += (0, $f43ebbd33d4c5d93$export$fac44ee5b035f737)(arg);
        else message += arg;
        message += " ";
    }
    return message;
};
/**
 * Use this for all debug messages in Firebase.
 */ let $30d3a405033775a4$var$logger = null;
/**
 * Flag to check for log availability on first log message
 */ let $30d3a405033775a4$var$firstLog_ = true;
/**
 * The implementation of Firebase.enableLogging (defined here to break dependencies)
 * @param logger_ - A flag to turn on logging, or a custom logger
 * @param persistent - Whether or not to persist logging settings across refreshes
 */ const $30d3a405033775a4$var$enableLogging$1 = function(logger_, persistent) {
    (0, $f43ebbd33d4c5d93$export$a7a9523472993e97)(!persistent || logger_ === true || logger_ === false, "Can't turn on custom loggers persistently.");
    if (logger_ === true) {
        $30d3a405033775a4$var$logClient.logLevel = (0, $a1112fe19640197d$export$243e62d78d3b544d).VERBOSE;
        $30d3a405033775a4$var$logger = $30d3a405033775a4$var$logClient.log.bind($30d3a405033775a4$var$logClient);
        if (persistent) $30d3a405033775a4$var$SessionStorage.set("logging_enabled", true);
    } else if (typeof logger_ === "function") $30d3a405033775a4$var$logger = logger_;
    else {
        $30d3a405033775a4$var$logger = null;
        $30d3a405033775a4$var$SessionStorage.remove("logging_enabled");
    }
};
const $30d3a405033775a4$var$log = function(...varArgs) {
    if ($30d3a405033775a4$var$firstLog_ === true) {
        $30d3a405033775a4$var$firstLog_ = false;
        if ($30d3a405033775a4$var$logger === null && $30d3a405033775a4$var$SessionStorage.get("logging_enabled") === true) $30d3a405033775a4$var$enableLogging$1(true);
    }
    if ($30d3a405033775a4$var$logger) {
        const message = $30d3a405033775a4$var$buildLogMessage_.apply(null, varArgs);
        $30d3a405033775a4$var$logger(message);
    }
};
const $30d3a405033775a4$var$logWrapper = function(prefix) {
    return function(...varArgs) {
        $30d3a405033775a4$var$log(prefix, ...varArgs);
    };
};
const $30d3a405033775a4$var$error = function(...varArgs) {
    const message = "FIREBASE INTERNAL ERROR: " + $30d3a405033775a4$var$buildLogMessage_(...varArgs);
    $30d3a405033775a4$var$logClient.error(message);
};
const $30d3a405033775a4$var$fatal = function(...varArgs) {
    const message = `FIREBASE FATAL ERROR: ${$30d3a405033775a4$var$buildLogMessage_(...varArgs)}`;
    $30d3a405033775a4$var$logClient.error(message);
    throw new Error(message);
};
const $30d3a405033775a4$var$warn = function(...varArgs) {
    const message = "FIREBASE WARNING: " + $30d3a405033775a4$var$buildLogMessage_(...varArgs);
    $30d3a405033775a4$var$logClient.warn(message);
};
/**
 * Logs a warning if the containing page uses https. Called when a call to new Firebase
 * does not use https.
 */ const $30d3a405033775a4$var$warnIfPageIsSecure = function() {
    // Be very careful accessing browser globals. Who knows what may or may not exist.
    if (typeof window !== "undefined" && window.location && window.location.protocol && window.location.protocol.indexOf("https:") !== -1) $30d3a405033775a4$var$warn("Insecure Firebase access from a secure page. Please use https in calls to new Firebase().");
};
/**
 * Returns true if data is NaN, or +/- Infinity.
 */ const $30d3a405033775a4$var$isInvalidJSONNumber = function(data) {
    return typeof data === "number" && (data !== data || // NaN
    data === Number.POSITIVE_INFINITY || data === Number.NEGATIVE_INFINITY);
};
const $30d3a405033775a4$var$executeWhenDOMReady = function(fn) {
    if ((0, $f43ebbd33d4c5d93$export$5d1d834fbbf8bab7)() || document.readyState === "complete") fn();
    else {
        // Modeled after jQuery. Try DOMContentLoaded and onreadystatechange (which
        // fire before onload), but fall back to onload.
        let called = false;
        const wrappedFn = function() {
            if (!document.body) {
                setTimeout(wrappedFn, Math.floor(10));
                return;
            }
            if (!called) {
                called = true;
                fn();
            }
        };
        if (document.addEventListener) {
            document.addEventListener("DOMContentLoaded", wrappedFn, false);
            // fallback to onload.
            window.addEventListener("load", wrappedFn, false);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } else if (document.attachEvent) {
            // IE.
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            document.attachEvent("onreadystatechange", ()=>{
                if (document.readyState === "complete") wrappedFn();
            });
            // fallback to onload.
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            window.attachEvent("onload", wrappedFn);
        // jQuery has an extra hack for IE that we could employ (based on
        // http://javascript.nwbox.com/IEContentLoaded/) But it looks really old.
        // I'm hoping we don't need it.
        }
    }
};
/**
 * Minimum key name. Invalid for actual data, used as a marker to sort before any valid names
 */ const $30d3a405033775a4$var$MIN_NAME = "[MIN_NAME]";
/**
 * Maximum key name. Invalid for actual data, used as a marker to sort above any valid names
 */ const $30d3a405033775a4$var$MAX_NAME = "[MAX_NAME]";
/**
 * Compares valid Firebase key names, plus min and max name
 */ const $30d3a405033775a4$var$nameCompare = function(a, b) {
    if (a === b) return 0;
    else if (a === $30d3a405033775a4$var$MIN_NAME || b === $30d3a405033775a4$var$MAX_NAME) return -1;
    else if (b === $30d3a405033775a4$var$MIN_NAME || a === $30d3a405033775a4$var$MAX_NAME) return 1;
    else {
        const aAsInt = $30d3a405033775a4$var$tryParseInt(a), bAsInt = $30d3a405033775a4$var$tryParseInt(b);
        if (aAsInt !== null) {
            if (bAsInt !== null) return aAsInt - bAsInt === 0 ? a.length - b.length : aAsInt - bAsInt;
            else return -1;
        } else if (bAsInt !== null) return 1;
        else return a < b ? -1 : 1;
    }
};
/**
 * @returns {!number} comparison result.
 */ const $30d3a405033775a4$var$stringCompare = function(a, b) {
    if (a === b) return 0;
    else if (a < b) return -1;
    else return 1;
};
const $30d3a405033775a4$var$requireKey = function(key, obj) {
    if (obj && key in obj) return obj[key];
    else throw new Error("Missing required key (" + key + ") in object: " + (0, $f43ebbd33d4c5d93$export$fac44ee5b035f737)(obj));
};
const $30d3a405033775a4$var$ObjectToUniqueKey = function(obj) {
    if (typeof obj !== "object" || obj === null) return (0, $f43ebbd33d4c5d93$export$fac44ee5b035f737)(obj);
    const keys = [];
    // eslint-disable-next-line guard-for-in
    for(const k in obj)keys.push(k);
    // Export as json, but with the keys sorted.
    keys.sort();
    let key = "{";
    for(let i = 0; i < keys.length; i++){
        if (i !== 0) key += ",";
        key += (0, $f43ebbd33d4c5d93$export$fac44ee5b035f737)(keys[i]);
        key += ":";
        key += $30d3a405033775a4$var$ObjectToUniqueKey(obj[keys[i]]);
    }
    key += "}";
    return key;
};
/**
 * Splits a string into a number of smaller segments of maximum size
 * @param str - The string
 * @param segsize - The maximum number of chars in the string.
 * @returns The string, split into appropriately-sized chunks
 */ const $30d3a405033775a4$var$splitStringBySize = function(str, segsize) {
    const len = str.length;
    if (len <= segsize) return [
        str
    ];
    const dataSegs = [];
    for(let c = 0; c < len; c += segsize)if (c + segsize > len) dataSegs.push(str.substring(c, len));
    else dataSegs.push(str.substring(c, c + segsize));
    return dataSegs;
};
/**
 * Apply a function to each (key, value) pair in an object or
 * apply a function to each (index, value) pair in an array
 * @param obj - The object or array to iterate over
 * @param fn - The function to apply
 */ function $30d3a405033775a4$var$each(obj, fn) {
    for(const key in obj)if (obj.hasOwnProperty(key)) fn(key, obj[key]);
}
/**
 * Borrowed from http://hg.secondlife.com/llsd/src/tip/js/typedarray.js (MIT License)
 * I made one modification at the end and removed the NaN / Infinity
 * handling (since it seemed broken [caused an overflow] and we don't need it).  See MJL comments.
 * @param v - A double
 *
 */ const $30d3a405033775a4$var$doubleToIEEE754String = function(v) {
    (0, $f43ebbd33d4c5d93$export$a7a9523472993e97)(!$30d3a405033775a4$var$isInvalidJSONNumber(v), "Invalid JSON number"); // MJL
    const ebits = 11, fbits = 52;
    const bias = (1 << ebits - 1) - 1;
    let s, e, f, ln, i;
    // Compute sign, exponent, fraction
    // Skip NaN / Infinity handling --MJL.
    if (v === 0) {
        e = 0;
        f = 0;
        s = 1 / v === -Infinity ? 1 : 0;
    } else {
        s = v < 0;
        v = Math.abs(v);
        if (v >= Math.pow(2, 1 - bias)) {
            // Normalized
            ln = Math.min(Math.floor(Math.log(v) / Math.LN2), bias);
            e = ln + bias;
            f = Math.round(v * Math.pow(2, fbits - ln) - Math.pow(2, fbits));
        } else {
            // Denormalized
            e = 0;
            f = Math.round(v / Math.pow(2, 1 - bias - fbits));
        }
    }
    // Pack sign, exponent, fraction
    const bits = [];
    for(i = fbits; i; i -= 1){
        bits.push(f % 2 ? 1 : 0);
        f = Math.floor(f / 2);
    }
    for(i = ebits; i; i -= 1){
        bits.push(e % 2 ? 1 : 0);
        e = Math.floor(e / 2);
    }
    bits.push(s ? 1 : 0);
    bits.reverse();
    const str = bits.join("");
    // Return the data as a hex string. --MJL
    let hexByteString = "";
    for(i = 0; i < 64; i += 8){
        let hexByte = parseInt(str.substr(i, 8), 2).toString(16);
        if (hexByte.length === 1) hexByte = "0" + hexByte;
        hexByteString = hexByteString + hexByte;
    }
    return hexByteString.toLowerCase();
};
/**
 * Used to detect if we're in a Chrome content script (which executes in an
 * isolated environment where long-polling doesn't work).
 */ const $30d3a405033775a4$var$isChromeExtensionContentScript = function() {
    return !!(typeof window === "object" && window["chrome"] && window["chrome"]["extension"] && !/^chrome/.test(window.location.href));
};
/**
 * Used to detect if we're in a Windows 8 Store app.
 */ const $30d3a405033775a4$var$isWindowsStoreApp = function() {
    // Check for the presence of a couple WinRT globals
    return typeof Windows === "object" && typeof Windows.UI === "object";
};
/**
 * Converts a server error code to a Javascript Error
 */ function $30d3a405033775a4$var$errorForServerCode(code, query) {
    let reason = "Unknown Error";
    if (code === "too_big") reason = "The data requested exceeds the maximum size that can be accessed with a single request.";
    else if (code === "permission_denied") reason = "Client doesn't have permission to access the desired data.";
    else if (code === "unavailable") reason = "The service is unavailable";
    const error = new Error(code + " at " + query._path.toString() + ": " + reason);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    error.code = code.toUpperCase();
    return error;
}
/**
 * Used to test for integer-looking strings
 */ const $30d3a405033775a4$var$INTEGER_REGEXP_ = new RegExp("^-?(0*)\\d{1,10}$");
/**
 * For use in keys, the minimum possible 32-bit integer.
 */ const $30d3a405033775a4$var$INTEGER_32_MIN = -2147483648;
/**
 * For use in kyes, the maximum possible 32-bit integer.
 */ const $30d3a405033775a4$var$INTEGER_32_MAX = 2147483647;
/**
 * If the string contains a 32-bit integer, return it.  Else return null.
 */ const $30d3a405033775a4$var$tryParseInt = function(str) {
    if ($30d3a405033775a4$var$INTEGER_REGEXP_.test(str)) {
        const intVal = Number(str);
        if (intVal >= $30d3a405033775a4$var$INTEGER_32_MIN && intVal <= $30d3a405033775a4$var$INTEGER_32_MAX) return intVal;
    }
    return null;
};
/**
 * Helper to run some code but catch any exceptions and re-throw them later.
 * Useful for preventing user callbacks from breaking internal code.
 *
 * Re-throwing the exception from a setTimeout is a little evil, but it's very
 * convenient (we don't have to try to figure out when is a safe point to
 * re-throw it), and the behavior seems reasonable:
 *
 * * If you aren't pausing on exceptions, you get an error in the console with
 *   the correct stack trace.
 * * If you're pausing on all exceptions, the debugger will pause on your
 *   exception and then again when we rethrow it.
 * * If you're only pausing on uncaught exceptions, the debugger will only pause
 *   on us re-throwing it.
 *
 * @param fn - The code to guard.
 */ const $30d3a405033775a4$var$exceptionGuard = function(fn) {
    try {
        fn();
    } catch (e) {
        // Re-throw exception when it's safe.
        setTimeout(()=>{
            // It used to be that "throw e" would result in a good console error with
            // relevant context, but as of Chrome 39, you just get the firebase.js
            // file/line number where we re-throw it, which is useless. So we log
            // e.stack explicitly.
            const stack = e.stack || "";
            $30d3a405033775a4$var$warn("Exception was thrown by user callback.", stack);
            throw e;
        }, Math.floor(0));
    }
};
/**
 * @returns {boolean} true if we think we're currently being crawled.
 */ const $30d3a405033775a4$var$beingCrawled = function() {
    const userAgent = typeof window === "object" && window["navigator"] && window["navigator"]["userAgent"] || "";
    // For now we whitelist the most popular crawlers.  We should refine this to be the set of crawlers we
    // believe to support JavaScript/AJAX rendering.
    // NOTE: Google Webmaster Tools doesn't really belong, but their "This is how a visitor to your website
    // would have seen the page" is flaky if we don't treat it as a crawler.
    return userAgent.search(/googlebot|google webmaster tools|bingbot|yahoo! slurp|baiduspider|yandexbot|duckduckbot/i) >= 0;
};
/**
 * Same as setTimeout() except on Node.JS it will /not/ prevent the process from exiting.
 *
 * It is removed with clearTimeout() as normal.
 *
 * @param fn - Function to run.
 * @param time - Milliseconds to wait before running.
 * @returns The setTimeout() return value.
 */ const $30d3a405033775a4$var$setTimeoutNonBlocking = function(fn, time) {
    const timeout = setTimeout(fn, time);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if (typeof timeout === "object" && timeout["unref"]) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    timeout["unref"]();
    return timeout;
};
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Abstraction around AppCheck's token fetching capabilities.
 */ class $30d3a405033775a4$var$AppCheckTokenProvider {
    getToken(forceRefresh) {
        if (!this.appCheck) return new Promise((resolve, reject)=>{
            // Support delayed initialization of FirebaseAppCheck. This allows our
            // customers to initialize the RTDB SDK before initializing Firebase
            // AppCheck and ensures that all requests are authenticated if a token
            // becomes available before the timoeout below expires.
            setTimeout(()=>{
                if (this.appCheck) this.getToken(forceRefresh).then(resolve, reject);
                else resolve(null);
            }, 0);
        });
        return this.appCheck.getToken(forceRefresh);
    }
    addTokenChangeListener(listener) {
        var _a;
        (_a = this.appCheckProvider) === null || _a === void 0 || _a.get().then((appCheck)=>appCheck.addTokenListener(listener));
    }
    notifyForInvalidToken() {
        $30d3a405033775a4$var$warn(`Provided AppCheck credentials for the app named "${this.appName_}" ` + "are invalid. This usually indicates your app was not initialized correctly.");
    }
    constructor(appName_, appCheckProvider){
        this.appName_ = appName_;
        this.appCheckProvider = appCheckProvider;
        this.appCheck = appCheckProvider === null || appCheckProvider === void 0 ? void 0 : appCheckProvider.getImmediate({
            optional: true
        });
        if (!this.appCheck) appCheckProvider === null || appCheckProvider === void 0 || appCheckProvider.get().then((appCheck)=>this.appCheck = appCheck);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Abstraction around FirebaseApp's token fetching capabilities.
 */ class $30d3a405033775a4$var$FirebaseAuthTokenProvider {
    getToken(forceRefresh) {
        if (!this.auth_) return new Promise((resolve, reject)=>{
            // Support delayed initialization of FirebaseAuth. This allows our
            // customers to initialize the RTDB SDK before initializing Firebase
            // Auth and ensures that all requests are authenticated if a token
            // becomes available before the timoeout below expires.
            setTimeout(()=>{
                if (this.auth_) this.getToken(forceRefresh).then(resolve, reject);
                else resolve(null);
            }, 0);
        });
        return this.auth_.getToken(forceRefresh).catch((error)=>{
            // TODO: Need to figure out all the cases this is raised and whether
            // this makes sense.
            if (error && error.code === "auth/token-not-initialized") {
                $30d3a405033775a4$var$log("Got auth/token-not-initialized error.  Treating as null token.");
                return null;
            } else return Promise.reject(error);
        });
    }
    addTokenChangeListener(listener) {
        // TODO: We might want to wrap the listener and call it with no args to
        // avoid a leaky abstraction, but that makes removing the listener harder.
        if (this.auth_) this.auth_.addAuthTokenListener(listener);
        else this.authProvider_.get().then((auth)=>auth.addAuthTokenListener(listener));
    }
    removeTokenChangeListener(listener) {
        this.authProvider_.get().then((auth)=>auth.removeAuthTokenListener(listener));
    }
    notifyForInvalidToken() {
        let errorMessage = 'Provided authentication credentials for the app named "' + this.appName_ + '" are invalid. This usually indicates your app was not ' + "initialized correctly. ";
        if ("credential" in this.firebaseOptions_) errorMessage += 'Make sure the "credential" property provided to initializeApp() is authorized to access the specified "databaseURL" and is from the correct project.';
        else if ("serviceAccount" in this.firebaseOptions_) errorMessage += 'Make sure the "serviceAccount" property provided to initializeApp() is authorized to access the specified "databaseURL" and is from the correct project.';
        else errorMessage += 'Make sure the "apiKey" and "databaseURL" properties provided to initializeApp() match the values provided for your app at https://console.firebase.google.com/.';
        $30d3a405033775a4$var$warn(errorMessage);
    }
    constructor(appName_, firebaseOptions_, authProvider_){
        this.appName_ = appName_;
        this.firebaseOptions_ = firebaseOptions_;
        this.authProvider_ = authProvider_;
        this.auth_ = null;
        this.auth_ = authProvider_.getImmediate({
            optional: true
        });
        if (!this.auth_) authProvider_.onInit((auth)=>this.auth_ = auth);
    }
}
/* AuthTokenProvider that supplies a constant token. Used by Admin SDK or mockUserToken with emulators. */ class $30d3a405033775a4$var$EmulatorTokenProvider {
    getToken(forceRefresh) {
        return Promise.resolve({
            accessToken: this.accessToken
        });
    }
    addTokenChangeListener(listener) {
        // Invoke the listener immediately to match the behavior in Firebase Auth
        // (see packages/auth/src/auth.js#L1807)
        listener(this.accessToken);
    }
    removeTokenChangeListener(listener) {}
    notifyForInvalidToken() {}
    constructor(accessToken){
        this.accessToken = accessToken;
    }
}
/** A string that is treated as an admin access token by the RTDB emulator. Used by Admin SDK. */ $30d3a405033775a4$var$EmulatorTokenProvider.OWNER = "owner";
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $30d3a405033775a4$var$PROTOCOL_VERSION = "5";
const $30d3a405033775a4$var$VERSION_PARAM = "v";
const $30d3a405033775a4$var$TRANSPORT_SESSION_PARAM = "s";
const $30d3a405033775a4$var$REFERER_PARAM = "r";
const $30d3a405033775a4$var$FORGE_REF = "f";
// Matches console.firebase.google.com, firebase-console-*.corp.google.com and
// firebase.corp.google.com
const $30d3a405033775a4$var$FORGE_DOMAIN_RE = /(console\.firebase|firebase-console-\w+\.corp|firebase\.corp)\.google\.com/;
const $30d3a405033775a4$var$LAST_SESSION_PARAM = "ls";
const $30d3a405033775a4$var$APPLICATION_ID_PARAM = "p";
const $30d3a405033775a4$var$APP_CHECK_TOKEN_PARAM = "ac";
const $30d3a405033775a4$var$WEBSOCKET = "websocket";
const $30d3a405033775a4$var$LONG_POLLING = "long_polling";
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A class that holds metadata about a Repo object
 */ class $30d3a405033775a4$var$RepoInfo {
    isCacheableHost() {
        return this.internalHost.substr(0, 2) === "s-";
    }
    isCustomHost() {
        return this._domain !== "firebaseio.com" && this._domain !== "firebaseio-demo.com";
    }
    get host() {
        return this._host;
    }
    set host(newHost) {
        if (newHost !== this.internalHost) {
            this.internalHost = newHost;
            if (this.isCacheableHost()) $30d3a405033775a4$var$PersistentStorage.set("host:" + this._host, this.internalHost);
        }
    }
    toString() {
        let str = this.toURLString();
        if (this.persistenceKey) str += "<" + this.persistenceKey + ">";
        return str;
    }
    toURLString() {
        const protocol = this.secure ? "https://" : "http://";
        const query = this.includeNamespaceInQueryParams ? `?ns=${this.namespace}` : "";
        return `${protocol}${this.host}/${query}`;
    }
    /**
     * @param host - Hostname portion of the url for the repo
     * @param secure - Whether or not this repo is accessed over ssl
     * @param namespace - The namespace represented by the repo
     * @param webSocketOnly - Whether to prefer websockets over all other transports (used by Nest).
     * @param nodeAdmin - Whether this instance uses Admin SDK credentials
     * @param persistenceKey - Override the default session persistence storage key
     */ constructor(host, secure, namespace, webSocketOnly, nodeAdmin = false, persistenceKey = "", includeNamespaceInQueryParams = false){
        this.secure = secure;
        this.namespace = namespace;
        this.webSocketOnly = webSocketOnly;
        this.nodeAdmin = nodeAdmin;
        this.persistenceKey = persistenceKey;
        this.includeNamespaceInQueryParams = includeNamespaceInQueryParams;
        this._host = host.toLowerCase();
        this._domain = this._host.substr(this._host.indexOf(".") + 1);
        this.internalHost = $30d3a405033775a4$var$PersistentStorage.get("host:" + host) || this._host;
    }
}
function $30d3a405033775a4$var$repoInfoNeedsQueryParam(repoInfo) {
    return repoInfo.host !== repoInfo.internalHost || repoInfo.isCustomHost() || repoInfo.includeNamespaceInQueryParams;
}
/**
 * Returns the websocket URL for this repo
 * @param repoInfo - RepoInfo object
 * @param type - of connection
 * @param params - list
 * @returns The URL for this repo
 */ function $30d3a405033775a4$var$repoInfoConnectionURL(repoInfo, type, params) {
    (0, $f43ebbd33d4c5d93$export$a7a9523472993e97)(typeof type === "string", "typeof type must == string");
    (0, $f43ebbd33d4c5d93$export$a7a9523472993e97)(typeof params === "object", "typeof params must == object");
    let connURL;
    if (type === $30d3a405033775a4$var$WEBSOCKET) connURL = (repoInfo.secure ? "wss://" : "ws://") + repoInfo.internalHost + "/.ws?";
    else if (type === $30d3a405033775a4$var$LONG_POLLING) connURL = (repoInfo.secure ? "https://" : "http://") + repoInfo.internalHost + "/.lp?";
    else throw new Error("Unknown connection type: " + type);
    if ($30d3a405033775a4$var$repoInfoNeedsQueryParam(repoInfo)) params["ns"] = repoInfo.namespace;
    const pairs = [];
    $30d3a405033775a4$var$each(params, (key, value)=>{
        pairs.push(key + "=" + value);
    });
    return connURL + pairs.join("&");
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Tracks a collection of stats.
 */ class $30d3a405033775a4$var$StatsCollection {
    incrementCounter(name, amount = 1) {
        if (!(0, $f43ebbd33d4c5d93$export$2344b14b097df817)(this.counters_, name)) this.counters_[name] = 0;
        this.counters_[name] += amount;
    }
    get() {
        return (0, $f43ebbd33d4c5d93$export$6c40052bed430212)(this.counters_);
    }
    constructor(){
        this.counters_ = {};
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $30d3a405033775a4$var$collections = {};
const $30d3a405033775a4$var$reporters = {};
function $30d3a405033775a4$var$statsManagerGetCollection(repoInfo) {
    const hashString = repoInfo.toString();
    if (!$30d3a405033775a4$var$collections[hashString]) $30d3a405033775a4$var$collections[hashString] = new $30d3a405033775a4$var$StatsCollection();
    return $30d3a405033775a4$var$collections[hashString];
}
function $30d3a405033775a4$var$statsManagerGetOrCreateReporter(repoInfo, creatorFunction) {
    const hashString = repoInfo.toString();
    if (!$30d3a405033775a4$var$reporters[hashString]) $30d3a405033775a4$var$reporters[hashString] = creatorFunction();
    return $30d3a405033775a4$var$reporters[hashString];
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * This class ensures the packets from the server arrive in order
 * This class takes data from the server and ensures it gets passed into the callbacks in order.
 */ class $30d3a405033775a4$var$PacketReceiver {
    closeAfter(responseNum, callback) {
        this.closeAfterResponse = responseNum;
        this.onClose = callback;
        if (this.closeAfterResponse < this.currentResponseNum) {
            this.onClose();
            this.onClose = null;
        }
    }
    /**
     * Each message from the server comes with a response number, and an array of data. The responseNumber
     * allows us to ensure that we process them in the right order, since we can't be guaranteed that all
     * browsers will respond in the same order as the requests we sent
     */ handleResponse(requestNum, data) {
        this.pendingResponses[requestNum] = data;
        while(this.pendingResponses[this.currentResponseNum]){
            const toProcess = this.pendingResponses[this.currentResponseNum];
            delete this.pendingResponses[this.currentResponseNum];
            for(let i = 0; i < toProcess.length; ++i)if (toProcess[i]) $30d3a405033775a4$var$exceptionGuard(()=>{
                this.onMessage_(toProcess[i]);
            });
            if (this.currentResponseNum === this.closeAfterResponse) {
                if (this.onClose) {
                    this.onClose();
                    this.onClose = null;
                }
                break;
            }
            this.currentResponseNum++;
        }
    }
    /**
     * @param onMessage_
     */ constructor(onMessage_){
        this.onMessage_ = onMessage_;
        this.pendingResponses = [];
        this.currentResponseNum = 0;
        this.closeAfterResponse = -1;
        this.onClose = null;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // URL query parameters associated with longpolling
const $30d3a405033775a4$var$FIREBASE_LONGPOLL_START_PARAM = "start";
const $30d3a405033775a4$var$FIREBASE_LONGPOLL_CLOSE_COMMAND = "close";
const $30d3a405033775a4$var$FIREBASE_LONGPOLL_COMMAND_CB_NAME = "pLPCommand";
const $30d3a405033775a4$var$FIREBASE_LONGPOLL_DATA_CB_NAME = "pRTLPCB";
const $30d3a405033775a4$var$FIREBASE_LONGPOLL_ID_PARAM = "id";
const $30d3a405033775a4$var$FIREBASE_LONGPOLL_PW_PARAM = "pw";
const $30d3a405033775a4$var$FIREBASE_LONGPOLL_SERIAL_PARAM = "ser";
const $30d3a405033775a4$var$FIREBASE_LONGPOLL_CALLBACK_ID_PARAM = "cb";
const $30d3a405033775a4$var$FIREBASE_LONGPOLL_SEGMENT_NUM_PARAM = "seg";
const $30d3a405033775a4$var$FIREBASE_LONGPOLL_SEGMENTS_IN_PACKET = "ts";
const $30d3a405033775a4$var$FIREBASE_LONGPOLL_DATA_PARAM = "d";
const $30d3a405033775a4$var$FIREBASE_LONGPOLL_DISCONN_FRAME_REQUEST_PARAM = "dframe";
//Data size constants.
//TODO: Perf: the maximum length actually differs from browser to browser.
// We should check what browser we're on and set accordingly.
const $30d3a405033775a4$var$MAX_URL_DATA_SIZE = 1870;
const $30d3a405033775a4$var$SEG_HEADER_SIZE = 30; //ie: &seg=8299234&ts=982389123&d=
const $30d3a405033775a4$var$MAX_PAYLOAD_SIZE = $30d3a405033775a4$var$MAX_URL_DATA_SIZE - $30d3a405033775a4$var$SEG_HEADER_SIZE;
/**
 * Keepalive period
 * send a fresh request at minimum every 25 seconds. Opera has a maximum request
 * length of 30 seconds that we can't exceed.
 */ const $30d3a405033775a4$var$KEEPALIVE_REQUEST_INTERVAL = 25000;
/**
 * How long to wait before aborting a long-polling connection attempt.
 */ const $30d3a405033775a4$var$LP_CONNECT_TIMEOUT = 30000;
/**
 * This class manages a single long-polling connection.
 */ class $30d3a405033775a4$var$BrowserPollConnection {
    /**
     * @param onMessage - Callback when messages arrive
     * @param onDisconnect - Callback with connection lost.
     */ open(onMessage, onDisconnect) {
        this.curSegmentNum = 0;
        this.onDisconnect_ = onDisconnect;
        this.myPacketOrderer = new $30d3a405033775a4$var$PacketReceiver(onMessage);
        this.isClosed_ = false;
        this.connectTimeoutTimer_ = setTimeout(()=>{
            this.log_("Timed out trying to connect.");
            // Make sure we clear the host cache
            this.onClosed_();
            this.connectTimeoutTimer_ = null;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        }, Math.floor($30d3a405033775a4$var$LP_CONNECT_TIMEOUT));
        // Ensure we delay the creation of the iframe until the DOM is loaded.
        $30d3a405033775a4$var$executeWhenDOMReady(()=>{
            if (this.isClosed_) return;
            //Set up a callback that gets triggered once a connection is set up.
            this.scriptTagHolder = new $30d3a405033775a4$var$FirebaseIFrameScriptHolder((...args)=>{
                const [command, arg1, arg2, arg3, arg4] = args;
                this.incrementIncomingBytes_(args);
                if (!this.scriptTagHolder) return; // we closed the connection.
                if (this.connectTimeoutTimer_) {
                    clearTimeout(this.connectTimeoutTimer_);
                    this.connectTimeoutTimer_ = null;
                }
                this.everConnected_ = true;
                if (command === $30d3a405033775a4$var$FIREBASE_LONGPOLL_START_PARAM) {
                    this.id = arg1;
                    this.password = arg2;
                } else if (command === $30d3a405033775a4$var$FIREBASE_LONGPOLL_CLOSE_COMMAND) {
                    // Don't clear the host cache. We got a response from the server, so we know it's reachable
                    if (arg1) {
                        // We aren't expecting any more data (other than what the server's already in the process of sending us
                        // through our already open polls), so don't send any more.
                        this.scriptTagHolder.sendNewPolls = false;
                        // arg1 in this case is the last response number sent by the server. We should try to receive
                        // all of the responses up to this one before closing
                        this.myPacketOrderer.closeAfter(arg1, ()=>{
                            this.onClosed_();
                        });
                    } else this.onClosed_();
                } else throw new Error("Unrecognized command received: " + command);
            }, (...args)=>{
                const [pN, data] = args;
                this.incrementIncomingBytes_(args);
                this.myPacketOrderer.handleResponse(pN, data);
            }, ()=>{
                this.onClosed_();
            }, this.urlFn);
            //Send the initial request to connect. The serial number is simply to keep the browser from pulling previous results
            //from cache.
            const urlParams = {};
            urlParams[$30d3a405033775a4$var$FIREBASE_LONGPOLL_START_PARAM] = "t";
            urlParams[$30d3a405033775a4$var$FIREBASE_LONGPOLL_SERIAL_PARAM] = Math.floor(Math.random() * 100000000);
            if (this.scriptTagHolder.uniqueCallbackIdentifier) urlParams[$30d3a405033775a4$var$FIREBASE_LONGPOLL_CALLBACK_ID_PARAM] = this.scriptTagHolder.uniqueCallbackIdentifier;
            urlParams[$30d3a405033775a4$var$VERSION_PARAM] = $30d3a405033775a4$var$PROTOCOL_VERSION;
            if (this.transportSessionId) urlParams[$30d3a405033775a4$var$TRANSPORT_SESSION_PARAM] = this.transportSessionId;
            if (this.lastSessionId) urlParams[$30d3a405033775a4$var$LAST_SESSION_PARAM] = this.lastSessionId;
            if (this.applicationId) urlParams[$30d3a405033775a4$var$APPLICATION_ID_PARAM] = this.applicationId;
            if (this.appCheckToken) urlParams[$30d3a405033775a4$var$APP_CHECK_TOKEN_PARAM] = this.appCheckToken;
            if (typeof location !== "undefined" && location.hostname && $30d3a405033775a4$var$FORGE_DOMAIN_RE.test(location.hostname)) urlParams[$30d3a405033775a4$var$REFERER_PARAM] = $30d3a405033775a4$var$FORGE_REF;
            const connectURL = this.urlFn(urlParams);
            this.log_("Connecting via long-poll to " + connectURL);
            this.scriptTagHolder.addTag(connectURL, ()=>{
            /* do nothing */ });
        });
    }
    /**
     * Call this when a handshake has completed successfully and we want to consider the connection established
     */ start() {
        this.scriptTagHolder.startLongPoll(this.id, this.password);
        this.addDisconnectPingFrame(this.id, this.password);
    }
    /**
     * Forces long polling to be considered as a potential transport
     */ static forceAllow() {
        $30d3a405033775a4$var$BrowserPollConnection.forceAllow_ = true;
    }
    /**
     * Forces longpolling to not be considered as a potential transport
     */ static forceDisallow() {
        $30d3a405033775a4$var$BrowserPollConnection.forceDisallow_ = true;
    }
    // Static method, use string literal so it can be accessed in a generic way
    static isAvailable() {
        if ((0, $f43ebbd33d4c5d93$export$5d1d834fbbf8bab7)()) return false;
        else if ($30d3a405033775a4$var$BrowserPollConnection.forceAllow_) return true;
        else // NOTE: In React-Native there's normally no 'document', but if you debug a React-Native app in
        // the Chrome debugger, 'document' is defined, but document.createElement is null (2015/06/08).
        return !$30d3a405033775a4$var$BrowserPollConnection.forceDisallow_ && typeof document !== "undefined" && document.createElement != null && !$30d3a405033775a4$var$isChromeExtensionContentScript() && !$30d3a405033775a4$var$isWindowsStoreApp();
    }
    /**
     * No-op for polling
     */ markConnectionHealthy() {}
    /**
     * Stops polling and cleans up the iframe
     */ shutdown_() {
        this.isClosed_ = true;
        if (this.scriptTagHolder) {
            this.scriptTagHolder.close();
            this.scriptTagHolder = null;
        }
        //remove the disconnect frame, which will trigger an XHR call to the server to tell it we're leaving.
        if (this.myDisconnFrame) {
            document.body.removeChild(this.myDisconnFrame);
            this.myDisconnFrame = null;
        }
        if (this.connectTimeoutTimer_) {
            clearTimeout(this.connectTimeoutTimer_);
            this.connectTimeoutTimer_ = null;
        }
    }
    /**
     * Triggered when this transport is closed
     */ onClosed_() {
        if (!this.isClosed_) {
            this.log_("Longpoll is closing itself");
            this.shutdown_();
            if (this.onDisconnect_) {
                this.onDisconnect_(this.everConnected_);
                this.onDisconnect_ = null;
            }
        }
    }
    /**
     * External-facing close handler. RealTime has requested we shut down. Kill our connection and tell the server
     * that we've left.
     */ close() {
        if (!this.isClosed_) {
            this.log_("Longpoll is being closed.");
            this.shutdown_();
        }
    }
    /**
     * Send the JSON object down to the server. It will need to be stringified, base64 encoded, and then
     * broken into chunks (since URLs have a small maximum length).
     * @param data - The JSON data to transmit.
     */ send(data) {
        const dataStr = (0, $f43ebbd33d4c5d93$export$fac44ee5b035f737)(data);
        this.bytesSent += dataStr.length;
        this.stats_.incrementCounter("bytes_sent", dataStr.length);
        //first, lets get the base64-encoded data
        const base64data = (0, $f43ebbd33d4c5d93$export$e510a73ee562749)(dataStr);
        //We can only fit a certain amount in each URL, so we need to split this request
        //up into multiple pieces if it doesn't fit in one request.
        const dataSegs = $30d3a405033775a4$var$splitStringBySize(base64data, $30d3a405033775a4$var$MAX_PAYLOAD_SIZE);
        //Enqueue each segment for transmission. We assign each chunk a sequential ID and a total number
        //of segments so that we can reassemble the packet on the server.
        for(let i = 0; i < dataSegs.length; i++){
            this.scriptTagHolder.enqueueSegment(this.curSegmentNum, dataSegs.length, dataSegs[i]);
            this.curSegmentNum++;
        }
    }
    /**
     * This is how we notify the server that we're leaving.
     * We aren't able to send requests with DHTML on a window close event, but we can
     * trigger XHR requests in some browsers (everything but Opera basically).
     */ addDisconnectPingFrame(id, pw) {
        if ((0, $f43ebbd33d4c5d93$export$5d1d834fbbf8bab7)()) return;
        this.myDisconnFrame = document.createElement("iframe");
        const urlParams = {};
        urlParams[$30d3a405033775a4$var$FIREBASE_LONGPOLL_DISCONN_FRAME_REQUEST_PARAM] = "t";
        urlParams[$30d3a405033775a4$var$FIREBASE_LONGPOLL_ID_PARAM] = id;
        urlParams[$30d3a405033775a4$var$FIREBASE_LONGPOLL_PW_PARAM] = pw;
        this.myDisconnFrame.src = this.urlFn(urlParams);
        this.myDisconnFrame.style.display = "none";
        document.body.appendChild(this.myDisconnFrame);
    }
    /**
     * Used to track the bytes received by this client
     */ incrementIncomingBytes_(args) {
        // TODO: This is an annoying perf hit just to track the number of incoming bytes.  Maybe it should be opt-in.
        const bytesReceived = (0, $f43ebbd33d4c5d93$export$fac44ee5b035f737)(args).length;
        this.bytesReceived += bytesReceived;
        this.stats_.incrementCounter("bytes_received", bytesReceived);
    }
    /**
     * @param connId An identifier for this connection, used for logging
     * @param repoInfo The info for the endpoint to send data to.
     * @param applicationId The Firebase App ID for this project.
     * @param appCheckToken The AppCheck token for this client.
     * @param authToken The AuthToken to use for this connection.
     * @param transportSessionId Optional transportSessionid if we are
     * reconnecting for an existing transport session
     * @param lastSessionId Optional lastSessionId if the PersistentConnection has
     * already created a connection previously
     */ constructor(connId, repoInfo, applicationId, appCheckToken, authToken, transportSessionId, lastSessionId){
        this.connId = connId;
        this.repoInfo = repoInfo;
        this.applicationId = applicationId;
        this.appCheckToken = appCheckToken;
        this.authToken = authToken;
        this.transportSessionId = transportSessionId;
        this.lastSessionId = lastSessionId;
        this.bytesSent = 0;
        this.bytesReceived = 0;
        this.everConnected_ = false;
        this.log_ = $30d3a405033775a4$var$logWrapper(connId);
        this.stats_ = $30d3a405033775a4$var$statsManagerGetCollection(repoInfo);
        this.urlFn = (params)=>{
            // Always add the token if we have one.
            if (this.appCheckToken) params[$30d3a405033775a4$var$APP_CHECK_TOKEN_PARAM] = this.appCheckToken;
            return $30d3a405033775a4$var$repoInfoConnectionURL(repoInfo, $30d3a405033775a4$var$LONG_POLLING, params);
        };
    }
}
/*********************************************************************************************
 * A wrapper around an iframe that is used as a long-polling script holder.
 *********************************************************************************************/ class $30d3a405033775a4$var$FirebaseIFrameScriptHolder {
    /**
     * Each browser has its own funny way to handle iframes. Here we mush them all together into one object that I can
     * actually use.
     */ static createIFrame_() {
        const iframe = document.createElement("iframe");
        iframe.style.display = "none";
        // This is necessary in order to initialize the document inside the iframe
        if (document.body) {
            document.body.appendChild(iframe);
            try {
                // If document.domain has been modified in IE, this will throw an error, and we need to set the
                // domain of the iframe's document manually. We can do this via a javascript: url as the src attribute
                // Also note that we must do this *after* the iframe has been appended to the page. Otherwise it doesn't work.
                const a = iframe.contentWindow.document;
                if (!a) // Apologies for the log-spam, I need to do something to keep closure from optimizing out the assignment above.
                $30d3a405033775a4$var$log("No IE domain setting required");
            } catch (e) {
                const domain = document.domain;
                iframe.src = "javascript:void((function(){document.open();document.domain='" + domain + "';document.close();})())";
            }
        } else // LongPollConnection attempts to delay initialization until the document is ready, so hopefully this
        // never gets hit.
        throw "Document body has not initialized. Wait to initialize Firebase until after the document is ready.";
        // Get the document of the iframe in a browser-specific way.
        if (iframe.contentDocument) iframe.doc = iframe.contentDocument; // Firefox, Opera, Safari
        else if (iframe.contentWindow) iframe.doc = iframe.contentWindow.document; // Internet Explorer
        else if (iframe.document) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        iframe.doc = iframe.document; //others?
        return iframe;
    }
    /**
     * Cancel all outstanding queries and remove the frame.
     */ close() {
        //Mark this iframe as dead, so no new requests are sent.
        this.alive = false;
        if (this.myIFrame) {
            //We have to actually remove all of the html inside this iframe before removing it from the
            //window, or IE will continue loading and executing the script tags we've already added, which
            //can lead to some errors being thrown. Setting innerHTML seems to be the easiest way to do this.
            this.myIFrame.doc.body.innerHTML = "";
            setTimeout(()=>{
                if (this.myIFrame !== null) {
                    document.body.removeChild(this.myIFrame);
                    this.myIFrame = null;
                }
            }, Math.floor(0));
        }
        // Protect from being called recursively.
        const onDisconnect = this.onDisconnect;
        if (onDisconnect) {
            this.onDisconnect = null;
            onDisconnect();
        }
    }
    /**
     * Actually start the long-polling session by adding the first script tag(s) to the iframe.
     * @param id - The ID of this connection
     * @param pw - The password for this connection
     */ startLongPoll(id, pw) {
        this.myID = id;
        this.myPW = pw;
        this.alive = true;
        //send the initial request. If there are requests queued, make sure that we transmit as many as we are currently able to.
        while(this.newRequest_());
    }
    /**
     * This is called any time someone might want a script tag to be added. It adds a script tag when there aren't
     * too many outstanding requests and we are still alive.
     *
     * If there are outstanding packet segments to send, it sends one. If there aren't, it sends a long-poll anyways if
     * needed.
     */ newRequest_() {
        // We keep one outstanding request open all the time to receive data, but if we need to send data
        // (pendingSegs.length > 0) then we create a new request to send the data.  The server will automatically
        // close the old request.
        if (this.alive && this.sendNewPolls && this.outstandingRequests.size < (this.pendingSegs.length > 0 ? 2 : 1)) {
            //construct our url
            this.currentSerial++;
            const urlParams = {};
            urlParams[$30d3a405033775a4$var$FIREBASE_LONGPOLL_ID_PARAM] = this.myID;
            urlParams[$30d3a405033775a4$var$FIREBASE_LONGPOLL_PW_PARAM] = this.myPW;
            urlParams[$30d3a405033775a4$var$FIREBASE_LONGPOLL_SERIAL_PARAM] = this.currentSerial;
            let theURL = this.urlFn(urlParams);
            //Now add as much data as we can.
            let curDataString = "";
            let i = 0;
            while(this.pendingSegs.length > 0){
                //first, lets see if the next segment will fit.
                const nextSeg = this.pendingSegs[0];
                if (nextSeg.d.length + $30d3a405033775a4$var$SEG_HEADER_SIZE + curDataString.length <= $30d3a405033775a4$var$MAX_URL_DATA_SIZE) {
                    //great, the segment will fit. Lets append it.
                    const theSeg = this.pendingSegs.shift();
                    curDataString = curDataString + "&" + $30d3a405033775a4$var$FIREBASE_LONGPOLL_SEGMENT_NUM_PARAM + i + "=" + theSeg.seg + "&" + $30d3a405033775a4$var$FIREBASE_LONGPOLL_SEGMENTS_IN_PACKET + i + "=" + theSeg.ts + "&" + $30d3a405033775a4$var$FIREBASE_LONGPOLL_DATA_PARAM + i + "=" + theSeg.d;
                    i++;
                } else break;
            }
            theURL = theURL + curDataString;
            this.addLongPollTag_(theURL, this.currentSerial);
            return true;
        } else return false;
    }
    /**
     * Queue a packet for transmission to the server.
     * @param segnum - A sequential id for this packet segment used for reassembly
     * @param totalsegs - The total number of segments in this packet
     * @param data - The data for this segment.
     */ enqueueSegment(segnum, totalsegs, data) {
        //add this to the queue of segments to send.
        this.pendingSegs.push({
            seg: segnum,
            ts: totalsegs,
            d: data
        });
        //send the data immediately if there isn't already data being transmitted, unless
        //startLongPoll hasn't been called yet.
        if (this.alive) this.newRequest_();
    }
    /**
     * Add a script tag for a regular long-poll request.
     * @param url - The URL of the script tag.
     * @param serial - The serial number of the request.
     */ addLongPollTag_(url, serial) {
        //remember that we sent this request.
        this.outstandingRequests.add(serial);
        const doNewRequest = ()=>{
            this.outstandingRequests.delete(serial);
            this.newRequest_();
        };
        // If this request doesn't return on its own accord (by the server sending us some data), we'll
        // create a new one after the KEEPALIVE interval to make sure we always keep a fresh request open.
        const keepaliveTimeout = setTimeout(doNewRequest, Math.floor($30d3a405033775a4$var$KEEPALIVE_REQUEST_INTERVAL));
        const readyStateCB = ()=>{
            // Request completed.  Cancel the keepalive.
            clearTimeout(keepaliveTimeout);
            // Trigger a new request so we can continue receiving data.
            doNewRequest();
        };
        this.addTag(url, readyStateCB);
    }
    /**
     * Add an arbitrary script tag to the iframe.
     * @param url - The URL for the script tag source.
     * @param loadCB - A callback to be triggered once the script has loaded.
     */ addTag(url, loadCB) {
        if ((0, $f43ebbd33d4c5d93$export$5d1d834fbbf8bab7)()) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.doNodeLongPoll(url, loadCB);
        else setTimeout(()=>{
            try {
                // if we're already closed, don't add this poll
                if (!this.sendNewPolls) return;
                const newScript = this.myIFrame.doc.createElement("script");
                newScript.type = "text/javascript";
                newScript.async = true;
                newScript.src = url;
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                newScript.onload = newScript.onreadystatechange = function() {
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    const rstate = newScript.readyState;
                    if (!rstate || rstate === "loaded" || rstate === "complete") {
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        newScript.onload = newScript.onreadystatechange = null;
                        if (newScript.parentNode) newScript.parentNode.removeChild(newScript);
                        loadCB();
                    }
                };
                newScript.onerror = ()=>{
                    $30d3a405033775a4$var$log("Long-poll script failed to load: " + url);
                    this.sendNewPolls = false;
                    this.close();
                };
                this.myIFrame.doc.body.appendChild(newScript);
            } catch (e) {
            // TODO: we should make this error visible somehow
            }
        }, Math.floor(1));
    }
    /**
     * @param commandCB - The callback to be called when control commands are recevied from the server.
     * @param onMessageCB - The callback to be triggered when responses arrive from the server.
     * @param onDisconnect - The callback to be triggered when this tag holder is closed
     * @param urlFn - A function that provides the URL of the endpoint to send data to.
     */ constructor(commandCB, onMessageCB, onDisconnect, urlFn){
        this.onDisconnect = onDisconnect;
        this.urlFn = urlFn;
        //We maintain a count of all of the outstanding requests, because if we have too many active at once it can cause
        //problems in some browsers.
        this.outstandingRequests = new Set();
        //A queue of the pending segments waiting for transmission to the server.
        this.pendingSegs = [];
        //A serial number. We use this for two things:
        // 1) A way to ensure the browser doesn't cache responses to polls
        // 2) A way to make the server aware when long-polls arrive in a different order than we started them. The
        //    server needs to release both polls in this case or it will cause problems in Opera since Opera can only execute
        //    JSONP code in the order it was added to the iframe.
        this.currentSerial = Math.floor(Math.random() * 100000000);
        // This gets set to false when we're "closing down" the connection (e.g. we're switching transports but there's still
        // incoming data from the server that we're waiting for).
        this.sendNewPolls = true;
        if (!(0, $f43ebbd33d4c5d93$export$5d1d834fbbf8bab7)()) {
            //Each script holder registers a couple of uniquely named callbacks with the window. These are called from the
            //iframes where we put the long-polling script tags. We have two callbacks:
            //   1) Command Callback - Triggered for control issues, like starting a connection.
            //   2) Message Callback - Triggered when new data arrives.
            this.uniqueCallbackIdentifier = $30d3a405033775a4$var$LUIDGenerator();
            window[$30d3a405033775a4$var$FIREBASE_LONGPOLL_COMMAND_CB_NAME + this.uniqueCallbackIdentifier] = commandCB;
            window[$30d3a405033775a4$var$FIREBASE_LONGPOLL_DATA_CB_NAME + this.uniqueCallbackIdentifier] = onMessageCB;
            //Create an iframe for us to add script tags to.
            this.myIFrame = $30d3a405033775a4$var$FirebaseIFrameScriptHolder.createIFrame_();
            // Set the iframe's contents.
            let script = "";
            // if we set a javascript url, it's IE and we need to set the document domain. The javascript url is sufficient
            // for ie9, but ie8 needs to do it again in the document itself.
            if (this.myIFrame.src && this.myIFrame.src.substr(0, 11) === "javascript:") {
                const currentDomain = document.domain;
                script = '<script>document.domain="' + currentDomain + '";</script>';
            }
            const iframeContents = "<html><body>" + script + "</body></html>";
            try {
                this.myIFrame.doc.open();
                this.myIFrame.doc.write(iframeContents);
                this.myIFrame.doc.close();
            } catch (e) {
                $30d3a405033775a4$var$log("frame writing exception");
                if (e.stack) $30d3a405033775a4$var$log(e.stack);
                $30d3a405033775a4$var$log(e);
            }
        } else {
            this.commandCB = commandCB;
            this.onMessageCB = onMessageCB;
        }
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $30d3a405033775a4$var$WEBSOCKET_MAX_FRAME_SIZE = 16384;
const $30d3a405033775a4$var$WEBSOCKET_KEEPALIVE_INTERVAL = 45000;
let $30d3a405033775a4$var$WebSocketImpl = null;
if (typeof MozWebSocket !== "undefined") $30d3a405033775a4$var$WebSocketImpl = MozWebSocket;
else if (typeof WebSocket !== "undefined") $30d3a405033775a4$var$WebSocketImpl = WebSocket;
/**
 * Create a new websocket connection with the given callbacks.
 */ class $30d3a405033775a4$var$WebSocketConnection {
    /**
     * @param repoInfo - The info for the websocket endpoint.
     * @param transportSessionId - Optional transportSessionId if this is connecting to an existing transport
     *                                         session
     * @param lastSessionId - Optional lastSessionId if there was a previous connection
     * @returns connection url
     */ static connectionURL_(repoInfo, transportSessionId, lastSessionId, appCheckToken, applicationId) {
        const urlParams = {};
        urlParams[$30d3a405033775a4$var$VERSION_PARAM] = $30d3a405033775a4$var$PROTOCOL_VERSION;
        if (!(0, $f43ebbd33d4c5d93$export$5d1d834fbbf8bab7)() && typeof location !== "undefined" && location.hostname && $30d3a405033775a4$var$FORGE_DOMAIN_RE.test(location.hostname)) urlParams[$30d3a405033775a4$var$REFERER_PARAM] = $30d3a405033775a4$var$FORGE_REF;
        if (transportSessionId) urlParams[$30d3a405033775a4$var$TRANSPORT_SESSION_PARAM] = transportSessionId;
        if (lastSessionId) urlParams[$30d3a405033775a4$var$LAST_SESSION_PARAM] = lastSessionId;
        if (appCheckToken) urlParams[$30d3a405033775a4$var$APP_CHECK_TOKEN_PARAM] = appCheckToken;
        if (applicationId) urlParams[$30d3a405033775a4$var$APPLICATION_ID_PARAM] = applicationId;
        return $30d3a405033775a4$var$repoInfoConnectionURL(repoInfo, $30d3a405033775a4$var$WEBSOCKET, urlParams);
    }
    /**
     * @param onMessage - Callback when messages arrive
     * @param onDisconnect - Callback with connection lost.
     */ open(onMessage, onDisconnect) {
        this.onDisconnect = onDisconnect;
        this.onMessage = onMessage;
        this.log_("Websocket connecting to " + this.connURL);
        this.everConnected_ = false;
        // Assume failure until proven otherwise.
        $30d3a405033775a4$var$PersistentStorage.set("previous_websocket_failure", true);
        try {
            let options;
            if ((0, $f43ebbd33d4c5d93$export$5d1d834fbbf8bab7)()) {
                const device = this.nodeAdmin ? "AdminNode" : "Node";
                // UA Format: Firebase/<wire_protocol>/<sdk_version>/<platform>/<device>
                const options = {
                    headers: {
                        "User-Agent": `Firebase/${$30d3a405033775a4$var$PROTOCOL_VERSION}/${$30d3a405033775a4$var$SDK_VERSION}/${$i9yYZ.platform}/${device}`,
                        "X-Firebase-GMPID": this.applicationId || ""
                    }
                };
                // If using Node with admin creds, AppCheck-related checks are unnecessary.
                // Note that we send the credentials here even if they aren't admin credentials, which is
                // not a problem.
                // Note that this header is just used to bypass appcheck, and the token should still be sent
                // through the websocket connection once it is established.
                if (this.authToken) options.headers["Authorization"] = `Bearer ${this.authToken}`;
                if (this.appCheckToken) options.headers["X-Firebase-AppCheck"] = this.appCheckToken;
                // Plumb appropriate http_proxy environment variable into faye-websocket if it exists.
                const env = {};
                const proxy = this.connURL.indexOf("wss://") === 0 ? env["HTTPS_PROXY"] || env["https_proxy"] : env["HTTP_PROXY"] || env["http_proxy"];
                if (proxy) options["proxy"] = {
                    origin: proxy
                };
            }
            this.mySock = new $30d3a405033775a4$var$WebSocketImpl(this.connURL, [], options);
        } catch (e) {
            this.log_("Error instantiating WebSocket.");
            const error = e.message || e.data;
            if (error) this.log_(error);
            this.onClosed_();
            return;
        }
        this.mySock.onopen = ()=>{
            this.log_("Websocket connected.");
            this.everConnected_ = true;
        };
        this.mySock.onclose = ()=>{
            this.log_("Websocket connection was disconnected.");
            this.mySock = null;
            this.onClosed_();
        };
        this.mySock.onmessage = (m)=>{
            this.handleIncomingFrame(m);
        };
        this.mySock.onerror = (e)=>{
            this.log_("WebSocket error.  Closing connection.");
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const error = e.message || e.data;
            if (error) this.log_(error);
            this.onClosed_();
        };
    }
    /**
     * No-op for websockets, we don't need to do anything once the connection is confirmed as open
     */ start() {}
    static forceDisallow() {
        $30d3a405033775a4$var$WebSocketConnection.forceDisallow_ = true;
    }
    static isAvailable() {
        let isOldAndroid = false;
        if (typeof navigator !== "undefined" && navigator.userAgent) {
            const oldAndroidRegex = /Android ([0-9]{0,}\.[0-9]{0,})/;
            const oldAndroidMatch = navigator.userAgent.match(oldAndroidRegex);
            if (oldAndroidMatch && oldAndroidMatch.length > 1) {
                if (parseFloat(oldAndroidMatch[1]) < 4.4) isOldAndroid = true;
            }
        }
        return !isOldAndroid && $30d3a405033775a4$var$WebSocketImpl !== null && !$30d3a405033775a4$var$WebSocketConnection.forceDisallow_;
    }
    /**
     * Returns true if we previously failed to connect with this transport.
     */ static previouslyFailed() {
        // If our persistent storage is actually only in-memory storage,
        // we default to assuming that it previously failed to be safe.
        return $30d3a405033775a4$var$PersistentStorage.isInMemoryStorage || $30d3a405033775a4$var$PersistentStorage.get("previous_websocket_failure") === true;
    }
    markConnectionHealthy() {
        $30d3a405033775a4$var$PersistentStorage.remove("previous_websocket_failure");
    }
    appendFrame_(data) {
        this.frames.push(data);
        if (this.frames.length === this.totalFrames) {
            const fullMess = this.frames.join("");
            this.frames = null;
            const jsonMess = (0, $f43ebbd33d4c5d93$export$c5a53ce6a17cf18d)(fullMess);
            //handle the message
            this.onMessage(jsonMess);
        }
    }
    /**
     * @param frameCount - The number of frames we are expecting from the server
     */ handleNewFrameCount_(frameCount) {
        this.totalFrames = frameCount;
        this.frames = [];
    }
    /**
     * Attempts to parse a frame count out of some text. If it can't, assumes a value of 1
     * @returns Any remaining data to be process, or null if there is none
     */ extractFrameCount_(data) {
        (0, $f43ebbd33d4c5d93$export$a7a9523472993e97)(this.frames === null, "We already have a frame buffer");
        // TODO: The server is only supposed to send up to 9999 frames (i.e. length <= 4), but that isn't being enforced
        // currently.  So allowing larger frame counts (length <= 6).  See https://app.asana.com/0/search/8688598998380/8237608042508
        if (data.length <= 6) {
            const frameCount = Number(data);
            if (!isNaN(frameCount)) {
                this.handleNewFrameCount_(frameCount);
                return null;
            }
        }
        this.handleNewFrameCount_(1);
        return data;
    }
    /**
     * Process a websocket frame that has arrived from the server.
     * @param mess - The frame data
     */ handleIncomingFrame(mess) {
        if (this.mySock === null) return; // Chrome apparently delivers incoming packets even after we .close() the connection sometimes.
        const data = mess["data"];
        this.bytesReceived += data.length;
        this.stats_.incrementCounter("bytes_received", data.length);
        this.resetKeepAlive();
        if (this.frames !== null) // we're buffering
        this.appendFrame_(data);
        else {
            // try to parse out a frame count, otherwise, assume 1 and process it
            const remainingData = this.extractFrameCount_(data);
            if (remainingData !== null) this.appendFrame_(remainingData);
        }
    }
    /**
     * Send a message to the server
     * @param data - The JSON object to transmit
     */ send(data) {
        this.resetKeepAlive();
        const dataStr = (0, $f43ebbd33d4c5d93$export$fac44ee5b035f737)(data);
        this.bytesSent += dataStr.length;
        this.stats_.incrementCounter("bytes_sent", dataStr.length);
        //We can only fit a certain amount in each websocket frame, so we need to split this request
        //up into multiple pieces if it doesn't fit in one request.
        const dataSegs = $30d3a405033775a4$var$splitStringBySize(dataStr, $30d3a405033775a4$var$WEBSOCKET_MAX_FRAME_SIZE);
        //Send the length header
        if (dataSegs.length > 1) this.sendString_(String(dataSegs.length));
        //Send the actual data in segments.
        for(let i = 0; i < dataSegs.length; i++)this.sendString_(dataSegs[i]);
    }
    shutdown_() {
        this.isClosed_ = true;
        if (this.keepaliveTimer) {
            clearInterval(this.keepaliveTimer);
            this.keepaliveTimer = null;
        }
        if (this.mySock) {
            this.mySock.close();
            this.mySock = null;
        }
    }
    onClosed_() {
        if (!this.isClosed_) {
            this.log_("WebSocket is closing itself");
            this.shutdown_();
            // since this is an internal close, trigger the close listener
            if (this.onDisconnect) {
                this.onDisconnect(this.everConnected_);
                this.onDisconnect = null;
            }
        }
    }
    /**
     * External-facing close handler.
     * Close the websocket and kill the connection.
     */ close() {
        if (!this.isClosed_) {
            this.log_("WebSocket is being closed");
            this.shutdown_();
        }
    }
    /**
     * Kill the current keepalive timer and start a new one, to ensure that it always fires N seconds after
     * the last activity.
     */ resetKeepAlive() {
        clearInterval(this.keepaliveTimer);
        this.keepaliveTimer = setInterval(()=>{
            //If there has been no websocket activity for a while, send a no-op
            if (this.mySock) this.sendString_("0");
            this.resetKeepAlive();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        }, Math.floor($30d3a405033775a4$var$WEBSOCKET_KEEPALIVE_INTERVAL));
    }
    /**
     * Send a string over the websocket.
     *
     * @param str - String to send.
     */ sendString_(str) {
        // Firefox seems to sometimes throw exceptions (NS_ERROR_UNEXPECTED) from websocket .send()
        // calls for some unknown reason.  We treat these as an error and disconnect.
        // See https://app.asana.com/0/58926111402292/68021340250410
        try {
            this.mySock.send(str);
        } catch (e) {
            this.log_("Exception thrown from WebSocket.send():", e.message || e.data, "Closing connection.");
            setTimeout(this.onClosed_.bind(this), 0);
        }
    }
    /**
     * @param connId identifier for this transport
     * @param repoInfo The info for the websocket endpoint.
     * @param applicationId The Firebase App ID for this project.
     * @param appCheckToken The App Check Token for this client.
     * @param authToken The Auth Token for this client.
     * @param transportSessionId Optional transportSessionId if this is connecting
     * to an existing transport session
     * @param lastSessionId Optional lastSessionId if there was a previous
     * connection
     */ constructor(connId, repoInfo, applicationId, appCheckToken, authToken, transportSessionId, lastSessionId){
        this.connId = connId;
        this.applicationId = applicationId;
        this.appCheckToken = appCheckToken;
        this.authToken = authToken;
        this.keepaliveTimer = null;
        this.frames = null;
        this.totalFrames = 0;
        this.bytesSent = 0;
        this.bytesReceived = 0;
        this.log_ = $30d3a405033775a4$var$logWrapper(this.connId);
        this.stats_ = $30d3a405033775a4$var$statsManagerGetCollection(repoInfo);
        this.connURL = $30d3a405033775a4$var$WebSocketConnection.connectionURL_(repoInfo, transportSessionId, lastSessionId, appCheckToken, applicationId);
        this.nodeAdmin = repoInfo.nodeAdmin;
    }
}
/**
 * Number of response before we consider the connection "healthy."
 */ $30d3a405033775a4$var$WebSocketConnection.responsesRequiredToBeHealthy = 2;
/**
 * Time to wait for the connection te become healthy before giving up.
 */ $30d3a405033775a4$var$WebSocketConnection.healthyTimeout = 30000;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Currently simplistic, this class manages what transport a Connection should use at various stages of its
 * lifecycle.
 *
 * It starts with longpolling in a browser, and httppolling on node. It then upgrades to websockets if
 * they are available.
 */ class $30d3a405033775a4$var$TransportManager {
    static get ALL_TRANSPORTS() {
        return [
            $30d3a405033775a4$var$BrowserPollConnection,
            $30d3a405033775a4$var$WebSocketConnection
        ];
    }
    /**
     * Returns whether transport has been selected to ensure WebSocketConnection or BrowserPollConnection are not called after
     * TransportManager has already set up transports_
     */ static get IS_TRANSPORT_INITIALIZED() {
        return this.globalTransportInitialized_;
    }
    initTransports_(repoInfo) {
        const isWebSocketsAvailable = $30d3a405033775a4$var$WebSocketConnection && $30d3a405033775a4$var$WebSocketConnection["isAvailable"]();
        let isSkipPollConnection = isWebSocketsAvailable && !$30d3a405033775a4$var$WebSocketConnection.previouslyFailed();
        if (repoInfo.webSocketOnly) {
            if (!isWebSocketsAvailable) $30d3a405033775a4$var$warn("wss:// URL used, but browser isn't known to support websockets.  Trying anyway.");
            isSkipPollConnection = true;
        }
        if (isSkipPollConnection) this.transports_ = [
            $30d3a405033775a4$var$WebSocketConnection
        ];
        else {
            const transports = this.transports_ = [];
            for (const transport of $30d3a405033775a4$var$TransportManager.ALL_TRANSPORTS)if (transport && transport["isAvailable"]()) transports.push(transport);
            $30d3a405033775a4$var$TransportManager.globalTransportInitialized_ = true;
        }
    }
    /**
     * @returns The constructor for the initial transport to use
     */ initialTransport() {
        if (this.transports_.length > 0) return this.transports_[0];
        else throw new Error("No transports available");
    }
    /**
     * @returns The constructor for the next transport, or null
     */ upgradeTransport() {
        if (this.transports_.length > 1) return this.transports_[1];
        else return null;
    }
    /**
     * @param repoInfo - Metadata around the namespace we're connecting to
     */ constructor(repoInfo){
        this.initTransports_(repoInfo);
    }
}
// Keeps track of whether the TransportManager has already chosen a transport to use
$30d3a405033775a4$var$TransportManager.globalTransportInitialized_ = false;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Abort upgrade attempt if it takes longer than 60s.
const $30d3a405033775a4$var$UPGRADE_TIMEOUT = 60000;
// For some transports (WebSockets), we need to "validate" the transport by exchanging a few requests and responses.
// If we haven't sent enough requests within 5s, we'll start sending noop ping requests.
const $30d3a405033775a4$var$DELAY_BEFORE_SENDING_EXTRA_REQUESTS = 5000;
// If the initial data sent triggers a lot of bandwidth (i.e. it's a large put or a listen for a large amount of data)
// then we may not be able to exchange our ping/pong requests within the healthy timeout.  So if we reach the timeout
// but we've sent/received enough bytes, we don't cancel the connection.
const $30d3a405033775a4$var$BYTES_SENT_HEALTHY_OVERRIDE = 10240;
const $30d3a405033775a4$var$BYTES_RECEIVED_HEALTHY_OVERRIDE = 102400;
const $30d3a405033775a4$var$MESSAGE_TYPE = "t";
const $30d3a405033775a4$var$MESSAGE_DATA = "d";
const $30d3a405033775a4$var$CONTROL_SHUTDOWN = "s";
const $30d3a405033775a4$var$CONTROL_RESET = "r";
const $30d3a405033775a4$var$CONTROL_ERROR = "e";
const $30d3a405033775a4$var$CONTROL_PONG = "o";
const $30d3a405033775a4$var$SWITCH_ACK = "a";
const $30d3a405033775a4$var$END_TRANSMISSION = "n";
const $30d3a405033775a4$var$PING = "p";
const $30d3a405033775a4$var$SERVER_HELLO = "h";
/**
 * Creates a new real-time connection to the server using whichever method works
 * best in the current browser.
 */ class $30d3a405033775a4$var$Connection {
    /**
     * Starts a connection attempt
     */ start_() {
        const conn = this.transportManager_.initialTransport();
        this.conn_ = new conn(this.nextTransportId_(), this.repoInfo_, this.applicationId_, this.appCheckToken_, this.authToken_, null, this.lastSessionId);
        // For certain transports (WebSockets), we need to send and receive several messages back and forth before we
        // can consider the transport healthy.
        this.primaryResponsesRequired_ = conn["responsesRequiredToBeHealthy"] || 0;
        const onMessageReceived = this.connReceiver_(this.conn_);
        const onConnectionLost = this.disconnReceiver_(this.conn_);
        this.tx_ = this.conn_;
        this.rx_ = this.conn_;
        this.secondaryConn_ = null;
        this.isHealthy_ = false;
        /*
         * Firefox doesn't like when code from one iframe tries to create another iframe by way of the parent frame.
         * This can occur in the case of a redirect, i.e. we guessed wrong on what server to connect to and received a reset.
         * Somehow, setTimeout seems to make this ok. That doesn't make sense from a security perspective, since you should
         * still have the context of your originating frame.
         */ setTimeout(()=>{
            // this.conn_ gets set to null in some of the tests. Check to make sure it still exists before using it
            this.conn_ && this.conn_.open(onMessageReceived, onConnectionLost);
        }, Math.floor(0));
        const healthyTimeoutMS = conn["healthyTimeout"] || 0;
        if (healthyTimeoutMS > 0) this.healthyTimeout_ = $30d3a405033775a4$var$setTimeoutNonBlocking(()=>{
            this.healthyTimeout_ = null;
            if (!this.isHealthy_) {
                if (this.conn_ && this.conn_.bytesReceived > $30d3a405033775a4$var$BYTES_RECEIVED_HEALTHY_OVERRIDE) {
                    this.log_("Connection exceeded healthy timeout but has received " + this.conn_.bytesReceived + " bytes.  Marking connection healthy.");
                    this.isHealthy_ = true;
                    this.conn_.markConnectionHealthy();
                } else if (this.conn_ && this.conn_.bytesSent > $30d3a405033775a4$var$BYTES_SENT_HEALTHY_OVERRIDE) this.log_("Connection exceeded healthy timeout but has sent " + this.conn_.bytesSent + " bytes.  Leaving connection alive.");
                else {
                    this.log_("Closing unhealthy connection after timeout.");
                    this.close();
                }
            }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        }, Math.floor(healthyTimeoutMS));
    }
    nextTransportId_() {
        return "c:" + this.id + ":" + this.connectionCount++;
    }
    disconnReceiver_(conn) {
        return (everConnected)=>{
            if (conn === this.conn_) this.onConnectionLost_(everConnected);
            else if (conn === this.secondaryConn_) {
                this.log_("Secondary connection lost.");
                this.onSecondaryConnectionLost_();
            } else this.log_("closing an old connection");
        };
    }
    connReceiver_(conn) {
        return (message)=>{
            if (this.state_ !== 2 /* DISCONNECTED */ ) {
                if (conn === this.rx_) this.onPrimaryMessageReceived_(message);
                else if (conn === this.secondaryConn_) this.onSecondaryMessageReceived_(message);
                else this.log_("message on old connection");
            }
        };
    }
    /**
     * @param dataMsg - An arbitrary data message to be sent to the server
     */ sendRequest(dataMsg) {
        // wrap in a data message envelope and send it on
        const msg = {
            t: "d",
            d: dataMsg
        };
        this.sendData_(msg);
    }
    tryCleanupConnection() {
        if (this.tx_ === this.secondaryConn_ && this.rx_ === this.secondaryConn_) {
            this.log_("cleaning up and promoting a connection: " + this.secondaryConn_.connId);
            this.conn_ = this.secondaryConn_;
            this.secondaryConn_ = null;
        // the server will shutdown the old connection
        }
    }
    onSecondaryControl_(controlData) {
        if ($30d3a405033775a4$var$MESSAGE_TYPE in controlData) {
            const cmd = controlData[$30d3a405033775a4$var$MESSAGE_TYPE];
            if (cmd === $30d3a405033775a4$var$SWITCH_ACK) this.upgradeIfSecondaryHealthy_();
            else if (cmd === $30d3a405033775a4$var$CONTROL_RESET) {
                // Most likely the session wasn't valid. Abandon the switch attempt
                this.log_("Got a reset on secondary, closing it");
                this.secondaryConn_.close();
                // If we were already using this connection for something, than we need to fully close
                if (this.tx_ === this.secondaryConn_ || this.rx_ === this.secondaryConn_) this.close();
            } else if (cmd === $30d3a405033775a4$var$CONTROL_PONG) {
                this.log_("got pong on secondary.");
                this.secondaryResponsesRequired_--;
                this.upgradeIfSecondaryHealthy_();
            }
        }
    }
    onSecondaryMessageReceived_(parsedData) {
        const layer = $30d3a405033775a4$var$requireKey("t", parsedData);
        const data = $30d3a405033775a4$var$requireKey("d", parsedData);
        if (layer === "c") this.onSecondaryControl_(data);
        else if (layer === "d") // got a data message, but we're still second connection. Need to buffer it up
        this.pendingDataMessages.push(data);
        else throw new Error("Unknown protocol layer: " + layer);
    }
    upgradeIfSecondaryHealthy_() {
        if (this.secondaryResponsesRequired_ <= 0) {
            this.log_("Secondary connection is healthy.");
            this.isHealthy_ = true;
            this.secondaryConn_.markConnectionHealthy();
            this.proceedWithUpgrade_();
        } else {
            // Send a ping to make sure the connection is healthy.
            this.log_("sending ping on secondary.");
            this.secondaryConn_.send({
                t: "c",
                d: {
                    t: $30d3a405033775a4$var$PING,
                    d: {}
                }
            });
        }
    }
    proceedWithUpgrade_() {
        // tell this connection to consider itself open
        this.secondaryConn_.start();
        // send ack
        this.log_("sending client ack on secondary");
        this.secondaryConn_.send({
            t: "c",
            d: {
                t: $30d3a405033775a4$var$SWITCH_ACK,
                d: {}
            }
        });
        // send end packet on primary transport, switch to sending on this one
        // can receive on this one, buffer responses until end received on primary transport
        this.log_("Ending transmission on primary");
        this.conn_.send({
            t: "c",
            d: {
                t: $30d3a405033775a4$var$END_TRANSMISSION,
                d: {}
            }
        });
        this.tx_ = this.secondaryConn_;
        this.tryCleanupConnection();
    }
    onPrimaryMessageReceived_(parsedData) {
        // Must refer to parsedData properties in quotes, so closure doesn't touch them.
        const layer = $30d3a405033775a4$var$requireKey("t", parsedData);
        const data = $30d3a405033775a4$var$requireKey("d", parsedData);
        if (layer === "c") this.onControl_(data);
        else if (layer === "d") this.onDataMessage_(data);
    }
    onDataMessage_(message) {
        this.onPrimaryResponse_();
        // We don't do anything with data messages, just kick them up a level
        this.onMessage_(message);
    }
    onPrimaryResponse_() {
        if (!this.isHealthy_) {
            this.primaryResponsesRequired_--;
            if (this.primaryResponsesRequired_ <= 0) {
                this.log_("Primary connection is healthy.");
                this.isHealthy_ = true;
                this.conn_.markConnectionHealthy();
            }
        }
    }
    onControl_(controlData) {
        const cmd = $30d3a405033775a4$var$requireKey($30d3a405033775a4$var$MESSAGE_TYPE, controlData);
        if ($30d3a405033775a4$var$MESSAGE_DATA in controlData) {
            const payload = controlData[$30d3a405033775a4$var$MESSAGE_DATA];
            if (cmd === $30d3a405033775a4$var$SERVER_HELLO) this.onHandshake_(payload);
            else if (cmd === $30d3a405033775a4$var$END_TRANSMISSION) {
                this.log_("recvd end transmission on primary");
                this.rx_ = this.secondaryConn_;
                for(let i = 0; i < this.pendingDataMessages.length; ++i)this.onDataMessage_(this.pendingDataMessages[i]);
                this.pendingDataMessages = [];
                this.tryCleanupConnection();
            } else if (cmd === $30d3a405033775a4$var$CONTROL_SHUTDOWN) // This was previously the 'onKill' callback passed to the lower-level connection
            // payload in this case is the reason for the shutdown. Generally a human-readable error
            this.onConnectionShutdown_(payload);
            else if (cmd === $30d3a405033775a4$var$CONTROL_RESET) // payload in this case is the host we should contact
            this.onReset_(payload);
            else if (cmd === $30d3a405033775a4$var$CONTROL_ERROR) $30d3a405033775a4$var$error("Server Error: " + payload);
            else if (cmd === $30d3a405033775a4$var$CONTROL_PONG) {
                this.log_("got pong on primary.");
                this.onPrimaryResponse_();
                this.sendPingOnPrimaryIfNecessary_();
            } else $30d3a405033775a4$var$error("Unknown control packet command: " + cmd);
        }
    }
    /**
     * @param handshake - The handshake data returned from the server
     */ onHandshake_(handshake) {
        const timestamp = handshake.ts;
        const version = handshake.v;
        const host = handshake.h;
        this.sessionId = handshake.s;
        this.repoInfo_.host = host;
        // if we've already closed the connection, then don't bother trying to progress further
        if (this.state_ === 0 /* CONNECTING */ ) {
            this.conn_.start();
            this.onConnectionEstablished_(this.conn_, timestamp);
            if ($30d3a405033775a4$var$PROTOCOL_VERSION !== version) $30d3a405033775a4$var$warn("Protocol version mismatch detected");
            // TODO: do we want to upgrade? when? maybe a delay?
            this.tryStartUpgrade_();
        }
    }
    tryStartUpgrade_() {
        const conn = this.transportManager_.upgradeTransport();
        if (conn) this.startUpgrade_(conn);
    }
    startUpgrade_(conn) {
        this.secondaryConn_ = new conn(this.nextTransportId_(), this.repoInfo_, this.applicationId_, this.appCheckToken_, this.authToken_, this.sessionId);
        // For certain transports (WebSockets), we need to send and receive several messages back and forth before we
        // can consider the transport healthy.
        this.secondaryResponsesRequired_ = conn["responsesRequiredToBeHealthy"] || 0;
        const onMessage = this.connReceiver_(this.secondaryConn_);
        const onDisconnect = this.disconnReceiver_(this.secondaryConn_);
        this.secondaryConn_.open(onMessage, onDisconnect);
        // If we haven't successfully upgraded after UPGRADE_TIMEOUT, give up and kill the secondary.
        $30d3a405033775a4$var$setTimeoutNonBlocking(()=>{
            if (this.secondaryConn_) {
                this.log_("Timed out trying to upgrade.");
                this.secondaryConn_.close();
            }
        }, Math.floor($30d3a405033775a4$var$UPGRADE_TIMEOUT));
    }
    onReset_(host) {
        this.log_("Reset packet received.  New host: " + host);
        this.repoInfo_.host = host;
        // TODO: if we're already "connected", we need to trigger a disconnect at the next layer up.
        // We don't currently support resets after the connection has already been established
        if (this.state_ === 1 /* CONNECTED */ ) this.close();
        else {
            // Close whatever connections we have open and start again.
            this.closeConnections_();
            this.start_();
        }
    }
    onConnectionEstablished_(conn, timestamp) {
        this.log_("Realtime connection established.");
        this.conn_ = conn;
        this.state_ = 1 /* CONNECTED */ ;
        if (this.onReady_) {
            this.onReady_(timestamp, this.sessionId);
            this.onReady_ = null;
        }
        // If after 5 seconds we haven't sent enough requests to the server to get the connection healthy,
        // send some pings.
        if (this.primaryResponsesRequired_ === 0) {
            this.log_("Primary connection is healthy.");
            this.isHealthy_ = true;
        } else $30d3a405033775a4$var$setTimeoutNonBlocking(()=>{
            this.sendPingOnPrimaryIfNecessary_();
        }, Math.floor($30d3a405033775a4$var$DELAY_BEFORE_SENDING_EXTRA_REQUESTS));
    }
    sendPingOnPrimaryIfNecessary_() {
        // If the connection isn't considered healthy yet, we'll send a noop ping packet request.
        if (!this.isHealthy_ && this.state_ === 1 /* CONNECTED */ ) {
            this.log_("sending ping on primary.");
            this.sendData_({
                t: "c",
                d: {
                    t: $30d3a405033775a4$var$PING,
                    d: {}
                }
            });
        }
    }
    onSecondaryConnectionLost_() {
        const conn = this.secondaryConn_;
        this.secondaryConn_ = null;
        if (this.tx_ === conn || this.rx_ === conn) // we are relying on this connection already in some capacity. Therefore, a failure is real
        this.close();
    }
    /**
     * @param everConnected - Whether or not the connection ever reached a server. Used to determine if
     * we should flush the host cache
     */ onConnectionLost_(everConnected) {
        this.conn_ = null;
        // NOTE: IF you're seeing a Firefox error for this line, I think it might be because it's getting
        // called on window close and RealtimeState.CONNECTING is no longer defined.  Just a guess.
        if (!everConnected && this.state_ === 0 /* CONNECTING */ ) {
            this.log_("Realtime connection failed.");
            // Since we failed to connect at all, clear any cached entry for this namespace in case the machine went away
            if (this.repoInfo_.isCacheableHost()) {
                $30d3a405033775a4$var$PersistentStorage.remove("host:" + this.repoInfo_.host);
                // reset the internal host to what we would show the user, i.e. <ns>.firebaseio.com
                this.repoInfo_.internalHost = this.repoInfo_.host;
            }
        } else if (this.state_ === 1 /* CONNECTED */ ) this.log_("Realtime connection lost.");
        this.close();
    }
    onConnectionShutdown_(reason) {
        this.log_("Connection shutdown command received. Shutting down...");
        if (this.onKill_) {
            this.onKill_(reason);
            this.onKill_ = null;
        }
        // We intentionally don't want to fire onDisconnect (kill is a different case),
        // so clear the callback.
        this.onDisconnect_ = null;
        this.close();
    }
    sendData_(data) {
        if (this.state_ !== 1 /* CONNECTED */ ) throw "Connection is not connected";
        else this.tx_.send(data);
    }
    /**
     * Cleans up this connection, calling the appropriate callbacks
     */ close() {
        if (this.state_ !== 2 /* DISCONNECTED */ ) {
            this.log_("Closing realtime connection.");
            this.state_ = 2 /* DISCONNECTED */ ;
            this.closeConnections_();
            if (this.onDisconnect_) {
                this.onDisconnect_();
                this.onDisconnect_ = null;
            }
        }
    }
    closeConnections_() {
        this.log_("Shutting down all connections");
        if (this.conn_) {
            this.conn_.close();
            this.conn_ = null;
        }
        if (this.secondaryConn_) {
            this.secondaryConn_.close();
            this.secondaryConn_ = null;
        }
        if (this.healthyTimeout_) {
            clearTimeout(this.healthyTimeout_);
            this.healthyTimeout_ = null;
        }
    }
    /**
     * @param id - an id for this connection
     * @param repoInfo_ - the info for the endpoint to connect to
     * @param applicationId_ - the Firebase App ID for this project
     * @param appCheckToken_ - The App Check Token for this device.
     * @param authToken_ - The auth token for this session.
     * @param onMessage_ - the callback to be triggered when a server-push message arrives
     * @param onReady_ - the callback to be triggered when this connection is ready to send messages.
     * @param onDisconnect_ - the callback to be triggered when a connection was lost
     * @param onKill_ - the callback to be triggered when this connection has permanently shut down.
     * @param lastSessionId - last session id in persistent connection. is used to clean up old session in real-time server
     */ constructor(id, repoInfo_, applicationId_, appCheckToken_, authToken_, onMessage_, onReady_, onDisconnect_, onKill_, lastSessionId){
        this.id = id;
        this.repoInfo_ = repoInfo_;
        this.applicationId_ = applicationId_;
        this.appCheckToken_ = appCheckToken_;
        this.authToken_ = authToken_;
        this.onMessage_ = onMessage_;
        this.onReady_ = onReady_;
        this.onDisconnect_ = onDisconnect_;
        this.onKill_ = onKill_;
        this.lastSessionId = lastSessionId;
        this.connectionCount = 0;
        this.pendingDataMessages = [];
        this.state_ = 0 /* CONNECTING */ ;
        this.log_ = $30d3a405033775a4$var$logWrapper("c:" + this.id + ":");
        this.transportManager_ = new $30d3a405033775a4$var$TransportManager(repoInfo_);
        this.log_("Connection created");
        this.start_();
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface defining the set of actions that can be performed against the Firebase server
 * (basically corresponds to our wire protocol).
 *
 * @interface
 */ class $30d3a405033775a4$var$ServerActions {
    put(pathString, data, onComplete, hash) {}
    merge(pathString, data, onComplete, hash) {}
    /**
     * Refreshes the auth token for the current connection.
     * @param token - The authentication token
     */ refreshAuthToken(token) {}
    /**
     * Refreshes the app check token for the current connection.
     * @param token The app check token
     */ refreshAppCheckToken(token) {}
    onDisconnectPut(pathString, data, onComplete) {}
    onDisconnectMerge(pathString, data, onComplete) {}
    onDisconnectCancel(pathString, onComplete) {}
    reportStats(stats) {}
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Base class to be used if you want to emit events. Call the constructor with
 * the set of allowed event names.
 */ class $30d3a405033775a4$var$EventEmitter {
    /**
     * To be called by derived classes to trigger events.
     */ trigger(eventType, ...varArgs) {
        if (Array.isArray(this.listeners_[eventType])) {
            // Clone the list, since callbacks could add/remove listeners.
            const listeners = [
                ...this.listeners_[eventType]
            ];
            for(let i = 0; i < listeners.length; i++)listeners[i].callback.apply(listeners[i].context, varArgs);
        }
    }
    on(eventType, callback, context) {
        this.validateEventType_(eventType);
        this.listeners_[eventType] = this.listeners_[eventType] || [];
        this.listeners_[eventType].push({
            callback: callback,
            context: context
        });
        const eventData = this.getInitialEvent(eventType);
        if (eventData) callback.apply(context, eventData);
    }
    off(eventType, callback, context) {
        this.validateEventType_(eventType);
        const listeners = this.listeners_[eventType] || [];
        for(let i = 0; i < listeners.length; i++)if (listeners[i].callback === callback && (!context || context === listeners[i].context)) {
            listeners.splice(i, 1);
            return;
        }
    }
    validateEventType_(eventType) {
        (0, $f43ebbd33d4c5d93$export$a7a9523472993e97)(this.allowedEvents_.find((et)=>{
            return et === eventType;
        }), "Unknown event: " + eventType);
    }
    constructor(allowedEvents_){
        this.allowedEvents_ = allowedEvents_;
        this.listeners_ = {};
        (0, $f43ebbd33d4c5d93$export$a7a9523472993e97)(Array.isArray(allowedEvents_) && allowedEvents_.length > 0, "Requires a non-empty array");
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Monitors online state (as reported by window.online/offline events).
 *
 * The expectation is that this could have many false positives (thinks we are online
 * when we're not), but no false negatives.  So we can safely use it to determine when
 * we definitely cannot reach the internet.
 */ class $30d3a405033775a4$var$OnlineMonitor extends $30d3a405033775a4$var$EventEmitter {
    static getInstance() {
        return new $30d3a405033775a4$var$OnlineMonitor();
    }
    getInitialEvent(eventType) {
        (0, $f43ebbd33d4c5d93$export$a7a9523472993e97)(eventType === "online", "Unknown event type: " + eventType);
        return [
            this.online_
        ];
    }
    currentlyOnline() {
        return this.online_;
    }
    constructor(){
        super([
            "online"
        ]);
        this.online_ = true;
        // We've had repeated complaints that Cordova apps can get stuck "offline", e.g.
        // https://forum.ionicframework.com/t/firebase-connection-is-lost-and-never-come-back/43810
        // It would seem that the 'online' event does not always fire consistently. So we disable it
        // for Cordova.
        if (typeof window !== "undefined" && typeof window.addEventListener !== "undefined" && !(0, $f43ebbd33d4c5d93$export$872f8323f01d7ae0)()) {
            window.addEventListener("online", ()=>{
                if (!this.online_) {
                    this.online_ = true;
                    this.trigger("online", true);
                }
            }, false);
            window.addEventListener("offline", ()=>{
                if (this.online_) {
                    this.online_ = false;
                    this.trigger("online", false);
                }
            }, false);
        }
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Maximum key depth. */ const $30d3a405033775a4$var$MAX_PATH_DEPTH = 32;
/** Maximum number of (UTF8) bytes in a Firebase path. */ const $30d3a405033775a4$var$MAX_PATH_LENGTH_BYTES = 768;
/**
 * An immutable object representing a parsed path.  It's immutable so that you
 * can pass them around to other functions without worrying about them changing
 * it.
 */ class $30d3a405033775a4$var$Path {
    toString() {
        let pathString = "";
        for(let i = this.pieceNum_; i < this.pieces_.length; i++)if (this.pieces_[i] !== "") pathString += "/" + this.pieces_[i];
        return pathString || "/";
    }
    /**
     * @param pathOrString - Path string to parse, or another path, or the raw
     * tokens array
     */ constructor(pathOrString, pieceNum){
        if (pieceNum === void 0) {
            this.pieces_ = pathOrString.split("/");
            // Remove empty pieces.
            let copyTo = 0;
            for(let i = 0; i < this.pieces_.length; i++)if (this.pieces_[i].length > 0) {
                this.pieces_[copyTo] = this.pieces_[i];
                copyTo++;
            }
            this.pieces_.length = copyTo;
            this.pieceNum_ = 0;
        } else {
            this.pieces_ = pathOrString;
            this.pieceNum_ = pieceNum;
        }
    }
}
function $30d3a405033775a4$var$newEmptyPath() {
    return new $30d3a405033775a4$var$Path("");
}
function $30d3a405033775a4$var$pathGetFront(path) {
    if (path.pieceNum_ >= path.pieces_.length) return null;
    return path.pieces_[path.pieceNum_];
}
/**
 * @returns The number of segments in this path
 */ function $30d3a405033775a4$var$pathGetLength(path) {
    return path.pieces_.length - path.pieceNum_;
}
function $30d3a405033775a4$var$pathPopFront(path) {
    let pieceNum = path.pieceNum_;
    if (pieceNum < path.pieces_.length) pieceNum++;
    return new $30d3a405033775a4$var$Path(path.pieces_, pieceNum);
}
function $30d3a405033775a4$var$pathGetBack(path) {
    if (path.pieceNum_ < path.pieces_.length) return path.pieces_[path.pieces_.length - 1];
    return null;
}
function $30d3a405033775a4$var$pathToUrlEncodedString(path) {
    let pathString = "";
    for(let i = path.pieceNum_; i < path.pieces_.length; i++)if (path.pieces_[i] !== "") pathString += "/" + encodeURIComponent(String(path.pieces_[i]));
    return pathString || "/";
}
/**
 * Shallow copy of the parts of the path.
 *
 */ function $30d3a405033775a4$var$pathSlice(path, begin = 0) {
    return path.pieces_.slice(path.pieceNum_ + begin);
}
function $30d3a405033775a4$var$pathParent(path) {
    if (path.pieceNum_ >= path.pieces_.length) return null;
    const pieces = [];
    for(let i = path.pieceNum_; i < path.pieces_.length - 1; i++)pieces.push(path.pieces_[i]);
    return new $30d3a405033775a4$var$Path(pieces, 0);
}
function $30d3a405033775a4$var$pathChild(path, childPathObj) {
    const pieces = [];
    for(let i = path.pieceNum_; i < path.pieces_.length; i++)pieces.push(path.pieces_[i]);
    if (childPathObj instanceof $30d3a405033775a4$var$Path) for(let i = childPathObj.pieceNum_; i < childPathObj.pieces_.length; i++)pieces.push(childPathObj.pieces_[i]);
    else {
        const childPieces = childPathObj.split("/");
        for(let i = 0; i < childPieces.length; i++)if (childPieces[i].length > 0) pieces.push(childPieces[i]);
    }
    return new $30d3a405033775a4$var$Path(pieces, 0);
}
/**
 * @returns True if there are no segments in this path
 */ function $30d3a405033775a4$var$pathIsEmpty(path) {
    return path.pieceNum_ >= path.pieces_.length;
}
/**
 * @returns The path from outerPath to innerPath
 */ function $30d3a405033775a4$var$newRelativePath(outerPath, innerPath) {
    const outer = $30d3a405033775a4$var$pathGetFront(outerPath), inner = $30d3a405033775a4$var$pathGetFront(innerPath);
    if (outer === null) return innerPath;
    else if (outer === inner) return $30d3a405033775a4$var$newRelativePath($30d3a405033775a4$var$pathPopFront(outerPath), $30d3a405033775a4$var$pathPopFront(innerPath));
    else throw new Error("INTERNAL ERROR: innerPath (" + innerPath + ") is not within " + "outerPath (" + outerPath + ")");
}
/**
 * @returns -1, 0, 1 if left is less, equal, or greater than the right.
 */ function $30d3a405033775a4$var$pathCompare(left, right) {
    const leftKeys = $30d3a405033775a4$var$pathSlice(left, 0);
    const rightKeys = $30d3a405033775a4$var$pathSlice(right, 0);
    for(let i = 0; i < leftKeys.length && i < rightKeys.length; i++){
        const cmp = $30d3a405033775a4$var$nameCompare(leftKeys[i], rightKeys[i]);
        if (cmp !== 0) return cmp;
    }
    if (leftKeys.length === rightKeys.length) return 0;
    return leftKeys.length < rightKeys.length ? -1 : 1;
}
/**
 * @returns true if paths are the same.
 */ function $30d3a405033775a4$var$pathEquals(path, other) {
    if ($30d3a405033775a4$var$pathGetLength(path) !== $30d3a405033775a4$var$pathGetLength(other)) return false;
    for(let i = path.pieceNum_, j = other.pieceNum_; i <= path.pieces_.length; i++, j++){
        if (path.pieces_[i] !== other.pieces_[j]) return false;
    }
    return true;
}
/**
 * @returns True if this path is a parent (or the same as) other
 */ function $30d3a405033775a4$var$pathContains(path, other) {
    let i = path.pieceNum_;
    let j = other.pieceNum_;
    if ($30d3a405033775a4$var$pathGetLength(path) > $30d3a405033775a4$var$pathGetLength(other)) return false;
    while(i < path.pieces_.length){
        if (path.pieces_[i] !== other.pieces_[j]) return false;
        ++i;
        ++j;
    }
    return true;
}
/**
 * Dynamic (mutable) path used to count path lengths.
 *
 * This class is used to efficiently check paths for valid
 * length (in UTF8 bytes) and depth (used in path validation).
 *
 * Throws Error exception if path is ever invalid.
 *
 * The definition of a path always begins with '/'.
 */ class $30d3a405033775a4$var$ValidationPath {
    /**
     * @param path - Initial Path.
     * @param errorPrefix_ - Prefix for any error messages.
     */ constructor(path, errorPrefix_){
        this.errorPrefix_ = errorPrefix_;
        this.parts_ = $30d3a405033775a4$var$pathSlice(path, 0);
        /** Initialize to number of '/' chars needed in path. */ this.byteLength_ = Math.max(1, this.parts_.length);
        for(let i = 0; i < this.parts_.length; i++)this.byteLength_ += (0, $f43ebbd33d4c5d93$export$9536dc0a75b20bf9)(this.parts_[i]);
        $30d3a405033775a4$var$validationPathCheckValid(this);
    }
}
function $30d3a405033775a4$var$validationPathPush(validationPath, child) {
    // Count the needed '/'
    if (validationPath.parts_.length > 0) validationPath.byteLength_ += 1;
    validationPath.parts_.push(child);
    validationPath.byteLength_ += (0, $f43ebbd33d4c5d93$export$9536dc0a75b20bf9)(child);
    $30d3a405033775a4$var$validationPathCheckValid(validationPath);
}
function $30d3a405033775a4$var$validationPathPop(validationPath) {
    const last = validationPath.parts_.pop();
    validationPath.byteLength_ -= (0, $f43ebbd33d4c5d93$export$9536dc0a75b20bf9)(last);
    // Un-count the previous '/'
    if (validationPath.parts_.length > 0) validationPath.byteLength_ -= 1;
}
function $30d3a405033775a4$var$validationPathCheckValid(validationPath) {
    if (validationPath.byteLength_ > $30d3a405033775a4$var$MAX_PATH_LENGTH_BYTES) throw new Error(validationPath.errorPrefix_ + "has a key path longer than " + $30d3a405033775a4$var$MAX_PATH_LENGTH_BYTES + " bytes (" + validationPath.byteLength_ + ").");
    if (validationPath.parts_.length > $30d3a405033775a4$var$MAX_PATH_DEPTH) throw new Error(validationPath.errorPrefix_ + "path specified exceeds the maximum depth that can be written (" + $30d3a405033775a4$var$MAX_PATH_DEPTH + ") or object contains a cycle " + $30d3a405033775a4$var$validationPathToErrorString(validationPath));
}
/**
 * String for use in error messages - uses '.' notation for path.
 */ function $30d3a405033775a4$var$validationPathToErrorString(validationPath) {
    if (validationPath.parts_.length === 0) return "";
    return "in property '" + validationPath.parts_.join(".") + "'";
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $30d3a405033775a4$var$VisibilityMonitor extends $30d3a405033775a4$var$EventEmitter {
    static getInstance() {
        return new $30d3a405033775a4$var$VisibilityMonitor();
    }
    getInitialEvent(eventType) {
        (0, $f43ebbd33d4c5d93$export$a7a9523472993e97)(eventType === "visible", "Unknown event type: " + eventType);
        return [
            this.visible_
        ];
    }
    constructor(){
        super([
            "visible"
        ]);
        let hidden;
        let visibilityChange;
        if (typeof document !== "undefined" && typeof document.addEventListener !== "undefined") {
            if (typeof document["hidden"] !== "undefined") {
                // Opera 12.10 and Firefox 18 and later support
                visibilityChange = "visibilitychange";
                hidden = "hidden";
            } else if (typeof document["mozHidden"] !== "undefined") {
                visibilityChange = "mozvisibilitychange";
                hidden = "mozHidden";
            } else if (typeof document["msHidden"] !== "undefined") {
                visibilityChange = "msvisibilitychange";
                hidden = "msHidden";
            } else if (typeof document["webkitHidden"] !== "undefined") {
                visibilityChange = "webkitvisibilitychange";
                hidden = "webkitHidden";
            }
        }
        // Initially, we always assume we are visible. This ensures that in browsers
        // without page visibility support or in cases where we are never visible
        // (e.g. chrome extension), we act as if we are visible, i.e. don't delay
        // reconnects
        this.visible_ = true;
        if (visibilityChange) document.addEventListener(visibilityChange, ()=>{
            const visible = !document[hidden];
            if (visible !== this.visible_) {
                this.visible_ = visible;
                this.trigger("visible", visible);
            }
        }, false);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $30d3a405033775a4$var$RECONNECT_MIN_DELAY = 1000;
const $30d3a405033775a4$var$RECONNECT_MAX_DELAY_DEFAULT = 300000; // 5 minutes in milliseconds (Case: 1858)
const $30d3a405033775a4$var$GET_CONNECT_TIMEOUT = 3000;
const $30d3a405033775a4$var$RECONNECT_MAX_DELAY_FOR_ADMINS = 30000; // 30 seconds for admin clients (likely to be a backend server)
const $30d3a405033775a4$var$RECONNECT_DELAY_MULTIPLIER = 1.3;
const $30d3a405033775a4$var$RECONNECT_DELAY_RESET_TIMEOUT = 30000; // Reset delay back to MIN_DELAY after being connected for 30sec.
const $30d3a405033775a4$var$SERVER_KILL_INTERRUPT_REASON = "server_kill";
// If auth fails repeatedly, we'll assume something is wrong and log a warning / back off.
const $30d3a405033775a4$var$INVALID_TOKEN_THRESHOLD = 3;
/**
 * Firebase connection.  Abstracts wire protocol and handles reconnecting.
 *
 * NOTE: All JSON objects sent to the realtime connection must have property names enclosed
 * in quotes to make sure the closure compiler does not minify them.
 */ class $30d3a405033775a4$var$PersistentConnection extends $30d3a405033775a4$var$ServerActions {
    sendRequest(action, body, onResponse) {
        const curReqNum = ++this.requestNumber_;
        const msg = {
            r: curReqNum,
            a: action,
            b: body
        };
        this.log_((0, $f43ebbd33d4c5d93$export$fac44ee5b035f737)(msg));
        (0, $f43ebbd33d4c5d93$export$a7a9523472993e97)(this.connected_, "sendRequest call when we're not connected not allowed.");
        this.realtime_.sendRequest(msg);
        if (onResponse) this.requestCBHash_[curReqNum] = onResponse;
    }
    get(query) {
        this.initConnection_();
        const deferred = new (0, $f43ebbd33d4c5d93$export$85f6557964517f1a)();
        const request = {
            p: query._path.toString(),
            q: query._queryObject
        };
        const outstandingGet = {
            action: "g",
            request: request,
            onComplete: (message)=>{
                const payload = message["d"];
                if (message["s"] === "ok") {
                    this.onDataUpdate_(request["p"], payload, /*isMerge*/ false, /*tag*/ null);
                    deferred.resolve(payload);
                } else deferred.reject(payload);
            }
        };
        this.outstandingGets_.push(outstandingGet);
        this.outstandingGetCount_++;
        const index = this.outstandingGets_.length - 1;
        if (!this.connected_) setTimeout(()=>{
            const get = this.outstandingGets_[index];
            if (get === undefined || outstandingGet !== get) return;
            delete this.outstandingGets_[index];
            this.outstandingGetCount_--;
            if (this.outstandingGetCount_ === 0) this.outstandingGets_ = [];
            this.log_("get " + index + " timed out on connection");
            deferred.reject(new Error("Client is offline."));
        }, $30d3a405033775a4$var$GET_CONNECT_TIMEOUT);
        if (this.connected_) this.sendGet_(index);
        return deferred.promise;
    }
    listen(query, currentHashFn, tag, onComplete) {
        this.initConnection_();
        const queryId = query._queryIdentifier;
        const pathString = query._path.toString();
        this.log_("Listen called for " + pathString + " " + queryId);
        if (!this.listens.has(pathString)) this.listens.set(pathString, new Map());
        (0, $f43ebbd33d4c5d93$export$a7a9523472993e97)(query._queryParams.isDefault() || !query._queryParams.loadsAllData(), "listen() called for non-default but complete query");
        (0, $f43ebbd33d4c5d93$export$a7a9523472993e97)(!this.listens.get(pathString).has(queryId), "listen() called twice for same path/queryId.");
        const listenSpec = {
            onComplete: onComplete,
            hashFn: currentHashFn,
            query: query,
            tag: tag
        };
        this.listens.get(pathString).set(queryId, listenSpec);
        if (this.connected_) this.sendListen_(listenSpec);
    }
    sendGet_(index) {
        const get = this.outstandingGets_[index];
        this.sendRequest("g", get.request, (message)=>{
            delete this.outstandingGets_[index];
            this.outstandingGetCount_--;
            if (this.outstandingGetCount_ === 0) this.outstandingGets_ = [];
            if (get.onComplete) get.onComplete(message);
        });
    }
    sendListen_(listenSpec) {
        const query = listenSpec.query;
        const pathString = query._path.toString();
        const queryId = query._queryIdentifier;
        this.log_("Listen on " + pathString + " for " + queryId);
        const req = {
            p: pathString
        };
        const action = "q";
        // Only bother to send query if it's non-default.
        if (listenSpec.tag) {
            req["q"] = query._queryObject;
            req["t"] = listenSpec.tag;
        }
        req[/*hash*/ "h"] = listenSpec.hashFn();
        this.sendRequest(action, req, (message)=>{
            const payload = message[/*data*/ "d"];
            const status = message[/*status*/ "s"];
            // print warnings in any case...
            $30d3a405033775a4$var$PersistentConnection.warnOnListenWarnings_(payload, query);
            const currentListenSpec = this.listens.get(pathString) && this.listens.get(pathString).get(queryId);
            // only trigger actions if the listen hasn't been removed and readded
            if (currentListenSpec === listenSpec) {
                this.log_("listen response", message);
                if (status !== "ok") this.removeListen_(pathString, queryId);
                if (listenSpec.onComplete) listenSpec.onComplete(status, payload);
            }
        });
    }
    static warnOnListenWarnings_(payload, query) {
        if (payload && typeof payload === "object" && (0, $f43ebbd33d4c5d93$export$2344b14b097df817)(payload, "w")) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const warnings = (0, $f43ebbd33d4c5d93$export$e51ae4db7b428f67)(payload, "w");
            if (Array.isArray(warnings) && ~warnings.indexOf("no_index")) {
                const indexSpec = '".indexOn": "' + query._queryParams.getIndex().toString() + '"';
                const indexPath = query._path.toString();
                $30d3a405033775a4$var$warn(`Using an unspecified index. Your data will be downloaded and ` + `filtered on the client. Consider adding ${indexSpec} at ` + `${indexPath} to your security rules for better performance.`);
            }
        }
    }
    refreshAuthToken(token) {
        this.authToken_ = token;
        this.log_("Auth token refreshed");
        if (this.authToken_) this.tryAuth();
        else //If we're connected we want to let the server know to unauthenticate us. If we're not connected, simply delete
        //the credential so we dont become authenticated next time we connect.
        if (this.connected_) this.sendRequest("unauth", {}, ()=>{});
        this.reduceReconnectDelayIfAdminCredential_(token);
    }
    reduceReconnectDelayIfAdminCredential_(credential) {
        // NOTE: This isn't intended to be bulletproof (a malicious developer can always just modify the client).
        // Additionally, we don't bother resetting the max delay back to the default if auth fails / expires.
        const isFirebaseSecret = credential && credential.length === 40;
        if (isFirebaseSecret || (0, $f43ebbd33d4c5d93$export$fc970ed23da99565)(credential)) {
            this.log_("Admin auth credential detected.  Reducing max reconnect time.");
            this.maxReconnectDelay_ = $30d3a405033775a4$var$RECONNECT_MAX_DELAY_FOR_ADMINS;
        }
    }
    refreshAppCheckToken(token) {
        this.appCheckToken_ = token;
        this.log_("App check token refreshed");
        if (this.appCheckToken_) this.tryAppCheck();
        else //If we're connected we want to let the server know to unauthenticate us.
        //If we're not connected, simply delete the credential so we dont become
        // authenticated next time we connect.
        if (this.connected_) this.sendRequest("unappeck", {}, ()=>{});
    }
    /**
     * Attempts to authenticate with the given credentials. If the authentication attempt fails, it's triggered like
     * a auth revoked (the connection is closed).
     */ tryAuth() {
        if (this.connected_ && this.authToken_) {
            const token = this.authToken_;
            const authMethod = (0, $f43ebbd33d4c5d93$export$9565ca3d387f8aa0)(token) ? "auth" : "gauth";
            const requestData = {
                cred: token
            };
            if (this.authOverride_ === null) requestData["noauth"] = true;
            else if (typeof this.authOverride_ === "object") requestData["authvar"] = this.authOverride_;
            this.sendRequest(authMethod, requestData, (res)=>{
                const status = res[/*status*/ "s"];
                const data = res[/*data*/ "d"] || "error";
                if (this.authToken_ === token) {
                    if (status === "ok") this.invalidAuthTokenCount_ = 0;
                    else // Triggers reconnect and force refresh for auth token
                    this.onAuthRevoked_(status, data);
                }
            });
        }
    }
    /**
     * Attempts to authenticate with the given token. If the authentication
     * attempt fails, it's triggered like the token was revoked (the connection is
     * closed).
     */ tryAppCheck() {
        if (this.connected_ && this.appCheckToken_) this.sendRequest("appcheck", {
            "token": this.appCheckToken_
        }, (res)=>{
            const status = res[/*status*/ "s"];
            const data = res[/*data*/ "d"] || "error";
            if (status === "ok") this.invalidAppCheckTokenCount_ = 0;
            else this.onAppCheckRevoked_(status, data);
        });
    }
    /**
     * @inheritDoc
     */ unlisten(query, tag) {
        const pathString = query._path.toString();
        const queryId = query._queryIdentifier;
        this.log_("Unlisten called for " + pathString + " " + queryId);
        (0, $f43ebbd33d4c5d93$export$a7a9523472993e97)(query._queryParams.isDefault() || !query._queryParams.loadsAllData(), "unlisten() called for non-default but complete query");
        const listen = this.removeListen_(pathString, queryId);
        if (listen && this.connected_) this.sendUnlisten_(pathString, queryId, query._queryObject, tag);
    }
    sendUnlisten_(pathString, queryId, queryObj, tag) {
        this.log_("Unlisten on " + pathString + " for " + queryId);
        const req = {
            p: pathString
        };
        const action = "n";
        // Only bother sending queryId if it's non-default.
        if (tag) {
            req["q"] = queryObj;
            req["t"] = tag;
        }
        this.sendRequest(action, req);
    }
    onDisconnectPut(pathString, data, onComplete) {
        this.initConnection_();
        if (this.connected_) this.sendOnDisconnect_("o", pathString, data, onComplete);
        else this.onDisconnectRequestQueue_.push({
            pathString: pathString,
            action: "o",
            data: data,
            onComplete: onComplete
        });
    }
    onDisconnectMerge(pathString, data, onComplete) {
        this.initConnection_();
        if (this.connected_) this.sendOnDisconnect_("om", pathString, data, onComplete);
        else this.onDisconnectRequestQueue_.push({
            pathString: pathString,
            action: "om",
            data: data,
            onComplete: onComplete
        });
    }
    onDisconnectCancel(pathString, onComplete) {
        this.initConnection_();
        if (this.connected_) this.sendOnDisconnect_("oc", pathString, null, onComplete);
        else this.onDisconnectRequestQueue_.push({
            pathString: pathString,
            action: "oc",
            data: null,
            onComplete: onComplete
        });
    }
    sendOnDisconnect_(action, pathString, data, onComplete) {
        const request = {
            p: pathString,
            /*data*/ d: data
        };
        this.log_("onDisconnect " + action, request);
        this.sendRequest(action, request, (response)=>{
            if (onComplete) setTimeout(()=>{
                onComplete(response[/*status*/ "s"], response[/* data */ "d"]);
            }, Math.floor(0));
        });
    }
    put(pathString, data, onComplete, hash) {
        this.putInternal("p", pathString, data, onComplete, hash);
    }
    merge(pathString, data, onComplete, hash) {
        this.putInternal("m", pathString, data, onComplete, hash);
    }
    putInternal(action, pathString, data, onComplete, hash) {
        this.initConnection_();
        const request = {
            /*path*/ p: pathString,
            /*data*/ d: data
        };
        if (hash !== undefined) request[/*hash*/ "h"] = hash;
        // TODO: Only keep track of the most recent put for a given path?
        this.outstandingPuts_.push({
            action: action,
            request: request,
            onComplete: onComplete
        });
        this.outstandingPutCount_++;
        const index = this.outstandingPuts_.length - 1;
        if (this.connected_) this.sendPut_(index);
        else this.log_("Buffering put: " + pathString);
    }
    sendPut_(index) {
        const action = this.outstandingPuts_[index].action;
        const request = this.outstandingPuts_[index].request;
        const onComplete = this.outstandingPuts_[index].onComplete;
        this.outstandingPuts_[index].queued = this.connected_;
        this.sendRequest(action, request, (message)=>{
            this.log_(action + " response", message);
            delete this.outstandingPuts_[index];
            this.outstandingPutCount_--;
            // Clean up array occasionally.
            if (this.outstandingPutCount_ === 0) this.outstandingPuts_ = [];
            if (onComplete) onComplete(message[/*status*/ "s"], message[/* data */ "d"]);
        });
    }
    reportStats(stats) {
        // If we're not connected, we just drop the stats.
        if (this.connected_) {
            const request = {
                c: stats
            };
            this.log_("reportStats", request);
            this.sendRequest(/*stats*/ "s", request, (result)=>{
                const status = result[/*status*/ "s"];
                if (status !== "ok") {
                    const errorReason = result[/* data */ "d"];
                    this.log_("reportStats", "Error sending stats: " + errorReason);
                }
            });
        }
    }
    onDataMessage_(message) {
        if ("r" in message) {
            // this is a response
            this.log_("from server: " + (0, $f43ebbd33d4c5d93$export$fac44ee5b035f737)(message));
            const reqNum = message["r"];
            const onResponse = this.requestCBHash_[reqNum];
            if (onResponse) {
                delete this.requestCBHash_[reqNum];
                onResponse(message[/*body*/ "b"]);
            }
        } else if ("error" in message) throw "A server-side error has occurred: " + message["error"];
        else if ("a" in message) // a and b are action and body, respectively
        this.onDataPush_(message["a"], message["b"]);
    }
    onDataPush_(action, body) {
        this.log_("handleServerMessage", action, body);
        if (action === "d") this.onDataUpdate_(body[/*path*/ "p"], body[/*data*/ "d"], /*isMerge*/ false, body["t"]);
        else if (action === "m") this.onDataUpdate_(body[/*path*/ "p"], body[/*data*/ "d"], /*isMerge=*/ true, body["t"]);
        else if (action === "c") this.onListenRevoked_(body[/*path*/ "p"], body[/*query*/ "q"]);
        else if (action === "ac") this.onAuthRevoked_(body[/*status code*/ "s"], body[/* explanation */ "d"]);
        else if (action === "apc") this.onAppCheckRevoked_(body[/*status code*/ "s"], body[/* explanation */ "d"]);
        else if (action === "sd") this.onSecurityDebugPacket_(body);
        else $30d3a405033775a4$var$error("Unrecognized action received from server: " + (0, $f43ebbd33d4c5d93$export$fac44ee5b035f737)(action) + "\nAre you using the latest client?");
    }
    onReady_(timestamp, sessionId) {
        this.log_("connection ready");
        this.connected_ = true;
        this.lastConnectionEstablishedTime_ = new Date().getTime();
        this.handleTimestamp_(timestamp);
        this.lastSessionId = sessionId;
        if (this.firstConnection_) this.sendConnectStats_();
        this.restoreState_();
        this.firstConnection_ = false;
        this.onConnectStatus_(true);
    }
    scheduleConnect_(timeout) {
        (0, $f43ebbd33d4c5d93$export$a7a9523472993e97)(!this.realtime_, "Scheduling a connect when we're already connected/ing?");
        if (this.establishConnectionTimer_) clearTimeout(this.establishConnectionTimer_);
        // NOTE: Even when timeout is 0, it's important to do a setTimeout to work around an infuriating "Security Error" in
        // Firefox when trying to write to our long-polling iframe in some scenarios (e.g. Forge or our unit tests).
        this.establishConnectionTimer_ = setTimeout(()=>{
            this.establishConnectionTimer_ = null;
            this.establishConnection_();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        }, Math.floor(timeout));
    }
    initConnection_() {
        if (!this.realtime_ && this.firstConnection_) this.scheduleConnect_(0);
    }
    onVisible_(visible) {
        // NOTE: Tabbing away and back to a window will defeat our reconnect backoff, but I think that's fine.
        if (visible && !this.visible_ && this.reconnectDelay_ === this.maxReconnectDelay_) {
            this.log_("Window became visible.  Reducing delay.");
            this.reconnectDelay_ = $30d3a405033775a4$var$RECONNECT_MIN_DELAY;
            if (!this.realtime_) this.scheduleConnect_(0);
        }
        this.visible_ = visible;
    }
    onOnline_(online) {
        if (online) {
            this.log_("Browser went online.");
            this.reconnectDelay_ = $30d3a405033775a4$var$RECONNECT_MIN_DELAY;
            if (!this.realtime_) this.scheduleConnect_(0);
        } else {
            this.log_("Browser went offline.  Killing connection.");
            if (this.realtime_) this.realtime_.close();
        }
    }
    onRealtimeDisconnect_() {
        this.log_("data client disconnected");
        this.connected_ = false;
        this.realtime_ = null;
        // Since we don't know if our sent transactions succeeded or not, we need to cancel them.
        this.cancelSentTransactions_();
        // Clear out the pending requests.
        this.requestCBHash_ = {};
        if (this.shouldReconnect_()) {
            if (!this.visible_) {
                this.log_("Window isn't visible.  Delaying reconnect.");
                this.reconnectDelay_ = this.maxReconnectDelay_;
                this.lastConnectionAttemptTime_ = new Date().getTime();
            } else if (this.lastConnectionEstablishedTime_) {
                // If we've been connected long enough, reset reconnect delay to minimum.
                const timeSinceLastConnectSucceeded = new Date().getTime() - this.lastConnectionEstablishedTime_;
                if (timeSinceLastConnectSucceeded > $30d3a405033775a4$var$RECONNECT_DELAY_RESET_TIMEOUT) this.reconnectDelay_ = $30d3a405033775a4$var$RECONNECT_MIN_DELAY;
                this.lastConnectionEstablishedTime_ = null;
            }
            const timeSinceLastConnectAttempt = new Date().getTime() - this.lastConnectionAttemptTime_;
            let reconnectDelay = Math.max(0, this.reconnectDelay_ - timeSinceLastConnectAttempt);
            reconnectDelay = Math.random() * reconnectDelay;
            this.log_("Trying to reconnect in " + reconnectDelay + "ms");
            this.scheduleConnect_(reconnectDelay);
            // Adjust reconnect delay for next time.
            this.reconnectDelay_ = Math.min(this.maxReconnectDelay_, this.reconnectDelay_ * $30d3a405033775a4$var$RECONNECT_DELAY_MULTIPLIER);
        }
        this.onConnectStatus_(false);
    }
    async establishConnection_() {
        if (this.shouldReconnect_()) {
            this.log_("Making a connection attempt");
            this.lastConnectionAttemptTime_ = new Date().getTime();
            this.lastConnectionEstablishedTime_ = null;
            const onDataMessage = this.onDataMessage_.bind(this);
            const onReady = this.onReady_.bind(this);
            const onDisconnect = this.onRealtimeDisconnect_.bind(this);
            const connId = this.id + ":" + $30d3a405033775a4$var$PersistentConnection.nextConnectionId_++;
            const lastSessionId = this.lastSessionId;
            let canceled = false;
            let connection = null;
            const closeFn = function() {
                if (connection) connection.close();
                else {
                    canceled = true;
                    onDisconnect();
                }
            };
            const sendRequestFn = function(msg) {
                (0, $f43ebbd33d4c5d93$export$a7a9523472993e97)(connection, "sendRequest call when we're not connected not allowed.");
                connection.sendRequest(msg);
            };
            this.realtime_ = {
                close: closeFn,
                sendRequest: sendRequestFn
            };
            const forceRefresh = this.forceTokenRefresh_;
            this.forceTokenRefresh_ = false;
            try {
                // First fetch auth and app check token, and establish connection after
                // fetching the token was successful
                const [authToken, appCheckToken] = await Promise.all([
                    this.authTokenProvider_.getToken(forceRefresh),
                    this.appCheckTokenProvider_.getToken(forceRefresh)
                ]);
                if (!canceled) {
                    $30d3a405033775a4$var$log("getToken() completed. Creating connection.");
                    this.authToken_ = authToken && authToken.accessToken;
                    this.appCheckToken_ = appCheckToken && appCheckToken.token;
                    connection = new $30d3a405033775a4$var$Connection(connId, this.repoInfo_, this.applicationId_, this.appCheckToken_, this.authToken_, onDataMessage, onReady, onDisconnect, /* onKill= */ (reason)=>{
                        $30d3a405033775a4$var$warn(reason + " (" + this.repoInfo_.toString() + ")");
                        this.interrupt($30d3a405033775a4$var$SERVER_KILL_INTERRUPT_REASON);
                    }, lastSessionId);
                } else $30d3a405033775a4$var$log("getToken() completed but was canceled");
            } catch (error) {
                this.log_("Failed to get token: " + error);
                if (!canceled) {
                    if (this.repoInfo_.nodeAdmin) // This may be a critical error for the Admin Node.js SDK, so log a warning.
                    // But getToken() may also just have temporarily failed, so we still want to
                    // continue retrying.
                    $30d3a405033775a4$var$warn(error);
                    closeFn();
                }
            }
        }
    }
    interrupt(reason) {
        $30d3a405033775a4$var$log("Interrupting connection for reason: " + reason);
        this.interruptReasons_[reason] = true;
        if (this.realtime_) this.realtime_.close();
        else {
            if (this.establishConnectionTimer_) {
                clearTimeout(this.establishConnectionTimer_);
                this.establishConnectionTimer_ = null;
            }
            if (this.connected_) this.onRealtimeDisconnect_();
        }
    }
    resume(reason) {
        $30d3a405033775a4$var$log("Resuming connection for reason: " + reason);
        delete this.interruptReasons_[reason];
        if ((0, $f43ebbd33d4c5d93$export$dd1bc94b04021eeb)(this.interruptReasons_)) {
            this.reconnectDelay_ = $30d3a405033775a4$var$RECONNECT_MIN_DELAY;
            if (!this.realtime_) this.scheduleConnect_(0);
        }
    }
    handleTimestamp_(timestamp) {
        const delta = timestamp - new Date().getTime();
        this.onServerInfoUpdate_({
            serverTimeOffset: delta
        });
    }
    cancelSentTransactions_() {
        for(let i = 0; i < this.outstandingPuts_.length; i++){
            const put = this.outstandingPuts_[i];
            if (put && /*hash*/ "h" in put.request && put.queued) {
                if (put.onComplete) put.onComplete("disconnect");
                delete this.outstandingPuts_[i];
                this.outstandingPutCount_--;
            }
        }
        // Clean up array occasionally.
        if (this.outstandingPutCount_ === 0) this.outstandingPuts_ = [];
    }
    onListenRevoked_(pathString, query) {
        // Remove the listen and manufacture a "permission_denied" error for the failed listen.
        let queryId;
        if (!query) queryId = "default";
        else queryId = query.map((q)=>$30d3a405033775a4$var$ObjectToUniqueKey(q)).join("$");
        const listen = this.removeListen_(pathString, queryId);
        if (listen && listen.onComplete) listen.onComplete("permission_denied");
    }
    removeListen_(pathString, queryId) {
        const normalizedPathString = new $30d3a405033775a4$var$Path(pathString).toString(); // normalize path.
        let listen;
        if (this.listens.has(normalizedPathString)) {
            const map = this.listens.get(normalizedPathString);
            listen = map.get(queryId);
            map.delete(queryId);
            if (map.size === 0) this.listens.delete(normalizedPathString);
        } else // all listens for this path has already been removed
        listen = undefined;
        return listen;
    }
    onAuthRevoked_(statusCode, explanation) {
        $30d3a405033775a4$var$log("Auth token revoked: " + statusCode + "/" + explanation);
        this.authToken_ = null;
        this.forceTokenRefresh_ = true;
        this.realtime_.close();
        if (statusCode === "invalid_token" || statusCode === "permission_denied") {
            // We'll wait a couple times before logging the warning / increasing the
            // retry period since oauth tokens will report as "invalid" if they're
            // just expired. Plus there may be transient issues that resolve themselves.
            this.invalidAuthTokenCount_++;
            if (this.invalidAuthTokenCount_ >= $30d3a405033775a4$var$INVALID_TOKEN_THRESHOLD) {
                // Set a long reconnect delay because recovery is unlikely
                this.reconnectDelay_ = $30d3a405033775a4$var$RECONNECT_MAX_DELAY_FOR_ADMINS;
                // Notify the auth token provider that the token is invalid, which will log
                // a warning
                this.authTokenProvider_.notifyForInvalidToken();
            }
        }
    }
    onAppCheckRevoked_(statusCode, explanation) {
        $30d3a405033775a4$var$log("App check token revoked: " + statusCode + "/" + explanation);
        this.appCheckToken_ = null;
        this.forceTokenRefresh_ = true;
        // Note: We don't close the connection as the developer may not have
        // enforcement enabled. The backend closes connections with enforcements.
        if (statusCode === "invalid_token" || statusCode === "permission_denied") {
            // We'll wait a couple times before logging the warning / increasing the
            // retry period since oauth tokens will report as "invalid" if they're
            // just expired. Plus there may be transient issues that resolve themselves.
            this.invalidAppCheckTokenCount_++;
            if (this.invalidAppCheckTokenCount_ >= $30d3a405033775a4$var$INVALID_TOKEN_THRESHOLD) this.appCheckTokenProvider_.notifyForInvalidToken();
        }
    }
    onSecurityDebugPacket_(body) {
        if (this.securityDebugCallback_) this.securityDebugCallback_(body);
        else if ("msg" in body) console.log("FIREBASE: " + body["msg"].replace("\n", "\nFIREBASE: "));
    }
    restoreState_() {
        //Re-authenticate ourselves if we have a credential stored.
        this.tryAuth();
        this.tryAppCheck();
        // Puts depend on having received the corresponding data update from the server before they complete, so we must
        // make sure to send listens before puts.
        for (const queries of this.listens.values())for (const listenSpec of queries.values())this.sendListen_(listenSpec);
        for(let i = 0; i < this.outstandingPuts_.length; i++)if (this.outstandingPuts_[i]) this.sendPut_(i);
        while(this.onDisconnectRequestQueue_.length){
            const request = this.onDisconnectRequestQueue_.shift();
            this.sendOnDisconnect_(request.action, request.pathString, request.data, request.onComplete);
        }
        for(let i = 0; i < this.outstandingGets_.length; i++)if (this.outstandingGets_[i]) this.sendGet_(i);
    }
    /**
     * Sends client stats for first connection
     */ sendConnectStats_() {
        const stats = {};
        let clientName = "js";
        if ((0, $f43ebbd33d4c5d93$export$5d1d834fbbf8bab7)()) {
            if (this.repoInfo_.nodeAdmin) clientName = "admin_node";
            else clientName = "node";
        }
        stats["sdk." + clientName + "." + $30d3a405033775a4$var$SDK_VERSION.replace(/\./g, "-")] = 1;
        if ((0, $f43ebbd33d4c5d93$export$872f8323f01d7ae0)()) stats["framework.cordova"] = 1;
        else if ((0, $f43ebbd33d4c5d93$export$f7a1e23e542d38e3)()) stats["framework.reactnative"] = 1;
        this.reportStats(stats);
    }
    shouldReconnect_() {
        const online = $30d3a405033775a4$var$OnlineMonitor.getInstance().currentlyOnline();
        return (0, $f43ebbd33d4c5d93$export$dd1bc94b04021eeb)(this.interruptReasons_) && online;
    }
    /**
     * @param repoInfo_ - Data about the namespace we are connecting to
     * @param applicationId_ - The Firebase App ID for this project
     * @param onDataUpdate_ - A callback for new data from the server
     */ constructor(repoInfo_, applicationId_, onDataUpdate_, onConnectStatus_, onServerInfoUpdate_, authTokenProvider_, appCheckTokenProvider_, authOverride_){
        super();
        this.repoInfo_ = repoInfo_;
        this.applicationId_ = applicationId_;
        this.onDataUpdate_ = onDataUpdate_;
        this.onConnectStatus_ = onConnectStatus_;
        this.onServerInfoUpdate_ = onServerInfoUpdate_;
        this.authTokenProvider_ = authTokenProvider_;
        this.appCheckTokenProvider_ = appCheckTokenProvider_;
        this.authOverride_ = authOverride_;
        // Used for diagnostic logging.
        this.id = $30d3a405033775a4$var$PersistentConnection.nextPersistentConnectionId_++;
        this.log_ = $30d3a405033775a4$var$logWrapper("p:" + this.id + ":");
        this.interruptReasons_ = {};
        this.listens = new Map();
        this.outstandingPuts_ = [];
        this.outstandingGets_ = [];
        this.outstandingPutCount_ = 0;
        this.outstandingGetCount_ = 0;
        this.onDisconnectRequestQueue_ = [];
        this.connected_ = false;
        this.reconnectDelay_ = $30d3a405033775a4$var$RECONNECT_MIN_DELAY;
        this.maxReconnectDelay_ = $30d3a405033775a4$var$RECONNECT_MAX_DELAY_DEFAULT;
        this.securityDebugCallback_ = null;
        this.lastSessionId = null;
        this.establishConnectionTimer_ = null;
        this.visible_ = false;
        // Before we get connected, we keep a queue of pending messages to send.
        this.requestCBHash_ = {};
        this.requestNumber_ = 0;
        this.realtime_ = null;
        this.authToken_ = null;
        this.appCheckToken_ = null;
        this.forceTokenRefresh_ = false;
        this.invalidAuthTokenCount_ = 0;
        this.invalidAppCheckTokenCount_ = 0;
        this.firstConnection_ = true;
        this.lastConnectionAttemptTime_ = null;
        this.lastConnectionEstablishedTime_ = null;
        if (authOverride_ && !(0, $f43ebbd33d4c5d93$export$5d1d834fbbf8bab7)()) throw new Error("Auth override specified in options, but not supported on non Node.js platforms");
        $30d3a405033775a4$var$VisibilityMonitor.getInstance().on("visible", this.onVisible_, this);
        if (repoInfo_.host.indexOf("fblocal") === -1) $30d3a405033775a4$var$OnlineMonitor.getInstance().on("online", this.onOnline_, this);
    }
}
$30d3a405033775a4$var$PersistentConnection.nextPersistentConnectionId_ = 0;
/**
 * Counter for number of connections created. Mainly used for tagging in the logs
 */ $30d3a405033775a4$var$PersistentConnection.nextConnectionId_ = 0;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $30d3a405033775a4$var$NamedNode {
    static Wrap(name, node) {
        return new $30d3a405033775a4$var$NamedNode(name, node);
    }
    constructor(name, node){
        this.name = name;
        this.node = node;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $30d3a405033775a4$var$Index {
    /**
     * @returns A standalone comparison function for
     * this index
     */ getCompare() {
        return this.compare.bind(this);
    }
    /**
     * Given a before and after value for a node, determine if the indexed value has changed. Even if they are different,
     * it's possible that the changes are isolated to parts of the snapshot that are not indexed.
     *
     *
     * @returns True if the portion of the snapshot being indexed changed between oldNode and newNode
     */ indexedValueChanged(oldNode, newNode) {
        const oldWrapped = new $30d3a405033775a4$var$NamedNode($30d3a405033775a4$var$MIN_NAME, oldNode);
        const newWrapped = new $30d3a405033775a4$var$NamedNode($30d3a405033775a4$var$MIN_NAME, newNode);
        return this.compare(oldWrapped, newWrapped) !== 0;
    }
    /**
     * @returns a node wrapper that will sort equal to or less than
     * any other node wrapper, using this index
     */ minPost() {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return $30d3a405033775a4$var$NamedNode.MIN;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $30d3a405033775a4$var$__EMPTY_NODE;
class $30d3a405033775a4$var$KeyIndex extends $30d3a405033775a4$var$Index {
    static get __EMPTY_NODE() {
        return $30d3a405033775a4$var$__EMPTY_NODE;
    }
    static set __EMPTY_NODE(val) {
        $30d3a405033775a4$var$__EMPTY_NODE = val;
    }
    compare(a, b) {
        return $30d3a405033775a4$var$nameCompare(a.name, b.name);
    }
    isDefinedOn(node) {
        // We could probably return true here (since every node has a key), but it's never called
        // so just leaving unimplemented for now.
        throw (0, $f43ebbd33d4c5d93$export$a39cad550e7ab28a)("KeyIndex.isDefinedOn not expected to be called.");
    }
    indexedValueChanged(oldNode, newNode) {
        return false; // The key for a node never changes.
    }
    minPost() {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return $30d3a405033775a4$var$NamedNode.MIN;
    }
    maxPost() {
        // TODO: This should really be created once and cached in a static property, but
        // NamedNode isn't defined yet, so I can't use it in a static.  Bleh.
        return new $30d3a405033775a4$var$NamedNode($30d3a405033775a4$var$MAX_NAME, $30d3a405033775a4$var$__EMPTY_NODE);
    }
    makePost(indexValue, name) {
        (0, $f43ebbd33d4c5d93$export$a7a9523472993e97)(typeof indexValue === "string", "KeyIndex indexValue must always be a string.");
        // We just use empty node, but it'll never be compared, since our comparator only looks at name.
        return new $30d3a405033775a4$var$NamedNode(indexValue, $30d3a405033775a4$var$__EMPTY_NODE);
    }
    /**
     * @returns String representation for inclusion in a query spec
     */ toString() {
        return ".key";
    }
}
const $30d3a405033775a4$var$KEY_INDEX = new $30d3a405033775a4$var$KeyIndex();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An iterator over an LLRBNode.
 */ class $30d3a405033775a4$var$SortedMapIterator {
    getNext() {
        if (this.nodeStack_.length === 0) return null;
        let node = this.nodeStack_.pop();
        let result;
        if (this.resultGenerator_) result = this.resultGenerator_(node.key, node.value);
        else result = {
            key: node.key,
            value: node.value
        };
        if (this.isReverse_) {
            node = node.left;
            while(!node.isEmpty()){
                this.nodeStack_.push(node);
                node = node.right;
            }
        } else {
            node = node.right;
            while(!node.isEmpty()){
                this.nodeStack_.push(node);
                node = node.left;
            }
        }
        return result;
    }
    hasNext() {
        return this.nodeStack_.length > 0;
    }
    peek() {
        if (this.nodeStack_.length === 0) return null;
        const node = this.nodeStack_[this.nodeStack_.length - 1];
        if (this.resultGenerator_) return this.resultGenerator_(node.key, node.value);
        else return {
            key: node.key,
            value: node.value
        };
    }
    /**
     * @param node - Node to iterate.
     * @param isReverse_ - Whether or not to iterate in reverse
     */ constructor(node, startKey, comparator, isReverse_, resultGenerator_ = null){
        this.isReverse_ = isReverse_;
        this.resultGenerator_ = resultGenerator_;
        this.nodeStack_ = [];
        let cmp = 1;
        while(!node.isEmpty()){
            node;
            cmp = startKey ? comparator(node.key, startKey) : 1;
            // flip the comparison if we're going in reverse
            if (isReverse_) cmp *= -1;
            if (cmp < 0) {
                // This node is less than our start key. ignore it
                if (this.isReverse_) node = node.left;
                else node = node.right;
            } else if (cmp === 0) {
                // This node is exactly equal to our start key. Push it on the stack, but stop iterating;
                this.nodeStack_.push(node);
                break;
            } else {
                // This node is greater than our start key, add it to the stack and move to the next one
                this.nodeStack_.push(node);
                if (this.isReverse_) node = node.right;
                else node = node.left;
            }
        }
    }
}
/**
 * Represents a node in a Left-leaning Red-Black tree.
 */ class $30d3a405033775a4$var$LLRBNode {
    /**
     * Returns a copy of the current node, optionally replacing pieces of it.
     *
     * @param key - New key for the node, or null.
     * @param value - New value for the node, or null.
     * @param color - New color for the node, or null.
     * @param left - New left child for the node, or null.
     * @param right - New right child for the node, or null.
     * @returns The node copy.
     */ copy(key, value, color, left, right) {
        return new $30d3a405033775a4$var$LLRBNode(key != null ? key : this.key, value != null ? value : this.value, color != null ? color : this.color, left != null ? left : this.left, right != null ? right : this.right);
    }
    /**
     * @returns The total number of nodes in the tree.
     */ count() {
        return this.left.count() + 1 + this.right.count();
    }
    /**
     * @returns True if the tree is empty.
     */ isEmpty() {
        return false;
    }
    /**
     * Traverses the tree in key order and calls the specified action function
     * for each node.
     *
     * @param action - Callback function to be called for each
     *   node.  If it returns true, traversal is aborted.
     * @returns The first truthy value returned by action, or the last falsey
     *   value returned by action
     */ inorderTraversal(action) {
        return this.left.inorderTraversal(action) || !!action(this.key, this.value) || this.right.inorderTraversal(action);
    }
    /**
     * Traverses the tree in reverse key order and calls the specified action function
     * for each node.
     *
     * @param action - Callback function to be called for each
     * node.  If it returns true, traversal is aborted.
     * @returns True if traversal was aborted.
     */ reverseTraversal(action) {
        return this.right.reverseTraversal(action) || action(this.key, this.value) || this.left.reverseTraversal(action);
    }
    /**
     * @returns The minimum node in the tree.
     */ min_() {
        if (this.left.isEmpty()) return this;
        else return this.left.min_();
    }
    /**
     * @returns The maximum key in the tree.
     */ minKey() {
        return this.min_().key;
    }
    /**
     * @returns The maximum key in the tree.
     */ maxKey() {
        if (this.right.isEmpty()) return this.key;
        else return this.right.maxKey();
    }
    /**
     * @param key - Key to insert.
     * @param value - Value to insert.
     * @param comparator - Comparator.
     * @returns New tree, with the key/value added.
     */ insert(key, value, comparator) {
        let n = this;
        const cmp = comparator(key, n.key);
        if (cmp < 0) n = n.copy(null, null, null, n.left.insert(key, value, comparator), null);
        else if (cmp === 0) n = n.copy(null, value, null, null, null);
        else n = n.copy(null, null, null, null, n.right.insert(key, value, comparator));
        return n.fixUp_();
    }
    /**
     * @returns New tree, with the minimum key removed.
     */ removeMin_() {
        if (this.left.isEmpty()) return $30d3a405033775a4$var$SortedMap.EMPTY_NODE;
        let n = this;
        if (!n.left.isRed_() && !n.left.left.isRed_()) n = n.moveRedLeft_();
        n = n.copy(null, null, null, n.left.removeMin_(), null);
        return n.fixUp_();
    }
    /**
     * @param key - The key of the item to remove.
     * @param comparator - Comparator.
     * @returns New tree, with the specified item removed.
     */ remove(key, comparator) {
        let n, smallest;
        n = this;
        if (comparator(key, n.key) < 0) {
            if (!n.left.isEmpty() && !n.left.isRed_() && !n.left.left.isRed_()) n = n.moveRedLeft_();
            n = n.copy(null, null, null, n.left.remove(key, comparator), null);
        } else {
            if (n.left.isRed_()) n = n.rotateRight_();
            if (!n.right.isEmpty() && !n.right.isRed_() && !n.right.left.isRed_()) n = n.moveRedRight_();
            if (comparator(key, n.key) === 0) {
                if (n.right.isEmpty()) return $30d3a405033775a4$var$SortedMap.EMPTY_NODE;
                else {
                    smallest = n.right.min_();
                    n = n.copy(smallest.key, smallest.value, null, null, n.right.removeMin_());
                }
            }
            n = n.copy(null, null, null, null, n.right.remove(key, comparator));
        }
        return n.fixUp_();
    }
    /**
     * @returns Whether this is a RED node.
     */ isRed_() {
        return this.color;
    }
    /**
     * @returns New tree after performing any needed rotations.
     */ fixUp_() {
        let n = this;
        if (n.right.isRed_() && !n.left.isRed_()) n = n.rotateLeft_();
        if (n.left.isRed_() && n.left.left.isRed_()) n = n.rotateRight_();
        if (n.left.isRed_() && n.right.isRed_()) n = n.colorFlip_();
        return n;
    }
    /**
     * @returns New tree, after moveRedLeft.
     */ moveRedLeft_() {
        let n = this.colorFlip_();
        if (n.right.left.isRed_()) {
            n = n.copy(null, null, null, null, n.right.rotateRight_());
            n = n.rotateLeft_();
            n = n.colorFlip_();
        }
        return n;
    }
    /**
     * @returns New tree, after moveRedRight.
     */ moveRedRight_() {
        let n = this.colorFlip_();
        if (n.left.left.isRed_()) {
            n = n.rotateRight_();
            n = n.colorFlip_();
        }
        return n;
    }
    /**
     * @returns New tree, after rotateLeft.
     */ rotateLeft_() {
        const nl = this.copy(null, null, $30d3a405033775a4$var$LLRBNode.RED, null, this.right.left);
        return this.right.copy(null, null, this.color, nl, null);
    }
    /**
     * @returns New tree, after rotateRight.
     */ rotateRight_() {
        const nr = this.copy(null, null, $30d3a405033775a4$var$LLRBNode.RED, this.left.right, null);
        return this.left.copy(null, null, this.color, null, nr);
    }
    /**
     * @returns Newt ree, after colorFlip.
     */ colorFlip_() {
        const left = this.left.copy(null, null, !this.left.color, null, null);
        const right = this.right.copy(null, null, !this.right.color, null, null);
        return this.copy(null, null, !this.color, left, right);
    }
    /**
     * For testing.
     *
     * @returns True if all is well.
     */ checkMaxDepth_() {
        const blackDepth = this.check_();
        return Math.pow(2.0, blackDepth) <= this.count() + 1;
    }
    check_() {
        if (this.isRed_() && this.left.isRed_()) throw new Error("Red node has red child(" + this.key + "," + this.value + ")");
        if (this.right.isRed_()) throw new Error("Right child of (" + this.key + "," + this.value + ") is red");
        const blackDepth = this.left.check_();
        if (blackDepth !== this.right.check_()) throw new Error("Black depths differ");
        else return blackDepth + (this.isRed_() ? 0 : 1);
    }
    /**
     * @param key - Key associated with this node.
     * @param value - Value associated with this node.
     * @param color - Whether this node is red.
     * @param left - Left child.
     * @param right - Right child.
     */ constructor(key, value, color, left, right){
        this.key = key;
        this.value = value;
        this.color = color != null ? color : $30d3a405033775a4$var$LLRBNode.RED;
        this.left = left != null ? left : $30d3a405033775a4$var$SortedMap.EMPTY_NODE;
        this.right = right != null ? right : $30d3a405033775a4$var$SortedMap.EMPTY_NODE;
    }
}
$30d3a405033775a4$var$LLRBNode.RED = true;
$30d3a405033775a4$var$LLRBNode.BLACK = false;
/**
 * Represents an empty node (a leaf node in the Red-Black Tree).
 */ class $30d3a405033775a4$var$LLRBEmptyNode {
    /**
     * Returns a copy of the current node.
     *
     * @returns The node copy.
     */ copy(key, value, color, left, right) {
        return this;
    }
    /**
     * Returns a copy of the tree, with the specified key/value added.
     *
     * @param key - Key to be added.
     * @param value - Value to be added.
     * @param comparator - Comparator.
     * @returns New tree, with item added.
     */ insert(key, value, comparator) {
        return new $30d3a405033775a4$var$LLRBNode(key, value, null);
    }
    /**
     * Returns a copy of the tree, with the specified key removed.
     *
     * @param key - The key to remove.
     * @param comparator - Comparator.
     * @returns New tree, with item removed.
     */ remove(key, comparator) {
        return this;
    }
    /**
     * @returns The total number of nodes in the tree.
     */ count() {
        return 0;
    }
    /**
     * @returns True if the tree is empty.
     */ isEmpty() {
        return true;
    }
    /**
     * Traverses the tree in key order and calls the specified action function
     * for each node.
     *
     * @param action - Callback function to be called for each
     * node.  If it returns true, traversal is aborted.
     * @returns True if traversal was aborted.
     */ inorderTraversal(action) {
        return false;
    }
    /**
     * Traverses the tree in reverse key order and calls the specified action function
     * for each node.
     *
     * @param action - Callback function to be called for each
     * node.  If it returns true, traversal is aborted.
     * @returns True if traversal was aborted.
     */ reverseTraversal(action) {
        return false;
    }
    minKey() {
        return null;
    }
    maxKey() {
        return null;
    }
    check_() {
        return 0;
    }
    /**
     * @returns Whether this node is red.
     */ isRed_() {
        return false;
    }
}
/**
 * An immutable sorted map implementation, based on a Left-leaning Red-Black
 * tree.
 */ class $30d3a405033775a4$var$SortedMap {
    /**
     * Returns a copy of the map, with the specified key/value added or replaced.
     * (TODO: We should perhaps rename this method to 'put')
     *
     * @param key - Key to be added.
     * @param value - Value to be added.
     * @returns New map, with item added.
     */ insert(key, value) {
        return new $30d3a405033775a4$var$SortedMap(this.comparator_, this.root_.insert(key, value, this.comparator_).copy(null, null, $30d3a405033775a4$var$LLRBNode.BLACK, null, null));
    }
    /**
     * Returns a copy of the map, with the specified key removed.
     *
     * @param key - The key to remove.
     * @returns New map, with item removed.
     */ remove(key) {
        return new $30d3a405033775a4$var$SortedMap(this.comparator_, this.root_.remove(key, this.comparator_).copy(null, null, $30d3a405033775a4$var$LLRBNode.BLACK, null, null));
    }
    /**
     * Returns the value of the node with the given key, or null.
     *
     * @param key - The key to look up.
     * @returns The value of the node with the given key, or null if the
     * key doesn't exist.
     */ get(key) {
        let cmp;
        let node = this.root_;
        while(!node.isEmpty()){
            cmp = this.comparator_(key, node.key);
            if (cmp === 0) return node.value;
            else if (cmp < 0) node = node.left;
            else if (cmp > 0) node = node.right;
        }
        return null;
    }
    /**
     * Returns the key of the item *before* the specified key, or null if key is the first item.
     * @param key - The key to find the predecessor of
     * @returns The predecessor key.
     */ getPredecessorKey(key) {
        let cmp, node = this.root_, rightParent = null;
        while(!node.isEmpty()){
            cmp = this.comparator_(key, node.key);
            if (cmp === 0) {
                if (!node.left.isEmpty()) {
                    node = node.left;
                    while(!node.right.isEmpty())node = node.right;
                    return node.key;
                } else if (rightParent) return rightParent.key;
                else return null; // first item.
            } else if (cmp < 0) node = node.left;
            else if (cmp > 0) {
                rightParent = node;
                node = node.right;
            }
        }
        throw new Error("Attempted to find predecessor key for a nonexistent key.  What gives?");
    }
    /**
     * @returns True if the map is empty.
     */ isEmpty() {
        return this.root_.isEmpty();
    }
    /**
     * @returns The total number of nodes in the map.
     */ count() {
        return this.root_.count();
    }
    /**
     * @returns The minimum key in the map.
     */ minKey() {
        return this.root_.minKey();
    }
    /**
     * @returns The maximum key in the map.
     */ maxKey() {
        return this.root_.maxKey();
    }
    /**
     * Traverses the map in key order and calls the specified action function
     * for each key/value pair.
     *
     * @param action - Callback function to be called
     * for each key/value pair.  If action returns true, traversal is aborted.
     * @returns The first truthy value returned by action, or the last falsey
     *   value returned by action
     */ inorderTraversal(action) {
        return this.root_.inorderTraversal(action);
    }
    /**
     * Traverses the map in reverse key order and calls the specified action function
     * for each key/value pair.
     *
     * @param action - Callback function to be called
     * for each key/value pair.  If action returns true, traversal is aborted.
     * @returns True if the traversal was aborted.
     */ reverseTraversal(action) {
        return this.root_.reverseTraversal(action);
    }
    /**
     * Returns an iterator over the SortedMap.
     * @returns The iterator.
     */ getIterator(resultGenerator) {
        return new $30d3a405033775a4$var$SortedMapIterator(this.root_, null, this.comparator_, false, resultGenerator);
    }
    getIteratorFrom(key, resultGenerator) {
        return new $30d3a405033775a4$var$SortedMapIterator(this.root_, key, this.comparator_, false, resultGenerator);
    }
    getReverseIteratorFrom(key, resultGenerator) {
        return new $30d3a405033775a4$var$SortedMapIterator(this.root_, key, this.comparator_, true, resultGenerator);
    }
    getReverseIterator(resultGenerator) {
        return new $30d3a405033775a4$var$SortedMapIterator(this.root_, null, this.comparator_, true, resultGenerator);
    }
    /**
     * @param comparator_ - Key comparator.
     * @param root_ - Optional root node for the map.
     */ constructor(comparator_, root_ = $30d3a405033775a4$var$SortedMap.EMPTY_NODE){
        this.comparator_ = comparator_;
        this.root_ = root_;
    }
}
/**
 * Always use the same empty node, to reduce memory.
 */ $30d3a405033775a4$var$SortedMap.EMPTY_NODE = new $30d3a405033775a4$var$LLRBEmptyNode();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $30d3a405033775a4$var$NAME_ONLY_COMPARATOR(left, right) {
    return $30d3a405033775a4$var$nameCompare(left.name, right.name);
}
function $30d3a405033775a4$var$NAME_COMPARATOR(left, right) {
    return $30d3a405033775a4$var$nameCompare(left, right);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $30d3a405033775a4$var$MAX_NODE$2;
function $30d3a405033775a4$var$setMaxNode$1(val) {
    $30d3a405033775a4$var$MAX_NODE$2 = val;
}
const $30d3a405033775a4$var$priorityHashText = function(priority) {
    if (typeof priority === "number") return "number:" + $30d3a405033775a4$var$doubleToIEEE754String(priority);
    else return "string:" + priority;
};
/**
 * Validates that a priority snapshot Node is valid.
 */ const $30d3a405033775a4$var$validatePriorityNode = function(priorityNode) {
    if (priorityNode.isLeafNode()) {
        const val = priorityNode.val();
        (0, $f43ebbd33d4c5d93$export$a7a9523472993e97)(typeof val === "string" || typeof val === "number" || typeof val === "object" && (0, $f43ebbd33d4c5d93$export$2344b14b097df817)(val, ".sv"), "Priority must be a string or number.");
    } else (0, $f43ebbd33d4c5d93$export$a7a9523472993e97)(priorityNode === $30d3a405033775a4$var$MAX_NODE$2 || priorityNode.isEmpty(), "priority of unexpected type.");
    // Don't call getPriority() on MAX_NODE to avoid hitting assertion.
    (0, $f43ebbd33d4c5d93$export$a7a9523472993e97)(priorityNode === $30d3a405033775a4$var$MAX_NODE$2 || priorityNode.getPriority().isEmpty(), "Priority nodes can't have a priority of their own.");
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $30d3a405033775a4$var$__childrenNodeConstructor;
/**
 * LeafNode is a class for storing leaf nodes in a DataSnapshot.  It
 * implements Node and stores the value of the node (a string,
 * number, or boolean) accessible via getValue().
 */ class $30d3a405033775a4$var$LeafNode {
    static set __childrenNodeConstructor(val) {
        $30d3a405033775a4$var$__childrenNodeConstructor = val;
    }
    static get __childrenNodeConstructor() {
        return $30d3a405033775a4$var$__childrenNodeConstructor;
    }
    /** @inheritDoc */ isLeafNode() {
        return true;
    }
    /** @inheritDoc */ getPriority() {
        return this.priorityNode_;
    }
    /** @inheritDoc */ updatePriority(newPriorityNode) {
        return new $30d3a405033775a4$var$LeafNode(this.value_, newPriorityNode);
    }
    /** @inheritDoc */ getImmediateChild(childName) {
        // Hack to treat priority as a regular child
        if (childName === ".priority") return this.priorityNode_;
        else return $30d3a405033775a4$var$LeafNode.__childrenNodeConstructor.EMPTY_NODE;
    }
    /** @inheritDoc */ getChild(path) {
        if ($30d3a405033775a4$var$pathIsEmpty(path)) return this;
        else if ($30d3a405033775a4$var$pathGetFront(path) === ".priority") return this.priorityNode_;
        else return $30d3a405033775a4$var$LeafNode.__childrenNodeConstructor.EMPTY_NODE;
    }
    hasChild() {
        return false;
    }
    /** @inheritDoc */ getPredecessorChildName(childName, childNode) {
        return null;
    }
    /** @inheritDoc */ updateImmediateChild(childName, newChildNode) {
        if (childName === ".priority") return this.updatePriority(newChildNode);
        else if (newChildNode.isEmpty() && childName !== ".priority") return this;
        else return $30d3a405033775a4$var$LeafNode.__childrenNodeConstructor.EMPTY_NODE.updateImmediateChild(childName, newChildNode).updatePriority(this.priorityNode_);
    }
    /** @inheritDoc */ updateChild(path, newChildNode) {
        const front = $30d3a405033775a4$var$pathGetFront(path);
        if (front === null) return newChildNode;
        else if (newChildNode.isEmpty() && front !== ".priority") return this;
        else {
            (0, $f43ebbd33d4c5d93$export$a7a9523472993e97)(front !== ".priority" || $30d3a405033775a4$var$pathGetLength(path) === 1, ".priority must be the last token in a path");
            return this.updateImmediateChild(front, $30d3a405033775a4$var$LeafNode.__childrenNodeConstructor.EMPTY_NODE.updateChild($30d3a405033775a4$var$pathPopFront(path), newChildNode));
        }
    }
    /** @inheritDoc */ isEmpty() {
        return false;
    }
    /** @inheritDoc */ numChildren() {
        return 0;
    }
    /** @inheritDoc */ forEachChild(index, action) {
        return false;
    }
    val(exportFormat) {
        if (exportFormat && !this.getPriority().isEmpty()) return {
            ".value": this.getValue(),
            ".priority": this.getPriority().val()
        };
        else return this.getValue();
    }
    /** @inheritDoc */ hash() {
        if (this.lazyHash_ === null) {
            let toHash = "";
            if (!this.priorityNode_.isEmpty()) toHash += "priority:" + $30d3a405033775a4$var$priorityHashText(this.priorityNode_.val()) + ":";
            const type = typeof this.value_;
            toHash += type + ":";
            if (type === "number") toHash += $30d3a405033775a4$var$doubleToIEEE754String(this.value_);
            else toHash += this.value_;
            this.lazyHash_ = $30d3a405033775a4$var$sha1(toHash);
        }
        return this.lazyHash_;
    }
    /**
     * Returns the value of the leaf node.
     * @returns The value of the node.
     */ getValue() {
        return this.value_;
    }
    compareTo(other) {
        if (other === $30d3a405033775a4$var$LeafNode.__childrenNodeConstructor.EMPTY_NODE) return 1;
        else if (other instanceof $30d3a405033775a4$var$LeafNode.__childrenNodeConstructor) return -1;
        else {
            (0, $f43ebbd33d4c5d93$export$a7a9523472993e97)(other.isLeafNode(), "Unknown node type");
            return this.compareToLeafNode_(other);
        }
    }
    /**
     * Comparison specifically for two leaf nodes
     */ compareToLeafNode_(otherLeaf) {
        const otherLeafType = typeof otherLeaf.value_;
        const thisLeafType = typeof this.value_;
        const otherIndex = $30d3a405033775a4$var$LeafNode.VALUE_TYPE_ORDER.indexOf(otherLeafType);
        const thisIndex = $30d3a405033775a4$var$LeafNode.VALUE_TYPE_ORDER.indexOf(thisLeafType);
        (0, $f43ebbd33d4c5d93$export$a7a9523472993e97)(otherIndex >= 0, "Unknown leaf type: " + otherLeafType);
        (0, $f43ebbd33d4c5d93$export$a7a9523472993e97)(thisIndex >= 0, "Unknown leaf type: " + thisLeafType);
        if (otherIndex === thisIndex) {
            // Same type, compare values
            if (thisLeafType === "object") // Deferred value nodes are all equal, but we should also never get to this point...
            return 0;
            else {
                // Note that this works because true > false, all others are number or string comparisons
                if (this.value_ < otherLeaf.value_) return -1;
                else if (this.value_ === otherLeaf.value_) return 0;
                else return 1;
            }
        } else return thisIndex - otherIndex;
    }
    withIndex() {
        return this;
    }
    isIndexed() {
        return true;
    }
    equals(other) {
        if (other === this) return true;
        else if (other.isLeafNode()) {
            const otherLeaf = other;
            return this.value_ === otherLeaf.value_ && this.priorityNode_.equals(otherLeaf.priorityNode_);
        } else return false;
    }
    /**
     * @param value_ - The value to store in this leaf node. The object type is
     * possible in the event of a deferred value
     * @param priorityNode_ - The priority of this node.
     */ constructor(value_, priorityNode_ = $30d3a405033775a4$var$LeafNode.__childrenNodeConstructor.EMPTY_NODE){
        this.value_ = value_;
        this.priorityNode_ = priorityNode_;
        this.lazyHash_ = null;
        (0, $f43ebbd33d4c5d93$export$a7a9523472993e97)(this.value_ !== undefined && this.value_ !== null, "LeafNode shouldn't be created with null/undefined value.");
        $30d3a405033775a4$var$validatePriorityNode(this.priorityNode_);
    }
}
/**
 * The sort order for comparing leaf nodes of different types. If two leaf nodes have
 * the same type, the comparison falls back to their value
 */ $30d3a405033775a4$var$LeafNode.VALUE_TYPE_ORDER = [
    "object",
    "boolean",
    "number",
    "string"
];
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $30d3a405033775a4$var$nodeFromJSON$1;
let $30d3a405033775a4$var$MAX_NODE$1;
function $30d3a405033775a4$var$setNodeFromJSON(val) {
    $30d3a405033775a4$var$nodeFromJSON$1 = val;
}
function $30d3a405033775a4$var$setMaxNode(val) {
    $30d3a405033775a4$var$MAX_NODE$1 = val;
}
class $30d3a405033775a4$var$PriorityIndex extends $30d3a405033775a4$var$Index {
    compare(a, b) {
        const aPriority = a.node.getPriority();
        const bPriority = b.node.getPriority();
        const indexCmp = aPriority.compareTo(bPriority);
        if (indexCmp === 0) return $30d3a405033775a4$var$nameCompare(a.name, b.name);
        else return indexCmp;
    }
    isDefinedOn(node) {
        return !node.getPriority().isEmpty();
    }
    indexedValueChanged(oldNode, newNode) {
        return !oldNode.getPriority().equals(newNode.getPriority());
    }
    minPost() {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return $30d3a405033775a4$var$NamedNode.MIN;
    }
    maxPost() {
        return new $30d3a405033775a4$var$NamedNode($30d3a405033775a4$var$MAX_NAME, new $30d3a405033775a4$var$LeafNode("[PRIORITY-POST]", $30d3a405033775a4$var$MAX_NODE$1));
    }
    makePost(indexValue, name) {
        const priorityNode = $30d3a405033775a4$var$nodeFromJSON$1(indexValue);
        return new $30d3a405033775a4$var$NamedNode(name, new $30d3a405033775a4$var$LeafNode("[PRIORITY-POST]", priorityNode));
    }
    /**
     * @returns String representation for inclusion in a query spec
     */ toString() {
        return ".priority";
    }
}
const $30d3a405033775a4$var$PRIORITY_INDEX = new $30d3a405033775a4$var$PriorityIndex();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $30d3a405033775a4$var$LOG_2 = Math.log(2);
class $30d3a405033775a4$var$Base12Num {
    nextBitIsOne() {
        //noinspection JSBitwiseOperatorUsage
        const result = !(this.bits_ & 0x1 << this.current_);
        this.current_--;
        return result;
    }
    constructor(length){
        const logBase2 = (num)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
            parseInt(Math.log(num) / $30d3a405033775a4$var$LOG_2, 10);
        const bitMask = (bits)=>parseInt(Array(bits + 1).join("1"), 2);
        this.count = logBase2(length + 1);
        this.current_ = this.count - 1;
        const mask = bitMask(this.count);
        this.bits_ = length + 1 & mask;
    }
}
/**
 * Takes a list of child nodes and constructs a SortedSet using the given comparison
 * function
 *
 * Uses the algorithm described in the paper linked here:
 * http://citeseerx.ist.psu.edu/viewdoc/summary?doi=10.1.1.46.1458
 *
 * @param childList - Unsorted list of children
 * @param cmp - The comparison method to be used
 * @param keyFn - An optional function to extract K from a node wrapper, if K's
 * type is not NamedNode
 * @param mapSortFn - An optional override for comparator used by the generated sorted map
 */ const $30d3a405033775a4$var$buildChildSet = function(childList, cmp, keyFn, mapSortFn) {
    childList.sort(cmp);
    const buildBalancedTree = function(low, high) {
        const length = high - low;
        let namedNode;
        let key;
        if (length === 0) return null;
        else if (length === 1) {
            namedNode = childList[low];
            key = keyFn ? keyFn(namedNode) : namedNode;
            return new $30d3a405033775a4$var$LLRBNode(key, namedNode.node, $30d3a405033775a4$var$LLRBNode.BLACK, null, null);
        } else {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const middle = parseInt(length / 2, 10) + low;
            const left = buildBalancedTree(low, middle);
            const right = buildBalancedTree(middle + 1, high);
            namedNode = childList[middle];
            key = keyFn ? keyFn(namedNode) : namedNode;
            return new $30d3a405033775a4$var$LLRBNode(key, namedNode.node, $30d3a405033775a4$var$LLRBNode.BLACK, left, right);
        }
    };
    const buildFrom12Array = function(base12) {
        let node = null;
        let root = null;
        let index = childList.length;
        const buildPennant = function(chunkSize, color) {
            const low = index - chunkSize;
            const high = index;
            index -= chunkSize;
            const childTree = buildBalancedTree(low + 1, high);
            const namedNode = childList[low];
            const key = keyFn ? keyFn(namedNode) : namedNode;
            attachPennant(new $30d3a405033775a4$var$LLRBNode(key, namedNode.node, color, null, childTree));
        };
        const attachPennant = function(pennant) {
            if (node) {
                node.left = pennant;
                node = pennant;
            } else {
                root = pennant;
                node = pennant;
            }
        };
        for(let i = 0; i < base12.count; ++i){
            const isOne = base12.nextBitIsOne();
            // The number of nodes taken in each slice is 2^(arr.length - (i + 1))
            const chunkSize = Math.pow(2, base12.count - (i + 1));
            if (isOne) buildPennant(chunkSize, $30d3a405033775a4$var$LLRBNode.BLACK);
            else {
                // current == 2
                buildPennant(chunkSize, $30d3a405033775a4$var$LLRBNode.BLACK);
                buildPennant(chunkSize, $30d3a405033775a4$var$LLRBNode.RED);
            }
        }
        return root;
    };
    const base12 = new $30d3a405033775a4$var$Base12Num(childList.length);
    const root = buildFrom12Array(base12);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return new $30d3a405033775a4$var$SortedMap(mapSortFn || cmp, root);
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $30d3a405033775a4$var$_defaultIndexMap;
const $30d3a405033775a4$var$fallbackObject = {};
class $30d3a405033775a4$var$IndexMap {
    /**
     * The default IndexMap for nodes without a priority
     */ static get Default() {
        (0, $f43ebbd33d4c5d93$export$a7a9523472993e97)($30d3a405033775a4$var$fallbackObject && $30d3a405033775a4$var$PRIORITY_INDEX, "ChildrenNode.ts has not been loaded");
        $30d3a405033775a4$var$_defaultIndexMap = $30d3a405033775a4$var$_defaultIndexMap || new $30d3a405033775a4$var$IndexMap({
            ".priority": $30d3a405033775a4$var$fallbackObject
        }, {
            ".priority": $30d3a405033775a4$var$PRIORITY_INDEX
        });
        return $30d3a405033775a4$var$_defaultIndexMap;
    }
    get(indexKey) {
        const sortedMap = (0, $f43ebbd33d4c5d93$export$e51ae4db7b428f67)(this.indexes_, indexKey);
        if (!sortedMap) throw new Error("No index defined for " + indexKey);
        if (sortedMap instanceof $30d3a405033775a4$var$SortedMap) return sortedMap;
        else // The index exists, but it falls back to just name comparison. Return null so that the calling code uses the
        // regular child map
        return null;
    }
    hasIndex(indexDefinition) {
        return (0, $f43ebbd33d4c5d93$export$2344b14b097df817)(this.indexSet_, indexDefinition.toString());
    }
    addIndex(indexDefinition, existingChildren) {
        (0, $f43ebbd33d4c5d93$export$a7a9523472993e97)(indexDefinition !== $30d3a405033775a4$var$KEY_INDEX, "KeyIndex always exists and isn't meant to be added to the IndexMap.");
        const childList = [];
        let sawIndexedValue = false;
        const iter = existingChildren.getIterator($30d3a405033775a4$var$NamedNode.Wrap);
        let next = iter.getNext();
        while(next){
            sawIndexedValue = sawIndexedValue || indexDefinition.isDefinedOn(next.node);
            childList.push(next);
            next = iter.getNext();
        }
        let newIndex;
        if (sawIndexedValue) newIndex = $30d3a405033775a4$var$buildChildSet(childList, indexDefinition.getCompare());
        else newIndex = $30d3a405033775a4$var$fallbackObject;
        const indexName = indexDefinition.toString();
        const newIndexSet = Object.assign({}, this.indexSet_);
        newIndexSet[indexName] = indexDefinition;
        const newIndexes = Object.assign({}, this.indexes_);
        newIndexes[indexName] = newIndex;
        return new $30d3a405033775a4$var$IndexMap(newIndexes, newIndexSet);
    }
    /**
     * Ensure that this node is properly tracked in any indexes that we're maintaining
     */ addToIndexes(namedNode, existingChildren) {
        const newIndexes = (0, $f43ebbd33d4c5d93$export$871de8747c9eaa88)(this.indexes_, (indexedChildren, indexName)=>{
            const index = (0, $f43ebbd33d4c5d93$export$e51ae4db7b428f67)(this.indexSet_, indexName);
            (0, $f43ebbd33d4c5d93$export$a7a9523472993e97)(index, "Missing index implementation for " + indexName);
            if (indexedChildren === $30d3a405033775a4$var$fallbackObject) {
                // Check to see if we need to index everything
                if (index.isDefinedOn(namedNode.node)) {
                    // We need to build this index
                    const childList = [];
                    const iter = existingChildren.getIterator($30d3a405033775a4$var$NamedNode.Wrap);
                    let next = iter.getNext();
                    while(next){
                        if (next.name !== namedNode.name) childList.push(next);
                        next = iter.getNext();
                    }
                    childList.push(namedNode);
                    return $30d3a405033775a4$var$buildChildSet(childList, index.getCompare());
                } else // No change, this remains a fallback
                return $30d3a405033775a4$var$fallbackObject;
            } else {
                const existingSnap = existingChildren.get(namedNode.name);
                let newChildren = indexedChildren;
                if (existingSnap) newChildren = newChildren.remove(new $30d3a405033775a4$var$NamedNode(namedNode.name, existingSnap));
                return newChildren.insert(namedNode, namedNode.node);
            }
        });
        return new $30d3a405033775a4$var$IndexMap(newIndexes, this.indexSet_);
    }
    /**
     * Create a new IndexMap instance with the given value removed
     */ removeFromIndexes(namedNode, existingChildren) {
        const newIndexes = (0, $f43ebbd33d4c5d93$export$871de8747c9eaa88)(this.indexes_, (indexedChildren)=>{
            if (indexedChildren === $30d3a405033775a4$var$fallbackObject) // This is the fallback. Just return it, nothing to do in this case
            return indexedChildren;
            else {
                const existingSnap = existingChildren.get(namedNode.name);
                if (existingSnap) return indexedChildren.remove(new $30d3a405033775a4$var$NamedNode(namedNode.name, existingSnap));
                else // No record of this child
                return indexedChildren;
            }
        });
        return new $30d3a405033775a4$var$IndexMap(newIndexes, this.indexSet_);
    }
    constructor(indexes_, indexSet_){
        this.indexes_ = indexes_;
        this.indexSet_ = indexSet_;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // TODO: For memory savings, don't store priorityNode_ if it's empty.
let $30d3a405033775a4$var$EMPTY_NODE;
/**
 * ChildrenNode is a class for storing internal nodes in a DataSnapshot
 * (i.e. nodes with children).  It implements Node and stores the
 * list of children in the children property, sorted by child name.
 */ class $30d3a405033775a4$var$ChildrenNode {
    static get EMPTY_NODE() {
        return $30d3a405033775a4$var$EMPTY_NODE || ($30d3a405033775a4$var$EMPTY_NODE = new $30d3a405033775a4$var$ChildrenNode(new $30d3a405033775a4$var$SortedMap($30d3a405033775a4$var$NAME_COMPARATOR), null, $30d3a405033775a4$var$IndexMap.Default));
    }
    /** @inheritDoc */ isLeafNode() {
        return false;
    }
    /** @inheritDoc */ getPriority() {
        return this.priorityNode_ || $30d3a405033775a4$var$EMPTY_NODE;
    }
    /** @inheritDoc */ updatePriority(newPriorityNode) {
        if (this.children_.isEmpty()) // Don't allow priorities on empty nodes
        return this;
        else return new $30d3a405033775a4$var$ChildrenNode(this.children_, newPriorityNode, this.indexMap_);
    }
    /** @inheritDoc */ getImmediateChild(childName) {
        // Hack to treat priority as a regular child
        if (childName === ".priority") return this.getPriority();
        else {
            const child = this.children_.get(childName);
            return child === null ? $30d3a405033775a4$var$EMPTY_NODE : child;
        }
    }
    /** @inheritDoc */ getChild(path) {
        const front = $30d3a405033775a4$var$pathGetFront(path);
        if (front === null) return this;
        return this.getImmediateChild(front).getChild($30d3a405033775a4$var$pathPopFront(path));
    }
    /** @inheritDoc */ hasChild(childName) {
        return this.children_.get(childName) !== null;
    }
    /** @inheritDoc */ updateImmediateChild(childName, newChildNode) {
        (0, $f43ebbd33d4c5d93$export$a7a9523472993e97)(newChildNode, "We should always be passing snapshot nodes");
        if (childName === ".priority") return this.updatePriority(newChildNode);
        else {
            const namedNode = new $30d3a405033775a4$var$NamedNode(childName, newChildNode);
            let newChildren, newIndexMap;
            if (newChildNode.isEmpty()) {
                newChildren = this.children_.remove(childName);
                newIndexMap = this.indexMap_.removeFromIndexes(namedNode, this.children_);
            } else {
                newChildren = this.children_.insert(childName, newChildNode);
                newIndexMap = this.indexMap_.addToIndexes(namedNode, this.children_);
            }
            const newPriority = newChildren.isEmpty() ? $30d3a405033775a4$var$EMPTY_NODE : this.priorityNode_;
            return new $30d3a405033775a4$var$ChildrenNode(newChildren, newPriority, newIndexMap);
        }
    }
    /** @inheritDoc */ updateChild(path, newChildNode) {
        const front = $30d3a405033775a4$var$pathGetFront(path);
        if (front === null) return newChildNode;
        else {
            (0, $f43ebbd33d4c5d93$export$a7a9523472993e97)($30d3a405033775a4$var$pathGetFront(path) !== ".priority" || $30d3a405033775a4$var$pathGetLength(path) === 1, ".priority must be the last token in a path");
            const newImmediateChild = this.getImmediateChild(front).updateChild($30d3a405033775a4$var$pathPopFront(path), newChildNode);
            return this.updateImmediateChild(front, newImmediateChild);
        }
    }
    /** @inheritDoc */ isEmpty() {
        return this.children_.isEmpty();
    }
    /** @inheritDoc */ numChildren() {
        return this.children_.count();
    }
    /** @inheritDoc */ val(exportFormat) {
        if (this.isEmpty()) return null;
        const obj = {};
        let numKeys = 0, maxKey = 0, allIntegerKeys = true;
        this.forEachChild($30d3a405033775a4$var$PRIORITY_INDEX, (key, childNode)=>{
            obj[key] = childNode.val(exportFormat);
            numKeys++;
            if (allIntegerKeys && $30d3a405033775a4$var$ChildrenNode.INTEGER_REGEXP_.test(key)) maxKey = Math.max(maxKey, Number(key));
            else allIntegerKeys = false;
        });
        if (!exportFormat && allIntegerKeys && maxKey < 2 * numKeys) {
            // convert to array.
            const array = [];
            // eslint-disable-next-line guard-for-in
            for(const key in obj)array[key] = obj[key];
            return array;
        } else {
            if (exportFormat && !this.getPriority().isEmpty()) obj[".priority"] = this.getPriority().val();
            return obj;
        }
    }
    /** @inheritDoc */ hash() {
        if (this.lazyHash_ === null) {
            let toHash = "";
            if (!this.getPriority().isEmpty()) toHash += "priority:" + $30d3a405033775a4$var$priorityHashText(this.getPriority().val()) + ":";
            this.forEachChild($30d3a405033775a4$var$PRIORITY_INDEX, (key, childNode)=>{
                const childHash = childNode.hash();
                if (childHash !== "") toHash += ":" + key + ":" + childHash;
            });
            this.lazyHash_ = toHash === "" ? "" : $30d3a405033775a4$var$sha1(toHash);
        }
        return this.lazyHash_;
    }
    /** @inheritDoc */ getPredecessorChildName(childName, childNode, index) {
        const idx = this.resolveIndex_(index);
        if (idx) {
            const predecessor = idx.getPredecessorKey(new $30d3a405033775a4$var$NamedNode(childName, childNode));
            return predecessor ? predecessor.name : null;
        } else return this.children_.getPredecessorKey(childName);
    }
    getFirstChildName(indexDefinition) {
        const idx = this.resolveIndex_(indexDefinition);
        if (idx) {
            const minKey = idx.minKey();
            return minKey && minKey.name;
        } else return this.children_.minKey();
    }
    getFirstChild(indexDefinition) {
        const minKey = this.getFirstChildName(indexDefinition);
        if (minKey) return new $30d3a405033775a4$var$NamedNode(minKey, this.children_.get(minKey));
        else return null;
    }
    /**
     * Given an index, return the key name of the largest value we have, according to that index
     */ getLastChildName(indexDefinition) {
        const idx = this.resolveIndex_(indexDefinition);
        if (idx) {
            const maxKey = idx.maxKey();
            return maxKey && maxKey.name;
        } else return this.children_.maxKey();
    }
    getLastChild(indexDefinition) {
        const maxKey = this.getLastChildName(indexDefinition);
        if (maxKey) return new $30d3a405033775a4$var$NamedNode(maxKey, this.children_.get(maxKey));
        else return null;
    }
    forEachChild(index, action) {
        const idx = this.resolveIndex_(index);
        if (idx) return idx.inorderTraversal((wrappedNode)=>{
            return action(wrappedNode.name, wrappedNode.node);
        });
        else return this.children_.inorderTraversal(action);
    }
    getIterator(indexDefinition) {
        return this.getIteratorFrom(indexDefinition.minPost(), indexDefinition);
    }
    getIteratorFrom(startPost, indexDefinition) {
        const idx = this.resolveIndex_(indexDefinition);
        if (idx) return idx.getIteratorFrom(startPost, (key)=>key);
        else {
            const iterator = this.children_.getIteratorFrom(startPost.name, $30d3a405033775a4$var$NamedNode.Wrap);
            let next = iterator.peek();
            while(next != null && indexDefinition.compare(next, startPost) < 0){
                iterator.getNext();
                next = iterator.peek();
            }
            return iterator;
        }
    }
    getReverseIterator(indexDefinition) {
        return this.getReverseIteratorFrom(indexDefinition.maxPost(), indexDefinition);
    }
    getReverseIteratorFrom(endPost, indexDefinition) {
        const idx = this.resolveIndex_(indexDefinition);
        if (idx) return idx.getReverseIteratorFrom(endPost, (key)=>{
            return key;
        });
        else {
            const iterator = this.children_.getReverseIteratorFrom(endPost.name, $30d3a405033775a4$var$NamedNode.Wrap);
            let next = iterator.peek();
            while(next != null && indexDefinition.compare(next, endPost) > 0){
                iterator.getNext();
                next = iterator.peek();
            }
            return iterator;
        }
    }
    compareTo(other) {
        if (this.isEmpty()) {
            if (other.isEmpty()) return 0;
            else return -1;
        } else if (other.isLeafNode() || other.isEmpty()) return 1;
        else if (other === $30d3a405033775a4$var$MAX_NODE) return -1;
        else // Must be another node with children.
        return 0;
    }
    withIndex(indexDefinition) {
        if (indexDefinition === $30d3a405033775a4$var$KEY_INDEX || this.indexMap_.hasIndex(indexDefinition)) return this;
        else {
            const newIndexMap = this.indexMap_.addIndex(indexDefinition, this.children_);
            return new $30d3a405033775a4$var$ChildrenNode(this.children_, this.priorityNode_, newIndexMap);
        }
    }
    isIndexed(index) {
        return index === $30d3a405033775a4$var$KEY_INDEX || this.indexMap_.hasIndex(index);
    }
    equals(other) {
        if (other === this) return true;
        else if (other.isLeafNode()) return false;
        else {
            const otherChildrenNode = other;
            if (!this.getPriority().equals(otherChildrenNode.getPriority())) return false;
            else if (this.children_.count() === otherChildrenNode.children_.count()) {
                const thisIter = this.getIterator($30d3a405033775a4$var$PRIORITY_INDEX);
                const otherIter = otherChildrenNode.getIterator($30d3a405033775a4$var$PRIORITY_INDEX);
                let thisCurrent = thisIter.getNext();
                let otherCurrent = otherIter.getNext();
                while(thisCurrent && otherCurrent){
                    if (thisCurrent.name !== otherCurrent.name || !thisCurrent.node.equals(otherCurrent.node)) return false;
                    thisCurrent = thisIter.getNext();
                    otherCurrent = otherIter.getNext();
                }
                return thisCurrent === null && otherCurrent === null;
            } else return false;
        }
    }
    /**
     * Returns a SortedMap ordered by index, or null if the default (by-key) ordering can be used
     * instead.
     *
     */ resolveIndex_(indexDefinition) {
        if (indexDefinition === $30d3a405033775a4$var$KEY_INDEX) return null;
        else return this.indexMap_.get(indexDefinition.toString());
    }
    /**
     * @param children_ - List of children of this node..
     * @param priorityNode_ - The priority of this node (as a snapshot node).
     */ constructor(children_, priorityNode_, indexMap_){
        this.children_ = children_;
        this.priorityNode_ = priorityNode_;
        this.indexMap_ = indexMap_;
        this.lazyHash_ = null;
        /**
         * Note: The only reason we allow null priority is for EMPTY_NODE, since we can't use
         * EMPTY_NODE as the priority of EMPTY_NODE.  We might want to consider making EMPTY_NODE its own
         * class instead of an empty ChildrenNode.
         */ if (this.priorityNode_) $30d3a405033775a4$var$validatePriorityNode(this.priorityNode_);
        if (this.children_.isEmpty()) (0, $f43ebbd33d4c5d93$export$a7a9523472993e97)(!this.priorityNode_ || this.priorityNode_.isEmpty(), "An empty node cannot have a priority");
    }
}
$30d3a405033775a4$var$ChildrenNode.INTEGER_REGEXP_ = /^(0|[1-9]\d*)$/;
class $30d3a405033775a4$var$MaxNode extends $30d3a405033775a4$var$ChildrenNode {
    compareTo(other) {
        if (other === this) return 0;
        else return 1;
    }
    equals(other) {
        // Not that we every compare it, but MAX_NODE is only ever equal to itself
        return other === this;
    }
    getPriority() {
        return this;
    }
    getImmediateChild(childName) {
        return $30d3a405033775a4$var$ChildrenNode.EMPTY_NODE;
    }
    isEmpty() {
        return false;
    }
    constructor(){
        super(new $30d3a405033775a4$var$SortedMap($30d3a405033775a4$var$NAME_COMPARATOR), $30d3a405033775a4$var$ChildrenNode.EMPTY_NODE, $30d3a405033775a4$var$IndexMap.Default);
    }
}
/**
 * Marker that will sort higher than any other snapshot.
 */ const $30d3a405033775a4$var$MAX_NODE = new $30d3a405033775a4$var$MaxNode();
Object.defineProperties($30d3a405033775a4$var$NamedNode, {
    MIN: {
        value: new $30d3a405033775a4$var$NamedNode($30d3a405033775a4$var$MIN_NAME, $30d3a405033775a4$var$ChildrenNode.EMPTY_NODE)
    },
    MAX: {
        value: new $30d3a405033775a4$var$NamedNode($30d3a405033775a4$var$MAX_NAME, $30d3a405033775a4$var$MAX_NODE)
    }
});
/**
 * Reference Extensions
 */ $30d3a405033775a4$var$KeyIndex.__EMPTY_NODE = $30d3a405033775a4$var$ChildrenNode.EMPTY_NODE;
$30d3a405033775a4$var$LeafNode.__childrenNodeConstructor = $30d3a405033775a4$var$ChildrenNode;
$30d3a405033775a4$var$setMaxNode$1($30d3a405033775a4$var$MAX_NODE);
$30d3a405033775a4$var$setMaxNode($30d3a405033775a4$var$MAX_NODE);
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $30d3a405033775a4$var$USE_HINZE = true;
/**
 * Constructs a snapshot node representing the passed JSON and returns it.
 * @param json - JSON to create a node for.
 * @param priority - Optional priority to use.  This will be ignored if the
 * passed JSON contains a .priority property.
 */ function $30d3a405033775a4$var$nodeFromJSON(json, priority = null) {
    if (json === null) return $30d3a405033775a4$var$ChildrenNode.EMPTY_NODE;
    if (typeof json === "object" && ".priority" in json) priority = json[".priority"];
    (0, $f43ebbd33d4c5d93$export$a7a9523472993e97)(priority === null || typeof priority === "string" || typeof priority === "number" || typeof priority === "object" && ".sv" in priority, "Invalid priority type found: " + typeof priority);
    if (typeof json === "object" && ".value" in json && json[".value"] !== null) json = json[".value"];
    // Valid leaf nodes include non-objects or server-value wrapper objects
    if (typeof json !== "object" || ".sv" in json) {
        const jsonLeaf = json;
        return new $30d3a405033775a4$var$LeafNode(jsonLeaf, $30d3a405033775a4$var$nodeFromJSON(priority));
    }
    if (!(json instanceof Array) && $30d3a405033775a4$var$USE_HINZE) {
        const children = [];
        let childrenHavePriority = false;
        const hinzeJsonObj = json;
        $30d3a405033775a4$var$each(hinzeJsonObj, (key, child)=>{
            if (key.substring(0, 1) !== ".") {
                // Ignore metadata nodes
                const childNode = $30d3a405033775a4$var$nodeFromJSON(child);
                if (!childNode.isEmpty()) {
                    childrenHavePriority = childrenHavePriority || !childNode.getPriority().isEmpty();
                    children.push(new $30d3a405033775a4$var$NamedNode(key, childNode));
                }
            }
        });
        if (children.length === 0) return $30d3a405033775a4$var$ChildrenNode.EMPTY_NODE;
        const childSet = $30d3a405033775a4$var$buildChildSet(children, $30d3a405033775a4$var$NAME_ONLY_COMPARATOR, (namedNode)=>namedNode.name, $30d3a405033775a4$var$NAME_COMPARATOR);
        if (childrenHavePriority) {
            const sortedChildSet = $30d3a405033775a4$var$buildChildSet(children, $30d3a405033775a4$var$PRIORITY_INDEX.getCompare());
            return new $30d3a405033775a4$var$ChildrenNode(childSet, $30d3a405033775a4$var$nodeFromJSON(priority), new $30d3a405033775a4$var$IndexMap({
                ".priority": sortedChildSet
            }, {
                ".priority": $30d3a405033775a4$var$PRIORITY_INDEX
            }));
        } else return new $30d3a405033775a4$var$ChildrenNode(childSet, $30d3a405033775a4$var$nodeFromJSON(priority), $30d3a405033775a4$var$IndexMap.Default);
    } else {
        let node = $30d3a405033775a4$var$ChildrenNode.EMPTY_NODE;
        $30d3a405033775a4$var$each(json, (key, childData)=>{
            if ((0, $f43ebbd33d4c5d93$export$2344b14b097df817)(json, key)) {
                if (key.substring(0, 1) !== ".") {
                    // ignore metadata nodes.
                    const childNode = $30d3a405033775a4$var$nodeFromJSON(childData);
                    if (childNode.isLeafNode() || !childNode.isEmpty()) node = node.updateImmediateChild(key, childNode);
                }
            }
        });
        return node.updatePriority($30d3a405033775a4$var$nodeFromJSON(priority));
    }
}
$30d3a405033775a4$var$setNodeFromJSON($30d3a405033775a4$var$nodeFromJSON);
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $30d3a405033775a4$var$PathIndex extends $30d3a405033775a4$var$Index {
    extractChild(snap) {
        return snap.getChild(this.indexPath_);
    }
    isDefinedOn(node) {
        return !node.getChild(this.indexPath_).isEmpty();
    }
    compare(a, b) {
        const aChild = this.extractChild(a.node);
        const bChild = this.extractChild(b.node);
        const indexCmp = aChild.compareTo(bChild);
        if (indexCmp === 0) return $30d3a405033775a4$var$nameCompare(a.name, b.name);
        else return indexCmp;
    }
    makePost(indexValue, name) {
        const valueNode = $30d3a405033775a4$var$nodeFromJSON(indexValue);
        const node = $30d3a405033775a4$var$ChildrenNode.EMPTY_NODE.updateChild(this.indexPath_, valueNode);
        return new $30d3a405033775a4$var$NamedNode(name, node);
    }
    maxPost() {
        const node = $30d3a405033775a4$var$ChildrenNode.EMPTY_NODE.updateChild(this.indexPath_, $30d3a405033775a4$var$MAX_NODE);
        return new $30d3a405033775a4$var$NamedNode($30d3a405033775a4$var$MAX_NAME, node);
    }
    toString() {
        return $30d3a405033775a4$var$pathSlice(this.indexPath_, 0).join("/");
    }
    constructor(indexPath_){
        super();
        this.indexPath_ = indexPath_;
        (0, $f43ebbd33d4c5d93$export$a7a9523472993e97)(!$30d3a405033775a4$var$pathIsEmpty(indexPath_) && $30d3a405033775a4$var$pathGetFront(indexPath_) !== ".priority", "Can't create PathIndex with empty path or .priority key");
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $30d3a405033775a4$var$ValueIndex extends $30d3a405033775a4$var$Index {
    compare(a, b) {
        const indexCmp = a.node.compareTo(b.node);
        if (indexCmp === 0) return $30d3a405033775a4$var$nameCompare(a.name, b.name);
        else return indexCmp;
    }
    isDefinedOn(node) {
        return true;
    }
    indexedValueChanged(oldNode, newNode) {
        return !oldNode.equals(newNode);
    }
    minPost() {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return $30d3a405033775a4$var$NamedNode.MIN;
    }
    maxPost() {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return $30d3a405033775a4$var$NamedNode.MAX;
    }
    makePost(indexValue, name) {
        const valueNode = $30d3a405033775a4$var$nodeFromJSON(indexValue);
        return new $30d3a405033775a4$var$NamedNode(name, valueNode);
    }
    /**
     * @returns String representation for inclusion in a query spec
     */ toString() {
        return ".value";
    }
}
const $30d3a405033775a4$var$VALUE_INDEX = new $30d3a405033775a4$var$ValueIndex();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Modeled after base64 web-safe chars, but ordered by ASCII.
const $30d3a405033775a4$var$PUSH_CHARS = "-0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ_abcdefghijklmnopqrstuvwxyz";
const $30d3a405033775a4$var$MIN_PUSH_CHAR = "-";
const $30d3a405033775a4$var$MAX_PUSH_CHAR = "z";
const $30d3a405033775a4$var$MAX_KEY_LEN = 786;
/**
 * Fancy ID generator that creates 20-character string identifiers with the
 * following properties:
 *
 * 1. They're based on timestamp so that they sort *after* any existing ids.
 * 2. They contain 72-bits of random data after the timestamp so that IDs won't
 *    collide with other clients' IDs.
 * 3. They sort *lexicographically* (so the timestamp is converted to characters
 *    that will sort properly).
 * 4. They're monotonically increasing. Even if you generate more than one in
 *    the same timestamp, the latter ones will sort after the former ones. We do
 *    this by using the previous random bits but "incrementing" them by 1 (only
 *    in the case of a timestamp collision).
 */ const $30d3a405033775a4$var$nextPushId = function() {
    // Timestamp of last push, used to prevent local collisions if you push twice
    // in one ms.
    let lastPushTime = 0;
    // We generate 72-bits of randomness which get turned into 12 characters and
    // appended to the timestamp to prevent collisions with other clients. We
    // store the last characters we generated because in the event of a collision,
    // we'll use those same characters except "incremented" by one.
    const lastRandChars = [];
    return function(now) {
        const duplicateTime = now === lastPushTime;
        lastPushTime = now;
        let i;
        const timeStampChars = new Array(8);
        for(i = 7; i >= 0; i--){
            timeStampChars[i] = $30d3a405033775a4$var$PUSH_CHARS.charAt(now % 64);
            // NOTE: Can't use << here because javascript will convert to int and lose
            // the upper bits.
            now = Math.floor(now / 64);
        }
        (0, $f43ebbd33d4c5d93$export$a7a9523472993e97)(now === 0, "Cannot push at time == 0");
        let id = timeStampChars.join("");
        if (!duplicateTime) for(i = 0; i < 12; i++)lastRandChars[i] = Math.floor(Math.random() * 64);
        else {
            // If the timestamp hasn't changed since last push, use the same random
            // number, except incremented by 1.
            for(i = 11; i >= 0 && lastRandChars[i] === 63; i--)lastRandChars[i] = 0;
            lastRandChars[i]++;
        }
        for(i = 0; i < 12; i++)id += $30d3a405033775a4$var$PUSH_CHARS.charAt(lastRandChars[i]);
        (0, $f43ebbd33d4c5d93$export$a7a9523472993e97)(id.length === 20, "nextPushId: Length should be 20.");
        return id;
    };
}();
const $30d3a405033775a4$var$successor = function(key) {
    if (key === "" + $30d3a405033775a4$var$INTEGER_32_MAX) // See https://firebase.google.com/docs/database/web/lists-of-data#data-order
    return $30d3a405033775a4$var$MIN_PUSH_CHAR;
    const keyAsInt = $30d3a405033775a4$var$tryParseInt(key);
    if (keyAsInt != null) return "" + (keyAsInt + 1);
    const next = new Array(key.length);
    for(let i = 0; i < next.length; i++)next[i] = key.charAt(i);
    if (next.length < $30d3a405033775a4$var$MAX_KEY_LEN) {
        next.push($30d3a405033775a4$var$MIN_PUSH_CHAR);
        return next.join("");
    }
    let i = next.length - 1;
    while(i >= 0 && next[i] === $30d3a405033775a4$var$MAX_PUSH_CHAR)i--;
    // `successor` was called on the largest possible key, so return the
    // MAX_NAME, which sorts larger than all keys.
    if (i === -1) return $30d3a405033775a4$var$MAX_NAME;
    const source = next[i];
    const sourcePlusOne = $30d3a405033775a4$var$PUSH_CHARS.charAt($30d3a405033775a4$var$PUSH_CHARS.indexOf(source) + 1);
    next[i] = sourcePlusOne;
    return next.slice(0, i + 1).join("");
};
// `key` is assumed to be non-empty.
const $30d3a405033775a4$var$predecessor = function(key) {
    if (key === "" + $30d3a405033775a4$var$INTEGER_32_MIN) return $30d3a405033775a4$var$MIN_NAME;
    const keyAsInt = $30d3a405033775a4$var$tryParseInt(key);
    if (keyAsInt != null) return "" + (keyAsInt - 1);
    const next = new Array(key.length);
    for(let i = 0; i < next.length; i++)next[i] = key.charAt(i);
    // If `key` ends in `MIN_PUSH_CHAR`, the largest key lexicographically
    // smaller than `key`, is `key[0:key.length - 1]`. The next key smaller
    // than that, `predecessor(predecessor(key))`, is
    //
    // `key[0:key.length - 2] + (key[key.length - 1] - 1) + \
    //   { MAX_PUSH_CHAR repeated MAX_KEY_LEN - (key.length - 1) times }
    //
    // analogous to increment/decrement for base-10 integers.
    //
    // This works because lexigographic comparison works character-by-character,
    // using length as a tie-breaker if one key is a prefix of the other.
    if (next[next.length - 1] === $30d3a405033775a4$var$MIN_PUSH_CHAR) {
        if (next.length === 1) // See https://firebase.google.com/docs/database/web/lists-of-data#orderbykey
        return "" + $30d3a405033775a4$var$INTEGER_32_MAX;
        delete next[next.length - 1];
        return next.join("");
    }
    // Replace the last character with it's immediate predecessor, and
    // fill the suffix of the key with MAX_PUSH_CHAR. This is the
    // lexicographically largest possible key smaller than `key`.
    next[next.length - 1] = $30d3a405033775a4$var$PUSH_CHARS.charAt($30d3a405033775a4$var$PUSH_CHARS.indexOf(next[next.length - 1]) - 1);
    return next.join("") + $30d3a405033775a4$var$MAX_PUSH_CHAR.repeat($30d3a405033775a4$var$MAX_KEY_LEN - next.length);
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $30d3a405033775a4$var$changeValue(snapshotNode) {
    return {
        type: "value" /* VALUE */ ,
        snapshotNode: snapshotNode
    };
}
function $30d3a405033775a4$var$changeChildAdded(childName, snapshotNode) {
    return {
        type: "child_added" /* CHILD_ADDED */ ,
        snapshotNode: snapshotNode,
        childName: childName
    };
}
function $30d3a405033775a4$var$changeChildRemoved(childName, snapshotNode) {
    return {
        type: "child_removed" /* CHILD_REMOVED */ ,
        snapshotNode: snapshotNode,
        childName: childName
    };
}
function $30d3a405033775a4$var$changeChildChanged(childName, snapshotNode, oldSnap) {
    return {
        type: "child_changed" /* CHILD_CHANGED */ ,
        snapshotNode: snapshotNode,
        childName: childName,
        oldSnap: oldSnap
    };
}
function $30d3a405033775a4$var$changeChildMoved(childName, snapshotNode) {
    return {
        type: "child_moved" /* CHILD_MOVED */ ,
        snapshotNode: snapshotNode,
        childName: childName
    };
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Doesn't really filter nodes but applies an index to the node and keeps track of any changes
 */ class $30d3a405033775a4$var$IndexedFilter {
    updateChild(snap, key, newChild, affectedPath, source, optChangeAccumulator) {
        (0, $f43ebbd33d4c5d93$export$a7a9523472993e97)(snap.isIndexed(this.index_), "A node must be indexed if only a child is updated");
        const oldChild = snap.getImmediateChild(key);
        // Check if anything actually changed.
        if (oldChild.getChild(affectedPath).equals(newChild.getChild(affectedPath))) {
            // There's an edge case where a child can enter or leave the view because affectedPath was set to null.
            // In this case, affectedPath will appear null in both the old and new snapshots.  So we need
            // to avoid treating these cases as "nothing changed."
            if (oldChild.isEmpty() === newChild.isEmpty()) // Nothing changed.
            // This assert should be valid, but it's expensive (can dominate perf testing) so don't actually do it.
            //assert(oldChild.equals(newChild), 'Old and new snapshots should be equal.');
            return snap;
        }
        if (optChangeAccumulator != null) {
            if (newChild.isEmpty()) {
                if (snap.hasChild(key)) optChangeAccumulator.trackChildChange($30d3a405033775a4$var$changeChildRemoved(key, oldChild));
                else (0, $f43ebbd33d4c5d93$export$a7a9523472993e97)(snap.isLeafNode(), "A child remove without an old child only makes sense on a leaf node");
            } else if (oldChild.isEmpty()) optChangeAccumulator.trackChildChange($30d3a405033775a4$var$changeChildAdded(key, newChild));
            else optChangeAccumulator.trackChildChange($30d3a405033775a4$var$changeChildChanged(key, newChild, oldChild));
        }
        if (snap.isLeafNode() && newChild.isEmpty()) return snap;
        else // Make sure the node is indexed
        return snap.updateImmediateChild(key, newChild).withIndex(this.index_);
    }
    updateFullNode(oldSnap, newSnap, optChangeAccumulator) {
        if (optChangeAccumulator != null) {
            if (!oldSnap.isLeafNode()) oldSnap.forEachChild($30d3a405033775a4$var$PRIORITY_INDEX, (key, childNode)=>{
                if (!newSnap.hasChild(key)) optChangeAccumulator.trackChildChange($30d3a405033775a4$var$changeChildRemoved(key, childNode));
            });
            if (!newSnap.isLeafNode()) newSnap.forEachChild($30d3a405033775a4$var$PRIORITY_INDEX, (key, childNode)=>{
                if (oldSnap.hasChild(key)) {
                    const oldChild = oldSnap.getImmediateChild(key);
                    if (!oldChild.equals(childNode)) optChangeAccumulator.trackChildChange($30d3a405033775a4$var$changeChildChanged(key, childNode, oldChild));
                } else optChangeAccumulator.trackChildChange($30d3a405033775a4$var$changeChildAdded(key, childNode));
            });
        }
        return newSnap.withIndex(this.index_);
    }
    updatePriority(oldSnap, newPriority) {
        if (oldSnap.isEmpty()) return $30d3a405033775a4$var$ChildrenNode.EMPTY_NODE;
        else return oldSnap.updatePriority(newPriority);
    }
    filtersNodes() {
        return false;
    }
    getIndexedFilter() {
        return this;
    }
    getIndex() {
        return this.index_;
    }
    constructor(index_){
        this.index_ = index_;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Filters nodes by range and uses an IndexFilter to track any changes after filtering the node
 */ class $30d3a405033775a4$var$RangedFilter {
    getStartPost() {
        return this.startPost_;
    }
    getEndPost() {
        return this.endPost_;
    }
    matches(node) {
        return this.index_.compare(this.getStartPost(), node) <= 0 && this.index_.compare(node, this.getEndPost()) <= 0;
    }
    updateChild(snap, key, newChild, affectedPath, source, optChangeAccumulator) {
        if (!this.matches(new $30d3a405033775a4$var$NamedNode(key, newChild))) newChild = $30d3a405033775a4$var$ChildrenNode.EMPTY_NODE;
        return this.indexedFilter_.updateChild(snap, key, newChild, affectedPath, source, optChangeAccumulator);
    }
    updateFullNode(oldSnap, newSnap, optChangeAccumulator) {
        if (newSnap.isLeafNode()) // Make sure we have a children node with the correct index, not a leaf node;
        newSnap = $30d3a405033775a4$var$ChildrenNode.EMPTY_NODE;
        let filtered = newSnap.withIndex(this.index_);
        // Don't support priorities on queries
        filtered = filtered.updatePriority($30d3a405033775a4$var$ChildrenNode.EMPTY_NODE);
        const self = this;
        newSnap.forEachChild($30d3a405033775a4$var$PRIORITY_INDEX, (key, childNode)=>{
            if (!self.matches(new $30d3a405033775a4$var$NamedNode(key, childNode))) filtered = filtered.updateImmediateChild(key, $30d3a405033775a4$var$ChildrenNode.EMPTY_NODE);
        });
        return this.indexedFilter_.updateFullNode(oldSnap, filtered, optChangeAccumulator);
    }
    updatePriority(oldSnap, newPriority) {
        // Don't support priorities on queries
        return oldSnap;
    }
    filtersNodes() {
        return true;
    }
    getIndexedFilter() {
        return this.indexedFilter_;
    }
    getIndex() {
        return this.index_;
    }
    static getStartPost_(params) {
        if (params.hasStart()) {
            const startName = params.getIndexStartName();
            return params.getIndex().makePost(params.getIndexStartValue(), startName);
        } else return params.getIndex().minPost();
    }
    static getEndPost_(params) {
        if (params.hasEnd()) {
            const endName = params.getIndexEndName();
            return params.getIndex().makePost(params.getIndexEndValue(), endName);
        } else return params.getIndex().maxPost();
    }
    constructor(params){
        this.indexedFilter_ = new $30d3a405033775a4$var$IndexedFilter(params.getIndex());
        this.index_ = params.getIndex();
        this.startPost_ = $30d3a405033775a4$var$RangedFilter.getStartPost_(params);
        this.endPost_ = $30d3a405033775a4$var$RangedFilter.getEndPost_(params);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Applies a limit and a range to a node and uses RangedFilter to do the heavy lifting where possible
 */ class $30d3a405033775a4$var$LimitedFilter {
    updateChild(snap, key, newChild, affectedPath, source, optChangeAccumulator) {
        if (!this.rangedFilter_.matches(new $30d3a405033775a4$var$NamedNode(key, newChild))) newChild = $30d3a405033775a4$var$ChildrenNode.EMPTY_NODE;
        if (snap.getImmediateChild(key).equals(newChild)) // No change
        return snap;
        else if (snap.numChildren() < this.limit_) return this.rangedFilter_.getIndexedFilter().updateChild(snap, key, newChild, affectedPath, source, optChangeAccumulator);
        else return this.fullLimitUpdateChild_(snap, key, newChild, source, optChangeAccumulator);
    }
    updateFullNode(oldSnap, newSnap, optChangeAccumulator) {
        let filtered;
        if (newSnap.isLeafNode() || newSnap.isEmpty()) // Make sure we have a children node with the correct index, not a leaf node;
        filtered = $30d3a405033775a4$var$ChildrenNode.EMPTY_NODE.withIndex(this.index_);
        else if (this.limit_ * 2 < newSnap.numChildren() && newSnap.isIndexed(this.index_)) {
            // Easier to build up a snapshot, since what we're given has more than twice the elements we want
            filtered = $30d3a405033775a4$var$ChildrenNode.EMPTY_NODE.withIndex(this.index_);
            // anchor to the startPost, endPost, or last element as appropriate
            let iterator;
            if (this.reverse_) iterator = newSnap.getReverseIteratorFrom(this.rangedFilter_.getEndPost(), this.index_);
            else iterator = newSnap.getIteratorFrom(this.rangedFilter_.getStartPost(), this.index_);
            let count = 0;
            while(iterator.hasNext() && count < this.limit_){
                const next = iterator.getNext();
                let inRange;
                if (this.reverse_) inRange = this.index_.compare(this.rangedFilter_.getStartPost(), next) <= 0;
                else inRange = this.index_.compare(next, this.rangedFilter_.getEndPost()) <= 0;
                if (inRange) {
                    filtered = filtered.updateImmediateChild(next.name, next.node);
                    count++;
                } else break;
            }
        } else {
            // The snap contains less than twice the limit. Faster to delete from the snap than build up a new one
            filtered = newSnap.withIndex(this.index_);
            // Don't support priorities on queries
            filtered = filtered.updatePriority($30d3a405033775a4$var$ChildrenNode.EMPTY_NODE);
            let startPost;
            let endPost;
            let cmp;
            let iterator;
            if (this.reverse_) {
                iterator = filtered.getReverseIterator(this.index_);
                startPost = this.rangedFilter_.getEndPost();
                endPost = this.rangedFilter_.getStartPost();
                const indexCompare = this.index_.getCompare();
                cmp = (a, b)=>indexCompare(b, a);
            } else {
                iterator = filtered.getIterator(this.index_);
                startPost = this.rangedFilter_.getStartPost();
                endPost = this.rangedFilter_.getEndPost();
                cmp = this.index_.getCompare();
            }
            let count = 0;
            let foundStartPost = false;
            while(iterator.hasNext()){
                const next = iterator.getNext();
                if (!foundStartPost && cmp(startPost, next) <= 0) // start adding
                foundStartPost = true;
                const inRange = foundStartPost && count < this.limit_ && cmp(next, endPost) <= 0;
                if (inRange) count++;
                else filtered = filtered.updateImmediateChild(next.name, $30d3a405033775a4$var$ChildrenNode.EMPTY_NODE);
            }
        }
        return this.rangedFilter_.getIndexedFilter().updateFullNode(oldSnap, filtered, optChangeAccumulator);
    }
    updatePriority(oldSnap, newPriority) {
        // Don't support priorities on queries
        return oldSnap;
    }
    filtersNodes() {
        return true;
    }
    getIndexedFilter() {
        return this.rangedFilter_.getIndexedFilter();
    }
    getIndex() {
        return this.index_;
    }
    fullLimitUpdateChild_(snap, childKey, childSnap, source, changeAccumulator) {
        // TODO: rename all cache stuff etc to general snap terminology
        let cmp;
        if (this.reverse_) {
            const indexCmp = this.index_.getCompare();
            cmp = (a, b)=>indexCmp(b, a);
        } else cmp = this.index_.getCompare();
        const oldEventCache = snap;
        (0, $f43ebbd33d4c5d93$export$a7a9523472993e97)(oldEventCache.numChildren() === this.limit_, "");
        const newChildNamedNode = new $30d3a405033775a4$var$NamedNode(childKey, childSnap);
        const windowBoundary = this.reverse_ ? oldEventCache.getFirstChild(this.index_) : oldEventCache.getLastChild(this.index_);
        const inRange = this.rangedFilter_.matches(newChildNamedNode);
        if (oldEventCache.hasChild(childKey)) {
            const oldChildSnap = oldEventCache.getImmediateChild(childKey);
            let nextChild = source.getChildAfterChild(this.index_, windowBoundary, this.reverse_);
            while(nextChild != null && (nextChild.name === childKey || oldEventCache.hasChild(nextChild.name)))// There is a weird edge case where a node is updated as part of a merge in the write tree, but hasn't
            // been applied to the limited filter yet. Ignore this next child which will be updated later in
            // the limited filter...
            nextChild = source.getChildAfterChild(this.index_, nextChild, this.reverse_);
            const compareNext = nextChild == null ? 1 : cmp(nextChild, newChildNamedNode);
            const remainsInWindow = inRange && !childSnap.isEmpty() && compareNext >= 0;
            if (remainsInWindow) {
                if (changeAccumulator != null) changeAccumulator.trackChildChange($30d3a405033775a4$var$changeChildChanged(childKey, childSnap, oldChildSnap));
                return oldEventCache.updateImmediateChild(childKey, childSnap);
            } else {
                if (changeAccumulator != null) changeAccumulator.trackChildChange($30d3a405033775a4$var$changeChildRemoved(childKey, oldChildSnap));
                const newEventCache = oldEventCache.updateImmediateChild(childKey, $30d3a405033775a4$var$ChildrenNode.EMPTY_NODE);
                const nextChildInRange = nextChild != null && this.rangedFilter_.matches(nextChild);
                if (nextChildInRange) {
                    if (changeAccumulator != null) changeAccumulator.trackChildChange($30d3a405033775a4$var$changeChildAdded(nextChild.name, nextChild.node));
                    return newEventCache.updateImmediateChild(nextChild.name, nextChild.node);
                } else return newEventCache;
            }
        } else if (childSnap.isEmpty()) // we're deleting a node, but it was not in the window, so ignore it
        return snap;
        else if (inRange) {
            if (cmp(windowBoundary, newChildNamedNode) >= 0) {
                if (changeAccumulator != null) {
                    changeAccumulator.trackChildChange($30d3a405033775a4$var$changeChildRemoved(windowBoundary.name, windowBoundary.node));
                    changeAccumulator.trackChildChange($30d3a405033775a4$var$changeChildAdded(childKey, childSnap));
                }
                return oldEventCache.updateImmediateChild(childKey, childSnap).updateImmediateChild(windowBoundary.name, $30d3a405033775a4$var$ChildrenNode.EMPTY_NODE);
            } else return snap;
        } else return snap;
    }
    constructor(params){
        this.rangedFilter_ = new $30d3a405033775a4$var$RangedFilter(params);
        this.index_ = params.getIndex();
        this.limit_ = params.getLimit();
        this.reverse_ = !params.isViewFromLeft();
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * This class is an immutable-from-the-public-api struct containing a set of query parameters defining a
 * range to be returned for a particular location. It is assumed that validation of parameters is done at the
 * user-facing API level, so it is not done here.
 *
 * @internal
 */ class $30d3a405033775a4$export$7ba287e361c94330 {
    hasStart() {
        return this.startSet_;
    }
    hasStartAfter() {
        return this.startAfterSet_;
    }
    hasEndBefore() {
        return this.endBeforeSet_;
    }
    /**
     * @returns True if it would return from left.
     */ isViewFromLeft() {
        if (this.viewFrom_ === "") // limit(), rather than limitToFirst or limitToLast was called.
        // This means that only one of startSet_ and endSet_ is true. Use them
        // to calculate which side of the view to anchor to. If neither is set,
        // anchor to the end.
        return this.startSet_;
        else return this.viewFrom_ === "l" /* VIEW_FROM_LEFT */ ;
    }
    /**
     * Only valid to call if hasStart() returns true
     */ getIndexStartValue() {
        (0, $f43ebbd33d4c5d93$export$a7a9523472993e97)(this.startSet_, "Only valid if start has been set");
        return this.indexStartValue_;
    }
    /**
     * Only valid to call if hasStart() returns true.
     * Returns the starting key name for the range defined by these query parameters
     */ getIndexStartName() {
        (0, $f43ebbd33d4c5d93$export$a7a9523472993e97)(this.startSet_, "Only valid if start has been set");
        if (this.startNameSet_) return this.indexStartName_;
        else return $30d3a405033775a4$var$MIN_NAME;
    }
    hasEnd() {
        return this.endSet_;
    }
    /**
     * Only valid to call if hasEnd() returns true.
     */ getIndexEndValue() {
        (0, $f43ebbd33d4c5d93$export$a7a9523472993e97)(this.endSet_, "Only valid if end has been set");
        return this.indexEndValue_;
    }
    /**
     * Only valid to call if hasEnd() returns true.
     * Returns the end key name for the range defined by these query parameters
     */ getIndexEndName() {
        (0, $f43ebbd33d4c5d93$export$a7a9523472993e97)(this.endSet_, "Only valid if end has been set");
        if (this.endNameSet_) return this.indexEndName_;
        else return $30d3a405033775a4$var$MAX_NAME;
    }
    hasLimit() {
        return this.limitSet_;
    }
    /**
     * @returns True if a limit has been set and it has been explicitly anchored
     */ hasAnchoredLimit() {
        return this.limitSet_ && this.viewFrom_ !== "";
    }
    /**
     * Only valid to call if hasLimit() returns true
     */ getLimit() {
        (0, $f43ebbd33d4c5d93$export$a7a9523472993e97)(this.limitSet_, "Only valid if limit has been set");
        return this.limit_;
    }
    getIndex() {
        return this.index_;
    }
    loadsAllData() {
        return !(this.startSet_ || this.endSet_ || this.limitSet_);
    }
    isDefault() {
        return this.loadsAllData() && this.index_ === $30d3a405033775a4$var$PRIORITY_INDEX;
    }
    copy() {
        const copy = new $30d3a405033775a4$export$7ba287e361c94330();
        copy.limitSet_ = this.limitSet_;
        copy.limit_ = this.limit_;
        copy.startSet_ = this.startSet_;
        copy.indexStartValue_ = this.indexStartValue_;
        copy.startNameSet_ = this.startNameSet_;
        copy.indexStartName_ = this.indexStartName_;
        copy.endSet_ = this.endSet_;
        copy.indexEndValue_ = this.indexEndValue_;
        copy.endNameSet_ = this.endNameSet_;
        copy.indexEndName_ = this.indexEndName_;
        copy.index_ = this.index_;
        copy.viewFrom_ = this.viewFrom_;
        return copy;
    }
    constructor(){
        this.limitSet_ = false;
        this.startSet_ = false;
        this.startNameSet_ = false;
        this.startAfterSet_ = false;
        this.endSet_ = false;
        this.endNameSet_ = false;
        this.endBeforeSet_ = false;
        this.limit_ = 0;
        this.viewFrom_ = "";
        this.indexStartValue_ = null;
        this.indexStartName_ = "";
        this.indexEndValue_ = null;
        this.indexEndName_ = "";
        this.index_ = $30d3a405033775a4$var$PRIORITY_INDEX;
    }
}
function $30d3a405033775a4$var$queryParamsGetNodeFilter(queryParams) {
    if (queryParams.loadsAllData()) return new $30d3a405033775a4$var$IndexedFilter(queryParams.getIndex());
    else if (queryParams.hasLimit()) return new $30d3a405033775a4$var$LimitedFilter(queryParams);
    else return new $30d3a405033775a4$var$RangedFilter(queryParams);
}
function $30d3a405033775a4$var$queryParamsLimitToFirst(queryParams, newLimit) {
    const newParams = queryParams.copy();
    newParams.limitSet_ = true;
    newParams.limit_ = newLimit;
    newParams.viewFrom_ = "l" /* VIEW_FROM_LEFT */ ;
    return newParams;
}
function $30d3a405033775a4$var$queryParamsLimitToLast(queryParams, newLimit) {
    const newParams = queryParams.copy();
    newParams.limitSet_ = true;
    newParams.limit_ = newLimit;
    newParams.viewFrom_ = "r" /* VIEW_FROM_RIGHT */ ;
    return newParams;
}
function $30d3a405033775a4$var$queryParamsStartAt(queryParams, indexValue, key) {
    const newParams = queryParams.copy();
    newParams.startSet_ = true;
    if (indexValue === undefined) indexValue = null;
    newParams.indexStartValue_ = indexValue;
    if (key != null) {
        newParams.startNameSet_ = true;
        newParams.indexStartName_ = key;
    } else {
        newParams.startNameSet_ = false;
        newParams.indexStartName_ = "";
    }
    return newParams;
}
function $30d3a405033775a4$var$queryParamsStartAfter(queryParams, indexValue, key) {
    let params;
    if (queryParams.index_ === $30d3a405033775a4$var$KEY_INDEX) {
        if (typeof indexValue === "string") indexValue = $30d3a405033775a4$var$successor(indexValue);
        params = $30d3a405033775a4$var$queryParamsStartAt(queryParams, indexValue, key);
    } else {
        let childKey;
        if (key == null) childKey = $30d3a405033775a4$var$MAX_NAME;
        else childKey = $30d3a405033775a4$var$successor(key);
        params = $30d3a405033775a4$var$queryParamsStartAt(queryParams, indexValue, childKey);
    }
    params.startAfterSet_ = true;
    return params;
}
function $30d3a405033775a4$var$queryParamsEndAt(queryParams, indexValue, key) {
    const newParams = queryParams.copy();
    newParams.endSet_ = true;
    if (indexValue === undefined) indexValue = null;
    newParams.indexEndValue_ = indexValue;
    if (key !== undefined) {
        newParams.endNameSet_ = true;
        newParams.indexEndName_ = key;
    } else {
        newParams.endNameSet_ = false;
        newParams.indexEndName_ = "";
    }
    return newParams;
}
function $30d3a405033775a4$var$queryParamsEndBefore(queryParams, indexValue, key) {
    let childKey;
    let params;
    if (queryParams.index_ === $30d3a405033775a4$var$KEY_INDEX) {
        if (typeof indexValue === "string") indexValue = $30d3a405033775a4$var$predecessor(indexValue);
        params = $30d3a405033775a4$var$queryParamsEndAt(queryParams, indexValue, key);
    } else {
        if (key == null) childKey = $30d3a405033775a4$var$MIN_NAME;
        else childKey = $30d3a405033775a4$var$predecessor(key);
        params = $30d3a405033775a4$var$queryParamsEndAt(queryParams, indexValue, childKey);
    }
    params.endBeforeSet_ = true;
    return params;
}
function $30d3a405033775a4$var$queryParamsOrderBy(queryParams, index) {
    const newParams = queryParams.copy();
    newParams.index_ = index;
    return newParams;
}
/**
 * Returns a set of REST query string parameters representing this query.
 *
 * @returns query string parameters
 */ function $30d3a405033775a4$var$queryParamsToRestQueryStringParameters(queryParams) {
    const qs = {};
    if (queryParams.isDefault()) return qs;
    let orderBy;
    if (queryParams.index_ === $30d3a405033775a4$var$PRIORITY_INDEX) orderBy = "$priority" /* PRIORITY_INDEX */ ;
    else if (queryParams.index_ === $30d3a405033775a4$var$VALUE_INDEX) orderBy = "$value" /* VALUE_INDEX */ ;
    else if (queryParams.index_ === $30d3a405033775a4$var$KEY_INDEX) orderBy = "$key" /* KEY_INDEX */ ;
    else {
        (0, $f43ebbd33d4c5d93$export$a7a9523472993e97)(queryParams.index_ instanceof $30d3a405033775a4$var$PathIndex, "Unrecognized index type!");
        orderBy = queryParams.index_.toString();
    }
    qs["orderBy" /* ORDER_BY */ ] = (0, $f43ebbd33d4c5d93$export$fac44ee5b035f737)(orderBy);
    if (queryParams.startSet_) {
        qs["startAt" /* START_AT */ ] = (0, $f43ebbd33d4c5d93$export$fac44ee5b035f737)(queryParams.indexStartValue_);
        if (queryParams.startNameSet_) qs["startAt" /* START_AT */ ] += "," + (0, $f43ebbd33d4c5d93$export$fac44ee5b035f737)(queryParams.indexStartName_);
    }
    if (queryParams.endSet_) {
        qs["endAt" /* END_AT */ ] = (0, $f43ebbd33d4c5d93$export$fac44ee5b035f737)(queryParams.indexEndValue_);
        if (queryParams.endNameSet_) qs["endAt" /* END_AT */ ] += "," + (0, $f43ebbd33d4c5d93$export$fac44ee5b035f737)(queryParams.indexEndName_);
    }
    if (queryParams.limitSet_) {
        if (queryParams.isViewFromLeft()) qs["limitToFirst" /* LIMIT_TO_FIRST */ ] = queryParams.limit_;
        else qs["limitToLast" /* LIMIT_TO_LAST */ ] = queryParams.limit_;
    }
    return qs;
}
function $30d3a405033775a4$var$queryParamsGetQueryObject(queryParams) {
    const obj = {};
    if (queryParams.startSet_) {
        obj["sp" /* INDEX_START_VALUE */ ] = queryParams.indexStartValue_;
        if (queryParams.startNameSet_) obj["sn" /* INDEX_START_NAME */ ] = queryParams.indexStartName_;
    }
    if (queryParams.endSet_) {
        obj["ep" /* INDEX_END_VALUE */ ] = queryParams.indexEndValue_;
        if (queryParams.endNameSet_) obj["en" /* INDEX_END_NAME */ ] = queryParams.indexEndName_;
    }
    if (queryParams.limitSet_) {
        obj["l" /* LIMIT */ ] = queryParams.limit_;
        let viewFrom = queryParams.viewFrom_;
        if (viewFrom === "") {
            if (queryParams.isViewFromLeft()) viewFrom = "l" /* VIEW_FROM_LEFT */ ;
            else viewFrom = "r" /* VIEW_FROM_RIGHT */ ;
        }
        obj["vf" /* VIEW_FROM */ ] = viewFrom;
    }
    // For now, priority index is the default, so we only specify if it's some other index
    if (queryParams.index_ !== $30d3a405033775a4$var$PRIORITY_INDEX) obj["i" /* INDEX */ ] = queryParams.index_.toString();
    return obj;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An implementation of ServerActions that communicates with the server via REST requests.
 * This is mostly useful for compatibility with crawlers, where we don't want to spin up a full
 * persistent connection (using WebSockets or long-polling)
 */ class $30d3a405033775a4$var$ReadonlyRestClient extends $30d3a405033775a4$var$ServerActions {
    reportStats(stats) {
        throw new Error("Method not implemented.");
    }
    static getListenId_(query, tag) {
        if (tag !== undefined) return "tag$" + tag;
        else {
            (0, $f43ebbd33d4c5d93$export$a7a9523472993e97)(query._queryParams.isDefault(), "should have a tag if it's not a default query.");
            return query._path.toString();
        }
    }
    /** @inheritDoc */ listen(query, currentHashFn, tag, onComplete) {
        const pathString = query._path.toString();
        this.log_("Listen called for " + pathString + " " + query._queryIdentifier);
        // Mark this listener so we can tell if it's removed.
        const listenId = $30d3a405033775a4$var$ReadonlyRestClient.getListenId_(query, tag);
        const thisListen = {};
        this.listens_[listenId] = thisListen;
        const queryStringParameters = $30d3a405033775a4$var$queryParamsToRestQueryStringParameters(query._queryParams);
        this.restRequest_(pathString + ".json", queryStringParameters, (error, result)=>{
            let data = result;
            if (error === 404) {
                data = null;
                error = null;
            }
            if (error === null) this.onDataUpdate_(pathString, data, /*isMerge=*/ false, tag);
            if ((0, $f43ebbd33d4c5d93$export$e51ae4db7b428f67)(this.listens_, listenId) === thisListen) {
                let status;
                if (!error) status = "ok";
                else if (error === 401) status = "permission_denied";
                else status = "rest_error:" + error;
                onComplete(status, null);
            }
        });
    }
    /** @inheritDoc */ unlisten(query, tag) {
        const listenId = $30d3a405033775a4$var$ReadonlyRestClient.getListenId_(query, tag);
        delete this.listens_[listenId];
    }
    get(query) {
        const queryStringParameters = $30d3a405033775a4$var$queryParamsToRestQueryStringParameters(query._queryParams);
        const pathString = query._path.toString();
        const deferred = new (0, $f43ebbd33d4c5d93$export$85f6557964517f1a)();
        this.restRequest_(pathString + ".json", queryStringParameters, (error, result)=>{
            let data = result;
            if (error === 404) {
                data = null;
                error = null;
            }
            if (error === null) {
                this.onDataUpdate_(pathString, data, /*isMerge=*/ false, /*tag=*/ null);
                deferred.resolve(data);
            } else deferred.reject(new Error(data));
        });
        return deferred.promise;
    }
    /** @inheritDoc */ refreshAuthToken(token) {
    // no-op since we just always call getToken.
    }
    /**
     * Performs a REST request to the given path, with the provided query string parameters,
     * and any auth credentials we have.
     */ restRequest_(pathString, queryStringParameters = {}, callback) {
        queryStringParameters["format"] = "export";
        return Promise.all([
            this.authTokenProvider_.getToken(/*forceRefresh=*/ false),
            this.appCheckTokenProvider_.getToken(/*forceRefresh=*/ false)
        ]).then(([authToken, appCheckToken])=>{
            if (authToken && authToken.accessToken) queryStringParameters["auth"] = authToken.accessToken;
            if (appCheckToken && appCheckToken.token) queryStringParameters["ac"] = appCheckToken.token;
            const url = (this.repoInfo_.secure ? "https://" : "http://") + this.repoInfo_.host + pathString + "?" + "ns=" + this.repoInfo_.namespace + (0, $f43ebbd33d4c5d93$export$ac4103b836844853)(queryStringParameters);
            this.log_("Sending REST request for " + url);
            const xhr = new XMLHttpRequest();
            xhr.onreadystatechange = ()=>{
                if (callback && xhr.readyState === 4) {
                    this.log_("REST Response for " + url + " received. status:", xhr.status, "response:", xhr.responseText);
                    let res = null;
                    if (xhr.status >= 200 && xhr.status < 300) {
                        try {
                            res = (0, $f43ebbd33d4c5d93$export$c5a53ce6a17cf18d)(xhr.responseText);
                        } catch (e) {
                            $30d3a405033775a4$var$warn("Failed to parse JSON response for " + url + ": " + xhr.responseText);
                        }
                        callback(null, res);
                    } else {
                        // 401 and 404 are expected.
                        if (xhr.status !== 401 && xhr.status !== 404) $30d3a405033775a4$var$warn("Got unsuccessful REST response for " + url + " Status: " + xhr.status);
                        callback(xhr.status);
                    }
                    callback = null;
                }
            };
            xhr.open("GET", url, /*asynchronous=*/ true);
            xhr.send();
        });
    }
    /**
     * @param repoInfo_ - Data about the namespace we are connecting to
     * @param onDataUpdate_ - A callback for new data from the server
     */ constructor(repoInfo_, onDataUpdate_, authTokenProvider_, appCheckTokenProvider_){
        super();
        this.repoInfo_ = repoInfo_;
        this.onDataUpdate_ = onDataUpdate_;
        this.authTokenProvider_ = authTokenProvider_;
        this.appCheckTokenProvider_ = appCheckTokenProvider_;
        /** @private {function(...[*])} */ this.log_ = $30d3a405033775a4$var$logWrapper("p:rest:");
        /**
         * We don't actually need to track listens, except to prevent us calling an onComplete for a listen
         * that's been removed. :-/
         */ this.listens_ = {};
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Mutable object which basically just stores a reference to the "latest" immutable snapshot.
 */ class $30d3a405033775a4$var$SnapshotHolder {
    getNode(path) {
        return this.rootNode_.getChild(path);
    }
    updateSnapshot(path, newSnapshotNode) {
        this.rootNode_ = this.rootNode_.updateChild(path, newSnapshotNode);
    }
    constructor(){
        this.rootNode_ = $30d3a405033775a4$var$ChildrenNode.EMPTY_NODE;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $30d3a405033775a4$var$newSparseSnapshotTree() {
    return {
        value: null,
        children: new Map()
    };
}
/**
 * Stores the given node at the specified path. If there is already a node
 * at a shallower path, it merges the new data into that snapshot node.
 *
 * @param path - Path to look up snapshot for.
 * @param data - The new data, or null.
 */ function $30d3a405033775a4$var$sparseSnapshotTreeRemember(sparseSnapshotTree, path, data) {
    if ($30d3a405033775a4$var$pathIsEmpty(path)) {
        sparseSnapshotTree.value = data;
        sparseSnapshotTree.children.clear();
    } else if (sparseSnapshotTree.value !== null) sparseSnapshotTree.value = sparseSnapshotTree.value.updateChild(path, data);
    else {
        const childKey = $30d3a405033775a4$var$pathGetFront(path);
        if (!sparseSnapshotTree.children.has(childKey)) sparseSnapshotTree.children.set(childKey, $30d3a405033775a4$var$newSparseSnapshotTree());
        const child = sparseSnapshotTree.children.get(childKey);
        path = $30d3a405033775a4$var$pathPopFront(path);
        $30d3a405033775a4$var$sparseSnapshotTreeRemember(child, path, data);
    }
}
/**
 * Purge the data at path from the cache.
 *
 * @param path - Path to look up snapshot for.
 * @returns True if this node should now be removed.
 */ function $30d3a405033775a4$var$sparseSnapshotTreeForget(sparseSnapshotTree, path) {
    if ($30d3a405033775a4$var$pathIsEmpty(path)) {
        sparseSnapshotTree.value = null;
        sparseSnapshotTree.children.clear();
        return true;
    } else {
        if (sparseSnapshotTree.value !== null) {
            if (sparseSnapshotTree.value.isLeafNode()) // We're trying to forget a node that doesn't exist
            return false;
            else {
                const value = sparseSnapshotTree.value;
                sparseSnapshotTree.value = null;
                value.forEachChild($30d3a405033775a4$var$PRIORITY_INDEX, (key, tree)=>{
                    $30d3a405033775a4$var$sparseSnapshotTreeRemember(sparseSnapshotTree, new $30d3a405033775a4$var$Path(key), tree);
                });
                return $30d3a405033775a4$var$sparseSnapshotTreeForget(sparseSnapshotTree, path);
            }
        } else if (sparseSnapshotTree.children.size > 0) {
            const childKey = $30d3a405033775a4$var$pathGetFront(path);
            path = $30d3a405033775a4$var$pathPopFront(path);
            if (sparseSnapshotTree.children.has(childKey)) {
                const safeToRemove = $30d3a405033775a4$var$sparseSnapshotTreeForget(sparseSnapshotTree.children.get(childKey), path);
                if (safeToRemove) sparseSnapshotTree.children.delete(childKey);
            }
            return sparseSnapshotTree.children.size === 0;
        } else return true;
    }
}
/**
 * Recursively iterates through all of the stored tree and calls the
 * callback on each one.
 *
 * @param prefixPath - Path to look up node for.
 * @param func - The function to invoke for each tree.
 */ function $30d3a405033775a4$var$sparseSnapshotTreeForEachTree(sparseSnapshotTree, prefixPath, func) {
    if (sparseSnapshotTree.value !== null) func(prefixPath, sparseSnapshotTree.value);
    else $30d3a405033775a4$var$sparseSnapshotTreeForEachChild(sparseSnapshotTree, (key, tree)=>{
        const path = new $30d3a405033775a4$var$Path(prefixPath.toString() + "/" + key);
        $30d3a405033775a4$var$sparseSnapshotTreeForEachTree(tree, path, func);
    });
}
/**
 * Iterates through each immediate child and triggers the callback.
 * Only seems to be used in tests.
 *
 * @param func - The function to invoke for each child.
 */ function $30d3a405033775a4$var$sparseSnapshotTreeForEachChild(sparseSnapshotTree, func) {
    sparseSnapshotTree.children.forEach((tree, key)=>{
        func(key, tree);
    });
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns the delta from the previous call to get stats.
 *
 * @param collection_ - The collection to "listen" to.
 */ class $30d3a405033775a4$var$StatsListener {
    get() {
        const newStats = this.collection_.get();
        const delta = Object.assign({}, newStats);
        if (this.last_) $30d3a405033775a4$var$each(this.last_, (stat, value)=>{
            delta[stat] = delta[stat] - value;
        });
        this.last_ = newStats;
        return delta;
    }
    constructor(collection_){
        this.collection_ = collection_;
        this.last_ = null;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Assuming some apps may have a short amount of time on page, and a bulk of firebase operations probably
// happen on page load, we try to report our first set of stats pretty quickly, but we wait at least 10
// seconds to try to ensure the Firebase connection is established / settled.
const $30d3a405033775a4$var$FIRST_STATS_MIN_TIME = 10000;
const $30d3a405033775a4$var$FIRST_STATS_MAX_TIME = 30000;
// We'll continue to report stats on average every 5 minutes.
const $30d3a405033775a4$var$REPORT_STATS_INTERVAL = 300000;
class $30d3a405033775a4$var$StatsReporter {
    reportStats_() {
        const stats = this.statsListener_.get();
        const reportedStats = {};
        let haveStatsToReport = false;
        $30d3a405033775a4$var$each(stats, (stat, value)=>{
            if (value > 0 && (0, $f43ebbd33d4c5d93$export$2344b14b097df817)(this.statsToReport_, stat)) {
                reportedStats[stat] = value;
                haveStatsToReport = true;
            }
        });
        if (haveStatsToReport) this.server_.reportStats(reportedStats);
        // queue our next run.
        $30d3a405033775a4$var$setTimeoutNonBlocking(this.reportStats_.bind(this), Math.floor(Math.random() * 2 * $30d3a405033775a4$var$REPORT_STATS_INTERVAL));
    }
    constructor(collection, server_){
        this.server_ = server_;
        this.statsToReport_ = {};
        this.statsListener_ = new $30d3a405033775a4$var$StatsListener(collection);
        const timeout = $30d3a405033775a4$var$FIRST_STATS_MIN_TIME + ($30d3a405033775a4$var$FIRST_STATS_MAX_TIME - $30d3a405033775a4$var$FIRST_STATS_MIN_TIME) * Math.random();
        $30d3a405033775a4$var$setTimeoutNonBlocking(this.reportStats_.bind(this), Math.floor(timeout));
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 *
 * @enum
 */ var $30d3a405033775a4$var$OperationType;
(function(OperationType) {
    OperationType[OperationType["OVERWRITE"] = 0] = "OVERWRITE";
    OperationType[OperationType["MERGE"] = 1] = "MERGE";
    OperationType[OperationType["ACK_USER_WRITE"] = 2] = "ACK_USER_WRITE";
    OperationType[OperationType["LISTEN_COMPLETE"] = 3] = "LISTEN_COMPLETE";
})($30d3a405033775a4$var$OperationType || ($30d3a405033775a4$var$OperationType = {}));
function $30d3a405033775a4$var$newOperationSourceUser() {
    return {
        fromUser: true,
        fromServer: false,
        queryId: null,
        tagged: false
    };
}
function $30d3a405033775a4$var$newOperationSourceServer() {
    return {
        fromUser: false,
        fromServer: true,
        queryId: null,
        tagged: false
    };
}
function $30d3a405033775a4$var$newOperationSourceServerTaggedQuery(queryId) {
    return {
        fromUser: false,
        fromServer: true,
        queryId: queryId,
        tagged: true
    };
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $30d3a405033775a4$var$AckUserWrite {
    operationForChild(childName) {
        if (!$30d3a405033775a4$var$pathIsEmpty(this.path)) {
            (0, $f43ebbd33d4c5d93$export$a7a9523472993e97)($30d3a405033775a4$var$pathGetFront(this.path) === childName, "operationForChild called for unrelated child.");
            return new $30d3a405033775a4$var$AckUserWrite($30d3a405033775a4$var$pathPopFront(this.path), this.affectedTree, this.revert);
        } else if (this.affectedTree.value != null) {
            (0, $f43ebbd33d4c5d93$export$a7a9523472993e97)(this.affectedTree.children.isEmpty(), "affectedTree should not have overlapping affected paths.");
            // All child locations are affected as well; just return same operation.
            return this;
        } else {
            const childTree = this.affectedTree.subtree(new $30d3a405033775a4$var$Path(childName));
            return new $30d3a405033775a4$var$AckUserWrite($30d3a405033775a4$var$newEmptyPath(), childTree, this.revert);
        }
    }
    /**
     * @param affectedTree - A tree containing true for each affected path. Affected paths can't overlap.
     */ constructor(/** @inheritDoc */ path, /** @inheritDoc */ affectedTree, /** @inheritDoc */ revert){
        this.path = path;
        this.affectedTree = affectedTree;
        this.revert = revert;
        /** @inheritDoc */ this.type = $30d3a405033775a4$var$OperationType.ACK_USER_WRITE;
        /** @inheritDoc */ this.source = $30d3a405033775a4$var$newOperationSourceUser();
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $30d3a405033775a4$var$ListenComplete {
    operationForChild(childName) {
        if ($30d3a405033775a4$var$pathIsEmpty(this.path)) return new $30d3a405033775a4$var$ListenComplete(this.source, $30d3a405033775a4$var$newEmptyPath());
        else return new $30d3a405033775a4$var$ListenComplete(this.source, $30d3a405033775a4$var$pathPopFront(this.path));
    }
    constructor(source, path){
        this.source = source;
        this.path = path;
        /** @inheritDoc */ this.type = $30d3a405033775a4$var$OperationType.LISTEN_COMPLETE;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $30d3a405033775a4$var$Overwrite {
    operationForChild(childName) {
        if ($30d3a405033775a4$var$pathIsEmpty(this.path)) return new $30d3a405033775a4$var$Overwrite(this.source, $30d3a405033775a4$var$newEmptyPath(), this.snap.getImmediateChild(childName));
        else return new $30d3a405033775a4$var$Overwrite(this.source, $30d3a405033775a4$var$pathPopFront(this.path), this.snap);
    }
    constructor(source, path, snap){
        this.source = source;
        this.path = path;
        this.snap = snap;
        /** @inheritDoc */ this.type = $30d3a405033775a4$var$OperationType.OVERWRITE;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $30d3a405033775a4$var$Merge {
    operationForChild(childName) {
        if ($30d3a405033775a4$var$pathIsEmpty(this.path)) {
            const childTree = this.children.subtree(new $30d3a405033775a4$var$Path(childName));
            if (childTree.isEmpty()) // This child is unaffected
            return null;
            else if (childTree.value) // We have a snapshot for the child in question.  This becomes an overwrite of the child.
            return new $30d3a405033775a4$var$Overwrite(this.source, $30d3a405033775a4$var$newEmptyPath(), childTree.value);
            else // This is a merge at a deeper level
            return new $30d3a405033775a4$var$Merge(this.source, $30d3a405033775a4$var$newEmptyPath(), childTree);
        } else {
            (0, $f43ebbd33d4c5d93$export$a7a9523472993e97)($30d3a405033775a4$var$pathGetFront(this.path) === childName, "Can't get a merge for a child not on the path of the operation");
            return new $30d3a405033775a4$var$Merge(this.source, $30d3a405033775a4$var$pathPopFront(this.path), this.children);
        }
    }
    toString() {
        return "Operation(" + this.path + ": " + this.source.toString() + " merge: " + this.children.toString() + ")";
    }
    constructor(/** @inheritDoc */ source, /** @inheritDoc */ path, /** @inheritDoc */ children){
        this.source = source;
        this.path = path;
        this.children = children;
        /** @inheritDoc */ this.type = $30d3a405033775a4$var$OperationType.MERGE;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A cache node only stores complete children. Additionally it holds a flag whether the node can be considered fully
 * initialized in the sense that we know at one point in time this represented a valid state of the world, e.g.
 * initialized with data from the server, or a complete overwrite by the client. The filtered flag also tracks
 * whether a node potentially had children removed due to a filter.
 */ class $30d3a405033775a4$var$CacheNode {
    /**
     * Returns whether this node was fully initialized with either server data or a complete overwrite by the client
     */ isFullyInitialized() {
        return this.fullyInitialized_;
    }
    /**
     * Returns whether this node is potentially missing children due to a filter applied to the node
     */ isFiltered() {
        return this.filtered_;
    }
    isCompleteForPath(path) {
        if ($30d3a405033775a4$var$pathIsEmpty(path)) return this.isFullyInitialized() && !this.filtered_;
        const childKey = $30d3a405033775a4$var$pathGetFront(path);
        return this.isCompleteForChild(childKey);
    }
    isCompleteForChild(key) {
        return this.isFullyInitialized() && !this.filtered_ || this.node_.hasChild(key);
    }
    getNode() {
        return this.node_;
    }
    constructor(node_, fullyInitialized_, filtered_){
        this.node_ = node_;
        this.fullyInitialized_ = fullyInitialized_;
        this.filtered_ = filtered_;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An EventGenerator is used to convert "raw" changes (Change) as computed by the
 * CacheDiffer into actual events (Event) that can be raised.  See generateEventsForChanges()
 * for details.
 *
 */ class $30d3a405033775a4$var$EventGenerator {
    constructor(query_){
        this.query_ = query_;
        this.index_ = this.query_._queryParams.getIndex();
    }
}
/**
 * Given a set of raw changes (no moved events and prevName not specified yet), and a set of
 * EventRegistrations that should be notified of these changes, generate the actual events to be raised.
 *
 * Notes:
 *  - child_moved events will be synthesized at this time for any child_changed events that affect
 *    our index.
 *  - prevName will be calculated based on the index ordering.
 */ function $30d3a405033775a4$var$eventGeneratorGenerateEventsForChanges(eventGenerator, changes, eventCache, eventRegistrations) {
    const events = [];
    const moves = [];
    changes.forEach((change)=>{
        if (change.type === "child_changed" /* CHILD_CHANGED */  && eventGenerator.index_.indexedValueChanged(change.oldSnap, change.snapshotNode)) moves.push($30d3a405033775a4$var$changeChildMoved(change.childName, change.snapshotNode));
    });
    $30d3a405033775a4$var$eventGeneratorGenerateEventsForType(eventGenerator, events, "child_removed" /* CHILD_REMOVED */ , changes, eventRegistrations, eventCache);
    $30d3a405033775a4$var$eventGeneratorGenerateEventsForType(eventGenerator, events, "child_added" /* CHILD_ADDED */ , changes, eventRegistrations, eventCache);
    $30d3a405033775a4$var$eventGeneratorGenerateEventsForType(eventGenerator, events, "child_moved" /* CHILD_MOVED */ , moves, eventRegistrations, eventCache);
    $30d3a405033775a4$var$eventGeneratorGenerateEventsForType(eventGenerator, events, "child_changed" /* CHILD_CHANGED */ , changes, eventRegistrations, eventCache);
    $30d3a405033775a4$var$eventGeneratorGenerateEventsForType(eventGenerator, events, "value" /* VALUE */ , changes, eventRegistrations, eventCache);
    return events;
}
/**
 * Given changes of a single change type, generate the corresponding events.
 */ function $30d3a405033775a4$var$eventGeneratorGenerateEventsForType(eventGenerator, events, eventType, changes, registrations, eventCache) {
    const filteredChanges = changes.filter((change)=>change.type === eventType);
    filteredChanges.sort((a, b)=>$30d3a405033775a4$var$eventGeneratorCompareChanges(eventGenerator, a, b));
    filteredChanges.forEach((change)=>{
        const materializedChange = $30d3a405033775a4$var$eventGeneratorMaterializeSingleChange(eventGenerator, change, eventCache);
        registrations.forEach((registration)=>{
            if (registration.respondsTo(change.type)) events.push(registration.createEvent(materializedChange, eventGenerator.query_));
        });
    });
}
function $30d3a405033775a4$var$eventGeneratorMaterializeSingleChange(eventGenerator, change, eventCache) {
    if (change.type === "value" || change.type === "child_removed") return change;
    else {
        change.prevName = eventCache.getPredecessorChildName(change.childName, change.snapshotNode, eventGenerator.index_);
        return change;
    }
}
function $30d3a405033775a4$var$eventGeneratorCompareChanges(eventGenerator, a, b) {
    if (a.childName == null || b.childName == null) throw (0, $f43ebbd33d4c5d93$export$a39cad550e7ab28a)("Should only compare child_ events.");
    const aWrapped = new $30d3a405033775a4$var$NamedNode(a.childName, a.snapshotNode);
    const bWrapped = new $30d3a405033775a4$var$NamedNode(b.childName, b.snapshotNode);
    return eventGenerator.index_.compare(aWrapped, bWrapped);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $30d3a405033775a4$var$newViewCache(eventCache, serverCache) {
    return {
        eventCache: eventCache,
        serverCache: serverCache
    };
}
function $30d3a405033775a4$var$viewCacheUpdateEventSnap(viewCache, eventSnap, complete, filtered) {
    return $30d3a405033775a4$var$newViewCache(new $30d3a405033775a4$var$CacheNode(eventSnap, complete, filtered), viewCache.serverCache);
}
function $30d3a405033775a4$var$viewCacheUpdateServerSnap(viewCache, serverSnap, complete, filtered) {
    return $30d3a405033775a4$var$newViewCache(viewCache.eventCache, new $30d3a405033775a4$var$CacheNode(serverSnap, complete, filtered));
}
function $30d3a405033775a4$var$viewCacheGetCompleteEventSnap(viewCache) {
    return viewCache.eventCache.isFullyInitialized() ? viewCache.eventCache.getNode() : null;
}
function $30d3a405033775a4$var$viewCacheGetCompleteServerSnap(viewCache) {
    return viewCache.serverCache.isFullyInitialized() ? viewCache.serverCache.getNode() : null;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $30d3a405033775a4$var$emptyChildrenSingleton;
/**
 * Singleton empty children collection.
 *
 */ const $30d3a405033775a4$var$EmptyChildren = ()=>{
    if (!$30d3a405033775a4$var$emptyChildrenSingleton) $30d3a405033775a4$var$emptyChildrenSingleton = new $30d3a405033775a4$var$SortedMap($30d3a405033775a4$var$stringCompare);
    return $30d3a405033775a4$var$emptyChildrenSingleton;
};
/**
 * A tree with immutable elements.
 */ class $30d3a405033775a4$var$ImmutableTree {
    static fromObject(obj) {
        let tree = new $30d3a405033775a4$var$ImmutableTree(null);
        $30d3a405033775a4$var$each(obj, (childPath, childSnap)=>{
            tree = tree.set(new $30d3a405033775a4$var$Path(childPath), childSnap);
        });
        return tree;
    }
    /**
     * True if the value is empty and there are no children
     */ isEmpty() {
        return this.value === null && this.children.isEmpty();
    }
    /**
     * Given a path and predicate, return the first node and the path to that node
     * where the predicate returns true.
     *
     * TODO Do a perf test -- If we're creating a bunch of `{path: value:}`
     * objects on the way back out, it may be better to pass down a pathSoFar obj.
     *
     * @param relativePath - The remainder of the path
     * @param predicate - The predicate to satisfy to return a node
     */ findRootMostMatchingPathAndValue(relativePath, predicate) {
        if (this.value != null && predicate(this.value)) return {
            path: $30d3a405033775a4$var$newEmptyPath(),
            value: this.value
        };
        else {
            if ($30d3a405033775a4$var$pathIsEmpty(relativePath)) return null;
            else {
                const front = $30d3a405033775a4$var$pathGetFront(relativePath);
                const child = this.children.get(front);
                if (child !== null) {
                    const childExistingPathAndValue = child.findRootMostMatchingPathAndValue($30d3a405033775a4$var$pathPopFront(relativePath), predicate);
                    if (childExistingPathAndValue != null) {
                        const fullPath = $30d3a405033775a4$var$pathChild(new $30d3a405033775a4$var$Path(front), childExistingPathAndValue.path);
                        return {
                            path: fullPath,
                            value: childExistingPathAndValue.value
                        };
                    } else return null;
                } else return null;
            }
        }
    }
    /**
     * Find, if it exists, the shortest subpath of the given path that points a defined
     * value in the tree
     */ findRootMostValueAndPath(relativePath) {
        return this.findRootMostMatchingPathAndValue(relativePath, ()=>true);
    }
    /**
     * @returns The subtree at the given path
     */ subtree(relativePath) {
        if ($30d3a405033775a4$var$pathIsEmpty(relativePath)) return this;
        else {
            const front = $30d3a405033775a4$var$pathGetFront(relativePath);
            const childTree = this.children.get(front);
            if (childTree !== null) return childTree.subtree($30d3a405033775a4$var$pathPopFront(relativePath));
            else return new $30d3a405033775a4$var$ImmutableTree(null);
        }
    }
    /**
     * Sets a value at the specified path.
     *
     * @param relativePath - Path to set value at.
     * @param toSet - Value to set.
     * @returns Resulting tree.
     */ set(relativePath, toSet) {
        if ($30d3a405033775a4$var$pathIsEmpty(relativePath)) return new $30d3a405033775a4$var$ImmutableTree(toSet, this.children);
        else {
            const front = $30d3a405033775a4$var$pathGetFront(relativePath);
            const child = this.children.get(front) || new $30d3a405033775a4$var$ImmutableTree(null);
            const newChild = child.set($30d3a405033775a4$var$pathPopFront(relativePath), toSet);
            const newChildren = this.children.insert(front, newChild);
            return new $30d3a405033775a4$var$ImmutableTree(this.value, newChildren);
        }
    }
    /**
     * Removes the value at the specified path.
     *
     * @param relativePath - Path to value to remove.
     * @returns Resulting tree.
     */ remove(relativePath) {
        if ($30d3a405033775a4$var$pathIsEmpty(relativePath)) {
            if (this.children.isEmpty()) return new $30d3a405033775a4$var$ImmutableTree(null);
            else return new $30d3a405033775a4$var$ImmutableTree(null, this.children);
        } else {
            const front = $30d3a405033775a4$var$pathGetFront(relativePath);
            const child = this.children.get(front);
            if (child) {
                const newChild = child.remove($30d3a405033775a4$var$pathPopFront(relativePath));
                let newChildren;
                if (newChild.isEmpty()) newChildren = this.children.remove(front);
                else newChildren = this.children.insert(front, newChild);
                if (this.value === null && newChildren.isEmpty()) return new $30d3a405033775a4$var$ImmutableTree(null);
                else return new $30d3a405033775a4$var$ImmutableTree(this.value, newChildren);
            } else return this;
        }
    }
    /**
     * Gets a value from the tree.
     *
     * @param relativePath - Path to get value for.
     * @returns Value at path, or null.
     */ get(relativePath) {
        if ($30d3a405033775a4$var$pathIsEmpty(relativePath)) return this.value;
        else {
            const front = $30d3a405033775a4$var$pathGetFront(relativePath);
            const child = this.children.get(front);
            if (child) return child.get($30d3a405033775a4$var$pathPopFront(relativePath));
            else return null;
        }
    }
    /**
     * Replace the subtree at the specified path with the given new tree.
     *
     * @param relativePath - Path to replace subtree for.
     * @param newTree - New tree.
     * @returns Resulting tree.
     */ setTree(relativePath, newTree) {
        if ($30d3a405033775a4$var$pathIsEmpty(relativePath)) return newTree;
        else {
            const front = $30d3a405033775a4$var$pathGetFront(relativePath);
            const child = this.children.get(front) || new $30d3a405033775a4$var$ImmutableTree(null);
            const newChild = child.setTree($30d3a405033775a4$var$pathPopFront(relativePath), newTree);
            let newChildren;
            if (newChild.isEmpty()) newChildren = this.children.remove(front);
            else newChildren = this.children.insert(front, newChild);
            return new $30d3a405033775a4$var$ImmutableTree(this.value, newChildren);
        }
    }
    /**
     * Performs a depth first fold on this tree. Transforms a tree into a single
     * value, given a function that operates on the path to a node, an optional
     * current value, and a map of child names to folded subtrees
     */ fold(fn) {
        return this.fold_($30d3a405033775a4$var$newEmptyPath(), fn);
    }
    /**
     * Recursive helper for public-facing fold() method
     */ fold_(pathSoFar, fn) {
        const accum = {};
        this.children.inorderTraversal((childKey, childTree)=>{
            accum[childKey] = childTree.fold_($30d3a405033775a4$var$pathChild(pathSoFar, childKey), fn);
        });
        return fn(pathSoFar, this.value, accum);
    }
    /**
     * Find the first matching value on the given path. Return the result of applying f to it.
     */ findOnPath(path, f) {
        return this.findOnPath_(path, $30d3a405033775a4$var$newEmptyPath(), f);
    }
    findOnPath_(pathToFollow, pathSoFar, f) {
        const result = this.value ? f(pathSoFar, this.value) : false;
        if (result) return result;
        else {
            if ($30d3a405033775a4$var$pathIsEmpty(pathToFollow)) return null;
            else {
                const front = $30d3a405033775a4$var$pathGetFront(pathToFollow);
                const nextChild = this.children.get(front);
                if (nextChild) return nextChild.findOnPath_($30d3a405033775a4$var$pathPopFront(pathToFollow), $30d3a405033775a4$var$pathChild(pathSoFar, front), f);
                else return null;
            }
        }
    }
    foreachOnPath(path, f) {
        return this.foreachOnPath_(path, $30d3a405033775a4$var$newEmptyPath(), f);
    }
    foreachOnPath_(pathToFollow, currentRelativePath, f) {
        if ($30d3a405033775a4$var$pathIsEmpty(pathToFollow)) return this;
        else {
            if (this.value) f(currentRelativePath, this.value);
            const front = $30d3a405033775a4$var$pathGetFront(pathToFollow);
            const nextChild = this.children.get(front);
            if (nextChild) return nextChild.foreachOnPath_($30d3a405033775a4$var$pathPopFront(pathToFollow), $30d3a405033775a4$var$pathChild(currentRelativePath, front), f);
            else return new $30d3a405033775a4$var$ImmutableTree(null);
        }
    }
    /**
     * Calls the given function for each node in the tree that has a value.
     *
     * @param f - A function to be called with the path from the root of the tree to
     * a node, and the value at that node. Called in depth-first order.
     */ foreach(f) {
        this.foreach_($30d3a405033775a4$var$newEmptyPath(), f);
    }
    foreach_(currentRelativePath, f) {
        this.children.inorderTraversal((childName, childTree)=>{
            childTree.foreach_($30d3a405033775a4$var$pathChild(currentRelativePath, childName), f);
        });
        if (this.value) f(currentRelativePath, this.value);
    }
    foreachChild(f) {
        this.children.inorderTraversal((childName, childTree)=>{
            if (childTree.value) f(childName, childTree.value);
        });
    }
    constructor(value, children = $30d3a405033775a4$var$EmptyChildren()){
        this.value = value;
        this.children = children;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * This class holds a collection of writes that can be applied to nodes in unison. It abstracts away the logic with
 * dealing with priority writes and multiple nested writes. At any given path there is only allowed to be one write
 * modifying that path. Any write to an existing path or shadowing an existing path will modify that existing write
 * to reflect the write added.
 */ class $30d3a405033775a4$var$CompoundWrite {
    static empty() {
        return new $30d3a405033775a4$var$CompoundWrite(new $30d3a405033775a4$var$ImmutableTree(null));
    }
    constructor(writeTree_){
        this.writeTree_ = writeTree_;
    }
}
function $30d3a405033775a4$var$compoundWriteAddWrite(compoundWrite, path, node) {
    if ($30d3a405033775a4$var$pathIsEmpty(path)) return new $30d3a405033775a4$var$CompoundWrite(new $30d3a405033775a4$var$ImmutableTree(node));
    else {
        const rootmost = compoundWrite.writeTree_.findRootMostValueAndPath(path);
        if (rootmost != null) {
            const rootMostPath = rootmost.path;
            let value = rootmost.value;
            const relativePath = $30d3a405033775a4$var$newRelativePath(rootMostPath, path);
            value = value.updateChild(relativePath, node);
            return new $30d3a405033775a4$var$CompoundWrite(compoundWrite.writeTree_.set(rootMostPath, value));
        } else {
            const subtree = new $30d3a405033775a4$var$ImmutableTree(node);
            const newWriteTree = compoundWrite.writeTree_.setTree(path, subtree);
            return new $30d3a405033775a4$var$CompoundWrite(newWriteTree);
        }
    }
}
function $30d3a405033775a4$var$compoundWriteAddWrites(compoundWrite, path, updates) {
    let newWrite = compoundWrite;
    $30d3a405033775a4$var$each(updates, (childKey, node)=>{
        newWrite = $30d3a405033775a4$var$compoundWriteAddWrite(newWrite, $30d3a405033775a4$var$pathChild(path, childKey), node);
    });
    return newWrite;
}
/**
 * Will remove a write at the given path and deeper paths. This will <em>not</em> modify a write at a higher
 * location, which must be removed by calling this method with that path.
 *
 * @param compoundWrite - The CompoundWrite to remove.
 * @param path - The path at which a write and all deeper writes should be removed
 * @returns The new CompoundWrite with the removed path
 */ function $30d3a405033775a4$var$compoundWriteRemoveWrite(compoundWrite, path) {
    if ($30d3a405033775a4$var$pathIsEmpty(path)) return $30d3a405033775a4$var$CompoundWrite.empty();
    else {
        const newWriteTree = compoundWrite.writeTree_.setTree(path, new $30d3a405033775a4$var$ImmutableTree(null));
        return new $30d3a405033775a4$var$CompoundWrite(newWriteTree);
    }
}
/**
 * Returns whether this CompoundWrite will fully overwrite a node at a given location and can therefore be
 * considered "complete".
 *
 * @param compoundWrite - The CompoundWrite to check.
 * @param path - The path to check for
 * @returns Whether there is a complete write at that path
 */ function $30d3a405033775a4$var$compoundWriteHasCompleteWrite(compoundWrite, path) {
    return $30d3a405033775a4$var$compoundWriteGetCompleteNode(compoundWrite, path) != null;
}
/**
 * Returns a node for a path if and only if the node is a "complete" overwrite at that path. This will not aggregate
 * writes from deeper paths, but will return child nodes from a more shallow path.
 *
 * @param compoundWrite - The CompoundWrite to get the node from.
 * @param path - The path to get a complete write
 * @returns The node if complete at that path, or null otherwise.
 */ function $30d3a405033775a4$var$compoundWriteGetCompleteNode(compoundWrite, path) {
    const rootmost = compoundWrite.writeTree_.findRootMostValueAndPath(path);
    if (rootmost != null) return compoundWrite.writeTree_.get(rootmost.path).getChild($30d3a405033775a4$var$newRelativePath(rootmost.path, path));
    else return null;
}
/**
 * Returns all children that are guaranteed to be a complete overwrite.
 *
 * @param compoundWrite - The CompoundWrite to get children from.
 * @returns A list of all complete children.
 */ function $30d3a405033775a4$var$compoundWriteGetCompleteChildren(compoundWrite) {
    const children = [];
    const node = compoundWrite.writeTree_.value;
    if (node != null) // If it's a leaf node, it has no children; so nothing to do.
    {
        if (!node.isLeafNode()) node.forEachChild($30d3a405033775a4$var$PRIORITY_INDEX, (childName, childNode)=>{
            children.push(new $30d3a405033775a4$var$NamedNode(childName, childNode));
        });
    } else compoundWrite.writeTree_.children.inorderTraversal((childName, childTree)=>{
        if (childTree.value != null) children.push(new $30d3a405033775a4$var$NamedNode(childName, childTree.value));
    });
    return children;
}
function $30d3a405033775a4$var$compoundWriteChildCompoundWrite(compoundWrite, path) {
    if ($30d3a405033775a4$var$pathIsEmpty(path)) return compoundWrite;
    else {
        const shadowingNode = $30d3a405033775a4$var$compoundWriteGetCompleteNode(compoundWrite, path);
        if (shadowingNode != null) return new $30d3a405033775a4$var$CompoundWrite(new $30d3a405033775a4$var$ImmutableTree(shadowingNode));
        else return new $30d3a405033775a4$var$CompoundWrite(compoundWrite.writeTree_.subtree(path));
    }
}
/**
 * Returns true if this CompoundWrite is empty and therefore does not modify any nodes.
 * @returns Whether this CompoundWrite is empty
 */ function $30d3a405033775a4$var$compoundWriteIsEmpty(compoundWrite) {
    return compoundWrite.writeTree_.isEmpty();
}
/**
 * Applies this CompoundWrite to a node. The node is returned with all writes from this CompoundWrite applied to the
 * node
 * @param node - The node to apply this CompoundWrite to
 * @returns The node with all writes applied
 */ function $30d3a405033775a4$var$compoundWriteApply(compoundWrite, node) {
    return $30d3a405033775a4$var$applySubtreeWrite($30d3a405033775a4$var$newEmptyPath(), compoundWrite.writeTree_, node);
}
function $30d3a405033775a4$var$applySubtreeWrite(relativePath, writeTree, node) {
    if (writeTree.value != null) // Since there a write is always a leaf, we're done here
    return node.updateChild(relativePath, writeTree.value);
    else {
        let priorityWrite = null;
        writeTree.children.inorderTraversal((childKey, childTree)=>{
            if (childKey === ".priority") {
                // Apply priorities at the end so we don't update priorities for either empty nodes or forget
                // to apply priorities to empty nodes that are later filled
                (0, $f43ebbd33d4c5d93$export$a7a9523472993e97)(childTree.value !== null, "Priority writes must always be leaf nodes");
                priorityWrite = childTree.value;
            } else node = $30d3a405033775a4$var$applySubtreeWrite($30d3a405033775a4$var$pathChild(relativePath, childKey), childTree, node);
        });
        // If there was a priority write, we only apply it if the node is not empty
        if (!node.getChild(relativePath).isEmpty() && priorityWrite !== null) node = node.updateChild($30d3a405033775a4$var$pathChild(relativePath, ".priority"), priorityWrite);
        return node;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Create a new WriteTreeRef for the given path. For use with a new sync point at the given path.
 *
 */ function $30d3a405033775a4$var$writeTreeChildWrites(writeTree, path) {
    return $30d3a405033775a4$var$newWriteTreeRef(path, writeTree);
}
/**
 * Record a new overwrite from user code.
 *
 * @param visible - This is set to false by some transactions. It should be excluded from event caches
 */ function $30d3a405033775a4$var$writeTreeAddOverwrite(writeTree, path, snap, writeId, visible) {
    (0, $f43ebbd33d4c5d93$export$a7a9523472993e97)(writeId > writeTree.lastWriteId, "Stacking an older write on top of newer ones");
    if (visible === undefined) visible = true;
    writeTree.allWrites.push({
        path: path,
        snap: snap,
        writeId: writeId,
        visible: visible
    });
    if (visible) writeTree.visibleWrites = $30d3a405033775a4$var$compoundWriteAddWrite(writeTree.visibleWrites, path, snap);
    writeTree.lastWriteId = writeId;
}
/**
 * Record a new merge from user code.
 */ function $30d3a405033775a4$var$writeTreeAddMerge(writeTree, path, changedChildren, writeId) {
    (0, $f43ebbd33d4c5d93$export$a7a9523472993e97)(writeId > writeTree.lastWriteId, "Stacking an older merge on top of newer ones");
    writeTree.allWrites.push({
        path: path,
        children: changedChildren,
        writeId: writeId,
        visible: true
    });
    writeTree.visibleWrites = $30d3a405033775a4$var$compoundWriteAddWrites(writeTree.visibleWrites, path, changedChildren);
    writeTree.lastWriteId = writeId;
}
function $30d3a405033775a4$var$writeTreeGetWrite(writeTree, writeId) {
    for(let i = 0; i < writeTree.allWrites.length; i++){
        const record = writeTree.allWrites[i];
        if (record.writeId === writeId) return record;
    }
    return null;
}
/**
 * Remove a write (either an overwrite or merge) that has been successfully acknowledge by the server. Recalculates
 * the tree if necessary.  We return true if it may have been visible, meaning views need to reevaluate.
 *
 * @returns true if the write may have been visible (meaning we'll need to reevaluate / raise
 * events as a result).
 */ function $30d3a405033775a4$var$writeTreeRemoveWrite(writeTree, writeId) {
    // Note: disabling this check. It could be a transaction that preempted another transaction, and thus was applied
    // out of order.
    //const validClear = revert || this.allWrites_.length === 0 || writeId <= this.allWrites_[0].writeId;
    //assert(validClear, "Either we don't have this write, or it's the first one in the queue");
    const idx = writeTree.allWrites.findIndex((s)=>{
        return s.writeId === writeId;
    });
    (0, $f43ebbd33d4c5d93$export$a7a9523472993e97)(idx >= 0, "removeWrite called with nonexistent writeId.");
    const writeToRemove = writeTree.allWrites[idx];
    writeTree.allWrites.splice(idx, 1);
    let removedWriteWasVisible = writeToRemove.visible;
    let removedWriteOverlapsWithOtherWrites = false;
    let i = writeTree.allWrites.length - 1;
    while(removedWriteWasVisible && i >= 0){
        const currentWrite = writeTree.allWrites[i];
        if (currentWrite.visible) {
            if (i >= idx && $30d3a405033775a4$var$writeTreeRecordContainsPath_(currentWrite, writeToRemove.path)) // The removed write was completely shadowed by a subsequent write.
            removedWriteWasVisible = false;
            else if ($30d3a405033775a4$var$pathContains(writeToRemove.path, currentWrite.path)) // Either we're covering some writes or they're covering part of us (depending on which came first).
            removedWriteOverlapsWithOtherWrites = true;
        }
        i--;
    }
    if (!removedWriteWasVisible) return false;
    else if (removedWriteOverlapsWithOtherWrites) {
        // There's some shadowing going on. Just rebuild the visible writes from scratch.
        $30d3a405033775a4$var$writeTreeResetTree_(writeTree);
        return true;
    } else {
        // There's no shadowing.  We can safely just remove the write(s) from visibleWrites.
        if (writeToRemove.snap) writeTree.visibleWrites = $30d3a405033775a4$var$compoundWriteRemoveWrite(writeTree.visibleWrites, writeToRemove.path);
        else {
            const children = writeToRemove.children;
            $30d3a405033775a4$var$each(children, (childName)=>{
                writeTree.visibleWrites = $30d3a405033775a4$var$compoundWriteRemoveWrite(writeTree.visibleWrites, $30d3a405033775a4$var$pathChild(writeToRemove.path, childName));
            });
        }
        return true;
    }
}
function $30d3a405033775a4$var$writeTreeRecordContainsPath_(writeRecord, path) {
    if (writeRecord.snap) return $30d3a405033775a4$var$pathContains(writeRecord.path, path);
    else {
        for(const childName in writeRecord.children){
            if (writeRecord.children.hasOwnProperty(childName) && $30d3a405033775a4$var$pathContains($30d3a405033775a4$var$pathChild(writeRecord.path, childName), path)) return true;
        }
        return false;
    }
}
/**
 * Re-layer the writes and merges into a tree so we can efficiently calculate event snapshots
 */ function $30d3a405033775a4$var$writeTreeResetTree_(writeTree) {
    writeTree.visibleWrites = $30d3a405033775a4$var$writeTreeLayerTree_(writeTree.allWrites, $30d3a405033775a4$var$writeTreeDefaultFilter_, $30d3a405033775a4$var$newEmptyPath());
    if (writeTree.allWrites.length > 0) writeTree.lastWriteId = writeTree.allWrites[writeTree.allWrites.length - 1].writeId;
    else writeTree.lastWriteId = -1;
}
/**
 * The default filter used when constructing the tree. Keep everything that's visible.
 */ function $30d3a405033775a4$var$writeTreeDefaultFilter_(write) {
    return write.visible;
}
/**
 * Static method. Given an array of WriteRecords, a filter for which ones to include, and a path, construct the tree of
 * event data at that path.
 */ function $30d3a405033775a4$var$writeTreeLayerTree_(writes, filter, treeRoot) {
    let compoundWrite = $30d3a405033775a4$var$CompoundWrite.empty();
    for(let i = 0; i < writes.length; ++i){
        const write = writes[i];
        // Theory, a later set will either:
        // a) abort a relevant transaction, so no need to worry about excluding it from calculating that transaction
        // b) not be relevant to a transaction (separate branch), so again will not affect the data for that transaction
        if (filter(write)) {
            const writePath = write.path;
            let relativePath;
            if (write.snap) {
                if ($30d3a405033775a4$var$pathContains(treeRoot, writePath)) {
                    relativePath = $30d3a405033775a4$var$newRelativePath(treeRoot, writePath);
                    compoundWrite = $30d3a405033775a4$var$compoundWriteAddWrite(compoundWrite, relativePath, write.snap);
                } else if ($30d3a405033775a4$var$pathContains(writePath, treeRoot)) {
                    relativePath = $30d3a405033775a4$var$newRelativePath(writePath, treeRoot);
                    compoundWrite = $30d3a405033775a4$var$compoundWriteAddWrite(compoundWrite, $30d3a405033775a4$var$newEmptyPath(), write.snap.getChild(relativePath));
                }
            } else if (write.children) {
                if ($30d3a405033775a4$var$pathContains(treeRoot, writePath)) {
                    relativePath = $30d3a405033775a4$var$newRelativePath(treeRoot, writePath);
                    compoundWrite = $30d3a405033775a4$var$compoundWriteAddWrites(compoundWrite, relativePath, write.children);
                } else if ($30d3a405033775a4$var$pathContains(writePath, treeRoot)) {
                    relativePath = $30d3a405033775a4$var$newRelativePath(writePath, treeRoot);
                    if ($30d3a405033775a4$var$pathIsEmpty(relativePath)) compoundWrite = $30d3a405033775a4$var$compoundWriteAddWrites(compoundWrite, $30d3a405033775a4$var$newEmptyPath(), write.children);
                    else {
                        const child = (0, $f43ebbd33d4c5d93$export$e51ae4db7b428f67)(write.children, $30d3a405033775a4$var$pathGetFront(relativePath));
                        if (child) {
                            // There exists a child in this node that matches the root path
                            const deepNode = child.getChild($30d3a405033775a4$var$pathPopFront(relativePath));
                            compoundWrite = $30d3a405033775a4$var$compoundWriteAddWrite(compoundWrite, $30d3a405033775a4$var$newEmptyPath(), deepNode);
                        }
                    }
                }
            } else throw (0, $f43ebbd33d4c5d93$export$a39cad550e7ab28a)("WriteRecord should have .snap or .children");
        }
    }
    return compoundWrite;
}
/**
 * Given optional, underlying server data, and an optional set of constraints (exclude some sets, include hidden
 * writes), attempt to calculate a complete snapshot for the given path
 *
 * @param writeIdsToExclude - An optional set to be excluded
 * @param includeHiddenWrites - Defaults to false, whether or not to layer on writes with visible set to false
 */ function $30d3a405033775a4$var$writeTreeCalcCompleteEventCache(writeTree, treePath, completeServerCache, writeIdsToExclude, includeHiddenWrites) {
    if (!writeIdsToExclude && !includeHiddenWrites) {
        const shadowingNode = $30d3a405033775a4$var$compoundWriteGetCompleteNode(writeTree.visibleWrites, treePath);
        if (shadowingNode != null) return shadowingNode;
        else {
            const subMerge = $30d3a405033775a4$var$compoundWriteChildCompoundWrite(writeTree.visibleWrites, treePath);
            if ($30d3a405033775a4$var$compoundWriteIsEmpty(subMerge)) return completeServerCache;
            else if (completeServerCache == null && !$30d3a405033775a4$var$compoundWriteHasCompleteWrite(subMerge, $30d3a405033775a4$var$newEmptyPath())) // We wouldn't have a complete snapshot, since there's no underlying data and no complete shadow
            return null;
            else {
                const layeredCache = completeServerCache || $30d3a405033775a4$var$ChildrenNode.EMPTY_NODE;
                return $30d3a405033775a4$var$compoundWriteApply(subMerge, layeredCache);
            }
        }
    } else {
        const merge = $30d3a405033775a4$var$compoundWriteChildCompoundWrite(writeTree.visibleWrites, treePath);
        if (!includeHiddenWrites && $30d3a405033775a4$var$compoundWriteIsEmpty(merge)) return completeServerCache;
        else {
            // If the server cache is null, and we don't have a complete cache, we need to return null
            if (!includeHiddenWrites && completeServerCache == null && !$30d3a405033775a4$var$compoundWriteHasCompleteWrite(merge, $30d3a405033775a4$var$newEmptyPath())) return null;
            else {
                const filter = function(write) {
                    return (write.visible || includeHiddenWrites) && (!writeIdsToExclude || !~writeIdsToExclude.indexOf(write.writeId)) && ($30d3a405033775a4$var$pathContains(write.path, treePath) || $30d3a405033775a4$var$pathContains(treePath, write.path));
                };
                const mergeAtPath = $30d3a405033775a4$var$writeTreeLayerTree_(writeTree.allWrites, filter, treePath);
                const layeredCache = completeServerCache || $30d3a405033775a4$var$ChildrenNode.EMPTY_NODE;
                return $30d3a405033775a4$var$compoundWriteApply(mergeAtPath, layeredCache);
            }
        }
    }
}
/**
 * With optional, underlying server data, attempt to return a children node of children that we have complete data for.
 * Used when creating new views, to pre-fill their complete event children snapshot.
 */ function $30d3a405033775a4$var$writeTreeCalcCompleteEventChildren(writeTree, treePath, completeServerChildren) {
    let completeChildren = $30d3a405033775a4$var$ChildrenNode.EMPTY_NODE;
    const topLevelSet = $30d3a405033775a4$var$compoundWriteGetCompleteNode(writeTree.visibleWrites, treePath);
    if (topLevelSet) {
        if (!topLevelSet.isLeafNode()) // we're shadowing everything. Return the children.
        topLevelSet.forEachChild($30d3a405033775a4$var$PRIORITY_INDEX, (childName, childSnap)=>{
            completeChildren = completeChildren.updateImmediateChild(childName, childSnap);
        });
        return completeChildren;
    } else if (completeServerChildren) {
        // Layer any children we have on top of this
        // We know we don't have a top-level set, so just enumerate existing children
        const merge = $30d3a405033775a4$var$compoundWriteChildCompoundWrite(writeTree.visibleWrites, treePath);
        completeServerChildren.forEachChild($30d3a405033775a4$var$PRIORITY_INDEX, (childName, childNode)=>{
            const node = $30d3a405033775a4$var$compoundWriteApply($30d3a405033775a4$var$compoundWriteChildCompoundWrite(merge, new $30d3a405033775a4$var$Path(childName)), childNode);
            completeChildren = completeChildren.updateImmediateChild(childName, node);
        });
        // Add any complete children we have from the set
        $30d3a405033775a4$var$compoundWriteGetCompleteChildren(merge).forEach((namedNode)=>{
            completeChildren = completeChildren.updateImmediateChild(namedNode.name, namedNode.node);
        });
        return completeChildren;
    } else {
        // We don't have anything to layer on top of. Layer on any children we have
        // Note that we can return an empty snap if we have a defined delete
        const merge = $30d3a405033775a4$var$compoundWriteChildCompoundWrite(writeTree.visibleWrites, treePath);
        $30d3a405033775a4$var$compoundWriteGetCompleteChildren(merge).forEach((namedNode)=>{
            completeChildren = completeChildren.updateImmediateChild(namedNode.name, namedNode.node);
        });
        return completeChildren;
    }
}
/**
 * Given that the underlying server data has updated, determine what, if anything, needs to be
 * applied to the event cache.
 *
 * Possibilities:
 *
 * 1. No writes are shadowing. Events should be raised, the snap to be applied comes from the server data
 *
 * 2. Some write is completely shadowing. No events to be raised
 *
 * 3. Is partially shadowed. Events
 *
 * Either existingEventSnap or existingServerSnap must exist
 */ function $30d3a405033775a4$var$writeTreeCalcEventCacheAfterServerOverwrite(writeTree, treePath, childPath, existingEventSnap, existingServerSnap) {
    (0, $f43ebbd33d4c5d93$export$a7a9523472993e97)(existingEventSnap || existingServerSnap, "Either existingEventSnap or existingServerSnap must exist");
    const path = $30d3a405033775a4$var$pathChild(treePath, childPath);
    if ($30d3a405033775a4$var$compoundWriteHasCompleteWrite(writeTree.visibleWrites, path)) // At this point we can probably guarantee that we're in case 2, meaning no events
    // May need to check visibility while doing the findRootMostValueAndPath call
    return null;
    else {
        // No complete shadowing. We're either partially shadowing or not shadowing at all.
        const childMerge = $30d3a405033775a4$var$compoundWriteChildCompoundWrite(writeTree.visibleWrites, path);
        if ($30d3a405033775a4$var$compoundWriteIsEmpty(childMerge)) // We're not shadowing at all. Case 1
        return existingServerSnap.getChild(childPath);
        else // This could be more efficient if the serverNode + updates doesn't change the eventSnap
        // However this is tricky to find out, since user updates don't necessary change the server
        // snap, e.g. priority updates on empty nodes, or deep deletes. Another special case is if the server
        // adds nodes, but doesn't change any existing writes. It is therefore not enough to
        // only check if the updates change the serverNode.
        // Maybe check if the merge tree contains these special cases and only do a full overwrite in that case?
        return $30d3a405033775a4$var$compoundWriteApply(childMerge, existingServerSnap.getChild(childPath));
    }
}
/**
 * Returns a complete child for a given server snap after applying all user writes or null if there is no
 * complete child for this ChildKey.
 */ function $30d3a405033775a4$var$writeTreeCalcCompleteChild(writeTree, treePath, childKey, existingServerSnap) {
    const path = $30d3a405033775a4$var$pathChild(treePath, childKey);
    const shadowingNode = $30d3a405033775a4$var$compoundWriteGetCompleteNode(writeTree.visibleWrites, path);
    if (shadowingNode != null) return shadowingNode;
    else {
        if (existingServerSnap.isCompleteForChild(childKey)) {
            const childMerge = $30d3a405033775a4$var$compoundWriteChildCompoundWrite(writeTree.visibleWrites, path);
            return $30d3a405033775a4$var$compoundWriteApply(childMerge, existingServerSnap.getNode().getImmediateChild(childKey));
        } else return null;
    }
}
/**
 * Returns a node if there is a complete overwrite for this path. More specifically, if there is a write at
 * a higher path, this will return the child of that write relative to the write and this path.
 * Returns null if there is no write at this path.
 */ function $30d3a405033775a4$var$writeTreeShadowingWrite(writeTree, path) {
    return $30d3a405033775a4$var$compoundWriteGetCompleteNode(writeTree.visibleWrites, path);
}
/**
 * This method is used when processing child remove events on a query. If we can, we pull in children that were outside
 * the window, but may now be in the window.
 */ function $30d3a405033775a4$var$writeTreeCalcIndexedSlice(writeTree, treePath, completeServerData, startPost, count, reverse, index) {
    let toIterate;
    const merge = $30d3a405033775a4$var$compoundWriteChildCompoundWrite(writeTree.visibleWrites, treePath);
    const shadowingNode = $30d3a405033775a4$var$compoundWriteGetCompleteNode(merge, $30d3a405033775a4$var$newEmptyPath());
    if (shadowingNode != null) toIterate = shadowingNode;
    else if (completeServerData != null) toIterate = $30d3a405033775a4$var$compoundWriteApply(merge, completeServerData);
    else // no children to iterate on
    return [];
    toIterate = toIterate.withIndex(index);
    if (!toIterate.isEmpty() && !toIterate.isLeafNode()) {
        const nodes = [];
        const cmp = index.getCompare();
        const iter = reverse ? toIterate.getReverseIteratorFrom(startPost, index) : toIterate.getIteratorFrom(startPost, index);
        let next = iter.getNext();
        while(next && nodes.length < count){
            if (cmp(next, startPost) !== 0) nodes.push(next);
            next = iter.getNext();
        }
        return nodes;
    } else return [];
}
function $30d3a405033775a4$var$newWriteTree() {
    return {
        visibleWrites: $30d3a405033775a4$var$CompoundWrite.empty(),
        allWrites: [],
        lastWriteId: -1
    };
}
/**
 * If possible, returns a complete event cache, using the underlying server data if possible. In addition, can be used
 * to get a cache that includes hidden writes, and excludes arbitrary writes. Note that customizing the returned node
 * can lead to a more expensive calculation.
 *
 * @param writeIdsToExclude - Optional writes to exclude.
 * @param includeHiddenWrites - Defaults to false, whether or not to layer on writes with visible set to false
 */ function $30d3a405033775a4$var$writeTreeRefCalcCompleteEventCache(writeTreeRef, completeServerCache, writeIdsToExclude, includeHiddenWrites) {
    return $30d3a405033775a4$var$writeTreeCalcCompleteEventCache(writeTreeRef.writeTree, writeTreeRef.treePath, completeServerCache, writeIdsToExclude, includeHiddenWrites);
}
/**
 * If possible, returns a children node containing all of the complete children we have data for. The returned data is a
 * mix of the given server data and write data.
 *
 */ function $30d3a405033775a4$var$writeTreeRefCalcCompleteEventChildren(writeTreeRef, completeServerChildren) {
    return $30d3a405033775a4$var$writeTreeCalcCompleteEventChildren(writeTreeRef.writeTree, writeTreeRef.treePath, completeServerChildren);
}
/**
 * Given that either the underlying server data has updated or the outstanding writes have updated, determine what,
 * if anything, needs to be applied to the event cache.
 *
 * Possibilities:
 *
 * 1. No writes are shadowing. Events should be raised, the snap to be applied comes from the server data
 *
 * 2. Some write is completely shadowing. No events to be raised
 *
 * 3. Is partially shadowed. Events should be raised
 *
 * Either existingEventSnap or existingServerSnap must exist, this is validated via an assert
 *
 *
 */ function $30d3a405033775a4$var$writeTreeRefCalcEventCacheAfterServerOverwrite(writeTreeRef, path, existingEventSnap, existingServerSnap) {
    return $30d3a405033775a4$var$writeTreeCalcEventCacheAfterServerOverwrite(writeTreeRef.writeTree, writeTreeRef.treePath, path, existingEventSnap, existingServerSnap);
}
/**
 * Returns a node if there is a complete overwrite for this path. More specifically, if there is a write at
 * a higher path, this will return the child of that write relative to the write and this path.
 * Returns null if there is no write at this path.
 *
 */ function $30d3a405033775a4$var$writeTreeRefShadowingWrite(writeTreeRef, path) {
    return $30d3a405033775a4$var$writeTreeShadowingWrite(writeTreeRef.writeTree, $30d3a405033775a4$var$pathChild(writeTreeRef.treePath, path));
}
/**
 * This method is used when processing child remove events on a query. If we can, we pull in children that were outside
 * the window, but may now be in the window
 */ function $30d3a405033775a4$var$writeTreeRefCalcIndexedSlice(writeTreeRef, completeServerData, startPost, count, reverse, index) {
    return $30d3a405033775a4$var$writeTreeCalcIndexedSlice(writeTreeRef.writeTree, writeTreeRef.treePath, completeServerData, startPost, count, reverse, index);
}
/**
 * Returns a complete child for a given server snap after applying all user writes or null if there is no
 * complete child for this ChildKey.
 */ function $30d3a405033775a4$var$writeTreeRefCalcCompleteChild(writeTreeRef, childKey, existingServerCache) {
    return $30d3a405033775a4$var$writeTreeCalcCompleteChild(writeTreeRef.writeTree, writeTreeRef.treePath, childKey, existingServerCache);
}
/**
 * Return a WriteTreeRef for a child.
 */ function $30d3a405033775a4$var$writeTreeRefChild(writeTreeRef, childName) {
    return $30d3a405033775a4$var$newWriteTreeRef($30d3a405033775a4$var$pathChild(writeTreeRef.treePath, childName), writeTreeRef.writeTree);
}
function $30d3a405033775a4$var$newWriteTreeRef(path, writeTree) {
    return {
        treePath: path,
        writeTree: writeTree
    };
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $30d3a405033775a4$var$ChildChangeAccumulator {
    trackChildChange(change) {
        const type = change.type;
        const childKey = change.childName;
        (0, $f43ebbd33d4c5d93$export$a7a9523472993e97)(type === "child_added" /* CHILD_ADDED */  || type === "child_changed" /* CHILD_CHANGED */  || type === "child_removed" /* CHILD_REMOVED */ , "Only child changes supported for tracking");
        (0, $f43ebbd33d4c5d93$export$a7a9523472993e97)(childKey !== ".priority", "Only non-priority child changes can be tracked.");
        const oldChange = this.changeMap.get(childKey);
        if (oldChange) {
            const oldType = oldChange.type;
            if (type === "child_added" /* CHILD_ADDED */  && oldType === "child_removed" /* CHILD_REMOVED */ ) this.changeMap.set(childKey, $30d3a405033775a4$var$changeChildChanged(childKey, change.snapshotNode, oldChange.snapshotNode));
            else if (type === "child_removed" /* CHILD_REMOVED */  && oldType === "child_added" /* CHILD_ADDED */ ) this.changeMap.delete(childKey);
            else if (type === "child_removed" /* CHILD_REMOVED */  && oldType === "child_changed" /* CHILD_CHANGED */ ) this.changeMap.set(childKey, $30d3a405033775a4$var$changeChildRemoved(childKey, oldChange.oldSnap));
            else if (type === "child_changed" /* CHILD_CHANGED */  && oldType === "child_added" /* CHILD_ADDED */ ) this.changeMap.set(childKey, $30d3a405033775a4$var$changeChildAdded(childKey, change.snapshotNode));
            else if (type === "child_changed" /* CHILD_CHANGED */  && oldType === "child_changed" /* CHILD_CHANGED */ ) this.changeMap.set(childKey, $30d3a405033775a4$var$changeChildChanged(childKey, change.snapshotNode, oldChange.oldSnap));
            else throw (0, $f43ebbd33d4c5d93$export$a39cad550e7ab28a)("Illegal combination of changes: " + change + " occurred after " + oldChange);
        } else this.changeMap.set(childKey, change);
    }
    getChanges() {
        return Array.from(this.changeMap.values());
    }
    constructor(){
        this.changeMap = new Map();
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An implementation of CompleteChildSource that never returns any additional children
 */ // eslint-disable-next-line @typescript-eslint/naming-convention
class $30d3a405033775a4$var$NoCompleteChildSource_ {
    getCompleteChild(childKey) {
        return null;
    }
    getChildAfterChild(index, child, reverse) {
        return null;
    }
}
/**
 * Singleton instance.
 */ const $30d3a405033775a4$var$NO_COMPLETE_CHILD_SOURCE = new $30d3a405033775a4$var$NoCompleteChildSource_();
/**
 * An implementation of CompleteChildSource that uses a WriteTree in addition to any other server data or
 * old event caches available to calculate complete children.
 */ class $30d3a405033775a4$var$WriteTreeCompleteChildSource {
    getCompleteChild(childKey) {
        const node = this.viewCache_.eventCache;
        if (node.isCompleteForChild(childKey)) return node.getNode().getImmediateChild(childKey);
        else {
            const serverNode = this.optCompleteServerCache_ != null ? new $30d3a405033775a4$var$CacheNode(this.optCompleteServerCache_, true, false) : this.viewCache_.serverCache;
            return $30d3a405033775a4$var$writeTreeRefCalcCompleteChild(this.writes_, childKey, serverNode);
        }
    }
    getChildAfterChild(index, child, reverse) {
        const completeServerData = this.optCompleteServerCache_ != null ? this.optCompleteServerCache_ : $30d3a405033775a4$var$viewCacheGetCompleteServerSnap(this.viewCache_);
        const nodes = $30d3a405033775a4$var$writeTreeRefCalcIndexedSlice(this.writes_, completeServerData, child, 1, reverse, index);
        if (nodes.length === 0) return null;
        else return nodes[0];
    }
    constructor(writes_, viewCache_, optCompleteServerCache_ = null){
        this.writes_ = writes_;
        this.viewCache_ = viewCache_;
        this.optCompleteServerCache_ = optCompleteServerCache_;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $30d3a405033775a4$var$newViewProcessor(filter) {
    return {
        filter: filter
    };
}
function $30d3a405033775a4$var$viewProcessorAssertIndexed(viewProcessor, viewCache) {
    (0, $f43ebbd33d4c5d93$export$a7a9523472993e97)(viewCache.eventCache.getNode().isIndexed(viewProcessor.filter.getIndex()), "Event snap not indexed");
    (0, $f43ebbd33d4c5d93$export$a7a9523472993e97)(viewCache.serverCache.getNode().isIndexed(viewProcessor.filter.getIndex()), "Server snap not indexed");
}
function $30d3a405033775a4$var$viewProcessorApplyOperation(viewProcessor, oldViewCache, operation, writesCache, completeCache) {
    const accumulator = new $30d3a405033775a4$var$ChildChangeAccumulator();
    let newViewCache, filterServerNode;
    if (operation.type === $30d3a405033775a4$var$OperationType.OVERWRITE) {
        const overwrite = operation;
        if (overwrite.source.fromUser) newViewCache = $30d3a405033775a4$var$viewProcessorApplyUserOverwrite(viewProcessor, oldViewCache, overwrite.path, overwrite.snap, writesCache, completeCache, accumulator);
        else {
            (0, $f43ebbd33d4c5d93$export$a7a9523472993e97)(overwrite.source.fromServer, "Unknown source.");
            // We filter the node if it's a tagged update or the node has been previously filtered  and the
            // update is not at the root in which case it is ok (and necessary) to mark the node unfiltered
            // again
            filterServerNode = overwrite.source.tagged || oldViewCache.serverCache.isFiltered() && !$30d3a405033775a4$var$pathIsEmpty(overwrite.path);
            newViewCache = $30d3a405033775a4$var$viewProcessorApplyServerOverwrite(viewProcessor, oldViewCache, overwrite.path, overwrite.snap, writesCache, completeCache, filterServerNode, accumulator);
        }
    } else if (operation.type === $30d3a405033775a4$var$OperationType.MERGE) {
        const merge = operation;
        if (merge.source.fromUser) newViewCache = $30d3a405033775a4$var$viewProcessorApplyUserMerge(viewProcessor, oldViewCache, merge.path, merge.children, writesCache, completeCache, accumulator);
        else {
            (0, $f43ebbd33d4c5d93$export$a7a9523472993e97)(merge.source.fromServer, "Unknown source.");
            // We filter the node if it's a tagged update or the node has been previously filtered
            filterServerNode = merge.source.tagged || oldViewCache.serverCache.isFiltered();
            newViewCache = $30d3a405033775a4$var$viewProcessorApplyServerMerge(viewProcessor, oldViewCache, merge.path, merge.children, writesCache, completeCache, filterServerNode, accumulator);
        }
    } else if (operation.type === $30d3a405033775a4$var$OperationType.ACK_USER_WRITE) {
        const ackUserWrite = operation;
        if (!ackUserWrite.revert) newViewCache = $30d3a405033775a4$var$viewProcessorAckUserWrite(viewProcessor, oldViewCache, ackUserWrite.path, ackUserWrite.affectedTree, writesCache, completeCache, accumulator);
        else newViewCache = $30d3a405033775a4$var$viewProcessorRevertUserWrite(viewProcessor, oldViewCache, ackUserWrite.path, writesCache, completeCache, accumulator);
    } else if (operation.type === $30d3a405033775a4$var$OperationType.LISTEN_COMPLETE) newViewCache = $30d3a405033775a4$var$viewProcessorListenComplete(viewProcessor, oldViewCache, operation.path, writesCache, accumulator);
    else throw (0, $f43ebbd33d4c5d93$export$a39cad550e7ab28a)("Unknown operation type: " + operation.type);
    const changes = accumulator.getChanges();
    $30d3a405033775a4$var$viewProcessorMaybeAddValueEvent(oldViewCache, newViewCache, changes);
    return {
        viewCache: newViewCache,
        changes: changes
    };
}
function $30d3a405033775a4$var$viewProcessorMaybeAddValueEvent(oldViewCache, newViewCache, accumulator) {
    const eventSnap = newViewCache.eventCache;
    if (eventSnap.isFullyInitialized()) {
        const isLeafOrEmpty = eventSnap.getNode().isLeafNode() || eventSnap.getNode().isEmpty();
        const oldCompleteSnap = $30d3a405033775a4$var$viewCacheGetCompleteEventSnap(oldViewCache);
        if (accumulator.length > 0 || !oldViewCache.eventCache.isFullyInitialized() || isLeafOrEmpty && !eventSnap.getNode().equals(oldCompleteSnap) || !eventSnap.getNode().getPriority().equals(oldCompleteSnap.getPriority())) accumulator.push($30d3a405033775a4$var$changeValue($30d3a405033775a4$var$viewCacheGetCompleteEventSnap(newViewCache)));
    }
}
function $30d3a405033775a4$var$viewProcessorGenerateEventCacheAfterServerEvent(viewProcessor, viewCache, changePath, writesCache, source, accumulator) {
    const oldEventSnap = viewCache.eventCache;
    if ($30d3a405033775a4$var$writeTreeRefShadowingWrite(writesCache, changePath) != null) // we have a shadowing write, ignore changes
    return viewCache;
    else {
        let newEventCache, serverNode;
        if ($30d3a405033775a4$var$pathIsEmpty(changePath)) {
            // TODO: figure out how this plays with "sliding ack windows"
            (0, $f43ebbd33d4c5d93$export$a7a9523472993e97)(viewCache.serverCache.isFullyInitialized(), "If change path is empty, we must have complete server data");
            if (viewCache.serverCache.isFiltered()) {
                // We need to special case this, because we need to only apply writes to complete children, or
                // we might end up raising events for incomplete children. If the server data is filtered deep
                // writes cannot be guaranteed to be complete
                const serverCache = $30d3a405033775a4$var$viewCacheGetCompleteServerSnap(viewCache);
                const completeChildren = serverCache instanceof $30d3a405033775a4$var$ChildrenNode ? serverCache : $30d3a405033775a4$var$ChildrenNode.EMPTY_NODE;
                const completeEventChildren = $30d3a405033775a4$var$writeTreeRefCalcCompleteEventChildren(writesCache, completeChildren);
                newEventCache = viewProcessor.filter.updateFullNode(viewCache.eventCache.getNode(), completeEventChildren, accumulator);
            } else {
                const completeNode = $30d3a405033775a4$var$writeTreeRefCalcCompleteEventCache(writesCache, $30d3a405033775a4$var$viewCacheGetCompleteServerSnap(viewCache));
                newEventCache = viewProcessor.filter.updateFullNode(viewCache.eventCache.getNode(), completeNode, accumulator);
            }
        } else {
            const childKey = $30d3a405033775a4$var$pathGetFront(changePath);
            if (childKey === ".priority") {
                (0, $f43ebbd33d4c5d93$export$a7a9523472993e97)($30d3a405033775a4$var$pathGetLength(changePath) === 1, "Can't have a priority with additional path components");
                const oldEventNode = oldEventSnap.getNode();
                serverNode = viewCache.serverCache.getNode();
                // we might have overwrites for this priority
                const updatedPriority = $30d3a405033775a4$var$writeTreeRefCalcEventCacheAfterServerOverwrite(writesCache, changePath, oldEventNode, serverNode);
                if (updatedPriority != null) newEventCache = viewProcessor.filter.updatePriority(oldEventNode, updatedPriority);
                else // priority didn't change, keep old node
                newEventCache = oldEventSnap.getNode();
            } else {
                const childChangePath = $30d3a405033775a4$var$pathPopFront(changePath);
                // update child
                let newEventChild;
                if (oldEventSnap.isCompleteForChild(childKey)) {
                    serverNode = viewCache.serverCache.getNode();
                    const eventChildUpdate = $30d3a405033775a4$var$writeTreeRefCalcEventCacheAfterServerOverwrite(writesCache, changePath, oldEventSnap.getNode(), serverNode);
                    if (eventChildUpdate != null) newEventChild = oldEventSnap.getNode().getImmediateChild(childKey).updateChild(childChangePath, eventChildUpdate);
                    else // Nothing changed, just keep the old child
                    newEventChild = oldEventSnap.getNode().getImmediateChild(childKey);
                } else newEventChild = $30d3a405033775a4$var$writeTreeRefCalcCompleteChild(writesCache, childKey, viewCache.serverCache);
                if (newEventChild != null) newEventCache = viewProcessor.filter.updateChild(oldEventSnap.getNode(), childKey, newEventChild, childChangePath, source, accumulator);
                else // no complete child available or no change
                newEventCache = oldEventSnap.getNode();
            }
        }
        return $30d3a405033775a4$var$viewCacheUpdateEventSnap(viewCache, newEventCache, oldEventSnap.isFullyInitialized() || $30d3a405033775a4$var$pathIsEmpty(changePath), viewProcessor.filter.filtersNodes());
    }
}
function $30d3a405033775a4$var$viewProcessorApplyServerOverwrite(viewProcessor, oldViewCache, changePath, changedSnap, writesCache, completeCache, filterServerNode, accumulator) {
    const oldServerSnap = oldViewCache.serverCache;
    let newServerCache;
    const serverFilter = filterServerNode ? viewProcessor.filter : viewProcessor.filter.getIndexedFilter();
    if ($30d3a405033775a4$var$pathIsEmpty(changePath)) newServerCache = serverFilter.updateFullNode(oldServerSnap.getNode(), changedSnap, null);
    else if (serverFilter.filtersNodes() && !oldServerSnap.isFiltered()) {
        // we want to filter the server node, but we didn't filter the server node yet, so simulate a full update
        const newServerNode = oldServerSnap.getNode().updateChild(changePath, changedSnap);
        newServerCache = serverFilter.updateFullNode(oldServerSnap.getNode(), newServerNode, null);
    } else {
        const childKey = $30d3a405033775a4$var$pathGetFront(changePath);
        if (!oldServerSnap.isCompleteForPath(changePath) && $30d3a405033775a4$var$pathGetLength(changePath) > 1) // We don't update incomplete nodes with updates intended for other listeners
        return oldViewCache;
        const childChangePath = $30d3a405033775a4$var$pathPopFront(changePath);
        const childNode = oldServerSnap.getNode().getImmediateChild(childKey);
        const newChildNode = childNode.updateChild(childChangePath, changedSnap);
        if (childKey === ".priority") newServerCache = serverFilter.updatePriority(oldServerSnap.getNode(), newChildNode);
        else newServerCache = serverFilter.updateChild(oldServerSnap.getNode(), childKey, newChildNode, childChangePath, $30d3a405033775a4$var$NO_COMPLETE_CHILD_SOURCE, null);
    }
    const newViewCache = $30d3a405033775a4$var$viewCacheUpdateServerSnap(oldViewCache, newServerCache, oldServerSnap.isFullyInitialized() || $30d3a405033775a4$var$pathIsEmpty(changePath), serverFilter.filtersNodes());
    const source = new $30d3a405033775a4$var$WriteTreeCompleteChildSource(writesCache, newViewCache, completeCache);
    return $30d3a405033775a4$var$viewProcessorGenerateEventCacheAfterServerEvent(viewProcessor, newViewCache, changePath, writesCache, source, accumulator);
}
function $30d3a405033775a4$var$viewProcessorApplyUserOverwrite(viewProcessor, oldViewCache, changePath, changedSnap, writesCache, completeCache, accumulator) {
    const oldEventSnap = oldViewCache.eventCache;
    let newViewCache, newEventCache;
    const source = new $30d3a405033775a4$var$WriteTreeCompleteChildSource(writesCache, oldViewCache, completeCache);
    if ($30d3a405033775a4$var$pathIsEmpty(changePath)) {
        newEventCache = viewProcessor.filter.updateFullNode(oldViewCache.eventCache.getNode(), changedSnap, accumulator);
        newViewCache = $30d3a405033775a4$var$viewCacheUpdateEventSnap(oldViewCache, newEventCache, true, viewProcessor.filter.filtersNodes());
    } else {
        const childKey = $30d3a405033775a4$var$pathGetFront(changePath);
        if (childKey === ".priority") {
            newEventCache = viewProcessor.filter.updatePriority(oldViewCache.eventCache.getNode(), changedSnap);
            newViewCache = $30d3a405033775a4$var$viewCacheUpdateEventSnap(oldViewCache, newEventCache, oldEventSnap.isFullyInitialized(), oldEventSnap.isFiltered());
        } else {
            const childChangePath = $30d3a405033775a4$var$pathPopFront(changePath);
            const oldChild = oldEventSnap.getNode().getImmediateChild(childKey);
            let newChild;
            if ($30d3a405033775a4$var$pathIsEmpty(childChangePath)) // Child overwrite, we can replace the child
            newChild = changedSnap;
            else {
                const childNode = source.getCompleteChild(childKey);
                if (childNode != null) {
                    if ($30d3a405033775a4$var$pathGetBack(childChangePath) === ".priority" && childNode.getChild($30d3a405033775a4$var$pathParent(childChangePath)).isEmpty()) // This is a priority update on an empty node. If this node exists on the server, the
                    // server will send down the priority in the update, so ignore for now
                    newChild = childNode;
                    else newChild = childNode.updateChild(childChangePath, changedSnap);
                } else // There is no complete child node available
                newChild = $30d3a405033775a4$var$ChildrenNode.EMPTY_NODE;
            }
            if (!oldChild.equals(newChild)) {
                const newEventSnap = viewProcessor.filter.updateChild(oldEventSnap.getNode(), childKey, newChild, childChangePath, source, accumulator);
                newViewCache = $30d3a405033775a4$var$viewCacheUpdateEventSnap(oldViewCache, newEventSnap, oldEventSnap.isFullyInitialized(), viewProcessor.filter.filtersNodes());
            } else newViewCache = oldViewCache;
        }
    }
    return newViewCache;
}
function $30d3a405033775a4$var$viewProcessorCacheHasChild(viewCache, childKey) {
    return viewCache.eventCache.isCompleteForChild(childKey);
}
function $30d3a405033775a4$var$viewProcessorApplyUserMerge(viewProcessor, viewCache, path, changedChildren, writesCache, serverCache, accumulator) {
    // HACK: In the case of a limit query, there may be some changes that bump things out of the
    // window leaving room for new items.  It's important we process these changes first, so we
    // iterate the changes twice, first processing any that affect items currently in view.
    // TODO: I consider an item "in view" if cacheHasChild is true, which checks both the server
    // and event snap.  I'm not sure if this will result in edge cases when a child is in one but
    // not the other.
    let curViewCache = viewCache;
    changedChildren.foreach((relativePath, childNode)=>{
        const writePath = $30d3a405033775a4$var$pathChild(path, relativePath);
        if ($30d3a405033775a4$var$viewProcessorCacheHasChild(viewCache, $30d3a405033775a4$var$pathGetFront(writePath))) curViewCache = $30d3a405033775a4$var$viewProcessorApplyUserOverwrite(viewProcessor, curViewCache, writePath, childNode, writesCache, serverCache, accumulator);
    });
    changedChildren.foreach((relativePath, childNode)=>{
        const writePath = $30d3a405033775a4$var$pathChild(path, relativePath);
        if (!$30d3a405033775a4$var$viewProcessorCacheHasChild(viewCache, $30d3a405033775a4$var$pathGetFront(writePath))) curViewCache = $30d3a405033775a4$var$viewProcessorApplyUserOverwrite(viewProcessor, curViewCache, writePath, childNode, writesCache, serverCache, accumulator);
    });
    return curViewCache;
}
function $30d3a405033775a4$var$viewProcessorApplyMerge(viewProcessor, node, merge) {
    merge.foreach((relativePath, childNode)=>{
        node = node.updateChild(relativePath, childNode);
    });
    return node;
}
function $30d3a405033775a4$var$viewProcessorApplyServerMerge(viewProcessor, viewCache, path, changedChildren, writesCache, serverCache, filterServerNode, accumulator) {
    // If we don't have a cache yet, this merge was intended for a previously listen in the same location. Ignore it and
    // wait for the complete data update coming soon.
    if (viewCache.serverCache.getNode().isEmpty() && !viewCache.serverCache.isFullyInitialized()) return viewCache;
    // HACK: In the case of a limit query, there may be some changes that bump things out of the
    // window leaving room for new items.  It's important we process these changes first, so we
    // iterate the changes twice, first processing any that affect items currently in view.
    // TODO: I consider an item "in view" if cacheHasChild is true, which checks both the server
    // and event snap.  I'm not sure if this will result in edge cases when a child is in one but
    // not the other.
    let curViewCache = viewCache;
    let viewMergeTree;
    if ($30d3a405033775a4$var$pathIsEmpty(path)) viewMergeTree = changedChildren;
    else viewMergeTree = new $30d3a405033775a4$var$ImmutableTree(null).setTree(path, changedChildren);
    const serverNode = viewCache.serverCache.getNode();
    viewMergeTree.children.inorderTraversal((childKey, childTree)=>{
        if (serverNode.hasChild(childKey)) {
            const serverChild = viewCache.serverCache.getNode().getImmediateChild(childKey);
            const newChild = $30d3a405033775a4$var$viewProcessorApplyMerge(viewProcessor, serverChild, childTree);
            curViewCache = $30d3a405033775a4$var$viewProcessorApplyServerOverwrite(viewProcessor, curViewCache, new $30d3a405033775a4$var$Path(childKey), newChild, writesCache, serverCache, filterServerNode, accumulator);
        }
    });
    viewMergeTree.children.inorderTraversal((childKey, childMergeTree)=>{
        const isUnknownDeepMerge = !viewCache.serverCache.isCompleteForChild(childKey) && childMergeTree.value === undefined;
        if (!serverNode.hasChild(childKey) && !isUnknownDeepMerge) {
            const serverChild = viewCache.serverCache.getNode().getImmediateChild(childKey);
            const newChild = $30d3a405033775a4$var$viewProcessorApplyMerge(viewProcessor, serverChild, childMergeTree);
            curViewCache = $30d3a405033775a4$var$viewProcessorApplyServerOverwrite(viewProcessor, curViewCache, new $30d3a405033775a4$var$Path(childKey), newChild, writesCache, serverCache, filterServerNode, accumulator);
        }
    });
    return curViewCache;
}
function $30d3a405033775a4$var$viewProcessorAckUserWrite(viewProcessor, viewCache, ackPath, affectedTree, writesCache, completeCache, accumulator) {
    if ($30d3a405033775a4$var$writeTreeRefShadowingWrite(writesCache, ackPath) != null) return viewCache;
    // Only filter server node if it is currently filtered
    const filterServerNode = viewCache.serverCache.isFiltered();
    // Essentially we'll just get our existing server cache for the affected paths and re-apply it as a server update
    // now that it won't be shadowed.
    const serverCache = viewCache.serverCache;
    if (affectedTree.value != null) {
        // This is an overwrite.
        if ($30d3a405033775a4$var$pathIsEmpty(ackPath) && serverCache.isFullyInitialized() || serverCache.isCompleteForPath(ackPath)) return $30d3a405033775a4$var$viewProcessorApplyServerOverwrite(viewProcessor, viewCache, ackPath, serverCache.getNode().getChild(ackPath), writesCache, completeCache, filterServerNode, accumulator);
        else if ($30d3a405033775a4$var$pathIsEmpty(ackPath)) {
            // This is a goofy edge case where we are acking data at this location but don't have full data.  We
            // should just re-apply whatever we have in our cache as a merge.
            let changedChildren = new $30d3a405033775a4$var$ImmutableTree(null);
            serverCache.getNode().forEachChild($30d3a405033775a4$var$KEY_INDEX, (name, node)=>{
                changedChildren = changedChildren.set(new $30d3a405033775a4$var$Path(name), node);
            });
            return $30d3a405033775a4$var$viewProcessorApplyServerMerge(viewProcessor, viewCache, ackPath, changedChildren, writesCache, completeCache, filterServerNode, accumulator);
        } else return viewCache;
    } else {
        // This is a merge.
        let changedChildren = new $30d3a405033775a4$var$ImmutableTree(null);
        affectedTree.foreach((mergePath, value)=>{
            const serverCachePath = $30d3a405033775a4$var$pathChild(ackPath, mergePath);
            if (serverCache.isCompleteForPath(serverCachePath)) changedChildren = changedChildren.set(mergePath, serverCache.getNode().getChild(serverCachePath));
        });
        return $30d3a405033775a4$var$viewProcessorApplyServerMerge(viewProcessor, viewCache, ackPath, changedChildren, writesCache, completeCache, filterServerNode, accumulator);
    }
}
function $30d3a405033775a4$var$viewProcessorListenComplete(viewProcessor, viewCache, path, writesCache, accumulator) {
    const oldServerNode = viewCache.serverCache;
    const newViewCache = $30d3a405033775a4$var$viewCacheUpdateServerSnap(viewCache, oldServerNode.getNode(), oldServerNode.isFullyInitialized() || $30d3a405033775a4$var$pathIsEmpty(path), oldServerNode.isFiltered());
    return $30d3a405033775a4$var$viewProcessorGenerateEventCacheAfterServerEvent(viewProcessor, newViewCache, path, writesCache, $30d3a405033775a4$var$NO_COMPLETE_CHILD_SOURCE, accumulator);
}
function $30d3a405033775a4$var$viewProcessorRevertUserWrite(viewProcessor, viewCache, path, writesCache, completeServerCache, accumulator) {
    let complete;
    if ($30d3a405033775a4$var$writeTreeRefShadowingWrite(writesCache, path) != null) return viewCache;
    else {
        const source = new $30d3a405033775a4$var$WriteTreeCompleteChildSource(writesCache, viewCache, completeServerCache);
        const oldEventCache = viewCache.eventCache.getNode();
        let newEventCache;
        if ($30d3a405033775a4$var$pathIsEmpty(path) || $30d3a405033775a4$var$pathGetFront(path) === ".priority") {
            let newNode;
            if (viewCache.serverCache.isFullyInitialized()) newNode = $30d3a405033775a4$var$writeTreeRefCalcCompleteEventCache(writesCache, $30d3a405033775a4$var$viewCacheGetCompleteServerSnap(viewCache));
            else {
                const serverChildren = viewCache.serverCache.getNode();
                (0, $f43ebbd33d4c5d93$export$a7a9523472993e97)(serverChildren instanceof $30d3a405033775a4$var$ChildrenNode, "serverChildren would be complete if leaf node");
                newNode = $30d3a405033775a4$var$writeTreeRefCalcCompleteEventChildren(writesCache, serverChildren);
            }
            newNode;
            newEventCache = viewProcessor.filter.updateFullNode(oldEventCache, newNode, accumulator);
        } else {
            const childKey = $30d3a405033775a4$var$pathGetFront(path);
            let newChild = $30d3a405033775a4$var$writeTreeRefCalcCompleteChild(writesCache, childKey, viewCache.serverCache);
            if (newChild == null && viewCache.serverCache.isCompleteForChild(childKey)) newChild = oldEventCache.getImmediateChild(childKey);
            if (newChild != null) newEventCache = viewProcessor.filter.updateChild(oldEventCache, childKey, newChild, $30d3a405033775a4$var$pathPopFront(path), source, accumulator);
            else if (viewCache.eventCache.getNode().hasChild(childKey)) // No complete child available, delete the existing one, if any
            newEventCache = viewProcessor.filter.updateChild(oldEventCache, childKey, $30d3a405033775a4$var$ChildrenNode.EMPTY_NODE, $30d3a405033775a4$var$pathPopFront(path), source, accumulator);
            else newEventCache = oldEventCache;
            if (newEventCache.isEmpty() && viewCache.serverCache.isFullyInitialized()) {
                // We might have reverted all child writes. Maybe the old event was a leaf node
                complete = $30d3a405033775a4$var$writeTreeRefCalcCompleteEventCache(writesCache, $30d3a405033775a4$var$viewCacheGetCompleteServerSnap(viewCache));
                if (complete.isLeafNode()) newEventCache = viewProcessor.filter.updateFullNode(newEventCache, complete, accumulator);
            }
        }
        complete = viewCache.serverCache.isFullyInitialized() || $30d3a405033775a4$var$writeTreeRefShadowingWrite(writesCache, $30d3a405033775a4$var$newEmptyPath()) != null;
        return $30d3a405033775a4$var$viewCacheUpdateEventSnap(viewCache, newEventCache, complete, viewProcessor.filter.filtersNodes());
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A view represents a specific location and query that has 1 or more event registrations.
 *
 * It does several things:
 *  - Maintains the list of event registrations for this location/query.
 *  - Maintains a cache of the data visible for this location/query.
 *  - Applies new operations (via applyOperation), updates the cache, and based on the event
 *    registrations returns the set of events to be raised.
 */ class $30d3a405033775a4$var$View {
    get query() {
        return this.query_;
    }
    constructor(query_, initialViewCache){
        this.query_ = query_;
        this.eventRegistrations_ = [];
        const params = this.query_._queryParams;
        const indexFilter = new $30d3a405033775a4$var$IndexedFilter(params.getIndex());
        const filter = $30d3a405033775a4$var$queryParamsGetNodeFilter(params);
        this.processor_ = $30d3a405033775a4$var$newViewProcessor(filter);
        const initialServerCache = initialViewCache.serverCache;
        const initialEventCache = initialViewCache.eventCache;
        // Don't filter server node with other filter than index, wait for tagged listen
        const serverSnap = indexFilter.updateFullNode($30d3a405033775a4$var$ChildrenNode.EMPTY_NODE, initialServerCache.getNode(), null);
        const eventSnap = filter.updateFullNode($30d3a405033775a4$var$ChildrenNode.EMPTY_NODE, initialEventCache.getNode(), null);
        const newServerCache = new $30d3a405033775a4$var$CacheNode(serverSnap, initialServerCache.isFullyInitialized(), indexFilter.filtersNodes());
        const newEventCache = new $30d3a405033775a4$var$CacheNode(eventSnap, initialEventCache.isFullyInitialized(), filter.filtersNodes());
        this.viewCache_ = $30d3a405033775a4$var$newViewCache(newEventCache, newServerCache);
        this.eventGenerator_ = new $30d3a405033775a4$var$EventGenerator(this.query_);
    }
}
function $30d3a405033775a4$var$viewGetServerCache(view) {
    return view.viewCache_.serverCache.getNode();
}
function $30d3a405033775a4$var$viewGetCompleteNode(view) {
    return $30d3a405033775a4$var$viewCacheGetCompleteEventSnap(view.viewCache_);
}
function $30d3a405033775a4$var$viewGetCompleteServerCache(view, path) {
    const cache = $30d3a405033775a4$var$viewCacheGetCompleteServerSnap(view.viewCache_);
    if (cache) {
        // If this isn't a "loadsAllData" view, then cache isn't actually a complete cache and
        // we need to see if it contains the child we're interested in.
        if (view.query._queryParams.loadsAllData() || !$30d3a405033775a4$var$pathIsEmpty(path) && !cache.getImmediateChild($30d3a405033775a4$var$pathGetFront(path)).isEmpty()) return cache.getChild(path);
    }
    return null;
}
function $30d3a405033775a4$var$viewIsEmpty(view) {
    return view.eventRegistrations_.length === 0;
}
function $30d3a405033775a4$var$viewAddEventRegistration(view, eventRegistration) {
    view.eventRegistrations_.push(eventRegistration);
}
/**
 * @param eventRegistration - If null, remove all callbacks.
 * @param cancelError - If a cancelError is provided, appropriate cancel events will be returned.
 * @returns Cancel events, if cancelError was provided.
 */ function $30d3a405033775a4$var$viewRemoveEventRegistration(view, eventRegistration, cancelError) {
    const cancelEvents = [];
    if (cancelError) {
        (0, $f43ebbd33d4c5d93$export$a7a9523472993e97)(eventRegistration == null, "A cancel should cancel all event registrations.");
        const path = view.query._path;
        view.eventRegistrations_.forEach((registration)=>{
            const maybeEvent = registration.createCancelEvent(cancelError, path);
            if (maybeEvent) cancelEvents.push(maybeEvent);
        });
    }
    if (eventRegistration) {
        let remaining = [];
        for(let i = 0; i < view.eventRegistrations_.length; ++i){
            const existing = view.eventRegistrations_[i];
            if (!existing.matches(eventRegistration)) remaining.push(existing);
            else if (eventRegistration.hasAnyCallback()) {
                // We're removing just this one
                remaining = remaining.concat(view.eventRegistrations_.slice(i + 1));
                break;
            }
        }
        view.eventRegistrations_ = remaining;
    } else view.eventRegistrations_ = [];
    return cancelEvents;
}
/**
 * Applies the given Operation, updates our cache, and returns the appropriate events.
 */ function $30d3a405033775a4$var$viewApplyOperation(view, operation, writesCache, completeServerCache) {
    if (operation.type === $30d3a405033775a4$var$OperationType.MERGE && operation.source.queryId !== null) {
        (0, $f43ebbd33d4c5d93$export$a7a9523472993e97)($30d3a405033775a4$var$viewCacheGetCompleteServerSnap(view.viewCache_), "We should always have a full cache before handling merges");
        (0, $f43ebbd33d4c5d93$export$a7a9523472993e97)($30d3a405033775a4$var$viewCacheGetCompleteEventSnap(view.viewCache_), "Missing event cache, even though we have a server cache");
    }
    const oldViewCache = view.viewCache_;
    const result = $30d3a405033775a4$var$viewProcessorApplyOperation(view.processor_, oldViewCache, operation, writesCache, completeServerCache);
    $30d3a405033775a4$var$viewProcessorAssertIndexed(view.processor_, result.viewCache);
    (0, $f43ebbd33d4c5d93$export$a7a9523472993e97)(result.viewCache.serverCache.isFullyInitialized() || !oldViewCache.serverCache.isFullyInitialized(), "Once a server snap is complete, it should never go back");
    view.viewCache_ = result.viewCache;
    return $30d3a405033775a4$var$viewGenerateEventsForChanges_(view, result.changes, result.viewCache.eventCache.getNode(), null);
}
function $30d3a405033775a4$var$viewGetInitialEvents(view, registration) {
    const eventSnap = view.viewCache_.eventCache;
    const initialChanges = [];
    if (!eventSnap.getNode().isLeafNode()) {
        const eventNode = eventSnap.getNode();
        eventNode.forEachChild($30d3a405033775a4$var$PRIORITY_INDEX, (key, childNode)=>{
            initialChanges.push($30d3a405033775a4$var$changeChildAdded(key, childNode));
        });
    }
    if (eventSnap.isFullyInitialized()) initialChanges.push($30d3a405033775a4$var$changeValue(eventSnap.getNode()));
    return $30d3a405033775a4$var$viewGenerateEventsForChanges_(view, initialChanges, eventSnap.getNode(), registration);
}
function $30d3a405033775a4$var$viewGenerateEventsForChanges_(view, changes, eventCache, eventRegistration) {
    const registrations = eventRegistration ? [
        eventRegistration
    ] : view.eventRegistrations_;
    return $30d3a405033775a4$var$eventGeneratorGenerateEventsForChanges(view.eventGenerator_, changes, eventCache, registrations);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $30d3a405033775a4$var$referenceConstructor$1;
/**
 * SyncPoint represents a single location in a SyncTree with 1 or more event registrations, meaning we need to
 * maintain 1 or more Views at this location to cache server data and raise appropriate events for server changes
 * and user writes (set, transaction, update).
 *
 * It's responsible for:
 *  - Maintaining the set of 1 or more views necessary at this location (a SyncPoint with 0 views should be removed).
 *  - Proxying user / server operations to the views as appropriate (i.e. applyServerOverwrite,
 *    applyUserOverwrite, etc.)
 */ class $30d3a405033775a4$var$SyncPoint {
    constructor(){
        /**
         * The Views being tracked at this location in the tree, stored as a map where the key is a
         * queryId and the value is the View for that query.
         *
         * NOTE: This list will be quite small (usually 1, but perhaps 2 or 3; any more is an odd use case).
         */ this.views = new Map();
    }
}
function $30d3a405033775a4$var$syncPointSetReferenceConstructor(val) {
    (0, $f43ebbd33d4c5d93$export$a7a9523472993e97)(!$30d3a405033775a4$var$referenceConstructor$1, "__referenceConstructor has already been defined");
    $30d3a405033775a4$var$referenceConstructor$1 = val;
}
function $30d3a405033775a4$var$syncPointGetReferenceConstructor() {
    (0, $f43ebbd33d4c5d93$export$a7a9523472993e97)($30d3a405033775a4$var$referenceConstructor$1, "Reference.ts has not been loaded");
    return $30d3a405033775a4$var$referenceConstructor$1;
}
function $30d3a405033775a4$var$syncPointIsEmpty(syncPoint) {
    return syncPoint.views.size === 0;
}
function $30d3a405033775a4$var$syncPointApplyOperation(syncPoint, operation, writesCache, optCompleteServerCache) {
    const queryId = operation.source.queryId;
    if (queryId !== null) {
        const view = syncPoint.views.get(queryId);
        (0, $f43ebbd33d4c5d93$export$a7a9523472993e97)(view != null, "SyncTree gave us an op for an invalid query.");
        return $30d3a405033775a4$var$viewApplyOperation(view, operation, writesCache, optCompleteServerCache);
    } else {
        let events = [];
        for (const view of syncPoint.views.values())events = events.concat($30d3a405033775a4$var$viewApplyOperation(view, operation, writesCache, optCompleteServerCache));
        return events;
    }
}
/**
 * Get a view for the specified query.
 *
 * @param query - The query to return a view for
 * @param writesCache
 * @param serverCache
 * @param serverCacheComplete
 * @returns Events to raise.
 */ function $30d3a405033775a4$var$syncPointGetView(syncPoint, query, writesCache, serverCache, serverCacheComplete) {
    const queryId = query._queryIdentifier;
    const view = syncPoint.views.get(queryId);
    if (!view) {
        // TODO: make writesCache take flag for complete server node
        let eventCache = $30d3a405033775a4$var$writeTreeRefCalcCompleteEventCache(writesCache, serverCacheComplete ? serverCache : null);
        let eventCacheComplete = false;
        if (eventCache) eventCacheComplete = true;
        else if (serverCache instanceof $30d3a405033775a4$var$ChildrenNode) {
            eventCache = $30d3a405033775a4$var$writeTreeRefCalcCompleteEventChildren(writesCache, serverCache);
            eventCacheComplete = false;
        } else {
            eventCache = $30d3a405033775a4$var$ChildrenNode.EMPTY_NODE;
            eventCacheComplete = false;
        }
        const viewCache = $30d3a405033775a4$var$newViewCache(new $30d3a405033775a4$var$CacheNode(eventCache, eventCacheComplete, false), new $30d3a405033775a4$var$CacheNode(serverCache, serverCacheComplete, false));
        return new $30d3a405033775a4$var$View(query, viewCache);
    }
    return view;
}
/**
 * Add an event callback for the specified query.
 *
 * @param query
 * @param eventRegistration
 * @param writesCache
 * @param serverCache - Complete server cache, if we have it.
 * @param serverCacheComplete
 * @returns Events to raise.
 */ function $30d3a405033775a4$var$syncPointAddEventRegistration(syncPoint, query, eventRegistration, writesCache, serverCache, serverCacheComplete) {
    const view = $30d3a405033775a4$var$syncPointGetView(syncPoint, query, writesCache, serverCache, serverCacheComplete);
    if (!syncPoint.views.has(query._queryIdentifier)) syncPoint.views.set(query._queryIdentifier, view);
    // This is guaranteed to exist now, we just created anything that was missing
    $30d3a405033775a4$var$viewAddEventRegistration(view, eventRegistration);
    return $30d3a405033775a4$var$viewGetInitialEvents(view, eventRegistration);
}
/**
 * Remove event callback(s).  Return cancelEvents if a cancelError is specified.
 *
 * If query is the default query, we'll check all views for the specified eventRegistration.
 * If eventRegistration is null, we'll remove all callbacks for the specified view(s).
 *
 * @param eventRegistration - If null, remove all callbacks.
 * @param cancelError - If a cancelError is provided, appropriate cancel events will be returned.
 * @returns removed queries and any cancel events
 */ function $30d3a405033775a4$var$syncPointRemoveEventRegistration(syncPoint, query, eventRegistration, cancelError) {
    const queryId = query._queryIdentifier;
    const removed = [];
    let cancelEvents = [];
    const hadCompleteView = $30d3a405033775a4$var$syncPointHasCompleteView(syncPoint);
    if (queryId === "default") // When you do ref.off(...), we search all views for the registration to remove.
    for (const [viewQueryId, view] of syncPoint.views.entries()){
        cancelEvents = cancelEvents.concat($30d3a405033775a4$var$viewRemoveEventRegistration(view, eventRegistration, cancelError));
        if ($30d3a405033775a4$var$viewIsEmpty(view)) {
            syncPoint.views.delete(viewQueryId);
            // We'll deal with complete views later.
            if (!view.query._queryParams.loadsAllData()) removed.push(view.query);
        }
    }
    else {
        // remove the callback from the specific view.
        const view = syncPoint.views.get(queryId);
        if (view) {
            cancelEvents = cancelEvents.concat($30d3a405033775a4$var$viewRemoveEventRegistration(view, eventRegistration, cancelError));
            if ($30d3a405033775a4$var$viewIsEmpty(view)) {
                syncPoint.views.delete(queryId);
                // We'll deal with complete views later.
                if (!view.query._queryParams.loadsAllData()) removed.push(view.query);
            }
        }
    }
    if (hadCompleteView && !$30d3a405033775a4$var$syncPointHasCompleteView(syncPoint)) // We removed our last complete view.
    removed.push(new ($30d3a405033775a4$var$syncPointGetReferenceConstructor())(query._repo, query._path));
    return {
        removed: removed,
        events: cancelEvents
    };
}
function $30d3a405033775a4$var$syncPointGetQueryViews(syncPoint) {
    const result = [];
    for (const view of syncPoint.views.values())if (!view.query._queryParams.loadsAllData()) result.push(view);
    return result;
}
/**
 * @param path - The path to the desired complete snapshot
 * @returns A complete cache, if it exists
 */ function $30d3a405033775a4$var$syncPointGetCompleteServerCache(syncPoint, path) {
    let serverCache = null;
    for (const view of syncPoint.views.values())serverCache = serverCache || $30d3a405033775a4$var$viewGetCompleteServerCache(view, path);
    return serverCache;
}
function $30d3a405033775a4$var$syncPointViewForQuery(syncPoint, query) {
    const params = query._queryParams;
    if (params.loadsAllData()) return $30d3a405033775a4$var$syncPointGetCompleteView(syncPoint);
    else {
        const queryId = query._queryIdentifier;
        return syncPoint.views.get(queryId);
    }
}
function $30d3a405033775a4$var$syncPointViewExistsForQuery(syncPoint, query) {
    return $30d3a405033775a4$var$syncPointViewForQuery(syncPoint, query) != null;
}
function $30d3a405033775a4$var$syncPointHasCompleteView(syncPoint) {
    return $30d3a405033775a4$var$syncPointGetCompleteView(syncPoint) != null;
}
function $30d3a405033775a4$var$syncPointGetCompleteView(syncPoint) {
    for (const view of syncPoint.views.values()){
        if (view.query._queryParams.loadsAllData()) return view;
    }
    return null;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $30d3a405033775a4$var$referenceConstructor;
function $30d3a405033775a4$var$syncTreeSetReferenceConstructor(val) {
    (0, $f43ebbd33d4c5d93$export$a7a9523472993e97)(!$30d3a405033775a4$var$referenceConstructor, "__referenceConstructor has already been defined");
    $30d3a405033775a4$var$referenceConstructor = val;
}
function $30d3a405033775a4$var$syncTreeGetReferenceConstructor() {
    (0, $f43ebbd33d4c5d93$export$a7a9523472993e97)($30d3a405033775a4$var$referenceConstructor, "Reference.ts has not been loaded");
    return $30d3a405033775a4$var$referenceConstructor;
}
/**
 * Static tracker for next query tag.
 */ let $30d3a405033775a4$var$syncTreeNextQueryTag_ = 1;
/**
 * SyncTree is the central class for managing event callback registration, data caching, views
 * (query processing), and event generation.  There are typically two SyncTree instances for
 * each Repo, one for the normal Firebase data, and one for the .info data.
 *
 * It has a number of responsibilities, including:
 *  - Tracking all user event callbacks (registered via addEventRegistration() and removeEventRegistration()).
 *  - Applying and caching data changes for user set(), transaction(), and update() calls
 *    (applyUserOverwrite(), applyUserMerge()).
 *  - Applying and caching data changes for server data changes (applyServerOverwrite(),
 *    applyServerMerge()).
 *  - Generating user-facing events for server and user changes (all of the apply* methods
 *    return the set of events that need to be raised as a result).
 *  - Maintaining the appropriate set of server listens to ensure we are always subscribed
 *    to the correct set of paths and queries to satisfy the current set of user event
 *    callbacks (listens are started/stopped using the provided listenProvider).
 *
 * NOTE: Although SyncTree tracks event callbacks and calculates events to raise, the actual
 * events are returned to the caller rather than raised synchronously.
 *
 */ class $30d3a405033775a4$var$SyncTree {
    /**
     * @param listenProvider_ - Used by SyncTree to start / stop listening
     *   to server data.
     */ constructor(listenProvider_){
        this.listenProvider_ = listenProvider_;
        /**
         * Tree of SyncPoints.  There's a SyncPoint at any location that has 1 or more views.
         */ this.syncPointTree_ = new $30d3a405033775a4$var$ImmutableTree(null);
        /**
         * A tree of all pending user writes (user-initiated set()'s, transaction()'s, update()'s, etc.).
         */ this.pendingWriteTree_ = $30d3a405033775a4$var$newWriteTree();
        this.tagToQueryMap = new Map();
        this.queryToTagMap = new Map();
    }
}
/**
 * Apply the data changes for a user-generated set() or transaction() call.
 *
 * @returns Events to raise.
 */ function $30d3a405033775a4$var$syncTreeApplyUserOverwrite(syncTree, path, newData, writeId, visible) {
    // Record pending write.
    $30d3a405033775a4$var$writeTreeAddOverwrite(syncTree.pendingWriteTree_, path, newData, writeId, visible);
    if (!visible) return [];
    else return $30d3a405033775a4$var$syncTreeApplyOperationToSyncPoints_(syncTree, new $30d3a405033775a4$var$Overwrite($30d3a405033775a4$var$newOperationSourceUser(), path, newData));
}
/**
 * Apply the data from a user-generated update() call
 *
 * @returns Events to raise.
 */ function $30d3a405033775a4$var$syncTreeApplyUserMerge(syncTree, path, changedChildren, writeId) {
    // Record pending merge.
    $30d3a405033775a4$var$writeTreeAddMerge(syncTree.pendingWriteTree_, path, changedChildren, writeId);
    const changeTree = $30d3a405033775a4$var$ImmutableTree.fromObject(changedChildren);
    return $30d3a405033775a4$var$syncTreeApplyOperationToSyncPoints_(syncTree, new $30d3a405033775a4$var$Merge($30d3a405033775a4$var$newOperationSourceUser(), path, changeTree));
}
/**
 * Acknowledge a pending user write that was previously registered with applyUserOverwrite() or applyUserMerge().
 *
 * @param revert - True if the given write failed and needs to be reverted
 * @returns Events to raise.
 */ function $30d3a405033775a4$var$syncTreeAckUserWrite(syncTree, writeId, revert = false) {
    const write = $30d3a405033775a4$var$writeTreeGetWrite(syncTree.pendingWriteTree_, writeId);
    const needToReevaluate = $30d3a405033775a4$var$writeTreeRemoveWrite(syncTree.pendingWriteTree_, writeId);
    if (!needToReevaluate) return [];
    else {
        let affectedTree = new $30d3a405033775a4$var$ImmutableTree(null);
        if (write.snap != null) // overwrite
        affectedTree = affectedTree.set($30d3a405033775a4$var$newEmptyPath(), true);
        else $30d3a405033775a4$var$each(write.children, (pathString)=>{
            affectedTree = affectedTree.set(new $30d3a405033775a4$var$Path(pathString), true);
        });
        return $30d3a405033775a4$var$syncTreeApplyOperationToSyncPoints_(syncTree, new $30d3a405033775a4$var$AckUserWrite(write.path, affectedTree, revert));
    }
}
/**
 * Apply new server data for the specified path..
 *
 * @returns Events to raise.
 */ function $30d3a405033775a4$var$syncTreeApplyServerOverwrite(syncTree, path, newData) {
    return $30d3a405033775a4$var$syncTreeApplyOperationToSyncPoints_(syncTree, new $30d3a405033775a4$var$Overwrite($30d3a405033775a4$var$newOperationSourceServer(), path, newData));
}
/**
 * Apply new server data to be merged in at the specified path.
 *
 * @returns Events to raise.
 */ function $30d3a405033775a4$var$syncTreeApplyServerMerge(syncTree, path, changedChildren) {
    const changeTree = $30d3a405033775a4$var$ImmutableTree.fromObject(changedChildren);
    return $30d3a405033775a4$var$syncTreeApplyOperationToSyncPoints_(syncTree, new $30d3a405033775a4$var$Merge($30d3a405033775a4$var$newOperationSourceServer(), path, changeTree));
}
/**
 * Apply a listen complete for a query
 *
 * @returns Events to raise.
 */ function $30d3a405033775a4$var$syncTreeApplyListenComplete(syncTree, path) {
    return $30d3a405033775a4$var$syncTreeApplyOperationToSyncPoints_(syncTree, new $30d3a405033775a4$var$ListenComplete($30d3a405033775a4$var$newOperationSourceServer(), path));
}
/**
 * Apply a listen complete for a tagged query
 *
 * @returns Events to raise.
 */ function $30d3a405033775a4$var$syncTreeApplyTaggedListenComplete(syncTree, path, tag) {
    const queryKey = $30d3a405033775a4$var$syncTreeQueryKeyForTag_(syncTree, tag);
    if (queryKey) {
        const r = $30d3a405033775a4$var$syncTreeParseQueryKey_(queryKey);
        const queryPath = r.path, queryId = r.queryId;
        const relativePath = $30d3a405033775a4$var$newRelativePath(queryPath, path);
        const op = new $30d3a405033775a4$var$ListenComplete($30d3a405033775a4$var$newOperationSourceServerTaggedQuery(queryId), relativePath);
        return $30d3a405033775a4$var$syncTreeApplyTaggedOperation_(syncTree, queryPath, op);
    } else // We've already removed the query. No big deal, ignore the update
    return [];
}
/**
 * Remove event callback(s).
 *
 * If query is the default query, we'll check all queries for the specified eventRegistration.
 * If eventRegistration is null, we'll remove all callbacks for the specified query/queries.
 *
 * @param eventRegistration - If null, all callbacks are removed.
 * @param cancelError - If a cancelError is provided, appropriate cancel events will be returned.
 * @returns Cancel events, if cancelError was provided.
 */ function $30d3a405033775a4$var$syncTreeRemoveEventRegistration(syncTree, query, eventRegistration, cancelError) {
    // Find the syncPoint first. Then deal with whether or not it has matching listeners
    const path = query._path;
    const maybeSyncPoint = syncTree.syncPointTree_.get(path);
    let cancelEvents = [];
    // A removal on a default query affects all queries at that location. A removal on an indexed query, even one without
    // other query constraints, does *not* affect all queries at that location. So this check must be for 'default', and
    // not loadsAllData().
    if (maybeSyncPoint && (query._queryIdentifier === "default" || $30d3a405033775a4$var$syncPointViewExistsForQuery(maybeSyncPoint, query))) {
        const removedAndEvents = $30d3a405033775a4$var$syncPointRemoveEventRegistration(maybeSyncPoint, query, eventRegistration, cancelError);
        if ($30d3a405033775a4$var$syncPointIsEmpty(maybeSyncPoint)) syncTree.syncPointTree_ = syncTree.syncPointTree_.remove(path);
        const removed = removedAndEvents.removed;
        cancelEvents = removedAndEvents.events;
        // We may have just removed one of many listeners and can short-circuit this whole process
        // We may also not have removed a default listener, in which case all of the descendant listeners should already be
        // properly set up.
        //
        // Since indexed queries can shadow if they don't have other query constraints, check for loadsAllData(), instead of
        // queryId === 'default'
        const removingDefault = -1 !== removed.findIndex((query)=>{
            return query._queryParams.loadsAllData();
        });
        const covered = syncTree.syncPointTree_.findOnPath(path, (relativePath, parentSyncPoint)=>$30d3a405033775a4$var$syncPointHasCompleteView(parentSyncPoint));
        if (removingDefault && !covered) {
            const subtree = syncTree.syncPointTree_.subtree(path);
            // There are potentially child listeners. Determine what if any listens we need to send before executing the
            // removal
            if (!subtree.isEmpty()) {
                // We need to fold over our subtree and collect the listeners to send
                const newViews = $30d3a405033775a4$var$syncTreeCollectDistinctViewsForSubTree_(subtree);
                // Ok, we've collected all the listens we need. Set them up.
                for(let i = 0; i < newViews.length; ++i){
                    const view = newViews[i], newQuery = view.query;
                    const listener = $30d3a405033775a4$var$syncTreeCreateListenerForView_(syncTree, view);
                    syncTree.listenProvider_.startListening($30d3a405033775a4$var$syncTreeQueryForListening_(newQuery), $30d3a405033775a4$var$syncTreeTagForQuery_(syncTree, newQuery), listener.hashFn, listener.onComplete);
                }
            }
        }
        // If we removed anything and we're not covered by a higher up listen, we need to stop listening on this query
        // The above block has us covered in terms of making sure we're set up on listens lower in the tree.
        // Also, note that if we have a cancelError, it's already been removed at the provider level.
        if (!covered && removed.length > 0 && !cancelError) {
            // If we removed a default, then we weren't listening on any of the other queries here. Just cancel the one
            // default. Otherwise, we need to iterate through and cancel each individual query
            if (removingDefault) {
                // We don't tag default listeners
                const defaultTag = null;
                syncTree.listenProvider_.stopListening($30d3a405033775a4$var$syncTreeQueryForListening_(query), defaultTag);
            } else removed.forEach((queryToRemove)=>{
                const tagToRemove = syncTree.queryToTagMap.get($30d3a405033775a4$var$syncTreeMakeQueryKey_(queryToRemove));
                syncTree.listenProvider_.stopListening($30d3a405033775a4$var$syncTreeQueryForListening_(queryToRemove), tagToRemove);
            });
        }
        // Now, clear all of the tags we're tracking for the removed listens
        $30d3a405033775a4$var$syncTreeRemoveTags_(syncTree, removed);
    }
    return cancelEvents;
}
/**
 * Apply new server data for the specified tagged query.
 *
 * @returns Events to raise.
 */ function $30d3a405033775a4$var$syncTreeApplyTaggedQueryOverwrite(syncTree, path, snap, tag) {
    const queryKey = $30d3a405033775a4$var$syncTreeQueryKeyForTag_(syncTree, tag);
    if (queryKey != null) {
        const r = $30d3a405033775a4$var$syncTreeParseQueryKey_(queryKey);
        const queryPath = r.path, queryId = r.queryId;
        const relativePath = $30d3a405033775a4$var$newRelativePath(queryPath, path);
        const op = new $30d3a405033775a4$var$Overwrite($30d3a405033775a4$var$newOperationSourceServerTaggedQuery(queryId), relativePath, snap);
        return $30d3a405033775a4$var$syncTreeApplyTaggedOperation_(syncTree, queryPath, op);
    } else // Query must have been removed already
    return [];
}
/**
 * Apply server data to be merged in for the specified tagged query.
 *
 * @returns Events to raise.
 */ function $30d3a405033775a4$var$syncTreeApplyTaggedQueryMerge(syncTree, path, changedChildren, tag) {
    const queryKey = $30d3a405033775a4$var$syncTreeQueryKeyForTag_(syncTree, tag);
    if (queryKey) {
        const r = $30d3a405033775a4$var$syncTreeParseQueryKey_(queryKey);
        const queryPath = r.path, queryId = r.queryId;
        const relativePath = $30d3a405033775a4$var$newRelativePath(queryPath, path);
        const changeTree = $30d3a405033775a4$var$ImmutableTree.fromObject(changedChildren);
        const op = new $30d3a405033775a4$var$Merge($30d3a405033775a4$var$newOperationSourceServerTaggedQuery(queryId), relativePath, changeTree);
        return $30d3a405033775a4$var$syncTreeApplyTaggedOperation_(syncTree, queryPath, op);
    } else // We've already removed the query. No big deal, ignore the update
    return [];
}
/**
 * Add an event callback for the specified query.
 *
 * @returns Events to raise.
 */ function $30d3a405033775a4$var$syncTreeAddEventRegistration(syncTree, query, eventRegistration) {
    const path = query._path;
    let serverCache = null;
    let foundAncestorDefaultView = false;
    // Any covering writes will necessarily be at the root, so really all we need to find is the server cache.
    // Consider optimizing this once there's a better understanding of what actual behavior will be.
    syncTree.syncPointTree_.foreachOnPath(path, (pathToSyncPoint, sp)=>{
        const relativePath = $30d3a405033775a4$var$newRelativePath(pathToSyncPoint, path);
        serverCache = serverCache || $30d3a405033775a4$var$syncPointGetCompleteServerCache(sp, relativePath);
        foundAncestorDefaultView = foundAncestorDefaultView || $30d3a405033775a4$var$syncPointHasCompleteView(sp);
    });
    let syncPoint = syncTree.syncPointTree_.get(path);
    if (!syncPoint) {
        syncPoint = new $30d3a405033775a4$var$SyncPoint();
        syncTree.syncPointTree_ = syncTree.syncPointTree_.set(path, syncPoint);
    } else {
        foundAncestorDefaultView = foundAncestorDefaultView || $30d3a405033775a4$var$syncPointHasCompleteView(syncPoint);
        serverCache = serverCache || $30d3a405033775a4$var$syncPointGetCompleteServerCache(syncPoint, $30d3a405033775a4$var$newEmptyPath());
    }
    let serverCacheComplete;
    if (serverCache != null) serverCacheComplete = true;
    else {
        serverCacheComplete = false;
        serverCache = $30d3a405033775a4$var$ChildrenNode.EMPTY_NODE;
        const subtree = syncTree.syncPointTree_.subtree(path);
        subtree.foreachChild((childName, childSyncPoint)=>{
            const completeCache = $30d3a405033775a4$var$syncPointGetCompleteServerCache(childSyncPoint, $30d3a405033775a4$var$newEmptyPath());
            if (completeCache) serverCache = serverCache.updateImmediateChild(childName, completeCache);
        });
    }
    const viewAlreadyExists = $30d3a405033775a4$var$syncPointViewExistsForQuery(syncPoint, query);
    if (!viewAlreadyExists && !query._queryParams.loadsAllData()) {
        // We need to track a tag for this query
        const queryKey = $30d3a405033775a4$var$syncTreeMakeQueryKey_(query);
        (0, $f43ebbd33d4c5d93$export$a7a9523472993e97)(!syncTree.queryToTagMap.has(queryKey), "View does not exist, but we have a tag");
        const tag = $30d3a405033775a4$var$syncTreeGetNextQueryTag_();
        syncTree.queryToTagMap.set(queryKey, tag);
        syncTree.tagToQueryMap.set(tag, queryKey);
    }
    const writesCache = $30d3a405033775a4$var$writeTreeChildWrites(syncTree.pendingWriteTree_, path);
    let events = $30d3a405033775a4$var$syncPointAddEventRegistration(syncPoint, query, eventRegistration, writesCache, serverCache, serverCacheComplete);
    if (!viewAlreadyExists && !foundAncestorDefaultView) {
        const view = $30d3a405033775a4$var$syncPointViewForQuery(syncPoint, query);
        events = events.concat($30d3a405033775a4$var$syncTreeSetupListener_(syncTree, query, view));
    }
    return events;
}
/**
 * Returns a complete cache, if we have one, of the data at a particular path. If the location does not have a
 * listener above it, we will get a false "null". This shouldn't be a problem because transactions will always
 * have a listener above, and atomic operations would correctly show a jitter of <increment value> ->
 *     <incremented total> as the write is applied locally and then acknowledged at the server.
 *
 * Note: this method will *include* hidden writes from transaction with applyLocally set to false.
 *
 * @param path - The path to the data we want
 * @param writeIdsToExclude - A specific set to be excluded
 */ function $30d3a405033775a4$var$syncTreeCalcCompleteEventCache(syncTree, path, writeIdsToExclude) {
    const includeHiddenSets = true;
    const writeTree = syncTree.pendingWriteTree_;
    const serverCache = syncTree.syncPointTree_.findOnPath(path, (pathSoFar, syncPoint)=>{
        const relativePath = $30d3a405033775a4$var$newRelativePath(pathSoFar, path);
        const serverCache = $30d3a405033775a4$var$syncPointGetCompleteServerCache(syncPoint, relativePath);
        if (serverCache) return serverCache;
    });
    return $30d3a405033775a4$var$writeTreeCalcCompleteEventCache(writeTree, path, serverCache, writeIdsToExclude, includeHiddenSets);
}
function $30d3a405033775a4$var$syncTreeGetServerValue(syncTree, query) {
    const path = query._path;
    let serverCache = null;
    // Any covering writes will necessarily be at the root, so really all we need to find is the server cache.
    // Consider optimizing this once there's a better understanding of what actual behavior will be.
    syncTree.syncPointTree_.foreachOnPath(path, (pathToSyncPoint, sp)=>{
        const relativePath = $30d3a405033775a4$var$newRelativePath(pathToSyncPoint, path);
        serverCache = serverCache || $30d3a405033775a4$var$syncPointGetCompleteServerCache(sp, relativePath);
    });
    let syncPoint = syncTree.syncPointTree_.get(path);
    if (!syncPoint) {
        syncPoint = new $30d3a405033775a4$var$SyncPoint();
        syncTree.syncPointTree_ = syncTree.syncPointTree_.set(path, syncPoint);
    } else serverCache = serverCache || $30d3a405033775a4$var$syncPointGetCompleteServerCache(syncPoint, $30d3a405033775a4$var$newEmptyPath());
    const serverCacheComplete = serverCache != null;
    const serverCacheNode = serverCacheComplete ? new $30d3a405033775a4$var$CacheNode(serverCache, true, false) : null;
    const writesCache = $30d3a405033775a4$var$writeTreeChildWrites(syncTree.pendingWriteTree_, query._path);
    const view = $30d3a405033775a4$var$syncPointGetView(syncPoint, query, writesCache, serverCacheComplete ? serverCacheNode.getNode() : $30d3a405033775a4$var$ChildrenNode.EMPTY_NODE, serverCacheComplete);
    return $30d3a405033775a4$var$viewGetCompleteNode(view);
}
/**
 * A helper method that visits all descendant and ancestor SyncPoints, applying the operation.
 *
 * NOTES:
 * - Descendant SyncPoints will be visited first (since we raise events depth-first).
 *
 * - We call applyOperation() on each SyncPoint passing three things:
 *   1. A version of the Operation that has been made relative to the SyncPoint location.
 *   2. A WriteTreeRef of any writes we have cached at the SyncPoint location.
 *   3. A snapshot Node with cached server data, if we have it.
 *
 * - We concatenate all of the events returned by each SyncPoint and return the result.
 */ function $30d3a405033775a4$var$syncTreeApplyOperationToSyncPoints_(syncTree, operation) {
    return $30d3a405033775a4$var$syncTreeApplyOperationHelper_(operation, syncTree.syncPointTree_, /*serverCache=*/ null, $30d3a405033775a4$var$writeTreeChildWrites(syncTree.pendingWriteTree_, $30d3a405033775a4$var$newEmptyPath()));
}
/**
 * Recursive helper for applyOperationToSyncPoints_
 */ function $30d3a405033775a4$var$syncTreeApplyOperationHelper_(operation, syncPointTree, serverCache, writesCache) {
    if ($30d3a405033775a4$var$pathIsEmpty(operation.path)) return $30d3a405033775a4$var$syncTreeApplyOperationDescendantsHelper_(operation, syncPointTree, serverCache, writesCache);
    else {
        const syncPoint = syncPointTree.get($30d3a405033775a4$var$newEmptyPath());
        // If we don't have cached server data, see if we can get it from this SyncPoint.
        if (serverCache == null && syncPoint != null) serverCache = $30d3a405033775a4$var$syncPointGetCompleteServerCache(syncPoint, $30d3a405033775a4$var$newEmptyPath());
        let events = [];
        const childName = $30d3a405033775a4$var$pathGetFront(operation.path);
        const childOperation = operation.operationForChild(childName);
        const childTree = syncPointTree.children.get(childName);
        if (childTree && childOperation) {
            const childServerCache = serverCache ? serverCache.getImmediateChild(childName) : null;
            const childWritesCache = $30d3a405033775a4$var$writeTreeRefChild(writesCache, childName);
            events = events.concat($30d3a405033775a4$var$syncTreeApplyOperationHelper_(childOperation, childTree, childServerCache, childWritesCache));
        }
        if (syncPoint) events = events.concat($30d3a405033775a4$var$syncPointApplyOperation(syncPoint, operation, writesCache, serverCache));
        return events;
    }
}
/**
 * Recursive helper for applyOperationToSyncPoints_
 */ function $30d3a405033775a4$var$syncTreeApplyOperationDescendantsHelper_(operation, syncPointTree, serverCache, writesCache) {
    const syncPoint = syncPointTree.get($30d3a405033775a4$var$newEmptyPath());
    // If we don't have cached server data, see if we can get it from this SyncPoint.
    if (serverCache == null && syncPoint != null) serverCache = $30d3a405033775a4$var$syncPointGetCompleteServerCache(syncPoint, $30d3a405033775a4$var$newEmptyPath());
    let events = [];
    syncPointTree.children.inorderTraversal((childName, childTree)=>{
        const childServerCache = serverCache ? serverCache.getImmediateChild(childName) : null;
        const childWritesCache = $30d3a405033775a4$var$writeTreeRefChild(writesCache, childName);
        const childOperation = operation.operationForChild(childName);
        if (childOperation) events = events.concat($30d3a405033775a4$var$syncTreeApplyOperationDescendantsHelper_(childOperation, childTree, childServerCache, childWritesCache));
    });
    if (syncPoint) events = events.concat($30d3a405033775a4$var$syncPointApplyOperation(syncPoint, operation, writesCache, serverCache));
    return events;
}
function $30d3a405033775a4$var$syncTreeCreateListenerForView_(syncTree, view) {
    const query = view.query;
    const tag = $30d3a405033775a4$var$syncTreeTagForQuery_(syncTree, query);
    return {
        hashFn: ()=>{
            const cache = $30d3a405033775a4$var$viewGetServerCache(view) || $30d3a405033775a4$var$ChildrenNode.EMPTY_NODE;
            return cache.hash();
        },
        onComplete: (status)=>{
            if (status === "ok") {
                if (tag) return $30d3a405033775a4$var$syncTreeApplyTaggedListenComplete(syncTree, query._path, tag);
                else return $30d3a405033775a4$var$syncTreeApplyListenComplete(syncTree, query._path);
            } else {
                // If a listen failed, kill all of the listeners here, not just the one that triggered the error.
                // Note that this may need to be scoped to just this listener if we change permissions on filtered children
                const error = $30d3a405033775a4$var$errorForServerCode(status, query);
                return $30d3a405033775a4$var$syncTreeRemoveEventRegistration(syncTree, query, /*eventRegistration*/ null, error);
            }
        }
    };
}
/**
 * Return the tag associated with the given query.
 */ function $30d3a405033775a4$var$syncTreeTagForQuery_(syncTree, query) {
    const queryKey = $30d3a405033775a4$var$syncTreeMakeQueryKey_(query);
    return syncTree.queryToTagMap.get(queryKey);
}
/**
 * Given a query, computes a "queryKey" suitable for use in our queryToTagMap_.
 */ function $30d3a405033775a4$var$syncTreeMakeQueryKey_(query) {
    return query._path.toString() + "$" + query._queryIdentifier;
}
/**
 * Return the query associated with the given tag, if we have one
 */ function $30d3a405033775a4$var$syncTreeQueryKeyForTag_(syncTree, tag) {
    return syncTree.tagToQueryMap.get(tag);
}
/**
 * Given a queryKey (created by makeQueryKey), parse it back into a path and queryId.
 */ function $30d3a405033775a4$var$syncTreeParseQueryKey_(queryKey) {
    const splitIndex = queryKey.indexOf("$");
    (0, $f43ebbd33d4c5d93$export$a7a9523472993e97)(splitIndex !== -1 && splitIndex < queryKey.length - 1, "Bad queryKey.");
    return {
        queryId: queryKey.substr(splitIndex + 1),
        path: new $30d3a405033775a4$var$Path(queryKey.substr(0, splitIndex))
    };
}
/**
 * A helper method to apply tagged operations
 */ function $30d3a405033775a4$var$syncTreeApplyTaggedOperation_(syncTree, queryPath, operation) {
    const syncPoint = syncTree.syncPointTree_.get(queryPath);
    (0, $f43ebbd33d4c5d93$export$a7a9523472993e97)(syncPoint, "Missing sync point for query tag that we're tracking");
    const writesCache = $30d3a405033775a4$var$writeTreeChildWrites(syncTree.pendingWriteTree_, queryPath);
    return $30d3a405033775a4$var$syncPointApplyOperation(syncPoint, operation, writesCache, null);
}
/**
 * This collapses multiple unfiltered views into a single view, since we only need a single
 * listener for them.
 */ function $30d3a405033775a4$var$syncTreeCollectDistinctViewsForSubTree_(subtree) {
    return subtree.fold((relativePath, maybeChildSyncPoint, childMap)=>{
        if (maybeChildSyncPoint && $30d3a405033775a4$var$syncPointHasCompleteView(maybeChildSyncPoint)) {
            const completeView = $30d3a405033775a4$var$syncPointGetCompleteView(maybeChildSyncPoint);
            return [
                completeView
            ];
        } else {
            // No complete view here, flatten any deeper listens into an array
            let views = [];
            if (maybeChildSyncPoint) views = $30d3a405033775a4$var$syncPointGetQueryViews(maybeChildSyncPoint);
            $30d3a405033775a4$var$each(childMap, (_key, childViews)=>{
                views = views.concat(childViews);
            });
            return views;
        }
    });
}
/**
 * Normalizes a query to a query we send the server for listening
 *
 * @returns The normalized query
 */ function $30d3a405033775a4$var$syncTreeQueryForListening_(query) {
    if (query._queryParams.loadsAllData() && !query._queryParams.isDefault()) // We treat queries that load all data as default queries
    // Cast is necessary because ref() technically returns Firebase which is actually fb.api.Firebase which inherits
    // from Query
    return new ($30d3a405033775a4$var$syncTreeGetReferenceConstructor())(query._repo, query._path);
    else return query;
}
function $30d3a405033775a4$var$syncTreeRemoveTags_(syncTree, queries) {
    for(let j = 0; j < queries.length; ++j){
        const removedQuery = queries[j];
        if (!removedQuery._queryParams.loadsAllData()) {
            // We should have a tag for this
            const removedQueryKey = $30d3a405033775a4$var$syncTreeMakeQueryKey_(removedQuery);
            const removedQueryTag = syncTree.queryToTagMap.get(removedQueryKey);
            syncTree.queryToTagMap.delete(removedQueryKey);
            syncTree.tagToQueryMap.delete(removedQueryTag);
        }
    }
}
/**
 * Static accessor for query tags.
 */ function $30d3a405033775a4$var$syncTreeGetNextQueryTag_() {
    return $30d3a405033775a4$var$syncTreeNextQueryTag_++;
}
/**
 * For a given new listen, manage the de-duplication of outstanding subscriptions.
 *
 * @returns This method can return events to support synchronous data sources
 */ function $30d3a405033775a4$var$syncTreeSetupListener_(syncTree, query, view) {
    const path = query._path;
    const tag = $30d3a405033775a4$var$syncTreeTagForQuery_(syncTree, query);
    const listener = $30d3a405033775a4$var$syncTreeCreateListenerForView_(syncTree, view);
    const events = syncTree.listenProvider_.startListening($30d3a405033775a4$var$syncTreeQueryForListening_(query), tag, listener.hashFn, listener.onComplete);
    const subtree = syncTree.syncPointTree_.subtree(path);
    // The root of this subtree has our query. We're here because we definitely need to send a listen for that, but we
    // may need to shadow other listens as well.
    if (tag) (0, $f43ebbd33d4c5d93$export$a7a9523472993e97)(!$30d3a405033775a4$var$syncPointHasCompleteView(subtree.value), "If we're adding a query, it shouldn't be shadowed");
    else {
        // Shadow everything at or below this location, this is a default listener.
        const queriesToStop = subtree.fold((relativePath, maybeChildSyncPoint, childMap)=>{
            if (!$30d3a405033775a4$var$pathIsEmpty(relativePath) && maybeChildSyncPoint && $30d3a405033775a4$var$syncPointHasCompleteView(maybeChildSyncPoint)) return [
                $30d3a405033775a4$var$syncPointGetCompleteView(maybeChildSyncPoint).query
            ];
            else {
                // No default listener here, flatten any deeper queries into an array
                let queries = [];
                if (maybeChildSyncPoint) queries = queries.concat($30d3a405033775a4$var$syncPointGetQueryViews(maybeChildSyncPoint).map((view)=>view.query));
                $30d3a405033775a4$var$each(childMap, (_key, childQueries)=>{
                    queries = queries.concat(childQueries);
                });
                return queries;
            }
        });
        for(let i = 0; i < queriesToStop.length; ++i){
            const queryToStop = queriesToStop[i];
            syncTree.listenProvider_.stopListening($30d3a405033775a4$var$syncTreeQueryForListening_(queryToStop), $30d3a405033775a4$var$syncTreeTagForQuery_(syncTree, queryToStop));
        }
    }
    return events;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $30d3a405033775a4$var$ExistingValueProvider {
    getImmediateChild(childName) {
        const child = this.node_.getImmediateChild(childName);
        return new $30d3a405033775a4$var$ExistingValueProvider(child);
    }
    node() {
        return this.node_;
    }
    constructor(node_){
        this.node_ = node_;
    }
}
class $30d3a405033775a4$var$DeferredValueProvider {
    getImmediateChild(childName) {
        const childPath = $30d3a405033775a4$var$pathChild(this.path_, childName);
        return new $30d3a405033775a4$var$DeferredValueProvider(this.syncTree_, childPath);
    }
    node() {
        return $30d3a405033775a4$var$syncTreeCalcCompleteEventCache(this.syncTree_, this.path_);
    }
    constructor(syncTree, path){
        this.syncTree_ = syncTree;
        this.path_ = path;
    }
}
/**
 * Generate placeholders for deferred values.
 */ const $30d3a405033775a4$var$generateWithValues = function(values) {
    values = values || {};
    values["timestamp"] = values["timestamp"] || new Date().getTime();
    return values;
};
/**
 * Value to use when firing local events. When writing server values, fire
 * local events with an approximate value, otherwise return value as-is.
 */ const $30d3a405033775a4$var$resolveDeferredLeafValue = function(value, existingVal, serverValues) {
    if (!value || typeof value !== "object") return value;
    (0, $f43ebbd33d4c5d93$export$a7a9523472993e97)(".sv" in value, "Unexpected leaf node or priority contents");
    if (typeof value[".sv"] === "string") return $30d3a405033775a4$var$resolveScalarDeferredValue(value[".sv"], existingVal, serverValues);
    else if (typeof value[".sv"] === "object") return $30d3a405033775a4$var$resolveComplexDeferredValue(value[".sv"], existingVal);
    else (0, $f43ebbd33d4c5d93$export$a7a9523472993e97)(false, "Unexpected server value: " + JSON.stringify(value, null, 2));
};
const $30d3a405033775a4$var$resolveScalarDeferredValue = function(op, existing, serverValues) {
    switch(op){
        case "timestamp":
            return serverValues["timestamp"];
        default:
            (0, $f43ebbd33d4c5d93$export$a7a9523472993e97)(false, "Unexpected server value: " + op);
    }
};
const $30d3a405033775a4$var$resolveComplexDeferredValue = function(op, existing, unused) {
    if (!op.hasOwnProperty("increment")) (0, $f43ebbd33d4c5d93$export$a7a9523472993e97)(false, "Unexpected server value: " + JSON.stringify(op, null, 2));
    const delta = op["increment"];
    if (typeof delta !== "number") (0, $f43ebbd33d4c5d93$export$a7a9523472993e97)(false, "Unexpected increment value: " + delta);
    const existingNode = existing.node();
    (0, $f43ebbd33d4c5d93$export$a7a9523472993e97)(existingNode !== null && typeof existingNode !== "undefined", "Expected ChildrenNode.EMPTY_NODE for nulls");
    // Incrementing a non-number sets the value to the incremented amount
    if (!existingNode.isLeafNode()) return delta;
    const leaf = existingNode;
    const existingVal = leaf.getValue();
    if (typeof existingVal !== "number") return delta;
    // No need to do over/underflow arithmetic here because JS only handles floats under the covers
    return existingVal + delta;
};
/**
 * Recursively replace all deferred values and priorities in the tree with the
 * specified generated replacement values.
 * @param path - path to which write is relative
 * @param node - new data written at path
 * @param syncTree - current data
 */ const $30d3a405033775a4$var$resolveDeferredValueTree = function(path, node, syncTree, serverValues) {
    return $30d3a405033775a4$var$resolveDeferredValue(node, new $30d3a405033775a4$var$DeferredValueProvider(syncTree, path), serverValues);
};
/**
 * Recursively replace all deferred values and priorities in the node with the
 * specified generated replacement values.  If there are no server values in the node,
 * it'll be returned as-is.
 */ const $30d3a405033775a4$var$resolveDeferredValueSnapshot = function(node, existing, serverValues) {
    return $30d3a405033775a4$var$resolveDeferredValue(node, new $30d3a405033775a4$var$ExistingValueProvider(existing), serverValues);
};
function $30d3a405033775a4$var$resolveDeferredValue(node, existingVal, serverValues) {
    const rawPri = node.getPriority().val();
    const priority = $30d3a405033775a4$var$resolveDeferredLeafValue(rawPri, existingVal.getImmediateChild(".priority"), serverValues);
    let newNode;
    if (node.isLeafNode()) {
        const leafNode = node;
        const value = $30d3a405033775a4$var$resolveDeferredLeafValue(leafNode.getValue(), existingVal, serverValues);
        if (value !== leafNode.getValue() || priority !== leafNode.getPriority().val()) return new $30d3a405033775a4$var$LeafNode(value, $30d3a405033775a4$var$nodeFromJSON(priority));
        else return node;
    } else {
        const childrenNode = node;
        newNode = childrenNode;
        if (priority !== childrenNode.getPriority().val()) newNode = newNode.updatePriority(new $30d3a405033775a4$var$LeafNode(priority));
        childrenNode.forEachChild($30d3a405033775a4$var$PRIORITY_INDEX, (childName, childNode)=>{
            const newChildNode = $30d3a405033775a4$var$resolveDeferredValue(childNode, existingVal.getImmediateChild(childName), serverValues);
            if (newChildNode !== childNode) newNode = newNode.updateImmediateChild(childName, newChildNode);
        });
        return newNode;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A light-weight tree, traversable by path.  Nodes can have both values and children.
 * Nodes are not enumerated (by forEachChild) unless they have a value or non-empty
 * children.
 */ class $30d3a405033775a4$var$Tree {
    /**
     * @param name - Optional name of the node.
     * @param parent - Optional parent node.
     * @param node - Optional node to wrap.
     */ constructor(name = "", parent = null, node = {
        children: {},
        childCount: 0
    }){
        this.name = name;
        this.parent = parent;
        this.node = node;
    }
}
/**
 * Returns a sub-Tree for the given path.
 *
 * @param pathObj - Path to look up.
 * @returns Tree for path.
 */ function $30d3a405033775a4$var$treeSubTree(tree, pathObj) {
    // TODO: Require pathObj to be Path?
    let path = pathObj instanceof $30d3a405033775a4$var$Path ? pathObj : new $30d3a405033775a4$var$Path(pathObj);
    let child = tree, next = $30d3a405033775a4$var$pathGetFront(path);
    while(next !== null){
        const childNode = (0, $f43ebbd33d4c5d93$export$e51ae4db7b428f67)(child.node.children, next) || {
            children: {},
            childCount: 0
        };
        child = new $30d3a405033775a4$var$Tree(next, child, childNode);
        path = $30d3a405033775a4$var$pathPopFront(path);
        next = $30d3a405033775a4$var$pathGetFront(path);
    }
    return child;
}
/**
 * Returns the data associated with this tree node.
 *
 * @returns The data or null if no data exists.
 */ function $30d3a405033775a4$var$treeGetValue(tree) {
    return tree.node.value;
}
/**
 * Sets data to this tree node.
 *
 * @param value - Value to set.
 */ function $30d3a405033775a4$var$treeSetValue(tree, value) {
    tree.node.value = value;
    $30d3a405033775a4$var$treeUpdateParents(tree);
}
/**
 * @returns Whether the tree has any children.
 */ function $30d3a405033775a4$var$treeHasChildren(tree) {
    return tree.node.childCount > 0;
}
/**
 * @returns Whethe rthe tree is empty (no value or children).
 */ function $30d3a405033775a4$var$treeIsEmpty(tree) {
    return $30d3a405033775a4$var$treeGetValue(tree) === undefined && !$30d3a405033775a4$var$treeHasChildren(tree);
}
/**
 * Calls action for each child of this tree node.
 *
 * @param action - Action to be called for each child.
 */ function $30d3a405033775a4$var$treeForEachChild(tree, action) {
    $30d3a405033775a4$var$each(tree.node.children, (child, childTree)=>{
        action(new $30d3a405033775a4$var$Tree(child, tree, childTree));
    });
}
/**
 * Does a depth-first traversal of this node's descendants, calling action for each one.
 *
 * @param action - Action to be called for each child.
 * @param includeSelf - Whether to call action on this node as well. Defaults to
 *   false.
 * @param childrenFirst - Whether to call action on children before calling it on
 *   parent.
 */ function $30d3a405033775a4$var$treeForEachDescendant(tree, action, includeSelf, childrenFirst) {
    if (includeSelf && !childrenFirst) action(tree);
    $30d3a405033775a4$var$treeForEachChild(tree, (child)=>{
        $30d3a405033775a4$var$treeForEachDescendant(child, action, true, childrenFirst);
    });
    if (includeSelf && childrenFirst) action(tree);
}
/**
 * Calls action on each ancestor node.
 *
 * @param action - Action to be called on each parent; return
 *   true to abort.
 * @param includeSelf - Whether to call action on this node as well.
 * @returns true if the action callback returned true.
 */ function $30d3a405033775a4$var$treeForEachAncestor(tree, action, includeSelf) {
    let node = includeSelf ? tree : tree.parent;
    while(node !== null){
        if (action(node)) return true;
        node = node.parent;
    }
    return false;
}
/**
 * @returns The path of this tree node, as a Path.
 */ function $30d3a405033775a4$var$treeGetPath(tree) {
    return new $30d3a405033775a4$var$Path(tree.parent === null ? tree.name : $30d3a405033775a4$var$treeGetPath(tree.parent) + "/" + tree.name);
}
/**
 * Adds or removes this child from its parent based on whether it's empty or not.
 */ function $30d3a405033775a4$var$treeUpdateParents(tree) {
    if (tree.parent !== null) $30d3a405033775a4$var$treeUpdateChild(tree.parent, tree.name, tree);
}
/**
 * Adds or removes the passed child to this tree node, depending on whether it's empty.
 *
 * @param childName - The name of the child to update.
 * @param child - The child to update.
 */ function $30d3a405033775a4$var$treeUpdateChild(tree, childName, child) {
    const childEmpty = $30d3a405033775a4$var$treeIsEmpty(child);
    const childExists = (0, $f43ebbd33d4c5d93$export$2344b14b097df817)(tree.node.children, childName);
    if (childEmpty && childExists) {
        delete tree.node.children[childName];
        tree.node.childCount--;
        $30d3a405033775a4$var$treeUpdateParents(tree);
    } else if (!childEmpty && !childExists) {
        tree.node.children[childName] = child.node;
        tree.node.childCount++;
        $30d3a405033775a4$var$treeUpdateParents(tree);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * True for invalid Firebase keys
 */ const $30d3a405033775a4$var$INVALID_KEY_REGEX_ = /[\[\].#$\/\u0000-\u001F\u007F]/;
/**
 * True for invalid Firebase paths.
 * Allows '/' in paths.
 */ const $30d3a405033775a4$var$INVALID_PATH_REGEX_ = /[\[\].#$\u0000-\u001F\u007F]/;
/**
 * Maximum number of characters to allow in leaf value
 */ const $30d3a405033775a4$var$MAX_LEAF_SIZE_ = 10485760;
const $30d3a405033775a4$var$isValidKey = function(key) {
    return typeof key === "string" && key.length !== 0 && !$30d3a405033775a4$var$INVALID_KEY_REGEX_.test(key);
};
const $30d3a405033775a4$var$isValidPathString = function(pathString) {
    return typeof pathString === "string" && pathString.length !== 0 && !$30d3a405033775a4$var$INVALID_PATH_REGEX_.test(pathString);
};
const $30d3a405033775a4$var$isValidRootPathString = function(pathString) {
    if (pathString) // Allow '/.info/' at the beginning.
    pathString = pathString.replace(/^\/*\.info(\/|$)/, "/");
    return $30d3a405033775a4$var$isValidPathString(pathString);
};
const $30d3a405033775a4$var$isValidPriority = function(priority) {
    return priority === null || typeof priority === "string" || typeof priority === "number" && !$30d3a405033775a4$var$isInvalidJSONNumber(priority) || priority && typeof priority === "object" && // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (0, $f43ebbd33d4c5d93$export$2344b14b097df817)(priority, ".sv");
};
/**
 * Pre-validate a datum passed as an argument to Firebase function.
 */ const $30d3a405033775a4$var$validateFirebaseDataArg = function(fnName, value, path, optional) {
    if (optional && value === undefined) return;
    $30d3a405033775a4$var$validateFirebaseData((0, $f43ebbd33d4c5d93$export$adea4917e02d93dc)(fnName, "value"), value, path);
};
/**
 * Validate a data object client-side before sending to server.
 */ const $30d3a405033775a4$var$validateFirebaseData = function(errorPrefix, data, path_) {
    const path = path_ instanceof $30d3a405033775a4$var$Path ? new $30d3a405033775a4$var$ValidationPath(path_, errorPrefix) : path_;
    if (data === undefined) throw new Error(errorPrefix + "contains undefined " + $30d3a405033775a4$var$validationPathToErrorString(path));
    if (typeof data === "function") throw new Error(errorPrefix + "contains a function " + $30d3a405033775a4$var$validationPathToErrorString(path) + " with contents = " + data.toString());
    if ($30d3a405033775a4$var$isInvalidJSONNumber(data)) throw new Error(errorPrefix + "contains " + data.toString() + " " + $30d3a405033775a4$var$validationPathToErrorString(path));
    // Check max leaf size, but try to avoid the utf8 conversion if we can.
    if (typeof data === "string" && data.length > $30d3a405033775a4$var$MAX_LEAF_SIZE_ / 3 && (0, $f43ebbd33d4c5d93$export$9536dc0a75b20bf9)(data) > $30d3a405033775a4$var$MAX_LEAF_SIZE_) throw new Error(errorPrefix + "contains a string greater than " + $30d3a405033775a4$var$MAX_LEAF_SIZE_ + " utf8 bytes " + $30d3a405033775a4$var$validationPathToErrorString(path) + " ('" + data.substring(0, 50) + "...')");
    // TODO = Perf = Consider combining the recursive validation of keys into NodeFromJSON
    // to save extra walking of large objects.
    if (data && typeof data === "object") {
        let hasDotValue = false;
        let hasActualChild = false;
        $30d3a405033775a4$var$each(data, (key, value)=>{
            if (key === ".value") hasDotValue = true;
            else if (key !== ".priority" && key !== ".sv") {
                hasActualChild = true;
                if (!$30d3a405033775a4$var$isValidKey(key)) throw new Error(errorPrefix + " contains an invalid key (" + key + ") " + $30d3a405033775a4$var$validationPathToErrorString(path) + ".  Keys must be non-empty strings " + 'and can\'t contain ".", "#", "$", "/", "[", or "]"');
            }
            $30d3a405033775a4$var$validationPathPush(path, key);
            $30d3a405033775a4$var$validateFirebaseData(errorPrefix, value, path);
            $30d3a405033775a4$var$validationPathPop(path);
        });
        if (hasDotValue && hasActualChild) throw new Error(errorPrefix + ' contains ".value" child ' + $30d3a405033775a4$var$validationPathToErrorString(path) + " in addition to actual children.");
    }
};
/**
 * Pre-validate paths passed in the firebase function.
 */ const $30d3a405033775a4$var$validateFirebaseMergePaths = function(errorPrefix, mergePaths) {
    let i, curPath;
    for(i = 0; i < mergePaths.length; i++){
        curPath = mergePaths[i];
        const keys = $30d3a405033775a4$var$pathSlice(curPath);
        for(let j = 0; j < keys.length; j++){
            if (keys[j] === ".priority" && j === keys.length - 1) ;
            else if (!$30d3a405033775a4$var$isValidKey(keys[j])) throw new Error(errorPrefix + "contains an invalid key (" + keys[j] + ") in path " + curPath.toString() + ". Keys must be non-empty strings " + 'and can\'t contain ".", "#", "$", "/", "[", or "]"');
        }
    }
    // Check that update keys are not descendants of each other.
    // We rely on the property that sorting guarantees that ancestors come
    // right before descendants.
    mergePaths.sort($30d3a405033775a4$var$pathCompare);
    let prevPath = null;
    for(i = 0; i < mergePaths.length; i++){
        curPath = mergePaths[i];
        if (prevPath !== null && $30d3a405033775a4$var$pathContains(prevPath, curPath)) throw new Error(errorPrefix + "contains a path " + prevPath.toString() + " that is ancestor of another path " + curPath.toString());
        prevPath = curPath;
    }
};
/**
 * pre-validate an object passed as an argument to firebase function (
 * must be an object - e.g. for firebase.update()).
 */ const $30d3a405033775a4$var$validateFirebaseMergeDataArg = function(fnName, data, path, optional) {
    if (optional && data === undefined) return;
    const errorPrefix$1 = (0, $f43ebbd33d4c5d93$export$adea4917e02d93dc)(fnName, "values");
    if (!(data && typeof data === "object") || Array.isArray(data)) throw new Error(errorPrefix$1 + " must be an object containing the children to replace.");
    const mergePaths = [];
    $30d3a405033775a4$var$each(data, (key, value)=>{
        const curPath = new $30d3a405033775a4$var$Path(key);
        $30d3a405033775a4$var$validateFirebaseData(errorPrefix$1, value, $30d3a405033775a4$var$pathChild(path, curPath));
        if ($30d3a405033775a4$var$pathGetBack(curPath) === ".priority") {
            if (!$30d3a405033775a4$var$isValidPriority(value)) throw new Error(errorPrefix$1 + "contains an invalid value for '" + curPath.toString() + "', which must be a valid " + "Firebase priority (a string, finite number, server value, or null).");
        }
        mergePaths.push(curPath);
    });
    $30d3a405033775a4$var$validateFirebaseMergePaths(errorPrefix$1, mergePaths);
};
const $30d3a405033775a4$var$validatePriority = function(fnName, priority, optional) {
    if (optional && priority === undefined) return;
    if ($30d3a405033775a4$var$isInvalidJSONNumber(priority)) throw new Error((0, $f43ebbd33d4c5d93$export$adea4917e02d93dc)(fnName, "priority") + "is " + priority.toString() + ", but must be a valid Firebase priority (a string, finite number, " + "server value, or null).");
    // Special case to allow importing data with a .sv.
    if (!$30d3a405033775a4$var$isValidPriority(priority)) throw new Error((0, $f43ebbd33d4c5d93$export$adea4917e02d93dc)(fnName, "priority") + "must be a valid Firebase priority " + "(a string, finite number, server value, or null).");
};
const $30d3a405033775a4$var$validateKey = function(fnName, argumentName, key, optional) {
    if (optional && key === undefined) return;
    if (!$30d3a405033775a4$var$isValidKey(key)) throw new Error((0, $f43ebbd33d4c5d93$export$adea4917e02d93dc)(fnName, argumentName) + 'was an invalid key = "' + key + '".  Firebase keys must be non-empty strings and ' + 'can\'t contain ".", "#", "$", "/", "[", or "]").');
};
/**
 * @internal
 */ const $30d3a405033775a4$export$8637b026ace8abb1 = function(fnName, argumentName, pathString, optional) {
    if (optional && pathString === undefined) return;
    if (!$30d3a405033775a4$var$isValidPathString(pathString)) throw new Error((0, $f43ebbd33d4c5d93$export$adea4917e02d93dc)(fnName, argumentName) + 'was an invalid path = "' + pathString + '". Paths must be non-empty strings and ' + 'can\'t contain ".", "#", "$", "[", or "]"');
};
const $30d3a405033775a4$var$validateRootPathString = function(fnName, argumentName, pathString, optional) {
    if (pathString) // Allow '/.info/' at the beginning.
    pathString = pathString.replace(/^\/*\.info(\/|$)/, "/");
    $30d3a405033775a4$export$8637b026ace8abb1(fnName, argumentName, pathString, optional);
};
/**
 * @internal
 */ const $30d3a405033775a4$export$8d83036122ae444e = function(fnName, path) {
    if ($30d3a405033775a4$var$pathGetFront(path) === ".info") throw new Error(fnName + " failed = Can't modify data under /.info/");
};
const $30d3a405033775a4$var$validateUrl = function(fnName, parsedUrl) {
    // TODO = Validate server better.
    const pathString = parsedUrl.path.toString();
    if (!(typeof parsedUrl.repoInfo.host === "string") || parsedUrl.repoInfo.host.length === 0 || !$30d3a405033775a4$var$isValidKey(parsedUrl.repoInfo.namespace) && parsedUrl.repoInfo.host.split(":")[0] !== "localhost" || pathString.length !== 0 && !$30d3a405033775a4$var$isValidRootPathString(pathString)) throw new Error((0, $f43ebbd33d4c5d93$export$adea4917e02d93dc)(fnName, "url") + "must be a valid firebase URL and " + 'the path can\'t contain ".", "#", "$", "[", or "]".');
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The event queue serves a few purposes:
 * 1. It ensures we maintain event order in the face of event callbacks doing operations that result in more
 *    events being queued.
 * 2. raiseQueuedEvents() handles being called reentrantly nicely.  That is, if in the course of raising events,
 *    raiseQueuedEvents() is called again, the "inner" call will pick up raising events where the "outer" call
 *    left off, ensuring that the events are still raised synchronously and in order.
 * 3. You can use raiseEventsAtPath and raiseEventsForChangedPath to ensure only relevant previously-queued
 *    events are raised synchronously.
 *
 * NOTE: This can all go away if/when we move to async events.
 *
 */ class $30d3a405033775a4$var$EventQueue {
    constructor(){
        this.eventLists_ = [];
        /**
         * Tracks recursion depth of raiseQueuedEvents_, for debugging purposes.
         */ this.recursionDepth_ = 0;
    }
}
/**
 * @param eventDataList - The new events to queue.
 */ function $30d3a405033775a4$var$eventQueueQueueEvents(eventQueue, eventDataList) {
    // We group events by path, storing them in a single EventList, to make it easier to skip over them quickly.
    let currList = null;
    for(let i = 0; i < eventDataList.length; i++){
        const data = eventDataList[i];
        const path = data.getPath();
        if (currList !== null && !$30d3a405033775a4$var$pathEquals(path, currList.path)) {
            eventQueue.eventLists_.push(currList);
            currList = null;
        }
        if (currList === null) currList = {
            events: [],
            path: path
        };
        currList.events.push(data);
    }
    if (currList) eventQueue.eventLists_.push(currList);
}
/**
 * Queues the specified events and synchronously raises all events (including previously queued ones)
 * for the specified path.
 *
 * It is assumed that the new events are all for the specified path.
 *
 * @param path - The path to raise events for.
 * @param eventDataList - The new events to raise.
 */ function $30d3a405033775a4$var$eventQueueRaiseEventsAtPath(eventQueue, path, eventDataList) {
    $30d3a405033775a4$var$eventQueueQueueEvents(eventQueue, eventDataList);
    $30d3a405033775a4$var$eventQueueRaiseQueuedEventsMatchingPredicate(eventQueue, (eventPath)=>$30d3a405033775a4$var$pathEquals(eventPath, path));
}
/**
 * Queues the specified events and synchronously raises all events (including previously queued ones) for
 * locations related to the specified change path (i.e. all ancestors and descendants).
 *
 * It is assumed that the new events are all related (ancestor or descendant) to the specified path.
 *
 * @param changedPath - The path to raise events for.
 * @param eventDataList - The events to raise
 */ function $30d3a405033775a4$var$eventQueueRaiseEventsForChangedPath(eventQueue, changedPath, eventDataList) {
    $30d3a405033775a4$var$eventQueueQueueEvents(eventQueue, eventDataList);
    $30d3a405033775a4$var$eventQueueRaiseQueuedEventsMatchingPredicate(eventQueue, (eventPath)=>$30d3a405033775a4$var$pathContains(eventPath, changedPath) || $30d3a405033775a4$var$pathContains(changedPath, eventPath));
}
function $30d3a405033775a4$var$eventQueueRaiseQueuedEventsMatchingPredicate(eventQueue, predicate) {
    eventQueue.recursionDepth_++;
    let sentAll = true;
    for(let i = 0; i < eventQueue.eventLists_.length; i++){
        const eventList = eventQueue.eventLists_[i];
        if (eventList) {
            const eventPath = eventList.path;
            if (predicate(eventPath)) {
                $30d3a405033775a4$var$eventListRaise(eventQueue.eventLists_[i]);
                eventQueue.eventLists_[i] = null;
            } else sentAll = false;
        }
    }
    if (sentAll) eventQueue.eventLists_ = [];
    eventQueue.recursionDepth_--;
}
/**
 * Iterates through the list and raises each event
 */ function $30d3a405033775a4$var$eventListRaise(eventList) {
    for(let i = 0; i < eventList.events.length; i++){
        const eventData = eventList.events[i];
        if (eventData !== null) {
            eventList.events[i] = null;
            const eventFn = eventData.getEventRunner();
            if ($30d3a405033775a4$var$logger) $30d3a405033775a4$var$log("event: " + eventData.toString());
            $30d3a405033775a4$var$exceptionGuard(eventFn);
        }
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $30d3a405033775a4$var$INTERRUPT_REASON = "repo_interrupt";
/**
 * If a transaction does not succeed after 25 retries, we abort it. Among other
 * things this ensure that if there's ever a bug causing a mismatch between
 * client / server hashes for some data, we won't retry indefinitely.
 */ const $30d3a405033775a4$var$MAX_TRANSACTION_RETRIES = 25;
/**
 * A connection to a single data repository.
 */ class $30d3a405033775a4$var$Repo {
    /**
     * @returns The URL corresponding to the root of this Firebase.
     */ toString() {
        return (this.repoInfo_.secure ? "https://" : "http://") + this.repoInfo_.host;
    }
    constructor(repoInfo_, forceRestClient_, authTokenProvider_, appCheckProvider_){
        this.repoInfo_ = repoInfo_;
        this.forceRestClient_ = forceRestClient_;
        this.authTokenProvider_ = authTokenProvider_;
        this.appCheckProvider_ = appCheckProvider_;
        this.dataUpdateCount = 0;
        this.statsListener_ = null;
        this.eventQueue_ = new $30d3a405033775a4$var$EventQueue();
        this.nextWriteId_ = 1;
        this.interceptServerDataCallback_ = null;
        /** A list of data pieces and paths to be set when this client disconnects. */ this.onDisconnect_ = $30d3a405033775a4$var$newSparseSnapshotTree();
        /** Stores queues of outstanding transactions for Firebase locations. */ this.transactionQueueTree_ = new $30d3a405033775a4$var$Tree();
        // TODO: This should be @private but it's used by test_access.js and internal.js
        this.persistentConnection_ = null;
        // This key is intentionally not updated if RepoInfo is later changed or replaced
        this.key = this.repoInfo_.toURLString();
    }
}
function $30d3a405033775a4$var$repoStart(repo, appId, authOverride) {
    repo.stats_ = $30d3a405033775a4$var$statsManagerGetCollection(repo.repoInfo_);
    if (repo.forceRestClient_ || $30d3a405033775a4$var$beingCrawled()) {
        repo.server_ = new $30d3a405033775a4$var$ReadonlyRestClient(repo.repoInfo_, (pathString, data, isMerge, tag)=>{
            $30d3a405033775a4$var$repoOnDataUpdate(repo, pathString, data, isMerge, tag);
        }, repo.authTokenProvider_, repo.appCheckProvider_);
        // Minor hack: Fire onConnect immediately, since there's no actual connection.
        setTimeout(()=>$30d3a405033775a4$var$repoOnConnectStatus(repo, /* connectStatus= */ true), 0);
    } else {
        // Validate authOverride
        if (typeof authOverride !== "undefined" && authOverride !== null) {
            if (typeof authOverride !== "object") throw new Error("Only objects are supported for option databaseAuthVariableOverride");
            try {
                (0, $f43ebbd33d4c5d93$export$fac44ee5b035f737)(authOverride);
            } catch (e) {
                throw new Error("Invalid authOverride provided: " + e);
            }
        }
        repo.persistentConnection_ = new $30d3a405033775a4$var$PersistentConnection(repo.repoInfo_, appId, (pathString, data, isMerge, tag)=>{
            $30d3a405033775a4$var$repoOnDataUpdate(repo, pathString, data, isMerge, tag);
        }, (connectStatus)=>{
            $30d3a405033775a4$var$repoOnConnectStatus(repo, connectStatus);
        }, (updates)=>{
            $30d3a405033775a4$var$repoOnServerInfoUpdate(repo, updates);
        }, repo.authTokenProvider_, repo.appCheckProvider_, authOverride);
        repo.server_ = repo.persistentConnection_;
    }
    repo.authTokenProvider_.addTokenChangeListener((token)=>{
        repo.server_.refreshAuthToken(token);
    });
    repo.appCheckProvider_.addTokenChangeListener((result)=>{
        repo.server_.refreshAppCheckToken(result.token);
    });
    // In the case of multiple Repos for the same repoInfo (i.e. there are multiple Firebase.Contexts being used),
    // we only want to create one StatsReporter.  As such, we'll report stats over the first Repo created.
    repo.statsReporter_ = $30d3a405033775a4$var$statsManagerGetOrCreateReporter(repo.repoInfo_, ()=>new $30d3a405033775a4$var$StatsReporter(repo.stats_, repo.server_));
    // Used for .info.
    repo.infoData_ = new $30d3a405033775a4$var$SnapshotHolder();
    repo.infoSyncTree_ = new $30d3a405033775a4$var$SyncTree({
        startListening: (query, tag, currentHashFn, onComplete)=>{
            let infoEvents = [];
            const node = repo.infoData_.getNode(query._path);
            // This is possibly a hack, but we have different semantics for .info endpoints. We don't raise null events
            // on initial data...
            if (!node.isEmpty()) {
                infoEvents = $30d3a405033775a4$var$syncTreeApplyServerOverwrite(repo.infoSyncTree_, query._path, node);
                setTimeout(()=>{
                    onComplete("ok");
                }, 0);
            }
            return infoEvents;
        },
        stopListening: ()=>{}
    });
    $30d3a405033775a4$var$repoUpdateInfo(repo, "connected", false);
    repo.serverSyncTree_ = new $30d3a405033775a4$var$SyncTree({
        startListening: (query, tag, currentHashFn, onComplete)=>{
            repo.server_.listen(query, currentHashFn, tag, (status, data)=>{
                const events = onComplete(status, data);
                $30d3a405033775a4$var$eventQueueRaiseEventsForChangedPath(repo.eventQueue_, query._path, events);
            });
            // No synchronous events for network-backed sync trees
            return [];
        },
        stopListening: (query, tag)=>{
            repo.server_.unlisten(query, tag);
        }
    });
}
/**
 * @returns The time in milliseconds, taking the server offset into account if we have one.
 */ function $30d3a405033775a4$var$repoServerTime(repo) {
    const offsetNode = repo.infoData_.getNode(new $30d3a405033775a4$var$Path(".info/serverTimeOffset"));
    const offset = offsetNode.val() || 0;
    return new Date().getTime() + offset;
}
/**
 * Generate ServerValues using some variables from the repo object.
 */ function $30d3a405033775a4$var$repoGenerateServerValues(repo) {
    return $30d3a405033775a4$var$generateWithValues({
        timestamp: $30d3a405033775a4$var$repoServerTime(repo)
    });
}
/**
 * Called by realtime when we get new messages from the server.
 */ function $30d3a405033775a4$var$repoOnDataUpdate(repo, pathString, data, isMerge, tag) {
    // For testing.
    repo.dataUpdateCount++;
    const path = new $30d3a405033775a4$var$Path(pathString);
    data = repo.interceptServerDataCallback_ ? repo.interceptServerDataCallback_(pathString, data) : data;
    let events = [];
    if (tag) {
        if (isMerge) {
            const taggedChildren = (0, $f43ebbd33d4c5d93$export$871de8747c9eaa88)(data, (raw)=>$30d3a405033775a4$var$nodeFromJSON(raw));
            events = $30d3a405033775a4$var$syncTreeApplyTaggedQueryMerge(repo.serverSyncTree_, path, taggedChildren, tag);
        } else {
            const taggedSnap = $30d3a405033775a4$var$nodeFromJSON(data);
            events = $30d3a405033775a4$var$syncTreeApplyTaggedQueryOverwrite(repo.serverSyncTree_, path, taggedSnap, tag);
        }
    } else if (isMerge) {
        const changedChildren = (0, $f43ebbd33d4c5d93$export$871de8747c9eaa88)(data, (raw)=>$30d3a405033775a4$var$nodeFromJSON(raw));
        events = $30d3a405033775a4$var$syncTreeApplyServerMerge(repo.serverSyncTree_, path, changedChildren);
    } else {
        const snap = $30d3a405033775a4$var$nodeFromJSON(data);
        events = $30d3a405033775a4$var$syncTreeApplyServerOverwrite(repo.serverSyncTree_, path, snap);
    }
    let affectedPath = path;
    if (events.length > 0) // Since we have a listener outstanding for each transaction, receiving any events
    // is a proxy for some change having occurred.
    affectedPath = $30d3a405033775a4$var$repoRerunTransactions(repo, path);
    $30d3a405033775a4$var$eventQueueRaiseEventsForChangedPath(repo.eventQueue_, affectedPath, events);
}
function $30d3a405033775a4$var$repoOnConnectStatus(repo, connectStatus) {
    $30d3a405033775a4$var$repoUpdateInfo(repo, "connected", connectStatus);
    if (connectStatus === false) $30d3a405033775a4$var$repoRunOnDisconnectEvents(repo);
}
function $30d3a405033775a4$var$repoOnServerInfoUpdate(repo, updates) {
    $30d3a405033775a4$var$each(updates, (key, value)=>{
        $30d3a405033775a4$var$repoUpdateInfo(repo, key, value);
    });
}
function $30d3a405033775a4$var$repoUpdateInfo(repo, pathString, value) {
    const path = new $30d3a405033775a4$var$Path("/.info/" + pathString);
    const newNode = $30d3a405033775a4$var$nodeFromJSON(value);
    repo.infoData_.updateSnapshot(path, newNode);
    const events = $30d3a405033775a4$var$syncTreeApplyServerOverwrite(repo.infoSyncTree_, path, newNode);
    $30d3a405033775a4$var$eventQueueRaiseEventsForChangedPath(repo.eventQueue_, path, events);
}
function $30d3a405033775a4$var$repoGetNextWriteId(repo) {
    return repo.nextWriteId_++;
}
/**
 * The purpose of `getValue` is to return the latest known value
 * satisfying `query`.
 *
 * This method will first check for in-memory cached values
 * belonging to active listeners. If they are found, such values
 * are considered to be the most up-to-date.
 *
 * If the client is not connected, this method will try to
 * establish a connection and request the value for `query`. If
 * the client is not able to retrieve the query result, it reports
 * an error.
 *
 * @param query - The query to surface a value for.
 */ function $30d3a405033775a4$var$repoGetValue(repo, query) {
    // Only active queries are cached. There is no persisted cache.
    const cached = $30d3a405033775a4$var$syncTreeGetServerValue(repo.serverSyncTree_, query);
    if (cached != null) return Promise.resolve(cached);
    return repo.server_.get(query).then((payload)=>{
        const node = $30d3a405033775a4$var$nodeFromJSON(payload).withIndex(query._queryParams.getIndex());
        const events = $30d3a405033775a4$var$syncTreeApplyServerOverwrite(repo.serverSyncTree_, query._path, node);
        $30d3a405033775a4$var$eventQueueRaiseEventsAtPath(repo.eventQueue_, query._path, events);
        return Promise.resolve(node);
    }, (err)=>{
        $30d3a405033775a4$var$repoLog(repo, "get for query " + (0, $f43ebbd33d4c5d93$export$fac44ee5b035f737)(query) + " failed: " + err);
        return Promise.reject(new Error(err));
    });
}
function $30d3a405033775a4$var$repoSetWithPriority(repo, path, newVal, newPriority, onComplete) {
    $30d3a405033775a4$var$repoLog(repo, "set", {
        path: path.toString(),
        value: newVal,
        priority: newPriority
    });
    // TODO: Optimize this behavior to either (a) store flag to skip resolving where possible and / or
    // (b) store unresolved paths on JSON parse
    const serverValues = $30d3a405033775a4$var$repoGenerateServerValues(repo);
    const newNodeUnresolved = $30d3a405033775a4$var$nodeFromJSON(newVal, newPriority);
    const existing = $30d3a405033775a4$var$syncTreeCalcCompleteEventCache(repo.serverSyncTree_, path);
    const newNode = $30d3a405033775a4$var$resolveDeferredValueSnapshot(newNodeUnresolved, existing, serverValues);
    const writeId = $30d3a405033775a4$var$repoGetNextWriteId(repo);
    const events = $30d3a405033775a4$var$syncTreeApplyUserOverwrite(repo.serverSyncTree_, path, newNode, writeId, true);
    $30d3a405033775a4$var$eventQueueQueueEvents(repo.eventQueue_, events);
    repo.server_.put(path.toString(), newNodeUnresolved.val(/*export=*/ true), (status, errorReason)=>{
        const success = status === "ok";
        if (!success) $30d3a405033775a4$var$warn("set at " + path + " failed: " + status);
        const clearEvents = $30d3a405033775a4$var$syncTreeAckUserWrite(repo.serverSyncTree_, writeId, !success);
        $30d3a405033775a4$var$eventQueueRaiseEventsForChangedPath(repo.eventQueue_, path, clearEvents);
        $30d3a405033775a4$var$repoCallOnCompleteCallback(repo, onComplete, status, errorReason);
    });
    const affectedPath = $30d3a405033775a4$var$repoAbortTransactions(repo, path);
    $30d3a405033775a4$var$repoRerunTransactions(repo, affectedPath);
    // We queued the events above, so just flush the queue here
    $30d3a405033775a4$var$eventQueueRaiseEventsForChangedPath(repo.eventQueue_, affectedPath, []);
}
function $30d3a405033775a4$var$repoUpdate(repo, path, childrenToMerge, onComplete) {
    $30d3a405033775a4$var$repoLog(repo, "update", {
        path: path.toString(),
        value: childrenToMerge
    });
    // Start with our existing data and merge each child into it.
    let empty = true;
    const serverValues = $30d3a405033775a4$var$repoGenerateServerValues(repo);
    const changedChildren = {};
    $30d3a405033775a4$var$each(childrenToMerge, (changedKey, changedValue)=>{
        empty = false;
        changedChildren[changedKey] = $30d3a405033775a4$var$resolveDeferredValueTree($30d3a405033775a4$var$pathChild(path, changedKey), $30d3a405033775a4$var$nodeFromJSON(changedValue), repo.serverSyncTree_, serverValues);
    });
    if (!empty) {
        const writeId = $30d3a405033775a4$var$repoGetNextWriteId(repo);
        const events = $30d3a405033775a4$var$syncTreeApplyUserMerge(repo.serverSyncTree_, path, changedChildren, writeId);
        $30d3a405033775a4$var$eventQueueQueueEvents(repo.eventQueue_, events);
        repo.server_.merge(path.toString(), childrenToMerge, (status, errorReason)=>{
            const success = status === "ok";
            if (!success) $30d3a405033775a4$var$warn("update at " + path + " failed: " + status);
            const clearEvents = $30d3a405033775a4$var$syncTreeAckUserWrite(repo.serverSyncTree_, writeId, !success);
            const affectedPath = clearEvents.length > 0 ? $30d3a405033775a4$var$repoRerunTransactions(repo, path) : path;
            $30d3a405033775a4$var$eventQueueRaiseEventsForChangedPath(repo.eventQueue_, affectedPath, clearEvents);
            $30d3a405033775a4$var$repoCallOnCompleteCallback(repo, onComplete, status, errorReason);
        });
        $30d3a405033775a4$var$each(childrenToMerge, (changedPath)=>{
            const affectedPath = $30d3a405033775a4$var$repoAbortTransactions(repo, $30d3a405033775a4$var$pathChild(path, changedPath));
            $30d3a405033775a4$var$repoRerunTransactions(repo, affectedPath);
        });
        // We queued the events above, so just flush the queue here
        $30d3a405033775a4$var$eventQueueRaiseEventsForChangedPath(repo.eventQueue_, path, []);
    } else {
        $30d3a405033775a4$var$log("update() called with empty data.  Don't do anything.");
        $30d3a405033775a4$var$repoCallOnCompleteCallback(repo, onComplete, "ok", undefined);
    }
}
/**
 * Applies all of the changes stored up in the onDisconnect_ tree.
 */ function $30d3a405033775a4$var$repoRunOnDisconnectEvents(repo) {
    $30d3a405033775a4$var$repoLog(repo, "onDisconnectEvents");
    const serverValues = $30d3a405033775a4$var$repoGenerateServerValues(repo);
    const resolvedOnDisconnectTree = $30d3a405033775a4$var$newSparseSnapshotTree();
    $30d3a405033775a4$var$sparseSnapshotTreeForEachTree(repo.onDisconnect_, $30d3a405033775a4$var$newEmptyPath(), (path, node)=>{
        const resolved = $30d3a405033775a4$var$resolveDeferredValueTree(path, node, repo.serverSyncTree_, serverValues);
        $30d3a405033775a4$var$sparseSnapshotTreeRemember(resolvedOnDisconnectTree, path, resolved);
    });
    let events = [];
    $30d3a405033775a4$var$sparseSnapshotTreeForEachTree(resolvedOnDisconnectTree, $30d3a405033775a4$var$newEmptyPath(), (path, snap)=>{
        events = events.concat($30d3a405033775a4$var$syncTreeApplyServerOverwrite(repo.serverSyncTree_, path, snap));
        const affectedPath = $30d3a405033775a4$var$repoAbortTransactions(repo, path);
        $30d3a405033775a4$var$repoRerunTransactions(repo, affectedPath);
    });
    repo.onDisconnect_ = $30d3a405033775a4$var$newSparseSnapshotTree();
    $30d3a405033775a4$var$eventQueueRaiseEventsForChangedPath(repo.eventQueue_, $30d3a405033775a4$var$newEmptyPath(), events);
}
function $30d3a405033775a4$var$repoOnDisconnectCancel(repo, path, onComplete) {
    repo.server_.onDisconnectCancel(path.toString(), (status, errorReason)=>{
        if (status === "ok") $30d3a405033775a4$var$sparseSnapshotTreeForget(repo.onDisconnect_, path);
        $30d3a405033775a4$var$repoCallOnCompleteCallback(repo, onComplete, status, errorReason);
    });
}
function $30d3a405033775a4$var$repoOnDisconnectSet(repo, path, value, onComplete) {
    const newNode = $30d3a405033775a4$var$nodeFromJSON(value);
    repo.server_.onDisconnectPut(path.toString(), newNode.val(/*export=*/ true), (status, errorReason)=>{
        if (status === "ok") $30d3a405033775a4$var$sparseSnapshotTreeRemember(repo.onDisconnect_, path, newNode);
        $30d3a405033775a4$var$repoCallOnCompleteCallback(repo, onComplete, status, errorReason);
    });
}
function $30d3a405033775a4$var$repoOnDisconnectSetWithPriority(repo, path, value, priority, onComplete) {
    const newNode = $30d3a405033775a4$var$nodeFromJSON(value, priority);
    repo.server_.onDisconnectPut(path.toString(), newNode.val(/*export=*/ true), (status, errorReason)=>{
        if (status === "ok") $30d3a405033775a4$var$sparseSnapshotTreeRemember(repo.onDisconnect_, path, newNode);
        $30d3a405033775a4$var$repoCallOnCompleteCallback(repo, onComplete, status, errorReason);
    });
}
function $30d3a405033775a4$var$repoOnDisconnectUpdate(repo, path, childrenToMerge, onComplete) {
    if ((0, $f43ebbd33d4c5d93$export$dd1bc94b04021eeb)(childrenToMerge)) {
        $30d3a405033775a4$var$log("onDisconnect().update() called with empty data.  Don't do anything.");
        $30d3a405033775a4$var$repoCallOnCompleteCallback(repo, onComplete, "ok", undefined);
        return;
    }
    repo.server_.onDisconnectMerge(path.toString(), childrenToMerge, (status, errorReason)=>{
        if (status === "ok") $30d3a405033775a4$var$each(childrenToMerge, (childName, childNode)=>{
            const newChildNode = $30d3a405033775a4$var$nodeFromJSON(childNode);
            $30d3a405033775a4$var$sparseSnapshotTreeRemember(repo.onDisconnect_, $30d3a405033775a4$var$pathChild(path, childName), newChildNode);
        });
        $30d3a405033775a4$var$repoCallOnCompleteCallback(repo, onComplete, status, errorReason);
    });
}
function $30d3a405033775a4$var$repoAddEventCallbackForQuery(repo, query, eventRegistration) {
    let events;
    if ($30d3a405033775a4$var$pathGetFront(query._path) === ".info") events = $30d3a405033775a4$var$syncTreeAddEventRegistration(repo.infoSyncTree_, query, eventRegistration);
    else events = $30d3a405033775a4$var$syncTreeAddEventRegistration(repo.serverSyncTree_, query, eventRegistration);
    $30d3a405033775a4$var$eventQueueRaiseEventsAtPath(repo.eventQueue_, query._path, events);
}
function $30d3a405033775a4$var$repoRemoveEventCallbackForQuery(repo, query, eventRegistration) {
    // These are guaranteed not to raise events, since we're not passing in a cancelError. However, we can future-proof
    // a little bit by handling the return values anyways.
    let events;
    if ($30d3a405033775a4$var$pathGetFront(query._path) === ".info") events = $30d3a405033775a4$var$syncTreeRemoveEventRegistration(repo.infoSyncTree_, query, eventRegistration);
    else events = $30d3a405033775a4$var$syncTreeRemoveEventRegistration(repo.serverSyncTree_, query, eventRegistration);
    $30d3a405033775a4$var$eventQueueRaiseEventsAtPath(repo.eventQueue_, query._path, events);
}
function $30d3a405033775a4$var$repoInterrupt(repo) {
    if (repo.persistentConnection_) repo.persistentConnection_.interrupt($30d3a405033775a4$var$INTERRUPT_REASON);
}
function $30d3a405033775a4$var$repoResume(repo) {
    if (repo.persistentConnection_) repo.persistentConnection_.resume($30d3a405033775a4$var$INTERRUPT_REASON);
}
function $30d3a405033775a4$var$repoLog(repo, ...varArgs) {
    let prefix = "";
    if (repo.persistentConnection_) prefix = repo.persistentConnection_.id + ":";
    $30d3a405033775a4$var$log(prefix, ...varArgs);
}
function $30d3a405033775a4$var$repoCallOnCompleteCallback(repo, callback, status, errorReason) {
    if (callback) $30d3a405033775a4$var$exceptionGuard(()=>{
        if (status === "ok") callback(null);
        else {
            const code = (status || "error").toUpperCase();
            let message = code;
            if (errorReason) message += ": " + errorReason;
            const error = new Error(message);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            error.code = code;
            callback(error);
        }
    });
}
/**
 * Creates a new transaction, adds it to the transactions we're tracking, and
 * sends it to the server if possible.
 *
 * @param path - Path at which to do transaction.
 * @param transactionUpdate - Update callback.
 * @param onComplete - Completion callback.
 * @param unwatcher - Function that will be called when the transaction no longer
 * need data updates for `path`.
 * @param applyLocally - Whether or not to make intermediate results visible
 */ function $30d3a405033775a4$var$repoStartTransaction(repo, path, transactionUpdate, onComplete, unwatcher, applyLocally) {
    $30d3a405033775a4$var$repoLog(repo, "transaction on " + path);
    // Initialize transaction.
    const transaction = {
        path: path,
        update: transactionUpdate,
        onComplete: onComplete,
        // One of TransactionStatus enums.
        status: null,
        // Used when combining transactions at different locations to figure out
        // which one goes first.
        order: $30d3a405033775a4$var$LUIDGenerator(),
        applyLocally: // Whether to raise local events for this transaction.
        applyLocally,
        // Count of how many times we've retried the transaction.
        retryCount: 0,
        unwatcher: // Function to call to clean up our .on() listener.
        unwatcher,
        // Stores why a transaction was aborted.
        abortReason: null,
        currentWriteId: null,
        currentInputSnapshot: null,
        currentOutputSnapshotRaw: null,
        currentOutputSnapshotResolved: null
    };
    // Run transaction initially.
    const currentState = $30d3a405033775a4$var$repoGetLatestState(repo, path, undefined);
    transaction.currentInputSnapshot = currentState;
    const newVal = transaction.update(currentState.val());
    if (newVal === undefined) {
        // Abort transaction.
        transaction.unwatcher();
        transaction.currentOutputSnapshotRaw = null;
        transaction.currentOutputSnapshotResolved = null;
        if (transaction.onComplete) transaction.onComplete(null, false, transaction.currentInputSnapshot);
    } else {
        $30d3a405033775a4$var$validateFirebaseData("transaction failed: Data returned ", newVal, transaction.path);
        // Mark as run and add to our queue.
        transaction.status = 0 /* RUN */ ;
        const queueNode = $30d3a405033775a4$var$treeSubTree(repo.transactionQueueTree_, path);
        const nodeQueue = $30d3a405033775a4$var$treeGetValue(queueNode) || [];
        nodeQueue.push(transaction);
        $30d3a405033775a4$var$treeSetValue(queueNode, nodeQueue);
        // Update visibleData and raise events
        // Note: We intentionally raise events after updating all of our
        // transaction state, since the user could start new transactions from the
        // event callbacks.
        let priorityForNode;
        if (typeof newVal === "object" && newVal !== null && (0, $f43ebbd33d4c5d93$export$2344b14b097df817)(newVal, ".priority")) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            priorityForNode = (0, $f43ebbd33d4c5d93$export$e51ae4db7b428f67)(newVal, ".priority");
            (0, $f43ebbd33d4c5d93$export$a7a9523472993e97)($30d3a405033775a4$var$isValidPriority(priorityForNode), "Invalid priority returned by transaction. Priority must be a valid string, finite number, server value, or null.");
        } else {
            const currentNode = $30d3a405033775a4$var$syncTreeCalcCompleteEventCache(repo.serverSyncTree_, path) || $30d3a405033775a4$var$ChildrenNode.EMPTY_NODE;
            priorityForNode = currentNode.getPriority().val();
        }
        const serverValues = $30d3a405033775a4$var$repoGenerateServerValues(repo);
        const newNodeUnresolved = $30d3a405033775a4$var$nodeFromJSON(newVal, priorityForNode);
        const newNode = $30d3a405033775a4$var$resolveDeferredValueSnapshot(newNodeUnresolved, currentState, serverValues);
        transaction.currentOutputSnapshotRaw = newNodeUnresolved;
        transaction.currentOutputSnapshotResolved = newNode;
        transaction.currentWriteId = $30d3a405033775a4$var$repoGetNextWriteId(repo);
        const events = $30d3a405033775a4$var$syncTreeApplyUserOverwrite(repo.serverSyncTree_, path, newNode, transaction.currentWriteId, transaction.applyLocally);
        $30d3a405033775a4$var$eventQueueRaiseEventsForChangedPath(repo.eventQueue_, path, events);
        $30d3a405033775a4$var$repoSendReadyTransactions(repo, repo.transactionQueueTree_);
    }
}
/**
 * @param excludeSets - A specific set to exclude
 */ function $30d3a405033775a4$var$repoGetLatestState(repo, path, excludeSets) {
    return $30d3a405033775a4$var$syncTreeCalcCompleteEventCache(repo.serverSyncTree_, path, excludeSets) || $30d3a405033775a4$var$ChildrenNode.EMPTY_NODE;
}
/**
 * Sends any already-run transactions that aren't waiting for outstanding
 * transactions to complete.
 *
 * Externally it's called with no arguments, but it calls itself recursively
 * with a particular transactionQueueTree node to recurse through the tree.
 *
 * @param node - transactionQueueTree node to start at.
 */ function $30d3a405033775a4$var$repoSendReadyTransactions(repo, node = repo.transactionQueueTree_) {
    // Before recursing, make sure any completed transactions are removed.
    if (!node) $30d3a405033775a4$var$repoPruneCompletedTransactionsBelowNode(repo, node);
    if ($30d3a405033775a4$var$treeGetValue(node)) {
        const queue = $30d3a405033775a4$var$repoBuildTransactionQueue(repo, node);
        (0, $f43ebbd33d4c5d93$export$a7a9523472993e97)(queue.length > 0, "Sending zero length transaction queue");
        const allRun = queue.every((transaction)=>transaction.status === 0 /* RUN */ );
        // If they're all run (and not sent), we can send them.  Else, we must wait.
        if (allRun) $30d3a405033775a4$var$repoSendTransactionQueue(repo, $30d3a405033775a4$var$treeGetPath(node), queue);
    } else if ($30d3a405033775a4$var$treeHasChildren(node)) $30d3a405033775a4$var$treeForEachChild(node, (childNode)=>{
        $30d3a405033775a4$var$repoSendReadyTransactions(repo, childNode);
    });
}
/**
 * Given a list of run transactions, send them to the server and then handle
 * the result (success or failure).
 *
 * @param path - The location of the queue.
 * @param queue - Queue of transactions under the specified location.
 */ function $30d3a405033775a4$var$repoSendTransactionQueue(repo, path, queue) {
    // Mark transactions as sent and increment retry count!
    const setsToIgnore = queue.map((txn)=>{
        return txn.currentWriteId;
    });
    const latestState = $30d3a405033775a4$var$repoGetLatestState(repo, path, setsToIgnore);
    let snapToSend = latestState;
    const latestHash = latestState.hash();
    for(let i = 0; i < queue.length; i++){
        const txn = queue[i];
        (0, $f43ebbd33d4c5d93$export$a7a9523472993e97)(txn.status === 0 /* RUN */ , "tryToSendTransactionQueue_: items in queue should all be run.");
        txn.status = 1 /* SENT */ ;
        txn.retryCount++;
        const relativePath = $30d3a405033775a4$var$newRelativePath(path, txn.path);
        // If we've gotten to this point, the output snapshot must be defined.
        snapToSend = snapToSend.updateChild(relativePath /** @type {!Node} */ , txn.currentOutputSnapshotRaw);
    }
    const dataToSend = snapToSend.val(true);
    const pathToSend = path;
    // Send the put.
    repo.server_.put(pathToSend.toString(), dataToSend, (status)=>{
        $30d3a405033775a4$var$repoLog(repo, "transaction put response", {
            path: pathToSend.toString(),
            status: status
        });
        let events = [];
        if (status === "ok") {
            // Queue up the callbacks and fire them after cleaning up all of our
            // transaction state, since the callback could trigger more
            // transactions or sets.
            const callbacks = [];
            for(let i = 0; i < queue.length; i++){
                queue[i].status = 2 /* COMPLETED */ ;
                events = events.concat($30d3a405033775a4$var$syncTreeAckUserWrite(repo.serverSyncTree_, queue[i].currentWriteId));
                if (queue[i].onComplete) // We never unset the output snapshot, and given that this
                // transaction is complete, it should be set
                callbacks.push(()=>queue[i].onComplete(null, true, queue[i].currentOutputSnapshotResolved));
                queue[i].unwatcher();
            }
            // Now remove the completed transactions.
            $30d3a405033775a4$var$repoPruneCompletedTransactionsBelowNode(repo, $30d3a405033775a4$var$treeSubTree(repo.transactionQueueTree_, path));
            // There may be pending transactions that we can now send.
            $30d3a405033775a4$var$repoSendReadyTransactions(repo, repo.transactionQueueTree_);
            $30d3a405033775a4$var$eventQueueRaiseEventsForChangedPath(repo.eventQueue_, path, events);
            // Finally, trigger onComplete callbacks.
            for(let i = 0; i < callbacks.length; i++)$30d3a405033775a4$var$exceptionGuard(callbacks[i]);
        } else {
            // transactions are no longer sent.  Update their status appropriately.
            if (status === "datastale") {
                for(let i = 0; i < queue.length; i++)if (queue[i].status === 3 /* SENT_NEEDS_ABORT */ ) queue[i].status = 4 /* NEEDS_ABORT */ ;
                else queue[i].status = 0 /* RUN */ ;
            } else {
                $30d3a405033775a4$var$warn("transaction at " + pathToSend.toString() + " failed: " + status);
                for(let i = 0; i < queue.length; i++){
                    queue[i].status = 4 /* NEEDS_ABORT */ ;
                    queue[i].abortReason = status;
                }
            }
            $30d3a405033775a4$var$repoRerunTransactions(repo, path);
        }
    }, latestHash);
}
/**
 * Finds all transactions dependent on the data at changedPath and reruns them.
 *
 * Should be called any time cached data changes.
 *
 * Return the highest path that was affected by rerunning transactions. This
 * is the path at which events need to be raised for.
 *
 * @param changedPath - The path in mergedData that changed.
 * @returns The rootmost path that was affected by rerunning transactions.
 */ function $30d3a405033775a4$var$repoRerunTransactions(repo, changedPath) {
    const rootMostTransactionNode = $30d3a405033775a4$var$repoGetAncestorTransactionNode(repo, changedPath);
    const path = $30d3a405033775a4$var$treeGetPath(rootMostTransactionNode);
    const queue = $30d3a405033775a4$var$repoBuildTransactionQueue(repo, rootMostTransactionNode);
    $30d3a405033775a4$var$repoRerunTransactionQueue(repo, queue, path);
    return path;
}
/**
 * Does all the work of rerunning transactions (as well as cleans up aborted
 * transactions and whatnot).
 *
 * @param queue - The queue of transactions to run.
 * @param path - The path the queue is for.
 */ function $30d3a405033775a4$var$repoRerunTransactionQueue(repo, queue, path) {
    if (queue.length === 0) return; // Nothing to do!
    // Queue up the callbacks and fire them after cleaning up all of our
    // transaction state, since the callback could trigger more transactions or
    // sets.
    const callbacks = [];
    let events = [];
    // Ignore all of the sets we're going to re-run.
    const txnsToRerun = queue.filter((q)=>{
        return q.status === 0 /* RUN */ ;
    });
    const setsToIgnore = txnsToRerun.map((q)=>{
        return q.currentWriteId;
    });
    for(let i = 0; i < queue.length; i++){
        const transaction = queue[i];
        const relativePath = $30d3a405033775a4$var$newRelativePath(path, transaction.path);
        let abortTransaction = false, abortReason;
        (0, $f43ebbd33d4c5d93$export$a7a9523472993e97)(relativePath !== null, "rerunTransactionsUnderNode_: relativePath should not be null.");
        if (transaction.status === 4 /* NEEDS_ABORT */ ) {
            abortTransaction = true;
            abortReason = transaction.abortReason;
            events = events.concat($30d3a405033775a4$var$syncTreeAckUserWrite(repo.serverSyncTree_, transaction.currentWriteId, true));
        } else if (transaction.status === 0 /* RUN */ ) {
            if (transaction.retryCount >= $30d3a405033775a4$var$MAX_TRANSACTION_RETRIES) {
                abortTransaction = true;
                abortReason = "maxretry";
                events = events.concat($30d3a405033775a4$var$syncTreeAckUserWrite(repo.serverSyncTree_, transaction.currentWriteId, true));
            } else {
                // This code reruns a transaction
                const currentNode = $30d3a405033775a4$var$repoGetLatestState(repo, transaction.path, setsToIgnore);
                transaction.currentInputSnapshot = currentNode;
                const newData = queue[i].update(currentNode.val());
                if (newData !== undefined) {
                    $30d3a405033775a4$var$validateFirebaseData("transaction failed: Data returned ", newData, transaction.path);
                    let newDataNode = $30d3a405033775a4$var$nodeFromJSON(newData);
                    const hasExplicitPriority = typeof newData === "object" && newData != null && (0, $f43ebbd33d4c5d93$export$2344b14b097df817)(newData, ".priority");
                    if (!hasExplicitPriority) // Keep the old priority if there wasn't a priority explicitly specified.
                    newDataNode = newDataNode.updatePriority(currentNode.getPriority());
                    const oldWriteId = transaction.currentWriteId;
                    const serverValues = $30d3a405033775a4$var$repoGenerateServerValues(repo);
                    const newNodeResolved = $30d3a405033775a4$var$resolveDeferredValueSnapshot(newDataNode, currentNode, serverValues);
                    transaction.currentOutputSnapshotRaw = newDataNode;
                    transaction.currentOutputSnapshotResolved = newNodeResolved;
                    transaction.currentWriteId = $30d3a405033775a4$var$repoGetNextWriteId(repo);
                    // Mutates setsToIgnore in place
                    setsToIgnore.splice(setsToIgnore.indexOf(oldWriteId), 1);
                    events = events.concat($30d3a405033775a4$var$syncTreeApplyUserOverwrite(repo.serverSyncTree_, transaction.path, newNodeResolved, transaction.currentWriteId, transaction.applyLocally));
                    events = events.concat($30d3a405033775a4$var$syncTreeAckUserWrite(repo.serverSyncTree_, oldWriteId, true));
                } else {
                    abortTransaction = true;
                    abortReason = "nodata";
                    events = events.concat($30d3a405033775a4$var$syncTreeAckUserWrite(repo.serverSyncTree_, transaction.currentWriteId, true));
                }
            }
        }
        $30d3a405033775a4$var$eventQueueRaiseEventsForChangedPath(repo.eventQueue_, path, events);
        events = [];
        if (abortTransaction) {
            // Abort.
            queue[i].status = 2 /* COMPLETED */ ;
            // Removing a listener can trigger pruning which can muck with
            // mergedData/visibleData (as it prunes data). So defer the unwatcher
            // until we're done.
            (function(unwatcher) {
                setTimeout(unwatcher, Math.floor(0));
            })(queue[i].unwatcher);
            if (queue[i].onComplete) {
                if (abortReason === "nodata") callbacks.push(()=>queue[i].onComplete(null, false, queue[i].currentInputSnapshot));
                else callbacks.push(()=>queue[i].onComplete(new Error(abortReason), false, null));
            }
        }
    }
    // Clean up completed transactions.
    $30d3a405033775a4$var$repoPruneCompletedTransactionsBelowNode(repo, repo.transactionQueueTree_);
    // Now fire callbacks, now that we're in a good, known state.
    for(let i = 0; i < callbacks.length; i++)$30d3a405033775a4$var$exceptionGuard(callbacks[i]);
    // Try to send the transaction result to the server.
    $30d3a405033775a4$var$repoSendReadyTransactions(repo, repo.transactionQueueTree_);
}
/**
 * Returns the rootmost ancestor node of the specified path that has a pending
 * transaction on it, or just returns the node for the given path if there are
 * no pending transactions on any ancestor.
 *
 * @param path - The location to start at.
 * @returns The rootmost node with a transaction.
 */ function $30d3a405033775a4$var$repoGetAncestorTransactionNode(repo, path) {
    let front;
    // Start at the root and walk deeper into the tree towards path until we
    // find a node with pending transactions.
    let transactionNode = repo.transactionQueueTree_;
    front = $30d3a405033775a4$var$pathGetFront(path);
    while(front !== null && $30d3a405033775a4$var$treeGetValue(transactionNode) === undefined){
        transactionNode = $30d3a405033775a4$var$treeSubTree(transactionNode, front);
        path = $30d3a405033775a4$var$pathPopFront(path);
        front = $30d3a405033775a4$var$pathGetFront(path);
    }
    return transactionNode;
}
/**
 * Builds the queue of all transactions at or below the specified
 * transactionNode.
 *
 * @param transactionNode
 * @returns The generated queue.
 */ function $30d3a405033775a4$var$repoBuildTransactionQueue(repo, transactionNode) {
    // Walk any child transaction queues and aggregate them into a single queue.
    const transactionQueue = [];
    $30d3a405033775a4$var$repoAggregateTransactionQueuesForNode(repo, transactionNode, transactionQueue);
    // Sort them by the order the transactions were created.
    transactionQueue.sort((a, b)=>a.order - b.order);
    return transactionQueue;
}
function $30d3a405033775a4$var$repoAggregateTransactionQueuesForNode(repo, node, queue) {
    const nodeQueue = $30d3a405033775a4$var$treeGetValue(node);
    if (nodeQueue) for(let i = 0; i < nodeQueue.length; i++)queue.push(nodeQueue[i]);
    $30d3a405033775a4$var$treeForEachChild(node, (child)=>{
        $30d3a405033775a4$var$repoAggregateTransactionQueuesForNode(repo, child, queue);
    });
}
/**
 * Remove COMPLETED transactions at or below this node in the transactionQueueTree_.
 */ function $30d3a405033775a4$var$repoPruneCompletedTransactionsBelowNode(repo, node) {
    const queue = $30d3a405033775a4$var$treeGetValue(node);
    if (queue) {
        let to = 0;
        for(let from = 0; from < queue.length; from++)if (queue[from].status !== 2 /* COMPLETED */ ) {
            queue[to] = queue[from];
            to++;
        }
        queue.length = to;
        $30d3a405033775a4$var$treeSetValue(node, queue.length > 0 ? queue : undefined);
    }
    $30d3a405033775a4$var$treeForEachChild(node, (childNode)=>{
        $30d3a405033775a4$var$repoPruneCompletedTransactionsBelowNode(repo, childNode);
    });
}
/**
 * Aborts all transactions on ancestors or descendants of the specified path.
 * Called when doing a set() or update() since we consider them incompatible
 * with transactions.
 *
 * @param path - Path for which we want to abort related transactions.
 */ function $30d3a405033775a4$var$repoAbortTransactions(repo, path) {
    const affectedPath = $30d3a405033775a4$var$treeGetPath($30d3a405033775a4$var$repoGetAncestorTransactionNode(repo, path));
    const transactionNode = $30d3a405033775a4$var$treeSubTree(repo.transactionQueueTree_, path);
    $30d3a405033775a4$var$treeForEachAncestor(transactionNode, (node)=>{
        $30d3a405033775a4$var$repoAbortTransactionsOnNode(repo, node);
    });
    $30d3a405033775a4$var$repoAbortTransactionsOnNode(repo, transactionNode);
    $30d3a405033775a4$var$treeForEachDescendant(transactionNode, (node)=>{
        $30d3a405033775a4$var$repoAbortTransactionsOnNode(repo, node);
    });
    return affectedPath;
}
/**
 * Abort transactions stored in this transaction queue node.
 *
 * @param node - Node to abort transactions for.
 */ function $30d3a405033775a4$var$repoAbortTransactionsOnNode(repo, node) {
    const queue = $30d3a405033775a4$var$treeGetValue(node);
    if (queue) {
        // Queue up the callbacks and fire them after cleaning up all of our
        // transaction state, since the callback could trigger more transactions
        // or sets.
        const callbacks = [];
        // Go through queue.  Any already-sent transactions must be marked for
        // abort, while the unsent ones can be immediately aborted and removed.
        let events = [];
        let lastSent = -1;
        for(let i = 0; i < queue.length; i++){
            if (queue[i].status === 3 /* SENT_NEEDS_ABORT */ ) ;
            else if (queue[i].status === 1 /* SENT */ ) {
                (0, $f43ebbd33d4c5d93$export$a7a9523472993e97)(lastSent === i - 1, "All SENT items should be at beginning of queue.");
                lastSent = i;
                // Mark transaction for abort when it comes back.
                queue[i].status = 3 /* SENT_NEEDS_ABORT */ ;
                queue[i].abortReason = "set";
            } else {
                (0, $f43ebbd33d4c5d93$export$a7a9523472993e97)(queue[i].status === 0 /* RUN */ , "Unexpected transaction status in abort");
                // We can abort it immediately.
                queue[i].unwatcher();
                events = events.concat($30d3a405033775a4$var$syncTreeAckUserWrite(repo.serverSyncTree_, queue[i].currentWriteId, true));
                if (queue[i].onComplete) callbacks.push(queue[i].onComplete.bind(null, new Error("set"), false, null));
            }
        }
        if (lastSent === -1) // We're not waiting for any sent transactions.  We can clear the queue.
        $30d3a405033775a4$var$treeSetValue(node, undefined);
        else // Remove the transactions we aborted.
        queue.length = lastSent + 1;
        // Now fire the callbacks.
        $30d3a405033775a4$var$eventQueueRaiseEventsForChangedPath(repo.eventQueue_, $30d3a405033775a4$var$treeGetPath(node), events);
        for(let i = 0; i < callbacks.length; i++)$30d3a405033775a4$var$exceptionGuard(callbacks[i]);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $30d3a405033775a4$var$decodePath(pathString) {
    let pathStringDecoded = "";
    const pieces = pathString.split("/");
    for(let i = 0; i < pieces.length; i++)if (pieces[i].length > 0) {
        let piece = pieces[i];
        try {
            piece = decodeURIComponent(piece.replace(/\+/g, " "));
        } catch (e) {}
        pathStringDecoded += "/" + piece;
    }
    return pathStringDecoded;
}
/**
 * @returns key value hash
 */ function $30d3a405033775a4$var$decodeQuery(queryString) {
    const results = {};
    if (queryString.charAt(0) === "?") queryString = queryString.substring(1);
    for (const segment of queryString.split("&")){
        if (segment.length === 0) continue;
        const kv = segment.split("=");
        if (kv.length === 2) results[decodeURIComponent(kv[0])] = decodeURIComponent(kv[1]);
        else $30d3a405033775a4$var$warn(`Invalid query segment '${segment}' in query '${queryString}'`);
    }
    return results;
}
const $30d3a405033775a4$var$parseRepoInfo = function(dataURL, nodeAdmin) {
    const parsedUrl = $30d3a405033775a4$var$parseDatabaseURL(dataURL), namespace = parsedUrl.namespace;
    if (parsedUrl.domain === "firebase.com") $30d3a405033775a4$var$fatal(parsedUrl.host + " is no longer supported. " + "Please use <YOUR FIREBASE>.firebaseio.com instead");
    // Catch common error of uninitialized namespace value.
    if ((!namespace || namespace === "undefined") && parsedUrl.domain !== "localhost") $30d3a405033775a4$var$fatal("Cannot parse Firebase url. Please use https://<YOUR FIREBASE>.firebaseio.com");
    if (!parsedUrl.secure) $30d3a405033775a4$var$warnIfPageIsSecure();
    const webSocketOnly = parsedUrl.scheme === "ws" || parsedUrl.scheme === "wss";
    return {
        repoInfo: new $30d3a405033775a4$var$RepoInfo(parsedUrl.host, parsedUrl.secure, namespace, webSocketOnly, nodeAdmin, /*persistenceKey=*/ "", /*includeNamespaceInQueryParams=*/ namespace !== parsedUrl.subdomain),
        path: new $30d3a405033775a4$var$Path(parsedUrl.pathString)
    };
};
const $30d3a405033775a4$var$parseDatabaseURL = function(dataURL) {
    // Default to empty strings in the event of a malformed string.
    let host = "", domain = "", subdomain = "", pathString = "", namespace = "";
    // Always default to SSL, unless otherwise specified.
    let secure = true, scheme = "https", port = 443;
    // Don't do any validation here. The caller is responsible for validating the result of parsing.
    if (typeof dataURL === "string") {
        // Parse scheme.
        let colonInd = dataURL.indexOf("//");
        if (colonInd >= 0) {
            scheme = dataURL.substring(0, colonInd - 1);
            dataURL = dataURL.substring(colonInd + 2);
        }
        // Parse host, path, and query string.
        let slashInd = dataURL.indexOf("/");
        if (slashInd === -1) slashInd = dataURL.length;
        let questionMarkInd = dataURL.indexOf("?");
        if (questionMarkInd === -1) questionMarkInd = dataURL.length;
        host = dataURL.substring(0, Math.min(slashInd, questionMarkInd));
        if (slashInd < questionMarkInd) // For pathString, questionMarkInd will always come after slashInd
        pathString = $30d3a405033775a4$var$decodePath(dataURL.substring(slashInd, questionMarkInd));
        const queryParams = $30d3a405033775a4$var$decodeQuery(dataURL.substring(Math.min(dataURL.length, questionMarkInd)));
        // If we have a port, use scheme for determining if it's secure.
        colonInd = host.indexOf(":");
        if (colonInd >= 0) {
            secure = scheme === "https" || scheme === "wss";
            port = parseInt(host.substring(colonInd + 1), 10);
        } else colonInd = host.length;
        const hostWithoutPort = host.slice(0, colonInd);
        if (hostWithoutPort.toLowerCase() === "localhost") domain = "localhost";
        else if (hostWithoutPort.split(".").length <= 2) domain = hostWithoutPort;
        else {
            // Interpret the subdomain of a 3 or more component URL as the namespace name.
            const dotInd = host.indexOf(".");
            subdomain = host.substring(0, dotInd).toLowerCase();
            domain = host.substring(dotInd + 1);
            // Normalize namespaces to lowercase to share storage / connection.
            namespace = subdomain;
        }
        // Always treat the value of the `ns` as the namespace name if it is present.
        if ("ns" in queryParams) namespace = queryParams["ns"];
    }
    return {
        host: host,
        port: port,
        domain: domain,
        subdomain: subdomain,
        secure: secure,
        scheme: scheme,
        pathString: pathString,
        namespace: namespace
    };
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Encapsulates the data needed to raise an event
 */ class $30d3a405033775a4$var$DataEvent {
    getPath() {
        const ref = this.snapshot.ref;
        if (this.eventType === "value") return ref._path;
        else return ref.parent._path;
    }
    getEventType() {
        return this.eventType;
    }
    getEventRunner() {
        return this.eventRegistration.getEventRunner(this);
    }
    toString() {
        return this.getPath().toString() + ":" + this.eventType + ":" + (0, $f43ebbd33d4c5d93$export$fac44ee5b035f737)(this.snapshot.exportVal());
    }
    /**
     * @param eventType - One of: value, child_added, child_changed, child_moved, child_removed
     * @param eventRegistration - The function to call to with the event data. User provided
     * @param snapshot - The data backing the event
     * @param prevName - Optional, the name of the previous child for child_* events.
     */ constructor(eventType, eventRegistration, snapshot, prevName){
        this.eventType = eventType;
        this.eventRegistration = eventRegistration;
        this.snapshot = snapshot;
        this.prevName = prevName;
    }
}
class $30d3a405033775a4$var$CancelEvent {
    getPath() {
        return this.path;
    }
    getEventType() {
        return "cancel";
    }
    getEventRunner() {
        return this.eventRegistration.getEventRunner(this);
    }
    toString() {
        return this.path.toString() + ":cancel";
    }
    constructor(eventRegistration, error, path){
        this.eventRegistration = eventRegistration;
        this.error = error;
        this.path = path;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A wrapper class that converts events from the database@exp SDK to the legacy
 * Database SDK. Events are not converted directly as event registration relies
 * on reference comparison of the original user callback (see `matches()`) and
 * relies on equality of the legacy SDK's `context` object.
 */ class $30d3a405033775a4$var$CallbackContext {
    onValue(expDataSnapshot, previousChildName) {
        this.snapshotCallback.call(null, expDataSnapshot, previousChildName);
    }
    onCancel(error) {
        (0, $f43ebbd33d4c5d93$export$a7a9523472993e97)(this.hasCancelCallback, "Raising a cancel event on a listener with no cancel callback");
        return this.cancelCallback.call(null, error);
    }
    get hasCancelCallback() {
        return !!this.cancelCallback;
    }
    matches(other) {
        return this.snapshotCallback === other.snapshotCallback || this.snapshotCallback.userCallback !== undefined && this.snapshotCallback.userCallback === other.snapshotCallback.userCallback && this.snapshotCallback.context === other.snapshotCallback.context;
    }
    constructor(snapshotCallback, cancelCallback){
        this.snapshotCallback = snapshotCallback;
        this.cancelCallback = cancelCallback;
    }
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The `onDisconnect` class allows you to write or clear data when your client
 * disconnects from the Database server. These updates occur whether your
 * client disconnects cleanly or not, so you can rely on them to clean up data
 * even if a connection is dropped or a client crashes.
 *
 * The `onDisconnect` class is most commonly used to manage presence in
 * applications where it is useful to detect how many clients are connected and
 * when other clients disconnect. See
 * {@link https://firebase.google.com/docs/database/web/offline-capabilities | Enabling Offline Capabilities in JavaScript}
 * for more information.
 *
 * To avoid problems when a connection is dropped before the requests can be
 * transferred to the Database server, these functions should be called before
 * writing any data.
 *
 * Note that `onDisconnect` operations are only triggered once. If you want an
 * operation to occur each time a disconnect occurs, you'll need to re-establish
 * the `onDisconnect` operations each time you reconnect.
 */ class $30d3a405033775a4$export$95b7818b4ee6c2af {
    /**
     * Cancels all previously queued `onDisconnect()` set or update events for this
     * location and all children.
     *
     * If a write has been queued for this location via a `set()` or `update()` at a
     * parent location, the write at this location will be canceled, though writes
     * to sibling locations will still occur.
     *
     * @returns Resolves when synchronization to the server is complete.
     */ cancel() {
        const deferred = new (0, $f43ebbd33d4c5d93$export$85f6557964517f1a)();
        $30d3a405033775a4$var$repoOnDisconnectCancel(this._repo, this._path, deferred.wrapCallback(()=>{}));
        return deferred.promise;
    }
    /**
     * Ensures the data at this location is deleted when the client is disconnected
     * (due to closing the browser, navigating to a new page, or network issues).
     *
     * @returns Resolves when synchronization to the server is complete.
     */ remove() {
        $30d3a405033775a4$export$8d83036122ae444e("OnDisconnect.remove", this._path);
        const deferred = new (0, $f43ebbd33d4c5d93$export$85f6557964517f1a)();
        $30d3a405033775a4$var$repoOnDisconnectSet(this._repo, this._path, null, deferred.wrapCallback(()=>{}));
        return deferred.promise;
    }
    /**
     * Ensures the data at this location is set to the specified value when the
     * client is disconnected (due to closing the browser, navigating to a new page,
     * or network issues).
     *
     * `set()` is especially useful for implementing "presence" systems, where a
     * value should be changed or cleared when a user disconnects so that they
     * appear "offline" to other users. See
     * {@link https://firebase.google.com/docs/database/web/offline-capabilities | Enabling Offline Capabilities in JavaScript}
     * for more information.
     *
     * Note that `onDisconnect` operations are only triggered once. If you want an
     * operation to occur each time a disconnect occurs, you'll need to re-establish
     * the `onDisconnect` operations each time.
     *
     * @param value - The value to be written to this location on disconnect (can
     * be an object, array, string, number, boolean, or null).
     * @returns Resolves when synchronization to the Database is complete.
     */ set(value) {
        $30d3a405033775a4$export$8d83036122ae444e("OnDisconnect.set", this._path);
        $30d3a405033775a4$var$validateFirebaseDataArg("OnDisconnect.set", value, this._path, false);
        const deferred = new (0, $f43ebbd33d4c5d93$export$85f6557964517f1a)();
        $30d3a405033775a4$var$repoOnDisconnectSet(this._repo, this._path, value, deferred.wrapCallback(()=>{}));
        return deferred.promise;
    }
    /**
     * Ensures the data at this location is set to the specified value and priority
     * when the client is disconnected (due to closing the browser, navigating to a
     * new page, or network issues).
     *
     * @param value - The value to be written to this location on disconnect (can
     * be an object, array, string, number, boolean, or null).
     * @param priority - The priority to be written (string, number, or null).
     * @returns Resolves when synchronization to the Database is complete.
     */ setWithPriority(value, priority) {
        $30d3a405033775a4$export$8d83036122ae444e("OnDisconnect.setWithPriority", this._path);
        $30d3a405033775a4$var$validateFirebaseDataArg("OnDisconnect.setWithPriority", value, this._path, false);
        $30d3a405033775a4$var$validatePriority("OnDisconnect.setWithPriority", priority, false);
        const deferred = new (0, $f43ebbd33d4c5d93$export$85f6557964517f1a)();
        $30d3a405033775a4$var$repoOnDisconnectSetWithPriority(this._repo, this._path, value, priority, deferred.wrapCallback(()=>{}));
        return deferred.promise;
    }
    /**
     * Writes multiple values at this location when the client is disconnected (due
     * to closing the browser, navigating to a new page, or network issues).
     *
     * The `values` argument contains multiple property-value pairs that will be
     * written to the Database together. Each child property can either be a simple
     * property (for example, "name") or a relative path (for example, "name/first")
     * from the current location to the data to update.
     *
     * As opposed to the `set()` method, `update()` can be use to selectively update
     * only the referenced properties at the current location (instead of replacing
     * all the child properties at the current location).
     *
     * @param values - Object containing multiple values.
     * @returns Resolves when synchronization to the Database is complete.
     */ update(values) {
        $30d3a405033775a4$export$8d83036122ae444e("OnDisconnect.update", this._path);
        $30d3a405033775a4$var$validateFirebaseMergeDataArg("OnDisconnect.update", values, this._path, false);
        const deferred = new (0, $f43ebbd33d4c5d93$export$85f6557964517f1a)();
        $30d3a405033775a4$var$repoOnDisconnectUpdate(this._repo, this._path, values, deferred.wrapCallback(()=>{}));
        return deferred.promise;
    }
    /** @hideconstructor */ constructor(_repo, _path){
        this._repo = _repo;
        this._path = _path;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @internal
 */ class $30d3a405033775a4$export$e79c8d837d2220a8 {
    get key() {
        if ($30d3a405033775a4$var$pathIsEmpty(this._path)) return null;
        else return $30d3a405033775a4$var$pathGetBack(this._path);
    }
    get ref() {
        return new $30d3a405033775a4$export$35c3a5e7c9d1033c(this._repo, this._path);
    }
    get _queryIdentifier() {
        const obj = $30d3a405033775a4$var$queryParamsGetQueryObject(this._queryParams);
        const id = $30d3a405033775a4$var$ObjectToUniqueKey(obj);
        return id === "{}" ? "default" : id;
    }
    /**
     * An object representation of the query parameters used by this Query.
     */ get _queryObject() {
        return $30d3a405033775a4$var$queryParamsGetQueryObject(this._queryParams);
    }
    isEqual(other) {
        other = (0, $f43ebbd33d4c5d93$export$4befe9b5fa509a1b)(other);
        if (!(other instanceof $30d3a405033775a4$export$e79c8d837d2220a8)) return false;
        const sameRepo = this._repo === other._repo;
        const samePath = $30d3a405033775a4$var$pathEquals(this._path, other._path);
        const sameQueryIdentifier = this._queryIdentifier === other._queryIdentifier;
        return sameRepo && samePath && sameQueryIdentifier;
    }
    toJSON() {
        return this.toString();
    }
    toString() {
        return this._repo.toString() + $30d3a405033775a4$var$pathToUrlEncodedString(this._path);
    }
    /**
     * @hideconstructor
     */ constructor(_repo, _path, _queryParams, _orderByCalled){
        this._repo = _repo;
        this._path = _path;
        this._queryParams = _queryParams;
        this._orderByCalled = _orderByCalled;
    }
}
/**
 * Validates that no other order by call has been made
 */ function $30d3a405033775a4$var$validateNoPreviousOrderByCall(query, fnName) {
    if (query._orderByCalled === true) throw new Error(fnName + ": You can't combine multiple orderBy calls.");
}
/**
 * Validates start/end values for queries.
 */ function $30d3a405033775a4$var$validateQueryEndpoints(params) {
    let startNode = null;
    let endNode = null;
    if (params.hasStart()) startNode = params.getIndexStartValue();
    if (params.hasEnd()) endNode = params.getIndexEndValue();
    if (params.getIndex() === $30d3a405033775a4$var$KEY_INDEX) {
        const tooManyArgsError = "Query: When ordering by key, you may only pass one argument to startAt(), endAt(), or equalTo().";
        const wrongArgTypeError = "Query: When ordering by key, the argument passed to startAt(), startAfter(), endAt(), endBefore(), or equalTo() must be a string.";
        if (params.hasStart()) {
            const startName = params.getIndexStartName();
            if (startName !== $30d3a405033775a4$var$MIN_NAME) throw new Error(tooManyArgsError);
            else if (typeof startNode !== "string") throw new Error(wrongArgTypeError);
        }
        if (params.hasEnd()) {
            const endName = params.getIndexEndName();
            if (endName !== $30d3a405033775a4$var$MAX_NAME) throw new Error(tooManyArgsError);
            else if (typeof endNode !== "string") throw new Error(wrongArgTypeError);
        }
    } else if (params.getIndex() === $30d3a405033775a4$var$PRIORITY_INDEX) {
        if (startNode != null && !$30d3a405033775a4$var$isValidPriority(startNode) || endNode != null && !$30d3a405033775a4$var$isValidPriority(endNode)) throw new Error("Query: When ordering by priority, the first argument passed to startAt(), startAfter() endAt(), endBefore(), or equalTo() must be a valid priority value (null, a number, or a string).");
    } else {
        (0, $f43ebbd33d4c5d93$export$a7a9523472993e97)(params.getIndex() instanceof $30d3a405033775a4$var$PathIndex || params.getIndex() === $30d3a405033775a4$var$VALUE_INDEX, "unknown index type.");
        if (startNode != null && typeof startNode === "object" || endNode != null && typeof endNode === "object") throw new Error("Query: First argument passed to startAt(), startAfter(), endAt(), endBefore(), or equalTo() cannot be an object.");
    }
}
/**
 * Validates that limit* has been called with the correct combination of parameters
 */ function $30d3a405033775a4$var$validateLimit(params) {
    if (params.hasStart() && params.hasEnd() && params.hasLimit() && !params.hasAnchoredLimit()) throw new Error("Query: Can't combine startAt(), startAfter(), endAt(), endBefore(), and limit(). Use limitToFirst() or limitToLast() instead.");
}
/**
 * @internal
 */ class $30d3a405033775a4$export$35c3a5e7c9d1033c extends $30d3a405033775a4$export$e79c8d837d2220a8 {
    get parent() {
        const parentPath = $30d3a405033775a4$var$pathParent(this._path);
        return parentPath === null ? null : new $30d3a405033775a4$export$35c3a5e7c9d1033c(this._repo, parentPath);
    }
    get root() {
        let ref = this;
        while(ref.parent !== null)ref = ref.parent;
        return ref;
    }
    /** @hideconstructor */ constructor(repo, path){
        super(repo, path, new $30d3a405033775a4$export$7ba287e361c94330(), false);
    }
}
/**
 * A `DataSnapshot` contains data from a Database location.
 *
 * Any time you read data from the Database, you receive the data as a
 * `DataSnapshot`. A `DataSnapshot` is passed to the event callbacks you attach
 * with `on()` or `once()`. You can extract the contents of the snapshot as a
 * JavaScript object by calling the `val()` method. Alternatively, you can
 * traverse into the snapshot by calling `child()` to return child snapshots
 * (which you could then call `val()` on).
 *
 * A `DataSnapshot` is an efficiently generated, immutable copy of the data at
 * a Database location. It cannot be modified and will never change (to modify
 * data, you always call the `set()` method on a `Reference` directly).
 */ class $30d3a405033775a4$export$80b98bcbc246c942 {
    /**
     * Gets the priority value of the data in this `DataSnapshot`.
     *
     * Applications need not use priority but can order collections by
     * ordinary properties (see
     * {@link https://firebase.google.com/docs/database/web/lists-of-data#sorting_and_filtering_data |Sorting and filtering data}
     * ).
     */ get priority() {
        // typecast here because we never return deferred values or internal priorities (MAX_PRIORITY)
        return this._node.getPriority().val();
    }
    /**
     * The key (last part of the path) of the location of this `DataSnapshot`.
     *
     * The last token in a Database location is considered its key. For example,
     * "ada" is the key for the /users/ada/ node. Accessing the key on any
     * `DataSnapshot` will return the key for the location that generated it.
     * However, accessing the key on the root URL of a Database will return
     * `null`.
     */ get key() {
        return this.ref.key;
    }
    /** Returns the number of child properties of this `DataSnapshot`. */ get size() {
        return this._node.numChildren();
    }
    /**
     * Gets another `DataSnapshot` for the location at the specified relative path.
     *
     * Passing a relative path to the `child()` method of a DataSnapshot returns
     * another `DataSnapshot` for the location at the specified relative path. The
     * relative path can either be a simple child name (for example, "ada") or a
     * deeper, slash-separated path (for example, "ada/name/first"). If the child
     * location has no data, an empty `DataSnapshot` (that is, a `DataSnapshot`
     * whose value is `null`) is returned.
     *
     * @param path - A relative path to the location of child data.
     */ child(path) {
        const childPath = new $30d3a405033775a4$var$Path(path);
        const childRef = $30d3a405033775a4$export$f9574b70e1d95d9d(this.ref, path);
        return new $30d3a405033775a4$export$80b98bcbc246c942(this._node.getChild(childPath), childRef, $30d3a405033775a4$var$PRIORITY_INDEX);
    }
    /**
     * Returns true if this `DataSnapshot` contains any data. It is slightly more
     * efficient than using `snapshot.val() !== null`.
     */ exists() {
        return !this._node.isEmpty();
    }
    /**
     * Exports the entire contents of the DataSnapshot as a JavaScript object.
     *
     * The `exportVal()` method is similar to `val()`, except priority information
     * is included (if available), making it suitable for backing up your data.
     *
     * @returns The DataSnapshot's contents as a JavaScript value (Object,
     *   Array, string, number, boolean, or `null`).
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    exportVal() {
        return this._node.val(true);
    }
    /**
     * Enumerates the top-level children in the `DataSnapshot`.
     *
     * Because of the way JavaScript objects work, the ordering of data in the
     * JavaScript object returned by `val()` is not guaranteed to match the
     * ordering on the server nor the ordering of `onChildAdded()` events. That is
     * where `forEach()` comes in handy. It guarantees the children of a
     * `DataSnapshot` will be iterated in their query order.
     *
     * If no explicit `orderBy*()` method is used, results are returned
     * ordered by key (unless priorities are used, in which case, results are
     * returned by priority).
     *
     * @param action - A function that will be called for each child DataSnapshot.
     * The callback can return true to cancel further enumeration.
     * @returns true if enumeration was canceled due to your callback returning
     * true.
     */ forEach(action) {
        if (this._node.isLeafNode()) return false;
        const childrenNode = this._node;
        // Sanitize the return value to a boolean. ChildrenNode.forEachChild has a weird return type...
        return !!childrenNode.forEachChild(this._index, (key, node)=>{
            return action(new $30d3a405033775a4$export$80b98bcbc246c942(node, $30d3a405033775a4$export$f9574b70e1d95d9d(this.ref, key), $30d3a405033775a4$var$PRIORITY_INDEX));
        });
    }
    /**
     * Returns true if the specified child path has (non-null) data.
     *
     * @param path - A relative path to the location of a potential child.
     * @returns `true` if data exists at the specified child path; else
     *  `false`.
     */ hasChild(path) {
        const childPath = new $30d3a405033775a4$var$Path(path);
        return !this._node.getChild(childPath).isEmpty();
    }
    /**
     * Returns whether or not the `DataSnapshot` has any non-`null` child
     * properties.
     *
     * You can use `hasChildren()` to determine if a `DataSnapshot` has any
     * children. If it does, you can enumerate them using `forEach()`. If it
     * doesn't, then either this snapshot contains a primitive value (which can be
     * retrieved with `val()`) or it is empty (in which case, `val()` will return
     * `null`).
     *
     * @returns true if this snapshot has any children; else false.
     */ hasChildren() {
        if (this._node.isLeafNode()) return false;
        else return !this._node.isEmpty();
    }
    /**
     * Returns a JSON-serializable representation of this object.
     */ toJSON() {
        return this.exportVal();
    }
    /**
     * Extracts a JavaScript value from a `DataSnapshot`.
     *
     * Depending on the data in a `DataSnapshot`, the `val()` method may return a
     * scalar type (string, number, or boolean), an array, or an object. It may
     * also return null, indicating that the `DataSnapshot` is empty (contains no
     * data).
     *
     * @returns The DataSnapshot's contents as a JavaScript value (Object,
     *   Array, string, number, boolean, or `null`).
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    val() {
        return this._node.val();
    }
    /**
     * @param _node - A SnapshotNode to wrap.
     * @param ref - The location this snapshot came from.
     * @param _index - The iteration order for this snapshot
     * @hideconstructor
     */ constructor(_node, /**
     * The location of this DataSnapshot.
     */ ref, _index){
        this._node = _node;
        this.ref = ref;
        this._index = _index;
    }
}
/**
 *
 * Returns a `Reference` representing the location in the Database
 * corresponding to the provided path. If no path is provided, the `Reference`
 * will point to the root of the Database.
 *
 * @param db - The database instance to obtain a reference for.
 * @param path - Optional path representing the location the returned
 *   `Reference` will point. If not provided, the returned `Reference` will
 *   point to the root of the Database.
 * @returns If a path is provided, a `Reference`
 *   pointing to the provided path. Otherwise, a `Reference` pointing to the
 *   root of the Database.
 */ function $30d3a405033775a4$export$eff4d24c3ff7876e(db, path) {
    db = (0, $f43ebbd33d4c5d93$export$4befe9b5fa509a1b)(db);
    db._checkNotDeleted("ref");
    return path !== undefined ? $30d3a405033775a4$export$f9574b70e1d95d9d(db._root, path) : db._root;
}
/**
 * Returns a `Reference` representing the location in the Database
 * corresponding to the provided Firebase URL.
 *
 * An exception is thrown if the URL is not a valid Firebase Database URL or it
 * has a different domain than the current `Database` instance.
 *
 * Note that all query parameters (`orderBy`, `limitToLast`, etc.) are ignored
 * and are not applied to the returned `Reference`.
 *
 * @param db - The database instance to obtain a reference for.
 * @param url - The Firebase URL at which the returned `Reference` will
 *   point.
 * @returns A `Reference` pointing to the provided
 *   Firebase URL.
 */ function $30d3a405033775a4$export$291fc3c05735451(db, url) {
    db = (0, $f43ebbd33d4c5d93$export$4befe9b5fa509a1b)(db);
    db._checkNotDeleted("refFromURL");
    const parsedURL = $30d3a405033775a4$var$parseRepoInfo(url, db._repo.repoInfo_.nodeAdmin);
    $30d3a405033775a4$var$validateUrl("refFromURL", parsedURL);
    const repoInfo = parsedURL.repoInfo;
    if (!db._repo.repoInfo_.isCustomHost() && repoInfo.host !== db._repo.repoInfo_.host) $30d3a405033775a4$var$fatal("refFromURL: Host name does not match the current database: (found " + repoInfo.host + " but expected " + db._repo.repoInfo_.host + ")");
    return $30d3a405033775a4$export$eff4d24c3ff7876e(db, parsedURL.path.toString());
}
/**
 * Gets a `Reference` for the location at the specified relative path.
 *
 * The relative path can either be a simple child name (for example, "ada") or
 * a deeper slash-separated path (for example, "ada/name/first").
 *
 * @param parent - The parent location.
 * @param path - A relative path from this location to the desired child
 *   location.
 * @returns The specified child location.
 */ function $30d3a405033775a4$export$f9574b70e1d95d9d(parent, path) {
    parent = (0, $f43ebbd33d4c5d93$export$4befe9b5fa509a1b)(parent);
    if ($30d3a405033775a4$var$pathGetFront(parent._path) === null) $30d3a405033775a4$var$validateRootPathString("child", "path", path, false);
    else $30d3a405033775a4$export$8637b026ace8abb1("child", "path", path, false);
    return new $30d3a405033775a4$export$35c3a5e7c9d1033c(parent._repo, $30d3a405033775a4$var$pathChild(parent._path, path));
}
/**
 * Returns an `OnDisconnect` object - see
 * {@link https://firebase.google.com/docs/database/web/offline-capabilities | Enabling Offline Capabilities in JavaScript}
 * for more information on how to use it.
 *
 * @param ref - The reference to add OnDisconnect triggers for.
 */ function $30d3a405033775a4$export$b61bdcd0bdb4f86a(ref) {
    ref = (0, $f43ebbd33d4c5d93$export$4befe9b5fa509a1b)(ref);
    return new $30d3a405033775a4$export$95b7818b4ee6c2af(ref._repo, ref._path);
}
/**
 * Generates a new child location using a unique key and returns its
 * `Reference`.
 *
 * This is the most common pattern for adding data to a collection of items.
 *
 * If you provide a value to `push()`, the value is written to the
 * generated location. If you don't pass a value, nothing is written to the
 * database and the child remains empty (but you can use the `Reference`
 * elsewhere).
 *
 * The unique keys generated by `push()` are ordered by the current time, so the
 * resulting list of items is chronologically sorted. The keys are also
 * designed to be unguessable (they contain 72 random bits of entropy).
 *
 * See {@link https://firebase.google.com/docs/database/web/lists-of-data#append_to_a_list_of_data | Append to a list of data}
 * </br>See {@link ttps://firebase.googleblog.com/2015/02/the-2120-ways-to-ensure-unique_68.html | The 2^120 Ways to Ensure Unique Identifiers}
 *
 * @param parent - The parent location.
 * @param value - Optional value to be written at the generated location.
 * @returns Combined `Promise` and `Reference`; resolves when write is complete,
 * but can be used immediately as the `Reference` to the child location.
 */ function $30d3a405033775a4$export$4cbf152802aa238(parent, value) {
    parent = (0, $f43ebbd33d4c5d93$export$4befe9b5fa509a1b)(parent);
    $30d3a405033775a4$export$8d83036122ae444e("push", parent._path);
    $30d3a405033775a4$var$validateFirebaseDataArg("push", value, parent._path, true);
    const now = $30d3a405033775a4$var$repoServerTime(parent._repo);
    const name = $30d3a405033775a4$var$nextPushId(now);
    // push() returns a ThennableReference whose promise is fulfilled with a
    // regular Reference. We use child() to create handles to two different
    // references. The first is turned into a ThennableReference below by adding
    // then() and catch() methods and is used as the return value of push(). The
    // second remains a regular Reference and is used as the fulfilled value of
    // the first ThennableReference.
    const thennablePushRef = $30d3a405033775a4$export$f9574b70e1d95d9d(parent, name);
    const pushRef = $30d3a405033775a4$export$f9574b70e1d95d9d(parent, name);
    let promise;
    if (value != null) promise = $30d3a405033775a4$export$adaa4cf7ef1b65be(pushRef, value).then(()=>pushRef);
    else promise = Promise.resolve(pushRef);
    thennablePushRef.then = promise.then.bind(promise);
    thennablePushRef.catch = promise.then.bind(promise, undefined);
    return thennablePushRef;
}
/**
 * Removes the data at this Database location.
 *
 * Any data at child locations will also be deleted.
 *
 * The effect of the remove will be visible immediately and the corresponding
 * event 'value' will be triggered. Synchronization of the remove to the
 * Firebase servers will also be started, and the returned Promise will resolve
 * when complete. If provided, the onComplete callback will be called
 * asynchronously after synchronization has finished.
 *
 * @param ref - The location to remove.
 * @returns Resolves when remove on server is complete.
 */ function $30d3a405033775a4$export$cd7f480d6b8286c3(ref) {
    $30d3a405033775a4$export$8d83036122ae444e("remove", ref._path);
    return $30d3a405033775a4$export$adaa4cf7ef1b65be(ref, null);
}
/**
 * Writes data to this Database location.
 *
 * This will overwrite any data at this location and all child locations.
 *
 * The effect of the write will be visible immediately, and the corresponding
 * events ("value", "child_added", etc.) will be triggered. Synchronization of
 * the data to the Firebase servers will also be started, and the returned
 * Promise will resolve when complete. If provided, the `onComplete` callback
 * will be called asynchronously after synchronization has finished.
 *
 * Passing `null` for the new value is equivalent to calling `remove()`; namely,
 * all data at this location and all child locations will be deleted.
 *
 * `set()` will remove any priority stored at this location, so if priority is
 * meant to be preserved, you need to use `setWithPriority()` instead.
 *
 * Note that modifying data with `set()` will cancel any pending transactions
 * at that location, so extreme care should be taken if mixing `set()` and
 * `transaction()` to modify the same data.
 *
 * A single `set()` will generate a single "value" event at the location where
 * the `set()` was performed.
 *
 * @param ref - The location to write to.
 * @param value - The value to be written (string, number, boolean, object,
 *   array, or null).
 * @returns Resolves when write to server is complete.
 */ function $30d3a405033775a4$export$adaa4cf7ef1b65be(ref, value) {
    ref = (0, $f43ebbd33d4c5d93$export$4befe9b5fa509a1b)(ref);
    $30d3a405033775a4$export$8d83036122ae444e("set", ref._path);
    $30d3a405033775a4$var$validateFirebaseDataArg("set", value, ref._path, false);
    const deferred = new (0, $f43ebbd33d4c5d93$export$85f6557964517f1a)();
    $30d3a405033775a4$var$repoSetWithPriority(ref._repo, ref._path, value, /*priority=*/ null, deferred.wrapCallback(()=>{}));
    return deferred.promise;
}
/**
 * Sets a priority for the data at this Database location.
 *
 * Applications need not use priority but can order collections by
 * ordinary properties (see
 * {@link https://firebase.google.com/docs/database/web/lists-of-data#sorting_and_filtering_data | Sorting and filtering data}
 * ).
 *
 * @param ref - The location to write to.
 * @param priority - The priority to be written (string, number, or null).
 * @returns Resolves when write to server is complete.
 */ function $30d3a405033775a4$export$313bf5dbe7a1196e(ref, priority) {
    ref = (0, $f43ebbd33d4c5d93$export$4befe9b5fa509a1b)(ref);
    $30d3a405033775a4$export$8d83036122ae444e("setPriority", ref._path);
    $30d3a405033775a4$var$validatePriority("setPriority", priority, false);
    const deferred = new (0, $f43ebbd33d4c5d93$export$85f6557964517f1a)();
    $30d3a405033775a4$var$repoSetWithPriority(ref._repo, $30d3a405033775a4$var$pathChild(ref._path, ".priority"), priority, null, deferred.wrapCallback(()=>{}));
    return deferred.promise;
}
/**
 * Writes data the Database location. Like `set()` but also specifies the
 * priority for that data.
 *
 * Applications need not use priority but can order collections by
 * ordinary properties (see
 * {@link https://firebase.google.com/docs/database/web/lists-of-data#sorting_and_filtering_data | Sorting and filtering data}
 * ).
 *
 * @param ref - The location to write to.
 * @param value - The value to be written (string, number, boolean, object,
 *   array, or null).
 * @param priority - The priority to be written (string, number, or null).
 * @returns Resolves when write to server is complete.
 */ function $30d3a405033775a4$export$1fa5d5bf488088f3(ref, value, priority) {
    $30d3a405033775a4$export$8d83036122ae444e("setWithPriority", ref._path);
    $30d3a405033775a4$var$validateFirebaseDataArg("setWithPriority", value, ref._path, false);
    $30d3a405033775a4$var$validatePriority("setWithPriority", priority, false);
    if (ref.key === ".length" || ref.key === ".keys") throw "setWithPriority failed: " + ref.key + " is a read-only object.";
    const deferred = new (0, $f43ebbd33d4c5d93$export$85f6557964517f1a)();
    $30d3a405033775a4$var$repoSetWithPriority(ref._repo, ref._path, value, priority, deferred.wrapCallback(()=>{}));
    return deferred.promise;
}
/**
 * Writes multiple values to the Database at once.
 *
 * The `values` argument contains multiple property-value pairs that will be
 * written to the Database together. Each child property can either be a simple
 * property (for example, "name") or a relative path (for example,
 * "name/first") from the current location to the data to update.
 *
 * As opposed to the `set()` method, `update()` can be use to selectively update
 * only the referenced properties at the current location (instead of replacing
 * all the child properties at the current location).
 *
 * The effect of the write will be visible immediately, and the corresponding
 * events ('value', 'child_added', etc.) will be triggered. Synchronization of
 * the data to the Firebase servers will also be started, and the returned
 * Promise will resolve when complete. If provided, the `onComplete` callback
 * will be called asynchronously after synchronization has finished.
 *
 * A single `update()` will generate a single "value" event at the location
 * where the `update()` was performed, regardless of how many children were
 * modified.
 *
 * Note that modifying data with `update()` will cancel any pending
 * transactions at that location, so extreme care should be taken if mixing
 * `update()` and `transaction()` to modify the same data.
 *
 * Passing `null` to `update()` will remove the data at this location.
 *
 * See
 * {@link https://firebase.googleblog.com/2015/09/introducing-multi-location-updates-and_86.html | Introducing multi-location updates and more}.
 *
 * @param ref - The location to write to.
 * @param values - Object containing multiple values.
 * @returns Resolves when update on server is complete.
 */ function $30d3a405033775a4$export$722fbec263ad908a(ref, values) {
    $30d3a405033775a4$var$validateFirebaseMergeDataArg("update", values, ref._path, false);
    const deferred = new (0, $f43ebbd33d4c5d93$export$85f6557964517f1a)();
    $30d3a405033775a4$var$repoUpdate(ref._repo, ref._path, values, deferred.wrapCallback(()=>{}));
    return deferred.promise;
}
/**
 * Gets the most up-to-date result for this query.
 *
 * @param query - The query to run.
 * @returns A `Promise` which resolves to the resulting DataSnapshot if a value is
 * available, or rejects if the client is unable to return a value (e.g., if the
 * server is unreachable and there is nothing cached).
 */ function $30d3a405033775a4$export$3988ae62b71be9a3(query) {
    query = (0, $f43ebbd33d4c5d93$export$4befe9b5fa509a1b)(query);
    return $30d3a405033775a4$var$repoGetValue(query._repo, query).then((node)=>{
        return new $30d3a405033775a4$export$80b98bcbc246c942(node, new $30d3a405033775a4$export$35c3a5e7c9d1033c(query._repo, query._path), query._queryParams.getIndex());
    });
}
/**
 * Represents registration for 'value' events.
 */ class $30d3a405033775a4$var$ValueEventRegistration {
    respondsTo(eventType) {
        return eventType === "value";
    }
    createEvent(change, query) {
        const index = query._queryParams.getIndex();
        return new $30d3a405033775a4$var$DataEvent("value", this, new $30d3a405033775a4$export$80b98bcbc246c942(change.snapshotNode, new $30d3a405033775a4$export$35c3a5e7c9d1033c(query._repo, query._path), index));
    }
    getEventRunner(eventData) {
        if (eventData.getEventType() === "cancel") return ()=>this.callbackContext.onCancel(eventData.error);
        else return ()=>this.callbackContext.onValue(eventData.snapshot, null);
    }
    createCancelEvent(error, path) {
        if (this.callbackContext.hasCancelCallback) return new $30d3a405033775a4$var$CancelEvent(this, error, path);
        else return null;
    }
    matches(other) {
        if (!(other instanceof $30d3a405033775a4$var$ValueEventRegistration)) return false;
        else if (!other.callbackContext || !this.callbackContext) // If no callback specified, we consider it to match any callback.
        return true;
        else return other.callbackContext.matches(this.callbackContext);
    }
    hasAnyCallback() {
        return this.callbackContext !== null;
    }
    constructor(callbackContext){
        this.callbackContext = callbackContext;
    }
}
/**
 * Represents the registration of a child_x event.
 */ class $30d3a405033775a4$var$ChildEventRegistration {
    respondsTo(eventType) {
        let eventToCheck = eventType === "children_added" ? "child_added" : eventType;
        eventToCheck = eventToCheck === "children_removed" ? "child_removed" : eventToCheck;
        return this.eventType === eventToCheck;
    }
    createCancelEvent(error, path) {
        if (this.callbackContext.hasCancelCallback) return new $30d3a405033775a4$var$CancelEvent(this, error, path);
        else return null;
    }
    createEvent(change, query) {
        (0, $f43ebbd33d4c5d93$export$a7a9523472993e97)(change.childName != null, "Child events should have a childName.");
        const childRef = $30d3a405033775a4$export$f9574b70e1d95d9d(new $30d3a405033775a4$export$35c3a5e7c9d1033c(query._repo, query._path), change.childName);
        const index = query._queryParams.getIndex();
        return new $30d3a405033775a4$var$DataEvent(change.type, this, new $30d3a405033775a4$export$80b98bcbc246c942(change.snapshotNode, childRef, index), change.prevName);
    }
    getEventRunner(eventData) {
        if (eventData.getEventType() === "cancel") return ()=>this.callbackContext.onCancel(eventData.error);
        else return ()=>this.callbackContext.onValue(eventData.snapshot, eventData.prevName);
    }
    matches(other) {
        if (other instanceof $30d3a405033775a4$var$ChildEventRegistration) return this.eventType === other.eventType && (!this.callbackContext || !other.callbackContext || this.callbackContext.matches(other.callbackContext));
        return false;
    }
    hasAnyCallback() {
        return !!this.callbackContext;
    }
    constructor(eventType, callbackContext){
        this.eventType = eventType;
        this.callbackContext = callbackContext;
    }
}
function $30d3a405033775a4$var$addEventListener(query, eventType, callback, cancelCallbackOrListenOptions, options) {
    let cancelCallback;
    if (typeof cancelCallbackOrListenOptions === "object") {
        cancelCallback = undefined;
        options = cancelCallbackOrListenOptions;
    }
    if (typeof cancelCallbackOrListenOptions === "function") cancelCallback = cancelCallbackOrListenOptions;
    if (options && options.onlyOnce) {
        const userCallback = callback;
        const onceCallback = (dataSnapshot, previousChildName)=>{
            $30d3a405033775a4$var$repoRemoveEventCallbackForQuery(query._repo, query, container);
            userCallback(dataSnapshot, previousChildName);
        };
        onceCallback.userCallback = callback.userCallback;
        onceCallback.context = callback.context;
        callback = onceCallback;
    }
    const callbackContext = new $30d3a405033775a4$var$CallbackContext(callback, cancelCallback || undefined);
    const container = eventType === "value" ? new $30d3a405033775a4$var$ValueEventRegistration(callbackContext) : new $30d3a405033775a4$var$ChildEventRegistration(eventType, callbackContext);
    $30d3a405033775a4$var$repoAddEventCallbackForQuery(query._repo, query, container);
    return ()=>$30d3a405033775a4$var$repoRemoveEventCallbackForQuery(query._repo, query, container);
}
function $30d3a405033775a4$export$ad30f661f41f4d90(query, callback, cancelCallbackOrListenOptions, options) {
    return $30d3a405033775a4$var$addEventListener(query, "value", callback, cancelCallbackOrListenOptions, options);
}
function $30d3a405033775a4$export$fdc3e67b2775c753(query, callback, cancelCallbackOrListenOptions, options) {
    return $30d3a405033775a4$var$addEventListener(query, "child_added", callback, cancelCallbackOrListenOptions, options);
}
function $30d3a405033775a4$export$a3fdf31223dcb03(query, callback, cancelCallbackOrListenOptions, options) {
    return $30d3a405033775a4$var$addEventListener(query, "child_changed", callback, cancelCallbackOrListenOptions, options);
}
function $30d3a405033775a4$export$1b001b15904d2a7f(query, callback, cancelCallbackOrListenOptions, options) {
    return $30d3a405033775a4$var$addEventListener(query, "child_moved", callback, cancelCallbackOrListenOptions, options);
}
function $30d3a405033775a4$export$8362b530316d1aba(query, callback, cancelCallbackOrListenOptions, options) {
    return $30d3a405033775a4$var$addEventListener(query, "child_removed", callback, cancelCallbackOrListenOptions, options);
}
/**
 * Detaches a callback previously attached with `on()`.
 *
 * Detach a callback previously attached with `on()`. Note that if `on()` was
 * called multiple times with the same eventType and callback, the callback
 * will be called multiple times for each event, and `off()` must be called
 * multiple times to remove the callback. Calling `off()` on a parent listener
 * will not automatically remove listeners registered on child nodes, `off()`
 * must also be called on any child listeners to remove the callback.
 *
 * If a callback is not specified, all callbacks for the specified eventType
 * will be removed. Similarly, if no eventType is specified, all callbacks
 * for the `Reference` will be removed.
 *
 * Individual listeners can also be removed by invoking their unsubscribe
 * callbacks.
 *
 * @param query - The query that the listener was registered with.
 * @param eventType - One of the following strings: "value", "child_added",
 * "child_changed", "child_removed", or "child_moved." If omitted, all callbacks
 * for the `Reference` will be removed.
 * @param callback - The callback function that was passed to `on()` or
 * `undefined` to remove all callbacks.
 */ function $30d3a405033775a4$export$8c8705df4a2dcec9(query, eventType, callback) {
    let container = null;
    const expCallback = callback ? new $30d3a405033775a4$var$CallbackContext(callback) : null;
    if (eventType === "value") container = new $30d3a405033775a4$var$ValueEventRegistration(expCallback);
    else if (eventType) container = new $30d3a405033775a4$var$ChildEventRegistration(eventType, expCallback);
    $30d3a405033775a4$var$repoRemoveEventCallbackForQuery(query._repo, query, container);
}
/**
 * A `QueryConstraint` is used to narrow the set of documents returned by a
 * Database query. `QueryConstraint`s are created by invoking {@link endAt},
 * {@link endBefore}, {@link startAt}, {@link startAfter}, {@link
 * limitToFirst}, {@link limitToLast}, {@link orderByChild},
 * {@link orderByChild}, {@link orderByKey} , {@link orderByPriority} ,
 * {@link orderByValue}  or {@link equalTo} and
 * can then be passed to {@link query} to create a new query instance that
 * also contains this `QueryConstraint`.
 */ class $30d3a405033775a4$export$b0e86f2c7431df4e {
}
class $30d3a405033775a4$var$QueryEndAtConstraint extends $30d3a405033775a4$export$b0e86f2c7431df4e {
    _apply(query) {
        $30d3a405033775a4$var$validateFirebaseDataArg("endAt", this._value, query._path, true);
        const newParams = $30d3a405033775a4$var$queryParamsEndAt(query._queryParams, this._value, this._key);
        $30d3a405033775a4$var$validateLimit(newParams);
        $30d3a405033775a4$var$validateQueryEndpoints(newParams);
        if (query._queryParams.hasEnd()) throw new Error("endAt: Starting point was already set (by another call to endAt, endBefore or equalTo).");
        return new $30d3a405033775a4$export$e79c8d837d2220a8(query._repo, query._path, newParams, query._orderByCalled);
    }
    constructor(_value, _key){
        super();
        this._value = _value;
        this._key = _key;
    }
}
/**
 * Creates a `QueryConstraint` with the specified ending point.
 *
 * Using `startAt()`, `startAfter()`, `endBefore()`, `endAt()` and `equalTo()`
 * allows you to choose arbitrary starting and ending points for your queries.
 *
 * The ending point is inclusive, so children with exactly the specified value
 * will be included in the query. The optional key argument can be used to
 * further limit the range of the query. If it is specified, then children that
 * have exactly the specified value must also have a key name less than or equal
 * to the specified key.
 *
 * You can read more about `endAt()` in
 * {@link https://firebase.google.com/docs/database/web/lists-of-data#filtering_data | Filtering data}.
 *
 * @param value - The value to end at. The argument type depends on which
 * `orderBy*()` function was used in this query. Specify a value that matches
 * the `orderBy*()` type. When used in combination with `orderByKey()`, the
 * value must be a string.
 * @param key - The child key to end at, among the children with the previously
 * specified priority. This argument is only allowed if ordering by child,
 * value, or priority.
 */ function $30d3a405033775a4$export$28ec54a8428bdb3f(value, key) {
    $30d3a405033775a4$var$validateKey("endAt", "key", key, true);
    return new $30d3a405033775a4$var$QueryEndAtConstraint(value, key);
}
class $30d3a405033775a4$var$QueryEndBeforeConstraint extends $30d3a405033775a4$export$b0e86f2c7431df4e {
    _apply(query) {
        $30d3a405033775a4$var$validateFirebaseDataArg("endBefore", this._value, query._path, false);
        const newParams = $30d3a405033775a4$var$queryParamsEndBefore(query._queryParams, this._value, this._key);
        $30d3a405033775a4$var$validateLimit(newParams);
        $30d3a405033775a4$var$validateQueryEndpoints(newParams);
        if (query._queryParams.hasEnd()) throw new Error("endBefore: Starting point was already set (by another call to endAt, endBefore or equalTo).");
        return new $30d3a405033775a4$export$e79c8d837d2220a8(query._repo, query._path, newParams, query._orderByCalled);
    }
    constructor(_value, _key){
        super();
        this._value = _value;
        this._key = _key;
    }
}
/**
 * Creates a `QueryConstraint` with the specified ending point (exclusive).
 *
 * Using `startAt()`, `startAfter()`, `endBefore()`, `endAt()` and `equalTo()`
 * allows you to choose arbitrary starting and ending points for your queries.
 *
 * The ending point is exclusive. If only a value is provided, children
 * with a value less than the specified value will be included in the query.
 * If a key is specified, then children must have a value lesss than or equal
 * to the specified value and a a key name less than the specified key.
 *
 * @param value - The value to end before. The argument type depends on which
 * `orderBy*()` function was used in this query. Specify a value that matches
 * the `orderBy*()` type. When used in combination with `orderByKey()`, the
 * value must be a string.
 * @param key - The child key to end before, among the children with the
 * previously specified priority. This argument is only allowed if ordering by
 * child, value, or priority.
 */ function $30d3a405033775a4$export$57203950645b8b11(value, key) {
    $30d3a405033775a4$var$validateKey("endBefore", "key", key, true);
    return new $30d3a405033775a4$var$QueryEndBeforeConstraint(value, key);
}
class $30d3a405033775a4$var$QueryStartAtConstraint extends $30d3a405033775a4$export$b0e86f2c7431df4e {
    _apply(query) {
        $30d3a405033775a4$var$validateFirebaseDataArg("startAt", this._value, query._path, true);
        const newParams = $30d3a405033775a4$var$queryParamsStartAt(query._queryParams, this._value, this._key);
        $30d3a405033775a4$var$validateLimit(newParams);
        $30d3a405033775a4$var$validateQueryEndpoints(newParams);
        if (query._queryParams.hasStart()) throw new Error("startAt: Starting point was already set (by another call to startAt, startBefore or equalTo).");
        return new $30d3a405033775a4$export$e79c8d837d2220a8(query._repo, query._path, newParams, query._orderByCalled);
    }
    constructor(_value, _key){
        super();
        this._value = _value;
        this._key = _key;
    }
}
/**
 * Creates a `QueryConstraint` with the specified starting point.
 *
 * Using `startAt()`, `startAfter()`, `endBefore()`, `endAt()` and `equalTo()`
 * allows you to choose arbitrary starting and ending points for your queries.
 *
 * The starting point is inclusive, so children with exactly the specified value
 * will be included in the query. The optional key argument can be used to
 * further limit the range of the query. If it is specified, then children that
 * have exactly the specified value must also have a key name greater than or
 * equal to the specified key.
 *
 * You can read more about `startAt()` in
 * {@link https://firebase.google.com/docs/database/web/lists-of-data#filtering_data | Filtering data}.
 *
 * @param value - The value to start at. The argument type depends on which
 * `orderBy*()` function was used in this query. Specify a value that matches
 * the `orderBy*()` type. When used in combination with `orderByKey()`, the
 * value must be a string.
 * @param key - The child key to start at. This argument is only allowed if
 * ordering by child, value, or priority.
 */ function $30d3a405033775a4$export$859941c5fc8eba6b(value = null, key) {
    $30d3a405033775a4$var$validateKey("startAt", "key", key, true);
    return new $30d3a405033775a4$var$QueryStartAtConstraint(value, key);
}
class $30d3a405033775a4$var$QueryStartAfterConstraint extends $30d3a405033775a4$export$b0e86f2c7431df4e {
    _apply(query) {
        $30d3a405033775a4$var$validateFirebaseDataArg("startAfter", this._value, query._path, false);
        const newParams = $30d3a405033775a4$var$queryParamsStartAfter(query._queryParams, this._value, this._key);
        $30d3a405033775a4$var$validateLimit(newParams);
        $30d3a405033775a4$var$validateQueryEndpoints(newParams);
        if (query._queryParams.hasStart()) throw new Error("startAfter: Starting point was already set (by another call to startAt, startAfter, or equalTo).");
        return new $30d3a405033775a4$export$e79c8d837d2220a8(query._repo, query._path, newParams, query._orderByCalled);
    }
    constructor(_value, _key){
        super();
        this._value = _value;
        this._key = _key;
    }
}
/**
 * Creates a `QueryConstraint` with the specified starting point (exclusive).
 *
 * Using `startAt()`, `startAfter()`, `endBefore()`, `endAt()` and `equalTo()`
 * allows you to choose arbitrary starting and ending points for your queries.
 *
 * The starting point is exclusive. If only a value is provided, children
 * with a value greater than the specified value will be included in the query.
 * If a key is specified, then children must have a value greater than or equal
 * to the specified value and a a key name greater than the specified key.
 *
 * @param value - The value to start after. The argument type depends on which
 * `orderBy*()` function was used in this query. Specify a value that matches
 * the `orderBy*()` type. When used in combination with `orderByKey()`, the
 * value must be a string.
 * @param key - The child key to start after. This argument is only allowed if
 * ordering by child, value, or priority.
 */ function $30d3a405033775a4$export$dd8dee5f7b804673(value, key) {
    $30d3a405033775a4$var$validateKey("startAfter", "key", key, true);
    return new $30d3a405033775a4$var$QueryStartAfterConstraint(value, key);
}
class $30d3a405033775a4$var$QueryLimitToFirstConstraint extends $30d3a405033775a4$export$b0e86f2c7431df4e {
    _apply(query) {
        if (query._queryParams.hasLimit()) throw new Error("limitToFirst: Limit was already set (by another call to limitToFirst or limitToLast).");
        return new $30d3a405033775a4$export$e79c8d837d2220a8(query._repo, query._path, $30d3a405033775a4$var$queryParamsLimitToFirst(query._queryParams, this._limit), query._orderByCalled);
    }
    constructor(_limit){
        super();
        this._limit = _limit;
    }
}
/**
 * Creates a new `QueryConstraint` that if limited to the first specific number
 * of children.
 *
 * The `limitToFirst()` method is used to set a maximum number of children to be
 * synced for a given callback. If we set a limit of 100, we will initially only
 * receive up to 100 `child_added` events. If we have fewer than 100 messages
 * stored in our Database, a `child_added` event will fire for each message.
 * However, if we have over 100 messages, we will only receive a `child_added`
 * event for the first 100 ordered messages. As items change, we will receive
 * `child_removed` events for each item that drops out of the active list so
 * that the total number stays at 100.
 *
 * You can read more about `limitToFirst()` in
 * {@link https://firebase.google.com/docs/database/web/lists-of-data#filtering_data | Filtering data}.
 *
 * @param limit - The maximum number of nodes to include in this query.
 */ function $30d3a405033775a4$export$9d02e839f813b99d(limit) {
    if (typeof limit !== "number" || Math.floor(limit) !== limit || limit <= 0) throw new Error("limitToFirst: First argument must be a positive integer.");
    return new $30d3a405033775a4$var$QueryLimitToFirstConstraint(limit);
}
class $30d3a405033775a4$var$QueryLimitToLastConstraint extends $30d3a405033775a4$export$b0e86f2c7431df4e {
    _apply(query) {
        if (query._queryParams.hasLimit()) throw new Error("limitToLast: Limit was already set (by another call to limitToFirst or limitToLast).");
        return new $30d3a405033775a4$export$e79c8d837d2220a8(query._repo, query._path, $30d3a405033775a4$var$queryParamsLimitToLast(query._queryParams, this._limit), query._orderByCalled);
    }
    constructor(_limit){
        super();
        this._limit = _limit;
    }
}
/**
 * Creates a new `QueryConstraint` that is limited to return only the last
 * specified number of children.
 *
 * The `limitToLast()` method is used to set a maximum number of children to be
 * synced for a given callback. If we set a limit of 100, we will initially only
 * receive up to 100 `child_added` events. If we have fewer than 100 messages
 * stored in our Database, a `child_added` event will fire for each message.
 * However, if we have over 100 messages, we will only receive a `child_added`
 * event for the last 100 ordered messages. As items change, we will receive
 * `child_removed` events for each item that drops out of the active list so
 * that the total number stays at 100.
 *
 * You can read more about `limitToLast()` in
 * {@link https://firebase.google.com/docs/database/web/lists-of-data#filtering_data | Filtering data}.
 *
 * @param limit - The maximum number of nodes to include in this query.
 */ function $30d3a405033775a4$export$f823b3589f69d3b8(limit) {
    if (typeof limit !== "number" || Math.floor(limit) !== limit || limit <= 0) throw new Error("limitToLast: First argument must be a positive integer.");
    return new $30d3a405033775a4$var$QueryLimitToLastConstraint(limit);
}
class $30d3a405033775a4$var$QueryOrderByChildConstraint extends $30d3a405033775a4$export$b0e86f2c7431df4e {
    _apply(query) {
        $30d3a405033775a4$var$validateNoPreviousOrderByCall(query, "orderByChild");
        const parsedPath = new $30d3a405033775a4$var$Path(this._path);
        if ($30d3a405033775a4$var$pathIsEmpty(parsedPath)) throw new Error("orderByChild: cannot pass in empty path. Use orderByValue() instead.");
        const index = new $30d3a405033775a4$var$PathIndex(parsedPath);
        const newParams = $30d3a405033775a4$var$queryParamsOrderBy(query._queryParams, index);
        $30d3a405033775a4$var$validateQueryEndpoints(newParams);
        return new $30d3a405033775a4$export$e79c8d837d2220a8(query._repo, query._path, newParams, /*orderByCalled=*/ true);
    }
    constructor(_path){
        super();
        this._path = _path;
    }
}
/**
 * Creates a new `QueryConstraint` that orders by the specified child key.
 *
 * Queries can only order by one key at a time. Calling `orderByChild()`
 * multiple times on the same query is an error.
 *
 * Firebase queries allow you to order your data by any child key on the fly.
 * However, if you know in advance what your indexes will be, you can define
 * them via the .indexOn rule in your Security Rules for better performance. See
 * the{@link https://firebase.google.com/docs/database/security/indexing-data}
 * rule for more information.
 *
 * You can read more about `orderByChild()` in
 * {@link https://firebase.google.com/docs/database/web/lists-of-data#sort_data | Sort data}.
 *
 * @param path - The path to order by.
 */ function $30d3a405033775a4$export$5162bd9025f8e144(path) {
    if (path === "$key") throw new Error('orderByChild: "$key" is invalid.  Use orderByKey() instead.');
    else if (path === "$priority") throw new Error('orderByChild: "$priority" is invalid.  Use orderByPriority() instead.');
    else if (path === "$value") throw new Error('orderByChild: "$value" is invalid.  Use orderByValue() instead.');
    $30d3a405033775a4$export$8637b026ace8abb1("orderByChild", "path", path, false);
    return new $30d3a405033775a4$var$QueryOrderByChildConstraint(path);
}
class $30d3a405033775a4$var$QueryOrderByKeyConstraint extends $30d3a405033775a4$export$b0e86f2c7431df4e {
    _apply(query) {
        $30d3a405033775a4$var$validateNoPreviousOrderByCall(query, "orderByKey");
        const newParams = $30d3a405033775a4$var$queryParamsOrderBy(query._queryParams, $30d3a405033775a4$var$KEY_INDEX);
        $30d3a405033775a4$var$validateQueryEndpoints(newParams);
        return new $30d3a405033775a4$export$e79c8d837d2220a8(query._repo, query._path, newParams, /*orderByCalled=*/ true);
    }
}
/**
 * Creates a new `QueryConstraint` that orders by the key.
 *
 * Sorts the results of a query by their (ascending) key values.
 *
 * You can read more about `orderByKey()` in
 * {@link https://firebase.google.com/docs/database/web/lists-of-data#sort_data | Sort data}.
 */ function $30d3a405033775a4$export$d5ab8b3bbd8afbf8() {
    return new $30d3a405033775a4$var$QueryOrderByKeyConstraint();
}
class $30d3a405033775a4$var$QueryOrderByPriorityConstraint extends $30d3a405033775a4$export$b0e86f2c7431df4e {
    _apply(query) {
        $30d3a405033775a4$var$validateNoPreviousOrderByCall(query, "orderByPriority");
        const newParams = $30d3a405033775a4$var$queryParamsOrderBy(query._queryParams, $30d3a405033775a4$var$PRIORITY_INDEX);
        $30d3a405033775a4$var$validateQueryEndpoints(newParams);
        return new $30d3a405033775a4$export$e79c8d837d2220a8(query._repo, query._path, newParams, /*orderByCalled=*/ true);
    }
}
/**
 * Creates a new `QueryConstraint` that orders by priority.
 *
 * Applications need not use priority but can order collections by
 * ordinary properties (see
 * {@link https://firebase.google.com/docs/database/web/lists-of-data#sort_data | Sort data}
 * for alternatives to priority.
 */ function $30d3a405033775a4$export$19e8ae5500cf2e55() {
    return new $30d3a405033775a4$var$QueryOrderByPriorityConstraint();
}
class $30d3a405033775a4$var$QueryOrderByValueConstraint extends $30d3a405033775a4$export$b0e86f2c7431df4e {
    _apply(query) {
        $30d3a405033775a4$var$validateNoPreviousOrderByCall(query, "orderByValue");
        const newParams = $30d3a405033775a4$var$queryParamsOrderBy(query._queryParams, $30d3a405033775a4$var$VALUE_INDEX);
        $30d3a405033775a4$var$validateQueryEndpoints(newParams);
        return new $30d3a405033775a4$export$e79c8d837d2220a8(query._repo, query._path, newParams, /*orderByCalled=*/ true);
    }
}
/**
 * Creates a new `QueryConstraint` that orders by value.
 *
 * If the children of a query are all scalar values (string, number, or
 * boolean), you can order the results by their (ascending) values.
 *
 * You can read more about `orderByValue()` in
 * {@link https://firebase.google.com/docs/database/web/lists-of-data#sort_data | Sort data}.
 */ function $30d3a405033775a4$export$7f2f62793c39d0c0() {
    return new $30d3a405033775a4$var$QueryOrderByValueConstraint();
}
class $30d3a405033775a4$var$QueryEqualToValueConstraint extends $30d3a405033775a4$export$b0e86f2c7431df4e {
    _apply(query) {
        $30d3a405033775a4$var$validateFirebaseDataArg("equalTo", this._value, query._path, false);
        if (query._queryParams.hasStart()) throw new Error("equalTo: Starting point was already set (by another call to startAt/startAfter or equalTo).");
        if (query._queryParams.hasEnd()) throw new Error("equalTo: Ending point was already set (by another call to endAt/endBefore or equalTo).");
        return new $30d3a405033775a4$var$QueryEndAtConstraint(this._value, this._key)._apply(new $30d3a405033775a4$var$QueryStartAtConstraint(this._value, this._key)._apply(query));
    }
    constructor(_value, _key){
        super();
        this._value = _value;
        this._key = _key;
    }
}
/**
 * Creates a `QueryConstraint` that includes children that match the specified
 * value.
 *
 * Using `startAt()`, `startAfter()`, `endBefore()`, `endAt()` and `equalTo()`
 * allows you to choose arbitrary starting and ending points for your queries.
 *
 * The optional key argument can be used to further limit the range of the
 * query. If it is specified, then children that have exactly the specified
 * value must also have exactly the specified key as their key name. This can be
 * used to filter result sets with many matches for the same value.
 *
 * You can read more about `equalTo()` in
 * {@link https://firebase.google.com/docs/database/web/lists-of-data#filtering_data | Filtering data}.
 *
 * @param value - The value to match for. The argument type depends on which
 * `orderBy*()` function was used in this query. Specify a value that matches
 * the `orderBy*()` type. When used in combination with `orderByKey()`, the
 * value must be a string.
 * @param key - The child key to start at, among the children with the
 * previously specified priority. This argument is only allowed if ordering by
 * child, value, or priority.
 */ function $30d3a405033775a4$export$bdcdec1f91f16dff(value, key) {
    $30d3a405033775a4$var$validateKey("equalTo", "key", key, true);
    return new $30d3a405033775a4$var$QueryEqualToValueConstraint(value, key);
}
/**
 * Creates a new immutable instance of `Query` that is extended to also include
 * additional query constraints.
 *
 * @param query - The Query instance to use as a base for the new constraints.
 * @param queryConstraints - The list of `QueryConstraint`s to apply.
 * @throws if any of the provided query constraints cannot be combined with the
 * existing or new constraints.
 */ function $30d3a405033775a4$export$2fa187e846a241c4(query1, ...queryConstraints) {
    let queryImpl = (0, $f43ebbd33d4c5d93$export$4befe9b5fa509a1b)(query1);
    for (const constraint of queryConstraints)queryImpl = constraint._apply(queryImpl);
    return queryImpl;
}
/**
 * Define reference constructor in various modules
 *
 * We are doing this here to avoid several circular
 * dependency issues
 */ $30d3a405033775a4$var$syncPointSetReferenceConstructor($30d3a405033775a4$export$35c3a5e7c9d1033c);
$30d3a405033775a4$var$syncTreeSetReferenceConstructor($30d3a405033775a4$export$35c3a5e7c9d1033c);
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * This variable is also defined in the firebase Node.js Admin SDK. Before
 * modifying this definition, consult the definition in:
 *
 * https://github.com/firebase/firebase-admin-node
 *
 * and make sure the two are consistent.
 */ const $30d3a405033775a4$var$FIREBASE_DATABASE_EMULATOR_HOST_VAR = "FIREBASE_DATABASE_EMULATOR_HOST";
/**
 * Creates and caches `Repo` instances.
 */ const $30d3a405033775a4$var$repos = {};
/**
 * If true, any new `Repo` will be created to use `ReadonlyRestClient` (for testing purposes).
 */ let $30d3a405033775a4$var$useRestClient = false;
/**
 * Update an existing `Repo` in place to point to a new host/port.
 */ function $30d3a405033775a4$var$repoManagerApplyEmulatorSettings(repo, host, port, tokenProvider) {
    repo.repoInfo_ = new $30d3a405033775a4$var$RepoInfo(`${host}:${port}`, /* secure= */ false, repo.repoInfo_.namespace, repo.repoInfo_.webSocketOnly, repo.repoInfo_.nodeAdmin, repo.repoInfo_.persistenceKey, repo.repoInfo_.includeNamespaceInQueryParams);
    if (tokenProvider) repo.authTokenProvider_ = tokenProvider;
}
/**
 * This function should only ever be called to CREATE a new database instance.
 * @internal
 */ function $30d3a405033775a4$export$a248c1d2ea757674(app, authProvider, appCheckProvider, url, nodeAdmin) {
    let dbUrl = url || app.options.databaseURL;
    if (dbUrl === undefined) {
        if (!app.options.projectId) $30d3a405033775a4$var$fatal("Can't determine Firebase Database URL. Be sure to include  a Project ID when calling firebase.initializeApp().");
        $30d3a405033775a4$var$log("Using default host for project ", app.options.projectId);
        dbUrl = `${app.options.projectId}-default-rtdb.firebaseio.com`;
    }
    let parsedUrl = $30d3a405033775a4$var$parseRepoInfo(dbUrl, nodeAdmin);
    let repoInfo = parsedUrl.repoInfo;
    let isEmulator;
    let dbEmulatorHost = undefined;
    if (typeof $i9yYZ !== "undefined" && $i9yYZ.env) dbEmulatorHost = $i9yYZ.env[$30d3a405033775a4$var$FIREBASE_DATABASE_EMULATOR_HOST_VAR];
    if (dbEmulatorHost) {
        isEmulator = true;
        dbUrl = `http://${dbEmulatorHost}?ns=${repoInfo.namespace}`;
        parsedUrl = $30d3a405033775a4$var$parseRepoInfo(dbUrl, nodeAdmin);
        repoInfo = parsedUrl.repoInfo;
    } else isEmulator = !parsedUrl.repoInfo.secure;
    const authTokenProvider = nodeAdmin && isEmulator ? new $30d3a405033775a4$var$EmulatorTokenProvider($30d3a405033775a4$var$EmulatorTokenProvider.OWNER) : new $30d3a405033775a4$var$FirebaseAuthTokenProvider(app.name, app.options, authProvider);
    $30d3a405033775a4$var$validateUrl("Invalid Firebase Database URL", parsedUrl);
    if (!$30d3a405033775a4$var$pathIsEmpty(parsedUrl.path)) $30d3a405033775a4$var$fatal("Database URL must point to the root of a Firebase Database (not including a child path).");
    const repo = $30d3a405033775a4$var$repoManagerCreateRepo(repoInfo, app, authTokenProvider, new $30d3a405033775a4$var$AppCheckTokenProvider(app.name, appCheckProvider));
    return new $30d3a405033775a4$export$6feb5ea51a7b0b47(repo, app);
}
/**
 * Remove the repo and make sure it is disconnected.
 *
 */ function $30d3a405033775a4$var$repoManagerDeleteRepo(repo, appName) {
    const appRepos = $30d3a405033775a4$var$repos[appName];
    // This should never happen...
    if (!appRepos || appRepos[repo.key] !== repo) $30d3a405033775a4$var$fatal(`Database ${appName}(${repo.repoInfo_}) has already been deleted.`);
    $30d3a405033775a4$var$repoInterrupt(repo);
    delete appRepos[repo.key];
}
/**
 * Ensures a repo doesn't already exist and then creates one using the
 * provided app.
 *
 * @param repoInfo - The metadata about the Repo
 * @returns The Repo object for the specified server / repoName.
 */ function $30d3a405033775a4$var$repoManagerCreateRepo(repoInfo, app, authTokenProvider, appCheckProvider) {
    let appRepos = $30d3a405033775a4$var$repos[app.name];
    if (!appRepos) {
        appRepos = {};
        $30d3a405033775a4$var$repos[app.name] = appRepos;
    }
    let repo = appRepos[repoInfo.toURLString()];
    if (repo) $30d3a405033775a4$var$fatal("Database initialized multiple times. Please make sure the format of the database URL matches with each database() call.");
    repo = new $30d3a405033775a4$var$Repo(repoInfo, $30d3a405033775a4$var$useRestClient, authTokenProvider, appCheckProvider);
    appRepos[repoInfo.toURLString()] = repo;
    return repo;
}
/**
 * Forces us to use ReadonlyRestClient instead of PersistentConnection for new Repos.
 */ function $30d3a405033775a4$var$repoManagerForceRestClient(forceRestClient) {
    $30d3a405033775a4$var$useRestClient = forceRestClient;
}
/**
 * Class representing a Firebase Realtime Database.
 */ class $30d3a405033775a4$export$6feb5ea51a7b0b47 {
    get _repo() {
        if (!this._instanceStarted) {
            $30d3a405033775a4$var$repoStart(this._repoInternal, this.app.options.appId, this.app.options["databaseAuthVariableOverride"]);
            this._instanceStarted = true;
        }
        return this._repoInternal;
    }
    get _root() {
        if (!this._rootInternal) this._rootInternal = new $30d3a405033775a4$export$35c3a5e7c9d1033c(this._repo, $30d3a405033775a4$var$newEmptyPath());
        return this._rootInternal;
    }
    _delete() {
        if (this._rootInternal !== null) {
            $30d3a405033775a4$var$repoManagerDeleteRepo(this._repo, this.app.name);
            this._repoInternal = null;
            this._rootInternal = null;
        }
        return Promise.resolve();
    }
    _checkNotDeleted(apiName) {
        if (this._rootInternal === null) $30d3a405033775a4$var$fatal("Cannot call " + apiName + " on a deleted database.");
    }
    /** @hideconstructor */ constructor(_repoInternal, /** The {@link @firebase/app#FirebaseApp} associated with this Realtime Database instance. */ app){
        this._repoInternal = _repoInternal;
        this.app = app;
        /** Represents a `Database` instance. */ this["type"] = "database";
        /** Track if the instance has been used (root or repo accessed) */ this._instanceStarted = false;
    }
}
function $30d3a405033775a4$var$checkTransportInit() {
    if ($30d3a405033775a4$var$TransportManager.IS_TRANSPORT_INITIALIZED) $30d3a405033775a4$var$warn("Transport has already been initialized. Please call this function before calling ref or setting up a listener");
}
/**
 * Force the use of websockets instead of longPolling.
 */ function $30d3a405033775a4$export$752b38c15a5377b6() {
    $30d3a405033775a4$var$checkTransportInit();
    $30d3a405033775a4$var$BrowserPollConnection.forceDisallow();
}
/**
 * Force the use of longPolling instead of websockets. This will be ignored if websocket protocol is used in databaseURL.
 */ function $30d3a405033775a4$export$387cff57f2608869() {
    $30d3a405033775a4$var$checkTransportInit();
    $30d3a405033775a4$var$WebSocketConnection.forceDisallow();
    $30d3a405033775a4$var$BrowserPollConnection.forceAllow();
}
/**
 * Returns the instance of the Realtime Database SDK that is associated
 * with the provided {@link @firebase/app#FirebaseApp}. Initializes a new instance with
 * with default settings if no instance exists or if the existing instance uses
 * a custom database URL.
 *
 * @param app - The {@link @firebase/app#FirebaseApp} instance that the returned Realtime
 * Database instance is associated with.
 * @param url - The URL of the Realtime Database instance to connect to. If not
 * provided, the SDK connects to the default instance of the Firebase App.
 * @returns The `Database` instance of the provided app.
 */ function $30d3a405033775a4$export$d0dd861204d0bf72(app = (0, $iXpG9.getApp)(), url) {
    return (0, $iXpG9._getProvider)(app, "database").getImmediate({
        identifier: url
    });
}
/**
 * Modify the provided instance to communicate with the Realtime Database
 * emulator.
 *
 * <p>Note: This method must be called before performing any other operation.
 *
 * @param db - The instance to modify.
 * @param host - The emulator host (ex: localhost)
 * @param port - The emulator port (ex: 8080)
 * @param options.mockUserToken - the mock auth token to use for unit testing Security Rules
 */ function $30d3a405033775a4$export$87f3cfc4a2e3958d(db, host, port, options = {}) {
    db = (0, $f43ebbd33d4c5d93$export$4befe9b5fa509a1b)(db);
    db._checkNotDeleted("useEmulator");
    if (db._instanceStarted) $30d3a405033775a4$var$fatal("Cannot call useEmulator() after instance has already been initialized.");
    const repo = db._repoInternal;
    let tokenProvider = undefined;
    if (repo.repoInfo_.nodeAdmin) {
        if (options.mockUserToken) $30d3a405033775a4$var$fatal('mockUserToken is not supported by the Admin SDK. For client access with mock users, please use the "firebase" package instead of "firebase-admin".');
        tokenProvider = new $30d3a405033775a4$var$EmulatorTokenProvider($30d3a405033775a4$var$EmulatorTokenProvider.OWNER);
    } else if (options.mockUserToken) {
        const token = typeof options.mockUserToken === "string" ? options.mockUserToken : (0, $f43ebbd33d4c5d93$export$367bf224123348f1)(options.mockUserToken, db.app.options.projectId);
        tokenProvider = new $30d3a405033775a4$var$EmulatorTokenProvider(token);
    }
    // Modify the repo to apply emulator settings
    $30d3a405033775a4$var$repoManagerApplyEmulatorSettings(repo, host, port, tokenProvider);
}
/**
 * Disconnects from the server (all Database operations will be completed
 * offline).
 *
 * The client automatically maintains a persistent connection to the Database
 * server, which will remain active indefinitely and reconnect when
 * disconnected. However, the `goOffline()` and `goOnline()` methods may be used
 * to control the client connection in cases where a persistent connection is
 * undesirable.
 *
 * While offline, the client will no longer receive data updates from the
 * Database. However, all Database operations performed locally will continue to
 * immediately fire events, allowing your application to continue behaving
 * normally. Additionally, each operation performed locally will automatically
 * be queued and retried upon reconnection to the Database server.
 *
 * To reconnect to the Database and begin receiving remote events, see
 * `goOnline()`.
 *
 * @param db - The instance to disconnect.
 */ function $30d3a405033775a4$export$bee838355d017f0a(db) {
    db = (0, $f43ebbd33d4c5d93$export$4befe9b5fa509a1b)(db);
    db._checkNotDeleted("goOffline");
    $30d3a405033775a4$var$repoInterrupt(db._repo);
}
/**
 * Reconnects to the server and synchronizes the offline Database state
 * with the server state.
 *
 * This method should be used after disabling the active connection with
 * `goOffline()`. Once reconnected, the client will transmit the proper data
 * and fire the appropriate events so that your client "catches up"
 * automatically.
 *
 * @param db - The instance to reconnect.
 */ function $30d3a405033775a4$export$e0eecaabee32dd(db) {
    db = (0, $f43ebbd33d4c5d93$export$4befe9b5fa509a1b)(db);
    db._checkNotDeleted("goOnline");
    $30d3a405033775a4$var$repoResume(db._repo);
}
function $30d3a405033775a4$export$4e1d237eb9e560af(logger, persistent) {
    $30d3a405033775a4$var$enableLogging$1(logger, persistent);
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $30d3a405033775a4$var$registerDatabase(variant) {
    $30d3a405033775a4$export$c9fb972242fcb3c4((0, $iXpG9.SDK_VERSION));
    (0, $iXpG9._registerComponent)(new (0, $f3262427d4ee348d$export$16fa2f45be04daa8)("database", (container, { instanceIdentifier: url })=>{
        const app = container.getProvider("app").getImmediate();
        const authProvider = container.getProvider("auth-internal");
        const appCheckProvider = container.getProvider("app-check-internal");
        return $30d3a405033775a4$export$a248c1d2ea757674(app, authProvider, appCheckProvider, url);
    }, "PUBLIC" /* PUBLIC */ ).setMultipleInstances(true));
    (0, $iXpG9.registerVersion)($30d3a405033775a4$var$name, $30d3a405033775a4$var$version, variant);
    // BUILD_TARGET will be replaced by values like esm5, esm2017, cjs5, etc during the compilation
    (0, $iXpG9.registerVersion)($30d3a405033775a4$var$name, $30d3a405033775a4$var$version, "esm2017");
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $30d3a405033775a4$var$SERVER_TIMESTAMP = {
    ".sv": "timestamp"
};
/**
 * Returns a placeholder value for auto-populating the current timestamp (time
 * since the Unix epoch, in milliseconds) as determined by the Firebase
 * servers.
 */ function $30d3a405033775a4$export$3ff8e7e00c3264b7() {
    return $30d3a405033775a4$var$SERVER_TIMESTAMP;
}
/**
 * Returns a placeholder value that can be used to atomically increment the
 * current database value by the provided delta.
 *
 * @param delta - the amount to modify the current value atomically.
 * @returns A placeholder value for modifying data atomically server-side.
 */ function $30d3a405033775a4$export$a2647aa13413c947(delta) {
    return {
        ".sv": {
            "increment": delta
        }
    };
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A type for the resolve value of {@link runTransaction}.
 */ class $30d3a405033775a4$export$7a6f238067628c6b {
    /** Returns a JSON-serializable representation of this object. */ toJSON() {
        return {
            committed: this.committed,
            snapshot: this.snapshot.toJSON()
        };
    }
    /** @hideconstructor */ constructor(/** Whether the transaction was successfully committed. */ committed, /** The resulting data snapshot. */ snapshot){
        this.committed = committed;
        this.snapshot = snapshot;
    }
}
/**
 * Atomically modifies the data at this location.
 *
 * Atomically modify the data at this location. Unlike a normal `set()`, which
 * just overwrites the data regardless of its previous value, `runTransaction()` is
 * used to modify the existing value to a new value, ensuring there are no
 * conflicts with other clients writing to the same location at the same time.
 *
 * To accomplish this, you pass `runTransaction()` an update function which is
 * used to transform the current value into a new value. If another client
 * writes to the location before your new value is successfully written, your
 * update function will be called again with the new current value, and the
 * write will be retried. This will happen repeatedly until your write succeeds
 * without conflict or you abort the transaction by not returning a value from
 * your update function.
 *
 * Note: Modifying data with `set()` will cancel any pending transactions at
 * that location, so extreme care should be taken if mixing `set()` and
 * `runTransaction()` to update the same data.
 *
 * Note: When using transactions with Security and Firebase Rules in place, be
 * aware that a client needs `.read` access in addition to `.write` access in
 * order to perform a transaction. This is because the client-side nature of
 * transactions requires the client to read the data in order to transactionally
 * update it.
 *
 * @param ref - The location to atomically modify.
 * @param transactionUpdate - A developer-supplied function which will be passed
 * the current data stored at this location (as a JavaScript object). The
 * function should return the new value it would like written (as a JavaScript
 * object). If `undefined` is returned (i.e. you return with no arguments) the
 * transaction will be aborted and the data at this location will not be
 * modified.
 * @param options - An options object to configure transactions.
 * @returns A `Promise` that can optionally be used instead of the `onComplete`
 * callback to handle success and failure.
 */ function $30d3a405033775a4$export$3c54e006bf9c93b7(ref, // eslint-disable-next-line @typescript-eslint/no-explicit-any
transactionUpdate, options) {
    var _a;
    ref = (0, $f43ebbd33d4c5d93$export$4befe9b5fa509a1b)(ref);
    $30d3a405033775a4$export$8d83036122ae444e("Reference.transaction", ref._path);
    if (ref.key === ".length" || ref.key === ".keys") throw "Reference.transaction failed: " + ref.key + " is a read-only object.";
    const applyLocally = (_a = options === null || options === void 0 ? void 0 : options.applyLocally) !== null && _a !== void 0 ? _a : true;
    const deferred = new (0, $f43ebbd33d4c5d93$export$85f6557964517f1a)();
    const promiseComplete = (error, committed, node)=>{
        let dataSnapshot = null;
        if (error) deferred.reject(error);
        else {
            dataSnapshot = new $30d3a405033775a4$export$80b98bcbc246c942(node, new $30d3a405033775a4$export$35c3a5e7c9d1033c(ref._repo, ref._path), $30d3a405033775a4$var$PRIORITY_INDEX);
            deferred.resolve(new $30d3a405033775a4$export$7a6f238067628c6b(committed, dataSnapshot));
        }
    };
    // Add a watch to make sure we get server updates.
    const unwatcher = $30d3a405033775a4$export$ad30f661f41f4d90(ref, ()=>{});
    $30d3a405033775a4$var$repoStartTransaction(ref._repo, ref._path, transactionUpdate, promiseComplete, unwatcher, applyLocally);
    return deferred.promise;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ $30d3a405033775a4$var$PersistentConnection;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
$30d3a405033775a4$var$PersistentConnection.prototype.simpleListen = function(pathString, onComplete) {
    this.sendRequest("q", {
        p: pathString
    }, onComplete);
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
$30d3a405033775a4$var$PersistentConnection.prototype.echo = function(data, onEcho) {
    this.sendRequest("echo", {
        d: data
    }, onEcho);
};
// RealTimeConnection properties that we use in tests.
$30d3a405033775a4$var$Connection;
/**
 * @internal
 */ const $30d3a405033775a4$export$3f9782a4529ff160 = function(newHash) {
    const oldPut = $30d3a405033775a4$var$PersistentConnection.prototype.put;
    $30d3a405033775a4$var$PersistentConnection.prototype.put = function(pathString, data, onComplete, hash) {
        if (hash !== undefined) hash = newHash();
        oldPut.call(this, pathString, data, onComplete, hash);
    };
    return function() {
        $30d3a405033775a4$var$PersistentConnection.prototype.put = oldPut;
    };
};
$30d3a405033775a4$var$RepoInfo;
/**
 * Forces the RepoManager to create Repos that use ReadonlyRestClient instead of PersistentConnection.
 * @internal
 */ const $30d3a405033775a4$export$868c9f20a76f0839 = function(forceRestClient) {
    $30d3a405033775a4$var$repoManagerForceRestClient(forceRestClient);
};
/**
 * Firebase Realtime Database
 *
 * @packageDocumentation
 */ $30d3a405033775a4$var$registerDatabase();






var $91ea4d37d0feb40e$exports = {};

$91ea4d37d0feb40e$exports = (parcelRequire("fF0r8")).getBundleURL("7lpHJ") + "check.d1f29035.svg";





const $934c2ed95a3e5a9d$export$3493b8991d49f558 = async (database, user, fullName)=>{
    var _user_providerData_, _user_providerData;
    const [firstName, lastName = ""] = (0, $9f66bc724b88f519$export$be63e0664592e141)(user).split(" ") || [];
    const givenName = (fullName === null || fullName === void 0 ? void 0 : fullName.firstName) || firstName;
    const familyName = (fullName === null || fullName === void 0 ? void 0 : fullName.lastName) || lastName;
    const email = user.email || ((_user_providerData = user.providerData) === null || _user_providerData === void 0 ? void 0 : (_user_providerData_ = _user_providerData[0]) === null || _user_providerData_ === void 0 ? void 0 : _user_providerData_.email);
    if (!email) throw new Error("No email provided");
    const snapshot = await (0, $30d3a405033775a4$export$3988ae62b71be9a3)((0, $30d3a405033775a4$export$f9574b70e1d95d9d)((0, $30d3a405033775a4$export$eff4d24c3ff7876e)(database), `users/${user.uid}`));
    if (snapshot.exists()) return;
    await (0, $30d3a405033775a4$export$adaa4cf7ef1b65be)((0, $30d3a405033775a4$export$eff4d24c3ff7876e)(database, "users/" + user.uid), {
        email: email,
        givenName: givenName,
        familyName: familyName,
        uid: user.uid,
        customerType: "payg",
        photoUrl: user.photoURL,
        name: `${givenName} ${familyName}`,
        timestamps: {
            createdAt: user.metadata.createdAt
        },
        joinDate: (0, $8a568d5cdba66624$export$2e2bcd8739ae039)(new Date(+user.metadata.createdAt), "yyyy/MM/dd")
    });
};



var $2cfeec8bacbc0da3$exports = {};

$2cfeec8bacbc0da3$exports = (parcelRequire("fF0r8")).getBundleURL("7lpHJ") + "apple_si.481ec491.png";


var $82af38e581079aa6$exports = {};

$82af38e581079aa6$exports = (parcelRequire("fF0r8")).getBundleURL("7lpHJ") + "google_si.0c9940fa.svg";


const $33234a48731835e8$var$Login = ({ loginUrl: loginUrl, onError: onError, onSuccess: onSuccess })=>{
    const { getFirebaseConfig: getFirebaseConfig } = (0, $a5a6fab2525fdce6$exports.Helpers);
    const [user, setUser] = (0, $b6HlZ.useState)(null);
    const [isLinkSent, setIsLinkSet] = (0, $b6HlZ.useState)(false);
    const queryParameters = new URLSearchParams(window.location.search);
    const oobCode = queryParameters.get("oobCode");
    const redirectUrl = queryParameters.get("redirectUrl");
    const { watch: watch, reset: reset, register: register, handleSubmit: handleSubmit, formState: { isDirty: isDirty } } = (0, $cyuoq.useForm)();
    const firebaseConfig = getFirebaseConfig({
        REACT_APP_FIREBASE_MESSAGE_SENDER_ID: "717114758534",
        REACT_APP_FIREBASE_APP_ID: "1:717114758534:web:c0f5a5118efc5855164807",
        REACT_APP_FIREBASE_API_KEY: "AIzaSyBoIeHTyO2Zr6jARvqrWPPAlqi3pdu2-KA",
        REACT_APP_FIREBASE_PROJECT_ID: "flexday-6dacf"
    });
    const app = (0, $iXpG9.initializeApp)(firebaseConfig);
    const auth = (0, $clAv2.n)(app);
    const database = (0, $30d3a405033775a4$export$d0dd861204d0bf72)(app);
    auth.onAuthStateChanged((user)=>{
        setUser(user);
    });
    (0, $b6HlZ.useEffect)(()=>{
        if (oobCode) onSignIn();
    }, []);
    const onSignIn = async ()=>{
        try {
            const emailLink = window.location.href;
            const { firstName: firstName = "", lastName: lastName = "", email: email } = JSON.parse(localStorage.getItem("userInfo"));
            const { user: user } = await (0, $clAv2.a9)(auth, email, emailLink);
            if (firstName || lastName) {
                await (0, $clAv2.af)(user, {
                    displayName: `${firstName} ${lastName}`.trim()
                });
                localStorage.removeItem("userInfo");
            }
            await (0, $934c2ed95a3e5a9d$export$3493b8991d49f558)(database, user, {
                firstName: firstName,
                lastName: lastName
            });
            window.history.pushState({}, "", emailLink.split("?")[0]);
            onSuccess(user, redirectUrl);
        } catch (error) {
            onError(error);
        }
    };
    const onSendLoginLink = async ({ email: email })=>{
        setIsLinkSet(false);
        const settings = {
            url: redirectUrl ? `${loginUrl}?redirectUrl=${redirectUrl}` : loginUrl,
            handleCodeInApp: true
        };
        try {
            const auth = (0, $clAv2.n)(app);
            localStorage.setItem("userInfo", JSON.stringify({
                email: email,
                firstName: "",
                lastName: ""
            }));
            await (0, $clAv2.a7)(auth, email, settings);
            reset({
                email: email
            });
            setIsLinkSet(true);
        } catch (error) {
            onError(error);
        }
    };
    const onSignInWithGoogle = async ()=>{
        try {
            const auth = (0, $clAv2.n)(app);
            const provider = new (0, $clAv2.Q)();
            const { user: user } = await (0, $clAv2.c)(auth, provider, (0, $clAv2.k));
            await (0, $934c2ed95a3e5a9d$export$3493b8991d49f558)(database, user);
            onSuccess(user, redirectUrl);
        } catch (error) {
            onError(error);
        }
    };
    const onSignInWithApple = async ()=>{
        try {
            const auth = (0, $clAv2.n)(app);
            const provider = new (0, $clAv2.U)("apple.com");
            const { user: user } = await (0, $clAv2.c)(auth, provider);
            await (0, $934c2ed95a3e5a9d$export$3493b8991d49f558)(database, user);
            onSuccess(user, redirectUrl);
        } catch (error) {
            onError(error);
        }
    };
    return /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsxs)("form", {
        className: "flex flex-col gap-6",
        onSubmit: handleSubmit(onSendLoginLink),
        children: [
            /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsxs)("div", {
                className: "relative max-w-sm",
                children: [
                    /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)((0, $8de9b6d6695a1edd$export$2e2bcd8739ae039), {
                        required: true,
                        name: "email",
                        type: "email",
                        className: "w-full",
                        placeholder: "Email",
                        register: register
                    }),
                    isLinkSent && /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)("img", {
                        alt: "success",
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($91ea4d37d0feb40e$exports))),
                        className: "absolute right-[-34px] top-2.5"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsxs)("div", {
                className: "flex flex-col justify-center gap-2 w-48",
                children: [
                    /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)((0, $b10e2d2452b40b3d$export$2e2bcd8739ae039), {
                        disabled: !watch("email") || !isDirty,
                        type: "submit",
                        title: "Login",
                        className: "h-14 font-bold bg-purple-400 hover:bg-purple-500 disabled:bg-purple-300 disabled:hover:bg-purple-300 disabled:cursor-not-allowed transition-colors duration-300 ease-in-out"
                    }),
                    /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)("p", {
                        className: "text-xs text-center italic text-black font-light",
                        children: "Send a link to email to login."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsxs)("div", {
                className: "flex flex-col gap-8 mt-10",
                children: [
                    /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)("p", {
                        children: "or sign in with:"
                    }),
                    /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsxs)("div", {
                        className: "flex flex-col sm:flex-row items-center gap-4",
                        children: [
                            /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)("button", {
                                type: "button",
                                children: /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($2cfeec8bacbc0da3$exports))),
                                    onClick: onSignInWithApple,
                                    className: "h-10"
                                })
                            }),
                            /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)("button", {
                                type: "button",
                                children: /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($82af38e581079aa6$exports))),
                                    onClick: onSignInWithGoogle,
                                    className: "h-10"
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $33234a48731835e8$export$2e2bcd8739ae039 = $33234a48731835e8$var$Login;




var $b6HlZ = parcelRequire("b6HlZ");
parcelRequire("ehmfL");
var $clAv2 = parcelRequire("clAv2");

var $cyuoq = parcelRequire("cyuoq");

var $iXpG9 = parcelRequire("iXpG9");






var $0672375741779ec4$exports = {};

$0672375741779ec4$exports = (parcelRequire("fF0r8")).getBundleURL("7lpHJ") + "apple_su.41cbc952.png";


var $e222666f1118d9b6$exports = {};

$e222666f1118d9b6$exports = (parcelRequire("fF0r8")).getBundleURL("7lpHJ") + "google_su.aeff0ed2.svg";


const $fee974a6341ad8f8$var$Signup = ({ onError: onError, onSuccess: onSuccess, createAccountUrl: createAccountUrl })=>{
    const { getFirebaseConfig: getFirebaseConfig } = (0, $a5a6fab2525fdce6$exports.Helpers);
    const [isLinkSent, setIsLinkSet] = (0, $b6HlZ.useState)(false);
    const [response, setResponse] = (0, $b6HlZ.useState)({
        message: "",
        color: ""
    });
    const queryParameters = new URLSearchParams(window.location.search);
    const redirectUrl = queryParameters.get("redirectUrl");
    const { watch: watch, reset: reset, register: register, handleSubmit: handleSubmit, formState: { isDirty: isDirty } } = (0, $cyuoq.useForm)();
    const firebaseConfig = getFirebaseConfig({
        REACT_APP_FIREBASE_MESSAGE_SENDER_ID: "717114758534",
        REACT_APP_FIREBASE_APP_ID: "1:717114758534:web:c0f5a5118efc5855164807",
        REACT_APP_FIREBASE_API_KEY: "AIzaSyBoIeHTyO2Zr6jARvqrWPPAlqi3pdu2-KA",
        REACT_APP_FIREBASE_PROJECT_ID: "flexday-6dacf"
    });
    const app = (0, $iXpG9.initializeApp)(firebaseConfig);
    const database = (0, $30d3a405033775a4$export$d0dd861204d0bf72)(app);
    const onCreateAccount = async ({ firstName: firstName, lastName: lastName, email: email })=>{
        setIsLinkSet(false);
        setResponse({
            message: "",
            color: ""
        });
        const settings = {
            url: redirectUrl ? `${createAccountUrl}?redirectUrl=${redirectUrl}` : createAccountUrl,
            handleCodeInApp: true
        };
        try {
            var _this;
            const auth = (0, $clAv2.n)(app);
            localStorage.setItem("userInfo", JSON.stringify({
                email: email,
                firstName: firstName,
                lastName: lastName
            }));
            const emailExists = !!((_this = await (0, $clAv2.aa)(auth, email)) === null || _this === void 0 ? void 0 : _this.length);
            if (emailExists) {
                setResponse({
                    color: "text-[#ff0000]",
                    message: "Email already exists."
                });
                return;
            }
            await (0, $clAv2.a7)(auth, email, settings);
            setResponse({
                color: "text-[#10b981]",
                message: "An email has been sent!"
            });
            reset({
                firstName: firstName,
                lastName: lastName,
                email: email
            });
            setIsLinkSet(true);
            onSuccess();
        } catch (error) {
            onError(error);
        }
    };
    const onSignUpWithGoogle = async ()=>{
        setResponse({
            message: "",
            color: ""
        });
        try {
            const auth = (0, $clAv2.n)(app);
            const provider = new (0, $clAv2.Q)();
            const { user: user } = await (0, $clAv2.c)(auth, provider, (0, $clAv2.k));
            await (0, $934c2ed95a3e5a9d$export$3493b8991d49f558)(database, user);
            onSuccess();
        } catch (error) {
            onError(error);
        }
    };
    const onSignUpWithApple = async ()=>{
        setResponse({
            message: "",
            color: ""
        });
        try {
            const auth = (0, $clAv2.n)(app);
            const provider = new (0, $clAv2.U)("apple.com");
            const { user: user } = await (0, $clAv2.c)(auth, provider);
            await (0, $934c2ed95a3e5a9d$export$3493b8991d49f558)(database, user);
            onSuccess();
        } catch (error) {
            onError(error);
        }
    };
    return /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsxs)("form", {
        className: "flex flex-col gap-3",
        onSubmit: handleSubmit(onCreateAccount),
        children: [
            /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)("p", {
                className: "mb-3 text-[26px] font-extrabold",
                children: "Create your account"
            }),
            /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)((0, $8de9b6d6695a1edd$export$2e2bcd8739ae039), {
                name: "firstName",
                register: register,
                placeholder: "First Name",
                className: "w-full max-w-sm"
            }),
            /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)((0, $8de9b6d6695a1edd$export$2e2bcd8739ae039), {
                name: "lastName",
                register: register,
                placeholder: "Last Name",
                className: "w-full max-w-sm"
            }),
            /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsxs)("div", {
                className: "relative max-w-sm",
                children: [
                    /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)((0, $8de9b6d6695a1edd$export$2e2bcd8739ae039), {
                        required: true,
                        name: "email",
                        type: "email",
                        className: "w-full",
                        placeholder: "Email",
                        register: register
                    }),
                    isLinkSent && /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)("img", {
                        alt: "success",
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($91ea4d37d0feb40e$exports))),
                        className: "absolute right-[-34px] top-2.5"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsxs)("div", {
                className: "relative flex flex-col justify-center gap-2 w-48 pb-5",
                children: [
                    /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)((0, $b10e2d2452b40b3d$export$2e2bcd8739ae039), {
                        type: "submit",
                        title: "Create Account",
                        disabled: !watch("email") || !isDirty,
                        className: "h-14 font-bold bg-purple-400 hover:bg-purple-500 disabled:bg-purple-300 disabled:hover:bg-purple-300 disabled:cursor-not-allowed transition-colors duration-300 ease-in-out"
                    }),
                    /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)("p", {
                        className: "text-xs text-center italic text-black font-light",
                        children: "Sends an email confirmation link."
                    }),
                    /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)("p", {
                        className: `absolute bottom-0 text-sm font-medium ${response.color}`,
                        children: response.message
                    })
                ]
            }),
            /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsxs)("div", {
                className: "flex flex-col gap-8 mt-10",
                children: [
                    /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)("p", {
                        children: "or create an account with:"
                    }),
                    /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsxs)("div", {
                        className: "flex flex-col sm:flex-row items-center gap-4",
                        children: [
                            /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)("button", {
                                type: "button",
                                children: /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($0672375741779ec4$exports))),
                                    onClick: onSignUpWithApple,
                                    className: "h-10"
                                })
                            }),
                            /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)("button", {
                                type: "button",
                                children: /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($e222666f1118d9b6$exports))),
                                    onClick: onSignUpWithGoogle,
                                    className: "h-10"
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $fee974a6341ad8f8$export$2e2bcd8739ae039 = $fee974a6341ad8f8$var$Signup;




var $b6HlZ = parcelRequire("b6HlZ");

parcelRequire("8vofH");
var $7TObl = parcelRequire("7TObl");

parcelRequire("ehmfL");
var $clAv2 = parcelRequire("clAv2");

var $iXpG9 = parcelRequire("iXpG9");

var $iXpG9 = parcelRequire("iXpG9");
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Firebase constants.  Some of these (@defines) can be overridden at compile-time.
 */ const $f84e8187c6005769$export$588c7fdda06fbb0a = {
    /**
     * @define {boolean} Whether this is the client Node.js SDK.
     */ NODE_CLIENT: false,
    /**
     * @define {boolean} Whether this is the Admin Node.js SDK.
     */ NODE_ADMIN: false,
    /**
     * Firebase SDK Version
     */ SDK_VERSION: "${JSCORE_VERSION}"
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Throws an error if the provided assertion is falsy
 */ const $f84e8187c6005769$export$a7a9523472993e97 = function(assertion, message) {
    if (!assertion) throw $f84e8187c6005769$export$a39cad550e7ab28a(message);
};
/**
 * Returns an Error object suitable for throwing.
 */ const $f84e8187c6005769$export$a39cad550e7ab28a = function(message) {
    return new Error("Firebase Database (" + $f84e8187c6005769$export$588c7fdda06fbb0a.SDK_VERSION + ") INTERNAL ASSERT FAILED: " + message);
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $f84e8187c6005769$var$stringToByteArray$1 = function(str) {
    // TODO(user): Use native implementations if/when available
    const out = [];
    let p = 0;
    for(let i = 0; i < str.length; i++){
        let c = str.charCodeAt(i);
        if (c < 128) out[p++] = c;
        else if (c < 2048) {
            out[p++] = c >> 6 | 192;
            out[p++] = c & 63 | 128;
        } else if ((c & 0xfc00) === 0xd800 && i + 1 < str.length && (str.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
            // Surrogate Pair
            c = 0x10000 + ((c & 0x03ff) << 10) + (str.charCodeAt(++i) & 0x03ff);
            out[p++] = c >> 18 | 240;
            out[p++] = c >> 12 & 63 | 128;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        } else {
            out[p++] = c >> 12 | 224;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        }
    }
    return out;
};
/**
 * Turns an array of numbers into the string given by the concatenation of the
 * characters to which the numbers correspond.
 * @param bytes Array of numbers representing characters.
 * @return Stringification of the array.
 */ const $f84e8187c6005769$var$byteArrayToString = function(bytes) {
    // TODO(user): Use native implementations if/when available
    const out = [];
    let pos = 0, c = 0;
    while(pos < bytes.length){
        const c1 = bytes[pos++];
        if (c1 < 128) out[c++] = String.fromCharCode(c1);
        else if (c1 > 191 && c1 < 224) {
            const c2 = bytes[pos++];
            out[c++] = String.fromCharCode((c1 & 31) << 6 | c2 & 63);
        } else if (c1 > 239 && c1 < 365) {
            // Surrogate Pair
            const c2 = bytes[pos++];
            const c3 = bytes[pos++];
            const c4 = bytes[pos++];
            const u = ((c1 & 7) << 18 | (c2 & 63) << 12 | (c3 & 63) << 6 | c4 & 63) - 0x10000;
            out[c++] = String.fromCharCode(0xd800 + (u >> 10));
            out[c++] = String.fromCharCode(0xdc00 + (u & 1023));
        } else {
            const c2 = bytes[pos++];
            const c3 = bytes[pos++];
            out[c++] = String.fromCharCode((c1 & 15) << 12 | (c2 & 63) << 6 | c3 & 63);
        }
    }
    return out.join("");
};
// We define it as an object literal instead of a class because a class compiled down to es5 can't
// be treeshaked. https://github.com/rollup/rollup/issues/1691
// Static lookup maps, lazily populated by init_()
const $f84e8187c6005769$export$b3b2de96497acc47 = {
    /**
     * Maps bytes to characters.
     */ byteToCharMap_: null,
    /**
     * Maps characters to bytes.
     */ charToByteMap_: null,
    /**
     * Maps bytes to websafe characters.
     * @private
     */ byteToCharMapWebSafe_: null,
    /**
     * Maps websafe characters to bytes.
     * @private
     */ charToByteMapWebSafe_: null,
    /**
     * Our default alphabet, shared between
     * ENCODED_VALS and ENCODED_VALS_WEBSAFE
     */ ENCODED_VALS_BASE: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789",
    /**
     * Our default alphabet. Value 64 (=) is special; it means "nothing."
     */ get ENCODED_VALS () {
        return this.ENCODED_VALS_BASE + "+/=";
    },
    /**
     * Our websafe alphabet.
     */ get ENCODED_VALS_WEBSAFE () {
        return this.ENCODED_VALS_BASE + "-_.";
    },
    /**
     * Whether this browser supports the atob and btoa functions. This extension
     * started at Mozilla but is now implemented by many browsers. We use the
     * ASSUME_* variables to avoid pulling in the full useragent detection library
     * but still allowing the standard per-browser compilations.
     *
     */ HAS_NATIVE_SUPPORT: typeof atob === "function",
    /**
     * Base64-encode an array of bytes.
     *
     * @param input An array of bytes (numbers with
     *     value in [0, 255]) to encode.
     * @param webSafe Boolean indicating we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */ encodeByteArray (input, webSafe) {
        if (!Array.isArray(input)) throw Error("encodeByteArray takes an array as a parameter");
        this.init_();
        const byteToCharMap = webSafe ? this.byteToCharMapWebSafe_ : this.byteToCharMap_;
        const output = [];
        for(let i = 0; i < input.length; i += 3){
            const byte1 = input[i];
            const haveByte2 = i + 1 < input.length;
            const byte2 = haveByte2 ? input[i + 1] : 0;
            const haveByte3 = i + 2 < input.length;
            const byte3 = haveByte3 ? input[i + 2] : 0;
            const outByte1 = byte1 >> 2;
            const outByte2 = (byte1 & 0x03) << 4 | byte2 >> 4;
            let outByte3 = (byte2 & 0x0f) << 2 | byte3 >> 6;
            let outByte4 = byte3 & 0x3f;
            if (!haveByte3) {
                outByte4 = 64;
                if (!haveByte2) outByte3 = 64;
            }
            output.push(byteToCharMap[outByte1], byteToCharMap[outByte2], byteToCharMap[outByte3], byteToCharMap[outByte4]);
        }
        return output.join("");
    },
    /**
     * Base64-encode a string.
     *
     * @param input A string to encode.
     * @param webSafe If true, we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */ encodeString (input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) return btoa(input);
        return this.encodeByteArray($f84e8187c6005769$var$stringToByteArray$1(input), webSafe);
    },
    /**
     * Base64-decode a string.
     *
     * @param input to decode.
     * @param webSafe True if we should use the
     *     alternative alphabet.
     * @return string representing the decoded value.
     */ decodeString (input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) return atob(input);
        return $f84e8187c6005769$var$byteArrayToString(this.decodeStringToByteArray(input, webSafe));
    },
    /**
     * Base64-decode a string.
     *
     * In base-64 decoding, groups of four characters are converted into three
     * bytes.  If the encoder did not apply padding, the input length may not
     * be a multiple of 4.
     *
     * In this case, the last group will have fewer than 4 characters, and
     * padding will be inferred.  If the group has one or two characters, it decodes
     * to one byte.  If the group has three characters, it decodes to two bytes.
     *
     * @param input Input to decode.
     * @param webSafe True if we should use the web-safe alphabet.
     * @return bytes representing the decoded value.
     */ decodeStringToByteArray (input, webSafe) {
        this.init_();
        const charToByteMap = webSafe ? this.charToByteMapWebSafe_ : this.charToByteMap_;
        const output = [];
        for(let i = 0; i < input.length;){
            const byte1 = charToByteMap[input.charAt(i++)];
            const haveByte2 = i < input.length;
            const byte2 = haveByte2 ? charToByteMap[input.charAt(i)] : 0;
            ++i;
            const haveByte3 = i < input.length;
            const byte3 = haveByte3 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            const haveByte4 = i < input.length;
            const byte4 = haveByte4 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            if (byte1 == null || byte2 == null || byte3 == null || byte4 == null) throw Error();
            const outByte1 = byte1 << 2 | byte2 >> 4;
            output.push(outByte1);
            if (byte3 !== 64) {
                const outByte2 = byte2 << 4 & 0xf0 | byte3 >> 2;
                output.push(outByte2);
                if (byte4 !== 64) {
                    const outByte3 = byte3 << 6 & 0xc0 | byte4;
                    output.push(outByte3);
                }
            }
        }
        return output;
    },
    /**
     * Lazy static initialization function. Called before
     * accessing any of the static map variables.
     * @private
     */ init_ () {
        if (!this.byteToCharMap_) {
            this.byteToCharMap_ = {};
            this.charToByteMap_ = {};
            this.byteToCharMapWebSafe_ = {};
            this.charToByteMapWebSafe_ = {};
            // We want quick mappings back and forth, so we precompute two maps.
            for(let i = 0; i < this.ENCODED_VALS.length; i++){
                this.byteToCharMap_[i] = this.ENCODED_VALS.charAt(i);
                this.charToByteMap_[this.byteToCharMap_[i]] = i;
                this.byteToCharMapWebSafe_[i] = this.ENCODED_VALS_WEBSAFE.charAt(i);
                this.charToByteMapWebSafe_[this.byteToCharMapWebSafe_[i]] = i;
                // Be forgiving when decoding and correctly decode both encodings.
                if (i >= this.ENCODED_VALS_BASE.length) {
                    this.charToByteMap_[this.ENCODED_VALS_WEBSAFE.charAt(i)] = i;
                    this.charToByteMapWebSafe_[this.ENCODED_VALS.charAt(i)] = i;
                }
            }
        }
    }
};
/**
 * URL-safe base64 encoding
 */ const $f84e8187c6005769$export$e510a73ee562749 = function(str) {
    const utf8Bytes = $f84e8187c6005769$var$stringToByteArray$1(str);
    return $f84e8187c6005769$export$b3b2de96497acc47.encodeByteArray(utf8Bytes, true);
};
/**
 * URL-safe base64 encoding (without "." padding in the end).
 * e.g. Used in JSON Web Token (JWT) parts.
 */ const $f84e8187c6005769$export$4b5284a3025a455 = function(str) {
    // Use base64url encoding and remove padding in the end (dot characters).
    return $f84e8187c6005769$export$e510a73ee562749(str).replace(/\./g, "");
};
/**
 * URL-safe base64 decoding
 *
 * NOTE: DO NOT use the global atob() function - it does NOT support the
 * base64Url variant encoding.
 *
 * @param str To be decoded
 * @return Decoded result, if possible
 */ const $f84e8187c6005769$export$c62426fdd000a97e = function(str) {
    try {
        return $f84e8187c6005769$export$b3b2de96497acc47.decodeString(str, true);
    } catch (e) {
        console.error("base64Decode failed: ", e);
    }
    return null;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Do a deep-copy of basic JavaScript Objects or Arrays.
 */ function $f84e8187c6005769$export$6c40052bed430212(value) {
    return $f84e8187c6005769$export$54e9fb29908872fa(undefined, value);
}
/**
 * Copy properties from source to target (recursively allows extension
 * of Objects and Arrays).  Scalar values in the target are over-written.
 * If target is undefined, an object of the appropriate type will be created
 * (and returned).
 *
 * We recursively copy all child properties of plain Objects in the source- so
 * that namespace- like dictionaries are merged.
 *
 * Note that the target can be a function, in which case the properties in
 * the source Object are copied onto it as static properties of the Function.
 *
 * Note: we don't merge __proto__ to prevent prototype pollution
 */ function $f84e8187c6005769$export$54e9fb29908872fa(target, source) {
    if (!(source instanceof Object)) return source;
    switch(source.constructor){
        case Date:
            // Treat Dates like scalars; if the target date object had any child
            // properties - they will be lost!
            const dateValue = source;
            return new Date(dateValue.getTime());
        case Object:
            if (target === undefined) target = {};
            break;
        case Array:
            // Always copy the array source and overwrite the target.
            target = [];
            break;
        default:
            // Not a plain Object - treat it as a scalar.
            return source;
    }
    for(const prop in source){
        // use isValidKey to guard against prototype pollution. See https://snyk.io/vuln/SNYK-JS-LODASH-450202
        if (!source.hasOwnProperty(prop) || !$f84e8187c6005769$var$isValidKey(prop)) continue;
        target[prop] = $f84e8187c6005769$export$54e9fb29908872fa(target[prop], source[prop]);
    }
    return target;
}
function $f84e8187c6005769$var$isValidKey(key) {
    return key !== "__proto__";
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $f84e8187c6005769$export$85f6557964517f1a {
    /**
     * Our API internals are not promiseified and cannot because our callback APIs have subtle expectations around
     * invoking promises inline, which Promises are forbidden to do. This method accepts an optional node-style callback
     * and returns a node-style callback which will resolve or reject the Deferred's promise.
     */ wrapCallback(callback) {
        return (error, value)=>{
            if (error) this.reject(error);
            else this.resolve(value);
            if (typeof callback === "function") {
                // Attaching noop handler just in case developer wasn't expecting
                // promises
                this.promise.catch(()=>{});
                // Some of our callbacks don't expect a value and our own tests
                // assert that the parameter length is 1
                if (callback.length === 1) callback(error);
                else callback(error, value);
            }
        };
    }
    constructor(){
        this.reject = ()=>{};
        this.resolve = ()=>{};
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
    }
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $f84e8187c6005769$export$367bf224123348f1(token, projectId) {
    if (token.uid) throw new Error('The "uid" field is no longer supported by mockUserToken. Please use "sub" instead for Firebase Auth User ID.');
    // Unsecured JWTs use "none" as the algorithm.
    const header = {
        alg: "none",
        type: "JWT"
    };
    const project = projectId || "demo-project";
    const iat = token.iat || 0;
    const sub = token.sub || token.user_id;
    if (!sub) throw new Error("mockUserToken must contain 'sub' or 'user_id' field!");
    const payload = Object.assign({
        // Set all required fields to decent defaults
        iss: `https://securetoken.google.com/${project}`,
        aud: project,
        iat: iat,
        exp: iat + 3600,
        auth_time: iat,
        sub: sub,
        user_id: sub,
        firebase: {
            sign_in_provider: "custom",
            identities: {}
        }
    }, token);
    // Unsecured JWTs use the empty string as a signature.
    const signature = "";
    return [
        $f84e8187c6005769$export$4b5284a3025a455(JSON.stringify(header)),
        $f84e8187c6005769$export$4b5284a3025a455(JSON.stringify(payload)),
        signature
    ].join(".");
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns navigator.userAgent string or '' if it's not defined.
 * @return user agent string
 */ function $f84e8187c6005769$export$c36915b22ce77c19() {
    if (typeof navigator !== "undefined" && typeof navigator["userAgent"] === "string") return navigator["userAgent"];
    else return "";
}
/**
 * Detect Cordova / PhoneGap / Ionic frameworks on a mobile device.
 *
 * Deliberately does not rely on checking `file://` URLs (as this fails PhoneGap
 * in the Ripple emulator) nor Cordova `onDeviceReady`, which would normally
 * wait for a callback.
 */ function $f84e8187c6005769$export$872f8323f01d7ae0() {
    return typeof window !== "undefined" && // @ts-ignore Setting up an broadly applicable index signature for Window
    // just to deal with this case would probably be a bad idea.
    !!(window["cordova"] || window["phonegap"] || window["PhoneGap"]) && /ios|iphone|ipod|ipad|android|blackberry|iemobile/i.test($f84e8187c6005769$export$c36915b22ce77c19());
}
/**
 * Detect Node.js.
 *
 * @return true if Node.js environment is detected.
 */ // Node detection logic from: https://github.com/iliakan/detect-node/
function $f84e8187c6005769$export$8ee0fc9ee280b4ee() {
    try {
        return Object.prototype.toString.call($parcel$global.process) === "[object process]";
    } catch (e) {
        return false;
    }
}
/**
 * Detect Browser Environment
 */ function $f84e8187c6005769$export$4e09c449d6c407f7() {
    return typeof self === "object" && self.self === self;
}
function $f84e8187c6005769$export$caa8774a9107a58e() {
    const runtime = typeof chrome === "object" ? chrome.runtime : typeof browser === "object" ? browser.runtime : undefined;
    return typeof runtime === "object" && runtime.id !== undefined;
}
/**
 * Detect React Native.
 *
 * @return true if ReactNative environment is detected.
 */ function $f84e8187c6005769$export$f7a1e23e542d38e3() {
    return typeof navigator === "object" && navigator["product"] === "ReactNative";
}
/** Detects Electron apps. */ function $f84e8187c6005769$export$f2f6a8999f8ebd30() {
    return $f84e8187c6005769$export$c36915b22ce77c19().indexOf("Electron/") >= 0;
}
/** Detects Internet Explorer. */ function $f84e8187c6005769$export$7e7b1a9668aaed8() {
    const ua = $f84e8187c6005769$export$c36915b22ce77c19();
    return ua.indexOf("MSIE ") >= 0 || ua.indexOf("Trident/") >= 0;
}
/** Detects Universal Windows Platform apps. */ function $f84e8187c6005769$export$202944b2d2824246() {
    return $f84e8187c6005769$export$c36915b22ce77c19().indexOf("MSAppHost/") >= 0;
}
/**
 * Detect whether the current SDK build is the Node version.
 *
 * @return true if it's the Node SDK build.
 */ function $f84e8187c6005769$export$5d1d834fbbf8bab7() {
    return $f84e8187c6005769$export$588c7fdda06fbb0a.NODE_CLIENT === true || $f84e8187c6005769$export$588c7fdda06fbb0a.NODE_ADMIN === true;
}
/** Returns true if we are running in Safari. */ function $f84e8187c6005769$export$95df08bae54cb4df() {
    return !$f84e8187c6005769$export$8ee0fc9ee280b4ee() && navigator.userAgent.includes("Safari") && !navigator.userAgent.includes("Chrome");
}
/**
 * This method checks if indexedDB is supported by current browser/service worker context
 * @return true if indexedDB is supported by current browser/service worker context
 */ function $f84e8187c6005769$export$3865db50535c2055() {
    return typeof indexedDB === "object";
}
/**
 * This method validates browser/sw context for indexedDB by opening a dummy indexedDB database and reject
 * if errors occur during the database open operation.
 *
 * @throws exception if current browser/sw context can't run idb.open (ex: Safari iframe, Firefox
 * private browsing)
 */ function $f84e8187c6005769$export$a8a3018f3d187a4d() {
    return new Promise((resolve, reject)=>{
        try {
            let preExist = true;
            const DB_CHECK_NAME = "validate-browser-context-for-indexeddb-analytics-module";
            const request = self.indexedDB.open(DB_CHECK_NAME);
            request.onsuccess = ()=>{
                request.result.close();
                // delete database only when it doesn't pre-exist
                if (!preExist) self.indexedDB.deleteDatabase(DB_CHECK_NAME);
                resolve(true);
            };
            request.onupgradeneeded = ()=>{
                preExist = false;
            };
            request.onerror = ()=>{
                var _a;
                reject(((_a = request.error) === null || _a === void 0 ? void 0 : _a.message) || "");
            };
        } catch (error) {
            reject(error);
        }
    });
}
/**
 *
 * This method checks whether cookie is enabled within current browser
 * @return true if cookie is enabled within current browser
 */ function $f84e8187c6005769$export$f172b7eb6cf60599() {
    if (typeof navigator === "undefined" || !navigator.cookieEnabled) return false;
    return true;
}
/**
 * Polyfill for `globalThis` object.
 * @returns the `globalThis` object for the given environment.
 */ function $f84e8187c6005769$export$a4e55266d2135a7f() {
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw new Error("Unable to locate global object.");
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Standardized Firebase Error.
 *
 * Usage:
 *
 *   // Typescript string literals for type-safe codes
 *   type Err =
 *     'unknown' |
 *     'object-not-found'
 *     ;
 *
 *   // Closure enum for type-safe error codes
 *   // at-enum {string}
 *   var Err = {
 *     UNKNOWN: 'unknown',
 *     OBJECT_NOT_FOUND: 'object-not-found',
 *   }
 *
 *   let errors: Map<Err, string> = {
 *     'generic-error': "Unknown error",
 *     'file-not-found': "Could not find file: {$file}",
 *   };
 *
 *   // Type-safe function - must pass a valid error code as param.
 *   let error = new ErrorFactory<Err>('service', 'Service', errors);
 *
 *   ...
 *   throw error.create(Err.GENERIC);
 *   ...
 *   throw error.create(Err.FILE_NOT_FOUND, {'file': fileName});
 *   ...
 *   // Service: Could not file file: foo.txt (service/file-not-found).
 *
 *   catch (e) {
 *     assert(e.message === "Could not find file: foo.txt.");
 *     if (e.code === 'service/file-not-found') {
 *       console.log("Could not read file: " + e['file']);
 *     }
 *   }
 */ const $f84e8187c6005769$var$ERROR_NAME = "FirebaseError";
// Based on code from:
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Custom_Error_Types
class $f84e8187c6005769$export$dd24e9cd51226c56 extends Error {
    constructor(/** The error code for this error. */ code, message, /** Custom data for this error. */ customData){
        super(message);
        this.code = code;
        this.customData = customData;
        /** The custom name for all FirebaseErrors. */ this.name = $f84e8187c6005769$var$ERROR_NAME;
        // Fix For ES5
        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $f84e8187c6005769$export$dd24e9cd51226c56.prototype);
        // Maintains proper stack trace for where our error was thrown.
        // Only available on V8.
        if (Error.captureStackTrace) Error.captureStackTrace(this, $f84e8187c6005769$export$3fa6e1b18a3b2d40.prototype.create);
    }
}
class $f84e8187c6005769$export$3fa6e1b18a3b2d40 {
    create(code, ...data) {
        const customData = data[0] || {};
        const fullCode = `${this.service}/${code}`;
        const template = this.errors[code];
        const message = template ? $f84e8187c6005769$var$replaceTemplate(template, customData) : "Error";
        // Service Name: Error message (service/code).
        const fullMessage = `${this.serviceName}: ${message} (${fullCode}).`;
        const error = new $f84e8187c6005769$export$dd24e9cd51226c56(fullCode, fullMessage, customData);
        return error;
    }
    constructor(service, serviceName, errors){
        this.service = service;
        this.serviceName = serviceName;
        this.errors = errors;
    }
}
function $f84e8187c6005769$var$replaceTemplate(template, data) {
    return template.replace($f84e8187c6005769$var$PATTERN, (_, key)=>{
        const value = data[key];
        return value != null ? String(value) : `<${key}?>`;
    });
}
const $f84e8187c6005769$var$PATTERN = /\{\$([^}]+)}/g;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Evaluates a JSON string into a javascript object.
 *
 * @param {string} str A string containing JSON.
 * @return {*} The javascript object representing the specified JSON.
 */ function $f84e8187c6005769$export$c5a53ce6a17cf18d(str) {
    return JSON.parse(str);
}
/**
 * Returns JSON representing a javascript object.
 * @param {*} data Javascript object to be stringified.
 * @return {string} The JSON contents of the object.
 */ function $f84e8187c6005769$export$fac44ee5b035f737(data) {
    return JSON.stringify(data);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Decodes a Firebase auth. token into constituent parts.
 *
 * Notes:
 * - May return with invalid / incomplete claims if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $f84e8187c6005769$export$2f872c0f2117be69 = function(token) {
    let header = {}, claims = {}, data = {}, signature = "";
    try {
        const parts = token.split(".");
        header = $f84e8187c6005769$export$c5a53ce6a17cf18d($f84e8187c6005769$export$c62426fdd000a97e(parts[0]) || "");
        claims = $f84e8187c6005769$export$c5a53ce6a17cf18d($f84e8187c6005769$export$c62426fdd000a97e(parts[1]) || "");
        signature = parts[2];
        data = claims["d"] || {};
        delete claims["d"];
    } catch (e) {}
    return {
        header: header,
        claims: claims,
        data: data,
        signature: signature
    };
};
/**
 * Decodes a Firebase auth. token and checks the validity of its time-based claims. Will return true if the
 * token is within the time window authorized by the 'nbf' (not-before) and 'iat' (issued-at) claims.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $f84e8187c6005769$export$5f870fcca7ae6a88 = function(token) {
    const claims = $f84e8187c6005769$export$2f872c0f2117be69(token).claims;
    const now = Math.floor(new Date().getTime() / 1000);
    let validSince = 0, validUntil = 0;
    if (typeof claims === "object") {
        if (claims.hasOwnProperty("nbf")) validSince = claims["nbf"];
        else if (claims.hasOwnProperty("iat")) validSince = claims["iat"];
        if (claims.hasOwnProperty("exp")) validUntil = claims["exp"];
        else // token will expire after 24h by default
        validUntil = validSince + 86400;
    }
    return !!now && !!validSince && !!validUntil && now >= validSince && now <= validUntil;
};
/**
 * Decodes a Firebase auth. token and returns its issued at time if valid, null otherwise.
 *
 * Notes:
 * - May return null if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $f84e8187c6005769$export$701c661ec91095f2 = function(token) {
    const claims = $f84e8187c6005769$export$2f872c0f2117be69(token).claims;
    if (typeof claims === "object" && claims.hasOwnProperty("iat")) return claims["iat"];
    return null;
};
/**
 * Decodes a Firebase auth. token and checks the validity of its format. Expects a valid issued-at time.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $f84e8187c6005769$export$9565ca3d387f8aa0 = function(token) {
    const decoded = $f84e8187c6005769$export$2f872c0f2117be69(token), claims = decoded.claims;
    return !!claims && typeof claims === "object" && claims.hasOwnProperty("iat");
};
/**
 * Attempts to peer into an auth token and determine if it's an admin auth token by looking at the claims portion.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $f84e8187c6005769$export$fc970ed23da99565 = function(token) {
    const claims = $f84e8187c6005769$export$2f872c0f2117be69(token).claims;
    return typeof claims === "object" && claims["admin"] === true;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $f84e8187c6005769$export$2344b14b097df817(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
}
function $f84e8187c6005769$export$e51ae4db7b428f67(obj, key) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) return obj[key];
    else return undefined;
}
function $f84e8187c6005769$export$dd1bc94b04021eeb(obj) {
    for(const key in obj){
        if (Object.prototype.hasOwnProperty.call(obj, key)) return false;
    }
    return true;
}
function $f84e8187c6005769$export$871de8747c9eaa88(obj, fn, contextObj) {
    const res = {};
    for(const key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) res[key] = fn.call(contextObj, obj[key], key, obj);
    return res;
}
/**
 * Deep equal two objects. Support Arrays and Objects.
 */ function $f84e8187c6005769$export$9cb4719e2e525b7a(a, b) {
    if (a === b) return true;
    const aKeys = Object.keys(a);
    const bKeys = Object.keys(b);
    for (const k of aKeys){
        if (!bKeys.includes(k)) return false;
        const aProp = a[k];
        const bProp = b[k];
        if ($f84e8187c6005769$var$isObject(aProp) && $f84e8187c6005769$var$isObject(bProp)) {
            if (!$f84e8187c6005769$export$9cb4719e2e525b7a(aProp, bProp)) return false;
        } else if (aProp !== bProp) return false;
    }
    for (const k of bKeys){
        if (!aKeys.includes(k)) return false;
    }
    return true;
}
function $f84e8187c6005769$var$isObject(thing) {
    return thing !== null && typeof thing === "object";
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a querystring-formatted string (e.g. &arg=val&arg2=val2) from a
 * params object (e.g. {arg: 'val', arg2: 'val2'})
 * Note: You must prepend it with ? when adding it to a URL.
 */ function $f84e8187c6005769$export$ac4103b836844853(querystringParams) {
    const params = [];
    for (const [key, value] of Object.entries(querystringParams))if (Array.isArray(value)) value.forEach((arrayVal)=>{
        params.push(encodeURIComponent(key) + "=" + encodeURIComponent(arrayVal));
    });
    else params.push(encodeURIComponent(key) + "=" + encodeURIComponent(value));
    return params.length ? "&" + params.join("&") : "";
}
/**
 * Decodes a querystring (e.g. ?arg=val&arg2=val2) into a params object
 * (e.g. {arg: 'val', arg2: 'val2'})
 */ function $f84e8187c6005769$export$c1271ca4c8a70741(querystring) {
    const obj = {};
    const tokens = querystring.replace(/^\?/, "").split("&");
    tokens.forEach((token)=>{
        if (token) {
            const [key, value] = token.split("=");
            obj[decodeURIComponent(key)] = decodeURIComponent(value);
        }
    });
    return obj;
}
/**
 * Extract the query string part of a URL, including the leading question mark (if present).
 */ function $f84e8187c6005769$export$1a8408415472d8ed(url) {
    const queryStart = url.indexOf("?");
    if (!queryStart) return "";
    const fragmentStart = url.indexOf("#", queryStart);
    return url.substring(queryStart, fragmentStart > 0 ? fragmentStart : undefined);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview SHA-1 cryptographic hash.
 * Variable names follow the notation in FIPS PUB 180-3:
 * http://csrc.nist.gov/publications/fips/fips180-3/fips180-3_final.pdf.
 *
 * Usage:
 *   var sha1 = new sha1();
 *   sha1.update(bytes);
 *   var hash = sha1.digest();
 *
 * Performance:
 *   Chrome 23:   ~400 Mbit/s
 *   Firefox 16:  ~250 Mbit/s
 *
 */ /**
 * SHA-1 cryptographic hash constructor.
 *
 * The properties declared here are discussed in the above algorithm document.
 * @constructor
 * @final
 * @struct
 */ class $f84e8187c6005769$export$c85d589bf4e25fef {
    reset() {
        this.chain_[0] = 0x67452301;
        this.chain_[1] = 0xefcdab89;
        this.chain_[2] = 0x98badcfe;
        this.chain_[3] = 0x10325476;
        this.chain_[4] = 0xc3d2e1f0;
        this.inbuf_ = 0;
        this.total_ = 0;
    }
    /**
     * Internal compress helper function.
     * @param buf Block to compress.
     * @param offset Offset of the block in the buffer.
     * @private
     */ compress_(buf, offset) {
        if (!offset) offset = 0;
        const W = this.W_;
        // get 16 big endian words
        if (typeof buf === "string") for(let i = 0; i < 16; i++){
            // TODO(user): [bug 8140122] Recent versions of Safari for Mac OS and iOS
            // have a bug that turns the post-increment ++ operator into pre-increment
            // during JIT compilation.  We have code that depends heavily on SHA-1 for
            // correctness and which is affected by this bug, so I've removed all uses
            // of post-increment ++ in which the result value is used.  We can revert
            // this change once the Safari bug
            // (https://bugs.webkit.org/show_bug.cgi?id=109036) has been fixed and
            // most clients have been updated.
            W[i] = buf.charCodeAt(offset) << 24 | buf.charCodeAt(offset + 1) << 16 | buf.charCodeAt(offset + 2) << 8 | buf.charCodeAt(offset + 3);
            offset += 4;
        }
        else for(let i = 0; i < 16; i++){
            W[i] = buf[offset] << 24 | buf[offset + 1] << 16 | buf[offset + 2] << 8 | buf[offset + 3];
            offset += 4;
        }
        // expand to 80 words
        for(let i = 16; i < 80; i++){
            const t = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
            W[i] = (t << 1 | t >>> 31) & 0xffffffff;
        }
        let a = this.chain_[0];
        let b = this.chain_[1];
        let c = this.chain_[2];
        let d = this.chain_[3];
        let e = this.chain_[4];
        let f, k;
        // TODO(user): Try to unroll this loop to speed up the computation.
        for(let i = 0; i < 80; i++){
            if (i < 40) {
                if (i < 20) {
                    f = d ^ b & (c ^ d);
                    k = 0x5a827999;
                } else {
                    f = b ^ c ^ d;
                    k = 0x6ed9eba1;
                }
            } else if (i < 60) {
                f = b & c | d & (b | c);
                k = 0x8f1bbcdc;
            } else {
                f = b ^ c ^ d;
                k = 0xca62c1d6;
            }
            const t = (a << 5 | a >>> 27) + f + e + k + W[i] & 0xffffffff;
            e = d;
            d = c;
            c = (b << 30 | b >>> 2) & 0xffffffff;
            b = a;
            a = t;
        }
        this.chain_[0] = this.chain_[0] + a & 0xffffffff;
        this.chain_[1] = this.chain_[1] + b & 0xffffffff;
        this.chain_[2] = this.chain_[2] + c & 0xffffffff;
        this.chain_[3] = this.chain_[3] + d & 0xffffffff;
        this.chain_[4] = this.chain_[4] + e & 0xffffffff;
    }
    update(bytes, length) {
        // TODO(johnlenz): tighten the function signature and remove this check
        if (bytes == null) return;
        if (length === undefined) length = bytes.length;
        const lengthMinusBlock = length - this.blockSize;
        let n = 0;
        // Using local instead of member variables gives ~5% speedup on Firefox 16.
        const buf = this.buf_;
        let inbuf = this.inbuf_;
        // The outer while loop should execute at most twice.
        while(n < length){
            // When we have no data in the block to top up, we can directly process the
            // input buffer (assuming it contains sufficient data). This gives ~25%
            // speedup on Chrome 23 and ~15% speedup on Firefox 16, but requires that
            // the data is provided in large chunks (or in multiples of 64 bytes).
            if (inbuf === 0) while(n <= lengthMinusBlock){
                this.compress_(bytes, n);
                n += this.blockSize;
            }
            if (typeof bytes === "string") while(n < length){
                buf[inbuf] = bytes.charCodeAt(n);
                ++inbuf;
                ++n;
                if (inbuf === this.blockSize) {
                    this.compress_(buf);
                    inbuf = 0;
                    break;
                }
            }
            else while(n < length){
                buf[inbuf] = bytes[n];
                ++inbuf;
                ++n;
                if (inbuf === this.blockSize) {
                    this.compress_(buf);
                    inbuf = 0;
                    break;
                }
            }
        }
        this.inbuf_ = inbuf;
        this.total_ += length;
    }
    /** @override */ digest() {
        const digest = [];
        let totalBits = this.total_ * 8;
        // Add pad 0x80 0x00*.
        if (this.inbuf_ < 56) this.update(this.pad_, 56 - this.inbuf_);
        else this.update(this.pad_, this.blockSize - (this.inbuf_ - 56));
        // Add # bits.
        for(let i = this.blockSize - 1; i >= 56; i--){
            this.buf_[i] = totalBits & 255;
            totalBits /= 256; // Don't use bit-shifting here!
        }
        this.compress_(this.buf_);
        let n = 0;
        for(let i = 0; i < 5; i++)for(let j = 24; j >= 0; j -= 8){
            digest[n] = this.chain_[i] >> j & 255;
            ++n;
        }
        return digest;
    }
    constructor(){
        /**
         * Holds the previous values of accumulated variables a-e in the compress_
         * function.
         * @private
         */ this.chain_ = [];
        /**
         * A buffer holding the partially computed hash result.
         * @private
         */ this.buf_ = [];
        /**
         * An array of 80 bytes, each a part of the message to be hashed.  Referred to
         * as the message schedule in the docs.
         * @private
         */ this.W_ = [];
        /**
         * Contains data needed to pad messages less than 64 bytes.
         * @private
         */ this.pad_ = [];
        /**
         * @private {number}
         */ this.inbuf_ = 0;
        /**
         * @private {number}
         */ this.total_ = 0;
        this.blockSize = 64;
        this.pad_[0] = 128;
        for(let i = 1; i < this.blockSize; ++i)this.pad_[i] = 0;
        this.reset();
    }
}
/**
 * Helper to make a Subscribe function (just like Promise helps make a
 * Thenable).
 *
 * @param executor Function which can make calls to a single Observer
 *     as a proxy.
 * @param onNoObservers Callback when count of Observers goes to zero.
 */ function $f84e8187c6005769$export$364097d812234b3f(executor, onNoObservers) {
    const proxy = new $f84e8187c6005769$var$ObserverProxy(executor, onNoObservers);
    return proxy.subscribe.bind(proxy);
}
/**
 * Implement fan-out for any number of Observers attached via a subscribe
 * function.
 */ class $f84e8187c6005769$var$ObserverProxy {
    next(value) {
        this.forEachObserver((observer)=>{
            observer.next(value);
        });
    }
    error(error) {
        this.forEachObserver((observer)=>{
            observer.error(error);
        });
        this.close(error);
    }
    complete() {
        this.forEachObserver((observer)=>{
            observer.complete();
        });
        this.close();
    }
    /**
     * Subscribe function that can be used to add an Observer to the fan-out list.
     *
     * - We require that no event is sent to a subscriber sychronously to their
     *   call to subscribe().
     */ subscribe(nextOrObserver, error, complete) {
        let observer;
        if (nextOrObserver === undefined && error === undefined && complete === undefined) throw new Error("Missing Observer.");
        // Assemble an Observer object when passed as callback functions.
        if ($f84e8187c6005769$var$implementsAnyMethods(nextOrObserver, [
            "next",
            "error",
            "complete"
        ])) observer = nextOrObserver;
        else observer = {
            next: nextOrObserver,
            error: error,
            complete: complete
        };
        if (observer.next === undefined) observer.next = $f84e8187c6005769$var$noop;
        if (observer.error === undefined) observer.error = $f84e8187c6005769$var$noop;
        if (observer.complete === undefined) observer.complete = $f84e8187c6005769$var$noop;
        const unsub = this.unsubscribeOne.bind(this, this.observers.length);
        // Attempt to subscribe to a terminated Observable - we
        // just respond to the Observer with the final error or complete
        // event.
        if (this.finalized) // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            try {
                if (this.finalError) observer.error(this.finalError);
                else observer.complete();
            } catch (e) {
            // nothing
            }
            return;
        });
        this.observers.push(observer);
        return unsub;
    }
    // Unsubscribe is synchronous - we guarantee that no events are sent to
    // any unsubscribed Observer.
    unsubscribeOne(i) {
        if (this.observers === undefined || this.observers[i] === undefined) return;
        delete this.observers[i];
        this.observerCount -= 1;
        if (this.observerCount === 0 && this.onNoObservers !== undefined) this.onNoObservers(this);
    }
    forEachObserver(fn) {
        if (this.finalized) // Already closed by previous event....just eat the additional values.
        return;
        // Since sendOne calls asynchronously - there is no chance that
        // this.observers will become undefined.
        for(let i = 0; i < this.observers.length; i++)this.sendOne(i, fn);
    }
    // Call the Observer via one of it's callback function. We are careful to
    // confirm that the observe has not been unsubscribed since this asynchronous
    // function had been queued.
    sendOne(i, fn) {
        // Execute the callback asynchronously
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            if (this.observers !== undefined && this.observers[i] !== undefined) try {
                fn(this.observers[i]);
            } catch (e) {
                // Ignore exceptions raised in Observers or missing methods of an
                // Observer.
                // Log error to console. b/31404806
                if (typeof console !== "undefined" && console.error) console.error(e);
            }
        });
    }
    close(err) {
        if (this.finalized) return;
        this.finalized = true;
        if (err !== undefined) this.finalError = err;
        // Proxy is no longer needed - garbage collect references
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            this.observers = undefined;
            this.onNoObservers = undefined;
        });
    }
    /**
     * @param executor Function which can make calls to a single Observer
     *     as a proxy.
     * @param onNoObservers Callback when count of Observers goes to zero.
     */ constructor(executor, onNoObservers){
        this.observers = [];
        this.unsubscribes = [];
        this.observerCount = 0;
        // Micro-task scheduling by calling task.then().
        this.task = Promise.resolve();
        this.finalized = false;
        this.onNoObservers = onNoObservers;
        // Call the executor asynchronously so subscribers that are called
        // synchronously after the creation of the subscribe function
        // can still receive the very first value generated in the executor.
        this.task.then(()=>{
            executor(this);
        }).catch((e)=>{
            this.error(e);
        });
    }
}
/** Turn synchronous function into one called asynchronously. */ // eslint-disable-next-line @typescript-eslint/ban-types
function $f84e8187c6005769$export$12af436354f1a4f7(fn, onError) {
    return (...args)=>{
        Promise.resolve(true).then(()=>{
            fn(...args);
        }).catch((error)=>{
            if (onError) onError(error);
        });
    };
}
/**
 * Return true if the object passed in implements any of the named methods.
 */ function $f84e8187c6005769$var$implementsAnyMethods(obj, methods) {
    if (typeof obj !== "object" || obj === null) return false;
    for (const method of methods){
        if (method in obj && typeof obj[method] === "function") return true;
    }
    return false;
}
function $f84e8187c6005769$var$noop() {
// do nothing
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Check to make sure the appropriate number of arguments are provided for a public function.
 * Throws an error if it fails.
 *
 * @param fnName The function name
 * @param minCount The minimum number of arguments to allow for the function call
 * @param maxCount The maximum number of argument to allow for the function call
 * @param argCount The actual number of arguments provided.
 */ const $f84e8187c6005769$export$20164226a0ed35c3 = function(fnName, minCount, maxCount, argCount) {
    let argError;
    if (argCount < minCount) argError = "at least " + minCount;
    else if (argCount > maxCount) argError = maxCount === 0 ? "none" : "no more than " + maxCount;
    if (argError) {
        const error = fnName + " failed: Was called with " + argCount + (argCount === 1 ? " argument." : " arguments.") + " Expects " + argError + ".";
        throw new Error(error);
    }
};
/**
 * Generates a string to prefix an error message about failed argument validation
 *
 * @param fnName The function name
 * @param argName The name of the argument
 * @return The prefix to add to the error thrown for validation.
 */ function $f84e8187c6005769$export$adea4917e02d93dc(fnName, argName) {
    return `${fnName} failed: ${argName} argument `;
}
/**
 * @param fnName
 * @param argumentNumber
 * @param namespace
 * @param optional
 */ function $f84e8187c6005769$export$8eef22622e725943(fnName, namespace, optional) {
    if (optional && !namespace) return;
    if (typeof namespace !== "string") //TODO: I should do more validation here. We only allow certain chars in namespaces.
    throw new Error($f84e8187c6005769$export$adea4917e02d93dc(fnName, "namespace") + "must be a valid firebase namespace.");
}
function $f84e8187c6005769$export$5bcd2a2eb6640dfa(fnName, argumentName, // eslint-disable-next-line @typescript-eslint/ban-types
callback, optional) {
    if (optional && !callback) return;
    if (typeof callback !== "function") throw new Error($f84e8187c6005769$export$adea4917e02d93dc(fnName, argumentName) + "must be a valid function.");
}
function $f84e8187c6005769$export$df77539402cfb523(fnName, argumentName, context, optional) {
    if (optional && !context) return;
    if (typeof context !== "object" || context === null) throw new Error($f84e8187c6005769$export$adea4917e02d93dc(fnName, argumentName) + "must be a valid context object.");
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Code originally came from goog.crypt.stringToUtf8ByteArray, but for some reason they
// automatically replaced '\r\n' with '\n', and they didn't handle surrogate pairs,
// so it's been modified.
// Note that not all Unicode characters appear as single characters in JavaScript strings.
// fromCharCode returns the UTF-16 encoding of a character - so some Unicode characters
// use 2 characters in Javascript.  All 4-byte UTF-8 characters begin with a first
// character in the range 0xD800 - 0xDBFF (the first character of a so-called surrogate
// pair).
// See http://www.ecma-international.org/ecma-262/5.1/#sec-15.1.3
/**
 * @param {string} str
 * @return {Array}
 */ const $f84e8187c6005769$export$655666783217a925 = function(str) {
    const out = [];
    let p = 0;
    for(let i = 0; i < str.length; i++){
        let c = str.charCodeAt(i);
        // Is this the lead surrogate in a surrogate pair?
        if (c >= 0xd800 && c <= 0xdbff) {
            const high = c - 0xd800; // the high 10 bits.
            i++;
            $f84e8187c6005769$export$a7a9523472993e97(i < str.length, "Surrogate pair missing trail surrogate.");
            const low = str.charCodeAt(i) - 0xdc00; // the low 10 bits.
            c = 0x10000 + (high << 10) + low;
        }
        if (c < 128) out[p++] = c;
        else if (c < 2048) {
            out[p++] = c >> 6 | 192;
            out[p++] = c & 63 | 128;
        } else if (c < 65536) {
            out[p++] = c >> 12 | 224;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        } else {
            out[p++] = c >> 18 | 240;
            out[p++] = c >> 12 & 63 | 128;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        }
    }
    return out;
};
/**
 * Calculate length without actually converting; useful for doing cheaper validation.
 * @param {string} str
 * @return {number}
 */ const $f84e8187c6005769$export$9536dc0a75b20bf9 = function(str) {
    let p = 0;
    for(let i = 0; i < str.length; i++){
        const c = str.charCodeAt(i);
        if (c < 128) p++;
        else if (c < 2048) p += 2;
        else if (c >= 0xd800 && c <= 0xdbff) {
            // Lead surrogate of a surrogate pair.  The pair together will take 4 bytes to represent.
            p += 4;
            i++; // skip trail surrogate.
        } else p += 3;
    }
    return p;
};
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The amount of milliseconds to exponentially increase.
 */ const $f84e8187c6005769$var$DEFAULT_INTERVAL_MILLIS = 1000;
/**
 * The factor to backoff by.
 * Should be a number greater than 1.
 */ const $f84e8187c6005769$var$DEFAULT_BACKOFF_FACTOR = 2;
/**
 * The maximum milliseconds to increase to.
 *
 * <p>Visible for testing
 */ const $f84e8187c6005769$export$bdf1213ffbdb096e = 14400000; // Four hours, like iOS and Android.
/**
 * The percentage of backoff time to randomize by.
 * See
 * http://go/safe-client-behavior#step-1-determine-the-appropriate-retry-interval-to-handle-spike-traffic
 * for context.
 *
 * <p>Visible for testing
 */ const $f84e8187c6005769$export$3518ed2cfe61fa30 = 0.5;
/**
 * Based on the backoff method from
 * https://github.com/google/closure-library/blob/master/closure/goog/math/exponentialbackoff.js.
 * Extracted here so we don't need to pass metadata and a stateful ExponentialBackoff object around.
 */ function $f84e8187c6005769$export$4d810c0ca64ed8e9(backoffCount, intervalMillis = $f84e8187c6005769$var$DEFAULT_INTERVAL_MILLIS, backoffFactor = $f84e8187c6005769$var$DEFAULT_BACKOFF_FACTOR) {
    // Calculates an exponentially increasing value.
    // Deviation: calculates value from count and a constant interval, so we only need to save value
    // and count to restore state.
    const currBaseValue = intervalMillis * Math.pow(backoffFactor, backoffCount);
    // A random "fuzz" to avoid waves of retries.
    // Deviation: randomFactor is required.
    const randomWait = Math.round(// A fraction of the backoff value to add/subtract.
    // Deviation: changes multiplication order to improve readability.
    $f84e8187c6005769$export$3518ed2cfe61fa30 * currBaseValue * // A random float (rounded to int by Math.round above) in the range [-1, 1]. Determines
    // if we add or subtract.
    (Math.random() - 0.5) * 2);
    // Limits backoff to max to avoid effectively permanent backoff.
    return Math.min($f84e8187c6005769$export$bdf1213ffbdb096e, currBaseValue + randomWait);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provide English ordinal letters after a number
 */ function $f84e8187c6005769$export$7bb39f879164e4ac(i) {
    if (!Number.isFinite(i)) return `${i}`;
    return i + $f84e8187c6005769$var$indicator(i);
}
function $f84e8187c6005769$var$indicator(i) {
    i = Math.abs(i);
    const cent = i % 100;
    if (cent >= 10 && cent <= 20) return "th";
    const dec = i % 10;
    if (dec === 1) return "st";
    if (dec === 2) return "nd";
    if (dec === 3) return "rd";
    return "th";
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $f84e8187c6005769$export$4befe9b5fa509a1b(service) {
    if (service && service._delegate) return service._delegate;
    else return service;
}



/**
 * Component for service name T, e.g. `auth`, `auth-internal`
 */ class $9e13847596aa735d$export$16fa2f45be04daa8 {
    setInstantiationMode(mode) {
        this.instantiationMode = mode;
        return this;
    }
    setMultipleInstances(multipleInstances) {
        this.multipleInstances = multipleInstances;
        return this;
    }
    setServiceProps(props) {
        this.serviceProps = props;
        return this;
    }
    setInstanceCreatedCallback(callback) {
        this.onInstanceCreated = callback;
        return this;
    }
    /**
     *
     * @param name The public service name, e.g. app, auth, firestore, database
     * @param instanceFactory Service factory responsible for creating the public interface
     * @param type whether the service provided by the component is public or private
     */ constructor(name, instanceFactory, type){
        this.name = name;
        this.instanceFactory = instanceFactory;
        this.type = type;
        this.multipleInstances = false;
        /**
         * Properties to be added to the service namespace
         */ this.serviceProps = {};
        this.instantiationMode = "LAZY" /* LAZY */ ;
        this.onInstanceCreated = null;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $9e13847596aa735d$var$DEFAULT_ENTRY_NAME = "[DEFAULT]";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for instance for service name T, e.g. 'auth', 'auth-internal'
 * NameServiceMapping[T] is an alias for the type of the instance
 */ class $9e13847596aa735d$export$2881499e37b75b9a {
    /**
     * @param identifier A provider can provide mulitple instances of a service
     * if this.component.multipleInstances is true.
     */ get(identifier) {
        // if multipleInstances is not supported, use the default name
        const normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
        if (!this.instancesDeferred.has(normalizedIdentifier)) {
            const deferred = new (0, $f84e8187c6005769$export$85f6557964517f1a)();
            this.instancesDeferred.set(normalizedIdentifier, deferred);
            if (this.isInitialized(normalizedIdentifier) || this.shouldAutoInitialize()) // initialize the service if it can be auto-initialized
            try {
                const instance = this.getOrInitializeService({
                    instanceIdentifier: normalizedIdentifier
                });
                if (instance) deferred.resolve(instance);
            } catch (e) {
            // when the instance factory throws an exception during get(), it should not cause
            // a fatal error. We just return the unresolved promise in this case.
            }
        }
        return this.instancesDeferred.get(normalizedIdentifier).promise;
    }
    getImmediate(options) {
        var _a;
        // if multipleInstances is not supported, use the default name
        const normalizedIdentifier = this.normalizeInstanceIdentifier(options === null || options === void 0 ? void 0 : options.identifier);
        const optional = (_a = options === null || options === void 0 ? void 0 : options.optional) !== null && _a !== void 0 ? _a : false;
        if (this.isInitialized(normalizedIdentifier) || this.shouldAutoInitialize()) try {
            return this.getOrInitializeService({
                instanceIdentifier: normalizedIdentifier
            });
        } catch (e) {
            if (optional) return null;
            else throw e;
        }
        else {
            // In case a component is not initialized and should/can not be auto-initialized at the moment, return null if the optional flag is set, or throw
            if (optional) return null;
            else throw Error(`Service ${this.name} is not available`);
        }
    }
    getComponent() {
        return this.component;
    }
    setComponent(component) {
        if (component.name !== this.name) throw Error(`Mismatching Component ${component.name} for Provider ${this.name}.`);
        if (this.component) throw Error(`Component for ${this.name} has already been provided`);
        this.component = component;
        // return early without attempting to initialize the component if the component requires explicit initialization (calling `Provider.initialize()`)
        if (!this.shouldAutoInitialize()) return;
        // if the service is eager, initialize the default instance
        if ($9e13847596aa735d$var$isComponentEager(component)) try {
            this.getOrInitializeService({
                instanceIdentifier: $9e13847596aa735d$var$DEFAULT_ENTRY_NAME
            });
        } catch (e) {
        // when the instance factory for an eager Component throws an exception during the eager
        // initialization, it should not cause a fatal error.
        // TODO: Investigate if we need to make it configurable, because some component may want to cause
        // a fatal error in this case?
        }
        // Create service instances for the pending promises and resolve them
        // NOTE: if this.multipleInstances is false, only the default instance will be created
        // and all promises with resolve with it regardless of the identifier.
        for (const [instanceIdentifier, instanceDeferred] of this.instancesDeferred.entries()){
            const normalizedIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
            try {
                // `getOrInitializeService()` should always return a valid instance since a component is guaranteed. use ! to make typescript happy.
                const instance = this.getOrInitializeService({
                    instanceIdentifier: normalizedIdentifier
                });
                instanceDeferred.resolve(instance);
            } catch (e) {
            // when the instance factory throws an exception, it should not cause
            // a fatal error. We just leave the promise unresolved.
            }
        }
    }
    clearInstance(identifier = $9e13847596aa735d$var$DEFAULT_ENTRY_NAME) {
        this.instancesDeferred.delete(identifier);
        this.instancesOptions.delete(identifier);
        this.instances.delete(identifier);
    }
    // app.delete() will call this method on every provider to delete the services
    // TODO: should we mark the provider as deleted?
    async delete() {
        const services = Array.from(this.instances.values());
        await Promise.all([
            ...services.filter((service)=>"INTERNAL" in service) // legacy services
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .map((service)=>service.INTERNAL.delete()),
            ...services.filter((service)=>"_delete" in service) // modularized services
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .map((service)=>service._delete())
        ]);
    }
    isComponentSet() {
        return this.component != null;
    }
    isInitialized(identifier = $9e13847596aa735d$var$DEFAULT_ENTRY_NAME) {
        return this.instances.has(identifier);
    }
    getOptions(identifier = $9e13847596aa735d$var$DEFAULT_ENTRY_NAME) {
        return this.instancesOptions.get(identifier) || {};
    }
    initialize(opts = {}) {
        const { options: options = {} } = opts;
        const normalizedIdentifier = this.normalizeInstanceIdentifier(opts.instanceIdentifier);
        if (this.isInitialized(normalizedIdentifier)) throw Error(`${this.name}(${normalizedIdentifier}) has already been initialized`);
        if (!this.isComponentSet()) throw Error(`Component ${this.name} has not been registered yet`);
        const instance = this.getOrInitializeService({
            instanceIdentifier: normalizedIdentifier,
            options: options
        });
        // resolve any pending promise waiting for the service instance
        for (const [instanceIdentifier, instanceDeferred] of this.instancesDeferred.entries()){
            const normalizedDeferredIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
            if (normalizedIdentifier === normalizedDeferredIdentifier) instanceDeferred.resolve(instance);
        }
        return instance;
    }
    /**
     *
     * @param callback - a function that will be invoked  after the provider has been initialized by calling provider.initialize().
     * The function is invoked SYNCHRONOUSLY, so it should not execute any longrunning tasks in order to not block the program.
     *
     * @param identifier An optional instance identifier
     * @returns a function to unregister the callback
     */ onInit(callback, identifier) {
        var _a;
        const normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
        const existingCallbacks = (_a = this.onInitCallbacks.get(normalizedIdentifier)) !== null && _a !== void 0 ? _a : new Set();
        existingCallbacks.add(callback);
        this.onInitCallbacks.set(normalizedIdentifier, existingCallbacks);
        const existingInstance = this.instances.get(normalizedIdentifier);
        if (existingInstance) callback(existingInstance, normalizedIdentifier);
        return ()=>{
            existingCallbacks.delete(callback);
        };
    }
    /**
     * Invoke onInit callbacks synchronously
     * @param instance the service instance`
     */ invokeOnInitCallbacks(instance, identifier) {
        const callbacks = this.onInitCallbacks.get(identifier);
        if (!callbacks) return;
        for (const callback of callbacks)try {
            callback(instance, identifier);
        } catch (_a) {
        // ignore errors in the onInit callback
        }
    }
    getOrInitializeService({ instanceIdentifier: instanceIdentifier, options: options = {} }) {
        let instance = this.instances.get(instanceIdentifier);
        if (!instance && this.component) {
            instance = this.component.instanceFactory(this.container, {
                instanceIdentifier: $9e13847596aa735d$var$normalizeIdentifierForFactory(instanceIdentifier),
                options: options
            });
            this.instances.set(instanceIdentifier, instance);
            this.instancesOptions.set(instanceIdentifier, options);
            /**
             * Invoke onInit listeners.
             * Note this.component.onInstanceCreated is different, which is used by the component creator,
             * while onInit listeners are registered by consumers of the provider.
             */ this.invokeOnInitCallbacks(instance, instanceIdentifier);
            /**
             * Order is important
             * onInstanceCreated() should be called after this.instances.set(instanceIdentifier, instance); which
             * makes `isInitialized()` return true.
             */ if (this.component.onInstanceCreated) try {
                this.component.onInstanceCreated(this.container, instanceIdentifier, instance);
            } catch (_a) {
            // ignore errors in the onInstanceCreatedCallback
            }
        }
        return instance || null;
    }
    normalizeInstanceIdentifier(identifier = $9e13847596aa735d$var$DEFAULT_ENTRY_NAME) {
        if (this.component) return this.component.multipleInstances ? identifier : $9e13847596aa735d$var$DEFAULT_ENTRY_NAME;
        else return identifier; // assume multiple instances are supported before the component is provided.
    }
    shouldAutoInitialize() {
        return !!this.component && this.component.instantiationMode !== "EXPLICIT" /* EXPLICIT */ ;
    }
    constructor(name, container){
        this.name = name;
        this.container = container;
        this.component = null;
        this.instances = new Map();
        this.instancesDeferred = new Map();
        this.instancesOptions = new Map();
        this.onInitCallbacks = new Map();
    }
}
// undefined should be passed to the service factory for the default instance
function $9e13847596aa735d$var$normalizeIdentifierForFactory(identifier) {
    return identifier === $9e13847596aa735d$var$DEFAULT_ENTRY_NAME ? undefined : identifier;
}
function $9e13847596aa735d$var$isComponentEager(component) {
    return component.instantiationMode === "EAGER" /* EAGER */ ;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * ComponentContainer that provides Providers for service name T, e.g. `auth`, `auth-internal`
 */ class $9e13847596aa735d$export$436a80eea5d5c0c5 {
    /**
     *
     * @param component Component being added
     * @param overwrite When a component with the same name has already been registered,
     * if overwrite is true: overwrite the existing component with the new component and create a new
     * provider with the new component. It can be useful in tests where you want to use different mocks
     * for different tests.
     * if overwrite is false: throw an exception
     */ addComponent(component) {
        const provider = this.getProvider(component.name);
        if (provider.isComponentSet()) throw new Error(`Component ${component.name} has already been registered with ${this.name}`);
        provider.setComponent(component);
    }
    addOrOverwriteComponent(component) {
        const provider = this.getProvider(component.name);
        if (provider.isComponentSet()) // delete the existing provider from the container, so we can register the new component
        this.providers.delete(component.name);
        this.addComponent(component);
    }
    /**
     * getProvider provides a type safe interface where it can only be called with a field name
     * present in NameServiceMapping interface.
     *
     * Firebase SDKs providing services should extend NameServiceMapping interface to register
     * themselves.
     */ getProvider(name) {
        if (this.providers.has(name)) return this.providers.get(name);
        // create a Provider for a service that hasn't registered with Firebase
        const provider = new $9e13847596aa735d$export$2881499e37b75b9a(name, this);
        this.providers.set(name, provider);
        return provider;
    }
    getProviders() {
        return Array.from(this.providers.values());
    }
    constructor(name){
        this.name = name;
        this.providers = new Map();
    }
}


/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Constants used in the Firebase Storage library.
 */ /**
 * Domain name for firebase storage.
 */ const $57d582485a4bd356$var$DEFAULT_HOST = "firebasestorage.googleapis.com";
/**
 * The key in Firebase config json for the storage bucket.
 */ const $57d582485a4bd356$var$CONFIG_STORAGE_BUCKET_KEY = "storageBucket";
/**
 * 2 minutes
 *
 * The timeout for all operations except upload.
 */ const $57d582485a4bd356$var$DEFAULT_MAX_OPERATION_RETRY_TIME = 120000;
/**
 * 10 minutes
 *
 * The timeout for upload.
 */ const $57d582485a4bd356$var$DEFAULT_MAX_UPLOAD_RETRY_TIME = 600000;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An error returned by the Firebase Storage SDK.
 * @public
 */ class $57d582485a4bd356$var$StorageError extends (0, $f84e8187c6005769$export$dd24e9cd51226c56) {
    /**
     * Compares a StorageErrorCode against this error's code, filtering out the prefix.
     */ _codeEquals(code) {
        return $57d582485a4bd356$var$prependCode(code) === this.code;
    }
    /**
     * Optional response message that was added by the server.
     */ get serverResponse() {
        return this.customData.serverResponse;
    }
    set serverResponse(serverResponse) {
        this.customData.serverResponse = serverResponse;
        if (this.customData.serverResponse) this.message = `${this._baseMessage}\n${this.customData.serverResponse}`;
        else this.message = this._baseMessage;
    }
    /**
     * @param code - A StorageErrorCode string to be prefixed with 'storage/' and
     *  added to the end of the message.
     * @param message  - Error message.
     */ constructor(code, message){
        super($57d582485a4bd356$var$prependCode(code), `Firebase Storage: ${message} (${$57d582485a4bd356$var$prependCode(code)})`);
        /**
         * Stores custom error data unque to StorageError.
         */ this.customData = {
            serverResponse: null
        };
        this._baseMessage = this.message;
        // Without this, `instanceof StorageError`, in tests for example,
        // returns false.
        Object.setPrototypeOf(this, $57d582485a4bd356$var$StorageError.prototype);
    }
}
function $57d582485a4bd356$var$prependCode(code) {
    return "storage/" + code;
}
function $57d582485a4bd356$var$unknown() {
    const message = "An unknown error occurred, please check the error payload for server response.";
    return new $57d582485a4bd356$var$StorageError("unknown" /* UNKNOWN */ , message);
}
function $57d582485a4bd356$var$objectNotFound(path) {
    return new $57d582485a4bd356$var$StorageError("object-not-found" /* OBJECT_NOT_FOUND */ , "Object '" + path + "' does not exist.");
}
function $57d582485a4bd356$var$quotaExceeded(bucket) {
    return new $57d582485a4bd356$var$StorageError("quota-exceeded" /* QUOTA_EXCEEDED */ , "Quota for bucket '" + bucket + "' exceeded, please view quota on " + "https://firebase.google.com/pricing/.");
}
function $57d582485a4bd356$var$unauthenticated() {
    const message = "User is not authenticated, please authenticate using Firebase Authentication and try again.";
    return new $57d582485a4bd356$var$StorageError("unauthenticated" /* UNAUTHENTICATED */ , message);
}
function $57d582485a4bd356$var$unauthorizedApp() {
    return new $57d582485a4bd356$var$StorageError("unauthorized-app" /* UNAUTHORIZED_APP */ , "This app does not have permission to access Firebase Storage on this project.");
}
function $57d582485a4bd356$var$unauthorized(path) {
    return new $57d582485a4bd356$var$StorageError("unauthorized" /* UNAUTHORIZED */ , "User does not have permission to access '" + path + "'.");
}
function $57d582485a4bd356$var$retryLimitExceeded() {
    return new $57d582485a4bd356$var$StorageError("retry-limit-exceeded" /* RETRY_LIMIT_EXCEEDED */ , "Max retry time for operation exceeded, please try again.");
}
function $57d582485a4bd356$var$canceled() {
    return new $57d582485a4bd356$var$StorageError("canceled" /* CANCELED */ , "User canceled the upload/download.");
}
function $57d582485a4bd356$var$invalidUrl(url) {
    return new $57d582485a4bd356$var$StorageError("invalid-url" /* INVALID_URL */ , "Invalid URL '" + url + "'.");
}
function $57d582485a4bd356$var$invalidDefaultBucket(bucket) {
    return new $57d582485a4bd356$var$StorageError("invalid-default-bucket" /* INVALID_DEFAULT_BUCKET */ , "Invalid default bucket '" + bucket + "'.");
}
function $57d582485a4bd356$var$noDefaultBucket() {
    return new $57d582485a4bd356$var$StorageError("no-default-bucket" /* NO_DEFAULT_BUCKET */ , "No default bucket found. Did you set the '" + $57d582485a4bd356$var$CONFIG_STORAGE_BUCKET_KEY + "' property when initializing the app?");
}
function $57d582485a4bd356$var$cannotSliceBlob() {
    return new $57d582485a4bd356$var$StorageError("cannot-slice-blob" /* CANNOT_SLICE_BLOB */ , "Cannot slice blob for upload. Please retry the upload.");
}
function $57d582485a4bd356$var$serverFileWrongSize() {
    return new $57d582485a4bd356$var$StorageError("server-file-wrong-size" /* SERVER_FILE_WRONG_SIZE */ , "Server recorded incorrect upload file size, please retry the upload.");
}
function $57d582485a4bd356$var$noDownloadURL() {
    return new $57d582485a4bd356$var$StorageError("no-download-url" /* NO_DOWNLOAD_URL */ , "The given file does not have any download URLs.");
}
/**
 * @internal
 */ function $57d582485a4bd356$export$8f74d9881d1936fd(message) {
    return new $57d582485a4bd356$var$StorageError("invalid-argument" /* INVALID_ARGUMENT */ , message);
}
function $57d582485a4bd356$var$appDeleted() {
    return new $57d582485a4bd356$var$StorageError("app-deleted" /* APP_DELETED */ , "The Firebase app was deleted.");
}
/**
 * @param name - The name of the operation that was invalid.
 *
 * @internal
 */ function $57d582485a4bd356$export$61f54cdc36500ad(name) {
    return new $57d582485a4bd356$var$StorageError("invalid-root-operation" /* INVALID_ROOT_OPERATION */ , "The operation '" + name + "' cannot be performed on a root reference, create a non-root " + "reference using child, such as .child('file.png').");
}
/**
 * @param format - The format that was not valid.
 * @param message - A message describing the format violation.
 */ function $57d582485a4bd356$var$invalidFormat(format, message) {
    return new $57d582485a4bd356$var$StorageError("invalid-format" /* INVALID_FORMAT */ , "String does not match format '" + format + "': " + message);
}
/**
 * @param message - A message describing the internal error.
 */ function $57d582485a4bd356$var$internalError(message) {
    throw new $57d582485a4bd356$var$StorageError("internal-error" /* INTERNAL_ERROR */ , "Internal error: " + message);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Firebase Storage location data.
 *
 * @internal
 */ class $57d582485a4bd356$export$adb98fff6714334 {
    get path() {
        return this.path_;
    }
    get isRoot() {
        return this.path.length === 0;
    }
    fullServerUrl() {
        const encode = encodeURIComponent;
        return "/b/" + encode(this.bucket) + "/o/" + encode(this.path);
    }
    bucketOnlyServerUrl() {
        const encode = encodeURIComponent;
        return "/b/" + encode(this.bucket) + "/o";
    }
    static makeFromBucketSpec(bucketString, host) {
        let bucketLocation;
        try {
            bucketLocation = $57d582485a4bd356$export$adb98fff6714334.makeFromUrl(bucketString, host);
        } catch (e) {
            // Not valid URL, use as-is. This lets you put bare bucket names in
            // config.
            return new $57d582485a4bd356$export$adb98fff6714334(bucketString, "");
        }
        if (bucketLocation.path === "") return bucketLocation;
        else throw $57d582485a4bd356$var$invalidDefaultBucket(bucketString);
    }
    static makeFromUrl(url, host) {
        let location = null;
        const bucketDomain = "([A-Za-z0-9.\\-_]+)";
        function gsModify(loc) {
            if (loc.path.charAt(loc.path.length - 1) === "/") loc.path_ = loc.path_.slice(0, -1);
        }
        const gsPath = "(/(.*))?$";
        const gsRegex = new RegExp("^gs://" + bucketDomain + gsPath, "i");
        const gsIndices = {
            bucket: 1,
            path: 3
        };
        function httpModify(loc) {
            loc.path_ = decodeURIComponent(loc.path);
        }
        const version = "v[A-Za-z0-9_]+";
        const firebaseStorageHost = host.replace(/[.]/g, "\\.");
        const firebaseStoragePath = "(/([^?#]*).*)?$";
        const firebaseStorageRegExp = new RegExp(`^https?://${firebaseStorageHost}/${version}/b/${bucketDomain}/o${firebaseStoragePath}`, "i");
        const firebaseStorageIndices = {
            bucket: 1,
            path: 3
        };
        const cloudStorageHost = host === $57d582485a4bd356$var$DEFAULT_HOST ? "(?:storage.googleapis.com|storage.cloud.google.com)" : host;
        const cloudStoragePath = "([^?#]*)";
        const cloudStorageRegExp = new RegExp(`^https?://${cloudStorageHost}/${bucketDomain}/${cloudStoragePath}`, "i");
        const cloudStorageIndices = {
            bucket: 1,
            path: 2
        };
        const groups = [
            {
                regex: gsRegex,
                indices: gsIndices,
                postModify: gsModify
            },
            {
                regex: firebaseStorageRegExp,
                indices: firebaseStorageIndices,
                postModify: httpModify
            },
            {
                regex: cloudStorageRegExp,
                indices: cloudStorageIndices,
                postModify: httpModify
            }
        ];
        for(let i = 0; i < groups.length; i++){
            const group = groups[i];
            const captures = group.regex.exec(url);
            if (captures) {
                const bucketValue = captures[group.indices.bucket];
                let pathValue = captures[group.indices.path];
                if (!pathValue) pathValue = "";
                location = new $57d582485a4bd356$export$adb98fff6714334(bucketValue, pathValue);
                group.postModify(location);
                break;
            }
        }
        if (location == null) throw $57d582485a4bd356$var$invalidUrl(url);
        return location;
    }
    constructor(bucket, path){
        this.bucket = bucket;
        this.path_ = path;
    }
}
/**
 * A request whose promise always fails.
 */ class $57d582485a4bd356$var$FailRequest {
    /** @inheritDoc */ getPromise() {
        return this.promise_;
    }
    /** @inheritDoc */ cancel(_appDelete = false) {}
    constructor(error){
        this.promise_ = Promise.reject(error);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @param f May be invoked
 *     before the function returns.
 * @param callback Get all the arguments passed to the function
 *     passed to f, including the initial boolean.
 */ function $57d582485a4bd356$var$start(f, // eslint-disable-next-line @typescript-eslint/no-explicit-any
callback, timeout) {
    // TODO(andysoto): make this code cleaner (probably refactor into an actual
    // type instead of a bunch of functions with state shared in the closure)
    let waitSeconds = 1;
    // Would type this as "number" but that doesn't work for Node so ¯\_(ツ)_/¯
    // TODO: find a way to exclude Node type definition for storage because storage only works in browser
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let retryTimeoutId = null;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let globalTimeoutId = null;
    let hitTimeout = false;
    let cancelState = 0;
    function canceled() {
        return cancelState === 2;
    }
    let triggeredCallback = false;
    function triggerCallback(...args) {
        if (!triggeredCallback) {
            triggeredCallback = true;
            callback.apply(null, args);
        }
    }
    function callWithDelay(millis) {
        retryTimeoutId = setTimeout(()=>{
            retryTimeoutId = null;
            f(handler, canceled());
        }, millis);
    }
    function clearGlobalTimeout() {
        if (globalTimeoutId) clearTimeout(globalTimeoutId);
    }
    function handler(success, ...args) {
        if (triggeredCallback) {
            clearGlobalTimeout();
            return;
        }
        if (success) {
            clearGlobalTimeout();
            triggerCallback.call(null, success, ...args);
            return;
        }
        const mustStop = canceled() || hitTimeout;
        if (mustStop) {
            clearGlobalTimeout();
            triggerCallback.call(null, success, ...args);
            return;
        }
        if (waitSeconds < 64) /* TODO(andysoto): don't back off so quickly if we know we're offline. */ waitSeconds *= 2;
        let waitMillis;
        if (cancelState === 1) {
            cancelState = 2;
            waitMillis = 0;
        } else waitMillis = (waitSeconds + Math.random()) * 1000;
        callWithDelay(waitMillis);
    }
    let stopped = false;
    function stop(wasTimeout) {
        if (stopped) return;
        stopped = true;
        clearGlobalTimeout();
        if (triggeredCallback) return;
        if (retryTimeoutId !== null) {
            if (!wasTimeout) cancelState = 2;
            clearTimeout(retryTimeoutId);
            callWithDelay(0);
        } else if (!wasTimeout) cancelState = 1;
    }
    callWithDelay(0);
    globalTimeoutId = setTimeout(()=>{
        hitTimeout = true;
        stop(true);
    }, timeout);
    return stop;
}
/**
 * Stops the retry loop from repeating.
 * If the function is currently "in between" retries, it is invoked immediately
 * with the second parameter as "true". Otherwise, it will be invoked once more
 * after the current invocation finishes iff the current invocation would have
 * triggered another retry.
 */ function $57d582485a4bd356$var$stop(id) {
    id(false);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $57d582485a4bd356$var$isJustDef(p) {
    return p !== void 0;
}
// eslint-disable-next-line @typescript-eslint/ban-types
function $57d582485a4bd356$var$isFunction(p) {
    return typeof p === "function";
}
function $57d582485a4bd356$var$isNonArrayObject(p) {
    return typeof p === "object" && !Array.isArray(p);
}
function $57d582485a4bd356$var$isString(p) {
    return typeof p === "string" || p instanceof String;
}
function $57d582485a4bd356$var$isNativeBlob(p) {
    return $57d582485a4bd356$var$isNativeBlobDefined() && p instanceof Blob;
}
function $57d582485a4bd356$var$isNativeBlobDefined() {
    return typeof Blob !== "undefined";
}
function $57d582485a4bd356$var$validateNumber(argument, minValue, maxValue, value) {
    if (value < minValue) throw $57d582485a4bd356$export$8f74d9881d1936fd(`Invalid value for '${argument}'. Expected ${minValue} or greater.`);
    if (value > maxValue) throw $57d582485a4bd356$export$8f74d9881d1936fd(`Invalid value for '${argument}'. Expected ${maxValue} or less.`);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $57d582485a4bd356$var$makeUrl(urlPart, host, protocol) {
    let origin = host;
    if (protocol == null) origin = `https://${host}`;
    return `${protocol}://${origin}/v0${urlPart}`;
}
function $57d582485a4bd356$var$makeQueryString(params) {
    const encode = encodeURIComponent;
    let queryPart = "?";
    for(const key in params)if (params.hasOwnProperty(key)) {
        const nextPart = encode(key) + "=" + encode(params[key]);
        queryPart = queryPart + nextPart + "&";
    }
    // Chop off the extra '&' or '?' on the end
    queryPart = queryPart.slice(0, -1);
    return queryPart;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Error codes for requests made by the the XhrIo wrapper.
 */ var $57d582485a4bd356$var$ErrorCode;
(function(ErrorCode) {
    ErrorCode[ErrorCode["NO_ERROR"] = 0] = "NO_ERROR";
    ErrorCode[ErrorCode["NETWORK_ERROR"] = 1] = "NETWORK_ERROR";
    ErrorCode[ErrorCode["ABORT"] = 2] = "ABORT";
})($57d582485a4bd356$var$ErrorCode || ($57d582485a4bd356$var$ErrorCode = {}));
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Handles network logic for all Storage Requests, including error reporting and
 * retries with backoff.
 *
 * @param I - the type of the backend's network response.
 * @param - O the output type used by the rest of the SDK. The conversion
 * happens in the specified `callback_`.
 */ class $57d582485a4bd356$var$NetworkRequest {
    /**
     * Actually starts the retry loop.
     */ start_() {
        const doTheRequest = (backoffCallback, canceled)=>{
            if (canceled) {
                backoffCallback(false, new $57d582485a4bd356$var$RequestEndStatus(false, null, true));
                return;
            }
            const connection = this.connectionFactory_();
            this.pendingConnection_ = connection;
            const progressListener = (progressEvent)=>{
                const loaded = progressEvent.loaded;
                const total = progressEvent.lengthComputable ? progressEvent.total : -1;
                if (this.progressCallback_ !== null) this.progressCallback_(loaded, total);
            };
            if (this.progressCallback_ !== null) connection.addUploadProgressListener(progressListener);
            // connection.send() never rejects, so we don't need to have a error handler or use catch on the returned promise.
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            connection.send(this.url_, this.method_, this.body_, this.headers_).then(()=>{
                if (this.progressCallback_ !== null) connection.removeUploadProgressListener(progressListener);
                this.pendingConnection_ = null;
                const hitServer = connection.getErrorCode() === $57d582485a4bd356$var$ErrorCode.NO_ERROR;
                const status = connection.getStatus();
                if (!hitServer || this.isRetryStatusCode_(status)) {
                    const wasCanceled = connection.getErrorCode() === $57d582485a4bd356$var$ErrorCode.ABORT;
                    backoffCallback(false, new $57d582485a4bd356$var$RequestEndStatus(false, null, wasCanceled));
                    return;
                }
                const successCode = this.successCodes_.indexOf(status) !== -1;
                backoffCallback(true, new $57d582485a4bd356$var$RequestEndStatus(successCode, connection));
            });
        };
        /**
         * @param requestWentThrough - True if the request eventually went
         *     through, false if it hit the retry limit or was canceled.
         */ const backoffDone = (requestWentThrough, status)=>{
            const resolve = this.resolve_;
            const reject = this.reject_;
            const connection = status.connection;
            if (status.wasSuccessCode) try {
                const result = this.callback_(connection, connection.getResponse());
                if ($57d582485a4bd356$var$isJustDef(result)) resolve(result);
                else resolve();
            } catch (e) {
                reject(e);
            }
            else {
                if (connection !== null) {
                    const err = $57d582485a4bd356$var$unknown();
                    err.serverResponse = connection.getErrorText();
                    if (this.errorCallback_) reject(this.errorCallback_(connection, err));
                    else reject(err);
                } else if (status.canceled) {
                    const err = this.appDelete_ ? $57d582485a4bd356$var$appDeleted() : $57d582485a4bd356$var$canceled();
                    reject(err);
                } else {
                    const err = $57d582485a4bd356$var$retryLimitExceeded();
                    reject(err);
                }
            }
        };
        if (this.canceled_) backoffDone(false, new $57d582485a4bd356$var$RequestEndStatus(false, null, true));
        else this.backoffId_ = $57d582485a4bd356$var$start(doTheRequest, backoffDone, this.timeout_);
    }
    /** @inheritDoc */ getPromise() {
        return this.promise_;
    }
    /** @inheritDoc */ cancel(appDelete) {
        this.canceled_ = true;
        this.appDelete_ = appDelete || false;
        if (this.backoffId_ !== null) $57d582485a4bd356$var$stop(this.backoffId_);
        if (this.pendingConnection_ !== null) this.pendingConnection_.abort();
    }
    isRetryStatusCode_(status) {
        // The codes for which to retry came from this page:
        // https://cloud.google.com/storage/docs/exponential-backoff
        const isFiveHundredCode = status >= 500 && status < 600;
        const extraRetryCodes = [
            // Request Timeout: web server didn't receive full request in time.
            408,
            // Too Many Requests: you're getting rate-limited, basically.
            429
        ];
        const isExtraRetryCode = extraRetryCodes.indexOf(status) !== -1;
        const isRequestSpecificRetryCode = this.additionalRetryCodes_.indexOf(status) !== -1;
        return isFiveHundredCode || isExtraRetryCode || isRequestSpecificRetryCode;
    }
    constructor(url_, method_, headers_, body_, successCodes_, additionalRetryCodes_, callback_, errorCallback_, timeout_, progressCallback_, connectionFactory_){
        this.url_ = url_;
        this.method_ = method_;
        this.headers_ = headers_;
        this.body_ = body_;
        this.successCodes_ = successCodes_;
        this.additionalRetryCodes_ = additionalRetryCodes_;
        this.callback_ = callback_;
        this.errorCallback_ = errorCallback_;
        this.timeout_ = timeout_;
        this.progressCallback_ = progressCallback_;
        this.connectionFactory_ = connectionFactory_;
        this.pendingConnection_ = null;
        this.backoffId_ = null;
        this.canceled_ = false;
        this.appDelete_ = false;
        this.promise_ = new Promise((resolve, reject)=>{
            this.resolve_ = resolve;
            this.reject_ = reject;
            this.start_();
        });
    }
}
/**
 * A collection of information about the result of a network request.
 * @param opt_canceled - Defaults to false.
 */ class $57d582485a4bd356$var$RequestEndStatus {
    constructor(wasSuccessCode, connection, canceled){
        this.wasSuccessCode = wasSuccessCode;
        this.connection = connection;
        this.canceled = !!canceled;
    }
}
function $57d582485a4bd356$var$addAuthHeader_(headers, authToken) {
    if (authToken !== null && authToken.length > 0) headers["Authorization"] = "Firebase " + authToken;
}
function $57d582485a4bd356$var$addVersionHeader_(headers, firebaseVersion) {
    headers["X-Firebase-Storage-Version"] = "webjs/" + (firebaseVersion !== null && firebaseVersion !== void 0 ? firebaseVersion : "AppManager");
}
function $57d582485a4bd356$var$addGmpidHeader_(headers, appId) {
    if (appId) headers["X-Firebase-GMPID"] = appId;
}
function $57d582485a4bd356$var$addAppCheckHeader_(headers, appCheckToken) {
    if (appCheckToken !== null) headers["X-Firebase-AppCheck"] = appCheckToken;
}
function $57d582485a4bd356$var$makeRequest(requestInfo, appId, authToken, appCheckToken, requestFactory, firebaseVersion) {
    const queryPart = $57d582485a4bd356$var$makeQueryString(requestInfo.urlParams);
    const url = requestInfo.url + queryPart;
    const headers = Object.assign({}, requestInfo.headers);
    $57d582485a4bd356$var$addGmpidHeader_(headers, appId);
    $57d582485a4bd356$var$addAuthHeader_(headers, authToken);
    $57d582485a4bd356$var$addVersionHeader_(headers, firebaseVersion);
    $57d582485a4bd356$var$addAppCheckHeader_(headers, appCheckToken);
    return new $57d582485a4bd356$var$NetworkRequest(url, requestInfo.method, headers, requestInfo.body, requestInfo.successCodes, requestInfo.additionalRetryCodes, requestInfo.handler, requestInfo.errorHandler, requestInfo.timeout, requestInfo.progressCallback, requestFactory);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $57d582485a4bd356$var$getBlobBuilder() {
    if (typeof BlobBuilder !== "undefined") return BlobBuilder;
    else if (typeof WebKitBlobBuilder !== "undefined") return WebKitBlobBuilder;
    else return undefined;
}
/**
 * Concatenates one or more values together and converts them to a Blob.
 *
 * @param args The values that will make up the resulting blob.
 * @return The blob.
 */ function $57d582485a4bd356$var$getBlob$1(...args) {
    const BlobBuilder1 = $57d582485a4bd356$var$getBlobBuilder();
    if (BlobBuilder1 !== undefined) {
        const bb = new BlobBuilder1();
        for(let i = 0; i < args.length; i++)bb.append(args[i]);
        return bb.getBlob();
    } else {
        if ($57d582485a4bd356$var$isNativeBlobDefined()) return new Blob(args);
        else throw new $57d582485a4bd356$var$StorageError("unsupported-environment" /* UNSUPPORTED_ENVIRONMENT */ , "This browser doesn't seem to support creating Blobs");
    }
}
/**
 * Slices the blob. The returned blob contains data from the start byte
 * (inclusive) till the end byte (exclusive). Negative indices cannot be used.
 *
 * @param blob The blob to be sliced.
 * @param start Index of the starting byte.
 * @param end Index of the ending byte.
 * @return The blob slice or null if not supported.
 */ function $57d582485a4bd356$var$sliceBlob(blob, start, end) {
    if (blob.webkitSlice) return blob.webkitSlice(start, end);
    else if (blob.mozSlice) return blob.mozSlice(start, end);
    else if (blob.slice) return blob.slice(start, end);
    return null;
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Converts a Base64 encoded string to a binary string. */ function $57d582485a4bd356$var$decodeBase64(encoded) {
    return atob(encoded);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An enumeration of the possible string formats for upload.
 * @public
 */ const $57d582485a4bd356$export$f22e7fe56db8ae03 = {
    /**
     * Indicates the string should be interpreted "raw", that is, as normal text.
     * The string will be interpreted as UTF-16, then uploaded as a UTF-8 byte
     * sequence.
     * Example: The string 'Hello! \\ud83d\\ude0a' becomes the byte sequence
     * 48 65 6c 6c 6f 21 20 f0 9f 98 8a
     */ RAW: "raw",
    /**
     * Indicates the string should be interpreted as base64-encoded data.
     * Padding characters (trailing '='s) are optional.
     * Example: The string 'rWmO++E6t7/rlw==' becomes the byte sequence
     * ad 69 8e fb e1 3a b7 bf eb 97
     */ BASE64: "base64",
    /**
     * Indicates the string should be interpreted as base64url-encoded data.
     * Padding characters (trailing '='s) are optional.
     * Example: The string 'rWmO--E6t7_rlw==' becomes the byte sequence
     * ad 69 8e fb e1 3a b7 bf eb 97
     */ BASE64URL: "base64url",
    /**
     * Indicates the string is a data URL, such as one obtained from
     * canvas.toDataURL().
     * Example: the string 'data:application/octet-stream;base64,aaaa'
     * becomes the byte sequence
     * 69 a6 9a
     * (the content-type "application/octet-stream" is also applied, but can
     * be overridden in the metadata object).
     */ DATA_URL: "data_url"
};
class $57d582485a4bd356$var$StringData {
    constructor(data, contentType){
        this.data = data;
        this.contentType = contentType || null;
    }
}
/**
 * @internal
 */ function $57d582485a4bd356$export$d80b9b5a2ccdd3e0(format, stringData) {
    switch(format){
        case $57d582485a4bd356$export$f22e7fe56db8ae03.RAW:
            return new $57d582485a4bd356$var$StringData($57d582485a4bd356$var$utf8Bytes_(stringData));
        case $57d582485a4bd356$export$f22e7fe56db8ae03.BASE64:
        case $57d582485a4bd356$export$f22e7fe56db8ae03.BASE64URL:
            return new $57d582485a4bd356$var$StringData($57d582485a4bd356$var$base64Bytes_(format, stringData));
        case $57d582485a4bd356$export$f22e7fe56db8ae03.DATA_URL:
            return new $57d582485a4bd356$var$StringData($57d582485a4bd356$var$dataURLBytes_(stringData), $57d582485a4bd356$var$dataURLContentType_(stringData));
    }
    // assert(false);
    throw $57d582485a4bd356$var$unknown();
}
function $57d582485a4bd356$var$utf8Bytes_(value) {
    const b = [];
    for(let i = 0; i < value.length; i++){
        let c = value.charCodeAt(i);
        if (c <= 127) b.push(c);
        else if (c <= 2047) b.push(192 | c >> 6, 128 | c & 63);
        else {
            if ((c & 64512) === 55296) {
                // The start of a surrogate pair.
                const valid = i < value.length - 1 && (value.charCodeAt(i + 1) & 64512) === 56320;
                if (!valid) // The second surrogate wasn't there.
                b.push(239, 191, 189);
                else {
                    const hi = c;
                    const lo = value.charCodeAt(++i);
                    c = 65536 | (hi & 1023) << 10 | lo & 1023;
                    b.push(240 | c >> 18, 128 | c >> 12 & 63, 128 | c >> 6 & 63, 128 | c & 63);
                }
            } else if ((c & 64512) === 56320) // Invalid low surrogate.
            b.push(239, 191, 189);
            else b.push(224 | c >> 12, 128 | c >> 6 & 63, 128 | c & 63);
        }
    }
    return new Uint8Array(b);
}
function $57d582485a4bd356$var$percentEncodedBytes_(value) {
    let decoded;
    try {
        decoded = decodeURIComponent(value);
    } catch (e) {
        throw $57d582485a4bd356$var$invalidFormat($57d582485a4bd356$export$f22e7fe56db8ae03.DATA_URL, "Malformed data URL.");
    }
    return $57d582485a4bd356$var$utf8Bytes_(decoded);
}
function $57d582485a4bd356$var$base64Bytes_(format, value) {
    switch(format){
        case $57d582485a4bd356$export$f22e7fe56db8ae03.BASE64:
            {
                const hasMinus = value.indexOf("-") !== -1;
                const hasUnder = value.indexOf("_") !== -1;
                if (hasMinus || hasUnder) {
                    const invalidChar = hasMinus ? "-" : "_";
                    throw $57d582485a4bd356$var$invalidFormat(format, "Invalid character '" + invalidChar + "' found: is it base64url encoded?");
                }
                break;
            }
        case $57d582485a4bd356$export$f22e7fe56db8ae03.BASE64URL:
            {
                const hasPlus = value.indexOf("+") !== -1;
                const hasSlash = value.indexOf("/") !== -1;
                if (hasPlus || hasSlash) {
                    const invalidChar = hasPlus ? "+" : "/";
                    throw $57d582485a4bd356$var$invalidFormat(format, "Invalid character '" + invalidChar + "' found: is it base64 encoded?");
                }
                value = value.replace(/-/g, "+").replace(/_/g, "/");
                break;
            }
    }
    let bytes;
    try {
        bytes = $57d582485a4bd356$var$decodeBase64(value);
    } catch (e) {
        throw $57d582485a4bd356$var$invalidFormat(format, "Invalid character found");
    }
    const array = new Uint8Array(bytes.length);
    for(let i = 0; i < bytes.length; i++)array[i] = bytes.charCodeAt(i);
    return array;
}
class $57d582485a4bd356$var$DataURLParts {
    constructor(dataURL){
        this.base64 = false;
        this.contentType = null;
        const matches = dataURL.match(/^data:([^,]+)?,/);
        if (matches === null) throw $57d582485a4bd356$var$invalidFormat($57d582485a4bd356$export$f22e7fe56db8ae03.DATA_URL, "Must be formatted 'data:[<mediatype>][;base64],<data>");
        const middle = matches[1] || null;
        if (middle != null) {
            this.base64 = $57d582485a4bd356$var$endsWith(middle, ";base64");
            this.contentType = this.base64 ? middle.substring(0, middle.length - 7) : middle;
        }
        this.rest = dataURL.substring(dataURL.indexOf(",") + 1);
    }
}
function $57d582485a4bd356$var$dataURLBytes_(dataUrl) {
    const parts = new $57d582485a4bd356$var$DataURLParts(dataUrl);
    if (parts.base64) return $57d582485a4bd356$var$base64Bytes_($57d582485a4bd356$export$f22e7fe56db8ae03.BASE64, parts.rest);
    else return $57d582485a4bd356$var$percentEncodedBytes_(parts.rest);
}
function $57d582485a4bd356$var$dataURLContentType_(dataUrl) {
    const parts = new $57d582485a4bd356$var$DataURLParts(dataUrl);
    return parts.contentType;
}
function $57d582485a4bd356$var$endsWith(s, end) {
    const longEnough = s.length >= end.length;
    if (!longEnough) return false;
    return s.substring(s.length - end.length) === end;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @param opt_elideCopy - If true, doesn't copy mutable input data
 *     (e.g. Uint8Arrays). Pass true only if you know the objects will not be
 *     modified after this blob's construction.
 *
 * @internal
 */ class $57d582485a4bd356$export$8deea8629ff0b8a7 {
    size() {
        return this.size_;
    }
    type() {
        return this.type_;
    }
    slice(startByte, endByte) {
        if ($57d582485a4bd356$var$isNativeBlob(this.data_)) {
            const realBlob = this.data_;
            const sliced = $57d582485a4bd356$var$sliceBlob(realBlob, startByte, endByte);
            if (sliced === null) return null;
            return new $57d582485a4bd356$export$8deea8629ff0b8a7(sliced);
        } else {
            const slice = new Uint8Array(this.data_.buffer, startByte, endByte - startByte);
            return new $57d582485a4bd356$export$8deea8629ff0b8a7(slice, true);
        }
    }
    static getBlob(...args) {
        if ($57d582485a4bd356$var$isNativeBlobDefined()) {
            const blobby = args.map((val)=>{
                if (val instanceof $57d582485a4bd356$export$8deea8629ff0b8a7) return val.data_;
                else return val;
            });
            return new $57d582485a4bd356$export$8deea8629ff0b8a7($57d582485a4bd356$var$getBlob$1.apply(null, blobby));
        } else {
            const uint8Arrays = args.map((val)=>{
                if ($57d582485a4bd356$var$isString(val)) return $57d582485a4bd356$export$d80b9b5a2ccdd3e0($57d582485a4bd356$export$f22e7fe56db8ae03.RAW, val).data;
                else // Blobs don't exist, so this has to be a Uint8Array.
                return val.data_;
            });
            let finalLength = 0;
            uint8Arrays.forEach((array)=>{
                finalLength += array.byteLength;
            });
            const merged = new Uint8Array(finalLength);
            let index = 0;
            uint8Arrays.forEach((array)=>{
                for(let i = 0; i < array.length; i++)merged[index++] = array[i];
            });
            return new $57d582485a4bd356$export$8deea8629ff0b8a7(merged, true);
        }
    }
    uploadData() {
        return this.data_;
    }
    constructor(data, elideCopy){
        let size = 0;
        let blobType = "";
        if ($57d582485a4bd356$var$isNativeBlob(data)) {
            this.data_ = data;
            size = data.size;
            blobType = data.type;
        } else if (data instanceof ArrayBuffer) {
            if (elideCopy) this.data_ = new Uint8Array(data);
            else {
                this.data_ = new Uint8Array(data.byteLength);
                this.data_.set(new Uint8Array(data));
            }
            size = this.data_.length;
        } else if (data instanceof Uint8Array) {
            if (elideCopy) this.data_ = data;
            else {
                this.data_ = new Uint8Array(data.length);
                this.data_.set(data);
            }
            size = data.length;
        }
        this.size_ = size;
        this.type_ = blobType;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns the Object resulting from parsing the given JSON, or null if the
 * given string does not represent a JSON object.
 */ function $57d582485a4bd356$var$jsonObjectOrNull(s) {
    let obj;
    try {
        obj = JSON.parse(s);
    } catch (e) {
        return null;
    }
    if ($57d582485a4bd356$var$isNonArrayObject(obj)) return obj;
    else return null;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Contains helper methods for manipulating paths.
 */ /**
 * @return Null if the path is already at the root.
 */ function $57d582485a4bd356$var$parent(path) {
    if (path.length === 0) return null;
    const index = path.lastIndexOf("/");
    if (index === -1) return "";
    const newPath = path.slice(0, index);
    return newPath;
}
function $57d582485a4bd356$var$child(path, childPath) {
    const canonicalChildPath = childPath.split("/").filter((component)=>component.length > 0).join("/");
    if (path.length === 0) return canonicalChildPath;
    else return path + "/" + canonicalChildPath;
}
/**
 * Returns the last component of a path.
 * '/foo/bar' -> 'bar'
 * '/foo/bar/baz/' -> 'baz/'
 * '/a' -> 'a'
 */ function $57d582485a4bd356$var$lastComponent(path) {
    const index = path.lastIndexOf("/", path.length - 2);
    if (index === -1) return path;
    else return path.slice(index + 1);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $57d582485a4bd356$var$noXform_(metadata, value) {
    return value;
}
class $57d582485a4bd356$var$Mapping {
    constructor(server, local, writable, xform){
        this.server = server;
        this.local = local || server;
        this.writable = !!writable;
        this.xform = xform || $57d582485a4bd356$var$noXform_;
    }
}
let $57d582485a4bd356$var$mappings_ = null;
function $57d582485a4bd356$var$xformPath(fullPath) {
    if (!$57d582485a4bd356$var$isString(fullPath) || fullPath.length < 2) return fullPath;
    else return $57d582485a4bd356$var$lastComponent(fullPath);
}
function $57d582485a4bd356$var$getMappings() {
    if ($57d582485a4bd356$var$mappings_) return $57d582485a4bd356$var$mappings_;
    const mappings = [];
    mappings.push(new $57d582485a4bd356$var$Mapping("bucket"));
    mappings.push(new $57d582485a4bd356$var$Mapping("generation"));
    mappings.push(new $57d582485a4bd356$var$Mapping("metageneration"));
    mappings.push(new $57d582485a4bd356$var$Mapping("name", "fullPath", true));
    function mappingsXformPath(_metadata, fullPath) {
        return $57d582485a4bd356$var$xformPath(fullPath);
    }
    const nameMapping = new $57d582485a4bd356$var$Mapping("name");
    nameMapping.xform = mappingsXformPath;
    mappings.push(nameMapping);
    /**
     * Coerces the second param to a number, if it is defined.
     */ function xformSize(_metadata, size) {
        if (size !== undefined) return Number(size);
        else return size;
    }
    const sizeMapping = new $57d582485a4bd356$var$Mapping("size");
    sizeMapping.xform = xformSize;
    mappings.push(sizeMapping);
    mappings.push(new $57d582485a4bd356$var$Mapping("timeCreated"));
    mappings.push(new $57d582485a4bd356$var$Mapping("updated"));
    mappings.push(new $57d582485a4bd356$var$Mapping("md5Hash", null, true));
    mappings.push(new $57d582485a4bd356$var$Mapping("cacheControl", null, true));
    mappings.push(new $57d582485a4bd356$var$Mapping("contentDisposition", null, true));
    mappings.push(new $57d582485a4bd356$var$Mapping("contentEncoding", null, true));
    mappings.push(new $57d582485a4bd356$var$Mapping("contentLanguage", null, true));
    mappings.push(new $57d582485a4bd356$var$Mapping("contentType", null, true));
    mappings.push(new $57d582485a4bd356$var$Mapping("metadata", "customMetadata", true));
    $57d582485a4bd356$var$mappings_ = mappings;
    return $57d582485a4bd356$var$mappings_;
}
function $57d582485a4bd356$var$addRef(metadata, service) {
    function generateRef() {
        const bucket = metadata["bucket"];
        const path = metadata["fullPath"];
        const loc = new $57d582485a4bd356$export$adb98fff6714334(bucket, path);
        return service._makeStorageReference(loc);
    }
    Object.defineProperty(metadata, "ref", {
        get: generateRef
    });
}
function $57d582485a4bd356$var$fromResource(service, resource, mappings) {
    const metadata = {};
    metadata["type"] = "file";
    const len = mappings.length;
    for(let i = 0; i < len; i++){
        const mapping = mappings[i];
        metadata[mapping.local] = mapping.xform(metadata, resource[mapping.server]);
    }
    $57d582485a4bd356$var$addRef(metadata, service);
    return metadata;
}
function $57d582485a4bd356$var$fromResourceString(service, resourceString, mappings) {
    const obj = $57d582485a4bd356$var$jsonObjectOrNull(resourceString);
    if (obj === null) return null;
    const resource = obj;
    return $57d582485a4bd356$var$fromResource(service, resource, mappings);
}
function $57d582485a4bd356$var$downloadUrlFromResourceString(metadata, resourceString, host, protocol) {
    const obj = $57d582485a4bd356$var$jsonObjectOrNull(resourceString);
    if (obj === null) return null;
    if (!$57d582485a4bd356$var$isString(obj["downloadTokens"])) // This can happen if objects are uploaded through GCS and retrieved
    // through list, so we don't want to throw an Error.
    return null;
    const tokens = obj["downloadTokens"];
    if (tokens.length === 0) return null;
    const encode = encodeURIComponent;
    const tokensList = tokens.split(",");
    const urls = tokensList.map((token)=>{
        const bucket = metadata["bucket"];
        const path = metadata["fullPath"];
        const urlPart = "/b/" + encode(bucket) + "/o/" + encode(path);
        const base = $57d582485a4bd356$var$makeUrl(urlPart, host, protocol);
        const queryString = $57d582485a4bd356$var$makeQueryString({
            alt: "media",
            token: token
        });
        return base + queryString;
    });
    return urls[0];
}
function $57d582485a4bd356$var$toResourceString(metadata, mappings) {
    const resource = {};
    const len = mappings.length;
    for(let i = 0; i < len; i++){
        const mapping = mappings[i];
        if (mapping.writable) resource[mapping.server] = metadata[mapping.local];
    }
    return JSON.stringify(resource);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $57d582485a4bd356$var$PREFIXES_KEY = "prefixes";
const $57d582485a4bd356$var$ITEMS_KEY = "items";
function $57d582485a4bd356$var$fromBackendResponse(service, bucket, resource) {
    const listResult = {
        prefixes: [],
        items: [],
        nextPageToken: resource["nextPageToken"]
    };
    if (resource[$57d582485a4bd356$var$PREFIXES_KEY]) for (const path of resource[$57d582485a4bd356$var$PREFIXES_KEY]){
        const pathWithoutTrailingSlash = path.replace(/\/$/, "");
        const reference = service._makeStorageReference(new $57d582485a4bd356$export$adb98fff6714334(bucket, pathWithoutTrailingSlash));
        listResult.prefixes.push(reference);
    }
    if (resource[$57d582485a4bd356$var$ITEMS_KEY]) for (const item of resource[$57d582485a4bd356$var$ITEMS_KEY]){
        const reference = service._makeStorageReference(new $57d582485a4bd356$export$adb98fff6714334(bucket, item["name"]));
        listResult.items.push(reference);
    }
    return listResult;
}
function $57d582485a4bd356$var$fromResponseString(service, bucket, resourceString) {
    const obj = $57d582485a4bd356$var$jsonObjectOrNull(resourceString);
    if (obj === null) return null;
    const resource = obj;
    return $57d582485a4bd356$var$fromBackendResponse(service, bucket, resource);
}
/**
 * Contains a fully specified request.
 *
 * @param I - the type of the backend's network response.
 * @param O - the output response type used by the rest of the SDK.
 */ class $57d582485a4bd356$var$RequestInfo {
    constructor(url, method, /**
     * Returns the value with which to resolve the request's promise. Only called
     * if the request is successful. Throw from this function to reject the
     * returned Request's promise with the thrown error.
     * Note: The XhrIo passed to this function may be reused after this callback
     * returns. Do not keep a reference to it in any way.
     */ handler, timeout){
        this.url = url;
        this.method = method;
        this.handler = handler;
        this.timeout = timeout;
        this.urlParams = {};
        this.headers = {};
        this.body = null;
        this.errorHandler = null;
        /**
         * Called with the current number of bytes uploaded and total size (-1 if not
         * computable) of the request body (i.e. used to report upload progress).
         */ this.progressCallback = null;
        this.successCodes = [
            200
        ];
        this.additionalRetryCodes = [];
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Throws the UNKNOWN StorageError if cndn is false.
 */ function $57d582485a4bd356$var$handlerCheck(cndn) {
    if (!cndn) throw $57d582485a4bd356$var$unknown();
}
function $57d582485a4bd356$var$metadataHandler(service, mappings) {
    function handler(xhr, text) {
        const metadata = $57d582485a4bd356$var$fromResourceString(service, text, mappings);
        $57d582485a4bd356$var$handlerCheck(metadata !== null);
        return metadata;
    }
    return handler;
}
function $57d582485a4bd356$var$listHandler(service, bucket) {
    function handler(xhr, text) {
        const listResult = $57d582485a4bd356$var$fromResponseString(service, bucket, text);
        $57d582485a4bd356$var$handlerCheck(listResult !== null);
        return listResult;
    }
    return handler;
}
function $57d582485a4bd356$var$downloadUrlHandler(service, mappings) {
    function handler(xhr, text) {
        const metadata = $57d582485a4bd356$var$fromResourceString(service, text, mappings);
        $57d582485a4bd356$var$handlerCheck(metadata !== null);
        return $57d582485a4bd356$var$downloadUrlFromResourceString(metadata, text, service.host, service._protocol);
    }
    return handler;
}
function $57d582485a4bd356$var$sharedErrorHandler(location) {
    function errorHandler(xhr, err) {
        let newErr;
        if (xhr.getStatus() === 401) {
            if (// This exact message string is the only consistent part of the
            // server's error response that identifies it as an App Check error.
            xhr.getErrorText().includes("Firebase App Check token is invalid")) newErr = $57d582485a4bd356$var$unauthorizedApp();
            else newErr = $57d582485a4bd356$var$unauthenticated();
        } else {
            if (xhr.getStatus() === 402) newErr = $57d582485a4bd356$var$quotaExceeded(location.bucket);
            else if (xhr.getStatus() === 403) newErr = $57d582485a4bd356$var$unauthorized(location.path);
            else newErr = err;
        }
        newErr.serverResponse = err.serverResponse;
        return newErr;
    }
    return errorHandler;
}
function $57d582485a4bd356$var$objectErrorHandler(location) {
    const shared = $57d582485a4bd356$var$sharedErrorHandler(location);
    function errorHandler(xhr, err) {
        let newErr = shared(xhr, err);
        if (xhr.getStatus() === 404) newErr = $57d582485a4bd356$var$objectNotFound(location.path);
        newErr.serverResponse = err.serverResponse;
        return newErr;
    }
    return errorHandler;
}
function $57d582485a4bd356$var$getMetadata$2(service, location, mappings) {
    const urlPart = location.fullServerUrl();
    const url = $57d582485a4bd356$var$makeUrl(urlPart, service.host, service._protocol);
    const method = "GET";
    const timeout = service.maxOperationRetryTime;
    const requestInfo = new $57d582485a4bd356$var$RequestInfo(url, method, $57d582485a4bd356$var$metadataHandler(service, mappings), timeout);
    requestInfo.errorHandler = $57d582485a4bd356$var$objectErrorHandler(location);
    return requestInfo;
}
function $57d582485a4bd356$var$list$2(service, location, delimiter, pageToken, maxResults) {
    const urlParams = {};
    if (location.isRoot) urlParams["prefix"] = "";
    else urlParams["prefix"] = location.path + "/";
    if (delimiter && delimiter.length > 0) urlParams["delimiter"] = delimiter;
    if (pageToken) urlParams["pageToken"] = pageToken;
    if (maxResults) urlParams["maxResults"] = maxResults;
    const urlPart = location.bucketOnlyServerUrl();
    const url = $57d582485a4bd356$var$makeUrl(urlPart, service.host, service._protocol);
    const method = "GET";
    const timeout = service.maxOperationRetryTime;
    const requestInfo = new $57d582485a4bd356$var$RequestInfo(url, method, $57d582485a4bd356$var$listHandler(service, location.bucket), timeout);
    requestInfo.urlParams = urlParams;
    requestInfo.errorHandler = $57d582485a4bd356$var$sharedErrorHandler(location);
    return requestInfo;
}
function $57d582485a4bd356$var$getBytes$1(service, location, maxDownloadSizeBytes) {
    const urlPart = location.fullServerUrl();
    const url = $57d582485a4bd356$var$makeUrl(urlPart, service.host, service._protocol) + "?alt=media";
    const method = "GET";
    const timeout = service.maxOperationRetryTime;
    const requestInfo = new $57d582485a4bd356$var$RequestInfo(url, method, (_, data)=>data, timeout);
    requestInfo.errorHandler = $57d582485a4bd356$var$objectErrorHandler(location);
    if (maxDownloadSizeBytes !== undefined) {
        requestInfo.headers["Range"] = `bytes=0-${maxDownloadSizeBytes}`;
        requestInfo.successCodes = [
            200 /* OK */ ,
            206 /* Partial Content */ 
        ];
    }
    return requestInfo;
}
function $57d582485a4bd356$var$getDownloadUrl(service, location, mappings) {
    const urlPart = location.fullServerUrl();
    const url = $57d582485a4bd356$var$makeUrl(urlPart, service.host, service._protocol);
    const method = "GET";
    const timeout = service.maxOperationRetryTime;
    const requestInfo = new $57d582485a4bd356$var$RequestInfo(url, method, $57d582485a4bd356$var$downloadUrlHandler(service, mappings), timeout);
    requestInfo.errorHandler = $57d582485a4bd356$var$objectErrorHandler(location);
    return requestInfo;
}
function $57d582485a4bd356$var$updateMetadata$2(service, location, metadata, mappings) {
    const urlPart = location.fullServerUrl();
    const url = $57d582485a4bd356$var$makeUrl(urlPart, service.host, service._protocol);
    const method = "PATCH";
    const body = $57d582485a4bd356$var$toResourceString(metadata, mappings);
    const headers = {
        "Content-Type": "application/json; charset=utf-8"
    };
    const timeout = service.maxOperationRetryTime;
    const requestInfo = new $57d582485a4bd356$var$RequestInfo(url, method, $57d582485a4bd356$var$metadataHandler(service, mappings), timeout);
    requestInfo.headers = headers;
    requestInfo.body = body;
    requestInfo.errorHandler = $57d582485a4bd356$var$objectErrorHandler(location);
    return requestInfo;
}
function $57d582485a4bd356$var$deleteObject$2(service, location) {
    const urlPart = location.fullServerUrl();
    const url = $57d582485a4bd356$var$makeUrl(urlPart, service.host, service._protocol);
    const method = "DELETE";
    const timeout = service.maxOperationRetryTime;
    function handler(_xhr, _text) {}
    const requestInfo = new $57d582485a4bd356$var$RequestInfo(url, method, handler, timeout);
    requestInfo.successCodes = [
        200,
        204
    ];
    requestInfo.errorHandler = $57d582485a4bd356$var$objectErrorHandler(location);
    return requestInfo;
}
function $57d582485a4bd356$var$determineContentType_(metadata, blob) {
    return metadata && metadata["contentType"] || blob && blob.type() || "application/octet-stream";
}
function $57d582485a4bd356$var$metadataForUpload_(location, blob, metadata) {
    const metadataClone = Object.assign({}, metadata);
    metadataClone["fullPath"] = location.path;
    metadataClone["size"] = blob.size();
    if (!metadataClone["contentType"]) metadataClone["contentType"] = $57d582485a4bd356$var$determineContentType_(null, blob);
    return metadataClone;
}
/**
 * Prepare RequestInfo for uploads as Content-Type: multipart.
 */ function $57d582485a4bd356$var$multipartUpload(service, location, mappings, blob, metadata) {
    const urlPart = location.bucketOnlyServerUrl();
    const headers = {
        "X-Goog-Upload-Protocol": "multipart"
    };
    function genBoundary() {
        let str = "";
        for(let i = 0; i < 2; i++)str = str + Math.random().toString().slice(2);
        return str;
    }
    const boundary = genBoundary();
    headers["Content-Type"] = "multipart/related; boundary=" + boundary;
    const metadata_ = $57d582485a4bd356$var$metadataForUpload_(location, blob, metadata);
    const metadataString = $57d582485a4bd356$var$toResourceString(metadata_, mappings);
    const preBlobPart = "--" + boundary + "\r\n" + "Content-Type: application/json; charset=utf-8\r\n\r\n" + metadataString + "\r\n--" + boundary + "\r\n" + "Content-Type: " + metadata_["contentType"] + "\r\n\r\n";
    const postBlobPart = "\r\n--" + boundary + "--";
    const body = $57d582485a4bd356$export$8deea8629ff0b8a7.getBlob(preBlobPart, blob, postBlobPart);
    if (body === null) throw $57d582485a4bd356$var$cannotSliceBlob();
    const urlParams = {
        name: metadata_["fullPath"]
    };
    const url = $57d582485a4bd356$var$makeUrl(urlPart, service.host, service._protocol);
    const method = "POST";
    const timeout = service.maxUploadRetryTime;
    const requestInfo = new $57d582485a4bd356$var$RequestInfo(url, method, $57d582485a4bd356$var$metadataHandler(service, mappings), timeout);
    requestInfo.urlParams = urlParams;
    requestInfo.headers = headers;
    requestInfo.body = body.uploadData();
    requestInfo.errorHandler = $57d582485a4bd356$var$sharedErrorHandler(location);
    return requestInfo;
}
/**
 * @param current The number of bytes that have been uploaded so far.
 * @param total The total number of bytes in the upload.
 * @param opt_finalized True if the server has finished the upload.
 * @param opt_metadata The upload metadata, should
 *     only be passed if opt_finalized is true.
 */ class $57d582485a4bd356$var$ResumableUploadStatus {
    constructor(current, total, finalized, metadata){
        this.current = current;
        this.total = total;
        this.finalized = !!finalized;
        this.metadata = metadata || null;
    }
}
function $57d582485a4bd356$var$checkResumeHeader_(xhr, allowed) {
    let status = null;
    try {
        status = xhr.getResponseHeader("X-Goog-Upload-Status");
    } catch (e) {
        $57d582485a4bd356$var$handlerCheck(false);
    }
    const allowedStatus = allowed || [
        "active"
    ];
    $57d582485a4bd356$var$handlerCheck(!!status && allowedStatus.indexOf(status) !== -1);
    return status;
}
function $57d582485a4bd356$var$createResumableUpload(service, location, mappings, blob, metadata) {
    const urlPart = location.bucketOnlyServerUrl();
    const metadataForUpload = $57d582485a4bd356$var$metadataForUpload_(location, blob, metadata);
    const urlParams = {
        name: metadataForUpload["fullPath"]
    };
    const url = $57d582485a4bd356$var$makeUrl(urlPart, service.host, service._protocol);
    const method = "POST";
    const headers = {
        "X-Goog-Upload-Protocol": "resumable",
        "X-Goog-Upload-Command": "start",
        "X-Goog-Upload-Header-Content-Length": `${blob.size()}`,
        "X-Goog-Upload-Header-Content-Type": metadataForUpload["contentType"],
        "Content-Type": "application/json; charset=utf-8"
    };
    const body = $57d582485a4bd356$var$toResourceString(metadataForUpload, mappings);
    const timeout = service.maxUploadRetryTime;
    function handler(xhr) {
        $57d582485a4bd356$var$checkResumeHeader_(xhr);
        let url;
        try {
            url = xhr.getResponseHeader("X-Goog-Upload-URL");
        } catch (e) {
            $57d582485a4bd356$var$handlerCheck(false);
        }
        $57d582485a4bd356$var$handlerCheck($57d582485a4bd356$var$isString(url));
        return url;
    }
    const requestInfo = new $57d582485a4bd356$var$RequestInfo(url, method, handler, timeout);
    requestInfo.urlParams = urlParams;
    requestInfo.headers = headers;
    requestInfo.body = body;
    requestInfo.errorHandler = $57d582485a4bd356$var$sharedErrorHandler(location);
    return requestInfo;
}
/**
 * @param url From a call to fbs.requests.createResumableUpload.
 */ function $57d582485a4bd356$var$getResumableUploadStatus(service, location, url, blob) {
    const headers = {
        "X-Goog-Upload-Command": "query"
    };
    function handler(xhr) {
        const status = $57d582485a4bd356$var$checkResumeHeader_(xhr, [
            "active",
            "final"
        ]);
        let sizeString = null;
        try {
            sizeString = xhr.getResponseHeader("X-Goog-Upload-Size-Received");
        } catch (e) {
            $57d582485a4bd356$var$handlerCheck(false);
        }
        if (!sizeString) // null or empty string
        $57d582485a4bd356$var$handlerCheck(false);
        const size = Number(sizeString);
        $57d582485a4bd356$var$handlerCheck(!isNaN(size));
        return new $57d582485a4bd356$var$ResumableUploadStatus(size, blob.size(), status === "final");
    }
    const method = "POST";
    const timeout = service.maxUploadRetryTime;
    const requestInfo = new $57d582485a4bd356$var$RequestInfo(url, method, handler, timeout);
    requestInfo.headers = headers;
    requestInfo.errorHandler = $57d582485a4bd356$var$sharedErrorHandler(location);
    return requestInfo;
}
/**
 * Any uploads via the resumable upload API must transfer a number of bytes
 * that is a multiple of this number.
 */ const $57d582485a4bd356$var$RESUMABLE_UPLOAD_CHUNK_SIZE = 262144;
/**
 * @param url From a call to fbs.requests.createResumableUpload.
 * @param chunkSize Number of bytes to upload.
 * @param status The previous status.
 *     If not passed or null, we start from the beginning.
 * @throws fbs.Error If the upload is already complete, the passed in status
 *     has a final size inconsistent with the blob, or the blob cannot be sliced
 *     for upload.
 */ function $57d582485a4bd356$var$continueResumableUpload(location, service, url, blob, chunkSize, mappings, status, progressCallback) {
    // TODO(andysoto): standardize on internal asserts
    // assert(!(opt_status && opt_status.finalized));
    const status_ = new $57d582485a4bd356$var$ResumableUploadStatus(0, 0);
    if (status) {
        status_.current = status.current;
        status_.total = status.total;
    } else {
        status_.current = 0;
        status_.total = blob.size();
    }
    if (blob.size() !== status_.total) throw $57d582485a4bd356$var$serverFileWrongSize();
    const bytesLeft = status_.total - status_.current;
    let bytesToUpload = bytesLeft;
    if (chunkSize > 0) bytesToUpload = Math.min(bytesToUpload, chunkSize);
    const startByte = status_.current;
    const endByte = startByte + bytesToUpload;
    const uploadCommand = bytesToUpload === bytesLeft ? "upload, finalize" : "upload";
    const headers = {
        "X-Goog-Upload-Command": uploadCommand,
        "X-Goog-Upload-Offset": `${status_.current}`
    };
    const body = blob.slice(startByte, endByte);
    if (body === null) throw $57d582485a4bd356$var$cannotSliceBlob();
    function handler(xhr, text) {
        // TODO(andysoto): Verify the MD5 of each uploaded range:
        // the 'x-range-md5' header comes back with status code 308 responses.
        // We'll only be able to bail out though, because you can't re-upload a
        // range that you previously uploaded.
        const uploadStatus = $57d582485a4bd356$var$checkResumeHeader_(xhr, [
            "active",
            "final"
        ]);
        const newCurrent = status_.current + bytesToUpload;
        const size = blob.size();
        let metadata;
        if (uploadStatus === "final") metadata = $57d582485a4bd356$var$metadataHandler(service, mappings)(xhr, text);
        else metadata = null;
        return new $57d582485a4bd356$var$ResumableUploadStatus(newCurrent, size, uploadStatus === "final", metadata);
    }
    const method = "POST";
    const timeout = service.maxUploadRetryTime;
    const requestInfo = new $57d582485a4bd356$var$RequestInfo(url, method, handler, timeout);
    requestInfo.headers = headers;
    requestInfo.body = body.uploadData();
    requestInfo.progressCallback = progressCallback || null;
    requestInfo.errorHandler = $57d582485a4bd356$var$sharedErrorHandler(location);
    return requestInfo;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An event that is triggered on a task.
 * @internal
 */ const $57d582485a4bd356$export$2cf04e0422ce9b07 = {
    /**
     * For this event,
     * <ul>
     *   <li>The `next` function is triggered on progress updates and when the
     *       task is paused/resumed with an `UploadTaskSnapshot` as the first
     *       argument.</li>
     *   <li>The `error` function is triggered if the upload is canceled or fails
     *       for another reason.</li>
     *   <li>The `complete` function is triggered if the upload completes
     *       successfully.</li>
     * </ul>
     */ STATE_CHANGED: "state_changed"
};
// type keys = keyof TaskState
/**
 * Represents the current state of a running upload.
 * @internal
 */ const $57d582485a4bd356$export$9dc4203728a9a7c9 = {
    /** The task is currently transferring data. */ RUNNING: "running",
    /** The task was paused by the user. */ PAUSED: "paused",
    /** The task completed successfully. */ SUCCESS: "success",
    /** The task was canceled. */ CANCELED: "canceled",
    /** The task failed with an error. */ ERROR: "error"
};
function $57d582485a4bd356$var$taskStateFromInternalTaskState(state) {
    switch(state){
        case "running" /* RUNNING */ :
        case "pausing" /* PAUSING */ :
        case "canceling" /* CANCELING */ :
            return $57d582485a4bd356$export$9dc4203728a9a7c9.RUNNING;
        case "paused" /* PAUSED */ :
            return $57d582485a4bd356$export$9dc4203728a9a7c9.PAUSED;
        case "success" /* SUCCESS */ :
            return $57d582485a4bd356$export$9dc4203728a9a7c9.SUCCESS;
        case "canceled" /* CANCELED */ :
            return $57d582485a4bd356$export$9dc4203728a9a7c9.CANCELED;
        case "error" /* ERROR */ :
            return $57d582485a4bd356$export$9dc4203728a9a7c9.ERROR;
        default:
            // TODO(andysoto): assert(false);
            return $57d582485a4bd356$export$9dc4203728a9a7c9.ERROR;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $57d582485a4bd356$var$Observer {
    constructor(nextOrObserver, error, complete){
        const asFunctions = $57d582485a4bd356$var$isFunction(nextOrObserver) || error != null || complete != null;
        if (asFunctions) {
            this.next = nextOrObserver;
            this.error = error !== null && error !== void 0 ? error : undefined;
            this.complete = complete !== null && complete !== void 0 ? complete : undefined;
        } else {
            const observer = nextOrObserver;
            this.next = observer.next;
            this.error = observer.error;
            this.complete = observer.complete;
        }
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a function that invokes f with its arguments asynchronously as a
 * microtask, i.e. as soon as possible after the current script returns back
 * into browser code.
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $57d582485a4bd356$var$async(f) {
    return (...argsToForward)=>{
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        Promise.resolve().then(()=>f(...argsToForward));
    };
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** An override for the text-based Connection. Used in tests. */ let $57d582485a4bd356$var$textFactoryOverride = null;
/**
 * Network layer for browsers. We use this instead of goog.net.XhrIo because
 * goog.net.XhrIo is hyuuuuge and doesn't work in React Native on Android.
 */ class $57d582485a4bd356$var$XhrConnection {
    send(url, method, body, headers) {
        if (this.sent_) throw $57d582485a4bd356$var$internalError("cannot .send() more than once");
        this.sent_ = true;
        this.xhr_.open(method, url, true);
        if (headers !== undefined) {
            for(const key in headers)if (headers.hasOwnProperty(key)) this.xhr_.setRequestHeader(key, headers[key].toString());
        }
        if (body !== undefined) this.xhr_.send(body);
        else this.xhr_.send();
        return this.sendPromise_;
    }
    getErrorCode() {
        if (!this.sent_) throw $57d582485a4bd356$var$internalError("cannot .getErrorCode() before sending");
        return this.errorCode_;
    }
    getStatus() {
        if (!this.sent_) throw $57d582485a4bd356$var$internalError("cannot .getStatus() before sending");
        try {
            return this.xhr_.status;
        } catch (e) {
            return -1;
        }
    }
    getResponse() {
        if (!this.sent_) throw $57d582485a4bd356$var$internalError("cannot .getResponse() before sending");
        return this.xhr_.response;
    }
    getErrorText() {
        if (!this.sent_) throw $57d582485a4bd356$var$internalError("cannot .getErrorText() before sending");
        return this.xhr_.statusText;
    }
    /** Aborts the request. */ abort() {
        this.xhr_.abort();
    }
    getResponseHeader(header) {
        return this.xhr_.getResponseHeader(header);
    }
    addUploadProgressListener(listener) {
        if (this.xhr_.upload != null) this.xhr_.upload.addEventListener("progress", listener);
    }
    removeUploadProgressListener(listener) {
        if (this.xhr_.upload != null) this.xhr_.upload.removeEventListener("progress", listener);
    }
    constructor(){
        this.sent_ = false;
        this.xhr_ = new XMLHttpRequest();
        this.initXhr();
        this.errorCode_ = $57d582485a4bd356$var$ErrorCode.NO_ERROR;
        this.sendPromise_ = new Promise((resolve)=>{
            this.xhr_.addEventListener("abort", ()=>{
                this.errorCode_ = $57d582485a4bd356$var$ErrorCode.ABORT;
                resolve();
            });
            this.xhr_.addEventListener("error", ()=>{
                this.errorCode_ = $57d582485a4bd356$var$ErrorCode.NETWORK_ERROR;
                resolve();
            });
            this.xhr_.addEventListener("load", ()=>{
                resolve();
            });
        });
    }
}
class $57d582485a4bd356$var$XhrTextConnection extends $57d582485a4bd356$var$XhrConnection {
    initXhr() {
        this.xhr_.responseType = "text";
    }
}
function $57d582485a4bd356$var$newTextConnection() {
    return $57d582485a4bd356$var$textFactoryOverride ? $57d582485a4bd356$var$textFactoryOverride() : new $57d582485a4bd356$var$XhrTextConnection();
}
class $57d582485a4bd356$var$XhrBytesConnection extends $57d582485a4bd356$var$XhrConnection {
    initXhr() {
        this.xhr_.responseType = "arraybuffer";
    }
}
function $57d582485a4bd356$var$newBytesConnection() {
    return new $57d582485a4bd356$var$XhrBytesConnection();
}
class $57d582485a4bd356$var$XhrBlobConnection extends $57d582485a4bd356$var$XhrConnection {
    initXhr() {
        this.xhr_.responseType = "blob";
    }
}
function $57d582485a4bd356$var$newBlobConnection() {
    return new $57d582485a4bd356$var$XhrBlobConnection();
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a blob being uploaded. Can be used to pause/resume/cancel the
 * upload and manage callbacks for various events.
 * @internal
 */ class $57d582485a4bd356$export$86a2a9b92406a048 {
    _makeProgressCallback() {
        const sizeBefore = this._transferred;
        return (loaded)=>this._updateProgress(sizeBefore + loaded);
    }
    _shouldDoResumable(blob) {
        return blob.size() > 262144;
    }
    _start() {
        if (this._state !== "running" /* RUNNING */ ) // This can happen if someone pauses us in a resume callback, for example.
        return;
        if (this._request !== undefined) return;
        if (this._resumable) {
            if (this._uploadUrl === undefined) this._createResumable();
            else {
                if (this._needToFetchStatus) this._fetchStatus();
                else if (this._needToFetchMetadata) // Happens if we miss the metadata on upload completion.
                this._fetchMetadata();
                else this._continueUpload();
            }
        } else this._oneShotUpload();
    }
    _resolveToken(callback) {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        Promise.all([
            this._ref.storage._getAuthToken(),
            this._ref.storage._getAppCheckToken()
        ]).then(([authToken, appCheckToken])=>{
            switch(this._state){
                case "running" /* RUNNING */ :
                    callback(authToken, appCheckToken);
                    break;
                case "canceling" /* CANCELING */ :
                    this._transition("canceled" /* CANCELED */ );
                    break;
                case "pausing" /* PAUSING */ :
                    this._transition("paused" /* PAUSED */ );
                    break;
            }
        });
    }
    // TODO(andysoto): assert false
    _createResumable() {
        this._resolveToken((authToken, appCheckToken)=>{
            const requestInfo = $57d582485a4bd356$var$createResumableUpload(this._ref.storage, this._ref._location, this._mappings, this._blob, this._metadata);
            const createRequest = this._ref.storage._makeRequest(requestInfo, $57d582485a4bd356$var$newTextConnection, authToken, appCheckToken);
            this._request = createRequest;
            createRequest.getPromise().then((url)=>{
                this._request = undefined;
                this._uploadUrl = url;
                this._needToFetchStatus = false;
                this.completeTransitions_();
            }, this._errorHandler);
        });
    }
    _fetchStatus() {
        // TODO(andysoto): assert(this.uploadUrl_ !== null);
        const url = this._uploadUrl;
        this._resolveToken((authToken, appCheckToken)=>{
            const requestInfo = $57d582485a4bd356$var$getResumableUploadStatus(this._ref.storage, this._ref._location, url, this._blob);
            const statusRequest = this._ref.storage._makeRequest(requestInfo, $57d582485a4bd356$var$newTextConnection, authToken, appCheckToken);
            this._request = statusRequest;
            statusRequest.getPromise().then((status)=>{
                status;
                this._request = undefined;
                this._updateProgress(status.current);
                this._needToFetchStatus = false;
                if (status.finalized) this._needToFetchMetadata = true;
                this.completeTransitions_();
            }, this._errorHandler);
        });
    }
    _continueUpload() {
        const chunkSize = $57d582485a4bd356$var$RESUMABLE_UPLOAD_CHUNK_SIZE * this._chunkMultiplier;
        const status = new $57d582485a4bd356$var$ResumableUploadStatus(this._transferred, this._blob.size());
        // TODO(andysoto): assert(this.uploadUrl_ !== null);
        const url = this._uploadUrl;
        this._resolveToken((authToken, appCheckToken)=>{
            let requestInfo;
            try {
                requestInfo = $57d582485a4bd356$var$continueResumableUpload(this._ref._location, this._ref.storage, url, this._blob, chunkSize, this._mappings, status, this._makeProgressCallback());
            } catch (e) {
                this._error = e;
                this._transition("error" /* ERROR */ );
                return;
            }
            const uploadRequest = this._ref.storage._makeRequest(requestInfo, $57d582485a4bd356$var$newTextConnection, authToken, appCheckToken);
            this._request = uploadRequest;
            uploadRequest.getPromise().then((newStatus)=>{
                this._increaseMultiplier();
                this._request = undefined;
                this._updateProgress(newStatus.current);
                if (newStatus.finalized) {
                    this._metadata = newStatus.metadata;
                    this._transition("success" /* SUCCESS */ );
                } else this.completeTransitions_();
            }, this._errorHandler);
        });
    }
    _increaseMultiplier() {
        const currentSize = $57d582485a4bd356$var$RESUMABLE_UPLOAD_CHUNK_SIZE * this._chunkMultiplier;
        // Max chunk size is 32M.
        if (currentSize < 33554432) this._chunkMultiplier *= 2;
    }
    _fetchMetadata() {
        this._resolveToken((authToken, appCheckToken)=>{
            const requestInfo = $57d582485a4bd356$var$getMetadata$2(this._ref.storage, this._ref._location, this._mappings);
            const metadataRequest = this._ref.storage._makeRequest(requestInfo, $57d582485a4bd356$var$newTextConnection, authToken, appCheckToken);
            this._request = metadataRequest;
            metadataRequest.getPromise().then((metadata)=>{
                this._request = undefined;
                this._metadata = metadata;
                this._transition("success" /* SUCCESS */ );
            }, this._metadataErrorHandler);
        });
    }
    _oneShotUpload() {
        this._resolveToken((authToken, appCheckToken)=>{
            const requestInfo = $57d582485a4bd356$var$multipartUpload(this._ref.storage, this._ref._location, this._mappings, this._blob, this._metadata);
            const multipartRequest = this._ref.storage._makeRequest(requestInfo, $57d582485a4bd356$var$newTextConnection, authToken, appCheckToken);
            this._request = multipartRequest;
            multipartRequest.getPromise().then((metadata)=>{
                this._request = undefined;
                this._metadata = metadata;
                this._updateProgress(this._blob.size());
                this._transition("success" /* SUCCESS */ );
            }, this._errorHandler);
        });
    }
    _updateProgress(transferred) {
        const old = this._transferred;
        this._transferred = transferred;
        // A progress update can make the "transferred" value smaller (e.g. a
        // partial upload not completed by server, after which the "transferred"
        // value may reset to the value at the beginning of the request).
        if (this._transferred !== old) this._notifyObservers();
    }
    _transition(state) {
        if (this._state === state) return;
        switch(state){
            case "canceling" /* CANCELING */ :
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.RUNNING ||
                //        this.state_ === InternalTaskState.PAUSING);
                this._state = state;
                if (this._request !== undefined) this._request.cancel();
                break;
            case "pausing" /* PAUSING */ :
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.RUNNING);
                this._state = state;
                if (this._request !== undefined) this._request.cancel();
                break;
            case "running" /* RUNNING */ :
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.PAUSED ||
                //        this.state_ === InternalTaskState.PAUSING);
                const wasPaused = this._state === "paused" /* PAUSED */ ;
                this._state = state;
                if (wasPaused) {
                    this._notifyObservers();
                    this._start();
                }
                break;
            case "paused" /* PAUSED */ :
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.PAUSING);
                this._state = state;
                this._notifyObservers();
                break;
            case "canceled" /* CANCELED */ :
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.PAUSED ||
                //        this.state_ === InternalTaskState.CANCELING);
                this._error = $57d582485a4bd356$var$canceled();
                this._state = state;
                this._notifyObservers();
                break;
            case "error" /* ERROR */ :
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.RUNNING ||
                //        this.state_ === InternalTaskState.PAUSING ||
                //        this.state_ === InternalTaskState.CANCELING);
                this._state = state;
                this._notifyObservers();
                break;
            case "success" /* SUCCESS */ :
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.RUNNING ||
                //        this.state_ === InternalTaskState.PAUSING ||
                //        this.state_ === InternalTaskState.CANCELING);
                this._state = state;
                this._notifyObservers();
                break;
        }
    }
    completeTransitions_() {
        switch(this._state){
            case "pausing" /* PAUSING */ :
                this._transition("paused" /* PAUSED */ );
                break;
            case "canceling" /* CANCELING */ :
                this._transition("canceled" /* CANCELED */ );
                break;
            case "running" /* RUNNING */ :
                this._start();
                break;
        }
    }
    /**
     * A snapshot of the current task state.
     */ get snapshot() {
        const externalState = $57d582485a4bd356$var$taskStateFromInternalTaskState(this._state);
        return {
            bytesTransferred: this._transferred,
            totalBytes: this._blob.size(),
            state: externalState,
            metadata: this._metadata,
            task: this,
            ref: this._ref
        };
    }
    /**
     * Adds a callback for an event.
     * @param type - The type of event to listen for.
     * @param nextOrObserver -
     *     The `next` function, which gets called for each item in
     *     the event stream, or an observer object with some or all of these three
     *     properties (`next`, `error`, `complete`).
     * @param error - A function that gets called with a `StorageError`
     *     if the event stream ends due to an error.
     * @param completed - A function that gets called if the
     *     event stream ends normally.
     * @returns
     *     If only the event argument is passed, returns a function you can use to
     *     add callbacks (see the examples above). If more than just the event
     *     argument is passed, returns a function you can call to unregister the
     *     callbacks.
     */ on(type, nextOrObserver, error, completed) {
        const observer = new $57d582485a4bd356$var$Observer(nextOrObserver || undefined, error || undefined, completed || undefined);
        this._addObserver(observer);
        return ()=>{
            this._removeObserver(observer);
        };
    }
    /**
     * This object behaves like a Promise, and resolves with its snapshot data
     * when the upload completes.
     * @param onFulfilled - The fulfillment callback. Promise chaining works as normal.
     * @param onRejected - The rejection callback.
     */ then(onFulfilled, onRejected) {
        // These casts are needed so that TypeScript can infer the types of the
        // resulting Promise.
        return this._promise.then(onFulfilled, onRejected);
    }
    /**
     * Equivalent to calling `then(null, onRejected)`.
     */ catch(onRejected) {
        return this.then(null, onRejected);
    }
    /**
     * Adds the given observer.
     */ _addObserver(observer) {
        this._observers.push(observer);
        this._notifyObserver(observer);
    }
    /**
     * Removes the given observer.
     */ _removeObserver(observer) {
        const i = this._observers.indexOf(observer);
        if (i !== -1) this._observers.splice(i, 1);
    }
    _notifyObservers() {
        this._finishPromise();
        const observers = this._observers.slice();
        observers.forEach((observer)=>{
            this._notifyObserver(observer);
        });
    }
    _finishPromise() {
        if (this._resolve !== undefined) {
            let triggered = true;
            switch($57d582485a4bd356$var$taskStateFromInternalTaskState(this._state)){
                case $57d582485a4bd356$export$9dc4203728a9a7c9.SUCCESS:
                    $57d582485a4bd356$var$async(this._resolve.bind(null, this.snapshot))();
                    break;
                case $57d582485a4bd356$export$9dc4203728a9a7c9.CANCELED:
                case $57d582485a4bd356$export$9dc4203728a9a7c9.ERROR:
                    const toCall = this._reject;
                    $57d582485a4bd356$var$async(toCall.bind(null, this._error))();
                    break;
                default:
                    triggered = false;
                    break;
            }
            if (triggered) {
                this._resolve = undefined;
                this._reject = undefined;
            }
        }
    }
    _notifyObserver(observer) {
        const externalState = $57d582485a4bd356$var$taskStateFromInternalTaskState(this._state);
        switch(externalState){
            case $57d582485a4bd356$export$9dc4203728a9a7c9.RUNNING:
            case $57d582485a4bd356$export$9dc4203728a9a7c9.PAUSED:
                if (observer.next) $57d582485a4bd356$var$async(observer.next.bind(observer, this.snapshot))();
                break;
            case $57d582485a4bd356$export$9dc4203728a9a7c9.SUCCESS:
                if (observer.complete) $57d582485a4bd356$var$async(observer.complete.bind(observer))();
                break;
            case $57d582485a4bd356$export$9dc4203728a9a7c9.CANCELED:
            case $57d582485a4bd356$export$9dc4203728a9a7c9.ERROR:
                if (observer.error) $57d582485a4bd356$var$async(observer.error.bind(observer, this._error))();
                break;
            default:
                // TODO(andysoto): assert(false);
                if (observer.error) $57d582485a4bd356$var$async(observer.error.bind(observer, this._error))();
        }
    }
    /**
     * Resumes a paused task. Has no effect on a currently running or failed task.
     * @returns True if the operation took effect, false if ignored.
     */ resume() {
        const valid = this._state === "paused" /* PAUSED */  || this._state === "pausing" /* PAUSING */ ;
        if (valid) this._transition("running" /* RUNNING */ );
        return valid;
    }
    /**
     * Pauses a currently running task. Has no effect on a paused or failed task.
     * @returns True if the operation took effect, false if ignored.
     */ pause() {
        const valid = this._state === "running" /* RUNNING */ ;
        if (valid) this._transition("pausing" /* PAUSING */ );
        return valid;
    }
    /**
     * Cancels a currently running or paused task. Has no effect on a complete or
     * failed task.
     * @returns True if the operation took effect, false if ignored.
     */ cancel() {
        const valid = this._state === "running" /* RUNNING */  || this._state === "pausing" /* PAUSING */ ;
        if (valid) this._transition("canceling" /* CANCELING */ );
        return valid;
    }
    /**
     * @param ref - The firebaseStorage.Reference object this task came
     *     from, untyped to avoid cyclic dependencies.
     * @param blob - The blob to upload.
     */ constructor(ref, blob, metadata = null){
        /**
         * Number of bytes transferred so far.
         */ this._transferred = 0;
        this._needToFetchStatus = false;
        this._needToFetchMetadata = false;
        this._observers = [];
        this._error = undefined;
        this._uploadUrl = undefined;
        this._request = undefined;
        this._chunkMultiplier = 1;
        this._resolve = undefined;
        this._reject = undefined;
        this._ref = ref;
        this._blob = blob;
        this._metadata = metadata;
        this._mappings = $57d582485a4bd356$var$getMappings();
        this._resumable = this._shouldDoResumable(this._blob);
        this._state = "running" /* RUNNING */ ;
        this._errorHandler = (error)=>{
            this._request = undefined;
            this._chunkMultiplier = 1;
            if (error._codeEquals("canceled" /* CANCELED */ )) {
                this._needToFetchStatus = true;
                this.completeTransitions_();
            } else {
                this._error = error;
                this._transition("error" /* ERROR */ );
            }
        };
        this._metadataErrorHandler = (error)=>{
            this._request = undefined;
            if (error._codeEquals("canceled" /* CANCELED */ )) this.completeTransitions_();
            else {
                this._error = error;
                this._transition("error" /* ERROR */ );
            }
        };
        this._promise = new Promise((resolve, reject)=>{
            this._resolve = resolve;
            this._reject = reject;
            this._start();
        });
        // Prevent uncaught rejections on the internal promise from bubbling out
        // to the top level with a dummy handler.
        this._promise.then(null, ()=>{});
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provides methods to interact with a bucket in the Firebase Storage service.
 * @internal
 * @param _location - An fbs.location, or the URL at
 *     which to base this object, in one of the following forms:
 *         gs://<bucket>/<object-path>
 *         http[s]://firebasestorage.googleapis.com/
 *                     <api-version>/b/<bucket>/o/<object-path>
 *     Any query or fragment strings will be ignored in the http[s]
 *     format. If no value is passed, the storage object will use a URL based on
 *     the project ID of the base firebase.App instance.
 */ class $57d582485a4bd356$var$Reference {
    /**
     * Returns the URL for the bucket and path this object references,
     *     in the form gs://<bucket>/<object-path>
     * @override
     */ toString() {
        return "gs://" + this._location.bucket + "/" + this._location.path;
    }
    _newRef(service, location) {
        return new $57d582485a4bd356$var$Reference(service, location);
    }
    /**
     * A reference to the root of this object's bucket.
     */ get root() {
        const location = new $57d582485a4bd356$export$adb98fff6714334(this._location.bucket, "");
        return this._newRef(this._service, location);
    }
    /**
     * The name of the bucket containing this reference's object.
     */ get bucket() {
        return this._location.bucket;
    }
    /**
     * The full path of this object.
     */ get fullPath() {
        return this._location.path;
    }
    /**
     * The short name of this object, which is the last component of the full path.
     * For example, if fullPath is 'full/path/image.png', name is 'image.png'.
     */ get name() {
        return $57d582485a4bd356$var$lastComponent(this._location.path);
    }
    /**
     * The `StorageService` instance this `StorageReference` is associated with.
     */ get storage() {
        return this._service;
    }
    /**
     * A `StorageReference` pointing to the parent location of this `StorageReference`, or null if
     * this reference is the root.
     */ get parent() {
        const newPath = $57d582485a4bd356$var$parent(this._location.path);
        if (newPath === null) return null;
        const location = new $57d582485a4bd356$export$adb98fff6714334(this._location.bucket, newPath);
        return new $57d582485a4bd356$var$Reference(this._service, location);
    }
    /**
     * Utility function to throw an error in methods that do not accept a root reference.
     */ _throwIfRoot(name) {
        if (this._location.path === "") throw $57d582485a4bd356$export$61f54cdc36500ad(name);
    }
    constructor(_service, location){
        this._service = _service;
        if (location instanceof $57d582485a4bd356$export$adb98fff6714334) this._location = location;
        else this._location = $57d582485a4bd356$export$adb98fff6714334.makeFromUrl(location, _service.host);
    }
}
/**
 * Download the bytes at the object's location.
 * @returns A Promise containing the downloaded bytes.
 */ function $57d582485a4bd356$var$getBytesInternal(ref, maxDownloadSizeBytes) {
    ref._throwIfRoot("getBytes");
    const requestInfo = $57d582485a4bd356$var$getBytes$1(ref.storage, ref._location, maxDownloadSizeBytes);
    return ref.storage.makeRequestWithTokens(requestInfo, $57d582485a4bd356$var$newBytesConnection).then((bytes)=>maxDownloadSizeBytes !== undefined ? bytes.slice(0, maxDownloadSizeBytes) : bytes);
}
/**
 * Download the bytes at the object's location.
 * @returns A Promise containing the downloaded blob.
 */ function $57d582485a4bd356$var$getBlobInternal(ref, maxDownloadSizeBytes) {
    ref._throwIfRoot("getBlob");
    const requestInfo = $57d582485a4bd356$var$getBytes$1(ref.storage, ref._location, maxDownloadSizeBytes);
    return ref.storage.makeRequestWithTokens(requestInfo, $57d582485a4bd356$var$newBlobConnection).then((blob)=>maxDownloadSizeBytes !== undefined ? blob.slice(0, maxDownloadSizeBytes) : blob);
}
/**
 * Uploads data to this object's location.
 * The upload is not resumable.
 *
 * @param ref - StorageReference where data should be uploaded.
 * @param data - The data to upload.
 * @param metadata - Metadata for the newly uploaded data.
 * @returns A Promise containing an UploadResult
 */ function $57d582485a4bd356$var$uploadBytes$1(ref, data, metadata) {
    ref._throwIfRoot("uploadBytes");
    const requestInfo = $57d582485a4bd356$var$multipartUpload(ref.storage, ref._location, $57d582485a4bd356$var$getMappings(), new $57d582485a4bd356$export$8deea8629ff0b8a7(data, true), metadata);
    return ref.storage.makeRequestWithTokens(requestInfo, $57d582485a4bd356$var$newTextConnection).then((finalMetadata)=>{
        return {
            metadata: finalMetadata,
            ref: ref
        };
    });
}
/**
 * Uploads data to this object's location.
 * The upload can be paused and resumed, and exposes progress updates.
 * @public
 * @param ref - StorageReference where data should be uploaded.
 * @param data - The data to upload.
 * @param metadata - Metadata for the newly uploaded data.
 * @returns An UploadTask
 */ function $57d582485a4bd356$var$uploadBytesResumable$1(ref, data, metadata) {
    ref._throwIfRoot("uploadBytesResumable");
    return new $57d582485a4bd356$export$86a2a9b92406a048(ref, new $57d582485a4bd356$export$8deea8629ff0b8a7(data), metadata);
}
/**
 * Uploads a string to this object's location.
 * The upload is not resumable.
 * @public
 * @param ref - StorageReference where string should be uploaded.
 * @param value - The string to upload.
 * @param format - The format of the string to upload.
 * @param metadata - Metadata for the newly uploaded string.
 * @returns A Promise containing an UploadResult
 */ function $57d582485a4bd356$var$uploadString$1(ref, value, format = $57d582485a4bd356$export$f22e7fe56db8ae03.RAW, metadata) {
    ref._throwIfRoot("uploadString");
    const data = $57d582485a4bd356$export$d80b9b5a2ccdd3e0(format, value);
    const metadataClone = Object.assign({}, metadata);
    if (metadataClone["contentType"] == null && data.contentType != null) metadataClone["contentType"] = data.contentType;
    return $57d582485a4bd356$var$uploadBytes$1(ref, data.data, metadataClone);
}
/**
 * List all items (files) and prefixes (folders) under this storage reference.
 *
 * This is a helper method for calling list() repeatedly until there are
 * no more results. The default pagination size is 1000.
 *
 * Note: The results may not be consistent if objects are changed while this
 * operation is running.
 *
 * Warning: listAll may potentially consume too many resources if there are
 * too many results.
 * @public
 * @param ref - StorageReference to get list from.
 *
 * @returns A Promise that resolves with all the items and prefixes under
 *      the current storage reference. `prefixes` contains references to
 *      sub-directories and `items` contains references to objects in this
 *      folder. `nextPageToken` is never returned.
 */ function $57d582485a4bd356$var$listAll$1(ref) {
    const accumulator = {
        prefixes: [],
        items: []
    };
    return $57d582485a4bd356$var$listAllHelper(ref, accumulator).then(()=>accumulator);
}
/**
 * Separated from listAll because async functions can't use "arguments".
 * @param ref
 * @param accumulator
 * @param pageToken
 */ async function $57d582485a4bd356$var$listAllHelper(ref, accumulator, pageToken) {
    const opt = {
        pageToken: // maxResults is 1000 by default.
        pageToken
    };
    const nextPage = await $57d582485a4bd356$var$list$1(ref, opt);
    accumulator.prefixes.push(...nextPage.prefixes);
    accumulator.items.push(...nextPage.items);
    if (nextPage.nextPageToken != null) await $57d582485a4bd356$var$listAllHelper(ref, accumulator, nextPage.nextPageToken);
}
/**
 * List items (files) and prefixes (folders) under this storage reference.
 *
 * List API is only available for Firebase Rules Version 2.
 *
 * GCS is a key-blob store. Firebase Storage imposes the semantic of '/'
 * delimited folder structure.
 * Refer to GCS's List API if you want to learn more.
 *
 * To adhere to Firebase Rules's Semantics, Firebase Storage does not
 * support objects whose paths end with "/" or contain two consecutive
 * "/"s. Firebase Storage List API will filter these unsupported objects.
 * list() may fail if there are too many unsupported objects in the bucket.
 * @public
 *
 * @param ref - StorageReference to get list from.
 * @param options - See ListOptions for details.
 * @returns A Promise that resolves with the items and prefixes.
 *      `prefixes` contains references to sub-folders and `items`
 *      contains references to objects in this folder. `nextPageToken`
 *      can be used to get the rest of the results.
 */ function $57d582485a4bd356$var$list$1(ref, options) {
    if (options != null) {
        if (typeof options.maxResults === "number") $57d582485a4bd356$var$validateNumber("options.maxResults", /* minValue= */ 1, /* maxValue= */ 1000, options.maxResults);
    }
    const op = options || {};
    const requestInfo = $57d582485a4bd356$var$list$2(ref.storage, ref._location, /*delimiter= */ "/", op.pageToken, op.maxResults);
    return ref.storage.makeRequestWithTokens(requestInfo, $57d582485a4bd356$var$newTextConnection);
}
/**
 * A `Promise` that resolves with the metadata for this object. If this
 * object doesn't exist or metadata cannot be retreived, the promise is
 * rejected.
 * @public
 * @param ref - StorageReference to get metadata from.
 */ function $57d582485a4bd356$var$getMetadata$1(ref) {
    ref._throwIfRoot("getMetadata");
    const requestInfo = $57d582485a4bd356$var$getMetadata$2(ref.storage, ref._location, $57d582485a4bd356$var$getMappings());
    return ref.storage.makeRequestWithTokens(requestInfo, $57d582485a4bd356$var$newTextConnection);
}
/**
 * Updates the metadata for this object.
 * @public
 * @param ref - StorageReference to update metadata for.
 * @param metadata - The new metadata for the object.
 *     Only values that have been explicitly set will be changed. Explicitly
 *     setting a value to null will remove the metadata.
 * @returns A `Promise` that resolves
 *     with the new metadata for this object.
 *     See `firebaseStorage.Reference.prototype.getMetadata`
 */ function $57d582485a4bd356$var$updateMetadata$1(ref, metadata) {
    ref._throwIfRoot("updateMetadata");
    const requestInfo = $57d582485a4bd356$var$updateMetadata$2(ref.storage, ref._location, metadata, $57d582485a4bd356$var$getMappings());
    return ref.storage.makeRequestWithTokens(requestInfo, $57d582485a4bd356$var$newTextConnection);
}
/**
 * Returns the download URL for the given Reference.
 * @public
 * @returns A `Promise` that resolves with the download
 *     URL for this object.
 */ function $57d582485a4bd356$var$getDownloadURL$1(ref) {
    ref._throwIfRoot("getDownloadURL");
    const requestInfo = $57d582485a4bd356$var$getDownloadUrl(ref.storage, ref._location, $57d582485a4bd356$var$getMappings());
    return ref.storage.makeRequestWithTokens(requestInfo, $57d582485a4bd356$var$newTextConnection).then((url)=>{
        if (url === null) throw $57d582485a4bd356$var$noDownloadURL();
        return url;
    });
}
/**
 * Deletes the object at this location.
 * @public
 * @param ref - StorageReference for object to delete.
 * @returns A `Promise` that resolves if the deletion succeeds.
 */ function $57d582485a4bd356$var$deleteObject$1(ref) {
    ref._throwIfRoot("deleteObject");
    const requestInfo = $57d582485a4bd356$var$deleteObject$2(ref.storage, ref._location);
    return ref.storage.makeRequestWithTokens(requestInfo, $57d582485a4bd356$var$newTextConnection);
}
/**
 * Returns reference for object obtained by appending `childPath` to `ref`.
 *
 * @param ref - StorageReference to get child of.
 * @param childPath - Child path from provided ref.
 * @returns A reference to the object obtained by
 * appending childPath, removing any duplicate, beginning, or trailing
 * slashes.
 *
 */ function $57d582485a4bd356$var$_getChild$1(ref, childPath) {
    const newPath = $57d582485a4bd356$var$child(ref._location.path, childPath);
    const location = new $57d582485a4bd356$export$adb98fff6714334(ref._location.bucket, newPath);
    return new $57d582485a4bd356$var$Reference(ref.storage, location);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $57d582485a4bd356$var$isUrl(path) {
    return /^[A-Za-z]+:\/\//.test(path);
}
/**
 * Returns a firebaseStorage.Reference for the given url.
 */ function $57d582485a4bd356$var$refFromURL(service, url) {
    return new $57d582485a4bd356$var$Reference(service, url);
}
/**
 * Returns a firebaseStorage.Reference for the given path in the default
 * bucket.
 */ function $57d582485a4bd356$var$refFromPath(ref, path) {
    if (ref instanceof $57d582485a4bd356$var$FirebaseStorageImpl) {
        const service = ref;
        if (service._bucket == null) throw $57d582485a4bd356$var$noDefaultBucket();
        const reference = new $57d582485a4bd356$var$Reference(service, service._bucket);
        if (path != null) return $57d582485a4bd356$var$refFromPath(reference, path);
        else return reference;
    } else {
        // ref is a Reference
        if (path !== undefined) return $57d582485a4bd356$var$_getChild$1(ref, path);
        else return ref;
    }
}
function $57d582485a4bd356$var$ref$1(serviceOrRef, pathOrUrl) {
    if (pathOrUrl && $57d582485a4bd356$var$isUrl(pathOrUrl)) {
        if (serviceOrRef instanceof $57d582485a4bd356$var$FirebaseStorageImpl) return $57d582485a4bd356$var$refFromURL(serviceOrRef, pathOrUrl);
        else throw $57d582485a4bd356$export$8f74d9881d1936fd("To use ref(service, url), the first argument must be a Storage instance.");
    } else return $57d582485a4bd356$var$refFromPath(serviceOrRef, pathOrUrl);
}
function $57d582485a4bd356$var$extractBucket(host, config) {
    const bucketString = config === null || config === void 0 ? void 0 : config[$57d582485a4bd356$var$CONFIG_STORAGE_BUCKET_KEY];
    if (bucketString == null) return null;
    return $57d582485a4bd356$export$adb98fff6714334.makeFromBucketSpec(bucketString, host);
}
function $57d582485a4bd356$var$connectStorageEmulator$1(storage, host, port, options = {}) {
    storage.host = `${host}:${port}`;
    storage._protocol = "http";
    const { mockUserToken: mockUserToken } = options;
    if (mockUserToken) storage._overrideAuthToken = typeof mockUserToken === "string" ? mockUserToken : (0, $f84e8187c6005769$export$367bf224123348f1)(mockUserToken, storage.app.options.projectId);
}
/**
 * A service that provides Firebase Storage Reference instances.
 * @param opt_url - gs:// url to a custom Storage Bucket
 *
 * @internal
 */ class $57d582485a4bd356$var$FirebaseStorageImpl {
    /**
     * The host string for this service, in the form of `host` or
     * `host:port`.
     */ get host() {
        return this._host;
    }
    set host(host) {
        this._host = host;
        if (this._url != null) this._bucket = $57d582485a4bd356$export$adb98fff6714334.makeFromBucketSpec(this._url, host);
        else this._bucket = $57d582485a4bd356$var$extractBucket(host, this.app.options);
    }
    /**
     * The maximum time to retry uploads in milliseconds.
     */ get maxUploadRetryTime() {
        return this._maxUploadRetryTime;
    }
    set maxUploadRetryTime(time) {
        $57d582485a4bd356$var$validateNumber("time", /* minValue=*/ 0, /* maxValue= */ Number.POSITIVE_INFINITY, time);
        this._maxUploadRetryTime = time;
    }
    /**
     * The maximum time to retry operations other than uploads or downloads in
     * milliseconds.
     */ get maxOperationRetryTime() {
        return this._maxOperationRetryTime;
    }
    set maxOperationRetryTime(time) {
        $57d582485a4bd356$var$validateNumber("time", /* minValue=*/ 0, /* maxValue= */ Number.POSITIVE_INFINITY, time);
        this._maxOperationRetryTime = time;
    }
    async _getAuthToken() {
        if (this._overrideAuthToken) return this._overrideAuthToken;
        const auth = this._authProvider.getImmediate({
            optional: true
        });
        if (auth) {
            const tokenData = await auth.getToken();
            if (tokenData !== null) return tokenData.accessToken;
        }
        return null;
    }
    async _getAppCheckToken() {
        const appCheck = this._appCheckProvider.getImmediate({
            optional: true
        });
        if (appCheck) {
            const result = await appCheck.getToken();
            // TODO: What do we want to do if there is an error getting the token?
            // Context: appCheck.getToken() will never throw even if an error happened. In the error case, a dummy token will be
            // returned along with an error field describing the error. In general, we shouldn't care about the error condition and just use
            // the token (actual or dummy) to send requests.
            return result.token;
        }
        return null;
    }
    /**
     * Stop running requests and prevent more from being created.
     */ _delete() {
        if (!this._deleted) {
            this._deleted = true;
            this._requests.forEach((request)=>request.cancel());
            this._requests.clear();
        }
        return Promise.resolve();
    }
    /**
     * Returns a new firebaseStorage.Reference object referencing this StorageService
     * at the given Location.
     */ _makeStorageReference(loc) {
        return new $57d582485a4bd356$var$Reference(this, loc);
    }
    /**
     * @param requestInfo - HTTP RequestInfo object
     * @param authToken - Firebase auth token
     */ _makeRequest(requestInfo, requestFactory, authToken, appCheckToken) {
        if (!this._deleted) {
            const request = $57d582485a4bd356$var$makeRequest(requestInfo, this._appId, authToken, appCheckToken, requestFactory, this._firebaseVersion);
            this._requests.add(request);
            // Request removes itself from set when complete.
            request.getPromise().then(()=>this._requests.delete(request), ()=>this._requests.delete(request));
            return request;
        } else return new $57d582485a4bd356$var$FailRequest($57d582485a4bd356$var$appDeleted());
    }
    async makeRequestWithTokens(requestInfo, requestFactory) {
        const [authToken, appCheckToken] = await Promise.all([
            this._getAuthToken(),
            this._getAppCheckToken()
        ]);
        return this._makeRequest(requestInfo, requestFactory, authToken, appCheckToken).getPromise();
    }
    constructor(/**
     * FirebaseApp associated with this StorageService instance.
     */ app, _authProvider, /**
     * @internal
     */ _appCheckProvider, /**
     * @internal
     */ _url, _firebaseVersion){
        this.app = app;
        this._authProvider = _authProvider;
        this._appCheckProvider = _appCheckProvider;
        this._url = _url;
        this._firebaseVersion = _firebaseVersion;
        this._bucket = null;
        /**
         * This string can be in the formats:
         * - host
         * - host:port
         */ this._host = $57d582485a4bd356$var$DEFAULT_HOST;
        this._protocol = "https";
        this._appId = null;
        this._deleted = false;
        this._maxOperationRetryTime = $57d582485a4bd356$var$DEFAULT_MAX_OPERATION_RETRY_TIME;
        this._maxUploadRetryTime = $57d582485a4bd356$var$DEFAULT_MAX_UPLOAD_RETRY_TIME;
        this._requests = new Set();
        if (_url != null) this._bucket = $57d582485a4bd356$export$adb98fff6714334.makeFromBucketSpec(_url, this._host);
        else this._bucket = $57d582485a4bd356$var$extractBucket(this._host, this.app.options);
    }
}
const $57d582485a4bd356$var$name = "@firebase/storage";
const $57d582485a4bd356$var$version = "0.9.7";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Type constant for Firebase Storage.
 */ const $57d582485a4bd356$var$STORAGE_TYPE = "storage";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Downloads the data at the object's location. Returns an error if the object
 * is not found.
 *
 * To use this functionality, you have to whitelist your app's origin in your
 * Cloud Storage bucket. See also
 * https://cloud.google.com/storage/docs/configuring-cors
 *
 * @public
 * @param ref - StorageReference where data should be downloaded.
 * @param maxDownloadSizeBytes - If set, the maximum allowed size in bytes to
 * retrieve.
 * @returns A Promise containing the object's bytes
 */ function $57d582485a4bd356$export$a3521add2594f3c8(ref, maxDownloadSizeBytes) {
    ref = (0, $f84e8187c6005769$export$4befe9b5fa509a1b)(ref);
    return $57d582485a4bd356$var$getBytesInternal(ref, maxDownloadSizeBytes);
}
/**
 * Uploads data to this object's location.
 * The upload is not resumable.
 * @public
 * @param ref - {@link StorageReference} where data should be uploaded.
 * @param data - The data to upload.
 * @param metadata - Metadata for the data to upload.
 * @returns A Promise containing an UploadResult
 */ function $57d582485a4bd356$export$ac40f56b52f99dd1(ref, data, metadata) {
    ref = (0, $f84e8187c6005769$export$4befe9b5fa509a1b)(ref);
    return $57d582485a4bd356$var$uploadBytes$1(ref, data, metadata);
}
/**
 * Uploads a string to this object's location.
 * The upload is not resumable.
 * @public
 * @param ref - {@link StorageReference} where string should be uploaded.
 * @param value - The string to upload.
 * @param format - The format of the string to upload.
 * @param metadata - Metadata for the string to upload.
 * @returns A Promise containing an UploadResult
 */ function $57d582485a4bd356$export$d885b2eb178808b3(ref, value, format, metadata) {
    ref = (0, $f84e8187c6005769$export$4befe9b5fa509a1b)(ref);
    return $57d582485a4bd356$var$uploadString$1(ref, value, format, metadata);
}
/**
 * Uploads data to this object's location.
 * The upload can be paused and resumed, and exposes progress updates.
 * @public
 * @param ref - {@link StorageReference} where data should be uploaded.
 * @param data - The data to upload.
 * @param metadata - Metadata for the data to upload.
 * @returns An UploadTask
 */ function $57d582485a4bd356$export$3895d39eb7ac9b25(ref, data, metadata) {
    ref = (0, $f84e8187c6005769$export$4befe9b5fa509a1b)(ref);
    return $57d582485a4bd356$var$uploadBytesResumable$1(ref, data, metadata);
}
/**
 * A `Promise` that resolves with the metadata for this object. If this
 * object doesn't exist or metadata cannot be retreived, the promise is
 * rejected.
 * @public
 * @param ref - {@link StorageReference} to get metadata from.
 */ function $57d582485a4bd356$export$8548546c0aa631e6(ref) {
    ref = (0, $f84e8187c6005769$export$4befe9b5fa509a1b)(ref);
    return $57d582485a4bd356$var$getMetadata$1(ref);
}
/**
 * Updates the metadata for this object.
 * @public
 * @param ref - {@link StorageReference} to update metadata for.
 * @param metadata - The new metadata for the object.
 *     Only values that have been explicitly set will be changed. Explicitly
 *     setting a value to null will remove the metadata.
 * @returns A `Promise` that resolves with the new metadata for this object.
 */ function $57d582485a4bd356$export$f64791b2d30456a0(ref, metadata) {
    ref = (0, $f84e8187c6005769$export$4befe9b5fa509a1b)(ref);
    return $57d582485a4bd356$var$updateMetadata$1(ref, metadata);
}
/**
 * List items (files) and prefixes (folders) under this storage reference.
 *
 * List API is only available for Firebase Rules Version 2.
 *
 * GCS is a key-blob store. Firebase Storage imposes the semantic of '/'
 * delimited folder structure.
 * Refer to GCS's List API if you want to learn more.
 *
 * To adhere to Firebase Rules's Semantics, Firebase Storage does not
 * support objects whose paths end with "/" or contain two consecutive
 * "/"s. Firebase Storage List API will filter these unsupported objects.
 * list() may fail if there are too many unsupported objects in the bucket.
 * @public
 *
 * @param ref - {@link StorageReference} to get list from.
 * @param options - See {@link ListOptions} for details.
 * @returns A `Promise` that resolves with the items and prefixes.
 *      `prefixes` contains references to sub-folders and `items`
 *      contains references to objects in this folder. `nextPageToken`
 *      can be used to get the rest of the results.
 */ function $57d582485a4bd356$export$8837f4fc672e936d(ref, options) {
    ref = (0, $f84e8187c6005769$export$4befe9b5fa509a1b)(ref);
    return $57d582485a4bd356$var$list$1(ref, options);
}
/**
 * List all items (files) and prefixes (folders) under this storage reference.
 *
 * This is a helper method for calling list() repeatedly until there are
 * no more results. The default pagination size is 1000.
 *
 * Note: The results may not be consistent if objects are changed while this
 * operation is running.
 *
 * Warning: `listAll` may potentially consume too many resources if there are
 * too many results.
 * @public
 * @param ref - {@link StorageReference} to get list from.
 *
 * @returns A `Promise` that resolves with all the items and prefixes under
 *      the current storage reference. `prefixes` contains references to
 *      sub-directories and `items` contains references to objects in this
 *      folder. `nextPageToken` is never returned.
 */ function $57d582485a4bd356$export$6a265a7d315dec03(ref) {
    ref = (0, $f84e8187c6005769$export$4befe9b5fa509a1b)(ref);
    return $57d582485a4bd356$var$listAll$1(ref);
}
/**
 * Returns the download URL for the given {@link StorageReference}.
 * @public
 * @param ref - {@link StorageReference} to get the download URL for.
 * @returns A `Promise` that resolves with the download
 *     URL for this object.
 */ function $57d582485a4bd356$export$c8bf645a0c2a7d9f(ref) {
    ref = (0, $f84e8187c6005769$export$4befe9b5fa509a1b)(ref);
    return $57d582485a4bd356$var$getDownloadURL$1(ref);
}
/**
 * Deletes the object at this location.
 * @public
 * @param ref - {@link StorageReference} for object to delete.
 * @returns A `Promise` that resolves if the deletion succeeds.
 */ function $57d582485a4bd356$export$39c5ed4ec960eade(ref) {
    ref = (0, $f84e8187c6005769$export$4befe9b5fa509a1b)(ref);
    return $57d582485a4bd356$var$deleteObject$1(ref);
}
function $57d582485a4bd356$export$eff4d24c3ff7876e(serviceOrRef, pathOrUrl) {
    serviceOrRef = (0, $f84e8187c6005769$export$4befe9b5fa509a1b)(serviceOrRef);
    return $57d582485a4bd356$var$ref$1(serviceOrRef, pathOrUrl);
}
/**
 * @internal
 */ function $57d582485a4bd356$export$9acd24c0fce96a85(ref, childPath) {
    return $57d582485a4bd356$var$_getChild$1(ref, childPath);
}
/**
 * Gets a {@link FirebaseStorage} instance for the given Firebase app.
 * @public
 * @param app - Firebase app to get {@link FirebaseStorage} instance for.
 * @param bucketUrl - The gs:// url to your Firebase Storage Bucket.
 * If not passed, uses the app's default Storage Bucket.
 * @returns A {@link FirebaseStorage} instance.
 */ function $57d582485a4bd356$export$fbd9b57a66480737(app = (0, $iXpG9.getApp)(), bucketUrl) {
    app = (0, $f84e8187c6005769$export$4befe9b5fa509a1b)(app);
    const storageProvider = (0, $iXpG9._getProvider)(app, $57d582485a4bd356$var$STORAGE_TYPE);
    const storageInstance = storageProvider.getImmediate({
        identifier: bucketUrl
    });
    return storageInstance;
}
/**
 * Modify this {@link FirebaseStorage} instance to communicate with the Cloud Storage emulator.
 *
 * @param storage - The {@link FirebaseStorage} instance
 * @param host - The emulator host (ex: localhost)
 * @param port - The emulator port (ex: 5001)
 * @param options - Emulator options. `options.mockUserToken` is the mock auth
 * token to use for unit testing Security Rules.
 * @public
 */ function $57d582485a4bd356$export$9850e656f954b889(storage, host, port, options = {}) {
    $57d582485a4bd356$var$connectStorageEmulator$1(storage, host, port, options);
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Downloads the data at the object's location. Returns an error if the object
 * is not found.
 *
 * To use this functionality, you have to whitelist your app's origin in your
 * Cloud Storage bucket. See also
 * https://cloud.google.com/storage/docs/configuring-cors
 *
 * This API is not available in Node.
 *
 * @public
 * @param ref - StorageReference where data should be downloaded.
 * @param maxDownloadSizeBytes - If set, the maximum allowed size in bytes to
 * retrieve.
 * @returns A Promise that resolves with a Blob containing the object's bytes
 */ function $57d582485a4bd356$export$37610328929d7521(ref, maxDownloadSizeBytes) {
    ref = (0, $f84e8187c6005769$export$4befe9b5fa509a1b)(ref);
    return $57d582485a4bd356$var$getBlobInternal(ref, maxDownloadSizeBytes);
}
/**
 * Downloads the data at the object's location. Raises an error event if the
 * object is not found.
 *
 * This API is only available in Node.
 *
 * @public
 * @param ref - StorageReference where data should be downloaded.
 * @param maxDownloadSizeBytes - If set, the maximum allowed size in bytes to
 * retrieve.
 * @returns A stream with the object's data as bytes
 */ function $57d582485a4bd356$export$747191980cdf43e8(ref, maxDownloadSizeBytes) {
    throw new Error("getStream() is only supported by NodeJS builds");
}
/**
 * Cloud Storage for Firebase
 *
 * @packageDocumentation
 */ function $57d582485a4bd356$var$factory(container, { instanceIdentifier: url }) {
    const app = container.getProvider("app").getImmediate();
    const authProvider = container.getProvider("auth-internal");
    const appCheckProvider = container.getProvider("app-check-internal");
    return new $57d582485a4bd356$var$FirebaseStorageImpl(app, authProvider, appCheckProvider, url, (0, $iXpG9.SDK_VERSION));
}
function $57d582485a4bd356$var$registerStorage() {
    (0, $iXpG9._registerComponent)(new (0, $9e13847596aa735d$export$16fa2f45be04daa8)($57d582485a4bd356$var$STORAGE_TYPE, $57d582485a4bd356$var$factory, "PUBLIC" /* PUBLIC */ ).setMultipleInstances(true));
    //RUNTIME_ENV will be replaced during the compilation to "node" for nodejs and an empty string for browser
    (0, $iXpG9.registerVersion)($57d582485a4bd356$var$name, $57d582485a4bd356$var$version, "");
    // BUILD_TARGET will be replaced by values like esm5, esm2017, cjs5, etc during the compilation
    (0, $iXpG9.registerVersion)($57d582485a4bd356$var$name, $57d582485a4bd356$var$version, "esm2017");
}
$57d582485a4bd356$var$registerStorage();





var $4378c63f1be46208$exports = {};

$4378c63f1be46208$exports = (parcelRequire("fF0r8")).getBundleURL("7lpHJ") + "user.66199745.svg";





const $d31a2db47f3d8dd6$var$collectionOptions = {
    meetingRoom: "Meeting Room",
    flexdaySuite: "Flexday Suite",
    privateOffice: "Private Office"
};
const $d31a2db47f3d8dd6$var$Profile = ({ profileUrl: profileUrl })=>{
    var _auth_currentUser;
    const { getFirebaseConfig: getFirebaseConfig } = (0, $a5a6fab2525fdce6$exports.Helpers);
    const [user, setUser] = (0, $b6HlZ.useState)(null);
    const [photo, setPhoto] = (0, $b6HlZ.useState)(null);
    const [bookings, setBookings] = (0, $b6HlZ.useState)([]);
    const [loadingBookings, setLoadingBookings] = (0, $b6HlZ.useState)(true);
    const [uploadingProfilePicture, setUploadingProfilePicture] = (0, $b6HlZ.useState)(false);
    const firebaseConfig = getFirebaseConfig({
        REACT_APP_FIREBASE_MESSAGE_SENDER_ID: "717114758534",
        REACT_APP_FIREBASE_APP_ID: "1:717114758534:web:c0f5a5118efc5855164807",
        REACT_APP_FIREBASE_API_KEY: "AIzaSyBoIeHTyO2Zr6jARvqrWPPAlqi3pdu2-KA",
        REACT_APP_FIREBASE_PROJECT_ID: "flexday-6dacf"
    });
    const app = (0, $iXpG9.initializeApp)(firebaseConfig);
    const firestore = (0, $7TObl.getFirestore)(app);
    const database = (0, $30d3a405033775a4$export$d0dd861204d0bf72)(app);
    const storage = (0, $57d582485a4bd356$export$fbd9b57a66480737)(app);
    const auth = (0, $clAv2.n)(app);
    auth.onAuthStateChanged((currentUser)=>{
        if (user && !currentUser) window.location.href = profileUrl;
        setUser(currentUser);
    });
    const getBookingsInfo = async ()=>{
        const bookingsList = [];
        const currentTimestamp = new Date().getTime() - 86400000;
        const querySnapshot = await (0, $7TObl.getDocs)((0, $7TObl.query)((0, $7TObl.collection)(firestore, "conciergeBookings"), (0, $7TObl.where)("uid", "==", user.uid), (0, $7TObl.where)("startedAt", ">", currentTimestamp), (0, $7TObl.orderBy)("startedAt", "asc")));
        if (!querySnapshot.empty) {
            querySnapshot.forEach((doc)=>{
                const bookingData = doc.data();
                const dateRange = [
                    ...new Set([
                        (0, $8a568d5cdba66624$export$2e2bcd8739ae039)(new Date(bookingData.startedAt), "yyyy/M/d"),
                        (0, $8a568d5cdba66624$export$2e2bcd8739ae039)(new Date(bookingData.endedAt), "yyyy/M/d")
                    ])
                ].join(" - ");
                const filteredData = {
                    dateRange: dateRange,
                    inventoryId: bookingData === null || bookingData === void 0 ? void 0 : bookingData.inventoryId,
                    inventoryType: $d31a2db47f3d8dd6$var$collectionOptions[bookingData === null || bookingData === void 0 ? void 0 : bookingData.inventoryType]
                };
                if ((bookingData === null || bookingData === void 0 ? void 0 : bookingData.status) === "active") bookingsList.push(filteredData);
            });
            setBookings(bookingsList);
        }
        setLoadingBookings(false);
    };
    const getUserPhoto = async ()=>{
        const snapshot = await (0, $30d3a405033775a4$export$3988ae62b71be9a3)((0, $30d3a405033775a4$export$f9574b70e1d95d9d)((0, $30d3a405033775a4$export$eff4d24c3ff7876e)(database), `users/${user.uid}`));
        if (snapshot.exists() && snapshot.val().photoUrl) setPhoto(snapshot.val().photoUrl);
    };
    (0, $b6HlZ.useEffect)(()=>{
        if (user) {
            getUserPhoto();
            getBookingsInfo();
        }
    }, [
        user
    ]);
    const renderBookings = ()=>{
        if (!bookings.length) return /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)("p", {
            children: "You have no active reservations."
        });
        return /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsxs)((0, $94829a8b99aa12e4$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)("div", {
                    className: `flex gap-12 w-screen pb-4 pl-4 scroll-smooth
                      overflow-auto md:gap-20 md:w-auto md:pl-8`,
                    children: bookings.map((booking)=>/*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsxs)("div", {
                            className: "inline-flex flex-col items-center gap-4 w-72 min-w-max",
                            children: [
                                /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)("p", {
                                    className: "text-slate-500",
                                    children: booking.dateRange
                                }),
                                booking.inventoryId && booking.inventoryType && /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)((0, $ee969eb065807adf$export$2e2bcd8739ae039), {
                                    id: booking.inventoryId,
                                    inventoryType: booking.inventoryType
                                })
                            ]
                        }, `${booking.inventoryId}-${booking.dateRange}`))
                }),
                /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsxs)("p", {
                    className: "px-2 italic text-slate-500",
                    children: [
                        /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)("b", {
                            children: "Please note:"
                        }),
                        " Flexday workspace amenities, photos and details may change at any point and differ from the information provided in this communication. Contact Flexday Concierge for the most updated information."
                    ]
                })
            ]
        });
    };
    const handleUploadImage = async (e)=>{
        try {
            setUploadingProfilePicture(true);
            const file = e.target.files[0];
            const storageRef = (0, $57d582485a4bd356$export$eff4d24c3ff7876e)(storage, `users/${user.uid}/profile-photo/${new Date().toISOString()}`);
            await (0, $57d582485a4bd356$export$ac40f56b52f99dd1)(storageRef, file);
            const photoUrl = await (0, $57d582485a4bd356$export$c8bf645a0c2a7d9f)(storageRef);
            await (0, $30d3a405033775a4$export$722fbec263ad908a)((0, $30d3a405033775a4$export$eff4d24c3ff7876e)(database, `users/${user.uid}`), {
                photoUrl: photoUrl
            });
            await getUserPhoto();
        } finally{
            setUploadingProfilePicture(false);
        }
    };
    const handleDeleteAccount = async ()=>{
        const isConfirmed = window.confirm("Deleting your account will result in removing all of your information from our records, including your memberships and credits. This cannot be undone.");
        if (isConfirmed) await auth.currentUser.delete().then(()=>{
            window.location.href = "https://www.flexday.com";
        }).catch(async (error)=>{
            if (error.code === "auth/requires-recent-login") window.alert("Looks like you've logged in a while ago. We need to check it's really you before deleting the account. Please log out and back in again.");
        });
    };
    if (!user) return null;
    return /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsxs)("div", {
        className: `
        flex flex-col items-center gap-10 p-6
        sm:flex-row sm:items-stretch sm:gap-16
      `,
        children: [
            /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsxs)("div", {
                className: "flex flex-col items-center gap-6 min-w-max",
                children: [
                    /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)("img", {
                        alt: "",
                        className: "w-48 h-48 rounded-full",
                        src: photo || (auth === null || auth === void 0 ? void 0 : (_auth_currentUser = auth.currentUser) === null || _auth_currentUser === void 0 ? void 0 : _auth_currentUser.photoURL) || (0, (/*@__PURE__*/$parcel$interopDefault($4378c63f1be46208$exports)))
                    }),
                    /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)("input", {
                        id: "img",
                        type: "file",
                        accept: "image/*",
                        className: "hidden",
                        onChange: handleUploadImage
                    }),
                    /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsxs)("label", {
                        htmlFor: "img",
                        className: "block cursor-pointer hover:underline text-xs text-slate-500 relative",
                        children: [
                            "Update Profile Picture",
                            uploadingProfilePicture && /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)((0, $2b4669b8fe7a2697$export$7f7cbe89f1eacd2), {
                                className: "absolute -top-2 -right-12"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsxs)("div", {
                className: "flex flex-col gap-4 items-center sm:items-stretch overflow-hidden",
                children: [
                    /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)("p", {
                        className: "text-4xl font-extrabold",
                        children: user === null || user === void 0 ? void 0 : user.displayName
                    }),
                    /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)("a", {
                        className: "underline",
                        href: `mailto:${user.email}`,
                        children: user.email
                    }),
                    /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)("p", {
                        className: "font-bold mt-2",
                        children: "Reservations"
                    }),
                    loadingBookings ? /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)((0, $2b4669b8fe7a2697$export$7f7cbe89f1eacd2), {}) : renderBookings(),
                    /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)((0, $b10e2d2452b40b3d$export$2e2bcd8739ae039), {
                        title: "Delete Account",
                        onClick: handleDeleteAccount,
                        className: `mt-16 max-w-max !text-red-700 font-semibold rounded-md bg-red-100 hover:bg-red-200`
                    })
                ]
            })
        ]
    });
};
var $d31a2db47f3d8dd6$export$2e2bcd8739ae039 = $d31a2db47f3d8dd6$var$Profile;




var $b6HlZ = parcelRequire("b6HlZ");

var $iXpG9 = parcelRequire("iXpG9");
parcelRequire("ehmfL");
var $clAv2 = parcelRequire("clAv2");

var $a36479b1b88aa772$exports = {};

$a36479b1b88aa772$exports = (parcelRequire("fF0r8")).getBundleURL("7lpHJ") + "menu.5d9374a3.svg";



const $23ae5bffab1cf302$var$UserProfileNavItem = ({ cartUrl: cartUrl, loginUrl: loginUrl, createAccountUrl: createAccountUrl, loggedOutUrl: loggedOutUrl })=>{
    var _auth_currentUser;
    const dropdownRef = (0, $b6HlZ.useRef)(null);
    const { getFirebaseConfig: getFirebaseConfig } = (0, $a5a6fab2525fdce6$exports.Helpers);
    const [isOpen, setIsOpen] = (0, $b6HlZ.useState)(false);
    const [isLoggedIn, setIsLoggedIn] = (0, $b6HlZ.useState)(false);
    const firebaseConfig = getFirebaseConfig({
        REACT_APP_FIREBASE_MESSAGE_SENDER_ID: "717114758534",
        REACT_APP_FIREBASE_APP_ID: "1:717114758534:web:c0f5a5118efc5855164807",
        REACT_APP_FIREBASE_API_KEY: "AIzaSyBoIeHTyO2Zr6jARvqrWPPAlqi3pdu2-KA",
        REACT_APP_FIREBASE_PROJECT_ID: "flexday-6dacf"
    });
    const app = (0, $iXpG9.initializeApp)(firebaseConfig);
    const auth = (0, $clAv2.n)(app);
    auth.onAuthStateChanged(function(user) {
        if (user) setIsLoggedIn(true);
        else setIsLoggedIn(false);
    });
    const toggleDropdown = ()=>{
        setIsOpen((prev)=>!prev);
    };
    const handleClickAway = (event)=>{
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) setIsOpen(false);
    };
    (0, $b6HlZ.useEffect)(()=>{
        document.addEventListener("click", handleClickAway);
        return ()=>{
            document.removeEventListener("click", handleClickAway);
        };
    }, []);
    const handleLogout = async ()=>{
        await (0, $clAv2.y)(auth);
        window.location.href = loggedOutUrl;
    };
    return /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsxs)("nav", {
        ref: dropdownRef,
        onClick: toggleDropdown,
        className: `relative w-fit h-12 border border-gray-400
       rounded-full cursor-pointer select-none`,
        children: [
            /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsxs)("div", {
                className: "flex items-center justify-center gap-3 p-3",
                children: [
                    /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)("img", {
                        className: "p-1",
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($a36479b1b88aa772$exports))),
                        alt: ""
                    }),
                    /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)("img", {
                        alt: "",
                        className: "w-6 h-6 rounded-full",
                        src: (auth === null || auth === void 0 ? void 0 : (_auth_currentUser = auth.currentUser) === null || _auth_currentUser === void 0 ? void 0 : _auth_currentUser.photoURL) || (0, (/*@__PURE__*/$parcel$interopDefault($4378c63f1be46208$exports)))
                    })
                ]
            }),
            isOpen && /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)("div", {
                className: "absolute right-0 w-56 mt-2 bg-white",
                style: {
                    boxShadow: "0px 4px 10px 0px rgba(0, 0, 0, 0.25)"
                },
                children: /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsxs)("div", {
                    className: "py-1 font-medium",
                    children: [
                        /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)("a", {
                            href: cartUrl,
                            className: "block px-4 py-2 hover:bg-gray-100",
                            children: "Cart"
                        }),
                        isLoggedIn ? /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsxs)((0, $94829a8b99aa12e4$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)("a", {
                                    href: `${"https://www.flexday.com"}/profile`,
                                    className: "block px-4 py-2 hover:bg-gray-100",
                                    children: "My Profile"
                                }),
                                /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)("div", {
                                    onClick: handleLogout,
                                    className: "px-4 py-2 hover:bg-gray-100",
                                    children: "Logout"
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsxs)((0, $94829a8b99aa12e4$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)("a", {
                                    href: `${loginUrl}?redirectUrl=${window.location.href}`,
                                    className: "block px-4 py-2 hover:bg-gray-100",
                                    children: "Login"
                                }),
                                /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)("a", {
                                    href: `${createAccountUrl}?redirectUrl=${window.location.href}`,
                                    className: "block px-4 py-2 hover:bg-gray-100",
                                    children: "Create Account"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
var $23ae5bffab1cf302$export$2e2bcd8739ae039 = $23ae5bffab1cf302$var$UserProfileNavItem;



console.log("version 1");
// Wrapper component to ensure all widgets are properly scoped
const $f25e85c08ff84b11$var$WidgetWrapper = ({ children: children })=>/*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)("div", {
        className: "flexday-widget",
        children: children
    });
let $f25e85c08ff84b11$var$fallbackLocation;
fetch(`https://pro.ip-api.com/json?key=${"3p1Q0bWionWhjwc"}`).then((response)=>response.json()).then((data)=>{
    const supportedAreas = {
        CA: {
            ON: {
                lat: 43.644379939764086,
                lng: -79.39865381355503
            },
            QC: {
                lat: 45.50347963768571,
                lng: -73.56843374638021
            },
            AB: {
                lat: 51.044743785977936,
                lng: -114.06401208919131
            },
            BC: {
                lat: 49.283301543004384,
                lng: -123.117195944881
            }
        },
        US: {
            GA: {
                lat: 33.78653104249158,
                lng: -84.38240317233726
            },
            NY: {
                lat: 40.759864838618434,
                lng: -73.98043482397334
            },
            MA: {
                lat: 42.35901680539551,
                lng: -71.05981268528137
            },
            NC: {
                lat: 35.78238221306003,
                lng: -78.63218547143912
            }
        }
    };
    if (supportedAreas[data.countryCode]) $f25e85c08ff84b11$var$fallbackLocation = supportedAreas[data.countryCode][data.region];
}).catch(()=>{}).finally(()=>{
    $f25e85c08ff84b11$var$renderMap($f25e85c08ff84b11$var$fallbackLocation);
});
function $f25e85c08ff84b11$var$renderMap(fallbackLocation) {
    document.querySelectorAll(".flexday-workspace-browser").forEach((el)=>{
        const lat = el.getAttribute("data-latitude") || "";
        const lng = el.getAttribute("data-longitude") || "";
        let defaultLocation = lat && lng ? {
            lat: parseFloat(lat),
            lng: parseFloat(lng)
        } : fallbackLocation;
        (0, (/*@__PURE__*/$parcel$interopDefault($3uMgk))).render(/*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)($f25e85c08ff84b11$var$WidgetWrapper, {
            children: /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)((0, $a5e02d0cf2f5ec6b$export$2e2bcd8739ae039), {
                defaultLocation: defaultLocation
            })
        }), el);
    });
}
document.querySelectorAll(".flexday-inventory-card").forEach((el)=>{
    const id = el.getAttribute("data-id");
    const inventoryType = el.getAttribute("data-inventory-type");
    (0, (/*@__PURE__*/$parcel$interopDefault($3uMgk))).render(/*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)($f25e85c08ff84b11$var$WidgetWrapper, {
        children: /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)((0, $ee969eb065807adf$export$2e2bcd8739ae039), {
            id: id,
            inventoryType: inventoryType
        })
    }), el);
});
document.querySelectorAll(".flexday-booking-agent").forEach((el)=>{
    const autoJoin = el.getAttribute("data-auto-join") === "true";
    (0, (/*@__PURE__*/$parcel$interopDefault($3uMgk))).render(/*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)($f25e85c08ff84b11$var$WidgetWrapper, {
        children: /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)((0, $e9527ac5b503f28e$export$2e2bcd8739ae039), {
            settingsId: el.dataset.settings,
            autoJoin: autoJoin
        })
    }), el);
});
// Add event-based mounting for BookingAgent
document.addEventListener("flexday-mount-booking-agent", (event)=>{
    const el = event.target;
    if (el && el.dataset.settings) {
        const autoJoin = el.getAttribute("data-auto-join") === "true";
        (0, (/*@__PURE__*/$parcel$interopDefault($3uMgk))).render(/*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)($f25e85c08ff84b11$var$WidgetWrapper, {
            children: /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)((0, $e9527ac5b503f28e$export$2e2bcd8739ae039), {
                settingsId: el.dataset.settings,
                autoJoin: autoJoin
            })
        }), el);
    }
});
document.querySelectorAll(".flexday-booking-configurator").forEach((el)=>{
    const renderComponent = ()=>{
        const inventoryPageId = el.getAttribute("data-inventory-page");
        const currency = el.getAttribute("data-currency") || "CAD";
        (0, (/*@__PURE__*/$parcel$interopDefault($3uMgk))).render(/*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)($f25e85c08ff84b11$var$WidgetWrapper, {
            children: /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)((0, $407defcb875a9eb9$export$2e2bcd8739ae039), {
                inventoryPageId: inventoryPageId,
                currency: currency
            })
        }), el);
    };
    renderComponent();
    const observer = new MutationObserver((mutationsList)=>{
        for (const mutation of mutationsList)if (mutation.type === "attributes" && mutation.attributeName === "data-currency") {
            (0, (/*@__PURE__*/$parcel$interopDefault($3uMgk))).unmountComponentAtNode(el);
            renderComponent();
            break;
        }
    });
    observer.observe(el, {
        attributes: true
    });
});
document.querySelectorAll(".flexday-cart-preview").forEach((el)=>{
    const renderCartPreview = ()=>{
        const currency = el.getAttribute("data-currency") || "CAD";
        console.debug({
            cartCurrency: currency
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($3uMgk))).render(/*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)($f25e85c08ff84b11$var$WidgetWrapper, {
            children: /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)((0, $2542c92c1839082d$export$2e2bcd8739ae039), {
                currency: currency
            })
        }), el);
    };
    renderCartPreview();
    const observer = new MutationObserver((mutationsList)=>{
        for (const mutation of mutationsList)if (mutation.type === "attributes" && mutation.attributeName === "data-currency") {
            // Unmount the existing component
            (0, (/*@__PURE__*/$parcel$interopDefault($3uMgk))).unmountComponentAtNode(el);
            renderCartPreview();
            break;
        }
    });
    observer.observe(el, {
        attributes: true
    });
});
document.querySelectorAll(".flexday-login").forEach((el)=>{
    const loginUrl = el.getAttribute("data-log-in-url");
    const successUrl = el.getAttribute("data-success-url");
    (0, (/*@__PURE__*/$parcel$interopDefault($3uMgk))).render(/*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)($f25e85c08ff84b11$var$WidgetWrapper, {
        children: /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)((0, $33234a48731835e8$export$2e2bcd8739ae039), {
            loginUrl: loginUrl,
            onError: (error)=>{
                console.error({
                    error: error
                });
            },
            onSuccess: async (user, redirectUrl)=>{
                const { email: email, displayName: displayName } = user;
                await (0, $d77b1014b2d60259$exports.update)({
                    email: email,
                    name: displayName
                });
                setTimeout(()=>{
                    window.location.href = redirectUrl !== null && redirectUrl !== void 0 ? redirectUrl : successUrl;
                }, 1000);
            }
        })
    }), el);
});
document.querySelectorAll(".flexday-signup").forEach((el)=>{
    const createAccountUrl = el.getAttribute("data-create-account-url");
    const successUrl = el.getAttribute("data-success-url");
    (0, (/*@__PURE__*/$parcel$interopDefault($3uMgk))).render(/*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)($f25e85c08ff84b11$var$WidgetWrapper, {
        children: /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)((0, $fee974a6341ad8f8$export$2e2bcd8739ae039), {
            createAccountUrl: createAccountUrl,
            onError: (error)=>{
                console.error({
                    error: error
                });
            },
            onSuccess: async (user, redirectUrl)=>{
                const { email: email, displayName: displayName } = user;
                await (0, $d77b1014b2d60259$exports.update)({
                    email: email,
                    name: displayName
                });
                setTimeout(()=>{
                    window.location.href = redirectUrl !== null && redirectUrl !== void 0 ? redirectUrl : successUrl;
                }, 1000);
            }
        })
    }), el);
});
document.querySelectorAll(".flexday-user-profile-nav-item").forEach((el)=>{
    const cartUrl = el.getAttribute("data-cart-url");
    const loginUrl = el.getAttribute("data-log-in-url");
    const createAccountUrl = el.getAttribute("data-create-account-url");
    const loggedOutUrl = el.getAttribute("data-logged-out-url");
    (0, (/*@__PURE__*/$parcel$interopDefault($3uMgk))).render(/*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)($f25e85c08ff84b11$var$WidgetWrapper, {
        children: /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)((0, $23ae5bffab1cf302$export$2e2bcd8739ae039), {
            cartUrl: cartUrl,
            loginUrl: loginUrl,
            createAccountUrl: createAccountUrl,
            loggedOutUrl: loggedOutUrl
        })
    }), el);
});
document.querySelectorAll(".flexday-user-profile").forEach((el)=>{
    const profileUrl = el.getAttribute("data-profile-url");
    (0, (/*@__PURE__*/$parcel$interopDefault($3uMgk))).render(/*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)($f25e85c08ff84b11$var$WidgetWrapper, {
        children: /*#__PURE__*/ (0, $94829a8b99aa12e4$exports.jsx)((0, $d31a2db47f3d8dd6$export$2e2bcd8739ae039), {
            profileUrl: profileUrl
        })
    }), el);
});
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
(0, $ea833559f5a67bb4$export$2e2bcd8739ae039)();

})();
//# sourceMappingURL=index.js.map
